/**
 * Statische ICD-10-GM Diagnose-Daten.
 *
 * Quelle: CSV Datei ICD-10-GM Codes mit Namen und Synonymen.
 * Generiert aus der ICD-10-GM CSV-Datei via: npm run generate:icd10
 */
export const ICD10_DATA = [
  {
    "code": "A00.0",
    "name": "Klassische Cholera",
    "synonyms": [
      "Cholera durch Vibrio cholerae O:1, Biovar cholerae",
      "Klassische Cholera"
    ]
  },
  {
    "code": "A00.1",
    "name": "El-Tor-Cholera",
    "synonyms": [
      "Cholera durch Vibrio cholerae O:1, Biovar eltor",
      "Choleraartige Dysenterie",
      "El-Tor-Cholera",
      "El-Tor-Enteritis"
    ]
  },
  {
    "code": "A00.9",
    "name": "Cholera",
    "synonyms": [
      "Cholera",
      "Cholera asiatica",
      "Cholera durch Vibrio cholerae O:1",
      "Cholera epidemica",
      "Cholera maligna"
    ]
  },
  {
    "code": "A01.0",
    "name": "Gallenblasentyphus",
    "synonyms": [
      "Abdomentyphus",
      "Abdominaltyphus",
      "Bauchtyphus",
      "Darmtyphus",
      "Eberth-Krankheit",
      "Enteritisches Fieber",
      "Enterotyphus",
      "Febris enterica",
      "Gallenblasentyphus",
      "Gastroenteritisches Fieber",
      "Gehirntyphus",
      "Hauttyphus",
      "Ileotyphus",
      "Infektion durch Bacterium typhosum",
      "Infektion durch Eberthella typhosa",
      "Infektion durch Salmonella typhi",
      "Lebertyphus",
      "Lungentyphus",
      "Lymphadenitis mesenterialis durch Salmonella typhi",
      "Posttyphoider Abszess",
      "Status typhoides",
      "Typhoenteritis",
      "Typhogastrisches Fieber",
      "Typhoide Salmonellose",
      "Typhoides Fieber",
      "Typhomanie",
      "Typhoperitonitis",
      "Typhus",
      "Typhus abdominalis",
      "Typhusinfektion",
      "Typhöse Enteritis",
      "Typhöse Fistel",
      "Typhöses Darmulkus",
      "Typhöses perforiertes Ulkus"
    ]
  },
  {
    "code": "A01.1",
    "name": "Paratyphus A",
    "synonyms": [
      "Fieber bei Paratyphus A",
      "Infektion durch Salmonella paratyphi A",
      "Paratyphus A"
    ]
  },
  {
    "code": "A01.2",
    "name": "Paratyphus B",
    "synonyms": [
      "Fieber bei Paratyphus B",
      "Infektion durch Salmonella paratyphi B",
      "Infektion durch Salmonella schottmuelleri",
      "Paratyphus B"
    ]
  },
  {
    "code": "A01.3",
    "name": "Paratyphus C",
    "synonyms": [
      "Fieber bei Paratyphus C",
      "Infektion durch Salmonella hirschfeldii",
      "Infektion durch Salmonella paratyphi C",
      "Paratyphus C"
    ]
  },
  {
    "code": "A01.4",
    "name": "Paratyphus",
    "synonyms": [
      "Abdominaler Paratyphus",
      "Gastroenteritis bei Paratyphus",
      "Gastroenteritis paratyphosa",
      "Infektion durch Salmonella paratyphi",
      "Paratyphus",
      "Paratyphus abdominalis",
      "Paratyphus-Fieber",
      "Paratyphöse Enteritis"
    ]
  },
  {
    "code": "A02.0",
    "name": "Enteritis durch Salmonellen",
    "synonyms": [
      "Arizona-Enteritis",
      "Diarrhoe durch Erreger der Arizona-Gruppe",
      "Dysenterie durch Salmonellen",
      "Enteritis durch Salmonellen",
      "Enterokolitis durch Salmonellen",
      "Gastroenteritis durch Salmonellen",
      "Salmonellenenteritis"
    ]
  },
  {
    "code": "A02.1",
    "name": "Sepsis durch Salmonellen",
    "synonyms": [
      "Salmonellensepsis",
      "Sepsis durch Salmonellen"
    ]
  },
  {
    "code": "A02.2",
    "name": "Lokale Infektion durch Salmonellen a.n.k.",
    "synonyms": [
      "Lokale Infektion durch Salmonellen a.n.k.",
      "Lokalisierte Salmonelleninfektion"
    ]
  },
  {
    "code": "A02.8",
    "name": "Invasive nontyphoidale Salmonellose",
    "synonyms": [
      "Invasive nontyphoidale Salmonellose"
    ]
  },
  {
    "code": "A02.9",
    "name": "Salmonellen-Infektion",
    "synonyms": [
      "Lebensmittelvergiftung durch Salmonellen",
      "Salmonellen-Infektion",
      "Salmonellose",
      "Vergiftung durch Bacillus cholerae-suis",
      "Vergiftung durch Salmonellen",
      "Vergiftung durch Suipestiferbakterien"
    ]
  },
  {
    "code": "A03.0",
    "name": "Shigellose durch Shigella dysenteriae",
    "synonyms": [
      "Dysenterie durch Shigella dysenteriae",
      "Dysenterie durch Shigellen der Gruppe A",
      "Infektion durch Shigella dysenteriae",
      "Infektion durch Shigella schmitzii",
      "Infektion durch Shigella shigae",
      "Infektion durch Shigellen der Gruppe A",
      "Ruhr durch Shiga-Kruse-Bakterien",
      "Schmitz-Stutzer-Dysenterie",
      "Shiga-Kruse-Dysenterie",
      "Shiga-Kruse-Ruhr",
      "Shigellose durch Shigella dysenteriae",
      "Shigellose durch Shigellen der Gruppe A"
    ]
  },
  {
    "code": "A03.1",
    "name": "Bakterielle Ruhr durch Shigella flexneri",
    "synonyms": [
      "Bakterielle Ruhr durch Shigella flexneri",
      "Dysenterie durch Shigella flexneri",
      "Dysenterie durch Shigella paradysenteriae",
      "Dysenterie durch Shigellen der Gruppe B",
      "Flexner-Diarrhoe",
      "Flexner-Dysenterie",
      "Hiss-Russel-Dysenterie",
      "Infektion durch Flexner-Bakterien",
      "Infektion durch Shigella flexneri",
      "Infektion durch Shigellen der Gruppe B",
      "Shigellose durch Shigella flexneri",
      "Shigellose durch Shigellen der Gruppe B"
    ]
  },
  {
    "code": "A03.2",
    "name": "Bakterielle Ruhr durch Shigella boydii",
    "synonyms": [
      "Bakterielle Ruhr durch Shigella boydii",
      "Boyd-Bazilleninfektion",
      "Boyd-Dysenterie",
      "Dysenterie durch Shigella boydii",
      "Dysenterie durch Shigellen der Gruppe C",
      "Infektion durch Shigella boydii",
      "Infektion durch Shigellen der Gruppe C",
      "Shigellose durch Shigella boydii",
      "Shigellose durch Shigellen der Gruppe C"
    ]
  },
  {
    "code": "A03.3",
    "name": "Bakterielle Ruhr durch Shigella sonnei",
    "synonyms": [
      "Bakterielle Ruhr durch Shigella sonnei",
      "Dysenterie durch Shigella sonnei",
      "Dysenterie durch Shigellen der Gruppe D",
      "Dysenterie durch Sonne-Bakterien",
      "Infektion durch E-Ruhr-Bakterien",
      "Infektion durch Kruse-Sonne-Ruhr-Bakterien",
      "Infektion durch Shigella sonnei",
      "Infektion durch Shigellen der Gruppe D",
      "Shigellose durch Shigella sonnei",
      "Shigellose durch Shigellen der Gruppe D",
      "Sonne-Kruse-Dysenterie"
    ]
  },
  {
    "code": "A03.9",
    "name": "Bakterienruhr",
    "synonyms": [
      "Bakterielle Dysenterie",
      "Bakterielle Ruhr",
      "Bakterienruhr",
      "Dysenterie durch Shigella a.n.k.",
      "Enteritis durch Shigellosis",
      "Ruhrbakterien-Infektion",
      "Shigella-Infektion",
      "Shigella-Sepsis",
      "Shigellose"
    ]
  },
  {
    "code": "A04.0",
    "name": "Enteritis durch enteropathogene Escherichia coli",
    "synonyms": [
      "Darminfektion durch enteropathogene Escherichia coli",
      "Diarrhoe durch EPEC [enteropathogene Escherichia coli]",
      "Diarrhoe durch enteropathogene Escherichia coli",
      "Enteritis durch enteropathogene Escherichia coli"
    ]
  },
  {
    "code": "A04.1",
    "name": "Diarrhoe durch enterotoxinbildende Escherichia coli",
    "synonyms": [
      "Darminfektion durch enterotoxinbildende Escherichia coli",
      "Diarrhoe durch enterotoxinbildende Escherichia coli",
      "Enteritis durch ETEC [Enterotoxinbildende Escherichia coli]",
      "Enteritis durch enterotoxinbildende Escherichia coli"
    ]
  },
  {
    "code": "A04.2",
    "name": "Diarrhoe durch enteroinvasive Escherichia coli",
    "synonyms": [
      "Darminfektion durch enteroinvasive Escherichia coli",
      "Diarrhoe durch enteroinvasive Escherichia coli",
      "Enteritis durch EIEC [Enteroinvasive Escherichia coli]",
      "Enteritis durch enteroinvasive Escherichia coli"
    ]
  },
  {
    "code": "A04.3",
    "name": "Diarrhoe durch enterohämorrhagische Escherichia coli",
    "synonyms": [
      "Darminfektion durch enterohämorrhagische Escherichia coli",
      "Diarrhoe durch enterohämorrhagische Escherichia coli",
      "Enteritis durch EHEC [Enterohämorrhagische Escherichia coli]",
      "Enteritis durch enterohämorrhagische Escherichia coli"
    ]
  },
  {
    "code": "A04.4",
    "name": "Enteritis durch Escherichia coli",
    "synonyms": [
      "Darminfektion durch Escherichia coli",
      "Diarrhoe durch Escherichia coli",
      "Diarrhoe durch Kolibakterien",
      "Diarrhoe durch enteroaggregative Escherichia coli",
      "Enteritis durch EAEC [Enteroaggregative Escherichia coli]",
      "Enteritis durch Escherichia coli",
      "Enteritis durch enteroaggregative Escherichia coli",
      "Koli-Enteritis",
      "Koli-Enteritis beim Säugling"
    ]
  },
  {
    "code": "A04.5",
    "name": "Enteritis durch Campylobacter",
    "synonyms": [
      "Diarrhoe durch Campylobacter",
      "Enteritis durch Campylobacter",
      "Intestinale Infektion durch Campylobacter"
    ]
  },
  {
    "code": "A04.6",
    "name": "Enteritis durch Yersinia enterocolitica",
    "synonyms": [
      "Diarrhoe durch Yersinia enterocolitica",
      "Enteritis durch Yersinia enterocolitica",
      "Enteritis durch Yersinien",
      "Infektion durch Yersinia enterocolitica",
      "Intestinale Yersiniose"
    ]
  },
  {
    "code": "A04.70",
    "name": "Enterokolitis durch Clostridium difficile ohne Megakolon, ohne Organkomplikation",
    "synonyms": [
      "Enterokolitis durch Clostridium difficile ohne Megakolon, ohne Organkomplikation"
    ]
  },
  {
    "code": "A04.71",
    "name": "Enterokolitis durch Clostridium difficile ohne Megakolon, mit Organkomplikation",
    "synonyms": [
      "Enterokolitis durch Clostridium difficile ohne Megakolon, mit Organkomplikation"
    ]
  },
  {
    "code": "A04.72",
    "name": "Megakolon durch Clostridium difficile",
    "synonyms": [
      "Enterokolitis durch Clostridium difficile mit Megakolon, ohne Organkomplikation",
      "Megakolon durch Clostridium difficile"
    ]
  },
  {
    "code": "A04.73",
    "name": "Enterokolitis durch Clostridium difficile mit Megakolon, mit Organkomplikation",
    "synonyms": [
      "Enterokolitis durch Clostridium difficile mit Megakolon, mit Organkomplikation"
    ]
  },
  {
    "code": "A04.79",
    "name": "Enterokolitis durch Clostridium difficile",
    "synonyms": [
      "Antibiotika-assoziierte Enterokolitis",
      "Antibiotika-assoziierte Kolitis",
      "Clostridienenteritis",
      "Clostridienenterokolitis",
      "Clostridioides-difficile-Infektion",
      "Colitis pseudomembranacea durch Clostridium difficile",
      "Diarrhoe durch Clostridium difficile",
      "Enterocolitis pseudomembranacea durch Clostridium difficile",
      "Enterokolitis durch Clostridium difficile",
      "Infektion durch Clostridium difficile",
      "Infektiöse Enteritis durch Clostridium difficile",
      "Infektiöse Kolitis durch Clostridium difficile",
      "Kolitis mit Clostridien-Nachweis",
      "Kolitis nach Antibiose",
      "Lebensmittelvergiftung durch Clostridium difficile",
      "Pseudomembranöse Enterokolitis durch Clostridium difficile",
      "Pseudomembranöse Enterokolitis im Sinne der antibiotika-assoziierten Kolitis",
      "Pseudomembranöse Kolitis",
      "Pseudomembranöse Kolitis durch Clostridium difficile",
      "Pseudomembranöse Kolitis im Sinne der antibiotika-assoziierten Kolitis",
      "Toxische Enteritis durch Clostridium difficile",
      "Toxische Kolitis durch Clostridium difficile"
    ]
  },
  {
    "code": "A04.8",
    "name": "Diarrhoe durch Clostridium perfringens",
    "synonyms": [
      "Diarrhoe durch Aerobacter aerogenes",
      "Diarrhoe durch Clostridium perfringens",
      "Diarrhoe durch Staphylokokken",
      "Enterokolitis durch Pseudotuberkulose"
    ]
  },
  {
    "code": "A04.9",
    "name": "Enteritis durch Bakterien",
    "synonyms": [
      "Bakterielle Diarrhoe a.n.k.",
      "Bakterielle Enteritis a.n.k.",
      "Bakterielle Kolitis",
      "Enteritis durch Bakterien"
    ]
  },
  {
    "code": "A05.0",
    "name": "Lebensmittelvergiftung durch Staphylokokken",
    "synonyms": [
      "Lebensmittelvergiftung durch Enterotoxin",
      "Lebensmittelvergiftung durch Staphylokokken"
    ]
  },
  {
    "code": "A05.1",
    "name": "Botulismus",
    "synonyms": [
      "Botulinus-Intoxikation",
      "Botulismus",
      "Infektion durch Clostridium botulinum",
      "Inhalativer Botulismus",
      "Intestinaler Botulismus",
      "Intestinaler Botulismus beim Erwachsenen",
      "Lebensmittelvergiftung durch Clostridium botulinum",
      "Säuglingsbotulismus",
      "Vergiftung durch Bacillus botulinus",
      "Vergiftung durch Botulinus-Toxin",
      "Wundbotulismus"
    ]
  },
  {
    "code": "A05.2",
    "name": "Lebensmittelvergiftung durch Clostridium perfringens",
    "synonyms": [
      "Enteritis necroticans",
      "Lebensmittelvergiftung durch Clostridium perfringens",
      "Lebensmittelvergiftung durch Clostridium welchii",
      "Nekrotische Enteritis",
      "Nekrotisierende Enteritis durch Clostridium perfringens"
    ]
  },
  {
    "code": "A05.3",
    "name": "Lebensmittelvergiftung durch Vibrio parahaemolyticus",
    "synonyms": [
      "Lebensmittelvergiftung durch Vibrio parahaemolyticus"
    ]
  },
  {
    "code": "A05.4",
    "name": "Lebensmittelvergiftung durch Bacillus cereus",
    "synonyms": [
      "Lebensmittelvergiftung durch Bacillus cereus"
    ]
  },
  {
    "code": "A05.9",
    "name": "Gastroenteritis durch Lebensmittelvergiftung",
    "synonyms": [
      "Bakterielle Vergiftung",
      "Bakterielle Vergiftung durch Fisch",
      "Bakterielle Vergiftung durch Fleisch",
      "Bakterielle Vergiftung durch Muscheln",
      "Bakterielle Vergiftung durch Nahrungsmittel",
      "Bakterielle Vergiftung durch Schalentiere",
      "Bakterielle Vergiftung durch essbare Meerestiere",
      "Gastroenteritis durch Lebensmittelvergiftung",
      "Indigestion völlig verdorbener Lebensmittel a.n.k.",
      "Infektion durch Lebensmittel",
      "Infektion durch Nahrungsmittel",
      "Vergiftung durch Bakterientoxin"
    ]
  },
  {
    "code": "A06.0",
    "name": "Dysenterie durch Amöben",
    "synonyms": [
      "Akute Amöbenruhr",
      "Akute Amöbiasis",
      "Akute Amöbiasis durch Entamoeba histolytica",
      "Akute Diarrhoe durch Amöben",
      "Akute Dysenterie durch Amöben",
      "Akute Enteritis durch Amöben",
      "Akute amöbische Diarrhoe",
      "Akute amöbische Dysenterie",
      "Akute amöbische Enteritis",
      "Amöbenruhr",
      "Amöbiasis intestinalis",
      "Amöbische Diarrhoe",
      "Amöbische Dysenterie",
      "Amöbische Enteritis",
      "Diarrhoe durch Amöben",
      "Dysenterie durch Amöben",
      "Enteritis durch Amöben",
      "Kolitis durch Amöben"
    ]
  },
  {
    "code": "A06.1",
    "name": "Chronische intestinale Amöbiasis",
    "synonyms": [
      "Chronische Diarrhoe durch Amöben",
      "Chronische Dysenterie durch Amöben",
      "Chronische Enteritis durch Amöben",
      "Chronische amöbische Diarrhoe",
      "Chronische amöbische Dysenterie",
      "Chronische amöbische Enteritis",
      "Chronische intestinale Amöbiasis",
      "Chronische intestinale Amöbiasis durch Entamoeba histolytica",
      "Darmulkus bei chronischer Amöbiasis"
    ]
  },
  {
    "code": "A06.2",
    "name": "Nichtdysenterische Kolitis durch Amöben",
    "synonyms": [
      "Nichtdysenterische Diarrhoe durch Amöben",
      "Nichtdysenterische Enteritis durch Amöben",
      "Nichtdysenterische Kolitis durch Amöben",
      "Nichtdysenterische Kolitis durch Entamoeba histolytica",
      "Nichtdysenterische amöbische Diarrhoe",
      "Nichtdysenterische amöbische Enteritis"
    ]
  },
  {
    "code": "A06.3",
    "name": "Darmamöbom",
    "synonyms": [
      "Amöbom",
      "Amöbom des Darmes",
      "Darmamöbom"
    ]
  },
  {
    "code": "A06.7",
    "name": "Hautabszess durch Amöben",
    "synonyms": [
      "Amöbiasis der Haut",
      "Dermatitis durch Amöben",
      "Hautabszess durch Amöben",
      "Hautamöbiasis",
      "Hautulkus durch Amöben",
      "Infektion der Haut durch Entamoeba histolytica"
    ]
  },
  {
    "code": "A06.8",
    "name": "Appendizitis durch Amöben",
    "synonyms": [
      "Akute Proktitis durch Amöben",
      "Appendizitis durch Amöben"
    ]
  },
  {
    "code": "A06.9",
    "name": "Amöbiasis",
    "synonyms": [
      "Amöben-Befall",
      "Amöben-Infektion",
      "Amöbiasis",
      "Amöbiasis durch Entamoeba histolytica",
      "Befall durch Entamoeba histolytica a.n.k.",
      "Infektion durch Entamoeba histolytica - s.a. Amöbiasis oder s.a. Krankheit durch Amöben"
    ]
  },
  {
    "code": "A07.0",
    "name": "Balantidiose",
    "synonyms": [
      "Anämie durch Balantidium coli",
      "Balantidiasis",
      "Balantidienruhr",
      "Balantidiose",
      "Befall durch Balantidium coli",
      "Diarrhoe durch Balantidium coli",
      "Dysenterie durch Balantidium coli",
      "Infektion durch Balantidium coli",
      "Kolitis durch Balantidium coli"
    ]
  },
  {
    "code": "A07.1",
    "name": "Lambliasis",
    "synonyms": [
      "Befall durch Giardia lamblia",
      "Diarrhoe durch Giardia intestinalis",
      "Diarrhoe durch Giardia lamblia",
      "Diarrhoe durch Lamblia intestinalis",
      "Dysenterie durch Giardia intestinalis",
      "Dysenterie durch Giardia lamblia",
      "Dysenterie durch Lamblia intestinalis",
      "Enteritis durch Giardia lamblia",
      "Giardiasis",
      "Infektion durch Giardia lamblia",
      "Infektion durch Lamblia intestinalis",
      "Infektiöse Enteritis durch Lamblia intestinalis",
      "Kolitis durch Giardia lamblia",
      "Kolitis durch Lamblia intestinalis",
      "Lambliasis",
      "Lamblien-Enteritis",
      "Lambliose"
    ]
  },
  {
    "code": "A07.2",
    "name": "Enteritis durch Kryptosporidien",
    "synonyms": [
      "Diarrhoe durch Kryptosporidien",
      "Enteritis durch Kryptosporidien",
      "Gastroenteritis durch Kryptosporidien",
      "Infektion durch Cryptosporidium",
      "Kryptosporidiose"
    ]
  },
  {
    "code": "A07.3",
    "name": "Kokzidiose",
    "synonyms": [
      "Befall durch Kokzidien",
      "Coccidiosis - s.a. Kokzidiose",
      "Diarrhoe durch Isospora belli",
      "Diarrhoe durch Isospora hominis",
      "Diarrhoe durch Kokzidien",
      "Dysenterie durch Isospora belli",
      "Dysenterie durch Isospora hominis",
      "Dysenterie durch Kokzidien",
      "Enteritis durch Kokzidien",
      "Infektion durch Isospora belli",
      "Infektion durch Isospora hominis",
      "Intestinale Kokzidiose",
      "Isosporiasis",
      "Isosporose",
      "Kokzidien-Infektion",
      "Kokzidiose",
      "Kolitis durch Isospora belli",
      "Kolitis durch Isospora hominis",
      "Kolitis durch Kokzidien",
      "Zyklosporiasis"
    ]
  },
  {
    "code": "A07.8",
    "name": "Cercomoniasis",
    "synonyms": [
      "Befall durch Chilomastix",
      "Befall durch Embadomonas",
      "Cercomoniasis",
      "Chilomastigiasis",
      "Diarrhoe durch Chilomastix",
      "Diarrhoe durch Dientamoeba",
      "Diarrhoe durch Trichomonas",
      "Dysenterie durch Chilomastix",
      "Dysenterie durch Dientamoeba fragilis",
      "Dysenterie durch Embadomonas",
      "Dysenterie durch Trichomonas",
      "Embadomoniasis",
      "Embadomoninale Enteritis",
      "Enteritis durch Chilomastix",
      "Enteritis durch Mikrosporidiose",
      "Enteritis durch Trichomonas",
      "Infektion durch Chilomastix intestinalis",
      "Infektion durch Sarcocystis",
      "Infektion durch Trichomonas intestinalis",
      "Infektiöse Enteritis durch Trichomonas",
      "Intestinale Mikrosporidiose",
      "Intestinale Sarkosporidiose",
      "Intestinale Trichomoniase",
      "Kolitis durch Trichomonas",
      "Sarkosporidiose",
      "Sarkozystose",
      "Trichomoniasis intestinalis"
    ]
  },
  {
    "code": "A07.9",
    "name": "Diarrhoe durch Flagellaten",
    "synonyms": [
      "Darminfektion durch Flagellaten",
      "Darminfektion durch Protozoen",
      "Darmkrankheit durch Protozoen",
      "Diarrhoe durch Flagellaten",
      "Diarrhoe durch Protozoen",
      "Dysenterie durch Protozoen",
      "Enteritis durch Protozoen",
      "Intestinale Krankheit durch Protozoen",
      "Kolitis durch Protozoen",
      "Kolonkrankheit durch Protozoen"
    ]
  },
  {
    "code": "A08.0",
    "name": "Enteritis durch Rotaviren",
    "synonyms": [
      "Enteritis durch Rotaviren",
      "Gastroenteritis durch Rotaviren",
      "Infektion durch Rotaviren",
      "Rotaviren-Diarrhoe",
      "Rotaviren-Infektion"
    ]
  },
  {
    "code": "A08.1",
    "name": "Akute Gastroenteritis durch Norwalk-Virus",
    "synonyms": [
      "Akute Gastroenteritis durch Norovirus",
      "Akute Gastroenteritis durch Norwalk-Virus",
      "Akute Gastroenteropathie durch Norwalk-Virus",
      "Bradley-Krankheit",
      "Epidemische Nausea",
      "Epidemische virale Gastroenteritis",
      "Epidemisches Erbrechen",
      "Goodall-Krankheit",
      "Norovirus-Enteritis",
      "Spencer-Krankheit",
      "Virale Enteritis durch Norwalk-Virus"
    ]
  },
  {
    "code": "A08.2",
    "name": "Enteritis durch Adenoviren",
    "synonyms": [
      "Diarrhoe durch Adenoviren",
      "Enteritis durch Adenoviren"
    ]
  },
  {
    "code": "A08.3",
    "name": "Diarrhoe durch Enteroviren",
    "synonyms": [
      "Coxsackie-Enteritis",
      "Diarrhoe durch Enteroviren",
      "Infantile virale Gastroenteritis",
      "Infektiöse Enteritis durch Enteroviren",
      "Schwere virale Gastroenteritis im Säuglingsalter",
      "Virale Enteritis durch Enteroviren"
    ]
  },
  {
    "code": "A08.4",
    "name": "Virusenteritis",
    "synonyms": [
      "Dysenterie durch Viren",
      "Gastroduodenitis durch Viren",
      "Gastroenteritis durch Viren",
      "Gastrointestinale Virusinfektion",
      "Toxische Gastroenteritis durch Viren",
      "Virale Enteritis",
      "Virale Gastritis",
      "Virale Gastroenteritis",
      "Virusdiarrhoe",
      "Virusenteritis"
    ]
  },
  {
    "code": "A08.5",
    "name": "Nichtbakterielle Gastroenteritis im Säuglingsalter",
    "synonyms": [
      "Nichtbakterielle Gastroenteritis im Säuglingsalter"
    ]
  },
  {
    "code": "A09.0",
    "name": "Magen-Darm-Katarrh",
    "synonyms": [
      "Akute hämorrhagische Diarrhoe",
      "Akuter Darmkatarrh",
      "Akuter Magen-Darm-Katarrh",
      "Akuter blutiger Durchfall",
      "Akuter wässriger Durchfall",
      "Arthropathie bei infektiöser Enteritis",
      "Bakterielle Magen-Darm-Infektion",
      "Darminfektion",
      "Darmkatarrh",
      "Diarrhoe, vermutlich infektiösen Ursprungs",
      "Dickdarminfektion",
      "Dysenterie",
      "Dysenterische Diarrhoe",
      "Dysenterischer Durchfall",
      "Dysenterisches Ulkus a.n.k.",
      "Endemische Diarrhoe",
      "Enteritis, vermutlich infektiösen Ursprungs",
      "Enteritische Infektion",
      "Epidemische Diarrhoe",
      "Epidemische Dysenterie",
      "Epidemische Enteritis",
      "Epidemische Gastroenteritis",
      "Epidemischer Durchfall",
      "Gangränöse Enteritis",
      "Gastroenteritis, vermutlich infektiösen Ursprungs",
      "Gastroenteritis, vermutlich infektiösen Ursprungs, mit Diarrhoe",
      "Gastrointestinale Infektion",
      "Hämorrhagische Dysenterie",
      "Infektion des Verdauungskanals a.n.k.",
      "Infektiöse Diarrhoe",
      "Infektiöse Diarrhoe beim Neugeborenen",
      "Infektiöse Diarrhoe und Gastroenteritis",
      "Infektiöse Enteritis a.n.k.",
      "Infektiöse Gastroenteritis",
      "Infektiöse Kolitis",
      "Infektiöse diarrhöische Krankheit a.n.k.",
      "Infektiöse hämorrhagische Enteritis",
      "Infektiöse hämorrhagische Gastroenteritis",
      "Infektiöse hämorrhagische Kolitis",
      "Infektiöse neonatale Diarrhoe",
      "Intestinale Infektion",
      "Katarrhalische Dysenterie",
      "Katarrhalische Kolitis",
      "Koloninfektion",
      "Magen-Darm-Infektion",
      "Magen-Darm-Katarrh",
      "Reisediarrhoe",
      "Ruhr",
      "Septische Diarrhoe",
      "Septische Enteritis",
      "Septische Gastroenteritis",
      "Septische Kolitis",
      "Sporadische Dysenterie",
      "Tropische Dysenterie",
      "Vermutlich infektiöse Diarrhoe",
      "Vermutlich infektiöse Enteritis",
      "Vermutlich infektiöse Gastroenteritis",
      "Vermutlich infektiöse Gastroenteritis mit Diarrhoe",
      "Vermutlich infektiöse Kolitis"
    ]
  },
  {
    "code": "A09.9",
    "name": "Akute Enterokolitis",
    "synonyms": [
      "ADS [Akutes Durchfallsyndrom]",
      "Akute Diarrhoe",
      "Akute Enteritis",
      "Akute Enterogastritis",
      "Akute Enterokolitis",
      "Akute Gastroenteritis",
      "Akute Kolitis",
      "Akute Magen-Darm-Entzündung",
      "Akuter Brechdurchfall",
      "Akuter Durchfall",
      "Blutige Diarrhoe",
      "Brechdurchfall",
      "Colitis - s.a. Kolitis",
      "Darmentzündung",
      "Diarrhoe",
      "Diarrhoe beim Neugeborenen",
      "Diarrhoe mit Erbrechen",
      "Diarrhoe über 1 Woche",
      "Diarrhöische Enteritis",
      "Dickdarmentzündung",
      "Durchfall - s.a. Diarrhoe",
      "Durchfall mit Erbrechen",
      "Durchfall über 1 Woche",
      "Durchfall-Krankheit",
      "Dyspepsie mit Diarrhoe",
      "Dünndarmentzündung",
      "Enteritis",
      "Enteritis ohne Erbrechen",
      "Enterogastritis",
      "Enterokolitis",
      "Enterorrhoe",
      "Entzündliche Diarrhoe",
      "Gastroenteritis",
      "Gastroenterokolitis",
      "Gastrojejunitis",
      "Gastrokolitis",
      "Hämorrhagische Enteritis",
      "Hämorrhagische Gastroenteritis",
      "Hämorrhagische Kolitis",
      "Ileitis",
      "Ileokolitis",
      "Ileumentzündung",
      "Infantile Diarrhoe",
      "Isolierte Diarrhoe",
      "Isolierter Durchfall",
      "Jejunitis",
      "Kolitis",
      "Magen-Darm-Entzündung",
      "Neonatale Diarrhoe",
      "Perikolitis",
      "Perisigmoiditis",
      "Sigmoiditis",
      "Sommerdiarrhoe",
      "Säuglingsdiarrhoe",
      "Säuglingsenteritis",
      "Säuglingsgastroenteritis",
      "Unspezifische Diarrhoe"
    ]
  },
  {
    "code": "A15.0",
    "name": "Bakteriologisch und durch mikroskopische Sputumuntersuchung gesicherte Lungentuberkulose",
    "synonyms": [
      "Bakteriologisch gesicherte Lungentuberkulose",
      "Bakteriologisch gesicherte tuberkulöse Bronchiektasie",
      "Bakteriologisch gesicherte tuberkulöse Lungenfibrose",
      "Bakteriologisch gesicherte tuberkulöse Pneumonie",
      "Bakteriologisch gesicherter tuberkulöser Pneumothorax",
      "Bakteriologisch und durch mikroskopische Sputumuntersuchung gesicherte Lungentuberkulose",
      "Durch mikroskopische Sputumuntersuchung und Kultur gesicherte tuberkulöse Bronchiektasie",
      "Durch mikroskopische Sputumuntersuchung und Kultur gesicherte tuberkulöse Lungenfibrose",
      "Durch mikroskopische Sputumuntersuchung und Kultur gesicherte tuberkulöse Pneumonie",
      "Durch mikroskopische Sputumuntersuchung und Kultur gesicherter tuberkulöser Pneumothorax",
      "Sputumpositive Lungentuberkulose",
      "Sputumpositive Tuberkulose"
    ]
  },
  {
    "code": "A15.1",
    "name": "Durch Kultur gesicherte Lungentuberkulose",
    "synonyms": [
      "Durch Kultur gesicherte Lungentuberkulose"
    ]
  },
  {
    "code": "A15.2",
    "name": "Histologisch gesicherte Lungentuberkulose",
    "synonyms": [
      "Histologisch gesicherte Lungentuberkulose"
    ]
  },
  {
    "code": "A15.3",
    "name": "Gesicherte Lungentuberkulose",
    "synonyms": [
      "Gesicherte Lungentuberkulose"
    ]
  },
  {
    "code": "A15.4",
    "name": "Tuberkulose der Hiluslymphknoten, bakteriologisch oder histologisch gesichert",
    "synonyms": [
      "Tuberkulose der Bronchiallymphknoten, bakteriologisch oder histologisch gesichert",
      "Tuberkulose der Hiluslymphknoten, bakteriologisch oder histologisch gesichert",
      "Tuberkulose der intrathorakalen Lymphknoten, bakteriologisch oder histologisch gesichert",
      "Tuberkulose der mediastinalen Lymphknoten, bakteriologisch oder histologisch gesichert",
      "Tuberkulose der tracheobronchialen Lymphknoten, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse tracheobronchiale Lymphadenopathie, bakteriologisch oder histologisch gesichert"
    ]
  },
  {
    "code": "A15.5",
    "name": "Tuberkulöse Bronchitis, bakteriologisch oder histologisch gesichert",
    "synonyms": [
      "Bronchialtuberkulose, bakteriologisch oder histologisch gesichert",
      "Bronchotracheale Tuberkulose, bakteriologisch oder histologisch gesichert",
      "Epiglottistuberkulose, bakteriologisch oder histologisch gesichert",
      "Glottistuberkulose, bakteriologisch oder histologisch gesichert",
      "Larynxtuberkulose, bakteriologisch oder histologisch gesichert",
      "Tracheatuberkulose, bakteriologisch oder histologisch gesichert",
      "Tracheobronchiale Tuberkulose, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Bronchialblutung, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Bronchitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Bronchorrhagie, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Laryngitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Peribronchitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Perichondritis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Tracheitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse bronchokutane Fistel, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse bronchomediastinale Fistel, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse bronchopleurale Fistel, bakteriologisch oder histologisch gesichert"
    ]
  },
  {
    "code": "A15.6",
    "name": "Tuberkulöses Empyem, bakteriologisch oder histologisch gesichert",
    "synonyms": [
      "Pleuratuberkulose, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Pleurakalzifikation, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Pleuritis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöser Hydropneumothorax, bakteriologisch oder histologisch gesichert",
      "Tuberkulöser Hämothorax, bakteriologisch oder histologisch gesichert a.n.k.",
      "Tuberkulöser Pleurafistel, bakteriologisch oder histologisch gesichert",
      "Tuberkulöser Pyopneumothorax, bakteriologisch oder histologisch gesichert",
      "Tuberkulöser Pyothorax, bakteriologisch oder histologisch gesichert",
      "Tuberkulöses Empyem, bakteriologisch oder histologisch gesichert"
    ]
  },
  {
    "code": "A15.7",
    "name": "Bakteriologisch gesicherte Epituberkulose",
    "synonyms": [
      "Bakteriologisch gesicherte Epituberkulose",
      "Bakteriologisch gesicherter Ghon-Herd",
      "Histologisch gesicherte Epituberkulose",
      "Histologisch gesicherter Ghon-Herd",
      "Infantile Tuberkulose, bakteriologisch oder histologisch gesichert",
      "Lungentuberkulose vom Kindheitstyp, bakteriologisch oder histologisch gesichert",
      "Primäre Bronchiallymphknotentuberkulose, bakteriologisch oder histologisch gesichert",
      "Primäre Lungentuberkulose, bakteriologisch oder histologisch gesichert",
      "Primäre Pleuratuberkulose, bakteriologisch oder histologisch gesichert",
      "Primäre Tuberkulose der Hiluslymphknoten, bakteriologisch oder histologisch gesichert",
      "Primäre Tuberkulose intrathorakaler Lymphknoten, bakteriologisch oder histologisch gesichert",
      "Primäre Tuberkulose mediastinaler Lymphknoten, bakteriologisch oder histologisch gesichert",
      "Primäre Tuberkulose tracheobronchialer Lymphknoten, bakteriologisch oder histologisch gesichert",
      "Primäre tuberkulöse Bronchialfistel, bakteriologisch oder histologisch gesichert",
      "Primäre tuberkulöse tracheobronchiale Lymphadenopathie, bakteriologisch oder histologisch gesichert",
      "Primärer tuberkulöser Lungenabszess, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Erstinfektion, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Primärinfektion, bakteriologisch oder histologisch gesichert",
      "Tuberkulöser Primärkomplex, bakteriologisch oder histologisch gesichert"
    ]
  },
  {
    "code": "A15.8",
    "name": "Tuberkulöse Sinusitis, bakteriologisch oder histologisch gesichert",
    "synonyms": [
      "Akute tuberkulöse Mediastinitis, bakteriologisch oder histologisch gesichert",
      "Chronische tuberkulöse Mediastinitis, bakteriologisch oder histologisch gesichert",
      "Hypopharynxtuberkulose, bakteriologisch oder histologisch gesichert",
      "Nasennebenhöhlentuberkulose, bakteriologisch oder histologisch gesichert",
      "Nasentuberkulose, bakteriologisch oder histologisch gesichert",
      "Nasopharynxtuberkulose, bakteriologisch oder histologisch gesichert",
      "Pharynxtuberkulose, bakteriologisch oder histologisch gesichert",
      "Rachentuberkulose, bakteriologisch oder histologisch gesichert",
      "Tonsillentuberkulose, bakteriologisch oder histologisch gesichert",
      "Tuberkulose des Mediastinums, bakteriologisch oder histologisch gesichert",
      "Tuberkulose des adenoiden Gewebes, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Mediastinitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Pansinusitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Pharyngitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Rhinitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Sinusitis, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Tonsillitis, bakteriologisch und histologisch gesichert",
      "Tuberkulöser Retropharyngealabszess, bakteriologisch oder histologisch gesichert",
      "Tuberkulöser Stirnhöhlenabszess, bakteriologisch und histologisch gesichert"
    ]
  },
  {
    "code": "A15.9",
    "name": "Tuberkulose der Atmungsorgane, bakteriologisch oder histologisch gesichert",
    "synonyms": [
      "Brustkorbtuberkulose, bakteriologisch oder histologisch gesichert",
      "Thoraxtuberkulose, bakteriologisch oder histologisch gesichert",
      "Tuberkulose der Atmungsorgane, bakteriologisch oder histologisch gesichert",
      "Tuberkulöse Infektion, bakteriologisch oder histologisch gesichert"
    ]
  },
  {
    "code": "A16.0",
    "name": "Bakteriologisch und histologisch nicht gesicherte Lungentuberkulose",
    "synonyms": [
      "Bakteriologisch und histologisch nicht gesicherte Lungentuberkulose",
      "Bakteriologisch und histologisch nicht gesicherte tuberkulöse Bronchiektasie",
      "Bakteriologisch und histologisch nicht gesicherte tuberkulöse Lungenfibrose",
      "Bakteriologisch und histologisch nicht gesicherte tuberkulöse Pneumonie",
      "Bakteriologisch und histologisch nicht gesicherter tuberkulöser Pneumothorax"
    ]
  },
  {
    "code": "A16.1",
    "name": "Bakteriologisch und histologisch nicht untersuchte tuberkulöse Bronchiektasie",
    "synonyms": [
      "Bakteriologisch und histologisch nicht untersuchte Lungentuberkulose",
      "Bakteriologisch und histologisch nicht untersuchte tuberkulöse Bronchiektasie",
      "Bakteriologisch und histologisch nicht untersuchte tuberkulöse Lungenfibrose",
      "Bakteriologisch und histologisch nicht untersuchte tuberkulöse Pneumonie",
      "Bakteriologisch und histologisch nicht untersuchter tuberkulöser Pneumothorax"
    ]
  },
  {
    "code": "A16.2",
    "name": "Lungentuberkulose",
    "synonyms": [
      "Apikale Tuberkulose",
      "Assmann-Herd mit Krankheitszeichen a.n.k.",
      "Kalter tuberkulöser Lungenabszess",
      "Käsige Pneumonie",
      "Lungen-TBC [Tuberkulose]",
      "Lungenkaverne",
      "Lungenphthise",
      "Lungenschwindsucht",
      "Lungenspitzentuberkulose",
      "Lungentuberkulose",
      "Phthisis pulmonum",
      "Rasmussen-Aneurysma a.n.k.",
      "Tuberculosis pulmonum",
      "Tuberkulöse Atelektase",
      "Tuberkulöse Bronchiektasie a.n.k.",
      "Tuberkulöse Bronchopneumonie",
      "Tuberkulöse Lungenfibrose",
      "Tuberkulöse Lungenfistel",
      "Tuberkulöse Lungeninfektion durch ein atypisches Mykobakterium",
      "Tuberkulöse Lungeninfiltration",
      "Tuberkulöse Pneumonie",
      "Tuberkulöse Pneumorrhagie",
      "Tuberkulöser Pneumothorax",
      "Tuberkulöses Asthma",
      "Tuberkulöses Emphysem",
      "Tuberkulöses Frühinfiltrat mit Krankheitszeichen",
      "Tuberkulöses Lungenulkus"
    ]
  },
  {
    "code": "A16.3",
    "name": "Tuberkulose der hilären Lymphknoten",
    "synonyms": [
      "Hilusdrüsentuberkulose",
      "Intrathorakale Lymphknoten-TBC [Tuberkulose]",
      "Mediastinale Lymphknoten-TBC [Tuberkulose]",
      "Tuberkulose der Hiluslymphknoten",
      "Tuberkulose der hilären Lymphknoten",
      "Tuberkulose der intrathorakalen Lymphknoten",
      "Tuberkulose der mediastinalen Lymphknoten",
      "Tuberkulose der tracheobronchialen Drüsen",
      "Tuberkulose der tracheobronchialen Lymphknoten",
      "Tuberkulöse tracheobronchiale Lymphadenopathie"
    ]
  },
  {
    "code": "A16.4",
    "name": "Laryngophthise",
    "synonyms": [
      "Bronchialtuberkulose",
      "Bronchientuberkulose",
      "Bronchitis tuberculosa",
      "Bronchotracheale Tuberkulose",
      "Bronchustuberkulose",
      "Chronische Tracheitis mit tuberkulöser Laryngitis",
      "Epiglottistuberkulose",
      "Glottis-TBC [Tuberkulose]",
      "Glottistuberkulose",
      "Isolierte Trachea-TBC [Tuberkulose]",
      "Kehldeckeltuberkulose",
      "Kehlkopf-TBC [Tuberkulose]",
      "Kehlkopftuberkulose",
      "Käsige tuberkulöse Bronchitis",
      "Laryngophthise",
      "Larynx-TBC [Tuberkulose]",
      "Larynxtuberkulose",
      "Tracheatuberkulose",
      "Tracheitis mit tuberkulöser Bronchitis a.n.k.",
      "Tracheobronchiale Tuberkulose",
      "Tuberkulose des Stimmapparates",
      "Tuberkulose mit Bronchialblutung",
      "Tuberkulöse Bronchialfistel",
      "Tuberkulöse Bronchitis",
      "Tuberkulöse Bronchorrhagie",
      "Tuberkulöse Laryngitis",
      "Tuberkulöse Laryngotracheitis",
      "Tuberkulöse Peribronchitis",
      "Tuberkulöse Perichondritis des Larynx",
      "Tuberkulöse Tracheastenose",
      "Tuberkulöse Tracheastriktur a.n.k.",
      "Tuberkulöse Tracheitis",
      "Tuberkulöse bronchokutane Fistel a.n.k.",
      "Tuberkulöse bronchomediastinale Fistel a.n.k.",
      "Tuberkulöse bronchopleurale Fistel a.n.k.",
      "Tuberkulöse bronchopleuromediastinale Fistel a.n.k."
    ]
  },
  {
    "code": "A16.5",
    "name": "Pleuritis tuberculosa",
    "synonyms": [
      "Bronchopleurale Tuberkulose",
      "Brustfelltuberkulose",
      "Pleuritis tuberculosa",
      "Rippenfelltuberkulose",
      "Tuberkulose der Pleura",
      "Tuberkulöse Brustfelladhäsion a.n.k.",
      "Tuberkulöse Pleuraadhäsion a.n.k.",
      "Tuberkulöse Pleurafistel a.n.k.",
      "Tuberkulöse Pleuritis",
      "Tuberkulöse Rippenfelladhäsion a.n.k.",
      "Tuberkulöse pleurokutane Fistel a.n.k.",
      "Tuberkulöse pleuroperitoneale Fistel a.n.k.",
      "Tuberkulöser Hydropneumothorax a.n.k.",
      "Tuberkulöser Hämothorax a.n.k.",
      "Tuberkulöser Pyopneumothorax a.n.k.",
      "Tuberkulöser Pyothorax a.n.k.",
      "Tuberkulöses Empyem",
      "Tuberkulöses Pleuraempyem"
    ]
  },
  {
    "code": "A16.7",
    "name": "Tuberkulöse Erstinfektion",
    "synonyms": [
      "Allergische Epituberkulose",
      "Epituberkulose",
      "Epituberkulose mit Atelektase",
      "Ghon-Herd",
      "Infantile Tuberkulose",
      "Primäre Bronchiallymphknotentuberkulose",
      "Primäre Lungentuberkulose",
      "Primäre Pleuratuberkulose",
      "Primäre Tuberkulose der Atmungsorgane",
      "Primäre Tuberkulose des Mediastinums",
      "Primäre Tuberkulose eines mediastinalen Lymphknotens",
      "Primäre hiläre Lymphknotentuberkulose",
      "Primäre intrathorakale Lymphknotentuberkulose",
      "Primäre progressive Brustfelltuberkulose",
      "Primäre progressive Hiluslymphknotentuberkulose",
      "Primäre progressive Rippenfelltuberkulose",
      "Primäre tracheobronchiale Lymphknotentuberkulose",
      "Primäre tuberkulöse Bronchialfistel",
      "Primäre tuberkulöse Mediastinitis",
      "Primäre tuberkulöse Pleuritis",
      "Primäre tuberkulöse tracheobronchiale Lymphadenopathie",
      "Primärer tuberkulöser Lungenabszess",
      "TBC [Tuberkulose]-Erstinfektion",
      "TBC [Tuberkulose]-Primärinfektion",
      "Tuberkel",
      "Tuberkulose beim Kind",
      "Tuberkulöse Erstinfektion",
      "Tuberkulöse Infektion ohne klinische Manifestation",
      "Tuberkulöse Primärinfektion",
      "Tuberkulöser Primärkomplex"
    ]
  },
  {
    "code": "A16.8",
    "name": "Mediastinale TBC [Tuberkulose]",
    "synonyms": [
      "Gaumenmandeltuberkulose",
      "Hypopharynxtuberkulose",
      "Mandeltuberkulose",
      "Mediastinale TBC [Tuberkulose]",
      "Mediastinumtuberkulose",
      "Nasen-TBC [Tuberkulose]",
      "Nasengangstuberkulose",
      "Nasennebenhöhlen-TBC [Tuberkulose]",
      "Nasennebenhöhlentuberkulose",
      "Nasenrachenraumtuberkulose",
      "Nasenseptumtuberkulose",
      "Nasentuberkulose",
      "Nasopharynxtuberkulose",
      "Pharynxtuberkulose",
      "Rachentuberkulose",
      "Tonsillentuberkulose",
      "Tuberkulose adenoiden Gewebes",
      "Tuberkulose der Nasenscheidewand",
      "Tuberkulöse Mediastinitis",
      "Tuberkulöse Pansinusitis",
      "Tuberkulöse Pharyngitis",
      "Tuberkulöse Rhinitis",
      "Tuberkulöse Sinusitis",
      "Tuberkulöse Tonsillitis",
      "Tuberkulöser Schnupfen",
      "Tuberkulöser Stirnhöhlenabszess",
      "Tuberkulöser retropharyngealer Abszess"
    ]
  },
  {
    "code": "A16.9",
    "name": "Tuberkulöse Infektion a.n.k.",
    "synonyms": [
      "Abscessus frigidus",
      "Alterstuberkulose",
      "Brustkorbtuberkulose",
      "Morbus Koch",
      "Phthise",
      "Phthisis",
      "Schwindsucht - s.a. Tuberkulose",
      "TBC [Tuberkulose] - s.a. Tuberculosis oder s.a. Tuberkulose",
      "TBK - s.a. Tuberkulose",
      "Thoraxtuberkulose",
      "Tuberculosis - s.a. Tuberkulose",
      "Tuberkulom",
      "Tuberkulose",
      "Tuberkulose der Atmungsorgane a.n.k.",
      "Tuberkulöse Auszehrung a.n.k.",
      "Tuberkulöse Degeneration a.n.k.",
      "Tuberkulöse Entzündung a.n.k.",
      "Tuberkulöse Gangrän a.n.k.",
      "Tuberkulöse Infektion a.n.k.",
      "Tuberkulöse Kachexie a.n.k.",
      "Tuberkulöse Nekrose",
      "Tuberkulöser Abszess a.n.k.",
      "Tuberkulöser Marasmus a.n.k."
    ]
  },
  {
    "code": "A18.1",
    "name": "Genitaltuberkulose",
    "synonyms": [
      "Genitaltuberkulose",
      "Harnorgantuberkulose",
      "Harntrakttuberkulose",
      "Harnwegstuberkulose",
      "Primäre Tuberkulose des Urogenitalsystems",
      "TBC [Tuberkulose] des Urogenitalsystems",
      "Tuberkulose der Geschlechtsorgane",
      "Tuberkulose des Urogenitalsystems",
      "Tuberkulöse Harnorganinfektion",
      "Tuberkulöse Hämaturie",
      "Tuberkulöser Abszess der Geschlechtsorgane a.n.k.",
      "Tuberkulöser Abszess der Harn- und Geschlechtsorgane",
      "Tuberkulöser Abszess des Urogenitalsystems",
      "Tuberkulöser Harnorganabszess",
      "Urogenitaltuberkulose"
    ]
  },
  {
    "code": "A18.2",
    "name": "Tuberkulöse Lymphadenitis",
    "synonyms": [
      "Achselhöhlentuberkulose",
      "Halslymphknotentuberkulose",
      "Lymphdrüsentuberkulose",
      "Lymphsystemtuberkulose",
      "Primäre tuberkulöse Lymphadenitis",
      "Skrofulose [Tuberkulose der Halslymphknoten]",
      "Skrofulöse Lymphangitis",
      "Skrofulöse Tuberkulose",
      "Skrofulöse tuberkulöse Lymphadenitis",
      "Skrofulöser Abszess",
      "Skrofulöser tuberkulöser Bubo",
      "Skrofulöses Ulkus",
      "TBC [Tuberkulose] der peripheren Lymphknoten",
      "Tuberkulose der axillären Lymphknoten",
      "Tuberkulose der infraklavikulären Lymphknoten",
      "Tuberkulose der inguinalen Lymphknoten",
      "Tuberkulose der peripheren Lymphknoten",
      "Tuberkulose der supraklavikulären Lymphknoten",
      "Tuberkulose der zervikalen Lymphknoten",
      "Tuberkulöse Adenitis",
      "Tuberkulöse Lymphadenitis",
      "Tuberkulöse Lymphadenopathie",
      "Tuberkulöse Lymphangitis",
      "Tuberkulöse Verkäsung der Lymphknoten",
      "Verkäsung der Lymphknoten"
    ]
  },
  {
    "code": "A18.3",
    "name": "Tuberkulöser Aszites",
    "synonyms": [
      "Abdominaltuberkulose",
      "Omentumtuberkulose",
      "Retroperitoneale Tuberkulose",
      "Tuberkulose der retroperitonealen Lymphknoten",
      "Tuberkulose eines Lymphknotens des Abdomens",
      "Tuberkulöser Aszites"
    ]
  },
  {
    "code": "A18.4",
    "name": "Aknitis",
    "synonyms": [
      "Aknitis",
      "Bazin-Krankheit",
      "Bazin-Syndrom",
      "Haut-TBC [Tuberkulose]",
      "Hauttuberkulose",
      "Lichenoides Tuberkulid",
      "Lupus exedens",
      "Lupus vulgaris",
      "Miliares Tuberkulid",
      "Papulonekrotisches Tuberkulid",
      "Primär lichenoide Tuberkulose",
      "Primär tuberkulöses Erythem",
      "Primäre Aknitis",
      "Primäre Tuberculosis indurativa",
      "Primäre Tuberkulose der Subkutis",
      "Primäre Tuberkulose des Unterhautgewebes",
      "Primäre papulonekrotische Tuberkulose",
      "Primäre tuberkulöse Entzündung des Unterhautzellgewebes",
      "Primäre tuberkulöse Lichen scrofulosorum",
      "Primäre tuberkulöse Paronychie",
      "Primäre tuberkulöse Verruca",
      "Primäre tuberkulöse Verruca necrogenica",
      "Primäre tuberkulöse Warze",
      "Primäre tuberkulöse Zellgewebsentzündung",
      "Primäres Skrofuloderm",
      "Primäres Tuberkulid",
      "Primäres lichenoides Tuberkulid",
      "Primäres tuberkulöses Hautulkus",
      "Skrofuloderm",
      "Skrofulöses Gumma",
      "Subkutanes Tuberkulid",
      "Tuberculosis cutis",
      "Tuberculosis cutis colliquativa",
      "Tuberculosis cutis indurativa",
      "Tuberculosis verrucosa",
      "Tuberkulid",
      "Tuberkulid der Haut",
      "Tuberkulose der Ohrhaut",
      "Tuberkulose des Unterhautzellgewebes",
      "Tuberkulose des äußeren Ohres",
      "Tuberkulöser Hautabszess",
      "Tuberkulöser Lupus",
      "Tuberkulöser Lupus vulgaris",
      "Tuberkulöses Erythema induratum",
      "Tuberkulöses Gumma",
      "Tuberkulöses Hautulkus",
      "Ulcus cutis tuberculosum",
      "Verhärtetes Tuberkulid",
      "Verruca tuberculosa"
    ]
  },
  {
    "code": "A18.5",
    "name": "Augentuberkulose",
    "synonyms": [
      "Augen-TBC [Tuberkulose]",
      "Augentuberkulose",
      "Okuläre Tuberkulose",
      "Orbitatuberkulose"
    ]
  },
  {
    "code": "A18.6",
    "name": "Ohrtuberkulose",
    "synonyms": [
      "Innenohrtuberkulose",
      "Ohr-TBC [Tuberkulose]",
      "Ohrtuberkulose"
    ]
  },
  {
    "code": "A18.8",
    "name": "Tuberkulöse Dammfistel",
    "synonyms": [
      "Brustdrüsentuberkulose",
      "Brusttuberkulose",
      "Mammatuberkulose",
      "Multifokale Tuberkulose",
      "Tuberkulose mehrerer Organe",
      "Tuberkulöse Dammfistel",
      "Tuberkulöser Brustdrüsenabszess",
      "Tuberkulöser Mammaabszess"
    ]
  },
  {
    "code": "A19.1",
    "name": "Multiple akute Tuberkulose",
    "synonyms": [
      "Akute tuberkulöse Polyserositis",
      "Multiple akute Miliartuberkulose",
      "Multiple akute Tuberkulose"
    ]
  },
  {
    "code": "A19.2",
    "name": "Akute Miliartuberkulose",
    "synonyms": [
      "Akute Miliartuberkulose"
    ]
  },
  {
    "code": "A19.8",
    "name": "Chronische Miliartuberkulose",
    "synonyms": [
      "Chronische Miliartuberkulose",
      "Chronische multiple Tuberkulose",
      "Chronische tuberkulöse Polyserositis"
    ]
  },
  {
    "code": "A19.9",
    "name": "Miliartuberkulose",
    "synonyms": [
      "Diffuse Tuberkulose",
      "Disseminierte Tuberkulose",
      "Generalisierte Tuberkulose",
      "Miliare Lungentuberkulose",
      "Miliartuberkulose",
      "Multiple Tuberkulose",
      "Septische Tuberkulose a.n.k.",
      "Tuberkulöse Polyserositis"
    ]
  },
  {
    "code": "A20.0",
    "name": "Bubonenpest",
    "synonyms": [
      "Beulenpest",
      "Bubo durch Yersinia pestis",
      "Bubonenpest",
      "Maligne Polyadenitis",
      "Pestis fulminans"
    ]
  },
  {
    "code": "A20.1",
    "name": "Hautpest",
    "synonyms": [
      "Hautpest"
    ]
  },
  {
    "code": "A20.2",
    "name": "Lungenpest",
    "synonyms": [
      "Lungenpest",
      "Pestpneumonie",
      "Pneumonie durch Yersinia pestis",
      "Primäre Lungenpest",
      "Primäre Pestpneumonie",
      "Sekundäre Lungenpest",
      "Sekundäre Pestpneumonie"
    ]
  },
  {
    "code": "A20.7",
    "name": "Pestsepsis",
    "synonyms": [
      "Pestis siderans",
      "Pestsepsis",
      "Sepsis durch Yersinia pestis"
    ]
  },
  {
    "code": "A20.8",
    "name": "Abortive Pest",
    "synonyms": [
      "Abortive Pest",
      "Asymptomatische Pest",
      "Pestis minor",
      "Pharyngeale Pest",
      "Tonsilläre Pest"
    ]
  },
  {
    "code": "A20.9",
    "name": "Pest",
    "synonyms": [
      "Bakteriämie durch Pestbakterien",
      "Bakteriämie durch Yersinia pestis",
      "Infektion durch Pasteurella pestis",
      "Infektion durch Yersinia pestis - s.a. Pest",
      "Pest",
      "Pest-Fieber",
      "Pestbakterien-Infektion",
      "Pestis"
    ]
  },
  {
    "code": "A21.0",
    "name": "Ulzeroglanduläre Tularämie",
    "synonyms": [
      "Ulzeroglanduläre Tularämie"
    ]
  },
  {
    "code": "A21.1",
    "name": "Okuloglanduläre Tularämie",
    "synonyms": [
      "Augentularämie",
      "Okuloglanduläre Tularämie"
    ]
  },
  {
    "code": "A21.2",
    "name": "Pulmonale Tularämie",
    "synonyms": [
      "Lungentularämie",
      "Pulmonale Tularämie"
    ]
  },
  {
    "code": "A21.3",
    "name": "Gastrointestinale Tularämie",
    "synonyms": [
      "Abdominale Tularämie",
      "Gastrointestinale Tularämie",
      "Ingestion bei Tularämie"
    ]
  },
  {
    "code": "A21.7",
    "name": "Generalisierte Tularämie",
    "synonyms": [
      "Generalisierte Tularämie",
      "Sepsis bei Tularämie",
      "Septische Tularämie",
      "Typhöse Tularämie"
    ]
  },
  {
    "code": "A21.8",
    "name": "Tracheobronchitis durch Francisella tularensis",
    "synonyms": [
      "Tracheobronchitis durch Francisella tularensis"
    ]
  },
  {
    "code": "A21.9",
    "name": "Tularämie",
    "synonyms": [
      "Chrysops-Fieber",
      "Francis-Krankheit",
      "Hasenfieber",
      "Hasenpest",
      "Hirschfliegen-Fieber",
      "Infektion durch Francisella tularensis",
      "Infektion durch Pasteurella tularensis",
      "Lemming-Fieber",
      "Ohara-Krankheit",
      "Pahvant-Tal-Krankheit",
      "Tularämie",
      "Wildkaninchen-Krankheit"
    ]
  },
  {
    "code": "A22.0",
    "name": "Hautmilzbrand",
    "synonyms": [
      "Anthrax contagiosus",
      "Anthrax der Haut",
      "Hautmilzbrand",
      "Milzbrand-Karbunkel",
      "Pustula maligna"
    ]
  },
  {
    "code": "A22.1",
    "name": "Hadern-Krankheit",
    "synonyms": [
      "Hadern-Krankheit"
    ]
  },
  {
    "code": "A22.2",
    "name": "Darmmilzbrand",
    "synonyms": [
      "Darmmilzbrand",
      "Intestinaler Anthrax",
      "Intestinaler Milzbrand",
      "Kolitis durch Anthrax",
      "Kolitis durch Milzbrand",
      "Milzbrand des Magen-Darm-Traktes"
    ]
  },
  {
    "code": "A22.7",
    "name": "Milzbrand-Sepsis",
    "synonyms": [
      "Anthrax-Sepsis",
      "Milzbrand-Sepsis",
      "Sepsis durch Bacillus anthracis"
    ]
  },
  {
    "code": "A22.9",
    "name": "Milzbrand",
    "synonyms": [
      "Anthrax - s.a. Milzbrand",
      "Febris carbuncularis",
      "Infektion durch Anthraxbazillen",
      "Infektion durch Bacillus anthracis - s.a. Anthrax oder s.a. Milzbrand",
      "Milzbrand",
      "Milzbrand-Fieber"
    ]
  },
  {
    "code": "A23.0",
    "name": "Malta-Fieber",
    "synonyms": [
      "Brucellose durch Brucella melitensis",
      "Febris melitensis",
      "Febris undulans melitensis",
      "Gibraltar-Fieber",
      "Infektion durch Brucella melitensis",
      "Malta-Fieber",
      "Mittelmeer-Fieber",
      "Neapolitan-Fieber",
      "Zypern-Fieber"
    ]
  },
  {
    "code": "A23.1",
    "name": "Bang-Krankheit",
    "synonyms": [
      "Abortus-Bang-Infektion",
      "Bang-Infektion",
      "Bang-Krankheit",
      "Brucellose durch Brucella abortus",
      "Febris abortus [Bang]",
      "Febris undulans Bang",
      "Febris undulans bovina",
      "Infektion durch Brucella abortus",
      "Morbus Abortus Bang",
      "Morbus Bang"
    ]
  },
  {
    "code": "A23.2",
    "name": "Schweinebrucellose",
    "synonyms": [
      "Brucellose durch Brucella suis",
      "Infektion durch Brucella suis",
      "Schweinebrucellose"
    ]
  },
  {
    "code": "A23.3",
    "name": "Brucellose durch Brucella canis",
    "synonyms": [
      "Brucellose durch Brucella canis",
      "Infektion durch Brucella canis"
    ]
  },
  {
    "code": "A23.8",
    "name": "Mischform der Brucellose",
    "synonyms": [
      "Mischform der Brucellose"
    ]
  },
  {
    "code": "A23.9",
    "name": "Endemische Bazillokokkie [Brucellose]",
    "synonyms": [
      "Brucella-Infektion",
      "Brucella-Sepsis",
      "Brucellose",
      "Endemische Bazillokokkie [Brucellose]",
      "Febris mediterranea",
      "Febris undulans",
      "Septische Brucellose",
      "Spondylitis brucellosa",
      "Undulierendes Fieber - s.a. Brucellose"
    ]
  },
  {
    "code": "A24.0",
    "name": "Rotz",
    "synonyms": [
      "Akuter Rotz",
      "Chronischer Rotz",
      "Infektion durch Burkholderia mallei",
      "Infektion durch Pseudomonas mallei",
      "Maliasmus",
      "Malleus",
      "Rotz",
      "Sepsis bei Malleus"
    ]
  },
  {
    "code": "A24.1",
    "name": "Akute Melioidose",
    "synonyms": [
      "Akute Melioidose",
      "Akute Melioidosis",
      "Akute pulmonale Melioidose",
      "Fulminante Melioidose",
      "Melioidose mit Sepsis",
      "Pneumonie durch Pseudomonas pseudomallei",
      "Septische Melioidose"
    ]
  },
  {
    "code": "A24.2",
    "name": "Chronische Melioidose",
    "synonyms": [
      "Chronische Melioidose",
      "Chronische pulmonale Melioidose",
      "Subakute Melioidose",
      "Subakute pulmonale Melioidose"
    ]
  },
  {
    "code": "A24.4",
    "name": "Melioidose",
    "synonyms": [
      "Infektion durch Burkholderia pseudomallei",
      "Infektion durch Malleomyces pseudomallei",
      "Infektion durch Pseudomonas pseudomallei",
      "Melioidose",
      "Melioidosis",
      "Pseudorotz",
      "Whitmore-Fieber",
      "Whitmore-Krankheit"
    ]
  },
  {
    "code": "A25.0",
    "name": "Sodoku",
    "synonyms": [
      "Fieber durch Spirillen",
      "Infektion durch Spirillum minus",
      "Rattenbiss-Fieber durch Spirillum minus",
      "Rattenbiss-Fieber durch Spirochaeta morsus muris",
      "Rattenbiss-Krankheit durch Spirillen",
      "Sodoku",
      "Spirillen-Rattenbisskrankheit"
    ]
  },
  {
    "code": "A25.1",
    "name": "Haverhill-Fieber",
    "synonyms": [
      "Epidemisches arthritisches Erythem",
      "Erythema arthriticum epidemicum",
      "Fieber durch Streptobazillen",
      "Haverhill-Fieber",
      "Infektion durch Streptobacillus moniliformis",
      "Rattenbiss-Fieber durch Streptobacillus moniliformis",
      "Rattenbiss-Fieber durch Streptobazillen",
      "Rattenbiss-Krankheit durch Streptobazillen",
      "Streptobazillen-Rattenbisskrankheit"
    ]
  },
  {
    "code": "A25.9",
    "name": "Rattenbiss-Fieber",
    "synonyms": [
      "Rattenbiss-Fieber",
      "Rattenbiss-Krankheit"
    ]
  },
  {
    "code": "A26.0",
    "name": "Schweinerotlauf",
    "synonyms": [
      "Erythema migrans",
      "Hauterysipeloid",
      "Rosenbach-Erysipeloid",
      "Schweinerotlauf"
    ]
  },
  {
    "code": "A26.7",
    "name": "Sepsis durch Erysipelothrix",
    "synonyms": [
      "Sepsis durch Erysipeloid",
      "Sepsis durch Erysipelothrix"
    ]
  },
  {
    "code": "A26.8",
    "name": "Disseminiertes Erysipeloid",
    "synonyms": [
      "Disseminiertes Erysipeloid"
    ]
  },
  {
    "code": "A26.9",
    "name": "Erysipeloid",
    "synonyms": [
      "Baker-Rosenbach-Krankheit",
      "Erysipeloid",
      "Infektion durch Erysipelothrix insidiosa rhusiopathiae",
      "Pseudoerysipel",
      "Rosenbach-Krankheit",
      "Rotlauf"
    ]
  },
  {
    "code": "A27.0",
    "name": "Weil-Krankheit",
    "synonyms": [
      "Hämorrhagische Leptospiren-Gelbsucht",
      "Hämorrhagische Spirochäten-Gelbsucht",
      "Hämorrhagischer Ikterus durch Leptospiren",
      "Hämorrhagischer Ikterus durch Spirochäten",
      "Infektion durch Leptospira interrogans icterohaemorrhagiae",
      "Infektion durch Spirochaeta icterogenes",
      "Leptospirose durch Leptospira interrogans serovar icterohaemorrhagiae",
      "Leptospirosis icterohaemorrhagica",
      "Spirochaetosis icterohaemorrhagica",
      "Weil-Krankheit",
      "Weil-Landouzy-Krankheit"
    ]
  },
  {
    "code": "A27.8",
    "name": "Nanukayami",
    "synonyms": [
      "Bouchet-Gsell-Krankheit",
      "Charente-Fieber",
      "Fort-Bragg-Fever",
      "Infektion durch Leptospira interrogans autumnalis",
      "Infektion durch Leptospira interrogans canicola",
      "Infektion durch Leptospira interrogans hebdomadis",
      "Infektion durch Leptospira interrogans pomona",
      "Japanisches Herbst-Fieber",
      "Japanisches Siebentagefieber",
      "Kanikola-Fieber",
      "Leptospirosis autumnalis",
      "Leptospirosis canicola",
      "Leptospirosis pomona",
      "Nanukayami",
      "Prätibiales Fieber",
      "Siebentagefieber",
      "Stuttgarter Hundeseuche"
    ]
  },
  {
    "code": "A27.9",
    "name": "Infektion durch Leptospiren",
    "synonyms": [
      "Fieber durch Leptospiren",
      "Infektion durch Leptospira interrogans",
      "Infektion durch Leptospiren",
      "Leptospirochätale Infektion a.n.k.",
      "Leptospirose",
      "Leptospirosis",
      "Schlammfieber",
      "Sumpffieber durch Leptospiren"
    ]
  },
  {
    "code": "A28.0",
    "name": "Pasteurellose",
    "synonyms": [
      "Infektion durch Pasteurella",
      "Infektion durch Pasteurella multocida",
      "Pasteurellose",
      "Sepsis durch Pasteurella multocida"
    ]
  },
  {
    "code": "A28.1",
    "name": "Gutartige Einimpfretikulose",
    "synonyms": [
      "Bartonellose durch Infektion mit Bartonella henselae",
      "Benigne Inokulationslymphoretikulose",
      "Benigne Lymphoretikulose",
      "Debré-Syndrom",
      "Gutartige Einimpfretikulose",
      "Inokulationsadenitis",
      "Katzenkratz-Fieber",
      "Katzenkratz-Krankheit",
      "Katzenkratz-Syndrom",
      "Kratz-Lymphadenitis",
      "Lymphadenitis durch Viren",
      "Petzetakis-Krankheit",
      "Pneumo-lymphonodal-Syndrom"
    ]
  },
  {
    "code": "A28.2",
    "name": "Pseudotuberkulose",
    "synonyms": [
      "Extraintestinale Yersiniose",
      "Infektion durch Yersinia pseudotuberculosis",
      "Pseudotuberculosis",
      "Pseudotuberkulose",
      "Sepsis durch extraintestinale Yersiniose"
    ]
  },
  {
    "code": "A28.8",
    "name": "Aktinobazillose",
    "synonyms": [
      "Aktinobazillose",
      "Infektion durch Actinobacillus actinomycetem comitans"
    ]
  },
  {
    "code": "A28.9",
    "name": "Bakterielle Zoonose",
    "synonyms": [
      "Bakterielle Zoonose",
      "Bakterielle zoonotische Krankheit a.n.k."
    ]
  },
  {
    "code": "A30.0",
    "name": "Indeterminierte Lepra [I-Lepra]",
    "synonyms": [
      "Indeterminierte Lepra [I-Lepra]",
      "Lepra indeterminata",
      "Uncharakteristische Lepra",
      "Uncharakteristischer Aussatz"
    ]
  },
  {
    "code": "A30.1",
    "name": "Tuberkuloide Lepra [TT-Lepra]",
    "synonyms": [
      "Lepra tuberculoides",
      "Polare gutartige Lepra",
      "Polarer gutartiger Aussatz",
      "Tuberkuloide Lepra [TT-Lepra]",
      "Tuberkuloider Aussatz"
    ]
  },
  {
    "code": "A30.2",
    "name": "Borderline-tuberkuloide Lepra [TT-Lepra]",
    "synonyms": [
      "Borderline-tuberkuloide Lepra [TT-Lepra]",
      "Borderline-tuberkuloider Aussatz"
    ]
  },
  {
    "code": "A30.3",
    "name": "Borderline-Lepra [BB-Lepra]",
    "synonyms": [
      "Borderline-Aussatz",
      "Borderline-Lepra [BB-Lepra]",
      "Lepra dimorpha",
      "Lepra mixta"
    ]
  },
  {
    "code": "A30.4",
    "name": "Borderline-lepromatöse Lepra [BL-Lepra]",
    "synonyms": [
      "Borderline-lepromatöse Lepra [BL-Lepra]",
      "Borderline-lepromatöser Aussatz"
    ]
  },
  {
    "code": "A30.5",
    "name": "Lepromatöse Lepra [LL-Lepra]",
    "synonyms": [
      "Elephantiasis graecorum",
      "Knotenaussatz",
      "Knotenlepra",
      "Lepra lazarina",
      "Lepra lepromatosa",
      "Lepromatöse Lepra [LL-Lepra]",
      "Lepromatöser Aussatz",
      "Noduläre Lepra",
      "Polare bösartige Lepra",
      "Polarer bösartiger Aussatz"
    ]
  },
  {
    "code": "A30.8",
    "name": "Lepra interpolaris",
    "synonyms": [
      "Lepra interpolaris"
    ]
  },
  {
    "code": "A30.9",
    "name": "Lepra",
    "synonyms": [
      "Anästhetische Form der Lepra",
      "Aussatz - s.a. Lepra",
      "Bakterienarme Lepra",
      "Bakterienarmer Aussatz",
      "Hansen-Krankheit",
      "Hansen-Mykobakteriose",
      "Hautaussatz",
      "Hautlepra",
      "Infektion durch Mycobacterium leprae - s.a. Lepra",
      "Larynxlepra",
      "Leberaussatz",
      "Leberlepra",
      "Lepra",
      "Lepra nervosa",
      "Leprom",
      "Lungenaussatz",
      "Lungenlepra",
      "Makuloanästhetische Lepra",
      "Makuläre Lepra",
      "Morbus phoenicius",
      "Nervenaussatz",
      "Nervenlepra",
      "Neurale Lepra",
      "Pharynxaussatz",
      "Pharynxlepra",
      "Rachenaussatz",
      "Rachenlepra"
    ]
  },
  {
    "code": "A31.0",
    "name": "Mykobakterielle Lungenkrankheit",
    "synonyms": [
      "Battey-Krankheit",
      "Infektion durch Mycobacterium Battey",
      "Lungeninfektion durch Mycobacterium avium",
      "Lungeninfektion durch Mycobacterium intracellulare",
      "Lungeninfektion durch Mycobacterium kansasii",
      "Lungeninfektion durch atypische Mykobakterien",
      "Mykobakterielle Lungenkrankheit",
      "Pulmonale nicht-tuberkulöse mykobakterielle Infektion"
    ]
  },
  {
    "code": "A31.1",
    "name": "Buruli-Ulkus",
    "synonyms": [
      "Buruli-Ulkus",
      "Hautinfektion durch Mycobacterium marinum",
      "Hautinfektion durch Mycobacterium ulcerans",
      "Hautinfektion durch atypische Mykobakterien",
      "Infektion durch Mycobacterium ulcerans",
      "Schwimmbadgranulom"
    ]
  },
  {
    "code": "A31.80",
    "name": "Extrapulmonale systemische Mykobakteriose",
    "synonyms": [
      "Disseminierte atypische Mykobakteriose",
      "Extrapulmonale systemische Mykobakteriose"
    ]
  },
  {
    "code": "A31.88",
    "name": "Infektion durch Mycobacterium chelonei",
    "synonyms": [
      "Infektion durch Mycobacterium chelonei",
      "Infektion durch Mycobacterium fortuitum",
      "Infektion durch Mycobacterium scrofulaceum",
      "Infektion durch Mycobacterium simiae",
      "Infektion durch Mycobacterium szulgai",
      "Infektion durch Mycobacterium terrae",
      "Infektion durch Mycobacterium triviale",
      "Infektion durch Mycobacterium xenopi"
    ]
  },
  {
    "code": "A31.9",
    "name": "Mykobakteriose",
    "synonyms": [
      "Atypische mykobakterielle Infektion",
      "Infektion durch Mykobakterien",
      "Mykobakterielle Krankheit",
      "Mykobakteriose"
    ]
  },
  {
    "code": "A32.0",
    "name": "Kutane Listeriose",
    "synonyms": [
      "Hautlisteriose",
      "Kutane Listeriose"
    ]
  },
  {
    "code": "A32.7",
    "name": "Sepsis durch Listerien",
    "synonyms": [
      "Listeriensepsis",
      "Sepsis durch Listerien"
    ]
  },
  {
    "code": "A32.8",
    "name": "Okuloglanduläre Listeriose",
    "synonyms": [
      "Miliare Granulomatose",
      "Okuloglanduläre Listeriose"
    ]
  },
  {
    "code": "A32.9",
    "name": "Listeriose",
    "synonyms": [
      "Infektion durch Listeria monocytogenes",
      "Listeriose",
      "Nahrungsmittelbedingte Infektion durch Listerien - s.a. Listeriose",
      "Nahrungsmittelbedingte Listeriose"
    ]
  },
  {
    "code": "A33",
    "name": "Tetanus neonatorum",
    "synonyms": [
      "Eclampsia neonatorum",
      "Kongenitale Infektion durch Clostridium tetani",
      "Tetanus bei Omphalitis",
      "Tetanus neonatorum",
      "Trismus beim Neugeborenen",
      "Trismus neonatorum"
    ]
  },
  {
    "code": "A34",
    "name": "Maternitätstetanie",
    "synonyms": [
      "Maternitätstetanie",
      "Postpartaler Tetanus",
      "Schwangerschaftstetanie",
      "Tetanus bei Abort",
      "Tetanus bei Entbindung",
      "Tetanus bei Extrauteringravidität",
      "Tetanus bei Extrauterinschwangerschaft",
      "Tetanus bei Schwangerschaft",
      "Tetanus bei der Geburt",
      "Tetanus im Wochenbett"
    ]
  },
  {
    "code": "A35",
    "name": "Tetanus",
    "synonyms": [
      "Kopftetanus",
      "Starrkrampf",
      "Tetanus",
      "Tetanus mit Konvulsionen",
      "Tetanus-Infektion",
      "Wundstarrkrampf"
    ]
  },
  {
    "code": "A36.0",
    "name": "Pharynxdiphtherie",
    "synonyms": [
      "Angina diphtherica",
      "Angina pseudomembranacea diphtherica",
      "Diphtherische Angina",
      "Diphtherische Halsentzündung",
      "Diphtherische Pharyngitis",
      "Diphtherische Rachenentzündung",
      "Diphtherische Tonsillitis",
      "Diphtherische membranöse Angina",
      "Diphtherisches Rachenulkus",
      "Diphtherisches Tonsillenulkus",
      "Pharynxdiphtherie",
      "Postdiphtherische Uvulaparalyse",
      "Rachenbräune",
      "Rachendiphtherie",
      "Tonsillendiphtherie",
      "Tonsillitis diphtherica"
    ]
  },
  {
    "code": "A36.1",
    "name": "Nasenrachendiphtherie",
    "synonyms": [
      "Nasenrachendiphtherie"
    ]
  },
  {
    "code": "A36.2",
    "name": "Diphtherischer Laryngismus",
    "synonyms": [
      "Diphtherie-Laryngitis",
      "Diphtherische Kehlkopfentzündung",
      "Diphtherische Laryngitis",
      "Diphtherische Laryngotracheitis",
      "Diphtherische Larynxentzündung",
      "Diphtherischer Krupp [Croup]",
      "Diphtherischer Laryngismus",
      "Diphtherischer kruppöser Stridor",
      "Diphtherisches Kehlkopfulkus",
      "Diphtherisches Larynxulkus",
      "Kehlkopfdiphtherie",
      "Larynxdiphtherie",
      "Larynxparalyse durch Diphtherie"
    ]
  },
  {
    "code": "A36.3",
    "name": "Nabeldiphtherie",
    "synonyms": [
      "Diphtherische Dermatitis",
      "Diphtherische Wundinfektion",
      "Hautdiphtherie",
      "Nabeldiphtherie",
      "Wunddiphtherie"
    ]
  },
  {
    "code": "A36.8",
    "name": "Nasendiphtherie",
    "synonyms": [
      "Diphtherische Anämie",
      "Diphtherische Stomatitis",
      "Diphtherische Tracheitis",
      "Lymphadenitis bei Diphtherie",
      "Nasendiphtherie",
      "Rhinodiphtherie",
      "Tracheadiphtherie"
    ]
  },
  {
    "code": "A36.9",
    "name": "Diphtherie",
    "synonyms": [
      "Diphtherie",
      "Gangränöse Diphtherie",
      "Halsbräune - s.a. Diphtherie",
      "Hämorrhagische Diphtherie"
    ]
  },
  {
    "code": "A37.0",
    "name": "Keuchhusten durch Bordetella pertussis",
    "synonyms": [
      "Infektion durch Bordetella pertussis",
      "Keuchhusten durch Bordetella pertussis",
      "Pertussis durch Bordetella pertussis"
    ]
  },
  {
    "code": "A37.1",
    "name": "Keuchhusten durch Parapertussis-Erreger",
    "synonyms": [
      "Infektion durch Bordetella parapertussis",
      "Keuchhusten durch Bordetella parapertussis",
      "Keuchhusten durch Parapertussis-Erreger",
      "Parapertussis",
      "Pertussis durch Bordetella parapertussis"
    ]
  },
  {
    "code": "A37.8",
    "name": "Tracheobronchitis durch Bordetella bronchiseptica",
    "synonyms": [
      "Keuchhusten durch Bordetella bronchoseptica",
      "Tracheobronchitis durch Bordetella bronchiseptica"
    ]
  },
  {
    "code": "A37.9",
    "name": "Keuchhusten",
    "synonyms": [
      "Infektion durch Bordetella",
      "Keuchhusten",
      "Pertussis",
      "Stickhusten",
      "Tussis convulsiva"
    ]
  },
  {
    "code": "A38",
    "name": "Scharlach",
    "synonyms": [
      "Febris rubra",
      "Scarlatina",
      "Scharlach",
      "Scharlach-Albuminurie",
      "Scharlach-Angina",
      "Scharlach-Exanthem",
      "Scharlach-Fieber",
      "Scharlachkomplikation",
      "Staphylokokken-induzierter Scharlach"
    ]
  },
  {
    "code": "A39.2",
    "name": "Akute Sepsis durch Meningokokken",
    "synonyms": [
      "Akute Bakteriämie durch Meningokokken",
      "Akute Sepsis durch Meningokokken",
      "Fulminante Sepsis durch Meningokokken",
      "Perakute Sepsis durch Meningokokken"
    ]
  },
  {
    "code": "A39.3",
    "name": "Chronische Sepsis durch Meningokokken",
    "synonyms": [
      "Chronische Bakteriämie durch Meningokokken",
      "Chronische Sepsis durch Meningokokken"
    ]
  },
  {
    "code": "A39.4",
    "name": "Sepsis durch Meningokokken",
    "synonyms": [
      "Bakteriämie durch Meningokokken",
      "Generalisierte Infektion durch Meningokokken",
      "Sepsis durch Meningokokken"
    ]
  },
  {
    "code": "A39.9",
    "name": "Infektion durch Meningokokken",
    "synonyms": [
      "Infektion durch Meningokokken",
      "Krankheit durch Meningokokken",
      "Meningokokken-Infektion"
    ]
  },
  {
    "code": "A40.0",
    "name": "Sepsis durch Streptokokken Gruppe A",
    "synonyms": [
      "Sepsis durch Streptococcus pyogenes",
      "Sepsis durch Streptokokken Gruppe A"
    ]
  },
  {
    "code": "A40.1",
    "name": "Sepsis durch Streptokokken Gruppe B",
    "synonyms": [
      "Sepsis durch Streptococcus agalacticae",
      "Sepsis durch Streptokokken Gruppe B"
    ]
  },
  {
    "code": "A40.2",
    "name": "Sepsis durch Streptokokken Gruppe D",
    "synonyms": [
      "Enterokokkensepsis",
      "Sepsis durch Enterokokken",
      "Sepsis durch Streptokokken Gruppe D"
    ]
  },
  {
    "code": "A40.3",
    "name": "Sepsis durch Pneumokokken",
    "synonyms": [
      "Generalisierte Infektion durch Pneumokokken",
      "Pyämische Embolie durch Pneumokokken",
      "Sepsis durch Pneumokokken",
      "Sepsis durch Streptococcus pneumoniae"
    ]
  },
  {
    "code": "A40.9",
    "name": "Sepsis durch Streptokokken",
    "synonyms": [
      "Pyämische Embolie durch Streptokokken",
      "Sepsis durch Streptokokken"
    ]
  },
  {
    "code": "A41.0",
    "name": "Sepsis durch Staphylococcus aureus",
    "synonyms": [
      "Sepsis durch Staphylococcus aureus"
    ]
  },
  {
    "code": "A41.1",
    "name": "Sepsis durch koagulasenegative Staphylokokken",
    "synonyms": [
      "Sepsis durch koagulasenegative Staphylokokken"
    ]
  },
  {
    "code": "A41.2",
    "name": "Sepsis durch Staphylokokken",
    "synonyms": [
      "Generalisierte Infektion durch Staphylokokken",
      "Pyämische Embolie durch Staphylokokken",
      "Sepsis durch Staphylokokken",
      "Staphylokokkensepsis"
    ]
  },
  {
    "code": "A41.3",
    "name": "Sepsis durch Haemophilus influenzae",
    "synonyms": [
      "Sepsis durch Haemophilus influenzae"
    ]
  },
  {
    "code": "A41.4",
    "name": "Sepsis durch Anaerobier",
    "synonyms": [
      "Sepsis durch Anaerobier",
      "Sepsis durch Clostridium difficile",
      "Sepsis durch Clostridium perfringens"
    ]
  },
  {
    "code": "A41.51",
    "name": "Generalisierte Kolibazillose a.n.k.",
    "synonyms": [
      "Generalisierte Infektion durch Escherichia coli",
      "Generalisierte Kolibazillose a.n.k.",
      "Sepsis durch Escherichia coli",
      "Sepsis durch Kolibazillen"
    ]
  },
  {
    "code": "A41.52",
    "name": "Sepsis durch Pseudomonas",
    "synonyms": [
      "Sepsis durch Pseudomonas"
    ]
  },
  {
    "code": "A41.58",
    "name": "Gramnegative Sepsis",
    "synonyms": [
      "Friedländer-Sepsis",
      "Gramnegative Sepsis",
      "Sepsis durch Enterobacter",
      "Sepsis durch gramnegative Erreger"
    ]
  },
  {
    "code": "A41.8",
    "name": "Sepsis durch grampositive Kokken",
    "synonyms": [
      "Sepsis durch grampositive Kokken"
    ]
  },
  {
    "code": "A41.9",
    "name": "Pyämie",
    "synonyms": [
      "Allgemeininfektion - s.a. Sepsis",
      "Bakterielle Sepsis",
      "Bakterielle Toxämie",
      "Biliäre Sepsis",
      "Blutvergiftung",
      "Eitervergiftung",
      "Gangränöse Sepsis",
      "Generalisierte Infektion a.n.k.",
      "Generalisierte Sepsis",
      "Kryptogenetische Sepsis",
      "Pyoseptikämie - s.a. Sepsis",
      "Pyämie",
      "Pyämische Embolie",
      "Schwere Sepsis",
      "Schwere bakterielle Sepsis",
      "Sepsis",
      "Sepsis bei unbekanntem Primärherd",
      "Sepsis mit Multiorganversagen",
      "Septikopyämie",
      "Septikämie - s.a. Sepsis",
      "Septisch-toxisches Multiorganversagen",
      "Septische Intoxikation",
      "Septische Toxikose",
      "Septisches Fieber",
      "Septisches Multiorganversagen",
      "Suppurative Sepsis",
      "Toxikämie [Sepsis]",
      "Toxämie [Sepsis]",
      "Urosepsis"
    ]
  },
  {
    "code": "A42.0",
    "name": "Lungenaktinomykose",
    "synonyms": [
      "Aktinomykose der Lunge",
      "Lungenaktinomykose"
    ]
  },
  {
    "code": "A42.1",
    "name": "Darmaktinomykose",
    "synonyms": [
      "Abdominale Aktinomykose",
      "Darmaktinomykose",
      "Gastrointestinale Aktinomykose"
    ]
  },
  {
    "code": "A42.2",
    "name": "Zervikofaziale Aktinomykose",
    "synonyms": [
      "Zervikofaziale Aktinomykose"
    ]
  },
  {
    "code": "A42.7",
    "name": "Aktinomykotische Sepsis",
    "synonyms": [
      "Aktinomykotische Sepsis",
      "Sepsis bei Aktinomykose"
    ]
  },
  {
    "code": "A42.8",
    "name": "Hautaktinomykose",
    "synonyms": [
      "Hautaktinomykose"
    ]
  },
  {
    "code": "A42.9",
    "name": "Streptotrichose",
    "synonyms": [
      "Aktinomykose",
      "Aktinomykotische Infektion a.n.k.",
      "Aktinomykotische Krankheit",
      "Aktinomykotischer Knoten",
      "Aktinomykotischer Nodulus",
      "Diskomykose",
      "Infektion durch Actinomyces israelii",
      "Leptothrikose",
      "Strahlenpilzkrankheit",
      "Streptotrichose"
    ]
  },
  {
    "code": "A43.0",
    "name": "Pulmonale Nokardiose",
    "synonyms": [
      "Pulmonale Nokardiose"
    ]
  },
  {
    "code": "A43.1",
    "name": "Hautnokardiose",
    "synonyms": [
      "Hautnokardiose",
      "Kutane Nokardiose",
      "Nokardiose der Haut"
    ]
  },
  {
    "code": "A43.9",
    "name": "Nokardiose",
    "synonyms": [
      "Chladotrichose",
      "Nocardia-Infektion",
      "Nokardiose"
    ]
  },
  {
    "code": "A44.0",
    "name": "Systemische Bartonellose",
    "synonyms": [
      "Carrión-Krankheit",
      "Fieber durch Bartonella",
      "Oroya-Fieber",
      "Systemische Bartonellose"
    ]
  },
  {
    "code": "A44.1",
    "name": "Peru-Warze",
    "synonyms": [
      "Bartonellose der Haut",
      "Kutane Bartonellose",
      "Mukokutane Bartonellose",
      "Peru-Warze",
      "Verruca peruviana",
      "Verruga peruana",
      "Verruga peruviana"
    ]
  },
  {
    "code": "A44.8",
    "name": "Bazilläre Angiomatose",
    "synonyms": [
      "Bazilläre Angiomatose"
    ]
  },
  {
    "code": "A44.9",
    "name": "Bartonellose",
    "synonyms": [
      "Bartonellose"
    ]
  },
  {
    "code": "A46",
    "name": "Gesichtserysipel",
    "synonyms": [
      "Beinerysipel",
      "Eitriges Erysipel",
      "Erysipel",
      "Erysipel beim Neugeborenen",
      "Erysipelas",
      "Erysipelas gangraenosum",
      "Erysipelas phlegmonosum",
      "Erysipelatöse Zellgewebsentzündung",
      "Erysipelatöser Abszess",
      "Erysipelatöses Fieber",
      "Gangränöses Erysipel",
      "Gesichtserysipel",
      "Gesichtsrose",
      "Gesichtswundrose",
      "Infantiles Erysipel",
      "Kopferysipel",
      "Kopfrose",
      "Kopfwundrose",
      "Larynxerysipel",
      "Larynxwundrose",
      "Ohrerysipel",
      "Ohrwundrose",
      "Peniserysipel",
      "Peniswundrose",
      "Phlegmonöses Erysipel",
      "Rose",
      "Streptodermia cutanea lymphatica",
      "Toxikose bei Erysipel",
      "Unterschenkelerysipel",
      "Wundrose - s.a. Erysipel"
    ]
  },
  {
    "code": "A48.0",
    "name": "Gasödem",
    "synonyms": [
      "Anaerobe Phlegmone",
      "Bakteriämie durch Gasbrandbazillen",
      "Bösartiges Ödem",
      "Gangraena emphysematosa",
      "Gangrän durch Bacillus aerogenes capsulatus",
      "Gangrän durch Bacillus welchii",
      "Gangrän durch Clostridium perfringens",
      "Gasbazillus-Infektion",
      "Gasbrand",
      "Gasbrand-Enteritis",
      "Gasbrand-Myositis",
      "Gasbrand-Sepsis",
      "Gasgangrän",
      "Gasphlegmone",
      "Gasödem",
      "Infektion durch Clostridien a.n.k.",
      "Infektion durch Clostridium bifermentans",
      "Infektion durch Clostridium histolyticum",
      "Infektion durch Clostridium novyi als Gasbranderreger",
      "Infektion durch Clostridium oedematiens",
      "Infektion durch Clostridium septicum als Gasbranderreger",
      "Infektion durch Clostridium sordellii als Gasbranderreger",
      "Infektion durch Gasbranderreger a.n.k.",
      "Infektion durch Welch-Fraenkel-Bacillus a.n.k.",
      "Muskelnekrose durch Clostridien",
      "Myonekrose durch Clostridien",
      "Myositis durch Clostridien",
      "Phlegmone durch Clostridien",
      "Uterusgasbrand",
      "Zellgewebsentzündung durch Anaerobier",
      "Zellgewebsentzündung durch Clostridien"
    ]
  },
  {
    "code": "A48.1",
    "name": "Legionärskrankheit",
    "synonyms": [
      "Infektion durch Legionella pneumophila",
      "Legionellose",
      "Legionellose mit Pneumonie",
      "Legionärskrankheit",
      "Legionärspneumonie"
    ]
  },
  {
    "code": "A48.2",
    "name": "Pontiac-Fieber",
    "synonyms": [
      "Infektion durch Legionella pneumophila ohne Pneumonie",
      "Legionellose ohne Pneumonie",
      "Pontiac-Fieber"
    ]
  },
  {
    "code": "A48.3",
    "name": "Syndrom des toxischen Schocks",
    "synonyms": [
      "Syndrom des bakteriellen toxischen Schocks",
      "Syndrom des toxischen Schocks",
      "Syndrom des toxischen Schocks bei Tamponbenutzung",
      "TSS [Toxisches Schocksyndrom]"
    ]
  },
  {
    "code": "A48.4",
    "name": "Brazilian purpuric fever",
    "synonyms": [
      "Brasilianisches Purpurfieber",
      "Brazilian purpuric fever",
      "Systemische Infektion durch Haemophilus aegyptius"
    ]
  },
  {
    "code": "A48.8",
    "name": "Dermatophilosis",
    "synonyms": [
      "Dermatophilosis",
      "Gardnerella-Infektion",
      "Lepothrix",
      "Nekrobazillose",
      "Rhinosklerom",
      "Sklerom",
      "Skleroma respiratorum",
      "Trichomycosis axillaris",
      "Trichomycosis palmellina"
    ]
  },
  {
    "code": "A49.0",
    "name": "Infektion durch Staphylokokken a.n.k.",
    "synonyms": [
      "Bakteriämie durch Staphylokokken",
      "Infektion durch Staphylokokken a.n.k."
    ]
  },
  {
    "code": "A49.1",
    "name": "Infektion durch Streptokokken a.n.k.",
    "synonyms": [
      "Bakteriämie durch Pneumokokken",
      "Bakteriämie durch Streptokokken",
      "Infektion durch Enterokokken a.n.k.",
      "Infektion durch Pneumokokken a.n.k.",
      "Infektion durch Streptokokken a.n.k.",
      "Pneumokokken-Infektion"
    ]
  },
  {
    "code": "A49.2",
    "name": "Haemophilus-influenzae-Infektion",
    "synonyms": [
      "Haemophilus-influenzae-Infektion",
      "Haemophilus-influenzae-Typ-B-Infektion",
      "Infektion durch Haemophilus influenzae Typ B"
    ]
  },
  {
    "code": "A49.3",
    "name": "Infektion durch Mykoplasma a.n.k.",
    "synonyms": [
      "Eaton-agent-Infektion",
      "Infektion durch Mykoplasma a.n.k.",
      "Infektion durch Pleuropneumonia-like-organism [PPLO]"
    ]
  },
  {
    "code": "A49.8",
    "name": "Pseudomonas-Infektion",
    "synonyms": [
      "Campylobacter-Infektion",
      "Escherichia-coli-Infektion",
      "Infektion durch Acinetobacter",
      "Infektion durch Bacteroides a.n.k.",
      "Infektion durch Essigbakterien",
      "Infektion durch Friedländer-Bakterien",
      "Infektion durch Helicobacter",
      "Infektion durch Helicobacter pylori",
      "Infektion durch Klebsiella friedlaenderi",
      "Infektion durch Klebsiella pneumoniae a.n.k.",
      "Infektion durch Klebsiella rhinoscleromatis",
      "Infektion durch Proteus",
      "Infektion durch Proteus mirabilis",
      "Infektion durch Proteus morganii",
      "Infektion durch Proteus vulgaris",
      "Infektion durch Pseudomonas aeruginosa",
      "Infektion durch gemischte bakterielle Flora a.n.k.",
      "Kolibazillose",
      "Mimea-polymorpha-Infektion",
      "Pseudomonas-Infektion"
    ]
  },
  {
    "code": "A49.9",
    "name": "Infektion durch Anaerobier",
    "synonyms": [
      "Anoxybionten-Infektion",
      "Bakterielle Infektion",
      "Bakterielle Kontaktinfektion",
      "Bakterielle Krankheit a.n.k.",
      "Bakterieller Kontaktinfekt",
      "Bakteriämie",
      "Bakteriämie durch Anaerobier",
      "Bakteriämie durch gramnegative Bakterien",
      "Bakteriämie durch grampositive Bakterien",
      "Infektion durch Anaerobier",
      "Infektion durch Bacillus a.n.k.",
      "Infektion durch gramnegative Bazillen",
      "Spezielle bakterielle Infektion",
      "Spezieller bakterieller Infekt"
    ]
  },
  {
    "code": "A50.0",
    "name": "Floride konnatale Frühsyphilis",
    "synonyms": [
      "Condyloma latum bei konnataler Syphilis",
      "Floride konnatale Frühlues",
      "Floride konnatale Frühsyphilis",
      "Konnatale Syphilis mit Frühstadiumsymptomen",
      "Konnatale frühsyphilitische Rhinitis",
      "Konnatale mukokutane Frühsyphilis",
      "Konnatale syphilitische Schleimhautpapeln",
      "Konnatale syphilitische Synovitis",
      "Konnatale syphilitische muköse Plaques",
      "Konnatale viszerale Frühsyphilis",
      "Konnataler syphilitischer Bubo",
      "Konnatales Syphilid",
      "Konnatales syphilitisches breites Kondylom",
      "Konnatales tuberöses Syphilid",
      "Rupia connata",
      "Synovitis bei konnataler Syphilis",
      "Syphilid beim Neugeborenen"
    ]
  },
  {
    "code": "A50.1",
    "name": "Latente konnatale Frühsyphilis",
    "synonyms": [
      "Konnatale latente Frühsyphilis mit negativem Liquortest",
      "Konnatale latente Lues im Frühstadium",
      "Konnatale latente Syphilis im Frühstadium",
      "Konnatale latente serologisch positive Frühsyphilis",
      "Latente konnatale Frühlues",
      "Latente konnatale Frühsyphilis"
    ]
  },
  {
    "code": "A50.2",
    "name": "Konnatale Syphilis im Frühstadium",
    "synonyms": [
      "Konnatale Frühlues",
      "Konnatale Frühsyphilis",
      "Konnatale Lues im Frühstadium",
      "Konnatale Syphilis im Frühstadium",
      "Syphilis bei Kindern unter 2 Jahren a.n.k."
    ]
  },
  {
    "code": "A50.4",
    "name": "Konnatale spätauftretende Neurosyphilis",
    "synonyms": [
      "Juvenile Neurosyphilis",
      "Juvenile Syphilis des Zentralnervensystems",
      "Juvenile Tabes dorsalis",
      "Juvenile Taboparalyse",
      "Juvenile generalisierte Paralyse",
      "Juvenile progressive Paralyse",
      "Juvenile progressive Parese",
      "Juvenile syphilitische Parese",
      "Juvenile taboparalytische Neurosyphilis",
      "Kongenitale Tabes",
      "Konnatale Neurosyphilis",
      "Konnatale Syphilis des Zentralnervensystems",
      "Konnatale Syphilis mit Tabes dorsalis",
      "Konnatale Syphilis mit Taboparalyse",
      "Konnatale spätauftretende Neurolues",
      "Konnatale spätauftretende Neurosyphilis",
      "Konnatale syphilitische Paralyse",
      "Konnatale syphilitische Parese",
      "Neurosyphilis juvenilis",
      "Syphilis des Zentralnervensystems mit juveniler Taboparalyse",
      "Syphilis des Zentralnervensystems mit progressiver juveniler Paralyse",
      "Tabes infantum"
    ]
  },
  {
    "code": "A50.5",
    "name": "Lues mit Kraniotabes",
    "synonyms": [
      "Gumma durch Syphilis connata",
      "Hutchinson-Syndrom",
      "Hutchinson-Trias",
      "Hutchinson-Zähne durch Syphilis connata",
      "Konnatale Lues mit Gumma",
      "Konnatale Lues mit Hutchinson-Zähnen",
      "Konnatale Lues mit Sattelnase",
      "Konnatale floride Syphilis im Spätstadium",
      "Konnatale syphilitische Nasendeformität",
      "Konnatale syphilitische Stigmata",
      "Konnatales Gumma",
      "Konnatales Syphilom",
      "Kraniotabes bei Syphilis",
      "Lues mit Kraniotabes",
      "Sattelnase durch Syphilis connata",
      "Syphilitische Kraniotabes",
      "Syphilitische Sattelnase"
    ]
  },
  {
    "code": "A50.6",
    "name": "Latente konnatale Spätsyphilis",
    "synonyms": [
      "Konnatale latente Spätsyphilis mit negativem Liquortest",
      "Konnatale latente serologisch positive Spätsyphilis",
      "Latente konnatale Lues im Spätstadium",
      "Latente konnatale Spätsyphilis",
      "Latente konnatale Syphilis im Spätstadium"
    ]
  },
  {
    "code": "A50.7",
    "name": "Konnatale Lues im Spätstadium",
    "synonyms": [
      "Konnatale Lues im Spätstadium",
      "Konnatale Spätsyphilis",
      "Konnatale Syphilis im Spätstadium",
      "Syphilis connata tarda"
    ]
  },
  {
    "code": "A50.9",
    "name": "Lues connata",
    "synonyms": [
      "Hereditäre Syphilis",
      "Heredosyphilis",
      "Kongenitale Syphilis",
      "Konnatale Lues",
      "Konnatale Syphilis",
      "Lues connata",
      "Syphilis beim Neugeborenen a.n.k.",
      "Syphilis beim Säugling a.n.k.",
      "Syphilis connata"
    ]
  },
  {
    "code": "A51.0",
    "name": "Lues der Geschlechtsorgane",
    "synonyms": [
      "Frühsyphilitische Vaginitis",
      "Frühsyphilitische Vulvitis",
      "Gemischter Schanker",
      "Genitale Lues",
      "Genitale Syphilis",
      "Harter Schanker",
      "Hunter-Schanker",
      "Lues I",
      "Lues der Geschlechtsorgane",
      "Lues im Primärstadium",
      "Lues mit primärem Genitalaffekt",
      "Multipler syphilitischer Schanker",
      "Penissyphilis",
      "Primäraffekt bei Syphilis",
      "Primäre Frühsyphilis",
      "Primäre Syphilis",
      "Primäre Syphilis der Geschlechtsorgane",
      "Primärer Schanker",
      "Primärer syphilitischer Bubo",
      "Rezidivierender Schanker",
      "Schanker",
      "Seronegativer Schanker",
      "Seropositiver Schanker",
      "Syphilis I",
      "Syphilis der Geschlechtsorgane",
      "Syphilis im Primärstadium",
      "Syphilis mit primärem Genitalaffekt",
      "Syphilitische Vaginitis",
      "Syphilitische Vulvitis",
      "Syphilitischer Bubo",
      "Syphilitischer Schanker",
      "Ulcus durum",
      "Urethraschanker",
      "Vaginalsyphilis",
      "Vulvalues",
      "Vulvasyphilis"
    ]
  },
  {
    "code": "A51.1",
    "name": "Analer Primäraffekt bei Syphilis",
    "synonyms": [
      "Analer Primäraffekt bei Lues",
      "Analer Primäraffekt bei Syphilis",
      "Anuslues im Primärstadium",
      "Anussyphilis im Primärstadium"
    ]
  },
  {
    "code": "A51.2",
    "name": "Fingerlues im Primärstadium",
    "synonyms": [
      "Brustwarzenschanker",
      "Extragenitaler Schanker",
      "Extragenitales Ulcus durum",
      "Fingerlues im Primärstadium",
      "Fingersyphilis im Primärstadium",
      "Lippenlues im Primärstadium",
      "Lippenschanker",
      "Lippensyphilis im Primärstadium",
      "Tonsillenlues im Primärstadium",
      "Tonsillensyphilis im Primärstadium",
      "Weicher Schanker des Gaumens"
    ]
  },
  {
    "code": "A51.3",
    "name": "Hautlues",
    "synonyms": [
      "Breites Kondylom",
      "Condyloma latum",
      "Condylomata lata",
      "Frühsyphilitisches Ulkus",
      "Hautlues",
      "Hautsyphilis",
      "Hautsyphilis mit Geschwürbildung",
      "Lippensyphilis",
      "Lues mit Rupia",
      "Mundhöhlenlues",
      "Mundhöhlensyphilis",
      "Riesenkondylom",
      "Sekundäre Hautlues",
      "Sekundäre Hautsyphilis",
      "Sekundäre Lues der Tonsillen",
      "Sekundäre Lues des Anus",
      "Sekundäre Lues des Rachens",
      "Sekundäre Mundlues",
      "Sekundäre Mundsyphilis",
      "Sekundäre Pharynxsyphilis",
      "Sekundäre Schleimhautlues",
      "Sekundäre Schleimhautsyphilis",
      "Sekundäre Syphilis der Tonsillen",
      "Sekundäre Syphilis des Anus",
      "Sekundäre Syphilis des Rachens",
      "Sekundäre mukokutane Syphilis",
      "Sekundäre symptomatische Frühsyphilis",
      "Sekundäres syphilitisches Ulkus",
      "Syphilid",
      "Syphilitische Rupia",
      "Syphilitische Schleimhautpapeln [Plaques muqueuses]",
      "Syphilitische muköse Plaques",
      "Syphilitisches Condyloma latum",
      "Syphilitisches Kondylom",
      "Venerisches Kondylom"
    ]
  },
  {
    "code": "A51.4",
    "name": "Sekundäre Syphilis",
    "synonyms": [
      "Frühsyphilitische Lymphadenitis",
      "Lues II",
      "Sekundäre Frühsyphilis eines Lymphknotens",
      "Sekundäre Lues",
      "Sekundäre Syphilis",
      "Sekundäre Syphilis der Viszera",
      "Sekundäre frühsyphilitische Lymphadenitis",
      "Sekundäre syphilitische Lymphadenitis",
      "Sekundäre syphilitische Lymphadenopathie",
      "Sekundäre viszerale Syphilis a.n.k.",
      "Syphilis II"
    ]
  },
  {
    "code": "A51.5",
    "name": "Latente Frühsyphilis",
    "synonyms": [
      "Latente Frühlues",
      "Latente Frühsyphilis",
      "Latente Frühsyphilis mit negativem Liquortest",
      "Latentes Frühstadium der Lues",
      "Latentes Frühstadium der Syphilis",
      "Serologisch positive latente Frühsyphilis",
      "Serologischer Rückfall nach Behandlung bei latenter Frühsyphilis"
    ]
  },
  {
    "code": "A51.9",
    "name": "Frühsyphilis a.n.k.",
    "synonyms": [
      "Erworbene Syphilis bei Kindern unter 2 Jahren",
      "Frühlues - s.a. Frühsyphilis",
      "Frühsyphilis a.n.k.",
      "Kürzlich erworbene symptomatische Syphilis a.n.k.",
      "Symptomatische Frühsyphilis"
    ]
  },
  {
    "code": "A52.1",
    "name": "Tabes",
    "synonyms": [
      "Ataxie bei progressiver Paralyse",
      "Bayle-Krankheit",
      "Floride Neurosyphilis",
      "Floride Syphilis des Zentralnervensystems",
      "Fortschreitende Ataxie bei Tabes",
      "Harnblasentabes",
      "Hinterstrangsklerose",
      "Latente Tabes",
      "Lissauer-Herdparalyse",
      "Lissauer-Paralyse",
      "Lissauer-Syndrom",
      "Meningovaskuläre Lues",
      "Meningovaskuläre Syphilis",
      "Neurolues paralytica",
      "Neurosyphilis mit lokomotorischer Ataxie",
      "Neurosyphilis mit progressiver Paralyse",
      "Neurosyphilis mit spastischer Ataxie",
      "Neurosyphilis mit spinaler Ataxie",
      "Neurosyphilis mit tabischer Paralyse",
      "Neurosyphilis paralytica",
      "Paralyse bei Syphilis",
      "Parenchymatöse degenerative Neurosyphilis",
      "Paretische Konvulsionen bei Syphilis",
      "Progressive Ataxie",
      "Progressive Paralyse",
      "Progressive psychische tabische Paralyse",
      "Progressive syphilitische Paralyse",
      "Progressive syphilitische Parese",
      "Rückenmarklues",
      "Rückenmarksyphilis",
      "Spastische Tabes",
      "Spätsyphilitische Paralyse",
      "Spätsyphilitische Tabes dorsalis",
      "Syphilis des Zentralnervensystems mit Ataxie",
      "Syphilis des Zentralnervensystems mit Parese",
      "Syphilis des Zentralnervensystems mit Tabes dorsalis",
      "Syphilis des Zentralnervensystems mit Taboparalyse",
      "Syphilis des Zentralnervensystems mit progressiver Paralyse",
      "Syphilitische Bulbärparalyse",
      "Syphilitische Duchenne-Ataxie",
      "Syphilitische Hemianästhesie",
      "Syphilitische Hemiparese",
      "Syphilitische Hemiplegie",
      "Syphilitische Lissauer-Paralyse",
      "Syphilitische Monoplegie",
      "Syphilitische Parästhesie",
      "Syphilitische Rückenmarkblase",
      "Syphilitische Rückenmarkdegeneration",
      "Syphilitische Rückenmarkparalyse",
      "Syphilitische Taboparalyse",
      "Syphilitische Zerebralparalyse",
      "Syphilitische lokomotorische Ataxie",
      "Syphilitische reflektorische Pupillenstarre [Argyll-Robertson-Phänomen]",
      "Syphilitische spastische Ataxie",
      "Syphilitische spastische Paraplegie",
      "Syphilitische spastische spinale Paralyse",
      "Tabes",
      "Tabes cerebrospinalis",
      "Tabes dorsalis",
      "Tabes mit Rückenmarkblase",
      "Tabes mit Syphilis des Zentralnervensystems",
      "Tabes mit progressiver Paralyse",
      "Tabes mit viszeraler Krise",
      "Tabische Ataxie",
      "Tabische Form der Dementia paralytica",
      "Tabische Harnblasensphinkterparese",
      "Tabische Krise",
      "Tabische Neurolues",
      "Tabische Organkrise",
      "Tabische Paralyse",
      "Tabische Rückenmarkblase",
      "Tabische zerebrospinale Syphilis",
      "Taboparalyse",
      "Taboparalyse mit Rückenmarkblase",
      "Zerebrospinale Lues",
      "Zerebrospinale Syphilis"
    ]
  },
  {
    "code": "A52.2",
    "name": "Asymptomatische Neurosyphilis",
    "synonyms": [
      "Asymptomatische Neurosyphilis",
      "Latente Syphilis des Zentralnervensystems",
      "Serologische Neurosyphilis ohne Symptome"
    ]
  },
  {
    "code": "A52.3",
    "name": "Neurolues",
    "synonyms": [
      "Gehirngumma",
      "Gehirnlues",
      "Gehirnsyphilis",
      "Inaktive Neurosyphilis",
      "Latente Neurosyphilis",
      "Neurolues",
      "Neurosyphilis",
      "Rekurrente Neurosyphilis",
      "Rezidivierende Neurosyphilis",
      "Späte Neurosyphilis",
      "Spätsyphilis des Zentralnervensystems",
      "Syphilis des ZNS",
      "Syphilis des Zentralnervensystems",
      "Syphilom des Zentralnervensystems",
      "Tertiäre Syphilis des Zentralnervensystems"
    ]
  },
  {
    "code": "A52.7",
    "name": "Gumma",
    "synonyms": [
      "Abdominale Spätsyphilis",
      "Gumma",
      "Gumma syphiliticum",
      "Mammalues",
      "Mammasyphilis",
      "Milchdrüsenlues",
      "Milchdrüsensyphilis",
      "Mukokutane Spätsyphilis",
      "Spätlues mit Frühstadiumsymptomen",
      "Spätsyphilis der Bauchhöhle",
      "Spätsyphilis der Brust",
      "Spätsyphilis der Eingeweide",
      "Spätsyphilis der Schleimhaut",
      "Spätsyphilis mit Frühstadiumsymptomen",
      "Spätsyphilitische Leontiasis",
      "Spätsyphilitische Leukoplakie",
      "Syphilitische Striktur a.n.k.",
      "Syphilitischer Aszites",
      "Syphilitisches Gumma a.n.k.",
      "Syphilom",
      "Thoraxsyphilis",
      "Urogenitale Spätsyphilis"
    ]
  },
  {
    "code": "A52.8",
    "name": "Latente Spätsyphilis",
    "synonyms": [
      "Latente Spätlues",
      "Latente Spätsyphilis",
      "Latente Spätsyphilis mit negativem Liquortest",
      "Latente serologisch positive Spätsyphilis"
    ]
  },
  {
    "code": "A52.9",
    "name": "Spätlues",
    "synonyms": [
      "Metalues",
      "Metasyphilis",
      "Spätlues",
      "Spätsyphilis",
      "Syphilis im Tertiärstadium",
      "Tertiäre Lues",
      "Tertiäre Syphilis"
    ]
  },
  {
    "code": "A53.0",
    "name": "Latente Syphilis",
    "synonyms": [
      "Latente Lues",
      "Latente Syphilis",
      "Nachsorge bei latenter Syphilis",
      "Positive Serumreaktion auf Syphilis",
      "Positive Wassermann-Reaktion",
      "Positiver VDRL-Test [Venereal diseases research laboratories]",
      "Positiver Wassermann-Test",
      "Positiver serologischer Befund auf Syphilis",
      "Seropositive Syphilis als einziger Befund"
    ]
  },
  {
    "code": "A53.9",
    "name": "Lues - s.a. Syphilis",
    "synonyms": [
      "Erworbene Syphilis",
      "Franzosenkrankheit",
      "Infektion durch Treponema pallidum",
      "Lues - s.a. Syphilis",
      "Malum venereum",
      "Morbus Schaudinn",
      "Morbus Wassermann",
      "Morbus americanus",
      "Morbus aphrodisiacus",
      "Morbus gallicus",
      "Organische Syphilis",
      "Syphilis",
      "Syphilis durch Bluttransfusion",
      "Syphilitischer Schaden",
      "Treponematosis durch Treponema pallidum"
    ]
  },
  {
    "code": "A54.0",
    "name": "Gonokokken-Infektion der unteren Harn- und Geschlechtsorgane",
    "synonyms": [
      "Akute Gonorrhoe der Cervix uteri",
      "Akute Gonorrhoe der unteren Harnorgane",
      "Akute Harnblasengonorrhoe",
      "Akute Urethritis bei Gonorrhoe",
      "Blennorrhoische Zystitis",
      "Cervicitis gonorrhoica",
      "Chronische Gonorrhoe der Bartholin-Drüse",
      "Chronische Gonorrhoe der Cervix uteri",
      "Chronische Gonorrhoe der unteren Genitalorgane",
      "Chronische Gonorrhoe der unteren Harnorgane",
      "Chronische Harnblasengonorrhoe",
      "Chronische Urethritis bei Gonorrhoe",
      "Cystitis gonorrhoica",
      "Genitale Gonorrhoe",
      "Gonokokken-Infektion der unteren Harn- und Geschlechtsorgane",
      "Gonorrhoe der Cervix uteri",
      "Gonorrhoe des unteren Urogenitaltraktes",
      "Gonorrhoische Bulbitis urethrae",
      "Gonorrhoische Condylomata acuminata",
      "Gonorrhoische Harnblasenentzündung",
      "Gonorrhoische Harnröhrenstriktur",
      "Gonorrhoische Lymphangitis des Penis",
      "Gonorrhoische Urethrastriktur",
      "Gonorrhoische Urethritis",
      "Gonorrhoische Zervizitis",
      "Gonorrhoische Zystitis",
      "Gonorrhoisches Kondylom",
      "Gonorrhoisches spitzes Kondylom",
      "Gryposis penis bei Gonorrhoe",
      "Harnblasengonorrhoe",
      "Harnröhrengonorrhoe",
      "Penisgonorrhoe",
      "Postgonorrhoische Urethritis",
      "Postgonorrhoisches Urethrareizsyndrom",
      "Purulente Gonorrhoe der Bartholin-Drüse",
      "Scheidengonorrhoe",
      "Tripper der Cervix uteri",
      "Urethragonorrhoe",
      "Urethritis durch Diplokokken",
      "Urethritis durch Gonokokken",
      "Vaginalgonorrhoe",
      "Zervixgonorrhoe",
      "Zervixtripper",
      "Zervizitis durch Gonokokken",
      "Zystitis durch Gonokokken"
    ]
  },
  {
    "code": "A54.1",
    "name": "Gonorrhoische Bartholinitis",
    "synonyms": [
      "Abszess der Bartholin-Drüse durch Gonokokken",
      "Abszess der Glandulae urethrales durch Gonokokken",
      "Akute gonorrhoische Bartholinitis",
      "Akute gonorrhoische Paraurethritis",
      "Chronische gonorrhoische Bartholinitis",
      "Chronische gonorrhoische Paraurethritis",
      "Gonorrhoe der Bartholin-Drüse mit Abszess",
      "Gonorrhoe der Cowper-Drüse mit Abszess",
      "Gonorrhoische Bartholinitis",
      "Gonorrhoische Paraurethritis",
      "Gonorrhoische Paraurethritis mit Abszess",
      "Gonorrhoische Urethritis mit Abszess",
      "Gonorrhoischer Abszess a.n.k.",
      "Gonorrhoischer Penisabszess a.n.k.",
      "Gonorrhoischer periurethraler Abszess a.n.k.",
      "Periurethraler Abszess durch Gonokokken",
      "Urethritis durch Diplokokken mit Abszess"
    ]
  },
  {
    "code": "A54.2",
    "name": "Chronische Gonorrhoe der oberen Harnorgane",
    "synonyms": [
      "Akute Gonorrhoe der oberen Genitalorgane",
      "Akute Gonorrhoe der oberen Harnorgane",
      "Beckengonorrhoe",
      "Chronische Gonorrhoe der oberen Genitalorgane",
      "Chronische Gonorrhoe der oberen Harnorgane",
      "Gonokokken-Infektion des Beckens",
      "Gonorrhoische Beckenkrankheit",
      "Pelviperitonitis durch Gonokokken"
    ]
  },
  {
    "code": "A54.3",
    "name": "Gonokokken-Infektion des Auges",
    "synonyms": [
      "Augengonorrhoe",
      "Gonokokken-Infektion des Auges"
    ]
  },
  {
    "code": "A54.5",
    "name": "Pharyngitis durch Gonokokken",
    "synonyms": [
      "Pharyngitis durch Gonokokken",
      "Pharynxgonorrhoe",
      "Rachenhöhlengonorrhoe"
    ]
  },
  {
    "code": "A54.6",
    "name": "Anusgonorrhoe",
    "synonyms": [
      "Anusgonorrhoe",
      "Gonorrhoische Mastdarminfektion",
      "Gonorrhoische Proktitis",
      "Gonorrhoische Rektuminfektion",
      "Gonorrhoische Rektumstriktur",
      "Proktitis durch Gonokokken",
      "Rektumgonorrhoe"
    ]
  },
  {
    "code": "A54.8",
    "name": "Sepsis durch Gonokokken",
    "synonyms": [
      "Akute gonorrhoische Follikulitis",
      "Blennorrhagischer Bubo durch Gonokokken",
      "Bubo durch Gonokokken",
      "Bubo durch Gonorrhoe",
      "Chronische gonorrhoische Follikulitis",
      "Gonorrhoische Adenitis",
      "Gonorrhoische Follikulitis",
      "Gonorrhoische Lymphadenitis",
      "Gonorrhoische Sepsis",
      "Gonorrhoische Zellgewebsentzündung a.n.k.",
      "Hautläsion durch Gonokokken",
      "Lymphknotengonorrhoe",
      "Sepsis durch Gonokokken",
      "Zellgewebsentzündung durch Gonokokken a.n.k."
    ]
  },
  {
    "code": "A54.9",
    "name": "Gonokokken-Infektion",
    "synonyms": [
      "Akute Blennorrhoe",
      "Akute Gonokokken-Infektion",
      "Akute Gonorrhoe",
      "Akute gonorrhoische Infektion",
      "Blennorrhoe",
      "Chronische Blennorrhoe",
      "Chronische Gonokokken-Infektion",
      "Chronische Gonorrhoe",
      "Chronische gonorrhoische Infektion",
      "Gonokokken-Infektion",
      "Gonokokkämie",
      "Gonorrhoe",
      "Gonorrhoische Bakteriämie",
      "Gonorrhoische Infektion a.n.k.",
      "Morbus Neisser",
      "Tripper - s.a. Gonorrhoe"
    ]
  },
  {
    "code": "A55",
    "name": "Esthiomène",
    "synonyms": [
      "Dukes-Filatow-Krankheit",
      "Dukes-Filatow-Syndrom",
      "Durand-Nicolas-Favre-Krankheit",
      "Durand-Nicolas-Favre-Syndrom",
      "Esthiomène",
      "Klimatischer Bubo",
      "Lymphogranulom durch Chlamydien",
      "Lymphogranuloma inguinale",
      "Lymphogranuloma venereum",
      "Lymphogranuloma venereum durch Chlamydien",
      "Lymphopathia venerea",
      "Poradenitis inguinalis sive venerea",
      "Tropischer Bubo",
      "Venerische Lymphadenitis durch Chlamydien",
      "Vierte Geschlechtskrankheit"
    ]
  },
  {
    "code": "A56.0",
    "name": "Kolpitis durch Chlamydien",
    "synonyms": [
      "Atrophische Leptothrix-Kolpitis",
      "Balanochlamyditis",
      "Chlamydien-Infektion der unteren Genitalorgane",
      "Chronische Kolpitis durch Leptothrixbakterien",
      "Chronische Leptothrix-Kolpitis",
      "Kolpitis durch Chlamydien",
      "Leptothrix-Kolpitis",
      "Leptothrix-Vaginitis",
      "Urethritis durch Chlamydien",
      "Vaginitis durch Chlamydien",
      "Vulvitis durch Chlamydien",
      "Vulvovaginitis durch Chlamydien",
      "Zervikovaginitis durch Chlamydien",
      "Zervizitis durch Chlamydien",
      "Zystitis durch Chlamydien"
    ]
  },
  {
    "code": "A56.1",
    "name": "Chlamydien-Infektion des kleinen Beckens",
    "synonyms": [
      "Chlamydien-Infektion des kleinen Beckens"
    ]
  },
  {
    "code": "A56.2",
    "name": "Genitale Chlamydien-Infektion",
    "synonyms": [
      "Genitale Chlamydien-Infektion"
    ]
  },
  {
    "code": "A56.3",
    "name": "Proktitis durch Chlamydien",
    "synonyms": [
      "Anusinfektion durch Chlamydien",
      "Proktitis durch Chlamydien",
      "Rektuminfektion durch Chlamydien"
    ]
  },
  {
    "code": "A56.4",
    "name": "Chlamydien-Infektion des Pharynx",
    "synonyms": [
      "Chlamydien-Infektion des Pharynx",
      "Pharyngitis durch Chlamydien"
    ]
  },
  {
    "code": "A56.8",
    "name": "Sexuell übertragene Chlamydien-Infektion a.n.k.",
    "synonyms": [
      "Sexuell übertragene Chlamydien-Infektion a.n.k."
    ]
  },
  {
    "code": "A57",
    "name": "Schankroid",
    "synonyms": [
      "Bubo durch Haemophilus ducreyi",
      "Bubo durch weichen Schanker",
      "Ducrey-Schanker",
      "Einfacher Schanker",
      "Infektion durch Ducrey-Bazillen",
      "Infektion durch Haemophilus ducreyi",
      "Inguinaler Bubo durch Haemophilus ducreyi",
      "Kongenitale schankröse Lymphadenitis",
      "Phagedänischer Abszess bei weichem Schanker",
      "Phagedänischer Schanker",
      "Schankroid",
      "Schankröse Adenitis durch Haemophilus ducreyi",
      "Schankröse Lymphangitis",
      "Schankröse Phimose",
      "Schankröser Bubo",
      "Schankröses Ulkus",
      "Ulcus molle",
      "Ulcus venereum",
      "Virulenter schankröser Bubo",
      "Vulvitis durch Haemophilus ducreyi",
      "Weicher Schanker"
    ]
  },
  {
    "code": "A58",
    "name": "Granuloma pudendi",
    "synonyms": [
      "Donovaniasis",
      "Donovanosis",
      "Granuloma inguinale",
      "Granuloma inguinale tropicum",
      "Granuloma pudendi",
      "Granuloma venereum",
      "Scheidengranulom",
      "Ulzeröses Granuloma pudendorum",
      "Vaginalgranulom"
    ]
  },
  {
    "code": "A59.0",
    "name": "Harnwegsinfektion durch Trichomonaden",
    "synonyms": [
      "Harnwegsinfektion durch Trichomonaden",
      "Trichomoniasis urogenitalis",
      "Urogenitale Trichomonaden-Infektion"
    ]
  },
  {
    "code": "A59.9",
    "name": "Trichomoniasis",
    "synonyms": [
      "Pruritus durch Trichomonaden",
      "Trichomonaden-Infektion",
      "Trichomonas-Infektion",
      "Trichomoniasis"
    ]
  },
  {
    "code": "A60.0",
    "name": "Herpes genitalis recidivans",
    "synonyms": [
      "Genitaler Herpes",
      "Herpes genitalis",
      "Herpes genitalis recidivans",
      "Herpes progenitalis",
      "Herpes simplex genitalis",
      "Herpes simplex progenitalis",
      "Herpes urogenitalis",
      "Infektion der weiblichen Genitalorgane durch Herpesviren"
    ]
  },
  {
    "code": "A60.1",
    "name": "Herpes perianalis",
    "synonyms": [
      "Herpes der Perianalhaut",
      "Herpes perianalis",
      "Perianale Herpes-Infektion"
    ]
  },
  {
    "code": "A60.9",
    "name": "Anogenitaler Herpes",
    "synonyms": [
      "Anogenitaler Herpes"
    ]
  },
  {
    "code": "A63.0",
    "name": "Analkondylom",
    "synonyms": [
      "Analkondylom",
      "Anogenitale Warze",
      "Anogenitales Kondylom",
      "Condyloma - s.a. Kondylom",
      "Condylomata",
      "Condylomata acuminata",
      "Condylomata ani",
      "Condylomata vulvae",
      "Feigwarze",
      "Kondylom",
      "Papilloma acuminatum sive venereum",
      "Spitzes Kondylom",
      "Venerische Verruca",
      "Venerische Warze",
      "Venerische Warze der Anogenitalregion",
      "Venerische Warze der äußeren Geschlechtsorgane",
      "Verruca acuminata",
      "Vulvakondylom",
      "Weibliches Papillom"
    ]
  },
  {
    "code": "A64",
    "name": "Geschlechtskrankheit a.n.k.",
    "synonyms": [
      "Geschlechtskrankheit a.n.k.",
      "STD [Sexually transmitted disease]",
      "Sexually transmitted disease",
      "Veneria",
      "Venerische Infektion",
      "Venerische Krankheit a.n.k.",
      "Venerischer Bubo"
    ]
  },
  {
    "code": "A65",
    "name": "Nichtvenerische Syphilis",
    "synonyms": [
      "Bejel",
      "Dichuchwa",
      "Endemische Syphilis",
      "Nichtvenerische Syphilis",
      "Njovera",
      "Siti",
      "Skerljevo"
    ]
  },
  {
    "code": "A66.0",
    "name": "Primärläsion bei Frambösie",
    "synonyms": [
      "Erstschädigung bei Frambösie",
      "Frambösieschanker",
      "Initiale Frambösie",
      "Initiales Ulkus bei Frambösie",
      "Muttereffloreszenz bei Frambösie",
      "Primäraffekt bei Frambösie",
      "Primäre Frambösie",
      "Primärläsion bei Frambösie",
      "Schanker bei Frambösie"
    ]
  },
  {
    "code": "A66.1",
    "name": "Frambösiepapillom der Fußsohle",
    "synonyms": [
      "Frambösiepapillom der Fußsohle",
      "Frambösiepapillom der Handfläche",
      "Frambösiom",
      "Krabbenframbösie",
      "Multiple Papillome bei Frambösie",
      "Palmares Frambösiepapillom",
      "Pianom",
      "Plantares Frambösiepapillom",
      "Polypapillomatöse Frambösie"
    ]
  },
  {
    "code": "A66.2",
    "name": "Framböside im Frühstadium der Frambösie",
    "synonyms": [
      "Framböside im Frühstadium der Frambösie",
      "Frühe Frambösie",
      "Frühe Frambösie der Haut",
      "Frühe makulopapulöse Frambösie der Haut",
      "Frühe makuläre Frambösie der Haut",
      "Frühe mikropapulöse Frambösie der Haut",
      "Frühe papulöse Frambösie der Haut",
      "Hautframbösie bis zu 5 Jahre nach der Ansteckung"
    ]
  },
  {
    "code": "A66.3",
    "name": "Hyperkeratose bei Frambösie",
    "synonyms": [
      "Ghoul hand",
      "Hyperkeratose bei Frambösie",
      "Hyperkeratose der Fußsohle bei Frambösie",
      "Hyperkeratose der Fußsohle bei früher Frambösie",
      "Hyperkeratose der Fußsohle bei später Frambösie",
      "Hyperkeratose der Handfläche bei Frambösie",
      "Hyperkeratose der Handfläche bei früher Frambösie",
      "Hyperkeratose der Handfläche bei später Frambösie",
      "Worm-eaten soles"
    ]
  },
  {
    "code": "A66.4",
    "name": "Gummata und Ulzera bei Frambösie",
    "synonyms": [
      "Frambösie mit Gummigeschwür",
      "Geschwür bei Frambösie",
      "Gumma bei Frambösie",
      "Gummata und Ulzera bei Frambösie",
      "Gummöses Frambösid",
      "Noduläre Frambösie im Spätstadium",
      "Noduläre ulzeröse Frambösie im Spätstadium",
      "Noduläre ulzeröse Spätframbösie",
      "Spätframbösie",
      "Ulzera bei Frambösie",
      "Ulzeröse Frambösie",
      "Ulzeröses Gumma bei Frambösie"
    ]
  },
  {
    "code": "A66.6",
    "name": "Goundou bei Frambösie",
    "synonyms": [
      "Goundou bei Frambösie",
      "Gummöse Ostitis bei Frambösie",
      "Gummöse Ostitis bei später Frambösie",
      "Knochengumma bei Frambösie",
      "Knochengumma bei später Frambösie",
      "Ostitis bei früher Frambösie",
      "Ostitis bei später Frambösie"
    ]
  },
  {
    "code": "A66.7",
    "name": "Juxtaartikuläre Knoten bei Frambösie",
    "synonyms": [
      "Gelenknahe Frambösieknoten",
      "Gelenknahe Knötchen bei Frambösie",
      "Juxtaartikuläre Knoten bei Frambösie",
      "Juxtaartikulärer Nodulus bei Frambösie",
      "Schleimhautframbösie"
    ]
  },
  {
    "code": "A66.8",
    "name": "Latente Frambösie",
    "synonyms": [
      "Frambösie mit positiver serologischer Reaktion ohne klinische Manifestationen",
      "Latente Frambösie"
    ]
  },
  {
    "code": "A66.9",
    "name": "Frambösie",
    "synonyms": [
      "Bouba",
      "Brasilianische Frambösie",
      "Breda-Krankheit",
      "Framboesia - s.a. Frambösie",
      "Framboesia tropica - s.a. Frambösie",
      "Frambösie",
      "Pian",
      "Treponematosis durch Treponema pertenue",
      "Tropische Frambösie",
      "Yaws - s.a. Frambösie"
    ]
  },
  {
    "code": "A67.0",
    "name": "Primärläsion bei Pinta",
    "synonyms": [
      "Papeln bei Pinta",
      "Pinta-Schanker",
      "Primäraffekt bei Carate",
      "Primäraffekt bei Pinta",
      "Primäre Papeln bei Carate",
      "Primäre Papeln bei Pinta",
      "Primärer Schanker bei Pinta",
      "Primärläsion bei Carate",
      "Primärläsion bei Pinta",
      "Schanker bei Carate"
    ]
  },
  {
    "code": "A67.1",
    "name": "Zwischenstadium der Pinta",
    "synonyms": [
      "Erythematöse Plaques bei Carate",
      "Erythematöse Plaques bei Pinta",
      "Hyperchrome Schädigung bei Carate",
      "Hyperchrome Schädigung bei Pinta",
      "Hyperkeratose bei Carate",
      "Hyperkeratose bei Pinta",
      "Hyperpigmentierte Hautveränderung bei Pinta",
      "Hyperpigmentierte Veränderung bei Pinta",
      "Pintide",
      "Schädigung im Zwischenstadium der Pinta",
      "Sekundärläsion der Carate",
      "Sekundärläsion der Pinta",
      "Sekundärschädigung bei Pinta",
      "Zwischenstadium der Carate",
      "Zwischenstadium der Pinta"
    ]
  },
  {
    "code": "A67.2",
    "name": "Spätstadium der Pinta",
    "synonyms": [
      "Achrome Hautveränderung bei Pinta",
      "Depigmentierte Hautveränderung bei Pinta",
      "Hautschaden bei Carate",
      "Hautschaden bei Pinta",
      "Narbige Hautveränderung bei Pinta",
      "Pigmentstörung der Haut bei Pinta",
      "Spätläsion der Carate",
      "Spätläsion der Pinta",
      "Spätschädigung bei Pinta",
      "Spätstadium der Carate",
      "Spätstadium der Pinta",
      "Vitiligo bei Carate",
      "Vitiligo bei Pinta"
    ]
  },
  {
    "code": "A67.3",
    "name": "Mischform der Pinta",
    "synonyms": [
      "Gleichzeitige achrome und hyperchrome Hautveränderung bei Pinta",
      "Gleichzeitige depigmentierte und hyperpigmentierte Hautveränderung bei Pinta",
      "Mischform der Carate",
      "Mischform der Pinta"
    ]
  },
  {
    "code": "A67.9",
    "name": "Pinta",
    "synonyms": [
      "Carate - s.a. Pinta",
      "Mal de Pinto",
      "Pinta",
      "Schädigung durch Pinta"
    ]
  },
  {
    "code": "A68.0",
    "name": "Läuserückfallfieber",
    "synonyms": [
      "Durch Läuse übertragenes Rückfallfieber",
      "Europäisches Rückfallfieber",
      "Infektion durch Borrelia obermeieri",
      "Infektion durch Borrelia recurrentis",
      "Infektion durch Spirochaeta obermeieri",
      "Infektion durch Spirochaeta recurrens",
      "Läuserückfallfieber",
      "Novy-Rückfallfieber durch Läuse übertragen",
      "Obermeier-Rückfallfieber",
      "Rückfallfieber durch Borrelia recurrentis",
      "Rückfallfieber durch Spirochaeta Obermeieri"
    ]
  },
  {
    "code": "A68.1",
    "name": "Zeckenrückfallfieber",
    "synonyms": [
      "Borreliose [tropisches Rückfallfieber] durch Zeckenbiss",
      "Carter-Rückfallfieber",
      "Durch Zecken übertragenes Rückfallfieber",
      "Dutton-Rückfallfieber",
      "Infektion durch Borrelia duttoni",
      "Infektion durch Spirochaeta duttoni",
      "Mittelafrikanisches Zeckenfieber a.n.k.",
      "Novy-Rückfallfieber durch Zecken übertragen",
      "Rückfallfieber durch Borrelien, ausgenommen durch Borrelia recurrentis",
      "Rückfallfieber durch Spirochaeta Duttoni",
      "Westafrika-Rückfallfieber",
      "Zeckenrückfallfieber",
      "Zentralafrikanisches Zeckenfieber a.n.k."
    ]
  },
  {
    "code": "A68.9",
    "name": "Rückfallfieber",
    "synonyms": [
      "Borreliose [tropisches Rückfallfieber]",
      "Febris recurrens",
      "Novy-Rückfallfieber",
      "Rekurrensfieber - s.a. Rückfallfieber",
      "Rückfallfieber",
      "Rückfallfieber durch Spirillen",
      "Spirillose a.n.k.",
      "Typhus recurrens"
    ]
  },
  {
    "code": "A69.0",
    "name": "Noma",
    "synonyms": [
      "Cancer aquaticus",
      "Cancrum oris",
      "Gangrän durch Fusospirochäten",
      "Gangränöse Noma",
      "Gangränöse Stomatitis",
      "Gesichtsbrand",
      "Infektiöse Noma",
      "Mundbrand",
      "Mundgangrän",
      "Mundnoma",
      "Nekrotische Stomatitis ulcerosa",
      "Nekrotisierend-ulzeröse Stomatitis",
      "Noma",
      "Stomatitis gangraenosa",
      "Wangenbrand",
      "Wasserkrebs"
    ]
  },
  {
    "code": "A69.1",
    "name": "Fusospirillose",
    "synonyms": [
      "ANUG [Akute nekrotisierend-ulzeröse Gingivitis]",
      "Akute nekrotisierend-ulzeröse Gingivitis",
      "Akute nekrotisierend-ulzeröse Gingivostomatitis",
      "Akute nekrotisierende pellagröse Gingivitis",
      "Angina necrotica",
      "Angina pseudomembranacea",
      "Angina ulcero-membranacea",
      "Angina ulcerosa",
      "Fusospirillose",
      "Fusospirilläre Plaut-Vincent-Angina",
      "Fusospirochätische Pharyngitis",
      "Infektion durch Borrelia buccalis",
      "Infektion durch Borrelia vincenti",
      "Laryngitis durch Borrelia vincenti",
      "Laryngotracheitis durch Borrelia vincenti",
      "Nekrotische Plaut-Vincent-Angina",
      "Nekrotisierend-ulzeröse Gingivitis",
      "Nekrotisierend-ulzeröse Gingivostomatitis",
      "Pharyngitis durch Fusospirochäten",
      "Plaut-Vincent-Angina",
      "Plaut-Vincent-Gangrän des Rachens",
      "Plaut-Vincent-Gingivitis",
      "Plaut-Vincent-Infektion",
      "Plaut-Vincent-Laryngitis",
      "Plaut-Vincent-Laryngotracheitis",
      "Plaut-Vincent-Nekrose des Pharynx",
      "Plaut-Vincent-Stomatitis",
      "Plaut-Vincent-Tonsillitis",
      "Pseudomembranöse Angina",
      "Spirochäten-Stomatitis",
      "Ulzeromembranöse Stomatitis",
      "Ulzeromembranöse Tonsillitis"
    ]
  },
  {
    "code": "A69.2",
    "name": "Lyme-Krankheit",
    "synonyms": [
      "Bannwarth-Krankheit",
      "Borreliose [Lyme-Krankheit]",
      "Borreliose [Lyme-Krankheit] durch Zeckenbiss",
      "Erythema chronicum migrans",
      "Erythema chronicum migrans durch Borrelia burgdorferi",
      "Erythema chronicum migrans durch Borrelia burgdorferi nach Zeckenbiss",
      "Erythema chronicum migrans durch Borrelien",
      "Exanthema chronicum migrans",
      "Infektion durch Borrelia burgdorferi",
      "Lyme-Borreliose",
      "Lyme-Borreliose im Stadium I",
      "Lyme-Borreliose im Stadium II",
      "Lyme-Borreliose im Stadium III",
      "Lyme-Krankheit",
      "Lyme-Krankheit nach Zeckenbiss",
      "Lymphozytäre Meningoradikulitis (Bannwarth)",
      "Morbus Lyme"
    ]
  },
  {
    "code": "A69.8",
    "name": "Castellani-Bronchitis",
    "synonyms": [
      "Bronchospirochaetosis",
      "Bronchospirochaetosis Castellani",
      "Bronchospirochätose",
      "Castellani-Bronchitis",
      "Gangrän durch Spirochäten a.n.k.",
      "Nasenulkus durch Spirochäten a.n.k."
    ]
  },
  {
    "code": "A69.9",
    "name": "Spirochäten-Infektion a.n.k.",
    "synonyms": [
      "Spirochaetosis",
      "Spirochäten-Infektion a.n.k.",
      "Spirochätose"
    ]
  },
  {
    "code": "A70",
    "name": "Psittakose",
    "synonyms": [
      "Infektion durch Chlamydia psittaci",
      "Lungenornithose",
      "Ornithose",
      "Papageien-Krankheit",
      "Psittakose"
    ]
  },
  {
    "code": "A71.0",
    "name": "Initialstadium des Trachoms",
    "synonyms": [
      "Anfangsstadium des Trachoms",
      "Initialstadium des Trachoms",
      "Trachoma dubium"
    ]
  },
  {
    "code": "A71.1",
    "name": "Aktives Stadium des Trachoms",
    "synonyms": [
      "Aktive trachomatöse Dakryozystitis",
      "Aktiver Pannus trachomatosus",
      "Aktives Stadium des Trachoms",
      "Trachomatöse Keratitis",
      "Trachomatöse Konjunktivakontraktur",
      "Trachomatöse Konjunktivitis",
      "Trachomatöser Pannus"
    ]
  },
  {
    "code": "A71.9",
    "name": "Trachom",
    "synonyms": [
      "Augenlidtrachom",
      "Lidtrachom",
      "Trachom",
      "Trachoma"
    ]
  },
  {
    "code": "A74.9",
    "name": "Chlamydien-Infektion",
    "synonyms": [
      "Chlamydien-Infektion",
      "Chlamydien-Krankheit a.n.k.",
      "Chlamydiose"
    ]
  },
  {
    "code": "A75.0",
    "name": "Epidemisches Fleckfieber durch Rickettsia prowazekii",
    "synonyms": [
      "Endemisches Fleckfieber",
      "Epidemisches Fleckfieber",
      "Epidemisches Fleckfieber durch Rickettsia prowazekii",
      "Epidemisches Läusefleckfieber",
      "Hungertyphus",
      "Infektion durch Rickettsia prowazekii",
      "Klassisches Fleckfieber",
      "Läusefleckfieber",
      "Läusetyphus",
      "Mexikanisches Fleckfieber durch Läuse",
      "Tabardillofieber durch Läuse",
      "Typhus exanthematicus durch Läuse"
    ]
  },
  {
    "code": "A75.1",
    "name": "Brill-Zinsser-Krankheit",
    "synonyms": [
      "Brill-Krankheit",
      "Brill-Krankheit durch Läuse",
      "Brill-Zinsser-Krankheit",
      "Morbus Brill-Zinsser",
      "Rekrudeszentes Fleckfieber",
      "Spätrezidiv bei Fleckfieber",
      "Typhus exanthematicus Brilli a.n.k."
    ]
  },
  {
    "code": "A75.2",
    "name": "Fleckfieber durch Rickettsia typhi",
    "synonyms": [
      "Brill-Krankheit durch Flöhe",
      "Fleckfieber durch Rickettsia mooseri",
      "Fleckfieber durch Rickettsia typhi",
      "Flohfleckfieber",
      "Infektion durch Rickettsia mooseri",
      "Infektion durch Rickettsia typhi",
      "Mexikanisches Fleckfieber durch Flöhe",
      "Murines Fleckfieber",
      "Rattenfleckfieber",
      "Tabardillofieber durch Flöhe",
      "Typhus exanthematicus durch Flöhe"
    ]
  },
  {
    "code": "A75.3",
    "name": "Fleckfieber durch Rickettsia tsutsugamushi",
    "synonyms": [
      "Akamushi-Fieber",
      "Buschfleckfieber",
      "Fleckfieber durch Rickettsia orientalis",
      "Fleckfieber durch Rickettsia tsutsugamushi",
      "Infektion durch Rickettsia orientalis",
      "Infektion durch Rickettsia tsutsugamushi",
      "Japanisches Flussfieber",
      "Kedani-Fieber",
      "Kedani-Krankheit",
      "Milbenfleckfieber",
      "Morbus Tsutsugamushi",
      "Scrub typhus",
      "Sumatra-Milben-Fieber",
      "Tropical typhus",
      "Tropisches Fleckfieber",
      "Tsutsugamushi-Fieber",
      "Tsutsugamushi-Krankheit",
      "Überschwemmungsfleckfieber"
    ]
  },
  {
    "code": "A75.9",
    "name": "Fleckfieber",
    "synonyms": [
      "Febris petechialis",
      "Fleckfieber",
      "Flecktyphus",
      "Tabardillo",
      "Tabardillofieber",
      "Typhus exanthematicus a.n.k."
    ]
  },
  {
    "code": "A77.0",
    "name": "Zeckenbissfieber durch Rickettsia rickettsii",
    "synonyms": [
      "Amerikanisches Fleckfieber",
      "Brasilianisches Fleckfieber",
      "Felsengebirgsfleckfieber",
      "Fleckfieber durch Rickettsia rickettsii",
      "Infektion durch Rickettsia rickettsii",
      "Kolumbianisches Fleckfieber",
      "Rocky Mountain spottet fever",
      "Rocky-Mountain-Fleckfieber",
      "São-Paulo-Fleckfieber",
      "Zeckenbissfieber durch Rickettsia rickettsii"
    ]
  },
  {
    "code": "A77.1",
    "name": "Zeckenbissfieber durch Rickettsia conori",
    "synonyms": [
      "Afrikanisches Zeckenbissfieber",
      "Boutonneuse-Fieber",
      "Carducci-Fieber",
      "Conor-Fieber",
      "Fièvre boutonneuse",
      "Fleckfieber durch Rickettsia conori",
      "Indisches Zeckenbissfieber",
      "Infektion durch Rickettsia conori",
      "Kenya-Fieber",
      "Kenya-Typhus",
      "Marokkanisches Sommerfieber",
      "Marseille-Fieber",
      "Marseiller Fleckfieber",
      "Mittelmeer-Fleckfieber",
      "Mittelmeer-Zeckenbissfieber",
      "Tunesisches Fieber",
      "Zeckenbissfieber durch Rickettsia conori"
    ]
  },
  {
    "code": "A77.2",
    "name": "Zeckenbissfieber durch Rickettsia sibirica",
    "synonyms": [
      "Fleckfieber durch Rickettsia sibirica",
      "Infektion durch Rickettsia sibirica",
      "Nordasiatisches Zeckenbissfieber",
      "Sibirisches Zeckenbissfieber",
      "Zeckenbissfieber durch Rickettsia sibirica"
    ]
  },
  {
    "code": "A77.3",
    "name": "Queenslandzeckenfieber",
    "synonyms": [
      "Fleckfieber durch Rickettsia australis",
      "Infektion durch Rickettsia australis",
      "Nordqueensland-Zeckenbissfieber a.n.k.",
      "Queensland-Zeckenbissfieber a.n.k.",
      "Queenslandfieber",
      "Queenslandzeckenfieber",
      "Zeckenbissfieber durch Rickettsia australis"
    ]
  },
  {
    "code": "A77.9",
    "name": "Zeckenbissfieber a.n.k.",
    "synonyms": [
      "Rickettsiose durch Zecken a.n.k.",
      "Zeckenbissfieber a.n.k.",
      "Zeckenfleckfieber a.n.k.",
      "Zeckentyphus"
    ]
  },
  {
    "code": "A78",
    "name": "Q-Fieber",
    "synonyms": [
      "Australisches Q-Fieber",
      "Balkanfieber",
      "Balkangrippe [Q-Fieber]",
      "Derrick-Burnet-Krankheit",
      "Euboea-Fieber",
      "Infektion durch Coxiella burnetii",
      "Infektion durch Rickettsia burnetii",
      "Mossmann-Krankheit",
      "Olympkrankheit [Q-Fieber]",
      "Q-Fieber",
      "Query-Fieber",
      "Schlachthaus-Fieber",
      "Südostgrippe [Q-Fieber]"
    ]
  },
  {
    "code": "A79.0",
    "name": "Wolhynisches Fieber",
    "synonyms": [
      "Febris quintana",
      "Fünftagefieber",
      "Infektion durch Rickettsia quintana",
      "Schützengrabenfieber",
      "Trench-Fever",
      "Wolhynisches Fieber"
    ]
  },
  {
    "code": "A79.1",
    "name": "Rickettsienpocken",
    "synonyms": [
      "Akari-Rickettsiose",
      "Bläschenrickettsiose",
      "Infektion durch Rickettsia akari",
      "Pockenfleckfieber",
      "Rickettsienpocken",
      "Rickettsienpocken durch Rickettsia akari",
      "Rickettsiose durch Rickettsia akari",
      "Rickettsiosis varicelliformis",
      "Vesicular-Rickettsiosis",
      "Vesikuläre Rickettsiose"
    ]
  },
  {
    "code": "A79.8",
    "name": "Humane granulozytäre Ehrlichiose [HGE]",
    "synonyms": [
      "Humane granulozytäre Ehrlichiose [HGE]",
      "Pseudotyphus California",
      "Rickettsiose durch Ehrlichia sennetsu",
      "Rickettsiose durch Neorickettsia sennetsu"
    ]
  },
  {
    "code": "A79.9",
    "name": "Rickettsiose a.n.k.",
    "synonyms": [
      "Infektion durch Rickettsia",
      "Rickettsien-Infektion",
      "Rickettsiose a.n.k."
    ]
  },
  {
    "code": "A80.0",
    "name": "Akute paralytische Poliomyelitis durch Impfviren",
    "synonyms": [
      "Akute paralytische Poliomyelitis durch Impfviren"
    ]
  },
  {
    "code": "A80.1",
    "name": "Paralytische Poliomyelitis durch importierten Wildvirus",
    "synonyms": [
      "Akute paralytische Poliomyelitis durch importiertes Wildvirus",
      "Paralytische Poliomyelitis durch importierten Wildvirus"
    ]
  },
  {
    "code": "A80.2",
    "name": "Paralytische Poliomyelitis durch einheimischen Wildvirus",
    "synonyms": [
      "Akute paralytische Poliomyelitis durch einheimisches Wildvirus",
      "Paralytische Poliomyelitis durch einheimischen Wildvirus"
    ]
  },
  {
    "code": "A80.3",
    "name": "Akute paralytische Poliomyelitis",
    "synonyms": [
      "Akute atrophische Spinalparalyse",
      "Akute atrophische infantile Paralyse",
      "Akute paralytische Poliomyelitis",
      "Akute paralytische atrophische Spinalkrankheit",
      "Akute poliomyelitische Bulbärparalyse",
      "Atrophische Spinalparalyse",
      "Aufsteigende progressive Poliomyelitis",
      "Bulbär-paralytische Poliomyelitis",
      "Infantile Bulbärparalyse",
      "Infantile Paralyse",
      "Infantile Spinalparalyse",
      "Paralysis acuta infantum",
      "Paralytische bulbäre Kinderlähmung",
      "Poliomyelitis mit Bulbärparalyse",
      "Spinale Atrophie mit akuter infantiler Lähmung"
    ]
  },
  {
    "code": "A80.4",
    "name": "Akute nichtparalytische Poliomyelitis",
    "synonyms": [
      "Abortive Poliomyelitis",
      "Akute nichtparalytische Poliomyelitis",
      "Aparalytische Poliomyelitis"
    ]
  },
  {
    "code": "A80.9",
    "name": "Poliomyelitis",
    "synonyms": [
      "Akute Polioenzephalitis",
      "Akute Polioenzephalomyelitis",
      "Akute Poliomyelitis [Spinale Kinderlähmung]",
      "Akute spinale Kinderlähmung",
      "Akute spinale Poliomyelitis",
      "Endemische Poliomyelitis",
      "Epidemische Kinderlähmung",
      "Epidemische Poliomyelitis",
      "Heine-Medin-Krankheit",
      "Kinderlähmung",
      "Nichtepidemische Poliomyelitis",
      "Polioenzephalomyelitis",
      "Polioenzephalomyelitis anterior",
      "Poliomyelitis",
      "Poliomyelitis anterior",
      "Poliomyelitis anterior acuta",
      "Poliomyelitis epidemica anterior acuta",
      "Spinale Kinderlähmung"
    ]
  },
  {
    "code": "A81.0",
    "name": "Creutzfeldt-Jakob-Krankheit",
    "synonyms": [
      "Atypische Form der Creutzfeldt-Jakob-Krankheit durch BSE [Bovine spongiforme Enzephalopathie]",
      "CJD [Creutzfeldt-Jakob-Disease]",
      "Creutzfeldt-Jakob-Krankheit",
      "Creutzfeldt-Jakob-Syndrom",
      "Erworbene Creutzfeldt-Jakob-Krankheit",
      "Hereditäre Creutzfeldt-Jakob-Krankheit",
      "Kortikostriatospinale Degeneration",
      "Sporadische Creutzfeldt-Jakob-Krankheit",
      "Subakute spongioforme Enzephalopathie",
      "iCJD [Iatrogene Creutzfeldt-Jakob-Krankheit]",
      "vCJD [Variante der Creutzfeldt-Jakob-Krankheit]"
    ]
  },
  {
    "code": "A81.1",
    "name": "Panenzephalitis",
    "synonyms": [
      "Dawson-Enzephalitis",
      "Einschlusskörperchenenzephalitis",
      "Panenzephalitis",
      "SSPE [Subakute sklerosierende Panenzephalitis]",
      "Sklerosierende Leukenzephalopathie Bogaert",
      "Subakute Einschlusskörperchenenzephalitis",
      "Subakute sklerosierende Leukoenzephalitis",
      "Subakute sklerosierende Panenzephalitis",
      "Van-Bogaert-Syndrom [Sklerosierende Leukenzephalopathie]"
    ]
  },
  {
    "code": "A81.2",
    "name": "Progressive multifokale Leukenzephalopathie",
    "synonyms": [
      "Multifokale Leukenzephalopathie",
      "PML [Progressive multifokale Leukoenzephalopathie]",
      "Progressive multifokale Leukenzephalopathie"
    ]
  },
  {
    "code": "A81.8",
    "name": "Lachkrankheit [atypische Virusinfektion des Zentralnervensystems]",
    "synonyms": [
      "Chorea Huntington-ähnliche Erkrankung 1",
      "FFI [Fatale familiäre Insomnie]",
      "Fatale familiäre Insomnie",
      "Fatale sporadische Insomnie",
      "Gerstmann-Sträussler-Scheinker-Syndrom",
      "Kuru",
      "Kuru-Krankheit",
      "Kuru-Syndrom",
      "Lachkrankheit [atypische Virusinfektion des Zentralnervensystems]",
      "Schüttelkrankheit [atypische Virusinfektion des Zentralnervensystems]",
      "Variable Protease-sensitive Prionopathie"
    ]
  },
  {
    "code": "A81.9",
    "name": "Slow-Virus-Enzephalitis",
    "synonyms": [
      "Atypische Virusinfektion",
      "Familiäre Alzheimer-ähnliche Prionkrankheit",
      "Prionen-Krankheit des ZNS",
      "Prionen-Krankheit des Zentralnervensystems",
      "Slow-Virus-Enzephalitis",
      "Slow-Virus-Infektion",
      "Slow-Virus-Infektion des Zentralnervensystems"
    ]
  },
  {
    "code": "A82.0",
    "name": "Wildtier-Tollwut",
    "synonyms": [
      "Wildtier-Rabies",
      "Wildtier-Tollwut"
    ]
  },
  {
    "code": "A82.1",
    "name": "Haustier-Tollwut",
    "synonyms": [
      "Haustier-Rabies",
      "Haustier-Tollwut"
    ]
  },
  {
    "code": "A82.9",
    "name": "Tollwut",
    "synonyms": [
      "Hydrophobie - s.a. Tollwut",
      "Lyssa",
      "Rabies",
      "Tollwut",
      "Wutkrankheit"
    ]
  },
  {
    "code": "A83.0",
    "name": "Japanische Enzephalitis",
    "synonyms": [
      "Encephalitis japonica B",
      "Japan-B-Enzephalitis",
      "Japanische Enzephalitis",
      "Russische Herbst-Enzephalitis"
    ]
  },
  {
    "code": "A83.1",
    "name": "Westliche Pferdeenzephalitis",
    "synonyms": [
      "Western-Equine-Encephalitis",
      "Westliche Pferdeenzephalitis"
    ]
  },
  {
    "code": "A83.2",
    "name": "Östliche Pferdeenzephalitis",
    "synonyms": [
      "Eastern-Equine-Encephalitis",
      "Östliche Pferdeenzephalitis"
    ]
  },
  {
    "code": "A83.3",
    "name": "St.-Louis-Enzephalitis",
    "synonyms": [
      "St.-Louis-Enzephalitis",
      "Typ-C-Enzephalitis"
    ]
  },
  {
    "code": "A83.4",
    "name": "Australische Enzephalitis",
    "synonyms": [
      "Australische Enzephalitis",
      "Australische X-Enzephalitis",
      "Australische X-Krankheit",
      "Kunjin-Krankheit",
      "Kunjin-Virusenzephalitis",
      "Murray-Valley-Enzephalitis"
    ]
  },
  {
    "code": "A83.5",
    "name": "Kalifornische Enzephalitis",
    "synonyms": [
      "California-Enzephalitis",
      "Kalifornische Enzephalitis",
      "Kalifornische Meningoenzephalitis",
      "Kalifornische Virusenzephalitis",
      "La-Crosse-Enzephalitis"
    ]
  },
  {
    "code": "A83.6",
    "name": "Rocio-Virusenzephalitis",
    "synonyms": [
      "Rocio-Virusenzephalitis"
    ]
  },
  {
    "code": "A83.8",
    "name": "Enzephalitis durch Ilhéusviren",
    "synonyms": [
      "Enzephalitis durch Ilhéusviren"
    ]
  },
  {
    "code": "A83.9",
    "name": "Virusenzephalitis durch Moskitos",
    "synonyms": [
      "Enzephalomyelitis equina",
      "Pferdeenzephalitis",
      "Virusenzephalitis durch Moskitos",
      "Virusenzephalitis durch Stechmücken",
      "Virusenzephalitis, durch Moskitos übertragen",
      "Virusmeningoenzephalitis, durch Moskitos übertragen"
    ]
  },
  {
    "code": "A84.0",
    "name": "Russische Frühsommer-Enzephalitis",
    "synonyms": [
      "Fernöstliche Enzephalitis durch Zecken",
      "Russische Frühsommer-Enzephalitis",
      "Russische Frühsommer-Meningoenzephalitis"
    ]
  },
  {
    "code": "A84.1",
    "name": "Zentraleuropäische Enzephalitis",
    "synonyms": [
      "Biphasische Meningoenzephalitis",
      "FSME [Zentraleuropäische Frühsommer-Meningoenzephalitis]",
      "Frühjahr-Sommer-Enzephalitis",
      "Frühsommer-Enzephalitis",
      "Frühsommer-Meningoenzephalitis",
      "Frühsommer-Meningoenzephalomyelitis",
      "Mitteleuropäische Enzephalitis",
      "Mitteleuropäische Enzephalitis, durch Zecken übertragen",
      "Sommer-Enzephalitis",
      "Sommer-Meningoenzephalomyelitis",
      "Tschechoslowakische Enzephalitis",
      "Zentraleuropäische Enzephalitis",
      "Zentraleuropäische Frühsommer-Meningoenzephalitis",
      "Zweiphasige Meningoenzephalitis"
    ]
  },
  {
    "code": "A84.8",
    "name": "Drehkrankheit",
    "synonyms": [
      "Drehkrankheit",
      "Drehkrankheit der Schafe",
      "Langat-Virus-Enzephalitis",
      "Louping-ill-Enzephalitis",
      "Louping-ill-Krankheit",
      "Powassan-Enzephalitis",
      "Spring- und Drehkrankheit"
    ]
  },
  {
    "code": "A84.9",
    "name": "Zeckenenzephalitis",
    "synonyms": [
      "Virusenzephalitis durch Zecken",
      "Virusmeningoenzephalitis, durch Zecken übertragen",
      "Zeckenenzephalitis"
    ]
  },
  {
    "code": "A85.2",
    "name": "Virusenzephalitis durch Arthropoden",
    "synonyms": [
      "Enzephalitis durch Arboviren a.n.k.",
      "Enzephalitis durch Arthropoden a.n.k.",
      "Enzephalitis durch Negishi-Virus",
      "Virusenzephalitis durch Arthropoden"
    ]
  },
  {
    "code": "A85.8",
    "name": "Nipah-Viruskrankheit",
    "synonyms": [
      "Hendra-Virus-Infektion mit Enzephalitis",
      "Nipah-Viruskrankheit"
    ]
  },
  {
    "code": "A86",
    "name": "Virale Meningoenzephalitis",
    "synonyms": [
      "Akute Meningoenzephalitis a.n.k.",
      "Akute Meningoenzephalomyelitis a.n.k.",
      "Akute Virusenzephalitis",
      "Akute virale Enzephalitis",
      "Endemische Enzephalitis",
      "Epidemische Enzephalitis a.n.k.",
      "Infektiöse Meningoenzephalitis",
      "Infektiöse virale Enzephalitis a.n.k.",
      "Infektiöse virale Enzephalomyelitis",
      "Meningoenzephalitis durch Viren",
      "Postvirale Enzephalitis a.n.k.",
      "Virale Enzephalomyelitis",
      "Virale Meningoenzephalitis",
      "Virale Meningoenzephalomyelitis",
      "Virusenzephalitis"
    ]
  },
  {
    "code": "A87.9",
    "name": "Virusmeningitis",
    "synonyms": [
      "Meningitis bei Viruskrankheit a.n.k.",
      "Meningitis durch Viren a.n.k.",
      "Virusmeningitis"
    ]
  },
  {
    "code": "A88.0",
    "name": "Fieber mit Exanthem durch Enteroviren",
    "synonyms": [
      "Boston-Exanthem",
      "Fieber mit Exanthem durch Enteroviren"
    ]
  },
  {
    "code": "A88.8",
    "name": "Coxsackie-Infektion des Zentralnervensystems a.n.k.",
    "synonyms": [
      "Akute schlaffe Myelitis",
      "Coxsackie-Infektion des Zentralnervensystems a.n.k.",
      "Infektion des Zentralnervensystems durch Enteroviren a.n.k."
    ]
  },
  {
    "code": "A89",
    "name": "Virusinfektion des Zentralnervensystems",
    "synonyms": [
      "Virusinfektion des Zentralnervensystems"
    ]
  },
  {
    "code": "A92.0",
    "name": "Chikungunya-Viruskrankheit",
    "synonyms": [
      "Chikungunya-Fieber",
      "Chikungunya-Viruskrankheit",
      "Hämorrhagisches Chikungunya-Fieber"
    ]
  },
  {
    "code": "A92.1",
    "name": "O'Nyong-nyong-Fieber",
    "synonyms": [
      "O'Nyong-nyong-Fieber"
    ]
  },
  {
    "code": "A92.2",
    "name": "Venezolanisches Pferdefieber",
    "synonyms": [
      "Venezolanisches Pferdefieber"
    ]
  },
  {
    "code": "A92.3",
    "name": "West-Nil-Fieber",
    "synonyms": [
      "West-Nil-Fieber",
      "West-Nil-Virusinfektion"
    ]
  },
  {
    "code": "A92.4",
    "name": "Rift-Tal-Fieber",
    "synonyms": [
      "Rift-Tal-Fieber",
      "Rift-Valley-Fieber",
      "Rifttalfieber"
    ]
  },
  {
    "code": "A92.5",
    "name": "Zika-Fieber",
    "synonyms": [
      "Zika",
      "Zika-Fieber",
      "Zika-Virus-Fieber",
      "Zika-Virus-Infektion",
      "Zika-Viruskrankheit"
    ]
  },
  {
    "code": "A92.8",
    "name": "Bwamba",
    "synonyms": [
      "Barmah-Forest-Fieber",
      "Bunyamwera-Fieber",
      "Bwamba",
      "Bwamba-Fieber",
      "Chandipura-Fieber",
      "Guama-Fieber",
      "Mayaro-Fieber",
      "Mucambo-Fieber",
      "Pixuna-Fieber",
      "Wesselsbron-Fieber"
    ]
  },
  {
    "code": "A92.9",
    "name": "Virales Fieber durch Moskitos übertragen",
    "synonyms": [
      "Virales Fieber durch Moskitos übertragen"
    ]
  },
  {
    "code": "A93.0",
    "name": "Oropouche-Viruskrankheit",
    "synonyms": [
      "Oropouche-Fieber",
      "Oropouche-Viruskrankheit"
    ]
  },
  {
    "code": "A93.1",
    "name": "Pappataci-Fieber",
    "synonyms": [
      "Chitral-Fieber",
      "Dalmatien-Fieber",
      "Dreitagefieber [Pappataci-Fieber]",
      "Drittetags-Fieber [Pappataci-Fieber]",
      "Febris pappataci",
      "Hunds-Fieber",
      "Italienische Sommergrippe",
      "Moskito-Fieber",
      "Papatasi-Fieber",
      "Pappataci-Fieber",
      "Phlebotomus-Fieber",
      "Pick-Fieber",
      "Sandfliegen-Fieber",
      "Sandfly fever"
    ]
  },
  {
    "code": "A93.2",
    "name": "Colorado-Zeckenfieber",
    "synonyms": [
      "American mountain tick fever",
      "Amerikanisches Gebirgszeckenfieber",
      "Colorado-Zeckenfieber",
      "Nichtexanthematisches Zeckenfieber"
    ]
  },
  {
    "code": "A93.8",
    "name": "Kemerovo-Fieber",
    "synonyms": [
      "Changuinola-Fieber",
      "Fieber bei vesikulärer Stomatitis",
      "Hämorrhagisches Fieber durch Haemaphysalis longicornis",
      "Hämorrhagisches Fieber durch Milben",
      "Hämorrhagisches Zeckenfieber a.n.k.",
      "Indiana-Fieber",
      "Kemerovo-Fieber",
      "Nairobi-Schaf-Krankheit",
      "Piry-Fieber",
      "Quaranfil-Fieber",
      "SFTS [Schweres Fieber mit Thrombozytopenie-Syndrom]",
      "Schweres Fieber mit Thrombozytopenie-Syndrom",
      "Stomatitis-vesicularis-Viruskrankheit",
      "Viruskrankheit durch Zecken",
      "Zeckenfieber a.n.k.",
      "Zeckenfieber durch Haemaphysalis longicornis"
    ]
  },
  {
    "code": "A94",
    "name": "Arthropoden-Krankheit a.n.k.",
    "synonyms": [
      "Arboviruskrankheit",
      "Arthropoden-Krankheit a.n.k.",
      "Fieber durch Arboviren",
      "Hämorrhagisches Arthropoden-Fieber",
      "Hämorrhagisches Fieber a.n.k.",
      "Hämorrhagisches Fieber durch Arboviren",
      "Infektion durch Arboviren",
      "Viruskrankheit durch Arthropoden a.n.k."
    ]
  },
  {
    "code": "A95.0",
    "name": "Buschgelbfieber",
    "synonyms": [
      "Buschgelbfieber",
      "Dschungelgelbfieber",
      "Sylvatisches Gelbfieber"
    ]
  },
  {
    "code": "A95.1",
    "name": "Urbanes Gelbfieber",
    "synonyms": [
      "Urbanes Gelbfieber"
    ]
  },
  {
    "code": "A95.9",
    "name": "Gelbfieber",
    "synonyms": [
      "Febris flava",
      "Gelbfieber",
      "YF [Gelbfieber]"
    ]
  },
  {
    "code": "A96.0",
    "name": "Hämorrhagisches Fieber durch Junin-Viren",
    "synonyms": [
      "Argentinisches hämorrhagisches Fieber",
      "Hämorrhagisches Fieber durch Junin-Viren"
    ]
  },
  {
    "code": "A96.1",
    "name": "Hämorrhagisches Fieber durch Machupo-Viren",
    "synonyms": [
      "Bolivianisches hämorrhagisches Fieber",
      "Hämorrhagisches Fieber durch Machupo-Viren"
    ]
  },
  {
    "code": "A96.2",
    "name": "Lassa-Fieber",
    "synonyms": [
      "Hämorrhagisches Fieber durch Lassa-Viren",
      "Lassa-Fieber"
    ]
  },
  {
    "code": "A96.8",
    "name": "Südamerikanisches hämorrhagisches Fieber",
    "synonyms": [
      "Brasilianisches hämorrhagisches Fieber",
      "Chapare hämorrhagisches Fieber",
      "Lujo hämorrhagisches Fieber",
      "Südamerikanisches hämorrhagisches Fieber",
      "Venezolanisches hämorrhagisches Fieber"
    ]
  },
  {
    "code": "A96.9",
    "name": "Hämorrhagisches Fieber durch Arenaviren",
    "synonyms": [
      "Hämorrhagisches Fieber durch Arenaviren"
    ]
  },
  {
    "code": "A97.0",
    "name": "Dengue ohne Warnzeichen",
    "synonyms": [
      "Dengue ohne Warnzeichen",
      "Dengue-Fieber ohne Warnzeichen",
      "Hämorrhagisches Dengue-Fieber ohne Warnzeichen",
      "Hämorrhagisches Dengue-Fieber, Grad 1",
      "Hämorrhagisches Dengue-Fieber, Grad 2"
    ]
  },
  {
    "code": "A97.1",
    "name": "Dengue mit Warnzeichen",
    "synonyms": [
      "Dengue mit Warnzeichen",
      "Dengue-Fieber mit Warnzeichen",
      "Hämorrhagisches Dengue-Fieber mit Warnzeichen"
    ]
  },
  {
    "code": "A97.2",
    "name": "Schweres Dengue",
    "synonyms": [
      "Schweres Dengue",
      "Schweres Dengue-Fieber",
      "Schweres hämorrhagisches Dengue-Fieber"
    ]
  },
  {
    "code": "A97.9",
    "name": "Dengue-Fieber",
    "synonyms": [
      "Aburabaku",
      "Adenfieber",
      "Breakbone fever",
      "DF [Dengue-Fieber]",
      "DHF [Dengue hämorrhagisches Fieber]",
      "Dandy-Fieber",
      "Dandy-Krankheit",
      "Dengue",
      "Dengue-Fieber",
      "Dengue-Viruskrankheit",
      "Hämorrhagische Dengue",
      "Hämorrhagisches Bangkok-Fieber",
      "Hämorrhagisches Dengue-Fieber",
      "Hämorrhagisches Fieber durch Moskitos",
      "Hämorrhagisches Philippinen-Fieber",
      "Hämorrhagisches Singapur-Fieber",
      "Hämorrhagisches Südostasien-Fieber",
      "Hämorrhagisches Thailand-Fieber",
      "Klassische Dengue",
      "Polka-Fieber"
    ]
  },
  {
    "code": "A98.0",
    "name": "Hämorrhagisches Krim-Kongo-Fieber",
    "synonyms": [
      "Fernöstliches hämorrhagisches Fieber",
      "Hämorrhagisches Krim-Kongo-Fieber",
      "Kongo-Krim-Fieber",
      "Zentralasiatisches hämorrhagisches Fieber"
    ]
  },
  {
    "code": "A98.1",
    "name": "Hämorrhagisches Omsk-Fieber",
    "synonyms": [
      "Hämorrhagisches Omsk-Fieber"
    ]
  },
  {
    "code": "A98.2",
    "name": "Kyasanur-forest-Krankheit",
    "synonyms": [
      "Kumaon-Fieber",
      "Kyasanur hämorrhagisches Fieber",
      "Kyasanur-Wald-Fieber",
      "Kyasanur-Wald-Krankheit",
      "Kyasanur-forest-Krankheit",
      "Kyasanur-forest-disease"
    ]
  },
  {
    "code": "A98.3",
    "name": "Marburg-Viruskrankheit",
    "synonyms": [
      "Grüne Meerkatzen-Krankheit",
      "MHF [Marburg hämorrhagisches Fieber]",
      "Marburg hämorrhagisches Fieber",
      "Marburg-Viruskrankheit"
    ]
  },
  {
    "code": "A98.4",
    "name": "Ebola-Viruskrankheit",
    "synonyms": [
      "Ebola hämorrhagisches Fieber",
      "Ebola-Fieber",
      "Ebola-Viruskrankheit"
    ]
  },
  {
    "code": "A98.5",
    "name": "Infektion durch Hantaan-Virus",
    "synonyms": [
      "Epidemisches hämorrhagisches Fieber",
      "Hantavirus-Fieber",
      "Infektion durch Hantaan-Virus",
      "Koreanisches hämorrhagisches Fieber",
      "Russisches hämorrhagisches Fieber"
    ]
  },
  {
    "code": "A99",
    "name": "Hämorrhagisches Fieber durch Viren",
    "synonyms": [
      "Hämorrhagisches Fieber durch Viren"
    ]
  },
  {
    "code": "B00.0",
    "name": "Herpes-Effloreszenz",
    "synonyms": [
      "Ekzema herpeticatum",
      "Ekzema herpeticatum Kaposi",
      "Ekzema herpeticum",
      "Herpes-Effloreszenz",
      "Pustulosis herpetica infantum",
      "Pustulosis varioliformis acuta",
      "Varizelliforme Kaposi-Eruption"
    ]
  },
  {
    "code": "B00.1",
    "name": "Bläschenflechte",
    "synonyms": [
      "Bläschenflechte",
      "Dermatitis vesicularis der Lippe durch HSV-2",
      "Dermatitis vesicularis der Lippe durch humanes Alpha-Herpes-Virus, Typ 2",
      "Dermatitis vesicularis des Ohres durch HSV-2",
      "Dermatitis vesicularis des Ohres durch humanes Alpha-Herpes-Virus, Typ 2",
      "Dermatitis vesicularis durch Herpesviren",
      "Fieberbläschen",
      "Fieberhafte Bläschenflechte",
      "Gesichtsherpes",
      "Herpes facialis",
      "Herpes febrilis",
      "Herpes labialis",
      "Herpes labialis recidivans",
      "Herpes simplex facialis",
      "Herpes simplex labialis",
      "Labialer Herpes simplex",
      "Lippenbläschen",
      "Lippenherpes"
    ]
  },
  {
    "code": "B00.2",
    "name": "Pharyngotonsillitis herpetica",
    "synonyms": [
      "Gingivitis aphthosa",
      "Gingivostomatitis aphthosa",
      "Gingivostomatitis herpetica",
      "Herpesinfektion im Mund-Rachen-Raum",
      "Herpetische Gingivostomatitis",
      "Herpetische Mundschleimhautentzündung",
      "Herpetische Pharyngitis",
      "Herpetische Pharyngotonsillitis",
      "Herpetische Rachenschleimhautentzündung",
      "Herpetische Stomatitis",
      "Mundfäule",
      "Pharyngitis durch Herpesviren",
      "Pharyngotonsillitis durch Herpesviren",
      "Pharyngotonsillitis herpetica",
      "Stomatitis aphthosa",
      "Stomatitis aphthosa herpetica",
      "Stomatitis durch Herpesviren",
      "Virale Stomatitis aphthosa"
    ]
  },
  {
    "code": "B00.70",
    "name": "Herpetische Sepsis",
    "synonyms": [
      "Herpetische Sepsis",
      "Sepsis durch Herpesviren"
    ]
  },
  {
    "code": "B00.78",
    "name": "Disseminierte Herpesvirus-Krankheit",
    "synonyms": [
      "Disseminierte Herpesvirus-Krankheit",
      "Disseminierte Infektion durch Herpes-simplex-Viren"
    ]
  },
  {
    "code": "B00.8",
    "name": "Herpes glutaealis",
    "synonyms": [
      "Herpes glutaealis",
      "Herpes mit Komplikation",
      "Herpes oticus"
    ]
  },
  {
    "code": "B00.9",
    "name": "Herpes",
    "synonyms": [
      "Entzündung durch Herpes simplex",
      "Herpes",
      "Herpes simplex",
      "Herpes simplex recidivans",
      "Herpes simplex recidivans in loco",
      "Herpes-Infektion",
      "Herpesvirus-Infektion",
      "Herpesvirus-Krankheit",
      "Infektion durch Herpes-simplex-Viren",
      "Rezidivierender Herpes simplex"
    ]
  },
  {
    "code": "B01.8",
    "name": "Varizellen-Exanthem",
    "synonyms": [
      "Varizellen-Exanthem"
    ]
  },
  {
    "code": "B01.9",
    "name": "Varizellen - s.a. Windpocken",
    "synonyms": [
      "Feuchtblattern",
      "Pseudovariola [Varizellen]",
      "Spitzblattern",
      "Spitzpocken",
      "Variola emphysematica [Varizellen]",
      "Variola hybrida [Varizellen]",
      "Variola illegitima [Varizellen]",
      "Variola notha [Varizellen]",
      "Variola spuria [Varizellen]",
      "Varizellen - s.a. Windpocken",
      "Varizellen ohne Komplikation",
      "Varizellen-Infektion",
      "Wasserpocken",
      "Windblattern",
      "Windpocken",
      "Windpocken ohne Komplikation"
    ]
  },
  {
    "code": "B02.7",
    "name": "Zoster generalisatus",
    "synonyms": [
      "Disseminierter Herpes zoster",
      "Herpes zoster generalisatus",
      "Zoster generalisatus"
    ]
  },
  {
    "code": "B02.9",
    "name": "Herpes zoster - s.a. Zoster",
    "synonyms": [
      "Gürtelrose",
      "Herpes zoster - s.a. Zoster",
      "Herpes zoster labialis",
      "Herpes zoster ohne Komplikation",
      "Zoster",
      "Zoster ohne Komplikation",
      "Zoster thoracicus",
      "Zoster-Schmerzen"
    ]
  },
  {
    "code": "B03",
    "name": "Alastrim",
    "synonyms": [
      "Alastrim",
      "Blattern - s.a. Pocken",
      "Echte Pocken",
      "Hämorrhagische Pocken",
      "Milchpocken",
      "Paravariola",
      "Pocken",
      "Purpura variolosa",
      "Samoapocken",
      "Sanagapocken",
      "Variola",
      "Variola humana",
      "Variola mitigata",
      "Variola vera",
      "Varioloid",
      "Variolois",
      "Weiße Pocken"
    ]
  },
  {
    "code": "B04",
    "name": "Affenpocken",
    "synonyms": [
      "Affenpocken",
      "Mpox [Affenpocken]"
    ]
  },
  {
    "code": "B05.8",
    "name": "Masern mit Komplikation a.n.k.",
    "synonyms": [
      "Masern mit Komplikation a.n.k."
    ]
  },
  {
    "code": "B05.9",
    "name": "Koplik-Flecken",
    "synonyms": [
      "Asymptomatische Masern",
      "Hämorrhagische Masern",
      "Koplik-Flecken",
      "Masern",
      "Masern ohne Komplikation",
      "Masern-Exanthem",
      "Morbilli - s.a. Masern",
      "Rotsucht",
      "Schwarze Masern",
      "Schwere Verlaufsform der Masern"
    ]
  },
  {
    "code": "B06.8",
    "name": "Rubella mit Komplikation a.n.k.",
    "synonyms": [
      "Rubella mit Komplikation a.n.k."
    ]
  },
  {
    "code": "B06.9",
    "name": "Röteln - s.a. Rubella oder s.a. Rubeola",
    "synonyms": [
      "Rubella",
      "Rubeola",
      "Rubeola scarlatinosa",
      "Rubeolen",
      "Röteln - s.a. Rubella oder s.a. Rubeola",
      "Röteln ohne Komplikation",
      "Rötelninfektion"
    ]
  },
  {
    "code": "B07",
    "name": "Verruca vulgaris",
    "synonyms": [
      "Dornwarze",
      "Epidermodysplasia verruciformis",
      "Filiforme Warze",
      "Fußsohlenwarze",
      "HPV [Humanes Papillomavirus]-Infektion",
      "Hautwarze",
      "Humanes-Papillomavirus-Infektion",
      "Infektion durch humanes Papillomavirus [HPV]",
      "Infektiöse Warze",
      "Juvenile Warze",
      "Lewandowsky-Lutz-Syndrom",
      "Lidverruca",
      "Lidwarze",
      "Multiple Warzen",
      "Palmarwarze",
      "Plantarwarze",
      "Verruca",
      "Verruca durch Viren",
      "Verruca filiformis",
      "Verruca palmaris",
      "Verruca plana",
      "Verruca plana juvenilis",
      "Verruca plantaris",
      "Verruca simplex",
      "Verruca subungualis",
      "Verruca vulgaris",
      "Verruca vulgaris palmaris",
      "Verruca vulgaris plantaris",
      "Verrucae",
      "Virale Verruca",
      "Virale Warze",
      "Viruswarze",
      "Vulgäre Warze",
      "Warze"
    ]
  },
  {
    "code": "B08.0",
    "name": "Melkerknoten",
    "synonyms": [
      "Dermatitis pustulosa contagiosa",
      "Ecthyma contagiosum",
      "Ecthyma infectiosum",
      "Generalisierte Vaccinia",
      "Humane Orthopockenvirus-Infektion",
      "Infektion durch Orfviren",
      "Infektion durch Orthopoxviren a.n.k.",
      "Infektion durch Vacciniavirus",
      "Kuhpocken",
      "Lokale Vaccinia",
      "Melkerknoten",
      "Melkerknoten durch Paravaccinia a.n.k.",
      "Orfvirus-Krankheit",
      "Paravaccinia-Infektion a.n.k.",
      "Pseudokuhpocken",
      "Schafblattern",
      "Schafpocken",
      "Vaccinia",
      "Vaccinia generalisata",
      "Vaccinia localisata"
    ]
  },
  {
    "code": "B08.1",
    "name": "Molluscum contagiosum",
    "synonyms": [
      "Dellwarze",
      "Epitheliales Molluscum",
      "Epitheliales Molluscum contagiosum",
      "Molluscum contagiosum",
      "Molluscum contagiosum epithelialis"
    ]
  },
  {
    "code": "B08.2",
    "name": "Exanthema subitum",
    "synonyms": [
      "Dreitagefieber [Exanthema subitum]",
      "Dreitagefieber-Exanthem [Exanthema subitum]",
      "Erythema subitum",
      "Exanthema subitum",
      "Pseudorubella",
      "Pseudorubeola",
      "Roseola infantum",
      "Sechste Krankheit [Exanthema subitum]"
    ]
  },
  {
    "code": "B08.3",
    "name": "Erythema infectiosum acutum",
    "synonyms": [
      "Epidemisches Megalerythem",
      "Erythema infectiosum acutum",
      "Fünfte Krankheit [Erythema infectiosum acutum]",
      "Großfleckenkrankheit",
      "Megalerythema",
      "Megalerythema epidemica",
      "Parvovirus-B19-Infektion",
      "Ringelröteln",
      "Sticker-Krankheit",
      "Sticker-Syndrom"
    ]
  },
  {
    "code": "B08.4",
    "name": "Hand-Fuß-Mund-Exanthem",
    "synonyms": [
      "HFM [Hand-Fuß-Mund]-Exanthem",
      "HFME [Hand-Fuß-Mund-Exanthem]",
      "Hand-Fuß-Mund-Exanthem",
      "Hand-Fuß-Mund-Krankheit",
      "Vesikuläre Stomatitis mit Exanthem durch Enteroviren"
    ]
  },
  {
    "code": "B08.5",
    "name": "Herpangina",
    "synonyms": [
      "Angina aphthosa",
      "Angina herpetica",
      "Herpangina",
      "Herpangina durch Coxsackie-Infektion",
      "Pharyngitis aphthosa",
      "Pharyngitis durch Coxsackieviren",
      "Pharynxinfektion durch Coxsackieviren",
      "Racheninfektion durch Coxsackieviren",
      "Vesikuläre Pharyngitis durch Enteroviren",
      "Zahorsky-Syndrom"
    ]
  },
  {
    "code": "B08.8",
    "name": "Tanapocken",
    "synonyms": [
      "Aphthae epizooticae",
      "Aphthenfieber",
      "Aphthenseuche",
      "Aphthöses Fieber",
      "Epidemische Stomatitis",
      "Epizootische Stomatitis",
      "Klauenseuche",
      "Lymphonoduläre Pharyngitis durch Enteroviren",
      "Maul- und Klauenseuche",
      "Tanapocken",
      "Tanapocken-Viruskrankheit",
      "Vierte Krankheit [Rubeola scartinosa]",
      "Yabapocken",
      "Yabapocken-Viruskrankheit"
    ]
  },
  {
    "code": "B09",
    "name": "Roseolen",
    "synonyms": [
      "Roseola",
      "Roseolen",
      "Virales Enanthem",
      "Virales Exanthem",
      "Virusdermatitis",
      "Virusenanthem",
      "Virusexanthem"
    ]
  },
  {
    "code": "B15.9",
    "name": "Hepatitis A",
    "synonyms": [
      "Akute Hepatitis A",
      "Akute katarrhalische Hepatitis",
      "Akuter Icterus catarrhalis",
      "Epidemische Gelbsucht",
      "Epidemische Hepatitis",
      "Epidemischer Ikterus",
      "Fieberhafte Gelbsucht bei Virushepatitis",
      "Fieberhafter Ikterus bei Virushepatitis",
      "Hepatitis A",
      "Hepatitis A durch Virus",
      "Hepatitis A ohne Coma hepaticum",
      "Hepatitis A ohne Folgen",
      "Hepatitis epidemica",
      "Infektiöse Gelbsucht",
      "Infektiöser Ikterus"
    ]
  },
  {
    "code": "B16.0",
    "name": "Akute Virushepatitis D mit Coma hepaticum",
    "synonyms": [
      "Akute Virushepatitis D mit Coma hepaticum"
    ]
  },
  {
    "code": "B16.1",
    "name": "Akute Virushepatitis B mit Begleitinfektion durch Delta-Virus ohne Coma hepaticum",
    "synonyms": [
      "Akute Virushepatitis B mit Begleitinfektion durch Delta-Virus ohne Coma hepaticum",
      "Akute Virushepatitis D ohne Coma hepaticum"
    ]
  },
  {
    "code": "B16.9",
    "name": "Akute Hepatitis B",
    "synonyms": [
      "Akute Hepatitis B",
      "Gelbsucht bei akuter Virushepatitis B durch Impfung",
      "Gelbsucht bei akuter Virushepatitis B durch Injektion",
      "Homologe Serumgelbsucht durch akute Virushepatitis B",
      "Homologer Ikterus bei akuter Virushepatitis B durch Serum",
      "Ikterus bei akuter Virushepatitis B durch Impfung",
      "Ikterus bei akuter Virushepatitis B durch Injektion",
      "Ikterus bei akuter Virushepatitis B durch Serum",
      "Serumgelbsucht durch akute Virushepatitis B",
      "Serumhepatitis durch akute Virushepatitis B",
      "Transfusionsgelbsucht durch akute Virushepatitis B",
      "Transfusionsikterus durch akute Virushepatitis B"
    ]
  },
  {
    "code": "B17.0",
    "name": "Akute Infektion mit Delta-Virus eines Hepatitis-B-Virus-Trägers",
    "synonyms": [
      "Akute Delta-Virus-Infektion eines Hepatitis-B-Virus-Trägers",
      "Akute Infektion mit Delta-Virus bei chronischer Hepatitis-B",
      "Akute Infektion mit Delta-Virus eines Hepatitis-B-Virus-Trägers"
    ]
  },
  {
    "code": "B17.1",
    "name": "Akute Virushepatitis C",
    "synonyms": [
      "Akute Virushepatitis C"
    ]
  },
  {
    "code": "B17.2",
    "name": "Virushepatitis E",
    "synonyms": [
      "Akute Virushepatitis E",
      "Hepatitis E",
      "Virushepatitis E"
    ]
  },
  {
    "code": "B17.8",
    "name": "Non-A-Non-B-Hepatitis",
    "synonyms": [
      "Akute Non-A-Non-B-Hepatitis",
      "Non-A-Non-B-Hepatitis",
      "Virushepatitis D",
      "Virushepatitis G"
    ]
  },
  {
    "code": "B17.9",
    "name": "Akute Hepatitis a.n.k.",
    "synonyms": [
      "Akute Hepatitis a.n.k.",
      "Akute Virushepatitis",
      "Akute infektiöse Hepatitis",
      "Hepatitis infectiosa acuta",
      "Hepatitis infectiosa subacuta"
    ]
  },
  {
    "code": "B18.0",
    "name": "Chronische Virushepatitis B mit Delta-Virus",
    "synonyms": [
      "Chronische Virushepatitis B mit Delta-Virus",
      "Chronische Virushepatitis D",
      "Hepatitis B und D"
    ]
  },
  {
    "code": "B18.11",
    "name": "Chronische Virushepatitis B ohne Delta-Virus, Phase 1",
    "synonyms": [
      "Chronische Virushepatitis B ohne Delta-Virus, HBeAg positiv, ohne Entzündungsaktivität, hochreplikativ",
      "Chronische Virushepatitis B ohne Delta-Virus, Phase 1",
      "Chronische Virushepatitis B ohne Delta-Virus, immuntolerante Phase"
    ]
  },
  {
    "code": "B18.12",
    "name": "Chronische Virushepatitis B ohne Delta-Virus, Phase 2",
    "synonyms": [
      "Aktive chronische Virushepatitis B",
      "Chronische Virushepatitis B ohne Delta-Virus, HBeAg positiv, mit Entzündungsaktivität, hochreplikativ",
      "Chronische Virushepatitis B ohne Delta-Virus, Phase 2"
    ]
  },
  {
    "code": "B18.13",
    "name": "Keimträger des HBc-Antigens",
    "synonyms": [
      "Chronische Virushepatitis B ohne Delta-Virus, HBeAg negativ, ohne Entzündungsaktivität, niedrigreplikativ",
      "Chronische Virushepatitis B ohne Delta-Virus, Phase 3",
      "Keimträger des HBc-Antigens",
      "Keimträger des HBs-Antigens",
      "Keimträger des Hepatitis-B-Oberflächen-Antigens [HBsAg]",
      "Keimträger von Hepatitis-Australia-Antigen [HAA]",
      "Überträger von HBc-Antigen",
      "Überträger von HBs-Antigen",
      "Überträger von Hepatitis-Australia-Antigen [HAA]"
    ]
  },
  {
    "code": "B18.14",
    "name": "Chronische Virushepatitis B ohne Delta-Virus, Phase 4",
    "synonyms": [
      "Chronische Virushepatitis B ohne Delta-Virus, HBeAg negativ, mit Entzündungsaktivität, hochreplikativ",
      "Chronische Virushepatitis B ohne Delta-Virus, Phase 4",
      "Reaktivierte Hepatitis B"
    ]
  },
  {
    "code": "B18.19",
    "name": "Hepatitis B",
    "synonyms": [
      "Antigen-assoziierte Hepatitis",
      "Chronische Hepatitis B",
      "Chronische Virushepatitis B",
      "Chronische Virushepatitis B ohne Delta-Virus",
      "HBs-Antigen-assoziierte Hepatitis",
      "HBsAG-positive chronische Hepatitis",
      "Hepatitis B",
      "Hepatitis B mit Nachweis von HBcAG",
      "Hepatitis B mit Nachweis von HBeAG",
      "Hepatitis B mit Nachweis von HBsAG",
      "Hepatitis B ohne Coma hepaticum",
      "Hepatitis B-C",
      "Hepatitis B-E",
      "Hepatitis B-S",
      "Hepatitis mit Australia-Antigen",
      "Virushepatitis B ohne Begleitinfektion durch Delta-Virus"
    ]
  },
  {
    "code": "B18.2",
    "name": "Hepatitis C",
    "synonyms": [
      "Chronische Virushepatitis C",
      "Hepatitis C",
      "Hepatitis C durch Virus"
    ]
  },
  {
    "code": "B18.80",
    "name": "Chronische Virushepatitis E",
    "synonyms": [
      "Chronische Virushepatitis E"
    ]
  },
  {
    "code": "B18.9",
    "name": "Keimträger einer Virushepatitis",
    "synonyms": [
      "Chronische Virushepatitis",
      "Keimträger einer Virushepatitis",
      "Überträger einer Virushepatitis"
    ]
  },
  {
    "code": "B19.0",
    "name": "Virushepatitis mit hepatischem Koma",
    "synonyms": [
      "Virushepatitis mit hepatischem Koma"
    ]
  },
  {
    "code": "B19.9",
    "name": "Inokulationshepatitis",
    "synonyms": [
      "Hepatitis durch Immunisation",
      "Hepatitisinfektion",
      "Homologe Serumhepatitis",
      "Infektiöse Hepatitis",
      "Inokulationshepatitis",
      "Positives Hepatitisantigen",
      "Transfusionshepatitis",
      "Virushepatitis",
      "Vorhandensein von HAV-Antikörpern",
      "Vorhandensein von HBV-Antikörpern",
      "Vorhandensein von HBV-DNA",
      "Vorhandensein von HCV-Antikörpern",
      "Vorhandensein von HCV-RNA"
    ]
  },
  {
    "code": "B20",
    "name": "Mehrere Infektionen bei HIV-Krankheit",
    "synonyms": [
      "HIV-Krankheit mit Papovavirus-Infektion",
      "Mehrere Infektionen bei HIV-Krankheit",
      "Multiple Infektionen bei HIV-Krankheit"
    ]
  },
  {
    "code": "B21",
    "name": "HIV-Krankheit mit bösartiger Neubildung",
    "synonyms": [
      "HIV-Krankheit mit Sarkom a.n.k.",
      "HIV-Krankheit mit bösartiger Neubildung",
      "HIV-Krankheit mit mehreren bösartigen Neubildungen"
    ]
  },
  {
    "code": "B22",
    "name": "Slim disease",
    "synonyms": [
      "HIV-Krankheit mit Gedeihstörung",
      "HIV-Krankheit mit Wasting-Syndrom",
      "HIV-Krankheit mit interstitieller lymphoider Pneumonitis",
      "Slim disease"
    ]
  },
  {
    "code": "B23.0",
    "name": "Akutes HIV-Infektionssyndrom",
    "synonyms": [
      "Akutes HIV-Infektionssyndrom"
    ]
  },
  {
    "code": "B23.8",
    "name": "HIV-Krankheit mit hämatologischer Störung",
    "synonyms": [
      "HIV-Krankheit mit Immunstörung",
      "HIV-Krankheit mit Störung der Immunmechanismen",
      "HIV-Krankheit mit hämatologischer Störung"
    ]
  },
  {
    "code": "B24",
    "name": "AIDS - s.a. HIV-Krankheit oder s.a. Erworbenes Immundefektsyndrom",
    "synonyms": [
      "AIDS - s.a. HIV-Krankheit oder s.a. Erworbenes Immundefektsyndrom",
      "AIDS related complex",
      "AIDS, Infektion",
      "AIDS, Latenzphase",
      "ARC [AIDS related complex]",
      "Acquired immunodeficiency syndrome [AIDS]",
      "Angeborenes AIDS",
      "Erworbenes Immundefektsyndrom [AIDS]",
      "Erworbenes Immundefizitsyndrom [AIDS]",
      "Erworbenes Immunmangelsyndrom [AIDS]",
      "HIV-Krankheit",
      "HTLV [Human T-lymphotropic virus]-LAV [Lymphadenopathie-assoziiertes Virus]-Infektion",
      "Humane Immundefizienz-Viruskrankheit",
      "Immundefektsyndrom [AIDS]",
      "Immunmangelsyndrom [AIDS]",
      "Prä-AIDS [Erworbenes Immundefektsyndrom]",
      "Therapiebedürftige HIV-Infektion"
    ]
  },
  {
    "code": "B25.80",
    "name": "Zytomegalie-Ileitis",
    "synonyms": [
      "Infektion des Verdauungstraktes durch Zytomegalieviren",
      "Zytomegalie-Ileitis"
    ]
  },
  {
    "code": "B25.88",
    "name": "Zytomegalie-Vaskulitis",
    "synonyms": [
      "Angiitis durch Zytomegalieviren",
      "Disseminierte Zytomegalievirus-Infektion bei Immunkompetenz",
      "Vaskulitis durch Zytomegalieviren",
      "Zytomegalie-Angiitis",
      "Zytomegalie-Vaskulitis"
    ]
  },
  {
    "code": "B25.9",
    "name": "Zytomegalie",
    "synonyms": [
      "Ablatio retinae exsudativa bei CMV [Zytomegalievirus]-Krankheit",
      "Cytomegalia infantum",
      "Einschlusskörperchenkrankheit",
      "Einschlusskörperchenkrankheit einer Speicheldrüse",
      "Einschlusskörperchenkrankheit eines Speicheldrüsenganges",
      "Generalisierte zytomegale Einschlusskrankheit",
      "Großzellige Einschlusskörperchenkrankheit",
      "Infektion durch Zytomegalieviren",
      "Infektion durch humanes Herpes-Virus 5",
      "Krankheit durch Zytomegalieviren",
      "Riesenzelleinschlusskrankheit",
      "Virus-Infektion einer Speicheldrüse",
      "Virus-Krankheit einer Speicheldrüse",
      "Virus-Krankheit eines Speicheldrüsenganges",
      "Zytomegale Riesenzelleinschlusskrankheit",
      "Zytomegalie",
      "Zytomegalie-Syndrom",
      "Zytomegalieviren-Infektion"
    ]
  },
  {
    "code": "B26.8",
    "name": "Mumps-Komplikation a.n.k.",
    "synonyms": [
      "Mumps-Komplikation a.n.k."
    ]
  },
  {
    "code": "B26.9",
    "name": "Mumps",
    "synonyms": [
      "Bauerntölpel [Mumps]",
      "Bauernwetzel [Mumps]",
      "Infektiöse Parotitis",
      "Mumps",
      "Mumps ohne Komplikation",
      "Mumps-Parotitis",
      "Parotitis epidemica",
      "Wochendippel [Mumps]",
      "Ziegenpeter",
      "Übertragbare Parotitis"
    ]
  },
  {
    "code": "B27.0",
    "name": "Pfeiffer-Drüsenfieber",
    "synonyms": [
      "Akute epidemische Adenitis",
      "CAEBV [Chronisch-aktive Ebstein-Barr-Virusinfektion]",
      "Chronisch-aktive Ebstein-Barr-Virusinfektion",
      "EBV [Epstein-Barr-Virus]-Infektion",
      "Epstein-Barr-Virus-Infektion",
      "Filatow-Krankheit",
      "Mononukleose durch Epstein-Barr-Viren",
      "Mononukleose durch Gamma-Herpes-Viren",
      "Morbus Pfeiffer",
      "Pfeiffer-Drüsenfieber",
      "Pfeiffer-Krankheit"
    ]
  },
  {
    "code": "B27.1",
    "name": "Mononukleose durch Zytomegalieviren",
    "synonyms": [
      "Mononukleose durch Zytomegalieviren",
      "Zytomegalie-Mononukleose"
    ]
  },
  {
    "code": "B27.9",
    "name": "Mononukleose",
    "synonyms": [
      "Drüsenfieber",
      "Infektiöse Mononukleose a.n.k.",
      "Mononucleosis infectiosa",
      "Mononukleose",
      "Mononukleosesyndrom",
      "Monozytenangina"
    ]
  },
  {
    "code": "B33.0",
    "name": "Pleurodynia epidemica",
    "synonyms": [
      "Bornholmer Krankheit",
      "Epidemische Myalgie",
      "Epidemische Myositis",
      "Epidemische Pleurodynie",
      "Epidemischer Schluckauf",
      "Epidemischer Singultus",
      "Myalgia cervicalis epidemica",
      "Myalgia epidemica",
      "Pleurodynia epidemica",
      "Pleurodynie durch Coxsackieviren",
      "Sylvest-Bornholm-Syndrom",
      "Teufelsgriff",
      "Virale Pleurodynie",
      "Zervikale epidemische Myalgie"
    ]
  },
  {
    "code": "B33.1",
    "name": "Ross-River-Krankheit",
    "synonyms": [
      "Epidemische Polyarthritis",
      "Epidemische Polyarthropathie mit Exanthem",
      "Epidemisches Exanthem",
      "Ross-River-Fieber",
      "Ross-River-Krankheit"
    ]
  },
  {
    "code": "B33.3",
    "name": "Infektion durch humanes T-Zell-lymphotropes Virus Typ I",
    "synonyms": [
      "Infektion durch Retroviren a.n.k.",
      "Infektion durch humanes T-Zell-lymphotropes Virus Typ I",
      "Krankheit durch humanes T-Zell-lymphotropes Virus Typ I"
    ]
  },
  {
    "code": "B33.8",
    "name": "Parapoliomyelitis",
    "synonyms": [
      "Akute infektiöse Lymphozytose",
      "Aujeszky-Krankheit",
      "Hendra-Virus-Infektion",
      "Lymphocytosis infectiosa acuta",
      "Parapoliomyelitis",
      "Sommergrippe",
      "Tahyna-Fieber"
    ]
  },
  {
    "code": "B34.0",
    "name": "Adenoviren-Infektion",
    "synonyms": [
      "Adenoviren-Infektion"
    ]
  },
  {
    "code": "B34.1",
    "name": "ECHO-Virus-Infektion",
    "synonyms": [
      "Coxsackievirus-Infektion",
      "Coxsackievirus-Krankheit a.n.k.",
      "ECHO-Virus-Infektion",
      "ECHO-Virus-Krankheit a.n.k.",
      "Enteroviren-Krankheit a.n.k.",
      "Infektion durch Enteroviren a.n.k.",
      "Infektion durch Rhinoviren"
    ]
  },
  {
    "code": "B34.2",
    "name": "Infektion durch MERS-Coronavirus",
    "synonyms": [
      "Infektion durch Coronaviren a.n.k.",
      "Infektion durch MERS-CoV",
      "Infektion durch MERS-Coronavirus",
      "Infektion durch Middle-East-Respiratory-Syndrome-Coronavirus"
    ]
  },
  {
    "code": "B34.3",
    "name": "Infektion durch Parvoviren a.n.k.",
    "synonyms": [
      "Infektion durch Parvoviren a.n.k."
    ]
  },
  {
    "code": "B34.4",
    "name": "Infektion durch Papovaviren a.n.k.",
    "synonyms": [
      "BK-Virus-Infektion",
      "Infektion durch Papovaviren a.n.k.",
      "Infektion durch Polyomaviren"
    ]
  },
  {
    "code": "B34.80",
    "name": "Sepsis durch Viren",
    "synonyms": [
      "Sepsis durch Viren"
    ]
  },
  {
    "code": "B34.88",
    "name": "Infektion durch Parainfluenzaviren",
    "synonyms": [
      "Infektion durch Parainfluenzaviren"
    ]
  },
  {
    "code": "B34.9",
    "name": "Virämie",
    "synonyms": [
      "Fieberhafte Virusinfektion",
      "Hochfieberhafte Virusinfektion",
      "Rezidivierende Virusinfektion",
      "Virale Allgemeininfektion",
      "Virale Infektion",
      "Virose",
      "Virusinfekt",
      "Virusinfektion a.n.k.",
      "Viruskrankheit",
      "Virämie"
    ]
  },
  {
    "code": "B35.0",
    "name": "Tinea barbae",
    "synonyms": [
      "Bartdermatophytose [Dermatophytie]",
      "Bartmykose",
      "Favus capitis",
      "Herpes tonsurans",
      "Kerion",
      "Kerion Celsi",
      "Kopfflechte",
      "Kopfgrind",
      "Kopfhautdermatophytose [Dermatophytie]",
      "Kopfmykose",
      "Mycosis barbae",
      "Mycosis capillitii",
      "Mykotische Sycosis contagiosa",
      "Mykotische Sykose",
      "Parasitäre Bartflechte",
      "Parasitäre Sykose",
      "Periorale Flechte",
      "Pilzinfektion der Kopfhaut",
      "Pilzinfektion des Bartes",
      "Pilzinfektion des Kopfes",
      "Sycosis parasitaria",
      "Tinea barbae",
      "Tinea capillitii",
      "Tinea capitis",
      "Tinea der Kopfhaut",
      "Tinea des Bartes",
      "Tinea des Gesichts",
      "Tinea faciei",
      "Tinea mit Sykose",
      "Tinea tonsurans",
      "Trichophytia capitis"
    ]
  },
  {
    "code": "B35.1",
    "name": "Nageldermatophytose [Dermatophytie]",
    "synonyms": [
      "Nageldermatophytose [Dermatophytie]",
      "Nagelmykose",
      "Nagelpilz",
      "Onychie durch Dermatophyten",
      "Onychomykose",
      "Onychomykose der Finger",
      "Onychomykose einer Zehe",
      "Pilzbefall des Nagels",
      "Pilzinfektion eines Nagels",
      "Pilzinfektion eines Zehennagels",
      "Tinea unguium",
      "Trichophytosis unguium"
    ]
  },
  {
    "code": "B35.2",
    "name": "Tinea manuum",
    "synonyms": [
      "Ekzematöse Tinea manuum",
      "Fingermykose",
      "Handdermatophytose [Dermatophytie]",
      "Handflechte",
      "Handmykose",
      "Handpilz",
      "Interdigitale Pilzinfektion der Hand",
      "Interdigitalmykose der Hand",
      "Interphalangeale Mykose der Hand",
      "Pilzinfektion der Hand",
      "Tinea interdigitalis der Hand",
      "Tinea manuum"
    ]
  },
  {
    "code": "B35.3",
    "name": "Tinea pedis",
    "synonyms": [
      "Fußdermatophytose [Dermatophytie]",
      "Fußflechte",
      "Fußinfektion durch Dermatophyten",
      "Fußmykose",
      "Fußpilz",
      "Hackenmykose",
      "Hyperkeratotische Fußmykose",
      "Interdigitale Pilzinfektion des Fußes",
      "Interdigitalmykose des Fußes",
      "Interphalangeale Fußmykose",
      "Mykotische Fußflechte",
      "Pilzinfektion des Fußes",
      "Plantarmykose",
      "Tinea der Fußsohle",
      "Tinea des Fußes",
      "Tinea interdigitalis des Fußes",
      "Tinea intertriginosa pedis",
      "Tinea pedis",
      "Tinea plantaris",
      "Unterschenkelmykose",
      "Zehenzwischenraummykose",
      "Zwischenzehenmykose"
    ]
  },
  {
    "code": "B35.4",
    "name": "Tinea corporis",
    "synonyms": [
      "Dermatomycosis corporis",
      "Dermatomykose des Körpers",
      "Dermatophytose [Dermatophytie] des Körpers",
      "Herpes circinatus",
      "Herpes tonsurans corporis",
      "Körpermykose",
      "Mycosis corporis",
      "Pilzbefall des Körpers",
      "Pilzinfektion des Körpers",
      "Tinea circinata",
      "Tinea corporis",
      "Tinea corporis superficialis",
      "Tinea tropica"
    ]
  },
  {
    "code": "B35.5",
    "name": "Tinea imbricata",
    "synonyms": [
      "Malabar-Flechte",
      "Tinea imbricata",
      "Tokelau"
    ]
  },
  {
    "code": "B35.6",
    "name": "Inguinalmykose",
    "synonyms": [
      "Analmykose",
      "Dermatophytia inguinalis",
      "Dermatophytose [Dermatophytie] der Leistengegend und des perianalen Bezirks",
      "Dhobie itch",
      "Ekzema marginatum",
      "Indische Wäscherflechte",
      "Inguinale Epidermatophytose [Epidermatophytie]",
      "Inguinalmykose",
      "Jock itch",
      "Leistendermatophytose [Dermatophytie]",
      "Leistenmykose",
      "Mykose der Leistenbeuge",
      "Perianale Dermatophytose [Dermatophytie]",
      "Perianale Pilzinfektion",
      "Perianalmykose",
      "Pilzinfektion der Leiste",
      "Tinea cruris",
      "Tinea inguinalis",
      "Tinea perianalis"
    ]
  },
  {
    "code": "B35.8",
    "name": "Skrotummykose",
    "synonyms": [
      "Disseminierte Dermatophytose [Dermatophytie]",
      "Granuloma trichophyticum",
      "Granulomatöse Dermatophytose [Dermatophytie]",
      "Majocchi-Granulom",
      "Nabelmykose",
      "Skrotummykose",
      "Superinfizierte Tinea",
      "Tiefe Dermatophytose",
      "Tiefsitzende Dermatophytose [Dermatophytie]",
      "Tinea axillaris",
      "Tinea genitalis",
      "Tinea manuum et pedum",
      "Trichophytia profunda"
    ]
  },
  {
    "code": "B35.9",
    "name": "Mikrosporie",
    "synonyms": [
      "Dermatomycosis favosa",
      "Dermatophytose [Dermatophytie]",
      "Dermatophytose [Dermatophytie] durch Epidermophyton",
      "Dermatophytose [Dermatophytie] durch Mikrosporum",
      "Dermatophytose [Dermatophytie] durch Trichophyton",
      "Epidermatophytose [Epidermatophytie]",
      "Erbgrind",
      "Favus",
      "Follikuläre Mykose",
      "Grind",
      "Infektion durch Epidermophyton",
      "Infektion durch Mikrosporum",
      "Infektion durch Trichophyton",
      "Infektiöse Dermatophytose [Dermatophytie]",
      "Interdigitale Pilzinfektion",
      "Interdigitalmykose",
      "Interphalangeale Mykose",
      "Mikrosporie",
      "Mikrosporosis",
      "Pilzflechte",
      "Pilzgrind",
      "Porrigo favosa",
      "Scherpilzflechte",
      "Tinea",
      "Tinea durch Mikrosporum",
      "Tinea durch Trichophyton",
      "Tinea favosa",
      "Tinea interdigitalis",
      "Tinea intersecta",
      "Tinea intertriginosa",
      "Trichophytia follicularis",
      "Trichophytia superficialis",
      "Trichophytie",
      "Trichophytose"
    ]
  },
  {
    "code": "B36.0",
    "name": "Pityriasis versicolor",
    "synonyms": [
      "Chromophytose",
      "Dermatomycosis furfuracea",
      "Infektion durch Malassezia furfur",
      "Infektion durch Microsporum furfur",
      "Kleienpilzflechte",
      "Pityriasis furfuracea",
      "Pityriasis versicolor",
      "Tinea flava",
      "Tinea versicolor"
    ]
  },
  {
    "code": "B36.1",
    "name": "Keratomycosis nigricans",
    "synonyms": [
      "Cladosporiose",
      "Infektion durch Cladosporium castellani",
      "Infektion durch Cladosporium werneckii",
      "Keratomycosis nigrans",
      "Keratomycosis nigricans",
      "Keratomycosis nigricans palmaris",
      "Kladosporiose",
      "Mikrosporosis nigra",
      "Pityriasis nigra",
      "Tinea nigra"
    ]
  },
  {
    "code": "B36.2",
    "name": "Piedra alba",
    "synonyms": [
      "Infektion durch Trichosporon",
      "Piedra alba",
      "Tinea blanca",
      "Trichosporonosis nodosa",
      "Weiße Piedra"
    ]
  },
  {
    "code": "B36.3",
    "name": "Piedra nigra",
    "synonyms": [
      "Infektion durch Piedraia hortae",
      "Piedra nigra",
      "Schwarze Haarknötchen-Krankheit",
      "Schwarze Piedra"
    ]
  },
  {
    "code": "B36.8",
    "name": "Trichomycosis nodosa",
    "synonyms": [
      "Beigel-Krankheit",
      "Chignon-Krankheit",
      "Dermatomykose im Windelbereich",
      "Paxton-Krankheit",
      "Piedra",
      "Tinea nodosa",
      "Trichomycosis nodosa",
      "Trichomycosis nodularis"
    ]
  },
  {
    "code": "B36.9",
    "name": "Trockenflechte",
    "synonyms": [
      "Dermatomycosis",
      "Dermatomykose a.n.k.",
      "Ekzematisierte Mykose",
      "Epidermale Mykose",
      "Epidermomykose",
      "Flechte",
      "Fungus-Dermatitis",
      "Hautmykose",
      "Hautpilz",
      "Hautpilzinfektion",
      "Hautpilzkrankheit",
      "Intertriginöse Mykose",
      "Intertrigo-Mykose",
      "Mykotische Hautinfektion a.n.k.",
      "Mykotisches Ekzem",
      "Oberflächliche Mykose a.n.k.",
      "Oberflächliche Pilzinfektion",
      "Pilzekzem",
      "Rezidivierende Genitalmykose",
      "Trockenflechte"
    ]
  },
  {
    "code": "B37.0",
    "name": "Candida-Glossitis",
    "synonyms": [
      "Aphthöser Soor",
      "Candida-Glossitis",
      "Candida-Mykose des Mundes",
      "Candida-Stomatitis",
      "Glossitis mycotica",
      "Mundkandidose",
      "Mundmykose",
      "Mundpilz",
      "Mundschleimhautkandidose",
      "Mundschleimhautsoor",
      "Mundsoor",
      "Mykotische Stomatitis",
      "Orale Kandidose",
      "Oralsoor",
      "Parasitäre Mundkrankheit a.n.k.",
      "Parasitäre Stomatitis",
      "Parasitäre Zungeninfektion",
      "Parasitäre Zungenkrankheit a.n.k.",
      "Pilzbefall der Zunge",
      "Soorglossitis",
      "Soorstomatitis",
      "Stomatitis bei Moniliasis",
      "Stomatitis candidomycetica",
      "Stomatomykose"
    ]
  },
  {
    "code": "B37.1",
    "name": "Candida-Pleuritis",
    "synonyms": [
      "Candida-Pleuritis"
    ]
  },
  {
    "code": "B37.2",
    "name": "Soordermatitis",
    "synonyms": [
      "Candida-Ekzem",
      "Erosio interdigitalis blastomycetica",
      "Granulomatöse Moniliasis der Haut",
      "Hautgranulom durch Candida",
      "Hautkandidose",
      "Hautsoor",
      "Intertriginöse Kandidose",
      "Intertriginöser Soor",
      "Intertrigo-Kandidose",
      "Nagelkandidose",
      "Onychie durch Candidaarten",
      "Onychie durch Kandidose",
      "Onychomykose durch Candida",
      "Paronychie durch Candida",
      "Paronychie durch Kandidose",
      "Perionychie durch Kandidose",
      "Soor des Gesäßes",
      "Soor mit Windeldermatitis",
      "Soordermatitis",
      "Soorekzem",
      "Soorintertrigo",
      "Submammäre Kandidose",
      "Windelpilz",
      "Windelsoor"
    ]
  },
  {
    "code": "B37.4",
    "name": "Genitalsoor",
    "synonyms": [
      "Anogenitale Kandidose",
      "Anogenitaler Soor",
      "Genitale Kandidose",
      "Genitale Soormykose",
      "Genitalsoor",
      "Kandidose des Urogenitaltraktes a.n.k.",
      "Soorinfektion des Genitalbereiches",
      "Urogenitale Kandidose",
      "Urogenitaler Soor"
    ]
  },
  {
    "code": "B37.7",
    "name": "Candida-Sepsis",
    "synonyms": [
      "Candida-Sepsis",
      "Sepsis durch Kandidose",
      "Soorsepsis"
    ]
  },
  {
    "code": "B37.81",
    "name": "Soorösophagitis",
    "synonyms": [
      "Candida-Ösophagitis",
      "Soorösophagitis"
    ]
  },
  {
    "code": "B37.88",
    "name": "Perianalkandidose",
    "synonyms": [
      "Anale Kandidose",
      "Analsoor",
      "Candida-Bronchiolitis",
      "Candida-Bronchitis",
      "Candida-Cheilitis",
      "Candida-Cholezystitis",
      "Candida-Duodenitis",
      "Candida-Enteritis",
      "Candida-Enterokolitis",
      "Candida-Gastroenteritis",
      "Candida-Hepatitis",
      "Candida-Kolitis",
      "Candida-Lymphadenitis",
      "Candida-Mykose des Rachens",
      "Candida-Myositis",
      "Candida-Osteomyelitis",
      "Candida-Pharyngitis",
      "Candida-Splenitis",
      "Candida-Tonsillitis",
      "Candida-Tracheitis",
      "Candida-Vaskulitis",
      "Candidosis disseminata",
      "Candidosis intestinalis",
      "Chronische mukokutane Candidose",
      "Disseminierte Kandidose",
      "Dysenterie durch Candida",
      "Enteritis durch Candidaarten",
      "Gastrointestinale Candida-Mykose",
      "Intestinale Kandidose",
      "Levurose",
      "Monilia-Dysenterie",
      "Perianalkandidose",
      "Perlèche durch Moniliasis a.n.k.",
      "Perlèche-Kandidose",
      "Soor des Rachens",
      "Soorbronchiolitis",
      "Soorduodenitis",
      "Soorenteritis",
      "Soorgastritis",
      "Soorgastroenteritis",
      "Soorkolitis",
      "Soorlaryngitis",
      "Soorpharyngitis",
      "Soortonsillitis",
      "Soortracheitis",
      "Systemkandidose"
    ]
  },
  {
    "code": "B37.9",
    "name": "Candida-Abszess",
    "synonyms": [
      "Candida-Abszess",
      "Candida-Befall",
      "Candida-Infektion",
      "Candida-Mykose",
      "Candida-Superinfektion",
      "Candidiasis",
      "Candidosis - s.a. Kandidose oder s.a. Candidiasis",
      "Hefe-Infektion",
      "Hefe-Mykose",
      "Hefepilz-Erkrankung",
      "Hefepilz-Infektion",
      "Infektion durch tropische Candida albicans",
      "Invasive Candida-Infektion",
      "Kandidose",
      "Kandidose durch Candida auris",
      "Levurinosis",
      "Monilia-Infektion",
      "Moniliasis",
      "Postantibiotischer Soor",
      "Soor",
      "Soorinfektion",
      "Soormykose"
    ]
  },
  {
    "code": "B38.70",
    "name": "Sepsis durch Coccidioides",
    "synonyms": [
      "Sepsis durch Coccidioides"
    ]
  },
  {
    "code": "B38.78",
    "name": "Disseminierte Kokzidioidomykose",
    "synonyms": [
      "Disseminierte Kokzidioidomykose",
      "Generalisierte Kokzidioidomykose",
      "Kokzidioidales Granulom",
      "Primäres progressives kokzidioidales Granulom"
    ]
  },
  {
    "code": "B38.9",
    "name": "Kokzidioidomykose",
    "synonyms": [
      "Coccidioides-Infektion",
      "Infektion durch Coccidioides immitis",
      "Kokzidioidomykose",
      "Kokzidioidose",
      "Wiesenfieber"
    ]
  },
  {
    "code": "B39.30",
    "name": "Sepsis durch Histoplasma capsulatum",
    "synonyms": [
      "Sepsis durch Histoplasma capsulatum"
    ]
  },
  {
    "code": "B39.38",
    "name": "Disseminierte Histoplasmose durch Histoplasma capsulatum",
    "synonyms": [
      "Disseminierte Histoplasmose durch Histoplasma capsulatum",
      "Generalisierte Histoplasmose durch Histoplasma capsulatum"
    ]
  },
  {
    "code": "B39.4",
    "name": "Darling-Krankheit",
    "synonyms": [
      "Abortive Histoplasmose",
      "Amerikanische Histoplasmose",
      "Darling-Histoplasmose",
      "Darling-Krankheit",
      "Histoplasmose durch Histoplasma capsulatum",
      "Infektion durch Histoplasma capsulatum",
      "Retikuloendotheliale Zytomykose",
      "Zytomykose"
    ]
  },
  {
    "code": "B39.5",
    "name": "Histoplasmose durch Histoplasma duboisii",
    "synonyms": [
      "Afrikanische Histoplasmose",
      "Histoplasmose durch Histoplasma duboisii",
      "Infektion durch Histoplasma duboisii"
    ]
  },
  {
    "code": "B39.9",
    "name": "Histoplasmose",
    "synonyms": [
      "Histoplasmose",
      "Infektion durch Histoplasma",
      "Larynxhistoplasmose",
      "Nasenhistoplasmose"
    ]
  },
  {
    "code": "B40.70",
    "name": "Sepsis durch Blastomyces",
    "synonyms": [
      "Sepsis durch Blastomyces"
    ]
  },
  {
    "code": "B40.78",
    "name": "Disseminierte Blastomykose",
    "synonyms": [
      "Disseminierte Blastomykose",
      "Generalisierte Blastomykose"
    ]
  },
  {
    "code": "B40.9",
    "name": "Nordamerikanische Blastomykose",
    "synonyms": [
      "Blastomycosis",
      "Blastomykose",
      "Blastomykotische Infektion",
      "Chicago-Krankheit",
      "Gilchrist-Krankheit",
      "Infektion durch Blastomyces",
      "Infektion durch Blastomyces dermatitidis",
      "Nordamerikanische Blastomykose"
    ]
  },
  {
    "code": "B41.70",
    "name": "Sepsis durch Paracoccidioides",
    "synonyms": [
      "Sepsis durch Paracoccidioides"
    ]
  },
  {
    "code": "B41.78",
    "name": "Disseminierte Parakokzidioidomykose",
    "synonyms": [
      "Disseminierte Parakokzidioidomykose",
      "Generalisierte Parakokzidioidomykose"
    ]
  },
  {
    "code": "B41.8",
    "name": "Granuloma paracoccidioides",
    "synonyms": [
      "Granuloma paracoccidioides",
      "Mukokutan-lymphangitische Parakokzidioidomykose",
      "Parakokzidioidales Granulom",
      "Viszerale Parakokzidioidomykose"
    ]
  },
  {
    "code": "B41.9",
    "name": "Parakokzidioidomykose",
    "synonyms": [
      "Brasilianische Blastomykose",
      "Brasilianisches Granulom",
      "Costa-Rica-Blastomykose",
      "De-Almeida-Krankheit",
      "Granuloma brasiliensis",
      "Infektion durch Blastomyces brasiliensis",
      "Infektion durch Paracoccidioides brasiliensis",
      "Lutz-Splendore-de-Almeida-Krankheit",
      "Paracoccidioidosis brasiliensis",
      "Parakokzidioidomykose",
      "Parakokzidioidose",
      "Südamerikanische Blastomykose"
    ]
  },
  {
    "code": "B42.1",
    "name": "Lymphokutane Sporotrichose",
    "synonyms": [
      "De-Beurmann-Krankheit",
      "Lymphokutane Sporotrichose",
      "Schenk-Krankheit"
    ]
  },
  {
    "code": "B42.70",
    "name": "Sepsis durch Sporothrix",
    "synonyms": [
      "Sepsis durch Sporothrix"
    ]
  },
  {
    "code": "B42.78",
    "name": "Disseminierte Sporotrichose",
    "synonyms": [
      "Disseminierte Sporotrichose",
      "Generalisierte Sporotrichose"
    ]
  },
  {
    "code": "B42.9",
    "name": "Sporotrichose",
    "synonyms": [
      "Infektion durch Sporothrix schenckii",
      "Infektion durch Sporotrichon",
      "Rhinocladium-Infektion",
      "Sporotrichose"
    ]
  },
  {
    "code": "B43.0",
    "name": "Infektion durch Phialophora verrucosa",
    "synonyms": [
      "Infektion durch Phialophora verrucosa"
    ]
  },
  {
    "code": "B43.8",
    "name": "Fungi-imperfecti-Infektion",
    "synonyms": [
      "Fungi-imperfecti-Infektion",
      "Infektion durch Drechslera hawaiiensis"
    ]
  },
  {
    "code": "B43.9",
    "name": "Chromomykose",
    "synonyms": [
      "Chappa",
      "Chromoblastomykose",
      "Chromomykose",
      "Figueira [Form der Chromomykose]",
      "Pedroso-Krankheit",
      "Phaeohyphomycosis",
      "Phäohyphomykose",
      "Phäomykose"
    ]
  },
  {
    "code": "B44.1",
    "name": "Aspergillusabszess der Lunge",
    "synonyms": [
      "Aspergillusabszess der Lunge",
      "Bronchopulmonale Aspergillose"
    ]
  },
  {
    "code": "B44.70",
    "name": "Aspergillus-Sepsis",
    "synonyms": [
      "Aspergillus-Sepsis",
      "Aspergillus-Septikopyämie"
    ]
  },
  {
    "code": "B44.78",
    "name": "Disseminierte Aspergillose",
    "synonyms": [
      "Disseminierte Aspergillose",
      "Generalisierte Aspergillose"
    ]
  },
  {
    "code": "B44.8",
    "name": "Aspergillus-Glossitis",
    "synonyms": [
      "Aspergillose des ZNS",
      "Aspergillus-Glossitis",
      "Aspergillus-Granulom",
      "Aspergillus-Pleuritis",
      "Aspergillus-Splenitis",
      "Aspergillus-Tracheitis",
      "Aspergillus-Vaskulitis",
      "Zerebrale Aspergillose"
    ]
  },
  {
    "code": "B44.9",
    "name": "Aspergillose",
    "synonyms": [
      "Aspergillom",
      "Aspergillose",
      "Aspergillus-Infektion",
      "Aspergillus-flavus-Infektion",
      "Aspergillus-fumigatus-Infektion",
      "Aspergillus-terreus-Infektion",
      "Invasive Aspergillose"
    ]
  },
  {
    "code": "B45.70",
    "name": "Sepsis durch Cryptococcus",
    "synonyms": [
      "Sepsis durch Cryptococcus"
    ]
  },
  {
    "code": "B45.78",
    "name": "Disseminierte Kryptokokkose",
    "synonyms": [
      "Disseminierte Kryptokokkose",
      "Generalisierte Kryptokokkose"
    ]
  },
  {
    "code": "B45.8",
    "name": "Adrenalitis durch Kryptokokken",
    "synonyms": [
      "Adrenalitis durch Kryptokokken",
      "Lymphadenitis durch Kryptokokken",
      "Myokarditis durch Kryptokokken",
      "Nephritis durch Kryptokokken",
      "Parathyreoiditis durch Kryptokokken",
      "Sialadenitis durch Kryptokokken",
      "Thyreoiditis durch Kryptokokken"
    ]
  },
  {
    "code": "B45.9",
    "name": "Kryptokokkose",
    "synonyms": [
      "Cryptococcosis - s.a. Kryptokokkose",
      "Europäische Blastomykose",
      "Infektion durch Cryptococcus neoformans",
      "Infektion durch Kryptokokken",
      "Infektion durch Torula histolytica",
      "Kryptokokkose",
      "Kryptokokkose durch Cryptococcus neoformans",
      "Torulose",
      "Torulosis"
    ]
  },
  {
    "code": "B46.40",
    "name": "Sepsis durch Mucorales",
    "synonyms": [
      "Sepsis durch Mucorales"
    ]
  },
  {
    "code": "B46.48",
    "name": "Disseminierte Mukormykose",
    "synonyms": [
      "Disseminierte Mukormykose",
      "Generalisierte Mukormykose"
    ]
  },
  {
    "code": "B46.5",
    "name": "Mukormykose",
    "synonyms": [
      "Infektion durch Absidia",
      "Infektion durch Cunninghamella",
      "Infektion durch Rhizopus",
      "Mucor-Infektion",
      "Mukormykose",
      "Orbitamukormykose"
    ]
  },
  {
    "code": "B46.8",
    "name": "Entomophthoro-Mykose",
    "synonyms": [
      "Entomophthoro-Mykose",
      "Infektion durch Basidiobolus",
      "Infektion durch Conidiobolus",
      "Infektion durch Entomophthora"
    ]
  },
  {
    "code": "B46.9",
    "name": "Phykomykose",
    "synonyms": [
      "Phykomykose",
      "Phykomyzetose",
      "Zygomykose"
    ]
  },
  {
    "code": "B47.0",
    "name": "Eumyzetom",
    "synonyms": [
      "Ascomycetes-Infektion",
      "Deuteromycetes-Infektion",
      "Eumyzetom",
      "Infektion durch Acremonium falciforme",
      "Infektion durch Cephalosporium falciforme",
      "Infektion durch Leptosphaeria senegalensis",
      "Infektion durch Madurella grisea",
      "Infektion durch Madurella mycetomi",
      "Infektion durch Neotestudina rosatii",
      "Infektion durch Pyrenochaeta romeroi",
      "Maduramykose",
      "Maduramykotisches Myzetom",
      "Mykotischer Madurafuß",
      "Mykotisches Fußmyzetom",
      "Mykotisches Myzetom"
    ]
  },
  {
    "code": "B47.1",
    "name": "Aktinomyzetom",
    "synonyms": [
      "Actinomadura-Infektion",
      "Aktinomykotisches Fußmyzetom",
      "Aktinomykotisches Myzetom",
      "Aktinomyzetom",
      "Aktinomyzetom des Fußes",
      "Infektion durch Streptomyces",
      "Myzetom durch Aktinomyzeten",
      "Myzetom durch Nocardia",
      "Streptomykose"
    ]
  },
  {
    "code": "B47.9",
    "name": "Madurafuß",
    "synonyms": [
      "Fußmyzetom",
      "Madurafuß",
      "Maduramyzetom a.n.k.",
      "Mycetoma",
      "Mycetoma pedis",
      "Myzetom",
      "Phykomyzetom",
      "Pilzmyzetom"
    ]
  },
  {
    "code": "B48.0",
    "name": "Keloid-Blastomykose",
    "synonyms": [
      "Blastomycosis queloidana",
      "Glenosporella-Infektion",
      "Infektion durch Loboa loboi",
      "Keloid-Blastomykose",
      "Lobo-Krankheit",
      "Lobomykose"
    ]
  },
  {
    "code": "B48.1",
    "name": "Rhinosporidiose",
    "synonyms": [
      "Infektion durch Rhinosporidium seeberi",
      "Rhinosporidiose"
    ]
  },
  {
    "code": "B48.2",
    "name": "Allescheriose",
    "synonyms": [
      "Allescheriose",
      "Allescheriosis",
      "Infektion durch Allescheria boydii",
      "Infektion durch Petriellidium boydii",
      "Infektion durch Pseudallescheria boydii",
      "Infektion durch Scedosporium",
      "Petriellidosis"
    ]
  },
  {
    "code": "B48.3",
    "name": "Geotrichose",
    "synonyms": [
      "Geotrichose",
      "Infektion durch Geotrichum candidum",
      "Lungengeotrichose",
      "Stomatitis durch Geotricha"
    ]
  },
  {
    "code": "B48.4",
    "name": "Penicilliosis",
    "synonyms": [
      "Penicilliosis",
      "Penizilliose"
    ]
  },
  {
    "code": "B48.7",
    "name": "Gelegenheitsmykose",
    "synonyms": [
      "Alternaria-Infektion",
      "Fusariose",
      "Fusarium-Infektion",
      "Gelegenheitsmykose",
      "Mykose durch opportunistisch-pathogene Pilze",
      "Opportunistische Mykose",
      "Scopulariopsis-Infektion"
    ]
  },
  {
    "code": "B48.80",
    "name": "Pilzsepsis",
    "synonyms": [
      "Pilzsepsis",
      "Sepsis durch Pilze"
    ]
  },
  {
    "code": "B48.88",
    "name": "Adiaspiromykose",
    "synonyms": [
      "Adiaspiromykose",
      "Hemisporose",
      "Phytose",
      "Pilzinfektion des Sputums"
    ]
  },
  {
    "code": "B49",
    "name": "Genitalmykose",
    "synonyms": [
      "Fungämie a.n.k.",
      "Genitale Pilzkrankheit",
      "Genitalmykose",
      "Harnröhrenmykose",
      "Harntrakt-Pilzkrankheit",
      "Harntraktmykose",
      "Harnwegsmykose",
      "Infektion durch Mycelium a.n.k.",
      "Infektion durch Myzel a.n.k.",
      "Mycosis a.n.k. - s.a. Mykose",
      "Mykose - s.a. Mycosis",
      "Mykose der weiblichen Genitalien",
      "Mykotische Infektion a.n.k.",
      "Pilzbefall",
      "Pilzinfektion a.n.k.",
      "Pilzinfektion des Ohres",
      "Pilzkrankheit",
      "Superinfizierte Mykose",
      "Systemmykose",
      "Uromykose"
    ]
  },
  {
    "code": "B50.8",
    "name": "Schwarzwasserfieber",
    "synonyms": [
      "Biliöses Fieber mit Hämoglobinurie",
      "Blackwater fever",
      "Febris biliosa",
      "Febris haemoglobinurica",
      "Haemoglobinurica malarica",
      "Komplikation der Malaria tropica",
      "Malaria biliosa",
      "Malaria falciparum mit Komplikation a.n.k.",
      "Malaria mit Hämaturie",
      "Malaria mit Hämoglobinurie",
      "Malaria mit Schwarzwasserfieber",
      "Malaria-Melanose",
      "Perniciosa haemoglobinurica",
      "Schwarzwasserfieber",
      "Schwere Form der Malaria falciparum",
      "Schwere Form der Malaria tropica",
      "Westafrikanisches Fieber"
    ]
  },
  {
    "code": "B50.9",
    "name": "Malaria tropica",
    "synonyms": [
      "Bösartige Malaria tertiana",
      "Febris quotidiana",
      "Infektion durch Plasmodium falciparum",
      "Malaria algida",
      "Malaria durch Plasmodium falciparum a.n.k.",
      "Malaria falciparum",
      "Malaria quotidiana",
      "Malaria tertiana maligna",
      "Malaria tropica",
      "Malaria tropica durch Plasmodium falciparum",
      "Panama-Fieber",
      "Perniziöses intermittierendes Fieber",
      "Subtertian-Malaria",
      "Ästivo-Autumnalfieber"
    ]
  },
  {
    "code": "B51.8",
    "name": "Malaria vivax mit Komplikationen a.n.k.",
    "synonyms": [
      "Malaria vivax mit Komplikationen a.n.k."
    ]
  },
  {
    "code": "B51.9",
    "name": "Malaria tertiana",
    "synonyms": [
      "Febris tertiana",
      "Gutartige Malaria tertiana",
      "Infektion durch Plasmodium vivax a.n.k.",
      "Malaria durch Plasmodium vivax a.n.k.",
      "Malaria tertiana",
      "Malaria tertiana durch Plasmodium vivax",
      "Malaria tertiana ohne Komplikation",
      "Malaria vivax",
      "Tertiana"
    ]
  },
  {
    "code": "B52.9",
    "name": "Malaria quartana",
    "synonyms": [
      "Febris quartana",
      "Infektion durch Plasmodium malariae",
      "Malaria durch Plasmodium malariae a.n.k.",
      "Malaria malariae",
      "Malaria quartana",
      "Malaria quartana durch Plasmodium malariae",
      "Malaria quartana ohne Komplikation",
      "Quartana",
      "Viertage-Fieber"
    ]
  },
  {
    "code": "B53.0",
    "name": "Malaria durch Plasmodium ovale",
    "synonyms": [
      "Fieber durch Plasmodium ovale",
      "Infektion durch Plasmodium ovale",
      "Malaria durch Plasmodium ovale",
      "Malaria ovale"
    ]
  },
  {
    "code": "B53.1",
    "name": "Malaria durch Affen-Plasmodien",
    "synonyms": [
      "Malaria durch Affen-Plasmodien"
    ]
  },
  {
    "code": "B53.8",
    "name": "Therapeutische Malaria-Infektion",
    "synonyms": [
      "Impfmalaria",
      "Künstliche Malaria",
      "Malaria durch Mischinfektion",
      "Parasitologisch bestätigte Malaria",
      "Therapeutische Malaria-Infektion"
    ]
  },
  {
    "code": "B54",
    "name": "Malaria",
    "synonyms": [
      "Febris intermittens bei Malaria",
      "Fieber mit Schüttelfrost in Malaria-Gebieten",
      "Intermittierendes Fieber bei Malaria",
      "Intestinales Fieber bei Malaria",
      "Kachexie bei Malaria",
      "Kamerun-Fieber",
      "Klinisch diagnostizierte Malaria ohne parasitologische Bestätigung",
      "Korsika-Fieber",
      "Malaria",
      "Malaria recurrens",
      "Malaria-Rückfall",
      "Malariafieber",
      "Malarialeber",
      "Marschfieber",
      "Paludale Kachexie",
      "Paludales Fieber",
      "Paludismus",
      "Remittierende Malaria",
      "Remittierendes Fieber bei Malaria",
      "Schüttelfrost in Malaria-Regionen",
      "Sumpffieber",
      "Tropenleber bei Malaria",
      "Wechselfieber"
    ]
  },
  {
    "code": "B55.0",
    "name": "Viszerale Leishmaniose",
    "synonyms": [
      "Assam-Fieber",
      "Burdwan-Fieber",
      "Dumdum-Fieber",
      "Dysenterische Leishmaniose",
      "Hautbefall nach Kala-Azar",
      "Hautleishmaniose post Kala-Azar",
      "Hautleishmanoid post Kala-Azar",
      "Infektion durch Leishmania chagasi",
      "Infektion durch Leishmania donovani",
      "Infektion durch Leishmania infantum",
      "Kala-Azar",
      "Leishmaniasis interna",
      "Leishmaniose der Mittelmeerländer",
      "Leishmanoid nach Kala-Azar",
      "Mediterrane Leishmaniose",
      "Schwarze Krankheit",
      "Viszerale Leishmaniose"
    ]
  },
  {
    "code": "B55.1",
    "name": "Kutane Leishmaniose",
    "synonyms": [
      "Aleppobeule",
      "Asiatische Wüstenleishmaniose",
      "Bagdad-Beule",
      "Chiclero-Geschwür",
      "Cochinchina-Ulkus",
      "Delhibeule",
      "Delhigeschwür",
      "Delhipustel",
      "Hautleishmaniose",
      "Hautleishmanoid",
      "Infektion durch Leishmania aethiopica",
      "Infektion durch Leishmania major",
      "Infektion durch Leishmania mexicana",
      "Infektion durch Leishmania tropica",
      "Kutane Leishmaniose",
      "Kutane amerikanische Leishmaniose",
      "Kutane asiatische Leishmaniose",
      "Kutane städtische Leishmaniose",
      "Kutane äthiopische Leishmaniose",
      "Leishmaniasis cutis",
      "Leishmaniasis tegumentaria diffusa",
      "Leishmaniasis tropica",
      "Leishmaniasis tropica major",
      "Natalbeule",
      "Orientbeule",
      "Orientfistel",
      "Orientgeschwür",
      "Tropische Leishmaniose",
      "Ulcus tropicum durch Leishmaniose",
      "Uta-Geschwür",
      "Wüstenleishmaniose"
    ]
  },
  {
    "code": "B55.2",
    "name": "Mukokutane Leishmaniose",
    "synonyms": [
      "Bahia-Ulkus",
      "Brasilianische Leishmaniose",
      "Espundia",
      "Infektion durch Leishmania brasiliensis",
      "Leishmaniose der Mund- und Nasenschleimhaut",
      "Mexikanische Leishmaniose",
      "Mukokutane Leishmaniose",
      "Nasoorale Leishmaniose",
      "Nasopharyngeale Leishmaniose",
      "Südamerikanische Haut-Schleimhaut-Leishmaniose"
    ]
  },
  {
    "code": "B55.9",
    "name": "Leishmaniose",
    "synonyms": [
      "Infektion durch Leishmania",
      "Leishmaniase - s.a. Leishmaniose",
      "Leishmaniasis",
      "Leishmaniose"
    ]
  },
  {
    "code": "B56.0",
    "name": "Trypanosomiasis gambiensis",
    "synonyms": [
      "Afrikanische Schlafkrankheit durch Trypanosoma brucei gambiense",
      "Afrikanische Schlafkrankheit durch Trypanosoma gambiense",
      "Infektion durch Trypanosoma brucei gambiense",
      "Trypanosomiasis durch Trypanosoma brucei gambiense",
      "Trypanosomiasis gambiensis",
      "Westafrikanische Schlafkrankheit",
      "Westafrikanische Trypanosomiasis"
    ]
  },
  {
    "code": "B56.1",
    "name": "Trypanosomiasis rhodesiensis",
    "synonyms": [
      "Afrikanische Schlafkrankheit durch Trypanosoma brucei rhodesiense",
      "Afrikanische Schlafkrankheit durch Trypanosoma rhodesiense",
      "Infektion durch Trypanosoma brucei rhodesiense",
      "Nairobi-Schlafkrankheit",
      "Ostafrikanische Schlafkrankheit",
      "Ostafrikanische Trypanosomiasis",
      "Trypanosomiasis durch Trypanosoma brucei rhodesiense",
      "Trypanosomiasis rhodesiensis"
    ]
  },
  {
    "code": "B56.9",
    "name": "Afrikanische Trypanosomiasis",
    "synonyms": [
      "Afrikanische Schlafkrankheit",
      "Afrikanische Trypanosomiasis",
      "Afrikanische Trypanosomiasis durch Trypanosoma brucei",
      "Schlafkrankheit",
      "Trypanosomiasis africana",
      "Trypanosomiasis africana durch Trypanosoma brucei"
    ]
  },
  {
    "code": "B57.1",
    "name": "Chagas-Krankheit ohne Organbeteiligung",
    "synonyms": [
      "Akute Chagas-Krankheit",
      "Akute Chagas-Krankheit ohne Herzbeteiligung",
      "Chagas-Krankheit ohne Organbeteiligung"
    ]
  },
  {
    "code": "B57.2",
    "name": "Chagas-Krankheit",
    "synonyms": [
      "Amerikanische Trypanose",
      "Amerikanische Trypanosomiasis",
      "Chagas-Krankheit",
      "Chronische Chagas-Krankheit",
      "Cruz-Chagas-Krankheit",
      "Infektion durch Trypanosoma cruzi",
      "Morbus Chagas",
      "Pseudomyxödem"
    ]
  },
  {
    "code": "B58.8",
    "name": "Adrenalitis durch Toxoplasmen",
    "synonyms": [
      "Adrenalitis durch Toxoplasmen",
      "Angiitis durch Toxoplasmen",
      "Gastritis durch Toxoplasmen",
      "Parathyreoiditis durch Toxoplasmen",
      "Toxoplasmose-Adrenalitis",
      "Toxoplasmose-Angiitis",
      "Toxoplasmose-Gastritis",
      "Toxoplasmose-Lymphadenopathie",
      "Uveatoxoplasmose"
    ]
  },
  {
    "code": "B58.90",
    "name": "Toxoplasmose-Sepsis",
    "synonyms": [
      "Sepsis durch Toxoplasmen",
      "Toxoplasmose-Sepsis"
    ]
  },
  {
    "code": "B58.98",
    "name": "Toxoplasmose beim Erwachsenen",
    "synonyms": [
      "Erworbene Toxoplasmose",
      "Infektion durch Toxoplasma gondii",
      "Toxoplasmen-Infektion",
      "Toxoplasmose",
      "Toxoplasmose beim Erwachsenen",
      "Toxoplasmosis"
    ]
  },
  {
    "code": "B60.0",
    "name": "Babesiose",
    "synonyms": [
      "Babesiose",
      "Piroplasmose"
    ]
  },
  {
    "code": "B60.1",
    "name": "Akanthamöbiasis",
    "synonyms": [
      "Akanthamöbiasis"
    ]
  },
  {
    "code": "B60.2",
    "name": "Infektion durch Naegleria",
    "synonyms": [
      "Infektion durch Naegleria",
      "Naegleriainfektion",
      "Naegleriasis"
    ]
  },
  {
    "code": "B60.80",
    "name": "Sepsis durch Protozoen",
    "synonyms": [
      "Sepsis durch Protozoen"
    ]
  },
  {
    "code": "B60.88",
    "name": "Mikrosporidiose",
    "synonyms": [
      "Blastocystis-Infektion",
      "Mikrosporidiose"
    ]
  },
  {
    "code": "B64",
    "name": "Protozoen-Krankheit",
    "synonyms": [
      "Befall durch Protozoen a.n.k.",
      "Protozoen-Infektion",
      "Protozoen-Krankheit",
      "Protozoonose",
      "Sporozoa-Infektion"
    ]
  },
  {
    "code": "B65.0",
    "name": "Schistosomiasis durch Schistosoma haematobium",
    "synonyms": [
      "Befall durch Schistosoma haematobium",
      "Bilharziöse Lipurie",
      "Blasenschistosomiasis",
      "Chylurie bei Bilharziose",
      "Chylurie bei Schistosomiasis",
      "Chylurie durch Bilharzia haematobia",
      "Endemische Hämaturie",
      "Galakturie bei Bilharziose",
      "Hämatochylurie",
      "Hämatochylurie bei Bilharziose",
      "Hämatochylurie bei Schistosomiasis",
      "Hämatochylurie durch Bilharzia haematobia",
      "Infektion durch Schistosoma haematobium",
      "Lipurie bei Bilharziose",
      "Schistosomiasis durch Schistosoma haematobium",
      "Schistosomiasis urogenitalis",
      "Tropische Hämaturie",
      "Urogenitale Bilharziose",
      "Vesikale Schistosomiasis"
    ]
  },
  {
    "code": "B65.1",
    "name": "Schistosomiasis durch Schistosoma mansoni",
    "synonyms": [
      "Befall durch Schistosoma mansoni",
      "Darmbilharziose",
      "Darmschistosomiasis",
      "Dysenterie durch Schistosomen",
      "Infektion durch Schistosoma mansoni",
      "Intestinale Bilharziose",
      "Kolonschistosomiasis",
      "Schistosomiasis durch Schistosoma mansoni",
      "Schistosomiasis intestinalis"
    ]
  },
  {
    "code": "B65.2",
    "name": "Schistosomiasis durch Schistosoma japonicum",
    "synonyms": [
      "Asiatische Bilharziose",
      "Asiatische Schistosomiasis",
      "Befall durch Schistosoma japonicum",
      "Infektion durch Schistosoma japonicum",
      "Katayama-Fieber",
      "Katayama-Krankheit",
      "Ostasiatische Bilharziose",
      "Schistosomiasis durch Schistosoma japonicum",
      "Schistosomiasis orientalis"
    ]
  },
  {
    "code": "B65.3",
    "name": "Dermatitis durch Schistosomen",
    "synonyms": [
      "Badedermatitis durch Zerkarien",
      "Befall durch Schistosoma cercariae",
      "Befall durch Zerkarien",
      "Bilharziose der Haut",
      "Dermatitis durch Schistosomen",
      "Dermatitis durch Zerkarien",
      "Schistosomiasis der Haut",
      "Swimmer's itch",
      "Zerkariendermatitis"
    ]
  },
  {
    "code": "B65.8",
    "name": "Schistosomiasis bovis",
    "synonyms": [
      "Befall durch Schistosoma bovis",
      "Befall durch Schistosoma intercalatum",
      "Befall durch Schistosoma mattheei",
      "Befall durch Schistosoma mekongi",
      "Befall durch Schistosoma spindale",
      "Infektion durch Schistosoma intercalatum",
      "Infektion durch Schistosoma mattheei",
      "Infektion durch Schistosoma mekongi",
      "Schistosomiasis bovis",
      "Schistosomiasis intercalatum",
      "Schistosomiasis mattheei",
      "Schistosomiasis spindale"
    ]
  },
  {
    "code": "B65.9",
    "name": "Bilharziose",
    "synonyms": [
      "Befall des Blutes durch Egel a.n.k.",
      "Befall des Blutes durch Schistosoma a.n.k.",
      "Befall durch Bilharzia a.n.k.",
      "Befall durch Schistosoma",
      "Bilharziose",
      "Distomiase im Blut",
      "Granulom durch Schistosomen",
      "Schistosomiase",
      "Schistosomiasis",
      "Snail fever - s.a. Schistosomiasis"
    ]
  },
  {
    "code": "B66.0",
    "name": "Opisthorchiasis",
    "synonyms": [
      "Befall durch Katzenleberegel",
      "Infektion durch Katzenleberegel",
      "Infektion durch Opisthorchis felineus",
      "Infektion durch Opisthorchis tenuicollis",
      "Infektion durch Opisthorchis viverrini",
      "Opisthorchiasis",
      "Opisthorchiasis felineus",
      "Opisthorchiasis veverrini"
    ]
  },
  {
    "code": "B66.1",
    "name": "Clonorchiasis",
    "synonyms": [
      "Befall der Leber durch Clonorchis sinensis",
      "Befall durch Clonorchis sinensis",
      "Befall durch chinesischen Leberegel",
      "Befall durch orientalischen Leberegel",
      "Befall durch ostasiatischen Leberegel",
      "Chinesische Leberegel-Krankheit",
      "Clonorchiasis",
      "Infektion der Leber durch Clonorchis sinensis",
      "Infektion durch Clonorchis sinensis",
      "Orientalische Leberegel-Krankheit"
    ]
  },
  {
    "code": "B66.2",
    "name": "Dicrocoeliasis",
    "synonyms": [
      "Befall durch Dicrocoelium dendriticum",
      "Befall durch Lanzettegel",
      "Dicrocoeliasis",
      "Infektion durch Dicrocoelium dendriticum",
      "Infektion durch Lanzettegel"
    ]
  },
  {
    "code": "B66.3",
    "name": "Fascioliasis",
    "synonyms": [
      "Befall durch Distoma hepaticum",
      "Befall durch Fasciola hepatica",
      "Befall durch Leberegel",
      "Befall durch Schafleberegel",
      "Befall durch großen Leberegel",
      "Fascioliasis",
      "Infektion durch Fasciola gigantica",
      "Infektion durch Fasciola hepatica",
      "Infektion durch Fasciola indica",
      "Infektion durch Schafleberegel",
      "Krankheit durch großen Leberegel",
      "Leberegel-Krankheit",
      "Schafleberegel-Krankheit"
    ]
  },
  {
    "code": "B66.4",
    "name": "Paragonimiasis",
    "synonyms": [
      "Befall durch Lungenegel",
      "Befall durch Paragonimus ringeri",
      "Befall durch Paragonimus westermani",
      "Infektion durch Paragonimus westermani",
      "Infektion durch Paragonimus-Arten",
      "Lungenegelkrankheit",
      "Paragonimiasis"
    ]
  },
  {
    "code": "B66.5",
    "name": "Fasciolopsiasis",
    "synonyms": [
      "Befall des Darmes durch Fasciolopsis buski",
      "Befall durch Darmegel",
      "Darmegel-Krankheit",
      "Fasciolopsiasis",
      "Fasciolopsiasis buski",
      "Infektion durch Fasciolopsis buski",
      "Intestinale Distomatose",
      "Intestinale Distomiase",
      "Intestinale Fasciolopsiasis",
      "Intestinaler Befall durch Egel"
    ]
  },
  {
    "code": "B66.8",
    "name": "Echinostomiasis",
    "synonyms": [
      "Befall durch Echinostoma ilocanum",
      "Befall durch Gastrodiscoides hominis",
      "Befall durch Heterophyes",
      "Befall durch Metagonimus yokogawai",
      "Befall durch Stellantchasmus falcatus",
      "Echinostomiasis",
      "Gastrodiscoidiasis",
      "Heterophyiasis",
      "Heterophyiasis des Dünndarmes",
      "Infektion durch Heterophyes",
      "Infektion durch Metagonimus",
      "Infektion durch Stellantchasmus falcatus",
      "Metagonimiasis",
      "Nanophyetiasis",
      "Watsoniasis"
    ]
  },
  {
    "code": "B66.9",
    "name": "Distomiasis",
    "synonyms": [
      "Befall durch Saugwurm",
      "Befall durch Trematoden a.n.k.",
      "Distomatose",
      "Distomiase",
      "Distomiasis",
      "Infektion durch Trematoden a.n.k.",
      "Krankheit durch Saugwurm a.n.k.",
      "Krankheit durch Trematoden a.n.k.",
      "Trematodiasis a.n.k."
    ]
  },
  {
    "code": "B67.0",
    "name": "Hydatidenzyste der Leber durch Echinococcus granulosus",
    "synonyms": [
      "Hydatidenzyste der Leber durch Echinococcus granulosus"
    ]
  },
  {
    "code": "B67.4",
    "name": "Infektion durch Echinococcus granulosus",
    "synonyms": [
      "Befall durch Hundebandwurm",
      "Infektion durch Echinococcus cysticus",
      "Infektion durch Echinococcus granulosus",
      "Infektion durch Hundebandwurm",
      "Krankheit durch Hundebandwurm a.n.k.",
      "Zystische Echinococcus-Infektion",
      "Zystische Echinokokkose"
    ]
  },
  {
    "code": "B67.5",
    "name": "Hydatidenzyste der Leber durch Echinococcus multilocularis",
    "synonyms": [
      "Hydatidenzyste der Leber durch Echinococcus multilocularis"
    ]
  },
  {
    "code": "B67.7",
    "name": "Infektion durch Echinococcus multilocularis",
    "synonyms": [
      "Alveoläre Echinokokkose",
      "Befall durch Fuchsbandwurm",
      "Infektion durch Echinococcus alveolaris",
      "Infektion durch Echinococcus multilocularis"
    ]
  },
  {
    "code": "B67.9",
    "name": "Echinokokkose",
    "synonyms": [
      "Befall durch Echinococcus",
      "Echinococcus-Infektion",
      "Echinococcus-Zyste",
      "Echinokokken-Krankheit",
      "Echinokokkose",
      "Hydatidentumor",
      "Hydatidosis",
      "Krankheit durch Blasenwurm",
      "Krankheit durch Hydatiden",
      "Zyste durch Hydatiden"
    ]
  },
  {
    "code": "B68.0",
    "name": "Befall durch Taenia solium",
    "synonyms": [
      "Befall durch Taenia solium",
      "Infektion durch Schweinebandwurm",
      "Infektion durch Taenia solium",
      "Intestinale Infektion durch Taenia solium",
      "Intestinaler Befall durch Schweinebandwurm"
    ]
  },
  {
    "code": "B68.1",
    "name": "Befall durch Taenia saginata",
    "synonyms": [
      "Befall durch Rinderbandwurm",
      "Befall durch Rinderfinnenbandwurm",
      "Befall durch Taenia mediocanellata",
      "Befall durch Taenia saginata",
      "Infektion durch Rinderbandwurm",
      "Infektion durch Taenia saginata",
      "Infektion durch adulte Form von Taenia saginata"
    ]
  },
  {
    "code": "B68.9",
    "name": "Taeniasis",
    "synonyms": [
      "Befall durch Taenia",
      "Intestinale Taeniasis",
      "Taenia-Infektion",
      "Taeniasis",
      "Taeniasis intestinalis"
    ]
  },
  {
    "code": "B69.9",
    "name": "Zystizerkose",
    "synonyms": [
      "Befall durch Cysticercus cellulosae",
      "Befall durch Finnen des Schweinebandwurmes",
      "Befall durch Taenia solium im Larvenstadium",
      "Infektion durch Cysticercus cellulosae",
      "Infektion durch Larven des Schweinebandwurmes - s.a. Zystizerkose",
      "Zyste bei Zystizerkose",
      "Zystizerkose"
    ]
  },
  {
    "code": "B70.0",
    "name": "Infektion durch Diphyllobothrium",
    "synonyms": [
      "Befall durch Bothriocephalus latus",
      "Befall durch Dibothriocephalus",
      "Befall durch Fischbandwurm",
      "Befall durch Grubenkopfbandwurm",
      "Befall durch adulte Form von Diphyllobothrium latum",
      "Befall durch breiten Bandwurm",
      "Dibothriocephaliasis",
      "Dibothriocephaliasis latus",
      "Diphyllobothriasis",
      "Diphyllobothriose",
      "Diphyllobothriose des Darmes",
      "Infektion durch Dibothriocephalus",
      "Infektion durch Diphyllobothrium",
      "Infektion durch Fischbandwurm",
      "Infektion durch adulte Form von Diphyllobothrium",
      "Infektion durch adulte Form von Diphyllobothrium latum",
      "Infektion durch adulte Form von Diphyllobothrium pacificum"
    ]
  },
  {
    "code": "B70.1",
    "name": "Sparganose",
    "synonyms": [
      "Befall durch Bothriocephalus-latus-Finnen",
      "Befall durch Dibothriocephalus-Finnen",
      "Befall durch Diphyllobothrium-Finnen",
      "Befall durch Diphyllobothrium-Larven",
      "Befall durch Finnen des Fischbandwurmes",
      "Befall durch Finnen des Grubenkopfbandwurmes",
      "Befall durch Finnen des breiten Bandwurmes",
      "Befall durch Plerozerkoide",
      "Befall durch Sparganum mansoni",
      "Befall durch Sparganum proliferum",
      "Befall durch Spirometralarven",
      "Dibothriocephaliasis durch Finnen des Fischbandwurmes",
      "Diphyllobothriose durch Larven",
      "Infektion durch Finnen des Fischbandwurmes",
      "Infektion durch Sparganum",
      "Infektion durch Sparganum mansoni",
      "Infektion durch Sparganum proliferum",
      "Infektion durch Spirometralarven",
      "Sparganose",
      "Spirometrose",
      "Spirometrosis"
    ]
  },
  {
    "code": "B71.0",
    "name": "Hymenolepis-Infektion",
    "synonyms": [
      "Befall durch Hymenolepis",
      "Befall durch Rattenbandwurm",
      "Befall durch Rodentolepis nana",
      "Befall durch Taenia diminuta",
      "Befall durch Taenia nana",
      "Befall durch Zwergbandwurm",
      "Hymenolepiasis",
      "Hymenolepiasis diminuta",
      "Hymenolepiasis nana",
      "Hymenolepis-Infektion",
      "Infektion durch Hymenolepis nana",
      "Infektion durch Rattenbandwurm",
      "Infektion durch Zwergbandwurm"
    ]
  },
  {
    "code": "B71.1",
    "name": "Dipylidiose",
    "synonyms": [
      "Befall durch Dipylidium caninum",
      "Dipylidiasis",
      "Dipylidiose",
      "Intestinale Dipylidiose"
    ]
  },
  {
    "code": "B71.8",
    "name": "Bertielliasis",
    "synonyms": [
      "Befall durch Diplogonoporus grandis",
      "Bertielliasis",
      "Coenurosis",
      "Raillietiniasis"
    ]
  },
  {
    "code": "B71.9",
    "name": "Infektion durch Bandwurm",
    "synonyms": [
      "Bandwurmkrankheit",
      "Befall durch Bandwurm a.n.k.",
      "Befall durch Zestoden a.n.k.",
      "Infektion durch Bandwurm",
      "Infektion durch Zestoden",
      "Zestodiasis"
    ]
  },
  {
    "code": "B72",
    "name": "Drakunkulose",
    "synonyms": [
      "Befall durch Dracunculus medinensis",
      "Befall durch Guineawurm",
      "Befall durch Medinawurm",
      "Drakontiasis",
      "Drakunkulose",
      "Infektion durch Dracunculus",
      "Infektion durch Dracunculus medinensis",
      "Infektion durch Guineawurm",
      "Infektion durch Medinawurm"
    ]
  },
  {
    "code": "B73",
    "name": "Dermatitis nodosa tropica",
    "synonyms": [
      "Befall durch Knäuelfilarie",
      "Befall durch Onchocerca volvulus",
      "Dermatitis nodosa tropica",
      "Elephantiasis scroti durch Onchocerca volvulus",
      "Infektion durch Onchocerca volvulus",
      "Knoten-Filariasis",
      "Onchozerkiasis",
      "Onchozerkose",
      "Roble-Krankheit"
    ]
  },
  {
    "code": "B74.0",
    "name": "Filariose durch Wuchereria bancrofti",
    "synonyms": [
      "Bancrofti-Filariose",
      "Befall durch Filaria bancrofti",
      "Befall durch Wuchereria bancrofti",
      "Chylurie durch Wuchereria bancrofti",
      "Elephantiasis durch Wuchereria bancrofti",
      "Filariose durch Wuchereria bancrofti",
      "Infektion durch Wuchereria bancrofti",
      "Lymphadenitis durch Wuchereria bancrofti",
      "Lymphangitis durch Wuchereria bancrofti",
      "Lymphatische Filariose"
    ]
  },
  {
    "code": "B74.1",
    "name": "Filariose durch Brugia malayi",
    "synonyms": [
      "Befall durch Brugia malayi",
      "Befall durch Malayenfilarie",
      "Befall durch Wuchereria malayi",
      "Chylurie durch Brugia malayi",
      "Chylurie durch Wuchereria malayi",
      "Elephantiasis durch Brugia malayi",
      "Elephantiasis durch Wuchereria malayi",
      "Filariose durch Brugia malayi",
      "Infektion durch Brugia malayi",
      "Infektion durch Wuchereria malayi",
      "Lymphadenitis durch Brugia malayi",
      "Lymphangitis durch Brugia malayi",
      "Malayische Elephantiasis"
    ]
  },
  {
    "code": "B74.2",
    "name": "Filariose durch Brugia timori",
    "synonyms": [
      "Befall durch Brugia timori",
      "Befall durch Filaria timori",
      "Chylurie durch Brugia timori",
      "Elephantiasis durch Brugia timori",
      "Filariose durch Brugia timori",
      "Infektion durch Brugia timori",
      "Lymphadenitis durch Brugia timori",
      "Lymphangitis durch Brugia timori"
    ]
  },
  {
    "code": "B74.3",
    "name": "Loiasis",
    "synonyms": [
      "Afrikanische Augenwurmkrankheit",
      "Befall durch Filaria loa",
      "Befall durch Loa-loa",
      "Befall durch afrikanischen Augenwurm",
      "Kalabarbeule",
      "Kalabarschwellung",
      "Loa-loa-Filariose",
      "Loa-loa-Infektion",
      "Loiasis"
    ]
  },
  {
    "code": "B74.4",
    "name": "Dipetalonemiasis",
    "synonyms": [
      "Acanthocheilonemiasis",
      "Acanthocheilonemiasis perstans",
      "Acanthocheilonemiasis streptocerca",
      "Befall durch Acanthocheilonema perstans",
      "Befall durch Acanthocheilonema streptocerca",
      "Befall durch Dauerlarvenfilarie",
      "Befall durch Dipetalonema perstans",
      "Befall durch Dipetalonema streptocerca",
      "Befall durch Filaria perstans",
      "Befall durch Mansonella ozzardi",
      "Befall durch Mansonella perstans",
      "Befall durch Mansonella streptocerca",
      "Befall durch Microfilaria streptocera",
      "Dipetalonemiasis",
      "Filaria-ozzardi-Infektion",
      "Filariose durch Mansonella ozzardi",
      "Infektion durch Acanthocheilonema perstans",
      "Infektion durch Dipetalonema perstans",
      "Infektion durch Mansonella ozzardi",
      "Infektion durch Mansonella perstans",
      "Infektion durch Mansonella streptocerca",
      "Mansonelliasis",
      "Mansonellose"
    ]
  },
  {
    "code": "B74.8",
    "name": "Dirofilariasis",
    "synonyms": [
      "Dirofilaria-Infektion",
      "Dirofilariasis",
      "Dirofilariose"
    ]
  },
  {
    "code": "B74.9",
    "name": "Filariose",
    "synonyms": [
      "Chylurie durch Filarien",
      "Elephantiasis durch Filarien",
      "Filariasis",
      "Filarien-Abszess",
      "Filarien-Befall",
      "Filariose",
      "Filariöser chylöser Aszites",
      "Tropische Elephantiasis"
    ]
  },
  {
    "code": "B75",
    "name": "Trichinose",
    "synonyms": [
      "Infektion durch Trichinella-Arten",
      "Lungentrichinose",
      "Orbitatrichinose",
      "Trichinella-spiralis-Befall",
      "Trichinella-spiralis-Infektion",
      "Trichinelliasis",
      "Trichinellose",
      "Trichinose",
      "Vergiftung durch trichinöse Wurst",
      "Vergiftung durch trichinöses Fleisch"
    ]
  },
  {
    "code": "B76.0",
    "name": "Ankylostomiasis",
    "synonyms": [
      "Ancylostomiasis",
      "Ankylostomiasis",
      "Ankylostomiasis brasiliense",
      "Ankylostomiasis caninum",
      "Ankylostomiasis ceylonicum",
      "Ankylostomiasis duodenale",
      "Befall durch Ankylostoma brasiliense",
      "Befall durch Ankylostoma caninum",
      "Befall durch Ankylostoma ceylonicum",
      "Befall durch Ankylostoma duodenale",
      "Befall durch Ankylostoma-Nematoden a.n.k.",
      "Hakenwurm-Krankheit durch Ancylostoma brasiliense",
      "Hakenwurm-Krankheit durch Ancylostoma ceylonensis",
      "Hakenwurm-Krankheit durch Ancylostoma duodenale",
      "Helminthose durch Ankylostoma",
      "Infektion durch Ankylostoma duodenale",
      "Infektion durch Ankylostoma-Arten"
    ]
  },
  {
    "code": "B76.1",
    "name": "Nekatoriasis",
    "synonyms": [
      "Ankylostomiasis durch Necator americanus",
      "Befall durch Necator americanus",
      "Befall durch Uncinaria americana",
      "Hakenwurm-Krankheit durch Necator americanus",
      "Helminthose durch Necator americanus",
      "Infektion durch Necator americanus",
      "Nekatoriasis"
    ]
  },
  {
    "code": "B76.9",
    "name": "Larva migrans cutanea a.n.k.",
    "synonyms": [
      "Creeping Eruption",
      "Griesinger-Krankheit",
      "Ground itch",
      "Hakenwurm-Befall",
      "Hakenwurm-Infektion",
      "Hakenwurm-Krankheit",
      "Krankheit durch Sandwurm",
      "Larva migrans cutanea a.n.k.",
      "Unzinariasis",
      "Wasserkrätze der Tropen"
    ]
  },
  {
    "code": "B77.8",
    "name": "Askaridose mit Komplikation a.n.k.",
    "synonyms": [
      "Askaridose mit Komplikation a.n.k."
    ]
  },
  {
    "code": "B77.9",
    "name": "Askaridose",
    "synonyms": [
      "Askariasis - s.a. Askaridose",
      "Askaridiasis - s.a. Askaridose",
      "Askaridose",
      "Befall durch Ascaris lumbricoides",
      "Befall durch Spulwurm a.n.k.",
      "Infektion durch Ascaris lumbricoides",
      "Infektion durch Spulwurm",
      "Krankheit durch Spulwurm a.n.k."
    ]
  },
  {
    "code": "B78.0",
    "name": "Darmstrongyloidiasis",
    "synonyms": [
      "Cochinchina-Diarrhoe",
      "Darmstrongyloidiasis",
      "Diarrhoe bei Anguilluliasis",
      "Diarrhoe bei Strongyloidiasis",
      "Dysenterische Strongyloidiasis",
      "Intestinale Strongyloidiasis",
      "Strongyloidiasis des Darmes"
    ]
  },
  {
    "code": "B78.7",
    "name": "Disseminierte Strongyloidiasis",
    "synonyms": [
      "Disseminierte Strongyloidiasis"
    ]
  },
  {
    "code": "B78.9",
    "name": "Strongyloidiasis",
    "synonyms": [
      "Anguilluliasis",
      "Befall durch Anguillula stercoralis",
      "Befall durch Darmälchen",
      "Befall durch Rhabdonema intestinale",
      "Befall durch Strongyloides stercoralis",
      "Befall durch Zwergfadenwurm",
      "Kotälchen",
      "Strongyloidiasis",
      "Strongyloidose"
    ]
  },
  {
    "code": "B79",
    "name": "Trichuriasis",
    "synonyms": [
      "Befall durch Peitschenwurm",
      "Befall durch Trichocephalus trichiura",
      "Befall durch Trichuris trichiura",
      "Infektion durch Peitschenwurm",
      "Krankheit durch Peitschenwurm",
      "Trichocephaliasis",
      "Trichuriasis"
    ]
  },
  {
    "code": "B80",
    "name": "Appendicopathia oxyurica",
    "synonyms": [
      "Appendicopathia oxyurica",
      "Befall durch Enterobius vermicularis",
      "Befall durch Fadenwurm",
      "Befall durch Madenwurm",
      "Befall durch Oxyuren",
      "Befall durch Springwurm",
      "Enterobiasis",
      "Enterobiose",
      "Fadenwürmer",
      "Infektion durch Enterobius vermicularis",
      "Infektion durch Fadenwurm",
      "Infektion durch Madenwurm",
      "Infektion durch Oxyuris vermicularis",
      "Krankheit durch Madenwurm",
      "Krankheit durch Springwurm",
      "Lungenoxyuriasis",
      "Oxyuriasis"
    ]
  },
  {
    "code": "B81.0",
    "name": "Anisakiasis",
    "synonyms": [
      "Anisakiasis",
      "Anisakidose",
      "Anisakis-Larven-Befall",
      "Befall durch Anisakis marina",
      "Infektion durch Anisakis-Larven",
      "Krankheit durch Heringswurm"
    ]
  },
  {
    "code": "B81.1",
    "name": "Infektion durch Capillaria philippinensis",
    "synonyms": [
      "Befall durch Capillaria philippinensis",
      "Infektion durch Capillaria philippinensis",
      "Intestinale Infektion durch Capillaria",
      "Intestinale Kapillariasis",
      "Intestinaler Befall durch Capillaria",
      "Kapillariasis"
    ]
  },
  {
    "code": "B81.2",
    "name": "Trichostrongyliasis",
    "synonyms": [
      "Befall durch Trichostrongylus orientalis",
      "Trichostrongyliasis",
      "Trichostrongyliasis des Dünndarmes"
    ]
  },
  {
    "code": "B81.3",
    "name": "Intestinale Angiostrongyliasis",
    "synonyms": [
      "Angiostrongyliasis durch Angiostrongylus costaricensis",
      "Angiostrongyliasis durch Parastrongylus costaricensis",
      "Befall durch Angiostrongylus costaricensis",
      "Befall durch Parastrongylus costaricensis",
      "Intestinale Angiostrongyliasis"
    ]
  },
  {
    "code": "B81.4",
    "name": "Mischform intestinaler Helminthosen",
    "synonyms": [
      "Mischform intestinaler Helminthosen",
      "Mischinfektion durch Helminthen des Darmes"
    ]
  },
  {
    "code": "B81.8",
    "name": "Echinorhynchiasis",
    "synonyms": [
      "Befall durch Oesophagostomum apistomum",
      "Befall durch Ternidens deminutus",
      "Befall durch Ternidens diminutus",
      "Echinorhynchiasis",
      "Infektion durch Oesophagostomum-Arten",
      "Infektion durch Ternidens deminutus",
      "Infektion durch Ternidens diminutus",
      "Oesophagostomiasis",
      "Physalopteriasis",
      "Ternidensiasis"
    ]
  },
  {
    "code": "B82.0",
    "name": "Nematoden-Infektion",
    "synonyms": [
      "Darmbefall durch Helminthen a.n.k.",
      "Intestinale Helminthose a.n.k.",
      "Intestinale Infektion durch Helminthen",
      "Intestinale Wurm-Krankheit",
      "Intestinaler Befall durch Nematoden a.n.k.",
      "Nematoden-Infektion",
      "Nematoden-Infektion des Darmes a.n.k.",
      "Nematodiasis des Darmes",
      "Wurm-Krankheit des Darmes"
    ]
  },
  {
    "code": "B82.9",
    "name": "Darmbefall a.n.k.",
    "synonyms": [
      "Befall durch Darmparasiten a.n.k.",
      "Darmbefall a.n.k.",
      "Darmbefall durch Parasiten a.n.k.",
      "Intestinaler Befall a.n.k.",
      "Parasitäre Enteritis a.n.k.",
      "Parasitäre intestinale Krankheit a.n.k."
    ]
  },
  {
    "code": "B83.0",
    "name": "Toxokariasis",
    "synonyms": [
      "Befall durch Hundespulwurm-Larven",
      "Befall durch Katzenspulwurm",
      "Befall durch Larva migrans visceralis a.n.k.",
      "Befall durch Toxocara-canis-Larven",
      "Befall durch Toxocara-cati-Larven",
      "Infektion durch Toxocara",
      "Larva migrans visceralis",
      "Toxocariasis",
      "Toxokariasis",
      "Viszerale Larva migrans"
    ]
  },
  {
    "code": "B83.1",
    "name": "Gnathostomiasis",
    "synonyms": [
      "Befall durch Gnathostoma spinigerum",
      "Gnathostomiasis",
      "Infektion durch Gnathostoma spinigerum",
      "Wandernde Schwellung durch Gnathostoma spinigerum"
    ]
  },
  {
    "code": "B83.2",
    "name": "Angiostrongyliasis durch Parastrongylus cantonensis",
    "synonyms": [
      "Angiostrongyliasis cantonensis",
      "Angiostrongyliasis durch Angiostrongylus cantonensis",
      "Angiostrongyliasis durch Parastrongylus cantonensis",
      "Befall durch Angiostrongylus cantonensis",
      "Befall durch Parastrongylus cantonensis"
    ]
  },
  {
    "code": "B83.3",
    "name": "Syngamiasis",
    "synonyms": [
      "Syngamiasis",
      "Syngamose",
      "Syngamosis"
    ]
  },
  {
    "code": "B83.4",
    "name": "Hirudiniasis interna",
    "synonyms": [
      "Hirudiniasis interna",
      "Interner Befall durch Hirudinae-Egel"
    ]
  },
  {
    "code": "B83.8",
    "name": "Akanthozephaliasis",
    "synonyms": [
      "Acanthocephaliasis",
      "Akanthozephaliasis",
      "Befall durch Capillaria hepatica",
      "Befall durch Dioctophyma renale",
      "Befall durch Gongylonema",
      "Gongylonemiasis",
      "Infektion durch Capillaria hepatica",
      "Infektion durch Gongylonema",
      "Kapillariasis der Leber",
      "Metastrongyliasis",
      "Thelaziasis"
    ]
  },
  {
    "code": "B83.9",
    "name": "Helminthose",
    "synonyms": [
      "Befall durch Helminthen a.n.k.",
      "Colica verminosa",
      "Helminthiasis",
      "Helminthose",
      "Infektion durch Helminthen",
      "Wurm-Befall a.n.k.",
      "Wurm-Fieber",
      "Wurm-Infektion",
      "Wurm-Krankheit a.n.k."
    ]
  },
  {
    "code": "B85.0",
    "name": "Pedikulose durch Pediculus humanus capitis",
    "synonyms": [
      "Befall durch Pediculus capitis",
      "Kopfläusebefall",
      "Pediculosis capitis",
      "Pedikulose durch Pediculus humanus capitis"
    ]
  },
  {
    "code": "B85.1",
    "name": "Körperläusebefall",
    "synonyms": [
      "Befall durch Kleiderläuse",
      "Befall durch Pediculus corporis",
      "Cutis vagantium",
      "Körperläusebefall",
      "Maculae caeruleae",
      "Pediculosis corporis",
      "Pediculosis vestimenti"
    ]
  },
  {
    "code": "B85.2",
    "name": "Läusebefall",
    "synonyms": [
      "Befall durch Pediculus",
      "Läusebefall",
      "Läusekrankheit",
      "Pediculosis",
      "Pedikulose",
      "Verlausung"
    ]
  },
  {
    "code": "B85.3",
    "name": "Pediculosis pubis",
    "synonyms": [
      "Befall durch Pediculus pubis",
      "Befall durch Phthirus pubis",
      "Filzläusebefall",
      "Pediculosis pubis",
      "Phthiriasis",
      "Phthiriasis pubis",
      "Verlausung durch Filzläuse",
      "Verlausung durch Schamläuse",
      "Vulvapedikulose"
    ]
  },
  {
    "code": "B85.4",
    "name": "Multipler Läusebefall",
    "synonyms": [
      "Mischform von Pedikulose und Phthiriasis",
      "Multipler Läusebefall"
    ]
  },
  {
    "code": "B86",
    "name": "Skabies",
    "synonyms": [
      "Befall durch Krätzmilben",
      "Befall durch Sarcoptes scabiei",
      "Befall durch Skabies",
      "Borkenkrätze",
      "Ekzema scabiosum",
      "Ekzematisierte Skabies",
      "Krätze",
      "Norwegische Krätze",
      "Räude",
      "Skabies",
      "Skabies mit postskabiösem Ekzem"
    ]
  },
  {
    "code": "B87.0",
    "name": "Furunkuloide Myiasis",
    "synonyms": [
      "Furunkuloide Myiasis",
      "Furunkuloide Myiasis durch Cordylobia anthropophaga",
      "Furunkuloide Myiasis durch Dermatobia hominis",
      "Migratorische Myiasis"
    ]
  },
  {
    "code": "B87.1",
    "name": "Wundmyiasis",
    "synonyms": [
      "Traumatische Dermatomyiasis",
      "Traumatische Hautmyiasis",
      "Traumatische Myiasis",
      "Traumatische kutane Myiasis",
      "Wundmyiasis"
    ]
  },
  {
    "code": "B87.8",
    "name": "Urogenitalmyiasis",
    "synonyms": [
      "Körperhöhlenmyiasis",
      "Urogenitalmyiasis"
    ]
  },
  {
    "code": "B87.9",
    "name": "Myiasis",
    "synonyms": [
      "Befall durch Dermatobia hominis",
      "Befall durch Gasterophilus intestinalis",
      "Befall durch Larven",
      "Befall durch Oestrus ovis",
      "Dassel-Beule",
      "Fliegenlarvenbefall",
      "Fliegenmadenkrankheit",
      "Madenbefall",
      "Myiasis",
      "Oestriasis",
      "Oestridiasis"
    ]
  },
  {
    "code": "B88.0",
    "name": "Trombikulose",
    "synonyms": [
      "Acariasis",
      "Acarodermatitis",
      "Akarinose",
      "Befall durch Demodex folliculorum",
      "Befall durch Dermanyssus gallinae",
      "Befall durch Erntemilben",
      "Befall durch Haarbalgmilben",
      "Befall durch Herbstmilben",
      "Befall durch Käsemilben",
      "Befall durch Liponyssoides sanguineus",
      "Befall durch Tetranychus molestissimus",
      "Befall durch Trombicula-Larven",
      "Biss durch Trombicula-Larven",
      "Demodikose",
      "Dermatitis durch Demodex-Arten",
      "Dermatitis durch Dermanyssus gallinae",
      "Dermatitis durch Erntemilben",
      "Dermatitis durch Liponyssoides sanguineus",
      "Dermatitis durch Milben",
      "Diarrhoe durch Milben",
      "Erntekrätze",
      "Geflügelzüchter-Krätze",
      "Getreidekrätze",
      "Korn-Krätze",
      "Krämerkrätze",
      "Milben im Sputum",
      "Strohkrätze",
      "Trombidiose",
      "Trombikulose"
    ]
  },
  {
    "code": "B88.1",
    "name": "Tungiasis",
    "synonyms": [
      "Befall durch Sandfloh",
      "Befall durch Tunga penetrans",
      "Biss durch Sandfloh",
      "Tungiasis"
    ]
  },
  {
    "code": "B88.2",
    "name": "Scarabiasis",
    "synonyms": [
      "Arthropoden-Befall a.n.k.",
      "Myriapodiasis",
      "Scarabiasis",
      "Skarabiasis"
    ]
  },
  {
    "code": "B88.3",
    "name": "Hirudiniasis externa",
    "synonyms": [
      "Blutegelbefall",
      "Externer Befall durch Blutegel",
      "Externer Befall durch Hirudinae-Egel",
      "Hirudiniasis externa",
      "Landblutegelbefall"
    ]
  },
  {
    "code": "B88.8",
    "name": "Linguatulosis",
    "synonyms": [
      "Befall durch Candiru",
      "Befall durch Capnocytophaga canimorsus",
      "Befall durch Ixodeszecken",
      "Befall durch Linguatula",
      "Befall durch Pentastoma",
      "Befall durch Saprophyten a.n.k.",
      "Befall durch Vandellia cirrhosa",
      "Fischparasitenbefall durch Vandellia cirrhosa",
      "Infektion durch Candiru",
      "Infektion durch Capnocytophaga canimorsus",
      "Ixodiasis",
      "Linguatulose",
      "Linguatulosis",
      "Porozephalose",
      "Saprophytäre Infektion"
    ]
  },
  {
    "code": "B88.9",
    "name": "Milbenbefall",
    "synonyms": [
      "Akarus-Räude",
      "Epizootie",
      "Hautparasitenbefall a.n.k.",
      "Lymphangitis epizootica",
      "Milben-Krankheit",
      "Milbenbefall",
      "Parasitäre Hautkrankheit a.n.k."
    ]
  },
  {
    "code": "B89",
    "name": "Parasitenbefall a.n.k.",
    "synonyms": [
      "Parasitenbefall a.n.k.",
      "Parasiteninfektion",
      "Parasitose",
      "Parasitäre Infektion a.n.k.",
      "Parasitäre Krankheit a.n.k.",
      "Parasitäre Zyste a.n.k."
    ]
  },
  {
    "code": "B90.0",
    "name": "Folgezustand einer Tuberkulose des Zentralnervensystems",
    "synonyms": [
      "Folgezustand einer Tuberkulose des Zentralnervensystems",
      "Spätfolge einer Tuberkulose des Zentralnervensystems"
    ]
  },
  {
    "code": "B90.1",
    "name": "Folgezustand einer Tuberkulose des Urogenitalsystems",
    "synonyms": [
      "Folgezustand einer Tuberkulose der Harn- und Geschlechtsorgane",
      "Folgezustand einer Tuberkulose des Urogenitalsystems",
      "Kittniere als Tuberkulose-Spätfolge",
      "Mörtelniere als Tuberkulose-Spätfolge",
      "Spätfolge einer Tuberkulose der Harn- und Geschlechtsorgane"
    ]
  },
  {
    "code": "B90.2",
    "name": "Folgezustand einer Tuberkulose der Knochen und Gelenke",
    "synonyms": [
      "Folgezustand einer Tuberkulose der Knochen und Gelenke",
      "Spätfolge einer Tuberkulose der Knochen und Gelenke"
    ]
  },
  {
    "code": "B90.8",
    "name": "Tuberkulöse Lymphknotenkalzifikation",
    "synonyms": [
      "Tuberkulöse Hautnarbe",
      "Tuberkulöse Lymphknotenkalzifikation"
    ]
  },
  {
    "code": "B90.9",
    "name": "Alte inaktive Tuberkulose",
    "synonyms": [
      "Alte Tuberkulose mit schwerer Ventilationsstörung",
      "Alte inaktive Tuberkulose",
      "Folgen einer Tuberkulose",
      "Folgen einer Tuberkulose der Atmungsorgane",
      "Folgezustände einer Tuberkulose",
      "Folgezustände einer Tuberkulose der Atmungsorgane",
      "Spätfolge einer Tuberkulose",
      "Tuberkulöse Lungenkalzifikation",
      "Tuberkulöse Narbe a.n.k.",
      "Tuberkulöse Pleurakalzifikation a.n.k."
    ]
  },
  {
    "code": "B91",
    "name": "Folgezustand einer Poliomyelitis",
    "synonyms": [
      "Folgezustand einer Kinderlähmung",
      "Folgezustand einer Poliomyelitis",
      "Poliomyelitisfolgen",
      "Spätfolge einer akuten Poliomyelitis"
    ]
  },
  {
    "code": "B92",
    "name": "Folgezustand einer Lepra",
    "synonyms": [
      "Folgen der Hansen-Krankheit",
      "Folgezustand einer Lepra"
    ]
  },
  {
    "code": "B94.0",
    "name": "Folgezustand eines Trachoms",
    "synonyms": [
      "Folgen eines Trachoms",
      "Folgezustand eines Trachoms",
      "Spätfolge eines Trachoms",
      "Trachom im Narbenstadium",
      "Trichiasis als Spätfolge eines Trachoms"
    ]
  },
  {
    "code": "B94.1",
    "name": "Folgezustand einer Virusenzephalitis",
    "synonyms": [
      "Folgen einer Virusenzephalitis",
      "Folgezustand einer Virusenzephalitis",
      "Spätfolge einer Virusenzephalitis"
    ]
  },
  {
    "code": "B94.2",
    "name": "Folgezustand einer Virushepatitis",
    "synonyms": [
      "Folgen einer viralen Hepatitis",
      "Folgezustand einer Virushepatitis"
    ]
  },
  {
    "code": "B94.8",
    "name": "Postgonorrhoisches Genitalsyndrom",
    "synonyms": [
      "Postgonorrhoisches Genitalsyndrom",
      "Postgonorrhoisches Syndrom",
      "Postgonorrhoisches Urogenitalsyndrom"
    ]
  },
  {
    "code": "B94.9",
    "name": "Folgen einer infektiösen Krankheit a.n.k.",
    "synonyms": [
      "Folgen einer infektiösen Krankheit a.n.k.",
      "Folgen einer parasitären Krankheit a.n.k."
    ]
  },
  {
    "code": "B99",
    "name": "Infektionskrankheit",
    "synonyms": [
      "Akute Infektion",
      "Banaler Infekt",
      "Fieberhafte Infektion",
      "Fieberhafter Infekt",
      "Hochfieberhafte Infektion",
      "Hochfieberhafter Infekt",
      "Infekt - s.a. Infektion",
      "Infekt ohne Fieber",
      "Infektion",
      "Infektionskrankheit",
      "Infektiöse Krankheit a.n.k.",
      "Infektiöses Fieber a.n.k.",
      "Infektiöses Granulom a.n.k.",
      "Langzeitinfekt",
      "Langzeitinfektion",
      "Opportunistische Infektion",
      "Rezidivierende Infektion",
      "Rezidivierender Infekt",
      "Seltene Infektion",
      "Unklarer Infekt",
      "Unklarer hochfieberhafter Infekt",
      "Übertragbare Krankheit a.n.k."
    ]
  },
  {
    "code": "C00.0",
    "name": "Oberlippenkrebs",
    "synonyms": [
      "Bösartige Neubildung der Außenseite der Oberlippe",
      "Bösartige Neubildung der Lippenrotgrenze der Oberlippe",
      "Bösartige Neubildung der Oberlippe",
      "Bösartige Neubildung der oberen Lippenrotgrenze",
      "Bösartige Neubildung der äußeren Oberlippe",
      "Bösartige Neubildung des Lippenrots der Oberlippe",
      "Bösartige Neubildung des oberen Lippenstiftbereiches",
      "Karzinom der äußeren Oberlippe",
      "Krebs der äußeren Oberlippe",
      "Oberlippenkarzinom",
      "Oberlippenkrebs",
      "Plattenepithelkarzinom der äußeren Oberlippe"
    ]
  },
  {
    "code": "C00.1",
    "name": "Bösartige Neubildung der Unterlippe",
    "synonyms": [
      "Bösartige Neubildung der Außenseite der Unterlippe",
      "Bösartige Neubildung der Lippenrotgrenze der Unterlippe",
      "Bösartige Neubildung der Unterlippe",
      "Bösartige Neubildung der unteren Lippenrotgrenze",
      "Bösartige Neubildung der äußeren Unterlippe",
      "Bösartige Neubildung des Lippenrots der Unterlippe",
      "Bösartige Neubildung des unteren Lippenstiftbereiches",
      "Karzinom der äußeren Unterlippe",
      "Krebs der äußeren Unterlippe",
      "Plattenepithelkarzinom der Unterlippe",
      "Plattenepithelkarzinom der äußeren Unterlippe",
      "Unterlippenkarzinom",
      "Unterlippenkrebs"
    ]
  },
  {
    "code": "C00.2",
    "name": "Bösartige Neubildung des Lippenrots",
    "synonyms": [
      "Bösartige Neubildung der Außenseite der Lippe",
      "Bösartige Neubildung der Lippenrotgrenze",
      "Bösartige Neubildung des Lippenrots",
      "Bösartige Neubildung des Lippenstiftbereiches",
      "Plattenepithelkarzinom der Außenseite der Lippe"
    ]
  },
  {
    "code": "C00.3",
    "name": "Bösartige Neubildung der Innenseite der Oberlippe",
    "synonyms": [
      "Bösartige Neubildung der Innenseite der Oberlippe",
      "Bösartige Neubildung der Mundhöhlenseite der Oberlippe",
      "Bösartige Neubildung der Oberlippenschleimhaut",
      "Bösartige Neubildung der Wangenseite der Oberlippe",
      "Bösartige Neubildung des Frenulums der Oberlippe",
      "Karzinom der inneren Oberlippe",
      "Krebs der inneren Oberlippe",
      "Plattenepithelkarzinom der Innenseite der Oberlippe"
    ]
  },
  {
    "code": "C00.4",
    "name": "Bösartige Neubildung der Innenseite der Unterlippe",
    "synonyms": [
      "Bösartige Neubildung der Innenseite der Unterlippe",
      "Bösartige Neubildung der Mundhöhlenseite der Unterlippe",
      "Bösartige Neubildung der Unterlippenschleimhaut",
      "Bösartige Neubildung der Wangenseite der Unterlippe",
      "Bösartige Neubildung des Frenulums der Unterlippe",
      "Karzinom der inneren Unterlippe",
      "Krebs der inneren Unterlippe",
      "Plattenepithelkarzinom der Innenseite der Unterlippe"
    ]
  },
  {
    "code": "C00.5",
    "name": "Bösartige Neubildung der inneren Lippe",
    "synonyms": [
      "Bösartige Neubildung der Innenseite der Lippe",
      "Bösartige Neubildung der Lippenschleimhaut",
      "Bösartige Neubildung der Mundhöhlenseite einer Lippe",
      "Bösartige Neubildung der Wangenseite einer Lippe",
      "Bösartige Neubildung der inneren Lippe",
      "Bösartige Neubildung des Lippenfrenulums",
      "Karzinom der inneren Lippe",
      "Krebs der inneren Lippe",
      "Plattenepithelkarzinom der Innenseite der Lippe"
    ]
  },
  {
    "code": "C00.6",
    "name": "Bösartige Neubildung des Mundwinkels",
    "synonyms": [
      "Bösartige Neubildung der Lippenkommissur",
      "Bösartige Neubildung des Mundwinkels",
      "Mundwinkelkarzinom",
      "Mundwinkelkrebs",
      "Plattenepithelkarzinom der Lippenkommissur"
    ]
  },
  {
    "code": "C00.8",
    "name": "Plattenepithelkarzinom der Lippe, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Plattenepithelkarzinom der Lippe, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C00.9",
    "name": "Lippenkrebs",
    "synonyms": [
      "Bösartige Neubildung der Lippe",
      "Lippenkarzinom",
      "Lippenkrebs",
      "Plattenepithelkarzinom der Lippe"
    ]
  },
  {
    "code": "C01",
    "name": "Zungengrundkrebs",
    "synonyms": [
      "Bösartige Neubildung der Dorsalfläche der Zungenbasis",
      "Bösartige Neubildung der Zungenwurzel",
      "Bösartige Neubildung des Zungengrundes",
      "Bösartige Neubildung des fixierten Zungenteils",
      "Bösartige Neubildung des hinteren Drittels der Zunge",
      "Bösartige Neubildung des hinteren Zungenteils",
      "Bösartige Neubildung des unbeweglichen Zungenteils",
      "Karzinom des fixierten Zungenteils",
      "Zungengrundkarzinom",
      "Zungengrundkrebs",
      "Zungenwurzelkarzinom",
      "Zungenwurzelkrebs"
    ]
  },
  {
    "code": "C02.0",
    "name": "Oberflächlicher dorsaler Zungenkrebs",
    "synonyms": [
      "Bösartige Neubildung der Zungenmittellinie a.n.k.",
      "Bösartige Neubildung der dorsalen Zunge",
      "Bösartige Neubildung der dorsalen Zungenoberfläche",
      "Bösartige Neubildung der vorderen zwei Drittel der Dorsalfläche der Zunge",
      "Bösartige Neubildung des Zungenrückens",
      "Dorsaler Zungenkrebs",
      "Dorsales Zungenkarzinom",
      "Oberflächliche bösartige Neubildung der dorsalen Zunge",
      "Oberflächlicher dorsaler Zungenkrebs",
      "Oberflächliches dorsales Zungenkarzinom",
      "Zungenrückenkarzinom",
      "Zungenrückenkrebs"
    ]
  },
  {
    "code": "C02.1",
    "name": "Bösartige Neubildung der Zungenspitze",
    "synonyms": [
      "Bösartige Neubildung der Zungenspitze",
      "Bösartige Neubildung des Zungenrandes",
      "Bösartige Neubildung des Zungenrandes und der Zungenspitze",
      "Karzinom des Zungenrandes und der Zungenspitze",
      "Krebs des Zungenrandes und der Zungenspitze",
      "Zungenrandkarzinom",
      "Zungenrandkrebs"
    ]
  },
  {
    "code": "C02.2",
    "name": "Ventraler oberflächlicher Zungenkrebs",
    "synonyms": [
      "Bösartige Neubildung der Zungenunterfläche",
      "Bösartige Neubildung der ventralen Zungenoberfläche",
      "Bösartige Neubildung der vorderen zwei Drittel der Ventralfläche der Zunge",
      "Bösartige Neubildung des Frenulum linguae",
      "Bösartige Neubildung des Zungenfrenulums",
      "Karzinom der Zungenunterfläche",
      "Karzinom der ventralen Zunge",
      "Krebs der Zungenunterfläche",
      "Oberflächliches Karzinom der ventralen Zunge",
      "Ventraler Zungenkrebs",
      "Ventraler oberflächlicher Zungenkrebs"
    ]
  },
  {
    "code": "C02.3",
    "name": "Bösartige Neubildung des beweglichen Zungenteils",
    "synonyms": [
      "Bösartige Neubildung des beweglichen Zungenteils",
      "Bösartige Neubildung des mittleren Zungendrittels",
      "Bösartige Neubildung des vorderen Zungenteils a.n.k.",
      "Zungenkarzinom des beweglichen Zungenteils",
      "Zungenkrebs des beweglichen Zungenteils"
    ]
  },
  {
    "code": "C02.4",
    "name": "Karzinom der Zungenmandel",
    "synonyms": [
      "Bösartige Neubildung der Tonsilla lingualis",
      "Bösartige Neubildung der Zungenmandel",
      "Bösartige Neubildung der Zungentonsille",
      "Karzinom der Zungenmandel",
      "Karzinom der Zungentonsille",
      "Krebs der Zungentonsille",
      "Zungenmandelkrebs"
    ]
  },
  {
    "code": "C02.8",
    "name": "Bösartige Neubildung der Zunge an der Übergangszone",
    "synonyms": [
      "Bösartige Neubildung der Zunge an der Übergangszone"
    ]
  },
  {
    "code": "C02.9",
    "name": "Zungenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Zunge",
      "Linguale bösartige Neubildung a.n.k.",
      "Squamöses Karzinom der Zunge",
      "Zungenkarzinom",
      "Zungenkrebs"
    ]
  },
  {
    "code": "C03.0",
    "name": "Karzinom des oberen Zahnfleisches",
    "synonyms": [
      "Bösartige Neubildung der Oberkieferalveolarmukosa",
      "Bösartige Neubildung der Oberkieferalveolarschleimhaut",
      "Bösartige Neubildung der Oberkiefergingiva",
      "Bösartige Neubildung der Oberkieferweichteile",
      "Bösartige Neubildung des Oberkieferzahnfleisches",
      "Bösartige Neubildung des oberen Zahnfleisches",
      "Bösartige Neubildung einer Oberkieferalveole",
      "Karzinom des oberen Zahnfleisches",
      "Krebs des oberen Zahnfleisches",
      "Oberkieferalveolarfortsatzkarzinom"
    ]
  },
  {
    "code": "C03.1",
    "name": "Krebs des unteren Zahnfleisches",
    "synonyms": [
      "Bösartige Neubildung der Unterkieferalveolarmukosa",
      "Bösartige Neubildung der Unterkieferalveolarschleimhaut",
      "Bösartige Neubildung der Unterkiefergingiva",
      "Bösartige Neubildung der Unterkieferweichteile",
      "Bösartige Neubildung des Unterkieferzahnfleisches",
      "Bösartige Neubildung des unteren Zahnfleisches",
      "Bösartige Neubildung einer Unterkieferalveole",
      "Karzinom der Unterkieferalveolarschleimhaut",
      "Karzinom des unteren Zahnfleisches",
      "Krebs des unteren Zahnfleisches"
    ]
  },
  {
    "code": "C03.9",
    "name": "Zahnfleischkrebs",
    "synonyms": [
      "Alveolarfortsatzkarzinom",
      "Bösartige Neubildung der Alveolarmukosa",
      "Bösartige Neubildung der Alveolarschleimhaut",
      "Bösartige Neubildung der Gingiva",
      "Bösartige Neubildung der Kieferweichteile",
      "Bösartige Neubildung des Kieferbindegewebes a.n.k.",
      "Bösartige Neubildung des Zahnfleisches",
      "Bösartige Neubildung des periodontalen Gewebes a.n.k.",
      "Bösartige Neubildung einer Zahnalveole",
      "Bösartige Neubildung eines Zahnfachs a.n.k.",
      "Parodontale bösartige Neubildung a.n.k.",
      "Zahnfleischkarzinom",
      "Zahnfleischkrebs"
    ]
  },
  {
    "code": "C04.0",
    "name": "Bösartige Neubildung des vorderen Teils des Mundbodens",
    "synonyms": [
      "Bösartige Neubildung des vorderen Teils des Mundbodens",
      "Karzinom des vorderen Teils des Mundbodens",
      "Krebs des vorderen Teils des Mundbodens"
    ]
  },
  {
    "code": "C04.1",
    "name": "Bösartige Neubildung des seitlichen Teils des Mundbodens",
    "synonyms": [
      "Bösartige Neubildung des seitlichen Teils des Mundbodens",
      "Karzinom des seitlichen Teils des Mundbodens",
      "Krebs des seitlichen Teils des Mundbodens"
    ]
  },
  {
    "code": "C04.9",
    "name": "Mundbodenkrebs",
    "synonyms": [
      "Bösartige Neubildung des Mundbodens",
      "Karzinom des Sulcus glossoalveolaris",
      "Mundbodenkarzinom",
      "Mundbodenkrebs",
      "Sublinguale bösartige Neubildung"
    ]
  },
  {
    "code": "C05.0",
    "name": "Bösartige Neubildung des harten Gaumens",
    "synonyms": [
      "Bösartige Neubildung des harten Gaumens",
      "Karzinom des harten Gaumens",
      "Krebs des harten Gaumens"
    ]
  },
  {
    "code": "C05.1",
    "name": "Bösartige Neubildung des weichen Gaumens",
    "synonyms": [
      "Bösartige Neubildung des weichen Gaumens",
      "Karzinom des weichen Gaumens",
      "Krebs des weichen Gaumens"
    ]
  },
  {
    "code": "C05.2",
    "name": "Bösartige Neubildung der Uvula",
    "synonyms": [
      "Bösartige Neubildung der Uvula",
      "Uvulakarzinom",
      "Uvulakrebs"
    ]
  },
  {
    "code": "C05.8",
    "name": "Bösartige Neubildung des Überganges zwischen hartem und weichem Gaumen",
    "synonyms": [
      "Bösartige Neubildung des Überganges zwischen hartem und weichem Gaumen"
    ]
  },
  {
    "code": "C05.9",
    "name": "Bösartige Neubildung des Gaumens",
    "synonyms": [
      "Bösartige Neubildung des Gaumens",
      "Bösartige Neubildung des Mundhöhlendaches",
      "Gaumenkarzinom",
      "Gaumenkrebs"
    ]
  },
  {
    "code": "C06.0",
    "name": "Bösartige Neubildung der Wangenschleimhaut",
    "synonyms": [
      "Bösartige Neubildung der Mundschleimhaut a.n.k.",
      "Bösartige Neubildung der Wangeninnenseite",
      "Bösartige Neubildung der Wangenschleimhaut",
      "Bösartige Neubildung der bukkalen Schleimhaut",
      "Bösartige Neubildung der inneren Wange",
      "Malignes Melanom der Mundschleimhaut",
      "Mundschleimhautkarzinom",
      "Mundschleimhautkrebs",
      "Plattenepithelkarzinom der Wangenschleimhaut",
      "Wangenschleimhautkarzinom",
      "Wangenschleimhautkrebs"
    ]
  },
  {
    "code": "C06.1",
    "name": "Bösartige Neubildung des vorderen Teils des Mundes",
    "synonyms": [
      "Bösartige Neubildung der Lippenumschlagsfalte",
      "Bösartige Neubildung der Wangenumschlagsfalte",
      "Bösartige Neubildung der oberen Lippenumschlagsfalte",
      "Bösartige Neubildung der oberen Wangenumschlagsfalte",
      "Bösartige Neubildung der unteren Lippenumschlagsfalte",
      "Bösartige Neubildung der unteren Wangenumschlagsfalte",
      "Bösartige Neubildung des Vestibulum oris",
      "Bösartige Neubildung des bukkalen Sulkus",
      "Bösartige Neubildung des labialen Sulkus",
      "Bösartige Neubildung des vorderen Teils des Mundes",
      "Karzinom des vorderen Teils des Mundes",
      "Krebs des vorderen Teils des Mundes",
      "Plattenepithelkarzinom des Vestibulum oris"
    ]
  },
  {
    "code": "C06.2",
    "name": "Bösartige Neubildung der Retromolarregion",
    "synonyms": [
      "Bösartige Neubildung der Retromolarregion",
      "Karzinom der Retromolarregion",
      "Krebs der Retromolarregion",
      "Plattenepithelkarzinom der Retromolarregion"
    ]
  },
  {
    "code": "C06.9",
    "name": "Mundhöhlenkarzinom",
    "synonyms": [
      "Bukkale bösartige Neubildung",
      "Bösartige Neubildung der Mundhöhle",
      "Bösartige Neubildung der Nebenspeicheldrüsen a.n.k.",
      "Bösartige Neubildung kleiner Speicheldrüsen",
      "Karzinom der Mundhöhle",
      "Mundhöhlenkarzinom",
      "Mundkarzinom",
      "Mundkrebs",
      "Plattenepithelkarzinom der Mundhöhle"
    ]
  },
  {
    "code": "C07",
    "name": "Bösartige Neubildung der Parotis",
    "synonyms": [
      "Bösartige Neubildung der Ohrspeicheldrüse",
      "Bösartige Neubildung der Parotis",
      "Bösartige Neubildung des Ductus parotideus",
      "Bösartige Neubildung des Stensen-Ganges",
      "Karzinom der Glandula parotis",
      "Maligner epithelialer Tumor der Glandula parotis",
      "Ohrspeicheldrüsenkarzinom",
      "Ohrspeicheldrüsenkrebs",
      "Parotiskarzinom",
      "Parotiskrebs"
    ]
  },
  {
    "code": "C08.0",
    "name": "Bösartige Neubildung der Glandula submandibularis",
    "synonyms": [
      "Bösartige Neubildung der Glandula submandibularis",
      "Bösartige Neubildung der Glandula submaxillaris",
      "Bösartige Neubildung der Unterkieferspeicheldrüse",
      "Bösartige Neubildung des Ductus submandibularis",
      "Bösartige Neubildung des Wharton-Ganges",
      "Karzinom der Glandula submandibularis",
      "Krebs der Glandula submandibularis",
      "Maligner epithelialer Tumor der Glandula submandibularis",
      "Unterkieferspeicheldrüsenkarzinom",
      "Unterkieferspeicheldrüsenkrebs"
    ]
  },
  {
    "code": "C08.1",
    "name": "Bösartige Neubildung der Glandula sublingualis",
    "synonyms": [
      "Bösartige Neubildung der Glandula sublingualis",
      "Bösartige Neubildung der Unterzungendrüse",
      "Bösartige Neubildung der Unterzungenspeicheldrüse",
      "Bösartige Neubildung des Ductus sublingualis",
      "Karzinom der Glandula sublingualis",
      "Krebs der Glandula sublingualis",
      "Maligner epithelialer Tumor der Glandula sublingualis",
      "Unterzungendrüsenkarzinom",
      "Unterzungendrüsenkrebs"
    ]
  },
  {
    "code": "C08.9",
    "name": "Speicheldrüsenkarzinom",
    "synonyms": [
      "Basalzelladenokarzinom",
      "Bösartige Neubildung einer Speicheldrüse",
      "Bösartige Neubildung großer Speicheldrüsen",
      "Speicheldrüsenkarzinom",
      "Speicheldrüsenkrebs"
    ]
  },
  {
    "code": "C09.0",
    "name": "Bösartige Neubildung der Fossa tonsillaris",
    "synonyms": [
      "Bösartige Neubildung der Fossa tonsillaris",
      "Bösartige Neubildung des glossopharyngealen Sulkus",
      "Karzinom der Fossa tonsillaris",
      "Karzinom des Sulcus glossopharyngeus",
      "Krebs der Fossa tonsillaris"
    ]
  },
  {
    "code": "C09.1",
    "name": "Bösartige Neubildung des Gaumenbogens",
    "synonyms": [
      "Bösartige Neubildung der Gaumenbogentonsillen",
      "Bösartige Neubildung des Arcus palatoglossus",
      "Bösartige Neubildung des Arcus palatopharyngeus",
      "Bösartige Neubildung des Gaumenbogens",
      "Gaumenbogenkarzinom",
      "Gaumenbogenkrebs",
      "Karzinom des Sulcus glossopalatinus"
    ]
  },
  {
    "code": "C09.9",
    "name": "Tonsillenkrebs",
    "synonyms": [
      "Angiosarkom der Tonsillen",
      "Bösartige Neubildung der Fauces",
      "Bösartige Neubildung der Gaumenmandel",
      "Bösartige Neubildung der Gaumentonsille",
      "Bösartige Neubildung der Schlundtonsille",
      "Bösartige Neubildung der Tonsilla palatina",
      "Bösartige Neubildung der Tonsillen",
      "Tonsillenkarzinom",
      "Tonsillenkrebs"
    ]
  },
  {
    "code": "C10.0",
    "name": "Bösartige Neubildung der Vallecula epiglottica",
    "synonyms": [
      "Bösartige Neubildung der Vallecula epiglottica",
      "Karzinom der Vallecula epiglottica",
      "Krebs der Vallecula epiglottica",
      "Plattenepithelkarzinom der Vallecula epiglottica"
    ]
  },
  {
    "code": "C10.1",
    "name": "Bösartige Neubildung des vorderen Kehldeckels",
    "synonyms": [
      "Bösartige Neubildung der Epiglottisoberfläche",
      "Bösartige Neubildung der Epiglottisvorderfläche",
      "Bösartige Neubildung der Plica glossoepiglottica",
      "Bösartige Neubildung des freien Randes der Epiglottis",
      "Bösartige Neubildung des vorderen Kehldeckels",
      "Karzinom des vorderen Kehldeckels",
      "Krebs des vorderen Kehldeckels",
      "Plattenepithelkarzinom der Epiglottisvorderfläche"
    ]
  },
  {
    "code": "C10.2",
    "name": "Karzinom der seitlichen Wand des Rachenrings",
    "synonyms": [
      "Bösartige Neubildung der Seitenwand des Oropharynx",
      "Bösartige Neubildung des seitlichen Rachenrings",
      "Karzinom der seitlichen Wand des Rachenrings",
      "Krebs des seitlichen Rachenrings",
      "Plattenepithelkarzinom der Seitenwand des Oropharynx"
    ]
  },
  {
    "code": "C10.3",
    "name": "Bösartige Neubildung des hinteren Rachenrings",
    "synonyms": [
      "Bösartige Neubildung der Hinterwand des Oropharynx",
      "Bösartige Neubildung des hinteren Rachenrings",
      "Karzinom des hinteren Rachenrings",
      "Krebs des hinteren Rachenrings",
      "Plattenepithelkarzinom der Hinterwand des Oropharynx"
    ]
  },
  {
    "code": "C10.4",
    "name": "Branchiogenes Karzinom",
    "synonyms": [
      "Branchiales Karzinom",
      "Branchiogenes Karzinom",
      "Bösartige Neubildung der Kiemenspalte",
      "Bösartige Neubildung einer branchiogenen Zyste",
      "Plattenepithelkarzinom einer branchiogenen Zyste"
    ]
  },
  {
    "code": "C10.8",
    "name": "Bösartige Neubildung der Verbindungszone des Rachenrings",
    "synonyms": [
      "Bösartige Neubildung der Verbindungszone des Rachenrings",
      "Bösartige Neubildung der Übergangsregion des Oropharynx",
      "Karzinom der Verbindungszone [Übergangsregion] des Rachenrings",
      "Krebs der Verbindungszone des Rachenrings",
      "Plattenepithelkarzinom des Oropharynx, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C10.9",
    "name": "Oropharynxkarzinom",
    "synonyms": [
      "Bösartige Neubildung des Oropharynx",
      "Bösartige Neubildung des Rachenrings",
      "Mesopharynxkarzinom",
      "Oropharynxkarzinom",
      "Plattenepithelkarzinom des Oropharynx",
      "Rachenringkarzinom",
      "Rachenringkrebs"
    ]
  },
  {
    "code": "C11.0",
    "name": "Bösartige Neubildung des oberen Nasenrachenraums",
    "synonyms": [
      "Bösartige Neubildung der oberen Wand des Nasenrachenraums",
      "Bösartige Neubildung des Daches des Nasenrachenraums",
      "Bösartige Neubildung des Nasopharynxdaches",
      "Bösartige Neubildung des oberen Nasenrachenraums",
      "Karzinom des oberen Nasenrachenraums",
      "Krebs des oberen Nasenrachenraums",
      "Malignes Teratom der oberen Wand des Nasopharynx"
    ]
  },
  {
    "code": "C11.1",
    "name": "Rachenmandelkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Adenoide",
      "Bösartige Neubildung der Pharynxtonsille",
      "Bösartige Neubildung der Rachenmandel",
      "Bösartige Neubildung der Rachentonsille",
      "Bösartige Neubildung der Tonsilla pharyngea",
      "Bösartige Neubildung der hinteren Wand des Nasenrachenraums",
      "Bösartige Neubildung des hinteren Nasenrachenraums",
      "Karzinom der Adenoide",
      "Karzinom des hinteren Nasenrachenraums",
      "Krebs des hinteren Nasenrachenraums",
      "Malignes Teratom der Hinterwand des Nasopharynx",
      "Rachenmandelkarzinom"
    ]
  },
  {
    "code": "C11.2",
    "name": "Bösartige Neubildung des seitlichen Nasenrachenraums",
    "synonyms": [
      "Bösartige Neubildung der Rosenmüller-Grube",
      "Bösartige Neubildung der seitlichen Wand des Nasenrachenraums",
      "Bösartige Neubildung des Ostium pharyngeum der Tuba auditiva",
      "Bösartige Neubildung des Recessus pharyngeus",
      "Bösartige Neubildung des pharyngealen Recessus",
      "Bösartige Neubildung des pharyngealen Tubenostiums",
      "Bösartige Neubildung des seitlichen Nasenrachenraums",
      "Karzinom des seitlichen Nasenrachenraums",
      "Krebs des seitlichen Nasenrachenraums",
      "Malignes Teratom der Seitenwand des Nasopharynx"
    ]
  },
  {
    "code": "C11.3",
    "name": "Bösartige Neubildung des vorderen Nasenrachenraums",
    "synonyms": [
      "Bösartige Neubildung der Choane",
      "Bösartige Neubildung der anterioren nasopharyngealen Fläche des weichen Gaumens",
      "Bösartige Neubildung der nasopharyngealen Fläche des weichen Gaumens",
      "Bösartige Neubildung der pharyngealen Fornix",
      "Bösartige Neubildung der posterioren nasopharyngealen Fläche des weichen Gaumens",
      "Bösartige Neubildung der vorderen Wand des Nasenrachenraums",
      "Bösartige Neubildung des Bodens des Nasenrachenraums",
      "Bösartige Neubildung des Choanenhinterrandes",
      "Bösartige Neubildung des Daches des weichen Gaumens",
      "Bösartige Neubildung des Fornix pharyngis",
      "Bösartige Neubildung des Nasenseptumhinterrandes",
      "Bösartige Neubildung des Nasopharynxbodens",
      "Bösartige Neubildung des hinteren Randes des Nasenseptums",
      "Bösartige Neubildung des vorderen Nasenrachenraums",
      "Karzinom des vorderen Nasenrachenraums",
      "Krebs des vorderen Nasenrachenraums",
      "Malignes Teratom der Vorderwand des Nasopharynx"
    ]
  },
  {
    "code": "C11.8",
    "name": "Nasopharynxkarzinom, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Malignes Nasopharynxteratom, mehrere Teilbereiche überlappend",
      "Nasopharynxkarzinom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C11.9",
    "name": "Karzinom des Epipharynx",
    "synonyms": [
      "Bösartige Neubildung der Nasopharynxwand",
      "Bösartige Neubildung der Wand des Nasenrachenraums",
      "Bösartige Neubildung des Nasenrachenraums",
      "Bösartige Neubildung des Nasopharynx",
      "Karzinom des Epipharynx",
      "Malignes Nasopharynxteratom",
      "Nasenrachenraumkarzinom",
      "Nasenrachenraumkrebs",
      "Nasopharynxkarzinom",
      "Schmincke-Karzinom",
      "Schmincke-Tumor"
    ]
  },
  {
    "code": "C12",
    "name": "Bösartige Neubildung des Recessus piriformis",
    "synonyms": [
      "Bösartige Neubildung der Fossa piriformis",
      "Bösartige Neubildung des Recessus piriformis",
      "Bösartige Neubildung des Sinus piriformis",
      "Karzinom des Recessus piriformis",
      "Karzinom des Sinus piriformis",
      "Krebs des Recessus piriformis",
      "Plattenepithelkarzinom des Recessus piriformis",
      "Plattenepithelkarzinom des Sinus piriformis"
    ]
  },
  {
    "code": "C13.0",
    "name": "Bösartige Neubildung des postkrikoidalen Hypopharynx",
    "synonyms": [
      "Bösartige Neubildung der Regio postcricoidea",
      "Bösartige Neubildung des Krikopharynx",
      "Bösartige Neubildung des postkrikoidalen Hypopharynx",
      "Karzinom des postkrikoidalen Hypopharynx",
      "Krebs des postkrikoidalen Hypopharynx",
      "Plattenepithelkarzinom des postkrikoidalen Hypopharynx"
    ]
  },
  {
    "code": "C13.1",
    "name": "Bösartige Neubildung der Plica aryepiglottica",
    "synonyms": [
      "Bösartige Neubildung der Plica aryepiglottica",
      "Bösartige Neubildung der Randzone der Plica aryepiglottica",
      "Bösartige Neubildung der Randzone der aryepiglottischen Falte",
      "Bösartige Neubildung der aryepiglottischen Falte",
      "Bösartige Neubildung der hypopharyngealen Seite der Plica aryepiglottica",
      "Bösartige Neubildung der hypopharyngealen Seite der aryepiglottischen Falte",
      "Karzinom der Plica aryepiglottica",
      "Krebs der Plica aryepiglottica",
      "Plattenepithelkarzinom der aryepiglottischen Falte"
    ]
  },
  {
    "code": "C13.2",
    "name": "Bösartige Neubildung der hinteren Wand des Hypopharynx",
    "synonyms": [
      "Bösartige Neubildung der hinteren Wand des Hypopharynx",
      "Plattenepithelkarzinom der hinteren Wand des Hypopharynx"
    ]
  },
  {
    "code": "C13.8",
    "name": "Plattenepithelkarzinom des Hypopharynx, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Plattenepithelkarzinom des Hypopharynx, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C13.9",
    "name": "Krebs des Hypopharynx",
    "synonyms": [
      "Bösartige Neubildung der Hypopharynxwand",
      "Bösartige Neubildung des Hypopharynx",
      "Bösartige Neubildung des Laryngopharynx",
      "Karzinom des Hypopharynx",
      "Krebs des Hypopharynx",
      "Plattenepithelkarzinom des Hypopharynx"
    ]
  },
  {
    "code": "C14.0",
    "name": "Rachenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Pharynxwand",
      "Bösartige Neubildung der hinteren Rachenwand",
      "Bösartige Neubildung des Pharynx",
      "Bösartige Neubildung des Rachens",
      "Karzinom der hinteren Rachenwand",
      "Krebs der hinteren Rachenwand",
      "Pharynxkarzinom",
      "Rachenkarzinom",
      "Rachenkrebs",
      "Retropharyngeale bösartige Neubildung"
    ]
  },
  {
    "code": "C14.2",
    "name": "Bösartige Neubildung des Waldeyer-Rachenrings",
    "synonyms": [
      "Bösartige Neubildung des Waldeyer-Rachenrings",
      "Karzinom des Waldeyer-Rachenrings",
      "Krebs des Waldeyer-Rachenrings"
    ]
  },
  {
    "code": "C14.8",
    "name": "Bösartige Neubildung des Mundrachenraums",
    "synonyms": [
      "Bösartige Neubildung des Mundrachenraums",
      "Karzinom des Mundrachenraums",
      "Krebs des Mundrachenraums"
    ]
  },
  {
    "code": "C15.0",
    "name": "Bösartige Neubildung des zervikalen Ösophagus",
    "synonyms": [
      "Bösartige Neubildung der Pars cervicalis des Ösophagus",
      "Bösartige Neubildung des zervikalen Ösophagus",
      "GIST [Gastrointestinaler Stromatumor] des zervikalen Ösophagus",
      "Gastrointestinaler Stromatumor des zervikalen Ösophagus",
      "Neuroendokrine Neoplasie des zervikalen Ösophagus",
      "Plattenepithelkarzinom des zervikalen Ösophagus",
      "Zervikales undifferenziertes Ösophaguskarzinom",
      "Zervikales Ösophaguskarzinom",
      "Zervikales Ösophaguskarzinom vom Speicheldrüsentyp"
    ]
  },
  {
    "code": "C15.1",
    "name": "Bösartige Neubildung des thorakalen Ösophagus",
    "synonyms": [
      "Bösartige Neubildung der Pars thoracica des Ösophagus",
      "Bösartige Neubildung des thorakalen Ösophagus",
      "GIST [Gastrointestinaler Stromatumor] des thorakalen Ösophagus",
      "Gastrointestinaler Stromatumor des thorakalen Ösophagus",
      "Neuroendokrine Neoplasie des thorakalen Ösophagus",
      "Plattenepithelkarzinom des thorakalen Ösophagus",
      "Thorakales undifferenziertes Ösophaguskarzinom",
      "Thorakales Ösophaguskarzinom",
      "Thorakales Ösophaguskarzinom vom Speicheldrüsentyp"
    ]
  },
  {
    "code": "C15.2",
    "name": "Bösartige Neubildung des abdominalen Ösophagus",
    "synonyms": [
      "Abdominales undifferenziertes Ösophaguskarzinom",
      "Abdominales Ösophaguskarzinom",
      "Abdominales Ösophaguskarzinom vom Speicheldrüsentyp",
      "Adenokarzinom des abdominalen Ösophagus",
      "Bösartige Neubildung der Pars abdominalis des Ösophagus",
      "Bösartige Neubildung des abdominalen Ösophagus",
      "GIST [Gastrointestinaler Stromatumor] des abdominalen Ösophagus",
      "Gastrointestinaler Stromatumor des abdominalen Ösophagus",
      "Neuroendokrine Neoplasie des abdominalen Ösophagus"
    ]
  },
  {
    "code": "C15.3",
    "name": "Bösartige Neubildung des oberen Drittels des Ösophagus",
    "synonyms": [
      "Bösartige Neubildung des oberen Drittels des Ösophagus",
      "Bösartige Neubildung des proximalen Drittels des Ösophagus",
      "GIST [Gastrointestinaler Stromatumor] des oberen Drittels des Ösophagus",
      "Gastrointestinaler Stromatumor des oberen Drittels des Ösophagus",
      "Karzinom des oberen Drittels des Ösophagus",
      "Karzinom vom Speicheldrüsentyp des oberen Drittels des Ösophagus",
      "Neuroendokrine Neoplasie des oberen Drittels des Ösophagus",
      "Plattenepithelkarzinom des oberen Drittels des Ösophagus",
      "Undifferenziertes Karzinom des oberen Drittels des Ösophagus"
    ]
  },
  {
    "code": "C15.4",
    "name": "Bösartige Neubildung des mittleren Drittels des Ösophagus",
    "synonyms": [
      "Bösartige Neubildung des mittleren Drittels des Ösophagus",
      "GIST [Gastrointestinaler Stromatumor] des mittleren Drittels des Ösophagus",
      "Gastrointestinaler Stromatumor des mittleren Drittels des Ösophagus",
      "Karzinom des mittleren Drittels des Ösophagus",
      "Karzinom vom Speicheldrüsentyp des mittleren Drittels des Ösophagus",
      "Neuroendokrine Neoplasie des mittleren Drittels des Ösophagus",
      "Plattenepithelkarzinom des mittleren Drittels des Ösophagus",
      "Undifferenziertes Karzinom des mittleren Drittels des Ösophagus"
    ]
  },
  {
    "code": "C15.5",
    "name": "Bösartige Neubildung des unteren Drittels des Ösophagus",
    "synonyms": [
      "Adenokarzinom des unteren Drittels des Ösophagus",
      "Bösartige Neubildung des distalen Drittels des Ösophagus",
      "Bösartige Neubildung des unteren Drittels des Ösophagus",
      "Distales Ösophaguskarzinom",
      "GIST [Gastrointestinaler Stromatumor] des unteren Drittels des Ösophagus",
      "Gastrointestinaler Stromatumor des unteren Drittels des Ösophagus",
      "Karzinom des unteren Drittels des Ösophagus",
      "Karzinom vom Speicheldrüsentyp des unteren Drittels des Ösophagus",
      "Neuroendokrine Neoplasie des unteren Drittels des Ösophagus",
      "Undifferenziertes Karzinom des unteren Drittels des Ösophagus"
    ]
  },
  {
    "code": "C15.8",
    "name": "Neuroendokrine Neoplasie des Ösophagus, mehrere Teilbereiche überlappend",
    "synonyms": [
      "GIST [Gastrointestinaler Stromatumor] des Ösophagus, mehrere Teilbereiche überlappend",
      "Gastrointestinaler Stromatumor des Ösophagus, mehrere Teilbereiche überlappend",
      "Neuroendokrine Neoplasie des Ösophagus, mehrere Teilbereiche überlappend",
      "Undifferenziertes Ösophaguskarzinom, mehrere Teilbereiche überlappend",
      "Ösophaguskarzinom vom Speicheldrüsentyp, mehrere Teilbereiche überlappend",
      "Ösophaguskarzinom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C15.9",
    "name": "Ösophagusbasaliom",
    "synonyms": [
      "Adenokarzinom des Ösophagus",
      "Barrett-Karzinom",
      "Bösartige Neubildung der Speiseröhre",
      "Bösartige Neubildung des Ösophagus",
      "GIST [Gastrointestinaler Stromatumor] des Ösophagus",
      "Gastrointestinaler Stromatumor des Ösophagus",
      "Neuroendokrine Neoplasie des Ösophagus",
      "Neuroendokriner Tumor des Ösophagus",
      "Plattenepithelkarzinom des Ösophagus",
      "Speiseröhrenkarzinom",
      "Speiseröhrenkrebs",
      "Undifferenziertes Ösophaguskarzinom",
      "Ösophagusbasaliom",
      "Ösophaguskarzinom",
      "Ösophaguskarzinom vom Speicheldrüsentyp",
      "Ösophaguskrebs"
    ]
  },
  {
    "code": "C16.0",
    "name": "Krebs der Kardia",
    "synonyms": [
      "Adenokarzinom der Kardia",
      "Bösartige Neubildung der Kardia",
      "Bösartige Neubildung des Mageneingangs",
      "Bösartige Neubildung des Ostium cardiacum des Ösophagus",
      "Bösartige Neubildung des Speiseröhren-Magen-Überganges",
      "Bösartige Neubildung des gastroösophagealen Überganges",
      "Bösartige Neubildung des kardioösophagealen Überganges",
      "Bösartige Neubildung des Ösophagus-Magen-Überganges",
      "Bösartige Neubildung des ösophagogastrischen Überganges",
      "Bösartiger Kardiatumor",
      "Epstein-Barr-Virus-assoziiertes Karzinom der Kardia",
      "Familiärer maligner neuroendokriner Tumor der Kardia Typ 1",
      "GIST [Gastrointestinaler Stromatumor] der Kardia",
      "Gastrointestinaler Stromatumor der Kardia",
      "Hereditäres diffuses Karzinom der Kardia",
      "Kardiakarzinom des Magens",
      "Karzinom der Kardia",
      "Karzinom der Kardia bei Lynch-Syndrom",
      "Karzinom des Magenmundes",
      "Krebs der Kardia",
      "Linitis plastica der Kardia",
      "Mageneingangskarzinom",
      "Magenkarzinom der Kardiaregion",
      "Maligner neuroendokriner Tumor der Kardia",
      "Plattenepithelkarzinom der Kardia",
      "Plattenepithelkarzinom des Speiseröhren-Magen-Überganges",
      "Plattenepithelkarzinom des gastroösophagealen Überganges",
      "Undifferenziertes Karzinom der Kardia"
    ]
  },
  {
    "code": "C16.1",
    "name": "Bösartige Neubildung des Fundus ventriculi",
    "synonyms": [
      "Bösartige Neubildung des Fundus ventriculi",
      "Bösartige Neubildung des Magenfundus",
      "Familiärer maligner neuroendokriner Tumor des Magenfundus Typ 1",
      "GIST [Gastrointestinaler Stromatumor] des Fundus ventriculi",
      "Gastrointestinaler Stromatumor des Fundus ventriculi",
      "Hereditäres diffuses Karzinom des Magenfundus",
      "Karzinom der Magenkuppel",
      "Karzinom des Fundus ventriculi",
      "Karzinom des Fundus ventriculi bei Lynch-Syndrom",
      "Krebs des Fundus ventriculi",
      "Linitis plastica des Magenfundus",
      "Maligner neuroendokriner Tumor des Magenfundus",
      "Plattenepithelkarzinom des Fundus ventriculi",
      "Plattenepithelkarzinom des Magenfundus",
      "Undifferenziertes Karzinom des Magenfundus"
    ]
  },
  {
    "code": "C16.2",
    "name": "Bösartige Neubildung des Corpus ventriculi",
    "synonyms": [
      "Bösartige Neubildung des Corpus ventriculi",
      "Bösartige Neubildung des Magenkorpus",
      "Epstein-Barr-Virus-assoziiertes Karzinom des Magenkorpus",
      "Familiärer maligner neuroendokriner Tumor des Magenkorpus Typ 1",
      "GIST [Gastrointestinaler Stromatumor] des Corpus ventriculi",
      "Gastrointestinaler Stromatumor des Corpus ventriculi",
      "Hereditäres diffuses Karzinom des Magenkorpus",
      "Karzinom des Corpus ventriculi",
      "Karzinom des Corpus ventriculi bei Lynch-Syndrom",
      "Korpuskarzinom des Magens",
      "Krebs des Corpus ventriculi",
      "Linitis plastica des Magenkorpus",
      "Maligner neuroendokriner Tumor des Magenkorpus",
      "Plattenepithelkarzinom des Corpus ventriculi",
      "Undifferenziertes Karzinom des Magenkorpus"
    ]
  },
  {
    "code": "C16.3",
    "name": "Bösartige Neubildung des Antrum pyloricum",
    "synonyms": [
      "Bösartige Neubildung des Antrum pyloricum",
      "Bösartige Neubildung des Magenantrums",
      "Bösartige Neubildung des Magenvorhofs",
      "Familiärer maligner neuroendokriner Tumor des Magenantrums Typ 1",
      "GIST [Gastrointestinaler Stromatumor] des Antrum pyloricum",
      "Gastrointestinaler Stromatumor des Antrum pyloricum",
      "Hereditäres diffuses Karzinom des Magenantrums",
      "Karzinom des Antrum pyloricum",
      "Karzinom des Antrum pyloricum bei Lynch-Syndrom",
      "Karzinom des Magenantrums",
      "Krebs des Antrum pyloricum",
      "Linitis plastica des Magenantrums",
      "Maligner neuroendokriner Tumor des Magenantrums",
      "Plattenepithelkarzinom des Antrum pyloricum",
      "Plattenepithelkarzinom des Magenvorhofs",
      "Siegelringzellenkarzinom des Magenantrums",
      "Undifferenziertes Karzinom des Magenantrums"
    ]
  },
  {
    "code": "C16.4",
    "name": "Bösartige Neubildung des Pylorus",
    "synonyms": [
      "Bösartige Neubildung des Canalis pyloricus",
      "Bösartige Neubildung des Präpylorus",
      "Bösartige Neubildung des Pylorus",
      "Familiärer maligner neuroendokriner Tumor des Pylorus Typ 1",
      "GIST [Gastrointestinaler Stromatumor] des Pylorus",
      "Gastrointestinaler Stromatumor des Pylorus",
      "Hereditäres diffuses Karzinom des Pylorus",
      "Karzinom des Pylorus bei Lynch-Syndrom",
      "Linitis plastica des Pylorus",
      "Magenausgangskarzinom",
      "Maligner neuroendokriner Tumor des Pylorus",
      "Plattenepithelkarzinom des Canalis pyloricus",
      "Plattenepithelkarzinom des Präpylorus",
      "Plattenepithelkarzinom des Pylorus",
      "Pyloruskarzinom",
      "Pyloruskrebs",
      "Undifferenziertes Karzinom des Pylorus"
    ]
  },
  {
    "code": "C16.5",
    "name": "Bösartige Neubildung der kleinen Magenkurvatur",
    "synonyms": [
      "Bösartige Neubildung der kleinen Magenkurvatur",
      "Familiärer maligner neuroendokriner Tumor der kleinen Magenkurvatur Typ 1",
      "GIST [Gastrointestinaler Stromatumor] der kleinen Magenkurvatur",
      "Gastrointestinaler Stromatumor der kleinen Magenkurvatur",
      "Hereditäres diffuses Karzinom der kleinen Magenkurvatur",
      "Karzinom der kleinen Magenkurvatur",
      "Karzinom der kleinen Magenkurvatur bei Lynch-Syndrom",
      "Krebs der kleinen Magenkurvatur",
      "Linitis plastica der kleinen Magenkurvatur",
      "Maligner neuroendokriner Tumor der kleinen Magenkurvatur",
      "Plattenepithelkarzinom der kleinen Magenkurvatur",
      "Undifferenziertes Karzinom der kleinen Magenkurvatur"
    ]
  },
  {
    "code": "C16.6",
    "name": "Bösartige Neubildung der großen Magenkurvatur",
    "synonyms": [
      "Bösartige Neubildung der großen Magenkurvatur",
      "Familiärer maligner neuroendokriner Tumor der großen Magenkurvatur Typ 1",
      "GIST [Gastrointestinaler Stromatumor] der großen Magenkurvatur",
      "Gastrointestinaler Stromatumor der großen Magenkurvatur",
      "Hereditäres diffuses Karzinom der großen Magenkurvatur",
      "Karzinom der großen Magenkurvatur",
      "Karzinom der großen Magenkurvatur bei Lynch-Syndrom",
      "Linitis plastica der großen Magenkurvatur",
      "Maligner neuroendokriner Tumor der großen Magenkurvatur",
      "Plattenepithelkarzinom der großen Magenkurvatur",
      "Undifferenziertes Karzinom der großen Magenkurvatur"
    ]
  },
  {
    "code": "C16.8",
    "name": "Bösartige Neubildung der vorderen Magenwand a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der hinteren Magenwand a.n.k.",
      "Bösartige Neubildung der vorderen Magenwand a.n.k.",
      "Familiärer benigner neuroendokriner Tumor des Magens Typ 1, mehrere Teilbereiche überlappend",
      "GIST [Gastrointestinaler Stromatumor] des Magens, mehrere Teilbereiche überlappend",
      "Gastrointestinaler Stromatumor des Magens, mehrere Teilbereiche überlappend",
      "Hereditäres diffuses Magenkarzinom, mehrere Teilbereiche überlappend",
      "Karzinom der hinteren Magenwand bei Lynch-Syndrom",
      "Karzinom der vorderen Magenwand bei Lynch-Syndrom",
      "Linitis plastica des Magens, mehrere Teilbereiche überlappend",
      "Maligner neuroendokriner Tumor des Magens, mehrere Teilbereiche überlappend",
      "Plattenepithelkarzinom der hinteren Magenwand",
      "Plattenepithelkarzinom der vorderen Magenwand",
      "Undifferenziertes Magenkarzinom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C16.9",
    "name": "Magenkarzinom",
    "synonyms": [
      "Adenokarzinom des Magens",
      "Bösartige Neubildung der Magenwand a.n.k.",
      "Bösartige Neubildung des Magens",
      "Diffuses Adenokarzinom des Magens",
      "Diffuses Magenkarzinom",
      "Epstein-Barr-Virus-assoziiertes Magenkarzinom",
      "Familiärer diffuser Krebs des Magens",
      "Familiärer diffuser Magenkrebs",
      "Familiärer maligner neuroendokriner Tumor des Magens Typ 1",
      "GAPPS [Gastrales Adenokarzinom mit proximaler Polypose des Magens]",
      "GIST [Gastrointestinaler Stromatumor] des Magens",
      "Gastrales Adenokarzinom mit proximaler Polypose des Magens",
      "Gastrointestinaler Stromatumor des Magens",
      "Gastrokarzinom",
      "Hereditäres diffuses Magenkarzinom",
      "Hereditäres diffuses gastrisches Adenokarzinom",
      "Intestinaler Typ des Adenokarzinoms",
      "Lederbeutelmagen",
      "Leiomyosarkom des Magens",
      "Linitis plastica",
      "Linitis plastica bei szirrhösem Magenkarzinom",
      "Linitis plastica des Magens",
      "Magenfrühkarzinom",
      "Magenkarzinom",
      "Magenkarzinom bei Lynch-Syndrom",
      "Magenkrebs",
      "Magenkrebs Typ Borrmann 4",
      "Magenmalignom",
      "Magenstumpfkarzinom",
      "Maligner neuroendokriner Tumor des Magens",
      "Plattenepithelkarzinom des Magens",
      "Schrumpfmagen",
      "Siegelringzellenkarzinom des Magens",
      "Undifferenziertes Magenkarzinom"
    ]
  },
  {
    "code": "C17.0",
    "name": "Bösartige Neubildung des Duodenums",
    "synonyms": [
      "Adenokarzinom des Duodenums",
      "Adenokarzinom des Zwölffingerdarmes",
      "Bösartige Neubildung des Duodenums",
      "Bösartige Neubildung des Zwölffingerdarmes",
      "Duodenalkarzinom",
      "Duodenalkrebs",
      "GIST [Gastrointestinaler Stromatumor] des Duodenums",
      "Gastrointestinaler Stromatumor des Duodenums",
      "Karzinom des Duodenums bei Lynch-Syndrom",
      "Leiomyosarkom des Duodenums",
      "Maligner neuroendokriner Tumor des Duodenums",
      "Plattenepithelkarzinom des Duodenums",
      "Plattenepithelkarzinom des Zwölffingerdarmes",
      "Somatostatinom des Duodenums",
      "Zwölffingerdarmkarzinom",
      "Zwölffingerdarmkrebs"
    ]
  },
  {
    "code": "C17.1",
    "name": "Bösartige Neubildung des Jejunums",
    "synonyms": [
      "Adenokarzinom des Jejunums",
      "Bösartige Neubildung des Jejunums",
      "GIST [Gastrointestinaler Stromatumor] des Jejunums",
      "Gastrointestinaler Stromatumor des Jejunums",
      "Jejunumkarzinom",
      "Jejunumkrebs",
      "Karzinom des Jejunums bei Lynch-Syndrom",
      "Leiomyosarkom des Jejunums",
      "Maligner neuroendokriner Tumor des Jejunums",
      "Plattenepithelkarzinom des Jejunums"
    ]
  },
  {
    "code": "C17.2",
    "name": "Ileumkarzinoid",
    "synonyms": [
      "Adenokarzinom des Ileums",
      "Bösartige Neubildung des Ileums",
      "GIST [Gastrointestinaler Stromatumor] des Ileums",
      "Gastrointestinaler Stromatumor des Ileums",
      "Ileumkarzinoid",
      "Ileumkarzinom",
      "Ileumkrebs",
      "Karzinom des Ileums bei Lynch-Syndrom",
      "Leiomyosarkom des Ileums",
      "Maligner neuroendokriner Tumor des Ileums",
      "Plattenepithelkarzinom des Ileums"
    ]
  },
  {
    "code": "C17.3",
    "name": "Bösartige Neubildung eines Meckel-Divertikels",
    "synonyms": [
      "Adenokarzinom eines Meckel-Divertikels",
      "Bösartige Neubildung eines Meckel-Divertikels",
      "GIST [Gastrointestinaler Stromatumor] eines Meckel-Divertikels",
      "Gastrointestinaler Stromatumor eines Meckel-Divertikels",
      "Karzinom eines Meckel-Divertikels",
      "Leiomyosarkom eines Meckel-Divertikels",
      "Plattenepithelkarzinom eines Meckel-Divertikels"
    ]
  },
  {
    "code": "C17.8",
    "name": "Bösartige Neubildung des duodenojejunalen Überganges",
    "synonyms": [
      "Adenokarzinom des duodenojejunalen Überganges",
      "Bösartige Neubildung des Dünndarms, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung des duodenojejunalen Überganges",
      "GIST [Gastrointestinaler Stromatumor] des duodenojejunalen Überganges",
      "Gastrointestinaler Stromatumor des duodenojejunalen Überganges",
      "Karzinom des duodenojejunalen Überganges bei Lynch-Syndrom",
      "Leiomyosarkom des duodenojejunalen Überganges",
      "Plattenepithelkarzinom des duodenojejunalen Überganges"
    ]
  },
  {
    "code": "C17.9",
    "name": "Dünndarmkarzinoid",
    "synonyms": [
      "Adenokarzinom des Dünndarms",
      "Bösartige Neubildung des Dünndarmes",
      "Dünndarmkarzinoid",
      "Dünndarmkarzinom",
      "Dünndarmkarzinom bei Lynch-Syndrom",
      "Dünndarmkrebs",
      "GIST [Gastrointestinaler Stromatumor] des Dünndarms",
      "Gastrointestinaler Stromatumor des Dünndarms",
      "Leiomyosarkom des Dünndarms",
      "Maligner neuroendokriner Tumor des Dünndarms",
      "Metastasierendes Karzinoid des Dünndarmes",
      "Plattenepithelkarzinom des Dünndarms"
    ]
  },
  {
    "code": "C18.0",
    "name": "Krebs des Zäkums",
    "synonyms": [
      "Adenokarzinom des Zäkums",
      "Bösartige Neubildung der Bauhin-Klappe",
      "Bösartige Neubildung der Ileozäkalklappe",
      "Bösartige Neubildung des Ileozäkums",
      "Bösartige Neubildung des Zäkums",
      "Bösartige Neubildung des ileozäkalen Überganges",
      "GIST [Gastrointestinaler Stromatumor] des Zäkums",
      "Gastrointestinaler Stromatumor des Zäkums",
      "Hereditäres nichtpolypöses Karzinom des Zäkums",
      "Ileozökalkarzinom",
      "Karzinom des Ileozäkums",
      "Karzinom des Zäkums",
      "Krebs des Zäkums",
      "Maligner neuroendokriner Tumor des Zäkums",
      "Plattenepithelkarzinom des Zäkums"
    ]
  },
  {
    "code": "C18.1",
    "name": "Karzinom des Wurmfortsatzes",
    "synonyms": [
      "Appendixkarzinom",
      "Appendixkrebs",
      "Becherzellkarzinoid",
      "Bösartige Neubildung der Appendix",
      "Bösartige Neubildung der Appendix vermiformis",
      "Bösartiges schleimbildendes Karzinoid",
      "GIST [Gastrointestinaler Stromatumor] der Appendix",
      "Gastrointestinaler Stromatumor der Appendix",
      "Karzinom des Wurmfortsatzes",
      "Krebs des Wurmfortsatzes",
      "Maligner neuroendokriner Tumor der Appendix",
      "Muzinöses Adenokarzinom der Appendix",
      "Schleimbildender karzinoider Tumor",
      "Schleimbildender karzinoider Tumor der Appendix"
    ]
  },
  {
    "code": "C18.2",
    "name": "Karzinom des Colon ascendens",
    "synonyms": [
      "Adenokarzinom des Colon ascendens",
      "Bösartige Neubildung des Colon ascendens",
      "Bösartige Neubildung des rechten Kolons",
      "GIST [Gastrointestinaler Stromatumor] des Colon ascendens",
      "Gastrointestinaler Stromatumor des Colon ascendens",
      "Hereditäres nichtpolypöses Karzinom des Colon ascendens",
      "Karzinom des Colon ascendens",
      "Karzinom des Colon ascendens bei Lynch-Syndrom",
      "Krebs des Colon ascendens",
      "Maligner neuroendokriner Tumor des Colon ascendens",
      "Plattenepithelkarzinom des Colon ascendens"
    ]
  },
  {
    "code": "C18.3",
    "name": "Bösartige Neubildung der Flexura coli hepatica",
    "synonyms": [
      "Bösartige Neubildung der Flexura coli dextra",
      "Bösartige Neubildung der Flexura coli hepatica",
      "Bösartige Neubildung der hepatischen Kolonflexur",
      "GIST [Gastrointestinaler Stromatumor] der Flexura coli dextra",
      "Gastrointestinaler Stromatumor der Flexura coli dextra",
      "Hereditäres nichtpolypöses Karzinom der Flexura coli dextra",
      "Karzinom der Flexura coli dextra",
      "Karzinom der Flexura coli dextra bei Lynch-Syndrom",
      "Karzinom der Flexura coli hepatica",
      "Karzinom der rechten Kolonflexur",
      "Krebs der Flexura coli dextra",
      "Krebs der Flexura coli hepatica",
      "Maligner neuroendokriner Tumor der Flexura coli dextra",
      "Plattenepithelkarzinom der Flexura coli dextra"
    ]
  },
  {
    "code": "C18.4",
    "name": "Transversumkarzinom",
    "synonyms": [
      "Adenokarzinom des Colon transversum",
      "Adenokarzinom des Querkolons",
      "Bösartige Neubildung des Colon transversum",
      "Bösartige Neubildung des Querkolons",
      "GIST [Gastrointestinaler Stromatumor] des Colon transversum",
      "Gastrointestinaler Stromatumor des Colon transversum",
      "Hereditäres nichtpolypöses Karzinom des Colon transversum",
      "Karzinom des Colon transversum",
      "Karzinom des Colon transversum bei Lynch-Syndrom",
      "Krebs des Colon transversum",
      "Maligner neuroendokriner Tumor des Colon transversum",
      "Plattenepithelkarzinom des Colon transversum",
      "Querkolonkarzinom",
      "Transversumkarzinom"
    ]
  },
  {
    "code": "C18.5",
    "name": "Karzinom der Flexura coli lienalis",
    "synonyms": [
      "Adenokarzinom der linken Kolonflexur",
      "Bösartige Neubildung der Flexura coli lienalis",
      "Bösartige Neubildung der Flexura coli sinistra",
      "GIST [Gastrointestinaler Stromatumor] der Flexura coli sinistra",
      "Gastrointestinaler Stromatumor der Flexura coli sinistra",
      "Hereditäres nichtpolypöses Karzinom der Flexura coli sinistra",
      "Karzinom der Flexura coli lienalis",
      "Karzinom der Flexura coli sinistra",
      "Karzinom der Flexura coli sinistra bei Lynch-Syndrom",
      "Kolonkarzinom der linken Flexur",
      "Krebs der Flexura coli lienalis",
      "Krebs der Flexura coli sinistra",
      "Maligner neuroendokriner Tumor der Flexura coli sinistra",
      "Plattenepithelkarzinom der Flexura coli sinistra"
    ]
  },
  {
    "code": "C18.6",
    "name": "Karzinom des Colon descendens",
    "synonyms": [
      "Bösartige Neubildung des Colon descendens",
      "Bösartige Neubildung des linken Kolons",
      "GIST [Gastrointestinaler Stromatumor] des Colon descendens",
      "Gastrointestinaler Stromatumor des Colon descendens",
      "Hereditäres nichtpolypöses Karzinom des Colon descendens",
      "Karzinom des Colon descendens",
      "Karzinom des Colon descendens bei Lynch-Syndrom",
      "Krebs des Colon descendens",
      "Maligner neuroendokriner Tumor des Colon descendens",
      "Plattenepithelkarzinom des Colon descendens"
    ]
  },
  {
    "code": "C18.7",
    "name": "Sigmakarzinom",
    "synonyms": [
      "Bösartige Neubildung der Flexura coli sigmoidei",
      "Bösartige Neubildung des Colon pelvinum",
      "Bösartige Neubildung des Colon sigmoideum",
      "Bösartige Neubildung des Sigmas",
      "Bösartige Neubildung des distalen Kolons",
      "GIST [Gastrointestinaler Stromatumor] des Colon sigmoideum",
      "Gastrointestinaler Stromatumor des Colon sigmoideum",
      "Hereditäres nichtpolypöses Karzinom des Colon sigmoideum",
      "Karzinom des Colon sigmoideum",
      "Karzinom des Colon sigmoideum bei Lynch-Syndrom",
      "Kolonkarzinom des Sigmas",
      "Krebs des Colon sigmoideum",
      "Maligner neuroendokriner Tumor des Colon sigmoideum",
      "Plattenepithelkarzinom des Colon sigmoideum",
      "Sigmakarzinom"
    ]
  },
  {
    "code": "C18.8",
    "name": "Karzinom des Colon und des Sigmas",
    "synonyms": [
      "GIST [Gastrointestinaler Stromatumor] des Kolons, mehrere Teilbereiche überlappend",
      "Gastrointestinaler Stromatumor des Kolons, mehrere Teilbereiche überlappend",
      "Hereditäres nichtpolypöses Karzinom des Kolons, mehrere Teilbereiche überlappend",
      "Karzinom des Colon und des Sigmas",
      "Kolonkarzinom bei Lynch-Syndrom, mehrere Teilbereiche überlappend",
      "Maligner neuroendokriner Tumor des Kolons, mehrere Teilbereiche überlappend",
      "Plattenepithelkarzinom des Kolons, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C18.9",
    "name": "Dickdarmkrebs",
    "synonyms": [
      "Adenokarzinom bei Polyposis coli",
      "Adenokarzinom bei adenomatöser Polyposis coli",
      "Adenokarzinom des Kolons",
      "Bösartige Neubildung des Dickdarmes",
      "Bösartige Neubildung des Kolons",
      "Dickdarmkarzinom",
      "Dickdarmkrebs",
      "Dickdarmmalignom",
      "GIST [Gastrointestinaler Stromatumor] des Kolons",
      "Gastrointestinaler Stromatumor des Kolons",
      "Karzinom bei Polyposis coli",
      "Kolondivertikel mit Entartung",
      "Kolonkarzinom",
      "Kolonkarzinom bei Lynch-Syndrom",
      "Kolonkrebs",
      "Lynch-Syndrom",
      "Maligner neuroendokriner Tumor des Kolons",
      "Malignes Melanom des Dickdarms",
      "Neuroendokrines Kolonkarzinom",
      "Plattenepithelkarzinom des Dickdarms"
    ]
  },
  {
    "code": "C19",
    "name": "Bösartige Neubildung des Rektosigmoids",
    "synonyms": [
      "Bösartige Neubildung des Kolons und Rektums",
      "Bösartige Neubildung des Rektosigmoids",
      "Bösartige Neubildung des pelvirektalen Überganges",
      "Bösartige Neubildung des rektosigmoidalen Überganges",
      "Bösartige Neubildung des Überganges vom Colon sigmoideum zum Rektum",
      "Bösartige Neubildung des Überganges vom Kolon zum Rektosigmoid",
      "Bösartige Neubildung des Überganges vom Rektum zum Colon sigmoideum",
      "Darmkarzinom des Rektosigmoids",
      "Familiäres kolorektales Karzinom Typ X",
      "GIST [Gastrointestinaler Stromatumor] des rektosigmoidalen Überganges",
      "Gastrointestinaler Stromatumor des rektosigmoidalen Überganges",
      "Karzinom des Kolons und Rektums",
      "Kolon-Rektum-Karzinom",
      "Kolorektales Karzinom",
      "Kolorektales Karzinom bei Lynch-Syndrom",
      "Krebs des Kolons und Rektums",
      "Rektosigmoidales Karzinom",
      "Rektosigmoidkarzinom",
      "Rektosigmoidkrebs",
      "Rektum-Sigma-Karzinom"
    ]
  },
  {
    "code": "C20",
    "name": "Bösartige Neubildung der Ampulla recti",
    "synonyms": [
      "Adenokarzinom des Rektums",
      "Bösartige Neubildung der Ampulla recti",
      "Bösartige Neubildung des Mastdarmes",
      "Bösartige Neubildung des Rektums",
      "GIST [Gastrointestinaler Stromatumor] des Rektums",
      "Gastrointestinaler Stromatumor des Rektums",
      "Maligner neuroendokriner Tumor des Rektums",
      "Mastdarmkrebs",
      "Plattenepithelkarzinom des Rektums",
      "Rektumkarzinom",
      "Rektumkrebs",
      "Rektummalignom"
    ]
  },
  {
    "code": "C21.0",
    "name": "Karzinom des Anus",
    "synonyms": [
      "Analmelanom",
      "Bösartige Neubildung des Analbereichs",
      "Bösartige Neubildung des Anus",
      "Extramammäre Paget-Krankheit des Anus",
      "Karzinom des Anus",
      "Krebs des Anus",
      "Maligner Analtumor",
      "Malignes Melanom des Afters",
      "Malignes Melanom des Anus",
      "Paget-Karzinom des Anus"
    ]
  },
  {
    "code": "C21.1",
    "name": "Bösartige Neubildung des Analkanals",
    "synonyms": [
      "Adenokarzinom des Analkanals",
      "Bösartige Neubildung der Hämorrhoidalzone",
      "Bösartige Neubildung des Analkanals",
      "Bösartige Neubildung des Analsphinkters",
      "Bösartige Neubildung des Sphincter ani",
      "Karzinom des Analkanals",
      "Krebs des Analkanals",
      "Maligner Tumor des Analkanals",
      "Maligner neuroendokriner Tumor des Analkanals",
      "Squamöses Karzinom des Analkanals"
    ]
  },
  {
    "code": "C21.2",
    "name": "Bösartige Neubildung der Kloakenregion",
    "synonyms": [
      "Bösartige Neubildung der Kloake",
      "Bösartige Neubildung der Kloakenregion",
      "Karzinom der Kloake",
      "Kloakogenes Karzinom"
    ]
  },
  {
    "code": "C21.8",
    "name": "Bösartige anorektale Neubildung",
    "synonyms": [
      "Anorektaler Krebs",
      "Anorektales Karzinom",
      "Bösartige Neubildung der Morgagni-Krypten",
      "Bösartige Neubildung des Anorektums",
      "Bösartige Neubildung des anorektalen Überganges",
      "Bösartige anorektale Neubildung"
    ]
  },
  {
    "code": "C22.0",
    "name": "Cholangiohepatom",
    "synonyms": [
      "Adultes hepatozelluläres Karzinom",
      "Bösartiger embryonaler Lebermischtumor",
      "Carcinoma hepatis",
      "Carcinoma hepatocellulare",
      "Carcinoma hepatocholangiocellulare",
      "Cholangiohepatom",
      "Embryonales Hepatom",
      "Fibrolamelläres Carcinoma hepatocellulare",
      "Fibrolamelläres hepatozelluläres Karzinom",
      "HCC [Hepatozelluläres Karzinom]",
      "Hepatocholangiokarzinom",
      "Hepatokarzinom",
      "Hepatom",
      "Hepatozelluläres Karzinom",
      "Hepatozelluläres Karzinom im Kindesalter",
      "Kombiniertes Cholangiokarzinom und hepatozelluläres Karzinom",
      "Kombiniertes Gallengangskarzinom und Leberzellkarzinom",
      "Leberembryom",
      "Leberzellkarzinom",
      "Leberzellkrebs",
      "Malignes Hepatom"
    ]
  },
  {
    "code": "C22.1",
    "name": "Intrahepatisches Gallengangskarzinom",
    "synonyms": [
      "Adenokarzinom vom Gallengangstyp",
      "Biliäres Zystadenokarzinom der Leber",
      "Bösartige Neubildung der Ductuli biliferi",
      "Bösartige Neubildung der Ductuli intrahepaticae",
      "Bösartige Neubildung des interlobulären Gallenganges",
      "Bösartige Neubildung des interlobulären Gallenweges",
      "Bösartige Neubildung des intrahepatischen Gallenganges",
      "Bösartige Neubildung des intrahepatischen Gallenweges",
      "Bösartige Neubildung des intralobulären Gallenganges",
      "Bösartige Neubildung des intralobulären Gallenweges",
      "Cholangiokarzinom",
      "Cholangiokarzinom der Leber",
      "Cholangiozelluläres Karzinom",
      "Intrahepatisches Gallengangskarzinom",
      "Krebs des intrahepatischen Gallenganges",
      "Malignes Cholangiom",
      "Zystadenokarzinom des Gallenganges"
    ]
  },
  {
    "code": "C22.2",
    "name": "Hepatoblastom",
    "synonyms": [
      "Hepatoblastom"
    ]
  },
  {
    "code": "C22.3",
    "name": "Angiosarkom der Leber",
    "synonyms": [
      "Angiosarkom der Leber",
      "Kupffer-Zell-Sarkom"
    ]
  },
  {
    "code": "C22.4",
    "name": "Gemischter mesodermaler Lebertumor",
    "synonyms": [
      "Embryonales Sarkom der Leber",
      "Gemischter mesodermaler Lebertumor",
      "Undifferenziertes Sarkom der Leber"
    ]
  },
  {
    "code": "C22.7",
    "name": "Teratokarzinom der Leber",
    "synonyms": [
      "Embryonaler Lebertumor",
      "Embryonales Leberkarzinom",
      "Embryonales Leberteratom",
      "Epitheloides Hämangioendotheliom der Leber",
      "Leberteratom",
      "Neuroendokriner Lebertumor",
      "Neuroendokrines Leberkarzinom",
      "Primär hepatischer neuroendokriner Tumor",
      "Rhabdoidtumor der Leber",
      "Teratokarzinom der Leber"
    ]
  },
  {
    "code": "C22.9",
    "name": "Leberkrebs",
    "synonyms": [
      "Bösartige Neubildung der Leber",
      "Hepatische bösartige Neubildung",
      "Karzinom der Leber und des Gallensystems",
      "Leberkarzinom",
      "Leberkrebs",
      "Lebermelanom",
      "Lebersarkom",
      "Primäre bösartige Neubildung der Leber",
      "Primärer Leberkrebs",
      "Primäres Karzinom der Leber"
    ]
  },
  {
    "code": "C23",
    "name": "Bösartige Neubildung der Gallenblase",
    "synonyms": [
      "Adenokarzinom der Gallenblase",
      "Bösartige Neubildung der Gallenblase",
      "Gallenblasenkarzinom",
      "Gallenblasenkrebs",
      "Neuroendokriner Tumor der Gallenblase",
      "Plattenepithelkarzinom der Gallenblase"
    ]
  },
  {
    "code": "C24.0",
    "name": "Karzinom des Choledochus",
    "synonyms": [
      "Adenokarzinom der Gabelung des Ductus hepaticus [Klatskin-Tumor]",
      "Adenokarzinom des extrahepatischen Gallengangs",
      "Bösartige Neubildung der Gallengänge",
      "Bösartige Neubildung der hepatischen Gallengänge",
      "Bösartige Neubildung des Ductus choledochus",
      "Bösartige Neubildung des Ductus cysticus",
      "Bösartige Neubildung des Ductus hepaticus",
      "Bösartige Neubildung des Ductus hepaticus communis",
      "Bösartige Neubildung des Gallenblasenganges",
      "Bösartige Neubildung des extrahepatischen Gallenganges",
      "Gallengangskarzinom",
      "Hiläres Cholangiokarzinom",
      "Karzinom des Choledochus",
      "Karzinom des Ductus choledochus",
      "Karzinom des extrahepatischen Gallenganges",
      "Klatskin-Tumor",
      "Krebs des extrahepatischen Gallenganges",
      "Plattenepithelkarzinom des extrahepatischen Gallengangs"
    ]
  },
  {
    "code": "C24.1",
    "name": "Bösartige Neubildung der Papilla Vateri",
    "synonyms": [
      "Bösartige Neubildung der Ampulla Vateri",
      "Bösartige Neubildung der Ampulla hepatopancreatica",
      "Bösartige Neubildung der Papilla Vateri",
      "Bösartige Neubildung des Sphincter Oddi",
      "Karzinom der Ampulla Vateri",
      "Karzinom der Papilla Vateri"
    ]
  },
  {
    "code": "C24.8",
    "name": "Bösartige Neubildung der intra- und extrahepatischen Gallengänge",
    "synonyms": [
      "Bösartige Neubildung der intra- und extrahepatischen Gallengänge",
      "Karzinom der intra- und extrahepatischen Gallengänge"
    ]
  },
  {
    "code": "C24.9",
    "name": "Gallensystemmalignom",
    "synonyms": [
      "Bösartige Neubildung der Gallenwege",
      "Bösartige Neubildung des Gallensystems",
      "Gallensystemkarzinom",
      "Gallensystemkrebs",
      "Gallensystemmalignom",
      "Karzinom der Gallenwege"
    ]
  },
  {
    "code": "C25.0",
    "name": "Pankreaskopfkarzinom",
    "synonyms": [
      "Azinuszellkarzinom des Pankreaskopfes",
      "Blastom des Pankreaskopfes",
      "Bösartige Neubildung des Caput pancreatis",
      "Bösartige Neubildung des Pankreaskopfes",
      "Familiäres Pankreaskopfkarzinom",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Pankreaskopfes",
      "Karzinom des Caput pancreatis",
      "Karzinom des Caput pancreatis bei Lynch-Syndrom",
      "Krebs des Caput pancreatis",
      "Muzinöses Zystadenokarzinom des Pankreaskopfes",
      "Osteoklastischer Riesenzelltumor des Pankreaskopfes",
      "Pankreaskopfkarzinom",
      "Pankreaskopfkrebs",
      "Plattenepithelkarzinom des Pankreaskopfes",
      "Seröses Zystadenokarzinom des Pankreaskopfes",
      "Solides pseudopapilläres Karzinom des Pankreaskopfes",
      "Undifferenziertes Karzinom mit Osteoklasten-ähnlichen Riesenzellen des Pankreaskopfes"
    ]
  },
  {
    "code": "C25.1",
    "name": "Bösartige Neubildung des Corpus pancreatis",
    "synonyms": [
      "Azinuszellkarzinom des Pankreaskörpers",
      "Blastom des Pankreaskörpers",
      "Bösartige Neubildung des Corpus pancreatis",
      "Bösartige Neubildung des Pankreaskörpers",
      "Familiäres Pankreaskörperkarzinom",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Pankreaskörpers",
      "Karzinom des Corpus pancreatis",
      "Krebs des Corpus pancreatis",
      "Muzinöses Zystadenokarzinom des Pankreaskörpers",
      "Osteoklastischer Riesenzelltumor des Pankreaskörpers",
      "Plattenepithelkarzinom des Pankreaskörpers",
      "Seröses Zystadenokarzinom des Pankreaskörpers",
      "Solides pseudopapilläres Karzinom des Pankreaskörpers",
      "Undifferenziertes Karzinom mit Osteoklasten-ähnlichen Riesenzellen des Pankreaskörpers"
    ]
  },
  {
    "code": "C25.2",
    "name": "Krebs der Cauda pancreatis",
    "synonyms": [
      "Azinuszellkarzinom des Pankreasschwanzes",
      "Blastom des Pankreasschwanzes",
      "Bösartige Neubildung der Cauda pancreatis",
      "Bösartige Neubildung des Pankreasschwanzes",
      "Familiäres Pankreasschwanzkarzinom",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Pankreasschwanzes",
      "Karzinom der Cauda pancreatis",
      "Karzinom der Cauda pancreatis bei Lynch-Syndrom",
      "Krebs der Cauda pancreatis",
      "Muzinöses Zystadenokarzinom des Pankreasschwanzes",
      "Osteoklastischer Riesenzelltumor des Pankreasschwanzes",
      "Pankreasschwanzkarzinom",
      "Plattenepithelkarzinom des Pankreasschwanzes",
      "Seröses Zystadenokarzinom des Pankreasschwanzes",
      "Solides pseudopapilläres Karzinom des Pankreasschwanzes",
      "Undifferenziertes Karzinom mit Osteoklasten-ähnlichen Riesenzellen des Pankreasschwanzes"
    ]
  },
  {
    "code": "C25.3",
    "name": "Bösartige Neubildung des Ductus pancreaticus",
    "synonyms": [
      "Bösartige Neubildung des Ductus pancreaticus",
      "Bösartige Neubildung des Ductus pancreaticus accessorius",
      "Bösartige Neubildung des Pankreasganges",
      "Bösartige Neubildung des Santorini-Ganges",
      "Bösartige Neubildung des Wirsung-Ganges",
      "Familiäres Karzinom des Ductus pancreaticus",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Ductus pancreaticus",
      "Intraduktales papillär-muzinöses Karzinom des Pankreas",
      "Karzinom des Ductus pancreaticus",
      "Krebs des Ductus pancreaticus"
    ]
  },
  {
    "code": "C25.4",
    "name": "Inselzellkarzinom",
    "synonyms": [
      "Adenokarzinom der Inselzellen",
      "Bösartige Nesidioblastose",
      "Bösartige Neubildung der Inselzellen des Pankreas",
      "Bösartige Neubildung der Langerhans-Inseln",
      "Bösartiger Alpha-Zell-Tumor des Pankreas",
      "Bösartiger Beta-Zell-Tumor des Pankreas",
      "Bösartiger G-Zell-Tumor des Pankreas",
      "Bösartiger Inselzell-Tumor des Pankreas",
      "Bösartiges Insulinom",
      "Bösartiges Nesidioblastom",
      "Bösartiges Pankreasinsulinom",
      "Bösartiges VIPom [Vasoaktives intestinales Polypeptid sezernierender Tumor] des Pankreas",
      "Inselzellkarzinom",
      "Karzinom der Langerhans-Inseln",
      "Krebs der Langerhans-Inseln",
      "Maligner nicht-funktioneller neuroendokriner Tumor des Pankreas",
      "Malignes Gastrinom",
      "Malignes Glukagonom",
      "Malignes Pankreasgastrinom",
      "Malignes Pankreasglukagonom",
      "Neuroendokriner Pankreastumor",
      "Neuroendokrines Karzinom der Inselzellen des Pankreas",
      "Neuroendokrines Karzinom des Pankreas",
      "Serotonin-produzierender neuroendokriner Tumor des Pankreas",
      "Somatostatinom des Pankreas"
    ]
  },
  {
    "code": "C25.7",
    "name": "Bösartige Neubildung des Pankreashalses",
    "synonyms": [
      "Azinuszellkarzinom des Pankreashalses",
      "Blastom des Pankreashalses",
      "Bösartige Neubildung des Pankreashalses",
      "Familiäres Pankreashalskarzinom",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Pankreashalses",
      "Muzinöses Zystadenokarzinom des Pankreashalses",
      "Osteoklastischer Riesenzelltumor des Pankreashalses",
      "Plattenepithelkarzinom des Pankreashalses",
      "Seröses Zystadenokarzinom des Pankreashalses",
      "Solides pseudopapilläres Karzinom des Pankreashalses",
      "Undifferenziertes Karzinom mit Osteoklasten-ähnlichen Riesenzellen des Pankreashalses"
    ]
  },
  {
    "code": "C25.8",
    "name": "Pankreatoblastom, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Azinuszellkarzinom des Pankreas, mehrere Teilbereiche überlappend",
      "Familiäres Pankreaskarzinom, mehrere Teilbereiche überlappend",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Pankreas, mehrere Teilbereiche überlappend",
      "Muzinöses Zystadenokarzinom des Pankreas, mehrere Teilbereiche überlappend",
      "Osteoklastischer Riesenzelltumor des Pankreas, mehrere Teilbereiche überlappend",
      "Pankreaskarzinom bei Lynch-Syndrom, mehrere Teilbereiche überlappend",
      "Pankreatoblastom, mehrere Teilbereiche überlappend",
      "Plattenepithelkarzinom des Pankreas, mehrere Teilbereiche überlappend",
      "Seröses Zystadenokarzinom des Pankreas, mehrere Teilbereiche überlappend",
      "Solides pseudopapilläres Karzinom des Pankreas, mehrere Teilbereiche überlappend",
      "Undifferenziertes Karzinom mit Osteoklasten-ähnlichen Riesenzellen des Pankreas, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C25.9",
    "name": "Pankreaskarzinom",
    "synonyms": [
      "Adenokarzinom des Pankreas",
      "Azinuszellkarzinom des Pankreas",
      "Bauchspeicheldrüsenkarzinom",
      "Bauchspeicheldrüsenkrebs",
      "Bösartige Neubildung der Bauchspeicheldrüse",
      "Bösartige Neubildung des Pankreas",
      "Familiäres Pankreaskarzinom",
      "Gemischte neuroendokrin-nichtneuroendokrine Neoplasie des Pankreas",
      "ITPN [Intraduktale tubulopapilläre Neoplasie] des Pankreas",
      "Muzinöses Zystadenokarzinom des Pankreas",
      "Osteoklastischer Riesenzelltumor des Pankreas",
      "Pankreaskarzinom",
      "Pankreaskarzinom bei Lynch-Syndrom",
      "Pankreaskrebs",
      "Pankreasmalignom",
      "Pankreatoblastom",
      "Plattenepithelkarzinom des Pankreas",
      "Seröses Zystadenokarzinom des Pankreas",
      "Solides pseudopapilläres Karzinom des Pankreas",
      "Undifferenziertes Karzinom mit Osteoklasten-ähnlichen Riesenzellen des Pankreas",
      "Zystadenokarzinom des Pankreas"
    ]
  },
  {
    "code": "C26.0",
    "name": "Darmkarzinom",
    "synonyms": [
      "Bösartige Neubildung des Darmes",
      "Bösartige Neubildung des Darmtraktes a.n.k.",
      "Darmkarzinom",
      "Darmkrebs",
      "Maligner Darmpolyp"
    ]
  },
  {
    "code": "C26.1",
    "name": "Milzkarzinom",
    "synonyms": [
      "Angiosarkom der Milz",
      "Bösartige Neubildung der Milz",
      "Fibrosarkom der Milz",
      "Milzkarzinom",
      "Milzkrebs"
    ]
  },
  {
    "code": "C26.9",
    "name": "Bösartige Neubildung des Gastrointestinaltraktes",
    "synonyms": [
      "Bösartige Neubildung der Verdauungsorgane",
      "Bösartige Neubildung der Verdauungswege a.n.k.",
      "Bösartige Neubildung des Gastrointestinaltraktes",
      "Bösartige Neubildung des Magen-Darm-Kanals",
      "Bösartige Neubildung des Verdauungskanals",
      "Bösartige Neubildung des Verdauungssystems a.n.k.",
      "Bösartige Neubildung des Verdauungstraktes",
      "Gastrointestinaler Stromatumor",
      "Gastrointestinales Karzinom",
      "Karzinom der Verdauungsorgane",
      "Karzinom des Verdauungssystems",
      "Neuroendokriner gastrointestinaler Tumor",
      "Periampulläres Karzinom"
    ]
  },
  {
    "code": "C30.0",
    "name": "Ästhesioneuroblastom",
    "synonyms": [
      "Bösartige Neubildung der Conchae nasales",
      "Bösartige Neubildung der Fossa nasalis",
      "Bösartige Neubildung der Nares",
      "Bösartige Neubildung der Nasenhöhle",
      "Bösartige Neubildung der Nasenlöcher",
      "Bösartige Neubildung der Nasenmuschel",
      "Bösartige Neubildung der Nasenschleimhaut",
      "Bösartige Neubildung der Schleimhaut der Nasenmuschel",
      "Bösartige Neubildung der inneren Nase",
      "Bösartige Neubildung des Naseninnenraums",
      "Bösartige Neubildung des Nasenknorpels",
      "Bösartige Neubildung des Nasenseptums",
      "Bösartige Neubildung des Nasenvorhofes",
      "Bösartige Neubildung des Vestibulum nasi",
      "Embryonales Rhabdomyosarkom der inneren Nase",
      "Intranasales Malignom",
      "Nasenhöhlenkarzinom",
      "Nasenhöhlenkrebs",
      "Neuroblastom der Nervi olfactorii",
      "Neuroepitheliom der Nervi olfactorii",
      "Neurogener Olfaktoriustumor",
      "Olfaktoriusneuroblastom",
      "Olfaktoriusneuroepitheliom",
      "Plattenepithelkarzinom der Nasenhöhle",
      "Schneider-Karzinom",
      "Ästhesioneuroblastom",
      "Ästhesioneuroepitheliom",
      "Ästhesioneurozytom"
    ]
  },
  {
    "code": "C30.1",
    "name": "Bösartige Neubildung des inneren Gehörganges",
    "synonyms": [
      "Bösartige Neubildung der Cellulae mastoideae",
      "Bösartige Neubildung der Eustachi-Röhre",
      "Bösartige Neubildung der Mastoidzellen",
      "Bösartige Neubildung der Paukenhöhle",
      "Bösartige Neubildung der Tuba auditiva",
      "Bösartige Neubildung des Antrum maxillare tympanicum",
      "Bösartige Neubildung des Cavum tympani",
      "Bösartige Neubildung des Innenohrs",
      "Bösartige Neubildung des Mittelohres",
      "Bösartige Neubildung des inneren Gehörganges",
      "Maligner neuroendokriner Tumor des Mittelohrs",
      "Mittelohrkarzinom",
      "Mittelohrkrebs"
    ]
  },
  {
    "code": "C31.0",
    "name": "Karzinom der Kieferhöhle",
    "synonyms": [
      "Bösartige Neubildung der Highmore-Höhle",
      "Bösartige Neubildung der Kieferhöhle",
      "Bösartige Neubildung der Oberkieferhöhle",
      "Bösartige Neubildung der Oberkiefernebenhöhle",
      "Bösartige Neubildung des Antrum maxillare",
      "Bösartige Neubildung des Sinus maxillaris",
      "Bösartige Neubildung eines Oberkiefersinus",
      "Embryonales Rhabdomyosarkom des Sinus maxillaris",
      "Karzinom der Kieferhöhle",
      "Karzinom des Sinus maxillaris",
      "Kieferhöhlenkrebs",
      "Krebs des Sinus maxillaris",
      "Malignes Melanom der Schleimhaut des Sinus maxillaris",
      "Plattenepithelkarzinom der Kieferhöhle"
    ]
  },
  {
    "code": "C31.1",
    "name": "Karzinom der Siebbeinzellen",
    "synonyms": [
      "Bösartige Neubildung der Siebbeinhöhle",
      "Bösartige Neubildung des Sinus ethmoidalis",
      "Embryonales Rhabdomyosarkom des Sinus ethmoidalis",
      "Karzinom der Siebbeinzellen",
      "Karzinom des Sinus ethmoidalis",
      "Krebs des Sinus ethmoidalis",
      "Malignes Melanom der Schleimhaut des Sinus ethmoidalis",
      "Plattenepithelkarzinom der Siebbeinhöhle",
      "Siebbeinhöhlenkarzinom",
      "Siebbeinhöhlenkrebs"
    ]
  },
  {
    "code": "C31.2",
    "name": "Karzinom des Sinus frontalis",
    "synonyms": [
      "Bösartige Neubildung der Stirnhöhle",
      "Bösartige Neubildung des Sinus frontalis",
      "Embryonales Rhabdomyosarkom des Sinus frontalis",
      "Karzinom des Sinus frontalis",
      "Krebs des Sinus frontalis",
      "Malignes Melanom der Schleimhaut des Sinus frontalis",
      "Plattenepithelkarzinom der Stirnhöhle",
      "Stirnhöhlenkarzinom"
    ]
  },
  {
    "code": "C31.3",
    "name": "Keilbeinhöhlenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Keilbeinhöhle",
      "Bösartige Neubildung des Sinus sphenoidalis",
      "Embryonales Rhabdomyosarkom des Sinus sphenoidalis",
      "Karzinom des Sinus sphenoidalis",
      "Keilbeinhöhlenkarzinom",
      "Keilbeinhöhlenkrebs",
      "Krebs des Sinus sphenoidalis",
      "Malignes Melanom der Schleimhaut des Sinus sphenoidalis",
      "Plattenepithelkarzinom der Keilbeinhöhle"
    ]
  },
  {
    "code": "C31.8",
    "name": "Plattenepithelkarzinom der Nasennebenhöhlen, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Plattenepithelkarzinom der Nasennebenhöhlen, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C31.9",
    "name": "Bösartige Neubildung der Nasennebenhöhle",
    "synonyms": [
      "Bösartige Neubildung der Nasennebenhöhle",
      "Bösartige Neubildung der Sinus paranasales a.n.k.",
      "Karzinom der Sinus paranasales",
      "Maligner Nasennebenhöhlentumor",
      "Malignes Melanom der Nasennebenhöhlenschleimhaut",
      "Nasennebenhöhlenkarzinom",
      "Nasennebenhöhlenkrebs",
      "Nebenhöhlenkarzinom",
      "Plattenepithelkarzinom der Nasennebenhöhlen",
      "Sinunasales Karzinom"
    ]
  },
  {
    "code": "C32.0",
    "name": "Stimmlippenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Glottis",
      "Bösartige Neubildung der Kehlkopfkommissur",
      "Bösartige Neubildung der Larynxkommissur a.n.k.",
      "Bösartige Neubildung des Ligamentum vocale",
      "Bösartige Neubildung des Ventriculus laryngis",
      "Bösartige Neubildung des echten Stimmbandes",
      "Bösartige Neubildung des inneren Larynx a.n.k.",
      "Glottiskarzinom",
      "Glottiskrebs",
      "Maligner neuroendokriner Tumor der Glottis",
      "Plattenepithelkarzinom der Glottis",
      "Stimmbandkarzinom",
      "Stimmlippenkarzinom"
    ]
  },
  {
    "code": "C32.1",
    "name": "Karzinom der Epiglottis",
    "synonyms": [
      "Bösartige Neubildung der Epiglottis",
      "Bösartige Neubildung der Plica ventricularis laryngis",
      "Bösartige Neubildung der Plica vestibularis",
      "Bösartige Neubildung der Supraglottis",
      "Bösartige Neubildung der falschen Stimmbänder",
      "Bösartige Neubildung der hinteren Epiglottisfläche",
      "Bösartige Neubildung der laryngealen Epiglottisfläche",
      "Bösartige Neubildung der laryngealen Seite der Plica aryepiglottica",
      "Bösartige Neubildung der laryngealen Seite der aryepiglottischen Falte",
      "Bösartige Neubildung des Epiglottisknorpels",
      "Bösartige Neubildung des Ligamentum vestibulare",
      "Bösartige Neubildung des Taschenbandes [falsches Stimmband]",
      "Bösartige Neubildung des Vestibulum laryngis",
      "Bösartige Neubildung des suprahyoidalen Anteils der Epiglottis",
      "Bösartige Neubildung des äußeren Larynx a.n.k.",
      "Karzinom der Epiglottis",
      "Maligner neuroendokriner Tumor der Supraglottis",
      "Maligner neuroendokriner Tumor der hinteren Epiglottisfläche",
      "Plattenepithelkarzinom der Epiglottis",
      "Supraglottische bösartige Neubildung",
      "Supraglottisches Karzinom",
      "Supraglottiskrebs"
    ]
  },
  {
    "code": "C32.2",
    "name": "Bösartige Neubildung der Subglottis",
    "synonyms": [
      "Bösartige Neubildung der Subglottis",
      "Maligner neuroendokriner Tumor der Subglottis",
      "Plattenepithelkarzinom der Subglottis",
      "Subglottische bösartige Neubildung",
      "Subglottisches Karzinom",
      "Subglottiskrebs"
    ]
  },
  {
    "code": "C32.3",
    "name": "Bösartige Neubildung des Kehlkopfknorpels",
    "synonyms": [
      "Bösartige Neubildung der Cartilago arytaenoidea",
      "Bösartige Neubildung des Aryknorpels",
      "Bösartige Neubildung des Gießbeckenknorpels",
      "Bösartige Neubildung des Kegelknorpels",
      "Bösartige Neubildung des Kehlkopfknorpels",
      "Bösartige Neubildung des Larynxknorpels a.n.k.",
      "Bösartige Neubildung des Ringknorpels",
      "Bösartige Neubildung des Schildknorpels",
      "Bösartige Neubildung des Stellknorpels",
      "Kehlkopfknorpelkarzinom",
      "Kehlkopfknorpelkrebs"
    ]
  },
  {
    "code": "C32.8",
    "name": "Plattenepithelkarzinom des Larynx, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Plattenepithelkarzinom des Larynx, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C32.9",
    "name": "Kehlkopfkarzinom",
    "synonyms": [
      "Bösartige Neubildung des Kehlkopfes",
      "Bösartige Neubildung des Larynx",
      "Kehlkopfkarzinom",
      "Kehlkopfkrebs",
      "Larynxkarzinom",
      "Larynxkrebs",
      "Leiomyosarkom des Larynx",
      "Maligner neuroendokriner Tumor des Larynx",
      "Plattenepithelkarzinom des Larynx"
    ]
  },
  {
    "code": "C33",
    "name": "Tracheakarzinom",
    "synonyms": [
      "Bösartige Neubildung der Luftröhre",
      "Bösartige Neubildung der Trachea",
      "Bösartige Neubildung des Luftröhrenknorpels",
      "Tracheakarzinom"
    ]
  },
  {
    "code": "C34.0",
    "name": "Bösartige Neubildung des Hauptbronchus",
    "synonyms": [
      "Bronchialkarzinom des Hauptbronchus",
      "Bösartige Neubildung der Carina tracheae",
      "Bösartige Neubildung des Bronchialknorpels",
      "Bösartige Neubildung des Hauptbronchus",
      "Bösartige Neubildung des Hilus pulmonis",
      "Bösartige Neubildung des Lungenhilus",
      "Karzinom des Hauptbronchus",
      "Krebs des Hauptbronchus",
      "Neuroendokriner Tumor des Hauptbronchus"
    ]
  },
  {
    "code": "C34.1",
    "name": "Bronchialkarzinom des Oberlappens",
    "synonyms": [
      "Bronchialkarzinom des Oberlappens",
      "Bösartige Neubildung der Lingula pulmonis sinistri",
      "Bösartige Neubildung des Lobus lingualis pulmonis",
      "Bösartige Neubildung des Lobus superior pulmonis",
      "Bösartige Neubildung des Lobus venae azygos",
      "Bösartige Neubildung des Lungenoberlappens",
      "Gut differenziertes fetales Adenokarzinom des Lungenoberlappens",
      "Karzinom des Lungenoberlappens",
      "Karzinom des Oberlappenbronchus",
      "Kleinzelliges Bronchialkarzinom des Lungenoberlappens",
      "Lungenkarzinom des Oberlappens",
      "Lungenkrebs des Oberlappens",
      "Neuroendokriner Tumor des Oberlappenbronchus",
      "Pancoast-Syndrom",
      "Pancoast-Tumor",
      "Pulmonales Blastom des Lobus superior pulmonis",
      "Pulmonales Blastom des Lungenoberlappens",
      "Pulmonales Blastom des Oberlappens"
    ]
  },
  {
    "code": "C34.2",
    "name": "Bösartige Neubildung des Lungenmittellappens",
    "synonyms": [
      "Bronchialkarzinom des Mittellappens",
      "Bösartige Neubildung des Lobus medius pulmonis",
      "Bösartige Neubildung des Lungenmittellappens",
      "Gut differenziertes fetales Adenokarzinom des Lungenmittellappens",
      "Kleinzelliges Bronchialkarzinom des Lungenmittellappens",
      "Lungenkarzinom des Mittellappens",
      "Lungenkrebs des Mittellappens",
      "Neuroendokriner Tumor des Mittellappenbronchus",
      "Pulmonales Blastom des Lobus medius pulmonis",
      "Pulmonales Blastom des Lungenmittellappens",
      "Pulmonales Blastom des Mittellappens"
    ]
  },
  {
    "code": "C34.3",
    "name": "Bronchialkarzinom des Unterlappens",
    "synonyms": [
      "Bronchialkarzinom des Unterlappens",
      "Bösartige Neubildung des Lobus inferior pulmonis",
      "Bösartige Neubildung des Lungenunterlappens",
      "Gut differenziertes fetales Adenokarzinom des Lungenunterlappens",
      "Kleinzelliges Bronchialkarzinom des Lungenunterlappens",
      "Lungenkarzinom des Unterlappens",
      "Lungenkrebs des Unterlappens",
      "Neuroendokriner Tumor des Unterlappenbronchus",
      "Pulmonales Blastom des Lobus inferior pulmonis",
      "Pulmonales Blastom des Lungenunterlappens",
      "Pulmonales Blastom des Unterlappens"
    ]
  },
  {
    "code": "C34.8",
    "name": "Bösartige Neubildung der Bronchien und der Lunge, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Bronchialer neuroendokriner Tumor, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung der Bronchien und der Lunge, mehrere Teilbereiche überlappend",
      "Gut differenziertes fetales Adenokarzinom der Lunge, mehrere Teilbereiche überlappend",
      "Kleinzelliges Bronchialkarzinom, mehrere Teilbereiche überlappend",
      "Mehrere Teilbereiche überlappendes Bronchialkarzinom",
      "Tracheobronchiale bösartige Neubildung"
    ]
  },
  {
    "code": "C34.9",
    "name": "Pneumoblastom",
    "synonyms": [
      "Adenokarzinom der Lunge",
      "Alveolarzellkarzinom",
      "Alveoläres Adenokarzinom",
      "Alveoläres Karzinom",
      "Bronchialer neuroendokriner Tumor",
      "Bronchialkarzinom",
      "Bronchialsarkom",
      "Bronchiogene bösartige Neubildung",
      "Bronchiolo-alveoläres Adenokarzinom",
      "Bronchiolo-alveoläres Karzinom",
      "Bronchioläres Adenokarzinom",
      "Bronchioläres Karzinom",
      "Bronchoalveoläres Adenokarzinom",
      "Bronchuskarzinoid",
      "Bronchuskarzinom",
      "Bronchuskrebs",
      "Bösartige Neubildung der Lunge",
      "Bösartige Neubildung einer Bronchiole",
      "Bösartige Neubildung eines Bronchus",
      "Gut differenziertes fetales Adenokarzinom der Lunge",
      "Haferkorn-Karzinom",
      "Haferzell-Karzinom",
      "Karzinoid der Lunge",
      "Karzinoid vom Bronchusadenom-Typ",
      "Kleinzelliges Bronchialkarzinom",
      "Kleinzelliges Lungenkarzinom",
      "Kleinzelliges Plattenepithelkarzinom des Bronchus",
      "Lungenkarzinom",
      "Lungenkrebs",
      "Lungensarkom",
      "Malignom der Bronchien und der Lunge",
      "Multizentrische adenomatöse Pneumonie",
      "NSCLC [Non small cell lung cancer]",
      "Narbenkarzinom der Lunge",
      "Neuroendokriner Lungentumor",
      "Nicht kleinzelliges Lungenkarzinom",
      "Nicht-kleinzelliges Bronchialkarzinom",
      "Oat-cell-Karzinom",
      "Plattenepithelkarzinom der Bronchien",
      "Plattenepithelkarzinom der Lunge",
      "Pneumoblastom",
      "Pulmonale bösartige Neubildung",
      "Pulmonales Blastom",
      "SCLC [Small cell lung cancer]",
      "Schleimbildender karzinoider Tumor der Lunge",
      "Subpleurale bösartige Neubildung",
      "Teerkrebs der Lunge",
      "Zylinderkarzinom der Lunge"
    ]
  },
  {
    "code": "C37",
    "name": "Bösartige Neubildung des Thymus",
    "synonyms": [
      "Bösartige Neubildung des Thymus",
      "Bösartiges Thymom",
      "Gut differenziertes neuroendokrines Thymuskarzinom",
      "Malignes Thymom",
      "Malignes Thymom Typ A",
      "Malignes Thymom Typ AB",
      "Malignes Thymom Typ B",
      "Neuroendokriner Tumor des Thymus",
      "Neuroendokrines Thymuskarzinom",
      "Thymuskarzinom",
      "Thymuskrebs"
    ]
  },
  {
    "code": "C38.0",
    "name": "Herzbeutelkarzinom",
    "synonyms": [
      "Bösartige Neubildung des Atrium cordis",
      "Bösartige Neubildung des Endokards",
      "Bösartige Neubildung des Epikards",
      "Bösartige Neubildung des Herzens",
      "Bösartige Neubildung des Myokards",
      "Bösartige Neubildung des Perikards",
      "Herzbeutelkarzinom",
      "Herzkarzinom",
      "Herzkrebs",
      "Maligner primärer kardialer Tumor des Erwachsenen",
      "Maligner primärer kardialer Tumor im Kindesalter",
      "Perikardkarzinom"
    ]
  },
  {
    "code": "C38.1",
    "name": "Bösartige Neubildung des Mediastinum anterius",
    "synonyms": [
      "Bösartige Neubildung des Mediastinum anterius",
      "Bösartige Neubildung des anterioren Mediastinums",
      "Karzinom des Mediastinum anterius",
      "Krebs des Mediastinum anterius",
      "Substernale bösartige Neubildung"
    ]
  },
  {
    "code": "C38.2",
    "name": "Bösartige Neubildung des Mediastinum posterius",
    "synonyms": [
      "Bösartige Neubildung des Mediastinum posterius",
      "Bösartige Neubildung des posterioren Mediastinums",
      "Karzinom des Mediastinum posterius",
      "Krebs des Mediastinum posterius"
    ]
  },
  {
    "code": "C38.3",
    "name": "Bösartige Neubildung des Mediastinums",
    "synonyms": [
      "Bösartige Neubildung des Mediastinums",
      "Mediastinales Germinom",
      "Mediastinumkarzinom",
      "Mediastinumkrebs"
    ]
  },
  {
    "code": "C38.4",
    "name": "Karzinom der Pleura",
    "synonyms": [
      "Bösartige Neubildung der Pleura",
      "Bösartige Neubildung der Pleura parietalis",
      "Bösartige Neubildung der Pleura pulmonalis",
      "Bösartige Neubildung des Brustfells",
      "Karzinom der Pleura",
      "Karzinom der Pleura parietalis",
      "Karzinom der Pleura pulmonalis",
      "Karzinom des Brustfells",
      "Krebs der Pleura",
      "Krebs der Pleura parietalis",
      "Krebs der Pleura pulmonalis",
      "Krebs des Brustfells"
    ]
  },
  {
    "code": "C39.0",
    "name": "Bösartige Neubildung der oberen Luftwege",
    "synonyms": [
      "Bösartige Neubildung der oberen Atemwege",
      "Bösartige Neubildung der oberen Luftwege",
      "Bösartige Neubildung des oberen Respirationstraktes a.n.k.",
      "Karzinom der oberen Luftwege",
      "Krebs der oberen Luftwege"
    ]
  },
  {
    "code": "C39.9",
    "name": "Karzinom der Atmungsorgane",
    "synonyms": [
      "Bösartige Neubildung der Atemwege a.n.k.",
      "Bösartige Neubildung der Atmungsorgane",
      "Bösartige Neubildung der Respirationsorgane a.n.k.",
      "Bösartige Neubildung des Atemsystems a.n.k.",
      "Bösartige Neubildung des Respirationssystems a.n.k.",
      "Bösartige Neubildung des Respirationstraktes",
      "Karzinom der Atmungsorgane",
      "Krebs der Atmungsorgane"
    ]
  },
  {
    "code": "C40.0",
    "name": "Bösartige Neubildung des Schulterblattes",
    "synonyms": [
      "Adamantinom der langen Knochen der oberen Gliedmaßen",
      "Bösartige Neubildung am Armknochen a.n.k.",
      "Bösartige Neubildung am Ellenbogenknochen",
      "Bösartige Neubildung am Knochen der oberen Gliedmaßen a.n.k.",
      "Bösartige Neubildung am Schulterknochen",
      "Bösartige Neubildung am Unterarmknochen",
      "Bösartige Neubildung der Knochenhaut der Schulter",
      "Bösartige Neubildung der Knochenhaut der Skapula",
      "Bösartige Neubildung der Knochenhaut der Speiche",
      "Bösartige Neubildung der Knochenhaut der Ulna",
      "Bösartige Neubildung der Knochenhaut der langen Knochen der oberen Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Knochenhaut der oberen Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Knochenhaut des Akromions",
      "Bösartige Neubildung der Knochenhaut des Arms a.n.k.",
      "Bösartige Neubildung der Knochenhaut des Ellenbogens",
      "Bösartige Neubildung der Knochenhaut des Humerus",
      "Bösartige Neubildung der Knochenhaut des Radius",
      "Bösartige Neubildung der Knochenhaut des Unterarms",
      "Bösartige Neubildung der Skapula",
      "Bösartige Neubildung der Speiche",
      "Bösartige Neubildung der Ulna",
      "Bösartige Neubildung der langen Knochen der oberen Gliedmaßen a.n.k.",
      "Bösartige Neubildung des Akromioklavikulargelenks",
      "Bösartige Neubildung des Akromions",
      "Bösartige Neubildung des Humerus",
      "Bösartige Neubildung des Radius",
      "Bösartige Neubildung des Schulterblattes",
      "Chondrosarkom der Scapula",
      "Chondrosarkom der Schulter",
      "Chondrosarkom des Arms",
      "Ellensarkom",
      "Ewing-Sarkom der Skapula",
      "Ewing-Sarkom der Ulna",
      "Ewing-Sarkom des Humerus",
      "Ewing-Sarkom des Radius",
      "Humerussarkom",
      "Oberarmsarkom",
      "Osteosarkom der Skapula",
      "Osteosarkom der Ulna",
      "Osteosarkom des Humerus",
      "Osteosarkom des Radius",
      "Radiussarkom",
      "Sarkom des Schulterblattes",
      "Speichensarkom",
      "Ulnasarkom"
    ]
  },
  {
    "code": "C40.1",
    "name": "Bösartige Neubildung der Handphalangen",
    "synonyms": [
      "Bösartige Neubildung der Daumenknochen",
      "Bösartige Neubildung der Fingerknochen",
      "Bösartige Neubildung der Handknochen",
      "Bösartige Neubildung der Handphalangen",
      "Bösartige Neubildung der Handwurzelknochen",
      "Bösartige Neubildung der Knochenhaut der Finger",
      "Bösartige Neubildung der Knochenhaut der Hand",
      "Bösartige Neubildung der Knochenhaut der Handphalangen",
      "Bösartige Neubildung der Knochenhaut der Handwurzel",
      "Bösartige Neubildung der Knochenhaut der Mittelhand",
      "Bösartige Neubildung der Knochenhaut der kurzen Knochen der oberen Gliedmaßen",
      "Bösartige Neubildung der Knochenhaut des Daumens",
      "Bösartige Neubildung der Mittelhandknochen",
      "Bösartige Neubildung der kurzen Knochen der oberen Gliedmaßen a.n.k.",
      "Bösartige Neubildung des Metakarpus",
      "Chondrosarkom der kurzen Knochen der oberen Gliedmaßen",
      "Ewing-Sarkom der kurzen Knochen der oberen Gliedmaßen",
      "Osteosarkom der kurzen Knochen der oberen Gliedmaßen"
    ]
  },
  {
    "code": "C40.2",
    "name": "Sarkom des Wadenbeins",
    "synonyms": [
      "Adamantinom der Tibia",
      "Adamantinom der langen Knochen der unteren Gliedmaßen",
      "Ameloblastom der Tibia",
      "Bösartige Neubildung der Beinknochen a.n.k.",
      "Bösartige Neubildung der Fibula",
      "Bösartige Neubildung der Knochen am Kniegelenk",
      "Bösartige Neubildung der Knochen der unteren Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Knochenhaut der Fibula",
      "Bösartige Neubildung der Knochenhaut der Tibia",
      "Bösartige Neubildung der Knochenhaut der langen Knochen der unteren Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Knochenhaut der unteren Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Knochenhaut des Beins a.n.k.",
      "Bösartige Neubildung der Knochenhaut des Femurs",
      "Bösartige Neubildung der Knochenhaut des Knies",
      "Bösartige Neubildung der Tibia",
      "Bösartige Neubildung der langen Knochen der unteren Gliedmaßen a.n.k.",
      "Bösartige Neubildung des Femurs",
      "Bösartige Neubildung des Meniskus am Kniegelenk",
      "Bösartige Neubildung des Semilunarknorpels am Knie",
      "Chondrosarkom der langen Knochen der unteren Gliedmaßen",
      "Chondrosarkom des Femurs",
      "Ewing-Sarkom der Fibula",
      "Ewing-Sarkom der Tibia",
      "Ewing-Sarkom des Femurs",
      "Osteosarkom der Fibula",
      "Osteosarkom der Tibia",
      "Osteosarkom der langen Knochen der unteren Gliedmaßen",
      "Osteosarkom des Femurs",
      "Sarkom der Fibula",
      "Sarkom der Tibia",
      "Sarkom des Femurs",
      "Sarkom des Oberschenkelknochens",
      "Sarkom des Schienbeins",
      "Sarkom des Wadenbeins"
    ]
  },
  {
    "code": "C40.3",
    "name": "Sarkom der Kniescheibe",
    "synonyms": [
      "Bösartige Neubildung der Fußknochen",
      "Bösartige Neubildung der Fußphalangen",
      "Bösartige Neubildung der Fußwurzelknochen",
      "Bösartige Neubildung der Knochenhaut der Ferse",
      "Bösartige Neubildung der Knochenhaut der Fußphalangen",
      "Bösartige Neubildung der Knochenhaut der Fußwurzel",
      "Bösartige Neubildung der Knochenhaut der Patella",
      "Bösartige Neubildung der Knochenhaut der Zehen",
      "Bösartige Neubildung der Knochenhaut der kurzen Knochen der unteren Gliedmaßen",
      "Bösartige Neubildung der Knochenhaut des Astragalus",
      "Bösartige Neubildung der Knochenhaut des Calcaneus",
      "Bösartige Neubildung der Knochenhaut des Fersenbeins",
      "Bösartige Neubildung der Knochenhaut des Fußes",
      "Bösartige Neubildung der Knochenhaut des Knöchels",
      "Bösartige Neubildung der Knochenhaut des Mittelfußes",
      "Bösartige Neubildung der Knochenhaut des Sprungbeins",
      "Bösartige Neubildung der Mittelfußknochen",
      "Bösartige Neubildung der Patella",
      "Bösartige Neubildung der Zehenknochen",
      "Bösartige Neubildung der kurzen Knochen der unteren Gliedmaßen",
      "Bösartige Neubildung des Astragalus",
      "Bösartige Neubildung des Calcaneus",
      "Bösartige Neubildung des Fersenbeins",
      "Bösartige Neubildung des Fersenknochens",
      "Bösartige Neubildung des Fußknöchels",
      "Bösartige Neubildung des Metatarsus",
      "Bösartige Neubildung des Sprungbeins",
      "Bösartige Neubildung des Tarsus",
      "Chondrosarkom der kurzen Knochen der unteren Gliedmaßen",
      "Ewing-Sarkom der Patella",
      "Osteosarkom der Patella",
      "Osteosarkom der kurzen Knochen der unteren Gliedmaßen",
      "Patellasarkom",
      "Sarkom der Kniescheibe"
    ]
  },
  {
    "code": "C40.8",
    "name": "Ewing-Sarkom der oberen Gliedmaßen, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Chondrosarkom der Gliedmaßenknochen, mehrere Teilbereiche überlappend",
      "Ewing-Sarkom der oberen Gliedmaßen, mehrere Teilbereiche überlappend",
      "Ewing-Sarkom der unteren Gliedmaßen, mehrere Teilbereiche überlappend",
      "Osteosarkom der oberen Gliedmaßen, mehrere Teilbereiche überlappend",
      "Osteosarkom der unteren Gliedmaßen, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C40.9",
    "name": "Epiphysenteratom",
    "synonyms": [
      "Adamantinom eines Röhrenknochens",
      "Ameloblastom eines Röhrenknochens",
      "Bösartige Neubildung der Gliedmaßenknochen a.n.k.",
      "Bösartige Neubildung der Knochenhaut der Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Knochenhaut der Phalanxknochen",
      "Bösartige Neubildung der Phalangen",
      "Bösartige Neubildung eines kurzen Knochens",
      "Bösartige Neubildung eines langen Knochens",
      "Epiphysenteratom",
      "Ewing-Sarkom eines Röhrenknochens"
    ]
  },
  {
    "code": "C41.01",
    "name": "Sarkom des Os temporale",
    "synonyms": [
      "Bösartige Neubildung der Calvaria",
      "Bösartige Neubildung der Keilbeinknochen",
      "Bösartige Neubildung der Knochen der Augenhöhle",
      "Bösartige Neubildung der Knochen der Sella turcica",
      "Bösartige Neubildung der Knochen des Gehirn- und des Gesichtsschädels",
      "Bösartige Neubildung der Knochenhaut der Calvaria",
      "Bösartige Neubildung der Knochenhaut der Orbita",
      "Bösartige Neubildung der Knochenhaut der Sella turcica",
      "Bösartige Neubildung der Knochenhaut der Stirn",
      "Bösartige Neubildung der Knochenhaut des Clivus",
      "Bösartige Neubildung der Knochenhaut des Craniums",
      "Bösartige Neubildung der Knochenhaut des Hinterhauptbeins",
      "Bösartige Neubildung der Knochenhaut des Keilbeins",
      "Bösartige Neubildung der Knochenhaut des Scheitelbeins",
      "Bösartige Neubildung der Knochenhaut des Schläfenbeins",
      "Bösartige Neubildung der Knochenhaut des Schädeldaches",
      "Bösartige Neubildung der Knochenhaut des Schädels",
      "Bösartige Neubildung der Knochenhaut des Siebbeins",
      "Bösartige Neubildung der Orbitaknochen",
      "Bösartige Neubildung der Siebbeinknochen",
      "Bösartige Neubildung der Siebbeinzellen",
      "Bösartige Neubildung des Clivus",
      "Bösartige Neubildung des Craniums",
      "Bösartige Neubildung des Gehirnschädels",
      "Bösartige Neubildung des Hinterhauptbeins",
      "Bösartige Neubildung des Keilbeins",
      "Bösartige Neubildung des Mastoidknochens",
      "Bösartige Neubildung des Processus mastoideus",
      "Bösartige Neubildung des Scheitelbeins",
      "Bösartige Neubildung des Schläfenbeins",
      "Bösartige Neubildung des Schädeldaches",
      "Bösartige Neubildung des Schädelknochens",
      "Bösartige Neubildung des Stirnbeins",
      "Bösartige Neubildung des Warzenfortsatzes",
      "Bösartige Neubildung eines kraniofazialen Knochens",
      "Chondrosarkom des Schädelknochens",
      "Chordom des Schädelknochens",
      "Ewing-Sarkom des Gesichtsschädels",
      "Ewing-Sarkom des Schädeldaches",
      "Osteosarkom des Schädelknochens",
      "Sarkom des Os ethmoidale",
      "Sarkom des Os frontale",
      "Sarkom des Os occipitale",
      "Sarkom des Os parietale",
      "Sarkom des Os sphenoidale",
      "Sarkom des Os temporale",
      "Sarkom des Schädelknochens"
    ]
  },
  {
    "code": "C41.02",
    "name": "Sarkom des Oberkiefers",
    "synonyms": [
      "Ameloblastisches Fibrosarkom des Oberkieferknochens",
      "Ameloblastisches Karzinom des Oberkieferknochens",
      "Ameloblastisches Odontosarkom des Oberkieferknochens",
      "Ameloblastosarkom des Oberkieferknochens",
      "Amelosarkom des Oberkieferknochens",
      "Bösartige Neubildung der Gesichtsknochen",
      "Bösartige Neubildung der Knochen der Nasenmuschel",
      "Bösartige Neubildung der Knochen der Nebenhöhle",
      "Bösartige Neubildung der Knochenhaut der Gesichtsknochen",
      "Bösartige Neubildung der Knochenhaut der Nase",
      "Bösartige Neubildung der Knochenhaut des Jochbeins",
      "Bösartige Neubildung der Knochenhaut des Pflugscharbeins",
      "Bösartige Neubildung der Knochenhaut des Vomer",
      "Bösartige Neubildung der Knochenhaut des Zungenbeins",
      "Bösartige Neubildung der Maxilla",
      "Bösartige Neubildung der Nasenknochen",
      "Bösartige Neubildung des Gesichtsknochens",
      "Bösartige Neubildung des Gesichtsschädels",
      "Bösartige Neubildung des Jochbeins",
      "Bösartige Neubildung des Nasenbeins",
      "Bösartige Neubildung des Oberkieferalveolarfortsatzes",
      "Bösartige Neubildung des Oberkieferalveolarkamms",
      "Bösartige Neubildung des Oberkieferknochens",
      "Bösartige Neubildung des Pflugscharbeins",
      "Bösartige Neubildung des Zungenbeins",
      "Bösartige Neubildung eines maxillofazialen Knochens",
      "Bösartiger odontogener Oberkiefertumor",
      "Bösartiges Ameloblastom des Oberkieferknochens",
      "Chondrosarkom des Oberkieferknochens",
      "Ewing-Sarkom des Oberkieferknochens",
      "Intraossäres Karzinom des Oberkieferknochens",
      "Malignes Adamantinom des Oberkiefers",
      "Maxillasarkom",
      "Odontogenes Fibrosarkom des Oberkieferknochens",
      "Odontogenes Karzinom des Oberkieferknochens",
      "Odontogenes Sarkom des Oberkieferknochens",
      "Odontosarkom des Oberkieferknochens",
      "Osteosarkom des Oberkieferknochens",
      "Sarkom der Nasenmuschel",
      "Sarkom des Gesichtsknochens",
      "Sarkom des Oberkiefers",
      "Sarkom des Os nasale",
      "Sarkom des Os zygomaticum",
      "Sarkom des Vomer"
    ]
  },
  {
    "code": "C41.1",
    "name": "Kieferknochensarkom",
    "synonyms": [
      "Ameloblastisches Fibroodontosarkom",
      "Ameloblastisches Fibrosarkom",
      "Ameloblastisches Fibrosarkom des Unterkieferknochens",
      "Ameloblastisches Karzinom",
      "Ameloblastisches Karzinom des Unterkieferknochens",
      "Ameloblastisches Odontosarkom",
      "Ameloblastisches Odontosarkom des Unterkieferknochens",
      "Ameloblastosarkom",
      "Ameloblastosarkom des Unterkieferknochens",
      "Amelosarkom",
      "Amelosarkom des Unterkieferknochens",
      "Bösartige Neubildung der Kieferknochen",
      "Bösartige Neubildung der Knochenhaut der Mandibula",
      "Bösartige Neubildung der Knochenhaut des Kiefers",
      "Bösartige Neubildung der Knochenhaut des Unterkiefers",
      "Bösartige Neubildung des Alveolarfortsatzes",
      "Bösartige Neubildung des Alveolarkamms",
      "Bösartige Neubildung des Kieferknochens",
      "Bösartige Neubildung des Temporomandibulargelenks a.n.k.",
      "Bösartige Neubildung des Unterkieferalveolarfortsatzes",
      "Bösartige Neubildung des Unterkieferalveolarkammes",
      "Bösartige Neubildung des Unterkieferalveolarkamms",
      "Bösartige Neubildung des Unterkieferknochens",
      "Bösartiges Adamantinom",
      "Bösartiges Ameloblastom",
      "Bösartiges Unterkieferameloblastom",
      "Chondrosarkom des Unterkieferknochens",
      "Ewing-Sarkom des Unterkieferknochens",
      "Intraossäres Karzinom",
      "Kieferknochensarkom",
      "Maligner odontogener Tumor",
      "Maligner odontogener Tumor des Unterkieferknochens",
      "Malignes Adamantinom",
      "Malignes Unterkieferadamantinom",
      "Odontogenes Fibrosarkom",
      "Odontogenes Fibrosarkom des Unterkieferknochens",
      "Odontogenes Karzinom",
      "Odontogenes Karzinom des Unterkieferknochens",
      "Odontogenes Sarkom",
      "Odontogenes Sarkom des Unterkieferknochens",
      "Odontosarkom",
      "Odontosarkom des Unterkieferknochens",
      "Osteosarkom des Unterkieferknochens",
      "Sarkom der Mandibula",
      "Unterkieferknochensarkom",
      "Unterkiefersarkom"
    ]
  },
  {
    "code": "C41.2",
    "name": "Krebs der Columna vertebralis",
    "synonyms": [
      "Bösartige Neubildung der Columna vertebralis",
      "Bösartige Neubildung der Knochenhaut der Wirbelsäule",
      "Bösartige Neubildung der Knochenhaut des Atlas",
      "Bösartige Neubildung der Knochenhaut des Axis",
      "Bösartige Neubildung der Knochenhaut des Rückens a.n.k.",
      "Bösartige Neubildung der Knochenhaut eines Wirbels",
      "Bösartige Neubildung der Rückenknochen a.n.k.",
      "Bösartige Neubildung der Wirbelsäule",
      "Bösartige Neubildung des Atlas",
      "Bösartige Neubildung des Axis",
      "Bösartige Neubildung einer Bandscheibe",
      "Bösartige Neubildung einer Intervertebralscheibe",
      "Bösartige Neubildung einer Zwischenwirbelscheibe",
      "Bösartige Neubildung eines Discus intervertebralis",
      "Bösartige Neubildung eines Nucleus pulposus",
      "Bösartige Neubildung eines Wirbels",
      "Chondroides Chordom der Wirbelsäule",
      "Chondrosarkom der Halswirbelsäule",
      "Chondrosarkom eines Brustwirbelkörpers",
      "Chordom der Lendenwirbelsäule",
      "Ewing-Sarkom der Wirbelsäule",
      "Krebs der Columna vertebralis",
      "Osteosarkom der Wirbelsäule",
      "Sarkom der Columna vertebralis",
      "Wirbelkörpersarkom",
      "Wirbelsarkom",
      "Wirbelsäulenkrebs",
      "Wirbelsäulensarkom"
    ]
  },
  {
    "code": "C41.30",
    "name": "Bösartige Neubildung der Rippe",
    "synonyms": [
      "Bösartige Neubildung der Knochenhaut der Rippen",
      "Bösartige Neubildung der Rippe",
      "Bösartige Neubildung des Kostalknorpels",
      "Bösartige Neubildung des Kostovertebralgelenks a.n.k.",
      "Bösartige Neubildung des Rippenknorpels",
      "Chondrosarkom der Rippe",
      "Ewing-Sarkom der Rippe",
      "Osteosarkom der Rippe",
      "Rippensarkom"
    ]
  },
  {
    "code": "C41.31",
    "name": "Bösartige Neubildung des Brustbeins",
    "synonyms": [
      "Brustbeinsarkom",
      "Bösartige Neubildung der Knochenhaut des Brustbeins",
      "Bösartige Neubildung der Knochenhaut des Processus xiphoideus",
      "Bösartige Neubildung des Brustbeins",
      "Bösartige Neubildung des Processus xiphoideus",
      "Bösartige Neubildung des Sternokostalgelenks a.n.k.",
      "Bösartige Neubildung des Sternums",
      "Chondrosarkom des Sternums",
      "Ewing-Sarkom des Sternums",
      "Osteosarkom des Sternums",
      "Sternumsarkom"
    ]
  },
  {
    "code": "C41.32",
    "name": "Bösartige Neubildung des Schlüsselbeins",
    "synonyms": [
      "Bösartige Neubildung der Klavikula",
      "Bösartige Neubildung der Knochenhaut der Klavikula",
      "Bösartige Neubildung der Knochenhaut des Schlüsselbeins",
      "Bösartige Neubildung des Schlüsselbeins",
      "Chondrosarkom der Klavikula",
      "Ewing-Sarkom der Klavikula",
      "Klavikulasarkom",
      "Osteosarkom des Schlüsselbeins",
      "Schlüsselbeinsarkom"
    ]
  },
  {
    "code": "C41.4",
    "name": "Bösartige Neubildung des Beckenknochens",
    "synonyms": [
      "Bösartige Neubildung der Hüftknochen",
      "Bösartige Neubildung der Knochenhaut der Hüfte",
      "Bösartige Neubildung der Knochenhaut des Azetabulums",
      "Bösartige Neubildung der Knochenhaut des Beckens",
      "Bösartige Neubildung der Knochenhaut des Darmbeins",
      "Bösartige Neubildung der Knochenhaut des Hüftbeins",
      "Bösartige Neubildung der Knochenhaut des Kreuzbeins",
      "Bösartige Neubildung der Knochenhaut des Schambeins",
      "Bösartige Neubildung der Knochenhaut des Sitzbeins",
      "Bösartige Neubildung der Knochenhaut des Steißbeins",
      "Bösartige Neubildung der Symphysis pubica",
      "Bösartige Neubildung des Azetabulums",
      "Bösartige Neubildung des Beckenknochens",
      "Bösartige Neubildung des Darmbeins",
      "Bösartige Neubildung des Hüftbeins",
      "Bösartige Neubildung des Kreuzbeins",
      "Bösartige Neubildung des Schambeins",
      "Bösartige Neubildung des Sitzbeins",
      "Bösartige Neubildung des Steißbeins",
      "Chondroides Chordom am Steißbein",
      "Chondrosarkom des Azetabulums",
      "Chondrosarkom des Beckenknochens",
      "Chondrosarkom des Beckens",
      "Chordom des Os sacrum",
      "Ewing-Sarkom des Beckens",
      "Ewing-Sarkom des Kreuzbeins",
      "Ewing-Sarkom des Steißbeins",
      "Kreuzbeinsarkom",
      "Malignes sakrokokzygeales Teratom",
      "Osteosarkom des Beckenknochens",
      "Osteosarkom des Sakrums",
      "Sarkom des Beckenknochens",
      "Steißbeinsarkom"
    ]
  },
  {
    "code": "C41.8",
    "name": "Ewing-Sarkom des Knochens, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Chondrosarkom, mehrere Teilbereiche überlappend",
      "Ewing-Sarkom des Knochens, mehrere Teilbereiche überlappend",
      "Osteosarkom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C41.9",
    "name": "Bösartige Neubildung des Knochens mit Knorpel",
    "synonyms": [
      "Angioendotheliom des Knochens",
      "Bösartige Neubildung der Knochenhaut",
      "Bösartige Neubildung der Knochenhaut des Skelett a.n.k.",
      "Bösartige Neubildung des Gelenkknorpels a.n.k.",
      "Bösartige Neubildung des Knochens",
      "Bösartige Neubildung des Knochens mit Knorpel",
      "Bösartige Neubildung des Skeletts a.n.k.",
      "Bösartige Neubildung eines Gelenks a.n.k.",
      "Bösartiges Chondroblastom",
      "Bösartiges Osteoklastom",
      "Chondroblastisches Sarkom",
      "Chondromyxosarkom",
      "Chondroplastisches Osteosarkom",
      "Chondroplastisches Sarkom",
      "Chondrosarkom",
      "Chondrosarkom des Gelenkknorpels",
      "Diffuses Endotheliom [Ewing-Sarkom]",
      "Diffuses Hämangioendotheliom des Knochens",
      "Enchondroma malignum",
      "Endotheliales Myelom",
      "Ewing-Angioendotheliom",
      "Ewing-Sarkom",
      "Ewing-Tumor",
      "Fibroblastisches Osteosarkom",
      "Fibrochondrosarkom",
      "Juxtakortikales Chondrosarkom",
      "Juxtakortikales Osteosarkom",
      "Kleinzelliges Osteosarkom",
      "Knochenkrebs",
      "Knochensarkom",
      "Knochensarkom mit Knorpelbeteiligung",
      "Knorpelsarkom",
      "Knorpelsarkom mit Knochenbeteiligung",
      "Myxochondrosarkom",
      "Myxoides Chondrosarkom",
      "Omoblastom",
      "Osteoblastisches Sarkom",
      "Osteochondromyxosarkom",
      "Osteochondrosarkom",
      "Osteoclastoma malignum",
      "Osteofibrosarkom",
      "Osteogenes Sarkom",
      "Osteoplastisches Sarkom",
      "Osteosarkom",
      "Parostales Osteosarkom",
      "Periostales Fibrosarkom",
      "Periostales Sarkom",
      "Sarkom eines Gelenks",
      "Teleangiektatisches Osteosarkom",
      "Undifferenziertes Rundzellensarkom des Knochens"
    ]
  },
  {
    "code": "C43.0",
    "name": "Malignes Melanom der Lippe",
    "synonyms": [
      "Bösartiges Melanom der Lippe",
      "Familiäres Melanom der Lippe",
      "Malignes Melanom der Lippe"
    ]
  },
  {
    "code": "C43.1",
    "name": "Malignes Melanom des Augenwinkels",
    "synonyms": [
      "Bösartiges Melanom des Augenlides",
      "Bösartiges Melanom des Augenlides und des Kanthus",
      "Familiäres Melanom des Augenlids",
      "Familiäres Melanom des Kanthus",
      "Malignes Melanom der Palpebra",
      "Malignes Melanom des Augenlids",
      "Malignes Melanom des Augenwinkels",
      "Malignes Melanom des Kanthus",
      "Malignes Melanom des Lidwinkels"
    ]
  },
  {
    "code": "C43.2",
    "name": "Malignes Melanom des Ohres",
    "synonyms": [
      "Familiäres Melanom des äußeren Gehörganges",
      "Malignes Melanom der Ohrhelix",
      "Malignes Melanom der Ohrmuschel",
      "Malignes Melanom des Meatus acusticus externus",
      "Malignes Melanom des Mittelohres",
      "Malignes Melanom des Ohres",
      "Malignes Melanom des Ohres und des äußeren Gehörganges",
      "Malignes Melanom des äußeren Gehörganges"
    ]
  },
  {
    "code": "C43.3",
    "name": "Malignes Melanom des Gesichts",
    "synonyms": [
      "Familiäres Melanom des Gesichts",
      "Malignes Melanom der Ala nasi",
      "Malignes Melanom der Augenbraue",
      "Malignes Melanom der Glabella",
      "Malignes Melanom der Nase",
      "Malignes Melanom der Nasolabialfalte",
      "Malignes Melanom der Schläfe",
      "Malignes Melanom der Stirn",
      "Malignes Melanom der Wange",
      "Malignes Melanom der äußeren Nase",
      "Malignes Melanom der äußeren Wange",
      "Malignes Melanom des Gesichts",
      "Malignes Melanom des Kiefers",
      "Malignes Melanom des Kinns"
    ]
  },
  {
    "code": "C43.4",
    "name": "Malignes Melanom der Kopfhaut",
    "synonyms": [
      "Familiäres Melanom der behaarten Kopfhaut",
      "Familiäres Melanom des Halses",
      "Malignes Melanom der Kopfhaut",
      "Malignes Melanom der behaarten Kopfhaut",
      "Malignes Melanom des Halses"
    ]
  },
  {
    "code": "C43.5",
    "name": "Malignes Melanom der Leistenbeuge",
    "synonyms": [
      "Bösartiges Melanom des Rumpfes",
      "Familiäres Melanom des Rumpfes",
      "Malignes Melanom der Analhaut",
      "Malignes Melanom der Axilla",
      "Malignes Melanom der Bauchwand",
      "Malignes Melanom der Brust",
      "Malignes Melanom der Brustdrüsenhaut",
      "Malignes Melanom der Brustwand",
      "Malignes Melanom der Flanke",
      "Malignes Melanom der Interskapularregion",
      "Malignes Melanom der Leistenbeuge",
      "Malignes Melanom der Lende",
      "Malignes Melanom der Mammahaut",
      "Malignes Melanom der Nates",
      "Malignes Melanom der Perianalhaut",
      "Malignes Melanom der Submammärfalte",
      "Malignes Melanom des Analrandes",
      "Malignes Melanom des Gesäßes",
      "Malignes Melanom des Nabels",
      "Malignes Melanom des Perineums",
      "Malignes Melanom des Rumpfes a.n.k.",
      "Malignes Melanom des Rückens",
      "Malignes Melanom des Stamms",
      "Malignes Melanom des Unterbauches"
    ]
  },
  {
    "code": "C43.6",
    "name": "Malignes Melanom der oberen Gliedmaßen",
    "synonyms": [
      "Bösartiges Melanom der Schulter",
      "Bösartiges Melanom der oberen Extremität",
      "Familiäres Melanom der Schulter",
      "Familiäres Melanom der oberen Extremität",
      "Malignes Melanom der Hand",
      "Malignes Melanom der Schulter",
      "Malignes Melanom der oberen Extremität a.n.k.",
      "Malignes Melanom der oberen Gliedmaßen",
      "Malignes Melanom des Arms",
      "Malignes Melanom des Ellenbogens",
      "Malignes Melanom des Unterarms",
      "Malignes Melanom eines Fingers",
      "Melanom eines Fingernagels"
    ]
  },
  {
    "code": "C43.7",
    "name": "Malignes Melanom des Beins",
    "synonyms": [
      "Bösartiges Melanom der Haut der Hüfte",
      "Bösartiges Melanom der unteren Extremität",
      "Familiäres Melanom der Hüfte",
      "Familiäres Melanom der unteren Extremität",
      "Malignes Melanom der Ferse",
      "Malignes Melanom der Haut der unteren Gliedmaßen",
      "Malignes Melanom der Hüfte",
      "Malignes Melanom der Kniekehle",
      "Malignes Melanom der unteren Extremität a.n.k.",
      "Malignes Melanom der unteren Gliedmaßen",
      "Malignes Melanom des Beins",
      "Malignes Melanom des Fußes",
      "Malignes Melanom des Knies",
      "Malignes Melanom des Knöchels",
      "Malignes Melanom des Oberschenkels",
      "Malignes Melanom des Unterschenkels",
      "Malignes Melanom des Vorfußes",
      "Malignes Melanom einer Zehe",
      "Malignes superfiziell spreitendes Melanom des Unterschenkels",
      "Melanom eines Zehennagels"
    ]
  },
  {
    "code": "C43.8",
    "name": "Familiäres Melanom der Haut, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Bösartiges Melanom der Haut, mehrere Teilbereiche überlappend",
      "Familiäres Melanom der Haut, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C43.9",
    "name": "Malignes Melanom der Haut",
    "synonyms": [
      "Achromatisches Melanom",
      "Amelanotisches Melanom",
      "Ballonzell-Melanom",
      "Blasenzellen-Melanom",
      "Bösartiges Melanom",
      "Bösartiges akrolentiginöses Melanom",
      "Desmoplastisches bösartiges Melanom",
      "Epitheloidzelliges Melanom",
      "Epitheloidzelliges Melanosarkom",
      "Familiäres Melanom",
      "Hautmelanokarzinom",
      "Malignes Melanom",
      "Malignes Melanom an einem Nagel",
      "Malignes Melanom der Haut",
      "Malignes Melanom in Sommersprossen",
      "Malignes Schleimhautmelanom",
      "Malignes akrolentiginöses Melanom",
      "Malignes amelanotisches Melanom",
      "Malignes knotiges Melanom",
      "Malignes noduläres Melanom",
      "Malignes superfiziell spreitendes Melanom",
      "Melanom",
      "Melanom-Rezidiv",
      "Melanotisches Sarkom",
      "Metastasiertes malignes Melanom",
      "Naevus malignus",
      "Neurotrophes bösartiges Melanom",
      "Noduläres Melanom",
      "Oberflächlich spreitendes Melanom",
      "Regressives bösartiges Melanom",
      "Superficial spreading melanoma"
    ]
  },
  {
    "code": "C44.0",
    "name": "Lippenbasaliom",
    "synonyms": [
      "Basalzellkarzinom der Lippe",
      "Bösartige Neubildung der Lippenhaut",
      "Lippenbasaliom",
      "Lippenhautkarzinom",
      "Lippenhautkrebs",
      "Merkel-Zell-Karzinom der Lippenhaut",
      "Nichtmelanomartige bösartige Neubildung der Lippenhaut"
    ]
  },
  {
    "code": "C44.1",
    "name": "Lidbasaliom",
    "synonyms": [
      "Augenlidbasaliom",
      "Augenlidkarzinom",
      "Augenlidkrebs",
      "Augenwinkelbasaliom",
      "Bösartige Neubildung der Meibom-Drüsen",
      "Bösartige Neubildung der Palpebra",
      "Bösartige Neubildung des Augenlids",
      "Bösartige Neubildung des Augenwinkels",
      "Bösartige Neubildung des Lids",
      "Drüsenkarzinom des Lids",
      "Lidbasaliom",
      "Maligner Lidhauttumor",
      "Maligner Tumor des Lids und Kanthus",
      "Meibom-Karzinom",
      "Merkel-Zell-Karzinom des Augenlids",
      "Nichtmelanomartige bösartige Neubildung der Augenlidhaut",
      "Nichtmelanomartige bösartige Neubildung der Augenwinkelhaut",
      "Nichtmelanomartige bösartige Neubildung der Palpebralhaut",
      "Nichtmelanomartige bösartige Neubildung des Lids",
      "Oberlidbasaliom",
      "Plattenepithelkarzinom des Lids",
      "Unterlidbasaliom"
    ]
  },
  {
    "code": "C44.2",
    "name": "Gehörgangskarzinom",
    "synonyms": [
      "Bösartige Neubildung der Auricula",
      "Bösartige Neubildung der Haut des Ohres",
      "Bösartige Neubildung der Ohrhelix",
      "Bösartige Neubildung der Ohrmuschel",
      "Bösartige Neubildung des Gehörganges",
      "Bösartige Neubildung des Meatus acusticus externus",
      "Bösartige Neubildung des Ohrkanals",
      "Bösartige Neubildung des Ohrläppchens",
      "Bösartige Neubildung des Tragus",
      "Bösartige Neubildung des äußeren Gehörganges",
      "Gehörgangskarzinom",
      "Gehörgangskrebs",
      "Merkel-Zell-Karzinom der Haut des Ohres",
      "Nichtmelanomartige bösartige Neubildung der Haut der Ohrhelix",
      "Nichtmelanomartige bösartige Neubildung der Haut des Tragus",
      "Nichtmelanomartige bösartige Neubildung der Haut des äußeren Gehörganges",
      "Nichtmelanomartige bösartige Neubildung der Ohrhaut",
      "Nichtmelanomartige bösartige Neubildung der Ohrmuschelhaut",
      "Ohrbasaliom",
      "Ohrhautkarzinom",
      "Ohrmuschelbasaliom",
      "Ohrspinaliom",
      "Zeruminöses Adenokarzinom",
      "Zeruminöses Karzinom"
    ]
  },
  {
    "code": "C44.3",
    "name": "Gesichtshautbasaliom",
    "synonyms": [
      "Augenbrauenbasaliom",
      "Basaliom des medialen Jochbogens",
      "Basalzellkarzinom der Wange",
      "Basalzellkarzinom des Oberkiefers",
      "Bösartige Neubildung der Columella nasi",
      "Bösartige Neubildung der Haut der Augenbraue",
      "Bösartige Neubildung der Haut der Schläfe",
      "Bösartige Neubildung der Kieferhaut",
      "Bösartige Neubildung der Kinnhaut",
      "Bösartige Neubildung der Nasenhaut",
      "Bösartige Neubildung der Nasolabialfalte",
      "Bösartige Neubildung der Stirnhaut",
      "Bösartige Neubildung der Wangenaußenseite",
      "Bösartige Neubildung der äußeren Nase",
      "Bösartige Neubildung des Ala nasi externa",
      "Bösartige Neubildung des Nasenflügels",
      "Gesichtsbasaliom",
      "Gesichtshautbasaliom",
      "Gesichtshautkarzinom",
      "Gesichtshautspinaliom",
      "Karzinom der Haut der Augenbraue",
      "Karzinom der Haut der Schläfe",
      "Merkel-Zell-Karzinom der Gesichtshaut",
      "Nasenbasaliom",
      "Nasenspinaliom",
      "Nichtmelanomartige bösartige Neubildung der Gesichtshaut a.n.k.",
      "Nichtmelanomartige bösartige Neubildung der Haut der Columella nasi",
      "Nichtmelanomartige bösartige Neubildung der Kieferhaut",
      "Nichtmelanomartige bösartige Neubildung der Kinnhaut",
      "Nichtmelanomartige bösartige Neubildung der Nasenflügelhaut",
      "Nichtmelanomartige bösartige Neubildung der Nasenhaut",
      "Nichtmelanomartige bösartige Neubildung der Stirnhaut",
      "Nichtmelanomartige bösartige Neubildung der Wangenhaut",
      "Schläfenbasaliom",
      "Schläfenspinaliom",
      "Stirnbasaliom",
      "Wangenbasaliom"
    ]
  },
  {
    "code": "C44.4",
    "name": "Halsbasaliom",
    "synonyms": [
      "Angiosarkom der Kopfhaut",
      "Basaliom der behaarten Kopfhaut",
      "Bösartige Neubildung der Haut des Halses",
      "Bösartige Neubildung der Kopfhaut",
      "Bösartige Neubildung der Kopfschwarte",
      "Dermatofibrosarcoma protuberans der Haut des Halses",
      "Dermatofibrosarcoma protuberans der Kopfhaut",
      "Halsbasaliom",
      "Karzinom der Haut des Halses",
      "Karzinom der behaarten Kopfhaut",
      "Kopfhautbasaliom",
      "Kopfhautkarzinom",
      "Kopfhautspinaliom",
      "Merkel-Zell-Karzinom der Haut des Halses",
      "Merkel-Zell-Karzinom der Kopfhaut",
      "Nichtmelanomartige bösartige Neubildung der Haut der Halsgegend",
      "Nichtmelanomartige bösartige Neubildung der Haut der Nackengegend",
      "Nichtmelanomartige bösartige Neubildung der Haut der Supraklavikulargrube",
      "Nichtmelanomartige bösartige Neubildung der Kopfschwarte",
      "Nichtmelanomartige bösartige Neubildung des Kopfes a.n.k.",
      "Pilomatrixkarzinom des Halses",
      "Pilomatrixkarzinom des Kopfes"
    ]
  },
  {
    "code": "C44.50",
    "name": "Karzinom des Analrandes",
    "synonyms": [
      "Analrandkarzinom",
      "Basaliom des Anus",
      "Basaliom des Perineums",
      "Bösartige Neubildung der Analhaut",
      "Bösartige Neubildung der Perianalhaut",
      "Bösartige Neubildung des Analrandes",
      "Karzinom der Analhaut",
      "Karzinom der Haut des Perineums",
      "Karzinom des Analrandes",
      "Maligner Analrandtumor",
      "Nichtmelanomartige bösartige Neubildung der Analhaut",
      "Nichtmelanomartige bösartige Neubildung der Perianalhaut",
      "Nichtmelanomartige bösartige Neubildung der Perineumhaut",
      "Paget-Karzinom der Analhaut",
      "Perianale bösartige Neubildung",
      "Perianalkarzinom"
    ]
  },
  {
    "code": "C44.59",
    "name": "Basaliom des Gesäßes",
    "synonyms": [
      "Axillabasaliom",
      "Basaliom des Gesäßes",
      "Bauchwandbasaliom",
      "Brustbasaliom",
      "Bösartige Neubildung der Brustdrüsenhaut",
      "Bösartige Neubildung der Haut der Bauchwand",
      "Bösartige Neubildung der Haut des Rumpfes",
      "Bösartige Neubildung der Hautfalte der Achselhöhle",
      "Bösartige Neubildung der Mammahaut",
      "Bösartige Steißbeinzyste",
      "Dermatofibrosarcoma protuberans der Haut der Bauchwand",
      "Dermatofibrosarcoma protuberans der Haut des Rumpfes",
      "Dermatofibrosarcoma protuberans der Haut des Rückens",
      "Karzinom der Haut der Axilla",
      "Karzinom der Haut der Bauchdecke",
      "Karzinom der Haut der Bauchwand",
      "Karzinom der Haut der Brust",
      "Karzinom der Haut des Rumpfes",
      "Karzinom der Haut des Rückens",
      "Maligne Pilonidalzyste",
      "Merkel-Zell-Karzinom der Haut des Rumpfes",
      "Nichtmelanomartige bösartige Neubildung der Achselhaut",
      "Nichtmelanomartige bösartige Neubildung der Bauchhaut",
      "Nichtmelanomartige bösartige Neubildung der Bauchwandhaut",
      "Nichtmelanomartige bösartige Neubildung der Brusthaut",
      "Nichtmelanomartige bösartige Neubildung der Brustwandhaut",
      "Nichtmelanomartige bösartige Neubildung der Flankenhaut",
      "Nichtmelanomartige bösartige Neubildung der Gesäßhaut",
      "Nichtmelanomartige bösartige Neubildung der Haut der Achselhöhle",
      "Nichtmelanomartige bösartige Neubildung der Haut der Glutäalregion",
      "Nichtmelanomartige bösartige Neubildung der Haut der Inguinalregion",
      "Nichtmelanomartige bösartige Neubildung der Haut der Kreuzbeingegend",
      "Nichtmelanomartige bösartige Neubildung der Haut der Leistenbeuge",
      "Nichtmelanomartige bösartige Neubildung der Haut der Leistengegend",
      "Nichtmelanomartige bösartige Neubildung der Haut der Schamgegend",
      "Nichtmelanomartige bösartige Neubildung der Haut der Skapularregion",
      "Nichtmelanomartige bösartige Neubildung der Haut der Steißbeingegend",
      "Nichtmelanomartige bösartige Neubildung der Haut der Thoraxwand",
      "Nichtmelanomartige bösartige Neubildung der Haut der submammären Falte",
      "Nichtmelanomartige bösartige Neubildung der Haut des Klavikulargebietes",
      "Nichtmelanomartige bösartige Neubildung der Nabelhaut",
      "Nichtmelanomartige bösartige Neubildung der Rückenhaut",
      "Nichtmelanomartige bösartige Neubildung der Thoraxhaut",
      "Nichtmelanomartige bösartige Neubildung der subklavikulären Haut",
      "Pilomatrixkarzinom des Rumpfes",
      "Rumpfbasaliom",
      "Rumpfhautbasaliom",
      "Rückenbasaliom"
    ]
  },
  {
    "code": "C44.6",
    "name": "Schulterbasaliom",
    "synonyms": [
      "Basaliom der oberen Gliedmaßen",
      "Bösartige Neubildung der Haut der Schulter",
      "Dermatofibrosarcoma protuberans der Haut der oberen Gliedmaßen",
      "Handspinaliom",
      "Karzinom der Haut der Schulter",
      "Karzinom der Haut der oberen Gliedmaßen",
      "Merkel-Zell-Karzinom der Haut der Schulter",
      "Merkel-Zell-Karzinom der Haut der oberen Gliedmaßen",
      "Nichtmelanomartige bösartige Neubildung der Armhaut",
      "Nichtmelanomartige bösartige Neubildung der Daumenhaut",
      "Nichtmelanomartige bösartige Neubildung der Ellenbeugenhaut",
      "Nichtmelanomartige bösartige Neubildung der Ellenbogenhaut",
      "Nichtmelanomartige bösartige Neubildung der Fingerhaut",
      "Nichtmelanomartige bösartige Neubildung der Handhaut",
      "Nichtmelanomartige bösartige Neubildung der Haut der oberen Gliedmaßen a.n.k.",
      "Nichtmelanomartige bösartige Neubildung der Unterarmhaut",
      "Nichtmelanomartige bösartige Neubildung des Handflächenhaut",
      "Oberarmbasaliom",
      "Pilomatrixkarzinom der oberen Gliedmaßen",
      "Schulterbasaliom",
      "Schulterspinaliom",
      "Unterarmbasaliom"
    ]
  },
  {
    "code": "C44.7",
    "name": "Hüftbasaliom",
    "synonyms": [
      "Basaliom der unteren Gliedmaßen",
      "Bösartige Neubildung der Haut der Hüfte",
      "Dermatofibrosarcoma protuberans der Haut der unteren Gliedmaßen",
      "Hüftbasaliom",
      "Karzinom der Haut der Hüfte",
      "Merkel-Zell-Karzinom der Haut der Hüfte",
      "Merkel-Zell-Karzinom der Haut der unteren Gliedmaßen",
      "Nichtmelanomartige bösartige Neubildung der Beinhaut",
      "Nichtmelanomartige bösartige Neubildung der Fersenhaut",
      "Nichtmelanomartige bösartige Neubildung der Fußhaut",
      "Nichtmelanomartige bösartige Neubildung der Fußsohlenhaut",
      "Nichtmelanomartige bösartige Neubildung der Haut der unteren Gliedmaßen a.n.k.",
      "Nichtmelanomartige bösartige Neubildung der Haut des Knöchels",
      "Nichtmelanomartige bösartige Neubildung der Kniehaut",
      "Nichtmelanomartige bösartige Neubildung der Kniekehlenhaut",
      "Nichtmelanomartige bösartige Neubildung der Oberschenkelhaut",
      "Nichtmelanomartige bösartige Neubildung der Plantarhaut",
      "Nichtmelanomartige bösartige Neubildung der Wadenhaut",
      "Nichtmelanomartige bösartige Neubildung der Zehenhaut"
    ]
  },
  {
    "code": "C44.8",
    "name": "Dermatofibrosarcoma protuberans der Haut, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Dermatofibrosarcoma protuberans der Haut, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C44.9",
    "name": "Basalzellkarzinom",
    "synonyms": [
      "Adenokarzinom der Schweißdrüsen",
      "Adenokarzinom der Talgdrüsen",
      "Apokrines Adenokarzinom",
      "Apokrines Karzinom",
      "Basaliom",
      "Basaliom mit epidermoider Differenzierung",
      "Basalioma rodens",
      "Basalioma sclerodermiforme",
      "Basalioma terebrans",
      "Basalzellepitheliom",
      "Basalzellgeschwulst",
      "Basalzellkarzinom",
      "Bednar-Tumor",
      "Bowen-Karzinom",
      "Bösartige Neubildung der Haut",
      "Bösartige Neubildung der Schweißdrüsen",
      "Bösartige Neubildung der Talgdrüsen",
      "Bösartiges Pilomatrixom",
      "Carcinoma basocellulare",
      "Carcinoma sebaceum",
      "Carcinoma spino-basocellulare",
      "Dermatofibrosarcoma protuberans",
      "Dermatofibrosarkom",
      "Epithelioma basocellulare",
      "Exulzerierendes Basaliom",
      "Fibroepitheliales Basaliom",
      "Fibroepitheliales basalzelliges Karzinom",
      "Gemischtes baso-spinozelluläres Karzinom",
      "Hautbasaliom",
      "Hautbasalzellkarzinom",
      "Hautkarzinom",
      "Hautkrebs",
      "Hautmalignom",
      "Hidradenokarzinom",
      "Karzinom der Hautanhangsgebilde",
      "Koriumkarzinom",
      "Kutanes neuroendokrines Karzinom",
      "Maligne Narbe",
      "Malignes Basaliom",
      "Merkel-Zell-Karzinom",
      "Merkel-Zell-Tumor",
      "Metatypisches Karzinom",
      "Multizentrisches Basaliom",
      "Narbenkarzinom der Haut",
      "Nichtmelanomartige bösartige Neubildung der Gliedmaßenhaut a.n.k.",
      "Nichtmelanomartige bösartige Neubildung der Haut a.n.k.",
      "Pigmentiertes Basaliom",
      "Pigmentiertes Basalzellkarzinom",
      "Pilomatrixkarzinom",
      "Plattenepithelkarzinom der Haut",
      "Progressives rezidivierendes Dermatofibrom",
      "Schweißdrüsenkarzinom",
      "Spinaliom der Haut [Plattenepithelkarzinom]",
      "Talgdrüsenkarzinom",
      "Teerkrebs der Haut",
      "Ulcus rodens"
    ]
  },
  {
    "code": "C45.0",
    "name": "Pleuramesotheliom",
    "synonyms": [
      "Mesotheliom der Pleura",
      "Pleuramesotheliom"
    ]
  },
  {
    "code": "C45.1",
    "name": "Peritonealmesotheliom",
    "synonyms": [
      "Bauchfellmesotheliom",
      "Malignes Peritonealmesotheliom",
      "Mesotheliom des Mesenteriums",
      "Mesotheliom des Mesokolons",
      "Mesotheliom des Omentums",
      "Mesotheliom des Peritoneum parietale",
      "Mesotheliom des Peritoneum viscerale",
      "Mesotheliom des Peritoneums",
      "Peritonealmesotheliom"
    ]
  },
  {
    "code": "C45.2",
    "name": "Perikardmesotheliom",
    "synonyms": [
      "Perikardmesotheliom"
    ]
  },
  {
    "code": "C45.7",
    "name": "Lebermesotheliom",
    "synonyms": [
      "Lebermesotheliom",
      "Lungenmesotheliom",
      "Mesotheliom des Mediastinums",
      "Mesotheliom des Retroperitoneums"
    ]
  },
  {
    "code": "C45.9",
    "name": "Mesotheliom",
    "synonyms": [
      "Biphasisches bösartiges Mesotheliom",
      "Epitheloidzelliges Mesotheliom",
      "Fibröses Mesotheliom",
      "Malignes Mesotheliom",
      "Mesotheliales Sarkom",
      "Mesotheliom",
      "Mesothelioma"
    ]
  },
  {
    "code": "C46.0",
    "name": "Idiopathische Hautsarkomatose",
    "synonyms": [
      "Akrosarkom",
      "Idiopathische Hautsarkomatose",
      "Kaposi-Sarkom der Haut"
    ]
  },
  {
    "code": "C46.1",
    "name": "Kaposi-Sarkom des Weichteilgewebes",
    "synonyms": [
      "Kaposi-Sarkom des Bindegewebes",
      "Kaposi-Sarkom des Weichteilgewebes"
    ]
  },
  {
    "code": "C46.2",
    "name": "Kaposi-Sarkom des Gaumens",
    "synonyms": [
      "Kaposi-Sarkom des Gaumens"
    ]
  },
  {
    "code": "C46.3",
    "name": "Kaposi-Sarkom der Lymphknoten",
    "synonyms": [
      "Kaposi-Sarkom der Lymphknoten"
    ]
  },
  {
    "code": "C46.7",
    "name": "Kaposi-Sarkom der Konjunktiva",
    "synonyms": [
      "Kaposi-Sarkom der Konjunktiva"
    ]
  },
  {
    "code": "C46.8",
    "name": "Kaposi-Sarkom mehrerer Organe",
    "synonyms": [
      "Kaposi-Sarkom mehrerer Organe"
    ]
  },
  {
    "code": "C46.9",
    "name": "Kaposi-Sarkom",
    "synonyms": [
      "Angioendothelioma cutaneum",
      "Angiomatosis Kaposi",
      "Angiomatosis multiplex haemorrhagica",
      "Granuloma multiplex haemorrhagicum Koebner",
      "Kaposi-Sarkom",
      "Kaposi-Syndrom",
      "Kazal-Ronchese-Kern-Angioretikulomatose",
      "Multiple hämorrhagische Sarkome",
      "Pseudosarcomatosis haemorrhagica pigmentosa",
      "Retikuloangiomatose",
      "Sarcoma idiopathicum haemorrhagicum multiplex",
      "Sarcomatosis Kaposi"
    ]
  },
  {
    "code": "C47.0",
    "name": "Bösartige Neubildung der Nerven der Fossa pterygoidea a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Augenlidnerven a.n.k.",
      "Bösartige Neubildung der Gesichtsnerven a.n.k.",
      "Bösartige Neubildung der Halsnerven a.n.k.",
      "Bösartige Neubildung der Kinnnerven a.n.k.",
      "Bösartige Neubildung der Kopfnerven a.n.k.",
      "Bösartige Neubildung der Nackennerven a.n.k.",
      "Bösartige Neubildung der Nerven der Auricula a.n.k.",
      "Bösartige Neubildung der Nerven der Fossa pterygoidea a.n.k.",
      "Bösartige Neubildung der Nerven der Kopfschwarte a.n.k.",
      "Bösartige Neubildung der Nerven der Schläfenbeinregion a.n.k.",
      "Bösartige Neubildung der Nerven der Supraklavikulargegend a.n.k.",
      "Bösartige Neubildung der Nerven des äußeren Ohres a.n.k.",
      "Bösartige Neubildung der Schläfennerven a.n.k.",
      "Bösartige Neubildung der Stirnnerven a.n.k.",
      "Bösartige Neubildung der Wangennerven a.n.k.",
      "Bösartige Neubildung der submentalen Nerven a.n.k.",
      "Bösartige Neubildung des Plexus cervicalis",
      "Bösartiger Triton-Tumor der Halsnerven",
      "Bösartiger Triton-Tumor der Kopfnerven",
      "Malignes Schwannom der Halsnerven",
      "Malignes Schwannom der Kopfnerven",
      "Neuroblastom der Halsnerven",
      "Rhabdoidtumor der Kopfnerven"
    ]
  },
  {
    "code": "C47.1",
    "name": "Bösartige Neubildung des Brachialplexus",
    "synonyms": [
      "Bösartige Neubildung der Armnerven a.n.k.",
      "Bösartige Neubildung der Brachialnerven a.n.k.",
      "Bösartige Neubildung der Daumennerven a.n.k.",
      "Bösartige Neubildung der Ellenbeugennerven a.n.k.",
      "Bösartige Neubildung der Ellenbogennerven a.n.k.",
      "Bösartige Neubildung der Fingernerven a.n.k.",
      "Bösartige Neubildung der Handgelenknerven a.n.k.",
      "Bösartige Neubildung der Handnerven a.n.k.",
      "Bösartige Neubildung der Nerven der oberen Extremität a.n.k.",
      "Bösartige Neubildung der Nerven der oberen Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Schulternerven a.n.k.",
      "Bösartige Neubildung der Unterarmnerven a.n.k.",
      "Bösartige Neubildung des Brachialplexus",
      "Bösartige Neubildung des Nervus brachialis",
      "Bösartige Neubildung des Nervus medianus",
      "Bösartige Neubildung des Nervus radialis",
      "Bösartige Neubildung des Nervus ulnaris",
      "Bösartige Neubildung des Plexus brachialis",
      "Bösartiger Triton-Tumor der Nerven der oberen Gliedmaßen",
      "Ganglioneuroblastom der Armnerven",
      "Malignes Schwannom der Nerven der oberen Gliedmaßen",
      "Neuroblastom der Nerven der oberen Gliedmaßen",
      "Rhabdoidtumor der Nerven der oberen Gliedmaßen"
    ]
  },
  {
    "code": "C47.2",
    "name": "Bösartige Neubildung der Nerven der unteren Extremität a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Beinnerven a.n.k.",
      "Bösartige Neubildung der Fersenerven a.n.k.",
      "Bösartige Neubildung der Fußnerven a.n.k.",
      "Bösartige Neubildung der Hüftnerven a.n.k.",
      "Bösartige Neubildung der Kniekehlennerven a.n.k.",
      "Bösartige Neubildung der Knienerven a.n.k.",
      "Bösartige Neubildung der Knöchelnerven a.n.k.",
      "Bösartige Neubildung der Nerven der unteren Extremität a.n.k.",
      "Bösartige Neubildung der Nerven der unteren Gliedmaßen a.n.k.",
      "Bösartige Neubildung der Oberschenkelnerven a.n.k.",
      "Bösartige Neubildung der Wadennerven a.n.k.",
      "Bösartige Neubildung der Zehennerven a.n.k.",
      "Bösartige Neubildung des Nervus femoralis",
      "Bösartige Neubildung des Nervus ischiadicus",
      "Bösartige Neubildung des Nervus obturatorius",
      "Bösartiger Triton-Tumor der Nerven der unteren Gliedmaßen",
      "Malignes Schwannom der Hüftnerven",
      "Malignes Schwannom der Nerven der unteren Gliedmaßen",
      "Neuroblastom der Nerven der unteren Gliedmaßen",
      "Rhabdoidtumor der Nerven der unteren Gliedmaßen"
    ]
  },
  {
    "code": "C47.3",
    "name": "Bösartige Neubildung der Brustnerven a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Achselhöhlennerven a.n.k.",
      "Bösartige Neubildung der Brustnerven a.n.k.",
      "Bösartige Neubildung der Brustwandnerven a.n.k.",
      "Bösartige Neubildung der Nerven der Infraklavikulargegend a.n.k.",
      "Bösartige Neubildung der Nerven der Schulterblattgegend a.n.k.",
      "Bösartige Neubildung der Thoraxnerven a.n.k.",
      "Bösartige Neubildung der Thoraxwandnerven a.n.k.",
      "Bösartige Neubildung der intrathorakalen Nerven a.n.k.",
      "Bösartige Neubildung eines Nervus intercostalis",
      "Bösartiger Triton-Tumor der Thoraxnerven",
      "Ganglioneuroblastom der Thoraxnerven",
      "Malignes Schwannom der Thoraxnerven",
      "Neuroblastom der Thoraxnerven",
      "Rhabdoidtumor der Thoraxnerven"
    ]
  },
  {
    "code": "C47.4",
    "name": "Bösartige Neubildung der Nerven des Abdomens a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Bauchwandnerven a.n.k.",
      "Bösartige Neubildung der Nabelnerven a.n.k.",
      "Bösartige Neubildung der Nerven des Abdomens a.n.k.",
      "Bösartiger Triton-Tumor der Bauchwandnerven",
      "Ganglioneuroblastom der Nerven des Abdomens",
      "Malignes Schwannom der Nerven des Abdomens",
      "Neuroblastom der Nerven des Abdomens",
      "Rhabdoidtumor der Nerven des Abdomens"
    ]
  },
  {
    "code": "C47.5",
    "name": "Bösartige Neubildung der Beckennerven a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Beckenbodennerven a.n.k.",
      "Bösartige Neubildung der Beckennerven a.n.k.",
      "Bösartige Neubildung der Gesäßnerven a.n.k.",
      "Bösartige Neubildung der Kreuzbeinnerven a.n.k.",
      "Bösartige Neubildung der Nerven der Fossa ischiorectalis a.n.k.",
      "Bösartige Neubildung der Nerven der Glutäalmuskulatur a.n.k.",
      "Bösartige Neubildung der Nerven der Leistenkanalgegend a.n.k.",
      "Bösartige Neubildung der Nerven der Steißbeingegend a.n.k.",
      "Bösartige Neubildung der Nerven des Septum rectovaginale a.n.k.",
      "Bösartige Neubildung der Nervi sacrales",
      "Bösartige Neubildung der Perineumnerven a.n.k.",
      "Bösartige Neubildung der extrarektalen Nerven a.n.k.",
      "Bösartige Neubildung der inguinalen Nerven a.n.k.",
      "Bösartige Neubildung der pararektalen Nerven a.n.k.",
      "Bösartige Neubildung der paraurethralen Nerven a.n.k.",
      "Bösartige Neubildung der paravaginalen Nerven a.n.k.",
      "Bösartige Neubildung der perirektalen Nerven a.n.k.",
      "Bösartige Neubildung der periurethralen Nerven a.n.k.",
      "Bösartige Neubildung der präsakralen Nerven a.n.k.",
      "Bösartige Neubildung der rektovesikalen Nerven a.n.k.",
      "Bösartige Neubildung der vesikorektalen Nerven a.n.k.",
      "Bösartige Neubildung des Lumbosakralplexus",
      "Bösartige Neubildung des Plexus lumbosacralis",
      "Bösartige Neubildung des Plexus sacralis",
      "Bösartiger Triton-Tumor der Beckennerven",
      "Malignes Schwannom der Beckennerven",
      "Neuroblastom der Beckennerven",
      "Rhabdoidtumor der Beckennerven"
    ]
  },
  {
    "code": "C47.6",
    "name": "Bösartige Neubildung der Rumpfnerven a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Nerven der Flankengegend a.n.k.",
      "Bösartige Neubildung der Nervi lumbales",
      "Bösartige Neubildung der Rumpfnerven a.n.k.",
      "Bösartige Neubildung der Rückennerven a.n.k.",
      "Bösartiger Triton-Tumor der Rumpfnerven",
      "Malignes Schwannom der Rumpfnerven",
      "Neuroblastom der Rumpfnerven",
      "Rhabdoidtumor der Rumpfnerven"
    ]
  },
  {
    "code": "C47.8",
    "name": "Bösartige Neubildung der abdominopelvinen Nerven a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der abdominopelvinen Nerven a.n.k.",
      "Bösartiger Triton-Tumor der peripheren Nerven, mehrere Teilbereiche überlappend",
      "Malignes Schwannom der abdominopelvinen Nerven",
      "Malignes Schwannom der peripheren Nerven, mehrere Teilbereiche überlappend",
      "Neuroblastom der peripheren Nerven, mehrere Teilbereiche überlappend",
      "Rhabdoidtumor der peripheren Nerven, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C47.9",
    "name": "Neurilemmosarkom",
    "synonyms": [
      "Bösartige Neubildung autonomer Nerven a.n.k.",
      "Bösartige Neubildung der Extremitätennerven a.n.k.",
      "Bösartige Neubildung der Gliedmaßennerven a.n.k.",
      "Bösartige Neubildung der Nervi spinales a.n.k.",
      "Bösartige Neubildung der peripheren Nerven a.n.k.",
      "Bösartige Neubildung des autonomen Nervensystems",
      "Bösartige Neubildung einer Nervenwurzel an der Wirbelsäule",
      "Bösartige Neubildung eines Ganglions",
      "Bösartige Neubildung eines Nerven",
      "Bösartige Neubildung eines Nerven an der Wirbelsäule",
      "Bösartige Neubildung parasympathischer Ganglien",
      "Bösartige Neubildung parasympathischer Nerven",
      "Bösartige Neubildung peripherer Nerven",
      "Bösartige Neubildung sympathischer Ganglien",
      "Bösartige Neubildung sympathischer Nerven",
      "Bösartige Neurofibromatose",
      "Bösartiger Triton-Tumor",
      "Bösartiges Neurilemmom",
      "Bösartiges Schwannom",
      "Ganglioneuroblastom",
      "Ganglioneuroma malignum",
      "MPNST [Maligner peripherer Nervenscheidentumor]",
      "Maligner peripherer Nervenscheidentumor",
      "Malignes Schwannom",
      "Nervenmalignom",
      "Neurilemmosarkom",
      "Neuroblastom autonomer Nerven",
      "Neuroblastom der peripheren Nerven",
      "Neurofibrosarkom",
      "Neurogenes Sarkom",
      "Neurosarkom",
      "Sympathoblastom"
    ]
  },
  {
    "code": "C48.0",
    "name": "Bösartige Neubildung des Retroperitoneums",
    "synonyms": [
      "Bösartige Neubildung des Retroperitoneums",
      "Bösartige Neubildung des retroperitonealen Bindegewebes a.n.k.",
      "Dedifferenziertes Liposarkom des Retroperitonealraums",
      "Embryonales Rhabdomyosarkom des Retroperitoneums",
      "Hochdifferenziertes Liposarkom des Retroperitoneums",
      "Karzinom des Retroperitonealraums",
      "Krebs des Retroperitonealraums",
      "Leiomyosarkom des Retroperitoneums",
      "Liposarkom des Retroperitoneums",
      "Myxoides Liposarkom des Retroperitoneums",
      "Paranephritische bösartige Neubildung",
      "Periadrenale bösartige Neubildung",
      "Perinephrische bösartige Neubildung",
      "Peripankreatische bösartige Neubildung",
      "Perirenale bösartige Neubildung",
      "Pleomorphes Liposarkom des Retroperitoneums",
      "Retroperitoneale bösartige Neubildung",
      "Retroperitoneales Germinom",
      "Retrozäkale bösartige Neubildung"
    ]
  },
  {
    "code": "C48.1",
    "name": "Karzinom des Beckenperitoneums",
    "synonyms": [
      "Bösartige Neubildung der Mesoappendix",
      "Bösartige Neubildung der rektouterinen Tasche",
      "Bösartige Neubildung des Beckenperitoneums",
      "Bösartige Neubildung des Douglas-Raums",
      "Bösartige Neubildung des Mesenteriums",
      "Bösartige Neubildung des Mesokolons",
      "Bösartige Neubildung des Omentums",
      "Bösartige Neubildung des Peritoneum parietale",
      "Bösartige Neubildung des Peritoneum viscerale",
      "Bösartige Neubildung des parietalen Peritoneums",
      "Gekrösekarzinom",
      "Karzinom des Beckenperitoneums",
      "Leiomyosarkom des Mesenteriums",
      "Mesenteriummalignom",
      "Mesokolonkarzinom",
      "Omentumkarzinom"
    ]
  },
  {
    "code": "C48.2",
    "name": "Bauchfellkarzinom",
    "synonyms": [
      "Bauchfellkarzinom",
      "Bauchfellkrebs",
      "Bösartige Neubildung der Peritonealhöhle",
      "Bösartige Neubildung des Bauchfells",
      "Bösartige Neubildung des Peritoneums",
      "Desmoplastischer Rundzelltumor des Peritoneums",
      "GIST [Gastrointestinaler Stromatumor] des Peritoneums",
      "Gastrointestinaler Stromatumor des Peritoneums",
      "Peritonealsarkomatose",
      "Peritoneumkrebs",
      "Primäres Peritonealkarzinom",
      "Primäres papilläres seröses Karzinom des Peritoneums"
    ]
  },
  {
    "code": "C49.0",
    "name": "Bösartige Neubildung des Bindegewebes des Kopfes",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile des Halses",
      "Alveoläres Rhabdomyosarkom der Weichteile des Kopfes",
      "Alveoläres Sarkom der Weichteile des Halses",
      "Alveoläres Sarkom der Weichteile des Kopfes",
      "Angiosarkom des Halses",
      "Bösartige Neubildung der Arteria carotis",
      "Bösartige Neubildung der Augenlidweichteile",
      "Bösartige Neubildung der Ohrweichteile",
      "Bösartige Neubildung der Weichteile des Gesichts",
      "Bösartige Neubildung der Weichteile des Halses",
      "Bösartige Neubildung der Weichteile des Kopfes",
      "Bösartige Neubildung der Weichteile in der Fossa pterygoidea a.n.k.",
      "Bösartige Neubildung des Augenlidbindegewebes",
      "Bösartige Neubildung des Augenlidknorpels",
      "Bösartige Neubildung des Auriculabindegewebes a.n.k.",
      "Bösartige Neubildung des Auriculaknorpels",
      "Bösartige Neubildung des Bindegewebes der Supraklavikulargegend a.n.k.",
      "Bösartige Neubildung des Bindegewebes des Gesichts",
      "Bösartige Neubildung des Bindegewebes des Halses",
      "Bösartige Neubildung des Bindegewebes des Kopfes",
      "Bösartige Neubildung des Bindegewebes in der Fossa pterygoidea a.n.k.",
      "Bösartige Neubildung des Kinnbindegewebes a.n.k.",
      "Bösartige Neubildung des Kopfschwartenbindegewebes a.n.k.",
      "Bösartige Neubildung des Ohrbindegewebes",
      "Bösartige Neubildung des Ohrknorpels",
      "Bösartige Neubildung des Schläfenbindegewebes a.n.k.",
      "Bösartige Neubildung des Stirnbindegewebes a.n.k.",
      "Bösartige Neubildung des Wangenbindegewebes a.n.k.",
      "Bösartige Neubildung des submentalen Bindegewebes a.n.k.",
      "Bösartige Neubildung in der Fossa pterygoidea a.n.k.",
      "Dedifferenziertes Liposarkom der Weichteile des Halses",
      "Dedifferenziertes Liposarkom der Weichteile des Kopfes",
      "Embryonales Rhabdomyosarkom der Weichteile des Halses",
      "Embryonales Rhabdomyosarkom der Weichteile des Kopfes",
      "Epitheloides Hämangioendotheliom der Weichteile des Halses",
      "Epitheloides Hämangioendotheliom der Weichteile des Kopfes",
      "Epitheloidsarkom der Weichteile des Kopfes",
      "Extraskelettales Ewing-Sarkom der Weichteile des Halses",
      "Extraskelettales Ewing-Sarkom der Weichteile des Kopfes",
      "Extraskelettales myxoides Chondrosarkom der Weichteile des Kopfes",
      "Fibrosarkom des Halses",
      "Fibrosarkom des Kopfes",
      "Hochdifferenziertes Liposarkom der Weichteile des Kopfes",
      "Karzinom des Bindegewebes und der Weichteile des Gesichts",
      "Karzinom des Bindegewebes und der Weichteile des Halses",
      "Karzinom des Bindegewebes und der Weichteile des Kopfes",
      "Liposarkom der Weichteile des Kopfes",
      "Myxofibrosarkom der Weichteile des Kopfes",
      "Myxoides Liposarkom der Weichteile des Kopfes",
      "Pleomorphes Liposarkom der Weichteile des Kopfes",
      "Pleomorphes Rhabdomyosarkom der Weichteile des Kopfes",
      "Rhabdoidtumor der Weichteile des Kopfes",
      "Rhabdomyosarkom der Weichteile des Halses",
      "Rhabdomyosarkom der Weichteile des Kopfes",
      "Sarkom des Bindegewebes und der Weichteile des Gesichts",
      "Sarkom des Bindegewebes und der Weichteile des Halses",
      "Sarkom des Bindegewebes und der Weichteile des Kopfes",
      "Synovialsarkom der Weichteile des Halses",
      "Synovialsarkom der Weichteile des Kopfes",
      "Weichteilsarkom des Halses",
      "Weichteilsarkom des Kopfes"
    ]
  },
  {
    "code": "C49.1",
    "name": "Sarkom der Weichteile der Schulter",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile der oberen Gliedmaßen",
      "Alveoläres Sarkom der Weichteile der oberen Gliedmaßen",
      "Angiosarkom der Schulter",
      "Angiosarkom der oberen Gliedmaßen",
      "Bösartige Neubildung der Aponeurosis palmaris",
      "Bösartige Neubildung der Palmarfaszie",
      "Bösartige Neubildung der Weichteile der Schulter",
      "Bösartige Neubildung der Weichteile der oberen Gliedmaßen",
      "Bösartige Neubildung des Armbindegewebes a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Schulter",
      "Bösartige Neubildung des Bindegewebes der oberen Extremität a.n.k.",
      "Bösartige Neubildung des Bindegewebes der oberen Gliedmaßen",
      "Bösartige Neubildung des Daumenbindegewebes a.n.k.",
      "Bösartige Neubildung des Ellenbeugenbindegewebes a.n.k.",
      "Bösartige Neubildung des Ellenbogenbindegewebes a.n.k.",
      "Bösartige Neubildung des Fingerbindegewebes a.n.k.",
      "Bösartige Neubildung des Handbindegewebes a.n.k.",
      "Bösartige Neubildung des Handgelenkbindegewebes a.n.k.",
      "Bösartige Neubildung des Unterarmbindegewebes a.n.k.",
      "Dedifferenziertes Liposarkom der Weichteile der oberen Gliedmaßen",
      "Epitheloides Hämangioendotheliom der Weichteile der oberen Gliedmaßen",
      "Epitheloidsarkom der Weichteile der oberen Gliedmaßen",
      "Extraskelettales Ewing-Sarkom der Weichteile der Schulter",
      "Extraskelettales Ewing-Sarkom der Weichteile der oberen Gliedmaßen",
      "Extraskelettales myxoides Chondrosarkom der Weichteile der oberen Gliedmaßen",
      "Fibrosarkom der Schulter",
      "Fibrosarkom der oberen Gliedmaßen",
      "Hochdifferenziertes Liposarkom der Weichteile der oberen Gliedmaßen",
      "Karzinom der Weichteile der oberen Gliedmaßen",
      "Klarzellsarkom der Weichteile der oberen Gliedmaßen",
      "Liposarkom der Weichteile der oberen Gliedmaßen",
      "Myxofibrosarkom der Weichteile der oberen Gliedmaßen",
      "Myxoides Liposarkom der Weichteile der oberen Gliedmaßen",
      "Pleomorphes Liposarkom der Weichteile der oberen Gliedmaßen",
      "Pleomorphes Rhabdomyosarkom der Weichteile der oberen Gliedmaßen",
      "Rhabdoidtumor der Weichteile der oberen Gliedmaßen",
      "Rhabdomyosarkom der Weichteile der Schulter",
      "Rhabdomyosarkom der Weichteile der oberen Gliedmaßen",
      "Sarkom der Weichteile der Schulter",
      "Sarkom der Weichteile der oberen Gliedmaßen",
      "Sarkom des Bindegewebes der Schulter",
      "Sarkom des Bindegewebes der oberen Gliedmaßen",
      "Synovialsarkom der Weichteile der oberen Gliedmaßen",
      "Undifferenziertes pleomorphes Sarkom der Schulter",
      "Undifferenziertes pleomorphes Sarkom der oberen Extremität",
      "Weichteilsarkom der Schulter",
      "Weichteilsarkom der oberen Gliedmaßen"
    ]
  },
  {
    "code": "C49.2",
    "name": "Sarkom der Weichteile der Hüfte",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile der unteren Gliedmaßen",
      "Alveoläres Sarkom der Weichteile der unteren Gliedmaßen",
      "Angiosarkom der Hüfte",
      "Angiosarkom der unteren Gliedmaßen",
      "Bösartige Neubildung der Aponeurosis plantaris",
      "Bösartige Neubildung der Plantarfaszie",
      "Bösartige Neubildung der Weichteile der Hüfte",
      "Bösartige Neubildung der Weichteile der unteren Gliedmaßen",
      "Bösartige Neubildung des Beinbindegewebes a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Hüfte",
      "Bösartige Neubildung des Bindegewebes der unteren Extremität a.n.k.",
      "Bösartige Neubildung des Bindegewebes der unteren Gliedmaßen",
      "Bösartige Neubildung des Fersenbindegewebes a.n.k.",
      "Bösartige Neubildung des Fußbindegewebes a.n.k.",
      "Bösartige Neubildung des Kniebindegewebes a.n.k.",
      "Bösartige Neubildung des Kniekehlenbindegewebes a.n.k.",
      "Bösartige Neubildung des Knöchelbindegewebes a.n.k.",
      "Bösartige Neubildung des Oberschenkelbindegewebes a.n.k.",
      "Bösartige Neubildung des Wadenbindegewebes a.n.k.",
      "Bösartige Neubildung des Zehenbindegewebes a.n.k.",
      "Dedifferenziertes Liposarkom der Weichteile der unteren Gliedmaßen",
      "Epitheloides Hämangioendotheliom der Weichteile der unteren Gliedmaßen",
      "Epitheloidsarkom der Weichteile der unteren Gliedmaßen",
      "Extraskelettales Ewing-Sarkom der Weichteile der Hüfte",
      "Extraskelettales Ewing-Sarkom der Weichteile der unteren Gliedmaßen",
      "Extraskelettales myxoides Chondrosarkom der Weichteile der unteren Gliedmaßen",
      "Fibrosarkom der Hüfte",
      "Fibrosarkom der unteren Gliedmaßen",
      "Hochdifferenziertes Liposarkom der Weichteile der unteren Gliedmaßen",
      "Hüftsarkom",
      "Karzinom der Weichteile der Hüfte",
      "Karzinom der Weichteile der unteren Gliedmaßen",
      "Klarzellsarkom der Weichteile der unteren Gliedmaßen",
      "Liposarkom der Weichteile der unteren Gliedmaßen",
      "Liposarkom des Oberschenkels",
      "Myxofibrosarkom der Weichteile der unteren Gliedmaßen",
      "Myxoides Liposarkom der Weichteile der unteren Gliedmaßen",
      "Pleomorphes Liposarkom der Weichteile der unteren Gliedmaßen",
      "Pleomorphes Rhabdomyosarkom der Weichteile der unteren Gliedmaßen",
      "Rhabdoidtumor der Weichteile der unteren Gliedmaßen",
      "Rhabdomyosarkom der Weichteile der Hüfte",
      "Rhabdomyosarkom der Weichteile der unteren Gliedmaßen",
      "Sarkom der Weichteile der Hüfte",
      "Sarkom der Weichteile der unteren Gliedmaßen",
      "Sarkom des Bindegewebes der Hüfte",
      "Sarkom des Bindegewebes der unteren Gliedmaßen",
      "Synovialsarkom der Weichteile der unteren Gliedmaßen",
      "Undifferenziertes pleomorphes Sarkom der Hüfte",
      "Undifferenziertes pleomorphes Sarkom der unteren Extremität",
      "Weichteilsarkom der Hüfte",
      "Weichteilsarkom der unteren Gliedmaßen"
    ]
  },
  {
    "code": "C49.3",
    "name": "Bösartige Neubildung des Bindegewebes des Thorax",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile des Thorax",
      "Alveoläres Sarkom der Weichteile des Thorax",
      "Angiosarkom des Thorax",
      "Askin-Tumor [Bösartige Bindegewebeneubildung der Lungen-Thorax-Region im Kindesalter]",
      "Bösartige Neubildung der Aorta thoracica",
      "Bösartige Neubildung der Axillaweichteile",
      "Bösartige Neubildung der Vena cava superior",
      "Bösartige Neubildung der Weichteile des Thorax",
      "Bösartige Neubildung des Achselhöhlenbindegewebes a.n.k.",
      "Bösartige Neubildung des Axillabindegewebes",
      "Bösartige Neubildung des Bindegewebes der Infraklavikulargegend a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Lungen-Thorax-Region im Kindesalter [Askin-Tumor]",
      "Bösartige Neubildung des Bindegewebes der Schulterblattgegend a.n.k.",
      "Bösartige Neubildung des Bindegewebes des Diaphragmas a.n.k.",
      "Bösartige Neubildung des Bindegewebes des Thorax",
      "Bösartige Neubildung des Brustbindegewebes a.n.k.",
      "Bösartige Neubildung des Brustwandbindegewebes a.n.k.",
      "Bösartige Neubildung des Diaphragmas",
      "Bösartige Neubildung des Ductus thoracicus a.n.k.",
      "Bösartige Neubildung des Zwerchfellbindegewebes a.n.k.",
      "Bösartige Neubildung des Zwerchfells",
      "Bösartige Neubildung des intrathorakalen Bindegewebes a.n.k.",
      "Bösartige Neubildung großer Gefäße des Thorax",
      "Dedifferenziertes Liposarkom der Weichteile des Thorax",
      "Desmoplastischer Rundzelltumor der Weichteile des Thorax",
      "Epitheloidsarkom der Weichteile des Thorax",
      "Extraskelettales Ewing-Sarkom der Weichteile des Thorax",
      "Extraskelettales myxoides Chondrosarkom der Weichteile des Thorax",
      "Fibrosarkom des Thorax",
      "Hochdifferenziertes Liposarkom der Weichteile des Thorax",
      "Karzinom der Weichteile des Thorax",
      "Liposarkom der Weichteile des Thorax",
      "Myxofibrosarkom der Weichteile des Thorax",
      "Myxoides Liposarkom der Weichteile des Thorax",
      "Pleomorphes Liposarkom der Weichteile des Thorax",
      "Pleomorphes Rhabdomyosarkom der Weichteile des Thorax",
      "Rhabdoidtumor der Weichteile des Thorax",
      "Rhabdomyosarkom der Weichteile des Thorax",
      "Sarkom der Weichteile des Thorax",
      "Sarkom des Bindegewebes des Thorax",
      "Sarkom des Thorax bei SMARCA4-Mangel",
      "Synovialsarkom der Weichteile des Thorax",
      "Undifferenziertes pleomorphes Sarkom des Thorax",
      "Weichteilsarkom des Thorax",
      "Zwerchfellkarzinom"
    ]
  },
  {
    "code": "C49.4",
    "name": "Sarkom des Bindegewebes des Abdomens",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile des Abdomens",
      "Alveoläres Sarkom der Weichteile des Abdomens",
      "Angiosarkom des Abdomens",
      "Bauchwandkarzinom",
      "Bauchwandsarkom",
      "Bösartige Neubildung der Bauchwand",
      "Bösartige Neubildung der Vena cava inferior",
      "Bösartige Neubildung der Weichteile des Abdomens",
      "Bösartige Neubildung des Bauchwandbindegewebes",
      "Bösartige Neubildung des Bindegewebes des Abdomens",
      "Bösartige Neubildung des Bindegewebes des Hypochondriums",
      "Bösartige Neubildung des Bindegewebes des Iliopsoasmuskels a.n.k.",
      "Bösartige Neubildung des Bindegewebes des Psoasmuskels a.n.k.",
      "Bösartige Neubildung des Nabelbindegewebes",
      "Dedifferenziertes Liposarkom der Weichteile des Abdomens",
      "Desmoplastischer Rundzelltumor der Weichteile des Abdomens",
      "Epitheloidsarkom der Weichteile des Abdomens",
      "Extraskelettales Ewing-Sarkom der Weichteile des Abdomens",
      "Extraskelettales myxoides Chondrosarkom der Weichteile des Abdomens",
      "Fibrosarkom des Abdomens",
      "Hochdifferenziertes Liposarkom der Weichteile des Abdomens",
      "Hypochondriumkarzinom",
      "Hypochondriumsarkom",
      "Leiomyosarkom der Vena cava inferior",
      "Liposarkom der Weichteile des Abdomens",
      "Myxofibrosarkom der Weichteile des Abdomens",
      "Myxoides Liposarkom der Weichteile des Abdomens",
      "Pleomorphes Liposarkom der Weichteile des Abdomens",
      "Pleomorphes Rhabdomyosarkom der Weichteile des Abdomens",
      "Rhabdoidtumor der Weichteile des Abdomens",
      "Rhabdomyosarkom der Weichteile des Abdomens",
      "Sarkom der Weichteile des Abdomens",
      "Sarkom des Bindegewebes des Abdomens",
      "Synovialsarkom der Weichteile des Abdomens",
      "Undifferenziertes pleomorphes Sarkom des Abdomens",
      "Weichteilsarkom des Abdomens"
    ]
  },
  {
    "code": "C49.5",
    "name": "Sarkom des Bindegewebes des Beckens",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile des Beckens",
      "Alveoläres Sarkom der Weichteile des Beckens",
      "Angiosarkom des Beckens",
      "Bösartige Neubildung der Dammweichteile",
      "Bösartige Neubildung der Gesäßweichteile",
      "Bösartige Neubildung der Weichteile der Leistengegend",
      "Bösartige Neubildung der Weichteile des Beckens",
      "Bösartige Neubildung des Beckenbodenbindegewebes a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Fossa ischiorectalis a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Glutäalmuskulatur a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Kreuzbeingegend und Steißbeingegend a.n.k.",
      "Bösartige Neubildung des Bindegewebes der Leistengegend",
      "Bösartige Neubildung des Bindegewebes des Beckens",
      "Bösartige Neubildung des Bindegewebes des Gesäßes",
      "Bösartige Neubildung des Bindegewebes des Perineums a.n.k.",
      "Bösartige Neubildung des Bindegewebes des Septum rectovaginale a.n.k.",
      "Bösartige Neubildung des Dammbindegewebes",
      "Bösartige Neubildung des Glomus coccygeum",
      "Bösartige Neubildung des extrarektalen Bindegewebes a.n.k.",
      "Bösartige Neubildung des inguinalen Bindegewebes a.n.k.",
      "Bösartige Neubildung des pararektalen Bindegewebes a.n.k.",
      "Bösartige Neubildung des paraurethralen Bindegewebes a.n.k.",
      "Bösartige Neubildung des paravaginalen Bindegewebes a.n.k.",
      "Bösartige Neubildung des perirektalen Bindegewebes a.n.k.",
      "Bösartige Neubildung des periurethralen Bindegewebes a.n.k.",
      "Bösartige Neubildung des präsakralen Bindegewebes a.n.k.",
      "Bösartige Neubildung des rektovesikalen Bindegewebes a.n.k.",
      "Bösartige Neubildung des vesikorektalen Bindegewebes a.n.k.",
      "Bösartiger Weichteiltumor des Beckens",
      "Dedifferenziertes Liposarkom der Weichteile des Beckens",
      "Desmoplastischer Rundzelltumor der Weichteile des Beckens",
      "Epitheloidsarkom der Weichteile des Beckens",
      "Extraskelettales Ewing-Sarkom der Weichteile des Beckens",
      "Extraskelettales myxoides Chondrosarkom der Weichteile des Beckens",
      "Fibrosarkom des Beckens",
      "Hochdifferenziertes Liposarkom der Weichteile des Beckens",
      "Karzinom der Weichteile des Beckens",
      "Liposarkom der Weichteile des Beckens",
      "Myxofibrosarkom der Weichteile des Beckens",
      "Myxoides Liposarkom der Weichteile des Beckens",
      "Pleomorphes Liposarkom der Weichteile des Beckens",
      "Pleomorphes Rhabdomyosarkom der Weichteile des Beckens",
      "Rhabdoidtumor der Weichteile des Beckens",
      "Rhabdomyosarkom der Weichteile des Beckens",
      "Sarkom der Weichteile des Beckens",
      "Sarkom des Bindegewebes des Beckens",
      "Synovialsarkom der Weichteile des Beckens",
      "Weichteilsarkom des Beckens"
    ]
  },
  {
    "code": "C49.6",
    "name": "Bösartige Neubildung des Bindegewebes des Rumpfes",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile des Rumpfes",
      "Alveoläres Sarkom der Weichteile des Rumpfes",
      "Angiosarkom des Rumpfes",
      "Bösartige Neubildung der Weichteile des Rumpfes",
      "Bösartige Neubildung der Weichteile des Rückens",
      "Bösartige Neubildung des Bindegewebes der Flankengegend a.n.k.",
      "Bösartige Neubildung des Bindegewebes des Rumpfes",
      "Bösartige Neubildung des Bindegewebes des Rückens",
      "Dedifferenziertes Liposarkom der Weichteile des Rumpfes",
      "Epitheloidsarkom der Weichteile des Rumpfes",
      "Extraskelettales Ewing-Sarkom der Weichteile des Rumpfes",
      "Extraskelettales myxoides Chondrosarkom der Weichteile des Rumpfes",
      "Fibrosarkom des Rumpfes",
      "Hochdifferenziertes Liposarkom der Weichteile des Rumpfes",
      "Karzinom der Weichteile des Rumpfes",
      "Karzinom der Weichteile des Rückens",
      "Liposarkom der Weichteile des Rumpfes",
      "Myxofibrosarkom der Weichteile des Rumpfes",
      "Myxoides Liposarkom der Weichteile des Rumpfes",
      "Pleomorphes Liposarkom der Weichteile des Rumpfes",
      "Pleomorphes Rhabdomyosarkom der Weichteile des Rumpfes",
      "Rhabdoidtumor der Weichteile des Rumpfes",
      "Rhabdomyosarkom der Weichteile des Rumpfes",
      "Sarkom der Weichteile des Rumpfes",
      "Sarkom der Weichteile des Rückens",
      "Sarkom des Bindegewebes des Rumpfes",
      "Sarkom des Bindegewebes des Rückens",
      "Synovialsarkom der Weichteile des Rumpfes",
      "Weichteilsarkom des Rumpfes"
    ]
  },
  {
    "code": "C49.8",
    "name": "Bösartige Neubildung des abdominopelvinen Bindegewebes",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Alveoläres Weichteilsarkom, mehrere Teilbereiche überlappend",
      "Angiosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung des abdominopelvinen Bindegewebes",
      "Dedifferenziertes Liposarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Epitheloidsarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Extraskelettales Ewing-Sarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Extraskelettales myxoides Chondrosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Fibrosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Hochdifferenziertes Liposarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Liposarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Myxofibrosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Myxoides Liposarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Pleomorphes Liposarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Pleomorphes Rhabdomyosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Rhabdoidtumor der Weichteile, mehrere Teilbereiche überlappend",
      "Rhabdomyosarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Synovialsarkom der Weichteile, mehrere Teilbereiche überlappend",
      "Weichteilsarkom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C49.9",
    "name": "Angioleiomyosarkom - s.a. Tabelle der Neubildungen",
    "synonyms": [
      "Alveoläres Rhabdomyosarkom",
      "Alveoläres Weichteilsarkom",
      "Angeborenes Fibrosarkom",
      "Angioblastosarkom - s.a. Tabelle der Neubildungen",
      "Angioleiomyosarkom - s.a. Tabelle der Neubildungen",
      "Angioma sarcomatodes",
      "Angiomyosarkom - s.a. Tabelle der Neubildungen",
      "Angioretikulosarkom - s.a. Tabelle der Neubildungen",
      "Angiosarkom - s.a. Tabelle der Neubildungen",
      "Biphasisches Synovialsarkom",
      "Botryoidsarkom",
      "Bösartige Neubildung der Faszie",
      "Bösartige Neubildung der Ligamente",
      "Bösartige Neubildung der Muskeln",
      "Bösartige Neubildung der Sehnen",
      "Bösartige Neubildung der Sehnenscheiden",
      "Bösartige Neubildung der Weichteile",
      "Bösartige Neubildung des Bindegewebes",
      "Bösartige Neubildung des Bindegewebes der Gliedmaßen a.n.k.",
      "Bösartige Neubildung des Bindegewebes einer Extremität a.n.k.",
      "Bösartige Neubildung des Fettgewebes",
      "Bösartige Neubildung des Knorpels",
      "Bösartige Neubildung einer Bursa",
      "Bösartige Neubildung einer Lymphbahn a.n.k.",
      "Bösartige Neubildung einer Synovialmembran",
      "Bösartige Neubildung eines Blutgefäßes",
      "Bösartige Neubildung eines Lymphgefäßes",
      "Bösartiger Weichteiltumor",
      "Bösartiges Angiom",
      "Bösartiges Fibroxanthom",
      "Bösartiges Gangliozytom",
      "Bösartiges Hämangioendotheliom",
      "Bösartiges Hämangioperizytom",
      "Bösartiges Lymphangioendotheliom",
      "Bösartiges Lymphangiom",
      "Bösartiges Mesenchymom",
      "Bösartiges Myom",
      "Bösartiges Synovialom - s.a. Neubildung, Bindegewebe, bösartig",
      "Bösartiges granularzelliges Myoblastom",
      "Dedifferenziertes Liposarkom",
      "Desmoplastischer Rundzelltumor",
      "Differenziertes Liposarkom",
      "Embryonales Liposarkom",
      "Embryonales Rhabdomyosarkom",
      "Embryonales Sarkom",
      "Endotheliom - s.a. Tabelle der Neubildungen",
      "Entdifferenziertes Liposarkom",
      "Epitheloides Hämangioendotheliom",
      "Epitheloides Leiomyosarkom",
      "Epitheloidsarkom",
      "Epitheloidzelliges Sarkom",
      "Epitheloidzelliges Synovialsarkom",
      "Extraossäres Ewing-Sarkom",
      "Extraskelettales Ewing-Sarkom",
      "Extraskelettales myxoides Chondrosarkom",
      "Fasziales Fibrosarkom",
      "Fibroliposarkom - s.a. Tabelle der Neubildungen",
      "Fibroma sarcomatosum",
      "Fibromyxosarkom - s.a. Tabelle der Neubildungen",
      "Fibroplastisches Sarkom",
      "Fibrosarkom - s.a. Tabelle der Neubildungen",
      "Fibroxanthosarkom - s.a. Tabelle der Neubildungen",
      "Glomangiomatöses Sarkom",
      "Glomusangiosarkom - s.a. Tabelle der Neubildungen",
      "Gut differenziertes Liposarkom",
      "Haemangiopericytoma malignum",
      "Hochdifferenziertes Liposarkom",
      "Hämangioendotheliales Sarkom",
      "Hämangioendotheliosarkom - s.a. Tabelle der Neubildungen",
      "Hämangiosarkom - s.a. Tabelle der Neubildungen",
      "Infantiles Fibrosarkom",
      "Kaposiforme Lymphangiomatose",
      "Kaposiformes Hämangioendotheliom",
      "Klarzelliges Sarkom",
      "Kleinzelliges Sarkom",
      "Konnatales Fibrosarkom",
      "Leiomyoblastisches Sarkom",
      "Leiomyoma sarcomatodes",
      "Leiomyosarkom - s.a. Tabelle der Neubildungen",
      "Lipoblastisches Sarkom",
      "Lipoma sarcomatodes",
      "Lipomyxosarkom - s.a. Tabelle der Neubildungen",
      "Lipoplastisches Sarkom",
      "Liposarkom - s.a. Tabelle der Neubildungen",
      "Lymphangioendotheliales Sarkom",
      "Lymphangiosarkom - s.a. Tabelle der Neubildungen",
      "Lymphgefäßkarzinom",
      "Maligner Weichteiltumor",
      "Malignes Histiozytom",
      "Malignes Hämangioendotheliom",
      "Malignes Hämangiom",
      "Malignes Myoperizytom",
      "Malignes Weichteilmelanom",
      "Mesenchymales Chondrosarkom",
      "Mesenchymales Sarkom",
      "Mesenchymoma malignum",
      "Mischform eines Liposarkoms",
      "Myoma sarcomatosum",
      "Myosarkom - s.a. Tabelle der Neubildungen",
      "Myxofibrosarkom - s.a. Tabelle der Neubildungen",
      "Myxoides Leiomyosarkom",
      "Myxoides Liposarkom",
      "Myxoides malignes fibröses Histiozytom",
      "Myxoliposarkom - s.a. Tabelle der Neubildungen",
      "Myxoma sarcomatosum",
      "Myxomatöses Fibrosarkom",
      "Myxoplastisches Sarkom",
      "Myxosarkom - s.a. Tabelle der Neubildungen",
      "Peripherer primitiver neuroektodermaler Tumor",
      "Pleomorphes Liposarkom",
      "Pleomorphes Rhabdomyosarkom",
      "Pleomorphes Sarkom",
      "Polymorphzelliges Liposarkom",
      "Polymorphzelliges Rhabdomyosarkom",
      "Polymorphzelliges Sarkom",
      "Primär intralymphatisches Angioendotheliom",
      "Reifzelliges Liposarkom",
      "Rhabdomyoblastisches Sarkom",
      "Rhabdomyosarkom - s.a. Tabelle der Neubildungen",
      "Rhabdomyosarkom vom Mischtyp",
      "Rhabdosarkom - s.a. Tabelle der Neubildungen",
      "Riesenzelliges Sarkom (ausgenommen Knochen)",
      "Run"
    ]
  },
  {
    "code": "C50.0",
    "name": "Morbus Paget der Mamille",
    "synonyms": [
      "Bösartige Neubildung der Areola",
      "Bösartige Neubildung der Brustwarze und des Warzenhofes",
      "Bösartige Neubildung der weiblichen Brustwarze",
      "Bösartige Neubildung des weiblichen Warzenhofes",
      "Hereditäres Karzinom der Brustwarze",
      "Hereditäres Karzinom des Warzenhofes",
      "Karzinom der weiblichen Brustwarze",
      "Karzinom des weiblichen Warzenhofes",
      "Karzinom vom Speicheldrüsentyp der Brustwarze",
      "Krebs der weiblichen Brustwarze",
      "Krebs des weiblichen Warzenhofes",
      "Mamillenkarzinom",
      "Morbus Paget der Brustwarze",
      "Morbus Paget der Mamille",
      "Paget-Karzinom",
      "Paget-Karzinom der Brustdrüse",
      "Paget-Karzinom der Brustwarze",
      "Paget-Karzinom der Mamma",
      "Paget-Krankheit der Brust",
      "Paget-Krankheit der Brustdrüse",
      "Paget-Krankheit der Brustwarze"
    ]
  },
  {
    "code": "C50.1",
    "name": "Bösartige Neubildung des Zentrums der Mamma",
    "synonyms": [
      "Bösartige Neubildung des Zentrums der Mamma",
      "Bösartige Neubildung des zentralen Drüsenkörpers der Brustdrüse",
      "Hereditäres Karzinom des zentralen Drüsenkörpers der Brustdrüse",
      "Karzinom vom Speicheldrüsentyp des zentralen Drüsenkörpers der Brustdrüse",
      "Krebs der Mamma im Zentrum",
      "Mammakarzinom des Zentrums",
      "Metaplastisches Karzinom des zentralen Drüsenkörpers der Brustdrüse"
    ]
  },
  {
    "code": "C50.2",
    "name": "Bösartige Neubildung des oberen inneren Quadranten der Mamma",
    "synonyms": [
      "Angiosarkom des oberen inneren Quadranten der Brustdrüse",
      "Bösartige Neubildung des oberen inneren Quadranten der Brustdrüse",
      "Bösartige Neubildung des oberen inneren Quadranten der Mamma",
      "Hereditäres Karzinom des oberen inneren Quadranten der Brustdrüse",
      "Karzinom vom Speicheldrüsentyp des oberen inneren Quadranten der Brustdrüse",
      "Mammakarzinom des oberen inneren Quadranten",
      "Metaplastisches Karzinom des oberen inneren Quadranten der Brustdrüse"
    ]
  },
  {
    "code": "C50.3",
    "name": "Bösartige Neubildung des unteren inneren Quadranten der Mamma",
    "synonyms": [
      "Angiosarkom des unteren inneren Quadranten der Brustdrüse",
      "Bösartige Neubildung des unteren inneren Quadranten der Brustdrüse",
      "Bösartige Neubildung des unteren inneren Quadranten der Mamma",
      "Hereditäres Karzinom des unteren inneren Quadranten der Brustdrüse",
      "Karzinom vom Speicheldrüsentyp des unteren inneren Quadranten der Brustdrüse",
      "Mammakarzinom des unteren inneren Quadranten",
      "Metaplastisches Karzinom des unteren inneren Quadranten der Brustdrüse"
    ]
  },
  {
    "code": "C50.4",
    "name": "Bösartige Neubildung des oberen äußeren Quadranten der Mamma",
    "synonyms": [
      "Angiosarkom des oberen äußeren Quadranten der Brustdrüse",
      "Bösartige Neubildung des oberen äußeren Quadranten der Brustdrüse",
      "Bösartige Neubildung des oberen äußeren Quadranten der Mamma",
      "Hereditäres Karzinom des oberen äußeren Quadranten der Brustdrüse",
      "Karzinom vom Speicheldrüsentyp des oberen äußeren Quadranten der Brustdrüse",
      "Mammakarzinom des oberen äußeren Quadranten",
      "Metaplastisches Karzinom des oberen äußeren Quadranten der Brustdrüse"
    ]
  },
  {
    "code": "C50.5",
    "name": "Bösartige Neubildung des unteren äußeren Quadranten der Mamma",
    "synonyms": [
      "Angiosarkom des unteren äußeren Quadranten der Brustdrüse",
      "Bösartige Neubildung des unteren äußeren Quadranten der Brustdrüse",
      "Bösartige Neubildung des unteren äußeren Quadranten der Mamma",
      "Hereditäres Karzinom des unteren äußeren Quadranten der Brustdrüse",
      "Karzinom vom Speicheldrüsentyp des unteren äußeren Quadranten der Brustdrüse",
      "Mammakarzinom des unteren äußeren Quadranten",
      "Metaplastisches Karzinom des unteren äußeren Quadranten der Brustdrüse"
    ]
  },
  {
    "code": "C50.6",
    "name": "Bösartige Neubildung des Recessus axillaris der Mamma",
    "synonyms": [
      "Angiosarkom des Recessus axillaris der Brustdrüse",
      "Bösartige Neubildung des Recessus axillaris der Brustdrüse",
      "Bösartige Neubildung des Recessus axillaris der Mamma",
      "Bösartige Neubildung des axillären Ausläufers der Brustdrüse",
      "Hereditäres Karzinom des Recessus axillaris der Brustdrüse",
      "Karzinom vom Speicheldrüsentyp des Recessus axillaris der Brustdrüse",
      "Mammakarzinom des Recessus axillaris",
      "Metaplastisches Karzinom des Recessus axillaris der Brustdrüse"
    ]
  },
  {
    "code": "C50.8",
    "name": "Cancer en cuirasse",
    "synonyms": [
      "Angiosarkom der Brustdrüse, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung der Brustdrüse, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung der Medioklavikularlinie der Brustdrüse",
      "Bösartige Neubildung der inneren 2 Quadranten der Brustdrüse",
      "Bösartige Neubildung der oberen Brustdrüse",
      "Bösartige Neubildung der unteren Brustdrüse",
      "Bösartige Neubildung der äußeren 2 Quadranten der Brustdrüse",
      "Bösartige Neubildung einer ektopischen Brustdrüse",
      "Cancer en cuirasse",
      "Hereditäres Karzinom der Brustdrüse, mehrere Teilbereiche überlappend",
      "Mammakarzinom vom Speicheldrüsentyp, mehrere Teilbereiche überlappend",
      "Metaplastisches Karzinom der inneren 2 Quadranten der Brustdrüse",
      "Metaplastisches Karzinom der äußeren 2 Quadranten der Brustdrüse"
    ]
  },
  {
    "code": "C50.9",
    "name": "Brustdrüsenkrebs beim Mann",
    "synonyms": [
      "Adenokarzinom vom duktalen Typ",
      "Angiosarkom der Mamma",
      "Brustdrüsenkarzinom",
      "Brustdrüsenkrebs",
      "Brustdrüsenkrebs beim Mann",
      "Brustdrüsenmalignom",
      "Brustkrebs",
      "Brustkrebs beim Mann",
      "Bösartige Neubildung der Brustdrüse",
      "Bösartige Neubildung der Mamma",
      "Bösartige Neubildung der männlichen Brustdrüse",
      "Bösartige Neubildung der weiblichen Brustdrüse",
      "Bösartige Neubildung des Brustdrüsenbindegewebes",
      "Bösartige Neubildung des Mammabindegewebes",
      "Cystosarcoma phylloides malignum",
      "Duktales Adenokarzinom",
      "Duktales invasives Mammakarzinom",
      "Entzündetes Adenokarzinom",
      "Glykogenreiches Karzinom",
      "Hereditärer Brustkrebs",
      "Hereditäres Karzinom der Brustdrüse",
      "Hereditäres Mammakarzinom",
      "Hormonrezeptorpositives invasives Mammakarzinom",
      "Inflammatorisches Karzinom",
      "Invasives duktales Adenokarzinom",
      "Invasives duktales Karzinom",
      "Invasives lobuläres Karzinom",
      "Juveniles Mammakarzinom",
      "Karzinom der männlichen Brust",
      "Karzinom der weiblichen Brust",
      "Komedokarzinom",
      "Lipidreiches Karzinom",
      "Lobuläres Adenokarzinom",
      "Lobuläres und invasiv duktales Carcinoma in situ der Brustdrüse",
      "Lobuläres und invasiv duktales Carcinoma in situ der Mamma",
      "Mammaadenokarzinom",
      "Mammakarzinom",
      "Mammakarzinom beim Mann",
      "Mammakarzinom vom Speicheldrüsentyp",
      "Mammakrebs",
      "Mammakrebs beim Mann",
      "Mammamalignom",
      "Metaplastisches Karzinom der Brust",
      "Metastasierende Mammaneoplasie",
      "Metastasierendes Mammakarzinom",
      "Milchgangskarzinom",
      "Plateauphänomen",
      "Prolaktinabhängiges Mammakarzinom",
      "Sekretorisches Mammakarzinom"
    ]
  },
  {
    "code": "C51.0",
    "name": "Karzinom der großen Schamlippen",
    "synonyms": [
      "Adenokarzinom der Labia majora pudendi",
      "Basalzellkarzinom der Labia majora pudendi",
      "Bösartige Neubildung der Bartholin-Drüse",
      "Bösartige Neubildung der Glandula vestibularis major",
      "Bösartige Neubildung der Labia majora pudendi",
      "Bösartige Neubildung der vulvovaginalen Drüsen",
      "Karzinom der Bartholin-Drüse",
      "Karzinom der Labia majora pudendi",
      "Karzinom der großen Schamlippen",
      "Krebs der Labia majora pudendi",
      "Malignes Melanom der Schleimhaut der Labia majora pudendi",
      "Melanom der Labia majora pudendi",
      "Nichtmelanomartige bösartige Neubildung der Haut der Labia majora pudendi",
      "Nichtmelanomartige bösartige Neubildung der Labia majora pudendi",
      "Plattenepithelkarzinom der Labia majora pudendi"
    ]
  },
  {
    "code": "C51.1",
    "name": "Bösartige Neubildung der Labia minora pudendi",
    "synonyms": [
      "Adenokarzinom der Labia minora pudendi",
      "Basalzellkarzinom der Labia minora pudendi",
      "Bösartige Neubildung der Labia minora pudendi",
      "Karzinom der Labia minora pudendi",
      "Karzinom der kleinen Schamlippen",
      "Krebs der Labia minora pudendi",
      "Malignes Melanom der Schleimhaut der Labia minora pudendi",
      "Melanom der Labia minora pudendi",
      "Nichtmelanomartige bösartige Neubildung der Haut der Labia minora pudendi",
      "Nichtmelanomartige bösartige Neubildung der Labia minora pudendi",
      "Plattenepithelkarzinom der Labia minora pudendi"
    ]
  },
  {
    "code": "C51.2",
    "name": "Bösartige Neubildung der Klitoris",
    "synonyms": [
      "Adenokarzinom der Klitoris",
      "Basalzellkarzinom der Klitoris",
      "Bösartige Neubildung der Klitoris",
      "Karzinom der Klitoris",
      "Krebs der Klitoris",
      "Malignes Melanom der Klitoris",
      "Malignes Melanom der Schleimhaut der Klitoris",
      "Nichtmelanomartige bösartige Neubildung der Klitorishaut",
      "Plattenepithelkarzinom der Klitoris"
    ]
  },
  {
    "code": "C51.8",
    "name": "Vulvakarzinom, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Adenokarzinom der Vulva, mehrere Teilbereiche überlappend",
      "Basalzellkarzinom der Vulva, mehrere Teilbereiche überlappend",
      "Plattenepithelkarzinom der Vulva, mehrere Teilbereiche überlappend",
      "Vulvakarzinom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C51.9",
    "name": "Labienkarzinom",
    "synonyms": [
      "Adenokarzinom der Vulva",
      "Basalzellkarzinom der Vulva",
      "Bösartige Neubildung der Labienhaut",
      "Bösartige Neubildung der Vulva",
      "Bösartige Neubildung der Vulvahaut",
      "Bösartige Neubildung der äußeren weiblichen Genitalorgane",
      "Bösartige Neubildung des Frenulum labiorum pudendi",
      "Bösartige Neubildung des Mons pubis",
      "Bösartige Neubildung des Mons veneris",
      "Bösartige Neubildung des Pudendum femininum",
      "Labienkarzinom",
      "Malignes Melanom der Labien",
      "Malignes Melanom der weiblichen Schamteile",
      "Melanom der äußeren weiblichen Geschlechtsorgane",
      "Nichtmelanomartige bösartige Neubildung der Haut der Labien a.n.k.",
      "Nichtmelanomartige bösartige Neubildung der Haut der Pudenda feminae",
      "Nichtmelanomartige bösartige Neubildung der Haut der weiblichen Geschlechtsorgane",
      "Nichtmelanomartige bösartige Neubildung der Labien",
      "Nichtmelanomartige bösartige Neubildung der Vulvahaut",
      "Plattenepithelkarzinom der Vulva",
      "Vulvakarzinom",
      "Vulvakrebs",
      "Vulvamelanom"
    ]
  },
  {
    "code": "C52",
    "name": "Bösartige Neubildung der Vagina",
    "synonyms": [
      "Bösartige Neubildung der Scheide",
      "Bösartige Neubildung der Vagina",
      "Bösartige Neubildung des Fornix vaginae",
      "Bösartige Neubildung des Gartner-Ganges",
      "Bösartige Neubildung des Hymens",
      "Maligner Keimzelltumor der Vagina",
      "Scheidenkarzinom",
      "Scheidenkrebs",
      "Scheidensarkom",
      "Vaginakrebs",
      "Vaginaleiomyosarkom",
      "Vaginalkarzinom",
      "Vaginalsarkom"
    ]
  },
  {
    "code": "C53.0",
    "name": "Bösartige Neubildung der Endozervix",
    "synonyms": [
      "Adenoid-zystisches Karzinom der Endozervix",
      "Adenoides Basalzellkarzinom der Endozervix",
      "Adenokarzinom der Endozervix",
      "Adenosarkom der Endozervix",
      "Bösartige Neubildung der Endozervix",
      "Bösartige Neubildung der Ovula Nabothi",
      "Bösartige Neubildung des Zervikalkanals",
      "Bösartige Neubildung des inneren Muttermundes",
      "Endozervikale bösartige Neubildung",
      "Endozervixkarzinom",
      "Glaszellkarzinom der Endozervix",
      "Karzinosarkom der Endozervix",
      "Leiomyosarkom der Endozervix",
      "Maligner Keimzelltumor der Endozervix",
      "Plattenepithelkarzinom der Endozervix",
      "Primitiver neuroektodermaler Tumor der Endozervix",
      "Rhabdomyosarkom der Endozervix",
      "Sarkom der Endozervix",
      "Schlecht differenziertes neuroendokrines Karzinom der Endozervix"
    ]
  },
  {
    "code": "C53.1",
    "name": "Ektozervixkrebs",
    "synonyms": [
      "Adenoid-zystisches Karzinom der Ektozervix",
      "Adenoides Basalzellkarzinom der Ektozervix",
      "Adenokarzinom der Ektozervix",
      "Adenokarzinom der Portio vaginalis",
      "Adenosarkom der Ektozervix",
      "Bösartige Neubildung der Ektozervix",
      "Bösartige Neubildung des äußeren Muttermundes",
      "Ektozervixkarzinom",
      "Ektozervixkrebs",
      "Glaszellkarzinom der Ektozervix",
      "Karzinosarkom der Ektozervix",
      "Leiomyosarkom der Ektozervix",
      "Maligner Keimzelltumor der Ektozervix",
      "Plattenepithelkarzinom der Ektozervix",
      "Primitiver neuroektodermaler Tumor der Ektozervix",
      "Rhabdomyosarkom der Ektozervix",
      "Sarkom der Ektozervix",
      "Schlecht differenziertes neuroendokrines Karzinom der Ektozervix"
    ]
  },
  {
    "code": "C53.8",
    "name": "Zervixstumpfkarzinom",
    "synonyms": [
      "Adenoid-zystisches Karzinom des Überganges zwischen Zervix und Vagina",
      "Adenoides Basalzellkarzinom des Überganges zwischen Zervix und Vagina",
      "Adenokarzinom der Cervix uteri, mehrere Teilbereiche überlappend",
      "Adenosarkom des Überganges zwischen Zervix und Vagina",
      "Bösartige Neubildung der Cervix uteri, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung des Stumpfes der Cervix uteri",
      "Bösartige Neubildung des Zervixstumpfes",
      "Bösartige Neubildung des Zervixüberganges zur Vagina",
      "Bösartige Neubildung des Überganges der Cervix uteri zur Vagina",
      "Bösartige Neubildung des Überganges zwischen Zervix und Vagina",
      "Glaszellkarzinom des Überganges zwischen Zervix und Vagina",
      "Karzinom des Stumpfes der Cervix uteri",
      "Karzinosarkom der Cervix uteri, mehrere Teilbereiche überlappend",
      "Leiomyosarkom des Überganges zwischen Zervix und Vagina",
      "Maligner Keimzelltumor des Überganges zwischen Zervix und Vagina",
      "Plattenepithelkarzinom der Cervix uteri, mehrere Teilbereiche überlappend",
      "Primitiver neuroektodermaler Tumor der Cervix uteri, mehrere Teilbereiche überlappend",
      "Rhabdomyosarkom des Überganges zwischen Zervix und Vagina",
      "Sarkom der Cervix uteri, mehrere Teilbereiche überlappend",
      "Schlecht differenziertes neuroendokrines Karzinom des Zervixüberganges zur Vagina",
      "Zervixstumpfkarzinom"
    ]
  },
  {
    "code": "C53.9",
    "name": "Kollumkarzinom (Collum uteri)",
    "synonyms": [
      "Adenoid-zystisches Karzinom der Cervix uteri",
      "Adenoides Basalzellkarzinom der Cervix uteri",
      "Adenokarzinom der Cervix uteri",
      "Adenokarzinom des Collum uteri",
      "Adenosarkom der Cervix uteri",
      "Bösartige Neubildung der Cervix uteri",
      "Bösartige Neubildung der Zervix",
      "Gebärmutterhalskrebs",
      "Gebärmutterhalsmalignom",
      "Glaszellkarzinom der Cervix uteri",
      "Karzinom der Cervix uteri",
      "Karzinom des Collum uteri",
      "Karzinosarkom der Cervix uteri",
      "Kollumkarzinom (Collum uteri)",
      "Kollumkarzinom des Uterus",
      "Leiomyosarkom der Cervix uteri",
      "Maligner Keimzelltumor der Cervix uteri",
      "Maligner Müller-Mischtumor der Cervix uteri",
      "Maligner peripherer neuroektodermaler Tumor der Cervix uteri",
      "Malignom der Cervix uteri",
      "Metastasierendes Kollumkarzinom (Collum uteri)",
      "Muttermundkarzinom",
      "Muttermundmalignom",
      "Papilläres Karzinom der Cervix uteri",
      "Plattenepithelkarzinom der Zervix",
      "Portio-uteri-Malignom",
      "Portiokarzinom",
      "Primitiver neuroektodermaler Tumor der Cervix uteri",
      "Rhabdomyosarkom der Cervix uteri",
      "Sarkom der Cervix uteri",
      "Schlecht differenziertes neuroendokrines Karzinom der Cervix uteri",
      "Zervixkarzinom"
    ]
  },
  {
    "code": "C54.0",
    "name": "Bösartige Neubildung des Isthmus uteri",
    "synonyms": [
      "Bösartige Neubildung des Isthmus des Uterus",
      "Bösartige Neubildung des Isthmus uteri",
      "Bösartige Neubildung des unteren Uterinsegments",
      "Bösartige Stromatose des Isthmus uteri",
      "Endometriales Sarkom des Isthmus uteri",
      "Karzinofibrom des Isthmus uteri",
      "Karzinom des Isthmus uteri",
      "Krebs des Isthmus uteri",
      "Leiomyosarkom des Isthmus uteri",
      "Primitiver neuroektodermaler Tumor des Isthmus uteri",
      "Sarkom der Schleimhaut des Isthmus uteri",
      "Stromales Sarkom des Isthmus uteri"
    ]
  },
  {
    "code": "C54.1",
    "name": "Bösartige Neubildung des Endometriums",
    "synonyms": [
      "Adenoakanthom der Mamma",
      "Bösartige Neubildung des Endometriums",
      "Bösartige Neubildung des Endometriumstromas",
      "Endometriales Stromasarkom",
      "Endometriumkarzinom",
      "Endometriumkarzinom bei Lynch-Syndrom",
      "Gut differenzierter neuroendokriner Tumor des Endometriums",
      "Karzinofibrom des Endometriums",
      "Leiomyosarkom des Endometriums",
      "Maligner Keimzelltumor des Endometriums",
      "Primitiver neuroektodermaler Tumor des Endometriums",
      "Sarkom der Uterusschleimhaut",
      "Schlecht differenziertes neuroendokrines Karzinom des Endometriums",
      "Seröses Endometriumkarzinom",
      "Transitionalzellkarzinom des Corpus uteri",
      "Undifferenziertes Endometriumkarzinom"
    ]
  },
  {
    "code": "C54.2",
    "name": "Bösartige Neubildung des Myometriums",
    "synonyms": [
      "Bösartige Neubildung des Myometriums",
      "Karzinofibrom des Myometriums",
      "Karzinom des Myometriums",
      "Leiomyosarkom des Myometriums",
      "Primitiver neuroektodermaler Tumor des Myometriums"
    ]
  },
  {
    "code": "C54.3",
    "name": "Bösartige Neubildung des Fundus uteri",
    "synonyms": [
      "Bösartige Neubildung des Fundus des Uterus",
      "Bösartige Neubildung des Fundus uteri",
      "Karzinofibrom des Fundus uteri",
      "Karzinom des Fundus uteri",
      "Leiomyosarkom des Fundus uteri",
      "Primitiver neuroektodermaler Tumor des Fundus uteri"
    ]
  },
  {
    "code": "C54.8",
    "name": "Leiomyosarkom des Corpus uteri, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Leiomyosarkom des Corpus uteri, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C54.9",
    "name": "Malignom des Corpus uteri",
    "synonyms": [
      "Adenokarzinom des Corpus uteri",
      "Adenosarkom des Corpus uteri",
      "Bösartige Neubildung des Corpus uteri",
      "Bösartige Neubildung des Uterushorns",
      "Bösartige Neubildung des Uteruskörpers",
      "Corpus-uteri-Sarkom",
      "Gut differenzierter neuroendokriner Tumor des Corpus uteri",
      "Karzinofibrom des Corpus uteri",
      "Karzinom des Corpus uteri",
      "Karzinosarkom des Corpus uteri",
      "Leiomyosarkom des Corpus uteri",
      "Maligner Keimzelltumor des Corpus uteri",
      "Maligner Müller-Mischtumor des Corpus uteri",
      "Malignom des Corpus uteri",
      "Papilläres Karzinom des Corpus uteri",
      "Plattenepithelkarzinom des Corpus uteri",
      "Primitiver neuroektodermaler Tumor des Corpus uteri",
      "Rhabdomyosarkom des Corpus uteri",
      "Schlecht differenziertes neuroendokrines Karzinom des Corpus uteri",
      "Uterushornkarzinom"
    ]
  },
  {
    "code": "C55",
    "name": "Uterussarkom",
    "synonyms": [
      "Bösartige Neubildung des Uterus",
      "Gebärmutterkarzinom",
      "Gebärmutterkrebs",
      "Gebärmuttermalignom",
      "Submuköses Leiomyosarkom des Uterus",
      "Subseröses Leiomyosarkom des Uterus",
      "Uteruskarzinom",
      "Uteruskrebs",
      "Uterusleiomyosarkom",
      "Uterusmalignom",
      "Uterussarkom"
    ]
  },
  {
    "code": "C56",
    "name": "Ovarialdysgerminom",
    "synonyms": [
      "Adenokarzinom des Ovars",
      "Bösartige Neubildung des Eierstocks",
      "Bösartige Neubildung des Ovars",
      "Bösartiger Granulosazell-Tumor",
      "Bösartiger Leydigzell-Tumor bei der Frau",
      "Bösartiges Androblastom bei der Frau",
      "Bösartiges Arrhenoblastom bei der Frau",
      "Bösartiges Thekom",
      "Carcinoma ovarii",
      "Dermoidtumor mit maligner Transformation",
      "Dermoidtumor mit maligner Transformation am Ovar",
      "Dermoidzyste mit maligner Transformation",
      "Dottersacktumor bei der Frau",
      "Dysgerminoma ovarii",
      "Eierstockkarzinom",
      "Eierstockkrebs",
      "Endometrioides Adenokarzinom am Ovar",
      "Endometrioides Adenokarzinom bei der Frau",
      "Endometrioides Karzinom am Ovar",
      "Endometrioides Zystadenokarzinom am Ovar",
      "Endometrioides Zystadenokarzinom bei der Frau",
      "Epithelialer Ovarialtumor mit Borderline-Malignität",
      "Extraovariales Ovarialkarzinom",
      "Granulosazell-Karzinom",
      "Hereditäres Site-specific-ovarian-cancer-Syndrom",
      "Klarzelliges Adenokarzinom des Ovars",
      "Kleinzelliges Ovarialkarzinom",
      "Maligner Brenner-Tumor",
      "Maligner Müller-Mischtumor des Ovars",
      "Maligner Ovarialtumor",
      "Maligner Sertoli-Leydig-Zell-Tumor des Ovars",
      "Maligner Tumor des Ovars",
      "Malignes Dysgerminom des Ovars",
      "Malignes Follikulom",
      "Malignes Teratom des Ovars",
      "Malignes endometrioides Adenofibrom",
      "Malignes endometrioides Zystadenofibrom",
      "Malignes unreifzelliges ovariales embryonales Teratom",
      "Muzinöser Tumor am Ovar mit geringem Malignitätspotential",
      "Muzinöser Tumor mit geringem Malignitätspotential",
      "Muzinöser papillärer Tumor am Ovar mit geringem Malignitätspotential",
      "Muzinöser papillärer Tumor mit geringem Malignitätspotential",
      "Muzinöses Adenokarzinom des Ovars",
      "Muzinöses Zystadenokarzinom",
      "Muzinöses Zystadenokarzinom am Ovar",
      "Muzinöses Zystadenom des Ovars mit Borderline-Malignität",
      "Nicht-dysgerminomatöser maligner Keimzelltumor des Ovars",
      "Ovarialdysgerminom",
      "Ovarialkarzinom",
      "Ovarialkarzinom bei Lynch-Syndrom",
      "Ovarialkarzinom bei hereditärem Brust- und Ovarialkrebssyndrom",
      "Ovarialkrebs",
      "Ovarialmesonephrom",
      "Ovarialseminom",
      "Ovarkarzinom",
      "Papillozystisches Adenokarzinom",
      "Papillozystisches Adenokarzinom am Ovar",
      "Papillozystisches Karzinom",
      "Papillozystisches Karzinom am Ovar",
      "Papilläres Adenokarzinom am Ovar",
      "Papilläres Zystadenokarzinom",
      "Papilläres Zystadenokarzinom am Ovar",
      "Papilläres Zystadenom des Ovars mit Borderline-Malignität",
      "Polyembryom des Ovars",
      "Polyvesikulärer Dottersacktumor bei der Frau",
      "Polyvesikulärer Vitellustumor bei der Frau",
      "Primäres nichtgestationales Chorionkarzinom des Ovars",
      "Pseudomuzinöses Adenokarzinom",
      "Pseudomuzinöses Adenokarzinom am Ovar",
      "Pseudomuzinöses Zystadenokarzinom",
      "Pseudomuzinöses Zystadenokarzinom am Ovar",
      "Pseudomuzinöses Zystadenom des Ovars mit Borderline-Malignität",
      "Sertoli-Zell-Karzinom bei der Frau",
      "Seröser Tumor mit geringem Malignitätsgrad",
      "Seröses Zystadenokarzinom",
      "Seröses Zystadenom des Ovars mit Borderline-Malignität",
      "Struma ovarii maligna",
      "Thecoma malignum",
      "Thekazellkarzinom",
      "Weibliches Dysgerminom"
    ]
  },
  {
    "code": "C57.0",
    "name": "Tubenchorionepitheliom",
    "synonyms": [
      "Bösartige Neubildung der Salpinx",
      "Bösartige Neubildung der Tuba uterina",
      "Bösartige Neubildung des Eileiters",
      "Bösartige Neubildung eines Ovidukts",
      "Eileiterkarzinom",
      "Karzinom der Tuba uterina",
      "Maligner Tumor der Eileiter",
      "Tubenchorionepitheliom"
    ]
  },
  {
    "code": "C57.1",
    "name": "Bösartige Neubildung des Ligamentum latum uteri",
    "synonyms": [
      "Bösartige Neubildung der Mesosalpinx",
      "Bösartige Neubildung der uteroovarialen Bänder",
      "Bösartige Neubildung des Ligamentum latum uteri",
      "Bösartige Neubildung des Ligamentum ovarii proprium",
      "Bösartige Neubildung des Mesovariums",
      "Bösartige Neubildung des Parovariums",
      "Karzinom des Ligamentum latum uteri",
      "Mesometriummalignom"
    ]
  },
  {
    "code": "C57.2",
    "name": "Bösartige Neubildung des Ligamentum teres uteri",
    "synonyms": [
      "Bösartige Neubildung des Ligamentum rotundum",
      "Bösartige Neubildung des Ligamentum teres uteri",
      "Karzinom des Ligamentum teres uteri",
      "Krebs des Ligamentum teres uteri"
    ]
  },
  {
    "code": "C57.3",
    "name": "Bösartige Neubildung des Parametriums",
    "synonyms": [
      "Bösartige Neubildung der Ligamenta sacrouterina",
      "Bösartige Neubildung der Ligamenta uteri",
      "Bösartige Neubildung der Uterusligamente",
      "Bösartige Neubildung der uterosakralen Bänder",
      "Bösartige Neubildung der uterosakralen Ligamente",
      "Bösartige Neubildung des Parametriums",
      "Bösartige Neubildung eines Uterusbandes",
      "Karzinom eines Uterusbandes",
      "Krebs eines Uterusbandes",
      "Parametriumkarzinom",
      "Parametriumkrebs"
    ]
  },
  {
    "code": "C57.4",
    "name": "Bösartige Neubildung der Uterusadnexe",
    "synonyms": [
      "Bösartige Neubildung der Uterusadnexe",
      "Karzinom der Uterusadnexe",
      "Krebs der Uterusadnexe"
    ]
  },
  {
    "code": "C57.7",
    "name": "Bösartige Neubildung des Wolff-Ganges",
    "synonyms": [
      "Bösartige Neubildung des Müller-Ganges bei der Frau",
      "Bösartige Neubildung des Wolff-Ganges",
      "Bösartige Neubildung des Wolff-Ganges bei der Frau",
      "Bösartige Neubildung des Wolff-Körpers"
    ]
  },
  {
    "code": "C57.8",
    "name": "Tuboovarialkarzinom",
    "synonyms": [
      "Bösartige tuboovariale Neubildung",
      "Bösartige uteroovariale Neubildung",
      "Tuboovarialkarzinom",
      "Uteroovarialkarzinom",
      "Vulvovaginales Rhabdomyosarkom"
    ]
  },
  {
    "code": "C57.9",
    "name": "Vesikovaginales Karzinom",
    "synonyms": [
      "Adenosarkom der Genitalorgane der Frau",
      "Bösartige Neubildung der Genitalorgane der Frau",
      "Bösartige Neubildung der weiblichen Geschlechtsorgane a.n.k.",
      "Bösartige Neubildung des Septum urethrovaginale",
      "Bösartige Neubildung des Septum vesikovaginale",
      "Bösartige Neubildung des vaginovesikalen Septums",
      "Bösartige Neubildung des vesikovaginalen Septums",
      "Bösartige Neubildung des vesikozervikalen Gewebes",
      "Bösartige Neubildung des weiblichen Urogenitaltraktes",
      "Karzinom der weiblichen Genitalien",
      "Urethrovaginale bösartige Neubildung",
      "Vaginovesikale bösartige Neubildung",
      "Vesikovaginale bösartige Neubildung",
      "Vesikovaginales Karzinom",
      "Weiblicher Unterleibskrebs"
    ]
  },
  {
    "code": "C58",
    "name": "Chorionepitheliom",
    "synonyms": [
      "Bösartige Neubildung der Plazenta",
      "Chorioblastom",
      "Chorionepitheliom",
      "Chorionkarzinom",
      "Chorionkarzinom bei der Frau",
      "Deciduoma malignum",
      "Deziduom",
      "Deziduomatose",
      "Fetaler Zottenkrebs",
      "Gestationales Chorionkarzinom",
      "Maligner epitheloider Trophoblasttumor",
      "Plazentakarzinom",
      "Plazentom",
      "Sarcoma deciduocellulare",
      "Schwangerschafts-Chorionkarzinom",
      "Syncytioma malignum"
    ]
  },
  {
    "code": "C60.0",
    "name": "Präputiumkrebs",
    "synonyms": [
      "Adenokarzinom des Präputiums",
      "Bösartige Neubildung der Vorhaut",
      "Bösartige Neubildung des Präputiums",
      "Malignes Melanom der Präputialschleimhaut",
      "Malignes Melanom der Vorhaut",
      "Malignes Melanom des Präputiums",
      "Nichtmelanomartige bösartige Neubildung der Haut des Präputiums",
      "Nichtmelanomartige bösartige Neubildung der Präputialhaut",
      "Plattenepithelkarzinom des Präputiums",
      "Präputiumkarzinom",
      "Präputiumkrebs"
    ]
  },
  {
    "code": "C60.1",
    "name": "Bösartige Neubildung der Glans penis",
    "synonyms": [
      "Adenokarzinom der Glans penis",
      "Bösartige Neubildung der Glans penis",
      "Karzinom der Glans penis",
      "Krebs der Glans penis",
      "Plattenepithelkarzinom der Glans penis"
    ]
  },
  {
    "code": "C60.2",
    "name": "Bösartige Neubildung des Corpus cavernosum penis",
    "synonyms": [
      "Adenokarzinom des Penisschaftes",
      "Bösartige Neubildung des Corpus cavernosum penis",
      "Bösartige Neubildung des Penisschaftes",
      "Karzinom des Corpus cavernosum des Penis",
      "Krebs des Corpus cavernosum des Penis",
      "Plattenepithelkarzinom des Penisschaftes"
    ]
  },
  {
    "code": "C60.8",
    "name": "Adenokarzinom des Penis, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Adenokarzinom des Penis, mehrere Teilbereiche überlappend",
      "Plattenepithelkarzinom des Penis, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C60.9",
    "name": "Peniskarzinom",
    "synonyms": [
      "Adenokarzinom des Penis",
      "Bösartige Neubildung der Penishaut",
      "Bösartige Neubildung des Penis",
      "Maligner Tumor des Penis",
      "Malignes Melanom des Penis",
      "Nichtmelanomartige bösartige Neubildung der Penishaut a.n.k.",
      "Peniskarzinom",
      "Peniskrebs",
      "Plattenepithelkarzinom des Penis"
    ]
  },
  {
    "code": "C61",
    "name": "Prostataadenokarzinom",
    "synonyms": [
      "Bösartige Neubildung der Prostata",
      "Embryonales Rhabdomyosarkom der Prostata",
      "Endometrioides Adenokarzinom beim Mann",
      "Endometrioides Zystadenokarzinom beim Mann",
      "Familiäres Prostatakarzinom",
      "Intraduktales Karzinom der Prostata [IDPCa]",
      "Maligne Prostataerkrankung",
      "Maligner Prozess der Prostata",
      "Metastasierende Neoplasie der Prostata",
      "Metastasierendes Prostatakarzinom",
      "Prostataadenokarzinom",
      "Prostatakarzinom",
      "Prostatakrebs",
      "Prostatamalignom",
      "Prostatasarkom",
      "Vorsteherdrüsenkrebs",
      "Vorsteherdrüsenmalignom"
    ]
  },
  {
    "code": "C62.0",
    "name": "Bösartige Neubildung des Hodens bei Kryptorchismus",
    "synonyms": [
      "Bösartige Neubildung des Hodens bei Kryptorchismus",
      "Bösartige Neubildung eines ektopischen Hodens",
      "Bösartige Neubildung eines nichtdeszendierten Hodens",
      "Bösartige Neubildung eines retinierten Hodens",
      "Embryom eines nichtdeszendierten Hodens",
      "Hodenkarzinom bei Kryptorchismus",
      "Hodenkrebs bei Kryptorchismus",
      "Keimstrang-Stromatumor eines dystopen Hodens",
      "Nichtseminomatöser Keimzelltumor eines dystopen Hodens",
      "Polyembryom eines nichtdeszendierten Hodens",
      "Seminom eines nichtdeszendierten Hodens",
      "Teratom eines dystopen Hodens",
      "Teratom eines maldeszendierten Hodens"
    ]
  },
  {
    "code": "C62.1",
    "name": "Bösartige Neubildung eines deszendierten Hodens",
    "synonyms": [
      "Bösartige Neubildung eines deszendierten Hodens",
      "Bösartige Neubildung eines skrotalen Hodens",
      "Embryom eines deszendierten Hodens",
      "Keimstrang-Stromatumor eines skrotalen Hodens",
      "Nichtseminomatöser Keimzelltumor eines skrotalen Hodens",
      "Polyembryom eines deszendierten Hodens",
      "Seminom eines deszendierten Hodens",
      "Teratom eines skrotalen Hodens"
    ]
  },
  {
    "code": "C62.9",
    "name": "Orchioblastom",
    "synonyms": [
      "Anaplastisches Seminom",
      "Bösartige Neubildung des Hodens",
      "Bösartiger Leydigzell-Tumor beim Mann",
      "Bösartiges Androblastom beim Mann",
      "Bösartiges Arrhenoblastom beim Mann",
      "Chorionkarzinom beim Mann",
      "Dottersacktumor beim Mann",
      "Dysgerminom beim Mann",
      "Epithelioma seminifere",
      "Epithelioma spermatogonique Masson",
      "Hodenchorionepitheliom",
      "Hodenembryom",
      "Hodengerminom",
      "Hodenkarzinom",
      "Hodenkrebs",
      "Hodenmesotheliom",
      "Hodenseminom",
      "Hodenteratokarzinom",
      "Hodenteratom",
      "Keimstrang-Stromatumor des Hodens",
      "Maligner Hodentumor",
      "Metastasierender Hodentumor",
      "Nichtseminomatöser testikulärer Keimzelltumor",
      "Orchioblastom",
      "Polyvesikulärer Dottersacktumor beim Mann",
      "Polyvesikulärer Vitellustumor beim Mann",
      "Seminom",
      "Sertoli-Zell-Karzinom",
      "Sertoli-Zell-Karzinom beim Mann",
      "Spermatozytom",
      "Spermatozytäres Seminom",
      "Testiskarzinom"
    ]
  },
  {
    "code": "C63.0",
    "name": "Nebenhodenkarzinom",
    "synonyms": [
      "Adenokarzinom des Nebenhodens",
      "Bösartige Neubildung der Epididymis",
      "Bösartige Neubildung des Nebenhodens",
      "Epididymiskarzinom",
      "Epididymiskrebs",
      "Nebenhodenkarzinom",
      "Nebenhodenkrebs",
      "Nebenhodenmesotheliom"
    ]
  },
  {
    "code": "C63.1",
    "name": "Samenstrangkarzinom",
    "synonyms": [
      "Adenokarzinom des Samenstranges",
      "Bösartige Neubildung des Ductus deferens",
      "Bösartige Neubildung des Funiculus spermaticus",
      "Bösartige Neubildung des Samenstranges",
      "Bösartige Neubildung des Vas deferens",
      "Embryonales Rhabdomyosarkom des Samenstranges",
      "Hochdifferenziertes Liposarkom des Samenstranges",
      "Karzinom des Funiculus spermaticus",
      "Krebs des Funiculus spermaticus",
      "Samenstrangkarzinom"
    ]
  },
  {
    "code": "C63.2",
    "name": "Skrotumkarzinom",
    "synonyms": [
      "Adenokarzinom des Skrotums",
      "Bösartige Neubildung der Skrotalhaut",
      "Bösartige Neubildung des Skrotums",
      "Malignes Melanom des Skrotums",
      "Nichtmelanomartige bösartige Neubildung der Skrotalhaut",
      "Schornsteinfegerkrebs",
      "Skrotumbasaliom",
      "Skrotumkarzinom",
      "Skrotumkrebs"
    ]
  },
  {
    "code": "C63.7",
    "name": "Samenblasenkarzinom",
    "synonyms": [
      "Adenokarzinom der Samenblase",
      "Bösartige Neubildung der Bläschendrüse",
      "Bösartige Neubildung der Samenblase",
      "Bösartige Neubildung der Tunica vaginalis testis",
      "Bösartige Neubildung der Vesicula seminalis",
      "Bösartige Neubildung des Ductus ejaculatorius",
      "Bösartige Neubildung des Müller-Ganges beim Mann",
      "Bösartige Neubildung des Wolff-Ganges beim Mann",
      "Karzinom der Tunica vaginalis testis",
      "Karzinom der Vesicula seminalis",
      "Samenblasenkarzinom"
    ]
  },
  {
    "code": "C63.8",
    "name": "Paratestikuläres Adenokarzinom, mehrere Teilbereiche überlappend",
    "synonyms": [
      "Paratestikuläres Adenokarzinom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C63.9",
    "name": "Karzinom der männlichen Genitalien",
    "synonyms": [
      "Adenosarkom der Genitalorgane des Mannes",
      "Bösartige Neubildung der Genitalorgane des Mannes",
      "Bösartige Neubildung der männlichen Geschlechtsorgane a.n.k.",
      "Bösartige Neubildung des männlichen Urogenitaltraktes",
      "Karzinom der männlichen Genitalien",
      "Nichtmelanomartige bösartige Neubildung der Haut der männlichen Geschlechtsorgane",
      "Paratestikuläres Adenokarzinom"
    ]
  },
  {
    "code": "C64",
    "name": "Nephroblastom",
    "synonyms": [
      "Adenokarzinom der Nierenzellen",
      "Angiosarkom der Niere",
      "Birch-Hirschfeld-Tumor",
      "Bösartige Neubildung der Niere",
      "Bösartige Neubildung des Nierenparenchyms",
      "Chromophobes Nierenzellkarzinom",
      "Ductus-Bellini-Karzinom",
      "Embryonales Adenorhabdomyosarkom der Niere",
      "Embryonales Adenosarkom der Niere [Wilms-Tumor]",
      "Embryonales Nephroblastom",
      "Epinephrom",
      "Epitheliales Nephroblastom",
      "Grawitz-Tumor",
      "Hereditäres klarzelliges Nierenzellkarzinom",
      "Hereditäres papilläres Nierenzellkarzinom",
      "Hypernephroider Nierentumor",
      "Hypernephroides Nierenkarzinom",
      "Hypernephrom",
      "Klarzelliges Karzinom der Niere",
      "Klarzelliges Nierensarkom",
      "Klarzelliges Nierenzellkarzinom",
      "Klarzelliges papilläres Nierenzellkarzinom",
      "Klarzellsarkom der Niere",
      "Maligner Nierentumor",
      "Malignes Nephrom",
      "Manon-Nieren-Dysembryom",
      "Medulläres Nierenkarzinom",
      "Mesenchymales Nephroblastom",
      "MiT-assoziiertes Translokations-Nierenzellkarzinom",
      "Muzinöses tubuläres und spindelzelliges Karzinom der Niere",
      "Nephroblastom",
      "Nephrogenes Dysembryom",
      "Nephrom",
      "Nierenadenokarzinom",
      "Nierenembryom",
      "Nierenkarzinom",
      "Nierenkrebs",
      "Nierenmalignom",
      "Nierenparenchymkarzinom",
      "Nierenstruma",
      "Nierenzellkarzinom",
      "Papilläres Nierenzellkarzinom",
      "RCC [Nierenzellkarzinom]",
      "Renale bösartige Neubildung",
      "Renales Adenokarzinom",
      "Rhabdoidtumor der Niere",
      "Sarcoma clarocellulare der Niere",
      "Tubulozystisches Nierenzellkarzinom",
      "Wilms-Adenosarkom",
      "Wilms-Tumor"
    ]
  },
  {
    "code": "C65",
    "name": "Nierenbeckenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Nierenbeckenkelche",
      "Bösartige Neubildung der Nierenkelche",
      "Bösartige Neubildung des Nierenbecken-Ureter-Überganges",
      "Bösartige Neubildung des Nierenbeckens",
      "Bösartige Neubildung des Nierenhilus",
      "Bösartige Neubildung des Überganges zwischen Nierenbecken und Harnleiter",
      "Bösartiger Tumor des Nierenbeckens",
      "Malignes Nierenbeckenpapillom",
      "Nierenbeckenkarzinom",
      "Nierenbeckenkrebs",
      "Nierenkelchkarzinom",
      "Transitionalzellkarzinom des Nierenbeckens",
      "Übergangszellkarzinom des Nierenbeckens"
    ]
  },
  {
    "code": "C66",
    "name": "Bösartige Neubildung des Harnleiters",
    "synonyms": [
      "Bösartige Neubildung des Harnleiters",
      "Bösartige Neubildung des Ureters",
      "Harnleiterkarzinom",
      "Harnleiterkrebs",
      "Transitionalzellkarzinom des Harnleiters",
      "Ureterkarzinom",
      "Ureterkrebs"
    ]
  },
  {
    "code": "C67.0",
    "name": "Bösartige Neubildung des Harnblasenbodens",
    "synonyms": [
      "Blasenbodenkarzinom",
      "Bösartige Neubildung des Harnblasenbodens",
      "Bösartige Neubildung des Trigonum vesicae",
      "Embryonales Rhabdomyosarkom des Trigonum vesicae",
      "Harnblasenbodenkarzinom",
      "Karzinom des Trigonum vesicae",
      "Kleinzelliges Karzinom des Trigonum vesicae",
      "Krebs des Trigonum vesicae",
      "Nicht-papilläres Transitionalzellkarzinom des Trigonum vesicae"
    ]
  },
  {
    "code": "C67.1",
    "name": "Bösartige Neubildung des Blasenscheitels",
    "synonyms": [
      "Bösartige Neubildung des Apex vesicae",
      "Bösartige Neubildung des Blasenscheitels",
      "Bösartige Neubildung des Harnblasenscheitels",
      "Embryonales Rhabdomyosarkom des Apex vesicae",
      "Karzinom des Blasenscheitels",
      "Kleinzelliges Karzinom des Apex vesicae",
      "Krebs des Blasenscheitels",
      "Nicht-papilläres Transitionalzellkarzinom des Apex vesicae"
    ]
  },
  {
    "code": "C67.2",
    "name": "Karzinom der seitlichen Harnblasenwand",
    "synonyms": [
      "Bösartige Neubildung der lateralen Harnblasenwand",
      "Bösartige Neubildung der seitlichen Harnblasenwand",
      "Embryonales Rhabdomyosarkom der seitlichen Harnblasenwand",
      "Karzinom der seitlichen Harnblasenwand",
      "Kleinzelliges Karzinom der seitlichen Harnblasenwand",
      "Krebs der seitlichen Harnblasenwand",
      "Nicht-papilläres Transitionalzellkarzinom der seitlichen Harnblasenwand"
    ]
  },
  {
    "code": "C67.3",
    "name": "Karzinom der vorderen Harnblasenwand",
    "synonyms": [
      "Bösartige Neubildung der vorderen Harnblasenwand",
      "Embryonales Rhabdomyosarkom der vorderen Harnblasenwand",
      "Karzinom der vorderen Harnblasenwand",
      "Kleinzelliges Karzinom der vorderen Harnblasenwand",
      "Krebs der vorderen Harnblasenwand",
      "Nicht-papilläres Transitionalzellkarzinom der vorderen Harnblasenwand"
    ]
  },
  {
    "code": "C67.4",
    "name": "Bösartige Neubildung der hinteren Harnblasenwand",
    "synonyms": [
      "Bösartige Neubildung der hinteren Harnblasenwand",
      "Embryonales Rhabdomyosarkom der hinteren Harnblasenwand",
      "Karzinom der hinteren Harnblasenwand",
      "Kleinzelliges Karzinom der hinteren Harnblasenwand",
      "Krebs der hinteren Harnblasenwand",
      "Nicht-papilläres Transitionalzellkarzinom der hinteren Harnblasenwand"
    ]
  },
  {
    "code": "C67.5",
    "name": "Bösartige Neubildung der Cervix vesicae",
    "synonyms": [
      "Bösartige Neubildung der Cervix vesicae",
      "Bösartige Neubildung der inneren Mündung der Urethra",
      "Bösartige Neubildung des Blasenhalses",
      "Bösartige Neubildung des Harnblasenhalses",
      "Bösartige Neubildung des Ostium urethrae internum",
      "Embryonales Rhabdomyosarkom des Harnblasenhalses",
      "Karzinom der Cervix vesicae",
      "Karzinom des Blasenhalses",
      "Kleinzelliges Karzinom des Harnblasenhalses",
      "Krebs der Cervix vesicae",
      "Krebs des Blasenhalses",
      "Nicht-papilläres Transitionalzellkarzinom des Blasenhalses"
    ]
  },
  {
    "code": "C67.6",
    "name": "Bösartige Neubildung des Ostium ureteris",
    "synonyms": [
      "Bösartige Neubildung der Harnleitermündung",
      "Bösartige Neubildung der Uretermündung",
      "Bösartige Neubildung des Ostium ureteris",
      "Karzinom der Harnleitermündung",
      "Karzinom des Ostium ureteris",
      "Kleinzelliges Karzinom des Ostium ureteris",
      "Krebs der Harnleitermündung",
      "Krebs des Ostium ureteris",
      "Nicht-papilläres Transitionalzellkarzinom des Ostium ureteris"
    ]
  },
  {
    "code": "C67.7",
    "name": "Bösartige Neubildung des Urachus",
    "synonyms": [
      "Bösartige Neubildung des Urachus",
      "Kleinzelliges Urachuskarzinom",
      "Nicht-papilläres Transitionalzellkarzinom des Urachus",
      "Urachuskarzinom",
      "Urachuskrebs"
    ]
  },
  {
    "code": "C67.8",
    "name": "Bösartige Neubildung des Harnblasensphinkters",
    "synonyms": [
      "Bösartige Neubildung des Harnblase, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung des Harnblasensphinkters",
      "Embryonales Rhabdomyosarkom der Harnblase, mehrere Teilbereiche überlappend",
      "Kleinzelliges Harnblasenkarzinom, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C67.9",
    "name": "Blasenkarzinom (Harnblase)",
    "synonyms": [
      "Blasenkarzinom (Harnblase)",
      "Blasenkrebs",
      "Blasenwandkarzinom",
      "Bösartige Blasenneubildung",
      "Bösartige Neubildung der Harnblase",
      "Bösartige Neubildung der Harnblasenwand",
      "Bösartige Neubildung der Harnblasenöffnung",
      "Embryonales Rhabdomyosarkom der Harnblase",
      "Harnblasenkarzinom",
      "Harnblasenkrebs",
      "Harnblasenmalignom",
      "Harnblasensarkom",
      "Kleinzelliges Harnblasenkarzinom",
      "Maligner Harnblasentumor",
      "Metastasierendes Blasenkarzinom (Harnblase)",
      "Nicht-papilläres Transitionalzellkarzinom der Harnblase",
      "Rhabdomyosarkom der Harnblase",
      "Teerkrebs der Harnblase",
      "Transitionalzellkarzinom der Blase",
      "Transitionalzellkarzinom der Harnblase",
      "Übergangszellkarzinom der Blase",
      "Übergangszellkarzinom der Harnblase"
    ]
  },
  {
    "code": "C68.0",
    "name": "Harnröhrenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Bulbourethraldrüsen",
      "Bösartige Neubildung der Cervix urethrae",
      "Bösartige Neubildung der Cowper-Drüsen",
      "Bösartige Neubildung der Harnröhre",
      "Bösartige Neubildung der Urethra",
      "Bösartige Neubildung des Utriculus prostaticus",
      "Harnröhrenkarzinom",
      "Harnröhrenkrebs",
      "Urethrakarzinom",
      "Urethrakrebs",
      "Urethramalignom"
    ]
  },
  {
    "code": "C68.1",
    "name": "Krebs der paraurethralen Drüse",
    "synonyms": [
      "Bösartige Neubildung der Skene-Drüse",
      "Bösartige Neubildung der paraurethralen Drüse",
      "Karzinom der paraurethralen Drüse",
      "Krebs der paraurethralen Drüse"
    ]
  },
  {
    "code": "C68.9",
    "name": "Bösartige Neubildung der Harnorgane",
    "synonyms": [
      "Bösartige Neubildung der Harnorgane",
      "Bösartige Neubildung der Harnwege a.n.k.",
      "Bösartige Neubildung der männlichen Harnorgane",
      "Bösartige Neubildung der weiblichen Harnorgane",
      "Bösartige Neubildung des Harnsystems",
      "Bösartige Neubildung des Harntraktes",
      "Karzinom der Harnorgane",
      "Krebs der Harnorgane",
      "Transitionalzellkarzinom",
      "Urothelkarzinom",
      "Urothelkarzinom bei Lynch-Syndrom",
      "Urothelkarzinom des oberen Harntraktes"
    ]
  },
  {
    "code": "C69.0",
    "name": "Malignes Melanom der Konjunktiva",
    "synonyms": [
      "Bindehautkarzinom",
      "Bindehautkrebs",
      "Bösartige Neubildung der Bindehaut",
      "Bösartige Neubildung der Konjunktiva",
      "Bösartiger Bindehauttumor",
      "Konjunktivakarzinom",
      "Konjunktivakrebs",
      "Maligner Karunkeltumor am Auge",
      "Maligner Tumor der Konjunktiva",
      "Malignes Bindehautmelanom",
      "Malignes Melanom der Konjunktiva",
      "Plattenepithelkarzinom der Bindehaut",
      "Plattenepithelkarzinom der Konjunktiva"
    ]
  },
  {
    "code": "C69.1",
    "name": "Bösartige Neubildung der Kornea",
    "synonyms": [
      "Bösartige Neubildung der Kornea",
      "Bösartige Neubildung des Limbus corneae",
      "Korneakarzinom",
      "Korneakrebs",
      "Maligner Hornhauttumor"
    ]
  },
  {
    "code": "C69.2",
    "name": "Retinogliom",
    "synonyms": [
      "Bösartige Neubildung der Retina",
      "Differenziertes Retinoblastom",
      "Glioma retinae",
      "Hereditäres Retinoblastom",
      "Maligner Netzhauttumor",
      "Maligner Retinatumor",
      "Malignes Melanom der Retina",
      "Medulloepitheliom der Retina",
      "Netzhautastrozytom",
      "Nicht-hereditäres Retinoblastom",
      "Retinaastrozytom",
      "Retinakarzinom",
      "Retinakrebs",
      "Retinoblastom",
      "Retinoblastom mit echten Rosetten",
      "Retinoblastom ohne Rosetten",
      "Retinogliom",
      "Retinom",
      "Undifferenziertes Retinoblastom"
    ]
  },
  {
    "code": "C69.3",
    "name": "Bösartige Neubildung der Chorioidea",
    "synonyms": [
      "Aderhautmelanom",
      "Bösartige Neubildung der Chorioidea",
      "Chorioideakarzinom",
      "Chorioideakrebs",
      "Chorioideamelanom",
      "Maligner Aderhauttumor",
      "Maligner Chorioideatumor",
      "Malignes Aderhautmelanom",
      "Malignes Chorioideamelanom"
    ]
  },
  {
    "code": "C69.4",
    "name": "Uveaepitheliom",
    "synonyms": [
      "Bösartige Neubildung der Iris",
      "Bösartige Neubildung der Linse",
      "Bösartige Neubildung der Sklera",
      "Bösartige Neubildung des Corpus ciliare",
      "Bösartige Neubildung des Uvealtrakts",
      "Bösartige Neubildung des Ziliarkörpers",
      "Karzinom des Corpus ciliare",
      "Krebs des Corpus ciliare",
      "Maligner Iristumor",
      "Maligner Skleratumor",
      "Maligner Ziliarkörpertumor",
      "Malignes Melanom der Iris",
      "Malignes Ziliarkörpermelanom",
      "Malignes Ziliarkörperringmelanom",
      "Malignes spindelzelliges Melanom des Ziliarkörpers vom Typ A",
      "Malignes spindelzelliges Melanom des Ziliarkörpers vom Typ B",
      "Medulloepitheliom der Iris",
      "Medulloepitheliom des Ziliarkörpers",
      "Uveaepitheliom"
    ]
  },
  {
    "code": "C69.5",
    "name": "Maligner Tränenwegtumor",
    "synonyms": [
      "Bösartige Neubildung der Glandula lacrimalis",
      "Bösartige Neubildung der Tränendrüse",
      "Bösartige Neubildung der Tränendrüse und der Tränenwege",
      "Bösartige Neubildung der Tränenwege",
      "Bösartige Neubildung des Ductus nasolacrimalis",
      "Bösartige Neubildung des Tränenkanals",
      "Bösartige Neubildung des Tränennasenganges",
      "Bösartige Neubildung des Tränenpunktes",
      "Bösartige Neubildung des Tränensacks",
      "Bösartiger Tränendrüsentumor",
      "Karzinom der Glandula lacrimalis",
      "Krebs der Glandula lacrimalis",
      "Maligner Tränendrüsentumor",
      "Maligner Tränenwegtumor",
      "Malignes Melanom der Tränendrüse",
      "Tränendrüsenkarzinom",
      "Tränendrüsenkrebs",
      "Tränenkanalkarzinom",
      "Tränenkanalkrebs"
    ]
  },
  {
    "code": "C69.6",
    "name": "Malignes Orbitamelanom",
    "synonyms": [
      "Augenhöhlenkarzinom",
      "Augenhöhlenkrebs",
      "Bösartige Neubildung der Augenhöhle",
      "Bösartige Neubildung der Orbita",
      "Bösartige Neubildung der Orbitaweichteile",
      "Bösartige Neubildung der autonomen Nerven der Orbita",
      "Bösartige Neubildung der extraokulären Augenmuskeln",
      "Bösartige Neubildung der peripheren Nerven der Orbita",
      "Bösartige Neubildung des Bindegewebes der Orbita",
      "Bösartige Neubildung des retrobulbären Gewebes",
      "Bösartige Neubildung des retrookulären Gewebes",
      "Bösartige Neubildung eines extraokulären Muskels in der Orbita",
      "Bösartige Neubildung peripherer Nerven der Orbita",
      "Embryonales Rhabdomyosarkom der Orbita",
      "Intraorbitale bösartige Neubildung",
      "Maligner Orbitatumor",
      "Malignes Orbitamelanom",
      "Malignes retrobulbäres Melanom",
      "Medulloepitheliom der Orbita",
      "Orbitakarzinom",
      "Orbitakrebs",
      "Orbitasarkom",
      "Rhabdomyosarkom der Orbita"
    ]
  },
  {
    "code": "C69.9",
    "name": "Bösartige Neubildung des Augapfels",
    "synonyms": [
      "Augapfelkarzinom",
      "Augapfelkrebs",
      "Augenkarzinom",
      "Augenkrebs",
      "Bösartige Neubildung des Augapfels",
      "Bösartige Neubildung des Auges",
      "Intraokuläre bösartige Neubildung",
      "Intraokuläres Medulloepitheliom",
      "Maligner Augentumor",
      "Malignes Gliom des Auges",
      "Malignes Melanom des Auges",
      "Retrobulbäre bösartige Neubildung"
    ]
  },
  {
    "code": "C70.0",
    "name": "Bösartige Neubildung der Hirnhaut",
    "synonyms": [
      "Bösartige Neubildung der Arachnoidea cerebralis",
      "Bösartige Neubildung der Dura mater cranialis",
      "Bösartige Neubildung der Dura mater encephali",
      "Bösartige Neubildung der Falx cerebelli",
      "Bösartige Neubildung der Falx cerebri",
      "Bösartige Neubildung der Gehirnmeningen",
      "Bösartige Neubildung der Hirnhaut",
      "Bösartige Neubildung der intrakraniellen Meningen",
      "Bösartige Neubildung der kranialen Pia mater",
      "Bösartige Neubildung der kraniellen Meningen",
      "Bösartige Neubildung der zerebralen Meningen",
      "Bösartige Neubildung der zerebralen Pia mater",
      "Bösartige Neubildung des Tentorium cerebelli",
      "Bösartige Neubildung zerebraler Meningen",
      "Hirnhautkrebs",
      "Karzinom der Hirnhaut",
      "Primäres Melanom der zerebralen Meningen"
    ]
  },
  {
    "code": "C70.1",
    "name": "Bösartige Neubildung der Rückenmarkhäute",
    "synonyms": [
      "Bösartige Neubildung der Arachnoidea spinalis",
      "Bösartige Neubildung der Dura mater der Wirbelsäule",
      "Bösartige Neubildung der Dura mater spinalis",
      "Bösartige Neubildung der Pia mater der Wirbelsäule",
      "Bösartige Neubildung der Rückenmarkhäute",
      "Bösartige Neubildung der Rückenmarkmeningen",
      "Bösartige Neubildung der Wirbelsäulenmeningen",
      "Bösartige Neubildung der spinalen Meningen",
      "Bösartige Neubildung der spinalen Pia mater",
      "Karzinom der Rückenmarkhäute",
      "Krebs der Rückenmarkhäute",
      "Primäres Melanom der spinalen Meningen"
    ]
  },
  {
    "code": "C70.9",
    "name": "Meningensarkom",
    "synonyms": [
      "Bösartige Neubildung der Arachnoidea",
      "Bösartige Neubildung der Dura mater",
      "Bösartige Neubildung der Meningen",
      "Bösartige Neubildung der Pia mater",
      "Bösartiges Meningeom",
      "Karzinom der Meningen",
      "Krebs der Meningen",
      "Leptomeningealsarkom",
      "Malignes Melanom der Meningen",
      "Meningensarkom",
      "Meningensarkomatose",
      "Meningeoma malignum",
      "Meningothelialsarkom",
      "Subdurale bösartige Neubildung"
    ]
  },
  {
    "code": "C71.0",
    "name": "Bösartige Neubildung des Großhirns",
    "synonyms": [
      "Anaplastisches Astrozytom des Großhirns",
      "Anaplastisches Gangliogliom des Zerebrums",
      "Anaplastisches Oligoastrozytom des Großhirns",
      "Anaplastisches Oligodendrogliom des Zerebrums",
      "Astroblastom des Großhirns",
      "Astrozytom des Großhirns",
      "Astrozytom des Thalamus",
      "Balkengliom",
      "Bösartige Neubildung der Basalganglien",
      "Bösartige Neubildung der Capsula interna",
      "Bösartige Neubildung der Großhirnhemisphäre",
      "Bösartige Neubildung der Großhirnrinde",
      "Bösartige Neubildung der Insula",
      "Bösartige Neubildung der Reil-Insel",
      "Bösartige Neubildung der inneren Kapsel",
      "Bösartige Neubildung der zentralen weißen Hirnsubstanz",
      "Bösartige Neubildung der zerebralen weißen Hirnsubstanz",
      "Bösartige Neubildung des Corpus striatum",
      "Bösartige Neubildung des Globus pallidus",
      "Bösartige Neubildung des Großhirns",
      "Bösartige Neubildung des Hypothalamus",
      "Bösartige Neubildung des Operculum",
      "Bösartige Neubildung des Palliums",
      "Bösartige Neubildung des Putamens",
      "Bösartige Neubildung des Rhinenzephalons",
      "Bösartige Neubildung des Thalamus",
      "Bösartige Neubildung des Zerebrums",
      "Bösartige Neubildung eines basalen Ganglions",
      "Bösartige supratentorielle Neubildung",
      "Bösartiger Stammganglientumor",
      "Diffuses Astrozytom des Großhirns",
      "Ependymoblastom des Großhirns",
      "Germinom der Basalganglien",
      "Germinom des Thalamus",
      "Glioblastom des Großhirns",
      "Gliomatosis cerebri",
      "Gliosarkom des Großhirns",
      "Großhirnkarzinom",
      "Großhirnkrebs",
      "Malignes Teratom des Cerebrums",
      "Medulloepitheliom des Großhirns",
      "Oligoastrozytischer Tumor des Großhirns",
      "Oligoastrozytom des Großhirns",
      "Oligodendrogliom des Großhirns",
      "Oligodendrogliom des Zerebrums",
      "Pilomyxoides Astrozytom des Großhirns",
      "Pilomyxoides Astrozytom des Hypothalamus",
      "Pilozytisches Astrozytom des Großhirns",
      "Pleomorphes Xanthoastrozytom des Großhirns",
      "Primitiver neuroektodermaler Tumor des Zerebrums",
      "Protoplasmatisches Astrozytom des Großhirns",
      "Riesenzellglioblastom des Großhirns",
      "Thalamusmalignom"
    ]
  },
  {
    "code": "C71.1",
    "name": "Bösartige Neubildung des Lobus frontalis",
    "synonyms": [
      "Anaplastisches Astrozytom des Frontallappens",
      "Anaplastisches Gangliogliom des Lobus frontalis",
      "Anaplastisches Oligoastrozytom des Lobus frontalis",
      "Anaplastisches Oligodendrogliom des Lobus frontalis",
      "Astroblastom des Lobus frontalis",
      "Astrozytom des Frontalhirns",
      "Bösartige Neubildung des Frontalhirns a.n.k.",
      "Bösartige Neubildung des Frontallappens",
      "Bösartige Neubildung des Lobus frontalis",
      "Bösartige Neubildung des Polus frontalis cerebri",
      "Bösartige Neubildung des Stirnlappens des Gehirns",
      "Chorionkarzinom des Lobus frontalis",
      "Diffuses Astrozytom des Lobus frontalis",
      "Ependymoblastom des Lobus frontalis",
      "Glioblastom des Frontallappens",
      "Gliosarkom des Lobus frontalis",
      "Karzinom des Lobus frontalis",
      "Krebs des Lobus frontalis",
      "Malignes Gliom des Lobus frontalis",
      "Malignes Teratom des Lobus frontalis",
      "Medulloepitheliom des Lobus frontalis",
      "Oligoastrozytischer Tumor des Lobus frontalis",
      "Oligoastrozytom des Lobus frontalis",
      "Oligodendrogliom des Lobus frontalis",
      "Pilomyxoides Astrozytom des Lobus frontalis",
      "Pilozytisches Astrozytom des Lobus frontalis",
      "Pleomorphes Xanthoastrozytom des Lobus frontalis",
      "Primitiver neuroektodermaler Tumor des Lobus frontalis",
      "Protoplasmatisches Astrozytom des Lobus frontalis",
      "Riesenzellglioblastom des Lobus frontalis"
    ]
  },
  {
    "code": "C71.2",
    "name": "Bösartige Neubildung des Lobus temporalis",
    "synonyms": [
      "Anaplastisches Astrozytom des Lobus temporalis",
      "Anaplastisches Gangliogliom des Lobus temporalis",
      "Anaplastisches Oligoastrozytom des Lobus temporalis",
      "Anaplastisches Oligodendrogliom des Lobus temporalis",
      "Astroblastom des Lobus temporalis",
      "Astrozytom des Schläfenlappens",
      "Bösartige Neubildung des Hippocampus",
      "Bösartige Neubildung des Lobus temporalis",
      "Bösartige Neubildung des Temporallappens des Gehirns",
      "Bösartige Neubildung des Uncus",
      "Chorionkarzinom des Lobus temporalis",
      "Diffuses Astrozytom des Lobus temporalis",
      "Ependymoblastom des Lobus temporalis",
      "Glioblastom des Lobus temporalis",
      "Gliosarkom des Lobus temporalis",
      "Karzinom des Lobus temporalis",
      "Krebs des Lobus temporalis",
      "Malignes Gliom des Lobus temporalis",
      "Malignes Teratom des Lobus temporalis",
      "Medulloepitheliom des Lobus temporalis",
      "Oligoastrozytischer Tumor des Lobus temporalis",
      "Oligoastrozytom des Lobus temporalis",
      "Oligodendrogliom des Lobus temporalis",
      "Pilomyxoides Astrozytom des Lobus temporalis",
      "Pilozytisches Astrozytom des Lobus temporalis",
      "Pleomorphes Xanthoastrozytom des Lobus temporalis",
      "Primitiver neuroektodermaler Tumor des Lobus temporalis",
      "Protoplasmatisches Astrozytom des Lobus temporalis",
      "Riesenzellglioblastom des Lobus temporalis",
      "Temporales Astrozytom 2. Grades",
      "Temporallappenastrozytom"
    ]
  },
  {
    "code": "C71.3",
    "name": "Bösartige Neubildung des Lobus parietalis",
    "synonyms": [
      "Anaplastisches Astrozytom des Lobus parietalis",
      "Anaplastisches Gangliogliom des Lobus parietalis",
      "Anaplastisches Oligoastrozytom des Lobus parietalis",
      "Anaplastisches Oligodendrogliom des Lobus parietalis",
      "Astroblastom des Lobus parietalis",
      "Astrozytom des Parietallappens",
      "Astrozytom des Scheitellappens",
      "Bösartige Neubildung des Lobus parietalis",
      "Bösartige Neubildung des Parietallappens",
      "Bösartige Neubildung des Parietallappens des Gehirns a.n.k.",
      "Bösartige Neubildung des Scheitellappens des Gehirns",
      "Chorionkarzinom des Lobus parietalis",
      "Diffuses Astrozytom des Lobus parietalis",
      "Ependymoblastom des Lobus parietalis",
      "Glioblastom des Parietallappens",
      "Gliosarkom des Lobus parietalis",
      "Karzinom des Lobus parietalis",
      "Krebs des Lobus parietalis",
      "Malignes Gliom des Lobus parietalis",
      "Malignes Teratom des Lobus parietalis",
      "Medulloepitheliom des Lobus parietalis",
      "Oligoastrozytischer Tumor des Lobus parietalis",
      "Oligoastrozytom des Lobus parietalis",
      "Oligodendrogliom des Lobus parietalis",
      "Parietales Astrozytom",
      "Pilomyxoides Astrozytom des Lobus parietalis",
      "Pilozytisches Astrozytom des Lobus parietalis",
      "Pleomorphes Xanthoastrozytom des Lobus parietalis",
      "Primitiver neuroektodermaler Tumor des Lobus parietalis",
      "Protoplasmatisches Astrozytom des Lobus parietalis",
      "Riesenzellglioblastom des Lobus parietalis"
    ]
  },
  {
    "code": "C71.4",
    "name": "Bösartige Neubildung des Lobus occipitalis",
    "synonyms": [
      "Anaplastisches Astrozytom des Lobus occipitalis",
      "Anaplastisches Gangliogliom des Lobus occipitalis",
      "Anaplastisches Oligoastrozytom des Lobus occipitalis",
      "Anaplastisches Oligodendrogliom des Lobus occipitalis",
      "Astroblastom des Lobus occipitalis",
      "Astrozytom des Okzipitallappens",
      "Bösartige Neubildung des Lobus occipitalis",
      "Bösartige Neubildung des Okzipitallappens des Gehirns a.n.k.",
      "Bösartige Neubildung des Polus occipitalis cerebri",
      "Chorionkarzinom des Lobus occipitalis",
      "Diffuses Astrozytom des Lobus occipitalis",
      "Ependymoblastom des Lobus occipitalis",
      "Glioblastom des Lobus occipitalis",
      "Gliosarkom des Lobus occipitalis",
      "Karzinom des Lobus occipitalis",
      "Krebs des Lobus occipitalis",
      "Malignes Gliom des Lobus occipitalis",
      "Malignes Teratom des Lobus occipitalis",
      "Medulloepitheliom des Lobus occipitalis",
      "Oligoastrozytischer Tumor des Lobus occipitalis",
      "Oligoastrozytom des Lobus occipitalis",
      "Oligodendrogliom des Lobus occipitalis",
      "Pilomyxoides Astrozytom des Lobus occipitalis",
      "Pilozytisches Astrozytom des Lobus occipitalis",
      "Pleomorphes Xanthoastrozytom des Lobus occipitalis",
      "Primitiver neuroektodermaler Tumor des Lobus occipitalis",
      "Protoplasmatisches Astrozytom des Lobus occipitalis",
      "Riesenzellglioblastom des Lobus occipitalis"
    ]
  },
  {
    "code": "C71.5",
    "name": "Bösartige Neubildung eines Hirnventrikels",
    "synonyms": [
      "Anaplastisches Astrozytom eines Hirnventrikels",
      "Anaplastisches Chorioidalplexuspapillom",
      "Anaplastisches Ependymom eines Hirnventrikels",
      "Anaplastisches Gangliogliom eines Hirnventrikels",
      "Anaplastisches Oligodendrogliom eines Hirnventrikels",
      "Anaplastisches Papillom des Plexus chorioideus",
      "Astrozytom eines Hirnventrikels",
      "Atypisches Choroidplexuspapillom",
      "Bösartige Neubildung des Ependyms des Gehirns",
      "Bösartige Neubildung des Plexus chorioideus",
      "Bösartige Neubildung eines Hirnventrikels",
      "Bösartige Neubildung zerebraler Ventrikel",
      "Chordoides Gliom",
      "Diffuses Astrozytom eines Hirnventrikels",
      "Ependymoblastom eines Hirnventrikels",
      "Ependymom eines Hirnventrikels",
      "Gehirnventrikelkarzinom",
      "Gehirnventrikelkrebs",
      "Glioblastom eines Hirnventrikels",
      "Malignes Chorioidalplexuspapillom",
      "Malignes Papillom des Plexus chorioideus",
      "Malignes Teratom eines Hirnventrikels",
      "Oligodendrogliom eines Hirnventrikels",
      "Pilomyxoides Astrozytom eines Hirnventrikels",
      "Pilozytisches Astrozytom eines Hirnventrikels",
      "Pleomorphes Xanthoastrozytom eines Hirnventrikels",
      "Plexuskarzinom",
      "Primitiver neuroektodermaler Tumor eines Hirnventrikels",
      "RELA-Fusion-positives Ependymom"
    ]
  },
  {
    "code": "C71.6",
    "name": "Medullomyoblastom",
    "synonyms": [
      "Anaplastisches Astrozytom des Kleinhirns",
      "Anaplastisches Gangliogliom des Kleinhirns",
      "Anaplastisches Medulloblastom",
      "Anaplastisches Oligoastrozytom des Kleinhirns",
      "Anaplastisches Oligodendrogliom des Kleinhirns",
      "Astroblastom des Kleinhirns",
      "Bösartige Neubildung des Kleinhirnbrückenwinkels",
      "Bösartige Neubildung des Kleinhirns",
      "Bösartige Neubildung des Kleinhirnwurms",
      "Bösartige Neubildung des Vermis cerebelli",
      "Bösartige Neubildung des Zerebellums",
      "Bösartiges Kleinhirnbrückenwinkelchordom",
      "Bösartiges Kleinhirngliom",
      "Desmoplastisches Medulloblastom",
      "Diffuses Astrozytom des Kleinhirns",
      "Germinom des Kleinhirns",
      "Glioblastom des Kleinhirns",
      "Gliosarkom des Kleinhirns",
      "Großzelliges Medulloblastom",
      "Klassisches Medulloblastom",
      "Kleinhirngliom",
      "Kleinhirnkarzinom",
      "Kleinhirnkrebs",
      "Malignes Teratom des Zerebellums",
      "Medulloblastom",
      "Medulloblastom mit extensiver Nodularität",
      "Medulloepitheliom des Kleinhirns",
      "Medullomyoblastom",
      "Oligoastrozytischer Tumor des Kleinhirns",
      "Oligoastrozytom des Kleinhirns",
      "Oligodendrogliom des Kleinhirns",
      "Pilomyxoides Astrozytom des Kleinhirns",
      "Pilozytisches Astrozytom des Kleinhirns",
      "Pleomorphes Xanthoastrozytom des Kleinhirns",
      "Primitiver neuroektodermaler Tumor des Kleinhirns",
      "Protoplasmatisches Astrozytom des Kleinhirns",
      "Riesenzellglioblastom des Kleinhirns",
      "Sarcoma cerebelli",
      "Umschriebenes Kleinhirnsarkom",
      "Umschriebenes arachnoidales Zerebellarsarkom",
      "Zerebellares Astrozytom",
      "Zerebellarsarkom"
    ]
  },
  {
    "code": "C71.7",
    "name": "Hirnstammgliom",
    "synonyms": [
      "Anaplastisches Astrozytom des Hirnstamms",
      "Anaplastisches Ependymom des vierten Ventrikels",
      "Anaplastisches Gangliogliom des Hirnstamms",
      "Anaplastisches Gangliogliom des vierten Ventrikels",
      "Anaplastisches Oligoastrozytom des Hirnstamms",
      "Anaplastisches Oligodendrogliom des Hirnstamms",
      "Anaplastisches Oligodendrogliom des vierten Ventrikels",
      "Astroblastom des Hirnstamms",
      "Astrozytom der Medulla oblongata",
      "Astrozytom des Hirnstamms",
      "Bösartige Neubildung der Medulla oblongata",
      "Bösartige Neubildung der Oliva",
      "Bösartige Neubildung der Pyramis medullae oblongatae",
      "Bösartige Neubildung des Hirnstamms",
      "Bösartige Neubildung des Mittelhirns",
      "Bösartige Neubildung des Pedunculus",
      "Bösartige Neubildung des Pedunculus cerebri",
      "Bösartige Neubildung des Plexus chorioideus des vierten Ventrikels",
      "Bösartige Neubildung des Pons Varoli",
      "Bösartige Neubildung des vierten Ventrikels",
      "Bösartige infratentorielle Neubildung",
      "Diffuses Astrozytom des Hirnstamms",
      "Diffuses intrinsisches Ponsgliom",
      "Ependymoblastom des vierten Ventrikels",
      "Ependymom des vierten Ventrikels",
      "Glioblastom des Hirnstamms",
      "Gliosarkom des Hirnstamms",
      "Hirnstammgliom",
      "Hirnstammkarzinom",
      "Hirnstammkrebs",
      "Malignes Teratom des Hirnstamms",
      "Medulloepitheliom des Hirnstamms",
      "Oligoastrozytischer Tumor des Hirnstamms",
      "Oligoastrozytom des Hirnstamms",
      "Oligodendrogliom des Hirnstamms",
      "Oligodendrogliom des vierten Ventrikels",
      "Pilomyxoides Astrozytom des Hirnstamms",
      "Pilomyxoides Astrozytom des vierten Ventrikels",
      "Pilozytisches Astrozytom des vierten Ventrikels",
      "Pleomorphes Xanthoastrozytom des vierten Ventrikels",
      "Primitiver neuroektodermaler Tumor des vierten Ventrikels",
      "Protoplasmatisches Astrozytom des Hirnstamms",
      "Riesenzellglioblastom des Hirnstamms"
    ]
  },
  {
    "code": "C71.8",
    "name": "Bösartige Neubildung des Corpus callosum",
    "synonyms": [
      "Anaplastisches Astrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Anaplastisches Gangliogliom des Gehirns, mehrere Teilbereiche überlappend",
      "Anaplastisches Oligoastrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Anaplastisches Oligodendrogliom des Gehirns, mehrere Teilbereiche überlappend",
      "Astroblastom des Gehirns, mehrere Teilbereiche überlappend",
      "Astrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Bösartige Neubildung des Corpus callosum",
      "Bösartige Neubildung des Tapetum cerebri",
      "Diffuses Astrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Ependymoblastom des Gehirns, mehrere Teilbereiche überlappend",
      "Ependymom des Gehirns, mehrere Teilbereiche überlappend",
      "Glioblastom des Gehirns, mehrere Teilbereiche überlappend",
      "Gliosarkom des Gehirns, mehrere Teilbereiche überlappend",
      "Malignes Gliom des Gehirns, mehrere Teilbereiche überlappend",
      "Malignes Teratom des Gehirns, mehrere Teilbereiche überlappend",
      "Medulloepitheliom des Gehirns, mehrere Teilbereiche überlappend",
      "Oligoastrozytischer Tumor des Gehirns, mehrere Teilbereiche überlappend",
      "Oligoastrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Oligodendrogliom des Gehirns, mehrere Teilbereiche überlappend",
      "Pilomyxoides Astrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Pilozytisches Astrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Pleomorphes Xanthoastrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Primitiver neuroektodermaler Tumor des Gehirns, mehrere Teilbereiche überlappend",
      "Protoplasmatisches Astrozytom des Gehirns, mehrere Teilbereiche überlappend",
      "Riesenzellglioblastom des Gehirns, mehrere Teilbereiche überlappend"
    ]
  },
  {
    "code": "C71.9",
    "name": "Amöboidzellengliom",
    "synonyms": [
      "Adenogliom [Ependymom]",
      "Amöboidzellengliom",
      "Anaplastisches Astrozytom",
      "Anaplastisches Ependymom",
      "Anaplastisches Gangliogliom",
      "Anaplastisches Oligoastrozytom",
      "Anaplastisches Oligodendrogliom",
      "Angiozentrisches Gliom",
      "Astroblastom",
      "Astrocytoma",
      "Astrocytoma cysticum",
      "Astrocytoma juvenile",
      "Astrocytoma pilocyticum",
      "Astrocytoma piloides",
      "Astrogangliozytom",
      "Astrogliom",
      "Astrozytom",
      "Astrozytäres Gliom",
      "Blastom",
      "Blastoma ependymale",
      "Buntes Gliom",
      "Bösartige Neubildung des Gehirns",
      "Bösartige Neubildung in der Fossa cranii",
      "Bösartige Neubildung in der hinteren Schädelgrube",
      "Bösartige Neubildung in einer kranialen Fossa",
      "Bösartiger Gehirntumor",
      "Bösartiger Hirntumor",
      "Bösartiges Gliom",
      "Bösartiges Großhirngliom",
      "Diffuses Astrozytom",
      "Diffuses Gliom",
      "Ependymales Glioblastom",
      "Ependymepitheliom",
      "Ependymgliom",
      "Ependymoblastom",
      "Ependymom",
      "Ependymom des Gehirns",
      "Ependymozytom",
      "Epitheliales Ependymom",
      "Fibrilläres Astrozytom",
      "Fibröses Astrozytom",
      "Gehirngliom",
      "Gehirnkarzinom",
      "Gehirnmalignom",
      "Gemischtes Gliom",
      "Gemischtzelliges Astrozytom",
      "Gemistozytisches Astrozytom",
      "Gemistozytom",
      "Glioblastisches Sarkom",
      "Glioblastom",
      "Glioblastom des Gehirns",
      "Glioblastom mit sarkomatöser Komponente",
      "Glioblastoma",
      "Glioblastoma gigantocellulare",
      "Glioblastoma multiforme",
      "Glioependymom",
      "Gliom",
      "Glioma",
      "Glioma durum",
      "Glioma multiforme",
      "Glioma sarcomatodes",
      "Gliosarkom",
      "Gliozytom",
      "Großhirngliom",
      "Hirngliom",
      "Hirnkarzinom",
      "Intrakranielle bösartige Neubildung",
      "Krebs des Gehirns",
      "Maligner Hirntumor",
      "Malignes Astrozytom",
      "Malignes Ependymom",
      "Malignes Gliom",
      "Malignes Teratom des Gehirns",
      "Mikrozelluläres Gliom",
      "Mittelhirngliom",
      "Monstrozelluläres Sarkom",
      "Neuroepitheliom",
      "Oligoastrozytischer Tumor",
      "Oligoastrozytom",
      "Oligodendroblastom",
      "Oligodendroglialer Tumor",
      "Oligodendrogliom",
      "Pfeilerzellgliom",
      "Pilomyxoides Astrozytom",
      "Pilozytisches Astrozytom",
      "Pinselzellgliom",
      "Pleomorphes Xanthoastrozytom",
      "Polymorphes Gliom",
      "Polymorphes Spongioblastom",
      "Primitiver neuroektodermaler Tumor des Gehirns",
      "Primitives polares Spongioblastom",
      "Protoplasmatisches Astrozytom",
      "Protoplasmisches Astrozytom",
      "Riesenzellglioblastom",
      "Rundzellengliom",
      "Sarcoma angiolithicum",
      "Schmetterlingsgliom",
      "Spinnenzellgliom",
      "Spongioblastoma multiforme",
      "Spongioblastoma polare",
      "Sternzellgliom",
      "Supraselläre bösartige Neubildung",
      "Supraselläres Germinom",
      "Xanthoastrozytom",
      "Zerebrales Gliom",
      "Zerebrales Malignom",
      "Zystisches Astrozytom"
    ]
  },
  {
    "code": "C72.0",
    "name": "Bösartige Neubildung des Rückenmarks",
    "synonyms": [
      "Anaplastisches Ependymom des Rückenmarks",
      "Bösartige Neubildung des Conus medullaris",
      "Bösartige Neubildung des Filum terminale",
      "Bösartige Neubildung des Rückenmarks",
      "Ependymom des Rückenmarks",
      "Primitiver neuroektodermaler Tumor des Rückenmarks",
      "Rückenmarkkarzinom",
      "Rückenmarkkrebs"
    ]
  },
  {
    "code": "C72.1",
    "name": "Bösartige Neubildung der Cauda equina",
    "synonyms": [
      "Bösartige Neubildung der Cauda equina"
    ]
  },
  {
    "code": "C72.2",
    "name": "Bösartige Neubildung der Nervi olfactorii",
    "synonyms": [
      "Bösartige Neubildung der Nervi olfactorii",
      "Bösartige Neubildung des Bulbus olfactorius"
    ]
  },
  {
    "code": "C72.3",
    "name": "Bösartige Neubildung des Nervus opticus",
    "synonyms": [
      "Bösartige Neubildung des Chiasma opticum",
      "Bösartige Neubildung des Nervus opticus",
      "Bösartige Neubildung des Sehnerven",
      "Bösartige Neubildung des Sehtraktes",
      "Bösartige Neubildung des Tractus opticus",
      "Maligner Optikustumor",
      "Medulloepitheliom des Sehnerven"
    ]
  },
  {
    "code": "C72.4",
    "name": "Bösartige Neubildung des Nervus vestibulocochlearis",
    "synonyms": [
      "Bösartige Neubildung der Pars cochlearis des Nervus vestibulocochlearis",
      "Bösartige Neubildung des Gehörnerven",
      "Bösartige Neubildung des Nervus acusticus",
      "Bösartige Neubildung des Nervus vestibulocochlearis",
      "Bösartiges Akustikusneurilemmom"
    ]
  },
  {
    "code": "C72.5",
    "name": "Maligner Hirnnerventumor",
    "synonyms": [
      "Bösartige Neubildung der Nervi craniales a.n.k.",
      "Bösartige Neubildung des Nervus abducens",
      "Bösartige Neubildung des Nervus facialis",
      "Bösartige Neubildung des Nervus glossopharyngeus",
      "Bösartige Neubildung des Nervus hypoglossus",
      "Bösartige Neubildung des Nervus oculomotorius",
      "Bösartige Neubildung des Nervus trigeminus",
      "Bösartige Neubildung des Nervus trochlearis",
      "Bösartige Neubildung des Nervus vagus",
      "Bösartige Neubildung des spinalen Nervus accessorius",
      "Bösartige Neubildung eines Hirnnerven",
      "Hirnnervenkarzinom",
      "Hirnnervenkrebs",
      "Maligner Hirnnerventumor",
      "Primitiver neuroektodermaler Tumor eines Hirnnerven"
    ]
  },
  {
    "code": "C72.9",
    "name": "Krebs des Nervensystems",
    "synonyms": [
      "Atypischer Rhabdoid-Teratoid-Tumor",
      "Bösartige Neubildung des Nervensystems",
      "Bösartige Neubildung des Zentralnervensystems",
      "Choriokarzinom des Zentralnervensystems",
      "Dottersacktumor des Zentralnervensystems",
      "Embryonaler Tumor des neuroepithelialen Gewebes",
      "Embryonalkarzinom des Zentralnervensystems",
      "Epidurale bösartige Neubildung",
      "Gemischter Keimzelltumor des Zentralnervensystems",
      "Germinom des Zentralnervensystems",
      "Glioblastom des Nervensystems",
      "Karzinom des Nervensystems",
      "Krebs des Nervensystems",
      "Malignes Teratom des Zentralnervensystems",
      "Medulloepitheliom des Zentralnervensystems",
      "Paraselläre bösartige Neubildung",
      "Primitiver neuroektodermaler Tumor des Zentralnervensystems",
      "Primäres Melanom des Zentralnervensystems",
      "ZNS-PNET [Primitiver neuroektodermaler Tumor des Zentralnervensystems]"
    ]
  },
  {
    "code": "C73",
    "name": "Langhans-Struma",
    "synonyms": [
      "Adenokarzinom der Hürthle-Zellen",
      "Anaplastisches Schilddrüsenkarzinom",
      "Angiosarkom der Schilddrüse",
      "Bösartige Neubildung der Schilddrüse",
      "Bösartige Neubildung der Thyreoidea",
      "Bösartige Neubildung des Ductus thyreoglossus",
      "Bösartiger Hürthle-Zell-Tumor",
      "Bösartiger Kropf",
      "C-Zell-Karzinom",
      "Familiäres follikuläres Schilddrüsenkarzinom",
      "Familiäres medulläres Schilddrüsenkarzinom",
      "Familiäres nicht-medulläres Schilddrüsenkarzinom",
      "Familiäres papilläres Schilddrüsenkarzinom",
      "Follikuläre Variante des papillären Adenokarzinoms",
      "Follikuläre Variante des papillären Karzinoms",
      "Follikuläres Adenokarzinom der Schilddrüse",
      "Follikuläres Adenokarzinom vom gut differenzierten Typ",
      "Follikuläres Adenokarzinom vom mäßig differenzierten Typ",
      "Follikuläres Adenokarzinom vom trabekulären Typ",
      "Follikuläres Karzinom der Schilddrüse",
      "Follikuläres Karzinom vom gut differenzierten Typ",
      "Follikuläres Karzinom vom mäßig differenzierten Typ",
      "Follikuläres Karzinom vom trabekulären Typ",
      "Gemischt papilläres und follikuläres Adenokarzinom",
      "Gemischt papilläres und follikuläres Karzinom",
      "Graham-Tumor",
      "Hürthle-Zell-Karzinom",
      "Langhans-Struma",
      "Maligne Struma",
      "Medulläres Schilddrüsenkarzinom",
      "Nichtabgekapselter sklerosierender Tumor der Schilddrüse",
      "Papilläres Schilddrüsenkarzinom",
      "Parafollikuläres Karzinom der Schilddrüse",
      "SD-Karzinom",
      "Schilddrüsenkarzinom",
      "Schilddrüsenkrebs",
      "Schilddrüsenmalignom",
      "Sklerosierendes nichtabgekapseltes Adenokarzinom der Schilddrüse",
      "Struma maligna",
      "Wuchernde Langhans-Struma"
    ]
  },
  {
    "code": "C74.0",
    "name": "Maligner Nebennierenrindentumor",
    "synonyms": [
      "Adenokarzinom der Nebennierenrinde",
      "Adrenokortikales Karzinom",
      "Bösartige Neubildung der Nebennierenrinde",
      "Karzinom der Nebennierenrinde",
      "Maligner Nebennierenrindentumor"
    ]
  },
  {
    "code": "C74.1",
    "name": "Phäochromoblastom",
    "synonyms": [
      "Bösartige Neubildung der Medulla glandulae suprarenalis",
      "Bösartige Neubildung des Nebennierenmarks",
      "Ganglioneuroblastom des Nebennierenmarks",
      "Malignes Phäochromozytom",
      "Malignes familiäres Phäochromozytom",
      "Malignes sporadisches Phäochromozytom",
      "Neuroblastom des Nebennierenmarks",
      "Phäochromoblastom"
    ]
  },
  {
    "code": "C74.9",
    "name": "Maligner Nebennierentumor",
    "synonyms": [
      "Bösartige Neubildung der Glandula suprarenalis",
      "Bösartige Neubildung der Nebenniere",
      "Bösartige Neubildung der Nebennierenkapsel",
      "Bösartige Neubildung einer Nebennierendrüse",
      "Karzinom der Glandula suprarenalis",
      "Krebs der Glandula suprarenalis",
      "Maligner Nebennierentumor",
      "Nebennierenkarzinom",
      "Nebennierenkrebs",
      "Nebennierenneuroblastom",
      "Neuroblastom",
      "Neurogoniom",
      "Sympathikoblastom",
      "Sympathikogoniom"
    ]
  },
  {
    "code": "C75.0",
    "name": "Karzinom der Glandula parathyreoidea",
    "synonyms": [
      "Bösartige Neubildung der Epithelkörperchen",
      "Bösartige Neubildung der Glandula parathyreoidea",
      "Bösartige Neubildung der Nebenschilddrüse",
      "Bösartige Neubildung der Parathyreoidea",
      "Epithelkörperchenkrebs",
      "Karzinom der Epithelkörperchen",
      "Karzinom der Glandula parathyreoidea",
      "Karzinom der Nebenschilddrüse",
      "Krebs der Glandula parathyreoidea",
      "Nebenschilddrüsenkrebs",
      "Wasserhellzelliges Adenokarzinom der Nebenschilddrüse",
      "Wasserhellzelliges Karzinom der Nebenschilddrüse"
    ]
  },
  {
    "code": "C75.1",
    "name": "Hypophysenmalignom",
    "synonyms": [
      "Azidophiles Adenokarzinom",
      "Azidophiles Adenokarzinom der Hypophyse",
      "Azidophiles Karzinom",
      "Azidophiles Karzinom der Hypophyse",
      "Baso-eosinophiles Karzinom",
      "Baso-eosinophiles Karzinom der Hypophyse",
      "Basophiles Adenokarzinom",
      "Basophiles Adenokarzinom der Hypophyse",
      "Basophiles Karzinom",
      "Basophiles Karzinom der Hypophyse",
      "Bösartige Neubildung der Glandula pituitaria",
      "Bösartige Neubildung der Hypophyse",
      "Bösartige Neubildung der Rathke-Tasche",
      "Bösartige Neubildung des Hirnanhanges",
      "Bösartige Neubildung in der Fossa pituitaria",
      "Chromophobes Adenokarzinom",
      "Chromophobes Adenokarzinom der Hypophyse",
      "Chromophobes Karzinom",
      "Chromophobes Karzinom der Hypophyse",
      "Eosinophiles Adenokarzinom",
      "Eosinophiles Adenokarzinom der Hypophyse",
      "Eosinophiles Karzinom",
      "Eosinophiles Karzinom der Hypophyse",
      "Gemischtes azido-basophiles Karzinom",
      "Gemischtes azido-basophiles Karzinom der Hypophyse",
      "Gemischtes baso-azidophiles Karzinom",
      "Gemischtes baso-azidophiles Karzinom der Hypophyse",
      "Hypophysenkarzinom",
      "Hypophysenkrebs",
      "Hypophysenmalignom",
      "Intraselläre bösartige Neubildung",
      "Karzinom der Glandula pituitaria",
      "Krebs der Glandula pituitaria",
      "Mukoidzelladenokarzinom",
      "Mukoidzelladenokarzinom der Hypophyse",
      "Mukoidzellkarzinom",
      "Mukoidzellkarzinom der Hypophyse"
    ]
  },
  {
    "code": "C75.2",
    "name": "Krebs des kraniopharyngealen Ganges",
    "synonyms": [
      "Bösartige Neubildung des Ductus craniopharyngealis",
      "Bösartige Neubildung des kraniopharyngealen Ganges",
      "Karzinom des kraniopharyngealen Ganges",
      "Krebs des kraniopharyngealen Ganges"
    ]
  },
  {
    "code": "C75.3",
    "name": "Pinealoblastom",
    "synonyms": [
      "Bösartige Neubildung der Epiphyse",
      "Bösartige Neubildung der Zirbeldrüse",
      "Bösartige Neubildung des Corpus pineale",
      "Chorionkarzinom der Zirbeldrüse",
      "Germinom der Pinealisregion",
      "Karzinom des Corpus pineale",
      "Krebs des Corpus pineale",
      "Malignes Pinealom",
      "Pinealoblastom",
      "Pineoblastom",
      "Zirbeldrüsenkarzinom",
      "Zirbeldrüsenkrebs"
    ]
  },
  {
    "code": "C75.4",
    "name": "Bösartige Neubildung des Glomus caroticum",
    "synonyms": [
      "Bösartige Neubildung der Karotisdrüse",
      "Bösartige Neubildung des Glomus caroticum",
      "Karotisdrüsenkrebs",
      "Karzinom des Glomus caroticum",
      "Krebs des Glomus caroticum"
    ]
  },
  {
    "code": "C75.5",
    "name": "Bösartige Neubildung der Paraganglien",
    "synonyms": [
      "Bösartige Neubildung der Paraganglien",
      "Bösartige Neubildung des Glomus jugulare",
      "Bösartige Neubildung des Glomus tympanicum",
      "Bösartige Neubildung des Paraganglion aorticum abdominale a.n.k.",
      "Bösartige Neubildung des Zuckerkandl-Organs",
      "Bösartiges Paragangliom",
      "Malignes Paragangliom des Glomus aorticum",
      "Malignes familiäres Paragangliom",
      "Paraganglienkarzinom",
      "Paraganglienkrebs",
      "Paraganglioma malignum"
    ]
  },
  {
    "code": "C75.8",
    "name": "Bösartige Neubildung der pluriglandulären endokrinen Drüsen a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der pluriglandulären endokrinen Drüsen a.n.k.",
      "Polyglanduläre bösartige Neubildung"
    ]
  },
  {
    "code": "C75.9",
    "name": "Karzinom einer endokrinen Drüse",
    "synonyms": [
      "Bösartige Neubildung endokriner Drüsen",
      "Endokrines Karzinom",
      "Karzinom einer endokrinen Drüse",
      "Krebs einer endokrinen Drüse"
    ]
  },
  {
    "code": "C76.0",
    "name": "Wangenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Mandibula",
      "Bösartige Neubildung der Nase",
      "Bösartige Neubildung der Supraklavikulargrube",
      "Bösartige Neubildung der Temporalregion",
      "Bösartige Neubildung der Wange",
      "Bösartige Neubildung der Zervikalregion",
      "Bösartige Neubildung des Gesichts",
      "Bösartige Neubildung des Halses",
      "Bösartige Neubildung des Kiefers",
      "Bösartige Neubildung des Kopfes",
      "Gesichtskarzinom",
      "Halskarzinom",
      "Karzinom des Kopfes",
      "Kieferkarzinom",
      "Mandibulakarzinom",
      "Nasenkarzinom",
      "Oberkieferkarzinom",
      "Ohrkarzinom",
      "Submentale bösartige Neubildung",
      "Unterkieferkarzinom",
      "Wangenkarzinom"
    ]
  },
  {
    "code": "C76.1",
    "name": "Axillakarzinom",
    "synonyms": [
      "Axillakarzinom",
      "Bösartige Neubildung der Achselhöhle",
      "Bösartige Neubildung der Axilla",
      "Bösartige Neubildung der Brustwand a.n.k.",
      "Bösartige Neubildung der Regio scapularis",
      "Bösartige Neubildung der Schulterblattregion",
      "Bösartige Neubildung der intrathorakalen Organe",
      "Bösartige Neubildung des Thorax",
      "Bösartige intrathorakale Neubildung",
      "Bösartige thorakale Neubildung",
      "Infraklavikuläre bösartige Neubildung",
      "Karzinom der Achselhöhle",
      "Krebs der Achselhöhle",
      "Thoraxkarzinom",
      "Thoraxkrebs"
    ]
  },
  {
    "code": "C76.2",
    "name": "Bösartige Neubildung der Baucheingeweide",
    "synonyms": [
      "Abdomenkarzinom",
      "Abdomenmalignom",
      "Adenokarzinom des Unterbauches",
      "Baucheingeweidekarzinom",
      "Baucheingeweidemalignom",
      "Bauchkarzinom",
      "Bauchmalignom",
      "Bauchraumkarzinom",
      "Bösartige Neubildung der Baucheingeweide",
      "Bösartige Neubildung der Bauchhöhle",
      "Bösartige Neubildung der Bauchorgane",
      "Bösartige Neubildung des Abdomens",
      "Bösartige Neubildung des Bauches",
      "Bösartige Neubildung des Oberbauches",
      "Bösartige Neubildung des Unterbauches",
      "Intraabdominale bösartige Neubildung",
      "Intraabdominales Karzinom",
      "Unterbauchkarzinom"
    ]
  },
  {
    "code": "C76.3",
    "name": "Paraurethrales malignes Ulkus",
    "synonyms": [
      "Adenokarzinom des kleinen Beckens",
      "Beckenkarzinom",
      "Bösartige Neubildung der Beckenorgane",
      "Bösartige Neubildung der Beckenwand",
      "Bösartige Neubildung der Fossa ischiorectalis",
      "Bösartige Neubildung der Glutäalregion",
      "Bösartige Neubildung der Kreuzbeingegend",
      "Bösartige Neubildung der Leistenbeuge a.n.k.",
      "Bösartige Neubildung der Leistengegend",
      "Bösartige Neubildung der rektovaginalen Wand",
      "Bösartige Neubildung des Beckenbodens",
      "Bösartige Neubildung des Beckens",
      "Bösartige Neubildung des Dammes",
      "Bösartige Neubildung des Gesäßes a.n.k.",
      "Bösartige Neubildung des Perineums",
      "Bösartige Neubildung des Septum rectovaginale",
      "Bösartige Neubildung des Septum rectovesicale",
      "Bösartige Neubildung des periurethralen Gewebes",
      "Bösartige Neubildung des rektovaginalen Septums",
      "Bösartige Neubildung des rektovesikalen Septums",
      "Bösartige rektovaginale Neubildung",
      "Bösartige rektovesikale Neubildung",
      "Dammkarzinom",
      "Extrarektale bösartige Neubildung",
      "Ischiorektale bösartige Neubildung",
      "Leistenkarzinom",
      "Pararektale bösartige Neubildung",
      "Paraurethrale bösartige Neubildung",
      "Paraurethrales malignes Ulkus",
      "Paravaginale bösartige Neubildung",
      "Perirektale bösartige Neubildung",
      "Präsakrale bösartige Neubildung",
      "Rektovaginales Karzinom",
      "Rektovesikales Karzinom",
      "Retrovesikale bösartige Neubildung",
      "Unterleibkarzinom",
      "Unterleibmalignom",
      "Vesikorektale Neubildung",
      "Vesikorektales Karzinom"
    ]
  },
  {
    "code": "C76.4",
    "name": "Armkarzinom",
    "synonyms": [
      "Armkarzinom",
      "Bösartige Neubildung der Hand a.n.k.",
      "Bösartige Neubildung der Schulter a.n.k.",
      "Bösartige Neubildung der oberen Extremität",
      "Bösartige Neubildung der oberen Gliedmaßen",
      "Bösartige Neubildung des Arms a.n.k.",
      "Bösartige Neubildung des Daumens a.n.k.",
      "Bösartige Neubildung des Ellenbogens a.n.k.",
      "Bösartige Neubildung des Handgelenks a.n.k.",
      "Bösartige Neubildung des Unterarms a.n.k.",
      "Bösartige Neubildung eines Fingers a.n.k.",
      "Krebs der oberen Gliedmaßen",
      "Oberarmkarzinom"
    ]
  },
  {
    "code": "C76.5",
    "name": "Bösartige Neubildung der unteren Gliedmaßen",
    "synonyms": [
      "Beinkarzinom",
      "Bösartige Neubildung der Ferse a.n.k.",
      "Bösartige Neubildung der Hüfte a.n.k.",
      "Bösartige Neubildung der Kniekehle",
      "Bösartige Neubildung der Wade",
      "Bösartige Neubildung der unteren Extremität",
      "Bösartige Neubildung der unteren Gliedmaßen",
      "Bösartige Neubildung des Beins a.n.k.",
      "Bösartige Neubildung des Fußes a.n.k.",
      "Bösartige Neubildung des Knies a.n.k.",
      "Bösartige Neubildung des Knöchels a.n.k.",
      "Bösartige Neubildung des Oberschenkels a.n.k.",
      "Bösartige Neubildung einer Zehe a.n.k.",
      "Krebs der unteren Gliedmaßen",
      "Unterschenkelkarzinom"
    ]
  },
  {
    "code": "C76.7",
    "name": "Flankenkarzinom",
    "synonyms": [
      "Bösartige Neubildung der Eingeweide a.n.k.",
      "Bösartige Neubildung der Flanke a.n.k.",
      "Bösartige Neubildung der Gliedmaßen",
      "Bösartige Neubildung des Rumpfes a.n.k.",
      "Bösartige Neubildung des Rückens a.n.k.",
      "Bösartige Neubildung einer Extremität",
      "Flankenkarzinom"
    ]
  },
  {
    "code": "C76.8",
    "name": "Abdominopelvine bösartige Neubildung",
    "synonyms": [
      "Abdominopelvine bösartige Neubildung",
      "Pelvikoabdominale bösartige Neubildung"
    ]
  },
  {
    "code": "C77.0",
    "name": "Lymphknotenmetastase am Hals bei unbekanntem Primärtumor",
    "synonyms": [
      "Aurikuläre Lymphknotenmetastase",
      "Bösartige Neubildung supraklavikulärer Lymphknoten",
      "Jugulare Lymphknotenmetastase",
      "Lymphknotenmetastase am Gesicht",
      "Lymphknotenmetastase am Hals",
      "Lymphknotenmetastase am Hals bei unbekanntem Primärtumor",
      "Lymphknotenmetastase am Kopf",
      "Lymphknotenmetastase am Nacken",
      "Lymphknotenmetastase an der Parotis",
      "Mandibuläre Lymphknotenmetastase",
      "Metastase an den Skalenus-Lymphknoten",
      "Metastase an der Virchow-Drüse",
      "Nuchale Lymphknotenmetastase",
      "Okzipitale Lymphknotenmetastase",
      "Präaurikuläre Lymphknotenmetastase",
      "Prälaryngeale Lymphknotenmetastase",
      "Prätracheale Lymphknotenmetastase",
      "Retroaurikuläre Lymphknotenmetastase",
      "Sublinguale Lymphknotenmetastase",
      "Submandibuläre Lymphknotenmetastase",
      "Submaxilläre Lymphknotenmetastase",
      "Submentale Lymphknotenmetastase",
      "Supraklavikuläre Lymphknotenmetastase",
      "Zervikale Lymphknotenmetastase",
      "Zervikofaziale Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.1",
    "name": "Hiluslymphknotenmetastase",
    "synonyms": [
      "Bronchiale Lymphknotenmetastase",
      "Bronchopulmonale Lymphknotenmetastase",
      "Diaphragmale Lymphknotenmetastase",
      "Hiluslymphknotenmetastase",
      "Interkostale Lymphknotenmetastase",
      "Intrathorakale Lymphknotenmetastase",
      "Lymphknotenmetastase am Lungenhilus",
      "Lymphknotenmetastase am Mediastinum",
      "Lymphknotenmetastase an der Lunge",
      "Mediastinale Lymphknotenmetastase",
      "Metastase an den Lymphknoten des Zwerchfells",
      "Parasternale Lymphknotenmetastase",
      "Thorakale Lymphknotenmetastase",
      "Tracheale Lymphknotenmetastase",
      "Tracheobronchiale Lymphknotenmetastase",
      "Ösophageale Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.2",
    "name": "Intraabdominale Lymphknotenmetastase",
    "synonyms": [
      "Abdominale Lymphknotenmetastase",
      "Abdominale aortale Lymphknotenmetastase",
      "Abdominale paraaortale Lymphknotenmetastase",
      "Abdominale periaortale Lymphknotenmetastase",
      "Hepatische Lymphknotenmetastase",
      "Intestinale Lymphknotenmetastase",
      "Intraabdominale Lymphknotenmetastase",
      "Lumbale Lymphknotenmetastase",
      "Lymphknotenmetastase am Abdomen",
      "Lymphknotenmetastase am Gallengang",
      "Lymphknotenmetastase am Ileum",
      "Lymphknotenmetastase am Kolon",
      "Lymphknotenmetastase am Magen",
      "Lymphknotenmetastase am Mesokolon",
      "Lymphknotenmetastase am Pankreas",
      "Lymphknotenmetastase am Pylorus",
      "Lymphknotenmetastase an der Leber",
      "Lymphknotenmetastase an der Milz",
      "Lymphknotenmetastase an der Pfortader",
      "Lymphknotenmetastase an der Porta hepatis",
      "Mesenteriale Lymphknotenmetastase",
      "Peripankreatische Lymphknotenmetastase",
      "Portale Lymphknotenmetastase",
      "Retroperitoneale Lymphknotenmetastase",
      "Zöliakale Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.3",
    "name": "Bösartige Neubildung pektoraler Lymphknoten",
    "synonyms": [
      "Axilläre Lymphknotenmetastase",
      "Axilläres Lymphknotenkarzinom",
      "Brachiale Lymphknotenmetastase",
      "Bösartige Neubildung pektoraler Lymphknoten",
      "Epitrochleäre Lymphknotenmetastase",
      "Infraklavikuläre Lymphknotenmetastase",
      "Kubitale Lymphknotenmetastase",
      "Lymphknotenmetastase am Arm",
      "Lymphknotenmetastase an den oberen Gliedmaßen",
      "Pektorale Lymphknotenmetastase",
      "Subklavikuläre Lymphknotenmetastase",
      "Subskapuläre Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.4",
    "name": "Lymphknotenmetastase an der Leistenbeuge",
    "synonyms": [
      "Femorale Lymphknotenmetastase",
      "Inguinale Lymphknotenmetastase",
      "Lymphknotenmetastase am Anulus femoralis",
      "Lymphknotenmetastase am Bein",
      "Lymphknotenmetastase an den unteren Gliedmaßen",
      "Lymphknotenmetastase an der Leistenbeuge",
      "Metastase am Cloquet-Knoten",
      "Popliteale Lymphknotenmetastase",
      "Subinguinale Lymphknotenmetastase",
      "Tibiale Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.5",
    "name": "Lymphknotenmetastase am Becken",
    "synonyms": [
      "Iliakale Lymphknotenmetastase",
      "Inferiore epigastrische Lymphknotenmetastase",
      "Lymphknotenmetastase am Becken",
      "Lymphknotenmetastase am Foramen obturatum",
      "Lymphknotenmetastase am Hypogastrium",
      "Lymphknotenmetastase am Parametrium",
      "Parauterine Lymphknotenmetastase",
      "Paravaginale Lymphknotenmetastase",
      "Parazervikale Lymphknotenmetastase",
      "Pelvine Lymphknotenmetastase",
      "Präsymphyseale Lymphknotenmetastase",
      "Sakrale Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.8",
    "name": "Retroperitoneale inguinale Lymphknotenmetastase",
    "synonyms": [
      "Retroperitoneale inguinale Lymphknotenmetastase"
    ]
  },
  {
    "code": "C77.9",
    "name": "Bösartige Neubildung der Lymphknoten",
    "synonyms": [
      "Bösartige Neubildung der Lymphknoten",
      "Lymphknotenfiliae",
      "Lymphknotenkarzinom",
      "Lymphknotenmetastase",
      "Lymphogene Metastasierung"
    ]
  },
  {
    "code": "C78.0",
    "name": "Lungenmetastase",
    "synonyms": [
      "Bronchiale Metastase",
      "Bronchiogene Metastase",
      "Bronchiolenmetastase",
      "Bronchusmetastase",
      "Hauptbronchusmetastase",
      "Lungenabsiedelung eines Tumors",
      "Lungenfiliae",
      "Lungenhilusmetastase",
      "Lungenmetastase",
      "Lungenmetastase bei unbekanntem Primärtumor",
      "Lungenmittellappenmetastase",
      "Lungenoberlappenmetastase",
      "Lungenparenchymmetastase",
      "Lungenunterlappenmetastase",
      "Metastase am Bronchialknorpel",
      "Metastase am Hilus pulmonis",
      "Metastase am Lobus inferior pulmonis",
      "Metastase am Lobus lingualis pulmonis",
      "Metastase am Lobus medius pulmonis",
      "Metastase am Lobus superior pulmonis",
      "Metastase am Lobus venae azygos",
      "Metastase an der Carina tracheae",
      "Metastase an der Lingula pulmonis sinistri",
      "Pulmonale Metastase",
      "Subpleurale Metastase",
      "Tracheobronchiale Metastase"
    ]
  },
  {
    "code": "C78.1",
    "name": "Mediastinummetastase",
    "synonyms": [
      "Anteriore Mediastinummetastase",
      "Mediastinale Metastase",
      "Mediastinummetastase",
      "Posteriore Mediastinummetastase",
      "Substernale Metastase"
    ]
  },
  {
    "code": "C78.2",
    "name": "Carcinosis pleurae",
    "synonyms": [
      "Carcinosis pleurae",
      "Metastase an der Pleura parietalis",
      "Metastase an der Pleura pulmonalis",
      "Pleurakarzinose",
      "Pleurametastase",
      "Pleuritis carcinomatosa"
    ]
  },
  {
    "code": "C78.3",
    "name": "Metastase am Antrum tympanicum",
    "synonyms": [
      "Aryknorpelmetastase",
      "Atemwegsmetastase a.n.k.",
      "Epiglottismetastase",
      "Glottismetastase",
      "Innenohrmetastase",
      "Kegelknorpelmetastase",
      "Keilbeinhöhlenmetastase",
      "Kieferhöhlenmetastase",
      "Larynxknorpelmetastase a.n.k.",
      "Larynxmetastase a.n.k.",
      "Luftröhrenmetastase",
      "Metastase am Antrum Highmore",
      "Metastase am Antrum maxillaris",
      "Metastase am Antrum tympanicum",
      "Metastase am Aryknorpel",
      "Metastase am Atemsystem a.n.k.",
      "Metastase am Cartilago arytaenoidea",
      "Metastase am Cavum tympani",
      "Metastase am Epiglottisknorpel",
      "Metastase am Gießbeckenknorpel",
      "Metastase am Kehlkopfknorpel",
      "Metastase am Ligamentum vestibulare",
      "Metastase am Ligamentum vocale",
      "Metastase am Luftröhrenknorpel",
      "Metastase am Nasenseptum",
      "Metastase am Nasenvorhof",
      "Metastase am Oberkiefersinus",
      "Metastase am Respirationssystem a.n.k.",
      "Metastase am Respirationstrakt a.n.k.",
      "Metastase am Ringknorpel",
      "Metastase am Schildknorpel",
      "Metastase am Sinus ethmoidalis",
      "Metastase am Sinus frontalis",
      "Metastase am Sinus maxillaris",
      "Metastase am Sinus sphenoidalis",
      "Metastase am Stellknorpel",
      "Metastase am Vestibulum nasi",
      "Metastase am inneren Gehörgang",
      "Metastase am inneren Larynx",
      "Metastase am äußeren Larynx a.n.k.",
      "Metastase an den Atemorganen a.n.k.",
      "Metastase an den Conchae nasales",
      "Metastase an den Nares",
      "Metastase an den Respirationsorganen a.n.k.",
      "Metastase an den falschen Stimmbändern",
      "Metastase an der Eustachi-Röhre",
      "Metastase an der Fossa nasalis",
      "Metastase an der Kehlkopfkommissur",
      "Metastase an der Larynxkommissur",
      "Metastase an der Oberkieferhöhle",
      "Metastase an der Oberkiefernebenhöhle",
      "Metastase an der Plica ventricularis laryngis",
      "Metastase an der Tuba auditiva",
      "Metastase an der hinteren Oberfläche der Epiglottis",
      "Metastase an der inneren Nase",
      "Metastase an der laryngealen Seite der Plica aryepiglottica",
      "Metastase an der laryngealen Seite der aryepiglottischen Falte",
      "Metastase an der suprahyoidalen Epiglottis",
      "Metastase der Mastoidhöhle",
      "Metastase der Sinus paranasales a.n.k.",
      "Metastase in der Siebbeinhöhle",
      "Mittelohrmetastase",
      "Nasenhöhlenmetastase",
      "Nasenknorpelmetastase",
      "Nasenlochmetastase",
      "Nasenmuschelmetastase",
      "Nasenschleimhautmetastase",
      "Nebenhöhlenmetastase",
      "Paukenhöhlenmetastase",
      "Ringknorpelmetastase",
      "Schildknorpelmetastase",
      "Stimmbandmetastase",
      "Stirnhöhlenmetastase",
      "Subglottische Metastase",
      "Supraglottische Metastase",
      "Tracheametastase"
    ]
  },
  {
    "code": "C78.4",
    "name": "Ileummetastase",
    "synonyms": [
      "Duodenalmetastase",
      "Dünndarmmetastase",
      "Ileummetastase",
      "Jejunummetastase",
      "Metastase am duodenojejunalen Übergang",
      "Metastase an einem Meckel-Divertikel"
    ]
  },
  {
    "code": "C78.5",
    "name": "Mastdarmmetastase",
    "synonyms": [
      "Analkanalmetastase",
      "Analsphinktermetastase",
      "Anorektummetastase",
      "Anusmetastase",
      "Appendixmetastase",
      "Darmmetastase",
      "Darmtraktmetastase a.n.k.",
      "Dickdarmmetastase",
      "Distale Kolonmetastase",
      "Ileozäkummetastase",
      "Kloakenmetastase",
      "Kolonmetastase",
      "Mastdarmmetastase",
      "Metastase am Colon ascendens",
      "Metastase am Colon descendens",
      "Metastase am Colon pelvinum",
      "Metastase am Colon sigmoideum",
      "Metastase am Colon transversum",
      "Metastase am Rektosigmoid",
      "Metastase am Sphincter ani",
      "Metastase am anorektalen Übergang",
      "Metastase am ileozäkalen Übergang",
      "Metastase am linken Kolon",
      "Metastase am pelvikorektalen Übergang",
      "Metastase am pelvirektalen Übergang",
      "Metastase am rechten Kolon",
      "Metastase am rektosigmoidalen Übergang",
      "Metastase an Kolon und Rektum",
      "Metastase an den Morgagni-Krypten",
      "Metastase an der Flexura coli dextra",
      "Metastase an der Flexura coli hepatica",
      "Metastase an der Flexura coli lienalis",
      "Metastase an der Flexura coli sigmoidei",
      "Metastase an der Flexura coli sinistra",
      "Metastase an der Hämorrhoidalzone",
      "Metastase an der hepatischen Kolonflexur",
      "Rektummetastase",
      "Sigmametastase",
      "Zäkummetastase"
    ]
  },
  {
    "code": "C78.6",
    "name": "Peritonealkarzinose",
    "synonyms": [
      "Bauchfellmetastase",
      "Bauchnetzmetastase",
      "Carcinosis peritonei",
      "Gallertbauch",
      "Gallertiger Aszites",
      "Mesenteriummetastase",
      "Mesoappendixmetastase",
      "Mesokolonmetastase",
      "Metastase am Beckenperitoneum",
      "Metastase am Omentum",
      "Metastase am parietalen Peritoneum",
      "Metastase am retroperitonealen Bindegewebe a.n.k.",
      "Metastase an der rektouterinen Tasche",
      "Metastase im Douglas-Raum",
      "PMP [Pseudomyxoma peritonei]",
      "Paranephritische Metastase",
      "Periadrenale Metastase",
      "Perinephrische Metastase",
      "Peripankreatische Metastase",
      "Perirenale Metastase",
      "Peritoneale Karzinomatose",
      "Peritonealhöhlenmetastase",
      "Peritonealkarzinose",
      "Peritonealmetastase",
      "Peritoneummetastase",
      "Peritonitis carcinomatosa",
      "Pseudomyxoma peritonei",
      "Retroperitoneale Metastase",
      "Retroperitoneummetastase",
      "Retrozäkale Metastase"
    ]
  },
  {
    "code": "C78.7",
    "name": "Lebermetastase",
    "synonyms": [
      "Hepatische Metastase",
      "Interlobuläre Gallengangsmetastase",
      "Interlobuläre Gallenwegsmetastase",
      "Leberfiliae",
      "Lebermetastase",
      "Lebermetastase bei unbekanntem Primärtumor",
      "Metastase an den Ductuli biliferi",
      "Metastase an den Ductuli intrahepaticae",
      "Metastase an den intrahepatischen Gallengängen",
      "Metastase an den intrahepatischen Gallenwegen",
      "Metastase an den intralobulären Gallengängen",
      "Metastase an den intralobulären Gallenwegen"
    ]
  },
  {
    "code": "C78.8",
    "name": "Pankreaskopfmetastase",
    "synonyms": [
      "Gallenblasengangsmetastase",
      "Gallenblasenmetastase",
      "Gallengangsmetastase",
      "Gallenwegsmetastase",
      "Intestinale Metastasierung",
      "Magenantrummetastase",
      "Mageneingangsmetastase",
      "Magenfundusmetastase",
      "Magenkorpusmetastase",
      "Magenmetastase",
      "Magenwandmetastase a.n.k.",
      "Metastase am Antrum pyloricum",
      "Metastase am Canalis pyloricus",
      "Metastase am Corpus ventriculi",
      "Metastase am Ductus choledochus",
      "Metastase am Ductus cysticus",
      "Metastase am Ductus hepaticus",
      "Metastase am Ductus pancreaticus accessorius",
      "Metastase am Gastrointestinaltrakt a.n.k.",
      "Metastase am Magenfundus",
      "Metastase am Ostium cardiacum",
      "Metastase am Pankreasgang",
      "Metastase am Pars abdominalis des Ösophagus",
      "Metastase am Pars cervicalis des Ösophagus",
      "Metastase am Pars thoracica des Ösophagus",
      "Metastase am Präpylorus",
      "Metastase am Pylorus",
      "Metastase am Santorini-Gang",
      "Metastase am Sphincter Oddi",
      "Metastase am Verdauungssystem a.n.k.",
      "Metastase am Wirsung-Gang",
      "Metastase am gastroösophagealen Übergang",
      "Metastase am kardioösophagealen Übergang",
      "Metastase an den Inselzellen",
      "Metastase an den Inselzellen des Pankreas",
      "Metastase an den Langerhans-Inseln",
      "Metastase an den Verdauungsorganen a.n.k.",
      "Metastase an den Verdauungswegen a.n.k.",
      "Metastase an den extrahepatischen Gallengängen",
      "Metastase an den hepatischen Gallengängen",
      "Metastase an der Ampulla Vateri",
      "Metastase an der Kardia des Magens",
      "Metastase an der großen Kurvatur des Magens a.n.k.",
      "Metastase an der kleinen Kurvatur des Magens a.n.k.",
      "Milzmetastase a.n.k.",
      "Pankreashalsmetastase",
      "Pankreaskopfmetastase",
      "Pankreaskörpermetastase",
      "Pankreasmetastase",
      "Pankreasschwanzmetastase",
      "Ösophagusmetastase"
    ]
  },
  {
    "code": "C79.0",
    "name": "Nierenmetastase",
    "synonyms": [
      "Metastase am Übergang zwischen Nierenbecken und Harnleiter",
      "Nierenbeckeninfiltration",
      "Nierenbeckenmetastase",
      "Nierenhilusmetastase",
      "Nierenkelchmetastase",
      "Nierenmetastase",
      "Nierenparenchymmetastase",
      "Renale Metastase"
    ]
  },
  {
    "code": "C79.1",
    "name": "Blasenmetastase",
    "synonyms": [
      "Blasenmetastase",
      "Harnblasenmetastase",
      "Harnblasenscheitelmetastase",
      "Harnblasenwandmetastase",
      "Harnorganmetastase a.n.k.",
      "Harnwegsmetastase a.n.k.",
      "Metastase am Harnblasenhals",
      "Metastase am Harnblasenostium",
      "Metastase am Harnblasensphinkter",
      "Metastase am Ostium ureteris",
      "Metastase am Ostium urethrae internum",
      "Metastase am Trigonum vesicae",
      "Metastase am Ureter",
      "Metastase am Utriculus prostaticus",
      "Metastase an den Bulbourethraldrüsen",
      "Metastase an den Cowper-Drüsen",
      "Metastase an den männlichen Harnorganen",
      "Metastase an den weiblichen Harnorganen",
      "Metastase an der Harnblasenwand",
      "Metastase an der Harnblasenöffnung",
      "Metastase an der Skene-Drüse",
      "Metastase an der Uretermündung",
      "Metastase an der Urethra",
      "Metastase an der inneren Mündung der Urethra",
      "Metastase an einer paraurethralen Drüse",
      "Urachusmetastase"
    ]
  },
  {
    "code": "C79.2",
    "name": "Bauchdeckenmetastase",
    "synonyms": [
      "Analhautmetastase",
      "Analrandmetastase",
      "Augenbrauenmetastase",
      "Augenlidmetastase",
      "Augenwinkelmetastase",
      "Auriculametastase",
      "Bauchdeckenmetastase",
      "Bauchwandmetastase",
      "Gehörgangsmetastase",
      "Hautmetastase",
      "Helixmetastase",
      "Kieferhautmetastase",
      "Kinnmetastase",
      "Kopfschwartenmetastase",
      "Lidmetastase",
      "Lippenhautmetastase",
      "Melanom-Hautmetastase",
      "Metastase am Ala nasi externa",
      "Metastase am Gehörgang",
      "Metastase am Meatus acusticus externus",
      "Metastase am Tragus",
      "Metastase am äußeren Gehörgang",
      "Metastase am äußeren Nasenflügel",
      "Metastase an den Meibom-Drüsen",
      "Metastase an der Brustdrüsenhaut",
      "Metastase an der Columella nasi",
      "Metastase an der Hautfalte der Achselhöhle",
      "Metastase an der Nasolabialfalte",
      "Metastase an der Perineumhaut",
      "Metastase an der Wangenaußenseite",
      "Nabelmetastase",
      "Nasenhautmetastase",
      "Nichtmelanomartige Hautmetastase",
      "Nichtmelanomartige Hautmetastase am Anus",
      "Nichtmelanomartige Hautmetastase am Arm",
      "Nichtmelanomartige Hautmetastase am Augenlid",
      "Nichtmelanomartige Hautmetastase am Augenwinkel",
      "Nichtmelanomartige Hautmetastase am Bauch",
      "Nichtmelanomartige Hautmetastase am Bein",
      "Nichtmelanomartige Hautmetastase am Daumen",
      "Nichtmelanomartige Hautmetastase am Ellenbogen",
      "Nichtmelanomartige Hautmetastase am Fuß",
      "Nichtmelanomartige Hautmetastase am Gehörgang",
      "Nichtmelanomartige Hautmetastase am Gesicht a.n.k.",
      "Nichtmelanomartige Hautmetastase am Gesäß",
      "Nichtmelanomartige Hautmetastase am Kiefer",
      "Nichtmelanomartige Hautmetastase am Kinn",
      "Nichtmelanomartige Hautmetastase am Knie",
      "Nichtmelanomartige Hautmetastase am Knöchel",
      "Nichtmelanomartige Hautmetastase am Kopf a.n.k.",
      "Nichtmelanomartige Hautmetastase am Lid",
      "Nichtmelanomartige Hautmetastase am Nabel",
      "Nichtmelanomartige Hautmetastase am Nasenflügel",
      "Nichtmelanomartige Hautmetastase am Oberschenkel",
      "Nichtmelanomartige Hautmetastase am Ohr",
      "Nichtmelanomartige Hautmetastase am Rumpf",
      "Nichtmelanomartige Hautmetastase am Rücken",
      "Nichtmelanomartige Hautmetastase am Thorax",
      "Nichtmelanomartige Hautmetastase am Tragus",
      "Nichtmelanomartige Hautmetastase am Unterarm",
      "Nichtmelanomartige Hautmetastase an den Fingern",
      "Nichtmelanomartige Hautmetastase an den Zehen",
      "Nichtmelanomartige Hautmetastase an den oberen Gliedmaßen a.n.k.",
      "Nichtmelanomartige Hautmetastase an den unteren Gliedmaßen a.n.k.",
      "Nichtmelanomartige Hautmetastase an der Achsel",
      "Nichtmelanomartige Hautmetastase an der Achselfalte",
      "Nichtmelanomartige Hautmetastase an der Augenbraue",
      "Nichtmelanomartige Hautmetastase an der Bauchwand",
      "Nichtmelanomartige Hautmetastase an der Brust",
      "Nichtmelanomartige Hautmetastase an der Brustwand",
      "Nichtmelanomartige Hautmetastase an der Columella nasi",
      "Nichtmelanomartige Hautmetastase an der Ellenbeuge",
      "Nichtmelanomartige Hautmetastase an der Ferse",
      "Nichtmelanomartige Hautmetastase an der Flanke",
      "Nichtmelanomartige Hautmetastase an der Fußsohle",
      "Nichtmelanomartige Hautmetastase an der Hand",
      "Nichtmelanomartige Hautmetastase an der Handfläche",
      "Nichtmelanomartige Hautmetastase an der Hüfte",
      "Nichtmelanomartige Hautmetastase an der Kopfschwarte",
      "Nichtmelanomartige Hautmetastase an der Lippe",
      "Nichtmelanomartige Hautmetastase an der Nase",
      "Nichtmelanomartige Hautmetastase an der Ohrhelix",
      "Nichtmelanomartige Hautmetastase an der Ohrmuschel",
      "Nichtmelanomartige Hautmetastase an der Schläfe",
      "Nichtmelanomartige Hautmetastase an der Schulter",
      "Nichtmelanomartige Hautmetastase an der Stirn",
      "Nichtmelanomartige Hautmetastase an der Thoraxwand",
      "Nichtmelanomartige Hautmetastase an der Wade",
      "Nichtmelanomartige Hautmetastase an der Wange",
      "Nichtmelanomartige Hautmetastase im Klavikulargebiet",
      "Nichtmelanomartige Hautmetastase in der Glutäalregion",
      "Nichtmelanomartige Hautmetastase in der Halsgegend",
      "Nichtmelanomartige Hautmetastase in der Inguinalregion",
      "Nichtmelanomartige Hautmetastase in der Kniekehle",
      "Nichtmelanomartige Hautmetastase in der Kreuzbeingegend",
      "Nichtmelanomartige Hautmetastase in der Leistenbeuge",
      "Nichtmelanomartige Hautmetastase in der Leistengegend",
      "Nichtmelanomartige Hautmetastase in der Nackengegend",
      "Nichtmelanomartige Hautmetastase in der Schamgegend",
      "Nichtmelanomartige Hautmetastas"
    ]
  },
  {
    "code": "C79.3",
    "name": "Durametastase",
    "synonyms": [
      "Basalganglienmetastase",
      "Durametastase",
      "Frontalhirnmetastase a.n.k.",
      "Gehirnfiliae",
      "Gehirnmetastase",
      "Gehirnmetastase bei unbekanntem Primärtumor",
      "Großhirnmetastase",
      "Großhirnrindenmetastase",
      "Hippocampusmetastase",
      "Hirnfiliae",
      "Hirnhautmetastase a.n.k.",
      "Hirnmetastase",
      "Hirnstammmetastase",
      "Hypothalamusmetastase",
      "Intrakranielle Metastase a.n.k.",
      "Kleinhirnbrückenwinkelmetastase",
      "Kleinhirnmetastase",
      "Kleinhirnwurmmetastase",
      "Kraniale Metastase",
      "Meningenkarzinose",
      "Meningeosis",
      "Meningeosis carcinomatosa",
      "Meningeosis leucaemica",
      "Meningeosis lymphomatosa",
      "Metastase am Corpus callosum",
      "Metastase am Corpus striatum",
      "Metastase am Ependym des Gehirns",
      "Metastase am Globus pallidus",
      "Metastase am Lobus frontalis cerebri",
      "Metastase am Lobus occipitalis cerebri",
      "Metastase am Lobus parietalis cerebri",
      "Metastase am Lobus temporalis cerebri",
      "Metastase am Okzipitallappen des Gehirns a.n.k.",
      "Metastase am Operculum cerebri",
      "Metastase am Pallium",
      "Metastase am Pedunculus cerebri",
      "Metastase am Plexus chorioideus",
      "Metastase am Plexus chorioideus des vierten Ventrikels",
      "Metastase am Polus frontalis cerebri",
      "Metastase am Polus occipitalis cerebri",
      "Metastase am Pons Varoli",
      "Metastase am Putamen",
      "Metastase am Rhinenzephalon",
      "Metastase am Stirnlappen des Gehirns",
      "Metastase am Tapetum cerebri",
      "Metastase am Temporallappen",
      "Metastase am Temporallappen des Gehirns a.n.k.",
      "Metastase am Tentorium cerebelli",
      "Metastase am Uncus",
      "Metastase am Vermis cerebelli",
      "Metastase an den Gehirnmeningen",
      "Metastase an den intrakraniellen Meningen",
      "Metastase an den kraniellen Meningen",
      "Metastase an den zerebralen Meningen",
      "Metastase an der Arachnoidea cerebralis",
      "Metastase an der Capsula interna",
      "Metastase an der Dura mater cranialis",
      "Metastase an der Dura mater encephali",
      "Metastase an der Falx cerebelli",
      "Metastase an der Falx cerebri",
      "Metastase an der Gehirnolive",
      "Metastase an der Großhirnhemisphäre",
      "Metastase an der Insula",
      "Metastase an der Medulla oblongata",
      "Metastase an der Pyramide",
      "Metastase an der Reil-Insel",
      "Metastase an der hinteren Schädelgrube",
      "Metastase an der inneren Kapsel",
      "Metastase an der kranialen Pia mater",
      "Metastase an der weißes Hirnsubstanz",
      "Metastase an der zentralen weißen Hirnsubstanz",
      "Metastase an der zerebralen Pia mater",
      "Metastase an einem Hirnventrikel",
      "Metastase an einem basalen Ganglion",
      "Metastase in der Fossa cranii",
      "Mittelhirnmetastase",
      "Pedunculusmetastase",
      "Scheitellappenmetastase",
      "Supraselläre Metastase",
      "Supratentorielle Metastase a.n.k.",
      "Thalamusmetastase",
      "Zerebellare Metastase",
      "Zerebellummetastase",
      "Zerebrale Meningenmetastase",
      "Zerebrale Metastase",
      "Zerebrale Ventrikelmetastase",
      "Zerebrummetastase"
    ]
  },
  {
    "code": "C79.4",
    "name": "Metastase an der Arachnoidea spinalis",
    "synonyms": [
      "Augapfelmetastase",
      "Epidurale Metastase",
      "Hirnnervenmetastase a.n.k.",
      "Intraokuläre Metastase",
      "Intraorbitale Metastase",
      "Irismetastase",
      "Konjunktivametastase",
      "Korneametastase",
      "Linsenmetastase",
      "Meningenmetastase",
      "Metastase am Chiasma opticum",
      "Metastase am Conus medullaris",
      "Metastase am Ductus nasolacrimalis",
      "Metastase am Filum terminale",
      "Metastase am Gehörnerven",
      "Metastase am Limbus corneae",
      "Metastase am Nervus abducens",
      "Metastase am Nervus acusticus",
      "Metastase am Nervus facialis",
      "Metastase am Nervus glossopharyngeus",
      "Metastase am Nervus hypoglossus",
      "Metastase am Nervus oculomotorius",
      "Metastase am Nervus opticus",
      "Metastase am Nervus trigeminus",
      "Metastase am Nervus trochlearis",
      "Metastase am Nervus vagus",
      "Metastase am Nervus vestibulocochlearis",
      "Metastase am Orbitabindegewebe a.n.k.",
      "Metastase am Pars cochlearis des Nervus vestibulocochlearis",
      "Metastase am Tractus opticus",
      "Metastase am Tränenkanal",
      "Metastase am Tränennasengang",
      "Metastase am Tränenpunkt",
      "Metastase am Tränensack",
      "Metastase am Uvealtrakt",
      "Metastase am Zentralnervensystem a.n.k.",
      "Metastase am spinalen Nervus accessorius",
      "Metastase an den Nervi craniales a.n.k.",
      "Metastase an den Nervi olfactorii",
      "Metastase an den Orbitanerven a.n.k.",
      "Metastase an den Orbitaweichteilen",
      "Metastase an den Rückenmarkhäuten",
      "Metastase an den Rückenmarkmeningen",
      "Metastase an den Wirbelsäulenmeningen",
      "Metastase an den autonomen Nerven der Orbita",
      "Metastase an den extraokulären Augenmuskeln",
      "Metastase an den peripheren Nerven der Orbita",
      "Metastase an den spinalen Meningen",
      "Metastase an der Arachnoidea",
      "Metastase an der Arachnoidea spinalis",
      "Metastase an der Cauda equina",
      "Metastase an der Chorioidea",
      "Metastase an der Dura mater",
      "Metastase an der Dura mater der Wirbelsäule",
      "Metastase an der Dura mater spinalis",
      "Metastase an der Pia mater",
      "Metastase an der Pia mater der Wirbelsäule",
      "Metastase an der Tränendrüse",
      "Metastase an der spinalen Pia mater",
      "Paraselläre Metastase",
      "Retinametastase",
      "Retrobulbäre Metastase",
      "Rückenmarkmetastase",
      "Sehnervmetastase",
      "Sehtraktmetastase",
      "Sklerametastase",
      "Spinale Metastase",
      "Subdurale Metastase",
      "ZNS-Metastase",
      "Ziliarkörpermetastase"
    ]
  },
  {
    "code": "C79.5",
    "name": "Knochenmetastase",
    "synonyms": [
      "Akromioklavikulargelenkmetastase",
      "Akromionmetastase",
      "Armknochenmetastase a.n.k.",
      "Astragalusmetastase",
      "Atlasmetastase",
      "Axismetastase",
      "Azetabulummetastase",
      "Bandscheibenmetastase",
      "Beckenknochenkarzinom",
      "Beckenknochenmetastase",
      "Beinknochenmetastase a.n.k.",
      "Brustbeinkarzinom",
      "Brustbeinmetastase",
      "Brustwirbelkörpermetastase",
      "Brustwirbelsäulenmetastase",
      "Calcaneusmetastase",
      "Craniummetastase",
      "Darmbeinmetastase",
      "Daumenknochenmetastase",
      "Ellenbogenknochenmetastase",
      "Ellenkarzinom",
      "Femurkarzinom",
      "Femurmetastase",
      "Fersenbeinmetastase",
      "Fersenknochenmetastase",
      "Fibulakarzinom",
      "Fibulametastase",
      "Fingerknochenmetastase",
      "Fußknochenmetastase",
      "Fußphalangenmetastase",
      "Fußwurzelknochenmetastase",
      "Gelenkkarzinom",
      "Gelenkmetastase a.n.k.",
      "Gesichtsknochenkarzinom",
      "Gesichtsknochenmetastase",
      "Gesichtsschädelknochenkarzinom",
      "Handknochenmetastase",
      "Handphalangenmetastase",
      "Handwurzelknochenmetastase",
      "Hinterhauptbeinmetastase",
      "Humeruskarzinom",
      "Humerusmetastase",
      "Hüftbeinmetastase",
      "Hüftknochenmetastase",
      "Jochbeinmetastase",
      "Karzinom der Columna vertebralis",
      "Karzinom des Os frontale",
      "Karzinom des Os nasale",
      "Karzinom des Os occipitale",
      "Karzinom des Os temporale",
      "Keilbeinknochenmetastase",
      "Keilbeinmetastase",
      "Kieferknochenmetastase",
      "Klavikulakarzinom",
      "Klavikulametastase",
      "Kniescheibenkarzinom",
      "Knochenfiliae",
      "Knochenhautmetastase",
      "Knochenhautmetastase am Akromion",
      "Knochenhautmetastase am Arm a.n.k.",
      "Knochenhautmetastase am Astragalus",
      "Knochenhautmetastase am Atlas",
      "Knochenhautmetastase am Axis",
      "Knochenhautmetastase am Azetabulum",
      "Knochenhautmetastase am Becken",
      "Knochenhautmetastase am Bein a.n.k.",
      "Knochenhautmetastase am Brustbein",
      "Knochenhautmetastase am Calcaneus",
      "Knochenhautmetastase am Clivus",
      "Knochenhautmetastase am Cranium",
      "Knochenhautmetastase am Darmbein",
      "Knochenhautmetastase am Daumen",
      "Knochenhautmetastase am Ellenbogen",
      "Knochenhautmetastase am Femur",
      "Knochenhautmetastase am Fersenbein",
      "Knochenhautmetastase am Finger",
      "Knochenhautmetastase am Fuß",
      "Knochenhautmetastase am Hinterhauptbein",
      "Knochenhautmetastase am Humerus",
      "Knochenhautmetastase am Hüftbein",
      "Knochenhautmetastase am Jochbein",
      "Knochenhautmetastase am Keilbein",
      "Knochenhautmetastase am Kiefer",
      "Knochenhautmetastase am Knie",
      "Knochenhautmetastase am Knöchel",
      "Knochenhautmetastase am Kreuzbein",
      "Knochenhautmetastase am Mittelfuß",
      "Knochenhautmetastase am Pflugscharbein",
      "Knochenhautmetastase am Processus xiphoideus",
      "Knochenhautmetastase am Radius",
      "Knochenhautmetastase am Rücken a.n.k.",
      "Knochenhautmetastase am Schambein",
      "Knochenhautmetastase am Scheitelbein",
      "Knochenhautmetastase am Schläfenbein",
      "Knochenhautmetastase am Schlüsselbein",
      "Knochenhautmetastase am Schädel",
      "Knochenhautmetastase am Schädeldach",
      "Knochenhautmetastase am Siebbein",
      "Knochenhautmetastase am Sitzbein",
      "Knochenhautmetastase am Skelett a.n.k.",
      "Knochenhautmetastase am Sprungbein",
      "Knochenhautmetastase am Steißbein",
      "Knochenhautmetastase am Unterarm",
      "Knochenhautmetastase am Unterkiefer",
      "Knochenhautmetastase am Vomer",
      "Knochenhautmetastase am Zungenbein",
      "Knochenhautmetastase an den Fußphalangen",
      "Knochenhautmetastase an den Gesichtsknochen",
      "Knochenhautmetastase an den Gliedmaßen a.n.k.",
      "Knochenhautmetastase an den Handphalangen",
      "Knochenhautmetastase an den Phalangen",
      "Knochenhautmetastase an den Rippen",
      "Knochenhautmetastase an den Wirbeln",
      "Knochenhautmetastase an den Zehen",
      "Knochenhautmetastase an den kurzen Knochen",
      "Knochenhautmetastase an den kurzen Knochen der oberen Gliedmaßen a.n.k.",
      "Knochenhautmetastase an den kurzen Knochen der unteren Gliedmaßen a.n.k.",
      "Knochenhautmetastase an den langen Knochen der oberen Gliedmaßen a.n.k.",
      "Knochenhautmetastase an den oberen Gliedmaßen a.n.k.",
      "Knochenhautmetastase an den unteren Gliedmaßen a.n.k.",
      "Knochenhautmetastase an der Calvaria",
      "Knochenhautmetastase an der Ferse",
      "Knochenhautmetastase an der Fibula",
      "Knochenhautmetastase an der Fußwurzel",
      "Knochenhautmetastase an der Hand",
      "Knochenhautmetastase an der Handwurzel",
      "Knochenhautmetastase an der Hüfte",
      "Knochenhautmetastase an der Klavikula",
      "Knochenhautmetastase an der Mandibula",
      "Knochenhautmetastase an der Mittelhand",
      "Knochenhautmetastase an der Nase",
      "Knochenhautmetastase an de"
    ]
  },
  {
    "code": "C79.6",
    "name": "Krukenberg-Tumor",
    "synonyms": [
      "Eierstockmetastase",
      "Krukenberg-Tumor",
      "Ovarmetastase"
    ]
  },
  {
    "code": "C79.7",
    "name": "Nebennierenmetastase",
    "synonyms": [
      "Metastase an den Nebennierendrüsen",
      "Metastase an der Medulla glandulae suprarenalis",
      "Metastase an der Nebennierenkapsel",
      "Nebennierenmarkmetastase",
      "Nebennierenmetastase",
      "Nebennierenrindenmetastase"
    ]
  },
  {
    "code": "C79.81",
    "name": "Mammametastase",
    "synonyms": [
      "Areolametastase",
      "Brustdrüsenmetastase",
      "Brustwarzenmetastase",
      "Mammametastase",
      "Metastase am Recessus axillaris der Brustdrüse",
      "Metastase am Warzenhof der Brustdrüse",
      "Metastase am axillären Ausläufer der Brustdrüse",
      "Metastase am oberen inneren Quadranten der Brustdrüse",
      "Metastase am oberen äußeren Quadranten der Brustdrüse",
      "Metastase am unteren inneren Quadranten der Brustdrüse",
      "Metastase am unteren äußeren Quadranten der Brustdrüse",
      "Metastase am zentralen Drüsenkörper der Brustdrüse",
      "Metastase an der Brustdrüse",
      "Metastase an der Brustwarze",
      "Metastase an der Medioklavikularlinie der Brustdrüse",
      "Metastase an der inneren Brustdrüse",
      "Metastase an der oberen Brustdrüse",
      "Metastase an der unteren Brustdrüse",
      "Metastase an der äußeren Brustdrüse",
      "Metastase an einer ektopischen Brustdrüse"
    ]
  },
  {
    "code": "C79.82",
    "name": "Vaginalmetastase",
    "synonyms": [
      "Eileitermetastase",
      "Endozervikale Metastase",
      "Epididymismetastase",
      "Hodenmetastase",
      "Hymenmetastase",
      "Klitorismetastase",
      "Mesosalpinxmetastase",
      "Metastase am Corpus cavernosum",
      "Metastase am Corpus uteri",
      "Metastase am Ductus deferens",
      "Metastase am Ductus ejaculatorius",
      "Metastase am Endometrium",
      "Metastase am Endometriumstroma",
      "Metastase am Frenulum labiorum pudendi",
      "Metastase am Fundus des Uterus",
      "Metastase am Fundus uteri",
      "Metastase am Gartner-Gang",
      "Metastase am Isthmus des Uterus",
      "Metastase am Isthmus uteri",
      "Metastase am Ligamentum latum uteri",
      "Metastase am Ligamentum ovarii proprium",
      "Metastase am Ligamentum rotundum",
      "Metastase am Ligamentum rotundum uteri",
      "Metastase am Ligamentum teres uteri",
      "Metastase am Mons pubis",
      "Metastase am Mons veneris",
      "Metastase am Müller-Gang bei der Frau",
      "Metastase am Müller-Gang beim Mann",
      "Metastase am Ovidukt",
      "Metastase am Parametrium",
      "Metastase am Parovarium",
      "Metastase am Präputium",
      "Metastase am Septum urethrovaginale",
      "Metastase am Septum vesicovaginale",
      "Metastase am Stumpf der Cervix uteri",
      "Metastase am Uterus",
      "Metastase am Uterushorn",
      "Metastase am Uteruskörper",
      "Metastase am Vas deferens",
      "Metastase am Wolff-Gang bei der Frau",
      "Metastase am Wolff-Gang beim Mann",
      "Metastase am Zervikalkanal",
      "Metastase am Zervixübergang zur Vagina",
      "Metastase am inneren Muttermund",
      "Metastase am männlichen Urogenitaltrakt",
      "Metastase am rektovaginalen Septum",
      "Metastase am unteren Segment des Uterus",
      "Metastase am vaginovesikalen Septum",
      "Metastase am vesikovaginalen Septum",
      "Metastase am vesikozervikalen Gewebe",
      "Metastase am weiblichen Urogenitaltrakt",
      "Metastase am Übergang der Cervix uteri zur Vagina",
      "Metastase am Übergang zwischen Cervix uteri und Vagina",
      "Metastase am Übergang zwischen Zervix und Vagina",
      "Metastase am äußeren Muttermund",
      "Metastase an den Labia majora pudendi",
      "Metastase an den Labia minora pudendi",
      "Metastase an den Ligamenta sacrouterina",
      "Metastase an den Ligamenta uteri",
      "Metastase an den Ovula Nabothi",
      "Metastase an den Pudenda feminae",
      "Metastase an den Uterusligamenten",
      "Metastase an den männlichen Geschlechtsorganen a.n.k.",
      "Metastase an den uteroovarialen Bändern",
      "Metastase an den uterosakralen Bändern",
      "Metastase an den uterosakralen Ligamenten",
      "Metastase an den vulvovaginalen Drüsen",
      "Metastase an den weiblichen Geschlechtsorganen a.n.k.",
      "Metastase an der Bartholin-Drüse",
      "Metastase an der Cervix uteri",
      "Metastase an der Ektozervix",
      "Metastase an der Endozervix",
      "Metastase an der Glandula vestibularis major",
      "Metastase an der Glans penis",
      "Metastase an der Penishaut a.n.k.",
      "Metastase an der Salpinx",
      "Metastase an der Tuba uterina",
      "Metastase an der Tunica vaginalis testis",
      "Metastase an der Uterusadnexe",
      "Metastase an der Vagina",
      "Metastase an der Vesicula seminalis",
      "Metastase an der rektovaginalen Wand",
      "Metastase an einem deszendierten Hoden",
      "Metastase an einem ektopischen Hoden",
      "Metastase an einem nichtdeszendierten Hoden",
      "Metastase an einem retinierten Hoden",
      "Metastase an einem skrotalen Hoden",
      "Metastase in der Fornix vaginae",
      "Myometriummetastase",
      "Nebenhodenmetastase",
      "Nichtmelanomartige Hautmetastase am Penis a.n.k.",
      "Nichtmelanomartige Hautmetastase am Präputium",
      "Nichtmelanomartige Hautmetastase am Skrotum",
      "Nichtmelanomartige Hautmetastase an den Labia majora pudendi",
      "Nichtmelanomartige Hautmetastase an den Labia minora pudendi",
      "Nichtmelanomartige Hautmetastase an den Labien",
      "Nichtmelanomartige Hautmetastase an den Pudenda feminae",
      "Nichtmelanomartige Hautmetastase an den männlichen Geschlechtsorganen",
      "Nichtmelanomartige Hautmetastase an den weiblichen Geschlechtsorganen",
      "Nichtmelanomartige Hautmetastase an der Klitoris",
      "Nichtmelanomartige Hautmetastase an der Vulva",
      "Paravaginale Metastase",
      "Penismetastase",
      "Plazentametastase",
      "Prostatametastase",
      "Samenblaseninfiltration",
      "Samenblasenmetastase",
      "Samenstrangmetastase",
      "Skrotummetastase",
      "Tuboovariale Metastase",
      "Urethrovaginale Metastase",
      "Uteroovariale Metastase",
      "Vaginalmetastase",
      "Vaginovesikale Metastase",
      "Vesikovaginale Metastase",
      "Vorhautmetastase",
      "Vulvametastase",
      "Zervixmetastase",
      "Zervixstumpfmetastase"
    ]
  },
  {
    "code": "C79.83",
    "name": "Perikardkarzinose",
    "synonyms": [
      "Pericarditis carcinomatosa",
      "Perikardkarzinose",
      "Perikardmetastase"
    ]
  },
  {
    "code": "C79.84",
    "name": "Epikardkarzinose",
    "synonyms": [
      "Endokardmetastase",
      "Epikardkarzinose",
      "Epikardmetastase",
      "Herzmetastase",
      "Metastase am Atrium cordis",
      "Myokardmetastase"
    ]
  },
  {
    "code": "C79.85",
    "name": "Metastase am Bindegewebe des Halses",
    "synonyms": [
      "Metastase am Bindegewebe des Halses"
    ]
  },
  {
    "code": "C79.86",
    "name": "Metastase am Bindegewebe des Beins a.n.k.",
    "synonyms": [
      "Metastase am Bindegewebe der Ellenbeuge",
      "Metastase am Bindegewebe der Extremitäten a.n.k.",
      "Metastase am Bindegewebe der Ferse",
      "Metastase am Bindegewebe der Gliedmaßen a.n.k.",
      "Metastase am Bindegewebe der Hand",
      "Metastase am Bindegewebe der Hüfte",
      "Metastase am Bindegewebe der Kniekehle",
      "Metastase am Bindegewebe der Schulter",
      "Metastase am Bindegewebe der Wade",
      "Metastase am Bindegewebe des Armes",
      "Metastase am Bindegewebe des Beins a.n.k.",
      "Metastase am Bindegewebe des Daumens",
      "Metastase am Bindegewebe des Ellenbogens",
      "Metastase am Bindegewebe des Fingers",
      "Metastase am Bindegewebe des Fußes",
      "Metastase am Bindegewebe des Handgelenkes",
      "Metastase am Bindegewebe des Knies",
      "Metastase am Bindegewebe des Knöchels",
      "Metastase am Bindegewebe des Oberschenkels",
      "Metastase am Bindegewebe des Unterarms",
      "Metastase am Bindegewebe einer Zehe",
      "Metastase am Weichteilgewebe der Hüfte",
      "Metastase am Weichteilgewebe der Schulter",
      "Metastase an der Aponeurosis plantaris"
    ]
  },
  {
    "code": "C79.88",
    "name": "Lymphangiosis carcinomatosa",
    "synonyms": [
      "Abdomenmetastase",
      "Abdominalmetastase",
      "Abdominopelvine Metastase",
      "Achselhöhlenmetastase",
      "Alveolarschleimhautmetastase",
      "Armmetastase a.n.k.",
      "Augenlidknorpelmetastase",
      "Augenmetastase",
      "Baucheingeweidemetastase",
      "Bauchhöhlenmetastase",
      "Bauchmetastase",
      "Bauchorganmetastase",
      "Bauchraummetastase",
      "Beckenbodenmetastase",
      "Beckenmetastase",
      "Beckenorganmetastase",
      "Beckenwandmetastase",
      "Beinmetastase a.n.k.",
      "Bindegewebemetastase",
      "Brachialnervenmetastase",
      "Brustwandmetastase a.n.k.",
      "Bukkale Metastase",
      "Bukkale Schleimhautmetastase",
      "Daumenmetastase a.n.k.",
      "Diaphragmametastase",
      "Eingeweidemetastase a.n.k.",
      "Ellenbogenmetastase a.n.k.",
      "Epiphysenmetastase",
      "Extrarektale Metastase",
      "Extremitätenmetastase",
      "Faszienmetastase",
      "Fersenmetastase a.n.k.",
      "Fingermetastase a.n.k.",
      "Flankenmetastase a.n.k.",
      "Fußmetastase a.n.k.",
      "Ganglionmetastase",
      "Gaumenbogenmetastase",
      "Gaumenmandelmetastase a.n.k.",
      "Gaumenmetastase",
      "Gesichtsmetastase a.n.k.",
      "Gesäßmetastase a.n.k.",
      "Gingivametastase",
      "Gingivametastase am Oberkiefer",
      "Gingivametastase am Unterkiefer",
      "Halsmetastase a.n.k.",
      "Handgelenkmetastase a.n.k.",
      "Handmetastase a.n.k.",
      "Hypopharynxmetastase",
      "Hypophysenmetastase",
      "Hüftmetastase a.n.k.",
      "Infraklavikuläre Metastase",
      "Intraabdominale Metastase",
      "Intraabdominale Metastasierung",
      "Intraselläre Metastase",
      "Intrathorakale Metastase",
      "Ischiorektale Metastase",
      "Kiefermetastase",
      "Kiemenspaltenmetastase",
      "Kniekehlenmetastase",
      "Kniemetastase a.n.k.",
      "Knöchelmetastase a.n.k.",
      "Kopfmetastase a.n.k.",
      "Krikopharynxmetastase",
      "Labiale Metastase",
      "Laryngopharynxmetastase",
      "Linguale Metastase a.n.k.",
      "Lippenmetastase",
      "Lumbosakralplexusmetastase",
      "Lymphangiosis carcinomatosa",
      "Lymphbahnenmetastase a.n.k.",
      "Lymphgefäßmetastase",
      "Metastase am Achselhöhlenbindegewebe",
      "Metastase am Arcus palatoglossus",
      "Metastase am Arcus palatopharyngeus",
      "Metastase am Augenlidbindegewebe",
      "Metastase am Augenlidknorpel",
      "Metastase am Auriculaknorpel",
      "Metastase am Bauchwandbindegewebe",
      "Metastase am Bindegewebe der Auricula",
      "Metastase am Bindegewebe der Brust",
      "Metastase am Bindegewebe der Brustwand",
      "Metastase am Bindegewebe der Flankengegend",
      "Metastase am Bindegewebe der Fossa ischiorectalis",
      "Metastase am Bindegewebe der Fossa pterygoidea",
      "Metastase am Bindegewebe der Glutäalmuskulatur",
      "Metastase am Bindegewebe der Infraklavikulargegend",
      "Metastase am Bindegewebe der Kopfschwarte",
      "Metastase am Bindegewebe der Kreuzbeingegend und Steißbeingegend",
      "Metastase am Bindegewebe der Schläfe",
      "Metastase am Bindegewebe der Schulterblattgegend",
      "Metastase am Bindegewebe der Stirn",
      "Metastase am Bindegewebe der Supraklavikulargegend",
      "Metastase am Bindegewebe der Wange",
      "Metastase am Bindegewebe der großen Gefäße a.n.k.",
      "Metastase am Bindegewebe des Abdomens",
      "Metastase am Bindegewebe des Beckenbodens",
      "Metastase am Bindegewebe des Beckens",
      "Metastase am Bindegewebe des Ductus thoracicus",
      "Metastase am Bindegewebe des Gesichts",
      "Metastase am Bindegewebe des Gesäßes",
      "Metastase am Bindegewebe des Iliopsoasmuskels",
      "Metastase am Bindegewebe des Kiefers",
      "Metastase am Bindegewebe des Kinns",
      "Metastase am Bindegewebe des Ohres",
      "Metastase am Bindegewebe des Perineums",
      "Metastase am Bindegewebe des Psoasmuskels",
      "Metastase am Bindegewebe des Rumpfes",
      "Metastase am Bindegewebe des Rückens",
      "Metastase am Bindegewebe des Septum rectovaginale",
      "Metastase am Boden des Nasenrachenraums",
      "Metastase am Brachialplexus",
      "Metastase am Corpus pineale",
      "Metastase am Dach des Nasenrachenraums",
      "Metastase am Dach des weichen Gaumens",
      "Metastase am Diaphragmabindegewebe",
      "Metastase am Ductus craniopharyngealis",
      "Metastase am Ductus parotideus",
      "Metastase am Ductus sublingualis",
      "Metastase am Ductus submandibularis",
      "Metastase am Ductus thoracicus",
      "Metastase am Ductus thyreoglossus",
      "Metastase am Frenulum linguae",
      "Metastase am Glomus caroticum",
      "Metastase am Glomus coccygeum",
      "Metastase am Glomus jugulare",
      "Metastase am Glomus tympanicum",
      "Metastase am Kopfbindegewebe",
      "Metastase am Lippenstiftbereich",
      "Metastase am Mesovarium",
      "Metastase am Mundhöhlendach",
      "Metastase am Nabelbindegewebe",
      "Metastase am Nasenrachenraum",
      "Metastase am Nervus brachialis",
      "Metastase am Nervus femoralis",
      "Metastase am Nervus ischiadicus",
      "Metastase am Nervu"
    ]
  },
  {
    "code": "C79.9",
    "name": "Chorionepitheliommetastase",
    "synonyms": [
      "Absiedelung eines Tumors",
      "Chorionepitheliommetastase",
      "Diffuse Metastasierung",
      "Disseminierte Metastasierung",
      "Exulzerierende Metastasierung",
      "Fernmetastase",
      "Filiae",
      "Generalisierte Krankheit durch Krebs",
      "Generalisierte bösartige Neubildung",
      "Generalisierter Krebs",
      "Generalisierter maligner Tumor",
      "Generalisierter sekundärer Krebs",
      "Generalisierter sekundärer maligner Tumor",
      "Generalisiertes neoplastisches Syndrom",
      "Kanzeromatose",
      "Kanzerose",
      "Karzinomatose",
      "Karzinommetastase",
      "Karzinose",
      "Melanom-Metastase",
      "Metastase",
      "Metastase bei unbekanntem Primärtumor",
      "Metastasenausbreitung",
      "Metastasierender Tumor",
      "Metastasierendes Karzinom",
      "Metastatische Absiedelung",
      "Metastatische Krankheit",
      "Metastatisches Karzinom",
      "Multipler sekundärer Krebs",
      "Neubildung mit Metastase",
      "Sarkomatose",
      "Sekundäre Karzinomausbreitung",
      "Sekundäre Karzinominfiltration",
      "Sekundäre Karzinose",
      "Sekundäre bösartige Neubildung",
      "Sekundärer Krebs",
      "Sekundärer Tumor",
      "Sekundärer maligner Tumor",
      "Sekundäres Karzinom",
      "Sekundäres Wachstum",
      "Sekundärgeschwulst",
      "Tumoraussaat",
      "Tumormetastase"
    ]
  },
  {
    "code": "C80.0",
    "name": "Bösartige Neubildung unbekannter Primärlokalisation",
    "synonyms": [
      "Adenokarzinom bei unklarem Primärtumor",
      "Adenokarzinom unbekannter Primärlokalisation",
      "Bösartige Neubildung unbekannter Primärlokalisation",
      "Bösartige Neubildung unklaren Sitzes",
      "Bösartiger Primärtumor unbekannten Ursprungs",
      "Bösartiger Tumor unklarer Lokalisation",
      "CUP [Cancer of Unknown Primary]",
      "Karzinom unklarer Lokalisation",
      "Unbekannter maligner Primärtumor",
      "Unklarer Primärtumor"
    ]
  },
  {
    "code": "C80.9",
    "name": "Adenosarkom",
    "synonyms": [
      "Adenokarzinoid - s.a. Neubildung, bösartig",
      "Adenokarzinoidtumor - s.a. Neubildung, bösartig",
      "Adenokarzinom",
      "Adenokarzinom in Polypen",
      "Adenoma malignum",
      "Adenosarkom",
      "Adenosquamöses Karzinom",
      "Anaplastisches Zytom",
      "Atypisches Karzinoid",
      "Atypisches Plattenepithelkarzinom",
      "Azinuszellen-Adenokarzinom",
      "Azinöses Adenokarzinom",
      "Bösartige Erkrankung",
      "Bösartige Geschwulst",
      "Bösartige Krankheit",
      "Bösartige Neubildung",
      "Bösartige Neubildung an mehreren Lokalisationen",
      "Bösartige Neubildung unklarer Genese",
      "Bösartige Raumforderung",
      "Bösartige Tumorerkrankung",
      "Bösartige Veränderung",
      "Bösartiger Polyp",
      "Bösartiger Tumor",
      "Bösartiges Akanthom",
      "Bösartiges Argentaffinom",
      "Bösartiges Karzinoid",
      "Bösartiges Mesonephrom - s.a. Neubildung, bösartig",
      "Bösartiges Teratom",
      "Bösartiges Ulkus",
      "Carcinoma - s.a. Neubildung, bösartig",
      "Carcinoma adenomatosum",
      "Carcinoma planocellulare",
      "Carcinoma platycellulare",
      "Carcinoma spinocellulare",
      "Chordom",
      "Disseminierte bösartige Neubildung",
      "Embolie bei Tumor",
      "Embryonaler Keimzelltumor",
      "Embryonales Adenokarzinom",
      "Embryonales Teratom",
      "Embryonalkarzinom",
      "Embryonalkarzinom außerhalb des ZNS",
      "Entdifferenziertes Karzinom",
      "Enterochromaffiner Tumor",
      "Epitheliom - s.a. Neubildung, bösartig",
      "Epithelioma - s.a. Neubildung, bösartig",
      "Exulzeriertes Karzinom",
      "Gallertkarzinom",
      "Gekörntzelliges Adenokarzinom",
      "Gelatinöses Adenokarzinom",
      "Gemischter Keimzelltumor",
      "Gemischtzelliges Adenokarzinom",
      "Granularzelladenokarzinom",
      "Großzellig-oxyphiles Adenokarzinom",
      "Hellzelliges Adenokarzinom",
      "Intrazystisches papilläres Adenokarzinom",
      "Invasives Karzinom",
      "Kankroid",
      "Karzinoid - s.a. Neubildung, bösartig",
      "Karzinom - s.a. Neubildung, bösartig",
      "Karzinom im Status progressivus",
      "Karzinom in Polypen",
      "Karzinomatöse Zyste",
      "Karzinomerkrankung",
      "Karzinöses Ulkus",
      "Klarzelliges Adenokarzinom",
      "Kleinzelliges anaplastisches Karzinom",
      "Kolloides Adenokarzinom",
      "Krebs - s.a. Neubildung, bösartig",
      "Li-Fraumeni-Syndrom",
      "Lymphoepitheliomartiges Karzinom",
      "Maligne Krankheit",
      "Maligne Neoplasie",
      "Maligne Zyste",
      "Maligner Polyp",
      "Maligner Tumor",
      "Malignes Chromaffinom",
      "Malignes Epitheliom - s.a. Neubildung, bösartig",
      "Malignes Grundleiden",
      "Malignes Mesonephrom - s.a. Neubildung, bösartig",
      "Malignes Teratoblastom - s.a. Neubildung, bösartig",
      "Malignom",
      "Medulläres Adenokarzinom",
      "Mesonephrisches Adenokarzinom",
      "Mesonephrom - s.a. Neubildung, bösartig",
      "Mesonephroma - s.a. Neubildung, bösartig",
      "Metastasierender neuroendokriner Tumor",
      "Mischzelladenokarzinom",
      "Mischzelliges Karzinoid",
      "Mukoides Adenokarzinom",
      "Muköses Adenokarzinom",
      "Multipler Krebs",
      "Muzinproduzierendes Adenokarzinom",
      "Muzinsezernierendes Adenokarzinom",
      "Muzinöses Adenokarzinom",
      "NUT [Nuclear protein in testis]-Karzinom",
      "NUT [Nuclear protein in testis]-Mittellinienkarzinom",
      "Neuroendokriner Tumor",
      "Neuroendokrines Karzinom",
      "Oberflächlich spreitendes Adenokarzinom",
      "Onkozytäres Adenokarzinom",
      "Oxyphiles Adenokarzinom",
      "Papilläres Adenokarzinom",
      "Papilläres Karzinom",
      "Paraneoplasie",
      "Paraneoplastisches Syndrom",
      "Plattenepitheliales Epitheliom",
      "Plattenepithelkarzinom",
      "Polyembryom",
      "Primäre Karzinose",
      "Primärer Krebs",
      "Primärer maligner Tumor",
      "Primäres Karzinom",
      "Primärkarzinom",
      "Primärtumor",
      "Pseudomyasthenisches Syndrom",
      "Rhabdoid-Teratoid-Tumor",
      "Rhabdoides Sarkom",
      "Rhabdoidtumor",
      "Schleimbildendes Adenokarzinom",
      "Seröses Adenokarzinom",
      "Siegelringzelladenokarzinom",
      "Siegelringzellkarzinom",
      "Spinaliom",
      "Spinozelluläres Karzinom",
      "Superficial spreading adenocarcinoma",
      "Szirrhöses Adenokarzinom",
      "Teratoblastom - s.a. Neubildung, bösartig",
      "Teratoides Medulloepitheliom",
      "Teratokarzinom",
      "Teratom mit maligner Transformation",
      "Teratoma malignum",
      "Trabekuläres Adenokarzinom",
      "Tubuläres Adenokarzinom",
      "Ulcus malignum",
      "Undifferenziertes Teratom",
      "Unreifes Teratom",
      "Villöses Adenokarzinom",
      "Zylindromatöses Adenokarzinom",
      "Zystisches Adenokarzinom"
    ]
  },
  {
    "code": "C81.0",
    "name": "Hodgkin-Paragranulom",
    "synonyms": [
      "Hodgkin-Krankheit mit lymphozytär-histiozytärer Prädominanz",
      "Hodgkin-Paragranulom",
      "Noduläres Paragranulom",
      "Noduläres lymphozytenprädominantes Hodgkin-Lymphom"
    ]
  },
  {
    "code": "C81.1",
    "name": "Nodulärsklerosierende Form der Hodgkin-Krankheit",
    "synonyms": [
      "Gemischtzellige nodulärsklerosierende Hodgkin-Krankheit",
      "Lymphozytenarme nodulärsklerosierende Hodgkin-Krankheit",
      "Lymphozytenreiche nodulärsklerosierende Hodgkin-Krankheit",
      "Nodulärsklerosierende Form der Hodgkin-Krankheit",
      "Nodulärsklerosierendes klassisches Hodgkin-Lymphom",
      "Nodulärsklerosierendes klassisches Hodgkin-Lymphom, Grad 1",
      "Nodulärsklerosierendes klassisches Hodgkin-Lymphom, Grad 2",
      "Synzytiale nodulärsklerosierende Hodgkin-Krankheit",
      "Zelluläre Phase einer nodulärsklerosierenden Hodgkin-Krankheit"
    ]
  },
  {
    "code": "C81.2",
    "name": "Gemischtzellige Form der Hodgkin-Krankheit",
    "synonyms": [
      "Gemischtzellige Form der Hodgkin-Krankheit",
      "Gemischtzelliges klassisches Hodgkin-Lymphom"
    ]
  },
  {
    "code": "C81.3",
    "name": "Hodgkin-Sarkom",
    "synonyms": [
      "Diffusfibrosierendes lymphozytenarmes klassisches Hodgkin-Lymphom",
      "Hodgkin-Sarkom",
      "Lymphozytenarme Hodgkin-Krankheit",
      "Lymphozytenarme diffusfibrosierende Hodgkin-Krankheit",
      "Lymphozytenarme retikuläre Hodgkin-Krankheit",
      "Lymphozytenarmes klassisches Hodgkin-Lymphom",
      "Retikuläres lymphozytenarmes klassisches Hodgkin-Lymphom"
    ]
  },
  {
    "code": "C81.4",
    "name": "Lymphozytenreiche Hodgkin-Krankheit",
    "synonyms": [
      "Lymphozytenreiche Hodgkin-Krankheit",
      "Lymphozytenreiche diffuse Hodgkin-Krankheit",
      "Lymphozytenreiche noduläre Hodgkin-Krankheit",
      "Lymphozytenreiches klassisches Hodgkin-Lymphom"
    ]
  },
  {
    "code": "C81.7",
    "name": "Nicht typisiertes klassisches Hodgkin-Lymphom",
    "synonyms": [
      "Klassisches Hodgkin-Lymphom",
      "Nicht typisiertes klassisches Hodgkin-Lymphom"
    ]
  },
  {
    "code": "C81.9",
    "name": "Hodgkin-Lymphom",
    "synonyms": [
      "Bösartige Lymphogranulomatose",
      "Bösartiges Hodgkin-Lymphom",
      "Hodgkin-Granulom",
      "Hodgkin-Krankheit",
      "Hodgkin-Lymphom",
      "Lymphogranulom",
      "Lymphogranuloma maligne",
      "Lymphogranulomatose",
      "Malignes Lymphogranulom",
      "Morbus Hodgkin",
      "Zerebrales Hodgkin-Lymphom"
    ]
  },
  {
    "code": "C82.0",
    "name": "Kleinzelliges gekerbtes follikuläres Lymphom",
    "synonyms": [
      "Follikuläres Lymphom Grad 1",
      "Kleinzelliges gekerbtes follikuläres Lymphom"
    ]
  },
  {
    "code": "C82.1",
    "name": "Gemischt klein- und großzelliges gekerbtes follikuläres Non-Hodgkin-Lymphom",
    "synonyms": [
      "Follikuläres Lymphom Grad 2",
      "Follikuläres Lymphosarkom vom Mischzelltyp",
      "Follikuläres Retikulolymphosarkom",
      "Gemischt klein- und großzelliges gekerbtes follikuläres Lymphom",
      "Gemischt klein- und großzelliges gekerbtes follikuläres Non-Hodgkin-Lymphom",
      "Gemischtes noduläres Lymphom",
      "Gemischtzelliges follikuläres Lymphom",
      "Gemischtzelliges noduläres lymphozytär-histiozytäres Lymphom",
      "Noduläres lymphozytär-histiozytäres Lymphom"
    ]
  },
  {
    "code": "C82.2",
    "name": "Großzelliges follikuläres Non-Hodgkin-Lymphom",
    "synonyms": [
      "Follikuläres Lymphom Grad 3",
      "Gekerbtes großzelliges follikuläres Lymphom",
      "Großzelliges follikuläres Lymphom",
      "Großzelliges follikuläres Non-Hodgkin-Lymphom",
      "Histiozytäres follikuläres Lymphom",
      "Histiozytäres noduläres Lymphom",
      "Ungekerbtes follikuläres Lymphom",
      "Zentroblastisches follikuläres Lymphom"
    ]
  },
  {
    "code": "C82.3",
    "name": "Follikuläres Lymphom Grad 3a",
    "synonyms": [
      "Follikuläres Lymphom Grad 3a"
    ]
  },
  {
    "code": "C82.4",
    "name": "Follikuläres Lymphom Grad 3b",
    "synonyms": [
      "Follikuläres Lymphom Grad 3b"
    ]
  },
  {
    "code": "C82.5",
    "name": "Diffuses Follikelzentrumslymphom",
    "synonyms": [
      "Diffuses Follikelzentrumslymphom"
    ]
  },
  {
    "code": "C82.6",
    "name": "Kutanes Follikelzentrumslymphom",
    "synonyms": [
      "Kutanes Follikelzentrumslymphom",
      "Primär kutanes Follikelzentrumslymphom"
    ]
  },
  {
    "code": "C82.7",
    "name": "Sonstige Typen des follikulären Lymphoms",
    "synonyms": [
      "Sonstige Typen des follikulären Lymphoms"
    ]
  },
  {
    "code": "C82.9",
    "name": "Follikuläres Lymphom",
    "synonyms": [
      "Brill-Symmers-Krankheit",
      "Brill-Symmers-Syndrom",
      "Follikuläres Germinoblastom",
      "Follikuläres Lymphom",
      "Follikuläres Lymphom mit diffuser Ausbreitung",
      "Follikuläres Lymphom ohne diffuse Ausbreitung",
      "Follikuläres Lymphosarkom",
      "Follikuläres Non-Hodgkin-Lymphom",
      "Follikuläres Non-Hodgkin-Lymphom mit diffusen Bezirken",
      "Follikuläres Non-Hodgkin-Lymphom ohne diffuse Bezirke",
      "Gekerbtes follikuläres Lymphom",
      "Kleinzelliges gekerbtes follikuläres Non-Hodgkin-Lymphom",
      "Lymphozytisches noduläres Lymphom",
      "Lymphozytäres noduläres Lymphom",
      "Noduläres Lymphom",
      "Noduläres Lymphom vom Intermediärtyp",
      "Noduläres Non-Hodgkin-Lymphom",
      "Noduläres Retikulolymphosarkom",
      "Noduläres gut differenziertes Lymphom",
      "Noduläres mäßig differenziertes Lymphom",
      "Noduläres wenig differenziertes Lymphom",
      "Zentroblastisch-zentrozytisches follikuläres Lymphom"
    ]
  },
  {
    "code": "C83.0",
    "name": "B-Zell-Immunozytom",
    "synonyms": [
      "B-Zell-Immunozytom",
      "Diffuses mäßig differenziertes Lymphom",
      "Immunozytom",
      "Kleinzelliges B-Zell-Lymphom",
      "Kleinzelliges Non-Hodgkin-Lymphom",
      "Kleinzelliges diffuses Lymphom",
      "Kleinzelliges ungekerbtes Lymphom",
      "Lymphoplasmozytisches Lymphom",
      "Lymphoplasmozytisches Lymphom ohne IgM-Produktion",
      "Lymphoplasmozytoides Lymphom",
      "Lymphozytäres diffuses Lymphom",
      "Lymphozytäres kleinzelliges Lymphom",
      "Nicht leukämische Variante der B-CLL",
      "Nodales Marginalzonen-B-Zell-Lymphom",
      "Nodales Marginalzonenlymphom",
      "Plasmazelluläres Lymphom",
      "Primär kutanes Marginalzonen-B-Zell-Lymphom",
      "Splenisches Marginalzonenlymphom",
      "Splenisches diffuses kleinzelliges B-Zell-Lymphom der roten Pulpa"
    ]
  },
  {
    "code": "C83.1",
    "name": "Kleinzelliges gekerbtes Non-Hodgkin-Lymphom",
    "synonyms": [
      "Gekerbtes diffuses Lymphom",
      "Kleinzelliges gekerbtes Lymphom",
      "Kleinzelliges gekerbtes Non-Hodgkin-Lymphom",
      "Lymphom der Mantelschicht",
      "MCL [Mantelzell-Lymphom]",
      "Maligne lymphomatöse Polyposis",
      "Mantelzell-Lymphom",
      "Zentrozytisches Lymphom",
      "Zentrozytom"
    ]
  },
  {
    "code": "C83.3",
    "name": "Immunoblastom",
    "synonyms": [
      "ALK-positives diffus großzelliges B-Zell-Lymphom",
      "ALK-positives großzelliges B-Zell-Lymphom",
      "Anaplastisches diffus großzelliges B-Zell-Lymphom",
      "CD30-positives diffuses großzelliges B-Zell-Lymphom",
      "Diffus großzelliges Non-Hodgkin-Lymphom",
      "Diffuses Retikulosarkom",
      "Diffuses großzelliges B-Zell-Lymphom",
      "Diffuses großzelliges B-Zell-Lymphom assoziiert mit chronischer Entzündung",
      "Diffuses großzelliges B-Zell-Lymphom des Zentralnervensystems",
      "Diffuses großzelliges B-Zell-Lymphom, Subtyp nicht differenziert",
      "Diffuses immunoblastisches Sarkom",
      "Diffuses retikulozelluläres Sarkom",
      "EBV [Epstein-Barr-Virus]-positives diffuses großzelliges B-Zell-Lymphom des älteren Erwachsenen",
      "Großzelliges B-Zell-Lymphom",
      "Großzelliges diffuses Lymphom",
      "Großzelliges gekerbtes Lymphom",
      "Großzelliges gekerbtes und ungekerbtes Lymphom",
      "Immunoblastisches Non-Hodgkin-Lymphom",
      "Immunoblastisches diffus großzelliges B-Zell-Lymphom",
      "Immunoblastisches diffuses Lymphom",
      "Immunoblastom",
      "Lymphom vom undifferenzierten Non-Burkitt-Typ",
      "Malignes Immunoblastom",
      "PZNSL [Primäres Lymphom des Zentralnervensystems]",
      "Plasmablastisches diffus großzelliges B-Zell-Lymphom",
      "Plasmoblastisches Lymphom",
      "Pleomorphzelliges retikulozelluläres Sarkom",
      "Primär kutanes diffuses großzelliges B-Zell-Lymphom vom Bein-Typ",
      "Primäres Lymphom des Zentralnervensystems",
      "Primäres okulozerebrales Non-Hodgkin-Lymphom",
      "Retikuloendotheliom",
      "Retikuloendothelsarkom",
      "Retikulosarkom",
      "Retikulumzellsarkom",
      "T-Zell-reiches diffus großzelliges B-Zell-Lymphom",
      "T-Zell/histiozytenreiches großzelliges B-Zell-Lymphom",
      "Zentroblastisches Non-Hodgkin-Lymphom",
      "Zentroblastisches diffus großzelliges B-Zell-Lymphom",
      "Zentroblastisches diffuses Lymphom",
      "Zentroblastom"
    ]
  },
  {
    "code": "C83.5",
    "name": "Lymphoblastisches Non-Hodgkin-Lymphom",
    "synonyms": [
      "B-Präkursor-Lymphom a.n.k.",
      "B-Zell-Vorläufer-Lymphom",
      "B-lymphoblastisches Lymphom mit Hyperdiploidie",
      "B-lymphoblastisches Lymphom mit Hypodiploidie",
      "B-lymphoblastisches Lymphom mit rekurrenter genetischer Anomalie",
      "B-lymphoblastisches Lymphom mit t(12",
      "21)(p13.2",
      "q22.1)",
      "B-lymphoblastisches Lymphom mit t(1",
      "19)(q23",
      "p13.3)",
      "B-lymphoblastisches Lymphom mit t(5",
      "14)(q31.1",
      "q32.3)",
      "B-lymphoblastisches Lymphom mit t(9",
      "22)(q34.1",
      "q11.2)",
      "B-lymphoblastisches Lymphom mit t(v",
      "11q23.3)",
      "Convoluted-Cell-Typ-Lymphom",
      "Lymphoblastisches B-Zell-Lymphom",
      "Lymphoblastisches Lymphom",
      "Lymphoblastisches Non-Hodgkin-Lymphom",
      "Lymphoblastisches Sarkom",
      "Lymphoblastisches T-Zell-Lymphom",
      "T-Zell-Vorläufer-Lymphom"
    ]
  },
  {
    "code": "C83.7",
    "name": "Zentralafrikanisches Lymphom",
    "synonyms": [
      "Atypisches Burkitt-Lymphom",
      "Burkitt-Lymphom",
      "Burkitt-Tumor",
      "Burkitt-Tumor-Lymphom",
      "Burkitt-like-Lymphom",
      "Epidemisches Lymphosarkom",
      "Kleinzelliges ungekerbtes Burkitt-Lymphom",
      "Zentralafrikanisches Lymphom"
    ]
  },
  {
    "code": "C83.8",
    "name": "Lymphoide Granulomatose",
    "synonyms": [
      "B-Zell-Lymphom mit primärem Erguss",
      "Hochmalignes B-Zell-Lymphom mit Rearrangement von MYC und BCL2",
      "Hochmalignes B-Zell-Lymphom mit Rearrangement von MYC und BCL6",
      "Hochmalignes B-Zell-Lymphom mit Rearrangement von MYC, BCL2 und BCL6",
      "Intravaskuläres großzelliges B-Zell-Lymphom",
      "LYG [Lymphomatoide Granulomatose]",
      "Lymphoide Granulomatose",
      "Lymphomatoide Granulomatose",
      "Primäres Effusionslymphom"
    ]
  },
  {
    "code": "C83.9",
    "name": "Zentroblastisch-zentrozytisches Lymphom",
    "synonyms": [
      "Bösartige lymphomatöse intestinale Polyposis",
      "Diffuses Germinoblastom",
      "Diffuses Lymphom",
      "Diffuses Lymphom vom Mischzelltyp",
      "Diffuses Non-Hodgkin-Lymphom",
      "Diffuses Retikulolymphosarkom",
      "Histiozytisches diffuses Lymphom",
      "Lymphom vom undifferenzierten Zelltyp",
      "Nicht-follikuläres Lymphom",
      "Nicht-follikuläres diffuses Non-Hodgkin-Lymphom",
      "Undifferenziertes Non-Hodgkin-Lymphom",
      "Ungekerbtes diffuses Lymphom",
      "Zentroblastisch-zentrozytisches Lymphom",
      "Zentroblastisch-zentrozytisches diffuses Lymphom"
    ]
  },
  {
    "code": "C84.0",
    "name": "Mycosis fungoides",
    "synonyms": [
      "Alibert-Bazin-Syndrom",
      "Follikulotrope Mycosis fungoides",
      "Granuloma fungoides",
      "Lokalisierte pagetoide Retikulose",
      "Mycosis fungoides"
    ]
  },
  {
    "code": "C84.1",
    "name": "Sézary-Syndrom",
    "synonyms": [
      "Retikulo-leukämische maligne Erythrodermie",
      "Sézary-Krankheit",
      "Sézary-Lymphom",
      "Sézary-Retikulose",
      "Sézary-Syndrom"
    ]
  },
  {
    "code": "C84.4",
    "name": "T-Zell-Lymphom a.n.k.",
    "synonyms": [
      "Lennert-Lymphom",
      "Lymphoepitheloides Lymphom",
      "Peripheres T-Zell-Lymphom",
      "Peripheres T-Zell-Lymphom, nicht spezifiziert",
      "Pleomorphes kleinzelliges peripheres T-Zell-Lymphom",
      "Pleomorphes mittel- und großzelliges peripheres T-Zell-Lymphom",
      "Primär kutane CD4-positive klein- bis mittelgroßzellige pleomorphe T-Zell-Lymphoproliferation",
      "Primär kutanes CD4-positives klein- bis mittelgroßzelliges pleomorphes T-Zell-Lymphom",
      "Primär kutanes peripheres T-Zell-Lymphom, nicht spezifiziert",
      "T-Zell-Lymphom a.n.k.",
      "T-Zell-Non-Hodgkin-Lymphom",
      "T-Zonenlymphom"
    ]
  },
  {
    "code": "C84.5",
    "name": "Hydroa vacciniformia-artiges Lymphom",
    "synonyms": [
      "Chronische lymphoproliferative Krankheit der NK-Zellen",
      "Hydroa vacciniformia-artiges Lymphom",
      "Primär kutanes aggressives epidermotropes CD8-positives T-Zell-Lymphom",
      "Primär kutanes gamma-delta-positives T-Zell-Lymphom"
    ]
  },
  {
    "code": "C84.6",
    "name": "Großzelliges Ki-1-positives Lymphom",
    "synonyms": [
      "Anaplastisches großzelliges Lymphom, ALK-positiv",
      "Anaplastisches großzelliges Lymphom, CD30-positiv",
      "Großzelliges Ki-1-positives Lymphom"
    ]
  },
  {
    "code": "C84.7",
    "name": "Anaplastisches großzelliges Lymphom, ALK-negativ",
    "synonyms": [
      "Anaplastisches großzelliges Lymphom, ALK-negativ"
    ]
  },
  {
    "code": "C84.8",
    "name": "Kutanes Lymphom",
    "synonyms": [
      "Kutanes Lymphom",
      "Kutanes T-Zell-Lymphom",
      "Primär kutanes T-Zell-Lymphom"
    ]
  },
  {
    "code": "C84.9",
    "name": "Immunoblastisches T-Zell-Lymphom",
    "synonyms": [
      "Immunoblastisches T-Zell-Lymphom",
      "Reifzelliges T/NK-Zell-Lymphom"
    ]
  },
  {
    "code": "C85.1",
    "name": "B-Zell-Lymphom a.n.k.",
    "synonyms": [
      "B-Zell-Lymphom a.n.k.",
      "B-Zell-Non-Hodgkin-Lymphom",
      "Hochmalignes B-Zell-Lymphom",
      "Niedrigmalignes B-Zell-Lymphom",
      "Zerebrales B-Zell-Lymphom"
    ]
  },
  {
    "code": "C85.2",
    "name": "Lymphom des Mediastinums",
    "synonyms": [
      "Lymphom des Mediastinums",
      "Mediastinales thymisches großzelliges B-Zell-Lymphom",
      "Primär mediastinales großzelliges B-Zell-Lymphom"
    ]
  },
  {
    "code": "C85.7",
    "name": "Mikrogliom",
    "synonyms": [
      "Mikrogliom",
      "Primäres Knochenlymphom",
      "Primäres intraokuläres Lymphom"
    ]
  },
  {
    "code": "C85.9",
    "name": "Angioendotheliomatosis",
    "synonyms": [
      "Abdominales Lymphom",
      "Angioendotheliomatosis",
      "Axillalymphom",
      "Bösartiges Lymphom",
      "Chorioidealymphom",
      "Darmlymphom",
      "Diffuses Lymphoblastom",
      "Diffuses Lymphosarkom",
      "Dünndarmlymphom",
      "Gemischtzelliges lymphozytär-histiozytäres Lymphom",
      "Germinoblastom",
      "Großzelliges Lymphom",
      "Großzelliges Non-Hodgkin-Lymphom",
      "Hiläres Lymphom",
      "Histiolymphozytäres Sarkom",
      "Hochmalignes Non-Hodgkin-Lymphom",
      "Konjunktivalymphom",
      "Leukosarkom",
      "Leukosarkom in kompletter Remission",
      "Lidlymphom",
      "Lymphadenom",
      "Lymphoblastisches diffuses Lymphom",
      "Lymphoblastom",
      "Lymphoblastoma",
      "Lymphom",
      "Lymphom vom Mischzelltyp",
      "Lymphom vom histiozytären Typ",
      "Lymphomata",
      "Lymphoretikulosarkom",
      "Lymphosarkom",
      "Lymphozytäres Sarkom",
      "Magenlymphom",
      "Maligne Retikulozytose",
      "Malignes Lymphom",
      "Monozytoides B-Zell-Lymphom",
      "NHL [Non-Hodgkin-Lymphom] - s.a. Non-Hodgkin-Lymphom",
      "Non-Hodgkin-Lymphom a.n.k.",
      "Orbitalymphom",
      "Primäres Bindehaut-Lymphom",
      "Primäres Lungenlymphom",
      "Primäres Magenlymphom",
      "Retikulolymphosarkom",
      "Schilddrüsenlymphom",
      "Zerebrales Lymphom",
      "Zerebrales Non-Hodgkin-Lymphom",
      "Zerebrales Non-Hodgkin-Lymphom hochmaligne"
    ]
  },
  {
    "code": "C86.0",
    "name": "Letales Mittelliniengranulom",
    "synonyms": [
      "Angiozentrische immunproliferative Läsion",
      "Angiozentrischer immunproliferativer Schaden",
      "Angiozentrisches T-Zell-Lymphom",
      "Bösartige Retikulose",
      "Bösartiges mediofaziales Granulom",
      "Extranodales NK/T-Zell-Lymphom vom nasalen Typ",
      "Granuloma gangraenescens nasi",
      "Letales Mittelliniengranulom",
      "Maligne Retikulose",
      "Malignes Granulom des Gesichts",
      "Polymorphe Retikulose"
    ]
  },
  {
    "code": "C86.1",
    "name": "Hepatosplenisches T-Zell-Lymphom",
    "synonyms": [
      "Hepatosplenisches T-Zell-Lymphom"
    ]
  },
  {
    "code": "C86.2",
    "name": "T-Zell-Lymphom vom Enteropathie-Typ",
    "synonyms": [
      "Enteropathie-assoziiertes T-Zell-Lymphom",
      "T-Zell-Lymphom vom Enteropathie-Typ"
    ]
  },
  {
    "code": "C86.3",
    "name": "Subkutanes pannikulitisches T-Zell-Lymphom",
    "synonyms": [
      "Subkutanes pannikulitisches T-Zell-Lymphom"
    ]
  },
  {
    "code": "C86.4",
    "name": "Blastisches NK-Zell-Lymphom",
    "synonyms": [
      "BPDCN [Blastische plasmozytoide dendritische Zellneoplasie]",
      "Blastische plasmozytoide dendritische Zellneoplasie",
      "Blastisches NK-Zell-Lymphom"
    ]
  },
  {
    "code": "C86.5",
    "name": "Angioimmunoblastisches Lymphom [AILD]",
    "synonyms": [
      "Angioimmunoblastische Lymphadenopathie",
      "Angioimmunoblastische Lymphadenopathie mit Dysproteinämie [AILD]",
      "Angioimmunoblastisches Lymphadenom",
      "Angioimmunoblastisches Lymphom [AILD]",
      "Angioimmunoblastisches Non-Hodgkin-Lymphom",
      "Angioimmunoblastisches T-Zell-Lymphom",
      "Angioimmunoblastom"
    ]
  },
  {
    "code": "C86.6",
    "name": "Papulosis lymphomatoides",
    "synonyms": [
      "Lymphomatoide Papulose",
      "Papulosis lymphomatoides",
      "Primär kutane CD30-positive T-Zell-Lymphoproliferation",
      "Primär kutanes CD30-positives großzelliges T-Zell-Lymphom",
      "Primär kutanes anaplastisches großzelliges Lymphom",
      "Primäre kutane CD30-positive T-Zell-Proliferation"
    ]
  },
  {
    "code": "C88.00",
    "name": "Makroglobulinämie",
    "synonyms": [
      "Bing-von-Neel-Syndrom",
      "Idiopathische Makroglobulinämie",
      "Lymphoplasmozytisches Lymphom mit IgM-Produktion",
      "Makroglobulinämie",
      "Makroglobulinämie Waldenström",
      "Morbus Waldenström",
      "Primäre Makroglobulinämie",
      "Waldenström-Syndrom [Makroglobulinämie]"
    ]
  },
  {
    "code": "C88.01",
    "name": "Makroglobulinämie in kompletter Remission",
    "synonyms": [
      "Lymphoplasmozytisches Lymphom mit IgM-Produktion in kompletter Remission",
      "Makroglobulinämie Waldenström in kompletter Remission",
      "Makroglobulinämie in kompletter Remission",
      "Morbus Waldenström in kompletter Remission"
    ]
  },
  {
    "code": "C88.20",
    "name": "Gamma-Schwerkettenkrankheit",
    "synonyms": [
      "Franklin-Krankheit",
      "Franklin-Syndrom",
      "Gamma-Schwerkettenkrankheit",
      "H-Ketten-Krankheit",
      "Heavy chain disease",
      "My-Schwerkettenkrankheit"
    ]
  },
  {
    "code": "C88.21",
    "name": "Gamma-Schwerkettenkrankheit in kompletter Remission",
    "synonyms": [
      "Franklin-Krankheit in kompletter Remission",
      "Gamma-Schwerkettenkrankheit in kompletter Remission",
      "My-Schwerkettenkrankheit in kompletter Remission"
    ]
  },
  {
    "code": "C88.30",
    "name": "Alpha-Schwerkettenkrankheit",
    "synonyms": [
      "Alpha-Schwerkettenkrankheit",
      "Immunoproliferative Erkrankung des Dünndarms",
      "Immunproliferative Dünndarmkrankheit",
      "Immunproliferative Dünndarmkrankheit vom Mittelmeer-Typ",
      "Mediterranes Lymphom"
    ]
  },
  {
    "code": "C88.31",
    "name": "Alpha-Schwerkettenkrankheit in kompletter Remission",
    "synonyms": [
      "Alpha-Schwerkettenkrankheit in kompletter Remission",
      "Immunproliferative Dünndarmkrankheit in kompletter Remission",
      "Immunproliferative Dünndarmkrankheit vom Mittelmeer-Typ in kompletter Remission"
    ]
  },
  {
    "code": "C88.40",
    "name": "MALT [Mucosa Associated Lymphoid Tissue]-Lymphom",
    "synonyms": [
      "Extranodales Marginalzonen-B-Zell-Lymphom des Mukosa-assoziierten lymphatischen Gewebes [MALT-Lymphom]",
      "Lymphom des Bronchus-assoziierten lymphatischen Gewebes [BALT-Lymphom]",
      "Lymphom des Kutis-assoziierten lymphatischen Gewebes [SALT-Lymphom]",
      "Lymphom des Mukosa-assoziierten lymphatischen Gewebes",
      "MALT [Mucosa Associated Lymphoid Tissue]-Lymphom",
      "MALT [Mucosa Associated Lymphoid Tissue]-Lymphom der Lunge",
      "MALT [Mucosa Associated Lymphoid Tissue]-Lymphom des Magens",
      "Mukoassoziiertes Lymphom"
    ]
  },
  {
    "code": "C88.41",
    "name": "Mukoassoziiertes Lymphom in kompletter Remission",
    "synonyms": [
      "Extranodales Marginalzonen-B-Zell-Lymphom des Mukosa-assoziierten lymphatischen Gewebes [MALT-Lymphom] in kompletter Remission",
      "Lymphom des Bronchus-assoziierten lymphatischen Gewebes [BALT-Lymphom] in kompletter Remission",
      "Lymphom des Kutis-assoziierten lymphatischen Gewebes [SALT-Lymphom] in kompletter Remission",
      "Mukoassoziiertes Lymphom in kompletter Remission"
    ]
  },
  {
    "code": "C88.70",
    "name": "Polymorphe posttransplantations-lymphoproliferative Krankheit ohne Angabe einer Remission",
    "synonyms": [
      "PTLD [Post-Transplant Lymphoproliferative Disorder], polymorph",
      "PTLD [Post-Transplant Lymphoproliferative Disorder], polymorph, ohne Angabe einer kompletten Remission",
      "Polymorphe posttransplantations-lymphoproliferative Krankheit in partieller Remission",
      "Polymorphe posttransplantations-lymphoproliferative Krankheit ohne Angabe einer Remission"
    ]
  },
  {
    "code": "C88.71",
    "name": "Polymorphe posttransplantations-lymphoproliferative Krankheit in kompletter Remission",
    "synonyms": [
      "PTLD [Post-Transplant Lymphoproliferative Disorder], polymorph, in kompletter Remission",
      "Polymorphe posttransplantations-lymphoproliferative Krankheit in kompletter Remission"
    ]
  },
  {
    "code": "C88.90",
    "name": "Immunproliferative Krankheit",
    "synonyms": [
      "Immunproliferative Krankheit",
      "Immunproliferative bösartige Neubildung a.n.k."
    ]
  },
  {
    "code": "C88.91",
    "name": "Immunproliferative Krankheit in kompletter Remission",
    "synonyms": [
      "Immunproliferative Krankheit in kompletter Remission"
    ]
  },
  {
    "code": "C90.00",
    "name": "IgG [Immunglobulin G]-Plasmozytom",
    "synonyms": [
      "Anaplastisches Plasmozytom",
      "Bence-Jones-Plasmozytom",
      "Hupert-Krankheit",
      "IgG [Immunglobulin G]-Plasmozytom",
      "Kahler-Buzzolo-Krankheit",
      "Kahler-Krankheit",
      "Malignes Plasmom",
      "Medulläres Plasmozytom",
      "Monostotisches Plasmazellenmyelom",
      "Morbus Kahler",
      "Multipler Plasmazelltumor",
      "Multiples Myelom",
      "Multiples Plasmazellenmyelom",
      "Multiples Plasmozytom",
      "Myelom",
      "Myelomatose",
      "Myelozytom",
      "Plasmazellmyelom",
      "Reticulosis plasmacellularis",
      "Retikulosarkom mit plasmazellulärer Differenzierung"
    ]
  },
  {
    "code": "C90.01",
    "name": "Myelomatose in kompletter Remission",
    "synonyms": [
      "Hupert-Krankheit in kompletter Remission",
      "IgA [Immunglobulin A]-Plasmozytom in kompletter Remission",
      "IgG [Immunglobulin G]-Plasmozytom in kompletter Remission",
      "Kahler-Buzzolo-Krankheit in kompletter Remission",
      "Kahler-Krankheit in kompletter Remission",
      "Malignes Plasmom in kompletter Remission",
      "Medulläres Plasmozytom in kompletter Remission",
      "Morbus Kahler in kompletter Remission",
      "Multiples Myelom in kompletter Remission",
      "Multiples Plasmazellenmyelom in kompletter Remission",
      "Myelom in kompletter Remission",
      "Myelomatose in kompletter Remission",
      "Myelozytom in kompletter Remission",
      "Plasmazellmyelom in kompletter Remission",
      "Plasmozytom in kompletter Remission",
      "Reticulosis plasmacellularis in kompletter Remission",
      "Retikulosarkom mit plasmazellulärer Differenzierung in kompletter Remission"
    ]
  },
  {
    "code": "C90.10",
    "name": "Plasmazellenleukämie",
    "synonyms": [
      "Plasmazellenleukämie",
      "Plasmazelluläre Leukämie",
      "Plasmazytische Leukämie",
      "Plasmozytäre Leukämie"
    ]
  },
  {
    "code": "C90.11",
    "name": "Plasmazellenleukämie in kompletter Remission",
    "synonyms": [
      "Plasmazellenleukämie in kompletter Remission",
      "Plasmazytische Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C90.20",
    "name": "Extramedulläres Plasmozytom",
    "synonyms": [
      "Extramedulläres Plasmozytom",
      "Monostotisches Myelom"
    ]
  },
  {
    "code": "C90.21",
    "name": "Extramedulläres Plasmozytom in kompletter Remission",
    "synonyms": [
      "Extramedulläres Plasmozytom in kompletter Remission"
    ]
  },
  {
    "code": "C90.30",
    "name": "Plasmozytom",
    "synonyms": [
      "Bösartiger Plasmazelltumor",
      "Plasmazellsarkom",
      "Plasmozytom",
      "Plasmozytäres Sarkom",
      "Primäres Plasmozytom des Knochens",
      "Solitärer Plasmazelltumor",
      "Solitäres Myelom",
      "Solitäres Plasmozytom"
    ]
  },
  {
    "code": "C90.31",
    "name": "Nierenmyelom in kompletter Remission",
    "synonyms": [
      "Bösartiger Plasmazelltumor in kompletter Remission",
      "Nierenmyelom in kompletter Remission",
      "Nierenplasmozytom in kompletter Remission",
      "Solitäres Myelom in kompletter Remission"
    ]
  },
  {
    "code": "C91.00",
    "name": "Akute lymphozytäre Leukämie",
    "synonyms": [
      "ALL [Akute lymphatische Leukämie]",
      "Akute lymphatische Leukämie",
      "Akute lymphoblastische Leukämie",
      "Akute lymphoide Leukämie",
      "Akute lymphozytische Leukämie",
      "Akute lymphozytäre Leukämie",
      "B-lymphoblastische Leukämie mit Hyperdiploidie",
      "B-lymphoblastische Leukämie mit Hypodiploidie",
      "B-lymphoblastische Leukämie mit rekurrenter genetischer Anomalie",
      "B-lymphoblastische Leukämie mit t(12",
      "21)(p13.2",
      "q22.1)",
      "B-lymphoblastische Leukämie mit t(1",
      "19)(q23",
      "p13.3)",
      "B-lymphoblastische Leukämie mit t(5",
      "14)(q31.1",
      "q32.3)",
      "B-lymphoblastische Leukämie mit t(9",
      "22)(q34.1",
      "q11.2)",
      "B-lymphoblastische Leukämie mit t(v",
      "11q23.3)",
      "Lymphatische Neoplasie mit assoziiertem JAK2-Rearrangement, akute Form",
      "Lymphoblastenleukämie",
      "Lymphoblastische Leukämie"
    ]
  },
  {
    "code": "C91.01",
    "name": "Akute lymphozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "ALL [Akute lymphatische Leukämie] in kompletter Remission",
      "Akute lymphatische Leukämie in kompletter Remission",
      "Akute lymphoblastische Leukämie in kompletter Remission",
      "Akute lymphoide Leukämie in kompletter Remission",
      "Akute lymphozytäre Leukämie in kompletter Remission",
      "Lymphoblastenleukämie in kompletter Remission"
    ]
  },
  {
    "code": "C91.10",
    "name": "Chronische lymphozytäre Leukämie",
    "synonyms": [
      "Blastenschub einer lymphatischen Leukämie",
      "CLL [Chronische lymphatische Leukämie]",
      "Chronische lymphatische Leukämie",
      "Chronische lymphatische Leukämie vom B-Zell-Typ [CLL]",
      "Chronische lymphoide Leukämie",
      "Chronische lymphozytäre Leukämie",
      "Lymphadenose",
      "Lymphatische Neoplasie mit assoziiertem JAK2-Rearrangement, chronische Form",
      "Lymphoplasmozytoide Leukämie",
      "Richter-Syndrom"
    ]
  },
  {
    "code": "C91.11",
    "name": "Chronische lymphozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "CLL [Chronische lymphatische Leukämie] in kompletter Remission",
      "Chronische lymphatische Leukämie in kompletter Remission",
      "Chronische lymphatische Leukämie vom B-Zell-Typ [CLL] in kompletter Remission",
      "Chronische lymphozytäre Leukämie in kompletter Remission",
      "Lymphadenose in kompletter Remission",
      "Lymphoplasmozytoide Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C91.30",
    "name": "Prolymphozytäre Leukämie",
    "synonyms": [
      "Prolymphozyten-Leukämie vom B-Zell-Typ",
      "Prolymphozytenleukämie",
      "Prolymphozytäre Leukämie"
    ]
  },
  {
    "code": "C91.31",
    "name": "Prolymphozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "Prolymphozyten-Leukämie vom B-Zell-Typ in kompletter Remission",
      "Prolymphozytäre Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C91.40",
    "name": "Haarzellenleukämie",
    "synonyms": [
      "HZL [Haarzell-Leukämie]",
      "HZL-V [Haarzellenleukämie-Variante]",
      "Haarzellenleukämie",
      "Hairy cell leukemia",
      "Leukämische Retikuloendotheliose"
    ]
  },
  {
    "code": "C91.41",
    "name": "Haarzellenleukämie in kompletter Remission",
    "synonyms": [
      "Haarzellenleukämie in kompletter Remission",
      "Leukämische Retikuloendotheliose in kompletter Remission"
    ]
  },
  {
    "code": "C91.50",
    "name": "T-Zellen-Leukämie beim Erwachsenen",
    "synonyms": [
      "Adulte T-Zell-Leukämie (HTLV-1-assoziiert)",
      "Adulte T-Zellen-Leukämie",
      "Adultes T-Zell-Lymphom",
      "Adultes leukämisches T-Zell-Lymphom",
      "Akutes adultes T-Zell-Lymphom",
      "Chronisches adultes T-Zell-Lymphom",
      "Lymphomatöses adultes T-Zell-Lymphom",
      "T-Zell-Leukämie",
      "T-Zellen-Leukämie beim Erwachsenen"
    ]
  },
  {
    "code": "C91.51",
    "name": "T-Zellen-Leukämie beim Erwachsenen in kompletter Remission",
    "synonyms": [
      "Adulte T-Zell-Leukämie (HTLV-1-assoziiert) in kompletter Remission",
      "Adultes T-Zell-Lymphom (HTLV-1-assoziiert) in kompletter Remission",
      "Akutes adultes T-Zell-Lymphom in kompletter Remission",
      "T-Zellen-Leukämie beim Erwachsenen in kompletter Remission"
    ]
  },
  {
    "code": "C91.60",
    "name": "Prolymphozyten-Leukämie vom T-Zell-Typ",
    "synonyms": [
      "Prolymphozyten-Leukämie vom T-Zell-Typ",
      "Promyelozyten-Leukämie vom T-Zell-Typ"
    ]
  },
  {
    "code": "C91.61",
    "name": "Prolymphozyten-Leukämie vom T-Zell-Typ in kompletter Remission",
    "synonyms": [
      "Prolymphozyten-Leukämie vom T-Zell-Typ in kompletter Remission"
    ]
  },
  {
    "code": "C91.70",
    "name": "B-Zellen-Leukämie",
    "synonyms": [
      "B-Zellen-Leukämie",
      "Leukämie grob-granulierter Lymphozyten vom T-Zell-Typ",
      "Lymphatische Neoplasie mit assoziiertem FGFR1-Gen-Rearrangement",
      "Lymphatische Neoplasie mit assoziiertem JAK2-Rearrangement",
      "Lymphatische Neoplasie mit assoziiertem PDGFRA-Gen-Rearrangement",
      "Lymphatische Neoplasie mit assoziiertem PDGFRB-Gen-Rearrangement",
      "T-Zell-Leukämie großer granulärer Lymphozyten"
    ]
  },
  {
    "code": "C91.71",
    "name": "B-Zellen-Leukämie in kompletter Remission",
    "synonyms": [
      "B-Zellen-Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C91.80",
    "name": "Burkitt-Zell-Leukämie",
    "synonyms": [
      "Burkitt-Zell-Leukämie",
      "Reifzellige B-ALL vom Burkitt-Typ"
    ]
  },
  {
    "code": "C91.81",
    "name": "Reifzellige B-ALL vom Burkitt-Typ in kompletter Remission",
    "synonyms": [
      "Reifzellige B-ALL vom Burkitt-Typ in kompletter Remission"
    ]
  },
  {
    "code": "C91.90",
    "name": "Lymphatische Leukämie",
    "synonyms": [
      "Aleukämische lymphatische Leukämie",
      "Aleukämische lymphoide Leukämie",
      "Leukämisches Lymphosarkom",
      "Lymphatische Leukämie",
      "Lymphogene Leukämie",
      "Lymphoide Leukämie",
      "Lymphosarkomatöse Leukämie",
      "Lymphosarkomzellenleukämie",
      "Lymphozytische Leukämie",
      "Lymphozytäre Leukämie",
      "Subakute lymphatische Leukämie",
      "Subakute lymphoide Leukämie",
      "Subakute lymphozytäre Leukämie"
    ]
  },
  {
    "code": "C91.91",
    "name": "Subakute lymphozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "Lymphatische Leukämie in kompletter Remission",
      "Lymphosarkomzellenleukämie in kompletter Remission",
      "Lymphozytäre Leukämie in kompletter Remission",
      "Subakute lymphatische Leukämie in kompletter Remission",
      "Subakute lymphozytäre Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C92.00",
    "name": "Akute myeloische Leukämie",
    "synonyms": [
      "AML M0",
      "AML M1",
      "AML M2",
      "AML [Akute myeloische Leukämie]",
      "AML mit t(8",
      "21)",
      "AML1/ETO",
      "Akute Myelose",
      "Akute granulozytäre Leukämie",
      "Akute minimal differenzierte myeloische Leukämie",
      "Akute myeloblastische Leukämie",
      "Akute myelogene Leukämie",
      "Akute myeloische Leukämie",
      "Akute myeloische Leukämie bei familiärem Monosomie-7-Syndrom",
      "Akute myeloische Leukämie durch Topoisomerase-Typ-II-Inhibitor",
      "Akute myeloische Leukämie durch ionisierende Strahlung",
      "Akute myeloische Leukämie mit Ausreifung",
      "Akute myeloische Leukämie mit Translokation t(8",
      "16)(p11",
      "p13)",
      "Akute myeloische Leukämie mit inv3(q21q26.2)",
      "Akute myeloische Leukämie mit minimaler Ausreifung",
      "Akute myeloische Leukämie mit minimaler Differenzierung",
      "Akute myeloische Leukämie mit somatischen CEBPA-Genmutationen",
      "Akute myeloische Leukämie mit somatischen NPM1-Genmutationen",
      "Akute myeloische Leukämie mit t(3",
      "3)(q21",
      "q26.2)",
      "Akute myeloische Leukämie mit t(6",
      "9) (p23",
      "q34)",
      "Akute myeloische Leukämie mit t(8",
      "21)(q22",
      "q22)",
      "Akute myeloische Leukämie mit t(9",
      "11) (p22",
      "q23)",
      "Akute myeloische Leukämie mit t(9",
      "22)(q34.1",
      "q11.2)",
      "Akute myeloische Leukämie ohne Ausreifung",
      "Akute myelozytäre Leukämie",
      "Alkylanzien-induzierte akute myeloische Leukämie",
      "Familiäre akute myeloische Leukämie",
      "Granulozytäre Blastzellenleukämie",
      "Myeloische Neoplasie mit assoziiertem JAK2-Rearrangement, akute Form",
      "Primär therapierefraktäre akute myeloische Leukämie",
      "Refraktäre Anämie mit Blastenkrise in Transformation",
      "Refraktäre Anämie mit Blastenüberschuss in Transformation"
    ]
  },
  {
    "code": "C92.01",
    "name": "Akute myeloische Leukämie in kompletter Remission",
    "synonyms": [
      "AML [Akute myeloische Leukämie] in kompletter Remission",
      "Akute myeloische Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C92.10",
    "name": "Chronische granulozytäre Leukämie",
    "synonyms": [
      "CML [Chronische myeloische Leukämie]",
      "Chronische granulozytäre Leukämie",
      "Chronische myelogene Leukämie",
      "Chronische myeloische Leukämie",
      "Chronische myeloische Leukämie, BCR/ABL-positiv",
      "Chronische myeloische Leukämie, Philadelphia-Chromosom (Ph1) positiv",
      "Chronische myeloische Leukämie, t(9",
      "22) (q34",
      "q11)",
      "Chronische myelozytäre Leukämie",
      "Myeloische Neoplasie mit assoziiertem JAK2-Rearrangement, chronische Form"
    ]
  },
  {
    "code": "C92.11",
    "name": "Chronische myeloische Leukämie in kompletter Remission",
    "synonyms": [
      "CML [Chronische myeloische Leukämie] in kompletter Remission",
      "Chronische granulozytäre Leukämie in kompletter Remission",
      "Chronische myeloische Leukämie in kompletter Remission",
      "Chronische myeloische Leukämie, BCR/ABL-positiv in kompletter Remission",
      "Chronische myeloische Leukämie, Philadelphia-Chromosom (Ph1) positiv in kompletter Remission",
      "Chronische myeloische Leukämie, t(9",
      "22) (q34",
      "q11) in kompletter Remission"
    ]
  },
  {
    "code": "C92.20",
    "name": "Subakute myeloische Leukämie",
    "synonyms": [
      "Atypische chronische myeloische Leukämie",
      "Atypische chronische myeloische Leukämie, BCR/ABL-negativ",
      "Atypische myeloische Leukämie",
      "Subakute granulozytäre Leukämie",
      "Subakute myelogene Leukämie",
      "Subakute myeloische Leukämie"
    ]
  },
  {
    "code": "C92.21",
    "name": "Subakute myeloische Leukämie in kompletter Remission",
    "synonyms": [
      "Atypische chronische myeloische Leukämie, BCR/ABL-negativ, in kompletter Remission",
      "Subakute myeloische Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C92.30",
    "name": "Granulozytäres Sarkom",
    "synonyms": [
      "Aran-Krebs [Chlorom]",
      "Cancer xanthosus [Chlorom]",
      "Chlorom",
      "Extramedullärer myeloischer Tumor",
      "Granulozytäres Sarkom",
      "Monozytäres Sarkom",
      "Myeloisches Sarkom",
      "Myelosarkom",
      "Pseudoleukämisches Sarkom"
    ]
  },
  {
    "code": "C92.31",
    "name": "Chlorom in kompletter Remission",
    "synonyms": [
      "Aran-Krebs [Chlorom] in kompletter Remission",
      "Cancer xanthosus [Chlorom] in kompletter Remission",
      "Chlorom in kompletter Remission",
      "Granulozytäres Sarkom in kompletter Remission",
      "Monozytäres Sarkom in kompletter Remission",
      "Myeloisches Sarkom in kompletter Remission",
      "Myelosarkom in kompletter Remission",
      "Pseudoleukämisches Sarkom in kompletter Remission"
    ]
  },
  {
    "code": "C92.40",
    "name": "Promyelozyten-Leukämie",
    "synonyms": [
      "AML M3",
      "AML mit t(15",
      "17)",
      "Akute Promyelozyten-Leukämie [PCL]",
      "Akute promyelozytäre Leukämie",
      "PML [Akute promyelozytäre Leukämie]",
      "Promyelozyten-Leukämie"
    ]
  },
  {
    "code": "C92.41",
    "name": "Promyelozyten-Leukämie in kompletter Remission",
    "synonyms": [
      "AML M3 in kompletter Remission",
      "AML mit t(15",
      "17) in kompletter Remission",
      "Akute promyelozytäre Leukämie in kompletter Remission",
      "PML [Akute promyelozytäre Leukämie] in kompletter Remission",
      "Promyelozyten-Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C92.50",
    "name": "Akute myelomonozytäre Leukämie",
    "synonyms": [
      "AML M4",
      "AML mit Eo mit inv(16)",
      "AML mit Eo mit t(16",
      "16)",
      "Akute myeloische Leukämie mit abnormen Eosinophilen und inv(16) (p13q22)",
      "Akute myeloische Leukämie mit abnormen Eosinophilen und t(16",
      "16) (p13",
      "q22)",
      "Akute myelomonozytäre Leukämie",
      "Myeloische monozytäre Leukämie"
    ]
  },
  {
    "code": "C92.51",
    "name": "Akute myelomonozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "AML M4 in kompletter Remission",
      "AML mit Eo mit inv(16) in kompletter Remission",
      "AML mit Eo mit t(16",
      "16) in kompletter Remission",
      "Akute myelomonozytäre Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C92.60",
    "name": "Akute myeloische Leukämie mit 11q23-Abnormität",
    "synonyms": [
      "Akute myeloische Leukämie mit 11q23-Abnormität",
      "Akute myeloische Leukämie mit Veränderungen des MLL-Gens"
    ]
  },
  {
    "code": "C92.61",
    "name": "Akute myeloische Leukämie mit 11q23-Abnormität in kompletter Remission",
    "synonyms": [
      "Akute myeloische Leukämie mit 11q23-Abnormität in kompletter Remission"
    ]
  },
  {
    "code": "C92.70",
    "name": "Eosinophile Leukämie",
    "synonyms": [
      "Eosinophile Leukämie",
      "Myeloische Neoplasie mit assoziiertem FGFR1-Gen-Rearrangement",
      "Myeloische Neoplasie mit assoziiertem JAK2-Rearrangement",
      "Myeloische Neoplasie mit assoziiertem PDGFRA-Gen-Rearrangement",
      "Myeloische Neoplasie mit assoziiertem PDGFRB-Gen-Rearrangement"
    ]
  },
  {
    "code": "C92.80",
    "name": "Akute myeloische Leukämie mit multilineärer Dysplasie",
    "synonyms": [
      "Akute myeloische Leukämie mit multilineärer Dysplasie"
    ]
  },
  {
    "code": "C92.81",
    "name": "Akute myeloische Leukämie mit multilineärer Dysplasie in kompletter Remission",
    "synonyms": [
      "Akute myeloische Leukämie mit multilineärer Dysplasie in kompletter Remission"
    ]
  },
  {
    "code": "C92.90",
    "name": "Granulozytäre Leukämie",
    "synonyms": [
      "Aleukämische Myelose",
      "Aleukämische granulozytäre Leukämie",
      "Aleukämische myelogene Leukämie",
      "Aleukämische myeloische Leukämie",
      "Granulozytäre Leukämie",
      "Monomyelozytäre Leukämie",
      "Myelogene Leukämie",
      "Myeloide Leukämie",
      "Myeloische Leukämie",
      "Myelose",
      "Myelozytäre Leukämie",
      "Subakute Myelose"
    ]
  },
  {
    "code": "C92.91",
    "name": "Granulozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "Granulozytäre Leukämie in kompletter Remission",
      "Myelogene Leukämie in kompletter Remission",
      "Myeloische Leukämie in kompletter Remission",
      "Myelose in kompletter Remission"
    ]
  },
  {
    "code": "C93.00",
    "name": "Akute Monozytenleukämie",
    "synonyms": [
      "AML M5",
      "AML M5a",
      "AML M5b",
      "Akute Monoblastenleukämie",
      "Akute Monozytenleukämie",
      "Akute monoblastische Leukämie"
    ]
  },
  {
    "code": "C93.01",
    "name": "Akute Monozytenleukämie in kompletter Remission",
    "synonyms": [
      "AML M5 in kompletter Remission",
      "AML M5a in kompletter Remission",
      "AML M5b in kompletter Remission",
      "Akute Monoblastenleukämie in kompletter Remission",
      "Akute Monozytenleukämie in kompletter Remission"
    ]
  },
  {
    "code": "C93.10",
    "name": "Chronische Monozytenleukämie",
    "synonyms": [
      "CMML [Chronische myelomonozytäre Leukämie]",
      "CMML [Chronische myelomonozytäre Leukämie] mit Eosinophilie",
      "CMML-1",
      "CMML-2",
      "Chronische Monozytenleukämie",
      "Chronische monozytäre Leukämie",
      "Chronische myelomonozytäre Leukämie",
      "Monozytäre Naegeli-Leukämie"
    ]
  },
  {
    "code": "C93.11",
    "name": "Monozytäre Naegeli-Leukämie in kompletter Remission",
    "synonyms": [
      "CMML [Chronische myelomonozytäre Leukämie] in kompletter Remission",
      "CMML [Chronische myelomonozytäre Leukämie] mit Eosinophilie in kompletter Remission",
      "CMML-1 in kompletter Remission",
      "CMML-2 in kompletter Remission",
      "Chronische Monozytenleukämie in kompletter Remission",
      "Chronische monozytäre Leukämie in kompletter Remission",
      "Chronische myelomonozytäre Leukämie in kompletter Remission",
      "Monozytäre Naegeli-Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C93.30",
    "name": "Juvenile myelomonozytäre Leukämie",
    "synonyms": [
      "JMML [Juvenile myelomonozytäre Leukämie]",
      "Juvenile myelomonozytäre Leukämie"
    ]
  },
  {
    "code": "C93.31",
    "name": "Juvenile myelomonozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "JMML [Juvenile myelomonozytäre Leukämie] in kompletter Remission",
      "Juvenile myelomonozytäre Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C93.90",
    "name": "Monozytenleukämie",
    "synonyms": [
      "Aleukämische monozytäre Leukämie",
      "Histiomonozytäre Leukämie",
      "Histiozytäre Leukämie",
      "Monozytenleukämie",
      "Monozytoide Leukämie",
      "Schilling-Typ der monozytären Leukämie",
      "Subakute monozytäre Leukämie"
    ]
  },
  {
    "code": "C93.91",
    "name": "Subakute monozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "Monozytenleukämie in kompletter Remission",
      "Monozytoide Leukämie in kompletter Remission",
      "Subakute monozytäre Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C94.00",
    "name": "Erythrämie",
    "synonyms": [
      "AML M6",
      "Akute Erythroleukämie",
      "Akute Erythrose",
      "Akute Erythrämie",
      "Akute erythrämische Myelose",
      "Akute myeloische Leukämie, M6 (a) (b)",
      "Di-Guglielmo-Krankheit",
      "Di-Guglielmo-Syndrom",
      "Erythroleukoblastose",
      "Erythroleukose",
      "Erythroleukämie",
      "Erythroleukämische Myelose",
      "Erythrozythämie",
      "Erythrämie",
      "Erythrämische Myelose"
    ]
  },
  {
    "code": "C94.01",
    "name": "Erythrämie in kompletter Remission",
    "synonyms": [
      "Akute Erythroleukämie in kompletter Remission",
      "Akute Erythrose in kompletter Remission",
      "Akute Erythrämie in kompletter Remission",
      "Akute erythrämische Myelose in kompletter Remission",
      "Akute myeloische Leukämie, M6 (a) (b) in kompletter Remission",
      "Di-Guglielmo-Krankheit in kompletter Remission",
      "Erythroleukoblastose in kompletter Remission",
      "Erythroleukämie in kompletter Remission",
      "Erythroleukämische Myelose in kompletter Remission",
      "Erythrozythämie in kompletter Remission",
      "Erythrämie in kompletter Remission"
    ]
  },
  {
    "code": "C94.20",
    "name": "Megakaryozytäre Leukämie",
    "synonyms": [
      "Akute Megakaryoblastenleukämie",
      "Akute megakaryozytäre Leukämie",
      "Akute myeloische Leukämie, M7",
      "Megakaryoblastische Leukämie",
      "Megakaryoblastische akute myeloische Leukämie mit t(1",
      "22) (p13",
      "q13)",
      "Megakaryozytoide Leukämie",
      "Megakaryozytose",
      "Megakaryozytäre Leukämie",
      "Thrombozytäre Leukämie"
    ]
  },
  {
    "code": "C94.21",
    "name": "Megakaryozytäre Leukämie in kompletter Remission",
    "synonyms": [
      "Akute Megakaryoblastenleukämie in kompletter Remission",
      "Akute myeloische Leukämie, M7 in kompletter Remission",
      "Megakaryozytose in kompletter Remission",
      "Megakaryozytäre Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C94.30",
    "name": "Mastzellenleukämie",
    "synonyms": [
      "Akute Mastzellenleukämie",
      "Aleukämische Variante der Mastzellleukämie",
      "Basophile Leukämie",
      "Chronische Mastzellenleukämie",
      "Mastzellenleukämie"
    ]
  },
  {
    "code": "C94.31",
    "name": "Mastzellenleukämie in kompletter Remission",
    "synonyms": [
      "Basophile Leukämie in kompletter Remission",
      "Mastzellenleukämie in kompletter Remission"
    ]
  },
  {
    "code": "C94.40",
    "name": "Panmyelose",
    "synonyms": [
      "Akute Myelofibrose",
      "Akute Myelosklerose",
      "Akute Panmyelose",
      "Akute Panmyelose mit Myelofibrose",
      "Panmyelose"
    ]
  },
  {
    "code": "C94.41",
    "name": "Panmyelose in kompletter Remission",
    "synonyms": [
      "Akute Myelofibrose in kompletter Remission",
      "Akute Panmyelose in kompletter Remission",
      "Akute Panmyelose mit Myelofibrose in kompletter Remission",
      "Panmyelose in kompletter Remission"
    ]
  },
  {
    "code": "C94.60",
    "name": "Nicht klassifizierbare myelodysplastische Krankheit",
    "synonyms": [
      "Nicht klassifizierbare myelodysplastische Krankheit",
      "Nicht klassifizierbare myelodysplastische und myeloproliferative Krankheit",
      "Nicht klassifizierbare myeloproliferative Krankheit"
    ]
  },
  {
    "code": "C94.61",
    "name": "Nicht klassifizierbare myelodysplastische Krankheit in kompletter Remission",
    "synonyms": [
      "Nicht klassifizierbare myelodysplastische Krankheit in kompletter Remission",
      "Nicht klassifizierbare myeloproliferative Krankheit in kompletter Remission"
    ]
  },
  {
    "code": "C94.70",
    "name": "Aggressive NK-Zell-Leukämie",
    "synonyms": [
      "Aggressive NK-Zell-Leukämie",
      "Akute Basophilenleukämie"
    ]
  },
  {
    "code": "C94.71",
    "name": "Aggressive NK-Zell-Leukämie in kompletter Remission",
    "synonyms": [
      "Aggressive NK-Zell-Leukämie in kompletter Remission",
      "Akute Basophilenleukämie in kompletter Remission"
    ]
  },
  {
    "code": "C95.00",
    "name": "Akute Leukämie a.n.k.",
    "synonyms": [
      "Akute Leukämie a.n.k.",
      "Akute Leukämie mit gemischtem Phänotyp",
      "Akute Leukämie mit gemischtem Phänotyp mit t(9",
      "22)(q34.1",
      "q11.2)",
      "Akute Leukämie mit gemischtem Phänotyp mit t(v",
      "11q23.3)",
      "Akute biliniäre Leukämie",
      "Akute gemischt-liniäre Leukämie",
      "Akute undifferenzierte Leukämie",
      "Akute unreifzellige Leukämie",
      "Biphänotypische akute Leukämie",
      "Blastenleukämie",
      "Blastzellenleukämie",
      "Gemischte myeloisch-lymphatische Neoplasie mit assoziiertem JAK2-Rearrangement, akute Form",
      "Stammzellenleukämie",
      "Stammzellenleukämie mit unklarer Linienzuordnung"
    ]
  },
  {
    "code": "C95.01",
    "name": "Akute Leukämie in kompletter Remission",
    "synonyms": [
      "Akute Leukämie in kompletter Remission",
      "Akute biliniäre Leukämie in kompletter Remission",
      "Akute gemischt-liniäre Leukämie in kompletter Remission",
      "Biphänotypische akute Leukämie in kompletter Remission",
      "Blastenleukämie in kompletter Remission",
      "Blastzellenleukämie in kompletter Remission",
      "Stammzellenleukämie in kompletter Remission",
      "Stammzellenleukämie mit unklarer Linienzuordnung in kompletter Remission"
    ]
  },
  {
    "code": "C95.10",
    "name": "Chronische Leukämie a.n.k.",
    "synonyms": [
      "Chronische Leukämie a.n.k.",
      "Gemischte myeloisch-lymphatische Neoplasie mit assoziiertem JAK2-Rearrangement, chronische Form"
    ]
  },
  {
    "code": "C95.11",
    "name": "Chronische Leukämie in kompletter Remission",
    "synonyms": [
      "Chronische Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C95.70",
    "name": "Aleukämie",
    "synonyms": [
      "Aleukämie",
      "Aleukämische Leukämie a.n.k."
    ]
  },
  {
    "code": "C95.71",
    "name": "Aleukämie in kompletter Remission",
    "synonyms": [
      "Aleukämie in kompletter Remission"
    ]
  },
  {
    "code": "C95.90",
    "name": "Leukoblastose",
    "synonyms": [
      "Chemotherapieinduzierte Leukämie",
      "Leucaemia",
      "Leukoblastose",
      "Leukose - s.a. Leukämie",
      "Leukämie",
      "Leukämische Infiltration",
      "Sekundäre Leukämie durch Bestrahlung",
      "Subakute Leukämie a.n.k."
    ]
  },
  {
    "code": "C95.91",
    "name": "Subakute Leukämie in kompletter Remission",
    "synonyms": [
      "Leukoblastose in kompletter Remission",
      "Leukose in kompletter Remission",
      "Leukämie in kompletter Remission",
      "Subakute Leukämie in kompletter Remission"
    ]
  },
  {
    "code": "C96.0",
    "name": "Reticulosis maligna",
    "synonyms": [
      "Abt-Letterer-Siwe-Krankheit",
      "Abt-Letterer-Siwe-Syndrom",
      "Akute Granulomatose der Langerhans-Zellen",
      "Akute Histiozytose X",
      "Akute Retikuloendotheliose",
      "Akute Retikuloendotheliose beim Säugling",
      "Akute Retikulose beim Säugling",
      "Akute differenzierte progressive Histiozytose",
      "Akute und disseminierte Langerhans-Zell-Histiozytose",
      "Aleukämische Retikulose",
      "Infektiöse Retikuloendotheliose",
      "Infektiöse Retikulose",
      "Letterer-Retikuloendotheliose",
      "Letterer-Retikulose",
      "Letterer-Siwe-Krankheit",
      "Multifokale und multisystemische Langerhans-Zell-Histiozytose",
      "Multisystemische Histiozytose X",
      "Reticulosis maligna",
      "Retikuloendotheliose ohne Lipidspeicherung",
      "Retikuloendotheliose ohne Lipoidspeicherung"
    ]
  },
  {
    "code": "C96.2",
    "name": "Maligner Mastzellentumor",
    "synonyms": [
      "Aggressive systemische Mastozytose",
      "Bösartige Mastozytose",
      "Bösartiger Mastzelltumor",
      "Bösartiges Mastozytom",
      "Extrakutanes Mastozytom",
      "Maligne Mastozytose",
      "Maligner Mastzellentumor",
      "Malignes Mastozytom",
      "Mastzellensarkom"
    ]
  },
  {
    "code": "C96.4",
    "name": "Langerhans-Zell-Sarkom",
    "synonyms": [
      "Histiozytose der indeterminierten Zellen",
      "Indeterminanter dendritischer Zelltumor",
      "Langerhans-Zell-Sarkom",
      "Sarkom der dendritischen Zellen",
      "Sarkom der dendritischen Zellen, nicht spezifiziert",
      "Sarkom der follikulären dendritischen Zellen",
      "Sarkom der interdigitierenden dendritischen Zellen"
    ]
  },
  {
    "code": "C96.5",
    "name": "Hand-Schüller-Christian-Krankheit",
    "synonyms": [
      "Hand-Schüller-Christian-Krankheit",
      "Hand-Schüller-Christian-Syndrom",
      "Multifokale Histiocytosis X",
      "Multifokale und unisystemische Langerhans-Zell-Histiozytose",
      "Pulmonale Histiocytosis X",
      "Schüller-Christian-Krankheit",
      "Schüller-Christian-Syndrom"
    ]
  },
  {
    "code": "C96.6",
    "name": "X-Histiozytose",
    "synonyms": [
      "Chronische Histiocytosis X",
      "Chronische Langerhans-Zell-Granulomatose",
      "Eosinophiles Granulom",
      "Eosinophiles Knochengranulom",
      "Eosinophiles Lungengranulom",
      "Histiocytosis X",
      "Langerhans-Zell-Granulomatose a.n.k.",
      "Langerhans-Zell-Histiozytose a.n.k.",
      "Lipoidhistiozytose",
      "Liporetikulose",
      "Unifokale Histiocytosis X",
      "Unifokale Langerhans-Zell-Histiozytose",
      "X-Histiozytose"
    ]
  },
  {
    "code": "C96.8",
    "name": "Bösartige Histiozytose",
    "synonyms": [
      "Bösartige Histiozytose",
      "Echtes histiozytäres Lymphom",
      "Histiozytische medulläre Retikulose",
      "Histiozytisches Sarkom",
      "Maligne Histiozytose"
    ]
  },
  {
    "code": "C96.9",
    "name": "Knochenmarkmalignom",
    "synonyms": [
      "Bösartige Erkrankung des Blutes und des Lymphsystems",
      "Bösartige Erkrankung des Lymphsystems",
      "Bösartige Neubildung des Knochenmarks a.n.k.",
      "Bösartige Neubildung des blutbildenden Gewebes",
      "Bösartige Neubildung des hämatopoetischen Gewebes a.n.k.",
      "Bösartige Neubildung des lymphatischen und blutbildenden Gewebes",
      "Bösartige Neubildung des lymphatischen und histiozytären Systems",
      "Hämoblastose",
      "Knochenmarkkarzinose",
      "Knochenmarkmalignom",
      "Retikulozelluläres noduläres Sarkom"
    ]
  },
  {
    "code": "D00.0",
    "name": "Carcinoma in situ des Oropharynx",
    "synonyms": [
      "Bukkales Carcinoma in situ",
      "Carcinoma in situ der Alveolarfortsatzschleimhaut",
      "Carcinoma in situ der Alveolarkammschleimhaut",
      "Carcinoma in situ der Alveolarschleimhaut",
      "Carcinoma in situ der Außenseite der Lippe",
      "Carcinoma in situ der Außenseite der Oberlippe",
      "Carcinoma in situ der Außenseite der Unterlippe",
      "Carcinoma in situ der Choane",
      "Carcinoma in situ der Fauces",
      "Carcinoma in situ der Fossa piriformis",
      "Carcinoma in situ der Fossa tonsillaris",
      "Carcinoma in situ der Gaumenbogentonsillen",
      "Carcinoma in situ der Gaumenmandel a.n.k.",
      "Carcinoma in situ der Gingiva",
      "Carcinoma in situ der Hinterwand des Oropharynx",
      "Carcinoma in situ der Innenseite der Lippe",
      "Carcinoma in situ der Kiemenspalte",
      "Carcinoma in situ der Lippe",
      "Carcinoma in situ der Lippenkommissur",
      "Carcinoma in situ der Lippenrotgrenze",
      "Carcinoma in situ der Mundhöhle",
      "Carcinoma in situ der Mundschleimhaut a.n.k.",
      "Carcinoma in situ der Nebenspeicheldrüse a.n.k.",
      "Carcinoma in situ der Oberfläche der Epiglottis",
      "Carcinoma in situ der Oberkieferalveolarschleimhaut",
      "Carcinoma in situ der Oberkiefergingiva",
      "Carcinoma in situ der Oberlippe",
      "Carcinoma in situ der Ohrspeicheldrüse",
      "Carcinoma in situ der Parotis",
      "Carcinoma in situ der Pharynxtonsille",
      "Carcinoma in situ der Pharynxwand",
      "Carcinoma in situ der Plica aryepiglottica",
      "Carcinoma in situ der Plica glossoepiglottica",
      "Carcinoma in situ der Rachenmandel",
      "Carcinoma in situ der Randzone der Plica aryepiglottica",
      "Carcinoma in situ der Randzone der aryepiglottischen Falte",
      "Carcinoma in situ der Regio postcricoidea",
      "Carcinoma in situ der Retromolarregion",
      "Carcinoma in situ der Rosenmüller-Grube",
      "Carcinoma in situ der Seitenwand des Oropharynx",
      "Carcinoma in situ der Speicheldrüsen",
      "Carcinoma in situ der Tonsilla lingualis",
      "Carcinoma in situ der Tonsilla palatina",
      "Carcinoma in situ der Tonsilla pharyngea",
      "Carcinoma in situ der Tonsillen",
      "Carcinoma in situ der Unterkieferalveolarschleimhaut",
      "Carcinoma in situ der Unterkiefergingiva",
      "Carcinoma in situ der Unterkieferspeicheldrüse",
      "Carcinoma in situ der Unterlippe",
      "Carcinoma in situ der Unterzungenspeicheldrüse",
      "Carcinoma in situ der Uvula",
      "Carcinoma in situ der Vallecula epiglottica",
      "Carcinoma in situ der Vorderfläche der Epiglottis",
      "Carcinoma in situ der Wand des Nasenrachenraums",
      "Carcinoma in situ der Wangeninnenseite",
      "Carcinoma in situ der Wangenschleimhaut",
      "Carcinoma in situ der Zunge",
      "Carcinoma in situ der Zungenmandel",
      "Carcinoma in situ der Zungenmittellinie a.n.k.",
      "Carcinoma in situ der Zungenoberfläche",
      "Carcinoma in situ der Zungenspitze",
      "Carcinoma in situ der Zungenwurzel",
      "Carcinoma in situ der aryepiglottischen Falte",
      "Carcinoma in situ der bukkalen Schleimhaut",
      "Carcinoma in situ der hinteren Oberfläche des weichen Gaumens",
      "Carcinoma in situ der hinteren Wand des Hypopharynx",
      "Carcinoma in situ der hinteren Wand des Nasenrachenraums",
      "Carcinoma in situ der hinteren Zunge",
      "Carcinoma in situ der hypopharyngealen Seite der Plica aryepiglottica",
      "Carcinoma in situ der hypopharyngealen Seite der aryepiglottischen Falte",
      "Carcinoma in situ der oberen Wand des Nasenrachenraums",
      "Carcinoma in situ der pharyngealen Fornix",
      "Carcinoma in situ der seitlichen Wand des Nasenrachenraums",
      "Carcinoma in situ der vorderen Wand des Nasenrachenraums",
      "Carcinoma in situ der vorderen Zunge a.n.k.",
      "Carcinoma in situ der Übergangsregion des Oropharynx",
      "Carcinoma in situ der Übergangszone der Zunge",
      "Carcinoma in situ des Arcus palatoglossus",
      "Carcinoma in situ des Arcus palatopharyngeus",
      "Carcinoma in situ des Bodens des Nasenrachenraums",
      "Carcinoma in situ des Daches des Nasenrachenraums",
      "Carcinoma in situ des Ductus parotideus",
      "Carcinoma in situ des Ductus sublingualis",
      "Carcinoma in situ des Ductus submandibularis",
      "Carcinoma in situ des Fornix pharyngis",
      "Carcinoma in situ des Frenulum linguae",
      "Carcinoma in situ des Gaumenbogens",
      "Carcinoma in situ des Gaumens",
      "Carcinoma in situ des Hypopharynx",
      "Carcinoma in situ des Krikopharynx",
      "Carcinoma in situ des Laryngopharynx",
      "Carcinoma in situ des Lippenstiftbereiches",
      "Carcinoma in situ des Mundbodens",
      "Carcinoma in situ des Mundhöhlendache"
    ]
  },
  {
    "code": "D00.1",
    "name": "Carcinoma in situ des Ösophagus",
    "synonyms": [
      "Carcinoma in situ der Pars abdominalis des Ösophagus",
      "Carcinoma in situ der Pars cervicalis des Ösophagus",
      "Carcinoma in situ der Pars thoracica des Ösophagus",
      "Carcinoma in situ des Ösophagus",
      "Hochgradige Dysplasie bei Barrett-Ösophagus"
    ]
  },
  {
    "code": "D00.2",
    "name": "Carcinoma in situ des Magens",
    "synonyms": [
      "Carcinoma in situ der Kardia des Magens",
      "Carcinoma in situ der Magenwand a.n.k.",
      "Carcinoma in situ der großen Kurvatur des Magens a.n.k.",
      "Carcinoma in situ der hinteren Magenwand a.n.k.",
      "Carcinoma in situ der kleinen Kurvatur des Magens a.n.k.",
      "Carcinoma in situ der vorderen Magenwand a.n.k.",
      "Carcinoma in situ des Antrum pyloricum",
      "Carcinoma in situ des Canalis pyloricus",
      "Carcinoma in situ des Corpus ventriculi",
      "Carcinoma in situ des Magenantrums",
      "Carcinoma in situ des Mageneingangs",
      "Carcinoma in situ des Magenfundus",
      "Carcinoma in situ des Magenkorpus",
      "Carcinoma in situ des Magens",
      "Carcinoma in situ des Ostium cardiacum",
      "Carcinoma in situ des Präpylorus",
      "Carcinoma in situ des Pylorus",
      "Carcinoma in situ des gastroösophagealen Überganges",
      "Carcinoma in situ des kardioösophagealen Überganges"
    ]
  },
  {
    "code": "D01.0",
    "name": "Carcinoma in situ des Dickdarmes",
    "synonyms": [
      "Carcinoma in situ der Appendix",
      "Carcinoma in situ der Flexura coli dextra",
      "Carcinoma in situ der Flexura coli hepatica",
      "Carcinoma in situ der Flexura coli lienalis",
      "Carcinoma in situ der Flexura coli sigmoidei",
      "Carcinoma in situ der Flexura coli sinistra",
      "Carcinoma in situ der hepatischen Kolonflexur",
      "Carcinoma in situ des Colon ascendens",
      "Carcinoma in situ des Colon descendens",
      "Carcinoma in situ des Colon pelvinum",
      "Carcinoma in situ des Colon sigmoideum",
      "Carcinoma in situ des Colon transversum",
      "Carcinoma in situ des Dickdarmes",
      "Carcinoma in situ des Ileozäkums",
      "Carcinoma in situ des Kolons",
      "Carcinoma in situ des Sigmas",
      "Carcinoma in situ des Zäkums",
      "Carcinoma in situ des distalen Kolons",
      "Carcinoma in situ des ileozäkalen Überganges",
      "Carcinoma in situ des linken Kolons",
      "Carcinoma in situ des rechten Kolons"
    ]
  },
  {
    "code": "D01.1",
    "name": "Carcinoma in situ des rektosigmoidalen Überganges",
    "synonyms": [
      "Carcinoma in situ des Kolons und des Rektums",
      "Carcinoma in situ des Rektosigmoids",
      "Carcinoma in situ des pelvikorektalen Überganges",
      "Carcinoma in situ des pelvirektalen Überganges",
      "Carcinoma in situ des rektosigmoidalen Überganges"
    ]
  },
  {
    "code": "D01.2",
    "name": "Carcinoma in situ des Rektums",
    "synonyms": [
      "Carcinoma in situ des Rektums"
    ]
  },
  {
    "code": "D01.3",
    "name": "Carcinoma in situ des Analkanals",
    "synonyms": [
      "Carcinoma in situ der Hämorrhoidalzone",
      "Carcinoma in situ der Kloake",
      "Carcinoma in situ der Morgagni-Krypten",
      "Carcinoma in situ des Analkanals",
      "Carcinoma in situ des Analsphinkters",
      "Carcinoma in situ des Anus",
      "Carcinoma in situ des Sphincter ani"
    ]
  },
  {
    "code": "D01.4",
    "name": "Intestinales Carcinoma in situ",
    "synonyms": [
      "Carcinoma in situ des Anorektums",
      "Carcinoma in situ des Darmes",
      "Carcinoma in situ des Darmtraktes a.n.k.",
      "Carcinoma in situ des Duodenums",
      "Carcinoma in situ des Dünndarmes",
      "Carcinoma in situ des Ileums",
      "Carcinoma in situ des Jejunums",
      "Carcinoma in situ des anorektalen Überganges",
      "Carcinoma in situ des duodenojejunalen Überganges",
      "Carcinoma in situ eines Meckel-Divertikels",
      "Intestinales Carcinoma in situ"
    ]
  },
  {
    "code": "D01.5",
    "name": "Carcinoma in situ der Leber",
    "synonyms": [
      "Carcinoma in situ der Ampulla Vateri",
      "Carcinoma in situ der Ampulla hepatopancreatica",
      "Carcinoma in situ der Ductuli biliferi",
      "Carcinoma in situ der Ductuli intrahepaticae",
      "Carcinoma in situ der Gallenblase",
      "Carcinoma in situ der Gallenwege",
      "Carcinoma in situ der Leber",
      "Carcinoma in situ der hepatischen Gallengänge",
      "Carcinoma in situ der interlobulären Gallenwege",
      "Carcinoma in situ der intrahepatischen Gallengänge",
      "Carcinoma in situ der intrahepatischen Gallenwege",
      "Carcinoma in situ der intrahepatischen und extrahepatischen Gallengänge",
      "Carcinoma in situ der intralobulären Gallengänge",
      "Carcinoma in situ der intralobulären Gallenwege",
      "Carcinoma in situ des Ductus choledochus",
      "Carcinoma in situ des Ductus cysticus",
      "Carcinoma in situ des Ductus hepaticus",
      "Carcinoma in situ des Gallenblasenganges",
      "Carcinoma in situ des Gallenganges",
      "Carcinoma in situ des Gallensystems",
      "Carcinoma in situ des Sphincter Oddi",
      "Hepatisches Carcinoma in situ"
    ]
  },
  {
    "code": "D01.7",
    "name": "Carcinoma in situ des Pankreas",
    "synonyms": [
      "Carcinoma in situ der Inselzellen des Pankreas",
      "Carcinoma in situ der Langerhans-Inseln",
      "Carcinoma in situ des Ductus pancreaticus accessorius",
      "Carcinoma in situ des Pankreas",
      "Carcinoma in situ des Pankreasganges",
      "Carcinoma in situ des Pankreashalses",
      "Carcinoma in situ des Pankreaskopfes",
      "Carcinoma in situ des Pankreaskörpers",
      "Carcinoma in situ des Pankreasschwanzes",
      "Carcinoma in situ des Santorini-Ganges",
      "Carcinoma in situ des Wirsung-Ganges"
    ]
  },
  {
    "code": "D01.9",
    "name": "Gastrointestinales Carcinoma in situ a.n.k.",
    "synonyms": [
      "Carcinoma in situ der Verdauungsorgane a.n.k.",
      "Carcinoma in situ der Verdauungswege a.n.k.",
      "Carcinoma in situ des Verdauungssystems a.n.k.",
      "Gastrointestinales Carcinoma in situ a.n.k."
    ]
  },
  {
    "code": "D02.0",
    "name": "Carcinoma in situ des Larynx",
    "synonyms": [
      "Carcinoma in situ der Cartilago arytaenoidea",
      "Carcinoma in situ der Epiglottis",
      "Carcinoma in situ der Glottis",
      "Carcinoma in situ der Kehlkopfkommissur",
      "Carcinoma in situ der Larynxkommissur a.n.k.",
      "Carcinoma in situ der Plica ventricularis laryngis",
      "Carcinoma in situ der echten Stimmbänder",
      "Carcinoma in situ der falschen Stimmbänder",
      "Carcinoma in situ der hinteren Oberfläche der Epiglottis",
      "Carcinoma in situ der laryngealen Seite der Plica aryepiglottica",
      "Carcinoma in situ der laryngealen Seite der aryepiglottischen Falte",
      "Carcinoma in situ des Aryknorpels",
      "Carcinoma in situ des Epiglottisknorpels",
      "Carcinoma in situ des Gießbeckenknorpels",
      "Carcinoma in situ des Kegelknorpels",
      "Carcinoma in situ des Kehlkopfes",
      "Carcinoma in situ des Kehlkopfknorpels",
      "Carcinoma in situ des Larynx",
      "Carcinoma in situ des Larynxknorpels a.n.k.",
      "Carcinoma in situ des Ligamentum vestibulare",
      "Carcinoma in situ des Ligamentum vocale",
      "Carcinoma in situ des Ringknorpels",
      "Carcinoma in situ des Schildknorpels",
      "Carcinoma in situ des Stellknorpels",
      "Carcinoma in situ des inneren Larynx a.n.k.",
      "Carcinoma in situ des suprahyoidalen Anteils der Epiglottis",
      "Carcinoma in situ des äußeren Larynx a.n.k.",
      "Carcinoma in situ einer Stimmlippe",
      "Subglottisches Carcinoma in situ",
      "Supraglottisches Carcinoma in situ"
    ]
  },
  {
    "code": "D02.1",
    "name": "Carcinoma in situ der Trachea",
    "synonyms": [
      "Carcinoma in situ der Luftröhre",
      "Carcinoma in situ der Trachea",
      "Carcinoma in situ des Luftröhrenknorpels"
    ]
  },
  {
    "code": "D02.2",
    "name": "Carcinoma in situ der Bronchien",
    "synonyms": [
      "Bronchiogenes Carcinoma in situ",
      "Carcinoma in situ der Bronchien",
      "Carcinoma in situ der Carina tracheae",
      "Carcinoma in situ der Lingula pulmonis sinistri",
      "Carcinoma in situ der Lunge",
      "Carcinoma in situ des Bronchialknorpels",
      "Carcinoma in situ des Hilus pulmonis",
      "Carcinoma in situ des Lobus inferior pulmonis",
      "Carcinoma in situ des Lobus lingualis pulmonis",
      "Carcinoma in situ des Lobus medius pulmonis",
      "Carcinoma in situ des Lobus superior pulmonis",
      "Carcinoma in situ des Lobus venae azygos",
      "Carcinoma in situ des Lungenhilus",
      "Carcinoma in situ des Lungenmittellappens",
      "Carcinoma in situ des Lungenoberlappens",
      "Carcinoma in situ des Lungenunterlappens",
      "Carcinoma in situ einer Bronchiole",
      "Carcinoma in situ eines Hauptbronchus",
      "Pulmonales Carcinoma in situ",
      "Subpleurales Carcinoma in situ",
      "Tracheobronchiales Carcinoma in situ"
    ]
  },
  {
    "code": "D02.3",
    "name": "Carcinoma in situ des Mittelohres",
    "synonyms": [
      "Carcinoma in situ der Conchae nasales",
      "Carcinoma in situ der Eustachi-Röhre",
      "Carcinoma in situ der Fossa nasalis",
      "Carcinoma in situ der Keilbeinhöhle",
      "Carcinoma in situ der Kieferhöhle",
      "Carcinoma in situ der Mastoidzellen",
      "Carcinoma in situ der Nares",
      "Carcinoma in situ der Nasenhöhle",
      "Carcinoma in situ der Nasenlöcher",
      "Carcinoma in situ der Nasenmuschel",
      "Carcinoma in situ der Nasenschleimhaut",
      "Carcinoma in situ der Nebenhöhle",
      "Carcinoma in situ der Oberkieferhöhle",
      "Carcinoma in situ der Oberkiefernebenhöhle",
      "Carcinoma in situ der Paukenhöhle",
      "Carcinoma in situ der Sinus paranasales a.n.k.",
      "Carcinoma in situ der Stirnhöhle",
      "Carcinoma in situ der Tuba auditiva",
      "Carcinoma in situ der inneren Nase",
      "Carcinoma in situ des Antrum Highmore",
      "Carcinoma in situ des Antrum maxillaris",
      "Carcinoma in situ des Antrum tympanicum",
      "Carcinoma in situ des Cavum tympani",
      "Carcinoma in situ des Gehörganges",
      "Carcinoma in situ des Innenohres",
      "Carcinoma in situ des Mittelohres",
      "Carcinoma in situ des Nasenknorpels",
      "Carcinoma in situ des Nasenseptums",
      "Carcinoma in situ des Nasenvorhofes",
      "Carcinoma in situ des Oberkiefersinus",
      "Carcinoma in situ des Siebbeins",
      "Carcinoma in situ des Sinus ethmoidalis",
      "Carcinoma in situ des Sinus frontalis",
      "Carcinoma in situ des Sinus maxillaris",
      "Carcinoma in situ des Sinus sphenoidalis",
      "Carcinoma in situ des Vestibulum nasi"
    ]
  },
  {
    "code": "D02.4",
    "name": "Carcinoma in situ der Atmungsorgane",
    "synonyms": [
      "Carcinoma in situ der Atemwege",
      "Carcinoma in situ der Atmungsorgane",
      "Carcinoma in situ der Respirationsorgane a.n.k.",
      "Carcinoma in situ des Atemsystems",
      "Carcinoma in situ des Respirationssystems a.n.k.",
      "Carcinoma in situ des Respirationstraktes a.n.k."
    ]
  },
  {
    "code": "D03.0",
    "name": "Melanoma in situ der Lippe",
    "synonyms": [
      "Melanoma in situ der Lippe"
    ]
  },
  {
    "code": "D03.1",
    "name": "Melanoma in situ des Lids",
    "synonyms": [
      "Melanoma in situ des Augenlids",
      "Melanoma in situ des Kanthus",
      "Melanoma in situ des Lids"
    ]
  },
  {
    "code": "D03.2",
    "name": "Melanoma in situ des Ohres",
    "synonyms": [
      "Melanoma in situ der Ohrhaut",
      "Melanoma in situ der Ohrhelix",
      "Melanoma in situ des Meatus externus des Ohres",
      "Melanoma in situ des Ohres",
      "Melanoma in situ des äußeren Gehörganges",
      "Melanoma in situ des äußeren Ohres"
    ]
  },
  {
    "code": "D03.3",
    "name": "Melanoma in situ der Nasenhaut",
    "synonyms": [
      "Melanoma in situ der Augenbraue",
      "Melanoma in situ der Nasenhaut",
      "Melanoma in situ der Schläfe",
      "Melanoma in situ der Stirn",
      "Melanoma in situ der Wange",
      "Melanoma in situ des Ala nasi",
      "Melanoma in situ des Gesichts a.n.k.",
      "Melanoma in situ des Kiefers",
      "Melanoma in situ des Kinns"
    ]
  },
  {
    "code": "D03.4",
    "name": "Melanoma in situ der behaarten Kopfhaut",
    "synonyms": [
      "Melanoma in situ der behaarten Kopfhaut",
      "Melanoma in situ des Halses"
    ]
  },
  {
    "code": "D03.5",
    "name": "Melanoma in situ des Rumpfes",
    "synonyms": [
      "Melanoma in situ der Achselhöhle",
      "Melanoma in situ der Analhaut",
      "Melanoma in situ der Axilla",
      "Melanoma in situ der Bauchdecke",
      "Melanoma in situ der Brustdrüse",
      "Melanoma in situ der Brustdrüsenhaut",
      "Melanoma in situ der Brustwand",
      "Melanoma in situ der Flanke",
      "Melanoma in situ der Gesäßbacke",
      "Melanoma in situ der Gesäßmuskelregion",
      "Melanoma in situ der Interskapularregion",
      "Melanoma in situ der Mamma",
      "Melanoma in situ der Mammahaut",
      "Melanoma in situ der Perianalhaut",
      "Melanoma in situ der Submammärfalte",
      "Melanoma in situ des Analrandes",
      "Melanoma in situ des Brustdrüsenweichteilgewebes",
      "Melanoma in situ des Gesäßes",
      "Melanoma in situ des Nabels",
      "Melanoma in situ des Perineums",
      "Melanoma in situ des Rumpfes",
      "Melanoma in situ des Rückens",
      "Melanoma in situ einer Rippe"
    ]
  },
  {
    "code": "D03.6",
    "name": "Melanoma in situ des Arms",
    "synonyms": [
      "Melanoma in situ der Hand",
      "Melanoma in situ der Schulter",
      "Melanoma in situ der oberen Extremität a.n.k.",
      "Melanoma in situ des Arms",
      "Melanoma in situ des Unterarms",
      "Melanoma in situ eines Fingernagels",
      "Melanoma in situ eines Fingers"
    ]
  },
  {
    "code": "D03.7",
    "name": "Melanoma in situ des Beins",
    "synonyms": [
      "Melanoma in situ der Ferse",
      "Melanoma in situ der Hüfte",
      "Melanoma in situ der Kniekehle",
      "Melanoma in situ der unteren Extremität a.n.k.",
      "Melanoma in situ des Beins",
      "Melanoma in situ des Fußes",
      "Melanoma in situ des Knies",
      "Melanoma in situ des Knöchels",
      "Melanoma in situ des Schenkels",
      "Melanoma in situ einer Zehe",
      "Melanoma in situ eines Zehennagels"
    ]
  },
  {
    "code": "D03.8",
    "name": "Melanoma in situ des Auges",
    "synonyms": [
      "Melanoma in situ der Cervix uteri",
      "Melanoma in situ der Chorioidea",
      "Melanoma in situ der Genitalorgane",
      "Melanoma in situ der Iris",
      "Melanoma in situ der Konjunktiva",
      "Melanoma in situ der Labia majora pudendi",
      "Melanoma in situ der Labia minora pudendi",
      "Melanoma in situ der Orbita",
      "Melanoma in situ der Retina",
      "Melanoma in situ der Schamteile",
      "Melanoma in situ der Tränendrüse",
      "Melanoma in situ der Vorhaut",
      "Melanoma in situ der Vulva",
      "Melanoma in situ der männlichen Geschlechtsorgane a.n.k.",
      "Melanoma in situ der weiblichen Geschlechtsorgane a.n.k.",
      "Melanoma in situ des Auges",
      "Melanoma in situ des Penis",
      "Melanoma in situ des Präputiums",
      "Melanoma in situ des Skrotums",
      "Melanoma in situ einer Speicheldrüse",
      "Retrobulbäres Melanoma in situ"
    ]
  },
  {
    "code": "D03.9",
    "name": "Lentigo maligna",
    "synonyms": [
      "Bösartige Lentigo",
      "Lentigo maligna",
      "Melanoma in situ",
      "Melanoma in situ der Haut a.n.k.",
      "Melanoma in situ eines Nagels",
      "Präkanzeröse Melanose"
    ]
  },
  {
    "code": "D04.0",
    "name": "Carcinoma in situ der Lippenhaut",
    "synonyms": [
      "Carcinoma in situ der Lippenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Lippenhaut"
    ]
  },
  {
    "code": "D04.1",
    "name": "Carcinoma in situ des Kanthus",
    "synonyms": [
      "Carcinoma in situ der Lidhaut",
      "Carcinoma in situ der Meibom-Drüsen",
      "Carcinoma in situ der Palpebra",
      "Carcinoma in situ des Augenlids",
      "Carcinoma in situ des Augenwinkels",
      "Carcinoma in situ des Kanthus",
      "Carcinoma in situ des Lids",
      "Morbus Bowen des Lids",
      "Nichtmelanomartiges Carcinoma in situ der Augenlidhaut",
      "Nichtmelanomartiges Carcinoma in situ der Augenwinkelhaut",
      "Nichtmelanomartiges Carcinoma in situ der Lidhaut",
      "Nichtmelanomartiges Carcinoma in situ der Palpebralhaut"
    ]
  },
  {
    "code": "D04.2",
    "name": "Carcinoma in situ der Haut des äußeren Ohres",
    "synonyms": [
      "Carcinoma in situ der Auricula",
      "Carcinoma in situ der Haut des Gehörganges",
      "Carcinoma in situ der Haut des äußeren Gehörganges",
      "Carcinoma in situ der Haut des äußeren Ohres",
      "Carcinoma in situ der Ohrhaut",
      "Carcinoma in situ der Ohrhelix",
      "Carcinoma in situ der Ohrmuschel",
      "Carcinoma in situ des Meatus acusticus externus",
      "Carcinoma in situ des Ohrkanals",
      "Carcinoma in situ des Ohrläppchens",
      "Carcinoma in situ des Tragus",
      "Carcinoma in situ des äußeren Gehörganges",
      "Nichtmelanomartiges Carcinoma in situ der Gehörgangshaut",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Ohrhelix",
      "Nichtmelanomartiges Carcinoma in situ der Haut des Tragus",
      "Nichtmelanomartiges Carcinoma in situ der Ohrhaut",
      "Nichtmelanomartiges Carcinoma in situ der Ohrmuschelhaut"
    ]
  },
  {
    "code": "D04.3",
    "name": "Carcinoma in situ der Nasenhaut",
    "synonyms": [
      "Carcinoma in situ der Augenbraue",
      "Carcinoma in situ der Columella nasi",
      "Carcinoma in situ der Gesichtshaut a.n.k.",
      "Carcinoma in situ der Kieferhaut",
      "Carcinoma in situ der Nasenhaut",
      "Carcinoma in situ der Nasolabialfalte",
      "Carcinoma in situ der Schläfe",
      "Carcinoma in situ der Stirnhaut",
      "Carcinoma in situ der Wangenaußenseite",
      "Carcinoma in situ der äußeren Nase",
      "Carcinoma in situ des Ala nasi externa",
      "Carcinoma in situ des Kinns",
      "Carcinoma in situ des Nasenflügels",
      "Nichtmelanomartiges Carcinoma in situ der Augenbrauenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Gesichtshaut a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Columella nasi",
      "Nichtmelanomartiges Carcinoma in situ der Kieferhaut",
      "Nichtmelanomartiges Carcinoma in situ der Kinnhaut",
      "Nichtmelanomartiges Carcinoma in situ der Nasenflügelhaut",
      "Nichtmelanomartiges Carcinoma in situ der Nasenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Schläfenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Stirnhaut",
      "Nichtmelanomartiges Carcinoma in situ der Wangenhaut"
    ]
  },
  {
    "code": "D04.4",
    "name": "Carcinoma in situ der Kopfschwarte",
    "synonyms": [
      "Carcinoma in situ der Haut des Halses",
      "Carcinoma in situ der Kopfschwarte",
      "Carcinoma in situ des Kopfes a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Halsgegend",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Nackengegend",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Supraklavikulargrube",
      "Nichtmelanomartiges Carcinoma in situ der Kopfhaut a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Kopfschwartenhaut"
    ]
  },
  {
    "code": "D04.5",
    "name": "Carcinoma in situ der Haut des Dammes",
    "synonyms": [
      "Carcinoma in situ der Analhaut",
      "Carcinoma in situ der Bauchwand",
      "Carcinoma in situ der Brustdrüsenhaut",
      "Carcinoma in situ der Flanke a.n.k.",
      "Carcinoma in situ der Gesäßhaut",
      "Carcinoma in situ der Haut der Achselfalte",
      "Carcinoma in situ der Haut der Bauchwand",
      "Carcinoma in situ der Haut der Brust",
      "Carcinoma in situ der Haut der Glutäalregion",
      "Carcinoma in situ der Haut der Leistenbeuge",
      "Carcinoma in situ der Haut des Dammes",
      "Carcinoma in situ der Haut des Nabels",
      "Carcinoma in situ der Haut des Rumpfes",
      "Carcinoma in situ der Haut des Rückens",
      "Carcinoma in situ der Hautfalte der Achselhöhle",
      "Carcinoma in situ der Leistenbeuge a.n.k.",
      "Carcinoma in situ der Leistengegend",
      "Carcinoma in situ der Mammahaut",
      "Carcinoma in situ der Perianalhaut",
      "Carcinoma in situ der Regio scapularis",
      "Carcinoma in situ der Schulterblattregion",
      "Carcinoma in situ des Analrandes",
      "Carcinoma in situ des Nabels",
      "Carcinoma in situ des Rumpfes a.n.k.",
      "Carcinoma in situ des Rückens a.n.k.",
      "Infraklavikuläres Carcinoma in situ",
      "Nichtmelanomartiges Carcinoma in situ der Achselfaltenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Achselhaut",
      "Nichtmelanomartiges Carcinoma in situ der Analhaut",
      "Nichtmelanomartiges Carcinoma in situ der Bauchhaut",
      "Nichtmelanomartiges Carcinoma in situ der Bauchwandhaut",
      "Nichtmelanomartiges Carcinoma in situ der Brusthaut",
      "Nichtmelanomartiges Carcinoma in situ der Brustwandhaut",
      "Nichtmelanomartiges Carcinoma in situ der Flankenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Gesäßhaut",
      "Nichtmelanomartiges Carcinoma in situ der Glutäalhaut",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Inguinalregion",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Kreuzbeingegend",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Leistengegend",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Schamgegend",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Skapularregion",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Steißbeingegend",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Thoraxwand",
      "Nichtmelanomartiges Carcinoma in situ der Haut der submammären Falte",
      "Nichtmelanomartiges Carcinoma in situ der Haut des Klavikulargebiets",
      "Nichtmelanomartiges Carcinoma in situ der Leistenbeugenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Nabelhaut",
      "Nichtmelanomartiges Carcinoma in situ der Perianalhaut",
      "Nichtmelanomartiges Carcinoma in situ der Perinealhaut",
      "Nichtmelanomartiges Carcinoma in situ der Rumpfhaut",
      "Nichtmelanomartiges Carcinoma in situ der Rückenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Thoraxhaut",
      "Nichtmelanomartiges Carcinoma in situ der subklavikulären Haut",
      "Perianales Carcinoma in situ"
    ]
  },
  {
    "code": "D04.6",
    "name": "Carcinoma in situ der Haut der Schulter",
    "synonyms": [
      "Carcinoma in situ der Handhaut a.n.k.",
      "Carcinoma in situ der Haut der Schulter",
      "Carcinoma in situ der Haut der oberen Extremität",
      "Carcinoma in situ der Haut der oberen Gliedmaßen",
      "Carcinoma in situ der Haut des Arms a.n.k.",
      "Carcinoma in situ der Haut des Daumens a.n.k.",
      "Carcinoma in situ der Haut des Ellenbogens a.n.k.",
      "Carcinoma in situ der Haut des Handgelenks a.n.k.",
      "Carcinoma in situ der Haut eines Fingers a.n.k.",
      "Carcinoma in situ der Schulter a.n.k.",
      "Carcinoma in situ des Unterarms a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Armhaut",
      "Nichtmelanomartiges Carcinoma in situ der Daumenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Ellenbeugenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Ellenbogenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Fingerhaut",
      "Nichtmelanomartiges Carcinoma in situ der Handflächenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Handhaut",
      "Nichtmelanomartiges Carcinoma in situ der Haut der oberen Gliedmaßen a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Schulterhaut",
      "Nichtmelanomartiges Carcinoma in situ der Unterarmhaut"
    ]
  },
  {
    "code": "D04.7",
    "name": "Carcinoma in situ der Hüfthaut",
    "synonyms": [
      "Carcinoma in situ der Beinhaut a.n.k.",
      "Carcinoma in situ der Fersenhaut a.n.k.",
      "Carcinoma in situ der Fußhaut a.n.k.",
      "Carcinoma in situ der Haut der unteren Extremität",
      "Carcinoma in situ der Haut der unteren Gliedmaßen",
      "Carcinoma in situ der Haut einer Zehe a.n.k.",
      "Carcinoma in situ der Hüfte a.n.k.",
      "Carcinoma in situ der Hüfthaut",
      "Carcinoma in situ der Kniekehle",
      "Carcinoma in situ der Wadenhaut",
      "Carcinoma in situ des Knies a.n.k.",
      "Carcinoma in situ des Knöchels a.n.k.",
      "Carcinoma in situ des Oberschenkels a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Beinhaut",
      "Nichtmelanomartiges Carcinoma in situ der Fersenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Fußhaut",
      "Nichtmelanomartiges Carcinoma in situ der Fußsohlenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Haut der unteren Gliedmaßen a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Hüfthaut",
      "Nichtmelanomartiges Carcinoma in situ der Kniehaut",
      "Nichtmelanomartiges Carcinoma in situ der Kniekehlenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Knöchelhaut",
      "Nichtmelanomartiges Carcinoma in situ der Oberschenkelhaut",
      "Nichtmelanomartiges Carcinoma in situ der Plantarhaut",
      "Nichtmelanomartiges Carcinoma in situ der Wadenhaut",
      "Nichtmelanomartiges Carcinoma in situ der Zehenhaut"
    ]
  },
  {
    "code": "D04.8",
    "name": "Carcinoma in situ der Haut einer Extremität",
    "synonyms": [
      "Carcinoma in situ der Gliedmaßenhaut",
      "Carcinoma in situ der Haut einer Extremität"
    ]
  },
  {
    "code": "D04.9",
    "name": "Bowen-Darier-Syndrom",
    "synonyms": [
      "Aktinische Präkanzerose",
      "Bowen-Darier-Krankheit",
      "Bowen-Darier-Syndrom",
      "Bowen-Dermatose",
      "Bowen-Epitheliom",
      "Bowen-Krankheit",
      "Carcinoma in situ der Epidermis",
      "Carcinoma in situ der Haut",
      "Carcinoma in situ der Schweißdrüsen",
      "Dermatitis praecancerosa Bowen",
      "Intradermales Karzinom",
      "Intraepitheliales Epitheliom",
      "Morbus Bowen",
      "Nichtmelanomartiges Carcinoma in situ der Haut",
      "Präkanzerose der Haut"
    ]
  },
  {
    "code": "D05.0",
    "name": "Lobuläres Carcinoma in situ der Brustdrüse",
    "synonyms": [
      "Lobuläres Carcinoma in situ der Brustdrüse",
      "Lobuläres Carcinoma in situ der Mamma",
      "Lobuläres nichtinvasives Brustdrüsenkarzinom",
      "Lobuläres nichtinvasives Mammakarzinom"
    ]
  },
  {
    "code": "D05.1",
    "name": "Carcinoma in situ des Milchganges",
    "synonyms": [
      "Carcinoma in situ des Milchganges",
      "Intraduktales Adenokarzinom",
      "Intraduktales Adenokarzinom der Brustdrüse",
      "Intraduktales Adenokarzinom der Mamma",
      "Intraduktales Brustdrüsenkarzinom",
      "Intraduktales Carcinoma in situ",
      "Intraduktales Mammakarzinom",
      "Intraduktales nichtinvasives Adenokarzinom der Brustdrüse",
      "Intraduktales nichtinvasives Adenokarzinom der Mamma",
      "Intraduktales nichtinvasives Brustdrüsenkarzinom",
      "Intraduktales nichtinvasives Mammakarzinom",
      "Intraduktales papilläres Adenokarzinom der Brustdrüse",
      "Intraduktales papilläres Adenokarzinom der Mamma",
      "Intraduktales papilläres Brustdrüsenkarzinom",
      "Intraduktales papilläres Mammakarzinom",
      "Nichtinvasives DCiS [Duktales Carcinoma in situ]",
      "Nichtinvasives Komedokarzinom",
      "Nichtinvasives Komedokarzinom der Brustdrüse",
      "Nichtinvasives Komedokarzinom der Mamma"
    ]
  },
  {
    "code": "D05.7",
    "name": "Apokrines Carcinoma in situ der Brustdrüse",
    "synonyms": [
      "Apokrines Carcinoma in situ der Brustdrüse",
      "Apokrines Carcinoma in situ der Mamma",
      "Lobuläres und intraduktales Carcinoma in situ der Brustdrüse",
      "Lobuläres und intraduktales Carcinoma in situ der Mamma"
    ]
  },
  {
    "code": "D05.9",
    "name": "Carcinoma in situ der Brustdrüse a.n.k.",
    "synonyms": [
      "Adenocarcinoma in situ der Brustdrüse",
      "Adenocarcinoma in situ der Mamma",
      "Carcinoma in situ am Warzenhof der Brustdrüse",
      "Carcinoma in situ der Areola",
      "Carcinoma in situ der Brustdrüse a.n.k.",
      "Carcinoma in situ der Brustwarze",
      "Carcinoma in situ der Mamma",
      "Carcinoma in situ der Medioklavikularlinie der Brustdrüse",
      "Carcinoma in situ der inneren Brustdrüse",
      "Carcinoma in situ der oberen Brustdrüse",
      "Carcinoma in situ der unteren Brustdrüse",
      "Carcinoma in situ der äußeren Brustdrüse",
      "Carcinoma in situ des Recessus axillaris der Brustdrüse",
      "Carcinoma in situ des axillären Ausläufers der Brustdrüse",
      "Carcinoma in situ des oberen inneren Quadranten der Brustdrüse",
      "Carcinoma in situ des oberen äußeren Quadranten der Brustdrüse",
      "Carcinoma in situ des unteren inneren Quadranten der Brustdrüse",
      "Carcinoma in situ des unteren äußeren Quadranten der Brustdrüse",
      "Carcinoma in situ des zentralen Drüsenkörpers der Brustdrüse",
      "Carcinoma in situ einer ektopischen Brustdrüse"
    ]
  },
  {
    "code": "D06.0",
    "name": "Carcinoma in situ der Endozervix",
    "synonyms": [
      "Carcinoma in situ der Endozervix",
      "Carcinoma in situ der Ovula Nabothi",
      "Carcinoma in situ des Kanals der Cervix uteri",
      "Carcinoma in situ des Zervikalkanals",
      "Carcinoma in situ des inneren Muttermundes",
      "Endozervikales Carcinoma in situ"
    ]
  },
  {
    "code": "D06.1",
    "name": "Carcinoma in situ der Ektozervix",
    "synonyms": [
      "Carcinoma in situ der Ektozervix",
      "Carcinoma in situ des äußeren Muttermundes"
    ]
  },
  {
    "code": "D06.7",
    "name": "Carcinoma in situ des Zervixstumpfes",
    "synonyms": [
      "Carcinoma in situ des Zervixstumpfes",
      "Carcinoma in situ des Zervixüberganges zur Vagina",
      "Carcinoma in situ des Überganges zwischen Cervix uteri und Vagina",
      "Carcinoma in situ des Überganges zwischen Zervix und Vagina"
    ]
  },
  {
    "code": "D06.9",
    "name": "Carcinoma in situ der Cervix uteri",
    "synonyms": [
      "CIN [zervikale intraepitheliale Neoplasie] III. Grades",
      "Carcinoma in situ der Cervix uteri",
      "Carcinoma in situ der Portio",
      "Carcinoma in situ der Zervix",
      "Epidermoides Carcinoma in situ mit fraglicher Stromainvasion der Cervix uteri",
      "HSIL [Hochgradige squamöse intraepitheliale Läsion]",
      "Plattenepitheliales Carcinoma in situ mit fraglicher Stromainvasion der Cervix uteri",
      "Zervikale intraepitheliale Neoplasie III. Grades",
      "Zervikale intraepitheliale Neoplasie III. Grades mit hochgradiger Dysplasie"
    ]
  },
  {
    "code": "D07.0",
    "name": "Carcinoma in situ des Endometriums",
    "synonyms": [
      "Carcinoma in situ des Endometriums",
      "Carcinoma in situ des Endometriumstromas"
    ]
  },
  {
    "code": "D07.1",
    "name": "Carcinoma in situ der Vulva",
    "synonyms": [
      "Carcinoma in situ der Bartholin-Drüse",
      "Carcinoma in situ der Glandula vestibularis major",
      "Carcinoma in situ der Klitoris",
      "Carcinoma in situ der Labia majora pudendi",
      "Carcinoma in situ der Labia minora pudendi",
      "Carcinoma in situ der Labienhaut",
      "Carcinoma in situ der Pudenda feminae",
      "Carcinoma in situ der Vulva",
      "Carcinoma in situ der vulvovaginalen Drüsen",
      "Carcinoma in situ des Frenulum labiorum pudendi",
      "Carcinoma in situ des Mons pubis",
      "Carcinoma in situ des Mons veneris",
      "Intraepitheliale Vulvaneoplasie III. Grades",
      "Intraepitheliale Vulvaneoplasie III. Grades mit hochgradiger Dysplasie",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Labia majora pudendi",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Labia minora pudendi",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Labien",
      "Nichtmelanomartiges Carcinoma in situ der Haut der Pudenda feminae",
      "Nichtmelanomartiges Carcinoma in situ der Haut der weiblichen Geschlechtsorgane",
      "Nichtmelanomartiges Carcinoma in situ der Klitorishaut",
      "Nichtmelanomartiges Carcinoma in situ der Vulvahaut",
      "Queyrat-Syndrom der Schamlippen",
      "VIN [intraepitheliale Vulvaneoplasie] III. Grades"
    ]
  },
  {
    "code": "D07.2",
    "name": "Carcinoma in situ der Vagina",
    "synonyms": [
      "Carcinoma in situ der Vagina",
      "Carcinoma in situ des Fornix vaginae",
      "Carcinoma in situ des Gartner-Ganges",
      "Carcinoma in situ des Hymens",
      "Intraepitheliale Vaginaneoplasie III. Grades",
      "Intraepitheliale Vaginaneoplasie III. Grades mit hochgradiger Dysplasie",
      "VAIN [intraepitheliale Vaginaneoplasie] III. Grades"
    ]
  },
  {
    "code": "D07.3",
    "name": "Carcinoma in situ des Uterus",
    "synonyms": [
      "Carcinoma in situ der Plazenta",
      "Carcinoma in situ der Salpinx",
      "Carcinoma in situ der Tuba uterina",
      "Carcinoma in situ der Uterusadnexe",
      "Carcinoma in situ der weiblichen Geschlechtsorgane a.n.k.",
      "Carcinoma in situ der weiblichen Harnorgane",
      "Carcinoma in situ des Corpus uteri",
      "Carcinoma in situ des Eileiters",
      "Carcinoma in situ des Fundus des Uterus",
      "Carcinoma in situ des Fundus uteri",
      "Carcinoma in situ des Isthmus des Uterus",
      "Carcinoma in situ des Isthmus uteri",
      "Carcinoma in situ des Ligamentum latum uteri",
      "Carcinoma in situ des Mesovariums",
      "Carcinoma in situ des Müller-Ganges bei der Frau",
      "Carcinoma in situ des Ovars",
      "Carcinoma in situ des Oviduktes",
      "Carcinoma in situ des Parovariums",
      "Carcinoma in situ des Septum urethrovaginale",
      "Carcinoma in situ des Septum vesikovaginale",
      "Carcinoma in situ des Uterus",
      "Carcinoma in situ des Uterushorns",
      "Carcinoma in situ des Uteruskörpers",
      "Carcinoma in situ des Wolff-Ganges bei der Frau",
      "Carcinoma in situ des unteren Segments des Uterus",
      "Carcinoma in situ des vaginovesikalen Septums",
      "Carcinoma in situ des vesikovaginalen Septums",
      "Carcinoma in situ des vesikozervikalen Gewebes",
      "Carcinoma in situ des weiblichen Urogenitaltraktes",
      "Tuboovariales Carcinoma in situ",
      "Urethrovaginales Carcinoma in situ",
      "Vaginovesikales Carcinoma in situ",
      "Vesikovaginales Carcinoma in situ"
    ]
  },
  {
    "code": "D07.4",
    "name": "Peniserythroplasie",
    "synonyms": [
      "Carcinoma in situ der Glans penis",
      "Carcinoma in situ der Penishaut a.n.k.",
      "Carcinoma in situ der Vorhaut",
      "Carcinoma in situ des Corpus cavernosum penis",
      "Carcinoma in situ des Penis",
      "Carcinoma in situ des Präputiums",
      "Erythroplasie",
      "Nichtmelanomartiges Carcinoma in situ der Haut des Präputiums",
      "Nichtmelanomartiges Carcinoma in situ der Penishaut a.n.k.",
      "Nichtmelanomartiges Carcinoma in situ der Präputialhaut",
      "Peniserythroplasie",
      "Queyrat-Erythroplasie",
      "Queyrat-Erythroplasie des Penis",
      "Queyrat-Syndrom"
    ]
  },
  {
    "code": "D07.5",
    "name": "Carcinoma in situ der Prostata",
    "synonyms": [
      "Carcinoma in situ der Prostata",
      "Hochgradige Prostatadysplasie",
      "Hochgradige intraepitheliale Neoplasie der Prostata [high-grade PIN]",
      "Intraepitheliale Neoplasie der Prostata [PIN] III. Grades"
    ]
  },
  {
    "code": "D07.6",
    "name": "Carcinoma in situ des Wolff-Ganges beim Mann",
    "synonyms": [
      "Carcinoma in situ der Epididymis",
      "Carcinoma in situ der Samenblase",
      "Carcinoma in situ der Tunica vaginalis testis",
      "Carcinoma in situ der Vesicula seminalis",
      "Carcinoma in situ der männlichen Geschlechtsorgane a.n.k.",
      "Carcinoma in situ des Ductus deferens",
      "Carcinoma in situ des Ductus ejaculatorius",
      "Carcinoma in situ des Hodens",
      "Carcinoma in situ des Müller-Ganges beim Mann",
      "Carcinoma in situ des Nebenhodens",
      "Carcinoma in situ des Samenstranges",
      "Carcinoma in situ des Skrotums",
      "Carcinoma in situ des Vas deferens",
      "Carcinoma in situ des Wolff-Ganges beim Mann",
      "Carcinoma in situ des deszendierten Hodens",
      "Carcinoma in situ des ektopischen Hodens",
      "Carcinoma in situ des männlichen Urogenitaltraktes",
      "Carcinoma in situ des nichtdeszendierten Hodens",
      "Carcinoma in situ des retinierten Hodens",
      "Carcinoma in situ des skrotalen Hodens",
      "Nichtmelanomartiges Carcinoma in situ der Haut der männlichen Geschlechtsorgane",
      "Nichtmelanomartiges Carcinoma in situ der Skrotalhaut"
    ]
  },
  {
    "code": "D09.0",
    "name": "Carcinoma in situ der Blase",
    "synonyms": [
      "Carcinoma in situ der Blase",
      "Carcinoma in situ der Harnblase",
      "Carcinoma in situ der Harnblasenwand",
      "Carcinoma in situ der Harnblasenöffnung",
      "Carcinoma in situ der Uretermündung",
      "Carcinoma in situ der inneren Mündung der Urethra",
      "Carcinoma in situ des Harnblasenhalses",
      "Carcinoma in situ des Harnblasenostiums",
      "Carcinoma in situ des Harnblasenscheitels",
      "Carcinoma in situ des Harnblasensphinkters",
      "Carcinoma in situ des Ostium ureteris",
      "Carcinoma in situ des Ostium urethrae internum",
      "Carcinoma in situ des Trigonum vesicae",
      "Carcinoma in situ des Urachus"
    ]
  },
  {
    "code": "D09.1",
    "name": "Carcinoma in situ der Niere",
    "synonyms": [
      "Carcinoma in situ der Bulbourethraldrüsen",
      "Carcinoma in situ der Cowper-Drüsen",
      "Carcinoma in situ der Harnorgane",
      "Carcinoma in situ der Harnröhre",
      "Carcinoma in situ der Harnwege a.n.k.",
      "Carcinoma in situ der Niere",
      "Carcinoma in situ der Nierenkelche",
      "Carcinoma in situ der Skene-Drüse",
      "Carcinoma in situ der Urethra",
      "Carcinoma in situ der männlichen Harnorgane",
      "Carcinoma in situ der paraurethralen Drüsen",
      "Carcinoma in situ des Harnleiters",
      "Carcinoma in situ des Nierenbeckens",
      "Carcinoma in situ des Nierenhilus",
      "Carcinoma in situ des Nierenparenchyms",
      "Carcinoma in situ des Ureters",
      "Carcinoma in situ des Utriculus prostaticus",
      "Carcinoma in situ des Überganges zwischen Nierenbecken und Harnleiter",
      "Renales Carcinoma in situ"
    ]
  },
  {
    "code": "D09.2",
    "name": "Bindehauterythroplasie",
    "synonyms": [
      "Bindehauterythroplasie",
      "Carcinoma in situ der Chorioidea",
      "Carcinoma in situ der Iris",
      "Carcinoma in situ der Konjunktiva",
      "Carcinoma in situ der Kornea",
      "Carcinoma in situ der Linse",
      "Carcinoma in situ der Orbita",
      "Carcinoma in situ der Retina",
      "Carcinoma in situ der Sklera",
      "Carcinoma in situ der Tränendrüse",
      "Carcinoma in situ der extraokulären Augenmuskeln",
      "Carcinoma in situ des Augapfels",
      "Carcinoma in situ des Auges",
      "Carcinoma in situ des Ductus nasolacrimalis",
      "Carcinoma in situ des Limbus corneae",
      "Carcinoma in situ des Tränenkanals",
      "Carcinoma in situ des Tränennasenganges",
      "Carcinoma in situ des Tränenpunktes",
      "Carcinoma in situ des Tränensacks",
      "Carcinoma in situ des Uvealtraktes",
      "Carcinoma in situ des Ziliarkörpers",
      "Intraokuläres Carcinoma in situ",
      "Intraorbitales Carcinoma in situ",
      "Konjunktivaerythroplasie",
      "Morbus Bowen der Hornhaut des Auges"
    ]
  },
  {
    "code": "D09.3",
    "name": "Carcinoma in situ einer endokrinen Drüse",
    "synonyms": [
      "Carcinoma in situ der Fossa pituitaria",
      "Carcinoma in situ der Hypophyse",
      "Carcinoma in situ der Medulla glandulae suprarenalis",
      "Carcinoma in situ der Nebenniere",
      "Carcinoma in situ der Nebennierenkapsel",
      "Carcinoma in situ der Nebennierenrinde",
      "Carcinoma in situ der Nebenschilddrüse",
      "Carcinoma in situ der Parathyreoidea",
      "Carcinoma in situ der Rathke-Tasche",
      "Carcinoma in situ der Schilddrüse",
      "Carcinoma in situ der Thyreoidea",
      "Carcinoma in situ des Ductus craniopharyngealis",
      "Carcinoma in situ des Ductus thyreoglossus",
      "Carcinoma in situ des Hirnanhanges",
      "Carcinoma in situ des Nebennierenmarks",
      "Carcinoma in situ des Thymus",
      "Carcinoma in situ einer Nebennierendrüse",
      "Carcinoma in situ einer endokrinen Drüse",
      "Carcinoma in situ einer pluriglandulären endokrinen Drüse a.n.k.",
      "Intraselläres Carcinoma in situ",
      "Polyglanduläres Carcinoma in situ"
    ]
  },
  {
    "code": "D09.7",
    "name": "Carcinoma in situ der Nase",
    "synonyms": [
      "Carcinoma in situ der Achselhöhle",
      "Carcinoma in situ der Bauchhöhle",
      "Carcinoma in situ der Beckenwand",
      "Carcinoma in situ der Brustwand a.n.k.",
      "Carcinoma in situ der Kreuzbeingegend",
      "Carcinoma in situ der Nase",
      "Carcinoma in situ der Supraklavikulargrube",
      "Carcinoma in situ der Temporalregion",
      "Carcinoma in situ der Wange",
      "Carcinoma in situ der Zervikalregion",
      "Carcinoma in situ der rektovaginalen Wand",
      "Carcinoma in situ des Abdomens",
      "Carcinoma in situ des Bauches",
      "Carcinoma in situ des Beckenbodens",
      "Carcinoma in situ des Beckens",
      "Carcinoma in situ des Halses a.n.k.",
      "Carcinoma in situ des Kiefers",
      "Carcinoma in situ des Perineums",
      "Carcinoma in situ des Septum rectovaginale",
      "Carcinoma in situ des Septum rectovesikale",
      "Carcinoma in situ des Thorax",
      "Carcinoma in situ des rektovaginalen Septums",
      "Carcinoma in situ des rektovesikalen Septums",
      "Pelvikoabdominales Carcinoma in situ",
      "Submentales Carcinoma in situ",
      "Vesikorektales Carcinoma in situ"
    ]
  },
  {
    "code": "D09.9",
    "name": "Carcinoma in situ",
    "synonyms": [
      "Adenocarcinoma in situ",
      "Adenocarcinoma in situ in Polypen",
      "Carcinoma in situ",
      "Carcinoma in situ des Übergangsepithels",
      "Carcinoma in situ in Polypen",
      "Epidermoides Carcinoma in situ",
      "Papilläres Carcinoma in situ",
      "Plattenepitheliales Carcinoma in situ",
      "Präkanzerose",
      "Präneoplasie",
      "Transitionalzelliges Carcinoma in situ",
      "Vorkrebs"
    ]
  },
  {
    "code": "D10.0",
    "name": "Lippenpapillom",
    "synonyms": [
      "Gutartige Neubildung der Außenseite der Lippe",
      "Gutartige Neubildung der Außenseite der Oberlippe",
      "Gutartige Neubildung der Außenseite der Unterlippe",
      "Gutartige Neubildung der Innenseite der Lippe",
      "Gutartige Neubildung der Innenseite der Oberlippe",
      "Gutartige Neubildung der Innenseite der Unterlippe",
      "Gutartige Neubildung der Lippe",
      "Gutartige Neubildung der Lippenkommissur",
      "Gutartige Neubildung der Lippenrotgrenze",
      "Gutartige Neubildung der Lippenschleimhaut",
      "Gutartige Neubildung der Oberlippe",
      "Gutartige Neubildung der Unterlippe",
      "Gutartige Neubildung des Frenulum labii",
      "Gutartige Neubildung des Lippenstiftbereiches",
      "Lippenpapillom"
    ]
  },
  {
    "code": "D10.1",
    "name": "Gutartige Neubildung der Zunge",
    "synonyms": [
      "Granularzelliges Zungenmyoblastom",
      "Gutartige Neubildung der Tonsilla lingualis",
      "Gutartige Neubildung der Zunge",
      "Gutartige Neubildung der Zungenmandel",
      "Gutartige Neubildung der Zungenmittellinie",
      "Gutartige Neubildung der Zungenoberfläche",
      "Gutartige Neubildung der Zungenspitze",
      "Gutartige Neubildung der Zungentonsille",
      "Gutartige Neubildung der Zungenwurzel",
      "Gutartige Neubildung der hinteren Zunge",
      "Gutartige Neubildung der vorderen Zunge",
      "Gutartige Neubildung der Übergangszone der Zunge",
      "Gutartige Neubildung des Frenulum linguae",
      "Gutartige Neubildung des Zungenfrenulums",
      "Gutartige Neubildung des Zungengrundes",
      "Gutartige Neubildung des beweglichen Teils der Zunge",
      "Gutartige Neubildung des seitlichen Zungenrandes",
      "Gutartige Neubildung des unbeweglichen Teils der Zunge",
      "Linguale gutartige Neubildung a.n.k."
    ]
  },
  {
    "code": "D10.2",
    "name": "Gutartige Neubildung des Mundbodens",
    "synonyms": [
      "Gutartige Neubildung des Mundbodens",
      "Sublinguale gutartige Neubildung"
    ]
  },
  {
    "code": "D10.3",
    "name": "Mundhöhlenpapillom",
    "synonyms": [
      "Bukkale gutartige Neubildung",
      "Gutartige Neubildung der Alveolarfortsatzschleimhaut",
      "Gutartige Neubildung der Alveolarkammschleimhaut",
      "Gutartige Neubildung der Alveolarschleimhaut",
      "Gutartige Neubildung der Gingiva",
      "Gutartige Neubildung der Kieferweichteile",
      "Gutartige Neubildung der Mundhöhle",
      "Gutartige Neubildung der Mundschleimhaut a.n.k.",
      "Gutartige Neubildung der Nebenspeicheldrüsen a.n.k.",
      "Gutartige Neubildung der Oberkieferalveolarschleimhaut",
      "Gutartige Neubildung der Oberkiefergingiva",
      "Gutartige Neubildung der Oberkieferweichteile",
      "Gutartige Neubildung der Retromolarregion",
      "Gutartige Neubildung der Unterkieferalveolarschleimhaut",
      "Gutartige Neubildung der Unterkiefergingiva",
      "Gutartige Neubildung der Unterkieferweichteile",
      "Gutartige Neubildung der Uvula",
      "Gutartige Neubildung der Wangeninnenseite",
      "Gutartige Neubildung der Wangenschleimhaut",
      "Gutartige Neubildung der bukkalen Schleimhaut",
      "Gutartige Neubildung des Gaumens",
      "Gutartige Neubildung des Kieferbindegewebes a.n.k.",
      "Gutartige Neubildung des Mundhöhlendaches",
      "Gutartige Neubildung des Mundwinkels",
      "Gutartige Neubildung des Vestibulum oris",
      "Gutartige Neubildung des Zahnfleisches",
      "Gutartige Neubildung des bukkalen Sulkus",
      "Gutartige Neubildung des harten Gaumens",
      "Gutartige Neubildung des labialen Sulkus",
      "Gutartige Neubildung des periodontalen Gewebes a.n.k.",
      "Gutartige Neubildung des weichen Gaumens",
      "Gutartige Neubildung des Überganges zwischen hartem und weichem Gaumen",
      "Gutartige Neubildung einer Zahnalveole",
      "Gutartige Neubildung einer kleinen Speicheldrüse",
      "Gutartige Neubildung eines Zahnfachs a.n.k.",
      "Mundhöhlenpapillom",
      "Parodontale gutartige Neubildung a.n.k.",
      "Uvulapapillom"
    ]
  },
  {
    "code": "D10.4",
    "name": "Tonsillenpapillom",
    "synonyms": [
      "Gutartige Neubildung der Fauces",
      "Gutartige Neubildung der Gaumenmandel a.n.k.",
      "Gutartige Neubildung der Gaumentonsille",
      "Gutartige Neubildung der Schlundtonsille",
      "Gutartige Neubildung der Tonsilla palatina",
      "Gutartige Neubildung der Tonsillen",
      "Tonsillenpapillom"
    ]
  },
  {
    "code": "D10.5",
    "name": "Gutartige Neubildung des Gaumenbogens",
    "synonyms": [
      "Gutartige Neubildung der Epiglottisoberfläche",
      "Gutartige Neubildung der Epiglottisvorderfläche",
      "Gutartige Neubildung der Fossa tonsillaris",
      "Gutartige Neubildung der Gaumenbogentonsillen",
      "Gutartige Neubildung der Kiemenspalte",
      "Gutartige Neubildung der Plica glossoepiglottica",
      "Gutartige Neubildung der Vallecula epiglottica",
      "Gutartige Neubildung des Arcus palatoglossus",
      "Gutartige Neubildung des Arcus palatopharyngeus",
      "Gutartige Neubildung des Gaumenbogens",
      "Gutartige Neubildung des Oropharynx",
      "Gutartige Neubildung des Rachenrings a.n.k.",
      "Gutartige Neubildung des freien Rands der Epiglottis",
      "Gutartige Neubildung des glossopharyngealen Sulkus"
    ]
  },
  {
    "code": "D10.6",
    "name": "Fibroma nasopharyngeale",
    "synonyms": [
      "Benignes Nasopharynxteratom",
      "Fibrom des Nasenrachens",
      "Fibroma nasopharyngeale",
      "Gutartige Neubildung der Choane",
      "Gutartige Neubildung der Pharynxtonsille",
      "Gutartige Neubildung der Rachenmandel",
      "Gutartige Neubildung der Rachentonsille",
      "Gutartige Neubildung der Rosenmüller-Grube",
      "Gutartige Neubildung der Tonsilla pharyngea",
      "Gutartige Neubildung der Wand des Nasenrachenraums",
      "Gutartige Neubildung der hinteren Wand des Nasenrachenraums",
      "Gutartige Neubildung der oberen Wand des Nasenrachenraums",
      "Gutartige Neubildung der pharyngealen Fornix",
      "Gutartige Neubildung der seitlichen Wand des Nasenrachenraums",
      "Gutartige Neubildung der vorderen Wand des Nasenrachenraums",
      "Gutartige Neubildung des Bodens des Nasenrachenraums",
      "Gutartige Neubildung des Choanenhinterrandes",
      "Gutartige Neubildung des Daches des Nasenrachenraums",
      "Gutartige Neubildung des Daches des weichen Gaumens",
      "Gutartige Neubildung des Epipharynx",
      "Gutartige Neubildung des Fornix pharyngis",
      "Gutartige Neubildung des Nasenrachenraums",
      "Gutartige Neubildung des Nasenseptumhinterrandes",
      "Gutartige Neubildung des Nasopharynx",
      "Gutartige Neubildung des Ostium pharyngeum der Tuba auditiva",
      "Gutartige Neubildung des Recessus pharyngeus",
      "Gutartige Neubildung des adenoiden Gewebes",
      "Gutartige Neubildung des hinteren Randes des Nasenseptums",
      "Gutartige Neubildung des pharyngealen Recessus",
      "Juveniles Angiofibrom",
      "Juveniles Fibroangiom",
      "Juveniles nasopharyngeales Angiofibrom",
      "Nasopharyngeales Fibrom"
    ]
  },
  {
    "code": "D10.7",
    "name": "Gutartige Neubildung des Hypopharynx",
    "synonyms": [
      "Gutartige Neubildung der Fossa piriformis",
      "Gutartige Neubildung der Plica aryepiglottica",
      "Gutartige Neubildung der Regio postcricoidea",
      "Gutartige Neubildung der aryepiglottischen Falte",
      "Gutartige Neubildung der hinteren Wand des Hypopharynx",
      "Gutartige Neubildung des Hypopharynx",
      "Gutartige Neubildung des Krikopharynx",
      "Gutartige Neubildung des Sinus piriformis"
    ]
  },
  {
    "code": "D10.9",
    "name": "Gutartige Neubildung des Rachens",
    "synonyms": [
      "Gutartige Neubildung der Pharynxwand",
      "Gutartige Neubildung des Laryngopharynx",
      "Gutartige Neubildung des Pharynx",
      "Gutartige Neubildung des Rachens",
      "Gutartige Neubildung des Waldeyer-Rachenrings",
      "Retropharyngeale gutartige Neubildung"
    ]
  },
  {
    "code": "D11.0",
    "name": "Parotisadenom",
    "synonyms": [
      "Benigner epithelialer Tumor der Parotis",
      "Gutartige Neubildung der Ohrspeicheldrüse",
      "Gutartige Neubildung der Parotis",
      "Gutartige Neubildung des Ductus parotideus",
      "Gutartige Neubildung des Stensen-Ganges",
      "Parotisadenom",
      "Parotiszystadenolymphom",
      "Pleomorphes Adenom der Parotis"
    ]
  },
  {
    "code": "D11.7",
    "name": "Gutartige Neubildung der Glandula sublingualis",
    "synonyms": [
      "Benigner epithelialer Tumor der Glandula sublingualis",
      "Benigner epithelialer Tumor der Glandula submandibularis",
      "Gutartige Neubildung der Glandula sublingualis",
      "Gutartige Neubildung der Glandula submandibularis",
      "Gutartige Neubildung der Unterkieferspeicheldrüse",
      "Gutartige Neubildung der Unterzungenspeicheldrüse",
      "Gutartige Neubildung des Ductus sublingualis",
      "Gutartige Neubildung des Ductus submandibularis",
      "Gutartige Neubildung des Wharton-Ganges"
    ]
  },
  {
    "code": "D11.9",
    "name": "Adenolymphom",
    "synonyms": [
      "Adenolymphom",
      "Basalzelladenom",
      "Benigner epithelialer Speicheldrüsentumor",
      "Gutartige Neubildung der Hauptspeicheldrüse",
      "Gutartige Neubildung der Speicheldrüsen",
      "Gutartige Neubildung einer großen Speicheldrüse",
      "Lymphomatöses Adenom",
      "Sialadenom",
      "Speicheldrüsenadenom",
      "Warthin-Tumor"
    ]
  },
  {
    "code": "D12.0",
    "name": "Gutartige Neubildung des Zäkums",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Zäkums",
      "Gutartige Neubildung der Bauhin-Klappe",
      "Gutartige Neubildung der Ileozäkalklappe",
      "Gutartige Neubildung des Ileozäkums",
      "Gutartige Neubildung des Zäkums",
      "Gutartige Neubildung des ileozäkalen Überganges",
      "Tubulovillöses Adenom des Zäkums",
      "Zäkumadenom"
    ]
  },
  {
    "code": "D12.1",
    "name": "Gutartige Neubildung der Appendix vermiformis",
    "synonyms": [
      "Benigner neuroendokriner Tumor der Appendix",
      "Gutartige Neubildung der Appendix",
      "Gutartige Neubildung der Appendix vermiformis"
    ]
  },
  {
    "code": "D12.2",
    "name": "Gutartige Neubildung des Colon ascendens",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Colon ascendens",
      "Gutartige Neubildung des Colon ascendens",
      "Gutartige Neubildung des rechten Kolons",
      "Tubulovillöses Adenom des Colon ascendens"
    ]
  },
  {
    "code": "D12.3",
    "name": "Gutartige Neubildung des Colon transversum",
    "synonyms": [
      "Benigner neuroendokriner Tumor der Flexura coli dextra",
      "Benigner neuroendokriner Tumor der Flexura coli sinistra",
      "Benigner neuroendokriner Tumor des Colon transversum",
      "Gutartige Neubildung der Flexura coli dextra",
      "Gutartige Neubildung der Flexura coli hepatica",
      "Gutartige Neubildung der Flexura coli lienalis",
      "Gutartige Neubildung der Flexura coli sinistra",
      "Gutartige Neubildung der hepatischen Kolonflexur",
      "Gutartige Neubildung des Colon transversum"
    ]
  },
  {
    "code": "D12.4",
    "name": "Gutartige Neubildung des Colon descendens",
    "synonyms": [
      "Adenom des Colon descendens",
      "Benigner neuroendokriner Tumor des Colon descendens",
      "Gutartige Neubildung des Colon descendens",
      "Gutartige Neubildung des linken Kolons"
    ]
  },
  {
    "code": "D12.5",
    "name": "Sigmoideumadenom",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Colon sigmoideum",
      "Gutartige Neubildung der Flexura coli sigmoidei",
      "Gutartige Neubildung des Colon pelvinum",
      "Gutartige Neubildung des Sigmas",
      "Gutartige Neubildung des distalen Kolons",
      "Sigmoideumadenom",
      "Tubulovillöses Adenom des Colon sigmoideum"
    ]
  },
  {
    "code": "D12.6",
    "name": "Gardner-Syndrom",
    "synonyms": [
      "AFAP [Attenuierte familiäre adenomatöse Polyposis]",
      "APC-assoziierte adenomatöse attenuierte familiäre Polyposis",
      "Adenomatose",
      "Adenomatose des Kolons",
      "Adenomatöse Polyposis des Kolons",
      "Attenuierte FAP [Familiäre adenomatöse Polyposis]",
      "Attenuierte familiäre Polyposis coli",
      "Attenuierte familiäre adenomatöse Polyposis",
      "Darmpolyposis",
      "FAP [Familiäre adenomatöse Polyposis]",
      "Familiäre Polyposis",
      "Familiäre adenomatöse Polyposis",
      "Familiäre intestinale Polyposis",
      "Gardner-Syndrom",
      "Gutartige Neubildung des Dickdarmes",
      "Gutartige Neubildung des Kolons",
      "HMPS [Hereditäres gemischtes Polyposis-Syndrom]",
      "Hereditäre Polyposis coli",
      "Hyperplastisches Polyposis-Syndrom",
      "Intestinal adenomatöse Polyposis",
      "JPS [Juveniles Polyposis-Syndrom]",
      "Juvenile gastrointestinale Polyposis",
      "Juvenile intestinale Polypose",
      "Kappenpolyposis",
      "Kolonadenom",
      "MSH3-assoziierte adenomatöse attenuierte familiäre Polyposis",
      "MUTYH-abhängige attenuierte FAP [Familiäre adenomatöse Polyposis]",
      "MUTYH-abhängige attenuierte familiäre Polyposis coli",
      "MUTYH-abhängige attenuierte familiäre adenomatöse Polyposis",
      "NTHL1-assoziierte adenomatöse attenuierte familiäre Polyposis",
      "PPAP [Polymerase-proofreading-assoziierte Polyposis]",
      "Polymerase-proofreading-assoziierte Polyposis",
      "Polyposis coli",
      "Polyposis intestinalis",
      "Serratiertes Polyposis-Syndrom"
    ]
  },
  {
    "code": "D12.7",
    "name": "Gutartige Neubildung des Kolons und Rektums",
    "synonyms": [
      "Gutartige Neubildung des Kolons und Rektums",
      "Gutartige Neubildung des Rektosigmoids",
      "Gutartige Neubildung des pelvikorektalen Überganges",
      "Gutartige Neubildung des pelvirektalen Überganges",
      "Gutartige Neubildung des rektosigmoidalen Überganges"
    ]
  },
  {
    "code": "D12.8",
    "name": "Rektumadenom",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Rektums",
      "Gutartige Mastdarmneubildung",
      "Gutartige Rektumneubildung",
      "Gutartiger Rektumtumor",
      "Rektumadenom",
      "Tubulovillöses Adenom des Rektums"
    ]
  },
  {
    "code": "D12.9",
    "name": "Gutartige Neubildung des Canalis analis",
    "synonyms": [
      "Analpapillom",
      "Anuspapillom",
      "Benigner neuroendokriner Tumor des Analkanals",
      "Gutartige Neubildung der Hämorrhoidalzone",
      "Gutartige Neubildung der Kloake",
      "Gutartige Neubildung der Morgagni-Krypten",
      "Gutartige Neubildung des Analkanals",
      "Gutartige Neubildung des Analsphinkters",
      "Gutartige Neubildung des Anorektums",
      "Gutartige Neubildung des Anus",
      "Gutartige Neubildung des Canalis analis",
      "Gutartige Neubildung des anorektalen Überganges",
      "Gutartiger Analtumor"
    ]
  },
  {
    "code": "D13.0",
    "name": "Ösophagusadenom",
    "synonyms": [
      "Gutartige Neubildung der Pars abdominalis des Ösophagus",
      "Gutartige Neubildung der Pars cervicalis des Ösophagus",
      "Gutartige Neubildung der Pars thoracica des Ösophagus",
      "Gutartige Neubildung des Ösophagus",
      "Ösophagusadenom"
    ]
  },
  {
    "code": "D13.1",
    "name": "Gutartige Neubildung des Magens",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Magens",
      "Familiärer benigner neuroendokriner Tumor des Magens Typ 1",
      "Gutartige Neubildung der Kardia des Magens",
      "Gutartige Neubildung der Magenwand a.n.k.",
      "Gutartige Neubildung der großen Kurvatur des Magens a.n.k.",
      "Gutartige Neubildung der kleinen Kurvatur des Magens a.n.k.",
      "Gutartige Neubildung des Antrum pyloricum",
      "Gutartige Neubildung des Canalis pyloricus",
      "Gutartige Neubildung des Corpus ventriculi",
      "Gutartige Neubildung des Magenantrums",
      "Gutartige Neubildung des Mageneingangs",
      "Gutartige Neubildung des Magenfundus",
      "Gutartige Neubildung des Magenkorpus",
      "Gutartige Neubildung des Magens",
      "Gutartige Neubildung des Ostium cardiacum",
      "Gutartige Neubildung des Präpylorus",
      "Gutartige Neubildung des Pylorus",
      "Gutartige Neubildung des gastroösophagealen Überganges",
      "Gutartige Neubildung des kardioösophagealen Überganges",
      "Magenschleimhautadenom"
    ]
  },
  {
    "code": "D13.2",
    "name": "Gutartige Neubildung des Duodenums",
    "synonyms": [
      "Adenom des Duodenums",
      "Benigner neuroendokriner Tumor des Duodenums",
      "Gangliozytisches Paragangliom",
      "Gutartige Neubildung des Duodenums"
    ]
  },
  {
    "code": "D13.3",
    "name": "Gutartige Neubildung des Dünndarmes",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Ileums",
      "Benigner neuroendokriner Tumor des Jejunums",
      "Gutartige Neubildung des Dünndarmes",
      "Gutartige Neubildung des Ileums",
      "Gutartige Neubildung des Jejunums",
      "Gutartige Neubildung des duodenojejunalen Überganges",
      "Gutartige Neubildung eines Meckel-Divertikels"
    ]
  },
  {
    "code": "D13.4",
    "name": "Leberzelladenom",
    "synonyms": [
      "Adenohepatom",
      "Adenomatose der Leber",
      "Benignes Hepatom",
      "Cholangiom",
      "Gutartige Neubildung der Ductuli biliferi",
      "Gutartige Neubildung der Ductuli intrahepaticae",
      "Gutartige Neubildung der Leber",
      "Gutartige Neubildung der interlobulären Gallengänge",
      "Gutartige Neubildung der interlobulären Gallenwege",
      "Gutartige Neubildung der intrahepatischen Gallengänge",
      "Gutartige Neubildung der intrahepatischen Gallenwege",
      "Gutartige Neubildung der intralobulären Gallengänge",
      "Gutartige Neubildung der intralobulären Gallenwege",
      "Gutartiges adultes reifzelliges Leberteratom",
      "Hepatische gutartige Neubildung",
      "Hepatocholangiom",
      "Hepatozelluläres Adenom",
      "Hepatozelluläres teleangiektatisches Adenom",
      "Intrahepatisches Gallengangsadenom",
      "Leberadenom",
      "Leberzelladenom",
      "Teleangiektatische fokale noduläre Leberhyperplasie",
      "Zystadenom des intrahepatischen Gallenganges",
      "Zystisches Leberhamartom"
    ]
  },
  {
    "code": "D13.5",
    "name": "Gallenblasenadenomyomatose",
    "synonyms": [
      "Adenom der Papilla Vateri",
      "Adenom des Ductus choledochus",
      "Extrahepatisches Gallengangsadenom",
      "Gallenblasenadenomyomatose",
      "Gallengangsadenom",
      "Gutartige Neubildung der Ampulla Vateri",
      "Gutartige Neubildung der Gallenblase",
      "Gutartige Neubildung der Gallenwege",
      "Gutartige Neubildung der extrahepatischen Gallengänge",
      "Gutartige Neubildung des Ductus choledochus",
      "Gutartige Neubildung des Ductus cysticus",
      "Gutartige Neubildung des Ductus hepaticus",
      "Gutartige Neubildung des Gallenblasenganges",
      "Gutartige Neubildung des Gallenganges",
      "Gutartige Neubildung des Sphincter Oddi"
    ]
  },
  {
    "code": "D13.6",
    "name": "Gutartige Neubildung des Pankreas",
    "synonyms": [
      "Bauchspeicheldrüsenadenom",
      "Gastrinproduzierendes Pankreasadenom",
      "Gutartige Neubildung der Bauchspeicheldrüse",
      "Gutartige Neubildung des Ductus pancreaticus accessorius",
      "Gutartige Neubildung des Pankreas",
      "Gutartige Neubildung des Pankreasganges",
      "Gutartige Neubildung des Pankreashalses",
      "Gutartige Neubildung des Pankreaskopfes",
      "Gutartige Neubildung des Pankreaskörpers",
      "Gutartige Neubildung des Pankreasschwanzes",
      "Gutartige Neubildung des Santorini-Ganges",
      "Gutartige Neubildung des Wirsung-Ganges",
      "Mikrozystisches Adenom",
      "Mikrozystisches Pankreasadenom",
      "Pankreasadenom",
      "Zystadenom des Pankreas"
    ]
  },
  {
    "code": "D13.7",
    "name": "Inselzelladenom",
    "synonyms": [
      "Adenoma insucellulare",
      "Alpha-Zell-Adenom",
      "Alpha-Zell-Tumor",
      "B-Zell-Tumor",
      "Benigner nicht-funktioneller neuroendokriner Tumor des Pankreas",
      "Benignes Glukagonom",
      "Benignes Glukagonom des Pankreas",
      "Benignes Insulinom",
      "Benignes Pankreasinsulinom",
      "Beta-Zell-Adenom",
      "Beta-Zell-Tumor",
      "Gutartige Nesidioblastose",
      "Gutartige Neubildung der Inselzellen des Pankreas",
      "Gutartige Neubildung der Langerhans-Inseln",
      "Gutartiger Inselzelltumor",
      "Gutartiges Insulinom",
      "Gutartiges Nesidioblastom",
      "Inselzelladenom",
      "Inselzelltumor des Pankreas",
      "Nesidioblastom des Pankreas",
      "Nesidiom",
      "Nesidiom des Pankreas"
    ]
  },
  {
    "code": "D13.9",
    "name": "Gutartiger Darmtumor",
    "synonyms": [
      "Darmadenom",
      "Fibrosplenom",
      "Gutartige Neubildung der Milz",
      "Gutartige Neubildung der Verdauungsorgane a.n.k.",
      "Gutartige Neubildung der Verdauungswege a.n.k.",
      "Gutartige Neubildung des Darmes",
      "Gutartige Neubildung des Darmtraktes a.n.k.",
      "Gutartige Neubildung des Gallensystems",
      "Gutartige Neubildung des Gastrointestinaltraktes",
      "Gutartige Neubildung des Intestinums",
      "Gutartige Neubildung des Magen-Darm-Kanals",
      "Gutartige Neubildung des Verdauungssystems",
      "Gutartiger Darmtumor",
      "Peritoneale Splenose",
      "Splenadenom",
      "Splenom"
    ]
  },
  {
    "code": "D14.0",
    "name": "Rhinopapillom",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Mittelohrs",
      "Endolymphsacktumor",
      "Gutartige Neubildung der Conchae nasales",
      "Gutartige Neubildung der Eustachi-Röhre",
      "Gutartige Neubildung der Fossa nasalis",
      "Gutartige Neubildung der Keilbeinhöhle",
      "Gutartige Neubildung der Kieferhöhle",
      "Gutartige Neubildung der Mastoidzellen",
      "Gutartige Neubildung der Nares",
      "Gutartige Neubildung der Nasenhöhle",
      "Gutartige Neubildung der Nasenlöcher",
      "Gutartige Neubildung der Nasennebenhöhle",
      "Gutartige Neubildung der Nasenschleimhaut",
      "Gutartige Neubildung der Nebenhöhle",
      "Gutartige Neubildung der Oberkieferhöhle",
      "Gutartige Neubildung der Oberkiefernebenhöhle",
      "Gutartige Neubildung der Paukenhöhle",
      "Gutartige Neubildung der Schleimhaut der Nasenmuschel",
      "Gutartige Neubildung der Siebbeinhöhle",
      "Gutartige Neubildung der Sinus paranasales a.n.k.",
      "Gutartige Neubildung der Stirnhöhle",
      "Gutartige Neubildung der Tuba auditiva",
      "Gutartige Neubildung der inneren Nase",
      "Gutartige Neubildung des Antrum Highmore",
      "Gutartige Neubildung des Antrum maxillaris",
      "Gutartige Neubildung des Antrum tympanicum",
      "Gutartige Neubildung des Cavum tympani",
      "Gutartige Neubildung des Innenohres",
      "Gutartige Neubildung des Mittelohres",
      "Gutartige Neubildung des Nasenbindegewebes",
      "Gutartige Neubildung des Nasenknorpels",
      "Gutartige Neubildung des Nasenseptums",
      "Gutartige Neubildung des Nasenvorhofs",
      "Gutartige Neubildung des Oberkiefersinus",
      "Gutartige Neubildung des Sinus ethmoidalis",
      "Gutartige Neubildung des Sinus frontalis",
      "Gutartige Neubildung des Sinus maxillaris",
      "Gutartige Neubildung des Sinus sphenoidalis",
      "Gutartige Neubildung des Vestibulum nasi",
      "Gutartige Neubildung des inneren Gehörganges",
      "Nasenpapillom",
      "Rhinopapillom",
      "Schneider-Papillom"
    ]
  },
  {
    "code": "D14.1",
    "name": "Larynxadenom",
    "synonyms": [
      "Benigner neuroendokriner Tumor des Larynx",
      "Gutartige Neubildung der Cartilago arytaenoidea",
      "Gutartige Neubildung der Epiglottis",
      "Gutartige Neubildung der Glottis",
      "Gutartige Neubildung der Kehlkopfkommissur",
      "Gutartige Neubildung der Larynxkommissur a.n.k.",
      "Gutartige Neubildung der Plica ventricularis laryngis",
      "Gutartige Neubildung der Stimmbänder",
      "Gutartige Neubildung der falschen Stimmbänder",
      "Gutartige Neubildung der hinteren Oberfläche der Epiglottis",
      "Gutartige Neubildung der laryngealen Seite der Plica aryepiglottica",
      "Gutartige Neubildung der laryngealen Seite der aryepiglottischen Falte",
      "Gutartige Neubildung der suprahyoidalen Epiglottis",
      "Gutartige Neubildung des Aryknorpels",
      "Gutartige Neubildung des Epiglottisknorpels",
      "Gutartige Neubildung des Gießbeckenknorpels",
      "Gutartige Neubildung des Kegelknorpels",
      "Gutartige Neubildung des Kehlkopfes",
      "Gutartige Neubildung des Kehlkopfknorpels",
      "Gutartige Neubildung des Larynx",
      "Gutartige Neubildung des Larynxbindegewebes",
      "Gutartige Neubildung des Larynxknorpels",
      "Gutartige Neubildung des Ligamentum vestibulare",
      "Gutartige Neubildung des Ligamentum vocale",
      "Gutartige Neubildung des Ringknorpels",
      "Gutartige Neubildung des Schildknorpels",
      "Gutartige Neubildung des Stellknorpels",
      "Gutartige Neubildung des inneren Larynx a.n.k.",
      "Gutartige Neubildung des suprahyoidalen Anteils der Epiglottis",
      "Gutartige Neubildung des äußeren Larynx a.n.k.",
      "Kehlkopfadenom",
      "Larynxadenom",
      "Larynxchondrom",
      "Larynxmyom",
      "Larynxmyxom",
      "Larynxpapillomatose",
      "Stimmbandleiomyom",
      "Stimmbandmyom",
      "Stimmbandpapillom",
      "Subglottische gutartige Neubildung",
      "Supraglottische gutartige Neubildung"
    ]
  },
  {
    "code": "D14.2",
    "name": "Tracheaadenom",
    "synonyms": [
      "Gutartige Neubildung der Luftröhre",
      "Gutartige Neubildung der Trachea",
      "Gutartige Neubildung des Luftröhrenknorpels",
      "Gutartige Neubildung des Tracheaknorpels",
      "Tracheaadenom",
      "Tracheachondrom",
      "Tracheafibrom",
      "Tracheapapillom",
      "Tracheobronchiale gutartige Neubildung"
    ]
  },
  {
    "code": "D14.3",
    "name": "Lungenalveolaradenom",
    "synonyms": [
      "Adenomatoid-zystische Lungendegeneration",
      "Alveoläres Adenom",
      "DIPNECH [Diffuse idiopathische pulmonale neuroendokrine Zellhyperplasie]",
      "Diffuse idiopathische pulmonale neuroendokrine Zellhyperplasie",
      "Gutartige Neubildung der Bronchien",
      "Gutartige Neubildung der Bronchiolen",
      "Gutartige Neubildung der Carina tracheae",
      "Gutartige Neubildung der Lingula pulmonis sinistri",
      "Gutartige Neubildung der Lunge",
      "Gutartige Neubildung des Bronchialknorpels",
      "Gutartige Neubildung des Hauptbronchus",
      "Gutartige Neubildung des Hilus pulmonis",
      "Gutartige Neubildung des Lobus inferior pulmonis",
      "Gutartige Neubildung des Lobus lingualis pulmonis",
      "Gutartige Neubildung des Lobus medius pulmonis",
      "Gutartige Neubildung des Lobus superior pulmonis",
      "Gutartige Neubildung des Lobus venae azygos",
      "Gutartige Neubildung des Lungenhilus",
      "Gutartige Neubildung des Lungenmittellappens",
      "Gutartige Neubildung des Lungenoberlappens",
      "Gutartige Neubildung des Lungenunterlappens",
      "Lungenalveolaradenom",
      "Lungenchondrom",
      "Pulmonale gutartige Neubildung",
      "Subpleurale gutartige Neubildung"
    ]
  },
  {
    "code": "D14.4",
    "name": "Gutartige Neubildung der Atmungsorgane",
    "synonyms": [
      "Gutartige Neubildung der Atemwege a.n.k.",
      "Gutartige Neubildung der Atmungsorgane",
      "Gutartige Neubildung der Respirationsorgane a.n.k.",
      "Gutartige Neubildung der oberen Atemwege",
      "Gutartige Neubildung der oberen Luftwege",
      "Gutartige Neubildung des Atemsystems a.n.k.",
      "Gutartige Neubildung des Respirationssystems a.n.k.",
      "Gutartige Neubildung des Respirationstraktes a.n.k.",
      "Gutartige Neubildung des oberen Respirationstraktes a.n.k.",
      "Rezidivierende respiratorische Papillomatose"
    ]
  },
  {
    "code": "D15.0",
    "name": "Thymom",
    "synonyms": [
      "Benignes Thymom Typ A",
      "Benignes Thymom Typ AB",
      "Benignes Thymom Typ B",
      "Gutartige Neubildung des Thymus",
      "Gutartiges Thymom",
      "Thymoblastom",
      "Thymom",
      "Thymusepitheliom"
    ]
  },
  {
    "code": "D15.1",
    "name": "Gutartige Neubildung des Herzens",
    "synonyms": [
      "Benigner primärer kardialer Tumor des Erwachsenen",
      "Benigner primärer kardialer Tumor im Kindesalter",
      "Familiäres atriales Myxom",
      "Gutartige Neubildung der Herzventrikel",
      "Gutartige Neubildung des Atrium cordis",
      "Gutartige Neubildung des Endokards",
      "Gutartige Neubildung des Epikards",
      "Gutartige Neubildung des Herzens",
      "Gutartige Neubildung des Myokards",
      "Gutartige Neubildung des Perikards",
      "Herzmyom",
      "Kardiales papilläres Fibroelastom",
      "Papilläres Fibroelastom des Herzens",
      "Vorhofmyxom"
    ]
  },
  {
    "code": "D15.2",
    "name": "Gutartige Neubildung des Mediastinums",
    "synonyms": [
      "Gutartige Neubildung des Mediastinums",
      "Gutartige Neubildung des anterioren Mediastinums",
      "Gutartige Neubildung des posterioren Mediastinums",
      "Substernale gutartige Neubildung"
    ]
  },
  {
    "code": "D15.7",
    "name": "Gutartige Neubildung der Pleura",
    "synonyms": [
      "Gutartige Neubildung der Pleura",
      "Gutartige Neubildung der Pleura parietalis",
      "Gutartige Neubildung der Pleura pulmonalis"
    ]
  },
  {
    "code": "D16.0",
    "name": "Gutartige Neubildung des Akromions",
    "synonyms": [
      "Chondromyxoides Fibrom der langen Knochen der oberen Gliedmaßen",
      "Gutartige Neubildung der Armknochen a.n.k.",
      "Gutartige Neubildung der Ellenbogenknochen",
      "Gutartige Neubildung der Knochen der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut der Schulter",
      "Gutartige Neubildung der Knochenhaut der Skapula",
      "Gutartige Neubildung der Knochenhaut der Speiche",
      "Gutartige Neubildung der Knochenhaut der Ulna",
      "Gutartige Neubildung der Knochenhaut der langen Knochen der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut des Akromions",
      "Gutartige Neubildung der Knochenhaut des Arms a.n.k.",
      "Gutartige Neubildung der Knochenhaut des Ellenbogens",
      "Gutartige Neubildung der Knochenhaut des Humerus",
      "Gutartige Neubildung der Knochenhaut des Radius",
      "Gutartige Neubildung der Knochenhaut des Unterarms",
      "Gutartige Neubildung der Schulterknochen",
      "Gutartige Neubildung der Skapula",
      "Gutartige Neubildung der Speiche",
      "Gutartige Neubildung der Ulna",
      "Gutartige Neubildung der Unterarmknochen",
      "Gutartige Neubildung der langen Knochen der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung des Akromioklavikulargelenks a.n.k.",
      "Gutartige Neubildung des Akromions",
      "Gutartige Neubildung des Humerus",
      "Gutartige Neubildung des Radius",
      "Gutartige Neubildung des Schulterblattes",
      "Osteoblastom der Skapula",
      "Osteoblastom der Ulna",
      "Osteoblastom der langen Knochen der oberen Gliedmaßen",
      "Osteoblastom des Humerus",
      "Osteoblastom des Radius"
    ]
  },
  {
    "code": "D16.1",
    "name": "Gutartige Neubildung der Handphalangen",
    "synonyms": [
      "Chondromyxoides Fibrom der kurzen Knochen der oberen Gliedmaßen",
      "Gutartige Neubildung der Daumenknochen",
      "Gutartige Neubildung der Fingerknochen",
      "Gutartige Neubildung der Handknochen",
      "Gutartige Neubildung der Handphalangen",
      "Gutartige Neubildung der Handwurzelknochen",
      "Gutartige Neubildung der Knochen der Handphalangen",
      "Gutartige Neubildung der Knochenhaut der Finger",
      "Gutartige Neubildung der Knochenhaut der Hand",
      "Gutartige Neubildung der Knochenhaut der Handphalangen",
      "Gutartige Neubildung der Knochenhaut der Handwurzel",
      "Gutartige Neubildung der Knochenhaut der Mittelhand",
      "Gutartige Neubildung der Knochenhaut der kurzen Knochen der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut des Daumens",
      "Gutartige Neubildung der Mittelhandknochen",
      "Gutartige Neubildung der kurzen Knochen der oberen Gliedmaßen",
      "Gutartige Neubildung des Metakarpus",
      "Osteoblastom der Daumenknochen",
      "Osteoblastom der Fingerknochen",
      "Osteoblastom der Handknochen",
      "Osteoblastom der Handphalangen",
      "Osteoblastom der Handwurzelknochen",
      "Osteoblastom der Knochen der Handphalangen",
      "Osteoblastom der Mittelhandknochen",
      "Osteoblastom der kurzen Knochen der oberen Gliedmaßen",
      "Osteoblastom des Metakarpus"
    ]
  },
  {
    "code": "D16.2",
    "name": "Gutartige Neubildung des Femurs",
    "synonyms": [
      "Chondromyxoides Fibrom der langen Knochen der unteren Gliedmaßen",
      "Gutartige Neubildung der Beinknochen a.n.k.",
      "Gutartige Neubildung der Fibula",
      "Gutartige Neubildung der Knochen am Kniegelenk",
      "Gutartige Neubildung der Knochen der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut der Fibula",
      "Gutartige Neubildung der Knochenhaut der Tibia",
      "Gutartige Neubildung der Knochenhaut der langen Knochen der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut des Beins a.n.k.",
      "Gutartige Neubildung der Knochenhaut des Femurs",
      "Gutartige Neubildung der Knochenhaut des Knies",
      "Gutartige Neubildung der Tibia",
      "Gutartige Neubildung der langen Knochen der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung des Femurs",
      "Gutartige Neubildung des Meniskus",
      "Gutartige Neubildung des Semilunarknorpels am Knie",
      "Osteoblastom der Fibula",
      "Osteoblastom der Tibia",
      "Osteoblastom der langen Knochen der unteren Gliedmaßen",
      "Osteoblastom des Femurs",
      "Osteofibröse Dysplasie der Fibula",
      "Osteofibröse Dysplasie der Tibia"
    ]
  },
  {
    "code": "D16.3",
    "name": "Kartilaginäre Exostose der Großzehe",
    "synonyms": [
      "Chondromyxoides Fibrom der kurzen Knochen der unteren Gliedmaßen",
      "Gutartige Neubildung der Fersenknochen",
      "Gutartige Neubildung der Fußknochen",
      "Gutartige Neubildung der Fußphalangen",
      "Gutartige Neubildung der Fußwurzelknochen",
      "Gutartige Neubildung der Knochenhaut der Ferse",
      "Gutartige Neubildung der Knochenhaut der Fußphalangen",
      "Gutartige Neubildung der Knochenhaut der Fußwurzel",
      "Gutartige Neubildung der Knochenhaut der Patella",
      "Gutartige Neubildung der Knochenhaut der Zehen",
      "Gutartige Neubildung der Knochenhaut der kurzen Knochen der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut des Astragalus",
      "Gutartige Neubildung der Knochenhaut des Calcaneus",
      "Gutartige Neubildung der Knochenhaut des Fersenbeins",
      "Gutartige Neubildung der Knochenhaut des Fußes",
      "Gutartige Neubildung der Knochenhaut des Knöchels",
      "Gutartige Neubildung der Knochenhaut des Mittelfußes",
      "Gutartige Neubildung der Knochenhaut des Sprungbeins",
      "Gutartige Neubildung der Knöchelknochen",
      "Gutartige Neubildung der Mittelfußknochen",
      "Gutartige Neubildung der Patella",
      "Gutartige Neubildung der Zehenknochen",
      "Gutartige Neubildung der kurzen Knochen der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung des Astragalus",
      "Gutartige Neubildung des Calcaneus",
      "Gutartige Neubildung des Fersenbeins",
      "Gutartige Neubildung des Metatarsus",
      "Gutartige Neubildung des Sprungbeins",
      "Gutartige Neubildung des Tarsus",
      "Kartilaginäre Exostose der Großzehe",
      "Osteoblastom der Mittelfußknochen",
      "Osteoblastom der Patella",
      "Osteoblastom der Zehenknochen",
      "Osteoblastom der kurzen Knochen der unteren Extremität",
      "Osteoblastom des Calcaneus",
      "Osteoblastom des Tarsus"
    ]
  },
  {
    "code": "D16.41",
    "name": "Benigner Orbitaknochentumor",
    "synonyms": [
      "Benigner Knochentumor des Kopfes",
      "Benigner Orbitaknochentumor",
      "Chondromyxoides Fibrom des Kopfes",
      "Gutartige Neubildung der Calvaria",
      "Gutartige Neubildung der Keilbeinknochen",
      "Gutartige Neubildung der Knochen der Augenhöhle",
      "Gutartige Neubildung der Knochenhaut der Calvaria",
      "Gutartige Neubildung der Knochenhaut der Orbita",
      "Gutartige Neubildung der Knochenhaut der Sella turcica",
      "Gutartige Neubildung der Knochenhaut der Stirn",
      "Gutartige Neubildung der Knochenhaut des Clivus",
      "Gutartige Neubildung der Knochenhaut des Craniums",
      "Gutartige Neubildung der Knochenhaut des Hinterhauptbeins",
      "Gutartige Neubildung der Knochenhaut des Keilbeins",
      "Gutartige Neubildung der Knochenhaut des Scheitelbeins",
      "Gutartige Neubildung der Knochenhaut des Schläfenbeins",
      "Gutartige Neubildung der Knochenhaut des Schädeldaches",
      "Gutartige Neubildung der Knochenhaut des Schädels",
      "Gutartige Neubildung der Orbitaknochen",
      "Gutartige Neubildung der Schädelknochen",
      "Gutartige Neubildung der Sella turcica",
      "Gutartige Neubildung der Siebbeinknochen",
      "Gutartige Neubildung der Siebbeinzellen",
      "Gutartige Neubildung der Stirnknochen",
      "Gutartige Neubildung des Clivus",
      "Gutartige Neubildung des Craniums",
      "Gutartige Neubildung des Hinterhauptbeins",
      "Gutartige Neubildung des Keilbeins",
      "Gutartige Neubildung des Mastoidknochens",
      "Gutartige Neubildung des Os ethmoidale",
      "Gutartige Neubildung des Os frontale",
      "Gutartige Neubildung des Os occipitale",
      "Gutartige Neubildung des Os parietale",
      "Gutartige Neubildung des Os sphenoidale",
      "Gutartige Neubildung des Os temporale",
      "Gutartige Neubildung des Processus mastoideus",
      "Gutartige Neubildung des Scheitelbeins",
      "Gutartige Neubildung des Schläfenbeins",
      "Gutartige Neubildung des Schädeldaches",
      "Gutartige Neubildung des Schädelknochens",
      "Gutartige Neubildung des Schädels",
      "Gutartige Neubildung des Stirnbeins",
      "Gutartige Neubildung des Warzenfortsatzes",
      "Osteoblastom der Keilbeinknochen",
      "Osteoblastom der Knochen der Augenhöhle",
      "Osteoblastom der Orbitaknochen",
      "Osteoblastom der Schädelknochen",
      "Osteoblastom der Siebbeinknochen",
      "Osteoblastom der Stirnknochen",
      "Osteoblastom des Craniums",
      "Osteoblastom des Hinterhauptbeins",
      "Osteoblastom des Keilbeins",
      "Osteoblastom des Os ethmoidale",
      "Osteoblastom des Os frontale",
      "Osteoblastom des Os occipitale",
      "Osteoblastom des Os parietale",
      "Osteoblastom des Os sphenoidale",
      "Osteoblastom des Os temporale",
      "Osteoblastom des Scheitelbeins",
      "Osteoblastom des Schläfenbeins",
      "Osteoblastom des Stirnbeins"
    ]
  },
  {
    "code": "D16.42",
    "name": "Oberkieferadenoameloblastom",
    "synonyms": [
      "Adenomatoider odontogener Oberkiefertumor",
      "Ameloblastisches Fibroodontom des Oberkieferknochens",
      "Ameloblastisches Oberkieferfibrom",
      "Ameloblastisches Odontom des Oberkieferknochens",
      "Ameloblastoodontom des Oberkieferknochens",
      "Cementoma",
      "Cementoma gingantoforme des Oberkieferknochens",
      "Dentinoblastom des Oberkieferknochens",
      "Dentinom des Oberkieferknochens",
      "Epithelialer odontogener Oberkiefertumor",
      "Familiäres ossifizierendes Fibrom des Oberkieferknochens",
      "Fibrinorrhoea plastica des Oberkieferknochens",
      "Fibrinorrhoea plastica des Oberkiefers",
      "Fibroameloblastisches Odontom des Oberkieferknochens",
      "Floride Oberkieferknochendysplasie",
      "Floride ossäre Dysplasie",
      "Floride ossäre Dysplasie der Maxilla",
      "Floride ossäre Dysplasie des Oberkiefers",
      "Gutartige Neubildung der Gesichtsknochen",
      "Gutartige Neubildung der Kieferknochen",
      "Gutartige Neubildung der Knochen der Nasenmuschel",
      "Gutartige Neubildung der Knochenhaut der Gesichtsknochen",
      "Gutartige Neubildung der Knochenhaut der Nase",
      "Gutartige Neubildung der Knochenhaut des Jochbeins",
      "Gutartige Neubildung der Knochenhaut des Kiefers",
      "Gutartige Neubildung der Knochenhaut des Pflugscharbeins",
      "Gutartige Neubildung der Knochenhaut des Siebbeins",
      "Gutartige Neubildung der Knochenhaut des Vomer",
      "Gutartige Neubildung der Knochenhaut des Zungenbeins",
      "Gutartige Neubildung der Maxilla",
      "Gutartige Neubildung der Nasenmuschel",
      "Gutartige Neubildung der Nebenhöhlenknochen",
      "Gutartige Neubildung des Gesichtsknochens",
      "Gutartige Neubildung des Jochbeins",
      "Gutartige Neubildung des Nasenbeins",
      "Gutartige Neubildung des Nasenknochens",
      "Gutartige Neubildung des Oberkieferknochens",
      "Gutartige Neubildung des Os nasale",
      "Gutartige Neubildung des Os zygomaticum",
      "Gutartige Neubildung des Pflugscharbeins",
      "Gutartige Neubildung des Vomer",
      "Gutartige Neubildung des Zungenbeins",
      "Gutartiger odontogener Oberkiefertumor",
      "Gutartiges Zementoblastom des Oberkieferknochens",
      "Kalzifizierende odontogene Oberkieferknochenzyste",
      "Keratozystisch-odontogener Tumor der Maxilla",
      "Komplexes Odontom des Oberkieferknochens",
      "Nasenosteom",
      "Oberkieferadamantinom",
      "Oberkieferadenoameloblastom",
      "Oberkieferameloblastenfibrom",
      "Odontoameloblastom des Oberkieferknochens",
      "Odontogene Keratozyste am Oberkiefer",
      "Odontogene Plattenepithelgeschwulst des Oberkiefers",
      "Odontogenes Oberkieferknochenfibrom",
      "Odontogenes Oberkiefermyxofibrom",
      "Odontogenes Oberkiefermyxom",
      "Odontom des Oberkieferknochens",
      "Osteoblastom der Gesichtsknochen",
      "Osteoblastom der Maxilla",
      "Osteoblastom der Nasenmuschel",
      "Osteoblastom des Gesichtsknochens",
      "Osteoblastom des Jochbeins",
      "Osteoblastom des Oberkieferknochens",
      "Osteoblastom des Os nasale",
      "Osteoblastom des Os zygomaticum",
      "Osteoblastom des Pflugscharbeins",
      "Osteoblastom des Vomer",
      "Periapikale Oberkieferknochendysplasie",
      "Pindborg-Tumor [Gutartiger kalzifizierender epithelialer odontogener Tumor] des Oberkiefers",
      "Plattenepithelialer odontogener Oberkiefertumor",
      "Riesenzelliges Zementom des Oberkieferknochens",
      "Zementom",
      "Zementom des Oberkieferknochens",
      "Zusammengesetztes Odontom des Oberkieferknochens"
    ]
  },
  {
    "code": "D16.5",
    "name": "Adenoameloblastom",
    "synonyms": [
      "Adamantinoblastom",
      "Adamantinom",
      "Adamantinom der Mandibula",
      "Adamantinom des Unterkieferknochens",
      "Adamantinom des Unterkiefers",
      "Adenoameloblastom",
      "Adenoameloblastom des Unterkiefers",
      "Adenomatoider odontogener Tumor",
      "Ameloblastenfibrom",
      "Ameloblastisches Fibrom",
      "Ameloblastisches Fibroodontom",
      "Ameloblastisches Odontom",
      "Ameloblastom",
      "Ameloblastom der Mandibula",
      "Ameloblastom des Unterkieferknochens",
      "Ameloblastom des Unterkiefers",
      "Ameloblastoodontom",
      "Cementoblastoma",
      "Cementoma gingantoforme",
      "Chondromyxoides Fibrom des Unterkieferknochens",
      "Dentinoblastom",
      "Dentinom",
      "Familiäres ossifizierendes Fibrom des Unterkieferknochens",
      "Fibroameloblastisches Odontom",
      "Floride ossäre Dysplasie der Mandibula",
      "Floride ossäre Dysplasie des Unterkiefers",
      "Gutartige Neubildung der Knochenhaut der Mandibula",
      "Gutartige Neubildung der Knochenhaut des Unterkiefers",
      "Gutartige Neubildung der Mandibula",
      "Gutartige Neubildung des Temporomandibulargelenks a.n.k.",
      "Gutartige Neubildung des Unterkieferalveolarfortsatzes",
      "Gutartige Neubildung des Unterkieferalveolarkammes",
      "Gutartige Neubildung des Unterkieferalveolarkamms",
      "Gutartige Neubildung des Unterkieferknochens",
      "Gutartiger odontogener Tumor",
      "Kalzifizierende odontogene Zyste",
      "Keratozyste",
      "Keratozystisch-odontogener Tumor der Mandibula",
      "Komplexes Odontom",
      "Odontoameloblastom",
      "Odontogene Keratozyste",
      "Odontogene Plattenepithelgeschwulst",
      "Odontogenes Fibrom",
      "Odontogenes Myxofibrom",
      "Odontogenes Myxom",
      "Odontom",
      "Osteoblastom der Mandibula",
      "Osteoblastom des Unterkieferknochens",
      "Periapikale zemento-ossale Dysplasie",
      "Peripheres odontogenes Fibrom",
      "Pindborg-Tumor [Gutartiger kalzifizierender epithelialer odontogener Tumor]",
      "Plattenepithelialer odontogener Tumor",
      "Riesenzelliges Zementom",
      "Verkalkender epithelialer odontogener Tumor",
      "Zementoblastom",
      "Zusammengesetztes Odontom"
    ]
  },
  {
    "code": "D16.6",
    "name": "Gutartige Neubildung der Wirbelsäule",
    "synonyms": [
      "Chondromyxoides Fibrom der Wirbelsäule",
      "Gutartige Neubildung der Knochen der Wirbelsäule",
      "Gutartige Neubildung der Knochenhaut der Wirbelsäule",
      "Gutartige Neubildung der Knochenhaut des Atlas",
      "Gutartige Neubildung der Knochenhaut des Axis",
      "Gutartige Neubildung der Knochenhaut des Rückens a.n.k.",
      "Gutartige Neubildung der Rückenknochen a.n.k.",
      "Gutartige Neubildung der Wirbelsäule",
      "Gutartige Neubildung des Atlas",
      "Gutartige Neubildung des Axis",
      "Gutartige Neubildung einer Bandscheibe",
      "Gutartige Neubildung einer Intervertebralscheibe",
      "Gutartige Neubildung einer Zwischenwirbelscheibe",
      "Gutartige Neubildung eines Discus intervertebralis",
      "Gutartige Neubildung eines Nucleus pulposus",
      "Gutartige Neubildung eines Wirbels",
      "Osteoblastom der Knochen der Wirbelsäule",
      "Osteoblastom der Wirbelsäule",
      "Osteoblastom des Atlas",
      "Osteoblastom des Axis",
      "Osteoblastom eines Wirbels"
    ]
  },
  {
    "code": "D16.70",
    "name": "Gutartige Neubildung der Rippe",
    "synonyms": [
      "Chondromyxoides Fibrom der Rippe",
      "Gutartige Neubildung der Knochenhaut der Rippen",
      "Gutartige Neubildung der Rippe",
      "Gutartige Neubildung des Kostalknorpels",
      "Gutartige Neubildung des Kostovertebralgelenks a.n.k.",
      "Gutartige Neubildung des Rippenknorpels",
      "Osteoblastom der Rippe"
    ]
  },
  {
    "code": "D16.71",
    "name": "Gutartige Neubildung des Brustbeins",
    "synonyms": [
      "Chondromyxoides Fibrom des Sternums",
      "Gutartige Neubildung der Knochenhaut des Brustbeins",
      "Gutartige Neubildung der Knochenhaut des Processus xiphoideus",
      "Gutartige Neubildung der Knochenhaut des Sternums",
      "Gutartige Neubildung des Brustbeins",
      "Gutartige Neubildung des Processus xiphoideus",
      "Gutartige Neubildung des Sternokostalgelenks a.n.k.",
      "Gutartige Neubildung des Sternums",
      "Osteoblastom des Brustbeins",
      "Osteoblastom des Sternums"
    ]
  },
  {
    "code": "D16.72",
    "name": "Gutartige Neubildung des Schlüsselbeins",
    "synonyms": [
      "Chondromyxoides Fibrom des Schlüsselbeins",
      "Gutartige Neubildung der Klavikula",
      "Gutartige Neubildung der Knochenhaut der Klavikula",
      "Gutartige Neubildung der Knochenhaut des Schlüsselbeins",
      "Gutartige Neubildung des Schlüsselbeins",
      "Osteoblastom der Klavikula",
      "Osteoblastom des Schlüsselbeins"
    ]
  },
  {
    "code": "D16.8",
    "name": "Gutartige Neubildung der Beckenknochen",
    "synonyms": [
      "Benignes sakrokokzygeales Teratom",
      "Chondromyxoides Fibrom der Beckenknochen",
      "Gutartige Neubildung der Beckenknochen",
      "Gutartige Neubildung der Hüftknochen",
      "Gutartige Neubildung der Knochenhaut der Hüfte",
      "Gutartige Neubildung der Knochenhaut des Azetabulums",
      "Gutartige Neubildung der Knochenhaut des Beckens",
      "Gutartige Neubildung der Knochenhaut des Darmbeins",
      "Gutartige Neubildung der Knochenhaut des Hüftbeins",
      "Gutartige Neubildung der Knochenhaut des Kreuzbeins",
      "Gutartige Neubildung der Knochenhaut des Schambeins",
      "Gutartige Neubildung der Knochenhaut des Sitzbeins",
      "Gutartige Neubildung der Knochenhaut des Steißbeins",
      "Gutartige Neubildung der Symphysis pubica",
      "Gutartige Neubildung des Azetabulums",
      "Gutartige Neubildung des Darmbeins",
      "Gutartige Neubildung des Hüftbeins",
      "Gutartige Neubildung des Kreuzbeins",
      "Gutartige Neubildung des Schambeins",
      "Gutartige Neubildung des Sitzbeins",
      "Gutartige Neubildung des Steißbeins",
      "Osteoblastom der Beckenknochen",
      "Osteoblastom der Hüftknochen",
      "Osteoblastom des Azetabulums",
      "Osteoblastom des Darmbeins",
      "Osteoblastom des Hüftbeins",
      "Osteoblastom des Kreuzbeins",
      "Osteoblastom des Schambeins",
      "Osteoblastom des Sitzbeins",
      "Osteoblastom des Steißbeins"
    ]
  },
  {
    "code": "D16.9",
    "name": "Chondroosteom",
    "synonyms": [
      "Chondroblastom",
      "Chondrom",
      "Chondromatöser riesenzelliger Tumor",
      "Chondromyxofibrom",
      "Chondromyxoides Fibrom",
      "Chondromyxom",
      "Chondroosteom",
      "Codman-Tumor",
      "Ekchondrom",
      "Fibroangiochondrom",
      "Fibroma chondromyxoides",
      "Fibromyxoidchondrom",
      "Fibroosteom",
      "Fibrozementom",
      "Gutartige Neubildung der Gliedmaßenknochen a.n.k.",
      "Gutartige Neubildung der Knochenhaut",
      "Gutartige Neubildung der Knochenhaut der Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Knochenhaut der Phalanxknochen",
      "Gutartige Neubildung der Knochenhaut des Skeletts a.n.k.",
      "Gutartige Neubildung der Phalangen",
      "Gutartige Neubildung der kurzen Knochen",
      "Gutartige Neubildung der langen Knochen",
      "Gutartige Neubildung des Gelenkknorpels",
      "Gutartige Neubildung des Knochens",
      "Gutartige Neubildung des Knorpels",
      "Gutartige Neubildung des Skeletts a.n.k.",
      "Gutartige Neubildung eines Gelenks a.n.k.",
      "Jaffé-Osteoidosteom",
      "Juxtakortikales Chondrom",
      "Kartilaginäre Exostose",
      "Melanoameloblastom",
      "Melanotisches Ameloblastom",
      "Myxochondrofibrom",
      "Myxochondrom",
      "Ossifizierendes Fibrom",
      "Osteoblastom",
      "Osteoblastom des Skeletts",
      "Osteochondrom",
      "Osteofibrom",
      "Osteofibröse Dysplasie",
      "Osteoidosteom",
      "Osteokartilaginäre Exostose",
      "Osteom",
      "Osteoma osteoideum",
      "Periostales Chondrom",
      "Periostales Fibrom",
      "Zementbildendes Fibrom",
      "Zementfibrom"
    ]
  },
  {
    "code": "D17.0",
    "name": "Gaumenlipom",
    "synonyms": [
      "Augenlidlipom",
      "Gaumenlipom",
      "Gesichtslipom",
      "Halslipom",
      "Kopflipom",
      "Lidlipom",
      "Pharynxlipom",
      "Rachenlipom"
    ]
  },
  {
    "code": "D17.1",
    "name": "Mammalipom",
    "synonyms": [
      "Bauchdeckenlipom",
      "Brustlipom",
      "Familiäre Angiolipomatose des Rumpfes",
      "Lipoblastom des Rumpfes",
      "Mammalipom",
      "Rumpflipom"
    ]
  },
  {
    "code": "D17.2",
    "name": "Extremitätenlipom",
    "synonyms": [
      "Extremitätenlipom",
      "Familiäre Angiolipomatose der Extremitäten",
      "Lipoblastom der Extremitäten"
    ]
  },
  {
    "code": "D17.3",
    "name": "Lipom des Bindegewebes a.n.k.",
    "synonyms": [
      "Lipom der Haut a.n.k.",
      "Lipom der Unterhaut a.n.k.",
      "Lipom des Bindegewebes a.n.k."
    ]
  },
  {
    "code": "D17.4",
    "name": "Ösophaguslipom",
    "synonyms": [
      "Intrathorakales Lipom",
      "Lipothymom",
      "Thymolipom",
      "Thymuslipom",
      "Ösophaguslipom"
    ]
  },
  {
    "code": "D17.5",
    "name": "Magenlipom",
    "synonyms": [
      "Intraabdominales Lipom",
      "Magenlipom",
      "Nebennierenlipom"
    ]
  },
  {
    "code": "D17.6",
    "name": "Gutartige Neubildung des Samenstrangfettgewebes",
    "synonyms": [
      "Gutartige Neubildung des Samenstrangfettgewebes",
      "Samenstranglipom"
    ]
  },
  {
    "code": "D17.7",
    "name": "Hypophysenlipom",
    "synonyms": [
      "Angiomyolipom der Niere",
      "Gutartige Neubildung des Fettgewebes des Peritoneums",
      "Gutartige Neubildung des Fettgewebes des Retroperitoneums",
      "Hypophysenlipom",
      "Lipoblastom des Retroperitoneums",
      "Lipom des Peritoneums",
      "Lipom des Retroperitoneums",
      "Lipoma arborscens",
      "Lipomatosis renalis",
      "Nephritis lipomatosa",
      "Nierenangiolipom",
      "Nierenbeckenfibrolipom",
      "Nierenbeckenfibrolipomatose",
      "Nierenfibrolipom",
      "Nierenlipom",
      "Nierenlipomatose",
      "Nierenpollipom",
      "Nierenrindenlipom",
      "Schilddrüsenlipom",
      "Sinuslipomatose der Niere",
      "Tonsillenlipom"
    ]
  },
  {
    "code": "D17.9",
    "name": "Fibromyxolipom",
    "synonyms": [
      "Angiolipom",
      "Angiolipomyom",
      "Angiomyolipom",
      "Dermatocele lipomatosa",
      "Familiäre Angiolipomatose",
      "Familiäre Angiolipomatosis",
      "Fetale Lipomatose",
      "Fetales Fettzellenlipom",
      "Fetales Lipom",
      "Fett-Tumor",
      "Fettgeschwulst",
      "Fettgewebsgeschwulst",
      "Fettgewebstumor",
      "Fettzellenlipom",
      "Fibrolipom",
      "Fibroma molle",
      "Fibroma pendulans",
      "Fibromyxolipom",
      "Gutartige Neubildung des Fettgewebes",
      "Hibernom",
      "Hämangioleiomyolipom",
      "Hämangiolipom",
      "Infiltrierendes Lipom",
      "Intramuskuläres Lipom",
      "Invasives Angiolipom",
      "Invasives Lipom",
      "Lipoangioleiomyom",
      "Lipoangiom",
      "Lipoblastom",
      "Lipofibrom",
      "Lipom",
      "Lipoma",
      "Lipomyom",
      "Myelolipom",
      "Myolipom",
      "Myxolipom",
      "Neurofibrolipom",
      "Pleomorphes Lipom",
      "Spindelzelliges Lipom",
      "Weiches Fibrom"
    ]
  },
  {
    "code": "D18.00",
    "name": "Angiomyoneurom",
    "synonyms": [
      "Adergeschwulst",
      "Aneurysma spongiosum",
      "Angiom",
      "Angioma",
      "Angiomatöser Nävus",
      "Angiomyoneurom",
      "Arteriovenöses Hämangiom",
      "Blutgefäßgeschwulst",
      "Blutschwamm",
      "Epitheloides Hämangiom",
      "Familiäres kapilläres Hämangiom",
      "Glomangiom",
      "Glomangiomyom",
      "Glomustumor",
      "Glomuvenöse Malformation",
      "Gutartiges Angioendotheliom",
      "Gutartiges Endotheliom eines Blutgefäßes",
      "Gutartiges Hämangioendotheliom",
      "Haemangioma",
      "Haemangioma capillare",
      "Haemangioma intramusculare",
      "Haemangioma racemosum",
      "Haemangioma simplex",
      "Haemangioma venosum",
      "Histiozytoides Hämangiom",
      "Hämangiom",
      "Hämangiom-Throbozytopenie-Syndrom",
      "Hämangiomatose, eine Lokalisation betreffend",
      "Hämangiomatöses Nävus",
      "Infantiles Hämangiom",
      "Infantiles Riesenhämangiom",
      "Juveniles Hämangiom",
      "Kapillarhämangiom",
      "Kapillärer Nävus",
      "Kapilläres Hämangiom",
      "Kasabach-Merritt-Syndrom",
      "Kavernöser Nävus",
      "Kavernöses Hämangiom",
      "Knäueltumor",
      "Kongenitales Hämangiom mit guter Spontanrückbildung",
      "Masson-Tumor",
      "NICH [Nicht involutierendes kongenitales Hämangiom]",
      "Nicht involutierendes kongenitales Hämangiom",
      "PICH [Partiell involutierendes kongenitales Hämangiom]",
      "Partiell involutierendes kongenitales Hämangiom",
      "Plexiformes Angiom",
      "Plexiformes Hämangiom",
      "RICH [Schnell involutierendes kongenitales Hämangiom]",
      "Rankenangiom",
      "Schnell involutierendes kongenitales Hämangiom",
      "Spindelzellhämangiom",
      "Verruköses Hämangiom",
      "Verruköses keratotisches Hämangiom",
      "Zusammengesetztes Hämangioendotheliom"
    ]
  },
  {
    "code": "D18.01",
    "name": "Kavernom",
    "synonyms": [
      "Angiokeratoma corporis circumscriptum",
      "Augenlidhämangiom",
      "Barré-Masson-Syndrom",
      "Büschelartiges Angiom",
      "Cavernoma capillare",
      "Haemangioma cavernosum",
      "Haemangioma simplex cavernosum",
      "Hämangiom der Haut",
      "Kavernom",
      "Lidhämangiom",
      "Nakagawa-Angioblastom"
    ]
  },
  {
    "code": "D18.02",
    "name": "Hämangiom des Gehirns",
    "synonyms": [
      "Angiom der Hirnbasisarterie",
      "Angiom mit intrazerebraler Blutung",
      "Hämangiom des Gehirns",
      "Stirnlappenhämangiom"
    ]
  },
  {
    "code": "D18.03",
    "name": "Leberhämangiom",
    "synonyms": [
      "Leberhämangiom"
    ]
  },
  {
    "code": "D18.05",
    "name": "Larynxhämangiom",
    "synonyms": [
      "Hämangiom der Nase",
      "Larynxhämangiom",
      "Ohrhämangiom",
      "Uveaangiom"
    ]
  },
  {
    "code": "D18.06",
    "name": "Aderhauthämangiom",
    "synonyms": [
      "Aderhauthämangiom",
      "Bindehautangiom",
      "Bindehauthämangiom",
      "Hämangiom der Retina",
      "Kapilläres Netzhauthämangiom",
      "Kapilläres Orbitahämangiom",
      "Kapilläres Retinahämangiom",
      "Kavernöses Netzhauthämangiom",
      "Kavernöses Orbitahämangiom",
      "Kavernöses Retinahämangiom",
      "Konjunktivaangiom",
      "Konjunktivahämangiom",
      "Netzhauthämangiom"
    ]
  },
  {
    "code": "D18.07",
    "name": "Hämangiom der knöchernen Wirbelsäule",
    "synonyms": [
      "Hämangiom der knöchernen Wirbelsäule",
      "Wirbelkörperhämangiom"
    ]
  },
  {
    "code": "D18.08",
    "name": "Generalisierte Skeletthämangiose",
    "synonyms": [
      "Angiom des Bauchraums",
      "Generalisierte Skeletthämangiose",
      "Gutartiges Angioendotheliom des Nervensystems",
      "Gutartiges Hämangioendotheliom des Nervensystems",
      "Hereditäres neurokutanes Angiom",
      "Hämangiom der Blase",
      "Hämangiom der Harnblase",
      "Intraossäres Hämangiom",
      "Laryngotracheales Angiom",
      "Nervenhämangiom",
      "Nierenangiom",
      "Nierenhämangiom",
      "Ossäre venöse Malformation",
      "Primäre intraossäre vaskuläre Fehlbildung"
    ]
  },
  {
    "code": "D18.10",
    "name": "Hygroma colli cysticum",
    "synonyms": [
      "Angeborenes Hygrom",
      "Hygroma colli cysticum",
      "Zystisches Hygrom"
    ]
  },
  {
    "code": "D18.11",
    "name": "Lymphangiom der Axilla",
    "synonyms": [
      "Lymphangiom der Axilla"
    ]
  },
  {
    "code": "D18.12",
    "name": "Inguinales Lymphangiom",
    "synonyms": [
      "Inguinales Lymphangiom"
    ]
  },
  {
    "code": "D18.13",
    "name": "Retroperitoneales Lymphangiom",
    "synonyms": [
      "Retroperitoneales Lymphangiom"
    ]
  },
  {
    "code": "D18.18",
    "name": "Orbitalymphangiom",
    "synonyms": [
      "Augenlidlymphangiom",
      "Lidlymphangiom",
      "Magenlymphangiom",
      "Mesenteriales Lymphangiom",
      "Mundhöhlenlymphangiom",
      "Nebennierenlymphangiom",
      "Orbitalymphangiom",
      "Primäres laryngeales Lymphangiom",
      "Speicheldrüsenlymphangiom",
      "Thymuslymphangiom",
      "Tonsillenlymphangiom"
    ]
  },
  {
    "code": "D18.19",
    "name": "Lymphangiomyom",
    "synonyms": [
      "Diffuse Lymphangiomatose",
      "Diffuse Lymphangiome",
      "Disseminierte Lymphangiomatose",
      "Disseminierte Lymphangiome",
      "Gemischt zystisches Lymphangiom",
      "Gutartiger Lymphgefäßtumor",
      "Hautlymphangiom",
      "Hämolymphangiom",
      "Infiltrierende mikrozystische lymphatische Malformation",
      "Kapilliäre lymphatische Fehlbildung",
      "Kapilläres Lymphangiom",
      "Kavernöse lymphatische Fehlbildung",
      "Kavernöses Lymphangiom",
      "Kutanes zirkumskriptes Lymphangiom",
      "Lymphangioendotheliom",
      "Lymphangioendothelioma",
      "Lymphangiom",
      "Lymphangioma",
      "Lymphangioma capillare",
      "Lymphangioma cavernosum",
      "Lymphangioma cysticum",
      "Lymphangiomatöse Zyste",
      "Lymphangiomyom",
      "Lymphatische Malformation",
      "Lymphatischer Nävus",
      "Lymphgefäßgeschwulst",
      "Lymphgefäßtumor",
      "Lymphoendotheliom",
      "Makrozystische lymphatische Malformation",
      "Makrozystisches Lymphangiom",
      "Mikrozystische lymphatische Malformation",
      "Mikrozystisches Lymphangiom",
      "Superfizielles Lymphangiom",
      "Zirkumskriptes Lymphangiom",
      "Zystisches Lymphangiom"
    ]
  },
  {
    "code": "D19.0",
    "name": "Benignes Pleuramesotheliom",
    "synonyms": [
      "Benignes Pleuramesotheliom",
      "Benignes biphasisches Pleuramesotheliom",
      "Benignes epitheloidzelliges Pleuramesotheliom",
      "Benignes fibröses Pleuramesotheliom"
    ]
  },
  {
    "code": "D19.1",
    "name": "Benignes Mesotheliom des Peritoneums",
    "synonyms": [
      "Benignes Mesotheliom des Mesokolons",
      "Benignes Mesotheliom des Omentums",
      "Benignes Mesotheliom des Peritoneums",
      "Benignes biphasisches Mesotheliom des Mesokolons",
      "Benignes biphasisches Mesotheliom des Omentums",
      "Benignes biphasisches Mesotheliom des Peritoneums",
      "Benignes biphasisches mesenteriales Mesotheliom",
      "Benignes epitheloidzelliges Mesotheliom des Mesokolons",
      "Benignes epitheloidzelliges Mesotheliom des Omentums",
      "Benignes epitheloidzelliges Mesotheliom des Peritoneums",
      "Benignes epitheloidzelliges mesenteriales Mesotheliom",
      "Benignes fibröses Mesotheliom des Mesokolons",
      "Benignes fibröses Mesotheliom des Omentums",
      "Benignes fibröses Mesotheliom des Peritoneums",
      "Benignes fibröses mesenteriales Mesotheliom",
      "Benignes mesenteriales Mesotheliom",
      "Mulitzystisches benignes peritoneales Mesotheliom"
    ]
  },
  {
    "code": "D19.9",
    "name": "Adenomatoidtumor",
    "synonyms": [
      "Adenomatoidtumor",
      "Gutartiges Mesotheliom",
      "Mesothelioma benigne"
    ]
  },
  {
    "code": "D20.0",
    "name": "Gutartige Neubildung des retroperitonealen Bindegewebes a.n.k.",
    "synonyms": [
      "Gutartige Neubildung des Retroperitoneums",
      "Gutartige Neubildung des retroperitonealen Bindegewebes a.n.k.",
      "Paranephritische gutartige Neubildung",
      "Periadrenale gutartige Neubildung",
      "Perinephrische gutartige Neubildung",
      "Peripankreatische gutartige Neubildung",
      "Perirenale gutartige Neubildung",
      "Retroperitoneale gutartige Neubildung",
      "Retrozäkale gutartige Neubildung"
    ]
  },
  {
    "code": "D20.1",
    "name": "Peritonealmyxom",
    "synonyms": [
      "Disseminierte peritoneale Leiomyomatose",
      "Gutartige Neubildung der Mesoappendix",
      "Gutartige Neubildung der Peritonealhöhle",
      "Gutartige Neubildung der rektouterinen Tasche",
      "Gutartige Neubildung des Beckenperitoneums",
      "Gutartige Neubildung des Douglas-Raums",
      "Gutartige Neubildung des Mesenteriums",
      "Gutartige Neubildung des Mesokolons",
      "Gutartige Neubildung des Omentums",
      "Gutartige Neubildung des Peritoneums",
      "Gutartige Neubildung des parietalen Peritoneums",
      "Peritonealmyxom"
    ]
  },
  {
    "code": "D21.0",
    "name": "Halsfibrom",
    "synonyms": [
      "Augenlidfibrom",
      "Basalfibrom",
      "Fibrom der Schädelbasis",
      "Fibromyom der Nase",
      "Gutartige Neubildung der Arteria carotis",
      "Gutartige Neubildung der Fossa pterygoidea a.n.k.",
      "Gutartige Neubildung der Weichteile des Gesichts",
      "Gutartige Neubildung der Weichteile des Halses",
      "Gutartige Neubildung der Weichteile des Kopfes",
      "Gutartige Neubildung des Augenbindegewebes",
      "Gutartige Neubildung des Augenlidknorpels",
      "Gutartige Neubildung des Auriculaknorpels",
      "Gutartige Neubildung des Bindegewebes der Auricula a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Fossa pterygoidea a.n.k.",
      "Gutartige Neubildung des Bindegewebes des Gesichts",
      "Gutartige Neubildung des Bindegewebes des Halses",
      "Gutartige Neubildung des Bindegewebes des Kopfes",
      "Gutartige Neubildung des Kinnbindegewebes a.n.k.",
      "Gutartige Neubildung des Kopfbindegewebes a.n.k.",
      "Gutartige Neubildung des Kopfschwartenbindegewebes a.n.k.",
      "Gutartige Neubildung des Ohrbindegewebes",
      "Gutartige Neubildung des Ohrknorpels",
      "Gutartige Neubildung des Ohrmuschelknorpels",
      "Gutartige Neubildung des Schläfenbindegewebes a.n.k.",
      "Gutartige Neubildung des Stirnbindegewebes a.n.k.",
      "Gutartige Neubildung des Wangenbindegewebes a.n.k.",
      "Gutartige Neubildung des submentalen Bindegewebes a.n.k.",
      "Halsfibrom",
      "Kimura-Krankheit der Weichteile des Halses",
      "Kimura-Krankheit der Weichteile des Kopfes",
      "Liddermoid",
      "Lidfibrom",
      "Nasenfibrom",
      "Zervikofaziales Fibrochondrom",
      "Zungenfibrom"
    ]
  },
  {
    "code": "D21.1",
    "name": "Gutartige Neubildung der Aponeurosis palmaris",
    "synonyms": [
      "Gutartige Neubildung der Aponeurosis palmaris",
      "Gutartige Neubildung der Palmarfaszie",
      "Gutartige Neubildung des Armbindegewebes a.n.k.",
      "Gutartige Neubildung des Bindegewebes der oberen Extremität a.n.k.",
      "Gutartige Neubildung des Bindegewebes der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung des Daumenbindegewebes a.n.k.",
      "Gutartige Neubildung des Ellenbeugenbindegewebes a.n.k.",
      "Gutartige Neubildung des Ellenbogenbindegewebes a.n.k.",
      "Gutartige Neubildung des Fingerbindegewebes a.n.k.",
      "Gutartige Neubildung des Handbindegewebes a.n.k.",
      "Gutartige Neubildung des Handgelenkbindegewebes a.n.k.",
      "Gutartige Neubildung des Schulterbindegewebes a.n.k.",
      "Gutartige Neubildung des Unterarmbindegewebes a.n.k.",
      "Onychomatrikom der Fingernägel"
    ]
  },
  {
    "code": "D21.2",
    "name": "Gutartige Neubildung der Aponeurosis plantaris",
    "synonyms": [
      "Gutartige Neubildung der Aponeurosis plantaris",
      "Gutartige Neubildung der Plantarfaszie",
      "Gutartige Neubildung des Beinbindegewebes a.n.k.",
      "Gutartige Neubildung des Bindegewebes der unteren Extremität a.n.k.",
      "Gutartige Neubildung des Bindegewebes der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung des Fersenbindegewebes a.n.k.",
      "Gutartige Neubildung des Fußbindegewebes a.n.k.",
      "Gutartige Neubildung des Hüftbindegewebes a.n.k.",
      "Gutartige Neubildung des Kniebindegewebes a.n.k.",
      "Gutartige Neubildung des Kniekehlenbindegewebes a.n.k.",
      "Gutartige Neubildung des Knöchelbindegewebes a.n.k.",
      "Gutartige Neubildung des Oberschenkelbindegewebes a.n.k.",
      "Gutartige Neubildung des Wadenbindegewebes a.n.k.",
      "Gutartige Neubildung des Zehenbindegewebes a.n.k.",
      "Onychomatrikom der Zehennägel"
    ]
  },
  {
    "code": "D21.3",
    "name": "Pleurafibrom",
    "synonyms": [
      "Gutartige Neubildung der Aorta",
      "Gutartige Neubildung der Aorta thoracica",
      "Gutartige Neubildung der Vena cava superior",
      "Gutartige Neubildung der Weichteile des Thorax",
      "Gutartige Neubildung des Achselhöhlenbindegewebes",
      "Gutartige Neubildung des Axillabindegewebes",
      "Gutartige Neubildung des Bindegewebes der Infraklavikulargegend a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Schulterblattgegend a.n.k.",
      "Gutartige Neubildung des Bindegewebes der großen Gefäße a.n.k.",
      "Gutartige Neubildung des Bindegewebes des Ductus thoracicus a.n.k.",
      "Gutartige Neubildung des Bindegewebes des Thorax",
      "Gutartige Neubildung des Brustwandbindegewebes a.n.k.",
      "Gutartige Neubildung des Diaphragmabindegewebes a.n.k.",
      "Gutartige Neubildung des Diaphragmas",
      "Gutartige Neubildung des Ductus thoracicus",
      "Gutartige Neubildung des Zwerchfellbindegewebes a.n.k.",
      "Gutartige Neubildung des Zwerchfells",
      "Gutartige Neubildung des intrathorakalen Bindegewebes a.n.k.",
      "Gutartige Neubildung eines großen Gefäßes",
      "Gutartige Neubildung eines großen Gefäßes des Thorax",
      "Pleurafibrom"
    ]
  },
  {
    "code": "D21.4",
    "name": "Nierenfibrom",
    "synonyms": [
      "Gutartige Neubildung der Vena cava inferior",
      "Gutartige Neubildung der Weichteile des Abdomens",
      "Gutartige Neubildung des Bauchwandbindegewebes",
      "Gutartige Neubildung des Bindegewebes des Abdomens",
      "Gutartige Neubildung des Bindegewebes des Iliopsoasmuskels a.n.k.",
      "Gutartige Neubildung des Bindegewebes des Psoasmuskels a.n.k.",
      "Gutartige Neubildung des Nabelbindegewebes",
      "Nierenfibrom",
      "Nierenkapselfibrom",
      "Nierenneurinom",
      "Nierenrindenfibrom"
    ]
  },
  {
    "code": "D21.5",
    "name": "Analfibrom",
    "synonyms": [
      "Analfibrom",
      "Fibrom des Anus",
      "Gutartige Neubildung der Weichteile des Beckens",
      "Gutartige Neubildung des Beckenbindegewebes a.n.k.",
      "Gutartige Neubildung des Beckenbodenbindegewebes a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Fossa ischiorectalis a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Glutäalmuskulatur a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Kreuzbeingegend und Steißbeingegend a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Leistenkanalgegend a.n.k.",
      "Gutartige Neubildung des Bindegewebes des Beckens",
      "Gutartige Neubildung des Bindegewebes des Septum rectovaginale a.n.k.",
      "Gutartige Neubildung des Gesäßbindegewebes a.n.k.",
      "Gutartige Neubildung des Glomus coccygeum",
      "Gutartige Neubildung des Perineumbindegewebes a.n.k.",
      "Gutartige Neubildung des extrarektalen Bindegewebes a.n.k.",
      "Gutartige Neubildung des inguinalen Bindegewebes a.n.k.",
      "Gutartige Neubildung des pararektalen Bindegewebes a.n.k.",
      "Gutartige Neubildung des paraurethralen Bindegewebes a.n.k.",
      "Gutartige Neubildung des paravaginalen Bindegewebes a.n.k.",
      "Gutartige Neubildung des perirektalen Bindegewebes a.n.k.",
      "Gutartige Neubildung des periurethralen Bindegewebes a.n.k.",
      "Gutartige Neubildung des präsakralen Bindegewebes a.n.k.",
      "Gutartige Neubildung des rektovesikalen Bindegewebes a.n.k.",
      "Gutartige Neubildung des vesikorektalen Bindegewebes a.n.k."
    ]
  },
  {
    "code": "D21.6",
    "name": "Gutartige Neubildung der Weichteile des Rumpfes",
    "synonyms": [
      "Elastofibroma dorsi",
      "Gutartige Neubildung der Weichteile des Rumpfes",
      "Gutartige Neubildung des Bindegewebes des Rumpfes",
      "Gutartige Neubildung des Bindegewebes des Rückens",
      "Gutartige Neubildung des Extremitätenbindegewebes a.n.k."
    ]
  },
  {
    "code": "D21.9",
    "name": "Gutartige Neubildung einer Bursa",
    "synonyms": [
      "Abrikossoff-Geschwulst",
      "Abrikossoff-Tumor",
      "Adultes Rhabdomyom",
      "Angioleiomyom",
      "Angiomyom",
      "Bizarres Leiomyom",
      "Blutgefäßreiches Leiomyom",
      "Elastofibrom",
      "Epitheloides Leiomyom",
      "Fasziales Fibrom",
      "Fetales Rhabdomyom",
      "Fibroepithelialer Tumor",
      "Fibroepitheliom",
      "Fibroid - s.a. Neubildung, Bindegewebe, gutartig",
      "Fibroider Tumor",
      "Fibroleiomyom",
      "Fibrom",
      "Fibroma durum",
      "Fibroma mucinosum",
      "Fibroma myxomatodes",
      "Fibroma simplex Unna",
      "Fibromyom",
      "Fibromyxom",
      "Fibroxanthom",
      "Fibröser Tumor - s.a. Neubildung, Bindegewebe, gutartig",
      "Fleischgeschwulst",
      "Glykogenes Rhabdomyom",
      "Granularzelliger Tumor",
      "Granularzellmyoblastom",
      "Gutartige Neubildung der Faszien",
      "Gutartige Neubildung der Ligamente",
      "Gutartige Neubildung der Lymphbahnen a.n.k.",
      "Gutartige Neubildung der Muskeln",
      "Gutartige Neubildung der Sehnen",
      "Gutartige Neubildung der Sehnenscheiden",
      "Gutartige Neubildung der Synovialis",
      "Gutartige Neubildung der Synovialmembran",
      "Gutartige Neubildung der Weichteile",
      "Gutartige Neubildung des Bindegewebes a.n.k.",
      "Gutartige Neubildung des Bindegewebes der Gliedmaßen a.n.k.",
      "Gutartige Neubildung des Sphincter ani",
      "Gutartige Neubildung des abdominopelvinen Bindegewebes a.n.k.",
      "Gutartige Neubildung einer Bursa",
      "Gutartige Neubildung eines Bandes",
      "Gutartige Neubildung eines Blutgefäßes",
      "Gutartige Neubildung eines Lymphgefäßes",
      "Gutartiges Hämangioperizytom",
      "Gutartiges Mesenchymom",
      "Gutartiges Synovialom",
      "Haemangiopericytoma benigna",
      "Hartes Fibrom",
      "Kimura-Krankheit",
      "Leiofibromyom",
      "Leiomyoblastom",
      "Leiomyofibrom",
      "Leiomyolipom",
      "Leiomyom",
      "Leiomyoma cavernosum",
      "Leiomyoma cellulare",
      "Leiomyoma teleangiectaticum",
      "Lipoleiomyom",
      "Mesenchymoma benignum",
      "Muskelgeschwulst",
      "Myoblastenmyom",
      "Myoblastom",
      "Myofibrom",
      "Myom",
      "Myoma laevicellulare",
      "Myomatose",
      "Myomknoten",
      "Myoperizytom",
      "Myxoblastom",
      "Myxofibrom",
      "Myxoides Fibrom",
      "Myxom",
      "Reizfibrom",
      "Rhabdomyoblastom",
      "Rhabdomyom",
      "Solitärer fibröser Tumor",
      "Vaskuläres Leiomyom",
      "Xanthofibrom",
      "Zelluläres Leiomyom"
    ]
  },
  {
    "code": "D22.0",
    "name": "Melanozytennävus der Lippe",
    "synonyms": [
      "Melanozytennävus der Lippe",
      "Nävus der Lippe"
    ]
  },
  {
    "code": "D22.1",
    "name": "Lidnävus",
    "synonyms": [
      "Augenlidnävus",
      "Lidnävus",
      "Melanozytennävus der Augenlidhaut",
      "Nävus der Palpebra",
      "Nävus des Kanthus",
      "Ota-Nävus der Augenlidhaut"
    ]
  },
  {
    "code": "D22.2",
    "name": "Nävus des Ohres",
    "synonyms": [
      "Nävus der Ohrhelix",
      "Nävus der Pinna",
      "Nävus des Ohres",
      "Nävus des äußeren Gehörganges"
    ]
  },
  {
    "code": "D22.3",
    "name": "Nävus des Gesichts",
    "synonyms": [
      "Fibröse Papeln der Nase",
      "Nävus Ota",
      "Nävus der Augenbraue",
      "Nävus der Nase",
      "Nävus der Nasolabialfalte",
      "Nävus der Schläfe",
      "Nävus der Stirn",
      "Nävus der Wange",
      "Nävus des Ala nasi",
      "Nävus des Gesichts",
      "Nävus des Kiefers",
      "Nävus des Kinns",
      "Ota-Nävus der Gesichtshaut (ohne Auge)"
    ]
  },
  {
    "code": "D22.4",
    "name": "Nävus des Halses",
    "synonyms": [
      "Nävus der Kopfhaut",
      "Nävus des Halses"
    ]
  },
  {
    "code": "D22.5",
    "name": "Melanozytennävus des Rumpfes",
    "synonyms": [
      "Melanozytennävus der Analhaut",
      "Melanozytennävus der Brustdrüsenhaut",
      "Melanozytennävus der Mammahaut",
      "Melanozytennävus der Perianalhaut",
      "Melanozytennävus des Analrandes",
      "Melanozytennävus des Rumpfes",
      "Nävus der Achselfalte",
      "Nävus der Achselhöhle",
      "Nävus der Axilla",
      "Nävus der Bauchwand",
      "Nävus der Brust",
      "Nävus der Brustdrüsenhaut",
      "Nävus der Brustwand",
      "Nävus der Flanke",
      "Nävus der Interskapularregion",
      "Nävus der Leistenbeuge",
      "Nävus der Mammahaut",
      "Nävus der Schamhaarregion",
      "Nävus der Submammärfalte",
      "Nävus des Anus",
      "Nävus des Dammes",
      "Nävus des Gesäßes",
      "Nävus des Nabels",
      "Nävus des Perineums",
      "Nävus des Rumpfes",
      "Nävus des Rückens",
      "Nävus im Bereich einer Rippe",
      "Perianaler Nävus",
      "Pigmentierter Becker-Haarnävus"
    ]
  },
  {
    "code": "D22.6",
    "name": "Nävus des Arms",
    "synonyms": [
      "Nävus Ito",
      "Nävus der Hand",
      "Nävus der Schulter",
      "Nävus des Arms",
      "Nävus des Unterarms",
      "Nävus eines Fingernagels",
      "Nävus eines Fingers"
    ]
  },
  {
    "code": "D22.7",
    "name": "Nävus des Beins",
    "synonyms": [
      "Nävus der Ferse",
      "Nävus der Hüfte",
      "Nävus der Kniekehle",
      "Nävus der unteren Extremität a.n.k.",
      "Nävus des Beins",
      "Nävus des Fußes",
      "Nävus des Knies",
      "Nävus des Knöchels",
      "Nävus des Schenkels",
      "Nävus einer Zehe",
      "Nävus eines Zehennagels"
    ]
  },
  {
    "code": "D22.9",
    "name": "Epidermaler Nävus",
    "synonyms": [
      "Achromatischer Nävus",
      "Amelanotischer Nävus",
      "Angeborener melanozytärer Riesennävus",
      "Atypische Melanozytenhyperplasie",
      "BK-Mole-Krankheit",
      "Ballonzell-Nävus",
      "Benignes Melanom",
      "Blasenzellnävus",
      "Blauer Jadassohn-Nävus",
      "Blauer Nävus",
      "Compound-Nävus",
      "Dermaler Nävus",
      "Dyskeratotischer Nävus",
      "Dysplastischer Nävus",
      "Dysplastisches Nävuszellnävussyndrom",
      "Epidermaler Nävus",
      "Epidermo-dermaler Nävus",
      "Epidermokutaner Grenzflächennävus",
      "Epidermokutaner Übergangsnävus",
      "Epitheloidzelliger Nävus",
      "Fibromatöser Nävuszellnävus",
      "Großzelliger Nävus",
      "Halo-Nävus",
      "Intradermaler Nävus",
      "Intraepidermaler Nävus",
      "Involutions-Nävus",
      "Junktionaler Nävus",
      "Junktionsnävus",
      "Juveniler Nävus",
      "Juveniles Melanom",
      "Kombinationsnävus",
      "Komplexer Nävus",
      "Macula matricis",
      "Maulbeernävus",
      "Melanotischer Nävus",
      "Melanozytennävus",
      "Naevus - s.a. Nävus",
      "Naevus achromicus",
      "Naevus albus",
      "Naevus apigmentosus",
      "Naevus coeruleus",
      "Naevus depigmentosus",
      "Naevus magnocellulare",
      "Naevus naevocellularis",
      "Naevus papillaris",
      "Naevus pigmentosus",
      "Naevus pilosus",
      "Neurokutane Melanozytose",
      "Neuronävus",
      "Nichtpigmentierter Nävus",
      "Nichtvaskulärer Nävus",
      "Nävi - s.a. Naevus oder s.a. Nävus",
      "Nävozelluläre Nävusentzündung",
      "Nävus - s.a. Naevus",
      "Nävus der Haut",
      "Nävus eines Nagels",
      "Nävusdysplasiesyndrom",
      "Nävuszellnävus",
      "Nävuszellnävus mit Entzündungsreaktion",
      "Nävuszellnävusdysplasie",
      "Papillomatöser Nävus",
      "Pigmentierter Naevus pilosus",
      "Pigmentierter Nävus",
      "Pigmentmal",
      "Pigmentnävus",
      "Pigmentnävus und Papillom",
      "Pigmentzellnävus",
      "Regressiver Nävus",
      "Spindelzelliger Nävus",
      "Spitz-Nävus",
      "Sutton-Nävus",
      "Tierfellnävus"
    ]
  },
  {
    "code": "D23.0",
    "name": "Gutartige Neubildung der Lippenhaut",
    "synonyms": [
      "Gutartige Neubildung der Lippenhaut",
      "Nichtmelanomartige gutartige Neubildung der Lippenhaut"
    ]
  },
  {
    "code": "D23.1",
    "name": "Gutartige Neubildung der Lidwinkelhaut",
    "synonyms": [
      "Augenlidsyringom",
      "Benigner Lidhauttumor",
      "Benigner Lidtumor",
      "Gutartige Neubildung der Augenlidhaut",
      "Gutartige Neubildung der Lidwinkelhaut",
      "Gutartige Neubildung der Meibom-Drüsen",
      "Gutartige Neubildung des Augenlids",
      "Gutartige Neubildung des Augenwinkels",
      "Gutartige Neubildung des Lids",
      "Lidpapillom",
      "Lidsyringom",
      "Nichtmelanomartige gutartige Neubildung der Augenlidhaut",
      "Nichtmelanomartige gutartige Neubildung der Augenwinkelhaut",
      "Nichtmelanomartige gutartige Neubildung der Lidhaut",
      "Nichtmelanomartige gutartige Neubildung der Palpebralhaut"
    ]
  },
  {
    "code": "D23.2",
    "name": "Gutartige Neubildung der Haut des Ohres",
    "synonyms": [
      "Adenoma ceruminosum",
      "Gutartige Neubildung der Auricula",
      "Gutartige Neubildung der Haut der Ohrmuschel",
      "Gutartige Neubildung der Haut des Ohres",
      "Gutartige Neubildung der Haut des äußeren Gehörganges",
      "Gutartige Neubildung der Helix",
      "Gutartige Neubildung der Ohrhaut",
      "Gutartige Neubildung der Ohrmuschel",
      "Gutartige Neubildung des Gehörganges",
      "Gutartige Neubildung des Meatus acusticus externus",
      "Gutartige Neubildung des Ohrkanals",
      "Gutartige Neubildung des Ohrläppchens",
      "Gutartige Neubildung des Tragus",
      "Nichtmelanomartige gutartige Neubildung der Haut der Ohrhelix",
      "Nichtmelanomartige gutartige Neubildung der Haut des Gehörganges",
      "Nichtmelanomartige gutartige Neubildung der Haut des Tragus",
      "Nichtmelanomartige gutartige Neubildung der Ohrhaut",
      "Zeruminöses Adenom"
    ]
  },
  {
    "code": "D23.3",
    "name": "Basalzellakanthom des Gesichts",
    "synonyms": [
      "Basalzellakanthom des Gesichts",
      "Gutartige Neubildung der Augenbraue",
      "Gutartige Neubildung der Columella nasi",
      "Gutartige Neubildung der Kieferhaut",
      "Gutartige Neubildung der Nasenhaut",
      "Gutartige Neubildung der Nasolabialfalte",
      "Gutartige Neubildung der Schläfe",
      "Gutartige Neubildung der Stirn",
      "Gutartige Neubildung der Wangenaußenseite",
      "Gutartige Neubildung der äußeren Nase",
      "Gutartige Neubildung des Ala nasi externa",
      "Gutartige Neubildung des Kinns",
      "Gutartige Neubildung des Nasenflügels",
      "Nichtmelanomartige gutartige Neubildung der Augenbrauenhaut",
      "Nichtmelanomartige gutartige Neubildung der Gesichtshaut a.n.k.",
      "Nichtmelanomartige gutartige Neubildung der Haut der Columella nasi",
      "Nichtmelanomartige gutartige Neubildung der Kieferhaut",
      "Nichtmelanomartige gutartige Neubildung der Kinnhaut",
      "Nichtmelanomartige gutartige Neubildung der Nasenflügelhaut",
      "Nichtmelanomartige gutartige Neubildung der Nasenhaut",
      "Nichtmelanomartige gutartige Neubildung der Schläfenhaut",
      "Nichtmelanomartige gutartige Neubildung der Stirnhaut",
      "Nichtmelanomartige gutartige Neubildung der Wangenhaut",
      "Pilomatrixom des Gesichts"
    ]
  },
  {
    "code": "D23.4",
    "name": "Turbantumor",
    "synonyms": [
      "Gutartige Neubildung der Haut des Halses",
      "Gutartige Neubildung der Kopfschwarte",
      "Nichtmelanomartige gutartige Neubildung der Haut der Halsgegend",
      "Nichtmelanomartige gutartige Neubildung der Haut der Kopfschwarte",
      "Nichtmelanomartige gutartige Neubildung der Haut der Nackengegend",
      "Nichtmelanomartige gutartige Neubildung der Haut der Supraklavikulargrube",
      "Nichtmelanomartige gutartige Neubildung der Kopfhaut a.n.k.",
      "Pilomatrixom der Haut des Halses",
      "Turbantumor"
    ]
  },
  {
    "code": "D23.5",
    "name": "Nabeladenom",
    "synonyms": [
      "Gutartige Neubildung der Analhaut",
      "Gutartige Neubildung der Bauchwand",
      "Gutartige Neubildung der Brustdrüsenhaut",
      "Gutartige Neubildung der Hautfalte der Achselhöhle",
      "Gutartige Neubildung der Mammahaut",
      "Gutartige Neubildung der Perianalhaut",
      "Gutartige Neubildung der Thoraxhaut",
      "Gutartige Neubildung der Thoraxwandhaut",
      "Gutartige Neubildung des Analrandes",
      "Gutartige Neubildung des Nabels",
      "Nabeladenom",
      "Nichtmelanomartige gutartige Neubildung der Achselfaltenhaut",
      "Nichtmelanomartige gutartige Neubildung der Achselhaut",
      "Nichtmelanomartige gutartige Neubildung der Analhaut",
      "Nichtmelanomartige gutartige Neubildung der Bauchhaut",
      "Nichtmelanomartige gutartige Neubildung der Bauchwandhaut",
      "Nichtmelanomartige gutartige Neubildung der Brusthaut",
      "Nichtmelanomartige gutartige Neubildung der Brustwandhaut",
      "Nichtmelanomartige gutartige Neubildung der Flankenhaut",
      "Nichtmelanomartige gutartige Neubildung der Gesäßhaut",
      "Nichtmelanomartige gutartige Neubildung der Glutäalhaut",
      "Nichtmelanomartige gutartige Neubildung der Haut der Inguinalregion",
      "Nichtmelanomartige gutartige Neubildung der Haut der Kreuzbeingegend",
      "Nichtmelanomartige gutartige Neubildung der Haut der Leistengegend",
      "Nichtmelanomartige gutartige Neubildung der Haut der Schamgegend",
      "Nichtmelanomartige gutartige Neubildung der Haut der Skapularregion",
      "Nichtmelanomartige gutartige Neubildung der Haut der Steißbeingegend",
      "Nichtmelanomartige gutartige Neubildung der Haut der submammären Falte",
      "Nichtmelanomartige gutartige Neubildung der Haut des Klavikulargebiets",
      "Nichtmelanomartige gutartige Neubildung der Leistenbeugenhaut",
      "Nichtmelanomartige gutartige Neubildung der Nabelhaut",
      "Nichtmelanomartige gutartige Neubildung der Perianalhaut",
      "Nichtmelanomartige gutartige Neubildung der Perinealhaut",
      "Nichtmelanomartige gutartige Neubildung der Rumpfhaut",
      "Nichtmelanomartige gutartige Neubildung der Rückenhaut",
      "Nichtmelanomartige gutartige Neubildung der subklavikulären Haut",
      "Perianale gutartige Neubildung"
    ]
  },
  {
    "code": "D23.6",
    "name": "Gutartige Neubildung der Haut der oberen Gliedmaßen",
    "synonyms": [
      "Gutartige Neubildung der Haut der oberen Gliedmaßen",
      "Nichtmelanomartige gutartige Neubildung der Armhaut",
      "Nichtmelanomartige gutartige Neubildung der Daumenhaut",
      "Nichtmelanomartige gutartige Neubildung der Ellenbeugenhaut",
      "Nichtmelanomartige gutartige Neubildung der Ellenbogenhaut",
      "Nichtmelanomartige gutartige Neubildung der Fingerhaut",
      "Nichtmelanomartige gutartige Neubildung der Handflächenhaut",
      "Nichtmelanomartige gutartige Neubildung der Handhaut",
      "Nichtmelanomartige gutartige Neubildung der Schulterhaut",
      "Nichtmelanomartige gutartige Neubildung der Unterarmhaut",
      "Onychozytisches Matrikom eines Fingernagels",
      "Pilomatrixom der Haut der oberen Gliedmaßen"
    ]
  },
  {
    "code": "D23.7",
    "name": "Gutartige Neubildung der Haut der unteren Gliedmaßen",
    "synonyms": [
      "Gutartige Neubildung der Haut der unteren Gliedmaßen",
      "Nichtmelanomartige gutartige Neubildung der Beinhaut",
      "Nichtmelanomartige gutartige Neubildung der Fersenhaut",
      "Nichtmelanomartige gutartige Neubildung der Fußhaut",
      "Nichtmelanomartige gutartige Neubildung der Fußsohlenhaut",
      "Nichtmelanomartige gutartige Neubildung der Hüfthaut",
      "Nichtmelanomartige gutartige Neubildung der Kniehaut",
      "Nichtmelanomartige gutartige Neubildung der Kniekehlenhaut",
      "Nichtmelanomartige gutartige Neubildung der Knöchelhaut",
      "Nichtmelanomartige gutartige Neubildung der Oberschenkelhaut",
      "Nichtmelanomartige gutartige Neubildung der Plantarhaut",
      "Nichtmelanomartige gutartige Neubildung der Wadenhaut",
      "Nichtmelanomartige gutartige Neubildung der Zehenhaut",
      "Onychozytisches Matrikom eines Zehennagels"
    ]
  },
  {
    "code": "D23.9",
    "name": "Tricholemmom",
    "synonyms": [
      "Adenom der Hautanhangsgebilde",
      "Adenoma sudoriparum",
      "Angiokeratom",
      "Apokrines Adenom",
      "Basalzellakanthom",
      "Benigner Hauttumor",
      "Brooke-Spiegler-Syndrom",
      "Brooke-Syndrom",
      "Brooke-Tumor",
      "Chondroides Syringom",
      "Dermales ekkrines Zylindrom",
      "Dermatofibrom - s.a. Neubildung, Haut, gutartig",
      "Ekkrines Spiradenom - s.a. Neubildung, Haut, gutartig",
      "Ekkrines papilläres Adenom",
      "Epithelioma adenoides cysticum Brooke",
      "Epithelioma calcificans Malherbe",
      "Familiäres multiples Trichodiskom",
      "Fibröses Histiozytom",
      "Granuloma xantho-sidero-gigantocellulare",
      "Gutartige Hautgeschwulst",
      "Gutartige Neubildung der Haarfollikel",
      "Gutartige Neubildung der Haut",
      "Gutartige Neubildung der Schweißdrüsen",
      "Gutartige Neubildung der Talgdrüsen",
      "Gutartige Neubildung der Unterhaut",
      "Gutartiger Hauttumor",
      "Haarnävus",
      "Hautzylindrom",
      "Hidradenom - s.a. Neubildung, Haut, gutartig",
      "Hidrozystom",
      "Histiozytom",
      "Intraepidermales Epitheliom vom Typ Borst-Jadassohn",
      "Intraepidermales Jadassohn-Epitheliom",
      "Intraepitheliales Epitheliom vom Typ Borst-Jadassohn",
      "Klarzelliges Hidradenom",
      "Lentikuläres Dermatofibrom - s.a. Neubildung, Haut, gutartig",
      "MSSE [Multiple selbstheilende squamöse Epitheliome]",
      "Malherbe-Tumor",
      "Melanoakanthom",
      "Naevus sebaceus",
      "Naevus syringocystadenosus",
      "Neurofibrom der Pseudotastkörperchen",
      "Noduläres Hidradenom - s.a. Neubildung, Haut, gutartig",
      "Onychozytisches Matrikom",
      "Papilläres Hidradenom",
      "Papilläres Syringadenom",
      "Papilläres Syringozystadenom",
      "Pigmentiertes Basalzellpapillom",
      "Pilomatrixom",
      "Schweißdrüsenadenom - s.a. Neubildung, Haut, gutartig",
      "Sklerosierendes Hämangiom",
      "Spiegler-Syringadenom",
      "Spieglertumor",
      "Spiradenom - s.a. Neubildung, Haut, gutartig",
      "Subepidermale noduläre Fibrose",
      "Syringoadenom",
      "Syringom",
      "Syringozystadenom",
      "Talgdrüsenadenom",
      "Talgdrüsenepitheliom",
      "Trichoepitheliom",
      "Trichofollikulom",
      "Tricholemmom",
      "Tumor der Hautanhangsgebilde",
      "Tumor der Vater-Pacini-Lamellenkörperchen",
      "Verkalkendes Epitheliom nach Malherbe",
      "Warziges Dyskeratom",
      "Zylindromatöses Syringadenom"
    ]
  },
  {
    "code": "D24",
    "name": "Gutartige Neubildung der Brustdrüse",
    "synonyms": [
      "Adenom der Brustwarze",
      "Adenomatosis erosiva der Brustwarze",
      "Apokrines Adenom der Brustdrüse",
      "Benigner Brusttumor",
      "Cystosarcoma phylloides benignum",
      "Fibroadenom",
      "Fibroadenoma cellulare intracanaliculare",
      "Fibroma intracanaliculare",
      "Gutartige Neubildung der Areola",
      "Gutartige Neubildung der Brust",
      "Gutartige Neubildung der Brustdrüse",
      "Gutartige Neubildung der Brustwarze",
      "Gutartige Neubildung der Mamma",
      "Gutartige Neubildung der Medioklavikularlinie der Brustdrüse",
      "Gutartige Neubildung der Weichteile der Brust",
      "Gutartige Neubildung der Weichteile der Brustdrüse",
      "Gutartige Neubildung der Weichteile der Mamma",
      "Gutartige Neubildung der inneren Brustdrüse",
      "Gutartige Neubildung der oberen Brustdrüse",
      "Gutartige Neubildung der unteren Brustdrüse",
      "Gutartige Neubildung der äußeren Brustdrüse",
      "Gutartige Neubildung des Bindegewebes der Brust",
      "Gutartige Neubildung des Brustdrüsenbindegewebes",
      "Gutartige Neubildung des Mammabindegewebes",
      "Gutartige Neubildung des Recessus axillaris der Brustdrüse",
      "Gutartige Neubildung des Warzenhofes der Brustdrüse",
      "Gutartige Neubildung des axillären Ausläufers der Brustdrüse",
      "Gutartige Neubildung des oberen inneren Quadranten der Brustdrüse",
      "Gutartige Neubildung des oberen äußeren Quadranten der Brustdrüse",
      "Gutartige Neubildung des unteren inneren Quadranten der Brustdrüse",
      "Gutartige Neubildung des unteren äußeren Quadranten der Brustdrüse",
      "Gutartige Neubildung des zentralen Drüsenkörpers der Brustdrüse",
      "Gutartige Neubildung einer ektopischen Brustdrüse",
      "Gutartiger Knoten der Brust",
      "Gutartiger Mammaknoten",
      "Gutartiger Mammatumor",
      "Gutartiger phylloider Tumor",
      "Intraduktales Fibroadenom",
      "Intrakanalikuläres Fibroadenom",
      "Juveniles Fibroadenom",
      "Mammaadenom",
      "Mammafibroadenom",
      "Mammafibrom",
      "Milchgangsadenom",
      "Milchgangspapillom",
      "Multiple Fibroadenome der Brust",
      "Perikanalikuläres Fibroadenom",
      "Phylloides Fibroadenom",
      "Riesenfibroadenom",
      "Riesenfibroadenom der Brust",
      "Riesenzelliges intrakanalikuläres Fibroadenom",
      "Subareoläre Milchgangspapillomatose",
      "Zelluläres intrakanalikuläres Fibroadenom"
    ]
  },
  {
    "code": "D25.0",
    "name": "Submuköses Leiomyom des Uterus",
    "synonyms": [
      "Submuköses Leiomyom des Uterus"
    ]
  },
  {
    "code": "D25.1",
    "name": "Intramurales Leiomyom des Uterus",
    "synonyms": [
      "Intramurales Leiomyom des Uterus"
    ]
  },
  {
    "code": "D25.2",
    "name": "Subseröses Leiomyom des Uterus",
    "synonyms": [
      "Subseröses Leiomyom des Uterus"
    ]
  },
  {
    "code": "D25.9",
    "name": "Fibromyom des Uterus",
    "synonyms": [
      "Fibromyom des Corpus uteri",
      "Fibromyom des Uterus",
      "Fundusmyom",
      "Gebärmuttermyom",
      "Leiomyofibrom der Cervix uteri",
      "Leiomyofibrom des Corpus uteri",
      "Mehrknolliger Uterus myomatosus",
      "Myoma uteri",
      "Uterus myomatosus",
      "Uterusfibroid",
      "Uterushinterwandmyom",
      "Uterusleiomyom",
      "Uterusmyom",
      "Uterusvorderwandmyom"
    ]
  },
  {
    "code": "D26.0",
    "name": "Gutartige Neubildung der Cervix uteri",
    "synonyms": [
      "Endozervikale gutartige Neubildung",
      "Gutartige Neubildung der Cervix uteri",
      "Gutartige Neubildung der Ektozervix",
      "Gutartige Neubildung der Endozervix",
      "Gutartige Neubildung der Ovula Nabothi",
      "Gutartige Neubildung der Zervix",
      "Gutartige Neubildung des Kanals der Cervix uteri",
      "Gutartige Neubildung des Stumpfes der Cervix uteri",
      "Gutartige Neubildung des Zervikalkanals",
      "Gutartige Neubildung des Zervixstumpfes",
      "Gutartige Neubildung des Zervixüberganges zur Vagina",
      "Gutartige Neubildung des inneren Muttermundes",
      "Gutartige Neubildung des Überganges der Cervix uteri zur Vagina",
      "Gutartige Neubildung des äußeren Muttermundes",
      "Gutartiger Tumor der Cervix uteri",
      "Papillom der Cervix uteri",
      "Papillomatose der Cervix uteri",
      "Zervixpapillomatose"
    ]
  },
  {
    "code": "D26.1",
    "name": "Gutartige Neubildung des Corpus uteri",
    "synonyms": [
      "Corpus-uteri-Adenom",
      "Endometrialer Knoten",
      "Endometrialer Stromaknoten",
      "Gutartige Neubildung des Corpus uteri",
      "Gutartige Neubildung des Endometriums",
      "Gutartige Neubildung des Endometriumstromas",
      "Gutartige Neubildung des Fundus des Uterus",
      "Gutartige Neubildung des Fundus uteri",
      "Gutartige Neubildung des Isthmus des Uterus",
      "Gutartige Neubildung des Isthmus uteri",
      "Gutartige Neubildung des Myometriums",
      "Gutartige Neubildung des Uterushorns",
      "Gutartige Neubildung des Uteruskörpers",
      "Gutartige Neubildung des unteren Segmentes des Uterus"
    ]
  },
  {
    "code": "D26.7",
    "name": "Gutartige Neubildung der Plazenta",
    "synonyms": [
      "Gutartige Neubildung der Plazenta"
    ]
  },
  {
    "code": "D26.9",
    "name": "Uteruspapillom",
    "synonyms": [
      "Gutartige Neubildung des Uterus",
      "Gutartiger Uterustumor",
      "Uterusfibrom",
      "Uteruspapillom"
    ]
  },
  {
    "code": "D27",
    "name": "Gutartige Neubildung des Ovars",
    "synonyms": [
      "Adenofibrom",
      "Adenofibrom des Ovars",
      "Adenoma testiculare bei der Frau",
      "Benigner Brenner-Tumor",
      "Brenner-Tumor",
      "Demons-Meigs-Syndrom",
      "Dermoidzyste des Ovars",
      "Endometrioides Adenofibrom",
      "Endometrioides Zystadenofibrom",
      "Fettgewebetumor des Ovars",
      "Fibroepithelioma benignum ovarii",
      "Fibroma thecacellulare xanthomatodes",
      "Fibrothekom des Ovars",
      "Folliculoma lipidique bei der Frau",
      "Follikuloides Ovarialadenom",
      "Gutartige Neubildung des Ovars",
      "Gutartiger Leydigzell-Tumor bei der Frau",
      "Gutartiger Ovarialtumor",
      "Gutartiges Androblastom bei der Frau",
      "Gutartiges Arrhenoblastom bei der Frau",
      "Hellzelliges Adenofibrom",
      "Hiluszelltumor",
      "Hilärer Tumor",
      "Klarzelliges Adenofibrom",
      "Kolloides Zystadenom",
      "Kystadenofibrom",
      "Lipoidzelltumor des Ovars",
      "Luteinisiertes Thekom",
      "Luteinom",
      "Luteom",
      "Meigs-Cass-Syndrom",
      "Meigs-Syndrom",
      "Mikrozystischer Stromatumor",
      "Muköses Zystadenofibrom",
      "Muzinöses Adenofibrom",
      "Muzinöses Zystadenofibrom",
      "Muzinöses Zystadenom",
      "Muzinöses Zystadenom des Ovars im Kindesalter",
      "Muzinöses Zystom",
      "Neoplastische Ovarialzyste",
      "Oberflächliches seröses Papillom",
      "Oophoroma folliculare",
      "Ovarialfibrom",
      "Ovarialkystom",
      "Ovarialteratom",
      "Ovarialzystom",
      "Papilläres Adenofibrom",
      "Pseudomuzinöse Ovarialzyste",
      "Pseudomuzinöses Zystadenom",
      "Schleimiges Zystadenom",
      "Sertoli-Leydig-Zell-Tumor bei der Frau",
      "Sertoli-Zell-Adenom bei der Frau",
      "Sertoli-Zell-Tumor bei der Frau",
      "Seröses Adenofibrom",
      "Seröses Zystadenofibrom",
      "Seröses Zystadenom",
      "Seröses Zystadenom des Ovars im Kindesalter",
      "Seröses Zystom",
      "Sklerosierender stromaler Tumor",
      "Struma ovarii",
      "Testikuläres Adenom bei der Frau",
      "Thecoma",
      "Thekafibrom",
      "Thekazelltumor",
      "Thekom",
      "Tubuläres Androblastom bei der Frau",
      "Tubuläres Pick-Adenom bei der Frau",
      "Xanthofibroma thecacellulare"
    ]
  },
  {
    "code": "D28.0",
    "name": "Gutartige Neubildung der Vulva",
    "synonyms": [
      "Gutartige Neubildung der Bartholin-Drüse",
      "Gutartige Neubildung der Glandula vestibularis major",
      "Gutartige Neubildung der Klitoris",
      "Gutartige Neubildung der Labia majora pudendi",
      "Gutartige Neubildung der Labia minora pudendi",
      "Gutartige Neubildung der Labienhaut",
      "Gutartige Neubildung der Pudenda feminae",
      "Gutartige Neubildung der Vulva",
      "Gutartige Neubildung der vulvovaginalen Drüsen",
      "Gutartige Neubildung des Frenulum labiorum pudendi",
      "Gutartige Neubildung des Mons pubis",
      "Gutartige Neubildung des Mons veneris",
      "Gutartiger Vulvatumor",
      "Nichtmelanomartige gutartige Neubildung der Haut der Labia majora pudendi",
      "Nichtmelanomartige gutartige Neubildung der Haut der Labia minora pudendi",
      "Nichtmelanomartige gutartige Neubildung der Haut der Labien",
      "Nichtmelanomartige gutartige Neubildung der Haut der Pudenda feminae",
      "Nichtmelanomartige gutartige Neubildung der Haut der weiblichen Geschlechtsorgane",
      "Nichtmelanomartige gutartige Neubildung der Klitorishaut",
      "Nichtmelanomartige gutartige Neubildung der Vulvahaut",
      "Nävus der Labia majora pudendi",
      "Nävus der Labia minora pudendi",
      "Nävus der Vulva",
      "Nävus der weiblichen Geschlechtsorgane a.n.k.",
      "Nävus des Pudendums",
      "Vulvapapillom"
    ]
  },
  {
    "code": "D28.1",
    "name": "Gutartige Neubildung der Vagina",
    "synonyms": [
      "Gutartige Neubildung der Scheide",
      "Gutartige Neubildung der Vagina",
      "Gutartige Neubildung des Fornix vaginae",
      "Gutartige Neubildung des Gartner-Ganges",
      "Gutartige Neubildung des Hymens",
      "Gutartiger Vaginaltumor",
      "Vaginalfibrom"
    ]
  },
  {
    "code": "D28.2",
    "name": "Gutartige Neubildung der Tuba Falloppii",
    "synonyms": [
      "Benigner Tumor der Eileiter",
      "Endosalpingiom",
      "Gutartige Neubildung der Ligamenta sacrouterina",
      "Gutartige Neubildung der Ligamenta uteri",
      "Gutartige Neubildung der Mesosalpinx",
      "Gutartige Neubildung der Salpinx",
      "Gutartige Neubildung der Tuba Falloppii",
      "Gutartige Neubildung der Tuba uterina",
      "Gutartige Neubildung der Uterusligamente",
      "Gutartige Neubildung der uteroovarialen Bänder",
      "Gutartige Neubildung der uterosakralen Bänder",
      "Gutartige Neubildung der uterosakralen Ligamente",
      "Gutartige Neubildung des Eileiters",
      "Gutartige Neubildung des Ligamentum latum uteri",
      "Gutartige Neubildung des Ligamentum ovarii proprium",
      "Gutartige Neubildung des Ligamentum rotundum",
      "Gutartige Neubildung des Ligamentum rotundum uteri",
      "Gutartige Neubildung des Ligamentum teres uteri",
      "Gutartige Neubildung des Ligamentum uteri",
      "Gutartige Neubildung des Mesovariums",
      "Gutartige Neubildung des Ovidukts",
      "Gutartige Neubildung des Parametriums",
      "Gutartige Neubildung des Parovariums",
      "Gutartiger Tuba-uterina-Tumor"
    ]
  },
  {
    "code": "D28.7",
    "name": "Gutartige Neubildung der Uterusadnexe",
    "synonyms": [
      "Gutartige Neubildung der Uterusadnexe",
      "Gutartige Neubildung des Müller-Ganges bei der Frau",
      "Gutartige Neubildung des Wolff-Ganges bei der Frau",
      "Tuboovariale gutartige Neubildung",
      "Uteroovariale gutartige Neubildung",
      "Wolff-Gang-Adenom bei der Frau"
    ]
  },
  {
    "code": "D28.9",
    "name": "Adenomatöser Genitaltumor bei der Frau",
    "synonyms": [
      "Adenomatöser Genitalpolyp bei der Frau",
      "Adenomatöser Genitaltumor bei der Frau",
      "Gutartige Neubildung der weiblichen Geschlechtsorgane a.n.k.",
      "Gutartige Neubildung des Septum urethrovaginale",
      "Gutartige Neubildung des Septum vesikovaginale",
      "Gutartige Neubildung des vaginovesikalen Septums",
      "Gutartige Neubildung des vesikovaginalen Septums",
      "Gutartige Neubildung des vesikozervikalen Gewebes",
      "Gutartige Neubildung des weiblichen Urogenitaltraktes",
      "Urethrovaginale gutartige Neubildung",
      "Vaginovesikale gutartige Neubildung",
      "Vesikovaginale gutartige Neubildung"
    ]
  },
  {
    "code": "D29.0",
    "name": "Fibrom der Glans penis",
    "synonyms": [
      "Fibrom der Glans penis",
      "Fibrom des Penisschaftes",
      "Gutartige Neubildung der Glans penis",
      "Gutartige Neubildung der Penishaut a.n.k.",
      "Gutartige Neubildung der Vorhaut",
      "Gutartige Neubildung des Corpus cavernosum penis",
      "Gutartige Neubildung des Penis",
      "Gutartige Neubildung des Präputiums",
      "Nichtmelanomartige gutartige Neubildung der Penis a.n.k.",
      "Nichtmelanomartige gutartige Neubildung der Penishaut a.n.k.",
      "Nichtmelanomartige gutartige Neubildung der Präputialhaut",
      "Nävus der Vorhaut",
      "Nävus des Penis",
      "Nävus des Präputiums"
    ]
  },
  {
    "code": "D29.1",
    "name": "Restharnbildung bei Prostataadenom",
    "synonyms": [
      "Adenom des Prostatamittellappens",
      "Adenom des Prostataseitenlappens",
      "Benigner Prostatatumor",
      "Gutartige Neubildung der Prostata",
      "Gutartiger Prostatatumor",
      "Obstruktives Prostataadenom",
      "Prostataadenofibrom",
      "Prostataadenom",
      "Prostataadenom Stadium I",
      "Prostataadenom Stadium II",
      "Prostataadenom Stadium III",
      "Prostataadenomyom",
      "Prostatafibroadenom",
      "Prostatafibrom",
      "Prostatalappenadenom",
      "Prostataleiomyom",
      "Prostatamyoadenom",
      "Prostatamyom",
      "Prostatapapillom",
      "Prostatarhabdomyom",
      "Prostataverschluss durch Adenom",
      "Restharnbildung bei Prostataadenom"
    ]
  },
  {
    "code": "D29.2",
    "name": "Gutartige Neubildung des Hodens",
    "synonyms": [
      "Adenoma testiculare beim Mann",
      "Folliculoma lipidique beim Mann",
      "Gutartige Neubildung des Hodens",
      "Gutartige Neubildung eines deszendierten Hodens",
      "Gutartige Neubildung eines ektopischen Hodens",
      "Gutartige Neubildung eines nichtdeszendierten Hodens",
      "Gutartige Neubildung eines retinierten Hodens",
      "Gutartige Neubildung eines skrotalen Hodens",
      "Gutartiger Leydigzell-Tumor beim Mann",
      "Gutartiges Androblastom beim Mann",
      "Gutartiges Arrhenoblastom beim Mann",
      "Gutartiges Hodenteratom",
      "Gutartiges adultes reifzelliges Hodenteratom",
      "Sertoli-Leydig-Zell-Tumor beim Mann",
      "Sertoli-Zell-Adenom beim Mann",
      "Sertoli-Zell-Tumor beim Mann",
      "Testikuläres Adenom beim Mann",
      "Tubuläres Androblastom beim Mann",
      "Tubuläres Pick-Adenom beim Mann"
    ]
  },
  {
    "code": "D29.3",
    "name": "Gutartige Neubildung der Nebenhoden",
    "synonyms": [
      "Gutartige Neubildung der Epididymis",
      "Gutartige Neubildung der Nebenhoden",
      "Nebenhodenkopffibrom"
    ]
  },
  {
    "code": "D29.4",
    "name": "Gutartige Neubildung des Skrotums",
    "synonyms": [
      "Gutartige Neubildung der Skrotalhaut",
      "Gutartige Neubildung des Skrotums",
      "Nichtmelanomartige gutartige Neubildung der Skrotalhaut",
      "Nävus des Skrotums"
    ]
  },
  {
    "code": "D29.7",
    "name": "Gutartige Neubildung der Vesicula seminalis",
    "synonyms": [
      "Gutartige Neubildung der Bläschendrüse",
      "Gutartige Neubildung der Samenblase",
      "Gutartige Neubildung der Tunica vaginalis testis",
      "Gutartige Neubildung der Vesicula seminalis",
      "Gutartige Neubildung des Ductus deferens",
      "Gutartige Neubildung des Ductus ejaculatorius",
      "Gutartige Neubildung des Funiculus spermaticus",
      "Gutartige Neubildung des Müller-Ganges beim Mann",
      "Gutartige Neubildung des Samenstranges",
      "Gutartige Neubildung des Vas deferens",
      "Gutartige Neubildung des Wolff-Ganges beim Mann"
    ]
  },
  {
    "code": "D29.9",
    "name": "Nävus der männlichen Geschlechtsorgane a.n.k.",
    "synonyms": [
      "Gutartige Neubildung der männlichen Geschlechtsorgane a.n.k.",
      "Gutartige Neubildung des männlichen Urogenitaltraktes",
      "Nichtmelanomartige gutartige Neubildung der Haut der männlichen Geschlechtsorgane",
      "Nävus der männlichen Geschlechtsorgane a.n.k."
    ]
  },
  {
    "code": "D30.0",
    "name": "Nierenkapseladenom",
    "synonyms": [
      "Adenomatose der Niere",
      "Benigne Raumforderung der Niere",
      "Benigner Nierenpoltumor",
      "Benigner Nierenprozess",
      "Benigner Nierentumor",
      "Benigner Prozess des Nierenpols",
      "Benigner metanephrischer Tumor",
      "Gutartige Neubildung der Niere",
      "Gutartige Neubildung des Nierenparenchyms",
      "Gutartiger Nierenpoltumor",
      "Gutartiger Nierentumor",
      "Metanephrisches Adenofibrom",
      "Metanephrisches Adenom",
      "Nierenadenom",
      "Nierenkapseladenom",
      "Nierenrindenadenom",
      "Nierenrindenpapillom",
      "Renale gutartige Neubildung"
    ]
  },
  {
    "code": "D30.1",
    "name": "Gutartige Neubildung des Nierenbeckens",
    "synonyms": [
      "Gutartige Neubildung der Nierenkelche",
      "Gutartige Neubildung des Nierenbeckens",
      "Gutartige Neubildung des Nierenhilus",
      "Gutartige Neubildung des Überganges zwischen Nierenbecken und Harnleiter",
      "Gutartige Neubildung eines Calix renalis",
      "Gutartiges Nierenbeckenpapillom",
      "Nierenbeckenpolyp"
    ]
  },
  {
    "code": "D30.2",
    "name": "Gutartige Neubildung des Ureters",
    "synonyms": [
      "Gutartige Neubildung des Harnleiters",
      "Gutartige Neubildung des Ureters",
      "Gutartiges Harnleiterpapillom",
      "Gutartiges Ureterpapillom"
    ]
  },
  {
    "code": "D30.3",
    "name": "Blasenadenom",
    "synonyms": [
      "Benigner Harnblasentumor",
      "Blasenadenom",
      "Blasenhalsadenom",
      "Gutartige Harnblasenpapillomatose",
      "Gutartige Neubildung der Harnblase",
      "Gutartige Neubildung der Harnblasenwand",
      "Gutartige Neubildung der Harnblasenöffnung",
      "Gutartige Neubildung der Uretermündung",
      "Gutartige Neubildung der inneren Mündung der Urethra",
      "Gutartige Neubildung des Harnblasenhalses",
      "Gutartige Neubildung des Harnblasenostiums",
      "Gutartige Neubildung des Harnblasenscheitels",
      "Gutartige Neubildung des Harnblasensphinkters",
      "Gutartige Neubildung des Ostium ureteris",
      "Gutartige Neubildung des Ostium urethrae internum",
      "Gutartige Neubildung des Trigonum vesicae",
      "Gutartige Neubildung des Urachus",
      "Gutartiges Blasenpapillom",
      "Gutartiges Harnblasenpapillom",
      "Gutartiges rezidivierendes Blasenpapillom",
      "Harnblasenadenom",
      "Harnblasenhalsadenom"
    ]
  },
  {
    "code": "D30.4",
    "name": "Gutartige Neubildung der Urethra",
    "synonyms": [
      "Gutartige Neubildung der Harnröhre",
      "Gutartige Neubildung der Urethra",
      "Gutartige Neubildung des Utriculus prostaticus",
      "Papillom der Harnröhre",
      "Papillom der prostatischen Harnröhre",
      "Papillom der prostatischen Urethra",
      "Papillomatöse Wucherung der prostatischen Harnröhre",
      "Papillomatöse Wucherung der prostatischen Urethra",
      "Papillomatöses Gewächs der prostatischen Harnröhre",
      "Papillomatöses Gewächs der prostatischen Urethra",
      "Pseudopapillom der prostatischen Harnröhre",
      "Pseudopapillom der prostatischen Urethra",
      "Pseudopapillomatöse Veränderung der prostatischen Harnröhre",
      "Pseudopapillomatöse Veränderung der prostatischen Urethra",
      "Urethrapapillom"
    ]
  },
  {
    "code": "D30.7",
    "name": "Gutartige Neubildung der paraurethralen Drüsen",
    "synonyms": [
      "Gutartige Neubildung der Bulbourethraldrüsen",
      "Gutartige Neubildung der Cowper-Drüsen",
      "Gutartige Neubildung der Skene-Drüse",
      "Gutartige Neubildung der paraurethralen Drüsen"
    ]
  },
  {
    "code": "D30.9",
    "name": "Gutartige Neubildung der Harnorgane",
    "synonyms": [
      "Gutartige Neubildung der Harnorgane",
      "Gutartige Neubildung der Harnwege a.n.k.",
      "Gutartige Neubildung des Harnsystems",
      "Pseudopapillomatöse Urothelveränderung",
      "Pseudopapillomatöse Urothelwucherung",
      "Urothelpseudopapillom"
    ]
  },
  {
    "code": "D31.0",
    "name": "Ota-Nävus der Konjunktiva",
    "synonyms": [
      "Ballonzell-Nävus der Konjunktiva",
      "Benigner Karunkeltumor am Auge",
      "Benigner Konjunktivatumor",
      "Bindehautdermoid",
      "Bindehautfibrom",
      "Bindehautnävus",
      "Bindehautpapillom",
      "Gutartige Neubildung der Konjunktiva",
      "Gutartiger Bindehauttumor",
      "Konjunktivadermoid",
      "Konjunktivafibrom",
      "Konjunktivapapillom",
      "Nävus der Konjunktiva",
      "Ota-Nävus der Konjunktiva"
    ]
  },
  {
    "code": "D31.1",
    "name": "Gutartige Neubildung der Kornea",
    "synonyms": [
      "Benigner Hornhauttumor",
      "Benigner Skleratumor",
      "Gutartige Neubildung der Kornea",
      "Gutartige Neubildung des Limbus corneae",
      "Ringdermoid der Kornea",
      "X-chromosomales korneales Dermoid"
    ]
  },
  {
    "code": "D31.2",
    "name": "Gutartige Neubildung der Retina",
    "synonyms": [
      "Benigner Netzhauttumor",
      "Benigner Retinatumor",
      "Gutartige Neubildung der Retina",
      "Kombiniertes Hamartom der Retina und des retinalen Pigmentepithels",
      "Nävus der Retina",
      "Vasoproliferativer Tumor der Retina"
    ]
  },
  {
    "code": "D31.3",
    "name": "Aderhautnävus",
    "synonyms": [
      "Aderhautnävus",
      "Benigner Aderhauttumor",
      "Benigner Chorioideatumor",
      "Gutartige Neubildung der Chorioidea",
      "Nävus der Chorioidea"
    ]
  },
  {
    "code": "D31.4",
    "name": "Gutartige Neubildung des Ziliarkörpers",
    "synonyms": [
      "Benigner Iristumor",
      "Benigner Ziliarkörpertumor",
      "Gutartige Neubildung der Iris",
      "Gutartige Neubildung der Linse",
      "Gutartige Neubildung der Sklera",
      "Gutartige Neubildung des Uvealtraktes",
      "Gutartige Neubildung des Ziliarkörpers",
      "Irisnävus",
      "Melanozytom der Papille",
      "Ziliarkörpermelanozytom"
    ]
  },
  {
    "code": "D31.5",
    "name": "Gutartige Neubildung des Tränennasenganges",
    "synonyms": [
      "Benigner Tränenwegtumor",
      "Gutartige Neubildung der Tränendrüse",
      "Gutartige Neubildung des Ductus nasolacrimalis",
      "Gutartige Neubildung des Tränenkanals",
      "Gutartige Neubildung des Tränennasenganges",
      "Gutartige Neubildung des Tränenpunktes",
      "Gutartige Neubildung des Tränensacks",
      "Gutartiger Tränendrüsentumor",
      "Nävus der Tränendrüse",
      "Pleomorphes Adenom der Tränendrüse"
    ]
  },
  {
    "code": "D31.6",
    "name": "Gutartige Neubildung der Orbita",
    "synonyms": [
      "Benigner Orbitatumor",
      "Bindehautneurofibrom",
      "Dermoidzyste der Orbita",
      "Epidermoidzyste der Orbita",
      "Gutartige Neubildung der Orbita",
      "Gutartige Neubildung der Orbitanerven a.n.k.",
      "Gutartige Neubildung der Orbitaweichteile",
      "Gutartige Neubildung der autonomen Nerven der Orbita",
      "Gutartige Neubildung der extraokulären Augenmuskeln",
      "Gutartige Neubildung der peripheren Nerven der Orbita",
      "Gutartige Neubildung des Orbitabindegewebes",
      "Gutartige Neubildung des retrobulbären Gewebes",
      "Gutartige Neubildung des retrookulären Gewebes",
      "Intraorbitale gutartige Neubildung",
      "Konjunktivaneurofibrom",
      "Leiomyom der Orbita",
      "Lipodermoid der Orbita",
      "Nävus der Orbita",
      "Orbitafibrom",
      "Orbitaneurinom",
      "Retrobulbäre gutartige Neubildung",
      "Retrobulbärer Nävus"
    ]
  },
  {
    "code": "D31.9",
    "name": "Gutartige Neubildung des Augapfels",
    "synonyms": [
      "Benigner Augentumor",
      "Gutartige Neubildung des Augapfels",
      "Gutartige Neubildung des Auges",
      "Intraokuläre gutartige Neubildung",
      "Melanozytom des Augapfels",
      "Nävus des Auges"
    ]
  },
  {
    "code": "D32.0",
    "name": "Gutartige Neubildung der Hirnhaut",
    "synonyms": [
      "Gutartige Neubildung der Arachnoidea cerebralis",
      "Gutartige Neubildung der Dura mater cranialis",
      "Gutartige Neubildung der Dura mater encephali",
      "Gutartige Neubildung der Falx cerebelli",
      "Gutartige Neubildung der Falx cerebri",
      "Gutartige Neubildung der Gehirnmeningen",
      "Gutartige Neubildung der Hirnhaut",
      "Gutartige Neubildung der intrakraniellen Meningen",
      "Gutartige Neubildung der kranialen Pia mater",
      "Gutartige Neubildung der kraniellen Meningen",
      "Gutartige Neubildung der zerebralen Meningen",
      "Gutartige Neubildung der zerebralen Pia mater",
      "Gutartige Neubildung des Tentorium cerebelli",
      "Intrakranielles Meningeom",
      "Klivusmeningeom",
      "Meningeom des Frontallappens",
      "Meningeom des Nervus opticus",
      "Optikusmeningeom",
      "Orbitameningeom",
      "Sehnervmeningeom",
      "Tentoriummeningeom",
      "Zerebrales Meningeom"
    ]
  },
  {
    "code": "D32.1",
    "name": "Spinales Meningeom",
    "synonyms": [
      "Gutartige Neubildung der Arachnoidea spinalis",
      "Gutartige Neubildung der Dura mater der Wirbelsäule",
      "Gutartige Neubildung der Dura mater spinalis",
      "Gutartige Neubildung der Pia mater der Wirbelsäule",
      "Gutartige Neubildung der Rückenmarkhäute",
      "Gutartige Neubildung der Rückenmarkmeningen",
      "Gutartige Neubildung der Wirbelsäulenmeningen",
      "Gutartige Neubildung der spinalen Meningen",
      "Gutartige Neubildung der spinalen Pia mater",
      "Meningeom des Rückenmarks",
      "Spinales Meningeom"
    ]
  },
  {
    "code": "D32.9",
    "name": "Gutartige Neubildung der Meningen",
    "synonyms": [
      "Angioblastisches Meningeom",
      "Angiomatöses Meningeom",
      "Atypisches Meningeom",
      "Endotheliomatöses Meningeom",
      "Familiäre multiple Meningeome",
      "Fibroblastisches Meningeom",
      "Fibromatöses Meningeom",
      "Fibröses Meningeom",
      "Gemischtzelliges Meningeom",
      "Gutartige Neubildung der Arachnoidea",
      "Gutartige Neubildung der Dura mater",
      "Gutartige Neubildung der Meningen",
      "Gutartige Neubildung der Pia mater",
      "Hämangioblastisches Meningeom",
      "Hämangioperizytom der Meningen",
      "Hämangioperizytöses Meningeom",
      "Leptomeningeom",
      "Leptomeningiom",
      "Meningenangiom",
      "Meningeom",
      "Meningiom - s.a. Meningeom",
      "Meningotheliomatöses Meningeom",
      "Psammom",
      "Psammöses Meningeom",
      "Subdurale gutartige Neubildung",
      "Synzytiales Meningeom",
      "Transitionalzelliges Meningeom"
    ]
  },
  {
    "code": "D33.0",
    "name": "Chorioidpapillom",
    "synonyms": [
      "Chorioidalplexuspapillom",
      "Chorioidpapillom",
      "Desmoplastisches infantiles Astrozytom",
      "Desmoplastisches infantiles Gangliogliom",
      "Gutartige Neubildung der Basalganglien",
      "Gutartige Neubildung der Capsula interna",
      "Gutartige Neubildung der Großhirnhemisphäre",
      "Gutartige Neubildung der Großhirnrinde",
      "Gutartige Neubildung der Hirnventrikel",
      "Gutartige Neubildung der Insula",
      "Gutartige Neubildung der Reil-Insel",
      "Gutartige Neubildung der inneren Kapsel",
      "Gutartige Neubildung der weißen Hirnsubstanz",
      "Gutartige Neubildung des Corpus striatum",
      "Gutartige Neubildung des Ependyms des Gehirns",
      "Gutartige Neubildung des Frontalhirns a.n.k.",
      "Gutartige Neubildung des Globus pallidus",
      "Gutartige Neubildung des Hippocampus",
      "Gutartige Neubildung des Hypothalamus",
      "Gutartige Neubildung des Lobus frontalis",
      "Gutartige Neubildung des Lobus occipitalis",
      "Gutartige Neubildung des Lobus parietalis",
      "Gutartige Neubildung des Lobus temporalis",
      "Gutartige Neubildung des Okzipitallappens des Gehirns",
      "Gutartige Neubildung des Operculum",
      "Gutartige Neubildung des Palliums",
      "Gutartige Neubildung des Parietallappens des Gehirns",
      "Gutartige Neubildung des Plexus chorioideus",
      "Gutartige Neubildung des Polus frontalis cerebri",
      "Gutartige Neubildung des Polus occipitalis cerebri",
      "Gutartige Neubildung des Putamens",
      "Gutartige Neubildung des Rhinenzephalons",
      "Gutartige Neubildung des Scheitellappens des Gehirns",
      "Gutartige Neubildung des Stirnlappens des Gehirns",
      "Gutartige Neubildung des Temporallappens des Gehirns",
      "Gutartige Neubildung des Thalamus",
      "Gutartige Neubildung des Uncus",
      "Gutartige Neubildung des Zerebrums",
      "Gutartige Neubildung des supratentoriellen Gehirns",
      "Gutartige Neubildung eines basalen Ganglions",
      "Pallister-Hall-Syndrom",
      "Papillom des Plexus chorioideus",
      "Supratentorielle gutartige Neubildung a.n.k."
    ]
  },
  {
    "code": "D33.1",
    "name": "Gutartiges Kleinhirnbrückenwinkelchordom",
    "synonyms": [
      "Benignes pilozytisches Astrozytom",
      "Gutartige Neubildung der Gehirnolive",
      "Gutartige Neubildung der Medulla oblongata",
      "Gutartige Neubildung der Pyramide",
      "Gutartige Neubildung des Hirnstamms",
      "Gutartige Neubildung des Kleinhirnbrückenwinkels",
      "Gutartige Neubildung des Kleinhirns",
      "Gutartige Neubildung des Kleinhirnwurms",
      "Gutartige Neubildung des Mittelhirns",
      "Gutartige Neubildung des Pedunculus cerebri",
      "Gutartige Neubildung des Plexus chorioideus des vierten Ventrikels",
      "Gutartige Neubildung des Pons Varoli",
      "Gutartige Neubildung des Vermis cerebelli",
      "Gutartige Neubildung des Zerebellums",
      "Gutartige Neubildung des infratentoriellen Gehirns",
      "Gutartige Neubildung des vierten Ventrikels",
      "Gutartiges Kleinhirnbrückenwinkelchordom",
      "Kleinhirncholesteatom",
      "Lhermitte-Duclos-Krankheit",
      "Papillom des Chorioidalplexus des vierten Ventrikels",
      "Papillom des Plexus chorioideus des vierten Ventrikels",
      "Zerebellares Cholesteatom"
    ]
  },
  {
    "code": "D33.2",
    "name": "Gutartige Neubildung des Gehirns",
    "synonyms": [
      "Benigner Gehirntumor",
      "Benigner Hirntumor",
      "Benignes Teratom des Gehirns",
      "Dysembryoplastischer neuroepithelialer Tumor",
      "Gutartige Neubildung der Fossa cranii",
      "Gutartige Neubildung des Corpus callosum",
      "Gutartige Neubildung des Gehirns",
      "Gutartige Neubildung des Tapetum cerebri",
      "Gutartige Neubildung einer kranialen Fossa",
      "Gutartige Neubildung in der hinteren Schädelgrube",
      "Gutartige zerebrale Neubildung",
      "Intrakranielle gutartige Neubildung a.n.k.",
      "Supraselläre gutartige Neubildung"
    ]
  },
  {
    "code": "D33.3",
    "name": "Gliom des Nervus opticus",
    "synonyms": [
      "Akustikusneurilemmom",
      "Akustikusneurinom",
      "Akustikusneurom",
      "Benigner Hirnnerventumor",
      "Benigner Optikustumor",
      "Benigner Tumor des Nervus abducens",
      "Benigner Tumor des Nervus oculomotorius",
      "Benigner Tumor des Nervus opticus",
      "Benigner Tumor des Nervus trochlearis",
      "Gliom des Nervus opticus",
      "Gutartige Neubildung der Nervi craniales a.n.k.",
      "Gutartige Neubildung der Nervi olfactorii",
      "Gutartige Neubildung der Pars cochlearis des Nervus vestibulocochlearis",
      "Gutartige Neubildung des Bulbus olfactorius",
      "Gutartige Neubildung des Chiasma opticum",
      "Gutartige Neubildung des Gehörnerven",
      "Gutartige Neubildung des Nervus abducens",
      "Gutartige Neubildung des Nervus acusticus",
      "Gutartige Neubildung des Nervus facialis",
      "Gutartige Neubildung des Nervus glossopharyngeus",
      "Gutartige Neubildung des Nervus hypoglossus",
      "Gutartige Neubildung des Nervus oculomotorius",
      "Gutartige Neubildung des Nervus opticus",
      "Gutartige Neubildung des Nervus trigeminus",
      "Gutartige Neubildung des Nervus trochlearis",
      "Gutartige Neubildung des Nervus vagus",
      "Gutartige Neubildung des Nervus vestibulocochlearis",
      "Gutartige Neubildung des Sehnerven",
      "Gutartige Neubildung des Sehtraktes",
      "Gutartige Neubildung des Tractus opticus",
      "Gutartige Neubildung eines Hirnnerven",
      "Neurinom des Nervus acusticus",
      "Neurinom eines Hirnnerven",
      "Neurofibrom des Nervus opticus",
      "Optikusgliom",
      "Vestibularis-Schwannom"
    ]
  },
  {
    "code": "D33.4",
    "name": "Gutartige Neubildung des Rückenmarks",
    "synonyms": [
      "Gutartige Neubildung der Cauda equina",
      "Gutartige Neubildung des Conus medullaris",
      "Gutartige Neubildung des Filum terminale",
      "Gutartige Neubildung des Rückenmarks"
    ]
  },
  {
    "code": "D33.9",
    "name": "Benigner intrakranieller Tumor",
    "synonyms": [
      "Benigner intrakranieller Tumor",
      "Benignes Teratom des Zentralnervensystems",
      "Dermoid des Zentralnervensystems",
      "Dermoidzyste des Zentralnervensystems",
      "Epidurale gutartige Neubildung",
      "Extradurale gutartige Neubildung des Zentralnervensystems",
      "Gutartige Neubildung des Nervensystems",
      "Gutartige Neubildung des Zentralnervensystems",
      "Paraselläre gutartige Neubildung"
    ]
  },
  {
    "code": "D34",
    "name": "Gutartige Neubildung der Schilddrüse",
    "synonyms": [
      "Autonomes Schilddrüsenadenom",
      "Dekompensiertes Schilddrüsenadenom",
      "Dekompensiertes autonomes Schilddrüsenadenom",
      "Fetales Adenom",
      "Follikuläres Adenom",
      "Großfollikuläres Adenom",
      "Gutartige Neubildung der Schilddrüse",
      "Gutartige Neubildung der Thyreoidea",
      "Gutartige Neubildung des Ductus thyreoglossus",
      "Hürthle-Zell-Adenom",
      "Hürthle-Zell-Tumor",
      "Kleinfollikuläres Adenom",
      "Kolloides Adenom",
      "Kompensiertes autonomes Schilddrüsenadenom",
      "Makrofollikuläres Adenom",
      "Mikrofollikuläres Adenom",
      "Postbranchiale Getzowa-Struma",
      "Schilddrüsenadenom",
      "Schilddrüsenpapillom"
    ]
  },
  {
    "code": "D35.0",
    "name": "Adenom der Zona glomerulosa der Nebenniere",
    "synonyms": [
      "Adenom der Nebennierenrinde",
      "Adenom der Zona glomerulosa der Nebenniere",
      "Adrenales Paragangliom",
      "Adrenokortikales Adenom",
      "Benigner Nebennierentumor",
      "Familiäres Phäochromozytom",
      "Gutartige Neubildung der Medulla glandulae suprarenalis",
      "Gutartige Neubildung der Nebenniere",
      "Gutartige Neubildung der Nebennierenkapsel",
      "Gutartige Neubildung der Nebennierenrinde",
      "Gutartige Neubildung des Nebennierenmarks",
      "Gutartige Neubildung einer Nebennierendrüse",
      "Gutartiger Nebennierentumor",
      "Klarzelliges Nebennierenadenom",
      "Nebennierenadenom",
      "Nebennierenadenom vom Glomerulosazelltyp",
      "Nebennierenadenom vom Kompaktzelltyp",
      "Nebennierenadenom vom Mischzelltyp",
      "Nebennierenparagangliom",
      "Phäochromozytom",
      "Schwarzes Adenom",
      "Sporadisches Phäochromozytom",
      "Stark pigmentierte Variante des Nebennierenadenoms"
    ]
  },
  {
    "code": "D35.1",
    "name": "Parathyreoideaadenom",
    "synonyms": [
      "Epithelkörperchenadenom",
      "Familiäres Nebenschilddrüsenadenom",
      "Gutartige Neubildung der Epithelkörperchen",
      "Gutartige Neubildung der Nebenschilddrüse",
      "Gutartige Neubildung der Parathyreoidea",
      "Hauptzelladenom der Nebenschilddrüse",
      "Nebenschilddrüsenadenom",
      "Parathyreoideaadenom",
      "Wasserhellzelliges Adenom der Nebenschilddrüse"
    ]
  },
  {
    "code": "D35.2",
    "name": "Benigner Hypophysentumor",
    "synonyms": [
      "Azido-basophiles Adenom",
      "Azidophiles Adenom",
      "Basophiles Adenom",
      "Benigner Hypophysentumor",
      "Chiasmakompression durch Hypophysenadenom",
      "Chromophobes Adenom",
      "Chromophobes Hypophysenadenom",
      "Dermoidzyste der Hypophyse",
      "Eosinophiles Adenom",
      "Eosinophiles Hypophysenadenom",
      "Familiäres isoliertes Hypophysenadenom",
      "Gonadotropes Hypophysenadenom",
      "Gutartige Neubildung der Hypophyse",
      "Gutartige Neubildung der Rathke-Tasche",
      "Gutartige Neubildung des Hirnanhanges",
      "Gutartige Neubildung in der Fossa pituitaria",
      "Hormoninaktives Hypophysenadenom",
      "Hypophysenadenom",
      "Hypophysäres kortikotropes Mikroadenom",
      "Intraselläre gutartige Neubildung",
      "Kortikotropes Hypophysenadenom",
      "LTH-produzierendes Hypophysenadenom",
      "Laktotropes Adenom der Hypophyse",
      "Makroprolaktinomsyndrom",
      "Mukoidzelladenom der Hypophyse",
      "NFPA [Hormoninaktives Hypophysenadenom]",
      "Nullzell-Hypophysenadenom",
      "Prolaktinom",
      "Prolaktinproduzierendes Hypophysenadenom",
      "Somatomammotropinom",
      "Thyreotropes Hypophysenadenom"
    ]
  },
  {
    "code": "D35.3",
    "name": "Gutartige Neubildung des kraniopharyngealen Ganges",
    "synonyms": [
      "Gutartige Neubildung des Ductus craniopharyngealis",
      "Gutartige Neubildung des kraniopharyngealen Ganges"
    ]
  },
  {
    "code": "D35.4",
    "name": "Gutartige Neubildung der Zirbeldrüse",
    "synonyms": [
      "Gutartige Neubildung der Epiphyse",
      "Gutartige Neubildung der Zirbeldrüse",
      "Gutartige Neubildung des Corpus pineale"
    ]
  },
  {
    "code": "D35.5",
    "name": "Gutartige Neubildung des Glomus caroticum",
    "synonyms": [
      "Gutartige Neubildung der Karotisdrüse",
      "Gutartige Neubildung des Glomus caroticum"
    ]
  },
  {
    "code": "D35.6",
    "name": "Gutartige Neubildung des Zuckerkandl-Organs",
    "synonyms": [
      "Gutartige Neubildung des Glomus jugulare",
      "Gutartige Neubildung des Glomus tympanicum",
      "Gutartige Neubildung des Paraganglion aorticum abdominale",
      "Gutartige Neubildung des Zuckerkandl-Organs",
      "Gutartige Neubildung eines Paraganglions a.n.k."
    ]
  },
  {
    "code": "D35.8",
    "name": "Gutartige Neubildung der pluriglandulären endokrinen Drüsen a.n.k.",
    "synonyms": [
      "Gutartige Neubildung der pluriglandulären endokrinen Drüsen a.n.k.",
      "Polyglanduläre gutartige Neubildung"
    ]
  },
  {
    "code": "D35.9",
    "name": "Gutartige Neubildung einer endokrinen Drüse a.n.k.",
    "synonyms": [
      "Gutartige Neubildung einer endokrinen Drüse a.n.k."
    ]
  },
  {
    "code": "D36.0",
    "name": "Gutartige Neubildung der Lymphknoten",
    "synonyms": [
      "Benignes Lymphom",
      "Gutartige Neubildung der Armlymphknoten",
      "Gutartige Neubildung der Beckenlymphknoten",
      "Gutartige Neubildung der Beinlymphknoten",
      "Gutartige Neubildung der Gallenganglymphknoten",
      "Gutartige Neubildung der Gesichtslymphknoten",
      "Gutartige Neubildung der Halslymphknoten",
      "Gutartige Neubildung der Ileumlymphknoten",
      "Gutartige Neubildung der Kolonlymphknoten",
      "Gutartige Neubildung der Kopflymphknoten",
      "Gutartige Neubildung der Leberlymphknoten",
      "Gutartige Neubildung der Leistenbeugenlymphknoten",
      "Gutartige Neubildung der Lungenhiluslymphknoten",
      "Gutartige Neubildung der Lymphknoten",
      "Gutartige Neubildung der Lymphknoten der Porta hepatis",
      "Gutartige Neubildung der Lymphknoten der oberen Gliedmaßen",
      "Gutartige Neubildung der Lymphknoten der unteren Gliedmaßen",
      "Gutartige Neubildung der Lymphknoten des Anulus femoralis",
      "Gutartige Neubildung der Lymphknoten des Foramen obturatum",
      "Gutartige Neubildung der Lymphknoten des Hypogastriums",
      "Gutartige Neubildung der Lymphknoten des Lungenhilus",
      "Gutartige Neubildung der Lymphknoten des Zwerchfells",
      "Gutartige Neubildung der Magenlymphknoten",
      "Gutartige Neubildung der Mesokolonlymphknoten",
      "Gutartige Neubildung der Milzlymphknoten",
      "Gutartige Neubildung der Nackenlymphknoten",
      "Gutartige Neubildung der Pankreaslymphknoten",
      "Gutartige Neubildung der Parametriumlymphknoten",
      "Gutartige Neubildung der Parotislymphknoten",
      "Gutartige Neubildung der Pfortaderlymphknoten",
      "Gutartige Neubildung der Pyloruslymphknoten",
      "Gutartige Neubildung der Rosenmüller-Lymphknoten",
      "Gutartige Neubildung der Skalenus-Lymphknoten",
      "Gutartige Neubildung der Virchow-Drüse",
      "Gutartige Neubildung der aortalen Lymphknoten",
      "Gutartige Neubildung der aurikulären Lymphknoten",
      "Gutartige Neubildung der axillären Lymphknoten",
      "Gutartige Neubildung der brachialen Lymphknoten",
      "Gutartige Neubildung der bronchialen Lymphknoten",
      "Gutartige Neubildung der bronchopulmonalen Lymphknoten",
      "Gutartige Neubildung der diaphragmalen Lymphknoten",
      "Gutartige Neubildung der epitrochleären Lymphknoten",
      "Gutartige Neubildung der femoralen Lymphknoten",
      "Gutartige Neubildung der hepatischen Lymphknoten",
      "Gutartige Neubildung der iliakalen Lymphknoten",
      "Gutartige Neubildung der inferioren epigastrischen Lymphknoten",
      "Gutartige Neubildung der infraklavikulären Lymphknoten",
      "Gutartige Neubildung der inguinalen Lymphknoten",
      "Gutartige Neubildung der interkostalen Lymphknoten",
      "Gutartige Neubildung der intestinalen Lymphknoten",
      "Gutartige Neubildung der intraabdominalen Lymphknoten",
      "Gutartige Neubildung der intrathorakalen Lymphknoten",
      "Gutartige Neubildung der jugularen Lymphknoten",
      "Gutartige Neubildung der kubitalen Lymphknoten",
      "Gutartige Neubildung der lumbalen Lymphknoten",
      "Gutartige Neubildung der mandibulären Lymphknoten",
      "Gutartige Neubildung der mediastinalen Lymphknoten",
      "Gutartige Neubildung der mesenterialen Lymphknoten",
      "Gutartige Neubildung der nuchalen Lymphknoten",
      "Gutartige Neubildung der okzipitalen Lymphknoten",
      "Gutartige Neubildung der paraaortalen Lymphknoten",
      "Gutartige Neubildung der parasternalen Lymphknoten",
      "Gutartige Neubildung der parauterinen Lymphknoten",
      "Gutartige Neubildung der paravaginalen Lymphknoten",
      "Gutartige Neubildung der parazervikalen Lymphknoten",
      "Gutartige Neubildung der pektoralen Lymphknoten",
      "Gutartige Neubildung der pelvinen Lymphknoten",
      "Gutartige Neubildung der periaortalen Lymphknoten",
      "Gutartige Neubildung der peripankreatischen Lymphknoten",
      "Gutartige Neubildung der poplitealen Lymphknoten",
      "Gutartige Neubildung der portalen Lymphknoten",
      "Gutartige Neubildung der präaurikulären Lymphknoten",
      "Gutartige Neubildung der prälaryngealen Lymphknoten",
      "Gutartige Neubildung der präsymphysealen Lymphknoten",
      "Gutartige Neubildung der prätrachealen Lymphknoten",
      "Gutartige Neubildung der retroaurikulären Lymphknoten",
      "Gutartige Neubildung der retroperitonealen Lymphknoten",
      "Gutartige Neubildung der retropharyngealen Lymphknoten",
      "Gutartige Neubildung der retrosternalen Lymphknoten",
      "Gutartige Neubildung der sakralen Lymphknoten",
      "Gutartige Neubildung der subinguinalen Lymphknoten",
      "Gutartige Neubildung der subklavikulären Lymphknoten"
    ]
  },
  {
    "code": "D36.1",
    "name": "Gutartige Neubildung der Ganglien",
    "synonyms": [
      "Benigner peripherer Nervenscheidentumor",
      "Echtes Neurom",
      "Extraneurales Perineuriom",
      "Fibroneurom",
      "Ganglioneurom",
      "Ganglioneuroma",
      "Ganglioneuromatose",
      "Gangliozytom",
      "Gutartige Neubildung abdominopelviner Nerven a.n.k.",
      "Gutartige Neubildung an Nerven der Wirbelsäule",
      "Gutartige Neubildung an Nervenwurzeln der Wirbelsäule",
      "Gutartige Neubildung der Abdominalnerven a.n.k.",
      "Gutartige Neubildung der Achselhöhlennerven a.n.k.",
      "Gutartige Neubildung der Armnerven a.n.k.",
      "Gutartige Neubildung der Augenlidnerven a.n.k.",
      "Gutartige Neubildung der Bauchwandnerven a.n.k.",
      "Gutartige Neubildung der Beckenbodennerven a.n.k.",
      "Gutartige Neubildung der Beckennerven a.n.k.",
      "Gutartige Neubildung der Beinnerven a.n.k.",
      "Gutartige Neubildung der Brachialnerven",
      "Gutartige Neubildung der Brustnerven a.n.k.",
      "Gutartige Neubildung der Brustwandnerven a.n.k.",
      "Gutartige Neubildung der Daumennerven a.n.k.",
      "Gutartige Neubildung der Ellenbeugennerven a.n.k.",
      "Gutartige Neubildung der Ellenbogennerven a.n.k.",
      "Gutartige Neubildung der Extremitätennerven a.n.k.",
      "Gutartige Neubildung der Fersennerven a.n.k.",
      "Gutartige Neubildung der Fingernerven a.n.k.",
      "Gutartige Neubildung der Fußnerven a.n.k.",
      "Gutartige Neubildung der Ganglien",
      "Gutartige Neubildung der Gesichtsnerven a.n.k.",
      "Gutartige Neubildung der Gesäßnerven a.n.k.",
      "Gutartige Neubildung der Gliedmaßennerven a.n.k.",
      "Gutartige Neubildung der Halsnerven a.n.k.",
      "Gutartige Neubildung der Handgelenknerven a.n.k.",
      "Gutartige Neubildung der Handnerven a.n.k.",
      "Gutartige Neubildung der Hüftnerven a.n.k.",
      "Gutartige Neubildung der Kinnnerven a.n.k.",
      "Gutartige Neubildung der Kniekehlennerven a.n.k.",
      "Gutartige Neubildung der Knienerven a.n.k.",
      "Gutartige Neubildung der Knöchelnerven a.n.k.",
      "Gutartige Neubildung der Kopfnerven a.n.k.",
      "Gutartige Neubildung der Kopfschwartennerven a.n.k.",
      "Gutartige Neubildung der Nabelnerven a.n.k.",
      "Gutartige Neubildung der Nackennerven a.n.k.",
      "Gutartige Neubildung der Nerven der Auricula a.n.k.",
      "Gutartige Neubildung der Nerven der Flankengegend a.n.k.",
      "Gutartige Neubildung der Nerven der Fossa ischiorectalis a.n.k.",
      "Gutartige Neubildung der Nerven der Fossa pterygoidea a.n.k.",
      "Gutartige Neubildung der Nerven der Glutäalmuskulatur a.n.k.",
      "Gutartige Neubildung der Nerven der Infraklavikulargegend a.n.k.",
      "Gutartige Neubildung der Nerven der Kreuzbeingegend a.n.k.",
      "Gutartige Neubildung der Nerven der Leistenkanalgegend a.n.k.",
      "Gutartige Neubildung der Nerven der Schläfenbeinregion a.n.k.",
      "Gutartige Neubildung der Nerven der Schulterblattgegend a.n.k.",
      "Gutartige Neubildung der Nerven der Steißbeingegend a.n.k.",
      "Gutartige Neubildung der Nerven der Supraklavikulargegend a.n.k.",
      "Gutartige Neubildung der Nerven der oberen Extremität a.n.k.",
      "Gutartige Neubildung der Nerven der oberen Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Nerven der unteren Extremität a.n.k.",
      "Gutartige Neubildung der Nerven der unteren Gliedmaßen a.n.k.",
      "Gutartige Neubildung der Nerven des Septum rectovaginale a.n.k.",
      "Gutartige Neubildung der Nervi lumbales",
      "Gutartige Neubildung der Nervi sacrales",
      "Gutartige Neubildung der Nervi spinales a.n.k.",
      "Gutartige Neubildung der Oberschenkelnerven a.n.k.",
      "Gutartige Neubildung der Ohrnerven a.n.k.",
      "Gutartige Neubildung der Perineumnerven a.n.k.",
      "Gutartige Neubildung der Rumpfnerven a.n.k.",
      "Gutartige Neubildung der Rückennerven a.n.k.",
      "Gutartige Neubildung der Schläfenerven a.n.k.",
      "Gutartige Neubildung der Schulternerven a.n.k.",
      "Gutartige Neubildung der Stirnnerven a.n.k.",
      "Gutartige Neubildung der Thoraxnerven a.n.k.",
      "Gutartige Neubildung der Thoraxwandnerven a.n.k.",
      "Gutartige Neubildung der Unterarmnerven a.n.k.",
      "Gutartige Neubildung der Wadennerven a.n.k.",
      "Gutartige Neubildung der Wangennerven a.n.k.",
      "Gutartige Neubildung der Zehennerven a.n.k.",
      "Gutartige Neubildung der autonomen Nerven a.n.k.",
      "Gutartige Neubildung der inguinalen Nerven a.n.k.",
      "Gutartige Neubildung der intrathorakalen Nerven a.n.k.",
      "Gutartige Neubildung der pararektalen Nerven a.n.k.",
      "Gutartige Neubildung der paraurethralen Nerven a.n.k.",
      "Gutartige Neubildung der paravaginalen Nerven a.n.k.",
      "Gutar"
    ]
  },
  {
    "code": "D36.7",
    "name": "Adenom der Nase",
    "synonyms": [
      "Abdominopelvine gutartige Neubildung",
      "Adenom der Nase",
      "Extrarektale gutartige Neubildung",
      "Gutartige Neubildung der Achselhöhle",
      "Gutartige Neubildung der Baucheingeweide",
      "Gutartige Neubildung der Bauchhöhle",
      "Gutartige Neubildung der Bauchorgane",
      "Gutartige Neubildung der Beckenorgane",
      "Gutartige Neubildung der Beckenwand",
      "Gutartige Neubildung der Brustwand a.n.k.",
      "Gutartige Neubildung der Eingeweide a.n.k.",
      "Gutartige Neubildung der Ferse a.n.k.",
      "Gutartige Neubildung der Flanke a.n.k.",
      "Gutartige Neubildung der Gliedmaßen",
      "Gutartige Neubildung der Glutäalregion",
      "Gutartige Neubildung der Hand a.n.k.",
      "Gutartige Neubildung der Hüfte a.n.k.",
      "Gutartige Neubildung der Kniekehle",
      "Gutartige Neubildung der Kreuzbeingegend",
      "Gutartige Neubildung der Leistenbeuge a.n.k.",
      "Gutartige Neubildung der Leistengegend",
      "Gutartige Neubildung der Nase",
      "Gutartige Neubildung der Regio scapularis",
      "Gutartige Neubildung der Schulter a.n.k.",
      "Gutartige Neubildung der Schulterblattregion",
      "Gutartige Neubildung der Supraklavikulargrube",
      "Gutartige Neubildung der Temporalregion",
      "Gutartige Neubildung der Wade",
      "Gutartige Neubildung der Wange",
      "Gutartige Neubildung der Zervikalregion",
      "Gutartige Neubildung der oberen Extremität",
      "Gutartige Neubildung der oberen Gliedmaßen",
      "Gutartige Neubildung der rektovaginalen Wand",
      "Gutartige Neubildung der unteren Extremität",
      "Gutartige Neubildung der unteren Gliedmaßen",
      "Gutartige Neubildung des Abdomens",
      "Gutartige Neubildung des Arms a.n.k.",
      "Gutartige Neubildung des Bauches",
      "Gutartige Neubildung des Beckenbodens",
      "Gutartige Neubildung des Beckens",
      "Gutartige Neubildung des Beins a.n.k.",
      "Gutartige Neubildung des Daumens a.n.k.",
      "Gutartige Neubildung des Ellenbogens a.n.k.",
      "Gutartige Neubildung des Fußes a.n.k.",
      "Gutartige Neubildung des Gesichts a.n.k.",
      "Gutartige Neubildung des Gesäßes a.n.k.",
      "Gutartige Neubildung des Halses a.n.k.",
      "Gutartige Neubildung des Handgelenks a.n.k.",
      "Gutartige Neubildung des Kiefers",
      "Gutartige Neubildung des Knies a.n.k.",
      "Gutartige Neubildung des Knöchels a.n.k.",
      "Gutartige Neubildung des Kopfes a.n.k.",
      "Gutartige Neubildung des Oberschenkels a.n.k.",
      "Gutartige Neubildung des Perineums",
      "Gutartige Neubildung des Rumpfes a.n.k.",
      "Gutartige Neubildung des Rückens a.n.k.",
      "Gutartige Neubildung des Septum rectovaginale",
      "Gutartige Neubildung des Septum rectovesicale",
      "Gutartige Neubildung des Thorax",
      "Gutartige Neubildung des Unterarms a.n.k.",
      "Gutartige Neubildung des periurethralen Gewebes",
      "Gutartige Neubildung des rektovaginalen Septums",
      "Gutartige Neubildung einer Extremität",
      "Gutartige Neubildung einer Zehe a.n.k.",
      "Gutartige Neubildung eines Fingers a.n.k.",
      "Gutartige Neubildung in der Fossa ischiorectalis",
      "Infraklavikuläre gutartige Neubildung",
      "Intraabdominale gutartige Neubildung",
      "Intrathorakale gutartige Neubildung",
      "Ischiorektale gutartige Neubildung",
      "Nasenschleimhautadenom",
      "Pararektale gutartige Neubildung",
      "Paraurethrale gutartige Neubildung",
      "Paraurethrales Adenom",
      "Paravaginale gutartige Neubildung",
      "Pelvikoabdominale gutartige Neubildung",
      "Perirektale gutartige Neubildung",
      "Präsakrale gutartige Neubildung",
      "Retrovesikale gutartige Neubildung",
      "Submentale gutartige Neubildung",
      "Vesikorektale gutartige Neubildung",
      "Zervikale Dermoidzyste"
    ]
  },
  {
    "code": "D36.9",
    "name": "Mikroadenom",
    "synonyms": [
      "Acanthoma - s.a. Neubildung, gutartig",
      "Adenokystom",
      "Adenom",
      "Adenoma tubulare",
      "Adenomatöser Polyp",
      "Adultes zystisches Teratom",
      "Akanthom - s.a. Neubildung, gutartig",
      "Azinuszellen-Adenom",
      "Azinöses Adenom",
      "Baso-eosinophiles Adenom",
      "Benigne Geschwulst",
      "Cystadenoma - s.a. Zystadenom",
      "Dermoid",
      "Dermoidzyste",
      "Differenziertes Teratom",
      "Duktales Adenom",
      "Embryonales Adenom",
      "Endometrioides Adenom",
      "Epithelioma papillare",
      "Gangadenom",
      "Großzellig-oxyphiles Adenom",
      "Gutartige Geschwulst",
      "Gutartige Neubildung",
      "Gutartiger Tumor",
      "Gutartiges Akanthom - s.a. Neubildung, gutartig",
      "Gutartiges Epitheliom",
      "Gutartiges Mesonephrom",
      "Gutartiges Teratom",
      "Hellzelliges Adenom",
      "Intrazystisches papilläres Adenom",
      "Klarzelliges Adenom",
      "Kystadenom",
      "Melanotisches Progonom - s.a. Neubildung, gutartig",
      "Mesonephrisches Adenom",
      "Mesonephroma benignum",
      "Mikroadenom",
      "Mischzelladenom",
      "Monomorphes Adenom",
      "Multiple adenomatöse Polypen",
      "Multiple adenomatöse Polyposis",
      "Multiple adenomatöse Schleimhautpolypen",
      "Muzinöses Adenom",
      "Onkozytäres Adenom",
      "Oxyphiles Adenom",
      "Papillom",
      "Papillomatöse Wucherung",
      "Papillomatöses Gewächs",
      "Papillotubuläres Adenom",
      "Papilläres Adenom",
      "Papillärtumor",
      "Pleomorphes Adenom",
      "Polymorphzelliges Adenom",
      "Polypoides Adenom",
      "Progonom - s.a. Neubildung, gutartig",
      "Schleimiges Adenom",
      "Teratoma benignum",
      "Teratoma cysticum adultum",
      "Trabekuläres Adenom",
      "Tubulovillöses Adenom",
      "Tubuläres Adenom",
      "Tumoranlage",
      "Villoglanduläres Adenom",
      "Zystadenom",
      "Zystisches Adenom"
    ]
  },
  {
    "code": "D37.0",
    "name": "Unsichere Neubildung der Mundhöhle",
    "synonyms": [
      "Bukkale unsichere Neubildung",
      "Epipharynxtumor",
      "Gaumenteratom",
      "Labiale unsichere Neubildung",
      "Linguale unsichere Neubildung a.n.k.",
      "Mischtumor der Mundspeicheldrüse",
      "Mundgeschwulst",
      "Mundhöhlenmischtumor",
      "Mundtumor",
      "Myxadenom",
      "Nasopharynxteratom",
      "Neoplasie des Mundes",
      "Neoplasie des Pharynx",
      "Parodontale unsichere Neubildung a.n.k.",
      "Parotismischtumor",
      "Parotistumor",
      "Pharynxgeschwulst",
      "Pharynxmischtumor",
      "Pharynxteratom",
      "Pharynxtumor",
      "Rachenmischtumor",
      "Rachenteratom",
      "Retropharyngeale unsichere Neubildung",
      "Speicheldrüsenmischtumor",
      "Sublinguale unsichere Neubildung",
      "Tonsillenmischtumor",
      "Tonsillenteratom",
      "Unsichere Neubildung der Alveolarschleimhaut",
      "Unsichere Neubildung der Außenseite der Lippe",
      "Unsichere Neubildung der Außenseite der Oberlippe",
      "Unsichere Neubildung der Außenseite der Unterlippe",
      "Unsichere Neubildung der Choane",
      "Unsichere Neubildung der Fauces",
      "Unsichere Neubildung der Fossa piriformis",
      "Unsichere Neubildung der Fossa tonsillaris",
      "Unsichere Neubildung der Gaumenbogentonsillen",
      "Unsichere Neubildung der Gaumenmandel a.n.k.",
      "Unsichere Neubildung der Gingiva",
      "Unsichere Neubildung der Hauptspeicheldrüse",
      "Unsichere Neubildung der Hinterwand des Oropharynx",
      "Unsichere Neubildung der Innenseite der Lippe",
      "Unsichere Neubildung der Innenseite der Oberlippe",
      "Unsichere Neubildung der Innenseite der Unterlippe",
      "Unsichere Neubildung der Kieferweichteile",
      "Unsichere Neubildung der Kiemenspalte",
      "Unsichere Neubildung der Lippe",
      "Unsichere Neubildung der Lippenkommissur",
      "Unsichere Neubildung der Lippenrotgrenze",
      "Unsichere Neubildung der Lippenschleimhaut",
      "Unsichere Neubildung der Mundhöhle",
      "Unsichere Neubildung der Mundhöhlenschleimhaut a.n.k.",
      "Unsichere Neubildung der Mundschleimhaut a.n.k.",
      "Unsichere Neubildung der Nebenspeicheldrüsen a.n.k.",
      "Unsichere Neubildung der Oberfläche der Epiglottis",
      "Unsichere Neubildung der Oberkieferalveolarschleimhaut",
      "Unsichere Neubildung der Oberkiefergingiva",
      "Unsichere Neubildung der Oberkieferweichteile",
      "Unsichere Neubildung der Oberlippe",
      "Unsichere Neubildung der Ohrspeicheldrüse",
      "Unsichere Neubildung der Parotis",
      "Unsichere Neubildung der Pharynxtonsille",
      "Unsichere Neubildung der Pharynxwand",
      "Unsichere Neubildung der Plica aryepiglottica",
      "Unsichere Neubildung der Plica glossoepiglottica",
      "Unsichere Neubildung der Rachenmandel",
      "Unsichere Neubildung der Randzone der Plica aryepiglottica",
      "Unsichere Neubildung der Randzone der aryepiglottischen Falte",
      "Unsichere Neubildung der Regio postcricoidea",
      "Unsichere Neubildung der Retromolarregion",
      "Unsichere Neubildung der Rosenmüller-Grube",
      "Unsichere Neubildung der Seitenwand des Oropharynx",
      "Unsichere Neubildung der Speicheldrüsen",
      "Unsichere Neubildung der Tonsilla lingualis",
      "Unsichere Neubildung der Tonsilla palatina",
      "Unsichere Neubildung der Tonsilla pharyngea",
      "Unsichere Neubildung der Tonsillen",
      "Unsichere Neubildung der Unterkieferalveolarschleimhaut",
      "Unsichere Neubildung der Unterkiefergingiva",
      "Unsichere Neubildung der Unterkieferspeicheldrüse",
      "Unsichere Neubildung der Unterkieferweichteile",
      "Unsichere Neubildung der Unterlippe",
      "Unsichere Neubildung der Unterzungenspeicheldrüse",
      "Unsichere Neubildung der Uvula",
      "Unsichere Neubildung der Vallecula epiglottica",
      "Unsichere Neubildung der Vorderfläche der Epiglottis",
      "Unsichere Neubildung der Wand des Nasenrachenraums",
      "Unsichere Neubildung der Wangeninnenseite",
      "Unsichere Neubildung der Wangenschleimhaut",
      "Unsichere Neubildung der Zunge",
      "Unsichere Neubildung der Zungenmandel",
      "Unsichere Neubildung der Zungenmittellinie a.n.k.",
      "Unsichere Neubildung der Zungenoberfläche",
      "Unsichere Neubildung der Zungenspitze",
      "Unsichere Neubildung der Zungenwurzel",
      "Unsichere Neubildung der aryepiglottische Falte",
      "Unsichere Neubildung der aryepiglottischen Falte",
      "Unsichere Neubildung der bukkalen Schleimhaut",
      "Unsichere Neubildung der hinteren Oberfläche des weichen Gaumens",
      "Unsichere Neubildung der hinteren Wand des Hypopharynx",
      "Unsichere Neubildung der hinteren Wand des Nasenrachenraums",
      "Unsichere Neubildung der hinteren Zunge",
      "Unsichere Neubildung der hypopharyngealen Seite der Plica aryepiglottica",
      "Unsichere Neubildung der hy"
    ]
  },
  {
    "code": "D37.1",
    "name": "Unsichere Neubildung des Magens",
    "synonyms": [
      "Gastro-oesophagealer Tumor",
      "Kardianeoplasie",
      "Kardiatumor",
      "Magengeschwulst",
      "Magenneoplasie",
      "Magentumor",
      "Unsichere Neubildung der Kardia des Magens",
      "Unsichere Neubildung der Magenwand a.n.k.",
      "Unsichere Neubildung der großen Kurvatur des Magens a.n.k.",
      "Unsichere Neubildung der hinteren Magenwand a.n.k.",
      "Unsichere Neubildung der kleinen Kurvatur des Magens a.n.k.",
      "Unsichere Neubildung der vorderen Magenwand a.n.k.",
      "Unsichere Neubildung des Antrum pyloricum",
      "Unsichere Neubildung des Canalis pyloricus",
      "Unsichere Neubildung des Corpus ventriculi",
      "Unsichere Neubildung des Magenantrums",
      "Unsichere Neubildung des Mageneingangs",
      "Unsichere Neubildung des Magenfundus",
      "Unsichere Neubildung des Magenkorpus",
      "Unsichere Neubildung des Magens",
      "Unsichere Neubildung des Ostium cardiacum",
      "Unsichere Neubildung des Präpylorus",
      "Unsichere Neubildung des Pylorus",
      "Unsichere Neubildung des gastroösophagealen Überganges",
      "Unsichere Neubildung des kardioösophagealen Überganges"
    ]
  },
  {
    "code": "D37.2",
    "name": "Unsichere Neubildung des Ileums",
    "synonyms": [
      "Duodenaltumor",
      "Dünndarmneoplasie",
      "Dünndarmtumor",
      "Ileumtumor",
      "Unsichere Neubildung des Duodenums",
      "Unsichere Neubildung des Dünndarmes",
      "Unsichere Neubildung des Ileums",
      "Unsichere Neubildung des Jejunums",
      "Unsichere Neubildung des duodenojejunalen Überganges",
      "Unsichere Neubildung eines Meckel-Divertikels",
      "Unsichere neuroendokrine Neubildung des Duodenums",
      "Unsichere neuroendokrine Neubildung des Ileums",
      "Unsichere neuroendokrine Neubildung des Jejunums"
    ]
  },
  {
    "code": "D37.3",
    "name": "Appendixkarzinoid",
    "synonyms": [
      "Appendixkarzinoid",
      "Appendixtumor",
      "Klassischer neuroendokriner Tumor der Apendix",
      "Unsichere Neubildung der Appendix",
      "Unsicherer neuroendokriner Tumor der Appendix"
    ]
  },
  {
    "code": "D37.4",
    "name": "Villöses Adenom des Colon ascendens",
    "synonyms": [
      "Colon-descendens-Tumor",
      "Colon-sigmoideum-Tumor",
      "Colon-transversum-Tumor",
      "Dickdarmneoplasie",
      "Dickdarmtumor",
      "Ileozäkaltumor",
      "Kolonneoplasie",
      "Kolontumor",
      "Sigmaneoplasie",
      "Sigmatumor",
      "Unsichere Neubildung der Flexura coli dextra",
      "Unsichere Neubildung der Flexura coli hepatica",
      "Unsichere Neubildung der Flexura coli lienalis",
      "Unsichere Neubildung der Flexura coli sigmoidei",
      "Unsichere Neubildung der Flexura coli sinistra",
      "Unsichere Neubildung der hepatischen Kolonflexur",
      "Unsichere Neubildung des Colon ascendens",
      "Unsichere Neubildung des Colon descendens",
      "Unsichere Neubildung des Colon pelvinum",
      "Unsichere Neubildung des Colon sigmoideum",
      "Unsichere Neubildung des Colon transversum",
      "Unsichere Neubildung des Dickdarmes",
      "Unsichere Neubildung des Ileozäkums",
      "Unsichere Neubildung des Kolons",
      "Unsichere Neubildung des Sigmas",
      "Unsichere Neubildung des Zäkums",
      "Unsichere Neubildung des distalen Kolons",
      "Unsichere Neubildung des ileozäkalen Überganges",
      "Unsichere Neubildung des linken Kolons",
      "Unsichere Neubildung des rechten Kolons",
      "Unsichere neuroendokrine Neubildung des Kolons",
      "Villöses Adenom des Colon ascendens",
      "Villöses Adenom des Colon sigmoideum",
      "Zäkumneoplasie",
      "Zäkumtumor"
    ]
  },
  {
    "code": "D37.5",
    "name": "Villöses Rektumadenom",
    "synonyms": [
      "Rektumgeschwulst",
      "Rektumneoplasie",
      "Rektumtumor",
      "Unsichere Neubildung des Kolons und des Rektums",
      "Unsichere Neubildung des Rektosigmoids",
      "Unsichere Neubildung des Rektums",
      "Unsichere Neubildung des pelvikorektalen Überganges",
      "Unsichere Neubildung des pelvirektalen Überganges",
      "Unsichere Neubildung des rektosigmoidalen Überganges",
      "Unsichere neuroendokrine Neubildung des Rektums",
      "Villöses Rektumadenom"
    ]
  },
  {
    "code": "D37.6",
    "name": "Tumor der Gallenblase",
    "synonyms": [
      "Cholangiozelluläre Neoplasie",
      "Geschwulst der Gallenblase",
      "Hepatische unsichere Neubildung",
      "Lebergeschwulst",
      "Leberneoplasie",
      "Lebertumor",
      "Neoplasie der Gallenblase",
      "Neoplasie des Gallensystems",
      "Tumor der Gallenblase",
      "Unsichere Neubildung der Ampulla Vateri",
      "Unsichere Neubildung der Ampulla hepatopancreatica",
      "Unsichere Neubildung der Ductuli biliferi",
      "Unsichere Neubildung der Ductuli intrahepaticae",
      "Unsichere Neubildung der Gallenblase",
      "Unsichere Neubildung der Gallenwege",
      "Unsichere Neubildung der Leber",
      "Unsichere Neubildung der extrahepatischen Gallengänge",
      "Unsichere Neubildung der hepatischen Gallengänge",
      "Unsichere Neubildung der intrahepatischen Gallengänge",
      "Unsichere Neubildung der intrahepatischen Gallenwege",
      "Unsichere Neubildung der intralobulären Gallengänge",
      "Unsichere Neubildung der intralobulären Gallenwege",
      "Unsichere Neubildung des Ductus choledochus",
      "Unsichere Neubildung des Ductus cysticus",
      "Unsichere Neubildung des Ductus hepaticus",
      "Unsichere Neubildung des Gallenblasenganges",
      "Unsichere Neubildung des Gallenganges",
      "Unsichere Neubildung des Sphincter Oddi"
    ]
  },
  {
    "code": "D37.70",
    "name": "Inselzelltumor",
    "synonyms": [
      "Bauchspeicheldrüsentumor",
      "G-Zell-Tumor",
      "Inselzelltumor",
      "PPOM [Pankreatisches Polypeptidom]",
      "Pankreasgeschwulst",
      "Pankreaskopftumor",
      "Pankreasneoplasie",
      "Pankreastumor",
      "Pankreatoduodenaltumor",
      "Unsichere Neubildung der Bauchspeicheldrüse",
      "Unsichere Neubildung der Inselzellen",
      "Unsichere Neubildung der Inselzellen des Pankreas",
      "Unsichere Neubildung der Langerhans-Inseln",
      "Unsichere Neubildung des Ductus pancreaticus accessorius",
      "Unsichere Neubildung des Pankreas",
      "Unsichere Neubildung des Pankreasganges",
      "Unsichere Neubildung des Pankreashalses",
      "Unsichere Neubildung des Pankreaskopfes",
      "Unsichere Neubildung des Pankreaskörpers",
      "Unsichere Neubildung des Pankreasschwanzes",
      "Unsichere Neubildung des Wirsung-Ganges",
      "Unsicheres Glukagonom",
      "Unsicheres Insulinom",
      "Unsicheres Pankreasglukagonom",
      "Unsicheres Pankreasinsulinom"
    ]
  },
  {
    "code": "D37.78",
    "name": "Unsichere Neubildung des Darmes",
    "synonyms": [
      "Analsphinktertumor",
      "Analtumor",
      "Darmgeschwulst",
      "Darmneoplasie",
      "Darmtumor",
      "Gastrinom",
      "Geschwulst des Analkanals",
      "Geschwulst des Anus",
      "Intestinaler Tumor",
      "Milztumor",
      "Neoplasie des Analkanals",
      "Neoplasie des Anus",
      "Tumor des Analkanals",
      "Tumor des Anus",
      "Unsichere Neubildung der Hämorrhoidalzone",
      "Unsichere Neubildung der Kloake",
      "Unsichere Neubildung der Milz a.n.k.",
      "Unsichere Neubildung der Morgagni-Krypten",
      "Unsichere Neubildung der Pars abdominalis des Ösophagus",
      "Unsichere Neubildung der Pars cervicalis des Ösophagus",
      "Unsichere Neubildung der Pars thoracica des Ösophagus",
      "Unsichere Neubildung der Speiseröhre",
      "Unsichere Neubildung des Analkanals",
      "Unsichere Neubildung des Analsphinkters",
      "Unsichere Neubildung des Anorektums",
      "Unsichere Neubildung des Anus",
      "Unsichere Neubildung des Canalis analis",
      "Unsichere Neubildung des Darmes",
      "Unsichere Neubildung des Darmtraktes a.n.k.",
      "Unsichere Neubildung des Santorini-Ganges",
      "Unsichere Neubildung des Sphincter ani",
      "Unsichere Neubildung des anorektalen Überganges",
      "Unsichere Neubildung des Ösophagus",
      "Unsichere neuroendokrine Neubildung des Analkanals",
      "Zystischer papillärer Tumor",
      "Ösophagusgeschwulst",
      "Ösophagusneoplasie",
      "Ösophagustumor"
    ]
  },
  {
    "code": "D37.9",
    "name": "Geschwulst der Verdauungsorgane",
    "synonyms": [
      "Geschwulst der Verdauungsorgane",
      "Neoplasie der Verdauungsorgane",
      "Tumor der Verdauungsorgane",
      "Unsichere Neubildung der Verdauungsorgane",
      "Unsichere Neubildung der Verdauungswege a.n.k.",
      "Unsichere Neubildung des Gastrointestinaltraktes a.n.k.",
      "Unsichere Neubildung des Verdauungssystems a.n.k."
    ]
  },
  {
    "code": "D38.0",
    "name": "Unsichere Neubildung des Kehlkopfes",
    "synonyms": [
      "Kehlkopfneoplasie",
      "Larynxgeschwulst",
      "Larynxneoplasie",
      "Larynxtumor",
      "Subglottische unsichere Neubildung",
      "Supraglottische unsichere Neubildung",
      "Unsichere Neubildung der Cartilago arytaenoidea",
      "Unsichere Neubildung der Epiglottis",
      "Unsichere Neubildung der Glottis",
      "Unsichere Neubildung der Kehlkopfkommissur",
      "Unsichere Neubildung der Larynxkommissur a.n.k.",
      "Unsichere Neubildung der Plica ventricularis laryngis",
      "Unsichere Neubildung der Stimmbänder",
      "Unsichere Neubildung der falschen Stimmbänder",
      "Unsichere Neubildung der hinteren Oberfläche der Epiglottis",
      "Unsichere Neubildung der laryngealen Seite der Plica aryepiglottica",
      "Unsichere Neubildung der laryngealen Seite der aryepiglottischen Falte",
      "Unsichere Neubildung der suprahyoidalen Epiglottis",
      "Unsichere Neubildung des Aryknorpels",
      "Unsichere Neubildung des Epiglottisknorpels",
      "Unsichere Neubildung des Gießbeckenknorpels",
      "Unsichere Neubildung des Kegelknorpels",
      "Unsichere Neubildung des Kehlkopfes",
      "Unsichere Neubildung des Kehlkopfknorpels",
      "Unsichere Neubildung des Larynx",
      "Unsichere Neubildung des Larynxknorpels",
      "Unsichere Neubildung des Ligamentum vestibulare",
      "Unsichere Neubildung des Ligamentum vocale",
      "Unsichere Neubildung des Ringknorpels",
      "Unsichere Neubildung des Schildknorpels",
      "Unsichere Neubildung des Stellknorpels",
      "Unsichere Neubildung des inneren Larynx a.n.k.",
      "Unsichere Neubildung des suprahyoidalen Anteils der Epiglottis",
      "Unsichere Neubildung des äußeren Larynx a.n.k.",
      "Unsichere neuroendokrine Neubildung des Larynx"
    ]
  },
  {
    "code": "D38.1",
    "name": "Unsichere Neubildung der Lunge",
    "synonyms": [
      "Bronchialadenom",
      "Bronchialneoplasma",
      "Bronchiogene unsichere Neubildung",
      "Bronchoalveolärer intravaskulärer Tumor",
      "Bronchusadenom",
      "Bronchusgeschwulst",
      "Bronchusmischtumor",
      "Bronchusneoplasie",
      "Bronchustumor",
      "Geschwulst der Lunge",
      "Geschwulst der Trachea",
      "Lungenadenom",
      "Lungenteratom",
      "Lungentumor",
      "Lymphangioleiomyomatose der Lunge",
      "Neoplasie der Lunge",
      "Neoplasie der Trachea",
      "Pulmonale Adenomatose",
      "Pulmonale unsichere Neubildung",
      "Subpleurale unsichere Neubildung",
      "Trachealtumor",
      "Tracheobronchiale unsichere Neubildung",
      "Tumor der Trachea",
      "Unsichere Neubildung der Bronchien",
      "Unsichere Neubildung der Carina tracheae",
      "Unsichere Neubildung der Lingula pulmonis sinistri",
      "Unsichere Neubildung der Luftröhre",
      "Unsichere Neubildung der Lunge",
      "Unsichere Neubildung der Trachea",
      "Unsichere Neubildung des Bronchialknorpels",
      "Unsichere Neubildung des Hilus pulmonis",
      "Unsichere Neubildung des Lobus inferior pulmonis",
      "Unsichere Neubildung des Lobus lingualis pulmonis",
      "Unsichere Neubildung des Lobus medius pulmonis",
      "Unsichere Neubildung des Lobus superior pulmonis",
      "Unsichere Neubildung des Lobus venae azygos",
      "Unsichere Neubildung des Luftröhrenknorpels",
      "Unsichere Neubildung des Lungenhilus",
      "Unsichere Neubildung des Lungenmittellappens",
      "Unsichere Neubildung des Lungenoberlappens",
      "Unsichere Neubildung des Lungenunterlappens",
      "Unsichere Neubildung einer Bronchiole",
      "Unsichere Neubildung eines Hauptbronchus"
    ]
  },
  {
    "code": "D38.2",
    "name": "Unsichere Neubildung des Brustfells",
    "synonyms": [
      "Unsichere Neubildung der Pleura",
      "Unsichere Neubildung der Pleura parietalis",
      "Unsichere Neubildung der Pleura pulmonalis",
      "Unsichere Neubildung des Brustfells"
    ]
  },
  {
    "code": "D38.3",
    "name": "Unsichere Neubildung des Mediastinums",
    "synonyms": [
      "Mediastinaltumor",
      "Substernale unsichere Neubildung",
      "Unsichere Neubildung des Mediastinums",
      "Unsichere Neubildung des anterioren Mediastinums",
      "Unsichere Neubildung des posterioren Mediastinums"
    ]
  },
  {
    "code": "D38.4",
    "name": "Unsichere Neubildung des Thymus",
    "synonyms": [
      "Thymustumor",
      "Unsichere Neubildung des Thymus"
    ]
  },
  {
    "code": "D38.5",
    "name": "Unsichere Neubildung des Mittelohres",
    "synonyms": [
      "Unsichere Neubildung der Conchae nasales",
      "Unsichere Neubildung der Eustachi-Röhre",
      "Unsichere Neubildung der Fossa nasalis",
      "Unsichere Neubildung der Keilbeinhöhle",
      "Unsichere Neubildung der Kieferhöhle",
      "Unsichere Neubildung der Mastoidzellen",
      "Unsichere Neubildung der Nares",
      "Unsichere Neubildung der Nasenhöhle",
      "Unsichere Neubildung der Nasennebenhöhlen",
      "Unsichere Neubildung der Nasenschleimhaut",
      "Unsichere Neubildung der Nebenhöhle",
      "Unsichere Neubildung der Oberkieferhöhle",
      "Unsichere Neubildung der Oberkiefernebenhöhle",
      "Unsichere Neubildung der Paukenhöhle",
      "Unsichere Neubildung der Schleimhaut der Nasenmuschel",
      "Unsichere Neubildung der Sinus paranasales a.n.k.",
      "Unsichere Neubildung der Stirnhöhle",
      "Unsichere Neubildung der Tuba auditiva",
      "Unsichere Neubildung der inneren Nase",
      "Unsichere Neubildung des Antrum Highmore",
      "Unsichere Neubildung des Antrum maxillaris",
      "Unsichere Neubildung des Antrum tympanicum",
      "Unsichere Neubildung des Cavum tympani",
      "Unsichere Neubildung des Innenohres",
      "Unsichere Neubildung des Mittelohres",
      "Unsichere Neubildung des Nasenknorpels",
      "Unsichere Neubildung des Nasenseptums",
      "Unsichere Neubildung des Nasenvorhofes",
      "Unsichere Neubildung des Oberkiefersinus",
      "Unsichere Neubildung des Siebbeins",
      "Unsichere Neubildung des Sinus ethmoidalis",
      "Unsichere Neubildung des Sinus frontalis",
      "Unsichere Neubildung des Sinus maxillaris",
      "Unsichere Neubildung des Sinus sphenoidalis",
      "Unsichere Neubildung des Vestibulum nasi",
      "Unsichere Neubildung des inneren Gehörganges",
      "Unsichere Neubildung des inneren Teils der Nase",
      "Unsichere neuroendokrine Neubildung des Mittelohrs"
    ]
  },
  {
    "code": "D38.6",
    "name": "Unsichere Neubildung der Atmungsorgane",
    "synonyms": [
      "Geschwulst der Atmungsorgane",
      "Neoplasie der Atmungsorgane",
      "Tumor der Atmungsorgane",
      "Unsichere Neubildung der Atemwege a.n.k.",
      "Unsichere Neubildung der Atmungsorgane",
      "Unsichere Neubildung der Respirationsorgane a.n.k.",
      "Unsichere Neubildung der oberen Atemwege a.n.k.",
      "Unsichere Neubildung des Atemsystems a.n.k.",
      "Unsichere Neubildung des Respirationssystems a.n.k.",
      "Unsichere Neubildung des Respirationstraktes a.n.k."
    ]
  },
  {
    "code": "D39.0",
    "name": "Stromaendometriose",
    "synonyms": [
      "Endolymphatische Stromamyose",
      "Endolymphatische stromale Myose",
      "Endometriale Stromatose",
      "Endozervikale unsichere Neubildung",
      "Neoplasie der Cervix uteri",
      "Neoplasie des Corpus uteri",
      "Stromaendometriose",
      "Stromale Endometriose",
      "Stromale Myose",
      "Unsichere Neubildung der Cervix uteri",
      "Unsichere Neubildung der Ektozervix",
      "Unsichere Neubildung der Endozervix",
      "Unsichere Neubildung der Ovula Nabothi",
      "Unsichere Neubildung der Zervix",
      "Unsichere Neubildung des Corpus uteri",
      "Unsichere Neubildung des Endometriums",
      "Unsichere Neubildung des Endometriumstromas",
      "Unsichere Neubildung des Fundus des Uterus",
      "Unsichere Neubildung des Fundus uteri",
      "Unsichere Neubildung des Isthmus des Uterus",
      "Unsichere Neubildung des Isthmus uteri",
      "Unsichere Neubildung des Kanals der Cervix uteri",
      "Unsichere Neubildung des Myometriums",
      "Unsichere Neubildung des Stumpfes der Cervix uteri",
      "Unsichere Neubildung des Uterus",
      "Unsichere Neubildung des Uterushorns",
      "Unsichere Neubildung des Uteruskörpers",
      "Unsichere Neubildung des Zervikalkanals",
      "Unsichere Neubildung des Zervixstumpfes",
      "Unsichere Neubildung des Zervixüberganges zur Vagina",
      "Unsichere Neubildung des inneren Muttermundes",
      "Unsichere Neubildung des innerer Muttermundes",
      "Unsichere Neubildung des unteres Segmentes des Uterus",
      "Unsichere Neubildung des Überganges der Cervix uteri zur Vagina",
      "Unsichere Neubildung des Überganges zwischen Zervix und Vagina",
      "Unsichere Neubildung des äußeren Muttermundes",
      "Uterusgeschwulst",
      "Uterusneoplasie",
      "Uterustumor",
      "Zervixneoplasie"
    ]
  },
  {
    "code": "D39.1",
    "name": "Unsichere Neubildung des Ovars",
    "synonyms": [
      "Androblastom bei der Frau",
      "Endometrioides Adenofibrom mit Borderline-Malignität",
      "Endometrioides Zystadenofibrom mit Borderline-Malignität",
      "Follikulom",
      "Geschwulst des Ovars",
      "Gonadoblastom bei der Frau",
      "Gonozytom bei der Frau",
      "Gynandroblastom bei der Frau",
      "Juveniler Granulosazell-Tumor",
      "Karzinoid mit Struma ovarii",
      "Keimstrangtumor mit anulären Tubuli",
      "Multilokuläre Ovarialzyste",
      "Neoplasie des Ovars",
      "Ovarialtumor",
      "Partiell maligner Brenner-Tumor",
      "Proliferierender Brenner-Tumor",
      "Pseudo-Meigs-Syndrom",
      "Strumakarzinoid des Ovars",
      "Theka-Granulosazell-Tumor",
      "Unsichere Neubildung des Ovars",
      "Zwischenzelltumor bei der Frau",
      "Zystischer Ovarialtumor"
    ]
  },
  {
    "code": "D39.2",
    "name": "Unsichere Neubildung der Plazenta",
    "synonyms": [
      "Bösartige Blasenmole",
      "Chorioadenoma",
      "Chorioadenoma destruens",
      "Chorionadenom",
      "Chorionadenoma",
      "Chorionadenoma destruens",
      "Chorionepitheliose",
      "Chorionepitheliosis interna",
      "Destruierende Blasenmole",
      "Destruierende Mole",
      "Destruierendes Chorionadenom",
      "Epitheloider Trophoblasttumor",
      "Invasive Blasenmole",
      "Invasive Mole",
      "Invasive hydatidiforme Mole",
      "Maligne Blasenmole",
      "Maligne hydatidiforme Mole",
      "Mola destruens",
      "Mola hydatidosa accreta",
      "Mola hydatidosa intravenosa",
      "Mola maligna",
      "Plazentabetttumor",
      "Plazentarer Trophoblasttumor",
      "Plazentatumor",
      "Trophoblastischer Tumor mit plazentarem Sitz",
      "Trophoblasttumor",
      "Unsichere Neubildung der Plazenta"
    ]
  },
  {
    "code": "D39.7",
    "name": "Unsichere Neubildung des Parametriums",
    "synonyms": [
      "Adnextumor",
      "Bartholin-Tumor",
      "Klitoristumor",
      "Labienneoplasma",
      "Labientumor",
      "Nichtmelanomartige unsichere Neubildung der Haut der Labia majora pudendi",
      "Nichtmelanomartige unsichere Neubildung der Haut der Labia minora pudendi",
      "Nichtmelanomartige unsichere Neubildung der Haut der Labien",
      "Nichtmelanomartige unsichere Neubildung der Haut der Pudenda feminae",
      "Nichtmelanomartige unsichere Neubildung der Haut der weiblichen Geschlechtsorgane",
      "Nichtmelanomartige unsichere Neubildung der Klitorishaut",
      "Nichtmelanomartige unsichere Neubildung der Vulvahaut",
      "Parametriumtumor",
      "Tuba-uterina-Tumor",
      "Tuboovariale unsichere Neubildung",
      "Tuboovarialtumor",
      "Unsichere Neubildung der Bartholin-Drüse",
      "Unsichere Neubildung der Glandula vestibularis major",
      "Unsichere Neubildung der Klitoris",
      "Unsichere Neubildung der Labia majora pudendi",
      "Unsichere Neubildung der Labia minora pudendi",
      "Unsichere Neubildung der Labien",
      "Unsichere Neubildung der Ligamenta sacrouterina",
      "Unsichere Neubildung der Ligamenta uteri",
      "Unsichere Neubildung der Mesosalpinx",
      "Unsichere Neubildung der Pudenda feminae",
      "Unsichere Neubildung der Salpinx",
      "Unsichere Neubildung der Scheide",
      "Unsichere Neubildung der Tuba uterina",
      "Unsichere Neubildung der Tuben",
      "Unsichere Neubildung der Uterusadnexe",
      "Unsichere Neubildung der Uterusligamente",
      "Unsichere Neubildung der Vagina",
      "Unsichere Neubildung der Vulva",
      "Unsichere Neubildung der Vulvahaut",
      "Unsichere Neubildung der uteroovarialen Bänder",
      "Unsichere Neubildung der uterosakralen Bänder",
      "Unsichere Neubildung der uterosakralen Ligamente",
      "Unsichere Neubildung der vulvovaginalen Drüsen",
      "Unsichere Neubildung des Eileiters",
      "Unsichere Neubildung des Fornix vaginae",
      "Unsichere Neubildung des Frenulum labiorum pudendi",
      "Unsichere Neubildung des Gartner-Ganges",
      "Unsichere Neubildung des Hymens",
      "Unsichere Neubildung des Ligamentum latum uteri",
      "Unsichere Neubildung des Ligamentum ovarii proprium",
      "Unsichere Neubildung des Ligamentum rotundum",
      "Unsichere Neubildung des Ligamentum teres uteri",
      "Unsichere Neubildung des Mesovariums",
      "Unsichere Neubildung des Mons pubis",
      "Unsichere Neubildung des Mons veneris",
      "Unsichere Neubildung des Müller-Ganges bei der Frau",
      "Unsichere Neubildung des Oviduktes",
      "Unsichere Neubildung des Parametriums",
      "Unsichere Neubildung des Parovariums",
      "Unsichere Neubildung des Septum urethrovaginale",
      "Unsichere Neubildung des Septum vesikovaginale",
      "Unsichere Neubildung des Wolff-Ganges bei der Frau",
      "Unsichere Neubildung des urethrovaginalen Septums",
      "Unsichere Neubildung des vaginovesikalen Septums",
      "Unsichere Neubildung des vesikovaginalen Septums",
      "Uteroovariale unsichere Neubildung",
      "Vaginaltumor",
      "Vulvaknoten",
      "Vulvaneoplasma",
      "Vulvatumor"
    ]
  },
  {
    "code": "D39.9",
    "name": "Teratom der weiblichen Geschlechtsorgane",
    "synonyms": [
      "Teratom der weiblichen Geschlechtsorgane",
      "Unsichere Neubildung der weiblichen Geschlechtsorgane",
      "Unsichere Neubildung der weiblichen Harnorgane",
      "Unsichere Neubildung des vesikozervikalen Gewebes",
      "Unsichere Neubildung des weiblichen Urogenitaltraktes",
      "Vaginovesikale unsichere Neubildung",
      "Vesikovaginale unsichere Neubildung"
    ]
  },
  {
    "code": "D40.0",
    "name": "Adenomyomatose der Prostata",
    "synonyms": [
      "Adenomyomatose der Prostata",
      "Adenoneoplasma der Prostata",
      "Knotige Veränderung der Prostata",
      "Paraprostatische Knötchen",
      "Phylloidtumor der Prostata",
      "Prostatageschwulst",
      "Prostataknoten",
      "Prostatamittellappentumor",
      "Prostataneoplasie",
      "Prostataneoplasma-Rezidiv",
      "Prostataseitenlappentumor",
      "Prostatatumor",
      "Unsichere Neubildung der Prostata"
    ]
  },
  {
    "code": "D40.1",
    "name": "Neoplasie des Hodens",
    "synonyms": [
      "Androblastom beim Mann",
      "Gonadoblastom beim Mann",
      "Gonozytom beim Mann",
      "Gynandroblastom beim Mann",
      "Hodengeschwulst",
      "Hodenknoten",
      "Hodenmischtumor",
      "Hodentumor",
      "Knotige Schwellung des Hodens",
      "Neoplasie des Hodens",
      "Testikulärer stromaler Tumor",
      "Testistumor",
      "Unsichere Neubildung des Hodens",
      "Unsichere Neubildung eines deszendierten Hodens",
      "Unsichere Neubildung eines ektopischen Hodens",
      "Unsichere Neubildung eines nichtdeszendierten Hodens",
      "Unsichere Neubildung eines retinierten Hodens",
      "Unsichere Neubildung eines skrotalen Hodens",
      "Unsicheres Hodenteratom",
      "Zwischenzelltumor beim Mann"
    ]
  },
  {
    "code": "D40.7",
    "name": "Unsichere Neubildung des Nebenhodens",
    "synonyms": [
      "Knotige Veränderung der Nebenhoden",
      "Knotiger Prozess der Nebenhoden",
      "Nebenhodengeschwulst",
      "Nebenhodenknoten",
      "Nebenhodenkopftumor",
      "Nebenhodenneoplasie",
      "Nebenhodentumor",
      "Nichtmelanomartige unsichere Neubildung der Haut des Präputiums",
      "Nichtmelanomartige unsichere Neubildung der Penishaut a.n.k.",
      "Nichtmelanomartige unsichere Neubildung der Präputialhaut",
      "Nichtmelanomartige unsichere Neubildung der Skrotalhaut",
      "Penisgeschwulst",
      "Penisneoplasma",
      "Penistumor",
      "Samenblasengeschwulst",
      "Samenblasenneoplasie",
      "Samenblasentumor",
      "Samenstrangtumor",
      "Tumor des Funiculus spermaticus",
      "Unsichere Neubildung der Epididymis",
      "Unsichere Neubildung der Glans penis",
      "Unsichere Neubildung der Penishaut",
      "Unsichere Neubildung der Samenblase",
      "Unsichere Neubildung der Skrotumhaut",
      "Unsichere Neubildung der Tunica vaginalis testis",
      "Unsichere Neubildung der Vesicula seminalis",
      "Unsichere Neubildung der Vorhaut",
      "Unsichere Neubildung des Corpus cavernosum",
      "Unsichere Neubildung des Ductus deferens",
      "Unsichere Neubildung des Ductus ejaculatorius",
      "Unsichere Neubildung des Müller-Ganges beim Mann",
      "Unsichere Neubildung des Nebenhodens",
      "Unsichere Neubildung des Penis",
      "Unsichere Neubildung des Präputiums",
      "Unsichere Neubildung des Samenstranges",
      "Unsichere Neubildung des Skrotums",
      "Unsichere Neubildung des Vas deferens",
      "Unsichere Neubildung des Wolff-Ganges beim Mann",
      "Unsichere Neubildung des männlichen Gliedes"
    ]
  },
  {
    "code": "D40.9",
    "name": "Unsichere Neubildung der männlichen Geschlechtsorgane",
    "synonyms": [
      "Nichtmelanomartige unsichere Neubildung der Haut der männlichen Geschlechtsorgane",
      "Unsichere Neubildung der männlichen Geschlechtsorgane",
      "Unsichere Neubildung des männlichen Urogenitaltraktes"
    ]
  },
  {
    "code": "D41.0",
    "name": "Nierenneoplasie",
    "synonyms": [
      "Juxtaglomerulärer Tumor",
      "Kongenitales mesoblastisches Nephrom",
      "Mesoblastisches Nephrom",
      "Neoplastischer Prozess der Niere",
      "Nierenneoplasie",
      "Nierenparenchymtumor",
      "Nierenpoltumor",
      "Nierentumor",
      "Raumforderung der Niere",
      "Raumforderung des Nierenpols",
      "Renale unsichere Neubildung",
      "Reninom",
      "Unsichere Neubildung der Niere",
      "Unsichere Neubildung des Nierenparenchyms",
      "Zystischer Nierentumor"
    ]
  },
  {
    "code": "D41.1",
    "name": "Unsichere Neubildung des Nierenbeckens",
    "synonyms": [
      "Nierenbeckenpapillom",
      "Nierenbeckentumor",
      "Papillom der Übergangszellen des Nierenbeckens",
      "Raumforderung des Nierenbeckens",
      "Transitionalzellpapillom des Nierenbeckens",
      "Unsichere Neubildung der Nierenkelche",
      "Unsichere Neubildung des Nierenbeckens",
      "Unsichere Neubildung des Nierenhilus",
      "Unsichere Neubildung des Überganges zwischen Nierenbecken und Harnleiter"
    ]
  },
  {
    "code": "D41.2",
    "name": "Unsichere Neubildung des Ureters",
    "synonyms": [
      "Harnleitertumor",
      "Tumoröse Ureterummauerung",
      "Unsichere Neubildung des Harnleiters",
      "Unsichere Neubildung des Ureters",
      "Ureterpapillom",
      "Uretertumor",
      "Übergangszellpapillom des Ureters"
    ]
  },
  {
    "code": "D41.3",
    "name": "Polyp der prostatischen Harnröhre im Sinne einer Neubildung",
    "synonyms": [
      "Endourethrale Polyposis im Sinne einer Neubildung",
      "Harnröhrenpolyp im Sinne einer Neubildung",
      "Harnröhrentumor",
      "Neoplasma der Harnröhre",
      "Neoplasma der Urethra",
      "Polyp der Pars prostatica der Urethra im Sinne einer Neubildung",
      "Polyp der prostatischen Harnröhre im Sinne einer Neubildung",
      "Polyp der prostatischen Urethra im Sinne einer Neubildung",
      "Transurethraler Tumor",
      "Unsichere Neubildung der Bulbourethraldrüsen",
      "Unsichere Neubildung der Cowper-Drüsen",
      "Unsichere Neubildung der Harnröhre",
      "Unsichere Neubildung der Urethra",
      "Unsichere Neubildung des Utriculus prostaticus",
      "Urethralpolyp im Sinne einer Neubildung",
      "Urethratumor"
    ]
  },
  {
    "code": "D41.4",
    "name": "Neoplasma der Blase",
    "synonyms": [
      "Blasenhalspolyp",
      "Blasenhalstumor",
      "Blasenpapillom",
      "Blasenpapillomatose",
      "Blasenpolyp",
      "Blasenschleimhautpolyp",
      "Blasensphinkterpolyp",
      "Blasentumor",
      "Blasenwandtumor",
      "Geschwulst der Harnblase",
      "Harnblasenausgangspolyp",
      "Harnblasenhalspolyp",
      "Harnblasenpapillom",
      "Harnblasenpapillomatose",
      "Harnblasenpolyp",
      "Harnblasenschleimhautpolyp",
      "Harnblasenseitenwandtumor",
      "Harnblasentumor",
      "Harnblasenwandtumor",
      "Neoplasie der Harnblase",
      "Neoplasma der Blase",
      "Papillom der Blasenvorderwand",
      "Papillom der Blasenwand",
      "Papillom der Harnblasenvorderwand",
      "Papillom der Harnblasenwand",
      "Papillom der Übergangszellen der Harnblase",
      "Papillomatöser Tumor der Blase",
      "Papillomatöser Tumor der Harnblase",
      "Polyp des Harnblasensphinkterbereiches",
      "Raumforderung im Blasenbereich",
      "Rezidivierendes Blasenpapillom",
      "Transitionalzellpapillom der Harnblase",
      "Tumor des Harnblasenhalses",
      "Unsichere Neubildung der Harnblase",
      "Unsichere Neubildung der Harnblasenwand",
      "Unsichere Neubildung der Harnblasenöffnung",
      "Unsichere Neubildung der Uretermündung",
      "Unsichere Neubildung der inneren Mündung der Urethra",
      "Unsichere Neubildung des Harnblasenhalses",
      "Unsichere Neubildung des Harnblasenostiums",
      "Unsichere Neubildung des Harnblasenscheitels",
      "Unsichere Neubildung des Harnblasensphinkters",
      "Unsichere Neubildung des Ostium ureteris",
      "Unsichere Neubildung des Ostium urethrae internum",
      "Unsichere Neubildung des Trigonum vesicae",
      "Unsichere Neubildung des Urachus",
      "Urachustumor",
      "Übergangszellpapillom der Harnblase"
    ]
  },
  {
    "code": "D41.7",
    "name": "Unsichere Neubildung einer paraurethralen Drüse",
    "synonyms": [
      "Unsichere Neubildung der Skene-Drüse",
      "Unsichere Neubildung einer paraurethralen Drüse"
    ]
  },
  {
    "code": "D41.9",
    "name": "Unsichere Neubildung der Harnorgane",
    "synonyms": [
      "Papillomatöse Urothelwucherung",
      "Papillomatöser Urotheltumor",
      "Tumor der Harnorgane",
      "Unsichere Neubildung der Harnorgane",
      "Unsichere Neubildung der Harnwege a.n.k.",
      "Unsichere Neubildung der männlichen Harnorgane",
      "Unsichere Urothelneubildung",
      "Urothelneoplasie",
      "Urothelpapillom",
      "Urotheltumor"
    ]
  },
  {
    "code": "D42.0",
    "name": "Unsichere Neubildung der Arachnoidea cerebralis",
    "synonyms": [
      "Unsichere Neubildung der Arachnoidea cerebralis",
      "Unsichere Neubildung der Dura mater cranialis",
      "Unsichere Neubildung der Dura mater encephali",
      "Unsichere Neubildung der Falx cerebelli",
      "Unsichere Neubildung der Falx cerebri",
      "Unsichere Neubildung der Gehirnmeningen",
      "Unsichere Neubildung der Hirnhaut a.n.k.",
      "Unsichere Neubildung der intrakraniellen Meningen",
      "Unsichere Neubildung der kranialen Pia mater",
      "Unsichere Neubildung der kraniellen Meningen",
      "Unsichere Neubildung der zerebralen Meningen",
      "Unsichere Neubildung der zerebralen Pia mater",
      "Unsichere Neubildung des Tentorium cerebelli"
    ]
  },
  {
    "code": "D42.1",
    "name": "Unsichere Neubildung der Arachnoidea spinalis",
    "synonyms": [
      "Unsichere Neubildung der Arachnoidea spinalis",
      "Unsichere Neubildung der Dura mater der Wirbelsäule",
      "Unsichere Neubildung der Dura mater spinalis",
      "Unsichere Neubildung der Pia mater der Wirbelsäule",
      "Unsichere Neubildung der Rückenmarkhäute",
      "Unsichere Neubildung der Rückenmarkmeningen",
      "Unsichere Neubildung der spinalen Meningen",
      "Unsichere Neubildung der spinalen Pia mater"
    ]
  },
  {
    "code": "D42.9",
    "name": "Unsichere Neubildung der Meningen",
    "synonyms": [
      "Diffuse Meningeomatose - s.a. Neubildung, Meningen, unsicheres Verhalten",
      "Diffuse leptomeningeale Melanozytose",
      "Meningeales Melanozytom",
      "Meningeomatose - s.a. Neubildung, Meningen, unsicheres Verhalten",
      "Multiple Meningeome",
      "Papilläres Meningeom",
      "Subdurale unsichere Neubildung",
      "Unsichere Neubildung der Arachnoidea",
      "Unsichere Neubildung der Dura mater",
      "Unsichere Neubildung der Meningen",
      "Unsichere Neubildung der Pia mater"
    ]
  },
  {
    "code": "D43.0",
    "name": "Unsichere Neubildung des Thalamus",
    "synonyms": [
      "Frontalhirntumor",
      "Supratentorielle unsichere Neubildung a.n.k.",
      "Unsichere Neubildung der Basalganglien",
      "Unsichere Neubildung der Capsula interna",
      "Unsichere Neubildung der Großhirnhemisphäre",
      "Unsichere Neubildung der Großhirnrinde",
      "Unsichere Neubildung der Hirnventrikel",
      "Unsichere Neubildung der Insula",
      "Unsichere Neubildung der Reil-Insel",
      "Unsichere Neubildung der inneren Kapsel",
      "Unsichere Neubildung der weißen Hirnsubstanz",
      "Unsichere Neubildung des Corpus striatum",
      "Unsichere Neubildung des Ependyms im Gehirn",
      "Unsichere Neubildung des Frontalhirns a.n.k.",
      "Unsichere Neubildung des Globus pallidus",
      "Unsichere Neubildung des Hippocampus",
      "Unsichere Neubildung des Hypothalamus",
      "Unsichere Neubildung des Lobus frontalis",
      "Unsichere Neubildung des Lobus occipitalis",
      "Unsichere Neubildung des Lobus parietalis",
      "Unsichere Neubildung des Lobus temporalis",
      "Unsichere Neubildung des Okzipitallappens des Gehirns a.n.k.",
      "Unsichere Neubildung des Operculum",
      "Unsichere Neubildung des Palliums",
      "Unsichere Neubildung des Parietallappens des Gehirns a.n.k.",
      "Unsichere Neubildung des Plexus chorioideus",
      "Unsichere Neubildung des Polus frontalis cerebri",
      "Unsichere Neubildung des Polus occipitalis cerebri",
      "Unsichere Neubildung des Putamens",
      "Unsichere Neubildung des Rhinenzephalons",
      "Unsichere Neubildung des Scheitellappens des Gehirns",
      "Unsichere Neubildung des Stirnlappens des Gehirns",
      "Unsichere Neubildung des Temporallappens des Gehirns a.n.k.",
      "Unsichere Neubildung des Thalamus",
      "Unsichere Neubildung des Uncus",
      "Unsichere Neubildung des Zerebrums",
      "Unsichere Neubildung eines basalen Ganglions",
      "Zentrales Neurozytom"
    ]
  },
  {
    "code": "D43.1",
    "name": "Kleinhirnbrückenwinkeltumor",
    "synonyms": [
      "Hirnstammtumor",
      "Kleinhirnbrückenwinkelchordom",
      "Kleinhirnbrückenwinkeltumor",
      "Unsichere Neubildung der Gehirnolive",
      "Unsichere Neubildung der Medulla oblongata",
      "Unsichere Neubildung der Pyramide",
      "Unsichere Neubildung des Hirnstamms",
      "Unsichere Neubildung des Kleinhirnbrückenwinkels",
      "Unsichere Neubildung des Kleinhirns",
      "Unsichere Neubildung des Kleinhirnwurms",
      "Unsichere Neubildung des Mittelhirns",
      "Unsichere Neubildung des Pedunculus",
      "Unsichere Neubildung des Pedunculus cerebri",
      "Unsichere Neubildung des Plexus chorioideus des vierten Ventrikels",
      "Unsichere Neubildung des Pons Varoli",
      "Unsichere Neubildung des Vermis cerebelli",
      "Unsichere Neubildung des Zerebellums",
      "Unsichere Neubildung des vierten Ventrikels",
      "Zerebelläres Liponeurozytom"
    ]
  },
  {
    "code": "D43.2",
    "name": "Unsichere Neubildung des Gehirns",
    "synonyms": [
      "Extraventrikuläres Neurozytom",
      "Gangliogliom",
      "Gehirntumor",
      "Geschwulst des Gehirns",
      "Hirntumor",
      "Intrakranielle multiple Tumore",
      "Intrakranielle unsichere Neubildung a.n.k.",
      "Kraniale unsichere Neubildung",
      "Myxopapilläres Ependymom",
      "Neoplasie des Gehirns",
      "Niedriggradiges Ependymom",
      "Papillärer glioneuronaler Tumor",
      "Papilläres Ependymom",
      "Rosettenbildender glioneuronaler Tumor",
      "Subependymales Astrozytom",
      "Subependymales Riesenzellastrozytom",
      "Subependymalgliom",
      "Subependymom",
      "Supraselläre unsichere Neubildung",
      "Unsichere Neubildung des Corpus callosum",
      "Unsichere Neubildung des Gehirns",
      "Unsichere Neubildung des Tapetum cerebri",
      "Unsichere Neubildung in der Fossa cranii",
      "Unsichere Neubildung in der hinteren Schädelgrube",
      "Unsichere zerebrale Neubildung"
    ]
  },
  {
    "code": "D43.3",
    "name": "Tumor des Tractus opticus",
    "synonyms": [
      "Tumor des Tractus opticus",
      "Unsichere Neubildung der Hirnnerven a.n.k.",
      "Unsichere Neubildung der Nervi craniales a.n.k.",
      "Unsichere Neubildung der Nervi olfactorii",
      "Unsichere Neubildung der Pars cochlearis des Nervus vestibulocochlearis",
      "Unsichere Neubildung des Chiasma opticum",
      "Unsichere Neubildung des Gehörnerven",
      "Unsichere Neubildung des Nervus abducens",
      "Unsichere Neubildung des Nervus acusticus",
      "Unsichere Neubildung des Nervus facialis",
      "Unsichere Neubildung des Nervus glossopharyngeus",
      "Unsichere Neubildung des Nervus hypoglossus",
      "Unsichere Neubildung des Nervus oculomotorius",
      "Unsichere Neubildung des Nervus opticus",
      "Unsichere Neubildung des Nervus trigeminus",
      "Unsichere Neubildung des Nervus trochlearis",
      "Unsichere Neubildung des Nervus vagus",
      "Unsichere Neubildung des Nervus vestibulocochlearis",
      "Unsichere Neubildung des Sehnerven",
      "Unsichere Neubildung des Sehtraktes",
      "Unsichere Neubildung des Tractus opticus",
      "Unsichere Neubildung des spinalen Nervus accessorius"
    ]
  },
  {
    "code": "D43.4",
    "name": "Unsichere Neubildung des Rückenmarks",
    "synonyms": [
      "Unsichere Neubildung der Cauda equina",
      "Unsichere Neubildung des Conus medullaris",
      "Unsichere Neubildung des Filum terminale",
      "Unsichere Neubildung des Rückenmarks"
    ]
  },
  {
    "code": "D43.9",
    "name": "Unsichere Neubildung des Zentralnervensystems",
    "synonyms": [
      "Paraselläre unsichere Neubildung",
      "Teratom des Zentralnervensystems",
      "Unsichere Neubildung des ZNS",
      "Unsichere Neubildung des Zentralnervensystems"
    ]
  },
  {
    "code": "D44.0",
    "name": "Unsichere Neubildung der Schilddrüse",
    "synonyms": [
      "Schilddrüsenneoplasie",
      "Schilddrüsenneoplasma",
      "Schilddrüsenteratom",
      "Schilddrüsentumor",
      "Thyreoideatumor",
      "Unsichere Neubildung der Schilddrüse",
      "Unsichere Neubildung der Thyreoidea",
      "Unsichere Neubildung des Ductus thyreoglossus"
    ]
  },
  {
    "code": "D44.1",
    "name": "Unsichere Neubildung der Nebenniere",
    "synonyms": [
      "Nebennierenraumforderung",
      "Nebennierentumor",
      "Parenchymtumor",
      "Tumor der Nebennierenrinde",
      "Tumor des Nebennierenmarks",
      "Tumoröse Nebennierenveränderung",
      "Tumoröser Nebennierenprozess",
      "Unsichere Neubildung der Medulla glandulae suprarenalis",
      "Unsichere Neubildung der Nebenniere",
      "Unsichere Neubildung der Nebennierenkapsel",
      "Unsichere Neubildung der Nebennierenrinde",
      "Unsichere Neubildung des Nebennierenmarks",
      "Unsichere Neubildung einer Nebennierendrüse",
      "Zystischer Nebennierentumor"
    ]
  },
  {
    "code": "D44.2",
    "name": "Unsichere Neubildung der Nebenschilddrüse",
    "synonyms": [
      "Unsichere Neubildung der Nebenschilddrüse",
      "Unsichere Neubildung der Parathyreoidea"
    ]
  },
  {
    "code": "D44.3",
    "name": "Unsichere Neubildung der Hypophyse",
    "synonyms": [
      "Hypophysengeschwulst",
      "Hypophysenneoplasie",
      "Hypophysenteratom",
      "Hypophysentumor",
      "Intraselläre unsichere Neubildung",
      "Pituizytom",
      "Tumor der Rathke-Tasche",
      "Unsichere Neubildung der Hypophyse",
      "Unsichere Neubildung der Rathke-Tasche",
      "Unsichere Neubildung des Hirnanhanges",
      "Unsichere Neubildung in der Fossa pituitaria"
    ]
  },
  {
    "code": "D44.4",
    "name": "Unsichere Neubildung des kraniopharyngealen Ganges",
    "synonyms": [
      "Craniopharyngioma",
      "Erdheim-Tumor",
      "Kraniopharyngeom",
      "Tumor des Hypophysenganges",
      "Unsichere Neubildung des Ductus craniopharyngealis",
      "Unsichere Neubildung des kraniopharyngealen Ganges"
    ]
  },
  {
    "code": "D44.5",
    "name": "Unsichere Neubildung der Zirbeldrüse",
    "synonyms": [
      "Papillärer Tumor der Pinealisregion",
      "Pinealisparenchymtumor intermediärer Differenzierung",
      "Pinealom",
      "Pinealozytom",
      "Pineozytom",
      "Unsichere Neubildung der Epiphyse",
      "Unsichere Neubildung der Zirbeldrüse",
      "Unsichere Neubildung des Corpus pineale"
    ]
  },
  {
    "code": "D44.6",
    "name": "Tumor des Glomus caroticum",
    "synonyms": [
      "Paragangliom des Glomus caroticum",
      "Tumor des Corpus caroticum",
      "Tumor des Glomus caroticum",
      "Unsichere Neubildung des Glomus caroticum"
    ]
  },
  {
    "code": "D44.7",
    "name": "Unsichere Neubildung der Paraganglien",
    "synonyms": [
      "Chemodektom",
      "Extraadrenales Paragangliom",
      "Juguläres Paragangliom",
      "Nicht-funktionelles Paragangliom",
      "Nichtadrenalinbildendes Paragangliom",
      "Nichtchromaffines Paragangliom",
      "Paragangliom",
      "Paragangliom des Glomus aorticum",
      "Paragangliom des Glomus jugulare",
      "Parasympathisches Paragangliom",
      "Sympathisches Paragangliom",
      "Tumor des Corpus aorticum",
      "Tumor des Glomus aorticum",
      "Tumor des Glomus jugulare",
      "Tumor des Glomus tympanicum",
      "Unsichere Neubildung der Paraganglien",
      "Unsichere Neubildung des Glomus jugulare",
      "Unsichere Neubildung des Glomus tympanicum",
      "Unsichere Neubildung des Paraganglion aorticum abdominale",
      "Unsichere Neubildung des Zuckerkandl-Organs"
    ]
  },
  {
    "code": "D44.8",
    "name": "Wermer-Syndrom",
    "synonyms": [
      "Carney-Stratakis-Syndrom",
      "Endokrines multiples Adenom-Syndrom",
      "MEN [Multiple endokrine Neoplasie] - s.a. Neoplasie, endokrin, multipel",
      "MEN [Multiple endokrine Neoplasie] Typ 1",
      "Multiple endokrine Adenomatosen",
      "Multiple endokrine Neoplasie Typ 1",
      "Multiple endokrine Neoplasie Typ 2",
      "Multiple endokrine Neoplasie Typ 4",
      "Multiple endokrine Neoplasien",
      "Pluriendokrine Adenomatose",
      "Pluriglanduläres Syndrom",
      "Polyglanduläre unsichere Neubildung",
      "Polyglanduläres Syndrom",
      "Unsichere Neubildung einer pluriglandulären endokrinen Drüse a.n.k.",
      "Unsichere Neubildung mehrerer endokriner Drüsen",
      "Wermer-Syndrom"
    ]
  },
  {
    "code": "D44.9",
    "name": "Unsichere Neubildung endokriner Drüsen",
    "synonyms": [
      "Apudom",
      "Tumor der endokrinen Drüsen",
      "Unsichere Neubildung endokriner Drüsen"
    ]
  },
  {
    "code": "D45",
    "name": "Plethora sanguinea",
    "synonyms": [
      "Chronische Erythrose",
      "Chronische Erythrose in kompletter Remission",
      "Chronische Erythrämie",
      "Chronische Erythrämie in kompletter Remission",
      "Heilmeyer-Schöner-Erythroblastose",
      "Heilmeyer-Schöner-Erythroblastose in kompletter Remission",
      "Heilmeyer-Schöner-Krankheit",
      "Heilmeyer-Schöner-Krankheit in kompletter Remission",
      "PV [Polycythaemia vera]",
      "Plethora sanguinea",
      "Plethora vera",
      "Polycythaemia",
      "Polycythaemia primaria",
      "Polycythaemia rubra vera",
      "Polycythaemia vera",
      "Vaquez-Osler-Krankheit",
      "Vaquez-Osler-Syndrom"
    ]
  },
  {
    "code": "D46.0",
    "name": "Refraktäre Anämie ohne Sideroblasten",
    "synonyms": [
      "Refraktäre Anämie ohne Blastenvermehrung",
      "Refraktäre Anämie ohne Ringsideroblasten",
      "Refraktäre Anämie ohne Sideroblasten"
    ]
  },
  {
    "code": "D46.1",
    "name": "Refraktäre Anämie mit Ringsideroblasten",
    "synonyms": [
      "Refraktäre Anämie mit Ringsideroblasten",
      "Refraktärer Anämie bei Hämochromatose"
    ]
  },
  {
    "code": "D46.2",
    "name": "Refraktäre Anämie mit Blastenüberschuss",
    "synonyms": [
      "RAEB [Refraktäre Anämie mit Blastenexzess]",
      "RAEB [Refraktäre Anämie mit Blastenexzess] I",
      "RAEB [Refraktäre Anämie mit Blastenexzess] II",
      "RAEB-t [Refraktäre Anämie mit Blastenexzess in Transformation]",
      "Refraktäre Anämie mit Blastenexzess",
      "Refraktäre Anämie mit Blastenüberschuss",
      "Refraktäre Anämie mit Blastenüberschuss, Typ I",
      "Refraktäre Anämie mit Blastenüberschuss, Typ II"
    ]
  },
  {
    "code": "D46.4",
    "name": "Refraktäre Anämie",
    "synonyms": [
      "Refraktäre Anämie"
    ]
  },
  {
    "code": "D46.5",
    "name": "Refraktäre Anämie mit Mehrliniendysplasie",
    "synonyms": [
      "Refraktäre Anämie mit Mehrliniendysplasie"
    ]
  },
  {
    "code": "D46.6",
    "name": "Myelodysplastisches Syndrom mit isolierter del(5q)-Chromosomenanomalie",
    "synonyms": [
      "5q-minus-Syndrom",
      "Myelodysplastisches Syndrom mit isolierter del(5q)-Chromosomenanomalie"
    ]
  },
  {
    "code": "D46.7",
    "name": "Nicht klassifizierbares myelodysplastisches Syndrom",
    "synonyms": [
      "Emberger-Syndrom",
      "Nicht klassifizierbares myelodysplastisches Syndrom"
    ]
  },
  {
    "code": "D46.9",
    "name": "Präleukämie",
    "synonyms": [
      "Myelodysplasie",
      "Myelodysplasie mit Blastenüberschuss",
      "Myelodysplastische Anämie",
      "Myelodysplastisches Syndrom",
      "Myelodysplastisches Syndrom bei familiärem Monosomie-7-Syndrom",
      "Myelodysplastisches Syndrom durch Alkylanzien",
      "Myelodysplastisches Syndrom durch Epipodophyllotoxin",
      "Myelodysplastisches Syndrom durch Topoisomerase-Typ-II-Inhibitor",
      "Myelodysplastisches Syndrom durch ionisierende Strahlung",
      "Präleukämie",
      "Präleukämiesyndrom",
      "Präleukämisches Syndrom",
      "Therapie-induziertes myelodysplastisches Syndrom"
    ]
  },
  {
    "code": "D47.0",
    "name": "Mastozytom",
    "synonyms": [
      "Histiozyten- und Mastzelltumor unsicheren oder unbekannten Verhaltens",
      "Indolente systemische Mastozytose",
      "Isolierte Mastozytose des Knochenmarks",
      "Mastozytom",
      "Mastzellentumor",
      "Schwelende systemische Mastozytose",
      "Systemische Krankheit der Gewebsmastzellen",
      "Systemische Mastozytose, assoziiert mit klonaler hämatologischer Nicht-Mastzellen-Krankheit [SM-AHNMD]",
      "Systemische Mastzellenkrankheit"
    ]
  },
  {
    "code": "D47.1",
    "name": "Myeloproliferatives Syndrom",
    "synonyms": [
      "Chronische Myelose",
      "Chronische Myelose in kompletter Remission",
      "Chronische Neutrophilenleukämie",
      "Chronische myeloproliferative Krankheit",
      "Myeloproliferative Anämie",
      "Myeloproliferative Krankheit",
      "Myeloproliferatives Syndrom",
      "Transientes myeloproliferatives Syndrom"
    ]
  },
  {
    "code": "D47.2",
    "name": "Monoklonale Gammopathie",
    "synonyms": [
      "Gammopathie mit lymphoplasmozytischer Dyskrasie",
      "IgG [Immunglobulin G]-Paraproteinämie",
      "Monoklonale Gammopathie",
      "Monoklonale Gammopathie unbestimmter Signifikanz [MGUS]",
      "Monoklonale Makroglobulinämie",
      "Monoklonale Paraproteinämie",
      "POEMS [Polyneuropathy, Organomegaly, Endocrinopathy, M-Protein, Skin changes]-Syndrom",
      "Sekundäre Paraproteinämie",
      "Sekundäre Paraproteinämie bei maligner Krankheit",
      "TEMPI [Teleangiektasien, erhöhte Erythropoetinkonzentration, monoklonale Gammopathie, perinephritischer Abszess, intrapulmonaler Shunt]-Syndrom",
      "Unsichere Neubildung der Plasmazellen"
    ]
  },
  {
    "code": "D47.3",
    "name": "Essentielle Thrombozythämie",
    "synonyms": [
      "ET [Essentielle Thrombozythämie]",
      "Essentielle Thrombozythämie",
      "Essentielle Thrombozytose",
      "Hämorrhagische Thrombozythämie",
      "Idiopathische Thrombozythämie",
      "Idiopathische hämorrhagische Thrombozythämie",
      "Primäre Thrombozythämie",
      "Thrombozythämie"
    ]
  },
  {
    "code": "D47.4",
    "name": "Myelosklerose",
    "synonyms": [
      "Chronische idiopathische Myelofibrose",
      "Chronische megakaryozytäre Myelose",
      "Idiopathische Myelofibrose",
      "Idiopathische generalisierte Osteomyelofibrose",
      "Knochenmarkfibrose",
      "Knochenmarkhyperplasie",
      "Markfibrose",
      "Megakaryozytische Osteomyelosklerose",
      "Megakaryozytäre Myelosklerose mit myeloider Metaplasie",
      "Megakaryozytäre Myelosklerose mit myeloischer Metaplasie",
      "Mulcahy-Syndrom [Myelosklerose]",
      "Myelofibrose",
      "Myelofibrose mit myeloider Metaplasie",
      "Myelofibrose mit myeloischer Metaplasie",
      "Myelofibrosesyndrom",
      "Myeloide megakaryozytäre Hepatosplenomegalie",
      "Myelophthisische Splenomegalie",
      "Myeloretikulose",
      "Myelosklerose",
      "Myelosklerose mit myeloider Metaplasie",
      "Myelosklerose mit myeloischer Metaplasie",
      "Osteomyelofibrose",
      "Osteomyelofibrosesyndrom",
      "Osteomyeloretikulose",
      "Osteomyeloretikulosesyndrom",
      "Osteomyelosklerose",
      "Osteomyelosklerosesyndrom",
      "Osteosklerose bei Myelofibrose",
      "Osteosklerotische Leukämie",
      "PMF [Primäre Myelofibrose]",
      "Primäre Myelofibrose",
      "Sekundäre Myelofibrose bei myeloproliferativer Erkrankung"
    ]
  },
  {
    "code": "D47.5",
    "name": "Chronische Eosinophilen-Leukämie",
    "synonyms": [
      "Chronische Eosinophilen-Leukämie",
      "Hypereosinophiles Syndrom",
      "Idiopathisches hypereosinophiles Syndrom",
      "Primäres hypereosinophiles Syndrom",
      "Sekundäres hypereosinophiles Syndrom"
    ]
  },
  {
    "code": "D47.7",
    "name": "Castleman-Krankheit",
    "synonyms": [
      "Angiofollikuläre Lymphknotenhyperplasie",
      "Castleman-Krankheit",
      "Castleman-Lymphom",
      "Castleman-Syndrom",
      "Castleman-Tumor",
      "Frühe Läsion einer posttransplantations-lymphoproliferativen Krankheit",
      "Histiozytentumor unsicheren Verhaltens",
      "Monoklonale Immunglobulin-Ablagerungskrankheit",
      "PTLD [Post-Transplant Lymphoproliferative Disorder], frühe Läsion",
      "Posttransplantations-lymphoproliferative Krankheit, floride follikuläre Hyperplasie"
    ]
  },
  {
    "code": "D47.9",
    "name": "Lymphatische Infiltration",
    "synonyms": [
      "ALPS [Autoimmun-lymphoproliferatives Syndrom]",
      "Autoimmun-lymphoproliferative Krankheit Typ Dianzani",
      "Autoimmun-lymphoproliferatives Syndrom",
      "Autoimmun-lymphoproliferatives Syndrom durch CTLA4 [Cytotoxisches T-Lymphozyten-assoziiertes Antigen 4]-Haploinsuffizienz",
      "Autosomal-rezessive lymphoproliferative Krankheit",
      "Autosomal-rezessive lymphoproliferative Krankheit durch CD27-Mangel",
      "Canale-Smith-Syndrom",
      "Chronisches lymphoproliferatives Syndrom",
      "Immunproliferative unsichere Neubildung a.n.k.",
      "Lymphatische Infiltration",
      "Lymphoproliferative Krankheit",
      "Lymphoproliferative T-Gamma-Krankheit",
      "PTLD [Posttransplantations-lymphoproliferative Erkrankung]",
      "Posttransplantations-lymphoproliferative Erkrankung",
      "Posttransplantationslymphom",
      "Primär kutane Plasmozytose",
      "RAS-assoziiertes autoimmun-lymphoproliferatives Syndrom",
      "Unsichere Neubildung des Knochenmarks a.n.k.",
      "Unsichere Neubildung des hämatopoetischen Gewebes a.n.k."
    ]
  },
  {
    "code": "D48.0",
    "name": "Unsichere Neubildung des Knorpels",
    "synonyms": [
      "Aggressives Osteoblastom",
      "Brustwirbelsäulentumor",
      "Chondromatose",
      "Ecchondrosis",
      "Ekchondrose",
      "Fibroosteoklasie",
      "Gelenkchondromatose",
      "Geschwulst des Knochens",
      "Knochenneoplasie",
      "Knochentumor",
      "Odontogener Tumor",
      "Osteochondromatose",
      "Osteochondromatosis articularis",
      "Osteoclastoma",
      "Osteoklastom",
      "Riesenzelliger Knochentumor",
      "Schädelhöhlenteratom",
      "Schädelteratom",
      "Steißteratom",
      "Unsichere Neubildung der Armknochen a.n.k.",
      "Unsichere Neubildung der Beckenknochen",
      "Unsichere Neubildung der Beinknochen a.n.k.",
      "Unsichere Neubildung der Calvaria",
      "Unsichere Neubildung der Daumenknochen",
      "Unsichere Neubildung der Ellenbogenknochen",
      "Unsichere Neubildung der Fersenknochen",
      "Unsichere Neubildung der Fibula",
      "Unsichere Neubildung der Fingerknochen",
      "Unsichere Neubildung der Fußknochen",
      "Unsichere Neubildung der Fußphalangen",
      "Unsichere Neubildung der Fußwurzelknochen",
      "Unsichere Neubildung der Gelenke",
      "Unsichere Neubildung der Gesichtsknochen",
      "Unsichere Neubildung der Handknochen",
      "Unsichere Neubildung der Handphalangen",
      "Unsichere Neubildung der Handwurzelknochen",
      "Unsichere Neubildung der Hüftknochen",
      "Unsichere Neubildung der Kieferknochen",
      "Unsichere Neubildung der Klavikula",
      "Unsichere Neubildung der Knochen",
      "Unsichere Neubildung der Knochen der Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochen der oberen Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochen der unteren Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochen des Knies",
      "Unsichere Neubildung der Knochenhaut",
      "Unsichere Neubildung der Knochenhaut der Calvaria",
      "Unsichere Neubildung der Knochenhaut der Ferse",
      "Unsichere Neubildung der Knochenhaut der Fibula",
      "Unsichere Neubildung der Knochenhaut der Finger",
      "Unsichere Neubildung der Knochenhaut der Fußphalangen",
      "Unsichere Neubildung der Knochenhaut der Fußwurzel",
      "Unsichere Neubildung der Knochenhaut der Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut der Hand",
      "Unsichere Neubildung der Knochenhaut der Handphalangen",
      "Unsichere Neubildung der Knochenhaut der Handwurzel",
      "Unsichere Neubildung der Knochenhaut der Hüfte",
      "Unsichere Neubildung der Knochenhaut der Klavikula",
      "Unsichere Neubildung der Knochenhaut der Mandibula",
      "Unsichere Neubildung der Knochenhaut der Mittelhand",
      "Unsichere Neubildung der Knochenhaut der Nase",
      "Unsichere Neubildung der Knochenhaut der Orbita",
      "Unsichere Neubildung der Knochenhaut der Patella",
      "Unsichere Neubildung der Knochenhaut der Phalanxknochen",
      "Unsichere Neubildung der Knochenhaut der Rippen",
      "Unsichere Neubildung der Knochenhaut der Schulter",
      "Unsichere Neubildung der Knochenhaut der Sella turcica",
      "Unsichere Neubildung der Knochenhaut der Skapula",
      "Unsichere Neubildung der Knochenhaut der Speiche",
      "Unsichere Neubildung der Knochenhaut der Stirn",
      "Unsichere Neubildung der Knochenhaut der Tibia",
      "Unsichere Neubildung der Knochenhaut der Ulna",
      "Unsichere Neubildung der Knochenhaut der Wirbel",
      "Unsichere Neubildung der Knochenhaut der Wirbelsäule",
      "Unsichere Neubildung der Knochenhaut der Zehen",
      "Unsichere Neubildung der Knochenhaut der Zwischenwirbelscheiben",
      "Unsichere Neubildung der Knochenhaut der kurzen Knochen der oberen Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut der kurzen Knochen der unteren Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut der langen Knochen der oberen Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut der langen Knochen der unteren Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut der oberen Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut der unteren Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Knochenhaut des Akromions",
      "Unsichere Neubildung der Knochenhaut des Arms a.n.k.",
      "Unsichere Neubildung der Knochenhaut des Astragalus",
      "Unsichere Neubildung der Knochenhaut des Atlas",
      "Unsichere Neubildung der Knochenhaut des Axis",
      "Unsichere Neubildung der Knochenhaut des Azetabulums",
      "Unsichere Neubildung der Knochenhaut des Beckens",
      "Unsichere Neubildung der Knochenhaut des Beins a.n.k.",
      "Unsichere Neubildung der Knochenhaut des Brustbeins",
      "Unsichere Neubildung der Knochenhaut des Calcaneus",
      "Unsichere Neubildung der Knochenhaut des Clivus",
      "Unsichere Neubild"
    ]
  },
  {
    "code": "D48.1",
    "name": "Unsichere Neubildung der Weichteile",
    "synonyms": [
      "Abdominale Fibromatose",
      "Abdominales Desmoid",
      "Aggressive Fibromatose",
      "Angeborene infiltrierende Lipomatose des Gesichts",
      "Angioblastom",
      "Angiomyoblastom",
      "Atypisches Fibroxanthom",
      "Bindegewebeneubildung",
      "Bindegewebetumor des Lids unbekannter Dignität",
      "Desmoid - s.a. Neubildung, Bindegewebe, unsicheres Verhalten",
      "Desmoidfibrom - s.a. Neubildung, Bindegewebe, unsicheres Verhalten",
      "Desmoidfibromatose",
      "Desmoidtumor - s.a. Neubildung, Bindegewebe, unsicheres Verhalten",
      "Desmoplastisches Fibrom",
      "Extraabdominales Desmoid - s.a. Neubildung, Bindegewebe, unsicheres Verhalten",
      "Geschwulst des Bindegewebes",
      "Geschwulst eines großen Gefäßes",
      "Hämangioblastom",
      "Hämangioendotheliom",
      "Hämangioperizytom",
      "Hämendotheliom",
      "Infantile Myofibromatose",
      "Intravaskuläre Leiomyomatose - s.a. Neubildung, Bindegewebe, unsicheres Verhalten",
      "Invasives Fibrom",
      "Kongenitale generalisierte Fibromatose",
      "Leiomyomatose - s.a. Neubildung, Bindegewebe, unsicheres Verhalten",
      "Lymphangioleiomyomatose",
      "Lymphangiomyomatose",
      "Mesenchymom",
      "Mesenchymtumor",
      "Myofibromatose",
      "Myofibromatosis",
      "Neoplasie des Bindegewebes",
      "Neoplasie eines großen Gefäßes",
      "Perivaskulärer epitheloidzelliger Tumor",
      "Perizytom",
      "Retiformes Hämangioendotheliom",
      "Synoviale Osteochondromatose",
      "Tumor der glatten Muskulatur",
      "Tumor des Bindegewebes",
      "Tumor des Lids unbekannter Dignität",
      "Tumor eines großen Gefäßes",
      "Unsichere Neubildung der Aorta thoracica",
      "Unsichere Neubildung der Aponeurosis palmaris",
      "Unsichere Neubildung der Aponeurosis plantaris",
      "Unsichere Neubildung der Arteria carotis",
      "Unsichere Neubildung der Bauchdecke",
      "Unsichere Neubildung der Faszie",
      "Unsichere Neubildung der Faszien",
      "Unsichere Neubildung der Fossa pterygoidea a.n.k.",
      "Unsichere Neubildung der Ligamente",
      "Unsichere Neubildung der Lymphbahnen a.n.k.",
      "Unsichere Neubildung der Lymphgefäße",
      "Unsichere Neubildung der Muskeln",
      "Unsichere Neubildung der Palmarfaszie",
      "Unsichere Neubildung der Plantarfaszie",
      "Unsichere Neubildung der Synovialmembran",
      "Unsichere Neubildung der Vena cava",
      "Unsichere Neubildung der Vena cava superior",
      "Unsichere Neubildung der Weichteile",
      "Unsichere Neubildung des Abdomenbindegewebes a.n.k.",
      "Unsichere Neubildung des Achselhöhlenbindegewebes a.n.k.",
      "Unsichere Neubildung des Armbindegewebes a.n.k.",
      "Unsichere Neubildung des Augenlidbindegewebes",
      "Unsichere Neubildung des Augenlidknorpels",
      "Unsichere Neubildung des Auriculabindegewebes a.n.k.",
      "Unsichere Neubildung des Auriculaknorpels",
      "Unsichere Neubildung des Bauchwandbindegewebes",
      "Unsichere Neubildung des Beckenbindegewebes a.n.k.",
      "Unsichere Neubildung des Beckenbodenbindegewebes a.n.k.",
      "Unsichere Neubildung des Beinbindegewebes a.n.k.",
      "Unsichere Neubildung des Bindegewebes",
      "Unsichere Neubildung des Bindegewebes der Flankengegend a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Fossa ischiorectalis a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Fossa pterygoidea a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Gliedmaßen a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Glutäalmuskulatur a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Infraklavikulargegend a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Kreuzbeingegend und Steißbeingegend",
      "Unsichere Neubildung des Bindegewebes der Leistenkanalgegend a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Schulterblattgegend a.n.k.",
      "Unsichere Neubildung des Bindegewebes der Supraklavikulargegend a.n.k.",
      "Unsichere Neubildung des Bindegewebes der großen Gefäße a.n.k.",
      "Unsichere Neubildung des Bindegewebes des Diaphragmas a.n.k.",
      "Unsichere Neubildung des Bindegewebes des Iliopsoasmuskels a.n.k.",
      "Unsichere Neubildung des Bindegewebes des Perineums a.n.k.",
      "Unsichere Neubildung des Bindegewebes des Psoasmuskels a.n.k.",
      "Unsichere Neubildung des Bindegewebes des Septum rectovaginale a.n.k.",
      "Unsichere Neubildung des Brustbindegewebes a.n.k.",
      "Unsichere Neubildung des Brustwandbindegewebes a.n.k.",
      "Unsichere Neubildung des Daumenbindegewebes a.n.k.",
      "Unsichere Neubildung des Diaphragmas",
      "Unsichere Neubildung des Ductus thoracicus",
      "Unsichere Neubildung des Ellenbeugenbindegewebes a.n.k.",
      "Unsichere Neubildung des Ellenb"
    ]
  },
  {
    "code": "D48.2",
    "name": "Unsichere Neubildung der Nerven",
    "synonyms": [
      "Geschwulst der Ganglien",
      "Neoplasie der Ganglien",
      "Nervenscheidentumor",
      "Neuromatosis",
      "Tumor der Ganglien",
      "Unsichere Neubildung abdominopelviner Nerven a.n.k.",
      "Unsichere Neubildung an Nerven der Wirbelsäule",
      "Unsichere Neubildung an Nervenwurzeln der Wirbelsäule",
      "Unsichere Neubildung der Abdominalnerven a.n.k.",
      "Unsichere Neubildung der Achselhöhlennerven a.n.k.",
      "Unsichere Neubildung der Armnerven a.n.k.",
      "Unsichere Neubildung der Augenlidnerven a.n.k.",
      "Unsichere Neubildung der Bauchwandnerven a.n.k.",
      "Unsichere Neubildung der Beckenbodennerven a.n.k.",
      "Unsichere Neubildung der Beckennerven a.n.k.",
      "Unsichere Neubildung der Beinnerven a.n.k.",
      "Unsichere Neubildung der Brachialnerven",
      "Unsichere Neubildung der Brustnerven a.n.k.",
      "Unsichere Neubildung der Brustwandnerven a.n.k.",
      "Unsichere Neubildung der Daumennerven a.n.k.",
      "Unsichere Neubildung der Ellenbeugennerven a.n.k.",
      "Unsichere Neubildung der Ellenbogennerven a.n.k.",
      "Unsichere Neubildung der Extremitätennerven a.n.k.",
      "Unsichere Neubildung der Fersennerven a.n.k.",
      "Unsichere Neubildung der Fingernerven a.n.k.",
      "Unsichere Neubildung der Fußnerven a.n.k.",
      "Unsichere Neubildung der Gesichtsnerven a.n.k.",
      "Unsichere Neubildung der Gesäßnerven a.n.k.",
      "Unsichere Neubildung der Gliedmaßennerven a.n.k.",
      "Unsichere Neubildung der Halsnerven a.n.k.",
      "Unsichere Neubildung der Handgelenknerven a.n.k.",
      "Unsichere Neubildung der Handnerven a.n.k.",
      "Unsichere Neubildung der Hüftnerven a.n.k.",
      "Unsichere Neubildung der Kinnnerven a.n.k.",
      "Unsichere Neubildung der Kniekehlennerven a.n.k.",
      "Unsichere Neubildung der Knienerven a.n.k.",
      "Unsichere Neubildung der Knöchelnerven a.n.k.",
      "Unsichere Neubildung der Kopfnerven a.n.k.",
      "Unsichere Neubildung der Kopfschwartennerven a.n.k.",
      "Unsichere Neubildung der Nabelnerven a.n.k.",
      "Unsichere Neubildung der Nackennerven a.n.k.",
      "Unsichere Neubildung der Nerven",
      "Unsichere Neubildung der Nerven der Auricula a.n.k.",
      "Unsichere Neubildung der Nerven der Flankengegend a.n.k.",
      "Unsichere Neubildung der Nerven der Fossa ischiorectalis a.n.k.",
      "Unsichere Neubildung der Nerven der Fossa pterygoidea a.n.k.",
      "Unsichere Neubildung der Nerven der Glutäalmuskulatur a.n.k.",
      "Unsichere Neubildung der Nerven der Infraklavikulargegend a.n.k.",
      "Unsichere Neubildung der Nerven der Kreuzbeingegend a.n.k.",
      "Unsichere Neubildung der Nerven der Leistenkanalgegend a.n.k.",
      "Unsichere Neubildung der Nerven der Schläfenbeinregion a.n.k.",
      "Unsichere Neubildung der Nerven der Schulterblattgegend a.n.k.",
      "Unsichere Neubildung der Nerven der Steißbeingegend a.n.k.",
      "Unsichere Neubildung der Nerven der Supraklavikulargegend a.n.k.",
      "Unsichere Neubildung der Nerven der oberen Extremität a.n.k.",
      "Unsichere Neubildung der Nerven der oberen Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Nerven der unteren Extremität a.n.k.",
      "Unsichere Neubildung der Nerven der unteren Gliedmaßen a.n.k.",
      "Unsichere Neubildung der Nerven des Septum rectovaginale a.n.k.",
      "Unsichere Neubildung der Nervi lumbales",
      "Unsichere Neubildung der Nervi sacrales",
      "Unsichere Neubildung der Nervi spinales a.n.k.",
      "Unsichere Neubildung der Oberschenkelnerven a.n.k.",
      "Unsichere Neubildung der Ohrnerven a.n.k.",
      "Unsichere Neubildung der Perineumnerven a.n.k.",
      "Unsichere Neubildung der Rumpfnerven a.n.k.",
      "Unsichere Neubildung der Rückennerven a.n.k.",
      "Unsichere Neubildung der Schläfenerven a.n.k.",
      "Unsichere Neubildung der Schulternerven a.n.k.",
      "Unsichere Neubildung der Stirnnerven a.n.k.",
      "Unsichere Neubildung der Thoraxnerven a.n.k.",
      "Unsichere Neubildung der Thoraxwandnerven a.n.k.",
      "Unsichere Neubildung der Unterarmnerven a.n.k.",
      "Unsichere Neubildung der Wadennerven a.n.k.",
      "Unsichere Neubildung der Wangennerven a.n.k.",
      "Unsichere Neubildung der Zehennerven a.n.k.",
      "Unsichere Neubildung der autonomen Nerven a.n.k.",
      "Unsichere Neubildung der extrarektalen Nerven a.n.k.",
      "Unsichere Neubildung der inguinalen Nerven a.n.k.",
      "Unsichere Neubildung der intrathorakalen Nerven a.n.k.",
      "Unsichere Neubildung der pararektalen Nerven a.n.k.",
      "Unsichere Neubildung der parasympathischen Nerven a.n.k.",
      "Unsichere Neubildung der paraurethralen Nerven a.n.k.",
      "Unsi"
    ]
  },
  {
    "code": "D48.3",
    "name": "Unsichere paranephritische Neubildung",
    "synonyms": [
      "Periadrenale unsichere Neubildung",
      "Perinephrische unsichere Neubildung",
      "Peripankreatische unsichere Neubildung",
      "Perirenale unsichere Neubildung",
      "Retroperitoneale Fibromatose",
      "Retroperitoneale unsichere Neubildung",
      "Retrozäkale unsichere Neubildung",
      "Unsichere Neubildung des Retroperitoneums",
      "Unsichere Neubildung des retroperitonealen Bindegewebes a.n.k.",
      "Unsichere paranephritische Neubildung"
    ]
  },
  {
    "code": "D48.4",
    "name": "Unklares Douglasinfiltrat",
    "synonyms": [
      "Douglastumor",
      "Peritonealteratom",
      "Peritonealtumor",
      "Unklares Douglasinfiltrat",
      "Unsichere Neubildung der Mesoappendix",
      "Unsichere Neubildung der Peritonealhöhle",
      "Unsichere Neubildung der rektouterinen Tasche",
      "Unsichere Neubildung des Beckenperitoneums",
      "Unsichere Neubildung des Douglas-Raums",
      "Unsichere Neubildung des Mesenteriums",
      "Unsichere Neubildung des Mesokolons",
      "Unsichere Neubildung des Omentums",
      "Unsichere Neubildung des Peritoneums",
      "Unsichere Neubildung des parietalen Peritoneums",
      "Zystisches Mesotheliom"
    ]
  },
  {
    "code": "D48.5",
    "name": "Neoplasie der Haut",
    "synonyms": [
      "Analrandtumor",
      "Angiomatoides fibröses Histiozytom",
      "Augenlidgeschwulst",
      "Augenlidneoplasie",
      "Augenlidtumor",
      "Badehosen-Nävus",
      "Basalzelliger Tumor",
      "Bathing-trunk-Naevus",
      "FAMMM [Familiäres atpisches multiples Muttermal-Melanom]-Syndrom",
      "Gehörgangshautneubildung",
      "Geschwulst der Analhaut",
      "Geschwulst der Haut",
      "Hautneubildung",
      "Hauttumor",
      "Lidgeschwulst",
      "Naevus gigantopigmentosus",
      "Neoplasie der Analhaut",
      "Neoplasie der Haut",
      "Nichtmelanomartige unsichere Neubildung der Achselfaltenhaut",
      "Nichtmelanomartige unsichere Neubildung der Achselhaut",
      "Nichtmelanomartige unsichere Neubildung der Analhaut",
      "Nichtmelanomartige unsichere Neubildung der Armhaut",
      "Nichtmelanomartige unsichere Neubildung der Augenbrauenhaut",
      "Nichtmelanomartige unsichere Neubildung der Augenlidhaut",
      "Nichtmelanomartige unsichere Neubildung der Augenwinkelhaut",
      "Nichtmelanomartige unsichere Neubildung der Bauchhaut",
      "Nichtmelanomartige unsichere Neubildung der Bauchwandhaut",
      "Nichtmelanomartige unsichere Neubildung der Beinhaut",
      "Nichtmelanomartige unsichere Neubildung der Brusthaut",
      "Nichtmelanomartige unsichere Neubildung der Brustwandhaut",
      "Nichtmelanomartige unsichere Neubildung der Daumenhaut",
      "Nichtmelanomartige unsichere Neubildung der Ellenbeugenhaut",
      "Nichtmelanomartige unsichere Neubildung der Ellenbogenhaut",
      "Nichtmelanomartige unsichere Neubildung der Fersenhaut",
      "Nichtmelanomartige unsichere Neubildung der Fingerhaut",
      "Nichtmelanomartige unsichere Neubildung der Flankenhaut",
      "Nichtmelanomartige unsichere Neubildung der Fußhaut",
      "Nichtmelanomartige unsichere Neubildung der Fußsohlenhaut",
      "Nichtmelanomartige unsichere Neubildung der Gesichtshaut a.n.k.",
      "Nichtmelanomartige unsichere Neubildung der Gesäßhaut",
      "Nichtmelanomartige unsichere Neubildung der Glutäalhaut",
      "Nichtmelanomartige unsichere Neubildung der Handflächenhaut",
      "Nichtmelanomartige unsichere Neubildung der Handhaut",
      "Nichtmelanomartige unsichere Neubildung der Haut der Columella nasi",
      "Nichtmelanomartige unsichere Neubildung der Haut der Halsgegend",
      "Nichtmelanomartige unsichere Neubildung der Haut der Inguinalregion",
      "Nichtmelanomartige unsichere Neubildung der Haut der Leistengegend",
      "Nichtmelanomartige unsichere Neubildung der Haut der Ohrhelix",
      "Nichtmelanomartige unsichere Neubildung der Haut der Schamgegend",
      "Nichtmelanomartige unsichere Neubildung der Haut der Skapularregion",
      "Nichtmelanomartige unsichere Neubildung der Haut der Supraklavikulargrube",
      "Nichtmelanomartige unsichere Neubildung der Haut der oberen Gliedmaßen a.n.k.",
      "Nichtmelanomartige unsichere Neubildung der Haut der submammären Falte",
      "Nichtmelanomartige unsichere Neubildung der Haut der unteren Gliedmaßen a.n.k.",
      "Nichtmelanomartige unsichere Neubildung der Haut des Gehörganges",
      "Nichtmelanomartige unsichere Neubildung der Haut des Klavikulargebiets",
      "Nichtmelanomartige unsichere Neubildung der Haut des Tragus",
      "Nichtmelanomartige unsichere Neubildung der Hüfthaut",
      "Nichtmelanomartige unsichere Neubildung der Kieferhaut",
      "Nichtmelanomartige unsichere Neubildung der Kinnhaut",
      "Nichtmelanomartige unsichere Neubildung der Kniehaut",
      "Nichtmelanomartige unsichere Neubildung der Kniekehlenhaut",
      "Nichtmelanomartige unsichere Neubildung der Knöchelhaut",
      "Nichtmelanomartige unsichere Neubildung der Kopfhaut a.n.k.",
      "Nichtmelanomartige unsichere Neubildung der Kopfschwartenhaut",
      "Nichtmelanomartige unsichere Neubildung der Kreuzbeingegend",
      "Nichtmelanomartige unsichere Neubildung der Leistenbeugenhaut",
      "Nichtmelanomartige unsichere Neubildung der Lidhaut",
      "Nichtmelanomartige unsichere Neubildung der Lippenhaut",
      "Nichtmelanomartige unsichere Neubildung der Nabelhaut",
      "Nichtmelanomartige unsichere Neubildung der Nasenflügelhaut",
      "Nichtmelanomartige unsichere Neubildung der Nasenhaut",
      "Nichtmelanomartige unsichere Neubildung der Oberschenkelhaut",
      "Nichtmelanomartige unsichere Neubildung der Ohrhaut",
      "Nichtmelanomartige unsichere Neubildung der Ohrmuschelhaut",
      "Nichtmelanomartige unsichere Neubildung der Palpebralhaut",
      "Nichtmelanomartige unsichere Neubildung der Perianalhaut",
      "Nichtmelanomartige unsichere Neubildung der Perinealhaut",
      "Nichtmelanomartige un"
    ]
  },
  {
    "code": "D48.6",
    "name": "Mammafibromatose",
    "synonyms": [
      "Brustdrüsengeschwulst",
      "Brustdrüsenneoplasie",
      "Brustdrüsentumor",
      "Brustwarzentumor",
      "Cystosarcoma phylloides",
      "Cystosarcoma phylloides der Brust",
      "Mamillentumor",
      "Mammafibromatose",
      "Mammageschwulst",
      "Mammaneoplasie",
      "Mammatumor",
      "Phylloider Tumor",
      "Phylloidestumor",
      "Phylloidestumor der Brust",
      "Unsichere Neubildung der Areola",
      "Unsichere Neubildung der Brustdrüse",
      "Unsichere Neubildung der Brustwarze",
      "Unsichere Neubildung der Mamma",
      "Unsichere Neubildung der Medioklavikularlinie der Brustdrüse",
      "Unsichere Neubildung der inneren Brustdrüse",
      "Unsichere Neubildung der oberen Brustdrüse",
      "Unsichere Neubildung der unteren Brustdrüse",
      "Unsichere Neubildung der äußeren Brustdrüse",
      "Unsichere Neubildung des Brustdrüsenbindegewebes",
      "Unsichere Neubildung des Mammabindegewebes",
      "Unsichere Neubildung des Recessus axillaris der Brustdrüse",
      "Unsichere Neubildung des Warzenhofes der Brustdrüse",
      "Unsichere Neubildung des axillären Ausläufers der Brustdrüse",
      "Unsichere Neubildung des oberen inneren Quadranten der Brustdrüse",
      "Unsichere Neubildung des oberen äußeren Quadranten der Brustdrüse",
      "Unsichere Neubildung des unteren inneren Quadranten der Brustdrüse",
      "Unsichere Neubildung des unteren äußeren Quadranten der Brustdrüse",
      "Unsichere Neubildung des zentralen Drüsenkörpers der Brustdrüse",
      "Unsichere Neubildung einer ektopischen Brustdrüse",
      "Zystosarkom"
    ]
  },
  {
    "code": "D48.7",
    "name": "Hornhauttumor unbekannter Dignität",
    "synonyms": [
      "Abdominopelvine unsichere Neubildung",
      "Aderhauttumor",
      "Augenneoplasma",
      "Augentumor unbekannter Dignität",
      "Beckentumor",
      "Bindehauttumor unbekannter Dignität",
      "Brustwandtumor",
      "Flankentumor",
      "Geschwulst der Nase",
      "Geschwulst des Beckenbodens",
      "Hornhauttumor unbekannter Dignität",
      "Infraklavikuläre unsichere Neubildung",
      "Intraabdominale unsichere Neubildung",
      "Intraokuläre unsichere Neubildung",
      "Intraorbitale unsichere Neubildung",
      "Intrathorakale unsichere Neubildung",
      "Iristumor unbekannter Dignität",
      "Ischiorektale unsichere Neubildung",
      "Konjunktivatumor unbekannter Dignität",
      "Korneaneoplasma",
      "Mesogastriumtumor",
      "Mittelbauchtumor",
      "Neoplasie der Nase",
      "Neoplasie des Beckenbodens",
      "Netzhauttumor unbekannter Dignität",
      "Optikustumor unbekannter Dignität",
      "Orbitatumor",
      "Orbitatumor unbekannter Dignität",
      "Pararektale unsichere Neubildung",
      "Paraurethrale unsichere Neubildung",
      "Paravaginale unsichere Neubildung",
      "Pelvikoabdominale unsichere Neubildung",
      "Präsakrale unsichere Neubildung",
      "Rektovaginaltumor",
      "Retinatumor unbekannter Dignität",
      "Retrobulbäre unsichere Neubildung",
      "Retrovesikale unsichere Neubildung",
      "Skleratumor unbekannter Dignität",
      "Submentale unsichere Neubildung",
      "Tränendrüsentumor unbekannter Dignität",
      "Tränenwegtumor unbekannter Dignität",
      "Tumor der Nase",
      "Tumor des Auges",
      "Tumor des Beckenbodens",
      "Unsichere Neubildung der Achselhöhle",
      "Unsichere Neubildung der Armlymphknoten",
      "Unsichere Neubildung der Baucheingeweide",
      "Unsichere Neubildung der Bauchhöhle",
      "Unsichere Neubildung der Bauchorgane",
      "Unsichere Neubildung der Beckenlymphknoten",
      "Unsichere Neubildung der Beckenorgane",
      "Unsichere Neubildung der Beckenwand",
      "Unsichere Neubildung der Beinlymphknoten",
      "Unsichere Neubildung der Bindehaut",
      "Unsichere Neubildung der Brustorgane",
      "Unsichere Neubildung der Brustwand a.n.k.",
      "Unsichere Neubildung der Chorioidea",
      "Unsichere Neubildung der Eingeweide a.n.k.",
      "Unsichere Neubildung der Ferse a.n.k.",
      "Unsichere Neubildung der Flanke a.n.k.",
      "Unsichere Neubildung der Fossa ischiorectalis",
      "Unsichere Neubildung der Gallengangslymphknoten",
      "Unsichere Neubildung der Gesichtslymphknoten",
      "Unsichere Neubildung der Gliedmaßen",
      "Unsichere Neubildung der Glutäalregion",
      "Unsichere Neubildung der Halslymphknoten",
      "Unsichere Neubildung der Hand a.n.k.",
      "Unsichere Neubildung der Hüfte a.n.k.",
      "Unsichere Neubildung der Ileumlymphknoten",
      "Unsichere Neubildung der Iris",
      "Unsichere Neubildung der Kniekehle",
      "Unsichere Neubildung der Kolonlymphknoten",
      "Unsichere Neubildung der Konjunktiva",
      "Unsichere Neubildung der Kopflymphknoten",
      "Unsichere Neubildung der Kornea",
      "Unsichere Neubildung der Kreuzbeingegend",
      "Unsichere Neubildung der Leberlymphknoten",
      "Unsichere Neubildung der Leistenbeuge a.n.k.",
      "Unsichere Neubildung der Leistenbeugenlymphknoten",
      "Unsichere Neubildung der Leistengegend",
      "Unsichere Neubildung der Linse",
      "Unsichere Neubildung der Lymphknoten",
      "Unsichere Neubildung der Lymphknoten der Porta hepatis",
      "Unsichere Neubildung der Lymphknoten der oberen Gliedmaßen",
      "Unsichere Neubildung der Lymphknoten der unteren Gliedmaßen",
      "Unsichere Neubildung der Lymphknoten des Anulus femoralis",
      "Unsichere Neubildung der Lymphknoten des Foramen obturatum",
      "Unsichere Neubildung der Lymphknoten des Hypogastriums",
      "Unsichere Neubildung der Lymphknoten des Lungenhilus",
      "Unsichere Neubildung der Lymphknoten des Parametriums",
      "Unsichere Neubildung der Lymphknoten des Zwerchfells",
      "Unsichere Neubildung der Magenlymphknoten",
      "Unsichere Neubildung der Mesokolonlymphknoten",
      "Unsichere Neubildung der Milzlymphknoten",
      "Unsichere Neubildung der Nackenlymphknoten",
      "Unsichere Neubildung der Nase",
      "Unsichere Neubildung der Orbita",
      "Unsichere Neubildung der Orbitanerven a.n.k.",
      "Unsichere Neubildung der Orbitaweichteile",
      "Unsichere Neubildung der Pankreaslymphknoten",
      "Unsichere Neubildung der Parotislymphknoten",
      "Unsichere Neubildung der Pfortaderlymphknoten",
      "Unsichere Neubildung der Pyloruslymphknoten",
      "Unsichere Neubildung der Regio scapularis",
      "Unsichere Neubildung der Retina",
      "Unsichere Neubildung der Rosenmüller-Lymphknoten",
      "Unsichere Neubildung der Schulter a.n.k.",
      "Unsichere Neubildung der Schulterblattregion",
      "Unsichere Neubildung der S"
    ]
  },
  {
    "code": "D48.9",
    "name": "Peripherer degenerativer Tumor",
    "synonyms": [
      "Argentaffines Karzinoid",
      "Embryonaltumor",
      "Extragonadales Teratom",
      "Florides Tumorleiden",
      "Geschwulst - s.a. Neubildung, unsicheres Verhalten",
      "Gewächs",
      "Growing-teratoma-Syndrom",
      "Inflammatorischer myofibroblastischer Tumor",
      "Neoplasie",
      "Neoplasma",
      "Neoplastische Geschwulst - s.a. Neubildung, unsicheres Verhalten",
      "Neoplastische Zyste",
      "Neoplastischer Prozess",
      "Neoplastisches Wachstum - s.a. Neubildung, unsicheres Verhalten",
      "Neubildung - s.a. Tabelle der Neubildungen",
      "Neue Geschwulst - s.a. Neubildung, unsicheres Verhalten",
      "Peripherer degenerativer Tumor",
      "Pilzartige Geschwulst - s.a. Neubildung, unsicheres Verhalten",
      "Reifes Teratom",
      "Solides Teratom - s.a. Neubildung, unsicheres Verhalten",
      "Teratom - s.a. Neubildung, unsicheres Verhalten",
      "Teratoma - s.a. Neubildung, unsicheres Verhalten",
      "Teratotumor",
      "Tumor - s.a. Neubildung",
      "Tumoröse Veränderung",
      "Tumoröser Prozess",
      "VIPom [Vasoaktives intestinales Polypeptid sezernierender Tumor]",
      "Villöses Adenom",
      "Übergangszelltumor"
    ]
  },
  {
    "code": "D50.0",
    "name": "Eisenmangelanämie nach Blutverlust",
    "synonyms": [
      "Blutungsanämie",
      "Chronische Anämie durch Blutung",
      "Chronische Anämie nach Blutverlust",
      "Chronische hämorrhagische Anämie",
      "Chronische posthämorrhagische Anämie",
      "Eisenmangelanämie nach Blutverlust",
      "Eisenmangelanämie nach chronischem Blutverlust",
      "Hämorrhagische Schießscheibenzell-Anämie",
      "Mikrozytäre Anämie durch Blutverlust",
      "Posthämorrhagische Anämie",
      "Progrediente posthämorrhagische Anämie"
    ]
  },
  {
    "code": "D50.1",
    "name": "Sideropenische Dysphagie",
    "synonyms": [
      "Kelly-Paterson-Syndrom",
      "Paterson-Brown-Kelly-Syndrom",
      "Plummer-Vinson-Krankheit",
      "Plummer-Vinson-Syndrom",
      "Sideropenische Dysphagie",
      "Sideropenisches Syndrom"
    ]
  },
  {
    "code": "D50.8",
    "name": "Mikrozytäre Anämie",
    "synonyms": [
      "Achlorhydrische Anämie",
      "Achylische Chloranämie",
      "Alimentäre Anämie mit geringer Eisenabsorption",
      "Anazide Anämie",
      "Chlorotische Anämie",
      "Eisenmangelanämie durch verminderte Eisenresorption",
      "Eisenrefraktäre Eisenmangelanämie",
      "Hypochromie der roten Blutkörperchen",
      "Mikrozytäre Anämie",
      "Mikrozytäre Anämie mit hepatischer Eisenüberladung",
      "Mikrozytäre hypochrome Anämie",
      "Nahrungsmangel-Anämie mit geringer Eisenabsorption",
      "Normoblastische hypochrome Anämie",
      "Nutritive Anämie mit Eisenverwertungsstörung",
      "Refraktäre sideropenische Anämie",
      "Witts-Anämie"
    ]
  },
  {
    "code": "D50.9",
    "name": "Hyposiderinämie",
    "synonyms": [
      "Anaemia oligosideraemica",
      "Asiderotische Anämie",
      "Bleichsucht",
      "Chlorose",
      "Eisenmangelanämie",
      "Eisenmangelsyndrom",
      "Faber-Syndrom",
      "Hypochrome Anämie",
      "Hypoferroanämie",
      "Hyposiderinämie",
      "Sideropenische Anämie",
      "Sideroprive Anämie"
    ]
  },
  {
    "code": "D51.0",
    "name": "Vitamin-B12-Mangelanämie durch Mangel an Intrinsic-Faktor",
    "synonyms": [
      "Addison-Anämie",
      "Addison-Biermer-Syndrom",
      "Anaemia maligna",
      "Anaemia perniciosa",
      "Anaemia perniciosa progressiva idiopathica",
      "Angeborene perniziöse Anämie",
      "Angeborener Intrinsic-Faktor-Mangel",
      "Biermer-Anämie",
      "Biermer-Ehrlich-Addison-Anämie",
      "Biermer-Krankheit",
      "Biermer-Syndrom",
      "Bösartige Anämie",
      "Erworbene perniziöse Anämie",
      "Hunter-Addison-Anämie",
      "Juvenile megaloblastische Anämie durch Intrinsic-Faktor-Mangel",
      "Juvenile perniziöse Anämie",
      "Kongenitaler Intrinsic-Faktor-Mangel",
      "Lebert-Anämie",
      "Maligne Anämie",
      "Morbus Biermer",
      "Möller-Hunter-Glossitis bei perniziöser Anämie",
      "Perniziöse Anämie",
      "Perniziöser Anämie mit Glossitis",
      "Vitamin-B12-Mangelanämie durch Mangel an Intrinsic-Faktor"
    ]
  },
  {
    "code": "D51.1",
    "name": "Vitamin-B12-Mangelanämie durch selektive Vitamin-B12-Malabsorption mit Proteinurie",
    "synonyms": [
      "Imerslund-Gräsbeck-Syndrom",
      "Imerslund-Syndrom",
      "Megaloblastäre hereditäre Anämie",
      "Selektive Cobalamin-Malabsorption mit Proteinurie",
      "Vitamin-B12-Mangelanämie durch selektive Vitamin-B12-Malabsorption mit Proteinurie"
    ]
  },
  {
    "code": "D51.2",
    "name": "Transcobalamin-II-Mangelanämie",
    "synonyms": [
      "Transcobalamin-II-Mangel",
      "Transcobalamin-II-Mangelanämie"
    ]
  },
  {
    "code": "D51.3",
    "name": "Vegane Anämie",
    "synonyms": [
      "Alimentäre Vitamin-B12-Mangelanämie",
      "Vegane Anämie",
      "Vitamin-B12-Mangelanämie beim Vegetarier"
    ]
  },
  {
    "code": "D51.9",
    "name": "Vitamin-B12-Mangelanämie",
    "synonyms": [
      "Vitamin-B12-Mangelanämie"
    ]
  },
  {
    "code": "D52.0",
    "name": "Alimentäre Folsäuremangelanämie",
    "synonyms": [
      "Alimentäre Folsäuremangelanämie",
      "Makrozytäre alimentäre Anämie",
      "Megaloblastäre alimentäre Anämie",
      "Megaloblastäre nutritive Anämie",
      "Von-Jaksch-Hayem-Anämie [Ziegenmilchanämie]",
      "Ziegenmilchanämie"
    ]
  },
  {
    "code": "D52.1",
    "name": "Arzneimittelinduzierte Folsäuremangelanämie",
    "synonyms": [
      "Arzneimittelinduzierte Folsäuremangelanämie"
    ]
  },
  {
    "code": "D52.8",
    "name": "Tropische makrozytäre Anämie",
    "synonyms": [
      "Megaloblastäre Anämie durch Dihydrofolat-Reduktase-Mangel",
      "Pleiochrome Anämie bei Sprue",
      "Tropische makrozytäre Anämie"
    ]
  },
  {
    "code": "D52.9",
    "name": "Folsäuremangelanämie",
    "synonyms": [
      "Folsäuremangelanämie",
      "Makrozytäre Anämie"
    ]
  },
  {
    "code": "D53.0",
    "name": "Eiweißmangelanämie",
    "synonyms": [
      "Aminosäuremangelanämie",
      "Anämie durch Aminosäurestoffwechselstörung",
      "Anämie durch Orotazidurie",
      "Eiweißmangelanämie",
      "Megaloblastäre Anämie durch Orotazidurie",
      "Proteinmangelanämie"
    ]
  },
  {
    "code": "D53.1",
    "name": "Megaloblastäre refraktäre Anämie",
    "synonyms": [
      "Achrestische Anämie",
      "Dimorphe Anämie",
      "Diphasische Anämie",
      "Gerbasi-Syndrom",
      "Megaloblastische Anämie",
      "Megaloblastäre Anämie",
      "Megaloblastäre Anämie im Kleinkindalter",
      "Megaloblastäre Anämie, resistent gegenüber Folsäure-Therapie",
      "Megaloblastäre Anämie, resistent gegenüber Vitamin-B12-Therapie",
      "Megaloblastäre refraktäre Anämie",
      "Megalozytäre Anämie",
      "Pseudo-Biermer-Anämie des Säuglings",
      "Pseudo-Biermer-Syndrom",
      "Pseudoperniziöse Anämie des Säuglings",
      "Zuelzer-Ogden-Syndrom"
    ]
  },
  {
    "code": "D53.2",
    "name": "Skorbutanämie",
    "synonyms": [
      "Skorbutanämie"
    ]
  },
  {
    "code": "D53.8",
    "name": "Zinkmangelanämie",
    "synonyms": [
      "Alkoholbedingte Anämie",
      "Kupfermangelanämie",
      "Molybdänmangelanämie",
      "Zinkmangelanämie"
    ]
  },
  {
    "code": "D53.9",
    "name": "Alimentäre Anämie",
    "synonyms": [
      "Alimentäre Anämie",
      "Anämie durch Hunger",
      "Anämie durch Mangelernährung",
      "Anämie durch Nahrungsmangel",
      "Chronische einfache Anämie",
      "Mangelanämie",
      "Nutritive Anämie"
    ]
  },
  {
    "code": "D55.0",
    "name": "Anämie durch Glukose-6-Phosphat-Dehydrogenase-Mangel [G6PD-Mangel]",
    "synonyms": [
      "Anämie durch Glukose-6-Phosphat-Dehydrogenase-Inaktivität [G6PD-Inaktivität]",
      "Anämie durch Glukose-6-Phosphat-Dehydrogenase-Mangel [G6PD-Mangel]",
      "Bagdad-Frühlingsanämie",
      "Bohnenkrankheit",
      "Cipriani-Krankheit",
      "Favismus",
      "Favismus mit Anämie",
      "Favismus-Syndrom",
      "Glukose-6-Phosphat-Dehydrogenase-Mangel [G6PD-Mangel] der Klasse 1",
      "Kongenitale nichtsphärozytäre hämolytische Anämie durch Glukose-6-Phosphat-Dehydrogenase-Mangel [G6PD-Mangel]",
      "Neonatale Gelbsucht durch Glukose-6-Phosphat-Dehydrogenase-Defekt-Anämie [G6PD-Defekt-Anämie]",
      "Neonataler Ikterus durch Glukose-6-Phosphat-Dehydrogenase-Defekt-Anämie [G6PD-Defekt-Anämie]",
      "Vergiftung durch Pferdebohnen",
      "Vergiftung durch Vicia faba"
    ]
  },
  {
    "code": "D55.1",
    "name": "Anämie durch Glutathionstoffwechselstörung",
    "synonyms": [
      "Anämie durch 6-PGD-Mangel",
      "Anämie durch 6-Phosphogluconat-Dehydrogenase [6-PGD]-Mangel",
      "Anämie durch Enzymmangel mit Bezug zum Hexosemonophosphat [HMP]-Shunt a.n.k.",
      "Anämie durch Enzymmangel mit Bezug zum Hexosemonophosphat [HMP]-Shunt, ausgenommen G6PD-Mangel",
      "Anämie durch GGS-R-Mangel [Glutathionreduktase-Mangel]",
      "Anämie durch GSH-Mangel [Glutathion-Mangel]",
      "Anämie durch Gamma-Glutamylcystein-Ligase-Mangel",
      "Anämie durch Glutathionreduktasemangel",
      "Anämie durch Glutathionstoffwechselstörung",
      "Anämie durch Glutathionsynthetase-Mangel",
      "Anämie durch Pentose-Phosphat-Stoffwechselstörung",
      "Erythrozyten-Glutathion-Mangelanämie",
      "Hämolytische Anämie durch Gamma-Glutamylcystein-Synthetase-Mangel",
      "Hämolytische Anämie durch Glutathionreduktase-Mangel",
      "Hämolytische nichtsphärozytäre Anämie, Typ I"
    ]
  },
  {
    "code": "D55.2",
    "name": "Anämie durch Pyruvatkinasemangel",
    "synonyms": [
      "Anämie durch 2,3-DPG-Mangel",
      "Anämie durch 2,3-Diphosphoglycerat-Mutase [2,3-DPG]-Mangel",
      "Anämie durch Glycerinaldehyd-3-Phosphat-Dehydrogenase-Mangel",
      "Anämie durch Hexokinase-Defekt",
      "Anämie durch Hexokinasemangel",
      "Anämie durch Mangel eines glykolytischen Enzyms",
      "Anämie durch PK-Mangel",
      "Anämie durch Phosphofruktaldolase-Mangel",
      "Anämie durch Phosphoglyceratkinase-Mangel",
      "Anämie durch Pyruvatkinasemangel",
      "Anämie durch Störung der anaeroben Glykolyse",
      "Anämie durch Triosephosphat-Isomerase-Mangel",
      "Hämolytische Anämie durch Diphosphoglycerat-Mutase-Mangel",
      "Hämolytische Anämie durch Glukosephosphat-Isomerase-Mangel",
      "Hämolytische Anämie durch Glycerinaldehyd-3-Phosphat-Dehydrogenase-Mangel",
      "Hämolytische Anämie durch Mangel der erythrozytären Pyruvatkinase",
      "Hämolytische nicht-sphärozytäre Anämie durch Hexokinasemangel",
      "Hämolytische nichtsphärozytäre Anämie, Typ II",
      "Kongenitale nichtsphärozytäre hämolytische Anämie durch Pyruvatkinase-Mangel",
      "Pyruvatkinase-Mangel der Erythrozyten"
    ]
  },
  {
    "code": "D55.3",
    "name": "Anämie durch Nukleotidstoffwechselstörung",
    "synonyms": [
      "Anämie durch Adenosintriphosphatase-Mangel",
      "Anämie durch Enzymmangel des Nukleotidstoffwechsels",
      "Anämie durch Nukleotidstoffwechselstörung",
      "Anämie durch Störungen des Nukleotidstoffwechsels",
      "Hämolytische Anämie durch Adenylat-Kinase-Mangel",
      "Hämolytische Anämie durch Pyrimidin-5'-Nukleotidase-Mangel",
      "Hämolytische Anämie durch erythrozytäre Adenosindesaminase-Überproduktion"
    ]
  },
  {
    "code": "D55.8",
    "name": "Crosby-Syndrom",
    "synonyms": [
      "Crosby-Syndrom",
      "Hereditäre nichtsphärozytäre hämolytische Anämie a.n.k.",
      "Kongenitale nichtsphärozytäre hämolytische Anämie a.n.k."
    ]
  },
  {
    "code": "D55.9",
    "name": "Anämie durch Enzymdefekt",
    "synonyms": [
      "Anämie durch Enzymdefekt",
      "Anämie durch Enzymmangel",
      "Hereditäre hämolytische Anämie durch Enzymdefekt",
      "Hämolytische Anämie durch Enzymdefekt"
    ]
  },
  {
    "code": "D56.0",
    "name": "Alpha-Thalassämie",
    "synonyms": [
      "Alpha-Thalassaemia intermedia",
      "Alpha-Thalassämie",
      "Syndrom der X-chromosomalen Alpha-Thalassämie mit Intelligenzminderung"
    ]
  },
  {
    "code": "D56.1",
    "name": "Beta-Thalassämie",
    "synonyms": [
      "Beta-Thalassaemia intermedia",
      "Beta-Thalassämie",
      "Beta-Thalassämie major",
      "Cooley-Anämie",
      "Cooley-Krankheit",
      "Cooley-Syndrom",
      "Erythroblasten-Anämie beim Kind",
      "Familiäre erythroblastische Anämie",
      "Hb-C-Beta-Thalassämie",
      "Hb-E-Beta-Thalassämie",
      "Schwere Beta-Thalassämie",
      "Thalassaemia intermedia",
      "Thalassaemia major"
    ]
  },
  {
    "code": "D56.2",
    "name": "Delta-Beta-Thalassämie",
    "synonyms": [
      "Delta-Beta-Thalassämie"
    ]
  },
  {
    "code": "D56.3",
    "name": "Thalassämie-Erbanlage",
    "synonyms": [
      "Beta-Thalassämie minor",
      "Pathologische Hämoglobin-Erbanlage mit Thalassämie",
      "Thalassaemia minor",
      "Thalassämie-Erbanlage"
    ]
  },
  {
    "code": "D56.4",
    "name": "Hereditäre Persistenz des fetalen Hämoglobins",
    "synonyms": [
      "HPFH [Hereditäre Persistenz des fetalen Hämoglobins] mit Beta-Thalassämie",
      "Hereditäre Persistenz des fetalen Hämoglobins",
      "Hereditäre Persistenz des fetalen Hämoglobins mit Beta-Thalassämie"
    ]
  },
  {
    "code": "D56.8",
    "name": "Mikrodrepanozytose",
    "synonyms": [
      "Familiäre mikrozytäre Anämie",
      "Hämoglobin-Lepore-Beta-Thalassämie-Syndrom",
      "Mikrodrepanozyten-Krankheit",
      "Mikrodrepanozytose",
      "Thalassämievariante"
    ]
  },
  {
    "code": "D56.9",
    "name": "Hereditäre Leptozytose",
    "synonyms": [
      "Gemischte Thalassämie",
      "Hereditäre Leptozytose",
      "Hämoglobinopathie mit Thalassämie",
      "Mediterrane Anämie",
      "Mikroelliptopoikilozytäre Anämie [Rietti-Greppi-Micheli]",
      "Mittelmeer-Anämie",
      "Mittelmeer-Anämie mit Hämoglobinopathie",
      "Mittelmeer-Krankheit",
      "Mittelmeer-Syndrom [Thalassämie]",
      "Rietti-Greppi-Micheli-Anämie",
      "Rietti-Greppi-Micheli-Syndrom",
      "Rietti-Krankheit",
      "Thalassämie",
      "Thalassämie-Anämie"
    ]
  },
  {
    "code": "D57.0",
    "name": "Sichelzellenanämie mit Krisen",
    "synonyms": [
      "Hb-SS-Krankheit mit Krisen",
      "Sichelzellenanämie mit Krisen",
      "Sichelzellenkrise"
    ]
  },
  {
    "code": "D57.1",
    "name": "Sichelzellenanämie ohne Krisen",
    "synonyms": [
      "Afrikanische Anämie",
      "Anämie durch Sichelzellenkrankheit",
      "Drepanozytenanämie",
      "Drepanozytische Anämie",
      "Drepanozytose",
      "HbS [Sichelzellenhämoglobin]-Krankheit",
      "Herrick-Anämie",
      "Herrick-Syndrom",
      "Meniskozytenanämie",
      "Sichelzellenanämie",
      "Sichelzellenanämie ohne Krisen",
      "Sichelzellenhämoglobinopathie",
      "Sichelzellenkrankheit",
      "Sichelzellenstörung"
    ]
  },
  {
    "code": "D57.2",
    "name": "Sichelzellen-Thalassämie-Krankheit",
    "synonyms": [
      "Doppelt heterozygote Sichelzellenkrankheit",
      "Hb-SC-Krankheit",
      "Hb-SD-Krankheit",
      "Hb-SE-Krankheit",
      "Sichelzellen-Beta-Thalassämie",
      "Sichelzellen-Hämoglobinopathie mit Thalassämie",
      "Sichelzellen-Thalassämie-Krankheit"
    ]
  },
  {
    "code": "D57.3",
    "name": "Sichelzellenerbanlage",
    "synonyms": [
      "Hb-AS-Erbanlage",
      "Hb-S-Erbanlage",
      "Heterozygote Sichelzellenkrankheit",
      "Heterozygotes Hämoglobin S",
      "Hämoglobin vom AS-Genotyp",
      "Sichelzellenerbanlage",
      "Sichelzellenheterozygotie"
    ]
  },
  {
    "code": "D57.8",
    "name": "Elliptozytose durch Sichelzellenkrankheit",
    "synonyms": [
      "Elliptozytose durch Sichelzellenkrankheit",
      "Sichelzellenerbanlage mit Elliptozytose",
      "Sichelzellenerbanlage mit Sphärozytose",
      "Sphärozytose bei Sichelzellenkrankheit"
    ]
  },
  {
    "code": "D58.0",
    "name": "Minkowski-Chauffard-Syndrom",
    "synonyms": [
      "Acholurische familiäre Gelbsucht",
      "Acholurischer familiärer Ikterus",
      "Angeborener hämolytischer Ikterus",
      "Angeborener sphärozytärer hämolytischer Ikterus",
      "Familiäre Sphärozytose",
      "Gänsslen-Erbsyndrom [Kugelzellenanämie]",
      "Hereditäre Sphärozyten-Anämie",
      "Hereditäre Sphärozytose",
      "Hämolytische familiäre Gelbsucht",
      "Hämolytische konstitutionelle Anämie",
      "Hämolytischer Ikterus",
      "Hämolytischer familiärer Ikterus",
      "Hämolytischer konstitutioneller Ikterus",
      "Kongenitale Sphärozytose",
      "Kongenitale hämolytische Anämie",
      "Kongenitale hämolytische Gelbsucht",
      "Kugelzellenanämie",
      "Kugelzellenkrankheit",
      "Minkowski-Chauffard-Gänsslen-Syndrom",
      "Minkowski-Chauffard-Syndrom",
      "Sphärozytose",
      "Sphärozytose bei Hämoglobinkrankheit"
    ]
  },
  {
    "code": "D58.1",
    "name": "Hereditäre Elliptozytose",
    "synonyms": [
      "Angeborene Elliptozytose",
      "Angeborene Ovalozytose",
      "Dresbach-Syndrom",
      "Elliptozyten-Anämie",
      "Elliptozytose",
      "HE [Hereditäre Elliptozytose]",
      "Hereditäre Elliptozytose",
      "Hereditäre Ovalozytose",
      "Hämoglobin-C-Erbanlage mit Elliptozytose",
      "Hämoglobin-Elliptozytose",
      "Kongenitale Elliptozytose",
      "Kongenitale Ovalozytose",
      "Ovale hereditäre Erythrozytose",
      "Ovalozytose",
      "Südostasiatische Ovalozytose"
    ]
  },
  {
    "code": "D58.2",
    "name": "Hämoglobinopathie a.n.k.",
    "synonyms": [
      "Anomales Hämoglobin",
      "Hb-C-Krankheit",
      "Hb-D-Krankheit",
      "Hb-E-Krankheit",
      "Hb-Krankheit",
      "Hb-Köln-Krankheit",
      "Hb-Zürich-Anomalie",
      "Heinz-Körper-Anämie",
      "Hämoglobin-C-Erbanlage",
      "Hämoglobin-C-Krankheit",
      "Hämoglobin-D-Krankheit",
      "Hämoglobin-E-Krankheit",
      "Hämoglobinkrankheit a.n.k.",
      "Hämoglobinopathie Toms River",
      "Hämoglobinopathie a.n.k.",
      "Hämolytische Anämie durch instabile Hämoglobine",
      "Hämolytische Anämie vom Stransky-Regala-Typ",
      "Instabile hämolytische Hämoglobinkrankheit",
      "Kongenitale Heinz-Körper-Anämie",
      "Kongenitale Innenkörper-Anämie",
      "Pathologische Hämoglobin-Erbanlage a.n.k.",
      "Pathologische Hämoglobinkrankheit a.n.k."
    ]
  },
  {
    "code": "D58.8",
    "name": "Stomatozytose",
    "synonyms": [
      "Atypisches hämolytisch-urämisches Syndrom",
      "Atypisches hämolytisch-urämisches Syndrom mit Anti-Faktor-H-Antikörpern",
      "Familiäre Pseudohyperkaliämie",
      "Hereditäre Kryohydrozytose mit normalem Stomatin",
      "Hereditäre Kryohydrozytose mit reduziertem Stomatin",
      "Hereditäre Stomatozytose",
      "Hereditäre Xerozytose",
      "Hämolytisch-urämisches Syndrom mit DGKE-Mutation",
      "Hämolytisch-urämisches Syndrom mit Diacylglycerolkinase-epsilon-Mutation",
      "Rh [Rhesus]-null-Syndrom",
      "Stomatozytose",
      "Waters-West-Syndrom",
      "Überhydrierte hereditäre Stomatozytose"
    ]
  },
  {
    "code": "D58.9",
    "name": "Hämolytische Anämie",
    "synonyms": [
      "Chronische hämolytische Anämie",
      "Hämolytische Anämie",
      "Hämolytische familiäre Anämie",
      "Hämolytische hereditäre Anämie"
    ]
  },
  {
    "code": "D59.0",
    "name": "Arzneimittelinduzierte autoimmunhämolytische Anämie",
    "synonyms": [
      "Arzneimittelinduzierte autoimmunhämolytische Anämie",
      "Medikamentös bedingte autoimmune hämolytische Anämie",
      "Medikamentös bedingte hämolytische Krankheit"
    ]
  },
  {
    "code": "D59.10",
    "name": "Kälteagglutininkrankheit",
    "synonyms": [
      "CAD [Kälteagglutininkrankheit]",
      "Chronische Kälteagglutininkrankheit",
      "Kälteagglutininkrankheit",
      "Primäre autoimmunhämolytische Krankheit vom Kälteautoantikörper-Typ"
    ]
  },
  {
    "code": "D59.18",
    "name": "Hämolytische Wärmeanämie",
    "synonyms": [
      "Akute hämolytische Lederer-Anämie",
      "Autoimmune Kältesensibilisierung",
      "Autoimmunhämolyse",
      "Autoimmunhämolytische Anämie",
      "Autoimmunhämolytische Anämie vom Wärmeautoantikörper-Typ",
      "Autoimmunhämolytische Anämie vom gemischten Typ",
      "Autoimmunhämolytische Krankheit vom Wärmeautoantikörper-Typ",
      "Autoimmunhämolytische Krankheit vom gemischten Typ",
      "CAS [Kälteagglutinin-Syndrom]",
      "Dyke-Young-Anämie",
      "Erworbene hämolytische autoimmune Anämie a.n.k.",
      "Gemischte autoimmunhämolytische Anämie",
      "Hämolytische Anämie durch Kälteautoantikörper",
      "Hämolytische Anämie durch Wärmeautoantikörper",
      "Hämolytische Autoimmunkrankheit",
      "Hämolytische Kälteanämie",
      "Hämolytische Lederer-Anämie",
      "Hämolytische Wärmeanämie",
      "Hämolytische autoimmune Anämie",
      "Hämolytische autoimmune sekundäre Anämie",
      "Kälte-Hämagglutinin-Syndrom",
      "Kälteagglutinin-Hämoglobinurie",
      "Kälteagglutinin-Syndrom",
      "Lederer-Brill-Syndrom",
      "Neonatale autoimmunhämolytische Anämie",
      "Sekundäre autoimmunhämolytische Anämie vom Kälteautoantikörper-Typ",
      "Sekundäre autoimmunhämolytische Anämie vom Wärmeautoantikörper-Typ",
      "Sekundäre autoimmunhämolytische Krankheit vom Kälteautoantikörper-Typ",
      "Sekundäre autoimmunhämolytische Krankheit vom Wärmeautoantikörper-Typ",
      "Symptomatische hämolytische autoimmune Anämie"
    ]
  },
  {
    "code": "D59.2",
    "name": "Arzneimittelinduzierte nichtautoimmunhämolytische Anämie",
    "synonyms": [
      "Arzneimittelinduzierte Enzymmangelanämie",
      "Arzneimittelinduzierte nichtautoimmunhämolytische Anämie",
      "Hämolytische Anämie durch Arzneimittel",
      "Hämolytische Anämie durch Medikamente",
      "Hämolytische Anämie durch medikamentös bedingten Enzymdefekt",
      "Medikamentös bedingte Enzymmangelanämie",
      "Medikamentös bedingte nichtautoimmunhämolytische Anämie"
    ]
  },
  {
    "code": "D59.3",
    "name": "Hämolytisch-urämisches Syndrom",
    "synonyms": [
      "Hämolytisch-urämisches Syndrom",
      "Hämolytisch-urämisches Syndrom mit Diarrhoe",
      "Infektionsbedingtes hämolytisch-urämisches Syndrom",
      "Typisches hämolytisch-urämisches Syndrom"
    ]
  },
  {
    "code": "D59.4",
    "name": "Hämolytische toxische Anämie",
    "synonyms": [
      "Erworbene hämolytische infektiöse Anämie",
      "Erworbene hämolytische toxische Anämie",
      "Hämolytische mechanische Anämie",
      "Hämolytische mechanische Anämie durch Prothese, Implantat oder Transplantat",
      "Hämolytische mechanische Anämie durch Shunt",
      "Hämolytische toxische Anämie",
      "Mikroangiopathische hämolytische Anämie",
      "Nichtautoimmune hämolytische Anämie",
      "Nichtautoimmune hämolytische Krankheit",
      "Sekundäre hämolytische Anämie",
      "Symptomatische hämolytische Anämie"
    ]
  },
  {
    "code": "D59.5",
    "name": "Nächtliche paroxysmale Hämoglobinurie",
    "synonyms": [
      "Marchiafava-Micheli-Anämie",
      "Marchiafava-Micheli-Syndrom",
      "Nächtliche Hämoglobinurie",
      "Nächtliche paroxysmale Hämaturie",
      "Nächtliche paroxysmale Hämoglobinurie",
      "Nächtliche paroxysmale Hämoglobinämie",
      "PNH [Paroxysmale nächtliche Hämoglobinurie]"
    ]
  },
  {
    "code": "D59.6",
    "name": "Hämoglobinurie durch Hämolyse a.n.k.",
    "synonyms": [
      "Belastungshämoglobinurie",
      "Donath-Landsteiner hämolytische Anämie",
      "Donath-Landsteiner-Syndrom",
      "Harley-Krankheit",
      "Hämoglobinurie durch Belastung a.n.k.",
      "Hämoglobinurie durch Hämolyse a.n.k.",
      "Hämoglobinurie durch erworbene hämolytische Anämie a.n.k.",
      "Intermittierende Hämoglobinurie",
      "Kältehämoglobinurie",
      "Marschhämoglobinurie",
      "Murri-Krankheit",
      "Paroxysmale Hämoglobinämie",
      "Paroxysmale Kältehämoglobinurie"
    ]
  },
  {
    "code": "D59.8",
    "name": "Acholurische erworbene Gelbsucht",
    "synonyms": [
      "Acholurische erworbene Gelbsucht",
      "Erworbener acholurischer Ikterus"
    ]
  },
  {
    "code": "D59.9",
    "name": "Akute hämolytische Anämie",
    "synonyms": [
      "Akute hämolytische Anämie",
      "Chronische idiopathische hämolytische Anämie",
      "Erworbene hämatogene Gelbsucht",
      "Erworbene hämolytische Anämie",
      "Erworbener hämatogener Ikterus",
      "Erworbener hämolytischer Ikterus",
      "Hämoglobinämie"
    ]
  },
  {
    "code": "D60.0",
    "name": "Chronische erworbene isolierte aplastische Anämie",
    "synonyms": [
      "Chronische erworbene isolierte aplastische Anämie",
      "Chronische isolierte Erythrozytenaplasie",
      "Erythroblastopenie im Erwachsenenalter"
    ]
  },
  {
    "code": "D60.1",
    "name": "Transitorische erworbene isolierte aplastische Anämie",
    "synonyms": [
      "Transitorische Erythroblastopenie des Kindesalters",
      "Transitorische aplastische Erythrozyten-Anämie",
      "Transitorische erworbene isolierte aplastische Anämie",
      "Transitorische isolierte Erythrozytenaplasie"
    ]
  },
  {
    "code": "D60.9",
    "name": "Erythroblastopenie",
    "synonyms": [
      "Erworbene Erythrozytenaplasie",
      "Erworbene aplastische Anämie",
      "Erworbene isolierte aplastische Anämie",
      "Erythroblastopenie",
      "Erythroblastophthise",
      "Isolierte Erythrozytenanämie",
      "Isolierte Erythrozytenaplasie bei Thymom",
      "Isolierte aplastische Anämie",
      "Isolierte aplastische Anämie bei Thymom",
      "Isolierte aplastische Anämie beim Erwachsenen",
      "Pure red cell aplasia",
      "RCPA [Pure red cell aplasia]"
    ]
  },
  {
    "code": "D61.0",
    "name": "Angeborene aplastische Anämie",
    "synonyms": [
      "Aase-Smith-Syndrom II",
      "Aase-Smith-Syndrom Typ II",
      "Aase-Syndrom",
      "Angeborene Aplasie der roten Blutkörperchen",
      "Angeborene aplastische Anämie",
      "Angeborene isolierte aplastische Anämie",
      "Blackfan-Diamond-Anämie",
      "Blackfan-Diamond-Syndrom",
      "Diamond-Blackfan-Krankheit",
      "Diamond-Blackfan-Syndrom",
      "Erythrogenesis imperfecta",
      "Familiäre hypoplastische Anämie",
      "Fanconi-Anämie",
      "Fanconi-Panzytopenie",
      "Fanconi-Syndrom",
      "Infantile isolierte Erythrozytenaplasie",
      "Isolierte aplastische Anämie im Kindesalter",
      "Kongenitale PRCA [Pure red cell aplasia]",
      "Kongenitale Panhämozytopenie",
      "Kongenitale Panzytopenie",
      "Kongenitale aplastische Anämie",
      "Kongenitale aplastische Erythrozyten-Anämie",
      "Kongenitale erythrozytäre Hypoplasie",
      "Kongenitale hypoplastische Anämie",
      "Kongenitale hypoplastische Anämie Typ Blackfan-Diamond",
      "Kongenitale isolierte Erythrozytenaplasie",
      "Konstitutionelle Panhämozytopenie",
      "Konstitutionelle Panmyelopathie",
      "Konstitutionelle Panmyelophthise",
      "Konstitutionelle aplastische Anämie",
      "Panzytopenie mit Fehlbildungen",
      "Panzytopenie-Syndrom mit Entwicklungsverzögerung",
      "Primäre isolierte Erythrozytenaplasie",
      "Primäre isolierte aplastische Anämie"
    ]
  },
  {
    "code": "D61.10",
    "name": "Aplastische Anämie durch zytostatische Therapie",
    "synonyms": [
      "Aplastische Anämie durch zytostatische Therapie",
      "Chemotherapiebedingte Panzytopenie",
      "Chemotherapieinduzierte Anämie",
      "Chemotherapieinduzierte Knochenmarkaplasie",
      "Chemotherapieinduzierte Panzytopenie"
    ]
  },
  {
    "code": "D61.19",
    "name": "Arzneimittelinduzierte aplastische Anämie",
    "synonyms": [
      "Aplastische Anämie durch Arzneimittel",
      "Aplastische Anämie durch Medikamente",
      "Arzneimittelinduzierte Panzytopenie",
      "Arzneimittelinduzierte aplastische Anämie"
    ]
  },
  {
    "code": "D61.2",
    "name": "Toxische aplastische Anämie",
    "synonyms": [
      "Alkoholtoxische Knochenmarkschädigung",
      "Aplastische Anämie durch Bestrahlung",
      "Aplastische Anämie durch Infekt",
      "Aplastische Anämie durch Infektion",
      "Aplastische Anämie durch äußere Agenzien a.n.k.",
      "Toxisch bedingtes aplastisches Anämiesyndrom",
      "Toxisch bedingtes aplastisches Syndrom",
      "Toxische Anämie",
      "Toxische aplastische Anämie"
    ]
  },
  {
    "code": "D61.3",
    "name": "Idiopathische aplastische Anämie",
    "synonyms": [
      "Idiopathische aplastische Anämie"
    ]
  },
  {
    "code": "D61.8",
    "name": "Semiplastische Anämie",
    "synonyms": [
      "Semiplastische Anämie"
    ]
  },
  {
    "code": "D61.9",
    "name": "Aleukia haemorrhagica",
    "synonyms": [
      "Aleukia haemorrhagica",
      "Anämie durch Erythrozytenhypoplasie",
      "Anämische Blutbildung",
      "Aplasie des Knochenmarks",
      "Aplastische Anämie",
      "Erworbene Panmyelopathie",
      "Erworbene Panzytopenie",
      "Hypoplastische Anämie",
      "Knochenmarkaplasie",
      "Knochenmarkdepression",
      "Knochenmarkhypoplasie",
      "Knochenmarkinsuffizienz",
      "Knochenmarkschädigung",
      "Medulläre Hypoplasie",
      "Myeloische Knochenmarksaplasie",
      "Normozytäre Anämie bei Myelophthise",
      "Panhämozytopenie",
      "Panmyelopathie",
      "Panmyelophthise",
      "Panzytopenie",
      "Refraktäre hypoproliferative Anämie",
      "Toxische Knochenmarkdepression"
    ]
  },
  {
    "code": "D62",
    "name": "Normozytäre Blutungsanämie",
    "synonyms": [
      "Akute Blutungsanämie",
      "Akute hämorrhagische Schießscheibenzell-Anämie",
      "Akute posthämorrhagische Anämie",
      "Anämie durch akute Blutung",
      "Anämie durch akute Hämorrhagie",
      "Anämie durch akuten Blutverlust",
      "Mikrozytäre Anämie durch akuten Blutverlust",
      "Normozytäre Anämie durch akuten Blutverlust",
      "Normozytäre Blutungsanämie"
    ]
  },
  {
    "code": "D64.0",
    "name": "Hereditäre sideroachrestische Anämie",
    "synonyms": [
      "Autosomal-rezessive sideroblastische Anämie",
      "GLRX5 [Glutaredoxin 5]-abhängige sideroblastische Anämie",
      "Hereditäre sideroachrestische Anämie",
      "Pearson-Syndrom",
      "Schwere angeborene hypochrome Anämie mit Ringsideroblasten",
      "X-chromosomal-gebundene hypochrome sideroachrestische Anämie",
      "X-chromosomale sideroachrestische Anämie mit Ataxie",
      "X-chromosomale sideroblastische Anämie",
      "X-chromosomale sideroblastische Anämie und Ataxie",
      "XLSA [X-chromosomale sideroblastische Anämie]"
    ]
  },
  {
    "code": "D64.1",
    "name": "Sekundäre sideroachrestische Anämie",
    "synonyms": [
      "Sekundäre sideroachrestische Anämie"
    ]
  },
  {
    "code": "D64.2",
    "name": "Sekundäre sideroachrestische Anämie durch Toxine",
    "synonyms": [
      "Bleianämie",
      "Sekundäre sideroachrestische Anämie durch Arzneimittel",
      "Sekundäre sideroachrestische Anämie durch Toxine"
    ]
  },
  {
    "code": "D64.3",
    "name": "Sideroachrestische Anämie",
    "synonyms": [
      "Anämie bei Vitamin-B6-Mangel",
      "Erworbene idiopathische sideroachrestische Anämie",
      "Erworbene primäre sideroblastische Anämie",
      "Hypochrome Anämie mit Eisenspeicherung",
      "Pyridoxinmangelanämie",
      "Pyridoxinsensible Anämie",
      "Pyridoxinsensible sideroachrestische Anämie",
      "Sideroachrestische Anämie",
      "Sideroblastische Anämie",
      "Vitamin-B6-sensible Anämie"
    ]
  },
  {
    "code": "D64.4",
    "name": "Dyserythropoetische kongenitale Anämie",
    "synonyms": [
      "Angeborene dyshämatopoetische Anämie",
      "Angeborene dyshämopoetische Anämie",
      "CDA [Kongenitale dyserythropoetische Anämie] Typ 1",
      "CDA [Kongenitale dyserythropoetische Anämie] Typ 2",
      "CDA [Kongenitale dyserythropoetische Anämie] Typ 3",
      "CDA [Kongenitale dyserythropoetische Anämie] Typ 4",
      "Dyserythropoetische kongenitale Anämie",
      "Dyshämatopoetische Anämie",
      "Dyshämopoetische Anämie",
      "HEMPAS [Hereditary erythroblastic multinuclearity with a positive acidified-serum test]",
      "Kongenitale dyserythropoetische Anämie",
      "Kongenitale dyserythropoetische Anämie Typ 1",
      "Kongenitale dyserythropoetische Anämie Typ 2",
      "Kongenitale dyserythropoetische Anämie Typ 3",
      "Kongenitale dyserythropoetische Anämie Typ 4",
      "Kongenitale dyshämatopoetische Anämie",
      "Kongenitale dyshämopoetische Anämie"
    ]
  },
  {
    "code": "D64.8",
    "name": "Anaemia pleiochromica",
    "synonyms": [
      "Anaemia pleiochromica",
      "Anaemia splenica",
      "Anämie bei Pseudoleukämie",
      "Heuck-Assmann-Anämie",
      "Hydrämie",
      "Hyperchrome Anämie",
      "Infantile Pseudoleukämie",
      "Infektiöse Anämie",
      "Isolierte Störung der Erythropoese",
      "Leukoerythroblastische Anämie",
      "Leukoerythroblastose",
      "Leukoerythrose",
      "Myelogene Anämie",
      "Myelopathische Anämie",
      "Osteosklerotische Anämie",
      "Pleiochrome Anämie",
      "Schießscheibenzell-Anämie",
      "Septische Anämie",
      "Splenomegale Anämie",
      "Targetzellen-Anämie",
      "Von-Jaksch-Hayem-Luzet-Krankheit",
      "Von-Jaksch-Hayem-Syndrom",
      "Von-Jaksch-Krankheit"
    ]
  },
  {
    "code": "D64.9",
    "name": "Oligozythämie",
    "synonyms": [
      "Anaemia",
      "Anämie",
      "Anämie bei Infekt",
      "Anämie bei Infektion",
      "Anämie durch Hämoglobinmangel",
      "Anämie in der Kindheit",
      "Aregenerative Anämie",
      "Atypische primäre Anämie",
      "Blutarmut",
      "Einfache Anämie",
      "Erythrozytopenie",
      "Essentielle Anämie",
      "Hb [Hämoglobin]-Mangel",
      "Hypoglobulie",
      "Hypoämie",
      "Hämoglobinmangel",
      "Idiopathische Anämie",
      "Infantile Anämie",
      "Latente Anämie",
      "Niedriges Hämoglobin a.n.k.",
      "Normochrome Anämie",
      "Normozytäre Anämie",
      "Oligoglobulie",
      "Oligozythämie",
      "Oligämie",
      "Primäre Anämie",
      "Progressive Anämie",
      "Schwere Anämie",
      "Sekundäre Anämie"
    ]
  },
  {
    "code": "D65.0",
    "name": "Erworbene Afibrinogenämie",
    "synonyms": [
      "Erworbene Afibrinogenämie",
      "Erworbene Fibrinogenopenie",
      "Erworbene Hypofibrinogenämie",
      "Erworbener Faktor-I-Mangel",
      "Erworbener Fibrinogenmangel"
    ]
  },
  {
    "code": "D65.1",
    "name": "Disseminierte intravasale Gerinnung",
    "synonyms": [
      "DIC [Disseminated intravascular coagulation]",
      "DIG [Disseminierte intravasale Gerinnung]",
      "Diffuse intravasale Gerinnung",
      "Diffuse intravasale Koagulation",
      "Disseminierte intravasale Gerinnung",
      "Disseminierte intravasale Koagulation",
      "Gangränöse Purpura mit Verbrauchskoagulopathie",
      "Intravasale Gerinnung",
      "Intravasale Koagulation",
      "Verbrauchskoagulopathie"
    ]
  },
  {
    "code": "D65.2",
    "name": "Fibrinolytische Purpura",
    "synonyms": [
      "Erworbene Fibrinolyse",
      "Erworbene Fibrinolyseblutung",
      "Erworbene fibrinolytische Blutung",
      "Erworbene fibrinolytische Hämorrhagie",
      "Fibrinogenolyse",
      "Fibrinogenolysehämorrhagie",
      "Fibrinolyse",
      "Fibrinolytische Purpura",
      "Hyperfibrinolyse",
      "Thrombolytische Purpura"
    ]
  },
  {
    "code": "D65.9",
    "name": "Defibrinierungssyndrom",
    "synonyms": [
      "Defibrinationssyndrom",
      "Defibrinierungssyndrom",
      "Erworbene Purpura fulminans",
      "Purpura fulminans"
    ]
  },
  {
    "code": "D66",
    "name": "Hereditärer Faktor-VIII-Mangel",
    "synonyms": [
      "Bluterkrankheit",
      "Faktor-VIII-Mangel",
      "Faktor-VIII-Mangel mit Funktionsstörung",
      "Familiäre Hämophilie",
      "Hereditäre Hämophilie",
      "Hereditärer Faktor-VIII-Mangel",
      "Hämophilie",
      "Hämophilie A",
      "Hämophilie A mit Faktor-VIII-Alloantikörper",
      "Klassische Hämophilie",
      "Mangel an antihämophilem Globulin a.n.k."
    ]
  },
  {
    "code": "D67",
    "name": "Hereditärer Faktor-IX-Mangel",
    "synonyms": [
      "Christmas disease",
      "Christmas-Krankheit",
      "Faktor-IX-Mangel",
      "Faktor-IX-Mangel mit Funktionsstörung",
      "Hereditärer Faktor-IX-Mangel",
      "Hämophilie B",
      "Hämophilie B Typ Leyden",
      "Hämophilie B mit Faktor-IX-Alloantikörper",
      "Mangel der Plasma-Thromboplastin-Komponente",
      "PTC [Plasma-thromboplastin-component]-Mangel",
      "Plasma-thromboplastin-component-Mangel"
    ]
  },
  {
    "code": "D68.00",
    "name": "Hereditäre Pseudohämophilie",
    "synonyms": [
      "Hereditäre Pseudohämophilie",
      "Hereditäres Von-Willebrand-Jürgens-Syndrom",
      "Konstitutionelle Thrombopathie",
      "Von-Willebrand-Syndrom Typ 1",
      "Von-Willebrand-Syndrom Typ 2",
      "Von-Willebrand-Syndrom Typ 2A",
      "Von-Willebrand-Syndrom Typ 2B",
      "Von-Willebrand-Syndrom Typ 2M",
      "Von-Willebrand-Syndrom Typ 2N",
      "Von-Willebrand-Syndrom Typ 3"
    ]
  },
  {
    "code": "D68.01",
    "name": "Erworbenes Von-Willebrand-Jürgens-Syndrom",
    "synonyms": [
      "Erworbenes Von-Willebrand-Jürgens-Syndrom"
    ]
  },
  {
    "code": "D68.09",
    "name": "Vaskuläre Hämophilie",
    "synonyms": [
      "Angiohämophilie",
      "Angiohämophilie A",
      "Angiohämophilie B",
      "Angiohämophilie-Syndrom",
      "Bernuth-Pseudohämophilie",
      "Faktor-VIII-Mangel mit Gefäßendothelfunktionsstörung",
      "Faktor-VIII-Mangel mit vaskulärer Dysfunktion",
      "Pseudohämophilie",
      "Pseudohämophilie vom Typ B",
      "Vaskuläre Hämophilie",
      "Von-Bernuth-Syndrom",
      "Von-Willebrand-Jürgens-Syndrom",
      "Von-Willebrand-Syndrom",
      "Willebrand-Jürgens-Thrombopathie"
    ]
  },
  {
    "code": "D68.1",
    "name": "Hereditärer Faktor-XI-Mangel",
    "synonyms": [
      "Faktor-XI-Mangel",
      "Hereditärer Faktor-XI-Mangel",
      "Hämophilie C",
      "Kongenitaler Faktor-XI-Mangel",
      "PTA [Plasma-thromboplastin-antecedent]-Mangel",
      "Plasma-thromboplastin-antecedent-Mangel",
      "Rosenthal-Faktor-Mangel",
      "Rosenthal-Krankheit",
      "Rosenthal-Syndrom"
    ]
  },
  {
    "code": "D68.20",
    "name": "Dysfibrinogenämie",
    "synonyms": [
      "Angeborene Afibrinogenämie",
      "Angeborene Dysfibrinogenämie",
      "Dysfibrinogenämie",
      "Faktor-I-Mangel",
      "Familiäre Afibrinogenämie",
      "Familiäre Dysfibrinogenämie",
      "Familiäre Hypofibrinogenämie",
      "Fibrinogenmangel",
      "Fibrinopenie",
      "Hereditäre Fibrinopenie",
      "Hereditärer Faktor-I-Mangel",
      "Hereditärer Fibrinogenmangel",
      "Kongenitale Afibrinogenämie",
      "Kongenitale Dysfibrinogenämie",
      "Kongenitale Fibrinogenopenie",
      "Kongenitale Hypofibrinogenämie",
      "Kongenitaler Faktor-I-Mangel",
      "Kongenitaler Fibrinogenmangel"
    ]
  },
  {
    "code": "D68.21",
    "name": "Hypoprothrombinämie",
    "synonyms": [
      "Dysprothrombinämie",
      "Faktor-II-Mangel",
      "Hereditäre Hypoprothrombinämie",
      "Hereditärer Faktor-II-Mangel",
      "Hereditärer Prothrombinmangel",
      "Hypoprothrombinämie",
      "Idiopathische Hypoprothrombinämie",
      "Kongenitale Hypoprothrombinämie",
      "Kongenitaler Faktor-II-Mangel",
      "Kongenitaler Prothrombinmangel",
      "Prothrombinmangel"
    ]
  },
  {
    "code": "D68.22",
    "name": "Parahämophilie",
    "synonyms": [
      "Gerinnungsdefekt durch Faktor-V-Amsterdam-Mutation",
      "Gerinnungsdefekt durch Faktor-V-Atlanta-Mutation",
      "Hereditärer AC-Globulin-Mangel",
      "Hereditärer Faktor-V-Mangel",
      "Hereditärer Mangel an labilem Faktor",
      "Hereditärer Proakzelerinmangel",
      "Hypoproakzelerinämie",
      "Kongenitaler AC-Globulin-Mangel",
      "Kongenitaler Faktor-V-Mangel",
      "Kongenitaler Mangel an labilem Faktor",
      "Kongenitaler Proakzelerinmangel",
      "Owren-Krankheit",
      "Owren-Syndrom",
      "Parahämophilie",
      "Proakzelerinmangel"
    ]
  },
  {
    "code": "D68.23",
    "name": "Hypoprokonvertinämie",
    "synonyms": [
      "Faktor-VII-Mangel",
      "Hereditärer Faktor-VII-Mangel",
      "Hereditärer Prokonvertin-Faktor-Mangel",
      "Hypoprokonvertinämie",
      "Kongenitale Hypoprokonvertinämie",
      "Kongenitale hereditäre Hypoprokonvertinämie",
      "Kongenitaler Faktor-VII-Mangel",
      "Kongenitaler Prokonvertin-Faktor-Mangel",
      "Konstitutioneller Prokonvertin-Mangel",
      "SPCA [Serum prothrombin conversion accelerator]-Mangel",
      "Stabiler-Faktor-Mangel"
    ]
  },
  {
    "code": "D68.24",
    "name": "Kongenitaler Faktor-X-Mangel",
    "synonyms": [
      "Faktor-X-Mangel",
      "Hereditärer Faktor-X-Mangel",
      "Kongenitaler Faktor-X-Mangel",
      "Kongenitaler Stuart-Faktor-Mangel",
      "Kongenitaler Stuart-Prower-Faktor-Mangel",
      "Stuart-Prower-Faktor-Mangel"
    ]
  },
  {
    "code": "D68.25",
    "name": "Defekt des Hageman-Faktors",
    "synonyms": [
      "Defekt des Hageman-Faktors",
      "Faktor-XII-Mangel",
      "Hageman-Faktor-Mangel",
      "Hageman-Faktor-Syndrom",
      "Hageman-Syndrom",
      "Hereditärer Faktor-XII-Mangel",
      "Kongenitaler Faktor-XII-Mangel",
      "Kongenitaler Hageman-Faktor-Mangel"
    ]
  },
  {
    "code": "D68.26",
    "name": "Hereditärer Faktor-XIII-Mangel",
    "synonyms": [
      "Faktor-XIII-Mangel",
      "Fibrinstabilisierender Faktor-Mangel",
      "Hereditärer Faktor-XIII-Mangel",
      "Hereditärer Mangel an fibrinstabilisierendem Faktor",
      "Kongenitaler Faktor-XIII-Mangel",
      "Kongenitaler Mangel an fibrinstabilisierendem Faktor"
    ]
  },
  {
    "code": "D68.28",
    "name": "Hereditärer Gerinnungsfaktormangel a.n.k.",
    "synonyms": [
      "Angeborener Mangel an Gerinnungsfaktoren",
      "Bluterkrankheit vom Ost-Texanischen Typ",
      "Gerinnungsfaktordefekt a.n.k.",
      "Hereditärer Gerinnungsfaktormangel a.n.k.",
      "Hereditärer Koagulationsfaktorenmangel a.n.k.",
      "Hereditärer kombinierter Mangel an Faktoren II, VII, IX und X",
      "Hereditärer kombinierter Mangel an Faktoren VII und X",
      "Hereditärer kombinierter Mangel an Vitamin K-abhängigen Gerinnungsfaktoren",
      "Koagulationsfaktorenstörung a.n.k."
    ]
  },
  {
    "code": "D68.31",
    "name": "Hämorrhagische Diathese durch Anti-VIIIa-Vermehrung",
    "synonyms": [
      "Faktor-VIII-Mangel durch Hemmkörperhämophilie",
      "Hemmkörperhämophilie gegen Faktor VIII",
      "Hämorrhagische Diathese durch Anti-VIIIa-Vermehrung",
      "Hämorrhagische Diathese durch Vermehrung von Antikörpern gegen Faktor VIII"
    ]
  },
  {
    "code": "D68.32",
    "name": "Antithromboplastinämie",
    "synonyms": [
      "Antithromboplastinogenämie",
      "Antithromboplastinämie",
      "Faktor-IX-Mangel durch Hemmkörperhämophilie",
      "Faktor-X-Mangel durch Hemmkörperhämophilie",
      "Faktor-XI-Mangel durch Hemmkörperhämophilie",
      "Hemmkörperhämophilie gegen Faktor IXa",
      "Hemmkörperhämophilie gegen Faktor V",
      "Hemmkörperhämophilie gegen Faktor VII",
      "Hemmkörperhämophilie gegen Faktor XI",
      "Hemmkörperhämophilie gegen Faktor XIII",
      "Hemmkörperhämophilie gegen Faktor Xa",
      "Hemmkörperhämophilie gegen Von-Willebrand-Faktor",
      "Hämorrhagische Diathese durch Anti-IXa-Vermehrung",
      "Hämorrhagische Diathese durch Anti-XIa-Vermehrung",
      "Hämorrhagische Diathese durch Anti-Xa-Vermehrung",
      "Hämorrhagische Diathese durch Antikörper gegen Von-Willebrand-Faktor"
    ]
  },
  {
    "code": "D68.33",
    "name": "Marcumar-Blutung",
    "synonyms": [
      "Blutung bei Dauertherapie mit Cumarinen",
      "Blutung bei Dauertherapie mit Vitamin-K-Antagonisten",
      "Blutung bei Falithrom-Therapie",
      "Blutung bei Marcumar-Therapie",
      "Falithrom-Blutung",
      "Hämorrhagische Diathese durch Cumarine",
      "Hämorrhagische Diathese durch Vitamin-K-Antagonisten",
      "Marcumar-Blutung"
    ]
  },
  {
    "code": "D68.34",
    "name": "Hyperheparinämie",
    "synonyms": [
      "Blutung bei Heparin-Therapie",
      "Hyperheparinämie",
      "Hämorrhagische Diathese durch Heparine"
    ]
  },
  {
    "code": "D68.35",
    "name": "Hämaturie bei Antikoagulanzientherapie",
    "synonyms": [
      "Blutung bei Antikoagulanziendauertherapie",
      "Hämaturie bei Antikoagulanzientherapie",
      "Hämorrhagische Diathese durch Antikoagulanzien",
      "Hämorrhagische Diathese durch Apixaban",
      "Hämorrhagische Diathese durch Bivalirudin",
      "Hämorrhagische Diathese durch Dabigatran",
      "Hämorrhagische Diathese durch Desirudin",
      "Hämorrhagische Diathese durch Edoxaban",
      "Hämorrhagische Diathese durch Fondaparinux",
      "Hämorrhagische Diathese durch Hirudin",
      "Hämorrhagische Diathese durch Lepirudin",
      "Hämorrhagische Diathese durch Rivaroxaban",
      "Hämorrhagische Diathese durch reversible Faktor-IIa-Hemmer",
      "Hämorrhagische Diathese durch reversible Thrombin-Hemmer",
      "Hämorrhagische Diathese durch selektive Faktor-Xa-Hemmer",
      "Hämorrhagische Störung durch zirkulierende Antikoagulanzien"
    ]
  },
  {
    "code": "D68.38",
    "name": "Hemmkörperhämophilie",
    "synonyms": [
      "Hemmkörperhämophilie",
      "Hämorrhagische Diathese durch Antikörper gegen Gerinnungsfaktoren",
      "Immunhemmkörperhämophilie"
    ]
  },
  {
    "code": "D68.4",
    "name": "Erworbener Mangel an Gerinnungsfaktoren",
    "synonyms": [
      "Blutung durch Vitamin-K-Mangel",
      "Erworbene Fibrinopenie",
      "Erworbene Hypoprothrombinämie",
      "Erworbene Hämophilie",
      "Erworbene Prokonvertin-Faktor-Mangel",
      "Erworbener AC-Globulin-Mangel",
      "Erworbener Faktor II-Mangel",
      "Erworbener Faktor-IX-Mangel",
      "Erworbener Faktor-V-Mangel",
      "Erworbener Faktor-VII-Mangel",
      "Erworbener Faktor-VIII-Mangel",
      "Erworbener Faktor-X-Mangel",
      "Erworbener Faktor-XI-Mangel",
      "Erworbener Faktor-XII-Mangel",
      "Erworbener Faktor-XIII-Mangel",
      "Erworbener Mangel an Gerinnungsfaktoren",
      "Erworbener Mangel an Koagulationsfaktoren",
      "Erworbener Mangel an fibrinstabilisierendem Faktor",
      "Erworbener Mangel an labilem Faktor",
      "Erworbener Proakzelerinmangel",
      "Erworbener Prothrombinmangel",
      "Gerinnungsdefekt durch Hyperprothrombinämie",
      "Gerinnungsdefekt durch Leberkrankheit",
      "Gerinnungsdefekt durch Vitamin-K-Mangel",
      "Gerinnungsfaktormangel durch Leberkrankheit",
      "Gerinnungsfaktormangel durch Vitamin-K-Mangel",
      "Kalziprive Hämophilie",
      "Koagulationsdefekt durch Hyperprothrombinämie",
      "Koagulationsdefekt durch Leberkrankheit",
      "Koagulationsdefekt durch Vitamin-K-Mangel",
      "Mangel an Koagulationsfaktoren durch Leberkrankheit",
      "Mangel an Koagulationsfaktoren durch Vitamin-K-Mangel",
      "Nichtfamiliäre Hämophilie"
    ]
  },
  {
    "code": "D68.5",
    "name": "Antithrombinämie",
    "synonyms": [
      "APC-Resistenz [Resistenz gegen aktiviertes Protein C]",
      "AT-III-Mangel",
      "Angeborener Antithrombin-III-Mangel",
      "Antithrombin-III-Mangel",
      "Antithrombin-Mangel",
      "Antithrombinämie",
      "Autosomal-rezessive Thrombophilie durch angeborenen Protein-C-Mangel",
      "Autosomal-rezessive Thrombophilie durch angeborenen Protein-S-Mangel",
      "Familiäre Thrombomodulin-Anomalie",
      "Hereditäre Thrombophilie durch kongenitalen Antithrombin-III-Mangel",
      "Hereditäre Thrombophilie durch kongenitalen Antithrombin-Mangel",
      "Hereditäre Thrombophilie durch kongenitalen HRG [histidinreiches Glykoprotein]-Mangel",
      "Hereditäre Thrombophilie durch kongenitalen Protein-C-Mangel",
      "Hereditäre Thrombophilie durch kongenitalen Protein-S-Mangel",
      "Hämorrhagische Diathese durch Antithrombin-Vermehrung",
      "Koagulopathie durch Faktor-V-Genmutation",
      "Primäre Thrombophilie",
      "Protein-C-Mangel",
      "Protein-S-Mangel",
      "Prothrombin-Gen-Mutation",
      "Thrombomodulin-abhängige Blutgerinnungsstörung"
    ]
  },
  {
    "code": "D68.6",
    "name": "Antiphospholipidsyndrom",
    "synonyms": [
      "APS [Antiphospholipidsyndrom]",
      "Antikardiolipinsyndrom",
      "Antiphospholipid-Antikörper-Syndrom",
      "Antiphospholipidsyndrom",
      "Hughes-Syndrom",
      "Inhibitor des systemischen Lupus erythematodes",
      "Katastrophales Antiphospholipidsyndrom",
      "Neonatales Antiphospholipidsyndrom",
      "Thrombophilie",
      "Vorhandensein des Lupus-Antikoagulanz"
    ]
  },
  {
    "code": "D68.8",
    "name": "Fibrinogenopenie",
    "synonyms": [
      "Afibrinogenämie",
      "Erworbener Mangel an Antithrombin III",
      "Erworbener Protein-S-Mangel",
      "Familiäre Thrombozytose",
      "Fibrinogenopenie",
      "Hypofibrinogenämie",
      "Kombinierter Mangel an Faktoren V und VIII",
      "Kongenitaler Alpha-2-Antiplasmin-Mangel",
      "Kongenitaler Mangel an hochmolekularem Kininogen",
      "Kongenitaler Plasminogen-Aktivator-Inhibitor-1-Mangel",
      "Kongenitaler Präkallikrein-Mangel",
      "Multipler Faktorenmangel",
      "Plasminogen-Mangel Typ 1",
      "Thrombogene Koagulopathie"
    ]
  },
  {
    "code": "D68.9",
    "name": "Gerinnungsstörung",
    "synonyms": [
      "Bluter",
      "Blutgerinnungsdefekt",
      "Blutgerinnungsstörung",
      "Blutungsneigung",
      "Erhöhte Blutungsneigung",
      "Erworbene Blutungsneigung",
      "Erworbener Gerinnungsdefekt",
      "Erworbener Koagulationsdefekt",
      "Familiär bedingter Bluter",
      "Familiäre Blutung",
      "Familiäre Hämorrhagie",
      "Gerinnungsdefekt",
      "Gerinnungsstörung",
      "Gerinnungsstörung beim Erwachsenen",
      "Hereditärer Bluter",
      "Hyperkoagulabilität",
      "Hämostasestörung",
      "Koagulationsdefekt",
      "Koagulationsstörung",
      "Koagulopathie",
      "Krankheit durch Mangel an Koagulationsfaktoren",
      "Mangelnde Blutgerinnung",
      "Neigung zur Hämorrhagie",
      "Verminderung von Blutgerinnungsfaktoren"
    ]
  },
  {
    "code": "D69.0",
    "name": "Hirnpurpura",
    "synonyms": [
      "Allergische Purpura",
      "Allergische Vaskulitis",
      "Anaphylaktische Purpura",
      "Autoimmunvaskulitis",
      "Bakterielle Purpura",
      "Gangränöse Purpura",
      "Gangränöse Purpura ohne Verbrauchskoagulopathie",
      "Gehirnpurpura",
      "Henoch-Schoenlein-Krankheit",
      "Henoch-Schoenlein-Syndrom",
      "Hirnpurpura",
      "Hämorrhagische nichtthrombozytopenische Purpura",
      "Idiopathische nichtthrombozytopenische Purpura",
      "IgA [Immunglobulin A]-Vaskulitis",
      "Immunkomplex-Vaskulitis",
      "Immunoglobulin A-Vaskulitis",
      "Immunvaskulitis",
      "Immunvaskuläre Reaktion",
      "Infektiöse Purpura",
      "Kapilläre hämorrhagische Toxikose",
      "Maligne Purpura",
      "Medikamenten-induzierte Vaskulitis",
      "Morbus Schoenlein-Henoch",
      "Peliosis",
      "Peliosis rheumatica",
      "Purpura Schoenlein-Henoch",
      "Purpura abdominalis",
      "Purpura allergica",
      "Purpura anaphylactoides",
      "Purpura mit viszeralen Symptomen",
      "Purpura nervosa",
      "Purpura rheumatica",
      "Purpura symptomatica",
      "Rheumatische Purpura",
      "Schoenlein-Henoch-Krankheit",
      "Schoenlein-Henoch-Syndrom",
      "Toxische Purpura",
      "Vasculitis allergica",
      "Vaskuläre Purpura"
    ]
  },
  {
    "code": "D69.1",
    "name": "Qualitativer Thrombozytendefekt",
    "synonyms": [
      "Autosomal-dominante Makrothrombozytopenie",
      "Autosomal-rezessive schwergradige Makrothrombozytopenie",
      "Bernard-Soulier-Syndrom",
      "Bernard-Soulier-Thrombopathie",
      "Blutungskrankheit durch CalDAG-GEFI [Calcium and DAG-regulated guanine nucleotide exchange factor-1]-Defizienz",
      "Diathesis thrombasthenica",
      "Dystrophische Thrombozytopathie",
      "Glanzmann-Naegeli-Syndrom",
      "Glanzmann-Naegeli-Thrombasthenie",
      "Glanzmann-Syndrom",
      "Glanzmann-Thrombasthenie",
      "Glanzmann-Thrombozytasthenie",
      "Graue-Thrombozyten-Syndrom",
      "Grey-platelet-Syndrom",
      "Hereditäre Thrombasthenie",
      "Hereditäre hämorrhagische Thrombasthenie",
      "Hämorrhagische Diathese durch Kollagen-Rezeptor-Defekt",
      "Hämorrhagische Thrombasthenie",
      "Hämorrhagische Thrombozytendystrophie",
      "Isolierte Delta-Storage-Pool-Krankheit",
      "Kombinierte Alpha-delta-Storage-Pool-Krankheit",
      "Makrothrombozytopenie Typ Medich",
      "PLA2G4A [Phospholipase-A2-Gruppe-IVa]-abhängige Blutplättchendysfunktion",
      "Pseudo-von-Willebrand-Syndrom",
      "Purpura thrombasthenica",
      "Qualitativer Thrombozytendefekt",
      "Quebec-Platelet-Syndrom",
      "Riesen-Plättchen-Syndrom",
      "Riesenthrombozyten-Syndrom",
      "Stormorken-Syndrom",
      "Störung der Thrombozytenfunktion",
      "Thrombasthenie",
      "Thrombopathie",
      "Thrombozytasthenie",
      "Thrombozytendefekt",
      "Thrombozytopathie",
      "Thrombozytopathie mit Granulozytopenie",
      "White-platelet-Syndrom"
    ]
  },
  {
    "code": "D69.2",
    "name": "Purpura senilis",
    "synonyms": [
      "Autoerythrozytäre Sensibilisierung",
      "Autoerythrozytäres Sensibilisierungssyndrom",
      "Blutfleckenkrankheit",
      "Erythrozytäre Autosensibilisierung",
      "Gardner-Diamond-Syndrom",
      "Kutane Blutung durch erythrozytäre Autosensibilisierung",
      "Kutane Hämorrhagie durch erythrozytäre Autosensibilisierung",
      "Nichtthrombopenische Purpura",
      "Nichtthrombozytopenische Purpura",
      "Petechiale Blutung durch erythrozytäre Autosensibilisierung",
      "Petechiale Hämorrhagie durch erythrozytäre Autosensibilisierung",
      "Purpura",
      "Purpura senilis",
      "Purpura simplex"
    ]
  },
  {
    "code": "D69.3",
    "name": "Chronische idiopathische Thrombozytopenie",
    "synonyms": [
      "Akute essentielle Thrombopenie",
      "Akute idiopathische Thrombozytopenie",
      "Chronische essentielle Thrombopenie",
      "Chronische idiopathische Thrombozytopenie",
      "Essentielle Thrombozytopenie",
      "Evans-Syndrom",
      "Hämorrhagische Purpura",
      "Idiopathische Thrombozytopenie",
      "Idiopathische thrombozytopenische Purpura",
      "Immunthrombozytopenie",
      "Morbus Werlhof",
      "Morbus maculosus haemorrhagicus Werlhof",
      "Purpura haemorrhagica",
      "Thrombozytopenische Purpura",
      "Thrombozytopenische Purpura idiopathica",
      "Werlhof-Krankheit",
      "Werlhof-Purpura",
      "Werlhof-Wichmann-Syndrom"
    ]
  },
  {
    "code": "D69.40",
    "name": "Transfusionsrefraktäre kongenitale thrombozytopenische Purpura",
    "synonyms": [
      "Transfusionsrefraktäre kongenitale Thrombozytopenie",
      "Transfusionsrefraktäre kongenitale thrombozytopenische Purpura",
      "Transfusionsrefraktäre megakaryozytische Hypoplasie"
    ]
  },
  {
    "code": "D69.41",
    "name": "Konstitutionelle Thrombopenie",
    "synonyms": [
      "Angeborene amegakaryozytische Thrombozytopenie",
      "Autosomal-dominante Thrombozytopenie mit Sekretionsdefekt der Thrombozyten",
      "Hereditäre Purpura thrombopenica",
      "Hereditäre Thrombozytopenie",
      "Hereditäre Thrombozytopenie mit normalen Thrombozyten",
      "Hereditäre thrombozytopenische Purpura",
      "Kongenitale Purpura thrombopenica",
      "Kongenitale Thrombozytopenie",
      "Kongenitale thrombozytopenische Purpura",
      "Konstitutionelle Thrombopenie",
      "MYH9-assoziierte Thrombozytopenie",
      "Megakaryozytische Knochenmarkhypoplasie",
      "Primäre Thrombozytopenie"
    ]
  },
  {
    "code": "D69.52",
    "name": "Heparininduzierte Thrombozytopenie Typ I",
    "synonyms": [
      "Heparin-assoziierte Thrombozytopenie",
      "Heparininduzierte Thrombozytopenie Typ I"
    ]
  },
  {
    "code": "D69.53",
    "name": "Heparininduzierte Thrombozytopenie Typ II",
    "synonyms": [
      "Heparininduzierte Thrombozytopenie Typ II"
    ]
  },
  {
    "code": "D69.57",
    "name": "Transfusionsrefraktäre sekundäre Thrombozytopenie",
    "synonyms": [
      "Transfusionsrefraktäre allergische Thrombozytopenie",
      "Transfusionsrefraktäre medikamentöse Thrombozytopenie",
      "Transfusionsrefraktäre sekundäre Thrombozytopenie"
    ]
  },
  {
    "code": "D69.58",
    "name": "Allergische Thrombozytopenie",
    "synonyms": [
      "Alkoholische Thrombozytopenie",
      "Allergische Thrombozytopenie",
      "Autoimmunthrombozytopenie",
      "Medikamentöse Thrombozytopenie",
      "Thrombozytopenie durch Arzneimittel",
      "Thrombozytopenie durch Blutverdünnung",
      "Thrombozytopenie durch Thrombozyten-Alloimmunisation",
      "Thrombozytopenie durch extrakorporalen Blutkreislauf",
      "Thrombozytopenie durch massive Bluttransfusion"
    ]
  },
  {
    "code": "D69.59",
    "name": "Sekundäre Thrombozytopenie",
    "synonyms": [
      "Sekundäre Thrombozytopenie"
    ]
  },
  {
    "code": "D69.60",
    "name": "Transfusionsrefraktäre Thrombozytopenie",
    "synonyms": [
      "Transfusionsrefraktäre Thrombozytopenie",
      "Transfusionsrefraktäre thrombozytopenische Anämie",
      "Transfusionsrefraktärer Blutplättchenmangel"
    ]
  },
  {
    "code": "D69.61",
    "name": "Thrombopenie",
    "synonyms": [
      "Blutplättchenmangel",
      "Blutplättchenverminderung",
      "Erniedrigte Thrombozytenzahl",
      "Thrombopenie",
      "Thrombopenische Anämie",
      "Thrombozytopenie",
      "Thrombozytopenische Anämie"
    ]
  },
  {
    "code": "D69.80",
    "name": "Hämorrhagische Diathese durch Thrombozytenaggregationshemmer",
    "synonyms": [
      "Blutung bei Dauertherapie mit Thrombozytenaggregationshemmern",
      "Hämorrhagische Diathese durch Thrombozytenaggregationshemmer"
    ]
  },
  {
    "code": "D69.88",
    "name": "Kongenitale Kapillarfragilität",
    "synonyms": [
      "Defekt des thrombozytären ADP [Adenosindiphosphat]-Rezeptors P2Y12",
      "Endotheliose",
      "Hereditäre Brüchigkeit eines Kapillargefäßes",
      "Hereditäre Kapillarbrüchigkeit",
      "Hämorrhagische Diathese durch Thromboxan-Synthetase-Mangel",
      "Hämorrhagische infektiöse Endotheliose",
      "Kapillarbrüchigkeit",
      "Kongenitale Kapillarfragilität",
      "Primäre kapilläre Blutung",
      "Primäre kapilläre Hämorrhagie",
      "Pseudohämophilie vom Typ A",
      "Purpura durch idiopathische Kapillarbrüchigkeit",
      "Scott-Syndrom",
      "Vaskuläre Pseudohämophilie"
    ]
  },
  {
    "code": "D69.9",
    "name": "Geplatztes Äderchen",
    "synonyms": [
      "Blutungsbereitschaft",
      "Familiäre hämorrhagische Diathese",
      "Geplatztes Äderchen",
      "Hämorrhagische Diathese",
      "Hämorrhagische Krankheit",
      "Hämorrhagische Störung a.n.k."
    ]
  },
  {
    "code": "D70.0",
    "name": "Genetisch bedingte Agranulozytose",
    "synonyms": [
      "Agranulocytosis infantilis hereditaria",
      "Angeborene Neutropenie",
      "Autosomal-dominante schwere kongenitale Neutropenie",
      "Autosomal-rezessive schwere kongenitale Neutropenie durch CSF3R-Defizienz",
      "Autosomal-rezessive schwere kongenitale Neutropenie durch CXCR2-Defizienz",
      "Autosomal-rezessive schwere kongenitale Neutropenie durch G6PC3-Defizienz",
      "Autosomal-rezessive schwere kongenitale Neutropenie durch JAGN1-Defizienz",
      "Genetisch bedingte Agranulozytose",
      "Hereditäre Agranulozytose",
      "Infantile Agranulozytose",
      "Kongenitale Neutropenie",
      "Kostmann-Syndrom",
      "Primäre Neutropenie",
      "X-chromosomale schwere kongenitale Neutropenie"
    ]
  },
  {
    "code": "D70.10",
    "name": "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase unter 4 Tagen",
    "synonyms": [
      "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase unter 4 Tagen"
    ]
  },
  {
    "code": "D70.11",
    "name": "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 10 Tagen bis unter 20 Tagen",
    "synonyms": [
      "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 10 Tagen bis unter 20 Tagen"
    ]
  },
  {
    "code": "D70.12",
    "name": "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 20 Tagen und mehr",
    "synonyms": [
      "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 20 Tagen und mehr"
    ]
  },
  {
    "code": "D70.13",
    "name": "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 4 bis unter 7 Tagen",
    "synonyms": [
      "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 4 bis unter 7 Tagen"
    ]
  },
  {
    "code": "D70.14",
    "name": "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 7 bis unter 10 Tagen",
    "synonyms": [
      "Arzneimittelinduzierte Agranulozytose und Neutropenie mit einer kritischen Phase von 7 bis unter 10 Tagen"
    ]
  },
  {
    "code": "D70.19",
    "name": "Leukopenie nach Zytostatikatherapie",
    "synonyms": [
      "Agranulozytose durch Chemotherapie",
      "Arzneimittelbedingte Neutropenie",
      "Arzneimittelinduzierte Agranulozytose",
      "Arzneimittelinduzierte Agranulozytose und Neutropenie",
      "Arzneimittelinduzierte Agranulozytose und Neutropenie durch zytostatische Therapie",
      "Arzneimittelinduzierte Neutropenie",
      "Chemotherapieassoziierte Agranulozytose",
      "Chemotherapieinduzierte Neutropenie",
      "Leukopenie nach Zytostatikatherapie",
      "Medikamentös induzierte Granulozytopenie"
    ]
  },
  {
    "code": "D70.3",
    "name": "Akute Agranulozytose",
    "synonyms": [
      "Agranulozytose",
      "Agranulozytose mit Angina",
      "Agranulozytose mit nekrotisierender Angina",
      "Agranulozytosesyndrom",
      "Akute Agranulozytose",
      "Angina agranulocytotica",
      "Aplastische Agranulozytose",
      "Chronische Agranulozytose",
      "Essentielle Agranulozytose",
      "Hyperplastische Agranulozytose",
      "Leukopenie mit Agranulozytose",
      "Nekrotische agranulozytische Mukositis",
      "Perniziöse Agranulozytose",
      "Schultz-Krankheit",
      "Schultz-Syndrom",
      "Werner-Schultz-Krankheit"
    ]
  },
  {
    "code": "D70.5",
    "name": "Zyklische Agranulozytose",
    "synonyms": [
      "Periodische Agranulozytose",
      "Periodische Neutropenie",
      "Zyklische Agranulozytose",
      "Zyklische Neutropenie"
    ]
  },
  {
    "code": "D70.6",
    "name": "Toxische Granulozytopenie",
    "synonyms": [
      "Adulte idiopathische Neutropenie",
      "Allergische Granulozytopenie",
      "Autoimmungranulozytopenie",
      "Leukopenie nach Strahlentherapie",
      "Maligne Granulozytopenie",
      "Maligne Leukopenie",
      "Neutropenische Splenomegalie",
      "Primäre Granulozytopenie",
      "Primäre splenogene Neutropenie",
      "Splenogene Neutropenie",
      "Splenopathische Neutropenie",
      "Toxische Granulozytopenie",
      "Toxische Neutropenie"
    ]
  },
  {
    "code": "D70.7",
    "name": "Hypoleukozytose",
    "synonyms": [
      "Fehlen der Neutrophilen",
      "Granulopenie",
      "Granulozytopenie",
      "Hypoleukozytose",
      "Leukopenie",
      "Leukozytopenie",
      "Neutropenie",
      "Neutrozytopenie"
    ]
  },
  {
    "code": "D71",
    "name": "Progressive septische Granulomatose",
    "synonyms": [
      "Angeborene Dysphagozytose",
      "CGD [Chronische Granulomatose]",
      "Chronische Granulomatose",
      "Chronische Granulomatose im Kindesalter",
      "Chronische familiäre Granulomatose",
      "Chronische granulomatöse Krankheit in der Kindheit",
      "Chronische septische Granulomatose",
      "Defekt des Zellmembran-Rezeptorenkomplexes (CR3)",
      "Dysphagozytose",
      "Funktionelle Störung der neutrophilen Granulozyten",
      "Kongenitale Dysphagozytose",
      "Neutrophiles Immundefektsyndrom",
      "Progressive septische Granulomatose"
    ]
  },
  {
    "code": "D72.0",
    "name": "Genetisch bedingte Leukozytenanomalie",
    "synonyms": [
      "Alder-Anomalie",
      "Alder-Reilly-Anomalie",
      "Genetisch bedingte Granulozytenanomalie",
      "Genetisch bedingte Leukozytenanomalie",
      "Hegglin-Anomalie",
      "Hegglin-Syndrom",
      "Hereditäre Leukomelanopathie",
      "Hereditäre leukozytäre Hypersegmentation",
      "Hereditäre leukozytäre Hyposegmentation",
      "MHA [May-Hegglin-Anomalie]",
      "May-Hegglin-Anomalie",
      "May-Hegglin-Syndrom",
      "Pelger-Huët-Anomalie",
      "Pelger-Huët-Kernanomalie",
      "Thrombozytopenie May-Hegglin"
    ]
  },
  {
    "code": "D72.1",
    "name": "Eosinophilie",
    "synonyms": [
      "Allergische Eosinophilie",
      "Eosinophile leukämoide Reaktion",
      "Eosinophilie",
      "Hereditäre Eosinophilie",
      "Hypereosinophilie"
    ]
  },
  {
    "code": "D72.8",
    "name": "Alymphozytose",
    "synonyms": [
      "Alymphocytosis",
      "Alymphozytose",
      "Eosinopenie",
      "Familiäre Lymphopenie",
      "Granulozytose",
      "Hereditäre Neutrophilie",
      "Hyperleukozytose",
      "Hypoeosinophilie",
      "Idiopathische CD4-Lymphozytopenie",
      "Leukostase",
      "Leukozythämie",
      "Leukozytose",
      "Leukämoide Reaktion",
      "Lymphopenie",
      "Lymphozytopenie",
      "Lymphozytose",
      "Lymphozytäre leukämoide Reaktion",
      "Monozytose",
      "Monozytäre leukämoide Reaktion",
      "Myeloische leukämoide Reaktion",
      "Myelozytäre leukämoide Reaktion",
      "Nichtleukämische Myelose",
      "Pathologisch erhöhte Neutrophilenzahl",
      "Persistente polyklonale B-Zell-Lymphozytose",
      "Plasmozytose",
      "Symptomatische Lymphozytose",
      "Symptomatische Monozytose"
    ]
  },
  {
    "code": "D72.9",
    "name": "Leukozytenkrankheit a.n.k.",
    "synonyms": [
      "Krankheit der weißen Blutkörperchen a.n.k.",
      "Leukopathie",
      "Leukozytenkrankheit a.n.k."
    ]
  },
  {
    "code": "D73.0",
    "name": "Hypospleniesyndrom",
    "synonyms": [
      "Asplenie nach Splenektomie",
      "Cachexia splenica",
      "Erworbenes Fehlen der Milz",
      "Hypospleniesyndrom",
      "Hyposplenismus",
      "Milzatrophie",
      "Milzdegeneration",
      "Milzkapselhyalinose"
    ]
  },
  {
    "code": "D73.1",
    "name": "Hypersplenismus",
    "synonyms": [
      "Gamna-Krankheit",
      "Gandy-Nanta-Krankheit",
      "Hypersplenie",
      "Hyperspleniesyndrom",
      "Hypersplenismus",
      "Milzmetaplasie",
      "Myelogene Metaplasie",
      "Myeloische Metaplasie",
      "Primäre splenogene Panhämozytopenie",
      "Primäre splenogene Panzytopenie",
      "Thrombopenia splenica",
      "Vermehrte Milzaktivität"
    ]
  },
  {
    "code": "D73.2",
    "name": "Chronisch-kongestive Splenomegalie",
    "synonyms": [
      "Chronisch-kongestive Splenomegalie",
      "Milzvenenthrombose-Syndrom",
      "Opitz-Krankheit [Milzvenenthrombose-Syndrom]",
      "Opitz-Symptomenkomplex",
      "Stauungsmilz"
    ]
  },
  {
    "code": "D73.3",
    "name": "Milzabszess",
    "synonyms": [
      "Milzabszess",
      "Milzlogenabszess"
    ]
  },
  {
    "code": "D73.4",
    "name": "Milzzyste a.n.k.",
    "synonyms": [
      "Milzzyste a.n.k."
    ]
  },
  {
    "code": "D73.5",
    "name": "Milzinfarzierung",
    "synonyms": [
      "Milzblutung",
      "Milzhämorrhagie",
      "Milzinfarkt",
      "Milzinfarzierung",
      "Milznekrose",
      "Milztorsion",
      "Nichttraumatische Milzruptur",
      "Spontane Milzruptur"
    ]
  },
  {
    "code": "D73.8",
    "name": "Episplenitis",
    "synonyms": [
      "Akute Milzkapselentzündung",
      "Akute eitrige Entzündung der Milz",
      "Akute eitrige Infektion der Milz",
      "Chronische Milzkapselentzündung",
      "Episplenitis",
      "Erworbene Milzdeformität",
      "Fistula splenocolica",
      "Infektiöse Perisplenitis",
      "Interstitielle Splenitis",
      "Lien migrans",
      "Lien mobilis",
      "Lienitis",
      "Lienomalazie",
      "Maligne Splenitis",
      "Milzerweichung",
      "Milzfibrose",
      "Milzinfektion",
      "Milzkalzifikation",
      "Milzprolaps",
      "Milzptose",
      "Nichttraumatische Milzschädigung",
      "Parasplenitis",
      "Perisplenitis",
      "Postinfektiöse Milzkrankheit",
      "Splenitis",
      "Splenoptose",
      "Splenose",
      "Splenosis",
      "Splenozele",
      "Unspezifische Splenitis",
      "Wandermilz",
      "Zuckergussmilz"
    ]
  },
  {
    "code": "D73.9",
    "name": "Milzkrankheit",
    "synonyms": [
      "Milzkrankheit",
      "Organische Milzkrankheit",
      "Splenopathie"
    ]
  },
  {
    "code": "D74.0",
    "name": "Angeborene Methämoglobinämie",
    "synonyms": [
      "Angeborene Methämoglobinämie",
      "Angeborener NADH-Methämoglobinreduktase-Mangel",
      "Diaphorasemangel",
      "Diaphorasemangelkrankheit",
      "Hb-M-Krankheit",
      "Hereditäre Methämoglobinämie",
      "Hämoglobin-M-Krankheit",
      "Kongenitale Methämoglobinämie",
      "Kongenitale enzymopathische Methämoglobinämie",
      "Kongenitaler NADH-Diaphorase-Mangel",
      "Kongenitaler NADH-Methämoglobinreduktase-Mangel",
      "Kongenitaler NADH-Reduktase-Mangel",
      "NADH-Cytochrom b5-Reduktase-Mangel",
      "NADH-Methämoglobinreduktase-Mangel"
    ]
  },
  {
    "code": "D74.8",
    "name": "Toxische Methämoglobinämie",
    "synonyms": [
      "Enterogene Zyanose [Erworbene Methämoglobinämie]",
      "Erworbene Methämoglobinämie",
      "Erworbene Methämoglobinämie mit Sulfhämoglobinämie",
      "Erworbene Sulfhämoglobinämie",
      "Sulfhämoglobinämie",
      "Sulfhämoglobinämie mit Methämoglobinämie",
      "Toxische Methämoglobinämie"
    ]
  },
  {
    "code": "D74.9",
    "name": "Methämoglobinämie",
    "synonyms": [
      "Methämoglobinämie",
      "Methämoglobinämie-Syndrom a.n.k."
    ]
  },
  {
    "code": "D75.0",
    "name": "Familiäre Erythrozytose",
    "synonyms": [
      "Familiäre Erythrozytose",
      "Familiäre Polyglobulie",
      "Familiäre Polyzythämie",
      "Gutartige Polyglobulie",
      "Gutartige Polyzythämie",
      "PFCP [Primäre familiäre und kongenitale Polyzythämie]",
      "Primäre familiäre Polyzythämie",
      "Primäre familiäre und kongenitale Polyzythämie",
      "Primäre kongenitale Erythrozytose"
    ]
  },
  {
    "code": "D75.1",
    "name": "Sekundäre Polyglobulie",
    "synonyms": [
      "Autosomal-dominante sekundäre Erythrozytose",
      "Autosomal-dominante sekundäre Polyzythämie",
      "Chuvash-Polyzythämie",
      "Emotionale Polyglobulie",
      "Erworbene Polyglobulie",
      "Erworbene Polyzythämie",
      "Erythrozytose",
      "Forssell-Syndrom",
      "Hochgebirgspolyglobulie",
      "Hypertensive Polyglobulie",
      "Hypoxämische Polyglobulie",
      "Höhenflugpolyglobulie",
      "Höhenpolyglobulie",
      "Nephrogene Polyglobulie",
      "Polyglobulie",
      "Polyglobulie durch Aufenthalt in großer Höhe",
      "Polyglobulie durch Erythropoetin",
      "Polyglobulie durch Hämokonzentration",
      "Polyzythämie",
      "Polyzythämie durch Aufenthalt in großer Höhe",
      "Polyzythämie durch Stress",
      "Pseudopolyglobulie",
      "Pseudopolyzythämie",
      "Relative Polyglobulie",
      "Renale Polyglobulie",
      "Sekundäre Erythrozytose",
      "Sekundäre Erythrämie",
      "Sekundäre Polyglobulie",
      "Sekundäre Polyzythämie",
      "Stress-Erythrozytose",
      "Stresspolyglobulie",
      "Symptomatische Polyglobulie"
    ]
  },
  {
    "code": "D75.8",
    "name": "Makrozytose",
    "synonyms": [
      "Basophileninvasion",
      "Basophilie",
      "Basozytose",
      "Erythrozytenartige Hyperplasie",
      "Makrozythämie",
      "Makrozytose",
      "Panzytolyse",
      "Retikuloendotheliale Hyperplasie"
    ]
  },
  {
    "code": "D75.9",
    "name": "Erythrophagie",
    "synonyms": [
      "Blutdyskrasie",
      "Blutkrankheit",
      "Erythrophagie",
      "Erythrophagozytose",
      "Erythrozytophagie",
      "Hämatologische Störung",
      "Knochenmarkkrankheit",
      "Krankheit der blutbildenden Organe",
      "Krankheit der hämatopoetischen Organe",
      "Krankheit des Blutes und der blutbildenden Organe",
      "Leistendrüsenkrankheit",
      "Störung der Blutbildung",
      "Störung der blutbildenden Organe",
      "Thrombozytose"
    ]
  },
  {
    "code": "D76.1",
    "name": "Hämophagozytäre Lymphohistiozytose",
    "synonyms": [
      "FHL [Familiäre hämophagozytische Lymphohistiozytose]",
      "Familiäre hämophagozytische Lymphohistiozytose",
      "Familiäre hämophagozytäre Retikulose",
      "Histiozytose mononukleärer Phagozyten a.n.k.",
      "Hämophagozytose-Syndrom",
      "Hämophagozytäre Lymphohistiozytose",
      "Makrophagen-Aktivierungssyndrom"
    ]
  },
  {
    "code": "D76.2",
    "name": "Hämophagozytäres Syndrom bei Infektion",
    "synonyms": [
      "Hämophagozytäres Syndrom bei Infektion"
    ]
  },
  {
    "code": "D76.3",
    "name": "Retikulohistiozytom",
    "synonyms": [
      "Benigne zephale Histiozytose",
      "Erdheim-Chester-Krankheit",
      "Generalisiertes eruptives Histiozytom",
      "Hereditäre progressive muzinöse Histiozytose",
      "Histiozytose",
      "Histiozytose-Syndrom a.n.k.",
      "Juveniles Xanthogranulom",
      "Nasenxanthogranulomatose",
      "Nekrobiotisches Xanthogranulom",
      "Papuläres Xanthom",
      "Progressive noduläre Histiozytose",
      "Retikulohistiozytom",
      "Retikulohistiozytäres Granulom",
      "Riesenzellen-Retikulohistiozytom",
      "Rosai-Dorfman-Syndrom",
      "Rosaï-Dorfman-Destombes-Krankheit",
      "Rosaï-Dorfman-Krankheit",
      "SHML [Sinushistiozytose mit massiver Lymphadenopathie]",
      "Seeblaue Histiozytose",
      "Sinushistiozytose",
      "Sinushistiozytose mit massiver Lymphadenopathie",
      "Xanthogranulom"
    ]
  },
  {
    "code": "D76.4",
    "name": "Cytokine-Release-Syndrom",
    "synonyms": [
      "Cytokine release syndrome",
      "Cytokine-Release-Syndrom",
      "Zytokinfreisetzungs-Syndrom",
      "Zytokinfreisetzungs-Syndrom nach CAR-T-Zelltherapie",
      "Zytokinfreisetzungs-Syndrom nach Immuntherapie"
    ]
  },
  {
    "code": "D80.0",
    "name": "Hereditäre Hypogammaglobulinämie",
    "synonyms": [
      "Agammaglobulinämie Typ Bruton",
      "Autosomal-rezessive Agammaglobulinämie",
      "Bruton-Typ der Agammaglobulinämie",
      "Bruton-Typ des Antikörpermangel-Syndroms",
      "Hereditäre Agammaglobulinämie",
      "Hereditäre Hypogammaglobulinämie",
      "Hereditärer Mangel an Gammaglobulinen im Blut",
      "Hereditäres Fehlen von Gammaglobulinen im Blut",
      "Hereditäres agammaglobulinämisches Antikörpermangel-Syndrom",
      "Hereditäres hypogammaglobulinämisches Antikörpermangel-Syndrom",
      "Isolierte Agammaglobulinämie",
      "Kongenitale geschlechtsgebundene Agammaglobulinämie",
      "Schweizer Typ der Agammaglobulinämie",
      "Syndrom der Agammaglobulinämie mit Mikrozephalie, Kraniosynostose und schwerer Dermatitis",
      "X-chromosomal-gebundene Agammaglobulinämie",
      "X-chromosomal-gebundene Agammaglobulinämie mit Wachstumshormonmangel"
    ]
  },
  {
    "code": "D80.1",
    "name": "Nichtfamiliäre Hypogammaglobulinämie",
    "synonyms": [
      "Agammaglobulinämie",
      "Agammaglobulinämie mit immunglobulin-positiven B-Lymphozyten",
      "Agammaglobulinämisches Antikörpermangel-Syndrom",
      "CVAgamma [Common variable Agammaglobulinämie]",
      "Common variable Agammaglobulinämie",
      "Erworbene Agammaglobulinämie",
      "Fehlen der Gammaglobuline im Blut",
      "Gammaglobulinmangel im Blut",
      "Hypogammaglobulinämie",
      "Hypogammaglobulinämie-Syndrom",
      "Hypogammaglobulinämisches Antikörpermangel-Syndrom",
      "Nichtfamiliäre Agammaglobulinämie",
      "Nichtfamiliäre Hypogammaglobulinämie",
      "Sekundäre Agammaglobulinämie"
    ]
  },
  {
    "code": "D80.2",
    "name": "Immunglobulin-A-Mangel",
    "synonyms": [
      "IgA [Immunglobulin A]-Mangel",
      "Immunglobulin-A-Mangel",
      "Selektiver Immunglobulin A-Mangel"
    ]
  },
  {
    "code": "D80.3",
    "name": "Mangel an Immunglobulin G",
    "synonyms": [
      "Mangel an Immunglobulin G",
      "Selektiver Mangel an Immunglobulin-G-Subklassen"
    ]
  },
  {
    "code": "D80.4",
    "name": "Immunglobulin-M-Mangel",
    "synonyms": [
      "IgM [Immunglobulin M]-Mangel",
      "Immunglobulin-M-Mangel",
      "Selektiver Immunoglobulin-M-Mangel"
    ]
  },
  {
    "code": "D80.5",
    "name": "Immundefekt bei erhöhtem Immunglobulin M",
    "synonyms": [
      "HIGM [Hyper-IgM-Syndrom] Typ 4",
      "HIGM [Hyper-IgM-Syndrom] mit opportunistischen Infektionen",
      "Hyper-IgM-Syndrom Typ 4",
      "Hyper-IgM-Syndrom mit opportunistischen Infektionen",
      "Hyper-IgM-Syndrom ohne opportunistische Infektionen",
      "Immundefekt bei erhöhtem Immunglobulin M"
    ]
  },
  {
    "code": "D80.6",
    "name": "Antikörpermangel bei Hypergammaglobulinämie",
    "synonyms": [
      "Antikörpermangel bei Hypergammaglobulinämie",
      "Antikörpermangel bei Normogammaglobulinämie",
      "Humoraler Immundefekt mit Hypergammaglobulinämie",
      "Humoraler Immundefekt mit Normogammaglobulinämie",
      "Immundefekt durch selektiven Antipolysaccharid-Antikörper-Mangel"
    ]
  },
  {
    "code": "D80.7",
    "name": "Transitorische Hypogammaglobulinämie im Säuglingsalter",
    "synonyms": [
      "Transiente Hypogammaglobulinämie der Kindheit",
      "Transitorische Hypogammaglobulinämie im Kindesalter",
      "Transitorische Hypogammaglobulinämie im Säuglingsalter"
    ]
  },
  {
    "code": "D80.8",
    "name": "Kappa-Leichtketten-Defekt",
    "synonyms": [
      "Defekt der schweren Immunglobulinkette",
      "Kappa-Leichtketten-Defekt",
      "Kappa-Leichtketten-Mangel",
      "Rezidivierende Infekte mit Mangel an Immunoglobulin-Isotypen"
    ]
  },
  {
    "code": "D80.9",
    "name": "Mangel an humoralen Antikörpern",
    "synonyms": [
      "Antikörperimmundefekt",
      "Antikörpermangel",
      "Humoraler Immundefekt",
      "Humoraler Immunitätsmangel",
      "Immundefekt mit Antikörpermangel",
      "Immundefekt mit vorwiegender Beeinträchtigung der Antikörper-Produktion",
      "Kombiniertes Antikörpermangel-Syndrom",
      "Mangel an humoralen Antikörpern"
    ]
  },
  {
    "code": "D81.0",
    "name": "Retikuläre Dysgenesie",
    "synonyms": [
      "Retikuläre Dysgenesie",
      "SCID [Schwerer kombinierter Immundefekt] mit retikulärer Dysgenesie",
      "Schwerer kombinierter Immundefekt mit retikulärer Dysgenesie"
    ]
  },
  {
    "code": "D81.1",
    "name": "Schwerer kombinierter Immundefekt mit niedriger T- und B-Zellen-Zahl",
    "synonyms": [
      "Cernunnos-Mangel",
      "Cernunnos/XLF-Mangel",
      "DNA-Ligase-IV-Mangel",
      "Kombinierter Immundefekt durch RAG 1/2 [Rekombinase-aktivierende Gene 1/2]-Defekt",
      "Kombinierter schwerer Immundefekt durch DOCK8 [dedicator of cytokinesis 8-Protein]-Defizienz",
      "Ligase 4-Syndrom",
      "SCID [Schwerer kombinierter Immundefekt] mit niedriger T- und B-Zellen-Zahl",
      "Schwerer kombinierter Immundefekt T-B-",
      "Schwerer kombinierter Immundefekt durch DCLRE1C-Mangel",
      "Schwerer kombinierter Immundefekt durch DNA-PKcs-Mangel",
      "Schwerer kombinierter Immundefekt durch kompletten RAG1/2 [Rekombinase-aktivierende Gene 1/2]-Mangel",
      "Schwerer kombinierter Immundefekt mit Mikrozephalie, Wachstumsretardierung und Sensitivität gegenüber ionisierender Strahlung",
      "Schwerer kombinierter Immundefekt mit Mikrozephalie, Wachstumsretardierung und Strahlenempfindlichkeit",
      "Schwerer kombinierter Immundefekt mit niedriger T- und B-Zellen-Zahl",
      "T-B- SCID [Severe combined immunodeficiency]"
    ]
  },
  {
    "code": "D81.2",
    "name": "Schwerer kombinierter Immundefekt mit normaler B-Zellen-Zahl",
    "synonyms": [
      "Kombinierter Immundefekt durch CD3-gamma-Mangel",
      "SCID [Schwerer kombinierter Immundefekt] mit niedriger oder normaler B-Zellen-Zahl",
      "Schwerer kombinierter Immundefekt T-B+",
      "Schwerer kombinierter Immundefekt T-B+ durch CD3-delta-Defekt",
      "Schwerer kombinierter Immundefekt T-B+ durch CD3-epsilon-Defekt",
      "Schwerer kombinierter Immundefekt T-B+ durch CD3-zeta-Defekt",
      "Schwerer kombinierter Immundefekt T-B+ durch CD45-Mangel",
      "Schwerer kombinierter Immundefekt T-B+ durch IL-7R-alpha-Mangel",
      "Schwerer kombinierter Immundefekt T-B+ durch JAK3-Mangel",
      "Schwerer kombinierter Immundefekt durch CARD11-Mangel",
      "Schwerer kombinierter Immundefekt durch CORO1A-Mangel",
      "Schwerer kombinierter Immundefekt durch IKK2-Mangel",
      "Schwerer kombinierter Immundefekt durch LAT-Defizienz",
      "Schwerer kombinierter Immundefekt durch LCK [Lymphozyten-spezifische Tyrosinkinase]-Mangel",
      "Schwerer kombinierter Immundefekt mit niedriger B-Zellen-Zahl",
      "Schwerer kombinierter Immundefekt mit normaler B-Zellen-Zahl",
      "T-B+ SCID [Severe combined immunodeficiency]",
      "X-chromosomaler schwerer kombinierter Immundefekt T-B+"
    ]
  },
  {
    "code": "D81.3",
    "name": "Adenosindesaminasemangel",
    "synonyms": [
      "ADA [Adenosindesaminase]-Mangel",
      "Adenosindesaminasemangel",
      "Schwerer kombinierter Immundefekt durch Adenosin-Desaminase-Mangel"
    ]
  },
  {
    "code": "D81.4",
    "name": "Nezelof-Syndrom",
    "synonyms": [
      "Nezelof-Syndrom"
    ]
  },
  {
    "code": "D81.5",
    "name": "Purinnukleosid-Phosphorylase-Mangel",
    "synonyms": [
      "PNP [Purinnukleosid-Phosphorylase]-Mangel",
      "Purinnukleosid-Phosphorylase-Mangel"
    ]
  },
  {
    "code": "D81.6",
    "name": "Haupthistokompatibilitäts-Komplex-Klasse-I-Defekt",
    "synonyms": [
      "BLS [Bare-Lymphocyte-Syndrom] Typ 1",
      "Bare-lymphocyte-Syndrom",
      "Haupthistokompatibilitäts-Komplex-Klasse-I-Defekt",
      "Haupthistokompatibilitäts-Komplex-Klasse-I-Mangel",
      "MHC [Haupthistokompatibilitätskomplex]-Klasse-I-Defekt"
    ]
  },
  {
    "code": "D81.7",
    "name": "Haupthistokompatibilitäts-Komplex-Klasse-II-Defekt",
    "synonyms": [
      "Haupthistokompatibilitäts-Komplex-Klasse-II-Defekt",
      "Haupthistokompatibilitäts-Komplex-Klasse-II-Mangel",
      "MHC [Haupthistokompatibilitätskomplex]-Klasse-II-Defekt"
    ]
  },
  {
    "code": "D81.8",
    "name": "Biotinabhängiger Carboxylasemangel",
    "synonyms": [
      "APDS [Activated phosphoinositide 3-Kinase-Delta-Syndrom]",
      "B-Zellen-Expansion mit NFKB- und T-Zell-Anergie",
      "BENTA [B-Zellen-Expansion mit NFKB- und T-Zell-Anergie]-Krankheit",
      "Biotinabhängiger Carboxylasemangel",
      "CARD11-Defekt",
      "HOIL1 [heme-oxidized iron-regulatory-protein-2-ubiquitin-ligase-1]-Defekt",
      "Holocarboxylase-Synthetase-Mangel",
      "Immundefekt durch CD25-Mangel",
      "Immundefekt durch T-Zell-Inaktivierung mit Dysfunktion des Kalziumkanals",
      "Kombinierter Immundefekt durch DOCK2 [Dedicator of cytokinesis 2]-Defekt",
      "Kombinierter Immundefekt durch FCHO1-Defekt",
      "Kombinierter Immundefekt durch GINS1-Defizienz",
      "Kombinierter Immundefekt durch IKAROS-Mangel",
      "Kombinierter Immundefekt durch IL21R-Mangel",
      "Kombinierter Immundefekt durch LRBA-Mangel",
      "Kombinierter Immundefekt durch MAGT1 [Magnesium-Transporter-1-Protein]-Mangel",
      "Kombinierter Immundefekt durch MALT 1 [Mucosa associated lymphoid tissue protein-1]-Mangel",
      "Kombinierter Immundefekt durch MKL1-bedingte Motilitätsstörung der Neutrophilen",
      "Kombinierter Immundefekt durch Moesin-Defizienz",
      "Kombinierter Immundefekt durch NIK [NF-Kappa-B-inducing kinase]-Defekt",
      "Kombinierter Immundefekt durch ORAI1-Mangel",
      "Kombinierter Immundefekt durch OX40-Defekt",
      "Kombinierter Immundefekt durch RELA-Haploinsuffizienz",
      "Kombinierter Immundefekt durch STIM1-Mangel",
      "Kombinierter Immundefekt durch STK4 [Serin-Threonin-Kinase 4]-Mangel",
      "Kombinierter Immundefekt durch TFRC-Mangel",
      "Kombinierter Immundefekt durch ZAP70-Mangel",
      "Kombinierter Immundefekt durch partiellen RAG1 [Rekombinase-aktivierendes Protein 1]-Mangel",
      "MonoMac [Monozytopenie und mykobakterielle Infektionen]-Syndrom",
      "Omenn-Syndrom",
      "Schwerer kombinierter Immundefekt durch CTPS1-Genmutation",
      "Schwerer kombinierter Immundefekt durch Defekt des CRAC-Kanals",
      "Schwerer kombinierter Immundefekt mit Hypereosinophilie",
      "T-Zell-Immundefekt durch RHOH-Mangel",
      "TCR [T-Zell-Rezeptor]-alpha-Defekt",
      "WHIM-Syndrom [Warzen mit Hypogammaglobulinämie, Infektionen und Myelokathexis]",
      "Warzen mit Hypogammaglobulinämie, Infektionen und Myelokathexis"
    ]
  },
  {
    "code": "D81.9",
    "name": "Kombinierter Immundefekt",
    "synonyms": [
      "Agammaglobulinämie mit Lymphozytopenie",
      "Kombinierter Immundefekt",
      "Kombinierter Immunitätsmangel",
      "Kombiniertes Immundefekt-Syndrom",
      "Lymphopenische Agammaglobulinämie",
      "SCID [Severe combined immunodeficiency] - s.a. Immundefekt, schwer, kombiniert",
      "Schwerer kombinierter Immundefekt"
    ]
  },
  {
    "code": "D82.0",
    "name": "Wiskott-Aldrich-Syndrom",
    "synonyms": [
      "Immundefekt mit Thrombozytopenie und Ekzem",
      "WAS [Wiskott-Aldrich-Syndrom]",
      "Wiskott-Aldrich-Syndrom"
    ]
  },
  {
    "code": "D82.1",
    "name": "Thymusaplasie",
    "synonyms": [
      "Alymphocytosis thymica",
      "Alymphoplasia thymica",
      "Di-George-Syndrom",
      "Lymphoblastische zytologische hereditäre Dysgenesie",
      "Parathyreoid-thymische Aplasie",
      "Syndrom des pharyngobranchialen Kiemenbogens",
      "Syndrom des vierten Kiemenbogens",
      "Thymusalymphoplasie",
      "Thymusaplasie",
      "Thymusaplasie mit Immundefekt",
      "Thymusdysplasie",
      "Thymusdysplasie mit Immundefekt",
      "Thymushypoplasie mit Immundefekt"
    ]
  },
  {
    "code": "D82.2",
    "name": "Immundefekt mit disproportioniertem Minderwuchs",
    "synonyms": [
      "Immundefekt mit disproportioniertem Kleinwuchs",
      "Immundefekt mit disproportioniertem Minderwuchs",
      "Laron-Syndrom mit Immundefekt",
      "Skelettdysplasie mit kurzen Extremitäten und schwerem kombiniertem Immundefekt"
    ]
  },
  {
    "code": "D82.3",
    "name": "X-chromosomal gebundene Lymphoproliferation",
    "synonyms": [
      "Immundefekt mit hereditär defekter Reaktion auf Epstein-Barr-Virus",
      "Kombinierter Immundefekt durch ITK-Defekt",
      "Schwerer kombinierter Immundefekt durch CARMIL2-Defekt",
      "Schwerer kombinierter Immundefekt durch CD70-Mangel",
      "Schwerer kombinierter Immundefekt durch RLTPR-Defekt",
      "Systemische EBV [Epstein-Barr-Virus]-positive T-Zell-lymphoproliferative Erkrankung der Kindheit",
      "X-chromosomal gebundene Lymphoproliferation",
      "X-chromosomal-gebundene lymphoproliferative Krankheit",
      "X-chromosomale lymphoproliferative Krankheit",
      "X-chromosomales lymphoproliferatives Syndrom",
      "X-chromosomales lymphoproliferatives Syndrom durch SH2D1A-Mangel",
      "X-chromosomales lymphoproliferatives Syndrom durch XIAP-Mangel"
    ]
  },
  {
    "code": "D82.4",
    "name": "Hyperimmunglobulin-E-Syndrom",
    "synonyms": [
      "Autosomal-dominantes HIES [Hyperimmunglobulin E-Syndrom]",
      "Autosomal-rezessives HIES [Hyperimmunglobulin E-Syndrom]",
      "Autosomal-rezessives HIES [Hyperimmunglobulin E-Syndrom] durch TYK2-Defizienz",
      "Autosomal-rezessives Hyper-IgE-Syndrom",
      "Hiob-Syndrom",
      "Hyper-IgE-Syndrom",
      "Hyperimmunglobulin-E-Syndrom",
      "IgE [Immunglobulin E]-Syndrom"
    ]
  },
  {
    "code": "D82.8",
    "name": "Winged-Helix-Nude-Defekt",
    "synonyms": [
      "FADD-abhängiger Immundefekt",
      "Good-Syndrom",
      "ICF [Immundefizienz, Zentromerinstabilität, faziale Anomalien]-Syndrom",
      "Neutropenie-Monozytopenie-Schwerhörigkeit-Syndrom",
      "Primäres Immundefekt-Syndrom durch LAMTOR2-Defizienz",
      "RIDDLE [Strahlenempfindlichkeit, Immundefekt, faziale Dysmorphien, Lernschwäche]-Syndrom",
      "Winged-Helix-Nude-Defekt"
    ]
  },
  {
    "code": "D83.0",
    "name": "Variabler Immundefekt mit überwiegenden Abweichungen der B-Zellen-Zahl und -Funktion",
    "synonyms": [
      "Variabler Immundefekt mit überwiegenden Abweichungen der B-Zellen-Zahl und -Funktion"
    ]
  },
  {
    "code": "D83.1",
    "name": "Variabler Immundefekt mit überwiegend immunregulatorischer T-Zell-Störung",
    "synonyms": [
      "Variabler Immundefekt mit überwiegend immunregulatorischer T-Zell-Störung"
    ]
  },
  {
    "code": "D83.2",
    "name": "Variabler Immundefekt mit Autoantikörpern gegen T-Zellen",
    "synonyms": [
      "Variabler Immundefekt mit Autoantikörpern gegen B-Zellen",
      "Variabler Immundefekt mit Autoantikörpern gegen T-Zellen"
    ]
  },
  {
    "code": "D83.9",
    "name": "Variabler Immundefekt",
    "synonyms": [
      "Allgemeiner variabler Immundefekt",
      "CVID [Common variable immunodeficiency]",
      "Common variable immunodeficiency",
      "Variabler Immundefekt",
      "Variables Immundefektsyndrom"
    ]
  },
  {
    "code": "D84.0",
    "name": "LFA-1 [Lymphozytenfunktion-Antigen-1]-Defekt",
    "synonyms": [
      "LFA-1 [Lymphozytenfunktion-Antigen-1]-Defekt",
      "Lymphozytenfunktion-Antigen-1 [LFA-1]-Defekt"
    ]
  },
  {
    "code": "D84.1",
    "name": "Hereditäres akutes Hautödem",
    "synonyms": [
      "ANGPT1-assoziiertes hereditäres Angioödem mit normalem C1-Inhibitor",
      "C1-Esterase-Inhibitor-Mangel",
      "C1-INH-Mangel",
      "C1-Inhibitor-Mangel",
      "CHAPLE [Komplement-Hyperaktivierung, angiopathische Thrombose, Eiweißverlustenteropathie]-Syndrom",
      "Defekte im Komplementsystem",
      "Erworbenes Angioödem mit C1-Inhibitor-Mangel",
      "F12-assoziiertes hereditäres Angioödem mit normalem C1-Inhibitor",
      "Familiäres angioneurotisches Ödem",
      "HAE [Hereditäres Angioödem]",
      "Hautödem, nicht Quincke-Ödem",
      "Hereditäre Bannister-Krankheit",
      "Hereditäre Larynxurtikaria",
      "Hereditäre Urticaria gigantea",
      "Hereditäres Angioödem",
      "Hereditäres Angioödem Typ 1",
      "Hereditäres Angioödem Typ 2",
      "Hereditäres Angioödem mit C1-Inhibitor-Mangel",
      "Hereditäres Angioödem mit normalem C1-Inhibitor",
      "Hereditäres Angioödem mit normalem C1-Inhibitor, nicht F12- oder PLG-assoziiert",
      "Hereditäres Bradykinin-induziertes Angioödem",
      "Hereditäres Quincke-Ödem",
      "Hereditäres akut-essentielles Ödem",
      "Hereditäres akut-umschriebenes Ödem",
      "Hereditäres akutes Hautödem",
      "Hereditäres allergisches Glottisödem",
      "Hereditäres angioneurotisches Ödem",
      "Hereditäres nicht-Histamin-induziertes Angioödem",
      "Hereditäres periodisches Ödem",
      "Immundefekt durch Ficolin-3-Mangel",
      "Immundefekt durch MASP-2 [MBL-assoziierte Serinprotease-2]-Mangel",
      "Immundefekt durch Mangel der Komplementkomponente C1",
      "Immundefekt durch Mangel der Komplementkomponente C2",
      "Immundefekt durch Mangel der Komplementkomponente C4",
      "Immundefekt mit Faktor H-Anomalie",
      "Immundefekt mit Faktor I-Anomalie",
      "Komplementdefekt bei Defizienz der Komponente C1",
      "Komplementdefekt bei Defizienz der Komponente C2",
      "Komplementdefekt bei Defizienz der Komponente C4",
      "Komplementdefekt bei Defizienz der Komponente C5",
      "Komplementdefekt bei Defizienz der Komponente C6",
      "Komplementdefekt bei Defizienz der Komponente C7",
      "Komplementdefekt bei Defizienz der Komponente C8",
      "Komplementdefekt bei Defizienz der Komponente C9",
      "Komplementfaktor C3-Mangel",
      "Komplementsystemdefekt",
      "PLG-assoziiertes hereditäres Angioödem mit normalem C1-Inhibitor",
      "Primärer CD59-Mangel",
      "Properdin-Mangel",
      "Syndrom der Komplement-Hyperaktivierung mit angiopathischer Thrombose und Eiweißverlustenteropathie",
      "Urtikaria mit hereditärem angioneurotischem Ödem"
    ]
  },
  {
    "code": "D84.8",
    "name": "Defekt der zellulären Immunität",
    "synonyms": [
      "Anfälligkeit für Atemwegsinfektionen durch CD8-alpha-Defizienz",
      "Autosomal-dominante Anfälligkeit für Mykobakteriosen durch partiellen Interferon-gamma-Rezeptor 1-Defekt",
      "Autosomal-dominante Anfälligkeit für Mykobakteriosen durch partiellen Interferon-gamma-Rezeptor 2-Defekt",
      "Autosomal-rezessive Anfälligkeit für Mykobakteriosen durch partiellen Interferon-gamma-Rezeptor 1-Defekt",
      "Autosomal-rezessive Anfälligkeit für Mykobakteriosen durch partiellen Interferon-gamma-Rezeptor 2-Defekt",
      "Autosomal-rezessive genetisch bedingte Anfälligkeit für Mykobakteriosen durch partiellen JAK1-Defekt",
      "Autosomal-rezessiver primärer Immundefekt durch RORC-Genmutation",
      "Autosomal-rezessiver primärer Immundefekt mit defekter spontaner NK-Zellen-Zytotoxizität",
      "CDG [Congenital disorder of glycosylation] Typ IIc",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIc",
      "Defekt der zellulären Immunität",
      "Erworbener Immundefekt mit Anti-Interferon-gamma-Autoantikörpern mit Beginn im Erwachsenenalter",
      "Familiäre Suszeptibilität für Mykobakteriosen",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch kompletten ISG15-Defekt",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch kompletten Interferon-gamma-Rezeptor 1-Defekt",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch kompletten Interferon-gamma-Rezeptor 2-Defekt",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch kompletten Interleukin 12B-Defekt",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch kompletten Interleukin-12-Rezeptor Beta 1-Defekt",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch partiellen IRF8 [Interferon regulatory factor-8]-Defekt",
      "Genetisch bedingte Anfälligkeit für Mykobakteriosen durch partiellen STAT1 [Signaltransduktor und Transkriptionsaktivator 1]-Defekt",
      "IRF7 [Interferon regulatory factor-7]-Defekt",
      "Immundefekt durch Interleukin-1-Rezeptor assoziierten Kinase-4-Mangel",
      "Invasive Pilzinfektion durch CARD9-Mangel",
      "Kongenitaler Defekt der Glykoproteinbiosynthese Typ IIc",
      "LAD [Leukozytenadhäsionsdefekt] Typ II",
      "Leukozytenadhäsionsdefekt",
      "Leukozytenadhäsionsdefekt Typ I",
      "Leukozytenadhäsionsdefekt Typ II",
      "Leukozytenadhäsionsdefekt Typ III",
      "Mendelsche Anfälligkeit für Erkrankung durch Mykobakterien",
      "MyD88-Defekt",
      "NCKAP1L-assoziierter hyperinflammatorischer lymphoproliferativer Immundefekt",
      "NFAT [Nuklearfaktor der aktivierten T-Zellen]-5-Haploinsuffizienz",
      "Primärer Immundefekt durch MCM4-Defekt",
      "Rambam-Hasharon-Syndrom",
      "STAT1 [Signaltransduktor und Transkriptionsaktivator-1]-Defekt",
      "Syndrom der Immundysregulation mit entzündlicher Darmkrankheit, Arthritis, rekurrenten Infektionen und Lymphopenie",
      "Zellulärer Immundefekt",
      "Zellulärer Immunitätsmangel"
    ]
  },
  {
    "code": "D84.9",
    "name": "Immunopathie",
    "synonyms": [
      "Gestörte Immunreaktion",
      "Immunanomalie",
      "Immundefekt",
      "Immunitätsmangel",
      "Immunmangelsyndrom",
      "Immunopathie",
      "Primärer Immundefekt"
    ]
  },
  {
    "code": "D86.0",
    "name": "Sarkoidose der Lunge",
    "synonyms": [
      "Lungenkrankheit bei Sarkoidose",
      "Sarkoidose der Lunge"
    ]
  },
  {
    "code": "D86.1",
    "name": "Sarkoidose der Lymphknoten",
    "synonyms": [
      "Sarkoidose der Lymphknoten"
    ]
  },
  {
    "code": "D86.2",
    "name": "Sarkoidose der Lunge mit Sarkoidose der Lymphknoten",
    "synonyms": [
      "Sarkoidose der Lunge mit Sarkoidose der Lymphknoten"
    ]
  },
  {
    "code": "D86.3",
    "name": "Sarkoidose der Haut",
    "synonyms": [
      "Boeck-Lupoid",
      "Darier-Roussy-Sarkoid",
      "Lupus pernio",
      "Miliarlupoid Boeck",
      "Sarkoidose der Haut"
    ]
  },
  {
    "code": "D86.8",
    "name": "Bilaterales Hiluslymphomsyndrom [Löfgren-Syndrom]",
    "synonyms": [
      "Bilaterales Hiluslymphomsyndrom [Löfgren-Syndrom]",
      "Blau-Syndrom",
      "Febris uveoparotidea [Heerfordt-Syndrom]",
      "Febris uveoparotidea subchronica",
      "Heerfordt-Krankheit",
      "Heerfordt-Mylius-Krankheit",
      "Heerfordt-Mylius-Syndrom",
      "Heerfordt-Syndrom",
      "Jüngling-Krankheit",
      "Löfgren-Syndrom",
      "Neurouveoparotitissyndrom",
      "Ostitis multiplex cystoides",
      "Ostitis multiplex cystoides Fleischner",
      "Ostitis multiplex cystoides Jüngling",
      "Paralytische Uveoparotitis",
      "Perthes-Jüngling-Krankheit",
      "Uveoparotitis",
      "Uveoparotitis-Syndrom"
    ]
  },
  {
    "code": "D86.9",
    "name": "Sarkoidose",
    "synonyms": [
      "Benigne Lymphogranulomatose",
      "Benigne Schaumann-Lymphogranulomatose",
      "Besnier-Boeck-Schaumann-Krankheit",
      "Besnier-Boeck-Schaumann-Syndrom",
      "Besnier-Tennesson-Syndrom",
      "Boeck-Knochenerkrankung",
      "Boeck-Krankheit",
      "Boeck-Sarkoid",
      "Epitheloidzellige Granulomatose",
      "Epitheloidzellige Retikuloendotheliose",
      "Granulomatosis benigna",
      "Hutchinson-Boeck-Granulomatose",
      "Hutchinson-Boeck-Krankheit",
      "Lymphogranulomatosis benigna",
      "Morbus Besnier-Boeck-Schaumann",
      "Morbus Boeck",
      "Morbus Schaumann",
      "Möller-Boeck-Krankheit",
      "Sarkoid",
      "Sarkoidose",
      "Schaumann-Krankheit"
    ]
  },
  {
    "code": "D89.0",
    "name": "Polyklonale Hypergammaglobulinämie",
    "synonyms": [
      "Benigne Purpura hypergammaglobulinaemica",
      "Benigne Purpura hyperglobulinaemica",
      "Hypergammaglobulinämie Waldenström",
      "Polyklonale Gammopathie",
      "Polyklonale Hypergammaglobulinämie",
      "Waldenström-Syndrom [Benigne Purpura hypergammaglobulinaemica]"
    ]
  },
  {
    "code": "D89.1",
    "name": "Kryoglobulinämie",
    "synonyms": [
      "Einfache Kryoglobulinämie",
      "Essentielle Kryoglobulinämie",
      "Essentielle gemischte Kryoglobulinämie",
      "Gemischte Kryoglobulinämie",
      "Idiopathische Kryoglobulinämie",
      "Kryoglobulinämie",
      "Kryoglobulinämie mit Purpura",
      "Kryoglobulinämie mit Vaskulitis",
      "Kryoglobulinämische Purpura",
      "Kryoglobulinämische Vaskulitis",
      "Primäre Kryoglobulinämie",
      "Purpura kryoglobulinaemica",
      "Sekundäre Kryoglobulinämie"
    ]
  },
  {
    "code": "D89.2",
    "name": "Benigne Paraproteinämie",
    "synonyms": [
      "Benigne Paraproteinämie",
      "Familiäre benigne Paraproteinämie",
      "Hypergammaglobulinämie",
      "Paraproteinämie"
    ]
  },
  {
    "code": "D89.3",
    "name": "Immunrekonstitutionssyndrom",
    "synonyms": [
      "Immunreaktivierungssyndrom",
      "Immunrekonstitutionssyndrom",
      "Inflammatorisches Immunrekonstitutionssyndrom [IRIS]"
    ]
  },
  {
    "code": "D89.8",
    "name": "HIDS [Hyperimmunglobulinämie-D-Syndrom]",
    "synonyms": [
      "HIDS [Hyperimmunglobulinämie-D-Syndrom]",
      "HIDS [Hyperimmunoglobulin-D-Syndrom]",
      "Hyperimmunoglobulin-D-Syndrom",
      "Monoklonales Mastzellaktivierungssyndrom",
      "Partieller Mevalonatkinase-Mangel",
      "TAFRO [Thrombozytopenie mit Anasarka, Fieber, Niereninsuffizienz, Organomegalie]-Syndrom"
    ]
  },
  {
    "code": "D89.9",
    "name": "Immunallergische Erkrankung",
    "synonyms": [
      "Abwehrschwäche",
      "Immunallergische Erkrankung",
      "Immuninsuffizienz",
      "Immunitätsstörung",
      "Immunkrankheit",
      "Immunschwäche",
      "Insuffizienz des Immunsystems",
      "Störung der Immunmechanismen"
    ]
  },
  {
    "code": "D90",
    "name": "Immunkompromittierung nach Bestrahlung",
    "synonyms": [
      "Abwehrschwäche unter Kortisonbehandlung",
      "Immunkompromittierung durch immunsuppressive Maßnahme",
      "Immunkompromittierung nach Bestrahlung",
      "Immunkompromittierung nach Chemotherapie",
      "Immunsuppressive Reaktion auf Chemotherapie"
    ]
  },
  {
    "code": "E00.0",
    "name": "Angeborenes Jodmangelsyndrom vom neurologischen Typ",
    "synonyms": [
      "Angeborenes Jodmangelsyndrom vom neurologischen Typ",
      "Endemischer Kretinismus vom neurologischen Typ"
    ]
  },
  {
    "code": "E00.1",
    "name": "Angeborenes Jodmangelsyndrom vom myxödematösen Typ",
    "synonyms": [
      "Angeborenes Jodmangelsyndrom vom myxödematösen Typ",
      "Endemischer Kretinismus vom myxödematösen Typ",
      "Hypothyreoter endemischer Kretinismus",
      "Kongenitales Myxödem"
    ]
  },
  {
    "code": "E00.2",
    "name": "Angeborenes Jodmangelsyndrom vom gemischten Typ",
    "synonyms": [
      "Angeborenes Jodmangelsyndrom vom gemischten Typ",
      "Endemischer Kretinismus vom gemischten Typ"
    ]
  },
  {
    "code": "E00.9",
    "name": "Angeborenes Jodmangelsyndrom",
    "synonyms": [
      "Angeborene Jodmangel-Hypothyreose",
      "Angeborener Hypothyreoidismus durch Jodmangel",
      "Angeborener Kretinismus",
      "Angeborenes Jodmangelsyndrom",
      "Endemischer Kretinismus",
      "Fetales Jodmangelsyndrom",
      "Kongenitaler Kretinismus",
      "Kretinismus",
      "Kretinismus ohne Kropf",
      "Sporadischer Kretinismus"
    ]
  },
  {
    "code": "E01.0",
    "name": "Jodmangelbedingte diffuse Struma",
    "synonyms": [
      "Diffuser Jodmangelkropf",
      "Endemische Struma diffusa",
      "Endemische kolloide Struma",
      "Endemischer diffuser Kropf",
      "Endemischer kolloider Kropf",
      "Jodmangelbedingte diffuse Struma"
    ]
  },
  {
    "code": "E01.1",
    "name": "Jodmangelbedingte mehrknotige Struma",
    "synonyms": [
      "Einknotiger Jodmangelkropf",
      "Endemische Struma nodosa simplex",
      "Endemische zystische adenomatöse Schilddrüse",
      "Endemischer adenomatöser Kropf",
      "Endemischer mehrknotiger Kropf",
      "Endemischer nodulärer Kropf",
      "Endemischer zystischer Kropf",
      "Jodmangelbedingte Knotenstruma",
      "Jodmangelbedingte mehrknotige Struma",
      "Mehrknotiger Jodmangelkropf",
      "Nichttoxische endemische Knotenstruma",
      "Nichttoxischer endemischer Knotenkropf",
      "Nodulärer Jodmangelkropf",
      "Zystischer Jodmangelkropf"
    ]
  },
  {
    "code": "E01.2",
    "name": "Endemischer einfacher Kropf",
    "synonyms": [
      "Endemische Schilddrüsenvergrößerung",
      "Endemische Struma",
      "Endemische Struma simplex",
      "Endemischer Jodmangelkropf",
      "Endemischer Kropf",
      "Endemischer einfacher Kropf",
      "Hyperplastische endemische Struma",
      "Jodmangelstruma",
      "Parenchymatöse endemische Struma",
      "Struma endemica"
    ]
  },
  {
    "code": "E01.8",
    "name": "Hypothyreose durch Jodmangel",
    "synonyms": [
      "Erworbene Jodmangel-Hypothyreose",
      "Erworbener Hypothyreoidismus durch Jodmangel a.n.k.",
      "Hypothyreose durch Jodmangel",
      "Jodmangelbedingte Schilddrüsenstörung"
    ]
  },
  {
    "code": "E02",
    "name": "Subklinische Jodmangel-Hypothyreose",
    "synonyms": [
      "Subklinische Jodmangel-Hypothyreose",
      "Subklinischer jodmangelbedingter Hypothyreoidismus"
    ]
  },
  {
    "code": "E03.0",
    "name": "Angeborene Hypothyreose mit diffuser Struma",
    "synonyms": [
      "Angeborene Hypothyreose mit diffuser Struma",
      "Angeborene nichttoxische Struma",
      "Angeborener Hypothyreoidismus mit diffuser Struma",
      "Familiäre Schilddrüsen-Dyshormonogenese",
      "Kongenitale Struma",
      "Kongenitaler diffuser Kropf",
      "Kongenitaler nichttoxischer Kropf",
      "Kongenitaler parenchymatöser Kropf",
      "Nichttoxische Struma congenita",
      "Nichttoxische Struma congenita parenchymatosa",
      "Struma congenita",
      "Struma congenita parenchymatosa"
    ]
  },
  {
    "code": "E03.1",
    "name": "Angeborene Hypothyreose ohne Struma",
    "synonyms": [
      "Angeborene Athyreose",
      "Angeborene Hypothyreose",
      "Angeborene Hypothyreose durch isolierten TSH [Thyreoideastimulierendes Hormon]-Mangel",
      "Angeborene Hypothyreose ohne Struma",
      "Angeborene Schilddrüsenatrophie",
      "Angeborene Schilddrüseninsuffizienz",
      "Angeborene Schilddrüsenunterfunktion",
      "Angeborener Hypothyreoidismus ohne Struma",
      "Angeborenes Fehlen der Schilddrüse",
      "Angeborenes Fehlen der Thyreoidea",
      "Athyreose",
      "Athyreosis congenita",
      "Athyrie",
      "Hypothyreose durch TSH [Thyreoideastimulierendes Hormon]-Rezeptor-Genmutationen",
      "Hypothyreose mit Muskelpseudohypertrophie",
      "Idiopathische kongenitale Hypothyreose",
      "Kocher-Debré-Semelaigne-Syndrom",
      "Kongenitale Hypothyreose",
      "Kongenitale Schilddrüsenatrophie",
      "Neonatale Gelbsucht durch kongenitale Schilddrüsenunterfunktion",
      "Neonataler Ikterus durch kongenitale Schilddrüsenunterfunktion",
      "Schilddrüsenagenesie",
      "Schilddrüsenaplasie",
      "Schilddrüsenaplasie mit Myxödem",
      "Schilddrüsenatrophie mit Kretinismus",
      "Schilddrüsenektopie",
      "Schilddrüsenhemiagenesie",
      "Schilddrüsenhypoplasie",
      "Thyreoideahypoplasie",
      "X-chromosomale kongenitale zentrale Hypothyreose mit spät beginnender Makroorchidie",
      "Zentrale Hypothyreose durch TRH [Thyrotropin-Releasing-Hormon]-Rezeptor-Mangel"
    ]
  },
  {
    "code": "E03.2",
    "name": "Hypothyreose nach Jodbehandlung",
    "synonyms": [
      "Hypothyreoidismus durch Arzneimittel a.n.k.",
      "Hypothyreoidismus durch PAS [p-Aminosalicylsäure]",
      "Hypothyreoidismus durch Phenylbutazon",
      "Hypothyreoidismus durch Resorzin",
      "Hypothyreoidismus durch Sulfonamide",
      "Hypothyreoidismus durch eine exogene Substanz a.n.k.",
      "Hypothyreose durch PAS [p-Aminosalicylsäure]",
      "Hypothyreose durch Phenylbutazon",
      "Hypothyreose durch Resorzin",
      "Hypothyreose nach Jodbehandlung",
      "Iatrogener Hypothyreoidismus a.n.k."
    ]
  },
  {
    "code": "E03.3",
    "name": "Postinfektiöse Hypothyreose",
    "synonyms": [
      "Postinfektiöse Hypothyreose",
      "Postinfektiöser Hypothyreoidismus"
    ]
  },
  {
    "code": "E03.4",
    "name": "Schilddrüsenatrophie",
    "synonyms": [
      "Cachexia strumipriva",
      "Erworbene Schilddrüsenatrophie",
      "Gull-Krankheit",
      "Schilddrüsenatrophie"
    ]
  },
  {
    "code": "E03.5",
    "name": "Myxödemkoma",
    "synonyms": [
      "Myxödemkoma"
    ]
  },
  {
    "code": "E03.8",
    "name": "Hypothyreose durch periphere Resistenz gegen Schilddrüsenhormone",
    "synonyms": [
      "Allan-Herndon-Dudley-Syndrom",
      "Hypothyreose durch periphere Resistenz gegen Schilddrüsenhormone"
    ]
  },
  {
    "code": "E03.9",
    "name": "Hypothyreose",
    "synonyms": [
      "Erworbene Athyreose",
      "Erworbene Hypothyreose",
      "Erworbene Insuffizienz der Schilddrüse",
      "Erworbene Schilddrüsenunterfunktion",
      "Erworbener Hypothyreoidismus",
      "Erworbenes Myxödem",
      "Fettsucht bei Hypothyreose",
      "Hypothyreoidismus",
      "Hypothyreose",
      "Hypothyreote Struma",
      "Infantiles Myxoedema",
      "Infantiles Myxödem",
      "Insuffizienz der Schilddrüse",
      "Kindliches Myxödem",
      "Latente Hypothyreose",
      "Myxoedema",
      "Myxödem",
      "Schilddrüsenhormonmangel",
      "Schilddrüsenunterfunktion"
    ]
  },
  {
    "code": "E04.0",
    "name": "Nichttoxische diffuse Struma",
    "synonyms": [
      "Diffuse Struma",
      "Einfache Struma",
      "Einfacher Kropf",
      "Euthyreote diffuse Struma",
      "Nichttoxische Struma diffusa colloides",
      "Nichttoxische Struma simplex",
      "Nichttoxische diffuse Struma",
      "Sporadische Struma diffusa",
      "Sporadische Struma simplex",
      "Sporadischer einfacher Kropf",
      "Struma diffusa",
      "Struma simplex"
    ]
  },
  {
    "code": "E04.1",
    "name": "Nichttoxischer solitärer Schilddrüsenknoten",
    "synonyms": [
      "Kolloidknoten",
      "Nichttoxische einknotige Struma",
      "Nichttoxische uninoduläre Struma",
      "Nichttoxischer solitärer Schilddrüsenknoten",
      "Nichttoxischer uninodulärer Kropf",
      "Schilddrüsenknoten",
      "Schilddrüsenzyste",
      "Struma nodosa colloides",
      "Struma uninodosa",
      "Strumaknoten",
      "Thyreoideazyste",
      "Unifokale Autonomie bei Struma mit Euthyreose",
      "Zystischer Schilddrüsenknoten"
    ]
  },
  {
    "code": "E04.2",
    "name": "Nichttoxische mehrknotige Struma",
    "synonyms": [
      "Adenomatöse zystische Schilddrüse",
      "Knotenstruma ohne Thyreotoxikose",
      "Mehrknotige Struma",
      "Mehrknotige zystische Struma",
      "Multifokale Autonomie bei Struma mit Euthyreose",
      "Multinoduläre Struma",
      "Multinodulärer zystischer Kropf",
      "Nichttoxische mehrknotige Struma",
      "Nichttoxische multinoduläre Struma",
      "Nichttoxischer multinodulärer Kropf",
      "Sporadisch zystische adenomatöse Schilddrüse",
      "Sporadischer zystischer Kropf",
      "Struma multinodosa",
      "Syndrom der familiären multinodulären Struma",
      "Zystenstruma",
      "Zystische Struma",
      "Zystischer Kropf"
    ]
  },
  {
    "code": "E04.9",
    "name": "Struma mit Schilddrüsenautonomie",
    "synonyms": [
      "Adenomatöser Kropf",
      "Balgkropf",
      "Bewegliche Struma",
      "Beweglicher Kropf",
      "Blande Struma",
      "Euthyreote Struma",
      "Juvenile Struma",
      "Knotenkropf",
      "Kolloider Kropf",
      "Kolloidstruma",
      "Kropf",
      "Nichttoxische Knotenstruma",
      "Nichttoxische Struma",
      "Nichttoxische Struma nodosa",
      "Nichttoxische adenomatöse Struma",
      "Nichttoxischer Kropf",
      "Nichttoxischer Schilddrüsenknoten",
      "Nichttoxischer nodulärer Kropf",
      "Parenchymatöse Struma",
      "Retrosternale Struma",
      "Retrosternale Struma mit Tracheaeinengung",
      "Rezidivierende Struma",
      "Schilddrüsenhyperplasie",
      "Schilddrüsenhypertrophie",
      "Schilddrüsenvergrößerung",
      "Sporadische Schilddrüsenvergrößerung",
      "Sporadische Struma nodosa simplex",
      "Sporadische hyperplastische Struma",
      "Sporadische kolloide Struma",
      "Sporadische parenchymatöse Struma",
      "Sporadischer Kropf",
      "Sporadischer adenomatöser Kropf",
      "Sporadischer kolloider Kropf",
      "Sporadischer nichttoxischer Knotenkropf",
      "Sporadischer nodulärer Kropf",
      "Struma",
      "Struma 1. Grades",
      "Struma 2. Grades",
      "Struma 3. Grades",
      "Struma adenomatosa",
      "Struma gangliosa",
      "Struma hyperplastica",
      "Struma mit Schilddrüsenautonomie",
      "Struma nodosa",
      "Struma nodosa diffusa",
      "Struma nodosa mit Euthyreose",
      "Strumarezidiv",
      "Substernale Schilddrüse",
      "Substernale Struma",
      "Substernaler Kropf",
      "Tauchkropf",
      "Thyreoideahyperplasie",
      "Thyreoideahypertrophie",
      "Zervikale Struma"
    ]
  },
  {
    "code": "E05.0",
    "name": "Hyperthyreose mit diffuser Struma",
    "synonyms": [
      "Basedow-Krankheit",
      "Basedow-Struma",
      "Basedow-Syndrom",
      "Diffuser toxischer Kropf",
      "Exophthalmischer Kropf",
      "Flajani-Krankheit",
      "Hyperthyreose bei Kropf",
      "Hyperthyreose bei Struma",
      "Hyperthyreose mit diffuser Struma",
      "Hyperthyreose vom Typ Basedow",
      "Hyperthyreosesyndrom mit Exophthalmus, Myxödem und Osteoarthropathia hypertrophicans [EMO]",
      "Immunogene Hyperthyreose",
      "Latent hyperthyreote Struma",
      "Morbus Basedow",
      "Morbus Basedow mit Beginn im Kindesalter",
      "Thyreotoxikose mit Kropf",
      "Toxische Struma",
      "Toxische Struma diffusa",
      "Toxische diffuse Struma",
      "Toxischer Kropf",
      "Von-Basedow-Syndrom"
    ]
  },
  {
    "code": "E05.1",
    "name": "Toxische uninoduläre Struma",
    "synonyms": [
      "Hyperthyreose mit Schilddrüsenknoten",
      "Hyperthyreose mit toxischem solitärem Schilddrüsenknoten",
      "Hyperthyreose mit toxischer einknotiger Struma",
      "Thyreotoxikose mit einknotigem Kropf",
      "Thyreotoxikose mit solitärem Schilddrüsenknoten",
      "Toxische uninoduläre Struma",
      "Toxischer uninodulärer Kropf",
      "Unifokale Autonomie bei Struma mit Hyperthyreose"
    ]
  },
  {
    "code": "E05.2",
    "name": "Hyperthyreose mit toxischer mehrknotiger Struma",
    "synonyms": [
      "Adenomatöse Struma mit Hyperthyreose",
      "Adenomatöser Kropf mit Hyperthyreose",
      "Adenomatöser Kropf mit Thyreotoxikose",
      "Hyperthyreose bei Struma mit multifokaler Autonomie",
      "Hyperthyreose mit nodulärem Kropf",
      "Hyperthyreose mit nodulärer Struma",
      "Hyperthyreose mit toxischer mehrknotiger Struma",
      "Multifokale Schilddrüsenautonomie bei Struma mit Hyperthyreose",
      "Nodulärer Kropf mit Thyreotoxikose",
      "Plummer-Krankheit [Toxische Struma multinodosa]",
      "Plummer-Syndrom [Toxische Struma multinodosa]",
      "Schilddrüsenautonomie bei Struma mit Hyperthyreose",
      "Thyreotoxikose mit mehrknotigem Kropf",
      "Thyreotoxikose mit nodulärem Kropf",
      "Toxische Knotenstruma",
      "Toxische adenomatöse Struma",
      "Toxische multinoduläre Struma",
      "Toxischer Knotenkropf",
      "Toxischer adenomatöser Kropf",
      "Toxischer multinodulärer Kropf",
      "Toxischer nodulärer Kropf",
      "Toxisches Struma nodosa"
    ]
  },
  {
    "code": "E05.3",
    "name": "Hyperthyreose durch ektopisches Schilddrüsengewebe",
    "synonyms": [
      "Hyperthyreose durch ektopisches Schilddrüsengewebe",
      "Thyreotoxikose durch ektopisches Schilddrüsengewebe"
    ]
  },
  {
    "code": "E05.4",
    "name": "Hyperthyreosis factitia",
    "synonyms": [
      "Hyperthyreosis factitia",
      "Thyreotoxicosis factitia",
      "Thyreotoxikose durch Einnahme einer thyreotropen Substanz"
    ]
  },
  {
    "code": "E05.5",
    "name": "Thyreotoxische Krise",
    "synonyms": [
      "Delirium durch Hyperthyreoidismus",
      "Koma durch Hyperthyreoidismus",
      "Schilddrüsenkrise",
      "Thyreoid storms",
      "Thyreotoxische Krise"
    ]
  },
  {
    "code": "E05.8",
    "name": "Autoimmunbedingte Hyperthyreose",
    "synonyms": [
      "Autoimmunbedingte Hyperthyreose",
      "Familiäre Hyperthyreose durch TSH-Rezeptor-Genmutation",
      "Familiäre nicht-immune Hyperthyreose",
      "Hypersekretion schilddrüsenstimulierender Hormone",
      "Resistenz gegen Schilddrüsenhormone durch Mutation im Thyroidhormonrezeptor Alpha",
      "Resistenz gegen Schilddrüsenhormone durch Mutation im Thyroidhormonrezeptor Beta",
      "TSH [Thyreoideastimulierendes Hormon]-Überproduktion",
      "Thyreotoxikose mit Thyreotropin-Überproduktion",
      "Thyreotropin-Überproduktion"
    ]
  },
  {
    "code": "E05.9",
    "name": "Hyperthyreose",
    "synonyms": [
      "Hyperthyreoidismus",
      "Hyperthyreoidismus ohne Kropf",
      "Hyperthyreose",
      "Juvenile Hyperthyreose",
      "Latente Hyperthyreose",
      "Rezidivierende Hyperthyreose",
      "Rezidivierende Thyreotoxikose",
      "Schilddrüsenhyperaktivität",
      "Schilddrüsenüberaktivität",
      "Schilddrüsenüberfunktion",
      "Thyreotoxicosis",
      "Thyreotoxikose",
      "Toxic goitre"
    ]
  },
  {
    "code": "E06.0",
    "name": "Akute Thyreoiditis",
    "synonyms": [
      "Akute Thyreoiditis",
      "Eitrige Thyreoiditis",
      "Pyogene Thyreoiditis",
      "Schilddrüsenabszess",
      "Schilddrüseneiterung"
    ]
  },
  {
    "code": "E06.1",
    "name": "Subakute Thyreoiditis",
    "synonyms": [
      "De-Quervain-Krankheit [Thyreoiditis]",
      "De-Quervain-Thyreoiditis",
      "Granulomatöse Thyreoiditis",
      "Nichteitrige Thyreoiditis",
      "Pseudotuberkulöse Thyreoiditis",
      "Riesenzellthyreoiditis",
      "Subakute Thyreoiditis"
    ]
  },
  {
    "code": "E06.2",
    "name": "Chronische Thyreoiditis mit transitorischer Hyperthyreose",
    "synonyms": [
      "Chronische Thyreoiditis mit transitorischer Hyperthyreose",
      "Transitorische Thyreotoxikose mit chronischer Thyreoiditis"
    ]
  },
  {
    "code": "E06.3",
    "name": "Autoimmunthyreoiditis",
    "synonyms": [
      "Autoimmunthyreoiditis",
      "Autoimmunthyreopathie",
      "Chronische lymphoadenoide Thyreoiditis",
      "Chronische lymphozytäre Thyreoiditis",
      "Hashimoto-Krankheit",
      "Hashimoto-Struma",
      "Hashimoto-Syndrom",
      "Hashimoto-Thyreoiditis",
      "Hashitoxikose",
      "Immunthyreoiditis",
      "Lymphadenoider Kropf",
      "Lymphoide Thyreoiditis",
      "Lymphomatöse Thyreoiditis",
      "Lymphozytäre Immunthyreoiditis",
      "Lymphozytäre Thyreoiditis",
      "Struma lymphomatosa",
      "Transitorische Hashitoxikose"
    ]
  },
  {
    "code": "E06.4",
    "name": "Arzneimittelinduzierte Thyreoiditis",
    "synonyms": [
      "Arzneimittelinduzierte Thyreoiditis",
      "Iatrogene Thyreoiditis"
    ]
  },
  {
    "code": "E06.5",
    "name": "Chronische Thyreoiditis",
    "synonyms": [
      "Chronische Thyreoiditis",
      "Chronische fibröse Thyreoiditis",
      "Eisenharte Thyreoiditis",
      "Holzige Thyreoiditis",
      "Invasiv-sklerosierende Thyreoiditis",
      "Riedel-Krankheit",
      "Riedel-Struma - s.a. Eisenharte Thyreoiditis",
      "Riedel-Thyreoiditis"
    ]
  },
  {
    "code": "E06.9",
    "name": "Perithyreoiditis",
    "synonyms": [
      "Perithyreoiditis",
      "Schilddrüsenentzündung",
      "Strumitis",
      "Thyreoadenitis",
      "Thyreoiditis"
    ]
  },
  {
    "code": "E07.0",
    "name": "Hypersekretion von Thyreokalzitonin",
    "synonyms": [
      "C-Zellen-Hyperplasie der Schilddrüse",
      "Hypersekretion von Kalzitonin",
      "Hypersekretion von Thyreokalzitonin",
      "Hyperthyreokalzitonismus",
      "Störung der Thyreokalzitoninsekretion"
    ]
  },
  {
    "code": "E07.1",
    "name": "Dyshormogene Struma",
    "synonyms": [
      "Dyshormogene Struma",
      "Dyshormogener familiärer Kropf",
      "Familiäre dyshormogene Struma",
      "Kropf durch Enzymdefekt bei Synthese von Schilddrüsenhormon",
      "Struma bei Enzymdefekt"
    ]
  },
  {
    "code": "E07.8",
    "name": "Schilddrüseninfarkt bei Hämorrhagie",
    "synonyms": [
      "Abnormes Thyreoglobulin",
      "Abnormität des Thyreoglobulins",
      "Anomalie des Thyreoglobulins",
      "Dystransthyretinämische Hyperthyroxinämie",
      "Euthyroid-Sick-Syndrom",
      "Hämorrhagie der Schilddrüse",
      "Hämorrhagie der Thyreoidea",
      "Schilddrüsenblutung",
      "Schilddrüsendegeneration",
      "Schilddrüsenfistel",
      "Schilddrüsengangrän",
      "Schilddrüseninfarkt",
      "Schilddrüseninfarkt bei Blutung",
      "Schilddrüseninfarkt bei Hämorrhagie",
      "Schilddrüseninfarzierung",
      "Thyreoideafistel"
    ]
  },
  {
    "code": "E07.9",
    "name": "Schilddrüsenfehlfunktion",
    "synonyms": [
      "Dysthyreose",
      "Funktionsstörung der Schilddrüse",
      "Krankheit der Schilddrüse",
      "Schilddrüsenaffektion",
      "Schilddrüsendysfunktion",
      "Schilddrüsenerkrankung",
      "Schilddrüsenfehlfunktion",
      "Thyreoideadysfunktion",
      "Thyreopathie"
    ]
  },
  {
    "code": "E10.01",
    "name": "Primär insulinabhängiger Diabetes mellitus mit Koma",
    "synonyms": [
      "Coma acidoticum bei Typ-1-Diabetes mellitus",
      "Coma diabeticum bei Typ-1-Diabetes mellitus",
      "Coma hyperglycaemicum diabeticum bei Typ-1-Diabetes mellitus",
      "Diabetes mellitus Typ 1 mit Präkoma",
      "Diabetisches Koma bei Typ-1-Diabetes mellitus",
      "Insulinabhängiger Typ-1-Diabetes mellitus mit Koma",
      "Kussmaul-Koma bei Typ-1-Diabetes mellitus",
      "Primär insulinabhängiger Diabetes mellitus mit Koma",
      "Typ-1-Diabetes mellitus mit Koma"
    ]
  },
  {
    "code": "E10.11",
    "name": "Primär insulinabhängiger Diabetes mellitus mit Ketoazidose",
    "synonyms": [
      "Diabetes mellitus Typ 1 mit Azetonämie",
      "Diabetes mellitus Typ 1 mit Azidose",
      "Diabetes mellitus Typ 1 mit Ketoazidose",
      "Diabetes mellitus Typ 1 mit Ketose",
      "Insulinabhängiger Typ-1-Diabetes mellitus mit Ketoazidose",
      "Primär insulinabhängiger Diabetes mellitus mit Ketoazidose",
      "Typ-1-Diabetes mellitus mit Ketoazidose"
    ]
  },
  {
    "code": "E10.40",
    "name": "Syndrom der Entwicklungsverzögerung mit Epilepsie und neonatalem Diabetes",
    "synonyms": [
      "DEND [Entwicklungsverzögerung, Epilepsie, neonataler Diabetes]-Syndrom",
      "DEND [Entwicklungsverzögerung, Epilepsie, neonataler Diabetes]-Syndrom, intermediäre Form",
      "Syndrom der Entwicklungsverzögerung mit Epilepsie und neonatalem Diabetes",
      "Syndrom der Entwicklungsverzögerung mit Epilepsie und neonatalem Diabetes, intermediäre Form"
    ]
  },
  {
    "code": "E10.50",
    "name": "Diabetische Gangrän des Fußes bei Typ-1-Diabetes mellitus",
    "synonyms": [
      "Diabetes mellitus Typ 1 mit Geschwür",
      "Diabetes mellitus Typ 1 mit peripherer Kreislaufstörung",
      "Diabetische Gangrän bei Typ-1-Diabetes mellitus",
      "Diabetische Gangrän des Fußes bei Typ-1-Diabetes mellitus",
      "Ulcus cruris diabeticum bei Typ-1-Diabetes mellitus",
      "Ulcus diabeticum bei Typ-1-Diabetes mellitus"
    ]
  },
  {
    "code": "E10.60",
    "name": "Insulinbedingte Hypoglykämie bei Typ-1-Diabetes mellitus",
    "synonyms": [
      "Diabetes mellitus Typ 1 mit Abszess",
      "Diabetes mellitus Typ 1 mit Hypoglykämie",
      "Diabetes mellitus Typ 1 mit Infektion",
      "Insulinbedingte Hypoglykämie bei Typ-1-Diabetes mellitus",
      "Sexualstörung bei Typ-1-Diabetes mellitus",
      "Unterzuckerung bei Typ-1-Diabetes mellitus"
    ]
  },
  {
    "code": "E10.61",
    "name": "Insulinkoma bei Typ-1-Diabetes mellitus",
    "synonyms": [
      "Hypoglykämischer Schock bei Typ-1-Diabetes mellitus",
      "Insulinkoma bei Typ-1-Diabetes mellitus"
    ]
  },
  {
    "code": "E10.72",
    "name": "Mauriac-Syndrom",
    "synonyms": [
      "Insulinabhängiger Typ-1-Diabetes mellitus mit multiplen Komplikationen",
      "Mauriac-Syndrom",
      "Primär insulinpflichtiger Diabetes mellitus mit mehreren Komplikationen",
      "Typ-1-Diabetes mellitus mit Spätsyndrom",
      "Typ-1-Diabetes mellitus mit multiplen Folgeschäden",
      "Typ-1-Diabetes mellitus mit multiplen Komplikationen",
      "Wolfram-Syndrom"
    ]
  },
  {
    "code": "E10.73",
    "name": "Wolfram-Syndrom, entgleist",
    "synonyms": [
      "Wolfram-Syndrom, entgleist"
    ]
  },
  {
    "code": "E10.74",
    "name": "Diabetischer Fuß bei Typ-1-Diabetes mellitus",
    "synonyms": [
      "Diabetischer Fuß bei Typ-1-Diabetes mellitus",
      "Typ-1-Diabetes mellitus mit diabetischem Fußsyndrom"
    ]
  },
  {
    "code": "E10.80",
    "name": "Komplikation bei Typ-1-Diabetes mellitus",
    "synonyms": [
      "Komplikation bei Typ-1-Diabetes mellitus"
    ]
  },
  {
    "code": "E10.90",
    "name": "Primär insulinabhängiger Diabetes mellitus ohne Komplikation",
    "synonyms": [
      "Brittle diabetes",
      "Diabetes mellitus Typ 1",
      "Diabetes mellitus Typ 1 beim Erwachsenen",
      "Diabetes mellitus Typ 1a",
      "Diabetes mellitus Typ 1b",
      "Diabetes mellitus Typ I",
      "Dysregulativer Typ-1-Diabetes mellitus",
      "Insulinabhängiger Diabetes mellitus Typ 1",
      "Insulinbehandelter Typ-1-Diabetes mellitus",
      "Insulinbehandelter Typ-1-Diabetes mellitus ohne Komplikation",
      "Insulinpflichtiger Typ-1-Diabetes mellitus",
      "Juveniler Diabetes mellitus",
      "Kongenitaler Diabetes mellitus",
      "LADA [Latent (or late-onset) autoimmune diabetes of adulthood]-Diabetes mellitus",
      "Labiler Diabetes mellitus",
      "Latenter autoimmun-assoziierter Diabetes mellitus",
      "Primär insulinabhängiger Diabetes mellitus",
      "Primär insulinabhängiger Diabetes mellitus ohne Komplikation",
      "Primär insulinpflichtiger Diabetes mellitus",
      "Typ-1-Diabetes mellitus - s.a. Diabetes mellitus, Typ-1-",
      "Typ-1-Diabetes mellitus ohne Komplikation"
    ]
  },
  {
    "code": "E10.91",
    "name": "Entgleister Diabetes mellitus Typ 1",
    "synonyms": [
      "Entgleister Diabetes mellitus Typ 1"
    ]
  },
  {
    "code": "E11.01",
    "name": "Nicht primär insulinabhängiger Diabetes mellitus mit Koma",
    "synonyms": [
      "Coma acidoticum bei Typ-2-Diabetes mellitus",
      "Coma diabeticum bei Typ-2-Diabetes mellitus",
      "Coma hyperglycaemicum diabeticum bei Typ-2-Diabetes mellitus",
      "Diabetes mellitus Typ 2 mit Präkoma",
      "Diabetisches Koma bei Typ-2-Diabetes mellitus",
      "Insulinabhängiger Typ-2-Diabetes mellitus mit Koma",
      "Kussmaul-Atmung bei diabetischem Koma bei Typ-2-Diabetes mellitus",
      "Kussmaul-Koma bei Typ-2-Diabetes mellitus",
      "MODY [Maturity onset diabetes of young people] mit Koma",
      "Nicht primär insulinabhängiger Diabetes mellitus mit Koma",
      "Nichtinsulinabhängiger Typ-2-Diabetes mellitus mit Koma",
      "Typ-2-Diabetes mellitus mit Koma"
    ]
  },
  {
    "code": "E11.11",
    "name": "Nicht primär insulinabhängiger Diabetes mellitus mit Ketoazidose",
    "synonyms": [
      "Diabetes mellitus Typ 2 mit Azetonämie",
      "Diabetes mellitus Typ 2 mit Azidose",
      "Diabetes mellitus Typ 2 mit Ketoazidose",
      "Diabetes mellitus Typ 2 mit Ketose",
      "Insulinabhängiger Typ-2-Diabetes mellitus mit Ketoazidose",
      "MODY [Maturity onset diabetes of young people] mit Ketoazidose",
      "Nicht primär insulinabhängiger Diabetes mellitus mit Ketoazidose",
      "Nichtinsulinabhängiger Typ-2-Diabetes mellitus mit Ketoazidose",
      "Typ-2-Diabetes mellitus mit Ketoazidose"
    ]
  },
  {
    "code": "E11.20",
    "name": "Diabetes mellitus Typ 2b mit Nephropathie",
    "synonyms": [
      "Diabetes mellitus Typ 2b mit Nephropathie"
    ]
  },
  {
    "code": "E11.50",
    "name": "Nicht primär insulinabhängiger Diabetes mellitus mit peripherer vaskulärer Komplikation",
    "synonyms": [
      "Diabetes mellitus Typ 2 mit Angiopathie",
      "Diabetes mellitus Typ 2 mit Geschwür",
      "Diabetes mellitus Typ 2 mit peripherer Kreislaufstörung",
      "Diabetes mellitus Typ 2 mit vaskulärer Komplikation",
      "Diabetische Gangrän bei Typ-2-Diabetes mellitus",
      "Diabetische Gangrän des Fußes bei Typ-2-Diabetes mellitus",
      "Durchblutungsstörung bei Typ-2-Diabetes mellitus",
      "Insulinabhängiger Typ-2-Diabetes mellitus mit peripherer vaskulärer Komplikation",
      "MODY [Maturity onset diabetes of young people] mit peripherer vaskulärer Komplikation",
      "Nicht primär insulinabhängiger Diabetes mellitus mit peripherer vaskulärer Komplikation",
      "Nichtinsulinabhängiger Typ-2-Diabetes mellitus mit peripherer vaskulärer Komplikation",
      "Typ-2-Diabetes mellitus mit peripherer vaskulärer Komplikation",
      "Ulcus cruris diabeticum bei Typ-2-Diabetes mellitus",
      "Ulcus diabeticum bei Typ-2-Diabetes mellitus"
    ]
  },
  {
    "code": "E11.51",
    "name": "MODY [Maturity onset diabetes of young people] mit peripherer vaskulärer Komplikation, entgleist",
    "synonyms": [
      "MODY [Maturity onset diabetes of young people] mit peripherer vaskulärer Komplikation, entgleist"
    ]
  },
  {
    "code": "E11.60",
    "name": "Unterzuckerung bei Typ-2-Diabetes mellitus",
    "synonyms": [
      "Diabetes mellitus Typ 2 mit Abszess",
      "Diabetes mellitus Typ 2 mit Hypoglykämie",
      "Diabetes mellitus Typ 2 mit Infektion",
      "Insulinbedingte Hypoglykämie bei Typ-2-Diabetes mellitus",
      "MODY [Maturity onset diabetes of young people] mit Hypoglykämie",
      "Sexualstörung bei Typ-2-Diabetes mellitus",
      "Unterzuckerung bei Typ-2-Diabetes mellitus"
    ]
  },
  {
    "code": "E11.61",
    "name": "Hypoglykämischer Schock bei Typ-2-Diabetes mellitus",
    "synonyms": [
      "Hypoglykämischer Schock bei MODY [Maturity onset diabetes of young people]",
      "Hypoglykämischer Schock bei Typ-2-Diabetes mellitus",
      "Hypoglykämisches Koma bei MODY [Maturity onset diabetes of young people]",
      "Insulinkoma bei Typ-2-Diabetes mellitus"
    ]
  },
  {
    "code": "E11.72",
    "name": "Nicht primär insulinabhängiger Diabetes mellitus mit multiplen Komplikationen",
    "synonyms": [
      "Insulinabhängiger Typ-2-Diabetes mellitus mit multiplen Komplikationen",
      "MODY [Maturity onset diabetes of young people] mit multiplen Komplikationen",
      "Nicht primär insulinabhängiger Diabetes mellitus mit multiplen Komplikationen",
      "Nicht primär insulinpflichtiger Diabetes mellitus mit mehreren Komplikationen",
      "Nichtinsulinabhängiger Typ-2-Diabetes mellitus mit multiplen Komplikationen",
      "Typ-2-Diabetes mellitus mit Spätsyndrom",
      "Typ-2-Diabetes mellitus mit multiplen Folgeschäden",
      "Typ-2-Diabetes mellitus mit multiplen Komplikationen",
      "Typ-2b-Diabetes mellitus mit Spätsyndrom",
      "Typ-2b-Diabetes mellitus mit multiplen Komplikationen"
    ]
  },
  {
    "code": "E11.73",
    "name": "MODY [Maturity onset diabetes of young people] mit multiplen Komplikationen, entgleist",
    "synonyms": [
      "MODY [Maturity onset diabetes of young people] mit multiplen Komplikationen, entgleist"
    ]
  },
  {
    "code": "E11.74",
    "name": "Diabetischer Fuß bei Typ-2-Diabetes mellitus",
    "synonyms": [
      "Diabetischer Fuß bei Typ-2-Diabetes mellitus",
      "MODY [Maturity onset diabetes of young people] mit diabetischem Fußsyndrom",
      "Typ-2-Diabetes mellitus mit diabetischem Fußsyndrom"
    ]
  },
  {
    "code": "E11.75",
    "name": "MODY [Maturity onset diabetes of young people] mit diabetischem Fußsyndrom, entgleist",
    "synonyms": [
      "MODY [Maturity onset diabetes of young people] mit diabetischem Fußsyndrom, entgleist"
    ]
  },
  {
    "code": "E11.80",
    "name": "Komplikation bei Typ-2-Diabetes mellitus",
    "synonyms": [
      "Diabetes mellitus Typ 2b mit Komplikationen",
      "Komplikation bei Typ-2-Diabetes mellitus",
      "MODY [Maturity onset diabetes of young people] mit Komplikation"
    ]
  },
  {
    "code": "E11.81",
    "name": "MODY [Maturity onset diabetes of young people] mit Komplikation, entgleist",
    "synonyms": [
      "MODY [Maturity onset diabetes of young people] mit Komplikation, entgleist"
    ]
  },
  {
    "code": "E11.90",
    "name": "MODY [Maturity onset diabetes of young people]",
    "synonyms": [
      "Altersbedingter Diabetes mellitus",
      "Altersdiabetes",
      "Altersdiabetes mit Adipositas",
      "Diabetes mellitus Typ 2 - s.a. Diabetes mellitus, Typ-2-",
      "Diabetes mellitus Typ 2 beim Erwachsenen",
      "Diabetes mellitus Typ 2a",
      "Diabetes mellitus Typ 2b",
      "Diätetisch behandelter Typ-2-Diabetes mellitus",
      "Diätetisch behandelter Typ-2-Diabetes mellitus ohne Komplikation",
      "Dysregulativer Typ-2-Diabetes mellitus",
      "Insulinabhängiger Typ-2-Diabetes mellitus",
      "Insulinbehandelter Typ-2-Diabetes mellitus",
      "Insulinbehandelter Typ-2-Diabetes mellitus ohne Komplikation",
      "Insulinpflichtiger Typ-2-Diabetes mellitus",
      "MODY [Maturity onset diabetes of young people]",
      "MODY [Maturity onset diabetes of young people] ohne Komplikation",
      "Maturity onset diabetes of young people",
      "NIDDM [Non-insulin-dependent diabetes mellitus]",
      "Nicht primär insulinpflichtiger Diabetes mellitus",
      "Nichtinsulinabhängiger Diabetes mellitus Typ 2",
      "Nichtinsulinabhängiger Diabetes mellitus beim Jugendlichen",
      "Sekundär insulinpflichtiger Diabetes mellitus",
      "Stabiler Diabetes mellitus",
      "Tablettenbehandelter Typ-2-Diabetes mellitus",
      "Tablettenbehandelter Typ-2-Diabetes mellitus ohne Komplikation",
      "Typ-2-Diabetes mellitus",
      "Typ-2-Diabetes mellitus bei Adipositas",
      "Typ-2-Diabetes mellitus ohne Adipositas",
      "Typ-2-Diabetes mellitus ohne Komplikation"
    ]
  },
  {
    "code": "E11.91",
    "name": "MODY [Maturity onset diabetes of young people] ohne Komplikation, entgleist",
    "synonyms": [
      "MODY [Maturity onset diabetes of young people] ohne Komplikation, entgleist"
    ]
  },
  {
    "code": "E12.90",
    "name": "Diabetes mellitus in Verbindung mit Fehl- oder Mangelernährung [Malnutrition]",
    "synonyms": [
      "Diabetes mellitus Typ 1 in Verbindung mit Fehl- oder Mangelernährung [Malnutrition]",
      "Diabetes mellitus Typ 2 in Verbindung mit Fehl- oder Mangelernährung [Malnutrition]",
      "Diabetes mellitus in Verbindung mit Fehl- oder Mangelernährung [Malnutrition]"
    ]
  },
  {
    "code": "E13.60",
    "name": "Insulinresistenz-Syndrom, Typ A",
    "synonyms": [
      "Insulinresistenz-Syndrom, Typ A"
    ]
  },
  {
    "code": "E13.61",
    "name": "Insulinresistenz-Syndrom, Typ A, entgleist",
    "synonyms": [
      "Insulinresistenz-Syndrom, Typ A, entgleist"
    ]
  },
  {
    "code": "E13.72",
    "name": "Insulinresistenz-Syndrom, Typ B",
    "synonyms": [
      "Insulinresistenz-Syndrom, Typ A, mit multiplen Komplikationen",
      "Insulinresistenz-Syndrom, Typ B",
      "Wolfram-ähnliches Syndrom"
    ]
  },
  {
    "code": "E13.73",
    "name": "Insulinresistenz-Syndrom, Typ B, entgleist",
    "synonyms": [
      "Insulinresistenz-Syndrom, Typ B, entgleist",
      "Wolfram-ähnliches Syndrom, entgleist"
    ]
  },
  {
    "code": "E13.90",
    "name": "Pankreopriver Diabetes mellitus",
    "synonyms": [
      "Diabetes mellitus, nicht Typ 1 oder 2",
      "Hepatogener Diabetes mellitus",
      "Pankreopriver Diabetes mellitus",
      "Rabson-Mendenhall-Syndrom",
      "Sekundärer Diabetes mellitus"
    ]
  },
  {
    "code": "E14.01",
    "name": "Kussmaul-Atmung bei diabetischem Koma",
    "synonyms": [
      "Coma acidoticum bei Diabetes mellitus",
      "Coma diabeticum",
      "Coma hyperglycaemicum diabeticum",
      "Diabetes mellitus mit Koma",
      "Diabetes mellitus mit Präkoma",
      "Diabetisches Koma",
      "Hyperglykämisches Koma",
      "Hyperosmolares diabetisches Koma",
      "Kussmaul-Atmung bei diabetischem Koma",
      "Kussmaul-Koma",
      "Praecoma diabeticum"
    ]
  },
  {
    "code": "E14.11",
    "name": "Diabetes mellitus mit Ketoazidose",
    "synonyms": [
      "Diabetes mellitus mit Azetonämie",
      "Diabetes mellitus mit Azidose",
      "Diabetes mellitus mit Ketoazidose",
      "Diabetes mellitus mit Ketose",
      "Diabetes mellitus mit Ketoseneigung"
    ]
  },
  {
    "code": "E14.30",
    "name": "Diabetes mellitus mit Augenkomplikation",
    "synonyms": [
      "Diabetes mellitus mit Augenkomplikation"
    ]
  },
  {
    "code": "E14.40",
    "name": "Diabetes mellitus mit neurologischer Komplikation",
    "synonyms": [
      "Diabetes mellitus mit neurologischer Komplikation"
    ]
  },
  {
    "code": "E14.50",
    "name": "Ulcus diabeticum",
    "synonyms": [
      "Diabetes mellitus mit Gangrän",
      "Diabetes mellitus mit Gefäßkomplikation",
      "Diabetes mellitus mit Geschwür",
      "Diabetes mellitus mit Makroangiopathie",
      "Diabetes mellitus mit Mikroangiopathie",
      "Diabetes mellitus mit peripherer Kreislaufstörung",
      "Diabetes mellitus mit vaskulärer Komplikation",
      "Diabetische Gangrän",
      "Diabetische Gangrän des Fußes",
      "Diabetische Vorfußgangrän",
      "Diabetisches Ulkus",
      "Ulcus cruris diabeticum",
      "Ulcus diabeticum",
      "Ulkus bei Diabetes mellitus"
    ]
  },
  {
    "code": "E14.60",
    "name": "Diabetes mellitus mit Infektion",
    "synonyms": [
      "Diabetes mellitus mit Abszess",
      "Diabetes mellitus mit Hypoglykämie",
      "Diabetes mellitus mit Infektion",
      "Diabetische Sexualstörung",
      "Insulinbedingte Hypoglykämie bei Diabetes mellitus",
      "Unterzuckerung bei Diabetes mellitus"
    ]
  },
  {
    "code": "E14.61",
    "name": "Insulinkoma bei Diabetes mellitus",
    "synonyms": [
      "Hypoglykämischer Schock bei Diabetes mellitus",
      "Insulinkoma bei Diabetes mellitus"
    ]
  },
  {
    "code": "E14.72",
    "name": "Diabetes mellitus mit multiplen Komplikationen",
    "synonyms": [
      "Diabetes mellitus mit Spätsyndrom",
      "Diabetes mellitus mit multiplen Komplikationen",
      "Diabetisches Spätsyndrom",
      "Maternal vererbter Diabetes mellitus mit Schwerhörigkeit"
    ]
  },
  {
    "code": "E14.74",
    "name": "Diabetischer Fuß",
    "synonyms": [
      "Diabetischer Fuß",
      "Diabetisches Fußsyndrom"
    ]
  },
  {
    "code": "E14.80",
    "name": "Diabetische Komplikation",
    "synonyms": [
      "Diabetes mellitus mit Komplikation",
      "Diabetes mellitus mit Spätkomplikation",
      "Diabetes mellitus mit Spätschaden",
      "Diabetische Komplikation",
      "Diabetische Spätkomplikation"
    ]
  },
  {
    "code": "E14.90",
    "name": "Dysregulativer Diabetes mellitus",
    "synonyms": [
      "Diabetes mellitus - kodiere möglichst gemäß Typ 1 oder Typ 2",
      "Diabetes mellitus beim Erwachsenen",
      "Diabetes mellitus ohne Ketoseneigung",
      "Diabetes mellitus ohne Komplikation",
      "Diabetische Stoffwechsellage",
      "Diabetische Stoffwechselstörung",
      "Dysregulativer Diabetes mellitus",
      "Familiärer Diabetes mellitus",
      "IDDM [Insulin dependent diabetes mellitus]",
      "Insulinpflichtiger Diabetes mellitus",
      "Insulinresistenz bei Diabetes mellitus",
      "Kontrollierter Diabetes mellitus",
      "Schwerer Diabetes mellitus",
      "Zuckerkrankheit - s.a. Diabetes mellitus"
    ]
  },
  {
    "code": "E14.91",
    "name": "Diabetische Entgleisung",
    "synonyms": [
      "Diabetes mellitus mit Entgleisung",
      "Diabetische Entgleisung"
    ]
  },
  {
    "code": "E15",
    "name": "Nichtdiabetisches hypoglykämisches Koma",
    "synonyms": [
      "Arzneimittelinduzierte Hypoglykämie mit Koma",
      "Arzneimittelinduziertes Insulinkoma beim Nichtdiabetiker",
      "Coma hypoglycaemicum",
      "Hyperinsulinismus mit Koma",
      "Hyperinsulinismus mit hypoglykämischem Koma",
      "Hypoglykämie durch Insulin mit Koma",
      "Hypoglykämie mit Koma",
      "Hypoglykämische Reaktion durch Insulin mit nichtdiabetischem Koma",
      "Hypoglykämischer Schock",
      "Hypoglykämisches Koma",
      "Iatrogene Hypoglykämie mit Koma",
      "Iatrogener Hyperinsulinismus",
      "Insulinkoma",
      "Nichtdiabetischer hypoglykämischer Schock",
      "Nichtdiabetisches Insulinkoma",
      "Nichtdiabetisches hypoglykämisches Koma"
    ]
  },
  {
    "code": "E16.0",
    "name": "Insulinbedingte Hypoglykämie",
    "synonyms": [
      "Arzneimittelinduzierte Hypoglykämie",
      "Autoimmunes hypoglykämisches Syndrom",
      "Hypoglykämische Reaktion durch Insulin",
      "Iatrogene Hypoglykämie",
      "Insulinbedingte Hypoglykämie"
    ]
  },
  {
    "code": "E16.1",
    "name": "Postoperative Hypoglykämie",
    "synonyms": [
      "Anstrengungsinduzierte hyperinsulinämische Hypoglykämie",
      "Anstrengungsinduzierter Hyperinsulinismus",
      "Antiinsulin-Antikörper-Syndrom",
      "Autosomal-dominanter Hyperinsulinismus durch Kir6.2-Mangel",
      "Autosomal-dominanter Hyperinsulinismus durch SUR1-Mangel",
      "Autosomal-rezessiver Hyperinsulinismus durch Kir6.2-Mangel",
      "Autosomal-rezessiver Hyperinsulinismus durch SUR1-Mangel",
      "B-Zell-Hyperplasie",
      "Beta-Zell-Hyperplasie",
      "Betazellen-Hyperplasie der Langerhans-Inseln",
      "Diazoxid-resistenter fokaler Hyperinsulinismus durch Kir6.2-Mangel",
      "Diazoxid-resistenter fokaler Hyperinsulinismus durch SUR1-Mangel",
      "Diazoxid-sensitive diffuse Form der hyperinsulinämischen Hypoglykämie",
      "Diazoxid-sensitiver diffuser Hyperinsulinismus",
      "Ektopischer Hyperinsulinismus",
      "Funktionelle Hypoglykämie, ohne Anstieg des Insulinspiegels",
      "Funktioneller Hyperinsulinismus",
      "Glukopenie",
      "Hyperinsulinismus",
      "Hyperinsulinismus durch Glukokinase-Mangel",
      "Hyperinsulinismus durch HNF1A-Defizienz",
      "Hyperinsulinismus durch HNF4A-Defizienz",
      "Hyperinsulinismus durch Monocarboxylat-Transporter 1-Mangel",
      "Hyperinsulinismus durch UCP2 [Uncoupling-Protein 2]-Mangel",
      "Hyperinsulinämische Hypoglykämie durch Glukokinase-Mangel",
      "Hyperinsulinämische Hypoglykämie durch Insulin-Rezeptor-Mangel",
      "Hyperinsulinämische Hypoglykämie durch UCP2 [Uncoupling-Protein 2]-Mangel",
      "Infantile Hypoglykämie",
      "Infantile persistierende hyperinsulinämische Hypoglykämie",
      "Kongenitaler Hyperinsulinismus",
      "Nichtarzneimittelinduzierte reaktive Hypoglykämie",
      "Persistierende hyperinsulinämische Hypoglykämie des Erwachsenen ohne Insulinom",
      "Postoperative Hypoglykämie"
    ]
  },
  {
    "code": "E16.2",
    "name": "Hypoglykämie",
    "synonyms": [
      "Erniedrigter Blutzuckerspiegel",
      "Glykopenie",
      "Hypoglykämie",
      "Spontane Hypoglykämie",
      "Unterzuckerung"
    ]
  },
  {
    "code": "E16.3",
    "name": "Erhöhte Glukagonsekretion",
    "synonyms": [
      "Abnorme Glukagonsekretion",
      "Erhöhte Glukagonsekretion",
      "Gesteigerte Glukagonsekretion",
      "Glukagon-Sekretionsstörung",
      "Hyperplasie des endokrinen Pankreasdrüsenanteils mit Glukagonüberproduktion",
      "Hypersekretion von Glukagon",
      "Mahvash-Krankheit"
    ]
  },
  {
    "code": "E16.4",
    "name": "Hypergastrinämie",
    "synonyms": [
      "Abnorme Gastrinsekretion",
      "Erhöhte Gastrinsekretion",
      "Gastrin-Sekretionsstörung",
      "Gesteigerte Gastrinsekretion",
      "Hypergastrinämie",
      "Hyperplasie der A-Zellen des Pankreas mit übermäßiger Gastrinsekretion",
      "Hypersekretion von Gastrin",
      "Zollinger-Ellison-Syndrom"
    ]
  },
  {
    "code": "E16.8",
    "name": "Hypersekretion pankreatischer Polypeptide aus dem endokrinen Pankreasdrüsenanteil",
    "synonyms": [
      "Gesteigerte Sekretion pankreatischer Polypeptide",
      "Gesteigerte Sekretion vasoaktiver intestinaler Polypeptide aus dem Pankreas",
      "Gesteigerte Sekretion von Somatostatin aus dem Pankreas",
      "Gesteigerte Sekretion von Somatotropin-Releasing-Hormon aus dem Pankreas",
      "Hyperplasie der A-Zellen des Pankreas",
      "Hypersekretion pankreatischer Polypeptide aus dem endokrinen Pankreasdrüsenanteil",
      "Hypersekretion von Somatostatin aus dem endokrinen Pankreasdrüsenanteil",
      "Hypersekretion von Somatotropin-Releasing-Hormon [SRH] [GHRH] aus dem endokrinen Pankreasdrüsenanteil",
      "Hypersekretion von vasoaktivem gastrointestinalem Polypeptid aus dem endokrinen Pankreasdrüsenanteil",
      "Hypoinsulinämische Hypoglykämie mit Hemihypertrophie"
    ]
  },
  {
    "code": "E16.9",
    "name": "Störung der inneren Pankreassekretion",
    "synonyms": [
      "Gesteigerte endokrine Pankreassekretion",
      "Hyperplasie des endokrinen Pankreasdrüsenanteils",
      "Inselzellhyperplasie",
      "Insuffizienz der Inselzellen des Pankreas",
      "Pankreashyperplasie",
      "Störung der inneren Bauchspeicheldrüsensekretion",
      "Störung der inneren Pankreassekretion"
    ]
  },
  {
    "code": "E20.0",
    "name": "Idiopathischer Hypoparathyreoidismus",
    "synonyms": [
      "Autoimmuner Hypoparathyreoidismus",
      "Idiopathischer Hypoparathyreoidismus"
    ]
  },
  {
    "code": "E20.1",
    "name": "Pseudohypoparathyreoidismus",
    "synonyms": [
      "Hereditäre Albright-Osteodystrophie",
      "Pseudohypoparathyreoidismus",
      "Pseudohypoparathyreoidismus Typ 1A",
      "Pseudohypoparathyreoidismus Typ 1B",
      "Pseudohypoparathyreoidismus Typ 1C",
      "Pseudohypoparathyreoidismus Typ 2",
      "Pseudopseudohypoparathyreoidismus"
    ]
  },
  {
    "code": "E20.8",
    "name": "Familiärer Hypoparathyreoidismus",
    "synonyms": [
      "Autosomal-dominante Hypokalzämie",
      "Familiärer Hypoparathyreoidismus",
      "Familiärer isolierter Hypoparathyreoidismus",
      "Familiärer isolierter Hypoparathyreoidismus durch gestörte Parathormon-Sekretion",
      "Sekundärer Hypoparathyreoidismus durch gestörte Parathormon-Sekretion"
    ]
  },
  {
    "code": "E20.9",
    "name": "Hypoparathyreoidismus",
    "synonyms": [
      "Hypoparathyreoidismus",
      "Insuffizienz der Epithelkörperchen",
      "Insuffizienz der Nebenschilddrüse",
      "Mangel an Nebenschilddrüsenhormon",
      "Parathyreogene Tetanie",
      "Tetanie bei Hypoparathyreoidismus",
      "Unterfunktion der Epithelkörperchen",
      "Unterfunktion der Nebenschilddrüse",
      "Unterfunktion der Parathyreoidea"
    ]
  },
  {
    "code": "E21.0",
    "name": "Primärer Hyperparathyreoidismus",
    "synonyms": [
      "Epithelkörperchenhyperplasie",
      "Familiärer isolierter Hyperparathyreoidismus",
      "Familiärer primärer Hyperparathyreoidismus",
      "Nebenschilddrüsenhyperplasie",
      "Nebenschilddrüsenhypertrophie",
      "Nebenschilddrüsenvergrößerung",
      "Neonataler schwerer primärer Hyperparathyreoidismus",
      "Parathyreoideahypertrophie",
      "Primäre Nebenschilddrüsenhyperplasie",
      "Primärer Hyperparathyreoidismus"
    ]
  },
  {
    "code": "E21.1",
    "name": "Sekundärer Hyperparathyreoidismus a.n.k.",
    "synonyms": [
      "Regulativer Hyperparathyreoidismus",
      "Sekundärer Hyperparathyreoidismus a.n.k."
    ]
  },
  {
    "code": "E21.2",
    "name": "Tertiärer Hyperparathyreoidismus",
    "synonyms": [
      "Tertiärer Hyperparathyreoidismus"
    ]
  },
  {
    "code": "E21.3",
    "name": "Hyperparathyreoidismus",
    "synonyms": [
      "Hyperparathyreoidismus",
      "Überfunktion der Epithelkörperchen",
      "Überfunktion der Nebenschilddrüse",
      "Überfunktion der Parathyreoidea"
    ]
  },
  {
    "code": "E21.4",
    "name": "Autoimmune Parathyreoiditis",
    "synonyms": [
      "Autoimmune Parathyreoiditis",
      "Nebenschilddrüsenentzündung",
      "Nebenschilddrüsenzyste",
      "Spontane Blutung der Nebenschilddrüse",
      "Spontane Hämorrhagie der Nebenschilddrüse"
    ]
  },
  {
    "code": "E21.5",
    "name": "Nebenschilddrüsenkrankheit",
    "synonyms": [
      "Nebenschilddrüsenkrankheit",
      "Nebenschilddrüsenstörung"
    ]
  },
  {
    "code": "E22.0",
    "name": "Akromegalie",
    "synonyms": [
      "Akromegalie",
      "Familiärer infantiler Gigantismus",
      "Gigantismus",
      "Hypersekretion von Somatotropin",
      "Hypersekretion von Wachstumshormon",
      "Hypophysenvorderlappenüberfunktion mit Akromegalie",
      "Hypophysenvorderlappenüberfunktion mit Gigantismus",
      "Hypophysenvorderlappenüberfunktion mit Riesenwuchs",
      "Hypophysärer Gigantismus",
      "Hypophysärer Hochwuchs",
      "Hypophysärer Riesenwuchs",
      "Infantile Form der Akromegalie",
      "Juvenile Form der Akromegalie",
      "Makrosomie",
      "Marie-Pierre-I-Krankheit",
      "Marie-Pierre-I-Syndrom",
      "Überproduktion von Somatotropin",
      "Überproduktion von Wachstumshormon"
    ]
  },
  {
    "code": "E22.1",
    "name": "Hyperprolaktinämie",
    "synonyms": [
      "Familiäre Hyperprolaktinämie",
      "Familiärer isolierter Prolaktin-Rezeptor-Mangel",
      "Forbes-Albright-Syndrom",
      "Galaktorrhoe-Amenorrhoe-Syndrom",
      "Hyperprolaktinämie",
      "Pathologische Prolaktinerhöhung"
    ]
  },
  {
    "code": "E22.2",
    "name": "Syndrom der inadäquaten Sekretion von Adiuretin",
    "synonyms": [
      "Hypersekretion von Adiuretin",
      "NSIAD [Nephrogenes Syndrom der inadäquaten Antidiurese]",
      "Nephrogenes Syndrom der inadäquaten Antidiurese",
      "SIADH [Syndrome of inappropriate ADH secretion]",
      "Schwartz-Bartter-Syndrom",
      "Störung der Sekretion des antidiuretischen Hormons",
      "Syndrom der inadäquaten Sekretion von Adiuretin",
      "Syndrom der inadäquaten Sekretion von antidiuretischem Hormon",
      "Übersekretion von ADH [Antidiuretisches Hormon]"
    ]
  },
  {
    "code": "E22.8",
    "name": "Zentral ausgelöste Pubertas praecox",
    "synonyms": [
      "Genetisch bedingte zentral ausgelöste vorzeitige Pubertät bei Mädchen",
      "Gonadotropin-abhängige Pubertas praecox",
      "Primäre zentral ausgelöste vorzeitige Pubertät bei Jungen",
      "Sekundäre zentral ausgelöste vorzeitige Pubertät bei Jungen",
      "Sekundäre zentral ausgelöste vorzeitige Pubertät bei Mädchen",
      "Vorzeitige Pubertät durch Hypophysenüberfunktion",
      "Zentral ausgelöste Pubertas praecox",
      "Zentral ausgelöste vorzeitige Pubertät",
      "Zentrale Pubertas praecox"
    ]
  },
  {
    "code": "E22.9",
    "name": "Hypophysenüberfunktion",
    "synonyms": [
      "Gesteigerte Hypophysenfunktion",
      "Hyperpituitarismus",
      "Hypersekretion eines Hypophysenhormons",
      "Hypophysenüberfunktion",
      "Überfunktion des Hypophysenvorderlappens"
    ]
  },
  {
    "code": "E23.0",
    "name": "Hypophysärer Hypoadrenokortizismus",
    "synonyms": [
      "ACTH [Adrenocorticotropes Hormon]-Hyposekretion",
      "Akute postpartale Hypophysenvorderlappeninsuffizienz",
      "Angeborener Hypopituitarismus",
      "Angeborener hypogonadotroper Hypogonadismus",
      "Angeborener normosmischer hypogonadotroper Hypogonadismus",
      "Apituitarismus",
      "Cachexia hypopituitaria",
      "Cachexia pituitaria",
      "Familiärer angeborener Hypopituitarismus",
      "Fertiler Eunuchoidismus",
      "Hypogonadotroper Eunuchoidismus",
      "Hypogonadotroper Hypogonadismus",
      "Hypophysenfunktionsstörung durch Empty-Sella-Syndrom",
      "Hypophysenhinterlappenunterfunktion",
      "Hypophyseninsuffizienz",
      "Hypophysennekrose",
      "Hypophysenunterfunktion",
      "Hypophysenvorderlappenunterfunktion",
      "Hypophysäre Kachexie",
      "Hypophysärer Hypoadrenokortizismus",
      "Hypophysärer Hypogonadismus",
      "Hypophysärer Infantilismus",
      "Hypophysärer Kleinwuchs",
      "Hypophysärer Kretinismus",
      "Hypophysärer Minderwuchs",
      "Hypophysäres Infantilismus-Syndrom",
      "Hypopituitarismus",
      "Hypopituitarismus post partum",
      "Hypopituitarismus-Syndrom",
      "Idiopathischer Somatotropinmangel",
      "Idiopathischer Wachstumshormonmangel",
      "Infertilität durch Affektion im Hypophysen-Zwischenhirnsystem bei der Frau",
      "Isolierter ACTH [Adrenocorticotropes Hormon]-Mangel",
      "Isolierter FSH [Follikelstimulierendes Hormon]-Mangel",
      "Isolierter Gonadotropinmangel",
      "Isolierter Hypophysenhormonmangel",
      "Isolierter Prolaktinmangel",
      "Isolierter Somatotropinmangel",
      "Isolierter Thyreotropinmangel",
      "Isolierter Wachstumshormonmangel",
      "Isolierter Wachstumshormonmangel Typ 1A",
      "Isolierter Wachstumshormonmangel Typ 1B",
      "Isolierter Wachstumshormonmangel Typ 2",
      "Isolierter Wachstumshormonmangel Typ 3",
      "Isolierter angeborener hypogonadotroper Hypogonadismus",
      "Juveniler Hypopituitarismus",
      "Kallmann-Syndrom",
      "Kongenitaler hypogonadotroper Hypogonadismus mit Anosmie",
      "Kongenitaler isolierter ACTH [Adrenocorticotropes Hormon]-Mangel",
      "Kongenitaler isolierter Wachstumshormonmangel",
      "Levi-Minderwuchs",
      "Lorain-Kleinwuchs",
      "Lorain-Levi-Minderwuchs",
      "Lorain-Syndrom",
      "Mangel an Hormonen des Hypophysenvorderlappens a.n.k.",
      "Morbus Sheehan",
      "Normosmischer idiopathischer hypogonadotroper Hypogonadismus",
      "Olfaktogenitales Syndrom",
      "Ovarunterfunktion bei Hypopituitarismus",
      "Panhypopituitarismus",
      "Pasqualini-Syndrom",
      "Postpartale Hypophysennekrose",
      "Postpartaler Panhypopituitarismus",
      "Präpubertärer Panhypopituitarismus",
      "Reye-Sheehan-Syndrom",
      "Sheehan-Krankheit",
      "Sheehan-Syndrom",
      "Simmonds-Kachexie",
      "Simmonds-Krankheit",
      "Simmonds-Sheehan-Syndrom",
      "Spät beginnender isolierter ACTH-Mangel",
      "Verminderte Hypophysenfunktion",
      "Verminderte Ovarfunktion bei Hypopituitarismus",
      "Wachstumshormonmangel"
    ]
  },
  {
    "code": "E23.1",
    "name": "Arzneimittelinduzierter Hypopituitarismus",
    "synonyms": [
      "Arzneimittelinduzierter Hypopituitarismus"
    ]
  },
  {
    "code": "E23.2",
    "name": "Diabetes spurius",
    "synonyms": [
      "Adiuretinhyposekretion",
      "Diabetes insipidus",
      "Diabetes insipidus vom neurogenen Typ",
      "Diabetes spurius",
      "Hypophysärer Diabetes insipidus",
      "Vasopressinhyposekretion",
      "Wasserharnruhr",
      "Zentraler Diabetes insipidus"
    ]
  },
  {
    "code": "E23.3",
    "name": "Dyspituitarismus",
    "synonyms": [
      "Dyspituitarismus",
      "Hypothalamischer Hypogonadismus",
      "Hypothalamisches Adipsie-Hypernatriämie-Syndrom",
      "Hypothalamusdysfunktion",
      "Hypothalamusüberaktivität"
    ]
  },
  {
    "code": "E23.6",
    "name": "Hypophysendystrophie",
    "synonyms": [
      "Adenohypophysitis",
      "Adipositas cerebralis",
      "Adiposogenitales Syndrom",
      "Babinski-Fröhlich-Syndrom",
      "Cystis intrasellaris",
      "Dienzephalussyndrom",
      "Dystrophia adiposogenitalis",
      "Fröhlich-Syndrom",
      "Hypophysenabszess",
      "Hypophysenatrophie",
      "Hypophysenblutung",
      "Hypophysendegeneration",
      "Hypophysendystrophie",
      "Hypophysenembolie",
      "Hypophysenfunktionsstörung durch Zyste der Rathke-Tasche",
      "Hypophysenhypertrophie",
      "Hypophysenhämorrhagie",
      "Hypophyseninfarkt",
      "Hypophysensekretionsstörung",
      "Hypophysenzyste",
      "Hypophysäre Fettsucht",
      "Hypoplasie der Geschlechtsorgane bei Dystrophia adiposogenitalis",
      "Infarkt des Hypophysenvorderlappens",
      "PSIS [Syndrom der isolierten Durchtrennung des Hypophysenstiels]",
      "Posttraumatische Hypophysenfunktionsstörung",
      "Syndrom der isolierten Durchtrennung des Hypophysenstiels",
      "Zyste der Rathke-Tasche"
    ]
  },
  {
    "code": "E23.7",
    "name": "Hormonelle Dysfunktion der Hypophyse",
    "synonyms": [
      "Hormonelle Dysfunktion der Hypophyse",
      "Hypophysendysfunktion",
      "Hypophysenfunktionsstörung",
      "Hypophysenkrankheit",
      "Hypophysenstörung",
      "Iatrogene Hypophysenstörung",
      "Nichttraumatische Schädigung des Hypothalamus"
    ]
  },
  {
    "code": "E24.0",
    "name": "Morbus Cushing",
    "synonyms": [
      "ACTH [Adrenocorticotropes Hormon]-Hypersekretion der Hypophyse",
      "ACTH [Adrenocorticotropes Hormon]-Überproduktion der Hypophyse",
      "Basophilismus",
      "Cortico-adrenaler Basophilismus",
      "Cushing-Basophilismus",
      "Hypophysärer Basophilismus",
      "Hypophysärer Hyperadrenokortizismus",
      "Hypophysärer Hyperkortizismus",
      "Hypophysäres Cushing-Syndrom",
      "Morbus Cushing",
      "Thymischer Basophilismus"
    ]
  },
  {
    "code": "E24.1",
    "name": "Nelson-Tumor",
    "synonyms": [
      "Nelson-Syndrom",
      "Nelson-Tumor"
    ]
  },
  {
    "code": "E24.2",
    "name": "Arzneimittelinduziertes Cushing-Syndrom",
    "synonyms": [
      "Artifizielles Cushing-Syndrom",
      "Arzneimittelinduziertes Cushing-Syndrom",
      "Iatrogenes Cushing-Syndrom"
    ]
  },
  {
    "code": "E24.3",
    "name": "Ektopisches ACTH [Adrenocorticotropes Hormon]-Syndrom",
    "synonyms": [
      "Cushing-Syndrom durch ektope ACTH [Adrenocorticotropes Hormon]-Produktion",
      "Cushing-Syndrom durch ektopischen ACTH [Adrenocorticotropes Hormon]-bildenden Tumor",
      "Ektopisches ACTH [Adrenocorticotropes Hormon]-Syndrom",
      "Extrahypophysäres ACTH [Adrenocorticotropes Hormon]-Syndrom"
    ]
  },
  {
    "code": "E24.4",
    "name": "Alkoholinduziertes Pseudo-Cushing-Syndrom",
    "synonyms": [
      "Alkoholinduziertes Pseudo-Cushing-Syndrom"
    ]
  },
  {
    "code": "E24.8",
    "name": "Idiopathisches Cushing-Syndrom",
    "synonyms": [
      "Cushing-Syndrom durch makronoduläre Nebennierenhyperplasie",
      "Idiopathisches Cushing-Syndrom",
      "Isolierte mikronoduläre adrenokortikale Krankheit",
      "Kleinhirnbrückenwinkel-Syndrom",
      "Primäre pigmentierte noduläre adrenokortikale Krankheit"
    ]
  },
  {
    "code": "E24.9",
    "name": "Crooke-Apert-Gallais-Syndrom",
    "synonyms": [
      "Adipositas osteoporotica endocrinica",
      "Apert-Cushing-Syndrom",
      "Basophiler Hyperpituitarismus",
      "Crooke-Apert-Gallais-Syndrom",
      "Cushing-Krankheit",
      "Cushing-Syndrom",
      "Dyskortizismus",
      "Endogenes Cushing-Syndrom",
      "Facies lunata",
      "Hyperadrenokortizismus",
      "Hyperkortisolismus",
      "Hyperkortizismus",
      "Hypersuprarenalismus",
      "Kortikoadrenale Hypersekretion",
      "Kortisolhypersekretion",
      "Mondgesicht",
      "Morbus Icenko-Cushing",
      "Vollmondgesicht"
    ]
  },
  {
    "code": "E25.00",
    "name": "Klassische Form des 21-Hydroxylase-Defektes",
    "synonyms": [
      "Klassische Form der kongenitalen Nebennierenhyperplasie durch 21-Hydroxylase-Mangel",
      "Klassische Form der kongenitalen Nebennierenhyperplasie mit Salzverlust durch 21-Hydroxylase-Mangel",
      "Klassische Form des 21-Hydroxylase-Defektes",
      "Klassische Form des 21-Hydroxylase-Mangels"
    ]
  },
  {
    "code": "E25.01",
    "name": "Late-onset-Form des 21-Hydroxylase-Defektes",
    "synonyms": [
      "Late-onset-Form des 21-Hydroxylase-Defektes",
      "Late-onset-Form des 21-Hydroxylase-Mangels"
    ]
  },
  {
    "code": "E25.08",
    "name": "11-Hydroxylase-Mangel",
    "synonyms": [
      "11-Hydroxylase-Mangel",
      "3-beta-Hydroxysteroid-Dehydrogenase-Mangel",
      "Hyperandrogenismus durch Kortisonreduktase-Mangel",
      "Kongenitale Nebennierenhyperplasie durch 11-beta-Hydroxylase-Mangel",
      "Kongenitale Nebennierenhyperplasie durch 17-alpha-Hydroxylase-Mangel",
      "Kongenitale Nebennierenhyperplasie durch 3-beta-Hydroxysteroid-Dehydrogenase-Mangel",
      "Kongenitale Nebennierenhyperplasie durch Cytochrom-P450-Oxydoreduktase-Mangel",
      "Kongenitale lipoide Nebennierenhyperplasie durch STAR [Steroidogenic acute regulatory protein]-Mangel"
    ]
  },
  {
    "code": "E25.09",
    "name": "Angeborenes adrenogenitales Syndrom",
    "synonyms": [
      "Angeborene Macrogenitosomia praecox",
      "Angeborene Makrogenitosomie",
      "Angeborene Maskulinisierung",
      "Angeborene Nebennierenhyperplasie mit Virilisierung",
      "Angeborene Nebennierenhyperplasie mit sexueller Frühreife",
      "Angeborene Nebennierenrindenhyperplasie",
      "Angeborene Vermännlichung",
      "Angeborener Virilismus",
      "Angeborener adrenaler Pseudohermaphroditismus femininus",
      "Angeborenes adrenogenitales Salzverlustsyndrom",
      "Angeborenes adrenogenitales Syndrom",
      "Kongenitale Salzverlusthyperplasie der Nebenniere",
      "Kongenitaler Hyperadrenokortizismus",
      "Pseudohermaphroditismus femininus bei angeborener Nebennierenrindenstörung",
      "Pseudohermaphroditismus masculinus bei angeborener Nebennierenrindenstörung",
      "Vorzeitige Pubertät durch angeborene Nebennierenrindenüberfunktion"
    ]
  },
  {
    "code": "E25.8",
    "name": "Pseudopubertas praecox",
    "synonyms": [
      "Adrenaler Pseudohermaphroditismus",
      "Adrenaler Pseudohermaphroditismus femininus",
      "Adrenaler Pseudohermaphroditismus masculinus",
      "Aromatase-Mangel",
      "Arzneimittelinduzierte adrenogenitale Störung",
      "Erworbenes adrenogenitales Syndrom mit Feminisierung",
      "Erworbenes adrenogenitales Syndrom mit Virilisierung",
      "Glukokortikoid-Resistenz",
      "Heterosexuelle Pseudopubertas praecox feminina",
      "Iatrogene adrenogenitale Störung",
      "Idiopathische adrenogenitale Störung",
      "Isosexuelle Pseudopubertas praecox masculina",
      "Primäre generalisierte Glukokortikoid-Resistenz",
      "Pseudohermaphroditismus femininus bei Nebennierenrindenstörung",
      "Pseudohermaphroditismus masculinus mit Nebennierenrindenstörung",
      "Pseudopubertas interrenalis",
      "Pseudopubertas praecox",
      "Vorzeitige Pseudopubertät",
      "Vorzeitige männliche isosexuelle Pseudopubertät",
      "Vorzeitige weibliche heterosexuelle Pseudopubertät"
    ]
  },
  {
    "code": "E25.9",
    "name": "Adrenogenitale Störung",
    "synonyms": [
      "AGS [Adrenogenitales Syndrom]",
      "Adrenale Makrogenitosomie",
      "Adrenaler Virilismus",
      "Adrenogenitale Störung",
      "Adrenogenitales Syndrom",
      "Genitoadrenales Syndrom",
      "Genitosuprarenales Syndrom",
      "Macrogenitosomia",
      "Macrogenitosomia praecox",
      "Macrogenitosomia praecox beim Knaben",
      "Macrogenitosomia praecox beim Mann",
      "Macrogenitosomia praecox masculina",
      "Makrogenitosomie",
      "Maskulinisierung",
      "Männliche Makrogenitosomie",
      "Nebennierenhyperplasie mit Virilisierung",
      "Nebennierenhyperplasie mit adrenalem Virilismus",
      "Sexuelle Frühreife bei Nebennierenrindenhyperplasie beim Knaben",
      "Vermännlichung",
      "Virago",
      "Virilisierung",
      "Virilisierung bei der Frau",
      "Virilismus",
      "Vorzeitig sexuelle Entwicklung bei Nebennierenrindenhyperplasie",
      "Vorzeitige Pubertät durch Nebennierenrindenüberfunktion",
      "Weibliche Maskulinisierung bei Nebennierenrindenhyperplasie",
      "Weibliche Virilisierung"
    ]
  },
  {
    "code": "E26.0",
    "name": "Primärer Hyperaldosteronismus",
    "synonyms": [
      "Conn-Syndrom",
      "Einseitige primäre Nebennierenhyperplasie",
      "FH [Familiärer Hyperaldosteronismus] Typ 1",
      "FH [Familiärer Hyperaldosteronismus] Typ 2",
      "FH [Familiärer Hyperaldosteronismus] Typ 3",
      "Familiärer Hyperaldosteronismus",
      "Familiärer Hyperaldosteronismus Typ 1",
      "Familiärer Hyperaldosteronismus Typ 2",
      "Familiärer Hyperaldosteronismus Typ 3",
      "Familiärer Hyperaldosteronismus Typ 4",
      "Genetisch bedingter Hyperaldosteronismus",
      "Glucocorticoid-behandelbarer Hyperaldosteronismus",
      "Hypertension mit Glukokortikoid-Sensibilität",
      "Morbus Conn",
      "Primärer Aldosteronismus",
      "Primärer Aldosteronismus durch Nebennierenrindenhyperplasie",
      "Primärer Aldosteronismus durch beidseitige Nebennierenrindenhyperplasie",
      "Primärer Hyperaldosteronismus"
    ]
  },
  {
    "code": "E26.1",
    "name": "Sekundärer Hyperaldosteronismus",
    "synonyms": [
      "Renaler Hyperaldosteronismus",
      "Sekundärer Hyperaldosteronismus"
    ]
  },
  {
    "code": "E26.8",
    "name": "Hyperreninämie",
    "synonyms": [
      "Bartter-Syndrom",
      "Bartter-Syndrom Typ 1",
      "Bartter-Syndrom Typ 2",
      "Bartter-Syndrom Typ 3",
      "Bartter-Syndrom Typ 4",
      "Bartter-Syndrom Typ 5",
      "Hyperreninämie",
      "Hyporeninämie"
    ]
  },
  {
    "code": "E26.9",
    "name": "Aldosteronismus",
    "synonyms": [
      "Aldosteronismus",
      "Erhöhte Aldosteronproduktion",
      "Erhöhte Aldosteronsekretion",
      "Hyperaldosteronismus",
      "Vermehrte Aldosteronproduktion",
      "Vermehrte Aldosteronsekretion"
    ]
  },
  {
    "code": "E27.0",
    "name": "Vorzeitige Adrenarche",
    "synonyms": [
      "ACTH [Adrenocorticotropes Hormon]-Hypersekretion, nicht in Verbindung mit Cushing-Syndrom",
      "ACTH [Adrenocorticotropes Hormon]-Überproduktion",
      "ACTH [Adrenocorticotropes Hormon]-Überproduktion, nicht in Verbindung mit Cushing-Krankheit",
      "Adrenale Androgenhypersekretion",
      "Adrenale Androgenvermehrung",
      "Adrenale Androgenüberproduktion",
      "Adrenaler Androgenüberschuss",
      "Adrenaler Hyperandrogenismus",
      "Adrenokortikales Syndrom",
      "Androgenhyperkrinie der Nebenniere",
      "Androgenhypersekretion der Nebenniere",
      "Hyperadrenokortizismus, nicht in Verbindung mit Cushing-Syndrom",
      "Mineralokortikoid-Exzess",
      "Nebennierenrindenüberaktivität a.n.k.",
      "Nebennierenüberfunktion",
      "Vorzeitige Adrenarche",
      "Überfunktion der Nebennierenrinde"
    ]
  },
  {
    "code": "E27.1",
    "name": "Primäre Nebennierenrindeninsuffizienz",
    "synonyms": [
      "Addison-Krankheit",
      "Addison-Melanose",
      "Addison-Syndrom",
      "Adrenale Melanose",
      "Adrenomyodystrophie",
      "Autoimmunadrenalitis",
      "Autoimmune Addison-Krankheit",
      "Bronzehautkrankheit",
      "Bronzekrankheit",
      "Familiäre Nebennierenhypoplasie bei fehlendem LH [Luteinisierendes Hormon]",
      "Familiärer Glukokortikoid-Mangel",
      "Immunadrenalitis",
      "Kongenitale Nebennierenhypoplasie vom zytomegalen Typ",
      "Melasma suprarenale",
      "Morbus Addison",
      "Nebennierenmelasma",
      "Primäre Nebennierenrindenatrophie",
      "Primäre Nebennierenrindeninsuffizienz",
      "Primäre Nebennierenrindenunterfunktion",
      "Primäre adrenale Insuffizienz",
      "Primäre adrenokortikale Insuffizienz",
      "Primäre suprarenale Insuffizienz",
      "Primärer Hypoadrenalismus",
      "Primärer Hypoadrenokortizismus",
      "Suprarenale Melanose",
      "Suprarenales Melasma",
      "Vererbte isolierte Nebenniereninsuffizienz durch CYP11A1-Defizienz"
    ]
  },
  {
    "code": "E27.2",
    "name": "Addison-Krise",
    "synonyms": [
      "Addison-Krise",
      "Adrenaler Kollaps",
      "Akute Nebenniereninsuffizienz",
      "Akute Nebennierenrindeninsuffizienz",
      "Akutes Nebennierenversagen",
      "Nebennierenkrise",
      "Nebennierenrindenkrise"
    ]
  },
  {
    "code": "E27.3",
    "name": "Arzneimittelinduzierte Nebennierenrindenunterfunktion",
    "synonyms": [
      "Arzneimittelinduzierte Nebennierenrindenunterfunktion",
      "Arzneimittelinduzierte adrenokortikale Insuffizienz",
      "Iatrogene adrenokortikale Insuffizienz"
    ]
  },
  {
    "code": "E27.4",
    "name": "Hyposuprarenalismus",
    "synonyms": [
      "18-Hydroxylase-Mangel",
      "18-Oxydase-Mangel",
      "Adrenale Insuffizienz",
      "Adrenokortikale Insuffizienz",
      "Aldosteron-Synthetase-Mangel",
      "Aldosteron-Synthetase-Mangel unabhängig vom CYP11B2-Gen",
      "Apoplexie der Nebennierenrinde",
      "Atrophie der Nebennierenrinde",
      "Blutung der Nebennierenrinde",
      "CMO [Corticosteron-Methyloxidase]-Mangel Typ I",
      "Corticosteron-Methyloxidase-Mangel Typ I",
      "Dystrophie der Nebennierenrinde",
      "Familiärer Hypoaldosteronismus",
      "Familiärer hyperreninämischer Hypoaldosteronismus Typ 1",
      "Familiärer hyperreninämischer Hypoaldosteronismus Typ 2",
      "Hypoadrenalismus",
      "Hypoadrenokortizismus",
      "Hypoaldosteronismus",
      "Hypokortisolismus",
      "Hypokortizismus",
      "Hyposuprarenalismus",
      "Hämorrhagie der Nebennierenrinde",
      "Infarkt der Nebennierenrinde",
      "Infarkt des Nebennierenmarks",
      "Insuffizienz der Nebennierenrinde",
      "Kalzifikation der Nebennierenrinde",
      "Kortikoadrenale Insuffizienz",
      "Kortikoadrenale Unterfunktion a.n.k.",
      "Nebennierenapoplexie",
      "Nebennierenblutung",
      "Nebennierenhämorrhagie",
      "Nebenniereninfarkt",
      "Nebenniereninfarzierung",
      "Nebenniereninsuffizienz",
      "Nebenniereninsult",
      "Nebennierennekrose",
      "Nebennierenunterfunktion",
      "Nekrose der Nebennierenrinde",
      "Suprarenale Insuffizienz",
      "Suprarenale Nekrose",
      "Suprarenaler Infarkt",
      "Triple-A [Achalasie, Morbus Addison, Alakrimie]-Syndrom",
      "Unterfunktion der Nebennierenrinde",
      "Verkalkung der Nebennierenrinde"
    ]
  },
  {
    "code": "E27.5",
    "name": "Hyperadrenalismus",
    "synonyms": [
      "Adrenomedulläre Hyperplasie",
      "Gesteigerte Funktion des Nebennierenmarks",
      "Hormonsekretion durch Phäochromozytom",
      "Hyperadrenalismus",
      "Hyperadrenie",
      "Hyperplasie des Nebennierenmarks",
      "Hypersekretion des Nebennierenmarks",
      "Hypersekretion von Adrenalin",
      "Hypersekretion von Katecholaminen",
      "Überfunktion des Nebennierenmarks"
    ]
  },
  {
    "code": "E27.8",
    "name": "Nebennierenabszess",
    "synonyms": [
      "Abnormes Transkortin",
      "Abnormität des Transcortins",
      "Abnormität des kortisolbindenden Globulins",
      "Adrenale Fibrose",
      "Adrenale Hyperplasie",
      "Adrenalitis",
      "Adrenitis",
      "Anomalie des kortisolbindenden Globulins",
      "Blutung des Nebennierenmarkes",
      "Hyalinose der Nebennierenrinde",
      "Hyperplasie der Nebennierenrinde",
      "Hypertrophie der Nebennierenrinde",
      "Hypoplasie der Nebennierenrinde",
      "Hämorrhagie des Nebennierenmarkes",
      "Knotige Verdickung der Nebenniere",
      "Knotige Veränderung der Nebenniere",
      "Mangel des kortisolbindenden Globulins",
      "Narbe der Nebennierenrinde",
      "Nebennierenabszess",
      "Nebennierenatrophie",
      "Nebennierendegeneration",
      "Nebennierenhyperplasie",
      "Nebennierenhypertrophie",
      "Nebennierenhypoplasie",
      "Nebennierenkalzifikation",
      "Nebennierensklerose",
      "Nebennierenverdickung",
      "Nebennierenvergrößerung",
      "Nebennierenverkalkung",
      "Nebennierenzyste",
      "Suprarenale Degeneration",
      "Transcortin-Mangel",
      "Unterfunktion des Nebennierenmarks",
      "Zyste der Nebennierenrinde"
    ]
  },
  {
    "code": "E27.9",
    "name": "Dysadrenokortizismus",
    "synonyms": [
      "Adrenale Dysfunktion",
      "Adrenale Hormonstoffwechselstörung",
      "Adrenale hormonelle Dysregulation",
      "Dysadrenokortizismus",
      "Hormonelle Dysregulation der Nebenniere",
      "Hormonstoffwechselstörung der Nebenniere",
      "Nebennierenerkrankung",
      "Nebennierenkrankheit",
      "Nebennierenveränderung",
      "Störung der Nebenniere",
      "Störung der Nebennierenrinde",
      "Suprarenale Dysfunktion"
    ]
  },
  {
    "code": "E28.0",
    "name": "Ovarialdysfunktion mit Östrogenüberschuss",
    "synonyms": [
      "Arzneimittelinduzierter Östrogenüberschuss",
      "Hypersekretion von Östrogen",
      "Hyperöstrogenismus",
      "Iatrogener Östrogenüberschuss",
      "Ovarialdysfunktion mit Östrogenüberschuss",
      "Östrogenüberschuss"
    ]
  },
  {
    "code": "E28.1",
    "name": "Ovarialdysfunktion mit Androgenüberschuss",
    "synonyms": [
      "Androgenisierung",
      "Androgenüberschuss",
      "Erhöhte ovariale Androgenproduktion",
      "Hyperandrogenämie bei der Frau",
      "Ovarialdysfunktion mit Androgenüberschuss",
      "Ovariale Androgenhypersekretion",
      "Ovariale Androgenvermehrung",
      "Ovariale Androgenüberproduktion",
      "Ovarialer Androgenüberschuss"
    ]
  },
  {
    "code": "E28.2",
    "name": "PCO [Polyzystisches Ovar]-Syndrom",
    "synonyms": [
      "PCO [Polyzystisches Ovar]-Syndrom",
      "PCOS [Polyzystisches Ovar-Syndrom]",
      "Polyzystische Ovarien",
      "Polyzystische Ovarkrankheit",
      "Polyzystisches-Ovar-Syndrom",
      "Sklerozystisches Ovar",
      "Stein-Leventhal-Syndrom",
      "Stein-Leventhal-Syndrom mit Infertilität bei der Frau",
      "Syndrom polyzystischer Ovarien"
    ]
  },
  {
    "code": "E28.3",
    "name": "Primäre Ovarialinsuffizienz",
    "synonyms": [
      "Climacterium praecox",
      "Hypergonadotrope Ovarialinsuffizienz",
      "Hypoovarismus",
      "Mangel an ovarialer Sekretion",
      "Ovarialer Hypogonadismus",
      "Ovarialhyposekretion",
      "Ovarialinsuffizienz",
      "Primäre Ovarialinsuffizienz",
      "Primärer ovarialer Hypogonadismus",
      "Primäres Nachlassen der Ovarfunktion",
      "Primäres Ovarialversagen",
      "Prämenopausensyndrom",
      "Syndrom gonadotropinresistenter Ovarien",
      "Syndrom resistenter Ovarien",
      "Unterfunktion der Ovarien",
      "Verminderte ovariale Sekretion",
      "Vorzeitige Menopause",
      "Vorzeitiges Klimakterium",
      "Weiblicher Hypogonadismus",
      "Östrogenmangel",
      "Östrogenverminderung"
    ]
  },
  {
    "code": "E28.8",
    "name": "Funktionelle Ovarialinsuffizienz",
    "synonyms": [
      "Funktionelle Ovarialinsuffizienz",
      "Gelbkörperhormonschwäche",
      "Gestagenmangel",
      "Hyperfollikulinie",
      "Hyperhormonale Amenorrhoe",
      "Hyperovarismus",
      "Hyperthecosis ovarii",
      "Insuffizienz des Corpus luteum",
      "Ovarialer Hypergonadismus",
      "Ovarialüberfunktion",
      "Persistierendes Corpus luteum",
      "Störung der Oogenese",
      "Thekomatose"
    ]
  },
  {
    "code": "E28.9",
    "name": "Ovarialstörung",
    "synonyms": [
      "Einschränkung der Ovarialfunktion",
      "Funktionsstörung der Ovarien",
      "Hormonelle Dysfunktion der Ovarien",
      "Ovarialdysfunktion",
      "Ovarialstörung"
    ]
  },
  {
    "code": "E29.0",
    "name": "Testikulärer Hypergonadismus",
    "synonyms": [
      "Erhöhte testikuläre Androgenproduktion",
      "Hodenüberfunktion",
      "Hyperandrogenämie",
      "Hyperandrogenämie beim Mann",
      "Hypersekretion testikulärer Hormone",
      "Männlicher Hypergonadismus",
      "Testikuläre Androgenhypersekretion",
      "Testikuläre Androgenvermehrung",
      "Testikuläre Androgenüberproduktion",
      "Testikuläre Überfunktion",
      "Testikulärer Androgenüberschuss",
      "Testikulärer Hypergonadismus"
    ]
  },
  {
    "code": "E29.1",
    "name": "Androgendeprivation",
    "synonyms": [
      "17-Keto-Reduktase-Mangel",
      "17-Ketosteroid-Reduktase-Mangel",
      "17-beta-Hydroxysteroid-Dehydrogenase 3-Mangel",
      "5-Alpha-Reduktase-Mangel",
      "5-Alpha-Reduktase-Mangel mit Pseudohermaphroditismus masculinus",
      "Abnorme Biosynthese der testikulären Androgene",
      "Androgendeprivation",
      "Androgenmangel",
      "Anti-Müller-Hormon-Mangel",
      "Defekt der Biosynthese der testikulären Androgene",
      "Eunuchoidismus",
      "Feminisierung",
      "Hodeninsuffizienz",
      "Hodenunterentwicklung",
      "Hodenunterfunktion",
      "Hypogonadismus-Syndrom beim Mann",
      "Leydigzell-Insuffizienz",
      "Mangel an testikulären Hormonen",
      "Männlicher Eunuchismus",
      "Männlicher Hypogonadismus",
      "Männlicher Pseudohermaphroditismus durch 17-beta-Hydroxysteroid-Dehydrogenase 3-Mangel",
      "Primärer testikulärer Hypogonadismus",
      "Reduktion der Spermatogenese",
      "Spermatogenetische Insuffizienz",
      "Störung der Biosynthese der testikulären Androgene",
      "Störung der Geschlechtsentwicklung durch 17-beta-Hydroxysteroid-Dehydrogenase 3-Mangel, mit Karyotyp 46,XY",
      "Störung der Geschlechtsentwicklung durch 5-Alpha-Reduktase 2-Mangel, mit Karyotyp 46,XY",
      "Störung der Geschlechtsentwicklung durch isolierten 17,20-Lyase-Mangel, mit Karyotyp 46,XY",
      "Störung der Geschlechtsentwicklung durch testikulären 17,20-Desmolase-Mangel, mit Karyotyp 46,XY",
      "Testikuläre Insuffizienz",
      "Testikuläre Unterfunktion",
      "Testikulärer Hypogonadismus",
      "Testisinsuffizienz",
      "Testosteronmangel",
      "Versagen der testikulären endokrinen Funktion",
      "Verweiblichung"
    ]
  },
  {
    "code": "E29.9",
    "name": "Testikuläre Dysfunktion",
    "synonyms": [
      "Funktionsstörung des Hodens",
      "Gestörte Spermatogenese",
      "Nicht traumatische Hodenschädigung",
      "Pseudohermaphroditismus masculinus mit Gonadenstörung",
      "Schädigung der Spermatogenese",
      "Testikuläre Dysfunktion"
    ]
  },
  {
    "code": "E30.0",
    "name": "Verzögerte Pubertät",
    "synonyms": [
      "Infantile Genitalien nach der Pubertät",
      "Konstitutionell verzögerte Pubertät",
      "Konstitutionelle Pubertätsverzögerung",
      "Pubertas tarda",
      "Sexuelle Unreife nach der Pubertät",
      "Sexuelle Unterentwicklung",
      "Späte Thelarche",
      "Uterusunterentwicklung",
      "Verzögerte Menarche",
      "Verzögerte Pubertät",
      "Verzögerte sexuelle Entwicklung",
      "Verzögerung der sexuellen Entwicklung"
    ]
  },
  {
    "code": "E30.1",
    "name": "Vorzeitige Pubertät",
    "synonyms": [
      "Aromatase-Exzess-Syndrom",
      "FMPP [Familiäre männliche Pubertas praecox]",
      "Idiopathische sexuelle Frühreife",
      "Konstitutionelle sexuelle Frühreife",
      "Kryptogene sexuelle Frühreife",
      "Männliche sexuelle Frühreife",
      "Pubertas praecox",
      "Sexuelle Frühreife",
      "Vorzeitige Menarche",
      "Vorzeitige Menstruation",
      "Vorzeitige Pubertät",
      "Vorzeitige sexuelle Entwicklung",
      "Weibliche sexuelle Frühreife"
    ]
  },
  {
    "code": "E30.8",
    "name": "Vorzeitige Thelarche",
    "synonyms": [
      "Pseudo-Fröhlich-Syndrom",
      "Pubertätsfettsucht",
      "Vorzeitige Pubarche",
      "Vorzeitige Thelarche"
    ]
  },
  {
    "code": "E30.9",
    "name": "Pubertätsstörung",
    "synonyms": [
      "Pubertätsstörung"
    ]
  },
  {
    "code": "E31.0",
    "name": "Autoimmune polyglanduläre Insuffizienz",
    "synonyms": [
      "APS [Autoimmunes polyglanduläres Syndrom]",
      "Autoimmun-Polyendokrinopathie Typ 1",
      "Autoimmune Enteropathie Typ 1",
      "Autoimmune Polyendokrinopathie",
      "Autoimmune Polyendokrinopathie Typ 2",
      "Autoimmune Polyendokrinopathie Typ 3",
      "Autoimmune Polyendokrinopathie Typ 4",
      "Autoimmune pluriglanduläre Atrophie",
      "Autoimmune polyglanduläre Insuffizienz",
      "Autoimmuner Hypoparathyreoidismus mit Candidiasis und Nebennierenrindeninsuffizienz",
      "Autoimmuner polyglandulärer Mangel",
      "Autoimmunes polyglanduläres Syndrom",
      "Autoimmunes polyglanduläres Syndrom Typ 1",
      "Autoimmunes polyglanduläres Syndrom Typ 2",
      "Autoimmunes polyglanduläres Versagen",
      "Polyendokrines Autoimmunsyndrom Typ II",
      "Progressive polyglanduläre Insuffizienz",
      "Schmidt-Syndrom",
      "Syndrom der thyreoadrenokortikalen Insuffizienz",
      "X-chromosomales Syndrom mit Immundysregulation, Polyendokrinopathie und Enteropathie"
    ]
  },
  {
    "code": "E31.1",
    "name": "Polyglanduläre Überfunktion",
    "synonyms": [
      "Polyglanduläre Überfunktion"
    ]
  },
  {
    "code": "E31.8",
    "name": "Pluriglanduläre Atrophie",
    "synonyms": [
      "Bangstad-Syndrom",
      "Pluriglanduläre Atrophie",
      "Polyglanduläre Dystrophie"
    ]
  },
  {
    "code": "E31.9",
    "name": "Polyglanduläre Dysfunktion",
    "synonyms": [
      "Glanduläre Insuffizienz",
      "Polyglanduläre Dysfunktion",
      "Polyglanduläre Dyskrasie",
      "Polyglanduläre Funktionsstörung",
      "Polyglanduläre Insuffizienz",
      "Polyglandulärer Mangel"
    ]
  },
  {
    "code": "E32.0",
    "name": "Persistierende Thymushyperplasie",
    "synonyms": [
      "Kongenitale Thymushypertrophie",
      "Mangelnde Thymusinvolution",
      "Persistierende Thymushyperplasie",
      "Thymismus",
      "Thymushyperplasie",
      "Thymushypertrophie",
      "Thymusvergrößerung"
    ]
  },
  {
    "code": "E32.1",
    "name": "Thymusabszess",
    "synonyms": [
      "Thymusabszess",
      "Thymusdrüsenabszess",
      "Thymuseiterung"
    ]
  },
  {
    "code": "E32.8",
    "name": "Asthma thymicum",
    "synonyms": [
      "Asthma thymicum",
      "Fettige Thymusdegeneration",
      "Fettige Thymusinfiltration",
      "Hyperfunktion des Thymus",
      "Hämorrhagie des Thymus",
      "Status thymico-lymphaticus",
      "Thymitis",
      "Thymus persistens",
      "Thymus-Syndrom",
      "Thymusatrophie",
      "Thymusblutung",
      "Thymusdegeneration",
      "Thymusentzündung",
      "Thymusfibrose",
      "Thymushypoplasie",
      "Thymusinvolution",
      "Thymusnekrose",
      "Thymusparenchymblutung",
      "Thymuszyste"
    ]
  },
  {
    "code": "E32.9",
    "name": "Thymuskrankheit",
    "synonyms": [
      "Dysfunktion des Thymus",
      "Thymuskrankheit"
    ]
  },
  {
    "code": "E34.0",
    "name": "Cassidy-Scholte-Syndrom",
    "synonyms": [
      "Biörck-Thorson-Syndrom [Karzinoidsyndrom]",
      "Cassidy-Scholte-Syndrom",
      "Flushsyndrom",
      "Hedinger-Syndrom",
      "Hormonsekretion durch karzinoiden Tumor",
      "Karzinoidose",
      "Karzinoidsyndrom",
      "Steiner-Voerner-Syndrom"
    ]
  },
  {
    "code": "E34.1",
    "name": "Hypersekretion intestinaler Hormone a.n.k.",
    "synonyms": [
      "Hypersekretion intestinaler Hormone a.n.k."
    ]
  },
  {
    "code": "E34.2",
    "name": "Hormonsekretion einer Non-in-loco-Drüse",
    "synonyms": [
      "Ektopische Hormonsekretion a.n.k.",
      "Hormonsekretion aus versprengtem Drüsengewebe a.n.k.",
      "Hormonsekretion einer Non-in-loco-Drüse"
    ]
  },
  {
    "code": "E34.3",
    "name": "Minderwuchs",
    "synonyms": [
      "Infantiler Minderwuchs",
      "Kleinwuchs",
      "Kleinwuchs durch GHSR [Growth hormone secretagogue receptor]-Mangel",
      "Kleinwuchs durch partiellen GHR [Growth hormone receptor]-Mangel",
      "Kleinwuchs durch primären Mangel der säurelabilen Untereinheit",
      "Kongenitaler Kleinwuchs",
      "Kongenitaler Minderwuchs",
      "Konstitutioneller Kleinwuchs",
      "Konstitutioneller Minderwuchs",
      "Minderwuchs",
      "Minderwuchs vom Laron-Typ",
      "Nanismus",
      "Nanosomie",
      "Psychosozialer Kleinwuchs",
      "Psychosozialer Minderwuchs",
      "Wachstumsverzögerung durch IGF-1 [Insulin-ähnlicher Wachstumsfaktor 1]-Resistenz"
    ]
  },
  {
    "code": "E34.4",
    "name": "Konstitutioneller Hochwuchs",
    "synonyms": [
      "Großwuchs",
      "Hochwuchs",
      "Hypersomie",
      "Konstitutioneller Hochwuchs",
      "Konstitutioneller Riesenwuchs",
      "Riesenwuchs",
      "Überlänge"
    ]
  },
  {
    "code": "E34.50",
    "name": "Reifenstein-Syndrom",
    "synonyms": [
      "Partielle Androgen-Insensitivität [PAIS]",
      "Reifenstein-Syndrom"
    ]
  },
  {
    "code": "E34.51",
    "name": "Testikuläre Feminisierung",
    "synonyms": [
      "Goldberg-Maxwell-Syndrom",
      "Hairless woman syndrome",
      "Komplette Androgen-Insensitivität [CAIS]",
      "Syndrom der testikulären Feminisierung",
      "Testikuläre Feminisierung"
    ]
  },
  {
    "code": "E34.59",
    "name": "Androgenresistenzsyndrom",
    "synonyms": [
      "Androgen-Insensitivität",
      "Androgenresistenz",
      "Androgenresistenzsyndrom",
      "Leydig-Zell-Hypoplasie",
      "Periphere Androgenrezeptorstörung",
      "Pseudohermaphroditismus masculinus mit Androgenresistenz",
      "Pseudohermaphroditismus masculinus mit testikulärer Feminisierung"
    ]
  },
  {
    "code": "E34.8",
    "name": "Hyperpinealismus",
    "synonyms": [
      "Adulte Progerie",
      "Akrogerie Gottron",
      "Atypisches Werner-Syndrom",
      "CDKN1C-assoziiertes Syndrom der intrauterinen Wachstumsretardierung mit Kleinwuchs",
      "Corpus-pineale-Syndrom",
      "Degeneration der Zirbeldrüse",
      "Donohue-Syndrom",
      "Dysfunktion des Corpus pineale",
      "Epiphysendysfunktion",
      "Hutchinson-Gilford-Krankheit",
      "Hutchinson-Gilford-Syndrom",
      "Hyperpinealismus",
      "Hypopinealismus",
      "Kalzifikation der Zirbeldrüse",
      "LMNA-abhängiges kardiokutanes Progerie-Syndrom",
      "Leprechaunismus",
      "Leprechaunismussyndrom",
      "MDPL [Mandibuläre Hypoplasie, Schwerhörigkeit, progeroide Merkmale, Lipodystrophie]-Syndrom",
      "Nestor-Guillermo-Progerie-Syndrom",
      "Petty-Laxova-Wiedemann-Syndrom",
      "Progerie",
      "Progerie-Kleinwuchs-Pigmentnävi-Syndrom",
      "Pseudo-Leprechaunismus-Syndrom Typ Patterson",
      "Syndrom der vorzeitigen Senilität",
      "Vergreisung im Kindesalter",
      "Vorzeitige Alterung",
      "Vorzeitige Pubertät durch Zirbeldrüsentumor",
      "Vorzeitige Vergreisung",
      "Vorzeitiges Alterungssyndrom Typ Penttinen",
      "Werner-Krankheit",
      "Werner-Syndrom",
      "Wiedemann-Rautenstrauch-Syndrom",
      "Zirbeldrüsenkrankheit",
      "Zirbeldrüsenzyste",
      "Zyste des Corpus pineale",
      "Östrogen-Resistenz-Syndrom",
      "Überfunktion der Zirbeldrüse"
    ]
  },
  {
    "code": "E34.9",
    "name": "Dyskrinie",
    "synonyms": [
      "Angeborene Steroidstoffwechselstörung",
      "Drüsendysfunktion a.n.k.",
      "Dysendokrinismus",
      "Dyskrinie",
      "Endokrine Dysfunktion a.n.k.",
      "Endokrine Komplikation",
      "Endokrine Störung",
      "Endokrinopathie",
      "Gestörtes Gleichgewicht des Endokriniums",
      "Gestörtes Hormongleichgewicht",
      "Hormonelle Dysfunktion",
      "Hormonelle Insuffizienz",
      "Hormonelle Störung",
      "Hormonelle gynäkologische Störung",
      "Hormoneller Ausfall",
      "Hormonmangel",
      "Hormonstörung",
      "Krankheit der endokrinen Drüsen a.n.k.",
      "Krankheit des endokrinen Systems a.n.k.",
      "Sexualhormonstörung",
      "Stoffwechselkomplikation",
      "Störung der Sexualhormonsekretion",
      "Störung der endokrinen Drüsen"
    ]
  },
  {
    "code": "E40",
    "name": "Kwashiorkor",
    "synonyms": [
      "Ernährungsödem mit Störungen der Haut- und Haarpigmentierung",
      "Kwashiorkor",
      "Kwashiorkor-Syndrom",
      "Maligne Malnutrition",
      "Malignes Unterernährungssyndrom",
      "Polykarenzsyndrom"
    ]
  },
  {
    "code": "E41",
    "name": "Alimentärer Marasmus",
    "synonyms": [
      "Abmagerung",
      "Abmagerung durch Mangelernährung",
      "Abzehrung - s.a. Marasmus",
      "Alimentärer Marasmus",
      "Erhebliche Mangelernährung mit Marasmus",
      "Extreme Abmagerung",
      "Hunger-Marasmus",
      "Intestinaler Marasmus",
      "Kachexie bei Ernährungsstörung",
      "Marasmus",
      "Marasmus durch Unterernährung",
      "Schwerer Kalorienmangel mit Marasmus"
    ]
  },
  {
    "code": "E42",
    "name": "Kwashiorkor-Marasmus",
    "synonyms": [
      "Erhebliche Energie- und Eiweißmangelernährung mit Anzeichen von Kwashiorkor und Marasmus gleichzeitig",
      "Intermediäre Form einer erheblichen Energie- und Eiweißmangelernährung",
      "Intermediäre Form einer schweren Protein-Kalorien-Malnutrition",
      "Kwashiorkor-Marasmus"
    ]
  },
  {
    "code": "E43",
    "name": "Schwere Unterernährung",
    "synonyms": [
      "Ernährungsbedingter Hydrops",
      "Ernährungsödemsyndrom",
      "Hungerödem",
      "Inanition mit Ödem",
      "Malnutrition 3. Grades",
      "Mangelödem - s.a. Malnutrition, 3. Grades",
      "Schwere Protein-Kalorien-Malnutrition",
      "Schwere Unterernährung",
      "Schwerer Kalorienmangel"
    ]
  },
  {
    "code": "E44.0",
    "name": "Mäßige Unterernährung",
    "synonyms": [
      "Malnutrition 2. Grades",
      "Mäßige Unterernährung",
      "Mäßiggradige Malnutrition"
    ]
  },
  {
    "code": "E44.1",
    "name": "Leichte Unterernährung",
    "synonyms": [
      "Leichte Unterernährung",
      "Leichtgradige Malnutrition",
      "Malnutrition 1. Grades"
    ]
  },
  {
    "code": "E45",
    "name": "Dystrophie durch Unterernährung",
    "synonyms": [
      "Alimentäre Dystrophie",
      "Alimentäre Entwicklungshemmung",
      "Alimentärer Minderwuchs",
      "Dystrophie durch Unterernährung",
      "Eiweißmangelernährung mit Entwicklungsverzögerung",
      "Entwicklungshemmung durch Malnutrition",
      "Entwicklungsstillstand durch Unterernährung",
      "Ernährungsbedingter Kleinwuchs",
      "Ernährungsbedingter Minderwuchs",
      "Ernährungsdystrophie",
      "Hungeratrophie",
      "Hungerdystrophie",
      "Inanitionsatrophie",
      "Inanitionsdystrophie",
      "Körperliche Retardierung durch Mangelernährung",
      "Körperlicher Entwicklungsrückstand durch Unterernährung beim Kind"
    ]
  },
  {
    "code": "E46",
    "name": "Protein-Kalorien-Malnutrition",
    "synonyms": [
      "Albuminmangel",
      "Eiweißmalnutrition",
      "Eiweißmangel",
      "Eiweißmangelernährung",
      "Eiweißunterernährung",
      "Energiemalnutrition",
      "Energiemangelernährung",
      "Fehlernährung",
      "Hunger durch Mangelernährung",
      "Hypoalimentation",
      "Inanition durch Mangelernährung",
      "Kalorienmalnutrition",
      "Malnutrition",
      "Mangel an energieliefernden Stoffen",
      "Mangelernährung",
      "Protein-Kalorien-Malnutrition",
      "Proteinmangel a.n.k.",
      "Proteinmangelernährung",
      "Reduzierter Ernährungszustand",
      "Störung der Protein-Energie-Balance",
      "Störung der Protein-Energie-Bilanz",
      "Unterernährung"
    ]
  },
  {
    "code": "E50.1",
    "name": "Bitot-Flecken beim Kleinkind",
    "synonyms": [
      "Bitot-Flecken beim Kleinkind"
    ]
  },
  {
    "code": "E50.7",
    "name": "Vitamin-A-Mangel des Auges",
    "synonyms": [
      "Vitamin-A-Mangel des Auges"
    ]
  },
  {
    "code": "E50.9",
    "name": "Vitamin-A-Mangel",
    "synonyms": [
      "Avitaminose A",
      "Hypovitaminose A",
      "Karotinmangel",
      "Vitamin-A-Mangel",
      "Vitamin-A-Mangel-Syndrom"
    ]
  },
  {
    "code": "E51.1",
    "name": "Beriberi",
    "synonyms": [
      "Beriberi",
      "Beriberi bei Vitamin-B-Mangel",
      "Feuchte Form der Beriberi",
      "Kakké",
      "Reisesser-Krankheit",
      "Trockene Form der Beriberi"
    ]
  },
  {
    "code": "E51.2",
    "name": "Pseudoencephalitis haemorrhagica superior",
    "synonyms": [
      "Pseudoencephalitis acuta haemorrhagica superior",
      "Pseudoencephalitis haemorrhagica superior"
    ]
  },
  {
    "code": "E51.9",
    "name": "Aneurinmangel",
    "synonyms": [
      "Aneurinmangel",
      "Aneurinmangelkrankheit",
      "Thiaminhydrochloridmangel",
      "Thiaminmangel",
      "Vitamin-B1-Mangel"
    ]
  },
  {
    "code": "E52",
    "name": "Pellagra",
    "synonyms": [
      "Alkoholbedingte Pellagra",
      "Dermatitis pellagrosa",
      "Elephantiasis italica",
      "Endemisches Erythem",
      "Erythema endemicum",
      "Italienischer Aussatz",
      "Lepra asturica",
      "Lepra lombardica",
      "Mailänder Aussatz",
      "Maiskrankheit",
      "Mangel an Pellagraschutzstoff",
      "Niazin-Mangel",
      "Niazinamid-Mangel",
      "Nikotinsäure-Mangel",
      "Nikotinsäureamid-Mangel",
      "PP-Faktor-Mangel",
      "Pellagra",
      "Pellagra bei Vitamin-B-Mangel",
      "Pellagra-Syndrom",
      "Tryptophanmangel"
    ]
  },
  {
    "code": "E53.0",
    "name": "Avitaminose B2",
    "synonyms": [
      "Alactoflavinose [Vitamin-B2-Mangel-Syndrom]",
      "Ariboflavinose",
      "Ariboflavinose-Syndrom",
      "Avitaminose B2",
      "Riboflavinmangel",
      "Riboflavinmangel-Syndrom",
      "Vitamin-B2-Mangel"
    ]
  },
  {
    "code": "E53.1",
    "name": "Vitamin-B6-Mangel",
    "synonyms": [
      "Mangel an Pyridoxin-Derivaten",
      "Pyridoxalmangel",
      "Pyridoxaminmangel",
      "Pyridoxinmangel",
      "Vitamin-B6-Mangel",
      "Vitamin-B6-Mangel-Syndrom"
    ]
  },
  {
    "code": "E53.8",
    "name": "Biotinmangel",
    "synonyms": [
      "Biotinidase-Mangel",
      "Biotinmangel",
      "Cobalaminmangel",
      "Folatmangel",
      "Folsäuremangel",
      "Kongenitale Folat-Malabsorption",
      "Multipler Carboxylase-Mangel",
      "Pantothensäuremangel",
      "Protein-R-Mangel",
      "Vitamin-B12-Mangel",
      "Vitamin-B12-Resorptionsstörung",
      "Vitamin-H-Mangel",
      "Zyanokobalaminmangel"
    ]
  },
  {
    "code": "E53.9",
    "name": "Vitamin-B-Mangel",
    "synonyms": [
      "Avitaminose B",
      "Burning-feet-Syndrom",
      "Hypovitaminose B",
      "Vitamin-B-Mangel"
    ]
  },
  {
    "code": "E54",
    "name": "Ascorbinsäuremangel",
    "synonyms": [
      "Ascorbinsäuremangel",
      "Avitaminose C",
      "Cheadle-Krankheit",
      "Hypovitaminose C",
      "Infantiler Skorbut",
      "Möller-Barlow-Krankheit",
      "Skorbut",
      "Vitamin-C-Mangel"
    ]
  },
  {
    "code": "E55.0",
    "name": "Floride Rachitis",
    "synonyms": [
      "Adoleszenten-Rachitis",
      "Aktive Rachitis",
      "Akute Rachitis",
      "Englische Krankheit",
      "Ergosterolmangel bei Rachitis",
      "Floride Rachitis",
      "Glisson-Krankheit",
      "Infantile Osteomalazie",
      "Infantile Rachitis",
      "Intestinale Rachitis",
      "Juvenile Osteomalazie",
      "Kalziferolmangel mit Rachitis",
      "Knochenmalazie beim Jugendlichen",
      "Kongenitale Rachitis",
      "Osteomalazie im Jugendalter",
      "Osteomalazie im Kindesalter",
      "Rachitis",
      "Rachitis bei Vitamin-D-Mangel",
      "Rachitis der Brustwand"
    ]
  },
  {
    "code": "E55.9",
    "name": "Ergosterolmangel",
    "synonyms": [
      "Avitaminose D",
      "Calciferolmangel",
      "Ergosterinmangel",
      "Ergosterolmangel",
      "Hypovitaminose D",
      "Provitamin-D-Mangel",
      "Vitamin-D-Mangel",
      "Vitamin-D2-Mangel"
    ]
  },
  {
    "code": "E56.0",
    "name": "Vitamin-E-Mangel",
    "synonyms": [
      "Tokopherolmangel",
      "Vitamin-E-Mangel"
    ]
  },
  {
    "code": "E56.1",
    "name": "Vitamin-K-Mangel",
    "synonyms": [
      "Avitaminose K",
      "Hypovitaminose K",
      "Vitamin-K-Mangel"
    ]
  },
  {
    "code": "E56.9",
    "name": "Vitaminmangel",
    "synonyms": [
      "Avitaminose",
      "Hypovitaminose",
      "Multiple Avitaminosen a.n.k.",
      "Multipler Vitaminmangel",
      "Vitaminabsorptionsstörung",
      "Vitaminmangel",
      "Vitaminmangel-Syndrom"
    ]
  },
  {
    "code": "E58",
    "name": "Alimentärer Kalziummangel",
    "synonyms": [
      "Alimentärer Kalziummangel",
      "Chronischer Kalkmangel",
      "Diätetische Hypokalzämie",
      "Kalziumabsorptionsstörung",
      "Kalziummangel"
    ]
  },
  {
    "code": "E59",
    "name": "Alimentärer Selenmangel",
    "synonyms": [
      "Alimentärer Selenmangel",
      "Keshan-Krankheit",
      "Selenmangel"
    ]
  },
  {
    "code": "E60",
    "name": "Alimentärer Zinkmangel",
    "synonyms": [
      "Alimentärer Zinkmangel",
      "Zinkmangel"
    ]
  },
  {
    "code": "E61.0",
    "name": "Kupfermangel",
    "synonyms": [
      "Ernährungsbedingter Kupfermangel",
      "Kupfermangel"
    ]
  },
  {
    "code": "E61.1",
    "name": "Eisenmangel",
    "synonyms": [
      "Eisenmangel",
      "Sideropenie"
    ]
  },
  {
    "code": "E61.2",
    "name": "Magnesiummangel",
    "synonyms": [
      "Alimentärer Magnesiummangel",
      "Magnesiummangel"
    ]
  },
  {
    "code": "E61.3",
    "name": "Manganmangel",
    "synonyms": [
      "Manganmangel"
    ]
  },
  {
    "code": "E61.4",
    "name": "Chrommangel",
    "synonyms": [
      "Chrommangel"
    ]
  },
  {
    "code": "E61.5",
    "name": "Molybdänmangel",
    "synonyms": [
      "Alimentärer Molybdänmangel",
      "Molybdänmangel"
    ]
  },
  {
    "code": "E61.6",
    "name": "Vanadiummangel",
    "synonyms": [
      "Vanadiummangel"
    ]
  },
  {
    "code": "E61.7",
    "name": "Mangel mehrerer Nahrungsbestandteile",
    "synonyms": [
      "Mangel mehrerer Nahrungsbestandteile"
    ]
  },
  {
    "code": "E61.8",
    "name": "Fluormangel",
    "synonyms": [
      "Fluormangel",
      "Jodmangel",
      "Mineralstoffmangel a.n.k."
    ]
  },
  {
    "code": "E61.9",
    "name": "Spurenelementmangel",
    "synonyms": [
      "Mangel an Nahrungsbestandteilen",
      "Spurenelementmangel"
    ]
  },
  {
    "code": "E63.0",
    "name": "Mangel an essentiellen Fettsäuren",
    "synonyms": [
      "Mangel an essentiellen Fettsäuren"
    ]
  },
  {
    "code": "E63.1",
    "name": "Alimentärer Mangelzustand durch unausgewogene Nahrungszusammensetzung",
    "synonyms": [
      "Alimentärer Mangelzustand durch unausgewogene Nahrungszusammensetzung",
      "Gestörtes Gleichgewicht im Nahrungszusammenhang"
    ]
  },
  {
    "code": "E63.8",
    "name": "Inositmangel",
    "synonyms": [
      "Carnitinmangel",
      "Cholinmangel",
      "Inositmangel"
    ]
  },
  {
    "code": "E63.9",
    "name": "Diätfehler",
    "synonyms": [
      "Alimentäre Störung",
      "Alimentärer Mangel",
      "Diätetische Insuffizienz",
      "Diätfehler",
      "Ernährungsmangelkrankheit",
      "Ernährungsstörung",
      "Inadäquate Ernährung, die eine Mangelernährung verursacht",
      "Mangelkrankheit",
      "Unausgewogene Nahrungszusammensetzung"
    ]
  },
  {
    "code": "E64.0",
    "name": "Folgen der Energie- und Eiweißmangelernährung",
    "synonyms": [
      "Folgen der Energie- und Eiweißmangelernährung"
    ]
  },
  {
    "code": "E64.1",
    "name": "Folgen eines Vitamin-A-Mangels",
    "synonyms": [
      "Folgen eines Vitamin-A-Mangels"
    ]
  },
  {
    "code": "E64.2",
    "name": "Folgen eines Vitamin-C-Mangels",
    "synonyms": [
      "Folgen eines Vitamin-C-Mangels"
    ]
  },
  {
    "code": "E64.3",
    "name": "Folgen einer Rachitis",
    "synonyms": [
      "Alte rachitische Deformität",
      "Beckendeformität als Spätfolge nach Rachitis",
      "Brustkorbdeformität als Spätfolge nach Rachitis",
      "Brustwanddeformität als Spätfolge nach Rachitis",
      "Coxa valga als Spätfolge nach Rachitis",
      "Coxa vara als Spätfolge nach Rachitis",
      "Cubitus valgus als Spätfolge nach Rachitis",
      "Cubitus varus als Spätfolge nach Rachitis",
      "Folgen einer Rachitis",
      "Genu extrorsum als Spätfolge nach Rachitis",
      "Genu recurvatum als Spätfolge nach Rachitis",
      "Genu valgum als Spätfolge nach Rachitis",
      "Genu varum als Spätfolge nach Rachitis",
      "Hallux rigidus als Spätfolge nach Rachitis",
      "Hammerfinger als Spätfolge nach Rachitis",
      "Hammerzehe als Spätfolge nach Rachitis",
      "Inaktive Rachitis",
      "Kyphoskoliose als Spätfolge nach Rachitis",
      "Lordose als Spätfolge nach Rachitis",
      "Rachitische Fußabflachung",
      "Rachitische Kielbrust",
      "Rachitische Kraniotabes",
      "Rachitische O-Beinstellung",
      "Rachitische Skoliose als Spätfolge",
      "Rachitische Wirbelsäulendeformität",
      "Rachitische Wirbelsäulendeformität als Spätfolge",
      "Rachitischer Pes planus",
      "Rachitisches Becken als Spätfolge",
      "Rachitisches Genu",
      "Spätfolge einer Rachitis",
      "Thoraxdeformität als Spätfolge nach Rachitis",
      "Thoraxwanddeformität als Spätfolge nach Rachitis",
      "Trichterbrust als Spätfolge nach Rachitis",
      "Wirbelsäulenverkrümmung als Spätfolge nach Rachitis"
    ]
  },
  {
    "code": "E64.8",
    "name": "Folgen von Kalziummangel",
    "synonyms": [
      "Folgen eines Vitamin-B-Mangels",
      "Folgen von Kalziummangel",
      "Folgen von Niazinmangel",
      "Folgen von Selenmangel",
      "Folgen von Thiaminmangel",
      "Folgen von Vitaminmangel a.n.k."
    ]
  },
  {
    "code": "E64.9",
    "name": "Folgen eines alimentären Mangelzustands",
    "synonyms": [
      "Folgen eines alimentären Mangelzustands"
    ]
  },
  {
    "code": "E65",
    "name": "Fettpolster",
    "synonyms": [
      "Bauchdeckenfettschürze",
      "Dorsozervikale Fettablagerung",
      "Fettpolster",
      "Fettschürze",
      "Intraabdominale Fettablagerung",
      "Lokalisierte Adipositas",
      "Lokalisierte Fettpolster",
      "Lokalisierte übermäßige Fettablagerung",
      "Panniculus adiposus",
      "Panniculus adiposus abdominalis",
      "Reithosenadipositas",
      "Umschriebene Fettpolster",
      "Viszerale Fettablagerung"
    ]
  },
  {
    "code": "E66.00",
    "name": "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 30 bis unter 35",
    "synonyms": [
      "Adipositas Grad I (WHO) durch übermäßige Kalorienzufuhr",
      "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 30 bis unter 35"
    ]
  },
  {
    "code": "E66.01",
    "name": "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 35 bis unter 40",
    "synonyms": [
      "Adipositas Grad II (WHO) durch übermäßige Kalorienzufuhr",
      "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 35 bis unter 40"
    ]
  },
  {
    "code": "E66.04",
    "name": "Adipositas durch übermäßige Kalorienzufuhr bei Kindern und Jugendlichen",
    "synonyms": [
      "Adipositas durch übermäßige Kalorienzufuhr bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.05",
    "name": "Extreme Adipositas durch übermäßige Kalorienzufuhr bei Kindern und Jugendlichen",
    "synonyms": [
      "Extreme Adipositas durch übermäßige Kalorienzufuhr bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.06",
    "name": "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 40 bis unter 50",
    "synonyms": [
      "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 40 bis unter 50"
    ]
  },
  {
    "code": "E66.07",
    "name": "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 50 bis unter 60",
    "synonyms": [
      "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 50 bis unter 60"
    ]
  },
  {
    "code": "E66.08",
    "name": "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 60 und mehr",
    "synonyms": [
      "Adipositas durch übermäßige Kalorienzufuhr mit einem Body-Mass-Index [BMI] von 60 und mehr"
    ]
  },
  {
    "code": "E66.09",
    "name": "Adipositas durch übermäßige Kalorienzufuhr",
    "synonyms": [
      "Adipositas Grad III (WHO) durch übermäßige Kalorienzufuhr",
      "Adipositas durch übermäßige Kalorienzufuhr",
      "Alimentäre Adipositas",
      "Alimentäre Fettsucht",
      "Exogene Fettsucht",
      "Fettsucht durch erhöhte Nahrungsaufnahme",
      "Fettsucht durch Überernährung"
    ]
  },
  {
    "code": "E66.10",
    "name": "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 30 bis unter 35",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas Grad I (WHO)",
      "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 30 bis unter 35"
    ]
  },
  {
    "code": "E66.11",
    "name": "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 35 bis unter 40",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas Grad II (WHO)",
      "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 35 bis unter 40"
    ]
  },
  {
    "code": "E66.14",
    "name": "Arzneimittelinduzierte Adipositas bei Kindern und Jugendlichen",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.15",
    "name": "Arzneimittelinduzierte extreme Adipositas bei Kindern und Jugendlichen",
    "synonyms": [
      "Arzneimittelinduzierte extreme Adipositas bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.16",
    "name": "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 40 bis unter 50",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 40 bis unter 50"
    ]
  },
  {
    "code": "E66.17",
    "name": "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 50 bis unter 60",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 50 bis unter 60"
    ]
  },
  {
    "code": "E66.18",
    "name": "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 60 und mehr",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas mit einem Body-Mass-Index [BMI] von 60 und mehr"
    ]
  },
  {
    "code": "E66.19",
    "name": "Arzneimittelinduzierte Adipositas",
    "synonyms": [
      "Arzneimittelinduzierte Adipositas",
      "Arzneimittelinduzierte Adipositas Grad III (WHO)",
      "Arzneimittelinduzierte Fettsucht"
    ]
  },
  {
    "code": "E66.20",
    "name": "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 30 bis unter 35",
    "synonyms": [
      "Adipositas Grad I (WHO) mit alveolärer Hypoventilation",
      "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 30 bis unter 35"
    ]
  },
  {
    "code": "E66.21",
    "name": "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 35 bis unter 40",
    "synonyms": [
      "Adipositas Grad II (WHO) mit alveolärer Hypoventilation",
      "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 35 bis unter 40"
    ]
  },
  {
    "code": "E66.24",
    "name": "Adipositas mit alveolärer Hypoventilation bei Kindern und Jugendlichen",
    "synonyms": [
      "Adipositas mit alveolärer Hypoventilation bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.25",
    "name": "Extreme Adipositas mit alveolärer Hypoventilation bei Kindern und Jugendlichen",
    "synonyms": [
      "Extreme Adipositas mit alveolärer Hypoventilation bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.26",
    "name": "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 40 bis unter 50",
    "synonyms": [
      "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 40 bis unter 50"
    ]
  },
  {
    "code": "E66.27",
    "name": "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 50 bis unter 60",
    "synonyms": [
      "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 50 bis unter 60"
    ]
  },
  {
    "code": "E66.28",
    "name": "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 60 und mehr",
    "synonyms": [
      "Adipositas mit alveolärer Hypoventilation mit einem Body-Mass-Index [BMI] von 60 und mehr"
    ]
  },
  {
    "code": "E66.29",
    "name": "Adipositas mit alveolärer Hypoventilation",
    "synonyms": [
      "Adipositas Grad III (WHO) mit alveolärer Hypoventilation",
      "Adipositas mit alveolärer Hypoventilation",
      "Kardiopulmonales Syndrom bei Adipositas",
      "Obesitas-Hypoventilationssyndrom [OHS]",
      "Pickwick-Syndrom",
      "Pickwick-Syndrom bei Kindern und Jugendlichen",
      "Syndrom der alveolären Hypoventilation",
      "Übermäßige Fettsucht mit alveolärer Hypoventilation"
    ]
  },
  {
    "code": "E66.80",
    "name": "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 30 bis unter 35",
    "synonyms": [
      "Krankhafte Adipositas Grad I (WHO)",
      "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 30 bis unter 35"
    ]
  },
  {
    "code": "E66.81",
    "name": "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 35 bis unter 40",
    "synonyms": [
      "Krankhafte Adipositas Grad II (WHO)",
      "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 35 bis unter 40"
    ]
  },
  {
    "code": "E66.84",
    "name": "Krankhafte Adipositas bei Kindern und Jugendlichen",
    "synonyms": [
      "Krankhafte Adipositas bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.85",
    "name": "Krankhafte extreme Adipositas bei Kindern und Jugendlichen",
    "synonyms": [
      "Krankhafte extreme Adipositas bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.86",
    "name": "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 40 bis unter 50",
    "synonyms": [
      "Adipositas permagna mit einem Body-Mass-Index [BMI] von 40 bis unter 50",
      "Extreme Adipositas mit einem Body-Mass-Index [BMI] von 40 bis unter 50",
      "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 40 bis unter 50"
    ]
  },
  {
    "code": "E66.87",
    "name": "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 50 bis unter 60",
    "synonyms": [
      "Adipositas permagna mit einem Body-Mass-Index [BMI] von 50 bis unter 60",
      "Extreme Adipositas mit einem Body-Mass-Index [BMI] von 50 bis unter 60",
      "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 50 bis unter 60"
    ]
  },
  {
    "code": "E66.88",
    "name": "Adipositas gigantea",
    "synonyms": [
      "Adipositas gigantea",
      "Adipositas permagna mit einem Body-Mass-Index [BMI] von 60 und mehr",
      "Extreme Adipositas mit einem Body-Mass-Index [BMI] von 60 und mehr",
      "Krankhafte Adipositas mit einem Body-Mass-Index [BMI] von 60 und mehr"
    ]
  },
  {
    "code": "E66.89",
    "name": "Nichtendokrine Fettsucht",
    "synonyms": [
      "Adipositas durch CEP19-Mangel",
      "Adipositas durch Leptinrezeptorgen-Mutationen",
      "Adipositas durch Melanokortin-4-Rezeptor-Mangel",
      "Adipositas durch Prohormon-Konvertase-1-Mangel",
      "Adipositas durch Proopiomelanocortin-Mangel",
      "Adipositas durch SIM1-Mangel",
      "Adipositas durch angeborene Leptin-Resistenz",
      "Adipositas durch angeborenen Leptinmangel",
      "Adipositas permagna",
      "Adrenale Fettsucht",
      "Endogene Fettsucht",
      "Endokrine Fettsucht",
      "Extreme Adipositas",
      "Familiäre Fettsucht",
      "Glanduläre Fettsucht",
      "Konstitutionelle Fettsucht",
      "Krankhafte Adipositas",
      "Krankhafte Adipositas Grad III (WHO)",
      "Krankhafte Fettsucht",
      "Nichtendokrine Adipositas",
      "Nichtendokrine Fettsucht",
      "Syndrom der früh beginnenden Adipositas mit Hyperphagie und schwerer Entwicklungsverzögerung"
    ]
  },
  {
    "code": "E66.90",
    "name": "Adipositas mit Body-Mass-Index [BMI] von 30 bis unter 35",
    "synonyms": [
      "Adipositas Grad I (WHO)",
      "Adipositas mit Body-Mass-Index [BMI] von 30 bis unter 35"
    ]
  },
  {
    "code": "E66.91",
    "name": "Adipositas mit Body-Mass-Index [BMI] von 35 bis unter 40",
    "synonyms": [
      "Adipositas Grad II (WHO)",
      "Adipositas mit Body-Mass-Index [BMI] von 35 bis unter 40"
    ]
  },
  {
    "code": "E66.94",
    "name": "Adipositas bei Kindern und Jugendlichen",
    "synonyms": [
      "Adipositas bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.95",
    "name": "Extreme Adipositas bei Kindern und Jugendlichen",
    "synonyms": [
      "Extreme Adipositas bei Kindern und Jugendlichen"
    ]
  },
  {
    "code": "E66.96",
    "name": "Adipositas mit Body-Mass-Index [BMI] von 40 bis unter 50",
    "synonyms": [
      "Adipositas mit Body-Mass-Index [BMI] von 40 bis unter 50"
    ]
  },
  {
    "code": "E66.97",
    "name": "Adipositas mit Body-Mass-Index [BMI] von 50 bis unter 60",
    "synonyms": [
      "Adipositas mit Body-Mass-Index [BMI] von 50 bis unter 60"
    ]
  },
  {
    "code": "E66.98",
    "name": "Adipositas mit Body-Mass-Index [BMI] von 60 und mehr",
    "synonyms": [
      "Adipositas mit Body-Mass-Index [BMI] von 60 und mehr"
    ]
  },
  {
    "code": "E66.99",
    "name": "Stammadipositas",
    "synonyms": [
      "Adipositas",
      "Adipositas Grad III (WHO)",
      "Einfache Adipositas",
      "Einfache Obesitas",
      "Fettleibigkeit",
      "Fettsucht",
      "Hypersteatose",
      "Korpulenz",
      "Obesitas",
      "Stammadipositas",
      "Stammfettsucht",
      "Übergewicht",
      "Übermäßige Fettablagerung",
      "Übermäßiges Fett"
    ]
  },
  {
    "code": "E67.0",
    "name": "Hypervitaminose A",
    "synonyms": [
      "Hyperalimentation mit Vitamin A",
      "Hypervitaminose A",
      "Hypervitaminose-A-Syndrom",
      "Übermäßige Zufuhr von Vitamin A"
    ]
  },
  {
    "code": "E67.1",
    "name": "Hyperkarotinämie",
    "synonyms": [
      "Aurantiasis cutis",
      "Ernährungsbedingte Hyperkarotinämie",
      "Hyperalimentation mit Karotin",
      "Hyperkarotinämie",
      "Karotinämie",
      "Karotinämie diätetischen Ursprungs",
      "Übermäßige Karotinzufuhr"
    ]
  },
  {
    "code": "E67.2",
    "name": "Megavitamin-B6-Syndrom",
    "synonyms": [
      "Hypervitaminose B6",
      "Megavitamin-B6-Syndrom"
    ]
  },
  {
    "code": "E67.3",
    "name": "Hypervitaminose D",
    "synonyms": [
      "Hyperalimentation mit Vitamin D",
      "Hypervitaminose D",
      "Vitamin-D-Hypervitaminose",
      "Vitamin-D-Intoxikation",
      "Vitamin-D-Vergiftung",
      "Übermäßige Zufuhr von Vitamin D"
    ]
  },
  {
    "code": "E67.8",
    "name": "Hypervitaminose",
    "synonyms": [
      "Diätetische Hypervitaminose",
      "Hypervitaminose",
      "Hypervitaminose durch übermäßigen Gebrauch von Vitaminpräparaten",
      "Vitamin-E-Hypervitaminose",
      "Vitamin-K-Hypervitaminose",
      "Übermäßige Zufuhr von Spurenelementen a.n.k."
    ]
  },
  {
    "code": "E68",
    "name": "Folgen einer Überernährung",
    "synonyms": [
      "Adipositasbeschwerden",
      "Folgen einer Überernährung"
    ]
  },
  {
    "code": "E70.0",
    "name": "Klassische Phenylketonurie",
    "synonyms": [
      "Fölling-Krankheit",
      "Fölling-Syndrom",
      "Klassische PKU [Phenylketonurie]",
      "Klassische Phenylketonurie",
      "Oligophrenia phenylpyruvica"
    ]
  },
  {
    "code": "E70.1",
    "name": "Phenylketonurie",
    "synonyms": [
      "DHPR [Dihydropteridinreduktase]-Mangel",
      "Dihydropteridinreduktase-Mangel",
      "GTP-Cyclohydrolase I-Mangel",
      "GTPCH [GTP-Cyclohydrolase I]-Mangel",
      "Hyperphenylalalinanämie durch 6-Pyruvoyl-Tetrahydropterin-Synthase-Mangel",
      "Hyperphenylalaninämie a.n.k.",
      "Hyperphenylalaninämie durch DNAJC12-Mangel",
      "Hyperphenylalaninämie durch Dihydropteridinreduktase-Mangel",
      "Hyperphenylalaninämie durch Tetrahydrobiopterin-Mangel",
      "Maternale Hyperphenylalaninämie",
      "Maternale PKU [Phenylketonurie]",
      "Maternale Phenylketonurie",
      "Milde HPA [Hyperphenylalaninämie]",
      "Milde Hyperphenylalaninämie",
      "Milde PKU [Phenylketonurie]",
      "Milde Phenylketonurie",
      "PKU [Phenylketonurie]",
      "Phenylalanin-Embryopathie",
      "Phenylalanin-Hydroxylase-Mangel",
      "Phenylketonurie",
      "Phenylketonurie Typ 2",
      "Phenylketonurie der Mutter",
      "Pterin-4-alpha-Carbinolamin-Dehydratase-Mangel"
    ]
  },
  {
    "code": "E70.2",
    "name": "Tyrosinämie",
    "synonyms": [
      "4-HPPD [4-alpha-Hydroxyphenylpyruvat-Dioxygenase]-Mangel",
      "4-alpha-Hydroxyphenylpyruvat-Dioxygenase-Mangel",
      "4-alpha-Hydroxyphenylpyruvat-Hydroxylase-Mangel",
      "Alkaptonurie",
      "Alkaptonurie-Syndrom",
      "Endogene Ochronose",
      "Fumarylacetoacetase-Mangel",
      "Hawkinsinurie",
      "Hepatorenale Tyrosinämie",
      "Hereditäre Ochronose",
      "Homogentisinsäure-Oxigenase-Mangel",
      "Hypertyrosinämie",
      "Ochronose",
      "Okulokutane Tyrosinämie",
      "Richner-Hanhart-Syndrom",
      "Störung des Tyrosinstoffwechsels",
      "Tyrosinose",
      "Tyrosinstoffwechselstörung",
      "Tyrosinurie",
      "Tyrosinämie",
      "Tyrosinämie Typ 1",
      "Tyrosinämie Typ 2",
      "Tyrosinämie Typ 3",
      "Tyrosinämie durch 4-Hydroxyphenylpyruvat-Dioxygenase-Mangel",
      "Tyrosinämie durch Tyrosintransaminase-Mangel"
    ]
  },
  {
    "code": "E70.3",
    "name": "Albinismus",
    "synonyms": [
      "Achromasie",
      "Achromie",
      "Albinismus",
      "Albinismussyndrom",
      "Albino",
      "Allgemeiner Albinismus",
      "Atypisches Chédiak-Higashi-Syndrom",
      "Chediak-Higashi-Krankheit",
      "Chediak-Higashi-Syndrom",
      "Chediak-Steinbrinck-Higashi-Anomalie",
      "Chediak-Steinbrinck-Higashi-Krankheit",
      "Chediak-Steinbrinck-Higashi-Syndrom",
      "Cross-McKusick-Breen-Syndrom",
      "Cross-Syndrom",
      "Gelber okulokutaner Albinismus",
      "Griscelli-Krankheit",
      "Griscelli-Syndrom",
      "Griscelli-Syndrom Typ 1",
      "Griscelli-Syndrom Typ 3",
      "HPS [Hermansky-Pudlak-Syndrom]",
      "Hermansky-Pudlak-Syndrom",
      "Hermansky-Pudlak-Syndrom Typ 1",
      "Hermansky-Pudlak-Syndrom Typ 2",
      "Hermansky-Pudlak-Syndrom Typ 4",
      "Hermansky-Pudlak-Syndrom Typ 7",
      "Hermansky-Pudlak-Syndrom Typ 8",
      "Hermansky-Pudlak-Syndrom Typ 9",
      "Hermansky-Pudlak-Syndrom durch AP3-Defizienz",
      "Hermansky-Pudlak-Syndrom durch BLOC-1-Defizienz",
      "Hermansky-Pudlak-Syndrom durch BLOC-2-Defizienz",
      "Hermansky-Pudlak-Syndrom durch BLOC-3-Defizienz",
      "Hermansky-Pudlak-Syndrom mit Lungenfibrose",
      "Isolierter Albinismus",
      "Klein-Waardenburg-Syndrom",
      "Kutaner Albinismus",
      "Kutaner Albinismus vom Hermelin-Phänotyp",
      "Leukopathia universalis",
      "Minimal-pigmentierter okulokutaner Albinismus Typ 1",
      "Neuroektodermale melanolysosomale Krankheit",
      "OA [Okulärer Albinismus]-Typ 1",
      "OCA [Okulokutaner Albinismus]",
      "OCA [Okulokutaner Albinismus]-Typ 1A",
      "OCA [Okulokutaner Albinismus]-Typ 1B",
      "OCA [Okulokutaner Albinismus]-Typ 2",
      "OCA [Okulokutaner Albinismus]-Typ 3",
      "OCA [Okulokutaner Albinismus]-Typ 4",
      "OCA [Okulokutaner Albinismus]-Typ 8",
      "Okulokutaner Albinismus",
      "Okulokutaner Albinismus Typ 1",
      "Okulokutaner Albinismus Typ 1A",
      "Okulokutaner Albinismus Typ 1B",
      "Okulokutaner Albinismus Typ 2",
      "Okulokutaner Albinismus Typ 3",
      "Okulokutaner Albinismus Typ 4",
      "Okulokutaner Albinismus Typ 5",
      "Okulokutaner Albinismus Typ 6",
      "Okulokutaner Albinismus Typ 7",
      "Okulokutaner Albinismus Typ 8",
      "Okulokutaner Albinismus vom Amisch Typ",
      "Okulozerebrales Hypopigmentierungs-Syndrom Typ Preus",
      "Okulärer Albinismus",
      "Okulärer Albinismus Typ 1",
      "Okulärer Albinismus mit kongenitaler sensorineuraler Schwerhörigkeit",
      "Okulärer Albinismus mit spät einsetzender sensorineuraler Schwerhörigkeit",
      "Okulärer Albinismus vom Nettleship-Falls-Typ",
      "Partieller Albinismus",
      "Piebaldismus",
      "Rezessiver X-chromosomaler okulärer Albinismus",
      "Roter okulokutaner Albinismus",
      "Temperatur-sensitiver okulokutaner Albinismus",
      "Temperatursensitiver okulokutaner Albinismus Typ 1",
      "Tietz-Syndrom",
      "Tyrosinase-negativer okulokutaner Albinismus",
      "Tyrosinase-positiver okulokutaner Albinismus",
      "WS [Waardenburg-Syndrom] Typ 3",
      "Waardenburg-Syndrom",
      "Waardenburg-Syndrom Typ 1",
      "Waardenburg-Syndrom Typ 2",
      "Waardenburg-Syndrom Typ 3",
      "Waardenburg-Syndrom mit Extremitätenanomalien",
      "Weißsucht",
      "Xanthöser okulokutaner Albinismus"
    ]
  },
  {
    "code": "E70.8",
    "name": "Tryptophanstoffwechselstörung",
    "synonyms": [
      "Blue-diaper-Syndrom",
      "Drummond-Syndrom",
      "Enzephalopathie durch Urocanase-Mangel",
      "FTCD [Formimidoyltransferase-Cyclodeaminase]-Mangel",
      "Familiäre Hyperkalzämie mit Nephrokalzinose und Indikanurie",
      "Familiäre Hypertryptophanämie",
      "Formimidoyltransferase-Cyclodeaminase-Mangel",
      "Formiminoglutaminsäure-Krankheit",
      "Glutamat-Formiminotransferase-Mangel",
      "Histidase-Mangel",
      "Histidin-Ammoniak-Lyase-Mangel",
      "Histidinstoffwechselstörung",
      "Histidinurie",
      "Histidinämie",
      "Histidinämiesyndrom",
      "Hydroxykynureninurie",
      "Hyperhistidinämie",
      "Imidazol-Syndrom",
      "Kynureninase-Mangel",
      "Monoaminoxidase-A-Mangel",
      "Syndrom der blauen Windeln",
      "Tryptophanstoffwechselstörung",
      "Xanthurenazidurie",
      "Xanthurensäureurie"
    ]
  },
  {
    "code": "E70.9",
    "name": "Stoffwechselstörung aromatischer Aminosäuren",
    "synonyms": [
      "Stoffwechselstörung aromatischer Aminosäuren"
    ]
  },
  {
    "code": "E71.0",
    "name": "Ahornsirup-Harn-Krankheit",
    "synonyms": [
      "Ahornsirup-Harn-Krankheit",
      "Ahornsirup-Harn-Syndrom",
      "Ahornsirup-Krankheit",
      "Alpha-Ketosäuredecarboxylase-Mangel",
      "Dekarboxylasemangel",
      "Intermediäre Form der Ahornsirup-Krankheit",
      "Intermittierende Form der Ahornsirup-Krankheit",
      "Leuzinose",
      "MSUD [Maple syrup urine disease]",
      "Menkes-I-Krankheit [Ahornsirup-Krankheit]",
      "Menkes-I-Syndrom [Ahornsirup-Syndrom]",
      "Thiamin-responsive Form der Ahornsirup-Krankheit",
      "Verzweigtketten-Ketosäuredecarboxylase-Mangel",
      "Verzweigtkettenketoazidurie"
    ]
  },
  {
    "code": "E71.1",
    "name": "Abbaustörung von verzweigtkettigen Aminosäuren",
    "synonyms": [
      "2-Methylbutyrazidurie",
      "2-Methylbutyryl-CoA-Dehydrogenase-Mangel",
      "3-Hydroxy-3-Methylglutarazidurie",
      "3-Hydroxyisobutyracidurie",
      "3-Ketothiolase-Mangel",
      "3-Methylcrotonylglyzinurie",
      "3-Methylglutaconazidurie Typ 1",
      "3-Methylglutaconazidurie Typ 2",
      "3-Methylglutaconazidurie Typ 3",
      "3-Methylglutaconazidurie Typ 4",
      "3-Methylglutaconazidurie Typ 7",
      "3-Methylglutaconazidurie Typ 8",
      "3-Methylglutaconazidurie Typ 9",
      "3-Methylglutaconyl-CoA-Hydratase-Mangel",
      "3-Oxo-Thiolase-Mangel",
      "Abbaustörung von verzweigtkettigen Aminosäuren",
      "Alpha-Methyl-Acetessigsäure-Azidurie",
      "Alpha-Methyl-Acetoacetyl-CoA-Thiolase-Mangel",
      "Autismus-Epilepsie-Syndrom durch Mangel an verzweigtkettiger Ketosäure-Dehydrogenase-Kinase",
      "Autosomal-rezessive Optikusatrophie Typ 3",
      "BTHS [Barth-Syndrom]",
      "Barth-Syndrom",
      "Beta-Ketothiolase-Mangel",
      "Cochrane-Syndrom",
      "Costeff-Syndrom",
      "Entwicklungsverzögerung durch 2-Methylbutyryl-CoA-Dehydrogenase-Mangel",
      "Entwicklungsverzögerung durch Methylmalonat-Semialdehyd-Dehydrogenase-Mangel",
      "Hydroxymethylglutarazidurie",
      "Hyperleuzin-Isoleuzinämie",
      "Hypervalinämie",
      "Infantile Optikusatrophie mit Chorea und spastischer Paraplegie",
      "Isobutyrazidurie",
      "Isobutyryl-CoA-Dehydrogenase-Mangel",
      "Isoleuzin-Abbaustörung",
      "Isoleuzin-Stoffwechselstörung",
      "Isoleuzinose",
      "Isolierter 3-Methylcrotonyl-CoA-Carboxylase-Mangel",
      "Isovalerianazidämie",
      "Isovaleryl-CoA-Dehydrogenase-Mangel",
      "Kardioskelettale Myopathie mit Neutropenie",
      "Kardioskelettale Myopathie mit Neutropenie und Mitochondriopathie",
      "Ketotische Glyzinämie",
      "Kompletter Methylmalonyl-CoA-Mutase-Mangel",
      "Leuzin-Abbaustörung",
      "Leuzin-Stoffwechselstörung",
      "Leuzinbedingte Hypoglykämie",
      "MCC [3-Methylcrotonyl-CoA-Carboxylase]-Mangel",
      "Mangel an 3-Hydroxy-3-Methylglutaryl-CoA-Lyase",
      "Metabolischer Valin-Defekt",
      "Methylmalonazidurie durch Transcobalamin-Rezeptor-Defekt",
      "Methylmalonazidämie",
      "Methylmalonazidämie durch Methylmalonyl-CoA-Epimerase-Mangel",
      "Mitochondrialer Acetoacetyl-Coenzym A-Thiolase-Mangel",
      "Neurodegeneration durch 3-Hydroxyisobutyryl-CoA-Hydrolase-Mangel",
      "Optikusatrophie-Syndrom Typ Costeff",
      "Partieller Methylmalonyl-CoA-Mutase-Mangel",
      "Propionatämie",
      "Propionazidurie",
      "Propionazidämie",
      "Propionyl-CoA-Carboxylase-Mangel",
      "Valin-Abbaustörung",
      "Valinstoffwechselstörung",
      "Vitamin B12-abhängige Methylmalonazidurie",
      "Vitamin B12-abhängige Methylmalonazidurie Typ CblA",
      "Vitamin B12-resistente Methylmalonazidämie",
      "Vitamin B12-sensible Methylmalonazidämie",
      "Vitamin B12-sensible Methylmalonazidämie Typ CblA",
      "Vitamin B12-unabhängige Methylmalonazidurie",
      "Vitamin-B12-abhängige Methylmalonazidurie Typ cblB",
      "Vitamin-B12-sensible Methylmalonazidämie Typ CblB",
      "X-chromosomale kardioskelettale Myopathie mit Neutropenie"
    ]
  },
  {
    "code": "E71.2",
    "name": "Stoffwechselstörung verzweigtkettiger Aminosäuren",
    "synonyms": [
      "Stoffwechselstörung verzweigtkettiger Aminosäuren",
      "Verzweigte Aminosäuren-Stoffwechselstörung"
    ]
  },
  {
    "code": "E71.3",
    "name": "Fettsäurestoffwechselstörung",
    "synonyms": [
      "Acyl-CoA-Dehydrogenase 9-Mangel",
      "Acyl-CoA-Oxydase-Mangel",
      "Addison-Schilder-Syndrom",
      "Adrenoleukodystrophie",
      "Adrenomyeloneuropathie",
      "CPT IA [Carnitin-Palmitoyltransferase IA]-Mangel",
      "CPT II [Carnitin-Palmitoyltransferase II]-Mangel",
      "Carnitin-Acylcarnitin-Translokase-Mangel",
      "Carnitin-Aufnahme-Mangel",
      "Carnitin-Palmitoyltransferase IA-Mangel",
      "Carnitin-Palmitoyltransferase II-Mangel",
      "Carnitin-Transporter-Mangel",
      "D-bifunktionales-Enzym-Mangel",
      "Defekt des mitochondrialen trifunktionalen Proteins",
      "Fettsäureoxidationsstörungen und Ketogenesedefekt",
      "Fettsäurestoffwechselstörung",
      "Glutarazidurie Typ 2",
      "Glutarazidämie Typ 2",
      "Hepatischer Carnitin-Palmitoyltransferase I-Mangel",
      "Hyperinsulinismus durch Mangel an kurzkettiger 3-Hydroxyacyl-CoA-Dehydrogenase",
      "Hyperinsulinismus durch SCHAD [Kurzkettige 3-Hydroxyacyl-CoA-Dehydrogenase]-Mangel",
      "Hyperinsulinämische Hypoglykämie durch Mangel an kurzkettiger 3-Hydroxyacyl-CoA-Dehydrogenase",
      "Ketokörper-Stoffwechselstörung",
      "LCHAD [Langkettige 3-Hydroxyacyl-CoA-Dehydrogenase]-Mangel",
      "MCAD [Mittelkettige Acyl-CoA-Dehydrogenase]-Mangel",
      "MTP [mitochondriales trifunktionales Protein]-Mangel",
      "Mangel an 3-Hydroxy-3-Methylglutaryl-CoA-Synthase",
      "Mangel an Succinyl-CoA-Acetoacetat-Transferase",
      "Mangel an Succinyl-CoA:3-Ketosäure-CoA-Transferase",
      "Mangel an Succinyl-CoA:3-Oxosäure-CoA-Transferase",
      "Mangel an kurzkettiger Acyl-CoA-Dehydrogenase",
      "Mangel an langkettiger 3-Hydroxyacyl-CoA-Dehydrogenase",
      "Mangel an langkettiger Acyl-CoA-Dehydrogenase",
      "Mangel an mittelkettiger Acyl-CoA-Dehydrogenase",
      "Mangel an peroxisomaler Acyl-CoA-Oxidase",
      "Mangel an sehr langkettiger Acyl-CoA-Dehydrogenase",
      "Mangel des Plasmamembranständigen Carnitin-Transporters",
      "Multipler Acyl-CoA-Dehydrogenase-Mangel",
      "Muskel-Carnitin-Palmitoyltransferase-Mangel",
      "NALD [Neonatale Adrenoleukodystrophie]",
      "Neonatale Adrenoleukodystrophie",
      "Neonatale Pseudoadrenoleukodystrophie",
      "Peroxisomale Acyl-CoA-Reduktase-1-Defizienz",
      "Peroxisomale beta-Oxidationsstörung",
      "Primärer systemischer Carnitinmangel",
      "Pseudo-NALD [Neonatale Adrenoleukodystrophie]",
      "Pseudoadrenoleukodystrophie",
      "SCAD [Kurzkettige Acyl-CoA-Dehydrogenase]-Mangel",
      "SCHAD [Kurzkettige 3-Hydroxyacyl-CoA-Dehydrogenase]-Mangel",
      "SCOT [Succinyl-CoA:3-Ketosäure-CoA-Transferase]-Mangel",
      "Schilder-Addison-Komplex",
      "Störung des Elektronentransportes durch Mangel an Flavoprotein",
      "Störung des Elektronentransportes durch Mangel an Flavoprotein-Ubiquinon-Oxidoreduktase",
      "VLCADD [Very long chain Acyl-CoA-dehydrogenase deficiency]",
      "X-ALD [X-chromosomale Adrenoleukodystrophie]",
      "X-chromosomale ALD [Adrenoleukodystrophie]",
      "X-chromosomale Adrenoleukodystrophie",
      "X-chromosomale zerebrale Adrenoleukodystrophie"
    ]
  },
  {
    "code": "E72.0",
    "name": "Aminosäuretransportstörung",
    "synonyms": [
      "Aminosäureaufnahme- und Transportstörung",
      "Aminosäuretransportstörung",
      "Cystinosis",
      "Cystinosis maligna",
      "Cystinurie mit Lysinurie",
      "De-Toni-Debré-Fanconi-Komplex",
      "De-Toni-Debré-Fanconi-Syndrom",
      "Dicarboxyl-Hyperaminoazidurie",
      "Gluko-Amino-Phosphat-Diabetes",
      "Glutamat-Aspartat-Transportdefekt",
      "Glyzinurie",
      "Hartnup-Krankheit",
      "Hartnup-Syndrom",
      "Hyperaminoazidurie durch Zystin",
      "Hyperdibasische Aminoazidurie Typ 1",
      "Hyperdibasische Aminoazidurie Typ 2",
      "Hypotonie-Zystinurie-Syndrom",
      "Iminoglycinurie",
      "LPI [Lysinurische Proteinintoleranz]",
      "Lignac-Syndrom",
      "Lowe-Syndrom",
      "Lowe-Syndrom mit Fanconi-Syndrom",
      "Lysinurische Proteinintoleranz",
      "Maligne Zystinose",
      "Mitochondrialer Aspartat-Glutamat-Carrier-1-Mangel",
      "OCRL [Okulo-zerebro-renales Syndrom]",
      "Okulo-zerebro-renales Syndrom",
      "Okulo-zerebro-renales Syndrom Lowe",
      "Primäres renotubuläres Fanconi-Syndrom",
      "Renale Glyzinurie",
      "Störungen des Aminosäuretransportes",
      "Zerebro-okulo-renale Dystrophie",
      "Zystinose",
      "Zystinurie",
      "Zystinurie Typ A",
      "Zystinurie Typ B",
      "Zystinurie-Syndrom"
    ]
  },
  {
    "code": "E72.1",
    "name": "Cystathioninuriesyndrom",
    "synonyms": [
      "3-Mercaptopyruvat-Sulfurtransferase-Mangel",
      "Cystathionase-Mangel",
      "Cystathionin-Gamma-Lyase-Mangel",
      "Cystathionin-beta-Synthase-Mangel",
      "Cystathioninstoffwechselstörung",
      "Cystathioninurie",
      "Cystathioninuriesyndrom",
      "Cystathioninämie",
      "Demyelinisierung des Gehirns durch Methionin-Adenosyltransferase-Mangel",
      "Enzephalopathie durch Sulfitoxidasemangel",
      "Funktioneller Methionin-Synthase-Mangel Typ Cbl G",
      "Funktioneller Methioninsynthase-Mangel",
      "Gamma-Cystathionase-Mangel",
      "Homocystinstoffwechselstörung",
      "Homocystinurie durch Cystathionin-beta-Synthase-Mangel",
      "Homocystinurie durch Methylen-Tetrahydrofolat-Reduktase-Mangel",
      "Homozystinurie",
      "Homozystinurie durch Defekt des Cobalamin-Cofaktor-Metabolismus",
      "Homozystinurie-Syndrom",
      "Homozystinämie",
      "Hyperhomocysteinämie",
      "Hyperhomocysteinämie durch MTHFR [Methylen-Tetrahydrofolat-Reduktase]-Mangel",
      "Hyperhomozysteinämie",
      "Hypermethioninämie",
      "Hypermethioninämie durch Adenosinkinase-Mangel",
      "Hypermethioninämie durch Glycin-N-Methyltransferase-Mangel",
      "Hypermethioninämie durch S-Adenosylhomocystein-Hydrolase-Mangel",
      "Isolierter Sulfitoxidasemangel",
      "Kombinierter Mangel von Sulfitoxidase, Xanthin-Dehydrogenase und Aldehyd-Oxidase, Typ A",
      "MTHFR [Methylen-Tetrahydrofolat-Reduktase]-Mangel",
      "Methionin-Adenosyltransferase-Mangel",
      "Methioninmalabsorptionssyndrom",
      "Methioninstoffwechselstörung",
      "Methioninämie",
      "Methylcobalamin-Mangel",
      "Methylcobalamin-Mangel Typ Cbl E",
      "Methylcobalamin-Mangel Typ Cbl G",
      "Methylen-Tetrahydrofolat-Reduktase-Mangel",
      "Oast-house-Syndrom",
      "Psychomotorische Retardierung durch S-Adenosylhomocystein-Hydrolase-Defizienz",
      "Smith-Strang-Syndrom",
      "Stoffwechselstörung schwefelhaltiger Aminosäuren",
      "Störung des zytosolischen Methylgruppentransfers",
      "Sulfitoxidase-Mangel durch Molybdän-Kofaktor-Mangel Typ B",
      "Sulfitoxidase-Mangel durch Molybdän-Kofaktor-Mangel Typ C",
      "Sulfitoxidasemangel",
      "Sulfitoxidasemangel durch Molybdän-Kofaktor-Mangel",
      "Sulfitoxidasemangel durch Molybdän-Kofaktor-Mangel Typ A",
      "Sulfocysteinurie",
      "Zystathioninurie",
      "Zystathioninuriesyndrom",
      "Zystathioninämie"
    ]
  },
  {
    "code": "E72.2",
    "name": "Arginin-Bernsteinsäure-Krankheit",
    "synonyms": [
      "Adulte Zitrullinämie Typ 1",
      "Akute neonatale Zitrullinämie Typ 1",
      "Ammoniakstoffwechselstörung",
      "Arginase-Mangel",
      "Arginin-Bernsteinsäure-Krankheit",
      "Arginin-Bernsteinsäure-Stoffwechselstörung",
      "Arginin-Bernsteinsäure-Syndrom",
      "Argininosuccinase-Mangel",
      "Argininosuccinat-Synthetase-Mangel",
      "Argininosuccino-Azidurie",
      "Argininosuccino-Azidämie",
      "Argininstoffwechselstörung",
      "Argininsuccinat-Lyase-Mangel",
      "Argininämie",
      "CPS1 [Carbamoyl-Phosphat-Synthetase 1]-Mangel",
      "Carbamoyl-Phosphat-Synthetase 1-Mangel",
      "Carbamylphosphat-Synthetase-Mangel",
      "Citrullinstoffwechselstörung",
      "Harnstoffzyklusdefekt und Störung der Ammoniak-Entgiftung",
      "Harnstoffzyklusstörung",
      "Hyperaminoazidurie durch Arginin",
      "Hyperammonämie",
      "Hyperammonämie durch N-Acetylglutamat-Synthetase-Mangel",
      "Hyperargininämie",
      "Kongenitale Hyperammonämie",
      "N-Acetylglutamatsynthetase-Mangel",
      "NAGS [N-Acetylglutamat-Synthetase]-Mangel",
      "Neonatale intrahepatische Cholestase durch Citrin-Mangel",
      "Zitrullinurie",
      "Zitrullinurie-Syndrom",
      "Zitrullinämie",
      "Zitrullinämie Typ 1",
      "Zitrullinämie Typ 1 mit spätem Beginn",
      "Zitrullinämie Typ 2"
    ]
  },
  {
    "code": "E72.3",
    "name": "Hyperlysinämie",
    "synonyms": [
      "Alpha-Aminoadipinazidurie",
      "Glutarazidurie",
      "Glutarazidurie Typ 1",
      "Glutarazidurie Typ 3",
      "Glutarazidämie Typ 1",
      "Glutaryl-CoA-Dehydrogenase-Mangel",
      "Glutaryl-CoA-Oxidase-Mangel",
      "Hydroxylysinstoffwechselstörung",
      "Hydroxylysinämie",
      "Hyperaminoazidurie durch Lysin",
      "Hyperlysinämie",
      "Hyperlysinämie Typ I",
      "Hyperlysinämie Typ II",
      "Krampfanfälle und Intelligenzminderung durch Hydroxylysinurie",
      "Lysin-alpha-Ketoglutarat-Reduktase-Mangel",
      "Lysinstoffwechselstörung",
      "Pipekolinämie",
      "Pipekolinämische Azidämie",
      "Saccharopin-Dehydrogenase-Mangel",
      "Saccharopinurie",
      "Störungen des Lysin- und Hydroxylysinstoffwechsels"
    ]
  },
  {
    "code": "E72.4",
    "name": "Ornithinstoffwechselstörung",
    "synonyms": [
      "HHH-Syndrom [Hyperornithinämie mit Hyperammonämie und Homozitrullinämie]",
      "Hyperaminoazidurie durch Ornithin",
      "Hyperornithinämie",
      "Hyperornithinämie mit Atrophia gyrata der Aderhaut und Netzhaut",
      "Hyperornithinämie mit Hyperammonämie und Homozitrullinämie",
      "OTC [Ornithin-Transcarbamylase]-Mangel",
      "Ornithin-Aminotransferase-Mangel",
      "Ornithin-Carbamoyltransferase-Mangel",
      "Ornithin-Transcarbamylase-Mangel",
      "Ornithinstoffwechselstörung",
      "Ornithinämie",
      "Ornithinämie Typ I",
      "Ornithinämie Typ II",
      "Störungen des Ornithinstoffwechsels",
      "Triple-H-Syndrom"
    ]
  },
  {
    "code": "E72.5",
    "name": "Glyzinstoffwechselstörung",
    "synonyms": [
      "Delta-1-Pyrrolin-5-Carboxylat-Dehydrogenase-Mangel",
      "Dimethylglycin-Dehydrogenase-Mangel",
      "Glukoglyzinurie",
      "Glyzin-Enzephalopathie",
      "Glyzinstoffwechselstörung",
      "Hydroxyprolinämie",
      "Hydroxyprolinämie-Syndrom",
      "Hyperglyzinämie",
      "Hyperhydroxyprolinämie",
      "Hyperprolinämie",
      "Hyperprolinämie Typ I",
      "Hyperprolinämie Typ II",
      "Nichtketotische Hyperglyzinämie",
      "Prolinoxydase-Mangel",
      "Pyrrolincarboxylsäure-Dehydrogenasemangel",
      "Sarkosin-Dehydrogenase-Komplex-Mangel",
      "Sarkosinämie"
    ]
  },
  {
    "code": "E72.8",
    "name": "Threoninstoffwechselstörung",
    "synonyms": [
      "2-Hydroxyglutarazidurie",
      "2-Hydroxyglutarazidämie",
      "2-Methyl-3-Hydroxybutyrazidurie",
      "3-PGDH [3-Phosphoglycerat-Dehydrogenase]-Mangel",
      "3-Phosphoglycerat-Dehydrogenase-Mangel",
      "3-Phosphoserin-Phosphatase-Mangel",
      "4-Hydroxybutyrazidurie",
      "5-Oxoprolinase-Mangel",
      "AGAT [Arginin:Glycin-Amidinotransferase]-Mangel",
      "Angeborenes generalisiertes hyperkontraktiles Muskelsteifigkeitsyndrom",
      "Asparagin-Synthetase-Mangel",
      "Bernsteinsäure-Semialdehyd-Dehydrogenase-Mangel",
      "Beta-Aminosäure-Stoffwechselstörung",
      "Carnosinase-Mangel",
      "Cystindiathese",
      "D-2-Hydroxyglutaryl-Azidurie",
      "D-2-Hydroxyglutaryl-Azidämie",
      "GABA [Gamma-Aminobuttersäure]-Stoffwechselstörung",
      "GABA [Gamma-Aminobuttersäure]-Transaminase-Mangel",
      "Gamma-Amino-Buttersäure-Stoffwechselstörung",
      "Gamma-Aminobuttersäure-Transaminase-Mangel",
      "Gamma-Glutamyltranspeptidase-Mangel",
      "Gamma-Hydroxybutyrazidurie",
      "Glutaminstoffwechselstörung",
      "Glutathionurie",
      "Guanidinoacetat-Methyltransferase-Mangel",
      "Homocarnosinase-Mangel",
      "Homocarnosinose",
      "Hyperimidodipeptidurie",
      "Iminosäurekrankheit",
      "Infantiler 3-Phosphoglycerat-Dehydrogenase-Mangel",
      "Infantiler Serinbiosynthese-Defekt",
      "Juveniler 3-Phosphoglycerat-Dehydrogenase-Mangel",
      "Juveniler Serinbiosynthese-Defekt",
      "Kombinierte D-2 und L-2-Hydroxyglutarazidurie",
      "Kongenitale Hirnfehlbildung durch Glutamin-Synthetase-Mangel",
      "Kongenitaler Glutamin-Synthetase-Mangel",
      "Kreatinmangel-Syndrom",
      "L-2-HGA [L-2-Hydroxyglutaryl-Azidurie]",
      "L-2-Hydroxyglutaryl-Azidurie",
      "L-2-Hydroxyglutaryl-Azidämie",
      "L-Arginin:Glycin-Amidinotransferase-Mangel",
      "Malonazidurie",
      "Malonyl-CoA-Decarboxylase-Mangel",
      "Methylmalonazidurie mit Homocystinurie Typ CblC",
      "Methylmalonazidurie mit Homocystinurie Typ CblD",
      "Methylmalonazidurie mit Homocystinurie Typ CblF",
      "Methylmalonazidurie mit Homocystinurie Typ CblJ",
      "Methylmalonazidämie mit Homocystinurie Typ CblC",
      "Methylmalonazidämie mit Homocystinurie Typ CblD",
      "Methylmalonazidämie mit Homocystinurie Typ CblF",
      "Methylmalonazidämie mit Homocystinurie Typ CblJ",
      "N-Acyl-L-Aminosäure-Amidohydrolase-Mangel",
      "Neurometabolische Störung durch Serin-Mangel",
      "Oxoprolinurie durch Oxoprolinase-Mangel",
      "Phosphoserin-Aminotransferase-Mangel",
      "Prolidasemangel",
      "SSADH [Succinat-Semialdehyd-Dehydrogenase]-Mangel",
      "Serin-Mangelsyndrom",
      "Serinstoffwechselstörung",
      "Störung des Gamma-Glutamylzyklus",
      "Störung im Stoffwechsel unverzweigter Aminosäuren",
      "Succinat-Semialdehyd-Dehydrogenase-Mangel",
      "Syndrom der Hyperurikämie mit pulmonaler Hypertension, Nierenversagen und Alkalose",
      "Syndrom der kongenitalen Mikrozephalie mit schwergradiger Enzephalopathie und progressiver zerebraler Atrophie",
      "Threoninstoffwechselstörung",
      "Äthanolaminurie"
    ]
  },
  {
    "code": "E72.9",
    "name": "Aminoazidopathie",
    "synonyms": [
      "Aminoazidopathie",
      "Aminoazidurie",
      "Aminosäuremangel",
      "Aminosäurestoffwechselstörung",
      "Angeborene Aminosäurestoffwechselstörung",
      "Hyperaminoazidurie"
    ]
  },
  {
    "code": "E73.0",
    "name": "Angeborener Laktasemangel",
    "synonyms": [
      "Alaktasie",
      "Angeborene Alaktasie",
      "Angeborener Laktasemangel",
      "Disaccharid-Intoleranzsyndrom",
      "Genetisch bedingter Laktasemangel",
      "Hereditäre Disaccharid-Intoleranz"
    ]
  },
  {
    "code": "E73.1",
    "name": "Sekundärer Laktasemangel",
    "synonyms": [
      "Sekundärer Laktasemangel"
    ]
  },
  {
    "code": "E73.9",
    "name": "Laktoseintoleranz",
    "synonyms": [
      "Angeborene Laktoseintoleranz",
      "Disaccharid-Malabsorption",
      "Disaccharid-Malabsorptionssyndrom",
      "Disaccharidasemangel",
      "Laktoseintoleranz",
      "Laktoseintoleranzsyndrom",
      "Laktoseunverträglichkeit",
      "Malabsorption von Laktose"
    ]
  },
  {
    "code": "E74.0",
    "name": "Amylopektinose",
    "synonyms": [
      "Adulte Polyglukosankörper-Krankheit",
      "Adulte neuromuskuläre Form GBE [Glykogen-Branching-Enzym]-Mangel",
      "Adulte neuromuskuläre Form der GSD [Glykogenspeicherkrankheit] Typ 4",
      "Adulte neuromuskuläre Form der GSD [Glykogenspeicherkrankheit] durch Glykogen-Branching-Enzym-Mangel",
      "Adulte neuromuskuläre Form der Glykogenose Typ 4",
      "Adulte neuromuskuläre Form der Glykogenose durch Glykogen-Branching-Enzym-Mangel",
      "Adulte neuromuskuläre Form der Glykogenspeicherkrankheit Typ 4",
      "Alpha-1,4-Glukosidase-Mangel",
      "Amylo-1,6-Glukosidase-Mangel",
      "Amylopectinosis",
      "Amylopektinose",
      "Andersen-Krankheit [Glykogenose]",
      "Andersen-Syndrom [Glykogenose]",
      "Beta-Enolase-Mangel",
      "Bickel-Fanconi-Glykogenose",
      "Branching-Enzym-Mangel",
      "Cori-Forbes-Krankheit",
      "Cori-Krankheit",
      "Cori-Syndrom",
      "Danon-Krankheit",
      "Debranching-Enzym-Mangel",
      "Diffuse Glykogenose",
      "Fanconi-Bickel-Syndrom",
      "Fatale perinatale neuromuskuläre Form der GSD [Glykogenspeicherkrankheit] Typ 4",
      "Fatale perinatale neuromuskuläre Form der GSD [Glykogenspeicherkrankheit] durch Glykogen-Branching-Enzym-Mangel",
      "Fatale perinatale neuromuskuläre Form der Glykogenose Typ 4",
      "Fatale perinatale neuromuskuläre Form der Glykogenose durch Glykogen-Branching-Enzym-Mangel",
      "Fatale perinatale neuromuskuläre Form der Glykogenspeicherkrankheit Typ 4",
      "Fatale perinatale neuromuskuläre Form des GBE [Glykogen-Branching-Enzym]-Mangel",
      "Forbes-Hers-Syndrom",
      "Forbes-Krankheit",
      "Forbes-Syndrom",
      "G6P [Glukose-6-Phosphat]-Translokase-Mangel",
      "G6PT [Glukose-6-Phosphat-Translokase]-Mangel",
      "GDE [Glycogen debranching enzyme]- Mangel",
      "GSD [Glykogenspeicherkrankheit]",
      "GSD [Glykogenspeicherkrankheit] Typ 0a",
      "GSD [Glykogenspeicherkrankheit] Typ 0b",
      "GSD [Glykogenspeicherkrankheit] Typ 1",
      "GSD [Glykogenspeicherkrankheit] Typ 12",
      "GSD [Glykogenspeicherkrankheit] Typ 13",
      "GSD [Glykogenspeicherkrankheit] Typ 1B",
      "GSD [Glykogenspeicherkrankheit] Typ 2",
      "GSD [Glykogenspeicherkrankheit] Typ 3",
      "GSD [Glykogenspeicherkrankheit] Typ 4",
      "GSD [Glykogenspeicherkrankheit] Typ 5",
      "GSD [Glykogenspeicherkrankheit] Typ 6B",
      "GSD [Glykogenspeicherkrankheit] Typ 7",
      "GSD [Glykogenspeicherkrankheit] Typ 9",
      "GSD [Glykogenspeicherkrankheit] Typ 9B",
      "GSD [Glykogenspeicherkrankheit] Typ 9D",
      "GSD [Glykogenspeicherkrankheit] Typ 9E",
      "GSD [Glykogenspeicherkrankheit] durch Aldolase A-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch GLUT2-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Glykogen-Branching-Enzym-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Glykogen-Debranching-Enzym-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Glykogen-Phosphorylase-Mangel der Leber",
      "GSD [Glykogenspeicherkrankheit] durch Myophosphorylase-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Phosphoglukomutase-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Phosphoglyceratkinase 1-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Phosphorylasekinase-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch hepatischen Glykogensynthase-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch muskulären Phosphofructokinase-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch muskulären Phosphorylasekinase-Mangel",
      "Generalisierte Glykogenose",
      "Generalisierte Glykogenspeicherkrankheit",
      "Glukose-6-Phosphatase-Mangel",
      "Glukose-6-Phosphatase-Translokase-Mangel",
      "Glykogen-Phosphorylase-Mangel der Leber",
      "Glykogeninfiltration",
      "Glykogenose",
      "Glykogenose Typ 0b",
      "Glykogenose Typ 1",
      "Glykogenose Typ 12",
      "Glykogenose Typ 13",
      "Glykogenose Typ 1A",
      "Glykogenose Typ 2",
      "Glykogenose Typ 3",
      "Glykogenose Typ 4",
      "Glykogenose Typ 5",
      "Glykogenose Typ 6B",
      "Glykogenose Typ 7",
      "Glykogenose Typ 9",
      "Glykogenose Typ 9A",
      "Glykogenose Typ 9B",
      "Glykogenose Typ 9C",
      "Glykogenose Typ 9D",
      "Glykogenose Typ 9E",
      "Glykogenose durch Aldolase A-Mangel",
      "Glykogenose durch GLUT2-Mangel",
      "Glykogenose durch Glykogen-Branching-Enzym-Mangel",
      "Glykogenose durch Glykogen-Debranching-Enzym-Mangel",
      "Glykogenose durch LAMP2 [Lysosomen-assoziiertes Membranprotein-2]-Mangel",
      "Glykogenose durch Leber- und Muskel-Phosphorylasekinase-Mangel",
      "Glykogenose durch PhK [Phosphorylasekinase]-Mangel",
      "Glykogenose durch Phosphofruktokinase-Mangel des Muskels",
      "Glykogenose durch Phosphoglukomutase-Mangel",
      "Glykogenose durch Phosphoglyceratkina"
    ]
  },
  {
    "code": "E74.1",
    "name": "Fruktosestoffwechselstörung",
    "synonyms": [
      "Benigne Fruktosämie",
      "Essentielle Fruktosurie",
      "Essentielle Fruktosämie",
      "Fruktokinasemangel",
      "Fruktose-1,6-Diphosphatasemangel",
      "Fruktoseintoleranz",
      "Fruktoseintoleranzsyndrom",
      "Fruktosestoffwechselstörung",
      "Fruktosurie",
      "Fruktosurie-Syndrom",
      "Fruktosämie",
      "Hereditäre Fruktoseintoleranz",
      "Hereditäre Fruktoseunverträglichkeit",
      "Hereditäre Fruktosämie",
      "Hereditäre Lävuloseintoleranz",
      "Hereditäre Lävuloseunverträglichkeit",
      "Hereditärer Aldolasemangel",
      "Hereditärer Fruktose-1-Phosphataldolase-Mangel",
      "Hyperfruktosämie",
      "Ketohexokinase-Mangel",
      "Störungen des Fruktosestoffwechsels"
    ]
  },
  {
    "code": "E74.2",
    "name": "Galaktosestoffwechselstörung",
    "synonyms": [
      "GALK [Galaktokinase]-Mangel",
      "GALT [Galaktose-1-Phosphat-Uridyltransferase]-Mangel",
      "Galaktokinasemangel",
      "Galaktose-Epimerase-Mangel",
      "Galaktose-Mutarotase-Mangel",
      "Galaktosediabetes",
      "Galaktoseintoleranz",
      "Galaktosestoffwechselstörung",
      "Galaktosurie",
      "Galaktosämie",
      "Galaktosämie Typ 1",
      "Galaktosämie Typ 2",
      "Galaktosämie Typ 3",
      "Galaktosämie-Syndrom",
      "Galaktosämischer Epimerase-Mangel",
      "Galaktosämischer Galaktokinase-Mangel",
      "Kongenitale Galaktoseunverträglichkeit",
      "Kongenitale Galaktosämie",
      "Malabsorption von Galaktose",
      "Mangel an Galaktose-1-Phosphat-Uridyltransferase",
      "Neonatale Gelbsucht durch Galaktosämie",
      "Neonataler Ikterus durch Galaktosämie",
      "Störungen des Galaktosestoffwechsels",
      "UDP [Uridindiphosphat]-Galaktose-4-Epimerase-Mangel"
    ]
  },
  {
    "code": "E74.3",
    "name": "Angeborene Glukose-Galaktose-Intoleranz",
    "synonyms": [
      "Angeborene Glukose-Galaktose-Intoleranz",
      "Angeborene Saccharose-Isomaltose-Intoleranz",
      "Chronische Diarrhoe durch Glucoamylase-Mangel",
      "Diarrhoe und Erbrechen durch Trehalase-Mangel",
      "Glukose-Galaktose-Malabsorption",
      "Intoleranz gegen Saccharose",
      "Intoleranz gegen Sucrose",
      "Kongenitaler Saccharase-Isomaltase-Mangel",
      "Malabsorption von Isomaltose",
      "Malabsorption von Monosaccharid",
      "Saccharasemangel",
      "Saccharose-Isomaltose-Malabsorption",
      "Störung der intestinalen Kohlenhydratabsorption a.n.k.",
      "Sucrase-Isomaltase-Mangel"
    ]
  },
  {
    "code": "E74.4",
    "name": "Phosphoenolpyruvat-Carboxykinase-Mangel",
    "synonyms": [
      "DLD [Dihydrolipoamid-Dehydrogenase]-Mangel",
      "Dihydrolipoamid-Dehydrogenase-Mangel",
      "Dihydrolipoamid-S-Acetyltransferase-Mangel",
      "GSD [Glykogenspeicherkrankheit] durch Laktatdehydrogenase-Mangel",
      "Glukoneogenesestörung",
      "Glykogenose durch LDH [Laktatdehydrogenase]-Mangel",
      "Glykogenspeicherkrankheit durch Laktatdehydrogenase-Mangel",
      "LDH [Laktatdehydrogenase]-Mangel",
      "PDH [Pyruvat-Dehydrogenase]-E2-Mangel",
      "PDH [Pyruvat-Dehydrogenase]-Phosphatase-Mangel",
      "PDHC [Pyruvatdehydrogenase-Komplex]-Mangel",
      "PEPCK [Phosphoenolpyruvat-Carboxykinase]-Mangel",
      "Phosphoenolpyruvat-Carboxykinase 1-Mangel",
      "Phosphoenolpyruvat-Carboxykinase 2-Mangel",
      "Phosphoenolpyruvat-Carboxykinase-Mangel",
      "Pyruvat-Dehydrogenase E1-alpha-Mangel",
      "Pyruvat-Dehydrogenase E1-beta-Mangel",
      "Pyruvat-Dehydrogenase E2-Mangel",
      "Pyruvat-Dehydrogenase E3-Mangel",
      "Pyruvat-Dehydrogenase-Phosphatase-Mangel",
      "Pyruvatcarboxylasemangel",
      "Pyruvatdehydrogenase-Komplex-Mangel",
      "Pyruvatdehydrogenasemangel",
      "Pyruvatstoffwechselstörung"
    ]
  },
  {
    "code": "E74.8",
    "name": "Pentosurie",
    "synonyms": [
      "Carboanhydrase-XII-Mangel",
      "D-Glycerat-Dehydrogenase-Mangel",
      "D-Glycerat-Kinase-Mangel",
      "Diabetes mellitus renalis",
      "Diabetes renalis",
      "Essentielle Pentosurie",
      "Familiäre renale Glukosurie",
      "Glucose-6-Phosphat-Dehydrogenase [G6PDH]-Mangel",
      "Glukosetransportstörung",
      "Glykolische Azidurie",
      "Hyperglycerolämie",
      "Hyperglyzerinämie",
      "Hyperoxalurie",
      "Isolierter Glycerol-Kinase-Mangel",
      "Isolierter Sedoheptulokinase-Mangel",
      "Kalziumoxalatnephritis",
      "Melliturie",
      "Oxalat-Nephropathie",
      "Oxalat-Schrumpfniere",
      "Oxalaturie",
      "Oxalose",
      "Oxalurie",
      "Pentosephosphat-Stoffwechselstörung",
      "Pentosurie",
      "Peroxisomaler Alanin-Glyoxylat-Aminotransferase-Mangel",
      "Primäre Hyperoxalurie",
      "Primäre Hyperoxalurie Typ 1",
      "Primäre Hyperoxalurie Typ 2",
      "Primäre Hyperoxalurie Typ 3",
      "Renale Glukosurie",
      "Ribose-5-Phosphat-Isomerase-Mangel",
      "Sekundäre Hyperoxalurie",
      "Störung glykolytischer Enzyme",
      "Transaldolase-Mangel",
      "Transketolase-Mangel",
      "Xylitol-Dehydrogenase-Mangel"
    ]
  },
  {
    "code": "E74.9",
    "name": "Kohlenhydratstoffwechselstörung",
    "synonyms": [
      "Kohlenhydratstoffwechselstörung"
    ]
  },
  {
    "code": "E75.0",
    "name": "Tay-Sachs-Krankheit",
    "synonyms": [
      "Adulte Form der GM2-Gangliosidose",
      "Adulte Form der Sandhoff-Krankheit",
      "Adulte Form der Tay-Sachs-Krankheit, Variante B",
      "Amaurotisch familiäre Tay-Sachs-Krankheit",
      "GM2-Gangliosidose",
      "GM2-Gangliosidose, Variante 0",
      "GM2-Gangliosidose, Variante AB",
      "GM2-Gangliosidose, Varianten B und B1",
      "Hexosaminidase A-Mangel",
      "Infantile Form der GM2-Gangliosidose",
      "Infantile Form der Sandhoff-Krankheit",
      "Infantile Form der Tay-Sachs-Krankheit, Variante B",
      "Juvenile Form der GM2-Gangliosidose",
      "Juvenile Form der Sandhoff-Krankheit",
      "Juvenile Form der Tay-Sachs-Krankheit, Variante B",
      "Morbus Tay-Sachs",
      "Sandhoff-Krankheit",
      "Tay-Sachs-Krankheit",
      "Tay-Sachs-Krankheit, Variante B1",
      "Tay-Sachs-Syndrom"
    ]
  },
  {
    "code": "E75.1",
    "name": "Mukolipidose IV",
    "synonyms": [
      "Beta-Galaktosidase 1-Mangel",
      "GM [Gamma-Kettenmarker]-Gangliosidose",
      "GM1-Gangliosidose",
      "GM1-Gangliosidose Typ 1",
      "GM1-Gangliosidose Typ 2",
      "GM1-Gangliosidose Typ 3",
      "GM1-Gangliosidose mit Beginn im Erwachsenenalter",
      "GM3-Gangliosidose",
      "Gangliosidose",
      "Gangliosidthesaurismose",
      "Infantile GM1-Gangliosidose",
      "Juvenile GM1-Gangliosidose",
      "Landing-Krankheit",
      "Mukolipidose IV",
      "Norman-Landing-Krankheit",
      "Spät-infantile GM1-Gangliosidose"
    ]
  },
  {
    "code": "E75.2",
    "name": "Fabry-Krankheit",
    "synonyms": [
      "ADLD [Autosomal-dominante Leukodystrophie mit adultem Beginn]",
      "Adulte Gaucher-Krankheit",
      "Akut-neuronopathische Gaucher-Krankheit",
      "Akute reversible Leukoenzephalopathie durch SLC13A3-Defizienz",
      "Alexander-Krankheit",
      "Alexander-Syndrom",
      "Alpha-Galaktosidase A-Mangel",
      "Aminoacylase 2-Mangel",
      "Anderson-Fabry-Krankheit",
      "Angiokeratoma corporis diffusum",
      "Aplasia axialis extracorticalis congenita",
      "Aplasia extracorticalis axialis",
      "Arylsulfatase A-Mangel",
      "Aspartoacylase-Mangel",
      "C11ORF73-assoziierte autosomal-rezessive hypomyelinisierende Leukodystrophie",
      "CACH [Childhood ataxia with central nervous system hypomyelination]-Syndrom",
      "Canavan-Krankheit",
      "Canavan-Syndrom",
      "Ceramidase-Mangel",
      "Chronisch-neuropathische Form der Gaucher-Krankheit",
      "Enzephalopathie durch Prosaposin-Mangel",
      "Essentielle Lipoidhistiozytose",
      "Fabry-Anderson-Krankheit",
      "Fabry-Krankheit",
      "Fabry-Syndrom",
      "Familiäre diffuse Gehirnsklerose",
      "Familiäre diffuse Hirnsklerose",
      "Familiäre zentrolobäre Sklerose",
      "Farber-Krankheit",
      "Farber-Lipogranulomatose",
      "Farber-Syndrom",
      "Fetale Gaucher-Krankheit",
      "Galaktosylzeramidase-Mangel",
      "Galaktozerebrosidase-Mangel",
      "Gaucher-Krankheit",
      "Gaucher-Krankheit Typ 1",
      "Gaucher-Krankheit Typ 2",
      "Gaucher-Krankheit Typ 3",
      "Gaucher-Krankheit Typ 3C",
      "Gaucher-Krankheit beim Erwachsenen",
      "Gaucher-Krankheit mit Ophthalmoplegie und kardiovaskulären Verkalkungen",
      "Gaucher-Splenomegalie",
      "Gaucher-Splenomegalie beim Erwachsenen",
      "Gaucher-Syndrom",
      "Globoidzellen-Leukodystrophie",
      "Glukozerebrosidase-Mangel",
      "Glykolipoide Lipidose",
      "Greenfield-Krankheit [Metachromatische Leukodystrophie]",
      "H-ABC [Hypomyelinisierung mit Atrophie der Basalganglien und des Zerebellums]",
      "Hereditäre diffuse Leukoenzephalopathie mit axonalen Sphäroiden und pigmentierter Glia",
      "Hypomyelinisierung mit Atrophie der Basalganglien und des Zerebellums",
      "Hypomyelinisierung mit Hirnstamm- und Rückenmarkbeteiligung und Beinspastik",
      "Infantile Form der Krabbe-Krankheit",
      "Infantile Gaucher-Krankheit",
      "Infantile Gaucher-Splenomegalie",
      "Infantile Gehirnsklerose",
      "Infantile Hirnsklerose",
      "Infantile diffuse Gehirnsklerose",
      "Infantile diffuse Hirnsklerose",
      "Juvenile Form der Krabbe-Krankheit",
      "Juvenile Sulfatidose Typ Austin",
      "Kardiovaskuläre Form der Gaucher-Krankheit",
      "Krabbe-Gehirnsklerose",
      "Krabbe-Hirnsklerose",
      "Krabbe-Krankheit",
      "Krabbe-Krankheit mit Beginn im Erwachsenenalter",
      "Krabbe-Leukodystrophie",
      "Krabbe-Syndrom",
      "Leukodystrophie",
      "Leukodystrophie durch ACER3 [Alkalische Ceramidase 3]-Mangel",
      "Leukoenzephalopathie mit beidseitigen vorderen Temporallappen-Zysten",
      "Leukoenzephalopathie mit milder zerebellärer Ataxie und Ödem der weißen Substanz",
      "MLD [Metachromatische Leukodystrophie]",
      "Megalenzephale Leukoenzephalopathie mit subkortikalen Zysten",
      "Metachromatische Leukodystrophie",
      "Metachromatische Leukoenzephalopathie",
      "Morbus Gaucher",
      "Mukosulfatidose",
      "Multipler Sulfatase-Mangel",
      "Myeloleukodystrophie",
      "NKX6-2-assoziierte autosomal-rezessive hypomyelinisierende Leukodystrophie",
      "Nasu-Hakola-Krankheit",
      "Nicht-neuronopathische Gaucher-Krankheit",
      "Niemann-Pick-Krankheit",
      "Niemann-Pick-Krankheit Typ A",
      "Niemann-Pick-Krankheit Typ A/B",
      "Niemann-Pick-Krankheit Typ B",
      "Niemann-Pick-Krankheit Typ C",
      "Niemann-Pick-Krankheit Typ E",
      "Niemann-Pick-Splenomegalie",
      "Niemann-Pick-Syndrom",
      "PMLD [Pelizaeus-Merzbacher-ähnliche Erkrankung]",
      "Pelizaeus-Merzbacher-Aplasie",
      "Pelizaeus-Merzbacher-Gehirnsklerose",
      "Pelizaeus-Merzbacher-Hirnsklerose",
      "Pelizaeus-Merzbacher-Krankheit",
      "Pelizaeus-Merzbacher-Krankheit bei weiblicher Trägerin",
      "Pelizaeus-Merzbacher-Krankheit, klassische Form",
      "Pelizaeus-Merzbacher-Krankheit, konnatale Form",
      "Pelizaeus-Merzbacher-Krankheit, Übergangsform",
      "Pelizaeus-Merzbacher-Syndrom",
      "Pelizaeus-Merzbacher-ähnliche Erkrankung",
      "Perinatal-letale Form der Gaucher-Krankheit",
      "Phosphatid-Thesaurismose",
      "Polymerase-III-assoziierte Leukodystrophie",
      "Progressive Leukodystrophie",
      "Progressive familiäre Gehirnsklerose",
      "Progressive familiäre Hirnsklerose",
      "Progressive zerebrale Leukodystrophie",
      "RARS-assoziierte autosomal-rezessive hypomyelinisierende Leukodystrophie",
      "RNASET2-defiziente zystische Leukoenzephalopathie",
      "Saure-Sphingomyelinase-Mangel",
      "Scholz-Syndrom",
      "Sphingomy"
    ]
  },
  {
    "code": "E75.3",
    "name": "Sphingolipidose",
    "synonyms": [
      "Sphingolipidose",
      "Sphingolipoidosis",
      "Sphingomyelinose"
    ]
  },
  {
    "code": "E75.4",
    "name": "Neuronale Zeroidlipofuszinose",
    "synonyms": [
      "ATP13A2-assoziierte juvenile neuronale Zeroidlipofuszinose",
      "Adulte NCL [Neuronale Zeroidlipofuszinose]",
      "Adulte neuronale Zeroidlipofuszinose",
      "Amaurotische Idiotie",
      "Batten-Krankheit",
      "Batten-Kufs-Syndrom",
      "Batten-Mayou-Krankheit",
      "Batten-Mayou-Syndrom",
      "Bielschowsky-Dollinger-Krankheit",
      "Bielschowsky-Dollinger-Syndrom",
      "CLN1 [Zeroidlipofuszinose, neuronale Typ 1]-Krankheit",
      "CLN10 [Zeroidlipofuszinose, neuronale Typ 10]-Krankheit",
      "CLN2 [Zeroidlipofuszinose, neuronale Typ 2]-Krankheit",
      "CLN3 [Zeroidlipofuszinose, neuronale Typ 3]-Krankheit",
      "CLN4A [Zeroidlipofuszinose, neuronale Typ 4A]-Krankheit",
      "CLN4B [Zeroidlipofuszinose, neuronale Typ 4B]-Krankheit",
      "CLN5 [Zeroidlipofuszinose, neuronale Typ 5]-Krankheit",
      "CLN6 [Zeroidlipofuszinose, neuronale Typ 6]-Krankheit",
      "CLN7 [Zeroidlipofuszinose, neuronale Typ 7]-Krankheit",
      "CLN8 [Zeroidlipofuszinose, neuronale Typ 8]-Krankheit",
      "CLN9 [Zeroidlipofuszinose, neuronale Typ 9]-Krankheit",
      "Familiäre amaurotische Idiotie",
      "Hagberg-Santavuori-Krankheit",
      "Infantile NCL [Neuronale Zeroidlipofuszinose]",
      "Infantile amaurotische Idiotie",
      "Infantile neuronale Zeroidlipofuszinose",
      "Jansky-Bielschowsky-Krankheit",
      "Juvenile NCL [Neuronale Zeroidlipofuszinose]",
      "Juvenile amaurotische Idiotie",
      "Juvenile neuronale Zeroidlipofuszinose",
      "Kongenitale neuronale Zeroidlipofuszinose",
      "Kufs-Krankheit",
      "Kufs-Syndrom",
      "NCL [Neuronale Zeroidlipofuszinose]",
      "Neurolipidose",
      "Neuronale Lipofuszinose",
      "Neuronale Lipofuszinose mit Zeroidose",
      "Neuronale Zeroidlipofuszinose",
      "Neuronale Zeroidlipofuszinose Typ 1",
      "Neuronale Zeroidlipofuszinose Typ 10",
      "Neuronale Zeroidlipofuszinose Typ 2",
      "Neuronale Zeroidlipofuszinose Typ 3",
      "Neuronale Zeroidlipofuszinose Typ 4A",
      "Neuronale Zeroidlipofuszinose Typ 4B",
      "Neuronale Zeroidlipofuszinose Typ 5",
      "Neuronale Zeroidlipofuszinose Typ 6",
      "Neuronale Zeroidlipofuszinose Typ 7",
      "Neuronale Zeroidlipofuszinose Typ 8",
      "Neuronale Zeroidlipofuszinose Typ 9",
      "Nordische Epilepsie",
      "Nordische Epilepsie-Variante der neuronalen Zeroidlipofuszinose",
      "Progressive Epilepsie und Intelligenzminderung vom finnischen Typ",
      "Spielmeyer-Vogt-Krankheit",
      "Spielmeyer-Vogt-Syndrom",
      "Spät-infantile neuronale Zeroidlipofuszinose",
      "Spätform der amaurotischen Idiotie",
      "Stock-Spielmeyer-Vogt-Syndrom",
      "Zerebrale Lipidose",
      "Zerebromakuläre Dystrophie",
      "Zerebroretinale Lipidose"
    ]
  },
  {
    "code": "E75.5",
    "name": "Wolman-Krankheit",
    "synonyms": [
      "Bänderxanthom",
      "Cholesterinester-Speicherkrankheit",
      "Cholesterinlipidose",
      "Cholesterinspeicherkrankheit",
      "Dorfman-Chanarin-Krankheit",
      "Essentielle Xanthomatose",
      "Familiäre Xanthomatose",
      "Gelenkxanthom",
      "Hereditäre Hyperlipidosis a.n.k.",
      "Hereditäre Xanthomatose",
      "Homozygote Phytosterinämie",
      "Kardiovaskuläre Xanthomatose",
      "Kutaneotendinöse Xanthomatose",
      "LAL-D [Lysosomale saure Lipase-Mangel]",
      "Lipidose mit Triglyzerid-Speicherkrankheit",
      "Lipoidgranulomatose",
      "Lysosomale saure Lipase-Mangel",
      "Neutralfett-Speicherkrankheit",
      "Neutralfett-Speicherkrankheit mit Ichthyose",
      "Nierenphospholipidose",
      "Peritonealhyalinose",
      "Phospholipidose",
      "Primäre Xanthomatose",
      "Primäres Xanthom",
      "Sehnenscheidenxanthom",
      "Sehnenxanthom",
      "Sterol-27-Hydroxylase-Mangel",
      "Triglyzerid-Speicherkrankheit",
      "Van-Bogaert-Scherer-Epstein-Krankheit",
      "Van-Bogaert-Scherer-Epstein-Syndrom",
      "Wolman-Krankheit",
      "Wolman-Syndrom",
      "Xanthom",
      "Xanthoma",
      "Xanthomatose",
      "Xanthomatosis",
      "Zerebrotendinöse Xanthomatose"
    ]
  },
  {
    "code": "E75.6",
    "name": "Hyperlipidosis",
    "synonyms": [
      "Aortenlipoidose",
      "Endokardlipoidose",
      "Fettspeicherung",
      "Hyperlipidosis",
      "Larynxlipoidose",
      "Lipidose",
      "Lipidspeicherkrankheit",
      "Lipidspeicherstörung",
      "Lipoidablagerung",
      "Lipoidose",
      "Lipoidspeicherkrankheit",
      "Nierenparenchymverfettung",
      "Nierenrindenlipoidose",
      "Nierenverfettung",
      "Tubulusepithelverfettung"
    ]
  },
  {
    "code": "E76.0",
    "name": "Mukopolysaccharidose Typ I",
    "synonyms": [
      "Alpha-L-Iduronidase-Mangel",
      "Dysostosis multiplex",
      "Dysostotische Idiotie [Pfaundler-Hurler-Syndrom]",
      "Enchondrale Dysostose",
      "Gargoylismus",
      "Hurler-Krankheit",
      "Hurler-Scheie-Krankheit",
      "Hurler-Scheie-Syndrom",
      "Hurler-Scheie-Variante [Mukopolysaccharidose Typ I-H/S]",
      "Hurler-Syndrom",
      "Lipochondrodystrophie",
      "MPS I [Mukopolysaccharidose Typ I]",
      "Mukopolysaccharidose Typ I",
      "Mukopolysaccharidose Typ I-S",
      "Pfaundler-Hurler-Krankheit",
      "Scheie-Krankheit",
      "Scheie-Syndrom",
      "Von-Pfaundler-Hurler-Krankheit",
      "Von-Pfaundler-Hurler-Syndrom"
    ]
  },
  {
    "code": "E76.1",
    "name": "Mukopolysaccharidose Typ II",
    "synonyms": [
      "Attenuierte Form der Mukopolysaccharidose Typ II",
      "Hunter-Hurler-Syndrom",
      "Hunter-Krankheit [Mukopolysaccharidose Typ II]",
      "Hunter-Syndrom",
      "Iduronat 2-Sulfatase-Mangel",
      "Mukopolysaccharidose Typ II",
      "Mukopolysaccharidose Typ IIA",
      "Mukopolysaccharidose Typ IIB",
      "Schwere Form der Mukopolysaccharidose Typ II"
    ]
  },
  {
    "code": "E76.2",
    "name": "Familiäre Osteochondrodystrophie",
    "synonyms": [
      "Arylsulfatase B-Mangel",
      "Beta-Glukuronidase-Mangel",
      "Chondroosteodystrophie Typ Morquio",
      "Familiäre Osteochondrodystrophie",
      "Galaktosamin-6-Sulfatase-Mangel",
      "Glucosamin N-Acetyl-6-Sulfatase-Mangel",
      "Heparan-Alpha-Glucosaminid N-Acetyltransferase-Mangel",
      "Heparan-Sulfamidase-Mangel",
      "Hyaluronidasemangel",
      "Klassische Morquio-Krankheit",
      "Leichte Maroteaux-Lamy-Krankheit",
      "Leichtes Maroteaux-Lamy-Syndrom",
      "MPS III [Mukopolysaccharidose Typ III]",
      "MPS VI [Mukopolysaccharidose Typ VI]",
      "Mangel an N-Acetylgalactosamin 4-Sulfatase",
      "Morquio-Krankheit",
      "Morquio-Ullrich-Brailsford-Krankheit",
      "Morquio-Ullrich-Brailsford-Syndrom",
      "Mukopolysaccharidose Typ III",
      "Mukopolysaccharidose Typ IIIA",
      "Mukopolysaccharidose Typ IIIB",
      "Mukopolysaccharidose Typ IIIC",
      "Mukopolysaccharidose Typ IIID",
      "Mukopolysaccharidose Typ IV",
      "Mukopolysaccharidose Typ IVa",
      "Mukopolysaccharidose Typ IVb",
      "Mukopolysaccharidose Typ IX",
      "Mukopolysaccharidose Typ VI",
      "Mukopolysaccharidose Typ VII",
      "Osteochondrodystrophia deformans",
      "Sanfilippo-Krankheit",
      "Sanfilippo-Krankheit Typ A",
      "Sanfilippo-Krankheit Typ B",
      "Sanfilippo-Krankheit Typ C",
      "Sanfilippo-Krankheit Typ D",
      "Sanfilippo-Syndrom",
      "Sanfilippo-Syndrom Typ A",
      "Sanfilippo-Syndrom Typ B",
      "Sanfilippo-Syndrom Typ C",
      "Sanfilippo-Syndrom Typ D",
      "Schwere Maroteaux-Lamy-Krankheit",
      "Schweres Maroteaux-Lamy-Syndrom",
      "Sly-Krankheit",
      "Sonderform der Morquio-Krankheit"
    ]
  },
  {
    "code": "E76.3",
    "name": "Osteochondrodystrophie",
    "synonyms": [
      "Chondroosteodystrophie",
      "Mucopolysaccharid-Speicherkrankheit",
      "Mukopolysaccharidose",
      "Osteochondrodystrophie"
    ]
  },
  {
    "code": "E76.9",
    "name": "Glykosaminoglykanstörung",
    "synonyms": [
      "Glykosaminoglykanstoffwechselstörung",
      "Glykosaminoglykanstörung"
    ]
  },
  {
    "code": "E77.0",
    "name": "Mukolipidose II",
    "synonyms": [
      "Defekt der posttranslationalen Modifikation lysosomaler Enzyme",
      "I-Zell-Krankheit",
      "Mukolipidose II",
      "Mukolipidose III",
      "N-Acetylglukosamin-1-Phosphotransferase-Mangel",
      "Pseudo-Hurler-Krankheit",
      "Pseudo-Hurler-Polydystrophie"
    ]
  },
  {
    "code": "E77.1",
    "name": "Glykoproteinabbaudefekt",
    "synonyms": [
      "Adulte Form der Alpha-Mannosidose",
      "Adulter Alpha-N-Acetylgalactosaminidase-Mangel",
      "Alpha-L-Fucosidase-Mangel",
      "Alpha-Mannosidose",
      "Alpha-N-Acetylgalactosaminidase-Mangel",
      "Alpha-N-Acetylgalactosaminidase-Mangel Typ 1",
      "Alpha-N-Acetylgalactosaminidase-Mangel Typ 2",
      "Alpha-N-Acetylgalactosaminidase-Mangel Typ 3",
      "Aspartyl-Glukosaminidase-Mangel",
      "Aspartylglukosaminurie",
      "Beta-Mannosidose",
      "Defekte beim Glykoproteinabbau",
      "Fukosidose",
      "Galaktosialidose",
      "Glykoproteinabbaudefekt",
      "Infantile Form der Alpha-Mannosidose",
      "Infantile dysmorphe Sialidose",
      "Juvenile Form der Sialidose Typ 2",
      "Kanzaki-Krankheit",
      "Kirschroter Fleck-Myoklonus-Syndrom",
      "Kongenitale Form der Sialidose Typ 2",
      "Lipomukopolysaccharidose",
      "Lyosomaler Alpha-D-Mannosidase-Mangel",
      "Lyosomaler Beta-Mannosidase-Mangel",
      "Mannosidose",
      "Mukolipidose I",
      "Normomorphe Sialidose",
      "Oligosaccharidose",
      "Schindler-Krankheit",
      "Schindler-Krankheit Typ 1",
      "Schindler-Krankheit Typ 2",
      "Schindler-Krankheit Typ 3",
      "Sialidose",
      "Sialidose Typ 1",
      "Sialidose Typ 2"
    ]
  },
  {
    "code": "E77.8",
    "name": "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ib",
    "synonyms": [
      "Beta-1,4-Galaktosyltransferase-Mangel",
      "CDG [Congenital disorder of glycosylation]",
      "CDG [Congenital disorder of glycosylation] Typ II durch MAN1B1-Defizienz",
      "CDG [Congenital disorder of glycosylation]-Syndrom",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIa",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIb",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IId",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIe",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIf",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIg",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIh",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIi",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIj",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIk",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIl",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIm",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIn",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIo",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ IIp",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ia",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ib",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ic",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Id",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ie",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ If",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ig",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ih",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ii",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ij",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ik",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Il",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Im",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ In",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Io",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ip",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Iq",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ir",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Is",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ It",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Iu",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Iw",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Ix",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Iy",
      "CDG [Congenital disorder of glycosylation]-Syndrom Typ Iz",
      "COG2-assoziierte CDG [Congenital disorder of glycosylation]",
      "COG2-assoziierte kongenitale Glykosylierungs-Krankheit",
      "Dol-P-Mannosyltransferase-Mangel",
      "Dolichol-Phosphat N-Acetylglucosamin 1-Phosphat-Transferase-Mangel",
      "Dolicholkinase-Mangel",
      "GM3-Synthase-Mangel",
      "Glucosyltransferase 2-Mangel",
      "Glukosidase 1-Mangel",
      "Glukosyltransferase 1-Mangel",
      "Hypotonie und Ichthyose durch Dolicholphosphat-Mangel",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom IIf",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ IIa",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ IIb",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ IId",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ IIe",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ IIg",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ IIh",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ia",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ib",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ic",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Id",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ie",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ If",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ig",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ih",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ii",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ij",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Ik",
      "Kohlenhydrat-defizientes Glykoprotein-Syndrom Typ Il",
      "Kohlenhydrat-d"
    ]
  },
  {
    "code": "E77.9",
    "name": "Glykoproteinstoffwechselstörung",
    "synonyms": [
      "Glykoproteinstoffwechselstörung"
    ]
  },
  {
    "code": "E78.0",
    "name": "Hyperbetalipoproteinämie",
    "synonyms": [
      "Cholesterinämie",
      "Essentielle Cholesterinämie",
      "Essentielle Hypercholesterinämie",
      "Familiäre Cholesterinämie",
      "Familiäre Hyperbetalipoproteinämie",
      "Familiäre Hypercholesterinämie",
      "Familiäre Hypercholesterinämie bei homozygoter Mutation",
      "Familiäre essentielle Hypercholesterinämie",
      "Hereditäre Cholesterinämie",
      "Hereditäre Hypercholesterinämie",
      "Heterozygote Hyperlipoproteinämie Typ IIa",
      "Hyperbetalipoproteinämie",
      "Hypercholesterinämie",
      "Hypercholesterinämie durch Cholesterol 7-alpha-Hydroxylase-Mangel",
      "Hypercholesterinämische Xanthomatose",
      "Hyperlipidämie A",
      "Hyperlipidämie Typ IIa",
      "Hyperlipidämie Typ IIa nach Fredrickson",
      "Hyperlipoproteinämie Typ IIa",
      "Hyperlipoproteinämie vom Low-densitiy-Lipoprotein-Typ",
      "Idiopathische Hypercholesterinämie",
      "LDL-Hyperlipoproteinämie",
      "Phytosterolämie",
      "Primäre Hypercholesterinämie",
      "Reine Cholesterinämie",
      "Reine Hypercholesterinämie",
      "Sitosterolämie",
      "Xanthomatose bei Hypercholesterinämie",
      "Xanthomatose mit Sitosterolämie"
    ]
  },
  {
    "code": "E78.1",
    "name": "Reine Hypertriglyzeridämie",
    "synonyms": [
      "Endogene Hypertriglyzeridämie",
      "Essentielle Hypertriglyzeridämie",
      "Familiäre Hyperpräbetalipoproteinämie",
      "Familiäre Hypertriglyzeridämie",
      "Familiäre Präbetalipoproteinämie",
      "Hereditäre Hypertriglyzeridämie",
      "Hyperlipidämie B",
      "Hyperlipidämie Typ IV nach Fredrickson",
      "Hyperlipoproteinämie Typ IV",
      "Hyperlipoproteinämie vom Very-low-density-lipoprotein-Typ",
      "Hyperpräbetalipoproteinämie",
      "Hypertriglyzeridämie",
      "Präbetalipoproteinämie",
      "Reine Hypertriglyzeridämie",
      "VLDL-Hyperlipoproteinämie"
    ]
  },
  {
    "code": "E78.2",
    "name": "Gemischte Hyperlipidämie",
    "synonyms": [
      "Betalipoproteinämie",
      "Betalipoproteinämie mit breiter Beta-Bande",
      "Broad-beta disease",
      "Broad-beta-Lipoproteinämie",
      "Familiäre Dysbetalipoproteinämie",
      "Familiäre Hyperbetalipoproteinämie mit Präbetalipoproteinämie",
      "Familiäre Hyperlipoproteinämie Typ III",
      "Floating-Betalipoproteinämie",
      "Gemischte Hyperlipidämie",
      "Gemischte Hyperlipoproteinämie",
      "HLP [Hyperlipoproteinämie] Typ III",
      "Hyperbetalipoproteinämie mit Präbetalipoproteinämie",
      "Hypercholesterinämie mit endogener Hyperglyzidämie",
      "Hypercholesterinämie mit endogener Hypertriglyzeridämie",
      "Hyperlipidämie C",
      "Hyperlipidämie Typ III nach Fredrickson",
      "Hyperlipidämie Typ IIb nach Fredrickson",
      "Hyperlipoproteinämie Typ III",
      "Hyperlipoproteinämie Typ IIb",
      "Kombinierte Hyperlipidämie",
      "Lipoproteinämie mit breiter Beta-Bande - s.a. Floating-Betalipoproteinämie",
      "Mixed Hyperlipidämie",
      "Multiple Xanthome der Haut",
      "Tuberoeruptives Xanthom",
      "Xanthom der Haut",
      "Xanthoma disseminatum",
      "Xanthoma disseminatum der Haut",
      "Xanthoma tuberosum"
    ]
  },
  {
    "code": "E78.3",
    "name": "Hyperchylomikronämie",
    "synonyms": [
      "Bürger-Grütz-Krankheit",
      "Bürger-Grütz-Syndrom",
      "Familiäre Hyperchylomikronämie",
      "Familiärer Apolipoprotein C-II-Mangel",
      "Familiärer Apolipoprotein-A-V-Mangel",
      "Familiärer GPIHBP1 [Glycosylphosphatidylinositol-verankertes High-Density-Lipoprotein-Bindungsprotein-1]-Mangel",
      "Familiärer LMF1 [Lipase-Reifungsfaktor 1]-Defekt",
      "Familiärer LMF1 [Lipase-Reifungsfaktor 1]-Mangel",
      "Familiärer Lipoprotein-Lipase-Mangel",
      "Familiäres Chylomikronämie-Syndrom",
      "Gemischte Hyperglyzeridämie",
      "Gemischte Hypertriglyzeridämie",
      "Hyperchylomikronämie",
      "Hyperchylomikronämie mit Hyperbetalipoproteinämie",
      "Hyperlipidämie D",
      "Hyperlipidämie Typ I nach Fredrickson",
      "Hyperlipidämie Typ V nach Fredrickson",
      "Hyperlipoproteinämie Typ I",
      "Hyperlipoproteinämie Typ I nach Fredrickson",
      "Hyperlipoproteinämie Typ V",
      "Hyperlipoproteinämie Typ V nach Fredrickson",
      "Lipoproteinlipase-Mangel",
      "Primäre Hyperchylomikronämie"
    ]
  },
  {
    "code": "E78.4",
    "name": "Familiäre Hyperlipidämie",
    "synonyms": [
      "CEPT [Cholesterin-Ester-Transfer-Protein]-Mangel",
      "Cholesterin-Ester-Transfer-Protein-Mangel",
      "Essentielle Hyperlipidämie",
      "Familiäre Hyperalphalipoproteinämie",
      "Familiäre Hyperlipidämie",
      "Familiäre kombinierte Hyperlipidämie",
      "Hyperlipidämie durch hepatischen Triglyceridlipase-Mangel"
    ]
  },
  {
    "code": "E78.5",
    "name": "Hyperlipidämie",
    "synonyms": [
      "Blutfetterhöhung",
      "Blutfettvermehrung",
      "Erhöhter Fettspiegel",
      "Hyperlipidämie",
      "Hyperlipidämische Xanthomatose",
      "Hyperlipoproteinämie",
      "Lipidämie",
      "Lipoidvermehrung",
      "Lipoidämie",
      "Lipoproteinämie",
      "Lipämie",
      "Post-Transplantations-Hyperlipidämie",
      "Xanthomatose bei Hyperlipidämie"
    ]
  },
  {
    "code": "E78.6",
    "name": "Akanthozytose",
    "synonyms": [
      "ATP-binding cassette-Transporter A1-Defekt",
      "Abetalipoproteinämie",
      "Akanthozytose",
      "Alphahypolipoproteinämie",
      "Analphalipoproteinämie",
      "Anderson-Krankheit",
      "Apo A-I-Mangel",
      "Apolipoprotein-A-I-Mangel",
      "Bassen-Kornzweig-Krankheit",
      "Bassen-Kornzweig-Syndrom",
      "Betahypolipoproteinämie",
      "Choreoakanthozytose",
      "Chylomikronen-Retentions-Krankheit",
      "Familiäre Analphalipoproteinämie",
      "Familiäre Hypobetalipoproteinämie",
      "Familiäre homozygote Hypobetalipoproteinämie",
      "Familiärer Apolipoprotein-A-I-Mangel",
      "Familiärer LCAT [Lecithin-Cholesterin-Acyltransferase]-Mangel",
      "Familiärer Lipoproteinmangel",
      "Fischaugen-Syndrom",
      "HDL [High-density-Lipoprotein]-Mangel",
      "High-density-Lipoprotein-Mangel",
      "Hypoalphalipoproteinämie",
      "Hypobetalipoproteinämie",
      "Hypolipoproteinämie",
      "Kompletter LCAT [Lecithin-Cholesterin-Acyltransferase]-Mangel",
      "LCAT [Lecithin-Cholesterin-Acyltransferase]-Mangel",
      "Lecithin-Cholesterin-Acyltransferase-Mangel",
      "Lipoproteinmangel",
      "Neuro-Akanthozytose-Syndrom McLeod",
      "Norum-Krankheit",
      "Partieller LCAT [Lecithin-Cholesterin-Acyltransferase]-Mangel",
      "Tangier-Krankheit",
      "Tangier-Syndrom"
    ]
  },
  {
    "code": "E78.80",
    "name": "Hyperlipoproteinämie (a)",
    "synonyms": [
      "Hyperlipoproteinämie (a)",
      "Lipoprotein(a)-Hyperlipoproteinämie"
    ]
  },
  {
    "code": "E78.88",
    "name": "Hyperlipoproteinurie",
    "synonyms": [
      "Generalisierte Lipogranulomatose",
      "Hyalinosis cutis et mucosae",
      "Hyperlipoproteinurie",
      "Infantile systemische Hyalinose",
      "Lipogranulomatose",
      "Lipoidproteinose",
      "Lipoyl-Transferase-2-Mangel",
      "Rambaud-Galian-Syndrom",
      "Roessle-Urbach-Wiethe-Syndrom",
      "Urbach-Lipoidproteinose",
      "Urbach-Wiethe-Krankheit",
      "Urbach-Wiethe-Syndrom"
    ]
  },
  {
    "code": "E78.9",
    "name": "Lipoproteinstoffwechselstörung",
    "synonyms": [
      "Angeborene Fettstoffwechselstörung",
      "Angeborene Lipidstoffwechselstörung",
      "Cholesterinstoffwechselstörung",
      "Dyslipidämie",
      "Fettstoffwechselstörung",
      "Lipidstoffwechselstörung",
      "Lipoproteinstoffwechselstörung"
    ]
  },
  {
    "code": "E79.0",
    "name": "Urikämie",
    "synonyms": [
      "Asymptomatische Hyperurikämie",
      "Asymptomatische Urikämie",
      "Harnsäureerhöhung",
      "Hyperurikämie",
      "Hyperurikämie ohne Zeichen von entzündlicher Arthritis oder tophischer Gicht",
      "Primäre familiäre Hyperurikämie",
      "Uratstoffwechselstörung",
      "Urikämie"
    ]
  },
  {
    "code": "E79.1",
    "name": "Lesch-Nyhan-Syndrom",
    "synonyms": [
      "HPRT [Hypoxanthin-Guanin-Phosphoribosyltransferase]-Mangel, Grad IV",
      "Hypoxanthin-Guanin-Phosphoribosyltransferase-Mangel, Grad IV",
      "Lesch-Nyhan-Syndrom"
    ]
  },
  {
    "code": "E79.8",
    "name": "Orotazidurie",
    "synonyms": [
      "AICA [5-Amino-4-Imidazolcarboxamid]-Ribosidurie",
      "Adenin-Phosphoribosyl-Transferasemangel",
      "Adenosinmonophosphat-Desaminase-Mangel",
      "Adenylosuccinase-Mangel",
      "Adenylosuccinat-Lyase-Mangel",
      "Arts-Syndrom",
      "Beta-Alanin-Synthase-Mangel",
      "Beta-Ureidopropionase-Mangel",
      "Dihydropyrimidin-Dehydrogenase-Mangel",
      "Dihydropyrimidinase-Mangel",
      "Dihydropyrimidinurie",
      "Enzymdefekt der Phosphoribosylpyrophosphat-Synthetase",
      "Enzymdefekt der Phosphoribosylpyrophosphat-Transferase",
      "Familiäre Pyrimidinämie",
      "HPRT [Hypoxanthin-Guanin-Phosphoribosyltransferase]-Mangel, Grad I",
      "HPRT [Hypoxanthin-Guanin-Phosphoribosyltransferase]-abhängige Hyperurikämie",
      "Hereditäre Orotazidurie",
      "Hereditäre Xanthinurie",
      "Hyperbetaalaninämie",
      "Kelley-Seegmiller-Syndrom",
      "Kombinierter Xanthin-Dehydrogenase- und Aldehydoxydase-Mangel",
      "Kongenitale Orotazidurie",
      "Letale Ataxie mit Schwerhörigkeit und Optikusatrophie",
      "Orotazidurie",
      "Orotidyl-Dekarboxylase-Mangel",
      "PRPP [Phosphoribosylpyrophosphat]-Synthetase-Überaktivität",
      "Partieller HPRT [Hypoxanthin-Guanin-Phosphoribosyltransferase]-Mangel",
      "Partieller Hypoxanthin-Guanin-Phosphoribosyltransferase-Mangel",
      "Phosphoribosylaminoimidazol-Carboxylase-Mangel",
      "Phosphoribosylpyrophosphat-Synthetase-Überaktivität",
      "Pyrimidinmangel",
      "Uridin-Monophosphat-Synthase-Mangel",
      "XDH [Xanthin-Dehydrogenase]-Mangel",
      "XO [Xanthin-Oxidase]-Mangel",
      "XOR [Xanthin-Oxidoreduktase]-Mangel",
      "Xanthinurie",
      "Xanthinurie Typ I",
      "Xanthinurie Typ II"
    ]
  },
  {
    "code": "E79.9",
    "name": "Purinstoffwechselstörung",
    "synonyms": [
      "Purinstoffwechselstörung",
      "Pyrimidinstoffwechselstörung"
    ]
  },
  {
    "code": "E80.0",
    "name": "Hereditäre erythropoetische Porphyrie",
    "synonyms": [
      "Angeborene erythropoetische Porphyrie",
      "CEP [Kongenitale erythropoetische Porphyrie]",
      "EPP [Erythropoetische Protoporphyrie]",
      "Erythropoetische Protoporphyrie",
      "Günther-Krankheit",
      "Günther-Syndrom",
      "Hereditäre erythropoetische Porphyrie",
      "X-chromosomal-dominante Protoporphyrie"
    ]
  },
  {
    "code": "E80.1",
    "name": "Porphyria cutanea tarda",
    "synonyms": [
      "PCT [Porphyria cutanea tarda]",
      "Porphyria cutanea tarda",
      "Porphyria hepatocutanea"
    ]
  },
  {
    "code": "E80.2",
    "name": "Hereditäre Koproporphyrie",
    "synonyms": [
      "Akute hepatische Porphyrie",
      "Akute intermittierende Porphyrie",
      "Akute intermittierende hepatische Porphyrie",
      "Doss-Porphyrie",
      "HEP [Hepatoerythropoetische Porphyrie]",
      "Hepatische Porphyrie",
      "Hepatoerythropoetische Porphyrie",
      "Hereditäre Koproporphyrie",
      "Porphyria",
      "Porphyria variegata",
      "Porphyrie",
      "Porphyrie beim Erwachsenen",
      "Porphyrie durch delta-Aminolävulinsäure-Dehydratase-Mangel",
      "Porphyrie-Syndrom",
      "Porphyrinkrankheit",
      "Porphyrinstoffwechselstörung",
      "Porphyrinurie",
      "Porphyrinurie-Syndrom",
      "Protoporphyrinogen-Oxidase-Mangel",
      "Schwedische Porphyrie",
      "Sekundäre Porphyrie",
      "Südafrikanische Porphyrie",
      "Toxische Porphyrie a.n.k."
    ]
  },
  {
    "code": "E80.3",
    "name": "Akatalasämie",
    "synonyms": [
      "Akatalasie",
      "Akatalasämie",
      "Katalase-Mangel",
      "Katalasedefekt",
      "Myeloperoxidase-Mangel",
      "Peroxidasedefekt",
      "Takahara-Krankheit",
      "Takahara-Syndrom"
    ]
  },
  {
    "code": "E80.4",
    "name": "Gilbert-Meulengracht-Syndrom",
    "synonyms": [
      "Cholaemia familiaris simplex",
      "Familiäre Cholämie",
      "Familiäre nichthämolytische Bilirubinämie",
      "Familiäre nichthämolytische Gelbsucht",
      "Familiärer nichthämolytischer Ikterus",
      "Gilbert-Cholämie",
      "Gilbert-Krankheit",
      "Gilbert-Meulengracht-Syndrom",
      "Icterus intermittens juvenilis",
      "Kongenitale Cholämie",
      "Meulengracht-Syndrom",
      "Morbus Meulengracht",
      "Neonatale Gelbsucht bei Gilbert-Lereboullet-Syndrom",
      "Neonatale Gelbsucht bei Gilbert-Meulengracht-Syndrom",
      "Neonataler Ikterus bei Gilbert-Lereboullet-Syndrom",
      "Neonataler Ikterus bei Gilbert-Meulengracht-Syndrom"
    ]
  },
  {
    "code": "E80.5",
    "name": "Crigler-Najjar-Syndrom",
    "synonyms": [
      "Arias-Syndrom",
      "Bilirubin-UDP [Uridindiphosphat]-Glucuronosyltransferase-Mangel Typ 1",
      "Bilirubin-UDP [Uridindiphosphat]-Glucuronosyltransferase-Mangel Typ 2",
      "Bilirubin-UGT [Uridindiphosphat-Glucuronosyltransferase]-Mangel Typ 1",
      "Bilirubin-UGT [Uridindiphosphat-Glucuronosyltransferase]-Mangel Typ 2",
      "Bilirubin-UGT-Mangel",
      "Bilirubin-Uridindiphosphat-Glucuronosyltransferase-Mangel",
      "Crigler-Najjar-Krankheit",
      "Crigler-Najjar-Syndrom",
      "Crigler-Najjar-Syndrom Typ 1",
      "Crigler-Najjar-Syndrom Typ 2",
      "Familiär unkonjugierte Hyperbilirubinämie",
      "Glucuronyltransferasemangel",
      "Hereditäre unkonjugierte Hyperbilirubinämie Typ 1",
      "Hereditäre unkonjugierte Hyperbilirubinämie Typ 2",
      "Kongenitale familiäre nichthämolytische Gelbsucht",
      "Kongenitaler familiärer nichthämolytischer Ikterus",
      "Neonatale Gelbsucht durch Crigler-Najjar-Syndrom",
      "Neonataler Ikterus durch Crigler-Najjar-Syndrom"
    ]
  },
  {
    "code": "E80.6",
    "name": "Rotor-Syndrom",
    "synonyms": [
      "Bilirubinausscheidungsdefekt a.n.k.",
      "Bilirubinausscheidungsstörung",
      "Dubin-Johnson-Ikterus",
      "Dubin-Johnson-Krankheit",
      "Dubin-Johnson-Syndrom",
      "Dubin-Sprinz-Ikterus",
      "Dubin-Sprinz-Syndrom",
      "Familiär konjugierte Hyperbilirubinämie",
      "Hereditäre Hyperbilirubinämie",
      "Hyperbilirubinämie Typ 2",
      "Hyperbilirubinämie vom Typ Rotor",
      "Konstitutionelle Hyperbilirubinämie",
      "Konstitutioneller nichthämolytischer Ikterus mit lipochromer Hepatose",
      "Rotor-Krankheit",
      "Rotor-Syndrom"
    ]
  },
  {
    "code": "E80.7",
    "name": "Bilirubinstoffwechselstörung",
    "synonyms": [
      "Bilirubinstoffwechselstörung"
    ]
  },
  {
    "code": "E83.0",
    "name": "Morbus Wilson",
    "synonyms": [
      "Amyostatisches Syndrom",
      "Benigner familiärer Kupfermangel",
      "Coeruloplasminmangel",
      "Hepatolentikuläre Degeneration",
      "Kinky hair disease",
      "Kinky-hair-Krankheit",
      "Kinky-hair-Syndrom - s.a. Menkes-II-Syndrom",
      "Kraushaarsyndrom",
      "Kupferstoffwechselstörung",
      "Menkes-II-Krankheit [Kupferstoffwechselstörung]",
      "Menkes-II-Syndrom [Kupferstoffwechselstörung]",
      "Menkes-Stahlhaarkrankheit",
      "Morbus Wilson",
      "Okzipitalhorn-Syndrom",
      "Progressive Linsenkerndegeneration",
      "Progressive lentikuläre Degeneration",
      "Progressives Lentikulärsyndrom",
      "Steely-hair-Syndrom - s.a. Menkes-II-Syndrom",
      "Störung des Kupferstoffwechsels",
      "Trichopoliodystrophie - s.a. Menkes-II-Syndrom",
      "Wilson-I-Syndrom",
      "Wilson-Krankheit [Hepatolentikuläre Degeneration]",
      "Wilson-Linsenkerndegeneration",
      "X-chromosomaler Kupfer-Mangel"
    ]
  },
  {
    "code": "E83.1",
    "name": "Eisenstoffwechselstörung",
    "synonyms": [
      "Afrikanische Eisenüberladung",
      "Autosomal-dominante Hämochromatose",
      "Autosomal-dominante hereditäre Hämochromatose",
      "Bantu-Siderose",
      "Bronzediabetes",
      "Diätetische Hämosiderose",
      "Eisenspeicherungskrankheit",
      "Eisenstoffwechselkrankheit",
      "Eisenstoffwechselstörung",
      "Eisenverwertungsstörung",
      "Ferroportin-Krankheit",
      "Hanot-Chauffard-Syndrom",
      "Hereditäre Hämochromatose",
      "Hämochromatose",
      "Hämochromatose Typ 2",
      "Hämochromatose Typ 3",
      "Hämochromatose Typ 4",
      "Hämochromatose Typ 5",
      "Hämochromatose durch Ferroportin-Defekt",
      "Hämochromatose mit Diabetes",
      "Hämosiderinablagerung",
      "Hämosiderinspeicherung",
      "Hämosiderose",
      "Juvenile Hämochromatose",
      "L-Ferritin-Mangel",
      "Neonatale Hämochromatose",
      "Pigmentzirrhose der Leber",
      "Plasmahämosiderose",
      "Primär idiopathische Hämochromatose",
      "Pseudohämorrhagische Anämie",
      "SLC40A1-assoziierte Hämochromatose",
      "Sekundäre Hämochromatose",
      "Seltene hereditäre Hämochromatose",
      "Siderophilie",
      "Störung des Eisenstoffwechsels",
      "Symptomatische Hämochromatose Typ 1",
      "TFR2-Gen-assoziierte Hämochromatose",
      "Troisier-Hanot-Chauffard-Syndrom",
      "Von-Recklinghausen-Applebaum-Syndrom"
    ]
  },
  {
    "code": "E83.2",
    "name": "Zinkstoffwechselstörung",
    "synonyms": [
      "Akrodermatitis enteropathica",
      "Brandt-Syndrom",
      "Danbolt-Syndrom",
      "Störung des Zinkstoffwechsels",
      "Syndrom der Hyperzinkämie und Hypercalprotectinämie",
      "Zinkstoffwechselstörung"
    ]
  },
  {
    "code": "E83.30",
    "name": "Hypophosphatämie",
    "synonyms": [
      "Autosomal-dominante hypophosphatämische Rachitis",
      "Autosomal-rezessive hypophosphatämische Rachitis",
      "Familiäre Hypophosphatämie",
      "Familiäre hypophosphatämische Rachitis",
      "Hypophosphatämie",
      "Kongenitale Hypophosphatämie",
      "Phosphat-Diabetes",
      "X-chromosomale Hypophosphatämie"
    ]
  },
  {
    "code": "E83.31",
    "name": "Vitamin-D-abhängige Rachitis",
    "synonyms": [
      "25-Hydroxyvitamin-D1-Alpha-Hydroxylase-Mangel",
      "Hypokalzämische Vitamin-D-abhängige Rachitis",
      "Pseudovitamin-D-Mangel",
      "Vitamin-D-Rezeptorstörung [Typ II]",
      "Vitamin-D-Synthesestörung [Typ I]",
      "Vitamin-D-abhängige Rachitis"
    ]
  },
  {
    "code": "E83.38",
    "name": "Hyperphosphatämie",
    "synonyms": [
      "Adulte Hypophosphatasie",
      "Erworbene Hypophosphatasie",
      "Erworbene Hypophosphatämie",
      "Familiäre Hypophosphatasie",
      "Familiäre hyperphosphatämische tumorale Kalzinose",
      "Familiäre normophosphatämische tumorale Kalzinose",
      "Familiäre tumorale Kalzinose",
      "Hyperphosphaturie",
      "Hyperphosphatämie",
      "Hypophosphatasie",
      "Hypophosphatasie mit Beginn im Kindesalter",
      "Infantile Hypophosphatasie",
      "Kongenitale Hypophosphatasie",
      "Mabry-Syndrom",
      "Phosphat-Stau",
      "Phosphaturie",
      "Phosphatämie",
      "Phosphoethanolaminurie",
      "Rathbun-Syndrom",
      "Renale Hypophosphatämie",
      "Saure-Phosphatase-Mangel",
      "Sekundäres Fanconi-Syndrom",
      "Tumorrachitis"
    ]
  },
  {
    "code": "E83.39",
    "name": "Phosphatstoffwechselstörung",
    "synonyms": [
      "Phosphatstoffwechselstörung",
      "Störung des Phosphatasestoffwechsels"
    ]
  },
  {
    "code": "E83.4",
    "name": "Magnesiumstoffwechselstörung",
    "synonyms": [
      "Autosomal-dominante isolierte Hypomagnesiämie",
      "Autosomal-dominante isolierte Hypomagnesiämie Typ Glaudemans",
      "Autosomal-dominante primäre Hypomagnesiämie mit Hypokalziurie",
      "Familiäre Hypomagnesiämie mit Hyperkalziurie und Nephrokalzinose ohne schwere Augenbeteiligung",
      "Familiäre Hypomagnesiämie mit Hyperkalziurie und Nephrokalzinose, mit schwerer Augenbeteiligung",
      "Familiäre primäre Hypomagnesiämie",
      "Familiäre primäre Hypomagnesiämie mit Normokalziurie und Normokalzämie",
      "HSH [Hypomagnesiämie mit sekundärer Hypokalzämie]",
      "Hypermagnesiämie",
      "Hypomagnesiämie",
      "Hypomagnesiämie durch selektive Magnesiumaufnahme",
      "Intestinale Hypomagnesiämie Typ 1",
      "Intestinale Hypomagnesiämie mit sekundärer Hypokalzämie",
      "Isolierter Magnesiumverlust der Nieren",
      "Magnesiummangelsyndrom",
      "Magnesiumstoffwechselstörung",
      "Meier-Blumberg-Imahorn-Syndrom",
      "Primäre Hypomagnesiämie mit refraktären Anfällen und Intelligenzminderung",
      "Primäre Hypomagnesiämie mit sekundärer Hypokalzämie",
      "Renale Hypomagnesiämie Typ 2",
      "Renale Hypomagnesiämie Typ 3",
      "Renale Hypomagnesiämie Typ 4"
    ]
  },
  {
    "code": "E83.50",
    "name": "Kalziphylaxie",
    "synonyms": [
      "CUA [Kalzifizierende urämische Arteriolopathie]",
      "Calciphylaxie",
      "Kalzifizierende urämische Arteriolopathie",
      "Kalziphylaxie"
    ]
  },
  {
    "code": "E83.58",
    "name": "Idiopathische infantile Hyperkalzämie",
    "synonyms": [
      "Autosomal-rezessive infantile Hyperkalzämie",
      "Burnett-Syndrom",
      "Calcinosis - s.a. Kalzinose",
      "Calcinosis interstitialis",
      "Diätetische Hyperkalzämie",
      "Familiäre Hyperkalzämie",
      "Familiäre benigne Hyperkalzämie",
      "Familiäre benigne hypokalziurische Hyperkalzämie",
      "Familiäre hypokalziurische Hyperkalzämie",
      "Generalisierte Kalzifikation",
      "Generalisierte Kalzinose",
      "Hyperkalziurie",
      "Hyperkalziämische Krise",
      "Hyperkalzämie",
      "Hypokalziämie durch Störung des Kalziumstoffwechsels",
      "Hypokalzämie",
      "Idiopathische Hyperkalziurie",
      "Idiopathische infantile Hyperkalzämie",
      "Kalzinose",
      "Kalziumverlust",
      "Metastatische Kalzifikation",
      "Milch-Alkali-Syndrom",
      "Milchtrinkersyndrom",
      "Tumoröse Kalzinose"
    ]
  },
  {
    "code": "E83.59",
    "name": "Kalziumstoffwechselstörung",
    "synonyms": [
      "Kalziumstoffwechselstörung"
    ]
  },
  {
    "code": "E83.8",
    "name": "Dystonie-Parkinsonismus-Hypermanganämie-Syndrom",
    "synonyms": [
      "Dystonie-Parkinsonismus-Hypermanganämie-Syndrom",
      "Zirrhose-Dystonie-Polyzythämie-Hypermanganämie-Syndrom"
    ]
  },
  {
    "code": "E83.9",
    "name": "Mineralstoffwechselstörung",
    "synonyms": [
      "Mineralstoffwechselstörung"
    ]
  },
  {
    "code": "E84.0",
    "name": "Zystische Fibrose mit Lungenmanifestation",
    "synonyms": [
      "Fibrozystische Lungenkrankheit",
      "Zystische Fibrose mit Lungenmanifestation"
    ]
  },
  {
    "code": "E84.1",
    "name": "Zystische Fibrose mit Darmmanifestation",
    "synonyms": [
      "Distales intestinales Obstruktionssyndrom",
      "Zystische Fibrose mit Darmmanifestation",
      "Zystische Fibrose mit Manifestation am Verdauungstrakt"
    ]
  },
  {
    "code": "E84.80",
    "name": "Zystische Fibrose mit Manifestationen an der Lunge und am Verdauungstrakt",
    "synonyms": [
      "Zystische Fibrose mit Manifestationen an der Lunge und am Verdauungstrakt"
    ]
  },
  {
    "code": "E84.87",
    "name": "Zystische Fibrose mit sonstigen multiplen Manifestationen",
    "synonyms": [
      "Zystische Fibrose mit sonstigen multiplen Manifestationen"
    ]
  },
  {
    "code": "E84.88",
    "name": "Neonatale Gelbsucht bei Mukoviszidose",
    "synonyms": [
      "Neonatale Gelbsucht bei Mukoviszidose",
      "Neonatale hepatobiliäre Erkrankung bei Mukoviszidose",
      "Neonataler Ikterus bei Mukoviszidose"
    ]
  },
  {
    "code": "E84.9",
    "name": "Mukoviszidose",
    "synonyms": [
      "CF [Fibrosis cystica] - s.a. Zystische Fibrose oder s.a. Cystische Fibrose oder s.a. Mukoviszidose",
      "Clarke-Hadfield-Syndrom [Mukoviszidose]",
      "Familiäre kongenitale zystische Fibrose",
      "Fanconi-Andersen-Syndrom [Mukoviszidose]",
      "Fibrozystische Krankheit",
      "Landsteiner-Fanconi-Andersen-Syndrom [Mukoviszidose]",
      "Mukoviszidose",
      "Zystische Fibrose"
    ]
  },
  {
    "code": "E85.0",
    "name": "Nichtneuropathische heredofamiliäre Amyloidose",
    "synonyms": [
      "AApoA-I [Apolipoprotein-A-I-Amyloidose]",
      "Apolipoprotein-A-I-Amyloidose",
      "Benigne paroxysmale Peritonitis",
      "Benigne rekurrierende Polyserositis",
      "FMF [Familiäres Mittelmeer-Fieber]",
      "Familiäre Form der paroxysmalen Polyserositis",
      "Familiäres Mittelmeer-Fieber",
      "LECT2 [Leukozyten-chemotaktischer-Faktor 2]-Amyloidose",
      "Nichtneuropathische heredofamiliäre Amyloidose",
      "Paroxysmal familiäre Peritonitis",
      "Paroxysmale familiäre benigne Peritonitis",
      "Periodische Polyserositis",
      "Periodische familiäre Peritonitis",
      "Periodisches Mittelmeer-Fieber",
      "TNF-Rezeptor-1-assoziiertes periodisches Fieber-Syndrom",
      "TRAPS [Tumornekrosefaktor-Rezeptor-1-assoziiertes periodisches Syndrom]",
      "Tumornekrosefaktor-Rezeptor-1-assoziiertes periodisches Fieber-Syndrom"
    ]
  },
  {
    "code": "E85.1",
    "name": "Neuropathische heredofamiliäre Amyloidose",
    "synonyms": [
      "Amyloidose durch ABeta2M-Variante",
      "Amyloidose vom portugiesischen Typ",
      "Hereditäre Amyloidose vom finnischen Typ",
      "Neuropathische heredofamiliäre Amyloidose"
    ]
  },
  {
    "code": "E85.2",
    "name": "Heredofamiliäre Amyloidose",
    "synonyms": [
      "Familiäre Amyloidose",
      "Genetische Amyloidose",
      "Hereditäre Transthyretin-Amyloidose",
      "Heredofamiliäre Amyloidose",
      "Primäre systemische Amyloidose",
      "h-ATTR [Hereditäre Transthyretin-Amyloidose]"
    ]
  },
  {
    "code": "E85.3",
    "name": "Sekundäre systemische Amyloidose",
    "synonyms": [
      "AA-Amyloidose",
      "Amyloidose bei Hämodialyse",
      "Beta-2-Mikroglobulin-Amyloidose",
      "Sekundäre Amyloidose",
      "Sekundäre Amyloidose bei Hämodialyse",
      "Sekundäre systemische Amyloidose"
    ]
  },
  {
    "code": "E85.4",
    "name": "Organbegrenzte Amyloidose",
    "synonyms": [
      "Gefäßamyloidose",
      "Gefäßwandamyloidose",
      "Hypophysenamyloidose",
      "Lidamyloidose",
      "Lokalisierte AL-Amyloidose",
      "Lokalisierte Amyloidose",
      "Lokalisierte amyloide Infiltration",
      "Nebennierenamyloidose",
      "Nebenschilddrüsenamyloidose",
      "Organbegrenzte Amyloidose",
      "Parathyreoideaamyloidose",
      "Primäre hereditäre Hornhautamyloidose",
      "Pulmonalarterienamyloidose",
      "Pulpaamyloidose",
      "Schilddrüsenamyloidose",
      "Thymusamyloidose"
    ]
  },
  {
    "code": "E85.8",
    "name": "Altersamyloidose",
    "synonyms": [
      "Altersamyloidose",
      "Apolipoprotein-A-IV-Amyloidose",
      "Lubarsch-Pick-Syndrom",
      "Paraamyloidablagerung",
      "Paraamyloidose",
      "Senile systemische Amyloidose",
      "Systemische Prionprotein-Amyloidose",
      "Wildtyp-Transthyretin-Amyloidose",
      "wt-ATTR [Wildtyp-Transthyretin-Amyloidose]"
    ]
  },
  {
    "code": "E85.9",
    "name": "Amyloidablagerung",
    "synonyms": [
      "AH [heavy chain amyloid]-Amyloidose",
      "AL-Amyloidose",
      "Amyloidablagerung",
      "Amyloide Degeneration",
      "Amyloidose",
      "Begleitamyloidose",
      "Generalisierte Amyloidose",
      "Generalisiertes amyloides Infiltrat",
      "Leichtkettenamyloidose",
      "Primäre Amyloidose"
    ]
  },
  {
    "code": "E86",
    "name": "Anhydrämie",
    "synonyms": [
      "Anhydratation",
      "Anhydration",
      "Anhydrämie",
      "Austrocknung",
      "Blutvolumenverringerung",
      "Dehydratation",
      "Dehydration",
      "Depletion der extrazellulären Flüssigkeit",
      "Depletion des Plasmavolumens",
      "Exsikkose",
      "Flüssigkeitsverlust",
      "Hypohydratation",
      "Hypotone Dehydratation",
      "Hypovolämie",
      "Plasmavolumenverringerung",
      "Verringerung der extrazellulären Flüssigkeit",
      "Volumenmangel",
      "Wasserverlust"
    ]
  },
  {
    "code": "E87.0",
    "name": "Hypernatriämie",
    "synonyms": [
      "Hypernatriämie",
      "Hyperosmolalität",
      "Hypersalämie",
      "Natriumvermehrung",
      "Natriumüberschuss",
      "Salzödem"
    ]
  },
  {
    "code": "E87.1",
    "name": "Salzmangel",
    "synonyms": [
      "Dysäquilibrium-Syndrom bei Dialyse",
      "Hyponatriämie",
      "Hyponatriämie-Syndrom",
      "Hypoosmolalität",
      "Hypoosmolares Koma",
      "Krampf durch Salzverlust",
      "Natriummangel",
      "Natriumverarmung",
      "Natriumverlust",
      "Salzmangel",
      "Salzmangel-Syndrom",
      "Salzverarmung",
      "Salzverlust-Syndrom",
      "Verminderung des Natriumgehaltes",
      "Verminderung des Salzgehaltes"
    ]
  },
  {
    "code": "E87.2",
    "name": "Azidose",
    "synonyms": [
      "Alkoholbedingte Azidose",
      "Alkoholische Ketoazidose",
      "Azidose",
      "Azidämie",
      "Ketoazidose a.n.k.",
      "Ketoazidotische Entgleisung",
      "Kussmaul-Atmung",
      "Laktatazidose",
      "Metabolische Azidose a.n.k.",
      "Respiratorische Azidose",
      "Schwergradige neonatale Laktatazidose durch NFS1-ISD11-Komplex-Mangel"
    ]
  },
  {
    "code": "E87.3",
    "name": "Alkalose",
    "synonyms": [
      "Alkaliämie",
      "Alkalose",
      "Metabolische Alkalose",
      "Respiratorische Alkalose",
      "Tetanie bei Alkalose"
    ]
  },
  {
    "code": "E87.4",
    "name": "Gemischte Störung des Säure-Basen-Gleichgewichts",
    "synonyms": [
      "Abnormes Säure-Basen-Gleichgewicht",
      "Gemischte Störung des Säure-Basen-Gleichgewichts"
    ]
  },
  {
    "code": "E87.5",
    "name": "Hyperkaliämie",
    "synonyms": [
      "Hyperkaliämie",
      "Hyperkaliämie-Syndrom",
      "Hyperpotassämie",
      "Kaliumintoxikationssyndrom",
      "Kaliumvergiftungssyndrom",
      "Kaliumvermehrung",
      "Kaliumüberschuss"
    ]
  },
  {
    "code": "E87.6",
    "name": "Hypokaliämie",
    "synonyms": [
      "Hypokaliämie",
      "Hypokaliämie-Syndrom",
      "Kalium-Verlustsyndrom",
      "Kaliummangel",
      "Kaliumverarmung",
      "Verminderung des Kaliumgehaltes des Blutes"
    ]
  },
  {
    "code": "E87.7",
    "name": "Hypotone Hyperhydratation",
    "synonyms": [
      "Flüssigkeitsüberlastung",
      "Flüssigkeitsüberschuss",
      "Hyperhydratation",
      "Hypervolämie",
      "Hypotone Hyperhydratation",
      "Verdünnungshyponatriämie",
      "Wasserintoxikation",
      "Wasservergiftung"
    ]
  },
  {
    "code": "E87.8",
    "name": "Elektrolytstörung mit Flüssigkeitsstörung",
    "synonyms": [
      "Abnormer Elektrolythaushalt",
      "Chloropenie",
      "Elektrolytentgleisung",
      "Elektrolytmangel",
      "Elektrolytstoffwechselstörung",
      "Elektrolytstörung",
      "Elektrolytstörung mit Flüssigkeitsstörung",
      "Elektrolytverschiebung",
      "Gestörter Elektrolythaushalt",
      "Gestörtes Gleichgewicht des Elektrolythaushaltes",
      "Hyperchlorämie",
      "Hyperelektrolytämie",
      "Hypochlorämie",
      "Kaliumstoffwechselstörung",
      "Natriumstoffwechselstörung a.n.k.",
      "Natriurese",
      "RFS [Refeeding-Syndrom]",
      "Refeeding-Syndrom",
      "Störung des Elektrolytgleichgewichtes",
      "Störung des Elektrolythaushaltes",
      "Störung im Wasserhaushalt"
    ]
  },
  {
    "code": "E88.0",
    "name": "Paraalbuminämie",
    "synonyms": [
      "A1-PI [Alpha-1-Proteinase-Inhibitor]-Mangel",
      "AATM [Alpha-1-Antitrypsinmangel]",
      "Abnormes Transportprotein",
      "Alpha-1-Antichymotrypsin-Mangel",
      "Alpha-1-Antitrypsinmangel",
      "Alpha-1-Proteinase-Inhibitor-Mangel",
      "Analbuminämie",
      "Atransferrinämie",
      "Bisalbuminämie",
      "Doppelalbuminämie",
      "Enzymmangel",
      "Familiärer Antitrypsinmangel",
      "Fehlen von Albumin im Blut",
      "Hypoalbuminämie",
      "Inversion des Albumin-Globulin-Verhältnis",
      "Kongenitale Analbuminämie",
      "Kongenitale Atransferrinämie",
      "Laurell-Eriksson-Syndrom",
      "Mangel an zirkulierenden Enzymen a.n.k.",
      "Paraalbuminämie",
      "Plasmaproteinstoffwechselstörung",
      "Proteintransportanomalie",
      "Pseudocholinesterasemangel",
      "Pyroglobulinämie a.n.k."
    ]
  },
  {
    "code": "E88.1",
    "name": "Lipodystrophie",
    "synonyms": [
      "Barraquer-Simons-Krankheit",
      "Barraquer-Simons-Syndrom",
      "Berardinelli-Seip-Syndrom",
      "CIDEC-Gen-assoziierte familiäre partielle Lipodystrophie",
      "Druck-induzierte lokale Lipodystrophie",
      "Erworbene generalisierte Lipodystrophie",
      "Erworbene partielle Lipodystrophie",
      "Familiäre partielle Lipodystrophie",
      "Familiäre partielle Lipodystrophie Typ Köbberling",
      "Familiäre partielle Lipodystrophie durch AKT2-Genmutation",
      "Familiäre partielle Lipodystrophie durch LIPE-Genmutation",
      "Familiäre partielle Lipodystrophie durch PLIN1-Genmutation",
      "Familiäre partielle Lipodystrophie durch PPARG-Genmutation",
      "Familiäre partielle Lipodystrophie vom Typ Dunnigan",
      "Generalisierte kongenitale Lipodystrophie Typ 4",
      "Generalisierte kongenitale Lipodystrophie mit Muskeldystrophie",
      "Idiopathische lokalisierte Lipodystrophie",
      "Keppen-Lubinsky-Syndrom",
      "Lawrence-Syndrom",
      "Lipoatrophie",
      "Lipodystrophia",
      "Lipodystrophia centrifugalis abdominalis infantilis",
      "Lipodystrophie",
      "Lipodystrophie durch kombinierten Mangel an Insulin, IGF1 [Insulin-ähnlicher Wachstumsfaktor 1] und EGF [Epidermaler Wachstumsfaktor]",
      "Marfanoides und progeroides Lipodystrophie-Syndrom",
      "Medikamenten-induzierte lokale Lipodystrophie",
      "Pannikulitis-induzierte lokalisierte Lipodystrophie",
      "Progressive cephalo-thorakale Lipodystrophie",
      "Simons-Krankheit",
      "Simons-Syndrom"
    ]
  },
  {
    "code": "E88.20",
    "name": "Lipödem, Stadium I",
    "synonyms": [
      "Lipödem, Stadium I"
    ]
  },
  {
    "code": "E88.21",
    "name": "Lipödem, Stadium II",
    "synonyms": [
      "Lipödem, Stadium II"
    ]
  },
  {
    "code": "E88.22",
    "name": "Lipödem, Stadium III",
    "synonyms": [
      "Lipödem, Stadium III"
    ]
  },
  {
    "code": "E88.28",
    "name": "Lipödem",
    "synonyms": [
      "Lipödem"
    ]
  },
  {
    "code": "E88.29",
    "name": "Mammalipomatose",
    "synonyms": [
      "Adipositas dolorosa",
      "Dercum-Krankheit",
      "Dercum-Lipomatose",
      "Dercum-Syndrom",
      "Enzephalokraniokutane Lipomatose",
      "Epidurale Lipomatose",
      "Epikardiale Lipomatose",
      "Familiäre multiple Lipomatose",
      "Fettdurchwachsung",
      "Fettgewebsdurchwachsung",
      "Fettgewebseinlagerung",
      "Haberland-Syndrom",
      "Hiluslipomatose",
      "Lipohypertrophie",
      "Lipomatose",
      "Lipomatosis",
      "Lipomatosis dolorosa",
      "Mammalipomatose",
      "Mediastinale Lipomatose",
      "Mesosomatische Lipomatose vom Roch-Leri-Typ",
      "Multiple Lipomatose",
      "Neurolipomatose",
      "Nierenbeckenlipomatose",
      "Pankreaslipomatose"
    ]
  },
  {
    "code": "E88.3",
    "name": "Tumorlyse-Syndrom",
    "synonyms": [
      "Tumorlyse nach zytostatischer Therapie bei Neoplasie",
      "Tumorlyse-Syndrom"
    ]
  },
  {
    "code": "E88.8",
    "name": "Madelung-Syndrom",
    "synonyms": [
      "Adenolipomatose",
      "Angeborener TPMT(Thiopurinmethyltransferase)-Mangel",
      "Angeborener Thiopurinmethyltransferase-Mangel",
      "Autosomal-rezessive extraorale Halitosis durch Methanethioloxidase-Defizienz",
      "Benigne symmetrische Lipomatose",
      "Enzephalopathie mit hypertropher Kardiomyopathie und renal-tubulärer Störung",
      "Fischgeruch-Syndrom",
      "Fumarazidurie",
      "GPAA1-assoziierter Biosynthesedefekt",
      "GRACILE-Syndrom [Growth restriction, Aminoaciduria, Cholestasis, Iron overload, Lactic acidosis, Early death]",
      "Hämoxygenase-1-Mangel",
      "Idiopathische Hoffa-Kastert-Krankheit",
      "Ketoazidose durch Monocarboxylat-Transporter-1-Mangel",
      "Ketose",
      "Kombinierte Störung der oxidativen Phosphorylierung",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 26",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 30",
      "Kombinierter OXPHOS [oxidative Phosphorylierung]-Defekt",
      "LTC4 [Leukotrien-C4]-Synthase-Mangel",
      "Launois-Bensaude-Adenolipomatose",
      "Liponsäure-Synthase-Mangel",
      "Liposynovitis praepatellaris",
      "Lipoyltransferase-1-Mangel",
      "Madelung-Fetthals",
      "Madelung-Syndrom",
      "Metabolisches Syndrom",
      "Mevalonazidurie",
      "Mitochondriopathie durch Defekt der mitochondrialen Proteinsynthese",
      "Oxoglutarazidurie",
      "Schwere primäre Trimethylaminurie",
      "Steatosis",
      "Syndrom der juvenilen Katarakt mit Mikrokornea und renaler Glukosurie",
      "Syndrom der neurologischen Entwicklungsverzögerung mit Krampfanfällen, Augenanomalien, Osteopenie und zerebellärer Atrophie",
      "Tetrahydrobiopterin-Mangel",
      "Trimethylaminurie",
      "Vollständiger Mevalonatkinase-Mangel",
      "X-chromosomaler Kreatin-Transporter-Mangel"
    ]
  },
  {
    "code": "E88.9",
    "name": "Stoffwechselstörung",
    "synonyms": [
      "Allgemeine Stoffwechselstörung",
      "Angeborene Enzymopathie",
      "Angeborene Stoffwechselstörung",
      "Dekompensierte Stoffwechsellage",
      "Metabolische Erkrankung",
      "Metabolische Krankheit",
      "Stoffwechselentgleisung",
      "Stoffwechselkrankheit",
      "Stoffwechselstörung",
      "Stoffwechselversagen"
    ]
  },
  {
    "code": "E89.0",
    "name": "Hypothyreose nach medizinischen Maßnahmen",
    "synonyms": [
      "Erworbenes Fehlen der Schilddrüse",
      "Erworbenes Fehlen der Thyreoidea",
      "Hypothyreoidismus nach Bestrahlung",
      "Hypothyreoidismus nach Operation",
      "Hypothyreoidismus nach medizinischen Maßnahmen",
      "Hypothyreose nach Bestrahlung",
      "Hypothyreose nach Strumektomie",
      "Hypothyreose nach Thyreoidektomie",
      "Hypothyreose nach medizinischen Maßnahmen",
      "Postoperative Hypothyreose",
      "Postoperativer Hypothyreoidismus",
      "Status nach Thyreoidektomie mit Hypothyreose"
    ]
  },
  {
    "code": "E89.1",
    "name": "Hypoinsulinämie nach medizinischen Maßnahmen",
    "synonyms": [
      "Hyperglykämie nach Pankreatektomie",
      "Hypoinsulinämie nach Pankreatektomie",
      "Hypoinsulinämie nach medizinischen Maßnahmen",
      "Postoperative Hypoinsulinämie",
      "Postoperativer Insulinmangel"
    ]
  },
  {
    "code": "E89.2",
    "name": "Hypoparathyreoidismus nach medizinischen Maßnahmen",
    "synonyms": [
      "Erworbenes Fehlen der Nebenschilddrüse",
      "Hypoparathyreoidismus nach Parathyreoidektomie",
      "Hypoparathyreoidismus nach medizinischen Maßnahmen",
      "Parathyreoprive Tetanie",
      "Postoperative Tetanie",
      "Tetanie nach Entfernung der Nebenschilddrüse",
      "Tetanie nach Thyreoidektomie"
    ]
  },
  {
    "code": "E89.3",
    "name": "Hypopituitarismus nach medizinischen Maßnahmen",
    "synonyms": [
      "Erworbenes Fehlen der Hypophyse",
      "Hypopituitarismus nach Hypophysektomie",
      "Hypopituitarismus nach Strahlentherapie",
      "Hypopituitarismus nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "E89.4",
    "name": "Ovarialinsuffizienz nach medizinischen Maßnahmen",
    "synonyms": [
      "Iatrogenes Ovarversagen",
      "Ovarialinsuffizienz nach chirurgischem Eingriff",
      "Ovarialinsuffizienz nach medizinischen Maßnahmen",
      "Ovarversagen nach medizinischen Maßnahmen",
      "Postablatives Nachlassen der Ovarfunktion"
    ]
  },
  {
    "code": "E89.5",
    "name": "Testikuläre Unterfunktion nach medizinischen Maßnahmen",
    "synonyms": [
      "Postablative testikuläre Unterfunktion",
      "Testikuläre Unterfunktion nach chirurgischem Eingriff",
      "Testikuläre Unterfunktion nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "E89.6",
    "name": "Nebennierenrinden- und Nebennierenmarkunterfunktion nach medizinischen Maßnahmen",
    "synonyms": [
      "Erworbenes Fehlen der Nebenniere",
      "Nebennierenrinden- und Nebennierenmarkunterfunktion nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "E89.9",
    "name": "Erworbenes Fehlen einer endokrinen Drüse a.n.k.",
    "synonyms": [
      "Endokrine Komplikation nach chirurgischem Eingriff",
      "Endokrine Komplikation nach medizinischen Maßnahmen",
      "Endokrine Störung nach medizinischen Maßnahmen",
      "Erworbenes Fehlen einer endokrinen Drüse a.n.k.",
      "Postoperative endokrine Komplikation",
      "Stoffwechselkomplikation nach chirurgischem Eingriff",
      "Stoffwechselkomplikation nach medizinischen Maßnahmen",
      "Stoffwechselstörung nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "F01.0",
    "name": "Vaskuläre Demenz mit akutem Beginn",
    "synonyms": [
      "Vaskuläre Demenz mit akutem Beginn"
    ]
  },
  {
    "code": "F01.1",
    "name": "Multiinfarktdemenz",
    "synonyms": [
      "Multiinfarktdemenz",
      "Vorwiegend kortikale Demenz"
    ]
  },
  {
    "code": "F01.2",
    "name": "Subkortikale vaskuläre Demenz",
    "synonyms": [
      "Binswanger-Demenz",
      "Subkortikale vaskuläre Demenz"
    ]
  },
  {
    "code": "F01.3",
    "name": "Gemischte kortikale und subkortikale vaskuläre Demenz",
    "synonyms": [
      "Gemischte kortikale und subkortikale vaskuläre Demenz"
    ]
  },
  {
    "code": "F01.9",
    "name": "Vaskuläre Demenz",
    "synonyms": [
      "Arteriosklerotische Demenz",
      "Atherosklerotische Demenz",
      "Demenz bei zerebraler Gefäßstörung",
      "Organische Psychose durch Arteriosklerose",
      "Organische Psychose durch zerebrovaskuläre Ischämie",
      "Vaskuläre Demenz",
      "Zerebrale Durchblutungsstörung vom Demenztyp",
      "Zerebrale Sklerose mit Verwirrtheit",
      "Zerebrale arteriosklerotische Demenz",
      "Zerebrale arteriosklerotische Psychose",
      "Zerebrale sklerotische Demenz",
      "Zerebrovaskuläre Demenz"
    ]
  },
  {
    "code": "F03",
    "name": "Demenz",
    "synonyms": [
      "Altersdemenz",
      "Alterspsychose",
      "Altersschwachsinn",
      "Altersschwäche mit Psychose",
      "Altersschwäche mit geistiger Veränderung a.n.k.",
      "Altersverwirrtheit",
      "Dementia",
      "Dementia senilis",
      "Dementielle Psychose",
      "Demenz",
      "Demenz bei Gehirnatrophie",
      "Demenz bei Hirnatrophie",
      "Demenz im Greisenalter",
      "Demenz unbekannter Ursache",
      "Depressive senile Demenz",
      "Einfache senile Demenz",
      "Organische Psychose durch präsenile Demenz",
      "Organische Psychose durch senile Demenz",
      "Organische präsenile Psychose",
      "Organische senile Psychose",
      "Paranoide Demenz",
      "Paranoide senile Demenz",
      "Persistierende Demenz",
      "Presbyophrene Psychose",
      "Presbyophrenie",
      "Primäre degenerative Demenz",
      "Präsenile Demenz",
      "Präsenile Psychose",
      "Senile Demenz",
      "Senile Demenz vom depressiven Typ",
      "Senile Demenz vom paranoiden Typ",
      "Senile Paranoia",
      "Senile Psychose a.n.k.",
      "Senile affektive Psychose a.n.k.",
      "Senile affektive Störung a.n.k.",
      "Senile intellektuelle Leistungsminderung",
      "Senile paranoide Psychose",
      "Senile paranoide Reaktion",
      "Seniles paranoides Zustandsbild",
      "Zerebrale Atrophie mit Demenz",
      "Zerebrale Demenz"
    ]
  },
  {
    "code": "F04",
    "name": "Nichtalkoholisches Korsakow-Syndrom",
    "synonyms": [
      "Amnestisches Zustandsbild",
      "Dysmnesie",
      "Dysmnestisches Zustandsbild",
      "Nichtalkoholbedingte Korsakow-Krankheit",
      "Nichtalkoholbedingte Korsakow-Psychose",
      "Nichtalkoholisches Korsakow-Syndrom",
      "Nichtalkoholisches organisches amnestisches Syndrom"
    ]
  },
  {
    "code": "F05.0",
    "name": "Delirium, nicht Demenz überlagernd",
    "synonyms": [
      "Delirium, nicht Demenz überlagernd"
    ]
  },
  {
    "code": "F05.1",
    "name": "Senile Demenz mit akuter Verwirrtheit",
    "synonyms": [
      "Altersschwäche mit akutem Verwirrtheitszustand",
      "Demenz mit Delirium",
      "Senile Demenz mit akuter Verwirrtheit"
    ]
  },
  {
    "code": "F05.8",
    "name": "Akute Psychose bei endokriner Störung",
    "synonyms": [
      "Akute Psychose bei Stoffwechselstörung",
      "Akute Psychose bei endokriner Störung",
      "Akute organische Psychose durch Epilepsie a.n.k.",
      "Akute organische Psychose durch Gehirninfektion",
      "Akute organische Psychose durch Gehirntrauma",
      "Akute organische Psychose durch Hirntrauma",
      "Akute organische Psychose durch endokrine Krankheit",
      "Akute organische Psychose durch metabolische Krankheit",
      "Akute posttraumatische organische Psychose",
      "Delirium im Wochenbett a.n.k.",
      "Delirium mit gemischter Ätiologie",
      "Epileptische Verwirrtheit",
      "Epileptischer Dämmerzustand",
      "Epileptischer Verwirrtheitszustand",
      "Postoperatives Delir",
      "Puerperales Delirium",
      "Subakute Psychose bei endokriner Störung",
      "Subakute organische Psychose durch Gehirninfektion",
      "Subakute organische Psychose durch endokrine Krankheit",
      "Subakute organische Psychose durch metabolische Krankheit",
      "Subakute posttraumatische organische Psychose"
    ]
  },
  {
    "code": "F05.9",
    "name": "Akute organische Psychose bei Infektionskrankheit",
    "synonyms": [
      "Akute Psychose bei Infektionskrankheit",
      "Akute Verwirrung",
      "Akute organische Psychose bei Infektionskrankheit",
      "Akuter Reaktionstyp",
      "Akuter Verwirrtheitszustand",
      "Akuter exogener Reaktionstyp",
      "Akuter nichtalkoholbedingter Verwirrtheitszustand",
      "Akuter organischer Reaktionstyp",
      "Akutes Delirium",
      "Akutes Delirium bei hirnorganischem Syndrom",
      "Akutes Delirium bei psychoorganischem Syndrom",
      "Akutes Delirium vom exogenen Reaktionstyp",
      "Akutes psychoorganisches Syndrom",
      "Delir - s.a. Delirium",
      "Deliranter Symptomenkomplex",
      "Delirantes Syndrom",
      "Delirium",
      "Nichtalkoholinduziertes Delirium",
      "Nichtalkoholisches Delirium",
      "Nichtdrogeninduziertes Delirium",
      "Prädelirium",
      "Psychose bei Infektionskrankheit",
      "Subakute Psychose bei Infektionskrankheit",
      "Subakute Verwirrtheit",
      "Subakute Verwirrung",
      "Subakuter Verwirrtheitszustand",
      "Subakuter nichtalkoholbedingter Verwirrtheitszustand",
      "Subakutes Delirium",
      "Subakutes Delirium bei hirnorganischem Syndrom",
      "Subakutes Delirium bei psychoorganischem Syndrom",
      "Subakutes Delirium vom exogenen Reaktionstyp",
      "Subakutes psychoorganisches Syndrom"
    ]
  },
  {
    "code": "F06.0",
    "name": "Organische Halluzinose",
    "synonyms": [
      "Dermatozoenwahn",
      "Epizoonosenwahn",
      "Organisch bedingtes halluzinatorisches Zustandsbild",
      "Organisch bedingtes nichtalkoholisches halluzinatorisches Zustandsbild",
      "Organische Halluzinose",
      "Palinopsie"
    ]
  },
  {
    "code": "F06.1",
    "name": "Organische katatone Störung",
    "synonyms": [
      "Organische katatone Störung",
      "Psychomotorische Aktivität mit katatonen Symptomen",
      "Stupor mit katatonen Symptomen"
    ]
  },
  {
    "code": "F06.2",
    "name": "Organische wahnhafte Störung",
    "synonyms": [
      "Organisch bedingtes paranoid-halluzinatorisches Zustandsbild",
      "Organisch bedingtes paranoides Zustandsbild",
      "Organische wahnhafte Störung",
      "Schizophreniforme Psychose bei Epilepsie",
      "Schizophreniforme Störung"
    ]
  },
  {
    "code": "F06.3",
    "name": "Organische affektive Störung",
    "synonyms": [
      "Depression nach Infektionskrankheit",
      "Exogene Depression",
      "Organische affektive Störung",
      "Organische bipolare Störung",
      "Organische depressive Störung"
    ]
  },
  {
    "code": "F06.4",
    "name": "Organische Angststörung",
    "synonyms": [
      "Organische Angststörung"
    ]
  },
  {
    "code": "F06.5",
    "name": "Organische dissoziative Störung",
    "synonyms": [
      "Organische dissoziative Störung"
    ]
  },
  {
    "code": "F06.6",
    "name": "Organische emotional labile Störung",
    "synonyms": [
      "Organische asthenische Störung",
      "Organische emotional labile Störung",
      "Pseudoneurasthenisches Syndrom"
    ]
  },
  {
    "code": "F06.7",
    "name": "Leichte Gedächtnislücke nach organischer Hirnschädigung",
    "synonyms": [
      "Leichte Gedächtnislücke nach organischer Hirnschädigung",
      "Leichte Gedächtnisstörung nach Hirnschädigung",
      "Leichte Störung des Erinnerungsvermögens nach Hirnschädigung",
      "Leichte kognitive Störung",
      "Leichter Verlust des Erinnerungsvermögens nach organischer Hirnschädigung"
    ]
  },
  {
    "code": "F06.8",
    "name": "Psychose bei Krampfleiden",
    "synonyms": [
      "Epileptische Psychose",
      "Hirnorganische Psychose",
      "Intrakranielle Infektion mit Psychose",
      "Organische Psychose bei Chorea Huntington",
      "Organische Psychose bei Ernährungsstörung",
      "Organische Psychose bei Infektionskrankheit",
      "Organische Psychose bei Stoffwechselstörung",
      "Organische Psychose bei intrakranieller Infektion",
      "Organische Psychose durch Gehirntrauma",
      "Organische Psychose durch Hirntrauma",
      "Organische psychotische Episode",
      "Postoperative Psychose",
      "Posttraumatische Psychose",
      "Posttraumatische organische Psychose",
      "Psychose bei Gehirntumor",
      "Psychose bei Hirntumor",
      "Psychose bei Krampfleiden",
      "Psychose bei endokriner Störung",
      "Psychose bei organischer Gehirnkrankheit",
      "Psychose bei organischer Hirnkrankheit"
    ]
  },
  {
    "code": "F06.9",
    "name": "Hirnorganisches Psychosyndrom",
    "synonyms": [
      "HOPS [Hirnorganisches Psychosyndrom]",
      "Hirnorganisches Psychosyndrom",
      "Hirnorganisches Syndrom",
      "Organische psychische Störung"
    ]
  },
  {
    "code": "F07.0",
    "name": "Organische Persönlichkeitsstörung",
    "synonyms": [
      "Frontalhirnsyndrom",
      "Leukotomiesyndrom",
      "Lobotomiesyndrom [Postlobotomiesyndrom]",
      "Moria",
      "Organisch bedingte pseudoretardierte Persönlichkeit",
      "Organische Gehirnstörung mit Verhaltensstörung",
      "Organische Hirnstörung mit Verhaltensstörung",
      "Organische Persönlichkeitsstörung",
      "Organische Pseudopsychopathie",
      "Organische Wesensänderung",
      "Persönlichkeitsstörung bei limbischer Epilepsie",
      "Persönlichkeitsstörung nach organischem Hirnschaden",
      "Postleukotomiesyndrom",
      "Pseudoretardierte Persönlichkeitsstörung",
      "Stirnhirnsyndrom",
      "Temporallappensyndrom",
      "Witzelsucht"
    ]
  },
  {
    "code": "F07.1",
    "name": "Postenzephalitisches Syndrom",
    "synonyms": [
      "Postenzephalitisches Syndrom"
    ]
  },
  {
    "code": "F07.2",
    "name": "Organisches Psychosyndrom nach Schädelhirntrauma",
    "synonyms": [
      "Boxer-Syndrom",
      "Chronische traumatische Enzephalopathie",
      "Commotio-Syndrom",
      "Organisches Psychosyndrom nach Schädelhirntrauma",
      "Post-commotio-Enzephalopathie",
      "Postkommotionelle Beschwerden",
      "Postkommotionelles Syndrom",
      "Postkontusionelle Enzephalopathie",
      "Postkontusionelles Syndrom",
      "Posttraumatisches Psychosyndrom nichtpsychotischer Ausprägung",
      "Psychosyndrom nach Commotio cerebri",
      "Punch-drunk-Syndrom",
      "Status post commotionem cerebri",
      "Traumatische Enzephalopathie"
    ]
  },
  {
    "code": "F07.8",
    "name": "Rechts-hemisphärische organische affektive Störung",
    "synonyms": [
      "Klüver-Bucy-Syndrom",
      "Rechts-hemisphärische organische affektive Störung"
    ]
  },
  {
    "code": "F07.9",
    "name": "Algogenes Psychosyndrom",
    "synonyms": [
      "Algogenes Psychosyndrom",
      "OPS [Organisches Psychosyndrom]",
      "Organisches Psychosyndrom",
      "Psychoorganisches Syndrom",
      "Psychosyndrom"
    ]
  },
  {
    "code": "F09",
    "name": "Chronische organische Psychose",
    "synonyms": [
      "Akute organische Psychose",
      "Chronische organische Psychose",
      "Degeneration des Zentralnervensystems mit Psychose",
      "Durchgangssyndrom",
      "Körperliche Psychose",
      "Organische Gehirnerkrankung mit Psychose",
      "Organische Psychose",
      "Subakute organische Psychose",
      "Symptomatische Psychose"
    ]
  },
  {
    "code": "F10.0",
    "name": "Akute Alkoholintoxikation, im Sinne eines Rausches",
    "synonyms": [
      "Akute Alkoholintoxikation, im Sinne eines Rausches",
      "Akute Alkoholvergiftung, im Sinne eines Rausches",
      "Akute Trunkenheit bei Alkoholabhängigkeit",
      "Akuter Alkoholrausch",
      "Akuter Rausch bei Alkoholabhängigkeit",
      "Alkoholintoxikation bei Abhängigkeit",
      "Alkoholkater",
      "Alkoholrausch",
      "Alkoholrausch bei Abhängigkeit",
      "Alkoholrausch mit Delirium",
      "Alkoholvergiftung bei Abhängigkeit",
      "Pathologische Trunkenheit",
      "Pathologischer Alkoholrausch",
      "Pathologischer Rausch",
      "Pathologischer alkoholischer Rausch a.n.k."
    ]
  },
  {
    "code": "F10.1",
    "name": "Alkoholmissbrauch",
    "synonyms": [
      "Alkoholabusus",
      "Alkoholische Organschädigung",
      "Alkoholmissbrauch",
      "Betrunkenheit",
      "Exzessives Trinken",
      "Schädlicher Gebrauch von Alkohol",
      "Übermäßiges Trinken a.n.k.",
      "Übermäßiges Trinken von Alkohol a.n.k."
    ]
  },
  {
    "code": "F10.2",
    "name": "Dipsomanie",
    "synonyms": [
      "Abhängigkeit von Alkohol",
      "Abhängigkeit von Methylalkohol",
      "Abhängigkeit von Äthanol",
      "Abhängigkeit von Äthylalkohol",
      "Abhängigkeitssyndrom bei Gebrauch von Alkohol",
      "Absinthabhängigkeit",
      "Alkoholismus",
      "Alkoholkrankheit",
      "Alkoholsucht",
      "Beständiges Trinken",
      "Chronische Alkoholsucht",
      "Chronische Trunkenheit",
      "Chronische Trunksucht",
      "Chronischer Alkoholabusus",
      "Chronischer Alkoholismus",
      "Chronischer Alkoholmissbrauch",
      "Chronischer Äthylismus",
      "Chronisches Potatorium",
      "Dipsomanie",
      "Gewohnheitsmäßiges Trinken",
      "Periodische Trunksucht",
      "Potatorium",
      "Quartalssäufer",
      "Trunksucht",
      "Äthylismus"
    ]
  },
  {
    "code": "F10.3",
    "name": "Entzugssyndrom nach Gebrauch von Alkohol",
    "synonyms": [
      "Alkoholabstinenzsyndrom",
      "Alkoholabusus mit Entzug",
      "Alkoholentzugserscheinungen",
      "Alkoholentzugskrampf",
      "Alkoholentzugssyndrom",
      "Entzugssyndrom nach Gebrauch von Alkohol"
    ]
  },
  {
    "code": "F10.4",
    "name": "Delirium tremens",
    "synonyms": [
      "Akutes Delirium alcoholicum",
      "Alkoholbedingtes Delirium tremens",
      "Alkoholdelirium",
      "Alkoholentzugsdelirium",
      "Alkoholisches Prädelirium",
      "Alkoholpsychose mit Delirium tremens",
      "Delirium alcoholicum",
      "Delirium tremens",
      "Entzugssyndrom mit Delirium nach Gebrauch von Alkohol"
    ]
  },
  {
    "code": "F10.5",
    "name": "Alkoholischer Eifersuchtswahn",
    "synonyms": [
      "Akute alkoholische Manie",
      "Alkoholhalluzinose",
      "Alkoholische Manie",
      "Alkoholische Paranoia",
      "Alkoholische Psychose",
      "Alkoholischer Eifersuchtswahn",
      "Alkoholismus mit Psychose",
      "Alkoholpsychose",
      "Alkoholpsychose mit Eifersucht",
      "Alkoholpsychose mit Halluzinose",
      "Chronische alkoholische Manie",
      "Dipsomanie mit Psychose",
      "Organische Psychose durch Alkoholsucht",
      "Organische Psychose durch akute alkoholische Intoxikation",
      "Organische Psychose durch akute alkoholische Vergiftung",
      "Organische Psychose durch alkoholische Leberkrankheit",
      "Paranoia durch Alkohol",
      "Paranoide Alkoholpsychose",
      "Paranoide alkoholische Psychose",
      "Psychotische Störung nach Gebrauch von Alkohol"
    ]
  },
  {
    "code": "F10.6",
    "name": "Amnestisches Syndrom nach Gebrauch von Alkohol",
    "synonyms": [
      "AKS [Alkoholbedingtes Korsakow-Syndrom]",
      "Alkoholbedingte Korsakow-Krankheit",
      "Alkoholische Psychose mit Polyneuritis",
      "Alkoholisches Korsakow-Syndrom",
      "Alkoholpsychose mit Polyneuritis",
      "Alkoholpsychose mit amnestischer Konfabulation",
      "Amnestischer Symptomenkomplex",
      "Amnestisches Syndrom",
      "Amnestisches Syndrom nach Gebrauch von Alkohol",
      "Cerebropathia psychica toxaemica",
      "Chronisches Delirium alcoholicum",
      "Korsakow-Alkoholismus",
      "Korsakow-Alkoholpsychose",
      "Korsakow-Krankheit",
      "Korsakow-Psychose",
      "Korsakow-Syndrom",
      "Meynert-Amentia",
      "Persistierende amnestische Störung durch Alkohol",
      "Polyneuritische alkoholische Psychose"
    ]
  },
  {
    "code": "F10.7",
    "name": "Chronisches alkoholisches organisches Psychosyndrom",
    "synonyms": [
      "Akute verzögert auftretende Psychose",
      "Alkoholdemenz",
      "Alkoholisches Psychosyndrom",
      "Alkoholpsychose mit Demenz",
      "Anhaltende kognitive Störung durch Alkohol",
      "Chronisches alkoholisches organisches Psychosyndrom",
      "Dementia alcoholica",
      "Demenz bei Alkoholismus",
      "Persistierende Störung durch Alkohol"
    ]
  },
  {
    "code": "F10.8",
    "name": "Alkoholische Pseudoparalyse",
    "synonyms": [
      "Alkoholische Pseudoparalyse"
    ]
  },
  {
    "code": "F10.9",
    "name": "Alkoholbedingte Verhaltensstörung",
    "synonyms": [
      "Alkoholbedingte Verhaltensstörung"
    ]
  },
  {
    "code": "F11.0",
    "name": "Akute Opioidintoxikation, im Sinne eines Rausches",
    "synonyms": [
      "Akute Heroinintoxikation, im Sinne eines Rausches",
      "Akute Heroinvergiftung, im Sinne eines Rausches",
      "Akute Opioidintoxikation, im Sinne eines Rausches",
      "Akute Opioidvergiftung, im Sinne eines Rausches",
      "Akuter Rausch durch Opioide",
      "Heroinintoxikation bei Abhängigkeit",
      "Heroinvergiftung bei Abhängigkeit",
      "Opioidintoxikation bei Abhängigkeit",
      "Opioidvergiftung bei Abhängigkeit"
    ]
  },
  {
    "code": "F11.1",
    "name": "Schädlicher Gebrauch von Opioiden",
    "synonyms": [
      "Heroinabusus",
      "Heroinmissbrauch",
      "Missbrauch vom Morphintyp",
      "Morphiumabusus",
      "Morphiummissbrauch",
      "Opioidabusus",
      "Opioidmissbrauch",
      "Schädlicher Gebrauch von Opioiden"
    ]
  },
  {
    "code": "F11.2",
    "name": "Abhängigkeit von Kodein",
    "synonyms": [
      "Abhängigkeit vom Morphinsulfattyp",
      "Abhängigkeit vom Morphinsulfittyp",
      "Abhängigkeit von Codein",
      "Abhängigkeit von Demerol",
      "Abhängigkeit von Dextromethorphan",
      "Abhängigkeit von Dextromoramid",
      "Abhängigkeit von Dextrorphan",
      "Abhängigkeit von Dilaudid",
      "Abhängigkeit von Heroin",
      "Abhängigkeit von Kodein",
      "Abhängigkeit von Laudanum",
      "Abhängigkeit von Methadon",
      "Abhängigkeit von Methylmorphin",
      "Abhängigkeit von Opiaten",
      "Abhängigkeit von Opium",
      "Abhängigkeit von Opiumderivat",
      "Abhängigkeit von Paregoric USP",
      "Abhängigkeit von Tinctura Opii benzoica",
      "Abhängigkeit von morphinähnlicher Substanz",
      "Abhängigkeit von synthetischen Drogen mit morphingleichem Effekt",
      "Abhängigkeit von Äthylmorphin",
      "Abhängigkeitssyndrom bei Gebrauch von Opioiden",
      "Morphinismus",
      "Opiumsucht"
    ]
  },
  {
    "code": "F11.3",
    "name": "Entzugssyndrom nach Gebrauch von Opioiden",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch von Opioiden"
    ]
  },
  {
    "code": "F11.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch von Opioiden",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch von Opioiden"
    ]
  },
  {
    "code": "F11.5",
    "name": "Psychotische Störung nach Gebrauch von Opioiden",
    "synonyms": [
      "Psychotische Störung nach Gebrauch von Opioiden"
    ]
  },
  {
    "code": "F11.6",
    "name": "Amnestisches Syndrom nach Gebrauch von Opioiden",
    "synonyms": [
      "Amnestisches Syndrom nach Gebrauch von Opioiden"
    ]
  },
  {
    "code": "F11.7",
    "name": "Verzögert auftretende psychotische Störung bei Restzustand nach Gebrauch von Opioiden",
    "synonyms": [
      "Verzögert auftretende psychotische Störung bei Restzustand nach Gebrauch von Opioiden"
    ]
  },
  {
    "code": "F12.0",
    "name": "Akute Intoxikation durch Cannabinoide, im Sinne eines Rausches",
    "synonyms": [
      "Akute Cannabinoidvergiftung, im Sinne eines Rausches",
      "Akute Intoxikation durch Cannabinoide, im Sinne eines Rausches",
      "Akuter Rausch durch Cannabinoide",
      "Cannabinoidintoxikation bei Abhängigkeit",
      "Cannabinoidvergiftung bei Abhängigkeit"
    ]
  },
  {
    "code": "F12.1",
    "name": "Schädlicher Gebrauch von Cannabinoiden",
    "synonyms": [
      "Cannabisabusus",
      "Cannabismissbrauch",
      "Haschischabusus ohne Abhängigkeit",
      "Haschischmissbrauch ohne Abhängigkeit",
      "Marihuanaabusus ohne Abhängigkeit",
      "Marihuanamissbrauch ohne Abhängigkeit",
      "Schädlicher Gebrauch von Cannabinoiden"
    ]
  },
  {
    "code": "F12.2",
    "name": "Abhängigkeitssyndrom bei Gebrauch von Cannabinoiden",
    "synonyms": [
      "Abhängigkeit von Bhang",
      "Abhängigkeit von Cannabis",
      "Abhängigkeit von Cannabis indica",
      "Abhängigkeit von Cannabis sativa",
      "Abhängigkeit von Cannabisharz",
      "Abhängigkeit von Cannabisverbindung",
      "Abhängigkeit von Dagga",
      "Abhängigkeit von Ganja",
      "Abhängigkeit von Hanf",
      "Abhängigkeit von Hanfprodukten",
      "Abhängigkeit von Haschisch",
      "Abhängigkeit von Hemp",
      "Abhängigkeit von Kiff",
      "Abhängigkeit von Maconha",
      "Abhängigkeit von Marihuana",
      "Abhängigkeit von indischem Hanf",
      "Abhängigkeitssyndrom bei Gebrauch von Cannabinoiden",
      "Cannabismus"
    ]
  },
  {
    "code": "F12.3",
    "name": "Entzugssyndrom nach Gebrauch von Cannabinoiden",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch von Cannabinoiden"
    ]
  },
  {
    "code": "F12.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch von Cannabinoiden",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch von Cannabinoiden"
    ]
  },
  {
    "code": "F12.5",
    "name": "Psychotische Störung nach Gebrauch von Cannabinoiden",
    "synonyms": [
      "Psychotische Störung nach Gebrauch von Cannabinoiden"
    ]
  },
  {
    "code": "F12.6",
    "name": "Amnestisches Syndrom nach Gebrauch von Cannabinoiden",
    "synonyms": [
      "Amnestisches Syndrom nach Gebrauch von Cannabinoiden"
    ]
  },
  {
    "code": "F12.7",
    "name": "Persistierende Störung durch Cannabis",
    "synonyms": [
      "Persistierende Störung durch Cannabis"
    ]
  },
  {
    "code": "F13.0",
    "name": "Akute Intoxikation durch Sedativa und Hypnotika, im Sinne eines Rausches",
    "synonyms": [
      "Akute Intoxikation durch Sedativa und Hypnotika, im Sinne eines Rausches",
      "Akute Vergiftung durch Sedativa und Hypnotika, im Sinne eines Rausches",
      "Akuter Rausch durch Hypnotika",
      "Akuter Rausch durch Sedativa",
      "Intoxikation durch Sedativa und Hypnotika bei Abhängigkeit",
      "Vergiftung durch Sedativa und Hypnotika bei Abhängigkeit"
    ]
  },
  {
    "code": "F13.1",
    "name": "Schädlicher Gebrauch von Sedativa und Hypnotika",
    "synonyms": [
      "Anxiolytikaabusus",
      "Anxiolytikamissbrauch",
      "Barbituratabusus",
      "Barbituratmissbrauch",
      "Benzodiazepinabusus",
      "Diazepamabusus",
      "Diazepammissbrauch",
      "Gabapentinabusus",
      "Gabapentinkonsumstörung",
      "Hypnotikaabusus",
      "Hypnotikamissbrauch",
      "Pregabalinabusus",
      "Pregabalinkonsumstörung",
      "Schädlicher Gebrauch von Sedativa und Hypnotika",
      "Sedativaabusus",
      "Sedativamissbrauch",
      "Tranquilizerabusus",
      "Tranquilizermissbrauch"
    ]
  },
  {
    "code": "F13.2",
    "name": "Abhängigkeitssyndrom bei Gebrauch von Sedativa und Hypnotika",
    "synonyms": [
      "Abhängigkeit von Amobarbital",
      "Abhängigkeit von Amytal",
      "Abhängigkeit von Barbital",
      "Abhängigkeit von Barbituraten",
      "Abhängigkeit von Benzodiazepin",
      "Abhängigkeit von Bromid a.n.k.",
      "Abhängigkeit von Chloralhydrat",
      "Abhängigkeit von Chlordiazepoxid",
      "Abhängigkeit von Cloralbetain",
      "Abhängigkeit von Diazepam",
      "Abhängigkeit von Gabapentin",
      "Abhängigkeit von Glutethimid",
      "Abhängigkeit von Hypnotika a.n.k.",
      "Abhängigkeit von Luminal",
      "Abhängigkeit von Meprobamat",
      "Abhängigkeit von Methaqualon",
      "Abhängigkeit von Methylbromid",
      "Abhängigkeit von Methylsulfonal",
      "Abhängigkeit von Nembutal",
      "Abhängigkeit von Neraval",
      "Abhängigkeit von Neravan",
      "Abhängigkeit von Neurobarb",
      "Abhängigkeit von Nichtbarbiturat mit Barbiturat-Effekt",
      "Abhängigkeit von Nichtbarbiturat-Sedativa",
      "Abhängigkeit von Paraldehyd",
      "Abhängigkeit von Pentobarbital",
      "Abhängigkeit von Pentothal",
      "Abhängigkeit von Phenobarbital",
      "Abhängigkeit von Pregabalin",
      "Abhängigkeit von Schlafmittel",
      "Abhängigkeit von Secobarbital",
      "Abhängigkeit von Seconal",
      "Abhängigkeit von Sedativa a.n.k.",
      "Abhängigkeit von Tranquilizer a.n.k.",
      "Abhängigkeit von Äthylbromid",
      "Abhängigkeitssyndrom bei Gebrauch von Sedativa und Hypnotika",
      "Chronischer Bromismus",
      "Schlafmittelsucht"
    ]
  },
  {
    "code": "F13.3",
    "name": "Entzugssyndrom nach Gebrauch von Sedativa und Hypnotika",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch von Sedativa und Hypnotika"
    ]
  },
  {
    "code": "F13.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch von Sedativa und Hypnotika",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch von Sedativa und Hypnotika"
    ]
  },
  {
    "code": "F13.5",
    "name": "Psychotische Störung nach Gebrauch von Sedativa und Hypnotika",
    "synonyms": [
      "Psychotische Störung nach Gebrauch von Sedativa und Hypnotika"
    ]
  },
  {
    "code": "F13.6",
    "name": "Amnestisches Syndrom nach Gebrauch von Sedativa und Hypnotika",
    "synonyms": [
      "Amnestisches Syndrom nach Gebrauch von Sedativa und Hypnotika",
      "Persistierende amnestische Störung durch Sedativa"
    ]
  },
  {
    "code": "F13.7",
    "name": "Demenz durch Sedativa",
    "synonyms": [
      "Anhaltende kognitive Störung durch Sedativa",
      "Demenz durch Hypnotika",
      "Demenz durch Sedativa",
      "Persistierende Störung durch Anxiolytika",
      "Persistierende Störung durch Hypnotika",
      "Persistierende Störung durch Sedativa"
    ]
  },
  {
    "code": "F13.8",
    "name": "Unruhezustände nach Anwendung von Hypnotika",
    "synonyms": [
      "Unruhezustände nach Anwendung von Hypnotika"
    ]
  },
  {
    "code": "F14.0",
    "name": "Akute Kokainintoxikation, im Sinne eines Rausches",
    "synonyms": [
      "Akute Kokainintoxikation, im Sinne eines Rausches",
      "Akute Kokainvergiftung, im Sinne eines Rausches",
      "Akuter Rausch durch Kokain",
      "Kokainintoxikation bei Abhängigkeit",
      "Kokainvergiftung bei Abhängigkeit"
    ]
  },
  {
    "code": "F14.1",
    "name": "Schädlicher Gebrauch von Kokain",
    "synonyms": [
      "Kokainabusus",
      "Kokainmissbrauch",
      "Missbrauch vom Kokaintyp",
      "Schädlicher Gebrauch von Kokain"
    ]
  },
  {
    "code": "F14.2",
    "name": "Abhängigkeitssyndrom bei Gebrauch von Kokain",
    "synonyms": [
      "Abhängigkeit von Kokablatt-Derivat",
      "Abhängigkeit von Kokablättern",
      "Abhängigkeit von Kokain",
      "Abhängigkeit von Kokainderivat",
      "Abhängigkeitssyndrom bei Gebrauch von Kokain",
      "Kokainismus",
      "Kokainsucht",
      "Schnüffeln von Kokain"
    ]
  },
  {
    "code": "F14.3",
    "name": "Entzugssyndrom nach Gebrauch von Kokain",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch von Kokain"
    ]
  },
  {
    "code": "F14.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch von Kokain",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch von Kokain"
    ]
  },
  {
    "code": "F14.5",
    "name": "Psychotische Störung nach Gebrauch von Kokain",
    "synonyms": [
      "Psychotische Störung nach Gebrauch von Kokain"
    ]
  },
  {
    "code": "F14.6",
    "name": "Amnestisches Syndrom nach Gebrauch von Kokain",
    "synonyms": [
      "Amnestisches Syndrom nach Gebrauch von Kokain"
    ]
  },
  {
    "code": "F15.0",
    "name": "Akuter Rausch durch Koffein",
    "synonyms": [
      "Akuter Rausch durch Koffein",
      "Akuter Rausch durch Stimulanzien a.n.k."
    ]
  },
  {
    "code": "F15.1",
    "name": "Amphetaminmissbrauch",
    "synonyms": [
      "Amphetaminabusus",
      "Amphetaminmissbrauch",
      "Koffeinmissbrauch",
      "Stimulanzienmissbrauch a.n.k."
    ]
  },
  {
    "code": "F15.2",
    "name": "Abhängigkeit von Phenmetrazin",
    "synonyms": [
      "Abhängigkeit von Amphetamin",
      "Abhängigkeit von Benzedrin",
      "Abhängigkeit von Dexamphetamin",
      "Abhängigkeit von Dexedrin",
      "Abhängigkeit von Dextro-nor-pseudoephedrin",
      "Abhängigkeit von Khat",
      "Abhängigkeit von Koffein",
      "Abhängigkeit von Methamphetamin",
      "Abhängigkeit von Methylphenidat",
      "Abhängigkeit von Phenmetrazin",
      "Abhängigkeit von Psychostimulans a.n.k.",
      "Abhängigkeit von Stimulanzien",
      "Koffeinabhängigkeitssyndrom"
    ]
  },
  {
    "code": "F15.3",
    "name": "Koffeinentzugssyndrom",
    "synonyms": [
      "Koffeinentzugssyndrom",
      "Stimulanzienentzugssyndrom a.n.k."
    ]
  },
  {
    "code": "F15.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch von Stimulanzien",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch von Stimulanzien"
    ]
  },
  {
    "code": "F16.0",
    "name": "Akute Intoxikation durch Halluzinogene, im Sinne eines Rausches",
    "synonyms": [
      "Akute Intoxikation durch Halluzinogene, im Sinne eines Rausches",
      "Akute Vergiftung durch Halluzinogene, im Sinne eines Rausches",
      "Akuter Rausch durch Halluzinogene",
      "Intoxikation durch Halluzinogene bei Abhängigkeit",
      "LSD [Lysergsäurediäthylamid]-Rausch",
      "Reaktion auf LSD [Lysergsäurediäthylamid]",
      "Vergiftung durch Halluzinogene bei Abhängigkeit"
    ]
  },
  {
    "code": "F16.1",
    "name": "Schädlicher Gebrauch von Halluzinogenen",
    "synonyms": [
      "Halluzinogenabusus",
      "Halluzinogenmissbrauch",
      "LSD [Lysergsäurediäthylamid]-Abusus ohne Abhängigkeit",
      "LSD [Lysergsäurediäthylamid]-Missbrauch ohne Abhängigkeit",
      "Schädlicher Gebrauch von Halluzinogenen"
    ]
  },
  {
    "code": "F16.2",
    "name": "Abhängigkeitssyndrom bei Gebrauch von Halluzinogenen",
    "synonyms": [
      "Abhängigkeit von D-Lysergsäurediäthylamid",
      "Abhängigkeit von Halluzinogenen",
      "Abhängigkeit von LSD [Lysergsäurediäthylamid]-Derivaten",
      "Abhängigkeit von Lysergsäure",
      "Abhängigkeit von Mescalin",
      "Abhängigkeit von Peyotl",
      "Abhängigkeit von Psilocin",
      "Abhängigkeit von Psilocybin",
      "Abhängigkeit von Psilocylin",
      "Abhängigkeit von Psilocyn",
      "Abhängigkeit von halluzinogenem Arzneimittel",
      "Abhängigkeit von halluzinogener Droge",
      "Abhängigkeitssyndrom bei Gebrauch von Halluzinogenen"
    ]
  },
  {
    "code": "F16.3",
    "name": "Entzugssyndrom nach Gebrauch von Halluzinogenen",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch von Halluzinogenen"
    ]
  },
  {
    "code": "F16.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch von Halluzinogenen",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch von Halluzinogenen"
    ]
  },
  {
    "code": "F16.5",
    "name": "Psychotische Störung nach Gebrauch von Halluzinogenen",
    "synonyms": [
      "Psychotische Störung nach Gebrauch von Halluzinogenen"
    ]
  },
  {
    "code": "F16.6",
    "name": "Amnestisches Syndrom nach Gebrauch von Halluzinogenen",
    "synonyms": [
      "Amnestisches Syndrom nach Gebrauch von Halluzinogenen"
    ]
  },
  {
    "code": "F16.7",
    "name": "Persistierende Störung durch Halluzinogene",
    "synonyms": [
      "Anhaltende kognitive Störung durch Halluzinogene",
      "Persistierende Störung durch Halluzinogene"
    ]
  },
  {
    "code": "F17.0",
    "name": "Akute Intoxikation durch Tabak",
    "synonyms": [
      "Akute Intoxikation durch Tabak",
      "Akute Tabakvergiftung",
      "Intoxikation durch Tabak bei Abhängigkeit",
      "Tabakvergiftung bei Abhängigkeit"
    ]
  },
  {
    "code": "F17.1",
    "name": "Schädlicher Gebrauch von Tabak",
    "synonyms": [
      "Exzessives Rauchen",
      "Exzessives Zigarettenrauchen",
      "Nikotinabusus",
      "Nikotinmissbrauch",
      "Rauchen",
      "Schädlicher Gebrauch von Tabak",
      "Tabakabusus",
      "Tabakmissbrauch"
    ]
  },
  {
    "code": "F17.2",
    "name": "Abhängigkeit von Nikotin",
    "synonyms": [
      "Abhängigkeit von Nikotin",
      "Chronischer Nikotinabusus",
      "Tabak-Abhängigkeitssyndrom"
    ]
  },
  {
    "code": "F17.3",
    "name": "Entzugssyndrom nach Gebrauch von Tabak",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch von Tabak",
      "Nikotinentwöhnung",
      "Nikotinentzugssyndrom",
      "Raucherentwöhnung",
      "Tabakentzugssyndrom"
    ]
  },
  {
    "code": "F17.5",
    "name": "Psychotische Störung nach Gebrauch von Tabak",
    "synonyms": [
      "Psychotische Störung nach Gebrauch von Tabak"
    ]
  },
  {
    "code": "F18.0",
    "name": "Akute Intoxikation durch ein flüchtiges Lösungsmittel, im Sinne eines Rausches",
    "synonyms": [
      "Akute Intoxikation durch ein flüchtiges Lösungsmittel, im Sinne eines Rausches",
      "Akute Vergiftung durch ein flüchtiges Lösungsmittel, im Sinne eines Rausches",
      "Akuter Rausch durch ein flüchtiges Lösungsmittel",
      "Intoxikation durch ein flüchtiges Lösungsmittel bei Abhängigkeit",
      "Vergiftung durch ein flüchtiges Lösungsmittel bei Abhängigkeit"
    ]
  },
  {
    "code": "F18.1",
    "name": "Schädlicher Gebrauch von flüchtigen Lösungsmitteln",
    "synonyms": [
      "Inhalationsmittelabusus",
      "Inhalationsmittelmissbrauch",
      "Lösungsmittelabusus",
      "Lösungsmittelmissbrauch",
      "Schnüffeln von Flugzeugkleber",
      "Schädlicher Gebrauch von flüchtigen Lösungsmitteln"
    ]
  },
  {
    "code": "F18.2",
    "name": "Abhängigkeitssyndrom bei Gebrauch eines flüchtigen Lösungsmittels",
    "synonyms": [
      "Abhängigkeit beim Schnüffeln von Benzin",
      "Abhängigkeit von Flugzeugkleber",
      "Abhängigkeitssyndrom bei Gebrauch eines flüchtigen Lösungsmittels",
      "Schnüffelsucht"
    ]
  },
  {
    "code": "F18.3",
    "name": "Entzugssyndrom nach Gebrauch eines flüchtigen Lösungsmittels",
    "synonyms": [
      "Entzugssyndrom nach Gebrauch eines flüchtigen Lösungsmittels"
    ]
  },
  {
    "code": "F18.4",
    "name": "Entzugssyndrom mit Delirium nach Gebrauch eines flüchtigen Lösungsmittels",
    "synonyms": [
      "Entzugssyndrom mit Delirium nach Gebrauch eines flüchtigen Lösungsmittels"
    ]
  },
  {
    "code": "F18.5",
    "name": "Psychotische Störung nach Gebrauch eines flüchtigen Lösungsmittels",
    "synonyms": [
      "Psychotische Störung nach Gebrauch eines flüchtigen Lösungsmittels"
    ]
  },
  {
    "code": "F18.6",
    "name": "Amnestisches Syndrom nach Gebrauch eines flüchtigen Lösungsmittels",
    "synonyms": [
      "Amnestisches Syndrom nach Gebrauch eines flüchtigen Lösungsmittels"
    ]
  },
  {
    "code": "F18.7",
    "name": "Demenz durch flüchtige Lösungsmittel",
    "synonyms": [
      "Demenz durch Inhalationsdrogen",
      "Demenz durch flüchtige Lösungsmittel"
    ]
  },
  {
    "code": "F19.0",
    "name": "Horrortrip",
    "synonyms": [
      "Akuter Rausch durch Betäubungsmittel",
      "Akuter Rausch durch multiple psychotrope Substanzen",
      "Horrortrip",
      "Pathologischer Drogenrausch",
      "Rausch durch eine psychotrope Substanz a.n.k."
    ]
  },
  {
    "code": "F19.1",
    "name": "Ständiger Tablettenabusus",
    "synonyms": [
      "Abusus einer psychoaktiven Substanz",
      "Arzneimittelabusus",
      "Arzneimittelexzess",
      "Arzneimittelmissbrauch",
      "Drogenabusus",
      "Drogenmissbrauch",
      "Medikamentenabusus",
      "Medikamentenmissbrauch",
      "Missbrauch einer Substanz",
      "Missbrauch einer psychoaktiven Substanz",
      "PCP [Phenylcyclidin]-Abusus",
      "PCP [Phenylcyclidin]-Missbrauch",
      "Phenylcyclidinabusus (oder vergleichbare Substanzen)",
      "Phenylcyclidinmissbrauch (oder vergleichbare Substanzen)",
      "Ständiger Tablettenabusus",
      "Tablettenabusus",
      "Tablettenmissbrauch"
    ]
  },
  {
    "code": "F19.2",
    "name": "Polytoxikomanie ohne Morphintyp",
    "synonyms": [
      "Abhängigkeit von Arzneimittel a.n.k.",
      "Abhängigkeit von Arzneimittel-Kombination a.n.k.",
      "Abhängigkeit von Drogen a.n.k.",
      "Abhängigkeit von Drogen-Kombination a.n.k.",
      "Abhängigkeit von Narkotika a.n.k.",
      "Abhängigkeit von Propofol",
      "Abhängigkeit von Rauschgift",
      "Abhängigkeit von Stickoxiden",
      "Abhängigkeit von Wermut",
      "Abhängigkeit von Äthylcarbamat",
      "Abhängigkeit von Äthylchlorid",
      "Absinthismus",
      "Arzneimittelsucht",
      "Betäubungsmittelabhängigkeit",
      "Drogensucht",
      "Medikamentenabhängigkeit",
      "Medikamentensucht",
      "Mehrfachabhängigkeit",
      "Narkomanie",
      "Polytoxikomanie",
      "Polytoxikomanie einschließlich Morphintyp",
      "Polytoxikomanie ohne Morphintyp",
      "Suchtstoffabhängigkeit a.n.k.",
      "Tablettensucht",
      "Toxikomanie"
    ]
  },
  {
    "code": "F19.3",
    "name": "Drogenentzugssyndrom a.n.k.",
    "synonyms": [
      "Abstinenzsyndrom",
      "Drogenentzugssyndrom a.n.k.",
      "Entzugssyndrom",
      "Entzugssyndrome bei Arzneimittelabhängigkeit",
      "Rauschgiftentzugssyndrom"
    ]
  },
  {
    "code": "F19.4",
    "name": "Entzugsdelirium",
    "synonyms": [
      "Drogenentzugssyndrom mit Delirium",
      "Entzugsdelirium"
    ]
  },
  {
    "code": "F19.5",
    "name": "Psychose durch Drogenintoxikation",
    "synonyms": [
      "Drogenhalluzinose",
      "Drogeninduzierte Halluzinose",
      "Drogeninduzierte Paranoia",
      "Drogeninduzierte Paranoia und Halluzinose",
      "Drogenpsychose",
      "Halluzinatorische Drogenpsychose",
      "Paranoid-halluzinatorische Drogenpsychose",
      "Paranoide Drogenpsychose",
      "Psychose durch Drogenintoxikation",
      "Psychose durch Drogenvergiftung"
    ]
  },
  {
    "code": "F19.7",
    "name": "Nachhallzustand",
    "synonyms": [
      "Nachhallzustand"
    ]
  },
  {
    "code": "F20.0",
    "name": "Paranoide Schizophrenie",
    "synonyms": [
      "Akute Paraphrenie",
      "Akute paranoide Schizophrenie",
      "Paranoid-halluzinatorische Schizophrenie",
      "Paranoid-schizophrene Psychose",
      "Paranoide Schizophrenie",
      "Paranoide Schizophrenie mit Halluzination",
      "Paraphrene Schizophrenie",
      "Paraphrenie"
    ]
  },
  {
    "code": "F20.1",
    "name": "Hebephrenie",
    "synonyms": [
      "Akute Hebephrenie",
      "Desintegrative Schizophrenie",
      "Desorganisierte Schizophrenie",
      "Hebephrene Dementia praecox",
      "Hebephrene Demenz",
      "Hebephrene Schizophrenie",
      "Hebephrenie"
    ]
  },
  {
    "code": "F20.2",
    "name": "Katatone Schizophrenie",
    "synonyms": [
      "Akute Katatonie",
      "Akute katatone Katalepsie",
      "Flexibilitas cerea bei Schizophrenie",
      "Idiopathische Katatonie",
      "Kataleptische Schizophrenie",
      "Katatone Agitation",
      "Katatone Demenz",
      "Katatone Erregung",
      "Katatone Schizophrenie",
      "Katatoner Erregungszustand",
      "Katatoner Spannungszustand",
      "Katatoner Stupor",
      "Katatonie",
      "Schizophrene Flexibilitas cerea",
      "Schizophrene Katalepsie",
      "Schizophrene Katatonie"
    ]
  },
  {
    "code": "F20.3",
    "name": "Undifferenzierte Schizophrenie",
    "synonyms": [
      "Atypische Schizophrenie",
      "Undifferenzierte Schizophrenie"
    ]
  },
  {
    "code": "F20.4",
    "name": "Postschizophrene Depression",
    "synonyms": [
      "Postschizophrene Depression"
    ]
  },
  {
    "code": "F20.5",
    "name": "Schizophrenes Residuum",
    "synonyms": [
      "Chronische Schizophrenie a.n.k.",
      "Chronische undifferenzierte Schizophrenie",
      "Chronischer Morbus Bleuler",
      "Residuale Schizophrenie",
      "Schizophrener Defekt",
      "Schizophrener Residualzustand",
      "Schizophrener Restzustand",
      "Schizophrenes Residuum"
    ]
  },
  {
    "code": "F20.6",
    "name": "Schizophrenia simplex",
    "synonyms": [
      "Akute einfache Schizophrenie",
      "Akute primäre Schizophrenie",
      "Schizophrenia simplex"
    ]
  },
  {
    "code": "F20.8",
    "name": "Akute schizophrene Attacke",
    "synonyms": [
      "Akute schizophrene Attacke",
      "Schizophrene Attacke",
      "Schizophrenie und Verwirrtheit",
      "Schizophreniforme Psychose",
      "Schizophreniformer Anfall",
      "Zönästhetische Schizophrenie"
    ]
  },
  {
    "code": "F20.9",
    "name": "Schizophrenie",
    "synonyms": [
      "Morbus Bleuler",
      "Schizophrene Demenz",
      "Schizophrene Psychose",
      "Schizophrene Reaktion",
      "Schizophrenia",
      "Schizophrenie",
      "Schizophrenie im Kindesalter",
      "Schizophrenie-Reaktion"
    ]
  },
  {
    "code": "F21",
    "name": "Schizotype Störung",
    "synonyms": [
      "Borderline-Schizophrenie",
      "Grenzpsychose",
      "Grenzschizophrenie",
      "Latente Schizophrenie",
      "Latente schizophrene Reaktion",
      "Prodromale Schizophrenie",
      "Präpsychotische Schizophrenie",
      "Pseudoneurotische Schizophrenie",
      "Pseudopsychopathische Schizophrenie",
      "Schizotype Persönlichkeit",
      "Schizotype Persönlichkeitsstörung",
      "Schizotype Störung",
      "Schizotypie",
      "Schizotypische Persönlichkeit"
    ]
  },
  {
    "code": "F22.0",
    "name": "Beziehungswahn",
    "synonyms": [
      "Beziehungswahn",
      "Capgras-Syndrom [Wahnsyndrom mit Personenverkennung im Sinne der Doppelgänger-Illusion]",
      "Chronische paranoide Reaktion",
      "Eifersuchtswahn",
      "Einfache paranoide Psychose",
      "Größenwahn",
      "Paranoia",
      "Paranoid-halluzinatorische Psychose",
      "Paranoide Charakterneurose",
      "Paranoide Halluzination",
      "Paranoide Psychose",
      "Paranoide Wahnvorstellung",
      "Paranoider Wahn",
      "Paranoider Zustand",
      "Paranoides Syndrom",
      "Paranoische Psychose",
      "Sensitiver Beziehungswahn",
      "Spätparaphrenie",
      "Systematisierter Wahn",
      "Verfolgungswahn",
      "Wahn",
      "Wahnhafte Störung",
      "Wahnidee",
      "Wahnsyndrom mit Personenverkennung im Sinne einer Doppelgängerillusion [Capgras-Syndrom]",
      "Wahnvorstellung"
    ]
  },
  {
    "code": "F22.8",
    "name": "Involutionsparaphrenie",
    "synonyms": [
      "Dysmorphophobie",
      "Involutionsparaphrenie",
      "Klimakterische Paraphrenie",
      "Klimakterische paranoide Psychose",
      "Klimakterische paranoide Reaktion",
      "Menopausale Paraphrenie",
      "Menopausale paranoide Psychose",
      "Paranoia querulans",
      "Paranoide Involutionspsychose",
      "Paranoide Involutionsreaktion",
      "Paranoides Zustandsbild bei Klimakterium",
      "Paranoides Zustandsbild im Involutionsalter",
      "Paranoides organisch bedingtes Zustandsbild im Involutionsalter",
      "Querulantenwahn",
      "Wahnhafte Dysmorphophobie"
    ]
  },
  {
    "code": "F22.9",
    "name": "Anhaltende wahnhafte Störung",
    "synonyms": [
      "Anhaltende wahnhafte Störung",
      "Dementia phantastica"
    ]
  },
  {
    "code": "F23.0",
    "name": "Zykloide Psychose",
    "synonyms": [
      "Akute polymorphe psychotische Störung ohne Symptome einer Schizophrenie",
      "Angstpsychose",
      "Bouffée délirante",
      "Bouffée délirante ohne Symptome einer Schizophrenie",
      "Glückspsychose",
      "Reaktive Psychose mit Verwirrtheitszustand",
      "Zykloide Psychose",
      "Zykloide Psychose ohne Symptome einer Schizophrenie"
    ]
  },
  {
    "code": "F23.1",
    "name": "Akute polymorphe psychotische Störung mit Symptomen einer Schizophrenie",
    "synonyms": [
      "Akute polymorphe psychotische Störung mit Symptomen einer Schizophrenie",
      "Bouffée délirante mit Symptomen einer Schizophrenie",
      "Verwirrtheitszustand bei schizophreniformer Psychose",
      "Zykloide Psychose mit Symptomen einer Schizophrenie"
    ]
  },
  {
    "code": "F23.2",
    "name": "Akute schizophreniforme psychotische Störung",
    "synonyms": [
      "Akute Schizophrenie a.n.k.",
      "Akute schizophreniforme psychotische Störung",
      "Akute undifferenzierte Schizophrenie",
      "Akuter schizophreniformer Anfall",
      "Kurzdauernde schizophrene Episode a.n.k.",
      "Kurze schizophreniforme Psychose",
      "Kurze schizophreniforme Störung",
      "Oneirophrenie",
      "Schizophrene Episode"
    ]
  },
  {
    "code": "F23.3",
    "name": "Akute paranoide Reaktion",
    "synonyms": [
      "Akute paranoide Reaktion",
      "Paranoide Reaktion",
      "Psychogene paranoide Psychose"
    ]
  },
  {
    "code": "F23.9",
    "name": "Reaktive Psychose",
    "synonyms": [
      "Akute Psychose",
      "Akute vorübergehende psychotische Störung",
      "Akuter psychotischer Zustand",
      "Kurze reaktive Psychose",
      "Psychogene Psychose",
      "Psychotische Episode",
      "Reaktive Psychose",
      "Reaktive Situationspsychose",
      "Reaktiver psychotischer Verwirrtheitszustand"
    ]
  },
  {
    "code": "F24",
    "name": "Induzierte wahnhafte Störung",
    "synonyms": [
      "Folie à deux",
      "Induzierte Psychose",
      "Induzierte paranoide Psychose",
      "Induzierte paranoide Störung",
      "Induzierte psychotische Störung",
      "Induzierte wahnhafte Störung",
      "Symbiotische Psychose"
    ]
  },
  {
    "code": "F25.0",
    "name": "Manische schizoaffektive Störung",
    "synonyms": [
      "Manische schizoaffektive Störung",
      "Manische schizophreniforme Psychose",
      "Schizomanische Störung"
    ]
  },
  {
    "code": "F25.1",
    "name": "Depressiv-schizoaffektive Störung",
    "synonyms": [
      "Depressiv-schizoaffektive Störung",
      "Depressive schizoaffektive Psychose",
      "Depressive schizophreniforme Psychose",
      "Schizodepressive Störung"
    ]
  },
  {
    "code": "F25.2",
    "name": "Gemischte schizoaffektive Störung",
    "synonyms": [
      "Gemischte psychotische Störung",
      "Gemischte schizoaffektive Störung",
      "Mischpsychose",
      "Schizophrene und affektive Mischpsychose",
      "Zyklische Schizophrenie"
    ]
  },
  {
    "code": "F25.9",
    "name": "Schizoaffektive Störung",
    "synonyms": [
      "Schizoaffektive Psychose",
      "Schizoaffektive Störung",
      "Schizophrene Psychose vom affektiven Typ",
      "Schizophrenie mit Affektpsychose"
    ]
  },
  {
    "code": "F28",
    "name": "Latente Psychose",
    "synonyms": [
      "Chronische Halluzinose",
      "Chronische halluzinatorische Psychose",
      "Halluzinose",
      "Involutionspsychose",
      "Klimakterische Psychose a.n.k.",
      "Larvierte Psychose",
      "Latente Psychose",
      "Menopausale Psychose a.n.k.",
      "Monomanie",
      "Psychogene Halluzination",
      "Zyklothyme Psychose"
    ]
  },
  {
    "code": "F29",
    "name": "Nichtorganische Psychose",
    "synonyms": [
      "Chronische Psychose",
      "Endogene Psychose",
      "Geisteskrankheit",
      "Geistesstörung",
      "Geistesverlust",
      "Nichtorganische Psychose",
      "Psychose",
      "Psychose unbekannter Ätiologie",
      "Psychotische Krankheit",
      "Psychotische Störung",
      "Psychotisches Syndrom",
      "Vesania"
    ]
  },
  {
    "code": "F30.0",
    "name": "Hypomanie",
    "synonyms": [
      "Hypomanie",
      "Hypomanische Episode",
      "Hypomanische Psychose",
      "Hypomanische Reaktion"
    ]
  },
  {
    "code": "F30.1",
    "name": "Manie ohne psychotische Symptome",
    "synonyms": [
      "Einzelne manische Episode ohne psychotische Symptome",
      "Manie ohne psychotische Symptome"
    ]
  },
  {
    "code": "F30.2",
    "name": "Manie mit psychotischen Symptomen",
    "synonyms": [
      "Einzelne manische Episode mit psychotischen Symptomen",
      "Manie mit parathymen psychotischen Symptomen",
      "Manie mit psychotischen Symptomen",
      "Manie mit synthymen psychotischen Symptomen",
      "Manische Psychose",
      "Manischer Stupor"
    ]
  },
  {
    "code": "F30.8",
    "name": "Reaktiver Erregungszustand",
    "synonyms": [
      "Bell-Krankheit",
      "Bell-Manie",
      "Psychogene Erregung",
      "Psychogener Erregungszustand",
      "Puerperale Manie",
      "Reaktive Erregung durch emotionalen Stress",
      "Reaktive Erregung durch seelisches Trauma",
      "Reaktive Psychose mit Erregungszustand",
      "Reaktiver Erregungszustand",
      "Wochenbettmanie"
    ]
  },
  {
    "code": "F30.9",
    "name": "Manische Episode",
    "synonyms": [
      "Einzelne manische Episode einer bipolaren Störung",
      "Endogene monopolare Manie",
      "Manie",
      "Manische Episode",
      "Manische Erregung",
      "Manische Störung",
      "Manischer Zustand",
      "Monopolare Manie",
      "Raserei"
    ]
  },
  {
    "code": "F31.0",
    "name": "Bipolare affektive Störung mit hypomanischer Episode",
    "synonyms": [
      "Bipolare affektive Störung mit hypomanischer Episode"
    ]
  },
  {
    "code": "F31.1",
    "name": "Bipolare affektive Störung mit manischer Episode ohne psychotische Symptome",
    "synonyms": [
      "Bipolare affektive Störung mit manischer Episode ohne psychotische Symptome",
      "Zyklothymie mit Manie"
    ]
  },
  {
    "code": "F31.2",
    "name": "Bipolare affektive Störung mit manischer Episode mit psychotischen Symptomen",
    "synonyms": [
      "Bipolare affektive Störung mit manischer Episode mit psychotischen Symptomen"
    ]
  },
  {
    "code": "F31.3",
    "name": "Bipolare affektive Störung mit leichter depressiver Episode",
    "synonyms": [
      "Bipolare affektive Störung mit leichter depressiver Episode",
      "Bipolare affektive Störung mit mittelgradiger depressiver Episode",
      "Zyklothymie mit Depression"
    ]
  },
  {
    "code": "F31.4",
    "name": "Bipolare affektive Störung mit schwerer depressiver Episode ohne psychotische Symptome",
    "synonyms": [
      "Bipolare affektive Störung mit schwerer depressiver Episode ohne psychotische Symptome"
    ]
  },
  {
    "code": "F31.5",
    "name": "Bipolare affektive Störung mit schwerer depressiver Episode mit psychotischen Symptomen",
    "synonyms": [
      "Bipolare affektive Störung mit schwerer depressiver Episode mit psychotischen Symptomen"
    ]
  },
  {
    "code": "F31.6",
    "name": "Manisch-depressiver Mischzustand",
    "synonyms": [
      "Bipolare affektive Störung mit gemischter Episode",
      "Manisch-depressiver Mischzustand"
    ]
  },
  {
    "code": "F31.7",
    "name": "Gegenwärtig remittierte bipolare affektive Störung",
    "synonyms": [
      "Gegenwärtig remittierte bipolare affektive Störung"
    ]
  },
  {
    "code": "F31.8",
    "name": "Manische Form der manisch-depressiven Reaktion",
    "synonyms": [
      "Bipolar-I-Störung",
      "Bipolar-II-Störung",
      "Chronische Manie",
      "Hypomanische Form der manisch-depressiven Reaktion",
      "Kurzzykler",
      "Manisch-depressiver Stupor",
      "Manische Form der manisch-depressiven Reaktion",
      "Rapid cycler",
      "Rezidivierende manische Episoden"
    ]
  },
  {
    "code": "F31.9",
    "name": "Bipolare affektive Störung",
    "synonyms": [
      "Bipolare Affektpsychose",
      "Bipolare Psychose",
      "Bipolare Störung",
      "Bipolare affektive Erkrankung",
      "Bipolare affektive Psychose",
      "Bipolare affektive Störung",
      "Manisch-depressive Krankheit",
      "Manisch-depressive Psychose",
      "Manisch-depressive Reaktion",
      "Manisch-depressive Symptomatik",
      "Manisch-depressives Syndrom",
      "Manische Depression",
      "Zyklischer Stupor"
    ]
  },
  {
    "code": "F32.0",
    "name": "Leichte depressive Episode",
    "synonyms": [
      "Depressive Störung als leichte Episode",
      "Leichte Depression",
      "Leichte depressive Episode",
      "Leichte reaktive Depression als Einzelepisode"
    ]
  },
  {
    "code": "F32.1",
    "name": "Mittelgradige depressive Episode",
    "synonyms": [
      "Depressive Störung als mittelgradige Episode",
      "Mittelgradige depressive Episode",
      "Mittelgradige reaktive Depression als Einzelepisode"
    ]
  },
  {
    "code": "F32.2",
    "name": "Schwere depressive Episode ohne psychotische Symptome",
    "synonyms": [
      "Agitierte Depression",
      "Agitierte Depression als Einzelepisode",
      "Depressive Störung als schwere Episode ohne psychotische Symptome",
      "Einzelne Episode einer majoren Depression ohne psychotische Symptome",
      "Einzelne Episode einer menopausalen agitierten Depression",
      "Einzelne Episode einer schweren reaktiven Depression ohne psychotische Symptome",
      "Einzelne Episode einer vitalen Depression ohne psychotische Symptome",
      "Einzelne schwere depressive Episode",
      "Melancholia agitata",
      "Schwere depressive Episode ohne psychotische Symptome",
      "Schwere reaktive Depression",
      "Ängstlich agitierte Depression"
    ]
  },
  {
    "code": "F32.3",
    "name": "Schwere depressive Episode mit psychotischen Symptomen",
    "synonyms": [
      "Depressive Psychose",
      "Einzelne Episode einer majoren Depression mit psychotischen Symptomen",
      "Paranoide Depression",
      "Psychogene depressive Psychose als Einzelepisode",
      "Psychotische Depression als Einzelepisode",
      "Psychotische depressive Reaktion",
      "Psychotische menopausale Depression als Einzelepisode",
      "Psychotische reaktive Depression",
      "Reaktive depressive Psychose",
      "Reaktive depressive Psychose als Einzelepisode",
      "Schwere depressive Episode mit psychotischen Symptomen"
    ]
  },
  {
    "code": "F32.8",
    "name": "Larvierte Depression",
    "synonyms": [
      "Atypische Depression",
      "Depressiver Stupor",
      "Einzelepisode einer larvierten Depression",
      "Einzelepisode einer reaktiven Depression",
      "Involutionsdepression",
      "Involutionsmelancholie",
      "Jammerdepression",
      "Klimakterische Depression",
      "Klimakterische Melancholie",
      "Larvierte Depression",
      "Menopausale Depression",
      "Menopausendepression",
      "Menopausenmelancholie",
      "Rückbildungsmelancholie",
      "Somatisierte Depression"
    ]
  },
  {
    "code": "F32.9",
    "name": "Melancholie",
    "synonyms": [
      "Akute Depression",
      "Akute reaktive Depression",
      "Altersdepression",
      "Antriebshemmung",
      "Antriebsschwäche",
      "Chronifizierte Depression",
      "Depression",
      "Depressive Entwicklung",
      "Depressive Episode",
      "Depressive Reaktion",
      "Depressive Reaktion als Einzelepisode",
      "Depressive Stimmungsschwankung",
      "Depressive Störung",
      "Depressive Verstimmung",
      "Depressive affektive Störung",
      "Depressiver Zustand",
      "Depressives Syndrom",
      "Dysphorie",
      "Dysphorisches Syndrom",
      "Erschöpfungsdepression",
      "Majore depressive Episode",
      "Melancholia",
      "Melancholie",
      "Organische Depression",
      "Pessimistische gedrückte Stimmungslage",
      "Postoperative Depression",
      "Psychogene Depression",
      "Psychogene Depression als Einzelepisode",
      "Psychogene depressive Störung",
      "Psychosomatische Depression",
      "Reaktiv-depressives Syndrom",
      "Reaktive Depression",
      "Reaktive Melancholie",
      "Schwermut",
      "Sekundäre Depression",
      "Senile Depression",
      "Senile Melancholie",
      "Traurige Verstimmung",
      "Zerebrale Depression",
      "Zerebrovaskuläre Depression"
    ]
  },
  {
    "code": "F33.0",
    "name": "Rezidivierende depressive Störung als leichte Episode",
    "synonyms": [
      "Rezidivierende depressive Störung als leichte Episode",
      "Rezidivierende leichte Episoden einer depressiven Reaktion",
      "Rezidivierende leichte Episoden einer psychogenen Depression",
      "Rezidivierende leichte Episoden einer reaktiven Depression"
    ]
  },
  {
    "code": "F33.1",
    "name": "Rezidivierende depressive Störung als mittelgradige Episode",
    "synonyms": [
      "Rezidivierende depressive Störung als mittelgradige Episode",
      "Rezidivierende mittelgradige Episoden einer depressiven Reaktion",
      "Rezidivierende mittelgradige Episoden einer psychogenen Depression",
      "Rezidivierende mittelgradige Episoden einer reaktiven Depression"
    ]
  },
  {
    "code": "F33.2",
    "name": "Depression bei manisch-depressiver Reaktion",
    "synonyms": [
      "Depression bei manisch-depressiver Psychose",
      "Depression bei manisch-depressiver Reaktion",
      "Depressive Form einer manisch-depressiven Psychose ohne psychotische Symptome",
      "Endogene Depression",
      "Endogene Depression ohne psychotische Symptome",
      "Endogene reaktive Depression ohne psychotische Symptome",
      "Endoreaktive Depression ohne psychotische Symptome",
      "Rezidivierende endogene Depression ohne psychotische Symptome",
      "Rezidivierende majore Depression ohne psychotische Symptome",
      "Rezidivierende vitale Depression ohne psychotische Symptome"
    ]
  },
  {
    "code": "F33.3",
    "name": "Rezidivierende depressive Störung als schwere Episode mit psychotischen Symptomen",
    "synonyms": [
      "Depressive Form einer manisch-depressiven Psychose mit psychotischen Symptomen",
      "Endogene Depression mit psychotischen Symptomen",
      "Rezidivierende Episoden einer psychotischen Depression",
      "Rezidivierende depressive Psychose",
      "Rezidivierende depressive Störung als schwere Episode mit psychotischen Symptomen",
      "Rezidivierende schwere Episoden einer majoren Depression mit psychotischen Symptomen",
      "Rezidivierende schwere Episoden einer psychogenen depressiven Psychose",
      "Rezidivierende schwere Episoden einer psychotischen Depression",
      "Rezidivierende schwere Episoden einer reaktiven depressiven Psychose"
    ]
  },
  {
    "code": "F33.4",
    "name": "Gegenwärtig remittierte rezidivierende depressive Störung",
    "synonyms": [
      "Gegenwärtig remittierte rezidivierende depressive Störung"
    ]
  },
  {
    "code": "F33.8",
    "name": "Rezidivierende Episode einer reaktiven Depression",
    "synonyms": [
      "Rezidivierende Episode einer psychogenen Depression",
      "Rezidivierende Episode einer psychogenen depressiven Psychose",
      "Rezidivierende Episode einer reaktiven Depression",
      "Rezidivierende Episode einer saisonalen depressiven Störung"
    ]
  },
  {
    "code": "F33.9",
    "name": "Rezidivierende depressive Störung",
    "synonyms": [
      "Chronische Depression",
      "Chronische reaktive Depression",
      "Endomonopolare Depression",
      "Monopolare Depression",
      "Periodische Depression",
      "Rezidivierende Depression",
      "Rezidivierende depressive Störung",
      "Rezidivierender depressiver Verstimmungszustand",
      "Saisonale depressive Störung"
    ]
  },
  {
    "code": "F34.0",
    "name": "Zyklothymie, depressive Phase",
    "synonyms": [
      "Affektive Persönlichkeit",
      "Affektive Persönlichkeitsstörung",
      "Affektive Psychopathie",
      "Hyperthyme Persönlichkeit",
      "Hyperthyme Persönlichkeitsstörung",
      "Zykloide Persönlichkeit",
      "Zyklothyme Depression",
      "Zyklothyme Persönlichkeit",
      "Zyklothyme Persönlichkeitsstörung",
      "Zyklothymes Temperament",
      "Zyklothymia",
      "Zyklothymie",
      "Zyklothymie, depressive Phase"
    ]
  },
  {
    "code": "F34.1",
    "name": "Depressive Neurose",
    "synonyms": [
      "Anhaltende ängstliche Depression",
      "Depressive Neurose",
      "Depressive Persönlichkeitsstörung",
      "Dysthymia",
      "Dysthymie",
      "Hypothyme Persönlichkeit",
      "Hypothyme Persönlichkeitsstörung",
      "Hypothyme Psychopathie",
      "Nervöse Depression",
      "Neurotisch-depressive Reaktion",
      "Neurotisch-depressive Verstimmung",
      "Neurotisch-depressiver Zustand",
      "Neurotische Depression",
      "Neurotische Depression ohne psychotische Symptome",
      "Neurotischer Zustand mit depressiven Phasen",
      "Psychoneurotische Depression",
      "Reaktive depressive Verstimmung"
    ]
  },
  {
    "code": "F34.9",
    "name": "Anhaltende affektive Störung",
    "synonyms": [
      "Anhaltende affektive Störung",
      "Anhaltende emotionale Störung",
      "Persistierende affektive Störung"
    ]
  },
  {
    "code": "F38.0",
    "name": "Affektlabilität",
    "synonyms": [
      "Affektlabilität",
      "Einzelne affektive Störung a.n.k.",
      "Gemischte affektive Episode",
      "Hyperthymie"
    ]
  },
  {
    "code": "F38.1",
    "name": "Rezidivierende kurze depressive Episoden",
    "synonyms": [
      "Rezidivierende affektive Störung a.n.k.",
      "Rezidivierende kurze depressive Episoden"
    ]
  },
  {
    "code": "F39",
    "name": "Affektive Psychose a.n.k.",
    "synonyms": [
      "Affektive Psychose a.n.k.",
      "Affektive Reaktion",
      "Affektive Störung",
      "Emotionale Störung"
    ]
  },
  {
    "code": "F40.00",
    "name": "Agoraphobie",
    "synonyms": [
      "Agoraphobie",
      "Agoraphobie ohne Panikstörung",
      "Ochlophobie",
      "Platzangst"
    ]
  },
  {
    "code": "F40.01",
    "name": "Agoraphobie mit Panikstörung",
    "synonyms": [
      "Agoraphobie mit Panik",
      "Agoraphobie mit Panikstörung"
    ]
  },
  {
    "code": "F40.1",
    "name": "Soziale Phobie",
    "synonyms": [
      "Anthropophobie",
      "Gynäkophobie",
      "Soziale Neurose",
      "Soziale Phobie",
      "Xenophobie"
    ]
  },
  {
    "code": "F40.2",
    "name": "Zoophobie",
    "synonyms": [
      "Aichmophobie",
      "Akarophobie",
      "Akrophobie",
      "Angst vor Spritzen",
      "Arztphobie",
      "Bathophobie",
      "Claustrophobia",
      "Einfache Phobie",
      "Erythrophobie",
      "Examensangst",
      "Gephyrophobie",
      "Höhenangst",
      "Isolierte Phobie",
      "Klaustrophobie",
      "Mysophobie",
      "Nadelphobie",
      "Parasitophobie",
      "Prüfungsangst",
      "Sitophobie",
      "Spezifische Phobie",
      "Tierphobie",
      "Zoophobie"
    ]
  },
  {
    "code": "F40.8",
    "name": "Phobische Neurose",
    "synonyms": [
      "Phobische Neurose"
    ]
  },
  {
    "code": "F40.9",
    "name": "Phobische Störung",
    "synonyms": [
      "Furcht",
      "Furchtkomplex",
      "Furchtsamkeit",
      "Krankhafte Angst",
      "Phobie",
      "Phobische Störung",
      "Phobischer Zustand",
      "Phobisches Syndrom"
    ]
  },
  {
    "code": "F41.0",
    "name": "Panik",
    "synonyms": [
      "Episodisch paroxysmale Angst",
      "Panik",
      "Panikanfall",
      "Panikattacke",
      "Panikneurose",
      "Panikstörung",
      "Paniksyndrom",
      "Panikzustand",
      "Panischer Anfall"
    ]
  },
  {
    "code": "F41.1",
    "name": "Phobische Reaktion",
    "synonyms": [
      "Angstneurose",
      "Angstreaktion",
      "Angstsyndrom",
      "Angstzustand",
      "Chronische Angstneurose",
      "Frei flottierende Angst",
      "Furchtreaktion",
      "Generalisierte Angst",
      "Generalisierte Angststörung",
      "Neurotischer Angstzustand",
      "Phobische Reaktion",
      "Psychoneurotischer Angstzustand",
      "Reaktiver Angstzustand"
    ]
  },
  {
    "code": "F41.2",
    "name": "Angst und depressive Störung, gemischt",
    "synonyms": [
      "Angst und depressive Reaktion, gemischt",
      "Angst und depressive Störung, gemischt",
      "Angstattacke",
      "Angstdepression",
      "Depressive ängstliche Entwicklung",
      "Depressiver Angstzustand",
      "Leichte ängstliche Depression",
      "Neurotischer depressiver Angstzustand",
      "Nichtanhaltende ängstliche Depression",
      "Ängstlich-depressive Verstimmung",
      "Ängstlich-depressives Syndrom",
      "Ängstliche Depression"
    ]
  },
  {
    "code": "F41.3",
    "name": "Akuter Angstzustand und Spannungszustand",
    "synonyms": [
      "Akuter Angstzustand und Spannungszustand",
      "Angst-Spannungsschmerz-Syndrom"
    ]
  },
  {
    "code": "F41.8",
    "name": "Angsthysterie",
    "synonyms": [
      "Angsthysterie"
    ]
  },
  {
    "code": "F41.9",
    "name": "Angst",
    "synonyms": [
      "Angst",
      "Angsterkrankung",
      "Angstgefühl",
      "Angststörung",
      "Bangigkeit",
      "Befürchtung",
      "Bänglichkeit",
      "Pessimismus",
      "Ängstlichkeit"
    ]
  },
  {
    "code": "F42.0",
    "name": "Grübelzwang",
    "synonyms": [
      "Grübelsucht",
      "Grübelzwang",
      "Neurotische Rumination",
      "Psychogene Rumination",
      "Psychogene Störung mit Zwangsgedanken",
      "Psychoneurotische Reaktion mit Zwangsgedanken",
      "Zwangsgedanken",
      "Zwangsideen",
      "Zwangsrumination",
      "Zwangsvorstellungen",
      "Zwangsvorstellungssyndrom"
    ]
  },
  {
    "code": "F42.1",
    "name": "Vorwiegend Zwangshandlung",
    "synonyms": [
      "Impulsivneurose",
      "Kompulsive psychoneurotische Reaktion",
      "Vorwiegend Zwangshandlung",
      "Vorwiegend Zwangsrituale",
      "Zwangshandlung"
    ]
  },
  {
    "code": "F42.2",
    "name": "Zwangsgedanken und Zwangshandlungen, gemischt",
    "synonyms": [
      "Zwangsgedanken und Zwangshandlungen, gemischt"
    ]
  },
  {
    "code": "F42.9",
    "name": "Zwangssyndrom",
    "synonyms": [
      "Anankasmus",
      "Anankastische Depression",
      "Anankastische Neurose",
      "Zwangskrankheit",
      "Zwangsneurose",
      "Zwangsphobie",
      "Zwangsreaktion",
      "Zwangsstörung",
      "Zwangssyndrom"
    ]
  },
  {
    "code": "F43.0",
    "name": "Akute Belastungsreaktion mit vorherrschender psychomotorischer Störung",
    "synonyms": [
      "Akute Belastungsreaktion",
      "Akute Belastungsreaktion mit Bewusstseinsstörung",
      "Akute Belastungsreaktion mit emotionaler Krise",
      "Akute Belastungsreaktion mit emotionaler Störung",
      "Akute Belastungsreaktion mit psychomotorischer Störung",
      "Akute Belastungsreaktion mit vorherrschender psychomotorischer Störung",
      "Akute Belastungsreaktion, Mischform",
      "Akute Hassreaktion",
      "Akute Krisenreaktion",
      "Akute Situationsreaktion",
      "Akute Situationsstörung",
      "Akute Stressreaktion",
      "Akute nervöse Erschöpfung",
      "Akute psychische Dekompensation",
      "Combat fatigue",
      "Erschöpfungsdelirium",
      "Erschöpfungspsychose",
      "Kampfneurose",
      "Kriegsneurose",
      "Krisenzustand",
      "Notstandssyndrom",
      "Panikreaktion auf außergewöhnlichen Stress",
      "Präoperativer Konflikt",
      "Psychischer Schock",
      "Psychosoziale Krise",
      "Vorwiegend psychomotorische Störung bei reaktivem Ausnahmezustand",
      "Vorübergehende Fugue als Reaktion auf außerordentliche Belastung",
      "Vorübergehender Stupor als Reaktion auf außergewöhnlichen Stress"
    ]
  },
  {
    "code": "F43.1",
    "name": "Posttraumatische Belastungsstörung [PTBS]",
    "synonyms": [
      "Fremdneurose",
      "Posttraumatische Belastungsstörung [PTBS]",
      "Posttraumatische Verbitterungsstörung",
      "Traumatische Neurose",
      "Unfallneurose"
    ]
  },
  {
    "code": "F43.2",
    "name": "Hospitalismus beim Kind",
    "synonyms": [
      "Abnorme Adaptationsreaktion",
      "Abnorme Anpassungsreaktion",
      "Abnorme Situationsreaktion",
      "Abnorme Trauerreaktion",
      "Adaptationsstörung",
      "Adaptationssyndrom",
      "Anpassungsstörung",
      "Anpassungsstörung des Sozialverhaltens",
      "Anpassungsstörung im Alter",
      "Anpassungsstörung im Jugendalter",
      "Anpassungsstörung mit emotionaler Krise",
      "Anpassungsstörung mit emotionaler Symptomatik",
      "Anpassungssyndrom",
      "Culture shock",
      "Emotionale Krise",
      "Heimweh",
      "Hospitalismus beim Kind",
      "Kulturschock",
      "Kurzdauernde depressive Reaktion bei Anpassungsstörung",
      "Langdauernde depressive Reaktion bei Anpassungsstörung",
      "Leichter Hospitalismus beim Kind",
      "Nostalgie",
      "Psychische Anpassungsstörung",
      "Soziale Anpassungsstörung mit emotionaler Beeinträchtigung",
      "Stresssyndrom",
      "Temporäre Situationsstörung",
      "Trennungsangst",
      "Vorübergehende Situationsstörung"
    ]
  },
  {
    "code": "F43.8",
    "name": "Reaktive psychische Störung",
    "synonyms": [
      "Reaktive psychische Störung"
    ]
  },
  {
    "code": "F43.9",
    "name": "Unklarer Ausnahmezustand",
    "synonyms": [
      "Managerkrankheit",
      "Nervenzusammenbruch",
      "Overstressedsyndrom",
      "Psychische Dekompensation",
      "Psychischer Ausnahmezustand",
      "Psychogene Belastungsreaktion",
      "Reaktion bei Belastung",
      "Reaktion bei schwerer Belastung",
      "Schwere Stressreaktion",
      "Spannungszustand",
      "Störung bei Belastung",
      "Unklarer Ausnahmezustand",
      "Unklarer psychogener Ausnahmezustand",
      "Versagenszustand"
    ]
  },
  {
    "code": "F44.0",
    "name": "Dissoziative Amnesie",
    "synonyms": [
      "Dissoziative Amnesie",
      "Hysterische Amnesie",
      "Psychogene Amnesie"
    ]
  },
  {
    "code": "F44.1",
    "name": "Dissoziative Fugue",
    "synonyms": [
      "Dissoziative Fugue",
      "Hysterische Fugue"
    ]
  },
  {
    "code": "F44.2",
    "name": "Dissoziativer Stupor",
    "synonyms": [
      "Dissoziativer Stupor",
      "Hysterische Katalepsie",
      "Hysterische Körperhaltung",
      "Katalepsie",
      "Kataleptischer Anfall",
      "Psychogener Stupor"
    ]
  },
  {
    "code": "F44.3",
    "name": "Besessenheitszustand",
    "synonyms": [
      "Besessenheitszustand",
      "Hysterische Trance"
    ]
  },
  {
    "code": "F44.4",
    "name": "Abasie",
    "synonyms": [
      "Abasie",
      "Astasie",
      "Ataxie nichtorganischen Ursprungs",
      "Dissoziative Bewegungsstörung",
      "Dissoziative psychomotorische Störung",
      "Dysbasie nichtorganischen Ursprungs",
      "Dyskinesie nichtorganischen Ursprungs",
      "Funktionelle Abasie",
      "Funktionelle Astasie",
      "Funktionelle Dysphonie",
      "Funktionelle Paraplegie",
      "Hysterische Abasie",
      "Hysterische Armparalyse",
      "Hysterische Astasie",
      "Hysterische Asthenie",
      "Hysterische Ataxie",
      "Hysterische Beinparalyse",
      "Hysterische Dysbasie",
      "Hysterische Dyskinesie",
      "Hysterische Dysphonie",
      "Hysterische Ganganomalie",
      "Hysterische Gangstörung",
      "Hysterische Handparalyse",
      "Hysterische Hemiplegie",
      "Hysterische Kamptokormie",
      "Hysterische Kontraktion",
      "Hysterische Larynxneurose",
      "Hysterische Paralyse",
      "Hysterische Paraplegie",
      "Hysterische Schluckparalyse",
      "Hysterische Stummheit",
      "Hysterische flüchtige Monoplegie",
      "Hysterischer Larynxspasmus",
      "Hysterischer Mutismus",
      "Hysterischer Spasmus",
      "Hysterischer Spasmus glottidis",
      "Hysterischer Tortikollis",
      "Hysterischer Tremor",
      "Kamptokormie",
      "Psychogene Aphonie",
      "Psychogene Ataxie",
      "Psychogene Bewegungsstörung",
      "Psychogene Dysbasie",
      "Psychogene Dyskinesie",
      "Psychogene Dysphonie",
      "Psychogene Dystonie",
      "Psychogene Monoplegie",
      "Psychogene Muskelkontraktion als Konversionsreaktion",
      "Psychogene motorische Störung",
      "Psychogener Tremor als Konversionsreaktion",
      "Psychomotorische Störung a.n.k.",
      "Psychomotorisches Defizit"
    ]
  },
  {
    "code": "F44.5",
    "name": "Dissoziativer Krampfanfall",
    "synonyms": [
      "Dissoziativer Krampfanfall",
      "Funktionelle Tetanie",
      "Hyperkinetische hysterische Tetanie",
      "Hysterische Konvulsionen",
      "Hysterische Pseudotetanie",
      "Hysterische Tetanie",
      "Hysterischer Anfall",
      "Hysteroepilepsie",
      "Pseudoanfall",
      "Psychogene Tetanie"
    ]
  },
  {
    "code": "F44.6",
    "name": "Hysterische Amaurose",
    "synonyms": [
      "Dissoziative Blindheit",
      "Dissoziative Empfindungsstörung",
      "Dissoziative Sensibilitätsstörung",
      "Dissoziative Sinneswahrnehmungsstörung",
      "Dissoziative funktionelle Anästhesie",
      "Emotionale Blindheit",
      "Emotionale Schwerhörigkeit",
      "Emotionale Taubheit",
      "Funktionelle Schwerhörigkeit",
      "Funktionelle Taubheit",
      "Hysterische Ageusie",
      "Hysterische Amaurose",
      "Hysterische Amblyopie",
      "Hysterische Anosmie",
      "Hysterische Anästhesie",
      "Hysterische Asthenopie",
      "Hysterische Blindheit",
      "Hysterische Dysästhesie",
      "Hysterische Schwerhörigkeit",
      "Hysterische Taubheit",
      "Hysterische Taubstummheit",
      "Psychogene Asthenopie",
      "Psychogene Empfindungsstörung",
      "Psychogene Perzeptionsstörung",
      "Psychogene Schwerhörigkeit",
      "Psychogene Taubheit"
    ]
  },
  {
    "code": "F44.7",
    "name": "Gemischte dissoziative Störung",
    "synonyms": [
      "Gemischte Konversionsstörung",
      "Gemischte dissoziative Störung"
    ]
  },
  {
    "code": "F44.80",
    "name": "Ganser-Syndrom",
    "synonyms": [
      "Ganser-Syndrom"
    ]
  },
  {
    "code": "F44.81",
    "name": "Multiple Persönlichkeitsstörungen",
    "synonyms": [
      "Multiple Persönlichkeitsstörungen"
    ]
  },
  {
    "code": "F44.82",
    "name": "Vorübergehende dissoziative Störung in der Kindheit und Jugend",
    "synonyms": [
      "Vorübergehende dissoziative Störung in der Kindheit und Jugend"
    ]
  },
  {
    "code": "F44.88",
    "name": "Psychogener Anfall",
    "synonyms": [
      "Alternierende Persönlichkeitsstörung",
      "Dissoziativer Ohnmachtsanfall",
      "Hysterische Anorexie",
      "Hysterische Depression",
      "Hysterische Larynxhyperästhesie",
      "Hysterische Manie",
      "Hysterische Mondsüchtigkeit",
      "Hysterische Pharynxhyperästhesie",
      "Hysterische Vertigo",
      "Hysterischer Dämmerzustand",
      "Hysterischer Kollaps",
      "Hysterischer Schwindel",
      "Hysterischer Somnambulismus",
      "Hysterischer Traumzustand",
      "Hysterisches Delirium",
      "Hysterisches Nachtwandeln",
      "Hysterisches Schlafwandeln",
      "Psychogene Orientierungsstörung",
      "Psychogene Verwirrtheit",
      "Psychogener Anfall",
      "Psychogener Dämmerzustand",
      "Reaktive Verwirrtheit durch emotionale Belastung"
    ]
  },
  {
    "code": "F44.9",
    "name": "Dissoziative Störung",
    "synonyms": [
      "Akute hysterische Psychose",
      "Dissoziative Reaktion",
      "Dissoziative Störung",
      "Hysterie",
      "Hysterische Neurose",
      "Hysterische Psychoneurose",
      "Hysterische Reaktion",
      "Kompensationsneurose",
      "Konversionshysterie",
      "Konversionsneurose",
      "Konversionsreaktion",
      "Konversionsstörung",
      "Konversionsstörung mit Hysterie",
      "Konversionsstörung mit Neurose",
      "Reaktive Konversionsstörung"
    ]
  },
  {
    "code": "F45.0",
    "name": "Somatisierungsstörung",
    "synonyms": [
      "Briquet-Störung",
      "Briquet-Syndrom",
      "Multiple psychosomatische Störungen",
      "Multiples Beschwerde-Syndrom",
      "Somatisierungsstörung"
    ]
  },
  {
    "code": "F45.1",
    "name": "Undifferenzierte Somatisierungsstörung",
    "synonyms": [
      "Psychosomatische Stigmatisierung",
      "Undifferenzierte Somatisierungsstörung",
      "Undifferenzierte psychosomatische Störung"
    ]
  },
  {
    "code": "F45.2",
    "name": "Hypochondrische Störung",
    "synonyms": [
      "AIDS-Phobie",
      "Abortangst",
      "Abortphobie",
      "Angst vor Schwangerschaft",
      "Carcinophobia",
      "Cheyne-Krankheit",
      "Cheyne-Syndrom",
      "Gravidophobie",
      "Herzangst",
      "Herzangstsyndrom",
      "Herzhypochondrie",
      "Herzphobie",
      "Hypochondrie",
      "Hypochondrische Beschwerden",
      "Hypochondrische Depression",
      "Hypochondrische Neurose",
      "Hypochondrische Reaktion",
      "Hypochondrische Störung",
      "Hypochondrischer Wahn",
      "Kankrophobie",
      "Kanzerophobie",
      "Kardiophobie",
      "Karzinophobie",
      "Krankheitsfurcht",
      "Krankheitswahn",
      "Krebsangst",
      "Körperdysmorphophobe Störung",
      "Malignomangst",
      "Missbildungsangst",
      "Nichtwahnhafte Dysmorphophobie",
      "Nosomanie",
      "Nosophobie",
      "Rezidivangst",
      "Ringelröteln-Phobie",
      "Schwangerschaftsphobie",
      "Syphilophobie",
      "Thromboembolieangst",
      "Thromboseangst"
    ]
  },
  {
    "code": "F45.30",
    "name": "Angioneurose",
    "synonyms": [
      "Angioneuropathie",
      "Angioneurose",
      "Cor nervosum",
      "Funktionelle Dyskardie",
      "Herz-Kreislauf-Neurose",
      "Herzirritabilität",
      "Herzneurose",
      "Kardiale Neurasthenie",
      "Kardioneurose",
      "Kardiovaskuläre Neurose",
      "Myokardirritabilität",
      "Nervöse Herz-Kreislauf-Beschwerden",
      "Nervöse Herzbeschwerden",
      "Nervöses Herz",
      "Neurogene Herzstörung",
      "Neurovegetative Kreislaufstörung",
      "Neurozirkulatorische Asthenie",
      "Neurozirkulatorischer Kollaps",
      "Organneurose des Herz-Kreislauf-Systems",
      "Phrenokardie",
      "Psychogene AV [Atrioventrikular]-junktionale Tachykardie",
      "Psychogene Arrhythmie",
      "Psychogene Herzasthenie",
      "Psychogene Herzbeschwerden",
      "Psychogene Herzkrankheit",
      "Psychogene Herzrhythmusstörung",
      "Psychogene Herzstörung",
      "Psychogene Hypertonie",
      "Psychogene Kreislaufstörung",
      "Psychogene Palpitationen",
      "Psychogene Tachykardie",
      "Psychogene funktionelle Herzkrankheit",
      "Psychogene kardiale Asthenie",
      "Psychogene kardiovaskuläre Asthenie",
      "Psychogene kardiovaskuläre Störung",
      "Psychogene myokardiale Asthenie",
      "Psychogene neurozirkulatorische Störung",
      "Psychogene paroxysmale Tachykardie",
      "Psychogener Gefäßspasmus",
      "Psychogener vasovagaler Anfall",
      "Psychogenes Vasovagalsyndrom",
      "Psychokardiomyopathie",
      "Psychosomatische Herzbeschwerden",
      "Vasomotorische Neurose",
      "Vegetative Herz-Kreislauf-Störung",
      "Vegetative Herzbeschwerden",
      "Vegetative Herzneurose"
    ]
  },
  {
    "code": "F45.31",
    "name": "Aerophagie",
    "synonyms": [
      "Aerophagie",
      "Funktionelle psychogene Magenkrankheit",
      "Gastrische Neurasthenie",
      "Gastrische Neurose",
      "Hysterischer Ptyalismus",
      "Luftschlucken",
      "Magenneurose",
      "Nervöse Dyspepsie",
      "Nervöse Efflation",
      "Nervöse Eruktation",
      "Nervöse Magenbeschwerden",
      "Nervöse psychogene Magenbeschwerden",
      "Nervöser Magen",
      "Nervöses Aufstoßen",
      "Nervöses Magenleiden",
      "Neurotische Dyspepsie",
      "Neurotische Gastrosukkorrhoe",
      "Neurotische Hyperchlorhydrie",
      "Neurotische Hypochlorhydrie",
      "Pneumophagie",
      "Psychogene Achlorhydrie",
      "Psychogene Achylia gastrica",
      "Psychogene Achylie",
      "Psychogene Aerophagie",
      "Psychogene Anazidität",
      "Psychogene Apepsie",
      "Psychogene Azidität",
      "Psychogene Dyspepsie",
      "Psychogene Eruktation",
      "Psychogene Gastrektasie",
      "Psychogene Gastrosukkorrhoe",
      "Psychogene Hyperazidität",
      "Psychogene Hyperchlorhydrie",
      "Psychogene Hyperemesis",
      "Psychogene Hypermobilität des Magens",
      "Psychogene Hypersensibilität des Magens",
      "Psychogene Hypoazidität",
      "Psychogene Hypochlorhydrie",
      "Psychogene Hypomotilität des Magens",
      "Psychogene Magenatonie",
      "Psychogene Magendilatation",
      "Psychogene Magendysfunktion",
      "Psychogene Magenirritabilität",
      "Psychogene Magenkontraktur",
      "Psychogene Pneumophagie",
      "Psychogene Rossbach-Krankheit",
      "Psychogene Sanduhrkontraktur des Magens",
      "Psychogene Störung der Magenfunktion",
      "Psychogene Subazidität",
      "Psychogene Superazidität",
      "Psychogene gastrische Hyperchylie",
      "Psychogene gastrische Hypersekretion",
      "Psychogene Ösophaguskrankheit",
      "Psychogene Ösophagusstörung",
      "Psychogener Gastrospasmus",
      "Psychogener Lufthunger",
      "Psychogener Magen",
      "Psychogener Magensäuremangel",
      "Psychogener Ptyalismus",
      "Psychogener Pylorospasmus",
      "Psychogener Reizmagen",
      "Psychogener Sanduhrmagen",
      "Psychogener Ösophagusspasmus",
      "Psychogenes Aufstoßen",
      "Psychogenes Luftschlucken",
      "Psychogenes Sodbrennen"
    ]
  },
  {
    "code": "F45.32",
    "name": "Psychogener Enterospasmus",
    "synonyms": [
      "Darmneurose",
      "Enteroneurose",
      "Funktionelle psychogene Diarrhoe",
      "Funktionelle psychogene Kolonkrankheit",
      "Intestinumneurose",
      "Kolonneurose",
      "Nervöse Diarrhoe",
      "Psychogene Darmatonie",
      "Psychogene Darmneurose",
      "Psychogene Darmstörung",
      "Psychogene Diarrhoe",
      "Psychogene Flatulenz",
      "Psychogene Hypermobilität des Darmes",
      "Psychogene Hypermobilität des Intestinums",
      "Psychogene Hypermobilität des Kolons",
      "Psychogene Hypersensibilität des Kolons",
      "Psychogene Hypomotilität des Darmes",
      "Psychogene Ileumdilatation",
      "Psychogene Intestinumstörung",
      "Psychogene Jejunumdilatation",
      "Psychogene Kolondilatation",
      "Psychogene Kolondysfunktion",
      "Psychogene Kolonirritabilität",
      "Psychogene Obstipation",
      "Psychogene Rektumdysfunktion",
      "Psychogene Zäkumatonie",
      "Psychogene Zäkumdilatation",
      "Psychogene rektale Störung",
      "Psychogener Analspasmus",
      "Psychogener Darmkrampf",
      "Psychogener Darmspasmus",
      "Psychogener Enterospasmus",
      "Psychogener Intestinumspasmus",
      "Psychogener Kolonspasmus",
      "Psychogener Proktospasmus",
      "Psychogener Rektumspasmus",
      "Psychogener Sigmaspasmus",
      "Psychogener Spasmus der Flexura coli sigmoidea",
      "Psychogener Spasmus des Gastrointestinaltraktes",
      "Psychogener Spasmus des Verdauungstraktes",
      "Psychogener Zäkumspasmus",
      "Psychogenes Colon irritabile",
      "Psychogenes irritables Kolon",
      "Psychogenes spastisches Kolon",
      "Rektumneurose"
    ]
  },
  {
    "code": "F45.33",
    "name": "Atemneurose",
    "synonyms": [
      "Atemneurose",
      "Funktionelle Dyspnoe",
      "Funktionelle Störung der Atmungsorgane",
      "Funktionelle Störung psychischen Ursprungs der Atmungsorgane",
      "Funktioneller Husten",
      "Hyperventilationssyndrom",
      "Hysterische Dyspnoe",
      "Hysterische Hyperventilation",
      "Hysterische Hyperventilationstetanie",
      "Hysterische Tachypnoe",
      "Hysterische Tetanie mit Hyperpnoe",
      "Hysterischer Husten",
      "Hysterischer Pharynxspasmus",
      "Hysterischer Rachenspasmus",
      "Inkoordinationsneurose des Larynx",
      "Inkoordinationsneurose einer Stimmlippe",
      "Inkoordinationsneurose eines Stimmbandes",
      "Larynxneurose",
      "Organneurose der Atmungsorgane",
      "Pharynxneurose",
      "Psychogene Atemstörung",
      "Psychogene Atmungsstörung",
      "Psychogene Dyspnoe",
      "Psychogene Hyperventilation",
      "Psychogene Hyperventilationstetanie",
      "Psychogene Störung der Atmungsorgane",
      "Psychogene Tachypnoe",
      "Psychogene Tetanie mit Hyperpnoe",
      "Psychogene ziehende Atmung",
      "Psychogener Husten",
      "Psychogener Larynxspasmus",
      "Psychogener Pharynxspasmus",
      "Psychogener Rachenspasmus",
      "Psychogener Schluckauf",
      "Psychogener Singultus",
      "Psychogener Spasmus glottidis",
      "Psychogenes Gähnen",
      "Sensorische Larynxneurose",
      "Subjektives Atemnotgefühl"
    ]
  },
  {
    "code": "F45.34",
    "name": "Genitalneurose",
    "synonyms": [
      "Blasenneurose",
      "Genitalneurose",
      "Harnblasenneurose",
      "Häufiges psychogenes Wasserlassen",
      "Nervöse Pollakisurie",
      "Psychogen bedingte erhöhte Miktionshäufigkeit",
      "Psychogene Basalzellüberfunktion der Cervix uteri",
      "Psychogene Dysurie",
      "Psychogene Harnblasenträgheit",
      "Psychogene Harnentleerungsstörung",
      "Psychogene Harnverhaltung",
      "Psychogene Miktionsstörung",
      "Psychogene Nykturie",
      "Psychogene Pollakisurie",
      "Psychogene Restharnretention",
      "Psychogene Retentio urinae",
      "Psychogene Störung der Harn- und Geschlechtsorgane",
      "Psychogene Störung der Harnorgane",
      "Psychogene Störung des Urogenitalsystems",
      "Psychogene häufige Miktion",
      "Psychogene schmerzhafte Miktion"
    ]
  },
  {
    "code": "F45.37",
    "name": "Gastrokardialer Symptomenkomplex",
    "synonyms": [
      "Da-Costa-Syndrom",
      "Effort-Syndrom",
      "Funktionelle Störung psychischen Ursprungs des Magen-Darm-Traktes",
      "GKSK [Gastrokardialer Symptomenkomplex]",
      "Gastroenteroneurose",
      "Gastrointestinale Neurose",
      "Gastrokardialer Symptomenkomplex",
      "Gastrokardialsyndrom",
      "Nervöse Indigestion",
      "Organneurose des Magen-Darm-Traktes",
      "Psychogene Indigestion",
      "Psychogene Magen-Darm-Störung",
      "Psychogene gastrointestinale Hypomotilität",
      "Psychogene gastrointestinale Reizung",
      "Psychogene gastrointestinale Störung",
      "Roemheld-Symptomenkomplex",
      "Roemheld-Syndrom"
    ]
  },
  {
    "code": "F45.38",
    "name": "Psychogener Diaphragmaspasmus",
    "synonyms": [
      "Psychogener Diaphragmaspasmus"
    ]
  },
  {
    "code": "F45.39",
    "name": "Funktionelle nichtorganische Oberbauchbeschwerden",
    "synonyms": [
      "Funktionelle nichtorganische Oberbauchbeschwerden",
      "Funktionelle psychovegetative Beschwerden",
      "Hysterische Kolik",
      "Nervöse Störung des Verdauungssystems",
      "Nervöse Verdauungsstörung",
      "Psychogene Abdomenschmerzen",
      "Psychogene Bauchschmerzen",
      "Psychogene Hyperperistaltik",
      "Psychogene Kolik",
      "Psychogene Störung des Verdauungssystems",
      "Psychogene Verdauungsstörung",
      "Somatoforme autonome Dysfunktion",
      "Somatoforme autonome Funktionsstörung",
      "Viszerale Neurose"
    ]
  },
  {
    "code": "F45.40",
    "name": "Psychogene Wirbelsäulenschmerzen",
    "synonyms": [
      "Anhaltende somatoforme schmerzhafte Störung",
      "Cephalgia nichtorganischen Ursprungs",
      "Emotionale Kopfschmerzen",
      "Kopfschmerzen nichtorganischen Ursprungs",
      "Nervöse Kephalgie",
      "Nervöse Kopfschmerzen",
      "Neuralgismus",
      "Persistierende psychogene Schmerzen",
      "Pseudoneuralgie",
      "Psychalgie",
      "Psychogene Arthralgie",
      "Psychogene Arthrodynie",
      "Psychogene Brustdrüsenschmerzen",
      "Psychogene Dorsalgie",
      "Psychogene Gastralgie",
      "Psychogene Gelenkschmerzen",
      "Psychogene Herzschmerzen",
      "Psychogene Hodenschmerzen",
      "Psychogene Kopfschmerzen",
      "Psychogene Magenschmerzen",
      "Psychogene Mammaschmerzen",
      "Psychogene Mastalgie",
      "Psychogene Mastodynie",
      "Psychogene Myalgie",
      "Psychogene Nackenschmerzen",
      "Psychogene Penisschmerzen",
      "Psychogene Polyarthralgie",
      "Psychogene Präkordialschmerzen",
      "Psychogene Rückenschmerzen",
      "Psychogene Schmerzen der Genitalorgane",
      "Psychogene Schmerzen des gastrointestinalen Systems",
      "Psychogene Schmerzen im Halswirbelsäulenbereich",
      "Psychogene Schmerzen im Skrotum",
      "Psychogene Schmerzen im Testis",
      "Psychogene Schmerzen im Uterus",
      "Psychogene Schmerzen im Weichteilgewebe",
      "Psychogene Wirbelsäulenschmerzen",
      "Psychogene gastrische Schmerzen",
      "Psychogene spastische Proktalgie",
      "Somatoforme Schmerzstörung"
    ]
  },
  {
    "code": "F45.41",
    "name": "Chronische Schmerzstörung mit somatischen und psychischen Faktoren",
    "synonyms": [
      "Chronische Schmerzstörung mit somatischen und psychischen Faktoren"
    ]
  },
  {
    "code": "F45.8",
    "name": "Funktionelle Störung des Urogenitalsystems",
    "synonyms": [
      "Augenneurose",
      "Bruxismus",
      "Brygmus",
      "Eingebildete Gravidität",
      "Eingebildete Schwangerschaft",
      "Engegefühl im Hals",
      "Fremdkörpergefühl im Hals",
      "Funktionelle Dysphagie",
      "Funktionelle Störung der Haut",
      "Funktionelle Störung des Muskel-Skelett-Systems",
      "Funktionelle Störung des Urogenitalsystems",
      "Funktionelle Störung psychischen Ursprungs der Haut",
      "Funktionelle Störung psychischen Ursprungs des Muskel-Skelett-Systems",
      "Funktionelle Störung psychischen Ursprungs des Urogenitalsystems",
      "Funktionsstörung psychischen Ursprungs",
      "Gelenkneurose",
      "Globus",
      "Globus hystericus",
      "Globus nervosus",
      "Globusgefühl",
      "Grossesse imaginaire",
      "Hautneurose",
      "Hysterische Dysphagie",
      "Hysterische Pseudogravidität",
      "Hysterische Pseudoschwangerschaft",
      "Inkoordinationsneurose",
      "Kloßgefühl im Hals",
      "Muskel-Skelett-Neurose",
      "Muskelneurose",
      "Nervöse Dysphagie",
      "Nervöser Spasmus",
      "Neurogener Pruritus",
      "Neurovegetative Prostatabeschwerden",
      "Neurovegetative Prostatopathie",
      "Neurovegetatives Prostatasyndrom",
      "Organneurose der Haut",
      "Organneurose der Muskeln",
      "Organneurose des Urogenitalsystems",
      "Organneurose des endokrinen Systems",
      "Organneurose eines Sinnesorgans",
      "Parametropathia spastica",
      "Pelvipathia spastica",
      "Pelvipathia vegetativa",
      "Pelvipathie",
      "Pelvipathiesyndrom",
      "Phantomtumor",
      "Pseudogravidität",
      "Pseudokyesis",
      "Pseudoschwangerschaft",
      "Psychogene Analsphinkterrelaxation",
      "Psychogene Armparalyse",
      "Psychogene Augenstörung",
      "Psychogene Beinparalyse",
      "Psychogene Blutsystemstörung",
      "Psychogene Dysmenorrhoe",
      "Psychogene Dysphagie",
      "Psychogene Gelenkstörung",
      "Psychogene Geruchssinnstörung",
      "Psychogene Geruchstäuschung",
      "Psychogene Gliedmaßenstörung",
      "Psychogene Handparalyse",
      "Psychogene Hautreaktion",
      "Psychogene Hautstörung",
      "Psychogene Hyperhidrose",
      "Psychogene Lymphsystemstörung",
      "Psychogene Menstruationsschmerzen",
      "Psychogene Menstruationsstörung",
      "Psychogene Metrorrhagie",
      "Psychogene Muskelstörung",
      "Psychogene Parageusie",
      "Psychogene Paralyse",
      "Psychogene Paraplegie",
      "Psychogene Parosmie",
      "Psychogene Perversion des Geruchssinns",
      "Psychogene Perversion des Geschmackssinns",
      "Psychogene Prostatareizung",
      "Psychogene Prurigo",
      "Psychogene Schmerzen der Haut",
      "Psychogene Sinnesorganstörung",
      "Psychogene Störung des Bewegungsorgans",
      "Psychogene Störung des Muskel- und Skelettsystems",
      "Psychogene Störung des endokrinen Systems",
      "Psychogene Urinverhaltung",
      "Psychogene Urogenitalstörung",
      "Psychogene Vertigo",
      "Psychogene ekzematöse Störung",
      "Psychogene endokrine Störung",
      "Psychogene funktionelle Störung a.n.k.",
      "Psychogene kutane Störung",
      "Psychogene monoplegische Störung",
      "Psychogene okulogyre Krise",
      "Psychogene okulomotorische Störung",
      "Psychogene physische Störung a.n.k.",
      "Psychogene rheumatische Störung",
      "Psychogene schmerzhafte Menstruation",
      "Psychogener Juckreiz",
      "Psychogener Muskelkrampf",
      "Psychogener Pruritus",
      "Psychogener Pruritus ani",
      "Psychogener Pruritus der Vulva",
      "Psychogener Pruritus des Skrotums",
      "Psychogener Pruritus genitalis",
      "Psychogener Rheumatismus",
      "Psychogener Schiefhals",
      "Psychogener Schwindel",
      "Psychogener Spasmus",
      "Psychogener Tortikollis",
      "Psychogener Tremor",
      "Psychogener Vaginalspasmus",
      "Psychogenes Zähneknirschen",
      "Psychosomatische Funktionsstörung",
      "Psychovegetative Prostatabeschwerden",
      "Psychovegetative Prostatopathie",
      "Psychovegetatives Prostatasyndrom",
      "Scheingravidität",
      "Scheinschwangerschaft",
      "Schlafbezogener Bruxismus",
      "Skelett-Neurose",
      "Vegetative Prostatopathie",
      "Vegetatives Prostatasyndrom",
      "Zähneknirschen"
    ]
  },
  {
    "code": "F45.9",
    "name": "Psychovegetative Dystonie",
    "synonyms": [
      "Funktionelle Beschwerden",
      "Funktionelle Störung",
      "Funktionelle neurotische Beschwerden",
      "Neurovegetative Dysfunktion",
      "Neurovegetative Dysregulation",
      "Neurovegetative Dystonie",
      "Neurovegetative Störung",
      "Organneurose",
      "Phobisch-vegetatives Syndrom",
      "Polymorphe Beschwerden, wahrscheinlich nichtorganisch",
      "Psycho-neurovegetative Dysregulation",
      "Psychogene Störung a.n.k.",
      "Psychonervöse Störung",
      "Psychophysiologische Reaktion",
      "Psychophysiologische Störung",
      "Psychoreaktive Störung",
      "Psychoreaktives Syndrom",
      "Psychosomatische Beschwerden",
      "Psychosomatische Dysregulation",
      "Psychosomatische Erkrankung",
      "Psychosomatische Krankheit",
      "Psychosomatische Störung",
      "Psychosomatische gynäkologische Erkrankung",
      "Psychosomatischer Symptomenkomplex",
      "Psychosomatisches Syndrom",
      "Psychovegetative Dekompensation",
      "Psychovegetative Dysregulation",
      "Psychovegetative Dystonie",
      "Psychovegetative Fehlsteuerung",
      "Psychovegetative Störung",
      "Psychovegetatives Syndrom",
      "Somatisation",
      "Somatisierungsreaktion",
      "Somatoforme Störung",
      "Vegetativ-phobisches Syndrom",
      "Vegetative Dysregulation",
      "Vegetative Dystonie",
      "Vegetative Fehlsteuerung",
      "Vegetative Symptomatik",
      "Vegetative Übererregbarkeit"
    ]
  },
  {
    "code": "F48.0",
    "name": "Beard-Krankheit",
    "synonyms": [
      "Allgemeine psychogene Ermüdung",
      "Asthenische Neurose",
      "Asthenische Reaktion",
      "Beard-Krankheit",
      "Beard-Syndrom",
      "Chronische Überlastungsbeschwerden",
      "Depressive Erschöpfung",
      "Depressives Erschöpfungssyndrom",
      "Ermüdungsneurose",
      "Ermüdungssyndrom",
      "Erschöpfungsneurose",
      "Erschöpfungssyndrom",
      "Fatigue-Syndrom",
      "Müdigkeitssyndrom",
      "Nervenschwäche",
      "Nervöse Asthenie",
      "Nervöse Erschöpfung",
      "Nervöse Kachexie",
      "Neurasthenie",
      "Neurastheniesyndrom",
      "Neurasthenische Erschöpfung",
      "Neurasthenische Reaktion",
      "Neurasthenisches Syndrom",
      "Neurotische Asthenie",
      "Pseudoneurasthenie",
      "Psychogene Asthenie",
      "Psychogene Erschöpfung",
      "Psychogene asthenische Störung",
      "Psychogenes Beard-Syndrom",
      "Psychonervöse Erschöpfung",
      "Psychoneurotische Asthenie",
      "Psychovegetative Erschöpfung",
      "Überforderungssyndrom",
      "Überlastung",
      "Überlastungssyndrom"
    ]
  },
  {
    "code": "F48.1",
    "name": "Depersonalisationssyndrom",
    "synonyms": [
      "Depersonalisation",
      "Depersonalisationssyndrom",
      "Derealisation",
      "Derealisationssyndrom",
      "Neurotische Derealisation",
      "Neurotischer Zustand mit Depersonalisationsphasen",
      "Neurotisches Depersonalisationssyndrom"
    ]
  },
  {
    "code": "F48.8",
    "name": "Situationsneurose",
    "synonyms": [
      "Berufsneurose",
      "Beschäftigungskrampf der Hand",
      "Beschäftigungsneurose",
      "Beschäftigungstic",
      "Cheirospasmus",
      "Dhat-Syndrom",
      "Gemischte Neurose a.n.k.",
      "Graphospasmus",
      "Janet-Krankheit",
      "Koro",
      "Latah",
      "Nervöser Kollaps",
      "Neurosemischform a.n.k.",
      "Pithiatismus",
      "Psychasthenie",
      "Psychasthenische Erschöpfung",
      "Psychasthenische Neurose",
      "Psychogene Synkope",
      "Psychogene berufsbedingte Störung",
      "Schreibkrampf",
      "Situationsneurose",
      "Umweltneurose",
      "Weinkrampf"
    ]
  },
  {
    "code": "F48.9",
    "name": "Kernneurose",
    "synonyms": [
      "Kernneurose",
      "Neurogene Reaktion",
      "Neurose",
      "Neurotische Entwicklung",
      "Neurotische Fehlentwicklung",
      "Neurotische Fehlsteuerung",
      "Neurotische Reaktion a.n.k.",
      "Neurotische Störung",
      "Neurotischer Zustand",
      "Neurotisches Fehlverhalten",
      "Phobisch-neurotische Überlagerung",
      "Psychoneurose",
      "Psychoneurotische Reaktion",
      "Psychoneurotische Störung"
    ]
  },
  {
    "code": "F50.00",
    "name": "Anorexia nervosa vom restriktiven Typ",
    "synonyms": [
      "Anorexia nervosa vom restriktiven Typ",
      "Anorexia nervosa, ohne Maßnahmen zur Gewichtsreduktion"
    ]
  },
  {
    "code": "F50.01",
    "name": "Anorexia nervosa vom bulimischen Typ",
    "synonyms": [
      "Anorexia nervosa vom aktiven Typ",
      "Anorexia nervosa vom bulimischen Typ",
      "Anorexia nervosa, mit Maßnahmen zur Gewichtsreduktion"
    ]
  },
  {
    "code": "F50.08",
    "name": "Psychogene Aphagie",
    "synonyms": [
      "Anorexia nervosa",
      "Endogene Magersucht",
      "Freiwilliger Hunger a.n.k.",
      "Präpubertäre Anorexia nervosa",
      "Psychogene Anorexie",
      "Psychogene Aphagie",
      "Pubertätsmagersucht"
    ]
  },
  {
    "code": "F50.1",
    "name": "Atypische Anorexia nervosa",
    "synonyms": [
      "Atypische Anorexia nervosa"
    ]
  },
  {
    "code": "F50.2",
    "name": "Bulimie",
    "synonyms": [
      "Bulimia",
      "Bulimia nervosa",
      "Bulimie",
      "Hyperorexia nervosa"
    ]
  },
  {
    "code": "F50.3",
    "name": "Atypische Bulimia nervosa",
    "synonyms": [
      "Atypische Bulimia nervosa",
      "Atypische Bulimie",
      "Bulimie mit Normalgewicht"
    ]
  },
  {
    "code": "F50.4",
    "name": "Psychogene Fresssucht",
    "synonyms": [
      "Essattacken nichtorganischen Ursprungs",
      "Psychogene Essattacken",
      "Psychogene Fresssucht"
    ]
  },
  {
    "code": "F50.5",
    "name": "Periodisches psychogenes Erbrechen",
    "synonyms": [
      "Erbrechen bei psychischer Störung",
      "Hysterisches Erbrechen",
      "Nervöses Erbrechen",
      "Neurotisches Erbrechen",
      "Periodisches psychogenes Erbrechen",
      "Psychogene Hyperemesis gravidarum",
      "Psychogener Vomitus",
      "Psychogener Vomitus faeculentus",
      "Psychogenes Erbrechen",
      "Psychogenes Erbrechen nach Magen-Darm-Operation",
      "Zyklisches psychogenes Erbrechen"
    ]
  },
  {
    "code": "F50.8",
    "name": "Psychogener Appetitverlust",
    "synonyms": [
      "Appetitlosigkeit nichtorganischen Ursprungs",
      "Appetitmangel nichtorganischen Ursprungs",
      "Appetitverlust nichtorganischen Ursprungs",
      "Binge-Eating-Störung",
      "Esssucht",
      "Hysterische Dysorexie",
      "Hysterischer Appetitverlust",
      "Nahrungsverweigerung als Verhaltensauffälligkeit",
      "Nichtorganische Pica beim Erwachsenen",
      "Nichtorganisches Ernährungsproblem",
      "Parorexie",
      "Perverser Appetit",
      "Pica",
      "Pica bei Erwachsenen",
      "Pica-Syndrom",
      "Pica-Syndrom beim Erwachsenen",
      "Pikazismus",
      "Psychogene Appetitstörung",
      "Psychogene Parorexie",
      "Psychogener Appetitmangel",
      "Psychogener Appetitverlust"
    ]
  },
  {
    "code": "F50.9",
    "name": "Essstörung",
    "synonyms": [
      "Dysponderosis",
      "Essstörung",
      "Essverhaltensstörung",
      "Nervöse Essstörung",
      "Psychogene Essstörung"
    ]
  },
  {
    "code": "F51.0",
    "name": "Nichtorganische Insomnie",
    "synonyms": [
      "Akute Insomnie [Schlafanpassungsstörung]",
      "Idiopathische Insomnie",
      "Nichtorganische Hyposomnie",
      "Nichtorganische Insomnie",
      "Paradoxe Insomnie",
      "Psychogene Schlaflosigkeit",
      "Psychophysiologische Insomnie"
    ]
  },
  {
    "code": "F51.1",
    "name": "Nichtorganische Hypersomnie",
    "synonyms": [
      "Nichtorganische Hypersomnie",
      "Nichtorganische Somnolenz",
      "Primäre Hypersomnie",
      "Psychogene Hypersomnie",
      "Schlafsucht"
    ]
  },
  {
    "code": "F51.2",
    "name": "Störung des Schlaf-Wach-Rhythmus durch Flugreisen",
    "synonyms": [
      "Jet-lag-Syndrom",
      "Psychogene Schlafumkehr",
      "Psychogene Störung des Schlaf-Wach-Rhythmus",
      "Psychogene Umkehr des 24-Stunden-Rhythmus",
      "Psychogene Umkehr des Nacht-Tag-Rhythmus",
      "Psychogene Umkehr des Schlafrhythmus",
      "Psychogene Umkehr des zirkadianen Rhythmus",
      "Störung des Schlaf-Wach-Rhythmus durch Flugreisen",
      "Syndrom des raschen Zeitzonenwechsels",
      "Umkehr des Schlafrhythmus nichtorganischen Ursprungs"
    ]
  },
  {
    "code": "F51.3",
    "name": "Schlafwandeln",
    "synonyms": [
      "Mondsüchtigkeit",
      "Nachtwandeln",
      "Schlafbezogene Essstörungen",
      "Schlaftrunkenheit",
      "Schlafwandeln",
      "Somnambulismus"
    ]
  },
  {
    "code": "F51.4",
    "name": "Pavor nocturnus",
    "synonyms": [
      "Nachtangst",
      "Nächtlicher Angstanfall",
      "Pavor nocturnus"
    ]
  },
  {
    "code": "F51.5",
    "name": "Alptraum",
    "synonyms": [
      "Albdrücken",
      "Albtraum",
      "Alpdrücken",
      "Alptraum",
      "Angsttraum",
      "Angsttraumstörung"
    ]
  },
  {
    "code": "F51.8",
    "name": "Nächtliche Unruhe",
    "synonyms": [
      "Nächtliche Unruhe"
    ]
  },
  {
    "code": "F51.9",
    "name": "Psychogene Schlafstörung",
    "synonyms": [
      "Emotional bedingte Schlafstörung",
      "Nichtorganische Schlafstörung",
      "Nichtorganische spezifische Schlafstörung",
      "Psychogene Schlafstörung",
      "Psychosomatische Schlafstörung",
      "Psychovegetative Schlafstörung"
    ]
  },
  {
    "code": "F52.0",
    "name": "Libidoverlust",
    "synonyms": [
      "Alibidinie",
      "Frigidität",
      "Gefühlskälte",
      "Geschlechtskälte",
      "Libidoabnahme",
      "Libidohemmung",
      "Libidomangel",
      "Libidominderung",
      "Libidostörung",
      "Libidoverlust",
      "Mangel an sexuellem Verlangen",
      "Sexuelle Hypoaktivität",
      "Verlust von sexuellem Verlangen"
    ]
  },
  {
    "code": "F52.1",
    "name": "Gestörte sexuelle Befriedigung",
    "synonyms": [
      "Anaphrodisie",
      "Gestörte sexuelle Befriedigung",
      "Mangelnde sexuelle Befriedigung",
      "Psychogene Anaesthesia sexualis",
      "Sexuelle Anhedonie",
      "Sexuelle Aversion"
    ]
  },
  {
    "code": "F52.2",
    "name": "Versagen der genitalen Reaktion",
    "synonyms": [
      "Erektile Dysfunktion",
      "Erektile Impotenz",
      "Erektile Potenzschwäche",
      "Erektile Potenzstörung",
      "Erektile psychogene Impotenz",
      "Erektionsschwäche",
      "Erektionsstörung",
      "Erektionsstörung beim Mann",
      "Impotentia sexualis",
      "Impotenz",
      "Männliche psychogene Impotenz",
      "Nichtorganische Erektionsstörung beim Mann",
      "Nichtorganische erektile Dysfunktion",
      "Nichtorganische erektile Potenzstörung",
      "Potenzschwäche",
      "Potenzstörung",
      "Potenzverlust",
      "Psychogene Impotenz",
      "Psychogene Potenzschwäche",
      "Psychogene Potenzstörung",
      "Psychogene erektile Dysfunktion",
      "Psychosomatische Potenzschwäche",
      "Psychosomatische Potenzstörung",
      "Sexuelle Erregungsstörung bei der Frau",
      "Sexuelle Impotenz",
      "Versagen der genitalen Reaktion"
    ]
  },
  {
    "code": "F52.3",
    "name": "Psychogene Anorgasmie",
    "synonyms": [
      "Anorgasmie",
      "Dysorgasmie",
      "Ejaculatio retarda",
      "Gehemmter Orgasmus",
      "Gehemmter männlicher Orgasmus",
      "Gehemmter weiblicher Orgasmus",
      "Orgasmusschwierigkeiten",
      "Orgasmusstörung",
      "POIS [Postorgasmic-Illness-Syndrom]",
      "Postorgasmic illness-Syndrom",
      "Psychogene Anorgasmie",
      "Verzögerte Ejakulation"
    ]
  },
  {
    "code": "F52.4",
    "name": "Ejaculatio praecox",
    "synonyms": [
      "Ejaculatio praecox"
    ]
  },
  {
    "code": "F52.5",
    "name": "Nichtorganischer Vaginismus",
    "synonyms": [
      "Hysterischer Vaginismus",
      "Nichtorganischer Vaginismus",
      "Psychogener Vaginismus"
    ]
  },
  {
    "code": "F52.6",
    "name": "Nichtorganische Dyspareunie",
    "synonyms": [
      "Nichtorganische Dyspareunie",
      "Psychogene Dyspareunie",
      "Psychogene Ejakulationsschmerzen",
      "Psychogene Koitusschmerzen",
      "Psychogene schmerzhafte Ejakulation"
    ]
  },
  {
    "code": "F52.7",
    "name": "Libidosteigerung",
    "synonyms": [
      "Erotomanie",
      "Gesteigerte Libido",
      "Gesteigertes sexuelles Verlangen",
      "Hypersexualität",
      "Libidosteigerung",
      "Nymphomanie",
      "Satyriasis",
      "Sexuelle Hyperaktivität"
    ]
  },
  {
    "code": "F52.8",
    "name": "Ejakulationsstörung",
    "synonyms": [
      "Ejakulationsstörung",
      "Ejakulatorische Dysfunktion",
      "Retrograde Ejakulation"
    ]
  },
  {
    "code": "F52.9",
    "name": "Sexualstörung",
    "synonyms": [
      "Chronische Libidostörung",
      "Kohabitationsstörung",
      "Nichtorganische sexuelle Funktionsstörung",
      "Psycho-sexuelle Störung",
      "Psychogene Sexualfunktionsstörung",
      "Psychogene Sexualschwäche",
      "Psychogene Sexualstörung",
      "Sexualproblem",
      "Sexualstörung",
      "Sexuelle Dysfunktion",
      "Sexuelle Funktionsstörung",
      "Sexuelle psychogene Störung"
    ]
  },
  {
    "code": "F53.0",
    "name": "Postpartale Depression",
    "synonyms": [
      "Depression post partum",
      "Leichte Störung des Sozialverhaltens im Wochenbett a.n.k.",
      "Leichte psychische Störung im Wochenbett a.n.k.",
      "Postnatale Depression",
      "Postpartale Depression",
      "Puerperaldepression",
      "Wochenbettdepression"
    ]
  },
  {
    "code": "F53.1",
    "name": "Puerperalpsychose",
    "synonyms": [
      "Abortpsychose",
      "Chronische Puerperalpsychose",
      "Chronische Wochenbettpsychose",
      "Laktationspsychose",
      "Postpartale Psychose",
      "Puerperale Demenz",
      "Puerperalpsychose",
      "Schwere Störung des Sozialverhaltens im Wochenbett a.n.k.",
      "Schwere psychische Störung im Wochenbett a.n.k.",
      "Wochenbettpsychose"
    ]
  },
  {
    "code": "F53.8",
    "name": "Verhaltensstörung im Wochenbett",
    "synonyms": [
      "Verhaltensstörung im Wochenbett"
    ]
  },
  {
    "code": "F53.9",
    "name": "Psychische Störung im Wochenbett",
    "synonyms": [
      "Psychische Störung im Wochenbett"
    ]
  },
  {
    "code": "F54",
    "name": "Psychogenes Asthma",
    "synonyms": [
      "Psychische Faktoren, die körperliche Störungen bewirken",
      "Psychogene Hautkrankheit",
      "Psychogenes Asthma"
    ]
  },
  {
    "code": "F55.0",
    "name": "Antidepressivamissbrauch",
    "synonyms": [
      "Antidepressivaabusus",
      "Antidepressivamissbrauch"
    ]
  },
  {
    "code": "F55.1",
    "name": "Laxanzienabusus",
    "synonyms": [
      "Laxanzienabusus",
      "Laxanziengewöhnung",
      "Laxanzienmissbrauch"
    ]
  },
  {
    "code": "F55.2",
    "name": "Analgetikaabusus",
    "synonyms": [
      "Abhängigkeit von Analgetika a.n.k.",
      "Analgetikaabusus",
      "Analgetikamissbrauch",
      "Schmerzmittelabusus"
    ]
  },
  {
    "code": "F55.3",
    "name": "Antazidamissbrauch",
    "synonyms": [
      "Antazidaabusus",
      "Antazidamissbrauch"
    ]
  },
  {
    "code": "F55.4",
    "name": "Vitaminmissbrauch",
    "synonyms": [
      "Vitaminabusus",
      "Vitaminmissbrauch"
    ]
  },
  {
    "code": "F55.5",
    "name": "Steroidabusus",
    "synonyms": [
      "Hormonabusus",
      "Hormonmissbrauch",
      "Steroidabusus",
      "Steroidmissbrauch"
    ]
  },
  {
    "code": "F55.6",
    "name": "Naturheilmittelmissbrauch",
    "synonyms": [
      "Naturheilmittelabusus",
      "Naturheilmittelmissbrauch",
      "Pflanzenmissbrauch"
    ]
  },
  {
    "code": "F55.8",
    "name": "Abusus von Nasenspray",
    "synonyms": [
      "Abhängigkeit von anästhetischem Mittel a.n.k.",
      "Abusus von Nasenspray",
      "Abusus von Nasentropfen",
      "Salizylismus bei Missbrauch"
    ]
  },
  {
    "code": "F59",
    "name": "Verhaltensstörung bei körperlicher Störung",
    "synonyms": [
      "Psychogene körperliche Funktionsstörung",
      "Verhaltensstörung bei körperlicher Störung"
    ]
  },
  {
    "code": "F60.0",
    "name": "Paranoide Persönlichkeit",
    "synonyms": [
      "Expansiv-paranoide Persönlichkeit",
      "Expansiv-paranoide Persönlichkeitsstörung",
      "Expansiv-paranoische Persönlichkeit",
      "Fanatische Persönlichkeit",
      "Fanatische Persönlichkeitsstörung",
      "Paranoide Neigung",
      "Paranoide Persönlichkeit",
      "Paranoide Persönlichkeitsstörung",
      "Paranoide Psychopathie",
      "Paranoider Charakterzug",
      "Paranoider Typ einer psychopathischen Persönlichkeit",
      "Querulatorische Persönlichkeit",
      "Querulatorische Persönlichkeitsstörung",
      "Sensitiv paranoide Persönlichkeit",
      "Sensitiv paranoide Persönlichkeitsstörung",
      "Sensitiv paranoische Persönlichkeit"
    ]
  },
  {
    "code": "F60.1",
    "name": "Schizoide Persönlichkeitsstörung",
    "synonyms": [
      "Schizoide Persönlichkeit",
      "Schizoide Persönlichkeitsstörung",
      "Schizoide Psychopathie",
      "Schizothymie"
    ]
  },
  {
    "code": "F60.2",
    "name": "Dissoziale Persönlichkeitsstörung",
    "synonyms": [
      "Amoralische Persönlichkeit",
      "Amoralische Persönlichkeitsstörung",
      "Antisoziale Persönlichkeit",
      "Antisoziale Persönlichkeitsstörung",
      "Antisoziale Psychopathie",
      "Asoziale Persönlichkeit",
      "Asoziale Persönlichkeitsstörung",
      "Asozialer Defekt",
      "Dissoziale Persönlichkeit",
      "Dissoziale Persönlichkeitsstörung",
      "Kriminelle Verhaltensweise",
      "Mangel an Moral",
      "Moralisch defekte Persönlichkeit",
      "Moralischer Defekt",
      "Persönlichkeitsstörung mit moralischem Defekt",
      "Psychopathische Persönlichkeit",
      "Psychopathische Persönlichkeitsstörung",
      "Soziopathische Persönlichkeit",
      "Soziopathische Persönlichkeitsstörung"
    ]
  },
  {
    "code": "F60.30",
    "name": "Emotional instabile Persönlichkeitsstörung vom impulsiven Typ",
    "synonyms": [
      "Aggressive Persönlichkeit",
      "Aggressive Persönlichkeitsstörung",
      "Emotional instabile Persönlichkeit",
      "Emotional instabile Persönlichkeitsstörung vom impulsiven Typ",
      "Emotionale Unausgeglichenheit",
      "Erregbare Persönlichkeit",
      "Explosible Persönlichkeit",
      "Explosive Persönlichkeitsstörung",
      "Pathologische Emotionalität",
      "Reizbare Persönlichkeit",
      "Reizbare Persönlichkeitsstörung",
      "Streitsucht",
      "Übermäßige emotionale Instabilität"
    ]
  },
  {
    "code": "F60.31",
    "name": "Psychisches Borderline-Syndrom bei Persönlichkeitsstörung",
    "synonyms": [
      "BPS [Borderline-Persönlichkeitsstörung]",
      "Borderline-Persönlichkeitsstörung",
      "Psychisches Borderline-Syndrom",
      "Psychisches Borderline-Syndrom bei Persönlichkeitsstörung"
    ]
  },
  {
    "code": "F60.4",
    "name": "Histrionische Persönlichkeitsstörung",
    "synonyms": [
      "Histrionische Persönlichkeit",
      "Histrionische Persönlichkeitsstörung",
      "Hysterische Persönlichkeit",
      "Hysterische Persönlichkeitsstörung",
      "Hysterische Psychopathie",
      "Infantile Persönlichkeit",
      "Infantile Persönlichkeitsstörung",
      "Labile Persönlichkeit",
      "Labile Persönlichkeitsstörung",
      "Psychoinfantile Persönlichkeit"
    ]
  },
  {
    "code": "F60.5",
    "name": "Anankastische Persönlichkeitsstörung",
    "synonyms": [
      "Anankastische Persönlichkeit",
      "Anankastische Persönlichkeitsstörung",
      "Zwanghafte Persönlichkeit",
      "Zwanghafte Persönlichkeitsstörung",
      "Zwangspersönlichkeit",
      "Zwangspersönlichkeitsstörung"
    ]
  },
  {
    "code": "F60.6",
    "name": "Minderwertigkeitskomplex",
    "synonyms": [
      "Minderwertigkeitskomplex",
      "Selbstunsichere Persönlichkeit",
      "Selbstunsichere Persönlichkeitsstörung",
      "Vermeidende Persönlichkeitsstörung",
      "Ängstliche Persönlichkeitsstörung"
    ]
  },
  {
    "code": "F60.7",
    "name": "Abhängige Persönlichkeitsstörung",
    "synonyms": [
      "Abhängige Persönlichkeit",
      "Abhängige Persönlichkeitsstörung",
      "Abhängige passive Persönlichkeit",
      "Asthenische Persönlichkeit",
      "Asthenische Persönlichkeitsstörung",
      "Inadäquate Persönlichkeit",
      "Inadäquate Persönlichkeitsstörung",
      "Inadäquate Reaktion auf die Anforderungen des täglichen Lebens",
      "Passive Persönlichkeit",
      "Passive Persönlichkeitsstörung",
      "Selbstschädigende Persönlichkeitsstörung",
      "Unzulängliche Persönlichkeitsstörung"
    ]
  },
  {
    "code": "F60.8",
    "name": "Exzentrische Persönlichkeit",
    "synonyms": [
      "Exzentrische Persönlichkeit",
      "Exzentrische Persönlichkeitsstörung",
      "Haltlose Persönlichkeit",
      "Haltlose Persönlichkeitsstörung",
      "Narzissmus",
      "Narzisstische Persönlichkeit",
      "Narzisstische Persönlichkeitsstörung",
      "Negativismus",
      "Nervöse Instabilität",
      "Neurotische Persönlichkeitsstörung",
      "Passiv-aggressive Persönlichkeit",
      "Passiv-aggressive Persönlichkeitsstörung",
      "Psychoneurotische Persönlichkeit",
      "Psychoneurotische Persönlichkeitsstörung",
      "Unreife Persönlichkeit",
      "Unreife Persönlichkeitsstörung",
      "Unzulängliche Persönlichkeit"
    ]
  },
  {
    "code": "F60.9",
    "name": "Pathologische Persönlichkeit",
    "synonyms": [
      "Charakterneurose",
      "Couvade-Syndrom",
      "Konstitutionelle Psychopathie",
      "Pathologische Persönlichkeit",
      "Pathologische Persönlichkeitsstörung",
      "Persönlichkeitsstörung",
      "Persönlichkeitsveränderung",
      "Persönlichkeitswandel",
      "Psychopathie",
      "Wesensänderung"
    ]
  },
  {
    "code": "F61",
    "name": "Kombinierte Persönlichkeitsstörung",
    "synonyms": [
      "Kombinierte Persönlichkeitsstörung"
    ]
  },
  {
    "code": "F62.0",
    "name": "Andauernde Persönlichkeitsänderung nach Extrembelastung",
    "synonyms": [
      "Andauernde Persönlichkeitsänderung nach Extrembelastung",
      "Persönlichkeitsänderung nach Folter",
      "Persönlichkeitsänderung nach Konzentrationslagererfahrung",
      "Persönlichkeitsänderung nach einer Katastrophe",
      "Persönlichkeitsänderung nach längerer lebensbedrohlicher Situation",
      "Persönlichkeitsänderungen eines Opfers von Terrorismus",
      "Persönlichkeitsänderungen nach andauernder Gefangenschaft mit unmittelbarer Todesgefahr"
    ]
  },
  {
    "code": "F62.1",
    "name": "Andauernde Persönlichkeitsänderung nach psychischer Krankheit",
    "synonyms": [
      "Andauernde Persönlichkeitsänderung nach psychischer Krankheit"
    ]
  },
  {
    "code": "F62.80",
    "name": "Andauernde Persönlichkeitsänderung bei chronischem Schmerzsyndrom",
    "synonyms": [
      "Andauernde Persönlichkeitsänderung bei chronischem Schmerzsyndrom"
    ]
  },
  {
    "code": "F62.88",
    "name": "Persönlichkeitsänderung nach Trauerfall",
    "synonyms": [
      "Persönlichkeitsänderung nach Trauerfall"
    ]
  },
  {
    "code": "F62.9",
    "name": "Andauernde Persönlichkeitsänderung",
    "synonyms": [
      "Andauernde Persönlichkeitsänderung"
    ]
  },
  {
    "code": "F63.0",
    "name": "Pathologisches Spielen",
    "synonyms": [
      "Pathologisches Glücksspiel",
      "Pathologisches Spielen",
      "Spielsucht",
      "Zwanghaftes Glücksspiel",
      "Zwanghaftes Spielen"
    ]
  },
  {
    "code": "F63.1",
    "name": "Pyromanie",
    "synonyms": [
      "Pathologische Brandstiftung",
      "Pyromanie"
    ]
  },
  {
    "code": "F63.2",
    "name": "Kleptomanie",
    "synonyms": [
      "Kleptomanie",
      "Pathologisches Stehlen"
    ]
  },
  {
    "code": "F63.3",
    "name": "Trichotillomanie",
    "synonyms": [
      "Pathologisches Haarausreißen",
      "Trichotillomanie",
      "Zwanghaftes Haarausreißen"
    ]
  },
  {
    "code": "F63.8",
    "name": "Störung des Sozialverhaltens mit Zwangscharakter",
    "synonyms": [
      "Internetsucht",
      "Pornographiesucht",
      "Störung der Impulskontrolle mit intermittierend auftretender Reizbarkeit",
      "Störung des Sozialverhaltens mit Zwangscharakter"
    ]
  },
  {
    "code": "F63.9",
    "name": "Störung der Impulskontrolle",
    "synonyms": [
      "Abnorme Gewohnheit",
      "Dermatillomanie",
      "Störung der Impulskontrolle"
    ]
  },
  {
    "code": "F64.0",
    "name": "Transsexualismus",
    "synonyms": [
      "Transsexualismus"
    ]
  },
  {
    "code": "F64.1",
    "name": "Transvestitismus",
    "synonyms": [
      "Störung der Geschlechtsidentität im Erwachsenenalter, nicht transsexueller Typ",
      "Transvestismus",
      "Transvestitismus",
      "Transvestitismus mit Beibehaltung beider Geschlechtsrollen"
    ]
  },
  {
    "code": "F64.2",
    "name": "Psychosexuelle Identitätsstörung im Kindesalter",
    "synonyms": [
      "Psychosexuelle Identitätsstörung im Kindesalter",
      "Störung der Geschlechtsidentität im Kindesalter"
    ]
  },
  {
    "code": "F64.9",
    "name": "Geschlechterrollenstörung",
    "synonyms": [
      "Geschlechterrollenstörung",
      "Geschlechtsidentitätsstörung",
      "Psychosexuelle Identitätsstörung"
    ]
  },
  {
    "code": "F65.0",
    "name": "Fetischismus",
    "synonyms": [
      "Fetischismus"
    ]
  },
  {
    "code": "F65.1",
    "name": "Fetischistischer Transvestitismus",
    "synonyms": [
      "Fetischistischer Transvestitismus",
      "Transvestitischer Fetischismus"
    ]
  },
  {
    "code": "F65.2",
    "name": "Exhibitionismus",
    "synonyms": [
      "Exhibitionismus"
    ]
  },
  {
    "code": "F65.3",
    "name": "Voyeurismus",
    "synonyms": [
      "Voyeurismus"
    ]
  },
  {
    "code": "F65.4",
    "name": "Pädophilie",
    "synonyms": [
      "Päderastie",
      "Pädophilie"
    ]
  },
  {
    "code": "F65.5",
    "name": "Sadismus",
    "synonyms": [
      "Aktive Algolagnie",
      "Algolagnie",
      "Masochismus",
      "Passive Algolagnie",
      "Sadismus",
      "Sadomasochismus",
      "Sexueller Masochismus",
      "Sexueller Sadismus"
    ]
  },
  {
    "code": "F65.6",
    "name": "Multiple Störungen der Sexualpräferenz",
    "synonyms": [
      "Multiple Störungen der Sexualpräferenz"
    ]
  },
  {
    "code": "F65.8",
    "name": "Frotteurismus",
    "synonyms": [
      "Bestiophilie",
      "Frotteurismus",
      "Koprolagnie",
      "Nekrophilie",
      "Sodomie",
      "Zoophilie"
    ]
  },
  {
    "code": "F65.9",
    "name": "Störung der Sexualpräferenz",
    "synonyms": [
      "Paraphilie",
      "Pathologische Sexualität",
      "Pathologisches Geschlechtsleben",
      "Sexualneurose",
      "Sexuelle Abnormität",
      "Sexuelle Deviation",
      "Sexuelle Perversion",
      "Sexuelle Psychopathie",
      "Sexuelle Verhaltensabweichung",
      "Sexuelle Verhaltensstörung",
      "Störung der Sexualpräferenz",
      "Triebneurose"
    ]
  },
  {
    "code": "F66.0",
    "name": "Sexuelle Reifungskrise",
    "synonyms": [
      "Sexuelle Reifungskrise"
    ]
  },
  {
    "code": "F66.1",
    "name": "Ichdystone Sexualorientierung",
    "synonyms": [
      "Ichdystone Sexualorientierung",
      "Ichdystone sexuelle Orientierungsstörung"
    ]
  },
  {
    "code": "F66.2",
    "name": "Sexuelle Beziehungsstörung",
    "synonyms": [
      "Chronischer Sexualkonflikt",
      "Eheproblem wegen Geschlechtsidentität",
      "Sexualkonflikt",
      "Sexuelle Beziehungsstörung",
      "Sexuelle Beziehungsstörung durch Bisexualität",
      "Sexuelle Orientierungsstörung mit Auswirkung auf die Beziehung"
    ]
  },
  {
    "code": "F66.8",
    "name": "Promiskuität",
    "synonyms": [
      "Promiskuität"
    ]
  },
  {
    "code": "F66.9",
    "name": "Konträres Sexualempfinden",
    "synonyms": [
      "Konträres Sexualempfinden",
      "Problem der psychosexuellen Entwicklung",
      "Psychosexuelle Entwicklungsstörung",
      "Tribadie",
      "Uranismus"
    ]
  },
  {
    "code": "F68.0",
    "name": "Rentenneurose",
    "synonyms": [
      "Begehrensneurose",
      "Entschädigungsneurose",
      "Entwicklung körperlicher Symptome aus psychischen Gründen",
      "Rentenneurose"
    ]
  },
  {
    "code": "F68.1",
    "name": "Artifizielle Störung",
    "synonyms": [
      "Artifizielle Störung",
      "Durch Institutionen wandernder Patient",
      "Hospital-hopper-Syndrom",
      "Münchhausen-Syndrom",
      "Peregrinating patient",
      "Vorgetäuschte Krankheit mit Krankheitswert im Sinne einer psychischen Störung"
    ]
  },
  {
    "code": "F68.8",
    "name": "Entwurzelungssyndrom",
    "synonyms": [
      "Beziehungsstörung",
      "Charakteranomalie",
      "Charakterstörung",
      "Entwurzelungssyndrom",
      "Identitätskrise",
      "Körperintegritätsidentitätsstörung",
      "Psychosoziale Störung",
      "Zwischenmenschliche Beziehungsstörung"
    ]
  },
  {
    "code": "F69",
    "name": "Verhaltensstörung und Persönlichkeitsstörung",
    "synonyms": [
      "Persönlichkeitsproblem",
      "Psychogene Verhaltensstörung",
      "Verhaltensabweichung",
      "Verhaltensproblem beim Erwachsenen",
      "Verhaltensstörung",
      "Verhaltensstörung und Persönlichkeitsstörung"
    ]
  },
  {
    "code": "F70.8",
    "name": "Leichte Intelligenzminderung mit Verhaltensstörung",
    "synonyms": [
      "Leichte Intelligenzminderung mit Verhaltensstörung"
    ]
  },
  {
    "code": "F70.9",
    "name": "Leichte Intelligenzminderung",
    "synonyms": [
      "Debilitas mentalis",
      "Debilität",
      "FRAXE [Fragiles X-Syndrom Position E]",
      "IQ 50-69 [Leichte Intelligenzminderung]",
      "Leichte Imbezillität",
      "Leichte Intelligenzminderung",
      "Leichte Intelligenzschwäche",
      "Leichte Oligophrenie",
      "Leichte autosomal-dominante nicht-syndromale Intelligenzminderung",
      "Leichte geistige Behinderung",
      "Leichte geistige Schwäche",
      "Leichte mentale Retardierung",
      "Leichter Schwachsinn"
    ]
  },
  {
    "code": "F71.8",
    "name": "Verhaltensstörung bei mittelgradiger Intelligenzminderung",
    "synonyms": [
      "Verhaltensstörung bei mittelgradiger Intelligenzminderung"
    ]
  },
  {
    "code": "F71.9",
    "name": "Mäßiger Schwachsinn",
    "synonyms": [
      "IQ 35-49 [Mittelgradige Intelligenzminderung]",
      "Imbezillität",
      "Mittelgradige Intelligenzminderung",
      "Mittelgradige Oligophrenie",
      "Mittelgradige autosomal-dominante nicht-syndromale Intelligenzminderung",
      "Mittelgradige geistige Behinderung",
      "Mäßige Oligophrenie",
      "Mäßige mentale Retardierung",
      "Mäßiger Schwachsinn"
    ]
  },
  {
    "code": "F72.1",
    "name": "Schwere Intelligenzminderung mit deutlich behandlungsbedürftiger Verhaltensstörung",
    "synonyms": [
      "Schwere Intelligenzminderung mit deutlich behandlungsbedürftiger Verhaltensstörung"
    ]
  },
  {
    "code": "F72.8",
    "name": "Verhaltensstörung bei schwerer Intelligenzminderung",
    "synonyms": [
      "Verhaltensstörung bei schwerer Intelligenzminderung"
    ]
  },
  {
    "code": "F72.9",
    "name": "Schwere Intelligenzminderung",
    "synonyms": [
      "Ausgeprägte Intelligenzschwäche",
      "Ausgeprägte Oligophrenie",
      "Ausgeprägter Schwachsinn",
      "IQ 20-34 [Schwere Intelligenzminderung]",
      "Schwere Intelligenzminderung",
      "Schwere Oligophrenie",
      "Schwere autosomal-dominante nicht-syndromale Intelligenzminderung",
      "Schwere geistige Behinderung",
      "Schwerer Schwachsinn",
      "Starker Schwachsinn"
    ]
  },
  {
    "code": "F73.1",
    "name": "Schwerste Intelligenzminderung mit deutlich behandlungsbedürftiger Verhaltensstörung",
    "synonyms": [
      "Schwerste Intelligenzminderung mit deutlich behandlungsbedürftiger Verhaltensstörung"
    ]
  },
  {
    "code": "F73.8",
    "name": "Verhaltensstörung bei schwerster Intelligenzminderung",
    "synonyms": [
      "Verhaltensstörung bei schwerster Intelligenzminderung"
    ]
  },
  {
    "code": "F73.9",
    "name": "Schwerste Intelligenzminderung",
    "synonyms": [
      "Hochgradiger Schwachsinn",
      "IQ unter 20 [Schwerste Intelligenzminderung]",
      "Idiotie",
      "Kongenitale Idiotie",
      "Schwerste Intelligenzminderung",
      "Schwerste Oligophrenie",
      "Schwerste autosomal-dominante nicht-syndromale Intelligenzminderung",
      "Schwerste geistige Behinderung"
    ]
  },
  {
    "code": "F74.9",
    "name": "Dissoziierte Intelligenz",
    "synonyms": [
      "Dissoziierte Intelligenz"
    ]
  },
  {
    "code": "F79.0",
    "name": "Intelligenzminderung ohne Verhaltensstörung",
    "synonyms": [
      "Intelligenzminderung ohne Verhaltensstörung"
    ]
  },
  {
    "code": "F79.1",
    "name": "Schwachsinn mit deutlicher Verhaltensstörung",
    "synonyms": [
      "Intelligenzminderung mit deutlicher Verhaltensstörung",
      "Schwachsinn mit deutlicher Verhaltensstörung"
    ]
  },
  {
    "code": "F79.8",
    "name": "Verhaltensstörung bei Intelligenzminderung",
    "synonyms": [
      "Verhaltensstörung bei Intelligenzminderung"
    ]
  },
  {
    "code": "F79.9",
    "name": "Amentia",
    "synonyms": [
      "Amentia",
      "Amentielles Syndrom",
      "Angeborene Demenz",
      "Autosomal-dominante nicht-syndromale Intelligenzminderung",
      "Autosomal-rezessive nicht-syndromale Intelligenzminderung",
      "Beschränktheit",
      "Geistesschwäche - s.a. Intelligenzminderung",
      "Geistig zurückgebliebene Entwicklung",
      "Geistige Behinderung",
      "Geistige Entwicklungsstörung",
      "Geistige Retardierung",
      "Geistige Spätentwicklung",
      "Geistiger Defekt",
      "Geistiges Defizit",
      "Intelligenzmangel",
      "Intelligenzminderung",
      "Intelligenzschwäche",
      "Kongenitale geistige Insuffizienz",
      "Mentale Retardierung",
      "Minderbegabung",
      "Oligophrenie",
      "Schwachsinn",
      "X-chromosomale nicht-syndromale Intelligenzminderung",
      "Zerebrale Minderbelastbarkeit"
    ]
  },
  {
    "code": "F80.0",
    "name": "Idioglossie",
    "synonyms": [
      "Artikulationsauffälligkeit",
      "Artikulationsstörung",
      "Dyslalie",
      "Entwicklungsbedingte Alalie",
      "Entwicklungsbedingte Artikulationsstörung",
      "Entwicklungsbedingte Dyslalie",
      "Funktionelle Artikulationsstörung",
      "Idioglossie",
      "Lallen",
      "Partielle Dyslalie",
      "Phonologische Entwicklungsstörung",
      "Psychisches Lallen",
      "Schetismus"
    ]
  },
  {
    "code": "F80.1",
    "name": "Expressive Sprachstörung",
    "synonyms": [
      "Expressive Sprachentwicklungsstörung",
      "Expressive Sprachstörung",
      "Expressiver Typ einer entwicklungsbedingten Aphasie",
      "Expressiver Typ einer entwicklungsbedingten Dysphasie",
      "Familiäre entwicklungsbedingte Dysphasie"
    ]
  },
  {
    "code": "F80.20",
    "name": "Auditive Verarbeitungsstörung und Wahrnehmungsstörung",
    "synonyms": [
      "AVWS [Auditive Verarbeitungs- und Wahrnehmungsstörung]",
      "Auditive Verarbeitungsstörung und Wahrnehmungsstörung"
    ]
  },
  {
    "code": "F80.28",
    "name": "Worttaubheit",
    "synonyms": [
      "Angeborene fehlende akustische Wahrnehmung",
      "Audiogene Sprachentwicklungsstörung",
      "Auditive entwicklungsbedingte Aphasie",
      "Entwicklungsbedingte Aphasie",
      "Entwicklungsbedingte Wernicke-Aphasie",
      "Entwicklungsbedingte verbale Agnosie",
      "Gemischte entwicklungsbedingte Sprachstörung",
      "Rezeptive Sprachentwicklungsstörung",
      "Rezeptive Sprachstörung",
      "Rezeptiver Typ einer entwicklungsbedingten Aphasie",
      "Rezeptiver Typ einer entwicklungsbedingten Dysphasie",
      "Worttaubheit"
    ]
  },
  {
    "code": "F80.3",
    "name": "Erworbene Aphasie mit Epilepsie",
    "synonyms": [
      "Erworbene Aphasie mit Epilepsie",
      "Landau-Kleffner-Syndrom"
    ]
  },
  {
    "code": "F80.8",
    "name": "Sigmatismus",
    "synonyms": [
      "Entwicklungsbedingte Amusie",
      "Lispeln",
      "Psychisches Lispeln",
      "Sigmatismus",
      "Sigmatismus interdentalis"
    ]
  },
  {
    "code": "F80.9",
    "name": "Rückstand in der Sprachentwicklung",
    "synonyms": [
      "Aussprachestörung",
      "Entwicklungsbedingte Sprachstörung",
      "Entwicklungsbedingter Sprachdefekt a.n.k.",
      "Entwicklungsbedingtes Kommunikationsproblem",
      "Entwicklungsbedingtes Sprachproblem",
      "Entwicklungsbedingtes Sprechproblem",
      "Rückstand in der Sprachentwicklung",
      "Spezifische Sprachentwicklungsstörung",
      "Sprachbildungsstörung",
      "Störung der Sprachentwicklung",
      "Störung der Sprechentwicklung",
      "Verzögerung der Sprachentwicklung"
    ]
  },
  {
    "code": "F81.0",
    "name": "Lese-Rechtschreib-Schwäche",
    "synonyms": [
      "Entwicklungsbedingte Alexie",
      "Entwicklungsbedingte Dyslexie",
      "Entwicklungsbedingte Lesestörung",
      "Entwicklungsdyslexie",
      "Entwicklungsstörung der Lesefähigkeit",
      "Entwicklungsstörung der Rechtschreibfähigkeit",
      "Legasthenie",
      "Lese-Rechtschreib-Schwäche",
      "Lese-Rechtschreib-Störung",
      "Leserückstand",
      "Leseschwierigkeiten",
      "Rechtschreib-Störung bei Lesestörung",
      "Strephosymbolie",
      "Umschriebene Lesestörung",
      "Umschriebene Rechtschreibschwierigkeiten"
    ]
  },
  {
    "code": "F81.1",
    "name": "Isolierte Rechtschreib-Störung",
    "synonyms": [
      "Isolierte Rechtschreib-Störung",
      "Rechtschreib-Störung",
      "Umschriebene Verzögerung der Rechtschreibfähigkeit",
      "Umschriebene Verzögerung der Rechtschreibfähigkeit ohne Lesestörung"
    ]
  },
  {
    "code": "F81.2",
    "name": "Rechenschwäche",
    "synonyms": [
      "Akalkulie bei Entwicklungsrückstand",
      "Entwicklungs-Akalkulie",
      "Entwicklungsbedingtes Gerstmann-Syndrom",
      "Entwicklungsstörung des Rechnens",
      "Gerstmann-Syndrom",
      "Rechenschwäche",
      "Rechenstörung"
    ]
  },
  {
    "code": "F81.3",
    "name": "Kombinierte Störungen der schulischen Fertigkeiten",
    "synonyms": [
      "Kombinierte Störungen der schulischen Fertigkeiten"
    ]
  },
  {
    "code": "F81.8",
    "name": "Psychische Lernstörung",
    "synonyms": [
      "Entwicklungsbedingte Agraphie",
      "Entwicklungsbedingte expressive Schreibstörung",
      "Psychische Lernstörung"
    ]
  },
  {
    "code": "F81.9",
    "name": "Entwicklungsstörung in der Schule",
    "synonyms": [
      "Entwicklungsproblem des Lernvermögens",
      "Entwicklungsstörung der Lernfähigkeit",
      "Entwicklungsstörung in der Schule",
      "Entwicklungsstörung schulischer Fertigkeiten",
      "Lernbehinderung",
      "Lerndefekt",
      "Lernschwäche",
      "Lernstörung",
      "Problem Kenntnisse zu erwerben",
      "Schwierigkeiten Kenntnisse zu erwerben",
      "Wissenserwerbstörung"
    ]
  },
  {
    "code": "F82.0",
    "name": "Grobmotorische Teilleistungsschwäche",
    "synonyms": [
      "Grobmotorische Teilleistungsschwäche",
      "Umschriebene Entwicklungsstörung der Grobmotorik"
    ]
  },
  {
    "code": "F82.1",
    "name": "Umschriebene Entwicklungsstörung der Fein- und Graphomotorik",
    "synonyms": [
      "Umschriebene Entwicklungsstörung der Fein- und Graphomotorik"
    ]
  },
  {
    "code": "F82.2",
    "name": "Umschriebene Entwicklungsstörung der Mundmotorik",
    "synonyms": [
      "Umschriebene Entwicklungsstörung der Mundmotorik"
    ]
  },
  {
    "code": "F82.9",
    "name": "Motorischer Entwicklungsrückstand",
    "synonyms": [
      "Dyspraxie-Syndrom",
      "Entwicklungsbedingte Koordinationsstörung",
      "Entwicklungsdyspraxie",
      "Entwicklungsstörung der motorischen Funktion",
      "Entwicklungsstörung der motorischen Koordination",
      "Motorische Entwicklungsverzögerung",
      "Motorischer Entwicklungsrückstand",
      "Sensomotorische Störung",
      "Statomotorische Retardierung",
      "Syndrom des ungeschickten Kindes",
      "Ungeschicklichkeit",
      "Verbale Entwicklungsdyspraxie"
    ]
  },
  {
    "code": "F83",
    "name": "Kombinierte Entwicklungsstörung",
    "synonyms": [
      "Entwicklungsrückstand, Mischform",
      "Entwicklungsstörung, Mischform",
      "Kombinierte Entwicklungsstörung",
      "Psychomotorische Retardierung"
    ]
  },
  {
    "code": "F84.0",
    "name": "Frühkindlicher Autismus",
    "synonyms": [
      "Autismus",
      "Autistische Störung",
      "Frühkindliche Psychose",
      "Frühkindlicher Autismus",
      "Frühkindliches Autismus-Syndrom",
      "Infantile Psychose",
      "Infantiler Autismus",
      "Kanner-Syndrom",
      "Psychose im Kindesalter"
    ]
  },
  {
    "code": "F84.1",
    "name": "Atypischer Autismus",
    "synonyms": [
      "Atypische Psychose im Kindesalter",
      "Atypische kindliche Psychose",
      "Atypischer Autismus",
      "GRIN2B-assoziierte Entwicklungsverzögerung mit Intelligenzminderung und Autismus-Spektrum-Störung",
      "Intelligenzminderung mit autistischen Zügen"
    ]
  },
  {
    "code": "F84.2",
    "name": "Rett-Syndrom",
    "synonyms": [
      "Atypisches Rett-Syndrom",
      "Rett-Syndrom"
    ]
  },
  {
    "code": "F84.3",
    "name": "Heller-Demenz",
    "synonyms": [
      "Dementia infantilis",
      "Desintegrative Psychose",
      "Desintegrative Störung beim Kind a.n.k.",
      "Heller-Demenz",
      "Heller-Syndrom",
      "Symbiotische Psychose im Kindesalter"
    ]
  },
  {
    "code": "F84.4",
    "name": "Überaktive Störung mit Bewegungsstereotypie und Intelligenzminderung",
    "synonyms": [
      "Hyperkinesie mit Bewegungsstereotypie und Intelligenzminderung",
      "Snijders-Blok-Campeau-Syndrom",
      "Überaktive Störung mit Bewegungsstereotypie und Intelligenzminderung"
    ]
  },
  {
    "code": "F84.5",
    "name": "Asperger-Syndrom",
    "synonyms": [
      "Asperger-Krankheit",
      "Asperger-Syndrom",
      "Autistische Psychopathie",
      "Früh beginnende Schizophrenie",
      "Kindliche Schizophrenie",
      "Schizoide Störung beim Kind",
      "Schizophrenes Syndrom beim Kind"
    ]
  },
  {
    "code": "F84.9",
    "name": "Tiefgreifende Entwicklungsstörung",
    "synonyms": [
      "Tiefgreifende Entwicklungsstörung"
    ]
  },
  {
    "code": "F88",
    "name": "Entwicklungsbedingte Agnosie",
    "synonyms": [
      "Entwicklungsbedingte Agnosie"
    ]
  },
  {
    "code": "F89",
    "name": "Entwicklungsstörung",
    "synonyms": [
      "Allgemeine Entwicklungsverzögerung",
      "Entwicklungsstörung",
      "Entwicklungsverzögerung",
      "Unklares Retardierungssyndrom",
      "Verzögerte Entwicklung"
    ]
  },
  {
    "code": "F90.0",
    "name": "Aufmerksamkeits- und Aktivitätsstörung",
    "synonyms": [
      "ADHS [Aufmerksamkeitsdefizit- und Hyperaktivitätsstörung]",
      "Aufmerksamkeits- und Aktivitätsstörung",
      "Aufmerksamkeitsdefizit bei Hyperaktivitätsstörung",
      "Aufmerksamkeitsdefizit bei hyperaktivem Syndrom",
      "Aufmerksamkeitsdefizit- und Hyperaktivitätsstörung [ADHS]",
      "Aufmerksamkeitsdefizitsyndrom [ADS]",
      "Aufmerksamkeitsstörung beim Kind",
      "Einfache Aktivitäts- und Aufmerksamkeitsstörung",
      "Hyperkinesie mit Aktivitäts- und Aufmerksamkeitsstörung"
    ]
  },
  {
    "code": "F90.1",
    "name": "Hyperkinetisches Syndrom mit Störung des Sozialverhaltens im Kindesalter",
    "synonyms": [
      "Hyperkinetisches Syndrom mit Störung des Sozialverhaltens im Kindesalter"
    ]
  },
  {
    "code": "F90.8",
    "name": "Hyperkinetisches Syndrom mit Entwicklungsrückstand",
    "synonyms": [
      "Erethismus",
      "Hyperkinetisches Syndrom mit Entwicklungsrückstand"
    ]
  },
  {
    "code": "F90.9",
    "name": "Hyperaktivität beim Kind",
    "synonyms": [
      "Hyperaktivität beim Kind",
      "Hyperaktivität im Kindesalter",
      "Hyperkinesie",
      "Hyperkinesie im Kindesalter",
      "Hyperkinesie in der Adoleszenz",
      "Hyperkinetische Bewegungsstörung",
      "Hyperkinetische Krankheit",
      "Hyperkinetische Reaktion",
      "Hyperkinetische Reaktion im Jugendalter",
      "Hyperkinetische Reaktion im Kindesalter",
      "Hyperkinetische Störung",
      "Hyperkinetisches Syndrom",
      "Hyperkinetisches Syndrom im Kindesalter"
    ]
  },
  {
    "code": "F91.0",
    "name": "Familienbezogene Störung des Sozialverhaltens",
    "synonyms": [
      "Familienbezogene Störung des Sozialverhaltens"
    ]
  },
  {
    "code": "F91.1",
    "name": "Fehlende Sozialisation bei Aggressivität",
    "synonyms": [
      "Aggressive Störung ohne Sozialisation",
      "Aggressiver Anfall",
      "Aggressiver Typ der Störung des Sozialverhaltens",
      "Aggressives Kind",
      "Aggressives Verhalten",
      "Aggressives Verhalten im Kindes- und Jugendalter",
      "Aggressivität",
      "Fehlende Sozialisation bei Aggressivität",
      "Nichtsozialisierte aggressive Störung",
      "Schulschwänzen in der Kindheit ohne Sozialisation",
      "Störung des Sozialverhaltens mit fehlender sozialer Bindung",
      "Störung des Sozialverhaltens ohne Sozialisation",
      "Wutausbrüche",
      "Wutausbrüche beim Kind"
    ]
  },
  {
    "code": "F91.2",
    "name": "Störung des Sozialverhaltens mit Sozialisation",
    "synonyms": [
      "Gemeinsames Stehlen",
      "Gruppenaggressivität",
      "Gruppendelinquenz",
      "Gruppendruck",
      "Schulschwänzen",
      "Schulschwänzen in der Kindheit mit Sozialisation",
      "Störung des Sozialverhaltens in der Gruppe",
      "Störung des Sozialverhaltens mit Sozialisation",
      "Störung des Sozialverhaltens mit andauerndem aggressiven Verhalten",
      "Störung des Sozialverhaltens mit andauerndem dissozialen Verhalten",
      "Störung des Sozialverhaltens mit sozialer Bindung",
      "Vergehen bei Bandenmitgliedschaft"
    ]
  },
  {
    "code": "F91.3",
    "name": "Störung des Sozialverhaltens mit oppositionellem aufsässigen Verhalten",
    "synonyms": [
      "Störung des Sozialverhaltens mit oppositionellem aufsässigen Verhalten"
    ]
  },
  {
    "code": "F91.8",
    "name": "Delinquenz",
    "synonyms": [
      "Delinquenz",
      "Delinquenz beim Jugendlichen",
      "Destruktives Verhalten",
      "Kindliche Launenhaftigkeit",
      "Launenhaftigkeit",
      "Lügensucht"
    ]
  },
  {
    "code": "F91.9",
    "name": "Störung des Sozialverhaltens",
    "synonyms": [
      "Störung des Sozialverhaltens",
      "Störung des Sozialverhaltens im Kindesalter",
      "Verhaltensstörung im Kindesalter"
    ]
  },
  {
    "code": "F92.0",
    "name": "Störung des Sozialverhaltens mit Depression",
    "synonyms": [
      "Störung des Sozialverhaltens mit Depression",
      "Störung des Sozialverhaltens mit depressiver Störung"
    ]
  },
  {
    "code": "F92.8",
    "name": "Störung des Sozialverhaltens mit emotionaler Symptomatik",
    "synonyms": [
      "Neurotische Delinquenz",
      "Störung des Sozialverhaltens mit emotionaler Störung",
      "Störung des Sozialverhaltens mit emotionaler Störung im Kindesalter",
      "Störung des Sozialverhaltens mit emotionaler Symptomatik",
      "Störung des Sozialverhaltens mit neurotischer Störung"
    ]
  },
  {
    "code": "F92.9",
    "name": "Kombinierte Störung des Sozialverhaltens und der Emotion",
    "synonyms": [
      "Kombinierte Störung des Sozialverhaltens und der Emotion"
    ]
  },
  {
    "code": "F93.0",
    "name": "Emotionale Störung mit Trennungsangst im Kindesalter",
    "synonyms": [
      "Emotionale Störung mit Trennungsangst im Kindesalter",
      "Trennungsangst im Kindesalter"
    ]
  },
  {
    "code": "F93.1",
    "name": "Phobische Störung im Kindesalter",
    "synonyms": [
      "Abnorme kindliche Furchtreaktion",
      "Phobische Störung im Kindesalter"
    ]
  },
  {
    "code": "F93.2",
    "name": "Störung mit sozialer Ängstlichkeit im Kindesalter",
    "synonyms": [
      "Abkapselungsreaktion beim Jugendlichen",
      "Abkapselungsreaktion beim Kind",
      "Beziehungsschwierigkeiten beim Kind",
      "Beziehungsstörung beim Kind",
      "Emotionale Störung mit sozialer Ängstlichkeit im Kindesalter",
      "Jugendliche Beziehungsstörung",
      "Kontaktstörung beim Kind",
      "Scheu und Abkapselung beim Kind",
      "Soziale Ängstlichkeit im Kindesalter",
      "Störung mit sozialer Ängstlichkeit im Kindesalter",
      "Vermeidende Störung beim Jugendlichen",
      "Vermeidende Störung beim Kind"
    ]
  },
  {
    "code": "F93.3",
    "name": "Eifersucht im Kindesalter",
    "synonyms": [
      "Eifersucht im Kindesalter",
      "Eifersucht unter Geschwistern",
      "Emotionale Störung mit Geschwisterrivalität im Kindesalter",
      "Geschwistereifersucht im Kindesalter",
      "Geschwisterrivalität",
      "Geschwisterrivalität bei spezifischer emotionaler Störung im Kindesalter"
    ]
  },
  {
    "code": "F93.8",
    "name": "Angst beim Kind",
    "synonyms": [
      "Angst bei spezifischer emotionaler Störung im Kindesalter",
      "Angst beim Kind",
      "Emotionale Störung der Identität mit Überängstlichkeit im Kindesalter",
      "Furchtsamkeit beim Kind",
      "Identitätsstörung im Kindesalter",
      "Mangelnde Ich-Identifikation beim Kind",
      "Problem mit der Bezugsperson im Kindesalter",
      "Rivalität in der Peer-Gruppe",
      "Spezifische emotionale Krise im Jugendalter",
      "Spezifische emotionale Krise im Kindesalter",
      "Störung mit Überängstlichkeit im Kindesalter",
      "Unglücklichsein beim Kind",
      "Überängstliche Reaktion beim Kind"
    ]
  },
  {
    "code": "F93.9",
    "name": "Spezifische emotionale Störung im Kindesalter",
    "synonyms": [
      "Spezifische emotionale Störung im Kindesalter"
    ]
  },
  {
    "code": "F94.0",
    "name": "Elektiver Mutismus",
    "synonyms": [
      "Anpassungsreaktion mit elektivem Mutismus",
      "Elektiver Mutismus",
      "Selektiver Mutismus"
    ]
  },
  {
    "code": "F94.1",
    "name": "Reaktive Bindungsstörung im Kindesalter",
    "synonyms": [
      "Reaktive Bindungsstörung im Kindesalter"
    ]
  },
  {
    "code": "F94.2",
    "name": "Bindungsstörung mit Enthemmung im Kindesalter",
    "synonyms": [
      "Bindungsstörung mit Enthemmung im Kindesalter",
      "Gefühlsarme Psychopathie",
      "Gefühlsarme Psychopathie im Kindesalter",
      "Hospitalismus",
      "Psychopathie beim Kind"
    ]
  },
  {
    "code": "F94.9",
    "name": "Soziale Funktionsstörung",
    "synonyms": [
      "Soziale Funktionsstörung"
    ]
  },
  {
    "code": "F95.0",
    "name": "Vorübergehende Ticstörung",
    "synonyms": [
      "Vorübergehende Ticstörung"
    ]
  },
  {
    "code": "F95.1",
    "name": "Räusperzwang",
    "synonyms": [
      "Chronische motorische Ticstörung",
      "Chronische vokale Ticstörung",
      "Räusperzwang"
    ]
  },
  {
    "code": "F95.2",
    "name": "Kombinierte vokale und multiple motorische Tics [Tourette-Syndrom]",
    "synonyms": [
      "Gilles de la Tourette-Syndrom",
      "Gilles-Krankheit",
      "Kombinierte vokale und multiple motorische Tics [Tourette-Syndrom]",
      "Tourette-Krankheit",
      "Tourette-Syndrom"
    ]
  },
  {
    "code": "F95.8",
    "name": "Orbikularis-Tic",
    "synonyms": [
      "Atmungs-Tic",
      "Augenlid-Tic",
      "Orbikularis-Tic"
    ]
  },
  {
    "code": "F95.9",
    "name": "Nervöser Tic",
    "synonyms": [
      "Augenlidzucken",
      "Blinzeltic",
      "Gewohnheitstic",
      "Habitueller Spasmus",
      "Nervöser Tic",
      "Nervöses Zucken",
      "Psychogene Ticstörung",
      "Psychogenes Augenlidzucken",
      "Tic",
      "Tic-Krankheit",
      "Tick - s.a. Tic",
      "Ticstörung",
      "Ticstörung mit Spasmen",
      "Unwillkürlicher Spasmus im Sinne von Tic"
    ]
  },
  {
    "code": "F98.00",
    "name": "Nichtorganische Enuresis nocturna",
    "synonyms": [
      "Enuresis nocturna neurotica",
      "Nichtorganische Enuresis nocturna",
      "Psychogene Enuresis nocturna"
    ]
  },
  {
    "code": "F98.01",
    "name": "Nichtorganische Enuresis diurna",
    "synonyms": [
      "Nichtorganische Enuresis diurna"
    ]
  },
  {
    "code": "F98.02",
    "name": "Nichtorganische Enuresis nocturna et diurna",
    "synonyms": [
      "Nichtorganische Enuresis nocturna et diurna"
    ]
  },
  {
    "code": "F98.08",
    "name": "Nichtorganische Enuresis",
    "synonyms": [
      "Funktionelle Enuresis",
      "Incontinentia urinae nichtorganischen Ursprungs",
      "Nervöse Enuresis",
      "Nichtorganische Enuresis",
      "Nichtorganische Harninkontinenz",
      "Nichtorganische primäre Enuresis",
      "Nichtorganische sekundäre Enuresis",
      "Psychogene Enuresis",
      "Urininkontinenz nichtorganischen Ursprungs"
    ]
  },
  {
    "code": "F98.1",
    "name": "Nichtorganische Enkopresis",
    "synonyms": [
      "Funktionelle Enkopresis",
      "Incontinentia alvi nichtorganischen Ursprungs",
      "Incontinentia faecalis nichtorganischen Ursprungs",
      "Nervöse Enkopresis",
      "Nichtorganische Enkopresis",
      "Nichtorganische Stuhlinkontinenz",
      "Psychogene Enkopresis",
      "Unfreiwilliger Stuhlabgang nichtorganischen Ursprungs",
      "Verlust der Kontrolle über den Rektumsphinkter nichtorganischen Ursprungs"
    ]
  },
  {
    "code": "F98.2",
    "name": "Fütterstörung im frühen Kindesalter",
    "synonyms": [
      "Fütterstörung im frühen Kindesalter",
      "Nahrungsverweigerung im frühen Kindesalter",
      "Nichtorganische Ernährungsschwierigkeiten im frühen Kindesalter",
      "Rumination im Kleinkindalter"
    ]
  },
  {
    "code": "F98.3",
    "name": "Pica im Kindesalter",
    "synonyms": [
      "Pica im Kindesalter",
      "Pica-Syndrom im Kindesalter"
    ]
  },
  {
    "code": "F98.40",
    "name": "Haarzupfen bei stereotyper Bewegungsstörung",
    "synonyms": [
      "Haarzupfen bei stereotyper Bewegungsstörung",
      "Stereotype Bewegungsstörung ohne Selbstverletzung"
    ]
  },
  {
    "code": "F98.41",
    "name": "Stereotype Bewegungsstörung mit Selbstverletzung",
    "synonyms": [
      "Stereotype Bewegungsstörung mit Selbstverletzung"
    ]
  },
  {
    "code": "F98.49",
    "name": "Stereotype Bewegungsstörung",
    "synonyms": [
      "Epilepsia nutans",
      "Spasmus nutans",
      "Stereotype Bewegungsstörung",
      "Stereotype abnorme Gewohnheiten",
      "Stereotypie a.n.k."
    ]
  },
  {
    "code": "F98.5",
    "name": "Stammeln",
    "synonyms": [
      "Anarthria syllabaris",
      "Balbuties",
      "Diskretes Stammeln",
      "Dysarthria syllabaris",
      "Entwicklungsstottern",
      "Psellismus",
      "Psychogenes Stammeln",
      "Psychogenes Stottern",
      "Silbenstolpern",
      "Stammeln",
      "Stottern"
    ]
  },
  {
    "code": "F98.6",
    "name": "Poltern",
    "synonyms": [
      "Poltern"
    ]
  },
  {
    "code": "F98.80",
    "name": "Reduziertes Konzentrationsvermögen",
    "synonyms": [
      "Aufmerksamkeitsdefizit",
      "Aufmerksamkeitsstörung",
      "Aufmerksamkeitsstörung ohne Hyperaktivität",
      "Aufmerksamkeitsstörung ohne Hyperaktivität mit Beginn in der Kindheit und Jugend",
      "Reduziertes Konzentrationsvermögen",
      "Verhaltensbedingte Insomnie in der Kindheit"
    ]
  },
  {
    "code": "F98.88",
    "name": "Daumenlutschen",
    "synonyms": [
      "Daumenlutschen",
      "Daumenlutschen beim Kind",
      "Exzessive Masturbation",
      "Exzessive Onanie",
      "Exzessives Daumenlutschen beim Kind",
      "Masturbation",
      "Masturbation beim Kind",
      "Nasebohren",
      "Nägelbeißen",
      "Nägelkauen",
      "Nägelkauen beim Kind",
      "Onanie",
      "Onychophagie",
      "Onychophagie beim Kind",
      "Psychogener Sprachfehler beim Kind a.n.k."
    ]
  },
  {
    "code": "F98.9",
    "name": "Emotionale Störung im Jugendalter",
    "synonyms": [
      "Emotionale Störung im Jugendalter",
      "Emotionale Verhaltensstörung im Kindes- und Jugendalter"
    ]
  },
  {
    "code": "F99",
    "name": "Insania",
    "synonyms": [
      "Gemütskrankheit",
      "Gemütsleiden",
      "Insania",
      "Psychiatrische Erkrankung",
      "Psychiatrische Krankheit",
      "Psychiatrisches Problem",
      "Psychische Erkrankung",
      "Psychische Krankheit",
      "Psychische Störung a.n.k.",
      "Psychisches Problem a.n.k.",
      "Psychogene Erkrankung",
      "Psychogene Reaktion a.n.k."
    ]
  },
  {
    "code": "G00.0",
    "name": "Meningitis durch Haemophilus influenzae",
    "synonyms": [
      "Meningitis durch Haemophilus influenzae"
    ]
  },
  {
    "code": "G00.1",
    "name": "Meningitis durch Pneumokokken",
    "synonyms": [
      "Meningitis durch Pneumokokken",
      "Pneumokokkenmeningitis"
    ]
  },
  {
    "code": "G00.2",
    "name": "Meningitis durch Streptokokken",
    "synonyms": [
      "Meningitis durch Streptokokken"
    ]
  },
  {
    "code": "G00.3",
    "name": "Meningitis durch Staphylokokken",
    "synonyms": [
      "Meningitis durch Staphylokokken"
    ]
  },
  {
    "code": "G00.9",
    "name": "Bakterielle Meningitis a.n.k.",
    "synonyms": [
      "Bakterielle Arachnoiditis",
      "Bakterielle Leptomeningitis",
      "Bakterielle Meningitis a.n.k.",
      "Bakterielle Pachymeningitis",
      "Eitrige Meningitis",
      "Fibrinopurulente Meningitis",
      "Meningeninfektion",
      "Meningitis durch gramnegative Bakterien",
      "Meningitis durch gramnegative Kokken",
      "Meningitis durch grampositive Kokken a.n.k.",
      "Meningitis purulenta",
      "Purulente Meningitis",
      "Pyogene Meningitis",
      "Septische Meningitis"
    ]
  },
  {
    "code": "G03.0",
    "name": "Nichteitrige Meningitis a.n.k.",
    "synonyms": [
      "Abakterielle Meningitis a.n.k.",
      "Akute aseptische Meningitis a.n.k.",
      "Aseptische Meningitis",
      "Meningitis bei klarem Liquor cerebrospinalis a.n.k.",
      "Meningitis serosa circumscripta a.n.k.",
      "Nichtbakterielle Meningitis a.n.k.",
      "Nichteitrige Leptomeningitis",
      "Nichteitrige Meningitis a.n.k.",
      "Seröse Meningitis",
      "Sterile Meningitis"
    ]
  },
  {
    "code": "G03.1",
    "name": "Chronische Meningitis a.n.k.",
    "synonyms": [
      "Chronische Meningitis a.n.k."
    ]
  },
  {
    "code": "G03.2",
    "name": "Benigne rezidivierende Meningitis",
    "synonyms": [
      "Benigne rezidivierende Meningitis",
      "Mollaret-Meningitis"
    ]
  },
  {
    "code": "G03.8",
    "name": "Chemische Arachnoiditis",
    "synonyms": [
      "Chemische Arachnoiditis",
      "IgG4-assoziierte Pachymeningitis"
    ]
  },
  {
    "code": "G03.9",
    "name": "Basalmeningitis",
    "synonyms": [
      "Adhäsive Arachnoiditis",
      "Adhäsive Pachymeningitis",
      "Akute Arachnoiditis",
      "Arachnoiditis",
      "Basalarachnoiditis",
      "Basale Pachymeningitis",
      "Basalmeningitis",
      "Basilärmeningitis",
      "Chronische Arachnoiditis",
      "Chronische Leptomeningitis",
      "Fibröse Pachymeningitis",
      "Gehirnhautinfektion",
      "Haubenleptomeningitis",
      "Haubenmeningitis",
      "Hirnhautentzündung",
      "Hydromeningitis",
      "Hypertrophische Pachymeningitis",
      "Hämorrhagische Leptomeningitis",
      "Hämorrhagische Pachymeningitis",
      "Konvexitätsmeningitis",
      "Leptomeningitis",
      "Meningenentzündung",
      "Meningenerguss",
      "Meningitis",
      "Meningitis basalis",
      "Meningoradikulitis",
      "Pachymeningitis",
      "Perimeningitis",
      "Rückenmarkerguss",
      "Spinale Arachnoiditis",
      "Spinale Meningitis",
      "Spinale Pachymeningitis",
      "Unspezifische Meningitis",
      "Zerebrale Meningitis",
      "Zerebrale Pachymeningitis",
      "Zerebrospinale Arachnoiditis",
      "Zerebrospinaler Erguss",
      "Zirkumskripte Leptomeningitis"
    ]
  },
  {
    "code": "G04.0",
    "name": "Akute disseminierte Enzephalitis",
    "synonyms": [
      "ADEM [Akute disseminierte Enzephalomyelitis]",
      "Akute Enzephalomyelitis",
      "Akute disseminierte Enzephalitis",
      "Akute disseminierte Enzephalomyelitis",
      "Akute disseminierte Enzephalomyelitis mit anti-MOG-Antikörper",
      "Akute disseminierte Enzephalomyelitis ohne anti-MOG-Antikörper",
      "Akute disseminierte Meningoenzephalomyelitis",
      "Akute disseminierte postinfektiöse Enzephalomyelitis",
      "Akute hämorrhagische Leukoenzephalitis nach Immunisierung",
      "Disseminierte Enzephalitis",
      "Enzephalitis als Impfkomplikation",
      "Enzephalitis nach Immunisierung",
      "Enzephalitis nach Impfung",
      "Enzephalitis nach Pockenimpfung",
      "Enzephalitis nach Vakzination",
      "Enzephalomyelitis als Impfkomplikation",
      "Enzephalomyelitis nach Immunisierung",
      "Enzephalomyelitis nach Impfung",
      "Enzephalomyelitis nach Vakzination",
      "Impfenzephalitis",
      "Leukoenzephalopathie nach Immunisierung",
      "Myelitis nach Immunisierung",
      "Myelitis nach Vakzination",
      "Postvakzinale Enzephalitis",
      "Postvakzinale Enzephalomyelitis",
      "Postvakzinale Leukoenzephalopathie",
      "Postvakzinale akute hämorrhagische Leukoenzephalitis"
    ]
  },
  {
    "code": "G04.1",
    "name": "Tropische spastische Paraplegie",
    "synonyms": [
      "Humane T-Zell-lymphotrope Virus-assoziierte Myelopathie",
      "Myelopathie durch humane T-Zell-lymphotrope Viruskrankheit Typ I (HTLV-1)",
      "Tropische spastische Paraparese",
      "Tropische spastische Paraplegie"
    ]
  },
  {
    "code": "G04.2",
    "name": "Bakterielle Meningoenzephalitis a.n.k.",
    "synonyms": [
      "Bakterielle Meningoenzephalitis a.n.k.",
      "Bakterielle Meningomyelitis a.n.k.",
      "Embolische Herdenzephalitis",
      "Herdenzephalitis",
      "Metastasierende Herdenzephalitis",
      "Metastatische Herdenzephalitis"
    ]
  },
  {
    "code": "G04.8",
    "name": "Myeloradikulitis",
    "synonyms": [
      "Autoimmune Enzephalopathie [anti-IgLON5] mit Parasomnie und obstruktiver Schlafapnoe",
      "Autoimmune limbische Enzephalitis",
      "CLIPPERS [Chronic lymphocytic inflammation with pontine perivascular enhancement responsive to steroids]-Syndrom",
      "Eitrige Enzephalitis",
      "Leukenzephalitis",
      "Leukoenzephalitis",
      "Limbische Enzephalitis mit DPP6 [Dipeptidyl-peptidase-6]-Antikörpern",
      "Myeloradikulitis",
      "Postinfektiöse Enzephalitis",
      "Postinfektiöse Enzephalomyelitis",
      "Postinfektiöse Leukenzephalitis",
      "Postinfektiöse Leukoenzephalitis",
      "Postinfektiöse Myelitis a.n.k.",
      "Postinfektiöse Zerebellitis",
      "Rasmussen-Enzephalitis"
    ]
  },
  {
    "code": "G04.9",
    "name": "Chronisch-entzündlicher Prozess des Zentralnervensystems",
    "synonyms": [
      "Akute Ependymitis",
      "Akute Myelitis",
      "Akute aszendierende Myelitis",
      "Aszendierende Myelitis",
      "Chronisch-entzündlicher Prozess des Zentralnervensystems",
      "Chronische Enzephalitis",
      "Chronische Ependymitis",
      "Diffuse Myelitis",
      "Disseminierte Myelitis",
      "Encephalitis - s.a. Enzephalitis",
      "Encephalomyelitis",
      "Entzündlicher Prozess des Zentralnervensystems",
      "Enzephalitis",
      "Enzephalomeningitis",
      "Enzephalomeningomyelitis",
      "Enzephalomyelitis",
      "Enzephalomyelomeningitis",
      "Ependymitis",
      "Falsche Enzephalitis",
      "Gehirnentzündung",
      "Gehirnfieber",
      "Gehirninfektion",
      "Granuläre Ependymitis",
      "Hypophysenentzündung",
      "Hypophysitis",
      "Hämatomyelitis",
      "Hämorrhagische Enzephalitis",
      "Idiopathische Enzephalitis",
      "Kompressionsmyelitis",
      "Medullitis",
      "Meningoenzephalitis",
      "Meningoenzephalomyelitis",
      "Meningomyelitis",
      "Meningomyeloneuritis",
      "Mesenzephalitis",
      "Myelenzephalitis",
      "Myelitis",
      "Myeloenzephalitis",
      "Myelomeningitis",
      "Nichtepidemische Enzephalitis",
      "Panhypophysitis",
      "Parenzephalitis",
      "Posttraumatische Enzephalitis",
      "Progressive Myelitis",
      "Querschnittmyelitis",
      "Radikulomyelitis",
      "Rückenmarkentzündung",
      "Rückenmarkinfektion",
      "Subakute Enzephalitis",
      "Syringomyelitis",
      "Ventrikulitis",
      "Zerebrale Entzündung",
      "Zerebrale Ependymitis",
      "Zerebrale Ventrikulitis",
      "Zerebrales Fieber"
    ]
  },
  {
    "code": "G06.0",
    "name": "Gehirnabszess",
    "synonyms": [
      "Abszess des Zerebellums",
      "Balkenabszess",
      "Embolischer Gehirnabszess",
      "Embolischer zerebraler Abszess",
      "Epiduraler Gehirnabszess",
      "Epiduraler intrakranieller Abszess",
      "Epidurales intrakranielles Granulom",
      "Extraduraler Gehirnabszess",
      "Extraduraler intrakranieller Abszess",
      "Extradurales intrakranielles Granulom",
      "Frontalhirnabszess",
      "Gehirnabszess",
      "Gehirneiterung",
      "Gehirnempyem",
      "Gehirngranulom",
      "Hirnabszess",
      "Intrakranielle Eiterung",
      "Intrakranieller Abszess",
      "Intrakranieller subduraler Abszess",
      "Intrakranieller venöser Abszess des Sinus accessorius",
      "Intrakranielles Granulom",
      "Kleinhirnabszess",
      "Otogener Gehirnabszess",
      "Parietalhirnabszess",
      "Pyozephalus",
      "Schläfenhirnabszess",
      "Septische Gehirninfektion",
      "Stammhirnabszess",
      "Stirnhirnabszess",
      "Subarachnoidaler Gehirnabszess",
      "Subdurales intrakranielles Granulom",
      "Temporalhirnabszess",
      "Temporosphenoidaler Abszess",
      "Ventrikuläres Empyem",
      "Zerebellarer Abszess",
      "Zerebraler Abszess",
      "Zerebrales Empyem",
      "Zerebrales Granulom",
      "Zerebrumabszess",
      "Zystischer Gehirnabszess"
    ]
  },
  {
    "code": "G06.1",
    "name": "Intraspinaler Abszess",
    "synonyms": [
      "Eitrige Rückenmarkembolie",
      "Embolischer Rückenmarkabszess",
      "Epiduraler Rückenmarkabszess",
      "Epiduraler intraspinaler Abszess",
      "Epidurales intraspinales Granulom",
      "Extraduraler Rückenmarkabszess",
      "Extraduraler intraspinaler Abszess",
      "Extradurales intraspinales Granulom",
      "Intraspinaler Abszess",
      "Rückenmarkabszess",
      "Rückenmarkthrombose eitrigen Ursprungs",
      "Spinalkanalabszess",
      "Subarachnoidaler Rückenmarkabszess",
      "Subduraler Rückenmarkabszess",
      "Subduraler intraspinaler Abszess",
      "Subdurales intraspinales Granulom"
    ]
  },
  {
    "code": "G06.2",
    "name": "Extraduraler Abszess",
    "synonyms": [
      "Epiduraler Abszess",
      "Epidurales und subdurales Empyem",
      "Extraduraler Abszess",
      "Extradurales Empyem",
      "Meningenabszess",
      "Subarachnoidaler Abszess",
      "Subarachnoidales Empyem",
      "Subduraler Abszess",
      "Subdurales Empyem"
    ]
  },
  {
    "code": "G08",
    "name": "Eitrige intrakranielle Phlebitis eines Venensinus",
    "synonyms": [
      "Eitrige intrakranielle Phlebitis eines Venensinus",
      "Gehirnsinusthrombose",
      "Hirnsinusthrombose",
      "Hirnvenenthrombose",
      "Intrakranielle Embolie eines Venensinus",
      "Intrakranielle Endophlebitis eines Venensinus",
      "Intrakranielle Phlebitis eines Venensinus",
      "Intrakranielle Thrombophlebitis eines Venensinus",
      "Intrakranielle Venensinusthrombose",
      "Intrakranielle eitrige Entzündung eines Venensinus",
      "Intrakranielle septische Embolie eines Venensinus",
      "Intrakranielle septische Endophlebitis",
      "Intrakranielle septische Endophlebitis eines Venensinus",
      "Intrakranielle septische Phlebitis",
      "Intrakranielle septische Phlebitis eines Venensinus",
      "Intrakranielle septische Thrombophlebitis",
      "Intrakranielle septische Thrombophlebitis eines Venensinus",
      "Intrakranielle septische Thrombose eines Venensinus",
      "Intrakranielle septische Venenembolie",
      "Intrakranielle septische Venenthrombose",
      "Intraspinale Venensinusembolie",
      "Intraspinale septische Endophlebitis",
      "Intraspinale septische Endophlebitis eines Venensinus",
      "Intraspinale septische Phlebitis",
      "Intraspinale septische Phlebitis eines Venensinus",
      "Intraspinale septische Thrombophlebitis",
      "Intraspinale septische Thrombophlebitis eines Venensinus",
      "Intraspinale septische Thrombose eines Venensinus",
      "Intraspinale septische Venenembolie",
      "Intraspinale septische Venensinusembolie",
      "Intraspinale septische Venenthrombose",
      "Phlebitis einer intraspinalen Vene",
      "Phlebitis eines intraspinalen Venensinus",
      "Septische Hirnsinusthrombose",
      "Sinusvenenthrombose",
      "Thrombophlebitis des Sinus cavernosus",
      "Thrombophlebitis des Sinus transversus",
      "Thrombophlebitis einer intraspinalen Vene",
      "Thrombophlebitis eines intraspinalen Venensinus",
      "Thrombose des Sinus cavernosus",
      "Thrombose des Sinus longitudinalis",
      "Thrombose des Sinus sigmoideus",
      "Thrombose des Sinus transversus",
      "Thrombose einer intraspinalen Vene",
      "Thrombose eines intraspinalen Venensinus",
      "Zerebrale Venensinusthrombose"
    ]
  },
  {
    "code": "G09",
    "name": "Folgen einer Enzephalomyelitis",
    "synonyms": [
      "Folgen einer Enzephalitis",
      "Folgen einer Enzephalomyelitis",
      "Folgen einer Myelitis",
      "Folgen einer bakteriellen Meningitis",
      "Folgen einer pyogenen intrakraniellen Infektion",
      "Folgen einer pyogenen intraspinalen Infektion",
      "Folgen eines intrakraniellen Abszesses",
      "Folgen eines intraspinalen Abszesses",
      "Spätfolge einer Enzephalitis",
      "Spätfolge einer Enzephalomyelitis",
      "Zustand nach Meningitis"
    ]
  },
  {
    "code": "G10",
    "name": "Chorea Huntington",
    "synonyms": [
      "Chorea Huntington",
      "Chorea Huntington-ähnliche Erkrankung 2",
      "Chorea Huntington-ähnliche Erkrankung 3",
      "Chorea Huntington-ähnliches Syndrom durch C9ORF72-Expansionen",
      "Chorea chronica progressiva hereditaria",
      "Degenerative Chorea",
      "Erbliche Chorea",
      "Erbveitstanz",
      "Hereditäre Chorea",
      "Huntington-Krankheit",
      "Huntington-Syndrom",
      "Juvenile Huntington-Krankheit",
      "Morbus Huntington"
    ]
  },
  {
    "code": "G11.0",
    "name": "Angeborene nichtprogressive Ataxie",
    "synonyms": [
      "Angeborene nichtprogressive Ataxie",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 2",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 6",
      "Cayman-Ataxie",
      "Gillespie-Syndrom",
      "Nicht-progressive zerebelläre Ataxie mit Intelligenzminderung",
      "SCA [Spinozerebellare Ataxie] Typ 29",
      "X-chromosomale nicht-progressive zerebelläre Ataxie"
    ]
  },
  {
    "code": "G11.1",
    "name": "Früh beginnende zerebellare Ataxie",
    "synonyms": [
      "4H [Hypomyelinisierung, hypogonadotroper Hypogonadismus, Hypodontie]-Syndrom",
      "AOA4 [Ataxie mit okulomotorischer Apraxie Typ 4]",
      "ARSACS [Autosomal-rezessive spastische Ataxie vom Typ Charlevoix-Saguenay]",
      "AVED [Ataxie mit Vitamin E-Mangel]",
      "Angeborene zerebellare Ataxie durch RNU12-Genmutation",
      "Ataxie mit okulomotorischer Apraxie Typ 4",
      "Autosomal-rezessive Ataxie durch Ubiquinon-Mangel",
      "Autosomal-rezessive Friedreich-Ataxie",
      "Autosomal-rezessive spastische Ataxie vom Typ Charlevoix-Saguenay",
      "Autosomal-rezessive spinozerebellare Ataxie Typ 19",
      "Autosomal-rezessive spinozerebellare Ataxie Typ 5",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 13",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 15",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 16",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 17",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 20",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 23",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 7",
      "Autosomal-rezessive zerebellare Ataxie durch PEX2-Mutation",
      "Autosomal-rezessive zerebellare Ataxie mit spät beginnender Spastik",
      "Autosomal-rezessive zerebelläre Ataxie Typ 12",
      "Autosomal-rezessive zerebelläre Ataxie durch WWOX Gen-Mangel",
      "Autosomal-rezessive zerebelläre Ataxie mit Blindheit und Schwerhörigkeit",
      "Autosomal-rezessive zerebelläre Ataxie mit Epilepsie und Intelligenzminderung",
      "Autosomal-rezessive zerebelläre Ataxie mit psychomotorischer Retardierung",
      "CAMOS [Cerebellar ataxia, mental retardation, optic atrophy, skin abnormalities]-Syndrom",
      "Dyssynergia cerebellaris myoclonica",
      "EOCA [Früh beginnende zerebellare Ataxie]",
      "Friedreich-Ataxie",
      "Friedreich-I-Syndrom",
      "Friedreich-Rückenmarksklerose",
      "Friedreich-ähnliche Ataxie mit Vitamin E-Mangel",
      "Früh beginnende zerebellare Ataxie",
      "Früh beginnende zerebellare Ataxie mit Myoklonie",
      "Früh beginnende zerebellare Ataxie mit erhaltenen Sehnenreflexen",
      "Früh beginnende zerebellare Ataxie mit essentiellem Tremor",
      "Hereditäre familiäre Friedreich-Ataxie",
      "Hereditäre spinale Ataxie",
      "Hereditäre spinale Friedreich-Ataxie",
      "Hereditäre spinale Sklerose",
      "Hinterstrangataxie mit Retinitis pigmentosa",
      "Hunt-Ataxie",
      "Hunt-III-Syndrom",
      "IOSCA [Infantile spinozerebellare Ataxie]",
      "Infantile spinozerebellare Ataxie",
      "Marinesco-Sjögren-Syndrom",
      "Ohaha-Syndrom",
      "Poretti-Boltshauser-Syndrom",
      "Ramsay-Hunt-Krankheit [Dyssynergia cerebellaris myoclonica]",
      "Ramsay-Hunt-Syndrom [Dyssynergia cerebellaris myoclonica]",
      "SCA [Spinozerebellare Ataxie] Typ 21",
      "SCA [Spinozerebellare Ataxie] Typ 27",
      "SCA [Spinozerebellare Ataxie] Typ 28",
      "Spastische Ataxie vom Typ Charlevoix-Saguenay",
      "Spectrin-assoziierte autosomal-rezessive zerebelläre Ataxie",
      "Spinozerebellare Ataxie Typ 28",
      "Syndrom der autosomal-rezessiven zerebellaren Ataxie mit Pyramidenbahnzeichen, Nystagmus und okulomotorischer Apraxie",
      "Syndrom der spinozerebellaren Ataxie mit Dysmorphie",
      "Syndrom mit Myoklonie, zerebellärer Ataxie und Taubheit",
      "X-chromosomal-rezessive spinozerebellare Ataxie",
      "X-chromosomale spinozerebellare Ataxie Typ 1",
      "X-chromosomale spinozerebellare Ataxie Typ 3",
      "X-chromosomale spinozerebellare Ataxie Typ 4",
      "Zerebellare Ataxie mit Intelligenzminderung, Optikusatrophie und Hautanomalien",
      "Zerebelläre Ataxie mit ektodermaler Dysplasie"
    ]
  },
  {
    "code": "G11.2",
    "name": "Spät beginnende zerebellare Ataxie",
    "synonyms": [
      "Ataxie mit Katarakt und Taubheit",
      "Autosomal-dominante zerebelläre Ataxie mit Schwerhörigkeit und Narkolepsie",
      "Autosomal-rezessive Ataxie Typ Beauce",
      "Autosomal-rezessive spinozerebelläre Ataxie Typ 10",
      "Autosomal-rezessive zerebelläre Ataxie mit Beginn im Erwachsenenalter",
      "FXTAS [Fragiles X-Tremor-Ataxie-Syndrom]",
      "Marie-Ataxie",
      "Marie-Pierre-II-Syndrom",
      "SCA [Spinozerebellare Ataxie] Typ 10",
      "SCA [Spinozerebellare Ataxie] Typ 12",
      "SCA [Spinozerebellare Ataxie] Typ 13",
      "SCA [Spinozerebellare Ataxie] Typ 14",
      "SCA [Spinozerebellare Ataxie] Typ 15",
      "SCA [Spinozerebellare Ataxie] Typ 19",
      "SCA [Spinozerebellare Ataxie] Typ 2",
      "SCA [Spinozerebellare Ataxie] Typ 20",
      "SCA [Spinozerebellare Ataxie] Typ 23",
      "SCA [Spinozerebellare Ataxie] Typ 26",
      "SCA [Spinozerebellare Ataxie] Typ 30",
      "SCA [Spinozerebellare Ataxie] Typ 34",
      "SCA [Spinozerebellare Ataxie] Typ 36",
      "SCA [Spinozerebellare Ataxie] Typ 38",
      "SCA [Spinozerebellare Ataxie] Typ 4",
      "SCA [Spinozerebellare Ataxie] Typ 40",
      "SCA [Spinozerebellare Ataxie] Typ 43",
      "SCA [Spinozerebellare Ataxie] Typ 44",
      "SCA [Spinozerebellare Ataxie] Typ 45",
      "SCA [Spinozerebellare Ataxie] Typ 46",
      "SCA [Spinozerebellare Ataxie] Typ 47",
      "SCA [Spinozerebellare Ataxie] Typ 47 mit Beginn im Erwachsenenalter",
      "SCA [Spinozerebellare Ataxie] Typ 48",
      "SCA [Spinozerebellare Ataxie] Typ 49",
      "SCA [Spinozerebellare Ataxie] Typ 6",
      "SCA [Spinozerebellare Ataxie] Typ 8",
      "Sanger-Brown-Ataxie",
      "Spinozerebellare Ataxie Typ 41",
      "Spinozerebellare Ataxie Typ 46",
      "Spät beginnende zerebellare Ataxie",
      "Spät beginnendes Marie-Pierre-II-Syndrom"
    ]
  },
  {
    "code": "G11.3",
    "name": "Zerebellare Ataxie mit defektem DNA-Reparatursystem",
    "synonyms": [
      "AOA1 [Ataxie mit okulomotorischer Apraxie Typ 1]",
      "ATLD [Ataxia-telangiectasia-like disorder]",
      "Ataxia teleangiectatica",
      "Ataxie mit okulomotorischer Apraxie Typ 1",
      "Louis-Bar-Syndrom",
      "PCNA-assoziiertes progressives neurodegeneratives photosensitives Syndrom",
      "Teleangiektatische Ataxie",
      "Zerebellare Ataxie mit defektem DNA-Reparatursystem",
      "Zerebellare Teleangiektasie"
    ]
  },
  {
    "code": "G11.4",
    "name": "Hereditäre spastische Paraplegie",
    "synonyms": [
      "Autosomal-dominante spastische Ataxie Typ 1",
      "Autosomal-dominante spastische Paraplegie Typ 10",
      "Autosomal-dominante spastische Paraplegie Typ 12",
      "Autosomal-dominante spastische Paraplegie Typ 13",
      "Autosomal-dominante spastische Paraplegie Typ 17",
      "Autosomal-dominante spastische Paraplegie Typ 19",
      "Autosomal-dominante spastische Paraplegie Typ 29",
      "Autosomal-dominante spastische Paraplegie Typ 3",
      "Autosomal-dominante spastische Paraplegie Typ 31",
      "Autosomal-dominante spastische Paraplegie Typ 32",
      "Autosomal-dominante spastische Paraplegie Typ 35",
      "Autosomal-dominante spastische Paraplegie Typ 36",
      "Autosomal-dominante spastische Paraplegie Typ 37",
      "Autosomal-dominante spastische Paraplegie Typ 38",
      "Autosomal-dominante spastische Paraplegie Typ 4",
      "Autosomal-dominante spastische Paraplegie Typ 41",
      "Autosomal-dominante spastische Paraplegie Typ 42",
      "Autosomal-dominante spastische Paraplegie Typ 6",
      "Autosomal-dominante spastische Paraplegie Typ 73",
      "Autosomal-dominante spastische Paraplegie Typ 8",
      "Autosomal-dominante spastische Paraplegie Typ 80",
      "Autosomal-dominante spastische Paraplegie Typ 9",
      "Autosomal-dominante spastische Paraplegie Typ 9A",
      "Autosomal-dominante spastische Paraplegie Typ 9B",
      "Autosomal-rezessive komplizierte spastische Paraplegie durch Störung im Kennedy-Stoffwechselweg",
      "Autosomal-rezessive spastische Ataxie Typ 4",
      "Autosomal-rezessive spastische Ataxie Typ 5",
      "Autosomal-rezessive spastische Ataxie mit Leukoenzephalopathie",
      "Autosomal-rezessive spastische Ataxie mit Optikusatrophie und Dysarthrie",
      "Autosomal-rezessive spastische Paraplegie Typ 11",
      "Autosomal-rezessive spastische Paraplegie Typ 14",
      "Autosomal-rezessive spastische Paraplegie Typ 15",
      "Autosomal-rezessive spastische Paraplegie Typ 18",
      "Autosomal-rezessive spastische Paraplegie Typ 20",
      "Autosomal-rezessive spastische Paraplegie Typ 21",
      "Autosomal-rezessive spastische Paraplegie Typ 23",
      "Autosomal-rezessive spastische Paraplegie Typ 24",
      "Autosomal-rezessive spastische Paraplegie Typ 25",
      "Autosomal-rezessive spastische Paraplegie Typ 26",
      "Autosomal-rezessive spastische Paraplegie Typ 27",
      "Autosomal-rezessive spastische Paraplegie Typ 28",
      "Autosomal-rezessive spastische Paraplegie Typ 30",
      "Autosomal-rezessive spastische Paraplegie Typ 39",
      "Autosomal-rezessive spastische Paraplegie Typ 43",
      "Autosomal-rezessive spastische Paraplegie Typ 44",
      "Autosomal-rezessive spastische Paraplegie Typ 45",
      "Autosomal-rezessive spastische Paraplegie Typ 46",
      "Autosomal-rezessive spastische Paraplegie Typ 48",
      "Autosomal-rezessive spastische Paraplegie Typ 49",
      "Autosomal-rezessive spastische Paraplegie Typ 53",
      "Autosomal-rezessive spastische Paraplegie Typ 54",
      "Autosomal-rezessive spastische Paraplegie Typ 55",
      "Autosomal-rezessive spastische Paraplegie Typ 56",
      "Autosomal-rezessive spastische Paraplegie Typ 57",
      "Autosomal-rezessive spastische Paraplegie Typ 58",
      "Autosomal-rezessive spastische Paraplegie Typ 59",
      "Autosomal-rezessive spastische Paraplegie Typ 5A",
      "Autosomal-rezessive spastische Paraplegie Typ 60",
      "Autosomal-rezessive spastische Paraplegie Typ 61",
      "Autosomal-rezessive spastische Paraplegie Typ 62",
      "Autosomal-rezessive spastische Paraplegie Typ 63",
      "Autosomal-rezessive spastische Paraplegie Typ 64",
      "Autosomal-rezessive spastische Paraplegie Typ 66",
      "Autosomal-rezessive spastische Paraplegie Typ 67",
      "Autosomal-rezessive spastische Paraplegie Typ 69",
      "Autosomal-rezessive spastische Paraplegie Typ 7",
      "Autosomal-rezessive spastische Paraplegie Typ 70",
      "Autosomal-rezessive spastische Paraplegie Typ 71",
      "Autosomal-rezessive spastische Paraplegie Typ 72",
      "Autosomal-rezessive spastische Paraplegie Typ 74",
      "Autosomal-rezessive spastische Paraplegie Typ 75",
      "Autosomal-rezessive spastische Paraplegie Typ 76",
      "Autosomal-rezessive spastische Paraplegie Typ 77",
      "Autosomal-rezessive spastische Paraplegie Typ 78",
      "Autosomal-rezessive spastische Paraplegie Typ 81",
      "Autosomal-rezessive spastische Paraplegie Typ 82",
      "Autosomal-rezessive spastische Paraplegie Typ 83",
      "Autosomal-rezessive spastische Paraplegie Typ 84",
      "Autosomal-rezessive spastische Paraplegie Typ 85",
      "Autosomal-rezessive spastische Paraplegie Typ 86",
      "Autosomal-rezes"
    ]
  },
  {
    "code": "G11.8",
    "name": "Mitochondriales rezessives Ataxie-Syndrom",
    "synonyms": [
      "Autosomal-rezessive Ataxie durch PEX10 [Peroxisomen-Biogenese-Faktor 10]-Mangel",
      "Autosomal-rezessive Ataxie durch PEX16-Mutation",
      "Autosomal-rezessive zerebelläre Ataxie mit sakkadischen Intrusionen",
      "Boucher-Neuhäuser-Syndrom",
      "CAMRQ [cerebelläre Ataxie-mentale Retardierung-Dysäquilibrium-Syndrom]-Syndrom",
      "CANVAS [Zerebellare Ataxie-Neuropathie-bilaterale vestibuläre Areflexie-Syndrom]",
      "CAPOS [Zerebellare Ataxie, Areflexie, Pes cavus, Optikusatrophie, sensorineurale Schwerhörigkeit]-Syndrom",
      "Dentato-rubro-pallido-luysische Atrophie",
      "Episodische Ataxie Typ 1",
      "Episodische Ataxie Typ 3",
      "Episodische Ataxie Typ 4",
      "Episodische Ataxie Typ 5",
      "Episodische Ataxie Typ 6",
      "Episodische Ataxie Typ 7",
      "Episodische Ataxie Typ 8",
      "Familiäre paroxysmale Ataxie",
      "Furukawa-Takagi-Nakao-Syndrom",
      "Gordon-Holmes-Syndrom",
      "Hereditäre episodische Ataxie",
      "MIRAS [Mitochondriales rezessives Ataxie-Syndrom]",
      "Machado-Joseph-Krankheit",
      "Machado-Joseph-Krankheit Typ 1",
      "Machado-Joseph-Krankheit Typ 2",
      "Machado-Joseph-Krankheit Typ 3",
      "Mitochondriales rezessives Ataxie-Syndrom",
      "SCA [Spinozerebellare Ataxie] Typ 1",
      "SCA [Spinozerebellare Ataxie] Typ 11",
      "SCA [Spinozerebellare Ataxie] Typ 17",
      "SCA [Spinozerebellare Ataxie] Typ 18",
      "SCA [Spinozerebellare Ataxie] Typ 25",
      "SCA [Spinozerebellare Ataxie] Typ 3",
      "SCA [Spinozerebellare Ataxie] Typ 31",
      "SCA [Spinozerebellare Ataxie] Typ 32",
      "SCA [Spinozerebellare Ataxie] Typ 35",
      "SCA [Spinozerebellare Ataxie] Typ 37",
      "SCA [Spinozerebellare Ataxie] Typ 5",
      "SCA [Spinozerebellare Ataxie] Typ 7",
      "Spastische Ataxie mit Hornhautdystrophie",
      "Spinozerebellare Ataxie Typ 1",
      "Spinozerebellare Ataxie Typ 42",
      "Spinozerebellare Ataxie Typ 7",
      "Syndrom der zerebellaren Ataxie mit Areflexie, Pes cavus, Optikusatrophie und sensorineuraler Schwerhörigkeit",
      "X-chromosomale Ataxie mit Apraxie und geistiger Retardierung"
    ]
  },
  {
    "code": "G11.9",
    "name": "Hereditäre zerebellare Ataxie",
    "synonyms": [
      "Ataxia hereditaria",
      "Autosomal-dominante zerebellare Ataxie",
      "Autosomal-rezessive zerebellare Ataxie",
      "Hereditäre Ataxie a.n.k.",
      "Hereditäre ataktische Paralyse",
      "Hereditäre spinozerebellare Krankheit",
      "Hereditäre zerebellare Ataxie",
      "Hereditäre zerebellare Degeneration",
      "Hereditäre zerebellare Krankheit",
      "Hereditäre zerebellare Sklerose",
      "Hereditäres Zerebellarsyndrom",
      "Hereditäres zerebellares Syndrom",
      "Spinozerebrale Ataxie",
      "Zerebellare Ataxie",
      "Zerebellare Heredoataxie",
      "Zerebrale Ataxie"
    ]
  },
  {
    "code": "G12.0",
    "name": "Infantile spinale Muskelatrophie Typ I",
    "synonyms": [
      "Hoffmann-Werdnig-Krankheit",
      "Infantile spinale Muskelatrophie Typ I",
      "Muskelatrophie Typ I",
      "Muskuläre Werdnig-Hoffmann-Atrophie",
      "Proximale spinale Muskelatrophie Typ I",
      "Werdnig-Hoffmann-Syndrom"
    ]
  },
  {
    "code": "G12.1",
    "name": "Kugelberg-Welander-Syndrom",
    "synonyms": [
      "Angeborene benigne spinale Muskelatrophie, autosomal-dominante Form",
      "Autosomal-dominante BICD2-assoziierte proximale spinale Muskelatrophie mit Beginn im Kindesalter",
      "Autosomal-dominante DYNC1H1-assoziierte proximale spinale Muskelatrophie mit Beginn im Kindesalter",
      "Autosomal-dominante proximale spinale Muskelatrophie mit Beginn im Erwachsenenalter",
      "Autosomal-dominante proximale spinale Muskelatrophie mit Beginn im Kindesalter",
      "Autosomal-rezessive distale spinale Muskelatrophie Typ 5",
      "Brown-Vialetto-van-Laere-Syndrom",
      "Bulbärparalyse beim Kind",
      "Distale Form der spinalen Muskelatrophie",
      "Distale spinale Muskelatrophie Typ 3",
      "Distale spinale Muskelatrophie Typ 4",
      "Fazio-Londe-Krankheit",
      "Fazio-Londe-Syndrom",
      "Hereditäre spinale Muskelatrophie a.n.k.",
      "Juvenile Form der spinalen Muskelatrophie (Typ III)",
      "Kindheitsform der spinalen Muskelatrophie (Typ II)",
      "Kugelberg-Welander-Krankheit",
      "Kugelberg-Welander-Syndrom",
      "Neurogenes scapuloperonäales Syndrom Typ Kaeser",
      "Progressive Bulbärparalyse im Kindesalter",
      "Proximale spinale Muskelatrophie",
      "Proximale spinale Muskelatrophie Typ II",
      "Proximale spinale Muskelatrophie Typ III",
      "Proximale spinale Muskelatrophie Typ IV",
      "Skapuloperonäale Form der spinalen Muskelatrophie",
      "Spinale Muskelatrophie Typ Jokela",
      "Spinale Muskelatrophie beim Erwachsenen",
      "Spinale juvenile Muskelatrophie",
      "Welander-Syndrom",
      "X-chromosomale distale spinale Muskelatrophie Typ 3"
    ]
  },
  {
    "code": "G12.2",
    "name": "Labioglossale Paralyse",
    "synonyms": [
      "ALS [Amyotrophische Lateralsklerose]",
      "Absteigende Spinalparalyse a.n.k.",
      "Affektion der Vorderhornganglienzellen",
      "Amyotrophe Lateralsklerose",
      "Amyotrophe Lateralsklerose Typ 4",
      "Amyotrophische Lateralsklerose",
      "Amyotrophische Paralyse",
      "Aufsteigende hereditäre spastische Paralyse des frühen Kindesalters",
      "Bulbospinale Muskelatrophie",
      "Bulbärparalyse",
      "Bulbärsyndrom",
      "Charcot-II-Syndrom",
      "Charcot-Krankheit [amyotrophische Lateralsklerose]",
      "Chronische Bulbärparalyse",
      "Diffuse progressive atrophische Lähmung",
      "Distale hereditäre motorische Neuropathie Typ 1",
      "Distale hereditäre motorische Neuropathie Typ 2",
      "Distale hereditäre motorische Neuropathie Typ 5",
      "Distale hereditäre motorische Neuropathie Typ 7",
      "Distale hereditäre motorische Neuropathie Typ Jerash",
      "Duchenne-Aran-Krankheit",
      "Duchenne-Aran-Muskelatrophie",
      "Duchenne-Aran-Syndrom",
      "Duchenne-II-Syndrom",
      "Duchenne-Paralyse bei Motoneuronkrankheit",
      "Familiäre Motoneuronkrankheit",
      "Fazio-pharyngo-glosso-mastikatorische Diplegie",
      "Foix-Chavany-Marie-Syndrom",
      "IAHSP [Infantile aufsteigende hereditäre spastische Paralyse]",
      "Juvenile amyotrophe Lateralsklerose",
      "Juvenile primäre Lateralsklerose",
      "Kennedy-Krankheit",
      "Krankheit der Vorderhornzellen",
      "Labioglossale Paralyse",
      "Laterale Rückenmarksklerose",
      "Lateralparalyse",
      "Lateralsklerose",
      "Mills-Syndrom",
      "Monomelische Amyotrophie",
      "Motoneuron-Krankheit Madras",
      "Motoneuronkrankheit",
      "Myatrophe Lateralsklerose",
      "Paralysis laryngolabioglossalis",
      "Polioencephalitis inferior",
      "Primäre Lateralsklerose",
      "Progressive Bulbärparalyse",
      "Progressive Degeneration des Cornu anterius",
      "Progressive Muskelatrophie",
      "Progressive Muskelparalyse",
      "Progressive Spinalparalyse",
      "Progressive atrophische Paralyse",
      "Progressive spinale Muskelatrophie",
      "Pseudobulbärparalyse",
      "SMARD [Spinale Muskelatrophie mit Atemnot] Typ 1",
      "SMARD [Spinale Muskelatrophie mit Atemnot] Typ 2",
      "Seitenstrangsklerose",
      "Spastische Bulbärparalyse",
      "Spinale Atrophie mit Lähmung [Progressive Muskelatrophie]",
      "Spinale Bulbärparalyse",
      "Spinale Muskelatrophie mit Atemnot Typ 1",
      "Spinale Muskelatrophie mit Atemnot Typ 2",
      "Spinale progressive Amyotrophie",
      "Spinobulbäre Muskelatrophie Typ Kennedy",
      "Vorderhornganglienzellkrankheit",
      "Zunge-Lippen-Kehlkopf-Lähmung [Paralysis laryngolabioglossalis]"
    ]
  },
  {
    "code": "G12.8",
    "name": "Cruveilhier-Krankheit",
    "synonyms": [
      "Cruveilhier-Krankheit",
      "O'Sullivan-McLeod-Syndrom"
    ]
  },
  {
    "code": "G12.9",
    "name": "Spinale Muskelatrophie",
    "synonyms": [
      "Spinale Muskelatrophie",
      "Spinale muskuläre Atrophie",
      "Spinaler Muskelschwund"
    ]
  },
  {
    "code": "G14",
    "name": "Post-Polio-Syndrom",
    "synonyms": [
      "Post-Polio-Syndrom",
      "Postpoliomyelitis-Syndrom"
    ]
  },
  {
    "code": "G20.00",
    "name": "Primäres Parkinson-Syndrom mit fehlender Beeinträchtigung ohne Wirkungsfluktuation",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit geringer Beeinträchtigung ohne Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit geringer Beeinträchtigung ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 0 bis unter 3 nach Hoehn und Yahr ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit fehlender Beeinträchtigung ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit geringer Beeinträchtigung ohne Wirkungsfluktuation"
    ]
  },
  {
    "code": "G20.01",
    "name": "Primäres Parkinson-Syndrom mit fehlender Beeinträchtigung mit Wirkungsfluktuation",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit geringer Beeinträchtigung mit Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit geringer Beeinträchtigung mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 0 bis unter 3 nach Hoehn und Yahr mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit fehlender Beeinträchtigung mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit geringer Beeinträchtigung mit Wirkungsfluktuation"
    ]
  },
  {
    "code": "G20.10",
    "name": "Primäres Parkinson-Syndrom mit mäßiger Beeinträchtigung ohne Wirkungsfluktuation",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit schwerer Beeinträchtigung ohne Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit schwerer Beeinträchtigung ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 3 nach Hoehn und Yahr ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 4 nach Hoehn und Yahr ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit mäßiger Beeinträchtigung ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit schwerer Beeinträchtigung ohne Wirkungsfluktuation"
    ]
  },
  {
    "code": "G20.11",
    "name": "Primäres Parkinson-Syndrom mit mäßiger Beeinträchtigung mit Wirkungsfluktuation",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit schwerer Beeinträchtigung mit Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit schwerer Beeinträchtigung mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 3 nach Hoehn und Yahr mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 4 nach Hoehn und Yahr mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit mäßiger Beeinträchtigung mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit schwerer Beeinträchtigung mit Wirkungsfluktuation"
    ]
  },
  {
    "code": "G20.20",
    "name": "Primäres Parkinson-Syndrom mit schwerster Beeinträchtigung ohne Wirkungsfluktuation",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit schwerster Beeinträchtigung ohne Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit schwerster Beeinträchtigung ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 5 nach Hoehn und Yahr ohne Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit schwerster Beeinträchtigung ohne Wirkungsfluktuation"
    ]
  },
  {
    "code": "G20.21",
    "name": "Primäres Parkinson-Syndrom mit schwerster Beeinträchtigung mit Wirkungsfluktuation",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit schwerster Beeinträchtigung mit Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit schwerster Beeinträchtigung mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom Stadium 5 nach Hoehn und Yahr mit Wirkungsfluktuation",
      "Primäres Parkinson-Syndrom mit schwerster Beeinträchtigung mit Wirkungsfluktuation"
    ]
  },
  {
    "code": "G20.90",
    "name": "Hemiparkinsonismus",
    "synonyms": [
      "Akinetische Krise",
      "Altersparkinson",
      "Atypisches juveniles Parkinson-Syndrom",
      "Früh-adultes Parkinson-Syndrom",
      "Genuine Paralysis agitans",
      "Hemiparkinsonismus",
      "Idiopathische Parkinson-Krankheit",
      "Idiopathischer Parkinsonismus",
      "Intrinsisches Pillendrehen",
      "Morbus Parkinson",
      "Pallidopyramidales Syndrom",
      "Pallidostriäres Syndrom",
      "Pallidumsyndrom",
      "Paralysis agitans",
      "Paralysis-agitans-Syndrom",
      "Parkinson-Krankheit",
      "Parkinson-Syndrom",
      "Parkinson-Tremor",
      "Parkinson-pyramidales Syndrom",
      "Parkinsonismus",
      "Perry-Syndrom",
      "Pillendrehen",
      "Primäre Parkinson-Krankheit",
      "Primärer Parkinsonismus",
      "Primäres Parkinson-Syndrom",
      "Schüttellähmung",
      "Schüttelparalyse",
      "X-chromosomales Parkinsonismus-Spastik-Syndrom",
      "Zitterlähmung"
    ]
  },
  {
    "code": "G20.91",
    "name": "Medikamentöse Off-Phase der Parkinson-Krankheit",
    "synonyms": [
      "Atypisches juveniles Parkinson-Syndrom mit Wirkungsfluktuation",
      "Früh-adultes Parkinson-Syndrom mit Wirkungsfluktuation",
      "Medikamentöse Off-Phase der Parkinson-Krankheit"
    ]
  },
  {
    "code": "G21.0",
    "name": "Malignes neuroleptisches Syndrom",
    "synonyms": [
      "Malignes Neuroleptika-Syndrom",
      "Malignes neuroleptisches Syndrom",
      "Parkinsonismus durch Neuroleptika"
    ]
  },
  {
    "code": "G21.1",
    "name": "Parkinson-Syndrom durch Arzneimittel",
    "synonyms": [
      "Behandlungsinduzierter Parkinsonismus a.n.k.",
      "Medikamentös bedingtes Parkinson-Syndrom",
      "Medikamentöse Schüttellähmung",
      "Medikamentöser Parkinsonismus",
      "Neuroleptisches Parkinsonoid",
      "Parkinson-Syndrom durch Arzneimittel",
      "Parkinsonoid",
      "Sekundärer Parkinsonismus durch Arzneimittel a.n.k.",
      "Sekundärer Parkinsonismus durch Medikamente a.n.k."
    ]
  },
  {
    "code": "G21.2",
    "name": "Sekundärer Parkinsonismus durch exogene Agenzien a.n.k.",
    "synonyms": [
      "Parkinson-Syndrom durch Zyanid-Vergiftung",
      "Sekundärer Parkinsonismus durch exogene Agenzien a.n.k."
    ]
  },
  {
    "code": "G21.3",
    "name": "Postenzephalitisches Parkinson-Syndrom",
    "synonyms": [
      "Postenzephalitischer Parkinsonismus",
      "Postenzephalitisches Parkinson-Syndrom",
      "Sekundärer Parkinsonismus durch Enzephalitis"
    ]
  },
  {
    "code": "G21.4",
    "name": "Arteriosklerotischer Parkinsonismus",
    "synonyms": [
      "Arteriosklerotische Paralysis agitans",
      "Arteriosklerotischer Parkinsonismus",
      "Pseudoparkinsonismus",
      "Sekundärer Parkinsonismus durch Arteriosklerose",
      "Vaskuläres Parkinson-Syndrom"
    ]
  },
  {
    "code": "G21.9",
    "name": "Sekundäres Parkinson-Syndrom",
    "synonyms": [
      "Sekundärer Morbus Parkinson",
      "Sekundärer Parkinsonismus",
      "Sekundäres Parkinson-Syndrom"
    ]
  },
  {
    "code": "G23.0",
    "name": "Hallervorden-Spatz-Syndrom",
    "synonyms": [
      "Aceruloplasminämie",
      "Beta-propeller-Protein-assoziierte Neurodegeneration",
      "COASY [Coenzym-A-Synthase]-Protein-assoziierte Neurodegeneration",
      "Ferritin-abhängige Neurodegeneration",
      "Fettsäure-Hydroxylase-assoziierte Neurodegeneration",
      "Hallervorden-Spatz-Krankheit",
      "Hallervorden-Spatz-Syndrom",
      "Kufor-Rakeb-Syndrom",
      "Mitochondriale Membranprotein-assoziierte Neurodegeneration",
      "NBIA [Neurodegeneration with Brain Iron Accumulation] Typ 1",
      "Neurodegeneration mit Eisenspeicherung im Gehirn Typ 1",
      "Neurodegeneration mit Eisenspeicherung im Gehirn durch C19ORF12-Gen-Mutation",
      "Neuroferritinopathie",
      "PKAN [Pantothenat-Kinase-assoziierte Neurodegeneration]",
      "Pantothenat-Kinase-assoziierte Neurodegeneration",
      "Pigmentdegeneration des Pallidums",
      "Pigmentierte Pallidumatrophie",
      "Pigmentierte Pallidumdegeneration",
      "Woodhouse-Sakati-Syndrom"
    ]
  },
  {
    "code": "G23.1",
    "name": "Progressive supranukleäre Ophthalmoplegie",
    "synonyms": [
      "Klassische progressive supranukleäre Blickparese",
      "PSP [Progressive supranukleäre Blickparese]",
      "Progressive supranukleäre Blickparese",
      "Progressive supranukleäre Blickparese mit Akinese und Gangblockaden",
      "Progressive supranukleäre Ophthalmoplegie",
      "Progressive supranukleäre Paralyse",
      "Progressive supranukleäre Parese",
      "Richardson-Syndrom",
      "Steele-Richardson-Olszewski-Krankheit",
      "Steele-Richardson-Olszewski-Syndrom",
      "Willige-Hunt-Krankheit",
      "Willige-Hunt-Syndrom"
    ]
  },
  {
    "code": "G23.2",
    "name": "Striatonigrale Degeneration",
    "synonyms": [
      "Infantile beidseitige striatale Nekrose, familiäre Form",
      "Infantile beidseitige striatale Nekrose, sporadische Form",
      "MSA-P [Multisystematrophie vom Parkinson-Typ]",
      "Multiple Systematrophie vom Parkinson-Typ",
      "Multisystematrophie",
      "Multisystematrophie vom Parkinson-Typ",
      "Multisystemdegeneration",
      "Striatonigrale Degeneration"
    ]
  },
  {
    "code": "G23.3",
    "name": "Olivopontozerebellare Atrophie",
    "synonyms": [
      "Déjerine-Thomas-Atrophie",
      "Déjerine-Thomas-Syndrom",
      "Familiäre olivopontozerebellare Degeneration",
      "Hereditäre olivopontozerebellare Degeneration",
      "MSA-C [Multisystematrophie vom cerebellären Typ]",
      "Multiple Systematrophie vom cerebellären Typ",
      "Multisystematrophie vom cerebellären Typ",
      "Multisystematrophie vom zerebellären Typ",
      "OPCA [Olivio-ponto-zerebellare Atrophie]",
      "Olivopontozerebellare Atrophie"
    ]
  },
  {
    "code": "G23.8",
    "name": "Hypokinetisches rigides Syndrom",
    "synonyms": [
      "Autosomal-dominante striatale Neurodegeneration",
      "Basalganglien-Degenerationssyndrom mit Beginn im Kindesalter",
      "Bilaterale striopallidodentate Kalzinose",
      "Brückenatrophie",
      "Fahr-Syndrom",
      "Hypokinetisches rigides Syndrom",
      "Kalzifikation der Basalganglien",
      "Lenk-Ploski-Syndrom",
      "Neurogene orthostatische Hypotonie",
      "Neurogene orthostatische Hypotonie mit Multisystematrophie - s.a. Shy-Drager-Syndrom",
      "Parkinson-Syndrom bei orthostatischer Hypotonie",
      "Parkinsonismus bei neurogener orthostatischer Hypotonie",
      "Parkinsonismus bei symptomatischer orthostatischer Hypotonie",
      "Shy-Drager-Syndrom",
      "Syndrom des früh beginnenden Parkinsonismus mit Intelligenzminderung",
      "Waisman-Syndrom"
    ]
  },
  {
    "code": "G23.9",
    "name": "Degenerative Krankheit der Basalganglien",
    "synonyms": [
      "Basalgangliendegeneration a.n.k.",
      "Degenerative Krankheit der Basalganglien"
    ]
  },
  {
    "code": "G24.0",
    "name": "Arzneimittelinduzierte Dystonie",
    "synonyms": [
      "Arzneimittelinduzierte Dystonie",
      "Dyskinesia tarda",
      "Neuroleptikainduzierte Dyskinesie",
      "Zungen-Schlund-Syndrom"
    ]
  },
  {
    "code": "G24.1",
    "name": "Idiopathische familiäre Dystonie",
    "synonyms": [
      "Autosomal-dominante Dopa-responsive Dystonie",
      "Autosomal-dominante fokale Dystonie Typ DYT25",
      "Autosomal-dominantes Segawa-Syndrom",
      "Autosomal-rezessive Dopa-responsive Dystonie",
      "Autosomal-rezessive Dystonie mit Beginn im Kindesalter Typ DYT29",
      "Autosomal-rezessives Segawa-Syndrom",
      "Dopa-responsive Dystonie durch Sepiapterin-Reduktase-Mangel",
      "Dysbasia lordotica progressiva",
      "Dystonia deformans progressiva",
      "Dystonia musculorum deformans",
      "Dystonie Typ DYT28",
      "Dystonie-Parkinsonismus mit schnellem Beginn",
      "Früh beginnende Torsionsdystonie",
      "Früh beginnende generalisierte Dystonie der Extremitäten",
      "Hereditäre progressive Dystonie mit tageszeitlicher Fluktuation",
      "Idiopathische Dystonie",
      "Idiopathische Torsionsdystonie",
      "Idiopathische familiäre Dystonie",
      "Infantiles Dystonie-Parkinson-Syndrom",
      "KMT2B-assoziierte Dystonie",
      "Kraniozervikale Dystonie Typ DYT24",
      "Myoklonus-Dystonie-Syndrom",
      "Oppenheim-Dystonie",
      "Primäre Dystonie Typ DYT1",
      "Primäre Dystonie Typ DYT13",
      "Primäre Dystonie Typ DYT16",
      "Primäre Dystonie Typ DYT17",
      "Primäre Dystonie Typ DYT2",
      "Primäre Dystonie Typ DYT21",
      "Primäre Dystonie Typ DYT27",
      "Primäre Dystonie Typ DYT4",
      "Primäre Dystonie Typ DYT6",
      "Progressiver Torsionsspasmus",
      "Schwalbe-Ziehen-Oppenheim-Krankheit",
      "Schwalbe-Ziehen-Oppenheim-Syndrom",
      "Torsionsdystonie",
      "Tortipelvis",
      "Tyrosin-Hydroxylase-Mangel",
      "Tyrosin-Hydroxylase-defiziente Dopa-responsive Dystonie",
      "X-chromosomales Dystonie-Parkinson-Syndrom",
      "Zervikale Dystonie mit Beginn im Erwachsenenalter Typ DYT23",
      "Ziehen-Oppenheim-Krankheit",
      "Ziehen-Oppenheim-Syndrom"
    ]
  },
  {
    "code": "G24.2",
    "name": "Idiopathische nichtfamiliäre Dystonie",
    "synonyms": [
      "Idiopathische nichtfamiliäre Dystonie",
      "Symptomatische Torsionsdystonie"
    ]
  },
  {
    "code": "G24.3",
    "name": "Torticollis spasticus",
    "synonyms": [
      "Benigner paroxysmaler Torticollis des Kindesalters",
      "Kombinierte zervikale Dystonie",
      "Spastischer Tortikollis",
      "Torticollis spasmodicus",
      "Torticollis spasticus",
      "Zervikale Dystonie mit überwiegend rotatorischer Komponente"
    ]
  },
  {
    "code": "G24.4",
    "name": "Idiopathische orofaziale Dystonie",
    "synonyms": [
      "Fazio-bukko-linguale Dystonie",
      "Idiopathische orofaziale Dystonie",
      "Meige-Syndrom",
      "Orofaziale Dysfunktion",
      "Orofaziale Dyskinesie",
      "Oromandibuläre Dystonie"
    ]
  },
  {
    "code": "G24.5",
    "name": "Blepharospasmus",
    "synonyms": [
      "Augenlidspasmus",
      "Blepharoklonus",
      "Blepharospasmus",
      "Lidkrampf",
      "Orbikularis-Spasmus",
      "Primärer Blepharospasmus",
      "Sekundärer Blepharospasmus"
    ]
  },
  {
    "code": "G24.8",
    "name": "Lentikuläre Dystonie",
    "synonyms": [
      "AADC [Aromatische-L-Aminosäuredecarboxylase]-Mangel",
      "Aromatische-L-Aminosäuredecarboxylase-Mangel",
      "Dystonie-Aphonie-Syndrom",
      "Infantile generalisierte Dyskinesie mit orofazialer Beteiligung",
      "Lentikuläre Dystonie",
      "Paroxysmale Dyskinesie",
      "Paroxysmale anstrengungsinduzierte Dyskinesie",
      "Paroxysmale dystonische Choreoathetose mit episodischer Ataxie und Spastik",
      "Paroxysmale kinesiogene Dyskinesie",
      "Paroxysmale nicht-kinesiogene Dyskinesie",
      "Sandifer-Syndrom"
    ]
  },
  {
    "code": "G24.9",
    "name": "Dystonie",
    "synonyms": [
      "Dyskinesie",
      "Dyskinetisches Syndrom",
      "Dystone Hyperkinese",
      "Dystonie",
      "Frühdyskinesie"
    ]
  },
  {
    "code": "G25.0",
    "name": "Essentieller Tremor",
    "synonyms": [
      "Essentieller Tremor",
      "Familiärer Tremor",
      "Hereditärer Tremor",
      "Minor-Krankheit [Hereditärer Tremor]",
      "Minor-Syndrom [Hereditärer Tremor]",
      "Primärer orthostatischer Tremor"
    ]
  },
  {
    "code": "G25.1",
    "name": "Arzneimittelinduzierter Tremor",
    "synonyms": [
      "Arzneimittelinduzierter Tremor"
    ]
  },
  {
    "code": "G25.2",
    "name": "Intentionstremor",
    "synonyms": [
      "Intentionstremor"
    ]
  },
  {
    "code": "G25.3",
    "name": "Myoklonus",
    "synonyms": [
      "Arzneimittelinduzierter Myoklonus",
      "Benigner Schlafmyoklonus in der Kindheit",
      "Chronischer Singultus",
      "Einschlafzuckungen",
      "Essentieller Myoklonus",
      "Exzessiver fragmentarischer Myoklonus",
      "Familiärer Myoklonus",
      "Familiärer kortikaler Myoklonus",
      "Hereditärer Geniospasmus",
      "Hypnagoger Fußtremor",
      "Massiver Myoklonus",
      "Multifokaler Myoklonus",
      "Myoklonie",
      "Myoklonische Zuckungen",
      "Myoklonus",
      "Myoklonus simplex",
      "Paramyoclonus multiplex",
      "Propriospinaler Myoklonus bei Schlafbeginn"
    ]
  },
  {
    "code": "G25.4",
    "name": "Arzneimittelinduzierte Chorea",
    "synonyms": [
      "Arzneimittelinduzierte Chorea"
    ]
  },
  {
    "code": "G25.5",
    "name": "Chronische Chorea",
    "synonyms": [
      "Alterschorea",
      "Atypische Form eines HSD10-Mangels",
      "Benigne familiäre Chorea",
      "Chorea",
      "Chorea gravis",
      "Chorea progressiva",
      "Choreatische Reflexhypokinesie",
      "Choreoathetose",
      "Chronische Chorea",
      "Hemiballismus",
      "Hemichorea",
      "Paroxysmale Choreoathetose",
      "Posthemiplegische Chorea",
      "Progressive Chorea",
      "Senile Chorea",
      "Spastische Chorea",
      "Veitstanz - s.a. Chorea",
      "X-chromosomale syndromale Intelligenzminderung Typ 10"
    ]
  },
  {
    "code": "G25.6",
    "name": "Organisch bedingtes Augenlidzucken",
    "synonyms": [
      "Arzneimittelinduzierte Ticstörung",
      "Degenerative Ticstörung des Nervus facialis",
      "Extrapyramidaler Tic",
      "Generalisierte degenerative Ticstörung",
      "Lokalisierte degenerative Ticstörung",
      "Organisch bedingtes Augenlidzucken",
      "Organische Ticstörung",
      "Tic organischen Ursprungs",
      "Ticstörung bei Chorea"
    ]
  },
  {
    "code": "G25.80",
    "name": "Periodische Extremitätenbewegungen im Schlaf [Periodic Limb Movement Disorder]",
    "synonyms": [
      "PLMS [Periodic Limb Movement Disorder]",
      "Periodische Extremitätenbewegungen im Schlaf [Periodic Limb Movement Disorder]"
    ]
  },
  {
    "code": "G25.81",
    "name": "Restless legs",
    "synonyms": [
      "Restless legs",
      "Restless-legs-Syndrom",
      "Syndrom der unruhigen Beine",
      "Wittmaack-Ekbom-Syndrom"
    ]
  },
  {
    "code": "G25.88",
    "name": "Stiff-man-Syndrom",
    "synonyms": [
      "Akathisie",
      "Ballismussyndrom",
      "Behandlungsinduzierte Akathisie",
      "Biotin-responsive Störung der Basalganglien",
      "Familiäre Startle-Krankheit",
      "Familiäre kongenitale Spiegelbewegungen",
      "Hereditäre Hyperekplexie",
      "Kok-Krankheit",
      "Kongenitales Stiff-Man-Syndrom",
      "Medikamenteninduzierte Akathisie",
      "Moersch-Woltman-Syndrom",
      "Muskelstarre-Syndrom",
      "Neuroleptika-Akathisie",
      "Organischer Graphospasmus",
      "Organischer Schreibkrampf",
      "PLMT [Painful legs and moving toes]-Syndrom",
      "SPS [Stiff-Person-Syndrom]",
      "Shuddering attacks",
      "Sporadische Hyperekplexie",
      "Stiff-Baby-Syndrom",
      "Stiff-Person-Syndrom",
      "Stiff-man-Syndrom",
      "Striopallidäre Krankheit a.n.k.",
      "Störung des zerebralen vesikulären Dopamin-Serotonin-Transportes"
    ]
  },
  {
    "code": "G25.9",
    "name": "Unklare extrapyramidale Affektion mit abnormer spastischer Bewegungsstörung",
    "synonyms": [
      "Basalganglienkrankheit",
      "Basalganglienschädigung",
      "Basalgangliensyndrom",
      "Behandlungsinduzierte Bewegungsstörung",
      "Bewegungsstörung",
      "EPS [Extrapyramidales Syndrom]",
      "Extrapyramidal-motorische Störung",
      "Extrapyramidale Bewegungsstörung",
      "Extrapyramidale Degeneration",
      "Extrapyramidale Krankheit",
      "Extrapyramidale Sklerose",
      "Extrapyramidale Störung",
      "Extrapyramidales Syndrom",
      "Stammganglienschädigung",
      "Unklare extrapyramidale Affektion mit abnormer Bewegungsstörung",
      "Unklare extrapyramidale Affektion mit abnormer spastischer Bewegungsstörung",
      "Zentrale Bewegungsstörung",
      "Zerebrale Bewegungsstörung"
    ]
  },
  {
    "code": "G30.0",
    "name": "Alzheimer-Krankheit, früher Beginn",
    "synonyms": [
      "Alzheimer-Krankheit, früher Beginn",
      "Autosomal-dominante Alzheimer-Krankheit mit frühem Beginn",
      "Präsenile Form der Alzheimer-Krankheit",
      "Präsenile Gehirnsklerose",
      "Präsenile Hirnsklerose",
      "Präsenile Sklerose (Alzheimer)"
    ]
  },
  {
    "code": "G30.1",
    "name": "Alzheimer-Krankheit, später Beginn",
    "synonyms": [
      "Alzheimer-Krankheit, später Beginn",
      "Morbus Alzheimer-Spättyp",
      "Senile Form der Alzheimer-Krankheit"
    ]
  },
  {
    "code": "G30.9",
    "name": "Alzheimer-Syndrom",
    "synonyms": [
      "Alzheimer-Krankheit",
      "Alzheimer-Sklerose",
      "Alzheimer-Syndrom",
      "Morbus Alzheimer"
    ]
  },
  {
    "code": "G31.0",
    "name": "Umschriebene Hirnatrophie",
    "synonyms": [
      "Atrophische lobäre Gehirnsklerose",
      "Frontalhirnatrophie",
      "Pick-Krankheit",
      "Pick-Syndrom",
      "Posteriore kortikale Atrophie",
      "Primäre progressive Sprechapraxie",
      "Progressive isolierte Aphasie",
      "Stirnhirnatrophie",
      "Umschriebene Gehirnatrophie",
      "Umschriebene Hirnatrophie"
    ]
  },
  {
    "code": "G31.1",
    "name": "Senile zerebrale Degeneration",
    "synonyms": [
      "Senile Gehirnatrophie",
      "Senile Gehirndegeneration a.n.k.",
      "Senile Gehirnkrankheit a.n.k.",
      "Senile Hirnatrophie",
      "Senile zerebrale Degeneration"
    ]
  },
  {
    "code": "G31.2",
    "name": "Alkoholische Degeneration des Nervensystems",
    "synonyms": [
      "Alkoholbedingte Enzephalopathie",
      "Alkoholbedingte zerebellare Ataxie",
      "Alkoholbedingte zerebellare Degeneration",
      "Alkoholbedingte zerebrale Degeneration",
      "Alkoholische Degeneration des Nervensystems",
      "Alkoholische Enzephalopathie",
      "Alkoholische Gehirnatrophie",
      "Alkoholische Gehirndegeneration",
      "Alkoholische Hirnatrophie",
      "Alkoholische kortikale Degeneration",
      "Alkoholische zerebellare Degeneration",
      "Degeneration des Nervensystems durch Alkohol",
      "Dysfunktion des autonomen Nervensystems durch Alkohol"
    ]
  },
  {
    "code": "G31.81",
    "name": "Mitochondriale Myoenzephalopathie",
    "synonyms": [
      "Akute nekrotisierende Enzephalopathie im Kindesalter",
      "COQ4-assoziierte neonatale Enzephalomyopathie",
      "DNM1L-assoziierte Enzephalopathie durch mitochondrialen und peroxisomalen Teilungsdefekt",
      "Enzephalopathie durch mitochondrialen und peroxisomalen Teilungsdefekt",
      "Ethylmalonsäure-Enzephalopathie",
      "Fatale infantile Kardioenzephalomyopathie durch Cytochrom-C-Oxidase-Mangel",
      "Fatales multiples mitochondriales Dysfunktionssyndrom",
      "Fatales multiples mitochondriales Dysfunktionssyndrom Typ 1",
      "Fatales multiples mitochondriales Dysfunktionssyndrom Typ 2",
      "Fatales multiples mitochondriales Dysfunktionssyndrom Typ 3",
      "Fatales multiples mitochondriales Dysfunktionssyndrom Typ 4",
      "Harel-Yoon-Syndrom",
      "Isolierter Atmungskettendefekt im Komplex I",
      "Isolierter Komplex-1-Defekt der mitochondrialen Atmungskette",
      "Isolierter NADH-CoQ-Reduktase-Mangel",
      "Isolierter NADH-Coenzym-Q-Reduktase-Mangel",
      "Isolierter NADH-Ubiquinon-Reduktase-Mangel",
      "Isolierter Succinat-Coenzym-Q-Reduktase-Mangel",
      "Isolierter mitochondrialer Atmungskettendefekt im Komplex III",
      "Isolierter mitochondrialer Atmungskettendefekt im Komplex IV",
      "Isolierter mitochondrialer Atmungskettendefekt im Komplex V",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 11",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 12",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 13",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 14",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 15",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 18",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 2",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 20",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 21",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 24",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 25",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 27",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 29",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 3",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 39",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 4",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 7",
      "LHON [Leber hereditary optic neuropathy]-plus-Krankheit",
      "Letales Syndrom der linksseitigen Non-Compaction-Kardiomyopathie mit Krämpfen, Hypotonie, Katarakt und Entwicklungsverzögerung",
      "Leukoenzephalopathie mit Hirnstamm- und Rückenmarkbeteiligung und Laktaterhöhung",
      "MELAS-Syndrom [Myopathy, Encephalopathy, Lactic Acidosis, Stroke-like Episodes] [Myopathie, Enzephalopathie, Laktatazidose, iktus-ähnliche zerebrale Anfälle]",
      "MERRF-Syndrom [Myoclonus Epilepsy with Ragged-Red Fibres]",
      "MFF-assoziierte Enzephalopathie durch mitochondrialen und peroxisomalen Teilungsdefekt",
      "MNGIE-Syndrom [Mitochondriale neurogastrointestinale Enzephalomyopathie]",
      "Mitochondriale DNA-assoziierte Kardiomyopathie mit Hörverlust",
      "Mitochondriale Enzephalomyopathie Typ Ghezzi-Zeviani",
      "Mitochondriale Enzephalomyopathie durch kombinierten Defekt der oxidativen Phosphorylierung Typ 6",
      "Mitochondriale Myoenzephalopathie",
      "Mitochondriale Myopathie mit Enzephalopathie, Laktatazidose und schlaganfallähnlichen Episoden",
      "Mitochondriale Zytopathie",
      "Mitochondriale neurogastrointestinale Enzephalomyopathie",
      "Mitochondriale spinozerebellare Ataxie mit Epilepsie",
      "Mitochondrialer Pyruvat-Carrier-Mangel",
      "Mitochondriales DNA-Depletions-Syndrom durch DGUOK-Mangel, hepatozerebrale Form",
      "Mitochondriales DNA-Depletionssyndrom, hepato-zerebro-renale Form",
      "Mitochondriopathie",
      "Mohr-Tranebjaerg-Syndrom",
      "Multiples mitochondriales Dysfunktionssyndrom Typ 5",
      "Multiples mitochondriales Dysfunktionssyndrom Typ 6",
      "NARP [Neuropathie, Ataxie, Retinitis pigmentosa]-Syndrom",
      "Neuropathie mit Ataxie und Retinitis pigmentosa",
      "Progressive Enzephalopathie mit Leukodystrophie durch DECR [2,4-Dienoyl-CoA-Reductase]-Mangel",
      "Schwere X-chromosomale mitochondriale Enzephalomyopathie",
      "Syndrom der Optikusatrophie mit Ataxie, peripherer Neuropathie und globaler Entwicklungsverzögerung",
      "Syndrom der Schwerhörigkeit mit Enzephaloneuro"
    ]
  },
  {
    "code": "G31.88",
    "name": "Leigh-Syndrom",
    "synonyms": [
      "Aicardi-Goutières-Syndrom",
      "Alpers-Huttenlocher-Syndrom",
      "Alpers-Krankheit",
      "Alpers-Syndrom",
      "Autosomal-rezessive zerebrale Atrophie",
      "Binswanger-Syndrom",
      "CLCN6-assoziierte progressive Neurodegeneration mit peripherer Neuropathie mit Beginn im Kindesalter",
      "COX [Cytochrom-C-Oxidase]-Mangel vom französisch-kanadischen Typ",
      "Cytochrom-C-Oxidase-Mangel Typ Saguenay-Lac-St.Jean",
      "Cytochrom-C-Oxidase-Mangel vom französisch-kanadischen Typ",
      "Degeneration der grauen Gehirnsubstanz",
      "Familiäre Enzephalopathie mit Neuroserpin-Einschlusskörperchen",
      "Familiäre Rückenmarkdegeneration a.n.k.",
      "Fettige Nervensystemdegeneration",
      "Fettige Rückenmarkdegeneration",
      "IRF2BPL-assoziiertes Syndrom der regressiven neurologischen Entwicklungsstörung mit Dystonie und Krampfanfällen",
      "Infantile neuroaxonale Dystrophie",
      "Infantile subakute nekrotisierende Enzephalomyelopathie",
      "Infantile zerebellar-retinale Degeneration",
      "Kohlschütter-Tönz-Syndrom",
      "Kongenitale Laktatazidose Typ Saguenay-Lac-St. Jean",
      "Kortikale Degeneration",
      "Leigh-Krankheit",
      "Leigh-Syndrom",
      "Leigh-Syndrom vom Saguenay-Lac-St.Jean Typ",
      "Leigh-Syndrom vom französisch-kanadischen Typ",
      "MEGDEL [3-Methylglutaconazidurie, Schwerhörigkeit, Enzephalopathie, Leigh-Syndrom-ähnliche Symptome]-Syndrom",
      "MTHFS-assoziiertes Syndrom mit Entwicklungsverzögerung, Mikrozephalie, Kleinwuchs und Epilepsie",
      "Maternal vererbtes Leigh-Syndrom",
      "Morbus Leigh [Subakute nekrotisierende Enzephalomyelopathie]",
      "Motorisches und kognitives Regressionssyndrom mit extrapyramidaler Bewegungsstörung mit Beginn im Kindesalter",
      "Nekrotisierende Enzephalomyelopathie",
      "Neurodegeneratives Syndrom durch zerebrale Folattransportstörung",
      "PCCA [Progressive zerebro-zerebellare Atrophie]",
      "PEHO [Progressive Enzephalopathie mit Ödem, Hypsarrhythmie und Optikusatrophie]-Syndrom",
      "PEHO [Progressive Enzephalopathie mit Ödem, Hypsarrhythmie und Optikusatrophie]-ähnliches Syndrom",
      "Phospholipase-A2-assoziierte Neurodegeneration",
      "Poliodystrophia cerebri progressiva infantilis",
      "Progressive neuronale Degeneration im Kindesalter mit Lebererkrankung",
      "Progressive sklerosierende Poliodystrophie Alpers",
      "Progressive zerebro-zerebellare Atrophie",
      "Rückenmarkdegeneration",
      "Schwergradige neurologische Entwicklungsstörung mit Fütterproblemen, stereotypen Handbewegungen und bilateraler Katarakt",
      "Seitelberger-Krankheit",
      "Subakute nekrotisierende Enzephalomyelopathie [Morbus Leigh]",
      "Subakute nekrotisierende Enzephalopathie",
      "Syndrom der früh beginnenden Enzephalopathie mit Hörverlust, Ponshypoplasie und Hirnatrophie",
      "Syndrom der früh beginnenden progressiven Enzephalopathie mit spastischer Ataxie und distaler spinaler Muskelatrophie",
      "Syndrom der früh beginnenden progressiven Neurodegeneration mit Blindheit, Ataxie und Spastik",
      "Syndrom der früh beginnenden progressiven diffusen Gehirnatrophie mit Mikrozephalie, Muskelschwäche und Optikusatrophie",
      "Syndrom der globalen Entwicklungsverzögerung mit Sehanomalien, progressiver zerebellarer Atrophie und trunkaler Hypotonie",
      "Syndrom der infantilen Neurodegeneration mit progressiver Spastik, Intelligenzminderung und Läsion der weißen Substanz",
      "TANGO2-assoziiertes Syndrom der metabolischen Enzephalopathie mit Arrhythmie",
      "X-chromosomales neurodegeneratives Syndrom Typ Bertini",
      "X-chromosomales neurodegeneratives Syndrom Typ Hamel",
      "Zerebro-kutanes Syndrom mit Eisenüberladung",
      "Zerebro-renales Syndrom Typ Perez",
      "Zystische Gehirndegeneration"
    ]
  },
  {
    "code": "G31.9",
    "name": "Zerebrale Degeneration",
    "synonyms": [
      "Degeneration des Gehirns",
      "Degeneration des Nervensystems",
      "Degenerative Erkrankung des Zentralnervensystems",
      "Degenerative Gehirnkrankheit",
      "Degenerative Hirnerkrankung",
      "Degenerative Hirnkrankheit",
      "Degenerative Hirnleistungsstörung",
      "Degenerative Krankheit des Nervensystems",
      "Degenerative Nervenerkrankung",
      "Erworbene zerebellare Ataxie",
      "Erworbene zerebellare Degeneration",
      "Gehirnabbauprozess",
      "Gehirnatrophie",
      "Gehirndegeneration beim Kind",
      "Gehirnschrumpfung",
      "Großhirnrindenatrophie",
      "Hemisphärenatrophie",
      "Hirnabbau",
      "Hirnabbauprozess",
      "Hirnatrophie",
      "Hirnrindenatrophie",
      "Hirnschrumpfung",
      "Kleinhirnatrophie",
      "Kortikale Atrophie",
      "Neurodegenerative Erkrankung",
      "Progressive kortikale Gehirndegeneration",
      "Zerebellare Atrophie",
      "Zerebellare Degeneration",
      "Zerebellare Hemiatrophie",
      "Zerebralabbauprozess",
      "Zerebrale Atrophie",
      "Zerebrale Degeneration"
    ]
  },
  {
    "code": "G35.0",
    "name": "Erstmanifestation einer Multiplen Sklerose",
    "synonyms": [
      "Erstmanifestation einer Multiplen Sklerose",
      "Erstmanifestation einer akuten multiplen Sklerose Typ Marburg"
    ]
  },
  {
    "code": "G35.10",
    "name": "Multiple Sklerose mit vorherrschend schubförmigem Verlauf",
    "synonyms": [
      "Akute multiple Sklerose Typ Marburg mit vorherrschend schubförmigem Verlauf",
      "Multiple Sklerose im Kindesalter mit vorherrschend schubförmigem Verlauf",
      "Multiple Sklerose mit vorherrschend schubförmigem Verlauf",
      "Multiple Sklerose mit vorherrschend schubförmigem Verlauf, ohne Angabe einer akuten Exazerbation oder Progression"
    ]
  },
  {
    "code": "G35.11",
    "name": "Multiple Sklerose mit vorherrschend schubförmigem Verlauf, mit Angabe einer akuten Exazerbation oder Progression",
    "synonyms": [
      "Multiple Sklerose im Kindesalter mit vorherrschend schubförmigem Verlauf und akuter Exazerbation",
      "Multiple Sklerose mit vorherrschend schubförmigem Verlauf, mit Angabe einer akuten Exazerbation oder Progression"
    ]
  },
  {
    "code": "G35.20",
    "name": "Multiple Sklerose mit primär-chronischem Verlauf",
    "synonyms": [
      "Multiple Sklerose mit primär-chronischem Verlauf",
      "Multiple Sklerose mit primär-chronischem Verlauf, ohne Angabe einer akuten Exazerbation oder Progression",
      "PPMS [Primär progrediente Multiple Sklerose]",
      "Primär progrediente Multiple Sklerose",
      "Primär progrediente akute multiple Sklerose Typ Marburg"
    ]
  },
  {
    "code": "G35.21",
    "name": "Multiple Sklerose mit primär-chronischem Verlauf, mit Angabe einer akuten Exazerbation oder Progression",
    "synonyms": [
      "Multiple Sklerose mit primär-chronischem Verlauf, mit Angabe einer akuten Exazerbation oder Progression",
      "Primär progrediente akute multiple Sklerose Typ Marburg mit akuter Exazerbation"
    ]
  },
  {
    "code": "G35.30",
    "name": "Multiple Sklerose mit sekundär-chronischem Verlauf",
    "synonyms": [
      "Multiple Sklerose mit sekundär-chronischem Verlauf",
      "Multiple Sklerose mit sekundär-chronischem Verlauf, ohne Angabe einer akuten Exazerbation oder Progression"
    ]
  },
  {
    "code": "G35.31",
    "name": "Multiple Sklerose mit sekundär-chronischem Verlauf, mit Angabe einer akuten Exazerbation oder Progression",
    "synonyms": [
      "Multiple Sklerose mit sekundär-chronischem Verlauf, mit Angabe einer akuten Exazerbation oder Progression"
    ]
  },
  {
    "code": "G35.9",
    "name": "Lumbosakrale Multiple Sklerose",
    "synonyms": [
      "Akute multiple Sklerose Typ Marburg",
      "Aszendierende Multiple Sklerose",
      "Bulbäre Multiple Sklerose",
      "Disseminierte Entmarkungsenzephalomyelitis",
      "Disseminierte Gehirnsklerose",
      "Disseminierte Hirnsklerose",
      "Disseminierte Multiple Sklerose",
      "Disseminierte Myelosklerose des Zentralnervensystems",
      "Disseminierte Rückenmarksklerose",
      "Disseminierte Sklerose",
      "Disseminierte zerebrospinale Sklerose",
      "ED [Encephalomyelitis disseminata]",
      "Encephalomyelitis disseminata",
      "Encephalomyelitis periaxialis sclerotica disseminata",
      "Generalisierte Multiple Sklerose",
      "Hemiplegische Multiple Sklerose",
      "Insulare Gehirnsklerose",
      "Insulare Hirnsklerose",
      "Insuläre Sklerose",
      "Lumbosakrale Multiple Sklerose",
      "MS [Encephalomyelitis disseminata]",
      "Miliare Gehirnsklerose",
      "Miliare Hirnsklerose",
      "Multiple Gehirnsklerose",
      "Multiple Hirnsklerose",
      "Multiple Sklerose",
      "Multiple Sklerose des Hirnstamms",
      "Multiple Sklerose des Rückenmarks",
      "Multiple Sklerose im Kindesalter",
      "Multiple zerebrospinale Sklerose",
      "Paraplegische Multiple Sklerose",
      "Polysklerose",
      "Pädiatrische Multiple Sklerose",
      "Sclérose en plaques",
      "Sklerotische Plaques",
      "Spinale Multiple Sklerose",
      "Zerebrale Multiple Sklerose"
    ]
  },
  {
    "code": "G36.0",
    "name": "Neuromyelitis optica",
    "synonyms": [
      "Demyelinisation bei Neuritis optica",
      "Devic-Krankheit",
      "Devic-Syndrom",
      "NMOSD [Neuromyelitis-optica-Spektrum-Krankheit] mit Anti-AQP4 [Aquaporin-4]-Antikörper",
      "NMOSD [Neuromyelitis-optica-Spektrum-Krankheit] mit Anti-MOG [Myelin-Oligodendrozyten-Glykoprotein]-Antikörper",
      "NMOSD [Neuromyelitis-optica-Spektrum-Krankheit] ohne Anti-MOG- und Anti-AQP4-Antikörper",
      "Neuroencephalomyelopathia optica",
      "Neuromyelitis optica",
      "Ophthalmoneuromyelitis"
    ]
  },
  {
    "code": "G36.1",
    "name": "Akute hämorrhagische Leukoenzephalitis",
    "synonyms": [
      "Akute hämorrhagische Leukoenzephalitis",
      "Hurst-Krankheit"
    ]
  },
  {
    "code": "G36.9",
    "name": "Neuromyelitis",
    "synonyms": [
      "Disseminierte akute Demyelinisation",
      "Neuromyelitis"
    ]
  },
  {
    "code": "G37.0",
    "name": "Diffuse Hirnsklerose",
    "synonyms": [
      "Diffuse Gehirnsklerose",
      "Diffuse Hirnsklerose",
      "Encephalitis periaxialis",
      "Encephalitis periaxialis diffusa",
      "Flatau-Schilder-Krankheit",
      "Myelinoklastische diffuse Sklerose",
      "Schilder-Foix-Heubner-Krankheit",
      "Schilder-Foix-Heubner-Syndrom",
      "Schilder-Krankheit",
      "Schilder-Syndrom"
    ]
  },
  {
    "code": "G37.1",
    "name": "Zentrale Demyelinisation des Corpus callosum",
    "synonyms": [
      "Demyelinisierende Enzephalopathie des Corpus callosum",
      "Marchiafava-Bignami-Krankheit",
      "Marchiafava-Bignami-Syndrom",
      "Zentrale Demyelinisation des Corpus callosum"
    ]
  },
  {
    "code": "G37.2",
    "name": "Zentrale pontine Myelinolyse",
    "synonyms": [
      "Zentrale pontine Myelinolyse"
    ]
  },
  {
    "code": "G37.3",
    "name": "Myelitis transversa acuta bei demyelinisierender Krankheit des Zentralnervensystems",
    "synonyms": [
      "Akute transverse Myelitis",
      "Akute transverse Myelitis mit Anti-MOG [Myelin-Oligodendrozyten-Glykoprotein]-Antikörper",
      "Akute transverse Myelopathie",
      "Myelitis transversa acuta",
      "Myelitis transversa acuta bei demyelinisierender Krankheit des Zentralnervensystems"
    ]
  },
  {
    "code": "G37.4",
    "name": "Subakute nekrotisierende Myelitis",
    "synonyms": [
      "Angiodysgenetische nekrotisierende Myelopathie",
      "Arteriovenöse spinale Fehlbildung",
      "Foix-Alajouanine-Syndrom",
      "Subakute angiohypertrophische Myelomalazie",
      "Subakute aufsteigende nekrotisierende Myelitis",
      "Subakute nekrotisierende Myelitis"
    ]
  },
  {
    "code": "G37.5",
    "name": "Konzentrische Sklerose",
    "synonyms": [
      "Baló-Krankheit",
      "Baló-Syndrom",
      "Encephalitis periaxialis concentrica",
      "Greenfield-Krankheit [Konzentrische Sklerose]",
      "Greenfield-Syndrom [Konzentrische Sklerose]",
      "Konzentrische Demyelinisation",
      "Konzentrische Sklerose",
      "Konzentrische Sklerose Baló"
    ]
  },
  {
    "code": "G37.8",
    "name": "Akute demyelinisierende Enzephalomyelitis [ADEM]",
    "synonyms": [
      "Akute demyelinisierende Enzephalomyelitis [ADEM]",
      "Mitchell-Syndrom (Polyneuropathie)"
    ]
  },
  {
    "code": "G37.9",
    "name": "Entmarkungsenzephalitis",
    "synonyms": [
      "Demyelinisation",
      "Demyelinisation des Zentralnervensystems",
      "Demyelinisierende Krankheit des Zentralnervensystems",
      "Demyelinisierendes Syndrom",
      "Entmarkungsenzephalitis",
      "Entmarkungskrankheit des Zentralnervensystems",
      "Gehirnsklerose",
      "Hirnsklerose",
      "Myelindegeneration des Zentralnervensystems"
    ]
  },
  {
    "code": "G40.00",
    "name": "Pseudo-Lennox-Syndrom",
    "synonyms": [
      "Gutartige atypische Epilepsie",
      "Pseudo-Lennox-Syndrom"
    ]
  },
  {
    "code": "G40.01",
    "name": "CSWS [Continuous spikes and waves during slow-wave sleep]",
    "synonyms": [
      "Bioelektrischer Status epilepticus im Schlaf",
      "CSWS [Continuous spikes and waves during slow-wave sleep]",
      "ESES [Electrical status epilepticus during slow-wave sleep]"
    ]
  },
  {
    "code": "G40.02",
    "name": "Benigne psychomotorische Epilepsie",
    "synonyms": [
      "Benigne Partialepilepsie mit affektiver Symptomatik",
      "Benigne psychomotorische Epilepsie"
    ]
  },
  {
    "code": "G40.08",
    "name": "Epilepsie im Kindesalter mit okzipitalen Paroxysmen im EEG",
    "synonyms": [
      "Benigne Epilepsie im Säuglingsalter [Watanabe]",
      "Benigne Säuglingsepilepsie mit komplexfokalem Anfall",
      "Benigne okzipitale Epilepsie",
      "Epilepsie im Kindesalter mit okzipitalen Paroxysmen im EEG",
      "Fokal beginnender epileptischer Anfall",
      "Gutartige Epilepsie im Kindesalter mit zentrotemporalen Spikes im EEG",
      "Rolando-Epilepsie",
      "Rolando-Epilepsie mit paroxysmaler anstrengungsinduzierter Dyskinesie und Schreibkrampf"
    ]
  },
  {
    "code": "G40.09",
    "name": "Idiopathische lokalisationsbezogene Epilepsie",
    "synonyms": [
      "Idiopathische lokalisationsbezogene Epilepsie"
    ]
  },
  {
    "code": "G40.1",
    "name": "Teilmotorische Epilepsie",
    "synonyms": [
      "ADNFLE [Autosomal-dominante nächtliche Frontallappenepilepsie]",
      "Autosomal-dominante nächtliche Frontallappenepilepsie",
      "Benigne Partialepilepsie im Kleinkindalter mit sekundär generalisierten Anfällen",
      "Benigne fokale Adoleszenten-Epilepsie",
      "Bravais-Jackson-Anfall",
      "Bravais-Jackson-Epilepsie",
      "Einfacher fokaler Anfall mit Entwicklung zu sekundär generalisiertem Anfall",
      "Einfacher fokaler epileptischer Anfall",
      "Epilepsie mit einfachem fokalem Anfall",
      "Epileptischer Anfall ohne Bewusstseinsstörung",
      "Familiäre partielle Epilepsie",
      "Fokale Epilepsie",
      "Fokale Jackson-Epilepsie",
      "Fokaler Jackson-Anfall",
      "Fokaler epileptiformer Anfall",
      "Herdepilepsie",
      "Jackson-Attacke",
      "Jackson-Aura",
      "Jackson-Epilepsie",
      "Jackson-Konvulsionen",
      "Jackson-Syndrom",
      "Kortikale Epilepsie",
      "Kortikaler fokaler Anfall",
      "Partielle Epilepsie",
      "Partielle Epilepsie ohne Bewusstseinsstörung",
      "Sekundär generalisierte partielle Epilepsie",
      "Somatomotorische Epilepsie",
      "Somatosensorische Epilepsie",
      "Teilmotorische Epilepsie"
    ]
  },
  {
    "code": "G40.2",
    "name": "Psychomotorische Epilepsie",
    "synonyms": [
      "AIEF [Akute infantile Enzephalopathie mit vorwiegender Beteiligung der Frontallappen]",
      "Akute infantile Enzephalopathie mit vorwiegender Beteiligung der Frontallappen",
      "Autosomal-dominante laterale Temporallappen-Epilepsie",
      "Benigne Partialepilepsie im Kleinkindalter mit komplexen fokalen Anfällen",
      "Epilepsie des limbischen Systems",
      "Epilepsie mit komplexem fokalen Anfall",
      "Epileptische Automatismen",
      "Epileptischer Anfall mit Bewusstseinsstörung",
      "Epileptisches Äquivalent",
      "Familiäre Temporallappenepilepsie",
      "Familiäre mesiale Temporallappenepilepsie",
      "Familiäre mesiale Temporallappenepilepsie mit Fieberkrämpfen",
      "Infantile mesiale Temporallappenepilepsie mit schwergradiger kognitiver Regression",
      "Komplex fokaler epileptischer Anfall",
      "Komplexer fokaler Anfall mit Entwicklung zu einem sekundär generalisierten Anfall",
      "Paroxysmale idiopathische Automatismen",
      "Partielle Epilepsie mit Bewusstseinsstörung",
      "Psychomotorische Epilepsie",
      "Psychomotorische Konvulsionen",
      "Psychomotorischer Anfall",
      "Psychomotorisches Anfallsleiden",
      "Psychosensorische Epilepsie",
      "Syndrom der X-chromosomalen Epilepsie mit Lernstörung und Verhaltensauffälligkeit",
      "Temporallappenepilepsie",
      "Uncinatus-Anfall"
    ]
  },
  {
    "code": "G40.3",
    "name": "Klonischer epileptischer Anfall",
    "synonyms": [
      "Absencen im Kindesalter",
      "Absencen-Epilepsie im Kindesalter",
      "Akinetische Epilepsie",
      "Akinetischer Anfall",
      "Atonische Absencen",
      "Atonische epileptische Absencen",
      "Atonischer Anfall",
      "BFIE [Benigne familiäre infantile Epilepsie]",
      "BFNIS [Benigne familiäre neonatal-infantile Anfälle]",
      "Benigne adulte familiäre Myoklonusepilepsie",
      "Benigne familiäre Neugeborenenkrämpfe",
      "Benigne familiäre infantile Epilepsie",
      "Benigne familiäre neonatal-infantile Anfälle",
      "Benigne idiopathische Neugeborenenkrämpfe",
      "Benigne infantile Krampfanfälle bei milder Gastroenteritis",
      "Benigne myoklonische Epilepsie des Kindesalters",
      "Benigne myoklonische Epilepsie im Kleinkindesalter",
      "Epilepsia major",
      "Epilepsia minor",
      "Epilepsie mit Grand-Mal-Anfall beim Aufwachen",
      "Epilepsie vom gemischten Typ",
      "Epileptisch-dyskinetische infantile Enzephalopathie",
      "FIME [Familiäre infantile Myoklonusepilepsie]",
      "Familiäre infantile Myoklonusepilepsie",
      "Familiärer gutartiger Neugeborenenkrampf",
      "Folinsäure-abhängige Anfälle",
      "Folinsäure-abhängigen Krämpfe",
      "Friedmann-Syndrom",
      "Früh beginnende Lafora-Einschlusskörperchen-Krankheit",
      "Frühinfantil-epileptische Enzephalopathie",
      "Generalisierte Epilepsie",
      "Generalisierte Epilepsie als Symptom einer anderen Hirnerkrankung",
      "Generalisierte Epilepsie mit Fieberkrämpfen plus",
      "Generalisierte Epilepsie mit Krampf",
      "Grand-Mal-Anfall beim Aufwachen",
      "Grand-Mal-Aufwachepilepsie",
      "Gutartige myoklonische Epilepsie im Kleinkindalter",
      "Gutartiger Neugeborenenkrampf",
      "Idiopathische Pyknolepsie",
      "Idiopathische generalisierte Epilepsie",
      "Impulsiv-Petit-Mal",
      "Impulsives Petit Mal",
      "Infant-Petit-Mal",
      "Infantile Petit-Mal-Epilepsie",
      "JME [Juvenile myoklonische Epilepsie]",
      "Jeavons-Syndrom",
      "Juberg-Hellman-Syndrom",
      "Juvenile Absencen-Epilepsie",
      "Juvenile Myoklonusepilepsie",
      "Juvenile myoklonische Epilepsie",
      "Klonische Epilepsie",
      "Klonischer epileptischer Anfall",
      "Konvulsive Epilepsia major",
      "Lafora-Krankheit",
      "Lafora-Syndrom",
      "Myoklonische Epilepsie",
      "Myoklonische Konvulsionen",
      "Myoklonischer epileptischer Anfall",
      "Myoklonus-Nephropathie-Syndrom",
      "Neonatale benigne Konvulsionen",
      "POMA [Periorale Myoklonien mit Absencen]",
      "Periorale Myoklonien mit Absencen",
      "Petit-Mal-Epilepsie",
      "Progressive Myoklonusepilepsie",
      "Progressive Myoklonusepilepsie Typ 1",
      "Progressive Myoklonusepilepsie Typ 2",
      "Progressive Myoklonusepilepsie Typ 3",
      "Progressive Myoklonusepilepsie Typ 4",
      "Progressive Myoklonusepilepsie Typ 5",
      "Progressive Myoklonusepilepsie Typ 6",
      "Progressive Myoklonusepilepsie Typ 7",
      "Progressive Myoklonusepilepsie Typ 8",
      "Progressive Myoklonusepilepsie Typ 9",
      "Progressive myoklonische Epilepsie",
      "Progressive myoklonische Epilepsie Typ 1",
      "Pyknolepsie",
      "STXBP1-assoziierte Enzephalopathie mit Epilepsie",
      "Schlaf-Grand-Mal",
      "Tonisch-klonische Epilepsie",
      "Tonisch-klonischer epileptischer Anfall",
      "Tonischer epileptischer Anfall",
      "ULD [Unverricht-Lundborg-Krankheit]",
      "Unspezifischer atonischer epileptischer Anfall",
      "Unspezifischer klonischer epileptischer Anfall",
      "Unspezifischer myoklonischer epileptischer Anfall",
      "Unspezifischer tonisch-klonischer epileptischer Anfall",
      "Unspezifischer tonischer epileptischer Anfall",
      "Unverricht-Krankheit",
      "Unverricht-Lundborg-Epilepsie",
      "Unverricht-Lundborg-Krankheit",
      "Unverricht-Lundborg-Syndrom",
      "Unverricht-Syndrom"
    ]
  },
  {
    "code": "G40.4",
    "name": "Blitz-Nick-Salaam-Krampf",
    "synonyms": [
      "BNS [Blitz-Nick-Salaam]-Epilepsie",
      "BNS [Blitz-Nick-Salaam]-Krampf",
      "Blitz-Nick-Salaam-Krampf",
      "Blitzkrampf",
      "CDKL5-assoziierte epileptische Enzephalopathie",
      "Doose-Syndrom",
      "Dravet-Syndrom",
      "Epilepsie der frühen Kindheit mit migratorischen fokalen Anfällen",
      "Epilepsie mit myoklonisch-astatischem Anfall",
      "Epilepsie mit myoklonisch-atonischen Anfällen",
      "Epilepsie mit myoklonischen Absencen",
      "Epilepsie mit schwerem myoklonischen Syndrom des Kindesalters",
      "Früh beginnende epileptische Enzephalopathie",
      "Früh beginnende progressive Enzephalopathie mit wanderndem kontinuierlichem Myoklonus",
      "Frühe myoklonische Enzephalopathie",
      "Frühkindliche Grand-mal-Epilepsie",
      "Frühkindliche myoklonische Enzephalopathie mit Suppression-bursts",
      "Generalisiertes epileptisches Syndrom",
      "Hemikonvulsion-Hemiplegie-Epilepsie-Syndrom",
      "Hypsarrhythmie",
      "ICCA [Infantile Konvulsionen und paroxysmale Choreoathetose]-Syndrom",
      "ITPA-assoziierte letale infantile epileptische Enzephalopathie mit Katarakt und kardialer Beteiligung",
      "Infantile Konvulsionen und Choreoathetose",
      "Infantiler Spasmus",
      "KCNQ2-assoziierte epileptische Enzephalopathie",
      "Lennox-Gastaut-Syndrom",
      "Lennox-Syndrom",
      "Maligne migrierende Partialepilepsie des Säuglingsalters",
      "Myoklonische Epilepsie bei nicht-progressiven Enzephalopathien",
      "Nickkrampf",
      "PURA-assoziiertes Syndrom der schweren neonatalen Muskelhypotonie mit Krämpfen und Enzephalopathie",
      "RNF13-assoziierte frühinfantil-epileptische Enzephalopathie",
      "Salaamanfall",
      "Salaamkrampf",
      "Spastischer Blitzkrampf",
      "Symptomatische frühzeitige myoklonische Enzephalopathie",
      "Syndrom der frühinfantilen epileptischen Enzephalopathie mit kortikaler Blindheit, Intelligenzminderung und Gesichtsdysmorphien",
      "West-Syndrom",
      "X-chromosomales Syndrom mit Spastik, Intelligenzminderung und Epilepsie"
    ]
  },
  {
    "code": "G40.5",
    "name": "Kojewnikoff-Syndrom",
    "synonyms": [
      "Alkoholisches Anfallsleiden",
      "Epilepsia partialis continua",
      "Epileptischer Anfall durch Alkohol",
      "Epileptischer Anfall durch Arzneimittel",
      "Epileptischer Anfall durch Drogen",
      "Epileptischer Anfall durch Schlafentzug",
      "Epileptischer Anfall durch Stress",
      "Epileptischer Anfall durch hormonelle Veränderung",
      "FIRES [Febrile infection-related epilepsy syndrome]",
      "Kojewnikoff-Syndrom",
      "Kojewnikow-Epilepsie",
      "Kojewnikow-Syndrom",
      "Koshewnikoff-Epilepsie",
      "Koshewnikoff-Syndrom",
      "Spezielles epileptisches Syndrom"
    ]
  },
  {
    "code": "G40.6",
    "name": "Grand-Mal-Epilepsie",
    "synonyms": [
      "Grand Mal",
      "Grand-Mal-Anfall",
      "Grand-Mal-Epilepsie",
      "Haut mal",
      "Idiopathisches Grand Mal",
      "Petit Mal mit Grand-Mal-Anfall"
    ]
  },
  {
    "code": "G40.7",
    "name": "Absencen-Epilepsie",
    "synonyms": [
      "Absencen-Epilepsie",
      "Epileptische Absencen a.n.k.",
      "Epileptische Absentia a.n.k.",
      "Idiopathisches Petit Mal",
      "Petit Mal",
      "Petit-Mal-Anfall"
    ]
  },
  {
    "code": "G40.8",
    "name": "Visuelle Epilepsie",
    "synonyms": [
      "Abdominalepilepsie",
      "Akustische Epilepsie",
      "Altersepilepsie",
      "Audiogene Reflexepilepsie",
      "Coma epilepticum",
      "Denkepilepsie",
      "Epilepsia abdominalis",
      "Epilepsie mit Bewusstseinstrübung",
      "Epilepsie, unbestimmt, ob fokal oder generalisiert",
      "Epileptische Bewusstseinstrübung",
      "Epileptische Migräne",
      "Epileptisches Koma",
      "Epileptisches Syndrom, unbestimmt, ob fokal oder generalisiert",
      "Essepilepsie",
      "Im Kindesalter beginnendes Epilepsie-Syndrom",
      "Klimakterische Epilepsie",
      "Konvulsives abdominales Äquivalent",
      "Leseepilepsie",
      "Lokalisationsbezogene Epilepsie",
      "Miktions-induzierte Reflexepilepsie",
      "Moore-Syndrom",
      "Musikinduzierte Epilepsie",
      "Orgasmus-induzierter Krampfanfall",
      "PNPO [Pyridoxamin-5-Phosphat-Oxidase]-Mangel",
      "PNPO [Pyridoxamin-5-Phosphat-Oxidase]-abhängige neonatale epileptische Enzephalopathie",
      "Paroxysmale Bewusstseinstrübung",
      "Periphere Epilepsie",
      "Photosensitive Epilepsie",
      "Pyridoxalphosphat-abhängige Epilepsie",
      "Pyridoxalphosphat-abhängige Krämpfe",
      "Pyridoxamine 5-Oxidase-Mangel",
      "Pyridoxinabhängige Epilepsie",
      "Pyridoxinabhängige Krämpfe",
      "Reflexepilepsie",
      "Schreckepilepsie",
      "Senile Epilepsie",
      "Spät beginnende kryptogenetische Epilepsie",
      "Vertigo epileptica",
      "Visuelle Epilepsie",
      "Viszerale Epilepsie",
      "Vitamin B6-abhängige Anfälle",
      "Warmwasser-Reflexepilepsie"
    ]
  },
  {
    "code": "G40.9",
    "name": "Morbus sacer",
    "synonyms": [
      "Amnesie durch Epilepsie",
      "Anfallsleiden",
      "Aura epileptica a.n.k.",
      "Epilepsia",
      "Epilepsie",
      "Epilepsie-Symptom",
      "Epilepsieanfall",
      "Epileptische Aura",
      "Epileptische Konvulsionen",
      "Epileptische Reaktion",
      "Epileptischer Anfall",
      "Epileptischer Krampf",
      "Epileptisches Anfallsleiden",
      "Epileptisches Syndrom",
      "Fallsucht",
      "Fugue durch Epilepsie",
      "Idiopathische Epilepsie",
      "Kryptogene Epilepsie",
      "Morbus caducus",
      "Morbus sacer",
      "Rindenepilepsie",
      "Unspezifischer epileptischer Anfall",
      "Zerebrale Epilepsie",
      "Zerebrales Anfallsleiden"
    ]
  },
  {
    "code": "G41.0",
    "name": "Grand-Mal-Status",
    "synonyms": [
      "Grand-Mal-Status",
      "Grand-Mal-Status mit tonisch-klonischem Anfall",
      "Konvulsiv-idiopathischer Status",
      "Status epilepticus bei Grand Mal",
      "Tonisch-klonischer Status epilepticus"
    ]
  },
  {
    "code": "G41.1",
    "name": "Petit-Mal-Status",
    "synonyms": [
      "Epileptischer Absencenstatus",
      "Petit-Mal-Status",
      "Status epilepticus bei Petit Mal"
    ]
  },
  {
    "code": "G41.2",
    "name": "Status epilepticus mit komplexfokalem Anfall",
    "synonyms": [
      "Psychomotorischer Status epilepticus",
      "Status epilepticus mit komplexfokalem Anfall",
      "Temporallappen-Status"
    ]
  },
  {
    "code": "G41.8",
    "name": "Status epilepticus partialis",
    "synonyms": [
      "Fokal motorischer Status epilepticus",
      "Neu beginnender refraktärer Status epilepticus",
      "Status epilepticus partialis"
    ]
  },
  {
    "code": "G41.9",
    "name": "Status epilepticus",
    "synonyms": [
      "Status epilepticus"
    ]
  },
  {
    "code": "G43.0",
    "name": "Migräne ohne Aura",
    "synonyms": [
      "Common-Migräne",
      "Gewöhnliche Migräne",
      "Migräne ohne Aura"
    ]
  },
  {
    "code": "G43.1",
    "name": "Migräne mit Aura",
    "synonyms": [
      "Abdominales Migräne-Syndrom",
      "Basiläre Migräne",
      "Echte Migräne",
      "Familiär-hemiplegische Migräne",
      "Hemiplegische Migräne",
      "Klassische Migräne",
      "Migraine accompagnée",
      "Migräne im Basilarisgebiet",
      "Migräne mit Aura",
      "Migräne mit Aura ohne Kopfschmerzen",
      "Migräne mit akut einsetzender Aura",
      "Migräne mit prolongierter Aura",
      "Migräne-Äquivalent"
    ]
  },
  {
    "code": "G43.2",
    "name": "Status migraenosus",
    "synonyms": [
      "Migräne-Status",
      "Status migraenosus"
    ]
  },
  {
    "code": "G43.3",
    "name": "Komplizierte Migräne",
    "synonyms": [
      "Komplizierte Migräne"
    ]
  },
  {
    "code": "G43.8",
    "name": "Moebius-Krankheit [Ophthalmoplegische Migräne]",
    "synonyms": [
      "Abdominale Migräne",
      "Chronische Migräne",
      "Moebius-Krankheit [Ophthalmoplegische Migräne]",
      "Morbus Moebius [Ophthalmoplegische Migräne]",
      "Ophthalmoplegische Migräne",
      "Periodische Lähmung des Nervus ophthalmicus [Ophthalmoplegische Migräne]",
      "Retinale Migräne"
    ]
  },
  {
    "code": "G43.9",
    "name": "Migräne",
    "synonyms": [
      "Halbseitige Kopfschmerzen im Sinne von Migräne",
      "Hemikranie im Sinne von Migräne",
      "Idiopathische Migräne",
      "Migraine",
      "Migräne",
      "Migräne-Kopfschmerzen",
      "Migräne-Variante",
      "Migräne-Zephalgie",
      "Migräneanfall",
      "Migränesyndrom",
      "Vegetative Migräne"
    ]
  },
  {
    "code": "G44.0",
    "name": "Cluster-Kopfschmerzen",
    "synonyms": [
      "Bing-Horton-Syndrom",
      "Chronische Cluster-Kopfschmerzen",
      "Chronische paroxysmale Hemikranie",
      "Cluster headache [Bing-Horton-Syndrom]",
      "Cluster-Kopfschmerz-Syndrom",
      "Cluster-Kopfschmerzen",
      "Cluster-Migräne",
      "Episodische Cluster-Kopfschmerzen",
      "Erythroprosopalgie vom Typ Bing",
      "Hemicrania continua",
      "Histamin-Kopfschmerzen",
      "Histaminkephalgie",
      "Horton-Kopfschmerzen",
      "Horton-Neuralgie",
      "Horton-Syndrom",
      "Migräneartige Neuralgie",
      "Nasoziliarneuralgie",
      "Paroxysmale Hemikranie",
      "Ziliarisneuralgie"
    ]
  },
  {
    "code": "G44.1",
    "name": "Cephalaea vasomotorica",
    "synonyms": [
      "Cephalaea vasomotorica",
      "Vaskuläre Kopfschmerzen",
      "Vasomotorische Kopfschmerzen",
      "Vasomotorische Zephalgie"
    ]
  },
  {
    "code": "G44.2",
    "name": "Migränoide Spannungskopfschmerzen",
    "synonyms": [
      "Chronische Spannungskopfschmerzen",
      "Episodische Spannungskopfschmerzen",
      "Migränoide Spannungskopfschmerzen",
      "Muskelbedingte Spannungskopfschmerzen",
      "Nervöse Spannungskopfschmerzen",
      "Spannungskopfschmerzen",
      "Tension headache"
    ]
  },
  {
    "code": "G44.3",
    "name": "Chronische posttraumatische Kopfschmerzen",
    "synonyms": [
      "Chronische posttraumatische Kopfschmerzen",
      "Posttraumatische Kopfschmerzen"
    ]
  },
  {
    "code": "G44.4",
    "name": "Medikamentöse Kopfschmerzen",
    "synonyms": [
      "Arzneimittelinduzierte Kopfschmerzen",
      "Kopfschmerzen durch Arzneimitteleinwirkung",
      "Kopfschmerzen durch Medikamenteneinwirkung",
      "Medikamentöse Kopfschmerzen"
    ]
  },
  {
    "code": "G44.8",
    "name": "Kopfschmerzsyndrom",
    "synonyms": [
      "Allergische Kopfschmerzen",
      "Kopfschmerzsyndrom",
      "SUNCT [Short lasting unilateral neuralgiform headache attacks with conjunctival injection and tearing]-Syndrom",
      "Schlafgebundener Kopfschmerz",
      "Sluder-Neuralgie",
      "Sluder-Syndrom",
      "Sphenopalatinale Neuralgie"
    ]
  },
  {
    "code": "G45.02",
    "name": "Drop attack",
    "synonyms": [
      "Arteria-vertebralis-Syndrom mit Basilaris-Symptomatik mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden",
      "Drop attack"
    ]
  },
  {
    "code": "G45.03",
    "name": "Arteria-vertebralis-Syndrom mit Basilaris-Symptomatik und mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
    "synonyms": [
      "Arteria-vertebralis-Syndrom mit Basilaris-Symptomatik und mit kompletter Rückbildung innerhalb von weniger als 1 Stunde"
    ]
  },
  {
    "code": "G45.09",
    "name": "Basilarisinsuffizienz",
    "synonyms": [
      "Arteria-basilaris-Syndrom",
      "Arteria-vertebralis-Syndrom",
      "Basilaris-Symptomatik",
      "Basilarisinsuffizienz",
      "Basiläre DBS [Durchblutungsstörung]",
      "Basiläre Durchblutungsstörung",
      "Insuffizienz der Arteria basilaris",
      "Insuffizienz der Arteria vertebralis",
      "VBI [Vertebrobasiläre Insuffizienz]",
      "Vertebrobasiläre DBS [Durchblutungsstörung]",
      "Vertebrobasiläre Durchblutungsstörung",
      "Vertebrobasiläre Insuffizienz"
    ]
  },
  {
    "code": "G45.12",
    "name": "Arteria-carotis-interna-Syndrom, mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden",
    "synonyms": [
      "Arteria-carotis-interna-Syndrom, mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden"
    ]
  },
  {
    "code": "G45.13",
    "name": "Arteria-carotis-interna-Syndrom, mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
    "synonyms": [
      "Arteria-carotis-interna-Syndrom, mit kompletter Rückbildung innerhalb von weniger als 1 Stunde"
    ]
  },
  {
    "code": "G45.19",
    "name": "Arteria-carotis-interna-Syndrom",
    "synonyms": [
      "Arteria-carotis-interna-Syndrom",
      "Insuffizienz der Arteria carotis"
    ]
  },
  {
    "code": "G45.22",
    "name": "Bilaterales Syndrom der extrazerebralen hirnversorgenden Arterien mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden",
    "synonyms": [
      "Bilaterales Syndrom der extrazerebralen hirnversorgenden Arterien mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden",
      "Multiple Syndrome der extrazerebralen hirnversorgenden Arterien mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden"
    ]
  },
  {
    "code": "G45.23",
    "name": "Bilaterales Syndrom der extrazerebralen hirnversorgenden Arterien mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
    "synonyms": [
      "Bilaterales Syndrom der extrazerebralen hirnversorgenden Arterien mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
      "Multiple Syndrome der extrazerebralen hirnversorgenden Arterien mit kompletter Rückbildung innerhalb von weniger als 1 Stunde"
    ]
  },
  {
    "code": "G45.29",
    "name": "Multiple Syndrome der präzerebralen Arterien",
    "synonyms": [
      "Bilaterale Syndrome der präzerebralen Arterien",
      "Multiple Syndrome der präzerebralen Arterien",
      "Präzerebrale arterielle Insuffizienz"
    ]
  },
  {
    "code": "G45.32",
    "name": "Amaurosis fugax mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden",
    "synonyms": [
      "Amaurosis fugax mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden"
    ]
  },
  {
    "code": "G45.33",
    "name": "Amaurosis fugax mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
    "synonyms": [
      "Amaurosis fugax mit kompletter Rückbildung innerhalb von weniger als 1 Stunde"
    ]
  },
  {
    "code": "G45.39",
    "name": "Amaurosis fugax",
    "synonyms": [
      "Amaurosis fugax"
    ]
  },
  {
    "code": "G45.42",
    "name": "Transiente globale Amnesie mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden",
    "synonyms": [
      "Transiente globale Amnesie mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden"
    ]
  },
  {
    "code": "G45.43",
    "name": "Transiente globale Amnesie mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
    "synonyms": [
      "Transiente globale Amnesie mit kompletter Rückbildung innerhalb von weniger als 1 Stunde"
    ]
  },
  {
    "code": "G45.49",
    "name": "Transiente globale Amnesie",
    "synonyms": [
      "Amnestische Episode",
      "Transiente globale Amnesie"
    ]
  },
  {
    "code": "G45.89",
    "name": "Subclavian-steal-Syndrom",
    "synonyms": [
      "Rezidivierende fokale zerebrale Ischämie",
      "Subclavian-steal-Syndrom"
    ]
  },
  {
    "code": "G45.92",
    "name": "TIA [Transitorische ischämische Attacke] - s.a. transitorische ischämische Attacke",
    "synonyms": [
      "TIA [Transitorische ischämische Attacke] - s.a. transitorische ischämische Attacke",
      "Transitorische ischämische Attacke",
      "Zerebrale transitorische Ischämie mit kompletter Rückbildung innerhalb von 1 bis 24 Stunden"
    ]
  },
  {
    "code": "G45.93",
    "name": "Zerebrale transitorische Ischämie mit kompletter Rückbildung innerhalb von weniger als 1 Stunde",
    "synonyms": [
      "Zerebrale transitorische Ischämie mit kompletter Rückbildung innerhalb von weniger als 1 Stunde"
    ]
  },
  {
    "code": "G45.99",
    "name": "Vorübergehender zerebraler Anfall",
    "synonyms": [
      "Hirnarterienspasmus",
      "Präapoplexie",
      "Vorübergehender zerebraler Anfall",
      "Zerebrale Claudicatio intermittens",
      "Zerebrale angiospastische Krankheit",
      "Zerebrale intermittierende Ischämie",
      "Zerebrale ischämische Attacke",
      "Zerebrale transitorische Ischämie",
      "Zerebraler Angiospasmus",
      "Zerebraler Arterienspasmus",
      "Zerebraler Gefäßspasmus",
      "Zerebraler arterieller Vasospasmus",
      "Zerebraler vaskulärer Spasmus"
    ]
  },
  {
    "code": "G47.0",
    "name": "Hyposomnie",
    "synonyms": [
      "Agrypnie",
      "Asomnie",
      "Durchschlafstörung",
      "Einschlafstörung",
      "Hyposomnia",
      "Hyposomnie",
      "Insomnie",
      "Organische Hyposomnie",
      "Organische Insomnie",
      "Organische Schlaflosigkeit",
      "Pervigilium",
      "Psychogene Insomnie",
      "Schlaflosigkeit",
      "Schlafstörung vom Insomnie-Typ"
    ]
  },
  {
    "code": "G47.1",
    "name": "Krankhaft gesteigertes Schlafbedürfnis",
    "synonyms": [
      "Exzessive Somnolenz",
      "Hypersomnie",
      "Idiopathische Hypersomnie",
      "Krankhaft gesteigertes Schlafbedürfnis",
      "Organische Hypersomnie",
      "Schlafstörung vom Hypersomnie-Typ"
    ]
  },
  {
    "code": "G47.2",
    "name": "Störung im Schlaf-Wach-Rhythmus",
    "synonyms": [
      "Freilaufender Schlafrhythmus",
      "Hypernykthemerales Syndrom",
      "Inversion des Nacht-Tag-Rhythmus",
      "Inversion des Schlafrhythmus",
      "Inversion des zirkadianen Rhythmus",
      "Irregulärer Schlaf-Wach-Rhythmus",
      "Nicht-24-Stunden-Schlaf-Wach-Syndrom",
      "Schlafrhythmusumkehr",
      "Störung im Schlaf-Wach-Rhythmus",
      "Syndrom der verzögerten Schlafphasen",
      "Syndrom der vorverlagerten Schlafphasen",
      "Umkehr des Nacht-Tag-Rhythmus",
      "Umkehr des zirkadianen Rhythmus",
      "Unregelmäßiger Schlaf-Wach-Rhythmus"
    ]
  },
  {
    "code": "G47.30",
    "name": "Primäre idiopathische Hypoventilation",
    "synonyms": [
      "Primäre idiopathische Hypoventilation",
      "Zentrale Schlafapnoe",
      "Zentrales Schlafapnoesyndrom"
    ]
  },
  {
    "code": "G47.31",
    "name": "Obstruktives Schlafapnoesyndrom",
    "synonyms": [
      "OSAS [Obstruktives Schlafapnoesyndrom]",
      "Obstruktive Schlafapnoe",
      "Obstruktives Schlafapnoesyndrom"
    ]
  },
  {
    "code": "G47.32",
    "name": "Undine-Syndrom",
    "synonyms": [
      "Kongenitales zentral-alveoläres Hypoventilations-Syndrom",
      "Kongenitales zentrales Hypoventilations-Syndrom",
      "Ondine-Syndrom",
      "Schlafbezogene idiopathische nichtobstruktive alveoläre Hypoventilation",
      "Schlafbezogenes Hypoventilations-Syndrom",
      "Undine-Syndrom"
    ]
  },
  {
    "code": "G47.39",
    "name": "Schlafapnoe",
    "synonyms": [
      "Atmungsbedingte Schlafstörung",
      "Schlafapnoe",
      "Schlafapnoesyndrom"
    ]
  },
  {
    "code": "G47.4",
    "name": "Kataplexie",
    "synonyms": [
      "Gélineau-Krankheit",
      "Gélineau-Syndrom",
      "Gélineau-Westphal-Syndrom",
      "Hypnolepsie",
      "Idiopathische Kataplexie",
      "Kataplexie",
      "Narkolepsie",
      "Narkolepsie mit Kataplexie",
      "Narkolepsie ohne Kataplexie",
      "Narkoleptisches Syndrom",
      "Schlaflähmung",
      "Sekundäre Narkolepsie"
    ]
  },
  {
    "code": "G47.8",
    "name": "Parasomnie",
    "synonyms": [
      "Hypersomnie-Bulimie-Syndrom",
      "Kleine-Levin-Syndrom",
      "Parasomnie",
      "Periodische Somnolenz",
      "Rezidivierende Hypersomnie",
      "Schlafstörung vom Parasomnie-Typ",
      "Schlafstörung vom gemischten Typ"
    ]
  },
  {
    "code": "G47.9",
    "name": "Schlafstörung",
    "synonyms": [
      "Chronische Schlafstörung",
      "Dyssomnie",
      "Schlafstörung"
    ]
  },
  {
    "code": "G50.0",
    "name": "Trigeminusneuralgie",
    "synonyms": [
      "Fothergill-Krankheit [Trigeminusneuralgie]",
      "Fothergill-Neuralgie",
      "Fothergill-Syndrom [Trigeminusneuralgie]",
      "Ganglionitis des Hirnnerven V",
      "Gesichtsneuralgie des Trigeminus",
      "Infraorbitale Schmerzen",
      "Infraorbitalneuralgie",
      "Morbus Fothergill [Trigeminusneuralgie]",
      "Nervenschmerzen des Gesichts",
      "Neuralgie des Nervus ophthalmicus",
      "Ophthalmikusneuralgie",
      "Paroxysmales Gesichtsschmerzsyndrom",
      "Quintus-Neuralgie",
      "Schmerzen des Nervus trigeminus",
      "Spasmus des Nervus trigeminus",
      "Supraorbitalneuralgie",
      "Tic douloureux",
      "Trigeminusneuralgie"
    ]
  },
  {
    "code": "G50.1",
    "name": "Atypische Prosopalgie",
    "synonyms": [
      "Atypische Gesichtsschmerzen",
      "Atypische Prosopalgie",
      "Atypischer Tic douloureux",
      "Persistierender idiopathischer Gesichtsschmerz"
    ]
  },
  {
    "code": "G50.8",
    "name": "Trigeminus-Lähmung",
    "synonyms": [
      "Angeborener Ausfall des Nervus trigeminus",
      "Aurikulotemporales Syndrom",
      "Frey-Syndrom",
      "Morbus Frey",
      "Neuritis des Nervus ophthalmicus",
      "Ophthalmikusneuritis",
      "Schädigung des Gasser-Ganglions",
      "Trigeminus-Lähmung",
      "Trigeminusneuritis"
    ]
  },
  {
    "code": "G50.9",
    "name": "Krankheit des Nervus trigeminus",
    "synonyms": [
      "Affektion des Nervus trigeminus",
      "Krankheit des Nervus trigeminus",
      "Störung des Hirnnerven V",
      "Störung des Nervus trigeminus",
      "Trigeminusaffektion"
    ]
  },
  {
    "code": "G51.0",
    "name": "Fazialisparese",
    "synonyms": [
      "Bell-Fazialisparese",
      "Bell-Lähmung",
      "Bell-Paralyse",
      "Bell-Syndrom",
      "Familiäre rezidivierende periphere Fazialisparese",
      "Fazialislähmung",
      "Fazialislähmung durch Läsion des unteren Motoneurons",
      "Fazialisparese",
      "Fazialisparese durch Läsion des unteren Motoneurons",
      "Fazialisschwäche durch Läsion des unteren Motoneurons",
      "Fazioplegie",
      "Gesichtslähmung",
      "Gesichtsnervenparalyse",
      "Gesichtsparese",
      "Idiopathische Gesichtslähmung",
      "Lähmung des Hirnnerven VII",
      "Paralyse des Nervus facialis",
      "Parese des Nervus facialis",
      "Periphere Fazialisparese",
      "Prosopodiplegie",
      "Prosopoplegie"
    ]
  },
  {
    "code": "G51.1",
    "name": "Entzündung des Ganglion geniculi",
    "synonyms": [
      "Entzündung des Ganglion geniculi",
      "Ganglion-geniculi-Neuralgie",
      "Ganglionitis geniculata",
      "Neuralgia facialis vera",
      "Neuritis des Ganglion geniculi"
    ]
  },
  {
    "code": "G51.2",
    "name": "Melkersson-Rosenthal-Syndrom",
    "synonyms": [
      "Melkersson-Rosenthal-Syndrom"
    ]
  },
  {
    "code": "G51.3",
    "name": "Spasmus hemifacialis",
    "synonyms": [
      "Bell-Spasmus",
      "Fazialer Hemispasmus",
      "Fazialisspasmus",
      "Fokale Myoklonie des Gesichts",
      "Hemispasmus facialis",
      "Klonischer Hemispasmus facialis",
      "Klonischer Spasmus hemifacialis",
      "Myoklonus facialis",
      "Spasmus facialis",
      "Spasmus hemifacialis"
    ]
  },
  {
    "code": "G51.4",
    "name": "Faziale Myokymie",
    "synonyms": [
      "Faziale Myokymie",
      "Isolierte faziale Myokymie"
    ]
  },
  {
    "code": "G51.8",
    "name": "Degeneration des Nervus facialis",
    "synonyms": [
      "Atrophie des Nervus facialis",
      "Degeneration des Nervus facialis",
      "Entzündung des Nervus facialis",
      "Fazialisatrophie",
      "Fazialisdegeneration",
      "Fazialisentzündung",
      "Fazialisneuralgie",
      "Fazialisneuritis",
      "Hemiatrophia facialis progressiva",
      "Hemifaziale Romberg-Atrophie",
      "Neuritis des Hirnnerven VII",
      "Neuritis des Nervus facialis",
      "Paraspasmus facialis",
      "Parry-Romberg-Syndrom",
      "Romberg-Syndrom",
      "Schädigung der Chorda tympani",
      "Von-Romberg-Krankheit"
    ]
  },
  {
    "code": "G51.9",
    "name": "Fazialisstörung",
    "synonyms": [
      "Affektion des Nervus facialis",
      "Fazialisaffektion",
      "Fazialiskrankheit",
      "Fazialisstörung",
      "Krankheit des Nervus facialis",
      "Neuropathie des Nervus facialis",
      "Störung des Hirnnerven VII a.n.k.",
      "Störung des Nervus facialis"
    ]
  },
  {
    "code": "G52.0",
    "name": "Krankheit der Nervi olfactorii",
    "synonyms": [
      "Affektion der Nervi olfactorii",
      "Krankheit der Nervi olfactorii",
      "Neuritis der Nervi olfactorii",
      "Olfaktoriusaffektion",
      "Olfaktoriuskrankheit",
      "Störung der Nervi olfactorii",
      "Störung des Hirnnerven I"
    ]
  },
  {
    "code": "G52.1",
    "name": "Krankheit des Nervus glossopharyngeus",
    "synonyms": [
      "Glossopharyngeuskrankheit",
      "Glossopharyngeusneuralgie",
      "Krankheit des Nervus glossopharyngeus",
      "Neuralgie des Nervus glossopharyngeus",
      "Paralyse des Nervus glossopharyngeus",
      "Sicard-Syndrom",
      "Störung des Hirnnerven IX",
      "Störung des Nervus glossopharyngeus a.n.k."
    ]
  },
  {
    "code": "G52.2",
    "name": "Krankheit des Nervus vagus",
    "synonyms": [
      "Affektion des Hirnnerven X",
      "Affektion des Nervus vagus",
      "Kompression des Nervus laryngeus recurrens",
      "Krankheit des Nervus vagus",
      "Laryngeusneuralgie",
      "Neuralgie des Nervus laryngeus",
      "Schädigung des Nervus laryngeus recurrens",
      "Störung des Hirnnerven X",
      "Störung des Nervus laryngeus recurrens",
      "Störung des Nervus pneumogastricus",
      "Störung des Nervus recurrens",
      "Störung des Nervus vagus",
      "Vagotonie",
      "Vagusaffektion",
      "Vaguskrankheit",
      "Vaguslähmung"
    ]
  },
  {
    "code": "G52.3",
    "name": "Krankheit des Nervus hypoglossus",
    "synonyms": [
      "Affektion des Nervus hypoglossus",
      "Hypoglossusaffektion",
      "Hypoglossuskrankheit",
      "Hypoglossuslähmung",
      "Hypoglossusneuralgie",
      "Hypoglossusparese",
      "Krankheit des Nervus hypoglossus",
      "Parese des Nervus hypoglossus",
      "Störung des Hirnnerven XII",
      "Störung des Nervus hypoglossus"
    ]
  },
  {
    "code": "G52.7",
    "name": "Tapia-Syndrom",
    "synonyms": [
      "Collet-Sicard-Syndrom",
      "Foramen-jugulare-Syndrom",
      "Multiple Hirnnervenparalysen",
      "Multiple Hirnnervenparesen",
      "Polyneuritis cranialis",
      "Polyneuropathia cranialis",
      "Syndrom der kombinierten hyperaktiven Dysfunktion der kranialen Nerven",
      "Tapia-Syndrom",
      "Vago-hypoglossal-Syndrom",
      "Vernet-Syndrom",
      "Villaret-Syndrom"
    ]
  },
  {
    "code": "G52.8",
    "name": "Affektion des Nervus accessorius",
    "synonyms": [
      "Affektion des Nervus accessorius",
      "Akzessoriusaffektion",
      "Akzessoriusparese",
      "Paralyse des Musculus sternocleidomastoideus",
      "Paralyse des Musculus trapezius",
      "Störung des Hirnnerven XI",
      "Störung des Nervus accessorius"
    ]
  },
  {
    "code": "G52.9",
    "name": "Atrophie eines Hirnnerven",
    "synonyms": [
      "Atrophie eines Hirnnerven",
      "Degeneration eines Hirnnerven",
      "Hirnnervenkrankheit",
      "Hirnnervenstörung",
      "Lähmung eines Hirnnerven"
    ]
  },
  {
    "code": "G54.0",
    "name": "Skalenussyndrom",
    "synonyms": [
      "Armplexuslähmung",
      "Armplexusparese",
      "Axilläre Paralyse",
      "Brachialplexuskompression",
      "Brachialplexusläsion",
      "Brachialplexusneuropathie",
      "Brachialplexusparalyse a.n.k.",
      "Brachialplexusreizung",
      "Brachialplexusschädigung",
      "Brachialplexusstörung",
      "Brachialplexussyndrom",
      "Cervicothoracic-outlet-Syndrom",
      "Druck auf den Plexus brachialis",
      "Hyperabduktions-Syndrom",
      "Kosto-Klavikular-Syndrom",
      "Läsion des Plexus brachialis",
      "Naffziger-Syndrom",
      "Parese des Plexus brachialis",
      "Pectoralis-major-Syndrom",
      "Scalenus-anterior-Syndrom",
      "Schultergürtel-Kompressionssyndrom",
      "Skalenussyndrom",
      "Subkorakoid-Pectoralis-minor-Syndrom",
      "TOS [Thoracic-outlet-Syndrom]",
      "Thoracic-outlet-Syndrom",
      "Wright-Syndrom"
    ]
  },
  {
    "code": "G54.1",
    "name": "Läsion des Lumbosakralplexus",
    "synonyms": [
      "Druck auf den Plexus lumbosacralis",
      "Glutäusparalyse",
      "Kompression des Lumbosakralplexus",
      "Lumbalplexusneuropathie",
      "Läsion des Lumbosakralplexus",
      "Reizung des Lumbosakralplexus",
      "Sakralplexusneuropathie",
      "Schädigung des Lumbosakralplexus",
      "Störung des Lumbosakralplexus"
    ]
  },
  {
    "code": "G54.2",
    "name": "Zervikale Wurzelläsion",
    "synonyms": [
      "Zervikale Nervenwurzelschädigung a.n.k.",
      "Zervikale Wurzelläsion",
      "Zervikale Wurzelstörung a.n.k."
    ]
  },
  {
    "code": "G54.3",
    "name": "Thorakale Wurzelläsion",
    "synonyms": [
      "Thorakale Nervenwurzelschädigung a.n.k.",
      "Thorakale Wurzelläsion"
    ]
  },
  {
    "code": "G54.4",
    "name": "Lumbosakrale Wurzelläsion",
    "synonyms": [
      "Lumbosakrale Wurzelläsion",
      "Lumbosakrale Wurzelschädigung a.n.k.",
      "Lumbosakrale Wurzelstörung a.n.k."
    ]
  },
  {
    "code": "G54.5",
    "name": "Neuralgische Amyotrophie",
    "synonyms": [
      "Neuralgische Amyotrophie",
      "Parsonage-Aldren-Turner-Syndrom",
      "Parsonage-Turner-Syndrom [Neuralgische Schulteramyotrophie]",
      "Schultergürtel-Syndrom",
      "Schultergürtelneuritis"
    ]
  },
  {
    "code": "G54.6",
    "name": "Phantomschmerzen",
    "synonyms": [
      "Phantomschmerzen"
    ]
  },
  {
    "code": "G54.7",
    "name": "Phantomglied ohne Schmerzen",
    "synonyms": [
      "Phantom-Glieder-Syndrom",
      "Phantom-Syndrom",
      "Phantomglied",
      "Phantomglied ohne Schmerzen"
    ]
  },
  {
    "code": "G54.8",
    "name": "Perineuralzyste",
    "synonyms": [
      "Perineuralzyste"
    ]
  },
  {
    "code": "G54.9",
    "name": "Nervenwurzelaffektion",
    "synonyms": [
      "Nervenplexuskompression a.n.k.",
      "Nervenwurzelaffektion",
      "Nervenwurzelkompression a.n.k.",
      "Nervenwurzelstörung",
      "Plexusaffektion",
      "Plexusläsion",
      "Plexusneuralgie",
      "Plexusneuritis",
      "Plexusstörung"
    ]
  },
  {
    "code": "G56.0",
    "name": "Brachialgia paraesthetica nocturna",
    "synonyms": [
      "Brachialgia paraesthetica nocturna",
      "KTS [Karpaltunnelsyndrom]",
      "Karpaltunnelsyndrom",
      "Kompression des Nervus medianus",
      "Neuropathie bei Engpass des Nervus medianus"
    ]
  },
  {
    "code": "G56.1",
    "name": "Medianuslähmung",
    "synonyms": [
      "Medianuslähmung",
      "Mononeuritis des Nervus medianus",
      "Spätparalyse des Nervus medianus",
      "Störung des Nervus medianus a.n.k."
    ]
  },
  {
    "code": "G56.2",
    "name": "Läsion des Nervus ulnaris",
    "synonyms": [
      "Kompression des Nervus ulnaris",
      "Läsion des Nervus ulnaris",
      "Mononeuritis des Nervus ulnaris",
      "Nervus-ulnaris-Syndrom",
      "Neuritis des Nervus ulnaris",
      "Neuropathie bei Engpass des Nervus ulnaris",
      "Nichttraumatische Verschiebung des Nervus ulnaris",
      "Nichttraumatisches Gleiten des Nervus ulnaris",
      "Parese des Nervus ulnaris",
      "Reizung des Nervus ulnaris",
      "Spätlähmung des Nervus ulnaris",
      "Spätparalyse des Nervus ulnaris",
      "Spätparese des Nervus ulnaris",
      "Störung des Nervus ulnaris",
      "Sulcus-ulnaris-Syndrom",
      "Ulnarislähmung",
      "Ulnarisläsion",
      "Ulnarisneuritis",
      "Ulnarisparese",
      "Ulnarisreizung",
      "Ulnarisrinnensyndrom",
      "Ulnarisspätparese"
    ]
  },
  {
    "code": "G56.3",
    "name": "Läsion des Nervus radialis",
    "synonyms": [
      "Läsion des Nervus radialis",
      "Mononeuritis des Nervus radialis",
      "Neuritis des Nervus radialis",
      "Paralyse des Nervus radialis",
      "Parese des Nervus radialis",
      "Radialisläsion",
      "Radialisneuritis",
      "Radialisparese",
      "Schädigung des Nervus radialis",
      "Störung des Nervus radialis",
      "Supinatorlogensyndrom",
      "Supinatorsyndrom"
    ]
  },
  {
    "code": "G56.8",
    "name": "Serratus-Syndrom",
    "synonyms": [
      "Axillarisläsion",
      "Interdigitales Neurom der Hände",
      "Interdigitales Pseudoneurom der Hände",
      "Läsion des Nervus axillaris",
      "Serratus-Syndrom"
    ]
  },
  {
    "code": "G56.9",
    "name": "Mononeuropathie der oberen Gliedmaßen",
    "synonyms": [
      "Mononeuritis der oberen Gliedmaßen",
      "Mononeuropathie der oberen Gliedmaßen",
      "Nervenstörung der oberen Extremität",
      "Periphere Nervenschädigung des Arms"
    ]
  },
  {
    "code": "G57.0",
    "name": "Läsion des Nervus ischiadicus",
    "synonyms": [
      "Adhäsion des Ischiasnerven",
      "Ischiadikusläsion",
      "Kompression des Nervus ischiadicus",
      "Läsion des Nervus ischiadicus",
      "Mononeuritis des Nervus ischiadicus",
      "Neuropathie des Nervus ischiadicus",
      "Schädigung des Nervus ischiadicus",
      "Störung des Nervus ischiadicus a.n.k."
    ]
  },
  {
    "code": "G57.1",
    "name": "Meralgia paraesthetica",
    "synonyms": [
      "Bernhard-Roth-Krankheit",
      "Bernhardt-Parästhesie",
      "Inguinaltunnel-Syndrom",
      "Meralgia paraesthetica",
      "Meralgie",
      "Mononeuritis des Nervus cutaneus femoris lateralis",
      "Neuralgische Schmerzen des Oberschenkels",
      "Neuropathie bei Engpass des Nervus cutaneus femoris lateralis",
      "Reizung des Nervus cutaneus femoris",
      "Roth-Bernhardt-Syndrom",
      "Störung des Nervus cutaneus femoris lateralis"
    ]
  },
  {
    "code": "G57.2",
    "name": "Läsion des Nervus femoralis",
    "synonyms": [
      "Femoralisläsion",
      "Femoralisneuralgie",
      "Femoralisneuritis",
      "Kompressionssyndrom des Nervus femoralis",
      "Läsion des Nervus femoralis",
      "Mononeuritis des Nervus femoralis",
      "Neuritis des Nervus femoralis",
      "Störung des Nervus femoralis"
    ]
  },
  {
    "code": "G57.3",
    "name": "Läsion des Nervus fibularis communis",
    "synonyms": [
      "Fußheberparese",
      "Lähmung des Nervus peronaeus",
      "Läsion des Nervus fibularis communis",
      "Läsion des Nervus peronaeus communis",
      "Mononeuritis des Nervus peronaeus communis",
      "Neuropathie bei Engpass des Nervus peronaeus",
      "Paralyse des Nervus peronaeus",
      "Parese des Nervus peronaeus",
      "Peronäusparese",
      "Störung des Nervus peronaeus communis"
    ]
  },
  {
    "code": "G57.4",
    "name": "Läsion des Nervus tibialis",
    "synonyms": [
      "Läsion des Nervus tibialis",
      "Mononeuritis des Nervus popliteus medialis",
      "Mononeuritis des Nervus tibialis",
      "Störung des Nervus tibialis",
      "Tibialisläsion"
    ]
  },
  {
    "code": "G57.5",
    "name": "Tarsaltunnelsyndrom",
    "synonyms": [
      "Kompression des Nervus tibialis posterior",
      "Neuropathie bei Engpass des Nervus tibialis posterior",
      "Tarsaltunnelsyndrom"
    ]
  },
  {
    "code": "G57.6",
    "name": "Läsion des Nervus plantaris",
    "synonyms": [
      "Läsion des Nervus plantaris",
      "Mononeuritis des Nervus plantaris",
      "Morton-Krankheit",
      "Morton-Metatarsalgie",
      "Morton-Neuralgie",
      "Morton-Neurom",
      "Morton-Syndrom",
      "Morton-Vorfußneuralgie",
      "Plantarisläsion"
    ]
  },
  {
    "code": "G57.8",
    "name": "Genitofemoralissyndrom",
    "synonyms": [
      "Genitofemoralissyndrom",
      "Howship-von-Romberg-Syndrom",
      "Interdigitales Neurom der Füße",
      "Interdigitales Pseudoneurom der Füße",
      "Intermetatarsales Neurom a.n.k."
    ]
  },
  {
    "code": "G57.9",
    "name": "Mononeuropathie der unteren Gliedmaßen",
    "synonyms": [
      "Mononeuritis der unteren Gliedmaßen",
      "Mononeuropathie der unteren Gliedmaßen",
      "Nervenstörung der unteren Extremität",
      "Periphere Nervenschädigung des Beins"
    ]
  },
  {
    "code": "G58.0",
    "name": "Interkostalneuralgie",
    "synonyms": [
      "Interkostalneuralgie",
      "Interkostalneuropathie",
      "Nichttumorbedingte Interkostalneuropathie",
      "Rectus abdominis-Syndrom",
      "Störung eines Interkostalnerven"
    ]
  },
  {
    "code": "G58.7",
    "name": "Mononeuritis multiplex",
    "synonyms": [
      "Mononeuritis multiplex",
      "Mononeuropathia multiplex",
      "Multiple Nervenstörung"
    ]
  },
  {
    "code": "G58.8",
    "name": "Interdigitalisneuralgie",
    "synonyms": [
      "Ilioinguinalissyndrom",
      "Interdigitales Neurom",
      "Interdigitalisneuralgie",
      "Neuralgie des Funiculus spermaticus",
      "Neuritis des Nervus occipitalis",
      "Okzipitalisneuritis",
      "Okzipitalneuralgie",
      "Pudendusneuralgie",
      "Samenstrangneuralgie",
      "Spermatikusneuralgie",
      "Störung des Nervus phrenicus"
    ]
  },
  {
    "code": "G58.9",
    "name": "Mononeuritis",
    "synonyms": [
      "Atrophie eines peripheren Nerven",
      "Atrophische Paralyse",
      "Endoperineuritis",
      "Engpass-Syndrom",
      "Irritation eines peripheren Nerven",
      "Kompression eines peripheren Nerven",
      "Läsion eines peripheren Nerven",
      "Mononeuritis",
      "Mononeuropathie",
      "Muskelparalyse bei Nervenschädigung a.n.k.",
      "Nervenkompression",
      "Nervenparalyse",
      "Nervenschädigung",
      "Nervenstörung",
      "Neuronitis",
      "Neuropathie bei Engpass",
      "Periphere Nervenparese",
      "Reizung eines peripheren Nerven",
      "Sensible Störung einzelner peripherer Nerven",
      "Sensible Störung einzelner peripherer Nervenwurzeln",
      "Unklare Nervenaffektion"
    ]
  },
  {
    "code": "G60.0",
    "name": "Hereditäre sensomotorische Neuropathie, Typ I-IV",
    "synonyms": [
      "ARAN-NM [autosomal-rezessive axonale Neuropathie mit Neuromyotonie]",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2 durch ATP1A1-Genmutation",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2 durch DGAT2-Genmutation",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2 durch KIF5A-Genmutation",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2 durch MME-Genmutation",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2 durch TFG-Genmutation",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2 mit Riesen-Axonen",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2A1",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2A2",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2B",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2C",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2D",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2E",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2F",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2I",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2J",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2K",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2L",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2M",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2N",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2O",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2P",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2Q",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2U",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2V",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2W",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2Y",
      "Autosomal-dominante Charcot-Marie-Tooth-Krankheit Typ 2Z",
      "Autosomal-rezessive Charcot-Marie-Tooth-Krankheit Typ 2 durch SPG11-Genmutation",
      "Autosomal-rezessive Charcot-Marie-Tooth-Krankheit Typ Ouvrier",
      "Autosomal-rezessive axonale Charcot-Marie-Tooth-Krankheit durch Kupferstoffwechseldefekt",
      "Autosomal-rezessive axonale Charcot-Marie-Tooth-Krankheit mit Akrodystrophie",
      "Autosomal-rezessive intermediäre Charcot-Marie-Tooth-Krankheit Typ A",
      "Autosomal-rezessive intermediäre Charcot-Marie-Tooth-Krankheit Typ B",
      "Autosomal-rezessive intermediäre Charcot-Marie-Tooth-Krankheit Typ C",
      "Autosomal-rezessive intermediäre Charcot-Marie-Tooth-Krankheit Typ D",
      "Axonaler Typ der peronäalen Muskelatrophie",
      "Charcot-Marie-Krankheit",
      "Charcot-Marie-Muskelatrophie",
      "Charcot-Marie-Tooth Krankheit Typ 2T",
      "Charcot-Marie-Tooth-Atrophie",
      "Charcot-Marie-Tooth-Hoffmann-Syndrom",
      "Charcot-Marie-Tooth-Krankheit",
      "Charcot-Marie-Tooth-Krankheit Typ 1A",
      "Charcot-Marie-Tooth-Krankheit Typ 1B",
      "Charcot-Marie-Tooth-Krankheit Typ 1C",
      "Charcot-Marie-Tooth-Krankheit Typ 1D",
      "Charcot-Marie-Tooth-Krankheit Typ 1E",
      "Charcot-Marie-Tooth-Krankheit Typ 1F",
      "Charcot-Marie-Tooth-Krankheit Typ 2B1",
      "Charcot-Marie-Tooth-Krankheit Typ 2B2",
      "Charcot-Marie-Tooth-Krankheit Typ 2H",
      "Charcot-Marie-Tooth-Krankheit Typ 2R",
      "Charcot-Marie-Tooth-Krankheit Typ 2S",
      "Charcot-Marie-Tooth-Krankheit Typ 3",
      "Charcot-Marie-Tooth-Krankheit Typ 4A",
      "Charcot-Marie-Tooth-Krankheit Typ 4B1",
      "Charcot-Marie-Tooth-Krankheit Typ 4B2",
      "Charcot-Marie-Tooth-Krankheit Typ 4B3",
      "Charcot-Marie-Tooth-Krankheit Typ 4C",
      "Charcot-Marie-Tooth-Krankheit Typ 4C4",
      "Charcot-Marie-Tooth-Krankheit Typ 4D",
      "Charcot-Marie-Tooth-Krankheit Typ 4E",
      "Charcot-Marie-Tooth-Krankheit Typ 4F",
      "Charcot-Marie-Tooth-Krankheit Typ 4G",
      "Charcot-Marie-Tooth-Krankheit Typ 4H",
      "Charcot-Marie-Tooth-Krankheit Typ 4J",
      "Charcot-Marie-Tooth-Krankheit Typ 4K",
      "Charcot-Marie-Tooth-Krankheit Typ 6",
      "Charcot-Marie-Tooth-Krankheit mit Schwerhörigkeit und Intelligenzminderung",
      "Charcot-Marie-Tooth-Paralyse",
      "DNAJB2-abhängige Charcot-Marie-Tooth-Krankheit Typ 2",
      "Dominant-intermediäre Charcot-Marie-Tooth-Krankheit Typ A",
      "Dominant-intermediäre Charcot-Marie-Tooth-Krankheit Typ B",
      "Dominant-intermediäre Charcot-Marie-Tooth-Krankheit Typ C",
      "Dominant-intermediäre Charcot-Marie-Tooth-Krankheit Typ D",
      "Dominant-intermediäre Charcot-Marie-Tooth-Krankheit Typ E",
      "Dominant-intermediäre C"
    ]
  },
  {
    "code": "G60.1",
    "name": "Refsum-Syndrom",
    "synonyms": [
      "Heredopathia atactica polyneuritiformis",
      "Heredopathia hemeraloptica polyneuritiformis",
      "IRD [Infantile Refsum-Krankheit]",
      "Infantile Form der Refsum-Krankheit",
      "Infantiles Refsum-Syndrom",
      "Periphere Neuropathie Typ Fiskerstrand",
      "Phytansäure-Oxidase-Mangel",
      "Refsum-Krankheit",
      "Refsum-Syndrom"
    ]
  },
  {
    "code": "G60.2",
    "name": "Neuropathie mit hereditärer Ataxie",
    "synonyms": [
      "AOA2 [Ataxie mit okulomotorischer Apraxie Typ 2]",
      "Neuropathie in Verbindung mit hereditärer Ataxie",
      "Neuropathie mit hereditärer Ataxie",
      "Spinozerebelläre Ataxie mit axonaler Neuropathie Typ 1"
    ]
  },
  {
    "code": "G60.3",
    "name": "Idiopathische progressive Neuropathie",
    "synonyms": [
      "Idiopathische periphere progressive Parese",
      "Idiopathische progressive Neuropathie",
      "Idiopathische progressive Polyneuropathie"
    ]
  },
  {
    "code": "G60.8",
    "name": "Hereditäre sensorische Neuropathie",
    "synonyms": [
      "Dominant vererbte sensible Neuropathie",
      "HSAN1 [Hereditäre sensorische und autonome Neuropathie Typ 1]",
      "HSAN1B [Hereditäre sensorische und autonome Neuropathie Typ 1B]",
      "HSAN2 [Hereditäre sensorische und autonome Neuropathie Typ 2]",
      "HSAN4 [Hereditäre sensorische und autonome Neuropathie Typ 4]",
      "HSAN5 [Hereditäre sensorische und autonome Neuropathie Typ 5]",
      "HSAN6 [Hereditäre sensorische und autonome Neuropathie Typ 6]",
      "HSAN7 [Hereditäre sensorische und autonome Neuropathie Typ 7]",
      "HSAN8 [Hereditäre sensorische und autonome Neuropathie Typ 8]",
      "HSN [Hereditäre sensorische Neuropathie] Typ 1E",
      "Hereditäre sensorische Neuropathie",
      "Hereditäre sensorische Polyneuropathie",
      "Hereditäre sensorische radikuläre Neuropathie",
      "Hereditäre sensorische und autonome Neuropathie Typ 1",
      "Hereditäre sensorische und autonome Neuropathie Typ 1B",
      "Hereditäre sensorische und autonome Neuropathie Typ 2",
      "Hereditäre sensorische und autonome Neuropathie Typ 4",
      "Hereditäre sensorische und autonome Neuropathie Typ 5",
      "Hereditäre sensorische und autonome Neuropathie Typ 6",
      "Hereditäre sensorische und autonome Neuropathie Typ 7",
      "Hereditäre sensorische und autonome Neuropathie Typ 8",
      "Limbische Enzephalitis mit Neuromyotonie, Hyperhidrose und Polyneuropathie",
      "Morvan-Krankheit",
      "Morvan-Syndrom",
      "Natrium-Kanalopathie-bedingte Small-fiber-Neuropathie",
      "Nelaton-Syndrom",
      "Neuropathie mit Schwerhörigkeit",
      "Rezessiv vererbte sensible Neuropathie",
      "Riesenaxon-Neuropathie"
    ]
  },
  {
    "code": "G60.9",
    "name": "Idiopathische periphere Neuropathie",
    "synonyms": [
      "Hereditäre Neuropathie",
      "Hereditäre Polyneuropathie",
      "Hereditäre periphere Neuropathie",
      "Idiopathische Neuropathie",
      "Idiopathische periphere Neuropathie",
      "Trophoneurose a.n.k."
    ]
  },
  {
    "code": "G61.0",
    "name": "Akute infektiöse Polyneuritis",
    "synonyms": [
      "Akute Enzephalomyeloradikulitis",
      "Akute Pandysautonomie",
      "Akute Polyradikuloneuritis",
      "Akute aufsteigende Spinalparalyse",
      "Akute fieberhafte Polyneuritis",
      "Akute infektiöse Polyneuritis",
      "Akute inflammatorische demyelinisierende Polyradikuloneuropathie",
      "Akute motorisch-sensorische axonale Neuropathie",
      "Akute motorische axonale Neuropathie",
      "Akute postinfektiöse Polyneuritis",
      "Akute sensorisch-ataktische Neuropathie",
      "Aszendierende Neuromyelitis",
      "Barré-Guillain-Krankheit",
      "Bickerstaff-Enzephalitis",
      "Enzephalomyeloradikulitis",
      "Fisher-Syndrom",
      "GBS [Guillain-Barré-Syndrom]",
      "Guillain-Barré-Polyradikulitis",
      "Guillain-Barré-Strohl-Syndrom",
      "Guillain-Barré-Syndrom",
      "Infektiöse multiple Neuritis a.n.k.",
      "Kraniale Variante des GBS [Guillain-Barré-Syndrom]",
      "Kraniale Variante des Guillain-Barré-Syndroms",
      "Kussmaul-Landry-Lähmung",
      "Landry-Guillain-Barré-Paralyse",
      "Landry-Guillain-Barré-Syndrom",
      "Landry-Paralyse",
      "Miller-Fisher-Syndrom",
      "Paralysis spinalis ascendens acuta",
      "Paraparetische Variante des Guillain-Barré-Syndroms",
      "Pharyngeal-zervikal-brachiale Variante des Guillain-Barré-Syndroms",
      "Polyradikuloneuritis",
      "Postinfektiöse Polyradikuloneuritis"
    ]
  },
  {
    "code": "G61.1",
    "name": "Serumpolyneuropathie",
    "synonyms": [
      "Serumneuritis",
      "Serumneuropathie",
      "Serumpolyneuropathie"
    ]
  },
  {
    "code": "G61.8",
    "name": "Chronische inflammatorische demyelinisierende Polyneuropathie",
    "synonyms": [
      "CANOMAD [Chronische ataktische Polyneuropathie, Ophthalmoplegie, monoklonales IgM-Protein, Kälteagglutinin, Disialosyl-Antikörper]-Syndrom",
      "CIDP [Chronische inflammatorische demyelinisierende Polyneuropathie]",
      "Chronische inflammatorische demyelinisierende Polyneuropathie",
      "Lewis-Sumner-Syndrom",
      "MMN [Multifokale motorische Neuropathie]",
      "Multifokale motorische Neuropathie",
      "NSVN [Nichtsystemische vaskulitische Neuropathie]",
      "Nichtsystemische vaskulitische Neuropathie",
      "Subakute inflammatorische demyelinisierende Polyneuropathie"
    ]
  },
  {
    "code": "G61.9",
    "name": "Polyneuritis",
    "synonyms": [
      "Periphere symmetrische Polyneuritis",
      "Polyneuritis",
      "Polyradikulitis"
    ]
  },
  {
    "code": "G62.0",
    "name": "Arzneimittelinduzierte Polyneuropathie",
    "synonyms": [
      "Arzneimittelinduzierte Polyneuropathie",
      "Polyneuropathie durch Arzneimittel",
      "Polyneuropathie durch Drogen",
      "Polyneuropathie durch Medikamente"
    ]
  },
  {
    "code": "G62.1",
    "name": "Alkoholpolyneuropathie",
    "synonyms": [
      "Alkoholische Polyneuropathie",
      "Alkoholpolyneuropathie"
    ]
  },
  {
    "code": "G62.2",
    "name": "Neuropathie durch Schnüffeln von Klebstoffen",
    "synonyms": [
      "Bleineuritis",
      "Bleipolyneuritis",
      "Bleipolyneuropathie",
      "Ingwer-Neuropathie",
      "Ingwer-Paralyse",
      "Jamaika-Neuropathie",
      "Jamaika-Paralyse",
      "Neuropathie durch Schnüffeln von Klebstoffen",
      "Polyneuropathie durch Arsen",
      "Polyneuropathie durch Organophosphate",
      "Polyneuropathie durch Triorthokresylphosphat",
      "Polyneuropathie durch toxische Agenzien a.n.k.",
      "Toxische Neuritis a.n.k.",
      "Toxische Neuropathie a.n.k."
    ]
  },
  {
    "code": "G62.80",
    "name": "Critical-illness-Polyneuropathie",
    "synonyms": [
      "Critical-illness-Polyneuropathie"
    ]
  },
  {
    "code": "G62.88",
    "name": "Aktinoneuritis",
    "synonyms": [
      "Aktinoneuritis",
      "Chronisch-rezidivierende demyelinisierende Neuropathie",
      "Chronische progressive segmentäre demyelinisierende Neuropathie",
      "Demyelinisierende Krankheit des peripheren Nervensystems",
      "Motorische und sensorische Neuropathie",
      "Polyneuropathie durch Strahlung",
      "Strahlungsinduzierte Polyneuropathie"
    ]
  },
  {
    "code": "G62.9",
    "name": "Periphere Neuritis",
    "synonyms": [
      "Akute multiple Neuropathien",
      "Chronische multiple Neuropathien",
      "Multiple Neuritis",
      "Neuropathia peripherica",
      "Neuropathie",
      "Neuropathie beim Kind",
      "Neuropathie peripherer Nerven",
      "Neuropathische Beschwerden",
      "Periphere Neuritis",
      "Periphere Polyneuropathie",
      "Polyneuropathie"
    ]
  },
  {
    "code": "G64",
    "name": "Störung des peripheren Nervensystems a.n.k.",
    "synonyms": [
      "Krankheit des peripheren Nervensystems",
      "Störung des peripheren Nervensystems a.n.k."
    ]
  },
  {
    "code": "G70.0",
    "name": "Myasthenia gravis",
    "synonyms": [
      "Autoimmune Myasthenia gravis",
      "Erb-Goldflam-Syndrom",
      "Erb-Oppenheim-Goldflam-Syndrom",
      "Goldflam-Erb-Krankheit",
      "Juvenile Myasthenia gravis",
      "Myasthenia gravis",
      "Myasthenia gravis pseudoparalytica",
      "Myasthenia pseudoparalytica",
      "Myasthenieptose",
      "Myasthenische Bulbärparalyse"
    ]
  },
  {
    "code": "G70.1",
    "name": "Neuromuskuläre toxische Krankheit",
    "synonyms": [
      "Myoneurale Störung durch Blei",
      "Neuromuskuläre toxische Affektion",
      "Neuromuskuläre toxische Krankheit",
      "Neuromuskuläre toxische Störung",
      "Toxische myoneurale Störung"
    ]
  },
  {
    "code": "G70.2",
    "name": "Oppenheim-Krankheit",
    "synonyms": [
      "Amyotonia congenita",
      "Entwicklungsbedingte Myasthenie",
      "Kongenitale Myasthenie",
      "Kongenitales myasthenes Syndrom",
      "Oppenheim-Krankheit"
    ]
  },
  {
    "code": "G70.8",
    "name": "Myatonie",
    "synonyms": [
      "Lambert-Eaton-Syndrom, nicht bei Neubildung",
      "Myatonia congenita",
      "Myatonie"
    ]
  },
  {
    "code": "G70.9",
    "name": "Krankhafte Muskelschwäche",
    "synonyms": [
      "Krankhafte Muskelermüdbarkeit",
      "Krankhafte Muskelschwäche",
      "Krankheit des neuromuskulären Systems",
      "Myasthenia",
      "Myasthenische Krise",
      "Myasthenisches Syndrom",
      "Myoneurale Krankheit",
      "Myoneurale Störung",
      "Neuromuskuläre Affektion",
      "Neuromuskuläre Erregungsstörung",
      "Neuromuskuläre Störung",
      "Neuromyopathie"
    ]
  },
  {
    "code": "G71.0",
    "name": "Muskeldystrophie",
    "synonyms": [
      "ADSSL1-abhängige distale Myopathie",
      "Alpha-B-Crystallin-abhängige spät-beginnende distale Myopathie",
      "Alpha-Sarkoglykanopathie",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1A",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1B",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1C",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1D",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1E",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1F",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1G",
      "Autosomal-dominante Gliedergürtelmuskeldystrophie Typ 1H",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2A",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2B",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2C",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2D",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2E",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2F",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2G",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2H",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2I",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2J",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2K",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2L",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2M",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2N",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2O",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2P",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2Q",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2R",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2S",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2T",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2U",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2W",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2X",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2Y",
      "Autosomal-rezessive Gliedergürtelmuskeldystrophie Typ 2Z",
      "Beckengürtelmyopathie",
      "Becker-Dystrophie",
      "Becker-Krankheit",
      "Benigne Muskeldystrophie (Typ Becker)",
      "Benigne skapuloperonäale Muskeldystrophie mit Frühkontrakturen (Typ Emery-Dreifuss)",
      "Beta-Sarkoglykanopathie",
      "Bethlem-Myopathie",
      "Calpain 3-assoziierte Gliedergürtelmuskeldystrophie D4",
      "DMD [Duchenne-Muskeldystrophie]",
      "Delta-Sarkoglykanopathie",
      "Distale Anoctaminopathie",
      "Distale Muskeldystrophie",
      "Distale Myopathie",
      "Distale Myopathie der oberen Extremitäten mit Beginn im Erwachsenenalter vom Finnischen Typ",
      "Distale Myopathie durch VCP-Genmutation mit Beginn im Erwachsenenalter",
      "Distale Myopathie mit Beginn am vorderen Schienenbein",
      "Distale Myopathie mit Beteiligung der posterioren Beinmuskulatur und anterioren Handmuskulatur",
      "Distale Myopathie mit Stimmbandschwäche",
      "Distale Myopathie mit früher Beteiligung der Atemmuskulatur",
      "Distale Myopathie vom Typ Laing",
      "Distale Myopathie vom Typ Tateyama",
      "Distale Myopathie vom Typ Welander",
      "Distale Myotilinopathie",
      "Duchenne-Griesinger-Krankheit",
      "Duchenne-Muskeldystrophie",
      "Duchenne-Paralyse bei Muskeldystrophie",
      "Duchenne-von-Leyden-Syndrom",
      "Dystrophinopathie vom Typ Becker",
      "Dystrophinopathie vom Typ Duchenne",
      "EDMD [Emery-Dreifuss Muskeldystrophie]",
      "EDMD1 [X-chromosomale Emery-Dreifuss Muskeldystrophie]",
      "EDMD2 [Autosomal-dominante Emery-Dreifuss Muskeldystrophie]",
      "EDMD3 [Autosomal-rezessive Emery-Dreifuss Muskeldystrophie]",
      "Emerinopathie",
      "Emery-Dreifuss-Muskeldystrophie",
      "Erb-Dystrophie",
      "Erb-Krankheit",
      "Erb-Muskeldystrophie",
      "Erb-Syndrom",
      "Fazio-skapulo-humerale Atrophie",
      "Fazio-skapulo-humerale Muskeldystrophie",
      "Fazio-skapulo-humerale Myopathie",
      "Gamma-Sarkoglykanopathie",
      "Gliedergürtelmuskeldystrophie durch FKRP [Fukutin-related Protein]-Mangel",
      "Gliedergürtelmuskeldystrophie durch Lamin A/C -Mangel",
      "Gliedergürtelmuskeldystrophie durch POMK-Mangel",
      "Gliedergürtelmuskeldystrophie durch alpha-Sarkoglykan-Mangel",
      "Gliedergürtelmuskeldystrophie durch beta-Sarkoglykan-Mangel",
      "Gliedergürtelmuskeldystrophie durch delta-Sarkoglykan-Mangel",
      "Glieder"
    ]
  },
  {
    "code": "G71.1",
    "name": "Myotonia atrophica",
    "synonyms": [
      "Arzneimittelinduzierte Myotonie",
      "Azetazolamid-sensitive Myotonia congenita",
      "Chondrodystrophische Myotonie",
      "Curschmann-Batten-Steinert-Syndrom",
      "Curschmann-Steinert-Krankheit",
      "Curschmann-Steinert-Syndrom",
      "DM1 [Myotone Dystrophie Typ 1]",
      "Dominante Myotonia congenita",
      "Dystrophia myotonica",
      "Erworbene Neuromyotonie",
      "Eulenburg-Krankheit",
      "Eulenburg-Syndrom",
      "Hereditäre muskuläre Daueraktivität",
      "Isaacs-Mertens-Syndrom",
      "Isaacs-Neuromyotonie",
      "Myalgie-Faszikulations-Krampus-Syndrom",
      "Myotone Dystrophie Steinert",
      "Myotone Dystrophie Steinert mit Beginn im Erwachsenenalter",
      "Myotone Dystrophie Steinert mit Beginn im Kindesalter",
      "Myotone Dystrophie Steinert mit spätem Beginn",
      "Myotone Dystrophie Steinert, juvenile Form",
      "Myotone Dystrophie Steinert, kongenitale Form",
      "Myotone Dystrophie Typ 1",
      "Myotones Syndrom",
      "Myotonia atrophica",
      "Myotonia congenita",
      "Myotonia fluctuans",
      "Myotonia hypertrophica congenita",
      "Myotonia permanens",
      "Myotonische Störung",
      "Myotonische muskuläre Dystrophie",
      "Neuromyotonie",
      "Paramyotonia",
      "Paramyotonia congenita",
      "Proximale myotone Myopathie",
      "Pseudomyotonie",
      "Rezessive Myotonia congenita (Becker)",
      "Steinert-Krankheit",
      "Symptomatische Myotonie",
      "Thomsen-Krankheit",
      "Thomsen-Syndrom"
    ]
  },
  {
    "code": "G71.2",
    "name": "Angeborene Myopathie",
    "synonyms": [
      "Aktin-Myopathie",
      "Angeborene Muskeldystrophie",
      "Angeborene Myopathie",
      "Angeborene Myopathie mit Typ 2-Muskelfaseratrophie",
      "Autosomal-dominante Myosinspeicher-Myopathie",
      "Autosomal-dominante zentronukleäre Myopathie",
      "Autosomal-rezessive Myosinspeicher-Myopathie",
      "Autosomal-rezessive zentronukleäre Myopathie",
      "CFTD [Kongenitale Fasertyp-Disproportion]",
      "Cap-Myopathie",
      "Central-core-Krankheit",
      "Central-core-Myopathie",
      "EMARDD [Früh beginnende Myopathie mit Areflexie, Atemnot und Dysphagie]",
      "Fasertypendisproportion",
      "Fatale infantile hypertone myofibrilläre Myopathie",
      "Fingerabdruckkörper-Myopathie",
      "Fingerprint-Body-Myopathie",
      "Früh beginnende Myopathie mit Areflexie, Atemnot und Dysphagie",
      "Hyaline Körper-Myopathie",
      "Intermediäre Nemalin-Myopathie",
      "Kappen-Myopathie",
      "King-Denborough-Syndrom",
      "Kongenitale Fasertyp-Disproportion",
      "Kongenitale Muskeldystrophie Typ 1A",
      "Kongenitale Muskeldystrophie Typ 1B",
      "Kongenitale Muskeldystrophie Typ Davignon-Chauveau",
      "Kongenitale Muskeldystrophie Typ Fukuyama",
      "Kongenitale Muskeldystrophie Typ Ullrich",
      "Kongenitale Muskeldystrophie durch Laminin-alpha-2-Mangel",
      "Kongenitale Muskeldystrophie mit ITGA7 [Integrin-alpha-7]-Defizienz",
      "Kongenitale Muskeldystrophie mit infantiler Katarakt und Hyogonadismus",
      "Kongenitale Muskeldystrophie-Dystroglykanopathie mit Intelligenzminderung",
      "Kongenitale Muskeldystrophie-Dystroglykanopathie ohne Intelligenzminderung",
      "Kongenitale Myopathie Typ Paradas",
      "Kongenitale Myopathie mit Fasertyp-Disproportion",
      "Kongenitale hereditäre Muskeldystrophie",
      "Kongenitale letale Myopathie Typ Compton-North",
      "Lamin A/C-assoziierte kongenitale Muskeldystrophie",
      "Megakoniale kongenitale Muskeldystrophie",
      "Milde Nemalin-Myopathie mit Beginn in der Kindheit",
      "Minicore-Krankheit",
      "Multicore-Krankheit",
      "Multiminicore-Myopathie",
      "Muskel-Augen-Gehirn-Krankheit",
      "Myopathie mit tubulären Aggregaten",
      "Myopathie mit zylindrischen Spiralen",
      "Myosinspeicher-Myopathie",
      "Myotubuläre Myopathie",
      "Myotubuläre zentronukleäre Myopathie",
      "NEM [Nemaline Myopathie]",
      "Native-American-Myopathie",
      "Nemalin-Myopathie",
      "Nemalin-Myopathie Typ Amish",
      "Nemalin-Myopathie mit Beginn im Erwachsenenalter",
      "Nemalin-Stäbchen-Myopathie",
      "Nemalinkörper-Krankheit",
      "Reducing-Body-Myopathie",
      "Rigid-Spine-Syndrom",
      "Schwere kongenitale Nemalin-Myopathie",
      "Spheroid-body-Myopathie",
      "Symptomatische x-chromosomale zentronukleäre Myopathie bei weiblicher Trägerin",
      "Typische kongenitale Nemalin-Myopathie",
      "X-chromosomale zentronukleäre Myopathie",
      "Zebra-Körperchen-Myopathie",
      "Zentralfibrillenmyopathie",
      "Zentronukleäre Myopathie",
      "Zentronukleäre Myopathie Typ 4"
    ]
  },
  {
    "code": "G71.3",
    "name": "Mitochondriale Myopathie a.n.k.",
    "synonyms": [
      "Autosomal-dominante mitochondriale Myopathie mit Belastungsintoleranz",
      "DNA2-assoziiertes mitochondriales DNA-Depletionssyndrom",
      "Infantile reversible COX [Cytochrom-C-Oxidase]-Defizienz-Myopathie",
      "LIMM [Letale infantile mitochondriale Myopathie]",
      "Letale infantile mitochondriale Myopathie",
      "Mitochondriale Myopathie a.n.k.",
      "Mitochondriale Myopathie mit Laktatazidose und Schwerhörigkeit",
      "Mitochondriale Myopathie und sideroachrestische Anämie",
      "Mitochondriales DNA-Depletionssyndrom, myopathische Form",
      "Myopathie mit Belastungsintoleranz vom schwedischen Typ",
      "Proximale Myopathie mit fokaler mitochondrialer Depletion",
      "Syndrom der kongenitalen Katarakt mit progressiver Muskelhypotonie, Hörverlust und Entwicklungsverzögerung",
      "Syndrom der progressiven externen Ophthalmoplegie mit Myopathie und Kachexie"
    ]
  },
  {
    "code": "G71.8",
    "name": "Amyotrophie",
    "synonyms": [
      "Amyotrophie",
      "Brody-Myopathie",
      "Desmin-abhängige Myopathie mit Mallory-Körperchen-ähnlichen Einschlüssen",
      "Desmin-assoziierte myofibrilläre Myopathie",
      "Desminopathie",
      "Distale Myopathie Typ Nonaka",
      "Distale Myopathie mit intrazytoplasmatischen Einschlüssen",
      "Einschlusskörperchen-Myopathie",
      "Einschlusskörperchenmyopathie Typ 2",
      "FLNC-assoziierte myofibrilläre Myopathie",
      "Filaminopathie",
      "Früh beginnende Myopathie mit fataler Kardiomyopathie",
      "Hereditäre Einschlusskörperchenmyopathie Typ 2",
      "Hereditäre Einschlusskörperchenmyopathie Typ 3",
      "Hereditäre Einschlusskörperchenmyopathie Typ 4",
      "Hereditäre Myopathie mit frühem Atemversagen",
      "Musculus quadriceps femoris-aussparende Myopathie",
      "Myofibrilläre Myopathie",
      "Myositis fibrosa generalisata",
      "Myosklerose",
      "Myosklerose-Syndrom",
      "Nonaka-Myopathie",
      "Rippling-Muskelkrankheit",
      "Syndrom der myofibrillären Myopathie mit Kyphose und lateraler Zungenatrophie",
      "X-chromosomale Myopathie mit exzessiver Autophagie"
    ]
  },
  {
    "code": "G71.9",
    "name": "Primäre Myopathie",
    "synonyms": [
      "Hereditäre Myopathie",
      "Hereditäre neuromuskuläre Störung a.n.k.",
      "Primäre Myopathie"
    ]
  },
  {
    "code": "G72.0",
    "name": "Arzneimittelinduzierte Myopathie",
    "synonyms": [
      "Arzneimittelinduzierte Myopathie"
    ]
  },
  {
    "code": "G72.1",
    "name": "Alkoholmyopathie",
    "synonyms": [
      "Alkoholische Myopathie",
      "Alkoholmyopathie"
    ]
  },
  {
    "code": "G72.2",
    "name": "Toxische Myopathie",
    "synonyms": [
      "Toxische Myopathie"
    ]
  },
  {
    "code": "G72.3",
    "name": "Periodische Lähmung",
    "synonyms": [
      "Adynamia episodica hereditaria",
      "Cavare-Krankheit",
      "Familiäre hyperkaliämische paroxysmale Lähmung",
      "Familiäre hyperkaliämische periodische Lähmung",
      "Familiäre hypokaliämische paroxysmale Lähmung",
      "Familiäre hypokaliämische periodische Lähmung",
      "Familiäre myotonische paroxysmale Lähmung",
      "Familiäre myotonische periodische Lähmung",
      "Familiäre normokaliämische paroxysmale Lähmung",
      "Familiäre normokaliämische periodische Lähmung",
      "Familiäre paroxysmale Lähmung",
      "Familiäre periodische Lähmung",
      "Familiäre periodische Paralyse",
      "Familiäre rezidivierende Paralyse",
      "Gamstorp-Syndrom",
      "Hyperkaliämische periodische Lähmung",
      "Hyperkalämische periodische Paralyse",
      "Hypokaliämische paroxysmale Lähmung",
      "Hypokaliämische periodische Lähmung",
      "Hypokaliämische periodische Paralyse",
      "Myotonische paroxysmale Lähmung",
      "Myotonische periodische Lähmung",
      "Myotonische periodische Paralyse",
      "Normokaliämische paroxysmale Lähmung",
      "Normokaliämische periodische Lähmung",
      "Normokaliämische periodische Paralyse",
      "Paroxysmale Lähmung",
      "Periodische Lähmung",
      "Periodische Paralyse",
      "Thyreotoxische periodische Paralyse"
    ]
  },
  {
    "code": "G72.4",
    "name": "Entzündliche Myopathie",
    "synonyms": [
      "Einschlusskörperchenmyositis",
      "Entzündliche Myopathie",
      "Immunvermittelte nekrotisierende Myopathie"
    ]
  },
  {
    "code": "G72.80",
    "name": "Critical-illness-Myopathie",
    "synonyms": [
      "Critical-illness-Myopathie"
    ]
  },
  {
    "code": "G72.88",
    "name": "Progressive Myopathie a.n.k.",
    "synonyms": [
      "Idiopathisches Dropped-Head-Syndrom",
      "Muskelparalyse a.n.k.",
      "Muskuläre Paralyse a.n.k.",
      "Progressive Myopathie a.n.k."
    ]
  },
  {
    "code": "G72.9",
    "name": "Myopathie",
    "synonyms": [
      "Myopathia",
      "Myopathie"
    ]
  },
  {
    "code": "G80.0",
    "name": "Tetraplegie bei spastischer infantiler Lähmung",
    "synonyms": [
      "Kongenitale spastische Quadriplegie",
      "Spastische quadriplegische Zerebralparese",
      "Spastische quadriplegische zerebrale Lähmung",
      "Spastische tetraplegische Zerebralparese",
      "Spastische tetraplegische zerebrale Lähmung",
      "Tetraplegie bei spastischer infantiler Lähmung"
    ]
  },
  {
    "code": "G80.1",
    "name": "Spastische Zerebralparese",
    "synonyms": [
      "Angeborene spastische Lähmung",
      "Angeborene zerebrale spastische Lähmung",
      "Atonisch-astatischer Symptomenkomplex",
      "Diplegie bei infantiler spastischer Zerebralparese",
      "Diplegie bei spastischer infantiler Lähmung",
      "Infantile spastische Diplegie",
      "Infantile spastische Lähmung",
      "Infantile spastische Paralyse",
      "Infantile spastische Paraplegie",
      "Infantile spastische Zerebralparese",
      "Kongenitale Zerebrospasmen",
      "Kongenitale spastische Monoplegie",
      "Kongenitale spastische Paralyse",
      "Kongenitale spastische Paraplegie",
      "Monoplegische spastische zerebrale Lähmung",
      "Spastische Diplegie",
      "Spastische Kinderlähmung",
      "Spastische Spinalparalyse",
      "Spastische Spinalparese",
      "Spastische Zerebralparese",
      "Spastische diplegische Zerebralparese",
      "Spastische diplegische zerebrale Lähmung",
      "Spastische paraplegische zerebrale Paralyse",
      "Zerebrale infantile spastische Lähmung",
      "Zerebrospasmen"
    ]
  },
  {
    "code": "G80.2",
    "name": "Infantile zerebrale spastische Hemiplegie",
    "synonyms": [
      "Hemiplegie bei infantiler Zerebralparese",
      "Hemiplegie bei spastischer infantiler Lähmung",
      "Hemiplegische Zerebralparalyse",
      "Hemiplegische zerebrale Kinderlähmung",
      "Infantile zerebrale spastische Hemiplegie",
      "Kongenitale spastische Hemiplegie",
      "Spastische hemiplegische Zerebralparese",
      "Spastische hemiplegische zerebrale Lähmung"
    ]
  },
  {
    "code": "G80.3",
    "name": "Dyskinetische Zerebralparese",
    "synonyms": [
      "Athetotische Zerebralparalyse",
      "Athetotische Zerebralparese",
      "Athetotische dyskinetische zerebrale Lähmung",
      "Athétose double",
      "Bilaterale kongenitale Athetose",
      "Cecile-Vogt-Syndrom",
      "Dyskinetische Zerebralparalyse",
      "Dyskinetische Zerebralparese",
      "Dyskinetische zerebrale Kinderlähmung",
      "Dyskinetische zerebrale Lähmung",
      "Dystone Zerebralparese",
      "Dystone dyskinetische zerebrale Lähmung",
      "Dystone zerebrale Lähmung",
      "Hammond-Syndrom",
      "Infantile dyskinetische Zerebralparese",
      "Status marmoratus",
      "Vogt-Krankheit",
      "Zerebrale Kinderlähmung mit Athetose"
    ]
  },
  {
    "code": "G80.4",
    "name": "Ataktische Zerebralparese",
    "synonyms": [
      "Ataktische Zerebralparalyse",
      "Ataktische Zerebralparese",
      "Ataktische zerebrale Kinderlähmung",
      "Ataktische zerebrale Lähmung",
      "Infantile ataktische Zerebralparese"
    ]
  },
  {
    "code": "G80.8",
    "name": "Kongenitale Diplegie",
    "synonyms": [
      "Diplegische zerebrale Kinderlähmung",
      "Infantile Monoplegie",
      "Infantile Paraplegie",
      "Infantile Quadriplegie",
      "Infantile Tetraplegie",
      "Infantile Triplegie",
      "Infantile spinale Monoplegie",
      "Infantile zerebrale Monoplegie",
      "Kongenitale Diplegie",
      "Kongenitale Hemiplegie",
      "Kongenitale Monoplegie",
      "Kongenitale Paraplegie",
      "Kongenitale Triplegie",
      "Kongenitale schlaffe zerebrale Quadriplegie",
      "Mischform der Zerebralparalyse",
      "Mischform der zerebralen Kinderlähmung",
      "Mischsyndrom der Zerebralparese",
      "Monoplegische Zerebralparalyse",
      "Monoplegische zerebrale Kinderlähmung a.n.k.",
      "Paraplegische Zerebralparalyse a.n.k.",
      "Paraplegische zerebrale Kinderlähmung a.n.k.",
      "Quadriplegische zerebrale Kinderlähmung",
      "Quadriplegische zerebrale Paralyse",
      "Tetraplegische zerebrale Kinderlähmung",
      "Worster-Drought-Syndrom"
    ]
  },
  {
    "code": "G80.9",
    "name": "Infantile Zerebralparese",
    "synonyms": [
      "Angeborene Zerebralparalyse",
      "CP [Zerebralparese]",
      "Gehirnschaden beim Kind a.n.k.",
      "Infantile Kinderlähmung",
      "Infantile Querschnittlähmung",
      "Infantile Zerebralparalyse",
      "Infantile Zerebralparese",
      "Kongenitale Kinderlähmung",
      "Kongenitale Spinalparalyse",
      "Kongenitale Zerebralparalyse",
      "Little-Krankheit",
      "Little-Syndrom",
      "Zerebrale Kinderlähmung",
      "Zerebrale Lähmung",
      "Zerebralparese"
    ]
  },
  {
    "code": "G81.0",
    "name": "Schlaffe Hemiplegie",
    "synonyms": [
      "Schlaffe Halbseitenlähmung",
      "Schlaffe Hemiparese",
      "Schlaffe Hemiplegie"
    ]
  },
  {
    "code": "G81.1",
    "name": "Spastische Hemiparese",
    "synonyms": [
      "Spastische Halbseitenlähmung",
      "Spastische Hemiparese",
      "Spastische Hemiplegie",
      "Spinale Hemiplegie"
    ]
  },
  {
    "code": "G81.9",
    "name": "Hemiplegie",
    "synonyms": [
      "Aszendierende Hemiplegie a.n.k.",
      "Benigne nächtliche alternierende Hemiplegie im Kindesalter",
      "Halbseitenlähmung - s.a. Hemiplegie",
      "Halbseitenparese",
      "Hemiparalyse",
      "Hemiparese",
      "Hemiplegia",
      "Hemiplegie"
    ]
  },
  {
    "code": "G82.00",
    "name": "Akute nichttraumatische schlaffe Paraplegie",
    "synonyms": [
      "Akute nichttraumatische schlaffe Paraplegie",
      "Schlaffe Paraplegie mit akuter kompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.01",
    "name": "Akute nichttraumatische schlaffe Paraparese",
    "synonyms": [
      "Akute nichttraumatische schlaffe Paraparese",
      "Schlaffe Paraparese mit akuter inkompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.02",
    "name": "Schlaffe Paraplegie",
    "synonyms": [
      "Schlaffe Paraplegie",
      "Schlaffe Paraplegie mit chronischer kompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.03",
    "name": "Schlaffe Paraparese",
    "synonyms": [
      "Schlaffe Paraparese",
      "Schlaffe Paraparese mit chronischer inkompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.10",
    "name": "Akute nichttraumatische spastische Paraplegie",
    "synonyms": [
      "Akute nichttraumatische spastische Paraplegie",
      "Spastische Paraplegie mit akuter kompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.11",
    "name": "Akute nichttraumatische spastische Paraparese",
    "synonyms": [
      "Akute nichttraumatische spastische Paraparese",
      "Spastische Paraparese mit akuter inkompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.12",
    "name": "Spastische Paraplegie",
    "synonyms": [
      "Spastische Paraplegie",
      "Spastische Paraplegie mit chronischer kompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.13",
    "name": "Spastische Paraparese",
    "synonyms": [
      "Spastische Paraparese",
      "Spastische Paraparese mit chronischer inkompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.19",
    "name": "Spastische Querschnittlähmung",
    "synonyms": [
      "Spastische Querschnittlähmung"
    ]
  },
  {
    "code": "G82.20",
    "name": "Akute nichttraumatische Paraplegie",
    "synonyms": [
      "Akute nichttraumatische Paraplegie",
      "Paraplegie mit akuter kompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.21",
    "name": "Akute nichttraumatische Paraparese",
    "synonyms": [
      "Akute nichttraumatische Paraparese",
      "Paraparese mit akuter inkompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.22",
    "name": "Chronische Paraplegie",
    "synonyms": [
      "Chronische Paraplegie",
      "Diplegia inferior",
      "Diplegie der unteren Extremitäten",
      "Paraplegie",
      "Paraplegie der unteren Extremitäten",
      "Paraplegie mit chronischer kompletter Querschnittlähmung",
      "Untere Paraplegie"
    ]
  },
  {
    "code": "G82.23",
    "name": "Paraparese mit chronischer inkompletter Querschnittlähmung",
    "synonyms": [
      "Paraparese mit chronischer inkompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.29",
    "name": "Paraparalyse",
    "synonyms": [
      "Lähmung beider Beine",
      "Lähmung der unteren Extremitäten",
      "Paralyse beider Beine",
      "Paralyse beider unterer Extremitäten",
      "Paraparalyse",
      "Paraparese",
      "Querschnittlähmung",
      "Querschnittsyndrom",
      "Transversalsyndrom"
    ]
  },
  {
    "code": "G82.30",
    "name": "Akute nichttraumatische schlaffe Tetraplegie",
    "synonyms": [
      "Akute nichttraumatische schlaffe Tetraplegie",
      "Schlaffe Tetraplegie mit akuter kompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.31",
    "name": "Akute nichttraumatische schlaffe Tetraparese",
    "synonyms": [
      "Akute nichttraumatische schlaffe Tetraparese",
      "Schlaffe Tetraparese mit akuter inkompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.32",
    "name": "Schlaffe Tetraplegie",
    "synonyms": [
      "Schlaffe Tetraplegie",
      "Schlaffe Tetraplegie mit chronischer kompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.33",
    "name": "Schlaffe Tetraparese",
    "synonyms": [
      "Schlaffe Tetraparese",
      "Schlaffe Tetraparese mit chronischer inkompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.40",
    "name": "Akute nichttraumatische spastische Tetraplegie",
    "synonyms": [
      "Akute nichttraumatische spastische Tetraplegie",
      "Spastische Tetraplegie mit akuter kompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.41",
    "name": "Akute nichttraumatische spastische Tetraparese",
    "synonyms": [
      "Akute nichttraumatische spastische Tetraparese",
      "Spastische Tetraparese mit akuter inkompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.42",
    "name": "Spastische Tetraplegie",
    "synonyms": [
      "Spastische Quadriplegie",
      "Spastische Tetraplegie",
      "Spastische Tetraplegie mit chronischer kompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.43",
    "name": "Spastische Tetraparese",
    "synonyms": [
      "Spastische Tetraparese",
      "Spastische Tetraparese mit chronischer inkompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.49",
    "name": "Tetraspastik",
    "synonyms": [
      "Tetraspastik"
    ]
  },
  {
    "code": "G82.50",
    "name": "Akute nichttraumatische Tetraplegie",
    "synonyms": [
      "Akute nichttraumatische Tetraplegie",
      "Tetraplegie mit akuter kompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.51",
    "name": "Akute nichttraumatische Tetraparese",
    "synonyms": [
      "Akute nichttraumatische Tetraparese",
      "Tetraparese mit akuter inkompletter Querschnittlähmung, nichttraumatischer Genese"
    ]
  },
  {
    "code": "G82.52",
    "name": "Tetraplegie",
    "synonyms": [
      "Chronische Tetraplegie",
      "Tetraplegie",
      "Tetraplegie mit chronischer kompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.53",
    "name": "Tetraparese",
    "synonyms": [
      "Tetraparese",
      "Tetraparese mit chronischer inkompletter Querschnittlähmung"
    ]
  },
  {
    "code": "G82.59",
    "name": "Paralyse aller vier Extremitäten",
    "synonyms": [
      "Chronische Quadriplegie",
      "Paralyse aller vier Extremitäten",
      "Quadriplegie - s.a. Tetraplegie",
      "Quadriplegische Paralyse",
      "Spinale Quadriplegie"
    ]
  },
  {
    "code": "G83.0",
    "name": "Diplegie der oberen Extremitäten",
    "synonyms": [
      "Diplegia",
      "Diplegia superior",
      "Diplegie",
      "Diplegie beider Arme",
      "Diplegie der oberen Extremitäten",
      "Lähmung beider Arme",
      "Lähmung beider oberer Extremitäten",
      "Obere Diplegie",
      "Paralyse beider Arme",
      "Paralyse beider oberer Extremitäten"
    ]
  },
  {
    "code": "G83.1",
    "name": "Monoplegie der unteren Extremität",
    "synonyms": [
      "Beinparalyse",
      "Beinparese",
      "Lähmung eines Beins",
      "Monoplegie der unteren Extremität",
      "Monoplegie eines Beins",
      "Paralyse einer unteren Extremität"
    ]
  },
  {
    "code": "G83.2",
    "name": "Monoplegie der oberen Extremität",
    "synonyms": [
      "Armlähmung",
      "Armparalyse",
      "Handparalyse",
      "Monoplegie der oberen Extremität",
      "Monoplegie eines Arms",
      "Paralyse einer oberen Extremität"
    ]
  },
  {
    "code": "G83.3",
    "name": "Monoplegie",
    "synonyms": [
      "Extremitätenlähmung",
      "Extremitätenparalyse a.n.k.",
      "Monoparese",
      "Monoplegie"
    ]
  },
  {
    "code": "G83.40",
    "name": "Komplettes Cauda-equina-Syndrom",
    "synonyms": [
      "Komplette Kompression der Cauda equina",
      "Komplette Schädigung der Cauda equina",
      "Komplettes Cauda-Syndrom",
      "Komplettes Cauda-equina-Syndrom"
    ]
  },
  {
    "code": "G83.41",
    "name": "Inkomplettes Cauda-equina-Syndrom",
    "synonyms": [
      "Inkomplette Kompression der Cauda equina",
      "Inkomplette Schädigung der Cauda equina",
      "Inkomplettes Cauda-Syndrom",
      "Inkomplettes Cauda-equina-Syndrom"
    ]
  },
  {
    "code": "G83.49",
    "name": "Blasen-Darm-Lähmung",
    "synonyms": [
      "Blasen-Darm-Lähmung",
      "Blasen-Mastdarm-Lähmung",
      "Cauda-Syndrom",
      "Cauda-equina-Syndrom",
      "Harnblasen-Darm-Lähmung",
      "Harnblasen-Mastdarm-Lähmung",
      "Harnblasen-Rektum-Lähmung",
      "Kompression der Cauda equina",
      "Kompressionssyndrom der Cauda equina",
      "Neurogene Blase bei Cauda-equina-Syndrom",
      "Neurogene Blasenentleerungsstörung bei Cauda-Syndrom",
      "Neurogene Blasenentleerungsstörung bei Cauda-equina-Syndrom",
      "Neurogene Harnblasenträgheit",
      "Schädigung der Cauda equina"
    ]
  },
  {
    "code": "G83.5",
    "name": "Locked-in-Syndrom",
    "synonyms": [
      "Locked-in-Syndrom"
    ]
  },
  {
    "code": "G83.6",
    "name": "Faziale Parese durch Läsion des oberen Motoneurons",
    "synonyms": [
      "Faziale Lähmung durch Läsion des oberen Motoneurons",
      "Faziale Parese durch Läsion des oberen Motoneurons",
      "Faziale Schwäche durch Läsion des oberen Motoneurons",
      "Zentrale faziale Parese"
    ]
  },
  {
    "code": "G83.8",
    "name": "Triplegie",
    "synonyms": [
      "Alternierende Paralyse",
      "Alternierende Paralyse des Nervus oculomotorius",
      "Alternierende mittlere Paralyse",
      "Brown-Séquard-Krankheit",
      "Brown-Séquard-Paralyse",
      "Brown-Séquard-Syndrom",
      "Hemiplegia alternans facialis",
      "Jackson-Paralyse",
      "Medulläre Paralyse",
      "Mesenzephalische Paralyse a.n.k.",
      "Paralysis spinalis",
      "Postepileptische Todd-Paralyse",
      "Postiktale Todd-Paralyse",
      "Rückenmarklähmung",
      "Rückenmarkparalyse",
      "Spinalparalyse",
      "Tegmentale Paralyse",
      "Tegmentale mesenzephalische Paralyse",
      "Todd-Paralyse",
      "Triplegie"
    ]
  },
  {
    "code": "G83.9",
    "name": "Lähmung",
    "synonyms": [
      "Intranukleäre Paralyse",
      "Lähmung",
      "Lähmungssyndrom",
      "Motorische Paralyse a.n.k.",
      "Paralyse",
      "Paralyse-Syndrom",
      "Paralysis",
      "Paralytisches Syndrom",
      "Parese",
      "Paresis",
      "Schlaffe Parese",
      "Senile Paralyse a.n.k.",
      "Spastische Paralyse",
      "Spastische Parese",
      "Teilparese",
      "Unvollständige Paralyse",
      "Vollständige Paralyse"
    ]
  },
  {
    "code": "G90.00",
    "name": "Hypersensitiver Karotissinus",
    "synonyms": [
      "Charcot-Weiss-Baker-Syndrom",
      "Hypersensibilität des Karotissinus",
      "Hypersensitiver Karotissinus",
      "Karotissinus-Syndrom",
      "Sensibilisierung des Sinus caroticus",
      "Synkope bei Druck auf den Sinus caroticus"
    ]
  },
  {
    "code": "G90.08",
    "name": "Faziozephalgie",
    "synonyms": [
      "Autonome Faziozephalgie",
      "Faziozephalgie",
      "Idiopathische autonome Insuffizienz",
      "Karotidodynie"
    ]
  },
  {
    "code": "G90.1",
    "name": "Familiäre Dysautonomie",
    "synonyms": [
      "Dysautonomie",
      "Familiäre Dysautonomie",
      "Reine Dysautonomie",
      "Riley-Day-Syndrom"
    ]
  },
  {
    "code": "G90.2",
    "name": "Horner-Syndrom",
    "synonyms": [
      "Claude-Bernard-Horner-Syndrom",
      "Horner-Bernard-Syndrom",
      "Horner-Symptomenkomplex",
      "Horner-Syndrom",
      "Horner-Trias",
      "Kongenitales Claude-Bernard-Horner-Syndrom",
      "Kongenitales Horner-Syndrom",
      "Zervikaler Sympathikusparalyse",
      "Zervikalsyndrom mit sympathischer Paralyse"
    ]
  },
  {
    "code": "G90.40",
    "name": "Autonome Dysreflexie als hypertone Krisen",
    "synonyms": [
      "Autonome Dysreflexie als hypertone Krisen"
    ]
  },
  {
    "code": "G90.41",
    "name": "Autonome Dysreflexie als Schwitzattacken",
    "synonyms": [
      "Autonome Dysreflexie als Schwitzattacken"
    ]
  },
  {
    "code": "G90.49",
    "name": "Autonome Dysreflexie",
    "synonyms": [
      "Autonome Dysreflexie"
    ]
  },
  {
    "code": "G90.50",
    "name": "Komplexes regionales Schmerzsyndrom Typ I der oberen Extremität",
    "synonyms": [
      "Komplexes regionales Schmerzsyndrom Typ I der oberen Extremität"
    ]
  },
  {
    "code": "G90.51",
    "name": "Komplexes regionales Schmerzsyndrom Typ I der unteren Extremität",
    "synonyms": [
      "Komplexes regionales Schmerzsyndrom Typ I der unteren Extremität"
    ]
  },
  {
    "code": "G90.59",
    "name": "Sudeck-Syndrom",
    "synonyms": [
      "Chronic regional pain syndrome [CRPS] Typ I",
      "Komplexes regionales Schmerzsyndrom, Typ I",
      "Morbus Sudeck [Neurogene posttraumatische Knochenatrophie]",
      "Neurogene posttraumatische Knochenatrophie",
      "Reflexdystrophie",
      "Sudeck-Atrophie",
      "Sudeck-Knochenatrophie",
      "Sudeck-Krankheit",
      "Sudeck-Syndrom",
      "Sympathische Reflexdystrophie"
    ]
  },
  {
    "code": "G90.60",
    "name": "Chronic regional pain syndrome [CRPS] Typ II der oberen Extremität",
    "synonyms": [
      "Chronic regional pain syndrome [CRPS] Typ II der oberen Extremität",
      "Komplexes regionales Schmerzsyndrom Typ II der oberen Extremität"
    ]
  },
  {
    "code": "G90.61",
    "name": "Chronic regional pain syndrome [CRPS] Typ II der unteren Extremität",
    "synonyms": [
      "Chronic regional pain syndrome [CRPS] Typ II der unteren Extremität",
      "Komplexes regionales Schmerzsyndrom Typ II der unteren Extremität"
    ]
  },
  {
    "code": "G90.69",
    "name": "Kausalgie",
    "synonyms": [
      "Kausalgie",
      "Kausalgie-Syndrom",
      "Komplexes regionales Schmerzsyndrom, Typ II"
    ]
  },
  {
    "code": "G90.70",
    "name": "Komplexes regionales Schmerzsyndrom der oberen Extremität",
    "synonyms": [
      "Komplexes regionales Schmerzsyndrom der oberen Extremität"
    ]
  },
  {
    "code": "G90.71",
    "name": "Komplexes regionales Schmerzsyndrom der unteren Extremität",
    "synonyms": [
      "Komplexes regionales Schmerzsyndrom der unteren Extremität"
    ]
  },
  {
    "code": "G90.79",
    "name": "Komplexes regionales Schmerzsyndrom",
    "synonyms": [
      "Komplexes regionales Schmerzsyndrom"
    ]
  },
  {
    "code": "G90.80",
    "name": "Posturales Tachykardiesyndrom",
    "synonyms": [
      "PoTS [Posturales Tachykardiesyndrom]",
      "Posturales Tachykardiesyndrom"
    ]
  },
  {
    "code": "G90.88",
    "name": "Quadrantensyndrom",
    "synonyms": [
      "Autonome Gleichgewichtsstörung",
      "Baroreflexversagen",
      "DBH [Dopamin-beta-Hydroxylase]-Mangel",
      "Dopamin-beta-Hydroxylase-Mangel",
      "Harlequin-Syndrom",
      "Kompression des peripheren autonomen Nervensystems",
      "Kompression eines Nervus sympathicus a.n.k.",
      "Lähmung des peripheren autonomen Nervensystems",
      "Noradrenalin-Mangel",
      "PEPD [Paroxysmal extreme pain disorder]",
      "Paroxysmales extremes Schmerzsyndrom",
      "Quadrantensyndrom",
      "Reizung des peripheren autonomen Nervensystems",
      "Reizung des sympathischen Nervensystems a.n.k.",
      "Shapiro-Syndrom",
      "Spontane periodische Hypothermie",
      "Sympathikotonie",
      "Sympathikusparalyse",
      "Sympathikusschmerzen",
      "Sympathische Gleichgewichtsstörung",
      "Sympathische Irritabilität",
      "Syndrom des kälteinduzierten Schwitzens",
      "Vasomotorische Paralyse a.n.k."
    ]
  },
  {
    "code": "G90.9",
    "name": "Autonome kardiale Neuropathie",
    "synonyms": [
      "Affektion des autonomen Nervensystems",
      "Autonome Neuropathie",
      "Autonome kardiale Neuropathie",
      "Degeneration des autonomen Nervensystems",
      "Degeneration des peripheren autonomen Nervensystems",
      "Krankheit des autonomen Nervensystems",
      "Krankheit des parasympathischen Nervensystems",
      "Krankheit des sympathischen Nervensystems",
      "Krankheit des vegetativen Nervensystems",
      "Neuropathie eines autonom peripheren Nerven",
      "Störung des autonomen Nervensystems",
      "Störung des parasympathischen Nervensystems",
      "Störung des sympathischen Nervensystems",
      "Störung des vegetativen Nervensystems",
      "Störung eines sympathischen Nerven",
      "Vegetative Störung"
    ]
  },
  {
    "code": "G91.0",
    "name": "Hydrocephalus communicans",
    "synonyms": [
      "Hydrocephalus communicans"
    ]
  },
  {
    "code": "G91.1",
    "name": "Hydrocephalus occlusus",
    "synonyms": [
      "Erworbene Blockade des Foramen Magendii",
      "Erworbene Stenose des Aquaeductus cerebri",
      "Erworbene Striktur des Aquaeductus cerebri",
      "Erworbener Hydrozephalus durch Foramen-Magendii-Block",
      "Erworbener Verschluss des Aquaeductus cerebri",
      "Hydrocephalus noncommunicans",
      "Hydrocephalus occlusus",
      "Obstruktion des Aquaeductus cerebri",
      "Verschluss eines Gehirnventrikels a.n.k."
    ]
  },
  {
    "code": "G91.20",
    "name": "Idiopathischer Normaldruckhydrozephalus",
    "synonyms": [
      "Idiopathischer Normaldruckhydrozephalus"
    ]
  },
  {
    "code": "G91.21",
    "name": "Sekundärer Normaldruckhydrozephalus",
    "synonyms": [
      "Sekundärer Normaldruckhydrozephalus"
    ]
  },
  {
    "code": "G91.29",
    "name": "Hydrozephalus ohne Hirndrucksteigerung",
    "synonyms": [
      "Hydrozephalus ohne Hirndrucksteigerung",
      "Normaldruckhydrozephalus"
    ]
  },
  {
    "code": "G91.3",
    "name": "Posttraumatischer Hydrozephalus a.n.k.",
    "synonyms": [
      "Posttraumatischer Hydrozephalus a.n.k."
    ]
  },
  {
    "code": "G91.9",
    "name": "Erworbener Hydrozephalus",
    "synonyms": [
      "Erworbener Hydrocephalus internus",
      "Erworbener Hydrozephalus",
      "Erworbener Wasserkopf",
      "Hydrocephalus - s.a. Hydrozephalus",
      "Hydrocephalus externus",
      "Hydrocephalus internus",
      "Hydrocrania",
      "Hydrops capitis",
      "Hydrozephalus - s.a. Hydrocephalus",
      "Makrohydrozephalus",
      "Maligner Hydrozephalus",
      "Rezidivierender Hydrozephalus",
      "Wasserkopf - s.a. Hydrozephalus"
    ]
  },
  {
    "code": "G92.0",
    "name": "Toxische Enzephalopathie unter Immuntherapie",
    "synonyms": [
      "Immuneffektorzell-assoziiertes Neurotoxizitätssyndrom",
      "Toxische Enzephalopathie unter Immuntherapie"
    ]
  },
  {
    "code": "G92.9",
    "name": "Toxische Enzephalopathie",
    "synonyms": [
      "Toxische Enzephalitis a.n.k.",
      "Toxische Enzephalopathie",
      "Toxische Meningoenzephalitis a.n.k."
    ]
  },
  {
    "code": "G93.0",
    "name": "Arachnoidalzyste",
    "synonyms": [
      "Arachnoidalzyste",
      "Epidermoidzyste des dritten Hirnventrikels",
      "Erworbene Porenzephalie",
      "Erworbene porenzephale Zyste",
      "Gehirnzyste",
      "Hirnerweichungszyste",
      "Hirnhautzyste",
      "Hirnzyste",
      "Kleinhirnzyste",
      "Meningenzyste",
      "Nichtentwicklungsbedingte Porenzephalie",
      "Subarachnoidale Zyste der hinteren Schädelgrube",
      "Zerebrale Meningenzyste",
      "Zerebrale Zyste",
      "Zerebrale subdurale Zyste",
      "Zyste der Corpora quadrigemina",
      "Zyste der Dura mater encephali",
      "Zyste des Plexus chorioideus"
    ]
  },
  {
    "code": "G93.1",
    "name": "Hypoxisch-ischämischer Hirnschaden",
    "synonyms": [
      "Anoxische Enzephalopathie",
      "Anoxischer Gehirnschaden",
      "Hypoxisch-ischämischer Gehirnschaden",
      "Hypoxisch-ischämischer Hirnschaden",
      "Hypoxische Enzephalopathie",
      "Hypoxischer Gehirnschaden",
      "Hypoxischer Hirnschaden",
      "Zerebrale Anoxie",
      "Zerebrale Hypoxie"
    ]
  },
  {
    "code": "G93.2",
    "name": "Gutartige intrakranielle Drucksteigerung",
    "synonyms": [
      "Benigne Hirndrucksteigerung",
      "Benigne intrakranielle Drucksteigerung",
      "Benigne intrakranielle Hypertension",
      "Benigne intrakranielle Hypertonie",
      "Erhöhter Hirndruck",
      "Erhöhung des Schädelinnendrucks",
      "Gutartige intrakranielle Drucksteigerung",
      "Hirndrucksteigerung",
      "Hirndrucksymptomatik",
      "Hirndruckzeichen",
      "Idiopathische intrakranielle Hypertension",
      "Intrakranielle Drucksteigerung",
      "Pseudotumor cerebri"
    ]
  },
  {
    "code": "G93.3",
    "name": "Postvirales Ermüdungssyndrom",
    "synonyms": [
      "Akureyri-Krankheit",
      "Akureyri-Syndrom",
      "CFS [Chronic fatigue syndrome]",
      "Chronic fatigue syndrome",
      "Chronisches Ermüdungssyndrom",
      "Chronisches Fatigue-Syndrom",
      "Chronisches Fatigue-Syndrom bei Immundysfunktion",
      "Chronisches Müdigkeitssyndrom",
      "Epidemische Neuromyasthenie",
      "Island-Krankheit",
      "Myalgische Enzephalomyelitis",
      "Neuromyasthenie",
      "Postinfektiöse Neuromyasthenie",
      "Postvirales Ermüdungssyndrom",
      "Postvirales Müdigkeitssyndrom",
      "Postvirales chronisches Müdigkeitssyndrom"
    ]
  },
  {
    "code": "G93.4",
    "name": "Leukoenzephalopathie",
    "synonyms": [
      "ADANE [Autosomal-dominante akute nekrotisierende Enzephalopathie]",
      "Akute Enzephalopathie",
      "Autosomal-dominante akute nekrotisierende Enzephalopathie",
      "Encephalopathia",
      "Encephalopathia acuta",
      "Enzephalopathie",
      "Gehirnfunktionsstörung",
      "Hirnfunktionsstörung",
      "Leukenzephalopathie",
      "Leukoenzephalopathie",
      "Neuhauser-Eichner-Opitz-Syndrom",
      "Zerebrale Funktionsstörung"
    ]
  },
  {
    "code": "G93.5",
    "name": "Hirnquetschung",
    "synonyms": [
      "Babinski-Nageotte-Syndrom",
      "Compressio cerebri",
      "Erworbene Enzephalozele",
      "Gehirnquetschung",
      "Herniation des Gehirns",
      "Herniation des Gehirnstamms",
      "Hernie des Foramen magnum",
      "Hirnquetschung",
      "Hirnstammeinklemmung",
      "Hirnstammherniation",
      "Hirnstammkompression",
      "Kompression des Gehirns",
      "Kompression des Gehirnstamms",
      "Zerebrale Herniation"
    ]
  },
  {
    "code": "G93.6",
    "name": "Hirnödem",
    "synonyms": [
      "Gehirnschwellung",
      "Gehirnödem",
      "Hirnschwellung",
      "Hirnödem",
      "Hypertonisches Gehirnödem",
      "Intrakranieller Erguss",
      "Posteriores reversibles Enzephalopathie-Syndrom",
      "Reversibles posteriores Leukoenzephalopathie-Syndrom (RPLS)",
      "Seröser Gehirnerguss",
      "Zerebraler Erguss",
      "Zerebrales Ödem"
    ]
  },
  {
    "code": "G93.7",
    "name": "Reye-Syndrom",
    "synonyms": [
      "Hepatozerebrales Syndrom",
      "Reye-Sequenz",
      "Reye-Syndrom"
    ]
  },
  {
    "code": "G93.80",
    "name": "Apallisches Syndrom",
    "synonyms": [
      "Apallisches Durchgangssyndrom",
      "Apallisches Syndrom",
      "Coma vigile",
      "Dezerebrationssyndrom",
      "Wachkoma"
    ]
  },
  {
    "code": "G93.88",
    "name": "Dissoziierter Hirntod",
    "synonyms": [
      "Automatismen",
      "Depression des Atemzentrums",
      "Dissoziierter Hirntod",
      "Déjerine-Roussy-Syndrom",
      "Enzephalomalazie",
      "Ependymopathie",
      "Erworbene Gehirndeformität",
      "Erworbene zerebrale Deformität",
      "Gehirnerweichung",
      "Gehirnhypertrophie",
      "Gehirninduration",
      "Gehirnnarbe",
      "Gehirnstauung",
      "Gehirnstenose",
      "Gehirnverhärtung",
      "Gliose",
      "Gliosis",
      "Hirnerweichung",
      "Hirnleistungsschwund",
      "Hirnleistungsschwäche",
      "Hirnnarbe",
      "Hirnorganische Ausfälle",
      "Hirnstauung",
      "Infantiles Plexus-chorioideus-Kalzifikations-Syndrom",
      "Intrakranielle Pneumatozele",
      "Irreversibler Hirnfunktionsausfall",
      "Kalzifikation des Plexus chorioideus",
      "Kortexmotoneuronenschädigung a.n.k.",
      "Medulläre Depression",
      "Minimale zerebrale Dysfunktion",
      "Mittelhirnsyndrom a.n.k.",
      "Nekrotische Enzephalomalazie",
      "Paralyse des Atemzentrums a.n.k.",
      "Pneumatozephalus",
      "Pneumozephalus",
      "Pontines Syndrom a.n.k.",
      "Progressive Enzephalomalazie",
      "Symmetrische Kalzifikationen des Thalamus",
      "Tegmentum-Syndrom",
      "Thalamussyndrom",
      "Versagen des Atmungszentrums",
      "Zerebellare Enzephalomalazie",
      "Zerebrale Dysfunktion",
      "Zerebrale Enzephalomalazie",
      "Zerebrale Erweichung",
      "Zerebrale Gliose",
      "Zerebrale Kalzifikation",
      "Zerebrales Versagen",
      "Zerebro-ventrikuläre Erkrankung",
      "Zerebromalazie"
    ]
  },
  {
    "code": "G93.9",
    "name": "Hirnveränderung",
    "synonyms": [
      "Gehirnerkrankung",
      "Gehirnkrankheit",
      "Gehirnschaden",
      "Gehirnveränderung",
      "Hirnerkrankung",
      "Hirnkrankheit",
      "Hirnschaden",
      "Hirnstammerkrankung",
      "Hirnveränderung",
      "Intrazerebrale Erkrankung",
      "Nichttraumatischer Gehirnschaden",
      "Organische Gehirnkrankheit",
      "Zerebrale Erkrankung",
      "Zerebrale Krankheit",
      "Zerebrale Störung",
      "Zerebrales Residualsyndrom",
      "Zerebralschaden"
    ]
  },
  {
    "code": "G95.0",
    "name": "Syringobulbie",
    "synonyms": [
      "Erworbene Syringomyelie",
      "Sekundäre Syringomyelie",
      "Syringobulbie",
      "Syringomyelie",
      "Syringopontie"
    ]
  },
  {
    "code": "G95.10",
    "name": "Hämatomyelie",
    "synonyms": [
      "Hämatomyelie",
      "Hämatorrhachis",
      "Intramedulläre Blutung a.n.k.",
      "Intramedulläre Hämorrhagie a.n.k.",
      "Minor-Krankheit [Hämatomyelie]",
      "Minor-Oppenheim-Syndrom",
      "Nichttraumatische spinale Blutung",
      "Rückenmarkblutung",
      "Rückenmarkhämorrhagie",
      "Spinale subdurale Blutung",
      "Spinale subdurale Hämorrhagie",
      "Spinales nichttraumatisches subdurales Hämatom",
      "Zentrale Hämatomyelie"
    ]
  },
  {
    "code": "G95.18",
    "name": "Vaskuläre Myelopathie",
    "synonyms": [
      "Akuter Rückenmarkinfarkt",
      "Akuter embolischer Rückenmarkinfarkt",
      "Akuter nichtembolischer Rückenmarkinfarkt",
      "Apoplexia spinalis",
      "Arteria-spinalis-anterior-Syndrom",
      "Arterielle Thrombose des Rückenmarks",
      "Arteriosklerose des Rückenmarks",
      "Arteriosklerotische Claudicatio intermittens des Rückenmarks",
      "Claudicatio spinalis (bei vaskulärer Myelopathie)",
      "Nekrotische Myelopathie",
      "Nichteitrige Embolie einer intraspinalen Vene",
      "Nichteitrige Embolie eines intraspinalen Venensinus",
      "Nichteitrige Phlebitis eines intraspinalen Venensinus",
      "Nichteitrige Thrombose einer intraspinalen Vene",
      "Nichteitrige Thrombose eines intraspinalen Venensinus",
      "Nichteitrige intraspinale Phlebitis",
      "Nichteitrige intraspinale Thrombophlebitis",
      "Nichttraumatisches vaskuläres Rückenmarködem",
      "Rückenmarkembolie",
      "Rückenmarkischämie",
      "Rückenmarknekrose",
      "Rückenmarkthrombose",
      "Rückenmarködem",
      "Spinale DBS [Durchblutungsstörung]",
      "Spinale Durchblutungsstörung",
      "Subakute nekrotisierende Myelopathie",
      "Syndrom der vorderen Spinalarterie",
      "Thrombose der Arteria spinalis",
      "Varicosis spinalis",
      "Vaskuläre Myelopathie"
    ]
  },
  {
    "code": "G95.2",
    "name": "Myelokompression",
    "synonyms": [
      "Druck auf das Rückenmark",
      "Myelokompression",
      "Rückenmarkkompression"
    ]
  },
  {
    "code": "G95.80",
    "name": "Rückenmarkblase",
    "synonyms": [
      "Harnblasenlähmung bei Schädigung des oberen motorischen Neurons [UMNL]",
      "Rückenmarkblase",
      "Spastische Blase",
      "Spinalbedingte Reflexblase"
    ]
  },
  {
    "code": "G95.81",
    "name": "Harnblasenlähmung bei Schädigung des unteren motorischen Neurons [LMNL]",
    "synonyms": [
      "Areflexie der Harnblase",
      "Harnblasenlähmung bei Schädigung des unteren motorischen Neurons [LMNL]",
      "Schlaffe Blase"
    ]
  },
  {
    "code": "G95.82",
    "name": "Harnblasenfunktionsstörung durch spinalen Schock",
    "synonyms": [
      "Harnblasenfunktionsstörung durch spinalen Schock"
    ]
  },
  {
    "code": "G95.83",
    "name": "Spinale Spastik der quergestreiften Muskulatur",
    "synonyms": [
      "Spinale Spastik der quergestreiften Muskulatur"
    ]
  },
  {
    "code": "G95.84",
    "name": "Detrusor-Sphinkter-Dyssynergie bei Schädigung des Rückenmarks",
    "synonyms": [
      "Detrusor-Sphinkter-Dyssynergie bei Schädigung des Rückenmarks"
    ]
  },
  {
    "code": "G95.85",
    "name": "Deafferentierungsschmerzen bei Schädigung des Rückenmarks",
    "synonyms": [
      "Deafferentierungsschmerzen bei Schädigung des Rückenmarks"
    ]
  },
  {
    "code": "G95.88",
    "name": "Medikamentöse Myelopathie",
    "synonyms": [
      "Aszendierende spinale Hemiplegie",
      "Conus-medullaris-Syndrom",
      "Degeneratio grisea",
      "Erworbene Rückenmarkdeformität",
      "Froin-Syndrom",
      "Gliosis spinalis",
      "Hinterstrangdegeneration",
      "Immunmyelopathie",
      "Medikamentöse Myelopathie",
      "Myelomalazie",
      "Myelopathie durch Arzneimittel",
      "Myelopathie durch Strahlenwirkung",
      "Progressive Rückenmarksklerose",
      "Rückenmarkerweichung",
      "Spinale Atrophie",
      "Spinalsklerose",
      "Strahleninduzierte Myelopathie",
      "Strahlenmyelopathie",
      "Toxische Myelopathie",
      "Transversale Spinalsklerose",
      "Zyste der Cauda equina"
    ]
  },
  {
    "code": "G95.9",
    "name": "Rückenmarkaffektion",
    "synonyms": [
      "Myelopathie",
      "Myelopathie des Rückenmarks",
      "Rückenmarkaffektion",
      "Rückenmarkerkrankung",
      "Rückenmarkkrankheit",
      "Rückenmarkläsion",
      "Rückenmarkschädigung"
    ]
  },
  {
    "code": "G96.0",
    "name": "Liquorrhoe",
    "synonyms": [
      "Austritt von Liquor cerebrospinalis",
      "Durchsickern von Zerebrospinalflüssigkeit",
      "Gehirnfistel",
      "Liquorrhoe",
      "Rhinorrhoe von Zerebrospinalflüssigkeit",
      "Spontane intrakranielle Hypotension",
      "Zerebrospinale Fistel",
      "Zerebrospinale Otorrhoe"
    ]
  },
  {
    "code": "G96.1",
    "name": "Hirnhautverwachsung",
    "synonyms": [
      "Adhäsion des Spinalkanals",
      "Adhäsion spinaler Meningen",
      "Adhäsion zerebraler Meningen",
      "Erworbene Deformität der Gehirnmeningen",
      "Erworbene Deformität der Rückenmarkhäute",
      "Erworbene Deformität der Rückenmarkmeningen",
      "Hirnhautverwachsung",
      "Kalzifikation der Falx cerebri",
      "Kalzifikation der spinalen Meningen",
      "Kalzifikation der zerebralen Meningen",
      "Leptomeningealfibrose",
      "Leptomeningopathie a.n.k.",
      "Meningenadhäsion",
      "Meningenfibrose",
      "Meningenverwachsung",
      "Meningitis ossificans",
      "Ossifikation der Falx cerebri",
      "Ossifikation der spinalen Meningen",
      "Ossifikation der zerebralen Meningen",
      "Posttraumatische Pseudomeningozele",
      "Rückenmarkzyste",
      "Spinale Meningenzyste",
      "Subdurale Rückenmarkzyste",
      "Zyste der Dura mater spinalis",
      "Zyste der Rückenmarkhäute"
    ]
  },
  {
    "code": "G96.8",
    "name": "Defizit des Zentralnervensystems",
    "synonyms": [
      "Defizit des Zentralnervensystems",
      "NRXN1-assoziierte schwere neurologische Entwicklungsstörung mit Bewegungsstereotypie, chronischer Obstipation und Schlaf-Wach-Rhythmus-Störung",
      "Zyste des Nervensystems a.n.k."
    ]
  },
  {
    "code": "G96.9",
    "name": "Enzephalomeningopathie",
    "synonyms": [
      "Enzephalomeningopathie",
      "Enzephalomyeloneuropathie",
      "Enzephalomyelopathie",
      "Enzephalomyeloradikulopathie",
      "Krankheit des Zentralnervensystems",
      "Meningoenzephalomyelopathie",
      "Meningoenzephalopathie",
      "Störung des Zentralnervensystems",
      "Zerebrospinale Krankheit"
    ]
  },
  {
    "code": "G97.0",
    "name": "Austritt von Liquor cerebrospinalis nach Lumbalpunktion",
    "synonyms": [
      "Austritt von Liquor cerebrospinalis nach Lumbalpunktion",
      "Austritt von Liquor cerebrospinalis nach Spinalpunktion",
      "Durchsickern von Zerebrospinalflüssigkeit nach Lumbalpunktion"
    ]
  },
  {
    "code": "G97.1",
    "name": "Reaktion nach Spinalpunktion",
    "synonyms": [
      "Komplikation durch Lumbalpunktion",
      "Komplikation durch Spinalpunktion",
      "Kopfschmerzen nach Liquorverlust durch Punktion",
      "Kopfschmerzen nach Lumbalpunktion",
      "Kopfschmerzen nach Spinalpunktion",
      "Reaktion nach Lumbalpunktion",
      "Reaktion nach Rückenmarkpunktion",
      "Reaktion nach Spinalpunktion",
      "Reaktion nach zerebrospinalem Flüssigkeitsverlust",
      "Synkope nach Lumbalpunktion"
    ]
  },
  {
    "code": "G97.2",
    "name": "Intrakranielle Druckminderung nach ventrikulärem Shunt",
    "synonyms": [
      "Intrakranielle Druckminderung nach ventrikulärem Shunt",
      "Intrakranielle Hypotonie nach ventrikulärem Shunt"
    ]
  },
  {
    "code": "G97.80",
    "name": "Postoperative Liquorfistel",
    "synonyms": [
      "Postoperative Liquorfistel"
    ]
  },
  {
    "code": "G97.81",
    "name": "Postoperativer zerebellärer Mutismus",
    "synonyms": [
      "Posterior-Fossa-Syndrom",
      "Postoperativer Mutismus",
      "Postoperativer zerebellärer Mutismus"
    ]
  },
  {
    "code": "G97.82",
    "name": "Postoperative epidurale spinale Blutung",
    "synonyms": [
      "Postoperative epidurale spinale Blutung"
    ]
  },
  {
    "code": "G97.83",
    "name": "Postoperative subdurale spinale Blutung",
    "synonyms": [
      "Postoperative subdurale spinale Blutung"
    ]
  },
  {
    "code": "G97.84",
    "name": "Postoperative subarachnoidale spinale Blutung",
    "synonyms": [
      "Postoperative subarachnoidale spinale Blutung"
    ]
  },
  {
    "code": "G97.88",
    "name": "Zerebrale Hypoxie durch ärztliche Maßnahmen a.n.k.",
    "synonyms": [
      "Anoxischer Gehirnschaden nach medizinischen Maßnahmen",
      "Anoxischer Gehirnschaden während einer ärztlichen Maßnahme",
      "Hypoxischer Gehirnschaden nach medizinischen Maßnahmen",
      "Hypoxischer Gehirnschaden während einer ärztlichen Maßnahme",
      "Pseudomeningozele nach medizinischen Maßnahmen",
      "Radiogene Myelitis",
      "Zerebrale Anoxie nach medizinischen Maßnahmen",
      "Zerebrale Anoxie während einer ärztlichen Maßnahme",
      "Zerebrale Hypoxie durch ärztliche Maßnahmen a.n.k."
    ]
  },
  {
    "code": "G97.9",
    "name": "Neurologische Ausfälle einer Extremität bei Gipsbehandlung",
    "synonyms": [
      "Komplikation des Nervensystems nach chirurgischem Eingriff",
      "Motorische Ausfälle einer Extremität bei Gipsbehandlung",
      "Neurologische Ausfälle einer Extremität bei Gipsbehandlung"
    ]
  },
  {
    "code": "G98",
    "name": "Affektion des Nervensystems",
    "synonyms": [
      "Affektion des Nervensystems",
      "Komplikation des Nervensystems",
      "Nervensystemkrankheit",
      "Nervensystemstörung"
    ]
  },
  {
    "code": "H00.0",
    "name": "Tiefe Augenlidentzündung",
    "synonyms": [
      "Abszess der Glandulae tarsales",
      "Abszess der Meibom-Drüsen",
      "Augenlidabszess",
      "Augenlidfurunkel",
      "Augenlidkarbunkel",
      "Entzündung der Meibom-Drüsen",
      "Entzündung der Moll-Drüsen",
      "Entzündung der Zeis-Drüsen",
      "Gerstenkorn",
      "Gerstenkorn der Meibom-Drüsen",
      "Gerstenkorn der Zeis-Drüsen",
      "Hordeolum",
      "Hordeolum externum",
      "Hordeolum internum",
      "Infektion der Meibom-Drüsen",
      "Infektion der Zeis-Drüsen",
      "Infizierte Augenlidzyste",
      "Infizierte Zyste der Meibom-Drüsen",
      "Infiziertes Augenlidsteatom",
      "Inneres Gerstenkorn",
      "Lidabszess",
      "Liddrüsenabszess",
      "Lidfurunkel",
      "Lidphlegmone",
      "Lidrandabszess",
      "Meibomitis",
      "Rezidivierendes Hordeolum",
      "Tiefe Augenlidentzündung",
      "Tiefe Lidinfektion",
      "Zilienfollikulitis",
      "Äußeres Gerstenkorn"
    ]
  },
  {
    "code": "H00.1",
    "name": "Chalazion",
    "synonyms": [
      "Chalazion",
      "Hagelkorn",
      "Hypertrophie der Meibom-Drüsen",
      "Tarsale Zyste",
      "Unterlidchalazion",
      "Zyste der Meibom-Drüsen"
    ]
  },
  {
    "code": "H01.0",
    "name": "Chronische Blepharitis",
    "synonyms": [
      "Allergische Blepharitis",
      "Bakterielle Blepharitis",
      "Blepharadenitis",
      "Blepharitis",
      "Blepharitis angularis",
      "Blepharitis ciliaris",
      "Blepharitis des Augenlids",
      "Blepharitis granulomatosa",
      "Blepharitis marginalis",
      "Blepharitis seborrhoica",
      "Blepharitis squamosa",
      "Blepharitis ulcerosa",
      "Chronische Blepharitis",
      "Granulomatöse Blepharitis",
      "Lidhautentzündung",
      "Lidrandentzündung",
      "Lidrandfollikulitis",
      "Nichtulzeröse Blepharitis",
      "Squamöse Blepharitis",
      "Ulzeröse Blepharitis"
    ]
  },
  {
    "code": "H01.1",
    "name": "Lidexanthem",
    "synonyms": [
      "Allergische Liddermatitis",
      "Allergisches Augenlidödem",
      "Allergisches Lidrandexanthem",
      "Augenlidekzem",
      "Ekzematöse Augenliddermatitis",
      "Ekzematöse Liddermatitis",
      "Erythematodes chronicus discoides des Augenlids",
      "Kontaktdermatitis des Augenlids",
      "Lidallergie",
      "Lidekzem",
      "Lidexanthem",
      "Lidhautxeroderma",
      "Lidrandekzem",
      "Lidxeroderma",
      "Lokalisierter Lupus erythematodes des Lids",
      "Lupus erythematodes des Augenlids",
      "Nichtinfektiöse Liddermatose",
      "Periorbitale Dermatitis",
      "Xeroderma des Augenlids",
      "Zystisches Augenlidsteatom"
    ]
  },
  {
    "code": "H01.8",
    "name": "Fremdkörpergranulom des Lids",
    "synonyms": [
      "Augenlidfistel",
      "Augenlidgranulom",
      "Augenlidinfiltration",
      "Augenlidulkus",
      "Fremdkörpergranulom des Lids",
      "Lidgranulom",
      "Lidknorpelentzündung",
      "Lidrandborken",
      "Lidrandulkus",
      "Lidwinkelulkus",
      "Tarsitis"
    ]
  },
  {
    "code": "H01.9",
    "name": "Lidentzündung",
    "synonyms": [
      "Augenlidentzündung",
      "Augenlidinfektion",
      "Lidentzündung"
    ]
  },
  {
    "code": "H02.0",
    "name": "Augenlidentropium",
    "synonyms": [
      "Augenlidentropium",
      "Einwärtskehrung des Lids",
      "Entropium",
      "Entropium senile",
      "Entropium spasticum",
      "Narbenentropium",
      "Narbige Einwärtskehrung des Lids",
      "Narbiges Entropium",
      "Oberlidentropium",
      "Palpebrale Trichiasis",
      "Paralytische Einwärtskehrung des Lids",
      "Paralytisches Entropium",
      "Senile Einwärtskehrung des Lids",
      "Seniles Entropium",
      "Spastische Einwärtskehrung des Lids",
      "Spastisches Entropium",
      "Trichiasis",
      "Trichiasis des Augenlids",
      "Wimperntrichiasis"
    ]
  },
  {
    "code": "H02.1",
    "name": "Paralytisches Ektropium",
    "synonyms": [
      "Augenlidektropium",
      "Ektropion",
      "Ektropium",
      "Ektropium nach Trauma",
      "Ektropium spasticum",
      "Mechanisches Ektropium",
      "Narbenektropium",
      "Paralytisches Ektropium",
      "Seniles Ektropium"
    ]
  },
  {
    "code": "H02.2",
    "name": "Lagophthalmus",
    "synonyms": [
      "Hasenauge",
      "Lagophthalmus",
      "Lagophthalmus durch Fazialisparese",
      "Lidschließdefekt",
      "Lidspaltendilatation",
      "Lidspaltenerweiterung",
      "Mechanischer Lagophthalmus",
      "Narbig bedingter Lagophthalmus",
      "Nervöser Lagophthalmus",
      "Paralytischer Lagophthalmus"
    ]
  },
  {
    "code": "H02.3",
    "name": "Blepharochalasis",
    "synonyms": [
      "Augenlidchalodermie",
      "Augenliddermatolyse",
      "Blepharochalasis",
      "Blepharodermatochalasis",
      "Dermatolysis palpebrarum",
      "Erworbene Erschlaffung der Augenlidhaut",
      "Vermehrung der Augenlidhaut"
    ]
  },
  {
    "code": "H02.4",
    "name": "Paralytische Augenlidptose",
    "synonyms": [
      "Augenlidparalyse",
      "Augenlidptose",
      "Blepharoptosis",
      "Mechanische Augenlidptose",
      "Neurologische Augenlidptose",
      "Paralyse des Musculus levator palpebrae superioris",
      "Paralytische Augenlidptose",
      "Pseudoptose",
      "Pseudoptosis",
      "Ptose",
      "Senile Augenlidptose",
      "Traumatische Augenlidptose"
    ]
  },
  {
    "code": "H02.5",
    "name": "Lidretraktion",
    "synonyms": [
      "Ankyloblepharon",
      "Augenlidadhäsion",
      "Augenlidkontraktur",
      "Augenlidnarbe",
      "Augenlidretraktion",
      "Augenlidverengung",
      "Blepharophimose",
      "Blepharophimose des Augenlids",
      "Blepharostenose",
      "Erworbenes Ankyloblepharon",
      "Funktionsstörung des Lids",
      "Lidfehlstellung",
      "Lidnarbe",
      "Lidretraktion",
      "Lidschlussstörung",
      "Lidspaltenverengung",
      "Lidverwachsung",
      "Narbig bedingte Lidfehlstellung",
      "Oberlidlähmung",
      "Phimosis palpebralis",
      "Spasmus des Musculus levator palpebrae superioris"
    ]
  },
  {
    "code": "H02.6",
    "name": "Augenlidxanthelasma",
    "synonyms": [
      "Augenlidxanthelasma",
      "Lidxanthelasma",
      "Xanthelasma",
      "Xanthelasma palpebrarum"
    ]
  },
  {
    "code": "H02.7",
    "name": "Fettgewebsprolaps des Lids",
    "synonyms": [
      "Augenlidnekrose",
      "Augenlidvitiligo",
      "Chloasma des Augenlids",
      "Defluvium ciliorum",
      "Degenerative Affektion des Augenlids",
      "Degenerative periokulare Affektion",
      "Erworbenes Fehlen der Wimpern",
      "Erworbenes Fehlen der Zilien",
      "Fettgewebsprolaps des Lids",
      "Lidchloasma",
      "Liddegeneration",
      "Lidmadarosis",
      "Lidvitiligo",
      "Madarosis",
      "Madarosis ciliaris",
      "Madarosis des Augenlids",
      "Ptilosis",
      "Ptilosis des Augenlids",
      "Senile Atrophie des Augenlids"
    ]
  },
  {
    "code": "H02.8",
    "name": "Seltener Lidschlag",
    "synonyms": [
      "Alter Lidfremdkörper",
      "Augenlidelephantiasis",
      "Augenlidemphysem",
      "Augenlidfremdkörper",
      "Augenlidhypertrichose",
      "Augenlidhypertrophie",
      "Augenlidhyperämie",
      "Augenlidinduration",
      "Augenlidschmerzen",
      "Augenlidverhärtung",
      "Augenlidzyste",
      "Augenlidödem",
      "Erworbene Augenliddeformität",
      "Erworbene Kanthusdeformität",
      "Erworbene Liddeformität",
      "Erworbene Lidfaltendeformität",
      "Erworbene Wimperndeformität",
      "Erworbenes Megaloblepharon",
      "Falschwachsende Wimpern",
      "Fehlstehende Wimpern",
      "Gefäßanomalie des Lids",
      "Inverse Zilien",
      "Lidatherom",
      "Lidemphysem",
      "Lidhypertrichose",
      "Lidrandretentionszyste",
      "Lidrandzyste",
      "Lidschwellung",
      "Lidödem",
      "Oberlidzyste",
      "Seltener Lidschlag",
      "Sensibilitätsstörung des Lids",
      "Verbliebener Fremdkörper im Augenlid",
      "Zyste der Augenlidhaut",
      "Zyste der Moll-Drüsen"
    ]
  },
  {
    "code": "H02.9",
    "name": "Liderkrankung",
    "synonyms": [
      "Augenlidaffektion",
      "Augenlidkrankheit",
      "Augenlidschädigung",
      "Augenwinkelschädigung",
      "Kanthusschädigung",
      "Liderkrankung",
      "Lidkrankheit",
      "Lidrandreizung"
    ]
  },
  {
    "code": "H04.0",
    "name": "Dakryoadenitis",
    "synonyms": [
      "Adenitis lacrimalis",
      "Akute Dakryoadenitis",
      "Chronische Dakryoadenitis",
      "Chronische Hypertrophie der Tränendrüse",
      "Chronische Vergrößerung der Tränendrüse",
      "Dakryoadenitis",
      "Tränendrüsenabszess",
      "Tränendrüsenentzündung",
      "Tränendrüsenfurunkel",
      "Tränendrüseninfektion",
      "Tränendrüsenkarbunkel"
    ]
  },
  {
    "code": "H04.1",
    "name": "Trockenes Auge",
    "synonyms": [
      "Benetzungsstörung des Auges",
      "Conjunctivitis sicca im Sinne des Syndroms des trockenen Auges",
      "Dakryops",
      "Erworbener Mangel an Tränenflüssigkeit",
      "Insuffizienz der Tränensekretion",
      "Keratitis sicca im Sinne des Syndroms des trockenen Auges",
      "Keratoconjunctivitis sicca im Sinne des Syndroms des trockenen Auges",
      "Mangel an Tränenflüssigkeit",
      "Sicca-Syndrom des Auges im Sinne des Syndroms des trockenen Auges",
      "Syndrom des trockenen Auges",
      "Trockenes Auge",
      "Tränendrüsenaffektion",
      "Tränendrüsenatrophie",
      "Tränendrüsendislokation",
      "Tränendrüsenerkrankung",
      "Tränendrüseninsuffizienz",
      "Tränendrüsenluxation",
      "Tränendrüsenzyste",
      "Tränenfilminsuffizienz",
      "Tränenproduktionsstörung",
      "Tränensekretionsstörung",
      "Verminderte Tränenflüssigkeitssekretion a.n.k.",
      "Verminderte Tränensekretion",
      "Verminderter Tränenfluss",
      "Zyste einer lakrimalen Drüse"
    ]
  },
  {
    "code": "H04.2",
    "name": "Epiphora",
    "synonyms": [
      "Anomale Tränensekretion",
      "Epiphora",
      "Hypersekretion der Tränendrüsen",
      "Subjektiv feuchtes Auge",
      "Subjektive Epiphora",
      "Tränenträufeln"
    ]
  },
  {
    "code": "H04.3",
    "name": "Akute Entzündung der Tränenwege",
    "synonyms": [
      "Abszess der Tränenwege",
      "Abszess des Tränenwärzchens",
      "Akute Dakryoperizystitis",
      "Akute Dakryophlegmone",
      "Akute Dakryozystitis",
      "Akute Entzündung der Tränenwege",
      "Akute Kanalikulitis",
      "Akute Peridakryozystitis",
      "Akute phlegmonöse Dakryozystitis",
      "Canaliculitis lacrimalis",
      "Caruncula lacrimalis",
      "Dakryoperizystitis",
      "Dakryophlegmone",
      "Dakryozystitis",
      "Eiterung des Tränenapparates",
      "Entzündung der Tränenwege",
      "Entzündung des Canaliculus lacrimalis",
      "Furunkel der Tränenwege",
      "Infektion der Tränenwege",
      "Kanalikulitis",
      "Karbunkel der Tränenwege",
      "Peridakryozystitis",
      "Phlegmonöse Dakryozystitis",
      "Subakute Dakryoperizystitis",
      "Subakute Dakryophlegmone",
      "Subakute Dakryozystitis",
      "Subakute Kanalikulitis",
      "Subakute Peridakryozystitis",
      "Subakute phlegmonöse Dakryozystitis",
      "Tränenkanalentzündung",
      "Tränensackentzündung",
      "Tränensackphlegmone",
      "Tränenwegphlegmone"
    ]
  },
  {
    "code": "H04.4",
    "name": "Dakryozystoblennorrhoe",
    "synonyms": [
      "Chronische Dakryoperizystitis",
      "Chronische Dakryozystitis",
      "Chronische Entzündung der Tränenwege",
      "Chronische Kanalikulitis",
      "Chronische Mukozele des Tränenapparates",
      "Dakryozystoblennorrhoe",
      "Mukozele des Tränensacks"
    ]
  },
  {
    "code": "H04.5",
    "name": "Tränensackhydrops",
    "synonyms": [
      "Dakryolith",
      "Dakryolithiasis",
      "Dakryostenose",
      "Einwärtsgewendete Tränenpünktchen",
      "Eversio puncti lacrimalis",
      "Fibrose des Tränenkanals",
      "Insuffizienz der Tränenwege",
      "Obstruktion des Ductus nasolacrimalis",
      "Postinfektiöse Adhäsion des Ductus lacrimalis",
      "Postinfektiöse Adhäsion des Ductus nasolacrimalis",
      "Postkanalikuläre Tränenwegstenose",
      "Rhinodakryolith",
      "Steinbildung der Tränendrüse",
      "Steinbildung im Tränendrüsengang",
      "Stenose des Canaliculus lacrimalis",
      "Stenose des Ductus lacrimalis",
      "Stenose des Ductus nasolacrimalis",
      "Stenose des Punctum lacrimale",
      "Striktur des Ductus lacrimalis",
      "Striktur des Ductus nasolacrimalis",
      "Striktur des Punctum lacrimale",
      "Tränenabflussstörung",
      "Tränengangobstruktion",
      "Tränengangsstenose",
      "Tränengangverschluss",
      "Tränenkanalstenose",
      "Tränennasengangsstenose",
      "Tränennasengangverschluss",
      "Tränenpünktchenstenose",
      "Tränenpünktchenstriktur",
      "Tränensackhydrops",
      "Tränensackstenose",
      "Tränenweginduration",
      "Tränenwegnarbe",
      "Tränenwegobstruktion",
      "Tränenwegstein",
      "Tränenwegstenose",
      "Tränenwegstriktur",
      "Tränenwegverengung",
      "Tränenwegverhärtung",
      "Tränenwegverschluss",
      "Tränenwegverstopfung",
      "Verschluss des Ductus nasolacrimalis"
    ]
  },
  {
    "code": "H04.6",
    "name": "Zyste der Tränenwege",
    "synonyms": [
      "Dakryoma",
      "Dakryozystozele",
      "Erworbene Deformität der Caruncula lacrimalis",
      "Erworbene Deformität des Canaliculus lacrimalis",
      "Erworbene Tränengangdeformität a.n.k.",
      "Erworbene Tränenkanaldeformität",
      "Erworbene Tränenwegdeformität a.n.k.",
      "Fistel des Ductus nasolacrimalis",
      "Fistel des Tränen-Nasenganges",
      "Fistula lacrimalis",
      "Granulom des Canaliculus lacrimalis",
      "Mukozele der Tränenwege",
      "Triefauge",
      "Tränendrüsenfistel",
      "Tränengangdilatation",
      "Tränengangfistel",
      "Tränensackfistel",
      "Tränensackgranulom",
      "Tränensackretentionszyste",
      "Tränenwegfistel",
      "Tränenwegzyste",
      "Zyste der Tränenwege"
    ]
  },
  {
    "code": "H04.8",
    "name": "Lakrimale Zyste",
    "synonyms": [
      "Lakrimale Zyste",
      "Tränenzyste"
    ]
  },
  {
    "code": "H04.9",
    "name": "Affektion des Tränenapparates",
    "synonyms": [
      "Affektion des Tränenapparates",
      "Krankheit des Tränenapparates a.n.k.",
      "Tränenproblem",
      "Vermehrter Tränenfluss"
    ]
  },
  {
    "code": "H05.0",
    "name": "Akute Orbitaentzündung",
    "synonyms": [
      "Akute Augenhöhlenentzündung",
      "Akute Orbitaentzündung",
      "Augenhöhlenabszess",
      "Augenhöhlenfurunkel",
      "Augenhöhlenkarbunkel",
      "Augenhöhlenosteomyelitis",
      "Augenhöhlenphlegmone",
      "Entzündung der Tenon-Kapsel",
      "Intraorbitaler Abszess",
      "Orbitaabszess",
      "Orbitafurunkel",
      "Orbitainfektion",
      "Orbitakarbunkel",
      "Orbitale Periostitis",
      "Orbitaosteomyelitis",
      "Orbitaperiostitis",
      "Orbitaphlegmone",
      "Periorbitale Infektion",
      "Retrobulbärabszess",
      "Tenonitis",
      "Tenonitis der Augapfelkapsel",
      "Zellgewebsentzündung der Orbita"
    ]
  },
  {
    "code": "H05.1",
    "name": "Pseudotumor der Orbita",
    "synonyms": [
      "Augenhöhlenentzündung",
      "Augenhöhlengranulom",
      "Chronische Orbitaentzündung",
      "Chronische Orbitamyositis",
      "Entzündliches Orbitaödem",
      "Fremdkörpergranulom der Orbita",
      "Orbitagranulom",
      "Orbitamyositis",
      "Orbitanekrose",
      "Orbitasequester",
      "Pseudotumor der Orbita"
    ]
  },
  {
    "code": "H05.2",
    "name": "Orbitaödem",
    "synonyms": [
      "Augapfelverlagerung",
      "Augenhöhlenödem",
      "Benignes Exophthalmus-Syndrom",
      "Exophthalmus",
      "Exophthalmus durch Orbitahämatom",
      "Haemophthalmus externus",
      "Intermittierender Exophthalmus a.n.k.",
      "Lageveränderung des Augapfels",
      "Laterale Lageveränderung des Augapfels",
      "Nichttraumatisches Augenhöhlenhämatom",
      "Nichttraumatisches Orbitahämatom",
      "Orbitablutung",
      "Orbitahämatom",
      "Orbitahämorrhagie",
      "Orbitaödem",
      "Proptosis",
      "Proptosis des Auges",
      "Protrusio bulbi",
      "Pseudoexophthalmus",
      "Pulsierender Exophthalmus"
    ]
  },
  {
    "code": "H05.3",
    "name": "Orbitadeformation",
    "synonyms": [
      "Erworbene Augenhöhlendeformität",
      "Erworbene Orbitadeformität",
      "Orbitaatrophie",
      "Orbitadeformation",
      "Orbitaexostose"
    ]
  },
  {
    "code": "H05.4",
    "name": "Enophthalmus",
    "synonyms": [
      "Enophthalmus",
      "Pseudoenophthalmus"
    ]
  },
  {
    "code": "H05.5",
    "name": "Alter Fremdkörper nach perforierender Orbitaverletzung",
    "synonyms": [
      "Alter Fremdkörper nach perforierender Orbitaverletzung",
      "Retinierter Fremdkörper in der Augenhöhle",
      "Retinierter alter Fremdkörper in der Orbita",
      "Retinierter alter Fremdkörper in einem Augenmuskel",
      "Retinierter retrobulbärer Fremdkörper",
      "Retrobulbärer Fremdkörper",
      "Retrobulbärer Fremdkörper nach perforierender Verletzung"
    ]
  },
  {
    "code": "H05.8",
    "name": "Venenthrombose der Orbita",
    "synonyms": [
      "Arteriovenöse Fistel der Orbita",
      "Augenhöhlenemphysem",
      "Augenhöhlenfistel",
      "Augenhöhlenzyste",
      "Fettgewebsatrophie der Orbita",
      "Myopathie der äußeren Augenmuskeln",
      "Orbitaemphysem",
      "Orbitafistel",
      "Orbitavarikose",
      "Orbitazyste",
      "Venenthrombose der Orbita"
    ]
  },
  {
    "code": "H05.9",
    "name": "Orbitaerkrankung",
    "synonyms": [
      "Augenhöhlenkrankheit",
      "Orbitaaffektion",
      "Orbitaerkrankung",
      "Orbitakrankheit",
      "Orbitopathie"
    ]
  },
  {
    "code": "H10.0",
    "name": "Mukopurulente Konjunktivitis",
    "synonyms": [
      "Bindehautabszess",
      "Eitrige Bindehautentzündung",
      "Eitrige Konjunktivaentzündung",
      "Eitrige Konjunktivitis",
      "Koch-Weeks-Konjunktivitis",
      "Konjunktivaabszess",
      "Mukopurulente Konjunktivitis",
      "Purulente Ophthalmie"
    ]
  },
  {
    "code": "H10.1",
    "name": "Akute allergische Konjunktivitis",
    "synonyms": [
      "Akute allergische Konjunktivitis",
      "Akute allergische Ophthalmie",
      "Akute atopische Konjunktivitis",
      "Allergische Augenentzündung",
      "Allergische Bindehautentzündung",
      "Allergische Konjunktivaentzündung",
      "Allergische Konjunktivitis",
      "Bindehautallergie",
      "Conjunctivitis allergica acuta",
      "Frühjahrs-Augenkatarrh",
      "Frühjahrs-Ophthalmie",
      "Hyperergische Konjunktivitis",
      "Konjunktivaallergie",
      "Konjunktivitis bei Heuschnupfen"
    ]
  },
  {
    "code": "H10.2",
    "name": "Konjunktivitis durch chemisch-physikalische Einflüsse",
    "synonyms": [
      "Akuter Augenkatarrh",
      "Conjunctivitis nodosa",
      "Conjunctivitis nodosa acuta",
      "Katarrhalische Ophthalmie",
      "Konjunktivitis durch Staub",
      "Konjunktivitis durch chemisch-physikalische Einflüsse",
      "Morax-Axenfeld-Konjunktivitis"
    ]
  },
  {
    "code": "H10.3",
    "name": "Akute Bindehautentzündung",
    "synonyms": [
      "Akute Bindehautentzündung",
      "Akute Konjunktivaentzündung",
      "Akute Konjunktivitis",
      "Conjunctivitis aestivalis"
    ]
  },
  {
    "code": "H10.4",
    "name": "Chronische Konjunktivitis",
    "synonyms": [
      "Akuter Schub einer chronischen Konjunktivitis",
      "Bindehautgranulom",
      "Chronische Bindehautentzündung",
      "Chronische Konjunktivaentzündung",
      "Chronische Konjunktivitis",
      "Chronische Konjunktivitis durch Staphylococcus aureus",
      "Conjunctivitis allergica chronica",
      "Conjunctivitis follicularis chronica",
      "Conjunctivitis nodosa chronica",
      "Conjunctivitis petrificans",
      "Conjunctivitis phlyktaenulosa",
      "Conjunctivitis vernalis",
      "Fremdkörpergranulom der Bindehaut",
      "Fremdkörpergranulom der Konjunktiva",
      "Konjunktivagranulom",
      "Lignöse Konjunktivitis",
      "Rezidivierende Konjunktivitis"
    ]
  },
  {
    "code": "H10.5",
    "name": "Blepharokonjunktivitis",
    "synonyms": [
      "Abszess des Augenlidwinkels",
      "Allergische Blepharokonjunktivitis",
      "Blepharokonjunktivitis",
      "Chronische Blepharokonjunktivitis",
      "Chronische purulente Blepharokonjunktivitis",
      "Einfache Blepharokonjunktivitis",
      "Eitrige Blepharokonjunktivitis",
      "Kanthusabszess"
    ]
  },
  {
    "code": "H10.8",
    "name": "Bakterielle Bindehautentzündung",
    "synonyms": [
      "Abakterielle Konjunktivitis",
      "Bakterielle Bindehautentzündung",
      "Bakterielle Konjunktivaentzündung",
      "Bakterielle Konjunktivitis",
      "Bindehautgeschwür",
      "Follikulärer Katarrh",
      "Gigantopapilläre Konjunktivitis",
      "Infektiöse Konjunktivitis a.n.k.",
      "Konjunktivageschwür",
      "Konjunktivaulkus",
      "Mechanische Konjunktivitis",
      "Medikamentöse Konjunktivitis",
      "Nicht medikamentöse chemische Konjunktivitis",
      "Okuloglanduläres Syndrom (Parinaud)",
      "Parinaud-Konjunktivitis",
      "Pyogene Konjunktivitis",
      "Rhinoconjunctivitis allergica saisonalis",
      "Rhinoconjunctivitis pollinosa",
      "Rhinokonjunktivitis",
      "Riesenpapillenkonjunktivitis",
      "Saisonale Rhinokonjunktivitis",
      "Seröse Konjunktivitis"
    ]
  },
  {
    "code": "H10.9",
    "name": "Ophthalmie",
    "synonyms": [
      "Bindehautentzündung",
      "Bindehautkatarrh",
      "Conjunctivitis - s.a. Konjunktivitis",
      "Conjunctivitis simplex",
      "Entzündung der Tunica conjunctiva",
      "Konjunktivaentzündung",
      "Konjunktivakatarrh",
      "Konjunktivitis",
      "Ophthalmia",
      "Ophthalmie"
    ]
  },
  {
    "code": "H11.0",
    "name": "Pterygium der Konjunktiva",
    "synonyms": [
      "Familiäres Pterygium conjunctivae",
      "Flügelfell des Auges",
      "Pterygium",
      "Pterygium der Konjunktiva",
      "Pterygium des Auges",
      "Pterygiumrezidiv des Auges"
    ]
  },
  {
    "code": "H11.1",
    "name": "Konjunktivaargyrose",
    "synonyms": [
      "Bindehautdegeneration",
      "Bindehauteinlagerung",
      "Bindehautmelanose",
      "Bindehautxerose",
      "Konjunktivaablagerung",
      "Konjunktivaargyrie a.n.k.",
      "Konjunktivaargyrose",
      "Konjunktivadegeneration",
      "Konjunktivaeinlagerung",
      "Konjunktivainduration",
      "Konjunktivakalzifikation",
      "Konjunktivakonkrement",
      "Konjunktivale Konkremente",
      "Konjunktivale Pigmentierung",
      "Konjunktivamelanose",
      "Konjunktivapigmentierung",
      "Konjunktivastein",
      "Konjunktivaverhärtung",
      "Konjunktivaxerose",
      "Lidspaltenfleck",
      "Pinguecula",
      "Xerosis conjunctivae",
      "Xerosis conjunctivae mit Bitot-Flecken"
    ]
  },
  {
    "code": "H11.2",
    "name": "Konjunktivanarbe",
    "synonyms": [
      "Bindehautadhäsion",
      "Bindehautnarbe",
      "Blepharosynechie",
      "Erworbene Adhäsion der Konjunktiva",
      "Konjunktivanarbe",
      "Lidverklebung",
      "Symblepharon"
    ]
  },
  {
    "code": "H11.3",
    "name": "Konjunktivablutung",
    "synonyms": [
      "Bindehautblutung",
      "Ekchymose der Konjunktiva",
      "Hyposphagma",
      "Konjunktivablutung",
      "Konjunktivahyposphagma",
      "Konjunktivahämorrhagie",
      "Subkonjunktivale Blutung",
      "Subkonjunktivale Hämorrhagie"
    ]
  },
  {
    "code": "H11.4",
    "name": "Gefäßkrankheit der Konjunktiva",
    "synonyms": [
      "Augenhyperämie",
      "Bindehautaneurysma",
      "Bindehautchemosis",
      "Bindehautzyste",
      "Bindehautödem",
      "Gefäßkrankheit der Konjunktiva",
      "Kanthuszyste",
      "Konjunktivaaneurysma",
      "Konjunktivachemosis",
      "Konjunktivahyperämie",
      "Konjunktivale Augenwinkelzyste",
      "Konjunktivale Hyperämie",
      "Konjunktivale Thrombose",
      "Konjunktivales Aneurysma",
      "Konjunktivales Ödem",
      "Konjunktivazyanose",
      "Konjunktivazyste",
      "Konjunktivaödem",
      "Retentionszyste der Bindehaut",
      "Retentionszyste der Konjunktiva",
      "Vaskuläre Bindehautveränderung",
      "Vaskuläre Konjunktivaveränderung"
    ]
  },
  {
    "code": "H11.8",
    "name": "Bindehautschwellung",
    "synonyms": [
      "Bindehauthypertrophie",
      "Bindehautschrumpfung",
      "Bindehautschwellung",
      "Emphysem der Konjunktiva",
      "Konjunktivaschrumpfung",
      "Konjunktivaschwellung",
      "Lymphangiektasie der Konjunktiva",
      "Lymphoide Hypertrophie der Konjunktiva",
      "Pseudopterygium",
      "Reaktive lymphoide Bindehautinfiltration",
      "Reaktive lymphoide Konjunktivainfiltration",
      "Senile Konjunktivaatrophie"
    ]
  },
  {
    "code": "H11.9",
    "name": "Bindehauterkrankung",
    "synonyms": [
      "Bindehauterkrankung",
      "Bindehautkrankheit",
      "Bindehautreizung",
      "Konjunktivaaffektion",
      "Konjunktivakrankheit",
      "Konjunktivareizung",
      "Konjunktivaschädigung",
      "Reizzustand der Bindehaut",
      "Reizzustand der Konjunktiva"
    ]
  },
  {
    "code": "H15.0",
    "name": "Skleritis",
    "synonyms": [
      "Eitrige Skleritis",
      "Granulomatöse Skleritis",
      "Idiopathische Skleritis",
      "Immunvermittelte Skleritis",
      "Infektiöse Skleritis",
      "Lederhautabszess",
      "Lederhautentzündung",
      "Skleraabszess",
      "Skleraentzündung",
      "Skleraulkus",
      "Skleritis",
      "Skleritis anterior",
      "Skleritis anularis",
      "Skleritis posterior",
      "Sklerokonjunktivitis",
      "Sklerotenonitis"
    ]
  },
  {
    "code": "H15.1",
    "name": "Episkleritis",
    "synonyms": [
      "Eitrige Episkleritis",
      "Episcleritis periodica fugax",
      "Episkleraentzündung",
      "Episkleritis"
    ]
  },
  {
    "code": "H15.8",
    "name": "Hyalinflecken der Sklera",
    "synonyms": [
      "Anteriores Staphylom",
      "Glaskörpersubstanzverlust",
      "Hyaline Skleradegeneration",
      "Hyalinflecken der Sklera",
      "Peripapilläres Staphylom",
      "Posteriores Staphylom",
      "Scleromalacia",
      "Scleromalacia perforans",
      "Senile Hyalinflecken der Sklera",
      "Skleraatrophie",
      "Skleraektasie",
      "Sklerafistel",
      "Sklerakalzifikation",
      "Skleramelanose",
      "Skleranekrose",
      "Skleraossifikation",
      "Sklerastaphylom",
      "Sklerastaphyloma",
      "Sklerazyste",
      "Skleromalazie",
      "Staphylom",
      "Staphyloma",
      "Staphyloma posticum",
      "Staphyloma posticum ohne degenerative Myopie",
      "Ziliares Staphylom",
      "Äquatoriales Sklerastaphylom",
      "Äquatoriales Staphylom"
    ]
  },
  {
    "code": "H15.9",
    "name": "Skleraerkrankung",
    "synonyms": [
      "Lederhautkrankheit des Auges",
      "Skleraerkrankung",
      "Sklerakrankheit"
    ]
  },
  {
    "code": "H16.0",
    "name": "Ulcus corneae",
    "synonyms": [
      "Chronisches Ulkus mit Hypopyon",
      "Erosio corneae",
      "Geschwür des Hornhautrandes",
      "Hornhauterosion",
      "Hornhautgeschwür",
      "Hornhautperforation durch Geschwür",
      "Hornhautulkus des Auges",
      "Keratitis mit Hypopyon",
      "Keratitis mit Ulzeration",
      "Keratitisgeschwür",
      "Korneaperforation durch Ulzeration",
      "Marginale Keratitis",
      "Marginales Hornhautulkus",
      "Marginales Ulcus corneae",
      "Mooren-Ulkus",
      "Nichttraumatische Erosion der Kornea",
      "Perforiertes Ulcus corneae",
      "Rheumatisches Hornhautringulkus",
      "Ringförmiges Ulcus corneae",
      "Subakutes Ulkus mit Hypopyon",
      "Sämisch-Geschwür",
      "Sämisch-Geschwür der Kornea",
      "Ulcus corneae",
      "Ulcus corneae marginale",
      "Ulcus corneae mit Hypopyon",
      "Ulcus corneae rodens (Mooren)",
      "Ulcus serpens corneae",
      "Ulzeröse Keratitis",
      "Xerosis corneae mit Ulkus",
      "Zentrales Ulcus corneae"
    ]
  },
  {
    "code": "H16.1",
    "name": "Ophthalmia electrica",
    "synonyms": [
      "Aktinische Keratitis",
      "Fädchenkeratitis",
      "Hornhautstippung",
      "Keratitis actinica",
      "Keratitis areolaris",
      "Keratitis filiformis",
      "Keratitis nummularis",
      "Keratitis photoelectrica",
      "Keratitis punctata",
      "Keratitis punctata superficialis",
      "Keratitis stellata",
      "Keratitis striata",
      "Keratitis superficialis",
      "Keratitis superficialis punctata",
      "Keratitis superficialis punctata Thygeson",
      "Lichtkeratitis",
      "Oberflächliche Keratitis ohne Konjunktivitis",
      "Ophthalmia actinica",
      "Ophthalmia electrica",
      "Ophthalmia photoelectrica",
      "Ophthalmie durch Ultraviolettstrahlen",
      "Photokeratitis",
      "Photophthalmie",
      "Randkeratitis",
      "Schneeblindheit",
      "Streifenkeratitis",
      "Verblitzung beim Schweißen"
    ]
  },
  {
    "code": "H16.2",
    "name": "Keratokonjunktivitis",
    "synonyms": [
      "Allergische Keratokonjunktivitis",
      "Allergische Phlyktäne",
      "Atopische Keratokonjunktivitis",
      "Chronische Keratokonjunktivitis",
      "Expositionskeratokonjunktivitis",
      "Immunogenes Hornhautinfiltrat durch Staphylokokken",
      "Immunogenes Hornhautinfiltrat durch Staphylokokken-Blepharokonjunktivitis",
      "Keratitis e lagophthalmo",
      "Keratitis neuroparalytica",
      "Keratitis phlyctaenulosa",
      "Keratitis superficialis mit Konjunktivitis",
      "Keratoconjunctivitis ekzematosa",
      "Keratoconjunctivitis neuroparalytica",
      "Keratoconjunctivitis phlyctaenulosa",
      "Keratoendotheliitis fugax hereditaria",
      "Keratokonjunktivitis",
      "Keratokonjunktivitis actinica",
      "Keratokonjunktivitis bei Lagophthalmus",
      "Keratokonjunktivitis vernalis",
      "Lagophthalmische Keratitis",
      "Limbale obere Keratokonjunktivitis",
      "Nichttuberkulöse Phlyktäne",
      "Nichttuberkulöse Phlyktänenbildung",
      "Oberflächliche Keratitis mit Konjunktivitis",
      "Ophthalmia nodosa",
      "Phlyktäne",
      "Phlyktänenbildung",
      "Phlyktänenbildung der Hornhaut",
      "Photoelektrische Keratokonjunktivitis",
      "Verblitzung mit Konjunktivitis",
      "Xerophthalmie nicht im Zusammenhang mit Vitamin-A-Mangel"
    ]
  },
  {
    "code": "H16.3",
    "name": "Keratitis parenchymatosa",
    "synonyms": [
      "Cogan-I-Syndrom",
      "Hornhautabszess",
      "Idiopathische lineare interstitielle Keratitis",
      "Interstitielle Keratitis",
      "Keratitis parenchymatosa",
      "Keratitis profunda",
      "Korneaabszess",
      "Nichtsyphilitische interstitielle Keratitis",
      "Sklerosierende Keratitis",
      "Stromakeratitis",
      "Tiefe Keratitis"
    ]
  },
  {
    "code": "H16.4",
    "name": "Hornhautneovaskularisation",
    "synonyms": [
      "Allergischer Pannus",
      "Allergischer Pannus eccematosus",
      "Gefäßeinsprossung der Hornhaut",
      "Ghost-vessel-Hornhaut",
      "Hornhautneovaskularisation",
      "Hornhautvaskularisation",
      "Hornhautvaskularisation durch weiche Kontaktlinsen",
      "Korneaneovaskularisation",
      "Obliteration eines Hornhautgefäßes",
      "Pannus",
      "Pannus corneae",
      "Pannus degenerativus",
      "Pannus der Kornea",
      "Pannus inflammatorius",
      "Stromale Hornhautvaskularisation",
      "Totale Hornhautvaskularisation"
    ]
  },
  {
    "code": "H16.8",
    "name": "Thygesson-Keratitis",
    "synonyms": [
      "Chronische Hornhautentzündung",
      "Chronische Keratitis",
      "Eitrige Keratitis",
      "Endotheliitis corneae",
      "Hereditäre Keratitis",
      "Keratitis bullosa",
      "Keratitis ekzematosa",
      "Keratitis petrificans",
      "Keratitis purulenta",
      "Sklerokeratitis",
      "Thygesson-Keratitis",
      "Ulzeröse eitrige Keratitis",
      "Vesikuläre Keratitis",
      "Xerotische Keratitis"
    ]
  },
  {
    "code": "H16.9",
    "name": "Keratitis",
    "synonyms": [
      "Hornhautentzündung",
      "Keratitis",
      "Korneaentzündung",
      "Nichtulzeröse Keratitis"
    ]
  },
  {
    "code": "H17.0",
    "name": "Leukoma adhaerens",
    "synonyms": [
      "Leukoma adhaerens"
    ]
  },
  {
    "code": "H17.1",
    "name": "Zentrale Hornhauttrübung a.n.k.",
    "synonyms": [
      "Zentrale Hornhauttrübung a.n.k.",
      "Zentrale Undurchsichtigkeit der Kornea a.n.k."
    ]
  },
  {
    "code": "H17.8",
    "name": "Periphere Hornhauttrübung",
    "synonyms": [
      "Korneakeloid",
      "Korneasklerose",
      "Leucoma corneae",
      "Leukom",
      "Leukoma",
      "Maculae corneae",
      "Nebula corneae",
      "Periphere Hornhauttrübung",
      "Totale Hornhauttrübung",
      "Xerophthalmische Korneanarbe"
    ]
  },
  {
    "code": "H17.9",
    "name": "Hornhauttrübung",
    "synonyms": [
      "Hornhautnarbe",
      "Hornhauttrübung",
      "Hornhautundurchsichtigkeit",
      "Korneaadhäsion",
      "Korneanarbe",
      "Korneaundurchsichtigkeit",
      "Opacitas corneae [Hornhauttrübung]"
    ]
  },
  {
    "code": "H18.0",
    "name": "Kayser-Fleischer-Kornealring a.n.k.",
    "synonyms": [
      "Blutflecken der Hornhaut",
      "Chalcosis corneae",
      "Chalkose der Kornea",
      "Hornhautablagerung des Auges",
      "Hornhautpigmentation",
      "Hornhautpigmentierung durch Hornhauteinlagerung",
      "Hornhauttüpfelung",
      "Hudson-Linie der Kornea",
      "Hämatokornea",
      "Kayser-Fleischer-Kornealring a.n.k.",
      "Kayser-Fleischer-Pigmentring",
      "Keratohämie",
      "Korneaablagerung",
      "Krukenberg-Axenfeld-Spindel",
      "Krukenberg-Spindel",
      "Melanosis corneae",
      "Pigmentierung des Limbus corneae",
      "Präsenile Korneamelanose",
      "Senile Korneamelanose",
      "Stähli-Linie der Hornhaut",
      "Stähli-Pigmentlinie",
      "Stähli-Pigmentlinie der Kornea",
      "Verfärbung der Hornhaut des Auges"
    ]
  },
  {
    "code": "H18.1",
    "name": "Keratopathia bullosa",
    "synonyms": [
      "Bullöse Keratopathie",
      "Bullöse Keratopathie durch Glaukom",
      "Keratopathia bullosa",
      "Keratopathia bullosa bei Hornhautdekompensation",
      "Keratopathia bullosa bei Hornhautdystrophie",
      "Keratopathia bullosa durch Glaukom",
      "Keratopathia bullosa durch IOL [Intraokulare Linse]"
    ]
  },
  {
    "code": "H18.2",
    "name": "Hornhautödem",
    "synonyms": [
      "Epithelödem der Hornhaut",
      "Hornhautödem",
      "Immunogenes Hornhautinfiltrat",
      "Infiltration der Hornhaut des Auges",
      "Korneainfiltration",
      "Korneaödem a.n.k."
    ]
  },
  {
    "code": "H18.3",
    "name": "Descemetfalte",
    "synonyms": [
      "Descemetfalte",
      "Descemetruptur",
      "Falte der Descemet-Membran",
      "Membranenveränderung der Hornhaut",
      "Ruptur der Descemet-Membran",
      "Veränderung der Descemet-Membran"
    ]
  },
  {
    "code": "H18.4",
    "name": "Hereditäre primäre Banddegeneration der Hornhaut",
    "synonyms": [
      "Arcus lipoides",
      "Arcus lipoides corneae",
      "Arcus senilis",
      "Arcus senilis der Kornea",
      "Bandförmige Hornhautdegeneration",
      "Bandförmige Keratopathie",
      "Degenerative Cornea guttata",
      "Degenerative Hornhauttrübung",
      "Degenerative Undurchsichtigkeit der Kornea",
      "Facette der Kornea",
      "Gerontoxon",
      "Gerontoxon der Kornea",
      "Hassal-Henle-Warze",
      "Hereditäre primäre Banddegeneration der Hornhaut",
      "Hornhautabscherung",
      "Hornhautdegeneration des Auges",
      "Hornhauterweichung des Auges",
      "Hyaline Korneadegeneration",
      "Keratomalazie",
      "Korneadegeneration",
      "Krokodil-Chagrin-Hornhautdegeneration",
      "Linea corneae senilis",
      "Marginale Hornhautdegeneration Terrien",
      "Pelluzide marginale Hornhautdegeneration",
      "Salzmann-Dystrophie",
      "Salzmann-Hornhautdegeneration",
      "Senile Korneadegeneration",
      "Sphäroidale Hornhautdegeneration",
      "Terrien-Degeneration der Hornhaut",
      "Vogt-Limbusgürtel",
      "Vogt-Mosaikdegeneration der Augenhornhaut"
    ]
  },
  {
    "code": "H18.5",
    "name": "Hereditäre Hornhautdystrophie",
    "synonyms": [
      "Cornea guttata",
      "Cornea verticillata",
      "Dystrophia Smolandiensis",
      "Endotheldystrophie der Hornhaut",
      "Epitheliale Hornhautdystrophie",
      "Familiäre Korneadegeneration",
      "Fleckförmige Hornhautdystrophie",
      "Fuchs-Hornhautdystrophie",
      "Fuchs-Hornhautepithelendothel-Dystrophie",
      "Fuchs-II-Syndrom",
      "Gittrige Hornhautdystrophie",
      "Granuläre Hornhautdystrophie",
      "Granuläre Hornhautdystrophie Typ 1",
      "Granuläre Hornhautdystrophie Typ 2",
      "Grayson-Wilbrandt-Hornhautdystrophie",
      "Haab-Dimmer-Syndrom",
      "Hereditäre Hornhautdystrophie",
      "Hereditäre Hornhauttrübung",
      "Hereditäre Undurchsichtigkeit der Kornea",
      "Hornhautdystrophie Waardenburg-Jonker",
      "Hornhautdystrophie der Bowman-Lamelle Typ II",
      "Hornhautdystrophie der vorderen Membran",
      "Hornhautdystrophie mit gewundenen Filamenten",
      "Hornhautepitheldystrophie",
      "Hornhautstromadystrophie",
      "Juvenile Meesmann-Hornhautdystrophie",
      "Klimabedingte tropfenförmige Degeneration",
      "Kongenitale hereditäre Endotheldystrophie Typ 1",
      "Kongenitale hereditäre Endotheldystrophie Typ 2",
      "Kongenitale stromale Hornhautdystrophie",
      "Lisch-epitheliale Hornhautdystrophie",
      "Makuläre Hornhautdystrophie",
      "Map-Dot-Fingerprint-Hornhautdystrophie",
      "Marginale kristalline Hornhautdystrophie",
      "Mikrozystische Cogan-Hornhautdystrophie",
      "Mouchetée-Hornhautdystrophie",
      "Posteriore amorphe Hornhautdystrophie",
      "Posteriore polymorphe Hornhautdystrophie",
      "Prädescemet-Hornhautdystrophie",
      "Reis-Bücklers-Hornhautdystrophie",
      "Schnyder-Hornhautdystrophie",
      "Stromale Hornhautdystrophie",
      "Subepitheliale Hornhautdystrophie",
      "Subepitheliale muzinöse Hornhautdystrophie",
      "Thiel-Behnke-Hornhautdystrophie",
      "Tropfenförmige gelatinöse Hornhautdystrophie",
      "Wabenförmige Hornhautdystrophie",
      "X-chromosomale Endotheldystrophie der Hornhaut",
      "Zentral-wolkenförmige Dystrophie von François",
      "Zentrale kristalline Hornhautdystrophie"
    ]
  },
  {
    "code": "H18.6",
    "name": "Keratokonus",
    "synonyms": [
      "Keratokonus",
      "Konische Kornea"
    ]
  },
  {
    "code": "H18.7",
    "name": "Hornhautdellen des Auges",
    "synonyms": [
      "Descemetozele",
      "Erworbene Korneadeformität",
      "Hornhautdeformität",
      "Hornhautdellen des Auges",
      "Hornhautektasie",
      "Hornhautstaphylom",
      "Hornhautverkrümmung",
      "Irreguläre Kontur der Kornea",
      "Keratektasie",
      "Keratodermatozele",
      "Keratoektasie",
      "Keratoglobus",
      "Keratozele",
      "Korneaektasie",
      "Staphyloma corneae"
    ]
  },
  {
    "code": "H18.8",
    "name": "Keratopathia medicamentosa",
    "synonyms": [
      "Erosion bei Keratopathie",
      "Hornhautanästhesie",
      "Hornhauthypästhesie",
      "Hornhautzyste",
      "Keratokonjunktivale Benetzungsstörung",
      "Keratopathia medicamentosa",
      "Kontaktlinsenintoleranz",
      "Kontaktlinsenunverträglichkeit",
      "Korneagangrän",
      "Kornealanästhesie",
      "Kornealhypoästhesie",
      "Kornealhypästhesie",
      "Korneanekrose",
      "Korneazyste",
      "Limbusstammzellinsuffizienz",
      "Medikamententoxische Keratopathie",
      "Rekurrente Hornhauterosion",
      "Rekurrente Korneaerosion",
      "Rezidivierende Erosio corneae",
      "Rezidivierende Hornhauterosion",
      "Xerosis corneae"
    ]
  },
  {
    "code": "H18.9",
    "name": "Keratopathie",
    "synonyms": [
      "Hornhautaffektion des Auges",
      "Hornhauterkrankung des Auges",
      "Hornhautkrankheit des Auges",
      "Hornhautreizung des Auges",
      "Hornhautveränderung des Auges",
      "Keratopathie",
      "Korneakrankheit"
    ]
  },
  {
    "code": "H20.0",
    "name": "Fibrinöse Iritis",
    "synonyms": [
      "Akute Iridozyklitis",
      "Akute Iritis",
      "Akute Uveitis anterior",
      "Akute Zyklitis",
      "Akute idiopathische Uveitis anterior",
      "Allergische Iridozyklitis",
      "Endogene Iridozyklitis",
      "Fibrinöse Iritis",
      "Hypopyon",
      "Hypopyon der vorderen Augenkammer",
      "Iridozyklitis bei Hypopyon",
      "Nichtgranulomatöse Iridozyklitis",
      "Rezidivierende Iridozyklitis",
      "Rezidivierende Iritis",
      "Rezidivierende Uveitis anterior",
      "Rezidivierende Zyklitis",
      "Subakute Iridozyklitis",
      "Subakute Iritis",
      "Subakute Uveitis anterior",
      "Subakute Zyklitis"
    ]
  },
  {
    "code": "H20.1",
    "name": "Chronische Iridozyklitis",
    "synonyms": [
      "Chronische Iridozyklitis",
      "Chronische Zyklitis",
      "Chronische idiopathische Uveitis anterior",
      "Granulomatöse Iridozyklitis",
      "Granulomatöse Iritis"
    ]
  },
  {
    "code": "H20.2",
    "name": "Phakogene Iridozyklitis",
    "synonyms": [
      "Iridozyklitis mit Linseninduration",
      "Linsen-induzierte Iridozyklitis",
      "Linsen-induzierte Uveitis",
      "Phakoanaphylaktische Uveitis",
      "Phakogene Iridozyklitis"
    ]
  },
  {
    "code": "H20.8",
    "name": "Seröse Iritis",
    "synonyms": [
      "Begleitiritis",
      "Fuchs-Heterochromiezyklitis",
      "Fuchs-III-Syndrom [Heterochrome Zyklitis]",
      "Heterochrome Uveitis",
      "Heterochrome Zyklitis",
      "Heterochromie bei Iritis",
      "Heterochromie bei Uveitis",
      "Idiopathische Uveitis anterior",
      "Irisabszess",
      "Regenbogenhautabszess",
      "Seröse Iritis",
      "Ziliarkörperabszess"
    ]
  },
  {
    "code": "H20.9",
    "name": "Keratoiritis",
    "synonyms": [
      "Cyclitis - s.a. Zyklitis",
      "Entzündung des Uvealtraktes",
      "Infektiöse Uveitis anterior",
      "Iridozyklitis",
      "Iritis",
      "Keratoiritis",
      "Keratouveitis",
      "Regenbogenhautentzündung",
      "Strahlenkörperentzündung",
      "Uveaentzündung a.n.k.",
      "Uveitis",
      "Uveitis anterior",
      "Uveokeratitis",
      "Ziliarkörperentzündung",
      "Zyklitis"
    ]
  },
  {
    "code": "H21.0",
    "name": "Hyphäma",
    "synonyms": [
      "Blutung der vorderen Augenkammer",
      "Hyphäma",
      "Hämorrhagie der vorderen Augenkammer",
      "Irisblutung",
      "Irishämorrhagie",
      "Postentzündliche Irisblutung",
      "Postentzündliche Irishämorrhagie",
      "Postinfektiöse Irisblutung",
      "Postinfektiöse Irishämorrhagie",
      "Toxische Irisblutung",
      "Toxische Irishämorrhagie",
      "Ziliarkörperblutung",
      "Ziliarkörperhämorrhagie"
    ]
  },
  {
    "code": "H21.1",
    "name": "Ziliarkörperneovaskularisation",
    "synonyms": [
      "Gefäßaffektion des Ziliarkörpers",
      "Gefäßkrankheit der Iris",
      "Gefäßneubildung der Iris",
      "Gefäßneubildung des Ziliarkörpers",
      "Gefäßveränderung der Iris",
      "Irisaneurysma",
      "Irishyperämie",
      "Neovaskularisation der Iris",
      "Rubeosis iridis",
      "Ziliarkörpergefäßkrankheit a.n.k.",
      "Ziliarkörperneovaskularisation"
    ]
  },
  {
    "code": "H21.2",
    "name": "Pupillarsaumatrophie",
    "synonyms": [
      "BADI [Bilaterale akute Depigmentierung der Iris]",
      "Bilaterale akute Depigmentierung der Iris",
      "Erworbene Irisheterochromie",
      "Essentielle Irisatrophie",
      "Essentielle progressive Irisatrophie",
      "Iridoschisis",
      "Irisatrophie",
      "Irisdegeneration",
      "Irisdurchleuchtbarkeit",
      "Irisdurchsichtigkeit",
      "Miotische Pupillenzyste",
      "Pigmentblattdegeneration der Iris",
      "Pigmentdegeneration der Iris",
      "Pigmentierte Irisdegeneration",
      "Progressive Irisatrophie",
      "Pupillarsaumatrophie",
      "Pupillarsaumdegeneration",
      "Ziliarkörperatrophie",
      "Ziliarkörperdegeneration"
    ]
  },
  {
    "code": "H21.3",
    "name": "Iriszyste",
    "synonyms": [
      "Exsudative Iriszyste",
      "Exsudative Vorderkammerzyste",
      "Exsudative Ziliarkörperzyste",
      "Implantationszyste der Iris",
      "Implantationszyste der Vorderkammer",
      "Implantationszyste des Ziliarkörpers",
      "Iriszyste",
      "Parasitäre Iriszyste",
      "Parasitäre Vorderkammerzyste",
      "Parasitäre Ziliarkörperzyste",
      "Pupillarsaumzyste",
      "Ziliarkörperzyste",
      "Zyste der vorderen Augenkammer"
    ]
  },
  {
    "code": "H21.4",
    "name": "Seclusio pupillae",
    "synonyms": [
      "Iris bombée",
      "Occlusio pupillae",
      "Pupillarmembran",
      "Pupillenokklusion",
      "Pupillenverschluss",
      "Seclusio pupillae",
      "Zirkuläre Membran"
    ]
  },
  {
    "code": "H21.5",
    "name": "Erworbener Irisdefekt",
    "synonyms": [
      "Erworbene Ektopia pupillae",
      "Erworbene Irisdeformität",
      "Erworbene Pupillendeformität",
      "Erworbene Pupillenverziehung",
      "Erworbener Irisdefekt",
      "Goniosynechie",
      "Hintere Synechie",
      "Hintere Synechie des Auges",
      "Iridodialyse",
      "Irisabriss",
      "Irisadhäsion a.n.k.",
      "Irisdisruption a.n.k.",
      "Irisruptur",
      "Irreguläre Pupille",
      "Kammerwinkeldeformität",
      "Kammerwinkelrezessus",
      "Retroversion der Iris",
      "Synechie der Iris",
      "Synechie der Pupille",
      "Synechie des Auges",
      "Vordere Synechie",
      "Vordere Synechie des Auges",
      "Ziliarkörperabriss",
      "Ziliarkörperadhäsion a.n.k.",
      "Ziliarkörperdisruption a.n.k."
    ]
  },
  {
    "code": "H21.8",
    "name": "Cogan-Reese-Syndrom",
    "synonyms": [
      "Chandler-Syndrom",
      "Cogan-Reese-Syndrom",
      "ICE [Iridokorneales endotheliales Syndrom]",
      "Iridodonesis",
      "Iridokorneale endotheliale Dystrophie [ICE-Syndrom]",
      "Irisektropium",
      "Irisödem",
      "Nichttraumatischer Irisprolaps",
      "Uveaektropium",
      "Uvealstaphylom",
      "Ziliarmuskelspasmus",
      "Ödem der Regenbogenhaut"
    ]
  },
  {
    "code": "H21.9",
    "name": "Affektion der Iris und des Ziliarkörpers",
    "synonyms": [
      "Affektion der Iris und des Ziliarkörpers",
      "Iriskrankheit",
      "Krankheit der vorderen Augenkammer",
      "Krankheit des vorderen Uvealtraktes",
      "Regenbogenhautkrankheit",
      "Ziliarkörperaffektion",
      "Ziliarkörperkrankheit"
    ]
  },
  {
    "code": "H25.0",
    "name": "Cataracta senilis incipiens",
    "synonyms": [
      "Cataracta senilis coronaria",
      "Cataracta senilis corticalis",
      "Cataracta senilis incipiens",
      "Cataracta senilis punctata",
      "Cataracta senilis subcapsularis anterior",
      "Cataracta senilis subcapsularis posterior",
      "Rindenstar",
      "Senile subkapsuläre Katarakt",
      "Senile subkapsuläre anteriore Katarakt",
      "Senile subkapsuläre posteriore Katarakt",
      "Wasserspalten-Speichen-Katarakt"
    ]
  },
  {
    "code": "H25.1",
    "name": "Cataracta brunescens",
    "synonyms": [
      "Cataracta brunescens",
      "Cataracta nuclearis mit Sklerose",
      "Cataracta nuclearis senilis",
      "Cataracta senilis brunescens",
      "Cataracta senilis nuclearis",
      "Kernsklerose-Katarakt",
      "Linsenkernsklerose",
      "Senile Linsenkernsklerose"
    ]
  },
  {
    "code": "H25.2",
    "name": "Cataracta senilis vom Morgagni-Typ",
    "synonyms": [
      "Cataracta senilis hypermatura",
      "Cataracta senilis vom Morgagni-Typ",
      "Katarakt vom Morgagni-Typ"
    ]
  },
  {
    "code": "H25.8",
    "name": "Cataracta senilis intumescens",
    "synonyms": [
      "Cataracta senilis intumescens",
      "Cataracta senilis provecta",
      "Cataracta senilis subcapsularis provecta",
      "Cataracta senilis, Mischform",
      "Kombinierte Kataraktform"
    ]
  },
  {
    "code": "H25.9",
    "name": "Grauer Altersstar",
    "synonyms": [
      "Alterskatarakt",
      "Altersstar",
      "Cataracta senilis",
      "Cataracta senilis matura",
      "Grauer Altersstar",
      "Senile Katarakt"
    ]
  },
  {
    "code": "H26.0",
    "name": "Infantile Katarakt",
    "synonyms": [
      "Infantile Katarakt",
      "Juvenile Katarakt",
      "Primär membranöse Katarakt",
      "Primäre Katarakt",
      "Präsenile Katarakt"
    ]
  },
  {
    "code": "H26.1",
    "name": "Cataracta traumatica",
    "synonyms": [
      "Cataracta traumatica",
      "Kontusionskatarakt",
      "Kontusionsrosette der Linse",
      "Metallosis lentis",
      "Siderosis lentis",
      "Traumatische Katarakt",
      "Wundstar"
    ]
  },
  {
    "code": "H26.2",
    "name": "Cataracta complicata",
    "synonyms": [
      "Cataracta complicata",
      "Cataracta secundaria bei Augenaffektion",
      "Glaukomflecken",
      "Heterochrome Katarakt",
      "Katarakt bei Heterochromie",
      "Katarakt infolge Augenkrankheit",
      "Katarakt mit chronischer Iridozyklitis",
      "Komplizierte Katarakt",
      "Sekundäre Katarakt bei Augenaffektion",
      "Subkapsuläre Glaukomflecken bei Katarakt"
    ]
  },
  {
    "code": "H26.3",
    "name": "Arzneimittelinduzierte Katarakt",
    "synonyms": [
      "Arzneimittelinduzierte Katarakt",
      "Medikamentös bedingte Katarakt",
      "Toxische Katarakt"
    ]
  },
  {
    "code": "H26.4",
    "name": "Cataracta secundaria",
    "synonyms": [
      "Cataracta secundaria",
      "Membranöse sekundäre Katarakt",
      "Nachstar",
      "Ringstar nach Soemmering"
    ]
  },
  {
    "code": "H26.8",
    "name": "Glasbläserstar",
    "synonyms": [
      "Cataracta corticonuclearis",
      "Cataracta corticonuclearis et capsularis posterior",
      "Cataracta corticonuclearis et subcapsularis posterior",
      "Cataracta corticonuclearis provecta",
      "Cataracta electrica",
      "Chalcosis lentis",
      "Feuerstar",
      "Glasbläser-Krankheit",
      "Glasbläserkatarakt",
      "Glasbläserstar",
      "Hintere subkapsuläre Katarakt",
      "Katarakt durch Lens tough",
      "Katarakt durch Wärmestrahlung",
      "Linsenchalkose",
      "Linsenkalzifikation",
      "Metallische Ablagerung in der Linse",
      "Pigmenteinlagerung in der Linse",
      "Pseudoexfoliatio lentis",
      "Pseudoexfoliation der Linsenkapsel",
      "Strahlenkatarakt",
      "Vordere subkapsuläre Katarakt"
    ]
  },
  {
    "code": "H26.9",
    "name": "Cataracta provecta",
    "synonyms": [
      "Beginnende Kerntrübung",
      "Cataracta",
      "Cataracta corticalis",
      "Cataracta immatura",
      "Cataracta incipiens",
      "Cataracta intumescens",
      "Cataracta matura",
      "Cataracta nuclearis",
      "Cataracta praematura",
      "Cataracta provecta",
      "Grauer Star - s.a. Cataracta oder s.a. Katarakt",
      "Intumeszenz der Linse",
      "Katarakt",
      "Kernstar",
      "Linsentrübung",
      "Linsenundurchsichtigkeit",
      "Nukleuskatarakt",
      "Rosettenstar"
    ]
  },
  {
    "code": "H27.0",
    "name": "Aphakie",
    "synonyms": [
      "Aphakie",
      "Aphakie ohne IOL [Intraokulare Linse]",
      "Erworbene Aphakie",
      "Erworbene beidseitige Aphakie",
      "Erworbene einseitige Aphakie",
      "Erworbenes Fehlen der Linse",
      "Linsenlosigkeit - s.a. Aphakie"
    ]
  },
  {
    "code": "H27.1",
    "name": "Linsenluxation",
    "synonyms": [
      "Linsendislokation",
      "Linsenluxation",
      "Linsensubluxation",
      "Linsenverlagerung"
    ]
  },
  {
    "code": "H27.8",
    "name": "Exfoliatio lentis",
    "synonyms": [
      "Augenlinsenabszess",
      "Augenlinsendegeneration",
      "Erworbene Deformität der Augenlinse",
      "Erworbene Lageanomalie der Linse",
      "Exfoliatio lentis",
      "Linsenvorfall",
      "Linsenzyste",
      "Phakozele"
    ]
  },
  {
    "code": "H27.9",
    "name": "Linsenaffektion",
    "synonyms": [
      "Linsenaffektion",
      "Linsenkrankheit"
    ]
  },
  {
    "code": "H30.0",
    "name": "Zentrale Uveitis posterior",
    "synonyms": [
      "Aderhautabszess",
      "Chorioideaabszess",
      "Chorioretinitis centralis serosa",
      "Chorioretinitis juxtapapillaris",
      "Fokale Chorioiditis",
      "Fokale Chorioretinitis",
      "Fokale Retinitis",
      "Fokale Retinochorioiditis",
      "Fokale Uveitis posterior",
      "Herdförmige Chorioiditis",
      "Herdförmige Chorioretinitis",
      "Herdförmige Retinitis",
      "Herdförmige Retinochorioiditis",
      "Jensen-Krankheit",
      "Netzhautabszess",
      "Retinaabszess",
      "Retinaulkus",
      "Retinitis centralis",
      "Retinitis juxtapapillaris",
      "Retinochorioiditis juxtapapillaris",
      "Uveitis posterior juxtapapillaris Jensen",
      "Zentrale Uveitis posterior"
    ]
  },
  {
    "code": "H30.1",
    "name": "Chorioiditis disseminata",
    "synonyms": [
      "Birdshot-Chorioretinopathie",
      "Birdshot-Retinochoroidopathie",
      "Chorioiditis disseminata",
      "Chorioretinitis disseminata",
      "Chorioretinopathie Typ Birdshot",
      "Chorioretinopathie mit Birdshots",
      "Disseminierte Chorioiditis",
      "Disseminierte Chorioretinitis",
      "Disseminierte Retinitis",
      "Disseminierte Retinochorioiditis",
      "Disseminierte Uveitis posterior",
      "Retinitis disseminata",
      "Retinochorioiditis disseminata"
    ]
  },
  {
    "code": "H30.2",
    "name": "Cyclitis posterior",
    "synonyms": [
      "Cyclitis posterior",
      "Entzündung der Pars plana corporis ciliaris",
      "Intermediäre Uveitis",
      "Uveitis intermedia"
    ]
  },
  {
    "code": "H30.8",
    "name": "Multiple evanescent white dot syndrome",
    "synonyms": [
      "AZOOR [Akute zonale okkulte äußere Retinopathie]",
      "Akute ringförmige äußere Retinopathie",
      "Harada-Krankheit",
      "Harada-Syndrom",
      "Multiple evanescent white dot syndrome",
      "Rezidivierende idiopathische Neuroretinitis",
      "Serpiginöse Chorioiditis",
      "Vogt-Koyanagi-Harada-Syndrom"
    ]
  },
  {
    "code": "H30.9",
    "name": "Neuroretinitis",
    "synonyms": [
      "Aderhaut- und Netzhautentzündung",
      "Aderhautentzündung",
      "Angeborene Chorioiditis",
      "Chorioidea- und Retinaentzündung",
      "Chorioideaentzündung",
      "Chorioiditis",
      "Chorioretinitis",
      "Idiopathische Uveitis posterior",
      "Infektiöse Uveitis posterior",
      "Konnatale Chorioiditis",
      "Netzhautentzündung",
      "Neurochorioretinitis",
      "Neuroretinitis",
      "Retinaentzündung",
      "Retinitis",
      "Retinochorioiditis",
      "Uveitis posterior",
      "Virusretinitis"
    ]
  },
  {
    "code": "H31.0",
    "name": "Chorioretinale Narbe",
    "synonyms": [
      "Aderhautnarbe",
      "Chorioideanarbe",
      "Chorioretinale Narbe",
      "Makulanarbe",
      "Makulanarbe durch Sonnenexposition",
      "Narbe des hinteren Augenpols",
      "Narbe des hinteren Pols der Macula lutea",
      "Narbe des hinteren Pols der Macula lutea nach Entzündung",
      "Netzhautnarbe",
      "Nicht makuläre chorioretinale Narbe",
      "Photoretinitis",
      "Postentzündliche Narbe der Makula",
      "Posttraumatische Narbe der Makula",
      "Posttraumatische Narbe des hinteren Pols der Macula lutea",
      "Retinanarbe",
      "Retinopathia solaris",
      "Retinopathie durch Lichtstrahlen"
    ]
  },
  {
    "code": "H31.1",
    "name": "Chorioideasklerose",
    "synonyms": [
      "Aderhautatrophie",
      "Aderhautdegeneration",
      "Aderhautschwund",
      "Aderhautsklerose",
      "Chorioideaatrophie",
      "Chorioideasklerose",
      "Chorioretinale Degeneration",
      "Degeneration der Bruch-Membran",
      "Degeneration der Chorioidea",
      "Degenerative Chorioiditis",
      "Degenerative Chorioidose",
      "Degenerative Veränderung der Chorioidea"
    ]
  },
  {
    "code": "H31.2",
    "name": "Hereditäre Dystrophie der Aderhaut",
    "synonyms": [
      "Aderhautdystrophie",
      "Atrophia gyrata",
      "Atrophia gyrata chorioideae",
      "Atrophia gyrata der Aderhaut",
      "Benigne konzentrische Makuladystrophie",
      "Bietti-Kristalldystrophie",
      "CHM [Choroideremie]",
      "Chorioideremie",
      "Generalisierte Aderhautdystrophie",
      "Helikoide peripapilläre chorioretinale Degeneration",
      "Hereditäre Aderhautdegeneration",
      "Hereditäre Chorioideadegeneration",
      "Hereditäre Chorioideadystrophie",
      "Hereditäre Chorioiditis",
      "Hereditäre Chorioidose",
      "Hereditäre Dystrophie der Aderhaut",
      "Hereditäre chorioretinale Degeneration",
      "Peripapilläre Aderhautdystrophie",
      "Tapetochoroidale Dystrophie",
      "Zentrale areoläre Aderhautdystrophie",
      "Zentrale areoläre Pigmentepitheldystrophie der Aderhaut",
      "Zentrale areoläre generalisierte Chorioideadystrophie"
    ]
  },
  {
    "code": "H31.3",
    "name": "Chorioideablutung",
    "synonyms": [
      "Aderhautblutung",
      "Aderhauthämatom",
      "Aderhautriss",
      "Aderhautruptur",
      "Chorioideablutung",
      "Chorioidearuptur",
      "Expulsive Aderhautblutung",
      "Expulsive Aderhauthämorrhagie",
      "Expulsive Chorioideablutung",
      "Expulsive Chorioideahämorrhagie",
      "Hämorrhagie der Chorioidea",
      "Subretinale Aderhautblutung"
    ]
  },
  {
    "code": "H31.4",
    "name": "Ablatio chorioideae",
    "synonyms": [
      "Ablatio chorioideae",
      "Ablösung der Chorioidea",
      "Abtrennung der Chorioidea",
      "Aderhautabhebung",
      "Aderhautamotio",
      "Alte Ablatio chorioideae",
      "Chorioidale Effusion",
      "Postinfektiöse Ablatio chorioideae",
      "Spontane Ablatio chorioideae"
    ]
  },
  {
    "code": "H31.8",
    "name": "Serpiginöse Chorioideopathie",
    "synonyms": [
      "Akute multifokale plakoide Pigmentepitheliopathie der Aderhaut",
      "Chorioidale Neovaskularisation",
      "Erworbene Chorioideadeformität",
      "Punktförmige innere Choroidopathie",
      "Serpiginöse Chorioideopathie",
      "Sklerochorioiditis"
    ]
  },
  {
    "code": "H31.9",
    "name": "Chorioideaerkrankung",
    "synonyms": [
      "Aderhauterkrankung",
      "Aderhautkrankheit",
      "Affektion der Chorioidea",
      "Chorioideaerkrankung",
      "Chorioideakrankheit",
      "Chorioidose"
    ]
  },
  {
    "code": "H33.0",
    "name": "Netzhautablösung mit Netzhautriss",
    "synonyms": [
      "Ablatio retinae mit Foramen retinae",
      "Ablatio retinae mit Hufeisenforamen",
      "Ablatio retinae mit Netzhautdefekt",
      "Ablatio retinae mit Orariss",
      "Ablatio retinae mit Retinadefekt",
      "Ablatio retinae mit Riesenriss (nicht Orariss)",
      "Ablatio retinae mit Riss",
      "Ablatio retinae mit Rundloch",
      "Ablatio retinae mit multiplen Foramina",
      "Autosomal-dominante rhegmatogene Netzhautablösung",
      "Netzhautablösung mit Defekt",
      "Netzhautablösung mit Netzhautriss",
      "Retinaablösung mit Defekt",
      "Retinaloch mit Netzhautablösung",
      "Retinaloch mit Retinaablösung",
      "Retinariss mit Netzhautablösung",
      "Retinariss mit Retinaablösung",
      "Rhegmatogene Ablatio retinae",
      "Rhegmatogene Amotio retinae",
      "Traumatische Retinaruptur mit Netzhautablösung",
      "Traumatische Retinaruptur mit Retinaablösung"
    ]
  },
  {
    "code": "H33.1",
    "name": "Retinapseudozyste",
    "synonyms": [
      "Blessig-Ivanoff-Zyste",
      "Netzhautpseudozyste",
      "Parasitäre Netzhautzyste",
      "Parasitäre Retinazyste",
      "Retinalzyste",
      "Retinapseudozyste",
      "Retinoschisis",
      "Retinoschisis mit Schichtforamen",
      "Schisisablatio",
      "Senile Retinoschisis",
      "Zyste der Ora serrata"
    ]
  },
  {
    "code": "H33.2",
    "name": "Seröse Netzhautablösung",
    "synonyms": [
      "Ablatio retinae",
      "Ablatio retinae exsudativa",
      "Ablatio retinae exsudativa bei Tumor",
      "Ablatio retinae non sanata",
      "Ablatio retinae ohne Netzhautdefekt",
      "Ablatio retinae ohne Retinadefekt",
      "Amotio retinae",
      "Entzündliche Ablatio retinae exsudativa",
      "Idiopathisches uveales Effusionssyndrom",
      "Netzhautablösung",
      "Netzhautablösung ohne Netzhautriss",
      "Persistierende Ablatio retinae nach Operation",
      "Retinaablösung",
      "Retinaablösung ohne Retinariss",
      "Seröse Ablatio retinae ohne Netzhautriss",
      "Seröse Ablatio retinae ohne Retinariss",
      "Seröse Netzhautablösung",
      "Seröse Netzhautablösung ohne Netzhautriss",
      "Seröse Retinaablösung",
      "Seröse Retinaablösung ohne Retinariss",
      "Uveales Effusionssyndrom"
    ]
  },
  {
    "code": "H33.3",
    "name": "Netzhautriss ohne Netzhautablösung",
    "synonyms": [
      "Foramen retinae",
      "Hufeisenforamen",
      "Hufeisenforamen der Retina",
      "Hufeisenriss der Retina ohne Netzhautablösung",
      "Hufeisenriss der Retina ohne Retinaablösung",
      "Netzhautdefekt",
      "Netzhautforamen",
      "Netzhautfragment ohne Netzhautablösung",
      "Netzhauthufeisenriss ohne Netzhautablösung",
      "Netzhautloch",
      "Netzhautriss",
      "Netzhautriss ohne Netzhautablösung",
      "Netzhautrundloch ohne Netzhautablösung",
      "Retinadefekt",
      "Retinaforamen",
      "Retinafragment ohne Retinaablösung",
      "Retinaloch ohne Netzhautablösung",
      "Retinaloch ohne Retinaablösung",
      "Retinariss ohne Retinaablösung",
      "Retinarundloch ohne Retinaablösung",
      "Retinaruptur",
      "Rundforamen der Netzhaut",
      "Rundforamen der Retina",
      "Traumatische Retinaruptur ohne Ablösung"
    ]
  },
  {
    "code": "H33.4",
    "name": "Proliferative Vitreoretinopathie mit Netzhautablösung",
    "synonyms": [
      "Ablatio retinae durch Zug",
      "Netzhauttraktionsablösung",
      "Proliferative Vitreoretinopathie mit Netzhautablösung",
      "Proliferative Vitreoretinopathie mit Retinaablösung",
      "Traktionsablatio bei alter Ablatio retinae",
      "Traktionsablatio der Netzhaut",
      "Traktionsablatio der Retina",
      "Traktionsablatio retinae"
    ]
  },
  {
    "code": "H33.5",
    "name": "Ablatio retinae bei Netzhautnekrose",
    "synonyms": [
      "Ablatio retinae bei Netzhautnekrose",
      "Ablatio retinae bei Pseudoaphakie",
      "Ablatio retinae bei Retinanekrose"
    ]
  },
  {
    "code": "H34.0",
    "name": "Arterieller transitorischer Gefäßverschluss der Netzhaut",
    "synonyms": [
      "Arterieller transitorischer Gefäßverschluss der Netzhaut",
      "Arterieller transitorischer Gefäßverschluss der Retina",
      "Transitorische Obstruktion einer Retinaarterie",
      "Transitorischer Verschluss einer Retinaarterie"
    ]
  },
  {
    "code": "H34.1",
    "name": "Verschluss der Arteria centralis retinae",
    "synonyms": [
      "Augenzentralarterienverschluss",
      "Obstruktion der zentralen Retinaarterie",
      "Verschluss der Arteria centralis retinae",
      "Verschluss der zentralen Retinaarterie"
    ]
  },
  {
    "code": "H34.2",
    "name": "Arterienastgefäßverschluss der Netzhaut",
    "synonyms": [
      "Aderhautdurchblutungsstörung",
      "Aderhautinfarkt",
      "Arterieller Gefäßverschluss der Netzhaut",
      "Arterieller Gefäßverschluss der Retina",
      "Arterienastgefäßverschluss der Netzhaut",
      "Arterienastverschluss der Retina",
      "Arterienspasmus der Retina",
      "Augenastarterienverschluss",
      "Augenembolie",
      "DBS [Durchblutungsstörung] der Aderhaut",
      "DBS [Durchblutungsstörung] der Netzhaut",
      "DBS [Durchblutungsstörung] der Retina",
      "Embolie der Arteria ophthalmica",
      "Embolie der Retinaarterie",
      "Hollenhorst-Plaques",
      "Mikroembolie der Retina",
      "Netzhautdurchblutungsstörung",
      "Netzhautembolie",
      "Netzhautinfarkt",
      "Netzhautischämie",
      "Obstruktion einer Retinaarterie a.n.k.",
      "Ophthalmische Embolie",
      "Partieller arterieller Gefäßverschluss der Netzhaut",
      "Partieller arterieller Gefäßverschluss der Retina",
      "Partieller arterieller retinaler Gefäßverschluss",
      "Retinadurchblutungsstörung",
      "Retinaembolie",
      "Retinainfarkt",
      "Retinaischämie",
      "Retinale Ischämie",
      "Retinaler Arterienastverschluss",
      "Thrombose der Arteria ophthalmica",
      "Thrombose einer Retinaarterie",
      "Verschluss der Arteria cilioretinalis",
      "Verschluss einer Netzhautarterie",
      "Verschluss einer Retinaarterie",
      "Zytoider Retinakörper"
    ]
  },
  {
    "code": "H34.8",
    "name": "Netzhautvenenastgefäßverschluss",
    "synonyms": [
      "Augenastvenenthrombose",
      "Augenthrombose",
      "Gefäßverschluss eines Venenastes der Retina",
      "Netzhautthrombose",
      "Netzhautvenenastgefäßverschluss",
      "Netzhautvenenthrombose",
      "Obstruktion einer Retinavene",
      "Ophthalmische Thrombose",
      "Partieller venöser Gefäßverschluss der Netzhaut",
      "Partieller venöser Gefäßverschluss der Retina",
      "Partieller venöser retinaler Gefäßverschluss",
      "Retinaler Venenastverschluss",
      "Retinathrombose",
      "Retinavenenthrombose",
      "Venenastverschluss der Retina",
      "Venenstauung der Retina",
      "Venöse Stauung der Retina",
      "Venöse Thrombose des Auges",
      "Venöser Gefäßverschluss der Netzhaut im Anfangsstadium",
      "Venöser Gefäßverschluss der Retina im Anfangsstadium",
      "Zentraler venöser Gefäßverschluss der Netzhaut",
      "Zentraler venöser Gefäßverschluss der Retina",
      "Zentraler venöser retinaler Gefäßverschluss",
      "Zentralvenenthrombose des Auges"
    ]
  },
  {
    "code": "H34.9",
    "name": "Retinagefäßverschluss",
    "synonyms": [
      "Netzhautgefäßverschluss",
      "Retinagefäßverschluss",
      "Retinavasospasmus"
    ]
  },
  {
    "code": "H35.0",
    "name": "Morbus Eales",
    "synonyms": [
      "Angiopathia retinae",
      "Coats-Krankheit",
      "Coats-Retinopathie",
      "Coats-Syndrom",
      "Cotton-Wool-Spot",
      "Criswick-Schepens-Syndrom",
      "Eales-Krankheit",
      "Eales-Syndrom",
      "Endarteriitis retinae",
      "Erworbenes Netzhautaneurysma",
      "Erworbenes Retinaaneurysma",
      "Exsudative Retinopathie",
      "Familiäre exsudative Retinopathie",
      "Familiäre exudative Vitreoretinopathie",
      "Fundus hypertonicus",
      "Fundusdegeneration",
      "Fundusveränderung",
      "Gefäßeinscheidung der Retina",
      "Gefäßerkrankung der Retina",
      "Gefäßneubildung der Retina",
      "Gefäßschädigung der Retina",
      "Hypertensive Retinopathie",
      "Hypertone Netzhautgefäßveränderung",
      "Hypertone Retinagefäßveränderung",
      "IRVAN [Idiopathische retinale Vaskulitis, Aneurysmen, Neuroretinitis]-Syndrom",
      "Idiopathische Perivaskulitis der Retina",
      "Idiopathische makuläre Teleangiektasie Typ 1",
      "Idiopathische makuläre Teleangiektasie Typ 3",
      "Kapillarektasien der Retina",
      "Kongenitale Teleangiektasie der Retina",
      "Makulare Teleangiektasie",
      "Medikamententoxische Retinopathie",
      "Mikroaneurysma der Retina",
      "Morbus Coats",
      "Morbus Eales",
      "Neovaskularisation der Retina",
      "Netzhautexsudation",
      "Parafoveale Teleangiektasie",
      "Retinaaneurysma",
      "Retinaexsudation",
      "Retinale Gefäßeinscheidung",
      "Retinale Gefäßneubildung",
      "Retinale Neovaskularisation",
      "Retinale Perivaskulitis",
      "Retinale Teleangiektasie",
      "Retinale Varizen",
      "Retinale Vaskulitis",
      "Retinales Exsudat",
      "Retinales Mikroaneurysma",
      "Retinaperiphlebitis",
      "Retinaperivaskulitis",
      "Retinavarizen",
      "Retinavaskulitis",
      "Retinopathia",
      "Retinopathia circinata",
      "Retinopathie",
      "Senile Retinasklerose",
      "Vaskuläre Retinaschädigung",
      "Vaskuläre Retinasklerose",
      "Vaskuläre Veränderung der Retina",
      "Verengung einer Retinaarterie",
      "Veränderung des Augenhintergrundes",
      "Veränderung im Erscheinungsbild eines Netzhautgefäßes",
      "Veränderung im Erscheinungsbild eines Retinagefäßes"
    ]
  },
  {
    "code": "H35.1",
    "name": "Retrolentale Fibroplasie",
    "synonyms": [
      "Frühgeborenenretinopathie",
      "ROP [Frühgeborenenretinopathie]",
      "Retinopathia praematurorum",
      "Retrolentale Fibroplasie"
    ]
  },
  {
    "code": "H35.2",
    "name": "Proliferative Vitreoretinopathie",
    "synonyms": [
      "Autosomal-dominante neovaskuläre inflammatorische Vitreoretinopathie",
      "Proliferative Retinopathie a.n.k.",
      "Proliferative Vitreoretinopathie"
    ]
  },
  {
    "code": "H35.30",
    "name": "Kuhnt-Junius-Degeneration",
    "synonyms": [
      "Altersbedingte feuchte Makuladegeneration",
      "Altersbedingte neovaskuläre Degeneration der Makula",
      "Exsudative Makuladegeneration",
      "Feuchte Makuladegeneration",
      "Kuhnt-Junius-Degeneration",
      "Kuhnt-Junius-Retinadegeneration",
      "Senile exsudative Makuladegeneration",
      "Senile feuchte Makuladegeneration",
      "Senile feuchte Makulopathie"
    ]
  },
  {
    "code": "H35.31",
    "name": "Senile trockene Makuladegeneration",
    "synonyms": [
      "Altersbedingte trockene Makuladegeneration",
      "Atrophische Makuladegeneration",
      "Drusenmakulopathie",
      "Nichtexsudative Makuladegeneration",
      "Senile atrophische Makuladegeneration",
      "Senile trockene Makuladegeneration",
      "Trockene Makuladegeneration",
      "Trockene sklerotische Makulopathie"
    ]
  },
  {
    "code": "H35.38",
    "name": "Degenerative Makuladrusen",
    "synonyms": [
      "Angioid streaks",
      "Angioid streaks der Makula",
      "Angioide Streifen",
      "Angioide Streifen der Chorioidea",
      "Angioide Streifen der Makula",
      "Angioide Streifen der Retina",
      "Degenerative Drusen am hinteren Pol",
      "Degenerative Makuladrusen",
      "Epiretinale Gliose",
      "Gefäßähnliche Streifen der Makula",
      "Macular pucker",
      "Makulafalte",
      "Makulaforamen",
      "Makulafältelung",
      "Makulaloch",
      "Makulazyste",
      "Myopische Makuladegeneration",
      "Myopische Makulopathie",
      "Netzhautfalten, nicht postoperativ",
      "Persistierende plakoide Makulopathie",
      "Pigmentverschiebung der Makula",
      "Pseudoforamen maculae",
      "Retinadrusen am hinteren Pol",
      "Retinafalten, nicht postoperativ",
      "Schichtloch der Makula",
      "Toxische Makulaerkrankung",
      "Toxische Makulopathie",
      "Toxische Makulopathie durch (Hydroxy-)Chloroquin",
      "Toxische Makulopathie durch Antimalaria-Medikamente",
      "Vitreomakuläre Traktion"
    ]
  },
  {
    "code": "H35.39",
    "name": "Makuladegeneration",
    "synonyms": [
      "AMNR [Akute makuläre Neuroretinopathie]",
      "Akute makuläre Neuroretinopathie",
      "Degeneration der Makula und des hinteren Pols",
      "Makuladegeneration",
      "Makulaveränderung",
      "Makulöse Retinadegeneration",
      "Retinadegeneration am hinteren Augenpol"
    ]
  },
  {
    "code": "H35.4",
    "name": "Periphere Netzhautdegeneration",
    "synonyms": [
      "Gitterförmige Retinadegeneration",
      "Gittrige Netzhautdegeneration",
      "Mikrozystoide Netzhautdegeneration",
      "Mikrozystoide Retinadegeneration",
      "Mikrozystoide äquatoriale Degeneration",
      "Netzhautdegeneration",
      "Netzhautdegeneration ohne Riss",
      "Palisadenartige Netzhautdegeneration",
      "Palisadenförmige Retinadegeneration",
      "Periphere Netzhautdegeneration",
      "Periphere Retinadegeneration",
      "Pflastersteindegeneration der Retina",
      "Pflastersteinförmige Netzhautdegeneration",
      "Pflastersteinförmige Retinadegeneration",
      "Pigmentepithelverschiebung der Netzhaut",
      "Pigmentepithelverschiebung der Retina",
      "Retikuläre Netzhautdegeneration",
      "Retikuläre Retinadegeneration",
      "Retinadegeneration",
      "Retinadegeneration ohne Riss",
      "Äquatoriale Degeneration mit Gitterlinien",
      "Äquatoriale Degeneration mit Glitzerpunkten",
      "Äquatoriale Degeneration mit Schneckenspuren",
      "Äquatoriale Degeneration, white without pressure",
      "Äquatoriale Netzhautdegeneration",
      "Äquatoriale Palisadendegeneration",
      "Äquatoriale Pflastersteindegeneration",
      "Äquatoriale Retinadegeneration"
    ]
  },
  {
    "code": "H35.5",
    "name": "Fundus albipunctatus",
    "synonyms": [
      "Adulte vitelliforme Makuladystrophie",
      "Autosomal-dominante Vitreoretinochoroidopathie",
      "Autosomal-dominante spät beginnende Netzhautdystrophie",
      "Autosomal-dominante vitelliforme Best-Makuladegeneration",
      "Autosomal-rezessive Bestrophinopathie",
      "Behr-Krankheit",
      "Behr-Syndrom",
      "Benigne familiäre gefleckte Retina",
      "Benigne konzentrische anuläre Makuladystrophie",
      "Best-Syndrom",
      "Dystrophia albipunctata retinae",
      "Dystrophia retinae",
      "EOSRD [Schwere frühkindliche Netzhautdegeneration]",
      "Familiäre Drusen",
      "Forsius-Eriksson-Syndrom",
      "Fundus albipunctatus",
      "Fundus pulverulentus",
      "Gefleckte Retina nach Kandori",
      "Goldmann-Favre-Syndrom",
      "Hereditäre Makuladegeneration",
      "Hereditäre Netzhautdystrophie",
      "Hereditäre Retinadegeneration",
      "Hereditäre Retinadystrophie",
      "Hereditäre dominante Drusen [Doyne-Drusen]",
      "Hereditäre makuläre Augendegeneration",
      "Isolierter Fundus flavimaculatus",
      "Kongenitale Leber-Amaurose",
      "Kongenitale Makuladegeneration",
      "Kongenitale Retinopathia pigmentosa",
      "Kongenitale makuläre Augendegeneration",
      "LORD [Late-onset retinal degeneration]",
      "Leber-Amaurose",
      "Makuläre Heredodegeneration",
      "Morbus Stargardt",
      "Multifokale Musterdystrophie des retinalen Pigmentepithels (vorgetäuschter Fundus flavimaculatus)",
      "Netzhautdystrophie",
      "Netzhautdystrophie Typ Bothnia",
      "North-Carolina-Makuladystrophie",
      "Okkulte Makuladystrophie",
      "Oligocone-Trichromasie",
      "Pigmentdegeneration der Netzhaut",
      "Pigmentdegeneration der Retina",
      "Pigmentierte Netzhautdystrophie",
      "Pigmentierte Retinadegeneration",
      "Pigmentierte Retinadystrophie",
      "Pigmentierte vitelliforme Albipunctata-Netzhautdystrophie",
      "Pigmentierte vitelliforme Albipunctata-Retinadystrophie",
      "Progressive Netzhautdystrophie durch Retinol-Transportprotein-Defekt",
      "Progressive Zapfendystrophie",
      "Progressive bifokale chorioretinale Atrophie",
      "Pseudoinflammatorische Fundusdystrophie Typ Sorsby",
      "Pseudoinflammatorische Sorsby-Fovea-Dystrophie",
      "Retikuläre Dystrophie des retinalen Pigmentepithels",
      "Retinadystrophie",
      "Retinale Makuladystrophie Typ 2",
      "Retinitis pigmentosa",
      "Retinitis pigmentosa ohne Pigment",
      "Retinitis punctata albescens",
      "Retinopathia pigmentosa - s.a. Retinitis pigmentosa",
      "Schmetterlingsförmige Pigmentdystrophie",
      "Schneeflocken-Vitreoretinopathie",
      "Schwere frühkindliche Netzhautdegeneration",
      "Stargardt-Degeneration der Makula",
      "Stargardt-Krankheit",
      "Stargardt-Makuladystrophie",
      "Stargardt-Syndrom",
      "Stäbchen-Zapfen-Dystrophie",
      "Tapetoretinale Degeneration",
      "Tapetoretinale Dystrophie",
      "Tapetoretinale Leber-Amaurose",
      "Tapetoretinale Netzhautdystrophie",
      "Tapetoretinale Retinadystrophie",
      "Tapetoretinale hereditäre Dystrophie",
      "Vitelliforme Netzhautdystrophie",
      "Vitelliforme Retinadystrophie",
      "Vitelliforme autosomal-dominante Makuladegeneration",
      "Vitreoretinale Dystrophie",
      "Vitreoretinale Netzhautdystrophie",
      "Vitreoretinale Retinadystrophie",
      "Wagner-Krankheit [Vitreoretinale Degeneration]",
      "Wagner-Syndrom",
      "Zapfendystrophie",
      "Zapfendystrophie mit supernormaler Stäbchenantwort",
      "Zystoide Makuladystrophie"
    ]
  },
  {
    "code": "H35.6",
    "name": "Retinablutung",
    "synonyms": [
      "Blutung des Augenhintergrundes",
      "Blutung des Fundus oculi",
      "Blutung eines Retinagefäßes",
      "Hämorrhagie des Augenhintergrundes",
      "Hämorrhagie des Fundus oculi",
      "Hämorrhagie eines Retinagefäßes",
      "Hämorrhagische Retinopathie",
      "Interne Retinablutung",
      "Intraretinale Blutung",
      "Intraretinale Netzhautblutung",
      "Makulablutung",
      "Morbus Purtscher",
      "Netzhautblutung",
      "Netzhautstreifenblutung",
      "Präretinale Blutung",
      "Präretinale Hämorrhagie",
      "Retinablutung",
      "Retinastreifenblutung",
      "Subhyaloidale Blutung",
      "Subhyaloidale Hämorrhagie",
      "Subhyaloidale Netzhautblutung",
      "Subhyaloidale Retinablutung",
      "Subretinale Blutung",
      "Subretinale Hämorrhagie",
      "Terson-Syndrom"
    ]
  },
  {
    "code": "H35.7",
    "name": "Abhebung von Netzhautschichten",
    "synonyms": [
      "Abhebung des Netzhautpigmentepithels",
      "Abhebung des retinalen Pigmentepithels",
      "Abhebung von Netzhautschichten",
      "Abhebung von Retinaschichten",
      "Ablation des Pigmentepithels der Netzhaut",
      "Ablation des Pigmentepithels der Retina",
      "Chorioretinopathia centralis serosa",
      "Netzhautabhebung mit Schichtenabhebung",
      "Netzhautschichtenlösung",
      "Pigmentblattabhebung der Netzhaut",
      "Pigmentblattabhebung der Retina",
      "Retinaabhebung mit Schichtenabhebung",
      "Retinaschichtenlösung",
      "Retinitis centralis serosa",
      "Retinopathia centralis serosa",
      "Zentrale seröse Chorioretinopathie",
      "Zentrale seröse Retinopathie"
    ]
  },
  {
    "code": "H35.8",
    "name": "Retinakongestion",
    "synonyms": [
      "Cholesterinablagerung in der Retina",
      "Hereditäres dominantes zystoides Makulaödem",
      "Lichtschädigung der Retina",
      "Makulaödem",
      "Netzhautödem",
      "Nichttraumatisches peripheres Netzhautödem",
      "Nichttraumatisches peripheres Retinaödem",
      "Nichtzystoides Makulaödem",
      "Phakoma des Auges",
      "Pigmentierte paravenöse retinochoroidale Atrophie",
      "Postinfektiöse Retinaatrophie",
      "Retinaatrophie",
      "Retinachalkose",
      "Retinahyperämie",
      "Retinakongestion",
      "Retinastauung",
      "Retinazyanose",
      "Retinaödem",
      "Zystoides Makulaödem"
    ]
  },
  {
    "code": "H35.9",
    "name": "Netzhauterkrankung",
    "synonyms": [
      "Makulaleiden",
      "Makulopathie",
      "Netzhautaffektion",
      "Netzhauterkrankung",
      "Netzhautkrankheit",
      "Netzhautleiden",
      "Netzhautveränderung",
      "Retinaaffektion",
      "Retinaerkrankung",
      "Retinakrankheit",
      "Retinaleiden",
      "Retinaschädigung",
      "Retinaveränderung"
    ]
  },
  {
    "code": "H40.0",
    "name": "Glaukomgrenzfall",
    "synonyms": [
      "Augapfelhypertonie",
      "Augendruckerhöhung",
      "Augenhypertension",
      "Augeninnendruckerhöhung",
      "Augenüberdruck",
      "Glaukomgrenzfall",
      "Glaukomverdacht",
      "Glaukomverdacht bei Nervenfaserschichtdefekt der Retina",
      "Glaukomverdacht bei entsprechendem Gesichtsfeldausfall",
      "Glaukomverdacht bei entsprechendem Papillenbefund",
      "Glaukomverdacht bei retinalem Nervenfaserschichtdefekt",
      "Grenzwertiger Augeninnendruck",
      "Intraokulare Drucksteigerung",
      "Okuläre Hypertension",
      "Verengung des vorderen Augenkammerwinkels",
      "Weiter Kammerwinkel"
    ]
  },
  {
    "code": "H40.1",
    "name": "Glaucoma chronicum simplex",
    "synonyms": [
      "Chronisches Glaukom",
      "Einfaches Glaukom",
      "Glaucoma chronicum simplex",
      "Glaucoma noncongestivum chronicum",
      "Glaucoma simplex",
      "Glaukom mit Pseudoexfoliation der Linse",
      "Glaukom ohne Druckerhöhung",
      "Glaukom ohne Hochdruck",
      "Kapselhäutchenglaukom",
      "Kapsuläres Glaukom mit Pseudoexfoliation der Linse",
      "Kapsuläres primäres Glaukom mit Pseudoexfoliation der Linse",
      "Mäßig erhöhter Augeninnendruck als Restzustand nach Glaukom",
      "Niederdruckglaukom",
      "Normaldruckglaukom",
      "PEX-Glaukom [Pseudoexfoliations-Glaukom]",
      "Pigmentdispersionsglaukom",
      "Pigmentglaukom",
      "Pigmentiertes Glaukom",
      "Primär chronisches Glaukom",
      "Primäres Offenwinkelglaukom",
      "Primäres Weitwinkelglaukom",
      "Pseudoexfoliationsglaukom",
      "Restzustand eines Pigmentglaukoms",
      "Restzustand eines kapsulären primären Glaukoms mit Pseudoexfoliation der Linse",
      "Restzustand eines primären Pigmentglaukoms",
      "Weitwinkelglaukom"
    ]
  },
  {
    "code": "H40.2",
    "name": "Primäres Engwinkelglaukom",
    "synonyms": [
      "Akutes Engwinkelglaukom",
      "Akutes Glaukom",
      "Akutes primäres Engwinkelglaukom",
      "Akutes primäres Winkelblockglaukom",
      "Anfallsglaukom",
      "Chronisches Engwinkelglaukom",
      "Chronisches primäres Engwinkelglaukom",
      "Engwinkelglaukom",
      "Engwinkelglaukom bei Plateau-Iris-Konfiguration",
      "Intermittierendes Engwinkelglaukom",
      "Intermittierendes primäres Engwinkelglaukom",
      "Malignes Glaukom",
      "Obturierendes Glaukom",
      "Primäres Engwinkelglaukom",
      "Primäres Winkelblockglaukom",
      "Protrahiertes Engwinkelglaukom",
      "Protrahiertes primäres Engwinkelglaukom",
      "Pupillarblockglaukom",
      "Restzustand eines akuten Engwinkelglaukoms",
      "Restzustand eines akuten primären Engwinkelglaukoms",
      "Restzustand eines chronischen Engwinkelglaukoms",
      "Restzustand eines chronischen primären Engwinkelglaukoms",
      "Restzustand eines intermittierenden Engwinkelglaukoms",
      "Restzustand eines intermittierenden primären Engwinkelglaukoms",
      "Restzustand eines protrahierten Engwinkelglaukoms",
      "Restzustand eines protrahierten primären Engwinkelglaukoms",
      "Rezidivierendes Engwinkelglaukom",
      "Rezidivierendes primäres Winkelblockglaukom"
    ]
  },
  {
    "code": "H40.3",
    "name": "Posttraumatisches Sekundärglaukom",
    "synonyms": [
      "Glaukom durch Contusio bulbi",
      "Posttraumatische vordere Synechie mit Sekundärglaukom",
      "Posttraumatisches Sekundärglaukom",
      "Sekundärglaukom bei traumatischer Blutung",
      "Sekundärglaukom nach Augenverletzung",
      "Sekundärglaukom nach Bulbuskontusion",
      "Sekundärglaukom nach Bulbusprellung",
      "Sekundärglaukom nach Kammerwinkeleinriss",
      "Traumatisches Glaukom",
      "Traumatisches hämorrhagisches Glaukom"
    ]
  },
  {
    "code": "H40.4",
    "name": "Postinfektiöses Glaukom",
    "synonyms": [
      "Glaukom bei Iridozyklitis",
      "Glaukomato-zyklitische Krise",
      "Posner-Schlossmann-Syndrom [Zyklitisches Glaukom]",
      "Postinfektiöses Glaukom",
      "Sekundärglaukom bei Augenentzündung",
      "Sekundärglaukom bei Fuchs-Heterochromiezyklitis",
      "Sekundärglaukom bei Iritis",
      "Sekundärglaukom bei Keratitis"
    ]
  },
  {
    "code": "H40.5",
    "name": "Glaukom bei Rubeosis iridis",
    "synonyms": [
      "Akutes Sekundärglaukom a.n.k.",
      "Aphakie-Glaukom",
      "Ghost-cell-Glaukom",
      "Glaukom bei Augapfeltumor",
      "Glaukom bei Augenaffektion a.n.k.",
      "Glaukom bei Cataracta hypermatura",
      "Glaukom bei Katarakt",
      "Glaukom bei Linsenaffektion a.n.k.",
      "Glaukom bei Linsendislokation",
      "Glaukom bei Netzhautvenenverschluss",
      "Glaukom bei Papillenprozess",
      "Glaukom bei Retinavenenverschluss",
      "Glaukom bei Rubeosis iridis",
      "Hämorrhagisches Glaukom",
      "Iridokorneale endotheliale Dystrophie [ICE-Syndrom] mit Sekundärglaukom",
      "Lentogenes Sekundärglaukom",
      "Linsensubluxationsglaukom",
      "Neovaskularisationsglaukom",
      "Neovaskularisationsglaukom nach Zentralvenenthrombose",
      "Nichttraumatische Blutung mit Sekundärglaukom",
      "Obturierendes Glaukom bei Linsenaffektion",
      "Phakolytisches Glaukom",
      "Phakomatoseglaukom",
      "Sekundärglaukom a.n.k.",
      "Sekundärglaukom bei Seclusio pupillae",
      "Sekundärglaukom bei erhöhtem episkleralen Venendruck",
      "Sekundärglaukom durch Augentumor"
    ]
  },
  {
    "code": "H40.6",
    "name": "Sekundärglaukom bei lokaler Steroidtherapie",
    "synonyms": [
      "Glaukom durch Arzneimittelverabreichung",
      "Kortikosteroidglaukom",
      "Kortikosteroidinduziertes Glaukom",
      "Kortisonglaukom",
      "Medikamentöses Sekundärglaukom",
      "Postoperatives Sekundärglaukom durch intraokular verbliebene Substanzen",
      "Sekundärglaukom bei lokaler Mydriatikatherapie",
      "Sekundärglaukom bei lokaler Steroidtherapie",
      "Sekundärglaukom bei systemischer Mydriatikatherapie",
      "Sekundärglaukom bei systemischer Steroidtherapie"
    ]
  },
  {
    "code": "H40.8",
    "name": "Hämorrhagisches postoperatives Glaukom",
    "synonyms": [
      "Glaukom durch Hypersekretion",
      "Glaukom durch Übersekretion von Kammerwasser",
      "Hämorrhagisches postoperatives Glaukom",
      "Sekundärglaukom bei postoperativer Blutung"
    ]
  },
  {
    "code": "H40.9",
    "name": "Glaukom",
    "synonyms": [
      "Druckerhöhung bei medikamentös eingestelltem Glaukom",
      "Glaucoma",
      "Glaukom",
      "Grüner Star - s.a. Glaucoma oder s.a. Glaukom"
    ]
  },
  {
    "code": "H43.0",
    "name": "Glaskörperprolaps",
    "synonyms": [
      "Glaskörperhernie",
      "Glaskörperhernie in die Vorderkammer",
      "Glaskörperprolaps",
      "Hernia corpus vitrei",
      "Hernie des Corpus vitreum in die Vorderkammer"
    ]
  },
  {
    "code": "H43.1",
    "name": "Glaskörperblutung",
    "synonyms": [
      "Glaskörperblutung",
      "Glaskörperblutung mit Netzhautforamen",
      "Glaskörperblutung mit Retinaforamen",
      "Glaskörperhämatom",
      "Glaskörperhämorrhagie",
      "Hämorrhagische Glaskörperabhebung",
      "Traumatische Glaskörperblutung"
    ]
  },
  {
    "code": "H43.2",
    "name": "Asteroide Hyalose",
    "synonyms": [
      "Asteroide Hyalose",
      "Benson-Krankheit",
      "Cholesterinablagerung im Glaskörper",
      "Glaskörperkalzifikation",
      "Kalksalze im Glaskörper",
      "Kalkseife im Glaskörper",
      "Kalziumsalze im Glaskörper",
      "Kalziumseife im Glaskörper",
      "Kristalline Ablagerung im Glaskörper",
      "Ossifikation des Glaskörperwassers",
      "Sternförmige Hyalitis",
      "Sternförmige Hyalosis"
    ]
  },
  {
    "code": "H43.3",
    "name": "Glaskörpertrübung bei intraokularer Entzündung",
    "synonyms": [
      "Glaskörperfloater",
      "Glaskörpermembran",
      "Glaskörperstränge",
      "Glaskörpertrübung",
      "Glaskörpertrübung bei intraokularer Entzündung",
      "Glaskörpertrübung nach Glaskörperblutung",
      "Glaskörperundurchsichtigkeit a.n.k.",
      "Glaskörperverdichtung",
      "Mouches volantes"
    ]
  },
  {
    "code": "H43.8",
    "name": "Autosomal-dominante Vitreoretinopathie",
    "synonyms": [
      "Autosomal-dominante Vitreoretinopathie",
      "Entzündliche Glaskörperinfiltration",
      "Erworbene Deformität des Corpus vitreum",
      "Erworbene Glaskörperdeformität",
      "Glaskörperabhebung",
      "Glaskörperablation",
      "Glaskörperablösung",
      "Glaskörperadhäsion",
      "Glaskörperanheftungslinie",
      "Glaskörperdegeneration",
      "Glaskörperdestruktion",
      "Glaskörperentzündung",
      "Glaskörperinfiltration",
      "Glaskörperverflüssigung",
      "Glaskörperzyste",
      "Hereditäre exsudative Vitreoretinopathie",
      "Hyalitis",
      "Senile Synchysis",
      "Sternförmiger Glaskörper",
      "Synchysis",
      "Synchysis des Glaskörpers",
      "Synchysis scintillans"
    ]
  },
  {
    "code": "H43.9",
    "name": "Glaskörpererkrankung",
    "synonyms": [
      "Glaskörperaffektion",
      "Glaskörpererkrankung",
      "Glaskörperkrankheit"
    ]
  },
  {
    "code": "H44.0",
    "name": "Septische Endophthalmitis",
    "synonyms": [
      "Augenabszess",
      "Augeninfektion",
      "Augenphlegmone",
      "Bakterielle Endophthalmitis",
      "Bakterielle Panophthalmitis",
      "Endophthalmie",
      "Glaskörperabszess",
      "Intraokulare Sepsis",
      "Metastatische Ophthalmie",
      "Mykotische Panophthalmitis",
      "Panophthalmie",
      "Panophthalmitis",
      "Purulente Augeninfektion",
      "Purulente Endophthalmitis",
      "Septische Endophthalmitis"
    ]
  },
  {
    "code": "H44.1",
    "name": "Virale Endophthalmitis",
    "synonyms": [
      "Akute Endophthalmitis",
      "Endophthalmitis",
      "Infektiöse Endophthalmitis",
      "Infektiöse Panuveitis",
      "Iridochorioiditis",
      "Iridozyklochorioiditis",
      "Lentogene Endophthalmitis",
      "Metastatische Endophthalmitis",
      "Mykotische Endophthalmitis",
      "Panuveitis",
      "Parasitäre Endophthalmitis a.n.k.",
      "Sterile Endophthalmitis",
      "Subakute Endophthalmitis",
      "Sympathische Augapfelreizung",
      "Sympathische Chorioideareizung",
      "Sympathische Endophthalmitis",
      "Sympathische Iridozyklitis",
      "Sympathische Ophthalmie",
      "Sympathische Panuveitis",
      "Sympathische Uveitis",
      "Systemische Panuveitis",
      "Systemische Uveitis",
      "Virale Endophthalmitis"
    ]
  },
  {
    "code": "H44.2",
    "name": "Aderhautdehnungsherd bei Myopie",
    "synonyms": [
      "Aderhautdehnungsherd bei Myopie",
      "Degenerative Myopie",
      "Fuchs-Flecken",
      "Fundusmyopie",
      "Konusmyopie",
      "Lacksprungmyopie",
      "Maligne Myopie",
      "Myopische Retinaveränderung",
      "Pathologische Myopie",
      "Perniziöse Myopie",
      "Progressive myopische Chorioretinitis"
    ]
  },
  {
    "code": "H44.3",
    "name": "Augensiderose",
    "synonyms": [
      "Augapfelsiderose",
      "Augensiderose",
      "Chalcosis",
      "Chalcosis bulbi",
      "Chalkose",
      "Siderosis bulbi"
    ]
  },
  {
    "code": "H44.4",
    "name": "Hypotonia bulbi",
    "synonyms": [
      "Abflachung der vorderen Augenkammer",
      "Augapfelfistel",
      "Hypotonia bulbi",
      "Obliteration der vorderen Augenkammer",
      "Okulare Hypotonie"
    ]
  },
  {
    "code": "H44.5",
    "name": "Glaucoma absolutum",
    "synonyms": [
      "Absolutes Glaukom",
      "Augapfelatrophie",
      "Augapfeldegeneration",
      "Bulbusdegeneration",
      "Degenerativer Zustand des Augapfels",
      "Glaucoma absolutum",
      "Infektiöse Phthisis bulbi",
      "Ophthalmophthisis",
      "Phthise des Augapfels durch Infektion",
      "Phthisis bulbi",
      "Phthisis bulbi oculi",
      "Phthisis dolorosa (Augapfel)"
    ]
  },
  {
    "code": "H44.6",
    "name": "Alter intraokularer magnetischer Fremdkörper der Iris",
    "synonyms": [
      "Alter intraokularer magnetischer Fremdkörper der Bulbushinterwand",
      "Alter intraokularer magnetischer Fremdkörper der Iris",
      "Alter intraokularer magnetischer Fremdkörper der Linse",
      "Alter intraokularer magnetischer Fremdkörper der Vorderkammer",
      "Alter intraokularer magnetischer Fremdkörper des Augapfels",
      "Alter intraokularer magnetischer Fremdkörper des Glaskörpers",
      "Alter intraokularer magnetischer Fremdkörper des Ziliarkörpers",
      "Verbliebener magnetischer Fremdkörper im Glaskörper",
      "Verbliebener magnetischer Fremdkörper im Ziliarkörper",
      "Verbliebener magnetischer Fremdkörper in der Bulbushinterwand",
      "Verbliebener magnetischer Fremdkörper in der Iris",
      "Verbliebener magnetischer Fremdkörper in der Linse",
      "Verbliebener magnetischer Fremdkörper in der Vorderkammer"
    ]
  },
  {
    "code": "H44.7",
    "name": "Alter intraokularer amagnetischer Fremdkörper der Iris",
    "synonyms": [
      "Alter intraokularer amagnetischer Fremdkörper der Bulbushinterwand",
      "Alter intraokularer amagnetischer Fremdkörper der Iris",
      "Alter intraokularer amagnetischer Fremdkörper der Linse",
      "Alter intraokularer amagnetischer Fremdkörper der Vorderkammer",
      "Alter intraokularer amagnetischer Fremdkörper des Glaskörpers",
      "Alter intraokularer amagnetischer Fremdkörper des Ziliarkörpers",
      "Heterochromie durch verbliebenen metallischen nichtmagnetischen Fremdkörper",
      "Retinierter Fremdkörper im Augapfel",
      "Retinierter Fremdkörper im Corpus ciliare",
      "Retinierter Fremdkörper in der Augapfelhinterwand",
      "Retinierter Fremdkörper in der vorderen Augenkammer",
      "Verbliebener amagnetischer Fremdkörper im Glaskörper",
      "Verbliebener amagnetischer Fremdkörper im Ziliarkörper",
      "Verbliebener amagnetischer Fremdkörper in der Bulbushinterwand",
      "Verbliebener amagnetischer Fremdkörper in der Iris",
      "Verbliebener amagnetischer Fremdkörper in der Linse",
      "Verbliebener amagnetischer Fremdkörper in der Vorderkammer"
    ]
  },
  {
    "code": "H44.8",
    "name": "Hämophthalmus",
    "synonyms": [
      "Augapfeladhäsion",
      "Augapfelblutung",
      "Augapfelhämorrhagie",
      "Erworbene Augapfeldeformität",
      "Fuchs-Blutung des Augapfels",
      "Haemorrhagia intraocularis",
      "Hämophthalmus",
      "Intraokulare Blutung",
      "Intraokulare Hämorrhagie",
      "Luxatio bulbi",
      "Luxation des Augapfels",
      "Nichttraumatische Dislokation des Augapfels",
      "Nichttraumatischer Augapfelprolaps",
      "Pseudogliom"
    ]
  },
  {
    "code": "H44.9",
    "name": "Bulbuserkrankung",
    "synonyms": [
      "Augapfelaffektion",
      "Augapfelkrankheit",
      "Bulbuserkrankung"
    ]
  },
  {
    "code": "H46",
    "name": "Neuropathie des Nervus opticus, ausgenommen ischämisch",
    "synonyms": [
      "CRION [Chronisch rezidivierende inflammatorische Optikusneuritis]",
      "Entzündung des Nervus opticus",
      "Fasciculitis optica",
      "Idiopathische Optikusperineuritis",
      "Isolierte Optikusneuritis",
      "Isolierte Optikusneuritis mit Anti-MOG [Myelin-Oligodendrozyten-Glykoprotein]-Antikörper",
      "Isolierte Optikusneuritis ohne Anti-MOG [Myelin-Oligodendrozyten-Glykoprotein]-Antikörper",
      "Neuritis des Hirnnerven II",
      "Neuritis des Nervus opticus",
      "Neuritis optica",
      "Neuropapillitis optica",
      "Neuropathie des Nervus opticus",
      "Neuropathie des Nervus opticus, ausgenommen ischämisch",
      "Optikusneuritis",
      "Papillenentzündung",
      "Papillitis",
      "Papillitis des Nervus opticus",
      "Radikulitis des Nervus opticus",
      "Retrobulbäre Neuritis optica",
      "Retrobulbäre Optikusneuralgie",
      "Retrobulbärneuritis",
      "Sehnerventzündung",
      "Traumatische Optikusneuropathie",
      "Wurzelentzündung des Nervus opticus"
    ]
  },
  {
    "code": "H47.0",
    "name": "Optikopathie durch Alkohol",
    "synonyms": [
      "Affektion des Nervus opticus a.n.k.",
      "Anteriore ischämische Optikusneuropathie",
      "Blutung der Sehnervscheide",
      "Blutung des Nervus opticus",
      "Degeneration des Nervus opticus",
      "Erkrankung des Nervus opticus",
      "Erkrankung des Sehnerven",
      "Foster-Kennedy-Syndrom",
      "Hämorrhagie des Nervus opticus",
      "Ischämische Neuropathie des Nervus opticus",
      "Ischämische Optikusneuropathie",
      "Kompression des Nervus opticus",
      "Optikopathie durch Alkohol",
      "Optikopathie durch Tabak",
      "Optikusdegeneration",
      "Optikuserkrankung",
      "Optikusischämie",
      "Optikuskompression",
      "Optikusneuropathie bei entzündlicher Allgemeinerkrankung",
      "Optikusscheidenhämatom",
      "Optikusstörung a.n.k.",
      "Sehnervdegeneration",
      "Störung des Hirnnerven II a.n.k.",
      "Störung des Nervus opticus a.n.k.",
      "Toxische Optikopathie",
      "Vaskulärer Prozess des Nervus opticus"
    ]
  },
  {
    "code": "H47.1",
    "name": "Papillenödem",
    "synonyms": [
      "Begleitendes Papillenödem bei Uveitis",
      "Begleitendes Papillenödem bei Vaskulitis",
      "Papillenödem",
      "Stauungspapille",
      "Stauungspapille e vacuo",
      "Ödem des Nervus opticus",
      "Ödem des Sehnerven"
    ]
  },
  {
    "code": "H47.2",
    "name": "Sehnervatrophie",
    "synonyms": [
      "Atrophie des Hirnnerven II",
      "Atrophie des Nervus opticus",
      "Autosomal-dominante Optikusatrophie Typ 3",
      "Autosomal-dominante Optikusatrophie Typ Kjer",
      "Autosomal-dominante Optikusatrophie mit Katarakt",
      "Autosomal-dominante Optikusatrophie und periphere Neuropathie",
      "Autosomal-dominantes Optikusatrophie-plus-Syndrom",
      "Autosomal-rezessive Optikusatrophie Typ 7",
      "Autosomal-rezessive isolierte Optikusatrophie",
      "Bosch-Boonstra-Schaaf-Optikusatrophie-Syndrom",
      "Exkavation der Sehnervenpapille",
      "Hereditäre Leber-Optikusneuropathie",
      "Hereditäre Optikusatrophie",
      "Hereditäre Optikusatrophie bei Theodor-Leber-Krankheit",
      "Klassische Form der autosomal-dominanten Optikusatrophie",
      "LHON [Leber hereditary optic neuropathy]",
      "Leber-Optikusatrophie",
      "Leber-Syndrom",
      "OPA2 [Optikusatrophie Typ 2]",
      "Optikus-Neuropathie Typ Leber",
      "Optikusatrophie",
      "Optikusatrophie Typ 2",
      "Optikusatrophie Typ Kjer",
      "Optikusatrophie bei Theodor-Leber-Krankheit",
      "Optikusatrophie mit Polyneuropathie, Taubheit und Myopathie",
      "Papillenabblassung",
      "Papillenatrophie",
      "Papillenblässe",
      "Papillenexkavation",
      "Posttraumatische Optikusatrophie",
      "Sehnervatrophie",
      "Temporale Papillenabblassung",
      "Vaskuläre Optikusatrophie"
    ]
  },
  {
    "code": "H47.3",
    "name": "Papillenkonus",
    "synonyms": [
      "Drusen der Papilla nervi optici",
      "Erworbene Papillenanomalie",
      "Papillendrusen",
      "Papillenkonus",
      "Papillenkrankheit",
      "Papillenunschärfe",
      "Pseudopapillenödem",
      "Pseudostauungspapille",
      "Störung der Optikuspapille"
    ]
  },
  {
    "code": "H47.4",
    "name": "Chiasmaaffektion",
    "synonyms": [
      "Affektion des Chiasma opticum",
      "Chiasmaaffektion",
      "Chiasmakompression",
      "Chiasmasyndrom",
      "Entzündliche Chiasmaaffektion",
      "Ischämische Chiasmaaffektion",
      "Kongenitale Achiasmie",
      "Schädigung des Chiasma opticum",
      "Störung des Chiasma opticum",
      "Zyste des Chiasma opticum a.n.k."
    ]
  },
  {
    "code": "H47.5",
    "name": "Krankheit des Corpus geniculatum",
    "synonyms": [
      "Affektion der Sehstrahlung",
      "Affektion des Corpus geniculatum laterale",
      "Affektion des Tractus opticus",
      "Blutung des Tractus opticus",
      "Ischämie des Tractus opticus",
      "Krankheit des Corpus geniculatum",
      "Sehstrahlungskrankheit",
      "Sehstrahlungsstörung",
      "Störung des Corpus geniculatum",
      "Störung des Tractus opticus"
    ]
  },
  {
    "code": "H47.6",
    "name": "Tumor des visuellen Kortex",
    "synonyms": [
      "Affektion des kortikalen Sehzentrums",
      "Blutung des visuellen Kortex",
      "Entzündung des visuellen Kortex",
      "Ischämie des visuellen Kortex",
      "Sehrindenaffektion",
      "Störung des kortikalen Sehzentrums",
      "Tumor des visuellen Kortex",
      "Zerebrale visuelle Verarbeitungsstörung"
    ]
  },
  {
    "code": "H47.7",
    "name": "Affektion der Sehbahn",
    "synonyms": [
      "Affektion der Sehbahn",
      "Störung der Sehbahn"
    ]
  },
  {
    "code": "H49.0",
    "name": "Lähmung des Nervus oculomotorius [III. Hirnnerv]",
    "synonyms": [
      "Atrophie des Hirnnerven III",
      "Atrophie des Nervus oculomotorius",
      "Axenfeld-Schürenberg-Syndrom",
      "Degeneration des Hirnnerven III",
      "Entzündung des Nervus oculomotorius",
      "Interne Okulomotoriusparese",
      "Kongenitale Okulomotoriusparese",
      "Kongenitale Parese des Nervus oculomotorius",
      "Lähmung des Nervus oculomotorius [III. Hirnnerv]",
      "Neuralgie des Hirnnerven III",
      "Neuritis des Hirnnerven III",
      "Neuritis des Nervus oculomotorius",
      "Nothnagel-Syndrom",
      "Okulomotoriusparese [III. Hirnnerv]",
      "Okulomotoriussyndrom",
      "Ophthalmoplegie-Ataxie-Areflexie-Syndrom",
      "Paralyse des Nervus oculomotorius",
      "Störung des Hirnnerven III a.n.k.",
      "Störung des Nervus oculomotorius a.n.k.",
      "Tolosa-Hunt-Syndrom",
      "Äußere bilaterale Paralyse des Nervus oculomotorius"
    ]
  },
  {
    "code": "H49.1",
    "name": "Lähmung des Nervus trochlearis [IV. Hirnnerv]",
    "synonyms": [
      "Atrophie des Hirnnerven IV",
      "Atrophie des Nervus trochlearis",
      "Degeneration des Hirnnerven IV",
      "Entzündung des Nervus trochlearis",
      "Familiäre kongenitale Parese des Nervus trochlearis",
      "Familiäre kongenitale Trochlearislähmung",
      "Kongenitale Parese des Nervus trochlearis",
      "Kongenitale Trochlearislähmung",
      "Lähmung des Nervus trochlearis [IV. Hirnnerv]",
      "Neuralgie des Hirnnerven IV",
      "Neuritis des Hirnnerven IV",
      "Neuritis des Nervus trochlearis",
      "Paralyse des Musculus obliquus inferior",
      "Paralyse des Musculus obliquus superior",
      "Paralyse des Nervus trochlearis",
      "Störung des Hirnnerven IV a.n.k.",
      "Störung des Nervus trochlearis a.n.k.",
      "Trochlearisparese [IV. Hirnnerv]"
    ]
  },
  {
    "code": "H49.2",
    "name": "Lähmung des Nervus abducens [VI. Hirnnerv]",
    "synonyms": [
      "Abduzensparese [VI. Hirnnerv]",
      "Atrophie des Hirnnerven VI",
      "Atrophie des Nervus abducens",
      "Degeneration des Hirnnerven VI",
      "Entzündung des Nervus abducens",
      "Kongenitale Parese des Nervus abducens",
      "Lähmung des Nervus abducens [VI. Hirnnerv]",
      "Neuralgie des Hirnnerven VI",
      "Neuritis des Hirnnerven VI",
      "Neuritis des Nervus abducens",
      "Paralyse des Nervus abducens",
      "Störung des Hirnnerven VI a.n.k.",
      "Störung des Nervus abducens a.n.k."
    ]
  },
  {
    "code": "H49.3",
    "name": "Ophthalmoplegia totalis externa",
    "synonyms": [
      "Ophthalmoplegia totalis externa",
      "Totale äußere Ophthalmoplegie"
    ]
  },
  {
    "code": "H49.4",
    "name": "Ophthalmoplegia progressiva externa",
    "synonyms": [
      "Autosomal-dominante progressive externe Ophthalmoplegie",
      "Autosomal-rezessive progressive externe Ophthalmoplegie",
      "Maternal-vererbte CPEO [Chronische progressive externe Ophthalmoplegie]",
      "Maternal-vererbte chronische progressive externe Ophthalmoplegie",
      "Ophthalmoplegia chronica progressiva",
      "Ophthalmoplegia progressiva externa",
      "Progressive externe Ophthalmoplegie und Skoliose",
      "Progressive äußere Ophthalmoplegie",
      "Von-Graefe-Krankheit",
      "Von-Graefe-Syndrom"
    ]
  },
  {
    "code": "H49.8",
    "name": "Parinaud-Syndrom [Ophthalmoplegie]",
    "synonyms": [
      "Kearns-Sayre-Syndrom [Ophthalmoplegia plus]",
      "Kongenitale Fibrose der extraokulären Muskeln",
      "Ophthalmoplegia externa",
      "Ophthalmoplegia plus",
      "Parinaud-Krankheit [Ophthalmoplegie]",
      "Parinaud-Ophthalmoplegie",
      "Parinaud-Syndrom [Ophthalmoplegie]"
    ]
  },
  {
    "code": "H49.9",
    "name": "Strabismus paralyticus",
    "synonyms": [
      "Augenmuskellähmung",
      "Augenmuskelparese",
      "Augensenkerparese",
      "Kongenitale Parese mehrerer Augenmuskelnerven",
      "Lähmungsschielen",
      "Ophthalmoplegia",
      "Ophthalmoplegie",
      "Paralyse des Musculus rectus des Auges",
      "Paralyse des äußeren Augenmuskels",
      "Paralytische Augenmuskelkontraktion",
      "Parese des äußeren Augenmuskels",
      "Strabismus paralyticus"
    ]
  },
  {
    "code": "H50.0",
    "name": "Konsekutive Esotropie",
    "synonyms": [
      "Akkommodierendes Schielen",
      "Alternierende Esotropie",
      "Alternierende Esotropie, ausgenommen intermittierend",
      "Alternierendes Einwärtsschielen",
      "Einwärtsschielen",
      "Esodeviation",
      "Esotropie",
      "Esotropie mit Konvergenzexzess",
      "Frühkindliche Esotropie",
      "Konsekutive Esotropie",
      "Monokulare Esotropie",
      "Monokulares Einwärtsschielen",
      "Nichtakkommodativer Konvergenzexzess",
      "Normosensorisches Spätschielen",
      "Obliquus-inferior-Überfunktion und Obliquus-superior-Parese mit V-Esotropie",
      "Obliquus-superior-Überfunktion und Obliquus-inferior-Parese mit A-Esotropie",
      "Restesotropie",
      "Schwankende Esotropie",
      "Sekundäre Esotropie",
      "Strabismus concomitans convergens",
      "Strabismus convergens",
      "Strabismus convergens unilateralis",
      "Unilaterale Esotropie"
    ]
  },
  {
    "code": "H50.1",
    "name": "Strabismus divergens",
    "synonyms": [
      "Alternierende Exotropie",
      "Alternierende Exotropie, ausgenommen intermittierend",
      "Auswärtsschielen",
      "Exodeviation",
      "Exotropie",
      "Exotropie mit Konvergenzexzess",
      "Konsekutive Exotropie",
      "Monokulare Exotropie",
      "Obliquus-inferior-Überfunktion und Obliquus-superior-Parese mit V-Exotropie",
      "Obliquus-superior-Überfunktion und Obliquus-inferior-Parese mit A-Exotropie",
      "Sekundäre Exotropie",
      "Strabismus concomitans divergens",
      "Strabismus divergens",
      "Strabismus divergens alternans",
      "Unilaterale Exotropie"
    ]
  },
  {
    "code": "H50.2",
    "name": "Strabismus verticalis",
    "synonyms": [
      "Dissoziierte Vertikaldivergenz",
      "Dissoziiertes Vertikalschielen",
      "Hypertropie",
      "Hypotropie",
      "Höhenschielen",
      "Negative Vertikaldivergenz",
      "Nichtparetische latente Vertikaldeviation",
      "Nichtparetische manifeste Vertikaldeviation",
      "Positive Vertikaldivergenz",
      "Strabismus verticalis",
      "Vertikaldivergenz",
      "Vertikale Heterotropie"
    ]
  },
  {
    "code": "H50.3",
    "name": "Intermittierender Strabismus concomitans",
    "synonyms": [
      "Akkommodativer Strabismus convergens",
      "Alternierender Strabismus convergens intermittens",
      "Alternierender Strabismus divergens intermittens",
      "Intermittierende Esotropie",
      "Intermittierende Exotropie",
      "Intermittierende Heterotropie",
      "Intermittierende Restesotropie",
      "Intermittierende Restexotropie",
      "Intermittierende alternierende Esotropie",
      "Intermittierende alternierende Exotropie",
      "Intermittierender Strabismus concomitans",
      "Intermittierendes Auswärtsschielen",
      "Intermittierendes Einwärtsschielen",
      "Strabismus convergens intermittens",
      "Strabismus convergens intermittens unilateralis",
      "Strabismus divergens intermittens",
      "Strabismus divergens intermittens unilateralis",
      "Unilateraler Strabismus convergens intermittens",
      "Unilateraler Strabismus divergens intermittens"
    ]
  },
  {
    "code": "H50.4",
    "name": "Mikrostrabismus",
    "synonyms": [
      "Heterotropie",
      "Mikrostrabismus",
      "Mikrostrabismus convergens mit latenter Komponente",
      "Mikrostrabismus divergens",
      "Mikrotropie",
      "Obliquus-inferior-Überfunktion und Obliquus-superior-Parese des Auges",
      "Obliquus-superior-Überfunktion und Obliquus-inferior-Parese des Auges",
      "Strabismus concomitans a.n.k.",
      "Zyklotropie"
    ]
  },
  {
    "code": "H50.5",
    "name": "Esophorie",
    "synonyms": [
      "Alternierende Hyperphorie",
      "Cyclophoria alternans",
      "Dekompensierte Esophorie",
      "Dekompensierte Exophorie",
      "Dekompensierte Hyperphorie",
      "Dekompensierte Hypophorie",
      "Dekompensierte Zyklophorie",
      "Esophorie",
      "Exophorie",
      "Heterophorie",
      "Hyperphorie",
      "Hypophorie",
      "Latenter Strabismus",
      "Latentes Innenschielen",
      "Latentes Schielen",
      "Nahexophorie",
      "Zyklophorie"
    ]
  },
  {
    "code": "H50.6",
    "name": "Mechanisch bedingter Strabismus",
    "synonyms": [
      "Augenmuskeladhäsion",
      "Augenmuskelfibrose",
      "Augenmuskelfibrosesyndrom",
      "Brown-Phänomen",
      "Brown-Syndrom",
      "Erworbene Augenmuskeldeformität",
      "Klicksyndrom",
      "Mechanisch bedingter Strabismus",
      "Mechanische Motilitätsstörung des Auges",
      "Mechanische Motilitätsstörung des Auges durch Blow-out-Fraktur",
      "Posttraumatisches Strabismus-Syndrom",
      "Pseudo-obliquus-superior-Parese des Auges [Brown-Syndrom]",
      "Strabismus durch Adhäsion",
      "Strabismus durch Narben",
      "Strabismus durch Trauma"
    ]
  },
  {
    "code": "H50.8",
    "name": "Myopathischer Strabismus von Graefe",
    "synonyms": [
      "Augenmuskelkontraktur",
      "Duane-Retraktionssyndrom",
      "Duane-Syndrom",
      "Fibrosesyndrom",
      "Myopathischer Strabismus von Graefe",
      "Okuläres Retraktionssyndrom",
      "Retraktion des Bulbus oculi",
      "Retraktionssyndrom",
      "Stilling-Türk-Duane-Syndrom",
      "Strabismus accommodativus",
      "Strabismus deorsoadductorius",
      "Strabismus sursoadductorius",
      "Strabismus sursoadductorius et deorsoadductorius"
    ]
  },
  {
    "code": "H50.9",
    "name": "Strabismus",
    "synonyms": [
      "Alternierender Strabismus",
      "Augenmuskelerkrankung",
      "Augenmuskelkrankheit",
      "Kongenitaler Strabismus",
      "Koordinationsstörung der Augenmuskeln a.n.k.",
      "Nichtparalytischer Strabismus",
      "Okularmuskelinsuffizienz a.n.k.",
      "Schielen",
      "Schielfehler",
      "Strabismus"
    ]
  },
  {
    "code": "H51.0",
    "name": "Konjugierte Blicklähmung",
    "synonyms": [
      "Konjugierte Blicklähmung",
      "Konjugierte Blickparalyse",
      "Konjugierte Paralyse der Augenmuskeln",
      "Konjugierte kortikale Paralyse der Augenmuskeln"
    ]
  },
  {
    "code": "H51.1",
    "name": "Supranukleäre Konvergenzstörung",
    "synonyms": [
      "Konvergenzexzess",
      "Konvergenzinsuffizienz",
      "Konvergenzlähmung",
      "Konvergenzparalyse",
      "Konvergenzparese",
      "Konvergenzschwäche",
      "Konvergenzschwäche des Auges",
      "Konvergenzstörung",
      "Supranukleäre Konvergenzstörung",
      "Übermäßiger Konvergenz mit Esophorie"
    ]
  },
  {
    "code": "H51.2",
    "name": "Internukleäre Ophthalmoplegie",
    "synonyms": [
      "Internukleäre Ophthalmoplegie",
      "Internukleäre Paralyse"
    ]
  },
  {
    "code": "H51.8",
    "name": "Blickkrampf",
    "synonyms": [
      "Augenbewegungsspasmus",
      "Balint-Holmes-Syndrom",
      "Balint-Syndrom",
      "Blickkrampf",
      "Cogan-II-Syndrom",
      "Divergenzinsuffizienz",
      "Divergenzschwäche mit Esophorie",
      "Déviation conjuguée",
      "Exzessive Divergenz der Augen",
      "Kongenitale okulomotorische Apraxie",
      "Konjugierter Spasmus",
      "Nukleäre Divergenzparalyse",
      "Okulogyre Krise",
      "Okulogyrer Spasmus",
      "Okulomotorische Apraxie vom Typ Cogan",
      "Spasmus des Musculus obliquus inferior oculi",
      "Stangler-Zuschrott-Divergenzlähmung mit Fernesotropie",
      "Unsymmetrische Augendeviation",
      "Übermäßiger Divergenz mit Exophorie"
    ]
  },
  {
    "code": "H51.9",
    "name": "Augenmotilitätsstörung",
    "synonyms": [
      "Affektion der Augenbewegung",
      "Augenmotilitätsstörung",
      "Blickbewegungsstörung",
      "Okulomotorische Affektion",
      "Okulomotorische Störung",
      "Störung der Augenbewegung",
      "Störung der binokularen Augenbewegung"
    ]
  },
  {
    "code": "H52.0",
    "name": "Hyperopie",
    "synonyms": [
      "Achsenhypermetropie",
      "Achsenhyperopie",
      "Brechungshypermetropie",
      "Brechungshyperopie",
      "Hohe Hyperopie",
      "Hypermetropie",
      "Hyperopie",
      "Kongenitale Hypermetropie",
      "Kongenitale Weitsichtigkeit",
      "Kongenitale Übersichtigkeit",
      "Latente Hyperopie",
      "Manifeste Hyperopie",
      "Weitsichtigkeit",
      "Übersichtigkeit"
    ]
  },
  {
    "code": "H52.1",
    "name": "Myopie",
    "synonyms": [
      "Achsenmyopie",
      "Brechungsmyopie",
      "Fundus myopicus",
      "Funktionelle Myopie",
      "Kongenitale Myopie",
      "Kurzsichtigkeit",
      "Myopia magna",
      "Myopie",
      "Progressive Myopie"
    ]
  },
  {
    "code": "H52.2",
    "name": "Astigmatismus",
    "synonyms": [
      "Astigmatismus",
      "Kongenitale Stabsichtigkeit",
      "Kongenitaler Astigmatismus",
      "Stabsichtigkeit",
      "Stabsichtigkeit, jede Art"
    ]
  },
  {
    "code": "H52.3",
    "name": "Aniseikonie",
    "synonyms": [
      "Aniseikonie",
      "Anisometropie",
      "Kongenitale Anisometropie"
    ]
  },
  {
    "code": "H52.4",
    "name": "Presbyopie",
    "synonyms": [
      "Altersauge",
      "Altersbedingte Akkommodationsinsuffizienz",
      "Altersbedingte Sehschwäche",
      "Alterssichtigkeit",
      "Presbyopie"
    ]
  },
  {
    "code": "H52.5",
    "name": "Zykloplegie",
    "synonyms": [
      "Akkommodationsbeschwerden",
      "Akkommodationsdefizit",
      "Akkommodationsinsuffizienz",
      "Akkommodationskrampf",
      "Akkommodationslähmung",
      "Akkommodationsparalyse",
      "Akkommodationsparese",
      "Akkommodationsschwäche",
      "Akkommodationsspasmus",
      "Akkommodationsstörung",
      "Akkommodative Asthenopie",
      "Medikamentöse Akkommodationsstörung",
      "Ophthalmoplegia interna",
      "Ophthalmoplegia interna totalis",
      "Paralyse eines inneren Augenmuskels",
      "Toxische Akkommodationsstörung",
      "Zykloplegie",
      "Zyklospasmus"
    ]
  },
  {
    "code": "H52.7",
    "name": "Ametropie",
    "synonyms": [
      "Ametropie",
      "Brechungsanomalie",
      "Brechungsfehler",
      "Refraktionsamblyopie",
      "Refraktionsanomalie a.n.k.",
      "Refraktionsfehler",
      "Refraktionsstörung"
    ]
  },
  {
    "code": "H53.0",
    "name": "Amblyopie",
    "synonyms": [
      "Amblyopia ex anisometropia",
      "Amblyopia ex anopsia",
      "Amblyopie",
      "Amblyopie bei Ametropie",
      "Amblyopie bei Anisometropie",
      "Amblyopie bei Deprivation",
      "Amblyopie bei Strabismus",
      "Erworbene Amblyopie",
      "Kongenitale Amblyopie",
      "Partielle Amblyopie",
      "Ptosis bei Amblyopie",
      "Schielamblyopie",
      "Schwachsichtigkeit - s.a. Amblyopie",
      "Sehminderung"
    ]
  },
  {
    "code": "H53.1",
    "name": "Subjektive Sehstörung",
    "synonyms": [
      "Asthenopie",
      "Asthenopische Beschwerden",
      "Augenflimmern",
      "Augenrauschen",
      "Augenüberanstrengung a.n.k.",
      "Blendung",
      "Chromatopsie",
      "Farbringsehen um Lichtquellen",
      "Flimmerskotom",
      "Funkensehen",
      "Hemeralopie [Tagblindheit]",
      "Lichtempfindlichkeit",
      "Lichtscheu",
      "Makropsie",
      "Megalopsie",
      "Metamorphopsie",
      "Mikropsie",
      "Nyktalopie (Tagblindheit)",
      "Nykteralopie (Tagblindheit)",
      "Pathologische Blendungsempfindlichkeit",
      "Photophobie",
      "Photopsie",
      "Plötzlicher Sehverlust",
      "Plötzlicher Verlust des Sehvermögens",
      "Schattensehen",
      "Spintheropie",
      "Subjektiv vermindertes Dämmerungssehen",
      "Subjektive Sehstörung",
      "Subjektiver Gesichtsfeldausfall",
      "Tagblindheit",
      "Transitorische Blindheit",
      "Visual-snow-Syndrom",
      "Visueller Halo"
    ]
  },
  {
    "code": "H53.2",
    "name": "Diplopie",
    "synonyms": [
      "Binokulare Diplopie",
      "Diplopie",
      "Doppelbilder",
      "Doppelsichtigkeit",
      "Doppeltsehen",
      "Monokulare Diplopie",
      "Paroxysmale Diplopie"
    ]
  },
  {
    "code": "H53.3",
    "name": "Fusionsschwäche",
    "synonyms": [
      "Abnormität der korrespondierenden Netzhautpunkte",
      "Abnormität der korrespondierenden Retinapunkte",
      "Abnormität der retinalen Korrespondenz",
      "Anomale Netzhautkorrespondenz",
      "Anomale Retinakorrespondenz",
      "Binokularstörung bei Fusion mit herabgesetztem Stereosehen",
      "Binokularstörung bei Simultansehen ohne Fusion",
      "Binokularstörung bei anomaler NH [Netzhaut]-Korrespondenz",
      "Binokularstörung bei anomaler Retinakorrespondenz",
      "Fehlende Stereopsis",
      "Fusionsschwäche",
      "Gestörtes binokulares Sehvermögen",
      "Gleichzeitige optische Wahrnehmung ohne Fusion",
      "Retinale anomale Korrespondenz",
      "Simultane Wahrnehmung ohne Fusion",
      "Simultanperzeption ohne Fusion",
      "Störung des Binokularsehens",
      "Suppression des Binokularsehens",
      "Vermindertes Stereosehen"
    ]
  },
  {
    "code": "H53.4",
    "name": "Hemianopsie",
    "synonyms": [
      "Anopsie",
      "Binasale Halbseitenblindheit",
      "Binasale Hemianopsie",
      "Bitemporale Halbseitenblindheit",
      "Bitemporale Halbsichtigkeit",
      "Bitemporale Hemianopsie",
      "Bjerrumskotom",
      "Bogenförmiges Skotom",
      "Bogenskotom",
      "Bogenskotom des Gesichtsfelds",
      "Funktionelle Gesichtsfeldkonstriktion",
      "Fusionsstörung mit Ausfall korrespondierender Gesichtsfeldareale",
      "Generalisierte Gesichtsfeldreduktion",
      "Gesichtsfeldausfall",
      "Gesichtsfeldbegrenzung",
      "Gesichtsfelddefekt",
      "Gesichtsfelddeformität",
      "Gesichtsfeldeinengung",
      "Gesichtsfeldeinschränkung",
      "Gesichtsfeldkontraktion",
      "Goldmannspirale des Gesichtsfelds",
      "Halbseitenblindheit",
      "Halbsichtigkeit",
      "Hemianopsie",
      "Heteronyme Halbseitenblindheit",
      "Heteronyme Hemianopsie",
      "Homonyme Halbseitenblindheit",
      "Homonyme Hemianopsie",
      "Konzentrische Einengung des Gesichtsfelds",
      "Nasale Halbseitenblindheit",
      "Nasale Halbsichtigkeit",
      "Nasale Hemianopsie",
      "Periphere Gesichtsfeldkonstriktion",
      "Periphere Halbseitenblindheit",
      "Periphere Hemianopsie",
      "Quadrantenanopie",
      "Quadrantenanopsie",
      "Quadrantenanopsie des Gesichtsfelds",
      "Quadrantenhemianopsie",
      "Ringförmiges Skotom",
      "Ringskotom",
      "Ringskotom des Gesichtsfelds",
      "Skotom",
      "Temporale Restinsel des Gesichtsfelds",
      "Vergrößerter blinder Fleck",
      "Vergrößerter blinder Fleck des Gesichtsfelds",
      "Zentraler Gesichtsfeldrest",
      "Zentrales Skotom",
      "Zentralskotom des Gesichtsfelds"
    ]
  },
  {
    "code": "H53.5",
    "name": "Achloropsie",
    "synonyms": [
      "Achloropsie",
      "Achromatopsie",
      "Anerythropsie",
      "Anomale Trichromasie",
      "Azyanopsie",
      "Blau-Gelb-Schwäche",
      "Blaublindheit",
      "Blauzapfenmonochromasie",
      "Daltonismus",
      "Deuteranomalie",
      "Deuteranopie",
      "Dichromasie",
      "Dichromatopsie",
      "Dyschromatopsie",
      "Einfarbensehen",
      "Erworbene Achromatopsie",
      "Erworbene Farbsinnstörung",
      "Farbenblindheit",
      "Farbenblindheit vom Tritan-Typ",
      "Farbenfehlsichtigkeit",
      "Farbsinnstörung",
      "Gelb-Blau-Schwäche",
      "Grün-Rot-Schwäche",
      "Grünblindheit",
      "Inkomplette Farbenblindheit",
      "Komplette Farbenblindheit",
      "Kongenitale Achromatopsie",
      "Kongenitale Dichromasie",
      "Kongenitale Dichromatopsie",
      "Kongenitale Tritanopie",
      "Kongenitale anomale Trichromasie",
      "Monochromasie",
      "Pingelapesische Blindheit",
      "Protanomalie",
      "Protanopie",
      "Rot-Grün-Blindheit",
      "Rot-Grün-Schwäche",
      "Rotblindheit",
      "Rotschwäche",
      "Stäbchenmonochromasie",
      "Totale Farbenblindheit",
      "Tritanomalie",
      "Tritanopie",
      "Unvollständige Deuteranopie",
      "Unvollständige Protanopie",
      "Vollständige Deuteranopie",
      "Vollständige Protanopie",
      "Xanthopsie",
      "Zyanopsie"
    ]
  },
  {
    "code": "H53.6",
    "name": "Nachtblindheit",
    "synonyms": [
      "Amblyopie durch Nachtblindheit",
      "Dämmerungsamblyopie",
      "Dämmerungsblindheit",
      "Dämmerungssehstörung",
      "Kongenitale stationäre Nachtblindheit",
      "Kongenitale stationäre Nachtblindheit Typ Oguchi",
      "Morbus Oguchi",
      "Nachtblindheit",
      "Oguchi-Krankheit",
      "Oguchi-Syndrom",
      "Pathologische Dunkeladaptation"
    ]
  },
  {
    "code": "H53.8",
    "name": "Kortikale Blindheit",
    "synonyms": [
      "Amblyopie durch Nikotin",
      "Bradyopsie",
      "Kortikale Blindheit",
      "Oszillopsie",
      "Polyopie",
      "Riddoch-Syndrom",
      "Toxische Amblyopie a.n.k.",
      "Verschwommenes Sehvermögen"
    ]
  },
  {
    "code": "H53.9",
    "name": "Sehstörung",
    "synonyms": [
      "Augenermüdung",
      "Fehlsichtigkeit",
      "Müde Augen",
      "Sehbehinderung",
      "Sehbehinderung ohne Refraktionsanomalie und ohne Amblyopie",
      "Sehfehler",
      "Sehstörung",
      "Störung des Sehvermögens",
      "Visuelle Störung",
      "Visusermüdung",
      "Visusstörung",
      "Visusverschlechterung"
    ]
  },
  {
    "code": "H54.0",
    "name": "Beidseitiger Visus &lt;0,05",
    "synonyms": [
      "Amaurose",
      "Amaurosis",
      "Beidseitige Amaurose",
      "Beidseitiger Visus &lt",
      "0,05",
      "Blindheit",
      "Blindheit beider Augen",
      "Erblindung",
      "Erworbene Amaurose",
      "Erworbene Blindheit",
      "Hochgradige binokulare Sehbehinderung",
      "Kongenitale Amaurose",
      "Kongenitale Blindheit",
      "Sehkraftverlust",
      "Stufe 3 der Sehbeeinträchtigung",
      "Stufe 4 der Sehbeeinträchtigung",
      "Stufe 5 der Sehbeeinträchtigung",
      "Völliger Sehkraftverlust"
    ]
  },
  {
    "code": "H54.1",
    "name": "Schwere binokulare Sehbeeinträchtigung",
    "synonyms": [
      "Schwere binokulare Sehbeeinträchtigung",
      "Stufe 2 der Sehbeeinträchtigung"
    ]
  },
  {
    "code": "H54.2",
    "name": "Beidseitiger Visus &lt;0,3",
    "synonyms": [
      "Beidseitiger Visus &lt",
      "0,3",
      "Mittelschwere binokulare Sehbeeinträchtigung",
      "Stufe 1 der Sehbeeinträchtigung"
    ]
  },
  {
    "code": "H54.3",
    "name": "Leichte binokulare Sehbeeinträchtigung",
    "synonyms": [
      "Leichte binokulare Sehbeeinträchtigung",
      "Stufe 0 der Sehbeeinträchtigung mit mindestens einer leichten Sehbeeinträchtigung auf einem Auge"
    ]
  },
  {
    "code": "H54.4",
    "name": "Einseitige Amaurose",
    "synonyms": [
      "Blindheit eines Auges",
      "Einseitige Amaurose",
      "Einseitige Amaurose bei normalem Visus des anderen Auges",
      "Einseitiger Visusverlust &lt",
      "0,05 bei normalem Visus des anderen Auges",
      "Hochgradige monokulare Sehbehinderung",
      "Monokulare Blindheit",
      "Stufe 3 der Sehbeeinträchtigung eines Auges mit Stufen 0, 1, 2 oder 9 des anderen Auges",
      "Stufe 4 der Sehbeeinträchtigung eines Auges mit Stufen 0, 1, 2 oder 9 des anderen Auges",
      "Stufe 5 der Sehbeeinträchtigung eines Auges mit Stufen 0, 1, 2 oder 9 des anderen Auges"
    ]
  },
  {
    "code": "H54.5",
    "name": "Schwere monokulare Sehbeeinträchtigung",
    "synonyms": [
      "Schwere monokulare Sehbeeinträchtigung",
      "Stufe 2 der Sehbeeinträchtigung eines Auges mit Stufe 0, 1 oder 9 des anderen Auges"
    ]
  },
  {
    "code": "H54.6",
    "name": "Mittelschwere monokulare Sehbeeinträchtigung",
    "synonyms": [
      "Mittelschwere monokulare Sehbeeinträchtigung",
      "Stufe 1 der Sehbeeinträchtigung eines Auges mit Stufe 0 oder 9 des anderen Auges"
    ]
  },
  {
    "code": "H54.9",
    "name": "Beidseitiger Visusverlust",
    "synonyms": [
      "Beidseitiger Sehverlust",
      "Beidseitiger Visusverlust",
      "Einseitiger Visusverlust",
      "Problem mit dem Sehvermögen",
      "Sehdefekt a.n.k.",
      "Sehschwäche",
      "Sehverlust",
      "Sehvermögensdefekt a.n.k.",
      "Sehvermögensverlust",
      "Stufe 9 der Sehbeeinträchtigung",
      "Verlust des Sehvermögens auf einem Auge",
      "Verlust des Sehvermögens beider Augen",
      "Visusabfall",
      "Visusverlust"
    ]
  },
  {
    "code": "H55",
    "name": "Kongenitaler Nystagmus",
    "synonyms": [
      "Angeborener Nystagmus",
      "Angeborenes Augenzittern",
      "Ataxia ocularis",
      "Augenzittern",
      "Bergleute-Nystagmus",
      "Blickrichtungsnystagmus",
      "Dissoziierter Nystagmus",
      "Horizontalnystagmus",
      "Instabilitas oculorum",
      "Kongenitaler Nystagmus",
      "Kongenitaler Nystagmus mit Blockierung in der Nähe",
      "Kongenitaler Nystagmus mit Kopfzwangshaltung",
      "Kongenitaler Nystagmus mit wechselnder Kopfzwangshaltung",
      "Latenter Nystagmus",
      "Nystagmus",
      "Nystagmus durch Degeneration",
      "Nystagmus durch Deprivation",
      "Nystagmus mit Blockierung in der Nähe",
      "Nystagmus mit Kopfzwangshaltung",
      "Nystagmus mit wechselnder Kopfzwangshaltung",
      "Pendelnystagmus",
      "Rotatorischer Nystagmus",
      "Rucknystagmus",
      "Spontannystagmus"
    ]
  },
  {
    "code": "H57.0",
    "name": "Hippus pupillae",
    "synonyms": [
      "Abnormer Pupillenreflex",
      "Abnormität der Pupillenfunktion",
      "Abnormität der Pupillenreaktion",
      "Abnormität des Pupillenreflexes",
      "Adie-Syndrom",
      "Affektion der Pupillenfunktion",
      "Anisokorie",
      "Anomalie der Pupillenfunktion",
      "Atypisches Argyll-Robertson-Syndrom",
      "Hippus pupillae",
      "Holmes-Adie-Syndrom",
      "Iridoparalysis",
      "Iridoplegie",
      "Irisparalyse",
      "Komplette Iridoparalysis",
      "Komplette Iridoplegie",
      "Mechanische Pupillenstörung",
      "Medikamentöse Mydriasis",
      "Medikamentöse Pupillenstörung",
      "Miosis",
      "Mydriasis",
      "Myotonische Pupille",
      "Nichtsyphilitisches Argyll-Robertson-Syndrom",
      "Paradoxe Pupillenreaktion",
      "Partielle Iridoparalysis",
      "Partielle Iridoplegie",
      "Physiologische Anisokorie",
      "Posttraumatische Mydriasis",
      "Pupillendifferenz",
      "Pupillendilatation",
      "Pupillenentrundung",
      "Pupillenerweiterung",
      "Pupillenmyotonie",
      "Pupillenstörung",
      "Pupillotonie",
      "Pupilläre Störung"
    ]
  },
  {
    "code": "H57.1",
    "name": "Augenschmerzen",
    "synonyms": [
      "Augenbewegungsschmerzen",
      "Augenbrennen",
      "Augendrücken",
      "Augenneuralgie",
      "Augenschmerzen",
      "Augenschmerzen mit Übelkeit",
      "Augenstechen",
      "Fremdkörpergefühl im Auge",
      "Ophthalmische Schmerzen",
      "Orbitaschmerzen",
      "Reizauge"
    ]
  },
  {
    "code": "H57.8",
    "name": "Augenjucken",
    "synonyms": [
      "Augenblutung",
      "Augenentzündung",
      "Augenhämorrhagie a.n.k.",
      "Augenjucken",
      "Augenmelanose a.n.k.",
      "Augentränen",
      "Augenzyste a.n.k.",
      "Entzündliche Augenkrankheit a.n.k."
    ]
  },
  {
    "code": "H57.9",
    "name": "Affektion der Augenanhangsgebilde",
    "synonyms": [
      "Affektion der Augenanhangsgebilde",
      "Augenaffektion",
      "Augenerkrankung",
      "Augenkomplikation",
      "Augenkrankheit",
      "Augenproblem",
      "Augenschaden",
      "Augentrübung",
      "Augenödem",
      "Rotes Auge"
    ]
  },
  {
    "code": "H59.0",
    "name": "Glaskörperkomplikation nach Kataraktextraktion",
    "synonyms": [
      "Bullöse Keratopathie nach Kataraktextraktion",
      "Glaskörper-Berührungs-Syndrom",
      "Glaskörper-Hornhaut-Syndrom",
      "Glaskörper-Prellungs-Syndrom",
      "Glaskörperkomplikation nach Kataraktextraktion",
      "Glaskörperverlust bei CE [Kataraktextraktion]"
    ]
  },
  {
    "code": "H59.8",
    "name": "Intraoperative Glaskörperblutung",
    "synonyms": [
      "Akute postoperative Keratopathie",
      "Blutung nach Lid-OP [Operation]",
      "Chorioretinale Narbe nach Ablatio-OP [Operation]",
      "Chorioretinale Narbe nach chirurgischem Eingriff wegen Ablösung",
      "Fadengranulom des Lids",
      "Infektion eines postoperativen Sickerkissens",
      "Intraoperative Glaskörperblutung",
      "Liddefekt nach Exzision",
      "Nichtinfektiöse Entzündung eines postoperativen Sickerkissens",
      "Operativ verursachte Vorderkammerblutung",
      "Postoperative Glaskörperblutung",
      "Postoperative Iriseinklemmung",
      "Postoperative chorioretinale Narbe",
      "Postoperativer Irispigmentdefekt",
      "Postoperatives zystoides Makulaödem",
      "Sickerkissen-assoziierte Endophthalmitis",
      "Vernarbung nach filtrierender Glaukomoperation"
    ]
  },
  {
    "code": "H59.9",
    "name": "Augenerkrankung nach medizinischen Maßnahmen",
    "synonyms": [
      "Augenerkrankung nach medizinischen Maßnahmen",
      "Postoperative Augenkomplikation",
      "Postoperative Augenstörung"
    ]
  },
  {
    "code": "H60.0",
    "name": "Gehörgangsfurunkel",
    "synonyms": [
      "Abszess des Ohres",
      "Abszess des äußeren Ohres",
      "Furunkel des äußeren Gehörganges",
      "Furunkel des äußeren Ohres",
      "Gehörgangsabszess",
      "Gehörgangsfurunkel",
      "Gehörgangskarbunkel",
      "Ohrfurunkel",
      "Ohrkarbunkel",
      "Ohrmuschelabszess",
      "Ohrmuschelfurunkel",
      "Ohrmuschelkarbunkel"
    ]
  },
  {
    "code": "H60.1",
    "name": "Gehörgangsphlegmone",
    "synonyms": [
      "Gehörgangsphlegmone",
      "Ohrmuschelphlegmone"
    ]
  },
  {
    "code": "H60.2",
    "name": "Otitis externa maligna",
    "synonyms": [
      "Nekrotisierende Otitis externa",
      "Otitis externa maligna"
    ]
  },
  {
    "code": "H60.3",
    "name": "Badeotitis",
    "synonyms": [
      "Badeotitis",
      "Diffuse Infektion des äußeren Gehörganges",
      "Diffuse Otitis externa",
      "Eiterung des äußeren Gehörganges a.n.k.",
      "Eiterung des äußeren Ohres a.n.k.",
      "Gehörgangseiterung",
      "Hämorrhagische Otitis externa",
      "Infektion des äußeren Ohres",
      "Infektiöse Otitis externa",
      "Otitis externa diffusa",
      "Otitis externa haemorrhagica"
    ]
  },
  {
    "code": "H60.4",
    "name": "Gehörgangscholesteatom",
    "synonyms": [
      "Cholesteatom des äußeren Ohres",
      "Gehörgangscholesteatom",
      "Gehörgangsgranulation",
      "Granulom des äußeren Ohres",
      "Keratitis obturans des Gehörganges",
      "Keratosis obturans des äußeren Ohres",
      "Pseudocholesteatom des äußeren Ohres"
    ]
  },
  {
    "code": "H60.5",
    "name": "Akute nichtinfektiöse Otitis externa",
    "synonyms": [
      "Akute Otitis externa",
      "Akute Otitis externa durch Kontakt",
      "Akute Otitis externa durch Strahlung",
      "Akute Otitis externa durch eine chemische Substanz",
      "Akute aktinische Otitis externa",
      "Akute ekzematöse Otitis externa",
      "Akute nichtinfektiöse Otitis externa",
      "Akute reaktive Otitis externa",
      "Ekzem des äußeren Ohres",
      "Gehörgangsekzem",
      "Kontaktotitis",
      "Ohrekzem",
      "Ohrmuscheldermatitis",
      "Ohrmuschelekzem"
    ]
  },
  {
    "code": "H60.8",
    "name": "Otitis externa circumscripta",
    "synonyms": [
      "Chronische Otitis externa",
      "Otitis externa circumscripta",
      "Otitis externa sicca"
    ]
  },
  {
    "code": "H60.9",
    "name": "Gehörgangsentzündung",
    "synonyms": [
      "Entzündung des äußeren Gehörganges",
      "Entzündung des äußeren Ohres",
      "Gehörgangsentzündung",
      "Otitis externa",
      "Otitis externa catarrhalis"
    ]
  },
  {
    "code": "H61.0",
    "name": "Ohrmuschelperichondritis",
    "synonyms": [
      "Chondrodermatitis der Ohrmuschel",
      "Chondrodermatitis nodularis chronica helicis",
      "Chondrodermatitis nodularis helicis",
      "Ohrmuschelentzündung",
      "Ohrmuschelperichondritis",
      "Perichondritis auricularis",
      "Perichondritis des äußeren Gehörganges",
      "Perichondritis des äußeren Ohres"
    ]
  },
  {
    "code": "H61.1",
    "name": "Ohrmuschelneuralgie",
    "synonyms": [
      "Aurikuläre Fistel",
      "Aurikuläre Ossifikation",
      "Aurikuläres Othämatom",
      "Aurikuläres nichttraumatisches Othämatom",
      "Erworbene Auriculadeformität",
      "Erworbene Konchadeformität des Ohres",
      "Erworbene Ohrdeformität",
      "Erworbene Ohrmuscheldeformität",
      "Haematoma auris",
      "Kalzifikation des äußeren Ohres",
      "Knorpelsubstanzverlust am Ohr",
      "Nichttraumatisches Auriculahämatom",
      "Nichttraumatisches Ohrmuschelhämatom",
      "Ohrmuscheldeformität",
      "Ohrmuschelfistel",
      "Ohrmuschelhämatom",
      "Ohrmuschelkrankheit a.n.k.",
      "Ohrmuschelnarbe",
      "Ohrmuschelneuralgie",
      "Ossifikation des äußeren Ohres",
      "Othämatom",
      "Perilymphfistel der Ohrmuschel"
    ]
  },
  {
    "code": "H61.2",
    "name": "Obturierendes Zerumen",
    "synonyms": [
      "Cerumen obturans",
      "Festsitzendes Ohrschmalz",
      "Festsitzendes Zerumen",
      "Impaktiertes Zerumen",
      "Obturierendes Zerumen",
      "Ohrpfropf",
      "Ohrschmalzpfropf",
      "Zerumen",
      "Zerumenpfropf",
      "Zeruminalpfropf"
    ]
  },
  {
    "code": "H61.3",
    "name": "Erworbene Gehörgangsstenose",
    "synonyms": [
      "Erworbene Gehörgangsstenose",
      "Erworbene Gehörgangsstriktur",
      "Erworbene Stenose des äußeren Ohrkanals",
      "Erworbene Striktur des Meatus osseus",
      "Gehörgangskonstriktion",
      "Gehörgangsstenose",
      "Gehörgangsverengung",
      "Kollaps des äußeren Gehörganges",
      "Ohrkanalobstruktion",
      "Verengung des äußeren Gehörganges"
    ]
  },
  {
    "code": "H61.8",
    "name": "Ohrfistel",
    "synonyms": [
      "Erworbene Gehörgangsdeformität",
      "Exostose des äußeren Gehörganges",
      "Gehörgangsexostose",
      "Gehörgangsfistel",
      "Ohrfistel",
      "Ohrmuschelnekrose"
    ]
  },
  {
    "code": "H61.9",
    "name": "Krankheit des äußeren Ohres a.n.k.",
    "synonyms": [
      "Affektion des äußeren Ohres",
      "Gehörgangskrankheit a.n.k.",
      "Gehörgangsreizung",
      "Krankheit des äußeren Ohres a.n.k."
    ]
  },
  {
    "code": "H65.0",
    "name": "Akute seröse Otitis media",
    "synonyms": [
      "Akute sekretorische Otitis media",
      "Akute seröse Otitis media",
      "Akute seröse Otitis media mit Myringitis",
      "Akute sezernierende Otitis media",
      "Akuter Tubotympanalkatarrh",
      "Subakute sezernierende Otitis media"
    ]
  },
  {
    "code": "H65.1",
    "name": "Akute exsudative Otitis media",
    "synonyms": [
      "Akute Otitis media mit Erguss",
      "Akute allergische Otitis media",
      "Akute allergische blutige Otitis media",
      "Akute allergische muköse Otitis media",
      "Akute allergische seröse Otitis media",
      "Akute blutige Otitis media",
      "Akute exsudative Otitis media",
      "Akute katarrhalische Otitis media",
      "Akute mukoide Otitis media",
      "Akute muköse Otitis media",
      "Akute nichteitrige Otitis media",
      "Akute nichteitrige Otitis media mit Myringitis",
      "Akute seromuköse Otitis media",
      "Akute transsudative Otitis media",
      "Akute virale Otitis media",
      "Subakute Otitis media mit Erguss",
      "Subakute allergische Otitis media",
      "Subakute allergische blutige Otitis media",
      "Subakute allergische muköse Otitis media",
      "Subakute allergische seröse Otitis media",
      "Subakute blutige Otitis media",
      "Subakute exsudative Otitis media",
      "Subakute katarrhalische Otitis media",
      "Subakute mukoide Otitis media",
      "Subakute muköse Otitis media",
      "Subakute nichteitrige Otitis media",
      "Subakute seromuköse Otitis media",
      "Subakute transsudative Otitis media",
      "Subakute virale Otitis media"
    ]
  },
  {
    "code": "H65.2",
    "name": "Serotympanon",
    "synonyms": [
      "Chronische katarrhalische Otitis media",
      "Chronische katarrhalische Tubotympanitis",
      "Chronische seröse Otitis media",
      "Chronische seröse Otitis media mit Myringitis",
      "Chronischer Mittelohrkatarrh",
      "Chronischer Tubenmittelohrkatarrh",
      "Chronischer Tubotympanalkatarrh",
      "Chronischer ulzerierender Mittelohrkatarrh",
      "Katarrhalische Tubotympanitis",
      "Serotympanon"
    ]
  },
  {
    "code": "H65.3",
    "name": "Chronische muköse Otitis media",
    "synonyms": [
      "Chronische mukoide Otitis media",
      "Chronische muköse Otitis media",
      "Chronische muköse Otitis media mit Myringitis",
      "Chronische schleimige Otitis media",
      "Chronische sekretorische Otitis media",
      "Chronische sezernierende Otitis media",
      "Chronische transsudative Otitis media",
      "Glue ear",
      "Leimohr",
      "Mukotympanon"
    ]
  },
  {
    "code": "H65.4",
    "name": "Chronische allergische Otitis media",
    "synonyms": [
      "Chronische Otitis media mit Erguss",
      "Chronische Otitis media mit nichteitrigem Erguss",
      "Chronische allergische Otitis media",
      "Chronische exsudative Otitis media",
      "Chronische nichteitrige Otitis media",
      "Chronische nichteitrige Otitis media mit Myringitis",
      "Chronische seromuköse Otitis media",
      "Mukoserotympanon",
      "Nichteitriger Paukenerguss",
      "Seromukotympanon"
    ]
  },
  {
    "code": "H65.9",
    "name": "Nichteitrige Otitis media",
    "synonyms": [
      "Allergische Otitis media",
      "Exsudative Otitis media",
      "Katarrhalische Otitis media",
      "Mittelohrerguss",
      "Mittelohrkatarrh",
      "Muköse Otitis",
      "Nichteitrige Otitis media",
      "Nichteitrige Otitis media mit Myringitis",
      "Otitis media mit Erguss",
      "Otitis media mit nichteitrigem Erguss",
      "Otitis media serosa",
      "Paukenerguss",
      "Sekretorische Otitis media",
      "Seromuköse Otitis media",
      "Seröse Otitis media",
      "Sezernierende Otitis media",
      "Transsudative Otitis media",
      "Tubenmittelohrkatarrh",
      "Tubotympanalkatarrh"
    ]
  },
  {
    "code": "H66.0",
    "name": "Akute eitrige Otitis media",
    "synonyms": [
      "Akute eitrige Otitis media",
      "Akute eitrige Otitis media mit Myringitis",
      "Akute nekrotisierende Otitis media",
      "Akute purulente Otitis media",
      "Akuter Mittelohrabszess",
      "Gradenigo-Syndrom",
      "Subakute nekrotisierende Otitis media"
    ]
  },
  {
    "code": "H66.1",
    "name": "Chronische mesotympanale eitrige Otitis media",
    "synonyms": [
      "Benigne chronische eitrige Otitis media",
      "Chronische Tubenmittelohrkrankheit",
      "Chronische mesotympanale Otitis media",
      "Chronische mesotympanale eitrige Otitis media",
      "Chronische mesotympanale eitrige Otitis media mit Myringitis"
    ]
  },
  {
    "code": "H66.2",
    "name": "Chronische epitympanale Otitis media",
    "synonyms": [
      "Chronische Krankheit des Epitympanums",
      "Chronische Otitis media epitympanalis",
      "Chronische epitympanale Otitis media",
      "Chronische epitympanale Otitis media mit Myringitis"
    ]
  },
  {
    "code": "H66.3",
    "name": "Chronische eitrige Otitis media",
    "synonyms": [
      "Chronische eitrige Otitis media",
      "Chronische eitrige Otitis media mit Myringitis",
      "Chronische purulente Otitis media"
    ]
  },
  {
    "code": "H66.4",
    "name": "Pyotympanon",
    "synonyms": [
      "Eitrige Mittelohrentzündung",
      "Eitrige Otitis media",
      "Eitrige Otitis media mit Myringitis",
      "Mittelohrabszess",
      "Mittelohreiterung",
      "Mittelohrvereiterung",
      "Otitis media purulenta",
      "Otitis purulenta",
      "Purulente Otitis media",
      "Pyotympanon"
    ]
  },
  {
    "code": "H66.9",
    "name": "Perforierte Otitis media",
    "synonyms": [
      "Akute Entzündung der Paukenhöhle",
      "Akute Mittelohrentzündung",
      "Akute Otitis",
      "Akute Otitis media",
      "Akute Otitis media mit Myringitis",
      "Akute Panotitis",
      "Begleitotitis",
      "Chronische Mittelohrentzündung",
      "Chronische Otitis",
      "Chronische Otitis media",
      "Chronische Otitis mit Myringitis",
      "Fieberhafte Otitis",
      "Mittelohrentzündung",
      "Mittelohrinfektion",
      "Ohrentzündung",
      "Ohrinfektion",
      "Otitis",
      "Otitis bullosa",
      "Otitis media",
      "Otitis media bullosa",
      "Otitis media mit Myringitis",
      "Panotitis",
      "Paukenhöhlenentzündung",
      "Perforierte Otitis",
      "Perforierte Otitis media",
      "Säuglingsotitis",
      "Virusotitis"
    ]
  },
  {
    "code": "H68.0",
    "name": "Entzündung der Tuba auditiva",
    "synonyms": [
      "Akuter Tubenkatarrh",
      "Chronischer Tubenkatarrh",
      "Entzündung der Tuba auditiva",
      "Exsudativer Tubenkatarrh",
      "Infektion der Tuba Eustachii",
      "Infektion der Tuba auditiva",
      "Katarrh der Eustachi-Röhre",
      "Katarrh der Tuba auditiva",
      "Katarrhalische Entzündung der Eustachi-Röhre",
      "Ohrtrompetenentzündung",
      "Ohrtrompetenkatarrh",
      "Ohrtubenkatarrh",
      "Otosalpingitis",
      "Rhinosalpingitis",
      "Syringitis",
      "Syringitis der Tuba auditiva",
      "Syringitis des Ohres",
      "Tubenkatarrh",
      "Tubenkatarrh des Ohres"
    ]
  },
  {
    "code": "H68.1",
    "name": "Verschluss der Tuba auditiva",
    "synonyms": [
      "Komplette Obstruktion der Tuba auditiva",
      "Kompression der Eustachi-Röhre",
      "Kompression der Tuba auditiva",
      "Obstruktion der Tuba auditiva",
      "Ohrtrompetenstenose",
      "Ohrtrompetenstriktur",
      "Ohrtubenstenose",
      "Partielle Obstruktion der Tuba auditiva",
      "Stenose der Tuba auditiva",
      "Striktur der Tuba auditiva",
      "Teilweise Obstruktion der Eustachi-Röhre",
      "Verengung der Tuba auditiva",
      "Verschluss der Tuba auditiva",
      "Vollständige Obstruktion der Eustachi-Röhre"
    ]
  },
  {
    "code": "H69.0",
    "name": "Erweiterte Tuba auditiva",
    "synonyms": [
      "Dilatation der Tuba auditiva",
      "Erweiterte Tuba auditiva",
      "Klaffende Tube",
      "Klaffende Tube des Ohres"
    ]
  },
  {
    "code": "H69.8",
    "name": "Tubenfunktionsstörung",
    "synonyms": [
      "Divertikel der Eustachi-Röhre",
      "Divertikel der Tuba auditiva",
      "Tubenbelüftungsstörung",
      "Tubenfunktionsstörung",
      "Tubeninsuffizienz",
      "Tubenventilationsstörung"
    ]
  },
  {
    "code": "H69.9",
    "name": "Krankheit der Tuba auditiva",
    "synonyms": [
      "Affektion der Tuba auditiva",
      "Krankheit der Tuba auditiva",
      "Ohrtrompetenkrankheit",
      "Störung der Eustachi-Röhre a.n.k.",
      "Störung der Tuba auditiva",
      "Tuba-auditiva-Dysfunktion"
    ]
  },
  {
    "code": "H70.0",
    "name": "Akute Mastoiditis",
    "synonyms": [
      "Abszess des Processus mastoideus",
      "Akute Entzündung des Warzenfortsatzes",
      "Akute Mastoiditis",
      "Akutes Empyem des Warzenfortsatzes",
      "Pyozele des Processus mastoideus",
      "Subakute Mastoiditis",
      "Von-Bezold-Abszess",
      "Von-Bezold-Krankheit",
      "Warzenfortsatzabszess",
      "Warzenfortsatzempyem"
    ]
  },
  {
    "code": "H70.1",
    "name": "Chronische Mastoiditis",
    "synonyms": [
      "Chronische Mastoiditis",
      "Chronische Warzenfortsatzkrankheit",
      "Chronische Warzenfortsatznekrose",
      "Fistel des Processus mastoideus",
      "Mastoidfistel",
      "Nekrotische Mastoiditis",
      "Postaurikuläre Fistel",
      "Retroaurikuläre Fistel",
      "Rezidivierende Mastoiditis",
      "Warzenfortsatzfistel",
      "Warzenfortsatznekrose"
    ]
  },
  {
    "code": "H70.2",
    "name": "Felsenbeineiterung",
    "synonyms": [
      "Akute Eiterung des Felsenbeins",
      "Akute Eiterung des Pyramidenspalts",
      "Akute Felsenbeinentzündung",
      "Akute Felsenbeinostitis",
      "Chronische Felsenbeinentzündung",
      "Chronische Felsenbeinostitis",
      "Eiterung der Pyramidenspitze",
      "Felsenbeinabszess",
      "Felsenbeineiterung",
      "Felsenbeinentzündung",
      "Felsenbeinosteomyelitis",
      "Petrositis",
      "Pyramideneiterung"
    ]
  },
  {
    "code": "H70.8",
    "name": "Warzenfortsatzperforation",
    "synonyms": [
      "Warzenfortsatzperforation"
    ]
  },
  {
    "code": "H70.9",
    "name": "Mastoiditis",
    "synonyms": [
      "Antritis",
      "Eitrige Mastoiditis",
      "Entzündung des Antrum mastoideum",
      "Hämorrhagische Mastoiditis",
      "Mastoiditis",
      "Mastoiditis mit Einschmelzung",
      "Ostitis mastoidea",
      "Suppurative Mastoiditis"
    ]
  },
  {
    "code": "H71",
    "name": "Mittelohrcholesteatom",
    "synonyms": [
      "Cholesteatom",
      "Cholesteatom des Cavum tympani",
      "Cholesteatom des Ohres",
      "Cholesteatom des Warzenfortsatzes",
      "Cholesteatom mit entzündlicher Reaktion",
      "Entzündetes Cholesteatom des Ohres",
      "Mittelohrcholesteatom",
      "Mittelohrgranulom",
      "Paukengranulation",
      "Perlgeschwulst",
      "Primäres Cholesteatom",
      "Primäres juveniles Cholesteatom",
      "Pseudocholesteatom",
      "Pseudocholesteatom des Mittelohres"
    ]
  },
  {
    "code": "H72.0",
    "name": "Zentrale Trommelfellperforation",
    "synonyms": [
      "Zentrale Trommelfellperforation"
    ]
  },
  {
    "code": "H72.1",
    "name": "Trommelfellperforation des Recessus epitympanicus",
    "synonyms": [
      "Perforation der Pars flaccida des Trommelfells",
      "Trommelfellperforation des Recessus epitympanicus"
    ]
  },
  {
    "code": "H72.2",
    "name": "Randständige Trommelfellperforation a.n.k.",
    "synonyms": [
      "Randständige Trommelfellperforation a.n.k."
    ]
  },
  {
    "code": "H72.8",
    "name": "Mehrfache Trommelfellperforation",
    "synonyms": [
      "Mehrfache Trommelfellperforation",
      "Mehrfache Trommelfellruptur",
      "Totale Trommelfellperforation",
      "Totale Trommelfellruptur"
    ]
  },
  {
    "code": "H72.9",
    "name": "Trommelfellperforation",
    "synonyms": [
      "Nichttraumatische Trommelfellperforation",
      "Nichttraumatische Trommelfellruptur",
      "Persistierend-posttraumatische Trommelfellperforation",
      "Trommelfelldefekt",
      "Trommelfellperforation",
      "Trommelfellperforation nach Entzündung"
    ]
  },
  {
    "code": "H73.0",
    "name": "Akute Myringitis",
    "synonyms": [
      "Akute Myringitis",
      "Akute Trommelfellentzündung",
      "Akute Tympanitis",
      "Bullöse Myringitis"
    ]
  },
  {
    "code": "H73.1",
    "name": "Chronische Myringitis",
    "synonyms": [
      "Chronische Myringitis",
      "Chronische Trommelfellentzündung",
      "Chronische Tympanitis",
      "Myringitis granulomatosa"
    ]
  },
  {
    "code": "H73.8",
    "name": "Trommelfellsklerose",
    "synonyms": [
      "Sklerose der Membrana tympani",
      "Trommelfellatrophie",
      "Trommelfellgranulation",
      "Trommelfellinfektion",
      "Trommelfellnarbe",
      "Trommelfellossifikation",
      "Trommelfellretraktion",
      "Trommelfellsklerose",
      "Tympanitis"
    ]
  },
  {
    "code": "H73.9",
    "name": "Trommelfellkrankheit",
    "synonyms": [
      "Myringitis",
      "Trommelfellaffektion",
      "Trommelfellentzündung",
      "Trommelfellkrankheit"
    ]
  },
  {
    "code": "H74.0",
    "name": "Tympanosklerose",
    "synonyms": [
      "Trommelfellverhärtung",
      "Tympanosklerose"
    ]
  },
  {
    "code": "H74.1",
    "name": "Adhäsive Otitis media",
    "synonyms": [
      "Adhäsive Mittelohrkrankheit",
      "Adhäsive Otitis",
      "Adhäsive Otitis media",
      "Adhäsivprozess nach Otitis media",
      "Mittelohradhäsivprozess"
    ]
  },
  {
    "code": "H74.2",
    "name": "Kontinuitätsunterbrechung der Gehörknöchelchenkette",
    "synonyms": [
      "Diskontinuität der Gehörknöchelchen",
      "Dislokation der Gehörknöchelchenkette",
      "Kontinuitätsunterbrechung der Gehörknöchelchenkette"
    ]
  },
  {
    "code": "H74.3",
    "name": "Ankylose der Gehörknöchelchen",
    "synonyms": [
      "Ankylose der Gehörknöchelchen",
      "Erworbene Abnormität der Ohrknöchelchen a.n.k.",
      "Erworbenes Fehlen des Ambosses",
      "Infektiöse Amboss-Steigbügel-Ankylose",
      "Nekrose der Gehörknöchelchen",
      "Partieller Verlust der Gehörknöchelchen",
      "Stapesankylose",
      "Stapesfixation",
      "Thies-Reis-Syndrom"
    ]
  },
  {
    "code": "H74.4",
    "name": "Mittelohrpolyp",
    "synonyms": [
      "Gehörgangspolyp",
      "Mittelohrpolyp",
      "Ohrpolyp",
      "Paukenhöhlenpolyp"
    ]
  },
  {
    "code": "H74.8",
    "name": "Mittelohrblutung",
    "synonyms": [
      "Mittelohrblutung",
      "Mittelohrfistel",
      "Mittelohrnarbe"
    ]
  },
  {
    "code": "H74.9",
    "name": "Warzenfortsatzkrankheit",
    "synonyms": [
      "Mittelohrkrankheit",
      "Warzenfortsatzkrankheit"
    ]
  },
  {
    "code": "H80.0",
    "name": "Nichtobliterierende Otosklerose mit Beteiligung der Fenestra vestibuli",
    "synonyms": [
      "Nichtobliterierende Otosklerose mit Beteiligung der Fenestra vestibuli",
      "Otosklerose mit nichtobliteriertem ovalen Fenster"
    ]
  },
  {
    "code": "H80.1",
    "name": "Obliterierende Otosklerose mit Beteiligung der Fenestra vestibuli",
    "synonyms": [
      "Obliterierende Otosklerose",
      "Obliterierende Otosklerose mit Beteiligung der Fenestra vestibuli",
      "Otosklerose mit obliteriertem ovalen Fenster"
    ]
  },
  {
    "code": "H80.2",
    "name": "Otosclerosis cochleae",
    "synonyms": [
      "Innenohrotosklerose",
      "Kapselotosklerose",
      "Kochlearotosklerose",
      "Otosclerosis cochleae",
      "Otosklerose der Labyrinthknochen",
      "Otosklerose mit Beteiligung der Fenestra cochleae",
      "Otosklerose mit Beteiligung des knöchernen Labyrinths"
    ]
  },
  {
    "code": "H80.9",
    "name": "Otosklerose",
    "synonyms": [
      "Otosklerose",
      "Otospongiose"
    ]
  },
  {
    "code": "H81.0",
    "name": "Labyrinthhydrops",
    "synonyms": [
      "Angioneurotische Oktavuskrise",
      "Angiopathia labyrinthica",
      "Endolymphatischer Hydrops",
      "Labyrinth-Vertigo",
      "Labyrinthhydrops",
      "Morbus Ménière",
      "Ménière-Krankheit",
      "Ménière-Schwindel",
      "Ménière-Symptomenkomplex",
      "Ménière-Syndrom",
      "Ménière-Vertigo",
      "Vestibularis-Syndrom"
    ]
  },
  {
    "code": "H81.1",
    "name": "Benigner paroxysmaler Schwindel",
    "synonyms": [
      "Benigne paroxysmale Vertigo",
      "Benigner paroxysmaler Lagerungsschwindel",
      "Benigner paroxysmaler Nystagmus",
      "Benigner paroxysmaler Schwindel",
      "Paroxysmaler Lageschwindel",
      "Peripherer Lagerungsnystagmus"
    ]
  },
  {
    "code": "H81.2",
    "name": "Neuropathia vestibularis",
    "synonyms": [
      "Epidemische Neurolabyrinthitis",
      "Neuronitis vestibularis",
      "Neuropathia vestibularis",
      "Vestibularisneuropathie",
      "Vestibularneuronitis"
    ]
  },
  {
    "code": "H81.3",
    "name": "Peripherer Schwindel",
    "synonyms": [
      "Lermoyez-Schwindel",
      "Lermoyez-Syndrom",
      "Ohrschwindel",
      "Otogene Vertigo",
      "Otogener Schwindel",
      "Peripher-labyrinthärer Schwindelzustand",
      "Periphere Vertigo a.n.k.",
      "Peripherer Schwindel",
      "Vertigo auralis",
      "Vertigo auricularis"
    ]
  },
  {
    "code": "H81.4",
    "name": "Schwindel zentralen Ursprungs",
    "synonyms": [
      "Hirnorganischer Schwindel",
      "Schwindel zentralen Ursprungs",
      "Vertigo zentralen Ursprungs",
      "Vestibularer Nystagmus",
      "Zentraler Lagenystagmus",
      "Zentraler Schwindel",
      "Zentrales vestibuläres Syndrom",
      "Zerebrale Vertigo"
    ]
  },
  {
    "code": "H81.8",
    "name": "Drehschwindel mit Gleichgewichtsstörung",
    "synonyms": [
      "Bonnier-Syndrom",
      "Drehschwindel mit Gleichgewichtsstörung",
      "Idiopathische bilaterale Vestibulopathie",
      "Mal-de-Débarquement-Syndrom",
      "Otolithenfunktionsstörung"
    ]
  },
  {
    "code": "H81.9",
    "name": "Vestibularisausfall",
    "synonyms": [
      "Dauerschwindel mit Gleichgewichtsstörung",
      "Schwindel-Syndrom",
      "Störung der Vestibularfunktion",
      "Vestibularerkrankung",
      "Vestibularisausfall",
      "Vestibularschwindel"
    ]
  },
  {
    "code": "H83.0",
    "name": "Labyrinthitis",
    "synonyms": [
      "Abszess des inneren Ohres",
      "Akute Labyrinthitis",
      "Akute Perilabyrinthitis",
      "Destruktive Labyrinthitis",
      "Diffuse Labyrinthitis",
      "Eiterung des inneren Ohres",
      "Eitrige Labyrinthitis",
      "Fensterlabyrinthitis",
      "Infektion des inneren Ohres",
      "Innenohrentzündung",
      "Innenohrhyperämie",
      "Labyrintheiterung",
      "Labyrinthentzündung",
      "Labyrinthhyperämie",
      "Labyrinthitis",
      "Labyrinthitis circumscripta",
      "Labyrinthitis des inneren Ohres",
      "Latente Labyrinthitis",
      "Otitis interna",
      "Otitis interna vasomotorica",
      "Perilabyrinthitis",
      "Vestibulitis",
      "Vestibulitis des Ohres"
    ]
  },
  {
    "code": "H83.1",
    "name": "Labyrinthfistel",
    "synonyms": [
      "Bogengangfistel",
      "Innenohrfistel",
      "Labyrinthfistel"
    ]
  },
  {
    "code": "H83.2",
    "name": "Funktionsstörung des Labyrinths",
    "synonyms": [
      "Dysfunktion des Labyrinths",
      "Funktionsstörung des Labyrinths",
      "Hypersensitives Labyrinth",
      "Koordinationsstörung des Labyrinths",
      "Labyrinthausfall",
      "Labyrinthreizung",
      "Labyrinthunterfunktion",
      "Labyrinthüberempfindlichkeit",
      "Nichtfunktionierendes Labyrinth",
      "Verlust der Labyrinthfunktion",
      "Übererregbarkeit des Labyrinths"
    ]
  },
  {
    "code": "H83.3",
    "name": "Lärmschädigung des Innenohres",
    "synonyms": [
      "Akustisches Trauma",
      "Akuter sensorineuraler Hörverlust durch akustisches Trauma",
      "Gehörverlust durch Geräusch",
      "Geräuschinduzierte Schwerhörigkeit",
      "Geräuschinduzierte Taubheit",
      "Knalltrauma",
      "Lärminduzierte Schwerhörigkeit",
      "Lärminduzierte Taubheit",
      "Lärmschwerhörigkeit",
      "Lärmschädigung des Innenohres",
      "Schädigende Geräuscheinwirkung auf Innenohr"
    ]
  },
  {
    "code": "H83.8",
    "name": "Labyrinthdegeneration",
    "synonyms": [
      "Bogengangsdehiszenz-Syndrom",
      "Cochleadegeneration",
      "Degeneration des knöchernen Labyrinths",
      "Innenohrblutung",
      "Innenohrhämorrhagie",
      "Kochleablutung",
      "Kochleahämorrhagie",
      "Labyrinthblutung",
      "Labyrinthdegeneration",
      "Labyrinthhämorrhagie",
      "Labyrinthstauung"
    ]
  },
  {
    "code": "H83.9",
    "name": "Innenohrstörung",
    "synonyms": [
      "Innenohrkrankheit",
      "Innenohrschaden",
      "Innenohrstörung",
      "Labyrinthaffektion",
      "Labyrinthkrankheit"
    ]
  },
  {
    "code": "H90.0",
    "name": "Beidseitiger Hörverlust durch Schallleitungsstörung",
    "synonyms": [
      "Beidseitige Schallleitungsschwerhörigkeit",
      "Beidseitiger Hörverlust durch Schallleitungsstörung",
      "Escher-Hirt-Syndrom",
      "Escher-Hort-Syndrom"
    ]
  },
  {
    "code": "H90.1",
    "name": "Einseitiger Hörverlust durch Schallleitungsstörung bei nichteingeschränktem Hörvermögen der anderen Seite",
    "synonyms": [
      "Einseitiger Hörverlust durch Schallleitungsstörung bei nichteingeschränktem Hörvermögen der anderen Seite"
    ]
  },
  {
    "code": "H90.2",
    "name": "Schallleitungsschwerhörigkeit",
    "synonyms": [
      "Konduktive Schwerhörigkeit",
      "Mittelohrschwerhörigkeit",
      "Schallleitungsschwerhörigkeit",
      "Schallleitungsstörung"
    ]
  },
  {
    "code": "H90.3",
    "name": "Beidseitiger Hörverlust durch Schallempfindungsstörung",
    "synonyms": [
      "Angeborene beidseitige Schallempfindungsschwerhörigkeit",
      "Autosomal-dominante nicht-syndromale sensorineurale Schwerhörigkeit Typ DFNA",
      "Autosomal-rezessive nicht-syndromale sensorineurale Schwerhörigkeit Typ DFNB",
      "Beidseitige Innenohrhochtonschwerhörigkeit",
      "Beidseitige Innenohrschwerhörigkeit",
      "Beidseitige Schallempfindungsschwerhörigkeit",
      "Beidseitiger Hörverlust durch Schallempfindungsstörung",
      "Nicht-syndromale genetisch bedingte beidseitige Schwerhörigkeit",
      "Progressive Schwerhörigkeit mit gingivaler Fibromatose",
      "X-chromosomale nicht-syndromale sensorineurale Schwerhörigkeit Typ DFN"
    ]
  },
  {
    "code": "H90.4",
    "name": "Einseitiger Hörverlust durch Schallempfindungsstörung bei nichteingeschränktem Hörvermögen der anderen Seite",
    "synonyms": [
      "Angeborene einseitige Schallempfindungsschwerhörigkeit",
      "Einseitige Schallempfindungsschwerhörigkeit",
      "Einseitiger Hörverlust durch Schallempfindungsstörung bei nichteingeschränktem Hörvermögen der anderen Seite"
    ]
  },
  {
    "code": "H90.5",
    "name": "Zentral-neurale Hörminderung",
    "synonyms": [
      "Angeborene Schwerhörigkeit",
      "Angeborene Taubheit",
      "Innenohrschwerhörigkeit",
      "Isolierte mitochondriale neurosensorische Schwerhörigkeit",
      "Isolierter mitochondrial bedingter neurosensorischer Hörverlust",
      "Kochleare Schwerhörigkeit",
      "Kongenitale Schwerhörigkeit a.n.k.",
      "Kongenitale Taubheit a.n.k.",
      "Labyrinthschwerhörigkeit",
      "Mitochondriale nicht-syndromale sensorineurale Schwerhörigkeit",
      "Mitochondriale nichtsyndromale sensorineurale Schwerhörigkeit mit erhöhter Empfindlichkeit gegen Aminoglykoside",
      "Neuraler Hörverlust",
      "Nicht-syndromale genetisch bedingte Schwerhörigkeit",
      "Perzeptionsschwerhörigkeit",
      "Perzeptiver Hörverlust",
      "Postlinguale nichtsyndromale genetisch bedingte Schwerhörigkeit",
      "Prälinguale nichtsyndromale genetisch bedingte Schwerhörigkeit",
      "Retrokochleäre Taubheit",
      "Rindentaubheit",
      "Schallempfindungsschwerhörigkeit",
      "Schwerhörigkeit durch Schallempfindungsstörung",
      "Schwerhörigkeit mit Albinismus",
      "Sensorineuraler Hörverlust",
      "Sensorischer Hörverlust",
      "Syndrom der sensorineuralen Schwerhörigkeit mit hochgradiger Myopie",
      "Taubheit durch Schallempfindungsstörung",
      "Zentral-neurale Hörminderung",
      "Zentrale Taubheit",
      "Zentraler Hörverlust"
    ]
  },
  {
    "code": "H90.6",
    "name": "Kombinierte beidseitige Schwerhörigkeit durch Schallleitungs- und Schallempfindungsstörung",
    "synonyms": [
      "Kombinierte beidseitige Schwerhörigkeit durch Schallleitungs- und Schallempfindungsstörung",
      "Kombinierte beidseitige Taubheit durch Schallleitungs- und Schallempfindungsstörung"
    ]
  },
  {
    "code": "H90.7",
    "name": "Kombinierte einseitige Schwerhörigkeit durch Schallleitungs- und Schallempfindungsstörung",
    "synonyms": [
      "Kombinierte einseitige Schwerhörigkeit durch Schallleitungs- und Schallempfindungsstörung",
      "Kombinierte einseitige Taubheit durch Schallleitungs- und Schallempfindungsstörung"
    ]
  },
  {
    "code": "H90.8",
    "name": "Kombinierte Innenohr- und Mittelohrschwerhörigkeit",
    "synonyms": [
      "Kombinierte Innenohr- und Mittelohrschwerhörigkeit",
      "Kombinierte Schwerhörigkeit durch Schallleitungs- und Schallempfindungsstörung",
      "Kombinierte Taubheit durch Schallleitungs- und Schallempfindungsstörung",
      "Nance-Schwerhörigkeit",
      "Schallleitungsschwerhörigkeit mit Innenohrschwerhörigkeit",
      "X-chromosomale Schwerhörigkeit Typ 2",
      "X-chromosomale gemischte Schallleitungsschwerhörigkeit und neurosensorischer Hörverlust",
      "X-chromosomale gemischte Schwerhörigkeit mit Perilymphfistel",
      "X-chromosomales Stapes-Gusher-Syndrom"
    ]
  },
  {
    "code": "H91.0",
    "name": "Ototoxischer Hörverlust",
    "synonyms": [
      "Ototoxische Schwerhörigkeit",
      "Ototoxische Taubheit",
      "Ototoxischer Hörverlust",
      "Schwerhörigkeit durch toxisches Agens",
      "Taubheit durch toxisches Agens",
      "Toxische Innenohrschwerhörigkeit"
    ]
  },
  {
    "code": "H91.1",
    "name": "Presbyakusis",
    "synonyms": [
      "Altersbedingte Schwerhörigkeit",
      "Altersbegleitende Schwerhörigkeit",
      "Altersschwerhörigkeit",
      "Presbyakusis"
    ]
  },
  {
    "code": "H91.2",
    "name": "Idiopathischer Hörsturz",
    "synonyms": [
      "Akute Schwerhörigkeit",
      "Akute Taubheit",
      "Akuter Hörverlust",
      "Akuter sensorineuraler Hörverlust durch Hörsturz",
      "Hörsturz",
      "Idiopathischer Hörsturz",
      "Plötzliche idiopathische Schwerhörigkeit",
      "Plötzliche idiopathische Taubheit",
      "Plötzlicher Hörverlust"
    ]
  },
  {
    "code": "H91.3",
    "name": "Taubstummheit",
    "synonyms": [
      "Erworbene Taubstummheit a.n.k.",
      "Kongenitale Taubstummheit a.n.k.",
      "Mutismus bei erworbener Taubheit a.n.k.",
      "Mutismus bei kongenitaler Taubheit a.n.k.",
      "Mutisurditas",
      "Mutitas surdorum",
      "Surdomutitas",
      "Taubstummheit"
    ]
  },
  {
    "code": "H91.9",
    "name": "Surditas",
    "synonyms": [
      "Beidseitige Schwerhörigkeit",
      "Einseitige Schwerhörigkeit",
      "Erworbene Minderung des Hörvermögens",
      "Erworbene Schwerhörigkeit",
      "Erworbene Taubheit",
      "Gehörlosigkeit - s.a. Taubheit",
      "Gehörschwäche - s.a. Schwerhörigkeit oder s.a. Gehörverminderung",
      "Gehörverminderung",
      "Herabgesetztes Hörvermögen",
      "Hereditäre Schwerhörigkeit",
      "Hereditäre Taubheit",
      "Hochtonschwerhörigkeit",
      "Hochtontaubheit",
      "Hypakusis",
      "Hypoakusis",
      "Hördefekt",
      "Hörminderung",
      "Hörschwäche",
      "Hörverlust",
      "Kongenitale Minderung des Hörvermögens",
      "Minderung des Hörvermögens",
      "Partielle Schwerhörigkeit",
      "Partielle Taubheit",
      "Problem mit dem Hörvermögen",
      "Schwerhörigkeit",
      "Schwerhörigkeit für hohe Frequenzen",
      "Schwerhörigkeit für hohe und tiefe Frequenzen",
      "Schwerhörigkeit für tiefe Frequenzen",
      "Surditas",
      "Taubheit",
      "Taubheit für hohe Frequenzen",
      "Taubheit für hohe und tiefe Frequenzen",
      "Taubheit für tiefe Frequenzen",
      "Tieftonschwerhörigkeit",
      "Tieftontaubheit",
      "Vollständige Schwerhörigkeit",
      "Vollständige Taubheit"
    ]
  },
  {
    "code": "H92.0",
    "name": "Otalgie",
    "synonyms": [
      "Mastoidalgie",
      "Ohrbeschwerden",
      "Ohrenschmerzen",
      "Ohrneuralgie",
      "Otagra",
      "Otalgia",
      "Otalgie",
      "Otodynie",
      "Otoneuralgie",
      "Retroaurikularneuralgie",
      "Warzenfortsatzschmerzen"
    ]
  },
  {
    "code": "H92.1",
    "name": "Otorrhoe",
    "synonyms": [
      "Ausfluss aus dem Ohr",
      "Chronische Otorrhoe",
      "Ohrenfluss",
      "Ohrlaufen",
      "Otorrhoe"
    ]
  },
  {
    "code": "H92.2",
    "name": "Otorrhagie",
    "synonyms": [
      "Gehörgangsblutung",
      "Nichttraumatische Hämorrhagie des äußeren Gehörganges",
      "Nichttraumatische Otorrhagie",
      "Otorrhagie"
    ]
  },
  {
    "code": "H93.0",
    "name": "Durchblutungsstörung des Innenohres",
    "synonyms": [
      "DBS [Durchblutungsstörung] des Innenohres",
      "DBS [Durchblutungsstörung] des Labyrinths",
      "Degenerative Ohrkrankheit",
      "Durchblutungsstörung des Innenohres",
      "Durchblutungsstörung des Labyrinths",
      "Entwicklungsbedingte vorübergehende ischämische Schwerhörigkeit",
      "Entwicklungsbedingte vorübergehende ischämische Taubheit",
      "Flüchtige ischämische Schwerhörigkeit",
      "Flüchtige ischämische Taubheit",
      "Transitorische ischämische Schwerhörigkeit",
      "Transitorische ischämische Taubheit",
      "Vaskuläre Ohrkrankheit",
      "Vaskuläre degenerative Ohraffektion",
      "Vorübergehende ischämische Schwerhörigkeit",
      "Vorübergehende ischämische Taubheit"
    ]
  },
  {
    "code": "H93.1",
    "name": "Tinnitus aurium",
    "synonyms": [
      "Arteriosklerotischer Tinnitus",
      "Hörbarer Tinnitus",
      "Ohrenklingen",
      "Ohrensausen",
      "Ohrgeräusch",
      "Ohrrauschen",
      "Subjektiver Tinnitus",
      "Tinnitus",
      "Tinnitus aurium",
      "Vaskulärer Tinnitus",
      "Zervikaler Tinnitus"
    ]
  },
  {
    "code": "H93.2",
    "name": "Lärmüberempfindlichkeit",
    "synonyms": [
      "Abnorme Hörempfindung",
      "Abnorme akustische Empfindung a.n.k.",
      "Akustisches Recruitment",
      "Diplakusis",
      "Dysakusis",
      "Hyperakusis",
      "Hörstörung",
      "Lautheitsausgleich",
      "Lärmempfindlichkeit des Gehörs",
      "Lärmüberempfindlichkeit",
      "Recruitment",
      "Störung der akustischen Diskrimination",
      "Subjektive Hörstörung",
      "Zeitweilige Hörschwellenverschiebung"
    ]
  },
  {
    "code": "H93.3",
    "name": "Neuritis des Nervus acusticus",
    "synonyms": [
      "Affektion des Hörnerven",
      "Affektion des Nervus cochlearis",
      "Atrophie des Hirnnerven VIII",
      "Atrophie des Nervus acusticus",
      "Atrophie des Nervus vestibulocochlearis",
      "Degeneration des Nervus acusticus",
      "Hörnervenneuritis",
      "Lähmung des Nervus acusticus",
      "Neuralgie des Nervus acusticus",
      "Neuritis des Hirnnerven VIII",
      "Neuritis des Nervus acusticus",
      "Neuritis des Nervus statoacusticus",
      "Neuritis des Nervus vestibulocochlearis",
      "Neuropathia vestibulocochlearis",
      "Radikulitis des Nervus acusticus",
      "Schädigung des Nervus acusticus",
      "Schädigung des Nervus vestibulocochlearis",
      "Störung des Hirnnerven VIII",
      "Störung des Hörnerven",
      "Störung des Nervus acusticus",
      "Störung des Nervus statoacusticus",
      "Störung des Nervus vestibulocochlearis",
      "Wurzelneuritis des Nervus acusticus"
    ]
  },
  {
    "code": "H93.8",
    "name": "Ohrkatarrh",
    "synonyms": [
      "Ohratrophie",
      "Ohrkatarrh"
    ]
  },
  {
    "code": "H93.9",
    "name": "Ohrreizung",
    "synonyms": [
      "Komplikation des Ohres",
      "Ohraffektion",
      "Ohrkrankheit",
      "Ohrproblem",
      "Ohrreizung"
    ]
  },
  {
    "code": "H95.0",
    "name": "Rezidivierendes Cholesteatom der Mastoidhöhle nach Mastoidektomie",
    "synonyms": [
      "Granulom nach Mastoidektomie",
      "Rezidivierendes Cholesteatom der Mastoidhöhle nach Mastoidektomie"
    ]
  },
  {
    "code": "H95.1",
    "name": "Mastoiditis nach Mastoidektomie",
    "synonyms": [
      "Chronische Entzündung der Mastoidhöhle nach Mastoidektomie",
      "Entzündung nach Mastoidektomie",
      "Granulation nach Mastoidektomie",
      "Granulationsgewebe der Mastoidhöhle nach Mastoidektomie",
      "Komplikation der Mastoidhöhle nach Mastoidektomie a.n.k.",
      "Mastoiditis nach Mastoidektomie",
      "Postmastoidektomie-Komplikation a.n.k.",
      "Schleimhautzyste in der Mastoidhöhle nach Mastoidektomie",
      "Zyste der Mastoidhöhle nach Mastoidektomie",
      "Zyste nach Mastoidektomie"
    ]
  },
  {
    "code": "H95.8",
    "name": "Operationsbedingter akuter sensorineuraler Hörverlust",
    "synonyms": [
      "Operationsbedingter akuter sensorineuraler Hörverlust"
    ]
  },
  {
    "code": "H95.9",
    "name": "Komplikation des Processus mastoideus nach medizinischen Maßnahmen",
    "synonyms": [
      "Komplikation des Ohres nach chirurgischem Eingriff",
      "Komplikation des Ohres nach medizinischen Maßnahmen",
      "Komplikation des Processus mastoideus nach medizinischen Maßnahmen",
      "Krankheit des Mastoids nach chirurgischem Eingriff",
      "Postoperative Ohrenstörung"
    ]
  },
  {
    "code": "I00",
    "name": "Rheumatisches Fieber",
    "synonyms": [
      "Akute Arthritis bei rheumatischem Fieber",
      "Akute rheumatische Arthritis",
      "Akute rheumatische Polyarthritis",
      "Akutes rheumatisches Fieber",
      "Rheumatisches Fieber",
      "Rheumatisches Fieber ohne Angabe einer Herzbeteiligung",
      "Subakute Arthritis bei rheumatischem Fieber",
      "Subakute rheumatische Arthritis",
      "Subakute rheumatische Polyarthritis",
      "Subakutes rheumatisches Fieber"
    ]
  },
  {
    "code": "I01.0",
    "name": "Rheumatische Perikarditis",
    "synonyms": [
      "Aktive Perikarditis mit rheumatischem Fieber",
      "Akute rheumatische Arthritis mit Perikarditis",
      "Akute rheumatische Perikarditis",
      "Rheumatische Perikarditis",
      "Rheumatisches Fieber mit Perikarditis",
      "Subakute rheumatische Arthritis mit Perikarditis"
    ]
  },
  {
    "code": "I01.1",
    "name": "Rheumatische Aortitis",
    "synonyms": [
      "Aktive Mitralklappenendokarditis",
      "Aktive Trikuspidalklappenendokarditis",
      "Aktive rheumatische Aortenklappenendokarditis",
      "Aktive rheumatische Aortenklappenendokarditis mit Mitralklappenkrankheit",
      "Aktive rheumatische Pulmonalklappenendokarditis",
      "Akute Mitralklappenendokarditis",
      "Akute Mitralstenose",
      "Akute Trikuspidalklappenendokarditis",
      "Akute rheumatische Aortenklappenendokarditis",
      "Akute rheumatische Aortenklappenendokarditis mit Mitralklappenkrankheit",
      "Akute rheumatische Arthritis mit Endokarditis",
      "Akute rheumatische Arthritis mit Valvulitis",
      "Akute rheumatische Endokarditis",
      "Akute rheumatische Herzklappenentzündung",
      "Akute rheumatische Pulmonalklappenendokarditis",
      "Akute rheumatische Valvulitis",
      "Rheumatische Aortitis",
      "Rheumatisches Fieber mit Endokarditis",
      "Subakute rheumatische Arthritis mit Endokarditis",
      "Subakute rheumatische Arthritis mit Valvulitis",
      "Subakute rheumatische Pulmonalklappenendokarditis"
    ]
  },
  {
    "code": "I01.2",
    "name": "Akute rheumatische Myokarditis",
    "synonyms": [
      "Aktive rheumatische myokardiale Insuffizienz",
      "Akute rheumatische Arthritis mit Myokarditis",
      "Akute rheumatische Myokarditis",
      "Akute rheumatische myokardiale Insuffizienz",
      "Akutes rheumatisches Fieber mit Myokarditis",
      "Subakute rheumatische Arthritis mit Myokarditis",
      "Subakute rheumatische Myokarditis",
      "Subakute rheumatische myokardiale Insuffizienz",
      "Toxische rheumatische Myokarditis"
    ]
  },
  {
    "code": "I01.8",
    "name": "Akute rheumatische Pankarditis",
    "synonyms": [
      "Aktive Linksherzinsuffizienz bei rheumatischem Fieber",
      "Aktive rheumatische Herzhypertrophie",
      "Aktive rheumatische Linksherzinsuffizienz",
      "Akute rheumatische Arthritis mit mehrfacher Herzbeteiligung",
      "Akute rheumatische Herzhypertrophie",
      "Akute rheumatische Linksherzinsuffizienz",
      "Akute rheumatische Pankarditis",
      "Akute rheumatische koronare Arteriitis",
      "Bouillaud-Krankheit",
      "Bouillaud-Syndrom",
      "Subakute rheumatische Arthritis mit mehrfacher Herzbeteiligung"
    ]
  },
  {
    "code": "I01.9",
    "name": "Akuter Gelenkrheumatismus mit Herzbeteiligung",
    "synonyms": [
      "Aktive rheumatische Herzkrankheit",
      "Akute rheumatische Arthritis mit Herzbeteiligung",
      "Akute rheumatische Herzkrankheit",
      "Akute rheumatische Karditis",
      "Akuter Gelenkrheumatismus mit Herzbeteiligung",
      "Rheumatisches Fieber mit Herzbeteiligung",
      "Subakute rheumatische Arthritis mit Herzbeteiligung"
    ]
  },
  {
    "code": "I02.0",
    "name": "Veitstanz mit Herzbeteiligung",
    "synonyms": [
      "Aktive Aortenklappenendokarditis mit Mitralklappenkrankheit mit Chorea",
      "Aktive Mitralklappenendokarditis mit Aortenklappenkrankheit mit Chorea",
      "Aktive Mitralklappenendokarditis mit Chorea",
      "Aktive Trikuspidalklappenendokarditis mit Chorea",
      "Aktive rheumatische Aortenklappenendokarditis mit Chorea",
      "Aktive rheumatische Aortenklappenendokarditis mit Mitralklappenkrankheit mit Chorea",
      "Aktive rheumatische Endokarditis mit Chorea",
      "Aktive rheumatische Linksherzinsuffizienz mit Chorea",
      "Aktive rheumatische Mitralklappeninsuffizienz mit Chorea",
      "Aktive rheumatische Myokarditis mit Chorea",
      "Akute Aortenklappenendokarditis mit Mitralklappenkrankheit mit Chorea",
      "Akute Mitralklappenendokarditis mit Aortenklappenkrankheit mit Chorea",
      "Akute Mitralklappenendokarditis mit Chorea",
      "Akute Perikarditis mit Chorea",
      "Akute Trikuspidalklappenendokarditis mit Chorea",
      "Akute rheumatische Aortenklappenendokarditis mit Chorea",
      "Akute rheumatische Aortenklappenendokarditis mit Mitralklappenkrankheit mit Chorea",
      "Akute rheumatische Endokarditis mit Chorea",
      "Akute rheumatische Linksherzinsuffizienz mit Chorea",
      "Akute rheumatische Mitralklappeninsuffizienz mit Chorea",
      "Akute rheumatische Pulmonalklappenendokarditis mit Chorea",
      "Chorea Sydenham mit Herzbeteiligung",
      "Chorea minor mit Herzbeteiligung",
      "Chorea mit Herzbeteiligung",
      "Rheumatische Chorea mit Endokarditis",
      "Rheumatische Chorea mit Herzbeteiligung",
      "Rheumatische Chorea mit Myokarditis",
      "Rheumatische Chorea mit Perikarditis",
      "Rheumatische Chorea mit Valvulitis",
      "Rheumatische Chorea mit mehrfacher Herzbeteiligung",
      "Subakute rheumatische Endokarditis mit Chorea",
      "Subakute rheumatische Pulmonalklappenendokarditis mit Chorea",
      "Sydenham-Syndrom mit Herzbeteiligung",
      "Veitstanz mit Herzbeteiligung"
    ]
  },
  {
    "code": "I02.9",
    "name": "Chorea minor",
    "synonyms": [
      "Chorea Sydenham",
      "Chorea infectiosa",
      "Chorea juvenilis",
      "Chorea minor",
      "Chorea simplex",
      "Rheumatische Chorea",
      "Rheumatische Chorea ohne Herzbeteiligung",
      "Rheumatisches Fieber mit Beteiligung des Zentralnervensystems",
      "Sydenham-Krankheit",
      "Sydenham-Syndrom"
    ]
  },
  {
    "code": "I05.0",
    "name": "Mitralstenose",
    "synonyms": [
      "Mitralklappenobstruktion",
      "Mitralklappenstenose",
      "Mitralklappenstriktur",
      "Mitralstenose",
      "Rheumatische Mitralklappenobstruktion"
    ]
  },
  {
    "code": "I05.1",
    "name": "Rheumatische Mitralklappeninsuffizienz",
    "synonyms": [
      "Rheumatische Mitralklappeninsuffizienz"
    ]
  },
  {
    "code": "I05.2",
    "name": "Kombiniertes Mitralvitium",
    "synonyms": [
      "Kombiniertes Mitralklappenvitium",
      "Kombiniertes Mitralvitium",
      "Mitralklappenobstruktion mit Insuffizienz",
      "Mitralklappenstenose mit Insuffizienz",
      "Mitralstenose mit Insuffizienz",
      "Mitralstenose mit Mitralinsuffizienz",
      "Mitralstenose mit Regurgitation",
      "Rheumatische Mitralklappeninsuffizienz mit Obstruktion",
      "Rheumatische Mitralklappeninsuffizienz mit Stenose"
    ]
  },
  {
    "code": "I05.8",
    "name": "Mitralklappenfehler",
    "synonyms": [
      "Chronischer rheumatischer Mitralklappenfehler",
      "Chronisches rheumatisches Mitralklappenvitium",
      "Mitralfehler",
      "Mitralklappendeformität",
      "Mitralklappenfehler",
      "Mitralklappensklerose",
      "Mitralklappenvitium",
      "Mitralvitium",
      "Rheumatische Mitralklappensklerose"
    ]
  },
  {
    "code": "I05.9",
    "name": "Mitralklappenkrankheit",
    "synonyms": [
      "Chronische Mitralklappenkrankheit",
      "Chronische rheumatische Mitralklappenentzündung",
      "Mitralklappenendokarditis",
      "Mitralklappenendokarditis mit inaktivem rheumatischem Fieber",
      "Mitralklappenendokarditis mit ruhendem rheumatischem Fieber",
      "Mitralklappenentzündung",
      "Mitralklappenkrankheit",
      "Mitralklappenschaden",
      "Rheumatische Mitralklappenkrankheit"
    ]
  },
  {
    "code": "I06.0",
    "name": "Rheumatische Aortenklappenstenose",
    "synonyms": [
      "Rheumatische Aortenklappenobstruktion",
      "Rheumatische Aortenklappenstenose",
      "Rheumatische Aortenstenose"
    ]
  },
  {
    "code": "I06.1",
    "name": "Rheumatische Aortenklappeninsuffizienz",
    "synonyms": [
      "Rheumatische Aorteninsuffizienz",
      "Rheumatische Aortenklappeninsuffizienz"
    ]
  },
  {
    "code": "I06.2",
    "name": "Rheumatische Aortenstenose mit Regurgitation",
    "synonyms": [
      "Rheumatische Aortenklappenstenose mit Insuffizienz",
      "Rheumatische Aortenklappenstenose mit Regurgitation",
      "Rheumatische Aortenklappenstenose mit Schlussunfähigkeit",
      "Rheumatische Aortenstenose mit Insuffizienz",
      "Rheumatische Aortenstenose mit Regurgitation"
    ]
  },
  {
    "code": "I06.8",
    "name": "Chronisches rheumatisches Aortenklappenvitium",
    "synonyms": [
      "Chronischer rheumatischer Aortenklappenfehler",
      "Chronisches rheumatisches Aortenklappenvitium",
      "Rheumatisches Vitium cordis der Aortenklappe",
      "Rheumatischs Aortenklappensklerose"
    ]
  },
  {
    "code": "I06.9",
    "name": "Rheumatische Aortenklappenendokarditis",
    "synonyms": [
      "Aortenklappenendokarditis mit inaktivem rheumatischem Fieber",
      "Aortenklappenendokarditis mit ruhendem rheumatischem Fieber",
      "Chronische rheumatische Aortenklappenentzündung",
      "Rheumatische Aortenklappenendokarditis",
      "Rheumatische Aortenklappenkrankheit"
    ]
  },
  {
    "code": "I07.0",
    "name": "Trikuspidalklappenstenose",
    "synonyms": [
      "Rheumatische Trikuspidalklappenstenose",
      "Trikuspidalklappenstenose",
      "Trikuspidalklappenstriktur"
    ]
  },
  {
    "code": "I07.1",
    "name": "Trikuspidalinsuffizienz",
    "synonyms": [
      "Rheumatische Trikuspidalklappeninsuffizienz",
      "Trikuspidalinsuffizienz",
      "Trikuspidalklappeninsuffizienz",
      "Trikuspidalklappenregurgitation"
    ]
  },
  {
    "code": "I07.2",
    "name": "Trikuspidalklappenstenose mit Insuffizienz",
    "synonyms": [
      "Trikuspidalklappenobstruktion mit Insuffizienz",
      "Trikuspidalklappenstenose mit Insuffizienz",
      "Trikuspidalklappenstenose mit Regurgitation",
      "Trikuspidalklappenstenose mit Schlussunfähigkeit",
      "Trikuspidalstenose mit Insuffizienz"
    ]
  },
  {
    "code": "I07.8",
    "name": "Trikuspidalklappenvitium",
    "synonyms": [
      "Rheumatischer Trikuspidalklappenfehler",
      "Trikuspidalklappenaneurysma",
      "Trikuspidalklappendeformität",
      "Trikuspidalklappenendokarditis",
      "Trikuspidalklappenendokarditis mit inaktivem rheumatischem Fieber",
      "Trikuspidalklappenendokarditis mit ruhendem rheumatischem Fieber",
      "Trikuspidalklappenfehler",
      "Trikuspidalklappenruptur",
      "Trikuspidalklappensklerose",
      "Trikuspidalklappenthrombose",
      "Trikuspidalklappenvitium"
    ]
  },
  {
    "code": "I07.9",
    "name": "Trikuspidalklappenkrankheit",
    "synonyms": [
      "Rheumatische Trikuspidalklappenkrankheit",
      "Trikuspidalklappendegeneration",
      "Trikuspidalklappengeräusch",
      "Trikuspidalklappenkrankheit",
      "Trikuspidalklappenschädigung"
    ]
  },
  {
    "code": "I08.0",
    "name": "Aortenmitralvitium",
    "synonyms": [
      "Aorten- und Mitralklappenentzündung",
      "Aorten- und Mitralklappenfehler",
      "Aorten- und Mitralklappeninsuffizienz",
      "Aorten- und Mitralklappensklerose",
      "Aorten- und Mitralklappenstenose",
      "Aorten- und Mitralklappenvitium",
      "Aortenklappenendokarditis mit Mitralklappenkrankheit",
      "Aortenklappeninsuffizienz mit Mitralklappenkrankheit",
      "Aortenmitralvitium",
      "Chronische rheumatische Entzündung der Mitral- und Aortenklappe",
      "Chronische rheumatische Insuffizienz der Mitral- und Aortenklappe",
      "Chronische rheumatische Krankheit der Mitral- und Aortenklappe",
      "Chronische rheumatische Sklerose der Mitral- und Aortenklappe",
      "Chronische rheumatische Stenose der Mitral- und Aortenklappe",
      "Chronischer rheumatischer Fehler der Mitral- und Aortenklappe",
      "Chronisches rheumatisches Vitium der Mitral- und Aortenklappe",
      "Kombiniertes Mitral- und Aortenklappenvitium",
      "Mitral- und Aortenklappenvitium",
      "Mitralaortenvitium",
      "Mitralklappenendokarditis mit Aortenklappenkrankheit",
      "Mitralklappeninsuffizienz mit Aortenklappenkrankheit",
      "Mitralklappenstenose mit Aortenklappenkrankheit",
      "Rheumatische Aortenklappeninsuffizienz mit Mitralklappenkrankheit",
      "Rheumatische Aortenklappenstenose mit Mitralklappenkrankheit",
      "Rheumatische Mitralklappeninsuffizienz mit Aortenklappenkrankheit"
    ]
  },
  {
    "code": "I08.1",
    "name": "Kombinierte Krankheit der Mitral- und Trikuspidalklappe",
    "synonyms": [
      "Kombinierte Krankheit der Mitral- und Trikuspidalklappe",
      "Mitralklappenendokarditis mit Trikuspidalklappenkrankheit",
      "Mitralklappeninsuffizienz mit Trikuspidalklappenkrankheit",
      "Rheumatische Mitralklappeninsuffizienz mit Trikuspidalklappenkrankheit",
      "Trikuspidalklappenendokarditis mit Mitralklappenkrankheit",
      "Trikuspidalklappeninsuffizienz mit Mitralklappenkrankheit",
      "Trikuspidalklappenstenose mit Mitralklappenkrankheit"
    ]
  },
  {
    "code": "I08.2",
    "name": "Kombinierte Krankheit der Aorten- und Trikuspidalklappe",
    "synonyms": [
      "Aortenklappenendokarditis mit Trikuspidalklappenkrankheit",
      "Aortenklappeninsuffizienz mit Trikuspidalklappenkrankheit",
      "Kombinierte Krankheit der Aorten- und Trikuspidalklappe",
      "Rheumatische Aortenklappeninsuffizienz mit Trikuspidalklappenkrankheit",
      "Rheumatische Aortenklappenstenose mit Trikuspidalklappenkrankheit",
      "Trikuspidalklappenendokarditis mit Aortenklappenkrankheit",
      "Trikuspidalklappeninsuffizienz mit Aortenklappenkrankheit",
      "Trikuspidalklappenstenose mit Aortenklappenkrankheit",
      "Trikuspidalklappenstenose mit Insuffizienz und Aortenklappenkrankheit",
      "Trikuspidalklappenstenose mit Regurgitation und Aortenklappenkrankheit",
      "Trikuspidalklappenstenose mit Schlussunfähigkeit und Aortenklappenkrankheit"
    ]
  },
  {
    "code": "I08.3",
    "name": "Kombinierte Krankheit der Mitral-, Aorten- und Trikuspidalklappe",
    "synonyms": [
      "Aortenklappenendokarditis mit Mitralklappenkrankheit und Trikuspidalklappenkrankheit",
      "Aortenklappeninsuffizienz mit Mitralklappenkrankheit und Trikuspidalklappenkrankheit",
      "Kombinierte Krankheit der Mitral-, Aorten- und Trikuspidalklappe",
      "Mitralklappeninsuffizienz mit Aortenklappenkrankheit und Trikuspidalklappenkrankheit",
      "Rheumatische Aortenklappenendokarditis mit Mitralklappenkrankheit und Trikuspidalklappenkrankheit",
      "Rheumatische Aortenklappeninsuffizienz mit Mitralklappenkrankheit und Trikuspidalklappenkrankheit",
      "Rheumatische Aortenklappenstenose mit Mitralklappenkrankheit und Trikuspidalklappenkrankheit",
      "Trikuspidalklappeninsuffizienz mit Mitralklappenkrankheit und Aortenklappenkrankheit",
      "Trikuspidalklappenstenose mit Mitralklappenkrankheit und Aortenklappenkrankheit"
    ]
  },
  {
    "code": "I08.8",
    "name": "Rheumatische Pulmonalklappenstenose mit Aortenklappenkrankheit",
    "synonyms": [
      "Rheumatische Pulmonalklappenstenose mit Aortenklappenkrankheit",
      "Rheumatische Pulmonalklappenstenose mit Mitralklappenkrankheit",
      "Rheumatische Pulmonalklappenstenose mit Trikuspidalklappenkrankheit"
    ]
  },
  {
    "code": "I08.9",
    "name": "Vierklappenvitium",
    "synonyms": [
      "Endokarditis mehrerer Klappen",
      "Krankheit mehrerer Herzklappen",
      "Mehrklappenvitium",
      "Panvalvuläre Herzkrankheit",
      "Vierklappenkrankheit des Herzens",
      "Vierklappenvitium"
    ]
  },
  {
    "code": "I09.0",
    "name": "Rheumatische Myokarditis",
    "synonyms": [
      "Aschoff-Geipel-Knötchen",
      "Inaktives rheumatisches Fieber mit Myodegeneratio cordis",
      "Inaktives rheumatisches Fieber mit Myokarditis",
      "Myodegeneratio cordis mit rheumatischem Fieber",
      "Myokarddegeneration mit rheumatischem Fieber",
      "Myokarditis mit rheumatischem Fieber",
      "Rheumatische Kardiomyopathie",
      "Rheumatische Myokarditis",
      "Ruhendes rheumatisches Fieber mit Myodegeneratio cordis",
      "Ruhendes rheumatisches Fieber mit Myokarditis"
    ]
  },
  {
    "code": "I09.1",
    "name": "Chronische rheumatische Herzklappenstenose",
    "synonyms": [
      "Chronische rheumatische Endokarditis",
      "Chronische rheumatische Herzklappenentzündung",
      "Chronische rheumatische Herzklappeninsuffizienz",
      "Chronische rheumatische Herzklappenstenose",
      "Chronische rheumatische Valvulitis",
      "Chronische rheumatische Valvulitis mit Chorea",
      "Inaktives rheumatisches Fieber mit Endokarditis",
      "Rheumatische Endokarditis",
      "Rheumatische Endokardkrankheit",
      "Rheumatische Herzklappendegeneration",
      "Rheumatische Herzklappeninsuffizienz",
      "Rheumatische Herzklappenstenose",
      "Rheumatische Valvulitis",
      "Rheumatischer Herzfehler",
      "Rheumatischer Herzklappenfehler",
      "Rheumatisches Herzklappenaneurysma",
      "Ruhendes rheumatisches Fieber mit Endokarditis"
    ]
  },
  {
    "code": "I09.2",
    "name": "Rheumatischer Perikarderguss",
    "synonyms": [
      "Chronische rheumatische Herzbeutelkrankheit",
      "Chronische rheumatische Herzbeutelverklebung",
      "Chronische rheumatische Herzbeutelverwachsung",
      "Chronische rheumatische Mediastinoperikarditis",
      "Chronische rheumatische Myoperikarditis",
      "Chronische rheumatische Perikarditis",
      "Idiopathische rekurrente Perikarditis",
      "Inaktives rheumatisches Fieber mit Perikarditis",
      "Rheumatische Herzadhäsion",
      "Rheumatische Perikardadhäsion",
      "Rheumatische Perikardverwachsung",
      "Rheumatische adhäsive Perikarditis",
      "Rheumatischer Perikarderguss",
      "Ruhendes rheumatisches Fieber mit Perikarditis"
    ]
  },
  {
    "code": "I09.8",
    "name": "Rheumatische Pulmonalklappenstenose",
    "synonyms": [
      "Chronische rheumatische koronare Arteriitis",
      "Inaktives rheumatisches Fieber mit Herzhypertrophie",
      "Inaktives rheumatisches Fieber mit Herzinsuffizienz",
      "Inaktives rheumatisches Fieber mit Herzkrankheit a.n.k.",
      "Inaktives rheumatisches Fieber mit Linksherzinsuffizienz",
      "Inaktives rheumatisches Fieber mit Pulmonalklappenendokarditis",
      "Rheumatische Herzhypertrophie",
      "Rheumatische Linksherzinsuffizienz",
      "Rheumatische Pankarditis",
      "Rheumatische Pulmonalklappenendokarditis",
      "Rheumatische Pulmonalklappeninsuffizienz",
      "Rheumatische Pulmonalklappenkrankheit",
      "Rheumatische Pulmonalklappenstenose",
      "Rheumatische valvuläre Pulmonalstenose",
      "Rheumatischer Pulmonalklappenfehler",
      "Rheumatisches Pulmonalklappenvitium",
      "Ruhendes rheumatisches Fieber mit Herzhypertrophie",
      "Ruhendes rheumatisches Fieber mit Herzinsuffizienz",
      "Ruhendes rheumatisches Fieber mit Herzkrankheit a.n.k.",
      "Ruhendes rheumatisches Fieber mit Linksherzinsuffizienz",
      "Ruhendes rheumatisches Fieber mit Pulmonalklappenendokarditis"
    ]
  },
  {
    "code": "I09.9",
    "name": "Chronische rheumatische Herzmuskelkrankheit",
    "synonyms": [
      "Chronische rheumatische Herzkrankheit",
      "Chronische rheumatische Herzmuskelkrankheit",
      "Chronische rheumatische Karditis",
      "Herzinsuffizienz mit rheumatischem Fieber",
      "Herzrheumatismus",
      "Inaktive rheumatische Karditis",
      "Inaktives rheumatisches Fieber mit Karditis",
      "Inaktives rheumatisches Fieber mit Pankarditis",
      "Rheumaherz",
      "Rheumatische Herzerkrankung",
      "Rheumatische Herzinsuffizienz",
      "Rheumatische Karditis",
      "Rheumatisches Herzversagen",
      "Ruhendes rheumatisches Fieber mit Karditis",
      "Ruhendes rheumatisches Fieber mit Pankarditis"
    ]
  },
  {
    "code": "I10.00",
    "name": "Benigne Hypertonie",
    "synonyms": [
      "Benigne Hypertonie"
    ]
  },
  {
    "code": "I10.01",
    "name": "Benigne essentielle Hypertonie mit hypertensiver Krise",
    "synonyms": [
      "Benigne essentielle Hypertonie mit hypertensiver Krise"
    ]
  },
  {
    "code": "I10.10",
    "name": "Maligne Hypertonie",
    "synonyms": [
      "Maligne Hypertonie"
    ]
  },
  {
    "code": "I10.11",
    "name": "Maligne Hypertonie mit hypertensiver Krise",
    "synonyms": [
      "Maligne Hypertonie mit hypertensiver Krise"
    ]
  },
  {
    "code": "I10.90",
    "name": "Hypertonie",
    "synonyms": [
      "Akzelerierte Hypertonie",
      "Arterielle Hypertonie",
      "Arterielle essentielle Hypertonie",
      "Arterieller Hochdruck",
      "Behandlungsrefraktäre Hypertonie",
      "Belastungshypertonie",
      "Bluthochdruck",
      "Borderline-Hypertonie",
      "Essentielle Hypertension",
      "Essentielle Hypertonie",
      "Essentieller Hypertonus",
      "Hochdruck",
      "Hoher Blutdruck",
      "Hypertension",
      "Hypertensive Krankheit",
      "Hypertonie",
      "Hypertonie 1. Grades",
      "Hypertonie 2. Grades",
      "Hypertonie 3. Grades",
      "Hypertonie mit Zyanose",
      "Hypertonie-Manifestation",
      "Hypertonus",
      "Idiopathische Hypertonie",
      "Instabile Hypertonie",
      "Juvenile Hypertonie",
      "Labile Hypertonie",
      "Latente Hypertonie",
      "Leichte Hypertonie",
      "Primäre essentielle Hypertonie",
      "Primärer essentieller Hochdruck",
      "Primärer essentieller hoher Blutdruck",
      "Schwer einstellbarer Bluthochdruck",
      "Systemische Hypertonie",
      "Vegetative Hypertonie"
    ]
  },
  {
    "code": "I10.91",
    "name": "Hypertensive Krise",
    "synonyms": [
      "Blutdruckkrise",
      "Hypertensive Krise",
      "Hypertensiver Notfall",
      "Hypertone Krise"
    ]
  },
  {
    "code": "I11.00",
    "name": "Herzdekompensation bei Hypertonie",
    "synonyms": [
      "Herzdekompensation bei Hypertonie",
      "Herzinsuffizienz bei Hypertonie",
      "Hypertensive Herzinsuffizienz durch Stauung",
      "Hypertensive Herzkrankheit mit Herzinsuffizienz",
      "Hypertensive Linksherzinsuffizienz",
      "Hypertensives Herzversagen",
      "Hypertensives Linksherzversagen"
    ]
  },
  {
    "code": "I11.01",
    "name": "Hypertensive Herzkrankheit mit Herzinsuffizienz mit hypertensiver Krise",
    "synonyms": [
      "Hypertensive Herzkrankheit mit Herzinsuffizienz mit hypertensiver Krise"
    ]
  },
  {
    "code": "I11.90",
    "name": "Kardiovaskuläre Hypertonie",
    "synonyms": [
      "Benigne Hypertonie bei Herzkrankheit",
      "Benigne hypertensive Herzkrankheit",
      "Bluthochdruck mit Herzbeteiligung",
      "Cor hypertonicum",
      "HHK [Hypertensive Herzkrankheit]",
      "Hochdruck mit Herzbeteiligung",
      "Hochdruck mit Herzkrankheit",
      "Hypertensive Herzhypertrophie",
      "Hypertensive Herzkrankheit",
      "Hypertensive Kardiomyopathie",
      "Hypertensive Myokarddegeneration",
      "Hypertone Herzkrankheit",
      "Hypertonie mit Altersherz",
      "Hypertonie mit Herzbeteiligung",
      "Hypertonieherz",
      "Kardiovaskuläre Hypertonie",
      "Maligne Hypertonie mit Herzbeteiligung",
      "Maligne hypertensive Herzkrankheit"
    ]
  },
  {
    "code": "I11.91",
    "name": "Hypertensive Herzkrankheit ohne Herzinsuffizienz mit hypertensiver Krise",
    "synonyms": [
      "Hypertensive Herzkrankheit ohne Herzinsuffizienz mit hypertensiver Krise"
    ]
  },
  {
    "code": "I12.00",
    "name": "Hypertonie mit Niereninsuffizienz",
    "synonyms": [
      "Arteriosklerotische Nephritis mit Niereninsuffizienz",
      "Arteriosklerotische Niereninsuffizienz",
      "Chronische arteriosklerotische Nephritis mit Niereninsuffizienz",
      "Fahr-Volhard-Krankheit mit Niereninsuffizienz",
      "Hypertensive Niereninsuffizienz",
      "Hypertensive Nierenkrankheit mit Niereninsuffizienz",
      "Hypertensives Nierenversagen",
      "Hypertonie bei Schrumpfniere mit Niereninsuffizienz",
      "Hypertonie mit Niereninsuffizienz",
      "Hypertonische Urämie",
      "Hypertonisches terminales Nierenversagen",
      "Interstitielle arteriosklerotische Nephritis mit Niereninsuffizienz",
      "Nephroangiosklerose mit Niereninsuffizienz",
      "Nephrosklerose mit Niereninsuffizienz",
      "Nierenarteriosklerose mit Niereninsuffizienz",
      "Nierenversagen bei Hypertonie",
      "Renale Hypertonie mit Niereninsuffizienz"
    ]
  },
  {
    "code": "I12.01",
    "name": "Hypertensive Nierenkrankheit mit Niereninsuffizienz mit hypertensiver Krise",
    "synonyms": [
      "Hypertensive Nierenkrankheit mit Niereninsuffizienz mit hypertensiver Krise"
    ]
  },
  {
    "code": "I12.90",
    "name": "Hypertonie mit Nierenbeteiligung",
    "synonyms": [
      "Arterioläre Nephritis",
      "Arterioläre Nephrosklerose",
      "Arterioläre hyaline Schrumpfniere",
      "Arterioläre hyperplastische Schrumpfniere",
      "Arteriosklerose der Niere",
      "Arteriosklerotische Bright-Krankheit",
      "Arteriosklerotische Nephritis",
      "Arteriosklerotische Nephrosklerose",
      "Arteriosklerotische Schrumpfniere",
      "Benigne Nephrosklerose",
      "Bösartige Nephrosklerose",
      "Chronische Nephrosklerose",
      "Chronische arteriosklerotische Nephritis",
      "Fahr-Volhard-Krankheit",
      "Gutartige Nephrosklerose",
      "Hyaline Nephrosklerose",
      "Hypertensive Nephropathie",
      "Hypertensive Nephrosklerose",
      "Hypertensive Nierenkrankheit",
      "Hypertensive Nierenkrankheit ohne Niereninsuffizienz",
      "Hypertonie mit Nierenbeteiligung",
      "Hypertonie mit Schrumpfniere",
      "Hypertonie mit diffusen sklerosierenden glomerulonephritischen Läsionen",
      "Interstitielle arteriosklerotische Nephritis",
      "Maligne Nephrosklerose",
      "Maligne Nierenhypertonie",
      "Maligne primäre Nephrosklerose",
      "Nephroangiosklerose",
      "Nephrosklerose",
      "Renale Arteriosklerose",
      "Renale Sklerose",
      "Renale vaskuläre Insuffizienz",
      "Schrumpfniere mit Hypertonie",
      "Vaskuläre Schrumpfniere"
    ]
  },
  {
    "code": "I12.91",
    "name": "Hypertensive Nierenkrankheit ohne Niereninsuffizienz mit hypertensiver Krise",
    "synonyms": [
      "Hypertensive Nierenkrankheit ohne Niereninsuffizienz mit hypertensiver Krise"
    ]
  },
  {
    "code": "I13.00",
    "name": "Hypertensive Herz- und Nierenkrankheit mit Herzinsuffizienz",
    "synonyms": [
      "Hypertensive Herz- und Nierenkrankheit mit Herzinsuffizienz",
      "Hypertensive Herzinsuffizienz mit Nierenkrankheit",
      "Hypertensive Stauungsinsuffizienz des Herzens mit Nierenkrankheit",
      "Renale Hypertonie mit Herzinsuffizienz"
    ]
  },
  {
    "code": "I13.01",
    "name": "Hypertensive Herz- und Nierenkrankheit mit Herzinsuffizienz mit hypertensiver Krise",
    "synonyms": [
      "Hypertensive Herz- und Nierenkrankheit mit Herzinsuffizienz mit hypertensiver Krise"
    ]
  },
  {
    "code": "I13.10",
    "name": "Hypertensive Herz- und Nierenkrankheit mit Niereninsuffizienz",
    "synonyms": [
      "Hypertensive Herz- und Nierenkrankheit mit Niereninsuffizienz",
      "Kardiorenale Hypertonie mit Niereninsuffizienz",
      "Nierenversagen bei hypertonischer Herzkrankheit",
      "Renale kardiovaskuläre Hypertonie mit Niereninsuffizienz"
    ]
  },
  {
    "code": "I13.11",
    "name": "Hypertensive Herz- und Nierenkrankheit mit Niereninsuffizienz mit hypertensiver Krise",
    "synonyms": [
      "Hypertensive Herz- und Nierenkrankheit mit Niereninsuffizienz mit hypertensiver Krise"
    ]
  },
  {
    "code": "I13.20",
    "name": "Hypertensive Herz- und Nierenkrankheit mit Herz- und Niereninsuffizienz",
    "synonyms": [
      "Hypertensive Herz- und Nierenkrankheit mit Herz- und Niereninsuffizienz",
      "Hypertensive Herzinsuffizienz mit Niereninsuffizienz",
      "Hypertensive kardiorenale Insuffizienz",
      "Kardiorenale Dekompensation",
      "Kardiorenale Hypertonie mit Herz- und Niereninsuffizienz",
      "Kardiorenale Komplikation",
      "Kardiorenaler Kollaps",
      "Kardiorenales Versagen mit Hypertonie",
      "Kardiovaskuläre Hypertonie mit Herz- und Niereninsuffizienz",
      "Renale Hypertonie mit Herz- und Niereninsuffizienz",
      "Renale kardiovaskuläre Insuffizienz"
    ]
  },
  {
    "code": "I13.21",
    "name": "Hypertensive Krise bei hypertensiver Herz- und Nierenkrankheit mit Herzinsuffizienz und Niereninsuffizienz",
    "synonyms": [
      "Hypertensive Krise bei hypertensiver Herz- und Nierenkrankheit mit Herzinsuffizienz und Niereninsuffizienz"
    ]
  },
  {
    "code": "I13.90",
    "name": "Maligne kardiorenale Hypertonie",
    "synonyms": [
      "Benigne kardiorenale Hypertonie",
      "Hypertensive Herz- und Nierenkrankheit",
      "Hypertensive kardiorenale Krankheit",
      "Hypertonie mit Nephrosklerose und Herzbeteiligung",
      "Hypertonie mit kardiorenaler Degeneration",
      "Hypertonie mit renaler kardiovaskulärer Degeneration",
      "Kardiorenale Arteriosklerose",
      "Kardiorenale Hypertonie",
      "Kardiorenale Sklerose",
      "Kardiorenales Syndrom",
      "Maligne kardiorenale Hypertonie",
      "Nephrosklerose mit Herzbeteiligung",
      "Renale kardiovaskuläre Hypertonie",
      "Renale kardiovaskuläre Krankheit",
      "Renale kardiovaskuläre Sklerose",
      "Schrumpfniere mit hypertensiver Herzkrankheit",
      "Vaskulärer kardiorenaler Schaden"
    ]
  },
  {
    "code": "I15.00",
    "name": "Renovaskuläre Hypertonie",
    "synonyms": [
      "Hypertonie durch arterielle renale Störung",
      "Renovaskuläre Hypertonie",
      "Sekundäre Hypertonie durch renovaskuläre Störung"
    ]
  },
  {
    "code": "I15.01",
    "name": "Renovaskuläre Hypertonie mit hypertensiver Krise",
    "synonyms": [
      "Renovaskuläre Hypertonie mit hypertensiver Krise"
    ]
  },
  {
    "code": "I15.10",
    "name": "Renoparenchymatöser Hochdruck",
    "synonyms": [
      "Apparenter Mineralocorticoid-Exzess",
      "Autosomal-dominante progressive Nephropathie mit Hypertonie",
      "Benigne renale Hypertonie",
      "Hypertonie durch renale Störungen a.n.k.",
      "Liddle-Syndrom",
      "Maligne renale Hypertonie",
      "Nephrogene Hypertonie",
      "Page-Niere mit Hypertonie",
      "Pseudoaldosteronismus",
      "Pseudohyperaldosteronismus Typ 1",
      "Pseudohyperaldosteronismus Typ 2",
      "Pseudohypoaldosteronismus Typ 2",
      "Pseudohypoaldosteronismus Typ 2A",
      "Pseudohypoaldosteronismus Typ 2B",
      "Pseudohypoaldosteronismus Typ 2C",
      "Pseudohypoaldosteronismus Typ 2D",
      "Pseudohypoaldosteronismus Typ 2E",
      "Renale Hypertonie",
      "Renoparenchymatöse Hypertonie",
      "Renoparenchymatöser Hochdruck"
    ]
  },
  {
    "code": "I15.11",
    "name": "Apparenter Mineralocorticoid-Exzess mit hypertensiver Krise",
    "synonyms": [
      "Apparenter Mineralocorticoid-Exzess mit hypertensiver Krise",
      "Autosomal-dominante progressive Nephropathie mit Hypertonie mit hypertensiver Krise",
      "Pseudoaldosteronismus mit hypertensiver Krise",
      "Pseudohyperaldosteronismus Typ 1 mit hypertensiver Krise",
      "Pseudohyperaldosteronismus Typ 2 mit hypertensiver Krise",
      "Pseudohypoaldosteronismus Typ 2 mit hypertensiver Krise",
      "Pseudohypoaldosteronismus Typ 2A mit hypertensiver Krise",
      "Pseudohypoaldosteronismus Typ 2B mit hypertensiver Krise",
      "Pseudohypoaldosteronismus Typ 2C mit hypertensiver Krise",
      "Pseudohypoaldosteronismus Typ 2D mit hypertensiver Krise",
      "Pseudohypoaldosteronismus Typ 2E mit hypertensiver Krise"
    ]
  },
  {
    "code": "I15.20",
    "name": "Hypertonie durch endokrine Krankheit",
    "synonyms": [
      "Hypertonie durch Phäochromozytom",
      "Hypertonie durch endokrine Krankheit",
      "Hypertonie durch endokrine Störung"
    ]
  },
  {
    "code": "I15.21",
    "name": "Hypertonie durch endokrine Krankheit mit hypertensiver Krise",
    "synonyms": [
      "Hypertonie durch endokrine Krankheit mit hypertensiver Krise"
    ]
  },
  {
    "code": "I15.90",
    "name": "Sekundäre Hypertonie",
    "synonyms": [
      "Sekundäre Hypertonie",
      "Sekundäre benigne Hypertonie",
      "Sekundäre maligne Hypertonie",
      "Sekundärer hoher Blutdruck"
    ]
  },
  {
    "code": "I20.0",
    "name": "Graybiel-Syndrom",
    "synonyms": [
      "Angina decubitus",
      "Angina pectoris bei Belastung erstmalig auftretend",
      "Angina pectoris de novo",
      "Angina pectoris mit abnehmender Belastungstoleranz",
      "Crescendoangina",
      "Drohender Herzinfarkt",
      "Drohender Myokardinfarkt",
      "Graybiel-Syndrom",
      "Instabile Angina pectoris",
      "Intermediäres Koronarsyndrom",
      "Präinfarktangina",
      "Präinfarktsyndrom",
      "Status anginosus"
    ]
  },
  {
    "code": "I20.1",
    "name": "Koronarspasmus",
    "synonyms": [
      "Angina pectoris mit nachgewiesenem Koronarspasmus",
      "Angina pectoris vasomotorica",
      "Angiospastische Angina pectoris",
      "Herzspasmus",
      "Kardialer Spasmus",
      "Koronararterienkrampf",
      "Koronararterienspasmus",
      "Koronarspasmus",
      "Prinzmetal-Angina",
      "Spasmusinduzierte Angina pectoris",
      "Variant-Angina-pectoris",
      "Vasospasmus der Koronararterien",
      "Vasospastische Angina"
    ]
  },
  {
    "code": "I20.8",
    "name": "Angina pectoris durch Belastung",
    "synonyms": [
      "Angina pectoris durch Belastung",
      "Angina pectoris nach Infarkt",
      "Arbeitsangina pectoris",
      "Belastungsangina",
      "Funktionelle Stenokardie",
      "Funktionelles Angina-pectoris-Syndrom",
      "Koronares Slow-Flow-Syndrom",
      "Ruheangina pectoris",
      "Stabile Angina pectoris",
      "Stenokardie"
    ]
  },
  {
    "code": "I20.9",
    "name": "Angina pectoris",
    "synonyms": [
      "AP - s.a. Angina pectoris",
      "Angina pectoris",
      "Angina-pectoris-Syndrom",
      "Anginöse Herzbeschwerden",
      "Herzangina",
      "Ischämischer Thoraxschmerz",
      "Kardiale Angina",
      "Pektangina",
      "Pektanginöse Herzbeschwerden",
      "Pektanginöse Schmerzen",
      "Pektanginöser Beschwerdenkomplex",
      "Sternalgie bei Angina pectoris"
    ]
  },
  {
    "code": "I21.0",
    "name": "Vorderwandinfarkt des Herzens",
    "synonyms": [
      "Akuter transmuraler Myokardinfarkt der Vorderwand",
      "Akuter transmuraler anteriorer Myokardinfarkt",
      "Akuter transmuraler anteroapikaler Myokardinfarkt",
      "Akuter transmuraler anterolateraler Myokardinfarkt",
      "Akuter transmuraler anteroseptaler Myokardinfarkt",
      "VWI [Vorderwandinfarkt]",
      "Vorderwandinfarkt des Herzens",
      "Vorderwandmyokardinfarkt"
    ]
  },
  {
    "code": "I21.1",
    "name": "Hinterwandinfarkt des Herzens",
    "synonyms": [
      "Akuter HWI [Hinterwandinfarkt] des Herzens",
      "Akuter Hinterwandinfarkt des Herzens",
      "Akuter Myokardinfarkt der Hinterwand",
      "Akuter transmuraler Myokardinfarkt der Hinterwand",
      "Akuter transmuraler diaphragmaler Myokardinfarkt",
      "Akuter transmuraler inferiorer Myokardinfarkt",
      "Akuter transmuraler inferolateraler Myokardinfarkt",
      "Akuter transmuraler inferoposteriorer Myokardinfarkt",
      "Hinterwandinfarkt des Herzens"
    ]
  },
  {
    "code": "I21.2",
    "name": "Akuter transmuraler hochlateraler Myokardinfarkt",
    "synonyms": [
      "Akuter transmuraler Myokardinfarkt der Seitenwand",
      "Akuter transmuraler apikolateraler Myokardinfarkt",
      "Akuter transmuraler basolateraler Myokardinfarkt",
      "Akuter transmuraler hochlateraler Myokardinfarkt",
      "Akuter transmuraler lateraler Myokardinfarkt",
      "Akuter transmuraler posteriorer Myokardinfarkt",
      "Akuter transmuraler posterobasaler Myokardinfarkt",
      "Akuter transmuraler posterolateraler Myokardinfarkt",
      "Akuter transmuraler posteroseptaler Myokardinfarkt",
      "Akuter transmuraler septaler Myokardinfarkt",
      "Seitenwandinfarkt des Herzens"
    ]
  },
  {
    "code": "I21.3",
    "name": "Akuter transmuraler Myokardinfarkt",
    "synonyms": [
      "Akuter transmuraler Myokardinfarkt",
      "Transmuraler Myokardinfarkt"
    ]
  },
  {
    "code": "I21.40",
    "name": "Akuter subendokardialer Myokardinfarkt, Typ-1-Infarkt",
    "synonyms": [
      "Akuter subendokardialer Myokardinfarkt, Typ-1-Infarkt",
      "NSTEMI [Nicht-ST-Hebungsinfarkt], Typ-1-Infarkt",
      "Nicht-ST-Hebungsinfarkt, Typ-1-Infarkt"
    ]
  },
  {
    "code": "I21.41",
    "name": "Akuter subendokardialer Myokardinfarkt, Typ-2-Infarkt",
    "synonyms": [
      "Akuter subendokardialer Myokardinfarkt, Typ-2-Infarkt"
    ]
  },
  {
    "code": "I21.48",
    "name": "Akuter nichttransmuraler Myokardinfarkt",
    "synonyms": [
      "Akute subendokardiale Nekrose",
      "Akuter nichttransmuraler Myokardinfarkt",
      "Akuter nichttraumatischer subendokardialer Infarkt",
      "Akuter subendokardialer Myokardinfarkt",
      "Infarkt der Myokardinnenschicht",
      "NSTEMI [Nicht-ST-Hebungsinfarkt]",
      "Nicht-ST-Hebungsinfarkt",
      "Nichttransmuraler Myokardinfarkt",
      "Non-Q-Wave-Myokardinfarkt"
    ]
  },
  {
    "code": "I21.9",
    "name": "Kardiorrhexis",
    "synonyms": [
      "AMI [Akuter Myokardinfarkt]",
      "Akuter Herzinfarkt",
      "Akuter Myokardinfarkt",
      "Akutes Herzwandaneurysma",
      "Apoplexia cordis der Kammer",
      "Apoplexia cordis des Vorhofs",
      "Apoplexie der Herzkammer",
      "Apoplexie des Herzens",
      "Apoplexie des Herzvorhofs",
      "Arterienruptur des Herzens",
      "Blutgefäßruptur des Herzens",
      "Endokardiale Thrombose",
      "Fettembolie des Herzens",
      "Herzbeutelruptur",
      "Herzembolie",
      "Herzinfarkt - s.a. Myokardinfarkt oder s.a. Herzmuskelinfarkt",
      "Herzmuskelinfarkt",
      "Herzmuskelnekrose",
      "Herzmuskelzellnekrose",
      "Herzruptur",
      "Herzventrikelinfarkt",
      "Intramurale Thrombose",
      "Kardiale Embolie",
      "Kardiale Ruptur",
      "Kardiale Thrombose",
      "Kardialer Infarkt",
      "Kardialer Insult",
      "Kardiorrhexis",
      "Kardiovaskulärer Insult",
      "Koronararterienembolie",
      "Koronararterieninfarkt",
      "Koronararterienruptur",
      "Koronararterienthromboembolie",
      "Koronararterienthrombose",
      "Koronararterienverschluss",
      "Koronare Thromboembolie",
      "Koronarembolie",
      "Koronargerinnsel",
      "Koronarinfarkt",
      "Koronarinsult",
      "Koronarthrombose",
      "Koronarvenenembolie",
      "Murale Thrombose",
      "Myokardialer Anfall",
      "Myokardinfarkt",
      "Myokardnekrose",
      "Myokardruptur",
      "Nekrose der Herzmuskelfasern",
      "Nekrose der Herzmuskelgruppen",
      "Parietale Thrombose der Koronararterien",
      "Rupturierte Koronararteriendissektion",
      "Rupturiertes koronares Aneurysma",
      "Vorhofruptur",
      "Wandständige Thrombose der Koronararterien"
    ]
  },
  {
    "code": "I22.0",
    "name": "Rezidivierender anteriorer Myokardinfarkt",
    "synonyms": [
      "Rezidivierender Myokardinfarkt der Vorderwand",
      "Rezidivierender anteriorer Myokardinfarkt",
      "Rezidivierender anteroapikaler Myokardinfarkt",
      "Rezidivierender anterolateraler Myokardinfarkt",
      "Rezidivierender anteroseptaler Myokardinfarkt"
    ]
  },
  {
    "code": "I22.1",
    "name": "Rezidivierender inferiorer Myokardinfarkt",
    "synonyms": [
      "Rezidivierender Myokardinfarkt der Hinterwand",
      "Rezidivierender diaphragmaler Myokardinfarkt",
      "Rezidivierender inferiorer Myokardinfarkt",
      "Rezidivierender inferolateraler Myokardinfarkt",
      "Rezidivierender inferoposteriorer Myokardinfarkt"
    ]
  },
  {
    "code": "I22.8",
    "name": "Rezidivierender hochlateraler Myokardinfarkt",
    "synonyms": [
      "Rezidivierender Myokardinfarkt der Seitenwand",
      "Rezidivierender apikolateraler Myokardinfarkt",
      "Rezidivierender basolateraler Myokardinfarkt",
      "Rezidivierender hochlateraler Myokardinfarkt",
      "Rezidivierender lateraler Myokardinfarkt",
      "Rezidivierender posteriorer Myokardinfarkt",
      "Rezidivierender posterobasaler Myokardinfarkt",
      "Rezidivierender posterolateraler Myokardinfarkt",
      "Rezidivierender posteroseptaler Myokardinfarkt",
      "Rezidivierender septaler Myokardinfarkt"
    ]
  },
  {
    "code": "I22.9",
    "name": "Reinfarkt",
    "synonyms": [
      "Akuter Rezidivinfarkt",
      "Myokardreinfarkt",
      "Reinfarkt",
      "Rezidivierender Myokardinfarkt",
      "Rezidivinfarkt - s.a. Infarkt, Myokard, rezidivierend"
    ]
  },
  {
    "code": "I23.0",
    "name": "Hämoperikard als akute Komplikation nach akutem Myokardinfarkt",
    "synonyms": [
      "Herzwandruptur mit Hämoperikard nach akutem Myokardinfarkt",
      "Hämoperikard als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.1",
    "name": "Vorhofseptumdefekt als akute Komplikation nach akutem Myokardinfarkt",
    "synonyms": [
      "Vorhofseptumdefekt als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.2",
    "name": "Ventrikelseptumdefekt als akute Komplikation nach akutem Myokardinfarkt",
    "synonyms": [
      "Ventrikelseptumdefekt als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.3",
    "name": "Herzwandruptur ohne Hämoperikard als akute Komplikation nach akutem Myokardinfarkt",
    "synonyms": [
      "Aneurysma der Herzwand als akute Komplikation nach akutem Myokardinfarkt",
      "Herzwandruptur ohne Hämoperikard als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.4",
    "name": "Ruptur der Chordae tendineae als akute Komplikation nach akutem Myokardinfarkt",
    "synonyms": [
      "Lazeration der Chordae tendineae nach akutem Myokardinfarkt",
      "Ruptur der Chordae tendineae als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.5",
    "name": "Papillarmuskelruptur als akute Komplikation nach akutem Myokardinfarkt",
    "synonyms": [
      "Papillarmuskelruptur als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.6",
    "name": "Herzthrombose nach akutem Myokardinfarkt",
    "synonyms": [
      "Herzohrthrombose als akute Komplikation nach akutem Myokardinfarkt",
      "Herzthrombose nach akutem Myokardinfarkt",
      "Thrombose der Herzkammer als akute Komplikation nach akutem Myokardinfarkt",
      "Vorhofthrombose als akute Komplikation nach akutem Myokardinfarkt"
    ]
  },
  {
    "code": "I23.8",
    "name": "Kardiale Komplikation nach akutem Myokardinfarkt a.n.k.",
    "synonyms": [
      "Kardiale Komplikation nach akutem Myokardinfarkt a.n.k."
    ]
  },
  {
    "code": "I24.0",
    "name": "Hinterwandischämie",
    "synonyms": [
      "Endokardiale Thrombose ohne nachfolgenden Myokardinfarkt",
      "Hinterwandischämie",
      "Kardiale Embolie ohne nachfolgenden Myokardinfarkt",
      "Kardiale Thrombose ohne nachfolgenden Myokardinfarkt",
      "Koronararterienembolie ohne nachfolgenden Myokardinfarkt",
      "Koronararterienthromboembolie ohne nachfolgenden Myokardinfarkt",
      "Koronararterienthrombose ohne nachfolgenden Myokardinfarkt",
      "Koronararterienverschluss ohne nachfolgenden Myokardinfarkt",
      "Koronarembolie ohne nachfolgenden Myokardinfarkt",
      "Koronarthromboembolie ohne nachfolgenden Myokardinfarkt",
      "Koronarvenenembolie ohne nachfolgenden Myokardinfarkt",
      "Koronarvenenthromboembolie ohne nachfolgenden Myokardinfarkt",
      "Koronarvenenverschluss ohne nachfolgenden Myokardinfarkt",
      "Koronarverschluss ohne nachfolgenden Myokardinfarkt",
      "Parietale Thrombose ohne nachfolgenden Myokardinfarkt"
    ]
  },
  {
    "code": "I24.1",
    "name": "Postmyokardinfarktsyndrom",
    "synonyms": [
      "Dressler-II-Syndrom",
      "Postmyokardinfarktsyndrom"
    ]
  },
  {
    "code": "I24.8",
    "name": "Koronarinsuffizienz",
    "synonyms": [
      "Akute Koronarinsuffizienz",
      "Koronararterieninsuffizienz",
      "Koronare Herzinsuffizienz",
      "Koronare Mangeldurchblutung",
      "Koronares Versagen",
      "Koronarinsuffizienz",
      "Mikroherzinfarkt",
      "Myokardiale Hypoxie",
      "Subendokardiale Ischämie"
    ]
  },
  {
    "code": "I24.9",
    "name": "Akuter Koronarschaden",
    "synonyms": [
      "ACS [Akutes Koronarsyndrom]",
      "Akute ischämische Herzkrankheit",
      "Akute koronare Herzkrankheit",
      "Akuter Koronarschaden",
      "Akutes Koronarsyndrom",
      "Zyanotische Herzkrankheit"
    ]
  },
  {
    "code": "I25.0",
    "name": "Kardiovaskuläre Arteriosklerose",
    "synonyms": [
      "Atherosklerotische Herz-Kreislauf-Krankheit",
      "Kardiovaskuläre Arteriosklerose",
      "Kardiovaskuläre arteriosklerotische Krankheit"
    ]
  },
  {
    "code": "I25.10",
    "name": "Atherosklerotische Herzkrankheit ohne hämodynamisch wirksame Stenosen",
    "synonyms": [
      "Atherosklerotische Herzkrankheit ohne hämodynamisch wirksame Stenosen"
    ]
  },
  {
    "code": "I25.11",
    "name": "RIVA [Ramus intraventricularis anterior]-Stenose",
    "synonyms": [
      "Arteriosklerose eines Herzgefäßes",
      "Koronare Ein-Gefäß-Erkrankung",
      "RIVA [Ramus intraventricularis anterior]-Stenose"
    ]
  },
  {
    "code": "I25.12",
    "name": "Koronare Zwei-Gefäß-Erkrankung",
    "synonyms": [
      "Atherosklerotische Zwei-Gefäß-Erkrankung",
      "Koronare Zwei-Gefäß-Erkrankung"
    ]
  },
  {
    "code": "I25.13",
    "name": "Koronare Drei-Gefäß-Erkrankung",
    "synonyms": [
      "Atherosklerotische Drei-Gefäß-Erkrankung",
      "Koronare Drei-Gefäß-Erkrankung",
      "Koronare Zwei- bis Drei-Gefäß-Erkrankung"
    ]
  },
  {
    "code": "I25.14",
    "name": "Stenose des linken Hauptstammes der Koronararterien",
    "synonyms": [
      "Koronare Vier-Gefäß-Erkrankung",
      "Stenose des linken Hauptstammes der Koronararterien"
    ]
  },
  {
    "code": "I25.15",
    "name": "Atherosklerotische Herzkrankheit mit stenosiertem Bypass-Gefäß",
    "synonyms": [
      "Atherosklerotische Herzkrankheit mit stenosiertem Bypass-Gefäß"
    ]
  },
  {
    "code": "I25.16",
    "name": "Atherosklerotische Herzkrankheit mit stenosierten Stents",
    "synonyms": [
      "Atherosklerotische Herzkrankheit mit In-Stent-Stenose",
      "Atherosklerotische Herzkrankheit mit stenosierten Stents"
    ]
  },
  {
    "code": "I25.19",
    "name": "Mittelgradige Koronararteriensklerose",
    "synonyms": [
      "Angiokardiosklerose",
      "Arterielle Herzkrankheit",
      "Arteriosklerose der Koronararterien",
      "Arteriosklerotische Herzkrankheit",
      "Arteriosklerotische Kardiopathie",
      "Atheromatöse Herzdegeneration",
      "Atherosklerose der Herzkranzarterien",
      "Atherosklerose der Herzkranzgefäße",
      "Atherosklerotische Herzkrankheit",
      "Chronische koronare Herzkrankheit",
      "Herzarteriosklerose",
      "Herzatherom",
      "Herzatheromatose",
      "Herzgefäßsklerose",
      "Herzsklerose",
      "KHE [Koronare Herzerkrankung] - s.a. Koronare Herzerkrankung",
      "KHK [Koronare Herzkrankheit] - s.a. Koronare Herzkrankheit",
      "Kardiale Arteriosklerose",
      "Kardiale Sklerose",
      "Kardiales Atherom",
      "Kardiosklerose",
      "Kardiovasosklerose",
      "Koronararterienatherom",
      "Koronararterienkalzifikation",
      "Koronararterienkrankheit",
      "Koronararterienobstruktion",
      "Koronararterienossifikation",
      "Koronararteriensklerose",
      "Koronararterienstenose",
      "Koronararterienstriktur",
      "Koronararterienverengung",
      "Koronararterienverkalkung",
      "Koronaratheromatose",
      "Koronare Arteriosklerose",
      "Koronare Atherosklerose",
      "Koronare Gefäßerkrankung",
      "Koronare Herzkrankheit",
      "Koronare Herzkrankheit mit eingeschränkter linksventrikulärer Funktion",
      "Koronare Mehrgefäßerkrankung",
      "Koronare arteriosklerotische Krankheit",
      "Koronarerkrankung",
      "Koronares Atherom",
      "Koronargefäßstenose",
      "Koronarsklerose",
      "Koronarstenose",
      "Koronarstriktur",
      "Mittelgradige Koronararteriensklerose",
      "Myokardatherom",
      "Myokardiales Atherom",
      "Sklerose der Herzkranzgefäße",
      "Sklerotische Herzkrankheit",
      "Stenosierende Koronararteriensklerose"
    ]
  },
  {
    "code": "I25.20",
    "name": "Alter Myokardinfarkt, 29 Tage bis unter 4 Monate zurückliegend",
    "synonyms": [
      "Alter Myokardinfarkt, 29 Tage bis unter 4 Monate zurückliegend"
    ]
  },
  {
    "code": "I25.21",
    "name": "Alter Myokardinfarkt, 4 Monate bis unter 1 Jahr zurückliegend",
    "synonyms": [
      "Alter Myokardinfarkt, 4 Monate bis unter 1 Jahr zurückliegend"
    ]
  },
  {
    "code": "I25.22",
    "name": "Alter Myokardinfarkt, 1 Jahr und länger zurückliegend",
    "synonyms": [
      "Alter Myokardinfarkt, 1 Jahr und länger zurückliegend"
    ]
  },
  {
    "code": "I25.29",
    "name": "Hinterwandschwiele des Herzens",
    "synonyms": [
      "Abgeheilter Myokardinfarkt",
      "Alter Anteroseptalinfarkt",
      "Alter Herzinfarkt",
      "Alter Inferolateralinfarkt",
      "Alter Myokardinfarkt",
      "Ausgeheilter Herzinfarkt",
      "Herzinfarktanamnese",
      "Herzinfarktschwiele",
      "Hinterwandschwiele des Herzens",
      "Hinterwandseptumschwiele",
      "Myokardiale Narbe",
      "Myokardinfarktnarbe",
      "Myokardinfarktschwiele",
      "Myokardnarbe",
      "Myokardvernarbung",
      "Rudimentärer Herzinfarkt",
      "Rudimentärer Myokardinfarkt",
      "Schwielenherz",
      "Zustand nach Herzinfarkt",
      "Zustand nach Myokardinfarkt"
    ]
  },
  {
    "code": "I25.3",
    "name": "Herzwandaneurysma",
    "synonyms": [
      "Aneurysma des Conus arteriosus",
      "Aneurysma des Septum interatriale",
      "Aneurysma des Septum interventriculare",
      "Herzaneurysma",
      "Herzventrikelaneurysma",
      "Herzwandaneurysma",
      "Hinterwandaneurysma",
      "Kardiales Aneurysma",
      "Koronare Herzkrankheit mit Ventrikelaneurysma",
      "Murales Aneurysma",
      "Myokardaneurysma",
      "Ventrikelaneurysma",
      "Vorderwandaneurysma"
    ]
  },
  {
    "code": "I25.4",
    "name": "Koronararterienaneurysma",
    "synonyms": [
      "Arteriosklerotisches Koronararterienaneurysma",
      "Erworbene koronare Fistel",
      "Erworbene koronare arteriovenöse Fistel",
      "Erworbenes arteriovenöses Aneurysma der Koronararterien",
      "Idiopathische spontane Koronararteriendissektion",
      "Koronararterienaneurysma",
      "Koronararteriendissektion",
      "Koronare Fistel"
    ]
  },
  {
    "code": "I25.5",
    "name": "Ischämische Kardiomyopathie",
    "synonyms": [
      "Arteriosklerotische Kardiomyopathie",
      "Ischämische Kardiomyopathie",
      "Ischämische Myokarderkrankung",
      "Ischämische Myokardschädigung"
    ]
  },
  {
    "code": "I25.6",
    "name": "Stumme Myokardischämie",
    "synonyms": [
      "Stumme Myokardischämie"
    ]
  },
  {
    "code": "I25.8",
    "name": "Koronararteriitis",
    "synonyms": [
      "Chronische Koronarinsuffizienz",
      "Chronische subendokardiale Nekrose",
      "Chronischer Myokardinfarkt",
      "Coronariitis - s.a. Koronariitis",
      "Erworbene Koronararteriendeformität",
      "Koronararterienentzündung",
      "Koronararteriitis",
      "Koronariitis",
      "Koronarvenenaneurysma",
      "Myokardinfarkt mit angegebener Krankheitsdauer von mehr als 4 Wochen"
    ]
  },
  {
    "code": "I25.9",
    "name": "Herzgefäßkrankheit",
    "synonyms": [
      "CIHK [Chronische ischämische Herzkrankheit]",
      "Chronische Herzgefäßkrankheit",
      "Chronische Herzischämie",
      "Chronische hypertonische ischämische Herzkrankheit",
      "Chronische ischämische Herzkrankheit",
      "Chronische kardiale Durchblutungsstörung",
      "Chronische myokardiale Ischämie",
      "Dekompensierte CIHK [Chronische ischämische Herzkrankheit]",
      "Herzgefäßkrankheit",
      "IHK [Ischämische Herzkrankheit]",
      "Ischämische Herzinsuffizienz",
      "Ischämische Herzkrankheit",
      "Ischämische Kardiopathie",
      "Kardiale Ischämie",
      "Kardioangiopathie",
      "Koronararterienschädigung",
      "Koronare DBS [Durchblutungsstörung]",
      "Koronare Durchblutungsstörung",
      "Koronare Ischämie",
      "Myokardischämie"
    ]
  },
  {
    "code": "I26.0",
    "name": "Akutes Cor pulmonale",
    "synonyms": [
      "Akute pulmonale Herzkrankheit",
      "Akutes Cor pulmonale",
      "Fulminante Lungenembolie",
      "Lungenembolie mit akutem Cor pulmonale",
      "Massive Lungenembolie",
      "Pulmonalarterienthromboembolie mit Cor pulmonale",
      "Pulmonalarterienthrombose mit Cor pulmonale",
      "Pulmonale Thromboembolie mit Cor pulmonale",
      "Pulmonale Thrombose mit Cor pulmonale",
      "Pulmonalvenenthromboembolie mit Cor pulmonale",
      "Pulmonalvenenthrombose mit Cor pulmonale"
    ]
  },
  {
    "code": "I26.9",
    "name": "Lungenembolie",
    "synonyms": [
      "Arterielle Lungenembolie",
      "Embolischer Lungeninfarkt",
      "Hämorrhagischer Lungeninfarkt",
      "Lungenarterienembolie",
      "Lungenembolie",
      "Lungenembolie ohne akutes Cor pulmonale",
      "Lungeninfarkt",
      "Lungenthrombembolie",
      "Lungenthrombose",
      "Nichtmassive Lungenembolie",
      "Postoperative Lungenembolie",
      "Pulmonalarterienembolie",
      "Pulmonalarterienthromboembolie",
      "Pulmonalarterienthrombose",
      "Pulmonale Thromboembolie",
      "Pulmonalembolie",
      "Pulmonaler Infarkt",
      "Pulmonalthrombose",
      "Pulmonalvenenthromboembolie",
      "Pulmonalvenenthrombose",
      "Thrombose der Arteria pulmonalis",
      "Thrombotischer Lungeninfarkt"
    ]
  },
  {
    "code": "I27.00",
    "name": "Pulmonale idiopathische Hypertonie",
    "synonyms": [
      "Familiäre pulmonale arterielle Hypertonie",
      "HPAH [Hereditäre pulmonale arterielle Hypertonie]",
      "Hereditäre pulmonale arterielle Hypertonie",
      "IPAH [Idiopathische pulmonale arterielle Hypertonie]",
      "Idiopathische PAH [Pulmonale arterielle Hypertonie]",
      "Idiopathische pulmonale arterielle Hypertonie",
      "Pulmonale idiopathische Hypertonie"
    ]
  },
  {
    "code": "I27.01",
    "name": "Pulmonale arterielle Hypertonie assoziiert mit angeborenem Herzfehler",
    "synonyms": [
      "APAH [Pulmonale arterielle Hypertonie assoziiert mit angeborenem Herzfehler, Krankheit des Bindegewebes und portaler Hypertension]",
      "Pulmonale arterielle Hypertonie assoziiert mit Krankheit des Bindegewebes",
      "Pulmonale arterielle Hypertonie assoziiert mit angeborenem Herzfehler",
      "Pulmonale arterielle Hypertonie assoziiert mit portaler Hypertension"
    ]
  },
  {
    "code": "I27.02",
    "name": "Pulmonale arterielle Hypertonie durch Arzneimittel",
    "synonyms": [
      "DPAH [Pulmonale arterielle Hypertonie induziert durch Arzneimittel, Droge, Toxin und Strahlung]",
      "Pulmonale arterielle Hypertonie durch Arzneimittel",
      "Pulmonale arterielle Hypertonie durch Drogen",
      "Pulmonale arterielle Hypertonie durch Strahlung",
      "Pulmonale arterielle Hypertonie durch Toxin"
    ]
  },
  {
    "code": "I27.08",
    "name": "Pulmonalarteriensklerose",
    "synonyms": [
      "Arteriosklerose der Arteria pulmonalis",
      "Ayerza-Krankheit",
      "Ayerza-Syndrom",
      "Cardiopathia nigra",
      "PAH [pulmonale arterielle Hypertonie]",
      "PVOD [Pulmonale venookklusive Krankheit]",
      "Primäre pulmonale Hypertonie",
      "Primäre pulmonale arterielle Hypertension",
      "Pulmonalarteriensklerose",
      "Pulmonale Arteriosklerose",
      "Pulmonale Venenverschlusskrankheit",
      "Pulmonale arterielle Hypertonie",
      "Pulmonale venookklusive Krankheit",
      "Sporadische pulmonale arterielle Hypertension"
    ]
  },
  {
    "code": "I27.1",
    "name": "Kyphoskoliotische Herzkrankheit",
    "synonyms": [
      "Cor kyphoscolioticum",
      "Kyphoskoliotische Herzkrankheit",
      "Kyphotische Herzkrankheit",
      "Skoliotische Herzkrankheit"
    ]
  },
  {
    "code": "I27.20",
    "name": "Pulmonale Hypertonie bei chronischer Thromboembolie",
    "synonyms": [
      "CTEPH [Chronische thromboembolische pulmonale Hypertension]",
      "Chronische thromboembolische pulmonale Hypertension",
      "Pulmonale Hypertonie bei chronischer Thromboembolie"
    ]
  },
  {
    "code": "I27.21",
    "name": "Pulmonale Hypertonie bei Linksherzerkrankung",
    "synonyms": [
      "Pulmonale Hypertonie bei Linksherzerkrankung"
    ]
  },
  {
    "code": "I27.22",
    "name": "Pulmonale Hypertonie bei Lungenkrankheit",
    "synonyms": [
      "Pulmonale Hypertonie bei Hypoxie",
      "Pulmonale Hypertonie bei Lungenkrankheit"
    ]
  },
  {
    "code": "I27.28",
    "name": "Pulmonale Hypertonie",
    "synonyms": [
      "Pulmonale Hypertonie",
      "Pulmonaler Bluthochdruck"
    ]
  },
  {
    "code": "I27.8",
    "name": "Eisenmenger-Komplex",
    "synonyms": [
      "Eisenmenger-Komplex",
      "Eisenmenger-Syndrom"
    ]
  },
  {
    "code": "I27.9",
    "name": "Cor pulmonale",
    "synonyms": [
      "Chronische kardiopulmonale Krankheit",
      "Chronische pulmonale Herzkrankheit",
      "Chronisches Cor pulmonale",
      "Cor pulmonale",
      "Kardiopulmonale Herzinsuffizienz",
      "Kardiopulmonale Herzkrankheit",
      "Pulmonale Herzkrankheit"
    ]
  },
  {
    "code": "I28.0",
    "name": "Arteriovenöse Fistel eines Lungengefäßes",
    "synonyms": [
      "Arteriovenöse Fistel eines Lungengefäßes",
      "Arteriovenöse pulmonale Fistel",
      "Arteriovenöser pulmonaler Shunt a.n.k.",
      "Erworbenes arteriovenöses pulmonales Aneurysma"
    ]
  },
  {
    "code": "I28.1",
    "name": "Pulmonalarterienaneurysma",
    "synonyms": [
      "Aneurysma der Arteria pulmonalis",
      "Lungenaneurysma",
      "Pulmonalarterienaneurysma",
      "Pulmonales Aneurysma"
    ]
  },
  {
    "code": "I28.8",
    "name": "Lungenarterienarrosion",
    "synonyms": [
      "Blutgefäßruptur der Lunge",
      "Erworbene Pulmonalarterienstenose",
      "Erworbene Pulmonalarterienstriktur",
      "Erworbene Striktur der Arteria pulmonalis",
      "Idiopathische Pulmonalarteriendilatation",
      "Lungenarterienarrosion",
      "Lungengefäßruptur",
      "Lungengefäßstenose",
      "Lungengefäßstriktur",
      "Lungenvenenstenose",
      "Pulmonalarterienarrosion",
      "Pulmonalarteriendilatation",
      "Pulmonalarterienektasie",
      "Pulmonalarterienruptur",
      "Pulmonale Endarteriitis obliterans",
      "Pulmonale Gefäßstenose",
      "Pulmonale Gefäßstriktur",
      "Pulmonalgefäßruptur"
    ]
  },
  {
    "code": "I28.9",
    "name": "Lungenkreislaufkrankheit",
    "synonyms": [
      "Lungengefäßveränderung",
      "Lungenkreislaufkrankheit",
      "Pulmonalarterienkrankheit"
    ]
  },
  {
    "code": "I30.0",
    "name": "Akute unspezifische idiopathische Perikarditis",
    "synonyms": [
      "Akute unspezifische idiopathische Perikarditis",
      "Idiopathische Perikarditis"
    ]
  },
  {
    "code": "I30.1",
    "name": "Virale Perikarditis",
    "synonyms": [
      "Akute bakterielle Perikarditis mit seropurulentem Erguss",
      "Akute bakterielle Perikarditis mit serösem Erguss",
      "Eitrige Perikarditis",
      "Eitrige fibrinöse Perikarditis",
      "Infektiöse Perikarditis",
      "Pericarditis purulenta",
      "Perikardialer Abszess",
      "Pneumopyoperikard",
      "Pyoperikard",
      "Pyoperikarditis",
      "Pyopneumoperikard",
      "Septische Perikarditis",
      "Suppurative Perikarditis",
      "Virale Perikarditis"
    ]
  },
  {
    "code": "I30.8",
    "name": "Fibrinöse Perikarditis",
    "synonyms": [
      "Akute benigne Perikarditis",
      "Fibrinöse Perikarditis",
      "Serofibrinöse Perikarditis"
    ]
  },
  {
    "code": "I30.9",
    "name": "Akute Perikarditis",
    "synonyms": [
      "Akute Myoperikarditis",
      "Akute Perikarditis",
      "Akute nichtrheumatische Perikarditis",
      "Akuter Perikarderguss"
    ]
  },
  {
    "code": "I31.0",
    "name": "Epikardverwachsung",
    "synonyms": [
      "Accretio cordis",
      "Accretio pericardii",
      "Adhäsive Mediastinoperikarditis",
      "Chronische adhäsive Perikarditis",
      "Epikardverwachsung",
      "Fibröse Perikarditis",
      "Herzadhäsion",
      "Pericarditis adhaesiva",
      "Perikardadhäsion",
      "Perikardverwachsung"
    ]
  },
  {
    "code": "I31.1",
    "name": "Perikarditische Pseudoleberzirrhose",
    "synonyms": [
      "Chronische konstriktive Perikarditis",
      "Concretio cordis",
      "Concretio pericardii",
      "Panzerherz",
      "Pericarditis calcarea",
      "Pericarditis constrictiva",
      "Pericarditis constrictiva chronica",
      "Perikardiale Kalzifikation",
      "Perikarditische Pseudoleberzirrhose",
      "Pseudocirrhosis hepatis pericardiaca"
    ]
  },
  {
    "code": "I31.2",
    "name": "Perikardblutung",
    "synonyms": [
      "Herzbeutelblutung",
      "Herzbeutelhämorrhagie",
      "Hämoperikard",
      "Hämopneumoperikard",
      "Hämorrhagische Perikarditis",
      "Perikardblutung",
      "Perikardhämorrhagie",
      "Pneumohämoperikard"
    ]
  },
  {
    "code": "I31.3",
    "name": "Chyloperikard",
    "synonyms": [
      "Chyloperikard",
      "Maligner Perikarderguss",
      "Nichtentzündlicher Perikarderguss",
      "Perikarderguss"
    ]
  },
  {
    "code": "I31.80",
    "name": "Herzbeuteltamponade",
    "synonyms": [
      "Herzbeuteltamponade",
      "Herztamponade",
      "Perikardtamponade"
    ]
  },
  {
    "code": "I31.88",
    "name": "Perikardfibrose",
    "synonyms": [
      "Epikardiale Plaques",
      "Fokale perikardiale Adhäsion",
      "Perikardfibrose",
      "Perikardschwiele",
      "Postinfektiöse fokale Perikardadhäsion"
    ]
  },
  {
    "code": "I31.9",
    "name": "Hydroperikard",
    "synonyms": [
      "Chronische Myoperikarditis",
      "Chronische Perikarditis",
      "Chronische Perikardkrankheit",
      "Chronische nichtrheumatische Perikarditis",
      "Epikarditis",
      "Hydroperikard",
      "Hydroperikarditis",
      "Hydropneumoperikard",
      "Hydropneumoperikarditis",
      "Kardioperikarditis",
      "Mediastinoperikarditis",
      "Myoperikarditis",
      "Pericarditis",
      "Perikardentzündung",
      "Perikarditis",
      "Perikarditis mit Dekompensation",
      "Perikarditis mit Erguss",
      "Perikardkrankheit",
      "Perimyokarditis",
      "Pleuroperikarditis",
      "Pneumohydroperikard",
      "Pneumoperikard",
      "Pneumoperikarditis"
    ]
  },
  {
    "code": "I33.0",
    "name": "Endocarditis lenta",
    "synonyms": [
      "Akute Endocarditis lenta",
      "Akute Endocarditis ulcerosa",
      "Akute bakterielle Endokarditis",
      "Akute infektiöse Endokarditis",
      "Akute maligne Endokarditis",
      "Akute septische Endokarditis",
      "Bakterielle Endokarditis",
      "Bakterielle Mitralklappenendokarditis",
      "Eitrige Endokarditis",
      "Endocarditis lenta",
      "Endocarditis maligna",
      "Endocarditis ulceropolyposa",
      "Endocarditis ulcerosa",
      "Herzklappenulkus",
      "Infektiöse Endokarditis",
      "Maligne Endokarditis",
      "Mykotische Endokarditis",
      "Osler-Knötchen",
      "Purulente Endokarditis",
      "Sepsis lenta",
      "Septische Endokarditis",
      "Subakute Endocarditis lenta",
      "Subakute Endocarditis ulcerosa",
      "Subakute bakterielle Endokarditis",
      "Subakute infektiöse Endokarditis",
      "Subakute maligne Endokarditis",
      "Subakute septische Endokarditis",
      "Suppurative Endokarditis",
      "Ulzerative Endokarditis",
      "Vegetative Endokarditis"
    ]
  },
  {
    "code": "I33.9",
    "name": "Subakute Endokarditis",
    "synonyms": [
      "Aktive nichtrheumatische Pulmonalklappenendokarditis",
      "Akute Endokarditis",
      "Akute Herzklappenentzündung",
      "Akute Herzklappenkrankheit",
      "Akute Myoendokarditis",
      "Akute Periendokarditis",
      "Akute nichtrheumatische Pulmonalklappenendokarditis",
      "Akute nichtrheumatische Trikuspidalklappenendokarditis",
      "Subakute Endokarditis",
      "Subakute Myoendokarditis",
      "Subakute Periendokarditis",
      "Subakute nichtrheumatische Trikuspidalklappenendokarditis",
      "Toxische Endokarditis"
    ]
  },
  {
    "code": "I34.0",
    "name": "Mitralklappeninsuffizienz",
    "synonyms": [
      "Degenerative Mitralklappeninsuffizienz",
      "Mitralinsuffizienz",
      "Mitralklappeninsuffizienz",
      "Mitralklappenregurgitation",
      "Nichtrheumatische Mitralklappeninsuffizienz",
      "Nichtrheumatische Mitralklappenregurgitation"
    ]
  },
  {
    "code": "I34.1",
    "name": "Mitralklappenprolaps",
    "synonyms": [
      "Barlow-Syndrom",
      "Familiärer Mitralklappenprolaps",
      "Floppy-valve-Syndrom",
      "Mitralklappenprolaps"
    ]
  },
  {
    "code": "I34.2",
    "name": "Nichtrheumatische Mitralklappenstenose",
    "synonyms": [
      "Nichtrheumatische Mitralklappenstenose"
    ]
  },
  {
    "code": "I34.80",
    "name": "Nichtrheumatische Mitralklappenstenose mit Mitralklappeninsuffizienz",
    "synonyms": [
      "Nichtrheumatische Mitralklappenstenose mit Mitralklappeninsuffizienz"
    ]
  },
  {
    "code": "I34.88",
    "name": "Mitralklappenverkalkung",
    "synonyms": [
      "Arteriosklerotische Mitralklappenendokarditis",
      "Mitralklappenaneurysma",
      "Mitralklappenatherom",
      "Mitralklappenkalzifikation",
      "Mitralklappenruptur",
      "Mitralklappenthrombose",
      "Mitralklappenverkalkung",
      "Nichtrheumatische Mitralklappenendokarditis",
      "Nichtrheumatischer Mitralklappenfehler"
    ]
  },
  {
    "code": "I34.9",
    "name": "Chronische sklerosierende Mitralklappenkrankheit",
    "synonyms": [
      "Chronische sklerosierende Mitralklappenkrankheit",
      "Nichtrheumatische Mitralklappenkrankheit"
    ]
  },
  {
    "code": "I35.0",
    "name": "Aortenklappenstenose",
    "synonyms": [
      "AKS [Aortenklappenstenose]",
      "Aortenklappenobstruktion",
      "Aortenklappenstenose",
      "Aortenklappenstriktur"
    ]
  },
  {
    "code": "I35.1",
    "name": "Austin-Flint-Geräusch",
    "synonyms": [
      "Aortenklappeninsuffizienz",
      "Aortenklappenregurgitation",
      "Austin-Flint-Geräusch",
      "Flint-Geräusch",
      "Nichtrheumatische Aortenklappeninsuffizienz",
      "Nichtrheumatische Aortenklappenregurgitation"
    ]
  },
  {
    "code": "I35.2",
    "name": "Aortenklappenstenose mit Insuffizienz",
    "synonyms": [
      "Aortenklappenstenose mit Insuffizienz",
      "Kombiniertes Aortenklappenvitium",
      "Kombiniertes Aortenvitium"
    ]
  },
  {
    "code": "I35.8",
    "name": "Aortenklappensklerose",
    "synonyms": [
      "Aortenklappenaneurysma",
      "Aortenklappenatherom",
      "Aortenklappendegeneration",
      "Aortenklappenentzündung",
      "Aortenklappenfehler",
      "Aortenklappengeräusch",
      "Aortenklappenkalzifikation",
      "Aortenklappenruptur",
      "Aortenklappensklerose",
      "Aortenklappenverkalkung",
      "Aortenklappenvitium",
      "Aortenvitium",
      "Arteriosklerotische Aortenklappenendokarditis",
      "Nichtrheumatische Aortenklappenendokarditis",
      "Nichtrheumatischer Aortenklappenfehler"
    ]
  },
  {
    "code": "I35.9",
    "name": "Aortenklappenkrankheit",
    "synonyms": [
      "Aortenklappenkrankheit",
      "Aortenklappenschädigung",
      "Aortenschädigung",
      "Chronische arteriosklerotische Aortenklappenkrankheit",
      "Nichtrheumatische Aortenklappenkrankheit"
    ]
  },
  {
    "code": "I36.0",
    "name": "Nichtrheumatische Trikuspidalklappenstenose",
    "synonyms": [
      "Nichtrheumatische Trikuspidalklappenstenose"
    ]
  },
  {
    "code": "I36.1",
    "name": "Nichtrheumatische Trikuspidalklappeninsuffizienz",
    "synonyms": [
      "Nichtrheumatische Trikuspidalklappeninsuffizienz",
      "Nichtrheumatische Trikuspidalklappenregurgitation"
    ]
  },
  {
    "code": "I36.2",
    "name": "Nichtrheumatische Trikuspidalklappenstenose mit Insuffizienz",
    "synonyms": [
      "Nichtrheumatische Trikuspidalklappenstenose mit Insuffizienz"
    ]
  },
  {
    "code": "I36.8",
    "name": "Trikuspidalklappenatherom",
    "synonyms": [
      "Arteriosklerotische Trikuspidalklappenendokarditis",
      "Nichtrheumatische Trikuspidalklappenendokarditis",
      "Trikuspidalklappenatherom"
    ]
  },
  {
    "code": "I36.9",
    "name": "Nichtrheumatische Trikuspidalklappenkrankheit",
    "synonyms": [
      "Nichtrheumatische Trikuspidalklappenkrankheit",
      "Nichtrheumatische Trikuspidalklappenschädigung"
    ]
  },
  {
    "code": "I37.0",
    "name": "Pulmonalklappenstenose",
    "synonyms": [
      "Erworbene Pulmonalklappenstenose",
      "Nichtrheumatische Pulmonalklappenstenose",
      "Pulmonalklappenobstruktion",
      "Pulmonalklappenstenose",
      "Pulmonalklappenstriktur",
      "Valvuläre Pulmonalstenose"
    ]
  },
  {
    "code": "I37.1",
    "name": "Pulmonalklappeninsuffizienz",
    "synonyms": [
      "Graham-Steell-Geräusch",
      "Nichtrheumatische Pulmonalklappeninsuffizienz",
      "Nichtrheumatische Pulmonalklappenregurgitation",
      "Pulmonalklappeninsuffizienz",
      "Pulmonalklappenregurgitation",
      "Steell-Geräusch"
    ]
  },
  {
    "code": "I37.2",
    "name": "Pulmonalklappenstenose mit Insuffizienz",
    "synonyms": [
      "Pulmonalklappeninsuffizienz mit Stenose",
      "Pulmonalklappenstenose mit Insuffizienz"
    ]
  },
  {
    "code": "I37.8",
    "name": "Pulmonalklappenfehler",
    "synonyms": [
      "Arteriosklerotische Pulmonalklappenendokarditis",
      "Chronische Pulmonalklappenendokarditis",
      "Pulmonalklappenaneurysma",
      "Pulmonalklappenatherom",
      "Pulmonalklappendegeneration",
      "Pulmonalklappenfehler",
      "Pulmonalklappengeräusch",
      "Pulmonalklappenruptur",
      "Pulmonalklappensklerose"
    ]
  },
  {
    "code": "I37.9",
    "name": "Chronische arteriosklerotische Pulmonalklappenkrankheit",
    "synonyms": [
      "Chronische arteriosklerotische Pulmonalklappenkrankheit",
      "Pulmonalklappenkrankheit",
      "Pulmonalklappenschädigung"
    ]
  },
  {
    "code": "I38",
    "name": "Erworbenes Vitium cordis",
    "synonyms": [
      "Arteriosklerotische Endokarditis",
      "Chronische Endokarditis",
      "Chronische Endokardkrankheit",
      "Chronische Valvulitis",
      "Chronische arteriosklerotische Herzklappenkrankheit",
      "Endocarditis",
      "Endokardfibrose",
      "Endokarditis",
      "Endokardverwachsung",
      "Endomyokarditis",
      "Endoperikarditis",
      "Erworbener Herzfehler",
      "Erworbenes Vitium cordis",
      "Herzfehler",
      "Herzinnenhautentzündung",
      "Herzklappenendokarditis",
      "Herzklappenentzündung",
      "Herzklappenfehler",
      "Herzklappenfibrose",
      "Herzklappenhypertrophie",
      "Herzklappeninsuffizienz",
      "Herzklappenkrankheit",
      "Herzklappenstenose",
      "Herzklappenstriktur",
      "Herzvitium",
      "Kardiales Vitium",
      "Myoendokarditis",
      "Nichtbakterielle Endokarditis",
      "Nichtrheumatische Herzklappeninsuffizienz",
      "Nichtrheumatische Herzklappenstenose",
      "Nichtrheumatische Valvulitis",
      "Nichtrheumatische chronische Valvulitis",
      "Periendokarditis",
      "Thrombotische Endokarditis",
      "Valvulitis",
      "Valvuläre Endokarditis",
      "Valvuläre Herzkrankheit",
      "Valvuläre Stenose",
      "Valvuläre Striktur",
      "Vitium cordis"
    ]
  },
  {
    "code": "I40.0",
    "name": "Myokardabszess",
    "synonyms": [
      "Akute bakterielle Myokarditis",
      "Eitrige Myokarditis",
      "Infektiöse Myokarditis",
      "Myokardabszess",
      "Myokardinfektion",
      "Septische Myokarditis",
      "Virale Myokarditis a.n.k.",
      "Virusmyokarditis a.n.k."
    ]
  },
  {
    "code": "I40.1",
    "name": "Herdmyokarditis",
    "synonyms": [
      "Akute isolierte Myokarditis",
      "Fiedler-Myokarditis",
      "Herdmyokarditis",
      "Idiopathische Myokarditis",
      "Isolierte Myokarditis"
    ]
  },
  {
    "code": "I40.8",
    "name": "Toxische Myokarditis",
    "synonyms": [
      "Alkoholbedingte Myokarditis",
      "Riesenzellmyokarditis",
      "Toxische Myokarditis"
    ]
  },
  {
    "code": "I40.9",
    "name": "Akute Myokarditis",
    "synonyms": [
      "Aktive Myokarditis",
      "Akute Herzmuskelentzündung",
      "Akute Myokarditis",
      "Akute interstitielle Myokarditis",
      "Subakute interstitielle Myokarditis"
    ]
  },
  {
    "code": "I42.0",
    "name": "Dilatative Kardiomyopathie",
    "synonyms": [
      "DCM [Dilatative Kardiomyopathie]",
      "Dilatative Kardiomyopathie",
      "Dilatative Myokardiopathie",
      "Familiäre dilatative Kardiomyopathie",
      "Familiäre dilatative Kardiomyopathie mit Reizleitungs-Defekt durch LMNA-Genmutation",
      "Histiozytoide Kardiomyopathie",
      "Kongestive Kardiomyopathie",
      "Kongestive Myokardiopathie"
    ]
  },
  {
    "code": "I42.1",
    "name": "Idiopathische hypertrophische Subaortenstenose",
    "synonyms": [
      "HOCM [Hypertrophische obstruktive Kardiomyopathie]",
      "Hypertrophische Subaortenstenose",
      "Hypertrophische obstruktive Kardiomyopathie",
      "IHSS [Idiopathische hypertrophische Subaortenstenose]",
      "Idiopathische hypertrophische Subaortenstenose",
      "Obstruktive Kardiomyopathie",
      "Obstruktive Myokardiopathie"
    ]
  },
  {
    "code": "I42.2",
    "name": "HNCM [Hypertrophische nichtobstruktive Kardiomyopathie]",
    "synonyms": [
      "Fatale infantile hypertrophe Kardiomyopathie durch Defekt im Atmungskettenkomplex I",
      "Fatale infantile hypertrophe Kardiomyopathie durch Komplex I-Defekt der mitochondriale Atmungskette",
      "Fatale infantile hypertrophe Kardiomyopathie durch NADH-CoQ-Reduktase Mangel",
      "Fatale infantile hypertrophe Kardiomyopathie durch NADH-Coenzym-Q-Reduktase-Mangel",
      "HNCM [Hypertrophische nichtobstruktive Kardiomyopathie]",
      "Hypertrophe Kardiomyopathie mit Muskelhypotonie und Laktatazidose",
      "Hypertrophe Kardiomyopathie mit renal-tubulärer Störung durch mitochondriale DNA-Mutation",
      "Hypertrophische nichtobstruktive Kardiomyopathie",
      "Hypotonie mit Laktatazidose und Hyperammonämie",
      "Idiopathische Myokardhypertrophie",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 10",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 16",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 17",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 23",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 28",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 8",
      "Kombinierter Defekt der oxidativen Phosphorylierung Typ 9",
      "Kombinierter OXPHOS [Oxidative Phosphorylierung]-Defekt Typ 10",
      "Mitochondriale hypertrophe Kardiomyopathie mit Laktatazidose durch MTO1-Mangel",
      "QRSL1-abhängiger kombinierter Defekt der oxidativen Phosphorylierung"
    ]
  },
  {
    "code": "I42.3",
    "name": "Endomyokardfibrose",
    "synonyms": [
      "Davies-Krankheit",
      "Endocarditis parietalis fibroplastica (Löffler)",
      "Endocarditis parietalis fibroplastica (Löffler) mit Hypereosinophilie",
      "Endomyofibrose",
      "Endomyokardfibrose",
      "Eosinophile Endokarditis",
      "Eosinophile endomyokardiale Krankheit",
      "Löffler-Endokarditis",
      "Löffler-II-Syndrom",
      "TEMF [Tropische Endomyokardfibrose]",
      "Tropische Endomyokardfibrose",
      "Verruköse Löffler-Endokarditis"
    ]
  },
  {
    "code": "I42.4",
    "name": "Endokardfibroelastose",
    "synonyms": [
      "Angeborene Endokarditis",
      "Angeborene Kardiomyopathie",
      "Elastomyofibrose",
      "Endokard-Fibroelastose-Syndrom",
      "Endokardfibroelastose",
      "Endokardiale Fibroelastosis",
      "Endomyokardiale Fibroelastosis",
      "Fetale Endokarditis",
      "Fibroelastosis",
      "Fibroelastosis cordis",
      "Kongenitale Endokarditis",
      "Kongenitale Kardiomyopathie",
      "Kongenitale subendokardiale Sklerose"
    ]
  },
  {
    "code": "I42.5",
    "name": "Restriktive Kardiomyopathie a.n.k.",
    "synonyms": [
      "Familiäre isolierte restriktive Kardiomyopathie",
      "Obliterative Kardiomyopathie",
      "Restriktive Kardiomyopathie a.n.k."
    ]
  },
  {
    "code": "I42.6",
    "name": "Alkoholische Kardiomyopathie",
    "synonyms": [
      "Alkoholbedingte Kardioangiopathie",
      "Alkoholbedingte dilatative Kardiomyopathie",
      "Alkoholische Kardiomyopathie",
      "Alkoholische Myokardiopathie",
      "Alkoholtoxische Kardiomyopathie"
    ]
  },
  {
    "code": "I42.7",
    "name": "Toxische Kardiomyopathie",
    "synonyms": [
      "Kardiomyopathie durch Arzneimittel",
      "Kardiomyopathie durch eine exogene Substanz a.n.k.",
      "Toxische Kardiomyopathie"
    ]
  },
  {
    "code": "I42.80",
    "name": "Arrhythmogene rechtsventrikuläre Krankheit",
    "synonyms": [
      "ARVCM [Arrhythmogene rechtsventrikuläre Kardiomyopathie]",
      "ARVD [Arrhythmogene rechtsventrikuläre Dysplasie]",
      "Arrhythmogene rechtsventrikuläre Dysplasie",
      "Arrhythmogene rechtsventrikuläre Kardiomyopathie",
      "Arrhythmogene rechtsventrikuläre Krankheit",
      "Familiäre isolierte arrhythmogene rechtsventrikuläre Dysplasie",
      "Familiäre isolierte arrhythmogene rechtsventrikuläre Kardiomyopathie"
    ]
  },
  {
    "code": "I42.88",
    "name": "Kardiovaskuläre Kollagenose",
    "synonyms": [
      "Apical-ballooning-Syndrom",
      "Becker-Kardiomyopathie",
      "Biventrikuläre Form der familiären isolierten arrhythmogenen ventrikulären Kardiomyopathie",
      "Kardiomyopathie Typ Takotsubo",
      "Kardiovaskuläre Kollagenose",
      "LVNC [Linksventrikuläre Noncompaction-Kardiomyopathie]",
      "Linksventrikuläre Hypertrabekulierung",
      "Linksventrikuläre Noncompaction-Kardiomyopathie",
      "Spongiöses Myokard",
      "Stress-Kardiomyopathie",
      "Syndrom der transienten linksventrikulären apikalen Ballonierung",
      "Tako-Tsubo-Kardiomyopathie",
      "Takotsubo-Syndrom",
      "Zirrhotische Kardiomyopathie"
    ]
  },
  {
    "code": "I42.9",
    "name": "Kardiomyopathie",
    "synonyms": [
      "Cardiomyopathia - s.a. Kardiomyopathie [CMP]",
      "Familiäre Kardiomyopathie",
      "Herzmuskelveränderung",
      "Idiopathische Kardiomyopathie",
      "Idiopathische Kardiopathie",
      "Idiopathische Myokardiopathie",
      "Kardiomyopathie",
      "Konstriktive Kardiomyopathie",
      "Myokardiopathie",
      "Myokardose",
      "Myokardveränderung",
      "Primäre Kardiomyopathie",
      "Primäre Myokardkrankheit",
      "Sekundäre Kardiomyopathie"
    ]
  },
  {
    "code": "I44.0",
    "name": "Atrioventrikulärer Block 1. Grades",
    "synonyms": [
      "Atrioventrikulärer Block 1. Grades",
      "Herzblock 1. Grades"
    ]
  },
  {
    "code": "I44.1",
    "name": "Mobitz-Block",
    "synonyms": [
      "Atrioventrikulärer Block 2. Grades",
      "Atrioventrikulärer Block 2. Grades, Typ I",
      "Atrioventrikulärer Block 2. Grades, Typ II",
      "Herzblock 2. Grades",
      "Herzblock 2. Grades, Typ I",
      "Herzblock 2. Grades, Typ II",
      "Mobitz-Block",
      "Mobitz-Block vom Typ I",
      "Mobitz-Block vom Typ II",
      "Wenckebach-Block vom Typ I",
      "Wenckebach-Block vom Typ II",
      "Wenckebach-Periodik",
      "Wenckebach-Phänomen",
      "Wenckebach-Syndrom"
    ]
  },
  {
    "code": "I44.2",
    "name": "Kompletter atrioventrikulärer Block",
    "synonyms": [
      "Atrioventrikulärer Block 3. Grades",
      "Herzblock 3. Grades",
      "Kompletter AV [Atrioventrikular]-Block",
      "Kompletter Herzblock",
      "Kompletter atrioventrikulärer Block",
      "Totaler AV [Atrioventrikular]-Block"
    ]
  },
  {
    "code": "I44.3",
    "name": "Leitungsunterbrechung des His-Bündels",
    "synonyms": [
      "AV [Atrioventrikular]-Block",
      "Astblock",
      "Atrioventrikulärer Block",
      "Idioventrikulärer Rhythmus",
      "Inkompletter AV [Atrioventrikular]-Block",
      "Leitungsunterbrechung des His-Bündels",
      "Sklerose des His-Bündels"
    ]
  },
  {
    "code": "I44.4",
    "name": "Linksanteriorer Faszikelblock",
    "synonyms": [
      "Anteriorer Faszikelblock",
      "Anteriorer faszikulärer Block",
      "Linksanteriorer Faszikelblock",
      "Linksanteriorer Hemiblock"
    ]
  },
  {
    "code": "I44.5",
    "name": "Linksposteriorer Faszikelblock",
    "synonyms": [
      "Linksposteriorer Faszikelblock",
      "Linksposteriorer Hemiblock",
      "Posteriorer Faszikelblock",
      "Posteriorer faszikulärer Block"
    ]
  },
  {
    "code": "I44.6",
    "name": "Halbseitiger Linksschenkelblock",
    "synonyms": [
      "Faszikelblock",
      "Halbseitiger Linksschenkelblock",
      "Hemiblock",
      "Inkompletter Linksschenkelblock",
      "Linksseitiger Faszikelblock",
      "Linksseitiger Hemiblock a.n.k.",
      "Partieller Linksschenkelblock"
    ]
  },
  {
    "code": "I44.7",
    "name": "Linksschenkelblock",
    "synonyms": [
      "Intermittierender Linksschenkelblock",
      "Kompletter Linksschenkelblock",
      "LSB [Left septal block]",
      "Linksschenkelblock"
    ]
  },
  {
    "code": "I45.0",
    "name": "Rechtsfaszikulärer Block",
    "synonyms": [
      "Rechtsfaszikulärer Block",
      "Rechtsseitiger Faszikelblock"
    ]
  },
  {
    "code": "I45.1",
    "name": "Rechtsschenkelblock",
    "synonyms": [
      "Inkompletter Rechtsschenkelblock",
      "Kompletter Rechtsschenkelblock",
      "RSB [Rechtsschenkelblock]",
      "Rechtsschenkelblock",
      "Wilson-Block"
    ]
  },
  {
    "code": "I45.2",
    "name": "Bifaszikulärer Block",
    "synonyms": [
      "Bifaszikulärer Block"
    ]
  },
  {
    "code": "I45.3",
    "name": "Trifaszikulärer Block",
    "synonyms": [
      "Trifaszikulärer Block"
    ]
  },
  {
    "code": "I45.4",
    "name": "Anomale intraventrikuläre Erregungsleitung",
    "synonyms": [
      "Anomale intraventrikuläre Erregungsausbreitung",
      "Anomale intraventrikuläre Erregungsleitung",
      "Schenkelblock",
      "Unspezifischer intraventrikulärer Block"
    ]
  },
  {
    "code": "I45.5",
    "name": "Arborisationsblock",
    "synonyms": [
      "Arborisationsblock",
      "Atriale Kardiomyopathie mit Herzblock",
      "Aurikulärer Stillstand",
      "Sinuatrialer Block",
      "Sinuatrialer Stillstand",
      "Sinuaurikulärer Block",
      "Sinuaurikulärer Stillstand",
      "Sinus-Vorhof-Block",
      "Sinusknotenblock",
      "Verzweigungsblock"
    ]
  },
  {
    "code": "I45.6",
    "name": "Wolff-Parkinson-White-Syndrom",
    "synonyms": [
      "Akzessorische atrioventrikuläre Erregungsleitung",
      "Akzessorische atrioventrikuläre Überleitung",
      "Anomale atrioventrikuläre Erregungsausbreitung",
      "Anomalie der atrioventrikulären Erregungsüberleitung",
      "Antesystolie",
      "Atriale Tachyarrhythmie mit kurzem PR-Intervall",
      "Beschleunigte atrioventrikuläre Erregungsleitung",
      "LGL [Lown-Ganong-Levine]-Syndrom",
      "Lown-Ganong-Levine-Syndrom",
      "Präexzitationssyndrom",
      "Verkürzte EKG [Elektrokardiogramm]-Überleitungszeit",
      "Verkürzte PQ-Dauer im EKG [Elektrokardiogramm]",
      "Vorzeitige atrioventrikuläre Erregungsleitung",
      "WPW [Wolff-Parkinson-White]-Syndrom",
      "Wolff-Parkinson-White-Syndrom"
    ]
  },
  {
    "code": "I45.8",
    "name": "Atrioventrikuläre Dissoziation",
    "synonyms": [
      "AV [Atrioventrikular]-Dissoziation",
      "Atrioventrikuläre Dissoziation",
      "Familiäre Lenègre-Krankheit",
      "Familiäre Lev-Krankheit",
      "Familiäre Lev-Lenegre-Krankheit",
      "Familiäre atriale Tachyarrhythmie mit infrahissärer Leitungsstörung",
      "Familiäre progressive kardiale Reizleitungsstörungen",
      "Familiärer progressiver Herzblock",
      "Hereditärer Schenkelblock",
      "Interferenzdissoziation",
      "Short-QT-Syndrom",
      "Verzögerte kardiale Erregungsleitung"
    ]
  },
  {
    "code": "I45.9",
    "name": "Herzblock",
    "synonyms": [
      "Adams-Stokes-Anfall",
      "Adams-Stokes-Krankheit",
      "Adams-Stokes-Symptomenkomplex",
      "Adams-Stokes-Syndrom",
      "Erregungsausbreitungsstörung des Herzens",
      "Erregungsbildungsstörung",
      "Erregungsleitungsstörung des Herzens",
      "Erregungsverspätung des Herzens",
      "Herzblock",
      "Kardiale Erregungsleitungsstörung",
      "Leitungsdefekt",
      "Morgagni-Adams-Stokes-Anfall",
      "Morgagni-Adams-Stokes-Syndrom",
      "Myokardialer Block",
      "Reizleitungsstörung",
      "Reizleitungsunterbrechung",
      "Subnormale Erregungsleitung des Herzens",
      "Vorhofüberleitungsstörung",
      "Überleitungsdefekt"
    ]
  },
  {
    "code": "I46.0",
    "name": "Herzstillstand mit erfolgreicher Wiederbelebung",
    "synonyms": [
      "Herzstillstand mit erfolgreicher Wiederbelebung"
    ]
  },
  {
    "code": "I46.1",
    "name": "Plötzlicher Herztod",
    "synonyms": [
      "Herzsekundentod",
      "Plötzlicher Herztod",
      "Sekundenherztod"
    ]
  },
  {
    "code": "I46.9",
    "name": "Herzstillstand",
    "synonyms": [
      "Asystolie",
      "HKS [Herz-Kreislauf-Stillstand]",
      "Herz-Kreislauf-Stillstand",
      "Herzstillstand",
      "Herzstillstand ohne erfolgreiche Wiederbelebung",
      "Herztod",
      "Kardiorespiratorischer Stillstand",
      "Ventrikulärer Stillstand"
    ]
  },
  {
    "code": "I47.0",
    "name": "Ventrikuläre Arrhythmie durch Reentry",
    "synonyms": [
      "Ventrikuläre Arrhythmie durch Reentry"
    ]
  },
  {
    "code": "I47.1",
    "name": "Supraventrikuläre Tachykardie",
    "synonyms": [
      "AV [Atrioventrikular]-junktionale Tachykardie",
      "AV [Atrioventrikular]-junktionale Vorhoftachykardie",
      "AV [Atrioventrikular]-junktionale paroxysmale Tachykardie",
      "AV [Atrioventrikular]-junktionale supraventrikuläre Tachykardie",
      "AV-Knoten-Reentry-Tachykardie",
      "AV-Reentry-Tachykardie",
      "AVNRT [AV-Knoten-Reentry-Tachykardie]",
      "AVRT [AV-Reentry-Tachykardie]",
      "Atrioventrikuläre paroxysmale Tachykardie",
      "Aurikuläre Tachykardie",
      "Chaotische Vorhoftachykardie",
      "Chaotische atriale Tachykardie",
      "Ektope atriale Tachykardie",
      "His-Bündel-Tachykardie",
      "JET [Junktionale ektope Tachykardie]",
      "Junktionale ektope Tachykardie",
      "MAT [Multifokale atriale Tachykardie]",
      "Multifokale Vorhoftachykardie des Kindes",
      "Multifokale atriale Tachykardie",
      "Nodale Tachykardie",
      "Paroxysmale Knotentachykardie",
      "Paroxysmale Sinustachykardie",
      "Paroxysmale Vorhoftachykardie",
      "Paroxysmale sinuaurikuläre Tachykardie",
      "Supraventrikuläre Tachykardie",
      "Supraventrikuläre paroxysmale Tachykardie",
      "Vorhoftachykardie"
    ]
  },
  {
    "code": "I47.2",
    "name": "Ventrikuläre Tachykardie",
    "synonyms": [
      "AV [Atrioventrikular]-junktionale ventrikuläre Tachykardie",
      "Anhaltende infantile ventrikuläre Tachykardie",
      "Kammertachykardie",
      "Katecholaminerge polymorphe ventrikuläre Tachykardie [CPVT]",
      "Maligne paroxysmale ventrikuläre Tachykardie",
      "Torsade de pointes",
      "Torsade de pointes mit kurzem Kopplungsintervall",
      "Ventrikuläre Tachykardie",
      "Ventrikuläre paroxysmale Tachykardie"
    ]
  },
  {
    "code": "I47.9",
    "name": "Paroxysmale Tachykardie",
    "synonyms": [
      "Anfallsweises Herzjagen",
      "Aurikuläre Form der paroxysmalen Tachykardie - s.a. Bouveret-Hoffmann-Syndrom",
      "Bouveret-Hoffmann-Syndrom",
      "Bouveret-Syndrom",
      "Paroxysmale Tachykardie"
    ]
  },
  {
    "code": "I48.0",
    "name": "Intermittierendes Vorhofflimmern",
    "synonyms": [
      "Intermittierendes Vorhofflimmern",
      "Paroxysmale Tachyarrhythmia absoluta",
      "Paroxysmale Tachyarrhythmia absoluta bei Vorhofflimmern",
      "Paroxysmales Vorhofflimmern"
    ]
  },
  {
    "code": "I48.1",
    "name": "Persistierendes Vorhofflimmern",
    "synonyms": [
      "Persistierendes Vorhofflimmern"
    ]
  },
  {
    "code": "I48.2",
    "name": "Chronisches Vorhofflimmern",
    "synonyms": [
      "Chronisches Vorhofflimmern",
      "Permanentes Vorhofflimmern"
    ]
  },
  {
    "code": "I48.3",
    "name": "Typisches Vorhofflattern",
    "synonyms": [
      "Typisches Vorhofflattern",
      "Vorhofflattern, Typ I"
    ]
  },
  {
    "code": "I48.4",
    "name": "Atypisches Vorhofflattern",
    "synonyms": [
      "Atypisches Vorhofflattern",
      "Vorhofflattern, Typ II"
    ]
  },
  {
    "code": "I48.9",
    "name": "Flimmerarrhythmie des Vorhofs",
    "synonyms": [
      "Absolute Arrhythmie",
      "Absolute Arrhythmie bei Vorhofflimmern",
      "Absolute Bradyarrhythmie",
      "Absolute Tachyarrhythmie",
      "Arrhythmia absoluta",
      "Arrhythmia absoluta bei Vorhofflimmern",
      "Bradyarrhythmia absoluta",
      "Chronisches Vorhofflattern",
      "Familiäres Vorhofflimmern",
      "Flimmerarrhythmie",
      "Flimmerarrhythmie des Vorhofs",
      "Intermittierende Arrhythmia absoluta",
      "Intermittierende absolute Arrhythmie",
      "Paroxysmale Tachyarrhythmia absoluta bei Vorhofflattern",
      "Paroxysmales Vorhofflattern",
      "TAA [Tachyarrhythmia absoluta]",
      "Tachyarrhythmia absoluta",
      "Tachyarrhythmie bei Vorhofflimmern",
      "Vorhofflattern",
      "Vorhofflimmern"
    ]
  },
  {
    "code": "I49.0",
    "name": "Kammerflimmern",
    "synonyms": [
      "Herzflimmern",
      "Herzkammerflimmern",
      "Kammerflattern",
      "Kammerflimmern",
      "Ventrikelflimmern",
      "Ventrikuläre Fibrillation",
      "Ventrikuläre Tachyarrhythmie"
    ]
  },
  {
    "code": "I49.1",
    "name": "Vorhofextrasystolie",
    "synonyms": [
      "Atriale Extrasystolie",
      "Vorhofextrasystolen",
      "Vorhofextrasystolie"
    ]
  },
  {
    "code": "I49.2",
    "name": "AV [Atrioventrikular]-junktionale Extrasystolie",
    "synonyms": [
      "AV [Atrioventrikular]-junktionale Extrasystolie"
    ]
  },
  {
    "code": "I49.3",
    "name": "VES [Ventrikuläre Extrasystolen]",
    "synonyms": [
      "Kammer-Extrasystolie",
      "VES [Ventrikuläre Extrasystolen]",
      "Ventrikuläre Extrasystolie"
    ]
  },
  {
    "code": "I49.4",
    "name": "Extrasystolie",
    "synonyms": [
      "Belastungsinduzierte Extrasystolie",
      "Ektopische Systolen",
      "Extrasystolen",
      "Extrasystolie",
      "Extrasystolische Arrhythmie",
      "SVES [Supraventrikuläre Extrasystolie]",
      "Supraventrikuläre Extrasystolen",
      "Supraventrikuläre Extrasystolie"
    ]
  },
  {
    "code": "I49.5",
    "name": "Kranker Sinusknoten",
    "synonyms": [
      "Familiäre Sinusknotendysfunktion",
      "Familiäres Sick-Sinus-Syndrom",
      "Kranker Sinusknoten",
      "Latentes Sinusknotensyndrom",
      "SSS [Sick-Sinus-Syndrom]",
      "Sick-Sinus-Syndrom",
      "Sick-Sinus-Tachykardie",
      "Sinusknotensyndrom",
      "Tachykardie-Bradykardie-Syndrom"
    ]
  },
  {
    "code": "I49.8",
    "name": "Bradyarrhythmie",
    "synonyms": [
      "AV-Knoten-Arrhythmie",
      "Atriale Arrhythmie",
      "Atriale Fibrillationen",
      "Atrioventrikulärer Knotenrhythmus",
      "Brachyarrhythmie",
      "Bradyarrhythmia",
      "Bradyarrhythmie",
      "Brugada-Syndrom",
      "Ektopischer Rhythmus",
      "Familiäres Long-QT-Syndrom",
      "Familiäres Short-QT-Syndrom",
      "Herzflattern",
      "Heterotoper Rhythmus",
      "Idiopathische Ventrikelfibrillation Typ Brugada",
      "Idiopathisches Kammerflimmern Typ non-Brugada",
      "Jervell-Lange-Nielsen-Syndrom",
      "Kardiale Ionenkanalerkrankung",
      "Knotenrhythmus",
      "Kongenitales Long-QT-Syndrom",
      "Koronarsinusrhythmus",
      "LQT8 [Long-QT-Syndrom Typ 8] Typ 1",
      "LQT8 [Long-QT-Syndrom Typ 8] Typ 2",
      "LQTS [Long QT Syndrom]",
      "Long-QT-Syndrom",
      "Long-QT-Syndrom Typ 8",
      "QT-Syndrom",
      "RWS [Romano-Ward-Syndrom]",
      "Romano-Ward-Long-QT-Syndrom",
      "Romano-Ward-Syndrom",
      "Sinus-coronarius-Rhythmus",
      "Sinusarrhythmie",
      "Syndrom der langen QT-Zeit",
      "Tachyarrhythmie",
      "Timothy-Syndrom",
      "Timothy-Syndrom Typ 1",
      "Timothy-Syndrom Typ 2",
      "Ventrikuläre Arrhythmie",
      "Ventrikuläre Herzrhythmusstörung",
      "Verlängertes QT-Intervall mit Schwerhörigkeit",
      "Wandernder Herzschrittmacher"
    ]
  },
  {
    "code": "I49.9",
    "name": "Herzstolpern",
    "synonyms": [
      "Abnormer Herzrhythmus",
      "Allorhythmie",
      "Arrhythmia",
      "Arrhythmia cordis",
      "Arrhythmie",
      "Funktionelle Herzrhythmusstörung",
      "Herzrhythmusstörung",
      "Herzstolpern",
      "Irreguläre Herztätigkeit",
      "Kardiale Arrhythmie",
      "Kardiale Dysrhythmie",
      "Kardiale Rhythmusstörung",
      "Respiratorische Arrhythmie",
      "Rhythmusstörung",
      "SADS [Sudden Arrhythmic Death Syndrome]",
      "Tachykarde Herzrhythmusstörung"
    ]
  },
  {
    "code": "I50.00",
    "name": "Primäre Rechtsherzinsuffizienz",
    "synonyms": [
      "Primäre Rechtsherzinsuffizienz"
    ]
  },
  {
    "code": "I50.01",
    "name": "Kardialer Aszites",
    "synonyms": [
      "Bernheim-Syndrom",
      "Biventrikuläre Herzinsuffizienz",
      "Dekompensierte Rechtsherzinsuffizienz",
      "Dekompensierte globale Herzinsuffizienz",
      "Dekompensierte kardiale Stauungsinsuffizienz",
      "Globale Herzinsuffizienz",
      "Globales Herzversagen",
      "Herzinsuffizienz mit Globaldekompensation",
      "Herzinsuffizienz mit peripherem Ödem",
      "Herzstauung",
      "Herzwassersucht",
      "Herzödem",
      "Kardiale Anasarka",
      "Kardiale Globalinsuffizienz",
      "Kardiale Stase",
      "Kardiale Stauung",
      "Kardiale Stauungsinsuffizienz",
      "Kardialer Aszites",
      "Kardialer Hydrops",
      "Kardiales peripheres Ödem",
      "Kardiovaskuläres Ödem bei Herzinsuffizienz",
      "Kongestive Herzkrankheit",
      "Kongestive Rechtsherzinsuffizienz",
      "Kongestives Herzversagen",
      "Myokardiales Versagen mit Stauungserscheinungen",
      "Myokardschwäche mit peripherem Ödem",
      "Rechtsherzinsuffizienz",
      "Rechtsherzversagen",
      "Rechtsherzversagen als Folge einer Linksherzinsuffizienz",
      "Sekundäre Rechtsherzinsuffizienz",
      "Sekundäre Rechtsherzinsuffizienz nach Linksherzinsuffizienz",
      "Stauungsherzversagen",
      "Stauungsinsuffizienz",
      "Stauungsinsuffizienz des Herzens"
    ]
  },
  {
    "code": "I50.11",
    "name": "Linksherzinsuffizienz ohne Beschwerden",
    "synonyms": [
      "Asymptomatische linksventrikuläre Dysfunktion",
      "Linksherzinsuffizienz ohne Beschwerden",
      "Linksherzinsuffizienz, NYHA-Stadium I"
    ]
  },
  {
    "code": "I50.12",
    "name": "Linksherzinsuffizienz, NYHA-Stadium II",
    "synonyms": [
      "Linksherzinsuffizienz mit Beschwerden bei stärkerer Belastung",
      "Linksherzinsuffizienz, NYHA-Stadium II"
    ]
  },
  {
    "code": "I50.13",
    "name": "Linksherzinsuffizienz mit Beschwerden bei leichterer Belastung",
    "synonyms": [
      "Linksherzinsuffizienz mit Beschwerden bei leichterer Belastung",
      "Linksherzinsuffizienz, NYHA-Stadium III"
    ]
  },
  {
    "code": "I50.14",
    "name": "Herzinsuffizienz mit Lungenödem",
    "synonyms": [
      "Akutes Lungenödem bei Herzinsuffizienz",
      "Akutes Lungenödem bei Herzkrankheit",
      "Herzinsuffizienz mit Lungenödem",
      "Linksherzinsuffizienz mit Beschwerden in Ruhe",
      "Linksherzinsuffizienz, NYHA-Stadium IV"
    ]
  },
  {
    "code": "I50.19",
    "name": "Linksherzinsuffizienz",
    "synonyms": [
      "Asthma cardiale",
      "Asthma cardiobronchiale",
      "Dekompensierte Linksherzinsuffizienz",
      "Diastolische Herzinsuffizienz",
      "Eingeschränkte linksventrikuläre Herzfunktion",
      "HFmrEF [Herzinsuffizienz mit geringgradig eingeschränkter linksventrikulärer Ejektionsfraktion]",
      "HFpEF [Herzinsuffizienz mit erhaltener linksventrikulärer Ejektionsfraktion]",
      "HFrEF [Herzinsuffizienz mit reduzierter linksventrikulärer Ejektionsfraktion]",
      "Herzasthma",
      "Kardiale Dyspnoe",
      "Kardiopulmonale Stauung",
      "Linksherzbelastung",
      "Linksherzdekompensation",
      "Linksherzinsuffizienz",
      "Linksherzversagen",
      "Linksventrikuläre Dysfunktion",
      "Stauungslunge bei Herzinsuffizienz"
    ]
  },
  {
    "code": "I50.9",
    "name": "Insufficientia cordis",
    "synonyms": [
      "Akute Herzinsuffizienz",
      "Akute Herzleistungsschwäche",
      "Akutes Herzversagen",
      "Altersbedingte Herzschwäche",
      "Altersherzinsuffizienz",
      "Arteriosklerotische Herzinsuffizienz",
      "Belastungsherzinsuffizienz",
      "Chronische Herzinsuffizienz",
      "Chronische Herzmuskelinsuffizienz",
      "Chronische Myokardinsuffizienz",
      "Chronische kardiale Insuffizienz",
      "Chronisches kardiovaskuläres Versagen",
      "Chronisches myokardiales Versagen",
      "Dekompensierte Herzinsuffizienz",
      "Dekompensierte Herzmuskelschwäche",
      "Dekompensierte Myokardinsuffizienz",
      "Dekompensierter Herzmuskelschaden",
      "Herz-Kreislauf-Insuffizienz",
      "Herz-Kreislauf-Versagen",
      "Herzasthenie",
      "Herzerschöpfung",
      "Herzinsuffizienz",
      "Herzkollaps",
      "Herzkrise",
      "Herzleistungsschwäche",
      "Herzmuskelinsuffizienz",
      "Herzmuskelschwäche",
      "Herzmuskelschwäche im Alter",
      "Herzmuskelversagen",
      "Herzparalyse",
      "Herzschwäche",
      "Herzversagen",
      "High-Output-Herzinsuffizienz",
      "Insufficientia cordis",
      "Kardiale Asthenie",
      "Kardiale Erschöpfung",
      "Kardiale Insuffizienz",
      "Kardiale Schwäche",
      "Kardiales Versagen",
      "Kardiovaskuläre Asthenie",
      "Kardiovaskuläre Insuffizienz",
      "Kompensierte Herzinsuffizienz",
      "Muskuläre Herzinsuffizienz",
      "Myokardermüdung",
      "Myokarderschöpfung",
      "Myokardiale Asthenie",
      "Myokardiale Erschöpfung",
      "Myokardiale Insuffizienz",
      "Myokardiales Versagen",
      "Myokardinsuffizienz",
      "Myokardschwäche",
      "Plötzliches Herzversagen",
      "Rückwärts- und Vorwärtsversagen bei Herzinsuffizienz",
      "Senile Herzinsuffizienz",
      "Seniles Herzversagen",
      "Ventrikelinsuffizienz",
      "Ventrikuläres Versagen"
    ]
  },
  {
    "code": "I51.0",
    "name": "Erworbener Ventrikelseptumdefekt",
    "synonyms": [
      "Alter erworbener Herzohrseptumdefekt",
      "Alter erworbener Kammerseptumdefekt",
      "Alter erworbener Vorhofseptumdefekt",
      "Erworbener Herzseptumdefekt",
      "Erworbener Herzseptumdefekt der Kammer",
      "Erworbener Herzseptumdefekt des Herzohres",
      "Erworbener Herzseptumdefekt des Vorhofs",
      "Erworbener Ventrikelseptumdefekt"
    ]
  },
  {
    "code": "I51.1",
    "name": "Ruptur der Chordae tendineae a.n.k.",
    "synonyms": [
      "Lazeration der Chordae tendineae a.n.k.",
      "Ruptur der Chordae tendineae a.n.k."
    ]
  },
  {
    "code": "I51.2",
    "name": "Papillarmuskelruptur a.n.k.",
    "synonyms": [
      "Papillarmuskelruptur a.n.k."
    ]
  },
  {
    "code": "I51.3",
    "name": "Vorhofthrombose",
    "synonyms": [
      "Alte Herzkammerthrombose",
      "Alte Herzohrthrombose",
      "Alte Herzspitzenthrombose",
      "Alte Vorhofthrombose",
      "Herzohrthrombose",
      "Herzspitzenthrombose",
      "Intrakardiale Thrombose a.n.k.",
      "Kammerthrombose",
      "Thrombose einer Herzkammer",
      "Thrombose eines Herzvorhofs",
      "Thrombus im linken Herz",
      "Vorhofthrombose"
    ]
  },
  {
    "code": "I51.4",
    "name": "Chronische Myokarditis",
    "synonyms": [
      "Alte Myokarditis",
      "Begleitmyokarditis",
      "Chronische Myokarditis",
      "Chronische interstitielle Myokarditis",
      "Fibroide Herzkrankheit",
      "Fibröse Myokarditis",
      "Herzfibroid",
      "Herzfibrose",
      "Herzmuskelentzündung",
      "Interstitielle Myokarditis",
      "Kardiale Fibrose",
      "Myofibrosis cordis",
      "Myokardentzündung",
      "Myokardfibrose",
      "Myokarditis",
      "Myokarditis mit Arteriosklerose",
      "Panmyokarditis",
      "Progressive Myokarditis",
      "Senile Myokarditis"
    ]
  },
  {
    "code": "I51.5",
    "name": "Endokardverfettung",
    "synonyms": [
      "Atrophia fusca",
      "Braune Herzmuskelatrophie",
      "Cor adiposum",
      "Degenerative Herzinsuffizienz",
      "Endokardverfettung",
      "Fettherz",
      "Fettige Herzdegeneration",
      "Fettige Herzhypertrophie",
      "Fettige Herzinfiltration",
      "Fettige Myokarddegeneration",
      "Herzdegeneration",
      "Herzerweichung",
      "Herzkalzifikation",
      "Herzmuskelatrophie",
      "Herzmuskeldegeneration",
      "Herzmuskelerkrankung",
      "Herzmuskelkrankheit",
      "Herzmuskelschaden",
      "Herzmuskelverkalkung",
      "Herzossifikation",
      "Herzsteatose",
      "Herzverfettung",
      "Kardiale Atrophie",
      "Kardiale Degeneration",
      "Kardiale Kalzifikation",
      "Kardiale Ossifikation",
      "Kardiomalazie",
      "Murale Herzdegeneration",
      "Myodegeneratio cordis",
      "Myokardatrophie",
      "Myokarddefekt",
      "Myokarddegeneration",
      "Myokarddystrophie",
      "Myokardiale Erweichung",
      "Myokardiale Krankheit",
      "Myokardkalzifikation",
      "Myokardkrankheit",
      "Myokardossifikation",
      "Myokardschaden",
      "Myokardstenose",
      "Myokardverfettung",
      "Myokardverkalkung",
      "Myomalacia cordis",
      "Senile Herzdegeneration",
      "Senile Myokarddegeneration",
      "Subendokardiale Schädigung"
    ]
  },
  {
    "code": "I51.6",
    "name": "Herz-Kreislauf-Krankheit",
    "synonyms": [
      "Funktionelle Herz-Kreislauf-Beschwerden",
      "Funktionelle kardiovaskuläre Störung",
      "Herz-Kreislauf-Beschwerden",
      "Herz-Kreislauf-Krankheit",
      "Herz-Kreislauf-Störung",
      "Herzanfall",
      "Kardiovaskuläre Degeneration",
      "Kardiovaskuläre Dekompensation",
      "Kardiovaskuläre Krankheit",
      "Kardiovaskuläre Sklerose",
      "Kardiovaskuläre Stenose",
      "Kardiovaskuläre Störung"
    ]
  },
  {
    "code": "I51.7",
    "name": "Kardiomegalie",
    "synonyms": [
      "Akute Herzdilatation",
      "Atriomegalie",
      "Biventrikulär hypertrophiertes Herz",
      "Biventrikuläre Herzhypertrophie",
      "Chronische Herzdilatation",
      "Chronische Herzhypertrophie",
      "Cor bovinum",
      "Dilatatio cordis",
      "Dilatative Herzkrankheit",
      "Herzdilatation",
      "Herzhypertrophie",
      "Herzmuskelhypertrophie",
      "Herzventrikelhypertrophie",
      "Herzvergrößerung",
      "Herzvorhofdilatation",
      "Idiopathische Kardiomegalie",
      "Kardiale Dilatation",
      "Kardiale Hypertrophie",
      "Kardiomegalie",
      "Konzentrische Linksherzhypertrophie",
      "Linksherzhypertrophie",
      "Linksherzvergrößerung",
      "Linksventrikuläre Hypertrophie",
      "Myokardhypertrophie",
      "Rechtsherzdilatation",
      "Rechtsherzhypertrophie",
      "Sportlerherz",
      "Ventrikeldilatation",
      "Ventrikelerweiterung"
    ]
  },
  {
    "code": "I51.8",
    "name": "Karditis",
    "synonyms": [
      "Akute Karditis",
      "Akute Pankarditis",
      "Alkoholbedingte Dysfunktion des Herzens",
      "Chronische Karditis",
      "Chronische Pankarditis",
      "Dysfunktion der Papillarmuskeln",
      "Dysfunktion des Herzens",
      "Dyskardie",
      "Endokardblutung",
      "Erworbene Herzverlagerung",
      "Funktionelle Herzbeschwerden",
      "Funktionelle Herzkrankheit",
      "Herzabszess",
      "Herzbeklemmung",
      "Herzblutung",
      "Herzentzündung",
      "Herzfunktionsstörung",
      "Herzhyperkinesie",
      "Herzhämorrhagie",
      "Herzinfektion",
      "Hyperkinetische Herzkrankheit",
      "Hyperkinetisches Herzsyndrom",
      "Hypostatische Herzkrankheit",
      "Kardiale Dysfunktion",
      "Karditis",
      "Myokardblutung",
      "Pankarditis",
      "Subakute Karditis"
    ]
  },
  {
    "code": "I51.9",
    "name": "Herzkrankheit",
    "synonyms": [
      "Akute kardiale Dekompensation",
      "Altersherzdekompensation",
      "Biventrikuläre Herzdekompensation",
      "Biventrikuläre Myokarddekompensation",
      "Chronische kardiale Dekompensation",
      "Decompensatio cordis",
      "Dekompensiertes Herz",
      "HK [Herzkomplikation] - s.a. Herzkrankheit",
      "Herzbeschwerden",
      "Herzdekompensation",
      "Herzkomplikation",
      "Herzkrankheit",
      "Herzschaden",
      "Herzstriktur",
      "Kardiale Dekompensation",
      "Kardiale Komplikation",
      "Kardialer Schaden",
      "Kardiopathie",
      "Morbus cordis",
      "Myokardiale Dekompensation",
      "Polymorphe Kardiopathie"
    ]
  },
  {
    "code": "I60.0",
    "name": "Ins Gehirn rupturiertes Karotisaneurysma",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Karotisaneurysma",
      "Ins Gehirn rupturiertes Karotisaneurysma",
      "Subarachnoidale Blutung, ausgehend von Karotissiphon und Bifurkation",
      "Subarachnoidale Hämorrhagie, ausgehend von Karotissiphon und Bifurkation"
    ]
  },
  {
    "code": "I60.1",
    "name": "Subarachnoidalblutung der Arteria cerebri media",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma der Arteria cerebri media",
      "Subarachnoidalblutung der Arteria cerebri media"
    ]
  },
  {
    "code": "I60.2",
    "name": "Subarachnoidalblutung der Arteria communicans anterior",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma der Arteria communicans anterior",
      "Subarachnoidalblutung der Arteria communicans anterior"
    ]
  },
  {
    "code": "I60.3",
    "name": "Subarachnoidalblutung der Arteria communicans posterior",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma der Arteria communicans posterior",
      "Subarachnoidalblutung der Arteria communicans posterior"
    ]
  },
  {
    "code": "I60.4",
    "name": "Subarachnoidalblutung der Arteria basilaris",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma der Arteria basilaris",
      "Subarachnoidalblutung der Arteria basilaris"
    ]
  },
  {
    "code": "I60.5",
    "name": "Subarachnoidalblutung der Arteria vertebralis",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma der Arteria vertebralis",
      "Subarachnoidalblutung der Arteria vertebralis"
    ]
  },
  {
    "code": "I60.6",
    "name": "Ruptur des Circulus arteriosus cerebri",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma des Circulus arteriosus cerebri",
      "Ruptur des Circulus arteriosus cerebri",
      "Rupturierte zerebrale Aneurysmen mehrerer intrakranieller Arterien",
      "Rupturiertes Aneurysma des Circulus arteriosus cerebri",
      "Rupturiertes angeborenes Aneurysma des Circulus arteriosus",
      "Subarachnoidalblutung aus mehreren intrakraniellen Arterien"
    ]
  },
  {
    "code": "I60.7",
    "name": "Hirnarterienaneurysmaruptur",
    "synonyms": [
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma einer Arteria communicans",
      "Hirnarterienaneurysmaruptur",
      "Rupturierte zerebrale Arteriendissektion",
      "Rupturiertes arteriosklerotisches Gehirnaneurysma",
      "Rupturiertes arteriosklerotisches zerebrales Aneurysma",
      "Rupturiertes zerebrales Aneurysma einer Arteria communicans",
      "Rupturiertes zerebrales Aneurysma einer Hirnarterie",
      "Subarachnoidalblutung aus einer Arteria communicans",
      "Subarachnoidalblutung aus einer Hirnarterie"
    ]
  },
  {
    "code": "I60.8",
    "name": "Meningealblutung",
    "synonyms": [
      "Blutung der Gehirnmeningen",
      "Erworbene Subarachnoidalblutung durch rupturiertes Aneurysma des Sinus cavernosus",
      "Hirnhautblutung",
      "Hirnhauthämorrhagie",
      "Meningealblutung",
      "Meningenblutung",
      "Meningenhämorrhagie",
      "Ruptur einer Meningenarterie",
      "Ruptur einer arteriovenösen Fistel des Gehirns",
      "Ruptur einer zerebralen arteriovenösen Fehlbildung",
      "Rupturierte kongenitale arteriovenöse Gehirnfistel",
      "Rupturiertes Aneurysma der Gehirnmeningen",
      "Rupturiertes arteriovenöses Aneurysma des Sinus cavernosus",
      "Rupturiertes arteriovenöses Gehirnaneurysma",
      "Rupturiertes erworbenes arteriovenöses Gehirnaneurysma",
      "Rupturiertes zerebrales arteriovenöses Aneurysma",
      "Subarachnoidale Blutung, ausgehend vom Sinus cavernosus",
      "Subarachnoidale Hämorrhagie, ausgehend vom Sinus cavernosus"
    ]
  },
  {
    "code": "I60.9",
    "name": "Ruptur eines zerebralen Aneurysmas",
    "synonyms": [
      "Angeborenes rupturiertes zerebrales Aneurysma",
      "Angeborenes rupturiertes zerebrales sackförmiges Aneurysma",
      "Arachnoidalblutung",
      "Erworbene aneurysmatische Subarachnoidalblutung",
      "Hämorrhagische Apoplexie der Meningen",
      "Kongenitales rupturiertes zerebrales Aneurysma",
      "Leptomeninxblutung",
      "Nichttraumatische Subarachnoidalblutung",
      "Nichttraumatische subarachnoidale Hämorrhagie",
      "Nichttraumatisches Subarachnoidalhämatom",
      "Ruptur eines zerebralen Aneurysmas",
      "Rupturiertes Gehirnaneurysma",
      "Rupturiertes beerenförmiges Gehirnaneurysma",
      "Rupturiertes kongenitales Gehirnaneurysma",
      "Rupturiertes miliares Aneurysma",
      "Rupturiertes mykotisches Gehirnaneurysma",
      "Rupturiertes zerebrales Aneurysma",
      "Rupturiertes zerebrales sackförmiges Aneurysma",
      "SAB [Subarachnoidalblutung]",
      "SAB [Subarachnoidalblutung] durch rupturiertes zerebrales Aneurysma",
      "Subarachnoidalblutung",
      "Subarachnoidalblutung durch rupturiertes zerebrales Aneurysma",
      "Subarachnoidalhämatom"
    ]
  },
  {
    "code": "I61.0",
    "name": "Stammganglienblutung",
    "synonyms": [
      "Basalganglienblutung",
      "Basalganglienhämorrhagie",
      "Basiläre Blutung",
      "Basiläre Hämorrhagie",
      "Blutung der Arteriae lenticulostriatae",
      "Blutung der Capsula interna",
      "Blutung des Corpus Luysi",
      "Blutung des Nucleus subthalamicus",
      "Hämorrhagie der Arteriae lenticulostriatae",
      "Hämorrhagie der Capsula interna",
      "Hämorrhagie des Corpus Luysi",
      "Hämorrhagie des Nucleus subthalamicus",
      "Schlaganfall durch subkortikale Blutung in die Großhirnhemisphäre",
      "Stammganglienblutung",
      "Subkortikale Gehirnblutung",
      "Subkortikale Hämorrhagie des Gehirns",
      "Subkortikale intrazerebrale Blutung der Großhirnhemisphäre",
      "Thalamusblutung",
      "Tiefe intrazerebrale Blutung",
      "Tiefe intrazerebrale Hämorrhagie"
    ]
  },
  {
    "code": "I61.1",
    "name": "Hirnrindenblutung",
    "synonyms": [
      "Hirnrindenblutung",
      "Kortikale Blutung im Gehirn",
      "Kortikale Hämorrhagie im Gehirn",
      "Kortikale intrazerebrale Blutung der Großhirnhemisphäre",
      "Oberflächliche intrazerebrale Blutung",
      "Oberflächliche intrazerebrale Hämorrhagie",
      "Schlaganfall durch kortikale Blutung in die Großhirnhemisphäre",
      "Zerebrale Lobusblutung",
      "Zerebrale Lobushämorrhagie"
    ]
  },
  {
    "code": "I61.2",
    "name": "Intrazerebrale Blutung in die Großhirnhemisphäre",
    "synonyms": [
      "Intrazerebrale Blutung in die Großhirnhemisphäre"
    ]
  },
  {
    "code": "I61.3",
    "name": "Intrazerebrale Hirnstammblutung",
    "synonyms": [
      "Blutung der Medulla oblongata",
      "Blutung der Pons",
      "Blutung der Pons cerebri",
      "Blutung des Mesenzephalons",
      "Bulbäre Blutung",
      "Bulbäre Hämorrhagie",
      "Hirnstammblutung",
      "Hämorrhagie der Medulla oblongata",
      "Hämorrhagie der Pons",
      "Hämorrhagie des Mesenzephalons",
      "Intrapontine Blutung",
      "Intrapontine Hämorrhagie",
      "Intrazerebrale Hirnstammblutung",
      "Intrazerebrale Hirnstammhämorrhagie",
      "Pontine Blutung",
      "Pontine Hämorrhagie",
      "Schlaganfall durch Hirnstammblutung",
      "Stammhirnblutung"
    ]
  },
  {
    "code": "I61.4",
    "name": "Intrazerebrale Kleinhirnblutung",
    "synonyms": [
      "Intrazerebrale Kleinhirnblutung",
      "Intrazerebrale Kleinhirnhämorrhagie",
      "Intrazerebrale Zerebellumhämorrhagie",
      "Kleinhirnblutung",
      "Nichttraumatische Kleinhirnblutung",
      "Nichttraumatische Kleinhirnhämorrhagie",
      "Nichttraumatische zerebellare Blutung",
      "Nichttraumatische zerebellare Hämorrhagie",
      "Schlaganfall durch Kleinhirnblutung"
    ]
  },
  {
    "code": "I61.5",
    "name": "Ventrikelblutung",
    "synonyms": [
      "Haematocephalus internus",
      "Hämatozephalus",
      "Intraventrikuläre Blutung",
      "Intraventrikuläre Gehirnblutung",
      "Intraventrikuläre Hirnblutung",
      "Intraventrikuläre Hämorrhagie",
      "Intrazerebrale intraventrikuläre Blutung",
      "Schlaganfall durch intrazerebrale intraventrikuläre Blutung",
      "Ventrikelblutung",
      "Ventrikuläre Blutung",
      "Ventrikuläre Hämorrhagie"
    ]
  },
  {
    "code": "I61.6",
    "name": "Zerebrale Massenblutung",
    "synonyms": [
      "Apoplektische Hirnmassenblutung",
      "Multiple intrazerebrale Blutungen",
      "Multiple umschriebene intrazerebrale Blutungen",
      "Multiple umschriebene intrazerebrale Hämorrhagien",
      "Zerebrale Massenblutung"
    ]
  },
  {
    "code": "I61.8",
    "name": "Zerebromeningeale Hämorrhagie",
    "synonyms": [
      "Nichttraumatische Blutung der Fossa cranii posterior",
      "Nichttraumatische Hämorrhagie der Fossa cranii posterior",
      "Zerebromeningeale Blutung",
      "Zerebromeningeale Hämorrhagie"
    ]
  },
  {
    "code": "I61.9",
    "name": "Gehirnblutung",
    "synonyms": [
      "Apoplektische Blutung",
      "Apoplektische Hämorrhagie",
      "Arterienruptur des Gehirns",
      "Blutgefäßruptur des Gehirns",
      "Blutung bei Schlaganfall",
      "Enzephalorrhagie",
      "Gehirnblutung",
      "Gehirnhämorrhagie",
      "Hirnblutung",
      "Hirngefäßruptur",
      "Hämorrhagie bei Schlaganfall",
      "Hämorrhagische Apoplexie",
      "Hämorrhagische Enzephalomalazie",
      "Intrazerebrale Blutung",
      "Intrazerebrale Hämorrhagie",
      "Nichttraumatische miliare Gehirnblutung",
      "Nichttraumatische miliare Gehirnhämorrhagie",
      "Nichttraumatisches Gehirnhämatom",
      "Zerebrale Blutung",
      "Zerebrale Hämorrhagie",
      "Zerebrospinale Blutung",
      "Zerebrospinale Hämorrhagie",
      "Zerebrovaskuläre Blutung"
    ]
  },
  {
    "code": "I62.00",
    "name": "Akute nichttraumatische subdurale Hämorrhagie",
    "synonyms": [
      "Akute nichttraumatische subdurale Blutung",
      "Akute nichttraumatische subdurale Hämorrhagie"
    ]
  },
  {
    "code": "I62.01",
    "name": "Subakute nichttraumatische subdurale Blutung",
    "synonyms": [
      "Subakute nichttraumatische subdurale Blutung"
    ]
  },
  {
    "code": "I62.02",
    "name": "Chronisches nichttraumatisches subdurales Hämatom",
    "synonyms": [
      "Chronische nichttraumatische subdurale Blutung",
      "Chronisches nichttraumatisches subdurales Hämatom"
    ]
  },
  {
    "code": "I62.09",
    "name": "Nichttraumatisches subdurales Hämatom",
    "synonyms": [
      "Nichttraumatische Subduralblutung",
      "Nichttraumatisches subdurales Hämatom"
    ]
  },
  {
    "code": "I62.1",
    "name": "Nichttraumatisches epidurales Hämatom",
    "synonyms": [
      "Nichttraumatische epidurale Blutung",
      "Nichttraumatische epidurale Hämorrhagie",
      "Nichttraumatische extradurale Blutung",
      "Nichttraumatische extradurale Hämorrhagie",
      "Nichttraumatisches epidurales Hämatom",
      "Nichttraumatisches extradurales Hämatom"
    ]
  },
  {
    "code": "I62.9",
    "name": "Intrakranielle Hämorrhagie",
    "synonyms": [
      "Intrakranielle Blutung",
      "Intrakranielle Hämorrhagie",
      "Kranielle Blutung",
      "Kranielle Hämorrhagie",
      "Nichttraumatische intrakranielle Blutung"
    ]
  },
  {
    "code": "I63.0",
    "name": "Hirninfarkt durch Thrombose einer extrakraniellen hirnversorgenden Arterie",
    "synonyms": [
      "Gehirninfarkt durch Thrombose der Arteria basilaris",
      "Gehirninfarkt durch Thrombose der Arteria carotis",
      "Gehirninfarkt durch Thrombose der Arteria vertebralis",
      "Gehirninfarkt durch Thrombose einer extrakraniellen hirnversorgenden Arterie",
      "Hirninfarkt durch Thrombose der Arteria basilaris",
      "Hirninfarkt durch Thrombose der Arteria carotis",
      "Hirninfarkt durch Thrombose der Arteria vertebralis",
      "Hirninfarkt durch Thrombose des Truncus brachiocephalicus",
      "Hirninfarkt durch Thrombose einer extrakraniellen hirnversorgenden Arterie",
      "Schlaganfall durch Thrombose präzerebraler Arterien",
      "Thrombotische Apoplexie einer extrakraniellen hirnversorgenden Arterie"
    ]
  },
  {
    "code": "I63.1",
    "name": "Hirninfarkt durch Embolie einer extrakraniellen hirnversorgenden Arterie",
    "synonyms": [
      "Embolische Apoplexie einer extrakraniellen hirnversorgenden Arterie",
      "Gehirninfarkt durch Embolie der Arteria basilaris",
      "Gehirninfarkt durch Embolie der Arteria carotis",
      "Gehirninfarkt durch Embolie der Arteria vertebralis",
      "Gehirninfarkt durch Embolie einer extrakraniellen hirnversorgenden Arterie",
      "Hirninfarkt durch Embolie der Arteria basilaris",
      "Hirninfarkt durch Embolie der Arteria carotis",
      "Hirninfarkt durch Embolie der Arteria vertebralis",
      "Hirninfarkt durch Embolie des Truncus brachiocephalicus",
      "Hirninfarkt durch Embolie einer extrakraniellen hirnversorgenden Arterie",
      "Schlaganfall durch Embolie präzerebraler Arterien"
    ]
  },
  {
    "code": "I63.2",
    "name": "Hirninfarkt durch komplette Obstruktion der Arteria basilaris",
    "synonyms": [
      "Gehirninfarkt durch Obstruktion der Arteria basilaris",
      "Gehirninfarkt durch Obstruktion der Arteria carotis",
      "Gehirninfarkt durch Obstruktion der Arteria vertebralis",
      "Gehirninfarkt durch Stenose einer extrakraniellen hirnversorgenden Arterie",
      "Gehirninfarkt durch Verschluss der Arteria basilaris",
      "Gehirninfarkt durch Verschluss der Arteria carotis",
      "Gehirninfarkt durch Verschluss der Arteria vertebralis",
      "Gehirninfarkt durch Verschluss einer extrakraniellen hirnversorgenden Arterie",
      "Gehirninfarkt durch komplette Obstruktion der Arteria basilaris",
      "Gehirninfarkt durch komplette Obstruktion der Arteria carotis",
      "Gehirninfarkt durch komplette Obstruktion der Arteria vertebralis",
      "Gehirninfarkt durch partielle Obstruktion der Arteria basilaris",
      "Gehirninfarkt durch partielle Obstruktion der Arteria carotis",
      "Gehirninfarkt durch partielle Obstruktion der Arteria vertebralis",
      "Hirninfarkt durch Obstruktion der Arteria basilaris",
      "Hirninfarkt durch Obstruktion der Arteria carotis",
      "Hirninfarkt durch Obstruktion der Arteria vertebralis",
      "Hirninfarkt durch Stenose des Truncus brachiocephalicus",
      "Hirninfarkt durch Stenose einer extrakraniellen hirnversorgenden Arterie",
      "Hirninfarkt durch Verschluss der Arteria basilaris",
      "Hirninfarkt durch Verschluss der Arteria carotis",
      "Hirninfarkt durch Verschluss der Arteria vertebralis",
      "Hirninfarkt durch Verschluss des Truncus brachiocephalicus",
      "Hirninfarkt durch Verschluss einer extrakraniellen hirnversorgenden Arterie",
      "Hirninfarkt durch komplette Obstruktion der Arteria basilaris",
      "Hirninfarkt durch komplette Obstruktion der Arteria carotis",
      "Hirninfarkt durch komplette Obstruktion der Arteria vertebralis",
      "Hirninfarkt durch partielle Obstruktion der Arteria basilaris",
      "Hirninfarkt durch partielle Obstruktion der Arteria carotis",
      "Hirninfarkt durch partielle Obstruktion der Arteria vertebralis"
    ]
  },
  {
    "code": "I63.3",
    "name": "Hirninfarkt durch Thrombose einer intrakraniellen Arterie",
    "synonyms": [
      "Akute thrombotische zerebrovaskuläre Krankheit",
      "Gehirninfarkt durch Thrombose der Arteria cerebelli",
      "Gehirninfarkt durch Thrombose der Arteria cerebri anterior",
      "Gehirninfarkt durch Thrombose der Arteria cerebri media",
      "Gehirninfarkt durch Thrombose der Arteria cerebri posterior",
      "Gehirninfarkt durch Thrombose der Arteriae perforantes",
      "Gehirninfarkt durch Thrombose einer Zerebralarterie",
      "Gehirninfarkt durch Thrombose einer intrakraniellen Arterie",
      "Hirninfarkt durch Thrombose der Arteria cerebelli",
      "Hirninfarkt durch Thrombose der Arteria cerebri anterior",
      "Hirninfarkt durch Thrombose der Arteria cerebri media",
      "Hirninfarkt durch Thrombose der Arteria cerebri posterior",
      "Hirninfarkt durch Thrombose der Arteriae perforantes",
      "Hirninfarkt durch Thrombose einer Zerebralarterie",
      "Hirninfarkt durch Thrombose einer intrakraniellen Arterie",
      "Ischämischer Schlaganfall durch Thrombose einer intrakraniellen Arterie im Kindesalter",
      "Schlaganfall durch Thrombose zerebraler Arterien",
      "Thrombotische Apoplexie",
      "Thrombotische Apoplexie einer intrakraniellen Arterie",
      "Thrombotische Enzephalomalazie",
      "Thrombotische Paralyse"
    ]
  },
  {
    "code": "I63.4",
    "name": "Hirninfarkt durch Embolie einer intrakraniellen Arterie",
    "synonyms": [
      "Embolische Apoplexie",
      "Embolische Apoplexie einer intrakraniellen Arterie",
      "Embolische Enzephalomalazie",
      "Embolische Paralyse",
      "Embolischer Gehirninfarkt",
      "Embolischer Hirninfarkt",
      "Embolischer Kleinhirninfarkt",
      "Embolischer Zerebelluminfarkt",
      "Embolischer zerebellarer Infarkt",
      "Gehirninfarkt durch Embolie der Arteria cerebelli",
      "Gehirninfarkt durch Embolie der Arteria cerebri anterior",
      "Gehirninfarkt durch Embolie der Arteria cerebri media",
      "Gehirninfarkt durch Embolie der Arteria cerebri posterior",
      "Gehirninfarkt durch Embolie der Arteriae perforantes",
      "Gehirninfarkt durch Embolie einer Zerebralarterie",
      "Gehirninfarkt durch Embolie einer intrakraniellen Arterie",
      "Hirninfarkt durch Embolie der Arteria cerebelli",
      "Hirninfarkt durch Embolie der Arteria cerebri anterior",
      "Hirninfarkt durch Embolie der Arteria cerebri media",
      "Hirninfarkt durch Embolie der Arteria cerebri posterior",
      "Hirninfarkt durch Embolie der Arteriae perforantes",
      "Hirninfarkt durch Embolie einer Zerebralarterie",
      "Hirninfarkt durch Embolie einer intrakraniellen Arterie",
      "Ischämischer Schlaganfall durch Embolie zerebraler Arterien im Kindesalter",
      "Schlaganfall durch Embolie zerebraler Arterien",
      "Zerebrale Mikroembolie"
    ]
  },
  {
    "code": "I63.5",
    "name": "Mediainfarkt",
    "synonyms": [
      "Gehirninfarkt durch Obstruktion der Arteria cerebri anterior",
      "Gehirninfarkt durch Obstruktion der Arteria cerebri media",
      "Gehirninfarkt durch Obstruktion der Arteria cerebri posterior",
      "Gehirninfarkt durch Obstruktion der Arteriae cerebelli",
      "Gehirninfarkt durch Stenose der Arteria cerebri anterior",
      "Gehirninfarkt durch Stenose der Arteria cerebri media",
      "Gehirninfarkt durch Stenose der Arteria cerebri posterior",
      "Gehirninfarkt durch Stenose der Arteriae cerebelli",
      "Gehirninfarkt durch Stenose der Stammganglienarterien",
      "Gehirninfarkt durch Stenose einer intrakraniellen Arterie",
      "Gehirninfarkt durch Verschluss der Arteria cerebri anterior",
      "Gehirninfarkt durch Verschluss der Arteria cerebri media",
      "Gehirninfarkt durch Verschluss der Arteria cerebri posterior",
      "Gehirninfarkt durch Verschluss der Arteriae cerebelli",
      "Gehirninfarkt durch Verschluss der Arteriae perforantes",
      "Gehirninfarkt durch Verschluss der Stammganglienarterien",
      "Gehirninfarkt durch Verschluss einer intrakraniellen Arterie",
      "Gehirninfarkt durch komplette Obstruktion der Arteria cerebri anterior",
      "Gehirninfarkt durch komplette Obstruktion der Arteria cerebri media",
      "Gehirninfarkt durch komplette Obstruktion der Arteria cerebri posterior",
      "Gehirninfarkt durch komplette Obstruktion der Arteriae cerebelli",
      "Gehirninfarkt durch partielle Obstruktion der Arteria cerebri anterior",
      "Gehirninfarkt durch partielle Obstruktion der Arteria cerebri media",
      "Gehirninfarkt durch partielle Obstruktion der Arteria cerebri posterior",
      "Gehirninfarkt durch partielle Obstruktion der Arteriae cerebelli",
      "Gehirninfarkt durch zerebrovaskulären Verschluss",
      "Hirninfarkt durch Obstruktion der Arteria cerebri anterior",
      "Hirninfarkt durch Obstruktion der Arteria cerebri media",
      "Hirninfarkt durch Obstruktion der Arteria cerebri posterior",
      "Hirninfarkt durch Obstruktion der Arteriae cerebelli",
      "Hirninfarkt durch Stenose der Arteria cerebri anterior",
      "Hirninfarkt durch Stenose der Arteria cerebri media",
      "Hirninfarkt durch Stenose der Arteria cerebri posterior",
      "Hirninfarkt durch Stenose der Arteriae cerebelli",
      "Hirninfarkt durch Stenose der Stammganglienarterien",
      "Hirninfarkt durch Stenose einer intrakraniellen Arterie",
      "Hirninfarkt durch Verschluss der Arteria cerebri anterior",
      "Hirninfarkt durch Verschluss der Arteria cerebri media",
      "Hirninfarkt durch Verschluss der Arteria cerebri posterior",
      "Hirninfarkt durch Verschluss der Arteriae cerebelli",
      "Hirninfarkt durch Verschluss der Arteriae perforantes",
      "Hirninfarkt durch Verschluss der Stammganglienarterien",
      "Hirninfarkt durch Verschluss einer intrakraniellen Arterie",
      "Hirninfarkt durch komplette Obstruktion der Arteria cerebri anterior",
      "Hirninfarkt durch komplette Obstruktion der Arteria cerebri media",
      "Hirninfarkt durch komplette Obstruktion der Arteria cerebri posterior",
      "Hirninfarkt durch komplette Obstruktion der Arteriae cerebelli",
      "Hirninfarkt durch partielle Obstruktion der Arteria cerebri anterior",
      "Hirninfarkt durch partielle Obstruktion der Arteria cerebri media",
      "Hirninfarkt durch partielle Obstruktion der Arteria cerebri posterior",
      "Hirninfarkt durch partielle Obstruktion der Arteriae cerebelli",
      "Hirninfarkt durch zerebrovaskulären Verschluss",
      "Infarkt der Arteria cerebri anterior",
      "Infarkt der Arteria cerebri media",
      "Infarkt der Arteria cerebri posterior",
      "Infarkt der Capsula interna",
      "Ischämischer Infarkt der Arteria cerebri media",
      "Ischämischer Infarkt einer intrakraniellen Arterie im Kindesalter",
      "Ischämischer Infarkt im Stromgebiet der Arteria cerebri media",
      "Lakunärer Infarkt",
      "Mediainfarkt",
      "Mediainfarkt des Gehirns",
      "Okklusive Enzephalomalazie"
    ]
  },
  {
    "code": "I63.6",
    "name": "Hirninfarkt durch nichteitrige Thrombose einer Hirnvene",
    "synonyms": [
      "Gehirninfarkt durch nichteitrige Thrombose des intrakraniellen venösen Sinus",
      "Gehirninfarkt durch nichteitrige Thrombose einer Hirnvene",
      "Hirninfarkt durch nichteitrige Thrombose des intrakraniellen venösen Sinus",
      "Hirninfarkt durch nichteitrige Thrombose einer Hirnvene",
      "Schlaganfall durch nichteitrige Thrombose einer Hirnvene"
    ]
  },
  {
    "code": "I63.8",
    "name": "Zerebraler angiospastischer Insult",
    "synonyms": [
      "Arteria-cerebellaris-superior-Syndrom",
      "Arteriosklerotische Enzephalomalazie",
      "Zerebraler angiospastischer Insult"
    ]
  },
  {
    "code": "I63.9",
    "name": "Hirninfarkt",
    "synonyms": [
      "Apoplektischer Rezidivinfarkt",
      "Apoplektischer ischämischer Insult",
      "Encephalomalacia alba",
      "Enzephalomalazischer Insult",
      "Frontalhirninfarkt",
      "Gehirninfarkt",
      "Hirninfarkt",
      "Hirnstamminfarkt",
      "Hämorrhagischer Hirninfarkt",
      "Ischämische Apoplexie",
      "Ischämischer Gehirninfarkt",
      "Ischämischer Hirninfarkt",
      "Ischämischer Insult",
      "Ischämischer Schlaganfall",
      "Ischämischer Schlaganfall des Kindes",
      "Ischämischer zerebraler Insult",
      "Kleinhirninfarkt",
      "Marklagerinfarkt",
      "Multiinfarktenzephalopathie",
      "Multiinfarktgeschehen",
      "Multiinfarktsyndrom",
      "PRIND [Prolongiertes reversibles ischämisches neurologisches Defizit]",
      "Ponsinfarkt",
      "Prolongiertes reversibles ischämisches neurologisches Defizit",
      "Rezidivierender Hirninfarkt",
      "Thalamusinfarkt",
      "Zerebellarer Infarkt",
      "Zerebelluminfarkt",
      "Zerebraler Infarkt",
      "Zerebraler Reinfarkt",
      "Zerebraler ischämischer Infarkt",
      "Zerebrales Multiinfarktgeschehen",
      "Zerebrales Multiinfarktsyndrom",
      "Zerebrovaskulärer Infarkt",
      "Zerebrovaskulärer Reinfarkt"
    ]
  },
  {
    "code": "I64",
    "name": "Hirnstamminsult",
    "synonyms": [
      "Akute Zerebralparalyse",
      "Akute zerebrale Lähmung",
      "Angiospastischer Insult",
      "Apoplektische Paralyse",
      "Apoplektischer Anfall",
      "Apoplektischer Insult",
      "Apoplektischer Insult der Arteria cerebri media",
      "Apoplektischer Insult der Arteria cerebri posterior",
      "Apoplektischer Insult im Mediagebiet",
      "Apoplektischer Insult im Stromgebiet einer zerebralen Arterie",
      "Apoplektischer zerebraler Insult",
      "Apoplektisches Koma",
      "Apoplex - s.a. Apoplexie",
      "Apoplex der Arteria cerebri media",
      "Apoplexia",
      "Apoplexia cerebri der Arteria cerebri media",
      "Apoplexie",
      "Arteria-cerebri-media-Insult",
      "Basiläre Apoplexie",
      "Bulbäre Apoplexie",
      "Coma apoplecticum",
      "Gehirnapoplexie",
      "Gehirninsult",
      "Gehirnschlag",
      "Hirninsult",
      "Hirnschlag",
      "Hirnstamminsult",
      "Kapilläre Apoplexie",
      "Paralytischer Schlaganfall",
      "Progrediente Apoplexie",
      "Progressive stroke",
      "Reapoplex",
      "Reinsult",
      "Rezidivapoplex",
      "Schlaganfall",
      "Zerebrale Apoplexie",
      "Zerebraler Insult",
      "Zerebraler Kollaps",
      "Zerebrovaskulärer Insult"
    ]
  },
  {
    "code": "I65.0",
    "name": "Verschluss der Arteria vertebralis",
    "synonyms": [
      "Arteriosklerose der Arteria vertebralis",
      "Embolie der Arteria vertebralis",
      "Komplette Obstruktion der Arteria vertebralis",
      "Obstruktion der Arteria vertebralis",
      "Partielle Obstruktion der Arteria vertebralis",
      "Stenose der Arteria vertebralis",
      "Striktur der Arteria vertebralis",
      "Thrombose der Arteria vertebralis",
      "Verengung der Arteria vertebralis",
      "Verschluss der Arteria vertebralis",
      "Vertebralisstenose",
      "Vertebralisthrombose"
    ]
  },
  {
    "code": "I65.1",
    "name": "Verschluss der Arteria basilaris",
    "synonyms": [
      "Arteriosklerose der Arteria basilaris",
      "Basilaristhrombose",
      "Embolie der Arteria basilaris",
      "Komplette Obstruktion der Arteria basilaris",
      "Obstruktion der Arteria basilaris",
      "Partielle Obstruktion der Arteria basilaris",
      "Stenose der Arteria basilaris",
      "Striktur der Arteria basilaris",
      "Thrombose der Arteria basilaris",
      "Verengung der Arteria basilaris",
      "Verschluss der Arteria basilaris"
    ]
  },
  {
    "code": "I65.2",
    "name": "Stenose der Arteria carotis",
    "synonyms": [
      "Arteriosklerose der Arteria carotis",
      "Embolie der Arteria carotis",
      "Karotissklerose",
      "Karotisstenose",
      "Karotisthrombose",
      "Komplette Obstruktion der Arteria carotis",
      "Obstruktion der Arteria carotis",
      "Partielle Obstruktion der Arteria carotis",
      "Stenose der Arteria carotis",
      "Stenose der Arteria carotis interna",
      "Striktur der Arteria carotis",
      "Thrombose der Arteria carotis",
      "Thrombose der Arteria carotis communis",
      "Thrombose der Arteria carotis interna",
      "Verengung der Arteria carotis",
      "Verschluss der Arteria carotis",
      "Verschluss der Arteria carotis interna"
    ]
  },
  {
    "code": "I65.3",
    "name": "Beidseitige Stenose der Arteria carotis",
    "synonyms": [
      "Beidseitige Stenose der Arteria carotis",
      "Bilaterale Stenose der präzerebralen Arterien",
      "Bilaterale Verengung der Arteria carotis",
      "Bilaterale Verengung der Arteria vertebralis",
      "Bilaterale Verengung einer extrakraniellen hirnversorgenden Arterie",
      "Bilaterale Verengung präzerebraler Arterien",
      "Bilateraler Verschluss der Arteria carotis",
      "Bilateraler Verschluss der Arteria vertebralis",
      "Bilateraler Verschluss der präzerebralen Arterien",
      "Bilateraler Verschluss einer extrakraniellen hirnversorgenden Arterie",
      "Multiple Verengungen einer extrakraniell hirnversorgenden Arterie",
      "Multiple Verengungen präzerebraler Arterien",
      "Multiple Verschlüsse einer extrakraniellen hirnversorgenden Arterie",
      "Multiple Verschlüsse präzerebraler Arterien"
    ]
  },
  {
    "code": "I65.8",
    "name": "Embolie der Arteria labyrinthi",
    "synonyms": [
      "Embolie der Arteria auditiva interna",
      "Embolie der Arteria labyrinthi",
      "Thrombose der Arteria auditiva interna",
      "Thrombose der Arteria labyrinthi",
      "Verengung der Arteria auditiva interna",
      "Verengung der Arteria labyrinthi",
      "Verengung einer Innenohrarterie",
      "Verschluss der Arteria auditiva interna",
      "Verschluss der Arteria labyrinthi"
    ]
  },
  {
    "code": "I65.9",
    "name": "Präzerebraler Arterienverschluss",
    "synonyms": [
      "Embolie einer extrakraniellen hirnversorgenden Arterie",
      "Obstruktion einer extrakraniellen hirnversorgenden Arterie",
      "Präzerebrale Arterienembolie",
      "Präzerebrale Arterienobstruktion",
      "Präzerebrale Arterienstriktur",
      "Präzerebrale Arterienthrombose",
      "Präzerebrale Arterienverengung",
      "Präzerebraler Arterienverschluss",
      "Stenose einer extrakraniellen hirnversorgenden Arterie",
      "Stenose einer präzerebralen Arterie",
      "Striktur einer extrakraniellen hirnversorgenden Arterie",
      "Thrombose extrakranieller hirnversorgender Arterien",
      "Verengung einer extrakraniellen hirnversorgenden Arterie",
      "Verschluss einer extrakraniellen hirnversorgenden Arterie"
    ]
  },
  {
    "code": "I66.0",
    "name": "Embolie der Arteria cerebri media",
    "synonyms": [
      "Embolie der Arteria cerebri media",
      "Komplette Obstruktion der Arteria cerebri media",
      "Obstruktion der Arteria cerebri media",
      "Partielle Obstruktion der Arteria cerebri media",
      "Stenose der Arteria cerebri media",
      "Thrombose der Arteria cerebri media",
      "Verschluss der Arteria cerebri media"
    ]
  },
  {
    "code": "I66.1",
    "name": "Embolie der Arteria cerebri anterior",
    "synonyms": [
      "Embolie der Arteria cerebri anterior",
      "Komplette Obstruktion der Arteria cerebri anterior",
      "Obstruktion der Arteria cerebri anterior",
      "Partielle Obstruktion der Arteria cerebri anterior",
      "Stenose der Arteria cerebri anterior",
      "Thrombose der Arteria cerebri anterior",
      "Verschluss der Arteria cerebri anterior"
    ]
  },
  {
    "code": "I66.2",
    "name": "Embolie der Arteria cerebri posterior",
    "synonyms": [
      "Embolie der Arteria cerebri posterior",
      "Komplette Obstruktion der Arteria cerebri posterior",
      "Obstruktion der Arteria cerebri posterior",
      "Partielle Obstruktion der Arteria cerebri posterior",
      "Stenose der Arteria cerebri posterior",
      "Thrombose der Arteria cerebri posterior",
      "Verschluss der Arteria cerebri posterior"
    ]
  },
  {
    "code": "I66.3",
    "name": "Embolie der Arteriae cerebelli",
    "synonyms": [
      "Embolie der Arteriae cerebelli",
      "Komplette Obstruktion der Arteriae cerebelli",
      "Obstruktion der Arteriae cerebelli",
      "Partielle Obstruktion der Arteriae cerebelli",
      "Stenose der Arteriae cerebelli",
      "Thrombose der Arteriae cerebelli",
      "Verschluss der Arteria cerebelli",
      "Zerebellare Arterienverengung"
    ]
  },
  {
    "code": "I66.4",
    "name": "Multipler Verschluss zerebraler Arterien",
    "synonyms": [
      "Bilateraler Verschluss zerebraler Arterien",
      "Multipler Verschluss zerebraler Arterien",
      "Stenose beidseitiger zerebraler Arterien",
      "Stenose mehrerer zerebraler Arterien"
    ]
  },
  {
    "code": "I66.8",
    "name": "Hirnhautembolie",
    "synonyms": [
      "Arterielle Thrombose der Meningen",
      "Embolie der Arteria chorioidea",
      "Embolie der Arteria communicans posterior",
      "Embolie der Arteria hypophysealis",
      "Embolie der Arteria pontina",
      "Embolie der Meningen",
      "Hirnhautembolie",
      "Stenose der Stammganglienarterien",
      "Thrombose der Arteria chorioidea",
      "Thrombose der Arteria communicans posterior",
      "Thrombose der Arteria hypophysealis",
      "Thrombose der Arteria meningea",
      "Thrombose der Arteria pontina",
      "Verengung der Arteria chorioidea",
      "Verengung der Arteria communicans posterior",
      "Verengung der Arteria hypophysealis",
      "Verengung der Arteria pontina",
      "Verschluss der Arteria chorioidea",
      "Verschluss der Arteria communicans posterior",
      "Verschluss der Arteria pontina",
      "Verschluss der Arteriae perforantes",
      "Verschluss der Stammganglienarterien"
    ]
  },
  {
    "code": "I66.9",
    "name": "Hirnarterienthrombose",
    "synonyms": [
      "CAVK [Cerebrale arterielle Verschlusskrankheit]",
      "Diffuser zerebrovaskulärer Verschluss",
      "Gehirnarterienthrombose",
      "Gehirnembolie",
      "Gehirngefäßverschluss",
      "Gehirngerinnsel",
      "Gehirnthrombose",
      "Hirnarterienembolie",
      "Hirnarterienthrombose",
      "Hirnarterienverschluss",
      "Hirnembolie",
      "Hirngefäßembolie",
      "Intrakranielle Embolie",
      "Intrakranielle arterielle Thrombose",
      "Kortikale Thrombose",
      "Okklusive Hirngefäßkrankheit",
      "Okklusive zerebrovaskuläre Krankheit",
      "Stenose der hirnversorgenden Gefäße",
      "Thrombotische zerebrovaskuläre Krankheit",
      "Verschluss der Arteria cerebralis",
      "Verschluss und Stenose intrakranieller Arterien",
      "Zerebralarterienembolie",
      "Zerebralarterienthrombose",
      "Zerebrale Arterienverengung",
      "Zerebrale Embolie",
      "Zerebrale Gefäßstenose",
      "Zerebraler Arterienverschluss",
      "Zerebraler Gefäßverschluss",
      "Zerebrovaskuläre embolische Krankheit",
      "Zerebrovaskulärer Verschluss"
    ]
  },
  {
    "code": "I67.0",
    "name": "Nichtrupturierte intrakranielle Arteriendissektion",
    "synonyms": [
      "Nichtrupturierte intrakranielle Arteriendissektion"
    ]
  },
  {
    "code": "I67.10",
    "name": "Hirnbasisarterienaneurysma",
    "synonyms": [
      "Aneurysma der Arteria carotis interna, pars cerebralis",
      "Aneurysma der Arteria cerebri anterior",
      "Aneurysma der Arteria cerebri media",
      "Aneurysma der Arteria communicans anterior",
      "Aneurysma der Arteria communicans posterior",
      "Aneurysma der Gehirnmeningen",
      "Aneurysma des Circulus arteriosus Willisii",
      "Aneurysma des Circulus arteriosus cerebri",
      "Aneurysma des Sinus cavernosus",
      "Aneurysma eines Hirnvenensinus",
      "Arteriosklerotisches Gehirnaneurysma",
      "Arteriosklerotisches zerebrales Aneurysma",
      "Erworbenes arteriovenöses Gehirnaneurysma",
      "Erworbenes arteriovenöses zerebrales Aneurysma",
      "Gehirnaneurysma",
      "Hirnaneurysma",
      "Hirnarterienaneurysma",
      "Hirnbasisaneurysma",
      "Hirnbasisarterienaneurysma",
      "Miliaraneurysma",
      "Nichtrupturiertes beerenförmiges Gehirnaneurysma",
      "Nichtrupturiertes zerebrales Aneurysma",
      "Zerebralarterienaneurysma",
      "Zerebrales Aneurysma"
    ]
  },
  {
    "code": "I67.11",
    "name": "Erworbene zerebrale arteriovenöse Fistel",
    "synonyms": [
      "Arteriovenöse Fistel des Gehirns",
      "Carotis-Sinus-cavernosus-Fistel",
      "Erworbene zerebrale arteriovenöse Fistel",
      "Nichttraumatische Fistel des Sinus cavernosus"
    ]
  },
  {
    "code": "I67.2",
    "name": "Zerebrale Arteriosklerose",
    "synonyms": [
      "Arterielle Zerebralsklerose",
      "Arteriosklerose der Arteria cerebri",
      "Arteriosklerose der zerebralen Strombahn",
      "Arteriosklerose des Zentralnervensystems",
      "Arteriosklerotische Enzephalopathie",
      "Arteriosklerotische Gehirnkrankheit",
      "Arteriosklerotische zerebrale Ischämie",
      "Atherom der Arteria basilaris",
      "Atherom der Arteria carotis",
      "Atherom der Arteria cerebri",
      "Atherom der Arteria vertebralis",
      "Atherosklerotische Enzephalopathie",
      "Gehirnarteriosklerose",
      "Gehirnatherosklerose",
      "Hirnarterienatheromatose",
      "Hirnarteriensklerose",
      "Hirnarteriosklerose",
      "Hirnatherosklerose",
      "Hirngefäßsklerose",
      "Senile Gehirnsklerose (arteriosklerotisch)",
      "Senile Hirnsklerose",
      "Spinale Arteriosklerose",
      "Zerebralarteriensklerose",
      "Zerebrale Arteriosklerose",
      "Zerebrale Atheromatose",
      "Zerebrale Atherosklerose",
      "Zerebrale Gefäßsklerose",
      "Zerebrale Vasosklerose",
      "Zerebralsklerose",
      "Zerebrospinale Arteriosklerose",
      "Zerebrovaskuläre Arteriosklerose",
      "Zerebrovaskuläre Sklerose",
      "Zerebrovaskuläre arteriosklerotische Krankheit"
    ]
  },
  {
    "code": "I67.3",
    "name": "Morbus Binswanger",
    "synonyms": [
      "Binswanger-Enzephalopathie",
      "Binswanger-Krankheit",
      "Morbus Binswanger",
      "Progressive subkortikale vaskuläre Enzephalopathie",
      "Subkortikale arteriosklerotische Enzephalopathie"
    ]
  },
  {
    "code": "I67.4",
    "name": "Hypertensive Enzephalopathie",
    "synonyms": [
      "Encephalopathia hypertensiva",
      "Hypertensive Enzephalopathie",
      "Hypertone Enzephalopathie"
    ]
  },
  {
    "code": "I67.5",
    "name": "Moyamoya-Krankheit",
    "synonyms": [
      "Morbus Moyamoya",
      "Moyamoya-Krankheit",
      "Moyamoya-Krankheit mit früh-einsetzender Achalasie",
      "Moyamoya-Syndrom"
    ]
  },
  {
    "code": "I67.6",
    "name": "Nichteitrige Durasinusthrombose",
    "synonyms": [
      "Nichteitrige Durasinusthrombose",
      "Nichteitrige Embolie eines intrakraniellen Venensinus",
      "Nichteitrige Hirnvenenthrombose",
      "Nichteitrige Thrombophlebitis eines intrakraniellen Venensinus",
      "Nichteitrige Thrombophlebitis eines intrakraniellen venösen Sinus",
      "Nichteitrige Thrombose einer Meningenvene",
      "Nichteitrige Thrombose eines intrakraniellen venösen Sinus",
      "Nichteitrige intrakranielle Sinusthrombose",
      "Nichteitrige zerebrale Thrombophlebitis",
      "Nichtpyogene Phlebitis eines intrakraniellen Venensinus",
      "Thrombose einer Meningenvene",
      "Thrombose eines zerebralen venösen Sinus",
      "Zerebrale Venenembolie"
    ]
  },
  {
    "code": "I67.7",
    "name": "Zerebrale Arteriitis",
    "synonyms": [
      "Gehirnarteriitis",
      "Gehirnendarteriitis",
      "Panarteriitis nodosa des Gehirns",
      "Primäre Vaskulitis des Zentralnervensystems",
      "Susac-Syndrom",
      "Zerebrale Arteriitis",
      "Zerebrale Endarteriitis",
      "Zerebrale Panarteriitis nodosa",
      "Zerebrospinale Endarteriitis"
    ]
  },
  {
    "code": "I67.88",
    "name": "Schlagfluss",
    "synonyms": [
      "Akute zerebrovaskuläre Insuffizienz",
      "Akute zerebrovaskuläre Krankheit",
      "Angiozerebrale Insuffizienz",
      "Apoplektiforme Konvulsionen bei zerebraler Ischämie",
      "Autosomal-dominante HTRA1-abhängige zerebrale Mikroangiopathie",
      "CADASIL [Zerebrale autosomal-dominante Arteriopathie mit subkortikalen Infarkten und Leukenzephalopathie]",
      "CARASAL [Cathepsin-A-assoziierte Arteriopathie mit Schlaganfällen und Leukoenzephalopathie]",
      "CARASIL [Zerebrale autosomal-rezessive Arteriopathie mit subkortikalen Infarkten und Leukenzephalopathie]",
      "CVI [Zerebrovaskuläre Insuffizienz]",
      "CVI [Zerebrovaskuläre Insuffizienz] mit Kopfschmerzen",
      "Call-Fleming-Syndrom",
      "Cathepsin-A-assoziierte Arteriopathie mit Schlaganfällen und Leukoenzephalopathie",
      "Chronische generalisierte zerebrale Ischämie",
      "Chronische zerebrale Durchblutungsstörung",
      "Chronische zerebrale Ischämie",
      "Chronische zerebrovaskuläre DBS [Durchblutungsstörung]",
      "Chronische zerebrovaskuläre Durchblutungsstörung",
      "DBS [Durchblutungsstörung] des Gehirns",
      "DBS [Durchblutungsstörung] des Hirns",
      "Gehirndurchblutungsstörung",
      "Gehirnischämie",
      "Hirndurchblutungsstörung",
      "Hirnischämie",
      "Hirnstammischämie",
      "Intrakranielle Stauung",
      "Ischämische Gehirnnekrose",
      "Ischämische Hirnerkrankung",
      "Ischämische Kleinhirnnekrose",
      "Ischämische Nekrose des Zentralnervensystems a.n.k.",
      "Ischämische zerebrale Nekrose",
      "Ischämische zerebrovaskuläre Krankheit",
      "Reversibles zerebrales Vasokonstriktionssyndrom",
      "Schlagfluss",
      "Sinus-cavernosus-Defekt",
      "Störung der Blut-Hirn-Schranke",
      "Zerebellare Durchblutungsstörung",
      "Zerebrale DBS [Durchblutungsstörung]",
      "Zerebrale Durchblutungsstörung",
      "Zerebrale Gefäßstauung",
      "Zerebrale Hyperämie",
      "Zerebrale Ischämie",
      "Zerebrale Makroangiopathie",
      "Zerebrale Mangeldurchblutung",
      "Zerebrale Mikroangiopathie",
      "Zerebrale Mikrozirkulationsstörung",
      "Zerebrale Minderdurchblutung",
      "Zerebrale Vaskulopathie",
      "Zerebrale arterielle Durchblutungsstörung",
      "Zerebrale ischämische Insuffizienz",
      "Zerebrale ischämische Krankheit",
      "Zerebraler Durchblutungsmangel",
      "Zerebralvenöse Insuffizienz",
      "Zerebrovaskuläre Durchblutungsstörung",
      "Zerebrovaskuläre Insuffizienz",
      "Zerebrovaskuläre Insuffizienz 1. Grades",
      "Zerebrovaskuläre Ischämie"
    ]
  },
  {
    "code": "I67.9",
    "name": "Hirngefäßkrankheit",
    "synonyms": [
      "Angiopathie des Gehirns",
      "Arterielle Gehirnkrankheit",
      "Gefäßschädigung im Zentralnervensystem",
      "Gehirngefäßschaden",
      "Hirngefäßkrankheit",
      "Kranieller Gefäßprozess",
      "Vaskuläre Enzephalopathie",
      "Zerebralarterienkrankheit",
      "Zerebrale Angiopathie",
      "Zerebraler Gefäßprozess",
      "Zerebrovaskuläre Dysregulation",
      "Zerebrovaskuläre Erkrankung",
      "Zerebrovaskuläre Krankheit",
      "Zerebrovaskuläre Schädigung",
      "Zerebrovaskuläre Störung",
      "Zerebrovaskuläres Ereignis"
    ]
  },
  {
    "code": "I69.0",
    "name": "Folgen einer Subarachnoidalblutung",
    "synonyms": [
      "Folgen einer Subarachnoidalblutung",
      "Superfizielle Siderose"
    ]
  },
  {
    "code": "I69.1",
    "name": "Folgen einer intrazerebralen Blutung",
    "synonyms": [
      "Folgen einer intrazerebralen Blutung"
    ]
  },
  {
    "code": "I69.2",
    "name": "Folgen einer nichttraumatischen intrakraniellen Blutung a.n.k.",
    "synonyms": [
      "Folgen einer nichttraumatischen intrakraniellen Blutung a.n.k.",
      "Folgen einer nichttraumatischen subduralen Blutung"
    ]
  },
  {
    "code": "I69.3",
    "name": "Hirninfarktfolgen",
    "synonyms": [
      "Gehirninfarktfolgen",
      "Hirninfarktfolgen"
    ]
  },
  {
    "code": "I69.4",
    "name": "Zustand nach Apoplexie",
    "synonyms": [
      "Alter Apoplex",
      "Alter zerebraler Insult",
      "Alter zerebrovaskulärer Insult",
      "Folgen einer Apoplexia cerebri",
      "Folgen eines Schlaganfalls a.n.k.",
      "Zustand nach Apoplexie"
    ]
  },
  {
    "code": "I69.8",
    "name": "Spätfolge einer Hirngefäßkrankheit",
    "synonyms": [
      "Folgen einer zerebrovaskulären Krankheit a.n.k.",
      "Spätfolge einer Hirngefäßkrankheit"
    ]
  },
  {
    "code": "I70.0",
    "name": "Aortenatheromatose",
    "synonyms": [
      "Aortenarteriosklerose",
      "Aortenatherom",
      "Aortenatheromatose",
      "Aortenatherosklerose",
      "Aortendegeneration",
      "Aortenkalzifikation",
      "Aortensklerose",
      "Aortoiliakales Atherom",
      "Arteriosklerotische Aortenstenose",
      "Arteriosklerotische Aortitis",
      "Atherosklerose der Bauchaorta",
      "Verkalkte Aortenstenose"
    ]
  },
  {
    "code": "I70.1",
    "name": "Goldblatt-Niere",
    "synonyms": [
      "Abgangsstenose der Arteria renalis",
      "Arterielle Hypertonie vom Goldblatt-Typ",
      "Arteriosklerose der Arteria renalis",
      "Arteriosklerose der renalen Arterie",
      "Arteriosklerose einer Nierenarterie",
      "Arteriosklerotische Einengung der Arteria renalis",
      "Arteriosklerotische Engstellung der Arteria renalis",
      "Arteriosklerotische Nierenarterieneinengung",
      "Arteriosklerotische Nierenarterienengstellung",
      "Arteriosklerotische Nierenarterienstenose",
      "Arteriosklerotische Nierenarterienstriktur",
      "Arteriosklerotische Stenose der Arteria renalis",
      "Atherosklerose einer Nierenarterie",
      "Goldblatt-Effekt",
      "Goldblatt-Hypertonie",
      "Goldblatt-Mechanismus",
      "Goldblatt-Niere",
      "Goldblatt-Phänomen",
      "Goldblatt-Syndrom",
      "Nierenarterienabgangsstenose",
      "Nierenarterienkalzifikation",
      "Nierenarteriensklerose",
      "Nierenarterienstenose",
      "Nierenarterienursprungsstenose",
      "Nierenarterienverkalkung",
      "Nierenarteriolosklerose",
      "Renale Arterienstenose",
      "Sklerose der Arteria renalis",
      "Stenose der Arteria renalis",
      "Striktur der Arteria renalis",
      "Ursprungsstenose der Arteria renalis"
    ]
  },
  {
    "code": "I70.20",
    "name": "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium I nach Fontaine",
    "synonyms": [
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium I nach Fontaine",
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, ohne Beschwerden"
    ]
  },
  {
    "code": "I70.21",
    "name": "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium IIa nach Fontaine",
    "synonyms": [
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit einer Gehstrecke von 200 m und mehr",
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium IIa nach Fontaine"
    ]
  },
  {
    "code": "I70.22",
    "name": "Periphere arterielle Verschlusskrankheit Stadium IIb (Fontaine)",
    "synonyms": [
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit einer Gehstrecke weniger als 200 m",
      "PAVK vom Becken-Bein-Typ, Stadium IIb nach Fontaine",
      "Periphere arterielle Verschlusskrankheit Stadium IIb (Fontaine)"
    ]
  },
  {
    "code": "I70.23",
    "name": "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit Ruheschmerzen",
    "synonyms": [
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit Ruheschmerzen",
      "PAVK vom Becken-Bein-Typ, Stadium III nach Fontaine"
    ]
  },
  {
    "code": "I70.24",
    "name": "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit Ulzeration",
    "synonyms": [
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit Ulzeration",
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium IV nach Fontaine mit Ulzeration",
      "Ulcus cruris arteriosum",
      "Ulcus cruris mixtum vom Becken-Bein-Typ"
    ]
  },
  {
    "code": "I70.25",
    "name": "Arteriosklerotische Gangrän",
    "synonyms": [
      "Arteriosklerotische Altersgangrän",
      "Arteriosklerotische Gangrän",
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ mit Gangrän",
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium IV nach Fontaine mit feuchter Gangrän",
      "Atherosklerose der Extremitätenarterien vom Becken-Bein-Typ, Stadium IV nach Fontaine mit trockener Gangrän",
      "Atherosklerotische Gangrän",
      "PAVK vom Becken-Bein-Typ, Stadium IV nach Fontaine mit Gangrän",
      "PAVK vom Becken-Bein-Typ, Stadium IVa nach Fontaine",
      "PAVK vom Becken-Bein-Typ, Stadium IVb nach Fontaine",
      "Senile arteriosklerotische Gangrän"
    ]
  },
  {
    "code": "I70.26",
    "name": "Atherosklerose der Extremitätenarterien vom Schulter-Arm-Typ in allen Stadien",
    "synonyms": [
      "Atherosklerose der Arteria subclavia",
      "Atherosklerose der Extremitätenarterien vom Schulter-Arm-Typ in allen Stadien",
      "Ulcus cruris mixtum vom Schulter-Arm-Typ"
    ]
  },
  {
    "code": "I70.29",
    "name": "DBS [Durchblutungsstörung] nach Fontaine",
    "synonyms": [
      "AVK [Arterielle Verschlusskrankheit]",
      "AVK [Arterielle Verschlusskrankheit] des Beins",
      "AVK [Arterielle Verschlusskrankheit] vom Becken- und Oberschenkeltyp",
      "AVK [Arterielle Verschlusskrankheit] vom Beckentyp",
      "AVK [Arterielle Verschlusskrankheit] vom Oberschenkeltyp",
      "Arterielle PVK [Periphere Verschlusskrankheit]",
      "Arterielle Verschlusskrankheit",
      "Arterielle Verschlusskrankheit des Beins",
      "Arterielle Verschlusskrankheit vom Becken- und Oberschenkeltyp",
      "Arterielle Verschlusskrankheit vom Beckentyp",
      "Arterielle Verschlusskrankheit vom Oberschenkeltyp",
      "Arterielle Verschlusskrankheit vom Unterschenkeltyp",
      "Arterielles Verschlusssyndrom",
      "Arteriosklerose der unteren Extremität",
      "Arteriosklerose einer Extremitätenarterie",
      "Arteriosklerose in den Extremitäten",
      "Arteriosklerose peripherer Arterien",
      "Arteriosklerose vom Becken-Bein-Typ",
      "Atherosklerose der Arteria femoralis",
      "Atherosklerose der peripheren Gefäße",
      "Atherosklerose der unteren Extremität",
      "Atherosklerose des Beins",
      "Atherosklerose einer Extremität",
      "Atherosklerose einer Extremitätenarterie",
      "Claudicatio intermittens bei peripherer arterieller Verschlusskrankheit",
      "DBS [Durchblutungsstörung] nach Fontaine",
      "Durchblutungsstörung nach Fontaine",
      "Ischämieschmerzen bei arterieller Verschlusskrankheit",
      "Mediale Arteriendegeneration",
      "Mediale Arteriosklerose",
      "Mediale arterielle Degeneration",
      "Mediasklerose",
      "Mönckeberg-Arteriosklerose",
      "Mönckeberg-Degeneration",
      "Mönckeberg-Sklerose",
      "Mönckeberg-Syndrom",
      "PAVK [Periphere arterielle Verschlusskrankheit] - s.a. Periphere arterielle Verschlusskrankheit",
      "PAVK [Periphere arterielle Verschlusskrankheit] vom Oberschenkeltyp",
      "PAVK [Periphere arterielle Verschlusskrankheit] vom Unterschenkeltyp",
      "Periphere Atherosklerose",
      "Periphere Verschlusskrankheit",
      "Periphere arterielle Verschlusskrankheit",
      "Sklerose einer peripheren Arterie",
      "Verschlusskrankheit"
    ]
  },
  {
    "code": "I70.8",
    "name": "Milzarterienverkalkung",
    "synonyms": [
      "Arteriosklerose einer Halsarterie",
      "Milzarterienkalzifikation",
      "Milzarterienverkalkung"
    ]
  },
  {
    "code": "I70.9",
    "name": "Arterienverkalkung",
    "synonyms": [
      "Aderverkalkung",
      "Allgemeine Arteriosklerose",
      "Allgemeine Pathosklerose",
      "Altersatherosklerose",
      "Angiopathosklerose",
      "Angiosklerose",
      "Arterielle Degeneration",
      "Arterielles Atherom",
      "Arterienatherom",
      "Arterienhyalinose",
      "Arterienkalzifikation",
      "Arteriensklerose",
      "Arterienverkalkung",
      "Arteriitis deformans",
      "Arterioarteriolohyalinose",
      "Arterioarteriolosklerose",
      "Arteriolosklerose",
      "Arteriopathia deformans",
      "Arteriosclerosis obliterans",
      "Arteriosklerose",
      "Arteriosklerotische Gefäßkrankheit",
      "Arteriosklerotische Gefäßveränderung",
      "Arteriosklerotische Krankheit",
      "Arteriovaskuläre Degeneration",
      "Atheromatose",
      "Atheromatöse Arteriendegeneration",
      "Atherosklerose - s.a. Arteriosklerose oder s.a. Aderverkalkung",
      "Diffuse Arteriosklerose",
      "Endarteriitis deformans",
      "Endarteriitis obliterans",
      "Gefäßarteriosklerose",
      "Gefäßatheromatose",
      "Gefäßdegeneration",
      "Gefäßkalzifikation",
      "Gefäßsklerose",
      "Gefäßverkalkung",
      "Gefäßwandkalzifikation",
      "Gefäßwandverkalkung",
      "Generalisierte Arteriosklerose",
      "Generalisierte Atherosklerose",
      "Generalisierter Gefäßprozess",
      "Generalisierter arteriosklerotischer Gefäßprozess",
      "Generelle Arteriosklerose",
      "Gänsegurgelarterie",
      "Kalzifizierende Arteriendegeneration",
      "Obliterierende Arteriosklerose",
      "Panarteriosklerose",
      "Periphere Gefäßsklerose",
      "Schlagaderkalzifikation",
      "Schlagaderverkalkung",
      "Senile Arteriitis",
      "Senile Arteriosklerose",
      "Senile Endarteriitis",
      "Vaskuläre Degeneration",
      "Vasosklerose",
      "Zentrale Arteriosklerose"
    ]
  },
  {
    "code": "I71.00",
    "name": "Aortendissektion - s.a. Aneurysma dissecans aortae",
    "synonyms": [
      "Aneurysma dissecans aortae",
      "Aortendissektion - s.a. Aneurysma dissecans aortae",
      "Disseziierendes Aortenaneurysma",
      "Erdheim-Gsell-Krankheit",
      "Familiäre Aortendissektion",
      "Gsell-Erdheim-Syndrom",
      "Hämatom der Aorta dissecans",
      "Medianecrosis aortae",
      "Zystische Medianekrose der Aorta"
    ]
  },
  {
    "code": "I71.01",
    "name": "Thorakales Aneurysma dissecans aortae Typ A",
    "synonyms": [
      "Aneurysma dissecans der Aorta ascendens",
      "Annuloaortale Ektasie",
      "Dissektion der Aorta thoracica",
      "Familiäre Dissektion der Aorta thoracica",
      "Thorakales Aneurysma dissecans aortae Typ A",
      "Thorakales Aneurysma dissecans aortae Typ B"
    ]
  },
  {
    "code": "I71.02",
    "name": "Dissektion der abdominalen Aorta",
    "synonyms": [
      "Aneurysma dissecans der Aorta abdominalis",
      "Dissektion der Aorta abdominalis",
      "Dissektion der abdominalen Aorta"
    ]
  },
  {
    "code": "I71.03",
    "name": "Thorakoabdominales Aneurysma dissecans aortae Typ A",
    "synonyms": [
      "Thorakoabdominales Aneurysma dissecans aortae Typ A",
      "Thorakoabdominales Aneurysma dissecans aortae Typ B"
    ]
  },
  {
    "code": "I71.04",
    "name": "Rupturiertes Aneurysma dissecans aortae",
    "synonyms": [
      "Aortendissektion mit Ruptur",
      "Rupturiertes Aneurysma dissecans aortae"
    ]
  },
  {
    "code": "I71.05",
    "name": "Rupturierte Dissektion der Aorta thoracica",
    "synonyms": [
      "Rupturierte Dissektion der Aorta thoracica",
      "Rupturierte familiäre Dissektion der Aorta thoracica"
    ]
  },
  {
    "code": "I71.06",
    "name": "Rupturierte Dissektion der Aorta abdominalis",
    "synonyms": [
      "Rupturierte Dissektion der Aorta abdominalis"
    ]
  },
  {
    "code": "I71.07",
    "name": "Rupturierte Dissektion der thorakoabdominalen Aorta",
    "synonyms": [
      "Rupturierte Dissektion der thorakoabdominalen Aorta"
    ]
  },
  {
    "code": "I71.1",
    "name": "Rupturiertes Aneurysma der Aorta thoracica",
    "synonyms": [
      "Aortenbogenruptur",
      "Ruptur der Aorta ascendens",
      "Ruptur der Aorta descendens thoracalis",
      "Ruptur der Aorta thoracica",
      "Rupturiertes Aneurysma der Aorta ascendens",
      "Rupturiertes Aneurysma der Aorta descendens thoracalis",
      "Rupturiertes Aneurysma der Aorta thoracica",
      "Rupturiertes Aneurysma des Aortenbogens",
      "Rupturiertes Brustaortenaneurysma",
      "Rupturiertes aortothorakales Aneurysma",
      "Rupturiertes thorakales Aneurysma",
      "Rupturiertes thorakales Aortenaneurysma"
    ]
  },
  {
    "code": "I71.2",
    "name": "Aortenbogenaneurysma",
    "synonyms": [
      "Aneurysma der Aorta ascendens",
      "Aneurysma der Aorta thoracica",
      "Aneurysma der Aorta thoracica descendens",
      "Aortenbogenaneurysma",
      "Aortenwurzelaneurysma",
      "Brustaortenaneurysma",
      "Intrathorakales Aneurysma",
      "Nichtsyphilitisches Aneurysma der Aorta thoracica"
    ]
  },
  {
    "code": "I71.3",
    "name": "Rupturiertes Aneurysma der Aorta abdominalis",
    "synonyms": [
      "Gedeckt perforiertes Bauchaortenaneurysma",
      "Perforiertes Bauchaortenaneurysma",
      "Ruptur der Aorta abdominalis",
      "Ruptur der Aorta abdominalis descendens",
      "Rupturiertes Aneurysma der Aorta abdominalis",
      "Rupturiertes Aneurysma der Aorta abdominalis descendens",
      "Rupturiertes familiäres abdominales Aortenaneurysma",
      "Rupturiertes infrarenales Aortenaneurysma"
    ]
  },
  {
    "code": "I71.4",
    "name": "Bauchaortenaneurysma",
    "synonyms": [
      "Aneurysma der Aorta abdominalis",
      "Bauchaortenaneurysma",
      "Familiäres abdominales Aortenaneurysma",
      "Infrarenales Aortenaneurysma",
      "Infrarenales Bauchaortenaneurysma"
    ]
  },
  {
    "code": "I71.5",
    "name": "Rupturiertes thorakoabdominales Aortenaneurysma",
    "synonyms": [
      "Rupturiertes thorakoabdominales Aortenaneurysma"
    ]
  },
  {
    "code": "I71.6",
    "name": "Thorakoabdominales Aortenaneurysma",
    "synonyms": [
      "Thorakoabdominales Aneurysma",
      "Thorakoabdominales Aortenaneurysma"
    ]
  },
  {
    "code": "I71.8",
    "name": "Rupturiertes Aortenaneurysma",
    "synonyms": [
      "Aortenriss",
      "Aortenruptur",
      "Aortenwandruptur",
      "Ruptur der Aorta descendens",
      "Rupturierte Aortendilatation",
      "Rupturierte Aortenektasie",
      "Rupturierte Aortennekrose",
      "Rupturiertes Aneurysma cylindricum der Aorta",
      "Rupturiertes Aneurysma der Aorta descendens",
      "Rupturiertes Aortenaneurysma",
      "Rupturiertes arteriosklerotisches Aortenaneurysma"
    ]
  },
  {
    "code": "I71.9",
    "name": "Aortenaneurysma",
    "synonyms": [
      "Aneurysma cylindricum der Aorta",
      "Aneurysma der Aorta descendens",
      "Aortenaneurysma",
      "Aortenaneurysmakalzifikation",
      "Aortenaneurysmaverkalkung",
      "Aortendilatation",
      "Aortenektasie",
      "Aortenerweiterung",
      "Arteriosklerotisches Aortenaneurysma a.n.k.",
      "Hyaline Nekrose der Aorta"
    ]
  },
  {
    "code": "I72.0",
    "name": "Aneurysma der Arteria carotis",
    "synonyms": [
      "Aneursyma der extrakraniellen Arteria carotis",
      "Aneurysma der Arteria carotis",
      "Aneurysma der Arteria carotis interna",
      "Dissektion der Arteria carotis",
      "Extrakranielles Aneurysma der Arteria carotis",
      "Familiäre Dissektion der Arteria carotis",
      "Karotisaneurysma",
      "Rupturiertes Aneurysma der Arteria carotis",
      "Rupturiertes Karotisaneurysma"
    ]
  },
  {
    "code": "I72.1",
    "name": "Arterienaneurysma der oberen Extremität",
    "synonyms": [
      "Aneurysma eines Gefäßes der oberen Extremität",
      "Arterienaneurysma der oberen Extremität",
      "Arteriendissektion der oberen Extremität",
      "Rupturiertes Arterienaneurysma der oberen Extremität"
    ]
  },
  {
    "code": "I72.2",
    "name": "Nierenarterienaneurysma",
    "synonyms": [
      "Aneurysma der Arteria renalis",
      "Dissektion der Arteria renalis",
      "Nierenarterienaneurysma",
      "Nierenarteriendissektion",
      "Rupturiertes Aneurysma der Arteria renalis",
      "Rupturiertes Nierenarterienaneurysma"
    ]
  },
  {
    "code": "I72.3",
    "name": "Aneurysma der Arteria iliaca",
    "synonyms": [
      "Aneurysma der Arteria iliaca",
      "Aneurysma der Arteria iliaca communis",
      "Aneurysma der Arteria iliaca interna",
      "Dissektion der Arteria iliaca",
      "Hüftarterienaneurysma",
      "Iliakalarterienaneurysma",
      "Leistenaneurysma",
      "Rupturiertes Aneurysma der Arteria iliaca",
      "Rupturiertes Hüftarterienaneurysma",
      "Rupturiertes Leistenaneurysma"
    ]
  },
  {
    "code": "I72.4",
    "name": "Aneurysma einer Arterie der unteren Extremität",
    "synonyms": [
      "Aneurysma der Arteria femoralis",
      "Aneurysma der Arteria poplitea",
      "Aneurysma einer Arterie der unteren Extremität",
      "Aneurysma spurium der Arteria profunda femoris",
      "Dissektion der Arteria femoralis",
      "Dissektion der Arteria poplitea",
      "Dissektion einer Arterie der unteren Extremität",
      "Rupturiertes Aneurysma einer Arterie der unteren Extremität"
    ]
  },
  {
    "code": "I72.5",
    "name": "Rückenmarkaneurysma",
    "synonyms": [
      "Aneurysma der Arteria basilaris",
      "Basilarisaneurysma",
      "Basilariskopfaneurysma",
      "Dissektion der Arteria basilaris",
      "Erworbenes Aneurysma präzerebraler Arterien",
      "Rupturiertes Aneurysma präzerebraler Arterien",
      "Rückenmarkaneurysma",
      "Spinales Aneurysma"
    ]
  },
  {
    "code": "I72.6",
    "name": "Aneurysma der Arteria vertebralis",
    "synonyms": [
      "Aneurysma der Arteria vertebralis",
      "Dissektion der Arteria vertebralis",
      "Familiäre Dissektion der Arteria vertebralis"
    ]
  },
  {
    "code": "I72.8",
    "name": "Leberarterienaneurysma",
    "synonyms": [
      "Aneurysma der Arteria subclavia",
      "Aneurysma eines Milzgefäßes",
      "Dissektion der Arteria subclavia",
      "Leberarterienaneurysma",
      "Leberarteriendissektion",
      "Mediastinales Aneurysma",
      "Nichtsyphilitisches Aneurysma des Truncus brachiocephalicus",
      "Peripheres Aneurysma a.n.k.",
      "Rupturiertes Aneurysma der Arteria lienalis",
      "Rupturiertes Aneurysma der Arteria subclavia",
      "Rupturiertes Aneurysma eines Milzgefäßes",
      "Rupturiertes Leberarterienaneurysma",
      "Rupturiertes mediastinales Aneurysma",
      "Rupturiertes peripheres Aneurysma a.n.k."
    ]
  },
  {
    "code": "I72.9",
    "name": "Arteriektasie",
    "synonyms": [
      "Aneurysma",
      "Aneurysma anastomoticum",
      "Aneurysma cirsoideum",
      "Aneurysma dissecans",
      "Aneurysma falsum",
      "Aneurysma spurium",
      "Aneurysmablutung",
      "Aneurysmaperforation",
      "Aneurysmaruptur",
      "Aneurysmatischer Tumor",
      "Arteriektasie",
      "Arterielles Aneurysma",
      "Arterienaneurysma",
      "Arteriendilatation - s.a. Aneurysma",
      "Arteriendissektion",
      "Arteriosklerotisches Aneurysma",
      "Diffuse Aneurysmen",
      "Disseziierendes Aneurysma",
      "Falsches Aneurysma",
      "Familiäre zervikale Arteriendissektion",
      "Fusiformes Aneurysma",
      "Gefäßwandaneurysma",
      "Infektiöses Aneurysma",
      "Multiple Aneurysmen",
      "Mykotisches Aneurysma",
      "Peripheres Aneurysma racemosum",
      "Rupturiertes Aneurysma",
      "Sackförmiges Aneurysma"
    ]
  },
  {
    "code": "I73.0",
    "name": "Raynaud-Syndrom",
    "synonyms": [
      "Digitus mortuus",
      "Lokale Asphyxie",
      "Morbus Raynaud",
      "Paroxysmale Fingerzyanose",
      "Raynaud-Gangrän",
      "Raynaud-Krankheit",
      "Raynaud-Phänomen",
      "Raynaud-Syndrom",
      "Sekundäres Raynaud-Phänomen",
      "Symmetrische Gangrän"
    ]
  },
  {
    "code": "I73.1",
    "name": "Thrombangiitis",
    "synonyms": [
      "Buerger-Krankheit",
      "Buerger-Syndrom",
      "Endangiitis",
      "Endangiitis obliterans",
      "Generalisierte Thrombangiitis obliterans",
      "Juvenile Gangrän",
      "Raucherbein",
      "Thrombangiitis",
      "Thrombangiitis obliterans",
      "Von-Winiwarter-Buerger-Endangiitis",
      "Von-Winiwarter-Buerger-Endarteriitis",
      "Von-Winiwarter-Buerger-Krankheit",
      "Von-Winiwarter-Buerger-Syndrom"
    ]
  },
  {
    "code": "I73.8",
    "name": "Akroasphyxie",
    "synonyms": [
      "Akroasphyxia",
      "Akroasphyxie",
      "Akromelalgie",
      "Akroparästhesie",
      "Akrozyanose",
      "Chronische Akroasphyxie",
      "Einfache Akroparästhesie",
      "Einfache Schultze-Akroparästhesie",
      "Erythralgie",
      "Erythrocyanosis",
      "Erythrocyanosis crurum",
      "Erythrocyanosis crurum puellarum",
      "Erythromelalgie",
      "Erythrothermalgie",
      "Erythrozyanose",
      "Erythrozyanose des Unterschenkels",
      "Mitchell-Krankheit (Erythromelalgie)",
      "Mitchell-Syndrom (Erythromelalgie)",
      "Nothnagel-Syndrom II",
      "Primäre Erythromelalgie",
      "Primäre Erythrothermalgie",
      "Schultze-Syndrom",
      "Sekundäre Erythromelalgie",
      "Syndrom der multisystemischen Dysfunktion der glatten Muskulatur",
      "Vasomotorische Akroparästhesie",
      "Vasomotorische Nothnagel-Akroparästhesie"
    ]
  },
  {
    "code": "I73.9",
    "name": "Vasospasmus",
    "synonyms": [
      "Angiospasmus",
      "Angiospastische Krankheit",
      "Angiospastisches Ödem",
      "Arterielle DBS [Durchblutungsstörung]",
      "Arterielle Durchblutungsstörung",
      "Arterielle Durchblutungsstörung des Beins",
      "Arterielles Durchblutungsleiden",
      "Arterienspasmus a.n.k.",
      "Arteriospasmus",
      "Beinischämie",
      "Charcot-I-Syndrom",
      "Claudicatio intermittens",
      "DBS [Durchblutungsstörung] der Extremitäten",
      "DBS [Durchblutungsstörung] des Beins",
      "Durchblutungsstörung bei peripherer Gefäßkrankheit",
      "Durchblutungsstörung der Extremitäten",
      "Durchblutungsstörung des Beins",
      "Durchblutungsstörung des Beins mit Ödem",
      "Dysbasia angiosclerotica intermittens",
      "Dysbasia intermittens",
      "Gefäßspasmus",
      "Insuffizienz eines peripheren Gefäßes",
      "Intermittierendes Hinken",
      "Labiles vasomotorisches System",
      "Periphere Angiopathie",
      "Periphere Durchblutungsstörung",
      "Periphere Gefäßkrankheit",
      "Periphere arterielle DBS [Durchblutungsstörung]",
      "Periphere arterielle Durchblutungsstörung",
      "Periphere vaskuläre Insuffizienz",
      "Peripherer Angiospasmus",
      "Peripherer Gefäßkrampf",
      "Peripherer Gefäßspasmus",
      "Peripherer Vasospasmus a.n.k.",
      "Renovaskuläre Erkrankung",
      "Traumatischer Angiospasmus des Beins",
      "Traumatischer Angiospasmus des Fußes",
      "Vaskuläre Beinbeschwerden",
      "Vaskulärer Spasmus a.n.k.",
      "Vasodilatation",
      "Vasomotorische Dilatation",
      "Vasomotorische Dysfunktion",
      "Vasomotorische Krankheit",
      "Vasomotorische Störung",
      "Vasomotorischer Spasmus a.n.k.",
      "Vasomotorisches Syndrom",
      "Vasospasmus",
      "Vasospastische Krankheit",
      "Vasospastische Störung",
      "Vasospastisches Phänomen"
    ]
  },
  {
    "code": "I74.0",
    "name": "Aortengabelembolie",
    "synonyms": [
      "Aortenbifurkationssyndrom",
      "Aortenbogenembolie",
      "Aortengabelembolie",
      "Aortensattelthrombose",
      "Bauchaortenembolie",
      "Bauchaortenthrombose",
      "Embolie der Aorta abdominalis",
      "Leriche-Syndrom",
      "Sattelembolie der Aorta",
      "Sattelembolie der Aortenbifurkation",
      "Sattelembolie der Bifurcatio aortae",
      "Thrombose der Aorta abdominalis",
      "Thrombose der Aortenbifurkation",
      "Verschluss der Aorta abdominalis"
    ]
  },
  {
    "code": "I74.1",
    "name": "Embolie der Aorta thoracica",
    "synonyms": [
      "Embolie der Aorta",
      "Embolie der Aorta thoracica",
      "Thrombose der Aorta",
      "Thrombose der Aorta thoracica"
    ]
  },
  {
    "code": "I74.2",
    "name": "Arterielle Embolie des Arms",
    "synonyms": [
      "Akuter arterieller Verschluss des Arms",
      "Arterielle Embolie der Arteria radialis",
      "Arterielle Embolie des Arms",
      "Arterielle Embolie des Oberarms",
      "Arterielle Embolie des Unterarms",
      "Arterienembolie der oberen Extremität",
      "Arterienthrombose der oberen Extremität",
      "Embolie der Arteria axillaris",
      "Embolie der Arteria brachialis",
      "Embolie der oberen Extremität",
      "Embolie des Arms",
      "Verschluss der Arteria brachialis"
    ]
  },
  {
    "code": "I74.3",
    "name": "Beinarterienthrombose",
    "synonyms": [
      "Akuter arterieller Verschluss des Beins",
      "Arterielle Beinembolie",
      "Arterielle Embolie der unteren Extremität",
      "Arterielle Embolie des Beins",
      "Arterielle Embolie des Fußes",
      "Arterielle Embolie des Oberschenkels",
      "Arterielle Embolie des Unterschenkels",
      "Arterielle Thromboembolie des Beins",
      "Arterielle Thrombose des Beins",
      "Arterieller Gefäßverschluss der unteren Extremität",
      "Arterieller Gefäßverschluss eines Beins",
      "Arterieller Gefäßverschluss eines Unterschenkels",
      "Arterieller Verschluss des Beins",
      "Arterieller Verschluss des Fußes",
      "Arterieller Verschluss des Unterschenkels",
      "Arterienembolie der unteren Extremität",
      "Arterienthrombose der unteren Extremität",
      "Beinarterienembolie",
      "Beinarterienthrombose",
      "Beinarterienverschluss",
      "Embolie der Arteria femoralis",
      "Embolie der Arteria femoralis communis",
      "Embolie der Arteria poplitea",
      "Femoralarterienthrombose",
      "Femorale Embolie",
      "Femoralisverschluss",
      "Poplitealarterienverschluss",
      "Thrombose der Arteria femoralis",
      "Verschluss der Arteria femoralis",
      "Verschluss der Arteria poplitea"
    ]
  },
  {
    "code": "I74.4",
    "name": "Embolie einer Extremitätenarterie",
    "synonyms": [
      "Akuter peripherer Arterienverschluss",
      "Arterienverschluss einer Extremität",
      "Embolie einer Extremität",
      "Embolie einer Extremitätenarterie",
      "Embolie einer peripheren Arterie a.n.k.",
      "Embolie und Thrombose einer Extremitätenarterie",
      "Embolischer Verschluss einer peripheren Arterie",
      "Periphere arterielle Embolie",
      "Peripherer Arterienverschluss",
      "Thrombose einer Extremitätenarterie",
      "Thrombose einer peripheren Arterie",
      "Thrombotischer Verschluss einer peripheren Arterie"
    ]
  },
  {
    "code": "I74.5",
    "name": "Thrombose der Arteria iliaca",
    "synonyms": [
      "Arterielle Embolie der Arteria iliaca externa",
      "Arterieller Verschluss der Arteria iliaca",
      "Embolie der Arteria iliaca",
      "Embolie und Thrombose der Arteria iliaca",
      "Thrombose der Arteria iliaca",
      "Verschluss der Arteria iliaca"
    ]
  },
  {
    "code": "I74.8",
    "name": "Leberarterienthrombose",
    "synonyms": [
      "Arterielle Milzthrombose",
      "Embolischer Milzinfarkt",
      "Leberarterienthrombose",
      "Milzarterienembolie",
      "Milzarterienthrombose",
      "Thrombose der Arteria hepatica",
      "Thrombotischer Milzinfarkt"
    ]
  },
  {
    "code": "I74.9",
    "name": "Arterienthromboembolie",
    "synonyms": [
      "Arterielle Embolie",
      "Arterielle Thromboembolie",
      "Arterieller Infarkt",
      "Arterieller Verschluss",
      "Arterieller thrombotischer Infarkt",
      "Arteriengerinnsel",
      "Arterienthromboembolie",
      "Arterienthrombose",
      "Arterienverschluss",
      "Arteriolenthrombus",
      "Atherothrombose",
      "Cholesterinkristallembolie",
      "Embolie",
      "Embolie unter Ovulationshemmer",
      "Embolische Endarteriitis",
      "Embolischer Infarkt",
      "Embolischer Verschluss",
      "Gerinnsel im Kreislauf",
      "Multiple Embolien a.n.k.",
      "Paradoxe Embolie a.n.k.",
      "Septische Embolie",
      "Thrombembolie",
      "Thromboembolie"
    ]
  },
  {
    "code": "I77.0",
    "name": "Arteriovenöse Fistel",
    "synonyms": [
      "Arteriovenöse Fistel",
      "Erworbene arteriovenöse Fistel",
      "Erworbenes arteriovenöses Aneurysma",
      "Rupturiertes variköses Aneurysma",
      "Varix aneurysmatica"
    ]
  },
  {
    "code": "I77.1",
    "name": "Arterienstenose a.n.k.",
    "synonyms": [
      "Arterial-Tortuosity-Syndrom",
      "Arterielle Insuffizienz",
      "Arterieneinengung",
      "Arterienknick",
      "Arterienkompression",
      "Arterienkrankheit mit Striktur",
      "Arterienstenose a.n.k.",
      "Arterienstriktur",
      "Arterienverengung a.n.k.",
      "Beckenarterienstenose",
      "Geschlängelte Arterien",
      "Kinking-Arterie",
      "Obliterierende Gefäßkrankheit",
      "Okklusive Arterienkrankheit",
      "Popliteakompressionssyndrom",
      "Popliteal artery entrapment syndrome",
      "Stenose der Arteria femoralis",
      "Subklaviastenose",
      "Tortuositas einer Arterie"
    ]
  },
  {
    "code": "I77.2",
    "name": "Arterienriss",
    "synonyms": [
      "Aortoduodenale Fistel",
      "Arterielle Arrosionsblutung",
      "Arterielle Ruptur",
      "Arterienfistel",
      "Arterienriss",
      "Arterienruptur",
      "Arterienwandruptur",
      "Eitrige Arteriitis"
    ]
  },
  {
    "code": "I77.3",
    "name": "Fibromuskuläre Dysplasie einer Arterie",
    "synonyms": [
      "Fibromuskuläre Dysplasie einer Arterie",
      "Fibromuskuläre Einengung der Arteria renalis",
      "Fibromuskuläre Engstellung der Arteria renalis",
      "Fibromuskuläre Hyperplasie einer Arterie",
      "Fibromuskuläre Nierenarterieneinengung",
      "Fibromuskuläre Nierenarterienengstellung",
      "Fibromuskuläre Nierenarterienstenose",
      "Fibromuskuläre Nierenarterienstriktur",
      "Fibromuskuläre Stenose der Arteria renalis"
    ]
  },
  {
    "code": "I77.4",
    "name": "Kompressionssyndrom der Arteria coeliaca",
    "synonyms": [
      "Arteria-coeliaca-Kompressions-Syndrom",
      "Arteria-coeliaca-Syndrom",
      "Kompressionssyndrom der Arteria coeliaca",
      "Truncus-coeliacus-Kompressionssyndrom"
    ]
  },
  {
    "code": "I77.5",
    "name": "Arteriennekrose",
    "synonyms": [
      "Arteriennekrose",
      "Arteriolonekrose"
    ]
  },
  {
    "code": "I77.6",
    "name": "Angiitis",
    "synonyms": [
      "ANCA-assoziierte Vaskulitis",
      "Angiitis",
      "Aortitis",
      "Arterienentzündung",
      "Arteriitis",
      "Arteriolitis",
      "Bakterielle Endarteriitis",
      "Disseminierte Vaskulitis",
      "Endarteriitis",
      "IgG4-assoziierte Aortitis",
      "Infektiöse Endarteriitis",
      "Leukozytoklastische Vaskulitis",
      "Nichtsyphilitische Aortitis",
      "Nichtsyphilitische Arteriitis der Aorta",
      "Panarteriitis",
      "Postinfektiöse Vaskulitis",
      "Septische Endarteriitis",
      "Subakute Endarteriitis",
      "Thrombarteriitis",
      "Vasculitis - s.a. Vaskulitis",
      "Vaskulitis",
      "Verkalkende Aortitis",
      "Zentrale Arteriitis"
    ]
  },
  {
    "code": "I77.80",
    "name": "Penetrierendes Aortenulkus",
    "synonyms": [
      "PAU [Penetrierendes Aortenulkus]",
      "Penetrierendes Aortenulkus"
    ]
  },
  {
    "code": "I77.88",
    "name": "Arterienarrosion",
    "synonyms": [
      "Arterienarrosion",
      "Arterienerosion",
      "Arterienhypertrophie",
      "Arterienulkus",
      "Arterienulzeration",
      "Arterienwandabszess",
      "Degos-Delort-Tricot-Syndrom",
      "Erworbene Aortenbogendeformität",
      "Erworbene Aortendeformität",
      "Erworbene Nierenarteriendeformität",
      "Erworbene periphere Arteriendeformität a.n.k.",
      "Erworbenes Arteria-mesenterica-superior-Syndrom",
      "Erworbenes Wilkie-Syndrom",
      "Fettige Aortendegeneration",
      "Hyperplasie der Arteria renalis",
      "Hypertrophie der Tunica muscularis der Arterien",
      "Maligne atrophische Papulose",
      "Nierenarterienhyperplasie",
      "Papulosis atrophicans maligna",
      "Segmentale arterielle Mediolyse",
      "Sneddon-Syndrom",
      "Vaskulitis der Niere"
    ]
  },
  {
    "code": "I77.9",
    "name": "Arteriopathie",
    "synonyms": [
      "Arterielle Gefäßkrankheit",
      "Arterieller Gefäßprozess",
      "Arterielles Gefäßleiden",
      "Arterieninfektion",
      "Arterienkrankheit",
      "Arteriolenkrankheit",
      "Arteriopathie",
      "Generalisierte obliterierende Arteriolenkrankheit",
      "Nichtsyphilitische Aortenkrankheit",
      "Small vessel disease"
    ]
  },
  {
    "code": "I78.0",
    "name": "Hereditäre hämorrhagische Teleangiektasie",
    "synonyms": [
      "HHT [Hereditäre hämorrhagische Teleangiektasie]",
      "Hereditäre Teleangiektasie",
      "Hereditäre hämorrhagische Teleangiektasie",
      "Morbus Osler",
      "Osler-Krankheit",
      "Osler-Syndrom",
      "Rendu-Osler-Weber-Krankheit",
      "Rendu-Weber-Osler-Syndrom"
    ]
  },
  {
    "code": "I78.1",
    "name": "Teleangiektasie",
    "synonyms": [
      "Angioma stellatum",
      "Naevus araneus",
      "Naevus stellatus",
      "Nichtneoplastischer Nävus",
      "Nichttumoröser Nävus",
      "Papilläre Varizen",
      "Seniler Nävus",
      "Seniles Angiom",
      "Spider-Nävus",
      "Spinnenmal",
      "Spinnennävus",
      "Sternnävus",
      "Teleangiektasie"
    ]
  },
  {
    "code": "I78.8",
    "name": "Erhöhte Durchlässigkeit eines Kapillargefäßes",
    "synonyms": [
      "Capillary-leak-Syndrom",
      "Dilatation der Kapillaren",
      "Dilatation des Plexus pampiniformis",
      "Ektasie des Plexus pampiniformis",
      "Erhöhte Durchlässigkeit eines Kapillargefäßes",
      "Erhöhung der Kapillarpermeabilität",
      "Erweiterung des Plexus pampiniformis",
      "Erworbene kapilläre Deformität",
      "Hyperpermeabilität der Kapillaren",
      "Kapillarembolie",
      "Kapillargefäßatonie",
      "Kapillargefäßektasie",
      "Kapillaritis",
      "Kapillarleck-Syndrom",
      "Kapillarruptur",
      "Kapillarthrombose",
      "Kapillarthrombus",
      "Kapilläre Blutung",
      "Kapilläre Hämorrhagie",
      "Kapilläre fettige Degeneration",
      "Vergrößerung des Plexus pampiniformis"
    ]
  },
  {
    "code": "I78.9",
    "name": "Kapillarkrankheit",
    "synonyms": [
      "Kapillargefäßkrankheit",
      "Kapillarkrankheit"
    ]
  },
  {
    "code": "I80.0",
    "name": "Oberflächliche Unterschenkelphlebitis",
    "synonyms": [
      "Oberflächliche Phlebitis des Beins",
      "Oberflächliche Phlebitis des Oberschenkels",
      "Oberflächliche Phlebothrombose des Beins",
      "Oberflächliche Phlebothrombose des Oberschenkels",
      "Oberflächliche Phlebothrombose des Unterschenkels",
      "Oberflächliche Thrombophlebitis der unteren Extremität",
      "Oberflächliche Thrombophlebitis des Beins",
      "Oberflächliche Thrombophlebitis des Oberschenkels",
      "Oberflächliche Thrombophlebitis des Unterschenkels",
      "Oberflächliche Thrombose des Beins",
      "Oberflächliche Thrombose des Oberschenkels",
      "Oberflächliche Thrombose des Unterschenkels",
      "Oberflächliche Unterschenkelphlebitis",
      "Oberflächliche thrombotische Venenentzündung der unteren Extremität",
      "Oberflächliche ulzeröse Phlebitis des Beins",
      "Phlebitis der Vena saphena",
      "Phlebitis eines oberflächlichen Gefäßes der unteren Extremität",
      "Saphenaphlebothrombose",
      "Thrombose der Vena saphena"
    ]
  },
  {
    "code": "I80.1",
    "name": "Thrombose der Vena femoralis",
    "synonyms": [
      "Embolie der Vena femoralis",
      "Femorale Phlebitis",
      "Femorale Venenembolie",
      "Femorale Venenthrombose",
      "Iliofemorale Phlebitis",
      "Iliofemorale Thrombophlebitis",
      "Iliofemorale Venenthrombose",
      "Nichtpuerperale Phlegmasia alba dolens",
      "Thrombophlebitis femoralis",
      "Thrombose der Vena femoralis"
    ]
  },
  {
    "code": "I80.20",
    "name": "Beckenvenenthrombose",
    "synonyms": [
      "Beckenbeinthrombose",
      "Beckenbeinvenenthrombose",
      "Beckenphlebothrombose",
      "Beckenthrombose",
      "Beckenvenenphlebothrombose",
      "Beckenvenenthrombose",
      "Beinbeckenthrombose",
      "Beinbeckenvenenthrombose",
      "Iliakale Venenthrombose",
      "Phlebitis der Beckenvene",
      "Thrombophlebitis der Beckenvene"
    ]
  },
  {
    "code": "I80.28",
    "name": "Tiefe Venenthrombose",
    "synonyms": [
      "Phlebitis der Vena poplitea",
      "Phlegmasia coerulea dolens",
      "Thrombophlebitis der Vena poplitea",
      "Thrombose der Vena poplitea",
      "Tiefe Beinphlebitis a.n.k.",
      "Tiefe Beinvenenthrombose",
      "Tiefe Phlebitis der unteren Extremität",
      "Tiefe Phlebitis des Oberschenkels",
      "Tiefe Phlebitis des Unterschenkels",
      "Tiefe Thrombophlebitis der unteren Extremität a.n.k.",
      "Tiefe Thrombophlebitis des Beins",
      "Tiefe Thrombophlebitis des Oberschenkels",
      "Tiefe Thrombophlebitis des Unterschenkels",
      "Tiefe Thrombose",
      "Tiefe Venenthrombose",
      "Tiefe thrombotische Venenentzündung der unteren Extremität",
      "Tiefe ulzeröse Phlebitis des Beins",
      "Tiefliegende Phlebothrombose der unteren Extremität",
      "Tiefliegende Phlebothrombose des Beins",
      "Tiefliegende Phlebothrombose des Oberschenkels",
      "Tiefliegende Phlebothrombose des Unterschenkels",
      "Tiefliegende Thrombose der unteren Extremität",
      "Tiefliegende Thrombose des Beins",
      "Tiefliegende Thrombose des Oberschenkels",
      "Tiefliegende Thrombose des Unterschenkels"
    ]
  },
  {
    "code": "I80.3",
    "name": "Thrombophlebitis des Unterschenkels",
    "synonyms": [
      "Beinembolie",
      "Beinphlebitis",
      "Beinphlebothrombose",
      "Beinthrombophlebitis",
      "Beinthrombose",
      "Beinvenenthrombose",
      "Embolie beider Unterschenkel",
      "Embolie der unteren Extremität",
      "Embolie und Thrombose des Beins",
      "Mehretagenthrombose des Beins",
      "Oberschenkelphlebitis",
      "Oberschenkelphlebothrombose",
      "Oberschenkelthrombose",
      "Oberschenkelvenenthrombose",
      "Phlebitis der unteren Extremität",
      "Thrombophlebitis der unteren Extremität",
      "Thrombophlebitis des Oberschenkels",
      "Thrombophlebitis des Unterschenkels",
      "Thrombose der unteren Extremität",
      "Ulzeröse Beinphlebitis",
      "Unterschenkelembolie",
      "Unterschenkelphlebitis",
      "Unterschenkelphlebothrombose",
      "Unterschenkelthrombose",
      "Unterschenkelvenenthrombose",
      "Venenembolie der unteren Extremität",
      "Venenentzündung der unteren Extremität",
      "Wadenvenenthrombose",
      "Zweietagenthrombose des Beins"
    ]
  },
  {
    "code": "I80.80",
    "name": "Thrombose der oberflächlichen Gefäße der oberen Extremität",
    "synonyms": [
      "Phlebitis der Vena basilica",
      "Phlebitis der Vena cephalica",
      "Phlebitis der oberflächlichen Gefäße der oberen Extremität",
      "Thrombophlebitis der Vena basilica",
      "Thrombophlebitis der Vena cephalica",
      "Thrombophlebitis der oberflächlichen Gefäße der oberen Extremität",
      "Thrombose der Vena basilica",
      "Thrombose der Vena cephalica",
      "Thrombose der oberflächlichen Gefäße der oberen Extremität"
    ]
  },
  {
    "code": "I80.81",
    "name": "Achselvenenthrombose",
    "synonyms": [
      "Achselvenenthrombose",
      "Axillarvenenthrombose",
      "Paget-Schroetter-Syndrom",
      "Paget-von-Schroetter-Syndrom",
      "Phlebitis der Vena axillaris",
      "Phlebitis der Vena subclavia",
      "Phlebitis der tiefen Gefäße der oberen Extremität",
      "Thrombophlebitis der Vena axillaris",
      "Thrombophlebitis der Vena subclavia",
      "Thrombophlebitis der tiefen Gefäße der oberen Extremität",
      "Thrombose der Vena axillaris",
      "Thrombose der Vena subclavia",
      "Thrombose der tiefen Gefäße der oberen Extremität"
    ]
  },
  {
    "code": "I80.88",
    "name": "Phlebitis umbilicalis",
    "synonyms": [
      "Armvenenthrombose",
      "Brustdrüsenphlebitis",
      "Hepatophlebitis",
      "Lemierre-Syndrom",
      "Mondor-Krankheit",
      "Mondor-Syndrom",
      "Morbus Mondor",
      "Nabelphlebitis",
      "Periphlebitis umbilicalis",
      "Phlebitis der Mamma",
      "Phlebitis einer hepatischen Vene",
      "Phlebitis umbilicalis",
      "Pyelophlebitis",
      "Thrombophlebitis einer hepatischen Vene",
      "Thrombophlebitis renalis",
      "Thrombose des Plexus pampiniformis"
    ]
  },
  {
    "code": "I80.9",
    "name": "Akute Thrombophlebitis",
    "synonyms": [
      "Akute Thrombophlebitis",
      "Chronische Phlebitis",
      "Chronische Thrombophlebitis",
      "Eitrige Phlebitis",
      "Endophlebitis",
      "Infektiöse Phlebitis",
      "Mesophlebitis",
      "Oberflächliche Venenentzündung",
      "Periphlebitis",
      "Phlebitis",
      "Phlebitis suppurativa",
      "Septische Phlebitis",
      "Septische Thrombophlebitis",
      "Superfizielle Phlebitis",
      "Thrombophlebitis",
      "Thrombotische Venenentzündung",
      "Tiefe Venenentzündung",
      "Ulzeröse Phlebitis",
      "Venenentzündung"
    ]
  },
  {
    "code": "I81",
    "name": "Pfortaderthrombose",
    "synonyms": [
      "Embolie der Vena portae",
      "Pfortaderblockade",
      "Pfortaderembolie",
      "Pfortaderobstruktion",
      "Pfortaderstenose",
      "Pfortaderthrombose",
      "Pfortaderverschluss",
      "Portale Thrombose",
      "Verschluss der Vena portae"
    ]
  },
  {
    "code": "I82.0",
    "name": "Budd-Chiari-Syndrom [Lebervenenverschlusssyndrom]",
    "synonyms": [
      "Budd-Chiari-Syndrom [Lebervenenverschlusssyndrom]",
      "Chiari-Krankheit",
      "Embolie der Vena hepatica",
      "Hepatische Thrombose",
      "Hepatische Venenembolie",
      "Leberthrombose",
      "Lebervenenblockade",
      "Lebervenenembolie",
      "Lebervenenstenose",
      "Lebervenenthrombose",
      "Lebervenenverschluss",
      "Lebervenenverschlusssyndrom",
      "Primäre Lebervenenthrombose"
    ]
  },
  {
    "code": "I82.1",
    "name": "Thrombophlebitis migrans",
    "synonyms": [
      "Idiopathische rezidivierende Thrombophlebitis",
      "Oberflächliche Phlebitis migrans",
      "Phlebitis migrans",
      "Thrombophlebitis migrans"
    ]
  },
  {
    "code": "I82.2",
    "name": "Thrombose der Vena cava superior",
    "synonyms": [
      "Embolie der Vena cava",
      "Embolie und Thrombose der Vena cava",
      "Thrombose der Vena cava",
      "Thrombose der Vena cava inferior",
      "Thrombose der Vena cava superior",
      "Verschluss der Vena cava"
    ]
  },
  {
    "code": "I82.3",
    "name": "Nierenvenenverschluss",
    "synonyms": [
      "Embolie der Vena renalis",
      "Nierenvenenembolie",
      "Nierenvenenthrombose",
      "Nierenvenenverschluss",
      "Thrombose einer renalen Vene"
    ]
  },
  {
    "code": "I82.80",
    "name": "Milzvenenthrombose",
    "synonyms": [
      "Milzthrombose",
      "Milzvenenthrombose",
      "Venöse Milzthrombose"
    ]
  },
  {
    "code": "I82.81",
    "name": "Jugularisvenenthrombose",
    "synonyms": [
      "Embolie der Jugularisvene",
      "Jugularisvenenthrombose",
      "Thrombose des Bulbus venae jugularis"
    ]
  },
  {
    "code": "I82.88",
    "name": "Nebennierenvenenthrombose",
    "synonyms": [
      "Bauchvenenthrombose",
      "Nebennierenvenenthrombose",
      "Venöser Halsgefäßverschluss"
    ]
  },
  {
    "code": "I82.9",
    "name": "Oberflächliche Venenthrombose",
    "synonyms": [
      "Abscheidungsthrombus",
      "Astvenenthrombose",
      "Astvenenverschluss",
      "Blande Thrombose a.n.k.",
      "Blutpfropfbildung",
      "Gefäßthrombose",
      "Mehretagenthrombose",
      "Mikroembolie",
      "Mikrothrombus",
      "Multiple Thrombosen",
      "Oberflächliche Venenthrombose",
      "Phlebothrombose",
      "Progressive Thrombose",
      "Schichtenthrombus",
      "Septische Thrombose",
      "Stumme Thrombose a.n.k.",
      "Thrombose",
      "Thrombose ohne Embolie",
      "Thromboseneinengung einer Vene",
      "Thrombotischer Verschluss",
      "Venenblockade a.n.k.",
      "Venenembolie",
      "Venengerinnsel",
      "Venenthrombose",
      "Venöse Embolie",
      "Venöse thromboembolische Ereignisse",
      "Zweietagenthrombose"
    ]
  },
  {
    "code": "I83.0",
    "name": "Postthrombotisches Ulcus cruris",
    "synonyms": [
      "Krampfadergeschwür",
      "Postthrombotisches Ulcus cruris",
      "Ulcus varicosum",
      "Ulcus varicosum der unteren Extremität",
      "Ulcus varicosum des Beins",
      "Ulkus bei Varicosis cruris",
      "Ulzerierte Venenvarikose",
      "Ulzeröse Varizen",
      "Ulzeröse Venenstauung",
      "Variköses Fußulkus",
      "Variköses Ulcus cruris",
      "Variköses Ulkus der unteren Extremität",
      "Varizen der unteren Extremität mit Geschwür",
      "Varizen der unteren Extremität mit Ulzeration",
      "Varizen des Beins mit Ulkus",
      "Varizen mit Ulcus cruris",
      "Varizen mit Ulkus",
      "Varizen mit Unterschenkelgeschwür"
    ]
  },
  {
    "code": "I83.1",
    "name": "Stauungsdermatose",
    "synonyms": [
      "Dermatitis hypostatica",
      "Dermatitis varicosa",
      "Ekzema varicosum",
      "Entzündete Varizen",
      "Entzündete Venenvarikose",
      "Hypostatische Dermatitis",
      "Hypostatisches Ekzem",
      "Infizierte Varizen",
      "Infizierte Venenvarikose",
      "Lipodermatosklerose",
      "Stauungsdermatitis",
      "Stauungsdermatose",
      "Stauungsekzem",
      "Superinfizierte Stauungsdermatose",
      "Varikophlebitis",
      "Varikothrombophlebitis",
      "Variköse Dermatitis",
      "Variköse Phlebitis",
      "Variköse Phlebitis der unteren Extremität",
      "Variköse Phlebitis des Beins",
      "Variköses Ekzem",
      "Varizen mit Entzündung",
      "Varizen mit Infektion",
      "Varizen mit Phlebitis",
      "Varizen mit Stauungsdermatose"
    ]
  },
  {
    "code": "I83.2",
    "name": "Ulcus cruris varicosum mit Entzündung",
    "synonyms": [
      "Entzündete Varizen mit Ulkus",
      "Entzündete Venenvarikose mit Ulkus",
      "Entzündetes variköses Ulkus",
      "Hypostatische Dermatitis bei Ulcus varicosum cruris",
      "Infizierte Varizen mit Ulkus",
      "Infizierte Venenvarikose mit Ulkus",
      "Infiziertes variköses Ulkus",
      "Stauungsdermatitis bei Ulcus cruris varicosum",
      "Ulcus cruris varicosum mit Entzündung",
      "Ulcus varicosum mit Entzündung",
      "Ulcus varicosum mit Infektion",
      "Ulzeröse Varizen mit Entzündung",
      "Ulzeröse Varizen mit Infektion",
      "Ulzeröse Venenstauung mit Entzündung",
      "Ulzeröse Venenstauung mit Infektion",
      "Variköse Phlebitis mit Ulkus",
      "Variköses Fußulkus mit Entzündung",
      "Variköses Fußulkus mit Infektion",
      "Variköses Ulkus der unteren Extremität mit Entzündung",
      "Variköses Ulkus der unteren Extremität mit Infektion",
      "Varizen mit Stauungsdermatose mit Geschwür"
    ]
  },
  {
    "code": "I83.9",
    "name": "Phlebektasie der unteren Extremität",
    "synonyms": [
      "Beidseitiger Status varicosus",
      "Beinkrampfadern",
      "Beinvarikose",
      "Beinvarikose mit Stauungsdermatose ohne Ulkus oder Entzündung",
      "Besenreiser",
      "Krampfaderbeschwerden",
      "Krampfadern",
      "Perforantenvarikose",
      "Phlebektasie",
      "Phlebektasie der unteren Extremität",
      "Prävarikose",
      "Retikuläre Varikose",
      "Rupturierte Varizen",
      "Seitenastvarikose",
      "Stamm- und Seitenastvarikose",
      "Stammvarikose",
      "Stammvarikose der Vena saphena magna",
      "Stammvarikose der Vena saphena parva",
      "Stammvarikose des Beins",
      "Stammvenenvarikose",
      "Status varicosus des Beins",
      "Unterschenkelvarikose",
      "Unterschenkelvarizen",
      "Varicosis - s.a. Varikose",
      "Varicosis cruris",
      "Varikose",
      "Varikose der Venae perforantes",
      "Varikose der unteren Extremität",
      "Varikose mit Ödem",
      "Variköse Venen des Beins",
      "Variköser Symptomenkomplex",
      "Varix - s.a. Varizen",
      "Varixknoten",
      "Varizen",
      "Varizen der unteren Extremität",
      "Varizenblutung der Extremitäten",
      "Varizenblutung des Beins",
      "Varizenblutung des Unterschenkels",
      "Varizenstauung",
      "Venektasie",
      "Venenknoten"
    ]
  },
  {
    "code": "I85.0",
    "name": "Ösophagusvarizenblutung",
    "synonyms": [
      "Blutende Venenvarikose des Ösophagus",
      "Blutendes Ulcus varicosum des Ösophagus",
      "Hämorrhagie bei Ösophagusvarizen",
      "Variköses blutendes Ulkus des Ösophagus",
      "Ösophagusvarizenblutung"
    ]
  },
  {
    "code": "I85.9",
    "name": "Ösophagusvarizen",
    "synonyms": [
      "Downhillvarizen",
      "Speiseröhrenvarizen",
      "Ulcus varicosum des Ösophagus",
      "Variköses Ösophagusulkus",
      "Venenvarikose des Ösophagus",
      "Ösophagusvarizen",
      "Ösophagusvarizen ohne Blutung"
    ]
  },
  {
    "code": "I86.0",
    "name": "Sublinguale Varizen",
    "synonyms": [
      "Sublinguale Varizen",
      "Sublinguale Venenvarikose"
    ]
  },
  {
    "code": "I86.1",
    "name": "Hodenvenenkonvolut",
    "synonyms": [
      "Hernia varicosa",
      "Hodenvarikozele",
      "Hodenvenenkonvolut",
      "Phlebektasie der Vena spermatica",
      "Skrotumphlebektasie",
      "Skrotumvarizen",
      "Thrombosierte Varikozele",
      "Ulcus varicosum des Skrotums",
      "Ulzeröse Samenstrangvarikozele",
      "Varicocele testis",
      "Varikose einer Skrotumvene",
      "Varikozele",
      "Varikozele des Plexus pampiniformis",
      "Varikozele des Skrotums",
      "Variköses Skrotumulkus",
      "Varizenbruch",
      "Venenkonvolut des Plexus pampiniformis"
    ]
  },
  {
    "code": "I86.2",
    "name": "Harnblasenphlebektasie",
    "synonyms": [
      "Beckenvarikose",
      "Beckenvarizen",
      "Harnblasenphlebektasie",
      "Harnblasenvarizen",
      "Mutterbandvarizen",
      "Ovarialvarikozele",
      "Ovarialvarizen",
      "Pelvivarikose",
      "Varikose einer Beckenvene",
      "Varikose einer pelvinen Vene",
      "Varizen des Ligamentum latum uteri"
    ]
  },
  {
    "code": "I86.3",
    "name": "Labienvarizen",
    "synonyms": [
      "Labienvarizen",
      "Varikose einer Vulvavene",
      "Varizen der Labia majora pudendi",
      "Vulvavarizen"
    ]
  },
  {
    "code": "I86.4",
    "name": "Fundusvarizen",
    "synonyms": [
      "Fundusvarizen",
      "Fundusvarizenblutung",
      "Kardiavarizen",
      "Kardiavarizenblutung",
      "Magenvarizen"
    ]
  },
  {
    "code": "I86.80",
    "name": "Dünndarmvarizen",
    "synonyms": [
      "Dünndarmvarizen"
    ]
  },
  {
    "code": "I86.81",
    "name": "Varizen des Colon sigmoideum",
    "synonyms": [
      "Dickdarmvarizen",
      "Kolonvarizen",
      "Varizen des Colon sigmoideum"
    ]
  },
  {
    "code": "I86.82",
    "name": "Rektumvarizen",
    "synonyms": [
      "Rektumvarizen"
    ]
  },
  {
    "code": "I86.88",
    "name": "Venendilatation",
    "synonyms": [
      "Aneurysma der Jugularisvene",
      "Caput medusae",
      "Orbitavarizen",
      "Pharynxvarizen",
      "Prostatavarizen",
      "Stimmbandvarizen",
      "Stimmlippenvarizen",
      "Ulcus varicosum des Nasenseptums",
      "Variköses Darmulkus",
      "Variköses Nasenulkus",
      "Variköses Ulcus septi nasi perforans",
      "Variköses Ulkus des Nasenseptums",
      "Varizen der Milzvene",
      "Varizen der Nierenpapille",
      "Varizen eines Rückenmarkgefäßes",
      "Venendilatation",
      "Venenerweiterung",
      "Venolendilatation a.n.k.",
      "Venöses Aneurysma"
    ]
  },
  {
    "code": "I87.00",
    "name": "Postthrombotisches Syndrom",
    "synonyms": [
      "PTS [Postthrombotisches Syndrom]",
      "Postphlebitisches Syndrom",
      "Postphlebitisches Syndrom ohne Ulzeration",
      "Postthrombotisches Syndrom",
      "Postthrombotisches Syndrom ohne Ulzeration"
    ]
  },
  {
    "code": "I87.01",
    "name": "Postphlebitische Ulzeration",
    "synonyms": [
      "Postphlebitische Ulzeration",
      "Postphlebitische Ulzeration der Beine",
      "Postphlebitisches Syndrom mit Ulzeration",
      "Postthrombotisches Syndrom mit Ulzeration"
    ]
  },
  {
    "code": "I87.1",
    "name": "Venenkompression",
    "synonyms": [
      "Beinödem durch Venenobstruktion",
      "Kompression der Vena cava inferior",
      "Kompression der Vena cava superior",
      "Obere Einflussstauung",
      "Obere und untere Einflussstauung",
      "Obstruktion der Vena cava inferior",
      "Obstruktion der Vena cava superior",
      "Stenose der Vena cava inferior",
      "Stenose der Vena cava superior",
      "Stenose der oberen Hohlvene",
      "Stenose der unteren Hohlvene",
      "Striktur der Vena cava inferior a.n.k.",
      "Striktur der Vena cava superior a.n.k.",
      "Vena-cava-Syndrom",
      "Vena-cava-inferior-Kompressionssyndrom",
      "Vena-cava-inferior-Okklusionssyndrom",
      "Vena-cava-inferior-Syndrom",
      "Vena-cava-superior-Kompressionssyndrom",
      "Vena-cava-superior-Okklusionssyndrom",
      "Vena-cava-superior-Syndrom",
      "Venenkompression",
      "Venenstenose",
      "Venenstriktur"
    ]
  },
  {
    "code": "I87.20",
    "name": "Venöse Insuffizienz - s.a. Chronisch-venöse Insuffizienz",
    "synonyms": [
      "CVI [Chronisch-venöse Insuffizienz]",
      "Chronisch-venöse Insuffizienz",
      "Chronisch-venöse Insuffizienz des Beins",
      "Chronisch-venöse periphere Insuffizienz",
      "Insuffizienz der Venae perforantes",
      "Leitveneninsuffizienz",
      "Perforanteninsuffizienz",
      "Venöse DBS [Durchblutungsstörung]",
      "Venöse Durchblutungsstörung",
      "Venöse Insuffizienz - s.a. Chronisch-venöse Insuffizienz"
    ]
  },
  {
    "code": "I87.21",
    "name": "Venöses Ulcus cruris ohne Varizen",
    "synonyms": [
      "Chronisch-venöse Insuffizienz mit Ulzeration",
      "Periphere venöse Insuffizienz mit Ulzeration",
      "Ulcus cruris durch venöse Insuffizienz",
      "Ulcus cruris nonvaricosum",
      "Venöse Insuffizienz der Beine mit Ulzeration",
      "Venöses Ulcus cruris ohne Varizen"
    ]
  },
  {
    "code": "I87.8",
    "name": "Phlebolith",
    "synonyms": [
      "Angiospastische Venenkrankheit",
      "Erhöhter Venendruck",
      "Kinking-Vene",
      "Phlebofibrose",
      "Phlebolith",
      "Phlebosklerose",
      "Venenfibrose",
      "Venenhypertrophie",
      "Venenknick",
      "Venensklerose",
      "Venenspasmus a.n.k.",
      "Venenstauung",
      "Venenstein",
      "Venenteilung",
      "Venöse Claudicatio intermittens",
      "Venöse Stase"
    ]
  },
  {
    "code": "I87.9",
    "name": "Phlebalgie",
    "synonyms": [
      "Chronisch-venöser Symptomenkomplex",
      "Phlebalgie",
      "Phlebopathie",
      "Venenkrankheit",
      "Venenleiden",
      "Venenschmerzen",
      "Venopathie",
      "Venöse Erkrankung mit Schmerzen",
      "Venöser Symptomenkomplex"
    ]
  },
  {
    "code": "I88.0",
    "name": "Unspezifische mesenteriale Lymphadenitis",
    "synonyms": [
      "Abszess der mesenterialen Lymphknoten",
      "Akute Lymphadenitis mesenterialis",
      "Akute mesenteriale Lymphadenitis",
      "Brenneman-Syndrom",
      "Chronische Lymphadenitis mesenterialis",
      "Chronische mesenteriale Lymphadenitis",
      "Lymphadenitis chronica mesenterialis",
      "Mesenteriale Lymphadenitis",
      "Mesenteriallymphknoteninfektion a.n.k.",
      "Pseudoappendizitis",
      "Subakute mesenteriale Lymphadenitis",
      "Unspezifische Lymphadenitis mesenterialis",
      "Unspezifische mesenteriale Lymphadenitis"
    ]
  },
  {
    "code": "I88.1",
    "name": "Chronische Leistendrüsenentzündung",
    "synonyms": [
      "Chronische Adenitis",
      "Chronische Adenitis cervicalis",
      "Chronische Leistendrüsenentzündung",
      "Chronische Lymphadenitis",
      "Chronische Lymphdrüsenentzündung",
      "Chronische axilläre Adenitis",
      "Chronische inguinale Adenitis",
      "Chronische zervikale Adenitis",
      "Kikuchi-Fujimoto-Krankheit",
      "Lymphadenitis chronica",
      "Subakute Adenitis",
      "Subakute Adenitis cervicalis",
      "Subakute axilläre Adenitis",
      "Subakute inguinale Adenitis",
      "Subakute zervikale Adenitis"
    ]
  },
  {
    "code": "I88.8",
    "name": "Adenosklerose",
    "synonyms": [
      "Adenosklerose",
      "Bubo",
      "Bubo inguinalis",
      "Lymphdrüsengranulom",
      "Regionale nichtbakterielle Lymphadenitis"
    ]
  },
  {
    "code": "I88.9",
    "name": "Lymphadenitis",
    "synonyms": [
      "Adenitis",
      "Adenitis cervicalis",
      "Axilläre Adenitis",
      "Generalisierte Lymphadenitis",
      "Inguinale Adenitis",
      "Lymphadenitis",
      "Lymphadenitis colli",
      "Lymphdrüsenentzündung",
      "Lymphknotenentzündung",
      "Lymphknoteninfiltration",
      "Polyadenitis",
      "Umschriebene Lymphadenitis",
      "Unspezifische Lymphadenitis",
      "Zervikale Adenitis"
    ]
  },
  {
    "code": "I89.00",
    "name": "Lymphödem der oberen Extremität, Stadium I",
    "synonyms": [
      "Lymphödem der oberen Extremität, Stadium I",
      "Lymphödem der unteren Extremität, Stadium I",
      "Primäres Lymphödem der oberen Extremität, Stadium I",
      "Primäres Lymphödem der unteren Extremität, Stadium I",
      "Spät-beginnendes primäres Lymphödem der oberen Extremität, Stadium I",
      "Spät-beginnendes primäres Lymphödem der unteren Extremität, Stadium I"
    ]
  },
  {
    "code": "I89.01",
    "name": "Lymphödem der oberen Extremität, Stadium II",
    "synonyms": [
      "Lymphödem der oberen Extremität, Stadium II",
      "Lymphödem der unteren Extremität, Stadium II",
      "Primäres Lymphödem der oberen Extremität, Stadium II",
      "Primäres Lymphödem der unteren Extremität, Stadium II",
      "Spät-beginnendes primäres Lymphödem der oberen Extremität, Stadium II",
      "Spät-beginnendes primäres Lymphödem der unteren Extremität, Stadium II"
    ]
  },
  {
    "code": "I89.02",
    "name": "Lymphödem der oberen Extremität, Stadium III",
    "synonyms": [
      "Elephantiasis der oberen Extremität",
      "Elephantiasis der unteren Extremität",
      "Lymphödem der oberen Extremität, Stadium III",
      "Lymphödem der unteren Extremität, Stadium III",
      "Primäres Lymphödem der oberen Extremität, Stadium III",
      "Primäres Lymphödem der unteren Extremität, Stadium III",
      "Spät-beginnendes primäres Lymphödem der oberen Extremität, Stadium III",
      "Spät-beginnendes primäres Lymphödem der unteren Extremität, Stadium III"
    ]
  },
  {
    "code": "I89.03",
    "name": "Lymphödem des Kopfes, Stadium I",
    "synonyms": [
      "Lymphödem der Thoraxwand, Stadium I",
      "Lymphödem des Genitalbereiches, Stadium I",
      "Lymphödem des Halses, Stadium I",
      "Lymphödem des Kopfes, Stadium I"
    ]
  },
  {
    "code": "I89.04",
    "name": "Lymphödem des Kopfes, Stadium II",
    "synonyms": [
      "Lymphödem der Thoraxwand, Stadium II",
      "Lymphödem des Genitalbereiches, Stadium II",
      "Lymphödem des Halses, Stadium II",
      "Lymphödem des Kopfes, Stadium II"
    ]
  },
  {
    "code": "I89.05",
    "name": "Orchelephantiasis",
    "synonyms": [
      "Glanduläre Elephantiasis",
      "Hodenelefantiasis",
      "Hodenelephantiasis",
      "Lymphödem der Thoraxwand, Stadium III",
      "Lymphödem des Genitalbereiches, Stadium III",
      "Lymphödem des Halses, Stadium III",
      "Lymphödem des Kopfes, Stadium III",
      "Orchelefantiasis",
      "Orchelephantiasis",
      "Peniselefantiasis",
      "Peniselephantiasis"
    ]
  },
  {
    "code": "I89.08",
    "name": "Latenzstadium des Lymphödems",
    "synonyms": [
      "Latenzstadium des Lymphödems"
    ]
  },
  {
    "code": "I89.09",
    "name": "Elephantiasis",
    "synonyms": [
      "Elefantiasis - s.a. Elephantiasis",
      "Elephantiasis",
      "Elephantiasis eines Lymphgefäßes",
      "Elephantiasis teleangiectodes",
      "Elephantiasis, nicht durch Filarien",
      "Intestinale Lymphangiektasie",
      "Lymphangiektasie",
      "Lymphangiektatische Elephantiasis",
      "Lymphatische Obstruktion",
      "Lymphatisches Ödem",
      "Lymphektasie",
      "Lymphgefäßdilatation",
      "Lymphgefäßerweiterung",
      "Lymphgefäßkompression",
      "Lymphgefäßobliteration",
      "Lymphgefäßverschluss",
      "Lymphoedema praecox",
      "Lymphödem",
      "Lymphödem des Arms",
      "Lymphödem des Beins",
      "Meige-ähnliche Krankheit",
      "Nicht-hereditäres primäres Lymphödem mit spätem Beginn",
      "Obstruktion des Ductus thoracicus",
      "Postinfektiöse Lymphangiektasie",
      "Primäre intestinale Lymphangiektasie",
      "Primäres Lymphödem",
      "Sekundäre intestinale Lymphangiektasie",
      "Sekundäres Lymphödem",
      "Spät-beginnendes primäres Lymphödem",
      "Verschluss des Ductus thoracicus",
      "Waldmann-Krankheit",
      "Ödem bei Lymphgefäßverschluss"
    ]
  },
  {
    "code": "I89.1",
    "name": "Lymphangitis",
    "synonyms": [
      "Chronische Lymphangitis",
      "Gangränöse Lymphangitis",
      "Lymphangitis",
      "Lymphgefäßentzündung",
      "Subakute Lymphangitis"
    ]
  },
  {
    "code": "I89.8",
    "name": "Lymphorrhoe",
    "synonyms": [
      "Ascites chylosus",
      "Chylektasie",
      "Chylozele",
      "Chylozele, nicht durch Filarien",
      "Chyluszyste",
      "Chylöser Aszites, nicht durch Filarien",
      "Extravasation von Lymphe ins Mesenterium",
      "Fistel des Ductus thoracicus",
      "Hyaline Lymphknotendegeneration",
      "Lipomelanotische Retikulose",
      "Lymphabflussstörung",
      "Lymphaszites",
      "Lymphatische Fistel",
      "Lymphatische Insuffizienz",
      "Lymphatische Stase",
      "Lymphfistel",
      "Lymphgefäßerosion",
      "Lymphgefäßruptur",
      "Lymphknotenfibrose",
      "Lymphknoteninfarkt",
      "Lymphknotenkalzifikation",
      "Lymphknotensklerose",
      "Lymphknotenverkalkung",
      "Lymphorrhagie",
      "Lymphorrhoe",
      "Lymphostase",
      "Lymphozele",
      "Lymphstauung",
      "Lymphzyste",
      "Pautrier-Woringer-Syndrom",
      "Postinfektiöse Lymphknotenkalzifikation",
      "Ruptur des Ductus thoracicus"
    ]
  },
  {
    "code": "I89.9",
    "name": "Lymphgefäßkrankheit",
    "synonyms": [
      "Lymphgefäßkrankheit",
      "Lymphknotenkrankheit"
    ]
  },
  {
    "code": "I95.0",
    "name": "Idiopathische Hypotonie",
    "synonyms": [
      "Idiopathische Hypotonie"
    ]
  },
  {
    "code": "I95.1",
    "name": "Orthostatische Hypotonie",
    "synonyms": [
      "Hypoadrenerge orthostatische Hypotension",
      "Hypotonie nach langem Stehen",
      "Orthostase",
      "Orthostasesyndrom",
      "Orthostatische Dysregulation",
      "Orthostatische Dysregulationsstörung",
      "Orthostatische Hypotonie",
      "Orthostatische Intoleranz durch NET [Noradrenalintransporter]-Mangel",
      "Orthostatische Kreislaufbeschwerden",
      "Orthostatische Regulationsstörung",
      "Orthostatischer Kollaps",
      "Orthostatisches Syndrom"
    ]
  },
  {
    "code": "I95.2",
    "name": "Hypotonie durch Arzneimittel",
    "synonyms": [
      "Arzneimittelinduzierte Hypotonie",
      "Hypotonie durch Arzneimittel",
      "Nitrit-Krise bei ordnungsgemäßer Verabreichung"
    ]
  },
  {
    "code": "I95.8",
    "name": "Chronische Hypotonie",
    "synonyms": [
      "Chronische Hypotonie"
    ]
  },
  {
    "code": "I95.9",
    "name": "Hypotone Kreislaufdysregulation",
    "synonyms": [
      "Arterielle Hypotonie",
      "Blutdruckabfall",
      "Hyposystolischer Druck",
      "Hypotension",
      "Hypotone Dysregulation",
      "Hypotone Kreislaufdysregulation",
      "Hypotone Kreislaufstörung",
      "Hypotone Regulationsstörung",
      "Hypotonie",
      "Hypotonie bei Kreislaufdysregulation",
      "Hypotonie durch Dysregulation",
      "Hypotonie mit Kreislaufbeschwerden",
      "Hypotonie mit Kreislaufschwäche",
      "Konstitutionelle Hypotonie",
      "Niederdruck (Blutdruck)",
      "Niedriger Blutdruck",
      "Symptomatische Hypotonie"
    ]
  },
  {
    "code": "I97.0",
    "name": "Postkardiotomiesyndrom",
    "synonyms": [
      "Postkardiotomiesyndrom",
      "Postkommissurotomiesyndrom",
      "Postvalvulotomiesyndrom"
    ]
  },
  {
    "code": "I97.1",
    "name": "Funktionsstörung nach Herzoperation",
    "synonyms": [
      "Angina pectoris bei Stentstenose",
      "Funktionsstörung nach Herzoperation",
      "Herzinsuffizienz durch Herzprothese",
      "Herzinsuffizienz nach Herzoperation",
      "Herzinsuffizienz nach kardiochirurgischem Eingriff",
      "Herzversagen durch Herzprothese",
      "Herzversagen nach Herzoperation",
      "Herzversagen nach kardiochirurgischem Eingriff",
      "Postkardiotomiesyndrom mit Rechtsherzversagen",
      "Postoperative kardiale Dysrhythmie als Langzeitwirkung nach Herzoperation",
      "Postoperativer Herzstillstand als Langzeitwirkung nach Herzoperation",
      "Schrittmachersyndrom",
      "Störung der Herzfunktion durch Herzprothese"
    ]
  },
  {
    "code": "I97.20",
    "name": "Lymphödem nach partieller Mastektomie mit Lymphadenektomie, Stadium I",
    "synonyms": [
      "Lymphödem nach Mastektomie mit Lymphadenektomie, Stadium I",
      "Lymphödem nach Mastektomie, Stadium I",
      "Lymphödem nach partieller Mastektomie mit Lymphadenektomie, Stadium I"
    ]
  },
  {
    "code": "I97.21",
    "name": "Lymphödem nach partieller Mastektomie mit Lymphadenektomie, Stadium II",
    "synonyms": [
      "Lymphödem nach Mastektomie mit Lymphadenektomie, Stadium II",
      "Lymphödem nach Mastektomie, Stadium II",
      "Lymphödem nach partieller Mastektomie mit Lymphadenektomie, Stadium II"
    ]
  },
  {
    "code": "I97.22",
    "name": "Elephantiasis nach Mastektomie",
    "synonyms": [
      "Elefantiasis nach Mastektomie",
      "Elephantiasis nach Brustamputation",
      "Elephantiasis nach Mastektomie",
      "Lymphödem nach Mastektomie mit Lymphadenektomie, Stadium III",
      "Lymphödem nach Mastektomie, Stadium III",
      "Lymphödem nach partieller Mastektomie mit Lymphadenektomie, Stadium III"
    ]
  },
  {
    "code": "I97.29",
    "name": "Postmastektomiesyndrom",
    "synonyms": [
      "Lymphgefäßobliteration nach Brustamputation",
      "Lymphgefäßverschluss nach Mastektomie",
      "Lymphödem nach Ablatio mammae",
      "Lymphödem nach Mastektomie",
      "Lymphödemsyndrom nach Brustamputation",
      "Oberarmlymphödem nach Mastektomie",
      "Postmastektomie-Ödem",
      "Postmastektomiesyndrom"
    ]
  },
  {
    "code": "I97.80",
    "name": "Lymphödem nach medizinischen Maßnahmen am zervikalen Lymphabflussgebiet",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am zervikalen Lymphabflussgebiet"
    ]
  },
  {
    "code": "I97.81",
    "name": "Lymphödem nach medizinischen Maßnahmen am axillären Lymphabflussgebiet, Stadium I",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am axillären Lymphabflussgebiet, Stadium I"
    ]
  },
  {
    "code": "I97.82",
    "name": "Lymphödem nach medizinischen Maßnahmen am axillären Lymphabflussgebiet, Stadium II",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am axillären Lymphabflussgebiet, Stadium II"
    ]
  },
  {
    "code": "I97.83",
    "name": "Lymphödem nach medizinischen Maßnahmen am axillären Lymphabflussgebiet, Stadium III",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am axillären Lymphabflussgebiet, Stadium III"
    ]
  },
  {
    "code": "I97.84",
    "name": "Lymphödem nach medizinischen Maßnahmen am inguinalen Lymphabflussgebiet, Stadium I",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am inguinalen Lymphabflussgebiet, Stadium I"
    ]
  },
  {
    "code": "I97.85",
    "name": "Lymphödem nach medizinischen Maßnahmen am inguinalen Lymphabflussgebiet, Stadium II",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am inguinalen Lymphabflussgebiet, Stadium II"
    ]
  },
  {
    "code": "I97.86",
    "name": "Lymphödem nach medizinischen Maßnahmen am inguinalen Lymphabflussgebiet, Stadium III",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am inguinalen Lymphabflussgebiet, Stadium III"
    ]
  },
  {
    "code": "I97.87",
    "name": "Lymphödem nach medizinischen Maßnahmen am Urogenitalsystem",
    "synonyms": [
      "Lymphödem nach medizinischen Maßnahmen am Genitalbereich",
      "Lymphödem nach medizinischen Maßnahmen am Urogenitalsystem",
      "Lymphödem nach medizinischen Maßnahmen am Uterus",
      "Lymphödem nach medizinischen Maßnahmen an den Adnexen",
      "Lymphödem nach medizinischen Maßnahmen an der Harnblase",
      "Lymphödem nach medizinischen Maßnahmen an der Prostata"
    ]
  },
  {
    "code": "I97.88",
    "name": "Elephantiasis nach chirurgischem Eingriff",
    "synonyms": [
      "Elephantiasis nach chirurgischem Eingriff",
      "Lymphödem nach chirurgischem Eingriff a.n.k.",
      "Lymphödem nach medizinischen Maßnahmen an der Thoraxwand"
    ]
  },
  {
    "code": "I97.89",
    "name": "Postoperative kardiale Dysrhythmie",
    "synonyms": [
      "Herzversagen nach operativem Eingriff",
      "Postoperative Herzfunktionsstörung",
      "Postoperative Herzinsuffizienz",
      "Postoperative kardiale Dysrhythmie",
      "Postoperativer Herzstillstand",
      "Postoperatives Herzversagen"
    ]
  },
  {
    "code": "I97.9",
    "name": "Postoperative kardiale Komplikation",
    "synonyms": [
      "Gefäßkomplikation nach medizinischen Maßnahmen",
      "Kardiale Komplikation nach chirurgischem Eingriff",
      "Kreislaufkomplikation nach chirurgischem Eingriff",
      "Kreislaufkomplikation nach medizinischen Maßnahmen",
      "Postoperative Kreislaufkomplikation",
      "Postoperative kardiale Komplikation"
    ]
  },
  {
    "code": "I99",
    "name": "Gefäßstenose",
    "synonyms": [
      "Altersbedingte Kreislaufstörung",
      "Angiektasie",
      "Angiektopie",
      "Angiolith",
      "Angioorganopathie",
      "Angiopathia",
      "Angiopathie",
      "Arteriovenöse Durchblutungsstörung",
      "Arteriovenöse Insuffizienz",
      "Blutgefäßdilatation",
      "Blutgefäßkrankheit",
      "Blutgefäßverschluss",
      "Blutleere",
      "Chronische Ischämie",
      "DBS [Durchblutungsstörung]",
      "Durchblutungsstörung",
      "Extremitätenischämie",
      "Gefäßdissektion",
      "Gefäßektasie",
      "Gefäßkrankheit",
      "Gefäßobstruktion a.n.k.",
      "Gefäßschaden",
      "Gefäßschwäche",
      "Gefäßstein",
      "Gefäßstenose",
      "Gefäßstörung",
      "Gefäßverschluss",
      "Ischämie",
      "Kollateralkreislauf",
      "Krankheit des Kreislaufsystems a.n.k.",
      "Kreislaufaffektion",
      "Kreislaufbeschwerden",
      "Kreislaufdefekt",
      "Kreislaufdysregulation",
      "Kreislaufinsuffizienz a.n.k.",
      "Kreislaufkomplikation",
      "Kreislaufkrankheit a.n.k.",
      "Kreislauflabilität",
      "Kreislaufschaden",
      "Kreislaufschwäche",
      "Kreislaufstauung a.n.k.",
      "Kreislaufstörung",
      "Labiler Blutdruck",
      "Lokaler vaskulärer Defekt",
      "Makroangiopathie",
      "Mangeldurchblutung",
      "Okklusive Gefäßkrankheit",
      "Schwankender Blutdruck",
      "Störung des Kreislaufsystems",
      "Vaskuläre Atrophie",
      "Vaskuläre Insuffizienz",
      "Vaskuläre Störung",
      "Vaskulärer Verschluss a.n.k.",
      "Vasolabilität",
      "Vasopathie",
      "Vegetative Kreislaufstörung",
      "Vegetatives Kreislaufproblem"
    ]
  },
  {
    "code": "J00",
    "name": "Epipharyngitis",
    "synonyms": [
      "Afebrile Erkältung",
      "Akute Koryza",
      "Akute Nasenrachenraumentzündung",
      "Akute Nasopharyngitis",
      "Akute Rhinitis",
      "Akute Rhinopharyngitis",
      "Akute eitrige Rhinitis",
      "Akuter Katarrh",
      "Akuter Nasenkatarrh",
      "Akuter Nasenrachenraumkatarrh",
      "Akuter Schnupfen",
      "Akuter rhinopharyngealer Katarrh",
      "Eitrige Rhinopharyngitis",
      "Entzündlicher Katarrh",
      "Epipharyngitis",
      "Erkältung",
      "Erkältung mit Fieber",
      "Erkältung ohne Fieber",
      "Erkältungsinfekt",
      "Erkältungsinfekt mit Fieber",
      "Erkältungskrankheit",
      "Erkältungsschnupfen",
      "Fieberhafter Katarrh",
      "Fiebrige Rhinopharyngitis",
      "Infektiöse Rhinitis",
      "Infektiöse Rhinopharyngitis",
      "Infektiöser Katarrh",
      "Katarrh",
      "Koryza",
      "Naseninfektion",
      "Nasenrachenraumentzündung",
      "Nasenrachenrauminfektion",
      "Nasenschleimhautinfektion",
      "Nasopharyngitis",
      "Rhinopharyngitis",
      "Schnupfen",
      "Septische Rhinopharyngitis",
      "Subakute Rhinopharyngitis"
    ]
  },
  {
    "code": "J01.0",
    "name": "Akute Entzündung der Kiefernebenhöhle",
    "synonyms": [
      "Akute Entzündung der Kiefernebenhöhle",
      "Akute Kieferhöhlenentzündung",
      "Akute Kieferhöhleninfektion",
      "Akute Kieferhöhlenvereiterung",
      "Akute Sinusitis der Kieferhöhle",
      "Akute Sinusitis maxillaris",
      "Akuter Kieferhöhlenabszess",
      "Akutes Kieferhöhlenempyem"
    ]
  },
  {
    "code": "J01.1",
    "name": "Akute Sinusitis frontalis",
    "synonyms": [
      "Akute Sinusitis der Stirnhöhle",
      "Akute Sinusitis frontalis",
      "Akute Stirnhöhlenentzündung",
      "Akute Stirnhöhleninfektion",
      "Akute Stirnhöhlenvereiterung",
      "Akuter Stirnhöhlenabszess",
      "Akutes Stirnhöhlenempyem"
    ]
  },
  {
    "code": "J01.2",
    "name": "Akute Siebbeinhöhlenentzündung",
    "synonyms": [
      "Akute Ethmoiditis",
      "Akute Siebbeinhöhlenentzündung",
      "Akute Siebbeinhöhleninfektion",
      "Akute Siebbeinhöhlenvereiterung",
      "Akute Sinusitis der Siebbeinhöhle",
      "Akute Sinusitis ethmoidalis",
      "Akuter Siebbeinhöhlenabszess",
      "Akutes Siebbeinhöhlenempyem"
    ]
  },
  {
    "code": "J01.3",
    "name": "Akute Sinusitis sphenoidalis",
    "synonyms": [
      "Akute Keilbeinhöhlenentzündung",
      "Akute Keilbeinhöhleninfektion",
      "Akute Keilbeinhöhlenvereiterung",
      "Akute Sinusitis der Keilbeinhöhle",
      "Akute Sinusitis sphenoidalis",
      "Akuter Keilbeinhöhlenabszess",
      "Akutes Keilbeinhöhlenempyem"
    ]
  },
  {
    "code": "J01.4",
    "name": "Akute Pansinusitis",
    "synonyms": [
      "Akute Abszesse in allen Nasennebenhöhlen",
      "Akute Entzündung aller Nasennebenhöhlen",
      "Akute Infektion aller Nasennebenhöhlen",
      "Akute Pansinusitis",
      "Akute komplette Nasennebenhöhlenvereiterung",
      "Akutes komplettes Nasennebenhöhlenempyem"
    ]
  },
  {
    "code": "J01.8",
    "name": "Sinusitis maxillaris mit akuter Sinusitis ethmoidalis",
    "synonyms": [
      "Akute Nebenhöhlenentzündung mit akuter Stirnhöhlenentzündung",
      "Akute Sinusitis maxillaris mit akuter Sinusitis ethmoidalis",
      "Akute Sinusitis maxillaris mit akuter Sinusitis frontalis",
      "Sinusitis maxillaris mit akuter Sinusitis ethmoidalis"
    ]
  },
  {
    "code": "J01.9",
    "name": "Akute Sinusitis",
    "synonyms": [
      "Akute Nasennebenhöhlenentzündung",
      "Akute Nasennebenhöhleninfektion",
      "Akute Nasennebenhöhlenvereiterung",
      "Akute Nebenhöhlenentzündung",
      "Akute Rhinosinusitis",
      "Akute Sinusitis",
      "Akute fiebrige Sinusitis",
      "Akute toxische Sinusitis",
      "Akuter Nasennebenhöhlenabszess",
      "Akuter Nasennebenhöhlenkatarrh",
      "Akutes Nasennebenhöhlenempyem"
    ]
  },
  {
    "code": "J02.0",
    "name": "Halsentzündung durch Streptokokken",
    "synonyms": [
      "Halsentzündung durch Streptokokken",
      "Pharyngitis durch Streptokokken",
      "Rachenentzündung durch Streptokokken",
      "Racheninfektion durch Streptokokken",
      "Rachensepsis durch Streptokokken",
      "Septische Halsentzündung durch Streptokokken",
      "Septische Pharyngitis durch Streptokokken",
      "Septisches Rachengeschwür durch Streptokokken"
    ]
  },
  {
    "code": "J02.8",
    "name": "Pharyngitis durch Viren",
    "synonyms": [
      "Pharyngitis durch Viren",
      "Virusinfektion des Rachens a.n.k."
    ]
  },
  {
    "code": "J02.9",
    "name": "Akute Pharyngitis",
    "synonyms": [
      "Akute Halsentzündung",
      "Akute Pharyngitis",
      "Akute Pharynxentzündung",
      "Akute Rachenentzündung",
      "Akute Seitenstrangangina",
      "Akute eitrige Pharyngitis",
      "Akute fieberhafte Racheninfektion",
      "Akute gangränöse Pharyngitis",
      "Akute infektiöse Pharyngitis",
      "Akute ulzeröse Pharyngitis",
      "Akuter Racheninfekt",
      "Akuter Rachenkatarrh",
      "Allergische Pharyngitis",
      "Eitrige Pharyngitis",
      "Eitrige Seitenstrangangina",
      "Fieberhafte Halsentzündung",
      "Fieberhafte Racheninfektion",
      "Fiebrige Pharyngitis",
      "Gangränöse Pharyngitis",
      "Halsentzündung",
      "Halsinfekt",
      "Halsinfektion",
      "Hypopharynxinfektion",
      "Infektiöse Pharyngitis",
      "Katarrhalische Pharyngitis",
      "Pharyngitis",
      "Pharyngitis lateralis",
      "Pharyngitis vesiculosa",
      "Pharynxgangrän",
      "Pharynxinfektion",
      "Pharynxnekrose",
      "Purulente Pharyngitis",
      "Putride Pharyngitis",
      "Rachenentzündung",
      "Rachengangrän",
      "Racheninfektion",
      "Rachenkatarrh",
      "Seitenstrangangina",
      "Seitenstrangentzündung",
      "Subakute Pharyngitis",
      "Suppurative Pharyngitis",
      "Ulzeröse Halsentzündung",
      "Ulzeröse Pharyngitis"
    ]
  },
  {
    "code": "J03.0",
    "name": "Angina durch Streptokokken",
    "synonyms": [
      "Angina durch Streptokokken",
      "Angina tonsillaris mit Streptokokkennachweis",
      "Eitrige Angina durch Streptokokken",
      "Septische Angina durch Streptokokken",
      "Tonsillitis durch Streptokokken"
    ]
  },
  {
    "code": "J03.8",
    "name": "Akute Angina",
    "synonyms": [
      "Akute Angina",
      "Akute Angina durch Viren",
      "Akute fieberhafte Angina",
      "Tonsillitis durch Viren a.n.k."
    ]
  },
  {
    "code": "J03.9",
    "name": "Zungengrundangina",
    "synonyms": [
      "Adenoidinfektion",
      "Adenoiditis",
      "Akute Adenoiditis",
      "Akute Angina simplex",
      "Akute Mandelentzündung",
      "Akute Tonsilleninfektion",
      "Akute Tonsillitis",
      "Akute gangränöse Tonsillitis",
      "Akute infektiöse Angina",
      "Akute infektiöse Tonsillitis",
      "Akute toxische Angina",
      "Akute ulzeröse Tonsillitis",
      "Akute vesikuläre Angina",
      "Angina",
      "Angina catarrhalis",
      "Angina follicularis",
      "Angina lacunaris",
      "Angina lacunaris follicularis",
      "Angina lingualis",
      "Angina phlegmonosa",
      "Angina purulenta",
      "Angina tonsillaris",
      "Eitrige Angina",
      "Eitrige Angina tonsillaris",
      "Eitrige Tonsillitis",
      "Entzündung der Tonsilla pharyngea",
      "Fieberhafte Angina tonsillaris",
      "Fieberhafte Tonsillitis",
      "Gangränöse Tonsillitis",
      "Infektiöse Tonsillitis",
      "Katarrhalische Angina",
      "Kruppöse Angina",
      "Kryptentonsillitis",
      "Linguale Tonsillitis",
      "Mandeleiterung",
      "Mandelentzündung - s.a. Tonsillitis",
      "Parenchymatöse Tonsillitis",
      "Rachenmandelentzündung",
      "Retronasale Angina",
      "Rezidivierende Tonsillitis",
      "Septische Angina",
      "Septische Tonsillitis",
      "Subakute Angina",
      "Subakute Tonsilleninfektion",
      "Subakute Tonsillitis",
      "Tonsilleneiterung",
      "Tonsillenentzündung",
      "Tonsilleninfektion",
      "Tonsillitis",
      "Tonsillitis catarrhalis",
      "Tonsillitis follicularis",
      "Tonsillitis lacunaris",
      "Tonsillitis lingualis",
      "Tonsillitis phlegmonosa",
      "Ulzerierende Tonsillitis",
      "Ulzeröse Tonsillitis",
      "Zungengrundangina",
      "Zungengrundtonsillitis"
    ]
  },
  {
    "code": "J04.0",
    "name": "Laryngitis",
    "synonyms": [
      "Akute Kehlkopfentzündung",
      "Akute Laryngitis",
      "Akute Larynxentzündung",
      "Akute Rhinolaryngitis",
      "Akute eitrige Laryngitis",
      "Akute spasmodische Laryngitis",
      "Akute subglottische Laryngitis",
      "Akute ulzeröse Laryngitis",
      "Akute ödematöse Laryngitis",
      "Eitrige Laryngitis",
      "Fieberhafte Laryngitis",
      "Glottisentzündung",
      "Heiserkeit bei Laryngitis",
      "Kehlkopfentzündung - s.a. Laryngitis",
      "Laryngitis",
      "Laryngitis subglottica",
      "Laryngitis ulcerosa",
      "Larynxentzündung",
      "Purulente Laryngitis",
      "Subglottische Laryngitis",
      "Suppurative Laryngitis",
      "Ulzeröse Laryngitis",
      "Ödematöse Laryngitis"
    ]
  },
  {
    "code": "J04.1",
    "name": "Luftröhrenentzündung",
    "synonyms": [
      "Akute Luftröhrenentzündung",
      "Akute Tracheitis",
      "Akute katarrhalische Tracheitis",
      "Fiebrige Tracheitis",
      "Infantile Tracheitis",
      "Infektionstracheitis",
      "Infekttracheitis",
      "Katarrhalische Tracheitis",
      "Luftröhrenentzündung",
      "Luftröhrenkatarrh",
      "Membranöse Tracheitis",
      "Peritracheitis",
      "Plastische Tracheitis",
      "Rhinotrachealkatarrh",
      "Rhinotracheitis",
      "Tracheaentzündung",
      "Trachealer Katarrh",
      "Trachealkatarrh",
      "Tracheitis",
      "Tracheitis durch Zytomegalieviren",
      "Zytomegalie-Tracheitis"
    ]
  },
  {
    "code": "J04.2",
    "name": "Laryngotracheitis",
    "synonyms": [
      "Akute Laryngotracheitis",
      "Akute Tracheolaryngitis",
      "Fieberhafte Tracheolaryngitis",
      "Infektiöse Laryngotracheitis",
      "Laryngotracheitis",
      "Laryngotracheitis catarrhalis",
      "Tracheitis mit Laryngitis",
      "Tracheolaryngitis"
    ]
  },
  {
    "code": "J05.0",
    "name": "Croup - s.a. Laryngitis, obstruktiv, akut",
    "synonyms": [
      "Akute obstruktive Laryngitis",
      "Akute spasmodische Laryngotracheitis",
      "Croup - s.a. Laryngitis, obstruktiv, akut",
      "Entzündlicher Croup",
      "Entzündlicher Krupp",
      "Infektiöser Croup",
      "Infektiöser Krupp",
      "Katarrhalischer Croup",
      "Katarrhalischer Krupp",
      "Krupp - s.a. Laryngitis, obstruktiv, akut",
      "Laryngitis mit obstruktiver Tracheitis",
      "Laryngitis stridulus",
      "Nichtdiphtherischer Croup",
      "Nichtdiphtherischer Krupp",
      "Obstruktive Laryngitis",
      "Obstruktive subglottische Laryngotracheitis",
      "Spasmodische Laryngitis",
      "Stenosierende Laryngotracheitis"
    ]
  },
  {
    "code": "J05.1",
    "name": "Akute Epiglottitis",
    "synonyms": [
      "Akute Epiglottisentzündung",
      "Akute Epiglottitis",
      "Akute Kehldeckelentzündung",
      "Epiglottisphlegmone",
      "Epiglottitis"
    ]
  },
  {
    "code": "J06.0",
    "name": "Akute Laryngopharyngitis",
    "synonyms": [
      "Akute Laryngopharyngitis",
      "Akute Pharyngolaryngitis",
      "Akute Rhinopharyngolaryngitis",
      "Hypopharyngitis",
      "Laryngopharyngitis",
      "Pharyngolaryngitis",
      "Pharyngorhinolaryngitis",
      "Rhinopharyngolaryngitis"
    ]
  },
  {
    "code": "J06.8",
    "name": "Akute Sinupharyngitis",
    "synonyms": [
      "Akute Infektion der oberen Atemwege multiplen Sitzes",
      "Akute Infektion der oberen Luftwege multiplen Sitzes",
      "Akute Pharyngolaryngotracheitis",
      "Akute Pharyngotracheitis",
      "Akute Rhinopharyngotracheitis",
      "Akute Sinularyngitis",
      "Akute Sinupharyngitis",
      "Akute Sinutracheitis",
      "Akute Tracheopharyngitis",
      "Laryngopharyngotracheitis",
      "Pharyngolaryngotracheitis",
      "Pharyngotonsillitis",
      "Pharyngotracheitis",
      "Rhinopharyngotracheitis",
      "Rhinosinutracheitis",
      "Tonsillopharyngitis",
      "Tracheopharyngitis"
    ]
  },
  {
    "code": "J06.9",
    "name": "Husten bei grippalem Infekt",
    "synonyms": [
      "Akute Erkrankung der oberen Atemwege",
      "Akute Infektion der oberen Atemwege",
      "Akute Infektion der oberen Luftwege",
      "Akuter Katarrh der oberen Atemwege",
      "Akuter Katarrh der oberen Luftwege",
      "Akuter kombinierter Atemwegekatarrh",
      "Akuter kombinierter Luftwegekatarrh",
      "Entzündung der oberen Atmungsorgane",
      "Fieberhafte Infektion der oberen Atemwege",
      "Fieberhafte Infektion der oberen Luftwege",
      "Fieberhafter Infekt der oberen Luftwege",
      "Fieberhafter grippaler Infekt",
      "Grippale Atemwegsinfektion",
      "Grippale Infektion",
      "Grippale Infektion mit Infektion der Atemwege",
      "Grippale Infektion mit Infektion der Atmungsorgane",
      "Grippale Infektion mit bakterieller Superinfektion",
      "Grippale Luftwegsinfektion",
      "Grippale Virusinfektion",
      "Grippaler Infekt",
      "Grippaler Infekt mit Infektion der Atemwege",
      "Grippaler Infekt mit Infektion der Atmungsorgane",
      "Grippaler Infekt mit Infektion der Luftwege",
      "Grippaler Infekt mit bakterieller Superinfektion",
      "Grippe [Grippaler Infekt]",
      "Hochfieberhafter grippaler Infekt",
      "Husten bei grippalem Infekt",
      "Infekt der oberen Atemwege",
      "Infekt der oberen Luftwege",
      "Infektion der oberen Atemwege",
      "Rezidivierende Infektion der oberen Atemwege",
      "Rezidivierender Infekt der oberen Atemwege",
      "Virusinfektion der oberen Atmungsorgane a.n.k."
    ]
  },
  {
    "code": "J09",
    "name": "Grippe [Influenza] mit Enteritis, zoonotische oder pandemische Influenzaviren nachgewiesen",
    "synonyms": [
      "Grippe [Influenza] mit Enteritis, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Gastroenteritis, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Infektion der oberen Atemwege, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Laryngitis, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Meningismus, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Pharyngitis, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Pleuraerguss, zoonotische oder pandemische Influenzaviren nachgewiesen",
      "Grippe [Influenza] mit Pneumonie, zoonotische oder pandemische Influenzaviren nachgewiesen"
    ]
  },
  {
    "code": "J10.0",
    "name": "Bronchopneumonie bei Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
    "synonyms": [
      "Bronchopneumonie bei Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippepneumonie [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Influenza mit Pneumonie, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus"
    ]
  },
  {
    "code": "J10.1",
    "name": "Influenza, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
    "synonyms": [
      "Akute Infektion der oberen Atemwege, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Asiatische Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Echte Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Epidemische Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippe [Influenza] mit Infektion der oberen Atemwege, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippe [Influenza] mit Laryngitis, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippe [Influenza] mit Pharyngitis, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippevirusinfektion, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Hochfieberhafte Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Influenza, saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Pleuraerguss bei Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus"
    ]
  },
  {
    "code": "J10.8",
    "name": "Enteritis bei Grippe [Influenza], saisonale Influenzaviren nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
    "synonyms": [
      "Enteritis bei Grippe [Influenza], saisonale Influenzaviren nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Gastroenteritis bei Grippe [Influenza], saisonale Influenzaviren nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus",
      "Grippe [Influenza], Influenzaviren B und C nachgewiesen",
      "Meningismus bei Grippe [Influenza], saisonaler Influenzavirus nachgewiesen, ausgenommen Vogelgrippe- und Schweinegrippe-Virus"
    ]
  },
  {
    "code": "J11.0",
    "name": "Grippepneumonie [Influenza] ohne Virusnachweis",
    "synonyms": [
      "Grippe [Influenza] mit Bronchopneumonie",
      "Grippebronchopneumonie [Influenza] ohne Virusnachweis",
      "Grippepneumonie [Influenza]",
      "Grippepneumonie [Influenza] ohne Virusnachweis",
      "Influenza mit Lobärpneumonie",
      "Influenza mit Pneumonie",
      "Viruspneumonie mit Grippe [Influenza]"
    ]
  },
  {
    "code": "J11.1",
    "name": "Grippe [Influenza] mit Seitenstrangangina",
    "synonyms": [
      "Asiatische Grippe [Influenza]",
      "Bronchiale Grippe [Influenza]",
      "Bronchitis bei Influenza",
      "Echte Grippe [Influenza] ohne Virusnachweis",
      "Epidemische Grippe [Influenza]",
      "Epidemische Grippe [Influenza] ohne Virusnachweis",
      "Erkältung mit Grippe [Influenza]",
      "Erkältung mit Influenza",
      "Ethmoiditis bei Grippe [Influenza]",
      "Ethmoiditis bei Influenza",
      "Grippale Bronchitis",
      "Grippale Virusinfektion [Influenza]",
      "Grippe [Influenza]",
      "Grippe [Influenza] mit Angina",
      "Grippe [Influenza] mit Husten",
      "Grippe [Influenza] mit Infektion der oberen Atemwege a.n.k.",
      "Grippe [Influenza] mit Koryza",
      "Grippe [Influenza] mit Laryngitis",
      "Grippe [Influenza] mit Laryngotracheitis",
      "Grippe [Influenza] mit Manifestation an den Atmungsorganen a.n.k.",
      "Grippe [Influenza] mit Pharyngitis",
      "Grippe [Influenza] mit Pleuraerguss",
      "Grippe [Influenza] mit Pleuritis",
      "Grippe [Influenza] mit Seitenstrangangina",
      "Grippe [Influenza] mit Sinusitis",
      "Grippe [Influenza] mit Tonsillitis",
      "Grippe [Influenza] ohne Virusnachweis",
      "Grippebronchiolitis [Influenza]",
      "Grippebronchitis [Influenza]",
      "Grippetracheitis [Influenza]",
      "Grippevirusinfektion [Influenzavirus]",
      "Hochfieberhafte Grippe [Influenza]",
      "Influenza - s.a. Grippe",
      "Influenza mit Laryngitis",
      "Influenza mit Pharyngitis",
      "Influenza mit Tonsillitis",
      "Influenza ohne Virusnachweis",
      "Tracheobronchitis bei Grippe [Influenza]",
      "Tracheobronchitis bei Influenza",
      "Virusgrippe [Influenza]"
    ]
  },
  {
    "code": "J11.8",
    "name": "Grippe [Influenza] mit Magen-Darm-Beteiligung",
    "synonyms": [
      "Darmgrippe [Influenza]",
      "Grippe [Influenza] mit Arthralgie",
      "Grippe [Influenza] mit Beteiligung des Nervensystems a.n.k.",
      "Grippe [Influenza] mit Enteritis",
      "Grippe [Influenza] mit Gastroenteritis",
      "Grippe [Influenza] mit Magen-Darm-Beteiligung",
      "Grippe [Influenza] mit Manifestation an den Verdauungsorganen",
      "Grippe [Influenza] mit bakterieller Superinfektion",
      "Grippe [Influenza] mit gastrointestinaler Beteiligung",
      "Intestinale Grippe [Influenza]",
      "Magen-Darm-Grippe [Influenza]",
      "Magengrippe [Influenza]",
      "Meningismus bei Grippe [Influenza]"
    ]
  },
  {
    "code": "J12.0",
    "name": "Pneumonie durch Adenoviren",
    "synonyms": [
      "Pneumonie durch Adenoviren"
    ]
  },
  {
    "code": "J12.1",
    "name": "Pneumonie durch Respiratory-Syncytial-Viren [RS-Viren]",
    "synonyms": [
      "Pneumonie durch Respiratory-Syncytial-Viren [RS-Viren]",
      "Respiratory-Syncytial-Viren-Infektion"
    ]
  },
  {
    "code": "J12.2",
    "name": "Pneumonie durch Parainfluenzaviren",
    "synonyms": [
      "Pneumonie durch Parainfluenzaviren"
    ]
  },
  {
    "code": "J12.3",
    "name": "Pneumonie durch humanes Metapneumovirus",
    "synonyms": [
      "Pneumonie durch humanes Metapneumovirus"
    ]
  },
  {
    "code": "J12.9",
    "name": "Viruspneumonie",
    "synonyms": [
      "Bronchopneumonie durch Viren",
      "Lobärpneumonie durch Viren",
      "Pneumonie durch Viren",
      "Viruspneumonie"
    ]
  },
  {
    "code": "J13",
    "name": "Pneumonie durch Pneumokokken",
    "synonyms": [
      "Bronchopneumonie durch Pneumokokken",
      "Bronchopneumonie durch Streptococcus pneumoniae",
      "Lobärpneumonie durch Pneumokokken",
      "Lobärpneumonie durch Streptococcus pneumoniae",
      "Pneumonie durch Pneumokokken",
      "Pneumonie durch Pneumokokken mit Sepsis",
      "Pneumonie durch Streptococcus pneumoniae",
      "Pyämische Embolie durch Pneumokokken mit Pneumonie"
    ]
  },
  {
    "code": "J14",
    "name": "Pneumonie durch Haemophilus influenzae",
    "synonyms": [
      "Bronchopneumonie durch Haemophilus influenzae",
      "Lobärpneumonie durch Haemophilus influenzae",
      "Pneumonie durch Haemophilus influenzae"
    ]
  },
  {
    "code": "J15.0",
    "name": "Pneumonie durch Klebsiella pneumoniae",
    "synonyms": [
      "Bronchopneumonie durch Friedländer-Bakterien",
      "Bronchopneumonie durch Klebsiella pneumoniae",
      "Friedländer-Pneumonie",
      "Lobärpneumonie durch Friedländer-Bakterien",
      "Lobärpneumonie durch Klebsiella pneumoniae",
      "Pneumonie durch Klebsiella pneumoniae"
    ]
  },
  {
    "code": "J15.1",
    "name": "Pneumonie durch Pseudomonas",
    "synonyms": [
      "Bronchopneumonie durch Pseudomonas",
      "Lobärpneumonie durch Pseudomonas",
      "Pneumonie durch Pseudomonas",
      "Pneumonie durch Pseudomonas aeruginosa"
    ]
  },
  {
    "code": "J15.2",
    "name": "Pneumonie durch Staphylokokken",
    "synonyms": [
      "Bronchopneumonie durch Staphylococcus aureus",
      "Bronchopneumonie durch Staphylokokken",
      "Lobärpneumonie durch Staphylokokken",
      "Pneumonie durch Staphylokokken",
      "Staphylokokken-Pneumonie",
      "Staphylokokken-induzierte nekrotisierende Pneumonie"
    ]
  },
  {
    "code": "J15.3",
    "name": "Pneumonie durch Streptokokken der Gruppe B",
    "synonyms": [
      "Bronchopneumonie durch Streptokokken der Gruppe B",
      "Lobärpneumonie durch Streptokokken der Gruppe B",
      "Pneumonie durch Streptokokken der Gruppe B"
    ]
  },
  {
    "code": "J15.4",
    "name": "Pneumonie durch Streptokokken",
    "synonyms": [
      "Bronchopneumonie durch Streptokokken a.n.k.",
      "Lobärpneumonie durch Streptokokken a.n.k.",
      "Pneumonie durch Streptokokken",
      "Pneumonie durch vergrünende Streptokokken"
    ]
  },
  {
    "code": "J15.5",
    "name": "Pneumonie durch Escherichia coli",
    "synonyms": [
      "Bronchopneumonie durch Escherichia coli",
      "Lobärpneumonie durch Escherichia coli",
      "Pneumonie durch Escherichia coli"
    ]
  },
  {
    "code": "J15.6",
    "name": "Pneumonie durch Proteus",
    "synonyms": [
      "Bronchopneumonie durch Proteus",
      "Lobärpneumonie durch Proteus",
      "Pneumonie durch Enterobacter",
      "Pneumonie durch Proteus",
      "Pneumonie durch Serratia marcescens",
      "Pneumonie durch gramnegative Bakterien",
      "Pneumonie durch gramnegative aerobe Bakterien"
    ]
  },
  {
    "code": "J15.7",
    "name": "Pneumonie durch Mycoplasma pneumoniae",
    "synonyms": [
      "Bronchopneumonie durch Eaton-Agens",
      "Bronchopneumonie durch Mycoplasma pneumoniae",
      "Bronchopneumonie durch Pleuropneumonia-like-organism [PPLO]",
      "Pneumonie durch Eaton-Agens",
      "Pneumonie durch Mycoplasma pneumoniae",
      "Pneumonie durch PPLO [Pleuropneumonia-like-organism]",
      "Pneumonie durch Pleuropneumonia-like-organism [PPLO]"
    ]
  },
  {
    "code": "J15.9",
    "name": "Bakterielle Pneumonie",
    "synonyms": [
      "Bakterielle Bronchopneumonie",
      "Bakterielle Lobärpneumonie",
      "Bakterielle Pneumonie",
      "Bazilläre Pneumonie"
    ]
  },
  {
    "code": "J16.0",
    "name": "Pneumonie durch Chlamydien",
    "synonyms": [
      "Pneumonie durch Chlamydien"
    ]
  },
  {
    "code": "J16.8",
    "name": "Pilzpneumonie",
    "synonyms": [
      "Pilzpneumonie"
    ]
  },
  {
    "code": "J18.0",
    "name": "Herdpneumonie",
    "synonyms": [
      "Bronchoalveolitis",
      "Bronchopleuropneumonie",
      "Bronchopneumonie",
      "Bronchopneumonie des Oberlappens",
      "Bronchopneumonie des Unterlappens",
      "Eitrige Bronchopneumonie",
      "Fanconi-Hegglin-Syndrom",
      "Herdpneumonie",
      "Hämorrhagische Bronchopneumonie",
      "Katarrhalische Pneumonie",
      "Laryngotracheobronchopneumonie",
      "Lobulärpneumonie",
      "Pleurobronchopneumonie",
      "Spastische Bronchopneumonie",
      "Tracheobronchopneumonie"
    ]
  },
  {
    "code": "J18.1",
    "name": "Fibrinöse Pneumonie",
    "synonyms": [
      "Akute Hepatisation der Lunge",
      "Basale Pneumonie",
      "Bilobäre Pneumonie",
      "Disseminierte Lobärpneumonie",
      "Fibrinöse Pneumonie",
      "Interstitielle Lobärpneumonie",
      "Kruppöse Pneumonie",
      "Lobärpneumonie",
      "Lungenhepatisation",
      "Mittellappenpneumonie",
      "Oberlappenpneumonie",
      "Pseudolobärpneumonie",
      "Pulmonale Hepatisation",
      "Unterlappenpneumonie",
      "Zentrale Pneumonie"
    ]
  },
  {
    "code": "J18.2",
    "name": "Hypostasepneumonie",
    "synonyms": [
      "Hypostasepneumonie",
      "Hypostatische Bronchopneumonie",
      "Hypostatische Lobärpneumonie",
      "Hypostatische Pneumonie",
      "Stauungspneumonie"
    ]
  },
  {
    "code": "J18.8",
    "name": "Segmentpneumonie",
    "synonyms": [
      "Akute Pleuropneumonie",
      "Alveoläre granulozytäre Pneumonie",
      "Bilaterale Pleuropneumonie",
      "Chronische Pleuropneumonie",
      "Doppelseitige Pleuropneumonie",
      "Karnifizierende Pneumonie",
      "Miliare Pneumonie",
      "Pleuropneumonie",
      "Pneumopleuritis",
      "Segmentpneumonie",
      "Septische Pleuropneumonie"
    ]
  },
  {
    "code": "J18.9",
    "name": "Hämorrhagische Lungenentzündung",
    "synonyms": [
      "Akute Lungenentzündung",
      "Akute Pneumonie",
      "Akute Pneumonitis",
      "Atypische Pneumonie",
      "Bilaterale Pneumonie",
      "Doppelseitige Pneumonie",
      "Eitrige Lungenentzündung",
      "Eitrige Pneumonie",
      "Hämorrhagische Lungenentzündung",
      "Hämorrhagische Pneumonie",
      "Kapilläre Pneumonie",
      "Lungenentzündung - s.a. Pneumonie",
      "Lungeninfektion a.n.k.",
      "Obstruktionspneumonie",
      "Peripneumonie",
      "Pneumonia",
      "Pneumonia migrans",
      "Pneumonie",
      "Pneumonie ohne Erregernachweis",
      "Pneumonitis",
      "Primäre Pneumonitis",
      "Pulmonale Infektion",
      "Purulente Pneumonie",
      "Retentionspneumonie",
      "Schaumzellpneumonie",
      "Septische Pneumonie",
      "Stagnationspneumonie",
      "Säuglingspneumonie",
      "Wander-Pneumonie"
    ]
  },
  {
    "code": "J20.0",
    "name": "Akute Bronchitis durch Mycoplasma pneumoniae",
    "synonyms": [
      "Akute Bronchitis durch Mycoplasma pneumoniae"
    ]
  },
  {
    "code": "J20.1",
    "name": "Akute Bronchitis durch Haemophilus influenzae",
    "synonyms": [
      "Akute Bronchitis durch Haemophilus influenzae"
    ]
  },
  {
    "code": "J20.2",
    "name": "Akute Bronchitis durch Streptokokken",
    "synonyms": [
      "Akute Bronchitis durch Pneumokokken",
      "Akute Bronchitis durch Streptokokken"
    ]
  },
  {
    "code": "J20.3",
    "name": "Akute Bronchitis durch Coxsackieviren",
    "synonyms": [
      "Akute Bronchitis durch Coxsackieviren"
    ]
  },
  {
    "code": "J20.4",
    "name": "Akute Bronchitis durch Parainfluenzaviren",
    "synonyms": [
      "Akute Bronchitis durch Parainfluenzaviren"
    ]
  },
  {
    "code": "J20.5",
    "name": "Akute Bronchitis durch Respiratory-Syncytial-Viren [RS-Viren]",
    "synonyms": [
      "Akute Bronchitis durch Respiratory-Syncytial-Viren [RS-Viren]"
    ]
  },
  {
    "code": "J20.6",
    "name": "Akute Bronchitis durch Rhinoviren",
    "synonyms": [
      "Akute Bronchitis durch Rhinoviren"
    ]
  },
  {
    "code": "J20.7",
    "name": "Akute Bronchitis durch ECHO-Viren",
    "synonyms": [
      "Akute Bronchitis durch ECHO-Viren"
    ]
  },
  {
    "code": "J20.8",
    "name": "Akute virale Bronchitis a.n.k.",
    "synonyms": [
      "Akute virale Bronchitis a.n.k.",
      "Bronchitis durch Zytomegalieviren",
      "Bronchitis durch humanes Metapneumovirus",
      "Subakute virale Bronchitis a.n.k.",
      "Tracheobronchitis durch Zytomegalieviren",
      "Zytomegalie-Bronchitis",
      "Zytomegalie-Tracheobronchitis"
    ]
  },
  {
    "code": "J20.9",
    "name": "Akute Laryngotracheobronchitis",
    "synonyms": [
      "Akute Bronchitis",
      "Akute Bronchitis mit Bronchospasmus",
      "Akute Bronchitis mit Obstruktion",
      "Akute Infektion der Bronchien",
      "Akute Laryngotracheobronchitis",
      "Akute Rhinobronchitis",
      "Akute Sinubronchitis",
      "Akute Tracheitis mit Bronchitis",
      "Akute Tracheobronchitis",
      "Akute eitrige Bronchitis",
      "Akute fibrinöse Bronchitis",
      "Akute fieberhafte Bronchitis",
      "Akute fieberhafte Tracheobronchitis",
      "Akute katarrhalische Bronchitis",
      "Akute membranöse Bronchitis",
      "Akute mukopurulente Bronchitis",
      "Akute obstruktive Bronchitis",
      "Akute purulente Bronchitis",
      "Akute septische Bronchitis",
      "Akute spastische Bronchitis",
      "Akute suppurative Bronchitis",
      "Akutes Sinubronchialsyndrom",
      "Akutes sinubronchiales Syndrom",
      "Bronchialer Krupp",
      "Bronchitis beim Kind",
      "Bronchitis plastica",
      "Exsudative Bronchitis",
      "Fieberhafte Bronchitis",
      "Fieberhafte Sinubronchitis",
      "Katarrhalische Bronchitis bei Kindern unter 15 Jahren",
      "Kruppöse Bronchitis",
      "Laryngotracheobronchitis beim Kind",
      "Obstruktive Bronchitis beim Kind",
      "Pertussiforme Bronchitis",
      "Pseudomembranöse Bronchitis",
      "Sinubronchitis beim Kind",
      "Spastische Bronchitis beim Kind",
      "Subakute Bronchitis",
      "Subakute Bronchitis mit Bronchospasmus",
      "Subakute Tracheitis mit Bronchitis",
      "Subakute Tracheobronchitis",
      "Subakute eitrige Bronchitis",
      "Subakute fibrinöse Bronchitis",
      "Subakute membranöse Bronchitis",
      "Subakute mukopurulente Bronchitis",
      "Subakute purulente Bronchitis",
      "Subakute septische Bronchitis",
      "Subakute suppurative Bronchitis",
      "Tracheobronchitis bei Kindern unter 15 Jahren",
      "Virusbronchitis"
    ]
  },
  {
    "code": "J21.0",
    "name": "Akute Bronchiolitis durch Respiratory-Syncytial-Viren [RS-Viren]",
    "synonyms": [
      "Akute Bronchiolitis durch Respiratory-Syncytial-Viren [RS-Viren]"
    ]
  },
  {
    "code": "J21.1",
    "name": "Akute Bronchiolitis durch humanes Metapneumovirus",
    "synonyms": [
      "Akute Bronchiolitis durch humanes Metapneumovirus"
    ]
  },
  {
    "code": "J21.8",
    "name": "Bronchiolitis durch Zytomegalieviren",
    "synonyms": [
      "Bronchiolitis durch Zytomegalieviren",
      "Bronchiolitis durch sonstige näher bezeichnete Erreger",
      "Zytomegalie-Bronchiolitis"
    ]
  },
  {
    "code": "J21.9",
    "name": "Akute Bronchiolitis",
    "synonyms": [
      "Akute Bronchiolitis",
      "Akute Bronchiolitis mit Bronchospasmus",
      "Bläschenbronchitis",
      "Bronchiolitis",
      "Bronchiolitis mit Bronchospasmus",
      "Bronchiolitis mit Obstruktion",
      "Bronchitis capillaris",
      "Eitrige Bronchiolitis",
      "Infektiöse Bronchiolitis",
      "Peribronchiolitis",
      "Subakute Bronchiolitis"
    ]
  },
  {
    "code": "J22",
    "name": "Fieberhafte Infektion der Luftwege",
    "synonyms": [
      "Akute Infektion der Atemwege",
      "Akute Infektion der Atmungsorgane",
      "Akute Infektion der Luftwege",
      "Akute Infektion der unteren Atemwege",
      "Akute Infektion der unteren Luftwege",
      "Akuter Atemwegskatarrh",
      "Bronchopulmonale Infektion",
      "Bronchopulmonaler Infekt",
      "Fieberhafte Infektion der Atemwege",
      "Fieberhafte Infektion der Luftwege",
      "Fieberhafte Infektion der unteren Atemwege",
      "Fieberhafte Infektion der unteren Luftwege",
      "Fieberhafter Infekt der Luftwege",
      "Fieberhafter Infekt der unteren Luftwege",
      "Infekt der unteren Luftwege",
      "Infektion der unteren Atemwege",
      "Infektion der unteren Atmungsorgane",
      "Rezidivierende Infektion der unteren Atemwege",
      "Rezidivierender Infekt der unteren Atemwege"
    ]
  },
  {
    "code": "J30.0",
    "name": "Rhinopathia vasomotorica",
    "synonyms": [
      "Rhinitis vasomotorica",
      "Rhinopathia vasomotorica",
      "Vasomotorische Rhinitis",
      "Vasomotorischer Fließschnupfen"
    ]
  },
  {
    "code": "J30.1",
    "name": "Allergische Rhinitis durch Pollen",
    "synonyms": [
      "Allergische Rhinitis durch Pollen",
      "Ambrosiagewächsallergie",
      "Autumnalfieber",
      "Autumnalkatarrh",
      "Birkenpollenallergie",
      "Catarrhus aestivus",
      "Fließschnupfen durch Pollen",
      "Frühblüherallergie",
      "Gräser-Frühblüherallergie",
      "Gräserpollenallergie",
      "Heuallergie",
      "Heufieber",
      "Heuschnupfen",
      "Jakobs-Kreuzkraut-Pollenallergie",
      "Kräuterpollenallergie",
      "Pollenallergie",
      "Pollenrhinitis",
      "Pollinose",
      "Rhinitis durch Pollen",
      "Rhinitis mit Heufieber",
      "Rhinopathia pollinosa",
      "Roggenallergie",
      "Rosenpollenallergie",
      "Sommerkatarrh"
    ]
  },
  {
    "code": "J30.2",
    "name": "Saisonale allergische Rhinitis",
    "synonyms": [
      "Jahreszeitlich bedingte allergische Rhinitis a.n.k.",
      "Saisonale allergische Rhinitis"
    ]
  },
  {
    "code": "J30.3",
    "name": "Allergie gegen Federn",
    "synonyms": [
      "Allergie durch Inhalation",
      "Allergie gegen Federn",
      "Allergie gegen Schimmelpilz",
      "Allergische Rhinitis durch Federn",
      "Allergische Rhinitis durch Inhalationsallergen a.n.k.",
      "Allergische Rhinitis durch Kapok",
      "Allergische Rhinitis durch tierische Epithelien",
      "Ganzjährig bestehende allergische Rhinitis",
      "Ganzjährig bestehende allergische Rhinopathie",
      "Haarschuppenallergie",
      "Hausstauballergie",
      "Hausstaubmilbenallergie",
      "Heufieber durch Allergene, ausgenommen Pollen",
      "Katzenhaarallergie",
      "Milbenallergie",
      "Nicht jahreszeitlich bedingte allergische Rhinitis",
      "Nichtsaisonale allergische Rhinitis",
      "Paroxysmale Rhinorrhoe",
      "Spasmodische Rhinorrhoe",
      "Tierhaarallergie"
    ]
  },
  {
    "code": "J30.4",
    "name": "Sinusitis allergica",
    "synonyms": [
      "Allergie der oberen Atemwege",
      "Allergische Rhinitis",
      "Allergische Rhinopathie",
      "Allergische Rhinopharyngitis",
      "Allergische Rhinosinusitis",
      "Allergische Sinusitis",
      "Allergische vasomotorische Rhinitis",
      "Allergischer Fließschnupfen",
      "Allergischer Schnupfen",
      "Atopische Rhinitis",
      "Chronische Rhinoallergie",
      "Nasenallergie",
      "Reflektorischer Fließschnupfen",
      "Rhinitis anaphylactica",
      "Rhinitis vasomotorica allergica",
      "Rhinoallergie",
      "Rhinopathia allergica",
      "Sinusitis allergica"
    ]
  },
  {
    "code": "J31.0",
    "name": "Eitrige Rhinitis",
    "synonyms": [
      "Alterslaufnase",
      "Atrophische Rhinitis",
      "Borkennase",
      "Borkige Rhinitis",
      "Chronische Rhinitis",
      "Chronische Rhinitis sicca",
      "Chronische atrophische Rhinitis",
      "Chronische eitrige Rhinitis",
      "Chronische granulomatöse Rhinitis",
      "Chronische hyperplastische Rhinitis",
      "Chronische hypertrophische Rhinitis",
      "Chronische obstruktive Rhinitis",
      "Chronische ulzeröse Rhinitis",
      "Chronischer Katarrh",
      "Chronischer Nasenkatarrh",
      "Chronischer Schnupfen",
      "Eitrige Nasenentzündung",
      "Eitrige Rhinitis",
      "Eitriger Schnupfen",
      "Fibrinöse Rhinitis",
      "Granulomatöse Rhinitis",
      "Hyperplastische Rhinopathie",
      "Hypertrophische Rhinitis",
      "Katarrhalische Rhinitis",
      "Medikamentöse Rhinopathie",
      "Membranöse Rhinitis",
      "Nasenentzündung",
      "Nasenkatarrh",
      "Nasenschleimhautentzündung",
      "Obstruktive Rhinitis",
      "Ozaena",
      "Privinismus",
      "Purulente Rhinitis",
      "Rhinitis",
      "Rhinitis anterior",
      "Rhinitis sicca",
      "Rhinitis sicca anterior",
      "Rhinitis simplex",
      "Rhinoblennorrhoe",
      "Rhinopathia sicca",
      "Stinknase",
      "Suppurative Rhinitis",
      "Trockene Nase",
      "Trockene Nasenschleimhaut",
      "Ulzeröse Rhinitis"
    ]
  },
  {
    "code": "J31.1",
    "name": "Chronische Nasopharyngitis",
    "synonyms": [
      "Atrophische Rhinopharyngitis",
      "Chronische Nasenrachenraumentzündung",
      "Chronische Nasopharyngitis",
      "Chronische Rhinopharyngitis",
      "Chronische Rhinopharyngitis sicca",
      "Chronischer Nasenrachenraumkatarrh",
      "Chronischer Rhinopharyngealkatarrh",
      "Chronischer rhinobronchialer Katarrh",
      "Nasenrachenraumkatarrh",
      "Rhinopharyngitis sicca",
      "Rhinopharynxatrophie",
      "Ulzeröse Rhinopharyngitis"
    ]
  },
  {
    "code": "J31.2",
    "name": "Chronische Pharyngitis",
    "synonyms": [
      "Atrophische Pharyngitis",
      "Atrophische Rachenentzündung",
      "Chronische Halsentzündung",
      "Chronische Pharyngitis",
      "Chronische Rachenentzündung",
      "Chronische Seitenstrangangina",
      "Chronische atrophische Pharyngitis",
      "Chronische follikuläre Pharyngitis",
      "Chronische granuläre Pharyngitis",
      "Chronische granulöse Pharyngitis",
      "Chronische hypertrophische Pharyngitis",
      "Chronischer Rachenkatarrh",
      "Follikuläre Pharynxentzündung",
      "Granuläre Pharynxentzündung",
      "Granulöse Pharyngitis",
      "Hyperplastische Pharyngitis",
      "Hypertrophische Pharyngitis",
      "Membranöse Angina",
      "Pharyngitis follicularis",
      "Pharyngitis granulosa",
      "Pharyngitis granulosa chronica",
      "Pharyngitis sicca",
      "Rachenkatarrh beim Raucher",
      "Raucherpharyngitis"
    ]
  },
  {
    "code": "J32.0",
    "name": "Chronische Sinusitis maxillaris",
    "synonyms": [
      "Antrumfistel",
      "Antrumnekrose",
      "Chronische Antrumentzündung",
      "Chronische Infektion des Sinus maxillaris",
      "Chronische Kieferhöhlenentzündung",
      "Chronische Kieferhöhleninfektion",
      "Chronische Kieferhöhlenvereiterung",
      "Chronische Sinusitis maxillaris",
      "Chronischer Abszess des Antrum Highmori",
      "Chronischer Kieferhöhlenabszess",
      "Chronisches Antrumempyem",
      "Chronisches Kieferhöhlenempyem",
      "Eitrige Sinusitis maxillaris",
      "Kieferhöhlen-Alveolen-Fistel",
      "Kieferhöhlen-Mund-Fistel",
      "Kieferhöhlen-Wangen-Fistel",
      "Kieferhöhlenabszess",
      "Kieferhöhleneiterung",
      "Kieferhöhlenempyem",
      "Kieferhöhlenentzündung",
      "Kieferhöhlenfistel",
      "Kieferhöhleninfektion",
      "Kieferhöhlenkatarrh",
      "Kieferhöhlennekrose",
      "Kieferhöhlensinusitis",
      "Sinusitis maxillaris",
      "Sinusitis maxillaris chronica"
    ]
  },
  {
    "code": "J32.1",
    "name": "Chronische Sinusitis frontalis",
    "synonyms": [
      "Chronische Sinusitis frontalis",
      "Chronische Stirnhöhlenentzündung",
      "Chronische Stirnhöhleninfektion",
      "Chronische Stirnhöhlenvereiterung",
      "Chronischer Stirnhöhlenabszess",
      "Chronisches Stirnhöhlenempyem",
      "Eitrige Sinusitis frontalis",
      "Sinusitis frontalis",
      "Stirnhöhlenabszess",
      "Stirnhöhlenempyem",
      "Stirnhöhlenentzündung",
      "Stirnhöhlenfistel",
      "Stirnhöhleninfektion",
      "Stirnhöhlenkatarrh",
      "Stirnhöhlensinusitis",
      "Stirnhöhlenvereiterung"
    ]
  },
  {
    "code": "J32.2",
    "name": "Chronische Sinusitis ethmoidalis",
    "synonyms": [
      "Chronische Ethmoiditis",
      "Chronische Siebbeinhöhlenentzündung",
      "Chronische Siebbeinhöhleninfektion",
      "Chronische Siebbeinhöhlenvereiterung",
      "Chronische Siebbeinzelleninfektion",
      "Chronische Sinusitis ethmoidalis",
      "Chronischer Siebbeinhöhlenabszess",
      "Chronisches Siebbeinhöhlenempyem",
      "Eitrige Ethmoiditis",
      "Ethmoidale Fistel",
      "Ethmoiditis",
      "Nichteitrige Ethmoiditis",
      "Polypöse Ethmoiditis",
      "Siebbeinhöhlenabszess",
      "Siebbeinhöhleneiterung",
      "Siebbeinhöhlenempyem",
      "Siebbeinhöhlenentzündung",
      "Siebbeinhöhleninfektion",
      "Siebbeinhöhlensinusitis",
      "Siebbeinnekrose",
      "Siebbeinzellenentzündung",
      "Sinusitis ethmoidalis"
    ]
  },
  {
    "code": "J32.3",
    "name": "Chronische Sinusitis sphenoidalis",
    "synonyms": [
      "Chronische Keilbeinhöhlenentzündung",
      "Chronische Keilbeinhöhleninfektion",
      "Chronische Sinusitis sphenoidalis",
      "Chronische Sphenoiditis",
      "Chronischer Keilbeinhöhlenabszess",
      "Chronisches Keilbeinhöhlenempyem",
      "Eitrige Sinusitis sphenoidalis",
      "Keilbeinhöhlenabszess",
      "Keilbeinhöhleneiterung",
      "Keilbeinhöhlenempyem",
      "Keilbeinhöhlenentzündung",
      "Keilbeinhöhleninfektion",
      "Keilbeinhöhlensinusitis",
      "Sinusitis sphenoidalis",
      "Sphenoiditis"
    ]
  },
  {
    "code": "J32.4",
    "name": "Chronische Pansinusitis",
    "synonyms": [
      "Abszesse in allen Nasennebenhöhlen",
      "Chronische Entzündung aller Nasennebenhöhlen",
      "Chronische Infektion aller Nasennebenhöhlen",
      "Chronische Pansinusitis",
      "Eitrige Pansinusitis",
      "Entzündung aller Nasennebenhöhlen",
      "Hyperplastische Pansinusitis",
      "Infektion aller Nasennebenhöhlen",
      "Nichteitrige Pansinusitis",
      "Pansinusitis"
    ]
  },
  {
    "code": "J32.8",
    "name": "Chronische Rhinosinusitis mit Exazerbation",
    "synonyms": [
      "Chronische Rhinosinusitis mit Exazerbation",
      "Chronische Sinusitis maxillaris et ethmoidalis",
      "Sinusitis maxillaris et ethmoidalis",
      "Sinusitis maxillaris frontalis",
      "Sinusitis maxillaris frontalis et ethmoidalis",
      "Sinusitis maxillaris mit Sinusitis frontalis",
      "Sinusitis maxillaris mit chronischer Sinusitis frontalis"
    ]
  },
  {
    "code": "J32.9",
    "name": "Chronische Sinusitis",
    "synonyms": [
      "Chronische Eiterung der Nasenhöhle",
      "Chronische Eiterung der Nasennebenhöhle",
      "Chronische Infektion der Sinus paranasales",
      "Chronische Nasennebenhöhlenentzündung",
      "Chronische Nasennebenhöhleninfektion",
      "Chronische Nasennebenhöhlenvereiterung",
      "Chronische Nebenhöhlenentzündung",
      "Chronische Nebenhöhleninfektion",
      "Chronische Rhinosinusitis",
      "Chronische Sinupharyngitis",
      "Chronische Sinuseiterung",
      "Chronische Sinusentzündung",
      "Chronische Sinusitis",
      "Chronischer Nebenhöhlenabszess",
      "Chronisches Nasennebenhöhlenempyem",
      "Chronisches Sinusempyem",
      "Eitrige Sinusitis",
      "Hyperplastische Sinusitis",
      "Infektiöses Nasennebenhöhlengranulom",
      "Infektsinusitis",
      "Katarrhalische Sinusitis",
      "Nasale Sinusitis",
      "Nasengranulom",
      "Nasenmuschelpyozele",
      "Nasennebenhöhlenabszess",
      "Nasennebenhöhlenempyem",
      "Nasennebenhöhlenentzündung",
      "Nasennebenhöhlenfistel",
      "Nasennebenhöhleninfektion",
      "Nasennebenhöhlenkrankheit",
      "Nasennebenhöhlenpyozele",
      "Nasennebenhöhlenvereiterung",
      "Nebenhöhlenentzündung",
      "Nebenhöhlenkatarrh",
      "Nichteitrige Sinusitis",
      "Purulente Sinusitis",
      "Rezidivierende Sinusitis",
      "Rhinosinusitis",
      "Sequestration der Nasennebenhöhle",
      "Sinupharyngitis",
      "Sinusdegeneration",
      "Sinushyalinose",
      "Sinusitis",
      "Sinusitis der Nebenhöhlen",
      "Zystische Sinusdegeneration"
    ]
  },
  {
    "code": "J33.0",
    "name": "Nasenhöhlenpolyp",
    "synonyms": [
      "Choanalpolyp",
      "Killian-Polyp der Nasenhöhle",
      "Nasenhöhlenpolyp",
      "Nasenlochpolyp",
      "Nasenrachenraumpolyp",
      "Nasenseptumpolyp",
      "Nasopharyngealer Polyp",
      "Polypöses adenoides Gewebe"
    ]
  },
  {
    "code": "J33.1",
    "name": "Polypoide Sinusdegeneration",
    "synonyms": [
      "Polypoide Sinusdegeneration",
      "Polyposis nasi deformans",
      "Woakes-Ethmoiditis",
      "Woakes-Syndrom"
    ]
  },
  {
    "code": "J33.8",
    "name": "Nebenhöhlenpolyp",
    "synonyms": [
      "Keilbeinhöhlenpolyp",
      "Kieferhöhlenpolyp",
      "Nasenmuschelpolyp",
      "Nasennebenhöhlenpolyp",
      "Nebenhöhlenpolyp",
      "Polyp des Antrum Highmori",
      "Polyposis der Nasennebenhöhlen",
      "Polyposis des Sinus ethmoidalis",
      "Polyposis des Sinus maxillaris",
      "Polyposis des Sinus sphenoidalis",
      "Polyposis nasi et sinuum",
      "Siebbeinhöhlenpolyp",
      "Siebbeinpolyp",
      "Stirnhöhlenpolyp"
    ]
  },
  {
    "code": "J33.9",
    "name": "Nasenpolyp",
    "synonyms": [
      "Nasenpolyp",
      "Nasenschleimhautpolyp",
      "Polypoide Nasenhyperplasie",
      "Polyposis nasi",
      "Polypöse Rhinopathie"
    ]
  },
  {
    "code": "J34.0",
    "name": "Nasenfurunkel",
    "synonyms": [
      "Abszess der äußeren Nase",
      "Abszess des Septum nasi",
      "Nasenabszess",
      "Nasenfurunkel",
      "Nasenkarbunkel",
      "Nasenmuschelulkus",
      "Nasennekrose",
      "Nasenscheidewandabszess",
      "Nasenseptumabszess",
      "Nasenseptumnekrose",
      "Nasenulkus",
      "Phlegmone der äußeren Nase",
      "Phlegmone des Nasenseptums",
      "Postnasaler Abszess",
      "Ulcus nasi",
      "Ulcus septi nasi perforans",
      "Ulzeration des Nasenseptums",
      "Ulzeration in der Nase"
    ]
  },
  {
    "code": "J34.1",
    "name": "Nebenhöhlenmukozele",
    "synonyms": [
      "Keilbeinhöhlenzyste",
      "Kieferhöhlenzyste",
      "Nasenmuschelmukozele",
      "Nasenmuschelzyste",
      "Nasennebenhöhlenmukozele",
      "Nasennebenhöhlenzyste",
      "Nebenhöhlenmukozele",
      "Siebbeinhöhlenzyste",
      "Stirnhöhlenzyste",
      "Zyste des Antrum Highmori"
    ]
  },
  {
    "code": "J34.2",
    "name": "Septumverbiegung",
    "synonyms": [
      "Deviatio septi nasi",
      "Erworbene Deviatio septi nasi",
      "Erworbene Nasenscheidewanddeviation",
      "Erworbene Nasenscheidewandverbiegung",
      "Erworbene Nasenseptumdeviation",
      "Erworbene Nasenseptumverbiegung",
      "Erworbene Rhinoseptumdeviation",
      "Erworbene Rhinoseptumverbiegung",
      "Erworbene Septumdeviation",
      "Erworbene Septumverbiegung",
      "Erworbene Subluxation des Nasenseptums",
      "Erworbene nasale Septumdeflexion",
      "Irreguläres Nasenseptum",
      "Nasenmuscheldeflexion",
      "Nasenscheidewanddeviation",
      "Nasenscheidewanddislokation",
      "Nasenscheidewandverbiegung",
      "Nasenscheidewandverkrümmung",
      "Nasenseptumdeformität",
      "Nasenseptumdeviation",
      "Nasenseptumdislokation",
      "Nasenseptumverbiegung",
      "Rhinoseptumdeviation",
      "Rhinoseptumverbiegung",
      "Septumdeviation",
      "Septumverbiegung",
      "Subluxation des Nasenseptums"
    ]
  },
  {
    "code": "J34.3",
    "name": "Nasenmuschelhypertrophie",
    "synonyms": [
      "Nasenmuschelhyperplasie",
      "Nasenmuschelhypertrophie",
      "Nasenmuschelschwellung"
    ]
  },
  {
    "code": "J34.8",
    "name": "Naseneingangsentzündung",
    "synonyms": [
      "Adhäsion der Nasenmuschel am Septum",
      "Chronische Nasennebenhöhlenperforation",
      "Destruktion des Septum nasi",
      "Erworbene Choanalstenose",
      "Erworbene Nasenatresie",
      "Hydrorrhoea nasi",
      "Hypertrophische Nasennebenhöhlenveränderung",
      "Hyperämie der Nasenschleimhaut",
      "Lymphoide Nasenhyperplasie",
      "Nasale Fistel",
      "Nasale Schmerzen",
      "Nasale Vestibulitis",
      "Nasenbeinhypertrophie",
      "Naseneingangsentzündung",
      "Naseneingangsstenose",
      "Nasenerkrankung",
      "Nasenfistel",
      "Nasenflügelhypertrophie",
      "Nasenhypertrophie",
      "Nasenhöhlensynechie",
      "Nasenknorpelhypertrophie",
      "Nasenkrankheit",
      "Nasenmuschelatrophie",
      "Nasenmuscheldegeneration",
      "Nasenmuscheleinklemmung",
      "Nasennebenhöhlenaplasie",
      "Nasennebenhöhlenatresie",
      "Nasennebenhöhlencholesteatom",
      "Nasennebenhöhlenhypertrophie",
      "Nasennebenhöhlenhypoplasie",
      "Nasennebenhöhlenobstruktion",
      "Nasennebenhöhlenschädigung",
      "Nasennebenhöhlenverschluss",
      "Nasenobstruktion",
      "Nasenperichondritis",
      "Nasenschleimhautdeformität",
      "Nasenschleimhauthypertrophie",
      "Nasenschleimhautnarbe",
      "Nasenschleimhautschwellung",
      "Nasenschleimhautüberfunktion",
      "Nasenschmerzen",
      "Nasenseptumdestruktion",
      "Nasenseptumperforation",
      "Nasenseptumsporn",
      "Nasensinusverschluss",
      "Nasenstein",
      "Nasenstriktur",
      "Nasenverschluss",
      "Nebenhöhlenaffektion",
      "Rhinolith",
      "Rhinolith der Nasennebenhöhle",
      "Rhinolithiasis",
      "Rhinomegalie",
      "Rhinopathie",
      "Rhinorrhoe",
      "Schädigung des Naseninneren",
      "Silent-Sinus-Syndrom",
      "Sinusschädigung",
      "Stenose der hinteren Nasenöffnung",
      "Stenose der vorderen Nasenöffnung",
      "Striktur einer Nasenöffnung",
      "Ulzerative Mukositis der Nase",
      "Ulzerative Mukositis der Nasennebenhöhlen",
      "Vakuumsinus",
      "Vomer-Sporn",
      "Überentwicklung der Nasenknochen"
    ]
  },
  {
    "code": "J35.0",
    "name": "Angina hypertrophica",
    "synonyms": [
      "Angina hypertrophica",
      "Chronische Adenoiditis",
      "Chronische Angina",
      "Chronische Angina tonsillaris",
      "Chronische Infektion der Adenoide",
      "Chronische Mandelentzündung",
      "Chronische Tonsilleneiterung",
      "Chronische Tonsilleninfektion",
      "Chronische Tonsillitis",
      "Chronische eitrige Tonsilleninfektion",
      "Exazerbation einer chronischen Tonsillitis",
      "Hyperplastische Tonsillitis",
      "Hypertrophische Tonsillitis",
      "Infizierter Tonsillenrest",
      "Infizierter Tonsillenüberrest",
      "Lymphoide posteriore Pharynxinfektion"
    ]
  },
  {
    "code": "J35.1",
    "name": "Gaumenmandelhyperplasie",
    "synonyms": [
      "Gaumenmandelhyperplasie",
      "Gaumenmandelvergrößerung",
      "Hyperplasie der Zungentonsille",
      "Mandelhyperplasie",
      "Tonsillenhyperplasie",
      "Tonsillenvergrößerung",
      "Vergrößerte Gaumenmandel",
      "Vergrößerte Mandeln",
      "Vergrößerte Tonsillen"
    ]
  },
  {
    "code": "J35.2",
    "name": "Adenoide Wucherung",
    "synonyms": [
      "Adenoide",
      "Adenoide 2. Grades",
      "Adenoide 3. Grades",
      "Adenoide Vegetationen",
      "Adenoide Wucherung",
      "Hyperplastische Adenoide",
      "Infektiöse Hyperplasie der Adenoide",
      "Lymphoide Hyperplasie des Nasenrachenraums",
      "Lymphoide Rhinopharynxhyperplasie",
      "Rachenmandelhyperplasie",
      "Rachenmandelvergrößerung",
      "Rachenmandelwucherung",
      "Vergrößerte Adenoide",
      "Vergrößerte Rachenmandel",
      "Vergrößerung der Adenoide"
    ]
  },
  {
    "code": "J35.3",
    "name": "Adenotonsillarhyperplasie",
    "synonyms": [
      "Adenotonsillarhyperplasie",
      "Gaumen- und Rachenmandelhyperplasie",
      "Gaumen- und Rachenmandelvergrößerung",
      "Hyperplasie von adenoidem Gewebe und Tonsille",
      "Vergrößerung von adenoidem Gewebe und Tonsille"
    ]
  },
  {
    "code": "J35.8",
    "name": "Tonsillenzyste",
    "synonyms": [
      "Adenoidnarbe",
      "Amygdalolith",
      "Blutung der Adenoide",
      "Blutung in peritonsilläres Gewebe",
      "Gaumenmandelnarbe",
      "Hämorrhagie der Adenoide",
      "Hämorrhagie der Tonsille",
      "Hämorrhagie in peritonsilläres Gewebe",
      "Infizierte adenoide Zyste",
      "Mandelgeschwür",
      "Mandelnarbe",
      "Mandelstein",
      "Peritonsilläres Ulkus",
      "Plica tonsillaris",
      "Rachenmandelnarbe",
      "Tonsillenblutung",
      "Tonsillenfokaltoxikose",
      "Tonsillenkeratose",
      "Tonsillenkonkrement",
      "Tonsillennarbe",
      "Tonsillennekrose",
      "Tonsillenrest",
      "Tonsillenruptur",
      "Tonsillenstein",
      "Tonsillenulkus",
      "Tonsillenzyste",
      "Tonsillenüberrest"
    ]
  },
  {
    "code": "J35.9",
    "name": "Chronische Tonsillenaffektion",
    "synonyms": [
      "Chronische Gaumenmandelkrankheit",
      "Chronische Rachenmandelkrankheit",
      "Chronische Tonsillenaffektion",
      "Chronische Tonsillenkrankheit",
      "Schädigung der Fossulae tonsillares",
      "Tonsillenaffektion"
    ]
  },
  {
    "code": "J36",
    "name": "Paratonsillitis",
    "synonyms": [
      "Intratonsillarabszess",
      "Mandelabszess",
      "Paratonsillarabszess",
      "Paratonsillitis",
      "Periamygdalitis",
      "Periamygdalitis phlegmonosa abscedens",
      "Peritonsillarabszess",
      "Peritonsillitis",
      "Peritonsilläre Phlegmone",
      "Peritonsilläres Infiltrat",
      "Retrotonsillarabszess",
      "Retrotonsilläres Infiltrat",
      "Tonsillarabszess",
      "Tonsillopharyngealabszess"
    ]
  },
  {
    "code": "J37.0",
    "name": "Chronische Pharyngolaryngitis",
    "synonyms": [
      "Allergische Laryngitis",
      "Atrophische Laryngitis",
      "Chronisch-hyperplastische Laryngitis",
      "Chronische Epiglottisentzündung",
      "Chronische Epiglottitis",
      "Chronische Kehldeckelentzündung",
      "Chronische Kehlkopfentzündung",
      "Chronische Laryngitis",
      "Chronische Laryngitis durch äußere Wirkstoffe",
      "Chronische Laryngopharyngitis",
      "Chronische Larynxentzündung",
      "Chronische Pharyngolaryngitis",
      "Chronische Rhinolaryngitis",
      "Chronische Rhinopharyngolaryngitis",
      "Chronischer Kehlkopfkatarrh",
      "Chronischer Larynxkatarrh",
      "Hypertrophische Laryngitis",
      "Hypertrophische hyperplastische Laryngitis",
      "Infektiöse atrophische Laryngitis",
      "Katarrhalische Laryngitis",
      "Laryngitis sicca",
      "Pharyngolaryngitis sicca"
    ]
  },
  {
    "code": "J37.1",
    "name": "Chronische Laryngotracheitis",
    "synonyms": [
      "Atrophische Laryngotracheitis",
      "Chronische Laryngitis mit Tracheitis",
      "Chronische Laryngotracheitis",
      "Chronische Laryngotracheitis durch äußeren Wirkstoff",
      "Chronische Tracheitis mit Laryngitis",
      "Chronische katarrhalische Laryngotracheitis",
      "Hypertrophische Laryngotracheitis",
      "Laryngotracheitis sicca",
      "Pharyngolaryngotracheitis sicca"
    ]
  },
  {
    "code": "J38.00",
    "name": "Glottisparese",
    "synonyms": [
      "Glottislähmung",
      "Glottisparalyse",
      "Glottisparese",
      "Kehlkopflähmung",
      "Kongenitale Stimmbandlähmung",
      "Laryngeale Abduktorenlähmung",
      "Laryngeale Abduktorenlähmung und geistige Retardierung",
      "Laryngoparalyse",
      "Larynxlähmung",
      "Larynxparalyse",
      "Larynxparese",
      "Lähmung der Kehlkopfmuskulatur",
      "Ortner-I-Syndrom",
      "Paralyse des Nervus laryngeus recurrens",
      "Paralyse des Nervus laryngeus superior",
      "Postikuslähmung",
      "Postikusparese",
      "Rekurrenslähmung",
      "Rekurrensparese",
      "Stimmbandlähmung",
      "Stimmbandparalyse",
      "Stimmbandparese",
      "Stimmlippenlähmung",
      "Stimmlippenparalyse",
      "Vollständige Kehlkopflähmung",
      "Vollständige Larynxlähmung"
    ]
  },
  {
    "code": "J38.01",
    "name": "Einseitige partielle Kehlkopflähmung",
    "synonyms": [
      "Einseitige partielle Kehlkopflähmung",
      "Einseitige partielle Larynxlähmung",
      "Einseitige partielle Lähmung einer Stimmlippe",
      "Einseitige partielle Lähmung eines Stimmbandes"
    ]
  },
  {
    "code": "J38.02",
    "name": "Einseitige komplette Kehlkopflähmung",
    "synonyms": [
      "Einseitige komplette Kehlkopflähmung",
      "Einseitige komplette Larynxlähmung",
      "Einseitige komplette Lähmung einer Stimmlippe",
      "Einseitige komplette Lähmung eines Stimmbandes",
      "Einseitige komplette kongenitale Stimmbandlähmung"
    ]
  },
  {
    "code": "J38.03",
    "name": "Beidseitige partielle Kehlkopflähmung",
    "synonyms": [
      "Beidseitige partielle Kehlkopflähmung",
      "Beidseitige partielle Larynxlähmung",
      "Beidseitige partielle Lähmung der Stimmbänder",
      "Beidseitige partielle Lähmung der Stimmlippen"
    ]
  },
  {
    "code": "J38.1",
    "name": "Stimmbandpolyp",
    "synonyms": [
      "Kehlkopfpolyp",
      "Larynxpolyp",
      "Stimmbandpolyp",
      "Stimmlippenpolyp [Stimmbandpolyp]"
    ]
  },
  {
    "code": "J38.2",
    "name": "Stimmbandentzündung",
    "synonyms": [
      "Chorditis",
      "Chorditis fibrinosa",
      "Chorditis nodosa",
      "Chorditis tuberosa",
      "Fibrinöse Chorditis",
      "Lehrerknötchen",
      "Nodulus vocalis",
      "Schreiknötchen",
      "Stimmbandentzündung",
      "Stimmbandknötchen",
      "Stimmlippenknötchen [Stimmbandknötchen]",
      "Sängerknötchen"
    ]
  },
  {
    "code": "J38.3",
    "name": "Stimmbandkeratose",
    "synonyms": [
      "Glottisleukoplakie",
      "Spastische Dysphonie",
      "Stimmbandabszess",
      "Stimmbandfixation",
      "Stimmbandgranulom",
      "Stimmbandhyperkeratose",
      "Stimmbandhypertrophie",
      "Stimmbandkeratose",
      "Stimmbandkrankheit",
      "Stimmbandleukokeratose",
      "Stimmbandleukoplakie",
      "Stimmbandnarbe",
      "Stimmbandparakeratose",
      "Stimmbandphlegmone",
      "Stimmbandzyste",
      "Stimmlippenabszess",
      "Stimmlippenentzündung",
      "Stimmlippenfixation",
      "Stimmlippengranulom",
      "Stimmlippenhyperkeratose",
      "Stimmlippenhypertrophie",
      "Stimmlippenkeratose [Stimmbandkeratose]",
      "Stimmlippenkrankheit",
      "Stimmlippenleukokeratose",
      "Stimmlippenleukoplakie",
      "Stimmlippennarbe",
      "Stimmlippenparakeratose",
      "Stimmlippenphlegmone",
      "Stimmlippenzyste [Stimmbandzyste]"
    ]
  },
  {
    "code": "J38.4",
    "name": "Glottisödem",
    "synonyms": [
      "Chronische ödematöse subglottische Enge",
      "Chronische ödematöse subglottische Verengung",
      "Epiglottisödem",
      "Glottisödem",
      "Kehlkopfödem",
      "Larynxödem",
      "Passives obstruktives Glottisödem",
      "Reinke-Ödem des Stimmbandes",
      "Reinke-Ödem einer Stimmlippe",
      "Stimmbandödem",
      "Stimmlippenödem",
      "Subglottisches Ödem",
      "Supraglottisches Ödem"
    ]
  },
  {
    "code": "J38.5",
    "name": "Laryngismus",
    "synonyms": [
      "Falscher Krupp",
      "Glottiskrampf",
      "Glottisspasmus",
      "Hyperkinesis laryngis",
      "Kehlkopfspasmus",
      "Kruppöser Stridor",
      "Laryngismus",
      "Laryngismus stridulus",
      "Laryngospasmus",
      "Larynxspasmus",
      "Pseudocroup",
      "Pseudokrupp",
      "Spasmodische Laryngotracheitis",
      "Spasmus glottidis",
      "Spastischer Krupp",
      "Stimmritzenkrampf",
      "Stridulöse Laryngotracheitis"
    ]
  },
  {
    "code": "J38.6",
    "name": "Larynxstenose",
    "synonyms": [
      "Glottisstenose",
      "Glottisstriktur",
      "Kehlkopfstenose",
      "Kehlkopfstriktur",
      "Laryngostenose",
      "Larynxkonstriktion",
      "Larynxobstruktion a.n.k.",
      "Larynxstenose",
      "Larynxstriktur a.n.k.",
      "Larynxverengung",
      "Larynxverschluss a.n.k.",
      "Ringknorpelstenose",
      "Subglottische Stenose",
      "Subglottische Striktur"
    ]
  },
  {
    "code": "J38.7",
    "name": "Kehlkopfkrankheit",
    "synonyms": [
      "Ankylose des Krikoarytänoidalgelenks",
      "Aphthöse Larynxulzeration",
      "Aphthöses Kehlkopfulkus",
      "Aphthöses Larynxulkus",
      "Arthropathie des Krikoarytänoidalgelenks",
      "Epiglottisabszess",
      "Epiglottisadhäsion",
      "Epiglottisulkus",
      "Epiglottiszyste",
      "Erworbene Deformität der Cartilago cricoidea",
      "Erworbene Epiglottisdeformität",
      "Erworbene Kehlkopfdeformität",
      "Erworbene Larynxdeformität",
      "Erworbene Ringknorpeldeformität",
      "Erworbene Schildknorpeldeformität",
      "Glottisulkus",
      "Kehldeckelabszess",
      "Kehldeckelgeschwür",
      "Kehlkopfabszess",
      "Kehlkopfkrankheit",
      "Kehlkopfmuskelprolaps",
      "Kehlkopfnekrose",
      "Kehlkopfpachydermie",
      "Kehlkopfperichondritis",
      "Kehlkopfphlegmone",
      "Kehlkopfschleimhautblutung",
      "Kehlkopfulkus",
      "Kehlkopfventrikelprolaps",
      "Kehlkopfvernarbung",
      "Laryngofissur",
      "Laryngoptose",
      "Larynxabszess",
      "Larynxatrophie",
      "Larynxfistel",
      "Larynxfixation",
      "Larynxgeschwür",
      "Larynxgranulom",
      "Larynxhyperästhesie",
      "Larynxinfektion",
      "Larynxkeratose",
      "Larynxknoten",
      "Larynxkrankheit",
      "Larynxleukoplakie",
      "Larynxnarbe",
      "Larynxnekrose",
      "Larynxossifikation",
      "Larynxpachydermie",
      "Larynxperichondritis",
      "Larynxphlegmone",
      "Larynxschleimhautblutung",
      "Larynxsklerose",
      "Larynxulkus",
      "Larynxverdickung",
      "Larynxvernarbung",
      "Larynxzyste",
      "Pachydermia laryngis verrucosa",
      "Pachydermische Laryngitis",
      "Pachydermische Laryngotracheitis",
      "Postlaryngealabszess",
      "Retrolaryngealabszess",
      "Senile Larynxkalzifikation",
      "Subepiglottische Verdickung",
      "Vocal cord dysfunction [VCD]",
      "Zyste der Cartilago arytenoidea",
      "Zyste der Vallecula epiglottica"
    ]
  },
  {
    "code": "J39.0",
    "name": "Hypopharynxphlegmone",
    "synonyms": [
      "Hypopharynxphlegmone",
      "Parapharyngealabszess",
      "Parapharyngeale Phlegmone",
      "Peripharyngealer Abszess",
      "Postpharyngealabszess",
      "Retropharyngealabszess"
    ]
  },
  {
    "code": "J39.1",
    "name": "Pharynxabszess",
    "synonyms": [
      "Abszess der Bursa pharyngea",
      "Abszess der Fauces",
      "Abszess der Rachenenge",
      "Nasenrachenraumabszess",
      "Nasopharynxabszess",
      "Pharyngeale Bursitis",
      "Pharynxabszess",
      "Pharynxphlegmone",
      "Phlegmonöse Pharynxinfektion",
      "Rachenabszess",
      "Rachenphlegmone"
    ]
  },
  {
    "code": "J39.2",
    "name": "Nasenrachenraumveränderung",
    "synonyms": [
      "Erworbene Pharynxdeformität",
      "Gesteigerter Würgreflex",
      "Gestörter Würgreflex",
      "Hypopharynxfistel",
      "Hypopharynxnarbe",
      "Hypopharynxperforation",
      "Hypopharynxstriktur",
      "Hypopharynxulkus",
      "Hypopharynxzyste",
      "Lymphoide Pharynxhyperplasie",
      "Narbe des Nasenrachenraums",
      "Nasenrachenraumulkus",
      "Nasenrachenraumveränderung",
      "Nasenschleimhautödem",
      "Nasopharyngeale Fistel",
      "Nasopharynxobstruktion",
      "Nasopharynxschmerzen",
      "Nasopharynxstriktur",
      "Nasopharynxzyste",
      "Nasopharynxödem",
      "Oropharynxstenose",
      "Pharyngealer Myoklonus",
      "Pharyngoplegie",
      "Pharynxatrophie",
      "Pharynxdilatation",
      "Pharynxfistel",
      "Pharynxhypertrophie",
      "Pharynxhyperästhesie",
      "Pharynxkeratose",
      "Pharynxkrankheit",
      "Pharynxnarbe",
      "Pharynxobstruktion",
      "Pharynxparalyse",
      "Pharynxperforation",
      "Pharynxpolyp",
      "Pharynxreizung",
      "Pharynxschleimhautpolyp",
      "Pharynxschmerzen",
      "Pharynxschädigung",
      "Pharynxstenose",
      "Pharynxstriktur",
      "Pharynxulkus",
      "Pharynxwandzyste",
      "Pharynxzyste",
      "Pharynxödem",
      "Rachenatrophie",
      "Rachenkrankheit",
      "Rachenmuskelparalyse",
      "Rachennarbe",
      "Rachenparalyse",
      "Rachenpolyp",
      "Rachenspasmus",
      "Rachenulkus",
      "Rachenwandzyste",
      "Rachenzyste",
      "Rachenödem",
      "Reflexspasmus des Pharynx",
      "Retropharyngeale Gangrän",
      "Rhinopharynxnarbe",
      "Rhinopharynxulkus",
      "Rhinopharynxzyste",
      "Tornwaldt-Bursitis",
      "Tornwaldt-Krankheit",
      "Tornwaldt-Zyste",
      "Uvulaödem",
      "Zyste der Bursa pharyngea",
      "Zyste des Nasenrachenraums",
      "Ödem des Nasenrachenraums"
    ]
  },
  {
    "code": "J39.3",
    "name": "Überempfindlichkeit der oberen Luftwege",
    "synonyms": [
      "Allergische Rhinopharyngolaryngitis",
      "Überempfindlichkeit der oberen Atemwege",
      "Überempfindlichkeit der oberen Luftwege"
    ]
  },
  {
    "code": "J39.80",
    "name": "Tracheastenose",
    "synonyms": [
      "Adhäsion der Trachea",
      "Erworbene Tracheastenose",
      "Luftröhrenstenose",
      "Tracheakompression",
      "Trachealkollaps",
      "Trachealstenose",
      "Tracheaobstruktion",
      "Tracheastenose",
      "Tracheastriktur"
    ]
  },
  {
    "code": "J39.88",
    "name": "Tracheozele",
    "synonyms": [
      "Abszess der oberen Atemwege",
      "Abszess der oberen Luftwege",
      "Atrophie der oberen Atemwege",
      "Atrophie der oberen Luftwege",
      "Chronische Infektion der oberen Atmungsorgane",
      "Eosinophile angiozentrische Fibrose",
      "Erworbene Tracheadeformität",
      "Erworbene Trachealringdeformität",
      "Hypertrophische Veränderung der oberen Atemwege",
      "Innere Tracheozele",
      "Luftröhrenabszess",
      "Luftröhrenatrophie",
      "Luftröhrenerweichung",
      "Luftröhrengeschwür",
      "Luftröhrenkalzifikation",
      "Luftröhrenkrankheit a.n.k.",
      "Luftröhrenverkalkung",
      "Submuköse Fibrose des oberen Respirationstraktes",
      "Tracheaabszess",
      "Tracheaatrophie",
      "Tracheadeviation",
      "Tracheadyskinesie",
      "Tracheaerweichung",
      "Tracheageschwür",
      "Tracheakalzifikation",
      "Tracheakrankheit a.n.k.",
      "Trachealkompression",
      "Trachealzyste",
      "Tracheanarbe",
      "Tracheanekrose",
      "Tracheaossifikation",
      "Tracheaperichondritis",
      "Tracheaulkus",
      "Tracheaverkalkung",
      "Tracheomalazie",
      "Tracheozele",
      "Äußere Tracheozele"
    ]
  },
  {
    "code": "J39.9",
    "name": "Krankheit der oberen Atemwege",
    "synonyms": [
      "Krankheit der oberen Atemwege",
      "Krankheit der oberen Luftwege",
      "Pharyngismus"
    ]
  },
  {
    "code": "J40",
    "name": "Superinfizierte spastische Bronchitis",
    "synonyms": [
      "Ableitungsbronchitis",
      "Bakterielle Bronchitis",
      "Bronchialentzündung",
      "Bronchialkatarrh",
      "Bronchitis",
      "Bronchitis beim Erwachsenen",
      "Bronchitis beim Jugendlichen",
      "Bronchitis catarrhalis",
      "Bronchitis durch protrahierte Verletzung",
      "Bronchitis mit Tracheitis",
      "Bronchitis mit protrahiertem, nichtchronischen Verlauf",
      "Bronchopharyngitis",
      "Diffuse Bronchitis",
      "Endobronchitis",
      "Exazerbierte Bronchitis",
      "Fibrinöse Bronchitis",
      "Hypostatische Bronchitis",
      "Infektion der Bronchien",
      "Infektiöse Bronchitis",
      "Katarrhalische Bronchitis",
      "Katarrhalische Tracheobronchitis",
      "Laryngobronchitis",
      "Laryngotracheobronchitis",
      "Laryngotracheobronchitis beim Erwachsenen",
      "Laryngotracheobronchitis beim Jugendlichen",
      "Membranöse Bronchitis",
      "Pharyngobronchitis",
      "Pharyngolaryngotracheobronchitis",
      "Pharyngotracheobronchitis",
      "Rhinobronchitis",
      "Rhinolaryngobronchitis",
      "Rhinopharyngobronchitis",
      "Rhinosinubronchitis",
      "Rhinotracheobronchitis",
      "Sinubronchitis",
      "Sinubronchitis beim Erwachsenen",
      "Sinubronchitis beim Jugendlichen",
      "Sinutracheobronchitis",
      "Spastische Bronchitis",
      "Spastische Bronchitis beim Erwachsenen",
      "Spastische Bronchitis beim Jugendlichen",
      "Superinfizierte spastische Bronchitis",
      "Tracheobronchitis",
      "Tracheobronchitis bei Patienten im Alter von 15 und mehr Jahren"
    ]
  },
  {
    "code": "J41.0",
    "name": "Chronische einfache Bronchitis",
    "synonyms": [
      "Chronische Bronchiorrhoe",
      "Chronische Bronchitis simplex",
      "Chronische einfache Bronchitis",
      "Chronische katarrhalische Bronchitis",
      "Raucherhusten"
    ]
  },
  {
    "code": "J41.1",
    "name": "Schleimig-eitrige chronische Bronchitis",
    "synonyms": [
      "Bronchitis purulenta",
      "Chronische Bronchitis putrida",
      "Chronische purulente Bronchitis",
      "Eitrige Bronchitis",
      "Eitrige Rhinobronchitis",
      "Eitrige Rhinosinubronchitis",
      "Eitrige Sinubronchitis",
      "Eitrige Sinularyngobronchitis",
      "Eitrige Tracheobronchitis",
      "Eitrige chronische Bronchitis",
      "Fötide Bronchitis",
      "Mukopurulente chronische Bronchitis",
      "Schleimig-eitrige chronische Bronchitis",
      "Suppurative Bronchitis"
    ]
  },
  {
    "code": "J41.8",
    "name": "Gemischte einfache und mukopurulente Bronchitis",
    "synonyms": [
      "Gemischte einfache und mukopurulente Bronchitis"
    ]
  },
  {
    "code": "J42",
    "name": "Chronische Tracheopharyngitis",
    "synonyms": [
      "Chronische Bronchitis",
      "Chronische Infektion der unteren Atmungsorgane",
      "Chronische Laryngotracheobronchitis",
      "Chronische Pharyngotracheitis",
      "Chronische Raucherbronchitis",
      "Chronische Sinubronchitis",
      "Chronische Tracheainfektion",
      "Chronische Tracheitis",
      "Chronische Tracheitis mit Bronchitis",
      "Chronische Tracheobronchitis",
      "Chronische Tracheopharyngitis",
      "Chronische infektiöse Bronchorrhoe",
      "Chronische senile Bronchitis",
      "Chronischer Bronchialkatarrh",
      "Chronisches Sinubronchialsyndrom",
      "Peribronchitis",
      "Rezidivierende Bronchitis",
      "Sinubronchiales Syndrom",
      "Sinubronchialsyndrom",
      "Stauungsbronchitis",
      "Stauungstracheobronchitis",
      "Tracheitis sicca",
      "Tracheobronchitis sicca"
    ]
  },
  {
    "code": "J43.0",
    "name": "McLeod-Syndrom",
    "synonyms": [
      "Einseitig helle Lunge",
      "Einseitiges Emphysem",
      "McLeod-Syndrom",
      "Syndrom der einseitig hellen Lunge",
      "Unilaterales Emphysem"
    ]
  },
  {
    "code": "J43.1",
    "name": "Panlobuläres Emphysem",
    "synonyms": [
      "Panazinöses Emphysem",
      "Panlobuläres Emphysem"
    ]
  },
  {
    "code": "J43.2",
    "name": "Zentrilobuläres Emphysem",
    "synonyms": [
      "Zentrilobuläres Emphysem"
    ]
  },
  {
    "code": "J43.9",
    "name": "Lungenemphysem",
    "synonyms": [
      "Altersemphysem",
      "Asthmaemphysem",
      "Atrophisches Emphysem",
      "Blähungslunge",
      "Bullöse Riesenzyste der Lunge",
      "Bullöses Emphysem",
      "Bullöses Lungenemphysem",
      "Chronisches Emphysem",
      "Chronisches Lungenemphysem",
      "Emphysem",
      "Emphysem im Alter",
      "Emphysema pulmonum",
      "Emphysemasthma",
      "Emphysembläschen",
      "Emphysemthorax",
      "Glasbläseremphysem",
      "Interlobuläres Emphysem",
      "Lungenblähung",
      "Lungenemphysem",
      "Nichtobstruktives Lungenemphysem",
      "Obstruktion der Atemwege mit Emphysem",
      "Obstruktion der Luftwege mit Emphysem",
      "Obstruktives Emphysem",
      "Pulmonales Emphysem",
      "Rupturierte Lungenbläschen",
      "Seniles Emphysem",
      "Vesikuläres Emphysem"
    ]
  },
  {
    "code": "J44.00",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &lt; 35 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &lt",
      "35 % des Sollwertes"
    ]
  },
  {
    "code": "J44.01",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &gt;= 35 % und &lt; 50 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &gt",
      "= 35 % und &lt",
      "50 % des Sollwertes"
    ]
  },
  {
    "code": "J44.02",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &gt;= 50 % und &lt; 70 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &gt",
      "= 50 % und &lt",
      "70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.03",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &gt;= 70 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege und mit FEV1 &gt",
      "= 70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.09",
    "name": "Chronische Emphysembronchitis mit akuter Infektion der unteren Atemwege",
    "synonyms": [
      "Chronisch-obstruktive Bronchitis mit akuter Infektion der unteren Atemwege",
      "Chronisch-obstruktive Tracheobronchitis mit akuter Infektion der unteren Atemwege",
      "Chronische Emphysembronchitis mit akuter Infektion der unteren Atemwege",
      "Chronische asthmatische Bronchitis mit akuter Infektion der unteren Atemwege",
      "Chronische emphysematöse Bronchitis mit akuter Infektion der unteren Atemwege",
      "Obstruktive Lungenkrankheit mit akuter Infektion der unteren Atemwege"
    ]
  },
  {
    "code": "J44.10",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &lt; 35 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &lt",
      "35 % des Sollwertes"
    ]
  },
  {
    "code": "J44.11",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &gt;= 35 % und &lt; 50 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &gt",
      "= 35 % und &lt",
      "50 % des Sollwertes"
    ]
  },
  {
    "code": "J44.12",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &gt;= 50 % und &lt; 70 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &gt",
      "= 50 % und &lt",
      "70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.13",
    "name": "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &gt;= 70 % des Sollwertes",
    "synonyms": [
      "Chronische obstruktive Lungenkrankheit mit akuter Exazerbation und mit FEV1 &gt",
      "= 70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.19",
    "name": "Chronisch-obstruktive Lungenerkrankung mit akuter Exazerbation",
    "synonyms": [
      "COPD [Chronic obstructive pulmonal disease] mit Exazerbation",
      "Chronisch-obstruktive Bronchitis mit akuter Exazerbation",
      "Chronisch-obstruktive Lungenerkrankung mit akuter Exazerbation",
      "Chronisch-obstruktive Tracheobronchitis mit Exazerbation",
      "Chronische Emphysembronchitis mit akuter Exazerbation",
      "Chronische asthmatische Bronchitis mit akuter Exazerbation",
      "Chronische emphysematöse Bronchitis mit akuter Exazerbation",
      "Emphysembronchitis mit Infektexazerbation",
      "Exazerbierte Emphysembronchitis",
      "Exazerbierte obstruktive Atemwegserkrankung",
      "Exazerbierte obstruktive Bronchitis",
      "Obstruktive Emphysembronchitis mit Exazerbation",
      "Obstruktive Lungenerkrankung mit Infektexazerbation",
      "Obstruktive Lungenkrankheit mit Exazerbation"
    ]
  },
  {
    "code": "J44.80",
    "name": "Chronische asthmatische Bronchitis mit FEV1 &lt; 35 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Bronchitis mit FEV1 &lt",
      "35 % des Sollwertes",
      "Chronische asthmatische Bronchitis mit FEV1 &lt",
      "35 % des Sollwertes"
    ]
  },
  {
    "code": "J44.81",
    "name": "Chronisch-obstruktive Bronchitis mit FEV1 &gt;= 35 % und &lt; 50 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Bronchitis mit FEV1 &gt",
      "= 35 % und &lt",
      "50 % des Sollwertes",
      "Chronische asthmatische Bronchitis mit FEV1 &gt",
      "= 35 % und &lt",
      "50 % des Sollwertes"
    ]
  },
  {
    "code": "J44.82",
    "name": "Chronisch-obstruktive Bronchitis mit FEV1 &gt;= 50 % und &lt; 70 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Bronchitis mit FEV1 &gt",
      "= 50 % und &lt",
      "70 % des Sollwertes",
      "Chronische asthmatische Bronchitis mit FEV1 &gt",
      "= 50 % und &lt",
      "70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.83",
    "name": "Chronisch-obstruktive Bronchitis mit FEV1 &gt;= 70 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Bronchitis mit FEV1 &gt",
      "= 70 % des Sollwertes",
      "Chronische asthmatische Bronchitis mit FEV1 &gt",
      "= 70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.89",
    "name": "Obstruktive Bronchitis",
    "synonyms": [
      "Altersemphysem bei Bronchitis",
      "Asthmatische Dyspnoe mit chronischer Bronchitis",
      "Bronchiolitis fibrosa obliterans",
      "Bronchiolitis obliterans mit obstruktiver Lungenerkrankung",
      "Bronchitis mit Asthmaemphysem",
      "Bronchitis mit Lungenblähung",
      "Bronchitis mit Lungenemphysem",
      "Bronchitis mit Obstruktion",
      "Bulböse Emphysembronchitis",
      "Bullöse Emphysembronchitis",
      "COB [Chronisch-obstruktive Bronchitis]",
      "COPD [Chronic obstructive pulmonal disease] vom Emphysemtyp",
      "Chronisch-obstruktive Bronchitis",
      "Chronisch-obstruktive Emphysembronchitis",
      "Chronisch-obstruktive Lungenkrankheit mit Bronchitis",
      "Chronisch-obstruktive Tracheobronchitis",
      "Chronisch-obstruktives Bronchialsyndrom",
      "Chronisch-spastische Bronchitis",
      "Chronische Bronchiolitis",
      "Chronische Bronchitis mit Atemwegsverschluss",
      "Chronische Bronchitis mit Obstruktion",
      "Chronische Bronchitis obliterans",
      "Chronische Emphysembronchitis",
      "Chronische asthmatische Bronchitis",
      "Chronische emphysematöse Bronchitis",
      "Chronische obliterierende Bronchiolitis",
      "Diffuse Panbronchiolitis",
      "Emphysembronchitis",
      "Obstruktive Bronchitis",
      "Obstruktive Emphysembronchitis",
      "Obstruktive Lungenkrankheit mit Emphysem",
      "Obstruktive Lungenkrankheit mit emphysematöser Bronchitis",
      "Obstruktive eitrige Bronchitis",
      "Rezidivierende obstruktive Bronchitis",
      "Spastische Emphysembronchitis"
    ]
  },
  {
    "code": "J44.90",
    "name": "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &lt; 35 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &lt",
      "35 % des Sollwertes",
      "Chronisch-obstruktive Lungenkrankheit mit FEV1 &lt",
      "35 % des Sollwertes"
    ]
  },
  {
    "code": "J44.91",
    "name": "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &gt;= 35 % und &lt; 50 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &gt",
      "= 35 % und &lt",
      "50 % des Sollwertes",
      "Chronisch-obstruktive Lungenkrankheit mit FEV1 &gt",
      "= 35 % und &lt",
      "50 % des Sollwertes"
    ]
  },
  {
    "code": "J44.92",
    "name": "Chronisch-obstruktive Lungenkrankheit mit FEV1 &gt;= 50 % und &lt; 70 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &gt",
      "= 50 % und &lt",
      "70 % des Sollwertes",
      "Chronisch-obstruktive Lungenkrankheit mit FEV1 &gt",
      "= 50 % und &lt",
      "70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.93",
    "name": "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &gt;= 70 % des Sollwertes",
    "synonyms": [
      "Chronisch-obstruktive Atemwegskrankheit mit FEV1 &gt",
      "= 70 % des Sollwertes",
      "Chronisch-obstruktive Lungenkrankheit mit FEV1 &gt",
      "= 70 % des Sollwertes"
    ]
  },
  {
    "code": "J44.99",
    "name": "COLD [Chronic obstructive lung disease]",
    "synonyms": [
      "COLD [Chronic obstructive lung disease]",
      "COPD [Chronic obstructive pulmonal disease]",
      "COPE [Chronische obstruktive Pulmonalerkrankung]",
      "Chronisch-obstruktive Atemwegskrankheit",
      "Chronisch-obstruktive Lungenerkrankung",
      "Chronisch-obstruktive Lungenkrankheit",
      "Chronische Obstruktion der Atemwege",
      "Chronische Obstruktion der Atmungsorgane",
      "Chronische Obstruktion der Luftwege",
      "Chronische respiratorische Obstruktion",
      "Chronischer Verschluss der Atemwege",
      "Obstruktion der Atemwege mit Asthma a.n.k.",
      "Obstruktion der Luftwege mit Asthma a.n.k.",
      "Obstruktive Lunge",
      "Obstruktive Lungenkrankheit",
      "Obstruktive pulmonale Erkrankung",
      "Obstruktives Atemwegssyndrom"
    ]
  },
  {
    "code": "J45.00",
    "name": "Vorwiegend allergisches Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Vorwiegend allergisches Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.01",
    "name": "Vorwiegend allergisches Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Vorwiegend allergisches Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.02",
    "name": "Vorwiegend allergisches Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Vorwiegend allergisches Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.03",
    "name": "Vorwiegend allergisches Asthma bronchiale, als gut kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Vorwiegend allergisches Asthma bronchiale, als gut kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.04",
    "name": "Vorwiegend allergisches Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Vorwiegend allergisches Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.05",
    "name": "Vorwiegend allergisches Asthma bronchiale, als unkontrolliert und schwer bezeichnet",
    "synonyms": [
      "Vorwiegend allergisches Asthma bronchiale, als unkontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.09",
    "name": "Allergische Bronchitis",
    "synonyms": [
      "Allergische Bronchitis",
      "Allergische Rhinopathie mit Asthma bronchiale",
      "Allergische Sinubronchitis",
      "Allergisches Asthma",
      "Allergisches Asthma bronchiale",
      "Allergisches Bronchialasthma",
      "Allergisches hyperreaktives Bronchialsystem",
      "Ambrosiagewächsallergie mit Asthma",
      "Asthma atopicum",
      "Asthma bronchiale atopicum",
      "Asthma durch Heu",
      "Asthma durch Mehlallergie",
      "Asthma durch Nahrungsmittel",
      "Asthma durch Platin",
      "Asthma durch Pollen",
      "Asthma durch exogen-allergische Ursachen",
      "Asthma extrinsicum",
      "Asthma in der Kindheit",
      "Asthma infantum",
      "Asthma mit Heufieber",
      "Asthma mit allergischer Rhinitis",
      "Atopisches Asthma",
      "Bronchialallergose",
      "Bäckerasthma",
      "Exogenes allergisches Asthma",
      "Extrinsisches Asthma bronchiale",
      "Gräserallergie mit Asthma",
      "Hausstauballergie mit Asthma",
      "Hausstaubmilbenallergie mit Bronchialasthma",
      "Heuschnupfen mit Asthma bronchiale",
      "Pollenallergie mit Asthma",
      "Rhinobronchitis allergica",
      "Vorwiegend allergisches Asthma bronchiale",
      "Überwiegend allergisches Asthma"
    ]
  },
  {
    "code": "J45.10",
    "name": "Nichtallergisches Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Nichtallergisches Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.11",
    "name": "Nichtallergisches Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Nichtallergisches Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.12",
    "name": "Nichtallergisches Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Nichtallergisches Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.13",
    "name": "Nichtallergisches Asthma bronchiale, als gut kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Nichtallergisches Asthma bronchiale, als gut kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.14",
    "name": "Nichtallergisches Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Nichtallergisches Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.15",
    "name": "Nichtallergisches Asthma bronchiale, als unkontrolliert und schwer bezeichnet",
    "synonyms": [
      "Nichtallergisches Asthma bronchiale, als unkontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.19",
    "name": "Nichtallergisches Asthma bronchiale",
    "synonyms": [
      "Analgetika-Asthma",
      "Anstrengungsasthma",
      "Anstrengungsbedingtes Bronchialasthma",
      "Asthma bei Idiosynkrasie",
      "Asthma bronchiale durch Analgetika",
      "Asthma intrinsicum",
      "Asthma mit akuter Infektion",
      "Asthma nervosum",
      "Asthmatische endogene Bronchitis",
      "Belastungsasthma",
      "Endogenes Asthma",
      "Endogenes nichtallergisches Asthma bronchiale",
      "Exercise-induced Asthma",
      "Infektasthma",
      "Infektbedingtes Asthma bronchiale",
      "Infektbedingtes Bronchialasthma",
      "Intrinsisches Asthma",
      "Intrinsisches Asthma bronchiale",
      "Nervöses Asthma",
      "Nichtallergisches Asthma bronchiale",
      "Nichtallergisches Asthma bronchiale durch ein Arzneimittel",
      "Nichtallergisches Asthma bronchiale durch ein Medikament",
      "Nichtallergisches arzneimittelbedingtes Asthma",
      "Nichtallergisches intrinsisches Asthma"
    ]
  },
  {
    "code": "J45.80",
    "name": "Mischform des Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Mischform des Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.81",
    "name": "Mischform des Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Mischform des Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.82",
    "name": "Mischform des Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Mischform des Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.83",
    "name": "Mischform des Asthma bronchiale, als gut kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Mischform des Asthma bronchiale, als gut kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.84",
    "name": "Mischform des Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Mischform des Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.85",
    "name": "Mischform des Asthma bronchiale, als unkontrolliert und schwer bezeichnet",
    "synonyms": [
      "Mischform des Asthma bronchiale, als unkontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.89",
    "name": "Mischform des Asthma bronchiale",
    "synonyms": [
      "Asthma bronchiale intrinsicum et extrinsicum",
      "Asthma mixtum",
      "Infektbedingte Exazerbation eines allergischen Bronchialasthmas",
      "Intrinsisches Bronchialasthma mit extrinsischem Ursprung",
      "Mischform des Asthma bronchiale"
    ]
  },
  {
    "code": "J45.90",
    "name": "Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Asthma bronchiale, als gut kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.91",
    "name": "Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Asthma bronchiale, als teilweise kontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.92",
    "name": "Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet",
    "synonyms": [
      "Asthma bronchiale, als unkontrolliert und nicht schwer bezeichnet"
    ]
  },
  {
    "code": "J45.93",
    "name": "Asthma bronchiale, als gut kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Asthma bronchiale, als gut kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.94",
    "name": "Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet",
    "synonyms": [
      "Asthma bronchiale, als teilweise kontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.95",
    "name": "Asthma bronchiale, als unkontrolliert und schwer bezeichnet",
    "synonyms": [
      "Asthma bronchiale, als unkontrolliert und schwer bezeichnet"
    ]
  },
  {
    "code": "J45.99",
    "name": "Exazerbiertes Asthma",
    "synonyms": [
      "Akutes Asthma",
      "Asthma",
      "Asthma bronchiale",
      "Asthma pulmonum",
      "Asthma-bronchiale-Anfall",
      "Asthmaanfall",
      "Asthmabronchitis",
      "Asthmatische Beschwerden",
      "Asthmatische Bronchitis",
      "Asthmatische Dyspnoe",
      "Asthmatische Dyspnoe mit Bronchitis",
      "Asthmatische obstruktive Bronchitis",
      "Asthmoide Bronchitis",
      "Asthmoide Spasmen",
      "Bronchialasthma",
      "Bronchitis bei Asthma bronchiale",
      "Chronisches Asthma",
      "Exazerbiertes Asthma",
      "Greisenasthma",
      "Kruppöses Asthma",
      "Late-onset-Asthma",
      "Lungenasthma",
      "Pulmonales Asthma",
      "Spastisches Asthma"
    ]
  },
  {
    "code": "J46",
    "name": "Status asthmaticus",
    "synonyms": [
      "Akutes schweres Asthma",
      "Status asthmaticus",
      "Status asthmaticus bei Asthma bronchiale"
    ]
  },
  {
    "code": "J47",
    "name": "Bronchusdilatation",
    "synonyms": [
      "Atemwegobstruktion mit Bronchiektasie",
      "Bronchiektasie",
      "Bronchiolektasen",
      "Bronchiolendilatation",
      "Bronchiolenerweiterung",
      "Bronchusdilatation",
      "Bronchuserweiterung",
      "Diffuse Bronchiektasie",
      "Ektasie des Bronchus",
      "Fusiforme Bronchiektasie",
      "Idiopathische Bronchiektasie",
      "Lokalisierte Bronchiektasie",
      "Luftwegobstruktion mit Bronchiektasie",
      "Postinfektiöse Bronchiektasie",
      "Sackförmige Bronchiektasie",
      "Zylindrische Bronchiektasie"
    ]
  },
  {
    "code": "J60",
    "name": "Bergmannslunge",
    "synonyms": [
      "Anthracosis pulmonum",
      "Anthrakose",
      "Anthrakose mit Lymphadenitis",
      "Anthrakosilikose",
      "Bergleute-Asthma",
      "Bergleute-Pneumokoniose",
      "Bergmannslunge",
      "Kohlenbergarbeiter-Pneumokoniose",
      "Kohlenstaublunge",
      "Lungenanthrakose",
      "Lungenfibrose mit Anthrakose",
      "Lungenfibrose mit Anthrakosilikose",
      "Pneumokoniose durch Kohlenstaub"
    ]
  },
  {
    "code": "J61.0",
    "name": "Asbestose",
    "synonyms": [
      "Amianthose",
      "Asbestlunge",
      "Asbestose",
      "Asbestosis pulmonum",
      "Asbeststaublunge",
      "Bergflachslunge",
      "Lungenasbestose",
      "Lungenfibrose mit Asbestose",
      "Pneumokoniose durch Asbest",
      "Pneumokoniose durch Asbest ohne akute Exazerbation",
      "Pneumokoniose durch anorganische Fasern ohne akute Exazerbation",
      "Pneumonie durch anorganische Fasern a.n.k."
    ]
  },
  {
    "code": "J61.1",
    "name": "Pneumokoniose durch Asbest mit akuter Exazerbation",
    "synonyms": [
      "Pneumokoniose durch Asbest mit akuter Exazerbation",
      "Pneumokoniose durch anorganische Fasern mit akuter Exazerbation"
    ]
  },
  {
    "code": "J62.0",
    "name": "Pneumokoniose durch Talkumstaub",
    "synonyms": [
      "Massive silikotische Lungenfibrose durch Talkumstaub",
      "Pneumokoniose durch Talkumstaub",
      "Silikotische Lungenfibrose durch Talkumstaub",
      "Talkose",
      "Talkose der Lunge"
    ]
  },
  {
    "code": "J62.8",
    "name": "Pneumokoniose durch Quarzstaub",
    "synonyms": [
      "Asthma montanum",
      "Chalikose",
      "Einfache Silikose",
      "Kalkstaublunge",
      "Kalzikose",
      "Kiesellunge",
      "Lungenfibrose mit Chalikose",
      "Lungenfibrose mit Kalzikose",
      "Lungenfibrose mit Silikose",
      "Lungensilikose",
      "Massive silikotische Lungenfibrose durch Quarzstaub",
      "Pneumokoniose durch Diatomit",
      "Pneumokoniose durch Glimmer",
      "Pneumokoniose durch Kalkstaub",
      "Pneumokoniose durch Kaolin",
      "Pneumokoniose durch Kieselsäure",
      "Pneumokoniose durch Marmorstaub",
      "Pneumokoniose durch Quarzstaub",
      "Pneumokoniose durch Silikate a.n.k.",
      "Quarzlunge",
      "Sandstrahlgebläsearbeiter-Asthma",
      "Schleifer-Asthma",
      "Siderosilikose",
      "Silikose",
      "Silikose mit Komplikation",
      "Silikosiderose",
      "Silikotische Lungenfibrose durch Quarzstaub",
      "Staublunge durch Steinstaub",
      "Steinhauerkrankheit",
      "Steinhauerlunge",
      "Steinmetz-Asthma",
      "Steinmetz-Krankheit",
      "Steinmetzlunge",
      "Steinstaublunge",
      "Töpfer-Asthma"
    ]
  },
  {
    "code": "J63.0",
    "name": "Aluminose",
    "synonyms": [
      "Aluminiumlunge",
      "Aluminiumstaublunge",
      "Aluminose",
      "Aluminosis pulmonum",
      "Lungenaluminose",
      "Lungenfibrose mit Aluminose",
      "Pneumokoniose durch Aluminium"
    ]
  },
  {
    "code": "J63.1",
    "name": "Lungenbauxitfibrose",
    "synonyms": [
      "Bauxitfibrose",
      "Lungenbauxitfibrose",
      "Pneumokoniose durch Bauxit"
    ]
  },
  {
    "code": "J63.2",
    "name": "Berylliumstaublunge",
    "synonyms": [
      "Berylliose",
      "Berylliosis pulmonum",
      "Berylliumgranulomatose",
      "Berylliumlunge",
      "Berylliumpneumonie",
      "Berylliumstaublunge",
      "Chronische Berylliose",
      "Lungenberylliose",
      "Lungenfibrose mit Berylliose",
      "Pneumokoniose durch Beryllium"
    ]
  },
  {
    "code": "J63.3",
    "name": "Graphitstaublunge",
    "synonyms": [
      "Graphitfibrose",
      "Graphitfibrose der Lunge",
      "Graphitlunge",
      "Graphitpneumokoniose",
      "Graphitstaublunge"
    ]
  },
  {
    "code": "J63.4",
    "name": "Lungensiderose",
    "synonyms": [
      "Eisenablagerung",
      "Eisenablagerung in der Lunge",
      "Eisenlunge",
      "Eisenstaublunge",
      "Lungenfibrose mit Pneumosiderose",
      "Lungenfibrose mit Siderose",
      "Lungenkrankheit durch Eisen",
      "Lungensiderose",
      "Pneumosiderose",
      "Siderose",
      "Siderosis pulmonum"
    ]
  },
  {
    "code": "J63.5",
    "name": "Stannose",
    "synonyms": [
      "Lungenfibrose mit Stannose",
      "Stannose",
      "Zinnarbeiterlunge"
    ]
  },
  {
    "code": "J63.8",
    "name": "Pneumokoniose durch anorganische Stäube",
    "synonyms": [
      "Bleiminenarbeiterlunge",
      "Manganpneumonie",
      "Pneumokoniose durch anorganische Stäube"
    ]
  },
  {
    "code": "J64",
    "name": "Staublunge",
    "synonyms": [
      "Lungenfibrose mit Pneumokoniose a.n.k.",
      "Mischstaubpneumokoniose",
      "Pneumokoniose a.n.k.",
      "Staubinhalations-Krankheit",
      "Staublunge",
      "Staublungen-Krankheit"
    ]
  },
  {
    "code": "J65",
    "name": "Silikotuberkulose",
    "synonyms": [
      "Aluminose mit Tuberkulose der Atmungsorgane",
      "Anthrakose mit Tuberkulose der Atmungsorgane",
      "Asbestose mit Tuberkulose der Atmungsorgane",
      "Bauxitfibrose mit Tuberkulose der Atmungsorgane",
      "Berylliose mit Tuberkulose der Atmungsorgane",
      "Graphitfibrose mit Tuberkulose der Atmungsorgane",
      "Pneumokoniose mit Tuberkulose",
      "Pneumokoniose mit Tuberkulose der Atmungsorgane",
      "Siderose mit Tuberkulose der Atmungsorgane",
      "Silikose mit Tuberkulose der Atmungsorgane",
      "Silikotuberkulose",
      "Stannose mit Tuberkulose der Atmungsorgane",
      "TBC [Tuberkulose] bei Silikose"
    ]
  },
  {
    "code": "J66.0",
    "name": "Byssinose",
    "synonyms": [
      "Atemwegskrankheit durch Baumwollstaub",
      "Baumwollstaublunge",
      "Byssinose",
      "Byssinose-Syndrom",
      "Lungenfibrose mit Byssinose",
      "Pneumokoniose durch Baumwollstaub"
    ]
  },
  {
    "code": "J66.1",
    "name": "Flachsarbeiterkrankheit",
    "synonyms": [
      "Flachsarbeiterkrankheit"
    ]
  },
  {
    "code": "J66.2",
    "name": "Cannabiose",
    "synonyms": [
      "Cannabinosis",
      "Cannabiose"
    ]
  },
  {
    "code": "J66.8",
    "name": "Pneumopathie durch organischen Staub a.n.k.",
    "synonyms": [
      "Pneumokoniose durch organischen Staub a.n.k.",
      "Pneumopathie durch organischen Staub a.n.k."
    ]
  },
  {
    "code": "J67.00",
    "name": "Drescherlunge",
    "synonyms": [
      "Drescher-Krankheit",
      "Drescher-Syndrom",
      "Drescherlunge",
      "Erntearbeiterlunge",
      "Farmerlunge",
      "Farmerlunge ohne Angabe einer akuten Exazerbation",
      "Getreidearbeiterkrankheit",
      "Getreidearbeiterlunge",
      "Lungenfibrose mit Farmerlunge",
      "Mouldy hay disease",
      "Mouldy-hay-Krankheit",
      "Mouldy-hay-Pneumokoniose"
    ]
  },
  {
    "code": "J67.01",
    "name": "Farmerlunge mit akuter Exazerbation",
    "synonyms": [
      "Farmerlunge mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.10",
    "name": "Bagassose",
    "synonyms": [
      "Bagasse-Krankheit",
      "Bagasse-Pneumokoniose",
      "Bagasse-Pneumonitis",
      "Bagasse-Staublunge",
      "Bagassose",
      "Bagassose ohne Angabe einer akuten Exazerbation",
      "Bagassosis",
      "Lungenfibrose mit Bagassose",
      "Zuckerrohr-Pneumokoniose"
    ]
  },
  {
    "code": "J67.11",
    "name": "Bagassose mit akuter Exazerbation",
    "synonyms": [
      "Bagassose mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.20",
    "name": "Vogelzüchterlunge",
    "synonyms": [
      "Taubenzüchter-Lungenkrankheit",
      "Taubenzüchterkrankheit",
      "Taubenzüchterlunge",
      "Vogelhalterkrankheit",
      "Vogelzüchterkrankheit",
      "Vogelzüchterlunge",
      "Vogelzüchterlunge ohne Angabe einer akuten Exazerbation",
      "Wellensittichzüchterkrankheit",
      "Wellensittichzüchterlunge"
    ]
  },
  {
    "code": "J67.21",
    "name": "Vogelzüchterlunge mit akuter Exazerbation",
    "synonyms": [
      "Vogelzüchterlunge mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.30",
    "name": "Suberose",
    "synonyms": [
      "Korkarbeiterkrankheit",
      "Korkarbeiterlunge",
      "Korkrindenschälerkrankheit",
      "Korkrindenschälerlunge",
      "Korkstaublunge",
      "Suberose",
      "Suberose ohne Angabe einer akuten Exazerbation",
      "Suberosis",
      "Suberosis pulmonum"
    ]
  },
  {
    "code": "J67.31",
    "name": "Suberose mit akuter Exazerbation",
    "synonyms": [
      "Suberose mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.40",
    "name": "Malzarbeiterlunge",
    "synonyms": [
      "Alveolitis durch Aspergillus clavatus",
      "Malzarbeiterlunge",
      "Malzarbeiterlunge ohne Angabe einer akuten Exazerbation"
    ]
  },
  {
    "code": "J67.41",
    "name": "Malzarbeiterlunge mit akuter Exazerbation",
    "synonyms": [
      "Malzarbeiterlunge mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.50",
    "name": "Pilzarbeiterlunge",
    "synonyms": [
      "Pilzarbeiterlunge",
      "Pilzarbeiterlunge ohne Angabe einer akuten Exazerbation"
    ]
  },
  {
    "code": "J67.51",
    "name": "Pilzarbeiterlunge mit akuter Exazerbation",
    "synonyms": [
      "Pilzarbeiterlunge mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.60",
    "name": "Ahornrindenstreiferkrankheit",
    "synonyms": [
      "Ahornrindenschälerlunge",
      "Ahornrindenschälerlunge ohne Angabe einer akuten Exazerbation",
      "Ahornrindenstreiferkrankheit",
      "Ahornrindensyndrom",
      "Alveolitis durch Cryptostroma corticale",
      "Towey-Krankheit"
    ]
  },
  {
    "code": "J67.61",
    "name": "Ahornrindenschälerlunge mit akuter Exazerbation",
    "synonyms": [
      "Ahornrindenschälerlunge mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.70",
    "name": "Ventilationspneumonitis [Klimaanlagenpneumonitis]",
    "synonyms": [
      "Allergische Alveolitis durch Organismen aus Belüftungsanlagen",
      "Allergische Alveolitis durch Pilze",
      "Allergische Alveolitis durch thermophile Aktinomyzeten",
      "Befeuchterlunge",
      "Befeuchterlunge ohne Angabe einer akuten Exazerbation",
      "Befeuchterpneumonitis",
      "Klimaanlage-Lunge ohne Angabe einer akuten Exazerbation",
      "Klimaanlagenpneumonitis",
      "Ventilationspneumonitis [Klimaanlagenpneumonitis]"
    ]
  },
  {
    "code": "J67.71",
    "name": "Befeuchterlunge mit akuter Exazerbation",
    "synonyms": [
      "Befeuchterlunge mit akuter Exazerbation",
      "Klimaanlage-Lunge mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.80",
    "name": "Kürschnerlunge",
    "synonyms": [
      "Allergische Pneumonitis durch Holzstaub",
      "Allergische Pneumonitis durch organischen Staub a.n.k.",
      "Fischmehlarbeiterlunge",
      "Fischmehlarbeiterlunge ohne Angabe einer akuten Exazerbation",
      "Kaffeearbeiterlunge",
      "Kaffeearbeiterlunge ohne Angabe einer akuten Exazerbation",
      "Käsewäscherlunge",
      "Käsewäscherlunge ohne Angabe einer akuten Exazerbation",
      "Kürschnerlunge",
      "Kürschnerlunge ohne Angabe einer akuten Exazerbation",
      "Sequoiose",
      "Sequoiose ohne Angabe einer akuten Exazerbation"
    ]
  },
  {
    "code": "J67.81",
    "name": "Fischmehlarbeiterlunge mit akuter Exazerbation",
    "synonyms": [
      "Fischmehlarbeiterlunge mit akuter Exazerbation",
      "Kaffeearbeiterlunge mit akuter Exazerbation",
      "Käsewäscherlunge mit akuter Exazerbation",
      "Kürschnerlunge mit akuter Exazerbation",
      "Sequoiose mit akuter Exazerbation"
    ]
  },
  {
    "code": "J67.90",
    "name": "Allergische Alveolitis",
    "synonyms": [
      "Allergische Alveolitis",
      "Allergische Alveolitis durch eingeatmeten organischen Staub",
      "Allergische Alveolitis durch organischen Staub ohne Angabe einer akuten Exazerbation",
      "Allergische Pneumonitis",
      "Atemwegobstruktion mit allergischer Alveolitis",
      "Exogen-allergische Alveolitis",
      "Extrinsische Alveolitis",
      "Hypersensitive Pneumonitis",
      "Hypersensitive Pneumonitis durch eingeatmeten organischen Staub",
      "Hypersensitivitätspneumonie",
      "Luftwegobstruktion mit allergischer Alveolitis",
      "Überempfindlichkeit mit Pneumonitis a.n.k."
    ]
  },
  {
    "code": "J67.91",
    "name": "Allergische Alveolitis durch organischen Staub mit akuter Exazerbation",
    "synonyms": [
      "Allergische Alveolitis durch organischen Staub mit akuter Exazerbation"
    ]
  },
  {
    "code": "J68.0",
    "name": "Bronchitis durch Rauch",
    "synonyms": [
      "Akute Bronchitis durch Chemikalie",
      "Akute chemische Bronchitis",
      "Bronchitis durch Chemikalie",
      "Bronchitis durch Rauch",
      "Bronchopneumonie durch Dampf",
      "Bronchopneumonie durch Gas",
      "Bronchopneumonie durch Rauch",
      "Pneumonie durch Dampf",
      "Pneumonie durch Gas",
      "Pneumonie durch Rauch",
      "Pneumonie durch chemische Substanzen",
      "Pneumonitis durch Beryllium",
      "Pneumonitis durch Dampf",
      "Pneumonitis durch Fluorkohlenstoff-Polymere",
      "Pneumonitis durch Gas",
      "Pneumonitis durch Kadmium",
      "Pneumonitis durch Mangan",
      "Pneumonitis durch Rauch",
      "Pneumonitis durch Stickstoffdioxid",
      "Pneumonitis durch Vanadium",
      "Subakute chemische Bronchitis"
    ]
  },
  {
    "code": "J68.1",
    "name": "Akutes Lungenödem durch Rauch",
    "synonyms": [
      "Akutes Lungenödem durch Chemikalie",
      "Akutes Lungenödem durch Rauch",
      "Lungenödem durch Chemikalie",
      "Lungenödem durch Rauch",
      "Toxisches Lungenödem durch Rauch",
      "Toxisches Lungenödem durch chemische Substanzen"
    ]
  },
  {
    "code": "J68.2",
    "name": "Entzündung der oberen Luftwege durch Rauch",
    "synonyms": [
      "Entzündung der oberen Atemwege durch Dampf",
      "Entzündung der oberen Atemwege durch Rauch",
      "Entzündung der oberen Luftwege durch Dampf",
      "Entzündung der oberen Luftwege durch Rauch"
    ]
  },
  {
    "code": "J68.3",
    "name": "Reactive airways dysfunction syndrome",
    "synonyms": [
      "Akute Krankheit der Atmungsorgane durch Dampf",
      "Akute Krankheit der Atmungsorgane durch Gas",
      "Akute Krankheit der Atmungsorgane durch Rauch",
      "Akute Krankheit der Atmungsorgane durch chemische Substanzen",
      "Akute respiratorische Affektion durch Dampf",
      "Akute respiratorische Affektion durch Gas",
      "Akute respiratorische Affektion durch Rauch",
      "Reactive airways dysfunction syndrome",
      "Reaktive Atemwegskrankheit"
    ]
  },
  {
    "code": "J68.4",
    "name": "Chronische respiratorische Affektion durch Rauch",
    "synonyms": [
      "Chronische Bronchitis durch Chemikalie",
      "Chronische Bronchitis durch Dampf",
      "Chronische Bronchitis durch Gas",
      "Chronische Bronchitis durch Rauch",
      "Chronische Krankheit der Atmungsorgane durch Dampf",
      "Chronische Krankheit der Atmungsorgane durch Gas",
      "Chronische Krankheit der Atmungsorgane durch Rauch",
      "Chronische Krankheit der Atmungsorgane durch chemische Substanzen",
      "Chronische Lungenfibrose durch Einatmen einer chemischen Substanz",
      "Chronische Lungenfibrose durch Einatmen von Dampf",
      "Chronische Lungenfibrose durch Einatmen von Gas",
      "Chronische Lungenfibrose durch Einatmen von Rauch",
      "Chronische chemische Bronchiolitis",
      "Chronische chemische Bronchitis",
      "Chronische obliterierende Bronchiolitis durch Einatmen einer chemischen Substanz",
      "Chronische obliterierende Bronchiolitis durch Einatmen von Dampf",
      "Chronische obliterierende Bronchiolitis durch Einatmen von Gas",
      "Chronische obliterierende Bronchiolitis durch Einatmen von Rauch",
      "Chronische respiratorische Affektion durch Dampf",
      "Chronische respiratorische Affektion durch Rauch",
      "Chronisches Emphysem durch Einatmen einer chemischen Substanz",
      "Chronisches Emphysem durch Einatmen von Dampf",
      "Chronisches Emphysem durch Einatmen von Gas",
      "Chronisches Emphysem durch Einatmen von Rauch",
      "Chronisches Lungenödem durch Chemikalie",
      "Chronisches Lungenödem durch Dampf",
      "Diffuses Emphysem durch Einatmen einer chemischen Substanz",
      "Diffuses Emphysem durch Einatmen von Dampf",
      "Diffuses Emphysem durch Einatmen von Gas",
      "Diffuses Emphysem durch Einatmen von Rauch",
      "Emphysem durch Chemikalie",
      "Emphysem durch Dampf",
      "Emphysem durch Einatmen einer chemischen Substanz",
      "Emphysem durch Einatmen von Dampf",
      "Emphysem durch Einatmen von Gas",
      "Emphysem durch Einatmen von Rauch",
      "Emphysem durch Gas",
      "Emphysem durch Rauch",
      "Lungenfibrose durch Einatmen einer chemischen Substanz",
      "Lungenfibrose durch Einatmen von Dampf",
      "Lungenfibrose durch Einatmen von Gas",
      "Lungenfibrose durch Einatmen von Rauch",
      "Obliterierende Bronchiolitis durch Einatmen einer chemischen Substanz",
      "Obliterierende Bronchiolitis durch Einatmen von Dampf",
      "Obliterierende Bronchiolitis durch Einatmen von Gas",
      "Obliterierende Bronchiolitis durch Einatmen von Rauch",
      "Respiratorische Bronchiolitis assoziiert mit interstitieller Lungenerkrankung",
      "Respiratory bronchiolitis interstitial lung disease [RB-ILD]",
      "Subakute obliterierende Bronchiolitis durch Einatmen einer chemischen Substanz",
      "Subakute obliterierende Bronchiolitis durch Einatmen von Dampf",
      "Subakute obliterierende Bronchiolitis durch Einatmen von Gas",
      "Subakute obliterierende Bronchiolitis durch Einatmen von Rauch"
    ]
  },
  {
    "code": "J68.8",
    "name": "Staublunge durch Rauch",
    "synonyms": [
      "Silofüllerkrankheit",
      "Silofüllersyndrom",
      "Staublunge durch Rauch"
    ]
  },
  {
    "code": "J68.9",
    "name": "Respiratorische Affektion durch Rauch",
    "synonyms": [
      "Respiratorische Affektion durch Dampf",
      "Respiratorische Affektion durch Gas",
      "Respiratorische Affektion durch Rauch"
    ]
  },
  {
    "code": "J69.0",
    "name": "Pneumonitis durch Aspiration von Nahrung",
    "synonyms": [
      "Aspirationsbronchopneumonie",
      "Aspirationslunge",
      "Aspirationspneumonie",
      "Aspirationspneumonie durch Erbrochenes",
      "Aspirationspneumonie durch Magensekret",
      "Aspirationspneumonie durch Milch",
      "Aspirationspneumonie durch Nahrungsmittel",
      "Aspirationspneumonie durch regurgitierte Nahrung",
      "Aspirationspneumonitis",
      "Bronchopneumonie durch Inhalation",
      "Deglutitions-Pneumonie",
      "Pneumonie durch Inhalation von Erbrochenem",
      "Pneumonie durch Inhalation von Nahrung",
      "Pneumonitis durch Aspiration von Erbrochenem",
      "Pneumonitis durch Aspiration von Nahrung",
      "Pneumonitis durch Inhalation von Erbrochenem",
      "Pneumonitis durch Inhalation von Milch",
      "Pneumonitis durch Inhalation von Nahrung",
      "Schluckpneumonie"
    ]
  },
  {
    "code": "J69.1",
    "name": "Lipidpneumonie",
    "synonyms": [
      "Aspirationspneumonie durch Essenzen",
      "Aspirationspneumonie durch Öl",
      "Bronchopneumonie durch Inhalation von Essenzen",
      "Bronchopneumonie durch Inhalation von Öl",
      "Bronchopneumonie durch Lipoide",
      "Lipidpneumonie",
      "Lipoidpneumonie",
      "Pneumonitis durch Aspiration von Lipoiden",
      "Pneumonitis durch Aspiration von Ölextrakten",
      "Pneumonitis durch Inhalation von Essenzen",
      "Pneumonitis durch Inhalation von Öl"
    ]
  },
  {
    "code": "J69.8",
    "name": "Asthma durch Detergenzien",
    "synonyms": [
      "Aspirationspneumonie durch Blut",
      "Aspirationspneumonie durch festen Stoff a.n.k.",
      "Aspirationspneumonie durch flüssigen Stoff a.n.k.",
      "Asthma durch Detergenzien",
      "Inhalationspneumonitis durch festen Stoff a.n.k.",
      "Inhalationspneumonitis durch flüssigen Stoff a.n.k.",
      "Pneumonie durch Aspiration von Blut",
      "Pneumonitis durch Detergenzien",
      "Pneumonitis durch Inhalation von Blut",
      "Pneumonitis durch festen Stoff a.n.k.",
      "Pneumonitis durch flüssigen Stoff a.n.k."
    ]
  },
  {
    "code": "J70.0",
    "name": "Strahlenpneumonitis",
    "synonyms": [
      "Akute Bronchitis durch Bestrahlung",
      "Akute Entzündung der oberen Atmungsorgane durch Bestrahlung",
      "Akute Lungenbeteiligung bei Strahleneinwirkung",
      "Akute pulmonale Manifestation durch Bestrahlung",
      "Akute respiratorische Affektion durch Bestrahlung",
      "Akute strahleninduzierte interstitielle Lungenkrankheit",
      "Akutes Lungenödem durch Bestrahlung",
      "Bestrahlungslunge",
      "Pneumonie durch Bestrahlung",
      "Radiogene Pneumonie",
      "Strahlenpneumonitis",
      "Subakute Bronchitis durch Bestrahlung"
    ]
  },
  {
    "code": "J70.1",
    "name": "Lungenstrahlenfibrose",
    "synonyms": [
      "Chronische Bronchitis durch Bestrahlung",
      "Chronische Krankheit der Atmungsorgane durch Bestrahlung",
      "Chronische pulmonale Manifestation durch Bestrahlung",
      "Chronische respiratorische Affektion durch Bestrahlung",
      "Chronische strahleninduzierte interstitielle Lungenkrankheit",
      "Lungenfibrose durch Bestrahlung",
      "Lungenfibrose nach Strahleneinwirkung",
      "Lungenstrahlenfibrose"
    ]
  },
  {
    "code": "J70.2",
    "name": "Akute arzneimittelinduzierte interstitielle Lungenkrankheit",
    "synonyms": [
      "Akute arzneimittelinduzierte Pneumonitis",
      "Akute arzneimittelinduzierte interstitielle Lungenkrankheit",
      "Akute arzneimittelinduzierte interstitielle Lungenstörung"
    ]
  },
  {
    "code": "J70.3",
    "name": "Chronische arzneimittelinduzierte interstitielle Lungenkrankheit",
    "synonyms": [
      "Chronische arzneimittelinduzierte Pneumonitis",
      "Chronische arzneimittelinduzierte interstitielle Lungenkrankheit",
      "Chronische arzneimittelinduzierte interstitielle Lungenstörung"
    ]
  },
  {
    "code": "J70.4",
    "name": "Zytostatikalunge",
    "synonyms": [
      "Arzneimittelinduzierte Lungenfibrose",
      "Arzneimittelinduzierte Pneumonitis",
      "Arzneimittelinduzierte interstitielle Lungenfibrose",
      "Arzneimittelinduzierte interstitielle Lungenkrankheit",
      "Arzneimittelinduzierte interstitielle Lungenstörung",
      "Zytostatikalunge"
    ]
  },
  {
    "code": "J70.9",
    "name": "Respiratorische Affektion durch äußere Wirkstoffe",
    "synonyms": [
      "Akute Krankheit der Atmungsorgane durch äußere Wirkstoffe",
      "Chronische Krankheit der Atmungsorgane durch äußere Wirkstoffe",
      "Lungenödem durch äußere Wirkstoffe",
      "Respiratorische Affektion durch äußere Wirkstoffe"
    ]
  },
  {
    "code": "J80.01",
    "name": "Mildes ARDS [Acute respiratory distress syndrome] des Erwachsenen",
    "synonyms": [
      "Mildes ARDS [Acute respiratory distress syndrome] des Erwachsenen",
      "Mildes akutes Atemnotsyndrom des Erwachsenen"
    ]
  },
  {
    "code": "J80.02",
    "name": "Moderates akutes Atemnotsyndrom des Erwachsenen",
    "synonyms": [
      "Moderates ARDS [Acute respiratory distress syndrome] des Erwachsenen",
      "Moderates akutes Atemnotsyndrom des Erwachsenen"
    ]
  },
  {
    "code": "J80.03",
    "name": "Schweres akutes Atemnotsyndrom des Erwachsenen",
    "synonyms": [
      "Schweres ARDS [Acute respiratory distress syndrome] des Erwachsenen",
      "Schweres akutes Atemnotsyndrom des Erwachsenen"
    ]
  },
  {
    "code": "J80.04",
    "name": "Mildes akutes Atemnotsyndrom des Kindes",
    "synonyms": [
      "Mildes ARDS [Acute respiratory distress syndrome] des Jugendlichen",
      "Mildes ARDS [Acute respiratory distress syndrome] des Kindes",
      "Mildes akutes Atemnotsyndrom des Jugendlichen",
      "Mildes akutes Atemnotsyndrom des Kindes"
    ]
  },
  {
    "code": "J80.05",
    "name": "Moderates akutes Atemnotsyndrom des Kindes",
    "synonyms": [
      "Moderates ARDS [Acute respiratory distress syndrome] des Jugendlichen",
      "Moderates ARDS [Acute respiratory distress syndrome] des Kindes",
      "Moderates akutes Atemnotsyndrom des Jugendlichen",
      "Moderates akutes Atemnotsyndrom des Kindes"
    ]
  },
  {
    "code": "J80.06",
    "name": "Schweres akutes Atemnotsyndrom des Kindes",
    "synonyms": [
      "Schweres ARDS [Acute respiratory distress syndrome] des Jugendlichen",
      "Schweres ARDS [Acute respiratory distress syndrome] des Kindes",
      "Schweres akutes Atemnotsyndrom des Jugendlichen",
      "Schweres akutes Atemnotsyndrom des Kindes"
    ]
  },
  {
    "code": "J80.09",
    "name": "Posttraumatische Lungeninsuffizienz",
    "synonyms": [
      "ARDS [Acute respiratory distress syndrome] des Erwachsenen",
      "ARDS [Acute respiratory distress syndrome] des Jugendlichen",
      "ARDS [Acute respiratory distress syndrome] des Kindes",
      "Acute respiratory distress syndrome",
      "Adultes Atemnotsyndrom",
      "Akutes Atemnotsyndrom beim Erwachsenen",
      "Akutes Atemnotsyndrom beim Jugendlichen",
      "Akutes Atemnotsyndrom beim Kind",
      "Atemnotsyndrom",
      "Atemnotzustand",
      "Hyaline Membranenkrankheit beim Erwachsenen",
      "Hyaline Membranenkrankheit beim Jugendlichen",
      "Hyaline Membranenkrankheit beim Kind",
      "Posttraumatische Lungeninsuffizienz",
      "Pulmonalinsuffizienz nach Schock",
      "Pulmonalinsuffizienz nach Trauma",
      "Respiratory-distress-Syndrom beim Erwachsenen",
      "Schocklunge"
    ]
  },
  {
    "code": "J81",
    "name": "Akutes Lungenödem",
    "synonyms": [
      "Akute Lungenstauung",
      "Akutes Lungenödem",
      "Chronisches Lungenödem",
      "Flüssigkeit in der Lunge - s.a. Ödem, Lunge",
      "Hypostatische Lungenstauung",
      "Interstitielles Lungenödem",
      "Lungenanschoppung",
      "Lungenhypostase",
      "Lungenstauung",
      "Lungenödem",
      "Passive Lungenhyperämie",
      "Passive Lungenstauung",
      "Passive pulmonale Hyperämie",
      "Passive pulmonale Hypostase",
      "Prälungenödem",
      "Pulmonale Hypostase",
      "Pulmonale Stase",
      "Pulmonale Stauung",
      "Rezidivierendes Lungenödem",
      "Terminales Lungenödem",
      "Wasserlunge"
    ]
  },
  {
    "code": "J82",
    "name": "Eosinophiles Lungeninfiltrat",
    "synonyms": [
      "Akute idiopathische eosinophile Pneumonie",
      "Allergische Bronchopneumonie",
      "Allergische Pneumonie",
      "Eosinophile Pneumonie",
      "Eosinophile Pneumonitis",
      "Eosinophiles Lungeninfiltrat",
      "Eosinophiles Lungeninfiltrat mit Asthma bronchiale",
      "IAEP [Idiopathische akute eosinophile Pneumonie]",
      "Idiopathische chronische eosinophile Pneumopathie",
      "Idiopathische eosinophile Pneumonie",
      "Lungeninfiltrat",
      "Löffler-I-Syndrom",
      "Löffler-Pneumonie",
      "Löffler-Syndrom",
      "Löhr-Léon-Kindberg-Syndrom",
      "Pulmonale Eosinophilie a.n.k.",
      "Tropische Eosinophilie",
      "Tropische pulmonale Eosinophilie",
      "Weingarten-Syndrom"
    ]
  },
  {
    "code": "J84.00",
    "name": "Microlithiasis alveolaris pulmonum",
    "synonyms": [
      "Alveolarpneumopathie",
      "Alveolarproteinose",
      "Alveolarproteinose ohne Angabe einer akuten Exazerbation",
      "Alveolarschaden",
      "Alveolarwandschaden",
      "Alveoläre Mikrolithiasis der Lunge",
      "Alveoläre Störung a.n.k.",
      "Autoimmune PAP [Pulmonale Alveolarproteinose]",
      "Autoimmune pulmonale Alveolarproteinose",
      "Bronchiolitis obliterans mit organisierender Pneumonie [BOOP]",
      "COP [Cryptogenic organising pneumonia]",
      "COP [Cryptogenic organising pneumonia] ohne Angabe einer akuten Exazerbation",
      "Chronische Pneumonitis des Kindesalters",
      "Idiopathische PAP [Pulmonale Alveolarproteinose]",
      "Idiopathische pulmonale Alveolarproteinose",
      "Isolierte pulmonale Kapillaritis",
      "Kongenitale pulmonale Alveolarproteinose",
      "Kryptogene organisierende Pneumonie",
      "Lungenproteinosesyndrom",
      "Microlithiasis alveolaris pulmonum",
      "Microlithiasis alveolaris pulmonum ohne Angabe einer akuten Exazerbation",
      "Parietoalveolare Pneumopathie",
      "Parietoalveolare Störung a.n.k.",
      "Pulmonale alveoläre Mikrolithiasis",
      "Schwere früh-beginnende pulmonale Alveolarproteinose durch MARS-Mangel",
      "Sekundäre pulmonale Alveolarproteinose"
    ]
  },
  {
    "code": "J84.01",
    "name": "Alveolarproteinose mit akuter Exazerbation",
    "synonyms": [
      "Alveolarproteinose mit akuter Exazerbation",
      "Bronchiolitis obliterans mit organisierender Pneumonie [BOOP] mit akuter Exazerbation",
      "COP [Cryptogenic organising pneumonia] mit akuter Exazerbation",
      "Kryptogene organisierende Pneumonie mit akuter Exazerbation",
      "Microlithiasis alveolaris pulmonum mit akuter Exazerbation"
    ]
  },
  {
    "code": "J84.10",
    "name": "Interstitielle idiopathische Lungenfibrose",
    "synonyms": [
      "AIP [Akute interstitielle Pneumonie]",
      "Akute interstitielle Pneumonie",
      "Akute interstitielle Pneumonie ohne Angabe einer akuten Exazerbation",
      "Alveolitis mit Fibrose",
      "Alveolokapilläre Blockade",
      "Atrophische Lungenfibrose",
      "CFA [Kryptogene fibrosierende Alveolitis]",
      "Chronische Bronchopneumonie",
      "Chronische Lobärpneumonie",
      "Chronische Lungenfibrose",
      "Chronische Lungenzirrhose",
      "Chronische fibroide Lungenverhärtung",
      "Chronische fibroide Pneumonie",
      "Chronische fibröse Lungeninduration",
      "Chronische fibröse Lungenkrankheit",
      "Chronische fibröse Pneumonie",
      "Chronische zirrhotische Pneumonie",
      "Desquamative interstitielle Pneumonie",
      "Diffuse Lungenfibrose",
      "Diffuse Lungenfibrose ohne Angabe einer akuten Exazerbation",
      "Fibrose der Lungenkapillaren",
      "Fibrosierende Alveolitis",
      "Fibrosierende Alveolitis ohne Angabe einer akuten Exazerbation",
      "Fibrosierende kryptogene Alveolitis",
      "Fibrosis pulmonum",
      "Gewöhnliche interstitielle Pneumonie",
      "Gewöhnliche interstitielle Pneumonie ohne Angabe einer akuten Exazerbation",
      "Hamman-Rich-Syndrom",
      "Hamman-Rich-Syndrom ohne Angabe einer akuten Exazerbation",
      "Idiopathische Lungenfibrose",
      "Idiopathische Lungenfibrose ohne Angabe einer akuten Exazerbation",
      "Idiopathische interstitielle Pneumonie",
      "Indurationspneumonie",
      "Infektiöses Lungengranulom",
      "Interstitielle idiopathische Lungenfibrose",
      "Lungenfibroid",
      "Lungenfibrose",
      "Lungeninduration",
      "Lungennarbe",
      "Lungenschrumpfung",
      "Lungenschwiele",
      "Lungensklerose",
      "Lungenumbau",
      "Lungenzirrhose",
      "Lymphoide interstitielle Pneumonie",
      "NSIP [Nichtspezifische interstitielle Pneumonie]",
      "Nichtspezifische interstitielle Pneumonie",
      "Parenchymatöse Pneumonie",
      "Peribronchialfibrose",
      "Postentzündliche Lungenfibrose",
      "Postinflammatorische Lungenfibrose",
      "Postpneumonische Lungenfibrose",
      "Pulmonale Fibrose",
      "Pulmonale Sklerose",
      "Pulmonale Zirrhose",
      "UIP [Usual interstitial pneumonia]"
    ]
  },
  {
    "code": "J84.11",
    "name": "Akute interstitielle Pneumonie mit akuter Exazerbation",
    "synonyms": [
      "Akute interstitielle Pneumonie mit akuter Exazerbation",
      "Diffuse Lungenfibrose mit akuter Exazerbation",
      "Fibrosierende Alveolitis mit akuter Exazerbation",
      "Gewöhnliche interstitielle Pneumonie mit akuter Exazerbation",
      "Hamman-Rich-Syndrom mit akuter Exazerbation",
      "Idiopathische Lungenfibrose mit akuter Exazerbation"
    ]
  },
  {
    "code": "J84.80",
    "name": "Cholesterinpneumonie",
    "synonyms": [
      "Cholesterinpneumonie",
      "Cholesterinpneumonie ohne Angabe einer akuten Exazerbation",
      "Cholesterinpneumonitis",
      "Endogene Lipidbronchopneumonie",
      "Endogene Lipidpneumonie",
      "Interstitielle Lungenerkrankung durch ABCA3-Mangel",
      "Interstitielle Lungenerkrankung durch Surfactant-Protein-C-Mangel",
      "NEHI [Neuroendokrine Zellhyperplasie der Kindheit]",
      "Neuroendokrine Zellhyperplasie der Kindheit",
      "Neuroendokrine Zellhyperplasie der Kindheit ohne Angabe einer akuten Exazerbation",
      "Noduläre lymphoide Hyperplasie der Lunge"
    ]
  },
  {
    "code": "J84.81",
    "name": "Cholesterinpneumonie mit akuter Exazerbation",
    "synonyms": [
      "Cholesterinpneumonie mit akuter Exazerbation",
      "Neuroendokrine Zellhyperplasie der Kindheit mit akuter Exazerbation"
    ]
  },
  {
    "code": "J84.90",
    "name": "Lungengerüsterkrankung",
    "synonyms": [
      "Interstitielle Bronchopneumonie",
      "Interstitielle Lungenentzündung",
      "Interstitielle Lungenkrankheit",
      "Interstitielle Lungenkrankheit ohne Angabe einer akuten Exazerbation",
      "Interstitielle Pneumonie",
      "Interstitielle Pneumonie ohne Angabe einer akuten Exazerbation",
      "Lungenalveolenkrankheit",
      "Lungengerüsterkrankung",
      "Pneumonose"
    ]
  },
  {
    "code": "J84.91",
    "name": "Interstitielle Lungenkrankheit mit akuter Exazerbation",
    "synonyms": [
      "Interstitielle Lungenkrankheit mit akuter Exazerbation",
      "Interstitielle Pneumonie mit akuter Exazerbation"
    ]
  },
  {
    "code": "J85.0",
    "name": "Lungennekrose",
    "synonyms": [
      "Gangraena pulmonis",
      "Gangränöse Pneumonie",
      "Lungenbrand",
      "Lungengangrän",
      "Lungennekrose",
      "Lungenparenchymnekrose",
      "Nekrotische Pneumonie",
      "Pulmonale Gangrän",
      "Pulmonale Nekrose"
    ]
  },
  {
    "code": "J85.1",
    "name": "Lungenabszess mit Pneumonie",
    "synonyms": [
      "Abszedierende Pneumonie",
      "Lungenabszess mit Pneumonie"
    ]
  },
  {
    "code": "J85.2",
    "name": "Lungenabszess",
    "synonyms": [
      "Abscessus pulmonum",
      "Lungenabszess",
      "Putrider Miliarabszess der Lunge"
    ]
  },
  {
    "code": "J85.3",
    "name": "Mediastinalabszess",
    "synonyms": [
      "Mediastinalabszess",
      "Mittelfellabszess"
    ]
  },
  {
    "code": "J86.00",
    "name": "Lungenfistel",
    "synonyms": [
      "Bronchopulmonale Fistel",
      "Lungenfistel",
      "Pulmonale Fistel",
      "Pulmopleurale Fistel",
      "Pyothorax mit Fistel des Lungenparenchyms"
    ]
  },
  {
    "code": "J86.01",
    "name": "Bronchus-Pleura-Fistel",
    "synonyms": [
      "Bronchialfistel",
      "Bronchopleurale Fistel",
      "Bronchus-Pleura-Fistel",
      "Bronchusfistel",
      "Fistula bronchialis",
      "Pyothorax mit Fistel der Trachea",
      "Pyothorax mit Fistel des Bronchus",
      "Tracheopleurale Fistel"
    ]
  },
  {
    "code": "J86.02",
    "name": "Thoraxwandfistel",
    "synonyms": [
      "Bronchokutane Fistel",
      "Brustwandfistel",
      "Empyema necessitatis",
      "Fistel der Rippengegend",
      "Pleurokutane Fistel",
      "Pyothorax mit Fistel der Thoraxwand",
      "Thoraxwandfistel"
    ]
  },
  {
    "code": "J86.03",
    "name": "Ösophagotracheale Fistel",
    "synonyms": [
      "Pyothorax mit ösophagotrachealer Fistel",
      "Tracheoösophageale Fistel",
      "Ösophagotracheale Fistel"
    ]
  },
  {
    "code": "J86.04",
    "name": "Pyothorax mit ösophagopleuraler Fistel",
    "synonyms": [
      "Pyothorax mit ösophagopleuraler Fistel",
      "Ösophagopleurale Fistel"
    ]
  },
  {
    "code": "J86.05",
    "name": "Ösophagobronchialfistel",
    "synonyms": [
      "Bronchoösophageale Fistel",
      "Ösophagobronchiale Fistel",
      "Ösophagobronchialfistel",
      "Ösophagopleurokutane Fistel",
      "Ösophagopulmonale Fistel"
    ]
  },
  {
    "code": "J86.08",
    "name": "Abdominothorakale Fistel",
    "synonyms": [
      "Abdominothorakale Fistel",
      "Bronchointestinale Fistel",
      "Bronchomediastinale Fistel",
      "Bronchopleuromediastinale Fistel",
      "Bronchoviszerale Fistel",
      "Brustfellabszess mit Fistel",
      "Hepatopleurale Fistel",
      "Hepatopulmonale Fistel",
      "Mediastinale Fistel",
      "Mediastinobronchiale Fistel",
      "Mediastinokutane Fistel",
      "Pleuroperitoneale Fistel",
      "Pulmoperitoneale Fistel",
      "Rippenfellabszess mit Fistel",
      "Thorakoabdominale Fistel",
      "Thorakogastrische Fistel",
      "Thorakointestinale Fistel"
    ]
  },
  {
    "code": "J86.09",
    "name": "Pyothorax mit Fistel",
    "synonyms": [
      "Eitrige Pleuritis mit Fistel",
      "Fibrinopurulente Pleuritis mit Fistel",
      "Fibropurulente Pleuritis mit Fistel",
      "Pleuraabszess mit Fistel",
      "Pleuraempyem mit Fistel",
      "Pleurafistel",
      "Pleuritis purulenta mit Fistel",
      "Pyopneumothorax mit Fistel",
      "Pyothorax mit Fistel",
      "Septische Pleuritis mit Fistel",
      "Seropurulente Pleuritis mit Fistel",
      "Thorakale Fistel",
      "Thoraxabszess mit Fistel"
    ]
  },
  {
    "code": "J86.9",
    "name": "Pyothorax ohne Fistel",
    "synonyms": [
      "Brustfellabszess",
      "Brustkorbempyem",
      "Doppelseitiges Empyem",
      "Eitrige Pleuritis",
      "Eitrige Rippenfellentzündung",
      "Empyem",
      "Empyema",
      "Fibrinopurulente Pleuritis",
      "Fibropurulente Pleuritis",
      "Infektiöser Pyopneumothorax",
      "Pleuraabszess",
      "Pleuraempyem",
      "Pleuritis purulenta",
      "Pleuritis putrida",
      "Pneumopyothorax",
      "Pyopneumothorax",
      "Pyothorax",
      "Pyothorax ohne Fistel",
      "Rippenfellabszess",
      "Rippenfellempyem",
      "Septische Pleuritis",
      "Seropurulente Pleuritis",
      "Supradiaphragmales Empyem",
      "Thoraxabszess",
      "Thoraxempyem"
    ]
  },
  {
    "code": "J90",
    "name": "Bakterielle Pleuritis exsudativa",
    "synonyms": [
      "Abgekapselte Flüssigkeit in der Lunge",
      "Abgekapselte Pleuritis",
      "Bakterielle Pleuritis",
      "Bakterielle Pleuritis exsudativa",
      "Bakterielle Pleuritis mit Erguss",
      "Bakterielle seröse Pleuritis",
      "Exsudative Pleuritis",
      "Pleuraerguss",
      "Pleuritis durch Pneumokokken",
      "Pleuritis durch Staphylokokken",
      "Pleuritis durch Streptokokken",
      "Pleuritis exsudativa",
      "Pleuritis mit Erguss",
      "Pleurorrhoe",
      "Serofibrinöse Pleuritis",
      "Seröse Pleuritis"
    ]
  },
  {
    "code": "J92.0",
    "name": "Pleuraplaques mit Nachweis von Asbest",
    "synonyms": [
      "Pleurale Plaques mit Nachweis von Asbest",
      "Pleuraplaques mit Nachweis von Asbest",
      "Pleuraschwarte mit Nachweis von Asbest",
      "Pleuraverdickung mit Nachweis von Asbest"
    ]
  },
  {
    "code": "J92.9",
    "name": "Pleuraplaques ohne Nachweis von Asbest",
    "synonyms": [
      "Pleuraplaques",
      "Pleuraplaques ohne Nachweis von Asbest",
      "Pleuraverdickung"
    ]
  },
  {
    "code": "J93.0",
    "name": "Spontaner Spannungspneumothorax",
    "synonyms": [
      "Spannungspneu",
      "Spannungspneumothorax",
      "Spontaner Spannungspneumothorax",
      "Ventilpneumothorax"
    ]
  },
  {
    "code": "J93.1",
    "name": "Spontanpneumothorax a.n.k.",
    "synonyms": [
      "Familiärer Spontanpneumothorax",
      "Spontanpneumothorax a.n.k."
    ]
  },
  {
    "code": "J93.8",
    "name": "Akuter Pneumothorax",
    "synonyms": [
      "Akuter Pneumothorax",
      "Chronischer Pneumothorax"
    ]
  },
  {
    "code": "J93.9",
    "name": "Pneumothorax",
    "synonyms": [
      "Aerothorax",
      "Gasbrust",
      "Luftansammlung in der Brustfellhöhle",
      "Luftbrust",
      "Mantelpneu",
      "Mantelpneumothorax",
      "Pneumothorax",
      "Seropneumothorax",
      "Thoraxkollaps"
    ]
  },
  {
    "code": "J94.0",
    "name": "Chylöser Erguss",
    "synonyms": [
      "Chylothorax",
      "Chylothorax, nicht durch Filarien",
      "Chylusartiger Erguss",
      "Chylusartiger Pleuraerguss",
      "Chylöser Erguss",
      "Chylöser Hydrothorax, nicht durch Filarien",
      "Chylöser Pleuraerguss",
      "Kongenitaler Chylothorax"
    ]
  },
  {
    "code": "J94.1",
    "name": "Pleurafibrose",
    "synonyms": [
      "Fibrothorax",
      "Pleurafibrose",
      "Pleurahyalinose",
      "Pleurakuppelschwiele",
      "Pleuraschwarte",
      "Pleuraschwiele",
      "Pleuravernarbung",
      "Pleuraverschwartung",
      "Rippenwinkelschwarte"
    ]
  },
  {
    "code": "J94.2",
    "name": "Hämatopneumothorax",
    "synonyms": [
      "Bakterieller Hämothorax",
      "Hydrohämatopneumothorax",
      "Hydropneumohämothorax",
      "Hämatopneumothorax",
      "Hämatothorax",
      "Hämopneumothorax",
      "Hämothorax",
      "Nichttuberkulöser Hämothorax",
      "Pneumohämatothorax"
    ]
  },
  {
    "code": "J94.8",
    "name": "Hydropneumothorax",
    "synonyms": [
      "Brustfelladhäsion",
      "Doppelseitiger Hydrothorax",
      "Flüssigkeit im Thorax",
      "Flüssigkeit in der Pleurahöhle",
      "Hydropneumothorax",
      "Hydrothorax",
      "Panzerpleura",
      "Pleuraadhäsion",
      "Pleurahydrops",
      "Pleurainfiltration",
      "Pleurakalzifikation",
      "Pleurastauung",
      "Pleurastein",
      "Pleurasynechie",
      "Pleuraverkalkung",
      "Pleuraverklebung",
      "Pleuraverwachsung",
      "Pleurazyste",
      "Pleuritis calcarea",
      "Pleuritis calcificata",
      "Pleuroperikardiale Adhäsion",
      "Pneumohydrothorax",
      "Postinfektiöse Pleurakalzifikation",
      "Rippenfelladhäsion",
      "Wasseransammlung im Brustraum"
    ]
  },
  {
    "code": "J94.9",
    "name": "Pleurakrankheit",
    "synonyms": [
      "Pleurahöhlenkrankheit",
      "Pleurakrankheit"
    ]
  },
  {
    "code": "J95.0",
    "name": "Funktionsstörung des Tracheostomas",
    "synonyms": [
      "Atemwegsverschluss nach Tracheotomie",
      "Blutung aus dem Tracheostoma",
      "Dysfunktion des Tracheostomas",
      "Fistel nach Tracheotomie",
      "Funktionsstörung des Tracheostomas",
      "Hämorrhagie aus dem Tracheostoma",
      "Komplikation durch Tracheostoma",
      "Obstruktion der durch Tracheotomie geschaffenen Atemwege",
      "Obstruktion des durch Tracheotomie geschaffenen Luftweges",
      "Sepsis nach Tracheotomie",
      "Stomastriktur nach Tracheotomie",
      "Tracheoösophagealfistel nach Tracheotomie",
      "Ösophagotrachealfistel nach Tracheotomie"
    ]
  },
  {
    "code": "J95.1",
    "name": "Akute pulmonale Insuffizienz nach Thoraxoperation",
    "synonyms": [
      "Akute pulmonale Insuffizienz nach Thoraxoperation",
      "Akute respiratorische Insuffizienz nach Thoraxoperation"
    ]
  },
  {
    "code": "J95.2",
    "name": "Akute pulmonale Insuffizienz nach (nicht am Thorax vorgenommener) Operation",
    "synonyms": [
      "Akute pulmonale Insuffizienz nach (nicht am Thorax vorgenommener) Operation",
      "Akute pulmonale Insuffizienz nach chirurgischem Eingriff",
      "Akute respiratorische Insuffizienz nach (nicht am Thorax vorgenommener) Operation"
    ]
  },
  {
    "code": "J95.3",
    "name": "Chronische pulmonale Insuffizienz nach Operation",
    "synonyms": [
      "Chronische pulmonale Insuffizienz nach Operation",
      "Chronische respiratorische Insuffizienz nach Operation",
      "Postoperative Lungeninsuffizienz"
    ]
  },
  {
    "code": "J95.4",
    "name": "Mendelson-Syndrom",
    "synonyms": [
      "Aspirationspneumonitis durch Anästhesie",
      "Chemische Pneumonitis durch Aspiration bei Anästhesie",
      "Mendelson-Syndrom"
    ]
  },
  {
    "code": "J95.5",
    "name": "Subglottische Stenose nach medizinischen Maßnahmen",
    "synonyms": [
      "Subglottische Stenose nach chirurgischem Eingriff",
      "Subglottische Stenose nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "J95.80",
    "name": "Pneumothorax durch eine operative Verletzung der Brustwand oder Lunge",
    "synonyms": [
      "Iatrogener Pneumothorax",
      "Pneumothorax durch eine operative Verletzung der Brustwand oder Lunge"
    ]
  },
  {
    "code": "J95.81",
    "name": "Tracheastenose nach medizinischen Maßnahmen",
    "synonyms": [
      "Tracheastenose nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "J95.82",
    "name": "Anastomoseninsuffizienz nach Operation an der Trachea",
    "synonyms": [
      "Anastomoseninsuffizienz nach Operation am Bronchus",
      "Anastomoseninsuffizienz nach Operation an der Lunge",
      "Anastomoseninsuffizienz nach Operation an der Trachea",
      "Nahtinsuffizienz nach Operation am Bronchus",
      "Nahtinsuffizienz nach Operation an der Lunge",
      "Nahtinsuffizienz nach Operation an der Trachea"
    ]
  },
  {
    "code": "J95.88",
    "name": "Postnarkotische Ateminsuffizienz",
    "synonyms": [
      "Beatmungsinduzierter Zwerchfellschaden",
      "Lungenversagen nach medizinischen Maßnahmen",
      "Pneumonie bei Beatmungstherapie",
      "Pneumonie nach medizinischen Maßnahmen",
      "Postnarkotische Ateminsuffizienz",
      "Postoperative Pneumonitis",
      "Postoperative respiratorische Insuffizienz",
      "Ventilator-induzierter Zwerchfellschaden"
    ]
  },
  {
    "code": "J95.9",
    "name": "Postoperative respiratorische Komplikation",
    "synonyms": [
      "Postoperative respiratorische Komplikation",
      "Respiratorische Komplikation nach chirurgischem Eingriff"
    ]
  },
  {
    "code": "J96.00",
    "name": "Akute respiratorische Insuffizienz, Typ I",
    "synonyms": [
      "Akute hypoxämische respiratorische Insuffizienz",
      "Akute respiratorische Insuffizienz, Typ I",
      "Akute respiratorische Partialinsuffizienz"
    ]
  },
  {
    "code": "J96.01",
    "name": "Akute respiratorische Insuffizienz, Typ II",
    "synonyms": [
      "Akute hyperkapnische respiratorische Insuffizienz",
      "Akute respiratorische Globalinsuffizienz",
      "Akute respiratorische Insuffizienz mit Hyperkapnie und Hypoxämie",
      "Akute respiratorische Insuffizienz, Typ II"
    ]
  },
  {
    "code": "J96.09",
    "name": "Akute respiratorische Dyspnoe",
    "synonyms": [
      "Akute Ateminsuffizienz",
      "Akute respiratorische Dyspnoe",
      "Akute respiratorische Insuffizienz",
      "Akutes Lungenversagen"
    ]
  },
  {
    "code": "J96.10",
    "name": "Chronische respiratorische Insuffizienz, Typ I",
    "synonyms": [
      "Chronische hypoxämische respiratorische Insuffizienz",
      "Chronische respiratorische Insuffizienz, Typ I",
      "Chronische respiratorische Partialinsuffizienz"
    ]
  },
  {
    "code": "J96.11",
    "name": "Chronische respiratorische Insuffizienz, Typ II",
    "synonyms": [
      "Chronische hyperkapnische respiratorische Insuffizienz",
      "Chronische respiratorische Globalinsuffizienz",
      "Chronische respiratorische Insuffizienz mit Hyperkapnie und Hypoxämie",
      "Chronische respiratorische Insuffizienz, Typ II"
    ]
  },
  {
    "code": "J96.19",
    "name": "Chronische Ateminsuffizienz",
    "synonyms": [
      "Chronische Ateminsuffizienz",
      "Chronische respiratorische Insuffizienz",
      "Chronisches Lungenversagen"
    ]
  },
  {
    "code": "J96.90",
    "name": "Respiratorische Partialinsuffizienz",
    "synonyms": [
      "Hypoxämische respiratorische Insuffizienz",
      "Respiratorische Insuffizienz, Typ I",
      "Respiratorische Partialinsuffizienz"
    ]
  },
  {
    "code": "J96.91",
    "name": "Respiratorische Globalinsuffizienz",
    "synonyms": [
      "Hyperkapnische respiratorische Insuffizienz",
      "Respiratorische Globalinsuffizienz",
      "Respiratorische Insuffizienz mit Hyperkapnie und Hypoxämie",
      "Respiratorische Insuffizienz, Typ II"
    ]
  },
  {
    "code": "J96.99",
    "name": "Respiratorische Insuffizienz",
    "synonyms": [
      "Ateminsuffizienz - s.a. respiratorische Insuffizienz",
      "Lungenversagen",
      "Pulmonales Versagen",
      "Respiratorische Dyspnoe",
      "Respiratorische Insuffizienz"
    ]
  },
  {
    "code": "J98.0",
    "name": "Bronchiengeschwür",
    "synonyms": [
      "Bronchialobstruktion",
      "Bronchialschleimhautpolyp",
      "Bronchialstein",
      "Bronchialstenose",
      "Bronchienabszess",
      "Bronchiengeschwür",
      "Bronchienkompression",
      "Bronchienkonstriktion",
      "Bronchienkrankheit a.n.k.",
      "Bronchienstase",
      "Bronchienstauung",
      "Bronchienverkalkung",
      "Bronchiolithiasis",
      "Broncholithiasis",
      "Bronchomalazie",
      "Bronchorrhoe",
      "Bronchospasmus",
      "Bronchostenose",
      "Bronchuseinriss",
      "Bronchuserosion",
      "Bronchuskalzifikation",
      "Bronchuskontraktur",
      "Bronchusnekrose",
      "Bronchusossifikation",
      "Bronchusparalyse",
      "Bronchusperforation",
      "Bronchusperichondritis",
      "Bronchuspolyp",
      "Bronchusruptur",
      "Bronchusstenose",
      "Bronchusstriktur",
      "Bronchusulkus",
      "Erworbene Bronchusdeformität a.n.k.",
      "Erworbene Bronchusdivertikulitis",
      "Erworbene Bronchusdivertikulose",
      "Erworbenes Bronchusdivertikel",
      "Hauptbronchusverschluss",
      "Säbelscheidentrachea",
      "Tracheobronchiale Dyskinesie",
      "Tracheobronchialer Kollaps",
      "Tracheobronchiales Kollaps-Syndrom",
      "Tracheobronchopathia osteochondroplastica"
    ]
  },
  {
    "code": "J98.10",
    "name": "Dystelektase",
    "synonyms": [
      "Dystelektase"
    ]
  },
  {
    "code": "J98.11",
    "name": "Unterlappenatelektase",
    "synonyms": [
      "Brock-Graham-Syndrom",
      "Brock-Syndrom",
      "Graham-Burford-Mayer-Syndrom",
      "Mittellappenatelektase",
      "Mittellappensyndrom",
      "Partielle Atelektase",
      "Unterlappenatelektase"
    ]
  },
  {
    "code": "J98.12",
    "name": "Totalatelektase",
    "synonyms": [
      "Lungenflügelatelektase",
      "Totalatelektase"
    ]
  },
  {
    "code": "J98.18",
    "name": "Lungenatelektase",
    "synonyms": [
      "Atelektase",
      "Erworbene Kompressionsatelektase",
      "Gerichtete Atelektase",
      "Kompressionsapneumatose",
      "Kompressionsatelektase",
      "Lungenatelektase",
      "Lungenkollaps",
      "Massive Atelektase",
      "Plattenatelektase",
      "Pulmonaler Kollaps",
      "Resorptionsatelektase",
      "Streifenatelektase",
      "Verdrängungsatelektase"
    ]
  },
  {
    "code": "J98.2",
    "name": "Interstitielles Emphysem",
    "synonyms": [
      "Interstitielles Emphysem",
      "Mediastinalemphysem",
      "Pneumomediastinum"
    ]
  },
  {
    "code": "J98.3",
    "name": "Kompensatorisches Emphysem",
    "synonyms": [
      "Kompensatorisches Emphysem"
    ]
  },
  {
    "code": "J98.4",
    "name": "Pulmolithiasis",
    "synonyms": [
      "Beerenlunge",
      "Bronchialzyste",
      "Bronchogene Zyste",
      "Bronchopulmonale Krankheit",
      "Chronische Pneumonie",
      "Chronische Pneumopathie",
      "Erworbene Lungendeformität",
      "Erworbene Lungenzyste",
      "Erworbene zystische Lungenkrankheit",
      "Knotige Lungenverdichtung",
      "Lungenadhäsion",
      "Lungendegeneration",
      "Lungeninsuffizienz",
      "Lungenkalzifikation",
      "Lungenkompression",
      "Lungenkrankheit",
      "Lungenleiden",
      "Lungenretraktion",
      "Lungenschädigung",
      "Lungenstein",
      "Lungenulkus",
      "Lungenverkalkung",
      "Lungenverschluss",
      "Nichttuberkulöse Lungenkaverne",
      "Pneumatozele",
      "Pneumolith",
      "Pneumolithiasis",
      "Pneumopathie a.n.k.",
      "Polyzystische Lunge",
      "Polyzystische Lungenkrankheit",
      "Postinfektiöse Lungenkalzifikation",
      "Pseudozyste der Lunge",
      "Pulmolithiasis",
      "Pulmonale Adhäsion",
      "Pulmonale Insuffizienz",
      "Sacklunge",
      "Schwammlunge",
      "Solitärknoten der Lunge",
      "Subkutane Lungenhernie",
      "Wabenlunge",
      "Zystenlunge",
      "Zystische Lungenkrankheit"
    ]
  },
  {
    "code": "J98.50",
    "name": "Mediastinitis",
    "synonyms": [
      "Akute Mediastinitis",
      "Chronische Mediastinitis",
      "IgG4-assoziierte Mediastinitis",
      "Mediastinitis",
      "Mediastinumentzündung",
      "Mediastinuminfektion",
      "Mittelfellentzündung"
    ]
  },
  {
    "code": "J98.58",
    "name": "Mediastinumfibrose",
    "synonyms": [
      "Herniation des Mediastinums",
      "Hernie des Mediastinums",
      "Mediastinalhernie",
      "Mediastinalkrankheit",
      "Mediastinumadhäsion",
      "Mediastinumfibrose",
      "Mediastinumretraktion",
      "Mediastinumschädigung durch Druck"
    ]
  },
  {
    "code": "J98.6",
    "name": "Zwerchfellaffektion",
    "synonyms": [
      "Diaphragmarelaxation",
      "Diaphragmatitis",
      "Diaphragmitis",
      "Erworbene Diaphragmadeformität",
      "Erworbene Zwerchfelldeformität",
      "Relaxatio diaphragmatica",
      "Schlaffe Diaphragmaparalyse",
      "Zwerchfellaffektion",
      "Zwerchfellentzündung",
      "Zwerchfellerschlaffung",
      "Zwerchfellkrankheit",
      "Zwerchfelllähmung",
      "Zwerchfellossifikation",
      "Zwerchfellparalyse"
    ]
  },
  {
    "code": "J98.7",
    "name": "Luftwegsinfektion",
    "synonyms": [
      "Atemwegsentzündung",
      "Atemwegsinfektion",
      "Infekt der Atemwege",
      "Infekt der Luftwege",
      "Infektion der Atmungsorgane a.n.k.",
      "Infektion des Respirationstraktes a.n.k.",
      "Luftwegsinfektion",
      "Respiratorische Infektion"
    ]
  },
  {
    "code": "J98.8",
    "name": "Atemwegsobstruktion",
    "synonyms": [
      "Atemwegsallergie",
      "Atemwegsinsuffizienz",
      "Atemwegsobstruktion",
      "Atemwegsstenose",
      "Atemwegsverschluss",
      "Bronchopulmonale Dekompensation",
      "Chronische Atemwegsinfektion",
      "Chronische Infektion der Atmungsorgane",
      "Dekompensation der Atmungsorgane",
      "Obstruktion der Atmungsorgane",
      "Obstruktion der Luftwege",
      "Respiratorische Dekompensation",
      "Rezidivierender Infekt der Atemwege"
    ]
  },
  {
    "code": "J98.9",
    "name": "Atemwegskrankheit",
    "synonyms": [
      "Atemwegskrankheit",
      "Chronische Atemwegskrankheit",
      "Krankheit der Atmungsorgane",
      "Respiratorische Affektion a.n.k.",
      "Respiratorische Komplikation",
      "Störung der Atmungsorgane"
    ]
  },
  {
    "code": "K00.0",
    "name": "Oligodontie",
    "synonyms": [
      "Angeborenes Fehlen der Zähne",
      "Anodontia",
      "Anodontia vera",
      "Anodontie",
      "Hypodontie",
      "Oligodontie",
      "Oligodontie mit Prädisposition für bösartige Neubildung",
      "Partielle Anodontie",
      "Selektive Zahn-Agenesie",
      "Teilweise Anodontie",
      "Teilweise Zahnlosigkeit",
      "Vollständige Anodontie",
      "Vollständige Zahnlosigkeit",
      "Zahnlosigkeit"
    ]
  },
  {
    "code": "K00.1",
    "name": "Distomolar [4. Molar]",
    "synonyms": [
      "Akzessorischer Zahn",
      "Distomolar [4. Molar]",
      "Hyperodontie",
      "Mesiodens",
      "Paramolar",
      "Vierter Molar",
      "Zusätzlicher Zahn",
      "Überzähliger Zahn"
    ]
  },
  {
    "code": "K00.2",
    "name": "Makrodontie",
    "synonyms": [
      "Abnorme Zahnform",
      "Abnorme Zahngröße",
      "Abnormität der Zahnform",
      "Abnormität der Zahngröße",
      "Akzessorische Zahnwurzel",
      "Dens evaginatus",
      "Dens in dente",
      "Dens invaginatus",
      "Dentes emboliformes",
      "Dentes geminati",
      "Dichotomie des Zahns",
      "Formabweichung eines Zahns",
      "Gemination des Zahns",
      "Größenabweichung eines Zahns",
      "Makrodontie",
      "Mikrodontie",
      "Molarisation der Prämolaren",
      "Prämolarisation",
      "Schaufelförmig verformter Schneidezahn",
      "Schizodontie",
      "Schmelzperlen",
      "Synodontie",
      "T-förmiger Schneidezahn",
      "Taurodontismus",
      "Tuberculum paramolare",
      "Verlängerter Zahn",
      "Verschmelzung der Schneidezähne im Unterkiefer",
      "Verschmelzung von Zähnen",
      "Zahndeformität",
      "Zahnfusion",
      "Zahnhöcker",
      "Zahnverwachsung",
      "Zapfenzahn",
      "Zwillingsbildung des Zahns",
      "Überzählige Zahnwurzel"
    ]
  },
  {
    "code": "K00.3",
    "name": "Zahnfluorose",
    "synonyms": [
      "Chronische Dentalfluorose",
      "Dentale Fluorose",
      "Gefleckter Zahnschmelz",
      "Mottled teeth",
      "Opazität des Zahnschmelzes",
      "Opazität des Zahnschmelzes durch Fluor",
      "Opazität des Zahnschmelzes, nicht durch Fluor",
      "Schmelzflecken",
      "Zahnfluorose",
      "Zahnschmelzdystrophie",
      "Zahnschmelzflecken"
    ]
  },
  {
    "code": "K00.4",
    "name": "Zahnbildungsstörung",
    "synonyms": [
      "Amelogenesis imperfecta nonhereditaria segmentalis",
      "Generalisierte Odontodysplasie",
      "Kalzifikation der Papilla dentalis",
      "Lokale Odontodysplasie",
      "Molaren-Inzisiven-Hypomineralisation [MIH]",
      "Neonatale Zahnschmelzhypoplasie",
      "Odonto-maxilläre segmentale Dysplasie",
      "Postnatale Zahnschmelzhypoplasie",
      "Pränatale Zahnschmelzhypoplasie",
      "Regionale Odontodysplasie",
      "Turner-Hypoplasie der Zähne",
      "Turner-Zahn",
      "Zahnbildungsstörung",
      "Zahndilazeration",
      "Zahnschmelzhypoplasie",
      "Zahnzementaplasie",
      "Zahnzementhypoplasie"
    ]
  },
  {
    "code": "K00.5",
    "name": "Hereditäre Zahnstrukturstörung a.n.k.",
    "synonyms": [
      "Amelogenesis",
      "Amelogenesis imperfecta",
      "DI [Dentinogenesis imperfecta]",
      "Dentindysplasie",
      "Dentindysplasie Typ 1",
      "Dentindysplasie Typ 2",
      "Dentindysplasie mit Knochensklerose",
      "Dentinogenesis imperfecta",
      "Dentinogenesis imperfecta Typ 2",
      "Dentinogenesis imperfecta Typ 3",
      "Dentinogenesis-imperfecta-II-Syndrom",
      "Hereditäre Zahnstrukturstörung a.n.k.",
      "Hypokalzifikationstyp der Amelogenesis imperfecta",
      "Hypomaturationstyp der Amelogenesis imperfecta",
      "Hypoplastischer Typ der Amelogenesis imperfecta",
      "Odontogenesis hypoplastica",
      "Odontogenesis imperfecta sive hypoplastica",
      "Opaleszierende Zähne ohne Osteogenesis imperfecta",
      "Syndrom der Amelogenesis imperfecta mit Zahnfleischhyperplasie",
      "Wurzellose Zähne"
    ]
  },
  {
    "code": "K00.6",
    "name": "Zahndurchbruchstörung",
    "synonyms": [
      "Abnormer Zahndurchbruch",
      "Dens neonatalis",
      "Dentes natales",
      "Dentitio praecox",
      "Dentitio tarda",
      "Dentitionsstörung",
      "Neonatale Zähne",
      "Persistenz der Dentes decidui",
      "Persistierende Milchzähne",
      "Primäre Zahndurchbruchstörung",
      "Retention der Milchzähne",
      "Verzögerte Dentition",
      "Vorzeitiger Milchzahnausfall",
      "Vorzeitiger Zahndurchbruch",
      "Vorzeitiger Zahnwechsel",
      "Zahndurchbruchanomalie",
      "Zahndurchbruchstörung"
    ]
  },
  {
    "code": "K00.7",
    "name": "Erschwerter Zahndurchbruch",
    "synonyms": [
      "Dentitio difficile",
      "Dentitionsbeschwerden",
      "Dentitionskrankheit",
      "Dentitionsschmerzen",
      "Dentitionssyndrom",
      "Erschwerte Dentition",
      "Erschwerter Zahndurchbruch",
      "Erschwertes Zahnen",
      "Störung beim Zahnen",
      "Zahnfieber",
      "Zahnungsbeschwerden"
    ]
  },
  {
    "code": "K00.8",
    "name": "Intrinsische Verfärbung der Zähne a.n.k.",
    "synonyms": [
      "Farbveränderung während der Zahnbildung",
      "Intrinsische Verfärbung der Zähne a.n.k."
    ]
  },
  {
    "code": "K00.9",
    "name": "Zahnentwicklungsstörung",
    "synonyms": [
      "Odontogenesestörung a.n.k.",
      "Zahnanomalie",
      "Zahnentwicklungsstörung"
    ]
  },
  {
    "code": "K01.0",
    "name": "Retinierter Zahn",
    "synonyms": [
      "Retinierter Zahn",
      "Teilweise retinierter Zahn",
      "Verlagerte Zahnkeime",
      "Vollständig retinierter Zahn",
      "Zahnretention"
    ]
  },
  {
    "code": "K01.1",
    "name": "Impaktierter Zahn",
    "synonyms": [
      "Einklemmung eines Zahns",
      "Impaktierter Zahn"
    ]
  },
  {
    "code": "K02.0",
    "name": "Karies, auf den Zahnschmelz begrenzt",
    "synonyms": [
      "Initiale Karies",
      "Karies, auf den Zahnschmelz begrenzt",
      "Opake Flecken [Initiale Karies]",
      "Opake Zahnflecken",
      "Weiße Flecken, Zahnschädigung",
      "Zahnschmelzkaries"
    ]
  },
  {
    "code": "K02.1",
    "name": "Dentinkaries",
    "synonyms": [
      "Dentinkaries"
    ]
  },
  {
    "code": "K02.2",
    "name": "Zementkaries",
    "synonyms": [
      "Zementkaries"
    ]
  },
  {
    "code": "K02.3",
    "name": "Kariesmarke",
    "synonyms": [
      "Inaktive Zahnkaries",
      "Kariesmarke"
    ]
  },
  {
    "code": "K02.4",
    "name": "Odontoklasie",
    "synonyms": [
      "Infantile Melanodontie",
      "Melanodontie",
      "Melanodontoklasie",
      "Odontoklasie"
    ]
  },
  {
    "code": "K02.5",
    "name": "Karies mit freiliegender Pulpa",
    "synonyms": [
      "Karies mit freiliegender Pulpa"
    ]
  },
  {
    "code": "K02.9",
    "name": "Zahnkaries",
    "synonyms": [
      "Caries - s.a. Karies",
      "Caries dentum",
      "Dentale Karies",
      "Dentaler Verfall",
      "Kariöse Läsion",
      "Kariöse Zähne",
      "Zahnfraß",
      "Zahnfäule",
      "Zahnkaries",
      "Zahnverfall"
    ]
  },
  {
    "code": "K03.0",
    "name": "Ausgeprägte Attrition der Zähne",
    "synonyms": [
      "Approximale Zahnabnutzung",
      "Attrition der Zahnhartsubstanz",
      "Attrition der Zähne",
      "Ausgeprägte Attrition der Zähne",
      "Okklusale Zahnabnutzung",
      "Übermäßige Abnutzung der Zähne"
    ]
  },
  {
    "code": "K03.1",
    "name": "Abrasio dentium",
    "synonyms": [
      "Abrasio dentium",
      "Berufsbedingte Zahnabrasion",
      "Habituelle Zahnabrasion",
      "Keilförmiger Zahndefekt",
      "Rituelle Zahnabrasion",
      "Traditionelle Zahnabrasion",
      "Zahnabrasion",
      "Zahnabrasion durch Zahnputzmittel",
      "Zahnabschleifung"
    ]
  },
  {
    "code": "K03.2",
    "name": "Zahnerosion",
    "synonyms": [
      "Berufsbedingte Zahnerosion",
      "Idiopathische Zahnerosion",
      "Zahnerosion",
      "Zahnerosion durch Arzneimittel",
      "Zahnerosion durch Drogen",
      "Zahnerosion durch Nahrungsmittel",
      "Zahnerosion durch unstillbares Erbrechen",
      "Zahnzerfall"
    ]
  },
  {
    "code": "K03.3",
    "name": "Pathologische Zahnresorption",
    "synonyms": [
      "Dentale Resorption",
      "Externe Zahnresorption",
      "Internes Granulom der Pulpa",
      "Pathologische Zahnresorption",
      "Pink Spot Disease",
      "Rosa-Flecken-Krankheit",
      "Zahnresorption"
    ]
  },
  {
    "code": "K03.4",
    "name": "Hyperzementose der Zähne",
    "synonyms": [
      "Hyperplasia cementi",
      "Hyperplasie des Zahnzements",
      "Hyperzementose der Zähne",
      "Zementose"
    ]
  },
  {
    "code": "K03.5",
    "name": "Ankylose der Zähne",
    "synonyms": [
      "Ankylose der Zähne",
      "Dentale Ankylose"
    ]
  },
  {
    "code": "K03.6",
    "name": "Zahnauflagerung",
    "synonyms": [
      "Betel-Zahnauflagerung",
      "Betel-Zahnbelag",
      "Extrinsische Zahnverfärbung",
      "Grüne Zahnauflagerung",
      "Grüner Zahnbelag",
      "Orangefarbene Zahnauflagerung",
      "Orangefarbener Zahnbelag",
      "Schwarze Zahnauflagerung",
      "Schwarzer Zahnbelag",
      "Subgingivaler Zahnstein",
      "Supragingivaler Zahnstein",
      "Zahnablagerung",
      "Zahnauflagerung",
      "Zahnauflagerung aus Materia alba",
      "Zahnauflagerung durch Tabak",
      "Zahnbelag",
      "Zahnbelag aus Materia alba",
      "Zahnbelag durch Tabak",
      "Zahnstein",
      "Zahnverfärbung durch Belag"
    ]
  },
  {
    "code": "K03.7",
    "name": "Zahnfarbänderung der Hartsubstanz",
    "synonyms": [
      "Posteruptive Farbänderung der Zähne",
      "Veränderung der Zahnfarbe nach der Dentition",
      "Zahnfarbänderung der Hartsubstanz",
      "Zahnverfärbung",
      "Zahnverfärbung durch Kupfer",
      "Zahnverfärbung durch Metalle",
      "Zahnverfärbung durch Pulpablutung",
      "Zahnverfärbung durch Silber"
    ]
  },
  {
    "code": "K03.8",
    "name": "Strahlenkaries",
    "synonyms": [
      "Dekalzifikation der Zähne",
      "Empfindliches Dentin",
      "Strahlengeschädigter Zahnschmelz",
      "Strahlenkaries",
      "Zahnschmelzschädigung durch künstliche Strahlen"
    ]
  },
  {
    "code": "K03.9",
    "name": "Krankheit der Zahnhartsubstanz",
    "synonyms": [
      "Krankheit der Zahnhartsubstanz"
    ]
  },
  {
    "code": "K04.0",
    "name": "Pulpitis",
    "synonyms": [
      "Akute Pulpitis",
      "Chronische Pulpitis",
      "Dentaler Polyp",
      "Eitrige Pulpitis",
      "Hyperplastische Pulpitis",
      "Irreversible Pulpitis",
      "Odontitis",
      "Pulpaabszess",
      "Pulpapolyp",
      "Pulpitis",
      "Reversible Pulpitis",
      "Ulzeröse Pulpitis",
      "Vereiterte Pulpa",
      "Zahnmarkentzündung",
      "Zahnwurzelentzündung"
    ]
  },
  {
    "code": "K04.1",
    "name": "Pulpanekrose",
    "synonyms": [
      "Pulpagangrän",
      "Pulpanekrose"
    ]
  },
  {
    "code": "K04.2",
    "name": "Pulpadegeneration",
    "synonyms": [
      "Denticulus",
      "Dentikel",
      "Kalzifikation der Pulpa dentium",
      "Kalzifikation der Zahnpulpa",
      "Pulpadegeneration",
      "Pulpahyalinose",
      "Pulpakalzifikation",
      "Pulpastein",
      "Pulpaverkalkung",
      "Zahnbeinkugel [Dentikel]"
    ]
  },
  {
    "code": "K04.3",
    "name": "Irreguläre Hartsubstanzbildung der Pulpa",
    "synonyms": [
      "Abnorme Zahnhartsubstanzbildung der Pulpa",
      "Irreguläre Hartsubstanzbildung der Pulpa",
      "Irreguläres Dentin",
      "Sekundäres Dentin"
    ]
  },
  {
    "code": "K04.4",
    "name": "Akute apikale Periodontitis",
    "synonyms": [
      "Akute Wurzelspitzenhautentzündung",
      "Akute apikale Parodontitis",
      "Akute apikale Periodontitis"
    ]
  },
  {
    "code": "K04.5",
    "name": "Chronische apikale Parodontitis",
    "synonyms": [
      "Apikale Parodontitis",
      "Apikale Periodontitis",
      "Apikales Granulom",
      "Chronische apikale Parodontitis",
      "Chronisches Zahngranulom",
      "Dentales Granulom",
      "Periapikale Infektion",
      "Periapikales Granulom",
      "Wurzelspitzenhautentzündung",
      "Zahngranulom"
    ]
  },
  {
    "code": "K04.6",
    "name": "Periapikaler Abszess mit Fistel",
    "synonyms": [
      "Dentaler Abszess mit Fistel",
      "Dentoalveolärer Abszess mit Fistel",
      "Parulis mit Fistel",
      "Periapikaler Abszess mit Fistel",
      "Periapikaler Abszess mit alveolärem Fistelgang",
      "Zahnabszess mit Fistelgang",
      "Zahnfistel",
      "Zahngeschwür mit Fistel"
    ]
  },
  {
    "code": "K04.7",
    "name": "Periapikaler Abszess ohne Fistel",
    "synonyms": [
      "Abszess der Fossa canina",
      "Alveolarfortsatzinfektion",
      "Apikaler Abszess",
      "Apikaler Zahnfachabszess",
      "Dentaler Abszess",
      "Dentoalveolärer Abszess",
      "Dentogener Abszess",
      "Fokale Zahninfektion",
      "Parulis",
      "Periapikaler Abszess",
      "Periapikaler Abszess ohne Fistel",
      "Zahn auf Eiter",
      "Zahnabszess",
      "Zahngeschwür",
      "Zahninfektion",
      "Zahnwurzelvereiterung"
    ]
  },
  {
    "code": "K04.8",
    "name": "Radikuläre Zahnzyste",
    "synonyms": [
      "Apikale Zyste",
      "Dentogene Zyste",
      "Parodontale Zyste",
      "Periapikale Zyste",
      "Periodontale Zyste",
      "Radikuläre Zahnzyste",
      "Radikuläre Zyste des Oberkiefers",
      "Residuale Zahnzyste",
      "Residuale radikuläre Zyste",
      "Zahnwurzelzyste",
      "Zahnwurzelzyste im Oberkiefer",
      "Zahnwurzelzyste im Unterkiefer"
    ]
  },
  {
    "code": "K04.9",
    "name": "Periapikale Gewebekrankheit",
    "synonyms": [
      "Dentale Infektion",
      "Devitalisierter Zahn",
      "Fokaltoxikose der Zähne",
      "Nervloser Zahn",
      "Periapikale Gewebekrankheit",
      "Pulpablutung",
      "Pulpahyperplasie",
      "Pulpakrankheit a.n.k.",
      "Pulpasiderose",
      "Zahnfokus",
      "Zahnpulpakrankheit a.n.k."
    ]
  },
  {
    "code": "K05.0",
    "name": "Akute Gingivitis",
    "synonyms": [
      "Akute Gingivitis",
      "Akute Zahnfleischentzündung"
    ]
  },
  {
    "code": "K05.1",
    "name": "Chronische Gingivitis",
    "synonyms": [
      "Chronische Gingivitis",
      "Chronische Zahnfleischentzündung",
      "Gingivainfektion",
      "Gingivitis",
      "Gingivitis chronica",
      "Gingivitis desquamativa",
      "Gingivitis desquamativa chronica",
      "Gingivitis hyperplastica",
      "Gingivitis hyperplastica chronica",
      "Gingivitis marginalis",
      "Gingivitis simplex",
      "Gingivitis simplex marginalis",
      "Gingivitis simplex marginalis chronica",
      "Gingivitis ulcerosa",
      "Gingivitis ulcerosa chronica",
      "Gingivostomatitis",
      "Hyperplastische Gingivitis",
      "Lineares Gingivaerythem",
      "Ulzeröse Gingivitis",
      "Verhornungsstörung des Zahnfleisches",
      "Zahnfleischentzündung",
      "Zahnfleischinfektion"
    ]
  },
  {
    "code": "K05.2",
    "name": "Akute Parodontitis",
    "synonyms": [
      "Abszess des Zahnhalteapparates a.n.k.",
      "Akute Parodontitis",
      "Akute Perikoronitis",
      "Akute Periodontitis",
      "Akuter Zahnfleischabszess",
      "Gingivaabszess",
      "Parodontaler Abszess",
      "Peridentale Infektion",
      "Peridontale Infektion",
      "Peridontaler Abszess"
    ]
  },
  {
    "code": "K05.3",
    "name": "Chronische Parodontitis",
    "synonyms": [
      "Alveolarpyorrhoe",
      "Chronische Parodontitis",
      "Chronische Perikoronitis",
      "Chronische Periodontitis",
      "Magitot-Krankheit [Parodontitis]",
      "Parodontale Pyorrhoe",
      "Parodontitis",
      "Parodontitis chronica purulenta",
      "Parodontitis complex",
      "Parodontitis marginalis superficialis",
      "Parodontitis simplex",
      "Parodontitis superficialis",
      "Parodontopathia inflammata superficialis",
      "Peridontitis simplex",
      "Perikoronitis",
      "Periodontitis",
      "Periodontitis complex",
      "Periodontitis simplex",
      "Perizementitis",
      "Pyorrhoea alveolaris"
    ]
  },
  {
    "code": "K05.4",
    "name": "Parodontose",
    "synonyms": [
      "Juvenile Parodontose",
      "Paradentose",
      "Parodontopathia dystrophica",
      "Parodontose",
      "Zahnfleischschwund"
    ]
  },
  {
    "code": "K05.5",
    "name": "Parodontale Schädigung durch traumatische Okklusion",
    "synonyms": [
      "Parodontale Schädigung durch traumatische Okklusion",
      "Traumatischer peridontaler Verschluss"
    ]
  },
  {
    "code": "K05.6",
    "name": "Krankheit des Parodontium",
    "synonyms": [
      "Krankheit des Parodontium",
      "Parodontale Krankheit",
      "Parodontopathie",
      "Peridontale Krankheit"
    ]
  },
  {
    "code": "K06.0",
    "name": "Zahnfleischschrumpfung",
    "synonyms": [
      "Generalisierte Gingivaretraktion",
      "Generalisierte Zahnfleischretraktion",
      "Generalisierte Zahnfleischschrumpfung",
      "Gingivaretraktion",
      "Lokale Zahnfleischschrumpfung",
      "Lokalisierte Gingivaretraktion",
      "Lokalisierte Zahnfleischretraktion",
      "Lokalisierte Zahnfleischschrumpfung",
      "Postinfektiöse Gingivaretraktion",
      "Postinfektiöse Zahnfleischretraktion",
      "Postinfektiöse Zahnfleischschrumpfung",
      "Postoperative Gingivaretraktion",
      "Postoperative Zahnfleischretraktion",
      "Postoperative Zahnfleischschrumpfung",
      "Zahnfleischatrophie",
      "Zahnfleischretraktion",
      "Zahnfleischschrumpfung"
    ]
  },
  {
    "code": "K06.1",
    "name": "Gingivahyperplasie",
    "synonyms": [
      "Gingivafibromatose",
      "Gingivahyperplasie",
      "Hereditäre Gingivafibromatose",
      "Zahnfleischfibromatose",
      "Zahnfleischhyperplasie",
      "Zahnfleischhypertrophie",
      "Zahnfleischverdickung"
    ]
  },
  {
    "code": "K06.2",
    "name": "Gingivaläsion",
    "synonyms": [
      "Gingivaläsion",
      "Gingivaschaden durch Trauma",
      "Hyperplasie durch Zahnprothese",
      "Hypertrophie der Alveolarfortsatzschleimhaut",
      "Irritative Hyperplasie des zahnlosen Alveolarkamms",
      "Traumatischer Gingivaverschluss",
      "Traumatischer Verschluss des zahnlosen Alveolarkamms",
      "Traumatischer Zahnfleischverschluss",
      "Zahnfleischläsion",
      "Zahnfleischschaden durch Trauma"
    ]
  },
  {
    "code": "K06.8",
    "name": "Zahnfleischschwellung",
    "synonyms": [
      "Chronisches Zahnfleischgeschwür",
      "Epulis",
      "Epulis des Zahnfleisches",
      "Epulis fibrosa",
      "Epulis gigantocellularis",
      "Erworbene Zahnfleischdeformität a.n.k.",
      "Gingivablutung",
      "Gingivahämorrhagie",
      "Gingivapolyp",
      "Gingivaulkus",
      "Kongenitale Epulis",
      "Metallablagerung im Zahnfleisch",
      "Peripheres Riesenzellgranulom",
      "Pyogenes Granulom der Gingiva",
      "Pyogenes Zahnfleischgranulom",
      "Riesenzellepulis",
      "Schlotterkamm",
      "Schlotterkammatrophie",
      "Zahnfleischblutung",
      "Zahnfleischgeschwür",
      "Zahnfleischhämorrhagie",
      "Zahnfleischpolyp",
      "Zahnfleischschwellung",
      "Zahnfleischulkus"
    ]
  },
  {
    "code": "K06.9",
    "name": "Gingivakrankheit",
    "synonyms": [
      "Gingivakrankheit",
      "Krankheit des zahnlosen Alveolarkamms",
      "Zahnfleischkrankheit"
    ]
  },
  {
    "code": "K07.0",
    "name": "Anomalie der Kiefergröße",
    "synonyms": [
      "Anomalie der Kiefergröße",
      "Brachygenie",
      "Brachygnathie",
      "Hypognathie",
      "Kieferagenesie",
      "Kieferhyperplasie",
      "Kieferhypoplasie",
      "Kongenitale Makrognathie",
      "Kongenitale Mikrognathie",
      "Makrognathie",
      "Mandibulaagenesie",
      "Mandibulahypoplasie",
      "Mandibuläre Hyperplasie",
      "Mandibuläre Makrognathie",
      "Mandibuläre Mikrognathie",
      "Maxillaagenesie",
      "Maxillahypoplasie",
      "Maxilläre Hyperplasie",
      "Maxilläre Makrognathie",
      "Maxilläre Mikrognathie",
      "Mikrogenie",
      "Mikrognathie",
      "Oberkieferagenesie",
      "Oberkieferhyperplasie",
      "Oberkieferhypoplasie",
      "Opisthogenie",
      "Opisthognathie",
      "Unterentwicklung des Oberkiefers",
      "Unterkieferagenesie",
      "Unterkieferhyperplasie",
      "Unterkieferhypoplasie"
    ]
  },
  {
    "code": "K07.1",
    "name": "Anomalie der Kiefer-Schädel-Stellung",
    "synonyms": [
      "Anomalie der Kiefer-Schädel-Stellung",
      "Autosomal-dominante mandibuläre Prognathie",
      "Kieferasymmetrie",
      "Mandibuläre Prognathie",
      "Mandibuläre Retrognathie",
      "Maxilläre Prognathie",
      "Maxilläre Retrognathie",
      "Mikroretrognathie",
      "Progenie",
      "Prognathie",
      "Retrogenie",
      "Retrognathie",
      "Retromikrognathie"
    ]
  },
  {
    "code": "K07.2",
    "name": "Anomalie des Zahnbogenverhältnisses",
    "synonyms": [
      "Anomalie des Zahnbogenverhältnisses",
      "Anteriorer offener Biss",
      "Distalbiss",
      "Dysgnathie",
      "Hintere Zungenbissstellung der Unterkieferzähne",
      "Hinterer Kreuzbiss",
      "Horizontaler Überbiss",
      "Kreuzbiss",
      "Mesialbiss",
      "Offener Biss",
      "Posteriore linguale Okklusion der Unterkieferzähne",
      "Posteriorer offener Biss",
      "Sagittale Frontzahnstufe",
      "Tiefer Überbiss",
      "Verschiebung der Kiefermittellinie",
      "Verschiebung der Zahnbogenmittellinie",
      "Verschiebung der Zahnmittellinie",
      "Vertikaler Überbiss",
      "Vorderer Kreuzbiss",
      "Zahnbogenanomalie",
      "Zungenbiss",
      "Überbiss",
      "Übermäßiger Überbiss"
    ]
  },
  {
    "code": "K07.3",
    "name": "Zahnverlagerung",
    "synonyms": [
      "Abnorme Zahnlückenbildung",
      "Anomale Zahnlückenbildung",
      "Engstand hervorrufender Mesiodens",
      "Engstand hervorrufender Paramolar",
      "Engstand hervorrufender akzessorischer Zahn",
      "Engstand hervorrufender überzähliger Zahn",
      "Erworbenes Fehlen von Zähnen mit fehlerhafter Okklusion",
      "Fehlerhafter Biss durch fehlende Zähne",
      "Gebissanomalie",
      "Impaktierter Zahn mit abnormer Stellung",
      "Impaktierter Zahn mit abnormer Stellung benachbarter Zähne",
      "Retinierter Zahn mit abnormer Stellung",
      "Retinierter Zahn mit abnormer Stellung benachbarter Zähne",
      "Retinierter und verlagerter Eckzahn",
      "Retinierter und verlagerter Weisheitszahn",
      "Retinierter und verlagerter Zahn",
      "Weit auseinander stehende Zähne",
      "Zahndiastema",
      "Zahndurchbruchstörung mit abnormer Zahnlage",
      "Zahnengstand",
      "Zahnfehlstellung",
      "Zahnlageanomalie",
      "Zahnretention mit abnormer Stellung benachbarter Zähne",
      "Zahnrotation",
      "Zahnstellungsanomalie",
      "Zahntransposition",
      "Zahnverlagerung"
    ]
  },
  {
    "code": "K07.4",
    "name": "Kiefersperre",
    "synonyms": [
      "Bissanomalie",
      "Fehlerhafter Biss",
      "Kiefersperre"
    ]
  },
  {
    "code": "K07.5",
    "name": "Funktionelle dentofaziale Anomalie",
    "synonyms": [
      "Abnormer Kieferschluss",
      "Fehlerhafte Zahnreihenokklusion durch Fingerlutschgewohnheiten",
      "Fehlerhafte Zahnreihenokklusion durch Lippenlutschgewohnheiten",
      "Fehlerhafte Zahnreihenokklusion durch Mundatmung",
      "Fehlerhafte Zahnreihenokklusion durch Zungenlutschgewohnheiten",
      "Fehlerhafte Zahnreihenokklusion durch abnormen Schluckakt",
      "Fehlerhafte Zahnreihenokklusion durch orofaziale Dysfunktion",
      "Fehlerhafter Biss durch Mundatmung",
      "Fehlerhafter Biss durch abnormes Schlucken",
      "Funktionelle dentofaziale Anomalie"
    ]
  },
  {
    "code": "K07.6",
    "name": "Kiefergelenkkrankheit",
    "synonyms": [
      "Affektion des Temporomandibulargelenks",
      "Binnenschädigung des Kiefergelenks",
      "Costen-Komplex",
      "Costen-Syndrom",
      "Dysfunktion des Temporomandibulargelenks",
      "Funktionsstörung des Kiefergelenks",
      "Kiefergelenkarthralgie",
      "Kiefergelenkarthritis",
      "Kiefergelenkarthrose",
      "Kiefergelenkdysfunktion",
      "Kiefergelenkknacken",
      "Kiefergelenkkrankheit",
      "Kiefergelenkschaden",
      "Kiefergelenkschmerzen",
      "Kiefergelenkstörung",
      "Kondyläre Hyperplasie Typ 1",
      "Kongenitale Kiefergelenkankylose",
      "Primäre kondyläre Hyperplasie",
      "Schmerzhafte Kiefergelenkdysfunktion",
      "Schnappender Kiefer",
      "Temporomandibuläre Arthritis",
      "Temporomandibuläre Gelenkstörung"
    ]
  },
  {
    "code": "K07.9",
    "name": "Dentofaziale Anomalie",
    "synonyms": [
      "Angeborene Kieferdeformität",
      "Dentofaziale Anomalie",
      "Erworbene Kieferdeformität",
      "Kieferanomalie",
      "Kieferdeformität",
      "Mandibuladeformität",
      "Maxilladeformität",
      "Oberkieferdeformität",
      "Unterkieferdeformität"
    ]
  },
  {
    "code": "K08.0",
    "name": "Zahnverfall durch systemische Ursachen",
    "synonyms": [
      "Abblättern der Zähne",
      "Abblättern der Zähne durch systemische Ursachen",
      "Exfoliation der Zähne durch systemische Ursachen",
      "Zahnverfall durch systemische Ursachen"
    ]
  },
  {
    "code": "K08.1",
    "name": "Zahnverlust durch Unfall",
    "synonyms": [
      "Erworbene Anodontie",
      "Fehlende Zähne durch Extraktion",
      "Fehlende Zähne durch Parodontose",
      "Fehlende Zähne durch Unfall",
      "Zahnlosigkeit durch Extraktion",
      "Zahnlosigkeit durch Unfall",
      "Zahnlosigkeit durch lokale Parodontose",
      "Zahnverlust durch Unfall"
    ]
  },
  {
    "code": "K08.2",
    "name": "Atrophie des zahnlosen Alveolarfortsatzes",
    "synonyms": [
      "Alveolarkammatrophie",
      "Atrophie des zahnlosen Alveolarfortsatzes",
      "Atrophie des zahnlosen Alveolarkamms",
      "Oberkieferalveolarfortsatzatrophie",
      "Unterkieferalveolarfortsatzatrophie"
    ]
  },
  {
    "code": "K08.3",
    "name": "Verbliebene Zahnwurzel",
    "synonyms": [
      "Verbliebene Zahnwurzel",
      "Zahnwurzelretention",
      "Zurückgebliebene Zahnwurzel"
    ]
  },
  {
    "code": "K08.81",
    "name": "Pathologische Zahnfraktur",
    "synonyms": [
      "Pathologische Zahnfraktur"
    ]
  },
  {
    "code": "K08.88",
    "name": "Odontogene Entzündung",
    "synonyms": [
      "Alveolarfortsatzblutung",
      "Alveolarfortsatzhypertrophie",
      "Alveolarfortsatzhämorrhagie",
      "Alveolarfortsatzspalte",
      "Alveolarfortsatzvergrößerung",
      "Alveolarkammhypertrophie",
      "Alveolarkammvergrößerung",
      "Alveolenhämorrhagie",
      "Erworbene Aplasie des Alveolarfortsatzes",
      "Hyperalveolie",
      "Irregulärer Alveolarfortsatz",
      "Lose Zähne",
      "Narbe des Alveolarfortsatzes",
      "Nichterhaltungswürdiger Zahn",
      "Odontalgie",
      "Odontogene Entzündung",
      "Odontorrhagie",
      "Problem mit dem Kauvermögen",
      "Problem mit der Kaubewegung",
      "Spalte des Processus alveolaris",
      "Störung des Kauvermögens",
      "Zahnlockerung",
      "Zahnschmerzen"
    ]
  },
  {
    "code": "K08.9",
    "name": "Zahnkrankheit",
    "synonyms": [
      "Alveolarfortsatzschädigung",
      "Chirurgisch sanierungsbedürftiges Gebiss",
      "Sanierungsbedürftiges Gebiss",
      "Zahnalveolenkrankheit",
      "Zahnhalteapparatkrankheit",
      "Zahnkrankheit",
      "Zahnschädigung"
    ]
  },
  {
    "code": "K09.0",
    "name": "Entwicklungsbedingte odontogene Zyste",
    "synonyms": [
      "Dentallaminazyste",
      "Dentitionszyste",
      "Dentitionszyste des Oberkiefers",
      "Dentitionszyste des Unterkiefers",
      "Entwicklungsbedingte odontogene Zyste",
      "Eruptive Zahnzyste",
      "Follikuläre odontogene Zyste",
      "Gingivazyste",
      "Laterale parodontale Zyste",
      "Laterale periodontale Zahnzyste",
      "Laterale periodontale Zyste",
      "Odontogene Zyste",
      "Perikoronarzyste",
      "Primordiale Kieferzyste",
      "Primordiale Zahnzyste",
      "Primordiale odontogene Zyste",
      "Ursprungszyste des Zahns",
      "Zahndurchbruchszyste",
      "Zahnfleischzyste",
      "Zahnzyste des Oberkiefers",
      "Zahnzyste des Unterkiefers",
      "Zahnzyste durch Zahnentwicklungsstörung"
    ]
  },
  {
    "code": "K09.1",
    "name": "Gaumen-Nasengang-Zyste",
    "synonyms": [
      "Entwicklungsbedingte Zyste der Mundregion",
      "Fissurale Zyste",
      "Gaumen-Nasengang-Zyste",
      "Globulomaxilläre Zyste",
      "Kieferspaltzyste",
      "Kleestadt-Zyste",
      "Mediane Gaumenzyste",
      "Mediane anteriormaxilläre Zyste",
      "Medianopalatinale Zyste",
      "Nasoalveoläre Zyste",
      "Nasolabiale Zyste",
      "Spaltzyste des Mundbereiches",
      "Zwischenkiefergangzyste",
      "Zyste der Papilla incisiva",
      "Zyste der Papilla palatina",
      "Zyste des Canalis incisivus",
      "Zyste des Ductus nasopalatinus",
      "Zyste des Naseneingangs",
      "Zyste des mittleren Gaumens",
      "Zyste des nasopalatinalen Ganges"
    ]
  },
  {
    "code": "K09.2",
    "name": "Kieferzyste",
    "synonyms": [
      "Aneurysmatische Kieferzyste",
      "Aneurysmatische Zyste des Kieferknochens",
      "Hämorrhagische Kieferzyste",
      "Hämorrhagische Zyste des Kieferknochens",
      "Kieferknochenzyste",
      "Kieferzyste",
      "Oberkieferzyste",
      "Solitäre Knochenzyste des Kiefers",
      "Traumatische Kieferzyste",
      "Traumatische Zyste des Kieferknochens",
      "Unterkieferzyste"
    ]
  },
  {
    "code": "K09.8",
    "name": "Dermoidzyste des Mundes",
    "synonyms": [
      "Dermoidzyste des Mundes",
      "Epidermoidzyste des Mundes",
      "Epstein-Epithelperlen",
      "Lymphoepitheliale Mundweichteilzyste",
      "Lymphoepithelialzyste des Mundes"
    ]
  },
  {
    "code": "K09.9",
    "name": "Mundzyste",
    "synonyms": [
      "Mundschleimhautzyste",
      "Mundzyste",
      "Zyste der Oralregion",
      "Zyste des oralen Weichteilgewebes"
    ]
  },
  {
    "code": "K10.0",
    "name": "Entwicklungsbedingte Krankheit des Kiefers",
    "synonyms": [
      "Entwicklungsbedingte Krankheit des Kiefers",
      "Entwicklungsbedingte Störung des Kiefers",
      "Latente Kieferknochenzyste",
      "Latente Knochenzyste des Kiefers",
      "Stafne-Zyste",
      "Stafne-Zyste des Unterkiefers",
      "Torus mandibularis",
      "Torus palatinus"
    ]
  },
  {
    "code": "K10.1",
    "name": "Zentrales Riesenzellgranulom",
    "synonyms": [
      "Kiefergranulom",
      "Reparatives Riesenzellgranulom des Kieferknochens",
      "Riesenzellgranulom",
      "Zentrales Riesenzellgranulom",
      "Zentrales Unterkiefergranulom"
    ]
  },
  {
    "code": "K10.20",
    "name": "Abszess der Maxilla",
    "synonyms": [
      "Abszess der Maxilla",
      "Eiterung der Maxilla",
      "Eiterung des Oberkiefers",
      "Maxillärer Abszess",
      "Oberkieferabszess",
      "Oberkieferosteomyelitis"
    ]
  },
  {
    "code": "K10.21",
    "name": "Retromaxillärer Abszess",
    "synonyms": [
      "Maxillärer Abszess mit Ausbreitung in die Fossa canina",
      "Retromaxillärer Abszess"
    ]
  },
  {
    "code": "K10.28",
    "name": "Osteoradionekrose des Kiefers",
    "synonyms": [
      "Abszess des harten Gaumens",
      "Akute Kieferosteomyelitis",
      "Akute Kieferostitis",
      "Akute Kieferperiostitis",
      "Akute Osteoradionekrose des Kiefers",
      "Bestrahlungsinduzierte Kieferosteonekrose",
      "Chronische Kieferosteomyelitis",
      "Chronische Kieferostitis",
      "Chronische Kieferperiostitis",
      "Chronische Osteoradionekrose des Kiefers",
      "Eitrige Kieferentzündung",
      "Eitrige Kieferosteomyelitis",
      "Eitrige Kieferostitis",
      "Eitrige Kieferperiostitis",
      "Eitrige Osteoradionekrose des Kiefers",
      "Infektion der Maxilla",
      "Kieferabszess",
      "Kieferknochenentzündung",
      "Kieferknocheninfektion",
      "Kieferknochensequester",
      "Kiefernekrose",
      "Kieferosteomyelitis",
      "Kieferostitis",
      "Kieferperiostitis",
      "Kiefersequester",
      "Medikamenteninduzierte Kieferosteonekrose",
      "Neonatale Kieferosteomyelitis",
      "Oberkieferinfektion",
      "Oberkieferperiostitis",
      "Osteonekrose des Kiefers",
      "Osteoradionekrose des Kiefers",
      "Osteoradionekrose des Oberkiefers",
      "Osteoradionekrose des Unterkiefers",
      "Radionekrose des Kiefers",
      "Suppurative Kieferosteomyelitis",
      "Suppurative Osteoradionekrose des Kiefers",
      "Unterkieferabszess",
      "Unterkieferinfektion",
      "Unterkieferosteomyelitis",
      "Unterkieferperiostitis"
    ]
  },
  {
    "code": "K10.29",
    "name": "Entzündliche Affektion des Kiefers",
    "synonyms": [
      "Akute Kieferentzündung",
      "Chronische Kieferentzündung",
      "Entzündliche Affektion des Kiefers",
      "Entzündung der Maxilla",
      "Mandibulitis",
      "Oberkieferentzündung",
      "Unterkieferentzündung"
    ]
  },
  {
    "code": "K10.3",
    "name": "Kieferalveolitis",
    "synonyms": [
      "Alveolitis sicca",
      "Alveolodentale Periostitis",
      "Alveoläre Gangrän",
      "Alveoläre Ostitis",
      "Alveoläre Periostitis",
      "Apikale Ostitis",
      "Dry socket",
      "Eiterung des dentalen Periosts",
      "Entzündung der Zahnalveolen",
      "Granuloma apicale",
      "Kieferalveolitis",
      "Trockene Zahnalveole",
      "Trockenes Zahnfach",
      "Zahnfachentzündung",
      "Zahnfachinfektion"
    ]
  },
  {
    "code": "K10.8",
    "name": "Kieferexostose",
    "synonyms": [
      "Cherubinismus",
      "Cherubismus",
      "Erworbene Gaumendeformität",
      "Fibröse Kieferdysplasie",
      "Gesichtsschmerzen bei Erkrankung des Kauapparates",
      "Hypertrophie des harten Gaumens",
      "Kieferexostose",
      "Kieferschmerzen",
      "Maxillaschmerzen",
      "Oberkieferschmerzen",
      "Unilateral kondyläre Unterkieferhyperplasie",
      "Unilaterale Hyperplasie des Processus condylaris mandibulae",
      "Unilaterale Hypoplasie des Processus condylaris mandibulae"
    ]
  },
  {
    "code": "K10.9",
    "name": "Kieferkrankheit",
    "synonyms": [
      "Kieferkrankheit"
    ]
  },
  {
    "code": "K11.0",
    "name": "Speicheldrüsenatrophie",
    "synonyms": [
      "Atrophie der Glandula sublingualis",
      "Atrophie der Glandula submandibularis",
      "Parotisatrophie",
      "Speicheldrüsenatrophie",
      "Speicheldrüseninvolution",
      "Speicheldrüsenlipomatose"
    ]
  },
  {
    "code": "K11.1",
    "name": "Speicheldrüsenhypertrophie",
    "synonyms": [
      "Hypertrophie der Ohrspeicheldrüse",
      "Hypertrophie der Unterkieferdrüse",
      "Hypertrophie der Unterzungendrüse",
      "Parotishypertrophie",
      "Speicheldrüsenhyperplasie",
      "Speicheldrüsenhypertrophie"
    ]
  },
  {
    "code": "K11.2",
    "name": "Akute Sialadenitis",
    "synonyms": [
      "Adenitis der Speicheldrüsen",
      "Adenitis des Speicheldrüsenganges",
      "Akute Parotitis",
      "Akute Sialadenitis",
      "Chronisch-sklerosierende Sialadenitis der Glandula submandibularis",
      "Chronische Parotitis",
      "Chronische Sialadenitis",
      "Eiterung des Speicheldrüsenganges",
      "Eitrige Adenitis der Glandula sublingualis",
      "Eitrige Adenitis der Glandula submandibularis",
      "Eitrige Adenitis der Parotis",
      "Eitrige Entzündung des Wharton-Ganges",
      "Eitrige Parotitis",
      "Eitrige Sialadenitis",
      "Entzündung der Glandula submandibularis",
      "Entzündung des Ductus submandibularis",
      "IgG4-assoziierte Krankheit der Glandula submandibularis",
      "Infektion der Speicheldrüse",
      "Infektion des Speicheldrüsenganges",
      "Iodidmumps",
      "Nichtepidemische Parotitis",
      "Ohrspeicheldrüsenentzündung",
      "Parotisentzündung",
      "Parotisinfektion",
      "Parotitis",
      "Parotitis, nicht durch Mumps bedingt",
      "Purulente Parotitis",
      "Septische Parotitis",
      "Sialadenitis",
      "Sialitis",
      "Sialoadenitis",
      "Sialodochitis",
      "Sialodochitis fibrinosa",
      "Speicheldrüseneiterung",
      "Speicheldrüsenentzündung",
      "Unspezifische toxische Parotitis"
    ]
  },
  {
    "code": "K11.3",
    "name": "Speicheldrüsenabszess",
    "synonyms": [
      "Abszess der sublingualen Drüsen",
      "Abszess der submandibulären Drüsen",
      "Abszess des Speicheldrüsenganges",
      "Parotisabszess",
      "Speicheldrüsenabszess"
    ]
  },
  {
    "code": "K11.4",
    "name": "Speichelgangfistel",
    "synonyms": [
      "Fistel der Glandula sublingualis",
      "Fistel der Ohrspeicheldrüse",
      "Fistel der Unterkieferdrüse",
      "Fistel des Speicheldrüsenganges",
      "Parotisfistel",
      "Speicheldrüsenfistel",
      "Speichelgangfistel"
    ]
  },
  {
    "code": "K11.5",
    "name": "Sialolithiasis",
    "synonyms": [
      "Sialodocholithiasis",
      "Sialolith",
      "Sialolith einer Speicheldrüse",
      "Sialolith eines Speicheldrüsenganges",
      "Sialolithiasis",
      "Speicheldrüsengangstein",
      "Speicheldrüsenstein",
      "Speichelstein",
      "Speichelstein einer Speicheldrüse",
      "Speichelstein eines Speicheldrüsenganges",
      "Speichelsteinleiden",
      "Stein der Glandula sublingualis",
      "Stein der Ohrspeicheldrüse",
      "Stein der Parotis",
      "Stein im Ductus parotideus",
      "Stein im Ductus sublingualis",
      "Stein im Ductus submandibularis",
      "Stein im Stensen-Gang",
      "Stein im Wharton-Gang",
      "Submandibulärstein"
    ]
  },
  {
    "code": "K11.6",
    "name": "Speicheldrüsenmukozele",
    "synonyms": [
      "Extravasationszyste der Parotis",
      "Extravasationszyste der Speicheldrüse",
      "Froschgeschwulst",
      "Muköse Extravasationszyste einer Speicheldrüse",
      "Muköse Retentionszyste einer Speicheldrüse",
      "Mundbodenzyste",
      "Parotiszyste",
      "Ranula",
      "Retentionszyste der Parotis",
      "Retentionszyste der Speicheldrüse",
      "Speicheldrüsenmukozele",
      "Speicheldrüsenzyste",
      "Unterkieferdrüsenzyste",
      "Unterzungendrüsenzyste",
      "Zyste der Glandula sublingualis",
      "Zyste der Glandula submandibularis",
      "Zyste des Ductus parotideus",
      "Zyste des Ductus stenonianus",
      "Zyste des Ductus submandibularis",
      "Zyste des Ductus submaxillaris",
      "Zyste des Ductus whartonii",
      "Zyste des Speicheldrüsenganges",
      "Zyste des Stensen-Ganges",
      "Zyste des Wharton-Ganges"
    ]
  },
  {
    "code": "K11.7",
    "name": "Speichelsekretionsstörung",
    "synonyms": [
      "Aptyalismus",
      "Asialie",
      "Gesteigerte Salivation",
      "Gesteigerter Speichelfluss",
      "Hypersalivation",
      "Hypersekretion von Speichel",
      "Hypoptyalismus",
      "Hyposekretion der Speicheldrüse",
      "Hyposialie",
      "Mangel an Speicheldrüsensekretion",
      "Periodischer Ptyalismus",
      "Ptyalismus",
      "Sialopenie",
      "Sialorrhoe",
      "Sialose",
      "Speicheldrüsenhypersekretion",
      "Speicheldrüsensekretionsstörung",
      "Speichelmangel",
      "Speichelsekretionsstörung",
      "Speichelstauung",
      "Xerostomie",
      "Übermäßige Salivation"
    ]
  },
  {
    "code": "K11.8",
    "name": "Sialektasie",
    "synonyms": [
      "Benigne lymphoepitheliale Speicheldrüsenläsion",
      "Erworbene Atresie des Ductus parotideus",
      "Erworbene Atresie des Ductus sublingualis",
      "Erworbene Atresie des Ductus submandibularis",
      "Erworbene Ohrspeicheldrüsendeformität",
      "Erworbene Parotisdeformität",
      "Erworbene Speicheldrüsendeformität",
      "Erworbene Speicheldrüsengangatresie",
      "Erworbene Speicheldrüsengangdeformität",
      "Gutartige lymphoepitheliale Speicheldrüsenschädigung",
      "IgG4 [Immunglobulin G4]-assoziierte Dakryoadenitis und Sialoadenitis",
      "Nekrotisierende Sialometaplasie",
      "Obstruktion der Unterkieferdrüse",
      "Parotisschmerzen",
      "Schwellung Parotis",
      "Sialektasie",
      "Speicheldrüsengangobstruktion",
      "Speicheldrüsengangsstenose",
      "Speicheldrüsengangstriktur",
      "Speicheldrüseninfarkt",
      "Speicheldrüsenstriktur",
      "Speichelgangsstenose",
      "Speichelgangstriktur",
      "Stenose des Ductus sublingualis",
      "Stensen-Gang-Obstruktion",
      "Von-Mikulicz-Krankheit",
      "Von-Mikulicz-Syndrom"
    ]
  },
  {
    "code": "K11.9",
    "name": "Speicheldrüsenkrankheit",
    "synonyms": [
      "Krankheit des Speicheldrüsenganges",
      "Sialoadenopathie",
      "Speicheldrüsenkrankheit",
      "Speicheldrüsenschädigung"
    ]
  },
  {
    "code": "K12.0",
    "name": "Orale rezidivierende Aphthen",
    "synonyms": [
      "Aphthen",
      "Aphthosis",
      "Bednar-Aphthen",
      "Herpetiforme Stomatitis",
      "Mundschleimhautaphthen",
      "Orale Aphthen",
      "Orale aphthöse Ulzeration",
      "Orale rezidivierende Aphthen",
      "Periadenitis mucosa necrotica recurrens",
      "Rezidivierendes aphthöses Ulkus",
      "Stomatitis herpetiformis",
      "Stomatitis recurrens major",
      "Stomatitis recurrens minor"
    ]
  },
  {
    "code": "K12.1",
    "name": "Mundgeschwür",
    "synonyms": [
      "Akute membranöse Stomatitis",
      "Allergische Stomatitis",
      "Entzündung des Mundraums",
      "Follikuläre Stomatitis",
      "Gaumenbläschen",
      "Gaumengeschwür",
      "Mundbläschen",
      "Mundentzündung",
      "Mundgeschwür",
      "Mundhöhlenentzündung",
      "Mundschleimhautentzündung",
      "Mundschleimhautulkus",
      "Stomatitis",
      "Stomatitis durch Prothese",
      "Stomatitis ulcerosa",
      "Stomatitis vesicularis",
      "Stomatitis vesiculosa",
      "Traumatisches Mundschleimhautulkus",
      "Ulkus des weichen Gaumens",
      "Ulzeröse Stomatitis",
      "Vesikuläre Stomatitis",
      "Zungenbläschen"
    ]
  },
  {
    "code": "K12.20",
    "name": "Mundschleimhautphlegmone",
    "synonyms": [
      "Angina Ludovici",
      "Ludwig-Angina",
      "Mundbodenphlegmone",
      "Mundphlegmone",
      "Mundschleimhautphlegmone"
    ]
  },
  {
    "code": "K12.21",
    "name": "Submandibulärer Abszess",
    "synonyms": [
      "Submandibulärer Abszess"
    ]
  },
  {
    "code": "K12.22",
    "name": "Submandibularabszess mit Ausbreitung nach mediastinal, parapharyngeal oder zervikal",
    "synonyms": [
      "Submandibularabszess mit Ausbreitung nach mediastinal, parapharyngeal oder zervikal"
    ]
  },
  {
    "code": "K12.23",
    "name": "Wangenschleimhautabszess",
    "synonyms": [
      "Wangenabszess",
      "Wangenschleimhautabszess"
    ]
  },
  {
    "code": "K12.28",
    "name": "Staphylitis",
    "synonyms": [
      "Akute Staphylitis",
      "Akute Uvulitis",
      "Akute eitrige Stomatitis",
      "Chronische Staphylitis",
      "Chronische Uvulitis",
      "Eitrige Staphylitis",
      "Eitrige Uvulitis",
      "Eitrige orale Infektion",
      "Gangränöse Staphylitis",
      "Gangränöse Uvulitis",
      "Gaumenabszess",
      "Gaumenzäpfchenentzündung",
      "Katarrhalische Staphylitis",
      "Katarrhalische Uvulitis",
      "Masseterikomandibulärer Abszess",
      "Membranöse Staphylitis",
      "Membranöse Uvulitis",
      "Mundantrumfistel",
      "Mundbodenabszess",
      "Mundbodenfistel",
      "Mundfistel",
      "Mundhöhlenfistel",
      "Orale Fistel",
      "Paramandibulärer Abszess",
      "Perimandibulärer Abszess",
      "Pterygomandibulärer Abszess",
      "Staphylitis",
      "Sublingualabszess",
      "Ulzeröse Staphylitis",
      "Ulzeröse Uvulitis",
      "Uvulitis"
    ]
  },
  {
    "code": "K12.29",
    "name": "Mundschleimhautabszess",
    "synonyms": [
      "Mundabszess",
      "Mundhöhlenabszess",
      "Mundschleimhautabszess"
    ]
  },
  {
    "code": "K12.3",
    "name": "Orale Mukositis",
    "synonyms": [
      "Medikamenteninduzierte orale Mukositis",
      "Orale Mukositis",
      "Oropharyngeale Mukositis",
      "Strahleninduzierte orale Mukositis",
      "Ulzerative orale Mukositis",
      "Virale orale Mukositis"
    ]
  },
  {
    "code": "K13.0",
    "name": "Aufgesprungene Lippen",
    "synonyms": [
      "Angulus infectiosus der Lippe",
      "Angulus infectiosus des Mundes",
      "Angulus infectiosus oris",
      "Anguläre Cheilitis",
      "Atopische Cheilitis",
      "Aufgesprungene Lippen",
      "Baelz-Krankheit",
      "Brennen der Lippen",
      "Cheilitis",
      "Cheilitis angularis",
      "Cheilitis exfoliativa",
      "Cheilodynie",
      "Cheilosis",
      "Erworbene Lippendeformität a.n.k.",
      "Erworbenes Ektropium der Lippe",
      "Exfoliative Cheilitis",
      "Faulecke",
      "Fauleckensyndrom",
      "Glanduläre Cheilitis",
      "Hypertrophie des Lippenfrenulums",
      "Lippenabszess",
      "Lippenatrophie",
      "Lippendrüsenzyste",
      "Lippeneiterung",
      "Lippenentzündung",
      "Lippenfissur",
      "Lippenfistel",
      "Lippengeschwür",
      "Lippenhypertrophie",
      "Lippenkrankheit",
      "Lippenparalyse",
      "Lippenrhagade",
      "Lippenschrunden",
      "Lippenschädigung",
      "Lippenulkus",
      "Lippenzyste",
      "Mundwinkelcheilitis",
      "Mundwinkelcheilosis",
      "Mundwinkelrhagade",
      "Mundwinkelschrunde",
      "Perlèche a.n.k.",
      "Schmerzhafte Lippenrötung",
      "Schmerzhafte Lippenschwellung",
      "Stomatitis angularis",
      "Trockene Lippen",
      "Verhornungsstörung der Lippen",
      "Von-Bälz-Syndrom"
    ]
  },
  {
    "code": "K13.1",
    "name": "Wangenbiss",
    "synonyms": [
      "Lippenbiss",
      "Wangenbiss"
    ]
  },
  {
    "code": "K13.2",
    "name": "Mundhöhlenleukoplakie",
    "synonyms": [
      "Erythroplakie der Zunge",
      "Erythroplakie des Mundes",
      "Erythroplakie des Mundhöhlenepithels und der Zunge",
      "Fokale orale Epithelhyperplasie",
      "Gingivaleukoplakie",
      "Hyperplasie des Zungenepithels",
      "Leukokeratosis nicotina palati",
      "Leukoplakia buccalis",
      "Leukoplakia oris",
      "Leuködem der Zunge",
      "Leuködem des Mundes",
      "Leuködem des Mundhöhlenepithels",
      "Mundhöhlenleukoplakie",
      "Mundleukoplakie",
      "Mundschleimhautleukoplakie",
      "Orale Akanthose",
      "Orale Hyperkeratose",
      "Orale Keratose",
      "Rauchergaumen",
      "Raucherleukokeratose",
      "Störung des Mundepithels",
      "Verhornungsstörung der Zunge",
      "Verhornungsstörung des Mundes",
      "Zahnfleischleukoplakie",
      "Zungenleukoplakie",
      "Zungenplaques",
      "Zungentylosis"
    ]
  },
  {
    "code": "K13.3",
    "name": "Haarleukoplakie",
    "synonyms": [
      "Haarleukoplakie"
    ]
  },
  {
    "code": "K13.4",
    "name": "Eitriges Mundgranulom",
    "synonyms": [
      "Eitriges Mundgranulom",
      "Eosinophiles Granulom der Mundschleimhaut",
      "Granuloma pediculatum der Mundschleimhaut",
      "Granuloma pyogenicum der Mundschleimhaut",
      "Granuloma teleangiectaticum der Mundschleimhaut",
      "Mundschleimhautgranulom",
      "Verruköses Xanthom der Mundschleimhaut"
    ]
  },
  {
    "code": "K13.5",
    "name": "Orale submuköse Fibrose",
    "synonyms": [
      "Orale submuköse Fibrose",
      "Submuköse Zungenfibrose"
    ]
  },
  {
    "code": "K13.6",
    "name": "Irritative Mundschleimhauthyperplasie",
    "synonyms": [
      "Irritative Mundschleimhauthyperplasie",
      "Irritative papilläre Gaumenhyperplasie"
    ]
  },
  {
    "code": "K13.7",
    "name": "Mundinfektion",
    "synonyms": [
      "Atrophie der Mundhöhlenschleimhaut",
      "Bukkale Schädigung",
      "Erosiv-desquamative Veränderung der Mundschleimhaut",
      "Erworbene Munddeformität",
      "Fokale orale Muzinose",
      "Gaumennarbe",
      "Gaumenparalyse",
      "Gaumensegellähmung",
      "Gaumensegelparalyse",
      "Gaumensegelparese",
      "Hypertrophie des weichen Gaumens",
      "Hämorrhagie der Mundhöhle",
      "Hämorrhagie des Mundes",
      "Mundblutung",
      "Mundhöhlenblutung",
      "Mundhöhlenmukozele",
      "Mundinfektion",
      "Mundnarbe",
      "Mundschleimhautatrophie",
      "Mundschmerzen",
      "Narbe des weichen Gaumens",
      "Orale Muzinose",
      "Palatoplegie",
      "Paralyse des weichen Gaumens",
      "Uvulahypertrophie",
      "Uvulaperforation",
      "Uvulaulkus"
    ]
  },
  {
    "code": "K14.0",
    "name": "Möller-Glossitis",
    "synonyms": [
      "Fede-Riga-Krankheit",
      "Gingivoglossitis",
      "Glossitis",
      "Glossitis chronica superficialis",
      "Glossitis interstitialis sclerosa",
      "Glossitis superficialis corticalis",
      "Glossodynia exfoliativa",
      "Hunter-Glossitis",
      "Hunter-Krankheit [Glossitis]",
      "Lingualer Abszess",
      "Möller-Glossitis",
      "Möller-Hunter-Glossitis",
      "Subglossitis",
      "Traumatische Zungenulzeration",
      "Traumatisches Zungenulkus",
      "Ulkus des Frenulum linguae",
      "Zungenabszess",
      "Zungenentzündung",
      "Zungengeschwür",
      "Zungeninfektion a.n.k.",
      "Zungenpapillitis",
      "Zungenulzeration"
    ]
  },
  {
    "code": "K14.1",
    "name": "Lingua geographica",
    "synonyms": [
      "Anulus migrans linguae",
      "Desquamatio areata linguae",
      "Erythema migrans der Zunge",
      "Excoriatio chronica linguae",
      "Exfoliatio areata linguae",
      "Glossitis areata exfoliativa",
      "Glossitis exfoliativa geographica",
      "Glossitis exfoliativa marginalis",
      "Glossitis exfoliativa marginata",
      "Glossitis migrans benigna",
      "Landkartenzunge",
      "Lingua geographica",
      "Zungenwanderplaque"
    ]
  },
  {
    "code": "K14.2",
    "name": "Glossitis rhombica mediana",
    "synonyms": [
      "Glossitis rhombica mediana",
      "Tuberculum rhombicum medianum glossis"
    ]
  },
  {
    "code": "K14.3",
    "name": "Zungenpapillenhypertrophie",
    "synonyms": [
      "Akanthose der Zunge",
      "Belegte Zunge",
      "Glossophytie",
      "Haarzunge",
      "Hypertrophie der Papillae foliatae der Zunge",
      "Lingua villosa",
      "Lingua villosa nigra",
      "Nigrities linguae",
      "Schwarze Haarzunge",
      "Zungenpapillenhypertrophie"
    ]
  },
  {
    "code": "K14.4",
    "name": "Zungenpapillenatrophie",
    "synonyms": [
      "Atrophische Möller-Hunter-Glossitis",
      "Glossitis atrophicans",
      "Zungenpapillenatrophie"
    ]
  },
  {
    "code": "K14.5",
    "name": "Lingua plicata",
    "synonyms": [
      "Erworbene Zungenfissur",
      "Faltenzunge",
      "Furchenzunge",
      "Lingua plicata",
      "Lingua scrotalis",
      "Skrotalzunge"
    ]
  },
  {
    "code": "K14.6",
    "name": "Glossodynie",
    "synonyms": [
      "Burning-Mouth-Syndrom",
      "Glossalgie",
      "Glossodynie",
      "Glossopyrosis",
      "Zungenbrennen",
      "Zungenschmerzen"
    ]
  },
  {
    "code": "K14.8",
    "name": "Zungengrundhyperplasie",
    "synonyms": [
      "Erworbene Makroglossie",
      "Erworbene Zungendeformität",
      "Gekerbte Zunge",
      "Glossoplegie",
      "Hemiatrophie der Zunge",
      "Hypertrophie des Zungenfrenulums",
      "Hämorrhagie der Zunge",
      "Infektion des Ductus thyreoglossus",
      "Lingualzyste",
      "Senile Zungenatrophie",
      "Zungenatrophie",
      "Zungenblutung",
      "Zungengrundhyperplasie",
      "Zungenhypertrophie",
      "Zungenkerbung",
      "Zungenlähmung",
      "Zungennarbe",
      "Zungenparalyse",
      "Zungenspasmus",
      "Zungenverdickung",
      "Zungenvergrößerung",
      "Zungenzyste"
    ]
  },
  {
    "code": "K14.9",
    "name": "Affektion des Frenulum linguae",
    "synonyms": [
      "Affektion des Frenulum linguae",
      "Glossopathie",
      "Zungenkrankheit",
      "Zungenveränderung"
    ]
  },
  {
    "code": "K20.0",
    "name": "EoE [Eosinophile Ösophagitis]",
    "synonyms": [
      "EoE [Eosinophile Ösophagitis]",
      "Eosinophile Ösophagitis",
      "Protonenpumpenhemmer-responsive eosinophile Ösophagitis"
    ]
  },
  {
    "code": "K20.1",
    "name": "Radiogene Ösophagitis",
    "synonyms": [
      "Durch Strahleneinwirkung hervorgerufene Ösophagitis",
      "Radiogene Ösophagitis"
    ]
  },
  {
    "code": "K20.8",
    "name": "Speiseröhrenabszess",
    "synonyms": [
      "Alkalische Ösophagitis",
      "Erosion des Ösophagus",
      "Speiseröhrenabszess",
      "Virusösophagitis",
      "Ösophagitis durch Chemikalie",
      "Ösophagusabszess",
      "Ösophaguserosion",
      "Ösophagusschleimhauterosion"
    ]
  },
  {
    "code": "K20.9",
    "name": "Ösophagitis",
    "synonyms": [
      "Akute Ösophagitis",
      "Blutende Ösophagitis",
      "Chronische Ösophagitis",
      "Infektiöse Ösophagitis",
      "Nekrotische Ösophagitis",
      "Postoperative Ösophagitis",
      "Speiseröhrenentzündung",
      "Ösophagitis",
      "Ösophagusentzündung"
    ]
  },
  {
    "code": "K21.0",
    "name": "Peptische Ösophagitis",
    "synonyms": [
      "Erosiv-ulzeröse Refluxösophagitis",
      "Gastroösophagealer Reflux mit Ösophagitis",
      "Peptische Ösophagitis",
      "Refluxösophagitis",
      "Ösophagusreflux mit Ösophagitis"
    ]
  },
  {
    "code": "K21.9",
    "name": "Gastroösophageale Refluxkrankheit",
    "synonyms": [
      "Gastroösophageale Refluxkrankheit",
      "Gastroösophagealer Reflux",
      "Kardia-ösophageale Relaxation",
      "Kardiochalasie",
      "Reflux im Ösophagus",
      "Refluxkrankheit",
      "Rückfluss von Magensaft",
      "Ösophagealer Reflux"
    ]
  },
  {
    "code": "K22.0",
    "name": "Kardiaachalasie",
    "synonyms": [
      "Achalasie",
      "Achalasie der Kardia",
      "Funktioneller Megaösophagus",
      "Idiopathische Achalasie",
      "Idiopathische Achalasie des Ösophagus",
      "Kardiaachalasie",
      "Kardialgie des Magens bei Achalasie",
      "Kardiospasmus",
      "Kardiospasmus der Speiseröhre",
      "Kardiospasmus des Magens",
      "Kardiospasmus des Ösophagus",
      "Kardiotonische Ösophagusdilatation",
      "Mageneingangskrampf",
      "Megaösophagus",
      "Primäre Achalasie",
      "Reflexkardiospasmus",
      "Ösophagusachalasie"
    ]
  },
  {
    "code": "K22.1",
    "name": "Barrett-Ulkus des Ösophagus",
    "synonyms": [
      "Barrett-Ulkus des Ösophagus",
      "Erosiv-ulzeröse Ösophagitis",
      "Fungoides Ösophagusulkus",
      "Infektiöses Ösophagusulkus",
      "Kardiaulkus",
      "Peptisches kardia-ösophageales Ulkus",
      "Peptisches Ösophagusulkus",
      "Ulzerative Ösophagitis",
      "Ösophagusgeschwür",
      "Ösophagusulkus",
      "Ösophagusulkus durch Arzneimittelingestion",
      "Ösophagusulkus durch Chemikalieningestion",
      "Ösophagusulkus durch Drogeningestion",
      "Ösophagusulkus durch Ingestion einer chemischen Substanz",
      "Ösophagusulkus durch Medikamenteningestion",
      "Ösophagusulkus durch Pilze"
    ]
  },
  {
    "code": "K22.2",
    "name": "Ösophagusstenose",
    "synonyms": [
      "Erworbene Ösophagusmembran",
      "Erworbener Schatzki-Ring des unteren Ösophagus",
      "Erworbener undurchgängiger Ösophagus",
      "Kardiaobstruktion a.n.k.",
      "Kardiastenose",
      "Kardiastriktur",
      "Kardiaverschluss",
      "Speiseröhreneinengung",
      "Speiseröhrenstenose",
      "Speiseröhrenstriktur",
      "Ösophaguseinengung",
      "Ösophaguskompression",
      "Ösophaguskonstriktion",
      "Ösophagusobstruktion",
      "Ösophagusstenose",
      "Ösophagusstriktur",
      "Ösophagusverschluss"
    ]
  },
  {
    "code": "K22.3",
    "name": "Ösophagusperforation",
    "synonyms": [
      "Ösophagusperforation",
      "Ösophagusruptur"
    ]
  },
  {
    "code": "K22.4",
    "name": "Ösophagusdyskinesie",
    "synonyms": [
      "Diffuser Ösophagusspasmus",
      "Distaler Ösophagusspasmus",
      "Hyperkontraktiler Ösophagus",
      "Ineffektive Motilität des tubulären Ösophagus",
      "Korkenzieherspeiseröhre",
      "Korkenzieherösophagus",
      "Motilitätsstörung des tubulären Ösophagus",
      "Nussknackerösophagus",
      "Speiseröhrendyskinesie",
      "Speiseröhrenkrampf",
      "Speiseröhrenspasmus",
      "Ösophageale Amotilität",
      "Ösophagismus",
      "Ösophagusamotilität",
      "Ösophagusdyskinesie",
      "Ösophaguskrampf",
      "Ösophagusspasmus"
    ]
  },
  {
    "code": "K22.5",
    "name": "Erworbene Taschenbildung des Ösophagus",
    "synonyms": [
      "Epiphrenales Ösophagusdivertikel",
      "Erworbene Taschenbildung des Ösophagus",
      "Erworbene pharyngoösophageale Divertikulitis",
      "Erworbene pharyngoösophageale Divertikulose",
      "Erworbenes pharyngoösophageales Divertikel",
      "Erworbenes Ösophagusdivertikel",
      "Kardiadivertikel",
      "Pulsionsdivertikel der Speiseröhre",
      "Pulsionsdivertikel des Ösophagus",
      "Traktionsdivertikel der Speiseröhre",
      "Traktionsdivertikel des Ösophagus",
      "Zenker-Divertikel",
      "Zenker-Divertikel des Ösophagus",
      "Zenker-Ösophagusdivertikel"
    ]
  },
  {
    "code": "K22.6",
    "name": "Mallory-Weiss-Syndrom",
    "synonyms": [
      "Boerhaave-Syndrom",
      "Magenschleimhautriss",
      "Mallory-Weiss-Läsion",
      "Mallory-Weiss-Syndrom",
      "Schleimhautriss der Kardiaregion mit Blutung",
      "Schleimhautriss der Kardiaregion mit Hämorrhagie"
    ]
  },
  {
    "code": "K22.7",
    "name": "Barrett-Syndrom",
    "synonyms": [
      "Barrett-Syndrom",
      "Barrett-Ösophagitis",
      "Barrett-Ösophagus"
    ]
  },
  {
    "code": "K22.80",
    "name": "Ösophagusfistel",
    "synonyms": [
      "Ösophagokutane Fistel",
      "Ösophagusfistel"
    ]
  },
  {
    "code": "K22.81",
    "name": "Ösophagusblutung",
    "synonyms": [
      "Speiseröhrenblutung",
      "Ösophagusblutung",
      "Ösophagushämorrhagie"
    ]
  },
  {
    "code": "K22.88",
    "name": "Ösophagektasie",
    "synonyms": [
      "Ampulle des unteren Ösophagus",
      "Brachyösophagus",
      "Erworbene Ösophagusdeformität",
      "Erworbene Ösophagusdeviation",
      "Erworbene Ösophagusverlagerung",
      "Phrenische Ampulle",
      "Speiseröhrenerweichung",
      "Ösophagektasie",
      "Ösophagogastromalazie",
      "Ösophagomalazie",
      "Ösophagusatonie",
      "Ösophagusdilatation",
      "Ösophagusepidermisierung",
      "Ösophagusepithelisierung",
      "Ösophaguserweichung",
      "Ösophagushypertrophie",
      "Ösophagusleukoplakie",
      "Ösophagusnekrose",
      "Ösophagusparalyse",
      "Ösophaguspolyp",
      "Ösophaguszyste"
    ]
  },
  {
    "code": "K22.9",
    "name": "Ösophaguskrankheit",
    "synonyms": [
      "Kardiaschaden",
      "Ösophaguskrankheit",
      "Ösophagusstörung"
    ]
  },
  {
    "code": "K25.0",
    "name": "Akutes Ulcus ventriculi mit Blutung",
    "synonyms": [
      "Akutes Magengeschwür mit Blutung",
      "Akutes Ulcus ventriculi mit Blutung",
      "Akutes Ulcus ventriculi mit Hämorrhagie",
      "Dieulafoy-Krankheit",
      "Dieulafoy-Ulkus",
      "Dieulafoy-Ulkus am Magen",
      "Exulceratio simplex Dieulafoy"
    ]
  },
  {
    "code": "K25.1",
    "name": "Akutes Ulcus ventriculi mit Perforation",
    "synonyms": [
      "Akutes Magengeschwür mit Perforation",
      "Akutes Ulcus ventriculi mit Perforation"
    ]
  },
  {
    "code": "K25.2",
    "name": "Akutes Ulcus ventriculi mit Blutung und Perforation",
    "synonyms": [
      "Akutes Magengeschwür mit Blutung und Perforation",
      "Akutes Magengeschwür mit Hämorrhagie und Perforation",
      "Akutes Ulcus ventriculi mit Blutung und Perforation"
    ]
  },
  {
    "code": "K25.3",
    "name": "Stressulkus des Magens",
    "synonyms": [
      "Akutes Magengeschwür",
      "Akutes Ulcus ventriculi",
      "Stressulkus des Magens"
    ]
  },
  {
    "code": "K25.4",
    "name": "Ulcus ventriculi mit Teerstuhl",
    "synonyms": [
      "Blutendes Magengeschwür",
      "Blutendes Ulcus ventriculi",
      "Chronisches Ulcus ventriculi mit Blutung",
      "Chronisches Ulcus ventriculi mit Hämorrhagie",
      "Magenulkusblutung",
      "Ulcus ventriculi mit Bluterbrechen",
      "Ulcus ventriculi mit Blutstuhl",
      "Ulcus ventriculi mit Blutung",
      "Ulcus ventriculi mit Hämatemesis",
      "Ulcus ventriculi mit Teerstuhl"
    ]
  },
  {
    "code": "K25.5",
    "name": "Magenperforation",
    "synonyms": [
      "Chronisches Ulcus ventriculi mit Perforation",
      "Magendurchbruch",
      "Magengeschwür mit Perforation",
      "Magenperforation",
      "Perforiertes Ulcus ventriculi"
    ]
  },
  {
    "code": "K25.6",
    "name": "Ulcus ventriculi mit Hämorrhagie und Perforation",
    "synonyms": [
      "Ulcus ventriculi mit Hämorrhagie und Perforation"
    ]
  },
  {
    "code": "K25.7",
    "name": "Chronisches Magengeschwür",
    "synonyms": [
      "Chronisches Magengeschwür",
      "Chronisches Ulcus ventriculi"
    ]
  },
  {
    "code": "K25.9",
    "name": "Ulcus ventriculi",
    "synonyms": [
      "Magengeschwür",
      "Magenschleimhautdefekt",
      "Magenulkus",
      "Magenwanddefekt",
      "Ulcus ad pylorum",
      "Ulcus callosum ventriculi",
      "Ulcus pepticum des Magens",
      "Ulcus pepticum des Pylorus",
      "Ulcus pepticum ventriculi",
      "Ulcus praepyloricum",
      "Ulcus pyloricum",
      "Ulcus rotundum ventriculi",
      "Ulcus ventriculi"
    ]
  },
  {
    "code": "K26.0",
    "name": "Akutes Ulcus duodeni mit Blutung",
    "synonyms": [
      "Akutes Ulcus duodeni mit Blutung",
      "Dieulafoy-Ulkus am Duodenum"
    ]
  },
  {
    "code": "K26.1",
    "name": "Akutes Ulcus duodeni mit Perforation",
    "synonyms": [
      "Akutes Ulcus duodeni mit Perforation"
    ]
  },
  {
    "code": "K26.2",
    "name": "Akutes Ulcus duodeni mit Blutung und Perforation",
    "synonyms": [
      "Akutes Ulcus duodeni mit Blutung und Perforation",
      "Akutes Ulcus duodeni mit Hämorrhagie und Perforation"
    ]
  },
  {
    "code": "K26.3",
    "name": "Akutes Ulcus duodeni",
    "synonyms": [
      "Akutes Ulcus duodeni"
    ]
  },
  {
    "code": "K26.4",
    "name": "Chronisches Ulcus duodeni mit Hämorrhagie",
    "synonyms": [
      "Blutendes Ulcus duodeni",
      "Chronisches Ulcus duodeni mit Blutung",
      "Chronisches Ulcus duodeni mit Hämorrhagie",
      "Duodenalgeschwür mit Blutung",
      "Ulcus duodeni mit Blutung",
      "Ulcus duodeni mit Hämorrhagie",
      "Zwölffingerdarmgeschwür mit Blutung",
      "Zwölffingerdarmgeschwür mit Hämorrhagie"
    ]
  },
  {
    "code": "K26.5",
    "name": "Duodenalperforation",
    "synonyms": [
      "Duodenalperforation",
      "Duodenalulkus mit Perforation",
      "Duodenumperforation",
      "Perforiertes Duodenalulkus",
      "Perforiertes Ulcus duodeni"
    ]
  },
  {
    "code": "K26.6",
    "name": "Chronisches Ulcus duodeni mit Hämorrhagie und Perforation",
    "synonyms": [
      "Chronisches Ulcus duodeni mit Blutung und Perforation",
      "Chronisches Ulcus duodeni mit Hämorrhagie und Perforation",
      "Ulcus duodeni mit Blutung und Perforation"
    ]
  },
  {
    "code": "K26.7",
    "name": "Rezidivierendes Ulcus duodeni",
    "synonyms": [
      "Chronisches Ulcus duodeni",
      "Rezidivierendes Ulcus duodeni"
    ]
  },
  {
    "code": "K26.9",
    "name": "Ulcus duodeni",
    "synonyms": [
      "Duodenalgeschwür",
      "Duodenalulkus",
      "Postpylorische Duodenalerosion",
      "Postpylorischer Ulcus pepticum",
      "Ulcus bulbi duodeni",
      "Ulcus duodeni",
      "Ulcus pepticum des Duodenums",
      "Ulcus pepticum duodeni",
      "Zwölffingerdarmgeschwür"
    ]
  },
  {
    "code": "K27.0",
    "name": "Akutes Ulcus pepticum mit Blutung",
    "synonyms": [
      "Akute gastroduodenale Ulkusblutung",
      "Akutes Ulcus pepticum mit Blutung"
    ]
  },
  {
    "code": "K27.1",
    "name": "Akutes Ulcus pepticum mit Perforation",
    "synonyms": [
      "Akutes Ulcus pepticum mit Perforation"
    ]
  },
  {
    "code": "K27.2",
    "name": "Akutes Ulcus pepticum mit Hämorrhagie und Perforation",
    "synonyms": [
      "Akutes Ulcus pepticum mit Blutung und Perforation",
      "Akutes Ulcus pepticum mit Hämorrhagie und Perforation"
    ]
  },
  {
    "code": "K27.3",
    "name": "Akutes Ulcus pepticum",
    "synonyms": [
      "Akute Magen- und Zwölffingerdarm-Geschwüre",
      "Akutes Ulcus pepticum"
    ]
  },
  {
    "code": "K27.4",
    "name": "Ulcus pepticum mit Hämorrhagie",
    "synonyms": [
      "Chronisches Ulcus pepticum mit Blutung",
      "Chronisches Ulcus pepticum mit Hämorrhagie",
      "Meläna mit Geschwür",
      "Ulcus pepticum mit Blutung",
      "Ulcus pepticum mit Hämorrhagie",
      "Ulkus mit Blutung a.n.k."
    ]
  },
  {
    "code": "K27.5",
    "name": "Ulkusperforation des Magen-Darm-Traktes",
    "synonyms": [
      "Ulcus pepticum mit Perforation",
      "Ulcus perforans a.n.k.",
      "Ulkusperforation des Magen-Darm-Traktes"
    ]
  },
  {
    "code": "K27.7",
    "name": "Chronisches Ulcus pepticum",
    "synonyms": [
      "Chronisches Ulcus pepticum",
      "Rezidivierendes Ulcus pepticum"
    ]
  },
  {
    "code": "K27.9",
    "name": "Ulcus pepticum",
    "synonyms": [
      "Peptisches Geschwür",
      "Ulcus gastroduodenale",
      "Ulcus pepticum"
    ]
  },
  {
    "code": "K28.0",
    "name": "Akutes Ulcus pepticum jejuni mit Blutung",
    "synonyms": [
      "Akutes Ulcus pepticum jejuni mit Blutung"
    ]
  },
  {
    "code": "K28.1",
    "name": "Akutes Ulcus pepticum jejuni mit Perforation",
    "synonyms": [
      "Akutes Ulcus pepticum jejuni mit Perforation",
      "Gastrojejunales akutes Ulkus mit Perforation"
    ]
  },
  {
    "code": "K28.2",
    "name": "Akutes Ulcus pepticum jejuni mit Blutung und Perforation",
    "synonyms": [
      "Akutes Ulcus pepticum jejuni mit Blutung und Perforation",
      "Akutes gastrojejunales Ulkus mit Blutung und Perforation",
      "Akutes gastrojejunales Ulkus mit Hämorrhagie und Perforation"
    ]
  },
  {
    "code": "K28.3",
    "name": "Akutes gastrojejunales Ulkus",
    "synonyms": [
      "Akute Magen- und Darmgeschwüre",
      "Akute gastrointestinale Geschwüre",
      "Akutes Ulcus pepticum jejuni",
      "Akutes gastrojejunales Ulkus"
    ]
  },
  {
    "code": "K28.4",
    "name": "Gastrojejunales Ulkus mit Hämorrhagie",
    "synonyms": [
      "Chronisches gastrojejunales Ulkus mit Blutung",
      "Chronisches gastrojejunales Ulkus mit Hämorrhagie",
      "Gastrojejunales Ulkus mit Blutung",
      "Gastrojejunales Ulkus mit Hämorrhagie"
    ]
  },
  {
    "code": "K28.5",
    "name": "Chronisches gastrojejunales Ulkus mit Perforation",
    "synonyms": [
      "Chronisches gastrojejunales Ulkus mit Perforation",
      "Gastrojejunales Ulkus mit Perforation"
    ]
  },
  {
    "code": "K28.7",
    "name": "Chronisches gastrojejunales Ulkus",
    "synonyms": [
      "Chronisches gastrojejunales Ulkus"
    ]
  },
  {
    "code": "K28.9",
    "name": "Ulkus des Magen-Darm-Traktes",
    "synonyms": [
      "Anastomosengeschwür",
      "Anastomosenulkus",
      "Gastrojejunales Ulkus",
      "Gastrojejunalgeschwür",
      "Jejunales Geschwür",
      "Marginales Darmulkus",
      "Peptische Anastomosenerosion",
      "Peptische gastrointestinale Erosion",
      "Peptische gastrojejunale Erosion",
      "Peptische gastrokolische Erosion",
      "Peptische jejunale Erosion",
      "Peptische magenseitige Erosion",
      "Peptische marginale Erosion",
      "Peptisches Anastomosenulkus",
      "Peptisches gastrointestinales Ulkus",
      "Peptisches gastrojejunales Ulkus",
      "Peptisches gastrokolisches Ulkus",
      "Peptisches jejunales Ulkus",
      "Peptisches magenseitiges Ulkus",
      "Peptisches marginales Ulkus",
      "Ulcus jejuni",
      "Ulcus pepticum jejuni",
      "Ulkus des Magen-Darm-Traktes"
    ]
  },
  {
    "code": "K29.0",
    "name": "Akute hämorrhagische Gastritis",
    "synonyms": [
      "Akute erosive Gastritis mit Blutung",
      "Akute hämorrhagische Gastritis",
      "Hämorrhagische Gastritis",
      "Hämorrhagische erosive Gastritis",
      "Magenschleimhautblutung"
    ]
  },
  {
    "code": "K29.1",
    "name": "Akute Gastritis",
    "synonyms": [
      "Akute Gastritis",
      "Erosive Gastritis",
      "Gastritis erosiva"
    ]
  },
  {
    "code": "K29.2",
    "name": "Alkoholgastritis",
    "synonyms": [
      "Alkoholgastritis",
      "Alkoholtoxische Gastritis",
      "Gastritis durch Alkoholismus"
    ]
  },
  {
    "code": "K29.3",
    "name": "Chronische Oberflächengastritis",
    "synonyms": [
      "Chronische Oberflächengastritis",
      "Chronische superfiziale Gastritis",
      "Kollagene Gastritis mit Beginn im Kindesalter",
      "Oberflächengastritis",
      "Superfiziale Gastritis"
    ]
  },
  {
    "code": "K29.4",
    "name": "Chronische atrophische Gastritis",
    "synonyms": [
      "Atrophische Gastritis",
      "Chronische atrophische Gastritis",
      "Magenschleimhautatrophie"
    ]
  },
  {
    "code": "K29.5",
    "name": "Chronische Antrumgastritis",
    "synonyms": [
      "Antrumgastritis",
      "Becherzellmetaplasie",
      "Chronisch-rezidivierende Gastritis",
      "Chronische Antrumgastritis",
      "Chronische Fundusgastritis",
      "Chronische Gastritis",
      "Chronische Gastritis durch Helicobacter pylori",
      "Rezidivierende Gastritis"
    ]
  },
  {
    "code": "K29.6",
    "name": "Allergische Gastritis",
    "synonyms": [
      "Allergische Gastritis",
      "Antrumerosion",
      "Bakterielle Gastritis",
      "Biliäre Gastritis",
      "Chronische erosive Gastritis",
      "Duodenalerosion",
      "Duodenalschleimhauterosion",
      "Faltenmagen",
      "Gallereflux",
      "Gastritis phlegmonosa",
      "Gastropathia hypertrophica gigantea",
      "Gastroösophagitis",
      "Granulomatöse Gastritis",
      "Hypersekretive Gastritis",
      "Hypertrophische Gastritis",
      "Hypertrophische Gastropathie Ménétrier",
      "Magenerosion",
      "Magenphlegmone",
      "Magenschleimhauterosion",
      "Magenschleimhauthypertrophie",
      "Ménétrier-Krankheit",
      "Ménétrier-Syndrom",
      "Nicht-hypoproteinämische hypertrophische Gastropathie",
      "Refluxgastritis",
      "Reizgastritis",
      "Riesenfaltengastritis",
      "Spastische Gastritis"
    ]
  },
  {
    "code": "K29.7",
    "name": "Korpusgastritis",
    "synonyms": [
      "Einfache Gastritis",
      "Gastritis",
      "Korpusgastritis",
      "Magenentzündung",
      "Magenkatarrh",
      "Magenschleimhautentzündung",
      "Stumpfgastritis"
    ]
  },
  {
    "code": "K29.8",
    "name": "Oberflächenduodenitis",
    "synonyms": [
      "Duodenalbulbitis",
      "Duodenalentzündung",
      "Duodenalkatarrh",
      "Duodenitis",
      "Nichtspezifische Duodenitis",
      "Oberflächenduodenitis",
      "Peptische Duodenitis",
      "Periduodenitis",
      "Zwölffingerdarmentzündung"
    ]
  },
  {
    "code": "K29.9",
    "name": "Akute Gastroduodenitis",
    "synonyms": [
      "Akute Gastroduodenitis",
      "Atrophische Gastroduodenitis",
      "Chronische Gastroduodenitis",
      "Gastroduodenitis",
      "Pylorusentzündung"
    ]
  },
  {
    "code": "K30",
    "name": "Verdauungsinsuffizienz",
    "synonyms": [
      "Allergische Dyspepsie",
      "Atonische Dyspepsie",
      "Berufsbedingte Dyspepsie",
      "Biliöse Indigestion",
      "Dyspepsiedarm",
      "Funktionelle Dyspepsie",
      "Funktionelle Indigestion",
      "Funktionelle allergische Dyspepsie",
      "Funktionelle gastrointestinale Dyspepsie",
      "Funktioneller gastrointestinaler Distress",
      "Fäulungsdyspepsie",
      "Gastrointestinale Dyspepsie",
      "Gastrointestinale Reizung",
      "Gärungsdyspepsie",
      "Indigestion",
      "Kongenitale Dyspepsie",
      "Maldigestion",
      "Reflexdyspepsie",
      "Reizmagen",
      "Säureindigestion",
      "Verdauungsinsuffizienz",
      "Verdauungsschwäche",
      "Verdauungsstörung"
    ]
  },
  {
    "code": "K31.0",
    "name": "Akute Magendilatation",
    "synonyms": [
      "Akute Magendilatation",
      "Akute Magendistension",
      "Akute Magenerweiterung"
    ]
  },
  {
    "code": "K31.10",
    "name": "Hypertrophische Pylorusstenose beim Erwachsenen",
    "synonyms": [
      "Hypertrophische Pylorusstenose beim Erwachsenen",
      "Hypertrophische Pylorusstriktur",
      "Pylorushypertrophie"
    ]
  },
  {
    "code": "K31.11",
    "name": "Entzündliche Pylorusstenose beim Erwachsenen",
    "synonyms": [
      "Entzündliche Pylorusstenose beim Erwachsenen"
    ]
  },
  {
    "code": "K31.12",
    "name": "Pylorusstenose beim Erwachsenen durch Kompression",
    "synonyms": [
      "Pylorusstenose beim Erwachsenen durch Infiltration",
      "Pylorusstenose beim Erwachsenen durch Kompression",
      "Pylorusstenose beim Erwachsenen durch Neubildungen am Duodenum",
      "Pylorusstenose beim Erwachsenen durch Neubildungen am Magen",
      "Pylorusstenose beim Erwachsenen durch Neubildungen am Pankreas"
    ]
  },
  {
    "code": "K31.18",
    "name": "Pylorusstenose",
    "synonyms": [
      "Magenausgangsstenose",
      "Magenausgangsverschluss",
      "Obstruktion des Magenausganges",
      "Pylorusobstruktion",
      "Pylorusobstruktion beim Erwachsenen",
      "Pylorusstenose",
      "Pylorusstriktur beim Erwachsenen",
      "Pylorusverschluss beim Erwachsenen"
    ]
  },
  {
    "code": "K31.2",
    "name": "Sanduhrstriktur des Magens",
    "synonyms": [
      "Kaskadenmagen",
      "Sanduhrmagen",
      "Sanduhrstenose des Magens",
      "Sanduhrstriktur des Magens"
    ]
  },
  {
    "code": "K31.3",
    "name": "Pylorospasmus a.n.k.",
    "synonyms": [
      "Magenobstruktion durch Pylorospasmus",
      "Magenpförtnerkrampf",
      "Pylorospasmus a.n.k.",
      "Pyloruskontraktur a.n.k.",
      "Reflexpylorospasmus a.n.k."
    ]
  },
  {
    "code": "K31.4",
    "name": "Magendivertikel",
    "synonyms": [
      "Magendivertikel",
      "Taschenbildung des Magens"
    ]
  },
  {
    "code": "K31.5",
    "name": "Duodenalstenose",
    "synonyms": [
      "Chronischer Duodenalileus",
      "Duodenalkonstriktion",
      "Duodenalobstruktion",
      "Duodenalstenose",
      "Duodenalstriktur",
      "Duodenalverschluss",
      "Obstruktive Duodenalnarbe",
      "Stasis duodenalis"
    ]
  },
  {
    "code": "K31.6",
    "name": "Duodenalfistel",
    "synonyms": [
      "Duodenalfistel",
      "Fistula gastro-jejuno-colica",
      "Fistula gastroduodenalis",
      "Gastrische Fistel",
      "Gastro-gastrische Fistel",
      "Gastroduodenalfistel",
      "Gastroenterokolische Fistel",
      "Gastrojejunale Fistel",
      "Gastrojejunokolische Fistel",
      "Gastrokolische Fistel",
      "Kolon-Magen-Fistel",
      "Magenfistel"
    ]
  },
  {
    "code": "K31.7",
    "name": "Antrumpolyp",
    "synonyms": [
      "Antrumpolyp",
      "Duodenalpolyp",
      "Hyperplastischer Duodenalpolyp",
      "Hyperplastischer Magenpolyp",
      "Magenpolyp",
      "Polyp des Antrum pyloricum"
    ]
  },
  {
    "code": "K31.81",
    "name": "Angiodysplasie des Magens",
    "synonyms": [
      "Angiektasie des Duodenums ohne Angabe einer Blutung",
      "Angiektasie des Magens ohne Angabe einer Blutung",
      "Angiodysplasie des Duodenums",
      "Angiodysplasie des Magens",
      "GAVE [Gastrale antrale vaskuläre Ektasie]-Syndrom am Duodenum ohne Angabe einer Blutung",
      "GAVE [Gastrale antrale vaskuläre Ektasie]-Syndrom am Magen ohne Angabe einer Blutung",
      "Gastrale antrale vaskuläre Ektasie am Duodenum ohne Angabe einer Blutung",
      "Gastrale antrale vaskuläre Ektasie am Magen ohne Angabe einer Blutung"
    ]
  },
  {
    "code": "K31.82",
    "name": "Angiodysplasie des Duodenums mit Blutung",
    "synonyms": [
      "Angiektasie des Duodenums mit Blutung",
      "Angiektasie des Magens mit Blutung",
      "Angiodysplasie des Duodenums mit Blutung",
      "Angiodysplasie des Magens mit Blutung",
      "GAVE [Gastrale antrale vaskuläre Ektasie]-Syndrom am Duodenum mit Blutung",
      "GAVE [Gastrale antrale vaskuläre Ektasie]-Syndrom am Magen mit Blutung",
      "Gastrale antrale vaskuläre Ektasie am Duodenum mit Blutung",
      "Gastrale antrale vaskuläre Ektasie am Magen mit Blutung"
    ]
  },
  {
    "code": "K31.88",
    "name": "Gastrektasie",
    "synonyms": [
      "Absolute Achlorhydrie",
      "Achlorhydrie",
      "Achlorhydrische Diarrhoe",
      "Achylia",
      "Achylia gastrica",
      "Achylia gastrica refractoria",
      "Achylie",
      "Anazidität",
      "Anazidität des Magens",
      "Angelhakenmagen",
      "Apepsia gastrica",
      "Apepsie",
      "Deformität des Bulbus duodeni",
      "Descensus ventriculi",
      "Dilatatio ventriculi",
      "Dolichogastrie",
      "Duodenalhypertrophie",
      "Duodenalhyperämie",
      "Erworbene Duodenaldeformität",
      "Erworbene Magendeformität",
      "Erworbene Megalogastrie",
      "Erworbene Pylorusdeformität",
      "Funktionelle Magenkrankheit",
      "Gastrektasie",
      "Gastrische Hyperazidität",
      "Gastrische Hypersekretion",
      "Gastrische Hypoazidität",
      "Gastrische Subazidität",
      "Gastrische Superazidität",
      "Gastrointestinale Hyperaktivität",
      "Gastrointestinale Hypomotilität",
      "Gastrolith",
      "Gastromalazie",
      "Gastroparese",
      "Gastroptose",
      "Gastrospasmus",
      "Gastrostenose",
      "Gastrosukkorrhoe",
      "Histaminrefraktäre Achylie",
      "Hyperazidität",
      "Hyperazidität des Magens",
      "Hyperchlorhydrie",
      "Hypoazidität",
      "Hypoazidität des Magens",
      "Hypochlorhydrie",
      "Hypochylie",
      "Idiopathische Gastroparese",
      "Intermittierende Gastrosukkorrhoe",
      "Kardiainsuffizienz",
      "Kontinuierliche Gastrosukkorrhoe",
      "Lageanomalie des Magens",
      "Magenandauung",
      "Magenatonie",
      "Magendegeneration",
      "Magendilatation",
      "Magendistension",
      "Magendysfunktion",
      "Magenektasie",
      "Magenerweichung",
      "Magenerweiterung",
      "Magenhyperaktivität",
      "Magenhypermobilität",
      "Magenhypertonie",
      "Magenhypertrophie",
      "Magenhyperämie",
      "Magenhypomotilität",
      "Mageninertia",
      "Magenirritabilität",
      "Magenischämie",
      "Magenkontraktur",
      "Magenmotorikstörung",
      "Magennekrose",
      "Magenobstruktion a.n.k.",
      "Magenparalyse",
      "Magenperforation ohne Ulkus",
      "Magenprolaps",
      "Magenptose",
      "Magenruptur",
      "Magenschleimhautprolaps",
      "Magensenkung",
      "Magensklerose",
      "Magenspasmus",
      "Magenstein",
      "Magenstenose",
      "Magenstriktur",
      "Magensäuremangel",
      "Magenvolvulus durch Verlust des Ligamentum gastrocolicum",
      "Magenübersäuerung",
      "Megalogastrie",
      "Neurogene Achlorhydrie",
      "Neurogener Gastrospasmus",
      "Nichttraumatische spontane Magenruptur",
      "Pylorusinsuffizienz",
      "Reflexgastrospasmus",
      "Ruptur des Duodenalstumpfes",
      "Sanduhrförmige Magenkontraktion",
      "Subazidität des Magens",
      "Superazidität"
    ]
  },
  {
    "code": "K31.9",
    "name": "Duodenalaffektion",
    "synonyms": [
      "Duodenalaffektion",
      "Duodenalkrankheit",
      "Duodenalschädigung",
      "Feldflaschenmagen",
      "Funktionelle Magenbeschwerden",
      "Funktionelle Magenentleerungsstörung",
      "Gastroduodenalschaden",
      "Gastroduodenopathie",
      "Gastropathie",
      "Krankheit des Magens und des Duodenums",
      "Krankheit von Magen und Zwölffingerdarm",
      "Magenaffektion",
      "Magenbeschwerden",
      "Magendruck",
      "Magenfunktionsstörung",
      "Magenkrankheit",
      "Magensekretionsstörung",
      "Magenverstimmung",
      "Pylorusschädigung"
    ]
  },
  {
    "code": "K35.2",
    "name": "Akute Appendizitis mit generalisierter Peritonitis nach Perforation",
    "synonyms": [
      "Akute Appendizitis mit generalisierter Peritonitis",
      "Akute Appendizitis mit generalisierter Peritonitis nach Perforation",
      "Akute Appendizitis mit generalisierter Peritonitis nach Ruptur",
      "Akute Blinddarmentzündung mit generalisierter Peritonitis",
      "Appendixgangrän mit generalisierter Peritonitis",
      "Appendixruptur mit generalisierter Peritonitis"
    ]
  },
  {
    "code": "K35.30",
    "name": "Akute Appendizitis mit lokaler Peritonitis",
    "synonyms": [
      "Akute Appendizitis mit lokaler Peritonitis",
      "Akute Appendizitis mit lokalisierter Peritonitis",
      "Akute Blinddarmentzündung mit lokalisierter Peritonitis",
      "Appendixgangrän mit lokaler Peritonitis"
    ]
  },
  {
    "code": "K35.31",
    "name": "Appendixperforation",
    "synonyms": [
      "Akute Appendizitis mit Perforation",
      "Akute Appendizitis mit Ruptur",
      "Akute Appendizitis mit lokalisierter Peritonitis nach Perforation",
      "Akute perforierende Appendizitis",
      "Appendixdurchbruch",
      "Appendixgangrän mit Perforation",
      "Appendixgangrän mit Ruptur",
      "Appendixperforation",
      "Appendixruptur",
      "Appendizitis mit Perforation",
      "Appendizitis mit Ruptur",
      "Blinddarmruptur",
      "Gedeckt perforierte Appendizitis",
      "Perforierende Appendizitis",
      "Perforierte Appendizitis"
    ]
  },
  {
    "code": "K35.32",
    "name": "Akute Appendizitis mit Peritonealabszess",
    "synonyms": [
      "Akute Appendizitis mit Peritonealabszess",
      "Appendixabszess",
      "Appendixgangrän mit Peritonealabszess",
      "Blinddarmabszess",
      "Ileozäkaler Abszess",
      "Paratyphlitischer Abszess",
      "Periappendizitischer Abszess",
      "Perityphlitischer Abszess",
      "Wurmfortsatzabszess",
      "Zäkumabszess",
      "Zäkumphlegmone"
    ]
  },
  {
    "code": "K35.8",
    "name": "Akute Appendizitis",
    "synonyms": [
      "Akute Appendizitis",
      "Akute Appendizitis ohne Perforation",
      "Akute Appendizitis ohne Peritonealabszess",
      "Akute Appendizitis ohne Ruptur",
      "Akute Blinddarmentzündung",
      "Akute Typhlitis",
      "Appendixgangrän",
      "Appendizitische Reizung",
      "Blinddarmreizung",
      "Eitrige Appendizitis",
      "Eitrige Blinddarmentzündung",
      "Eitrige Typhlitis",
      "Gangränöse Appendizitis",
      "Katarrhalische Appendizitis",
      "Nekrose des Blinddarms",
      "Phlegmonöse Appendizitis",
      "Septische Appendixthrombose",
      "Ulzeröse Appendizitis"
    ]
  },
  {
    "code": "K36",
    "name": "Chronische Appendizitis",
    "synonyms": [
      "Chronische Appendizitis",
      "Chronische Blinddarmentzündung",
      "Intervall-Appendizitis",
      "Obstruktive Appendizitis",
      "Rezidivierende Appendizitis",
      "Rezidivierende Blinddarmentzündung",
      "Subakute Appendizitis"
    ]
  },
  {
    "code": "K37",
    "name": "Appendizitis",
    "synonyms": [
      "Appendixentzündung",
      "Appendizitis",
      "Appendizitis durch Pneumokokken",
      "Blinddarmentzündung - s.a. Appendizitis oder s.a. Wurmfortsatzentzündung",
      "Periappendizitis",
      "Perityphlitis",
      "Retrozäkale Appendizitis",
      "Typhlitis",
      "Wurmfortsatzentzündung",
      "Zäkumentzündung",
      "Zäkuminfektion"
    ]
  },
  {
    "code": "K38.0",
    "name": "Appendixhyperplasie",
    "synonyms": [
      "Appendixhyperplasie",
      "Lymphoide Appendixhyperplasie"
    ]
  },
  {
    "code": "K38.1",
    "name": "Appendixkonkrement",
    "synonyms": [
      "Appendixkonkrement",
      "Appendixstein",
      "Koprolith der Appendix",
      "Koprostase der Appendix",
      "Kotstein der Appendix"
    ]
  },
  {
    "code": "K38.2",
    "name": "Appendixdivertikel",
    "synonyms": [
      "Appendixdivertikel"
    ]
  },
  {
    "code": "K38.3",
    "name": "Appendixfistel",
    "synonyms": [
      "Appendixfistel"
    ]
  },
  {
    "code": "K38.8",
    "name": "Appendixkolik",
    "synonyms": [
      "Appendixatrophie",
      "Appendixinvagination",
      "Appendixkolik",
      "Appendixmukozele",
      "Appendixstrangulation",
      "Appendixzyste",
      "Intussuszeption der Appendix",
      "Obliteration des Appendixlumens"
    ]
  },
  {
    "code": "K38.9",
    "name": "Appendikopathie",
    "synonyms": [
      "Appendikopathie",
      "Appendixkrankheit"
    ]
  },
  {
    "code": "K40.00",
    "name": "Doppelseitige Hernia inguinalis mit Einklemmung ohne Gangrän",
    "synonyms": [
      "Doppelseitige Hernia inguinalis mit Einklemmung ohne Gangrän"
    ]
  },
  {
    "code": "K40.01",
    "name": "Rezidivierende doppelseitige Hernia inguinalis mit Einklemmung ohne Gangrän",
    "synonyms": [
      "Rezidivierende doppelseitige Hernia inguinalis mit Einklemmung ohne Gangrän"
    ]
  },
  {
    "code": "K40.10",
    "name": "Doppelseitige Hernia inguinalis mit Gangrän",
    "synonyms": [
      "Doppelseitige Hernia inguinalis mit Gangrän"
    ]
  },
  {
    "code": "K40.11",
    "name": "Rezidivierende doppelseitige Hernia inguinalis mit Gangrän",
    "synonyms": [
      "Rezidivierende doppelseitige Hernia inguinalis mit Gangrän"
    ]
  },
  {
    "code": "K40.20",
    "name": "Beidseitige Inguinalhernie",
    "synonyms": [
      "Beidseitige Inguinalhernie",
      "Beidseitige Leistenhernie",
      "Doppelseitige Hernia inguinalis",
      "Doppelseitige Hernia inguinalis ohne Einklemmung",
      "Doppelseitige Leistenhernie ohne Einklemmung",
      "Hernia inguinalis bilateralis"
    ]
  },
  {
    "code": "K40.21",
    "name": "Rezidivierende beidseitige Inguinalhernie",
    "synonyms": [
      "Rezidivierende beidseitige Inguinalhernie",
      "Rezidivierende beidseitige Leistenhernie",
      "Rezidivierende doppelseitige Hernia inguinalis",
      "Rezidivierende doppelseitige Hernia inguinalis ohne Einklemmung",
      "Rezidivierende doppelseitige Leistenhernie ohne Einklemmung"
    ]
  },
  {
    "code": "K40.30",
    "name": "Leistenbruch mit Verschluss",
    "synonyms": [
      "Einseitige Hernia inguinalis mit Einklemmung",
      "Einseitige Verschluss verursachende Hernia inguinalis ohne Gangrän",
      "Einseitige inkarzerierte Hernia inguinalis ohne Gangrän",
      "Einseitige irreponible Hernia inguinalis ohne Gangrän",
      "Einseitige strangulierte Hernia inguinalis ohne Gangrän",
      "Hernia inguinalis mit Einklemmung",
      "Inguinalhernie mit Einklemmung",
      "Inguinalhernie mit Inkarzeration",
      "Inguinalhernie mit Strangulation",
      "Inguinalhernie mit Verschluss",
      "Inkarzerierte Hernia inguinalis ohne Gangrän",
      "Inkarzerierte Leistenhernie",
      "Irreponible Hernia inguinalis ohne Gangrän",
      "Leistenbruch mit Einklemmung",
      "Leistenbruch mit Inkarzeration",
      "Leistenbruch mit Strangulation",
      "Leistenbruch mit Verschluss",
      "Strangulierte Hernia inguinalis ohne Gangrän",
      "Verschluss verursachende Hernia inguinalis ohne Gangrän"
    ]
  },
  {
    "code": "K40.31",
    "name": "Rezidivierender Leistenbruch mit Verschluss",
    "synonyms": [
      "Rezidivierende Hernia inguinalis mit Einklemmung",
      "Rezidivierende Inguinalhernie mit Einklemmung",
      "Rezidivierende Inguinalhernie mit Inkarzeration",
      "Rezidivierende Inguinalhernie mit Strangulation",
      "Rezidivierende Inguinalhernie mit Verschluss",
      "Rezidivierende inkarzerierte Leistenhernie",
      "Rezidivierender Leistenbruch mit Einklemmung",
      "Rezidivierender Leistenbruch mit Inkarzeration",
      "Rezidivierender Leistenbruch mit Strangulation",
      "Rezidivierender Leistenbruch mit Verschluss"
    ]
  },
  {
    "code": "K40.40",
    "name": "Leistenbruch mit Gangrän",
    "synonyms": [
      "Einseitige Hernia inguinalis mit Gangrän",
      "Gleithernie mit Gangrän",
      "Hernia inguinalis mit Gangrän",
      "Inguinalhernie mit Gangrän",
      "Leistenbruch mit Gangrän"
    ]
  },
  {
    "code": "K40.41",
    "name": "Rezidivierender Leistenbruch mit Gangrän",
    "synonyms": [
      "Rezidivierende Gleithernie mit Gangrän",
      "Rezidivierende Inguinalhernie mit Gangrän",
      "Rezidivierender Leistenbruch mit Gangrän"
    ]
  },
  {
    "code": "K40.90",
    "name": "Einseitige Leistenhernie ohne Einklemmung",
    "synonyms": [
      "Direkte Leistenhernie",
      "Einseitige Hernia inguinalis",
      "Einseitige Hernia inguinalis ohne Einklemmung",
      "Einseitige Inguinalhernie",
      "Einseitige Leistenhernie ohne Einklemmung",
      "Femoroinguinalhernie",
      "Gleitbruch",
      "Gleithernie",
      "Hernia directa",
      "Hernia indirecta",
      "Hernia inguinalis",
      "Hernia inguinalis directa",
      "Hernia inguinalis indirecta",
      "Hernia inguinalis obliqua",
      "Hernia inguinoscrotalis",
      "Hernia labialis",
      "Hernia labialis posterior",
      "Hernia obliqua",
      "Hernia scrotalis",
      "Hodenbruch",
      "Indirekte Leistenhernie",
      "Indirekter Leistenbruch",
      "Inguinalhernie",
      "Inkomplette Leistenhernie",
      "Labialhernie",
      "Laterale Leistenhernie",
      "Leistenbruch",
      "Leistenhernie",
      "Mediale Leistenhernie",
      "Offener Processus vaginalis",
      "Offener Processus vaginalis peritonei",
      "Skrotalhernie",
      "Weiche Leiste"
    ]
  },
  {
    "code": "K40.91",
    "name": "Rezidivierende Hernia inguinalis",
    "synonyms": [
      "Leistenhernienrezidiv",
      "Rezidivierende Femoroinguinalhernie",
      "Rezidivierende Gleithernie",
      "Rezidivierende Hernia directa",
      "Rezidivierende Hernia indirecta",
      "Rezidivierende Hernia inguinalis",
      "Rezidivierende Hernia inguinalis directa",
      "Rezidivierende Hernia inguinalis indirecta",
      "Rezidivierende Hernia inguinalis obliqua",
      "Rezidivierende Hernia inguinoscrotalis",
      "Rezidivierende Hernia labialis",
      "Rezidivierende Hernia labialis posterior",
      "Rezidivierende Hernia obliqua",
      "Rezidivierende Hernia scrotalis",
      "Rezidivierende Inguinalhernie",
      "Rezidivierende Labialhernie",
      "Rezidivierende Skrotalhernie",
      "Rezidivierende direkte Leistenhernie",
      "Rezidivierende einseitige Hernia inguinalis ohne Einklemmung",
      "Rezidivierende einseitige Inguinalhernie",
      "Rezidivierende einseitige Leistenhernie ohne Einklemmung",
      "Rezidivierende indirekte Leistenhernie",
      "Rezidivierende weiche Leiste",
      "Rezidivierender Gleitbruch",
      "Rezidivierender Hodenbruch",
      "Rezidivierender Leistenbruch",
      "Rezidivierender indirekter Leistenbruch"
    ]
  },
  {
    "code": "K41.00",
    "name": "Doppelseitige Hernia femoralis mit Einklemmung ohne Gangrän",
    "synonyms": [
      "Doppelseitige Hernia femoralis mit Einklemmung ohne Gangrän"
    ]
  },
  {
    "code": "K41.01",
    "name": "Rezidivierende doppelseitige Hernia femoralis mit Einklemmung ohne Gangrän",
    "synonyms": [
      "Rezidivierende doppelseitige Hernia femoralis mit Einklemmung ohne Gangrän"
    ]
  },
  {
    "code": "K41.10",
    "name": "Doppelseitige Hernia femoralis mit Gangrän",
    "synonyms": [
      "Doppelseitige Hernia femoralis mit Gangrän"
    ]
  },
  {
    "code": "K41.11",
    "name": "Rezidivierende doppelseitige Hernia femoralis mit Gangrän",
    "synonyms": [
      "Rezidivierende doppelseitige Hernia femoralis mit Gangrän"
    ]
  },
  {
    "code": "K41.20",
    "name": "Doppelseitige Hernia femoralis",
    "synonyms": [
      "Doppelseitige Hernia femoralis"
    ]
  },
  {
    "code": "K41.21",
    "name": "Rezidivierende doppelseitige Hernia femoralis",
    "synonyms": [
      "Rezidivierende doppelseitige Hernia femoralis"
    ]
  },
  {
    "code": "K41.30",
    "name": "Inkarzerierte Schenkelhernie",
    "synonyms": [
      "Eingeklemmte Femoralhernie",
      "Einseitige Hernia femoralis mit Einklemmung",
      "Einseitige Verschluss verursachende Hernia femoralis ohne Gangrän",
      "Einseitige inkarzerierte Hernia femoralis ohne Gangrän",
      "Einseitige irreponible Hernia femoralis ohne Gangrän",
      "Einseitige strangulierte Hernia femoralis ohne Gangrän",
      "Femoralhernie mit Einklemmung",
      "Hernia femoralis mit Einklemmung",
      "Inkarzerierte Hernia femoralis ohne Gangrän",
      "Inkarzerierte Schenkelhernie",
      "Irreponible Femoralhernie",
      "Irreponible Hernia femoralis",
      "Irreponible Hernia femoralis ohne Gangrän",
      "Irreponibler Schenkelbruch",
      "Schenkelbruch mit Einklemmung",
      "Strangulierte Hernia femoralis ohne Gangrän",
      "Verschluss verursachende Hernia femoralis ohne Gangrän"
    ]
  },
  {
    "code": "K41.31",
    "name": "Rezidivierende einseitige Hernia femoralis mit Einklemmung",
    "synonyms": [
      "Rezidivierende Hernia femoralis mit Einklemmung",
      "Rezidivierende Verschluss verursachende Hernia femoralis ohne Gangrän",
      "Rezidivierende einseitige Hernia femoralis mit Einklemmung",
      "Rezidivierende einseitige Verschluss verursachende Hernia femoralis ohne Gangrän",
      "Rezidivierende einseitige inkarzerierte Hernia femoralis ohne Gangrän",
      "Rezidivierende einseitige irreponible Hernia femoralis ohne Gangrän",
      "Rezidivierende einseitige strangulierte Hernia femoralis ohne Gangrän",
      "Rezidivierende inkarzerierte Hernia femoralis ohne Gangrän",
      "Rezidivierende irreponible Hernia femoralis ohne Gangrän",
      "Rezidivierende strangulierte Hernia femoralis ohne Gangrän"
    ]
  },
  {
    "code": "K41.40",
    "name": "Schenkelbruch mit Gangrän",
    "synonyms": [
      "Einseitige Hernia femoralis mit Einklemmung mit Gangrän",
      "Femoralhernie mit Gangrän",
      "Hernia femoralis mit Gangrän",
      "Schenkelbruch mit Gangrän"
    ]
  },
  {
    "code": "K41.41",
    "name": "Rezidivierende einseitige Hernia femoralis mit Einklemmung mit Gangrän",
    "synonyms": [
      "Rezidivierende Hernia femoralis mit Gangrän",
      "Rezidivierende einseitige Hernia femoralis mit Einklemmung mit Gangrän"
    ]
  },
  {
    "code": "K41.90",
    "name": "Einseitige Femoralhernie",
    "synonyms": [
      "Einseitige Femoralhernie",
      "Einseitige Hernia femoralis",
      "Femoralhernie",
      "Hernia femoralis",
      "Hernia femoralis links",
      "Hernia femoralis rechts",
      "Schenkelbruch",
      "Schenkelhernie",
      "Schenkelhernie links",
      "Schenkelhernie rechts"
    ]
  },
  {
    "code": "K41.91",
    "name": "Rezidivierende einseitige Hernia femoralis",
    "synonyms": [
      "Rezidivierende Hernia femoralis",
      "Rezidivierende einseitige Hernia femoralis"
    ]
  },
  {
    "code": "K42.0",
    "name": "Inkarzerierte Nabelhernie",
    "synonyms": [
      "Hernia umbilicalis mit Einklemmung",
      "Inkarzerierte Hernia umbilicalis ohne Gangrän",
      "Inkarzerierte Nabelhernie",
      "Irreponible Hernia umbilicalis",
      "Irreponible Hernia umbilicalis ohne Gangrän",
      "Irreponibler Nabelbruch",
      "Nabelbruch mit Einklemmung",
      "Strangulierte Hernia umbilicalis ohne Gangrän",
      "Verschluss verursachende Hernia umbilicalis ohne Gangrän"
    ]
  },
  {
    "code": "K42.1",
    "name": "Hernia umbilicalis mit Gangrän",
    "synonyms": [
      "Hernia umbilicalis gangraenosa",
      "Hernia umbilicalis mit Gangrän",
      "Nabelbruch mit Gangrän"
    ]
  },
  {
    "code": "K42.9",
    "name": "Nabelhernie ohne Einklemmung",
    "synonyms": [
      "Enteromphalus",
      "Hernia funiculi umbilicalis",
      "Hernia paraumbilicalis",
      "Hernia umbilicalis",
      "Infraumbilikale Bauchwandhernie",
      "Nabelbruch",
      "Nabelhernie",
      "Nabelhernie ohne Einklemmung",
      "Paraumbilikalhernie",
      "Umbilikalhernie",
      "Umbilikalhernie ohne Einklemmung"
    ]
  },
  {
    "code": "K43.0",
    "name": "Inkarzerierte Narbenhernie",
    "synonyms": [
      "Inkarzerierte Narbenhernie",
      "Irreponible Narbenhernie",
      "Narbenhernie mit Einklemmung, ohne Gangrän",
      "Strangulierte Narbenhernie",
      "Verschluss verursachende Narbenhernie"
    ]
  },
  {
    "code": "K43.1",
    "name": "Narbenhernie mit Gangrän",
    "synonyms": [
      "Narbenhernie mit Gangrän"
    ]
  },
  {
    "code": "K43.2",
    "name": "Narbenhernie",
    "synonyms": [
      "Bauchnarbenbruch",
      "Bauchnarbenhernie",
      "Narbenbruch",
      "Narbenhernie",
      "Narbenhernie der Bauchwand",
      "Narbenhernie ohne Einklemmung und ohne Gangrän"
    ]
  },
  {
    "code": "K43.3",
    "name": "Parastomale Hernie mit Einklemmung",
    "synonyms": [
      "Inkarzerierte parastomale Hernie",
      "Irreponible parastomale Hernie",
      "Parastomale Hernie mit Einklemmung",
      "Parastomale Hernie mit Einklemmung, ohne Gangrän",
      "Strangulierte parastomale Hernie",
      "Verschluss verursachende parastomale Hernie"
    ]
  },
  {
    "code": "K43.4",
    "name": "Parastomale Hernie mit Gangrän",
    "synonyms": [
      "Parastomale Hernie mit Gangrän"
    ]
  },
  {
    "code": "K43.5",
    "name": "Parastomale Hernie",
    "synonyms": [
      "Parastomale Hernie",
      "Parastomale Hernie ohne Einklemmung und ohne Gangrän"
    ]
  },
  {
    "code": "K43.60",
    "name": "Partiell inkarzerierte epigastrische Hernie",
    "synonyms": [
      "Epigastrische Hernie mit Einklemmung",
      "Inkarzerierte epigastrische Hernie",
      "Irreponible epigastrische Hernie",
      "Partiell inkarzerierte epigastrische Hernie",
      "Verschluss verursachende epigastrische Hernie"
    ]
  },
  {
    "code": "K43.68",
    "name": "Inkarzerierte hypogastrische Hernie",
    "synonyms": [
      "Hypogastrische Hernie mit Einklemmung",
      "Inkarzerierte Mittellinien-Hernie",
      "Inkarzerierte Spieghel-Hernie",
      "Inkarzerierte hypogastrische Hernie",
      "Inkarzerierte subxiphoidale Hernie",
      "Irreponible Mittellinien-Hernie",
      "Irreponible Spieghel-Hernie",
      "Irreponible hypogastrische Hernie",
      "Irreponible subxiphoidale Hernie",
      "Mittellinien-Hernie mit Einklemmung",
      "Spieghel-Hernie mit Einklemmung",
      "Strangulierte Mittellinien-Hernie",
      "Strangulierte Spieghel-Hernie",
      "Strangulierte hypogastrische Hernie",
      "Strangulierte subxiphoidale Hernie",
      "Subxiphoidale Hernie mit Einklemmung",
      "Verschluss verursachende Mittellinien-Hernie",
      "Verschluss verursachende Spieghel-Hernie",
      "Verschluss verursachende hypogastrische Hernie",
      "Verschluss verursachende subxiphoidale Hernie"
    ]
  },
  {
    "code": "K43.69",
    "name": "Bauchwandbruch mit Einklemmung",
    "synonyms": [
      "Bauchwandbruch mit Einklemmung",
      "Hernia ventralis mit Einklemmung",
      "Inkarzerierte Hernia ventralis ohne Gangrän",
      "Irreponible Hernia ventralis",
      "Irreponible Hernia ventralis ohne Gangrän",
      "Irreponibler Bauchwandbruch",
      "Strangulierte Hernia ventralis ohne Gangrän",
      "Verschluss verursachende Hernia ventralis ohne Gangrän"
    ]
  },
  {
    "code": "K43.70",
    "name": "Hernia epigastrica mit Gangrän",
    "synonyms": [
      "Epigastrische Hernie mit Gangrän",
      "Hernia epigastrica mit Gangrän"
    ]
  },
  {
    "code": "K43.78",
    "name": "Hypogastrische Hernie mit Gangrän",
    "synonyms": [
      "Hypogastrische Hernie mit Gangrän",
      "Mittellinien-Hernie mit Gangrän",
      "Spieghel-Hernie mit Gangrän",
      "Subxiphoidale Hernie mit Gangrän"
    ]
  },
  {
    "code": "K43.79",
    "name": "Hernia ventralis mit Gangrän",
    "synonyms": [
      "Bauchwandbruch mit Gangrän",
      "Hernia ventralis gangraenosa",
      "Hernia ventralis mit Gangrän"
    ]
  },
  {
    "code": "K43.90",
    "name": "Epigastrische Hernie",
    "synonyms": [
      "Epigastrische Hernie",
      "Hernia epigastrica"
    ]
  },
  {
    "code": "K43.98",
    "name": "Spieghel-Hernie",
    "synonyms": [
      "Hypogastrische Hernie",
      "Mittellinien-Hernie",
      "Spieghel-Hernie",
      "Subxiphoidale Hernie"
    ]
  },
  {
    "code": "K43.99",
    "name": "Hernia ventralis",
    "synonyms": [
      "Bauchdeckenbruch",
      "Bauchdeckenhernie",
      "Bauchwandbruch",
      "Bauchwandhernie",
      "Eventration",
      "Hernia ventralis",
      "Laparozele"
    ]
  },
  {
    "code": "K44.0",
    "name": "Zwerchfellbruch mit Einklemmung",
    "synonyms": [
      "Hernia diaphragmatica mit Einklemmung",
      "Hiatushernie mit Einklemmung",
      "Inkarzerierte Hernia diaphragmatica ohne Gangrän",
      "Irreponible Hernia diaphragmatica",
      "Irreponible Hernia diaphragmatica ohne Gangrän",
      "Irreponibler Zwerchfellbruch",
      "Strangulierte Hernia diaphragmatica ohne Gangrän",
      "Verschluss verursachende Hernia diaphragmatica ohne Gangrän",
      "Zwerchfellbruch mit Einklemmung"
    ]
  },
  {
    "code": "K44.1",
    "name": "Hernia diaphragmatica mit Gangrän",
    "synonyms": [
      "Hernia diaphragmatica gangraenosa",
      "Hernia diaphragmatica mit Gangrän",
      "Hernia paraoesophagealis mit Gangrän",
      "Hiatushernie mit Gangrän",
      "Zwerchfellbruch mit Gangrän"
    ]
  },
  {
    "code": "K44.9",
    "name": "Hiatushernie",
    "synonyms": [
      "Abdominale Hiatushernie",
      "Axiale Hiatushernie",
      "Bochdalek-Hernie",
      "Diaphragmahernie",
      "Hernia diaphragmatica",
      "Hernia paraoesophagealis",
      "Hiatusgleitbruch",
      "Hiatusgleithernie",
      "Hiatushernie",
      "Hiatusinsuffizienz",
      "Kocher-Volvulus",
      "Larrey-Hernie",
      "Morgagni-Hernie",
      "Paraösophagealhernie",
      "Saint-Trias",
      "Thorakale Hiatushernie",
      "Upside-down-Magen",
      "Zwerchfellbruch",
      "Zwerchfellhernie"
    ]
  },
  {
    "code": "K45.0",
    "name": "Inkarzerierte Hernia abdominalis ohne Gangrän a.n.k.",
    "synonyms": [
      "Inkarzerierte Hernia abdominalis ohne Gangrän a.n.k.",
      "Inkarzerierte Hernia ischiadica ohne Gangrän",
      "Inkarzerierte Hernia lumbalis ohne Gangrän",
      "Inkarzerierte Hernia obturatoria ohne Gangrän",
      "Inkarzerierte Hernia pudendalis ohne Gangrän",
      "Inkarzerierte Hernia retroperitonealis ohne Gangrän",
      "Irreponible Hernia abdominalis ohne Gangrän a.n.k.",
      "Irreponible Hernia ischiadica ohne Gangrän",
      "Irreponible Hernia lumbalis ohne Gangrän",
      "Irreponible Hernia obturatoria ohne Gangrän",
      "Irreponible Hernia pudendalis ohne Gangrän",
      "Irreponible Hernia retroperitonealis ohne Gangrän",
      "Strangulierte Hernia abdominalis ohne Gangrän a.n.k.",
      "Strangulierte Hernia ischiadica ohne Gangrän",
      "Strangulierte Hernia lumbalis ohne Gangrän",
      "Strangulierte Hernia obturatoria ohne Gangrän",
      "Strangulierte Hernia pudendalis ohne Gangrän",
      "Strangulierte Hernia retroperitonealis ohne Gangrän",
      "Verschluss verursachende Hernia abdominalis ohne Gangrän a.n.k.",
      "Verschluss verursachende Hernia ischiadica ohne Gangrän",
      "Verschluss verursachende Hernia lumbalis ohne Gangrän",
      "Verschluss verursachende Hernia obturatoria ohne Gangrän",
      "Verschluss verursachende Hernia pudendalis ohne Gangrän",
      "Verschluss verursachende Hernia retroperitonealis ohne Gangrän"
    ]
  },
  {
    "code": "K45.1",
    "name": "Retroperitonealhernie mit Gangrän",
    "synonyms": [
      "Hernia abdominalis mit Gangrän a.n.k.",
      "Hernia ischiadica mit Gangrän",
      "Hernia lumbalis mit Gangrän",
      "Hernia obturatoria mit Gangrän",
      "Hernia pudendalis mit Gangrän",
      "Hernia retroperitonealis mit Gangrän",
      "Lumbalhernie mit Gangrän",
      "Retroperitonealhernie mit Gangrän"
    ]
  },
  {
    "code": "K45.8",
    "name": "Hernia ischiadica",
    "synonyms": [
      "Hernia dorsalis",
      "Hernia ischiadica",
      "Hernia littreana",
      "Hernia lumbalis",
      "Hernia obturatoria",
      "Hernia pudendalis",
      "Hernia retroperitonealis",
      "Hernia vaginolabialis",
      "Lendenhernie",
      "Littré-Hernie",
      "Lumbalhernie",
      "Obturatoriushernie",
      "Retroperitonealhernie"
    ]
  },
  {
    "code": "K46.0",
    "name": "Hernie mit Einklemmung",
    "synonyms": [
      "Abdominalhernie mit Einklemmung ohne Gangrän",
      "Eingeklemmter Bruch",
      "Eingeweidebruch mit Einklemmung",
      "Hernia abdominalis mit Einklemmung",
      "Hernia incarcerata",
      "Hernie mit Darmstrangulation",
      "Hernie mit Einklemmung",
      "Hernie mit Intestinumstrangulation",
      "Hernie mit Kotverschluss",
      "Hernie mit Magenstrangulation",
      "Hernie mit Strangulation",
      "Hernieninkarzeration",
      "Inkarzerierte Enterozele ohne Gangrän",
      "Inkarzerierte Epiplozele ohne Gangrän",
      "Inkarzerierte Hernie",
      "Inkarzerierte Hernie ohne Gangrän",
      "Inkarzerierte interstitielle Hernie ohne Gangrän",
      "Inkarzerierte intestinale Hernie ohne Gangrän",
      "Inkarzerierte intraabdominale Hernie ohne Gangrän",
      "Invaginationshernie",
      "Irreponible Enterozele ohne Gangrän",
      "Irreponible Epiplozele ohne Gangrän",
      "Irreponible Hernia abdominalis",
      "Irreponible Hernie",
      "Irreponible Hernie ohne Gangrän",
      "Irreponible interstitielle Hernie ohne Gangrän",
      "Irreponible intestinale Hernie ohne Gangrän",
      "Irreponible intraabdominale Hernie ohne Gangrän",
      "Irreponibler Eingeweidebruch",
      "Obstruktive Hernie",
      "Strangulierte Enterozele ohne Gangrän",
      "Strangulierte Epiplozele ohne Gangrän",
      "Strangulierte Hernie ohne Gangrän",
      "Strangulierte interstitielle Hernie ohne Gangrän",
      "Strangulierte intestinale Hernie ohne Gangrän",
      "Strangulierte intraabdominale Hernie ohne Gangrän",
      "Verschluss verursachende Enterozele ohne Gangrän",
      "Verschluss verursachende Epiplozele ohne Gangrän",
      "Verschluss verursachende Hernie ohne Gangrän",
      "Verschluss verursachende interstitielle Hernie ohne Gangrän",
      "Verschluss verursachende intestinale Hernie ohne Gangrän",
      "Verschluss verursachende intraabdominale Hernie ohne Gangrän"
    ]
  },
  {
    "code": "K46.1",
    "name": "Abdominalhernie mit Gangrän",
    "synonyms": [
      "Abdominalhernie mit Gangrän",
      "Darmstrangulation bei Hernie mit Gangrän",
      "Enterozele mit Gangrän",
      "Epiplozele mit Gangrän",
      "Gangränöse Hernie mit Einklemmung",
      "Gangränöse Hernie mit Inkarzeration",
      "Gangränöse Hernie mit Magenstrangulation",
      "Gangränöse Hernienstrangulation",
      "Gangränöse irreponible Hernie",
      "Gangränöse obstruktive Hernie",
      "Hernia intestinalis mit Gangrän",
      "Hernie mit Gangrän",
      "Interstitielle Hernie mit Gangrän",
      "Intestinale Hernie mit Gangrän",
      "Intestinalstrangulation mit Hernie mit Gangrän",
      "Intraabdominale Hernie mit Gangrän"
    ]
  },
  {
    "code": "K46.9",
    "name": "Hernia omentalis",
    "synonyms": [
      "Abdominalhernie",
      "Darmbruch",
      "Eingeweidebruch",
      "Enterozele",
      "Epiplozele",
      "Erworbene Hernie",
      "Hernia - s.a. Hernie",
      "Hernia abdominalis",
      "Hernia omentalis",
      "Hernie - s.a. Hernia",
      "Interstitielle Hernie",
      "Intestinale Hernie",
      "Intraabdominale Hernie",
      "Netzbruch",
      "Rezidivierende Hernie"
    ]
  },
  {
    "code": "K50.0",
    "name": "Crohn-Krankheit des Dünndarmes",
    "synonyms": [
      "Crohn-Ileitis",
      "Crohn-Krankheit des Duodenums",
      "Crohn-Krankheit des Dünndarmes",
      "Crohn-Krankheit des Ileums",
      "Crohn-Krankheit des Jejunums",
      "Enteritis regionalis des Duodenums",
      "Enteritis regionalis des Ileums",
      "Enteritis regionalis des Jejunums",
      "Ileitis diffusa",
      "Ileitis regionalis",
      "Ileitis segmentalis",
      "Ileitis terminalis",
      "Ileitis ulcerosa chronica stenosans",
      "Morbus Crohn des Dünndarmes",
      "Regionale Dünndarmenteritis",
      "Regionale Ileumentzündung",
      "Terminale Ileumentzündung"
    ]
  },
  {
    "code": "K50.1",
    "name": "Crohn-Krankheit des Dickdarmes",
    "synonyms": [
      "Colitis granulomatosa",
      "Colitis granulomatosa regionalis",
      "Colitis gravis regionalis",
      "Colitis regionalis",
      "Crohn-Krankheit des Dickdarmes",
      "Crohn-Krankheit des Kolons",
      "Crohn-Krankheit des Rektums",
      "Enteritis regionalis des Dickdarmes",
      "Enteritis regionalis des Kolons",
      "Enteritis regionalis des Rektums",
      "Granulomatöse Kolitis",
      "Kolonenteritis",
      "Morbus Crohn des Dickdarmes",
      "Morbus Crohn des Kolons",
      "Morbus Crohn des Rektums"
    ]
  },
  {
    "code": "K50.80",
    "name": "Crohn-Krankheit des Magens",
    "synonyms": [
      "Crohn-Krankheit des Magens"
    ]
  },
  {
    "code": "K50.81",
    "name": "Crohn-Krankheit der Speiseröhre",
    "synonyms": [
      "Crohn-Krankheit der Speiseröhre"
    ]
  },
  {
    "code": "K50.82",
    "name": "Crohn-Krankheit des Dünndarmes und des Dickdarmes",
    "synonyms": [
      "Crohn-Krankheit der Speiseröhre und des Magen-Darm-Traktes, mehrere Teilbereiche betreffend",
      "Crohn-Krankheit des Dünndarmes und des Dickdarmes",
      "Crohn-Krankheit des Dünndarmes und des Dickdarmes mit Abszess",
      "Enteritis regionalis des Dünndarmes und des Dickdarmes"
    ]
  },
  {
    "code": "K50.9",
    "name": "Crohn-Krankheit",
    "synonyms": [
      "Crohn-Krankheit",
      "Crohn-Krankheit mit Abszess",
      "Enteritis regionalis",
      "Enteritis segmentalis",
      "Granulomatöse Enteritis",
      "Ileocolitis regionalis",
      "Morbus Crohn",
      "Regionale Enteritis",
      "Regionale Ileokolitis"
    ]
  },
  {
    "code": "K51.0",
    "name": "Ulzeröse Enterokolitis",
    "synonyms": [
      "Backwash-Ileitis",
      "Chronische Enterocolitis ulcerosa",
      "Chronische Ileocolitis ulcerosa",
      "Chronische ulzeröse Pankolitis",
      "Enterocolitis ulcerosa",
      "Ileocolitis ulcerosa",
      "Subtotale ulzeröse chronische Kolitis",
      "Ulzeröse Enterokolitis",
      "Ulzeröse Ileokolitis"
    ]
  },
  {
    "code": "K51.2",
    "name": "Ulzeröse Proktitis",
    "synonyms": [
      "Chronische Proktitis ulcerosa",
      "Proktitis ulcerosa",
      "Ulzeröse Proktitis"
    ]
  },
  {
    "code": "K51.3",
    "name": "Ulzeröse Rektosigmoiditis",
    "synonyms": [
      "Chronische Rectosigmoiditis ulcerosa",
      "Chronische ulzeröse Proktosigmoiditis",
      "Idiopathische Proktokolitis",
      "Proktokolitis",
      "Rectosigmoiditis ulcerosa",
      "Rektokolitis",
      "Schleimhautproktokolitis",
      "Ulzeröse Rektosigmoiditis"
    ]
  },
  {
    "code": "K51.4",
    "name": "Pseudopolyposis coli",
    "synonyms": [
      "Colitis polyposa",
      "Entzündeter Kolonpolyp",
      "Inflammatorische Polypen des Kolons",
      "Pseudopolyposis coli"
    ]
  },
  {
    "code": "K51.5",
    "name": "Linksseitige Kolitis",
    "synonyms": [
      "Hemikolitis, links",
      "Linksseitige Kolitis"
    ]
  },
  {
    "code": "K51.9",
    "name": "Colitis ulcerosa",
    "synonyms": [
      "Chronische Colitis ulcerosa",
      "Chronische Enteritis ulcerosa",
      "Chronische Gastroenteritis ulcerosa",
      "Chronische ulzeröse Enteritis",
      "Colitis chronica purulenta",
      "Colitis ulcerosa",
      "Enteritis ulcerosa",
      "Gastroenteritis ulcerosa",
      "UC [Colitis ulcerosa]"
    ]
  },
  {
    "code": "K52.0",
    "name": "Bestrahlungsenteritis",
    "synonyms": [
      "Bestrahlungsenteritis",
      "Bestrahlungskolitis",
      "Gastroenteritis durch Strahleneinwirkung",
      "Kolitis durch Strahleneinwirkung",
      "Strahlenkolitis"
    ]
  },
  {
    "code": "K52.1",
    "name": "Toxische Gastroenteritis",
    "synonyms": [
      "Medikamenteninduzierte Diarrhoe",
      "Medikamenteninduzierte Gastroenteritis",
      "Medikamenteninduzierte Kolitis",
      "Postantibiotische Diarrhoe",
      "Toxische Diarrhoe",
      "Toxische Enteritis",
      "Toxische Gastroenteritis",
      "Toxische Kolitis"
    ]
  },
  {
    "code": "K52.2",
    "name": "Allergische Gastroenteritis",
    "synonyms": [
      "Allergische Diarrhoe",
      "Allergische Enteritis",
      "Allergische Gastroenteritis",
      "Allergische Kolitis",
      "Allergische gastrointestinale Reaktion durch Nahrungsmittel",
      "Diarrhoe durch Nahrungsmittelallergie",
      "Diätetische Diarrhoe",
      "Diätetische Enteritis",
      "Diätetische Gastroenteritis",
      "Diätetische Kolitis",
      "Enteritis durch Nahrungsmittelallergie",
      "Gastroenteritis durch Nahrungsmittelallergie",
      "Gastrointestinale Allergie",
      "Gastrointestinale Hypersensibilität",
      "Hypersensibilität des Magens",
      "Kolitis durch Nahrungsmittelallergie"
    ]
  },
  {
    "code": "K52.30",
    "name": "Pancolitis indeterminata",
    "synonyms": [
      "Pancolitis indeterminata",
      "Subtotale Colitis indeterminata"
    ]
  },
  {
    "code": "K52.31",
    "name": "Linksseitige Colitis indeterminata",
    "synonyms": [
      "Linksseitige Colitis indeterminata"
    ]
  },
  {
    "code": "K52.32",
    "name": "Colitis indeterminata des Rektosigmoids",
    "synonyms": [
      "Colitis indeterminata des Rektosigmoids"
    ]
  },
  {
    "code": "K52.38",
    "name": "Colitis indeterminata",
    "synonyms": [
      "Colitis indeterminata"
    ]
  },
  {
    "code": "K52.8",
    "name": "Kachektische Diarrhoe a.n.k.",
    "synonyms": [
      "ALPI-assoziierte chronisch-entzündliche Darmkrankheit",
      "Autoimmune Enteropathie Typ 3",
      "Chronische Diarrhoe mit Zottenatrophie",
      "Chronische infantile Diarrhoe durch Guanylatcyclase-2C-Überaktivität",
      "Colitis cystica superficialis",
      "Diversionskolitis",
      "Eosinophile Gastritis",
      "Eosinophile Gastroenteritis",
      "Eosinophile Kolitis",
      "Interleukin-10-assoziierte früh beginnende chronisch-entzündliche Darmerkrankung",
      "Kachektische Diarrhoe a.n.k.",
      "Kollagene Kolitis",
      "Lymphozytäre Kolitis",
      "Mikroskopische Kolitis",
      "Mikroskopische kollagene Kolitis",
      "Mikroskopische lymphozytäre Kolitis",
      "NK-Zellen-Enteropathie",
      "Primäre autoimmune Enteropathie",
      "Segmentale Enteritis",
      "TRIM22-assoziierte chronisch-entzündliche Darmkrankheit"
    ]
  },
  {
    "code": "K52.9",
    "name": "Chronische Gastroenteritis",
    "synonyms": [
      "CED [Chronische entzündliche Darmerkrankung]",
      "Chronische Diarrhoe",
      "Chronische Enteritis",
      "Chronische Enterokolitis",
      "Chronische Gastroenteritis",
      "Chronische Ileitis",
      "Chronische Ileokolitis",
      "Chronische Kolitis",
      "Chronische entzündliche Darmerkrankung",
      "Nichtinfektiöse Diarrhoe",
      "Nichtinfektiöse Enteritis",
      "Nichtinfektiöse Gastroenteritis",
      "Nichtinfektiöse Gastrojejunitis",
      "Nichtinfektiöse Ileitis",
      "Nichtinfektiöse Jejunitis",
      "Nichtinfektiöse Kolitis",
      "Nichtinfektiöse Sigmoiditis",
      "Spastische Enterokolitis",
      "Vermutlich nichtinfektiöse Enteritis",
      "Vermutlich nichtinfektiöse Gastrojejunitis",
      "Vermutlich nichtinfektiöse Jejunitis",
      "Vermutlich nichtinfektiöse Kolitis"
    ]
  },
  {
    "code": "K55.0",
    "name": "Akute ischämische Enteritis",
    "synonyms": [
      "Akute Darmgefäßkrankheit",
      "Akute Darmischämie",
      "Akute Darmnekrose",
      "Akute Dünndarmischämie",
      "Akute Intestinumnekrose",
      "Akute Ischämie des Intestinums",
      "Akute Ischämie des Mesenterium",
      "Akute Mesenterialarterieninsuffizienz",
      "Akute Verschlusskrankheit der Mesenterialarterien",
      "Akute fulminante ischämische Kolitis",
      "Akute ischämische Enteritis",
      "Akute ischämische Enterokolitis",
      "Akute ischämische Kolitis",
      "Akute mesenteriale Gefäßinsuffizienz",
      "Akute vaskuläre Insuffizienz des Mesenteriums",
      "Akuter Darminfarkt",
      "Akuter Intestinuminfarkt",
      "Akuter Verschluss der Arteria mesenterica",
      "Akuter Verschluss der Mesenterialarterien",
      "Arterielle Mesenterialgefäßthrombose",
      "Arterieller Mesenterialinfarkt",
      "Darmarterienembolie mit Gangrän",
      "Darmarterienthrombose",
      "Darmbrand",
      "Darmgangrän",
      "Darmgefäßinfarkt",
      "Darminfarkt",
      "Darmnekrose",
      "Darmthrombose mit Gangrän",
      "Darmvenenembolie mit Gangrän",
      "Darmwandgangrän",
      "Darmwandnekrose",
      "Dickdarmnekrose",
      "Dünndarmgangrän",
      "Dünndarminfarkt",
      "Dünndarmnekrose",
      "Embolie der Arteria mesenterica",
      "Embolie der Arteria mesenterica superior",
      "Embolie eines Mesenterialgefäßes",
      "Enterocolitis fulminans",
      "Fulminante ischämische Enterokolitis",
      "Hämorrhagische Darmnekrose",
      "Hämorrhagische Intestinumnekrose",
      "Ileumnekrose",
      "Infarkt eines Mesenterialgefäßes",
      "Intestinale Gangrän",
      "Intestinalthrombose mit Gangrän",
      "Intestinumnekrose",
      "Kolongangrän",
      "Koloninfarkt",
      "Kolonnekrose",
      "Massive hämorrhagische Gangrän des Intestinums",
      "Mesenterialarterienembolie",
      "Mesenterialarterienembolie mit Gangrän",
      "Mesenterialarterienthrombose",
      "Mesenterialembolie",
      "Mesenterialgangrän",
      "Mesenterialgefäßverschluss",
      "Mesenterialinfarkt",
      "Mesenterialischämie",
      "Mesenterialnekrose",
      "Mesenterialthrombose",
      "Mesenterialvenenembolie",
      "Mesenterialvenenembolie mit Gangrän",
      "Mesenterialvenenthrombose",
      "Omentalthrombose mit Gangrän",
      "Omentuminfarkt",
      "Omentumnekrose",
      "Peritoneumnekrose",
      "Subakute ischämische Kolitis",
      "Thrombose der Arteria mesenterica superior",
      "Thrombose mesenterialer Arterien mit Gangrän",
      "Transmuraler Darminfarkt"
    ]
  },
  {
    "code": "K55.1",
    "name": "Chronische ischämische Enterokolitis",
    "synonyms": [
      "Angina abdominalis",
      "Arteria-mesenterica-superior-Syndrom",
      "Arterielle mesenteriale Durchblutungsstörung",
      "Arteriosklerose einer Darmarterie",
      "Atherosklerose des Truncus coeliacus",
      "Chronische Darmgefäßstörung",
      "Chronische Darmischämie",
      "Chronische Ischämie des Intestinums",
      "Chronische Ischämie des Mesenterium",
      "Chronische Mesenterialarterieninsuffizienz",
      "Chronische Verschlusskrankheit von Mesenterialarterien",
      "Chronische ischämische Enteritis",
      "Chronische ischämische Enterokolitis",
      "Chronische ischämische Kolitis",
      "Chronische mesenteriale Arteriosklerose",
      "Chronische mesenteriale Gefäßinsuffizienz",
      "Chronische vaskuläre Insuffizienz des Mesenteriums",
      "Chronischer Verschluss von Mesenterialarterien",
      "Ischämische Darmstriktur",
      "Ischämische intestinale Striktur",
      "Mesenterialarterieninsuffizienz",
      "Mesenterialarteriensyndrom",
      "Mesenteriale Arteriosklerose",
      "Mesenteriale Atherosklerose",
      "Mesenteriale Gefäßinsuffizienz",
      "Mesenteriale Venenstenose",
      "Vaskuläre Insuffizienz des Mesenterium"
    ]
  },
  {
    "code": "K55.21",
    "name": "Angiodysplasie des Kolons",
    "synonyms": [
      "Angiodysplasie des Darmes",
      "Angiodysplasie des Kolons",
      "Gastrointestinale Angiodysplasie"
    ]
  },
  {
    "code": "K55.22",
    "name": "Angiodysplasie des Kolons mit Blutung",
    "synonyms": [
      "Angiodysplasie des Kolons mit Blutung"
    ]
  },
  {
    "code": "K55.31",
    "name": "Angiodysplasie des Dünndarmes",
    "synonyms": [
      "Angiodysplasie des Dünndarmes",
      "Angiodysplasie des Dünndarmes ohne Angabe einer Blutung",
      "Angiodysplasie des Jejunums"
    ]
  },
  {
    "code": "K55.32",
    "name": "Angiodysplasie des Dünndarmes mit Blutung",
    "synonyms": [
      "Angiodysplasie des Dünndarmes mit Blutung"
    ]
  },
  {
    "code": "K55.9",
    "name": "Ischämische Enterokolitis",
    "synonyms": [
      "Arterielle Durchblutungsstörung des Darmes",
      "Arterielle Durchblutungsstörung des Dünndarmes",
      "Darmischämie",
      "Darmwandischämie",
      "Dickdarmischämie",
      "Durchblutungsstörung des Darmes",
      "Dünndarmischämie",
      "Gefäßkrankheit des Darmes",
      "Intestinale Ischämie",
      "Ischämie des Colon ascendens",
      "Ischämie des Intestinums",
      "Ischämische Enteritis",
      "Ischämische Enterokolitis",
      "Ischämische Kolitis",
      "Kolonischämie",
      "Vaskuläre Darminsuffizienz"
    ]
  },
  {
    "code": "K56.0",
    "name": "Atonischer Ileus",
    "synonyms": [
      "ACPO [Acut colonic pseudo-obstruction]",
      "Adynamische Darmobstruktion",
      "Adynamischer Darmverschluss",
      "Akute intestinale Pseudoobstruktion",
      "Akute kolonische Pseudoobstruktion",
      "Atonischer Ileus",
      "Darmlähmung",
      "Darmparalyse",
      "Darmparese",
      "Dünndarmparalyse",
      "Intestinalparalyse a.n.k.",
      "Intestinalparese",
      "Kolonparalyse a.n.k.",
      "Kolonparese",
      "Neurogene Darmobstruktion",
      "Neurogener Ileus",
      "Ogilvie-Syndrom",
      "Paralytischer Darmverschluss",
      "Paralytischer Dickdarmverschluss",
      "Paralytischer Dünndarmileus",
      "Paralytischer Dünndarmverschluss",
      "Paralytischer Ileumverschluss",
      "Paralytischer Ileus",
      "Paralytischer Intestinumverschluss",
      "Paralytischer Jejunumverschluss",
      "Paralytischer Kolonverschluss",
      "Paralytischer Zäkumverschluss",
      "Pseudoobstruktionsileus"
    ]
  },
  {
    "code": "K56.1",
    "name": "Koloninvagination",
    "synonyms": [
      "Darmeinscheidung",
      "Darmeinstülpung",
      "Darminvagination",
      "Dünndarminvagination",
      "Intestinale Invagination",
      "Intussuszeption",
      "Intussuszeption des Darmes",
      "Intussuszeption des Intestinums",
      "Intussuszeption des Kolons",
      "Intussuszeption des Rektums",
      "Invagination",
      "Invagination des Intestinums",
      "Invagination des Rektums",
      "Invaginationsileus",
      "Koloneinscheidung",
      "Koloninvagination"
    ]
  },
  {
    "code": "K56.2",
    "name": "Darmverschlingung",
    "synonyms": [
      "Achsendrehung der Sigmaflexur",
      "Achsendrehung des Intestinums",
      "Achsendrehung des Kolons",
      "Achsendrehung des Mesenteriums",
      "Achsendrehung des Omentums",
      "Achsendrehung des Zäkums",
      "Darmachsendrehung",
      "Darmobstruktion durch Volvulus",
      "Darmstrangulation",
      "Darmtorsion",
      "Darmverknotung",
      "Darmverschlingung",
      "Darmverschluss durch Volvulus",
      "Darmvolvulus",
      "Duodenaltorsion",
      "Dünndarmvolvulus",
      "Ileumvolvulus",
      "Intestinalstrangulation",
      "Intestinaltorsion",
      "Kolonstrangulation",
      "Kolontorsion",
      "Sigmavolvulus",
      "Strangileus",
      "Strangulation des Mesenteriums",
      "Strangulation des Omentums",
      "Strangulationsileus",
      "Torsion des Mesenteriums",
      "Torsion des Omentums",
      "Torsionsileus",
      "Volvulus",
      "Volvulus des Intestinums",
      "Volvulus des Kolons"
    ]
  },
  {
    "code": "K56.3",
    "name": "Gallensteinileus",
    "synonyms": [
      "Darmeinklemmung durch Gallenstein",
      "Darmobstruktion durch Gallenstein",
      "Darmverschluss durch Gallenstein",
      "Gallensteinileus"
    ]
  },
  {
    "code": "K56.4",
    "name": "Darmobturation",
    "synonyms": [
      "Darmeinklemmung",
      "Darmobturation",
      "Darmstein",
      "Dickdarmeinklemmung",
      "Eingeklemmter Kotstein",
      "Einklemmung eines Enteroliths",
      "Einklemmung von Fäzes",
      "Enterolith",
      "Enterolithiasis",
      "Faekulom",
      "Fäkalieneinklemmung",
      "Ileus obturatorius",
      "Kolonimpaktion",
      "Kolonobturation",
      "Koprolith",
      "Koprolithiasis",
      "Koprostase",
      "Koteinklemmung",
      "Kotimpaktion",
      "Kotobstruktion",
      "Kotstauung",
      "Kotstein",
      "Kotverschluss",
      "Obturationsileus"
    ]
  },
  {
    "code": "K56.5",
    "name": "Intestinale Adhäsion mit Ileus",
    "synonyms": [
      "Adhäsionsileus",
      "Bauchfelladhäsion mit Ileus",
      "Bridenileus",
      "Darmverschluss bei Adhäsion",
      "Darmverschluss durch Briden",
      "Darmverwachsung mit Verschluss",
      "Dünndarmbridenileus",
      "Ileus durch Bauchfellverwachsung",
      "Ileus durch Peritonealverwachsung",
      "Intestinale Adhäsion mit Ileus",
      "Intestinale Adhäsion mit Obstruktion",
      "Obstruktiver Gewebestrang des Darmes",
      "Obstruktiver Gewebestrang des Peritoneums",
      "Peritoneale Adhäsion mit Darmverschluss",
      "Peritoneumadhäsion mit Ileus",
      "Postinfektiöse Darmadhäsion mit Ileus"
    ]
  },
  {
    "code": "K56.6",
    "name": "Obstruktionsileus a.n.k.",
    "synonyms": [
      "Darmabknickung",
      "Darmknick",
      "Darmkompression",
      "Darmkonstriktion",
      "Darmkontraktur",
      "Darmobstruktion",
      "Darmokklusion",
      "Darmstenose",
      "Darmstriktur",
      "Darmverschluss mit Darmgangrän",
      "Darmverschluss mit Gangrän des Intestinums",
      "Darmverschluss mit Gangrän des Mesenteriums",
      "Dickdarmstenose",
      "Dickdarmstriktur",
      "Dünndarmstenose",
      "Dünndarmstriktur",
      "Enterostenose",
      "Gastrointestinale Obstruktion",
      "Gärungsileus",
      "Ileumabknickung",
      "Ileumknick",
      "Ileumobstruktion",
      "Ileumstenose",
      "Ileumstriktur",
      "Intestinale Obstruktion",
      "Intestinalknick",
      "Intestinalokklusion",
      "Intestinalstenose",
      "Intestinalstriktur",
      "Intestinumabknickung",
      "Jejunumobstruktion",
      "Jejunumstenose",
      "Jejunumstriktur",
      "Kolonobstruktion",
      "Kolonokklusion",
      "Kolonstenose",
      "Kolonstriktur",
      "Mechanische Darmobstruktion",
      "Mechanischer Darmverschluss",
      "Mechanischer Dickdarmverschluss",
      "Mechanischer Dünndarmileus",
      "Mechanischer Dünndarmverschluss",
      "Mechanischer Ileumverschluss",
      "Mechanischer Ileus a.n.k.",
      "Mechanischer Intestinumverschluss",
      "Mechanischer Jejunumverschluss",
      "Mechanischer Kolonverschluss",
      "Mechanischer Zäkumverschluss",
      "Obstruktion der Übergangsstelle des Colon sigmoideum in das Rektum",
      "Obstruktionsileus a.n.k.",
      "Paroxysmale Darmobstruktion",
      "Postinfektiöse Darmobstruktion",
      "Rektosigmoidale Obstruktion",
      "Rektosigmoidale Striktur",
      "Sigmaeinengung",
      "Sigmastenose",
      "Sigmoideumobstruktion",
      "Striktur der Flexura coli sigmoidea",
      "Striktur der Sigmaflexur",
      "Zäkumobstruktion",
      "Zäkumstriktur"
    ]
  },
  {
    "code": "K56.7",
    "name": "Ileus",
    "synonyms": [
      "Darmileus",
      "Darmverschluss",
      "Dickdarmileus",
      "Dickdarmverschluss",
      "Dünndarmileus",
      "Dünndarmverschluss",
      "Gastrointestinaler Verschluss",
      "Ileumverschluss",
      "Ileus",
      "Ileus des Intestinums",
      "Ileus des Kolons",
      "Intestinumverschluss",
      "Jejunumverschluss",
      "Kolonverschluss",
      "Präileus",
      "Rektumverschluss",
      "Subileus",
      "Zäkumverschluss"
    ]
  },
  {
    "code": "K57.02",
    "name": "Dünndarmdivertikulitis mit Abszess",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes mit Perforation und Abszess",
      "Dünndarmdivertikulitis mit Abszess",
      "Dünndarmdivertikulitis mit Perforation",
      "Dünndarmdivertikulitis mit Peritonitis"
    ]
  },
  {
    "code": "K57.03",
    "name": "Dünndarmdivertikulitis mit Abszess mit Blutung",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes mit Perforation, Abszess und Blutung",
      "Dünndarmdivertikulitis mit Abszess mit Blutung",
      "Dünndarmdivertikulitis mit Perforation mit Blutung",
      "Dünndarmdivertikulitis mit Peritonitis mit Blutung"
    ]
  },
  {
    "code": "K57.10",
    "name": "Taschenbildung des Dünndarmes",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes",
      "Duodenaldivertikel",
      "Duodenaldivertikulose",
      "Dünndarmdivertikel",
      "Dünndarmdivertikulose",
      "Ileumdivertikel",
      "Ileumdivertikulose",
      "Jejunale Divertikel",
      "Jejunumdivertikel",
      "Jejunumdivertikulose",
      "Taschenbildung des Dünndarmes"
    ]
  },
  {
    "code": "K57.11",
    "name": "Dünndarmdivertikulose mit Blutung",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes mit Blutung",
      "Dünndarmdivertikulose mit Blutung"
    ]
  },
  {
    "code": "K57.12",
    "name": "Duodenaldivertikulitis",
    "synonyms": [
      "Duodenaldivertikulitis",
      "Dünndarmdivertikulitis",
      "Ileumdivertikulitis",
      "Jejunumdivertikulitis"
    ]
  },
  {
    "code": "K57.13",
    "name": "Dünndarmdivertikulitis mit Blutung",
    "synonyms": [
      "Dünndarmdivertikulitis mit Blutung"
    ]
  },
  {
    "code": "K57.22",
    "name": "Perforation eines Sigmadivertikels",
    "synonyms": [
      "Dickdarmdivertikulitis mit Abszess",
      "Dickdarmdivertikulitis mit Perforation",
      "Dickdarmdivertikulitis mit Perforation und Abszess",
      "Divertikelkrankheit des Dickdarmes mit Perforation und Abszess",
      "Divertikelperforation des Dickdarmes",
      "Kolondivertikulitis mit Peritonitis",
      "Perforation eines Sigmadivertikels",
      "Perforation eines Zäkumdivertikels",
      "Perforierte Sigmadivertikulitis",
      "Sigmadivertikulitis mit Perforation"
    ]
  },
  {
    "code": "K57.23",
    "name": "Kolondivertikulitis mit Peritonitis und Blutung",
    "synonyms": [
      "Dickdarmdivertikulitis mit Abszess und Blutung",
      "Dickdarmdivertikulitis mit Perforation und Blutung",
      "Divertikelkrankheit des Dickdarmes mit Perforation, Abszess und Blutung",
      "Kolondivertikulitis mit Peritonitis und Blutung"
    ]
  },
  {
    "code": "K57.30",
    "name": "Sigmadivertikel",
    "synonyms": [
      "Dickdarmdivertikulose",
      "Dickdarmdivertikulose ohne Perforation oder Abszess",
      "Divertikelkrankheit des Dickdarmes",
      "Kolondivertikel",
      "Kolondivertikulose",
      "Rektosigmoidales Divertikel",
      "Rektumdivertikel",
      "Rektumdivertikulose",
      "Sigmadivertikel",
      "Sigmadivertikulose",
      "Zäkumdivertikel",
      "Zäkumdivertikulitis",
      "Zäkumdivertikulose"
    ]
  },
  {
    "code": "K57.31",
    "name": "Dickdarmdivertikulose mit Blutung",
    "synonyms": [
      "Dickdarmdivertikulose mit Blutung",
      "Divertikelkrankheit des Dickdarmes mit Blutung",
      "Kolondivertikulose mit Blutung"
    ]
  },
  {
    "code": "K57.32",
    "name": "Kolondivertikulitis",
    "synonyms": [
      "Dickdarmdivertikulitis",
      "Kolondivertikulitis",
      "Rektumdivertikulitis",
      "Sigmadivertikulitis"
    ]
  },
  {
    "code": "K57.33",
    "name": "Kolondivertikulitis mit Blutung",
    "synonyms": [
      "Dickdarmdivertikulitis mit Blutung",
      "Kolondivertikulitis mit Blutung"
    ]
  },
  {
    "code": "K57.42",
    "name": "Divertikulitis des Dünndarmes und des Dickdarmes mit Perforation",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes und des Dickdarmes mit Perforation und Abszess",
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Abszess",
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Perforation",
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Peritonitis"
    ]
  },
  {
    "code": "K57.43",
    "name": "Divertikulitis des Dünndarmes und des Dickdarmes mit Perforation und mit Blutung",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes und des Dickdarmes mit Perforation, Abszess und mit Blutung",
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Abszess und mit Blutung",
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Perforation und mit Blutung",
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Peritonitis mit Blutung"
    ]
  },
  {
    "code": "K57.50",
    "name": "Divertikulose des Dünndarmes und des Dickdarmes",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes und des Dickdarmes",
      "Divertikulose des Dünndarmes und des Dickdarmes"
    ]
  },
  {
    "code": "K57.51",
    "name": "Divertikulose des Dünndarmes und des Dickdarmes mit Blutung",
    "synonyms": [
      "Divertikelkrankheit des Dünndarmes und des Dickdarmes mit Blutung",
      "Divertikulose des Dünndarmes und des Dickdarmes mit Blutung"
    ]
  },
  {
    "code": "K57.52",
    "name": "Divertikulitis des Dünndarmes und des Dickdarmes",
    "synonyms": [
      "Divertikulitis des Dünndarmes und des Dickdarmes"
    ]
  },
  {
    "code": "K57.53",
    "name": "Divertikulitis des Dünndarmes und des Dickdarmes mit Blutung",
    "synonyms": [
      "Divertikulitis des Dünndarmes und des Dickdarmes mit Blutung"
    ]
  },
  {
    "code": "K57.82",
    "name": "Divertikelperforation",
    "synonyms": [
      "Darmdivertikulitis mit Abszess",
      "Darmdivertikulitis mit Perforation",
      "Darmdivertikulitis mit Peritonitis",
      "Divertikelkrankheit des Darmes mit Perforation und Abszess",
      "Divertikelperforation",
      "Ruptur eines Darmdivertikels",
      "Ruptur eines Divertikels des Intestinums"
    ]
  },
  {
    "code": "K57.83",
    "name": "Darmdivertikulitis mit Perforation mit Blutung",
    "synonyms": [
      "Darmdivertikulitis mit Abszess mit Blutung",
      "Darmdivertikulitis mit Perforation mit Blutung",
      "Darmdivertikulitis mit Peritonitis mit Blutung",
      "Divertikelkrankheit des Darmes mit Perforation, Abszess und mit Blutung"
    ]
  },
  {
    "code": "K57.90",
    "name": "Darmdivertikulose",
    "synonyms": [
      "Darmdivertikel",
      "Darmdivertikulose",
      "Darmdivertikulose ohne Perforation",
      "Divertikel",
      "Divertikelkrankheit des Darmes",
      "Divertikulose"
    ]
  },
  {
    "code": "K57.91",
    "name": "Darmdivertikulose mit Blutung",
    "synonyms": [
      "Darmdivertikulose mit Blutung"
    ]
  },
  {
    "code": "K57.92",
    "name": "Darmdivertikulitis",
    "synonyms": [
      "Akute Divertikulitis",
      "Darmdivertikulitis",
      "Divertikelentzündung",
      "Divertikulitis",
      "Multiple Divertikel",
      "Multiple Divertikulitis",
      "Multiple Divertikulose",
      "Peridivertikulitis",
      "Peridivertikulitis des Darmes"
    ]
  },
  {
    "code": "K57.93",
    "name": "Darmdivertikulitis mit Blutung",
    "synonyms": [
      "Darmdivertikulitis mit Blutung"
    ]
  },
  {
    "code": "K58.1",
    "name": "Colon irritabile mit Diarrhoe",
    "synonyms": [
      "Colon irritabile mit Diarrhoe",
      "Darmirritabilität mit Diarrhoe",
      "IBS-D [Irritable bowel syndrome with predominant diarrhoea]",
      "Irritable bowel syndrome with predominant diarrhoea",
      "Kolonirritabilität mit Diarrhoe",
      "Kolonspasmus mit Diarrhoe",
      "RDS-D [Reizdarmsyndrom, Diarrhoe-prädominant]",
      "Reizdarm mit Diarrhoe",
      "Reizdarmsyndrom mit Diarrhoe",
      "Reizdarmsyndrom, Diarrhoe-prädominant",
      "Reizkolon mit Diarrhoe",
      "Spastische Kolitis mit Diarrhoe",
      "Syndrom des Colon irritabile mit Diarrhoe",
      "Zäkumspasmus mit Diarrhoe"
    ]
  },
  {
    "code": "K58.2",
    "name": "Reizdarmsyndrom, Obstipations-prädominant",
    "synonyms": [
      "IBS-C [Irritable bowel syndrome with predominant constipation]",
      "Irritable bowel syndrome with predominant constipation",
      "RDS-O [Reizdarmsyndrom, Obstipations-prädominant]",
      "Reizdarmsyndrom, Obstipations-prädominant"
    ]
  },
  {
    "code": "K58.3",
    "name": "Reizdarmsyndrom mit wechselnden Stuhlgewohnheiten",
    "synonyms": [
      "IBS-M [Irritable bowel syndrome with mixed bowel habits]",
      "Irritable bowel syndrome with mixed bowel habits",
      "RDS-M [Reizdarmsyndrom mit gemischten Stuhlgewohnheiten]",
      "Reizdarmsyndrom mit gemischten Stuhlgewohnheiten",
      "Reizdarmsyndrom mit wechselnden Stuhlgewohnheiten"
    ]
  },
  {
    "code": "K58.8",
    "name": "Colon irritabile ohne Diarrhoe",
    "synonyms": [
      "Colica mucomembranosa",
      "Colica mucosa",
      "Colitis mucosa membranosa",
      "Colon irritabile",
      "Colon irritabile ohne Diarrhoe",
      "Darmirritabilität",
      "Darmspasmen",
      "Enteritis membranosa",
      "Enterospasmus",
      "Intestinumspasmus",
      "Irritables Kolon",
      "Kolonirritabilität",
      "Kolonspasmen",
      "Magen-Darm-Spasmen",
      "Pseudomembranöse Enterokolitis im Sinne des Colon irritabile",
      "Pseudomembranöse Kolitis im Sinne des Colon irritabile",
      "Reizdarm",
      "Reizdarm ohne Diarrhoe",
      "Reizdarmsyndrom",
      "Reizdarmsyndrom ohne Diarrhoe",
      "Reizkolon",
      "Sigmaspasmus",
      "Spasmus der Flexura coli sigmoidea",
      "Spastische Kolitis",
      "Spastischer Dickdarm",
      "Spastisches Kolon",
      "Stressdarm",
      "Syndrom des Colon irritabile",
      "Syndrom des irritablen Kolons",
      "Zäkumspasmus"
    ]
  },
  {
    "code": "K59.00",
    "name": "Obstipation bei Kolontransitstörung",
    "synonyms": [
      "Obstipation bei Kolontransitstörung",
      "Slow-Transit-Obstipation"
    ]
  },
  {
    "code": "K59.01",
    "name": "Atonische Obstipation",
    "synonyms": [
      "Atonische Obstipation",
      "Neurogene Obstipation",
      "Obstipation bei Stuhlentleerungsstörung",
      "Obstipation bei anorektaler Funktionsstörung",
      "Obstruktives Defäkationssyndrom",
      "Outlet-Obstipation",
      "Spastische Obstipation"
    ]
  },
  {
    "code": "K59.02",
    "name": "Medikamentös induzierte Obstipation",
    "synonyms": [
      "Medikamentös induzierte Obstipation"
    ]
  },
  {
    "code": "K59.09",
    "name": "Obstipation",
    "synonyms": [
      "Chronische Obstipation",
      "Darmträgheit",
      "Dyschezie",
      "Einfache Obstipation",
      "Hartleibigkeit",
      "Obstipation",
      "Retentio alvi",
      "Stuhlträgheit",
      "Stuhlverhalten",
      "Stuhlverhaltung",
      "Stuhlverstopfung",
      "Verstopfung"
    ]
  },
  {
    "code": "K59.1",
    "name": "Funktionelle Diarrhoe",
    "synonyms": [
      "Funktionelle Diarrhoe",
      "Funktioneller Durchfall"
    ]
  },
  {
    "code": "K59.2",
    "name": "Neurogene Blasen-Darm-Störung a.n.k.",
    "synonyms": [
      "Neurogene Blasen-Darm-Störung a.n.k."
    ]
  },
  {
    "code": "K59.3",
    "name": "Makrosigma",
    "synonyms": [
      "Erworbenes Megakolon",
      "Funktionelles Megakolon",
      "Idiopathisches Megakolon",
      "Kolondilatation",
      "Kolonhypertrophie",
      "Makrosigma",
      "Makrosigmoideum",
      "Megakolon",
      "Megakolon, nicht durch Hirschsprung-Krankheit",
      "Megasigma",
      "Megasigmoideum",
      "Rektumdilatation",
      "Sigmahypertrophie",
      "Toxisches Megakolon",
      "Zäkumdilatation",
      "Zäkumhypertrophie"
    ]
  },
  {
    "code": "K59.4",
    "name": "Analspasmus",
    "synonyms": [
      "Analspasmus",
      "Erhöhter analer Sphinktertonus",
      "Levator-ani-Syndrom",
      "Proctalgia fugax",
      "Proktospasmus",
      "Spastische Proktalgie",
      "Sphinkterkrampf des Anus",
      "Sphinkterspasmus des Rektums"
    ]
  },
  {
    "code": "K59.8",
    "name": "Darmhypomotilität",
    "synonyms": [
      "Anusdilatation",
      "CIPO [Chronische intestinale Pseudoobstruktion]",
      "Chronische intestinale Pseudoobstruktion",
      "Darmatonie",
      "Darmhyperämie",
      "Darmhypomotilität",
      "Dickdarmatonie",
      "Duodenaldilatation",
      "Duodenalirritabilität",
      "Duodenalspasmus",
      "Dünndarmatonie",
      "Enterische Hyperämie",
      "Erworbene Kolonverlängerung",
      "Ileumdilatation",
      "Ileumirritabilität",
      "Ileumstase",
      "Intestinale Dyskinesie",
      "Intestinale Unterfunktion",
      "Jejunumdilatation",
      "Jejunumirritabilität",
      "Jejunumstase",
      "Kolonatonie",
      "Kolonstase",
      "Payr-Syndrom",
      "Rektumirritabilität",
      "Stuhlentleerungsstörung",
      "Zäkumatonie",
      "Zäkumstase"
    ]
  },
  {
    "code": "K59.9",
    "name": "Funktionelle Kolonbeschwerden",
    "synonyms": [
      "Darmentleerungsstörung",
      "Darmmotilitätsstörung",
      "Darmmotorikstörung",
      "Darmpassagestörung",
      "Dysfunktion des Rektumsphinkters",
      "Funktionelle Darmbeschwerden",
      "Funktionelle Darmkrankheit",
      "Funktionelle Darmstörung",
      "Funktionelle Intestinalkrankheit",
      "Funktionelle Kolonbeschwerden",
      "Funktionelle Kolonkrankheit",
      "Funktionelle Kolonstörung",
      "Funktionelle Verdauungsstörung",
      "Funktionelle gastrointestinale Krankheit",
      "Funktionelle gastrointestinale Störung",
      "Funktioneller intestinaler Distress a.n.k.",
      "Funktionelles Darmproblem",
      "Funktionelles Intestinalproblem",
      "Kolondysfunktion",
      "Rektumdysfunktion",
      "Stuhlproblem",
      "Syndrom der funktionellen Darmstörung"
    ]
  },
  {
    "code": "K60.0",
    "name": "Akute Analfissur",
    "synonyms": [
      "Akute Analfissur"
    ]
  },
  {
    "code": "K60.1",
    "name": "Chronische Analfissur",
    "synonyms": [
      "Chronische Analfissur"
    ]
  },
  {
    "code": "K60.2",
    "name": "Rektumfissur",
    "synonyms": [
      "Afterrhagade",
      "Afterschrunde",
      "Analfissur",
      "Analrhagade",
      "Fissura ani",
      "Nichttraumatische und nichtpuerperale Anuslazeration",
      "Nichttraumatischer Analriss",
      "Rektumfissur",
      "Rektumrhagade"
    ]
  },
  {
    "code": "K60.3",
    "name": "Analfistel",
    "synonyms": [
      "Analfistel",
      "Fistula in ano",
      "Perianale Fistel"
    ]
  },
  {
    "code": "K60.4",
    "name": "Rektumfistel",
    "synonyms": [
      "Mastdarmfistel",
      "Perineorektale Fistel",
      "Perirektale Fistel",
      "Rektale Fistel",
      "Rektokutane Fistel",
      "Rektum-Haut-Fistel",
      "Rektumfistel"
    ]
  },
  {
    "code": "K60.5",
    "name": "Anorektale Fistel",
    "synonyms": [
      "Anorektale Fistel"
    ]
  },
  {
    "code": "K61.0",
    "name": "Analphlegmone",
    "synonyms": [
      "Analabszess",
      "Analphlegmone",
      "Anusabszess",
      "Marginaler Abszess des Anus",
      "Perianalabszess"
    ]
  },
  {
    "code": "K61.1",
    "name": "Rektumfurunkel",
    "synonyms": [
      "Pararektalabszess",
      "Periproktischer Abszess",
      "Perirektalabszess",
      "Rektalabszess",
      "Rektalphlegmone",
      "Rektumfurunkel",
      "Rektumkarbunkel"
    ]
  },
  {
    "code": "K61.2",
    "name": "Anorektaler Abszess",
    "synonyms": [
      "Anorektale Phlegmone",
      "Anorektaler Abszess"
    ]
  },
  {
    "code": "K61.3",
    "name": "Ischiorektaler Abszess",
    "synonyms": [
      "Abszess der Fossa ischioanalis",
      "Abszess der Fossa ischiorectalis",
      "Ischiorektale Fistel",
      "Ischiorektale Phlegmone",
      "Ischiorektaler Abszess"
    ]
  },
  {
    "code": "K61.4",
    "name": "Intrasphinktärer Abszess am Anus",
    "synonyms": [
      "Analsphinkterabszess",
      "Intrasphinktäre Phlegmone am Anus",
      "Intrasphinktärer Abszess am Anus"
    ]
  },
  {
    "code": "K62.0",
    "name": "Analpolyp",
    "synonyms": [
      "Analkanalpolyp",
      "Analpolyp"
    ]
  },
  {
    "code": "K62.1",
    "name": "Rektumpolyp",
    "synonyms": [
      "Rektumpolyp"
    ]
  },
  {
    "code": "K62.2",
    "name": "Analprolaps",
    "synonyms": [
      "Aftervorfall",
      "Analektropium",
      "Analkanalprolaps",
      "Analprolaps",
      "Analschleimhautprolaps"
    ]
  },
  {
    "code": "K62.3",
    "name": "Rektumprolaps",
    "synonyms": [
      "Latenter Rektumprolaps",
      "Mastdarmvorfall",
      "Mastdarmvorfall bei der Frau",
      "Proktoptose",
      "Proktozele beim Mann",
      "Prolaps der Mastdarmschleimhaut",
      "Prolaps der Rektumschleimhaut",
      "Rektozele beim Mann",
      "Rektumprolaps",
      "Rektumvorfall",
      "Rektumvorfall bei der Frau"
    ]
  },
  {
    "code": "K62.4",
    "name": "Analstenose",
    "synonyms": [
      "Analkanalstenose",
      "Analringstenose",
      "Analsphinkterstriktur",
      "Analstenose",
      "Anusstenose",
      "Anusstenose mit Rektumstenose",
      "Anusstriktur",
      "Anusverschluss",
      "Rektumobstruktion",
      "Rektumsphinkterstenose",
      "Rektumsphinkterstriktur",
      "Rektumstenose"
    ]
  },
  {
    "code": "K62.50",
    "name": "Analhämorrhagie",
    "synonyms": [
      "Analblutung",
      "Analhämorrhagie",
      "Analkanalblutung",
      "Analkanalhämorrhagie",
      "Anusblutung",
      "Anushämorrhagie",
      "Perianale Blutung",
      "Proktorrhagie"
    ]
  },
  {
    "code": "K62.51",
    "name": "Rektumblutung",
    "synonyms": [
      "Haemorrhagia rectalis",
      "Hämorrhagie des Rektumsphinkters",
      "Rektale Blutung",
      "Rektumblutung",
      "Rektumhämorrhagie",
      "Rektumsphinkterblutung"
    ]
  },
  {
    "code": "K62.59",
    "name": "Anorektale Blutung",
    "synonyms": [
      "Anorektale Blutung"
    ]
  },
  {
    "code": "K62.6",
    "name": "Ulcus anorectale",
    "synonyms": [
      "Aftergeschwür",
      "Analkanalulkus",
      "Analulkus",
      "Anorektales Ulkus",
      "Kotgeschwür des Rektums",
      "Rektumgeschwür",
      "Rektumulkus",
      "Solitary-rectal-ulcer-Syndrom",
      "Solitäres Analgeschwür",
      "Solitäres Analulkus",
      "Solitäres Geschwür des Rektums",
      "Solitäres Rektumulkus",
      "Sterkoralgeschwür",
      "Sterkoralulkus",
      "Ulcus anorectale",
      "Ulcus stercoralis",
      "Ulkus des Analsphinkters"
    ]
  },
  {
    "code": "K62.7",
    "name": "Strahlenproktitis",
    "synonyms": [
      "Radiogene Proktitis",
      "Strahlenproktitis"
    ]
  },
  {
    "code": "K62.8",
    "name": "Analinsuffizienz",
    "synonyms": [
      "Analatrophie",
      "Anale Kryptitis",
      "Analentzündung",
      "Analinsuffizienz",
      "Analkanalentzündung",
      "Analpapillenhypertrophie",
      "Analpapillitis",
      "Analschmerz",
      "Analsphinkterinsuffizienz",
      "Analsphinkterparalyse",
      "Analsphinkterrelaxation",
      "Analsphinktersklerose",
      "Anitis",
      "Anusentzündung",
      "Anusfibrose",
      "Anusinfektion",
      "Anusinsuffizienz",
      "Anusleukoplakie",
      "Anusnarbe",
      "Anusparalyse",
      "Anusreizung",
      "Anusschmerzen",
      "Anuszyste",
      "Craurosis ani",
      "Cryptitis - s.a. Kryptitis",
      "Destruktion des Sphincter recti",
      "Dilatation des Sphincter ani",
      "Enddarmreizung",
      "Erworbene Anusdeformität",
      "Erworbene Rektumdeformität",
      "Hypertrophe Analpapillen",
      "Hyperämie der Analschleimhaut",
      "Kryptitis",
      "Kryptopapillitis",
      "Kryptopapillitis des Anus",
      "Mastdarmlähmung",
      "Megarektum",
      "Muköse Rektumzyste",
      "Paraproktitis",
      "Perianale Entzündung",
      "Periproktitis",
      "Perirektale Entzündung",
      "Perirektale Infektion",
      "Proctalgia",
      "Proktalgie",
      "Proktitis",
      "Proktodynie",
      "Proktoparalyse",
      "Rektale Entzündung",
      "Rektale Kryptitis",
      "Rektalgie",
      "Rektalsphinkterfibrose",
      "Rektitis",
      "Rektumentzündung",
      "Rektumgranulom",
      "Rektumleukoplakie",
      "Rektumlähmung",
      "Rektumnarbe",
      "Rektumpapillitis",
      "Rektumschmerzen",
      "Rektumsphinkterhypertrophie",
      "Rektumsphinkterinfektion",
      "Rektumsphinkterrelaxation",
      "Rektumzyste"
    ]
  },
  {
    "code": "K62.9",
    "name": "Perineale Schmerzen und perianale Schmerzen",
    "synonyms": [
      "Analkanalkrankheit",
      "Analkrankheit",
      "Analleiden",
      "Anorektale Schädigung",
      "Perineale Schmerzen und perianale Schmerzen",
      "Rektumkrankheit"
    ]
  },
  {
    "code": "K63.0",
    "name": "Darmabszess",
    "synonyms": [
      "Abszess der Kolonwand",
      "Darmabszess",
      "Darmeiterung",
      "Darmphlegmone",
      "Darmwandabszess",
      "Dünndarmphlegmone",
      "Intestinalabszess a.n.k.",
      "Sigmaabszess",
      "Tiefsitzender Darmabszess"
    ]
  },
  {
    "code": "K63.1",
    "name": "Dickdarmperforation",
    "synonyms": [
      "Darmdurchbruch",
      "Darmleckage",
      "Darmperforation",
      "Darmriss",
      "Darmruptur",
      "Dickdarmeinriss",
      "Dickdarmperforation",
      "Dickdarmruptur",
      "Dünndarmperforation",
      "Ileumperforation",
      "Intestinumperforation",
      "Jejunumperforation",
      "Kolonperforation",
      "Nichttraumatische Darmperforation",
      "Nichttraumatische Darmruptur a.n.k.",
      "Nichttraumatische Ileumruptur",
      "Nichttraumatische Intestinalruptur a.n.k.",
      "Nichttraumatische Jejunumruptur",
      "Nichttraumatische Kolonruptur",
      "Nichttraumatische Rektumruptur",
      "Nichttraumatische Sigmaruptur",
      "Perforation des Colon ascendens",
      "Perforiertes Darmulkus",
      "Rektumperforation",
      "Sigmaperforation",
      "Ulzerative Intestinalperforation a.n.k.",
      "Zäkumperforation"
    ]
  },
  {
    "code": "K63.2",
    "name": "Darmfistel a.n.k.",
    "synonyms": [
      "Abdomenfistel",
      "Bauchdeckenfistel",
      "Bauchwandfistel",
      "Darmfistel a.n.k.",
      "Dünndarmfistel",
      "Enterokolische Fistel",
      "Enterokutane Fistel",
      "Fistula stercoralis",
      "Ileorektale Fistel",
      "Ileosigmoidale Fistel",
      "Ileumfistel",
      "Intestinale Fistel",
      "Intestinalfistel",
      "Intestinumfistel a.n.k.",
      "Jejunumfistel",
      "Kolonfistel",
      "Kotfistel",
      "Rektosigmoidale Fistel",
      "Sigmafistel",
      "Sigmoidale Fistel",
      "Zäkalfistel",
      "Zäkosigmoidale Fistel",
      "Zäkumfistel"
    ]
  },
  {
    "code": "K63.3",
    "name": "Darmulkus",
    "synonyms": [
      "CMUSE [Kryptogene multifokale ulzeröse stenosierende Enteritis]",
      "Darmerosion",
      "Darmgeschwür",
      "Darmulkus",
      "Dünndarmgeschwür",
      "Ileumulkus",
      "Kolonulkus",
      "Kryptogene multifokale ulzeröse stenosierende Enteritis",
      "Primärer Dünndarmulkus",
      "Primärulkus des Dünndarmes",
      "Rektosigmoides Ulkus",
      "Sigmoidulkus",
      "Ulcus intestini",
      "Zäkumulkus"
    ]
  },
  {
    "code": "K63.4",
    "name": "Darmprolaps",
    "synonyms": [
      "Darmprolaps",
      "Darmptose",
      "Darmsenkung",
      "Darmvorfall",
      "Dünndarmprolaps",
      "Eingeweideptose",
      "Eingeweidesenkung",
      "Enteroptose",
      "Gastroenteroptose",
      "Gestielter Kolonprolaps",
      "Glénard-Krankheit",
      "Intestinalptose",
      "Koloptose",
      "Splanchnoptose",
      "Viszeralptose",
      "Viszeroptose",
      "Zäkumprolaps",
      "Zäkumptose"
    ]
  },
  {
    "code": "K63.5",
    "name": "Kolonpolyp",
    "synonyms": [
      "Dickdarmpolyp",
      "Kolonpolyp",
      "Sigmapolyp"
    ]
  },
  {
    "code": "K63.8",
    "name": "Gleichgewichtsstörung der Darmflora [Dysbiose]",
    "synonyms": [
      "Angeborene Enterozyten-Heparansulfat-Defizienz",
      "CEAS [Chronische Enteropathie assoziiert mit SLCO2A1-Gen]",
      "Darmatrophie",
      "Darmfibrose",
      "Darmgranulom a.n.k.",
      "Darmhypertrophie a.n.k.",
      "Darmpolyp",
      "Darmzyste",
      "Dickdarmzyste",
      "Dysbiose [Gleichgewichtsstörung der Darmflora]",
      "Dünndarmfehlbesiedelung",
      "Dünndarmpolyp",
      "Dünndarmzyste",
      "Erworbene Darmdeformität",
      "Erworbene Deformität des Gastrointestinaltraktes",
      "Erworbene Deformität des Magen-Darm-Kanals a.n.k.",
      "Erworbene Dickdarmdeformität",
      "Erworbene Dünndarmdeformität",
      "Erworbene Kolondeformität",
      "Erworbene Sigmadeformität",
      "Erworbene Zäkumdeformität",
      "Erworbene ileozäkale Deformität",
      "Gastrointestinale Atrophie",
      "Gleichgewichtsstörung der Darmflora [Dysbiose]",
      "Ileumgranulom",
      "Ileumhypertrophie",
      "Intestinale Intoxikation",
      "Intestinale Vergiftung",
      "Intestinale epitheliale Dysplasie",
      "Intestinumgranulom a.n.k.",
      "Intestinumhypertrophie a.n.k.",
      "Jejunumhypertrophie",
      "Kolongranulom",
      "Kolonzyste",
      "Leukoplakie des Kolons",
      "Magen-Darm-Intoxikation",
      "Magen-Darm-Vergiftung",
      "Melanose des Kolons",
      "Melanosis coli",
      "PCI [Pneumatosis cystoides intestini]",
      "Palpables Zäkum",
      "Pneumatosis coli",
      "Pneumatosis cystoides intestini",
      "Proktosigmoiditis",
      "Pseudomelanosis coli",
      "Rektosigmoiditis",
      "SLCO2A1-Gen-assoziierte chronische Enteropathie"
    ]
  },
  {
    "code": "K63.9",
    "name": "Enteropathie",
    "synonyms": [
      "Darminsuffizienz",
      "Darmkrankheit",
      "Darmstörung",
      "Enteropathie",
      "Gastrointestinalschaden",
      "Ileozäkale Schädigung",
      "Ileumschädigung",
      "Intestinalkrankheit",
      "Intestinalschädigung",
      "Kolonkrankheit",
      "Kolonschwäche",
      "Kolonschädigung",
      "Kolonstörung",
      "Krankheit des Verdauungskanals",
      "Organische Darmkrankheit",
      "Organische Intestinalkrankheit",
      "Rektosigmoidschädigung",
      "Schädigung des Colon sigmoideum",
      "Sigmaschädigung",
      "Zäkumkrankheit",
      "Zäkumschädigung"
    ]
  },
  {
    "code": "K64.0",
    "name": "Hämorrhoiden 1. Grades",
    "synonyms": [
      "Hämorrhoiden 1. Grades",
      "Hämorrhoiden Stadium 1",
      "Hämorrhoiden ohne Komplikation",
      "Hämorrhoiden ohne Prolaps"
    ]
  },
  {
    "code": "K64.1",
    "name": "Hämorrhoiden 2. Grades",
    "synonyms": [
      "Hämorrhoiden 2. Grades",
      "Hämorrhoiden Stadium 2",
      "Hämorrhoiden mit Prolaps beim Pressen, ziehen sich spontan zurück"
    ]
  },
  {
    "code": "K64.2",
    "name": "Hämorrhoiden 3. Grades",
    "synonyms": [
      "Hämorrhoiden 3. Grades",
      "Hämorrhoiden Stadium 3",
      "Thrombose bei Hämorrhoiden 3. Grades"
    ]
  },
  {
    "code": "K64.3",
    "name": "Hämorrhoiden 4. Grades",
    "synonyms": [
      "Hämorrhoiden 4. Grades",
      "Hämorrhoiden Stadium 4",
      "Hämorrhoiden mit Prolaps, manuelle Reposition nicht möglich"
    ]
  },
  {
    "code": "K64.4",
    "name": "Perianale Hautzipfel",
    "synonyms": [
      "Analmarisken",
      "Hypertrophe Analfalte",
      "Hämorrhoidale Marisken",
      "Marisken",
      "Marisken als Hämorrhoidenfolge",
      "Perianale Hautzipfel",
      "Perianale Marisken",
      "Rektale Marisken",
      "Residuale hämorrhoidale Hautzipfel"
    ]
  },
  {
    "code": "K64.5",
    "name": "Hämorrhoidalvenenthrombose",
    "synonyms": [
      "Analthrombose",
      "Analvenenthrombose",
      "Blutende äußere Hämorrhoiden",
      "Eingeklemmte äußere Hämorrhoiden",
      "Hämorrhoidalvenenthrombose",
      "Nichttraumatisches perianales Hämatom",
      "Perianalthrombose",
      "Perianalvenenthrombose",
      "Prolabierte äußere Hämorrhoiden",
      "Strangulierte äußere Hämorrhoiden",
      "Thrombosierte äußere Hämorrhoiden",
      "Ulzerierte äußere Hämorrhoiden",
      "Variköses äußeres Ulkus des Anus",
      "Vorgefallene äußere Hämorrhoiden",
      "Äußere Hämorrhoiden"
    ]
  },
  {
    "code": "K64.8",
    "name": "Thrombotischer Hämorrhoidalknoten",
    "synonyms": [
      "Eingeklemmte Hämorrhoiden",
      "Eingeklemmte innere Hämorrhoiden",
      "Hämorrhoiden mit Thrombose",
      "Hämorrhoidenentzündung",
      "Hämorrhoidenstrangulation",
      "Strangulierte Hämorrhoiden a.n.k.",
      "Strangulierte innere Hämorrhoiden",
      "Thrombosierte Hämorrhoiden a.n.k.",
      "Thrombosierte innere Hämorrhoiden",
      "Thrombotischer Hämorrhoidalknoten",
      "Ulzerierte Hämorrhoiden",
      "Ulzerierte innere Hämorrhoiden",
      "Ulzeröse innere Hämorrhoiden",
      "Variköses Ulkus des Anus",
      "Variköses inneres Ulkus des Anus"
    ]
  },
  {
    "code": "K64.9",
    "name": "Venektasie des Afters",
    "synonyms": [
      "Blutende Hämorrhoiden",
      "Blutende innere Hämorrhoiden",
      "Hämorrhoidalbeschwerden",
      "Hämorrhoidalerkrankung",
      "Hämorrhoidalknoten",
      "Hämorrhoidalleiden",
      "Hämorrhoidalring",
      "Hämorrhoidalvarizen",
      "Hämorrhoiden",
      "Innere Hämorrhoiden",
      "Prolabierte Hämorrhoiden",
      "Prolabierte innere Hämorrhoiden",
      "Venektasie des Afters",
      "Vorgefallene Hämorrhoiden",
      "Vorgefallene innere Hämorrhoiden"
    ]
  },
  {
    "code": "K65.00",
    "name": "Spontane bakterielle Peritonitis",
    "synonyms": [
      "SBP [Spontane bakterielle Peritonitis]",
      "Spontane bakterielle Peritonitis"
    ]
  },
  {
    "code": "K65.09",
    "name": "Akute Peritonitis",
    "synonyms": [
      "Abdominaler Abszess",
      "Abszess des Abdomens",
      "Abszess des Epiploons",
      "Abszess des Mesenteriums",
      "Abszess des Omentums",
      "Abszess des kleinen Beckens",
      "Akute Bauchfellentzündung",
      "Akute Peritonitis",
      "Akute Peritonitis des männlichen Beckens",
      "Akute diffuse Peritonitis",
      "Akute eitrige Peritonitis",
      "Akute eosinophile Peritonitis",
      "Akute subphrenische Peritonitis",
      "Allgemeine Peritonitis",
      "Bakterielle Peritonitis",
      "Bauchhöhlenabszess",
      "Bauchraumabszess",
      "Beckenperitonitis beim Mann",
      "Diaphragmatische Peritonitis",
      "Diffuse Peritonitis a.n.k.",
      "Disseminierte Peritonitis",
      "Eiterung des männlichen Beckens",
      "Eitrige Peritonitis",
      "Empyem im Oberbauch",
      "Extraperitonealabszess",
      "Fibropurulente Peritonitis",
      "Generalisierte Peritonitis",
      "Intraabdominaler Abszess",
      "Intraperitonealer Abszess",
      "Mesenterialer Abszess",
      "Männliche Pelveoperitonitis",
      "Netzabszess",
      "Pankreatische Peritonitis",
      "Pelveoabdominaler Abszess",
      "Pelvikoabdominaler Abszess",
      "Perforierter Peritonealabszess",
      "Peritonealabszess",
      "Peritonealer Beckenabszess beim Mann",
      "Peritonealphlegmone",
      "Peritonitis mit Abszess",
      "Peritonitis purulenta",
      "Retroperitonealabszess",
      "Retrozäkaler Abszess",
      "Rupturierter Peritonealabszess",
      "Septische Peritonitis",
      "Subdiaphragmatische Peritonitis",
      "Subdiaphragmatischer Abszess",
      "Subhepatischer Abszess",
      "Subphrenische Peritonitis",
      "Subphrenischer Abszess",
      "Unterbauchabszess",
      "Zwerchfellabszess"
    ]
  },
  {
    "code": "K65.8",
    "name": "Choleperitonitis",
    "synonyms": [
      "Biliäre Peritonitis",
      "Choleperitoneum",
      "Choleperitonitis",
      "Chronische proliferierende Peritonitis",
      "Eosinophile Peritonitis",
      "Fettnekrose des Mesenteriums",
      "Fettnekrose des Omentums",
      "Fettnekrose des Peritoneums",
      "Fibroplastische Peritonitis",
      "Galleperitonitis",
      "Gallige Peritonitis",
      "Kapselentzündung der Leber",
      "Kotige Peritonitis",
      "Mesenteriale Fettgewebsnekrose",
      "Mesenteriale Saponifikation",
      "Multiple Serositis",
      "Multiple peritoneale Serositis",
      "Perihepatitis",
      "Peritonitis durch Urin",
      "Saponifikation des Mesenteriums",
      "Sklerosierende Mesenteritis",
      "Urinperitonitis",
      "Verseifung des Mesenteriums"
    ]
  },
  {
    "code": "K65.9",
    "name": "Retroperitonitis",
    "synonyms": [
      "Adhäsive Peritonitis",
      "Bauchfellentzündung",
      "Durchwanderungsperitonitis",
      "Epiploitis",
      "Fibrinöse Peritonitis",
      "Infektiöses Hämoperitoneum",
      "Lokalisierte Bauchfellentzündung",
      "Lokalisierte Peritoneumentzündung",
      "Lokalisierte Peritonitis",
      "Mesenteritis",
      "Oberbauchperitonitis",
      "Omentitis",
      "Peritoneale Infektion",
      "Peritoneumentzündung",
      "Peritoneumfistel",
      "Peritonitis",
      "Peritonitis durch Perforation",
      "Peritonitis mit Erguss",
      "Permigrationsperitonitis",
      "Retroperitoneale Entzündung",
      "Retroperitonitis",
      "Unterbauchperitonitis",
      "Vierquadrantenperitonitis"
    ]
  },
  {
    "code": "K66.0",
    "name": "Appendixverwachsung",
    "synonyms": [
      "Abdomenadhäsion",
      "Abdominale Adhäsion",
      "Abdominale Verwachsung",
      "Adhäsion - s.a. Verwachsung",
      "Adhäsion der Bauchinnenwand",
      "Adhäsion des Intestinums",
      "Adhäsion des Mesenteriums",
      "Adhäsion des Omentums",
      "Adhäsion des männlichen Beckens",
      "Adhäsionsstrang",
      "Adhäsiver Gewebestrang",
      "Adhäsiver Gewebestrang des Darmes",
      "Adhäsiver peritonealer Gewebestrang",
      "Appendixadhäsion",
      "Appendixverwachsung",
      "Bauchfelladhäsion",
      "Bauchfellverwachsung",
      "Bauchwandadhäsion",
      "Beckenadhäsion",
      "Bride",
      "Darmadhäsion",
      "Darmverwachsung",
      "Diaphragmaadhäsion",
      "Duodenaladhäsion",
      "Dünndarmadhäsion",
      "Dünndarmbride",
      "Dünndarmverwachsung",
      "Eingeweideverwachsung",
      "Fibröse Briden",
      "Ileozäkale Adhäsion",
      "Ileumadhäsion",
      "Intestinale Verwachsung",
      "Intraabdominale Adhäsion",
      "Kolonadhäsion",
      "Leberadhäsion",
      "Magenadhäsion",
      "Oberbauchperitonealverwachsung",
      "Oberbauchverwachsung",
      "Periappendikale Adhäsion",
      "Perigastrische Adhäsion",
      "Peritoneale Adhäsion",
      "Peritoneumadhäsion",
      "Peritoneumverwachsung",
      "Postinfektiöse Adhäsion",
      "Postinfektiöse Beckenadhäsion beim Mann",
      "Postoperative Bauchfellverwachsung",
      "Postoperative Peritoneumverwachsung",
      "Pylorusadhäsion",
      "Sigmaadhäsion",
      "Verwachsung des Bauchraums",
      "Verwachsungsbauch",
      "Zwerchfelladhäsion",
      "Zwerchfellverwachsung",
      "Zäkumadhäsion"
    ]
  },
  {
    "code": "K66.1",
    "name": "Mesenterialblutung",
    "synonyms": [
      "Blutung des Mesenteriums",
      "Blutung des Omentums",
      "Blutung des Peritoneums",
      "Hämoperitoneum",
      "Hämorrhagie des Mesenteriums",
      "Hämorrhagie des Omentums",
      "Hämorrhagie des Peritoneums",
      "Intrapelvine Blutung beim Mann",
      "Intrapelvine Hämorrhagie beim Mann",
      "Intraperitoneale Blutung",
      "Intraperitoneale Hämorrhagie",
      "Mesenterialblutung",
      "Nichttraumatisches retroperitoneales Hämatom",
      "Peritonealblutung",
      "Peritoneale Hämorrhagie",
      "Retroperitonealhämatom"
    ]
  },
  {
    "code": "K66.2",
    "name": "Ormond-Fibrose",
    "synonyms": [
      "Idiopathische retroperitoneale Fibrose",
      "Idiopathische retroperitoneale Fibrose mit Infektion der Niere",
      "Morbus Ormond",
      "Ormond-Fibrose",
      "Ormond-Krankheit",
      "Ormond-Krankheit mit Infektion",
      "Ormond-Krankheit mit Ureterobstruktion",
      "Ormond-Syndrom",
      "Ormond-Syndrom mit Ureterobstruktion",
      "Perirenale Fasziitis mit Infektion",
      "Perirenale Fasziitis mit Ureterobstruktion",
      "Retroperitoneale Fibrose",
      "Retroperitonealfibrose"
    ]
  },
  {
    "code": "K66.8",
    "name": "Mesotheleinschlusszyste",
    "synonyms": [
      "Abdomengranulom",
      "Fibrose des Bauchfells",
      "Frozen pelvis beim Mann",
      "Mesenterialzyste",
      "Mesotheleinschlusszyste",
      "Mesothelzyste",
      "Nichttraumatische Mesenteriumruptur",
      "Omentalzyste",
      "Peritonealzyste",
      "Peritoneumgranulom",
      "Pneumatosis cystoides peritonei",
      "Pneumatosis peritonei",
      "Pseudoperitonealzyste",
      "Retroperitonealzyste",
      "Zyste des Omentum minus"
    ]
  },
  {
    "code": "K66.9",
    "name": "Peritoneale Reizung",
    "synonyms": [
      "Peritoneale Reizung",
      "Peritonealkrankheit"
    ]
  },
  {
    "code": "K70.0",
    "name": "Alkoholische Fettleber",
    "synonyms": [
      "Alkoholbedingte Steatosis hepatis",
      "Alkoholische Fettleber",
      "Alkoholische fettige Leberdegeneration",
      "Alkoholtoxische Fettleber",
      "Alkoholtoxische Steatosis hepatis",
      "Zieve-Syndrom"
    ]
  },
  {
    "code": "K70.1",
    "name": "Alkoholtoxische Hepatitis",
    "synonyms": [
      "Akute alkoholische Hepatitis",
      "Alkoholische Hepatitis",
      "Alkoholische Steatohepatitis",
      "Alkoholtoxische Hepatitis",
      "Chronische alkoholische Hepatitis"
    ]
  },
  {
    "code": "K70.2",
    "name": "Alkoholische Leberfibrose",
    "synonyms": [
      "Alkoholische Leberfibrose",
      "Alkoholische Lebersklerose",
      "Alkoholtoxische Lebersklerose"
    ]
  },
  {
    "code": "K70.3",
    "name": "Laënnec-Zirrhose",
    "synonyms": [
      "Alkoholbedingte Leberzirrhose",
      "Alkoholische Fettleberzirrhose",
      "Alkoholische Laënnec-Leberzirrhose",
      "Alkoholische Leberzirrhose",
      "Alkoholische Zirrhose",
      "Alkoholtoxische Leberzirrhose",
      "Laënnec-Zirrhose",
      "Makronoduläre alkoholische Zirrhose",
      "Mikronoduläre alkoholische Zirrhose",
      "Morbus Laënnec",
      "Nutritive alkoholische Zirrhose",
      "Portale alkoholische Zirrhose",
      "Postnekrotische alkoholische Zirrhose",
      "Äthyltoxische Cirrhosis hepatis"
    ]
  },
  {
    "code": "K70.40",
    "name": "Subakutes alkoholisches Leberversagen",
    "synonyms": [
      "Akutes alkoholisches Leberversagen",
      "Subakutes alkoholisches Leberversagen"
    ]
  },
  {
    "code": "K70.41",
    "name": "Chronisches alkoholisches Leberversagen",
    "synonyms": [
      "Chronisches alkoholisches Leberversagen"
    ]
  },
  {
    "code": "K70.42",
    "name": "Akut-auf-chronisches alkoholisches Leberversagen",
    "synonyms": [
      "Akut-auf-chronisches alkoholisches Leberversagen"
    ]
  },
  {
    "code": "K70.48",
    "name": "Alkoholisches Leberversagen",
    "synonyms": [
      "Alkoholbedingtes Leberversagen",
      "Alkoholisches Leberkoma",
      "Alkoholisches Leberversagen",
      "Alkoholisches Leberversagen mit Coma hepaticum",
      "Alkoholtoxisches Leberkoma",
      "Alkoholtoxisches Leberversagen",
      "Äthyltoxisches Leberversagen"
    ]
  },
  {
    "code": "K70.9",
    "name": "Alkoholische Leberkrankheit",
    "synonyms": [
      "Alkoholische Hepatopathie",
      "Alkoholische Leberkrankheit",
      "Alkoholischer Leberschaden",
      "Alkoholtoxische Hepatomegalie",
      "Alkoholtoxische Hepatopathie",
      "Alkoholtoxische Leberkrankheit",
      "Alkoholtoxische Leberschädigung",
      "Alkoholtoxischer Leberparenchymschaden",
      "Alkoholtoxischer Leberschaden",
      "Säuferleber"
    ]
  },
  {
    "code": "K71.0",
    "name": "Intrahepatische Cholestase a.n.k.",
    "synonyms": [
      "Aagenaes-Syndrom",
      "BRIC [Benigne rekurrente intrahepatische Cholestase]",
      "BRIC [Benigne rekurrente intrahepatische Cholestase] Typ 1",
      "BRIC [Benigne rekurrente intrahepatische Cholestase] Typ 2",
      "Benigne rekurrente intrahepatische Cholestase",
      "Benigne rekurrente intrahepatische Cholestase Typ 1",
      "Benigne rekurrente intrahepatische Cholestase Typ 2",
      "Cholestase mit Leberzellschädigung",
      "Cholestase-Lymphödem-Syndrom",
      "Familiäre intrahepatische Cholestase",
      "Intrahepatische Cholestase a.n.k.",
      "Isolierte Cholestase a.n.k.",
      "Reine Cholestase",
      "Toxische Leberkrankheit mit Cholestase"
    ]
  },
  {
    "code": "K71.1",
    "name": "Toxische Leberkrankheit mit Lebernekrose",
    "synonyms": [
      "Toxische Leberkrankheit mit Lebernekrose"
    ]
  },
  {
    "code": "K71.2",
    "name": "Toxische Leberkrankheit mit akuter Hepatitis",
    "synonyms": [
      "Toxische Leberkrankheit mit akuter Hepatitis"
    ]
  },
  {
    "code": "K71.3",
    "name": "Toxische Leberkrankheit mit chronisch-persistierender Hepatitis",
    "synonyms": [
      "Toxische Leberkrankheit mit chronisch-persistierender Hepatitis"
    ]
  },
  {
    "code": "K71.4",
    "name": "Toxische Leberkrankheit mit chronischer lobulärer Hepatitis",
    "synonyms": [
      "Toxische Leberkrankheit mit chronischer lobulärer Hepatitis"
    ]
  },
  {
    "code": "K71.5",
    "name": "Toxische Leberkrankheit mit chronisch-aktiver Hepatitis",
    "synonyms": [
      "Toxische Leberkrankheit mit chronisch-aktiver Hepatitis",
      "Toxische Leberkrankheit mit lupoider Hepatitis"
    ]
  },
  {
    "code": "K71.6",
    "name": "Toxische Hepatitis",
    "synonyms": [
      "Arzneimittelbedingte Hepatitis",
      "Eosinophile Hepatitis",
      "Toxische Hepatitis",
      "Toxische Leberkrankheit mit Hepatitis a.n.k."
    ]
  },
  {
    "code": "K71.7",
    "name": "Toxische Leberkrankheit mit Fibrose und Zirrhose der Leber",
    "synonyms": [
      "Medikamentös-toxische Leberzirrhose",
      "Toxische Cirrhosis hepatis",
      "Toxische Leberkrankheit mit Fibrose und Zirrhose der Leber",
      "Toxische Leberzirrhose"
    ]
  },
  {
    "code": "K71.80",
    "name": "Toxische veno-okklusive Leberkrankheit",
    "synonyms": [
      "Toxische veno-okklusive Leberkrankheit",
      "Toxisches Stuart-Bras-Syndrom"
    ]
  },
  {
    "code": "K71.88",
    "name": "Toxische Leberkrankheit mit fokaler nodulärer Hyperplasie",
    "synonyms": [
      "Toxische Leberkrankheit mit Lebergranulom",
      "Toxische Leberkrankheit mit Peliosis hepatis",
      "Toxische Leberkrankheit mit fokaler nodulärer Hyperplasie"
    ]
  },
  {
    "code": "K71.9",
    "name": "Toxische Leberkrankheit",
    "synonyms": [
      "Arzneimittelbedingte Leberfunktionsstörung",
      "Arzneimittelinduzierte unvorhersehbare idiosynkratische Leberkrankheit",
      "Arzneimittelinduzierte vorhersehbare toxische Leberkrankheit",
      "Toxisch nutritive Hepatopathie",
      "Toxische Hepatose",
      "Toxische Leberdegeneration a.n.k.",
      "Toxische Leberkrankheit",
      "Toxische Leberschädigung",
      "Toxische hepatobiliäre Krankheit"
    ]
  },
  {
    "code": "K72.0",
    "name": "Subakute gelbe Leberatrophie",
    "synonyms": [
      "Akute Leberdystrophie",
      "Akute gelbe Leberatrophie",
      "Akute nicht virale Hepatitis",
      "Akute parenchymatöse Leberdegeneration a.n.k.",
      "Akutes Leberversagen",
      "Akutes infantiles Leberversagen durch Synthesedefekt mtDNA-kodierter Proteine",
      "Late-onset-Form des Leberversagens",
      "Spät beginnendes Leberversagen",
      "Subakute gelbe Leberatrophie",
      "Subakute nicht virale Hepatitis",
      "Subakute parenchymatöse Leberdegeneration a.n.k.",
      "Syndrom des akuten infantilen Leberversagens mit multisystemischer Beteiligung",
      "Verzögert beginnendes Leberversagen"
    ]
  },
  {
    "code": "K72.10",
    "name": "Akut-auf-chronisches Leberversagen",
    "synonyms": [
      "Akut-auf-chronisches Leberversagen"
    ]
  },
  {
    "code": "K72.18",
    "name": "Chronisches Leberversagen",
    "synonyms": [
      "Chronische Leberdystrophie",
      "Chronische gelbe Leberatrophie",
      "Chronisches Leberversagen"
    ]
  },
  {
    "code": "K72.9",
    "name": "Bösartige Hepatitis",
    "synonyms": [
      "Bösartige Hepatitis",
      "Bösartige Hepatitis mit Leberversagen a.n.k.",
      "Fulminante Hepatitis mit Leberversagen",
      "Gelbe Leberatrophie",
      "Hepatische Dekompensation",
      "Hepatische Insuffizienz",
      "Icterus maligne",
      "Leberatrophie",
      "Leberausfallskoma",
      "Leberdekompensation",
      "Leberdystrophie",
      "Leberinsuffizienz",
      "Lebernekrose",
      "Lebernekrose mit Leberversagen",
      "Leberparenchymnekrose",
      "Leberparenchymschwund",
      "Leberversagen",
      "Leberzellnekrose",
      "Leberzellnekrose mit Leberversagen",
      "Maligne Hepatitis mit Leberversagen",
      "Nekrotisierende Hepatitis",
      "Praecoma hepaticum"
    ]
  },
  {
    "code": "K73.0",
    "name": "Chronische persistierende Hepatitis",
    "synonyms": [
      "Chronische persistierende Hepatitis"
    ]
  },
  {
    "code": "K73.1",
    "name": "Chronische lobuläre Hepatitis a.n.k.",
    "synonyms": [
      "Chronische lobuläre Hepatitis a.n.k."
    ]
  },
  {
    "code": "K73.2",
    "name": "Chronische aggressive Hepatitis",
    "synonyms": [
      "Bearn-Kunkel-Syndrom",
      "Chronische aggressive Hepatitis",
      "Chronische aktive Hepatitis"
    ]
  },
  {
    "code": "K73.8",
    "name": "Kunkel-Syndrom",
    "synonyms": [
      "Kunkel-Syndrom"
    ]
  },
  {
    "code": "K73.9",
    "name": "Chronische Hepatitis",
    "synonyms": [
      "Chronische Hepatitis",
      "Chronische Leberentzündung",
      "Nichtalkoholische chronische Hepatitis",
      "Rezidivierende Hepatitis"
    ]
  },
  {
    "code": "K74.0",
    "name": "Leberfibrose",
    "synonyms": [
      "Leberfibrose",
      "Narbenleber"
    ]
  },
  {
    "code": "K74.1",
    "name": "Lebersklerose",
    "synonyms": [
      "Lebersklerose"
    ]
  },
  {
    "code": "K74.2",
    "name": "Leberfibrose mit Lebersklerose",
    "synonyms": [
      "Leberfibrose mit Lebersklerose"
    ]
  },
  {
    "code": "K74.3",
    "name": "Primäre biliäre Zirrhose",
    "synonyms": [
      "Charcot-Zirrhose",
      "Chronische nichteitrige destruktive Cholangitis",
      "Hanot-Krankheit",
      "Hanot-Leberzirrhose",
      "Hanot-MacMahon-Tannhäuser-Syndrom",
      "Hanot-Syndrom",
      "Hanot-Zirrhose",
      "Hypertrophische Zirrhose",
      "Monolobuläre Zirrhose",
      "PBC [Primäre biliäre Zirrhose]",
      "Primäre biliäre Cholangitis",
      "Primäre biliäre Zirrhose",
      "Primäre cholangiolitische Zirrhose",
      "Primäre cholangitische Zirrhose",
      "Primäre cholestatische Zirrhose",
      "Todd-Zirrhose",
      "Unilobuläre Zirrhose"
    ]
  },
  {
    "code": "K74.4",
    "name": "Sekundäre biliäre Zirrhose",
    "synonyms": [
      "Sekundäre biliäre Zirrhose",
      "Sekundäre cholestatische Zirrhose"
    ]
  },
  {
    "code": "K74.5",
    "name": "Biliäre Zirrhose",
    "synonyms": [
      "Biliäre Zirrhose",
      "Byler-Syndrom",
      "Hanot-Rössle-Syndrom",
      "Progressive familiäre intrahepatische Cholestase",
      "Progressive familiäre intrahepatische Cholestase Typ 1",
      "Progressive familiäre intrahepatische Cholestase Typ 2",
      "Progressive familiäre intrahepatische Cholestase Typ 3",
      "Progressive familiäre intrahepatische Cholestase Typ 4"
    ]
  },
  {
    "code": "K74.6",
    "name": "Cruveilhier-von-Baumgarten-Zirrhose",
    "synonyms": [
      "Autoimmune Leberzirrhose",
      "Baumgarten-Cruveilhier-Syndrom",
      "Baumgarten-Cruveilhier-Zirrhose",
      "Chronische interstitielle Hepatitis",
      "Cirrhosis - s.a. Zirrhose",
      "Cirrhosis hepatis",
      "Cruveilhier-von-Baumgarten-Krankheit",
      "Cruveilhier-von-Baumgarten-Syndrom",
      "Cruveilhier-von-Baumgarten-Zirrhose",
      "Dekompensierte Leberzirrhose",
      "Diätetische Zirrhose",
      "Hepatische portal dekompensierte Zirrhose",
      "Hepatolienale Zirrhose",
      "Hereditäre infantile Zirrhose der nordamerikanischen Indianer",
      "Idiopathische Kupfer-Zirrhose",
      "Kryptogene Leberzirrhose",
      "Leberkapselfibrose",
      "Leberzirrhose",
      "Leberzirrhose nach Hepatitis",
      "Makronoduläre Leberzirrhose",
      "Makronoduläre Zirrhose",
      "Mikronoduläre Leberzirrhose",
      "Mikronoduläre Zirrhose",
      "Nichtalkoholisch bedingte Leberzirrhose",
      "Nichtalkoholische Laënnec-Leberzirrhose",
      "Nutritive Zirrhose",
      "Periportale Zirrhose",
      "Portale Leberzirrhose",
      "Portale Zirrhose",
      "Posthepatitische Zirrhose",
      "Postnekrotische Leberzirrhose",
      "Postnekrotische Zirrhose",
      "Schrumpfleber",
      "Trabekelzirrhose",
      "Zirrhose",
      "Zirrhosemischform"
    ]
  },
  {
    "code": "K75.0",
    "name": "Leberabszess",
    "synonyms": [
      "Cholangitischer Leberabszess",
      "Cholangitischer Leberabszess mit Perforation",
      "Eitrige Hepatitis",
      "Eitrige Leberentzündung",
      "Hepatischer Abszess",
      "Hämatogener Leberabszess",
      "Intrahepatischer Abszess",
      "Leberabszess",
      "Lymphogener Leberabszess",
      "Pylephlebitischer Leberabszess"
    ]
  },
  {
    "code": "K75.1",
    "name": "Pfortaderphlebitis",
    "synonyms": [
      "Endophlebitis portalis",
      "Pfortaderphlebitis",
      "Pfortaderpyämie",
      "Phlebitis portalis",
      "Pylephlebitis",
      "Pylethrombophlebitis",
      "Thrombophlebitis der Pfortader"
    ]
  },
  {
    "code": "K75.2",
    "name": "Unspezifische reaktive Hepatitis",
    "synonyms": [
      "Unspezifische reaktive Hepatitis"
    ]
  },
  {
    "code": "K75.3",
    "name": "Lebergranulom a.n.k.",
    "synonyms": [
      "Granulomatöse Hepatitis a.n.k.",
      "Lebergranulom a.n.k."
    ]
  },
  {
    "code": "K75.4",
    "name": "Lupoide Hepatitis a.n.k.",
    "synonyms": [
      "Autoimmune Hepatitis",
      "Autoimmunhepatitis",
      "Autoimmunhepatitis Typ 1",
      "Autoimmunhepatitis Typ 2",
      "Chronische autoimmune Hepatitis",
      "IgG4-assoziierte Hepatopathie",
      "Lupoide Hepatitis a.n.k."
    ]
  },
  {
    "code": "K75.8",
    "name": "Cholangiohepatitis",
    "synonyms": [
      "Bakterielle Hepatitis",
      "Cholangiohepatitis",
      "Cholangiolitische Hepatitis",
      "Cholestatische Hepatitis",
      "Fettleberhepatitis",
      "Hepatocholangitis",
      "NASH [nicht-alkoholische Steatohepatitis]",
      "Nichtalkoholische Steatohepatitis",
      "Pericholangitis",
      "Perihepatitis chronica hyperplastica",
      "Zuckergussleber"
    ]
  },
  {
    "code": "K75.9",
    "name": "Gastrohepatitis",
    "synonyms": [
      "Entzündliche Leberkrankheit",
      "Gastrohepatitis",
      "Hepatitis",
      "Hepatitis contagiosa",
      "Leberentzündung",
      "Nicht virale Hepatitis"
    ]
  },
  {
    "code": "K76.0",
    "name": "Fettleber a.n.k.",
    "synonyms": [
      "Degenerative Fettleber",
      "Fettige Leberdegeneration a.n.k.",
      "Fettleber a.n.k.",
      "Hepar crocatum",
      "Lebersteatose a.n.k.",
      "Leberverfettung",
      "Nichtalkoholische Fettleber",
      "Safranleber",
      "Steatosis hepatis a.n.k."
    ]
  },
  {
    "code": "K76.1",
    "name": "Stauungsleber",
    "synonyms": [
      "Chronische Stauungsleber",
      "Chronische passive Leberstauung",
      "Cirrhose cardiaque",
      "Hepar moschatum",
      "Hepatische Stauung",
      "Herbstlaubleber",
      "Kardiale Lebersklerose",
      "Kardiale Leberzirrhose",
      "Leberstauungsatrophie",
      "Leberstauungsinduration",
      "Muskatnussleber",
      "Pfortaderstauung",
      "Stauungsleber",
      "Stauungszirrhose der Leber"
    ]
  },
  {
    "code": "K76.2",
    "name": "Zentrale hämorrhagische Lebernekrose",
    "synonyms": [
      "Zentrale hämorrhagische Lebernekrose"
    ]
  },
  {
    "code": "K76.3",
    "name": "Leberinfarkt",
    "synonyms": [
      "Leberapoplexie",
      "Leberinfarkt"
    ]
  },
  {
    "code": "K76.4",
    "name": "Peliosis hepatis",
    "synonyms": [
      "Idiopathische Peliosis hepatis",
      "Leberangiomatose",
      "Peliosis hepatis"
    ]
  },
  {
    "code": "K76.5",
    "name": "Veno-okklusive Leberkrankheit",
    "synonyms": [
      "Stuart-Bras-Syndrom",
      "Veno-okklusive Leberkrankheit"
    ]
  },
  {
    "code": "K76.6",
    "name": "Portale Hypertonie",
    "synonyms": [
      "Banti-Krankheit",
      "Banti-Syndrom",
      "Familiäre nicht-zirrhotische portale Hypertension mit frühem Beginn",
      "Hepatolienale Fibrose mit portaler Hypertonie",
      "Idiopathische Pfortaderhypertonie",
      "Pfortaderhochdruck",
      "Pfortaderhypertonie durch chronische Leberkrankheit",
      "Portale Hypertension",
      "Portale Hypertonie"
    ]
  },
  {
    "code": "K76.7",
    "name": "Hepatorenales Syndrom",
    "synonyms": [
      "Hepatorenale Degeneration",
      "Hepatorenales Syndrom",
      "Hepatorenales Syndrom Typ 1",
      "Hepatorenales Syndrom Typ 2",
      "Hepatorenales Versagen",
      "Heyd-Syndrom",
      "Urohepatisches Syndrom"
    ]
  },
  {
    "code": "K76.8",
    "name": "Konstitutionelle Leberdysfunktion",
    "synonyms": [
      "Aktive Leberhyperämie",
      "Akute Leberhypertrophie",
      "Alpha-Methylacyl-CoA-Racemase-Mangel",
      "Cholangiohepatose",
      "Cholestatische Hepatose",
      "Diffuse Leberdegeneration a.n.k.",
      "Disse-Raum-Fibrose",
      "Einfache Leberzyste",
      "Erweiterung des Lebersinus",
      "Erworbene Leberdeformität",
      "Erworbener intrahepatischer vaskulärer Shunt",
      "Fokale noduläre Leberhyperplasie",
      "Funktionelle Leberdysfunktion",
      "Gallensäuren-CoA-Ligase-Mangel mit mangelhafter Amidierung",
      "Gallensäuresynthesedefekt mit Cholestase und Malabsorption",
      "Hepatalgie",
      "Hepatoptose",
      "Hepatose",
      "Hyperbiliverdinämie",
      "Hypertrophische Leberdegeneration a.n.k.",
      "Kongenitaler Gallensäuresynthesedefekt",
      "Kongenitaler Gallensäuresynthesedefekt Typ 1",
      "Kongenitaler Gallensäuresynthesedefekt Typ 2",
      "Kongenitaler Gallensäuresynthesedefekt Typ 3",
      "Kongenitaler Gallensäuresynthesedefekt Typ 4",
      "Konstitutionelle Leberdysfunktion",
      "Leberblutung",
      "Leberdegeneration",
      "Leberdysfunktion",
      "Leberhämorrhagie",
      "Leberinduration",
      "Leberinfiltration",
      "Leberkapselblutung",
      "Lebermelanose",
      "Leberprolaps",
      "Leberptose",
      "Leberverhärtung",
      "Leberzelldegeneration",
      "NRH [Noduläre regenerative Hyperplasie] der Leber",
      "Nichttraumatisches Leberhämatom",
      "Nichttraumatisches subkapsuläres Leberhämatom",
      "Pigmentäre Leberdegeneration a.n.k.",
      "Portosinusoidale vaskuläre Erkrankung",
      "Solitärer nekrotischer Knoten der Leber",
      "Steroid-Dehydrogenase-Mangel mit Zahnanomalien",
      "Zystische Leberdegeneration a.n.k."
    ]
  },
  {
    "code": "K76.9",
    "name": "Leberschaden",
    "synonyms": [
      "Chronische Hepatopathie",
      "Chronische Leberkrankheit",
      "Chronischer Leberschaden",
      "Hepatopathie",
      "Lebererkrankung",
      "Leberkrankheit",
      "Leberparenchymschaden",
      "Leberschaden",
      "Leberstörung",
      "Leberzellschaden",
      "Nichttraumatischer Leberschaden",
      "Organische Leberkrankheit"
    ]
  },
  {
    "code": "K80.00",
    "name": "Gallenblasenstein mit akuter Cholezystitis",
    "synonyms": [
      "Cholelithiasis mit akuter Cholezystitis",
      "Cholezystolithiasis mit akuter Cholezystitis",
      "Eingeklemmter Gallenstein im Ductus cysticus mit akuter Cholezystitis",
      "Eingeklemmter Gallenstein in der Gallenblase mit akuter Cholezystitis",
      "Gallenblasenstein mit akuter Cholezystitis",
      "Rezidivierende Gallenblasenkolik mit akuter Cholezystitis"
    ]
  },
  {
    "code": "K80.01",
    "name": "Cholelithiasis mit akuter Cholezystitis mit Gallenwegsobstruktion",
    "synonyms": [
      "Cholelithiasis mit akuter Cholezystitis mit Gallenwegsobstruktion",
      "Cholezystolithiasis mit akuter Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus cysticus mit akuter Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein in der Gallenblase mit akuter Cholezystitis mit Gallenwegsobstruktion",
      "Rezidivierende Gallenblasenkolik mit akuter Cholezystitis mit Gallenwegsobstruktion"
    ]
  },
  {
    "code": "K80.10",
    "name": "Cholelithiasis mit Cholezystitis",
    "synonyms": [
      "Cholelithiasis mit Cholezystitis",
      "Cholelithiasis mit chronischer Cholezystitis",
      "Cholezystitis mit Stein",
      "Cholezystolithiasis mit chronischer Cholezystitis",
      "Eingeklemmter Gallenstein im Ductus cysticus mit chronischer Cholezystitis",
      "Eingeklemmter Gallenstein in der Gallenblase mit chronischer Cholezystitis",
      "Kalkulöse Cholezystitis",
      "Rezidivierende Gallenblasenkolik mit chronischer Cholezystitis"
    ]
  },
  {
    "code": "K80.11",
    "name": "Cholelithiasis mit chronischer Cholezystitis mit Gallenwegsobstruktion",
    "synonyms": [
      "Cholelithiasis mit chronischer Cholezystitis mit Gallenwegsobstruktion",
      "Cholezystolithiasis mit chronischer Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus cysticus mit chronischer Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein in der Gallenblase mit chronischer Cholezystitis mit Gallenwegsobstruktion",
      "Rezidivierende Gallenblasenkolik mit chronischer Cholezystitis mit Gallenwegsobstruktion"
    ]
  },
  {
    "code": "K80.20",
    "name": "Gallenblasenstein ohne Cholezystitis",
    "synonyms": [
      "Cholelithiasis",
      "Cholelithiasis der Gallenblase",
      "Cholelithiasis des Ductus cysticus",
      "Cholelithiasis mit Fistel",
      "Cholelithiasis mit Hydrops",
      "Cholelithiasis mit festsitzendem Stein",
      "Cholesterinablagerung in der Galle",
      "Cholesterinkalkstein",
      "Cholesterinkonkrement",
      "Cholesterinpartikel in der Gallenblase",
      "Cholesterinpigmentstein",
      "Cholesterinstein",
      "Cholezystolithiasis",
      "Eingeklemmter Gallenstein im Ductus cysticus",
      "Eingeklemmter Gallenstein in der Gallenblase",
      "Einklemmung eines Gallensteins",
      "Einklemmung eines Gallensteins im Ductus cysticus",
      "Festsitzender Gallenstein",
      "Gallenblasenausgussstein",
      "Gallenblasenfistel mit Gallenstein",
      "Gallenblasenkolik",
      "Gallenblasenkonkrement",
      "Gallenblasenstein",
      "Gallenblasenstein ohne Cholezystitis",
      "Gallenkolik",
      "Gallenstein",
      "Gallenstein im Ductus cysticus",
      "Gallenstein in der Gallenblase",
      "Gallensteinbildung",
      "Gallensteinkolik",
      "Gallensteinkrankheit",
      "Gallensteinleiden",
      "Kolik des Ductus cysticus",
      "Multiple Bilirubinsteine",
      "Multiple Cholelithiasis",
      "Multiple Gallensteine",
      "Rezidivierende Gallenblasenkolik",
      "Stein im Ductus cysticus",
      "Zystische Choledocholithiasis"
    ]
  },
  {
    "code": "K80.21",
    "name": "Mirizzi-Syndrom",
    "synonyms": [
      "Cholelithiasis mit Gallenwegsobstruktion",
      "Cholezystolithiasis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus cysticus mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein in der Gallenblase mit Gallenwegsobstruktion",
      "Mirizzi-Syndrom",
      "Rezidivierende Gallenblasenkolik mit Gallenwegsobstruktion"
    ]
  },
  {
    "code": "K80.30",
    "name": "Gallengangsstein mit Cholangitis",
    "synonyms": [
      "Cholangitis mit Stein",
      "Cholangolithiasis",
      "Choledocholithiasis mit Cholangitis",
      "Eingeklemmter Gallenstein im Ductus choledochus mit Cholangitis",
      "Eingeklemmter Gallenstein im Ductus hepaticus mit Cholangitis",
      "Eingeklemmter Gallenstein im Gallengang mit Cholangitis",
      "Gallengangsstein mit Cholangitis",
      "Intrahepatische Cholelithiasis mit Cholangitis",
      "Primäre Hepatolithiasis",
      "Rezidivierende Leberkolik mit Cholangitis"
    ]
  },
  {
    "code": "K80.31",
    "name": "Eingeklemmter Gallenstein im Ductus choledochus mit Cholangitis mit Gallenwegsobstruktion",
    "synonyms": [
      "Choledocholithiasis mit Cholangitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus choledochus mit Cholangitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus hepaticus mit Cholangitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Gallengang mit Cholangitis mit Gallenwegsobstruktion",
      "Intrahepatische Cholelithiasis mit Cholangitis mit Gallenwegsobstruktion",
      "Rezidivierende Leberkolik mit Cholangitis mit Gallenwegsobstruktion"
    ]
  },
  {
    "code": "K80.40",
    "name": "Gallengangsstein mit Cholezystitis",
    "synonyms": [
      "Choledocholithiasis mit Cholezystitis",
      "Choledocholithiasis mit akuter Cholezystitis",
      "Eingeklemmter Gallenstein im Ductus choledochus mit Cholezystitis",
      "Eingeklemmter Gallenstein im Ductus hepaticus mit Cholezystitis",
      "Eingeklemmter Gallenstein im Gallengang mit Cholezystitis",
      "Gallengangsstein mit Cholezystitis",
      "Intrahepatische Cholelithiasis mit Cholezystitis",
      "Rezidivierende Leberkolik mit Cholezystitis"
    ]
  },
  {
    "code": "K80.41",
    "name": "Choledocholithiasis mit Cholezystitis mit Gallenwegsobstruktion",
    "synonyms": [
      "Choledocholithiasis mit Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus choledochus mit Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus hepaticus mit Cholezystitis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Gallengang mit Cholezystitis mit Gallenwegsobstruktion",
      "Intrahepatische Cholelithiasis mit Cholezystitis mit Gallenwegsobstruktion",
      "Rezidivierende Leberkolik mit Cholezystitis mit Gallenwegsobstruktion"
    ]
  },
  {
    "code": "K80.50",
    "name": "Gallengangskolik",
    "synonyms": [
      "Choledocholith",
      "Choledocholithiasis",
      "Choledocholithiasis des Ductus hepaticus",
      "Choledochusstein",
      "Cholelithiasis des Ductus choledochus",
      "Cholelithiasis des Ductus hepaticus",
      "Cholelithiasis des Gallenganges",
      "Colica hepatica",
      "Eingeklemmter Gallenstein im Ductus choledochus",
      "Eingeklemmter Gallenstein im Ductus hepaticus",
      "Eingeklemmter Gallenstein im Gallengang",
      "Einklemmung eines Gallensteins im Ductus choledochus",
      "Einklemmung eines Gallensteins im Ductus hepaticus",
      "Einklemmung eines Gallensteins im Gallengang",
      "Festsitzender Leberstein",
      "Gallengangsfistel mit Stein",
      "Gallengangskolik",
      "Gallengangskonkrement",
      "Gallengangskrankheit mit Stein",
      "Gallengangsstein",
      "Gallenstein im Ductus choledochus",
      "Gallenstein im Ductus hepaticus",
      "Gallenwegsstein",
      "Intrahepatische Cholelithiasis",
      "Kolik des Ductus choledochus",
      "Kolik des Ductus hepaticus",
      "Lebergangkonkrement",
      "Lebergangstein",
      "Rezidivierende Leberkolik",
      "Stein im Ductus choledochus",
      "Stein im Ductus hepaticus",
      "Stein in der Vater-Papille"
    ]
  },
  {
    "code": "K80.51",
    "name": "Choledocholithiasis mit Gallenwegsobstruktion",
    "synonyms": [
      "Choledocholithiasis mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus choledochus mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Ductus hepaticus mit Gallenwegsobstruktion",
      "Eingeklemmter Gallenstein im Gallengang mit Gallenwegsobstruktion",
      "Gallengangsobstruktion mit Stein",
      "Gallengangsverschluss mit Stein",
      "Intrahepatische Cholelithiasis mit Gallenwegsobstruktion",
      "Rezidivierende Leberkolik mit Gallenwegsobstruktion"
    ]
  },
  {
    "code": "K80.80",
    "name": "Cholezystocholedocholithiasis",
    "synonyms": [
      "Cholelithiasis mit assoziierter ABCB4-Genmutation",
      "Cholelithiasis mit niedrigem Phospholipid-Spiegel",
      "Cholezystocholedocholithiasis",
      "Hepatobiliärer Stein"
    ]
  },
  {
    "code": "K81.0",
    "name": "Gallenblasengangrän",
    "synonyms": [
      "Akute Cholezystitis",
      "Akute Gallenblaseneiterung",
      "Akute eitrige Infektion der Gallenblase",
      "Akute emphysematöse Cholezystitis",
      "Akute emphysematöse Cholezystitis ohne Gallenstein",
      "Angiocholezystitis",
      "Angiocholezystitis ohne Gallenstein",
      "Cholangiozystitis",
      "Eitrige Cholezystitis",
      "Eitrige Cholezystitis ohne Gallenstein",
      "Eitrige Gallenblasenentzündung",
      "Gallenblasenabszess",
      "Gallenblasenabszess ohne Gallenstein",
      "Gallenblasenempyem",
      "Gallenblasenempyem ohne Gallenstein",
      "Gallenblasengangrän",
      "Gallenblasengangrän ohne Gallenstein",
      "Gallenblasennekrose",
      "Gangränöse Cholezystitis",
      "Gangränöse Cholezystitis ohne Gallenstein",
      "Pericholezystitis",
      "Suppurative Cholezystitis"
    ]
  },
  {
    "code": "K81.1",
    "name": "Porzellangallenblase",
    "synonyms": [
      "Chronische Cholezystitis",
      "Chronische Gallenblasenentzündung",
      "Porzellangallenblase"
    ]
  },
  {
    "code": "K81.8",
    "name": "Hepatozystitis",
    "synonyms": [
      "Hepatozystitis"
    ]
  },
  {
    "code": "K81.9",
    "name": "Cholezystitis",
    "synonyms": [
      "Cholezystitis",
      "Gallenblasenentzündung",
      "Gallenblaseninfektion",
      "Infektion des Ductus cysticus"
    ]
  },
  {
    "code": "K82.0",
    "name": "Gallenblasenokklusion",
    "synonyms": [
      "Erworbene Atresie des Ductus cysticus",
      "Gallenblasengangsokklusion",
      "Gallenblasengangsstenose",
      "Gallenblasengangstriktur",
      "Gallenblasenkonstriktion",
      "Gallenblasenobstruktion",
      "Gallenblasenokklusion",
      "Gallenblasenokklusion ohne Stein",
      "Gallenblasenstenose",
      "Gallenblasenstenose ohne Stein",
      "Gallenblasenstriktur",
      "Gallenblasenstriktur ohne Stein",
      "Gallenblasenverschluss",
      "Obstruktion des Ductus cysticus",
      "Okklusion des Ductus cysticus ohne Stein",
      "Stenose des Ductus cysticus",
      "Stenose des Ductus cysticus ohne Stein",
      "Striktur des Ductus cysticus",
      "Striktur des Ductus cysticus ohne Stein",
      "Verschluss des Ductus cysticus"
    ]
  },
  {
    "code": "K82.1",
    "name": "Stauungsgallenblase",
    "synonyms": [
      "Gallenblasenhydrops",
      "Gallenblasenmukozele",
      "Stauungsgallenblase"
    ]
  },
  {
    "code": "K82.2",
    "name": "Gallenblasenperforation",
    "synonyms": [
      "Gallenblasengangsruptur",
      "Gallenblasenperforation",
      "Gallenblasenruptur",
      "Perforation des Ductus cysticus",
      "Ruptur des Ductus cysticus"
    ]
  },
  {
    "code": "K82.3",
    "name": "Fistula cholecystoduodenalis",
    "synonyms": [
      "Cholezystoduodenalfistel",
      "Fistel des Ductus cysticus",
      "Fistula biliaris",
      "Fistula cholecystocolica",
      "Fistula cholecystoduodenalis",
      "Fistula cholecystoenterica",
      "Fistula cholecystogastrica",
      "Fistula cholecystointestinalis",
      "Gallenblasen-Magen-Fistel",
      "Gallenblasenduodenalfistel",
      "Gallenblasenfistel"
    ]
  },
  {
    "code": "K82.4",
    "name": "Gallenblasencholesteatose",
    "synonyms": [
      "Cholesteatose",
      "Erdbeergallenblase",
      "Gallenblasencholesteatose",
      "Stippchengallenblase"
    ]
  },
  {
    "code": "K82.8",
    "name": "Funktionelle Cholezystopathie",
    "synonyms": [
      "Adhäsion des Ductus cysticus",
      "Atrophie des Ductus cysticus",
      "Cholezystektasie",
      "Dilatation des Ductus cysticus",
      "Dysfunktion des Ductus cysticus",
      "Dyskinesie des Ductus cysticus",
      "Erworbene Deformität des Ductus cysticus",
      "Erworbene Dilatation des Gallenblasenganges",
      "Erworbene Gallenblasendeformität",
      "Funktionelle Cholezystopathie",
      "Funktionsuntüchtigkeit der Gallenblase",
      "Funktionsuntüchtigkeit des Ductus cysticus",
      "Gallenblasenadhäsion",
      "Gallenblasenatrophie",
      "Gallenblasendilatation",
      "Gallenblasendysfunktion",
      "Gallenblasendyskinesie",
      "Gallenblasengangsadhäsion",
      "Gallenblasengangsatrophie",
      "Gallenblasengangsdyskinesie",
      "Gallenblasengangsgeschwür",
      "Gallenblasengangshypertrophie",
      "Gallenblasengangsulkus",
      "Gallenblasengangsverwachsung",
      "Gallenblasengangszyste",
      "Gallenblasengeschwür",
      "Gallenblasenhypertrophie",
      "Gallenblaseninsuffizienz",
      "Gallenblasenkalzifikation",
      "Gallenblasenkontraktur",
      "Gallenblasenpolyp",
      "Gallenblasenschleimzyste",
      "Gallenblasentorsion",
      "Gallenblasenulkus",
      "Gallenblasenzyste",
      "Gallenwegsdyskinesie",
      "Hypertrophie des Ductus cysticus",
      "Kontraktur des Ductus cysticus",
      "Lageanomalie der Gallenblase",
      "Nichtfunktionierende Gallenblase",
      "Postinfektiöse Adhäsion des Ductus cysticus",
      "Sanduhrgallenblase",
      "Schleimhautblutung der Gallenblase",
      "Schleimhautpolyp der Gallenblase",
      "Schrumpfgallenblase",
      "Torsion des Ductus cysticus",
      "Ulkus des Ductus cysticus",
      "Zyste des Ductus cysticus"
    ]
  },
  {
    "code": "K82.9",
    "name": "Chronische Galle",
    "synonyms": [
      "Cholepathie",
      "Cholezystopathie",
      "Chronische Galle",
      "Funktionelle Gallenbeschwerden",
      "Funktionsstörung der Galle",
      "Gallenbeschwerden",
      "Gallenblasenaffektion",
      "Gallenblasenkrankheit",
      "Gallenblasenreizung",
      "Gallenleiden"
    ]
  },
  {
    "code": "K83.00",
    "name": "Isolierte neonatale sklerosierende Cholangitis",
    "synonyms": [
      "Isolierte neonatale sklerosierende Cholangitis",
      "PSC [Primär sklerosierende Cholangitis]",
      "Primär sklerosierende Cholangitis"
    ]
  },
  {
    "code": "K83.01",
    "name": "IgG4-assoziierte sklerosierende Cholangitis",
    "synonyms": [
      "IgG4-assoziierte sklerosierende Cholangitis",
      "Sekundär sklerosierende Cholangitis"
    ]
  },
  {
    "code": "K83.08",
    "name": "Cholangitis purulenta",
    "synonyms": [
      "Aszendierende Cholangitis",
      "Cholangitis purulenta",
      "Eitrige Cholangitis",
      "Eitrige Choledochitis",
      "Primäre Cholangitis",
      "Rezidivierende Cholangitis",
      "Sekundäre Cholangitis",
      "Sklerosierende Cholangitis",
      "Stenosierende Cholangitis"
    ]
  },
  {
    "code": "K83.09",
    "name": "Choledochitis",
    "synonyms": [
      "Akute Cholangiolitis",
      "Bakterielle Cholangitis",
      "Cholangiolitis",
      "Cholangitis",
      "Choledochitis",
      "Choledochusentzündung",
      "Choledochusinfektion",
      "Chronische Cholangiolitis",
      "Duodenocholangitis",
      "Entzündung des Ductus choledochus",
      "Entzündung des Ductus hepaticus",
      "Extrahepatische Cholangiolitis",
      "Gallengangsentzündung",
      "Gallengangsinfektion",
      "Gallenwegsentzündung",
      "Gangränöse Cholangiolitis",
      "Infektion der Gallenwege",
      "Infektion des Ductus choledochus",
      "Infektion des Ductus hepaticus",
      "Intrahepatische Cholangiolitis",
      "Pericholangiolitis"
    ]
  },
  {
    "code": "K83.1",
    "name": "Acholie",
    "synonyms": [
      "Acholie",
      "Biliäre Stauung",
      "Choledochuseinengung",
      "Choledochusstenose",
      "Choledochusverschluss",
      "Cholestase a.n.k.",
      "Cholostase a.n.k. - s.a. Cholestase",
      "Erworbene Choledochusstenose",
      "Erworbene Gallengangsatresie",
      "Erworbene Gallengangsstriktur",
      "Extrahepatische Cholestase a.n.k.",
      "Gallengangsobliteration, nicht durch Steine",
      "Gallengangsobstruktion, nicht durch Steine",
      "Gallengangsokklusion ohne Gallenstein",
      "Gallengangsstenose",
      "Gallengangsstenose ohne Gallenstein",
      "Gallengangsstriktur",
      "Gallengangsstriktur ohne Gallenstein",
      "Gallengangsverschluss",
      "Gallenstase, nicht durch Steine",
      "Gallenstauung",
      "Hepatobiliäre Obstruktion",
      "Mechanischer Ikterus",
      "Obstruktion des Ductus choledochus, nicht durch Steine",
      "Obstruktion des Ductus hepaticus, nicht durch Steine",
      "Obstruktionsikterus",
      "Obstruktiver Ikterus",
      "Stenose des Ductus choledochus",
      "Stenose des Ductus hepaticus",
      "Striktur des Ductus choledochus",
      "Striktur des Ductus hepaticus",
      "Verschluss des Ductus choledochus, nicht durch Steine",
      "Verschluss des Ductus hepaticus, nicht durch Steine",
      "Verschlussikterus"
    ]
  },
  {
    "code": "K83.2",
    "name": "Choledochusperforation",
    "synonyms": [
      "Choledochusperforation",
      "Gallengangsperforation",
      "Gallengangsruptur",
      "Perforation des Ductus choledochus",
      "Perforation des Ductus hepaticus",
      "Ruptur des Ductus choledochus",
      "Ruptur des Ductus hepaticus"
    ]
  },
  {
    "code": "K83.3",
    "name": "Choledochoduodenale Fistel",
    "synonyms": [
      "Choledochoduodenale Fistel",
      "Choledochojejunale Fistel",
      "Fistel der Gallenwege",
      "Fistel des Ductus choledochus",
      "Fistel des Ductus hepaticus",
      "Fistula choledochoduodenalis",
      "Gallengangsfistel"
    ]
  },
  {
    "code": "K83.4",
    "name": "Spasmus des Sphincter Oddi",
    "synonyms": [
      "Dysfunktion des Sphincter Oddi",
      "Spasmus der Vater-Papille",
      "Spasmus des Sphincter Oddi"
    ]
  },
  {
    "code": "K83.5",
    "name": "Biliäre Zyste",
    "synonyms": [
      "Biliäre Zyste",
      "Gallengangszyste",
      "Zyste des Ductus choledochus",
      "Zyste des Ductus hepaticus"
    ]
  },
  {
    "code": "K83.8",
    "name": "Choledochusspasmus",
    "synonyms": [
      "Cholangiektasie",
      "Choledochusadhäsion",
      "Choledochusspasmus",
      "Dilatation des Ductus choledochus",
      "Dyscholie",
      "Dyssynergie der Gallengänge",
      "Erworbene Gallengangsdeformität",
      "Erworbene Gallengangsdilatation",
      "Erworbene Gallenwegsdeformität",
      "Gallengangsadhäsion",
      "Gallengangsatrophie",
      "Gallengangsgeschwür",
      "Gallengangshypertrophie",
      "Gallengangskontraktur",
      "Gallengangsnarbe",
      "Gallengangsnekrose",
      "Gallengangsproliferation",
      "Gallengangstorsion",
      "Gallengangsulkus",
      "Gallengangswucherung",
      "Gallenwegsblutung",
      "Gallenwegshämorrhagie",
      "Gallenwegskrampf",
      "Hypertrophie des Ductus choledochus",
      "Hypertrophie des Ductus hepaticus",
      "Hämatobilie",
      "Hämobilie",
      "Idiopathische Duktopenie im Erwachsenenalter",
      "Kontraktur des Ductus choledochus",
      "Kontraktur des Ductus hepaticus",
      "Narbe des Ductus choledochus",
      "Narbe des Ductus hepaticus",
      "Pathologischer Druckanstieg in den Gallenwegen",
      "Spasmus des Ductus choledochus",
      "Torsion des Ductus choledochus",
      "Torsion des Ductus hepaticus",
      "Ulkus des Ductus choledochus",
      "Ulkus des Ductus hepaticus"
    ]
  },
  {
    "code": "K83.9",
    "name": "Choledochopathie",
    "synonyms": [
      "Cholangiopathie",
      "Choledochopathie",
      "Gallengangskrankheit",
      "Gallengangsschädigung",
      "Gallenwegsaffektion",
      "Gallenwegskrankheit",
      "Gallenwegsstörung",
      "Hepatobiliäre Krankheit",
      "Krankheit des Ductus choledochus",
      "Krankheit des Ductus hepaticus"
    ]
  },
  {
    "code": "K85.00",
    "name": "Idiopathische akute Pankreatitis",
    "synonyms": [
      "Idiopathische akute Pankreatitis"
    ]
  },
  {
    "code": "K85.01",
    "name": "Idiopathische akute Pankreatitis mit Organkomplikation",
    "synonyms": [
      "Idiopathische akute Pankreatitis mit Organkomplikation"
    ]
  },
  {
    "code": "K85.10",
    "name": "Biliäre akute Pankreatitis",
    "synonyms": [
      "Biliäre Pankreaskopfpankreatitis",
      "Biliäre akute Pankreatitis",
      "Gallenstein-Pankreatitis"
    ]
  },
  {
    "code": "K85.11",
    "name": "Biliäre akute Pankreatitis mit Organkomplikation",
    "synonyms": [
      "Biliäre akute Pankreatitis mit Organkomplikation"
    ]
  },
  {
    "code": "K85.20",
    "name": "Alkoholinduzierte Pankreatitis",
    "synonyms": [
      "Alkoholinduzierte Pankreatitis",
      "Alkoholinduzierte akute Pankreatitis"
    ]
  },
  {
    "code": "K85.21",
    "name": "Alkoholinduzierte Pankreasnekrose",
    "synonyms": [
      "Alkoholinduzierte Pankreasnekrose",
      "Alkoholinduzierte Pankreatitis mit Organkomplikation"
    ]
  },
  {
    "code": "K85.30",
    "name": "Medikamenteninduzierte Pankreatitis",
    "synonyms": [
      "Medikamenteninduzierte Pankreatitis",
      "Medikamenteninduzierte akute Pankreatitis"
    ]
  },
  {
    "code": "K85.31",
    "name": "Medikamenteninduzierte Pankreatitis mit Organmanifestation",
    "synonyms": [
      "Medikamenteninduzierte Pankreatitis mit Organmanifestation"
    ]
  },
  {
    "code": "K85.90",
    "name": "Pankreatitis",
    "synonyms": [
      "Akute Pankreasentzündung",
      "Akute Pankreasinfektion",
      "Akute Pankreatitis",
      "Akute Pankreatitis anulare",
      "Akute interstitielle Pankreatitis",
      "Akute rezidivierende Pankreatitis",
      "Akute ödematöse Pankreatitis",
      "Bauchspeicheldrüsenentzündung",
      "Pankreasentzündung",
      "Pankreaskopfpankreatitis",
      "Pankreatitis",
      "Subakute Pankreatitis"
    ]
  },
  {
    "code": "K85.91",
    "name": "Akute nekrotisierende Pankreatitis",
    "synonyms": [
      "Akute Pankreaseiterung",
      "Akute Pankreasnekrose",
      "Akute hämorrhagische Pankreatitis",
      "Akute nekrotisierende Pankreatitis",
      "Eitrige Pankreasnekrose",
      "Eitrige Pankreatitis",
      "Gangränöse Pankreatitis",
      "Hämorrhagisch nekrotisierende Pankreatitis",
      "Hämorrhagische Pankreasnekrose",
      "Hämorrhagische Pankreatitis",
      "Infektiöse Pankreasnekrose",
      "Nekrotisierende Pankreatitis",
      "Pankreasabszess",
      "Pankreasgangabszess",
      "Pankreasgangrän"
    ]
  },
  {
    "code": "K86.0",
    "name": "Alkoholinduzierte chronische Pankreatitis",
    "synonyms": [
      "Alkoholinduzierte chronische Pankreatitis",
      "Alkoholische Pankreasschädigung",
      "Alkoholtoxische Pankreasinsuffizienz",
      "Alkoholtoxische Pankreatopathie"
    ]
  },
  {
    "code": "K86.10",
    "name": "Autoimmunpankreatitis",
    "synonyms": [
      "AIP [Autoimmunpankreatitis]",
      "Autoimmune Pankreatitis",
      "Autoimmunpankreatitis",
      "Autoimmunpankreatitis Typ 1",
      "Autoimmunpankreatitis Typ 2"
    ]
  },
  {
    "code": "K86.11",
    "name": "Hereditäre chronische Pankreatitis",
    "synonyms": [
      "Genetisch bedingte Pankreatitis",
      "Hereditäre Pankreatitis",
      "Hereditäre chronische Pankreatitis"
    ]
  },
  {
    "code": "K86.18",
    "name": "Chronische Pankreatitis",
    "synonyms": [
      "Chronisch-rezidivierende Pankreatitis",
      "Chronische Pankreatitis",
      "Chronische fibröse Pankreatitis",
      "Chronische infektiöse Pankreatitis",
      "Chronische interstitielle Pankreatitis",
      "Chronische rekurrierende Pankreatitis",
      "Chronische zystische Pankreatitis",
      "Kalzifizierende Pankreatitis",
      "Rezidivierende Pankreatitis",
      "Tropische Pankreatitis"
    ]
  },
  {
    "code": "K86.2",
    "name": "Pankreasgangzyste",
    "synonyms": [
      "Pankreasgangzyste",
      "Pankreaszyste",
      "Peripankreatische Zyste",
      "Zystische Pankreaskrankheit"
    ]
  },
  {
    "code": "K86.3",
    "name": "Pankreaspseudozyste",
    "synonyms": [
      "Pankreaspseudozyste"
    ]
  },
  {
    "code": "K86.80",
    "name": "Stein im Bauchspeicheldrüsengang",
    "synonyms": [
      "Pankreasgangstein ohne Pankreasgangstenose",
      "Stein im Bauchspeicheldrüsengang",
      "Stein im Ductus pancreaticus",
      "Stein im Pankreasgang"
    ]
  },
  {
    "code": "K86.81",
    "name": "Pankreasgangstein mit Pankreasgangstenose",
    "synonyms": [
      "Pankreasgangstein mit Pankreasgangstenose"
    ]
  },
  {
    "code": "K86.82",
    "name": "Verschluss des Ductus pancreaticus",
    "synonyms": [
      "Obstruktion des Ductus pancreaticus",
      "Pankreasgangstenose",
      "Verschluss des Ductus pancreaticus"
    ]
  },
  {
    "code": "K86.83",
    "name": "Exkretorische Pankreasinsuffizienz",
    "synonyms": [
      "Exkretorische Pankreasinsuffizienz",
      "Exokrine Pankreasinsuffizienz",
      "Störung der exokrinen Pankreasfunktion"
    ]
  },
  {
    "code": "K86.84",
    "name": "Pankreasfistel",
    "synonyms": [
      "Pankreasfistel",
      "Pankreatikoduodenale Fistel",
      "Pankreatoduodenale Fistel"
    ]
  },
  {
    "code": "K86.88",
    "name": "Pankreolithiasis",
    "synonyms": [
      "Achylia pancreatica",
      "Aseptische Pankreasnekrose",
      "Atrophie des Ductus pancreaticus",
      "Dilatation des Ductus pancreaticus",
      "Endokrine Pankreasinsuffizienz",
      "Erworbene Pankreasdeformität",
      "Infantilismus pancreaticus",
      "Nichttraumatische Pankreasruptur",
      "Pankreasachylie",
      "Pankreasatrophie",
      "Pankreasblutung",
      "Pankreasdegeneration",
      "Pankreasfettgewebsnekrose",
      "Pankreasfibrose",
      "Pankreashämorrhagie",
      "Pankreasinsuffizienz",
      "Pankreaskalzifikation",
      "Pankreasnekrose",
      "Pankreasparenchymunterfunktion",
      "Pankreassklerose",
      "Pankreasstauung",
      "Pankreasstein",
      "Pankreaszirrhose",
      "Pankreasüberfunktion",
      "Pankreatischer Infantilismus",
      "Pankreatischer Minderwuchs",
      "Pankreolithiasis",
      "Totale Pankreasinsuffizienz",
      "Verminderte Funktion des Pankreasparenchyms"
    ]
  },
  {
    "code": "K86.9",
    "name": "Krankheit der Bauchspeicheldrüse",
    "synonyms": [
      "Krankheit der Bauchspeicheldrüse",
      "Pankreaskrankheit",
      "Pankreasschädigung",
      "Pankreatopathie"
    ]
  },
  {
    "code": "K90.0",
    "name": "Einheimische Sprue",
    "synonyms": [
      "Coeliacia - s.a. Zöliakie",
      "Czerny-Spätatrophie",
      "Einheimische Sprue",
      "Gee-Herter-Thaysen-Krankheit",
      "Gee-Thaysen-Krankheit",
      "Gluten-sensitive Enteropathie",
      "Glutenallergie",
      "Glutenenteropathie",
      "Glutenunverträglichkeit",
      "Herter-Gee-Syndrom",
      "Herter-Heubner-Syndrom",
      "Herter-Infantilismus",
      "Heubner-Herter-Krankheit",
      "Idiopathische Sprue",
      "Idiopathische Steatorrhoe",
      "Intestinaler Infantilismus",
      "Nichttropische Sprue",
      "Primäre Steatorrhoe",
      "Rachitis bei Zöliakie",
      "Refraktäre Zöliakie",
      "Sprue-Syndrom",
      "Thaysen-Krankheit",
      "Zöliakaler Infantilismus",
      "Zöliakie",
      "Zöliakie beim Erwachsenen",
      "Zöliakie beim Kind"
    ]
  },
  {
    "code": "K90.1",
    "name": "Tropische Sprue",
    "synonyms": [
      "Psilosis linguae",
      "Sprue",
      "Tropische Diarrhoe",
      "Tropische Sprue",
      "Tropische Steatorrhoe"
    ]
  },
  {
    "code": "K90.2",
    "name": "Blind-loop-Syndrom",
    "synonyms": [
      "Blind-loop-Syndrom",
      "Syndrom der blinden Schlinge"
    ]
  },
  {
    "code": "K90.3",
    "name": "Pankreatogene Steatorrhoe",
    "synonyms": [
      "Colipase-Mangel",
      "Kombinierter Lipase-Kolipase-Mangel des Pankreas",
      "Pankreatische Fettabsorptionsstörung",
      "Pankreatischer Triglyceridlipase-Mangel",
      "Pankreatogene Steatorrhoe",
      "Verminderte Lipasefunktion"
    ]
  },
  {
    "code": "K90.4",
    "name": "Nahrungsmittelintoleranz",
    "synonyms": [
      "Chronische Steatorrhoe",
      "Enteropathie mit Proteinverlust",
      "Fettabsorptionsstörung",
      "Fettintoleranz a.n.k.",
      "Kohlenhydratabsorptionsstörung",
      "Kohlenhydratintoleranz",
      "Malabsorption durch Eiweißintoleranz",
      "Malabsorption durch Fettintoleranz",
      "Malabsorption durch Kohlenhydratintoleranz",
      "Malabsorption durch Stärkeintoleranz",
      "Malabsorption von Fett",
      "Malabsorption von Kohlenhydraten",
      "Malabsorption von Protein",
      "Malabsorption von Stärke",
      "Milchintoleranz a.n.k.",
      "NZWS [Nicht-Zöliakie-Weizensensitivität]",
      "Nahrungsmittelintoleranz",
      "Nicht-Zöliakie-Weizensensitivität",
      "Proteinabsorptionsstörung",
      "Proteinintoleranz",
      "Steatorrhoe",
      "Stärkeabsorptionsstörung",
      "Stärkeintoleranz a.n.k.",
      "Verminderte Fetttoleranz"
    ]
  },
  {
    "code": "K90.8",
    "name": "Intestinale Lipodystrophie",
    "synonyms": [
      "Chologene Diarrhoe",
      "Enterische Anendokrinose",
      "Gallensäure-Verlustsyndrom",
      "Idiopathische Malabsorption durch Gallensäuresynthesedefekt",
      "Intestinale Lipodystrophie",
      "Kongenitale Enteropathie durch Enteropeptidase-Mangel",
      "Kongenitale Mikrovillus-Atrophie",
      "Lipodystrophia intestinalis",
      "Malabsorption von Kalzium",
      "Syndromale angeborene Natriumdiarrhoe",
      "Syndromale angeborene Tufting-Enteropathie"
    ]
  },
  {
    "code": "K90.9",
    "name": "Intestinale Malabsorption",
    "synonyms": [
      "Absorptionsstörung",
      "Assimilationsstörung von Nahrungsmitteln",
      "Chronisches Darmversagen",
      "Intestinale Malabsorption",
      "Malabsorption",
      "Malabsorptionssyndrom",
      "Störung der Nahrungsverwertung"
    ]
  },
  {
    "code": "K91.0",
    "name": "Erbrechen nach Magen-Darm-Operation",
    "synonyms": [
      "Erbrechen nach Magen-Darm-Operation"
    ]
  },
  {
    "code": "K91.1",
    "name": "Dumping-Syndrom",
    "synonyms": [
      "Agastrisches Syndrom",
      "Alimentäre Kollapsneigung nach Magenresektion",
      "Alimentäres Frühsyndrom nach Magenresektion",
      "Dumping-Syndrom",
      "Dumping-Syndrom nach chirurgischem Eingriff",
      "Jejunumsyndrom",
      "Nutritive Hypersekretion",
      "Postgastrektomiesyndrom",
      "Postvagotomiesyndrom",
      "Sekundäre Achlorhydrie nach Vagotomie",
      "Syndrom des operierten Magens"
    ]
  },
  {
    "code": "K91.2",
    "name": "Postoperative Resorptionsstörung",
    "synonyms": [
      "Blind-loop-Syndrom nach operativem Eingriff",
      "Kurzdarmsyndrom",
      "Kurzdarmsyndrom nach chirurgischem Eingriff",
      "Malabsorption nach chirurgischem Eingriff a.n.k.",
      "Malabsorptionssyndrom nach operativem Eingriff",
      "Malnutrition durch Magen-Darm-Operation",
      "Postoperative Malnutrition",
      "Postoperative Resorptionsstörung",
      "Postoperative Störung der Kohlenhydratabsorption im Darm",
      "Postoperatives Malabsorptionssyndrom",
      "Short-bowel-Syndrom",
      "Syndrom der blinden Schlinge nach chirurgischem Eingriff",
      "Syndrom der zuführenden Schlinge"
    ]
  },
  {
    "code": "K91.3",
    "name": "Postoperativer Darmverschluss",
    "synonyms": [
      "Darmverschluss nach chirurgischem Eingriff",
      "Postoperative Adhäsion mit Darmverschluss",
      "Postoperative Darmobstruktion",
      "Postoperativer Darmverschluss"
    ]
  },
  {
    "code": "K91.4",
    "name": "Funktionsmangel nach Kolostomie",
    "synonyms": [
      "Anus-praeter-Prolaps",
      "Anus-praeter-Stenose",
      "Anus-praeter-transversus-Prolaps",
      "Dysfunktion eines Darmstomas",
      "Dysfunktion nach Enterostomie",
      "Dysfunktion nach Ileostomie",
      "Dysfunktion nach Jejunostomie",
      "Dysfunktion nach Kolostomie",
      "Enterostomie mit Abszess",
      "Funktionsgestörte Kolostomie",
      "Funktionsmangel nach Enterostomie",
      "Funktionsmangel nach Kolostomie",
      "Funktionsstörung des Ileostomas",
      "Funktionsstörung nach Enterostomie",
      "Ileostomie mit Abszess",
      "Ileostomieprolaps",
      "Kolostomie mit Abszess",
      "Kolostomie-Fistel",
      "Kolostomieprolaps",
      "Komplikation durch Enterostomie",
      "Komplikation durch Ileostomie",
      "Komplikation durch Jejunostomie",
      "Komplikation durch Kolostomie",
      "Komplikation durch Stoma",
      "Komplikation durch Zäkostomie",
      "Stenose einer Enterostomie",
      "Stenose einer Kolostomie",
      "Stomastriktur nach Enterostomie",
      "Stomastriktur nach Kolostomie",
      "Zäkostomieprolaps"
    ]
  },
  {
    "code": "K91.5",
    "name": "Postcholezystektomiesyndrom",
    "synonyms": [
      "Beschwerden nach Gallenblasenexstirpation",
      "Beschwerden nach Gallenblasenoperation",
      "Postcholezystektomiebeschwerden",
      "Postcholezystektomiesyndrom"
    ]
  },
  {
    "code": "K91.80",
    "name": "Generalisierte Mukositis bei Immunkompromittierung",
    "synonyms": [
      "Generalisierte Mukositis bei Immunkompromittierung"
    ]
  },
  {
    "code": "K91.81",
    "name": "Nahtinsuffizienz nach Operationen an Gallenblase und Gallenwegen",
    "synonyms": [
      "Insuffizienz von Anastomosen nach Operationen an Gallenblase und Gallenwegen",
      "Nahtinsuffizienz nach Operationen an Gallenblase und Gallenwegen"
    ]
  },
  {
    "code": "K91.82",
    "name": "Insuffizienz von Anastomosen nach Operationen am Pankreas",
    "synonyms": [
      "Insuffizienz von Anastomosen nach Operationen am Pankreas",
      "Insuffizienz von Anastomosen nach Operationen am Pankreas mit Beteiligung des Dünndarms",
      "Nahtinsuffizienz nach Operationen am Pankreas",
      "Nahtinsuffizienz nach Operationen am Pankreas mit Beteiligung des Dünndarms"
    ]
  },
  {
    "code": "K91.83",
    "name": "Anastomoseninsuffizienz nach Magenresektion",
    "synonyms": [
      "Anastomoseninsuffizienz im Gastrointestinaltrakt",
      "Anastomoseninsuffizienz nach Magenresektion",
      "Anastomoseninsuffizienz nach Operation am Anus",
      "Anastomoseninsuffizienz nach Operation am Darm",
      "Anastomoseninsuffizienz nach Operation am Rektum",
      "Anastomoseninsuffizienz nach Operation am Ösophagus",
      "Nahtinsuffizienz nach Operation am Anus",
      "Nahtinsuffizienz nach Operation am Darm",
      "Nahtinsuffizienz nach Operation am Magen",
      "Nahtinsuffizienz nach Operation am Rektum",
      "Nahtinsuffizienz nach Operation am Ösophagus",
      "Rektumstumpfinsuffizienz"
    ]
  },
  {
    "code": "K91.84",
    "name": "Stomastriktur nach Gastrostomie",
    "synonyms": [
      "Postoperative Gallengangsstriktur",
      "Stomastriktur nach Gastrostomie",
      "Striktur am Verdauungstrakt nach Operation",
      "Striktur nach endoskopischem Eingriff am Verdauungstrakt"
    ]
  },
  {
    "code": "K91.88",
    "name": "Diarrhoe nach Magen-Darm-Operation",
    "synonyms": [
      "Afferent-loop-Syndrom",
      "Akute primäre Pouchitis",
      "Cholestase durch parenterale Ernährung",
      "Chronische primäre Pouchitis",
      "Diarrhoe nach Magen-Darm-Operation",
      "Dysfunktion nach Gastrostomie",
      "Funktionelle Diarrhoe nach Magen-Darm-Operation",
      "Funktionelle Störung des Verdauungssystems nach medizinischen Maßnahmen a.n.k.",
      "Intestinale Anastomose mit Komplikation a.n.k.",
      "Komplikation durch Gastrostomie",
      "Leberversagen nach chirurgischem Eingriff",
      "Leberversagen nach medizinischen Maßnahmen",
      "Mechanische Schwierigkeiten bei Gastroduodenostomie",
      "Postoperative Parotitis",
      "Postoperatives hepatorenales Syndrom",
      "Pouchitis",
      "Rektumstriktur nach Bestrahlung",
      "Sekundäre Pouchitis"
    ]
  },
  {
    "code": "K91.9",
    "name": "Störung des Verdauungssystems nach medizinischen Maßnahmen",
    "synonyms": [
      "Gastrointestinale Komplikation nach chirurgischem Eingriff",
      "Störung des Verdauungssystems nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "K92.0",
    "name": "Hämatemesis",
    "synonyms": [
      "Bluterbrechen",
      "Hämatemesis",
      "Hämatinerbrechen"
    ]
  },
  {
    "code": "K92.1",
    "name": "Meläna",
    "synonyms": [
      "Blutstuhl",
      "Hämatochezie",
      "Meläna",
      "Pechstuhl",
      "Schwarzruhr",
      "Teerfarbiger Stuhl",
      "Teerstuhl"
    ]
  },
  {
    "code": "K92.2",
    "name": "Darmblutung",
    "synonyms": [
      "Blutung aus dem Gastrointestinaltrakt",
      "Darmblutung",
      "Darmhämorrhagie",
      "Dickdarmblutung",
      "Duodenalblutung",
      "Duodenalhämorrhagie",
      "Dünndarmblutung",
      "Enterorrhagie",
      "Gastroenterische Blutung",
      "Gastroenterische Hämorrhagie",
      "Gastrointestinale Blutung",
      "Gastrointestinale Hämorrhagie",
      "Gastrorrhagie",
      "Gastrostaxis",
      "Hämorrhagie des Duodenums",
      "Hämorrhagie des Intestinums",
      "Intestinalblutung",
      "Kolonblutung",
      "Kolonhämorrhagie",
      "Magen-Darm-Blutung",
      "Magenausgussblutung",
      "Magenblutung",
      "Magenhämorrhagie",
      "Okkulte Darmblutung",
      "Okkulte Intestinalblutung",
      "Zäkumblutung",
      "Zäkumhämorrhagie"
    ]
  },
  {
    "code": "K92.8",
    "name": "Ulzerative Mukositis des Gastrointestinaltraktes",
    "synonyms": [
      "Anusmukositis",
      "Duodenummukositis",
      "Dünndarmmukositis",
      "Enterales Eiweißverlustsyndrom",
      "Ileummukositis",
      "Kolonmukositis",
      "Magenmukositis",
      "Perianale Mukositis",
      "Perirektale Mukositis",
      "Rektummukositis",
      "Sigmamukositis",
      "Ulzerative Mukositis des Gastrointestinaltraktes",
      "Ösophagusmukositis"
    ]
  },
  {
    "code": "K92.9",
    "name": "Krankheit des Verdauungssystems",
    "synonyms": [
      "Akute Magen-Darm-Erkrankung",
      "Akute Magen-Darm-Störung",
      "Akute gastrointestinale Beschwerden",
      "Gastroenteropathie",
      "Gastrointestinale Beschwerden",
      "Gastrointestinale Komplikation",
      "Gastrointestinale Krankheit",
      "Gastrointestinale Störung",
      "Krankheit des Verdauungssystems",
      "Magen-Darm-Krankheit",
      "Störung des Verdauungssystems",
      "Verdauungsproblem"
    ]
  },
  {
    "code": "L00.0",
    "name": "Staphylococcal scalded skin syndrome",
    "synonyms": [
      "Dermatitis erysipelatosa",
      "Dermatitis exfoliativa infantum",
      "Dermatitis exfoliativa neonatorum",
      "Dermatitis exfoliativa neonatorum Ritter von Rittershain",
      "Pemphigus acutus febrilis",
      "Pemphigus acutus gravis",
      "Pemphigus acutus neonatorum",
      "Ritter-Syndrom",
      "Ritter-von-Rittershain-Krankheit",
      "SSS [Staphylococcal scalded skin]-Syndrom",
      "SSSS [Staphylococcal scalded skin syndrome]",
      "Staphylococcal scalded skin syndrome",
      "Staphylogene toxische epidermale Nekrolyse",
      "Staphylogenes Lyell-Syndrom"
    ]
  },
  {
    "code": "L00.1",
    "name": "SSS [Staphylococcal scalded skin]-Syndrom mit Schleimhautbefall",
    "synonyms": [
      "SSS [Staphylococcal scalded skin]-Syndrom mit Befall von 30 % der Körperoberfläche und mehr",
      "SSS [Staphylococcal scalded skin]-Syndrom mit Schleimhautbefall"
    ]
  },
  {
    "code": "L01.0",
    "name": "Impetigo contagiosa",
    "synonyms": [
      "Bockhart-Krankheit",
      "Bulla rodens",
      "Eiterausschlag",
      "Eiterflechte",
      "Folliculitis superficialis",
      "Grindausschlag",
      "Grindblasen",
      "Grindflechte",
      "Grindknötchen",
      "Impetiginisation",
      "Impetiginöses Ekzem",
      "Impetigo",
      "Impetigo Bockhart",
      "Impetigo bullosa",
      "Impetigo circinata",
      "Impetigo contagiosa",
      "Impetigo contagiosa durch Staphylokokken",
      "Impetigo contagiosa durch Streptokokken",
      "Impetigo follicularis",
      "Impetigo neonatorum",
      "Impetigo simplex",
      "Impetigo vulgaris",
      "Pemphigus neonatorum",
      "Perifolliculitis superficialis pustularis",
      "Pustulöse Follikulitis",
      "Schälblattern",
      "Staphylodermia superior impetiginosa",
      "Staphylodermia superior vesiculosa",
      "Streptodermia superior bullosa",
      "Streptodermia superior crustosa",
      "Streptodermia superior impetiginosa",
      "Streptodermia superior vesiculosa",
      "Ulzerative Impetigo"
    ]
  },
  {
    "code": "L01.1",
    "name": "Sekundäre Impetiginisation einer Dermatose",
    "synonyms": [
      "Ekzema impetiginosum",
      "Impetiginisation anderer Dermatosen a.n.k.",
      "Sekundäre Impetiginisation einer Dermatose"
    ]
  },
  {
    "code": "L02.0",
    "name": "Hautabszess des Gesichts",
    "synonyms": [
      "Abszess der Temporalregion",
      "Gesichtsabszess",
      "Gesichtsfurunkel",
      "Gesichtskarbunkel",
      "Hautabszess des Gesichts",
      "Karbunkel der Schläfengegend",
      "Kinnabszess",
      "Lippenfurunkel",
      "Lippenkarbunkel",
      "Schläfenabszess",
      "Schläfenfurunkel",
      "Schläfenkarbunkel",
      "Stirnabszess",
      "Submaxillärer Abszess",
      "Submentaler Abszess",
      "Wangenhautabszess"
    ]
  },
  {
    "code": "L02.1",
    "name": "Nackenfurunkel",
    "synonyms": [
      "Halsabszess",
      "Halsfurunkel",
      "Halskarbunkel",
      "Nackenabszess",
      "Nackenfurunkel",
      "Nackenkarbunkel"
    ]
  },
  {
    "code": "L02.2",
    "name": "Brustdrüsenfurunkel",
    "synonyms": [
      "Abszess der Rückenhaut",
      "Abszess des Mons pubis",
      "Bauchdeckenabszess",
      "Bauchdeckenfurunkel",
      "Bauchdeckenkarbunkel",
      "Bauchwandabszess",
      "Bauchwandfurunkel",
      "Bauchwandkarbunkel",
      "Beckenabszess",
      "Brustdrüsenfurunkel",
      "Brustfurunkel",
      "Brustwandabszess",
      "Brustwandfurunkel",
      "Brustwandkarbunkel",
      "Dammabszess",
      "Dammfurunkel",
      "Dammkarbunkel",
      "Iliakalabszess",
      "Inguinalabszess",
      "Leistenabszess",
      "Leistenbeugenabszess",
      "Leistenbeugenfurunkel",
      "Leistenbeugenkarbunkel",
      "Lendenabszess",
      "Lendenfurunkel",
      "Lendenkarbunkel",
      "Mammafurunkel",
      "Nabelabszess",
      "Nabelfurunkel",
      "Nabelkarbunkel",
      "Nichttuberkulöser lumbaler Abszess",
      "Pektoralisabszess",
      "Perineumabszess",
      "Perineumkarbunkel",
      "Retroperinealabszess",
      "Rumpfabszess",
      "Rumpffurunkel",
      "Rumpfkarbunkel",
      "Rückenabszess",
      "Rückenfurunkel",
      "Rückenkarbunkel",
      "Suprapubischer Abszess"
    ]
  },
  {
    "code": "L02.3",
    "name": "Steißbeinabszess",
    "synonyms": [
      "Afterfurunkel",
      "Afterkarbunkel",
      "Analfurunkel",
      "Analkarbunkel",
      "Anusfurunkel",
      "Anuskarbunkel",
      "Furunkel der Glutäalregion",
      "Gesäßabszess",
      "Gesäßfurunkel",
      "Gesäßkarbunkel",
      "Glutäalabszess",
      "Glutäaler Furunkel",
      "Glutäales Karbunkel",
      "Glutäusfurunkel",
      "Glutäuskarbunkel",
      "Hautabszess der Glutäalregion",
      "Karbunkel der Glutäalregion",
      "Steißbeinabszess"
    ]
  },
  {
    "code": "L02.4",
    "name": "Armabszess",
    "synonyms": [
      "Abszess der Ellenbeuge",
      "Abszess der Fossa supraclavicularis",
      "Abszess der oberen Extremität",
      "Abszess der unteren Extremität",
      "Achselhöhlenabszess",
      "Achselhöhlenfurunkel",
      "Achselhöhlenkarbunkel",
      "Armabszess",
      "Armfurunkel",
      "Armkarbunkel",
      "Außenknöchelabszess",
      "Axillaabszess",
      "Axillafurunkel",
      "Axillakarbunkel",
      "Beinabszess",
      "Beinfurunkel",
      "Beinkarbunkel",
      "Daumenabszess",
      "Daumenfurunkel",
      "Daumenkarbunkel",
      "Digitusabszess",
      "Eiterung einer Zehe",
      "Eiterung eines Fingers",
      "Ellenbogenabszess",
      "Femoralabszess",
      "Fersenabszess",
      "Fersenfurunkel",
      "Fersenkarbunkel",
      "Fingerabszess",
      "Fingerfurunkel",
      "Fingerkarbunkel",
      "Furunkel der oberen Extremität",
      "Furunkel der unteren Extremität",
      "Fußabszess",
      "Fußfurunkel",
      "Fußkarbunkel",
      "Hackenabszess",
      "Handabszess",
      "Handfurunkel",
      "Handgelenkabszess",
      "Handgelenkfurunkel",
      "Handgelenkkarbunkel",
      "Handkarbunkel",
      "Hüftabszess",
      "Hüftfurunkel",
      "Hüftgelenkabszess",
      "Hüftkarbunkel",
      "Infraklavikulärer Abszess",
      "Knieabszess",
      "Kniefurunkel",
      "Kniekarbunkel",
      "Kniekehlenabszess",
      "Knöchelabszess",
      "Knöchelfurunkel",
      "Knöchelkarbunkel",
      "Oberarmabszess",
      "Oberarmfurunkel",
      "Oberarmkarbunkel",
      "Oberschenkelabszess",
      "Oberschenkelfurunkel",
      "Oberschenkelkarbunkel",
      "Poplitealabszess",
      "Präpatellarabszess",
      "Schenkelabszess",
      "Schulterabszess",
      "Schulterfurunkel",
      "Schulterkarbunkel",
      "Supraklavikulärer Abszess",
      "Unterarmabszess",
      "Unterarmfurunkel",
      "Unterarmkarbunkel",
      "Unterschenkelabszess",
      "Unterschenkelfurunkel",
      "Unterschenkelkarbunkel",
      "Wadenabszess",
      "Zehenabszess",
      "Zehenfurunkel",
      "Zehenkarbunkel"
    ]
  },
  {
    "code": "L02.8",
    "name": "Kopfabszess",
    "synonyms": [
      "Kopfabszess",
      "Kopffurunkel",
      "Kopfhautabszess",
      "Kopfhautfurunkel",
      "Kopfhautkarbunkel",
      "Kopfkarbunkel",
      "Kopfschwartenabszess",
      "Kopfschwartenfurunkel",
      "Lokalisierter Abszess a.n.k.",
      "Scheitelbeinabszess"
    ]
  },
  {
    "code": "L02.9",
    "name": "Karbunkel",
    "synonyms": [
      "Abszess",
      "Bindegewebeabszess a.n.k.",
      "Carbunculus - s.a. Karbunkel",
      "Chronische Furunkulose",
      "Eiterbeule",
      "Eiterherd",
      "Embolischer Abszess",
      "Externer Abszess",
      "Fistelnder Abszess",
      "Furunkel",
      "Furunkel an multiplen Lokalisationen a.n.k.",
      "Furunkulose",
      "Hautabszess",
      "Hautfurunkel a.n.k.",
      "Hautkarbunkel a.n.k.",
      "Infektiöse Beule",
      "Infektiöser Abszess",
      "Karbunkel",
      "Karbunkel an multiplen Lokalisationen",
      "Metastatischer Abszess",
      "Multiple Abszesse",
      "Oberflächlicher Abszess",
      "Phagedänischer Abszess a.n.k.",
      "Septischer Abszess",
      "Septisches Geschwür",
      "Subkutaner Abszess",
      "Talgdrüsenabszess",
      "Wundabszess"
    ]
  },
  {
    "code": "L03.01",
    "name": "Fingerparonychie",
    "synonyms": [
      "Akute Paronychie eines Fingers",
      "Chronische Paronychie eines Fingers",
      "Daumennagelabszess",
      "Daumenpanaritium",
      "Daumenphlegmone",
      "Eitrige Entzündung des Fingernagels",
      "Eitrige Entzündung des Fingers mit Lymphangitis",
      "Eitrige Infektion des Fingernagels",
      "Eitrige Infektion des Fingers mit Lymphangitis",
      "Eitrige Nagelbettentzündung eines Fingers",
      "Eitrige Nagelwallentzündung eines Fingers",
      "Fingernagelabszess",
      "Fingeronychie",
      "Fingeronychie mit Lymphangitis",
      "Fingerpanaritium",
      "Fingerpanaritium mit Lymphangitis",
      "Fingerparonychie",
      "Fingerparonychie mit Lymphangitis",
      "Fingerphlegmone",
      "Fingerumlauf",
      "Fingerumlauf mit Lymphangitis",
      "Nagelbetteiterung eines Fingers",
      "Nagelbettentzündung eines Fingers",
      "Nagelbettgeschwür eines Fingers",
      "Nagelbettpanaritium eines Fingers",
      "Nagelbettumlauf eines Fingers",
      "Nagelentzündung eines Fingers",
      "Nagelfalzentzündung eines Fingers",
      "Nagelfalzinfektion eines Fingers",
      "Nagelgeschwür eines Fingers",
      "Nagelinfektion eines Fingers",
      "Nagelwallentzündung eines Fingers",
      "Niednagel eines Fingers",
      "Niednagel eines Fingers mit Lymphangitis",
      "Onychitis eines Fingers mit Lymphangitis",
      "Perionychie eines Fingers",
      "Perionychie eines Fingers mit Lymphangitis",
      "Periunguales Panaritium eines Fingers",
      "Subunguales Panaritium eines Fingers"
    ]
  },
  {
    "code": "L03.02",
    "name": "Zehenphlegmone",
    "synonyms": [
      "Akute Paronychie einer Zehe",
      "Chronische Paronychie einer Zehe",
      "Eitrige Nagelbettentzündung einer Zehe",
      "Eitrige Nagelwallentzündung einer Zehe",
      "Eitrige Zehenentzündung mit Lymphangitis",
      "Eitrige Zeheninfektion mit Lymphangitis",
      "Nagelbetteiterung einer Zehe",
      "Nagelbettentzündung einer Zehe",
      "Nagelbettgeschwür einer Zehe",
      "Nagelbettpanaritium einer Zehe",
      "Nagelbettumlauf einer Zehe",
      "Nagelentzündung einer Zehe",
      "Nagelfalzentzündung einer Zehe",
      "Nagelfalzinfektion einer Zehe",
      "Nagelgeschwür einer Zehe",
      "Nagelinfektion einer Zehe",
      "Nagelwallentzündung einer Zehe",
      "Niednagel einer Zehe",
      "Paronychie einer Zehe",
      "Paronychie einer Zehe mit Lymphangitis",
      "Perionychie einer Zehe",
      "Perionychie einer Zehe mit Lymphangitis",
      "Periunguales Panaritium einer Zehe",
      "Subunguales Panaritium einer Zehe",
      "Umlauf einer Zehe",
      "Zehennagelabszess",
      "Zehenonychie",
      "Zehenonychie mit Lymphangitis",
      "Zehenpanaritium",
      "Zehenphlegmone"
    ]
  },
  {
    "code": "L03.10",
    "name": "Axillaphlegmone",
    "synonyms": [
      "Achselhöhlenphlegmone",
      "Armphlegmone",
      "Axillaphlegmone",
      "Eitrige Entzündung am Arm mit Lymphangitis",
      "Eitrige Entzündung der Hand mit Lymphangitis",
      "Eitrige Infektion am Arm mit Lymphangitis",
      "Eitrige Infektion der Hand mit Lymphangitis",
      "Handgelenkphlegmone",
      "Handphlegmone",
      "Oberarmphlegmone",
      "Phlegmone an der oberen Extremität",
      "Schulterphlegmone",
      "Unterarmphlegmone"
    ]
  },
  {
    "code": "L03.11",
    "name": "Fußphlegmone",
    "synonyms": [
      "Beinphlegmone",
      "Eitrige Entzündung am Bein mit Lymphangitis",
      "Eitrige Entzündung am Fuß mit Lymphangitis (ausgenommen Zehe)",
      "Eitrige Infektion am Bein mit Lymphangitis",
      "Eitrige Infektion am Fuß mit Lymphangitis (ausgenommen Zehe)",
      "Fersenphlegmone",
      "Fußphlegmone",
      "Hackenphlegmone",
      "Hüftphlegmone",
      "Kniephlegmone",
      "Knöchelphlegmone",
      "Oberschenkelphlegmone",
      "Phlegmone an der unteren Extremität",
      "Phlegmone der Knöchelregion",
      "Schenkelphlegmone",
      "Sprunggelenkphlegmone",
      "Unterschenkelphlegmone",
      "Wadenphlegmone",
      "Zellgewebsentzündung des Unterschenkels"
    ]
  },
  {
    "code": "L03.2",
    "name": "Gesichtsphlegmone",
    "synonyms": [
      "Gesichtsphlegmone",
      "Kieferphlegmone",
      "Kinnphlegmone",
      "Periorbitalphlegmone",
      "Stirnphlegmone",
      "Wangenphlegmone"
    ]
  },
  {
    "code": "L03.3",
    "name": "Rumpfphlegmone",
    "synonyms": [
      "Bauchdeckenphlegmone",
      "Bauchwandphlegmone",
      "Beckenphlegmone",
      "Brustwandphlegmone",
      "Dammphlegmone",
      "Gesäßphlegmone",
      "Glutäusphlegmone",
      "Leistenbeugenphlegmone",
      "Lendenphlegmone",
      "Nabelphlegmone",
      "Omphalophlegmone",
      "Pektoralphlegmone",
      "Perineumphlegmone",
      "Retroperineale Phlegmone",
      "Rumpfphlegmone",
      "Rückenphlegmone",
      "Steißbeinphlegmone",
      "Umbilikalphlegmone"
    ]
  },
  {
    "code": "L03.8",
    "name": "Kopfhautphlegmone",
    "synonyms": [
      "Halsphlegmone",
      "Kopfhautphlegmone",
      "Kopfphlegmone a.n.k.",
      "Nackenphlegmone",
      "Phlegmone der behaarten Kopfhaut"
    ]
  },
  {
    "code": "L03.9",
    "name": "Akute Lymphangitis",
    "synonyms": [
      "Akute Lymphangitis",
      "Cellulitis - s.a. Zellulitis",
      "Chronische Phlegmone a.n.k.",
      "Diffuse Phlegmone",
      "Diffuse Unterhautzellgewebsentzündung",
      "Eitrige Phlegmone a.n.k.",
      "Entzündung des Unterhautzellgewebes a.n.k.",
      "Gewebsentzündung",
      "Hautphlegmone",
      "Perizellulitis",
      "Phlegmone",
      "Phlegmone mit Lymphangitis",
      "Septische Phlegmone a.n.k.",
      "Suppurative Phlegmone a.n.k.",
      "Unterhautzellgewebsentzündung mit Lymphangitis",
      "Zellgewebsentzündung",
      "Zellulitis"
    ]
  },
  {
    "code": "L04.0",
    "name": "Infektion zervikaler Lymphknoten",
    "synonyms": [
      "Abszess der Halslymphknoten",
      "Abszess zervikaler Lymphknoten",
      "Akute Adenitis cervicalis",
      "Akute Halsdrüsenentzündung",
      "Akute Lymphadenitis des Gesichts",
      "Akute Lymphadenitis des Kopfes",
      "Akute Lymphadenitis des Nackens",
      "Akute zervikale Adenitis",
      "Infektion zervikaler Lymphknoten",
      "Lymphknotenabszess im Nacken"
    ]
  },
  {
    "code": "L04.1",
    "name": "Akute Lymphadenitis des Rumpfes",
    "synonyms": [
      "Abszess inguinaler Lymphknoten",
      "Abszess von Lymphknoten der Leistenbeuge",
      "Abszess von Lymphknoten der Lendenregion",
      "Akute Lymphadenitis des Rumpfes",
      "Akute inguinale Adenitis",
      "Akute inguinale Lymphadenitis",
      "Infektion inguinaler Lymphknoten",
      "Infektion von Lymphknoten der Leiste"
    ]
  },
  {
    "code": "L04.2",
    "name": "Akute Lymphadenitis der oberen Extremität",
    "synonyms": [
      "Achseldrüsenabszess",
      "Akute Lymphadenitis der Achselhöhle",
      "Akute Lymphadenitis der Axilla",
      "Akute Lymphadenitis der Schulter",
      "Akute Lymphadenitis der oberen Extremität",
      "Akute axilläre Adenitis",
      "Akuter Abszess der Achsellymphdrüsen",
      "Infektion der axillären Lymphknoten"
    ]
  },
  {
    "code": "L04.3",
    "name": "Akute Lymphadenitis der unteren Extremität",
    "synonyms": [
      "Akute Lymphadenitis der Hüfte",
      "Akute Lymphadenitis der unteren Extremität",
      "Akuter Abszess der Leistenlymphdrüsen"
    ]
  },
  {
    "code": "L04.9",
    "name": "Akute Lymphadenitis",
    "synonyms": [
      "Akute Adenitis",
      "Akute Lymphadenitis",
      "Akute Lymphdrüsenentzündung",
      "Akute nichtmesenteriale Lymphadenitis",
      "Akuter Lymphdrüsenabszess",
      "Akuter Lymphknotenabszess",
      "Akuter nichtmesenterialer Lymphknotenabszess",
      "Eitrige Lymphadenitis",
      "Eitriger Bubo",
      "Gangränöse Adenitis",
      "Infektiöse Lymphadenitis",
      "Lymphknotenabszess",
      "Lymphknoteninfektion",
      "Lymphknotennekrose",
      "Purulente Lymphadenitis",
      "Pyogene Lymphadenitis",
      "Septische Lymphadenitis"
    ]
  },
  {
    "code": "L05.0",
    "name": "Abszess bei Haarbalgfistel",
    "synonyms": [
      "Abszedierende Entzündung des Sinus pilonidalis",
      "Abszedierender Sinus pilonidalis",
      "Abszess bei Haarbalgfistel",
      "Abszess bei Haarbalgzyste",
      "Abszess bei Pilonidalzyste",
      "Infektion des Sinus pilonidalis mit Abszess",
      "Kokzygealdermoid mit Abszess",
      "Kokzygeale Dermoidzyste mit Abszess",
      "Kokzygealsinus mit Abszess",
      "Pilonidalabszess",
      "Pilonidalfistel mit Abszess",
      "Sinus dermalis congenitalis mit Abszess",
      "Steißbeinfistel mit Abszess",
      "Steißbeinzyste mit Abszess"
    ]
  },
  {
    "code": "L05.9",
    "name": "Infizierter Sinus pilonidalis",
    "synonyms": [
      "Haarbalgfistelinfektion",
      "Haarbalgzyste",
      "Haarbalgzysteninfektion",
      "Infektion eines Sinus pilonidalis",
      "Infizierte Steißbeinzyste",
      "Infizierter Sinus pilonidalis",
      "Kokzygeale Dermoidzyste",
      "Kokzygealsinus",
      "Kongenitaler Sinus dermalis",
      "Pilonidalfistel",
      "Pilonidalsinus",
      "Pilonidalzyste",
      "Pilonidalzyste ohne Abszess",
      "Sinus pilonidalis",
      "Sinus sacralis dermalis",
      "Steißbeinatherom",
      "Steißbeindermoid",
      "Steißbeinfistel",
      "Steißbeinzyste"
    ]
  },
  {
    "code": "L08.0",
    "name": "Pyodermie a.n.k.",
    "synonyms": [
      "Dermatitis gangraenosa",
      "Dermatitis gangraenosa infantum",
      "Dermatitis purulenta",
      "Dermatitis septica",
      "Dermatitis suppurativa",
      "Ecthyma",
      "Ecthyma gangraenosum",
      "Ecthyma simplex",
      "Ecthyma vulgaris",
      "Eitrige Dermatitis",
      "Eitrige Hautschädigung",
      "Gangränöse Dermatitis",
      "Hauteiterung",
      "Periorale Pyodermie",
      "Purulente Dermatitis",
      "Pustulöses Exanthem",
      "Pyodermatitis",
      "Pyodermie a.n.k.",
      "Pyogene Dermatitis",
      "Pyogene Hautinfektion",
      "Septische Dermatitis",
      "Staphylodermie",
      "Suppurative Dermatitis",
      "Uncharakteristische eitrige Hautinfektion"
    ]
  },
  {
    "code": "L08.1",
    "name": "Erythrasma",
    "synonyms": [
      "Bärensprung-Krankheit [Erythrasma]",
      "Bärensprung-Zwergflechte [Erythrasma]",
      "Erythrasma",
      "Erythrasma intertriginosum",
      "Infektion der Haut durch Corynebacterium minutissimum"
    ]
  },
  {
    "code": "L08.8",
    "name": "Perifollikulitis",
    "synonyms": [
      "Infektion eines Hautsinus a.n.k.",
      "Infizierte Hautnarbe",
      "Infizierter Hautsinus a.n.k.",
      "Perifolliculitis",
      "Perifollikulitis",
      "Pyodermatitis vegetans",
      "Pyodermia vegetans"
    ]
  },
  {
    "code": "L08.9",
    "name": "Unterhautinfektion",
    "synonyms": [
      "Daktylitis",
      "Eiterpickel",
      "Entzündung des männlichen Perineums",
      "Entzündung des weiblichen Perineums",
      "Entzündung von areolärem Gewebe a.n.k.",
      "Hautentzündung",
      "Hautinfektion",
      "Hautinfektion des Beins a.n.k.",
      "Hautinfektion des Fußes",
      "Hautinfektion des Gesäßes",
      "Hautinfektion des Knies a.n.k.",
      "Hautinfektion des Oberschenkels",
      "Hautinfektion einer Zehe",
      "Hautinfektion eines Fingers",
      "Hautpustel",
      "Infektion der Bauchdecke",
      "Infiziertes Hautexanthem",
      "Lokale Haut- und Unterhautinfektion",
      "Lokale Hautinfektion",
      "Lokale Infektion des Unterhautzellgewebes a.n.k.",
      "Lokale subkutane Infektion a.n.k.",
      "Nabelentzündung",
      "Nabelinfektion",
      "Nicht maligne Pustula",
      "Omphalitis, nicht beim Neugeborenen",
      "Pustel",
      "Pustula",
      "Schleichende Nabelinfektion",
      "Unterhautinfektion"
    ]
  },
  {
    "code": "L10.0",
    "name": "Pemphigus vulgaris",
    "synonyms": [
      "Bösartiger Pemphigus",
      "Maligner Pemphigus",
      "Pemphigus vulgaris"
    ]
  },
  {
    "code": "L10.1",
    "name": "Pemphigus vegetans",
    "synonyms": [
      "Hallopeau-Syndrom [Pemphigus vegetans]",
      "Neumann-Syndrom",
      "Pemphigus vegetans"
    ]
  },
  {
    "code": "L10.2",
    "name": "Pemphigus foliaceus",
    "synonyms": [
      "Cazenave-Krankheit",
      "Pemphigus foliaceus",
      "Pemphigus herpetiformis"
    ]
  },
  {
    "code": "L10.3",
    "name": "Brasilianischer Pemphigus",
    "synonyms": [
      "Brasilianischer Pemphigus",
      "Fogo selvagem [Pemphigus brasiliensis]",
      "Pemphigus brasiliensis"
    ]
  },
  {
    "code": "L10.4",
    "name": "Pemphigus erythematosus",
    "synonyms": [
      "Pemphigus erythematosus",
      "Pemphigus seborrhoicus",
      "Senear-Usher-Syndrom"
    ]
  },
  {
    "code": "L10.5",
    "name": "Arzneimittelinduzierter Pemphigus",
    "synonyms": [
      "Arzneimittelinduzierter Pemphigus"
    ]
  },
  {
    "code": "L10.8",
    "name": "IgA-Pemphigus",
    "synonyms": [
      "IgA-Pemphigus"
    ]
  },
  {
    "code": "L10.9",
    "name": "Pemphigus",
    "synonyms": [
      "Pemphigus",
      "Pemphiguskrankheit"
    ]
  },
  {
    "code": "L11.0",
    "name": "Erworbene Keratosis follicularis",
    "synonyms": [
      "Erworbene Keratosis follicularis"
    ]
  },
  {
    "code": "L11.1",
    "name": "Transitorische akantholytische Dermatose",
    "synonyms": [
      "Grover-Krankheit",
      "Transitorische akantholytische Dermatose"
    ]
  },
  {
    "code": "L11.9",
    "name": "Akantholytische Dermatose",
    "synonyms": [
      "Akantholyse",
      "Akantholytische Dermatose",
      "Akantholytische Störung"
    ]
  },
  {
    "code": "L12.0",
    "name": "Bullöses Pemphigoid",
    "synonyms": [
      "Bullöses Pemphigoid",
      "Dermatitis herpetiformis senilis",
      "Erythema multiforme pemphigoides",
      "Herpes circinatus bullosus"
    ]
  },
  {
    "code": "L12.1",
    "name": "Vernarbendes Pemphigoid",
    "synonyms": [
      "Benignes Schleimhautpemphigoid",
      "Gutartiges Schleimhautpemphigoid",
      "Muköses membranöses Pemphigoid",
      "Narbiges Pemphigoid",
      "Vernarbendes Pemphigoid"
    ]
  },
  {
    "code": "L12.2",
    "name": "Juvenile Dermatitis herpetiformis",
    "synonyms": [
      "Chronisch-bullöse Dermatose beim Kind",
      "Chronisch-bullöse Krankheit beim Kind",
      "Juvenile Dermatitis herpetiformis",
      "Juveniles Pemphigoid"
    ]
  },
  {
    "code": "L12.3",
    "name": "Erworbene Epidermolysis bullosa",
    "synonyms": [
      "Erworbene Epidermolysis bullosa"
    ]
  },
  {
    "code": "L12.8",
    "name": "Gutartige pemphigoide Hautkrankheit",
    "synonyms": [
      "Anti-p200-Pemphigoid",
      "Gutartige pemphigoide Hautkrankheit"
    ]
  },
  {
    "code": "L12.9",
    "name": "Pemphigoid",
    "synonyms": [
      "Pemphigoid",
      "Pemphigoidkrankheit"
    ]
  },
  {
    "code": "L13.0",
    "name": "Hydroa pruriginosa",
    "synonyms": [
      "Brocq-Duhring-Krankheit",
      "Brocq-Duhring-Syndrom",
      "Dermatitis herpetiformis",
      "Dermatitis herpetiformis Duhring",
      "Dermatitis multiformis",
      "Dermatitis polymorpha dolorosa Brocq",
      "Dermatitis trophoneurotica",
      "Duhring-Krankheit",
      "Duhring-Syndrom",
      "Herpetiforme Dermatose",
      "Hydroa",
      "Hydroa herpetiformis",
      "Hydroa pruriginosa",
      "Hydroa puerorum",
      "Morbus Duhring"
    ]
  },
  {
    "code": "L13.1",
    "name": "Pustulosis subcornealis",
    "synonyms": [
      "Dermatitis pustulosa subcornealis",
      "Dermatosis pustulosa subcornealis",
      "Pustulosis subcornealis",
      "Sneddon-Wilkinson-Syndrom"
    ]
  },
  {
    "code": "L13.8",
    "name": "Culicosis bullosa",
    "synonyms": [
      "Culicosis bullosa",
      "IgA-lineare Dermatose",
      "Lineare IgA-Dermatose"
    ]
  },
  {
    "code": "L13.9",
    "name": "Bullöse Dermatose",
    "synonyms": [
      "Bullöse Dermatose",
      "Bullöse Krankheit",
      "Dermatitis bullosa"
    ]
  },
  {
    "code": "L20.0",
    "name": "Prurigo Besnier",
    "synonyms": [
      "Besnier-Syndrom",
      "Prurigo Besnier"
    ]
  },
  {
    "code": "L20.8",
    "name": "Nabelekzem beim Kind",
    "synonyms": [
      "Akutes Ekzem beim Kind",
      "Akutes Säuglingsekzem",
      "Allergisches infantiles Ekzem",
      "Atopisches Fußekzem",
      "Atopisches Gesichtsekzem",
      "Atopisches Handekzem",
      "Atopisches Kopfhautekzem",
      "Chronisches Ekzem beim Kind",
      "Chronisches Säuglingsekzem",
      "Dermatitis flexurarum a.n.k.",
      "Dermatitis infantum",
      "Dermatitis intertriginosa atopica",
      "Disseminierte Neurodermitis",
      "Ekzema flexurarum a.n.k.",
      "Ekzema flexurarum infantum",
      "Ekzema infantum",
      "Endogene Crusta lactea",
      "Endogener Milchschorf",
      "Infantiles endogenes Ekzem",
      "Infantumekzem",
      "Intrinsisches Ekzem",
      "Intrinsisches allergisches Ekzem",
      "Nabelekzem",
      "Nabelekzem beim Kind",
      "Neurodermatitis disseminata",
      "Neurodermitis",
      "Neurodermitis atopica",
      "Neurodermitis der Beugeseite",
      "Neurodermitis der Streckseite",
      "Neurodermitis diffusa",
      "Neurodermitis disseminata",
      "Säuglingsekzem"
    ]
  },
  {
    "code": "L20.9",
    "name": "Atopisches Ekzem",
    "synonyms": [
      "Atopiker",
      "Atopische Dermatitis",
      "Atopische Dermatose",
      "Atopisches Ekzem",
      "Atopisches impetiginisiertes Ekzem",
      "Dermatitis atopica",
      "Endogenes Ekzem",
      "Generalisiertes atopisches Ekzem",
      "Impetiginisiertes endogenes Ekzem"
    ]
  },
  {
    "code": "L21.0",
    "name": "Seborrhoea capitis",
    "synonyms": [
      "Kopfgneis",
      "Kopfschuppen",
      "Kopfseborrhoe",
      "Pityriasis",
      "Pityriasis amiantacea",
      "Pityriasis capitis",
      "Pityriasis seborrhoica capitis",
      "Pityriasis simplex capitis",
      "Seborrhoea capitis",
      "Seborrhoea sicca",
      "Seborrhoea sicca capitis",
      "Seborrhoides Kopfekzem",
      "Seborrhoische Crusta lactea",
      "Seborrhoischer Milchschorf"
    ]
  },
  {
    "code": "L21.1",
    "name": "Seborrhoisches Ekzem beim Kind",
    "synonyms": [
      "Dermatitis seborrhoides infantum",
      "Dermatitis seborrhoides juvenilis",
      "Ekzema intertriginosum infantum",
      "Ekzema seborrhoicum infantum",
      "Erythroderma desquamativa",
      "Erythrodermia desquamativa Leiner",
      "Erythrodermia exfoliativa Leiner",
      "Infantiles Ekzema intertriginosum",
      "Leiner-Krankheit",
      "Leiner-Syndrom",
      "Letale angeborene Erythrodermie",
      "Milchschorf beim Kind",
      "Milchschorf beim Säugling",
      "Seborrhoische Dermatitis beim Jugendlichen",
      "Seborrhoische Dermatitis beim Kind",
      "Seborrhoisches Ekzem beim Kind"
    ]
  },
  {
    "code": "L21.9",
    "name": "Seborrhoisches Ekzem",
    "synonyms": [
      "Infektiöse ekzematöse Dermatitis",
      "Seborrhoides Exanthem",
      "Seborrhoische Dermatitis",
      "Seborrhoisches Ekzem",
      "Seborrhoisches Ekzematoid"
    ]
  },
  {
    "code": "L22",
    "name": "Windelausschlag",
    "synonyms": [
      "Dermatitis ammoniacalis",
      "Dermatitis anogenitalis [Windeldermatitis]",
      "Glutäales Erythem [Windeldermatitis]",
      "Jacquet-Dermatitis",
      "Psoriasiforme Windeldermatitis",
      "Psoriasiformer Windelausschlag",
      "Windelausschlag",
      "Windeldermatitis",
      "Windeldermatose",
      "Windelerythem"
    ]
  },
  {
    "code": "L23.0",
    "name": "Nickelallergie",
    "synonyms": [
      "Allergische Kontaktdermatitis durch Bichromat",
      "Allergische Kontaktdermatitis durch Chrom",
      "Allergische Kontaktdermatitis durch Metalle",
      "Allergische Kontaktdermatitis durch Nickel",
      "Chromallergie",
      "Nickelallergie"
    ]
  },
  {
    "code": "L23.1",
    "name": "Allergische Kontaktdermatitis durch Klebstoff",
    "synonyms": [
      "Allergische Kontaktdermatitis durch Heftpflaster",
      "Allergische Kontaktdermatitis durch Katharidenpflaster",
      "Allergische Kontaktdermatitis durch Klebstoff",
      "Allergische Kontaktdermatitis durch Zugpflaster",
      "Heftpflasterekzem"
    ]
  },
  {
    "code": "L23.2",
    "name": "Allergie gegen Kosmetika",
    "synonyms": [
      "Allergie gegen Kosmetika",
      "Allergische Dermatitis durch Haarfärbemittel",
      "Allergische Kontaktdermatitis durch Kosmetika",
      "Allergische Kontaktdermatitis durch Kölnisch Wasser"
    ]
  },
  {
    "code": "L23.3",
    "name": "Allergische Kontaktdermatitis durch Arzneimittel",
    "synonyms": [
      "Allergische Kontaktdermatitis durch Arzneimittel",
      "Allergisches Kontaktexanthem durch Arzneimittel"
    ]
  },
  {
    "code": "L23.4",
    "name": "Allergische Kontaktdermatitis durch Farbstoff",
    "synonyms": [
      "Allergische Kontaktdermatitis durch Farbstoff"
    ]
  },
  {
    "code": "L23.5",
    "name": "Gummiallergie",
    "synonyms": [
      "Allergie durch industrielle Fette",
      "Allergie gegen Pflaster",
      "Allergie gegen organisches Lösungsmittel",
      "Allergische Dermatitis durch Terpentine",
      "Allergische Dermatitis durch chemische Produkte",
      "Allergische Kontaktdermatitis durch Gummi",
      "Allergische Kontaktdermatitis durch Insektizide",
      "Allergische Kontaktdermatitis durch Konservierungsstoffe",
      "Allergische Kontaktdermatitis durch Kunststoff",
      "Allergische Kontaktdermatitis durch Nylon",
      "Allergische Kontaktdermatitis durch Plastik",
      "Allergische Kontaktdermatitis durch Zement",
      "Allergische Kontaktdermatitis durch chemische Produkte",
      "Chemikalienallergie",
      "Detergenzienallergie",
      "Gummiallergie",
      "Insektizidallergie",
      "Konservierungsmittelallergie",
      "Kunststoffallergie",
      "Pflasterallergie",
      "Seifenallergie",
      "Waschmittelallergie",
      "Zementallergie"
    ]
  },
  {
    "code": "L23.6",
    "name": "Allergische Kontaktdermatitis durch Hautkontakt mit Nahrungsmitteln",
    "synonyms": [
      "Allergie durch Hautkontakt mit Nahrungsmitteln",
      "Allergische Kontaktdermatitis durch Fisch",
      "Allergische Kontaktdermatitis durch Fleisch",
      "Allergische Kontaktdermatitis durch Gemüse",
      "Allergische Kontaktdermatitis durch Hautkontakt mit Nahrungsmitteln",
      "Allergische Kontaktdermatitis durch Mehl",
      "Allergische Kontaktdermatitis durch Milch",
      "Allergische Kontaktdermatitis durch Obst",
      "Allergisches Bäckerekzem"
    ]
  },
  {
    "code": "L23.7",
    "name": "Dermatitis venenata",
    "synonyms": [
      "Allergische Kontaktdermatitis durch Ambrosiagewächse",
      "Allergische Kontaktdermatitis durch Brennnesseln",
      "Allergische Kontaktdermatitis durch Giftefeu",
      "Allergische Kontaktdermatitis durch Gifteiche",
      "Allergische Kontaktdermatitis durch Giftsumach",
      "Allergische Kontaktdermatitis durch Gräser",
      "Allergische Kontaktdermatitis durch Jakobskreuzkraut",
      "Allergische Kontaktdermatitis durch Primeln",
      "Allergische Kontaktdermatitis durch Schlüsselblumen",
      "Dermatitis pratensis",
      "Dermatitis venenata",
      "Pflanzenallergie",
      "Rhus-Dermatitis",
      "Wiesengräser-Dermatitis"
    ]
  },
  {
    "code": "L23.8",
    "name": "Allergische Kontaktdermatitis durch Pelz",
    "synonyms": [
      "Allergische Dermatitis durch äußeren Reizstoff a.n.k.",
      "Allergische Kontaktdermatitis durch Pelz"
    ]
  },
  {
    "code": "L23.9",
    "name": "Allergisches Ekzem",
    "synonyms": [
      "Allergie mit Dermatose",
      "Allergische Dermatitis",
      "Allergische Hautreaktion",
      "Allergische Kontaktdermatitis",
      "Allergische Kontaktsensibilisierung",
      "Allergisches Ekzem",
      "Allergisches Erythem",
      "Allergisches Exanthem",
      "Allergisches Kontaktekzem",
      "Allergodermie",
      "Dermatitis durch Sensibilisierung a.n.k.",
      "Ekzem mit Allergie",
      "Entzündliche allergische Dermatitis",
      "Hautallergie",
      "Hautallergie durch Kontakt",
      "Kontaktallergie"
    ]
  },
  {
    "code": "L24.0",
    "name": "Ekzem durch Detergenzien",
    "synonyms": [
      "Berufsekzem durch Detergenzien",
      "Dermatitis durch Detergenzien",
      "Dermatitis durch Seife",
      "Dermatitis durch Waschmittel",
      "Ekzem durch Detergenzien",
      "Ekzem durch Seife",
      "Ekzem durch Waschmittel",
      "Kontaktdermatitis durch Detergenzien",
      "Kontaktdermatitis durch Spülmittel",
      "Kontaktdermatitis durch Waschmittel"
    ]
  },
  {
    "code": "L24.1",
    "name": "Berufsekzem durch Fett",
    "synonyms": [
      "Berufsekzem durch Fett",
      "Dermatitis durch Fett",
      "Ekzem durch Fett",
      "Kontaktdermatitis durch Fett",
      "Kontaktdermatitis durch Schmiermittel a.n.k.",
      "Kontaktdermatitis durch Öl a.n.k.",
      "Kontaktekzem durch Fett",
      "Kontaktekzem durch Öl",
      "Toxische Ölkrätze",
      "Ölkrätze",
      "Ölkrätze durch Kontakt"
    ]
  },
  {
    "code": "L24.2",
    "name": "Ekzem durch organische Lösungsmittel",
    "synonyms": [
      "Berufsekzem durch organische Lösungsmittel",
      "Dermatitis durch organische Lösungsmittel",
      "Ekzem durch organische Lösungsmittel",
      "Kontaktdermatitis durch organische Lösung",
      "Kontaktekzem durch organische Lösungsmittel",
      "Toxische Dermatitis durch Terpentine",
      "Toxische Kontaktdermatitis durch Alkohol",
      "Toxische Kontaktdermatitis durch Azeton",
      "Toxische Kontaktdermatitis durch Benzin",
      "Toxische Kontaktdermatitis durch Chlorverbindung",
      "Toxische Kontaktdermatitis durch Cyclohexan",
      "Toxische Kontaktdermatitis durch Ester",
      "Toxische Kontaktdermatitis durch Glykol",
      "Toxische Kontaktdermatitis durch Keton",
      "Toxische Kontaktdermatitis durch Kohlenwasserstoff",
      "Toxische Kontaktdermatitis durch Lösungsmittel",
      "Toxische Kontaktdermatitis durch Petroleumprodukt",
      "Toxische Kontaktdermatitis durch Schwefelkohlenstoff",
      "Toxische Kontaktdermatitis durch Tetrachloräthylen",
      "Toxische Kontaktdermatitis durch Toluol"
    ]
  },
  {
    "code": "L24.3",
    "name": "Toxische Kontaktdermatitis durch Kosmetika",
    "synonyms": [
      "Toxische Dermatitis durch Haarfärbemittel",
      "Toxische Dermatitis durch Kölnisch Wasser",
      "Toxische Kontaktdermatitis durch Kosmetika"
    ]
  },
  {
    "code": "L24.4",
    "name": "Toxische Kontaktdermatitis durch Hautkontakt mit Arzneimittel",
    "synonyms": [
      "Berufsekzem durch Arzneimittel",
      "Toxische Kontaktdermatitis durch Hautkontakt mit Arzneimittel",
      "Toxisches Exanthem durch Hautkontakt mit Arzneimittel"
    ]
  },
  {
    "code": "L24.5",
    "name": "Berufsekzem durch Chemikalie",
    "synonyms": [
      "Berufsekzem durch Chemikalie",
      "Toxische Dermatitis durch Bichromat",
      "Toxische Dermatitis durch Klebstoff",
      "Toxische Dermatitis durch Konservierungsstoffe a.n.k.",
      "Toxische Dermatitis durch Nylon",
      "Toxische Dermatitis durch Pflaster",
      "Toxische Dermatitis durch Plastik",
      "Toxische Dermatitis durch Zement",
      "Toxische Kontaktdermatitis durch Alkali",
      "Toxische Kontaktdermatitis durch Insektizide",
      "Toxische Kontaktdermatitis durch Lauge",
      "Toxische Kontaktdermatitis durch Säure",
      "Toxische Kontaktdermatitis durch Ätzmittel"
    ]
  },
  {
    "code": "L24.6",
    "name": "Berufsekzem durch Nahrungsmittel",
    "synonyms": [
      "Berufsekzem durch Nahrungsmittel",
      "Toxische Kontaktdermatitis durch Fisch",
      "Toxische Kontaktdermatitis durch Fleisch",
      "Toxische Kontaktdermatitis durch Gemüse",
      "Toxische Kontaktdermatitis durch Milch",
      "Toxische Kontaktdermatitis durch Nahrungsmittel",
      "Toxische Kontaktdermatitis durch Obst",
      "Toxisches Bäckerekzem"
    ]
  },
  {
    "code": "L24.7",
    "name": "Berufsekzem durch Pflanzen",
    "synonyms": [
      "Berufsekzem durch Pflanzen",
      "Stich durch Pflanzen",
      "Toxische Dermatitis durch Pflanzen"
    ]
  },
  {
    "code": "L24.8",
    "name": "Raupenhaar-Dermatitis",
    "synonyms": [
      "Raupenhaar-Dermatitis",
      "Toxische Dermatitis durch Chrom",
      "Toxische Dermatitis durch Metalle",
      "Toxische Dermatitis durch Nickel",
      "Toxische Dermatitis durch Pelz",
      "Toxische Kontaktdermatitis durch Farbstoff"
    ]
  },
  {
    "code": "L24.9",
    "name": "Toxische Kontaktdermatitis",
    "synonyms": [
      "Berufsbedingte toxische Kontaktdermatitis",
      "Dermatitis durch äußeren Reizstoff a.n.k.",
      "Dermatitis toxica",
      "Kontaktdermatitis durch Reizstoff",
      "Nichtallergische Kontaktdermatitis",
      "Toxisch-degeneratives Ekzem",
      "Toxische Dermatitis durch äußeren Reizstoff a.n.k.",
      "Toxische Kontaktdermatitis",
      "Toxisches Ekzem",
      "Toxisches Kontaktekzem"
    ]
  },
  {
    "code": "L25.0",
    "name": "Kontaktdermatitis durch Kosmetika",
    "synonyms": [
      "Kontaktdermatitis durch Haarfärbemittel",
      "Kontaktdermatitis durch Kosmetika"
    ]
  },
  {
    "code": "L25.1",
    "name": "Kontaktdermatitis durch Arzneimittel",
    "synonyms": [
      "Exanthem durch Hautkontakt mit Arzneimittel",
      "Exanthem durch äußere Anwendung eines Arzneimittels",
      "Kontaktdermatitis durch Arzneimittel",
      "Kontaktekzem durch Arzneimittel"
    ]
  },
  {
    "code": "L25.2",
    "name": "Kontaktdermatitis durch Farbstoff",
    "synonyms": [
      "Kontaktdermatitis durch Farbstoff"
    ]
  },
  {
    "code": "L25.3",
    "name": "Ekzem durch Chemikalie",
    "synonyms": [
      "Ekzem durch Chemikalie",
      "Erythem durch Kontakt mit einer Chemikalie",
      "Kontaktdermatitis durch Chemikalie",
      "Kontaktdermatitis durch Insektizide",
      "Kontaktdermatitis durch Terpentin",
      "Kontaktdermatitis durch Zement",
      "Kontaktekzem durch Chemikalie",
      "Zementkrätze"
    ]
  },
  {
    "code": "L25.4",
    "name": "Kontaktdermatitis durch Mehl",
    "synonyms": [
      "Bäckerekzem",
      "Bäckerkrätze",
      "Kontaktdermatitis durch Fisch",
      "Kontaktdermatitis durch Fleisch",
      "Kontaktdermatitis durch Gemüse",
      "Kontaktdermatitis durch Mehl",
      "Kontaktdermatitis durch Milch",
      "Kontaktdermatitis durch Nahrungsmittel",
      "Kontaktdermatitis durch Obst",
      "Kontaktekzem durch Nahrungsmittel"
    ]
  },
  {
    "code": "L25.5",
    "name": "Ekzem durch Pflanzen",
    "synonyms": [
      "Dermatitis durch Pflanzen",
      "Ekzem durch Pflanzen",
      "Kontaktdermatitis durch Pflanzen",
      "Kontaktekzem durch Pflanzen"
    ]
  },
  {
    "code": "L25.9",
    "name": "Kontaktdermatitis",
    "synonyms": [
      "Berufsbedingte Dermatose",
      "Berufsbedingte Kontaktdermatitis",
      "Berufsbedingtes Kontaktekzem",
      "Berufsekzem",
      "Irritative Kontaktdermatitis",
      "Kontaktdermatitis",
      "Kontaktekzem"
    ]
  },
  {
    "code": "L26",
    "name": "Exfoliative Dermatitis",
    "synonyms": [
      "Dermatitis exfoliativa",
      "Dermatitis exfoliativa generalisata",
      "Exfoliative Dermatitis",
      "Exfoliative Dermatose",
      "Generalisierte Dermatitis exfoliativa",
      "Pityriasis Hebra",
      "Pityriasis rubra universalis Hebra",
      "Wilson-Brocq-Syndrom",
      "Wilson-Krankheit [Dermatitis exfoliativa]"
    ]
  },
  {
    "code": "L27.0",
    "name": "Generalisiertes Arzneimittelexanthem",
    "synonyms": [
      "AGEP [Akute generalisierte exanthematische Pustulose]",
      "Akute generalisierte exanthematische Pustulose",
      "Arzneimittelbedingter Ausschlag",
      "Arzneimitteldermatitis durch eingenommenes Arzneimittel",
      "Arzneimittelexanthem",
      "Dermatitis durch Arzneimittel",
      "Dermatitis durch Impfung",
      "Dermatitis durch Medikamente",
      "Dermatitis durch Vakzine",
      "Dermatitis durch eingenommenes Arzneimittel",
      "Ekzem durch Arzneimittel",
      "Erythem durch Arzneimittel",
      "Generalisierte Arzneimitteldermatitis durch eingenommenes Arzneimittel",
      "Generalisiertes Arzneimittelexanthem",
      "Hautallergie durch Arzneimittel",
      "Medikamentenexanthem",
      "Toxisches Exanthem durch Arzneimittel"
    ]
  },
  {
    "code": "L27.1",
    "name": "Lokalisierte Arzneimitteldermatitis durch eingenommenes Arzneimittel",
    "synonyms": [
      "Akute lokalisierte exanthematische Pustulose",
      "Fixes Arzneimittelexanthem",
      "Hand-Fuß-Syndrom",
      "Lokalisierte Arzneimitteldermatitis durch eingenommenes Arzneimittel",
      "Lokalisierter Ausschlag durch Arzneimittel",
      "Lokalisierter Ausschlag durch Impfung",
      "Lokalisiertes Erythem durch Arzneimittel",
      "Palmar-Plantar-Erythrodysästhesie"
    ]
  },
  {
    "code": "L27.2",
    "name": "Dermatitis durch aufgenommene Nahrungsmittel",
    "synonyms": [
      "Allergie gegen Kuhmilch",
      "Dermatitis durch Nahrungsmittel",
      "Dermatitis durch aufgenommene Nahrungsmittel",
      "Dermatitis durch getrunkene Milch",
      "Dermatitis durch verspeiste Nahrungsmittel",
      "Dermatitis durch verspeisten Fisch",
      "Dermatitis durch verspeistes Fleisch",
      "Dermatitis durch verspeistes Gemüse",
      "Dermatitis durch verspeistes Obst",
      "Ekzem durch aufgenommene Nahrungsmittel",
      "Exanthem durch aufgenommene Nahrungsmittel",
      "Hautallergie durch aufgenommene Nahrungsmittel"
    ]
  },
  {
    "code": "L27.8",
    "name": "Dermatitis durch Arsen",
    "synonyms": [
      "Dermatitis durch Arsen",
      "Dermatitis durch aufgenommene Chemikalie a.n.k."
    ]
  },
  {
    "code": "L27.9",
    "name": "Dermatitis durch aufgenommene Substanz",
    "synonyms": [
      "Dermatitis durch aufgenommene Substanz",
      "Dermatitis durch eingenommene Substanz",
      "Dermatitis durch verschluckte Substanz"
    ]
  },
  {
    "code": "L28.0",
    "name": "Lichenifikation",
    "synonyms": [
      "Ekzema hypertrophicans",
      "Ekzema lichenificatum a.n.k.",
      "Lichen",
      "Lichen Vidal",
      "Lichen obtusus corneus",
      "Lichen simplex",
      "Lichen simplex chronicus",
      "Lichen simplex chronicus circumscriptus",
      "Lichenifikation",
      "Lichenifizierte Dermatitis a.n.k.",
      "Lichenisation",
      "Lichenoider Hautausschlag",
      "Lokale Neurodermatitis",
      "Neurodermitis chronica circularis simplex",
      "Neurodermitis chronica circularis verrucosa",
      "Neurodermitis chronica circumscripta",
      "Vidal-Krankheit"
    ]
  },
  {
    "code": "L28.1",
    "name": "Prurigo nodularis",
    "synonyms": [
      "Disseminierter Lichen corneus",
      "Hyde-Krankheit",
      "Hyde-Syndrom",
      "Lichen corneus disseminatus",
      "Lichen ruber obtusus corneus Lailler-Brocq",
      "Prurigo nodularis",
      "Prurigo nodularis Hyde"
    ]
  },
  {
    "code": "L28.2",
    "name": "Juckblattern",
    "synonyms": [
      "Juckblattern",
      "Lichen urticatus",
      "Pruriginöse Dermatose",
      "Prurigo",
      "Prurigo Hebra",
      "Prurigo chronica Hebra",
      "Prurigo ferox",
      "Prurigo mitis",
      "Prurigo multiformis chronica",
      "Prurigo pigmentosa",
      "Prurigo simplex",
      "Strophulus infantum pruriginosus",
      "Urticaria papulosa",
      "Urticaria papulosa Hebra"
    ]
  },
  {
    "code": "L29.0",
    "name": "Analpruritus",
    "synonyms": [
      "Analer Juckreiz",
      "Analpruritus",
      "Pruritus ani"
    ]
  },
  {
    "code": "L29.1",
    "name": "Pruritus scrotalis",
    "synonyms": [
      "Hodensackpruritus",
      "Pruritus scrotalis",
      "Skrotalpruritus"
    ]
  },
  {
    "code": "L29.2",
    "name": "Vulvapruritus",
    "synonyms": [
      "Vulvapruritus"
    ]
  },
  {
    "code": "L29.3",
    "name": "Anogenitaler Juckreiz",
    "synonyms": [
      "Anogenitaler Juckreiz",
      "Genitaler Pruritus",
      "Perineumreizung a.n.k.",
      "Pruritus analis",
      "Pruritus anogenitalis",
      "Pruritus genitalis",
      "Pruritus vaginalis",
      "Pruritus vulvae et ani"
    ]
  },
  {
    "code": "L29.8",
    "name": "Chronischer Juckreiz",
    "synonyms": [
      "Altersjuckreiz",
      "Alterspruritus",
      "Cholestatischer Pruritus",
      "Chronischer Juckreiz",
      "Gehörgangspruritus",
      "Generalisierter Pruritus",
      "Lokaler Juckreiz",
      "Lokaler Pruritus",
      "Pruritus aurium",
      "Pruritus capillitii",
      "Pruritus capitis",
      "Pruritus corporis",
      "Pruritus generalisatus",
      "Pruritus senilis",
      "Pruritus sine materia",
      "Urämischer Pruritus"
    ]
  },
  {
    "code": "L29.9",
    "name": "Jucken",
    "synonyms": [
      "Allgemeiner Juckreiz",
      "Allgemeiner Pruritus",
      "Genitaler Juckreiz",
      "Hautjucken",
      "Jucken",
      "Juckreiz",
      "Pruritus",
      "Pruritus universalis",
      "Uncharakteristischer Juckreiz"
    ]
  },
  {
    "code": "L30.0",
    "name": "Nummuläres Ekzem",
    "synonyms": [
      "Dermatitis nummularis",
      "Ekzema nummulare",
      "Nummuläres Ekzem"
    ]
  },
  {
    "code": "L30.1",
    "name": "Cheiropompholyx",
    "synonyms": [
      "Cheiropompholyx",
      "Dermatitis plantaris sicca",
      "Dyshidrosiformes Ekzem",
      "Dyshidrosiformes Fußekzem",
      "Dyshidrosiformes Hand- und Fußekzem",
      "Dyshidrosiformes Handekzem",
      "Dyshidrosis",
      "Dyshidrosis lamellosa sicca",
      "Dyshidrosis manuum",
      "Dyshidrotisches Ekzem",
      "Dyshidrotisches Fingerekzem",
      "Podopompholyx",
      "Pompholyx",
      "Winterfeet [Winterfüße] [Dermatitis plantaris sicca]",
      "Winterfüße [Dermatitis plantaris sicca]"
    ]
  },
  {
    "code": "L30.2",
    "name": "Autosensibilisierung der Haut",
    "synonyms": [
      "Autosensibilisierung der Haut",
      "Candida-Mykid",
      "Candidid",
      "Dermatophytid",
      "Ekzematid",
      "Ekzematoid - s.a. Ekzematid",
      "Id-Reaktion",
      "Id-Reaktion durch Bakterien",
      "Kandidid",
      "Levurid"
    ]
  },
  {
    "code": "L30.3",
    "name": "Ekzematoide Dermatitis",
    "synonyms": [
      "Bakterielles Ekzem",
      "Ekzema pustulosum",
      "Ekzematoide Dermatitis",
      "Engman-Krankheit",
      "Infektiöse Dermatitis",
      "Infektiöse Dermatitis mit assoziierter humaner T-lymphotroper Virus 1-Infektion",
      "Infektiöse submammäre Dermatitis",
      "Mikrobielles Ekzem",
      "Periorales superinfiziertes Ekzem",
      "Superinfizierte Exsikkationsdermatitis",
      "Superinfiziertes Ekzem",
      "Tylotisches Ekzem",
      "Tylotisches rhagadiformes Ekzem"
    ]
  },
  {
    "code": "L30.4",
    "name": "Intertriginöses Ekzem",
    "synonyms": [
      "Dermatitis durch Reibung",
      "Ekzema intertriginosum a.n.k.",
      "Hautintertrigo",
      "Infektiöses intertriginöses Ekzem",
      "Intertriginöses Ekzem",
      "Intertriginöses Erythem",
      "Intertrigo",
      "Irritationsekzem",
      "Scheuerekzem",
      "Traumatisches Ekzem",
      "Wundsein"
    ]
  },
  {
    "code": "L30.5",
    "name": "Pityriasis alba faciei",
    "synonyms": [
      "Impetigo furfuracea",
      "Pityriasis alba faciei",
      "Pityriasis seborrhoica simplex",
      "Pityriasis sicca",
      "Pityriasis simplex"
    ]
  },
  {
    "code": "L30.8",
    "name": "Exsikkationsekzematoid",
    "synonyms": [
      "Acrodermatitis - s.a. Akrodermatitis",
      "Akneiforme Dermatitis",
      "Akrodermatitis",
      "Austrocknungsekzem",
      "Bullöse Sommerdermatitis",
      "Degeneratives Ekzem",
      "Dermatitis bei Exsikkation",
      "Dermatitis calorica durch Kälte",
      "Dermatitis durch Frost",
      "Dermatitis durch Kälte",
      "Dermatitis durch niedrige Temperatur",
      "Dermatitis hiemalis",
      "Dermatitis und Ekzem mit Rhagade",
      "Dermoepidermitis",
      "Erosive pustulöse Dermatose der Kopfhaut",
      "Exsikkationsdermatitis",
      "Exsikkationsekzem",
      "Exsikkationsekzematoid",
      "Follikuläre Dermatitis",
      "Hyperkeratotisches Ekzem",
      "Ichthyosiformes Ekzem",
      "Nässeekzem",
      "Nässender Nabel",
      "Nässendes Ekzem",
      "Papulöses Ekzem",
      "Pruriginöses Ekzem",
      "Sebostatisches Ekzem",
      "Trockenes Ekzem",
      "Vesikulöses Ekzem"
    ]
  },
  {
    "code": "L30.9",
    "name": "Anogenitalekzem",
    "synonyms": [
      "Akute Dermatitis",
      "Akutes Ekzem",
      "Analekzem",
      "Anogenitalekzem",
      "Ausgedehntes Ekzem",
      "Axillaekzem",
      "Chronisch-rezidivierendes Ekzem",
      "Chronische Dermatitis",
      "Chronisches Ekzem",
      "Dermatitis",
      "Eczema - s.a. Ekzem oder s.a. Ekzema",
      "Ekzem - s.a. Ekzema",
      "Ekzema",
      "Ekzema crurum",
      "Ekzema fissum",
      "Ekzema rubrum",
      "Ekzematöse Dermatitis a.n.k.",
      "Entzündliches Ekzem",
      "Erythematöses Ekzem",
      "Fußsohlenekzem",
      "Generalisiertes Ekzem",
      "Genitalekzem",
      "Gesichtsekzem",
      "Handekzem",
      "Hautekzem",
      "Hauteruption",
      "Kopfekzem",
      "Leckekzem",
      "Naseneingangsekzem",
      "Perianalekzem",
      "Rezidivierendes Ekzem",
      "Skrotumekzem",
      "Squamöses Ekzem",
      "Submammäre Dermatitis",
      "Unterschenkelekzem",
      "Vaginalekzem",
      "Wangenekzem"
    ]
  },
  {
    "code": "L40.0",
    "name": "Psoriasis vulgaris",
    "synonyms": [
      "Plaque-Psoriasis",
      "Psoriasis anularis",
      "Psoriasis capitis",
      "Psoriasis circinata",
      "Psoriasis geographica",
      "Psoriasis gyrata",
      "Psoriasis nummularis",
      "Psoriasis serpiginosa",
      "Psoriasis vulgaris",
      "Psoriasis vulgaris exsudativa"
    ]
  },
  {
    "code": "L40.1",
    "name": "Generalisierte Psoriasis pustulosa",
    "synonyms": [
      "DITRA [Defizienz des Interleukin-36-Rezeptor-Antagonisten]",
      "GPP [Generalisierte pustulöse Psoriasis]",
      "Generalisierte Psoriasis pustulosa",
      "Generalisierte pustulöse Psoriasis",
      "Impetigo herpetiformis",
      "Psoriasis pustulosa",
      "Von-Zumbusch-Syndrom"
    ]
  },
  {
    "code": "L40.2",
    "name": "Dermatitis vegetans",
    "synonyms": [
      "Acrodermatitis continua suppurativa Hallopeau",
      "Akrodermatitis continua pustulosa",
      "Akrodermatitis continua suppurativa",
      "Akrodermatitis perstans",
      "Dermatitis repens",
      "Dermatitis vegetans",
      "Hallopeau-Akrodermatitis",
      "Hallopeau-Syndrom [Acrodermatitis continua suppurativa]",
      "Morbus Hallopeau"
    ]
  },
  {
    "code": "L40.3",
    "name": "Psoriasis pustulosa palmoplantaris",
    "synonyms": [
      "Andrews-Bakterid",
      "Andrews-Syndrom",
      "Bakterid",
      "Barber-Syndrom",
      "Psoriasis palmaris et plantaris",
      "Psoriasis palmoplantaris",
      "Psoriasis pustulosa palmoplantaris",
      "Pustulosis palmaris et plantaris",
      "Pustulosis palmoplantaris",
      "Pustulöses Bakterid"
    ]
  },
  {
    "code": "L40.4",
    "name": "Psoriasis guttata",
    "synonyms": [
      "Psoriasis guttata"
    ]
  },
  {
    "code": "L40.8",
    "name": "Psoriasis inversa",
    "synonyms": [
      "Ekzematisierte Psoriasis",
      "Erythrodermia psoriatica",
      "Nagelpsoriasis",
      "Psoriasis capillitii",
      "Psoriasis corporis",
      "Psoriasis der Kopfhaut",
      "Psoriasis des behaarten Kopfes",
      "Psoriasis exfoliativa",
      "Psoriasis flexurarum",
      "Psoriasis inversa",
      "Psoriasis punctata",
      "Psoriasis unguium"
    ]
  },
  {
    "code": "L40.9",
    "name": "Psoriasis",
    "synonyms": [
      "Generalisierte Psoriasis",
      "Intertriginöse Psoriasis",
      "Psoriasiformes Bild",
      "Psoriasis",
      "Psoriasisähnliche Affektion",
      "Schuppenflechte"
    ]
  },
  {
    "code": "L41.0",
    "name": "Pityriasis lichenoides et varioliformis acuta (Mucha-Habermann)",
    "synonyms": [
      "Lichenoide Parapsoriasis",
      "Lichenoide Pityriasis",
      "Mucha-Habermann-Syndrom",
      "Parapsoriasis lichenoides",
      "Parapsoriasis varioliformis",
      "Parapsoriasis varioliformis acuta",
      "Pityriasis lichenoides et varioliformis acuta (Mucha-Habermann)",
      "Pityriasis varioliformis"
    ]
  },
  {
    "code": "L41.1",
    "name": "Parapsoriasis guttata",
    "synonyms": [
      "Chronische lichenoide Pityriasis",
      "Parapsoriasis guttata"
    ]
  },
  {
    "code": "L41.3",
    "name": "Kleinfleckige Parapsoriasis en plaques",
    "synonyms": [
      "Kleinfleckige Parapsoriasis en plaques"
    ]
  },
  {
    "code": "L41.4",
    "name": "Großfleckige Parapsoriasis en plaques",
    "synonyms": [
      "Großfleckige Parapsoriasis en plaques"
    ]
  },
  {
    "code": "L41.5",
    "name": "Parakeratosis variegata",
    "synonyms": [
      "Parakeratosis variegata",
      "Parapsoriasis mit Poikilodermie",
      "Parapsoriasis retiformis"
    ]
  },
  {
    "code": "L41.8",
    "name": "Parapsoriasis en plaques",
    "synonyms": [
      "Parapsoriasis en plaques"
    ]
  },
  {
    "code": "L41.9",
    "name": "Brocq-Parapsoriasis",
    "synonyms": [
      "Brocq-Krankheit",
      "Brocq-Parapsoriasis",
      "Morbus Brocq",
      "Parapsoriasis"
    ]
  },
  {
    "code": "L42",
    "name": "Pityriasis rosea",
    "synonyms": [
      "Gibert-Krankheit",
      "Pityriasis circinata",
      "Pityriasis maculata et circinata",
      "Pityriasis rosea",
      "Primärmedaillon",
      "Schuppenröschen"
    ]
  },
  {
    "code": "L43.0",
    "name": "Lichen ruber hypertrophicus",
    "synonyms": [
      "Lichen ruber hypertrophicus",
      "Lichen ruber verrucosus"
    ]
  },
  {
    "code": "L43.1",
    "name": "Lichen ruber pemphigoides",
    "synonyms": [
      "Lichen bullosus",
      "Lichen planus bullosus",
      "Lichen ruber bullosus",
      "Lichen ruber pemphigoides"
    ]
  },
  {
    "code": "L43.2",
    "name": "Lichenoide Arzneimittelreaktion",
    "synonyms": [
      "Lichenoide Arzneimittelreaktion"
    ]
  },
  {
    "code": "L43.3",
    "name": "Subakuter Lichen ruber planus",
    "synonyms": [
      "Lichen planus actinicus",
      "Lichen planus tropicus",
      "Lichen ruber tropicus",
      "Subakuter Lichen ruber planus"
    ]
  },
  {
    "code": "L43.8",
    "name": "Lichen ruber anularis",
    "synonyms": [
      "Annulärer atrophischer Lichen planus",
      "Lichen planus anularis",
      "Lichen planus atrophicans",
      "Lichen planus linearis",
      "Lichen planus pigmentosus",
      "Lichen ruber anularis",
      "Lichen ruber atrophicus",
      "Lichen ruber decalvans",
      "Lichen ruber exanthematicus",
      "Lichen ruber mucosae",
      "Lichen ruber obtusus",
      "Lichen ruber striatus",
      "Vulvovaginal-gingivales Syndrom"
    ]
  },
  {
    "code": "L43.9",
    "name": "Lichen ruber planus",
    "synonyms": [
      "Feinknötchenflechte",
      "Knötchenflechte",
      "Lichen ruber",
      "Lichen ruber Wilson",
      "Lichen ruber chronicus",
      "Lichen ruber planus",
      "Wilson-II-Syndrom"
    ]
  },
  {
    "code": "L44.0",
    "name": "Pityriasis rubra pilaris",
    "synonyms": [
      "Devergie-Krankheit",
      "Devergie-Syndrom",
      "Pityriasis rubra pilaris"
    ]
  },
  {
    "code": "L44.1",
    "name": "Lichen nitidus",
    "synonyms": [
      "Granuloma nitidum",
      "Lichen nitidus",
      "Pinkus-Krankheit"
    ]
  },
  {
    "code": "L44.2",
    "name": "Lichen striatus",
    "synonyms": [
      "Lichen striatus"
    ]
  },
  {
    "code": "L44.3",
    "name": "Lichen ruber moniliformis",
    "synonyms": [
      "Lichen ruber moniliformis"
    ]
  },
  {
    "code": "L44.4",
    "name": "Infantile papulöse Akrodermatitis",
    "synonyms": [
      "Akrodermatitis papulosa infantum",
      "Gianotti-Crosti-Krankheit",
      "Gianotti-Crosti-Syndrom",
      "Infantile papulöse Akrodermatitis"
    ]
  },
  {
    "code": "L44.8",
    "name": "Tinea amiantacea",
    "synonyms": [
      "Pityriasis rotunda",
      "Tinea amiantacea",
      "Tinea asbestina"
    ]
  },
  {
    "code": "L44.9",
    "name": "Papulosquamöse Krankheit",
    "synonyms": [
      "Papulosquamöse Krankheit"
    ]
  },
  {
    "code": "L50.0",
    "name": "Allergische Urtikaria",
    "synonyms": [
      "Allergische Urtikaria",
      "Urtikaria durch Nahrungsmittel"
    ]
  },
  {
    "code": "L50.1",
    "name": "Idiopathische Urtikaria",
    "synonyms": [
      "Idiopathische Urtikaria",
      "Nichtallergische Urtikaria"
    ]
  },
  {
    "code": "L50.2",
    "name": "Wärmeurtikaria",
    "synonyms": [
      "FCAS [Familiäres autoinflammatorisches Kältesyndrom]",
      "FCAS [Familiäres autoinflammatorisches Kältesyndrom] Typ 1",
      "FCAS [Familiäres autoinflammatorisches Kältesyndrom] Typ 2",
      "FCAS [Familiäres autoinflammatorisches Kältesyndrom] Typ 4",
      "FCU [Familiäre Kälteurtikaria]",
      "Familiäre Kälteurtikaria",
      "Familiäres autoinflammatorisches Kältesyndrom",
      "Familiäres kälteinduziertes autoinflammatorisches Syndrom",
      "Familiäres kälteinduziertes autoinflammatorisches Syndrom Typ 2",
      "Hautallergie durch Kälte",
      "Hautallergie durch Wärme",
      "Hitzeurtikaria",
      "Kälteurtikaria",
      "Thermale Urtikaria durch Hitze",
      "Thermale Urtikaria durch Kälte",
      "Wärmeurtikaria"
    ]
  },
  {
    "code": "L50.3",
    "name": "Urticaria factitia",
    "synonyms": [
      "Dermatographie",
      "Dermatographische Urtikaria",
      "Dermographismus",
      "Urticaria factitia",
      "Urtikarieller Dermographismus"
    ]
  },
  {
    "code": "L50.4",
    "name": "Urticaria mechanica",
    "synonyms": [
      "Urticaria mechanica",
      "Urtikaria durch Vibration",
      "Vibrations-Angioödem",
      "Vibrationsurtikaria"
    ]
  },
  {
    "code": "L50.5",
    "name": "Cholinergische Urtikaria",
    "synonyms": [
      "Cholinergische Urtikaria",
      "Urticaria cholinergica"
    ]
  },
  {
    "code": "L50.6",
    "name": "Kontakturtikaria",
    "synonyms": [
      "Kontakturtikaria",
      "Urtikaria durch Pflanzen"
    ]
  },
  {
    "code": "L50.8",
    "name": "Chronisch-rezidivierende Urtikaria",
    "synonyms": [
      "Akute Urtikaria",
      "Chronisch-rezidivierende Urtikaria",
      "Chronische Urtikaria",
      "Periodisch-rezidivierende Urtikaria",
      "Periodisch-wiederkehrende Urtikaria",
      "Schnitzler-Syndrom"
    ]
  },
  {
    "code": "L50.9",
    "name": "Urtikaria",
    "synonyms": [
      "Hautallergie unklarer Genese",
      "Nesselausschlag",
      "Nesselfieber",
      "Nesselsucht",
      "Quaddelausschlag",
      "Quaddelfieber",
      "Quaddelsucht",
      "Urticaria",
      "Urtikaria",
      "Urtikarielles Exanthem"
    ]
  },
  {
    "code": "L51.0",
    "name": "Nichtbullöses Erythema exsudativum multiforme",
    "synonyms": [
      "Nichtbullöses Erythema exsudativum multiforme"
    ]
  },
  {
    "code": "L51.1",
    "name": "Bullöses Erythema exsudativum multiforme",
    "synonyms": [
      "Baader-Syndrom",
      "Bullöses Erythema exsudativum multiforme",
      "Dermatostomatitis Typ Stevens-Johnson",
      "Ektodermosis erosiva pluriorificialis",
      "Erythema exsudativum multiforme majus",
      "Fuchs-I-Syndrom",
      "Irisherpes bei Erythema exsudativum multiforme",
      "Stevens-Johnson-Syndrom",
      "Syndroma mucooculocutaneum acutum"
    ]
  },
  {
    "code": "L51.20",
    "name": "Toxische epidermale Nekrolyse",
    "synonyms": [
      "Epidermolysis acuta toxica",
      "Epidermolysis necroticans combustiformis",
      "Lyell-Syndrom",
      "Lyell-Syndrom der Konjunktiva",
      "Stevens-Johnson-Syndrom/toxische epidermale Nekrolyse-Übergangsform",
      "Stevens-Johnson-Syndrom/toxische epidermale Nekrolyse-Überlappungs-Syndrom",
      "TEN [Toxische epidermale Nekrolyse]",
      "Toxische epidermale Nekrolyse",
      "Toxische epidermale Nekrolyse mit Befall von weniger als 30 % der Körperoberfläche",
      "Übergangsform Stevens-Johnson-Syndrom/toxische epidermale Nekrolyse"
    ]
  },
  {
    "code": "L51.21",
    "name": "Toxische epidermale Nekrolyse mit Schleimhautbefall",
    "synonyms": [
      "Lyell-Syndrom mit Befall von 30 % der Körperoberfläche und mehr",
      "Lyell-Syndrom mit Schleimhautbefall",
      "Toxische epidermale Nekrolyse mit Befall von 30 % der Körperoberfläche und mehr",
      "Toxische epidermale Nekrolyse mit Schleimhautbefall"
    ]
  },
  {
    "code": "L51.9",
    "name": "Erythema exsudativum multiforme",
    "synonyms": [
      "Erythema exsudativum multiforme",
      "Erythema multiforme"
    ]
  },
  {
    "code": "L52",
    "name": "Erythema nodosum",
    "synonyms": [
      "Dermatitis contusiformis",
      "Erythema nodosum",
      "Erythema-nodosum-Syndrom",
      "Nichttuberkulöses Erythema induratum",
      "Nichttuberkulöses Erythema nodosum"
    ]
  },
  {
    "code": "L53.0",
    "name": "Erythema toxicum a.n.k.",
    "synonyms": [
      "Erythem durch Chemikalie a.n.k.",
      "Erythema toxicum a.n.k.",
      "Toxischer Hautausschlag a.n.k."
    ]
  },
  {
    "code": "L53.1",
    "name": "Erythema anulare centrifugum",
    "synonyms": [
      "Darier-Syndrom [Erythema anulare centrifugum]",
      "Erythema anulare centrifugum"
    ]
  },
  {
    "code": "L53.2",
    "name": "Erythema marginatum",
    "synonyms": [
      "Erythema marginatum",
      "Erythema rheumaticum",
      "Streptogenes Erythem"
    ]
  },
  {
    "code": "L53.3",
    "name": "Chronisches figuriertes Erythem a.n.k.",
    "synonyms": [
      "Chronisches figuriertes Erythem a.n.k.",
      "Erythema figuratum perstans"
    ]
  },
  {
    "code": "L53.8",
    "name": "Handflächenerythem",
    "synonyms": [
      "Erythema palmare",
      "Erythema plantare",
      "Erythema scarlatiniforme",
      "Handflächenerythem",
      "Nekrolytisches akrales Erythem"
    ]
  },
  {
    "code": "L53.9",
    "name": "Erythematöse Krankheit",
    "synonyms": [
      "Erythem",
      "Erythema",
      "Erythematöse Affektion",
      "Erythematöse Entzündung a.n.k.",
      "Erythematöse Krankheit",
      "Erythrodermia",
      "Erythrodermie",
      "Hautrötung",
      "Sekundäre Erythrodermie"
    ]
  },
  {
    "code": "L55.0",
    "name": "Dermatitis solaris acuta 1. Grades",
    "synonyms": [
      "Dermatitis solaris acuta 1. Grades",
      "Erythema solare",
      "Sonnenbrand 1. Grades"
    ]
  },
  {
    "code": "L55.1",
    "name": "Dermatitis solaris acuta 2. Grades",
    "synonyms": [
      "Dermatitis solaris acuta 2. Grades",
      "Sonnenbrand 2. Grades"
    ]
  },
  {
    "code": "L55.2",
    "name": "Dermatitis solaris acuta 3. Grades",
    "synonyms": [
      "Dermatitis solaris acuta 3. Grades",
      "Sonnenbrand 3. Grades"
    ]
  },
  {
    "code": "L55.9",
    "name": "Dermatitis solaris acuta",
    "synonyms": [
      "Akute Dermatitis durch Sonne",
      "Dermatitis solaris",
      "Dermatitis solaris acuta",
      "Sonnenbrand"
    ]
  },
  {
    "code": "L56.0",
    "name": "Phototoxische Reaktion durch Arzneimittel",
    "synonyms": [
      "Phototoxische Reaktion durch Arzneimittel"
    ]
  },
  {
    "code": "L56.1",
    "name": "Photoallergische Reaktion durch Arzneimittel",
    "synonyms": [
      "Photoallergische Reaktion durch Arzneimittel"
    ]
  },
  {
    "code": "L56.2",
    "name": "Phototoxische Kontaktdermatitis",
    "synonyms": [
      "Berloque-Dermatitis",
      "Photosensitive Dermatitis",
      "Phototoxische Dermatitis",
      "Phototoxische Kontaktdermatitis",
      "Phytophotodermatose"
    ]
  },
  {
    "code": "L56.3",
    "name": "Urticaria solaris",
    "synonyms": [
      "Sonnenlichtbedingte Urtikaria",
      "Sonnenurtikaria",
      "Urticaria solaris"
    ]
  },
  {
    "code": "L56.4",
    "name": "Polymorphe Lichtdermatose",
    "synonyms": [
      "Aktinische Prurigo",
      "Hydroa aestivalia",
      "Hydroa vacciniformia",
      "Lichtdermatose",
      "Photodermatose",
      "Polymorphe Lichtdermatose",
      "Polymorpher Lichtausschlag durch Sonnenbestrahlung",
      "Prurigo aestivalis",
      "Sommer-Prurigo",
      "Sonnenallergie",
      "Sonnenlichtallergie"
    ]
  },
  {
    "code": "L56.8",
    "name": "Persistierende Lichtreaktion der Haut",
    "synonyms": [
      "Aktinische Cheilitis",
      "Aktinische Cheilitis durch Sonnenbestrahlung",
      "Akute Dermatitis durch Licht",
      "Akute Dermatitis durch Ultraviolettstrahlung",
      "Akutes Ekzem durch Ultraviolettstrahlung",
      "Arzneimittelbedingte Photodermatitis",
      "Cheilitis actinica solare",
      "Persistierende Lichtreaktion der Haut",
      "Photoallergie mit Dermatose",
      "Photoallergisches Ekzem",
      "Photodermatitis",
      "Photodermatitis durch Sonnenbestrahlung",
      "Photodermatitis pigmentosa",
      "Photosensibilität",
      "Photosensibilität der Haut",
      "Photosensibilität der Haut durch Sonnenbestrahlung",
      "UV [Ultraviolettstrahlung]-sensitives Syndrom"
    ]
  },
  {
    "code": "L56.9",
    "name": "Akute Hautveränderung durch Ultraviolettstrahlen",
    "synonyms": [
      "Akute Hautveränderung durch Ultraviolettstrahlen"
    ]
  },
  {
    "code": "L57.0",
    "name": "Aktinische Keratose",
    "synonyms": [
      "Aktinische Keratose",
      "Horngeschwulst",
      "Keratom",
      "Keratoma",
      "Keratoma senile",
      "Keratose",
      "Keratosis",
      "Keratosis senilis",
      "Keratosis solaris",
      "Senile Hyperkeratose",
      "Senile Keratose",
      "Seniles Keratom",
      "Vaselinoderm"
    ]
  },
  {
    "code": "L57.1",
    "name": "Aktinisches Retikuloid",
    "synonyms": [
      "Aktinisches Retikuloid"
    ]
  },
  {
    "code": "L57.2",
    "name": "Cutis rhomboidalis nuchae",
    "synonyms": [
      "Cutis rhomboidalis nuchae"
    ]
  },
  {
    "code": "L57.3",
    "name": "Poikilodermia reticularis",
    "synonyms": [
      "Civatte-Krankheit",
      "Civatte-Poikilodermie",
      "Poikilodermia reticularis"
    ]
  },
  {
    "code": "L57.4",
    "name": "Cutis laxa senilis",
    "synonyms": [
      "Aktinische Elastose a.n.k.",
      "Cutis laxa senilis",
      "Elastoidosis cutanea",
      "Elastoidosis senilis",
      "Elastosis atrophicans senilis",
      "Elastosis senilis",
      "Erworbene Cutis hyperelastica",
      "Erworbene Dermatolyse",
      "Erworbene Dermatorrhexis",
      "Erworbene elastische Haut",
      "Senile Dermatolyse",
      "Senile aktinische Elastose"
    ]
  },
  {
    "code": "L57.5",
    "name": "Strahlengranulom",
    "synonyms": [
      "Aktinisches Granulom",
      "Strahlengranulom"
    ]
  },
  {
    "code": "L57.8",
    "name": "Dermatitis durch Sonnenbestrahlung",
    "synonyms": [
      "Aktinische Dermatitis durch Sonnenbestrahlung",
      "Atrophia cutis senilis durch Strahlung",
      "Chronische Photodermatitis",
      "Chronische Sonnendermatitis",
      "Dermatitis durch Licht a.n.k.",
      "Dermatitis durch Sonnenbestrahlung",
      "Dermatitis durch Ultraviolettstrahlen",
      "Dermatitis durch nichtionisierende Strahlen",
      "Dermatitis solaris durch chronische Exposition",
      "Dermoid durch nichtionisierende Strahlung",
      "Elastose durch Sonnenbestrahlung a.n.k.",
      "Elastosis solaris",
      "Farmerhaut",
      "Hautatrophie durch Strahlung",
      "Kolloidale Milien",
      "Landmannshaut",
      "Morbus Favre-Racouchot [Elastoidosis cutis nodularis]",
      "Seemannshaut",
      "Senile Atrophodermie durch Strahlung",
      "Senile Hautatrophie durch Strahlung",
      "Sonnendermatitis durch chronische Lichtexposition"
    ]
  },
  {
    "code": "L57.9",
    "name": "Hautveränderung durch chronische nichtionisierende Strahlung",
    "synonyms": [
      "Hautveränderung durch chronische nichtionisierende Strahlung"
    ]
  },
  {
    "code": "L58.0",
    "name": "Akute Radiodermatitis",
    "synonyms": [
      "Akute Dermatitis durch Röntgenstrahlen",
      "Akute Dermatitis durch radioaktive Strahlung",
      "Akute Radiodermatitis",
      "Akute Strahlendermatitis"
    ]
  },
  {
    "code": "L58.1",
    "name": "Chronische Radiodermatitis",
    "synonyms": [
      "Alopezie durch Röntgenstrahlen",
      "Chronische Dermatitis durch Röntgenstrahlen",
      "Chronische Dermatitis durch radioaktive Strahlung",
      "Chronische Radiodermatitis",
      "Chronische Strahlendermatitis",
      "Ulkus durch Röntgenstrahlen"
    ]
  },
  {
    "code": "L58.9",
    "name": "Röntgendermatitis",
    "synonyms": [
      "Dermatitis durch Radium",
      "Dermatitis durch radioaktive Substanz",
      "Radiodermatitis",
      "Röntgendermatitis",
      "Röntgenhaut"
    ]
  },
  {
    "code": "L59.0",
    "name": "Erythema ab igne",
    "synonyms": [
      "Chronischer Wärmeschaden",
      "Dermatitis ab igne",
      "Dermatitis calorica",
      "Dermatitis calorica durch Sonnenbrand",
      "Dermatitis combustionis",
      "Erythema ab igne",
      "Hitzedermatitis",
      "Hitzeekzem"
    ]
  },
  {
    "code": "L59.8",
    "name": "Ekzem durch Bestrahlung",
    "synonyms": [
      "Aktinische Cheilitis durch andere als Sonnenstrahlen",
      "Aktinische Dermatitis durch andere als Sonnenstrahlen",
      "Bestrahlungsallergie",
      "Bestrahlungsdermatitis",
      "Dermatitis durch Infrarotstrahlen",
      "Ekzem durch Bestrahlung",
      "Ekzem durch Infrarotstrahlen",
      "Kontaktdermatitis durch Bestrahlung",
      "Photodermatitis durch andere als Sonnenstrahlen",
      "Photosensibilität der Haut durch andere als Sonnenstrahlen",
      "Strahlendermatitis",
      "Strahlendermatose",
      "Strahlenerythem",
      "Strahlenfibrose",
      "Ulkus durch Strahlung a.n.k."
    ]
  },
  {
    "code": "L59.9",
    "name": "Hautkrankheit durch Strahlenwirkung",
    "synonyms": [
      "Hautkrankheit durch Strahlenwirkung"
    ]
  },
  {
    "code": "L60.0",
    "name": "Unguis incarnatus",
    "synonyms": [
      "Eingewachsener Nagel",
      "Eingewachsener Zehennagel",
      "Onychocryptosis",
      "Unguis incarnatus"
    ]
  },
  {
    "code": "L60.1",
    "name": "Onycholyse",
    "synonyms": [
      "Onycholyse",
      "Onycholysis",
      "Onycholysis foliacea"
    ]
  },
  {
    "code": "L60.2",
    "name": "Onychogrypose",
    "synonyms": [
      "Gryposis unguium",
      "Klauennagel",
      "Krallennagel",
      "Nagelhypertrophie",
      "Nagelverdickung",
      "Onychauxie",
      "Onychauxis",
      "Onychogryphosis",
      "Onychogrypose"
    ]
  },
  {
    "code": "L60.3",
    "name": "Hohlnagel",
    "synonyms": [
      "20-Nägel-Dystrophie",
      "Abbrechen von Fingernägeln",
      "Alimentäre Nagelstörung",
      "Atrophia unguium",
      "Autosomal-dominante Nageldysplasie",
      "Brüchiger Nagel",
      "Coilonychia - s.a. Koilonychie",
      "Fingernagelbrüchigkeit",
      "Hohlnagel",
      "Koilonychie",
      "Löffelnagel",
      "Nagelatrophie",
      "Nagelbrüchigkeit",
      "Nageldystrophie",
      "Nagelerweichung",
      "Onychodystrophie",
      "Onychoklasie",
      "Onychomalazie",
      "Onychorrhexis",
      "Onychoschisis",
      "Schizonychia",
      "Spaltung der Nägel",
      "Splitternder Nagel",
      "Totale Onychodystrophie"
    ]
  },
  {
    "code": "L60.4",
    "name": "Beau-Reil-Querfurchen",
    "synonyms": [
      "Beau-Reil-Querfurchen",
      "Nagelquerfurchen"
    ]
  },
  {
    "code": "L60.5",
    "name": "Yellow-nail-Syndrom",
    "synonyms": [
      "Gelber-Nagel-Syndrom",
      "Lymphödem und gelber Nagel",
      "Yellow-nail-Syndrom"
    ]
  },
  {
    "code": "L60.8",
    "name": "Mees-Nagelband",
    "synonyms": [
      "Defluvium unguium",
      "Erworbene Anonychie",
      "Erworbene Nageldeformität",
      "Erworbene Nagelverlagerung",
      "Erworbene Platyonychie",
      "Fingernagelüberrest",
      "Hämorrhagie eines Nagels",
      "Klumpnagel",
      "Leukonychia punctata",
      "Leukonychia striata",
      "Leukonychie",
      "Leukopathia unguinum",
      "Longitudinale Furchen der Nägel",
      "Longitudinale Streifen der Nägel",
      "Mees-Nagelband",
      "Nagelabstoßung",
      "Nagelblutung",
      "Nageldemineralisation",
      "Nagelverfärbung",
      "Nagelwachstumsstörung",
      "Onychomadesis",
      "Onychophosis",
      "Onychoptosis",
      "Subunguale Blutung",
      "Subunguale Hämorrhagie"
    ]
  },
  {
    "code": "L60.9",
    "name": "Nagelkrankheit",
    "synonyms": [
      "Nagelerkrankung",
      "Nagelkrankheit",
      "Onychonosis"
    ]
  },
  {
    "code": "L63.0",
    "name": "Alopecia totalis",
    "synonyms": [
      "Alopecia cranialis totalis",
      "Alopecia totalis",
      "Totaler Haarausfall am Kopf"
    ]
  },
  {
    "code": "L63.1",
    "name": "Alopecia universalis",
    "synonyms": [
      "Alopecia universalis",
      "Alopezie des ganzen Körpers"
    ]
  },
  {
    "code": "L63.2",
    "name": "Ophiasis",
    "synonyms": [
      "Ophiasis"
    ]
  },
  {
    "code": "L63.9",
    "name": "Alopecia areata",
    "synonyms": [
      "Alopecia areata",
      "Alopecia circumscripta",
      "Lokalisierter Haarausfall",
      "Partieller Haarausfall",
      "Pelade",
      "Örtlich begrenzter Haarausfall"
    ]
  },
  {
    "code": "L64.0",
    "name": "Arzneimittelinduzierte Alopecia androgenetica",
    "synonyms": [
      "Arzneimittelinduzierte Alopecia androgenetica"
    ]
  },
  {
    "code": "L64.8",
    "name": "Alopecia praematura",
    "synonyms": [
      "Alopecia praematura"
    ]
  },
  {
    "code": "L64.9",
    "name": "Alopecia androgenetica",
    "synonyms": [
      "Alopecia androgenetica",
      "Alopecia climacterica",
      "Alopezie vom männlichen Typ",
      "Androgenbedingter Haarausfall",
      "Androgenetische Alopezie",
      "Androgenetischer Haarausfall",
      "Calvities",
      "Hormonell bedingter Haarausfall",
      "Klimakterische Alopezie",
      "Male pattern alopecia"
    ]
  },
  {
    "code": "L65.0",
    "name": "Telogeneffluvium",
    "synonyms": [
      "Alopecia postpartualis",
      "Postpartale Alopezie",
      "Postpartales Effluvium",
      "Telogeneffluvium"
    ]
  },
  {
    "code": "L65.1",
    "name": "Anageneffluvium",
    "synonyms": [
      "Anageneffluvium",
      "Loses Anagenhaar-Syndrom"
    ]
  },
  {
    "code": "L65.2",
    "name": "Alopecia mucinosa",
    "synonyms": [
      "Alopecia mucinosa"
    ]
  },
  {
    "code": "L65.8",
    "name": "Toxische Alopezie",
    "synonyms": [
      "Alopecia cicatricans",
      "Alopecia maligna",
      "Alopecia marginalis",
      "Alopecia parvimaculata",
      "Alopezie durch ein zytotoxisches Arzneimittel",
      "Alopezie nach Infektion",
      "Hypotrichose durch ein zytotoxisches Arzneimittel",
      "Hypotrichosis simplex",
      "Hypotrichosis simplex der Kopfhaut",
      "Hypotrichosis simplex des Skalps",
      "Postinfektiöse Alopezie",
      "Postinfektiöse Hypotrichose",
      "Toxische Alopezie"
    ]
  },
  {
    "code": "L65.9",
    "name": "Alopezie",
    "synonyms": [
      "Alopecia",
      "Alopecia diffusa",
      "Alopecia hereditaria",
      "Alopecia seborrhoica",
      "Alopezie",
      "Atrichia",
      "Atrichose",
      "Defluvium capillorum",
      "Diffuse Alopezie",
      "Diffuser Haarausfall",
      "Diffuses Effluvium",
      "Effluvium",
      "Effluvium capitis",
      "Haarausfall",
      "Haarausfall ohne Narbenbildung",
      "Hypotrichose",
      "Oligotrichie",
      "Psilosis",
      "Psilosis, nicht durch Sprue",
      "Seborrhoische Alopezie",
      "Senile Alopezie"
    ]
  },
  {
    "code": "L66.0",
    "name": "Brocq-Pseudopelade",
    "synonyms": [
      "Alopecia atrophicans",
      "Brocq-Pseudopelade",
      "Pseudopelade"
    ]
  },
  {
    "code": "L66.1",
    "name": "Lichen ruber acuminatus",
    "synonyms": [
      "Fibrosierende frontale Alopezie",
      "Follikulärer Lichen planus",
      "Graham-Little-Piccardi-Lassueur-Syndrom",
      "Lichen follicularis",
      "Lichen planopilaris",
      "Lichen planus follicularis",
      "Lichen ruber acuminatus",
      "Lichen ruber follicularis"
    ]
  },
  {
    "code": "L66.2",
    "name": "Folliculitis decalvans",
    "synonyms": [
      "Acne decalvans",
      "Folliculitis decalvans",
      "Folliculitis decalvans Quinquaud"
    ]
  },
  {
    "code": "L66.3",
    "name": "Folliculitis et Perifolliculitis capitis abscedens et suffodiens (Hoffmann)",
    "synonyms": [
      "Folliculitis abscedens et suffodiens",
      "Folliculitis et Perifolliculitis capitis abscedens et suffodiens (Hoffmann)",
      "Hoffmann-Krankheit [Folliculitis et Perifolliculitis capitis abscedens et suffodiens]",
      "Perifolliculitis capitis abscedens et suffodiens"
    ]
  },
  {
    "code": "L66.4",
    "name": "Ulerythema ophryogenes",
    "synonyms": [
      "Atrophodermia reticulata symmetricum faciei",
      "Atrophodermia vermiculata",
      "Folliculitis ulerythematosa reticulata",
      "Ulerythema acneiforme",
      "Ulerythema ophryogenes"
    ]
  },
  {
    "code": "L66.9",
    "name": "Narbige Alopezie",
    "synonyms": [
      "Narbige Alopezie"
    ]
  },
  {
    "code": "L67.0",
    "name": "Trichorrhexis nodosa",
    "synonyms": [
      "Clastothrix",
      "Trichorrhexis",
      "Trichorrhexis invaginata",
      "Trichorrhexis nodosa",
      "Trichoschisis"
    ]
  },
  {
    "code": "L67.1",
    "name": "Veränderung der Haarfarbe",
    "synonyms": [
      "Canities",
      "Ergrauen",
      "Ergrauen der Haare",
      "Erworbene Poliosis circumscripta",
      "Frühzeitiges Ergrauen der Haare",
      "Heterochromie des Haars",
      "Poliosis",
      "Poliosis der Augenbraue",
      "Poliosis der Wimpern",
      "Variation der Haarfarbe",
      "Veränderung der Haarfarbe",
      "Vorzeitige Canities",
      "Vorzeitiges Ergrauen"
    ]
  },
  {
    "code": "L67.8",
    "name": "Trichoklasie",
    "synonyms": [
      "Brüchigkeit der Haare",
      "Dystrophie der Haare",
      "Fragilitas crinium",
      "Haaratrophie",
      "Haarknoten",
      "Pili bifurcati",
      "Pili multigemini",
      "Pseudochromhidrose",
      "Trichoklasie",
      "Trichonodosis",
      "Trichoptilose",
      "Trichoptilosis",
      "Trichothiodystrophie"
    ]
  },
  {
    "code": "L67.9",
    "name": "Abnormität des Haars",
    "synonyms": [
      "Abnormität des Haars",
      "Haarfarbenanomalie",
      "Haarschaftanomalie"
    ]
  },
  {
    "code": "L68.0",
    "name": "Hirsutismus",
    "synonyms": [
      "Hirsutismus"
    ]
  },
  {
    "code": "L68.1",
    "name": "Hypertrichosis lanuginosa acquisita",
    "synonyms": [
      "Erworbene lanuginöse Hypertrichose",
      "Hypertrichosis lanuginosa acquisita"
    ]
  },
  {
    "code": "L68.2",
    "name": "Lokalisierte Hypertrichose",
    "synonyms": [
      "Isolierte ventrale zervikale Hypertrichose",
      "Lokalisierte Hypertrichose"
    ]
  },
  {
    "code": "L68.3",
    "name": "Polytrichie",
    "synonyms": [
      "Polytrichie"
    ]
  },
  {
    "code": "L68.8",
    "name": "Districhiasis",
    "synonyms": [
      "Districhiasis"
    ]
  },
  {
    "code": "L68.9",
    "name": "Hypertrichose",
    "synonyms": [
      "Hypertrichose",
      "Vermehrter Haarwuchs",
      "Verstärkter Haarwuchs"
    ]
  },
  {
    "code": "L70.0",
    "name": "Komedonenakne",
    "synonyms": [
      "Acne comedonica",
      "Acne cystica",
      "Acne indurata",
      "Acne juvenilis",
      "Acne nodosa",
      "Acne nodulocystica",
      "Acne papulopustulosa",
      "Acne pustulosa",
      "Acne simplex",
      "Acne vulgaris",
      "Ausgeprägte Mitesser",
      "Ausgeprägter Komedo",
      "Comedo",
      "Komedo",
      "Komedonenakne",
      "Mitesser",
      "Papulopustulöse Akne",
      "Papulöse Akne",
      "Zystische Akne"
    ]
  },
  {
    "code": "L70.1",
    "name": "Acne conglobata",
    "synonyms": [
      "Acne conglobata",
      "Acne vulgaris conglobata"
    ]
  },
  {
    "code": "L70.2",
    "name": "Acne varioliformis",
    "synonyms": [
      "Acne atrophica",
      "Acne necroticans",
      "Acne necroticans miliaris",
      "Acne varioliformis"
    ]
  },
  {
    "code": "L70.3",
    "name": "Acne tropica",
    "synonyms": [
      "Acne tropica"
    ]
  },
  {
    "code": "L70.4",
    "name": "Acne infantum",
    "synonyms": [
      "Acne infantum",
      "Acne vulgaris infantum",
      "Baby-Akne",
      "Neugeborenenakne"
    ]
  },
  {
    "code": "L70.5",
    "name": "Acne excoriée des jeunes filles",
    "synonyms": [
      "Acne excoriée",
      "Acne excoriée des jeunes filles"
    ]
  },
  {
    "code": "L70.8",
    "name": "Steroidakne",
    "synonyms": [
      "Acne androgenetica",
      "Acne artificialis",
      "Acne bromica",
      "Acne cachecticorum",
      "Acne chlorica",
      "Acne jodica",
      "Acne picea",
      "Acne professionalis",
      "Acne steroidalis",
      "Androgenetische Akne",
      "Berufsbedingte Akne",
      "Steroidakne",
      "Teerakne",
      "Ölakne"
    ]
  },
  {
    "code": "L70.9",
    "name": "Akne",
    "synonyms": [
      "Acne - s.a. Akne",
      "Akne",
      "Akne mit Narbenbildung",
      "Akneeffloreszenz",
      "Präakne"
    ]
  },
  {
    "code": "L71.0",
    "name": "Periorale Dermatitis",
    "synonyms": [
      "Periorale Dermatitis",
      "Periorales Ekzem"
    ]
  },
  {
    "code": "L71.1",
    "name": "Rhinophym",
    "synonyms": [
      "Knollennase",
      "Rhinophym"
    ]
  },
  {
    "code": "L71.8",
    "name": "Rosacea juvenilis",
    "synonyms": [
      "Rosacea erythematosa",
      "Rosacea juvenilis",
      "Rosacea lupoides",
      "Rosacea papulopustulosa",
      "Rosacea papulosa",
      "Rosacea pustulosa"
    ]
  },
  {
    "code": "L71.9",
    "name": "Rosazea",
    "synonyms": [
      "Acne rosacea",
      "Rosacea",
      "Rosazea"
    ]
  },
  {
    "code": "L72.0",
    "name": "Epidermoidzyste",
    "synonyms": [
      "Augenlidmilien",
      "Einschlusszyste der Haut",
      "Epidermalzyste",
      "Epidermiszyste",
      "Epidermoidzyste",
      "Epidermoidzyste der Haut",
      "Epitheliale Hautzyste",
      "Epithelzyste",
      "Inklusionszyste der Haut",
      "Milien",
      "Schleimhautzyste"
    ]
  },
  {
    "code": "L72.1",
    "name": "Talgdrüsenzyste",
    "synonyms": [
      "Atherom",
      "Balggeschwulst",
      "Entzündetes Atherom",
      "Grützbeutel",
      "Hautatherom",
      "Infiziertes Atherom",
      "Pilarzyste",
      "Proliferierende Trichilemmalzyste",
      "Skrotumatherom",
      "Steatom",
      "Talgdrüsentumor",
      "Talgdrüsenzyste",
      "Talgdrüsenzyste des Skrotums",
      "Talgzyste",
      "Trichilemmalzyste",
      "Trichodermalzyste",
      "Zyste eines Talgdrüsenganges"
    ]
  },
  {
    "code": "L72.2",
    "name": "Steatocystoma multiplex",
    "synonyms": [
      "Sebozystomatosis",
      "Steatocystoma multiplex",
      "Steatocystoma multiplex mit neonatalen Zähnen"
    ]
  },
  {
    "code": "L72.9",
    "name": "Follikuläre Zyste der Haut",
    "synonyms": [
      "Follikuläre Zyste der Haut",
      "Hautretentionszyste",
      "Hautzyste",
      "Skrotumzyste",
      "Zyste der Skrotumhaut"
    ]
  },
  {
    "code": "L73.0",
    "name": "Aknekeloid",
    "synonyms": [
      "Aknekeloid",
      "Dermatitis papillaris capillitii",
      "Folliculitis sclerotisans nuchae",
      "Keloidakne",
      "Keloidale Follikulitis"
    ]
  },
  {
    "code": "L73.1",
    "name": "Pseudofolliculitis barbae",
    "synonyms": [
      "Eingewachsene Barthaare",
      "Pili incarnati",
      "Pseudofolliculitis barbae"
    ]
  },
  {
    "code": "L73.2",
    "name": "Hidradenitis suppurativa",
    "synonyms": [
      "Acne inversa",
      "Aknetriade",
      "Apokrine Akne",
      "Eitrige Hidradenitis",
      "Eitrige Hydroadenitis",
      "Hidradenitis",
      "Hidradenitis axillaris",
      "Hidradenitis der Achselhöhle",
      "Hidradenitis suppurativa",
      "Hydroadenitis",
      "Hydroadenitis der Achselhöhle",
      "Pyodermia fistulans sinifica",
      "Schweißdrüsenentzündung"
    ]
  },
  {
    "code": "L73.8",
    "name": "Sycosis vulgaris",
    "synonyms": [
      "Bartflechte",
      "Eosinophile pustulöse Follikulitis",
      "Folliculitis barbae",
      "Folliculitis capitis",
      "Folliculitis simplex",
      "Folliculitis staphylogenes superficialis",
      "Naseneingangsfollikulitis",
      "Ofuji-Syndrom",
      "Parasitäre Follikulitis",
      "Sterile eosinophile Pustulose Ofuji",
      "Sycosis",
      "Sycosis barbae",
      "Sycosis lupoides",
      "Sycosis non parasitaria",
      "Sycosis simplex",
      "Sycosis vulgaris",
      "Sykose",
      "Talgdrüsenhyperplasie",
      "Ulerythema sycosiforme"
    ]
  },
  {
    "code": "L73.9",
    "name": "Ostiofolliculitis impetiginosa",
    "synonyms": [
      "Folliculitis",
      "Follikulitis",
      "Haarbalgdrüsenentzündung",
      "Haarfollikelentzündung",
      "Haarfollikelkrankheit",
      "Haarkrankheit",
      "Haarwachstumsstörung",
      "Ostiofolliculitis",
      "Ostiofolliculitis impetiginosa",
      "Talgdrüsenkrankheit"
    ]
  },
  {
    "code": "L74.0",
    "name": "Miliaria rubra",
    "synonyms": [
      "Hitzeausschlag",
      "Hitzefrieseln",
      "Miliaria rubra"
    ]
  },
  {
    "code": "L74.1",
    "name": "Miliaria cristallina",
    "synonyms": [
      "Miliaria alba",
      "Miliaria cristallina",
      "Sudamina"
    ]
  },
  {
    "code": "L74.2",
    "name": "Miliaria profunda",
    "synonyms": [
      "Miliaria profunda",
      "Miliaria tropica"
    ]
  },
  {
    "code": "L74.3",
    "name": "Miliaria",
    "synonyms": [
      "Friesel",
      "Miliaria",
      "Miliaria epidemica",
      "Schweißfriesel",
      "Sudor anglicus"
    ]
  },
  {
    "code": "L74.4",
    "name": "Anhidrose",
    "synonyms": [
      "Anhidrose",
      "Anidrose",
      "Hypohidrose",
      "Isolierte generalisierte Anhidrose mit normalen Schweißdrüsen",
      "Oligohidrose"
    ]
  },
  {
    "code": "L74.8",
    "name": "Periporitis",
    "synonyms": [
      "Apokriner Abszess",
      "Granuloma rubrum nasi",
      "Granulosis rubra nasi",
      "Hämathidrose",
      "Hämatidrose",
      "Hämhidrose",
      "Hämidrose",
      "Periporitis",
      "Schweißdrüsenabszess",
      "Schweißdrüsenabszess der Achselhöhle",
      "Schweißdrüsenzyste",
      "Urhidrose",
      "Zyste eines Schweißdrüsenganges"
    ]
  },
  {
    "code": "L74.9",
    "name": "Schweißdrüsenstörung",
    "synonyms": [
      "Ekkrine Schweißdrüsenkrankheit",
      "Schweißdrüsenaffektion",
      "Schweißdrüsenkrankheit",
      "Schweißdrüsenstörung"
    ]
  },
  {
    "code": "L75.0",
    "name": "Bromhidrose",
    "synonyms": [
      "Bromhidrose",
      "Bromidrose",
      "Fötider Schweiß",
      "Osmidrose"
    ]
  },
  {
    "code": "L75.1",
    "name": "Chromhidrose",
    "synonyms": [
      "Chromhidrose",
      "Chromidrose"
    ]
  },
  {
    "code": "L75.2",
    "name": "Apokrine Miliaria",
    "synonyms": [
      "Apokrine Miliaria",
      "Fox-Fordyce-Krankheit",
      "Fox-Fordyce-Syndrom"
    ]
  },
  {
    "code": "L75.8",
    "name": "Abscessus sudoriparus",
    "synonyms": [
      "Abscessus sudoriparus"
    ]
  },
  {
    "code": "L75.9",
    "name": "Krankheit der apokrinen Schweißdrüsen",
    "synonyms": [
      "Krankheit der apokrinen Schweißdrüsen"
    ]
  },
  {
    "code": "L80",
    "name": "Vitiligo",
    "synonyms": [
      "Vitiligo",
      "Weißfleckenkrankheit [Vitiligo]"
    ]
  },
  {
    "code": "L81.0",
    "name": "Postinflammatorische Hyperpigmentierung",
    "synonyms": [
      "Postinflammatorische Hyperpigmentation",
      "Postinflammatorische Hyperpigmentierung"
    ]
  },
  {
    "code": "L81.1",
    "name": "Melasma",
    "synonyms": [
      "Chloasma",
      "Chloasma cachecticorum",
      "Chloasma hormonale",
      "Chloasma medicamentosum",
      "Chloasma symptomaticum",
      "Chloasma virginum periorale",
      "Idiopathisches Chloasma",
      "Melasma",
      "Symptomatisches Chloasma"
    ]
  },
  {
    "code": "L81.2",
    "name": "Epheliden",
    "synonyms": [
      "Epheliden",
      "Sommersprossen"
    ]
  },
  {
    "code": "L81.3",
    "name": "Café-au-lait-Flecken",
    "synonyms": [
      "Café-au-lait-Flecken"
    ]
  },
  {
    "code": "L81.4",
    "name": "Riehl-Melanose",
    "synonyms": [
      "Akromelanose",
      "Familiäre generalisierte Lentiginose",
      "Familiäre progressive Hyperpigmentierung",
      "Kongenitale Lentigo",
      "Leberflecken",
      "Lentigo",
      "Lentigo aestiva",
      "Lentigo benigna",
      "Lentigo senilis",
      "Melaninanreicherung",
      "Melanineinlagerung",
      "Melaninhyperpigmentation",
      "Melaninspeicherung",
      "Melanodermie",
      "Melanose",
      "Melanosis",
      "Nävoide Lentigo",
      "PUVA-Lentigines",
      "Riehl-Melanose",
      "Riehl-Syndrom",
      "Streifen- und wirbelförmige nävoide Hypermelanose",
      "Teermelanose",
      "Toxische Melanose"
    ]
  },
  {
    "code": "L81.5",
    "name": "Leukoderm",
    "synonyms": [
      "Leukoderm",
      "Leukoderma a.n.k.",
      "Leukodermie a.n.k."
    ]
  },
  {
    "code": "L81.6",
    "name": "Poikilodermie",
    "synonyms": [
      "Pigmentationsstörung durch verminderte Melaninbildung",
      "Poikilodermia",
      "Poikilodermie"
    ]
  },
  {
    "code": "L81.7",
    "name": "Pigmentpurpura",
    "synonyms": [
      "Angioma serpiginosum",
      "Chronische Pigmentpurpura",
      "Dermatosis pigmentaris Schamberg",
      "Dermatosis pigmentaris progressiva",
      "Essentielle Teleangiektasie",
      "Essentielle familiäre Teleangiektasie",
      "Generalisierte essentielle Teleangiektasie",
      "Majocchi-Krankheit",
      "Majocchi-Purpura",
      "Pigmentpurpura",
      "Purpura anularis teleangiectodes",
      "Purpura pigmentosa progressiva",
      "Schamberg-Dermatitis",
      "Schamberg-Krankheit",
      "Schamberg-Syndrom",
      "Syndrom der familiären kutanen Teleangiektasie mit Prädisposition für Oropharynxkarzinom"
    ]
  },
  {
    "code": "L81.8",
    "name": "Senile Hyperpigmentierung",
    "synonyms": [
      "Arsenmelanose",
      "Arsenpigmentation",
      "Arsenpigmentierung",
      "Dowling-Degos-Krankheit",
      "Dyschromatosis symmetrica hereditaria",
      "Dyschromatosis universalis",
      "Familiäre progressive Hyperpigmentierung mit Hypopigmentierung",
      "Hyperpigmentation",
      "Hyperpigmentierung",
      "Metallpigmentierung",
      "Pigmentatio aurosa",
      "Pigmentationsstörung durch Eisen",
      "Pigmentierung durch Eisenablagerung",
      "Retikuläre Hyperpigmentierung vom Typ Kitamura",
      "Retikuläre Pigmentdermatose der Intertrigines",
      "Senile Hyperpigmentierung",
      "Tattoo",
      "Tätowierung"
    ]
  },
  {
    "code": "L81.9",
    "name": "Hautpigmentierungsstörung",
    "synonyms": [
      "Abnorme Pigmentierung",
      "Chromatose",
      "Dermatosis pigmentaris",
      "Dyschromie",
      "Dyschromie der Haut",
      "Hautpigmentierungsstörung",
      "Histochromatosis",
      "Pigmentationsanomalie a.n.k.",
      "Pigmentationsstörung",
      "Pigmentstörung",
      "Progressive Pigmentdermatose"
    ]
  },
  {
    "code": "L82",
    "name": "Basalzellpapillom",
    "synonyms": [
      "Alterswarze",
      "Basalzellpapillom",
      "Dermatosis papulosa nigra",
      "Keratosis seborrhoica",
      "Leser-Trélat-Krankheit",
      "Leser-Trélat-Syndrom",
      "Seborrhoische Akanthose",
      "Seborrhoische Keratose",
      "Seborrhoische Warze",
      "Senile Warze",
      "Verruca seborrhoica",
      "Verruca senilis"
    ]
  },
  {
    "code": "L83",
    "name": "Acanthosis nigricans",
    "synonyms": [
      "Acanthosis nigricans",
      "Akanthose",
      "Erworbene Akanthose",
      "Gougerot-Carteaud-Krankheit",
      "Gougerot-Carteaud-Syndrom",
      "Keratosis nigricans",
      "Papillomatosis confluens et reticularis"
    ]
  },
  {
    "code": "L84",
    "name": "Heloma",
    "synonyms": [
      "Berufsschwiele",
      "Callositas",
      "Clavus - s.a. Klavus",
      "Entzündeter Klavus",
      "Erworbene Tyloma",
      "Hautschwiele",
      "Heloma",
      "Hornhautschwiele",
      "Hornschwiele",
      "Hühnerauge",
      "Infizierte Callositas",
      "Infizierter Kallus",
      "Infizierter Klavus",
      "Infiziertes Hühnerauge",
      "Kallositas",
      "Kallus",
      "Klavus",
      "Klavusentzündung",
      "Leichdorn [Klavus]",
      "Melkerschwiele",
      "Schwiele",
      "Tyloma",
      "Tylosis",
      "Tylositas articulorum"
    ]
  },
  {
    "code": "L85.0",
    "name": "Erworbene Ichthyosis",
    "synonyms": [
      "Erworbene Fischschuppen-Krankheit",
      "Erworbene Ichthyosis",
      "Erworbenes Xeroderma"
    ]
  },
  {
    "code": "L85.1",
    "name": "Plantare Hyperkeratose",
    "synonyms": [
      "Erworbene Keratodermie",
      "Erworbenes Keratoma palmare et plantare",
      "Erworbenes Keratoma palmoplantare",
      "Erworbenes Tyloma palmaris et plantaris",
      "Haxthausen-Hyperkeratosis",
      "Haxthausen-Syndrom",
      "Hyperkeratosis palmoplantaris climacterica",
      "Keratodermia climacterica",
      "Klimakterische Keratodermie",
      "Plantare Hyperkeratose"
    ]
  },
  {
    "code": "L85.2",
    "name": "Keratosis punctata palmoplantaris",
    "synonyms": [
      "Keratodermia punctata",
      "Keratosis punctata palmoplantaris"
    ]
  },
  {
    "code": "L85.3",
    "name": "Xerosis cutis",
    "synonyms": [
      "Asteatosis",
      "Asteatosis cutis",
      "Hautxerose",
      "Trockendermatose",
      "Trockene Haut",
      "Xerodermie",
      "Xerosis cutis"
    ]
  },
  {
    "code": "L85.8",
    "name": "Erworbene Keratosis suprafollicularis [Keratosis pilaris simplex]",
    "synonyms": [
      "Aquagene palmoplantare Keratodermie",
      "Cornu cutaneum",
      "Cornu cutaneum des Lids",
      "Dyskeratose",
      "Dyskeratosis",
      "Erworbene Keratosis pilaris",
      "Erworbene Keratosis suprafollicularis [Keratosis pilaris simplex]",
      "Erworbene Lichen pilaris",
      "Familiäres Keratoakanthom",
      "Generalisiertes eruptives Keratoakanthom",
      "Hauthorn",
      "Hyperkeratosis lenticularis perstans",
      "Keratoakanthom",
      "Keratoakanthom des Lids",
      "Keratose durch Arsen",
      "Keratosis pilaris simplex [Erworbene Keratosis suprafollicularis]",
      "Morbus Flegel",
      "Rhagadiforme Hyperkeratose",
      "Trichodysplasia spinulosa"
    ]
  },
  {
    "code": "L85.9",
    "name": "Hyperkeratose",
    "synonyms": [
      "Epidermisverdickung",
      "Epithelhyperplasie",
      "Hyperkeratose",
      "Hyperkeratosis",
      "Hyperkeratöse Schädigung",
      "Pachydermatose",
      "Pachydermia",
      "Pachydermie"
    ]
  },
  {
    "code": "L87.0",
    "name": "Hyperkeratosis follicularis et parafollicularis in cutem penetrans",
    "synonyms": [
      "Hyperkeratosis follicularis et parafollicularis in cutem penetrans",
      "Hyperkeratosis follicularis penetrans",
      "Kyrle-Krankheit",
      "Kyrle-Syndrom"
    ]
  },
  {
    "code": "L87.1",
    "name": "Reaktive perforierende Kollagenose",
    "synonyms": [
      "Familiäre reaktive perforierende Kollagenose",
      "Larsen-ähnliches Syndrom Typ B3GAT3",
      "Reaktive perforierende Kollagenose"
    ]
  },
  {
    "code": "L87.2",
    "name": "Elastosis perforans serpiginosa",
    "synonyms": [
      "Elastosis perforans serpiginosa",
      "Lutz-Miescher-Elastoma",
      "Perforierendes Elastoma"
    ]
  },
  {
    "code": "L87.9",
    "name": "Störung der transepidermalen Elimination",
    "synonyms": [
      "Störung der transepidermalen Elimination"
    ]
  },
  {
    "code": "L88",
    "name": "Pyoderma gangraenosum",
    "synonyms": [
      "Bullöse Form des Pyoderma gangraenosum",
      "Dermatitis ulcerosa",
      "Gangränöse Pyodermie",
      "Phagedänische Pyodermie",
      "Pustulöse Form des Pyoderma gangraenosum",
      "Pyoderma gangraenosum",
      "Ulzeröse Form des Pyoderma gangraenosum",
      "Vegetierende Form des Pyoderma gangraenosum"
    ]
  },
  {
    "code": "L89.00",
    "name": "Dekubitus 1. Grades am Kopf",
    "synonyms": [
      "Dekubitus 1. Grades am Kopf",
      "Dekubitus, Kategorie 1 am Kopf",
      "Dekubitus, Stadium 1 am Kopf"
    ]
  },
  {
    "code": "L89.01",
    "name": "Dekubitus 1. Grades an der oberen Extremität",
    "synonyms": [
      "Dekubitus 1. Grades an der oberen Extremität",
      "Dekubitus, Stadium 1 an der oberen Extremität"
    ]
  },
  {
    "code": "L89.02",
    "name": "Dekubitus 1. Grades am Dornfortsatz",
    "synonyms": [
      "Dekubitus 1. Grades am Dornfortsatz",
      "Dekubitus, Stadium 1 am Dornfortsatz"
    ]
  },
  {
    "code": "L89.03",
    "name": "Dekubitus 1. Grades am Beckenkamm",
    "synonyms": [
      "Dekubitus 1. Grades am Beckenkamm",
      "Dekubitus, Stadium 1 am Beckenkamm"
    ]
  },
  {
    "code": "L89.04",
    "name": "Dekubitus 1. Grades am Steißbein",
    "synonyms": [
      "Dekubitus 1. Grades am Kreuzbein",
      "Dekubitus 1. Grades am Steißbein",
      "Dekubitus, Stadium 1 am Kreuzbein",
      "Dekubitus, Stadium 1 am Steißbein"
    ]
  },
  {
    "code": "L89.05",
    "name": "Dekubitus 1. Grades am Sitzbein",
    "synonyms": [
      "Dekubitus 1. Grades am Sitzbein",
      "Dekubitus, Stadium 1 am Sitzbein"
    ]
  },
  {
    "code": "L89.06",
    "name": "Dekubitus 1. Grades am Trochanter",
    "synonyms": [
      "Dekubitus 1. Grades am Trochanter",
      "Dekubitus, Stadium 1 am Trochanter"
    ]
  },
  {
    "code": "L89.07",
    "name": "Dekubitus 1. Grades an der Ferse",
    "synonyms": [
      "Dekubitus 1. Grades an der Ferse",
      "Dekubitus, Stadium 1 an der Ferse"
    ]
  },
  {
    "code": "L89.09",
    "name": "Dekubitus 1. Grades",
    "synonyms": [
      "Dekubitus 1. Grades",
      "Dekubitus, Stadium 1",
      "Druckzone mit nicht wegdrückbarer Rötung bei intakter Haut"
    ]
  },
  {
    "code": "L89.10",
    "name": "Dekubitus 2. Grades am Kopf",
    "synonyms": [
      "Dekubitus 2. Grades am Kopf",
      "Dekubitus, Stadium 2 am Kopf"
    ]
  },
  {
    "code": "L89.11",
    "name": "Dekubitus 2. Grades an der oberen Extremität",
    "synonyms": [
      "Dekubitus 2. Grades an der oberen Extremität",
      "Dekubitus, Stadium 2 an der oberen Extremität"
    ]
  },
  {
    "code": "L89.12",
    "name": "Dekubitus 2. Grades am Dornfortsatz",
    "synonyms": [
      "Dekubitus 2. Grades am Dornfortsatz",
      "Dekubitus, Stadium 2 am Dornfortsatz"
    ]
  },
  {
    "code": "L89.13",
    "name": "Dekubitus 2. Grades am Beckenkamm",
    "synonyms": [
      "Dekubitus 2. Grades am Beckenkamm",
      "Dekubitus, Stadium 2 am Beckenkamm"
    ]
  },
  {
    "code": "L89.14",
    "name": "Dekubitus 2. Grades am Steißbein",
    "synonyms": [
      "Dekubitus 2. Grades am Kreuzbein",
      "Dekubitus 2. Grades am Steißbein",
      "Dekubitus, Stadium 2 am Kreuzbein",
      "Dekubitus, Stadium 2 am Steißbein"
    ]
  },
  {
    "code": "L89.15",
    "name": "Dekubitus 2. Grades am Sitzbein",
    "synonyms": [
      "Dekubitus 2. Grades am Sitzbein",
      "Dekubitus, Stadium 2 am Sitzbein"
    ]
  },
  {
    "code": "L89.16",
    "name": "Dekubitus 2. Grades am Trochanter",
    "synonyms": [
      "Dekubitus 2. Grades am Trochanter",
      "Dekubitus, Stadium 2 am Trochanter"
    ]
  },
  {
    "code": "L89.17",
    "name": "Dekubitus 2. Grades an der Ferse",
    "synonyms": [
      "Dekubitus 2. Grades an der Ferse",
      "Dekubitus, Stadium 2 an der Ferse"
    ]
  },
  {
    "code": "L89.19",
    "name": "Dekubitus 2. Grades",
    "synonyms": [
      "Dekubitus 2. Grades",
      "Dekubitus mit Blase",
      "Dekubitus, Stadium 2"
    ]
  },
  {
    "code": "L89.20",
    "name": "Dekubitus 3. Grades am Kopf",
    "synonyms": [
      "Dekubitus 3. Grades am Kopf",
      "Dekubitus, Stadium 3 am Kopf"
    ]
  },
  {
    "code": "L89.21",
    "name": "Dekubitus 3. Grades an der oberen Extremität",
    "synonyms": [
      "Dekubitus 3. Grades an der oberen Extremität",
      "Dekubitus, Stadium 3 an der oberen Extremität"
    ]
  },
  {
    "code": "L89.22",
    "name": "Dekubitus 3. Grades am Dornfortsatz",
    "synonyms": [
      "Dekubitus 3. Grades am Dornfortsatz",
      "Dekubitus, Stadium 3 am Dornfortsatz"
    ]
  },
  {
    "code": "L89.23",
    "name": "Dekubitus 3. Grades am Beckenkamm",
    "synonyms": [
      "Dekubitus 3. Grades am Beckenkamm",
      "Dekubitus, Stadium 3 am Beckenkamm"
    ]
  },
  {
    "code": "L89.24",
    "name": "Dekubitus 3. Grades am Steißbein",
    "synonyms": [
      "Dekubitus 3. Grades am Kreuzbein",
      "Dekubitus 3. Grades am Steißbein",
      "Dekubitus, Stadium 3 am Kreuzbein",
      "Dekubitus, Stadium 3 am Steißbein"
    ]
  },
  {
    "code": "L89.25",
    "name": "Dekubitus 3. Grades am Sitzbein",
    "synonyms": [
      "Dekubitus 3. Grades am Sitzbein",
      "Dekubitus, Stadium 3 am Sitzbein"
    ]
  },
  {
    "code": "L89.26",
    "name": "Dekubitus 3. Grades am Trochanter",
    "synonyms": [
      "Dekubitus 3. Grades am Trochanter",
      "Dekubitus, Stadium 3 am Trochanter"
    ]
  },
  {
    "code": "L89.27",
    "name": "Dekubitus 3. Grades an der Ferse",
    "synonyms": [
      "Dekubitus 3. Grades an der Ferse",
      "Dekubitus, Stadium 3 an der Ferse"
    ]
  },
  {
    "code": "L89.29",
    "name": "Drucknekrose",
    "synonyms": [
      "Dekubitalnekrose",
      "Dekubitus 3. Grades",
      "Dekubitus, Stadium 3",
      "Drucknekrose"
    ]
  },
  {
    "code": "L89.30",
    "name": "Dekubitus 4. Grades am Kopf",
    "synonyms": [
      "Dekubitus 4. Grades am Kopf",
      "Dekubitus, Stadium 4 am Kopf"
    ]
  },
  {
    "code": "L89.31",
    "name": "Dekubitus 4. Grades an der oberen Extremität",
    "synonyms": [
      "Dekubitus 4. Grades an der oberen Extremität",
      "Dekubitus, Stadium 4 an der oberen Extremität"
    ]
  },
  {
    "code": "L89.32",
    "name": "Dekubitus 4. Grades am Dornfortsatz",
    "synonyms": [
      "Dekubitus 4. Grades am Dornfortsatz",
      "Dekubitus, Stadium 4 am Dornfortsatz"
    ]
  },
  {
    "code": "L89.33",
    "name": "Dekubitus 4. Grades am Beckenkamm",
    "synonyms": [
      "Dekubitus 4. Grades am Beckenkamm",
      "Dekubitus, Stadium 4 am Beckenkamm"
    ]
  },
  {
    "code": "L89.34",
    "name": "Dekubitus 4. Grades am Steißbein",
    "synonyms": [
      "Dekubitus 4. Grades am Kreuzbein",
      "Dekubitus 4. Grades am Steißbein",
      "Dekubitus, Stadium 4 am Kreuzbein",
      "Dekubitus, Stadium 4 am Steißbein"
    ]
  },
  {
    "code": "L89.35",
    "name": "Dekubitus 4. Grades am Sitzbein",
    "synonyms": [
      "Dekubitus 4. Grades am Sitzbein",
      "Dekubitus, Stadium 4 am Sitzbein"
    ]
  },
  {
    "code": "L89.36",
    "name": "Dekubitus 4. Grades am Trochanter",
    "synonyms": [
      "Dekubitus 4. Grades am Trochanter",
      "Dekubitus, Stadium 4 am Trochanter"
    ]
  },
  {
    "code": "L89.37",
    "name": "Dekubitus 4. Grades an der Ferse",
    "synonyms": [
      "Dekubitus 4. Grades an der Ferse",
      "Dekubitus, Stadium 4 an der Ferse"
    ]
  },
  {
    "code": "L89.39",
    "name": "Dekubitus 4. Grades",
    "synonyms": [
      "Dekubitus 4. Grades",
      "Dekubitus, Stadium 4"
    ]
  },
  {
    "code": "L89.90",
    "name": "Dekubitus am Kopf",
    "synonyms": [
      "Dekubitus am Kopf"
    ]
  },
  {
    "code": "L89.91",
    "name": "Dekubitus an der oberen Extremität",
    "synonyms": [
      "Dekubitalulkus am Ellenbogengelenk",
      "Dekubitus am Arm",
      "Dekubitus an der oberen Extremität"
    ]
  },
  {
    "code": "L89.92",
    "name": "Dekubitus am Dornfortsatz",
    "synonyms": [
      "Dekubitus am Dornfortsatz"
    ]
  },
  {
    "code": "L89.93",
    "name": "Dekubitus am Beckenkamm",
    "synonyms": [
      "Dekubitalgeschwür an der Hüfte",
      "Dekubitalulkus am Becken",
      "Dekubitus am Beckenkamm"
    ]
  },
  {
    "code": "L89.94",
    "name": "Dekubitus am Steißbein",
    "synonyms": [
      "Decubitus praesacralis",
      "Decubitus sacralis",
      "Dekubitalgeschwür am Steißbein",
      "Dekubitalgeschwür im Kreuzbeinbereich",
      "Dekubitalgeschwür in der Regio sacralis",
      "Dekubitalulkus am Os sacrum",
      "Dekubitalulkus am Steiß",
      "Dekubitalulkus am Steißbein",
      "Dekubitus am Kreuzbein",
      "Dekubitus am Os sacrum",
      "Dekubitus am Steißbein",
      "Dekubitus am Steißbereich",
      "Dekubitus im Kreuzbeinbereich",
      "Dekubitus im Sakralbereich",
      "Druckulkus am Os sacrum",
      "Präsakrales Dekubitalgeschwür",
      "Präsakrales Dekubitalulkus",
      "Sakrale Dekubitalnekrose",
      "Sakrales Dekubitalgeschwür",
      "Sakrales Dekubitalulkus"
    ]
  },
  {
    "code": "L89.95",
    "name": "Dekubitus am Sitzbein",
    "synonyms": [
      "Dekubitus am Sitzbein"
    ]
  },
  {
    "code": "L89.96",
    "name": "Dekubitus am Trochanter",
    "synonyms": [
      "Dekubitus am Trochanter"
    ]
  },
  {
    "code": "L89.97",
    "name": "Dekubitus an der Ferse",
    "synonyms": [
      "Dekubitalgeschwür an der Ferse",
      "Dekubitalulkus an der Ferse",
      "Dekubitus an der Ferse",
      "Druckulkus an der Ferse"
    ]
  },
  {
    "code": "L89.98",
    "name": "Dekubitus am Fuß",
    "synonyms": [
      "Dekubitalgeschwür am Bein",
      "Dekubitalgeschwür am Fuß",
      "Dekubitalgeschwür am Oberschenkel",
      "Dekubitalgeschwür an der Wade",
      "Dekubitalulkus am Fuß",
      "Dekubitalulkus am Unterschenkel",
      "Dekubitus am Außenknöchel",
      "Dekubitus am Fuß",
      "Dekubitus am Unterschenkel",
      "Dekubitus an der Wade",
      "Dekubitus an der Zehe"
    ]
  },
  {
    "code": "L89.99",
    "name": "Aufliegestellen",
    "synonyms": [
      "Analdekubitus",
      "Aufliegestellen",
      "Dekubitalgeschwür",
      "Dekubitalgeschwür des Rückens",
      "Dekubitalgeschwür im Analbereich",
      "Dekubitalinfektion",
      "Dekubitalulkus",
      "Dekubitalulkus am Rücken",
      "Dekubitus",
      "Dekubitus am Rücken",
      "Dekubitus an der Analregion",
      "Dekubitusgeschwür",
      "Druckgeschwür - s.a. Dekubitus",
      "Druckulkus",
      "Gangrän bei Dekubitus",
      "Hautschädigung durch Druck",
      "Pflastergeschwür",
      "Pflasterulkus",
      "Ulkus durch medizinische Anwendung von Gips",
      "Wundliegen"
    ]
  },
  {
    "code": "L90.0",
    "name": "Lichen sclerosus et atrophicus",
    "synonyms": [
      "Lichen albus",
      "Lichen atrophicus",
      "Lichen sclerosus",
      "Lichen sclerosus et atrophicus",
      "Weißfleckenkrankheit [Lichen sclerosus et atrophicus]",
      "White spot disease [Lichen sclerosus et atrophicus]"
    ]
  },
  {
    "code": "L90.1",
    "name": "Schweninger-Buzzi-Anetodermie",
    "synonyms": [
      "Anetodermie vom Typ Schweninger-Buzzi",
      "Schweninger-Buzzi-Anetodermie"
    ]
  },
  {
    "code": "L90.2",
    "name": "Anetodermie vom Typ Jadassohn-Pellizzari",
    "synonyms": [
      "Anetodermie vom Typ Jadassohn-Pellizzari",
      "Jadassohn-Pellizzari-Anetodermie"
    ]
  },
  {
    "code": "L90.3",
    "name": "Atrophodermia idiopathica vom Typ Pasini-Pierini",
    "synonyms": [
      "Atrophodermia idiopathica vom Typ Pasini-Pierini"
    ]
  },
  {
    "code": "L90.4",
    "name": "Akrodermatitis chronica atrophicans",
    "synonyms": [
      "Akrodermatitis atrophicans Herxheimer",
      "Akrodermatitis chronica atrophicans",
      "Akrodermatitis chronica atrophicans Herxheimer",
      "Atrophia cutis idiopathica progressiva",
      "Erythromelie",
      "Herxheimer-Krankheit",
      "Herxheimer-Syndrom",
      "Morbus Herxheimer"
    ]
  },
  {
    "code": "L90.5",
    "name": "Verunstaltung durch Narbe",
    "synonyms": [
      "Adhäsion einer Narbe",
      "Atrophische Narbe",
      "Bindegewebenarbe",
      "Cicatrix",
      "Dermatofibrose",
      "Entstellung durch Narbe",
      "Episiotomienarbe",
      "Hautfibrose a.n.k.",
      "Hautnarbe",
      "Hautnarbe mit Fibrose",
      "Narbe",
      "Narbenbeschwerden",
      "Narbenemphysem",
      "Narbenentzündung",
      "Narbenfibrose der Haut",
      "Narbengranulom",
      "Narbenirritation",
      "Narbenkontraktur",
      "Narbenproblem",
      "Narbenschmerzen",
      "Narbenverwachsung",
      "Postinfektiöse Hautnarbe",
      "Schmerzhafte Hautnarbe",
      "Schmerzhafte Narbe",
      "Verunstaltung durch Narbe",
      "Verwachsene Narbe"
    ]
  },
  {
    "code": "L90.6",
    "name": "Striae cutis atrophicae",
    "synonyms": [
      "Atrophia striata",
      "Mammastriae",
      "Schwangerschaftsstreifen",
      "Striae adolescentium",
      "Striae albicantes atrophicae",
      "Striae albicantes atrophicae der Haut",
      "Striae albicantes distensae",
      "Striae albicantes distensae der Haut",
      "Striae atrophicae",
      "Striae cutis atrophicae",
      "Striae cutis distensae",
      "Striae distensae",
      "Striae gravidarum",
      "Striae rubrae"
    ]
  },
  {
    "code": "L90.8",
    "name": "Dermatitis atrophicans",
    "synonyms": [
      "Anetodermia",
      "Anetodermia maculosa",
      "Anetodermie",
      "Atrophia cutis senilis",
      "Atrophische Hautflecken",
      "Atrophodermia linearis Moulin",
      "Atrophodermia maculata",
      "Atrophodermia neuriticum",
      "Dermatitis atrophicans",
      "Dermatitis atrophicans maculosa",
      "Familiäre Anetodermie",
      "Glanzhaut",
      "Maculae atrophicae",
      "Mediodermale Elastolyse",
      "Pseudoxanthoma elasticum-ähnliche papilläre dermale Elastolyse",
      "Senile Atrophodermie",
      "Senile Hautatrophie",
      "Weiße fibröse Papulose des Halses"
    ]
  },
  {
    "code": "L90.9",
    "name": "Atrophische Hautkrankheit",
    "synonyms": [
      "Atrophie der Gesichtshaut",
      "Atrophische Hautkrankheit",
      "Atrophoderma",
      "Atrophodermia",
      "Hautatrophie",
      "Schleimhautatrophie",
      "Subkutane Atrophie"
    ]
  },
  {
    "code": "L91.0",
    "name": "Wulstnarbe",
    "synonyms": [
      "Cicatrix hypertrophica",
      "Episiotomienarbenkeloid",
      "Hautkeloid",
      "Hypertrophe Narbe",
      "Hypertrophische Zikatrix",
      "Kelis",
      "Keloid",
      "Narbenhypertrophie",
      "Narbenkeloid",
      "Narbenwulst",
      "Spontankeloid",
      "Wulstnarbe",
      "Überschießende Keloidbildung",
      "Überschießende Narbe"
    ]
  },
  {
    "code": "L91.8",
    "name": "Hautanhängsel",
    "synonyms": [
      "Erworbene Cutis verticis gyrata",
      "Hautanhängsel",
      "Hypertrophiertes Hautanhängsel",
      "Infiziertes Hautanhängsel",
      "Parana-Syndrom"
    ]
  },
  {
    "code": "L91.9",
    "name": "Hypertrophe Hautkrankheit",
    "synonyms": [
      "Hauthypertrophie",
      "Hypertrophe Hautkrankheit"
    ]
  },
  {
    "code": "L92.0",
    "name": "Granuloma anulare",
    "synonyms": [
      "Granuloma anulare",
      "Granuloma anulare perforans"
    ]
  },
  {
    "code": "L92.1",
    "name": "Necrobiosis lipoidica a.n.k.",
    "synonyms": [
      "Lipoidnekrobiose",
      "Necrobiosis lipoidica a.n.k.",
      "Oppenheim-Urbach-Krankheit [Lipoidnekrobiose]"
    ]
  },
  {
    "code": "L92.2",
    "name": "Granuloma faciale",
    "synonyms": [
      "Eosinophiles Hautgranulom",
      "Granuloma eosinophilicum faciei",
      "Granuloma faciale"
    ]
  },
  {
    "code": "L92.3",
    "name": "Fremdkörpergranulom der Unterhaut",
    "synonyms": [
      "Berylliumgranulom der Haut",
      "Fadengranulom",
      "Fremdkörpergranulom der Haut",
      "Fremdkörpergranulom der Unterhaut",
      "Granulation einer Episiotomienaht",
      "Kieselsäuregranulom der Haut"
    ]
  },
  {
    "code": "L92.8",
    "name": "Granulomatosis disciformis",
    "synonyms": [
      "Fungus umbilicalis",
      "Granuloma umbilicale",
      "Granulomatosis disciformis",
      "Nabelgranulom",
      "Nabelschwamm",
      "Sklerosierendes Lipogranulom"
    ]
  },
  {
    "code": "L92.9",
    "name": "Caro luxurians",
    "synonyms": [
      "Abnormes Granulationsgewebe",
      "Caro luxurians",
      "Granulom",
      "Granuloma",
      "Granulomatose",
      "Granulomatosis",
      "Granulomatöse Hautkrankheit",
      "Hautgranulom",
      "Übermäßiges Granulationsgewebe"
    ]
  },
  {
    "code": "L93.0",
    "name": "Erythematodes chronicus discoides",
    "synonyms": [
      "Biett-Krankheit",
      "Chronischer Lupus erythematodes",
      "Chronischer kutaner Lupus erythematodes",
      "Diskoider Lupus erythematodes",
      "Diskoider fokaler Lupus",
      "Erythematodes chronicus discoides",
      "Kutaner Lupus erythematodes",
      "Lupus erythematodes",
      "Lupus erythematodes discoides",
      "Lupus erythematodes integumentalis"
    ]
  },
  {
    "code": "L93.1",
    "name": "Subakuter Lupus erythematodes cutaneus",
    "synonyms": [
      "Subakuter Lupus erythematodes cutaneus",
      "Subakuter kutaner Lupus erythematodes"
    ]
  },
  {
    "code": "L93.2",
    "name": "Lupus-Pannikulitis",
    "synonyms": [
      "Chilblain-Lupus",
      "Familiärer Chilblain-Lupus",
      "Hypertropher Lupus erythematodes",
      "Lupus erythematodes profundus",
      "Lupus erythematodes tumidus",
      "Lupus-Pannikulitis",
      "Verruköser Lupus erythematodes"
    ]
  },
  {
    "code": "L94.0",
    "name": "Sclerodermia circumscripta",
    "synonyms": [
      "Addison-Keloid",
      "En-plaques-Sklerodermie",
      "Lokalisierte Dermatosklerose",
      "Lokalisierte Sklerodermie",
      "Morphaea",
      "Sclerodermia circumscripta",
      "Zirkumskripte Sklerodermie"
    ]
  },
  {
    "code": "L94.1",
    "name": "Sclerodermia en Band",
    "synonyms": [
      "Lineare Sklerodermie",
      "Sclerodermia en Band",
      "Sclerodermia linearis",
      "Sclérodermie en coup de sabre"
    ]
  },
  {
    "code": "L94.2",
    "name": "Calcinosis cutis",
    "synonyms": [
      "Calcinosis circumscripta",
      "Calcinosis cutis",
      "Cutis osteosis",
      "Kalkgicht",
      "Osteosis cutis",
      "Subkutane Kalzifikation"
    ]
  },
  {
    "code": "L94.3",
    "name": "Sklerodaktylie",
    "synonyms": [
      "Sklerodaktylie"
    ]
  },
  {
    "code": "L94.4",
    "name": "Gottron-Papeln",
    "synonyms": [
      "Gottron-Papeln"
    ]
  },
  {
    "code": "L94.5",
    "name": "Poikilodermia atrophicans vascularis Jacobi",
    "synonyms": [
      "Poikilodermia atrophicans vascularis Jacobi"
    ]
  },
  {
    "code": "L94.6",
    "name": "Ainhum [Dactylolysis essentialis]",
    "synonyms": [
      "Ainhum [Dactylolysis essentialis]",
      "Ainhum-Syndrom",
      "Dabue [Ainhum]",
      "Dactylolysis essentialis [Ainhum]",
      "Dactylolysis spontanea",
      "Guduram"
    ]
  },
  {
    "code": "L94.8",
    "name": "Lineare fokale Elastose",
    "synonyms": [
      "Erworbenes Pseudoxanthoma elasticum",
      "Lineare fokale Elastose",
      "Papulöse Elastorrhexis"
    ]
  },
  {
    "code": "L94.9",
    "name": "Lokalisierte Krankheit des Bindegewebes",
    "synonyms": [
      "Lokalisierte Krankheit des Bindegewebes"
    ]
  },
  {
    "code": "L95.0",
    "name": "Livedo-Vaskulitis",
    "synonyms": [
      "Atrophie blanche",
      "Capillaritis alba",
      "Livedo reticularis mit Sommerulzerationen",
      "Livedo-Vaskulitis",
      "Livedovaskulopathie"
    ]
  },
  {
    "code": "L95.1",
    "name": "Erythema elevatum et diutinum",
    "synonyms": [
      "Bury-Krankheit",
      "Erythema elevatum et diutinum"
    ]
  },
  {
    "code": "L95.8",
    "name": "Noduläre Vaskulitis",
    "synonyms": [
      "Juvenile Arteriitis temporalis",
      "Noduläre Vaskulitis"
    ]
  },
  {
    "code": "L95.9",
    "name": "Vaskulitis der Haut",
    "synonyms": [
      "Vaskulitis der Haut"
    ]
  },
  {
    "code": "L97",
    "name": "Offener Fuß",
    "synonyms": [
      "Atrophisches Ulkus der unteren Extremität",
      "Chronisches Ulkus der unteren Extremität",
      "Fersenulkus",
      "Fußulkus",
      "Hautulkus der unteren Extremität",
      "Indolentes Fußulkus",
      "Infektiöses Ulcus cruris",
      "Neurogenes Ulkus der unteren Extremität",
      "Offener Fuß",
      "Perforiertes Fußulkus",
      "Perforiertes Ulkus der unteren Extremität",
      "Posttraumatisches Ulcus cruris",
      "Pyogenes Ulkus der unteren Extremität",
      "Ulcus cruris",
      "Unterschenkelgeschwür"
    ]
  },
  {
    "code": "L98.0",
    "name": "Granuloma pediculatum",
    "synonyms": [
      "Eitriges Granulom",
      "Entzündetes Granulom",
      "Granuloma pediculatum",
      "Granuloma pyogenicum",
      "Granuloma septicum",
      "Granuloma teleangiectaticum",
      "Suppuratives Granulom"
    ]
  },
  {
    "code": "L98.1",
    "name": "Dermatitis factitia",
    "synonyms": [
      "Artefakt",
      "Dermatitis artefacta",
      "Dermatitis factitia",
      "Dermatosis factitia",
      "Hautartefakt",
      "Neurotische Exkoriation",
      "Neurotische Hautabschürfung",
      "Neurotische oberflächliche Hautverletzung"
    ]
  },
  {
    "code": "L98.2",
    "name": "Akute febrile neutrophile Dermatose [Sweet-Syndrom]",
    "synonyms": [
      "Akute febrile neutrophile Dermatose [Sweet-Syndrom]",
      "Sweet-Dermatose",
      "Sweet-Syndrom"
    ]
  },
  {
    "code": "L98.3",
    "name": "Eosinophile Zellulitis",
    "synonyms": [
      "Eosinophile Zellulitis",
      "Wells-Syndrom"
    ]
  },
  {
    "code": "L98.4",
    "name": "Chronisches Geschwür",
    "synonyms": [
      "Barcoo-Krankheit",
      "Chronisches Geschwür",
      "Chronisches Hautgeschwür",
      "Chronisches Hautulkus",
      "Epithelulzeration",
      "Geschwür",
      "Hautgeschwür a.n.k.",
      "Hautulkus",
      "Hüftulkus",
      "Infektion der Haut mit Ulkus",
      "Infektiöses Ulkus",
      "Malum perforans pedis",
      "Meleney-Gangrän",
      "Meleney-Ulkus",
      "Naga-Geschwür",
      "Rezidivierendes Ulkus",
      "Sakralulkus",
      "Traumatisches Ulkus",
      "Trophisches Hautgeschwür",
      "Tropisches phagedänisches Geschwür",
      "Ulcus - s.a. Ulkus",
      "Ulcus chronicum der Haut",
      "Ulcus genitale",
      "Ulcus perforans der Haut",
      "Ulcus tropicum a.n.k.",
      "Ulkus - s.a. Ulcus",
      "Ulkuskrankheit der Haut",
      "Ulkusperforation der Haut",
      "Ulzera",
      "Ulzeration",
      "Ulzeröse Veränderung",
      "Wüstenulkus"
    ]
  },
  {
    "code": "L98.5",
    "name": "Hautmuzinose",
    "synonyms": [
      "Akral-persistierende papulöse Muzinose",
      "Arndt-Gottron-Syndrom",
      "Atypischer Lichen myxoedematosus",
      "Diskreter papulöser Lichen myxoedematosus",
      "Fokale Muzinose",
      "Generalisierter papulöser und sklerodermoider Lichen myxoedematosus",
      "Hautmuzinose",
      "Kutane Muzinose",
      "Lichen myxoedematosus",
      "Mucinosis",
      "Mucinosis papulosa",
      "Muzinose",
      "Myxoedema cutis",
      "Myxoedema papulatum",
      "Nodulärer Lichen myxoedematosus",
      "Papulöse Muzinose",
      "Papulöse Muzinose des Säuglingsalters",
      "Retikuläre erythematöse Muzinose",
      "Selbstheilende papulöse Muzinose",
      "Skleromyxödem"
    ]
  },
  {
    "code": "L98.6",
    "name": "Infiltrative Hautkrankheit",
    "synonyms": [
      "Benigne lymphozytäre Infiltration der Haut Typ Jessner-Kanof",
      "Infiltrative Hautkrankheit",
      "Jessnersche lymphozytäre Infiltration der Haut",
      "Lymphozytäre Infiltration Typ Jessner-Kanof"
    ]
  },
  {
    "code": "L98.7",
    "name": "Erschlaffung der Haut nach Gewichtsverlust",
    "synonyms": [
      "Erschlaffung der Gesichtshaut nach Gewichtsverlust",
      "Erschlaffung der Haut nach Gewichtsverlust",
      "Hängende Haut nach Gewichtsverlust",
      "Ptosis der Augenbraue",
      "Schlaffe Haut nach Gewichtsverlust",
      "Überschüssige Haut"
    ]
  },
  {
    "code": "L98.8",
    "name": "Senile Dermatose",
    "synonyms": [
      "Degenerative Hautkrankheit",
      "Elastoderma",
      "Epizoonose",
      "Fistel",
      "Fisteleiterung",
      "Fistula",
      "Hautdegeneration",
      "Hautdystrophie a.n.k.",
      "Hauterosion",
      "Hautfistel",
      "Hautunreinheit",
      "Irritationsdermatose",
      "Kolloide Hautdegeneration",
      "Kutane Fistel",
      "Kutanes Pseudolymphom",
      "Lymphadenosis cutis benigna [Morbus Bäfverstedt] [Bäfverstedt-Syndrom]",
      "Lymphozytom",
      "Lymphozytom Spiegler-Fendt",
      "Menstruale Dermatose a.n.k.",
      "Pseudolymphom",
      "Rhytidose",
      "Rhytidosis facialis",
      "Senile Dermatose",
      "Spät beginnende dermale fokale Elastose",
      "Stiff-skin-Syndrom",
      "Störung von Haut und Unterhaut",
      "Trophische Hautveränderung",
      "Umschriebene palmoplantare Hypokeratose",
      "Vermehrte Faltenbildung der Haut"
    ]
  },
  {
    "code": "L98.9",
    "name": "Haut- und Unterhauterkrankung",
    "synonyms": [
      "Dermatologische Erkrankung",
      "Dermatopathie",
      "Dermatose",
      "Dermatosis",
      "Exsudative Dermatose",
      "Haut- und Unterhauterkrankung",
      "Hautdefekt",
      "Hauterkrankung",
      "Hautkrankheit",
      "Hautläsion",
      "Hautschädigung",
      "Hautstörung",
      "Unterhautkrankheit"
    ]
  },
  {
    "code": "M00.09",
    "name": "Arthritis durch Staphylokokken",
    "synonyms": [
      "Arthritis durch Staphylokokken"
    ]
  },
  {
    "code": "M00.19",
    "name": "Arthritis durch Pneumokokken",
    "synonyms": [
      "Arthritis durch Pneumokokken"
    ]
  },
  {
    "code": "M00.29",
    "name": "Arthritis durch Streptokokken a.n.k.",
    "synonyms": [
      "Arthritis durch Streptokokken a.n.k."
    ]
  },
  {
    "code": "M00.90",
    "name": "Eitrige Polyarthritis",
    "synonyms": [
      "Eitrige Polyarthritis",
      "Pyogene Polyarthritis"
    ]
  },
  {
    "code": "M00.91",
    "name": "Akromioklavikulare Infektion",
    "synonyms": [
      "Akromioklavikulare Infektion",
      "Schultergelenkempyem",
      "Schultergelenkinfektion"
    ]
  },
  {
    "code": "M00.92",
    "name": "Ellenbogengelenkempyem",
    "synonyms": [
      "Ellenbogengelenkempyem"
    ]
  },
  {
    "code": "M00.95",
    "name": "Hüftgelenkinfektion",
    "synonyms": [
      "Eitrige Hüftgelenkkrankheit",
      "Hüftgelenkinfektion"
    ]
  },
  {
    "code": "M00.96",
    "name": "Kniegelenkempyem",
    "synonyms": [
      "Eitrige Gonarthritis",
      "Kniegelenkabszess",
      "Kniegelenkempyem",
      "Kniegelenkinfektion"
    ]
  },
  {
    "code": "M00.97",
    "name": "Sprunggelenkabszess",
    "synonyms": [
      "Empyem des Sprunggelenks",
      "Großzehengrundgelenkempyem",
      "Metatarsophalangeale Infektion",
      "Sprunggelenkabszess"
    ]
  },
  {
    "code": "M00.99",
    "name": "Chronische eitrige Arthritis",
    "synonyms": [
      "Arthritis durch Eitererreger a.n.k.",
      "Chronische eitrige Arthritis",
      "Eitrige Arthritis",
      "Eitrige Gelenkentzündung",
      "Eitrige Gelenkkrankheit",
      "Gelenkabszess",
      "Gelenkeiterung",
      "Gelenkempyem",
      "Gelenkinfektion",
      "Gelenkvereiterung",
      "Infektiöse Arthritis",
      "Purulente Arthritis",
      "Pyarthros",
      "Pyogene Arthritis",
      "Septische Arthritis"
    ]
  },
  {
    "code": "M02.09",
    "name": "Arthritis nach intestinalem Bypass",
    "synonyms": [
      "Arthritis nach intestinalem Bypass"
    ]
  },
  {
    "code": "M02.19",
    "name": "Postenteritische Arthritis",
    "synonyms": [
      "Postdysenterische Arthritis",
      "Postenteritische Arthritis",
      "Postenteritische Arthropathie"
    ]
  },
  {
    "code": "M02.29",
    "name": "Arthritis nach Impfung",
    "synonyms": [
      "Arthritis als Impfkomplikation",
      "Arthritis bei Serumkrankheit",
      "Arthritis nach Impfung",
      "Arthropathie nach Impfung",
      "Arthropathie nach Vakzination",
      "Impfarthritis",
      "Serumarthritis"
    ]
  },
  {
    "code": "M02.30",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] an mehreren Lokalisationen",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M02.31",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] der Schulterregion",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] der Schulterregion"
    ]
  },
  {
    "code": "M02.32",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Oberarms",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Oberarms"
    ]
  },
  {
    "code": "M02.33",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Unterarms",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Unterarms"
    ]
  },
  {
    "code": "M02.34",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] der Hand",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] der Hand"
    ]
  },
  {
    "code": "M02.35",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Beckens",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Beckens",
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Oberschenkels"
    ]
  },
  {
    "code": "M02.36",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Unterschenkels",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Unterschenkels"
    ]
  },
  {
    "code": "M02.37",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Sprunggelenks",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Fußes",
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] des Sprunggelenks"
    ]
  },
  {
    "code": "M02.38",
    "name": "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] der Wirbelsäule",
    "synonyms": [
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom] der Wirbelsäule"
    ]
  },
  {
    "code": "M02.39",
    "name": "Polyarthritis enterica",
    "synonyms": [
      "Arthritis dysenterica [Reiter-Syndrom]",
      "Arthritis urethritica [Reiter-Syndrom]",
      "Fiessinger-Leroy-Reiter-Krankheit",
      "Konjunktivisch-urethrisches synoviales Syndrom [Reiter-Syndrom]",
      "Konjunktivitis bei Reiter-Syndrom",
      "Morbus Reiter",
      "Polyarthritis enterica",
      "Postdysenterisches Syndrom [Reiter-Syndrom]",
      "Reiter-Krankheit",
      "Reiter-Syndrom",
      "Reiter-Trias",
      "Reiter-Urethritis",
      "Ruhrrheumatismus",
      "Trias aus Urethritis, Konjunktivitis und Arthritis",
      "Urethro-okulo-artikuläres Syndrom",
      "Urethro-okulo-synoviales Syndrom [Reiter-Syndrom]",
      "Venerische Arthritis"
    ]
  },
  {
    "code": "M02.99",
    "name": "Reaktive Arthritis",
    "synonyms": [
      "Infektarthritis [Reaktive Arthritis]",
      "Reaktive Arthritis",
      "Reaktive Arthropathie"
    ]
  },
  {
    "code": "M05.00",
    "name": "Felty-Syndrom [Polyarthritis, Splenomegalie und Leukopenie]",
    "synonyms": [
      "Chronische Polyarthritis mit Lymphosplenomegalie und Leukopenie",
      "Felty-Syndrom",
      "Felty-Syndrom [Polyarthritis, Splenomegalie und Leukopenie]",
      "Felty-Syndrom, mehrere Lokalisationen"
    ]
  },
  {
    "code": "M05.01",
    "name": "Felty-Syndrom, Schulterregion",
    "synonyms": [
      "Felty-Syndrom, Schulterregion"
    ]
  },
  {
    "code": "M05.02",
    "name": "Felty-Syndrom, Oberarm",
    "synonyms": [
      "Felty-Syndrom, Oberarm"
    ]
  },
  {
    "code": "M05.03",
    "name": "Felty-Syndrom, Unterarm",
    "synonyms": [
      "Felty-Syndrom, Unterarm"
    ]
  },
  {
    "code": "M05.04",
    "name": "Felty-Syndrom, Hand",
    "synonyms": [
      "Felty-Syndrom, Hand"
    ]
  },
  {
    "code": "M05.05",
    "name": "Felty-Syndrom, Beckenregion",
    "synonyms": [
      "Felty-Syndrom, Beckenregion",
      "Felty-Syndrom, Oberschenkel"
    ]
  },
  {
    "code": "M05.06",
    "name": "Felty-Syndrom, Unterschenkel",
    "synonyms": [
      "Felty-Syndrom, Unterschenkel"
    ]
  },
  {
    "code": "M05.07",
    "name": "Felty-Syndrom, Fuß",
    "synonyms": [
      "Felty-Syndrom, Fuß"
    ]
  },
  {
    "code": "M05.08",
    "name": "Felty-Syndrom, Wirbelsäule",
    "synonyms": [
      "Felty-Syndrom, Wirbelsäule"
    ]
  },
  {
    "code": "M05.20",
    "name": "Chronische Polyarthritis mit Vaskulitis",
    "synonyms": [
      "Chronische Polyarthritis mit Vaskulitis"
    ]
  },
  {
    "code": "M05.29",
    "name": "Rheumatoide Vaskulitis",
    "synonyms": [
      "Rheumatoide Vaskulitis"
    ]
  },
  {
    "code": "M05.30",
    "name": "Chronische Polyarthropathie mit Viszeralbeteiligung a.n.k.",
    "synonyms": [
      "Chronische Polyarthritis mit Systembeteiligung a.n.k.",
      "Chronische Polyarthritis mit Viszeralbeteiligung a.n.k.",
      "Chronische Polyarthropathie mit Systembeteiligung a.n.k.",
      "Chronische Polyarthropathie mit Viszeralbeteiligung a.n.k."
    ]
  },
  {
    "code": "M05.90",
    "name": "Seropositive chronische Polyarthritis",
    "synonyms": [
      "Seropositive chronische Polyarthritis"
    ]
  },
  {
    "code": "M06.00",
    "name": "Seronegative chronische Polyarthritis",
    "synonyms": [
      "Seronegative chronische Polyarthritis"
    ]
  },
  {
    "code": "M06.10",
    "name": "Adulte Form der Still-Krankheit",
    "synonyms": [
      "AOSD [Adult-onset Still disease]",
      "Adulte Form der Still-Krankheit",
      "Adulte Form der Still-Krankheit, mehrere Lokalisationen",
      "Adulte Form des Still-Syndroms",
      "Still-Syndrom des Erwachsenen"
    ]
  },
  {
    "code": "M06.11",
    "name": "Adulte Form der Still-Krankheit, Schulterregion",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Schulterregion"
    ]
  },
  {
    "code": "M06.12",
    "name": "Adulte Form der Still-Krankheit, Oberarm",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Oberarm"
    ]
  },
  {
    "code": "M06.13",
    "name": "Adulte Form der Still-Krankheit, Unterarm",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Unterarm"
    ]
  },
  {
    "code": "M06.14",
    "name": "Adulte Form der Still-Krankheit, Hand",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Hand"
    ]
  },
  {
    "code": "M06.15",
    "name": "Adulte Form der Still-Krankheit, Beckenregion",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Beckenregion",
      "Adulte Form der Still-Krankheit, Oberschenkel"
    ]
  },
  {
    "code": "M06.16",
    "name": "Adulte Form der Still-Krankheit, Unterschenkel",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Unterschenkel"
    ]
  },
  {
    "code": "M06.17",
    "name": "Adulte Form der Still-Krankheit, Fuß",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Fuß",
      "Adulte Form der Still-Krankheit, Sprunggelenk"
    ]
  },
  {
    "code": "M06.18",
    "name": "Adulte Form der Still-Krankheit, Wirbelsäule",
    "synonyms": [
      "Adulte Form der Still-Krankheit, Wirbelsäule"
    ]
  },
  {
    "code": "M06.20",
    "name": "Chronische Polyarthritis mit Bursitis",
    "synonyms": [
      "Chronische Polyarthritis mit Bursitis"
    ]
  },
  {
    "code": "M06.29",
    "name": "Rheumatoide Bursitis",
    "synonyms": [
      "Rheumatoide Bursitis"
    ]
  },
  {
    "code": "M06.30",
    "name": "Rheumaknoten",
    "synonyms": [
      "Rheumaknoten"
    ]
  },
  {
    "code": "M06.40",
    "name": "Entzündliche Polyarthropathie",
    "synonyms": [
      "Entzündliche Polyarthritis",
      "Entzündliche Polyarthropathie"
    ]
  },
  {
    "code": "M06.80",
    "name": "Fibroblastischer Rheumatismus an mehreren Lokalisationen",
    "synonyms": [
      "Fibroblastischer Rheumatismus an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M06.82",
    "name": "Fibroblastischer Rheumatismus des Ellenbogengelenks",
    "synonyms": [
      "Fibroblastischer Rheumatismus des Ellenbogengelenks"
    ]
  },
  {
    "code": "M06.83",
    "name": "Fibroblastischer Rheumatismus des Handgelenks",
    "synonyms": [
      "Fibroblastischer Rheumatismus des Handgelenks"
    ]
  },
  {
    "code": "M06.84",
    "name": "Fibroblastischer Rheumatismus der Hand",
    "synonyms": [
      "Fibroblastischer Rheumatismus der Hand"
    ]
  },
  {
    "code": "M06.86",
    "name": "Fibroblastischer Rheumatismus des Kniegelenks",
    "synonyms": [
      "Fibroblastischer Rheumatismus des Kniegelenks"
    ]
  },
  {
    "code": "M06.88",
    "name": "Rheumatoider Tortikollis",
    "synonyms": [
      "Rheumatoider Tortikollis",
      "Tortikollis bei chronischer Polyarthritis"
    ]
  },
  {
    "code": "M06.89",
    "name": "Fibroblastischer Rheumatismus",
    "synonyms": [
      "Fibroblastischer Rheumatismus"
    ]
  },
  {
    "code": "M06.90",
    "name": "Primär chronische Polyarthritis",
    "synonyms": [
      "Chronische Polyarthritis",
      "PCP [Primär-chronische Polyarthritis]",
      "Polyarthritis chronica",
      "Polyarthritis chronica progressiva",
      "Polyarthritis rheumatica",
      "Primär chronische Polyarthritis",
      "Primär chronische Polyarthropathie a.n.k.",
      "Progredient-chronische Polyarthritis",
      "Rheumatoide Polyarthritis"
    ]
  },
  {
    "code": "M06.99",
    "name": "Rheumatische Arthritis",
    "synonyms": [
      "Arthritis rheumatica",
      "Rheumatische Arthritis",
      "Rheumatoide Arthritis"
    ]
  },
  {
    "code": "M08.00",
    "name": "Juvenile chronische Polyarthritis vom adulten Typ",
    "synonyms": [
      "Juvenile Rheumafaktor-positive Polyarthritis",
      "Juvenile chronische Polyarthritis vom Erwachsenentyp mit Rheumafaktor-Nachweis",
      "Juvenile chronische Polyarthritis vom Erwachsenentyp ohne Rheumafaktor-Nachweis",
      "Juvenile chronische Polyarthritis vom adulten Typ"
    ]
  },
  {
    "code": "M08.19",
    "name": "Juvenile Spondylitis ankylosans",
    "synonyms": [
      "Juvenile Spondylitis ankylosans",
      "Juvenile axiale Spondyloarthritis"
    ]
  },
  {
    "code": "M08.20",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, mehrere Lokalisationen",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, mehrere Lokalisationen"
    ]
  },
  {
    "code": "M08.21",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Schulterregion",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Schulterregion"
    ]
  },
  {
    "code": "M08.22",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Ellenbogengelenk",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Ellenbogengelenk"
    ]
  },
  {
    "code": "M08.23",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Handgelenk",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Handgelenk"
    ]
  },
  {
    "code": "M08.24",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Hand",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Hand"
    ]
  },
  {
    "code": "M08.25",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Hüftgelenk",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Hüftgelenk",
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Iliosakralgelenk"
    ]
  },
  {
    "code": "M08.26",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Kniegelenk",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Kniegelenk"
    ]
  },
  {
    "code": "M08.27",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Fuß",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Fuß",
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Sprunggelenk"
    ]
  },
  {
    "code": "M08.28",
    "name": "Systemisch beginnende Form der juvenilen chronischen Arthritis, Wirbelsäule",
    "synonyms": [
      "Systemisch beginnende Form der juvenilen chronischen Arthritis, Wirbelsäule"
    ]
  },
  {
    "code": "M08.29",
    "name": "Juvenile chronische Arthritis, systemisch beginnende Form",
    "synonyms": [
      "Chauffard-Still-Syndrom",
      "Juvenile Still-Krankheit",
      "Juvenile chronische Arthritis, systemisch beginnende Form",
      "Juveniles Still-Syndrom",
      "Still-Krankheit",
      "Subsepsis hyperergica sive allergica"
    ]
  },
  {
    "code": "M08.3",
    "name": "Juvenile chronische seronegative Polyarthritis",
    "synonyms": [
      "Juvenile Rheumafaktor-negative Polyarthritis",
      "Juvenile Rheumafaktor-negative Polyarthritis mit antinukleären Antikörpern",
      "Juvenile chronische Arthritis, polyartikuläre Form",
      "Juvenile chronische Polyarthritis",
      "Juvenile chronische seronegative Polyarthritis",
      "Juvenile chronische seronegative Polyarthropathie",
      "Oligoartikulär beginnende Form der chronischen juvenilen Arthritis, im Verlauf polyartikulär [extended oligoarthritis]",
      "Polyartikulär beginnende Form der juvenilen Arthritis"
    ]
  },
  {
    "code": "M08.40",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, mehrere Lokalisationen",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, mehrere Lokalisationen"
    ]
  },
  {
    "code": "M08.41",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Schulterregion",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Schulterregion"
    ]
  },
  {
    "code": "M08.42",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Ellenbogengelenk",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Ellenbogengelenk"
    ]
  },
  {
    "code": "M08.43",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Handgelenk",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Handgelenk"
    ]
  },
  {
    "code": "M08.44",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Hand",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Hand"
    ]
  },
  {
    "code": "M08.45",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Beckenregion",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Beckenregion"
    ]
  },
  {
    "code": "M08.46",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Kniegelenk",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Kniegelenk"
    ]
  },
  {
    "code": "M08.47",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Fuß",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Fuß",
      "Juvenile chronische Arthritis, oligoartikuläre Form, Sprunggelenk"
    ]
  },
  {
    "code": "M08.48",
    "name": "Juvenile chronische Arthritis, oligoartikuläre Form, Wirbelsäule",
    "synonyms": [
      "Juvenile chronische Arthritis, oligoartikuläre Form, Wirbelsäule"
    ]
  },
  {
    "code": "M08.49",
    "name": "Juvenile chronische Arthritis, oligoartikulär beginnende Form",
    "synonyms": [
      "Juvenile Oligoarthritis",
      "Juvenile chronische Arthritis, oligoartikulär beginnende Form",
      "Juvenile oligoartikuläre Arthritis"
    ]
  },
  {
    "code": "M08.79",
    "name": "Vaskulitis bei juveniler Arthritis",
    "synonyms": [
      "Vaskulitis bei juveniler Arthritis"
    ]
  },
  {
    "code": "M08.80",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis an mehreren Lokalisationen",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis an mehreren Lokalisationen",
      "Unklassifizierte idiopathische juvenile Arthritis, mehrere Lokalisationen"
    ]
  },
  {
    "code": "M08.81",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Schulterregion",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Schulterregion",
      "Unklassifizierte idiopathische juvenile Arthritis, Schulterregion"
    ]
  },
  {
    "code": "M08.82",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Oberarm",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Oberarm",
      "Unklassifizierte idiopathische juvenile Arthritis, Oberarm"
    ]
  },
  {
    "code": "M08.83",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Unterarm",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Unterarm",
      "Unklassifizierte idiopathische juvenile Arthritis, Unterarm"
    ]
  },
  {
    "code": "M08.84",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Hand",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Hand",
      "Unklassifizierte idiopathische juvenile Arthritis, Hand"
    ]
  },
  {
    "code": "M08.85",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Beckenregion",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Beckenregion",
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Oberschenkel",
      "Unklassifizierte idiopathische juvenile Arthritis, Beckenregion"
    ]
  },
  {
    "code": "M08.86",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Unterschenkel",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Unterschenkel",
      "Unklassifizierte idiopathische juvenile Arthritis, Unterschenkel"
    ]
  },
  {
    "code": "M08.87",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Fuß",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Fuß",
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Sprunggelenk",
      "Unklassifizierte idiopathische juvenile Arthritis, Fuß"
    ]
  },
  {
    "code": "M08.88",
    "name": "Enthesitis-assoziierte idiopathische juvenile Arthritis, Wirbelsäule",
    "synonyms": [
      "Enthesitis-assoziierte idiopathische juvenile Arthritis, Wirbelsäule",
      "Unklassifizierte idiopathische juvenile Arthritis, Wirbelsäule"
    ]
  },
  {
    "code": "M08.89",
    "name": "Enthesitis-assoziierte Arthritis",
    "synonyms": [
      "Enthesitis-assoziierte Arthritis",
      "Enthesitis-assoziierte idiopathische juvenile Arthritis",
      "Unklassifizierte idiopathische juvenile Arthritis"
    ]
  },
  {
    "code": "M08.90",
    "name": "Juvenile idiopathische Arthritis an mehreren Lokalisationen",
    "synonyms": [
      "Juvenile idiopathische Arthritis an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M08.91",
    "name": "Juvenile idiopathische Arthritis, Schulterregion",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Schulterregion"
    ]
  },
  {
    "code": "M08.92",
    "name": "Juvenile idiopathische Arthritis, Oberarm",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Oberarm"
    ]
  },
  {
    "code": "M08.93",
    "name": "Juvenile idiopathische Arthritis, Unterarm",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Unterarm"
    ]
  },
  {
    "code": "M08.94",
    "name": "Juvenile idiopathische Arthritis, Hand",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Hand"
    ]
  },
  {
    "code": "M08.95",
    "name": "Juvenile idiopathische Arthritis, Beckenregion",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Beckenregion"
    ]
  },
  {
    "code": "M08.96",
    "name": "Juvenile idiopathische Arthritis, Unterschenkel",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Unterschenkel"
    ]
  },
  {
    "code": "M08.97",
    "name": "Juvenile idiopathische Arthritis, Fuß",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Fuß"
    ]
  },
  {
    "code": "M08.98",
    "name": "Juvenile idiopathische Arthritis, Wirbelsäule",
    "synonyms": [
      "Juvenile idiopathische Arthritis, Wirbelsäule"
    ]
  },
  {
    "code": "M08.99",
    "name": "Juvenile Arthritis",
    "synonyms": [
      "Juvenile Arthritis",
      "Juvenile chronische Arthritis",
      "Juvenile idiopathische Arthritis"
    ]
  },
  {
    "code": "M10.09",
    "name": "Idiopathische Gicht",
    "synonyms": [
      "Arthritis urica",
      "Genuine Gicht",
      "Gichtarthritis",
      "Gichtarthropathie",
      "Gichtbursitis",
      "Gichtische Arthritis",
      "Gichtische Arthropathie",
      "Gichtische Gelenkentzündung",
      "Gichtische Synovitis",
      "Gichtknoten",
      "Gichttophus a.n.k.",
      "Harnsäurekonkrement",
      "Harnsäurestein",
      "Idiopathische Gicht",
      "Primäre Gicht",
      "Spondylitis bei Gicht",
      "Synovitis bei Gicht",
      "Tophus arthriticus",
      "Uratstein",
      "Uratverstopfung",
      "Vermehrte Harnsäurekristalle"
    ]
  },
  {
    "code": "M10.19",
    "name": "Bleigicht",
    "synonyms": [
      "Bleigicht"
    ]
  },
  {
    "code": "M10.29",
    "name": "Arzneimittelinduzierte Gicht",
    "synonyms": [
      "Arzneimittelinduzierte Gicht"
    ]
  },
  {
    "code": "M10.39",
    "name": "Gicht durch Nierenfunktionsstörung",
    "synonyms": [
      "Gicht durch Nierenfunktionsstörung"
    ]
  },
  {
    "code": "M10.49",
    "name": "Sekundäre Gicht a.n.k.",
    "synonyms": [
      "Sekundäre Gicht a.n.k."
    ]
  },
  {
    "code": "M10.91",
    "name": "Omagra",
    "synonyms": [
      "Omagra"
    ]
  },
  {
    "code": "M10.96",
    "name": "Gonagra",
    "synonyms": [
      "Gonagra"
    ]
  },
  {
    "code": "M10.97",
    "name": "Podagra",
    "synonyms": [
      "Podagra"
    ]
  },
  {
    "code": "M10.99",
    "name": "Gicht",
    "synonyms": [
      "Chiragra",
      "Diathesis urica",
      "Gicht",
      "Gichtanfall",
      "Gichtdiathese",
      "Harnsäurediathese",
      "Harnsäurestein-Diathese",
      "Uratische Diathese",
      "Urikopathie"
    ]
  },
  {
    "code": "M11.09",
    "name": "Apatit-Rheumatismus",
    "synonyms": [
      "Apatit-Rheumatismus",
      "Arthropathie durch Apatitkristalle",
      "Arthropathie durch Hydroxylapatitkristalle",
      "Hydroxylapatit-Rheumatismus"
    ]
  },
  {
    "code": "M11.10",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, mehrere Lokalisationen",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, mehrere Lokalisationen"
    ]
  },
  {
    "code": "M11.11",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Schultergelenk",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Schultergelenk"
    ]
  },
  {
    "code": "M11.12",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Ellenbogengelenk",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Ellenbogengelenk"
    ]
  },
  {
    "code": "M11.13",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Handgelenk",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Handgelenk"
    ]
  },
  {
    "code": "M11.14",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Hand",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Hand"
    ]
  },
  {
    "code": "M11.15",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Beckenregion",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Beckenregion"
    ]
  },
  {
    "code": "M11.16",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Kniegelenk",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Kniegelenk"
    ]
  },
  {
    "code": "M11.17",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Fuß",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Fuß"
    ]
  },
  {
    "code": "M11.18",
    "name": "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Wirbelsäule",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit, Wirbelsäule"
    ]
  },
  {
    "code": "M11.19",
    "name": "Familiäre Chondrokalzinose",
    "synonyms": [
      "Familiäre CPPD [Kalziumpyrophosphat-Dihydrat]-Ablagerungskrankheit",
      "Familiäre Chondrokalzinose",
      "Familiäre Kalzium-Pyrophosphat-Speicherkrankheit",
      "Kalziumpyrophosphat-Arthropathie"
    ]
  },
  {
    "code": "M11.29",
    "name": "Chondrokalzinose",
    "synonyms": [
      "Chondrocalcinosis - s.a. Chondrokalzinose",
      "Chondrocalcinosis articularis",
      "Chondrokalzinose",
      "Chondrokalzinose-Arthropathie",
      "Pseudogicht"
    ]
  },
  {
    "code": "M11.89",
    "name": "Kristall-Arthropathie durch Kalziumphosphat",
    "synonyms": [
      "Kristall-Arthropathie durch Kalziumphosphat",
      "Kristall-Arthropathie durch Pyrophosphat"
    ]
  },
  {
    "code": "M11.99",
    "name": "Kristall-Arthropathie",
    "synonyms": [
      "Kristall-Arthropathie",
      "Kristallinduzierte Arthritis"
    ]
  },
  {
    "code": "M12.09",
    "name": "Chronische postrheumatische Arthritis [Jaccoud-Arthritis]",
    "synonyms": [
      "Chronische postrheumatische Arthritis [Jaccoud-Arthritis]",
      "Chronische postrheumatische Arthropathie [Jaccoud-Arthropathie]",
      "Jaccoud-Arthritis",
      "Jaccoud-Arthropathie"
    ]
  },
  {
    "code": "M12.19",
    "name": "Kaschin-Beck-Krankheit",
    "synonyms": [
      "Kaschin-Beck-Krankheit",
      "Kaschin-Beck-Syndrom",
      "Osteoarthritis deformans endemica",
      "Osteoarthrosis deformans",
      "Osteochondroarthrosis deformans"
    ]
  },
  {
    "code": "M12.20",
    "name": "Pigmentierte villonoduläre Synovialitis an mehreren Lokalisationen",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M12.21",
    "name": "Pigmentierte villonoduläre Synovialitis in der Schulterregion",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis in der Schulterregion"
    ]
  },
  {
    "code": "M12.22",
    "name": "Pigmentierte villonoduläre Synovialitis am Oberarm",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis am Oberarm"
    ]
  },
  {
    "code": "M12.23",
    "name": "Pigmentierte villonoduläre Synovialitis am Unterarm",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis am Unterarm"
    ]
  },
  {
    "code": "M12.24",
    "name": "Pigmentierte villonoduläre Synovialitis an der Hand",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis an der Hand"
    ]
  },
  {
    "code": "M12.25",
    "name": "Pigmentierte villonoduläre Synovialitis am Oberschenkel",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis am Oberschenkel",
      "Pigmentierte villonoduläre Synovialitis in der Beckenregion"
    ]
  },
  {
    "code": "M12.26",
    "name": "Pigmentierte villonoduläre Synovialitis am Unterschenkel",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis am Kniegelenk",
      "Pigmentierte villonoduläre Synovialitis am Unterschenkel"
    ]
  },
  {
    "code": "M12.27",
    "name": "Pigmentierte villonoduläre Synovialitis am Fuß",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis am Fuß"
    ]
  },
  {
    "code": "M12.28",
    "name": "Pigmentierte villonoduläre Synovialitis an der Wirbelsäule",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis an der Wirbelsäule"
    ]
  },
  {
    "code": "M12.29",
    "name": "Villonoduläre Synovitis",
    "synonyms": [
      "Pigmentierte villonoduläre Synovialitis",
      "Villonoduläre Synovitis"
    ]
  },
  {
    "code": "M12.39",
    "name": "Palindromer Rheumatismus",
    "synonyms": [
      "Hench-Rosenberg-Syndrom",
      "Palindromer Rheumatismus"
    ]
  },
  {
    "code": "M12.40",
    "name": "Intermittierende Hydrarthrose, mehrere Lokalisationen",
    "synonyms": [
      "Intermittierende Hydrarthrose, mehrere Lokalisationen"
    ]
  },
  {
    "code": "M12.42",
    "name": "Intermittierende Hydrarthrose, Ellenbogengelenk",
    "synonyms": [
      "Intermittierende Hydrarthrose, Ellenbogengelenk"
    ]
  },
  {
    "code": "M12.45",
    "name": "Intermittierende Hydrarthrose, Hüftgelenk",
    "synonyms": [
      "Intermittierende Hydrarthrose, Hüftgelenk"
    ]
  },
  {
    "code": "M12.46",
    "name": "Intermittierender Hydrops des Kniegelenks",
    "synonyms": [
      "Intermittierende Hydrarthrose, Kniegelenk",
      "Intermittierender Hydrops des Kniegelenks"
    ]
  },
  {
    "code": "M12.49",
    "name": "Intermittierender Hydrops",
    "synonyms": [
      "Hydrops intermittens articulorum",
      "Intermittierende Hydrarthrose",
      "Intermittierender Hydrops"
    ]
  },
  {
    "code": "M12.59",
    "name": "Traumatische Arthropathie",
    "synonyms": [
      "Chronische traumatische Arthritis",
      "Traumatische Arthropathie"
    ]
  },
  {
    "code": "M12.80",
    "name": "CACP [Kamptodaktylie, Arthropathie, Coxa vara, Perikarditis]-Syndrom",
    "synonyms": [
      "CACP [Kamptodaktylie, Arthropathie, Coxa vara, Perikarditis]-Syndrom"
    ]
  },
  {
    "code": "M12.85",
    "name": "Coxitis fugax",
    "synonyms": [
      "Coxitis fugax"
    ]
  },
  {
    "code": "M12.89",
    "name": "Pneumarthrose",
    "synonyms": [
      "Flüchtige Arthritis",
      "Flüchtige Arthropathie",
      "Pneumarthrose",
      "Transitorische Arthritis",
      "Transitorische Arthropathie",
      "Villöse Arthritis"
    ]
  },
  {
    "code": "M13.0",
    "name": "Akute Polyarthritis",
    "synonyms": [
      "Akute Polyarthritis",
      "Polyarthritis a.n.k.",
      "Polyarthropathie a.n.k.",
      "Polyartikuläre Arthritis"
    ]
  },
  {
    "code": "M13.11",
    "name": "Omarthritis",
    "synonyms": [
      "Omarthritis",
      "Schultergelenkarthritis",
      "Schultergelenkentzündung"
    ]
  },
  {
    "code": "M13.12",
    "name": "Arthritis des Ellenbogengelenks",
    "synonyms": [
      "Arthritis des Ellenbogengelenks"
    ]
  },
  {
    "code": "M13.13",
    "name": "Handgelenkarthritis",
    "synonyms": [
      "Belastungsabhängige Handgelenkarthritis",
      "Handgelenkarthritis"
    ]
  },
  {
    "code": "M13.14",
    "name": "Fingergelenkarthritis",
    "synonyms": [
      "Fingergelenkarthritis"
    ]
  },
  {
    "code": "M13.15",
    "name": "Iliosakralgelenkarthritis",
    "synonyms": [
      "Coxarthritis - s.a. Koxarthritis",
      "Coxitis - s.a. Koxitis",
      "Hüftgelenkarthritis",
      "Iliosakralgelenkarthritis",
      "Koxarthritis",
      "Koxitis",
      "Sakroiliakalgelenkarthritis"
    ]
  },
  {
    "code": "M13.16",
    "name": "Gonarthritis",
    "synonyms": [
      "Gonarthritis",
      "Kniegelenkarthritis",
      "Kniegelenkentzündung"
    ]
  },
  {
    "code": "M13.17",
    "name": "Sprunggelenkarthritis",
    "synonyms": [
      "Arthritis des oberen Sprunggelenks",
      "Belastungsabhängige Sprunggelenkarthritis",
      "Sprunggelenkarthritis"
    ]
  },
  {
    "code": "M13.19",
    "name": "Monarthritis a.n.k.",
    "synonyms": [
      "Monarthritis a.n.k."
    ]
  },
  {
    "code": "M13.89",
    "name": "Allergische Arthritis",
    "synonyms": [
      "Allergische Arthritis",
      "Klimakterische Arthritis a.n.k.",
      "Klimakterische toxische Polyarthritis a.n.k.",
      "Menopausale Arthritis a.n.k.",
      "Primäre progressive Arthritis",
      "Toxische Arthritis der Menopause",
      "Toxische Polyarthritis der Menopause a.n.k."
    ]
  },
  {
    "code": "M13.94",
    "name": "Handarthritis",
    "synonyms": [
      "Handarthritis"
    ]
  },
  {
    "code": "M13.97",
    "name": "Fußarthritis",
    "synonyms": [
      "Fußarthritis"
    ]
  },
  {
    "code": "M13.99",
    "name": "Arthritis",
    "synonyms": [
      "Akute Arthritis",
      "Akute Gelenkentzündung",
      "Arthritis",
      "Arthritis des Beins",
      "Chronische Arthritis",
      "Entzündliche Arthropathie",
      "Gelenkentzündung a.n.k.",
      "Nichteitrige Arthritis a.n.k.",
      "Panarthritis",
      "Subakute Arthritis"
    ]
  },
  {
    "code": "M15.0",
    "name": "Primäre generalisierte Arthrose",
    "synonyms": [
      "Generalisierte primäre Osteoarthrose",
      "Primäre Polyarthrose",
      "Primäre generalisierte Arthrose"
    ]
  },
  {
    "code": "M15.1",
    "name": "Heberden-Knoten mit Arthropathie",
    "synonyms": [
      "Arthrose der distalen Interphalangealgelenke der Finger",
      "Heberden-Arthrose",
      "Heberden-Arthrose der Finger",
      "Heberden-Knoten",
      "Heberden-Knoten mit Arthropathie",
      "Heberden-Krankheit",
      "Heberden-Polyarthrose der Fingergelenke",
      "Heberden-Syndrom"
    ]
  },
  {
    "code": "M15.2",
    "name": "Bouchard-Arthrose der Fingermittelgelenke",
    "synonyms": [
      "Arthrose der proximalen Interphalangealgelenke der Finger",
      "Bouchard-Arthrose",
      "Bouchard-Arthrose der Fingermittelgelenke",
      "Bouchard-Knoten",
      "Bouchard-Knoten mit Arthropathie",
      "Bouchard-Krankheit",
      "Bouchard-Polyarthrose der Fingermittelgelenke",
      "Bouchard-Syndrom"
    ]
  },
  {
    "code": "M15.3",
    "name": "Sekundäre multiple Arthrosen",
    "synonyms": [
      "Posttraumatische Polyarthrose",
      "Sekundäre multiple Arthrosen"
    ]
  },
  {
    "code": "M15.4",
    "name": "Erosive Arthrose",
    "synonyms": [
      "Erosive Arthrose",
      "Erosive Osteoarthrose"
    ]
  },
  {
    "code": "M15.8",
    "name": "Heberden- und Bouchard-Arthrose",
    "synonyms": [
      "Haygarth-Knoten",
      "Heberden- und Bouchard-Arthrose"
    ]
  },
  {
    "code": "M15.9",
    "name": "Fingerpolyarthrose",
    "synonyms": [
      "Arthrose an multiplen Lokalisationen",
      "Arthrose der großen Gelenke",
      "Arthrosis deformans der großen Gelenke",
      "Atrophische Polyarthritis",
      "Fingerpolyarthrose",
      "Generalisierte Arthrose",
      "Generalisierte Osteoarthrose",
      "Genuine Polyarthrose",
      "Panarthrose",
      "Polyarthrose",
      "Polyarthrose der Fingergelenke",
      "Polyarthrose der Hand",
      "Polyartikuläre Arthrose"
    ]
  },
  {
    "code": "M16.0",
    "name": "Beidseitige primäre Koxarthrose",
    "synonyms": [
      "Beidseitige primäre Koxarthrose",
      "Bilaterale primäre Koxarthrose"
    ]
  },
  {
    "code": "M16.1",
    "name": "Einseitige primäre Koxarthrose",
    "synonyms": [
      "Einseitige primäre Koxarthrose",
      "Primäre Koxarthrose"
    ]
  },
  {
    "code": "M16.2",
    "name": "Beidseitige Koxarthrose als Folge einer Dysplasie",
    "synonyms": [
      "Beidseitige Koxarthrose als Folge einer Dysplasie",
      "Bilaterale dysplastische Koxarthrose"
    ]
  },
  {
    "code": "M16.3",
    "name": "Dysplasie-Koxarthrose",
    "synonyms": [
      "Dysplasie-Koxarthrose",
      "Dysplastische Koxarthrose",
      "Einseitige Koxarthrose als Folge einer Dysplasie",
      "Einseitige dysplastische Koxarthrose",
      "Koxarthrose als Folge einer Dysplasie",
      "Unilaterale dysplastische Koxarthrose"
    ]
  },
  {
    "code": "M16.4",
    "name": "Beidseitige posttraumatische Koxarthrose",
    "synonyms": [
      "Beidseitige posttraumatische Koxarthrose",
      "Bilaterale posttraumatische Koxarthrose"
    ]
  },
  {
    "code": "M16.5",
    "name": "Einseitige posttraumatische Koxarthrose",
    "synonyms": [
      "Einseitige posttraumatische Koxarthrose",
      "Posttraumatische Koxarthrose"
    ]
  },
  {
    "code": "M16.6",
    "name": "Beidseitige sekundäre Koxarthrose",
    "synonyms": [
      "Beidseitige sekundäre Koxarthrose",
      "Bilaterale sekundäre Koxarthrose"
    ]
  },
  {
    "code": "M16.7",
    "name": "Protrusionskoxarthrose",
    "synonyms": [
      "Einseitige sekundäre Koxarthrose",
      "Protrusionskoxarthrose",
      "Sekundäre Koxarthrose",
      "Unilaterale sekundäre Koxarthrose a.n.k."
    ]
  },
  {
    "code": "M16.9",
    "name": "Aktivierte Koxarthrose",
    "synonyms": [
      "Aktivierte Koxarthrose",
      "Ankylosierende Koxarthrose",
      "Beidseitige Koxarthrose",
      "Coxarthrosis - s.a. Koxarthrose",
      "Einseitige Koxarthrose",
      "Hüftarthrose",
      "Hüftgelenkarthrose",
      "Initiale Koxarthrose",
      "Koxarthrose",
      "Koxarthrose 1. Grades",
      "Koxarthrose 1. bis 2. Grades",
      "Koxarthrose 2. Grades",
      "Koxarthrose 3. Grades",
      "Leichte Koxarthrose",
      "Malum coxae senile",
      "Präarthrose der Hüfte",
      "Präkoxarthrose",
      "Schwere Koxarthrose"
    ]
  },
  {
    "code": "M17.0",
    "name": "Beidseitige primäre Gonarthrose",
    "synonyms": [
      "Beidseitige primäre Gonarthrose"
    ]
  },
  {
    "code": "M17.1",
    "name": "Primäre Gonarthrose",
    "synonyms": [
      "Einseitige primäre Gonarthrose",
      "Primäre Gonarthrose",
      "Unilaterale primäre Gonarthrose"
    ]
  },
  {
    "code": "M17.2",
    "name": "Beidseitige posttraumatische Gonarthrose",
    "synonyms": [
      "Beidseitige posttraumatische Gonarthrose"
    ]
  },
  {
    "code": "M17.3",
    "name": "Posttraumatische Gonarthrose",
    "synonyms": [
      "Einseitige posttraumatische Gonarthrose",
      "Posttraumatische Gonarthrose",
      "Unilaterale posttraumatische Gonarthrose"
    ]
  },
  {
    "code": "M17.4",
    "name": "Sekundäre bilaterale Gonarthrose",
    "synonyms": [
      "Sekundäre bilaterale Gonarthrose"
    ]
  },
  {
    "code": "M17.5",
    "name": "Sekundäre Gonarthrose a.n.k.",
    "synonyms": [
      "Einseitige sekundäre Gonarthrose",
      "Sekundäre Gonarthrose a.n.k.",
      "Unilaterale sekundäre Gonarthrose"
    ]
  },
  {
    "code": "M17.9",
    "name": "Mediale Gonarthrose",
    "synonyms": [
      "Arthrosis deformans des Knies",
      "Beginnende Pangonarthrose",
      "Beidseitige Gonarthrose",
      "Femoropatellararthrose",
      "Femoropatellare Gonarthrose",
      "Fortbestehende Gonarthrose trotz Operation",
      "Gonarthrose",
      "Gonarthrose 1. Grades",
      "Gonarthrose 2. Grades",
      "Gonarthrose 2.-3. Grades",
      "Gonarthrose 3. Grades",
      "Gonarthrose 4. Grades",
      "Gonarthrose und retropatellare Arthrose",
      "Kniearthrose",
      "Kniegelenkarthrose",
      "Mediale Gonarthrose",
      "Mediale Kniegelenkarthrose",
      "Retropatellararthrose",
      "Retropatellare Arthrose",
      "Valgusgonarthrose",
      "Varusgonarthrose",
      "Varusgonarthrose und Femoropatellararthrose"
    ]
  },
  {
    "code": "M18.0",
    "name": "Primäre beidseitige Rhizarthrose",
    "synonyms": [
      "Primäre beidseitige Rhizarthrose",
      "Primäre bilaterale Rhizarthrose"
    ]
  },
  {
    "code": "M18.1",
    "name": "Unilaterale primäre Rhizarthrose",
    "synonyms": [
      "Einseitige primäre Rhizarthrose",
      "Primäre Rhizarthrose",
      "Unilaterale primäre Rhizarthrose"
    ]
  },
  {
    "code": "M18.2",
    "name": "Beidseitige posttraumatische Rhizarthrose",
    "synonyms": [
      "Beidseitige posttraumatische Rhizarthrose",
      "Bilaterale posttraumatische Rhizarthrose"
    ]
  },
  {
    "code": "M18.3",
    "name": "Unilaterale posttraumatische Rhizarthrose",
    "synonyms": [
      "Einseitige posttraumatische Rhizarthrose",
      "Posttraumatische Rhizarthrose",
      "Unilaterale posttraumatische Rhizarthrose"
    ]
  },
  {
    "code": "M18.4",
    "name": "Sekundäre bilaterale Rhizarthrose",
    "synonyms": [
      "Sekundäre beidseitige Rhizarthrose",
      "Sekundäre bilaterale Rhizarthrose"
    ]
  },
  {
    "code": "M18.5",
    "name": "Sekundäre Rhizarthrose a.n.k.",
    "synonyms": [
      "Einseitige sekundäre Rhizarthrose",
      "Sekundäre Rhizarthrose a.n.k.",
      "Unilaterale sekundäre Rhizarthrose"
    ]
  },
  {
    "code": "M18.9",
    "name": "Rhizarthrose",
    "synonyms": [
      "Arthrose des Karpometakarpalgelenks I",
      "Daumensattelgelenkarthrose",
      "Rhizarthrose"
    ]
  },
  {
    "code": "M19.09",
    "name": "Primäre Arthrose a.n.k.",
    "synonyms": [
      "Primäre Arthrose a.n.k."
    ]
  },
  {
    "code": "M19.19",
    "name": "Posttraumatische Arthrose a.n.k.",
    "synonyms": [
      "Posttraumatische Arthrose a.n.k."
    ]
  },
  {
    "code": "M19.29",
    "name": "Sekundäre Arthrose a.n.k.",
    "synonyms": [
      "Sekundäre Arthrose a.n.k."
    ]
  },
  {
    "code": "M19.89",
    "name": "Aktivierte Arthrose",
    "synonyms": [
      "Aktivierte Arthrose"
    ]
  },
  {
    "code": "M19.91",
    "name": "Omarthrose",
    "synonyms": [
      "Akromioklavikulargelenkarthrose",
      "Omarthrose",
      "Schultereckgelenkarthrose",
      "Schultergelenkarthrose"
    ]
  },
  {
    "code": "M19.92",
    "name": "Ellenbogengelenkarthrose",
    "synonyms": [
      "Ellenbogengelenkarthrose"
    ]
  },
  {
    "code": "M19.93",
    "name": "Handgelenkarthrose",
    "synonyms": [
      "Handgelenkarthrose",
      "Radioulnararthrose"
    ]
  },
  {
    "code": "M19.94",
    "name": "Fingergelenkarthrose",
    "synonyms": [
      "Degenerative Veränderung der Hand",
      "Fingergelenkarthrose",
      "Handwurzelarthrose"
    ]
  },
  {
    "code": "M19.95",
    "name": "Iliosakralgelenkarthrose",
    "synonyms": [
      "Iliosakralgelenkarthrose",
      "Sakroiliakalgelenkarthrose"
    ]
  },
  {
    "code": "M19.97",
    "name": "Mittelfußarthrose",
    "synonyms": [
      "Arthrose des oberen Sprunggelenks",
      "Chopart-Gelenk-Arthrose",
      "Fußarthrose",
      "Fußwurzelarthrose",
      "Großzehengrundgelenkarthrose",
      "Mittelfußarthrose",
      "Präarthrose des oberen Sprunggelenks",
      "Sprunggelenkarthrose"
    ]
  },
  {
    "code": "M19.98",
    "name": "Ankylosierende Arthrose",
    "synonyms": [
      "Ankylosierende Arthrose"
    ]
  },
  {
    "code": "M19.99",
    "name": "Osteoarthropathie",
    "synonyms": [
      "Arthritis deformans",
      "Arthropathia deformans",
      "Arthrose",
      "Arthrosis",
      "Arthrosis deformans",
      "Atrophische Arthritis",
      "Degenerative Arthropathie",
      "Degenerative Gelenkerkrankung",
      "Degenerative Gelenkkrankheit",
      "Degenerative Gelenkveränderung",
      "Degenerative Osteoarthrose",
      "Gelenkdegeneration",
      "Hypertrophische Arthritis",
      "Hypertrophische Arthropathie",
      "Hypertrophische Arthrose",
      "Hypertrophische Osteoarthropathie",
      "Hypertrophische Osteoarthrose",
      "Lokalisierte Arthrose",
      "Lokalisierte Osteoarthrose",
      "Osteoarthritis",
      "Osteoarthropathie",
      "Osteoarthrose",
      "Osteoarthrosis",
      "Senile Arthritis"
    ]
  },
  {
    "code": "M20.0",
    "name": "Digitus superductus der Hand",
    "synonyms": [
      "Digitus superductus der Hand",
      "Drop finger",
      "Erworbene Daumendeformität",
      "Erworbene Fingerdeformität",
      "Erworbener Hammerfinger",
      "Erworbener reitender Finger",
      "Fallfinger",
      "Fingerkontraktur a.n.k.",
      "Fingerretraktion",
      "Hammerfinger",
      "Knopflochdeformität",
      "Schwanenhalsdeformität"
    ]
  },
  {
    "code": "M20.1",
    "name": "Erworbener Hallux valgus",
    "synonyms": [
      "Erworbener Hallux valgus",
      "Fußballenentzündung",
      "Hallux valgus"
    ]
  },
  {
    "code": "M20.2",
    "name": "Hallux rigidus",
    "synonyms": [
      "Hallux rigidus"
    ]
  },
  {
    "code": "M20.3",
    "name": "Hallux valgus et rigidus",
    "synonyms": [
      "Erworbene Großzehendeformität a.n.k.",
      "Erworbener Hallux malleus a.n.k.",
      "Erworbener Hallux varus",
      "Hallux malleus",
      "Hallux valgus et rigidus",
      "Hallux varus"
    ]
  },
  {
    "code": "M20.4",
    "name": "Hammerzehe",
    "synonyms": [
      "Digitus malleus",
      "Erworbene Hammerzehe a.n.k.",
      "Hammerzehe"
    ]
  },
  {
    "code": "M20.5",
    "name": "Digitus superductus des Fußes",
    "synonyms": [
      "Digitus superductus des Fußes",
      "Drop toe",
      "Erworbene Klauenzehe",
      "Erworbene Krallenzehe",
      "Erworbene Zehenhypertrophie",
      "Erworbene reitende Zehe",
      "Fallzehe",
      "Taubengang",
      "Zehenkontraktur"
    ]
  },
  {
    "code": "M20.6",
    "name": "Zehenfehlstellung",
    "synonyms": [
      "Erworbene Zehenverformung",
      "Zehendeformität a.n.k.",
      "Zehenfehlstellung"
    ]
  },
  {
    "code": "M21.02",
    "name": "Cubitus valgus",
    "synonyms": [
      "Cubitus valgus"
    ]
  },
  {
    "code": "M21.05",
    "name": "Coxa valga",
    "synonyms": [
      "Coxa valga",
      "Coxa valga antetorta"
    ]
  },
  {
    "code": "M21.06",
    "name": "X-Bein-Stellung",
    "synonyms": [
      "Erworbene X-Bein-Stellung",
      "Genu valgum",
      "X-Bein-Stellung"
    ]
  },
  {
    "code": "M21.07",
    "name": "Fußeversion a.n.k.",
    "synonyms": [
      "Erworbener Knickfuß",
      "Erworbener Pes valgus",
      "Fußeversion a.n.k.",
      "Valgusdeformität des Fußes a.n.k."
    ]
  },
  {
    "code": "M21.09",
    "name": "Valgusdeformität",
    "synonyms": [
      "Valgusdeformität"
    ]
  },
  {
    "code": "M21.12",
    "name": "Cubitus varus",
    "synonyms": [
      "Cubitus varus"
    ]
  },
  {
    "code": "M21.15",
    "name": "Coxa vara",
    "synonyms": [
      "Coxa vara"
    ]
  },
  {
    "code": "M21.16",
    "name": "Varusstellung des Kniegelenks",
    "synonyms": [
      "Erworbene O-Beinstellung",
      "Genu varum",
      "O-Beinstellung",
      "Varusstellung des Kniegelenks"
    ]
  },
  {
    "code": "M21.17",
    "name": "Varusdeformität des Fußes a.n.k.",
    "synonyms": [
      "Erworbener Pes varus",
      "Varusdeformität des Fußes a.n.k."
    ]
  },
  {
    "code": "M21.19",
    "name": "Varusdeformität",
    "synonyms": [
      "Varusdeformität"
    ]
  },
  {
    "code": "M21.25",
    "name": "Erworbene Flexionsdeformität des Oberschenkels",
    "synonyms": [
      "Erworbene Flexionsdeformität der Hüfte",
      "Erworbene Flexionsdeformität des Oberschenkels"
    ]
  },
  {
    "code": "M21.29",
    "name": "Flexionsdeformität",
    "synonyms": [
      "Flexionsdeformität"
    ]
  },
  {
    "code": "M21.33",
    "name": "Fallhand",
    "synonyms": [
      "Fallhand"
    ]
  },
  {
    "code": "M21.37",
    "name": "Hängefuß",
    "synonyms": [
      "Fallfuß",
      "Hängefuß"
    ]
  },
  {
    "code": "M21.4",
    "name": "Erworbener Plattfuß",
    "synonyms": [
      "Einbruch des Fußgewölbes",
      "Erworbene Fußabflachung",
      "Erworbener Plattfuß",
      "Erworbener Senkfuß",
      "Fixierter Senkfuß",
      "Lagebedingter Senkfuß",
      "Pes planus",
      "Plattfuß",
      "Relaxation des Fußgewölbes",
      "Schmerzhafter Senkfuß",
      "Senkfuß"
    ]
  },
  {
    "code": "M21.54",
    "name": "Klauenhand",
    "synonyms": [
      "Erworbene Klauenhand",
      "Erworbene Klumphand",
      "Erworbene Krallenhand",
      "Klauenhand",
      "Krallenhand"
    ]
  },
  {
    "code": "M21.57",
    "name": "Erworbener Klauenhohlfuß",
    "synonyms": [
      "Erworbener Equinovarus",
      "Erworbener Klauenfuß",
      "Erworbener Klauenhohlfuß",
      "Erworbener Klumpfuß",
      "Erworbener Pes equinovarus",
      "Erworbener Spitzklumpfuß",
      "Paralytischer Klumpfuß"
    ]
  },
  {
    "code": "M21.60",
    "name": "Erworbener Hohlfuß",
    "synonyms": [
      "Erworbener Hohlfuß",
      "Erworbener Pes cavus",
      "Erworbener Pes excavatus"
    ]
  },
  {
    "code": "M21.61",
    "name": "Erworbener Knick-Senkfuß",
    "synonyms": [
      "Erworbener Knick-Plattfuß",
      "Erworbener Knick-Senkfuß",
      "Erworbener Pes planovalgus",
      "Erworbener Senk-Knickfuß"
    ]
  },
  {
    "code": "M21.62",
    "name": "Erworbene Spitzfußstellung",
    "synonyms": [
      "Erworbene Spitzfußstellung",
      "Erworbener Pes equinus",
      "Erworbener Spitzfuß"
    ]
  },
  {
    "code": "M21.63",
    "name": "Erworbener Spreizfuß",
    "synonyms": [
      "Erworbener Knick-Hohl-Spreizfuß",
      "Erworbener Knick-Platt-Spreizfuß",
      "Erworbener Knick-Spreizfuß",
      "Erworbener Pes transversus",
      "Erworbener Senk-Knick-Spreizfuß",
      "Erworbener Senk-Spreizfuß",
      "Erworbener Spreizfuß"
    ]
  },
  {
    "code": "M21.68",
    "name": "Fußdeformität",
    "synonyms": [
      "Erworbene Fersendeformität",
      "Erworbene Fußverformung",
      "Erworbene Knöcheldeformität a.n.k.",
      "Erworbene Mittelfußdeformität",
      "Erworbene Mittelfußverkürzung",
      "Erworbene Sprunggelenkdeformität a.n.k.",
      "Erworbener Hackenfuß",
      "Erworbener Pes adductus",
      "Erworbener Pes calcaneus",
      "Fußdeformität",
      "Fußpronation",
      "Knöchelpronation",
      "Vorfußdeformität"
    ]
  },
  {
    "code": "M21.73",
    "name": "Erworbene Radiusverkürzung",
    "synonyms": [
      "Erworbene Radiusverkürzung"
    ]
  },
  {
    "code": "M21.75",
    "name": "Erworbene Femurverkürzung",
    "synonyms": [
      "Erworbene Femurverkürzung",
      "Erworbene Hüftverkürzung",
      "Erworbene Oberschenkelverkürzung"
    ]
  },
  {
    "code": "M21.79",
    "name": "Erworbene Beinlängendifferenz",
    "synonyms": [
      "Beckenschiefstand bei Beinverkürzung",
      "Beinlängendifferenz",
      "Beinverkürzung",
      "Beinverkürzung egalisiert durch Beckenasymmetrie",
      "Beinverlängerung",
      "Erworbene Armverkürzung",
      "Erworbene Beinlängendifferenz",
      "Erworbene Beinverkürzung",
      "Erworbene Ungleichmäßigkeit der Beine",
      "Extremitätenverkürzung",
      "Ungleichmäßigkeit der Beine",
      "Ungleichmäßigkeit der Beinlänge",
      "Unterschiedliche Extremitätenlänge"
    ]
  },
  {
    "code": "M21.81",
    "name": "Erworbene Klavikuladeformität",
    "synonyms": [
      "Erworbene Klavikuladeformität",
      "Erworbene Schulterblattdeformität",
      "Erworbene Skapuladeformität"
    ]
  },
  {
    "code": "M21.82",
    "name": "Humeruskopfschiefstand",
    "synonyms": [
      "Erworbene Humerusdeformität",
      "Humeruskopfschiefstand"
    ]
  },
  {
    "code": "M21.83",
    "name": "Radiusdeflexion",
    "synonyms": [
      "Radiusdeflexion",
      "Radiusverbiegung",
      "Ulnare Deviation",
      "Unterarmverbiegung"
    ]
  },
  {
    "code": "M21.84",
    "name": "Erworbene Handgelenkverkrümmung",
    "synonyms": [
      "Erworbene Handgelenkverkrümmung",
      "Intrinsische Minus-Deformität der Hand",
      "Intrinsische Plus-Deformität der Hand"
    ]
  },
  {
    "code": "M21.85",
    "name": "Coxa antetorta",
    "synonyms": [
      "Coxa antetorta",
      "Erworbene Femurverkrümmung",
      "Erworbene Rotationsdeformität der Hüfte",
      "Femurverbiegung"
    ]
  },
  {
    "code": "M21.86",
    "name": "Genu recurvatum",
    "synonyms": [
      "Erworbene Tibiadeformität",
      "Erworbene Tibiaverkrümmung",
      "Fibulaverbiegung",
      "Genu recurvatum",
      "Tibiatorsion",
      "Tibiaverbiegung"
    ]
  },
  {
    "code": "M21.89",
    "name": "Erworbene Rotationsdeformität eines Gelenks",
    "synonyms": [
      "Erworbene Rotationsdeformität eines Gelenks"
    ]
  },
  {
    "code": "M21.91",
    "name": "Erworbene Schulterdeformität",
    "synonyms": [
      "Erworbene Schulterdeformität"
    ]
  },
  {
    "code": "M21.92",
    "name": "Erworbene Deformität des Ellenbogengelenks",
    "synonyms": [
      "Erworbene Deformität des Ellenbogengelenks"
    ]
  },
  {
    "code": "M21.93",
    "name": "Erworbene Radiusdeformität",
    "synonyms": [
      "Erworbene Radiusdeformität",
      "Erworbene Ulnadeformität",
      "Erworbene Unterarmdeformität"
    ]
  },
  {
    "code": "M21.94",
    "name": "Erworbene Mittelhanddeformität",
    "synonyms": [
      "Erworbene Mittelhanddeformität"
    ]
  },
  {
    "code": "M21.95",
    "name": "Erworbene Oberschenkeldeformität",
    "synonyms": [
      "Erworbene Oberschenkeldeformität"
    ]
  },
  {
    "code": "M21.96",
    "name": "Erworbene Unterschenkeldeformität",
    "synonyms": [
      "Erworbene Unterschenkeldeformität"
    ]
  },
  {
    "code": "M21.99",
    "name": "Erworbene Extremitätendeformität",
    "synonyms": [
      "Erworbene Armdeformität",
      "Erworbene Beindeformität",
      "Erworbene Deformität der Gliedmaßen",
      "Erworbene Extremitätendeformität",
      "Erworbene Gelenkdeformität a.n.k."
    ]
  },
  {
    "code": "M22.0",
    "name": "Habituelle Patellaluxation",
    "synonyms": [
      "Habituelle Patelladislokation",
      "Habituelle Patellaluxation"
    ]
  },
  {
    "code": "M22.1",
    "name": "Habituelle Patellasubluxation",
    "synonyms": [
      "Habituelle Patellasubluxation"
    ]
  },
  {
    "code": "M22.2",
    "name": "Krankheit des Patellofemoralbereiches",
    "synonyms": [
      "Femoropatellares Kompressionssyndrom",
      "Femoropatellares Schmerzsyndrom",
      "Krankheit des Patellofemoralbereiches",
      "Störung im Patellofemoralbereich"
    ]
  },
  {
    "code": "M22.3",
    "name": "Slipping patella",
    "synonyms": [
      "Patellagleiten",
      "Patellaschädigung a.n.k.",
      "Slipping patella"
    ]
  },
  {
    "code": "M22.4",
    "name": "Chondromalacia patellae",
    "synonyms": [
      "Chondromalacia patellae",
      "Chondromalazie 2. Grades des Knies",
      "Chondropathia patellae",
      "Familiäre Chondromalacia patellae",
      "Patellachondropathie",
      "Retropatellare Chondromalazie"
    ]
  },
  {
    "code": "M22.8",
    "name": "Erworbene Patelladeformität",
    "synonyms": [
      "Erworbene Patelladeformität"
    ]
  },
  {
    "code": "M22.9",
    "name": "Krankheit der Kniescheibe",
    "synonyms": [
      "Krankheit der Kniescheibe",
      "Patellaaffektion",
      "Patellakrankheit",
      "Patellastörung"
    ]
  },
  {
    "code": "M23.09",
    "name": "Meniskuszyste",
    "synonyms": [
      "Meniskusganglion",
      "Meniskuszyste"
    ]
  },
  {
    "code": "M23.19",
    "name": "Scheibenmeniskus",
    "synonyms": [
      "Kongenitaler Scheibenmeniskus",
      "Scheibenmeniskus"
    ]
  },
  {
    "code": "M23.29",
    "name": "Meniskusschädigung durch alten Riss",
    "synonyms": [
      "Alte Meniskusdistorsion",
      "Alte Meniskuslazeration",
      "Alte Meniskusruptur",
      "Alter Meniskuskorbhenkelriss",
      "Alter Meniskusschaden",
      "Meniskusablation durch alte Verletzung",
      "Meniskusablation durch alten Riss",
      "Meniskusschädigung durch alte Verletzung",
      "Meniskusschädigung durch alten Riss"
    ]
  },
  {
    "code": "M23.30",
    "name": "Innen- und Außenmeniskusläsion",
    "synonyms": [
      "Innen- und Außenmeniskusläsion"
    ]
  },
  {
    "code": "M23.31",
    "name": "Innenmeniskusvorderhornläsion",
    "synonyms": [
      "Innenmeniskusvorderhornläsion"
    ]
  },
  {
    "code": "M23.32",
    "name": "Innenmeniskushinterhornläsion",
    "synonyms": [
      "Innenmeniskushinterhornläsion"
    ]
  },
  {
    "code": "M23.33",
    "name": "Innenmeniskopathie",
    "synonyms": [
      "Degenerative Innenmeniskusläsion",
      "Innenmeniskopathie",
      "Innenmeniskusläsion",
      "Innenmeniskusreizung",
      "Innenmeniskusschaden",
      "Mediale Meniskopathie",
      "Mediale Meniskusläsion",
      "Mediale Meniskusreizung",
      "Schädigung des Meniscus medialis"
    ]
  },
  {
    "code": "M23.36",
    "name": "Schädigung des Meniscus lateralis",
    "synonyms": [
      "Außenmeniskusauffaserung",
      "Außenmeniskusläsion",
      "Außenmeniskusläsion des Kniegelenks",
      "Außenmeniskusschaden",
      "Degenerative Außenmeniskusläsion",
      "Schädigung des Meniscus lateralis"
    ]
  },
  {
    "code": "M23.39",
    "name": "Meniskushypermobilität",
    "synonyms": [
      "Degenerative Meniskopathie",
      "Degenerierter Meniskus",
      "Gelenkknorpeldegeneration im Kniegelenk",
      "Meniskopathie",
      "Meniskusablation",
      "Meniskusdegeneration",
      "Meniskushypermobilität",
      "Meniskusläsion",
      "Meniskusretention",
      "Meniskusschaden",
      "Meniskusschaden des Knies",
      "Meniskusüberrest des Knies",
      "Retinierter Meniskus",
      "Rezidivierender Meniskusschaden",
      "Rezidivierender Schaden des Meniskusknorpels am Knie"
    ]
  },
  {
    "code": "M23.4",
    "name": "Freier Gelenkkörper des Kniegelenks",
    "synonyms": [
      "Arthrolith des Knies",
      "Corpus liberum des Knies",
      "Freier Gelenkkörper des Kniegelenks",
      "Gelenkmaus des Knies",
      "Reiskörperchen des Knies"
    ]
  },
  {
    "code": "M23.51",
    "name": "Alte Ruptur des vorderen Kreuzbands am Kniegelenk",
    "synonyms": [
      "Alte Ruptur des vorderen Kreuzbands am Kniegelenk"
    ]
  },
  {
    "code": "M23.59",
    "name": "Chronische Instabilität des Kniegelenks",
    "synonyms": [
      "Alte Kniegelenkbandruptur",
      "Alter Riss eines Ligamentums am Knie",
      "Chronische Instabilität des Kniegelenks"
    ]
  },
  {
    "code": "M23.69",
    "name": "Spontaner Riss eines Ligamentums am Knie",
    "synonyms": [
      "Spontaner Riss eines Ligamentums am Knie"
    ]
  },
  {
    "code": "M23.81",
    "name": "Vordere Kreuzbandinsuffizienz",
    "synonyms": [
      "Vordere Kreuzbandinsuffizienz"
    ]
  },
  {
    "code": "M23.83",
    "name": "Innenbandinsuffizienz des Kniegelenks",
    "synonyms": [
      "Entzündung des tibialen Seitenbandes am Kniegelenk",
      "Innenbandinsuffizienz des Kniegelenks",
      "Kalzifikation des Ligamentum collaterale tibiale",
      "Kalzifikation eines Bandes des Knies"
    ]
  },
  {
    "code": "M23.84",
    "name": "Entzündung des fibularen Seitenbandes am Kniegelenk",
    "synonyms": [
      "Entzündung des fibularen Seitenbandes am Kniegelenk"
    ]
  },
  {
    "code": "M23.89",
    "name": "Retropatellarpathie",
    "synonyms": [
      "Alte Kniedislokation",
      "Alte Kniegelenkluxation",
      "Bänderschwäche des Knies",
      "Chondropathie des Knies",
      "Intraligamentäre Kniezyste",
      "Knarrendes Knie",
      "Kniegelenkadhäsion",
      "Kniegelenkblockade",
      "Kniegelenkdestruktion",
      "Krepitation im Kniegelenk",
      "Kreuzbandelongation",
      "Kreuzbandläsion",
      "Meniskuskalzifikation",
      "Retropatellarpathie",
      "Schnappendes Knie",
      "Schnellendes Knie"
    ]
  },
  {
    "code": "M23.99",
    "name": "Reizknie",
    "synonyms": [
      "Binnenschädigung des Kniegelenks",
      "Binnenverletzung des Kniegelenks",
      "Dérangement interne",
      "Innere Kniegelenkschädigung",
      "Kapselreizung des Kniegelenks",
      "Kniebinnenschaden",
      "Kniegelenkschädigung",
      "Knieschädigung a.n.k.",
      "Knorpelschaden des Kniegelenks",
      "Meniskusstörung a.n.k.",
      "Reizknie",
      "Reizzustand des Kniegelenks",
      "Rezidivierende Binnenschädigung des Kniegelenks",
      "Rezidivierende Knieschädigung"
    ]
  },
  {
    "code": "M24.09",
    "name": "Arthrolith",
    "synonyms": [
      "Arthrolith",
      "Corpus liberum",
      "Freier Gelenkkörper",
      "Freier Knorpel eines Gelenks",
      "Gelenkmaus",
      "Reichel-Jones-Henderson-Syndrom",
      "Reichel-Krankheit",
      "Reiskörperchen",
      "Reiskörperchen eines Gelenks"
    ]
  },
  {
    "code": "M24.11",
    "name": "Gelenkknorpeldegeneration im Schultergelenk a.n.k.",
    "synonyms": [
      "Alte Meniskusruptur an der Schulter",
      "Gelenkknorpeldegeneration im Schultergelenk a.n.k."
    ]
  },
  {
    "code": "M24.12",
    "name": "Gelenkknorpeldegeneration im Ellenbogengelenk a.n.k.",
    "synonyms": [
      "Alte Meniskusruptur am Ellenbogen",
      "Gelenkknorpeldegeneration im Ellenbogengelenk a.n.k."
    ]
  },
  {
    "code": "M24.17",
    "name": "Knorpelschaden des Sprunggelenks",
    "synonyms": [
      "Knorpelschaden des Sprunggelenks"
    ]
  },
  {
    "code": "M24.19",
    "name": "Gelenkknorpelaffektion",
    "synonyms": [
      "Alter Gelenkknorpelriss",
      "Gelenkknorpelaffektion",
      "Gelenkknorpeldegeneration a.n.k.",
      "Gelenkknorpelerkrankung",
      "Gelenkknorpelschaden a.n.k.",
      "Gelenkknorpelschädigung",
      "Gelenkknorpelstörung",
      "Rezidivierender Gelenkknorpelschaden"
    ]
  },
  {
    "code": "M24.25",
    "name": "Ligamentose des Iliolumbalbandes",
    "synonyms": [
      "Bänderschwäche der Beckenregion",
      "Ligamentose des Iliolumbalbandes"
    ]
  },
  {
    "code": "M24.27",
    "name": "Ligamentose der Fußwurzel",
    "synonyms": [
      "Ligamentose der Fußwurzel"
    ]
  },
  {
    "code": "M24.29",
    "name": "Krankheit eines Gelenkbandes",
    "synonyms": [
      "Bandhypertrophie",
      "Bandkalzifikation",
      "Bandkontraktur",
      "Bandstörung",
      "Bänderschwäche",
      "Erworbene Bänderdeformität",
      "Erworbene Deformität eines Ligaments",
      "Instabilität nach einer alten Bandverletzung",
      "Intraligamentäre Zyste",
      "Krankheit eines Gelenkbandes"
    ]
  },
  {
    "code": "M24.36",
    "name": "Pathologische Kniedislokation",
    "synonyms": [
      "Pathologische Kniedislokation"
    ]
  },
  {
    "code": "M24.39",
    "name": "Spontane Dislokation",
    "synonyms": [
      "Pathologische Dislokation a.n.k.",
      "Pathologische Subluxation",
      "Spontane Dislokation"
    ]
  },
  {
    "code": "M24.41",
    "name": "Habituelle Schulterluxation",
    "synonyms": [
      "Chronische Schultergelenkdislokation",
      "Habituelle Schulterdislokation",
      "Habituelle Schultergelenkdislokation",
      "Habituelle Schulterluxation"
    ]
  },
  {
    "code": "M24.42",
    "name": "Habituelle Ellenbogendislokation",
    "synonyms": [
      "Habituelle Ellenbogendislokation",
      "Habituelle Ellenbogenluxation"
    ]
  },
  {
    "code": "M24.45",
    "name": "Habituelle Hüftdislokation",
    "synonyms": [
      "Habituelle Hüftdislokation",
      "Habituelle Hüftgelenkluxation"
    ]
  },
  {
    "code": "M24.46",
    "name": "Habituelle Kniedislokation",
    "synonyms": [
      "Habituelle Kniedislokation",
      "Habituelle Kniegelenkluxation"
    ]
  },
  {
    "code": "M24.49",
    "name": "Habituelle Gelenkluxation",
    "synonyms": [
      "Habituelle Dislokation",
      "Habituelle Gelenkluxation"
    ]
  },
  {
    "code": "M24.54",
    "name": "Fingergelenkkontraktur",
    "synonyms": [
      "Fingergelenkkontraktur"
    ]
  },
  {
    "code": "M24.55",
    "name": "Hüftkontraktur",
    "synonyms": [
      "Beugekontraktur des Hüftgelenks",
      "Hüftkontraktur"
    ]
  },
  {
    "code": "M24.56",
    "name": "Beugekontraktur des Kniegelenks",
    "synonyms": [
      "Beugekontraktur des Kniegelenks"
    ]
  },
  {
    "code": "M24.59",
    "name": "Gelenkkontraktur",
    "synonyms": [
      "Adduktorenkontraktur",
      "Flexionskontraktur eines Gelenks",
      "Gelenkkontraktur",
      "Paralytische Gelenkkontraktur",
      "Sehnenverkürzung mit Gelenkkontraktur"
    ]
  },
  {
    "code": "M24.60",
    "name": "Ankylose mehrere Gelenke",
    "synonyms": [
      "Ankylose mehrere Gelenke"
    ]
  },
  {
    "code": "M24.61",
    "name": "Schulterankylose",
    "synonyms": [
      "Schulterankylose"
    ]
  },
  {
    "code": "M24.62",
    "name": "Ellenbogenankylose",
    "synonyms": [
      "Ellenbogenankylose"
    ]
  },
  {
    "code": "M24.63",
    "name": "Handgelenkankylose",
    "synonyms": [
      "Handgelenkankylose"
    ]
  },
  {
    "code": "M24.64",
    "name": "Fingerankylose",
    "synonyms": [
      "Ankylose der Hand",
      "Fingerankylose"
    ]
  },
  {
    "code": "M24.65",
    "name": "Hüftgelenkversteifung",
    "synonyms": [
      "Hüftankylose",
      "Hüftgelenkversteifung"
    ]
  },
  {
    "code": "M24.66",
    "name": "Knieankylose",
    "synonyms": [
      "Knieankylose",
      "Kniegelenkankylose"
    ]
  },
  {
    "code": "M24.67",
    "name": "Fußgelenkankylose",
    "synonyms": [
      "Fußgelenkankylose",
      "Sprunggelenkankylose"
    ]
  },
  {
    "code": "M24.69",
    "name": "Ankylose",
    "synonyms": [
      "Ankylose",
      "Ankylose des Arms",
      "Ankylose nach chirurgischen Maßnahmen",
      "Ankylosis",
      "Arthrofibrose",
      "Chirurgische Ankylose",
      "Erworbene Gelenkfusion",
      "Fibröse Ankylose",
      "Gelenkankylose",
      "Knöcherne Ankylose",
      "Knöcherne Gelenkblockade"
    ]
  },
  {
    "code": "M24.7",
    "name": "Protrusio acetabuli",
    "synonyms": [
      "Arthrokatadysis",
      "Otto-Becken [Protrusio acetabuli]",
      "Otto-Chrobak-Becken [Protrusio acetabuli]",
      "Protrusio acetabuli"
    ]
  },
  {
    "code": "M24.81",
    "name": "Kapselreizung des Schultergelenks",
    "synonyms": [
      "Kapselreizung des Schultergelenks"
    ]
  },
  {
    "code": "M24.83",
    "name": "Reizzustand des Handgelenks",
    "synonyms": [
      "Reizzustand des Handgelenks"
    ]
  },
  {
    "code": "M24.85",
    "name": "Flaches Azetabulum",
    "synonyms": [
      "Coxa saltans",
      "Erworbene Hüftinstabilität",
      "Femoro-azetabuläres Impingement",
      "Flaches Azetabulum",
      "Schnellende Hüfte"
    ]
  },
  {
    "code": "M24.87",
    "name": "Reizzustand des oberen Sprunggelenks",
    "synonyms": [
      "Impingementsyndrom des oberen Sprunggelenks",
      "Kapselreizung des oberen Sprunggelenks",
      "Reizzustand des Sprunggelenks",
      "Reizzustand des oberen Sprunggelenks"
    ]
  },
  {
    "code": "M24.89",
    "name": "Reizzustand eines Gelenks",
    "synonyms": [
      "Alte Dislokation",
      "Alte Luxation",
      "Alte Subluxation",
      "Blockade eines Gelenks",
      "Gelenkadhäsion",
      "Gelenkdestruktion",
      "Knarrendes Gelenk",
      "Krepitation im Gelenk",
      "Reizzustand eines Gelenks"
    ]
  },
  {
    "code": "M24.91",
    "name": "Binnenschädigung des Schultergelenks",
    "synonyms": [
      "Binnenschädigung des Schultergelenks"
    ]
  },
  {
    "code": "M24.92",
    "name": "Schädigung des inneren Ellenbogens",
    "synonyms": [
      "Binnenschädigung des Ellenbogengelenks",
      "Rezidivierende Binnenschädigung des Ellenbogens",
      "Rezidivierende Ellenbogenschädigung",
      "Schädigung des inneren Ellenbogens"
    ]
  },
  {
    "code": "M24.99",
    "name": "Gelenkschädigung",
    "synonyms": [
      "Binnenschaden eines Gelenks",
      "Gelenkschädigung",
      "Rezidivierende Binnenschädigung eines Gelenks"
    ]
  },
  {
    "code": "M25.06",
    "name": "Nichttraumatische Hämorrhagie des Kniegelenks",
    "synonyms": [
      "Nichttraumatische Blutung des Kniegelenks",
      "Nichttraumatische Hämorrhagie des Kniegelenks",
      "Nichttraumatisches Hämarthros des Kniegelenks"
    ]
  },
  {
    "code": "M25.09",
    "name": "Hämarthros",
    "synonyms": [
      "Blutiger Gelenkerguss",
      "Gelenkblutung",
      "Hämarthros",
      "Nichttraumatische Gelenkhämorrhagie",
      "Nichttraumatischer Hämarthros"
    ]
  },
  {
    "code": "M25.19",
    "name": "Gelenkfistel",
    "synonyms": [
      "Gelenkfistel"
    ]
  },
  {
    "code": "M25.29",
    "name": "Schlottergelenk",
    "synonyms": [
      "Paralytische Gelenkrelaxation",
      "Paralytisches Schlottergelenk",
      "Schlottergelenk"
    ]
  },
  {
    "code": "M25.31",
    "name": "Skapulahypermobilität",
    "synonyms": [
      "Schulterinstabilität",
      "Skapulahypermobilität"
    ]
  },
  {
    "code": "M25.35",
    "name": "Iliosakralgelenkinstabilität",
    "synonyms": [
      "Iliosakralgelenkinstabilität",
      "Sakroiliakalgelenkinstabilität"
    ]
  },
  {
    "code": "M25.37",
    "name": "Chronische Sprunggelenkinstabilität",
    "synonyms": [
      "Chronische Sprunggelenkinstabilität"
    ]
  },
  {
    "code": "M25.39",
    "name": "Posttraumatische Gelenkinstabilität",
    "synonyms": [
      "Gelenkinstabilität",
      "Posttraumatische Gelenkinstabilität"
    ]
  },
  {
    "code": "M25.46",
    "name": "Reizerguss des Knies",
    "synonyms": [
      "Erguss des Knies",
      "Hydrops genus",
      "Kniegelenkerguss",
      "Kniegelenkschwellung",
      "Reizerguss des Kniegelenks",
      "Reizerguss des Knies"
    ]
  },
  {
    "code": "M25.47",
    "name": "Erguss des oberen Sprunggelenks",
    "synonyms": [
      "Erguss des oberen Sprunggelenks",
      "Knöchelschwellung",
      "Schwellung des Fußgelenks"
    ]
  },
  {
    "code": "M25.49",
    "name": "Gelenkerguss",
    "synonyms": [
      "Flüssigkeit im Gelenk",
      "Gelenkerguss",
      "Gelenkhydrops",
      "Gelenkschwellung",
      "Gelenködem",
      "Hydarthrose",
      "Hydrarthrose",
      "Monarthropathie mit Erguss",
      "Reizerguss im Gelenk",
      "Wasseransammlung im Gelenk"
    ]
  },
  {
    "code": "M25.50",
    "name": "Polyarthralgie",
    "synonyms": [
      "Polyarthralgie"
    ]
  },
  {
    "code": "M25.51",
    "name": "Schulterschmerzen",
    "synonyms": [
      "Schultergelenkschmerzen",
      "Schulterschmerzen"
    ]
  },
  {
    "code": "M25.53",
    "name": "Handgelenkarthralgie",
    "synonyms": [
      "Handgelenkarthralgie",
      "Handgelenkschmerzen"
    ]
  },
  {
    "code": "M25.54",
    "name": "Metakarpophalangeale Schmerzen",
    "synonyms": [
      "Metakarpophalangeale Schmerzen"
    ]
  },
  {
    "code": "M25.55",
    "name": "Koxalgie",
    "synonyms": [
      "Coxalgia - s.a. Koxalgie",
      "Dysfunktion der Symphysis pubica",
      "Hüftgelenkschmerzen",
      "Koxalgie",
      "Nichttuberkulöse Koxalgie"
    ]
  },
  {
    "code": "M25.56",
    "name": "Kniegelenkschmerzen",
    "synonyms": [
      "Akute Gonalgie",
      "Arthralgie des Kniegelenks",
      "Gonalgie",
      "Kniegelenkschmerzen",
      "Knieschmerzen",
      "Nichttraumatische Kniegelenkschmerzen"
    ]
  },
  {
    "code": "M25.57",
    "name": "Sprunggelenkarthralgie",
    "synonyms": [
      "Metatarsophalangeale Schmerzen",
      "Sprunggelenkarthralgie",
      "Sprunggelenkschmerzen"
    ]
  },
  {
    "code": "M25.59",
    "name": "Gelenkschmerzen",
    "synonyms": [
      "Akute Gelenkschmerzen",
      "Allergische Arthralgie",
      "Arthralgie",
      "Arthrodynie",
      "Gelenkschmerzen"
    ]
  },
  {
    "code": "M25.61",
    "name": "Akute schmerzhafte Schultersteife",
    "synonyms": [
      "Akute schmerzhafte Schultersteife",
      "Schultergelenksteifheit",
      "Schultersteife",
      "Schulterteilsteife"
    ]
  },
  {
    "code": "M25.62",
    "name": "Ellenbogengelenksteifheit",
    "synonyms": [
      "Ellenbogengelenksteifheit"
    ]
  },
  {
    "code": "M25.63",
    "name": "Handgelenksteifheit",
    "synonyms": [
      "Handgelenksteifheit"
    ]
  },
  {
    "code": "M25.64",
    "name": "Fingergelenksteifheit",
    "synonyms": [
      "Fingergelenksteifheit"
    ]
  },
  {
    "code": "M25.65",
    "name": "Bewegungseinschränkung des Iliosakralgelenks",
    "synonyms": [
      "Bewegungseinschränkung des Iliosakralgelenks",
      "Hüftgelenksteifheit",
      "Iliosakralgelenksteifheit",
      "Sakroiliakalgelenksteifheit"
    ]
  },
  {
    "code": "M25.66",
    "name": "Kniegelenksteifheit",
    "synonyms": [
      "Kniegelenksteifheit"
    ]
  },
  {
    "code": "M25.67",
    "name": "Sprunggelenksteifheit",
    "synonyms": [
      "Sprunggelenksteifheit"
    ]
  },
  {
    "code": "M25.69",
    "name": "Gelenksteife",
    "synonyms": [
      "Fibröse Gelenksteife",
      "Gelenksteife",
      "Gelenksteifheit",
      "Gelenksteifheit mit partieller Bewegungseinschränkung",
      "Gelenksteifheit mit vollständiger Bewegungseinschränkung",
      "Knöcherne Gelenksteife"
    ]
  },
  {
    "code": "M25.79",
    "name": "Endoosteophyt",
    "synonyms": [
      "Arthrophyt",
      "Endoosteophyt",
      "Osteophyt",
      "Osteophytose"
    ]
  },
  {
    "code": "M25.86",
    "name": "Kniebeschwerden",
    "synonyms": [
      "Kniebeschwerden",
      "Überlastungsbeschwerden des Kniegelenks"
    ]
  },
  {
    "code": "M25.89",
    "name": "Periartikuläre Verkalkung",
    "synonyms": [
      "Alte Gelenkverletzung",
      "Gelenkkalzifikation",
      "Gelenkzyste a.n.k.",
      "Periartikuläre Kalzifikation",
      "Periartikuläre Ossifikation",
      "Periartikuläre Verkalkung",
      "Residuale Gelenkverletzung"
    ]
  },
  {
    "code": "M25.95",
    "name": "Hüftgelenkkrankheit",
    "synonyms": [
      "Hüftgelenkkrankheit"
    ]
  },
  {
    "code": "M25.96",
    "name": "Arthropathie des Knies",
    "synonyms": [
      "Arthropathie des Knies"
    ]
  },
  {
    "code": "M25.99",
    "name": "Gelenkaffektion",
    "synonyms": [
      "Arthropathia - s.a. Arthropathie",
      "Arthropathie",
      "Defektarthropathie",
      "Gelenkaffektion",
      "Gelenkerkrankung",
      "Gelenkkrankheit",
      "Gelenkläsion",
      "Gelenkstörung a.n.k.",
      "Gelenkveränderung",
      "Nichttraumatischer Gelenkschaden"
    ]
  },
  {
    "code": "M30.0",
    "name": "Arteriitis nodosa",
    "synonyms": [
      "Arteriitis nodosa",
      "Disseminierte Periarteriitis nodosa",
      "Infektiöse Periarteriitis nodosa",
      "Kussmaul-Maier-Krankheit",
      "Kussmaul-Maier-Syndrom",
      "Nekrotisierende Periarteriitis nodosa",
      "PAN [Polyarteriitis nodosa]",
      "Panangiitis",
      "Panarteriitis nodosa",
      "Periarteriitis nodosa",
      "Polyangiitis",
      "Polyarteriitis nodosa",
      "Primäre Polyarteriitis nodosa"
    ]
  },
  {
    "code": "M30.1",
    "name": "Panarteriitis mit Lungenbeteiligung",
    "synonyms": [
      "Allergische Granulomatose",
      "Allergische granulomatöse Angiitis",
      "Arteriitis hyperergica",
      "Churg-Strauss-Granulomatose",
      "Churg-Strauss-Syndrom [Allergische granulomatöse Angiitis] [Allergisch bedingte systemische granulomatös-nekrotisierende Vaskulitis (Arteriitis)] [Allergische Granulomatose]",
      "Eosinophile Granulomatose mit Polyangiitis",
      "IGDA [Interstitielle granulomatöse Dermatitis mit Arthritis]",
      "Interstitielle granulomatöse Dermatitis mit Arthritis",
      "Panarteriitis mit Lungenbeteiligung",
      "Panarteriitis nodosa mit Lungenbeteiligung",
      "Polyarteriitis mit Lungenbeteiligung"
    ]
  },
  {
    "code": "M30.2",
    "name": "Juvenile Panarteriitis",
    "synonyms": [
      "Juvenile Panarteriitis",
      "Juvenile Panarteriitis nodosa",
      "Juvenile Polyarteriitis"
    ]
  },
  {
    "code": "M30.3",
    "name": "Mukokutanes Lymphknotensyndrom [Kawasaki-Krankheit]",
    "synonyms": [
      "Kawasaki-Syndrom [Mukokutanes Lymphknotensyndrom]",
      "MCLS [Mukokutanes Lymphknotensyndrom]",
      "Mukokutanes Lymphknotensyndrom [Kawasaki-Krankheit]"
    ]
  },
  {
    "code": "M30.8",
    "name": "Polyangiitis-Overlap-Syndrom",
    "synonyms": [
      "Polyangiitis-Overlap-Syndrom",
      "Vaskulitis durch ADA2 [Adenosin-Desaminase 2]-Mangel"
    ]
  },
  {
    "code": "M31.0",
    "name": "Hämorrhagisches pulmorenales Syndrom",
    "synonyms": [
      "Allergische Angiitis",
      "Allergische Arteriitis",
      "Goodpasture-Syndrom",
      "Hypersensitive Angiitis",
      "Hypersensitivitätsangiitis",
      "Hämorrhagisches pulmorenales Syndrom",
      "Kutane Vaskulitis kleiner Gefäße",
      "Kutane leukozytoklastische Angiitis",
      "Kutane leukozytoklastische Vaskulitis"
    ]
  },
  {
    "code": "M31.1",
    "name": "Thrombotische Mikroangiopathie",
    "synonyms": [
      "Moschcowitz-Krankheit",
      "Moschcowitz-Syndrom",
      "TTP [Thrombotisch-thrombozytopenische Purpura]",
      "Thrombotisch-thrombozytopenische Purpura",
      "Thrombotische Mikroangiopathie"
    ]
  },
  {
    "code": "M31.3",
    "name": "Wegener-Granulomatose",
    "synonyms": [
      "GPA [Granulomatose mit Polyangiitis]",
      "Granuloma gangraenescens",
      "Granulomatose mit Polyangiitis",
      "McBride-Stewart-Syndrom [Granuloma gangraenescens]",
      "Morbus Wegener",
      "Nekrotisierende Granulomatose im Bereich der Atemwege",
      "Riesenzellengranuloarteriitis",
      "Wegener-Granulomatose",
      "Wegener-Klinger-Churg-Syndrom",
      "Wegener-Krankheit",
      "Wegener-Syndrom"
    ]
  },
  {
    "code": "M31.4",
    "name": "Aortenbogensyndrom",
    "synonyms": [
      "Aortenbogensyndrom",
      "Arteriitis der Aorta brachiocephalica",
      "Arteriitis des Aortenbogens",
      "Pulseless disease",
      "Takayasu-Arteriitis",
      "Takayasu-Krankheit",
      "Takayasu-Syndrom"
    ]
  },
  {
    "code": "M31.5",
    "name": "Riesenzellarteriitis bei rheumatischer Polymyalgie",
    "synonyms": [
      "Polymyalgia arteriitica",
      "Polymyalgia arteriitica mit Riesenzellen",
      "Riesenzellarteriitis bei Polymyalgia rheumatica",
      "Riesenzellarteriitis bei rheumatischer Polymyalgie"
    ]
  },
  {
    "code": "M31.6",
    "name": "Riesenzellarteriitis a.n.k.",
    "synonyms": [
      "Arteriitis temporalis",
      "Horton-Krankheit",
      "Horton-Magath-Brown-Syndrom",
      "Kranielle Arteriitis",
      "Morbus Horton",
      "Riesenzellarteriitis a.n.k."
    ]
  },
  {
    "code": "M31.7",
    "name": "Mikroskopische Polyangiitis",
    "synonyms": [
      "MPA [Mikroskopische Polyangiitis]",
      "Mikroskopische Panarteriitis",
      "Mikroskopische Polyangiitis",
      "Mikroskopische Polyarteriitis"
    ]
  },
  {
    "code": "M31.8",
    "name": "Hypokomplementämische urtikarielle Vaskulitis",
    "synonyms": [
      "Hypokomplementämische urtikarielle Vaskulitis"
    ]
  },
  {
    "code": "M31.9",
    "name": "Nekrotisierende Vaskulopathie",
    "synonyms": [
      "Nekrotisierende Angiitis",
      "Nekrotisierende Arteriitis",
      "Nekrotisierende Vaskulopathie"
    ]
  },
  {
    "code": "M32.0",
    "name": "Arzneimittelinduzierter systemischer Lupus erythematodes",
    "synonyms": [
      "Arzneimittelinduzierter systemischer Lupus erythematodes",
      "Arzneimittelinduzierter systemischer Lupus erythematodes im Kindesalter",
      "Medikamenteninduzierter Lupus erythematodes"
    ]
  },
  {
    "code": "M32.1",
    "name": "Viszeraler Lupus erythematodes",
    "synonyms": [
      "Systemischer Lupus erythematodes mit Beteiligung von Organen oder Organsystemen",
      "Viszeraler Lupus erythematodes"
    ]
  },
  {
    "code": "M32.8",
    "name": "Autosomal-rezessiver systemischer Lupus erythematodes",
    "synonyms": [
      "Autosomal-rezessiver systemischer Lupus erythematodes",
      "Familiärer systemischer Lupus erythematodes"
    ]
  },
  {
    "code": "M32.9",
    "name": "Systemischer Lupus erythematodes [SLE]",
    "synonyms": [
      "Akuter Lupus erythematodes",
      "Disseminierter Lupus erythematodes",
      "Lupus erythematodes Zellenphänomen",
      "Lupus erythematodes disseminatus",
      "Systemischer Lupus erythematodes [SLE]",
      "Systemischer Lupus erythematodes des Kindesalters"
    ]
  },
  {
    "code": "M33.0",
    "name": "Juvenile Dermatomyositis",
    "synonyms": [
      "Juvenile Dermatomyositis",
      "Juvenile Myositis",
      "Juveniles Myositis-Overlap-Syndrom",
      "Neonatale Dermatomyositis"
    ]
  },
  {
    "code": "M33.1",
    "name": "Dermatomukosomyositis",
    "synonyms": [
      "Adulte Dermatomyositis",
      "Akute Dermatomyositis",
      "Chronische Dermatomyositis",
      "Dermatomukosomyositis",
      "Dermatomyositis",
      "Petges-Cléjat-Jacobi-Syndrom",
      "Poikilodermatomyositis",
      "Pseudotrichinose",
      "Wagner-Krankheit [Dermatomyositis]",
      "Wagner-Polymyositis",
      "Wagner-Unverricht-Syndrom",
      "Weißfleckige Lila-Krankheit"
    ]
  },
  {
    "code": "M33.2",
    "name": "Akute Polymyositis",
    "synonyms": [
      "Akute Polymyositis",
      "Chronische Polymyositis",
      "Genuine Polymyositis",
      "Hämorrhagische Polymyositis",
      "Juvenile Polymyositis",
      "PM [Polymyositis]",
      "Polymyositis"
    ]
  },
  {
    "code": "M33.9",
    "name": "Dermatopolymyositis",
    "synonyms": [
      "Dermatomyositis-Polymyositis",
      "Dermatopolymyositis",
      "Polymyositis mit Hautbeteiligung"
    ]
  },
  {
    "code": "M34.0",
    "name": "Progressive systemische Sklerose",
    "synonyms": [
      "Diffuse kutane systemische Sklerodermie",
      "Diffuse kutane systemische Sklerose",
      "Limitierte systemische Sklerose",
      "Progressive kutane systemische Sklerose",
      "Progressive systemische Sklerodermie",
      "Progressive systemische Sklerose",
      "Systemische Sklerose ohne Sklerodermie"
    ]
  },
  {
    "code": "M34.1",
    "name": "CREST-Syndrom [Spezialform der progressiven systemischen Sklerose mit Calcinosis cutis, Raynaud-Phänomen, Ösophagusdysfunktion, Sklerodaktylie und Teleangiektasie]",
    "synonyms": [
      "CREST-Syndrom [Spezialform der progressiven systemischen Sklerose mit Calcinosis cutis, Raynaud-Phänomen, Ösophagusdysfunktion, Sklerodaktylie und Teleangiektasie]",
      "Limitierte kutane systemische Sklerose",
      "Progressive systemische Sklerose mit Calcinosis cutis, Raynaud-Phänomen, Ösophagusdysfunktion, Sklerodaktylie und Teleangiektasie [CREST-Syndrom]"
    ]
  },
  {
    "code": "M34.2",
    "name": "Arzneimittelinduzierte systemische Sklerose",
    "synonyms": [
      "Arzneimittelinduzierte systemische Sklerose",
      "Systemische Sklerose durch chemische Substanz a.n.k."
    ]
  },
  {
    "code": "M34.8",
    "name": "Akrosklerose",
    "synonyms": [
      "Akrosklerose",
      "Sclerema adultorum",
      "Scleroedema adultorum",
      "Sklerodermie der Niere",
      "Sklerödem Buschke",
      "Sklerödem beim Erwachsenen",
      "Thibièrge-Weissenbach-Krankheit",
      "Thibièrge-Weissenbach-Syndrom"
    ]
  },
  {
    "code": "M34.9",
    "name": "Systemische Sklerose",
    "synonyms": [
      "Chronische Dermatosklerose",
      "Dermatosklerose",
      "Diffuse Sklerodermie",
      "Disseminierte Trophoneurose a.n.k.",
      "Generalisierte Sklerodermie",
      "Sclerodermia - s.a. Sklerodermie",
      "Sclerodermia diffusa",
      "Sklerodermie",
      "Systemische Sklerodermie",
      "Systemische Sklerose"
    ]
  },
  {
    "code": "M35.0",
    "name": "Atrophische Dakryosialoadenopathie",
    "synonyms": [
      "Atrophische Dakryosialoadenopathie",
      "Dacryosialadenopathia atrophicans",
      "Gougerot-Sjögren-Krankheit",
      "Primäres Sjögren-Syndrom",
      "Sicca-Syndrom [Sjögren-Syndrom]",
      "Sicca-Syndrom der Augen im Sinne des Sjögren-Syndroms",
      "Sjögren-Krankheit",
      "Sjögren-Syndrom"
    ]
  },
  {
    "code": "M35.1",
    "name": "Mischkollagenose",
    "synonyms": [
      "MCTD [Mixed connective tissue disease]",
      "Mischkollagenose",
      "Mixed connective tissue disease",
      "Myositis-Overlap-Syndrom",
      "Overlapsyndrom",
      "Sharp-Syndrom"
    ]
  },
  {
    "code": "M35.2",
    "name": "Morbus Behçet",
    "synonyms": [
      "Arthritis bei Behçet-Syndrom",
      "Behçet-Aphthen",
      "Behçet-Krankheit",
      "Behçet-Syndrom",
      "Hughes-Stovin-Syndrom",
      "Morbus Adamantiades-Behçet",
      "Morbus Behçet"
    ]
  },
  {
    "code": "M35.3",
    "name": "Polymyalgia rheumatica",
    "synonyms": [
      "Morbus Forestier [Pseudopolyarthritis von Hüfte und Schulter]",
      "Polymyalges Schmerzsyndrom",
      "Polymyalgia",
      "Polymyalgia rheumatica"
    ]
  },
  {
    "code": "M35.4",
    "name": "Eosinophile Fasziitis",
    "synonyms": [
      "Diffuse eosinophile Fasziitis",
      "Eosinophile Fasziitis",
      "Shulman-Syndrom"
    ]
  },
  {
    "code": "M35.5",
    "name": "Multifokale Fibrosklerose",
    "synonyms": [
      "Multifokale Fibrosklerose"
    ]
  },
  {
    "code": "M35.6",
    "name": "Rezidivierende Pannikulitis",
    "synonyms": [
      "Christian-Weber-Krankheit",
      "Lipidgranulom bei Pfeifer-Weber-Christian-Syndrom",
      "Lipophages Granulom bei Pfeifer-Weber-Christian-Syndrom",
      "Pannikulitis nodularis non suppurativa",
      "Pfeifer-Weber-Christian-Krankheit",
      "Pfeifer-Weber-Christian-Syndrom",
      "Rezidivierende Pannikulitis",
      "Weber-Christian-Syndrom"
    ]
  },
  {
    "code": "M35.7",
    "name": "Hypermobilitätssyndrom",
    "synonyms": [
      "Familiäre Bänderschwäche",
      "Hypermobilitätssyndrom"
    ]
  },
  {
    "code": "M35.8",
    "name": "Eosinophilie-Myalgie-Syndrom",
    "synonyms": [
      "APLAID [Autoinflammation mit PLCG2-assoziiertem Antikörper-Mangel und Immundysregulation]",
      "Antisynthetase-Syndrom",
      "Autoinflammation mit PLCG2-assoziiertem Antikörper-Mangel und Immundysregulation",
      "CANDLE [Chronische atypische neutrophile Dermatose mit Lipodystrophie und erhöhter Temperatur]-Syndrom",
      "CEBPE-assoziiertes Autoinflammations-Syndrom mit Immundefekt und neutrophiler Funktionsstörung",
      "CINCA [Chronisch-infantiles neuro-kutaneo-artikuläres]-Syndrom",
      "COPA [Coatomer-Protein-Komplex, Untereinheit alpha]-Syndrom",
      "EMILIN-1-assoziierte Bindegewebskrankheit",
      "Eosinophilie-Myalgie-Syndrom",
      "Hereditäre Behçet-ähnliche Krankheit des Kindes",
      "Histiozytäre zytophagische Pannikulitis",
      "Kortikosteroid-sensitives aseptisches Abszess-Syndrom",
      "L-Tryptophan-assoziiertes Eosinophilie-Myalgie-Syndrom",
      "Muckle-Wells-Syndrom",
      "Multisystemische syndromale Autoimmunkrankheit durch ITCH-Defekt",
      "NLRC4-abhängiges Makrophagen-Aktivierungssyndrom",
      "NOMID [Neonatal-Onset Multisystem Inflammatory Disease]",
      "Nephrogene systemische Fibrose",
      "ORAS [OTULIN-assoziiertes autoinflammatorisches Syndrom]",
      "OTULIN-assoziiertes autoinflammatorisches Syndrom",
      "PAPA [Pyogene Arthritis, Pyoderma gangraenosum, Akne]-Syndrom",
      "PAPASH [Pyogene Arthritis, Pyoderma gangraenosum, Akne, Hidradenitis suppurativa]-Syndrom",
      "PASH [Pyoderma gangraenosum, Akne und Hidradenitis suppurativa]-Syndrom",
      "PASS [Pyoderma gangraenosum, Akne, Hidradenitis suppurativa, ankylosierende Spondylarthritis]-Syndrom",
      "PFAPA [Periodisches Fieber, aphthöse Stomatitis, Pharyngitis, Adenopathie]-Syndrom",
      "PLAID [PLCG2-associated antibody deficiency and immune dysregulation]",
      "PRAAS [Proteasom-assoziiertes autoinflammatorisches Syndrom]",
      "PsAPASH [Psoriasis-Arthritis, Pyoderma gangrenosum, Akne, Hidradenitis suppurativa]-Syndrom",
      "SAMD9L-assoziiertes autoinflammatorisches Syndrom",
      "SOCS1-assoziiertes autoinflammatorisches Syndrom",
      "STAT3-assoziierte früh beginnende multisystemische Autoimmunkrankheit",
      "STING [Stimulator von Interferongenen]-assoziierte Vaskulopathie mit Beginn in der Kindheit",
      "Syndrom der Psoriasis-Arthritis mit Pyoderma gangrenosum, Akne und Hidradenitis suppurativa",
      "Syndrom der pyogenen Arthritis mit Pyoderma gangraenosum, Akne und Hidradenitis suppurativa",
      "Syndrom des Pyoderma gangraenosum mit Akne, Hidradenitis suppurativa und ankylosierender Spondylarthritis",
      "Undifferenzierte Kollagenose",
      "VEXAS [Vakuolen, E1-Enzym, x-chromosomal, autoinflammatorisch, somatisch]-Syndrom"
    ]
  },
  {
    "code": "M35.9",
    "name": "Autoaggressionskrankheit",
    "synonyms": [
      "Autoaggressionskrankheit",
      "Autoimmunkrankheit",
      "Autoimmunopathie",
      "Kollagengefäßkrankheit",
      "Kollagenkrankheit",
      "Kollagenopathie",
      "Kollagenose",
      "Nichtvaskuläre Kollagenkrankheit",
      "Nichtvaskuläre Kollagenose",
      "Systemische Autoimmunkrankheit a.n.k.",
      "Systemische Krankheit des Bindegewebes",
      "Vaskuläre Kollagenkrankheit",
      "Vaskuläre Kollagenose"
    ]
  },
  {
    "code": "M40.02",
    "name": "Kyphotische Fehlhaltung der Halswirbelsäule",
    "synonyms": [
      "Kyphotische Fehlhaltung der Halswirbelsäule"
    ]
  },
  {
    "code": "M40.09",
    "name": "Haltungskyphose",
    "synonyms": [
      "Haltungskyphose",
      "Haltungskyphose beim Jugendlichen",
      "Kyphose als Haltungsschaden",
      "Kyphotische Haltungsstörung beim Jugendlichen",
      "Rundrücken als Haltungsschaden"
    ]
  },
  {
    "code": "M40.19",
    "name": "Gibbusbildung",
    "synonyms": [
      "Gibbusbildung",
      "Sekundäre Kyphose a.n.k."
    ]
  },
  {
    "code": "M40.22",
    "name": "Kyphotische Fehlstellung der Halswirbelsäule",
    "synonyms": [
      "Kyphotische Fehlstellung der Halswirbelsäule",
      "Kyphotischer Knick im HWS-Bereich"
    ]
  },
  {
    "code": "M40.24",
    "name": "Thorakalkyphose",
    "synonyms": [
      "BWS-Kyphose",
      "Fixierte BWS-Kyphose",
      "Hyperkyphose der Brustwirbelsäule",
      "Kyphose der Brustwirbelsäule",
      "Thorakalkyphose"
    ]
  },
  {
    "code": "M40.29",
    "name": "Kyphose",
    "synonyms": [
      "Buckel",
      "Erworbene Kyphose",
      "Erworbener Buckel",
      "Fixierter Rundrücken",
      "Gering fixierter Rundrücken",
      "Hohlrunder Rücken",
      "Kyphose",
      "Kyphosklerose",
      "Rigider Rundrücken",
      "Rundrücken",
      "Rundrücken mit Keilwirbeln"
    ]
  },
  {
    "code": "M40.39",
    "name": "Flachrücken",
    "synonyms": [
      "Flachrücken"
    ]
  },
  {
    "code": "M40.46",
    "name": "Hyperlordose der Lendenwirbelsäule",
    "synonyms": [
      "Hyperlordose der Lendenwirbelsäule"
    ]
  },
  {
    "code": "M40.49",
    "name": "Lordose als Haltungsstörung",
    "synonyms": [
      "Erworbene Lordose",
      "Hyperlordose",
      "Lordose als Haltungsstörung"
    ]
  },
  {
    "code": "M40.56",
    "name": "Lendenlordose",
    "synonyms": [
      "Lendenlordose"
    ]
  },
  {
    "code": "M40.57",
    "name": "Lordotischer Knick L5/S1",
    "synonyms": [
      "Lordotischer Knick L5/S1"
    ]
  },
  {
    "code": "M40.59",
    "name": "Lordose",
    "synonyms": [
      "Hohlkreuz",
      "Lordose",
      "Satteldeformität des Rückens"
    ]
  },
  {
    "code": "M41.09",
    "name": "Idiopathische Skoliose beim Kind",
    "synonyms": [
      "Idiopathische Skoliose beim Kind",
      "Säuglingsskoliose"
    ]
  },
  {
    "code": "M41.19",
    "name": "Idiopathische Skoliose beim Jugendlichen",
    "synonyms": [
      "Adoleszenten-Skoliose",
      "Idiopathische Skoliose beim Jugendlichen",
      "Juvenile Skoliose",
      "Skoliose beim Jugendlichen"
    ]
  },
  {
    "code": "M41.29",
    "name": "Idiopathische Skoliose a.n.k.",
    "synonyms": [
      "Idiopathische Skoliose a.n.k."
    ]
  },
  {
    "code": "M41.34",
    "name": "Thoraxbedingte Skoliose",
    "synonyms": [
      "Thoraxbedingte Skoliose"
    ]
  },
  {
    "code": "M41.49",
    "name": "Neuromyopathische Skoliose",
    "synonyms": [
      "Lähmungsskoliose",
      "Neuromuskuläre Skoliose",
      "Neuromyopathische Skoliose",
      "Paralytische Skoliose"
    ]
  },
  {
    "code": "M41.59",
    "name": "Sekundäre funktionelle Skoliose",
    "synonyms": [
      "Sekundäre Skoliose a.n.k.",
      "Sekundäre funktionelle Skoliose"
    ]
  },
  {
    "code": "M41.84",
    "name": "BWS-Torsionsskoliose",
    "synonyms": [
      "BWS-Torsionsskoliose",
      "Torsionsskoliose der Brustwirbelsäule"
    ]
  },
  {
    "code": "M41.85",
    "name": "BWS-LWS-Torsionsskoliose",
    "synonyms": [
      "BWS-LWS-Torsionsskoliose",
      "Thorakolumbale Torsionsskoliose",
      "Torsionsskoliose der Brust- und Lendenwirbelsäule"
    ]
  },
  {
    "code": "M41.86",
    "name": "Lumbale Torsionsskoliose",
    "synonyms": [
      "Lumbale Torsionsskoliose"
    ]
  },
  {
    "code": "M41.89",
    "name": "Schwere Rotationsskoliose",
    "synonyms": [
      "Myalgie bei Torsionsskoliose",
      "Schwere Rotationsskoliose",
      "Torsionsskoliose"
    ]
  },
  {
    "code": "M41.92",
    "name": "Linkskonvexe HWS-Skoliose",
    "synonyms": [
      "Linkskonvexe HWS-Skoliose",
      "Rechtskonvexe HWS-Skoliose"
    ]
  },
  {
    "code": "M41.94",
    "name": "BWS-Skoliose",
    "synonyms": [
      "BWS-Skoliose",
      "BWS-Skoliose mit degenerativer Veränderung",
      "Flach linkskonvexe BWS-Skoliose",
      "Flach rechtskonvexe BWS-Skoliose",
      "Flache BWS-Skoliose",
      "Linkskonvexe BWS-Skoliose",
      "Minimal linkskonvexe BWS-Skoliose",
      "Minimal rechtskonvexe BWS-Skoliose",
      "Rechtskonvexe BWS-Skoliose",
      "Rechtskonvexe Thorakalskoliose"
    ]
  },
  {
    "code": "M41.95",
    "name": "BWS-LWS-Skoliose",
    "synonyms": [
      "BWS-LWS-Skoliose",
      "Flach linkskonvexe BWS-LWS-Skoliose",
      "Flach rechtskonvexe BWS-LWS-Skoliose",
      "Linkskonvexe BWS-LWS-Skoliose",
      "Rechtskonvexe BWS-LWS-Skoliose",
      "Thorakolumbale Skoliose",
      "Thorakolumbalskoliose"
    ]
  },
  {
    "code": "M41.96",
    "name": "Lumbale Skoliose",
    "synonyms": [
      "Flach linkskonvexe LWS-Skoliose",
      "Flach rechtskonvexe LWS-Skoliose",
      "LWS-Skoliose",
      "Linkskonvexe LWS-Skoliose",
      "Lumbale Skoliose",
      "Minimal linkskonvexe LWS-Skoliose",
      "Minimal rechtskonvexe LWS-Skoliose",
      "Rechtskonvexe LWS-Skoliose",
      "S-förmige LWS-Skoliose"
    ]
  },
  {
    "code": "M41.99",
    "name": "Skoliose",
    "synonyms": [
      "Aktivierte Skoliose",
      "Erworbene Kyphoskoliose",
      "Erworbene Skoliose",
      "Flachbogige Skoliose",
      "Flache Skoliose",
      "Kyphoskoliose",
      "Leichte statisch nicht relevante Skoliose",
      "Linkskonvexe Kyphoskoliose",
      "Linkskonvexe Skoliose",
      "Rechtskonvexe Kyphoskoliose",
      "Rechtskonvexe Skoliose",
      "Schiefwuchs",
      "Skoliose",
      "Skoliose beim Erwachsenen",
      "Skoliose der Wirbelsäule",
      "Skoliotische Fehlhaltung",
      "Skoliotische Haltungsstörung",
      "Statische Skoliose",
      "WS-Skoliose"
    ]
  },
  {
    "code": "M42.09",
    "name": "Morbus Scheuermann",
    "synonyms": [
      "Adoleszenten-Kyphose",
      "Calvé-Krankheit",
      "Calvé-Syndrom",
      "Familiäre juvenile Kyphose Typ Scheuermann",
      "Juvenile Wirbelkörperosteochondrose",
      "Juvenile Wirbelsäulenosteochondrose",
      "Morbus Scheuermann",
      "Scheuermann-Krankheit",
      "Scheuermann-Osteochondrose",
      "Scheuermann-Syndrom",
      "Schmorl-Knorpelknötchen bei Scheuermann-Krankheit",
      "Vertebra plana",
      "Vertebrale Epiphysitis"
    ]
  },
  {
    "code": "M42.19",
    "name": "Osteochondrose der Wirbelsäule beim Erwachsenen",
    "synonyms": [
      "Osteochondrose der Wirbelsäule beim Erwachsenen"
    ]
  },
  {
    "code": "M42.92",
    "name": "Zervikale Osteochondrose",
    "synonyms": [
      "Ausgeprägte Osteochondrose der Halswirbelsäule",
      "HWS-Osteochondrose",
      "Osteochondrose der Halswirbelsäule",
      "Osteochondrose der unteren Halswirbelsäule",
      "Zervikale Osteochondrose"
    ]
  },
  {
    "code": "M42.94",
    "name": "Ausgeprägte Osteochondrose der Brustwirbelsäule",
    "synonyms": [
      "Ausgeprägte Osteochondrose der Brustwirbelsäule",
      "BWS-Osteochondrose",
      "Osteochondrose der Brustwirbelsäule"
    ]
  },
  {
    "code": "M42.96",
    "name": "Osteochondrose der LWS",
    "synonyms": [
      "Ausgeprägte Osteochondrose der Lendenwirbelsäule",
      "Massive Osteochondrose der Lendenwirbelsäule",
      "Osteochondrose der LWS",
      "Osteochondrose der Lendenwirbelsäule",
      "Schwere Osteochondrose der LWS"
    ]
  },
  {
    "code": "M42.97",
    "name": "Lumbosakrale Osteochondrose mit Retrolisthese",
    "synonyms": [
      "Ausgeprägte Osteochondrose der Lenden- und Sakralwirbelsäule",
      "Lumbosakrale Osteochondrose mit Retrolisthese",
      "Osteochondrose der Lenden- und Sakralwirbelsäule"
    ]
  },
  {
    "code": "M42.99",
    "name": "Osteochondrose der Wirbelsäule",
    "synonyms": [
      "Ausgeprägte Osteochondrose der Wirbelsäule mit Foraminaeinengungen",
      "Massive Osteochondrose der Wirbelsäule",
      "Osteochondrose der Wirbelsäule",
      "WS-Osteochondrose"
    ]
  },
  {
    "code": "M43.06",
    "name": "Spondylolyse im LWS-Bereich",
    "synonyms": [
      "Spondylolyse im LWS-Bereich"
    ]
  },
  {
    "code": "M43.07",
    "name": "Spondylolyse der Lenden- und Sakralwirbel",
    "synonyms": [
      "Spondylolyse der Lenden- und Sakralwirbel",
      "Spondylolyse im Lumbosakralbereich"
    ]
  },
  {
    "code": "M43.09",
    "name": "Spondylolyse",
    "synonyms": [
      "Erworbene Spondylolyse",
      "Spondylolyse"
    ]
  },
  {
    "code": "M43.12",
    "name": "Gefügestörung im HWS-Bereich",
    "synonyms": [
      "Gefügestörung im HWS-Bereich"
    ]
  },
  {
    "code": "M43.16",
    "name": "Gefügestörung im LWS-Bereich",
    "synonyms": [
      "Gefügelockerung L4/L5 mit Pseudospondylolisthesis",
      "Gefügestörung im LWS-Bereich",
      "Pseudospondylolisthesis L4/5",
      "Spondylolisthesis L3/4",
      "Spondylolisthesis L4/5",
      "Spondylolisthesis L4/5, Grad I (Meyerding)",
      "Spondylolisthesis L4/5, Grad II (Meyerding)"
    ]
  },
  {
    "code": "M43.17",
    "name": "Spondylolisthesis L5/S1",
    "synonyms": [
      "Spondylolisthesis L5/S1",
      "Spondylolisthesis L5/S1, Grad I (Meyerding)",
      "Spondylolisthesis L5/S1, Grad II (Meyerding)"
    ]
  },
  {
    "code": "M43.19",
    "name": "Spondylolisthesis",
    "synonyms": [
      "Alte traumatische Spondylolisthesis",
      "Degenerative Spondylolisthesis",
      "Erworbene Spondylolisthesis",
      "Gleitwirbel a.n.k.",
      "Gleitwirbelbildung",
      "Pseudospondylolisthesis",
      "Retrolisthese",
      "Spondylolisthesis",
      "Wirbelgleiten a.n.k."
    ]
  },
  {
    "code": "M43.22",
    "name": "Halswirbelversteifung",
    "synonyms": [
      "Halswirbelversteifung"
    ]
  },
  {
    "code": "M43.27",
    "name": "Ankylose des Iliosakralgelenks",
    "synonyms": [
      "Ankylose des Iliosakralgelenks",
      "Ankylose des Sakroiliakalgelenks",
      "Erworbene iliosakrale Fusion",
      "Erworbene lumbosakrale Fusion",
      "Lumbosakrale Ankylose"
    ]
  },
  {
    "code": "M43.29",
    "name": "Wirbelgelenkankylose",
    "synonyms": [
      "Ankylose der Wirbelsäule",
      "Erworbene Fusion der Wirbelsäule a.n.k.",
      "Erworbene Wirbelblockade a.n.k.",
      "Wirbelgelenkankylose"
    ]
  },
  {
    "code": "M43.3",
    "name": "Habituelle atlantoaxiale Subluxation mit Myelopathie",
    "synonyms": [
      "Habituelle atlantoaxiale Subluxation mit Myelopathie"
    ]
  },
  {
    "code": "M43.59",
    "name": "Habituelle Wirbelsubluxation a.n.k.",
    "synonyms": [
      "Habituelle Wirbelsubluxation a.n.k."
    ]
  },
  {
    "code": "M43.6",
    "name": "Tortikollis",
    "synonyms": [
      "Akuter Schiefhals",
      "Caput obstipum sive distortum",
      "Collum obstipum",
      "Intermittierender Tortikollis",
      "Muskulärer Schiefhals",
      "Muskulärer Tortikollis",
      "Schiefhals",
      "Steifer Nacken",
      "Torticollis - s.a. Tortikollis",
      "Tortikollis"
    ]
  },
  {
    "code": "M43.87",
    "name": "Erworbene lumbosakrale Deformität",
    "synonyms": [
      "Erworbene lumbosakrale Deformität"
    ]
  },
  {
    "code": "M43.88",
    "name": "Erworbene Kreuzbeindeformität",
    "synonyms": [
      "Erworbene Kreuzbeindeformität",
      "Erworbene Sakrumdeformität",
      "Erworbene Sakrumverkrümmung",
      "Erworbene Steißbeindeformität",
      "Erworbene Steißbeinverkrümmung",
      "Erworbene iliosakrale Deformität"
    ]
  },
  {
    "code": "M43.89",
    "name": "Kippwirbel",
    "synonyms": [
      "Erworbene Wirbelsäulendeformität a.n.k.",
      "Kippwirbel",
      "Wirbelkippung"
    ]
  },
  {
    "code": "M43.95",
    "name": "Thorakolumbale Fehlhaltung",
    "synonyms": [
      "Thorakolumbale Fehlhaltung"
    ]
  },
  {
    "code": "M43.99",
    "name": "WS-Fehlstatik",
    "synonyms": [
      "Deformierendes Rückenleiden",
      "Erworbene Wirbelsäulenverkrümmung",
      "Fehlstatik der Wirbelsäule",
      "Haltungsschaden der Wirbelsäule a.n.k.",
      "Haltungsschwäche der Wirbelsäule",
      "Haltungsstörung der Wirbelsäule a.n.k.",
      "Irregulärer Wirbel",
      "Rückendeformität",
      "Statische Wirbelsäulenbeschwerden",
      "WS-Fehlstatik",
      "Wirbelsäulendeformität",
      "Wirbelsäulenkontraktur",
      "Wirbelsäulenverbiegung",
      "Wirbelsäulenverkrümmung"
    ]
  },
  {
    "code": "M45.00",
    "name": "Spondylitis bei chronischer Polyarthritis",
    "synonyms": [
      "Chronische Polyarthritis der Wirbelsäule",
      "Spondylitis ankylosans an mehreren Lokalisationen der Wirbelsäule",
      "Spondylitis bei chronischer Polyarthritis"
    ]
  },
  {
    "code": "M45.09",
    "name": "Morbus von Bechterew",
    "synonyms": [
      "Ankylosierende Arthritis der Wirbelsäule",
      "Axiale Spondyloarthritis",
      "Marie-Pierre-Krankheit",
      "Marie-Strümpell-Spondylitis",
      "Marie-von-Strümpell-Arthritis der Wirbelsäule",
      "Marie-von-Strümpell-Krankheit",
      "Morbus von Bechterew",
      "Nichtröntgenologische axiale Spondyloarthritis",
      "Primäre progressive Wirbelsäulenarthritis",
      "Rheumatoide Spondylitis",
      "Rheumatoide Wirbelsäulenarthritis",
      "Röntgenologische axiale Spondyloarthritis",
      "Spondylitis ankylopoetica",
      "Spondylitis ankylosans",
      "Spondylitis atrophica ligamentosa",
      "Spondylitis rhizomélique",
      "Spondyloarthritis ankylopoetica",
      "Spondylosis rhizomélique",
      "Von-Bechterew-Krankheit",
      "Von-Bechterew-Syndrom",
      "Von-Bechterew-von-Strümpell-Marie-Krankheit",
      "Von-Bechterew-von-Strümpell-Marie-Syndrom"
    ]
  },
  {
    "code": "M46.09",
    "name": "Spinale Enthesiopathie",
    "synonyms": [
      "Enthesiopathie der Wirbelsäule",
      "Insertionsstörung der Wirbelsäule",
      "Läsion der Bänderinsertionsstellen der Wirbelsäule",
      "Läsion der Muskelinsertionsstellen der Wirbelsäule",
      "Spinale Enthesiopathie",
      "Spinale Enthesitis"
    ]
  },
  {
    "code": "M46.1",
    "name": "Sakroiliitis a.n.k.",
    "synonyms": [
      "Entzündliche Veränderung des Iliosakralgelenks",
      "Entzündung des Iliosakralgelenks",
      "Entzündung des Sakroiliakalgelenks",
      "Iliosakrale Spondylitis a.n.k.",
      "Sakroiliitis a.n.k."
    ]
  },
  {
    "code": "M46.22",
    "name": "Abszess der Halswirbelsäule",
    "synonyms": [
      "Abszess der Halswirbelsäule",
      "Wirbelosteomyelitis im Zervikalbereich"
    ]
  },
  {
    "code": "M46.28",
    "name": "Nichttuberkulöser Kreuzbeinabszess",
    "synonyms": [
      "Nichttuberkulöser Kreuzbeinabszess",
      "Nichttuberkulöser Sakrumabszess",
      "Wirbelosteomyelitis im Sakralbereich",
      "Wirbelosteomyelitis im Sakrokokzygealbereich"
    ]
  },
  {
    "code": "M46.29",
    "name": "Wirbelosteomyelitis",
    "synonyms": [
      "Nichttuberkulöser Wirbelsäulenabszess",
      "Nichttuberkulöser spinaler Knochenabszess",
      "Wirbelkörperabszess",
      "Wirbelosteomyelitis"
    ]
  },
  {
    "code": "M46.39",
    "name": "Bandscheibeninfektion",
    "synonyms": [
      "Bandscheibeninfektion",
      "Eitrige Spondylodiszitis",
      "Pyogene Bandscheibeninfektion",
      "Pyogene Diszitis",
      "Pyogene Infektion der Zwischenwirbelscheibe"
    ]
  },
  {
    "code": "M46.42",
    "name": "Spondylodiszitis der Halswirbelkörper",
    "synonyms": [
      "Spondylodiszitis der Halswirbelkörper"
    ]
  },
  {
    "code": "M46.44",
    "name": "Spondylodiszitis der Brustwirbelkörper",
    "synonyms": [
      "Spondylodiszitis der Brustwirbelkörper"
    ]
  },
  {
    "code": "M46.46",
    "name": "Spondylodiszitis der Lendenwirbelkörper",
    "synonyms": [
      "Spondylodiszitis der Lendenwirbelkörper"
    ]
  },
  {
    "code": "M46.49",
    "name": "Diszitis",
    "synonyms": [
      "Diszitis",
      "Spondylodiszitis"
    ]
  },
  {
    "code": "M46.59",
    "name": "Infektiöse Spondylitis a.n.k.",
    "synonyms": [
      "Eitrige Wirbelsäulenarthritis",
      "Infektiöse Spondylitis a.n.k.",
      "Infektiöse Spondylopathie a.n.k.",
      "Infektiöse Wirbelsäulenarthritis",
      "Nichttuberkulöser Wirbelgelenkabszess",
      "Purulente Wirbelsäulenarthritis",
      "Pyogene Wirbelsäulenarthritis",
      "Septische Wirbelsäulenarthritis"
    ]
  },
  {
    "code": "M46.89",
    "name": "Entzündlich-rheumatisches Wirbelsäulenleiden",
    "synonyms": [
      "Entzündlich-rheumatisches Wirbelsäulenleiden"
    ]
  },
  {
    "code": "M46.92",
    "name": "Zervikale Arthritis",
    "synonyms": [
      "Zervikale Arthritis"
    ]
  },
  {
    "code": "M46.99",
    "name": "Spondylitis",
    "synonyms": [
      "Arthritis der Wirbelsäule",
      "Arthritis des Rückens - s.a. Spondylitis",
      "Chronische Spondylitis",
      "Entzündliche Spondylopathie",
      "Spondylitis",
      "Wirbelentzündung",
      "Wirbelsäulenentzündung"
    ]
  },
  {
    "code": "M47.20",
    "name": "Degeneratives HWS-LWS-Syndrom",
    "synonyms": [
      "Degeneratives HWS-LWS-Syndrom",
      "Facettenreizung der gesamten Wirbelsäule"
    ]
  },
  {
    "code": "M47.22",
    "name": "Degeneratives Zervikalsyndrom",
    "synonyms": [
      "Chronisch-degeneratives Zervikalsyndrom",
      "Degeneratives HWS-Syndrom",
      "Degeneratives Zervikalsyndrom",
      "Degeneratives pseudoradikuläres Zervikalsyndrom",
      "Facettenreizung im HWS-Bereich",
      "HWS-Facettensyndrom",
      "HWS-Syndrom bei degenerativer Veränderung",
      "Migraine cervicale",
      "Zervikale Migräne"
    ]
  },
  {
    "code": "M47.23",
    "name": "Chronisches HWS-BWS-Syndrom bei degenerativer WS-Veränderung",
    "synonyms": [
      "Chronisches HWS-BWS-Syndrom bei degenerativer WS-Veränderung",
      "Zervikodorsalgie bei HWS- und BWS-Degeneration"
    ]
  },
  {
    "code": "M47.24",
    "name": "Degeneratives BWS-Syndrom",
    "synonyms": [
      "Degeneratives BWS-Syndrom",
      "Facettenreizung der BWS"
    ]
  },
  {
    "code": "M47.25",
    "name": "Degeneratives BWS-LWS-Syndrom",
    "synonyms": [
      "Degeneratives BWS-LWS-Syndrom"
    ]
  },
  {
    "code": "M47.26",
    "name": "Degeneratives Lumbalsyndrom",
    "synonyms": [
      "Chronisch-degeneratives LWS-Syndrom",
      "Chronisch-degeneratives Lumbalsyndrom",
      "Chronisches LWS-Syndrom bei degenerativer LWS-Veränderung",
      "Chronisches lumbales Facettensyndrom",
      "Degeneratives LWS-Syndrom",
      "Degeneratives Lumbalsyndrom",
      "Degeneratives lumbales Facettensyndrom",
      "Degeneratives pseudoradikuläres LWS-Syndrom",
      "Facettenreizung im LWS-Bereich",
      "LWS-Facettenreizung",
      "LWS-Syndrom bei degenerativer Veränderung",
      "Lumbales Facettensyndrom"
    ]
  },
  {
    "code": "M47.27",
    "name": "Chronisches Facettensyndrom L5/S1",
    "synonyms": [
      "Akutes lumbosakrales Facettensyndrom",
      "Chronisches Facettensyndrom L5/S1",
      "Lumbosakrales Facettensyndrom",
      "Lumbosakrales Facettensyndrom mit Blockierung"
    ]
  },
  {
    "code": "M47.29",
    "name": "Facettensyndrom",
    "synonyms": [
      "Facettensyndrom",
      "Spondylose mit Radikulopathie"
    ]
  },
  {
    "code": "M47.80",
    "name": "Spondylose von HWS und LWS",
    "synonyms": [
      "Spondylose von HWS und LWS",
      "Spondylose von HWS, BWS und LWS"
    ]
  },
  {
    "code": "M47.81",
    "name": "Axisarthrose",
    "synonyms": [
      "Axisarthrose"
    ]
  },
  {
    "code": "M47.82",
    "name": "Arthrose der Halswirbelsäule",
    "synonyms": [
      "Arthrose der Halswirbelsäule",
      "Degeneration der Halswirbelsäule",
      "Degenerative HWS-Veränderung",
      "Facettenarthrose der HWS",
      "Foraminaeinengung im HWS-Bereich",
      "HWS-Arthrose",
      "HWS-Spondylarthrose",
      "Massive Unkarthrose der Halswirbelsäule",
      "Spondylarthrose der Halswirbelsäule",
      "Spondylose der HWS",
      "Spondylose der Halswirbelsäule",
      "Spondylosis deformans der HWS",
      "Spondylosis deformans der Halswirbelsäule",
      "Spondylosis uncovertebralis",
      "Steilstellung der Halswirbelsäule mit Unkarthrose",
      "Unkarthrose",
      "Unkarthrose der Halswirbelsäule",
      "Unkarthrose mit Spondylarthrose der HWS",
      "Zervikale Spondylose"
    ]
  },
  {
    "code": "M47.83",
    "name": "Spondylose von HWS und BWS",
    "synonyms": [
      "Spondylose von HWS und BWS"
    ]
  },
  {
    "code": "M47.84",
    "name": "BWS-Syndrom bei verklammernder Spondylosis deformans",
    "synonyms": [
      "BWS-Syndrom bei verklammernder Spondylosis deformans",
      "Degenerative BWS-Veränderung",
      "Degenerative Brustwirbelsäulenveränderung",
      "Spondylarthrose der BWS",
      "Spondylarthrose der Brustwirbelsäule",
      "Spondylose der BWS",
      "Spondylose der Brustwirbelsäule",
      "Spondylosis deformans der BWS",
      "Spondylosis deformans der Brustwirbelsäule",
      "Starke Unkarthrose im Schulterbereich",
      "Thorakale Spondylose"
    ]
  },
  {
    "code": "M47.85",
    "name": "Spondylose von BWS und LWS",
    "synonyms": [
      "Spondylose von BWS und LWS"
    ]
  },
  {
    "code": "M47.86",
    "name": "Degenerative LWS-Veränderung",
    "synonyms": [
      "Arthrose der Lendenwirbelsäule",
      "Degenerative LWS-Veränderung",
      "Lumbale Spondylose",
      "Spondylarthrose der LWS",
      "Spondylarthrose der Lendenwirbelsäule",
      "Spondylose der LWS",
      "Spondylose der Lendenwirbelsäule",
      "Spondylosis deformans der Lendenwirbelsäule"
    ]
  },
  {
    "code": "M47.87",
    "name": "Lumbosakrale Facettenarthrose",
    "synonyms": [
      "Lumbosakrale Facettenarthrose",
      "Lumbosakrale Spondylose"
    ]
  },
  {
    "code": "M47.88",
    "name": "Spondylarthrose in der Sakralgegend",
    "synonyms": [
      "Kokzygeale Spondylose",
      "Sakrale Spondylose",
      "Sakrokokzygeale Spondylose",
      "Spondylarthrose in der Sakralgegend"
    ]
  },
  {
    "code": "M47.89",
    "name": "Intervertebralarthrose",
    "synonyms": [
      "Arthrosis uncovertebralis",
      "Intervertebralarthrose",
      "Unkovertebralarthrose"
    ]
  },
  {
    "code": "M47.99",
    "name": "Degenerative Veränderung der Wirbelsäule",
    "synonyms": [
      "Altersspondylitis",
      "Arthrose der kleinen Wirbelgelenke",
      "Chronische Spondylitis deformans",
      "Deformierende Spondylose",
      "Degeneration der Gelenkflächen der Wirbelsäule",
      "Degenerative Veränderung der Wirbelsäule",
      "Degenerative Wirbelkörperveränderung",
      "Degenerative Wirbelsäulenbeschwerden",
      "Degenerative Wirbelsäulenerkrankung",
      "Degeneratives Facettensyndrom",
      "Degeneratives Wirbelsäulenleiden",
      "Degeneratives Wirbelsäulensyndrom",
      "Hypertrophische Spondylopathie",
      "Osteophyt am Facettengelenk",
      "Spondylarthrose",
      "Spondylarthrosis",
      "Spondylarthrosis deformans",
      "Spondylopathia deformans",
      "Spondylose",
      "Spondylosis",
      "Spondylosis deformans",
      "Wirbelgelenkarthrose",
      "Wirbelsäulenarthrose",
      "Wirbelsäulendegeneration",
      "Wirbelsäulenosteoarthrose"
    ]
  },
  {
    "code": "M48.02",
    "name": "Zervikale Spinalstenose",
    "synonyms": [
      "Angeborene zervikale Spinalkanalstenose",
      "Zervikale Spinalkanalstenose",
      "Zervikale Spinalstenose"
    ]
  },
  {
    "code": "M48.06",
    "name": "Lumbale Markraumstenose",
    "synonyms": [
      "Lumbale Markraumstenose",
      "Lumbale Spinalkanalstenose",
      "Lumbale Spinalstenose"
    ]
  },
  {
    "code": "M48.08",
    "name": "Kaudastenose",
    "synonyms": [
      "Kaudastenose",
      "Spinalkanalstenose im Sakralbereich"
    ]
  },
  {
    "code": "M48.09",
    "name": "Spinalstenose",
    "synonyms": [
      "Degenerative Spinalkanalstenose",
      "Spinalkanalstenose",
      "Spinalstenose"
    ]
  },
  {
    "code": "M48.19",
    "name": "Spondylitis hyperostotica [Forestier-Ott-Syndrom]",
    "synonyms": [
      "Ankylosierende Hyperostose der Wirbelsäule",
      "Ankylosierende vertebrale Hyperostose mit Tylosis",
      "Diffuse idiopathische Skeletthyperostose",
      "Forestier-Ott-Krankheit",
      "Hyperostosis ankylosans vertebralis senilis [Forestier-Syndrom]",
      "Spondylitis hyperostotica [Forestier-Ott-Syndrom]"
    ]
  },
  {
    "code": "M48.29",
    "name": "Baastrup-Syndrom",
    "synonyms": [
      "Baastrup-Syndrom",
      "Kissing spine",
      "Morbus Baastrup"
    ]
  },
  {
    "code": "M48.39",
    "name": "Traumatische Spondylopathie",
    "synonyms": [
      "Chronische traumatische Spondylitis",
      "Kümmell-Krankheit",
      "Kümmell-Spondylitis",
      "Kümmell-Syndrom",
      "Kümmell-Verneuil-Krankheit",
      "Kümmell-Verneuil-Syndrom",
      "Posttraumatische Spondylitis",
      "Traumatische Spondylopathie",
      "Traumatische Spondylose",
      "Traumatische Wirbelsäulenarthritis"
    ]
  },
  {
    "code": "M48.49",
    "name": "Ermüdungsbruch eines Wirbels",
    "synonyms": [
      "Ermüdungsbruch eines Wirbels",
      "Ermüdungsfraktur eines Wirbels",
      "Stressfraktur eines Wirbels"
    ]
  },
  {
    "code": "M48.59",
    "name": "Keilwirbel a.n.k.",
    "synonyms": [
      "Keilwirbel a.n.k.",
      "Vertebraler Kollaps a.n.k.",
      "Wirbelkörperkompression a.n.k.",
      "Wirbelkörpersinterung"
    ]
  },
  {
    "code": "M48.89",
    "name": "Vertebrale Atrophie",
    "synonyms": [
      "OPLL [Ossification of Posterior Longitudinal Ligament]-Syndrom",
      "Ossifikation des Ligamentum longitudinale posterius",
      "Vertebrale Atrophie",
      "Wirbelatrophie"
    ]
  },
  {
    "code": "M48.99",
    "name": "Spondylopathie",
    "synonyms": [
      "Spondylopathia",
      "Spondylopathie"
    ]
  },
  {
    "code": "M50.2",
    "name": "Zervikale Bandscheibenprotrusion",
    "synonyms": [
      "Zervikale Bandscheibenprotrusion",
      "Zervikale Nucleus-pulposus-Hernie",
      "Zervikaler Bandscheibenprolaps",
      "Zervikaler Bandscheibenvorfall",
      "Zervikaler Diskusprolaps",
      "Zervikaler Nucleus-pulposus-Prolaps",
      "Zervikothorakale Nucleus-pulposus-Hernie"
    ]
  },
  {
    "code": "M50.3",
    "name": "Chondrosis intervertebralis cervicalis [Zervikalchondrose]",
    "synonyms": [
      "Chondrosis intervertebralis cervicalis [Zervikalchondrose]",
      "Zervikalchondrose [Chondrosis intervertebralis cervicalis]",
      "Zervikale Bandscheibendegeneration a.n.k.",
      "Zervikothorakale Bandscheibendegeneration a.n.k."
    ]
  },
  {
    "code": "M50.9",
    "name": "Zervikaler Bandscheibenschaden",
    "synonyms": [
      "Bandscheibenschaden der HWS",
      "Zervikaler Bandscheibenschaden",
      "Zervikothorakaler Bandscheibenschaden"
    ]
  },
  {
    "code": "M51.2",
    "name": "Lumbosakrale Bandscheibenprotrusion",
    "synonyms": [
      "BSP [Bandscheibenprolaps] - s.a. Bandscheibenprolaps",
      "BSV [Bandscheibenvorfall]",
      "Bandscheibenhernie",
      "Bandscheibenprolaps",
      "Bandscheibenprotrusion",
      "Bandscheibenverlagerung",
      "Bandscheibenvorfall",
      "Chronische Lumboischialgie bei Diskusprolaps",
      "Diskushernie",
      "Diskusprolaps",
      "Extraforaminale Bandscheibenverlagerung",
      "Hexenschuss durch Bandscheibenverlagerung",
      "Lumbago durch Bandscheibenprolaps",
      "Lumbago durch Bandscheibenverlagerung",
      "Lumbale Bandscheibenprotrusion",
      "Lumbale Nucleus-pulposus-Hernie",
      "Lumbaler BSV [Bandscheibenvorfall]",
      "Lumbaler Bandscheibenprolaps",
      "Lumbaler Bandscheibenvorfall",
      "Lumbaler Diskusprolaps",
      "Lumbaler NPP [Nucleus-pulposus-Prolaps]",
      "Lumbaler Nucleus-pulposus-Prolaps",
      "Lumbalgie durch Bandscheibenverlagerung",
      "Lumbosakrale Bandscheibenprotrusion",
      "Lumbosakraler Bandscheibenprolaps",
      "Lumbosakraler Bandscheibenvorfall",
      "Lumbosakraler Nucleus-pulposus-Prolaps",
      "NPP [Nucleus-pulposus-Prolaps]",
      "Nucleus-pulposus-Hernie a.n.k.",
      "Nucleus-pulposus-Prolaps",
      "Prolaps der Zwischenwirbelscheibe",
      "Thorakale Nucleus-pulposus-Hernie",
      "Thorakaler Bandscheibenvorfall",
      "Thorakaler Diskusprolaps",
      "Thorakolumbale Nucleus-pulposus-Hernie",
      "Thorakolumbaler Diskusprolaps"
    ]
  },
  {
    "code": "M51.3",
    "name": "Chondrosis intervertebralis",
    "synonyms": [
      "Bandscheibendegeneration a.n.k.",
      "Chondrosis intervertebralis",
      "Lumbale Bandscheibendegeneration a.n.k.",
      "Lumbosakrale Bandscheibendegeneration a.n.k.",
      "Thorakale Bandscheibendegeneration a.n.k.",
      "Thorakolumbale Bandscheibendegeneration a.n.k."
    ]
  },
  {
    "code": "M51.4",
    "name": "Schmorl-Knötchen",
    "synonyms": [
      "Intraspongiöse Hernie",
      "Intraspongiöser Diskusprolaps",
      "Schmorl-Knorpelknötchen",
      "Schmorl-Knötchen"
    ]
  },
  {
    "code": "M51.8",
    "name": "Bandscheibeneinriss",
    "synonyms": [
      "Bandscheibeneinriss",
      "Erworbene Bandscheibendeformität",
      "Postinfektiöse Bandscheibenkalzifikation"
    ]
  },
  {
    "code": "M51.9",
    "name": "Bandscheibenschaden",
    "synonyms": [
      "Bandscheibenkrankheit",
      "Bandscheibenschaden",
      "Bandscheibenschaden der LWS",
      "Bandscheibenveränderung",
      "Diskopathie",
      "Lumbale Diskopathie",
      "Lumbaler Bandscheibenschaden",
      "Lumbosakrale Diskopathie",
      "Lumbosakraler Bandscheibenschaden",
      "Thorakaler Bandscheibenschaden",
      "Thorakolumbaler Bandscheibenschaden"
    ]
  },
  {
    "code": "M53.0",
    "name": "Zervikozephales Syndrom",
    "synonyms": [
      "Akute Zervikozephalgie",
      "Barré-Liéou-Syndrom",
      "Cervicocephalgia - s.a. Zervikozephalgie",
      "Chronische Zervikozephalgie",
      "Kraniovertebrales Syndrom",
      "Okzipitozervikales Syndrom",
      "Sympathisches hinteres Zervikalsyndrom",
      "Zephales Zervikalsyndrom",
      "Zervikokranielles Syndrom",
      "Zervikozephales Syndrom",
      "Zervikozephalgie",
      "Zervikozephalgie bei Blockierung"
    ]
  },
  {
    "code": "M53.1",
    "name": "Akute Zervikobrachialgie",
    "synonyms": [
      "Akute Zervikobrachialgie",
      "Cervicobrachialgia - s.a. Zervikobrachialgie",
      "Chronische Zervikobrachialgie",
      "Chronisches HWS-Syndrom mit Brachialgie",
      "HWS-Blockierung mit Zervikobrachialgie",
      "Zephalo-brachiales Schmerzsyndrom",
      "Zervikobrachiale Schmerzen",
      "Zervikobrachialgie",
      "Zervikobrachialgie bei Blockierung",
      "Zervikobrachialsyndrom",
      "Zervikozephalobrachialgie"
    ]
  },
  {
    "code": "M53.26",
    "name": "Instabilität der LWS",
    "synonyms": [
      "Instabilität der LWS",
      "Lockerung der LWS",
      "Wirbelsäuleninstabilität im Lumbalbereich"
    ]
  },
  {
    "code": "M53.27",
    "name": "Lumbosakrale Insuffizienz",
    "synonyms": [
      "Lumbosakrale Instabilität",
      "Lumbosakrale Insuffizienz",
      "Relaxation des Lumbosakralgelenks"
    ]
  },
  {
    "code": "M53.28",
    "name": "Sakrolisthesis",
    "synonyms": [
      "Alte Iliosakralgelenkverlagerung",
      "Alte Kreuzbeindistorsion",
      "Alte iliosakrale Distorsion",
      "Angeborene Iliosakralgelenkverschiebung",
      "Chronische Kreuzbeindistorsion",
      "Chronische iliosakrale Distorsion",
      "Gleiten des Iliosakralgelenks",
      "Habituelle Dislokation der Articulatio sacroiliaca",
      "Habituelle iliosakrale Dislokation",
      "Lockerung des Iliosakralgelenks",
      "Lockerung des Sakroiliakalgelenks",
      "Posttraumatische iliosakrale Gelenkinstabilität",
      "Relaxation des Iliosakralgelenks",
      "Sakrolisthesis",
      "Steißbeinhypermobilität"
    ]
  },
  {
    "code": "M53.29",
    "name": "Wirbelsäuleninstabilität",
    "synonyms": [
      "Lockerung der Wirbelsäule",
      "Pathologische Wirbelsäulendislokation a.n.k.",
      "Relaxation des Bandapparates des Rückens",
      "Wirbelsäuleninstabilität"
    ]
  },
  {
    "code": "M53.3",
    "name": "Iliosakralgelenkkrankheit a.n.k.",
    "synonyms": [
      "Affektion des Iliosakralgelenks a.n.k.",
      "Coccygodynia - s.a. Kokzygodynie",
      "Iliosakralgelenkkrankheit a.n.k.",
      "Iliosakralgelenkschädigung",
      "Iliosakralschmerzen",
      "Kokzygodynie",
      "Kreuzbeinstörung a.n.k.",
      "Nichttraumatische Iliosakralgelenkschädigung",
      "Sakralgie",
      "Sakrodynie",
      "Sakroiliakalgelenkschädigung",
      "Schmerzen in der Steißbeingegend",
      "Schädigung der Kreuzbeingegend",
      "Steißbeinschmerzen",
      "Steißbeinstörung a.n.k."
    ]
  },
  {
    "code": "M53.82",
    "name": "Steilstellung der Halswirbelsäule",
    "synonyms": [
      "Steilstellung der Halswirbelsäule",
      "Steilstellung der Halswirbelsäule mit Blockierung",
      "Störung der Zervikalregion a.n.k.",
      "Störung im Nackenbereich a.n.k."
    ]
  },
  {
    "code": "M53.84",
    "name": "Steilstellung der Brustwirbelsäule",
    "synonyms": [
      "Steilstellung der Brustwirbelsäule"
    ]
  },
  {
    "code": "M53.86",
    "name": "Steilstellung der Lendenwirbelsäule",
    "synonyms": [
      "Steilstellung der Lendenwirbelsäule"
    ]
  },
  {
    "code": "M53.89",
    "name": "Rigidität der Wirbelsäule",
    "synonyms": [
      "Rigidität der Wirbelsäule",
      "Wirbelgelenksteifheit"
    ]
  },
  {
    "code": "M53.97",
    "name": "Lumbosakrale Übergangstörung",
    "synonyms": [
      "Krankheit der Lumbosakralregion",
      "Lumbosakrale Übergangstörung"
    ]
  },
  {
    "code": "M53.99",
    "name": "Segmentbezogene Wirbelsäulenstörung",
    "synonyms": [
      "Chronisches Wirbelsäulensyndrom",
      "Dorsopathie",
      "Massiver Wirbelsäulenverschleiß",
      "Rückenkrankheit",
      "Rückenleiden",
      "Segmentbezogene Wirbelsäulenstörung",
      "WS-Syndrom",
      "Wirbelsäulenkrankheit",
      "Wirbelsäulenstörung",
      "Wirbelsäulensyndrom"
    ]
  },
  {
    "code": "M54.02",
    "name": "Pannikulitis der Nackenregion",
    "synonyms": [
      "Pannikulitis der Nackenregion"
    ]
  },
  {
    "code": "M54.08",
    "name": "Pannikulitis der Kreuzbeingegend",
    "synonyms": [
      "Pannikulitis der Kreuzbeingegend"
    ]
  },
  {
    "code": "M54.09",
    "name": "Pannikulitis der Rückenregion",
    "synonyms": [
      "Pannikulitis der Rückenregion"
    ]
  },
  {
    "code": "M54.10",
    "name": "HWS-BWS-LWS-Syndrom",
    "synonyms": [
      "Chronisches HWS-BWS-LWS-Syndrom",
      "Chronisches HWS-LWS-Syndrom",
      "HWS-BWS-LWS-Syndrom",
      "HWS-LWS-Syndrom",
      "Zervikobrachiolumbalgie",
      "Zervikolumbalsyndrom"
    ]
  },
  {
    "code": "M54.12",
    "name": "Brachiale Radikulitis a.n.k.",
    "synonyms": [
      "Brachiale Neuritis",
      "Brachiale Radikulitis a.n.k.",
      "Brachiale radikuläre Neuropathie",
      "HWS-Schulter-Syndrom",
      "Nacken-Schulter-Arm-Syndrom",
      "Neuritis des Plexus brachialis",
      "Schulter-Arm-Syndrom",
      "Zervikale Neuritis a.n.k.",
      "Zervikale Radikulitis a.n.k.",
      "Zervikale radikuläre Neuropathie a.n.k."
    ]
  },
  {
    "code": "M54.13",
    "name": "HWS-BWS-Syndrom mit Blockierung",
    "synonyms": [
      "HWS-BWS-Syndrom mit Blockierung",
      "Zervikothorakalsyndrom"
    ]
  },
  {
    "code": "M54.14",
    "name": "Thorakalsyndrom",
    "synonyms": [
      "Akutes BWS-Syndrom",
      "BWS-Syndrom",
      "Brustwirbelsäulensyndrom",
      "Chronisches BWS-Syndrom",
      "Radikulopathie im Thorakalbereich",
      "Thorakale Neuritis a.n.k.",
      "Thorakale Radikulitis a.n.k.",
      "Thorakale radikuläre Neuropathie a.n.k.",
      "Thorakalsyndrom"
    ]
  },
  {
    "code": "M54.15",
    "name": "BWS-LWS-Syndrom",
    "synonyms": [
      "BWS-LWS-Syndrom",
      "Thorakolumbalgie",
      "Thorakolumbalsyndrom"
    ]
  },
  {
    "code": "M54.16",
    "name": "LWS-Syndrom",
    "synonyms": [
      "Akutes LWS-Syndrom",
      "Akutes LWS-Syndrom mit Iliosakralgelenkblockierung",
      "Akutes Lumbalsyndrom",
      "Chronisch-rezidivierendes Lumbalsyndrom",
      "Chronisches LWS-Syndrom",
      "Chronisches Lumbalsyndrom",
      "Chronisches pseudoradikuläres Lumbalsyndrom",
      "L5-Syndrom",
      "LWS-Kompressionssyndrom",
      "LWS-Syndrom",
      "Lendenwirbelsäulensyndrom",
      "Lumbale Neuritis",
      "Lumbale Radikulitis a.n.k.",
      "Lumbale Wurzelreizung",
      "Lumbale radikuläre Neuropathie",
      "Lumbales Radikulärsyndrom",
      "Lumbales Vertebralsyndrom",
      "Lumbales Wurzelkompressionssyndrom",
      "Lumbales Wurzelreizsyndrom",
      "Pseudoradikuläres Lumbalsyndrom",
      "Wurzelreizung im LWS-Bereich"
    ]
  },
  {
    "code": "M54.17",
    "name": "Iliosakralfugensyndrom",
    "synonyms": [
      "ISG-Syndrom [Iliosakralgelenksyndrom]",
      "Iliolumbales Syndrom",
      "Iliosakralfugensyndrom",
      "Iliosakralgelenksyndrom [ISG-Syndrom]",
      "LWS-Syndrom bei Sakralisation",
      "Lumbosakrale Neuritis",
      "Lumbosakrale Radikulitis a.n.k.",
      "Lumbosakrale radikuläre Neuropathie",
      "Lumbosakrales Wurzelreizsyndrom",
      "Neuralgie des Plexus lumbosacralis"
    ]
  },
  {
    "code": "M54.18",
    "name": "S1-Syndrom",
    "synonyms": [
      "S1-Syndrom",
      "Sakrale Wurzelkompression",
      "Sakrale Wurzelreizung",
      "Sakrales Wurzelreizsyndrom"
    ]
  },
  {
    "code": "M54.19",
    "name": "Radikulitis",
    "synonyms": [
      "Interspinalesneuralgie",
      "Interspinalesreizung",
      "Kompressionsradikulitis",
      "Nervenwurzelneuralgie",
      "Nervenwurzelneuritis",
      "Neuritis der Wurzel des Nervus spinalis",
      "Radikulitis",
      "Radikuloneuritis",
      "Radikulopathie",
      "Radikuläre Neuropathie a.n.k.",
      "Radikulärsyndrom a.n.k.",
      "Spinale Wurzelschmerzen",
      "Spinale radikuläre Schmerzen",
      "Spinalnervenneuritis",
      "Vertebragene Radikulitis",
      "Wurzelkompressionssyndrom",
      "Wurzelneuritis - s.a. Radikulitis",
      "Wurzelreizsyndrom",
      "Wurzelsyndrom a.n.k."
    ]
  },
  {
    "code": "M54.2",
    "name": "Vertebragene Kopfschmerzen",
    "synonyms": [
      "Akute Zervikalgie",
      "Akutes HWS-Syndrom",
      "Akutes HWS-Syndrom mit Blockierung der BWS",
      "Akutes Zervikalsyndrom",
      "Akutes rezidivierendes Zervikalsyndrom",
      "C7-Syndrom",
      "C8-Syndrom",
      "Cervicalgia - s.a. Zervikalgie",
      "Cervicalsyndrom - s.a. Zervikalsyndrom",
      "Chronische Zervikalgie",
      "Chronisches HWS-Syndrom",
      "Chronisches Zervikalsyndrom",
      "HWS-Schmerzen",
      "HWS-Syndrom",
      "HWS-Syndrom mit Blockierung",
      "Halswirbelsäulensyndrom",
      "Muskulotendinöses HWS-Syndrom",
      "Muskuläres HWS-Syndrom",
      "Nackenschmerzen a.n.k.",
      "Pseudoradikuläres Zervikalsyndrom",
      "Schmerzen im Halswirbelsäulenbereich",
      "Sensibles C6-C8-Syndrom",
      "Sensibles C6-Syndrom",
      "Vertebragene Kopfschmerzen",
      "Wirbelsäulenschmerzen der HWS",
      "Wurzelreizung im HWS-Bereich",
      "Zervikago",
      "Zervikale Wurzelreizung",
      "Zervikales Schmerzsyndrom",
      "Zervikales Wurzelreizsyndrom",
      "Zervikales Wurzelsyndrom",
      "Zervikalgie",
      "Zervikalneuralgie",
      "Zervikalsyndrom",
      "Zervikogene Kopfschmerzen"
    ]
  },
  {
    "code": "M54.3",
    "name": "Ischialgie",
    "synonyms": [
      "Akute Ischialgie",
      "Akute Ischialgie mit Wurzelirritation",
      "Infektiöse Ischialgie",
      "Ischialgie",
      "Ischias",
      "Ischiasschmerzen",
      "Neuritis des Nervus ischiadicus",
      "S1-Ischialgie"
    ]
  },
  {
    "code": "M54.4",
    "name": "Lumboischialgie",
    "synonyms": [
      "Akute Lumboischialgie",
      "Chronische Lumboischialgie",
      "Ischialgie mit Lumbago",
      "Ischialgie mit Lumbalgie",
      "Lumboischialgie",
      "Lumboischialgie mit Blockierung"
    ]
  },
  {
    "code": "M54.5",
    "name": "Akute Lumbago",
    "synonyms": [
      "Akute Dorsolumbalgie",
      "Akute Kreuzbeinschmerzen",
      "Akute Lumbago",
      "Akute Lumbalgie",
      "Akute Lumbalgie bei Blockierung",
      "Akute Lumbalgie mit Facettenreizung",
      "Akute rezidivierende Lumbalgie",
      "Chronisch-rezidivierende Lumbalgie",
      "Chronische Dorsolumbalgie",
      "Chronische Lumbago",
      "Chronische Lumbalgie",
      "Dorsolumbalgie",
      "Hexenschuss",
      "Iliosakralgelenkschmerzen",
      "Kreuzschmerzen",
      "Lendenschmerzen",
      "Lumbago",
      "Lumbale Rückenschmerzen",
      "Lumbales vertebragenes lokales Schmerzsyndrom",
      "Lumbalgie",
      "Lumbalgie bei Iliosakralgelenkirritation",
      "Lumbalgie mit Facettenreizung",
      "Lumbosakralgie",
      "Myofasziitis der Lumbalregion",
      "Reaktive Dorsolumbalgie",
      "Rezidivierende Dorsolumbalgie",
      "Sakroiliakalgelenkschmerzen",
      "Schmerzen in der Lendengegend",
      "Schmerzen in der Lumbalregion",
      "Statische Lumbalgie",
      "Überlastung der Kreuzbeingegend"
    ]
  },
  {
    "code": "M54.6",
    "name": "Wirbelsäulenschmerzen der BWS",
    "synonyms": [
      "Interskapulago",
      "Schmerzen der Brustwirbelsäule",
      "Sternoklavikularsyndrom",
      "Sternokostalsyndrom",
      "Wirbelsäulenschmerzen der BWS"
    ]
  },
  {
    "code": "M54.89",
    "name": "Rückenneuralgie",
    "synonyms": [
      "Rückenneuralgie",
      "Vertebragene Schmerzen",
      "Vertebragenes Schmerzsyndrom",
      "Vertebralsyndrom"
    ]
  },
  {
    "code": "M54.99",
    "name": "Chronische Rückenschmerzen",
    "synonyms": [
      "Akute Dorsalgie",
      "Akute rezidivierende Dorsalgie",
      "Chronische Dorsalgie",
      "Chronische Rückenschmerzen",
      "Dorsago",
      "Dorsalgie",
      "Dorsalgie bei Blockierung",
      "Haltungsabhängige Rückenschmerzen",
      "Rezidivierende Dorsalgie",
      "Rückenschmerzen",
      "Wirbelsäulenschmerzen"
    ]
  },
  {
    "code": "M60.00",
    "name": "Pyomyositis an mehreren Lokalisationen",
    "synonyms": [
      "Bakterielle Myositis an mehreren Lokalisationen",
      "Fungale Myositis an mehreren Lokalisationen",
      "Pyomyositis an mehreren Lokalisationen",
      "Virale Myositis an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M60.01",
    "name": "Pyomyositis in der Schulterregion",
    "synonyms": [
      "Bakterielle Myositis in der Schulterregion",
      "Fungale Myositis in der Schulterregion",
      "Pyomyositis in der Schulterregion",
      "Virale Myositis in der Schulterregion"
    ]
  },
  {
    "code": "M60.02",
    "name": "Pyomyositis am Oberarm",
    "synonyms": [
      "Bakterielle Myositis am Oberarm",
      "Fungale Myositis am Oberarm",
      "Pyomyositis am Oberarm",
      "Virale Myositis am Oberarm"
    ]
  },
  {
    "code": "M60.03",
    "name": "Pyomyositis am Unterarm",
    "synonyms": [
      "Bakterielle Myositis am Unterarm",
      "Fungale Myositis am Unterarm",
      "Pyomyositis am Unterarm",
      "Virale Myositis am Unterarm"
    ]
  },
  {
    "code": "M60.04",
    "name": "Pyomyositis an der Hand",
    "synonyms": [
      "Bakterielle Myositis an der Hand",
      "Fungale Myositis an der Hand",
      "Pyomyositis an der Hand",
      "Virale Myositis an der Hand"
    ]
  },
  {
    "code": "M60.05",
    "name": "Psoasphlegmone",
    "synonyms": [
      "Abszess des Musculus iliopsoas",
      "Bakterielle Myositis am Oberschenkel",
      "Bakterielle Myositis in der Beckenregion",
      "Fungale Myositis am Oberschenkel",
      "Fungale Myositis in der Beckenregion",
      "Nichttuberkulöser Iliopsoasabszess",
      "Nichttuberkulöser Psoasabszess",
      "Psoasabszess",
      "Psoasphlegmone",
      "Pyomyositis am Oberschenkel",
      "Pyomyositis in der Beckenregion",
      "Virale Myositis am Oberschenkel",
      "Virale Myositis in der Beckenregion"
    ]
  },
  {
    "code": "M60.06",
    "name": "Pyomyositis am Unterschenkel",
    "synonyms": [
      "Bakterielle Myositis am Unterschenkel",
      "Fungale Myositis am Unterschenkel",
      "Pyomyositis am Unterschenkel",
      "Virale Myositis am Unterschenkel"
    ]
  },
  {
    "code": "M60.07",
    "name": "Pyomyositis am Fuß",
    "synonyms": [
      "Bakterielle Myositis am Fuß",
      "Fungale Myositis am Fuß",
      "Pyomyositis am Fuß",
      "Virale Myositis am Fuß"
    ]
  },
  {
    "code": "M60.08",
    "name": "Pyomyositis am Rumpf",
    "synonyms": [
      "Bakterielle Myositis am Rumpf",
      "Fungale Myositis am Rumpf",
      "Pyomyositis am Rumpf",
      "Virale Myositis am Rumpf"
    ]
  },
  {
    "code": "M60.09",
    "name": "Infektiöse Myositis",
    "synonyms": [
      "Bakterielle Myositis",
      "Eitrige Myositis",
      "Fungale Myositis",
      "Infektiöse Myositis",
      "Muskelabszess",
      "Muskeleiterung",
      "Muskelinfektion a.n.k.",
      "Myositis purulenta",
      "Myositis purulenta tropica",
      "Myositis tropicans",
      "Myositis universalis acuta infectiosa",
      "Pyomyositis",
      "Tropische Pyomyositis",
      "Virale Myositis",
      "Virusmyositis"
    ]
  },
  {
    "code": "M60.19",
    "name": "Interstitielle Myositis",
    "synonyms": [
      "Interstitielle Myositis"
    ]
  },
  {
    "code": "M60.29",
    "name": "Granulom durch Talkum",
    "synonyms": [
      "Fremdkörpergranulom im Weichteilgewebe a.n.k.",
      "Granulom durch Talkum",
      "Reaktion auf Fremdsubstanz a.n.k."
    ]
  },
  {
    "code": "M60.80",
    "name": "Idiopathische eosinophile Myositis an mehreren Lokalisationen",
    "synonyms": [
      "Idiopathische eosinophile Myositis an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M60.81",
    "name": "Makrophagische Myofasziitis in der Schulterregion",
    "synonyms": [
      "Makrophagische Myofasziitis in der Schulterregion"
    ]
  },
  {
    "code": "M60.82",
    "name": "Idiopathische eosinophile Myositis am Oberarm",
    "synonyms": [
      "Idiopathische eosinophile Myositis am Oberarm"
    ]
  },
  {
    "code": "M60.83",
    "name": "Idiopathische eosinophile Myositis am Unterarm",
    "synonyms": [
      "Idiopathische eosinophile Myositis am Unterarm"
    ]
  },
  {
    "code": "M60.85",
    "name": "Psoasmyositis",
    "synonyms": [
      "Fokale Myositis am Oberschenkel",
      "Idiopathische eosinophile Myositis am Oberschenkel",
      "Psoasmyositis",
      "Psoitis"
    ]
  },
  {
    "code": "M60.86",
    "name": "Fokale Myositis am Unterschenkel",
    "synonyms": [
      "Fokale Myositis am Unterschenkel",
      "Idiopathische eosinophile Myositis am Unterschenkel"
    ]
  },
  {
    "code": "M60.88",
    "name": "Fokale Myositis am Kopf",
    "synonyms": [
      "Fokale Myositis am Kopf"
    ]
  },
  {
    "code": "M60.89",
    "name": "Neuromyositis",
    "synonyms": [
      "Alte traumatische Myositis",
      "Fokale Myositis",
      "Idiopathische eosinophile Myositis",
      "Makrophagische Myofasziitis",
      "Neuromyositis"
    ]
  },
  {
    "code": "M60.99",
    "name": "Myofasziitis",
    "synonyms": [
      "Akute Muskelentzündung",
      "Akute Myofasziitis",
      "Akute parenchymatöse Myositis",
      "Entzündliche Muskelkrankheit",
      "Muskelentzündung",
      "Myofasziitis",
      "Myositis"
    ]
  },
  {
    "code": "M61.09",
    "name": "Traumatische Myositis ossificans",
    "synonyms": [
      "Traumatische Myositis ossificans"
    ]
  },
  {
    "code": "M61.10",
    "name": "Polymyositis ossificans progressiva",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva an mehreren Lokalisationen",
      "Polymyositis ossificans generalisata",
      "Polymyositis ossificans progressiva"
    ]
  },
  {
    "code": "M61.11",
    "name": "Fibrodysplasia ossificans progressiva in der Schulterregion",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva in der Schulterregion"
    ]
  },
  {
    "code": "M61.12",
    "name": "Fibrodysplasia ossificans progressiva am Oberarm",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva am Oberarm"
    ]
  },
  {
    "code": "M61.13",
    "name": "Fibrodysplasia ossificans progressiva am Unterarm",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva am Unterarm"
    ]
  },
  {
    "code": "M61.14",
    "name": "Fibrodysplasia ossificans progressiva an der Hand",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva an der Hand"
    ]
  },
  {
    "code": "M61.15",
    "name": "Fibrodysplasia ossificans progressiva am Oberschenkel",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva am Oberschenkel"
    ]
  },
  {
    "code": "M61.16",
    "name": "Fibrodysplasia ossificans progressiva am Unterschenkel",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva am Unterschenkel"
    ]
  },
  {
    "code": "M61.17",
    "name": "Fibrodysplasia ossificans progressiva am Fuß",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva am Fuß"
    ]
  },
  {
    "code": "M61.18",
    "name": "Fibrodysplasia ossificans progressiva am Hals",
    "synonyms": [
      "Fibrodysplasia ossificans progressiva am Hals"
    ]
  },
  {
    "code": "M61.19",
    "name": "Myositis ossificans progressiva",
    "synonyms": [
      "FOP [Fibrodysplasia ossificans progressiva]",
      "Fibrodysplasia ossificans progressiva",
      "Myositis ossificans progressiva",
      "Münchmeyer-Krankheit",
      "Münchmeyer-Syndrom"
    ]
  },
  {
    "code": "M61.29",
    "name": "Muskelkalzifikation bei Lähmung",
    "synonyms": [
      "Muskelkalzifikation bei Lähmung",
      "Muskelossifikation bei Lähmung",
      "Myositis ossificans bei Paraplegie",
      "Myositis ossificans bei Tetraplegie",
      "Paralytische Muskelkalzifikation",
      "Paralytische Muskelossifikation"
    ]
  },
  {
    "code": "M61.39",
    "name": "Muskelkalzifikation bei Verbrennung",
    "synonyms": [
      "Muskelkalzifikation bei Verbrennung",
      "Muskelossifikation bei Verbrennung",
      "Myositis ossificans bei Verbrennung"
    ]
  },
  {
    "code": "M61.51",
    "name": "Progressive ossäre Heteroplasie in der Schulterregion",
    "synonyms": [
      "Progressive ossäre Heteroplasie in der Schulterregion"
    ]
  },
  {
    "code": "M61.52",
    "name": "Progressive ossäre Heteroplasie am Oberarm",
    "synonyms": [
      "Progressive ossäre Heteroplasie am Oberarm"
    ]
  },
  {
    "code": "M61.53",
    "name": "Progressive ossäre Heteroplasie am Unterarm",
    "synonyms": [
      "Progressive ossäre Heteroplasie am Unterarm"
    ]
  },
  {
    "code": "M61.54",
    "name": "Progressive ossäre Heteroplasie an der Hand",
    "synonyms": [
      "Progressive ossäre Heteroplasie an der Hand"
    ]
  },
  {
    "code": "M61.55",
    "name": "Progressive ossäre Heteroplasie am Oberschenkel",
    "synonyms": [
      "Progressive ossäre Heteroplasie am Oberschenkel"
    ]
  },
  {
    "code": "M61.56",
    "name": "Progressive ossäre Heteroplasie am Unterschenkel",
    "synonyms": [
      "Progressive ossäre Heteroplasie am Unterschenkel"
    ]
  },
  {
    "code": "M61.57",
    "name": "Progressive ossäre Heteroplasie am Fuß",
    "synonyms": [
      "Progressive ossäre Heteroplasie am Fuß"
    ]
  },
  {
    "code": "M61.58",
    "name": "Progressive ossäre Heteroplasie am Rumpf",
    "synonyms": [
      "Progressive ossäre Heteroplasie am Rumpf"
    ]
  },
  {
    "code": "M61.59",
    "name": "Myositis ossificans",
    "synonyms": [
      "Myopathia osteoplastica",
      "Myositis ossificans",
      "Myositis ossificans circumscripta",
      "Progressive ossäre Heteroplasie",
      "Reiterknochen-Ossifikation",
      "Reitknochen"
    ]
  },
  {
    "code": "M61.99",
    "name": "Muskelkalzifikation",
    "synonyms": [
      "Muskelkalzifikation",
      "Muskelossifikation"
    ]
  },
  {
    "code": "M62.08",
    "name": "Hängebauch bei Rektusdiastase",
    "synonyms": [
      "Hängebauch bei Rektusdiastase",
      "Rektusdiastase"
    ]
  },
  {
    "code": "M62.09",
    "name": "Muskeldiastase",
    "synonyms": [
      "Muskeldiastase",
      "Myodiastase"
    ]
  },
  {
    "code": "M62.19",
    "name": "Alter Muskelriss",
    "synonyms": [
      "Alter Muskelriss",
      "Nichttraumatische Muskelruptur",
      "Nichttraumatischer Muskelriss"
    ]
  },
  {
    "code": "M62.29",
    "name": "Ischämischer Muskelinfarkt",
    "synonyms": [
      "Ischämischer Muskelinfarkt",
      "Muskelischämie",
      "Nichttraumatisches Kompartmentsyndrom"
    ]
  },
  {
    "code": "M62.39",
    "name": "Immobilitätssyndrom",
    "synonyms": [
      "Immobilisationssyndrom",
      "Immobilitätssyndrom",
      "Paraplegisches Immobilisationssyndrom"
    ]
  },
  {
    "code": "M62.49",
    "name": "Muskelkontraktur",
    "synonyms": [
      "Muskelkontraktur",
      "Muskelnarbe mit Kontraktur",
      "Paralytische Muskelkontraktur",
      "Postinfektiöse Muskelkontraktur a.n.k.",
      "Posturale Muskelkontraktur a.n.k."
    ]
  },
  {
    "code": "M62.50",
    "name": "Generalisierte Muskelatrophie",
    "synonyms": [
      "Diffuse Muskelatrophie",
      "Generalisierte Muskelatrophie",
      "Muskelatrophie der Extremitäten"
    ]
  },
  {
    "code": "M62.59",
    "name": "Inaktivitätsatrophie a.n.k.",
    "synonyms": [
      "Atrophia musculorum",
      "Idiopathische Muskelatrophie",
      "Inaktivitätsatrophie a.n.k.",
      "Muskelatrophie",
      "Muskelschwund a.n.k.",
      "Myoatrophie",
      "Myopathische Atrophie a.n.k.",
      "Myositis fibrosa",
      "Primäre Muskelatrophie",
      "Sarkopenie"
    ]
  },
  {
    "code": "M62.69",
    "name": "Alte Muskelzerrung",
    "synonyms": [
      "Alte Muskelzerrung"
    ]
  },
  {
    "code": "M62.81",
    "name": "Myogelose der Schulter-Nacken-Muskulatur",
    "synonyms": [
      "Myogelose der Schulter-Nacken-Muskulatur",
      "Myogelose der Schulter-Nacken-Muskulatur mit Blockierung"
    ]
  },
  {
    "code": "M62.84",
    "name": "Defekt des Retinaculum extensorum",
    "synonyms": [
      "Defekt des Retinaculum extensorum"
    ]
  },
  {
    "code": "M62.85",
    "name": "Psoasblutung",
    "synonyms": [
      "Iliakushartspann",
      "Kontraktur der Fascia lata",
      "Psoasblutung",
      "Psoashartspann"
    ]
  },
  {
    "code": "M62.88",
    "name": "Myogelose im Wirbelsäulenbereich",
    "synonyms": [
      "BWS-Myogelose",
      "HWS-Myogelose",
      "LWS-Myogelose",
      "Myogelose der Rückenstrecker",
      "Myogelose der Wirbelsäule",
      "Myogelose im BWS-Bereich",
      "Myogelose im HWS-Bereich",
      "Myogelose im LWS-Bereich",
      "Myogelose im Wirbelsäulenbereich",
      "Paravertebrale Muskelverspannung"
    ]
  },
  {
    "code": "M62.89",
    "name": "Hartspann",
    "synonyms": [
      "Amyotonia",
      "Amyotonie",
      "Erworbene Muskeldeformität",
      "Faszienhernie",
      "Faszienkalzifikation",
      "Faszienkontraktur",
      "Faszienossifikation",
      "Fettige Muskeldegeneration",
      "Fettige Muskelinfiltration",
      "Fibrilläre Muskelzuckungen",
      "Fibröse Muskeldegeneration",
      "Hartspann",
      "Hyaline Muskeldegeneration",
      "Hämorrhagie der Muskeln",
      "Idiopathische Rhabdomyolyse",
      "Intermittierende Myotonie",
      "Muskelatonie",
      "Muskelblutung",
      "Muskelhernie",
      "Muskelhypertrophie",
      "Muskelhärte",
      "Muskelnarbe",
      "Muskelschwäche",
      "Muskelzerfall",
      "Myofibrose",
      "Myofibrosis",
      "Myogelose",
      "Myolyse",
      "Myomalacia",
      "Myomalazie",
      "Myostatin-assoziierte Muskelhypertrophie",
      "Myotonia",
      "Myotonia acquisita",
      "Myotonie",
      "Nichttraumatisches Muskelhämatom",
      "Progressive Muskeldegeneration",
      "Rhabdomyolyse a.n.k.",
      "Talma-Syndrom"
    ]
  },
  {
    "code": "M62.97",
    "name": "Fußmuskelinsuffizienz",
    "synonyms": [
      "Fußmuskelinsuffizienz"
    ]
  },
  {
    "code": "M62.98",
    "name": "Rückenmuskelinsuffizienz",
    "synonyms": [
      "Bauchmuskelinsuffizienz",
      "Muskuläre Dysbalance im Wirbelsäulenbereich",
      "Rückenmuskelinsuffizienz"
    ]
  },
  {
    "code": "M62.99",
    "name": "Muskelaffektion",
    "synonyms": [
      "Faszienkrankheit",
      "Faszienstörung",
      "Muskelaffektion",
      "Muskelinsuffizienz",
      "Muskelkrankheit",
      "Muskelstörung",
      "Muskuläre Dysbalance"
    ]
  },
  {
    "code": "M65.09",
    "name": "Sehnenscheidenabszess",
    "synonyms": [
      "Sehnenabszess",
      "Sehnenscheidenabszess"
    ]
  },
  {
    "code": "M65.19",
    "name": "Infektiöse Synovitis a.n.k.",
    "synonyms": [
      "Infektiöse Synovitis a.n.k.",
      "Infektiöse Tenosynovitis a.n.k.",
      "Sehneninfektion",
      "Sehnenscheideninfektion"
    ]
  },
  {
    "code": "M65.29",
    "name": "Tendinitis calcarea",
    "synonyms": [
      "Tendinitis calcarea",
      "Tendinitis mit Kalzifikation"
    ]
  },
  {
    "code": "M65.3",
    "name": "Tendopathia nodosa",
    "synonyms": [
      "Noduläre Sehnenkrankheit",
      "Schnappender Finger",
      "Schnellender Daumen",
      "Schnellender Finger",
      "Tendopathia nodosa"
    ]
  },
  {
    "code": "M65.4",
    "name": "Tendovaginitis stenosans (de Quervain)",
    "synonyms": [
      "De-Quervain-Krankheit [Tendovaginitis stenosans]",
      "Morbus de Quervain [Tendovaginitis stenosans]",
      "Tendovaginitis stenosans (de Quervain)"
    ]
  },
  {
    "code": "M65.85",
    "name": "Reizzustand des Hüftgelenks",
    "synonyms": [
      "Insertionstendopathie des Trochanter major",
      "Reizhüfte",
      "Reizzustand des Hüftgelenks"
    ]
  },
  {
    "code": "M65.89",
    "name": "Adhäsive Tendinitis",
    "synonyms": [
      "Adhäsive Tendinitis",
      "Adhäsive Tenosynovitis",
      "Kalzifikation einer Sehnenscheide",
      "Kristallinduzierte Synovitis",
      "Kristallinduzierte Tenosynovitis",
      "Paratenonitis crepitans",
      "Sehnenkalzifikation",
      "Synovitis crepitans"
    ]
  },
  {
    "code": "M65.91",
    "name": "Synovitis der Schulter",
    "synonyms": [
      "Synovitis der Schulter"
    ]
  },
  {
    "code": "M65.92",
    "name": "Tenosynovitis des Ellenbogens",
    "synonyms": [
      "Tenosynovitis des Ellenbogens"
    ]
  },
  {
    "code": "M65.93",
    "name": "Tenosynovitis des Handgelenks",
    "synonyms": [
      "Synovitis des Handgelenks",
      "Tenosynovitis des Handgelenks",
      "Tenosynovitis des Unterarms",
      "Tenovaginitis des Handgelenks",
      "Tenovaginitis des Unterarms"
    ]
  },
  {
    "code": "M65.94",
    "name": "Tenosynovitis eines Fingers",
    "synonyms": [
      "Tenosynovitis der Hand",
      "Tenosynovitis eines Fingers"
    ]
  },
  {
    "code": "M65.95",
    "name": "Tenosynovitis der Hüfte",
    "synonyms": [
      "Tenosynovitis der Hüfte",
      "Tenosynovitis des Gesäßes"
    ]
  },
  {
    "code": "M65.96",
    "name": "Tenovaginitis des Knies",
    "synonyms": [
      "Kniegelenksynovialitis",
      "Kniegelenksynovitis",
      "Tenosynovitis des Knies",
      "Tenovaginitis des Knies"
    ]
  },
  {
    "code": "M65.97",
    "name": "Synovitis des oberen Sprunggelenks",
    "synonyms": [
      "Synovitis des oberen Sprunggelenks",
      "Tenosynovitis des Fußes",
      "Tenosynovitis des Knöchels",
      "Tenosynovitis eines Zehs"
    ]
  },
  {
    "code": "M65.98",
    "name": "Tenosynovitis der Wirbelsäule",
    "synonyms": [
      "Tenosynovitis der Wirbelsäule"
    ]
  },
  {
    "code": "M65.99",
    "name": "Tendovaginitis",
    "synonyms": [
      "Arthrosynovitis",
      "Entzündliche Sehnenkrankheit a.n.k.",
      "Sehnenscheidenentzündung a.n.k.",
      "Synovialitis - s.a. Synovitis",
      "Synoviitis - s.a. Synovitis",
      "Synovitis",
      "Tendosynovitis - s.a. Tenosynovitis oder s.a. Tendovaginitis oder s.a. Tenovaginitis",
      "Tendovaginitis",
      "Tenosynovitis"
    ]
  },
  {
    "code": "M66.0",
    "name": "Ruptur einer Poplitealzyste",
    "synonyms": [
      "Ruptur einer Baker-Zyste",
      "Ruptur einer Poplitealzyste"
    ]
  },
  {
    "code": "M66.19",
    "name": "Synovialisruptur",
    "synonyms": [
      "Ruptur einer Synovialzyste",
      "Rupturierte Synovialzyste",
      "Synovialisruptur"
    ]
  },
  {
    "code": "M66.29",
    "name": "Spontanruptur von Strecksehnen",
    "synonyms": [
      "Spontanruptur von Strecksehnen"
    ]
  },
  {
    "code": "M66.39",
    "name": "Spontanruptur einer Beugesehne",
    "synonyms": [
      "Spontanruptur einer Beugesehne"
    ]
  },
  {
    "code": "M66.59",
    "name": "Nichttraumatische Sehnenruptur",
    "synonyms": [
      "Nichttraumatische Ruptur der Muskel-Sehnen-Verbindung",
      "Nichttraumatische Sehnenruptur",
      "Spontane Sehnenruptur"
    ]
  },
  {
    "code": "M67.0",
    "name": "Achillessehnenverkürzung",
    "synonyms": [
      "Achillessehnenkontraktur",
      "Achillessehnenverkürzung"
    ]
  },
  {
    "code": "M67.16",
    "name": "Sehnenverkürzung des Musculus tibialis anterior",
    "synonyms": [
      "Sehnenverkürzung des Musculus tibialis anterior",
      "Verkürzung des Musculus tibialis anterior"
    ]
  },
  {
    "code": "M67.19",
    "name": "Sehnenverkürzung",
    "synonyms": [
      "Sehnenkontraktur",
      "Sehnenscheidenkontraktur",
      "Sehnenverkürzung"
    ]
  },
  {
    "code": "M67.29",
    "name": "Synovialishypertrophie a.n.k.",
    "synonyms": [
      "Synovialishypertrophie a.n.k."
    ]
  },
  {
    "code": "M67.39",
    "name": "Transitorische Synovitis",
    "synonyms": [
      "Toxische Synovitis",
      "Transitorische Synovitis"
    ]
  },
  {
    "code": "M67.43",
    "name": "Handgelenkganglion",
    "synonyms": [
      "Handgelenkganglion"
    ]
  },
  {
    "code": "M67.44",
    "name": "Handrückenganglion",
    "synonyms": [
      "Handganglion",
      "Handrückenganglion",
      "Mukoidzyste am Fingergelenk"
    ]
  },
  {
    "code": "M67.47",
    "name": "Fußganglion",
    "synonyms": [
      "Fußganglion"
    ]
  },
  {
    "code": "M67.49",
    "name": "Sehnenscheidenganglion",
    "synonyms": [
      "Diffuses Ganglion",
      "Ganglion",
      "Ganglionzyste",
      "Gelenkganglion",
      "Hygrom",
      "Hygroma",
      "Sehnenganglion",
      "Sehnenscheidenganglion",
      "Sehnenscheidenhygrom",
      "Sehnenüberbein",
      "Wassergeschwulst",
      "Zusammengesetztes Ganglion",
      "Überbein"
    ]
  },
  {
    "code": "M67.86",
    "name": "Plicasyndrom",
    "synonyms": [
      "Plicasyndrom",
      "Plicasyndrom des Kniegelenks"
    ]
  },
  {
    "code": "M67.89",
    "name": "Tenophyt",
    "synonyms": [
      "Bandossifikation",
      "Degeneration der Membrana synovialis",
      "Ligamentossifikation",
      "Sehnenhernie",
      "Sehnenhypertrophie",
      "Sehnenossifikation",
      "Sehnenscheidenzyste",
      "Sehnenverschiebung",
      "Sehnenzyste",
      "Synovialisdegeneration",
      "Tenophyt"
    ]
  },
  {
    "code": "M67.99",
    "name": "Sehnenkrankheit",
    "synonyms": [
      "Sehnenaffektion",
      "Sehnenkrankheit",
      "Sehnenscheidenkrankheit",
      "Sehnenstörung",
      "Sehnenveränderung",
      "Synovialiskrankheit",
      "Synovialisstörung"
    ]
  },
  {
    "code": "M70.0",
    "name": "Chronische Synovitis crepitans der Hand",
    "synonyms": [
      "Chronische Synovitis crepitans der Hand",
      "Chronische Synovitis crepitans des Handgelenks"
    ]
  },
  {
    "code": "M70.1",
    "name": "Bursitis im Handbereich",
    "synonyms": [
      "Bursitis des Handgelenks",
      "Bursitis im Handbereich"
    ]
  },
  {
    "code": "M70.2",
    "name": "Bursitis olecrani",
    "synonyms": [
      "Bursitis olecrani",
      "Ellenbogengelenkbursitis"
    ]
  },
  {
    "code": "M70.3",
    "name": "Ellenbogenbursitis a.n.k.",
    "synonyms": [
      "Ellenbogenbursitis a.n.k."
    ]
  },
  {
    "code": "M70.4",
    "name": "Bursitis praepatellaris",
    "synonyms": [
      "Bursitis praepatellaris",
      "Hygroma praepatellare"
    ]
  },
  {
    "code": "M70.5",
    "name": "Bursitis infrapatellaris",
    "synonyms": [
      "Bursitis des Knies a.n.k.",
      "Bursitis infrapatellaris",
      "Bursitis semimembranacea",
      "Popliteale Bursitis"
    ]
  },
  {
    "code": "M70.6",
    "name": "Bursitis trochanterica",
    "synonyms": [
      "Bursitis trochanterica",
      "Tendinitis trochanterica"
    ]
  },
  {
    "code": "M70.7",
    "name": "Bursitis der Hüfte a.n.k.",
    "synonyms": [
      "Bursitis der Hüfte a.n.k.",
      "Bursitis der Os-ischii-Region"
    ]
  },
  {
    "code": "M70.8",
    "name": "Dorsalzyste",
    "synonyms": [
      "Dorsalzyste",
      "Fingerbursitis"
    ]
  },
  {
    "code": "M70.9",
    "name": "Überlastungsschaden des Unterarms",
    "synonyms": [
      "Berufsbedingte Bursitis a.n.k.",
      "Berufsbedingte Krankheit des Weichteilgewebes",
      "Bursitis durch Beanspruchung",
      "Bursitis durch Druck",
      "Bursitis durch Überbeanspruchung",
      "Synovitis durch Beanspruchung",
      "Synovitis durch Druck",
      "Synovitis durch Überbeanspruchung",
      "Tendinitis durch Beanspruchung",
      "Tendinitis durch Druck",
      "Tendinitis durch Überbeanspruchung",
      "Tenosynovitis durch Beanspruchung",
      "Tenosynovitis durch Druck",
      "Tenosynovitis durch Überbeanspruchung",
      "Überlastungsschaden des Handgelenks",
      "Überlastungsschaden des Unterarms",
      "Überlastungsschaden einer Extremität"
    ]
  },
  {
    "code": "M71.09",
    "name": "Schleimbeutelabszess",
    "synonyms": [
      "Bursaabszess",
      "Schleimbeutelabszess"
    ]
  },
  {
    "code": "M71.19",
    "name": "Infektiöse Bursitis a.n.k.",
    "synonyms": [
      "Infektiöse Bursitis a.n.k."
    ]
  },
  {
    "code": "M71.2",
    "name": "Baker-Zyste des Knies",
    "synonyms": [
      "Baker-Zyste",
      "Baker-Zyste des Knies",
      "Poplitealzyste",
      "Synovialzyste im Kniekehlenbereich"
    ]
  },
  {
    "code": "M71.39",
    "name": "Schleimzyste",
    "synonyms": [
      "Schleimbeutelzyste",
      "Schleimzyste",
      "Synovialzyste",
      "Zyste der Bursa synovialis a.n.k."
    ]
  },
  {
    "code": "M71.49",
    "name": "Bursitis calcarea",
    "synonyms": [
      "Bursakalzifikation a.n.k.",
      "Bursitis calcarea"
    ]
  },
  {
    "code": "M71.59",
    "name": "Adhäsive Bursitis",
    "synonyms": [
      "Adhäsive Bursitis"
    ]
  },
  {
    "code": "M71.99",
    "name": "Bursitis",
    "synonyms": [
      "Bursakrankheit",
      "Bursastörung",
      "Bursitis",
      "Bursitis acuta",
      "Bursopathie",
      "Schleimbeutelentzündung"
    ]
  },
  {
    "code": "M72.0",
    "name": "Fibromatose der Palmarfaszie",
    "synonyms": [
      "Dupuytren-Kontraktur",
      "Dupuytren-Krankheit",
      "Fibromatose der Palmarfaszie",
      "Morbus Dupuytren",
      "Palmaraponeurosenkontraktur",
      "Palmarfaszienkontraktur",
      "Palmarfaszienretraktion",
      "Palmarfibromatose"
    ]
  },
  {
    "code": "M72.1",
    "name": "Fingerknöchelpolster",
    "synonyms": [
      "Fingerknöchelpolster",
      "Knuckle pads",
      "Knuckle-pads-Syndrom"
    ]
  },
  {
    "code": "M72.2",
    "name": "Fibromatose der Plantarfaszie",
    "synonyms": [
      "Fasciitis plantaris",
      "Fibromatose der Plantarfaszie",
      "Fußsohlenfasziitis",
      "Ledderhose-Kontraktur",
      "Ledderhose-Krankheit",
      "Morbus Ledderhose",
      "Plantare Fibromatose",
      "Plantarfaszienkontraktur",
      "Plantarfasziitis"
    ]
  },
  {
    "code": "M72.40",
    "name": "Pseudosarkomatöse Fibromatose an mehreren Lokalisationen",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M72.41",
    "name": "Pseudosarkomatöse Fibromatose in der Schulterregion",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose in der Schulterregion"
    ]
  },
  {
    "code": "M72.42",
    "name": "Pseudosarkomatöse Fibromatose am Oberarm",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose am Oberarm"
    ]
  },
  {
    "code": "M72.43",
    "name": "Pseudosarkomatöse Fibromatose am Unterarm",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose am Unterarm"
    ]
  },
  {
    "code": "M72.44",
    "name": "Pseudosarkomatöse Fibromatose an der Hand",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose an der Hand"
    ]
  },
  {
    "code": "M72.45",
    "name": "Pseudosarkomatöse Fibromatose am Oberschenkel",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose am Oberschenkel"
    ]
  },
  {
    "code": "M72.46",
    "name": "Pseudosarkomatöse Fibromatose am Unterschenkel",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose am Unterschenkel"
    ]
  },
  {
    "code": "M72.47",
    "name": "Pseudosarkomatöse Fibromatose am Fuß",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose am Fuß"
    ]
  },
  {
    "code": "M72.48",
    "name": "Pseudosarkomatöse Fibromatose am Rumpf",
    "synonyms": [
      "Pseudosarkomatöse Fibromatose am Rumpf"
    ]
  },
  {
    "code": "M72.49",
    "name": "Fasciitis nodularis",
    "synonyms": [
      "Fasciitis nodularis",
      "Noduläre Fasziitis",
      "Pseudosarkomatöse Fibromatose"
    ]
  },
  {
    "code": "M72.69",
    "name": "Nekrotisierende Fasziitis",
    "synonyms": [
      "Nekrotisierende Fasziitis"
    ]
  },
  {
    "code": "M72.80",
    "name": "Digitale infantile Fibromatose",
    "synonyms": [
      "Digitale infantile Fibromatose"
    ]
  },
  {
    "code": "M72.81",
    "name": "Juveniles aponeurotisches Fibrom in der Schulterregion",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom in der Schulterregion"
    ]
  },
  {
    "code": "M72.82",
    "name": "Juveniles aponeurotisches Fibrom am Oberarm",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom am Oberarm"
    ]
  },
  {
    "code": "M72.83",
    "name": "Juveniles aponeurotisches Fibrom am Unterarm",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom am Unterarm"
    ]
  },
  {
    "code": "M72.84",
    "name": "Juveniles aponeurotisches Fibrom an der Hand",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom an der Hand"
    ]
  },
  {
    "code": "M72.85",
    "name": "Juveniles aponeurotisches Fibrom in der Beckenregion",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom in der Beckenregion"
    ]
  },
  {
    "code": "M72.86",
    "name": "Juveniles aponeurotisches Fibrom am Unterschenkel",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom am Unterschenkel"
    ]
  },
  {
    "code": "M72.87",
    "name": "Juveniles aponeurotisches Fibrom am Fuß",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom am Fuß"
    ]
  },
  {
    "code": "M72.88",
    "name": "Juveniles aponeurotisches Fibrom am Rumpf",
    "synonyms": [
      "Juveniles aponeurotisches Fibrom am Rumpf"
    ]
  },
  {
    "code": "M72.89",
    "name": "Faszienabszess",
    "synonyms": [
      "Faszienabszess",
      "Juvenile hyaline Fibromatose",
      "Juveniles aponeurotisches Fibrom",
      "Traumatische Fasziitis"
    ]
  },
  {
    "code": "M72.99",
    "name": "Fibromatose",
    "synonyms": [
      "Entzündliche Faszienkrankheit",
      "Faszienentzündung",
      "Fasziitis",
      "Fibroblastenstörung",
      "Fibromatose",
      "Fibromatosis"
    ]
  },
  {
    "code": "M75.0",
    "name": "Adhäsive Entzündung der Schultergelenkkapsel",
    "synonyms": [
      "Adhäsive Enthesiopathie der Schulterregion",
      "Adhäsive Entzündung der Schultergelenkkapsel",
      "Adhäsive Perikapsulitis der Schulter",
      "Adhäsive Schulterperitendinitis",
      "Adhäsive Schultertendinitis",
      "Akute Periarthritis humeroscapularis",
      "Bizepsrinnensyndrom",
      "Chronische Periarthritis humeroscapularis",
      "Duplay-Bursitis",
      "Duplay-Krankheit",
      "Duplay-Periarthritis",
      "Duplay-Syndrom",
      "Frozen shoulder",
      "Kapselentzündung der Schulter",
      "PAH [Periarthropathia humeroscapularis] - s.a. Periarthropathia humeroscapularis oder s.a. Periarthritis humeroscapularis",
      "PHS [Periarthropathia humeroscapularis] - s.a. Periarthropathia humeroscapularis oder s.a. Periarthrosis humeroscapularis oder s.a. Periarthritis humeroscapularis",
      "PHS [Periarthropathia humeroscapularis]-Syndrom",
      "Periarthritis der Schulter",
      "Periarthritis humeroscapularis",
      "Periarthropathia humeroscapularis",
      "Periarthropathia humeroscapularis acuta",
      "Periarthropathia humeroscapularis calcarea",
      "Periarthropathia humeroscapularis mit Bewegungseinschränkung",
      "Periarthropathia humeroscapularis mit Kalkablagerung",
      "Periarthropathia humeroscapularis mit Teilsteife",
      "Periarthropathia humeroscapularis mit einseitigem Kopfhochstand",
      "Periarthropathia humeroscapularis simplex",
      "Periarthrosis humeroscapularis",
      "Schulteradhäsion",
      "Schultergelenkadhäsion",
      "Sekundäre Periarthritis humeroscapularis",
      "Subskapuläre Adhäsion",
      "Tenosynovitis bei Schulteradhäsion"
    ]
  },
  {
    "code": "M75.1",
    "name": "Läsion der Rotatorenmanschette",
    "synonyms": [
      "Läsion der Rotatorenmanschette",
      "Läsion der Rotatorenmanschette des Schultergelenks",
      "Nichttraumatische unvollständige Ruptur der Rotatorenmanschette",
      "Nichttraumatische unvollständige Ruptur der Supraspinatussehne",
      "Nichttraumatische vollständige Ruptur der Rotatorenmanschette",
      "Nichttraumatische vollständige Ruptur der Supraspinatussehne",
      "Rotatorenmanschettenruptur",
      "Rotatorenmanschettenruptur der Schulter",
      "Rotatorenmanschettensyndrom",
      "Rotatorensyndrom",
      "Supra- und Infraspinatustendinitis",
      "Supraspinatus- und Subskapularistendinitis",
      "Supraspinatussehnensyndrom",
      "Supraspinatussyndrom",
      "Supraspinatustendinose"
    ]
  },
  {
    "code": "M75.2",
    "name": "Tendinitis des Musculus biceps brachii",
    "synonyms": [
      "Bizeps-brevis-Syndrom",
      "Bizeps-longus-Syndrom",
      "Bizepstendinitis",
      "Tendinitis des Musculus biceps brachii",
      "Tenosynovitis des Bizeps"
    ]
  },
  {
    "code": "M75.3",
    "name": "Tendinitis calcarea im Schulterbereich",
    "synonyms": [
      "Bursitis calcarea im Schulterbereich",
      "Bursitis calcarea supraspinata",
      "Tendinitis calcarea im Schulterbereich",
      "Tendinosis calcarea der Schulter"
    ]
  },
  {
    "code": "M75.4",
    "name": "Impingementsyndrom der Schulter",
    "synonyms": [
      "Impingementsyndrom der Schulter"
    ]
  },
  {
    "code": "M75.5",
    "name": "Schleimbeutelentzündung im Schulterbereich",
    "synonyms": [
      "Bursitis humeroscapularis",
      "Bursitis im Schulterbereich",
      "Bursitis subacromialis",
      "Bursitis subcoracoidea",
      "Bursitis subdeltoidea",
      "Schleimbeutelentzündung im Schulterbereich",
      "Subakromiale Bursitis"
    ]
  },
  {
    "code": "M75.6",
    "name": "Läsion des Labrums bei degenerativer Veränderung des Schultergelenkes",
    "synonyms": [
      "Läsion des Labrums bei degenerativer Veränderung des Schultergelenkes",
      "Läsion des Labrums, nicht als traumatisch bezeichnet"
    ]
  },
  {
    "code": "M75.8",
    "name": "Tendomyopathie im Schulterbereich",
    "synonyms": [
      "Fibromyositis humeroscapularis",
      "Insertionstendopathie im Schulterbereich",
      "Myofibrosis humeroscapularis",
      "Myofibrositis humeroscapularis",
      "Sehnenstörung in der Schulterregion",
      "Tendinitis im Schulterbereich",
      "Tendomyopathie des Schultergürtels",
      "Tendomyopathie im Schulterbereich",
      "Tendomyose des Schultergürtels",
      "Tenosynovitis der Schulter"
    ]
  },
  {
    "code": "M75.9",
    "name": "Schulterläsion",
    "synonyms": [
      "Affektion der Schultergegend a.n.k.",
      "Affektion der Schulterregion",
      "Enthesiopathie in der Schulterregion",
      "Nichttraumatische Schulterschädigung",
      "Schulterläsion"
    ]
  },
  {
    "code": "M76.0",
    "name": "Tendinitis der Glutäussehne",
    "synonyms": [
      "Glutäale Tendinitis",
      "Tendinitis der Glutäussehne"
    ]
  },
  {
    "code": "M76.1",
    "name": "Tendinitis der Iliopsoassehne",
    "synonyms": [
      "Psoastendinitis",
      "Tendinitis der Iliopsoassehne"
    ]
  },
  {
    "code": "M76.2",
    "name": "Knochensporn des Darmbeinkamms",
    "synonyms": [
      "Knochensporn des Darmbeinkamms"
    ]
  },
  {
    "code": "M76.3",
    "name": "Tractus-iliotibialis-Scheuersyndrom",
    "synonyms": [
      "Iliotibial band syndrome",
      "Tractus-iliotibialis-Scheuersyndrom",
      "Tractus-iliotibialis-Syndrom"
    ]
  },
  {
    "code": "M76.4",
    "name": "Bursitis im Bereich des Ligamentum collaterale tibiale",
    "synonyms": [
      "Bursitis im Bereich des Ligamentum collaterale tibiale",
      "Posttraumatische parakondyläre Femurossifikation",
      "Stieda-Krankheit",
      "Stieda-Pellegrini-Krankheit",
      "Stieda-Pellegrini-Syndrom"
    ]
  },
  {
    "code": "M76.5",
    "name": "Tendinitis der Patellarsehne",
    "synonyms": [
      "Patellartendinitis",
      "Patellaspitzensyndrom",
      "Tendinitis der Patellarsehne"
    ]
  },
  {
    "code": "M76.6",
    "name": "Achillobursitis",
    "synonyms": [
      "Achillessehnenentzündung",
      "Achillobursitis",
      "Achillodynie",
      "Bursitis achillea",
      "Bursitis der Achillessehne",
      "Bursitis subachillea",
      "Tendinitis der Achillessehne"
    ]
  },
  {
    "code": "M76.7",
    "name": "Tendinitis der Peronäussehne",
    "synonyms": [
      "Tendinitis der Peronäussehne"
    ]
  },
  {
    "code": "M76.8",
    "name": "Periarthritis coxae",
    "synonyms": [
      "Enthesiopathie der Hüftregion",
      "Enthesiopathie des Knies",
      "Knöchelbursitis",
      "Mediale Kapseltendinose des Knies",
      "Periarthritis coxae",
      "Periarthritis der Hüfte",
      "Periostitis tibiae durch Überlastung",
      "Pes-anserinus-Syndrom",
      "Schienbeinkantensyndrom",
      "Shin splits durch Überlastung",
      "Tendinitis des Musculus tibialis anterior",
      "Tendinitis des Musculus tibialis posterior",
      "Tendinitis tibialis anterior",
      "Tendinitis tibialis posterior",
      "Tendopathie des Knies",
      "Tibiakantensyndrom",
      "Trochantertendinose",
      "Trochantertendopathie"
    ]
  },
  {
    "code": "M76.9",
    "name": "Enthesiopathie der unteren Extremität",
    "synonyms": [
      "Enthesiopathie der unteren Extremität",
      "Repetitive strain injury [RSI] der unteren Extremität"
    ]
  },
  {
    "code": "M77.0",
    "name": "Epicondylitis humeri ulnaris",
    "synonyms": [
      "Epicondylitis humeri ulnaris",
      "Epicondylitis ulnaris",
      "Golfarm",
      "Golfellenbogen",
      "Ulnare Epikondylopathie"
    ]
  },
  {
    "code": "M77.1",
    "name": "Epicondylopathia humeri radialis",
    "synonyms": [
      "Chronische Epicondylitis humeri radialis",
      "Chronische Epicondylitis radialis",
      "Epicondylitis humeri radialis",
      "Epicondylitis radialis",
      "Epicondylopathia humeri radialis",
      "Epicondylopathia radialis",
      "Epikondylitis mit Blockierung des Radiusköpfchens",
      "Radiale Epikondylopathie",
      "Tennisellenbogen"
    ]
  },
  {
    "code": "M77.2",
    "name": "Tendopathie des Handgelenks",
    "synonyms": [
      "Periarthritis des Handgelenks",
      "Tendopathie des Handgelenks"
    ]
  },
  {
    "code": "M77.3",
    "name": "Kalkaneussporn",
    "synonyms": [
      "Fersensporn",
      "Haglund-Exostose",
      "Haglund-I-Syndrom",
      "Haglund-Krankheit",
      "Kalkaneussporn",
      "Plantarer Fersensporn"
    ]
  },
  {
    "code": "M77.4",
    "name": "Metatarsalgie",
    "synonyms": [
      "Chronische Metatarsalgie",
      "Metatarsalgie"
    ]
  },
  {
    "code": "M77.5",
    "name": "Enthesiopathie der Plantaraponeurose",
    "synonyms": [
      "Ballenbursitis",
      "Bursitis calcanea",
      "Bursitis des Fersenbeins",
      "Enthesiopathie der Plantaraponeurose",
      "Enthesiopathie des Fußes a.n.k.",
      "Enthesiopathie des Knöchels",
      "Enthesiopathie des Tarsus",
      "Fußbursitis",
      "Tendinitis des oberen Sprunggelenks",
      "Zehenbursitis"
    ]
  },
  {
    "code": "M77.8",
    "name": "Paravertebrale Tendomyopathie",
    "synonyms": [
      "Chronische Epicondylitis lateralis",
      "Enthesiopathie der Ellenbogenregion",
      "Enthesiopathie der Handwurzel a.n.k.",
      "Enthesiopathie des Handgelenks a.n.k.",
      "Enthesiopathie des Ligamentum iliolumbale",
      "Epicondylitis humeri",
      "Epicondylitis lateralis",
      "Epicondylitis medialis",
      "Epicondylitis tibiae",
      "Epicondylopathia humeri",
      "Epikondylitis",
      "Epikondylitis des Ellenbogens",
      "Epikondylopathie",
      "Paravertebrale Tendomyopathie",
      "Radiohumerale Bursitis",
      "Tendinitis des Unterarms",
      "Tendopathie mit diffuser Enthesiopathie"
    ]
  },
  {
    "code": "M77.9",
    "name": "Insertionstendopathie",
    "synonyms": [
      "Adhäsive Kapselentzündung",
      "Adhäsive Kapsulitis",
      "Ansatztendinose",
      "Aponeurosenkrankheit",
      "Bandansatzstörung",
      "Capsulitis - s.a. Kapsulitis",
      "Eagle-Syndrom",
      "Enthesiopathie",
      "Enthesopathie - s.a. Enthesiopathie",
      "Insertionsligamentopathie",
      "Insertionstendinitis",
      "Insertionstendopathie",
      "Kapselentzündung",
      "Kapselentzündung eines Gelenks",
      "Kapsulitis",
      "Kapsulitis eines Gelenks",
      "Knochensporn",
      "Ligamentopathie",
      "Myotendinose",
      "Paratendinitis",
      "Periarthritis",
      "Periarthritis calcificans",
      "Periarthritis eines Gelenks",
      "Periarthropathie",
      "Periphere Enthesiopathie a.n.k.",
      "Peritendinitis",
      "Processus-styloideus-Syndrom",
      "Repetitive strain injury [RSI] der oberen Extremität",
      "Störung der Muskelansätze",
      "Tendinitis",
      "Tendinose",
      "Tendomyopathie",
      "Tendopathie",
      "Tendoperiostopathie",
      "Überanstrengungsperiostose"
    ]
  },
  {
    "code": "M79.09",
    "name": "Rheumatismus",
    "synonyms": [
      "Akuter Gelenkrheumatismus",
      "Akuter Rheumatismus",
      "Chronischer Rheumatismus",
      "Extraartikulärer Rheumatismus",
      "Gelenkrheumatismus",
      "Neuralgischer Rheumatismus",
      "Rheuma",
      "Rheumatische Beschwerden",
      "Rheumatische Erkrankung",
      "Rheumatische Schmerzen",
      "Rheumatismus",
      "Subakuter Gelenkrheumatismus",
      "Subakuter Rheumatismus",
      "Weichteilrheumatismus"
    ]
  },
  {
    "code": "M79.18",
    "name": "Myalgie im Brustbereich",
    "synonyms": [
      "Interkostale Myalgie",
      "Myalgie im Brustbereich",
      "Myalgie im Hals-Nacken-Bereich",
      "Myalgie im Lendenbereich",
      "Myalgische Nackenbeschwerden",
      "Myalgische Rückenbeschwerden"
    ]
  },
  {
    "code": "M79.19",
    "name": "Myalgie",
    "synonyms": [
      "Chronische Myalgie",
      "Muskelschmerzen",
      "Muskuloskeletales Schmerzsyndrom",
      "Myalgia",
      "Myalgie",
      "Myofasziales Schmerzsyndrom",
      "Uncharakteristische Muskelschmerzen"
    ]
  },
  {
    "code": "M79.29",
    "name": "Neuromyalgie",
    "synonyms": [
      "Akute Neuralgie",
      "Chronische rheumatische Neuritis",
      "Epineuritis",
      "Nervenentzündung a.n.k.",
      "Nervenschmerzen a.n.k.",
      "Neuralgia",
      "Neuralgie",
      "Neuritis",
      "Neuromuskuläre Schmerzen",
      "Neuromyalgie",
      "Perineuritis a.n.k."
    ]
  },
  {
    "code": "M79.39",
    "name": "Pannikulitis",
    "synonyms": [
      "Pannikulitis"
    ]
  },
  {
    "code": "M79.46",
    "name": "Hypertrophie des Corpus adiposum",
    "synonyms": [
      "Hoffa-Hypertrophie des Knies [Krankheit des Corpus adiposum infrapatellare]",
      "Hoffa-Kastert-Syndrom",
      "Hypertrophie der Fettpolster des Knies",
      "Hypertrophie des Corpus adiposum",
      "Hypertrophie infrapatellarer Fettpolster",
      "Umschriebene retropatellare Fettpolster"
    ]
  },
  {
    "code": "M79.59",
    "name": "Verbliebener Fremdkörper im Weichteilgewebe",
    "synonyms": [
      "Fremdkörper im Weichteilgewebe",
      "Retinierter Fremdkörper im Muskel",
      "Retinierter Fremdkörper im Weichteilgewebe",
      "Verbliebener Fremdkörper im Weichteilgewebe"
    ]
  },
  {
    "code": "M79.62",
    "name": "Ellenbogenschmerzen, nicht operationsbedingt",
    "synonyms": [
      "Ellenbogenschmerzen, nicht operationsbedingt",
      "Oberarmschmerzen"
    ]
  },
  {
    "code": "M79.64",
    "name": "Handschmerzen",
    "synonyms": [
      "Fingerschmerzen",
      "Handschmerzen"
    ]
  },
  {
    "code": "M79.67",
    "name": "Fußschmerzen",
    "synonyms": [
      "Fersenbeinschmerzen",
      "Fersenschmerzen",
      "Fußschmerzen",
      "Kalkaneodynie",
      "Schmerzen im Fußgewölbe",
      "Statische Fußschmerzen",
      "Tarsalgie",
      "Zehenschmerzen"
    ]
  },
  {
    "code": "M79.69",
    "name": "Extremitätenschmerzen",
    "synonyms": [
      "Afebrile Gliederschmerzen",
      "Armschmerzen",
      "Beinschmerzen",
      "Brachialgie",
      "Extremitätenschmerzen",
      "Gliederschmerzen",
      "Gliedmaßenschmerzen",
      "Unklare Beinschmerzen",
      "Vertebragene Beinbeschwerden"
    ]
  },
  {
    "code": "M79.70",
    "name": "Fibromyalgiesyndrom",
    "synonyms": [
      "Fibromyalgie",
      "Fibromyalgiesyndrom",
      "Fibromyositis",
      "Fibrositis",
      "Juvenile Fibromyalgie",
      "Myofibrositis",
      "Periartikuläre Fibrositis",
      "Rheumatische Fibrositis"
    ]
  },
  {
    "code": "M79.84",
    "name": "Cheiromegalie",
    "synonyms": [
      "Cheiromegalie",
      "Fingerschwellung",
      "Handschwellung"
    ]
  },
  {
    "code": "M79.87",
    "name": "Fußschwellung",
    "synonyms": [
      "Fußschwellung",
      "Zehenschwellung"
    ]
  },
  {
    "code": "M79.88",
    "name": "Bauchwandschwäche",
    "synonyms": [
      "Bauchwandschwäche"
    ]
  },
  {
    "code": "M79.89",
    "name": "Bindegewebeschwäche",
    "synonyms": [
      "Allgemeine Bindegewebeschwäche",
      "Armschwellung",
      "Arzneimittelinduzierte Fibrose",
      "Bindegewebeschwäche",
      "Diffuse Bindegewebsentzündung a.n.k.",
      "Extremitätenschwellung",
      "Familiäres episodisches Schmerzsyndrom",
      "Fettgewebsnekrose",
      "Gliedmaßenschwellung",
      "LAMA5 [Laminin-alpha-5]-assoziiertes multisystemisches Syndrom",
      "Profichet-Syndrom",
      "Weichteilinfektion"
    ]
  },
  {
    "code": "M79.96",
    "name": "Nichttraumatischer prätibialer Weichteildefekt",
    "synonyms": [
      "Nichttraumatischer prätibialer Weichteildefekt"
    ]
  },
  {
    "code": "M79.99",
    "name": "Krankheit des Weichteilgewebes",
    "synonyms": [
      "Krankheit des Weichteilgewebes",
      "Störung des Muskel-Skelett-Systems",
      "Störung des Weichteilgewebes"
    ]
  },
  {
    "code": "M80.09",
    "name": "Postmenopausale Osteoporose mit pathologischer Fraktur",
    "synonyms": [
      "Postmenopausale Osteoporose mit pathologischer Fraktur"
    ]
  },
  {
    "code": "M80.19",
    "name": "Pathologische Fraktur bei Osteoporose nach Ovarektomie",
    "synonyms": [
      "Pathologische Fraktur bei Osteoporose nach Ovarektomie"
    ]
  },
  {
    "code": "M80.29",
    "name": "Inaktivitätsosteoporose mit pathologischer Fraktur",
    "synonyms": [
      "Fraktur durch Inaktivitätsosteoporose",
      "Inaktivitätsosteoporose mit pathologischer Fraktur"
    ]
  },
  {
    "code": "M80.39",
    "name": "Osteoporose mit pathologischer Fraktur durch postoperative Malabsorption",
    "synonyms": [
      "Osteoporose mit pathologischer Fraktur durch postoperative Malabsorption"
    ]
  },
  {
    "code": "M80.49",
    "name": "Arzneimittelinduzierte Osteoporose mit pathologischer Fraktur",
    "synonyms": [
      "Arzneimittelinduzierte Osteoporose mit pathologischer Fraktur"
    ]
  },
  {
    "code": "M80.59",
    "name": "Idiopathische Osteoporose mit pathologischer Fraktur",
    "synonyms": [
      "Idiopathische Osteoporose mit pathologischer Fraktur",
      "X-chromosomale Osteoporose mit Frakturen"
    ]
  },
  {
    "code": "M80.89",
    "name": "Senile Osteoporose mit pathologischer Fraktur",
    "synonyms": [
      "Posttraumatische Osteoporose mit pathologischer Fraktur",
      "Senile Osteoporose mit pathologischer Fraktur"
    ]
  },
  {
    "code": "M80.98",
    "name": "Schwere Osteoporose mit Wirbelsinterung",
    "synonyms": [
      "Osteoporose mit Wirbelfraktur",
      "Osteoporotische Wirbelkörperkompression",
      "Osteoporotischer Keilwirbel",
      "Schwere Osteoporose mit Wirbelsinterung"
    ]
  },
  {
    "code": "M80.99",
    "name": "Osteoporose mit pathologischer Fraktur",
    "synonyms": [
      "Osteoporose mit Fraktur",
      "Osteoporose mit pathologischer Fraktur",
      "Osteoporose mit vertebralem Kollaps"
    ]
  },
  {
    "code": "M81.09",
    "name": "Postmenopausale Osteoporose",
    "synonyms": [
      "Involutionsosteoporose",
      "Postmenopausale Osteoporose"
    ]
  },
  {
    "code": "M81.19",
    "name": "Osteoporose nach Ovarektomie",
    "synonyms": [
      "Osteoporose nach Ovarektomie"
    ]
  },
  {
    "code": "M81.29",
    "name": "Inaktivitätsosteoporose",
    "synonyms": [
      "Inaktivitätsosteoporose",
      "Knochenatrophie durch Inaktivität a.n.k."
    ]
  },
  {
    "code": "M81.39",
    "name": "Osteoporose durch postoperative Malabsorption",
    "synonyms": [
      "Osteoporose durch postoperative Malabsorption"
    ]
  },
  {
    "code": "M81.49",
    "name": "Arzneimittelinduzierte Osteoporose",
    "synonyms": [
      "Arzneimittelinduzierte Osteoporose",
      "Steroidosteoporose"
    ]
  },
  {
    "code": "M81.59",
    "name": "Idiopathische Osteoporose",
    "synonyms": [
      "Idiopathische Osteoporose",
      "Idiopathische juvenile Osteoporose",
      "LRP5-assoziierte primäre Osteoporose"
    ]
  },
  {
    "code": "M81.69",
    "name": "Lokalisierte Osteoporose",
    "synonyms": [
      "Lequesne",
      "Lokalisierte Osteoporose",
      "Transitorische Osteoporose"
    ]
  },
  {
    "code": "M81.88",
    "name": "Fischwirbelbildung",
    "synonyms": [
      "Fischwirbelbildung"
    ]
  },
  {
    "code": "M81.89",
    "name": "Altersosteoporose",
    "synonyms": [
      "Altersosteoporose",
      "Posttraumatische Knochenatrophie a.n.k.",
      "Posttraumatische Osteoporose",
      "Senile Osteoporose"
    ]
  },
  {
    "code": "M81.98",
    "name": "LWS-Osteoporose",
    "synonyms": [
      "LWS-Osteoporose",
      "Osteoporose der Lendenwirbelsäule",
      "Osteoporose der Wirbelsäule",
      "WS-Osteoporose"
    ]
  },
  {
    "code": "M81.99",
    "name": "Osteoporose",
    "synonyms": [
      "Knochendekalzifikation",
      "Knochendemineralisation",
      "Knochenschwund",
      "Osteoporose",
      "Präklinische Osteoporose"
    ]
  },
  {
    "code": "M83.09",
    "name": "Osteomalazie im Wochenbett",
    "synonyms": [
      "Osteomalazie im Wochenbett"
    ]
  },
  {
    "code": "M83.19",
    "name": "Senile Osteomalazie",
    "synonyms": [
      "Senile Osteomalazie"
    ]
  },
  {
    "code": "M83.29",
    "name": "Osteomalazie durch Malabsorption im Erwachsenenalter",
    "synonyms": [
      "Osteomalazie durch Malabsorption im Erwachsenenalter"
    ]
  },
  {
    "code": "M83.39",
    "name": "Osteomalazie durch Fehlernährung im Erwachsenenalter",
    "synonyms": [
      "Osteomalazie durch Fehlernährung im Erwachsenenalter",
      "Osteomalazie durch Mangelernährung im Erwachsenenalter"
    ]
  },
  {
    "code": "M83.49",
    "name": "Aluminiumosteopathie",
    "synonyms": [
      "Aluminiumkrankheit",
      "Aluminiumosteomalazie",
      "Aluminiumosteopathie"
    ]
  },
  {
    "code": "M83.59",
    "name": "Arzneimittelinduzierte Osteomalazie im Erwachsenenalter a.n.k.",
    "synonyms": [
      "Arzneimittelinduzierte Osteomalazie im Erwachsenenalter a.n.k."
    ]
  },
  {
    "code": "M83.85",
    "name": "Beckenosteomalazie",
    "synonyms": [
      "Beckenosteomalazie"
    ]
  },
  {
    "code": "M83.88",
    "name": "Kraniotabes",
    "synonyms": [
      "Kraniotabes",
      "Kraniotabes unbekannter Ursache",
      "Weichschädel"
    ]
  },
  {
    "code": "M83.89",
    "name": "Milkman-Krankheit",
    "synonyms": [
      "Ergosterinmangel mit Osteomalazie",
      "Kalziferolmangel mit Osteomalazie",
      "Looser-Milkman-Debray-Syndrom",
      "Milkman-Krankheit",
      "Milkman-Syndrom",
      "Onkogene Osteomalazie",
      "Osteomalazie bei Vitamin-D-Mangel beim Erwachsenen",
      "Osteoporose-Osteomalazie-Syndrom"
    ]
  },
  {
    "code": "M83.99",
    "name": "Osteomalazie im Erwachsenenalter",
    "synonyms": [
      "Knochenerweichung",
      "Malazie der Knochen",
      "Malazie der Knochen im Erwachsenenalter",
      "Nichtjuvenile Osteomalazie",
      "Osteomalazie",
      "Osteomalazie im Erwachsenenalter",
      "Rachitis beim Erwachsenen",
      "Rachitis tarda",
      "Spätrachitis"
    ]
  },
  {
    "code": "M84.09",
    "name": "Frakturheilung in Fehlstellung",
    "synonyms": [
      "Frakturheilung in Fehlstellung",
      "Schlechte Stellung von Frakturenden"
    ]
  },
  {
    "code": "M84.18",
    "name": "Xiphoid-Pseudarthrose",
    "synonyms": [
      "Xiphoid-Pseudarthrose"
    ]
  },
  {
    "code": "M84.19",
    "name": "Pseudarthrose",
    "synonyms": [
      "Falschgelenk",
      "Nichtvereinigung der Frakturenden",
      "Pseudarthrose"
    ]
  },
  {
    "code": "M84.29",
    "name": "Verzögerte Frakturheilung",
    "synonyms": [
      "Verzögerte Frakturheilung"
    ]
  },
  {
    "code": "M84.39",
    "name": "Marschfraktur",
    "synonyms": [
      "Ermüdungsfraktur",
      "Marschfraktur",
      "Stressfraktur"
    ]
  },
  {
    "code": "M84.45",
    "name": "Pathologische Schenkelhalsfraktur",
    "synonyms": [
      "Pathologische Schenkelhalsfraktur"
    ]
  },
  {
    "code": "M84.49",
    "name": "Spontanfraktur",
    "synonyms": [
      "Pathologische Fraktur",
      "Pathologische Knochenfraktur",
      "Spontanfraktur"
    ]
  },
  {
    "code": "M84.88",
    "name": "Diastase der Schädelknochen",
    "synonyms": [
      "Diastase der Schädelknochen"
    ]
  },
  {
    "code": "M84.89",
    "name": "Enostose",
    "synonyms": [
      "Enostose"
    ]
  },
  {
    "code": "M84.99",
    "name": "Veränderung der Knochenkontinuität",
    "synonyms": [
      "Störung der Knochenkontinuität",
      "Veränderung der Knochenkontinuität"
    ]
  },
  {
    "code": "M85.00",
    "name": "Monostotische fibröse Dysplasie an mehreren Lokalisationen",
    "synonyms": [
      "Monostotische fibröse Dysplasie an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M85.01",
    "name": "Monostotische fibröse Dysplasie in der Schulterregion",
    "synonyms": [
      "Monostotische fibröse Dysplasie in der Schulterregion"
    ]
  },
  {
    "code": "M85.02",
    "name": "Monostotische fibröse Dysplasie am Oberarm",
    "synonyms": [
      "Monostotische fibröse Dysplasie am Oberarm"
    ]
  },
  {
    "code": "M85.03",
    "name": "Monostotische fibröse Dysplasie am Unterarm",
    "synonyms": [
      "Monostotische fibröse Dysplasie am Unterarm"
    ]
  },
  {
    "code": "M85.04",
    "name": "Monostotische fibröse Dysplasie an der Hand",
    "synonyms": [
      "Monostotische fibröse Dysplasie an der Hand"
    ]
  },
  {
    "code": "M85.05",
    "name": "Monostotische fibröse Dysplasie am Oberschenkel",
    "synonyms": [
      "Monostotische fibröse Dysplasie am Oberschenkel"
    ]
  },
  {
    "code": "M85.06",
    "name": "Monostotische fibröse Dysplasie am Unterschenkel",
    "synonyms": [
      "Monostotische fibröse Dysplasie am Unterschenkel"
    ]
  },
  {
    "code": "M85.07",
    "name": "Monostotische fibröse Dysplasie am Fuß",
    "synonyms": [
      "Monostotische fibröse Dysplasie am Fuß"
    ]
  },
  {
    "code": "M85.08",
    "name": "Monostotische fibröse Dysplasie der Rippen",
    "synonyms": [
      "Monostotische fibröse Dysplasie am Schädel",
      "Monostotische fibröse Dysplasie der Rippen"
    ]
  },
  {
    "code": "M85.09",
    "name": "Fibröse Dysplasie",
    "synonyms": [
      "Fibröse Dysplasie",
      "Fibröse Knochendysplasie a.n.k.",
      "Monostotische Jaffé-Lichtenstein-Krankheit",
      "Monostotische fibröse Dysplasie",
      "Monostotisches Jaffé-Lichtenstein-Syndrom",
      "Ostitis fibrosa circumscripta"
    ]
  },
  {
    "code": "M85.19",
    "name": "Skelettfluorose",
    "synonyms": [
      "Skelettfluorose"
    ]
  },
  {
    "code": "M85.2",
    "name": "Hyperostose des Schädels",
    "synonyms": [
      "Hyperostose des Schädels",
      "Hyperostosis corticalis des Schädels",
      "Hyperostosis cranialis interna",
      "Hyperostosis frontalis interna",
      "Kraniodiaphysäre Dysplasie",
      "Leontiasis ossea",
      "Morel-Syndrom",
      "Morgagni-Syndrom",
      "Sklerosteose",
      "Stewart-Morel-Morgagni-Syndrom",
      "X-chromosomale Hyperostose der Schädelkalotte"
    ]
  },
  {
    "code": "M85.31",
    "name": "Kondensierende Osteitis der medialen Klavikula",
    "synonyms": [
      "Kondensierende Osteitis der medialen Klavikula"
    ]
  },
  {
    "code": "M85.35",
    "name": "Bársony-Polgár-Syndrom",
    "synonyms": [
      "Bársony-Polgár-Syndrom",
      "Kondensierende Osteitis des Ileums",
      "Osteitis condensans der Beckenregion",
      "Osteitis condensans ilei"
    ]
  },
  {
    "code": "M85.38",
    "name": "Kondensierende Osteitis des Sakrums",
    "synonyms": [
      "Kondensierende Osteitis des Sakrums",
      "Osteitis condensans sacrii"
    ]
  },
  {
    "code": "M85.39",
    "name": "Ostitis condensans",
    "synonyms": [
      "Ostitis condensans"
    ]
  },
  {
    "code": "M85.42",
    "name": "Solitäre Knochenzyste am Oberarm",
    "synonyms": [
      "Solitäre Knochenzyste am Oberarm"
    ]
  },
  {
    "code": "M85.43",
    "name": "Solitäre Knochenzyste am Unterarm",
    "synonyms": [
      "Solitäre Knochenzyste am Unterarm"
    ]
  },
  {
    "code": "M85.44",
    "name": "Solitäre Knochenzyste an der Hand",
    "synonyms": [
      "Solitäre Knochenzyste an der Hand"
    ]
  },
  {
    "code": "M85.45",
    "name": "Solitäre Knochenzyste am Oberschenkel",
    "synonyms": [
      "Solitäre Knochenzyste am Oberschenkel"
    ]
  },
  {
    "code": "M85.46",
    "name": "Solitäre Knochenzyste am Unterschenkel",
    "synonyms": [
      "Solitäre Knochenzyste am Unterschenkel"
    ]
  },
  {
    "code": "M85.47",
    "name": "Solitäre Knochenzyste am Fuß",
    "synonyms": [
      "Solitäre Knochenzyste am Fuß"
    ]
  },
  {
    "code": "M85.49",
    "name": "Solitäre Knochenzyste",
    "synonyms": [
      "Solitäre Knochenzyste"
    ]
  },
  {
    "code": "M85.59",
    "name": "Aneurysmatische Knochenzyste",
    "synonyms": [
      "Aneurysmatische Knochenzyste"
    ]
  },
  {
    "code": "M85.65",
    "name": "Kokzygealzyste",
    "synonyms": [
      "Kokzygealzyste"
    ]
  },
  {
    "code": "M85.66",
    "name": "Angeborene Tibiaknochenzyste",
    "synonyms": [
      "Angeborene Tibiaknochenzyste"
    ]
  },
  {
    "code": "M85.69",
    "name": "Knochenzyste a.n.k.",
    "synonyms": [
      "Knochenzyste a.n.k.",
      "Ostitis fibrosa a.n.k."
    ]
  },
  {
    "code": "M85.81",
    "name": "Isolierte sternokostoklavikuläre Hyperostose",
    "synonyms": [
      "Isolierte sternokostoklavikuläre Hyperostose"
    ]
  },
  {
    "code": "M85.89",
    "name": "Knochenrarefikation",
    "synonyms": [
      "Disseminierte Knochenverdichtung",
      "Disseminierte erhöhte Knochendichte",
      "Erhöhte Knochendichte",
      "Erworbene Osteosklerose",
      "Fleckig erhöhte Knochendichte",
      "Fleckige Knochenverdichtung",
      "Generalisierte Knochenverdichtung",
      "Generalisierte erhöhte Knochendichte",
      "Hyperostose",
      "Hyperostosis",
      "Knochenerosion",
      "Knochenrarefikation",
      "Knochensubstanzverlust",
      "Léri-Joanny-Syndrom [Melorheostose]",
      "Melorheostose",
      "Melorheostose der Knochen",
      "Osteopenie",
      "Osteosis eburnisata monomelica"
    ]
  },
  {
    "code": "M85.99",
    "name": "Störung der Knochenstruktur",
    "synonyms": [
      "Störung der Knochendichte",
      "Störung der Knochenstruktur"
    ]
  },
  {
    "code": "M86.09",
    "name": "Akute hämatogene Osteomyelitis",
    "synonyms": [
      "Akute hämatogene Osteomyelitis",
      "Akute septische Osteomyelitis"
    ]
  },
  {
    "code": "M86.19",
    "name": "Akute Osteomyelitis",
    "synonyms": [
      "Akute Osteomyelitis",
      "Akute Osteomyelitis bei Periostitis",
      "Periostaler Abszess mit akuter Osteomyelitis"
    ]
  },
  {
    "code": "M86.29",
    "name": "Subakute Osteomyelitis",
    "synonyms": [
      "Subakute Osteomyelitis",
      "Subakute Osteomyelitis bei Periostitis"
    ]
  },
  {
    "code": "M86.30",
    "name": "Chronische multifokale Osteomyelitis",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis",
      "Chronische multifokale Osteomyelitis"
    ]
  },
  {
    "code": "M86.31",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis in der Schulterregion",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis in der Schulterregion"
    ]
  },
  {
    "code": "M86.32",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis am Oberarm",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis am Oberarm"
    ]
  },
  {
    "code": "M86.33",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis am Unterarm",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis am Unterarm"
    ]
  },
  {
    "code": "M86.34",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis an der Hand",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis an der Hand"
    ]
  },
  {
    "code": "M86.35",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis am Oberschenkel",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis am Oberschenkel",
      "Chronisch rekurrierende multifokale Osteomyelitis in der Beckenregion"
    ]
  },
  {
    "code": "M86.36",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis am Unterschenkel",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis am Unterschenkel"
    ]
  },
  {
    "code": "M86.37",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis am Fuß",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis am Fuß"
    ]
  },
  {
    "code": "M86.38",
    "name": "Chronisch rekurrierende multifokale Osteomyelitis an der Wirbelsäule",
    "synonyms": [
      "Chronisch rekurrierende multifokale Osteomyelitis an der Wirbelsäule"
    ]
  },
  {
    "code": "M86.39",
    "name": "SAPHO [Synovitis, Akne, Pustulosis, Hyperostose, Osteitis]-Syndrom",
    "synonyms": [
      "DIRA [Defizienz des Interleukin-1-Rezeptor-Antagonisten]",
      "Majeed-Syndrom",
      "SAPHO [Synovitis, Akne, Pustulosis, Hyperostose, Osteitis]-Syndrom",
      "Sterile multifokale Osteomyelitis mit Periostitis und Pustulose"
    ]
  },
  {
    "code": "M86.49",
    "name": "Chronische Osteomyelitis mit Knochenfistel",
    "synonyms": [
      "Chronische Osteomyelitis mit Drainagesinus",
      "Chronische Osteomyelitis mit Knochenfistel"
    ]
  },
  {
    "code": "M86.59",
    "name": "Chronische hämatogene Osteomyelitis a.n.k.",
    "synonyms": [
      "Chronische hämatogene Osteomyelitis a.n.k."
    ]
  },
  {
    "code": "M86.69",
    "name": "Knochensequester",
    "synonyms": [
      "Chronische Osteomyelitis",
      "Chronische Osteomyelitis bei Periostitis a.n.k.",
      "Chronischer Knochenabszess",
      "Knochensequester",
      "Periostaler Abszess mit chronischer Osteomyelitis"
    ]
  },
  {
    "code": "M86.81",
    "name": "Schulterblattabszess",
    "synonyms": [
      "Schulterblattabszess"
    ]
  },
  {
    "code": "M86.88",
    "name": "Perikranielle Eiterung",
    "synonyms": [
      "Perikranielle Eiterung",
      "Pott-Geschwulst",
      "Pott-Tumor"
    ]
  },
  {
    "code": "M86.89",
    "name": "Diaphysitis",
    "synonyms": [
      "Brodie-Abszess",
      "Diaphysenentzündung",
      "Diaphysitis",
      "Garré-Osteomyelitis",
      "Garré-Syndrom",
      "Knochengranulom",
      "Knochengranulom durch residualen Fremdkörper",
      "Knochenulkus",
      "Nichteitrige Osteomyelitis",
      "Osteoperiostitis",
      "Periostaler Abszess mit Osteomyelitis",
      "Periostitis mit Osteomyelitis",
      "Periostose mit Osteomyelitis",
      "Sesamoiditis",
      "Sklerosierende Garré-Ostitis",
      "Sklerosierende nichteitrige Osteomyelitis",
      "Sklerosierende nichteitrige Ostitis"
    ]
  },
  {
    "code": "M86.93",
    "name": "Styloiditis radii",
    "synonyms": [
      "Styloiditis radii",
      "Styloiditis ulnae"
    ]
  },
  {
    "code": "M86.95",
    "name": "Trochanterabszess",
    "synonyms": [
      "Hüftkopfosteomyelitis",
      "Osteomyelitis der Hüfte",
      "Osteomyelitis des Femur",
      "Trochanterabszess"
    ]
  },
  {
    "code": "M86.97",
    "name": "Periostitis der Ferse",
    "synonyms": [
      "Osteomyelitis des Fußes",
      "Periostitis der Ferse"
    ]
  },
  {
    "code": "M86.98",
    "name": "Schläfenbeinosteomyelitis",
    "synonyms": [
      "Schläfenbeinosteomyelitis"
    ]
  },
  {
    "code": "M86.99",
    "name": "Ostitis",
    "synonyms": [
      "Daktylitis mit Knochenbeteiligung",
      "Diffuse Periostitis",
      "Infektiöse Osteomyelitis",
      "Infektiöse Periostitis",
      "Knocheneiterung",
      "Knochenentzündung",
      "Knochenhautentzündung",
      "Knocheninfektion a.n.k.",
      "Knochenmarkentzündung",
      "Knochenmarkphlegmone",
      "Konnatale Periostitis",
      "Osteomyelitis",
      "Ostitis",
      "Periostabszess",
      "Periostaler Abszess",
      "Periostitis",
      "Septische Osteomyelitis",
      "Subperiostaler Knochenabszess",
      "Suppurative Osteomyelitis",
      "Umschriebene Periostitis"
    ]
  },
  {
    "code": "M87.00",
    "name": "Idiopathische avaskuläre Nekrose an mehreren Lokalisationen",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M87.01",
    "name": "Idiopathische avaskuläre Nekrose in der Schulterregion",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose in der Schulterregion"
    ]
  },
  {
    "code": "M87.02",
    "name": "Idiopathische avaskuläre Nekrose am Oberarm",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose am Oberarm"
    ]
  },
  {
    "code": "M87.03",
    "name": "Idiopathische avaskuläre Nekrose am Unterarm",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose am Unterarm"
    ]
  },
  {
    "code": "M87.04",
    "name": "Idiopathische avaskuläre Nekrose an der Hand",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose an der Hand"
    ]
  },
  {
    "code": "M87.05",
    "name": "Aseptische Osteonekrose des medialen Femurkondylus",
    "synonyms": [
      "Aseptische Knochennekrose des medialen Femurkondylus",
      "Aseptische Osteonekrose des medialen Femurkondylus",
      "Femurrollennekrose",
      "Idiopathische avaskuläre Nekrose am Oberschenkel",
      "Idiopathische avaskuläre Nekrose in der Beckenregion",
      "Morbus Ahlbäck [Aseptische Osteonekrose des medialen Femurkondylus]"
    ]
  },
  {
    "code": "M87.06",
    "name": "Idiopathische avaskuläre Nekrose am Unterschenkel",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose am Unterschenkel"
    ]
  },
  {
    "code": "M87.07",
    "name": "Idiopathische avaskuläre Nekrose am Fuß",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose am Fuß"
    ]
  },
  {
    "code": "M87.08",
    "name": "Idiopathische avaskuläre Nekrose an der Wirbelsäule",
    "synonyms": [
      "Idiopathische avaskuläre Nekrose an der Wirbelsäule"
    ]
  },
  {
    "code": "M87.09",
    "name": "Idiopathische aseptische Knochennekrose",
    "synonyms": [
      "Avaskuläre idiopathische Knochennekrose",
      "Idiopathische aseptische Knochennekrose",
      "Idiopathische avaskuläre Nekrose"
    ]
  },
  {
    "code": "M87.10",
    "name": "Sekundäre nicht-traumatische avaskuläre Knochennekrose durch Arzneimittel an mehreren Lokalisationen",
    "synonyms": [
      "Knochennekrose durch Arzneimittel an mehreren Lokalisationen",
      "Sekundäre nicht-traumatische avaskuläre Knochennekrose durch Arzneimittel an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M87.11",
    "name": "Knochennekrose durch Arzneimittel in der Schulterregion",
    "synonyms": [
      "Knochennekrose durch Arzneimittel in der Schulterregion"
    ]
  },
  {
    "code": "M87.12",
    "name": "Knochennekrose durch Arzneimittel am Oberarm",
    "synonyms": [
      "Knochennekrose durch Arzneimittel am Oberarm"
    ]
  },
  {
    "code": "M87.13",
    "name": "Knochennekrose durch Arzneimittel am Unterarm",
    "synonyms": [
      "Knochennekrose durch Arzneimittel am Unterarm"
    ]
  },
  {
    "code": "M87.14",
    "name": "Knochennekrose durch Arzneimittel an der Hand",
    "synonyms": [
      "Knochennekrose durch Arzneimittel an der Hand"
    ]
  },
  {
    "code": "M87.15",
    "name": "Sekundäre nicht-traumatische avaskuläre Femurkopfnekrose durch Arzneimittel",
    "synonyms": [
      "Knochennekrose durch Arzneimittel am Oberschenkel",
      "Knochennekrose durch Arzneimittel in der Beckenregion",
      "Sekundäre nicht-traumatische avaskuläre Femurkopfnekrose durch Arzneimittel"
    ]
  },
  {
    "code": "M87.16",
    "name": "Knochennekrose durch Arzneimittel am Unterschenkel",
    "synonyms": [
      "Knochennekrose durch Arzneimittel am Unterschenkel"
    ]
  },
  {
    "code": "M87.17",
    "name": "Knochennekrose durch Arzneimittel am Fuß",
    "synonyms": [
      "Knochennekrose durch Arzneimittel am Fuß"
    ]
  },
  {
    "code": "M87.18",
    "name": "Knochennekrose durch Arzneimittel an der Wirbelsäule",
    "synonyms": [
      "Knochennekrose durch Arzneimittel an der Wirbelsäule"
    ]
  },
  {
    "code": "M87.19",
    "name": "Knochennekrose durch Arzneimittel",
    "synonyms": [
      "Knochennekrose durch Arzneimittel",
      "Sekundäre nicht-traumatische avaskuläre Knochennekrose durch Arzneimittel"
    ]
  },
  {
    "code": "M87.20",
    "name": "Traumatische avaskuläre Nekrose an mehreren Lokalisationen",
    "synonyms": [
      "Traumatische avaskuläre Nekrose an mehreren Lokalisationen"
    ]
  },
  {
    "code": "M87.21",
    "name": "Traumatische avaskuläre Nekrose in der Schulterregion",
    "synonyms": [
      "Traumatische avaskuläre Nekrose in der Schulterregion"
    ]
  },
  {
    "code": "M87.22",
    "name": "Traumatische avaskuläre Nekrose am Oberarm",
    "synonyms": [
      "Traumatische avaskuläre Nekrose am Oberarm"
    ]
  },
  {
    "code": "M87.23",
    "name": "Traumatische avaskuläre Nekrose am Unterarm",
    "synonyms": [
      "Traumatische avaskuläre Nekrose am Unterarm"
    ]
  },
  {
    "code": "M87.24",
    "name": "Preiser-Syndrom",
    "synonyms": [
      "Köhler-Mouchet-Syndrom",
      "Preiser-Krankheit",
      "Preiser-Syndrom",
      "Traumatische avaskuläre Nekrose an der Hand"
    ]
  },
  {
    "code": "M87.25",
    "name": "Traumatische avaskuläre Nekrose in der Beckenregion",
    "synonyms": [
      "Traumatische avaskuläre Nekrose am Oberschenkel",
      "Traumatische avaskuläre Nekrose in der Beckenregion"
    ]
  },
  {
    "code": "M87.26",
    "name": "Traumatische avaskuläre Nekrose am Unterschenkel",
    "synonyms": [
      "Traumatische avaskuläre Nekrose am Unterschenkel"
    ]
  },
  {
    "code": "M87.27",
    "name": "Traumatische avaskuläre Nekrose am Fuß",
    "synonyms": [
      "Traumatische avaskuläre Nekrose am Fuß"
    ]
  },
  {
    "code": "M87.29",
    "name": "Knochennekrose durch vorangegangenes Trauma",
    "synonyms": [
      "Knochennekrose durch vorangegangenes Trauma",
      "Traumatische avaskuläre Nekrose"
    ]
  },
  {
    "code": "M87.35",
    "name": "Sekundäre nicht-traumatische avaskuläre Femurkopfnekrose",
    "synonyms": [
      "Sekundäre nicht-traumatische avaskuläre Femurkopfnekrose"
    ]
  },
  {
    "code": "M87.39",
    "name": "Sekundäre Knochennekrose a.n.k.",
    "synonyms": [
      "Sekundäre Knochennekrose a.n.k.",
      "Sekundäre nicht-traumatische avaskuläre Knochennekrose"
    ]
  },
  {
    "code": "M87.85",
    "name": "Familiäre avaskuläre Nekrose des Femurkopfes",
    "synonyms": [
      "Familiäre avaskuläre Nekrose des Femurkopfes"
    ]
  },
  {
    "code": "M87.95",
    "name": "Hüftkopfnekrose",
    "synonyms": [
      "Aseptische Hüftnekrose",
      "Avaskuläre Hüftnekrose",
      "Hüftkopfnekrose"
    ]
  },
  {
    "code": "M87.98",
    "name": "Wirbelnekrose",
    "synonyms": [
      "Wirbelnekrose",
      "Wirbelsäulennekrose"
    ]
  },
  {
    "code": "M87.99",
    "name": "Knochennekrose - s.a. Osteonekrose",
    "synonyms": [
      "Aseptische Knochennekrose",
      "Avaskuläre Knochennekrose",
      "Knocheninfarkt",
      "Knochennekrose - s.a. Osteonekrose",
      "Osteonekrose - s.a. Nekrose, Knochen"
    ]
  },
  {
    "code": "M88.0",
    "name": "Osteodystrophia deformans des Schädelknochens",
    "synonyms": [
      "Osteodystrophia deformans des Schädelknochens",
      "Ostitis deformans des Schädels"
    ]
  },
  {
    "code": "M88.88",
    "name": "Wirbelsäulenverkrümmung durch Ostitis deformans",
    "synonyms": [
      "Wirbelsäulenverkrümmung durch Ostitis deformans"
    ]
  },
  {
    "code": "M88.99",
    "name": "Osteodystrophia deformans",
    "synonyms": [
      "Hyperostosis corticalis deformans juvenilis",
      "Juveniles Paget-Syndrom",
      "Morbus Paget des Knochens",
      "Osteodystrophia deformans",
      "Osteodystrophia fibrosa localisata",
      "Ostitis deformans",
      "Paget-Krankheit des Knochens",
      "Paget-Syndrom"
    ]
  },
  {
    "code": "M89.09",
    "name": "Algoneurodystrophie",
    "synonyms": [
      "Algodystrophie",
      "Algoneurodystrophie",
      "Kienböck-Meisel-Krankheit",
      "Leriche-Krankheit",
      "Neurodystrophie",
      "Schulter-Hand-Syndrom"
    ]
  },
  {
    "code": "M89.19",
    "name": "Stillstand des Epiphysenwachstums",
    "synonyms": [
      "Harris-Wachstumslinie",
      "Stillstand des Epiphysenwachstums"
    ]
  },
  {
    "code": "M89.29",
    "name": "Verzögerung des enchondralen Knochenwachstums",
    "synonyms": [
      "Entwicklungsstillstand der Knochen",
      "Retardierung des enchondralen Knochenwachstums",
      "Störung der Knochenentwicklung mit Wachstumsstörung a.n.k.",
      "Verzögerung des enchondralen Knochenwachstums",
      "Wachstumsstillstand der Knochen"
    ]
  },
  {
    "code": "M89.37",
    "name": "Kahnbeinhypertrophie des Fußes",
    "synonyms": [
      "Kahnbeinhypertrophie des Fußes",
      "Mittelfußknochenhypertrophie"
    ]
  },
  {
    "code": "M89.39",
    "name": "Knochenhypertrophie",
    "synonyms": [
      "Knochenhyperplasie",
      "Knochenhypertrophie",
      "Knochenverdickung",
      "Periostverdickung"
    ]
  },
  {
    "code": "M89.47",
    "name": "Fußhöcker",
    "synonyms": [
      "Fußhöcker"
    ]
  },
  {
    "code": "M89.48",
    "name": "Kranio-Osteoarthropathie",
    "synonyms": [
      "Kranio-Osteoarthropathie"
    ]
  },
  {
    "code": "M89.49",
    "name": "Osteoperiostitis ossificans toxica",
    "synonyms": [
      "Bamberger-Marie-Krankheit",
      "Marie-Bamberger-Syndrom",
      "Osteopathia hypertrophicans toxica",
      "Osteoperiostitis ossificans toxica",
      "Osteopulmonale Arthropathie",
      "Pachydermoperiostose",
      "Pulmonale hypertrophische Osteoarthropathie",
      "Sekundäre hypertrophische Osteoarthropathie",
      "Touraine-Solente-Golé-Syndrom",
      "Uehlinger-Syndrom"
    ]
  },
  {
    "code": "M89.50",
    "name": "Multizentrische karpotarsale Osteolyse",
    "synonyms": [
      "Multizentrische karpotarsale Osteolyse",
      "Pacman-Dysplasie",
      "Syndrom der Osteolyse von Talus, Patella und Skaphoid"
    ]
  },
  {
    "code": "M89.54",
    "name": "Transitorische Osteolyse der Phalangen",
    "synonyms": [
      "Osteolyse an der Hand",
      "Transitorische Osteolyse der Phalangen"
    ]
  },
  {
    "code": "M89.58",
    "name": "Idiopathische phalangeale Akroosteolyse",
    "synonyms": [
      "Idiopathische phalangeale Akroosteolyse"
    ]
  },
  {
    "code": "M89.59",
    "name": "Osteolyse",
    "synonyms": [
      "Autosomal-dominante Akroosteolyse",
      "Diffuse zystische Knochenangiomatose",
      "Expansile familiäre Osteolyse",
      "Gorham-Krankheit",
      "Gorham-Stout-Krankheit",
      "Gorham-Stout-Syndrom",
      "Gorham-Syndrom",
      "Idiopathische progrediente Osteolyse",
      "Massive Gorham-Osteolyse",
      "Massive idiopathische Osteolyse",
      "Massive progressive Osteolyse",
      "Nichttraumatische osteolytische Schädigung",
      "Osteolyse",
      "Vanishing-Bone-Disease"
    ]
  },
  {
    "code": "M89.69",
    "name": "Osteopathie nach Poliomyelitis",
    "synonyms": [
      "Osteopathie nach Poliomyelitis"
    ]
  },
  {
    "code": "M89.81",
    "name": "Schulterblattknarren",
    "synonyms": [
      "Schulterblattknarren",
      "Skapulalgie"
    ]
  },
  {
    "code": "M89.85",
    "name": "Ansatzperiostose des Kreuz-Darmbein-Gelenks",
    "synonyms": [
      "Ansatzperiostose des Kreuz-Darmbein-Gelenks",
      "Femurkopfabflachung"
    ]
  },
  {
    "code": "M89.86",
    "name": "Tibiaschmerzen",
    "synonyms": [
      "Tibiaschmerzen"
    ]
  },
  {
    "code": "M89.88",
    "name": "Gleitrippe",
    "synonyms": [
      "Cyriax-Syndrom",
      "Gleitrippe",
      "Rippenverschiebung",
      "Schmerzen des Xiphoids",
      "Xiphoid-Syndrom"
    ]
  },
  {
    "code": "M89.89",
    "name": "Degenerative Knochenerkrankung",
    "synonyms": [
      "Caffey-Krankheit",
      "Caffey-Silverman-Syndrom",
      "Degenerative Knochenerkrankung",
      "Degenerative Skelettveränderung",
      "Destruierender Knochenprozess",
      "Hyperostosis corticalis infantilis",
      "Hyperplastische Periostose",
      "Infantile kortikale Hyperostose",
      "Knochendegeneration a.n.k.",
      "Knochendestruktion",
      "Knochenfistel",
      "Knochennarbe",
      "Knochenschmerzen",
      "Nichtossifizierendes Knochenfibrom",
      "Ossalgie",
      "Ostealgie",
      "Osteodynie",
      "Periostalgie",
      "Periostdysplasie",
      "Periostkrankheit",
      "Periostose",
      "Posttraumatische subperiostale Ossifikation",
      "Senile Knochenatrophie a.n.k.",
      "Subperiostale Blutung",
      "Subperiostale Hämorrhagie"
    ]
  },
  {
    "code": "M89.92",
    "name": "Exostose des Olekranon",
    "synonyms": [
      "Exostose des Olekranon"
    ]
  },
  {
    "code": "M89.95",
    "name": "Trochantermassivexostose",
    "synonyms": [
      "Trochantermassivexostose"
    ]
  },
  {
    "code": "M89.98",
    "name": "Xiphoidalgie",
    "synonyms": [
      "Xiphoidalgie"
    ]
  },
  {
    "code": "M89.99",
    "name": "Exostose",
    "synonyms": [
      "Exostose",
      "Knochenkrankheit",
      "Knochenstörung",
      "Knochenveränderung",
      "Nichttraumatischer Knochenschaden",
      "Osteopathie"
    ]
  },
  {
    "code": "M91.0",
    "name": "Juvenile Osteochondrose des Beckens",
    "synonyms": [
      "Buchmann-Krankheit",
      "Buchmann-Osteochondrose",
      "Juvenile Osteochondrose der Symphyse",
      "Juvenile Osteochondrose der Symphysis pubica",
      "Juvenile Osteochondrose der Synchondrosis ischiopubica",
      "Juvenile Osteochondrose des Azetabulums",
      "Juvenile Osteochondrose des Beckens",
      "Juvenile Osteochondrose des Darmbeinkamms",
      "Odelberg-Krankheit",
      "Osteochondropathia ischiopubica",
      "Osteochondrose der Synchondrosis ischiopubica",
      "Pierson-Krankheit",
      "Pierson-Osteochondrose",
      "Van-Neck-Krankheit",
      "Van-Neck-Odelberg-Krankheit",
      "Van-Neck-Osteochondrose",
      "Van-Neck-Syndrom"
    ]
  },
  {
    "code": "M91.1",
    "name": "Morbus Calvé-Legg-Perthes [Osteochondrosis deformans coxae juvenilis]",
    "synonyms": [
      "Calvé-Legg-Perthes-Krankheit",
      "Calvé-Legg-Perthes-Osteochondrose",
      "Calvé-Legg-Perthes-Syndrom",
      "Juvenile Femurosteochondrose",
      "Juvenile Osteochondrose des Caput femoris",
      "Juvenile Osteochondrose des Femurkopfes",
      "Legg-Krankheit",
      "Morbus Calvé-Legg-Perthes [Osteochondrosis deformans coxae juvenilis]",
      "Morbus Perthes",
      "Osteochondropathia deformans coxae juvenilis",
      "Osteochondrosis deformans coxae juvenilis",
      "Perthes-Krankheit",
      "Perthes-Osteochondrose"
    ]
  },
  {
    "code": "M91.2",
    "name": "Coxa plana",
    "synonyms": [
      "Abflachung der Hüfte",
      "Coxa plana",
      "Hüftdeformität durch vorangegangene juvenile Osteochondrose"
    ]
  },
  {
    "code": "M91.3",
    "name": "Pseudokoxalgie",
    "synonyms": [
      "Pseudokoxalgie",
      "Pseudokoxitis"
    ]
  },
  {
    "code": "M91.8",
    "name": "Juvenile Osteochondrose nach Korrektur einer angeborenen Hüftluxation",
    "synonyms": [
      "Juvenile Osteochondrose nach Korrektur einer angeborenen Hüftluxation"
    ]
  },
  {
    "code": "M91.9",
    "name": "Juvenile Osteochondrose der Hüfte",
    "synonyms": [
      "Juvenile Osteochondrose der Hüfte"
    ]
  },
  {
    "code": "M92.0",
    "name": "Juvenile Osteochondrose des Humerus",
    "synonyms": [
      "Aseptische Nekrose des Capitulum humeri",
      "Hass-Krankheit",
      "Hass-Osteochondrose",
      "Hass-Syndrom",
      "Hegemann-Krankheit der Trochlea humeri",
      "Juvenile Osteochondrose des Capitulum humeri",
      "Juvenile Osteochondrose des Caput humeri",
      "Juvenile Osteochondrose des Humerus",
      "Osteochondrose des Capitulum humeri",
      "Panner-Krankheit",
      "Panner-Osteochondrose",
      "Panner-Syndrom"
    ]
  },
  {
    "code": "M92.1",
    "name": "Juvenile Osteochondrose des Radius",
    "synonyms": [
      "Burns-Krankheit",
      "Burns-Osteochondrose",
      "Burns-Syndrom",
      "Hegemann-Krankheit des Caput radii",
      "Hegemann-Osteochondrose",
      "Hegemann-Syndrom des Caput radii",
      "Juvenile Osteochondrose der Ulna",
      "Juvenile Osteochondrose der distalen Ulnaepiphyse",
      "Juvenile Osteochondrose des Caput radii",
      "Juvenile Osteochondrose des Radius"
    ]
  },
  {
    "code": "M92.2",
    "name": "Juvenile Osteochondrose der Hand",
    "synonyms": [
      "Aseptische Mondbeinnekrose",
      "Juvenile Kienböck-Krankheit",
      "Juvenile Lunatummalazie",
      "Juvenile Mondbeinnekrose",
      "Juvenile Osteochondrose der Hand",
      "Juvenile Osteochondrose der Handwurzelknochen",
      "Juvenile Osteochondrose der Mittelhandknochen",
      "Juvenile Osteochondrose des Metakarpalköpfchens",
      "Juvenile Osteochondrose des Os lunatum der Hand",
      "Juvenile Osteochondrose des Os lunatum der Handwurzel",
      "Kienböck-Krankheit",
      "Kienböck-Osteochondrose",
      "Kienböck-Syndrom",
      "Lunatummalazie",
      "Lunatumnekrose",
      "Mauclaire-Krankheit",
      "Mauclaire-Osteochondrose",
      "Osteochondritis des Mondbeins",
      "Osteochondrose des Os naviculare manus",
      "Osteochondrose des Os scaphoideum"
    ]
  },
  {
    "code": "M92.3",
    "name": "Fleischner-Osteochondrose",
    "synonyms": [
      "Fleischner-Krankheit",
      "Fleischner-Osteochondrose",
      "Friedrich-Osteochondrose",
      "Friedrich-Syndrom",
      "Juvenile Armosteochondrose",
      "Juvenile Osteochondrose der oberen Extremität a.n.k.",
      "Juvenile Osteochondrose der sternalen Klavikulaepiphyse",
      "Thiemann-Krankheit",
      "Thiemann-Osteochondrose",
      "Thiemann-Syndrom"
    ]
  },
  {
    "code": "M92.4",
    "name": "Juvenile Osteochondrose der Patella",
    "synonyms": [
      "Juvenile Osteochondrose der Patella",
      "Juvenile Osteochondrose des primären Patella-Ossifikationszentrums",
      "Juvenile Osteochondrose des sekundären Patella-Ossifikationszentrums",
      "Köhler-Krankheit",
      "Köhler-Osteochondrose der Patella",
      "Larsen-Johansson-Krankheit",
      "Larsen-Johansson-Osteochondrose",
      "Larsen-Johansson-Syndrom",
      "Morbus Sinding-Larsen",
      "Sinding-Larsen-Johansson-Syndrom",
      "Sinding-Larsen-Krankheit"
    ]
  },
  {
    "code": "M92.5",
    "name": "Juvenile Osteochondrose der Tibia",
    "synonyms": [
      "Apophysitis tibialis adolescentium",
      "Blount-Barber-Krankheit",
      "Blount-Barber-Osteochondrose",
      "Blount-Barber-Syndrom",
      "Blount-Krankheit",
      "Blount-Osteochondrose",
      "Blount-Syndrom",
      "Juvenile Osteochondrose der Fibula",
      "Juvenile Osteochondrose der Tibia",
      "Juvenile Osteochondrose der Tuberositas tibiae",
      "Juvenile Osteochondrose des Condylus medialis tibiae",
      "Juvenile Osteochondrose des Schienbeins",
      "Lannelongue-Krankheit",
      "Morbus Osgood-Schlatter",
      "Morbus Schlatter",
      "Osgood-Schlatter-Krankheit",
      "Osgood-Schlatter-Osteochondrose",
      "Osgood-Schlatter-Syndrom",
      "Osteochondrosis deformans tibiae",
      "Tibia vara"
    ]
  },
  {
    "code": "M92.6",
    "name": "Juvenile Osteochondrose des Tarsus",
    "synonyms": [
      "Aseptische Nekrose des Os naviculare pedis",
      "Blencke-Syndrom",
      "Diaz-Krankheit",
      "Diaz-Osteochondrose",
      "Diaz-Syndrom",
      "Haglund-Osteochondrose",
      "Juvenile Kalkaneusosteochondrose",
      "Juvenile Osteochondrose des Astragalus",
      "Juvenile Osteochondrose des Fersenbeins",
      "Juvenile Osteochondrose des Kahnbeins des Fußes",
      "Juvenile Osteochondrose des Os calcis",
      "Juvenile Osteochondrose des Os cuneiforme intermedium",
      "Juvenile Osteochondrose des Os naviculare des Tarsus",
      "Juvenile Osteochondrose des Os naviculare pedis",
      "Juvenile Osteochondrose des Os tibiale externum",
      "Juvenile Osteochondrose des Sprungbeins",
      "Juvenile Osteochondrose des Talus",
      "Juvenile Osteochondrose des Tarsus",
      "Köhler-I-Krankheit",
      "Köhler-Osteochondrose des Os naviculare pedis",
      "Morbus Köhler I",
      "Mouchet-II-Syndrom",
      "Müller-Weiss-Syndrom",
      "Osteochondrose des Talus",
      "Sever-Krankheit",
      "Sever-Osteochondrose",
      "Sever-Syndrom"
    ]
  },
  {
    "code": "M92.7",
    "name": "Juvenile Osteochondrose des Metatarsus",
    "synonyms": [
      "Freiberg-Infraktion",
      "Freiberg-Köhler-II-Krankheit",
      "Freiberg-Köhler-Osteochondrose",
      "Freiberg-Köhler-Syndrom",
      "Iselin-Krankheit",
      "Iselin-Osteochondrose",
      "Iselin-Syndrom",
      "Juvenile Osteochondrose der Mittelfußknochen",
      "Juvenile Osteochondrose des Metatarsus",
      "Juvenile Osteochondrose des Os metatarsale II",
      "Juvenile Osteochondrose des Os metatarsale V",
      "Köhler-II-Krankheit",
      "Köhler-Osteochondrose des Os metatarsale II",
      "Morbus Köhler II",
      "Osteochondrose des Os metatarsale"
    ]
  },
  {
    "code": "M92.8",
    "name": "Kalkaneusapophysitis",
    "synonyms": [
      "Apophysitis calcanei",
      "Juvenile Osteochondrose der unteren Extremität a.n.k.",
      "Juvenile Osteochondrose des Fußes a.n.k.",
      "Kalkaneusapophysitis",
      "König-I-Syndrom",
      "König-Osteochondrose",
      "Osteochondrose des distalen Femurendes"
    ]
  },
  {
    "code": "M92.9",
    "name": "Juvenile Osteochondrose",
    "synonyms": [
      "Juvenile Apophysitis",
      "Juvenile Epiphysitis",
      "Juvenile Osteochondritis",
      "Juvenile Osteochondrose",
      "Osteochondrosis deformans juvenilis"
    ]
  },
  {
    "code": "M93.0",
    "name": "Epiphyseolysis capitis femoris",
    "synonyms": [
      "Epiphysenlösung des Femurkopfes",
      "Epiphyseolysis capitis femoris",
      "Gleiten der oberen Femurepiphyse",
      "Verschiebung der oberen Femurepiphyse"
    ]
  },
  {
    "code": "M93.1",
    "name": "Kienböck-Krankheit beim Erwachsenen",
    "synonyms": [
      "Adulte Osteochondrose des Os lunatum der Hand",
      "Kienböck-Krankheit beim Erwachsenen",
      "Kienböck-Osteochondrose beim Erwachsenen",
      "Kienböck-Syndrom beim Erwachsenen",
      "Lunatummalazie beim Erwachsenen",
      "Mondbeinnekrose beim Erwachsenen",
      "Osteochondrose des Os lunatum der Hand beim Erwachsenen"
    ]
  },
  {
    "code": "M93.26",
    "name": "Osteochondrosis dissecans des Kniegelenks",
    "synonyms": [
      "Osteochondrosis dissecans des Kniegelenks"
    ]
  },
  {
    "code": "M93.29",
    "name": "Osteochondrosis dissecans",
    "synonyms": [
      "Familiäre Osteochondrosis dissecans",
      "Osteochondritis dissecans",
      "Osteochondrosis dissecans"
    ]
  },
  {
    "code": "M93.87",
    "name": "Osteochondrose des Os calcis beim Erwachsenen",
    "synonyms": [
      "Osteochondrose des Os calcis beim Erwachsenen"
    ]
  },
  {
    "code": "M93.88",
    "name": "Osteochondropathie der Wirbelsäule",
    "synonyms": [
      "Osteochondropathie der Wirbelsäule"
    ]
  },
  {
    "code": "M93.89",
    "name": "Adulte Osteochondrose a.n.k.",
    "synonyms": [
      "Adulte Osteochondrose a.n.k."
    ]
  },
  {
    "code": "M93.9",
    "name": "Apophysitis",
    "synonyms": [
      "Apophysitis",
      "Epiphysenlösung",
      "Epiphysennekrose",
      "Epiphysenverschiebung",
      "Epiphyseolyse",
      "Epiphyseolysis",
      "Epiphysitis",
      "Gleitepiphyse",
      "Nichttraumatische Epiphysenlösung",
      "Osteochondritis",
      "Osteochondropathie",
      "Osteochondrose",
      "Osteochondrosis",
      "Traumatische Epiphysenverschiebung",
      "Traumatische Gleitepiphyse"
    ]
  },
  {
    "code": "M94.0",
    "name": "Tietze-Syndrom",
    "synonyms": [
      "Chondritis der Rippen",
      "Chondropathia tuberosa",
      "Kostochondritis",
      "Kostochondrose",
      "Rippenknorpeldystrophie",
      "Tietze-Chondritis der Rippen",
      "Tietze-Krankheit",
      "Tietze-Syndrom"
    ]
  },
  {
    "code": "M94.1",
    "name": "Panchondritis",
    "synonyms": [
      "Panchondritis",
      "Rezidivierende Polychondritis",
      "Von-Meyenburg-Altherr-Uehlinger-Syndrom"
    ]
  },
  {
    "code": "M94.29",
    "name": "Knorpelnekrose",
    "synonyms": [
      "Chondromalacia",
      "Chondromalazie",
      "Knorpelnekrose",
      "Systemische Chondromalazie"
    ]
  },
  {
    "code": "M94.39",
    "name": "Chondrolyse",
    "synonyms": [
      "Chondrolyse"
    ]
  },
  {
    "code": "M94.88",
    "name": "Lumbosakrale Chondrose",
    "synonyms": [
      "Lumbosakrale Chondrose"
    ]
  },
  {
    "code": "M94.89",
    "name": "Knorpelerweichung",
    "synonyms": [
      "Atrophische Polychondritis",
      "Chondritis",
      "Chondrose",
      "Chronische Polychondritis",
      "Eitrige Chondritis",
      "Gelenkknorpelerosion",
      "Knorpelabszess",
      "Knorpelatrophie",
      "Knorpelentzündung",
      "Knorpelerweichung",
      "Knorpelhypertrophie",
      "Knorpelinfektion",
      "Knorpelsubstanzverlust",
      "Polychondritis",
      "Postinfektiöse Knorpelkalzifikation",
      "Purulente Chondritis",
      "Senile Knorpelossifikation"
    ]
  },
  {
    "code": "M94.99",
    "name": "Chondropathie",
    "synonyms": [
      "Chondropathie",
      "Knorpelkrankheit",
      "Knorpelschaden",
      "Knorpelstörung"
    ]
  },
  {
    "code": "M95.0",
    "name": "Hakennase",
    "synonyms": [
      "Erworbene Nasendeformität",
      "Hakennase",
      "Nasenbeindeformität",
      "Nasenverkrümmung",
      "Nasus incurvus",
      "Posttraumatische Schiefnase",
      "Rhinolordose",
      "Satteldeformität der Nase",
      "Sattelnase",
      "Schief-Sattelnase",
      "Schiefnase"
    ]
  },
  {
    "code": "M95.1",
    "name": "Blumenkohlohr",
    "synonyms": [
      "Blumenkohlohr"
    ]
  },
  {
    "code": "M95.2",
    "name": "Schädeldeformation",
    "synonyms": [
      "Deformität des Os frontale",
      "Erworbene Gesichtsdeformität",
      "Erworbene Kinndeformität",
      "Erworbene Kopfdeformität",
      "Erworbene Kraniumdeformität",
      "Erworbene Schädeldeformität",
      "Erworbene Stirnbeindeformität",
      "Erworbene Stirndeformität",
      "Erworbene Wangendeformität",
      "Gesichtsdeformität",
      "Schädeldeformation",
      "Schädeldeformität"
    ]
  },
  {
    "code": "M95.3",
    "name": "Erworbene Halsdeformität",
    "synonyms": [
      "Erworbene Halsdeformität"
    ]
  },
  {
    "code": "M95.4",
    "name": "Kielbrust",
    "synonyms": [
      "Brustkorbdeformität",
      "Erworbene Brustbeindeformität",
      "Erworbene Brustkorbdeformität",
      "Erworbene Kielbrust",
      "Erworbene Schusterbrust",
      "Erworbene Sternumdeformität",
      "Erworbene Sternumretraktion",
      "Erworbene Thoraxdeformität",
      "Erworbene Trichterbrust",
      "Erworbenes Pectus carinatum",
      "Erworbenes Pectus excavatum",
      "Erworbenes Pectus excavatum sive infundibularis",
      "Fassthorax",
      "Kielbrust",
      "Rippendeformität",
      "Schusterbrust",
      "Thoraxdeformität"
    ]
  },
  {
    "code": "M95.5",
    "name": "Erworbene Beckendeformität",
    "synonyms": [
      "Allgemeine Beckenkontraktur",
      "Beckengradstand",
      "Beckenschiefstand",
      "Beckentiefstand",
      "Deformität des Os ilium",
      "Deformität des Os ischii",
      "Erworbene Beckendeformität",
      "Erworbene Beckenkontraktur",
      "Erworbener Beckenschiefstand",
      "Erworbenes Naegele-Becken",
      "Erworbenes Trichterbecken",
      "Erworbenes flaches Becken",
      "Erworbenes infantiles Becken",
      "Erworbenes längsverengtes Becken",
      "Erworbenes schmales Becken"
    ]
  },
  {
    "code": "M95.8",
    "name": "Erworbene Rumpfdeformität",
    "synonyms": [
      "Erworbene Bauchwanddeformität",
      "Erworbene Rumpfdeformität"
    ]
  },
  {
    "code": "M95.9",
    "name": "Erworbene Deformität des Muskel-Skelett-Systems",
    "synonyms": [
      "Erworbene Deformität des Muskel-Skelett-Systems",
      "Erworbene Knochendeformität"
    ]
  },
  {
    "code": "M96.0",
    "name": "Pseudarthrose nach Fusion",
    "synonyms": [
      "Pseudarthrose nach Arthrodese",
      "Pseudarthrose nach Fusion",
      "Pseudarthrose nach Osteotomie"
    ]
  },
  {
    "code": "M96.1",
    "name": "Lumbales Postdiskektomiesyndrom",
    "synonyms": [
      "Epidurale Narbenfibrose nach Diskektomie",
      "Lumbales Postdiskektomiesyndrom",
      "Lumbosakrales Postdiskektomiesyndrom",
      "PDS [Postdiskektomiesyndrom] - s.a. Postdiskektomiesyndrom",
      "Postdiskektomiesyndrom",
      "Postlaminektomiesyndrom a.n.k.",
      "Postnukleotomiesyndrom"
    ]
  },
  {
    "code": "M96.2",
    "name": "Kyphose nach Bestrahlung",
    "synonyms": [
      "Kyphose nach Bestrahlung",
      "Kyphose nach Strahlentherapie"
    ]
  },
  {
    "code": "M96.3",
    "name": "Kyphose nach Laminektomie",
    "synonyms": [
      "Kyphose nach Laminektomie"
    ]
  },
  {
    "code": "M96.4",
    "name": "Postoperative Lordose",
    "synonyms": [
      "Lordose nach chirurgischem Eingriff",
      "Postoperative Lordose"
    ]
  },
  {
    "code": "M96.5",
    "name": "Skoliose nach Bestrahlung",
    "synonyms": [
      "Skoliose nach Bestrahlung",
      "Skoliose nach Strahlentherapie"
    ]
  },
  {
    "code": "M96.6",
    "name": "Knochenfraktur nach Einsetzen eines orthopädischen Implantates",
    "synonyms": [
      "Knochenfraktur nach Einsetzen einer Gelenkprothese",
      "Knochenfraktur nach Einsetzen einer Knochenplatte",
      "Knochenfraktur nach Einsetzen eines orthopädischen Implantates"
    ]
  },
  {
    "code": "M96.80",
    "name": "Elektiv offen belassenes Sternum nach thoraxchirurgischem Eingriff",
    "synonyms": [
      "Elektiv offen belassenes Sternum nach thoraxchirurgischem Eingriff"
    ]
  },
  {
    "code": "M96.81",
    "name": "Instabiler Thorax nach thoraxchirurgischem Eingriff",
    "synonyms": [
      "Instabiler Thorax nach thoraxchirurgischem Eingriff"
    ]
  },
  {
    "code": "M96.82",
    "name": "Verzögerte Knochenheilung nach Fusion",
    "synonyms": [
      "Verzögerte Knochenheilung nach Arthrodese",
      "Verzögerte Knochenheilung nach Fusion",
      "Verzögerte Knochenheilung nach Osteotomie"
    ]
  },
  {
    "code": "M96.88",
    "name": "Gelenkinstabilität nach Entfernen einer Gelenkprothese",
    "synonyms": [
      "Chronische Ischialgie nach Bandscheibenoperation",
      "Elektiv offen belassener Schädelknochen nach neurochirurgischem Eingriff",
      "Elektiver Schädeldefekt nach Entlastungskraniektomie",
      "Elektiver Schädeldefekt nach neurochirurgischem Eingriff",
      "Gelenkinstabilität nach Entfernen einer Gelenkprothese"
    ]
  },
  {
    "code": "M96.9",
    "name": "Störung des Muskel-Skelett-Systems nach medizinischen Maßnahmen",
    "synonyms": [
      "Komplikation des Muskel-Skelett-Systems nach chirurgischem Eingriff",
      "Komplikation des Muskel-Skelett-Systems nach medizinischen Maßnahmen",
      "Störung des Muskel-Skelett-Systems nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "M99.09",
    "name": "Segmentale Funktionsstörung",
    "synonyms": [
      "Segmentale Dysfunktion",
      "Segmentale Funktionsstörung",
      "Somatische Dysfunktion",
      "Somatische Funktionsstörung"
    ]
  },
  {
    "code": "M99.19",
    "name": "Subluxation der Wirbelsäule",
    "synonyms": [
      "Subluxation der Wirbelsäule"
    ]
  },
  {
    "code": "M99.29",
    "name": "Subluxationsstenose des Spinalkanals",
    "synonyms": [
      "Subluxationsstenose des Spinalkanals"
    ]
  },
  {
    "code": "M99.39",
    "name": "Knöcherne Stenose des Spinalkanals",
    "synonyms": [
      "Knöcherne Stenose des Spinalkanals"
    ]
  },
  {
    "code": "M99.49",
    "name": "Bindegewebige Stenose des Spinalkanals",
    "synonyms": [
      "Bindegewebige Stenose des Spinalkanals"
    ]
  },
  {
    "code": "M99.59",
    "name": "Bandscheibenbedingte Stenose des Spinalkanal",
    "synonyms": [
      "Bandscheibenbedingte Stenose des Spinalkanal"
    ]
  },
  {
    "code": "M99.69",
    "name": "Knöcherne Stenose der Foramina intervertebralia",
    "synonyms": [
      "Knöcherne Stenose der Foramina intervertebralia",
      "Subluxationsstenose der Foramina intervertebralia"
    ]
  },
  {
    "code": "M99.79",
    "name": "Stenose der Foramina intervertebralia durch Bandscheiben",
    "synonyms": [
      "Bindegewebige Stenose der Foramina intervertebralia",
      "Stenose der Foramina intervertebralia durch Bandscheiben"
    ]
  },
  {
    "code": "M99.80",
    "name": "Blockierung der Kopfgelenke",
    "synonyms": [
      "Atlantookzipitale Blockierung",
      "Atlasblockierung",
      "Blockierung der Kopfgelenke"
    ]
  },
  {
    "code": "M99.81",
    "name": "Blockierung eines zervikodorsalen Übergangswirbels",
    "synonyms": [
      "Akute Blockierung der Halswirbelsäule",
      "Blockierung der Brust- und Halswirbelsäule",
      "Blockierung der Hals- und Brustwirbelsäule",
      "Blockierung eines zervikodorsalen Übergangswirbels",
      "Blockierung im HWS-Bereich",
      "HWK [Halswirbelkörper]-Blockierung",
      "HWS-BWS-Blockierung",
      "HWS-Blockierung",
      "Rotationsblockierung im HWS-Bereich",
      "Zervikale Blockierung",
      "Zervikothorakale Blockierung"
    ]
  },
  {
    "code": "M99.82",
    "name": "Blockierung im BWS-Bereich",
    "synonyms": [
      "Akute Blockierung der Brustwirbelsäule",
      "BWK [Brustwirbelkörper]-Blockierung",
      "BWS-Blockierung",
      "Blockierung der Brustwirbelsäule",
      "Blockierung im BWS-Bereich",
      "Flexionsblockierung im BWS-Bereich",
      "Thorakale Blockierung"
    ]
  },
  {
    "code": "M99.83",
    "name": "Blockierung der Lendenwirbelsäule",
    "synonyms": [
      "Blockierung L5/S1",
      "Blockierung der Lendenwirbelsäule",
      "Blockierung des Wirbelsäulensegments L5/S1",
      "Blockierung im LWS-Bereich",
      "Flexionsblockierung L5/S1",
      "Flexionsblockierung im LWS-Bereich",
      "LWS-Blockierung",
      "Lumbale Blockierung",
      "Lumbale Spinalstenose als biomechanische Funktionsstörung",
      "Lumbosakrale Blockierung"
    ]
  },
  {
    "code": "M99.84",
    "name": "Iliosakralgelenkblockierung",
    "synonyms": [
      "Blockierung der Iliosakralfuge",
      "Blockierung des Kreuz-Darmbein-Gelenks",
      "Blockierung des Sakroiliakalgelenks",
      "Iliosakralgelenkblockierung"
    ]
  },
  {
    "code": "M99.86",
    "name": "Blockierung des Fibulaköpfchens",
    "synonyms": [
      "Blockierung des Fibulaköpfchens",
      "Blockierung des Tibiofibulargelenks",
      "Blockierung des oberen Sprunggelenks",
      "Blockierung eines Fußwurzelknochens"
    ]
  },
  {
    "code": "M99.87",
    "name": "Blockierung des Radiusköpfchens",
    "synonyms": [
      "Blockierung der Handwurzel",
      "Blockierung des Akromioklavikulargelenks",
      "Blockierung des Handgelenks",
      "Blockierung des Radiusköpfchens"
    ]
  },
  {
    "code": "M99.88",
    "name": "Blockierung eines Rippenwirbelgelenks [Articulatio costovertebralis]",
    "synonyms": [
      "Blockierung der 1. Rippe",
      "Blockierung einer Rippe",
      "Blockierung eines Rippenwirbelgelenks [Articulatio costovertebralis]",
      "Interkostalblockierung"
    ]
  },
  {
    "code": "M99.89",
    "name": "Blockierung eines Extremitätengelenks",
    "synonyms": [
      "Blockierung der Wirbelsäule",
      "Blockierung eines Extremitätengelenks",
      "Chirotherapeutisch behandelbare Gelenkblockierung",
      "Multiple Blockierungen der Wirbelsäule",
      "Multiple WS-Blockierungen"
    ]
  },
  {
    "code": "M99.99",
    "name": "Chirotherapeutisch angehbare Blockierung",
    "synonyms": [
      "Biomechanische Dysfunktion",
      "Biomechanische Funktionsstörung",
      "Chirotherapeutisch angehbare Blockierung",
      "Nichtallopathische Schädigung a.n.k."
    ]
  },
  {
    "code": "N00.0",
    "name": "Akutes nephritisches Syndrom mit minimaler glomerulärer Läsion",
    "synonyms": [
      "Akutes nephritisches Syndrom mit minimaler glomerulärer Läsion",
      "Glomerulusläsion"
    ]
  },
  {
    "code": "N00.1",
    "name": "Akute fokale Nephritis",
    "synonyms": [
      "Akute Herdnephritis",
      "Akute fokale Nephritis"
    ]
  },
  {
    "code": "N00.2",
    "name": "Akutes nephritisches Syndrom mit diffuser membranöser Glomerulonephritis",
    "synonyms": [
      "Akutes nephritisches Syndrom mit diffuser membranöser Glomerulonephritis"
    ]
  },
  {
    "code": "N00.3",
    "name": "Akutes nephritisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis",
    "synonyms": [
      "Akutes nephritisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis",
      "Diffuse mesangioproliferative Glomerulonephritis"
    ]
  },
  {
    "code": "N00.4",
    "name": "Akutes nephritisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis",
    "synonyms": [
      "Akutes nephritisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N00.5",
    "name": "Akutes nephritisches Syndrom mit diffuser mesangiokapillärer Glomerulonephritis",
    "synonyms": [
      "Akutes nephritisches Syndrom mit diffuser mesangiokapillärer Glomerulonephritis"
    ]
  },
  {
    "code": "N00.6",
    "name": "Akutes nephritisches Syndrom mit Dense-deposit-Krankheit",
    "synonyms": [
      "Akutes nephritisches Syndrom mit Dense-deposit-Krankheit"
    ]
  },
  {
    "code": "N00.7",
    "name": "Akutes nephritisches Syndrom mit Glomerulonephritis mit diffuser Halbmondbildung",
    "synonyms": [
      "Akute progrediente Glomerulonephritis",
      "Akutes nephritisches Syndrom mit Glomerulonephritis mit diffuser Halbmondbildung"
    ]
  },
  {
    "code": "N00.8",
    "name": "Akute proliferierende Glomerulonephritis",
    "synonyms": [
      "Akute epitheliale Nephritis",
      "Akute interstitielle Nephritis",
      "Akute interstitielle diffuse Nephritis",
      "Akute proliferierende Glomerulonephritis"
    ]
  },
  {
    "code": "N00.9",
    "name": "Akute Glomerulonephritis",
    "synonyms": [
      "Akute Glomerulitis",
      "Akute Glomerulonephritis",
      "Akute Glomerulonephritis nach Streptokokkeninfektion a.n.k.",
      "Akute Nephritis",
      "Akute Nierenentzündung",
      "Akute Nierenkrankheit",
      "Akute Poststreptokokken-Glomerulonephritis a.n.k.",
      "Akute Poststreptokokken-Nephritis",
      "Akute exsudative Nephritis",
      "Akute glomeruläre Krankheit",
      "Akute glomeruläre Niereninfektion",
      "Akute hämorrhagische Nephritis",
      "Akute katarrhalische Nephritis",
      "Akutes nephritisches Syndrom",
      "Hämorrhagische Glomerulonephritis"
    ]
  },
  {
    "code": "N01.0",
    "name": "Rapid-progressives nephritisches Syndrom mit minimaler glomerulärer Läsion",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit minimaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N01.1",
    "name": "Rapid-progressives nephritisches Syndrom mit fokaler glomerulärer Läsion",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit fokaler glomerulärer Läsion",
      "Rapid-progressives nephritisches Syndrom mit segmentaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N01.2",
    "name": "Rapid-progressives nephritisches Syndrom mit diffuser membranöser Glomerulonephritis",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit diffuser membranöser Glomerulonephritis"
    ]
  },
  {
    "code": "N01.3",
    "name": "Rapid-progressives nephritisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N01.4",
    "name": "Rapid-progressives nephritisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N01.5",
    "name": "Rapid-progressives nephritisches Syndrom mit diffuser mesangiokapillärer Glomerulonephritis",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit diffuser mesangiokapillärer Glomerulonephritis"
    ]
  },
  {
    "code": "N01.6",
    "name": "Rapid-progressives nephritisches Syndrom mit Dense-deposit-Krankheit",
    "synonyms": [
      "Rapid-progressives nephritisches Syndrom mit Dense-deposit-Krankheit"
    ]
  },
  {
    "code": "N01.7",
    "name": "Rapid-progressives nephritisches Syndrom mit Glomerulonephritis mit diffuser Halbmondbildung",
    "synonyms": [
      "Pauci-immune Glomerulonephritis",
      "Rapid-progressives nephritisches Syndrom mit Glomerulonephritis mit diffuser Halbmondbildung"
    ]
  },
  {
    "code": "N01.9",
    "name": "Rapid-progressives nephritisches Syndrom",
    "synonyms": [
      "Rapid-progressive Glomerulonephritis",
      "Rapid-progressive Glomerulonephritis nach Streptokokkeninfektion a.n.k.",
      "Rapid-progressive Nephritis",
      "Rapid-progressive Poststreptokokken-Glomerulonephritis",
      "Rapid-progressive Poststreptokokken-Nephritis",
      "Rapid-progressive glomeruläre Krankheit",
      "Rapid-progressives nephritisches Syndrom",
      "Subakute Nephritis"
    ]
  },
  {
    "code": "N02.0",
    "name": "Rezidivierende Hämaturie mit minimaler glomerulärer Läsion",
    "synonyms": [
      "Rezidivierende Hämaturie mit minimaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N02.1",
    "name": "Rezidivierende Hämaturie mit fokaler glomerulärer Läsion",
    "synonyms": [
      "IgA [Immunglobulin A]-Nephropathie mit glomerulärer Läsion und fokaler Hyalinose",
      "IgA [Immunglobulin A]-Nephropathie mit glomerulärer Läsion und fokaler Sklerose",
      "IgA [Immunglobulin A]-Nephropathie mit glomerulärer Läsion und segmentaler Hyalinose",
      "IgA [Immunglobulin A]-Nephropathie mit glomerulärer Läsion und segmentaler Sklerose",
      "Persistierende Hämaturie bei fokaler glomerulärer Läsion",
      "Persistierende Hämaturie bei segmentaler glomerulärer Läsion",
      "Rezidivierende Hämaturie mit fokaler glomerulärer Läsion",
      "Rezidivierende Hämaturie mit segmentaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N02.2",
    "name": "Rezidivierende Hämaturie mit diffuser membranöser Glomerulonephritis",
    "synonyms": [
      "IgA [Immunglobulin A]-Nephropathie mit membranösen glomerulären Läsionen",
      "Persistierende Hämaturie mit diffuser membranöser Glomerulonephritis",
      "Rezidivierende Hämaturie mit diffuser membranöser Glomerulonephritis"
    ]
  },
  {
    "code": "N02.3",
    "name": "Rezidivierende Hämaturie mit diffuser mesangioproliferativer Glomerulonephritis",
    "synonyms": [
      "IgA [Immunglobulin A]-Nephropathie mit mesangioproliferativen glomerulären Läsionen",
      "Persistierende Hämaturie mit diffuser mesangioproliferativer Glomerulonephritis",
      "Rezidivierende Hämaturie mit diffuser mesangioproliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N02.4",
    "name": "Rezidivierende Hämaturie mit diffuser endokapillär-proliferativer Glomerulonephritis",
    "synonyms": [
      "Persistierende Hämaturie mit diffuser endokapillär-proliferativer Glomerulonephritis",
      "Rezidivierende Hämaturie mit diffuser endokapillär-proliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N02.5",
    "name": "Rezidivierende Hämaturie mit diffuser mesangiokapillärer Glomerulonephritis",
    "synonyms": [
      "IgA [Immunglobulin A]-Nephropathie mit membranoproliferativen glomerulären Läsionen",
      "IgA [Immunglobulin A]-Nephropathie mit mesangiokapillären glomerulären Läsionen",
      "Persistierende Hämaturie mit diffuser mesangiokapillärer Glomerulonephritis",
      "Rezidivierende Hämaturie mit diffuser mesangiokapillärer Glomerulonephritis"
    ]
  },
  {
    "code": "N02.6",
    "name": "Rezidivierende Hämaturie mit Dense-deposit-Krankheit",
    "synonyms": [
      "Persistierende Hämaturie mit Dense-deposit-Krankheit",
      "Rezidivierende Hämaturie mit Dense-deposit-Krankheit"
    ]
  },
  {
    "code": "N02.7",
    "name": "Rezidivierende Hämaturie mit Glomerulonephritis mit diffuser Halbmondbildung",
    "synonyms": [
      "IgA-Glomerulonephritis mit Halbmondbildung",
      "Persistierende Hämaturie mit Glomerulonephritis mit diffuser Halbmondbildung",
      "Rezidivierende Hämaturie mit Glomerulonephritis mit diffuser Halbmondbildung"
    ]
  },
  {
    "code": "N02.8",
    "name": "IgA [Immunglobulin A]-Nephropathie",
    "synonyms": [
      "Berger-Krankheit",
      "IgA [Immunglobulin A]-Nephropathie",
      "IgA [Immunglobulin A]-Nephropathie mit proliferativen glomerulären Läsionen"
    ]
  },
  {
    "code": "N02.9",
    "name": "Rezidivierende Hämaturie",
    "synonyms": [
      "Belastungserythrozyturie",
      "Belastungshämaturie",
      "Gutartige familiäre Hämaturie",
      "Gutartige familiäre Hämaturie beim Kind",
      "Idiopathische Hämaturie",
      "Initiale Makrohämaturie",
      "Intermittierende Hämaturie",
      "Paroxysmale Hämaturie",
      "Persistierende Hämaturie",
      "Rezidivierende Hämaturie",
      "Terminale Makrohämaturie",
      "Totale Makrohämaturie"
    ]
  },
  {
    "code": "N03.0",
    "name": "Chronisches nephritisches Syndrom mit minimaler glomerulärer Läsion",
    "synonyms": [
      "Chronisches nephritisches Syndrom mit minimaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N03.1",
    "name": "Fokale chronische Nephritis",
    "synonyms": [
      "Fokale chronische Nephritis"
    ]
  },
  {
    "code": "N03.2",
    "name": "Chronisches nephritisches Syndrom mit diffuser membranöser Glomerulonephritis",
    "synonyms": [
      "Chronische membranöse Glomerulonephritis",
      "Chronisches nephritisches Syndrom mit diffuser membranöser Glomerulonephritis"
    ]
  },
  {
    "code": "N03.3",
    "name": "Chronisches nephritisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis",
    "synonyms": [
      "Chronisches nephritisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N03.4",
    "name": "Chronisches nephritisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis",
    "synonyms": [
      "Chronisches nephritisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N03.5",
    "name": "Chronische proliferierende Glomerulonephritis",
    "synonyms": [
      "Chronische membranöse proliferierende Glomerulonephritis",
      "Chronische proliferierende Glomerulonephritis"
    ]
  },
  {
    "code": "N03.6",
    "name": "Chronisches nephritisches Syndrom mit Dense-deposit-Krankheit",
    "synonyms": [
      "Chronisches nephritisches Syndrom mit Dense-deposit-Krankheit",
      "Immunotaktoide Glomerulopathie"
    ]
  },
  {
    "code": "N03.7",
    "name": "Chronische progrediente Glomerulonephritis",
    "synonyms": [
      "Chronische progrediente Glomerulonephritis"
    ]
  },
  {
    "code": "N03.8",
    "name": "Chronische proliferative Glomerulonephritis",
    "synonyms": [
      "Chronische diffuse Nephritis",
      "Chronische exsudative Nephritis",
      "Chronische hämorrhagische Nephritis",
      "Chronische proliferative Glomerulonephritis",
      "Nicht-amyloide fibrilläre Glomerulopathie"
    ]
  },
  {
    "code": "N03.9",
    "name": "Chronische Glomerulonephritis",
    "synonyms": [
      "Chronische Glomerulonephritis",
      "Chronische Glomerulonephritis nach Streptokokkeninfektion a.n.k.",
      "Chronische Nephritis",
      "Chronische Nierenentzündung",
      "Chronische Poststreptokokken-Glomerulonephritis a.n.k.",
      "Chronische Poststreptokokken-Nephritis",
      "Chronische glomeruläre Krankheit",
      "Chronisches nephritisches Syndrom"
    ]
  },
  {
    "code": "N04.0",
    "name": "Nephrotisches Syndrom mit minimaler glomerulärer Läsion",
    "synonyms": [
      "Familiäres idiopathisches steroid-resistentes nephrotisches Syndrom mit Minimalläsionen",
      "Nephrotisches Syndrom mit minimaler glomerulärer Läsion",
      "Steroid-sensitives nephrotisches Syndrom"
    ]
  },
  {
    "code": "N04.1",
    "name": "Nephrotisches Syndrom mit fokaler glomerulärer Läsion",
    "synonyms": [
      "Denys-Drash-Syndrom",
      "Drash-Syndrom",
      "Familiäres idiopathisches steroid-resistentes nephrotisches Syndrom mit fokaler und segmentaler Hyalinose",
      "Frasier-Syndrom",
      "Idiopathisches steroid-sensitives Nephrotisches Syndrom mit fokaler und segmentaler Glomerulosklerose",
      "Idiopathisches steroid-sensitives Nephrotisches Syndrom mit fokaler und segmentaler Hyalinose",
      "Nephrotisches Syndrom mit fokaler glomerulärer Läsion",
      "Nephrotisches Syndrom mit segmentaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N04.2",
    "name": "Nephrotisches Syndrom mit diffuser membranöser Glomerulonephritis",
    "synonyms": [
      "Nephrotisches Syndrom mit diffuser membranöser Glomerulonephritis"
    ]
  },
  {
    "code": "N04.3",
    "name": "Nephrotisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis",
    "synonyms": [
      "Familiäres idiopathisches steroid-resistentes nephrotisches Syndrom mit diffuser mesangialer Proliferation",
      "Idiopathisches steroid-sensitives Nephrotisches Syndrom mit diffuser mesangialer Proliferation",
      "Nephrotisches Syndrom mit diffuser mesangioproliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N04.4",
    "name": "Nephrotisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis",
    "synonyms": [
      "Nephrotisches Syndrom mit diffuser endokapillär-proliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N04.5",
    "name": "Nephrotisches Syndrom mit diffuser mesangiokapillärer Glomerulonephritis",
    "synonyms": [
      "Hypokomplementämische Nephrose mit glomerulärer Läsion",
      "Nephrotisches Syndrom mit diffuser mesangiokapillärer Glomerulonephritis"
    ]
  },
  {
    "code": "N04.6",
    "name": "Nephrotisches Syndrom mit Dense-deposit-Krankheit",
    "synonyms": [
      "Nephrotisches Syndrom mit Dense-deposit-Krankheit"
    ]
  },
  {
    "code": "N04.7",
    "name": "Nephrotisches Syndrom mit Glomerulonephritis mit diffuser Halbmondbildung",
    "synonyms": [
      "Nephrotisches Syndrom mit Glomerulonephritis mit diffuser Halbmondbildung"
    ]
  },
  {
    "code": "N04.8",
    "name": "Tubuläre parenchymatöse Nephrose",
    "synonyms": [
      "Familiäres idiopathisches steroid-resistentes nephrotisches Syndrom mit diffuser mesangialer Sklerose",
      "Kongenitale Nephrose vom finnischen Typ",
      "Kongenitales nephrotisches Syndrom vom finnischen Typ",
      "LAMB2-assoziiertes nephrotisches Syndrom mit Beginn im Kindesalter",
      "Paraproteinnephrose",
      "Tubuläre parenchymatöse Nephrose"
    ]
  },
  {
    "code": "N04.9",
    "name": "Glomerulonephrose",
    "synonyms": [
      "Akute Nephrose",
      "Angeborenes nephrotisches Syndrom",
      "Chromoproteinniere [Hämoglobinurische Nephrose]",
      "Epstein-Nephrose",
      "Epstein-Syndrom",
      "Familiäres idiopathisches steroid-resistentes nephrotisches Syndrom",
      "Glomerulonephritis mit Ödem",
      "Glomerulonephrose",
      "Hämoglobinurische Nephrose [Chromoproteinniere]",
      "Idiopathisches steroid-resistentes nephrotisches Syndrom",
      "Idiopathisches steroid-sensitives nephrotisches Syndrom mit sekundärer Steroid-Resistenz",
      "Kongenitale Nephrose",
      "Lipoidnephrose",
      "Nephritis desquamata",
      "Nephritis mit Ödem",
      "Nephrose",
      "Nephrose mit glomerulärer Läsion",
      "Nephrose-Syndrom",
      "Nephrotisches Syndrom",
      "Nierenkapselödem",
      "Nierenrindenverfettung",
      "Protein-Nephrose",
      "Renale Wassersucht",
      "Ödem bei nephrotischem Syndrom"
    ]
  },
  {
    "code": "N05.0",
    "name": "Minimalglomerulonephritis",
    "synonyms": [
      "Minimal-change-Glomerulonephritis",
      "Minimalglomerulonephritis"
    ]
  },
  {
    "code": "N05.1",
    "name": "Fokal proliferierende Glomerulonephritis",
    "synonyms": [
      "Fokal proliferierende Glomerulonephritis",
      "Fokal sklerosierende Glomerulonephritis",
      "Fokale Glomerulosklerose",
      "Glomeruläre Herdnephritis",
      "Herdglomerulitis",
      "Herdnephritis"
    ]
  },
  {
    "code": "N05.2",
    "name": "Membranöse Glomerulonephritis",
    "synonyms": [
      "Idiopathische membranöse Glomerulopathie",
      "Membranöse Glomerulonephritis",
      "Membranöse Glomerulopathie",
      "Primäre membranöse Glomerulonephritis"
    ]
  },
  {
    "code": "N05.5",
    "name": "Membranoproliferative Glomerulonephritis",
    "synonyms": [
      "Membranoproliferative Glomerulonephritis"
    ]
  },
  {
    "code": "N05.7",
    "name": "Progrediente Glomerulonephritis mit Nephritis",
    "synonyms": [
      "Progrediente Glomerulonephritis mit Nephritis"
    ]
  },
  {
    "code": "N05.8",
    "name": "Interkapilläre Glomerulonephritis",
    "synonyms": [
      "Extrakapillär-proliferative Glomerulonephritis",
      "Immunkomplex-Glomerulonephritis a.n.k.",
      "Immunkomplex-Nephritis a.n.k.",
      "Interkapilläre Glomerulonephritis",
      "Kortikale Nekrose bei Nephritis",
      "Kortikale Nekrose bei Nephropathie",
      "Nekrotisierende Glomerulitis",
      "Nekrotisierende Glomerulonephritis",
      "Nephritis durch zirkulierende Immunkomplexe a.n.k.",
      "Proliferierende Glomerulonephritis"
    ]
  },
  {
    "code": "N05.9",
    "name": "Glomerulitis",
    "synonyms": [
      "Abgesunkene glomeruläre Filtration",
      "Bright-Krankheit",
      "GN [Glomerulonephritis] - s.a. Glomerulonephritis",
      "Glomerulitis",
      "Glomerulonephritis",
      "Glomerulonephritis nach Streptokokkeninfektion a.n.k.",
      "Glomerulopathie",
      "Glomeruläre Krankheit",
      "Glomeruläre Störung",
      "Idiopathische non-Lupus-Nephropathie mit Full-house-Muster",
      "Nephritis",
      "Nephritisches Syndrom",
      "Nierenentzündung",
      "Poststreptokokken-Glomerulonephritis a.n.k.",
      "Poststreptokokken-Nephritis a.n.k",
      "Progrediente Glomerulonephritis",
      "Röntgenstrahlennephritis",
      "Strahlennephritis",
      "Subakute Glomerulitis",
      "Virusnephritis"
    ]
  },
  {
    "code": "N06.0",
    "name": "Isolierte Proteinurie mit morphologischer Veränderung bei minimaler glomerulärer Läsion",
    "synonyms": [
      "Isolierte Proteinurie mit morphologischer Veränderung bei minimaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N06.1",
    "name": "Isolierte Proteinurie mit fokaler glomerulärer Läsion",
    "synonyms": [
      "Isolierte Proteinurie mit fokaler glomerulärer Läsion"
    ]
  },
  {
    "code": "N06.2",
    "name": "Isolierte Proteinurie mit diffuser membranöser Glomerulonephritis",
    "synonyms": [
      "Isolierte Proteinurie mit diffuser membranöser Glomerulonephritis",
      "Isolierte Proteinurie mit membranöser glomerulärer Läsion"
    ]
  },
  {
    "code": "N06.3",
    "name": "Isolierte Proteinurie mit diffuser mesangioproliferativer Glomerulonephritis",
    "synonyms": [
      "Isolierte Proteinurie mit diffuser mesangioproliferativer Glomerulonephritis",
      "Isolierte Proteinurie mit mesangioproliferativer glomerulärer Läsion"
    ]
  },
  {
    "code": "N06.4",
    "name": "Isolierte Proteinurie mit diffuser endokapillär-proliferativer Glomerulonephritis",
    "synonyms": [
      "Isolierte Proteinurie mit diffuser endokapillär-proliferativer Glomerulonephritis"
    ]
  },
  {
    "code": "N06.5",
    "name": "Isolierte Proteinurie mit diffuser mesangiokapillärer Glomerulonephritis",
    "synonyms": [
      "Isolierte Proteinurie mit diffuser mesangiokapillärer Glomerulonephritis"
    ]
  },
  {
    "code": "N06.6",
    "name": "Isolierte Proteinurie mit Dense-deposit-Krankheit",
    "synonyms": [
      "Isolierte Proteinurie mit Dense-deposit-Krankheit"
    ]
  },
  {
    "code": "N06.7",
    "name": "Isolierte Proteinurie mit Glomerulonephritis mit diffuser Halbmondbildung",
    "synonyms": [
      "Isolierte Proteinurie mit Glomerulonephritis mit diffuser Halbmondbildung"
    ]
  },
  {
    "code": "N06.9",
    "name": "Isolierte Proteinurie mit glomerulären Läsionen",
    "synonyms": [
      "Isolierte Proteinurie mit glomerulären Läsionen"
    ]
  },
  {
    "code": "N07.6",
    "name": "Fibronektin-Glomerulopathie",
    "synonyms": [
      "Fibronektin-Glomerulopathie",
      "Kollagen Typ 3-Glomerulopathie"
    ]
  },
  {
    "code": "N07.8",
    "name": "Lipoprotein-Glomerulopathie",
    "synonyms": [
      "Lipoprotein-Glomerulopathie"
    ]
  },
  {
    "code": "N07.9",
    "name": "Hereditäre Nephropathie a.n.k.",
    "synonyms": [
      "Hereditäre Nephropathie a.n.k."
    ]
  },
  {
    "code": "N10",
    "name": "Akute tubulointerstitielle Nephritis",
    "synonyms": [
      "Akute Nierenbeckeninfektion",
      "Akute Pyelitis",
      "Akute Pyelonephritis",
      "Akute Zystopyelitis",
      "Akute bakterielle Pyelonephritis",
      "Akute bilaterale Pyelonephritis",
      "Akute infektiöse interstitielle Nephritis",
      "Akute tubulointerstitielle Nephritis",
      "Akute tubulointerstitielle Niereninfektion"
    ]
  },
  {
    "code": "N11.0",
    "name": "Refluxpyelonephritis",
    "synonyms": [
      "Chronische Pyelonephritis mit vesikoureteralem Reflux",
      "Nichtobstruktive Pyelonephritis mit vesikoureteralem Reflux",
      "Pyelonephritis mit Ureterreflux",
      "Pyelonephritis mit vesikoureteralem Reflux",
      "Pyelonephritis mit vesikoureteraler Regurgitation",
      "Refluxpyelonephritis"
    ]
  },
  {
    "code": "N11.1",
    "name": "Chronische obstruktive Pyelonephritis",
    "synonyms": [
      "Chronisch-obstruktive tubulointerstitielle Nephritis",
      "Chronische Pyelonephritis mit Ureterabknickung",
      "Chronische Pyelonephritis mit Ureteranomalie",
      "Chronische Pyelonephritis mit Ureterobstruktion",
      "Chronische Pyelonephritis mit Ureterstriktur",
      "Chronische Pyelonephritis mit pelviureteraler Abknickung",
      "Chronische Pyelonephritis mit pelviureteraler Anomalie",
      "Chronische Pyelonephritis mit pelviureteraler Obstruktion",
      "Chronische Pyelonephritis mit pelviureteraler Striktur",
      "Chronische Pyelonephritis mit pyeloureteraler Abknickung",
      "Chronische Pyelonephritis mit pyeloureteraler Anomalie",
      "Chronische Pyelonephritis mit pyeloureteraler Obstruktion",
      "Chronische Pyelonephritis mit pyeloureteraler Striktur",
      "Chronische obstruktive Pyelonephritis",
      "Obstruktive Pyelonephritis",
      "Obstruktive Pyelonephrose",
      "Pyelonephritis mit Obstruktion",
      "Pyelonephrose",
      "Ureterknick mit Pyelonephritis"
    ]
  },
  {
    "code": "N11.8",
    "name": "Nichtobstruktive chronische Pyelonephritis",
    "synonyms": [
      "Chronische nichtobstruktive tubulointerstitielle Nephritis",
      "IgG4-assoziierte Nierenkrankheit",
      "Karyomegale interstitielle Nephritis",
      "Nichtobstruktive chronische Pyelonephritis"
    ]
  },
  {
    "code": "N11.9",
    "name": "Chronische Zystopyelitis",
    "synonyms": [
      "Chronische Pyelitis",
      "Chronische Pyelonephritis",
      "Chronische Pyelonephrose",
      "Chronische Zystopyelitis",
      "Chronische infektiöse interstitielle Nephritis",
      "Chronische interstitielle Nephritis",
      "Chronische tubulointerstitielle Nephritis",
      "Pyelitis mit Schrumpfniere",
      "Pyelonephritis mit Schrumpfniere",
      "Pyelonephritische Nierenkontraktur",
      "Pyelonephritische Schrumpfniere",
      "Rezidivierende Pyelonephritis"
    ]
  },
  {
    "code": "N12",
    "name": "Aszendierende Nephritis",
    "synonyms": [
      "Abszedierende Pyelonephritis",
      "Antitubuläre Basalmembrannephritis a.n.k.",
      "Aszendierende Nephritis",
      "Bakterielle Pyelonephritis",
      "Eitrige Nephritis",
      "Eitrige Nierenbeckenentzündung",
      "Eitrige Pyelonephritis",
      "Eitrige interstitielle Nephritis",
      "Entzündliche Nierenbeckenkelchveränderung",
      "Entzündliche Nierenkelchveränderung",
      "Gangränöse Nierenbeckenentzündung",
      "Infektiöse Nephritis",
      "Interstitielle Nephritis",
      "Interstitielle Nephropathie",
      "Kalixinfektion",
      "Kongenitale Pyelitis",
      "Nichtobstruktive Pyelonephritis",
      "Nierenbeckenentzündung",
      "Nierenbeckenkelchentzündung",
      "Nierenkelchinfektion",
      "Nierenkrankheit mit interstitieller Nephritis",
      "PN [Pyelonephritis] - s.a. Pyelonephritis",
      "Peripyelitis",
      "Perirenitis",
      "Pustulöse Nephrozystitis",
      "Pyelitis",
      "Pyelonephritis",
      "Pyelozystitis",
      "Pyonephritis",
      "Septische Nephritis",
      "Tubulointerstitielle Nephritis",
      "Tubuläre Nierenkrankheit",
      "Urämische Pyelitis",
      "Zystische Nierenbeckenentzündung",
      "Zystopyelitis",
      "Zystopyelonephritis"
    ]
  },
  {
    "code": "N13.0",
    "name": "Hydronephrose bei ureteropelviner Obstruktion",
    "synonyms": [
      "Abflussbehinderung des Nierenbeckens",
      "Abflussstörung des Nierenbeckens",
      "Hydronephrose bei pelviureteraler Striktur",
      "Hydronephrose bei ureteropelviner Obstruktion",
      "Hydronephrose bei ureteropelviner Striktur"
    ]
  },
  {
    "code": "N13.1",
    "name": "Hydronephrose bei Ureterstriktur a.n.k.",
    "synonyms": [
      "Hydronephrose bei Ureterobstruktion a.n.k.",
      "Hydronephrose bei Ureterstriktur a.n.k.",
      "Ureterknick mit Hydronephrose"
    ]
  },
  {
    "code": "N13.20",
    "name": "Hydronephrose bei Obstruktion durch Nierenstein",
    "synonyms": [
      "Hydronephrose bei Obstruktion durch Nierenstein",
      "Unspezifische Ureteritis mit Nierenstein mit Hydronephrose"
    ]
  },
  {
    "code": "N13.21",
    "name": "Hydronephrose bei Obstruktion durch Ureterstein",
    "synonyms": [
      "Hydronephrose bei Obstruktion durch Ureterstein",
      "Ureterstein mit Hydronephrose"
    ]
  },
  {
    "code": "N13.3",
    "name": "Uronephrose",
    "synonyms": [
      "Abflussstörung der Niere",
      "Atrophische Hydronephrose",
      "Frühhydronephrose",
      "Gestaute Niere",
      "Harnstauungsniere",
      "Hydrokalix",
      "Hydronephrose",
      "Hydronephrose ohne Funktionseinschränkung",
      "Hydronephrotische Nierenatrophie",
      "Hydronephrotische Nierenkontraktur",
      "Hydronephrotische Sackniere",
      "Hydronephrotische Schrumpfniere",
      "Hydronephrotische stumme Niere",
      "Hydropyelon",
      "Intermittierende Hydronephrose",
      "Kalixhydronephrose",
      "Nierenbeckenzyste",
      "Nierenkelchdilatation",
      "Nierenkelchhalsstenose",
      "Nierenkelchhydronephrose",
      "Nierenkelchzyste",
      "Nierenstauung",
      "Primäre Hydronephrose",
      "Pyelektasie",
      "Renale Abflussstörung",
      "Rückstauniere",
      "Sackniere",
      "Sekundäre Hydronephrose a.n.k.",
      "Stauungsniere",
      "Uronephrose",
      "Verstopfungsniere",
      "Wassersackniere",
      "Zystische Nierenbeckenveränderung"
    ]
  },
  {
    "code": "N13.4",
    "name": "Hydroureter",
    "synonyms": [
      "Harnleitererweiterung",
      "Hydropyureter",
      "Hydroureter",
      "Prävesikale Abflussbehinderung",
      "Prävesikale Abflussstörung",
      "Uretererweiterung",
      "Ureterstau"
    ]
  },
  {
    "code": "N13.5",
    "name": "Nierenbeckenabgangsstenose",
    "synonyms": [
      "Bilaterale supravesikale Stenose",
      "Funktionelle Ureterobstruktion a.n.k.",
      "Harnleiterabgangsenge",
      "Harnleiterblockierung",
      "Harnleiterenge",
      "Harnleiterknickung",
      "Harnleiterobstruktion",
      "Harnleiterspasmus",
      "Harnleiterstenose",
      "Harnleiterstriktur",
      "Harnleiterverschluss",
      "Nierenbeckenabgangsenge",
      "Nierenbeckenabgangsstenose",
      "Nierenbeckenausgangstriktur",
      "Pelviureterale Striktur",
      "Pelvoureterale Obstruktion",
      "Postinfektiöse Kontraktur der ureterovesikalen Öffnung",
      "Postinfektiöse Kontraktur des Ostium ureteris",
      "Primär obstruktiver Harnleiter",
      "Primär obstruktiver Ureter",
      "Striktur des Ostium ureteris",
      "Subpelvine Harnleiterstenose",
      "Subpelvine Stenose",
      "Subpelvine Ureterstenose",
      "Supravesikale Obstruktion",
      "Supravesikale Stenose",
      "Unilaterale supravesikale Stenose",
      "Ureterabgangsstenose",
      "Ureterblockierung",
      "Ureterenge",
      "Ureterintussuszeption",
      "Ureterintussuszeption mit Einklemmung",
      "Ureterknick des pelvinen Abgangs",
      "Ureterknickung",
      "Ureterkonstriktion",
      "Uretermündungsstriktur",
      "Ureterobliteration",
      "Ureterobstruktion a.n.k.",
      "Ureteropelvine Striktur",
      "Ureterostiumstenose",
      "Ureterostiumstriktur",
      "Ureterovesikale Striktur",
      "Ureterprolaps mit Verschluss",
      "Ureterschleife",
      "Ureterspasmus",
      "Ureterstenose",
      "Ureterstriktur",
      "Ureterverengung",
      "Ureterverschluss",
      "Ureterverschluss am Beckenübergang",
      "Ureterverschluss am Blaseneingang",
      "Verschluss der ureterovesikalen Öffnung",
      "Verschluss des Ostium ureteris",
      "Verschluss des ureteropelvinen Überganges"
    ]
  },
  {
    "code": "N13.60",
    "name": "Hydronephrose bei ureteropelviner Obstruktion mit Infektion der Niere",
    "synonyms": [
      "Hydronephrose bei ureteropelviner Obstruktion mit Infektion der Niere"
    ]
  },
  {
    "code": "N13.61",
    "name": "Hydronephrose mit Ureterstriktur und Infektion",
    "synonyms": [
      "Hydronephrose bei Ureterstriktur mit Infektion der Niere",
      "Hydronephrose mit Ureterstriktur und Infektion"
    ]
  },
  {
    "code": "N13.62",
    "name": "Hydronephrose bei Obstruktion durch Nierenstein mit Infektion der Niere",
    "synonyms": [
      "Hydronephrose bei Obstruktion durch Nierenstein mit Infektion der Niere"
    ]
  },
  {
    "code": "N13.63",
    "name": "Hydronephrose bei Obstruktion durch Ureterstein mit Infektion der Niere",
    "synonyms": [
      "Hydronephrose bei Obstruktion durch Ureterstein mit Infektion der Niere"
    ]
  },
  {
    "code": "N13.64",
    "name": "Steinbedingte Pyelonephritis mit Hydronephrose",
    "synonyms": [
      "Chronische steinbedingte Pyelitis mit Hydronephrose",
      "Hydronephrose bei Obstruktion durch Stein, mit Infektion der Niere",
      "Hydronephrose mit Stein und Infektion",
      "Nierenabszess mit Stein und Hydronephrose",
      "Steinbedingte Pyelitis mit Hydronephrose",
      "Steinbedingte Pyelonephritis mit Hydronephrose"
    ]
  },
  {
    "code": "N13.65",
    "name": "Hydropyonephrose",
    "synonyms": [
      "Hydronephrose mit Infektion",
      "Hydronephrose mit Infektion der Niere",
      "Hydronephrotische Nierenatrophie mit Infektion",
      "Hydronephrotische Nierenkontraktur mit Infektion",
      "Hydropyonephrose",
      "Infizierte Hydronephrose",
      "Pyohydronephrose"
    ]
  },
  {
    "code": "N13.66",
    "name": "Hydropyoureteronephrose",
    "synonyms": [
      "Hydropyoureteronephrose",
      "Hydroureter mit Infektion",
      "Hydroureter mit Infektion der Niere"
    ]
  },
  {
    "code": "N13.67",
    "name": "Ureterovesikale Striktur mit Infektion",
    "synonyms": [
      "Abknickung des Ureters ohne Hydronephrose mit Infektion der Niere",
      "Kontraktur des Ostium ureteris mit Infektion",
      "Striktur des Ostium ureteris mit Infektion",
      "Striktur des Ureters ohne Hydronephrose mit Infektion der Niere",
      "Ureterknick mit Infektion",
      "Ureterkonstriktion mit Infektion",
      "Ureterobliteration mit Infektion",
      "Ureterovesikale Striktur mit Infektion",
      "Ureterprolaps mit Verschluss und Infektion",
      "Ureterverengung mit Infektion"
    ]
  },
  {
    "code": "N13.68",
    "name": "Akute Pyonephrose",
    "synonyms": [
      "Akute Pyonephrose",
      "Chronische Pyonephrose",
      "Obstruktive Uropathie mit Infektion",
      "Pyonephrose"
    ]
  },
  {
    "code": "N13.7",
    "name": "Vesikopelviner Reflux",
    "synonyms": [
      "Familiärer vesikoureteraler Reflux",
      "Primär refluxiver Harnleiter",
      "Primär refluxiver Ureter",
      "Refluxiver Harnleiter",
      "Refluxiver Ureter",
      "Sekundär obstruktiver Harnleiter",
      "Sekundär obstruktiver Ureter",
      "Sekundär refluxiver Harnleiter",
      "Sekundär refluxiver Ureter",
      "Ureterreflux",
      "Uropathie durch vesikoureteralen Reflux",
      "Vesikopelviner Reflux",
      "Vesikorenaler Reflux",
      "Vesikoureterale Regurgitation",
      "Vesikoureteraler Reflux a.n.k.",
      "Vesikoureteraler Reflux durch Narbenbildung",
      "Vesikoureterorenaler Rückfluss"
    ]
  },
  {
    "code": "N13.8",
    "name": "Obstruktive Nephropathie",
    "synonyms": [
      "Harnleiterdysplasie",
      "Infrarenale Obstruktion",
      "Nierenobstruktion",
      "Nierenstauungsblutung",
      "Obstruktive Nephropathie",
      "Obstruktive Nephrotubulopathie",
      "Ureterdysplasie"
    ]
  },
  {
    "code": "N13.9",
    "name": "Harnabflussbehinderung",
    "synonyms": [
      "Harnabflussbehinderung",
      "Harnabflussstörung",
      "Harnrückstau",
      "Harnstase",
      "Harnstauung",
      "Harnwegsobstruktion",
      "Harnwegsstenose",
      "Harnwegsverschluss",
      "Mechanische Harnabflussstörung",
      "Obstruktive Tubulopathie",
      "Obstruktive Uropathie",
      "Refluxnephropathie",
      "Refluxuropathie",
      "Urinstase"
    ]
  },
  {
    "code": "N14.0",
    "name": "Analgetikanephropathie",
    "synonyms": [
      "Analgetikanephropathie",
      "Analgetikaschrumpfniere",
      "Analgetische Nephropathie",
      "Phenacetin-Nephropathie"
    ]
  },
  {
    "code": "N14.2",
    "name": "Arzneimittelinduzierte Nephropathie",
    "synonyms": [
      "Arzneimittelinduzierte Nephropathie",
      "Osmotische Nephrose"
    ]
  },
  {
    "code": "N14.3",
    "name": "Nephropathie durch Schwermetalle",
    "synonyms": [
      "Bleinephritis",
      "Bleinephropathie",
      "Nephropathie durch Schwermetalle",
      "Schwermetallinduzierte Nephropathie"
    ]
  },
  {
    "code": "N14.4",
    "name": "Toxische Nephropathie a.n.k.",
    "synonyms": [
      "Toxische Nephropathie a.n.k."
    ]
  },
  {
    "code": "N15.0",
    "name": "Balkannephropathie",
    "synonyms": [
      "Balkannephropathie",
      "Chronische endemische Nephropathie",
      "Endemische Balkannephritis",
      "Endemische Balkannephropathie"
    ]
  },
  {
    "code": "N15.10",
    "name": "Nierenabszess",
    "synonyms": [
      "Nephropyosis",
      "Nierenabszess",
      "Nierenkapselabszess",
      "Nierenkarbunkel",
      "Nierenrindenabszess",
      "Renaler Abszess"
    ]
  },
  {
    "code": "N15.11",
    "name": "Paranephritischer Abszess",
    "synonyms": [
      "Eitrige Perinephritis",
      "Paranephritischer Abszess",
      "Pararenaler Abszess",
      "Perinephritischer Abszess",
      "Perirenaler Abszess"
    ]
  },
  {
    "code": "N15.8",
    "name": "Nierengranulom",
    "synonyms": [
      "Gitelman-Syndrom",
      "Nierengranulom"
    ]
  },
  {
    "code": "N15.9",
    "name": "Niereninfektion",
    "synonyms": [
      "Epinephritis",
      "Hämatogene Infektion der Nierenrinde",
      "Niereninfektion",
      "Nierenpolinfektion",
      "Paranephritis",
      "Perinephritis",
      "Perirenale Infektion",
      "Renale Infektion",
      "Tubulointerstitielle Krankheit",
      "Tubulopathie"
    ]
  },
  {
    "code": "N17.01",
    "name": "Akutes Nierenversagen mit Tubulusnekrose, Stadium 1",
    "synonyms": [
      "Akute Tubulusnekrose, Stadium 1",
      "Akutes Nierenversagen mit Tubulusnekrose, Stadium 1",
      "Renale Tubulusnekrose, Stadium 1",
      "Tubulusnekrose, Stadium 1"
    ]
  },
  {
    "code": "N17.02",
    "name": "Akutes Nierenversagen mit Tubulusnekrose, Stadium 2",
    "synonyms": [
      "Akute Tubulusnekrose, Stadium 2",
      "Akutes Nierenversagen mit Tubulusnekrose, Stadium 2",
      "Renale Tubulusnekrose, Stadium 2",
      "Tubulusnekrose, Stadium 2"
    ]
  },
  {
    "code": "N17.03",
    "name": "Akutes Nierenversagen mit Tubulusnekrose, Stadium 3",
    "synonyms": [
      "Akute Tubulusnekrose, Stadium 3",
      "Akutes Nierenversagen mit Tubulusnekrose, Stadium 3",
      "Renale Tubulusnekrose, Stadium 3",
      "Tubulusnekrose, Stadium 3"
    ]
  },
  {
    "code": "N17.09",
    "name": "Akutes Nierenversagen mit Tubulusnekrose",
    "synonyms": [
      "Akute Tubulusnekrose",
      "Akute tubuläre Nephrose",
      "Akutes Nierenversagen mit Tubulusnekrose",
      "Anoxische Nephrose",
      "Anoxische tubuläre Nekrose",
      "Ischämische Nephrose",
      "Nekrotische Nephrose",
      "Nephrose mit Hämoglobinurie",
      "Niereninsuffizienz mit Tubulusnekrose",
      "Nierentubulusnekrose",
      "Nierenversagen mit Tubulusnekrose",
      "Quecksilber-Nephrose",
      "Renale Tubulusnekrose",
      "Sublimatnephrose",
      "Toxische Nephrose",
      "Toxische tubuläre Nekrose",
      "Tubulusnekrose",
      "Tubuläre Nephrose",
      "Tubuläre Nierennekrose",
      "Tubuläre anoxische Nephrose",
      "Tubuläre toxische Nephrose"
    ]
  },
  {
    "code": "N17.11",
    "name": "Renale Rindennekrose, Stadium 1",
    "synonyms": [
      "Akute Nierenrindennekrose, Stadium 1",
      "Akutes Nierenversagen mit akuter Rindennekrose, Stadium 1",
      "Renale Rindennekrose, Stadium 1"
    ]
  },
  {
    "code": "N17.12",
    "name": "Akutes Nierenversagen mit akuter Rindennekrose, Stadium 2",
    "synonyms": [
      "Akute Nierenrindennekrose, Stadium 2",
      "Akutes Nierenversagen mit akuter Rindennekrose, Stadium 2",
      "Renale Rindennekrose, Stadium 2"
    ]
  },
  {
    "code": "N17.13",
    "name": "Akutes Nierenversagen mit akuter Rindennekrose, Stadium 3",
    "synonyms": [
      "Akute Nierenrindennekrose, Stadium 3",
      "Akutes Nierenversagen mit akuter Rindennekrose, Stadium 3",
      "Renale Rindennekrose, Stadium 3"
    ]
  },
  {
    "code": "N17.19",
    "name": "Akutes Nierenversagen mit akuter Rindennekrose",
    "synonyms": [
      "Akute Niereninsuffizienz mit Nierenrindennekrose",
      "Akute Nierenrindennekrose",
      "Akute kortikale Nierennekrose",
      "Akutes Nierenversagen mit akuter Rindennekrose",
      "Bilaterale Nierenrindennekrose",
      "Kortikale Nierennekrose",
      "Nierenrindennekrose",
      "Renale Rindennekrose"
    ]
  },
  {
    "code": "N17.21",
    "name": "Akutes Nierenversagen mit Marknekrose, Stadium 1",
    "synonyms": [
      "Akutes Nierenversagen mit Marknekrose, Stadium 1",
      "Akutes Nierenversagen mit Papillennekrose, Stadium 1",
      "Renale Marknekrose, Stadium 1",
      "Renale Papillennekrose, Stadium 1"
    ]
  },
  {
    "code": "N17.22",
    "name": "Akutes Nierenversagen mit Marknekrose, Stadium 2",
    "synonyms": [
      "Akutes Nierenversagen mit Marknekrose, Stadium 2",
      "Akutes Nierenversagen mit Papillennekrose, Stadium 2",
      "Renale Marknekrose, Stadium 2",
      "Renale Papillennekrose, Stadium 2"
    ]
  },
  {
    "code": "N17.23",
    "name": "Akutes Nierenversagen mit Marknekrose, Stadium 3",
    "synonyms": [
      "Akutes Nierenversagen mit Marknekrose, Stadium 3",
      "Akutes Nierenversagen mit Papillennekrose, Stadium 3",
      "Renale Marknekrose, Stadium 3",
      "Renale Papillennekrose, Stadium 3"
    ]
  },
  {
    "code": "N17.29",
    "name": "Akutes Nierenversagen mit Marknekrose",
    "synonyms": [
      "Akute Niereninsuffizienz mit Marknekrose",
      "Akute medulläre Nierennekrose",
      "Akute papilläre Nierennekrose",
      "Akutes Nierenversagen mit Marknekrose",
      "Akutes Nierenversagen mit Papillennekrose",
      "Akutes Nierenversagen mit akuter Papillennekrose",
      "Papillitis necroticans der Niere",
      "Papilläre Nekrose bei Nephritis"
    ]
  },
  {
    "code": "N17.81",
    "name": "Akutes Nierenversagen mit sonstigen histologischen Befunden, Stadium 1",
    "synonyms": [
      "Akutes Nierenversagen mit sonstigen histologischen Befunden, Stadium 1"
    ]
  },
  {
    "code": "N17.82",
    "name": "Akutes Nierenversagen mit sonstigen histologischen Befunden, Stadium 2",
    "synonyms": [
      "Akutes Nierenversagen mit sonstigen histologischen Befunden, Stadium 2"
    ]
  },
  {
    "code": "N17.83",
    "name": "Akutes Nierenversagen mit sonstigen histologischen Befunden, Stadium 3",
    "synonyms": [
      "Akutes Nierenversagen mit sonstigen histologischen Befunden, Stadium 3"
    ]
  },
  {
    "code": "N17.89",
    "name": "Akutes Nierenversagen mit sonstigen histologischen Befunden",
    "synonyms": [
      "Akutes Nierenversagen mit sonstigen histologischen Befunden"
    ]
  },
  {
    "code": "N17.91",
    "name": "Akutes Nierenversagen, Stadium 1",
    "synonyms": [
      "Akute Nierennekrose, Stadium 1",
      "Akutes Nierenversagen, Stadium 1"
    ]
  },
  {
    "code": "N17.92",
    "name": "Akutes Nierenversagen, Stadium 2",
    "synonyms": [
      "Akute Nierennekrose, Stadium 2",
      "Akutes Nierenversagen, Stadium 2"
    ]
  },
  {
    "code": "N17.93",
    "name": "Akutes Nierenversagen, Stadium 3",
    "synonyms": [
      "Akute Nierennekrose, Stadium 3",
      "Akutes Nierenversagen, Stadium 3"
    ]
  },
  {
    "code": "N17.99",
    "name": "Akute Niereninsuffizienz",
    "synonyms": [
      "AKI [Acute Kidney Injury]",
      "Akute Niereninsuffizienz",
      "Akute Nierennekrose",
      "Akute Nierenschädigung",
      "Akutes Nierenversagen",
      "Akutes Nierenversagen ohne Vorliegen eines histologischen Befundes",
      "Postrenales akutes Nierenversagen",
      "Prärenales akutes Nierenversagen"
    ]
  },
  {
    "code": "N18.1",
    "name": "Chronische Niereninsuffizienz, Stadium 1",
    "synonyms": [
      "Chronische Niereninsuffizienz, Stadium 1",
      "Chronische Nierenkrankheit, Stadium 1"
    ]
  },
  {
    "code": "N18.2",
    "name": "Chronische Niereninsuffizienz, Stadium 2",
    "synonyms": [
      "Chronische Niereninsuffizienz, Stadium 2",
      "Chronische Nierenkrankheit, Stadium 2"
    ]
  },
  {
    "code": "N18.3",
    "name": "Chronische Niereninsuffizienz, Stadium 3",
    "synonyms": [
      "Chronische Niereninsuffizienz, Stadium 3",
      "Chronische Nierenkrankheit, Stadium 3"
    ]
  },
  {
    "code": "N18.4",
    "name": "Präterminale Niereninsuffizienz",
    "synonyms": [
      "Chronische Niereninsuffizienz, Stadium 4",
      "Chronische Nierenkrankheit, Stadium 4",
      "Präterminale Niereninsuffizienz",
      "Präterminales Nierenversagen"
    ]
  },
  {
    "code": "N18.5",
    "name": "Terminale Niereninsuffizienz",
    "synonyms": [
      "Chronische Niereninsuffizienz, Stadium 5",
      "Chronische Nierenkrankheit, Stadium 5",
      "Dialysepflichtige chronische Niereninsuffizienz",
      "Dialysepflichtige terminale Niereninsuffizienz",
      "Nierenkrankheit im Endstadium",
      "Terminale Niereninsuffizienz",
      "Terminale Nierenkrankheit",
      "Terminale renale Krankheit",
      "Terminales Nierenversagen",
      "Terminales chronisches Nierenversagen"
    ]
  },
  {
    "code": "N18.80",
    "name": "Einseitige chronische Nierenfunktionsstörung",
    "synonyms": [
      "Einseitige chronische Nierenfunktionsstörung"
    ]
  },
  {
    "code": "N18.89",
    "name": "Dekompensierte Niereninsuffizienz",
    "synonyms": [
      "Dekompensierte Niereninsuffizienz",
      "Kompensierte Niereninsuffizienz",
      "Niereninsuffizienz im Stadium der Dekompensation",
      "Niereninsuffizienz im Stadium der Retention",
      "Niereninsuffizienz im Stadium der dekompensierten Retention",
      "Niereninsuffizienz im Stadium der kompensierten Retention"
    ]
  },
  {
    "code": "N18.9",
    "name": "Sklerosierende Glomerulonephritis",
    "synonyms": [
      "Chronische Niereninsuffizienz",
      "Chronische Nierenkrankheit",
      "Chronische Urämie",
      "Chronisches Nierenversagen",
      "Diffuse sklerosierende Glomerulonephritis",
      "Diffuse sklerosierende Nephritis",
      "Diffuse sklerosierende Nephritis mit glomerulären Läsionen",
      "Sklerosierende Glomerulonephritis",
      "Syndrom der chronischen Urämie"
    ]
  },
  {
    "code": "N19",
    "name": "Glomerulo-tubuläre Globalinsuffizienz",
    "synonyms": [
      "Anurisches Nierenversagen",
      "Coma uraemicum",
      "Dialysepflichtige Niereninsuffizienz",
      "Dialysepflichtiges Nierenversagen",
      "Extrarenales Nierenversagen",
      "Filtrationsschwäche",
      "Funktionslose Niere",
      "Globale Niereninsuffizienz",
      "Glomerulo-tubuläre Globalinsuffizienz",
      "Harnstarre",
      "Harnstoff im Blut erhöht",
      "Harntoxikose",
      "Harnvergiftung",
      "Hyperazotämie",
      "Isosthenurie",
      "Konzentrationsstarre (Harn)",
      "Nephrogene Dekompensation",
      "Nicht dialysepflichtige Niereninsuffizienz",
      "Nierenblockade",
      "Nierendekompensation",
      "Niereninsuffizienz",
      "Nierenunterfunktion",
      "Nierenversagen",
      "Postrenales Nierenversagen",
      "Prärenale Niereninsuffizienz",
      "Prärenales Nierenversagen",
      "Präurämie",
      "Renale Ausscheidungsstörung",
      "Renale Insuffizienz",
      "Renales Versagen",
      "Schockniere",
      "Sekundäre Niereninsuffizienz",
      "Stumme Niere",
      "Suburämie",
      "Urämie",
      "Urämische Aphasie",
      "Urämische Blindheit",
      "Urämische Dyspnoe",
      "Urämische Eklampsie",
      "Urämische Konvulsionen",
      "Urämische Toxikose",
      "Urämischer Krampf",
      "Urämisches Delirium",
      "Urämisches Fieber",
      "Urämisches Koma"
    ]
  },
  {
    "code": "N20.0",
    "name": "Kalziumnephrolithiasis",
    "synonyms": [
      "Festsitzender renaler Stein",
      "Kalixurolithiasis",
      "Kalziumnephrolithiasis",
      "Kelchstein",
      "Konkrement im Nierenkelchsystem",
      "Korallenstein",
      "Nephrolithiasis",
      "Nephrolithiasis des Nierenbeckens",
      "Nierenabszess mit Stein",
      "Nierenausgussstein",
      "Nierenbeckenausgussstein",
      "Nierenbeckendivertikel mit Stein",
      "Nierenbeckendivertikulitis mit Stein",
      "Nierenbeckendivertikulose mit Stein",
      "Nierenbeckenkelchkonkrement",
      "Nierenbeckenkelchstein",
      "Nierenbeckenkonkrement",
      "Nierenbeckensolitärstein",
      "Nierenbeckenstein",
      "Nierengrieß",
      "Nierengrießabgang",
      "Nierenkalziumoxalatstein",
      "Nierenkelchkonkrement",
      "Nierenkelchstein",
      "Nierenkolik durch Stein",
      "Nierenkonkrement",
      "Nierenoberkelchkonkrement",
      "Nierenoberkelchstein",
      "Nierenparenchymstein",
      "Nierensand",
      "Nierenstein",
      "Nierenstein der oberen Kelchgruppe",
      "Nierensteinabgang",
      "Nierensteingrieß",
      "Nierensteinkolik",
      "Nierenunterkelchkonkrement",
      "Nierenunterkelchstein",
      "Oxalat-Nephrolithiasis",
      "Pelviolithiasis [Nierenbeckenstein]",
      "Rezidivierende Nephrolithiasis",
      "Rezidivierender renaler Stein",
      "Uratablagerung in der Niere",
      "Uratstein im Nierenbecken",
      "Verkapselter Nierenbeckenstein"
    ]
  },
  {
    "code": "N20.1",
    "name": "Harnleitergrieß",
    "synonyms": [
      "Eingeklemmter Harnleiterstein",
      "Eingeklemmter Ureterstein",
      "Harnleitergrieß",
      "Harnleiterkolik durch Stein",
      "Harnleiterkonkrement",
      "Harnleiterstein",
      "Hoher Harnleiterstein",
      "Hoher Harnleiterstein mit Stauung",
      "Hoher Harnleiterstein ohne Stauung",
      "Hoher Ureterstein",
      "Hoher Ureterstein mit Stauung",
      "Hoher Ureterstein ohne Stauung",
      "Prävesikaler Harnleiterstein",
      "Prävesikaler Ureterstein",
      "Tiefsitzender Harnleiterstein",
      "Tiefsitzender Ureterstein",
      "Uretergrieß",
      "Ureteritis durch Stein",
      "Ureterkolik durch Stein",
      "Ureterkonkrement",
      "Ureterobstruktion durch Stein",
      "Ureterolithiasis",
      "Ureterozelenstein",
      "Ureterstein"
    ]
  },
  {
    "code": "N20.2",
    "name": "Gleichzeitiger Nieren- und Ureterstein",
    "synonyms": [
      "Gleichzeitiger Nieren- und Ureterstein",
      "Unspezifische Ureteritis mit Nierenstein"
    ]
  },
  {
    "code": "N20.9",
    "name": "Grießabgang",
    "synonyms": [
      "Anurie durch Steine",
      "Grießabgang",
      "Harngrieß",
      "Harngrießabgang",
      "Harnkonkrement",
      "Harnkristalle",
      "Harnorganstein",
      "Harnstein",
      "Harnsteinabgang",
      "Harnsteindiathese",
      "Harnsteinkrankheit",
      "Harnsteinleiden",
      "Kalziumoxalatkonkrement in den Harnwegen",
      "Kalziumoxalatstein in den Harnwegen",
      "Kalziumoxalatsteinabgang",
      "Kalziumurolithiasis",
      "Oxalatstein in den Harnwegen",
      "Oxalatsteinabgang",
      "Phosphat-Urolithiasis",
      "Urolithiasis",
      "Urolithiasis mit Kolik"
    ]
  },
  {
    "code": "N21.0",
    "name": "Harnblasendivertikelstein",
    "synonyms": [
      "Blasendivertikelstein",
      "Blasenkonkrement",
      "Blasenstein",
      "Blasensteinabgang",
      "Harnblasendivertikelstein",
      "Harnblasengrieß",
      "Harnblasenkonkrement",
      "Harnblasenstein",
      "Harnblasenstein mit Urethritis",
      "Harnblasenstein mit Zystitis",
      "Neoblasenstein",
      "Zystitis durch Stein",
      "Zystolithiasis"
    ]
  },
  {
    "code": "N21.1",
    "name": "Harnröhrenstein",
    "synonyms": [
      "Eingeklemmter Harnröhrenstein",
      "Eingeklemmter Urethrastein",
      "Harnröhrenkolik durch Stein",
      "Harnröhrenstein",
      "Urethradivertikel mit Stein",
      "Urethrakolik durch Stein",
      "Urethrakonkrement",
      "Urethralithiasis",
      "Urethralithiasis mit Infektion",
      "Urethralithiasis mit Kolik",
      "Urethrastein",
      "Urethritis durch Stein"
    ]
  },
  {
    "code": "N21.9",
    "name": "Harnstein der unteren Harnorgane",
    "synonyms": [
      "Harnstein der unteren Harnorgane"
    ]
  },
  {
    "code": "N23",
    "name": "Nierenkolik",
    "synonyms": [
      "Colica renalis",
      "Harnleiterkolik",
      "Nephralgie",
      "Nierenkolik",
      "Nierenschmerzen",
      "Ureterkolik",
      "Ureterschmerzen"
    ]
  },
  {
    "code": "N25.0",
    "name": "Renale Osteodystrophie",
    "synonyms": [
      "Azotämische Osteodystrophie",
      "Nanosomia renalis",
      "Nephrogener Infantilismus",
      "Nierenrachitis",
      "Rachitis renalis",
      "Renale Osteodystrophie",
      "Renale Osteopathie",
      "Renale Rachitis",
      "Renaler Infantilismus",
      "Renaler Kleinwuchs",
      "Renaler Minderwuchs",
      "Tubulusschaden mit Phosphatverlust",
      "Tubuläre Störung mit Phosphatverlust"
    ]
  },
  {
    "code": "N25.1",
    "name": "Nephrogener Diabetes insipidus",
    "synonyms": [
      "Nephrogener Diabetes insipidus",
      "Renaler Diabetes insipidus",
      "Vasopressinresistenter Diabetes insipidus"
    ]
  },
  {
    "code": "N25.8",
    "name": "Sekundärer renaler Hyperparathyreoidismus",
    "synonyms": [
      "Autosomal-dominanter Pseudohypoaldosteronismus Typ 1",
      "Autosomal-rezessive distale renale tubuläre Azidose",
      "Autosomal-rezessiver Pseudohypoaldosteronismus Typ 1",
      "Dent-Krankheit",
      "Dent-Krankheit Typ 1",
      "Dent-Krankheit Typ 2",
      "Dent-Syndrom",
      "Distale renale tubuläre Azidose",
      "Distale tubuläre Azidose",
      "Hereditäre renale Hypourikämie",
      "Lightwood-Albright-Syndrom",
      "Proximale renale tubuläre Azidose",
      "Pseudohypoaldosteronismus Typ 1",
      "Renale Azidose",
      "Renale tubuläre Azidose",
      "Renale tubuläre Azidose vom Typ I",
      "Renale tubuläre Azidose vom Typ II",
      "Renaler Pseudohypoaldosteronismus Typ 1",
      "Sagliker-Syndrom",
      "Sekundärer renaler Hyperparathyreoidismus",
      "Transienter Pseudohypoaldosteronismus"
    ]
  },
  {
    "code": "N25.9",
    "name": "Tubuläre Nephropathie",
    "synonyms": [
      "Krankheit durch Schädigung der tubulären Nierenfunktion",
      "Schädigung der tubulorenalen Funktion",
      "Störung der tubulären Nierenfunktion",
      "Störung durch Schädigung der tubulären Nierenfunktion",
      "Tubuläre Nephropathie"
    ]
  },
  {
    "code": "N26",
    "name": "Glomerulosklerose",
    "synonyms": [
      "Bleischrumpfniere",
      "Cirrhosis renis",
      "Glomerulosklerose",
      "Granularatrophie der Niere",
      "Granuläre Nierenkontraktur",
      "Granuläre Schrumpfniere",
      "Nephritis saturnina",
      "Nephrofibrose",
      "Nephrozirrhose",
      "Nierenatrophie",
      "Nierenfibrose",
      "Nierenrindenatrophie",
      "Nierenverkleinerung",
      "Renale Atrophie",
      "Renale Zirrhose",
      "Schrumpfniere",
      "Sekundäre Nierenkontraktur",
      "Sekundäre Schrumpfniere",
      "Terminale Nierenatrophie",
      "Tubulusatrophie",
      "Zirrhotische Nephritis"
    ]
  },
  {
    "code": "N27.0",
    "name": "Einseitige kleine Niere",
    "synonyms": [
      "Einseitige Zwergniere",
      "Einseitige kleine Niere",
      "Funktionelle Einzelniere"
    ]
  },
  {
    "code": "N27.1",
    "name": "Beidseitige Zwergniere",
    "synonyms": [
      "Beidseitige Zwergniere",
      "Beidseitige kleine Nieren"
    ]
  },
  {
    "code": "N27.9",
    "name": "Kleine Niere",
    "synonyms": [
      "Kleine Niere"
    ]
  },
  {
    "code": "N28.0",
    "name": "Nierenarterienembolie",
    "synonyms": [
      "Bilaterale Nierennekrose",
      "Bilaterale massive Nierenembolie",
      "Embolie der Arteria renalis",
      "Gestielte Nierentorsion mit Infarkt",
      "Juhel-Renoy-Syndrom",
      "Nephroangionekrose",
      "Nierenarterienembolie",
      "Nierenarterienobstruktion",
      "Nierenarterienthrombose",
      "Nierenarterienverschluss",
      "Nierenembolie",
      "Nierenfettembolie",
      "Niereninfarkt",
      "Nierenischämie",
      "Nierennekrose",
      "Nierenrindeninfarkt",
      "Nierenteilinfarkt",
      "Obstruktion der Arteria renalis",
      "Renale Arterienthrombose",
      "Renale Nekrose",
      "Renaler Infarkt",
      "Thrombose der Arteria renalis",
      "Unilaterale massive Nierenembolie",
      "Verschluss der Arteria renalis",
      "Verschluss der Nierenpolarterie"
    ]
  },
  {
    "code": "N28.1",
    "name": "Erworbene Nierenzyste",
    "synonyms": [
      "ACRD [Acquired Renal Cystic Disease]",
      "Erworbene Nierensolitärzyste",
      "Erworbene Nierenzyste",
      "Multiple erworbene Nierenzysten",
      "Nierenpolzyste",
      "Nierensolitärzyste",
      "Nierenzyste",
      "Renale Zyste",
      "Riesenhohlzyste der Niere",
      "Zyste der Niere"
    ]
  },
  {
    "code": "N28.80",
    "name": "Nichttraumatische Nierenruptur",
    "synonyms": [
      "Nichttraumatische Fornixruptur",
      "Nichttraumatische Nierenbeckenruptur",
      "Nichttraumatische Nierenkelchruptur",
      "Nichttraumatische Nierenruptur"
    ]
  },
  {
    "code": "N28.88",
    "name": "Nierenverkalkung",
    "synonyms": [
      "Abdomenwand-Ureter-Fistel",
      "Absinken der Niere",
      "Ballotierende Niere",
      "Blutung des Nierenhohlsystems",
      "Dilatation des Nierenbeckenkelchsystems",
      "Divertikel des Ostium ureteris",
      "Ektasie des Nierenbeckenkelchsystems",
      "Erweiterung des Nierenbeckenkelchsystems",
      "Erworbene Nierendeformität",
      "Erworbene Ureterdeformität",
      "Fettige Nierendegeneration",
      "Golflochostium der Harnblase",
      "Harnleiterabszess",
      "Harnleiterachalasie",
      "Harnleiteratonie",
      "Harnleiterdilatation",
      "Harnleiterdivertikel",
      "Harnleiterdyskinesie",
      "Harnleiterektasie",
      "Harnleiterentzündung",
      "Harnleiterfistel",
      "Harnleiterhypertrophie",
      "Harnleiterinfektion",
      "Harnleiterkompression",
      "Harnleiterperforation",
      "Harnleiterprolaps",
      "Harnleiterzyste",
      "Hypochlorämisches Nierensyndrom",
      "Hyposthenurie",
      "Idiopathischer Riesenharnleiter",
      "Idiopathischer Riesenureter",
      "Intrarenale Kalzifikation",
      "Intrarenale Verkalkung",
      "Kippniere",
      "Malakoplakie des Nierenbeckens",
      "Malakoplakie des Ureters",
      "Megaureter",
      "Mikrokalzifikation der Niere",
      "Mobile Niere",
      "Narbige Veränderung des Nierenpols",
      "Nephritis durch Salzverlust a.n.k.",
      "Nephroptose",
      "Nephrorrhagie",
      "Nephrotoxikose",
      "Nichttraumatische Harnleiterruptur",
      "Nichttraumatische Ureterruptur",
      "Nierenbeckenblutung",
      "Nierenbeckendilatation",
      "Nierenbeckenektasie",
      "Nierenbeckenerweiterung",
      "Nierenbeckenfistel",
      "Nierenbeckenleukoplakie",
      "Nierenbeckenmetaplasie",
      "Nierenblutung",
      "Nierendegeneration",
      "Nierendilatation",
      "Nierendislokation",
      "Nierendivertikel",
      "Nierenektasie",
      "Nierenerweiterung",
      "Nierenfistel",
      "Nierenhypertrophie",
      "Nierenhyperämie",
      "Nierenhämorrhagie",
      "Niereninfiltration",
      "Nierenkalzifikation",
      "Nierenkapselblutung",
      "Nierenkelchdeformierung",
      "Nierenkelchdivertikel",
      "Nierenkelchverplumpung",
      "Nierenkrise",
      "Nierenleukoplakie",
      "Nierenmetaplasie",
      "Nierenpapillenkalzifikation",
      "Nierenpapillenverkalkung",
      "Nierenparenchymkalzifikation",
      "Nierenparenchymverkalkung",
      "Nierenpetechien",
      "Nierenpolkalzifikation",
      "Nierenpolvernarbung",
      "Nierenprolaps",
      "Nierenptose",
      "Nierenrindenblutung",
      "Nierenrindendefekt",
      "Nierenschwellung",
      "Nierensenkung",
      "Nierensteatose",
      "Nierentiefstand",
      "Nierentoxikose",
      "Nierenvergrößerung",
      "Nierenverkalkung",
      "Nierenverlagerung",
      "Nierenvernarbung",
      "Nierenödem",
      "Palpable Niere",
      "Perineale Ureterfistel",
      "Perirenale Adhäsion",
      "Periureterale Adhäsion",
      "Periureterale Infektion",
      "Periureteraler Abszess",
      "Periureteritis",
      "Persistierende Ureterfistel",
      "Postinfektiöse Ureterleukoplakie",
      "Prolaps des Ostium ureteris",
      "Pseudotumor der Niere",
      "Pyelitis cystica",
      "Pyeloureteritis cystica",
      "Pyureter",
      "Rektoureterale Fistel",
      "Ren mobilis",
      "Renale Blutung",
      "Renale Degeneration",
      "Renale Fistel",
      "Renale Hämorrhagie",
      "Salzverlustniere",
      "Senkniere",
      "Thorn-Syndrom",
      "Tiefsitzende Niere",
      "Tubuläre Schwellung",
      "Unspezifische Ureteritis",
      "Ureter-Darm-Fistel",
      "Ureter-Haut-Fistel",
      "Ureterabszess",
      "Ureterachalasie",
      "Ureteratonie",
      "Ureterdilatation",
      "Ureterdivertikel",
      "Ureterdyskinesie",
      "Ureterektasie",
      "Ureterempyem",
      "Ureterentzündung",
      "Uretereversion",
      "Ureterfistel",
      "Ureterhernie",
      "Ureterhypertrophie",
      "Ureterinfektion",
      "Ureteritis",
      "Ureteritis cystica",
      "Ureterkalzifikation",
      "Ureterkompression",
      "Uretero-sigmoideo-abdominale Fistel",
      "Ureterointestinale Fistel",
      "Ureteropyelitis",
      "Ureterorektale Fistel",
      "Ureterosakralfistel",
      "Ureterozele",
      "Ureterperforation",
      "Ureterpolyp",
      "Ureterprolaps",
      "Ureterzyste",
      "Wanderniere",
      "Zyste der ureterovesikalen Öffnung",
      "Zystische Infektion von Nierenbecken und Ureter",
      "Zystische Pyelitis"
    ]
  },
  {
    "code": "N28.9",
    "name": "Nierenaffektion",
    "synonyms": [
      "Eingeschränkte Nierenfunktion",
      "Funktionelle Nierenbeckenkrankheit",
      "Funktionelle Nierenkrankheit",
      "Harnleiteraffektion",
      "Hyperkalziämische Nephropathie",
      "Nephropathia",
      "Nephropathie",
      "Nichtfunktionierende Niere",
      "Nierenaffektion",
      "Nierendysfunktion",
      "Nierenerkrankung",
      "Nierenfunktionsstörung",
      "Nierenkachexie",
      "Nierenkomplikation",
      "Nierenkrankheit",
      "Nierenkrankheit mit Ureterkrankheit",
      "Nierenparenchymschädigung",
      "Nierenpolerkrankung",
      "Nierenpolveränderung",
      "Nierenschaden",
      "Nierenstörung",
      "Pathologische Nierenveränderung",
      "Reduzierte Nierenfunktion",
      "Renale Funktionsstörung",
      "Renale Kachexie",
      "Renaler Schaden",
      "Renopathie",
      "Restniere",
      "Ureteraffektion",
      "Ureterkrankheit",
      "Ureterstörung",
      "Verminderte Nierenfunktion"
    ]
  },
  {
    "code": "N30.0",
    "name": "Akute Zystitis",
    "synonyms": [
      "Akute Blasenentzündung",
      "Akute Urozystitis",
      "Akute Zystitis",
      "Akute hämorrhagische Zystitis",
      "Subakute Zystitis"
    ]
  },
  {
    "code": "N30.1",
    "name": "Chronische interstitielle Blasenentzündung",
    "synonyms": [
      "BPS [Blasenschmerz-Syndrom]",
      "Blasenschmerz-Syndrom",
      "Chronische interstitielle Blasenentzündung",
      "Chronische interstitielle Zystitis",
      "Hunner-Geschwür",
      "Hunner-Ulkus",
      "IC/BPS [Interstitielle Cystitis/Blasenschmerz-Syndrom]",
      "Interstitielle Blasenentzündung",
      "Interstitielle Zystitis",
      "Submuköse Zystitis",
      "Submuköses Harnblasenulkus",
      "Ulcus simplex vesicae"
    ]
  },
  {
    "code": "N30.2",
    "name": "Chronische Zystitis",
    "synonyms": [
      "Atrophische Zystitis",
      "Chronische Blasenentzündung",
      "Chronische Zystitis",
      "Rezidivierende Zystitis"
    ]
  },
  {
    "code": "N30.3",
    "name": "Trigonitis",
    "synonyms": [
      "Pseudomembranöse Trigonitis",
      "Trigonitis",
      "Trigonitis der Harnblase",
      "Trigonumzystitis",
      "Urethrotrigonitis",
      "Urethrotrigonumzystitis"
    ]
  },
  {
    "code": "N30.4",
    "name": "Strahlenzystitis",
    "synonyms": [
      "Bestrahlungszystitis",
      "Radiozystitis",
      "Radiumblase",
      "Strahlenzystitis"
    ]
  },
  {
    "code": "N30.80",
    "name": "Harnblasenabszess",
    "synonyms": [
      "Abszess der Harnblasenwand",
      "Harnblasenabszess"
    ]
  },
  {
    "code": "N30.88",
    "name": "Harnblasengangrän",
    "synonyms": [
      "Allergische Zystitis",
      "Bakterielle Zystitis",
      "Bullöse Zystitis",
      "Cystitis cystica",
      "Cystitis cystica granulomatosa",
      "Cystitis gangraenescens",
      "Cystitis gangraenosa",
      "Cystitis intramuralis",
      "Cystitis parenchymatosa",
      "Diffuse Zystitis",
      "Eosinophile Zystitis",
      "Gangränöse Zystitis",
      "Granulomatöse Blasenentzündung",
      "Granulomatöse Zystitis",
      "Harnblasengangrän",
      "Intramurale Blasenentzündung",
      "Intramurale Zystitis",
      "Panzystitis [Cystitis parenchymatosa]",
      "Parenchymatöse Zystitis",
      "Perivesikale Phlegmone",
      "Perivesikaler Abszess",
      "Pyozystitis",
      "Rektovesikaler Abszess",
      "Retrovesikaler Abszess",
      "Ulzeröse Zystitis",
      "Ureterozystitis",
      "Verschorfende Zystitis",
      "Zystisch-granulomatöse Blasenentzündung",
      "Zystisch-granulomatöse Zystitis",
      "Zystische Blasenentzündung",
      "Zystische Zystitis"
    ]
  },
  {
    "code": "N30.9",
    "name": "Eitrige Zystitis",
    "synonyms": [
      "Blasenbodenzystitis",
      "Blasenentzündung",
      "Blasengrundzystitis",
      "Blaseninfektion",
      "Blutige Zystitis",
      "Cystitis - s.a. Zystitis",
      "Cystitis haemorrhagica",
      "Eitrige Zystitis",
      "Epizystitis",
      "Exsudative Zystitis",
      "Fibrinöse Zystitis",
      "Harnblasenbodenzystitis",
      "Harnblasenentzündung",
      "Harnblaseninfektion",
      "Harnblasenkatarrh",
      "Harnblasenvereiterung",
      "Hyperplastische Zystitis",
      "Hämorrhagische Blasenentzündung",
      "Hämorrhagische Zystitis",
      "Parazystitis",
      "Perivesikale Entzündung",
      "Perizystitis",
      "Pseudomembranöse Zystitis",
      "Pyovesica",
      "Septische Zystitis",
      "Suppurative Zystitis",
      "Urozystitis",
      "Zystitis"
    ]
  },
  {
    "code": "N31.0",
    "name": "Neurogene Harninkontinenz",
    "synonyms": [
      "Neurogene Blase mit ungehemmter Entleerung",
      "Neurogene Harnblaseninkontinenz",
      "Neurogene Harninkontinenz",
      "Ungehemmte neuromuskuläre Harnblasendysfunktion",
      "Zerebral bedingte Detrusorinstabilität",
      "Zerebral enthemmte Harnblase"
    ]
  },
  {
    "code": "N31.1",
    "name": "Neurogene Reflexblase",
    "synonyms": [
      "Detrusorhyperreflexie der Harnblase",
      "Harnblasenfunktionsstörung mit Detrusorinstabilität bei autonomer Neuropathie",
      "Neurogene Reflexblase",
      "Neurohormonale Reizblase"
    ]
  },
  {
    "code": "N31.2",
    "name": "Detrusordekompensation der Harnblase",
    "synonyms": [
      "Atonische neuromuskuläre Harnblasendysfunktion",
      "Autonome neuromuskuläre Harnblasendysfunktion",
      "Blasenatonie",
      "Blasenlähmung",
      "Blasenwandschwäche",
      "Detrusoratonie der Harnblase",
      "Detrusordekompensation der Harnblase",
      "Detrusorhypoaktivität der Harnblase",
      "Harnblasenatonie",
      "Harnblasenhypotonie",
      "Harnblasenlähmung",
      "Harnblasensphinktermyasthenie",
      "Harnblasensphinkterrelaxation",
      "Harnblasensphinkterschwäche",
      "Harnblasenwandschwäche",
      "Hypotone Blase",
      "Neurogene Blasenatonie",
      "Neurogene Harnblase bei Frontalhirnsyndrom",
      "Neurogene Harnblase bei autonomer Neuropathie",
      "Neurogene Harnblase nach operativer Deafferenzierung",
      "Neurogene Paralyse des Harnblasensphinkters",
      "Neurogene autonome Harnblase",
      "Neurogene motorisch atonische Harnblase",
      "Neurogene nichtreflektorische Blase",
      "Neurogene nichtreflektorische Harnblase",
      "Neurogene schlaffe Blase",
      "Neurogene sensorisch atonische Harnblase",
      "Nichtreflektorische neuromuskuläre Harnblasendysfunktion",
      "Paralyse des Harnblasensphinkters",
      "Parese des Harnblasensphinkters",
      "Paresis vesicae",
      "Schlaffe neuromuskuläre Harnblasendysfunktion",
      "Sphincter-vesicae-Myasthenie",
      "Sphincter-vesicae-Relaxation",
      "Sphincter-vesicae-Schwäche",
      "Vesikale Paralyse",
      "Vesikale Relaxation",
      "Vesikalparese a.n.k.",
      "Zystoplegie"
    ]
  },
  {
    "code": "N31.80",
    "name": "Organisch fixierte neuromuskuläre Low-compliance-Blase",
    "synonyms": [
      "Organisch fixierte neuromuskuläre Low-compliance-Blase"
    ]
  },
  {
    "code": "N31.81",
    "name": "Harnblasenträgheit",
    "synonyms": [
      "Akontraktile Blase",
      "Akontraktilität des Blasenmuskels ohne neurologisches Substrat",
      "Harnblasenträgheit",
      "Hypokontraktilität des Blasenmuskels ohne neurologisches Substrat",
      "Lazy bladder"
    ]
  },
  {
    "code": "N31.82",
    "name": "Instabile Blase ohne neurologisches Substrat",
    "synonyms": [
      "Instabile Blase ohne neurologisches Substrat",
      "Urgency-Blase"
    ]
  },
  {
    "code": "N31.88",
    "name": "Harnblasensphinkterinkontinenz",
    "synonyms": [
      "Detrusor-Sphinkter-Dyssynergie",
      "Harnblasensphinkterinkontinenz",
      "Hypertone Harnblase",
      "Neurogene Detrusor-Muskel-Hyperaktivität",
      "Neurogene Detrusor-Sphinkter-Dysfunktion",
      "Neurogene Harnblasenatrophie"
    ]
  },
  {
    "code": "N31.9",
    "name": "Neuromuskuläre Blasenstörung",
    "synonyms": [
      "Blasenfunktionsstörung",
      "Blasenschwäche",
      "Funktionelle Blasenentleerungsstörung",
      "Funktionelle Harnabflussstörung",
      "Harnblasendysfunktion",
      "Harnblasenfunktionsstörung",
      "Harnblaseninstabilität",
      "Harnblasenschwäche",
      "Hypersensitive Blase",
      "Instabile Blase",
      "Neurogene Blase",
      "Neurogene Blasenentleerungsstörung",
      "Neurogene Blasenstörung",
      "Neurogene Harnblase",
      "Neurogene Harnblasendysfunktion",
      "Neurogene Harnblasenentleerungsstörung",
      "Neurogene Miktionsstörung",
      "Neurogene Restharnretention",
      "Neuromuskuläre Blasendysfunktion",
      "Neuromuskuläre Blasenentleerungsstörung",
      "Neuromuskuläre Blasenstörung"
    ]
  },
  {
    "code": "N32.0",
    "name": "Blasenauslassobstruktion",
    "synonyms": [
      "Blasenauslassobstruktion",
      "Blasenhalsenge",
      "Blasenhalsobstruktion",
      "Blasenhalsstenose",
      "Blasenhalsstriktur",
      "Blasenhalsödem",
      "Harnblasenausgangsstenose",
      "Harnblasenhalsenge",
      "Harnblasenhalsobstruktion",
      "Harnblasenhalsstarre",
      "Harnblasenhalsstenose",
      "Harnblasenhalsstrangulation",
      "Harnblasenhalsstriktur",
      "Harnblasenhalsödem",
      "Marion-Krankheit",
      "Neoblasenhalsstriktur",
      "Obstruktion der vesikourethralen Öffnung",
      "Obstruktion des Ostium urethrae internum",
      "Strangulation des Ostium urethrae internum",
      "Striktur der vesikourethralen Öffnung",
      "Striktur des Ostium urethrae internum"
    ]
  },
  {
    "code": "N32.1",
    "name": "Harnblasen-Mastdarm-Fistel",
    "synonyms": [
      "Blasen-Darm-Fistel",
      "Blasen-Dünndarm-Fistel",
      "Blasen-Sigma-Fistel",
      "Darm-Blasen-Fistel",
      "Fistula enterovesicalis",
      "Fistula ileovesicalis",
      "Fistula vesicoenteralis",
      "Harnblasen-Darm-Fistel",
      "Harnblasen-Dünndarm-Fistel",
      "Harnblasen-Ileum-Fistel",
      "Harnblasen-Kolon-Fistel",
      "Harnblasen-Mastdarm-Fistel",
      "Harnblasen-Sigma-Fistel",
      "Ileovesikale Fistel",
      "Pouch-Darm-Fistel",
      "Rektovesikale Fistel",
      "Vesikointestinale Fistel",
      "Vesikorektale Fistel",
      "Vesikosigmoidale Fistel",
      "Vesikourethrorektale Fistel"
    ]
  },
  {
    "code": "N32.2",
    "name": "Blasenfistel",
    "synonyms": [
      "Abdomenwand-Harnblasen-Fistel",
      "Blasen-Douglas-Fistel",
      "Blasen-Haut-Fistel",
      "Blasenfistel",
      "Fistula vesicalis",
      "Harnblasen-Douglas-Fistel",
      "Harnblasen-Haut-Fistel",
      "Harnblasen-Ureter-Fistel",
      "Harnblasenfistel a.n.k.",
      "Ureterovesikale Fistel",
      "Urethroperineovesikale Fistel",
      "Urethrovesikale Fistel",
      "Vesikale Fistel a.n.k.",
      "Vesikoabdominale Fistel",
      "Vesikoperineale Fistel",
      "Vesikoureterale Fistel",
      "Vesikourethrale Fistel"
    ]
  },
  {
    "code": "N32.3",
    "name": "Blasendivertikel",
    "synonyms": [
      "Blasendivertikel",
      "Blasenhalsdivertikel",
      "Diverticulitis vesicae",
      "Harnblasendivertikel",
      "Harnblasendivertikulitis",
      "Harnblasenhalsdivertikel",
      "Pseudodivertikel der Blase",
      "Pseudodivertikel der Harnblase"
    ]
  },
  {
    "code": "N32.4",
    "name": "Nichttraumatische Harnblasenruptur",
    "synonyms": [
      "Blasenriss",
      "Blasenruptur",
      "Harnblasenriss",
      "Harnblasenruptur",
      "Nichttraumatische Harnblasenruptur",
      "Ruptur einer Neoblase"
    ]
  },
  {
    "code": "N32.8",
    "name": "Blasenfibrose",
    "synonyms": [
      "Aseptische Harnblasensphinkternekrose",
      "Balkenblase",
      "Balkenharnblase",
      "Blasenausgangsmetaplasie",
      "Blasenblutung",
      "Blasendilatation",
      "Blasendistension",
      "Blasenfibrose",
      "Blasengeschwür",
      "Blasenhalsdeformierung",
      "Blasenhalsfibrose",
      "Blasenhalshypertrophie",
      "Blasenhalskongestion",
      "Blasenhalsmetaplasie",
      "Blasenhalssklerose",
      "Blasenhernie beim Mann",
      "Blasenhypertrophie",
      "Blasenmetaplasie",
      "Blasenprolaps beim Mann",
      "Blasenreizung",
      "Blasenschrumpfung",
      "Blasensphinktersklerose",
      "Blasentamponade",
      "Blasentrigonummetaplasie",
      "Blasenulkus",
      "Blasenverziehung",
      "Blasenwanddeformierung",
      "Blasenwandfibrose",
      "Blasenwandödem",
      "Detrusorhyperaktivität",
      "Dilatation der Harnblasenöffnung",
      "Dilatation des Ostium urethrae internum",
      "Erworbene Deformität des Ostium urethrae internum",
      "Erworbene Harnblasendeformität",
      "Erworbene Harnblasenverlagerung",
      "Fibrosis vesicae",
      "Harnblasenadhäsion",
      "Harnblasenatrophie",
      "Harnblasenausgangsmetaplasie",
      "Harnblasenausweitung",
      "Harnblasenblutung",
      "Harnblasendilatation",
      "Harnblasendistension",
      "Harnblaseneversion",
      "Harnblasenfibrose",
      "Harnblasengeschwür",
      "Harnblasenhalsblutung",
      "Harnblasenhalsdeformierung",
      "Harnblasenhalsfibrose",
      "Harnblasenhalshypertrophie",
      "Harnblasenhalskalzifikation",
      "Harnblasenhalskongestion",
      "Harnblasenhalsmetaplasie",
      "Harnblasenhalssklerose",
      "Harnblasenhalsverkalkung",
      "Harnblasenhernie beim Mann",
      "Harnblasenhochstand",
      "Harnblasenhypertrophie",
      "Harnblasenhyperämie",
      "Harnblasenhämorrhagie",
      "Harnblaseninversion",
      "Harnblasenirritabilität",
      "Harnblasenkalzifikation",
      "Harnblasenkolik",
      "Harnblasenkontraktur",
      "Harnblasenmetaplasie",
      "Harnblasennarbe",
      "Harnblasenschrumpfung",
      "Harnblasenspasmus",
      "Harnblasensphinkterhypertrophie",
      "Harnblasensphinkterkalzifikation",
      "Harnblasensphinkterspasmus",
      "Harnblasensphinkterverkalkung",
      "Harnblasenstenose",
      "Harnblasenstriktur",
      "Harnblasentamponade",
      "Harnblasentrigonummetaplasie",
      "Harnblasenulkus",
      "Harnblasenverkalkung",
      "Harnblasenverwachsung",
      "Harnblasenverziehung",
      "Harnblasenvorfall beim Mann",
      "Harnblasenwandblutung",
      "Harnblasenwanddeformierung",
      "Harnblasenwandfibrose",
      "Harnblasenwandstarre",
      "Harnblasenzyste",
      "Hernia vesicalis beim Mann",
      "Hinman-Syndrom",
      "Hyperaktive Blase",
      "Hyperreflexive Blase",
      "Hyperreflexive Harnblase",
      "Hypertrophie des Trigonum vesicae",
      "Intravesikale Blutung",
      "Intravesikale Hämorrhagie",
      "Irritable bladder",
      "Kalzifizierte Harnblase",
      "Klimakterische Reizblase",
      "Kontrahierte Harnblase",
      "Krampfblase",
      "Malakoplakie der Harnblase",
      "Megavesica",
      "Metaplasie der squamösen Harnblasenzellen",
      "Männliche Zystozele",
      "Männlicher Harnblasenprolaps",
      "Perivesikale Adhäsion",
      "Postinfektiöse Harnblasenleukoplakie",
      "Prävesikale Hernie",
      "Reizblase",
      "Reizblasensyndrom",
      "Riesenharnblase",
      "Schrumpfblase",
      "Schrumpfharnblase",
      "Sklerose des Harnblasensphinkters",
      "Sphincter-urethrae-Sklerose",
      "Trabekelblase",
      "Transurethrale Sphinktersklerose",
      "Trigonummetaplasie",
      "Ulkus des Blasensphinkters",
      "Ulkus des Harnblasensphinkters",
      "Urethrale Sphinktersklerose",
      "Vegetative Reizblase",
      "Verstopfung der Harnblase",
      "Vesikale Blutung",
      "Vesikale Hämorrhagie",
      "Vesikale Kontraktur",
      "Vesikomegalie",
      "Zystoptose",
      "Zystorrhagie",
      "Zystourethrozele beim Mann",
      "Zystozele beim Mann",
      "Überaktive Harnblase"
    ]
  },
  {
    "code": "N32.9",
    "name": "Harnblasenaffektion",
    "synonyms": [
      "Blasen-Darm-Störung",
      "Blasen-Mastdarm-Störung",
      "Blasenbeschwerden",
      "Blasendekompensation",
      "Blasenerkrankung",
      "Blasenkrankheit",
      "Blasenstörung",
      "Harnblasen-Mastdarm-Störung",
      "Harnblasen-Rektum-Störung",
      "Harnblasenaffektion",
      "Harnblasenbeschwerden",
      "Harnblasendekompensation",
      "Harnblasenkrankheit",
      "Harnblasenstörung"
    ]
  },
  {
    "code": "N34.0",
    "name": "Paraurethraler Abszess",
    "synonyms": [
      "Abszess der Cowper-Drüse",
      "Abszess der Littré-Drüsen",
      "Abszess der Skene-Gänge",
      "Harnröhrenabszess",
      "Harnröhrenphlegmone",
      "Harnröhrenpyozele",
      "Paraurethraler Abszess",
      "Periurethraler Abszess",
      "Suburethraler Abszess",
      "Urethraabszess",
      "Urethraabszess im Perineum",
      "Urethradrüsenabszess",
      "Urethrakarbunkel",
      "Urethraphlegmone",
      "Urethrapyozele"
    ]
  },
  {
    "code": "N34.1",
    "name": "Unspezifische Urethritis",
    "synonyms": [
      "Nicht durch Geschlechtsverkehr übertragene Urethritis",
      "Nichtgonorrhoische Urethritis",
      "Nichtspezifische Urethritis",
      "Nichtvenerische Urethritis",
      "Unspezifische Urethritis",
      "Urethritis durch Mykoplasma",
      "Urethritis, nicht durch Gonokokken"
    ]
  },
  {
    "code": "N34.2",
    "name": "Urethrale Meatitis",
    "synonyms": [
      "Adenitis der Bulbourethraldrüse",
      "Adenitis der Cowper-Drüse",
      "Adenitis der Skene-Gänge",
      "Adenitis der Urethraldrüsen",
      "Anteriore Urethritis",
      "Atrophische Urethritis",
      "Cowper-Drüsen-Krankheit",
      "Cowperitis",
      "Entzündung der Cowper-Drüse",
      "Entzündung der Glandulae bulbourethrales",
      "Entzündung der Skene-Drüse",
      "Entzündung der Skene-Gänge",
      "Entzündung der paraurethralen Drüse",
      "Entzündung des Meatus urethrae",
      "Gangränöse Periurethritis",
      "Harnröhrenentzündung",
      "Harnröhrengeschwür",
      "Harnröhreninfektion",
      "Harnröhrenkatarrh",
      "Hormonmangel-Urethritis",
      "Hämorrhagische Urethritis",
      "Infektion der Skene-Gänge",
      "Infektion des Meatus urethrae",
      "Infektion paraurethraler Gänge",
      "Littreitis",
      "Littré-Drüsen-Entzündung",
      "Littré-Drüsen-Krankheit",
      "Paraurethritis",
      "Periurethritis",
      "Polypöse Urethritis",
      "Posteriore Urethritis",
      "Postmenopausale Urethritis",
      "Senile Urethritis",
      "Skenitis",
      "Ulkus des Meatus urinarius",
      "Urethrabulbitis",
      "Urethraentzündung",
      "Urethrageschwür",
      "Urethrainfektion",
      "Urethrakatarrh",
      "Urethrale Meatitis",
      "Urethraulkus",
      "Urethritis",
      "Urethritis externa",
      "Urethritis simplex",
      "Urethrozystitis",
      "Zystourethritis"
    ]
  },
  {
    "code": "N34.3",
    "name": "Urethrales Syndrom",
    "synonyms": [
      "Urethrales Syndrom"
    ]
  },
  {
    "code": "N35.0",
    "name": "Traumatische Harnröhrenstriktur",
    "synonyms": [
      "Harnröhrenstriktur nach Geburt",
      "Harnröhrenstriktur nach Verletzung",
      "Posttraumatische Harnröhrenstriktur",
      "Posttraumatische Urethrastriktur",
      "Traumatische Harnröhrenstenose",
      "Traumatische Harnröhrenstriktur",
      "Traumatische Urethrastenose",
      "Traumatische Urethrastriktur",
      "Urethrastriktur nach Geburt",
      "Urethrastriktur nach Verletzung"
    ]
  },
  {
    "code": "N35.1",
    "name": "Infektiöse Harnröhrenstriktur",
    "synonyms": [
      "Infektiöse Harnröhrenstenose",
      "Infektiöse Harnröhrenstriktur",
      "Infektiöse Urethrastenose",
      "Infektiöse Urethrastriktur a.n.k."
    ]
  },
  {
    "code": "N35.8",
    "name": "Spastische Harnröhrenstriktur",
    "synonyms": [
      "Spastische Harnröhrenstriktur",
      "Spastische Urethrastriktur",
      "Sphinkterspasmus der Urethra"
    ]
  },
  {
    "code": "N35.9",
    "name": "Distale Meatusstenose",
    "synonyms": [
      "Bulbäre Harnröhrenenge",
      "Bulbäre Harnröhrenstenose",
      "Bulbäre Harnröhrenstriktur",
      "Bulbäre Urethraenge",
      "Bulbäre Urethralenge",
      "Bulbäre Urethrastenose",
      "Bulbäre Urethrastriktur",
      "Distale Meatusenge",
      "Distale Meatusstenose",
      "Distale Urethrastenose",
      "Harnröhrenenge",
      "Harnröhrenmündungsstriktur",
      "Harnröhrenstenose",
      "Harnröhrenstriktur",
      "Meatusstenose",
      "Meatusstriktur",
      "Stenose des Ostium urethrae",
      "Stenosis urethrae",
      "Striktur der hinteren Harnröhre",
      "Striktur der hinteren Urethra",
      "Striktur der vorderen Harnröhre",
      "Striktur der vorderen Urethra",
      "Striktur des Meatus urinarius",
      "Urethraenge",
      "Urethrakontraktur",
      "Urethralenge",
      "Urethramündungsstriktur",
      "Urethraobliteration",
      "Urethrastenose",
      "Urethrastriktur",
      "Urethraverengung",
      "Urethraverschluss"
    ]
  },
  {
    "code": "N36.0",
    "name": "Perineale Fistel a.n.k.",
    "synonyms": [
      "Harnröhren-Damm-Fistel",
      "Harnröhren-Haut-Fistel",
      "Harnröhren-Mastdarm-Fistel",
      "Harnröhrenfistel",
      "Harnwegsfistel",
      "Perineale Fistel a.n.k.",
      "Perineale Fistel mit Beteiligung der Harnröhre",
      "Perineale Fistel mit Beteiligung der Urethra",
      "Persistierende Harnwegsfistel",
      "Prostatische Via falsa der Harnröhre",
      "Rektourethrale Fistel",
      "Urethra-Damm-Fistel",
      "Urethra-Haut-Fistel",
      "Urethra-Mastdarm-Fistel",
      "Urethra-Rektum-Fistel",
      "Urethrafistel",
      "Urethrointestinale Fistel",
      "Urethroperineale Fistel",
      "Urethrorektale Fistel",
      "Via falsa der Harnröhre",
      "Via falsa der Urethra"
    ]
  },
  {
    "code": "N36.1",
    "name": "Harnröhrendivertikel",
    "synonyms": [
      "Harnröhrendivertikel",
      "Harnröhrendivertikulitis",
      "Harnröhrendivertikulose",
      "Pseudodivertikel der Harnröhre",
      "Pseudodivertikel der Urethra",
      "Urethradivertikel",
      "Urethradivertikulitis",
      "Urethradivertikulose"
    ]
  },
  {
    "code": "N36.2",
    "name": "Harnröhrenkarunkel",
    "synonyms": [
      "Benigne Caruncula urethrae",
      "Endourethrale Polyposis im Sinne der Harnröhrenkarunkel",
      "Harnröhrenkarunkel",
      "Harnröhrenpolyp im Sinne der Harnröhrenkarunkel",
      "Polyp der Pars prostatica der Urethra im Sinne der Harnröhrenkarunkel",
      "Polyp der prostatischen Harnröhre im Sinne der Harnröhrenkarunkel",
      "Polyp der prostatischen Urethra im Sinne der Urethrakarunkel",
      "Urethrakarunkel",
      "Urethralkarunkel",
      "Urethralpolyp im Sinne der Harnröhrenkarunkel"
    ]
  },
  {
    "code": "N36.3",
    "name": "Männliche Urethrozele",
    "synonyms": [
      "Ektropium urethrae",
      "Harnröhrenprolaps beim Mann",
      "Harnröhrenschleimhautprolaps beim Mann",
      "Harnröhrenschleimhautvorfall beim Mann",
      "Harnröhrenvorfall beim Mann",
      "Männliche Urethrozele",
      "Prolaps des Meatus urinarius",
      "Urethraeversion",
      "Urethraprolaps beim Mann",
      "Urethraschleimhautprolaps beim Mann",
      "Urethraschleimhautvorfall beim Mann",
      "Urethravorfall beim Mann",
      "Urethrozele beim Mann"
    ]
  },
  {
    "code": "N36.8",
    "name": "Harnröhrenektropium",
    "synonyms": [
      "Erworbene Urethradeformität",
      "Erworbene Urethradilatation",
      "Fowler-Syndrom (Dysfunktion des urethralen Sphinkters)",
      "Harnröhrenblutung",
      "Harnröhrenektropium",
      "Harnröhrenmetaplasie",
      "Harnröhrenruptur",
      "Harnröhrenzyste",
      "Hydrourethra",
      "Hypertrophie des Colliculus seminalis",
      "Idiopathische Urethrahämorrhagie",
      "Malakoplakie der Urethra",
      "Nichttraumatische Urethraruptur",
      "Paraurethralzyste",
      "Postinfektiöse Urethraleukoplakie",
      "Schlaffe Harnröhre",
      "Schlaffe Urethra",
      "Suburethrale Zyste",
      "Urethraanhang",
      "Urethrablutung",
      "Urethradrüsenzyste",
      "Urethraektropium",
      "Urethragranulom",
      "Urethrahypertrophie",
      "Urethrahyperämie",
      "Urethrairritabilität",
      "Urethrakolik",
      "Urethrametaplasie",
      "Urethranarbe",
      "Urethraperforation",
      "Urethrarotation",
      "Urethraruptur",
      "Urethrasphinkterrelaxation",
      "Urethraverkürzung",
      "Urethrazyste",
      "Urethrorrhagie",
      "Zyste der Bulbourethraldrüse",
      "Zyste der Cowper-Drüse",
      "Zyste der Skene-Drüse"
    ]
  },
  {
    "code": "N36.9",
    "name": "Urethrale Erkrankung",
    "synonyms": [
      "Harnröhrenkrankheit",
      "Urethrakrankheit",
      "Urethrale Erkrankung",
      "Urethrastörung"
    ]
  },
  {
    "code": "N39.0",
    "name": "Chronische Harnwegsinfektion",
    "synonyms": [
      "Akute Harnwegsinfektion",
      "Asymptomatische Bakteriurie",
      "Aszendierender Harnwegsinfekt",
      "Bakterielle Harnwegsentzündung",
      "Bakterielle Harnwegsinfektion",
      "Bakterielle Pyurie",
      "Bakterien im Urin",
      "Bakteriurie",
      "Bazillen im Harn",
      "Bazillen im Urin",
      "Bazillurie",
      "Chronische Harnwegsinfektion",
      "Eiter im Harn",
      "Eiter im Urin",
      "Eitriger Urin",
      "HWI [Harnwegsinfekt]",
      "Harninfekt",
      "Harnphlegmone",
      "Harnwegsentzündung",
      "Harnwegsinfekt a.n.k.",
      "Harnwegsinfektion a.n.k.",
      "Infektion der Harnorgane a.n.k.",
      "Infektion des Urogenitaltraktes a.n.k.",
      "Koliurie",
      "Pyurie",
      "Rezidivierende Harnwegsinfektion",
      "Rezidivierender Harnwegsinfekt",
      "Urinphlegmone"
    ]
  },
  {
    "code": "N39.1",
    "name": "Persistierende Proteinurie",
    "synonyms": [
      "Persistierende Proteinurie"
    ]
  },
  {
    "code": "N39.2",
    "name": "Orthostatische Proteinurie",
    "synonyms": [
      "Adoleszenten-Albuminurie",
      "Haltungsbedingte Albuminurie",
      "Haltungsbedingte Proteinurie",
      "Juvenile Albuminurie",
      "Lordotische Albuminurie",
      "Orthostatische Albuminurie",
      "Orthostatische Proteinurie",
      "Statische Albuminurie"
    ]
  },
  {
    "code": "N39.3",
    "name": "Belastungsinkontinenz der Harnblase",
    "synonyms": [
      "Belastungsinkontinenz der Harnblase",
      "Harninkontinenz als Stressinkontinenz",
      "Incontinentia urinae durch Stress",
      "Stressinkontinenz der Harnblase",
      "Weibliche Stressinkontinenz"
    ]
  },
  {
    "code": "N39.40",
    "name": "Harninkontinenz als Reflexinkontinenz",
    "synonyms": [
      "Harninkontinenz als Reflexinkontinenz",
      "Reflexinkontinenz"
    ]
  },
  {
    "code": "N39.41",
    "name": "Überlaufblase",
    "synonyms": [
      "Harninkontinenz als Überlaufinkontinenz",
      "Incontinentia paradoxa",
      "Ischuria paradoxa",
      "Überlaufblase"
    ]
  },
  {
    "code": "N39.42",
    "name": "Urgeinkontinenz",
    "synonyms": [
      "Dranginkontinenz (Harninkontinenz)",
      "Harninkontinenz als Dranginkontinenz",
      "Urgeblase",
      "Urgeinkontinenz"
    ]
  },
  {
    "code": "N39.43",
    "name": "Extraurethrale Harninkontinenz",
    "synonyms": [
      "Extraurethrale Harninkontinenz"
    ]
  },
  {
    "code": "N39.48",
    "name": "Harninkontinenz durch organische Ursache",
    "synonyms": [
      "Harninkontinenz durch organische Ursache"
    ]
  },
  {
    "code": "N39.81",
    "name": "Flankenschmerz-Hämaturie-Syndrom",
    "synonyms": [
      "Flankenschmerz-Hämaturie-Syndrom"
    ]
  },
  {
    "code": "N39.88",
    "name": "Harnwegsblutung",
    "synonyms": [
      "Harnröhrenerosion",
      "Harnwegsblutung",
      "Polypöse Urothelwucherung",
      "Spastische Urethrakonstriktion",
      "Urethraerosion",
      "Urotheldysplasie",
      "Urothelhyperplasie",
      "Urothelmetaplasie",
      "Urothelpolyp"
    ]
  },
  {
    "code": "N39.9",
    "name": "Krankheit des Harnsystems",
    "synonyms": [
      "Funktionsstörung der ableitenden Harnwege",
      "Harnwegserkrankung",
      "Krankheit des Harnsystems",
      "Krankheit des Harntraktes",
      "Problem mit dem Harnsystem",
      "Störung des Harnsystems",
      "Uropathie"
    ]
  },
  {
    "code": "N40",
    "name": "Chronische Prostatafibrose",
    "synonyms": [
      "Adenofibromatöse Prostatahypertrophie",
      "BPH [Benigne Prostatahyperplasie]",
      "Benigne Prostatahyperplasie",
      "Benigne Prostatahypertrophie",
      "Blasen-Prostata-Hyperplasie",
      "Blasenhalskropf",
      "Chronische Prostatafibrose",
      "Fibrotische Querbarre des Harnblasenhalses",
      "Hyperplasie des Prostatamittellappens",
      "Hyperplasie des Prostataseitenlappens",
      "Hypertrophie des Prostatamittellappens",
      "Hypertrophie des Prostataseitenlappens",
      "Hypertrophische Querbarre des Harnblasenausganges",
      "Noduläre Prostatahyperplasie",
      "Paraprostatahypertrophie",
      "Prostatahyperplasie",
      "Prostatahypertrophie",
      "Prostataobstruktion",
      "Prostatavergrößerung",
      "Prostatismus",
      "Querbarre des Harnblasenhalses",
      "Urethroprostatopathie",
      "Vergrößerung des Prostatamittellappens",
      "Vergrößerung des Prostataseitenlappens",
      "Verschluss der prostatischen Harnröhre",
      "Verschluss der prostatischen Urethra",
      "Vorsteherdrüsenvergrößerung"
    ]
  },
  {
    "code": "N41.0",
    "name": "Akute Prostatitis",
    "synonyms": [
      "Akute Prostataentzündung",
      "Akute Prostatitis",
      "Akute Vorsteherdrüsenentzündung",
      "Akute bakterielle Prostatitis",
      "Subakute Prostatitis"
    ]
  },
  {
    "code": "N41.1",
    "name": "Chronische Prostatitis",
    "synonyms": [
      "Chronische Prostataentzündung",
      "Chronische Prostatitis",
      "Chronische Vorsteherdrüsenentzündung",
      "Fibröse Prostatitis",
      "Granulomatöse Prostatitis",
      "Hypertrophische Prostatitis",
      "Rezidivierende Prostatitis"
    ]
  },
  {
    "code": "N41.2",
    "name": "Purulente Prostatitis",
    "synonyms": [
      "Eitrige Prostatitis",
      "Periprostatischer Abszess",
      "Prostataabszess",
      "Purulente Prostatitis"
    ]
  },
  {
    "code": "N41.3",
    "name": "Bakterielle Prostatovesikulitis",
    "synonyms": [
      "Bakterielle Prostatovesikulitis",
      "Prostatitis mit Zystitis",
      "Prostatovesikulitis",
      "Prostatozystitis"
    ]
  },
  {
    "code": "N41.8",
    "name": "Kalzifizierende Prostatitis",
    "synonyms": [
      "Kalzifizierende Prostatitis",
      "Steintragende Prostatitis"
    ]
  },
  {
    "code": "N41.9",
    "name": "Prostatitis durch Mykoplasma",
    "synonyms": [
      "Bakterielle Prostatitis",
      "Kongestive Prostatitis",
      "Periprostatitis",
      "Prostatabettentzündung",
      "Prostataentzündung",
      "Prostatainfektion",
      "Prostatakapselinfektion",
      "Prostatitis",
      "Prostatitis durch Enterokokken",
      "Prostatitis durch Mykoplasma",
      "Prostatitis durch Streptokokken",
      "Suppurative Prostatitis",
      "Urethroprostatitis",
      "Vorsteherdrüsenentzündung"
    ]
  },
  {
    "code": "N42.0",
    "name": "Prostatalithiasis",
    "synonyms": [
      "Prostatakonkrement",
      "Prostatalithiasis",
      "Prostatastein"
    ]
  },
  {
    "code": "N42.1",
    "name": "Prostatahämatom",
    "synonyms": [
      "Chronische Prostatastauung",
      "Kongestion des Prostatamittellappens",
      "Kongestion des Prostataseitenlappens",
      "Prostatablutung",
      "Prostatahämatom",
      "Prostatahämorrhagie",
      "Prostatakongestion",
      "Prostatarandblutung",
      "Prostatawandblutung"
    ]
  },
  {
    "code": "N42.2",
    "name": "Prostataatrophie",
    "synonyms": [
      "Prostataatrophie"
    ]
  },
  {
    "code": "N42.3",
    "name": "Intraepitheliale Neoplasie der Prostata [PIN] II. Grades",
    "synonyms": [
      "Intraepitheliale Neoplasie der Prostata [PIN] I. Grades",
      "Intraepitheliale Neoplasie der Prostata [PIN] II. Grades",
      "Niedriggradige Prostatadysplasie",
      "Niedriggradige intraepitheliale Neoplasie der Prostata [low-grade PIN]",
      "Prostatadysplasie"
    ]
  },
  {
    "code": "N42.8",
    "name": "Prostatorrhoe",
    "synonyms": [
      "Amyloidkörperchen der Prostata",
      "Chronische Prostatopathie",
      "Corpora amylacea der Prostata",
      "Erworbene Prostatadeformität",
      "Höckerbildung der Prostata",
      "Induration des Prostatamittellappens",
      "Induration des Prostataseitenlappens",
      "Periprostatische Adhäsion",
      "Prostatadilatation",
      "Prostatafistel",
      "Prostatagranulom",
      "Prostatahypoplasie",
      "Prostatahöcker",
      "Prostatainduration",
      "Prostatainfarkt",
      "Prostatakalzifikation",
      "Prostatakaverne",
      "Prostatakontraktur",
      "Prostatalappeninduration",
      "Prostatanarbe",
      "Prostatastriktur",
      "Prostataverhärtung",
      "Prostataverkalkung",
      "Prostatazyste",
      "Prostatorrhoe",
      "Schnupftabak-Prostata",
      "Utrikuluszyste",
      "Vegetatives urogenitales Syndrom"
    ]
  },
  {
    "code": "N42.9",
    "name": "Prostatakrankheit",
    "synonyms": [
      "Prostataaffektion",
      "Prostatabeschwerden",
      "Prostatakrankheit",
      "Prostataschmerzen",
      "Prostatastörung",
      "Prostatisches Syndrom",
      "Prostatodynie",
      "Prostatopathie",
      "Suspekter Prostatabefund"
    ]
  },
  {
    "code": "N43.0",
    "name": "Zystische Hydrozele",
    "synonyms": [
      "Hydrocele encystica",
      "Zystische Hydrozele"
    ]
  },
  {
    "code": "N43.1",
    "name": "Infizierte Hydrozele",
    "synonyms": [
      "Infizierte Hydrozele"
    ]
  },
  {
    "code": "N43.2",
    "name": "Hydrocele testis mit Hydrocele funiculi spermatici",
    "synonyms": [
      "Hydrocele multilocularis",
      "Hydrocele testis mit Hydrocele funiculi spermatici",
      "Hydrocele vaginalis communicans",
      "Hydrocele vaginalis testis"
    ]
  },
  {
    "code": "N43.3",
    "name": "Hydrocele testis",
    "synonyms": [
      "Hodenhydrozele",
      "Hodensackhydrozele",
      "Hydrocele",
      "Hydrocele testis",
      "Hydrospermatozele",
      "Hydrozele",
      "Hydrozele der Tunica vaginalis testis",
      "Hydrozele des Funiculus spermaticus",
      "Hydrozele des Testis",
      "Samenstranghydrops",
      "Samenstranghydrozele",
      "Skrotumhydrozele",
      "Spermatohydrozele",
      "Wasserbruch - s.a. Hydrozele"
    ]
  },
  {
    "code": "N43.4",
    "name": "Spermatocele testis",
    "synonyms": [
      "Spermatocele testis",
      "Spermatozele"
    ]
  },
  {
    "code": "N44.0",
    "name": "Hodentorsion",
    "synonyms": [
      "Epididymistorsion",
      "Hodentorsion",
      "Nebenhodentorsion",
      "Samenstrangtorsion",
      "Testistorsion",
      "Torsion des Ductus deferens",
      "Torsion des Funiculus spermaticus"
    ]
  },
  {
    "code": "N44.1",
    "name": "Torsion einer Morgagni-Hydatide beim Mann",
    "synonyms": [
      "Hydatidentorsion",
      "Torsion einer Morgagni-Hydatide beim Mann"
    ]
  },
  {
    "code": "N45.0",
    "name": "Hodenabszess",
    "synonyms": [
      "Abszess der Epididymis",
      "Eitrige Epididymitis",
      "Eitrige Hodenentzündung",
      "Eitrige Orchitis",
      "Epididymitis mit Abszess",
      "Epididymoorchitis mit Abszess",
      "Hodenabszess",
      "Hodenfurunkel",
      "Hodenkarbunkel",
      "Hodenphlegmone",
      "Nebenhodenabszess",
      "Orchitis mit Abszess"
    ]
  },
  {
    "code": "N45.9",
    "name": "Akute Epididymitis",
    "synonyms": [
      "Akute Epididymitis",
      "Chronische Epididymitis",
      "Didymitis",
      "Epididymisentzündung",
      "Epididymisgangrän",
      "Epididymitis",
      "Epididymoorchitis",
      "Epididymoorchitis ohne Abszess",
      "Hodenentzündung",
      "Hodengangrän",
      "Hodeninfektion",
      "Nebenhoden-Hoden-Entzündung",
      "Nebenhodenentzündung",
      "Nebenhodengangrän",
      "Nebenhodeninfektion",
      "Nebenhodenorchitis",
      "Nichtvenerische Epididymitis",
      "Orchitis",
      "Orchitis ohne Abszess",
      "Orchoepididymitis",
      "Periepididymitis",
      "Periorchitis",
      "Rekurrente Epididymitis",
      "Residuale Epididymitis",
      "Septische Orchitis",
      "Suppurative Orchitis",
      "Testisinfektion",
      "Testitis",
      "Unspezifische Orchitis"
    ]
  },
  {
    "code": "N46",
    "name": "Männliche Sterilität",
    "synonyms": [
      "Aspermatogenese",
      "Aspermie",
      "Azoospermie",
      "Fertilitätsstörung beim Mann",
      "Fertilitätsverlust beim Mann",
      "Hypospermie",
      "Hypozoospermie",
      "Kryptozoospermie",
      "Männliche Fertilitätsstörung",
      "Männliche Infertilität",
      "Männliche Infertilität mit Störung der Spermatogenese",
      "Männliche Infertilität nach Vasektomie",
      "Männliche Sterilität",
      "Männliche Unfruchtbarkeit",
      "Nekrospermie",
      "Nekrozoospermie",
      "Nicht-syndromale männliche Infertilität durch Asthenozoospermie",
      "Oligo-Astheno-Teratozoospermie",
      "Oligo-Astheno-Zoospermie",
      "Oligo-Azoospermie",
      "Oligospermie",
      "Oligozoospermie",
      "Zeugungsunfähigkeit"
    ]
  },
  {
    "code": "N47",
    "name": "Spanischer Kragen",
    "synonyms": [
      "Akzessorische Vorhaut",
      "Akzessorisches Präputium",
      "Concretio praeputii",
      "Conglutinatio praeputii",
      "Erworbene Präputialkonstriktion",
      "Frenulum breve praeputii",
      "Kongenitale Paraphimose",
      "Kongenitale Phimose",
      "Kontrakte Präputialnarbe",
      "Paraphimose",
      "Phimose",
      "Phimose durch Infektion",
      "Präputialblattverklebung",
      "Präputiale Adhäsion",
      "Präputialenge",
      "Präputialverengung",
      "Präputialverklebung",
      "Präputialverwachsung",
      "Präputiumadhäsion",
      "Präputiumhypertrophie",
      "Spanischer Kragen",
      "Vorhautenge",
      "Vorhauthypertrophie",
      "Vorhautverengung",
      "Vorhautverklebung"
    ]
  },
  {
    "code": "N48.0",
    "name": "Peniskraurose",
    "synonyms": [
      "Balanitis xerotica",
      "Balanitis xerotica obliterans",
      "Craurosis penis",
      "Infektiöse Penisleukoplakie",
      "Lichen albus des Penis",
      "Lichen atrophicus des Penis",
      "Lichen sclerosus des Penis",
      "Lichen sclerosus et atrophicus des Penis",
      "Peniskraurose",
      "Penisleukoplakie",
      "Weißfleckenkrankheit des Penis"
    ]
  },
  {
    "code": "N48.1",
    "name": "Gangränöse Balanitis",
    "synonyms": [
      "Balanitis",
      "Balanitis circinata",
      "Balanitis gangraenosa",
      "Balanitis infectiosa",
      "Balanitis phagedaena",
      "Balanitis simplex",
      "Balanitis vulgaris",
      "Balanoposthitis",
      "Chronische Balanoposthitis",
      "Eichelentzündung - s.a. Balanitis",
      "Eichelkatarrh",
      "Entzündung der Glans penis",
      "Entzündung des Präputiums",
      "Erosion der Glans penis",
      "Erosive Balanitis",
      "Gangränöse Balanitis",
      "Infektion des Präputiums a.n.k.",
      "Infektiöse Balanitis",
      "Nichtgonorrhoische Balanitis",
      "Posthitis",
      "Psoriatische Balanitis",
      "Psoriatische Balanoposthitis",
      "Sklerosierende Balanitis",
      "Ulzeröse Balanitis",
      "Vorhautentzündung"
    ]
  },
  {
    "code": "N48.2",
    "name": "Penislymphangitis",
    "synonyms": [
      "Abszess des Corpus cavernosum",
      "Akute Penislymphangitis",
      "Cavernitis - s.a. Kavernitis",
      "Entzündliche Peniskrankheit",
      "Entzündung des Corpus cavernosum",
      "Furunkel des Corpus cavernosum",
      "Gangrän des Corpus cavernosum",
      "Infektion der Glans penis a.n.k.",
      "Karbunkel des Corpus cavernosum",
      "Kavernitis",
      "Penisabszess",
      "Penisbulbitis",
      "Penisentzündung",
      "Penisfurunkel",
      "Penisgangrän",
      "Penisinfektion a.n.k.",
      "Peniskarbunkel",
      "Peniskavernitis",
      "Penislymphangitis",
      "Penisphlegmone",
      "Penitis",
      "Phlegmone des Corpus cavernosum",
      "Schwellkörperentzündung"
    ]
  },
  {
    "code": "N48.30",
    "name": "Priapismus vom Low-Flow-Typ",
    "synonyms": [
      "Priapismus vom Low-Flow-Typ"
    ]
  },
  {
    "code": "N48.31",
    "name": "Priapismus vom High-Flow-Typ",
    "synonyms": [
      "Priapismus vom High-Flow-Typ"
    ]
  },
  {
    "code": "N48.39",
    "name": "Dauererektion",
    "synonyms": [
      "Dauererektion",
      "Priapismus",
      "Schmerzhafte Dauererektion"
    ]
  },
  {
    "code": "N48.4",
    "name": "Organische erektile Dysfunktion",
    "synonyms": [
      "Endokrine Impotenz",
      "Erektionsstörung organischen Ursprungs beim Mann",
      "Impotenz organischen Ursprungs a.n.k.",
      "Mangelhafte Erektion",
      "Organische Erektionsschwäche",
      "Organische Potenzschwäche",
      "Organische erektile Dysfunktion",
      "Organische erektile Potenzstörung",
      "Posttraumatische Impotenz",
      "Unvollständige Erektion"
    ]
  },
  {
    "code": "N48.5",
    "name": "Penisgeschwür",
    "synonyms": [
      "Chronisches Geschwür des Corpus cavernosum",
      "Chronisches Geschwür des Corpus penis",
      "Chronisches Penisgeschwür",
      "Chronisches Ulkus des Corpus cavernosum penis",
      "Penisgeschwür",
      "Penisulkus",
      "Präputiumulkus"
    ]
  },
  {
    "code": "N48.6",
    "name": "Induratio penis plastica",
    "synonyms": [
      "De-la-Peyronie-Syndrom",
      "Fibrosklerose des Corpus cavernosum",
      "Induratio penis plastica",
      "Induration des Corpus cavernosum penis",
      "Penisfibrose a.n.k.",
      "Penisfibrosklerose",
      "Penissklerose",
      "Penisverhärtung",
      "Peyronie-Krankheit",
      "Sklerose des Corpus cavernosum beim Mann",
      "Verhärtung des Corpus cavernosum penis"
    ]
  },
  {
    "code": "N48.8",
    "name": "Männliche Algopareunie",
    "synonyms": [
      "Atrophie des Corpus cavernosum",
      "Erworbene Penisdeformität",
      "Erworbene Präputiumdeformität",
      "Frenulum breve",
      "Gryposis penis",
      "Hypertrophie des Corpus cavernosum",
      "Kalzifikation des Corpus cavernosum",
      "Koitalgie beim Mann",
      "Männliche Algopareunie",
      "Männliche Dyspareunie",
      "Männliche Kohabitationsbeschwerden",
      "Nichtinfektiöse Gangrän des Corpus cavernosum",
      "Nichtinfektiöse Penisgangrän",
      "Nichttraumatisches Hämatom des Corpus cavernosum",
      "Nichtvenerische Gryposis penis",
      "Nichtvenerische Penisverkürzung",
      "Penisatrophie",
      "Penisblutung",
      "Penisdegeneration",
      "Penisembolie",
      "Penisfistel",
      "Penishypertrophie",
      "Penishämatom",
      "Penishämorrhagie",
      "Peniskalzifikation",
      "Peniskeratose",
      "Penisnarbe",
      "Penisossifikation",
      "Penisreizung",
      "Penisschmerzen",
      "Penisthrombose",
      "Penistorsion",
      "Peniszyste",
      "Penisödem",
      "Penoskrotalhämatom",
      "Präputiumzyste",
      "Schmerzhafte Ejakulation",
      "Schmerzhafter Koitus beim Mann",
      "Schwellkörperfibrose",
      "Talgdrüsenzyste des Penis",
      "Thrombose des Corpus cavernosum",
      "Vorhautzyste",
      "Zyste der Tyson-Drüse"
    ]
  },
  {
    "code": "N48.9",
    "name": "Penisaffektion",
    "synonyms": [
      "Krankheit des Corpus cavernosum",
      "Penisaffektion",
      "Peniskrankheit",
      "Störung des Corpus cavernosum"
    ]
  },
  {
    "code": "N49.0",
    "name": "Samenblasenfurunkel",
    "synonyms": [
      "Perivesikulitis",
      "Perivesikulitis der Bläschendrüse",
      "Samenblasenabszess",
      "Samenblasenempyem",
      "Samenblasenentzündung",
      "Samenblasenfurunkel",
      "Samenblaseninfektion",
      "Samenblasenkarbunkel",
      "Seminalitis",
      "Spermatozystitis",
      "Vesiculitis seminalis",
      "Vesikulitis"
    ]
  },
  {
    "code": "N49.1",
    "name": "Deferentitis",
    "synonyms": [
      "Abszess der Tunica vaginalis testis",
      "Abszess des Ductus deferens",
      "Abszess des Ductus spermaticus",
      "Abszess des Funiculus spermaticus",
      "Abszess des Vas deferens",
      "Akute Funikulitis",
      "Chronische Funikulitis",
      "Deferentitis",
      "Endemische Funikulitis",
      "Entzündung der Tunica vaginalis testis",
      "Entzündung des Funiculus spermaticus",
      "Entzündung des Vas deferens",
      "Funikulitis",
      "Gangrän der Tunica vaginalis testis",
      "Gangrän des Ductus deferens",
      "Infektion der Tunica vaginalis testis",
      "Infektion des Ductus deferens a.n.k.",
      "Infektion des Vas deferens a.n.k.",
      "Karbunkel des Ductus deferens",
      "Karbunkel des Ductus spermaticus",
      "Karbunkel des Funiculus spermaticus",
      "Karbunkel des Vas deferens",
      "Phlegmone des Ductus deferens",
      "Phlegmone des Ductus spermaticus",
      "Phlegmone des Funiculus spermaticus",
      "Phlegmone des Vas deferens",
      "Samenleiterabszess",
      "Samenleiterentzündung",
      "Samenleiterkarbunkel",
      "Samenleiterphlegmone",
      "Samenstrangabszess",
      "Samenstrangentzündung",
      "Samenstrangkarbunkel",
      "Samenstrangphlegmone",
      "Samenwegentzündung",
      "Samenweginfektion",
      "Samenweginfektion durch Staphylokokken",
      "Samenweginfektion durch Streptokokken",
      "Vasitis nodosa"
    ]
  },
  {
    "code": "N49.2",
    "name": "Hodensackphlegmone",
    "synonyms": [
      "Akute Skrotuminfektion a.n.k.",
      "Entzündlicher Skrotalknoten",
      "Hodensackabszess",
      "Hodensackfurunkel",
      "Hodensackkarbunkel",
      "Hodensackphlegmone",
      "Skrotumabszess",
      "Skrotumentzündung",
      "Skrotumfurunkel",
      "Skrotumgangrän",
      "Skrotumkarbunkel",
      "Skrotumphlegmone"
    ]
  },
  {
    "code": "N49.80",
    "name": "Fournier-Gangrän der männlichen Genitalien",
    "synonyms": [
      "Fournier-Gangrän beim Mann",
      "Fournier-Gangrän der männlichen Genitalien"
    ]
  },
  {
    "code": "N49.88",
    "name": "Multiple Entzündungen der männlichen Genitalorgane",
    "synonyms": [
      "Multiple Abszesse der männlichen Genitalorgane",
      "Multiple Entzündungen der männlichen Genitalorgane"
    ]
  },
  {
    "code": "N49.9",
    "name": "Karbunkel der männlichen Geschlechtsorgane",
    "synonyms": [
      "Abszess der männlichen Geschlechtsorgane",
      "Adnexitis virilis",
      "Entzündliche Krankheit der männlichen Genitalorgane",
      "Entzündung der männlichen Geschlechtsorgane",
      "Furunkel der männlichen Geschlechtsorgane",
      "Infektion der männlichen Genitalorgane",
      "Karbunkel der männlichen Geschlechtsorgane",
      "Männliche Genitalentzündung",
      "Perispermatozystitis",
      "Phlegmone der männlichen Genitalorgane"
    ]
  },
  {
    "code": "N50.0",
    "name": "Hodenatrophie",
    "synonyms": [
      "Hodenatrophie",
      "Hodenhypotrophie",
      "Testisatrophie"
    ]
  },
  {
    "code": "N50.1",
    "name": "Thrombose der männlichen Geschlechtsorgane",
    "synonyms": [
      "Blutung der Tunica vaginalis testis",
      "Blutung der männliche Genitalorgane",
      "Blutung des Ductus deferens",
      "Blutung des Ductus spermaticus",
      "Blutung des Hodenparenchyms",
      "Blutung des Vas deferens",
      "Hodenblutung",
      "Hodenhämatom",
      "Hodenhämorrhagie",
      "Hodensackblutung",
      "Hodensackthrombose",
      "Hodenthrombose",
      "Hämatom der männlichen Geschlechtsorgane",
      "Hämatom des Ductus deferens",
      "Hämatom des Ductus spermaticus",
      "Hämatom des Vas deferens",
      "Hämatospermie",
      "Hämatozele",
      "Hämatozele beim Mann a.n.k.",
      "Hämatozele der männlichen Genitalorgane",
      "Hämorrhagie der Tunica vaginalis testis",
      "Hämorrhagie des Ductus deferens",
      "Hämorrhagie des Ductus spermaticus",
      "Hämorrhagie des Vas deferens",
      "Nebenhodenblutung",
      "Nichttraumatisches Epididymishämatom",
      "Nichttraumatisches Hodenhämatom",
      "Nichttraumatisches Hämatom der Tunica vaginalis testis",
      "Nichttraumatisches Hämatom des Vas deferens",
      "Nichttraumatisches Nebenhodenhämatom",
      "Nichttraumatisches Samenstranghämatom",
      "Nichttraumatisches Testishämatom",
      "Samenblasenblutung",
      "Samenblasenhämatom",
      "Samenblasenhämorrhagie",
      "Samenblasenthrombose",
      "Samenleiterblutung",
      "Samenleiterhämatom",
      "Samenleiterthrombose",
      "Samenstrangblutung",
      "Samenstranghämorrhagie",
      "Skrotumblutung",
      "Skrotumhämorrhagie",
      "Skrotumthrombose",
      "Thrombose der männlichen Geschlechtsorgane",
      "Thrombose des Ductus deferens",
      "Thrombose des Ductus spermaticus",
      "Thrombose des Testis",
      "Thrombose des Vas deferens"
    ]
  },
  {
    "code": "N50.8",
    "name": "Fibrose der männlichen Geschlechtsorgane",
    "synonyms": [
      "Adhäsion der Tunica vaginalis testis",
      "Aphthöse Ulzeration der männlichen Geschlechtsorgane",
      "Aphthöses Ulkus der männlichen Geschlechtsorgane",
      "Atrophie der Tunica vaginalis testis",
      "Atrophie der Vesicula seminalis",
      "Atrophie der männlichen Geschlechtsorgane",
      "Atrophie des Ductus deferens",
      "Atrophie des Ductus spermaticus",
      "Atrophie des Funiculus spermaticus",
      "Atrophie des Vas deferens",
      "Chylozele der Tunica vaginalis testis",
      "Chylozele der Tunica vaginalis testis, nicht durch Filarien",
      "Climacterium virile mit Psychosyndrom",
      "Climacterium-virile-Syndrom",
      "Climax virile",
      "Distension der Vesicula seminalis",
      "Ejaculatio deficiens",
      "Epididymisadhäsion",
      "Epididymisatrophie",
      "Epididymisfibrose",
      "Epididymisfistel",
      "Epididymishypertrophie",
      "Epididymisstein",
      "Epididymiszyste",
      "Erworbene Bläschendrüsendeformität",
      "Erworbene Deformität der Vesicula seminalis",
      "Erworbene Deformität der männlichen Geschlechtsorgane",
      "Erworbene Deformität des Ductus deferens",
      "Erworbene Deformität des Ductus ejaculatorius",
      "Erworbene Deformität des Vas deferens",
      "Erworbene Epididymisdeformität",
      "Erworbene Hodendeformität",
      "Erworbene Nebenhodendeformität",
      "Erworbene Samenstrangadhäsion",
      "Erworbene Samenstrangdeformität",
      "Erworbene Skrotumdeformität",
      "Fibrose der Tunica vaginalis testis",
      "Fibrose der männlichen Geschlechtsorgane",
      "Fibrose des Ductus deferens",
      "Fibrose des Ductus ejaculatorius",
      "Fibrose des Ductus spermaticus",
      "Fibrose des Vas deferens",
      "Fistula scrotalis",
      "Geschwür der männlichen Geschlechtsorgane",
      "Geschwür des Ductus deferens",
      "Geschwür des Vas deferens",
      "Hautzyste der männlichen Geschlechtsorgane",
      "Hodenadhäsion",
      "Hodendystrophie",
      "Hodenfibrose",
      "Hodengeschwür",
      "Hodenhyperplasie",
      "Hodenhypertrophie",
      "Hodennekrose",
      "Hodensackatrophie",
      "Hodensackfibrose",
      "Hodensackfistel",
      "Hodensackgeschwür",
      "Hodensackhypertrophie",
      "Hodensackulkus",
      "Hodensacködem",
      "Hodenschmerzen",
      "Hodenschwellung",
      "Hodenulkus",
      "Hodenvergrößerung",
      "Hodenzyste",
      "Hodenödem",
      "Hyperplasie der männlichen Geschlechtsorgane",
      "Hypertrophie der Tunica vaginalis testis",
      "Hypertrophie der Vesicula seminalis",
      "Hypertrophie der männlichen Geschlechtsorgane",
      "Hypertrophie des Ductus deferens",
      "Hypertrophie des Ductus spermaticus",
      "Hypertrophie des Funiculus spermaticus",
      "Hypertrophie des Vas deferens",
      "Intraskrotale Fibrose",
      "Keratose der männlichen Genitalorgane",
      "Klimakterische Krankheit beim Mann",
      "Klimakterium beim Mann a.n.k.",
      "Männliches Klimakterium",
      "Nebenhodenadhäsion",
      "Nebenhodenatrophie",
      "Nebenhodenfibrose",
      "Nebenhodenfistel",
      "Nebenhodenhypertrophie",
      "Nebenhodenkopfzyste",
      "Nebenhodenschmerzen",
      "Nebenhodenschwellung",
      "Nebenhodenstein",
      "Nebenhodenzyste",
      "Necrosis testis",
      "Nichtinfektiöse Gangrän der Tunica vaginalis testis",
      "Nichtinfektiöse Gangrän des Ductus deferens",
      "Nichtinfektiöse Hodengangrän",
      "Nichtinfektiöse Skrotumgangrän",
      "Obstruktion des Ductus ejaculatorius",
      "Orchialgie",
      "Perivesikuläre Adhäsion der Samenblase",
      "Polyp des Colliculus seminalis",
      "Postinfektiöse Adhäsion des Ductus deferens",
      "Postinfektiöse Hodendegeneration",
      "Samenblasenadhäsion",
      "Samenblasenatrophie",
      "Samenblasendivertikel",
      "Samenblasenfibrose",
      "Samenblasengeschwür",
      "Samenblasenhypertrophie",
      "Samenblasenkalzifikation",
      "Samenblasenkongestion",
      "Samenblasenkonkrement",
      "Samenblasennarbe",
      "Samenblasenschmerzen",
      "Samenblasenstein",
      "Samenblasenulkus",
      "Samenblasenverkalkung",
      "Samenblasenzyste",
      "Samenblasenödem",
      "Samengangsobstruktion",
      "Samenleiteratrophie",
      "Samenleiterfibrose",
      "Samenleitergeschwür",
      "Samenleiterhypertrophie",
      "Samenleiterstriktur",
      "Samenleiterödem",
      "Samenstrangatrophie",
      "Samenstrangfibrose",
      "Samenstranggeschwür",
      "Samenstranghypertrophie",
      "Samenstrangschmerzen",
      "Samenstrangstriktur",
      "Samenstrangulkus",
      "Samenstrangzyste",
      "Samenwegobstruktion",
      "Samenwegverschluss",
      "Schmerzen der männlichen Genitalien",
      "Schmerzen des Skrotums",
      "Schwellung des Nebenhodenbereiches",
      "Sklerose des Funiculus spermaticus",
      "Skrotalnekrose",
      "Skrotumatrophie",
      "Skrotumfibrose",
      "Skrotumfistel",
      "Skrotumgeschwür",
      "Skrotumhypertrophie",
      "Skrotumkeratose",
      "Skrotumrelaxation",
      "Skrotumschwellung",
      "Skrotumulkus",
      "Skrotumödem",
      "Smegmaretention am Präputium masculinum",
      "Spermatorrhoe",
      "Stein der Tunica vaginalis testis",
      "Stein der Vesicula seminalis",
      "Stenose des Ductus ej"
    ]
  },
  {
    "code": "N50.9",
    "name": "Affektion der männlichen Geschlechtsorgane",
    "synonyms": [
      "Affektion der männlichen Geschlechtsorgane",
      "Epididymiskrankheit",
      "Hodenkrankheit",
      "Komplikation der männlichen Genitalorgane",
      "Krankheit der Vesicula seminalis",
      "Krankheit des Ductus deferens",
      "Nebenhodenkrankheit",
      "Problem der männlichen Geschlechtsorgane",
      "Skrotumkrankheit",
      "Störung des Urogenitalsystems beim Mann"
    ]
  },
  {
    "code": "N60.0",
    "name": "Solitärzyste der Mamma",
    "synonyms": [
      "Brustdrüsenzyste",
      "Brustwarzenzyste",
      "Gestielte Brustdrüsenzyste",
      "Gestielte Mammazyste",
      "Gutartige Brustdrüsenzyste",
      "Gutartige Mammazyste",
      "Mammaretentionszyste",
      "Mammazyste",
      "Solitärzyste der Brustdrüse",
      "Solitärzyste der Mamma"
    ]
  },
  {
    "code": "N60.1",
    "name": "Diffuse zystische Mastopathie",
    "synonyms": [
      "Chronische Brustdrüsenzyste",
      "Chronische Mammazyste",
      "Chronische Mastitis",
      "Chronische Zystenbrust",
      "Chronische zystische Mastitis",
      "Diffuse zystische Mastopathie",
      "Fibrozystische Brustkrankheit",
      "Fibrozystische Mammakrankheit",
      "Fibrozystische Mastopathie",
      "Mastopathia chronica cystica",
      "Mastopathia cystica",
      "Mastopathia fibrocystica",
      "Mastopathia fibrosa",
      "Mastopathia fibrosa cystica",
      "Mastopathie Grad I",
      "Zystenmamma",
      "Zystische Brustdrüsendysplasie",
      "Zystische Brustdrüsenhypertrophie",
      "Zystische Mammadysplasie",
      "Zystische Mammahypertrophie",
      "Zystische Mammakrankheit",
      "Zystische Mastitis",
      "Zystische Mastitis vom Typ Schimmelbusch",
      "Zystische Mastopathie",
      "Zystische Papillomatose der Brustdrüse",
      "Zystische fibröse Mastopathie"
    ]
  },
  {
    "code": "N60.2",
    "name": "Brustdrüsenfibroadenose",
    "synonyms": [
      "Adenofibrose der Brustdrüse",
      "Brustdrüsenfibroadenose",
      "Chronische Fibroadenose der Brustdrüse",
      "Diffuse Fibroadenose der Brustdrüse",
      "Fibroadenose der Brustdrüse",
      "Mammafibroadenose",
      "Periodische Fibroadenose der Brustdrüse",
      "Segmentale Fibroadenose der Brustdrüse",
      "Sklerosierende Adenose der Brustdrüse",
      "Sklerosierende Adenose der Mamma",
      "Zystische Fibroadenose der Brustdrüse"
    ]
  },
  {
    "code": "N60.3",
    "name": "Mammafibrosklerose",
    "synonyms": [
      "Brustdrüsenfibrose",
      "Brustdrüsenfibrosklerose",
      "Brustdrüsenzyste mit epithelialer Proliferation",
      "Chronische Mastitis mit epithelialer Proliferation",
      "Diffuse zystische Mastopathie mit epithelialer Proliferation",
      "Mammafibrose",
      "Mammafibrosklerose",
      "Mammazyste mit epithelialer Proliferation",
      "Mastopathia chronica cystica mit epithelialer Proliferation",
      "Mastopathie Grad II",
      "Mastopathie Grad III",
      "Zystische Brustdrüsenhypertrophie mit epithelialer Proliferation",
      "Zystische Mammahypertrophie mit epithelialer Proliferation",
      "Zystische Mastitis mit epithelialer Proliferation",
      "Zystische Mastopathie mit epithelialer Proliferation"
    ]
  },
  {
    "code": "N60.4",
    "name": "Ektasie des Ductus lactiferi",
    "synonyms": [
      "Brustdrüsenduktektasie",
      "Dilatation der Brustdrüsenmilchgänge",
      "Dilatation der Ductus lactiferi",
      "Duktektasie der Mamma",
      "Ektasie des Ductus lactiferi",
      "Milchgangsektasie"
    ]
  },
  {
    "code": "N60.8",
    "name": "Zystische Involution der Brustdrüse",
    "synonyms": [
      "Involutionszyste der Brustdrüse",
      "Involutionszyste der Mamma",
      "Metaplasie der apokrinen Drüsen der Mamma",
      "Talgdrüsenzyste der Brust",
      "Talgzyste der Brustdrüse",
      "Talgzyste der Mamma",
      "Zyste der Brusthaut",
      "Zyste eines Talgdrüsenganges der Brust",
      "Zystische Involution der Brustdrüse"
    ]
  },
  {
    "code": "N60.9",
    "name": "Gutartige Mammadysplasie",
    "synonyms": [
      "Brustdrüsendysplasie",
      "Gutartige Mammadysplasie",
      "Mammadysplasie"
    ]
  },
  {
    "code": "N61",
    "name": "Mammazellulitis",
    "synonyms": [
      "Abszess der Areola mammae",
      "Akute Mastitis",
      "Akute infektiöse Mastitis",
      "Akuter Areolaabszess",
      "Akuter Mammaabszess",
      "Akuter nichtpuerperaler Mammaabszess",
      "Areolaabszess",
      "Areolitis",
      "Brustdrüsenabszess",
      "Brustdrüseneiterung",
      "Brustdrüsenentzündung",
      "Brustdrüsenentzündung außerhalb der Neugeborenenperiode",
      "Brustdrüsenfistel",
      "Brustdrüseninfektion",
      "Brustdrüsenkarbunkel",
      "Brustdrüsenulzeration",
      "Brustdrüsenvereiterung",
      "Brustinfektion",
      "Brustulzeration",
      "Brustwarzenabszess",
      "Brustwarzenentzündung",
      "Chronische infektiöse Mastitis",
      "Chronischer Areolaabszess",
      "Chronischer Mammaabszess",
      "Chronischer nichtpuerperaler Mammaabszess",
      "Eitrige Mastitis",
      "Entzündliche Brustdrüsenkrankheit",
      "Entzündliche Mammakrankheit",
      "Entzündung der Areola mammae",
      "Entzündung des Brustwarzenhofes",
      "Fistula mamillaris",
      "Galaktophoritis",
      "Granulomatöse Mastitis",
      "Infektiöse Mastitis",
      "Interstitielle Mastitis",
      "Komedomastitis",
      "Mamillitis",
      "Mammaabszess",
      "Mammaeiterung",
      "Mammaentzündung",
      "Mammaentzündung außerhalb der Neugeborenenperiode",
      "Mammafistel",
      "Mammainfektion",
      "Mammakarbunkel",
      "Mammaulzeration",
      "Mammavereiterung",
      "Mammazellulitis",
      "Mastitis",
      "Mastitis adolescentium",
      "Mastitis beim Mann",
      "Mastitis nonpuerperalis",
      "Mastitis phlegmonosa",
      "Nichtpuerperale Mastitis",
      "Nichtpuerperale infektiöse Mastitis",
      "Nichtpuerperaler Areolaabszess",
      "Nichtpuerperaler Mammaabszess",
      "Paramastitis",
      "Pubertätsmastitis",
      "Subakute Mastitis",
      "Subareolärer Abszess",
      "Thelitis"
    ]
  },
  {
    "code": "N62",
    "name": "Brustwarzenhypertrophie",
    "synonyms": [
      "Brustdrüsenhyperplasie",
      "Brustdrüsenhypertrophie",
      "Brusthypertrophie",
      "Brustwarzenhypertrophie",
      "Familiäre juvenile Gigantomastie",
      "Familiäre juvenile Hypertrophie der Brust",
      "Fettbrust",
      "Gigantomastie",
      "Glanduläre Mammahyperplasie",
      "Gynäkomastie",
      "Hypermastie",
      "Hyperplasie des Brustwarzenepithels",
      "Makromastie",
      "Mammahyperplasie",
      "Mammahypertrophie",
      "Massive pubertätsbedingte Mammahypertrophie",
      "Pubertätsmammahypertrophie",
      "Senile Brustdrüsenhypertrophie",
      "Senile Mammahypertrophie",
      "Überentwicklung der Brustdrüse",
      "Überentwicklung der Mamma"
    ]
  },
  {
    "code": "N63",
    "name": "Mammaverdichtung",
    "synonyms": [
      "Brustdrüsenknoten a.n.k.",
      "Brustdrüsenverhärtung",
      "Mammaknoten",
      "Mammaverdichtung",
      "Mammaverhärtung",
      "Multiple Mammaknoten"
    ]
  },
  {
    "code": "N64.0",
    "name": "Brustwarzenfissur",
    "synonyms": [
      "Brustwarzenfissur",
      "Brustwarzenfistel",
      "Brustwarzenrhagade",
      "Mamillenfissur",
      "Mamillenfistel"
    ]
  },
  {
    "code": "N64.1",
    "name": "Fettgewebsnekrose der Mamma",
    "synonyms": [
      "Brustdrüsennekrose",
      "Brustwarzennekrose",
      "Fettgewebsnekrose der Mamma",
      "Mamillennekrose",
      "Segmentale Fettgewebsnekrose der Brustdrüse"
    ]
  },
  {
    "code": "N64.2",
    "name": "Mammaatrophie",
    "synonyms": [
      "Brustdrüsenatrophie",
      "Brustdrüseninvolution",
      "Brustwarzenatrophie",
      "Mammaatrophie",
      "Mammainvolution"
    ]
  },
  {
    "code": "N64.3",
    "name": "Galaktorrhoe, nicht bei Schwangerschaft",
    "synonyms": [
      "Argonz-del-Castillo-Syndrom",
      "Galaktorrhoe, nicht bei Schwangerschaft",
      "Nichtpuerperale Laktation"
    ]
  },
  {
    "code": "N64.4",
    "name": "Chronische Mastodynie",
    "synonyms": [
      "Brustdrüsenschmerzen",
      "Chronische Mastodynie",
      "Cooper-Syndrom",
      "Mammaschmerzen",
      "Mastalgie",
      "Mastodynie"
    ]
  },
  {
    "code": "N64.5",
    "name": "Mamillenreizung",
    "synonyms": [
      "Blutende Mamma",
      "Brustdrüsenblutung",
      "Brustdrüsenhämorrhagie",
      "Brustdrüseninduration",
      "Brustdrüsenschwellung",
      "Brustwarzenabsonderung",
      "Brustwarzenausfluss",
      "Brustwarzenblutung",
      "Brustwarzeneinziehung",
      "Brustwarzenhämorrhagie",
      "Brustwarzeninversion",
      "Brustwarzenreizung",
      "Brustwarzenretention",
      "Brustwarzenretraktion",
      "Flache Brustwarze",
      "Hohlwarze",
      "Mamillenabsonderung",
      "Mamillenblutung",
      "Mamilleneinziehung",
      "Mamillenreizung",
      "Mamillenretention",
      "Mamillenretraktion",
      "Mamillodynie",
      "Mammaabsonderung",
      "Mammainduration",
      "Mammaretraktion",
      "Mammaschwellung",
      "Mammasekretion",
      "Schlupfbrustwarze",
      "Sezernierende Brustwarze",
      "Sezernierende Mamille",
      "Sezernierende Mamma",
      "Thelalgie",
      "Thelorrhagie"
    ]
  },
  {
    "code": "N64.8",
    "name": "Mangelhafte Mammarückbildung nach Laktation",
    "synonyms": [
      "Brustdrüseninfarkt",
      "Brustwarzendegeneration",
      "Einseitige übermäßige Brustentwicklung",
      "Erworbene Brustdrüsendeformität",
      "Erworbene Brustwarzendeformität",
      "Erworbene Mammadeformität",
      "Galaktozele",
      "Galaktozele der Brust",
      "Hängebrust",
      "Mamma pendulans",
      "Mammadegeneration",
      "Mammainfarkt",
      "Mangelhafte Mammarückbildung nach Laktation",
      "Mastopathia oestrogenica",
      "Mastopathie ovarialen Ursprungs",
      "Mastoptose",
      "Milchgangszyste",
      "Milchzyste",
      "Nichttraumatisches Brustdrüsenhämatom",
      "Nichttraumatisches Mammahämatom",
      "Ptosis mammae",
      "Subinvolution der Brustdrüse nach der Laktation",
      "Subinvolution der Mamma nach der Laktation",
      "Verschluss des Ductus lactiferi"
    ]
  },
  {
    "code": "N64.9",
    "name": "Brustwarzenkrankheit",
    "synonyms": [
      "Brustdrüsenerkrankung",
      "Brustdrüsenkrankheit",
      "Brustdrüsenstörung",
      "Brustwarzenkrankheit",
      "Chronische Mastopathie",
      "Mammaerkrankung",
      "Mammakrankheit",
      "Mammastörung",
      "Mastopathia",
      "Mastopathie",
      "Suspekter Mammabefund"
    ]
  },
  {
    "code": "N70.0",
    "name": "Akute Adnexitis",
    "synonyms": [
      "Akute Adnexitis",
      "Akute Eierstockentzündung",
      "Akute Eileiter- und Eierstock-Entzündung",
      "Akute Eileiterentzündung mit Abszess",
      "Akute Endosalpingitis",
      "Akute Oophoritis",
      "Akute Ovarentzündung",
      "Akute Perioophoritis",
      "Akute Perisalpingitis",
      "Akute Pyosalpingitis",
      "Akute Pyosalpinx",
      "Akute Salpingitis",
      "Akute Salpingo-Oophoritis",
      "Akute Tuben- und Ovar-Entzündung",
      "Akute Tuboovarialentzündung",
      "Akuter Eierstockabszess",
      "Akuter Ovarabszess",
      "Akuter Ovarialabszess",
      "Akuter Tuboovarialabszess",
      "Akutes Pyovar",
      "Subakute Adnexitis"
    ]
  },
  {
    "code": "N70.1",
    "name": "Chronische Tuboovarialentzündung",
    "synonyms": [
      "Chronische Adnexitis",
      "Chronische Eierstockentzündung",
      "Chronische Eileiter- und Eierstock-Entzündung",
      "Chronische Endosalpingitis",
      "Chronische Oophoritis",
      "Chronische Ovarentzündung",
      "Chronische Ovariitis",
      "Chronische Perisalpingitis",
      "Chronische Pyosalpingitis",
      "Chronische Salpingitis",
      "Chronische Salpingo-Oophoritis",
      "Chronische Tuben- und Ovar-Entzündung",
      "Chronische Tuboovarialentzündung",
      "Chronische eitrige Adnexitis",
      "Chronischer Eierstockabszess",
      "Chronischer Eileiterabszess",
      "Chronischer Ovarabszess",
      "Chronischer Ovarialabszess",
      "Chronischer Tuboovarialabszess",
      "Entzündliche Tuboovarialzyste",
      "Hydrops tubae",
      "Hydrosalpinx",
      "Seröse Saktosalpinx"
    ]
  },
  {
    "code": "N70.9",
    "name": "Entzündung einer Adnexe",
    "synonyms": [
      "Abszess der Mesosalpinx",
      "Abszess der Tuba uterina",
      "Abszess der Tuba uterina mit Ruptur",
      "Abszess des Corpus luteum",
      "Adnexitis",
      "Eierstockabszess",
      "Eierstockentzündung",
      "Eileiterabszess",
      "Eileiterentzündung",
      "Eiterung der Tuba uterina",
      "Eitrige Adnexitis",
      "Eitrige Salpingo-Oophoritis",
      "Endosalpingitis",
      "Entzündliche Krankheit der Tuba uterina",
      "Entzündliche Tuboovarialkrankheit",
      "Entzündung der Tuba uterina",
      "Entzündung einer Adnexe",
      "Infektion der Tuba uterina",
      "Infektion des Corpus luteum",
      "Infektiöse Hämatosalpinx",
      "Infektiöse Oophoritis",
      "Interstitielle Oophoritis",
      "Metrosalpingitis",
      "Oophoritis",
      "Ovarialabszess",
      "Ovarialentzündung",
      "Ovarialgangrän",
      "Ovarialnekrose",
      "Ovarialphlegmone",
      "Ovariitis",
      "Ovarinfektion",
      "Perimetrosalpingitis",
      "Perioophoritis",
      "Perisalpingitis",
      "Pyoophoritis",
      "Pyosalpingitis",
      "Pyosalpinx",
      "Pyovar",
      "Ruptur einer Pyosalpinx",
      "Saktosalpinx",
      "Salpingitis",
      "Salpingitis der Tuba uterina",
      "Salpingo-Oophoritis",
      "Salpingo-Oophoritis mit Ruptur",
      "Salpingo-Ovariitis",
      "Salpingoperitonitis",
      "Septische Salpingo-Oophoritis",
      "Suppurative Adnexitis",
      "Suppurative Salpingo-Oophoritis",
      "Tuboovariale Infektion",
      "Tuboovarialentzündung",
      "Tuboovarialer Abszess",
      "Unspezifische Salpingitis",
      "Zystische Oophoritis",
      "Zystische Ovariitis"
    ]
  },
  {
    "code": "N71.0",
    "name": "Akute Uterusentzündung",
    "synonyms": [
      "Akute Endometritis",
      "Akute Endomyometritis",
      "Akute Metritis",
      "Akute Myometritis",
      "Akute Perimetritis",
      "Akute Pyometra",
      "Akute Uterusentzündung",
      "Akuter Uterusabszess",
      "Subakute Endometritis"
    ]
  },
  {
    "code": "N71.1",
    "name": "Chronische Uterusentzündung",
    "synonyms": [
      "Chronische Endometritis",
      "Chronische Endomyometritis",
      "Chronische Metritis",
      "Chronische Myometritis",
      "Chronische Perimetritis",
      "Chronische Pyometra",
      "Chronische Uterusentzündung",
      "Chronischer Uterusabszess"
    ]
  },
  {
    "code": "N71.9",
    "name": "Metrovaginitis",
    "synonyms": [
      "Eitrige Endometritis",
      "Eitrige Gebärmutterentzündung",
      "Eitrige Metritis",
      "Eitrige Uterusentzündung",
      "Eitriges Postmenopausenendometrium",
      "Endometritis",
      "Endometritis nonpuerperalis",
      "Endometriumabszess",
      "Endometriumentzündung",
      "Endomyometritis",
      "Entzündliche Uteruserkrankung",
      "Entzündliche Uteruskrankheit",
      "Entzündung der Gebärmutterschleimhaut",
      "Entzündung der Uterusschleimhaut",
      "Gebärmutterentzündung",
      "Hämorrhagische Metritis",
      "Infektiöse Uteruskrankheit",
      "Katarrhalische Metritis",
      "Metritis",
      "Metrovaginitis",
      "Myometritis",
      "Nichtspezifische Endometritis",
      "Perimetritis",
      "Purulente Endometritis",
      "Pyometra",
      "Pyometritis",
      "Senile atrophische Endometritis",
      "Septische Endometritis",
      "Septische Gebärmutterentzündung",
      "Septische Metritis",
      "Septische Uterusphlebitis",
      "Uterusabszess",
      "Uteruseiterung",
      "Uterusentzündung",
      "Uterusgangrän",
      "Uterusinfektion"
    ]
  },
  {
    "code": "N72",
    "name": "Entzündliche Krankheit der Cervix uteri",
    "synonyms": [
      "Abszess der Glandulae cervicales uteri",
      "Abszess der Ovula Nabothi",
      "Akute Endozervizitis",
      "Akute Zervizitis",
      "Cervicitis - s.a. Zervizitis",
      "Cervicitis subacuta",
      "Cervicocolpitis emphysematosa",
      "Chronische Endozervizitis",
      "Chronische Gebärmutterhalsentzündung",
      "Chronische Zervizitis",
      "Endometritis der Cervix uteri",
      "Endozervixinfektion",
      "Endozervizitis",
      "Endozervizitis mit Ektropium",
      "Endozervizitis mit Erosion",
      "Entzündliche Krankheit der Cervix uteri",
      "Entzündliche Zervixkrankheit",
      "Entzündung der Cervix uteri",
      "Erosive Zervizitis",
      "Eversion der Cervix uteri mit Zervizitis",
      "Exozervizitis",
      "Exozervizitis mit Ektropium",
      "Exozervizitis mit Erosion",
      "Gebärmutterhalsabszess",
      "Gebärmutterhalsentzündung",
      "Gebärmutterhalskatarrh",
      "Hyperplastische Endozervizitis",
      "Hyperplastische Zervizitis",
      "Infektion der Cervix uteri",
      "Katarrh der Cervix uteri",
      "Nichtpuerperaler Abszess der Cervix uteri",
      "Nichtvenerische Zervizitis",
      "Phlegmone der Cervix uteri",
      "Portioentzündung",
      "Reizung der Cervix uteri",
      "Senile atrophische Zervizitis",
      "Subakute Zervizitis",
      "Ulkus der Cervix uteri mit Zervizitis",
      "Uterushalsabszess",
      "Zervikale Metritis",
      "Zervikokolpitis",
      "Zervixendometritis",
      "Zervixentzündung",
      "Zervixinfektion",
      "Zervixkatarrh",
      "Zervixphlegmone",
      "Zervixreizung",
      "Zervixulkus mit Zervizitis",
      "Zervizitis",
      "Zervizitis mit Ektropium",
      "Zervizitis mit Erosion",
      "Zervizitis mit Ulkus",
      "Zervizitis mit Ulzeration"
    ]
  },
  {
    "code": "N73.0",
    "name": "Akute Beckenbindegewebsentzündung",
    "synonyms": [
      "Akute Beckenbindegewebsentzündung",
      "Akute Bindegewebsentzündung im weiblichen Becken",
      "Akute Parametritis",
      "Akute entzündliche Beckenkrankheit",
      "Akuter Abszess des Ligamentum latum uteri",
      "Akuter Parametriumabszess"
    ]
  },
  {
    "code": "N73.1",
    "name": "Chronischer parauteriner Abszess",
    "synonyms": [
      "Chronische Beckenbindegewebsentzündung",
      "Chronische Bindegewebsentzündung im weiblichen Becken",
      "Chronische Parametritis",
      "Chronische entzündliche Beckenkrankheit",
      "Chronischer Abszess des Ligamentum latum uteri",
      "Chronischer Abszess des Parametriums",
      "Chronischer parauteriner Abszess",
      "Chronischer periuteriner Abszess"
    ]
  },
  {
    "code": "N73.2",
    "name": "Periuteriner Abszess",
    "synonyms": [
      "Abszess des Ligamentum latum uteri",
      "Abszess des Parametriums",
      "Abszess des breiten Mutterbandes",
      "Beckenbindegewebsentzündung",
      "Bindegewebsentzündung des weiblichen Beckens",
      "Entzündung des Ligamentum latum uteri",
      "Parametrischer Abszess",
      "Parametritis",
      "Parametriumentzündung",
      "Parauteriner Abszess",
      "Perimetrischer Abszess",
      "Periuterine Entzündung",
      "Periuteriner Abszess",
      "Retrouteriner Abszess",
      "Uterusbandabszess",
      "Uterusbandentzündung"
    ]
  },
  {
    "code": "N73.3",
    "name": "Akute Pelveoperitonitis bei der Frau",
    "synonyms": [
      "Akute Pelveoperitonitis bei der Frau",
      "Akute Peritonitis des weiblichen Beckens"
    ]
  },
  {
    "code": "N73.4",
    "name": "Chronische Pelveoperitonitis bei der Frau",
    "synonyms": [
      "Chronische Pelveoperitonitis bei der Frau"
    ]
  },
  {
    "code": "N73.5",
    "name": "Pelveoperitonitis bei der Frau",
    "synonyms": [
      "Abszess des Beckenperitoneums bei der Frau",
      "Abszess des Douglas-Raums",
      "Chronischer Douglasabszess",
      "Douglasabszess",
      "Metroperitonitis",
      "Pelveoperitonitis bei der Frau",
      "Peritonitis des weiblichen Beckens"
    ]
  },
  {
    "code": "N73.6",
    "name": "Peritoneale Adhäsion des weiblichen Beckens",
    "synonyms": [
      "Adhäsion des Eierstocks",
      "Adhäsion des Ovars",
      "Adhäsion des weiblichen Beckens",
      "Adhäsion des weiblichen Pelviperitoneums",
      "Adhäsionsbeschwerden im weiblichen Becken",
      "Adhäsionsschmerzen im weiblichen Becken",
      "Chronische Beckenperitonitis mit Verwachsung bei der Frau",
      "Gewebestrang des Uterus",
      "Pelviperitoneale Verwachsung bei der Frau",
      "Periovariale Adhäsion",
      "Peritoneale Adhäsion des weiblichen Beckens",
      "Peritubare Adhäsion",
      "Periuterine Adhäsion",
      "Postinfektiöse Beckenadhäsion bei der Frau",
      "Postinfektiöse Uterusadhäsion zur Bauchwand",
      "Postinfektiöse postpartale Beckenadhäsion",
      "Tuboovariale Adhäsion",
      "Verwachsung des weiblichen Beckens",
      "Äußere Uterusadhäsion"
    ]
  },
  {
    "code": "N73.8",
    "name": "Entzündliches Douglasinfiltrat",
    "synonyms": [
      "Entzündliches Douglasinfiltrat"
    ]
  },
  {
    "code": "N73.9",
    "name": "Beckenentzündung bei der Frau",
    "synonyms": [
      "Abszess im weiblichen Becken",
      "Beckenentzündung bei der Frau",
      "Eiterung im weiblichen Becken",
      "Entzündliche Krankheit des weiblichen Beckens",
      "Entzündliche Unterbaucherkrankung",
      "Entzündung der Beckenorgane bei der Frau",
      "Entzündung der weiblichen Geschlechtsorgane",
      "Entzündung des weiblichen Beckengewebes",
      "Entzündung des weiblichen Beckens",
      "Infektion der weiblichen Genitalorgane",
      "Infektion des weiblichen Beckens",
      "Weibliche Pelveopathie"
    ]
  },
  {
    "code": "N75.0",
    "name": "Bartholin-Zyste",
    "synonyms": [
      "Bartholin-Zyste",
      "Zyste der Bartholin-Drüse"
    ]
  },
  {
    "code": "N75.1",
    "name": "Bartholin-Abszess",
    "synonyms": [
      "Abszess der vulvovaginalen Drüsen",
      "Bartholin-Abszess",
      "Bartholin-Empyem",
      "Bartholin-Pseudoabszess"
    ]
  },
  {
    "code": "N75.8",
    "name": "Bartholinitis",
    "synonyms": [
      "Bartholin-Adenitis",
      "Bartholinitis",
      "Eitrige Bartholinitis",
      "Entzündung der Bartholin-Drüse",
      "Hypertrophie der Bartholin-Drüse",
      "Infektion der Bartholin-Drüse"
    ]
  },
  {
    "code": "N76.0",
    "name": "Akute Kolpitis",
    "synonyms": [
      "Akute Kolpitis",
      "Akute Vaginalinfektion",
      "Akute Vaginitis",
      "Akute Vulvovaginitis",
      "Allergische Vaginitis",
      "Aminkolpitis",
      "Bakterielle Kolpitis",
      "Bakterielle Vaginalinfektion",
      "Bakterielle Vaginitis",
      "Bakterielle Vaginose",
      "Bakterielle Vulvovaginitis",
      "Colpitis - s.a. Kolpitis",
      "Gardnerella-Kolpitis",
      "Gardnerella-Vaginitis",
      "Hämorrhagische Kolpitis",
      "Kolpitis",
      "Kolpitis durch Haemophilus influenzae",
      "Kolpitis durch Kokken",
      "Kolpozystitis",
      "Parakolpitis",
      "Paravaginaler Abszess",
      "Paravaginitis",
      "Perivaginitis",
      "Pyokolpos",
      "Scheidenentzündung",
      "Unspezifische Kolpitis",
      "Vaginalabszess",
      "Vaginalentzündung",
      "Vaginitis",
      "Vaginitis durch Haemophilus influenzae",
      "Vaginorektaler Abszess",
      "Vibrionen-Kolpitis",
      "Vulvitis mit Vaginitis",
      "Vulvokolpitis",
      "Vulvovaginitis"
    ]
  },
  {
    "code": "N76.1",
    "name": "Subakute chronische Kolpitis",
    "synonyms": [
      "Atrophische hämorrhagische Kolpitis",
      "Chronische Kolpitis",
      "Chronische Kolpitis durch Haemophilus influenzae",
      "Chronische Kolpitis durch Kokken",
      "Chronische Vaginitis",
      "Chronische Vibrionen-Kolpitis",
      "Chronische Vulvovaginitis",
      "Chronische atrophische Kolpitis",
      "Chronische bakterielle Kolpitis",
      "Chronische bakterielle Vaginose",
      "Chronische bakterielle Vulvovaginitis",
      "Chronische unspezifische Kolpitis",
      "Subakute Vaginitis",
      "Subakute Vulvovaginitis",
      "Subakute chronische Kolpitis"
    ]
  },
  {
    "code": "N76.2",
    "name": "Akute Vulvitis",
    "synonyms": [
      "Akute Infektion der Labia majora pudendi",
      "Akute Infektion der Labia minora pudendi",
      "Akute Vulvainfektion",
      "Akute Vulvitis",
      "Allergische Vulvitis",
      "Aphthöse Vulvitis",
      "Atrophische Vulvitis",
      "Entzündung der Labia majora pudendi",
      "Entzündung der Labia minora pudendi",
      "Erosive Vulvitis",
      "Gangränöse Vulvitis",
      "Hypertrophische Vulvitis",
      "Intertriginöse Vulvitis",
      "Labienentzündung",
      "Schamlippenentzündung",
      "Schamlippeninfektion",
      "Schamlippenkatarrh",
      "Senile Vulvitis",
      "Vestibulitis der Vulva",
      "Vulvaentzündung",
      "Vulvainfektion",
      "Vulvitis",
      "Vulvitis allergica"
    ]
  },
  {
    "code": "N76.3",
    "name": "Chronische Vulvitis",
    "synonyms": [
      "Chronische Vulvitis",
      "Subakute Vulvitis"
    ]
  },
  {
    "code": "N76.4",
    "name": "Vulvakarbunkel",
    "synonyms": [
      "Abszess der Labia majora pudendi",
      "Abszess der Labia minora pudendi",
      "Abszess der äußeren Genitalorgane bei der Frau",
      "Folliculitis vulvae",
      "Furunkel der Labia majora pudendi",
      "Furunkel der Labia minora pudendi",
      "Karbunkel der Labia majora pudendi",
      "Karbunkel der Labia minora pudendi",
      "Labienabszess",
      "Schamlippenabszess",
      "Schamlippenfurunkel",
      "Schamlippenkarbunkel",
      "Vulvaabszess",
      "Vulvafurunkel",
      "Vulvakarbunkel"
    ]
  },
  {
    "code": "N76.5",
    "name": "Vaginalulkus",
    "synonyms": [
      "Druckulkus der Vagina",
      "Scheidenulzeration",
      "Vaginalulkus",
      "Vaginalulzeration"
    ]
  },
  {
    "code": "N76.6",
    "name": "Vulvaulzeration",
    "synonyms": [
      "Aphthöse Ulzeration der weiblichen Geschlechtsorgane",
      "Aphthöses Ulkus der weiblichen Geschlechtsorgane",
      "Labienulkus",
      "Ulkus der Labia majora pudendi",
      "Ulkus der Labia minora pudendi",
      "Vulvadruckulkus",
      "Vulvaulkus",
      "Vulvaulzeration"
    ]
  },
  {
    "code": "N76.80",
    "name": "Noma pudendi",
    "synonyms": [
      "Fournier-Gangrän bei der Frau",
      "Noma pudendi",
      "Noma vulvae",
      "Vulvagangrän"
    ]
  },
  {
    "code": "N76.88",
    "name": "Vulvaekzem",
    "synonyms": [
      "Bakterieller Fluor",
      "Entzündliche Krankheit der Vagina a.n.k.",
      "Entzündliche Krankheit der Vulva a.n.k.",
      "Pustulöses Vulvaekzem",
      "Vaginakrankheit mit Entzündung",
      "Vaginale Mukositis",
      "Vaginale Radiomukositis",
      "Vulvaekzem",
      "Vulvakrankheit mit Entzündung",
      "Vulvamukositis",
      "Vulvovaginale Ulzeration"
    ]
  },
  {
    "code": "N80.0",
    "name": "Uterusendometriose",
    "synonyms": [
      "Adenomyomatose des Uterus",
      "Adenomyose",
      "Adenomyosis",
      "Adenomyosis uteri",
      "Endometriose des Uterus",
      "Endometriosis uteri",
      "Endometriosis uteri externa",
      "Endometriosis uteri interna",
      "Fibroadenomatosis uteri",
      "Portioendometriose",
      "Uterusendometriose"
    ]
  },
  {
    "code": "N80.1",
    "name": "Ovarialendometriose",
    "synonyms": [
      "Eierstockendometriose",
      "Endometriose des Ovars",
      "Endometriosis ovarii",
      "Ovarialendometriose",
      "Sampson-Tumor",
      "Sampson-Zyste",
      "Schokoladenzyste des Ovars",
      "Teerzyste des Ovars"
    ]
  },
  {
    "code": "N80.2",
    "name": "Endometriose der Tuba uterina",
    "synonyms": [
      "Eileiterendometriose",
      "Endometriose der Tuba uterina",
      "Endometriosis tubae",
      "Tubenendometriose"
    ]
  },
  {
    "code": "N80.3",
    "name": "Endometriose des Beckenperitoneums",
    "synonyms": [
      "Beckenendometriose",
      "Douglasendometriose",
      "Endometriose des Beckenperitoneums",
      "Endometriose des Pelviperitoneums"
    ]
  },
  {
    "code": "N80.4",
    "name": "Endometriose des Septum rectovaginale",
    "synonyms": [
      "Endometriose des Septum rectovaginale",
      "Endometriosis vaginae",
      "Vaginalendometriose"
    ]
  },
  {
    "code": "N80.5",
    "name": "Intestinale Endometriose",
    "synonyms": [
      "Darmendometriose",
      "Endometriose des Darmes",
      "Intestinale Endometriose"
    ]
  },
  {
    "code": "N80.6",
    "name": "Hautendometriose",
    "synonyms": [
      "Endometriose in Hautnarbe",
      "Hautendometriose",
      "Hautnarbenendometriose",
      "Narbenendometriose"
    ]
  },
  {
    "code": "N80.8",
    "name": "Endometriosis externa",
    "synonyms": [
      "Blasenendometriose",
      "Endometriosis externa",
      "Endometriosis genitalis",
      "Endometriosis genitalis externa",
      "Endometriosis genitalis interna",
      "Harnblasenendometriose",
      "Nabelendometriose",
      "Rektumendometriose",
      "Thorakale Endometriose",
      "Thoraxendometriose"
    ]
  },
  {
    "code": "N80.9",
    "name": "Endometriosezyste",
    "synonyms": [
      "Ektopische Zyste des Endometriums",
      "Endometriose",
      "Endometriosezyste",
      "Endometriumektopie",
      "Hysteroadenosis"
    ]
  },
  {
    "code": "N81.0",
    "name": "Weibliche Urethrozele",
    "synonyms": [
      "Harnröhrenprolaps bei der Frau",
      "Harnröhrenschleimhautprolaps bei der Frau",
      "Harnröhrenschleimhautvorfall bei der Frau",
      "Harnröhrenvorfall bei der Frau",
      "Urethraprolaps bei der Frau",
      "Urethraschleimhautprolaps bei der Frau",
      "Urethraschleimhautvorfall bei der Frau",
      "Urethravorfall bei der Frau",
      "Urethrozele bei der Frau",
      "Weibliche Urethrozele"
    ]
  },
  {
    "code": "N81.1",
    "name": "Zystourethrozele",
    "synonyms": [
      "Blasenprolaps bei der Frau",
      "Blasensenkung bei der Frau",
      "Descensus vaginae",
      "Descensus vaginae anterior",
      "Descensus vaginae et vesicae",
      "Harnblasenhernie bei der Frau",
      "Harnblasenvorfall bei der Frau",
      "Hernia vaginalis anterior",
      "Hernia vesicalis bei der Frau",
      "Kolpozele",
      "Prolaps der vorderen Scheidenwand",
      "Prolaps der vorderen Vaginalwand",
      "Prolapsus vaginalis",
      "Rektozystozele bei der Frau",
      "Scheidenprolaps",
      "Scheidensenkung",
      "Scheidenvorfall",
      "Scheidenwandvorfall",
      "Urethrozele mit Zystozele bei der Frau",
      "Vaginalprolaps",
      "Vaginalsenkung",
      "Vaginaltotalprolaps",
      "Vaginalvorfall",
      "Weibliche Harnblasensenkung",
      "Weibliche Zystozele",
      "Weiblicher Descensus vesicae",
      "Weiblicher Harnblasenprolaps",
      "Zystoenterozele",
      "Zystorektozele bei der Frau",
      "Zystourethrozele",
      "Zystourethrozele bei der Frau",
      "Zystozele",
      "Zystozele 1. Grades bei der Frau",
      "Zystozele 2. Grades bei der Frau",
      "Zystozele 3. Grades bei der Frau",
      "Zystozele bei der Frau"
    ]
  },
  {
    "code": "N81.2",
    "name": "Partieller uterovaginaler Vorfall",
    "synonyms": [
      "Alter postpartaler Prolaps der Cervix uteri",
      "Alter postpartaler Zervixprolaps",
      "Descensus uteri 1. Grades",
      "Descensus uteri 2. Grades",
      "Partieller Descensus uteri et vaginae",
      "Partieller uterovaginaler Prolaps",
      "Partieller uterovaginaler Vorfall",
      "Portioprolaps",
      "Prolaps der Cervix uteri",
      "Prolaps des Stumpfes der Cervix uteri",
      "Prolapsus partialis uteri et vaginae",
      "Uteruspartialprolaps",
      "Uterusprolaps 1. Grades",
      "Uterusprolaps 2. Grades",
      "Vaginalprolaps mit partiellem Uterusprolaps",
      "Zervixprolaps",
      "Zervixstumpfprolaps"
    ]
  },
  {
    "code": "N81.3",
    "name": "Totalprolaps von Uterus und Vagina",
    "synonyms": [
      "Descensus uteri 3. Grades",
      "Procidentia uteri",
      "Subtotaler Prolaps von Uterus und Vagina",
      "Totaler Descensus uteri et vaginae",
      "Totaler uterovaginaler Prolaps",
      "Totalprolaps von Uterus und Vagina",
      "Uterusprolaps 3. Grades",
      "Uterusprolaps 4. Grades",
      "Uterustotalprolaps",
      "Vollständiger uterovaginaler Prolaps",
      "Vollständiger uterovaginaler Vorfall"
    ]
  },
  {
    "code": "N81.4",
    "name": "Uterusprolaps",
    "synonyms": [
      "Descensus uteri",
      "Descensus uteri et vaginae",
      "Gebärmuttersenkung",
      "Gebärmuttervorfall",
      "Postpartaler Uterusprolaps",
      "Prolaps von Gebärmutter und Scheide",
      "Prolaps von Uterus und Vagina",
      "Prolapsus vaginae et uteri",
      "Uterovaginalprolaps",
      "Uterusekstrophie nach Geburt",
      "Uteruseversion",
      "Uterusextraversion",
      "Uterushernie",
      "Uterusprolaps",
      "Uterussenkung",
      "Uterusvorfall"
    ]
  },
  {
    "code": "N81.5",
    "name": "Vaginalenterozele",
    "synonyms": [
      "Douglashernie",
      "Douglaszele",
      "Erworbene Vaginalenterozele a.n.k.",
      "Kongenitale Vaginalenterozele a.n.k.",
      "Scheidenenterozele",
      "Vaginalenterozele"
    ]
  },
  {
    "code": "N81.6",
    "name": "Prolaps der hinteren Scheidenwand",
    "synonyms": [
      "Hernia rectovaginalis",
      "Hernie der hinteren Scheidenwand",
      "Hernie der hinteren Vaginalwand",
      "Proktozele bei der Frau",
      "Prolaps der Vaginahinterwand mit Uterusprolaps",
      "Prolaps der hinteren Scheidenwand",
      "Prolaps der hinteren Vaginalwand",
      "Rektozele",
      "Rektozele bei der Frau",
      "Weiblicher anorektaler Prolaps"
    ]
  },
  {
    "code": "N81.8",
    "name": "Alte Lazeration des Dammes",
    "synonyms": [
      "Alte Lazeration des Beckenbodens",
      "Alte Lazeration des Dammes",
      "Alte Perineumlazeration",
      "Alte Verletzung der Beckenbodenmuskulatur",
      "Alter Muskelriss des Beckenbodens",
      "Alter partaler Dammriss",
      "Beckenbodenrelaxation",
      "Beckenbodenschwäche",
      "Erschlaffung des weiblichen Beckenbodens",
      "Perinealprolaps bei der Frau",
      "Perinealrelaxation",
      "Perineuminsuffizienz",
      "Prolaps des weiblichen Beckenbodens"
    ]
  },
  {
    "code": "N81.9",
    "name": "Genitalprolaps bei der Frau",
    "synonyms": [
      "Genitalprolaps bei der Frau",
      "Prolaps der weiblichen Geschlechtsorgane",
      "Prolapsus genitalis",
      "Vorfall der weiblichen Geschlechtsorgane"
    ]
  },
  {
    "code": "N82.0",
    "name": "Blasen-Scheiden-Fistel",
    "synonyms": [
      "Blasen-Scheiden-Fistel",
      "Harnblasen-Scheiden-Fistel",
      "Harnblasen-Vagina-Fistel",
      "Scheiden-Blasen-Fistel",
      "Vaginovesikale Fistel",
      "Vesikovaginale Fistel"
    ]
  },
  {
    "code": "N82.1",
    "name": "Urethrovaginale Fistel",
    "synonyms": [
      "Harnblasen-Uterus-Fistel",
      "Harnleiter-Scheiden-Fistel",
      "Ureterouterine Fistel",
      "Ureterovaginale Fistel",
      "Urethrovaginale Fistel",
      "Uterovesikale Fistel",
      "Uterus-Harnleiter-Fistel",
      "Vesikoureterovaginale Fistel",
      "Vesikouterine Fistel",
      "Vesikozervikale Fistel",
      "Vesikozervikovaginale Fistel",
      "Youssef-Syndrom [Vesikouterine Fistel]"
    ]
  },
  {
    "code": "N82.2",
    "name": "Dünndarm-Scheiden-Fistel",
    "synonyms": [
      "Dünndarm-Scheiden-Fistel",
      "Dünndarm-Vagina-Fistel",
      "Enterovaginale Dünndarmfistel",
      "Fistula ileovaginalis",
      "Ileovaginalfistel",
      "Intestinovaginale Dünndarmfistel a.n.k."
    ]
  },
  {
    "code": "N82.3",
    "name": "Sigma-Vagina-Fistel",
    "synonyms": [
      "Enterovaginale Dickdarmfistel",
      "Intestinovaginale Dickdarmfistel a.n.k.",
      "Kolovaginale Fistel",
      "Mastdarm-Scheiden-Fistel",
      "Rektovaginale Fistel",
      "Rektovesikovaginale Fistel",
      "Rektum-Scheiden-Fistel",
      "Sigma-Scheiden-Fistel",
      "Sigma-Vagina-Fistel",
      "Vesikosigmoideovaginale Fistel"
    ]
  },
  {
    "code": "N82.4",
    "name": "Uterorektale Fistel",
    "synonyms": [
      "Enterouterine Fistel",
      "Enterovaginale Fistel",
      "Fistula enterovaginalis",
      "Genitaltrakt-Darm-Fistel bei der Frau a.n.k.",
      "Intestinouterine Fistel",
      "Intestinovaginale Fistel a.n.k.",
      "Rektolabiale Fistel",
      "Rektouterine Fistel",
      "Rektovulväre Fistel",
      "Uterointestinale Fistel",
      "Uterorektale Fistel",
      "Vulvorektale Fistel",
      "Zervikosigmoidale Fistel"
    ]
  },
  {
    "code": "N82.5",
    "name": "Abdominouterine Fistel",
    "synonyms": [
      "Abdomenwand-Uterus-Fistel",
      "Abdominouterine Fistel",
      "Genitaltrakt-Haut-Fistel bei der Frau",
      "Uteroabdominale Fistel",
      "Uterus-Bauchwand-Fistel",
      "Vagina-Haut-Fistel",
      "Vaginoperineale Fistel",
      "Äußere Fistel der Tuba uterina",
      "Äußere Uterusfistel"
    ]
  },
  {
    "code": "N82.80",
    "name": "Fistel zwischen Vagina und Pouch als Rektumersatz",
    "synonyms": [
      "Fistel zwischen Vagina und Pouch als Rektumersatz"
    ]
  },
  {
    "code": "N82.81",
    "name": "Fistel zwischen Vagina und Ersatzharnblase",
    "synonyms": [
      "Fistel zwischen Vagina und Ersatzharnblase"
    ]
  },
  {
    "code": "N82.88",
    "name": "Uterovaginale Fistel",
    "synonyms": [
      "Blasen-Rektum-Scheiden-Fistel",
      "Douglas-Scheiden-Fistel",
      "Douglas-Vagina-Fistel",
      "Rektum-Scheiden-Blasen-Fistel",
      "Uterovaginale Fistel",
      "Vulvafistel"
    ]
  },
  {
    "code": "N82.9",
    "name": "Fistel der weiblichen Geschlechtsorgane",
    "synonyms": [
      "Fistel der Bartholin-Drüse",
      "Fistel der Cervix uteri",
      "Fistel der Labia majora pudendi",
      "Fistel der Labia minora pudendi",
      "Fistel der weiblichen Genitalorgane",
      "Fistel der weiblichen Geschlechtsorgane",
      "Fistula vaginalis",
      "Scheidenfistel",
      "Uterusfistel",
      "Vaginalfistel",
      "Zervixfistel"
    ]
  },
  {
    "code": "N83.0",
    "name": "Follikelzyste des Ovars",
    "synonyms": [
      "Atretische follikuläre Zyste",
      "Blutung eines rupturierten Graaf-Follikels",
      "Follikelzyste des Ovars",
      "Follikuläre Eierstockzyste",
      "Follikuläre Ovarzyste",
      "Hämorrhagie des rupturierten Graaf-Follikels",
      "Hämorrhagische Follikelzyste",
      "Ruptur eines Graaf-Follikels",
      "Rupturierte hämorrhagische Zyste des Graaf-Follikels",
      "Zyste des Graaf-Follikels"
    ]
  },
  {
    "code": "N83.1",
    "name": "Hämorrhagische Zyste des Corpus luteum",
    "synonyms": [
      "Blutung einer rupturierten Zyste des Corpus luteum",
      "Gelbkörperzyste",
      "Hämorrhagie einer rupturierten Zyste des Corpus luteum",
      "Hämorrhagische Luteinzyste",
      "Hämorrhagische Zyste des Corpus luteum",
      "Hämorrhagisches zystisches Corpus luteum",
      "Luteinzyste",
      "Ruptur des Corpus luteum",
      "Ruptur einer Zyste des Corpus luteum",
      "Thekalutein-Zyste des Ovars",
      "Zyste des Corpus luteum"
    ]
  },
  {
    "code": "N83.2",
    "name": "Rupturierte Ovarialzyste",
    "synonyms": [
      "Adhärente Ovarialzyste",
      "Einfache Ovarialzyste",
      "Gedrehte Ovarialzyste a.n.k.",
      "Hämorrhagische Ovarialzyste",
      "Mikrozystische Ovardegeneration",
      "Nichtentzündliche zystische Eileiterkrankheit",
      "Ovarialzyste",
      "Ovarialzyste durch mangelnde Involution des Ovars a.n.k.",
      "Ovarialzyste durch mangelnde Rückbildung des Ovars a.n.k.",
      "Ovarzyste a.n.k.",
      "Persistierende Ovarialzyste",
      "Retentionszyste des Ovars",
      "Rupturierte Ovarialzyste",
      "Seröse Ovarialzyste",
      "Thekalutein-Zyste",
      "Zyste des Corpus albicans",
      "Zystische Ovardegeneration",
      "Zystische Ovarkrankheit",
      "Zystovar"
    ]
  },
  {
    "code": "N83.3",
    "name": "Atrophie der Tuba uterina",
    "synonyms": [
      "Atrophie der Tuba uterina",
      "Eierstockatrophie",
      "Eileiteratrophie",
      "Ovaratrophie",
      "Senile Ovarialinvolution"
    ]
  },
  {
    "code": "N83.4",
    "name": "Ovariozele",
    "synonyms": [
      "Eierstockhernie",
      "Eierstockverlagerung",
      "Eierstockvorfall",
      "Eileiterhernie",
      "Eileitervorfall",
      "Erworbene Eileiterverlagerung",
      "Erworbene Ovarverlagerung",
      "Erworbene Verlagerung der Tuba uterina",
      "Hernie der Tuba uterina",
      "Hernie des Ovars",
      "Herniensack durch Ovarverlagerung",
      "Ovarialhernie",
      "Ovariozele",
      "Ovarprolaps",
      "Ovarvorfall",
      "Prolaps der Tuba uterina",
      "Salpingozele"
    ]
  },
  {
    "code": "N83.5",
    "name": "Torsion einer Morgagni-Hydatide bei der Frau",
    "synonyms": [
      "Adnexentorsion",
      "Beidseitige Torsion des Ovar",
      "Eierstockstieldrehung",
      "Eileitertorsion",
      "Eileitervolvulus",
      "Einseitige Torsion des Ovar",
      "Ovarialstielrotation",
      "Ovarialtorsion",
      "Ovarstieldrehung",
      "Torsion der Tuba uterina",
      "Torsion einer Morgagni-Hydatide bei der Frau",
      "Torsion einer akzessorischen Tube",
      "Volvulus der Tuba uterina"
    ]
  },
  {
    "code": "N83.6",
    "name": "Hämatosalpinx",
    "synonyms": [
      "Blutung der Tuba uterina",
      "Eileiterblutung",
      "Eileiterhämorrhagie",
      "Hämatosalpinx",
      "Hämorrhagie der Tuba uterina",
      "Hämosalpinx"
    ]
  },
  {
    "code": "N83.7",
    "name": "Hämatom des Ligamentum latum uteri",
    "synonyms": [
      "Hämatom des Ligamentum latum uteri",
      "Nichttraumatisches Hämatom der Mesosalpinx",
      "Nichttraumatisches Hämatom des Ligamentum latum uteri",
      "Nichttraumatisches Hämatom des Uterusbandes",
      "Nichttraumatisches Mutterbandhämatom"
    ]
  },
  {
    "code": "N83.8",
    "name": "Ovarialhämatozele",
    "synonyms": [
      "Divertikel der Tuba uterina",
      "Eileiterfibrose",
      "Eileiterruptur",
      "Eileiterzyste",
      "Erworbene Deformität der Tuba uterina",
      "Erworbene Eileiterdeformität",
      "Erworbene Ovarialdeformität",
      "Fibrose der Tuba uterina",
      "Gutartige Zyste des Ligamentum latum uteri",
      "Hämatozele des Eierstocks",
      "Induration des Ligamentum latum uteri",
      "Infarkt der Tuba uterina",
      "Masters-Allen-Syndrom",
      "Ovarhyperplasie",
      "Ovarhypertrophie",
      "Ovarialblutung",
      "Ovarialdegeneration",
      "Ovarialdystrophie",
      "Ovarialhämatozele",
      "Ovarialhämorrhagie",
      "Ovarialinfarkt",
      "Ovarialkalkherd",
      "Ovarialkalzifikation",
      "Ovarialsklerose",
      "Ovarialstrangulation",
      "Palpable Ovarien",
      "Paratubale Zyste",
      "Paratubarzyste",
      "Perforation des Ligamentum latum uteri",
      "Riss des Ligamentum latum uteri",
      "Ruptur der Tuba uterina",
      "Ruptur des Ovars",
      "Tuboovarialzyste",
      "Verhärtung des Ligamentum latum uteri",
      "Zyste der Tuba uterina"
    ]
  },
  {
    "code": "N83.9",
    "name": "Adnexverdickung",
    "synonyms": [
      "Adnexreizung",
      "Adnexschwellung",
      "Adnexverdickung",
      "Eileiterkrankheit",
      "Krankheit des Eierstocks",
      "Nichtentzündliche Eileiterkrankheit",
      "Nichtentzündliche Krankheit der Tuba uterina",
      "Nichtentzündliche Krankheit des Ligamentum latum uteri",
      "Nichtentzündliche Ovarkrankheit",
      "Nichtentzündliche Parametriumkrankheit",
      "Nichtentzündliche tuboovariale Krankheit"
    ]
  },
  {
    "code": "N84.0",
    "name": "Endometriumpolyp",
    "synonyms": [
      "Endometriumpolyp",
      "Polyp des Corpus uteri",
      "Uteruspolyp"
    ]
  },
  {
    "code": "N84.1",
    "name": "Polyp der Cervix uteri",
    "synonyms": [
      "Endozervikaler Polyp",
      "Muköser Polyp der Cervix uteri",
      "Muköser Zervixpolyp",
      "Polyp der Cervix uteri",
      "Polyp der Schleimhaut der Cervix uteri",
      "Portiopolyp",
      "Zervixpolyp",
      "Zervixschleimhautpolyp"
    ]
  },
  {
    "code": "N84.2",
    "name": "Vaginalpolyp",
    "synonyms": [
      "Scheidengranulationspolyp",
      "Scheidenpolyp",
      "Vaginalgranulationspolyp",
      "Vaginalpolyp",
      "Vaginalschleimhautpolyp",
      "Vaginalstumpfpolyp"
    ]
  },
  {
    "code": "N84.3",
    "name": "Vulvapolyp",
    "synonyms": [
      "Labienpolyp",
      "Polyp der Labia majora pudendi",
      "Polyp der Labia minora pudendi",
      "Polyp des Pudendum femininum",
      "Schamlippenpolyp",
      "Vulvapolyp"
    ]
  },
  {
    "code": "N84.8",
    "name": "Ovarialpolyp",
    "synonyms": [
      "Eileiterpolyp",
      "Ovarialpolyp",
      "Polyp der Tuba uterina"
    ]
  },
  {
    "code": "N84.9",
    "name": "Polyp der weiblichen Geschlechtsorgane",
    "synonyms": [
      "Polyp der weiblichen Genitalorgane",
      "Polyp der weiblichen Geschlechtsorgane"
    ]
  },
  {
    "code": "N85.0",
    "name": "Glanduläre Endometriumhyperplasie",
    "synonyms": [
      "Endometriumhyperplasie",
      "Glandulär-zystische Endometriumhyperplasie",
      "Glandulär-zystische Uterushyperplasie",
      "Glanduläre Endometriumhyperplasie",
      "Glanduläre Endometriumhypertrophie",
      "Hyperplastische Endometritis",
      "Polypoide Endometriumhyperplasie",
      "Zystische Endometriumhyperplasie"
    ]
  },
  {
    "code": "N85.1",
    "name": "Adenomatöse Endometriumhyperplasie",
    "synonyms": [
      "Adenomatöse Endometriumhyperplasie",
      "Adenomatöse Uterushyperplasie",
      "Atypische Endometriumhyperplasie",
      "Atypische Endometriumhypertrophie"
    ]
  },
  {
    "code": "N85.2",
    "name": "Uterusvergrößerung",
    "synonyms": [
      "Myohyperplasie des Uterus",
      "Myometriumhyperplasie",
      "Myometriumhypertrophie",
      "Uterushyperplasie",
      "Uterushypertrophie",
      "Uterusverdickung",
      "Uterusvergrößerung",
      "Verdickter Uterus",
      "Vergrößerter Uterus"
    ]
  },
  {
    "code": "N85.3",
    "name": "Uterussubinvolution",
    "synonyms": [
      "Uterussubinvolution"
    ]
  },
  {
    "code": "N85.4",
    "name": "Lageanomalie des Uterus",
    "synonyms": [
      "Antepositio uteri",
      "Anteversio uteri",
      "Dextroflexio uteri",
      "Dextropositio uteri",
      "Dextroversio uteri",
      "Elevatio uteri",
      "Gebärmutterknickung",
      "Lageanomalie des Uterus",
      "Lateroflexio uteri",
      "Lateropositio uteri",
      "Lateroversio uteri",
      "Postinfektiöse Lateroversion des Uterus",
      "Postpartale Lateroversion des Uterus",
      "Retroflexio uteri",
      "Retropositio uteri",
      "Retroversio uteri",
      "Sinistroflexio uteri",
      "Sinistropositio uteri",
      "Sinistroversio uteri",
      "Spitzwinklige Anteflexio uteri",
      "Uterusflexion",
      "Uterusknickung",
      "Uterusretraktion",
      "Uterustorsion",
      "Uterusverlagerung",
      "Verstärkte Anteversio uteri"
    ]
  },
  {
    "code": "N85.5",
    "name": "Inversio uteri",
    "synonyms": [
      "Chronische Inversio uteri",
      "Inversio uteri",
      "Uterusinversion"
    ]
  },
  {
    "code": "N85.6",
    "name": "Intrauterine Synechie",
    "synonyms": [
      "Asherman-Syndrom",
      "Endometriumsynechie",
      "Intrauterine Adhäsion",
      "Intrauterine Synechie",
      "Postinfektiöse innere Uterusadhäsion",
      "Synechie des Cavum uteri",
      "Uterusadhäsion",
      "Uterusstriktur",
      "Uterussynechie"
    ]
  },
  {
    "code": "N85.7",
    "name": "Hämatometra",
    "synonyms": [
      "Hämatometra",
      "Hämatosalpinx mit Hämatometra",
      "Intrauterine Blutung",
      "Intrauterine Hämorrhagie"
    ]
  },
  {
    "code": "N85.8",
    "name": "Benigne Uteruszyste",
    "synonyms": [
      "Alte Uteruslazeration",
      "Benigne Uteruszyste",
      "Endometrische Zyste",
      "Endometriumdysfunktion",
      "Endometriumhypoplasie",
      "Endometriumkalkherd",
      "Endometriumzyste",
      "Erosio follicularis uteri",
      "Erosio papillaris uteri",
      "Erosio simplex uteri",
      "Erosio vera uteri",
      "Erworbene Uterusatresie",
      "Erworbene Uterusatrophie",
      "Erworbene Uterusdeformität",
      "Hydrometra",
      "Involutio uteri",
      "Kleiner Uterus",
      "Laktationshyperinvolution des Uterus",
      "Myometriumatrophie",
      "Myometriumzyste",
      "Nichtpuerperale und nichttraumatische Uteruslazeration",
      "Nichtpuerperale und nichttraumatische Uterusruptur",
      "Rezidivierende Uteruszyste",
      "Rezidivierende Zyste des Corpus uteri",
      "Senile Endometriumatrophie",
      "Senile Myometriumatrophie",
      "Serometra",
      "Störung der parasympathischen Uterusinnervation",
      "Störung der sympathischen Uterusinnervation",
      "Superinvolutio uteri",
      "Uterusatrophie",
      "Uterusatrophie durch Bestrahlung (beabsichtigter Effekt)",
      "Uterusdegeneration",
      "Uterusdyskeratose a.n.k.",
      "Uteruserosion",
      "Uterusfibrose",
      "Uterusgeschwür",
      "Uterushyperämie",
      "Uterusinkarzeration",
      "Uterusinvolution",
      "Uteruskalkherd",
      "Uteruskalzifikation",
      "Uteruskontraktur",
      "Uterusleukoplakie",
      "Uterusnarbe",
      "Uterusobstruktion",
      "Uterusspasmus",
      "Uterusulkus",
      "Uterusverkalkung",
      "Uterusverschluss",
      "Uteruszyste",
      "Zystische Gebärmutterdegeneration"
    ]
  },
  {
    "code": "N85.9",
    "name": "Suspekter Endometriumbefund",
    "synonyms": [
      "Atypisches Endometrium",
      "Nichtentzündliche Uteruskrankheit",
      "Suspekter Endometriumbefund",
      "Uterusaffektion",
      "Uteruskrankheit",
      "Uterusschädigung a.n.k."
    ]
  },
  {
    "code": "N86",
    "name": "Gebärmutterhalsgeschwür",
    "synonyms": [
      "Atypische Portioektopieblutung",
      "Atypische Portioumwandlung",
      "Atypische Umwandlungszone Portio",
      "Atypisches Portiogefäß",
      "Chronische Portioektopie",
      "Chronische Portioerosion",
      "Chronische Portiotransformationszone",
      "Dekubitalgeschwür der Cervix uteri",
      "Ektropium der Cervix uteri",
      "Erosion der Cervix uteri",
      "Erosion der Portio uteri",
      "Erosion und Ektropium der Cervix uteri",
      "Eversion der Cervix uteri",
      "Gebärmutterhalsgeschwür",
      "Lazerationsektropium der Cervix uteri",
      "Portioektopie",
      "Portiotransformationszone",
      "Portioulkus",
      "Trophisches Dekubitalgeschwür der Zervix",
      "Ulkus der Cervix uteri",
      "Zervixerosion",
      "Zervixeversion",
      "Zervixulkus"
    ]
  },
  {
    "code": "N87.0",
    "name": "Niedriggradige Dysplasie der Cervix uteri",
    "synonyms": [
      "CIN [zervikale intraepitheliale Neoplasie] I. Grades",
      "LSIL [Niedriggradige squamöse intraepitheliale Läsion]",
      "Niedriggradige Dysplasie der Cervix uteri",
      "Niedriggradige squamöse intraepitheliale Läsion",
      "Zervikale intraepitheliale Neoplasie I. Grades"
    ]
  },
  {
    "code": "N87.1",
    "name": "Mittelgradige Dysplasie der Cervix uteri",
    "synonyms": [
      "CIN [zervikale intraepitheliale Neoplasie] II. Grades",
      "Mittelgradige Dysplasie der Cervix uteri",
      "Zervikale intraepitheliale Neoplasie II. Grades"
    ]
  },
  {
    "code": "N87.2",
    "name": "Hochgradige Dysplasie der Cervix uteri",
    "synonyms": [
      "Hochgradige Dysplasie der Cervix uteri",
      "Hochgradige zervikale Dysplasie"
    ]
  },
  {
    "code": "N87.9",
    "name": "Dysplasie der Cervix uteri",
    "synonyms": [
      "Anaplasie der Cervix uteri",
      "CIN [zervikale intraepitheliale Neoplasie]",
      "Dyskeratose der Cervix uteri",
      "Dysplasie der Cervix uteri",
      "Endometriumhyperplasie der Cervix uteri",
      "Epidermisation der Cervix uteri",
      "Epitheliale Dysplasie der Cervix uteri",
      "Epitheliale Zervixdysplasie",
      "Hyperkeratose der Cervix uteri",
      "Hyperplasie der Cervix uteri",
      "Intraepitheliale Neoplasie der Cervix uteri",
      "Jodnegativer Portiobezirk",
      "Plattenepitheldysplasie der Cervix uteri",
      "Portiodysplasie",
      "Verlagerung des Zylinderepithels der Cervix uteri",
      "Verlagerung des Zylinderepithels der Zervix",
      "Zervixdyskeratose",
      "Zervixdysplasie",
      "Zervixepidermisation",
      "Zervixepithelüberfunktion",
      "Zervixhyperkeratose",
      "Zervixhyperplasie",
      "Überfunktion der Basalzellen der Cervix uteri",
      "Überfunktion des Epithels der Cervix uteri"
    ]
  },
  {
    "code": "N88.0",
    "name": "Leukoplakie der Cervix uteri",
    "synonyms": [
      "Leukoplakie der Cervix uteri",
      "Leukoplakie der Portio uteri",
      "Zervixleukoplakie"
    ]
  },
  {
    "code": "N88.1",
    "name": "Alter Riss der Cervix uteri",
    "synonyms": [
      "Adhäsion der Cervix uteri",
      "Alte Lazeration der Cervix uteri",
      "Alte postpartale zervikovaginale Adhäsion",
      "Alter Gebärmutterhalsriss",
      "Alter Muttermundriss",
      "Alter Riss der Cervix uteri",
      "Alter Zervixriss",
      "Gewebestrang der Cervix uteri",
      "Narbe des Gebärmutterhalses",
      "Nichtpuerperale und nichttraumatische Lazeration der Cervix uteri",
      "Nichtpuerperaler und nichttraumatischer Riss der Cervix uteri",
      "Nichtpuerperaler und nichttraumatischer Zervixriss",
      "Postoperative Narbe der Cervix uteri",
      "Postoperative Zervixnarbe",
      "Postpartale Lazeration der Cervix uteri",
      "Postpartale Narbe der Cervix uteri",
      "Postpartale Zervixnarbe",
      "Zervikovaginale Adhäsion",
      "Zervixadhäsion"
    ]
  },
  {
    "code": "N88.2",
    "name": "Muttermundstriktur",
    "synonyms": [
      "Erworbene Atresie der Cervix uteri",
      "Erworbener Verschluss der Cervix uteri",
      "Gebärmutterhalsverengung",
      "Kontraktur der Cervix uteri",
      "Kontraktur des inneren Muttermundes",
      "Muttermundkontraktur",
      "Muttermundstriktur",
      "Stenose der Cervix uteri",
      "Stenose des Zervikalkanals",
      "Striktur der Cervix uteri",
      "Striktur des Os uteri",
      "Verschluss der Cervix uteri",
      "Zervikalkanalstriktur",
      "Zervixkanalverschluss",
      "Zervixkontraktur",
      "Zervixstenose",
      "Zervixstriktur",
      "Zervixverschluss"
    ]
  },
  {
    "code": "N88.3",
    "name": "Zervixinsuffizienz",
    "synonyms": [
      "Betreuung einer Nichtschwangeren bei Verdacht auf Insuffizienz der Cervix uteri",
      "Betreuung einer Nichtschwangeren bei Verdacht auf Zervixinsuffizienz",
      "Dilatation der Cervix uteri",
      "Insuffizienz der Cervix uteri",
      "Insuffizienz der Cervix uteri einer Nichtschwangeren",
      "Untersuchung einer Nichtschwangeren bei Verdacht auf Insuffizienz der Cervix uteri",
      "Untersuchung einer Nichtschwangeren bei Verdacht auf Zervixinsuffizienz",
      "Zervixdilatation",
      "Zervixerweiterung",
      "Zervixinsuffizienz",
      "Zervixinsuffizienz einer Nichtschwangeren",
      "Zervixöffnung des Uterus",
      "Öffnung der Cervix uteri"
    ]
  },
  {
    "code": "N88.4",
    "name": "Zervixhypertrophie mit Elongation",
    "synonyms": [
      "Elongatio cervici uteri",
      "Elongatio colli uteri",
      "Gebärmutterhalshypertrophie mit Elongation",
      "Hypertrophie der Cervix uteri mit Elongation",
      "Hypertrophische Verlängerung der Cervix uteri",
      "Hypertrophische Zervixverlängerung",
      "Konische Cervix uteri",
      "Konische Zervix",
      "Lippenbildung der Cervix uteri",
      "Zervixhypertrophie mit Elongation",
      "Zervixlippenbildung"
    ]
  },
  {
    "code": "N88.8",
    "name": "Lageveränderung der Cervix uteri",
    "synonyms": [
      "Anteversion der Cervix uteri",
      "Anteversion der Zervix",
      "Atrophie der Cervix uteri",
      "Atrophie des Myometriums der Cervix uteri",
      "Blutende Portio",
      "Blutung der Cervix uteri",
      "Blutung des Stumpfes der Cervix uteri a.n.k.",
      "Blutung des Zervixstumpfes a.n.k.",
      "Degeneration der Cervix uteri",
      "Degeneration der Cervix uteri durch Bestrahlung",
      "Erworbene Deformität der Cervix uteri a.n.k.",
      "Erworbene Teilung der Cervix uteri",
      "Erworbene Zervixdeformität a.n.k.",
      "Fibrose der Cervix uteri",
      "Hypertrophie der Cervix uteri",
      "Hämorrhagie der Cervix uteri a.n.k.",
      "Hämorrhagie der Zervix a.n.k.",
      "Hämorrhagie des Zervixstumpfes a.n.k.",
      "Inversion der Cervix uteri",
      "Kalzifikation der Cervix uteri",
      "Lageveränderung der Cervix uteri",
      "Naboth-Follikel",
      "Naboth-Zyste der Graaf-Follikel",
      "Ovula Nabothi",
      "Perforation der Cervix uteri",
      "Portioatrophie",
      "Portiofibrose",
      "Portiozyste",
      "Retraktion der Cervix uteri",
      "Retroversion der Cervix uteri",
      "Retroversion der Zervix",
      "Rupturierte Zyste der Naboth-Follikel",
      "Torsion der Cervix uteri",
      "Verlagerung der Cervix uteri",
      "Zervixatrophie",
      "Zervixatrophie des Uterus",
      "Zervixdegeneration",
      "Zervixfibrose",
      "Zervixhypertrophie",
      "Zervixinversion",
      "Zervixkalzifikation",
      "Zervixperforation",
      "Zervixretraktion",
      "Zervixtorsion",
      "Zervixverkalkung",
      "Zervixverlagerung",
      "Zervixzyste",
      "Zervixödem",
      "Zyste der Cervix uteri",
      "Ödem der Cervix uteri"
    ]
  },
  {
    "code": "N88.9",
    "name": "Nichtentzündliche Krankheit der Cervix uteri",
    "synonyms": [
      "Nichtentzündliche Krankheit der Cervix uteri",
      "Nichtentzündliche Zervixkrankheit"
    ]
  },
  {
    "code": "N89.0",
    "name": "Niedriggradige Dysplasie der Vagina",
    "synonyms": [
      "Intraepitheliale Vaginaneoplasie I. Grades",
      "Niedriggradige Dysplasie der Vagina",
      "VAIN [intraepitheliale Vaginaneoplasie] I. Grades"
    ]
  },
  {
    "code": "N89.1",
    "name": "Mittelgradige Dysplasie der Vagina",
    "synonyms": [
      "Intraepitheliale Vaginaneoplasie II. Grades",
      "Mittelgradige Dysplasie der Vagina",
      "VAIN [intraepitheliale Vaginaneoplasie] II. Grades"
    ]
  },
  {
    "code": "N89.2",
    "name": "Hochgradige Dysplasie der Vagina",
    "synonyms": [
      "Hochgradige Dysplasie der Vagina"
    ]
  },
  {
    "code": "N89.3",
    "name": "Vaginadysplasie",
    "synonyms": [
      "Hyperplasie des Vaginaepithels",
      "Intraepitheliale Vaginalneoplasie",
      "Scheidendysplasie",
      "VAIN [intraepitheliale Vaginaneoplasie]",
      "Vaginadysplasie"
    ]
  },
  {
    "code": "N89.4",
    "name": "Vaginalleukoplakie",
    "synonyms": [
      "Vaginalleukoplakie"
    ]
  },
  {
    "code": "N89.5",
    "name": "Vaginalstriktur",
    "synonyms": [
      "Erworbene Vaginalatresie",
      "Gewebestrang der Vagina",
      "Stenose des Fornix vaginae",
      "Vaginaladhäsion",
      "Vaginalkontraktur",
      "Vaginalobstruktion",
      "Vaginalstenose",
      "Vaginalstriktur",
      "Vaginalverschluss"
    ]
  },
  {
    "code": "N89.6",
    "name": "Fester Hymenalring",
    "synonyms": [
      "Enger Introitus vaginae",
      "Erworbene Hymenatresie",
      "Fester Hymenalring",
      "Hymenstenose",
      "Hymenstriktur",
      "Hymenverdickung",
      "Hymenverschluss",
      "Kleines Ostium vaginae",
      "Rigides Hymen",
      "Starrer Hymenalring",
      "Verengung des Introitus vaginae"
    ]
  },
  {
    "code": "N89.7",
    "name": "Hämatokolpos",
    "synonyms": [
      "Hämatokolpos",
      "Hämatokolpos mit Hämatometra",
      "Hämatokolpos mit Hämatosalpinx",
      "Kryptomenorrhoe"
    ]
  },
  {
    "code": "N89.8",
    "name": "Vaginales Druckulkus durch Ringpessar",
    "synonyms": [
      "Alte rektovaginale Lazeration",
      "Alte vaginale Lazeration",
      "Alter Scheidenriss",
      "Alter Vaginalriss",
      "Angeborener Hydrokolpos",
      "Caruncula vaginalis",
      "Chronischer Fluor",
      "Craurosis vaginae",
      "Einschlusszyste der Vagina",
      "Erosio vera der Scheide",
      "Erosio vera der Vagina",
      "Erosion des Vaginalepithels",
      "Erworbene Vaginadeformität",
      "Flatus vaginalis",
      "Fluor",
      "Fluor albus",
      "Fluor cervicalis",
      "Fluor genitalis",
      "Fluor vaginalis",
      "Garrulitas vulvae",
      "Hydrokolpos",
      "Hydrometrokolpos",
      "Hymenzyste",
      "Implantationszyste der Vagina",
      "Leukorrhoe",
      "Milchfluor",
      "Milchiger Fluor",
      "Narbenstrang der Vagina",
      "Nichtentzündlicher Vaginalausfluss",
      "Nichtpuerperale und nichttraumatische Vaginalazeration",
      "Nichttraumatische unbeabsichtigte Hymenruptur",
      "Nichttraumatisches Vaginalhämatom",
      "Retentionszyste der Vagina",
      "Scheidenstumpfgranulation",
      "Scheidenulkus durch Pessar",
      "Scheidenzyste",
      "Squamöse Vaginalzyste",
      "Therapieresistenter Vaginalfluor",
      "Trockene Scheide",
      "Trockene Vagina",
      "Uncharakteristischer vaginaler Ausfluss",
      "Vaginalausfluss",
      "Vaginales Druckulkus durch Ringpessar",
      "Vaginales Hämatom",
      "Vaginalfibrose",
      "Vaginalhypertrophie",
      "Vaginalkraurose",
      "Vaginalnarbe",
      "Vaginalnekrose",
      "Vaginalreizung",
      "Vaginalstumpfgranulation",
      "Vaginalulkus durch Pessar",
      "Vaginalzyste",
      "Vaginastein",
      "Weißfluss"
    ]
  },
  {
    "code": "N89.9",
    "name": "Gestörte Vaginalflora",
    "synonyms": [
      "Gestörte Scheidenflora",
      "Gestörte Vaginalflora",
      "Nichtentzündliche Vaginalkrankheit"
    ]
  },
  {
    "code": "N90.0",
    "name": "Niedriggradige Vulvadysplasie",
    "synonyms": [
      "Intraepitheliale Vulvaneoplasie I. Grades",
      "Niedriggradige Vulvadysplasie",
      "VIN [intraepitheliale Vulvaneoplasie] I. Grades"
    ]
  },
  {
    "code": "N90.1",
    "name": "Mittelgradige Vulvadysplasie",
    "synonyms": [
      "Intraepitheliale Vulvaneoplasie II. Grades",
      "Mittelgradige Vulvadysplasie",
      "VIN [intraepitheliale Vulvaneoplasie] II. Grades"
    ]
  },
  {
    "code": "N90.2",
    "name": "Hochgradige Vulvadysplasie",
    "synonyms": [
      "Hochgradige Vulvadysplasie"
    ]
  },
  {
    "code": "N90.3",
    "name": "Intraepitheliale Vulvaläsion",
    "synonyms": [
      "Hyperplasie des Labienepithels",
      "Hyperplasie des Vulvaepithels",
      "Intraepitheliale Vulvaläsion",
      "Intraepitheliale Vulvaneoplasie",
      "VIN [intraepitheliale Vulvaneoplasie]",
      "Vulvadysplasie"
    ]
  },
  {
    "code": "N90.4",
    "name": "Craurosis vulvae et vaginae",
    "synonyms": [
      "Craurosis vulvae",
      "Craurosis vulvae et vaginae",
      "Hyperkeratosis vulvae",
      "Leukokraurosis vulvae",
      "Lichen albus der Vulva",
      "Lichen atrophicus der Vulva",
      "Lichen sclerosus der Vulva",
      "Lichen sclerosus et atrophicus der Vulva",
      "Vulvadystrophie",
      "Vulvaleukoplakie",
      "Vulvitis bei Leukoplakie",
      "Weißfleckenkrankheit der Vulva"
    ]
  },
  {
    "code": "N90.5",
    "name": "Vulvaatrophie",
    "synonyms": [
      "Erworbene Vulvaatresie",
      "Erworbene Vulvastriktur",
      "Vulvaatrophie",
      "Vulvastenose",
      "Vulvaverschluss"
    ]
  },
  {
    "code": "N90.6",
    "name": "Vulvahypertrophie",
    "synonyms": [
      "Erworbene Verlängerung der Labia minora pudendi",
      "Hypertrophie der Labia majora pudendi",
      "Hypertrophie der Labia minora pudendi",
      "Hypertrophische Stasis der Vulva",
      "Labienhyperplasie",
      "Labienhypertrophie",
      "Schamlippenhypertrophie",
      "Vulvahyperplasie",
      "Vulvahypertrophie"
    ]
  },
  {
    "code": "N90.7",
    "name": "Vulvazyste",
    "synonyms": [
      "Einschlusszyste der Vulva",
      "Implantationszyste der Vulva",
      "Klitoriszyste",
      "Talgdrüsenzyste der Labia majora pudendi",
      "Talgdrüsenzyste der Labia minora pudendi",
      "Vulvaretentionszyste",
      "Vulvatalgretentionszyste",
      "Vulvazyste",
      "Zyste der Labia majora pudendi",
      "Zyste der Labia minora pudendi",
      "Zyste der Vulvovaginaldrüsen",
      "Zyste der äußeren weiblichen Geschlechtsorgane a.n.k."
    ]
  },
  {
    "code": "N90.8",
    "name": "Alte Vulvalazeration",
    "synonyms": [
      "Akutes Vulvaödem",
      "Alte Vulvalazeration",
      "Alte Vulvanarbe",
      "Alte postpartale Adhäsion der Vulva",
      "Alter Vulvariss",
      "Craurosis vulvae et ani",
      "Erworbene Deformität der Labia majora pudendi",
      "Erworbene Deformität der Labia minora pudendi",
      "Erworbene Klitorisdeformität",
      "Erworbene Vulvadeformität",
      "Klitorisadhäsion",
      "Klitorishypertrophie",
      "Labienhämatom",
      "Labienschwellung",
      "Labienödem",
      "Narbe der Labia majora pudendi",
      "Narbe der Labia minora pudendi",
      "Nichtgeburtshilfliche Perineumruptur",
      "Nichtgeburtshilfliches Hämatom der Labia majora pudendi",
      "Nichtgeburtshilfliches Hämatom der Labia minora pudendi",
      "Nichtgeburtshilfliches Vulvahämatom",
      "Nichtpuerperale und nichttraumatische Vulvalazeration",
      "Nichttraumatische Perineumruptur",
      "Nichttraumatisches Vulvahämatom",
      "Sklerose des Corpus cavernosum bei der Frau",
      "Smegmaretention der Klitoris",
      "Vitiligo der Vulva",
      "Vulvaadhäsion",
      "Vulvablutung",
      "Vulvaelephantiasis",
      "Vulvahydrozele",
      "Vulvahämatom",
      "Vulvahämorrhagie",
      "Vulvanarbe",
      "Vulvarhagade",
      "Vulvaödem",
      "Zirrhotische Klitorishypertrophie"
    ]
  },
  {
    "code": "N90.9",
    "name": "Nichtentzündliche Vulvaerkrankung",
    "synonyms": [
      "Nichtentzündliche Perineumerkrankung",
      "Nichtentzündliche Vulvaerkrankung",
      "Nichtentzündliche Vulvakrankheit"
    ]
  },
  {
    "code": "N91.0",
    "name": "Primäre Amenorrhoe",
    "synonyms": [
      "Atretische Amenorrhoe",
      "Nichteintreten der Menarche im Pubertätsalter",
      "Primäre Amenorrhoe",
      "Verzögerter Eintritt der Menarche"
    ]
  },
  {
    "code": "N91.1",
    "name": "Sekundäre Amenorrhoe",
    "synonyms": [
      "After-pill-Amenorrhoe",
      "Amenorrhoe bei Ovulationshemmereinnahme",
      "Funktionelle Amenorrhoe",
      "Hormonelle Amenorrhoe",
      "Hypogonadotrope Amenorrhoe",
      "Hypothalamische Amenorrhoe",
      "Notstandsamenorrhoe",
      "Post-Pill-Amenorrhoe",
      "Postpartale Amenorrhoe",
      "Pseudoamenorrhoe",
      "Psychogene Amenorrhoe",
      "Sekundäre Amenorrhoe",
      "Stressamenorrhoe",
      "Traumatische Amenorrhoe",
      "Zentrale Amenorrhoe"
    ]
  },
  {
    "code": "N91.2",
    "name": "Amenorrhoe",
    "synonyms": [
      "Amenorrhoe",
      "Ausbleiben der Menstruation",
      "Ausgebliebene Menstruation",
      "Fehlen der Menstruation",
      "Verhaltene Menstruation"
    ]
  },
  {
    "code": "N91.3",
    "name": "Primäre Oligomenorrhoe",
    "synonyms": [
      "Primäre Hypomenorrhoe",
      "Primäre Oligomenorrhoe"
    ]
  },
  {
    "code": "N91.4",
    "name": "Sekundäre Oligomenorrhoe",
    "synonyms": [
      "Sekundäre Hypomenorrhoe",
      "Sekundäre Oligomenorrhoe",
      "Unregelmäßige Oligomenorrhoe"
    ]
  },
  {
    "code": "N91.5",
    "name": "Oligomenorrhoe",
    "synonyms": [
      "Brachymenorrhoe",
      "Hypomenorrhoe",
      "Oligomenorrhoe",
      "Schwache Menstruation",
      "Seltene Menstruation",
      "Verminderte Menstruation"
    ]
  },
  {
    "code": "N92.0",
    "name": "Epimenorrhoe",
    "synonyms": [
      "Epimenorrhoe",
      "Hypermenorrhoe",
      "Häufige Menstruation",
      "Menorrhagie",
      "Polymenorrhoe",
      "Primäre Menorrhagie",
      "Starke Menstruation",
      "Zu starke Menstruation bei regelmäßigem Menstruationszyklus",
      "Übermäßig starke Menstruation bei regelmäßigem Menstruationszyklus"
    ]
  },
  {
    "code": "N92.1",
    "name": "Menometrorrhagie",
    "synonyms": [
      "Chronische Metrorrhagie",
      "Chronische unregelmäßige Zwischenblutung",
      "Menometrorrhagie",
      "Metrorrhagie",
      "Unregelmäßige Zwischenblutung",
      "Unregelmäßige intermenstruelle Blutung",
      "Unregelmäßige intermenstruelle Hämorrhagie",
      "Unregelmäßige intermenstruelle Uterusblutung",
      "Unregelmäßige intermenstruelle Uterushämorrhagie",
      "Unregelmäßige verkürzte Intervalle zwischen den Menstruationsblutungen",
      "Zwischenblutung",
      "Übermäßig starke Menstruation bei unregelmäßigem Menstruationszyklus"
    ]
  },
  {
    "code": "N92.2",
    "name": "Zu starke Menstruation im Pubertätsalter",
    "synonyms": [
      "Juvenile Menorrhagie",
      "Pubertätsblutung",
      "Pubertätsblutung des Uterus",
      "Pubertätshämorrhagie des Uterus",
      "Pubertätsmenorrhagie",
      "Zu häufige Menstruation im Pubertätsalter",
      "Zu starke Menstruation im Pubertätsalter",
      "Übermäßig starke Menstruation im Pubertätsalter",
      "Übermäßige Pubertätsblutung"
    ]
  },
  {
    "code": "N92.3",
    "name": "Ovulationsblutung",
    "synonyms": [
      "Intermenstruelle Schmierblutung a.n.k.",
      "Intermenstruelle Uterusblutung",
      "Intermenstruelle Uterushämorrhagie",
      "Mittelblutung",
      "Ovulationsblutung",
      "Ovulationshämorrhagie",
      "Regelmäßige intermenstruelle Blutung",
      "Regelmäßige intermenstruelle Hämorrhagie",
      "Regelmäßige intermenstruelle Schmierblutung"
    ]
  },
  {
    "code": "N92.4",
    "name": "Zu starke Blutung in der Prämenopause",
    "synonyms": [
      "Abnorme Prämenopausenblutung",
      "Abnorme klimakterische Blutung",
      "Abnorme klimakterische Uterusblutung",
      "Abnorme klimakterische Uterushämorrhagie",
      "Abnorme präklimakterische Uterusblutung",
      "Abnorme präklimakterische Uterushämorrhagie",
      "Abnorme prämenopausale Uterusblutung",
      "Abnorme prämenopausale Uterushämorrhagie",
      "Klimakterische Blutungsstörung",
      "Klimakterische Menorrhagie",
      "Klimakterische Metrorrhagie",
      "Menopausale Menorrhagie",
      "Menopausale Metrorrhagie",
      "Menopausenmenorrhagie",
      "Menopausenmetrorrhagie",
      "Menorrhagie in der Prämenopause",
      "Metrorrhagie in der Prämenopause",
      "Präklimakterische Blutungsstörung",
      "Präklimakterische Hypermenorrhoe",
      "Präklimakterische Menorrhagie",
      "Präklimakterische Metrorrhagie",
      "Prämenopausale Menorrhagie",
      "Prämenopausale Metrorrhagie",
      "Zu starke Blutung in der Prämenopause"
    ]
  },
  {
    "code": "N92.5",
    "name": "Verzögerte Menstruation",
    "synonyms": [
      "Latente Menstruation",
      "Membranöse Menstruation",
      "Protrahierte Menstruation",
      "Retrograde Menstruation",
      "Verzögerte Menstruation"
    ]
  },
  {
    "code": "N92.6",
    "name": "Zyklusstörung",
    "synonyms": [
      "Abnorme Zyklusblutung",
      "Anomale Menstruation",
      "Anomaler Menstruationszyklus",
      "Azyklische Blutung",
      "Azyklische Menstruation",
      "Blutungsstörung",
      "Chronische Zyklusanomalie",
      "Irreguläre Blutung",
      "Irreguläre Menstruation",
      "Irreguläre Periode",
      "Menstruationsstörung",
      "Periodenstörung",
      "Regelblutungsstörung",
      "Regelstörung",
      "Regeltempostörung",
      "Unregelmäßige Menstruation",
      "Unregelmäßige Menstruationsblutung",
      "Unregelmäßiger Menstruationszyklus",
      "Zyklusanomalie",
      "Zyklusstörung"
    ]
  },
  {
    "code": "N93.0",
    "name": "Kohabitationsblutung",
    "synonyms": [
      "Kohabitationsblutung",
      "Kontakthämorrhagie nach Geschlechtsverkehr",
      "Postkoitale Blutung",
      "Postkoitale Hämorrhagie",
      "Postkoitale Kontaktblutung",
      "Postkoitale Vaginalblutung"
    ]
  },
  {
    "code": "N93.8",
    "name": "Prämenstruelle Schmierblutung",
    "synonyms": [
      "Durchbruchblutung",
      "Dysfunktionelle Uterusblutung",
      "Dysfunktionelle Uterushämorrhagie",
      "Dysfunktionelle Vaginalblutung",
      "Dysfunktionelle Vaginalhämorrhagie",
      "Dysfunktionelle gynäkologische Blutung",
      "Dysfunktionelle uterine Blutung",
      "Dysfunktionelle vaginale Blutung",
      "Funktionelle Gebärmutterblutung",
      "Funktionelle Uterusblutung",
      "Funktionelle Uterushämorrhagie",
      "Funktionelle Vaginalblutung",
      "Funktionelle Vaginalhämorrhagie",
      "Hämorrhagische Metropathie",
      "Metropathia haemorrhagica",
      "Metropathie",
      "Postmenstruelle Blutung",
      "Prämenstruelle Blutung",
      "Prämenstruelle Schmierblutung",
      "Präpubertätsblutung des Uterus",
      "Präpubertätshämorrhagie des Uterus",
      "Spotting"
    ]
  },
  {
    "code": "N93.9",
    "name": "Gynäkologische Blutungsstörung",
    "synonyms": [
      "Abnorme Blutung aus den weiblichen Genitalorganen",
      "Abnorme Uterusblutung",
      "Abnorme Uterushämorrhagie",
      "Abnorme Vaginablutung",
      "Abnorme Vaginalhämorrhagie",
      "Abnorme genitale Blutung",
      "Akute Vaginalblutung",
      "Blutung der weiblichen Genitalien",
      "Dauerblutung",
      "Dauerschmierblutung",
      "Gebärmutterblutung",
      "Gynäkologische Blutung",
      "Gynäkologische Blutungsstörung",
      "Scheidenblutung",
      "Schmierblutung",
      "Uterusblutung a.n.k.",
      "Uterusblutung unabhängig vom Menstruationszyklus a.n.k.",
      "Uterushämorrhagie unabhängig vom Menstruationszyklus",
      "Vaginalblutung"
    ]
  },
  {
    "code": "N94.0",
    "name": "Intermenstrualschmerzen",
    "synonyms": [
      "Intermenstrualschmerzen",
      "Mittelschmerzen",
      "Ovulationsschmerzen"
    ]
  },
  {
    "code": "N94.1",
    "name": "Weibliche Algopareunie",
    "synonyms": [
      "Chronische Dyspareunie",
      "Dyspareunie",
      "Koitalgie",
      "Schmerzhafter Koitus",
      "Schmerzhafter Koitus bei der Frau",
      "Schmerzhafter weiblicher Koitus",
      "Sekundäre Dyspareunie",
      "Weibliche Algopareunie",
      "Weibliche Dyspareunie"
    ]
  },
  {
    "code": "N94.2",
    "name": "Vaginismus",
    "synonyms": [
      "Chronischer Vaginismus",
      "Reflektorischer Vaginismus",
      "Sekundärer Vaginismus",
      "Vaginalspasmus",
      "Vaginismus"
    ]
  },
  {
    "code": "N94.3",
    "name": "Prämenstruelle Beschwerden",
    "synonyms": [
      "Menstruationsmigräne",
      "Menstruelle Migräne",
      "Prämenstruelle Beschwerden",
      "Prämenstruelle Schmerzen",
      "Prämenstruelle Spannungserscheinungen",
      "Prämenstruelle neurovegetative Störung",
      "Prämenstruelle psychische Störung",
      "Prämenstruelles Spannungssyndrom",
      "Prämenstruelles Syndrom",
      "Prämenstruelles Ödem",
      "Zyklische Migräne"
    ]
  },
  {
    "code": "N94.4",
    "name": "Primäre Dysmenorrhoe",
    "synonyms": [
      "Primär schmerzhafte Menstruation",
      "Primäre Dysmenorrhoe"
    ]
  },
  {
    "code": "N94.5",
    "name": "Sekundäre Dysmenorrhoe",
    "synonyms": [
      "Sekundär schmerzhafte Menstruation",
      "Sekundäre Dysmenorrhoe"
    ]
  },
  {
    "code": "N94.6",
    "name": "Dysmenorrhoe",
    "synonyms": [
      "Algomenorrhoe",
      "Dermatitis dysmenorrhoica symmetrica",
      "Dysmenalgie",
      "Dysmenorrhoe",
      "Dysmenorrhoea membranacea",
      "Erworbene Dysmenorrhoe",
      "Essentielle Dysmenorrhoe",
      "Exfoliative Dysmenorrhoe",
      "Fibrinorrhoea plastica",
      "Intermenstruelle Dysmenorrhoe",
      "Kongestive Dysmenorrhoe",
      "Menstruationsbedingter Uteruskrampf",
      "Menstruationsschmerzen",
      "Molimina menstrualia",
      "Periodenschmerzen",
      "Regelschmerzen",
      "Schmerzhafte Regel",
      "Statische Dysmenorrhoe",
      "Uteruskolik bei Menstruation"
    ]
  },
  {
    "code": "N94.8",
    "name": "Adnexalgie",
    "synonyms": [
      "Adnexalgie",
      "Anteuterine Hämatozele",
      "Follikelpersistenz",
      "Frozen pelvis bei der Frau",
      "Hydrocele feminae",
      "Hydrozele des Ligamentum latum uteri",
      "Hydrozele des Nuck-Kanals",
      "Hyperplasie der weiblichen Geschlechtsorgane",
      "Hämatom der weiblichen Geschlechtsorgane",
      "Hämatozele bei der Frau",
      "Hämatozele des Ligamentum latum uteri",
      "Hämatozele des Ligamentum teres uteri",
      "Intrapelvine Blutung bei der Frau",
      "Intrapelvine Hämorrhagie bei der Frau",
      "Keratose der weiblichen Genitalorgane",
      "Krankheit des Peritoneums des weiblichen Beckens a.n.k.",
      "Mensesretention",
      "Menstruationszyklus-abhängiges periodisches Fieber",
      "Ovarialschmerzen",
      "Parametropathia",
      "Parametropathie",
      "Pelvic-congestion-Syndrom",
      "Perinealer Spasmus bei der Frau",
      "Retrouterine Hämatozele",
      "Schmerzen der weiblichen Genitalien",
      "Silent menstruation",
      "Störung der späten Lutealphase",
      "Talgdrüsenzyste der weiblichen Geschlechtsorgane",
      "Thrombose der weiblichen Genitalorgane",
      "Uteruskolik",
      "Uteruskrampf",
      "Uterusschmerzen",
      "Vikariierende Blutung",
      "Vikariierende Hämorrhagie",
      "Vikariierende Menstruation",
      "Zyste des Nuck-Kanals",
      "Zyste des Processus vaginalis peritonei",
      "Zyste des weiblichen Beckens"
    ]
  },
  {
    "code": "N94.9",
    "name": "Frauenleiden",
    "synonyms": [
      "Beschwerden im weiblichen Unterleib",
      "Frauenleiden",
      "Gynäkologische Erkrankung",
      "Gynäkologische Krankheit",
      "Krankheit der weiblichen Beckenorgane",
      "Krankheit des weiblichen Beckens a.n.k.",
      "Menstruationsbeschwerden",
      "Menstruelle Anomalie",
      "Problem der weiblichen Geschlechtsorgane",
      "Störung des Urogenitalsystems bei der Frau"
    ]
  },
  {
    "code": "N95.0",
    "name": "Abnorme Blutung in der Menopause",
    "synonyms": [
      "Abnorme Blutung in der Menopause",
      "Abnorme menopausale Uterusblutung",
      "Abnorme menopausale Uterushämorrhagie",
      "Klimakterische Zykluslabilität",
      "Postklimakterische Blutung",
      "Postklimakterische Blutungsstörung",
      "Postklimakterische Hämorrhagie",
      "Postklimakterische Menorrhagie",
      "Postklimakterische Uterusblutung",
      "Postklimakterische Uterushämorrhagie",
      "Postmenopausale Blutung",
      "Postmenopausale Blutungsstörung",
      "Postmenopausale Hämorrhagie",
      "Postmenopausale Menorrhagie",
      "Postmenopausenblutung"
    ]
  },
  {
    "code": "N95.1",
    "name": "Klimakterische Wallungen",
    "synonyms": [
      "Aufsteigende Hitze",
      "Climacterium tardum",
      "Fliegende Hitze",
      "Hitzewallungen",
      "Hitzewallungen in der Menopause",
      "Klimakterische Ausfallerscheinungen",
      "Klimakterische Hitzewellen",
      "Klimakterische Konzentrationsstörung",
      "Klimakterische Kopfschmerzen",
      "Klimakterische Krankheit bei der Frau",
      "Klimakterische Krise",
      "Klimakterische Neurose",
      "Klimakterische Psychoneurose",
      "Klimakterische Schlaflosigkeit",
      "Klimakterische Symptome bei der Frau",
      "Klimakterische Wallungen",
      "Klimakterische Zustände",
      "Klimakterium",
      "Konzentrationsschwäche in der Menopause",
      "Kopfschmerzen in der Menopause",
      "Menopausale Krise",
      "Menopause",
      "Menopausenmigräne",
      "Menopausenneurose",
      "Menopausensymptome",
      "Menopausensyndrom",
      "Migräne durch Menopause",
      "Schlaflosigkeit in der Menopause",
      "Vertigo in der Menopause",
      "Wallungen",
      "Wechseljahre - s.a. Klimakterium"
    ]
  },
  {
    "code": "N95.2",
    "name": "Atrophie bei Kolpitis",
    "synonyms": [
      "Atrophie bei Kolpitis",
      "Atrophische Kolpitis",
      "Atrophische Vaginitis",
      "Atrophische Vulvovaginitis",
      "Atrophische postklimakterische Kolpitis",
      "Atrophische postklimakterische Vaginitis",
      "Atrophische senile Vaginitis",
      "Kolpitis durch Hormonmangel",
      "Kolpitis durch Östrogenmangel",
      "Scheidenatrophie",
      "Senile Kolpitis",
      "Senile Kolpitis mit Vulvitis",
      "Senile Vaginalatrophie",
      "Senile Vaginitis",
      "Vaginalatrophie",
      "Vaginalinvolution",
      "Vulvitis durch Östrogenmangel"
    ]
  },
  {
    "code": "N95.3",
    "name": "Artifizielles Klimakterium",
    "synonyms": [
      "Artifizielle Menopause",
      "Artifizielles Klimakterium",
      "Blutung in der artifiziellen Menopause",
      "Chirurgisch bedingte Menopause",
      "Künstliche Menopause",
      "Postartifizielles Menopausensyndrom"
    ]
  },
  {
    "code": "N95.8",
    "name": "Altersatrophische Genitalien",
    "synonyms": [
      "Altersatrophische Genitalien",
      "Atrophie der Cervix uteri in der Menopause",
      "Atrophisches Postmenopausenendometrium",
      "Atrophisches klimakterisches Endometrium",
      "Genitalatrophie",
      "Perimenopause",
      "Postmenopausenendometrium"
    ]
  },
  {
    "code": "N95.9",
    "name": "Klimakterische Störung",
    "synonyms": [
      "Chronisches Postmenopausensyndrom",
      "Klimakterische Beschwerden",
      "Klimakterische Dysfunktion",
      "Klimakterische Störung",
      "Klimakterisches Hormonmangelsyndrom",
      "Klimakterisches Syndrom",
      "Klimaxbeschwerden",
      "Menopausale Störung",
      "Menopausenstörung",
      "Postklimakterische Beschwerden",
      "Postklimakterische Störung",
      "Postmenopause",
      "Postmenopausenkonflikt",
      "Postmenopausensyndrom",
      "Präklimakterium",
      "Psychovegetative Störung in der Menopause",
      "Wechseljahrsbeschwerden"
    ]
  },
  {
    "code": "N96",
    "name": "Neigung zu habituellem Abort",
    "synonyms": [
      "Betreuung einer Nichtschwangeren bei Neigung zu habituellem Abort",
      "Neigung zu habituellem Abort",
      "Untersuchung einer Nichtschwangeren bei Neigung zu habituellem Abort",
      "Weibliche Infertilität"
    ]
  },
  {
    "code": "N97.0",
    "name": "Anovulation",
    "synonyms": [
      "Anovulation",
      "Anovulatorische Sterilität",
      "Anovulatorischer Zyklus",
      "Ausbleiben der Ovulation",
      "Fehlende Ovulation",
      "Infertilität bei fehlender Ovulation",
      "Monophasischer Zyklus",
      "Nichtovulation",
      "Sterilität endokrinen Ursprungs bei der Frau ohne Ovulation",
      "Versagen der Ovulation mit Sterilität",
      "Versagen der Ovulation mit Unfruchtbarkeit"
    ]
  },
  {
    "code": "N97.1",
    "name": "Tubenstenose",
    "synonyms": [
      "Bilaterale Obstruktion der Tuba uterina",
      "Eileiterblockade",
      "Eileiterverschluss",
      "Erworbene Atresie der Tuba uterina",
      "Erworbene Eileiteratresie",
      "Infertilität bei Anomalie der Tuba uterina",
      "Infertilität bei Krankheit der Tuba uterina",
      "Nichtdurchlässiger Eileiter",
      "Obliteration der Tuba uterina",
      "Obstruktion der Tuba uterina",
      "Primäre tubare Sterilität",
      "Sekundäre tubare Sterilität",
      "Spasmus der Tuba uterina",
      "Stenose der Tuba uterina",
      "Striktur der Tuba uterina",
      "Tubare Sterilität",
      "Tubare Sterilität bei angeborener Anomalie der Tuba uterina",
      "Tubenspasmus",
      "Tubenstenose",
      "Tubenundurchgängigkeit",
      "Tubenverschluss",
      "Undurchgängiger Eileiter",
      "Verschluss der Tuba uterina",
      "Weibliche Unfruchtbarkeit durch peritubare Adhäsion"
    ]
  },
  {
    "code": "N97.2",
    "name": "Sterilität uterinen Ursprungs",
    "synonyms": [
      "Infertilität bei Uterusaffektion",
      "Infertilität bei Uterusanomalie",
      "Infertilität bei Uteruskrankheit",
      "Infertilität bei der Frau durch Nichtimplantation der Eizelle",
      "Nichtimplantation der Eizelle",
      "Nichtimplantation des befruchteten Eies",
      "Sterilität uterinen Ursprungs",
      "Tubare Sterilität bei angeborener Uterusanomalie",
      "Uterine Sterilität",
      "Weibliche Unfruchtbarkeit durch Nidationsstörung",
      "Weibliche Unfruchtbarkeit durch tuberkulöse Endometritis"
    ]
  },
  {
    "code": "N97.3",
    "name": "Sterilität zervikalen Ursprungs",
    "synonyms": [
      "Sterilität zervikalen Ursprungs",
      "Weibliche Infertilität bei Affektion der Cervix uteri",
      "Weibliche Infertilität bei Anomalie der Cervix uteri",
      "Weibliche Infertilität bei Krankheit der Cervix uteri",
      "Weibliche Infertilität bei Vaginalaffektion",
      "Weibliche Infertilität bei Zervixaffektion",
      "Weibliche Infertilität bei Zervixanomalie",
      "Weibliche Infertilität bei Zervixkrankheit",
      "Zervikale Sterilität"
    ]
  },
  {
    "code": "N97.4",
    "name": "Sterilität bei der Frau im Zusammenhang mit Partner-Faktoren",
    "synonyms": [
      "Infertilität bei der Frau im Zusammenhang mit Partner-Faktoren",
      "Sterilität bei der Frau im Zusammenhang mit Partner-Faktoren"
    ]
  },
  {
    "code": "N97.8",
    "name": "Immunologisch bedingte Sterilität bei der Frau",
    "synonyms": [
      "Immunologisch bedingte Sterilität bei der Frau",
      "Psychogene Sterilität bei der Frau",
      "Sterilität endokrinen Ursprungs bei der Frau mit Ovulation",
      "Weibliche Infertilität bei Vaginaanomalie",
      "Weibliche Infertilität bei Vaginakrankheit",
      "Weibliche Infertilität durch Zona pellucida-Defekt"
    ]
  },
  {
    "code": "N97.9",
    "name": "Sterilität bei der Frau",
    "synonyms": [
      "Fertilitätsstörung bei der Frau",
      "Fertilitätsverlust bei der Frau",
      "Gestörte Fertilität bei der Frau",
      "Nichteintreten einer Schwangerschaft",
      "Primäre weibliche Sterilität",
      "Sekundäre weibliche Sterilität",
      "Sterilität bei der Frau",
      "Sterilitätskonflikt bei der Frau",
      "Weibliche Sterilität",
      "Weibliche Unfruchtbarkeit"
    ]
  },
  {
    "code": "N98.0",
    "name": "Infektion bei artifizieller Insemination",
    "synonyms": [
      "Infektion bei artifizieller Insemination",
      "Infektion bei künstlicher Befruchtung"
    ]
  },
  {
    "code": "N98.1",
    "name": "Überstimulationssyndrom des Ovars",
    "synonyms": [
      "Hyperstimulation des Ovars",
      "Hyperstimulation des Ovars bei artifizieller Insemination",
      "Hyperstimulation des Ovars bei induzierter Ovulation",
      "Hyperstimulation des Ovars bei künstlicher Befruchtung",
      "Ovarialhyperstimulation",
      "Ovarialüberstimulation",
      "Überstimulationssyndrom des Ovars"
    ]
  },
  {
    "code": "N98.2",
    "name": "Komplikation nach In-vitro-Fertilisation",
    "synonyms": [
      "Komplikation bei versuchter Einführung eines befruchteten Eies nach In-vitro-Fertilisation",
      "Komplikation nach In-vitro-Fertilisation"
    ]
  },
  {
    "code": "N98.3",
    "name": "Komplikation nach Embryotransfer",
    "synonyms": [
      "Komplikation bei versuchter Implantation eines Embryos bei Embryotransfer",
      "Komplikation nach Embryotransfer"
    ]
  },
  {
    "code": "N98.8",
    "name": "Komplikationen bei artifizieller Insemination durch Fremdsamen",
    "synonyms": [
      "Komplikation bei artifizieller Insemination durch Samen des Ehemannes",
      "Komplikation bei artifizieller Insemination durch Samen des Partners",
      "Komplikationen bei artifizieller Insemination durch Fremdsamen"
    ]
  },
  {
    "code": "N98.9",
    "name": "Komplikation nach Insemination",
    "synonyms": [
      "Komplikation durch künstliche Befruchtung",
      "Komplikation nach Insemination"
    ]
  },
  {
    "code": "N99.0",
    "name": "Nierenversagen nach medizinischen Maßnahmen",
    "synonyms": [
      "Anurie nach medizinischen Maßnahmen",
      "Nierenblockade nach Blasenspiegelung",
      "Nierenblockade nach medizinischen Maßnahmen",
      "Niereninsuffizienz nach medizinischen Maßnahmen",
      "Nierenversagen nach Chemotherapie",
      "Nierenversagen nach Kontrastmittelgabe",
      "Nierenversagen nach medizinischen Maßnahmen",
      "Oligurie nach medizinischen Maßnahmen",
      "Renale Insuffizienz nach medizinischen Maßnahmen",
      "Tubuläre Nekrose nach medizinischen Maßnahmen",
      "Tubuläre Nephrose nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "N99.10",
    "name": "Harnröhrenstriktur-Rezidiv nach vorangegangener Operation einer Harnröhrenstriktur",
    "synonyms": [
      "Harnröhrenstriktur-Rezidiv nach vorangegangener Operation einer Harnröhrenstriktur"
    ]
  },
  {
    "code": "N99.18",
    "name": "Postoperative Harnröhrenstriktur",
    "synonyms": [
      "Harnröhrenstriktur durch Katheter",
      "Harnröhrenstriktur nach Katheterisierung",
      "Harnröhrenstriktur nach Kondylomabtragung",
      "Harnröhrenstriktur nach Strahlentherapie",
      "Harnröhrenstriktur nach Zirkumzision",
      "Harnröhrenstriktur nach transurethraler Operation",
      "Postoperative Harnröhrenstenose",
      "Postoperative Harnröhrenstriktur",
      "Postoperative Urethrastenose",
      "Postoperative Urethrastriktur",
      "Urethrastriktur durch Katheter",
      "Urethrastriktur nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "N99.2",
    "name": "Postoperative Vaginaadhäsion",
    "synonyms": [
      "Postoperative Vaginaadhäsion",
      "Postoperative Vaginanarbe"
    ]
  },
  {
    "code": "N99.3",
    "name": "Postoperativer Vorfall von Scheidengewebe",
    "synonyms": [
      "Postoperativer Prolaps von Scheidengewebe",
      "Postoperativer Prolaps von Vaginalgewebe",
      "Postoperativer Vorfall von Scheidengewebe",
      "Postoperativer Vorfall von Vaginalgewebe",
      "Scheidenstumpfprolaps nach Hysterektomie",
      "Vaginalinversion nach Hysterektomie",
      "Vaginalprolaps nach Hysterektomie",
      "Vaginalstumpfprolaps nach Hysterektomie"
    ]
  },
  {
    "code": "N99.4",
    "name": "Postoperative Adhäsion am Beckenperitoneum",
    "synonyms": [
      "Adhäsion am Beckenperitoneum bei der Frau, nach medizinischen Maßnahmen",
      "Postoperative Adhäsion am Beckenperitoneum"
    ]
  },
  {
    "code": "N99.5",
    "name": "Dysfunktion nach Zystostomie",
    "synonyms": [
      "Dysfunktion nach Zystostomie",
      "Komplikation durch Nephrostomie",
      "Komplikation durch Zystostomie"
    ]
  },
  {
    "code": "N99.8",
    "name": "Residual ovary syndrome",
    "synonyms": [
      "Intestinale Anastomose mit Komplikation im Bereich der Harnorgane",
      "Komplikation durch Anastomose im Bereich der Harnorgane",
      "Komplikation nach Pyelogramm",
      "Postoperative Stressinkontinenz",
      "Residual ovary syndrome",
      "Striktur einer vesikourethralen Anastomose (nach radikaler Prostatektomie)",
      "Uterusatrophie durch Bestrahlung"
    ]
  },
  {
    "code": "N99.9",
    "name": "Postoperative Komplikation der Harnorgane a.n.k.",
    "synonyms": [
      "Komplikation der Harnorgane nach chirurgischem Eingriff",
      "Komplikation der Harnwege nach Operation",
      "Komplikation der männliche Genitalorgane nach medizinischen Maßnahmen",
      "Komplikation des Urogenitalsystems nach Operation",
      "Komplikation des Urogenitalsystems nach medizinischen Maßnahmen",
      "Postoperative Komplikation der Harnorgane a.n.k."
    ]
  },
  {
    "code": "O00.0",
    "name": "Peritonealgravidität",
    "synonyms": [
      "Abdominalgravidität",
      "Bauchhöhlengravidität",
      "Bauchhöhlenschwangerschaft",
      "Ektopische Graviditas abdominalis",
      "Intraperitoneale Gravidität",
      "Intraperitoneale Schwangerschaft",
      "Peritonealgravidität",
      "Peritonealschwangerschaft"
    ]
  },
  {
    "code": "O00.1",
    "name": "Tubarabort",
    "synonyms": [
      "Abortus ampullaris",
      "Eileiterruptur durch Schwangerschaft",
      "Eileiterschwangerschaft",
      "Graviditas ampullaris",
      "Graviditas isthmica",
      "Ruptur der Tuba uterina durch Schwangerschaft",
      "Tubarabort",
      "Tubargravidität",
      "Tubenmole",
      "Tubenruptur durch Gravidität",
      "Tubenschwangerschaft"
    ]
  },
  {
    "code": "O00.2",
    "name": "Ovargravidität",
    "synonyms": [
      "Eierstockschwangerschaft",
      "Graviditas ovarica",
      "Ovargravidität",
      "Ovarschwangerschaft"
    ]
  },
  {
    "code": "O00.8",
    "name": "Intramurale Gravidität",
    "synonyms": [
      "Extrauteringravidität im Uterushorn",
      "Extrauterinschwangerschaft im Uterushorn",
      "Gravidität im Mesometrium",
      "Gravidität im Uterushorn",
      "Gravidität in der Cervix uteri",
      "Interstitielle Gravidität",
      "Interstitielle Schwangerschaft",
      "Intraligamentäre Gravidität",
      "Intraligamentäre Schwangerschaft",
      "Intramurale Gravidität",
      "Intramurale Schwangerschaft",
      "Schwangerschaft im Mesometrium",
      "Schwangerschaft im Uterushorn",
      "Schwangerschaft in der Cervix uteri",
      "Zervikale Extrauteringravidität",
      "Zervikale Extrauterinschwangerschaft",
      "Zervikalgravidität",
      "Zervikalschwangerschaft"
    ]
  },
  {
    "code": "O00.9",
    "name": "Extrauterinschwangerschaft",
    "synonyms": [
      "Ektope Schwangerschaft",
      "Ektopische Schwangerschaft",
      "Ektopische rupturierte Gravidität",
      "Ektopische rupturierte Schwangerschaft",
      "Extrauteringravidität",
      "Extrauterinschwangerschaft",
      "Graviditas extrauterina",
      "Hämatozele bei Extrauterinschwangerschaft",
      "Rupturierte Extrauteringravidität",
      "Rupturierte Extrauterinschwangerschaft",
      "Schwangerschaft außerhalb der Gebärmutter",
      "Schwangerschaft außerhalb des Uterus"
    ]
  },
  {
    "code": "O01.0",
    "name": "Klassische Blasenmole",
    "synonyms": [
      "Klassische Blasenmole",
      "Klassische hydatidiforme Mole",
      "Komplette Blasenmole",
      "Komplette hydatidiforme Mole"
    ]
  },
  {
    "code": "O01.1",
    "name": "Inkomplette Blasenmole",
    "synonyms": [
      "Inkomplette Blasenmole",
      "Inkomplette hydatidiforme Mole",
      "Partielle Blasenmole",
      "Partielle hydatidiforme Mole"
    ]
  },
  {
    "code": "O01.9",
    "name": "Choriontumor",
    "synonyms": [
      "Benigne Blasenmole",
      "Blasenmole",
      "Choriontumor",
      "Entbundene Blasenmole",
      "Hydatidenmole",
      "Mola hydatidosa",
      "Nichtentbundene Blasenmole",
      "Schwangerschaftskomplikation durch Blasenmole",
      "Schwangerschaftskomplikation durch hydatidiforme Mole",
      "Traubenmole",
      "Trophoblastenmole",
      "Trophoblastkrankheit"
    ]
  },
  {
    "code": "O02.0",
    "name": "Fleischmole",
    "synonyms": [
      "Abortivei",
      "Blutmole",
      "Breus-Mole",
      "Eimole",
      "Eizellenkrankheit",
      "Fleischmole",
      "Hämatommole",
      "Hämatomole",
      "Intrauterine Mole",
      "Molenei",
      "Molengravidität a.n.k.",
      "Molenschwangerschaft a.n.k.",
      "Pathologische Eizelle",
      "Retention eines abgestorbenen Eies",
      "Windei",
      "Windmole"
    ]
  },
  {
    "code": "O02.1",
    "name": "Missed abortion",
    "synonyms": [
      "Fetaltod in der Frühschwangerschaft",
      "Früher Fetaltod mit Retention",
      "Missed abortion",
      "Verhaltene Fehlgeburt",
      "Verhaltener Abort"
    ]
  },
  {
    "code": "O02.8",
    "name": "Chorioangiom",
    "synonyms": [
      "Chorangiom",
      "Chorioangiom",
      "Plazentahämangiom"
    ]
  },
  {
    "code": "O02.9",
    "name": "Abnormes Konzeptionsprodukt",
    "synonyms": [
      "Abnormes Konzeptionsprodukt"
    ]
  },
  {
    "code": "O03.3",
    "name": "Inkompletter Spontanabort mit Komplikation",
    "synonyms": [
      "Inkompletter Spontanabort mit Komplikation"
    ]
  },
  {
    "code": "O03.4",
    "name": "Spontaner unvollständiger Abort",
    "synonyms": [
      "Spontaner inkompletter Abort",
      "Spontaner unvollständiger Abort"
    ]
  },
  {
    "code": "O03.5",
    "name": "Infizierter Spontanabort",
    "synonyms": [
      "Infizierter Spontanabort",
      "Septischer Spontanabort"
    ]
  },
  {
    "code": "O03.6",
    "name": "Spontaner Abort mit Blutung",
    "synonyms": [
      "Spontaner Abort mit Blutung"
    ]
  },
  {
    "code": "O03.8",
    "name": "Kompletter Spontanabort mit Komplikation",
    "synonyms": [
      "Kompletter Spontanabort mit Komplikation"
    ]
  },
  {
    "code": "O03.9",
    "name": "Spontanabort",
    "synonyms": [
      "Abort nach drohendem Abort",
      "Abortus habitualis",
      "Habitueller Abort",
      "Spontanabort",
      "Spontane Fehlgeburt",
      "Spontaner habitueller Abort",
      "Spontaner kompletter Abort",
      "Spontaner vollständiger Abort"
    ]
  },
  {
    "code": "O04.3",
    "name": "Inkomplette Interruptio mit Komplikation",
    "synonyms": [
      "Inkomplette Interruptio mit Komplikation"
    ]
  },
  {
    "code": "O04.4",
    "name": "Inkomplette Interruptio",
    "synonyms": [
      "Inkomplette Interruptio",
      "Inkompletter legaler Schwangerschaftsabbruch"
    ]
  },
  {
    "code": "O04.8",
    "name": "Komplette Interruptio mit Komplikation",
    "synonyms": [
      "Komplette Interruptio mit Komplikation",
      "Legaler Schwangerschaftsabbruch mit Komplikation"
    ]
  },
  {
    "code": "O04.9",
    "name": "Graviditätsabbruch",
    "synonyms": [
      "Abort aus gesetzlicher Indikation",
      "Abort aus psychiatrischer Indikation",
      "Abort aus ärztlicher Indikation",
      "Abruptio graviditatis",
      "Abruptio graviditatis aus medizinischer Indikation",
      "Abruptio graviditatis aus sozialer Indikation",
      "Artifizieller Abort",
      "Gesetzlicher Schwangerschaftsabbruch",
      "Graviditätsabbruch",
      "Interruptio aus sozialer Indikation",
      "Interruptio legalis",
      "Komplette Interruptio",
      "Legaler Abort",
      "Legaler Graviditätsabbruch",
      "Legaler Schwangerschaftsabbruch",
      "Therapeutischer Abort",
      "Therapeutischer Schwangerschaftsabbruch",
      "Ärztlich eingeleiteter Abort",
      "Ärztliche Abruptio graviditatis",
      "Ärztliche Interruptio graviditatis",
      "Ärztlicher Graviditätsabbruch",
      "Ärztlicher Schwangerschaftsabbruch"
    ]
  },
  {
    "code": "O05.8",
    "name": "Seifenabort",
    "synonyms": [
      "Seifenabort"
    ]
  },
  {
    "code": "O05.9",
    "name": "Immunologisch bedingter Abort",
    "synonyms": [
      "Illegaler Abort",
      "Illegaler Graviditätsabbruch",
      "Illegaler Schwangerschaftsabbruch",
      "Immunologisch bedingter Abort",
      "Krimineller Abort",
      "Strafbarer Graviditätsabbruch",
      "Strafbarer Schwangerschaftsabbruch"
    ]
  },
  {
    "code": "O06.3",
    "name": "Inkomplette Fehlgeburt mit Komplikation",
    "synonyms": [
      "Inkomplette Fehlgeburt mit Komplikation",
      "Inkompletter Abort mit Komplikation"
    ]
  },
  {
    "code": "O06.4",
    "name": "Abortus incompletus",
    "synonyms": [
      "Abortus incompletus",
      "Inkomplette Fehlgeburt",
      "Inkompletter Abort",
      "Unvollständiger Abort"
    ]
  },
  {
    "code": "O06.5",
    "name": "Infizierter Abort",
    "synonyms": [
      "Infektiöser Abort",
      "Infizierter Abort"
    ]
  },
  {
    "code": "O06.6",
    "name": "Abort mit Hämorrhagie",
    "synonyms": [
      "Abort mit Blutung",
      "Abort mit Hämorrhagie",
      "Abort mit Spätblutung"
    ]
  },
  {
    "code": "O06.8",
    "name": "Kompletter Abort mit Komplikation",
    "synonyms": [
      "Einzeitiger Abort mit Komplikation",
      "Komplette Fehlgeburt mit Komplikation",
      "Kompletter Abort mit Komplikation",
      "Protrahierter Abort",
      "Zweizeitiger Abort mit Komplikation"
    ]
  },
  {
    "code": "O06.9",
    "name": "Abortus incipiens",
    "synonyms": [
      "Abort",
      "Abortus - s.a. Abort",
      "Abortus completus",
      "Abortus incipiens",
      "Abtreibung - s.a. Abort",
      "Einzeitiger Abort",
      "Fehlgeburt - s.a. Abort",
      "Frühabort",
      "Geminiabort",
      "Komplette Fehlgeburt",
      "Kompletter Abort",
      "Schwangerschaftsabbruch - s.a. Abort",
      "Spätabort",
      "Vollständiger Abort",
      "Zweizeitiger Abort",
      "Zwillingsabort"
    ]
  },
  {
    "code": "O07.0",
    "name": "Misslungener ärztlicher Abort mit Beckeninfektion",
    "synonyms": [
      "Misslungener ärztlicher Abort mit Beckeninfektion",
      "Misslungener ärztlicher Abort mit Endometritis",
      "Misslungener ärztlicher Abort mit Genitaltraktinfektion",
      "Misslungener ärztlicher Abort mit Oophoritis",
      "Misslungener ärztlicher Abort mit Parametritis",
      "Misslungener ärztlicher Abort mit Pelviperitonitis",
      "Misslungener ärztlicher Abort mit Salpingitis",
      "Misslungener ärztlicher Abort mit Salpingo-Oophoritis",
      "Misslungener ärztlicher Abort mit Sepsis",
      "Misslungener ärztlicher Abort mit septischem Schock"
    ]
  },
  {
    "code": "O07.1",
    "name": "Misslungener ärztlicher Abort mit Defibrinationssyndrom",
    "synonyms": [
      "Misslungener ärztlicher Abort mit Afibrinogenämie",
      "Misslungener ärztlicher Abort mit Blutung",
      "Misslungener ärztlicher Abort mit Defibrinationssyndrom",
      "Misslungener ärztlicher Abort mit intravasaler Gerinnung"
    ]
  },
  {
    "code": "O07.2",
    "name": "Misslungener ärztlicher Abort mit Embolie",
    "synonyms": [
      "Misslungener ärztlicher Abort mit Embolie"
    ]
  },
  {
    "code": "O07.3",
    "name": "Misslungener ärztlicher Abort mit Harnwegsinfektion",
    "synonyms": [
      "Misslungener ärztlicher Abort mit Beckenorganperforation",
      "Misslungener ärztlicher Abort mit Beckenorganriss",
      "Misslungener ärztlicher Abort mit Beckenorganverätzung",
      "Misslungener ärztlicher Abort mit Harnwegsinfektion",
      "Misslungener ärztlicher Abort mit Herzstillstand",
      "Misslungener ärztlicher Abort mit Kreislaufkollaps",
      "Misslungener ärztlicher Abort mit Nierentubulusnekrose",
      "Misslungener ärztlicher Abort mit Nierenversagen",
      "Misslungener ärztlicher Abort mit Oligurie",
      "Misslungener ärztlicher Abort mit Schock",
      "Misslungener ärztlicher Abort mit Störung des Elektrolythaushaltes"
    ]
  },
  {
    "code": "O07.4",
    "name": "Misslungener ärztlicher Abort",
    "synonyms": [
      "Misslungene ärztliche Aborteinleitung",
      "Misslungener ärztlicher Abort"
    ]
  },
  {
    "code": "O07.5",
    "name": "Misslungene Aborteinleitung mit Komplikation durch Infektion",
    "synonyms": [
      "Misslungene Aborteinleitung mit Komplikation durch Endometritis",
      "Misslungene Aborteinleitung mit Komplikation durch Infektion",
      "Misslungene Aborteinleitung mit Komplikation durch Oophoritis",
      "Misslungene Aborteinleitung mit Komplikation durch Parametritis",
      "Misslungene Aborteinleitung mit Komplikation durch Pelviperitonitis",
      "Misslungene Aborteinleitung mit Komplikation durch Sepsis",
      "Misslungener Abort mit Komplikation durch Beckeninfektion",
      "Misslungener Abort mit Komplikation durch Genitaltraktinfektion",
      "Misslungener Abort mit Komplikation durch Salpingitis",
      "Misslungener Abort mit Komplikation durch Salpingo-Oophoritis",
      "Misslungener Abort mit Komplikation durch Sepsis",
      "Misslungener Abort mit Komplikation durch septischen Schock"
    ]
  },
  {
    "code": "O07.6",
    "name": "Misslungene Aborteinleitung mit Komplikation durch verstärkte Blutung",
    "synonyms": [
      "Misslungene Aborteinleitung mit Komplikation durch Afibrinogenämie",
      "Misslungene Aborteinleitung mit Komplikation durch verstärkte Blutung",
      "Misslungener Abort mit Komplikation durch Defibrinationssyndrom",
      "Misslungener Abort mit Komplikation durch intravasale Gerinnung"
    ]
  },
  {
    "code": "O07.7",
    "name": "Misslungene Aborteinleitung mit Komplikation durch Embolie",
    "synonyms": [
      "Misslungene Aborteinleitung mit Komplikation durch Embolie"
    ]
  },
  {
    "code": "O07.8",
    "name": "Misslungene Aborteinleitung mit Komplikation",
    "synonyms": [
      "Misslungene Aborteinleitung mit Komplikation",
      "Misslungene Aborteinleitung mit Komplikation durch Oligurie",
      "Misslungene Aborteinleitung mit Komplikation durch Schock",
      "Misslungener Abort mit Komplikation durch Beckenorganperforation",
      "Misslungener Abort mit Komplikation durch Beckenorganriss",
      "Misslungener Abort mit Komplikation durch Harnwegsinfektion",
      "Misslungener Abort mit Komplikation durch Herzstillstand",
      "Misslungener Abort mit Komplikation durch Kreislaufkollaps",
      "Misslungener Abort mit Komplikation durch Nierenversagen",
      "Misslungener Abort mit Komplikation durch Störung des Elektrolythaushaltes",
      "Misslungener Abort mit Komplikation durch Tubulusnekrose Niere",
      "Misslungener Abort mit Komplikation durch chemische Verätzung der Beckenorgane"
    ]
  },
  {
    "code": "O07.9",
    "name": "Abtreibungsversuch",
    "synonyms": [
      "Abtreibungsversuch",
      "Misslungene Abortinduktion",
      "Misslungener Abort",
      "Misslungener Abortversuch"
    ]
  },
  {
    "code": "O08.0",
    "name": "Infektion der Geschlechtsorgane nach Abort",
    "synonyms": [
      "Abszess der Genitalorgane nach Abort",
      "Abszess der Genitalorgane nach Extrauterinschwangerschaft",
      "Abszess der Genitalorgane nach Molenschwangerschaft",
      "Beckenperitonitis nach Abort",
      "Endometritis nach Abort",
      "Endometritis nach Extrauteringravidität",
      "Endometritis nach Molenschwangerschaft",
      "Entzündliche Beckenkrankheit nach Abort",
      "Entzündliche Beckenkrankheit nach Extrauteringravidität",
      "Entzündliche Beckenkrankheit nach Molenschwangerschaft",
      "Infektion der Beckenorgane nach Abort",
      "Infektion der Genitalorgane bei Extrauteringravidität",
      "Infektion der Genitalorgane bei Extrauterinschwangerschaft",
      "Infektion der Genitalorgane bei Molenschwangerschaft",
      "Infektion der Geschlechtsorgane nach Abort",
      "Parametritis nach Abort",
      "Parametritis nach Extrauteringravidität",
      "Parametritis nach Molenschwangerschaft",
      "Peritoneumabszess nach Abort",
      "Peritoneumabszess nach Extrauteringravidität",
      "Peritoneumabszess nach Molenschwangerschaft",
      "Peritonitis nach Abort",
      "Peritonitis nach Extrauteringravidität",
      "Peritonitis nach Molenschwangerschaft",
      "Salpingitis nach Abort",
      "Salpingo-Oophoritis nach Abort",
      "Salpingo-Oophoritis nach Extrauteringravidität",
      "Salpingo-Oophoritis nach Molenschwangerschaft",
      "Sepsis nach Abort",
      "Septische Intoxikation nach Abort",
      "Septische Intoxikation nach Extrauterinschwangerschaft",
      "Septischer Abort",
      "Thrombophlebitis einer Beckenvene bei Extrauteringravidität",
      "Thrombophlebitis einer Beckenvene bei Extrauterinschwangerschaft",
      "Thrombophlebitis einer Beckenvene bei Molenschwangerschaft",
      "Thrombophlebitis einer Beckenvene nach Abort",
      "Toxischer Abort",
      "Vaginitis nach Abort",
      "Vaginitis nach Extrauteringravidität",
      "Vaginitis nach Molenschwangerschaft"
    ]
  },
  {
    "code": "O08.1",
    "name": "Späte Blutung nach Fehlgeburt",
    "synonyms": [
      "Akzidentelle Blutung nach Abort",
      "Blutung nach Interruptio",
      "Fibrinolyse nach Abort",
      "Fibrinolyse nach Extrauteringravidität",
      "Fibrinolyse nach Molenschwangerschaft",
      "Intravaskuläre Hämolyse nach Abort",
      "Intravaskuläre Hämolyse nach Extrauteringravidität",
      "Intravaskuläre Hämolyse nach Molenschwangerschaft",
      "Späte Blutung nach Extrauteringravidität",
      "Späte Blutung nach Fehlgeburt",
      "Späte Blutung nach Molenschwangerschaft",
      "Späte Hämorrhagie nach Extrauteringravidität",
      "Späte Hämorrhagie nach Molenschwangerschaft",
      "Verbrauchskoagulopathie nach Abort",
      "Verbrauchskoagulopathie nach Extrauteringravidität",
      "Verbrauchskoagulopathie nach Molenschwangerschaft"
    ]
  },
  {
    "code": "O08.2",
    "name": "Embolie nach Fehlgeburt",
    "synonyms": [
      "Embolie nach Abort",
      "Embolie nach Extrauteringravidität",
      "Embolie nach Fehlgeburt",
      "Pyämische Embolie nach Abort",
      "Pyämische Embolie nach Extrauteringravidität",
      "Pyämische Embolie nach Molenschwangerschaft",
      "Seifenintoxikation nach Abort",
      "Seifenvergiftung nach Abort"
    ]
  },
  {
    "code": "O08.3",
    "name": "Schock nach Fehlgeburt",
    "synonyms": [
      "Kreislaufkollaps nach Abort",
      "Kreislaufkollaps nach Extrauteringravidität",
      "Kreislaufkollaps nach Molenschwangerschaft",
      "Lungenkollaps nach Abort",
      "Schock nach Abort",
      "Schock nach Extrauterinschwangerschaft",
      "Schock nach Fehlgeburt",
      "Schock nach Molenschwangerschaft"
    ]
  },
  {
    "code": "O08.4",
    "name": "Nierenschaden nach Fehlgeburt",
    "synonyms": [
      "Anurie nach Abort",
      "Anurie nach Extrauteringravidität",
      "Anurie nach Molenschwangerschaft",
      "Nierenblockade nach Abort",
      "Nierenblockade nach Extrauterinschwangerschaft",
      "Nierenblockade nach Molenschwangerschaft",
      "Niereninsuffizienz nach Abort",
      "Niereninsuffizienz nach Molenschwangerschaft",
      "Nierenschaden nach Fehlgeburt",
      "Nierenversagen nach Abort",
      "Nierenversagen nach Extrauterinschwangerschaft",
      "Nierenversagen nach Molenschwangerschaft",
      "Oligurie nach Abort",
      "Oligurie nach Extrauterinschwangerschaft",
      "Oligurie nach Molenschwangerschaft",
      "Schockniere nach Abort",
      "Schockniere nach Extrauterinschwangerschaft",
      "Schockniere nach Molenschwangerschaft",
      "Tubuläre Nierennekrose nach Abort",
      "Tubuläre Nierennekrose nach Extrauterinschwangerschaft",
      "Tubuläre Nierennekrose nach Molenschwangerschaft",
      "Urämie nach Abort",
      "Urämie nach Extrauterinschwangerschaft",
      "Urämie nach Molenschwangerschaft"
    ]
  },
  {
    "code": "O08.5",
    "name": "Stoffwechselstörung nach Fehlgeburt",
    "synonyms": [
      "Stoffwechselstörung nach Fehlgeburt"
    ]
  },
  {
    "code": "O08.6",
    "name": "Verletzung von Beckenorganen bei Fehlgeburt",
    "synonyms": [
      "Beckenorganschädigung nach Abort",
      "Beckenorganschädigung nach Extrauterinschwangerschaft",
      "Beckenorganschädigung nach Molenschwangerschaft",
      "Harnblasenruptur bei Fehlgeburt",
      "Lazeration durch Abort im Nachbehandlungszeitraum",
      "Perforation von Beckenorganen nach Abort",
      "Urethraruptur bei Fehlgeburt",
      "Verletzung von Beckenorganen bei Fehlgeburt",
      "Verätzung nach eingeleitetem Abort"
    ]
  },
  {
    "code": "O08.7",
    "name": "Thrombose nach Extrauteringravidität",
    "synonyms": [
      "Thrombose nach Abort",
      "Thrombose nach Extrauteringravidität",
      "Thrombose nach Molenschwangerschaft"
    ]
  },
  {
    "code": "O08.8",
    "name": "Abort mit Infektion der Harnwege",
    "synonyms": [
      "Abort mit Infektion der Harnwege",
      "Endometriose post abruptionem",
      "Lymphangitis nach Abort",
      "Lymphangitis nach Extrauteringravidität",
      "Lymphangitis nach Molenschwangerschaft"
    ]
  },
  {
    "code": "O08.9",
    "name": "Komplizierte Fehlgeburt",
    "synonyms": [
      "Komplikation nach Abort",
      "Komplikation nach Extrauteringravidität",
      "Komplikation nach Extrauterinschwangerschaft",
      "Komplikation nach Molenschwangerschaft",
      "Komplizierte Fehlgeburt"
    ]
  },
  {
    "code": "O10.0",
    "name": "Gutartige essentielle Hypertonie bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Gutartige essentielle Hypertonie bei Schwangerschaft, bereits vorher bestehend",
      "Maligne Hypertonie bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O10.1",
    "name": "Herzkrankheit mit Hypertonie bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Herzkrankheit mit Hypertonie bei Gravidität, bereits vorher bestehend",
      "Herzkrankheit mit Hypertonie bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O10.2",
    "name": "Hypertensive Nierenkrankheit bei Gravidität, bereits vorher bestehend",
    "synonyms": [
      "Hypertensive Nierenkrankheit bei Gravidität, bereits vorher bestehend"
    ]
  },
  {
    "code": "O10.3",
    "name": "Gravidität mit hypertensiver Herz- und Nierenkrankheit, vorher bestehend",
    "synonyms": [
      "Gravidität mit hypertensiver Herz- und Nierenkrankheit, vorher bestehend",
      "Schwangerschaft mit hypertensiver Herz- und Nierenkrankheit, vorher bestehend"
    ]
  },
  {
    "code": "O10.4",
    "name": "Renale Hypertonie bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Renale Hypertonie bei Schwangerschaft, bereits vorher bestehend",
      "Schwangerschaft mit vorher bestehender renaler Hypertonie nach Nierenkrankheit",
      "Schwangerschaft mit vorher bestehender sekundärer Hypertonie durch Nephritis",
      "Schwangerschaft mit vorher bestehender sekundärer Hypertonie nach Nierenkrankheit",
      "Sekundäre Hypertonie bei Nierenkrankheit bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O11",
    "name": "Präeklamptische Hypertonie bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Aufgepfropfte Präeklampsie",
      "Aufgepfropfte Präeklampsie bei Hypertonie",
      "Aufgepfropfte Präeklampsie bei chronischer Hypertonie",
      "Aufgepfropfte Präeklampsie bei vorher bestehender Hypertonie",
      "Aufpfropfgestose",
      "Essentielle Hypertonie bei Schwangerschaft, vorher bestehend mit aufgepfropfter Präeklampsie",
      "Pfropf-Präeklampsie",
      "Präeklampsie bei schon früher bestehender Hypertonie",
      "Präeklamptische Hypertonie bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O12.0",
    "name": "Schwangerschaftshydrops",
    "synonyms": [
      "Gestationsbedingtes Ödem",
      "Gestationsödem",
      "Hydrops gravidarum",
      "Schwangerschaftshydrops",
      "Schwangerschaftsödem",
      "Ödem bei Gravidität"
    ]
  },
  {
    "code": "O12.1",
    "name": "Gestationsproteinurie",
    "synonyms": [
      "Albuminurie bei Gravidität",
      "Entbindungsalbuminurie",
      "Gestationsproteinurie",
      "Proteinurie bei Entbindung",
      "Proteinurie bei Gravidität",
      "Proteinurie im Wochenbett",
      "Schwangerschaftsalbuminurie",
      "Schwangerschaftsproteinurie",
      "Wochenbettalbuminurie"
    ]
  },
  {
    "code": "O12.2",
    "name": "Schwangerschaftsödem mit Proteinurie",
    "synonyms": [
      "Albuminurie bei Gravidität mit Ödem",
      "Albuminurie bei Schwangerschaft mit Ödem",
      "Albuminurie im Wochenbett mit Ödem",
      "Gestationsbedingtes Ödem mit Proteinurie",
      "Schwangerschaftsödem mit Proteinurie"
    ]
  },
  {
    "code": "O13",
    "name": "Schwangerschaftshypertonie",
    "synonyms": [
      "Flüchtige Hypertonie bei Gravidität",
      "Flüchtige Hypertonie bei Schwangerschaft",
      "Gestationshypertonie",
      "Schwangerschaftsbedingte Hypertonie",
      "Schwangerschaftsbedingte transiente Hypertonie",
      "Schwangerschaftshypertonie",
      "Schwangerschaftsinduzierte renale Hypertonie"
    ]
  },
  {
    "code": "O14.0",
    "name": "Mäßige Präeklampsie",
    "synonyms": [
      "Leichte Präeklampsie",
      "Mäßige Präeklampsie"
    ]
  },
  {
    "code": "O14.1",
    "name": "Schwere Präeklampsie",
    "synonyms": [
      "Hypertonie bei Schwangerschaft mit schwerer Albuminurie",
      "Schwere Präeklampsie",
      "Schwere Präeklampsie im Wochenbett"
    ]
  },
  {
    "code": "O14.2",
    "name": "HELLP [Hemolysis, elevated liver function test, low platelet counts]-Syndrom",
    "synonyms": [
      "Gravidität mit HELLP [Hemolysis, elevated liver function test, low platelet counts]-Syndrom",
      "HELLP [Hemolysis, elevated liver function test, low platelet counts]-Syndrom",
      "Schwangerschaft mit HELLP [Hemolysis, elevated liver function test, low platelet counts]-Syndrom"
    ]
  },
  {
    "code": "O14.9",
    "name": "Schwangerschaftstoxikose",
    "synonyms": [
      "EPH [Ödem-Proteinurie-Hypertonie]-Gestose",
      "Gestationstoxikose",
      "Gestose",
      "Graviditätstoxikose",
      "Postpartale Toxikose",
      "Präeklampsie",
      "Präeklampsie bei Gravidität",
      "Präeklampsie bei Schwangerschaft",
      "Präeklampsie im Wochenbett",
      "Präeklamptische Proteinurie",
      "Präeklamptische Toxikose",
      "Puerperale Toxikose",
      "Schnittentbindung bei Präeklampsie",
      "Schwangerschaftsgestose",
      "Schwangerschaftsspättoxikose",
      "Schwangerschaftstoxikose",
      "Spätgestose"
    ]
  },
  {
    "code": "O15.0",
    "name": "Eklampsie bei Schwangerschaft",
    "synonyms": [
      "Eklampsie bei Gravidität",
      "Eklampsie bei Schwangerschaft",
      "Eklamptische Urämie bei Gravidität",
      "Eklamptische Urämie bei Schwangerschaft",
      "Eklamptischer Krampf bei Gravidität",
      "Schnittentbindung bei Eklampsie",
      "Schwangerschaftskrampf"
    ]
  },
  {
    "code": "O15.1",
    "name": "Eklampsie bei Geburt",
    "synonyms": [
      "Eklampsie als Entbindungskomplikation",
      "Eklampsie bei Geburt"
    ]
  },
  {
    "code": "O15.2",
    "name": "Eklampsie im Wochenbett",
    "synonyms": [
      "Eklampsie im Wochenbett",
      "Postpartale Eklampsie"
    ]
  },
  {
    "code": "O15.9",
    "name": "Eklamptische Hypertonie bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Eklampsia",
      "Eklampsie",
      "Eklampsie mit Delirium",
      "Eklampsie mit Konvulsionen",
      "Eklampsie mit schwangerschaftsinduzierter Hypertonie a.n.k",
      "Eklampsie mit vorher bestehender Hypertonie a.n.k",
      "Eklampsieanfall",
      "Eklamptische Hypertonie bei Schwangerschaft, bereits vorher bestehend",
      "Eklamptische Toxikose",
      "Eklamptisches Koma"
    ]
  },
  {
    "code": "O16",
    "name": "Hypertonie der Mutter bei Schwangerschaft a.n.k.",
    "synonyms": [
      "Hypertonie als Entbindungskomplikation",
      "Hypertonie der Mutter bei Gravidität a.n.k.",
      "Hypertonie der Mutter bei Schwangerschaft a.n.k.",
      "Transitorische Hypertonie bei Schwangerschaft",
      "Transitorische renale Hypertonie bei Schwangerschaft"
    ]
  },
  {
    "code": "O20.0",
    "name": "Drohender Abort",
    "synonyms": [
      "Abortus imminens",
      "Blutung durch drohenden Abort",
      "Drohende Fehlgeburt",
      "Drohender Abort",
      "Drohender Spontanabort",
      "Imminenter Abort"
    ]
  },
  {
    "code": "O20.8",
    "name": "Menstruation bei Schwangerschaft",
    "synonyms": [
      "Menstruation bei Schwangerschaft"
    ]
  },
  {
    "code": "O20.9",
    "name": "Blutung bei Frühschwangerschaft",
    "synonyms": [
      "Blutung bei Frühschwangerschaft",
      "Gravidität mit Blutung vor Vollendung der 22. Schwangerschaftswoche",
      "Hämorrhagie bei Frühschwangerschaft",
      "Schmierblutung bei Frühschwangerschaft",
      "Schwangerschaft mit Blutung vor Vollendung der 22. Schwangerschaftswoche",
      "Schwangerschaftsblutung im 1. Trimenon"
    ]
  },
  {
    "code": "O21.0",
    "name": "Leichte Hyperemesis gravidarum",
    "synonyms": [
      "Hyperemesis bei Frühschwangerschaft",
      "Hyperemesis gravidarum",
      "Hyperemesis gravidarum, Beginn vor Beendigung der 20. Schwangerschaftswoche",
      "Leichte Hyperemesis bei Frühschwangerschaft",
      "Leichte Hyperemesis gravidarum",
      "Leichte Hyperemesis gravidarum, Beginn vor Beendigung der 20. Schwangerschaftswoche",
      "Vomitus gravidarum",
      "Übermäßiges Erbrechen bei Schwangerschaft"
    ]
  },
  {
    "code": "O21.1",
    "name": "Hyperemesis mit Stoffwechselstörung bei Gravidität",
    "synonyms": [
      "Hyperemesis gravidarum mit Dehydratation, Beginn vor Beendigung der 20. Schwangerschaftswoche",
      "Hyperemesis gravidarum mit Elektrolytstörung",
      "Hyperemesis gravidarum mit Hypoglykämie, Beginn vor Beendigung der 20. Schwangerschaftswoche",
      "Hyperemesis gravidarum mit Kohlenhydratverlust",
      "Hyperemesis gravidarum mit Stoffwechselstörung",
      "Hyperemesis gravidarum mit Stoffwechselstörung, Beginn vor Beendigung der 20. Schwangerschaftswoche",
      "Hyperemesis gravidarum mit Störung des Elektrolythaushaltes, Beginn vor Beendigung der 20. Schwangerschaftswoche",
      "Hyperemesis gravidarum mit Wasserentzug",
      "Hyperemesis mit Stoffwechselstörung bei Gravidität",
      "Hyperemesis mit Stoffwechselstörung bei Schwangerschaft"
    ]
  },
  {
    "code": "O21.2",
    "name": "Späterbrechen bei Schwangerschaft",
    "synonyms": [
      "Erbrechen im Spätstadium der Gravidität",
      "Erbrechen im Spätstadium der Schwangerschaft",
      "Späterbrechen bei Schwangerschaft",
      "Übermäßiges Erbrechen in der Schwangerschaft, Beginn nach 20 vollendeten Schwangerschaftswochen"
    ]
  },
  {
    "code": "O21.9",
    "name": "Emesis bei Gravidität",
    "synonyms": [
      "Emesis bei Gravidität",
      "Emesis bei Schwangerschaft",
      "Emesis gravidarum",
      "Erbrechen bei Gravidität",
      "Erbrechen bei Schwangerschaft"
    ]
  },
  {
    "code": "O22.0",
    "name": "Stammvarikose bei Gravidität",
    "synonyms": [
      "Gravidität mit varikösen Beinvenen",
      "Schwangerschaft mit varikösen Beinvenen",
      "Schwangerschaftsvarizen",
      "Stammvarikose bei Gravidität",
      "Stammvarikose bei Schwangerschaft",
      "Varikose bei Gravidität",
      "Varizen der unteren Extremität bei Schwangerschaft",
      "Venenvarikose bei Schwangerschaft"
    ]
  },
  {
    "code": "O22.1",
    "name": "Varicosis vulvae in graviditate",
    "synonyms": [
      "Genitalorganvarizen bei Schwangerschaft",
      "Genitalvarizen bei Schwangerschaft",
      "Perineumvarizen bei Gravidität",
      "Perineumvarizen bei Schwangerschaft",
      "Vaginavarizen bei Schwangerschaft",
      "Varicosis vulvae in graviditate",
      "Varikose von Genitalvenen bei Schwangerschaft",
      "Vulvavarizen bei Gravidität",
      "Vulvavarizen bei Schwangerschaft"
    ]
  },
  {
    "code": "O22.2",
    "name": "Schwangerschaft mit oberflächlicher Thrombophlebitis",
    "synonyms": [
      "Präpartale Thrombophlebitis eines Beins",
      "Präpartale oberflächliche Thrombophlebitis",
      "Schwangerschaft mit oberflächlicher Thrombophlebitis",
      "Schwangerschaftskomplikation durch oberflächliche Phlebitis",
      "Schwangerschaftsthrombophlebitis",
      "Thrombophlebitis bei Gravidität",
      "Thrombophlebitis des Beins bei Gravidität",
      "Thrombophlebitis des Beins bei Schwangerschaft"
    ]
  },
  {
    "code": "O22.3",
    "name": "Tiefe Thrombophlebitis bei Schwangerschaft",
    "synonyms": [
      "Antepartale tiefe Phlebothrombose",
      "Antepartale tiefe Thrombophlebitis",
      "Antepartale tiefe Venenthrombose",
      "Gravidität mit tiefer Venenthrombose",
      "Phlebothrombose bei Schwangerschaft",
      "Präpartale Thrombophlebitis einer Beckenvene",
      "Präpartale tiefe Venenthrombose",
      "Schwangerschaft mit tiefer Venenthrombose",
      "Schwangerschaftskomplikation durch Phlegmasia alba dolens",
      "Tiefe Phlebothrombose bei Schwangerschaft",
      "Tiefe Thrombophlebitis bei Gravidität",
      "Tiefe Thrombophlebitis bei Schwangerschaft"
    ]
  },
  {
    "code": "O22.4",
    "name": "Schwangerschaft mit Hämorrhoiden",
    "synonyms": [
      "Gravidität mit Hämorrhoiden",
      "Schwangerschaft mit Anusvarizen",
      "Schwangerschaft mit Hämorrhoiden",
      "Schwangerschaft mit Rektumvarizen",
      "Schwangerschaft mit Varikose einer Analvene",
      "Schwangerschaft mit Varikose einer Rektumvene"
    ]
  },
  {
    "code": "O22.5",
    "name": "Schwangerschaft mit Hirnvenenthrombose",
    "synonyms": [
      "Schwangerschaft mit Hirnvenenthrombose",
      "Thrombose eines zerebralen Venensinus in der Schwangerschaft",
      "Zerebrovenöse Sinusthrombose in der Schwangerschaft"
    ]
  },
  {
    "code": "O22.8",
    "name": "Tiefe Phlebitis bei Schwangerschaft",
    "synonyms": [
      "Tiefe Phlebitis bei Schwangerschaft"
    ]
  },
  {
    "code": "O22.9",
    "name": "Gravidität mit venöser Stauung",
    "synonyms": [
      "Gravidität mit Phlebitis",
      "Gravidität mit Thrombose",
      "Gravidität mit Venenthrombose",
      "Gravidität mit chronischer Veneninsuffizienz",
      "Gravidität mit venostatischem Ödem",
      "Gravidität mit venöser Stauung",
      "Phlebopathie bei Gravidität",
      "Präpartale Thrombose",
      "Schwangerschaft mit Thrombose",
      "Schwangerschaft mit chronischer Veneninsuffizienz",
      "Schwangerschaft mit venostatischem Ödem",
      "Schwangerschaft mit venöser Stauung",
      "Schwangerschaftsbedingte Phlebitis",
      "Schwangerschaftsbedingte Phlebopathie",
      "Schwangerschaftsbedingte Thrombose",
      "Schwangerschaftsphlebitis",
      "Schwangerschaftsphlebopathie",
      "Venenthrombose bei Schwangerschaft"
    ]
  },
  {
    "code": "O23.0",
    "name": "Niereninfektion bei Schwangerschaft",
    "synonyms": [
      "Gravidität mit Pyelonephritis",
      "Nierenabszess bei Schwangerschaft",
      "Niereninfektion bei Gravidität",
      "Niereninfektion bei Schwangerschaft",
      "Pyelitis bei Gravidität",
      "Pyelitis bei Schwangerschaft",
      "Pyelitis gravidarum",
      "Pyelonephritis gravidarum",
      "Pyonephritis bei Gravidität",
      "Pyonephritis bei Schwangerschaft",
      "Schwangerschaft mit Pyelonephritis",
      "Schwangerschaftspyelitis"
    ]
  },
  {
    "code": "O23.1",
    "name": "Septische Zystitis bei Gravidität",
    "synonyms": [
      "Cystitis gravidarum",
      "Eitrige Zystitis bei Gravidität",
      "Harnblasenabszess bei Gravidität",
      "Harnblasenabszess bei Schwangerschaft",
      "Harnblasengangrän bei Gravidität",
      "Harnblasengangrän bei Schwangerschaft",
      "Harnblaseninfektion bei Gravidität",
      "Harnblaseninfektion bei Schwangerschaft",
      "Harnblasenphlegmone bei Gravidität",
      "Harnblasenphlegmone bei Schwangerschaft",
      "Septische Zystitis bei Gravidität",
      "Zystitis bei Gravidität",
      "Zystitis bei Schwangerschaft"
    ]
  },
  {
    "code": "O23.2",
    "name": "Urethrainfektion bei Schwangerschaft",
    "synonyms": [
      "Harnröhreninfektion bei Schwangerschaft",
      "Urethrainfektion bei Gravidität",
      "Urethrainfektion bei Schwangerschaft",
      "Urethritis bei Gravidität",
      "Urethritis bei Schwangerschaft",
      "Urethritis gravidarum"
    ]
  },
  {
    "code": "O23.3",
    "name": "Zystopyelitis bei Gravidität",
    "synonyms": [
      "Pyelozystitis bei Gravidität",
      "Pyelozystitis bei Schwangerschaft",
      "Zystopyelitis bei Gravidität",
      "Zystopyelitis bei Schwangerschaft"
    ]
  },
  {
    "code": "O23.4",
    "name": "Asymptomatische Bakteriurie bei Gravidität",
    "synonyms": [
      "Asymptomatische Bakteriurie bei Gravidität",
      "Asymptomatische Bakteriurie bei Schwangerschaft",
      "Harnorganinfektion bei Gravidität",
      "Harnwegsinfektion bei Gravidität",
      "Harnwegsinfektion bei Schwangerschaft"
    ]
  },
  {
    "code": "O23.5",
    "name": "Herpes genitalis bei Gravidität",
    "synonyms": [
      "Abszess der Labia majora pudendi bei Schwangerschaft",
      "Abszess der Labia minora pudendi bei Schwangerschaft",
      "Endometritis bei Gravidität",
      "Endometritis bei Schwangerschaft",
      "Herpes genitalis bei Gravidität",
      "Herpes genitalis bei Schwangerschaft",
      "Infektion der Geschlechtsorgane bei Gravidität",
      "Infektion der Geschlechtsorgane bei Schwangerschaft",
      "Intrauterine Infektion bei Schwangerschaft",
      "Kolpitis bei Gravidität",
      "Kolpitis bei Schwangerschaft",
      "Oophoritis bei Gravidität",
      "Oophoritis bei Schwangerschaft",
      "Salpingitis bei Gravidität",
      "Salpingitis bei Schwangerschaft",
      "Salpingo-Oophoritis bei Gravidität",
      "Salpingo-Oophoritis bei Schwangerschaft",
      "Vaginitis bei Gravidität",
      "Vaginitis bei Schwangerschaft",
      "Vulvaabszess bei Schwangerschaft",
      "Vulvitis bei Gravidität",
      "Vulvitis bei Schwangerschaft",
      "Zervizitis bei Gravidität",
      "Zervizitis bei Schwangerschaft"
    ]
  },
  {
    "code": "O23.9",
    "name": "Infektion des Urogenitaltraktes bei Schwangerschaft",
    "synonyms": [
      "Infektion des Urogenitaltraktes bei Gravidität",
      "Infektion des Urogenitaltraktes bei Schwangerschaft"
    ]
  },
  {
    "code": "O24.0",
    "name": "Primär insulinpflichtiger Diabetes mellitus bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Diabetes mellitus Typ 1 bei Schwangerschaft, bereits vorher bestehend",
      "Primär insulinpflichtiger Diabetes mellitus bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O24.1",
    "name": "Diabetes mellitus Typ 2 bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Diabetes mellitus Typ 2 bei Schwangerschaft, bereits vorher bestehend",
      "Nichtinsulinpflichtiger Diabetes mellitus bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O24.2",
    "name": "Vor der Schwangerschaft bestehender Diabetes mellitus durch Fehl- oder Mangelernährung",
    "synonyms": [
      "Vor der Schwangerschaft bestehender Diabetes mellitus durch Fehl- oder Mangelernährung"
    ]
  },
  {
    "code": "O24.3",
    "name": "Diabetes mellitus bei Schwangerschaft, bereits vorher bestehend",
    "synonyms": [
      "Diabetes mellitus bei Schwangerschaft, bereits vorher bestehend"
    ]
  },
  {
    "code": "O24.4",
    "name": "Diabetes mellitus bei Schwangerschaft, während derselben auftretend",
    "synonyms": [
      "Diabetes mellitus bei Schwangerschaft, während derselben auftretend",
      "Gestationsbedingter Diabetes mellitus",
      "Gestationsdiabetes",
      "Schwangerschaftsbedingter Diabetes mellitus"
    ]
  },
  {
    "code": "O24.9",
    "name": "Diabetes mellitus bei Schwangerschaft",
    "synonyms": [
      "Diabetes mellitus bei Gravidität",
      "Diabetes mellitus bei Schwangerschaft",
      "Diabetes mellitus der Mutter bei Geburt",
      "Diabetes mellitus im Wochenbett",
      "Latenter Diabetes mellitus bei Gravidität",
      "Latenter Diabetes mellitus bei Schwangerschaft",
      "Schnittentbindung bei mütterlichem Diabetes mellitus"
    ]
  },
  {
    "code": "O25",
    "name": "Mangelernährung in der Schwangerschaft",
    "synonyms": [
      "Ernährungsmangel in der Gravidität",
      "Ernährungsmangel in der Schwangerschaft",
      "Fehlernährung bei Geburt",
      "Fehlernährung im Wochenbett",
      "Fehlernährung in der Schwangerschaft",
      "Malnutrition bei Entbindung",
      "Malnutrition im Wochenbett",
      "Malnutrition in der Schwangerschaft",
      "Mangelernährung bei Geburt",
      "Mangelernährung im Wochenbett",
      "Mangelernährung in der Schwangerschaft"
    ]
  },
  {
    "code": "O26.0",
    "name": "Übermäßige Gewichtszunahme bei Schwangerschaft",
    "synonyms": [
      "Übermäßige Gewichtszunahme bei Gravidität",
      "Übermäßige Gewichtszunahme bei Schwangerschaft"
    ]
  },
  {
    "code": "O26.1",
    "name": "Geringe Gewichtszunahme bei Schwangerschaft",
    "synonyms": [
      "Geringe Gewichtszunahme bei Gravidität",
      "Geringe Gewichtszunahme bei Schwangerschaft"
    ]
  },
  {
    "code": "O26.2",
    "name": "Neigung zu habituellem Abort bei Schwangerschaft",
    "synonyms": [
      "Neigung zu habituellem Abort bei Gravidität",
      "Neigung zu habituellem Abort bei Schwangerschaft"
    ]
  },
  {
    "code": "O26.3",
    "name": "Schwangerschaft bei liegendem Intrauterinpessar",
    "synonyms": [
      "Betreuung der Schwangeren bei liegendem Intrauterinpessar",
      "Gravidität bei liegendem Intrauterinpessar",
      "Retention eines Intrauterinpessars bei Schwangerschaft",
      "Schwangerschaft bei liegendem Intrauterinpessar"
    ]
  },
  {
    "code": "O26.4",
    "name": "Herpes gestationis",
    "synonyms": [
      "Betreuung der Schwangeren bei Herpes gestationis",
      "Gravida-Betreuung bei Herpes gestationis",
      "Herpes gestationis",
      "Herpes graviditatis",
      "Schwangerschafts-Pemphigoid"
    ]
  },
  {
    "code": "O26.5",
    "name": "Betreuung der Schwangeren bei Hypotoniesyndrom",
    "synonyms": [
      "Betreuung der Schwangeren bei Hypotonie",
      "Betreuung der Schwangeren bei Hypotoniesyndrom",
      "Betreuung der Schwangeren bei Vena-cava-Syndrom",
      "Gravida-Betreuung bei Vena-cava-Syndrom",
      "Hypotonie bei Gravidität",
      "Hypotonie bei Schwangerschaft",
      "Vena-cava-Kompressionssyndrom durch Schwangerschaft",
      "Vena-cava-Syndrom durch Schwangerschaft",
      "Vena-cava-inferior-Okklusionssyndrom durch Schwangerschaft"
    ]
  },
  {
    "code": "O26.60",
    "name": "Cholestase in der Schwangerschaft",
    "synonyms": [
      "Cholestase in der Schwangerschaft",
      "Intrahepatische Cholestase in der Schwangerschaft",
      "Intrahepatische Schwangerschaftscholestase",
      "Rekurrente intrahepatische Schwangerschaftscholestase",
      "Schwangerschaftsbedingte Cholestase"
    ]
  },
  {
    "code": "O26.68",
    "name": "Hepatopathie bei Gravidität",
    "synonyms": [
      "Akute Schwangerschaftsfettleber",
      "Betreuung der Schwangeren bei Lebererkrankung",
      "Gravidität mit Ikterus",
      "Gravidität mit Lebernekrose",
      "Gravidität mit akuter Hepatitis",
      "Gravidität mit bösartiger Hepatitis",
      "Gravidität mit subakuter Hepatitis",
      "Hepatopathie bei Gravidität",
      "Hepatopathie bei Schwangerschaft",
      "Icterus gravidarum",
      "Leberaffektion bei Gravidität",
      "Leberaffektion bei Schwangerschaft",
      "Leberatrophie mit akutem Ikterus bei Gravidität",
      "Leberatrophie mit akutem Ikterus bei Schwangerschaft",
      "Leberatrophie mit akuter Gelbsucht bei Gravidität",
      "Schwangerschaft mit Ikterus",
      "Schwangerschaft mit Lebernekrose",
      "Schwangerschaft mit akuter Hepatitis",
      "Schwangerschaft mit bösartiger Hepatitis",
      "Schwangerschaft mit subakuter Hepatitis",
      "Spontane Leberruptur als Schwangerschaftskomplikation"
    ]
  },
  {
    "code": "O26.7",
    "name": "Schwangerschaft mit Symphysendehiszenz",
    "synonyms": [
      "Betreuung der Schwangeren bei Symphysenruptur",
      "Schwangerschaft mit Beckenringlockerung",
      "Schwangerschaft mit Symphysendehiszenz",
      "Schwangerschaft mit Symphysendehnung",
      "Schwangerschaft mit Symphysendysfunktion",
      "Schwangerschaft mit Symphysenlockerung",
      "Schwangerschaft mit Symphysenruptur",
      "Schwangerschaft mit Symphysensubluxation"
    ]
  },
  {
    "code": "O26.81",
    "name": "Nephritis bei Gravidität",
    "synonyms": [
      "Gestationsnephrose",
      "Nephritis bei Gravidität",
      "Nephritis bei Schwangerschaft",
      "Nephropathia gravidarum",
      "Nephropathie bei Gravidität",
      "Nephropathie bei Schwangerschaft",
      "Nierenkrankheit bei Gravidität",
      "Nierenrindenkrankheit bei Gravidität",
      "Pyelonephrose bei Gravidität",
      "Pyelonephrose bei Schwangerschaft",
      "Schwangerschaft mit Nierenkrankheit",
      "Schwangerschaftsnephrose",
      "Urämie bei Gravidität",
      "Urämie bei Schwangerschaft"
    ]
  },
  {
    "code": "O26.82",
    "name": "Karpaltunnelsyndrom bei Schwangerschaft",
    "synonyms": [
      "Karpaltunnelsyndrom bei Schwangerschaft"
    ]
  },
  {
    "code": "O26.83",
    "name": "Neuritis bei Gravidität",
    "synonyms": [
      "Neuritis bei Gravidität",
      "Periphere Neuritis bei Gravidität",
      "Schwangerschaftsneuritis"
    ]
  },
  {
    "code": "O26.88",
    "name": "Peritonitis bei Gravidität",
    "synonyms": [
      "Chloasma gravidarum",
      "Ermüdung durch Gravidität",
      "Ermüdung durch Schwangerschaft",
      "Erschöpfung durch Gravidität",
      "Erschöpfung durch Schwangerschaft",
      "Folsäuremangelzustand in der Schwangerschaft",
      "Graviditätspruritus",
      "Hysteralgie des graviden Uterus",
      "Juckreiz in der Schwangerschaft",
      "Peritonitis bei Gravidität",
      "Peritonitis bei Schwangerschaft",
      "Polymorphe Schwangerschaftsdermatose",
      "Prurigo gestationis",
      "Pruritus gravidarum",
      "Ptyalismus bei Gravidität",
      "Ptyalismus bei Schwangerschaft",
      "Ptyalismus gravidarum",
      "Retinitis gravidarum",
      "Schwangerschaftspruritus",
      "Senkwehen",
      "Übermäßige Salivation bei Gravidität",
      "Übermäßige Salivation bei Schwangerschaft"
    ]
  },
  {
    "code": "O26.9",
    "name": "Gravidität mit Komplikation a.n.k.",
    "synonyms": [
      "Anomale Gravidität a.n.k.",
      "Anomale Schwangerschaft a.n.k.",
      "Gestörte Frühgravidität",
      "Gestörte Frühschwangerschaft",
      "Gestörte Schwangerschaft",
      "Gravidität mit Komplikation a.n.k.",
      "Komplizierte Schwangerschaft",
      "Krankheit in der Schwangerschaft a.n.k.",
      "Schwangerschaft mit Komplikation a.n.k.",
      "Schwangerschaftsbeschwerden",
      "Schwangerschaftskomplikation a.n.k."
    ]
  },
  {
    "code": "O28.0",
    "name": "Abnormer hämatologischer Befund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer hämatologischer Befund bei Graviditäts-Screening",
      "Abnormer hämatologischer Befund bei Schwangerschafts-Screening",
      "Abnormer hämatologischer Befund bei pränataler Screeninguntersuchung"
    ]
  },
  {
    "code": "O28.1",
    "name": "Abnormer biochemischer Befund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer biochemischer Befund bei Graviditäts-Screening",
      "Abnormer biochemischer Befund bei Schwangerschafts-Screening",
      "Abnormer biochemischer Befund bei pränataler Screeninguntersuchung"
    ]
  },
  {
    "code": "O28.2",
    "name": "Abnormer zytologischer Befund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer zytologischer Befund bei Graviditäts-Screening",
      "Abnormer zytologischer Befund bei Schwangerschafts-Screening",
      "Abnormer zytologischer Befund bei pränataler Screeninguntersuchung"
    ]
  },
  {
    "code": "O28.3",
    "name": "Abnormer Ultraschallbefund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer Ultraschallbefund bei Graviditäts-Screening",
      "Abnormer Ultraschallbefund bei Schwangerschafts-Screening",
      "Abnormer Ultraschallbefund bei pränataler Screeninguntersuchung"
    ]
  },
  {
    "code": "O28.4",
    "name": "Abnormer radiologischer Befund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer radiologischer Befund bei Graviditäts-Screening",
      "Abnormer radiologischer Befund bei Schwangerschafts-Screening",
      "Abnormer radiologischer Befund bei pränataler Screeninguntersuchung"
    ]
  },
  {
    "code": "O28.5",
    "name": "Abnormer Chromosomenbefund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer Chromosomenbefund bei Graviditäts-Screening",
      "Abnormer Chromosomenbefund bei Schwangerschafts-Screening",
      "Abnormer Chromosomenbefund bei pränataler Screeninguntersuchung",
      "Abnormer genetischer Befund bei Graviditäts-Screening",
      "Abnormer genetischer Befund bei Schwangerschafts-Screening",
      "Abnormer genetischer Befund bei pränataler Screeninguntersuchung"
    ]
  },
  {
    "code": "O28.8",
    "name": "Pathologisches Kardiotokogramm",
    "synonyms": [
      "Auffälliger CTG [Kardiotokogramm]-Befund",
      "CTG [Kardiotokogramm]-Auffälligkeit",
      "Fetaler Oszillationsverlust",
      "Gravidität mit pathologischem Kardiotokogramm",
      "Pathologisches CTG [Kardiotokogramm]",
      "Pathologisches KTG [Kardiotokogramm]",
      "Pathologisches Kardiotokogramm",
      "Schwangerschaft mit pathologischem Kardiotokogramm"
    ]
  },
  {
    "code": "O28.9",
    "name": "Abnormer Befund bei Graviditäts-Screening",
    "synonyms": [
      "Abnormer Befund bei Graviditäts-Screening",
      "Abnormer Befund bei Schwangerschafts-Screening"
    ]
  },
  {
    "code": "O29.0",
    "name": "Mendelson-Syndrom in der Schwangerschaft",
    "synonyms": [
      "Aspiration von Mageninhalt durch Anästhesie während der Schwangerschaft",
      "Aspiration von Magensekret durch Anästhesie während der Schwangerschaft",
      "Aspirationspneumonie durch Anästhesie während der Schwangerschaft",
      "Chemische Pneumonitis durch Aspiration bei Anästhesie während der Schwangerschaft",
      "Mendelson-Syndrom durch Anästhesie während der Schwangerschaft",
      "Mendelson-Syndrom in der Schwangerschaft",
      "Pneumonie durch Anästhesie während der Schwangerschaft",
      "Pneumothorax durch Anästhesie während der Schwangerschaft",
      "Pulmonale Komplikation durch Anästhesie während der Schwangerschaft"
    ]
  },
  {
    "code": "O29.1",
    "name": "Herzstillstand durch Anästhesie während der Schwangerschaft",
    "synonyms": [
      "Herzstillstand durch Anästhesie während der Schwangerschaft",
      "Herzversagen durch Anästhesie während der Schwangerschaft",
      "Kardiale Komplikation durch Anästhesie während der Schwangerschaft"
    ]
  },
  {
    "code": "O29.2",
    "name": "Zerebrale Anoxie durch Anästhesie während der Schwangerschaft",
    "synonyms": [
      "Komplikation des Zentralnervensystems durch Anästhesie während der Schwangerschaft",
      "Zerebrale Anoxie durch Anästhesie während der Schwangerschaft"
    ]
  },
  {
    "code": "O29.3",
    "name": "Toxische Reaktion auf Lokalanästhesie bei Schwangerschaft",
    "synonyms": [
      "Toxische Reaktion auf Lokalanästhesie bei Schwangerschaft"
    ]
  },
  {
    "code": "O29.4",
    "name": "Kopfschmerzen nach Spinal- oder Periduralanästhesie in der Schwangerschaft",
    "synonyms": [
      "Kopfschmerzen nach Spinal- oder Periduralanästhesie in der Schwangerschaft"
    ]
  },
  {
    "code": "O29.5",
    "name": "Komplikation durch Spinal- und Periduralanästhesie in der Schwangerschaft a.n.k.",
    "synonyms": [
      "Komplikation durch Spinal- und Periduralanästhesie in der Schwangerschaft a.n.k."
    ]
  },
  {
    "code": "O29.6",
    "name": "Schwierigkeiten bei der Intubation in der Schwangerschaft",
    "synonyms": [
      "Misslingen der Intubation in der Schwangerschaft",
      "Schwierigkeiten bei der Intubation in der Schwangerschaft"
    ]
  },
  {
    "code": "O29.9",
    "name": "Komplikation durch Verabreichung eines Allgemeinanästhetikums während der Schwangerschaft",
    "synonyms": [
      "Komplikation durch Verabreichung eines Allgemeinanästhetikums während der Schwangerschaft",
      "Komplikation durch Verabreichung eines Analgetikums während der Schwangerschaft",
      "Komplikation durch Verabreichung eines Lokalanästhetikums während der Schwangerschaft",
      "Komplikation durch eine Beruhigungsmaßnahme während der Schwangerschaft",
      "Tod durch Anästhesie während der Schwangerschaft"
    ]
  },
  {
    "code": "O30.0",
    "name": "Betreuung einer Gemini-Schwangerschaft",
    "synonyms": [
      "Betreuung einer Gemini-Schwangerschaft",
      "Betreuung einer Zwillingsschwangerschaft",
      "Dichoreale und diamniale Zwillingsgravidität",
      "Dichoreale und diamniale Zwillingsschwangerschaft",
      "Gemini-Gravidität",
      "Gemini-Schwangerschaft",
      "Zwillingsgravidität",
      "Zwillingsschwangerschaft"
    ]
  },
  {
    "code": "O30.1",
    "name": "Drillingsschwangerschaft",
    "synonyms": [
      "Betreuung einer Drillingsschwangerschaft",
      "Drillingsgravidität",
      "Drillingsschwangerschaft"
    ]
  },
  {
    "code": "O30.2",
    "name": "Vierlingsschwangerschaft",
    "synonyms": [
      "Betreuung einer Vierlingsschwangerschaft",
      "Vierlingsgravidität",
      "Vierlingsschwangerschaft"
    ]
  },
  {
    "code": "O30.8",
    "name": "Fünflingsschwangerschaft",
    "synonyms": [
      "Fünflingsgravidität",
      "Fünflingsschwangerschaft",
      "Mehrkeimige Gravidität a.n.k.",
      "Mehrkeimige Schwangerschaft a.n.k.",
      "Multiple Gravidität a.n.k.",
      "Multiple Schwangerschaft a.n.k.",
      "Sechslingsgravidität",
      "Sechslingsschwangerschaft",
      "Superfecundatio",
      "Superfekundation",
      "Superfekundation bei Gravidität",
      "Superfekundation bei Schwangerschaft",
      "Superfetation",
      "Superfetation bei Gravidität",
      "Superfetation bei Schwangerschaft"
    ]
  },
  {
    "code": "O30.9",
    "name": "Mehrlingsschwangerschaft a.n.k.",
    "synonyms": [
      "Betreuung einer Mehrlingsschwangerschaft",
      "Mehrlingsgravidität a.n.k.",
      "Mehrlingsschwangerschaft a.n.k."
    ]
  },
  {
    "code": "O31.0",
    "name": "Fetus papyraceus bei Mehrlingsschwangerschaft",
    "synonyms": [
      "Betreuung der Mutter bei Fetus compressus",
      "Betreuung der Mutter bei Fetus papyraceus",
      "Fetus papyraceus bei Gravidität",
      "Fetus papyraceus bei Mehrlingsschwangerschaft",
      "Fetus papyraceus bei Schwangerschaft",
      "Schwangerschaftskomplikation durch Pergamentkind"
    ]
  },
  {
    "code": "O31.1",
    "name": "Fortbestehen der Gravidität nach Fehlgeburt eines oder mehrerer Feten",
    "synonyms": [
      "Fortbestehen der Gravidität nach Fehlgeburt eines oder mehrerer Feten",
      "Fortbestehen der Schwangerschaft nach Fehlgeburt eines oder mehrerer Feten"
    ]
  },
  {
    "code": "O31.2",
    "name": "Fortbestehen der Gravidität nach intrauterinem Absterben eines oder mehrerer Feten",
    "synonyms": [
      "Fortbestehen der Gravidität nach intrauterinem Absterben eines oder mehrerer Feten",
      "Fortbestehen der Schwangerschaft nach intrauterinem Absterben eines oder mehrerer Feten"
    ]
  },
  {
    "code": "O32.0",
    "name": "Betreuung der Schwangeren bei wechselnder Kindslage",
    "synonyms": [
      "Betreuung der Mutter bei wechselnder Kindslage",
      "Betreuung der Schwangeren bei wechselnder Kindslage",
      "Gravida-Betreuung bei wechselnder Kindslage",
      "Wechselnde Lage des Fetus",
      "Wechselnde Lage des Fetus bei Gravidität",
      "Wechselnde Lage des Fetus bei Schwangerschaft"
    ]
  },
  {
    "code": "O32.1",
    "name": "Betreuung der Schwangeren bei Beckenendlage",
    "synonyms": [
      "Beckenendlage des Fetus",
      "Beinvorfall als Entbindungskomplikation",
      "Betreuung der Mutter bei Beckenendlage",
      "Betreuung der Mutter bei Beinprolaps",
      "Betreuung der Mutter bei Beinvorfall",
      "Betreuung der Schwangeren bei Beckenendlage",
      "Betreuung der Schwangeren bei Steißlage",
      "Fußvorfall als Entbindungskomplikation",
      "Gravida-Betreuung bei Beckenendlage",
      "Schnittentbindung bei Beckenendlage",
      "Schnittentbindung bei Steißlage",
      "Steißlage des Fetus",
      "Steißlage mit Wendung des Fetus"
    ]
  },
  {
    "code": "O32.2",
    "name": "Betreuung der Schwangeren bei Querlage",
    "synonyms": [
      "Armvorfall als Entbindungskomplikation",
      "Betreuung der Mutter bei Armprolaps des Fetus",
      "Betreuung der Mutter bei Armvorfall des Fetus",
      "Betreuung der Mutter bei Handprolaps des Fetus",
      "Betreuung der Schwangeren bei Querlage",
      "Betreuung der Schwangeren bei Schräglage",
      "Betreuung der Schwangeren bei Schulterlage",
      "Gravida-Betreuung bei Querlage",
      "Gravida-Betreuung bei Schräglage",
      "Gravida-Betreuung bei Schulterlage",
      "Handvorfall als Entbindungskomplikation",
      "Querlage des Fetus",
      "Schnittentbindung bei Armprolaps",
      "Schnittentbindung bei Armvorfall",
      "Schnittentbindung bei Handvorfall",
      "Schnittentbindung bei Querlage",
      "Schnittentbindung bei Schräglage",
      "Schnittentbindung bei Schulterlage",
      "Schräglage des Fetus a.n.k."
    ]
  },
  {
    "code": "O32.3",
    "name": "Gravida-Betreuung bei Stirnlage",
    "synonyms": [
      "Betreuung der Schwangeren bei Gesichtslage",
      "Betreuung der Schwangeren bei Kinnlage",
      "Betreuung der Schwangeren bei Stirnlage",
      "Betreuung der Schwangeren bei Vorderhauptslage",
      "Gesicht-Stirnlage des Fetus",
      "Gesichtslage des Fetus a.n.k.",
      "Gravida-Betreuung bei Gesichtslage",
      "Gravida-Betreuung bei Kinnlage",
      "Gravida-Betreuung bei Stirnlage",
      "Gravidität mit Kinnlage",
      "Kinnlage des Fetus a.n.k.",
      "Schnittentbindung bei Gesichtslage",
      "Schnittentbindung bei Kinnlage",
      "Schnittentbindung bei Stirnlage",
      "Schwangerschaft mit Kinnlage"
    ]
  },
  {
    "code": "O32.4",
    "name": "Betreuung der Schwangeren bei Nichteintreten des Kopfes beim Termin",
    "synonyms": [
      "Betreuung der Schwangeren bei Nichteintreten des Kopfes beim Termin",
      "Betreuung der Schwangeren bei fehlendem Kopfeintritt",
      "Gravida-Betreuung bei fehlendem Kopfeintritt",
      "Schnittentbindung bei Nichteintreten des Kopfes beim Termin"
    ]
  },
  {
    "code": "O32.5",
    "name": "Mehrlingsschwangerschaft mit Lageanomalie",
    "synonyms": [
      "Mehrlingsschwangerschaft mit Lageanomalie",
      "Schnittentbindung bei Mehrlingsschwangerschaft mit Lageanomalie"
    ]
  },
  {
    "code": "O32.6",
    "name": "Betreuung der Schwangeren bei Steiß-Fuß-Lage",
    "synonyms": [
      "Betreuung der Schwangeren bei Steiß-Fuß-Lage",
      "Steiß-Fuß-Lage"
    ]
  },
  {
    "code": "O32.8",
    "name": "Betreuung der Schwangeren bei Scheitellage",
    "synonyms": [
      "Betreuung der Schwangeren bei Scheitelbeineinstellung",
      "Betreuung der Schwangeren bei Scheitellage",
      "Betreuung der Schwangeren bei Schulterquerstand",
      "Betreuung der Schwangeren bei hinterer Hinterhauptslage",
      "Betreuung der Schwangeren bei hohem Geradstand",
      "Betreuung der Schwangeren bei tiefem Geradstand",
      "Betreuung der Schwangeren bei tiefem Querstand",
      "Gravida-Betreuung bei hohem Geradstand",
      "Gravida-Betreuung bei tiefem Geradstand",
      "Hohe Kopfeinstellung des Fetus",
      "Prolaps fetaler Gliedmaßen a.n.k.",
      "Vorfall fetaler Gliedmaßen a.n.k."
    ]
  },
  {
    "code": "O32.9",
    "name": "Betreuung der Schwangeren bei Lageanomalie des Fetus",
    "synonyms": [
      "Abnorme Einstellung des Fetus",
      "Abnorme Lage des Fetus",
      "Anomale Kindslage vor Eintritt der Wehen",
      "Betreuung der Schwangeren bei Einstellungsanomalie des Fetus",
      "Betreuung der Schwangeren bei Lageanomalie des Fetus",
      "Einstellungsanomalie des Fetus a.n.k.",
      "Fetale Lageanomalie",
      "Gravida-Betreuung bei Einstellungsanomalie des Fetus",
      "Gravida-Betreuung bei Lageanomalie des Fetus",
      "Gravidität mit Lageanomalie des Fetus",
      "Haltungsanomalie des Fetus a.n.k.",
      "Lageanomalie des Fetus a.n.k.",
      "Regelwidrige Kindslage",
      "Schnittentbindung bei Einstellungsanomalie des Fetus a.n.k.",
      "Schnittentbindung bei Lageanomalie",
      "Schnittentbindung bei Lageanomalie des Fetus",
      "Schnittentbindung bei anomaler Kindslage a.n.k.",
      "Schwangerschaft mit Lageanomalie des Fetus"
    ]
  },
  {
    "code": "O33.0",
    "name": "Abnormität des Beckenknochens bei Gravidität",
    "synonyms": [
      "Abnormität der Beckenknochen bei Schwangerschaft",
      "Abnormität des Beckenknochens bei Gravidität",
      "Androides Becken mit fetopelvinem Missverhältnis",
      "Anthropoides Becken mit fetopelvinem Missverhältnis",
      "Beckenanomalie bei Gravidität",
      "Beckenanomalie bei Schwangerschaft",
      "Beckenasymmetrie mit fetopelvinem Missverhältnis",
      "Beckendeformität bei Gravidität",
      "Beckendeformität bei Schwangerschaft",
      "Beckendeformität mit fetopelvinem Missverhältnis",
      "Betreuung der Mutter bei Beckendeformität",
      "Betreuung der Mutter bei Deformität des mütterlichen knöchernen Beckens",
      "Flaches Becken mit fetopelvinem Missverhältnis",
      "Naegele-Becken mit fetopelvinem Missverhältnis",
      "Pithekoides Becken mit fetopelvinem Missverhältnis",
      "Robert-Becken mit fetopelvinem Missverhältnis",
      "Schnittentbindung bei Beckendeformität a.n.k."
    ]
  },
  {
    "code": "O33.1",
    "name": "Pelvis angusta mit Gravidität",
    "synonyms": [
      "Beckenverengung mit fetopelvinem Missverhältnis",
      "Betreuung der Mutter bei Beckenverengung",
      "Betreuung der Schwangeren bei allgemein verengtem Becken",
      "Enges Becken mit Gravidität",
      "Enges Becken mit Schwangerschaft",
      "Enges Becken mit fetopelvinem Missverhältnis",
      "Pelvis angusta mit Gravidität",
      "Pelvis angusta mit Schwangerschaft",
      "Schmales Becken mit fetopelvinem Missverhältnis",
      "Schnittentbindung bei allgemein verengtem Becken"
    ]
  },
  {
    "code": "O33.2",
    "name": "Beckeneingangsverengung bei Gravidität",
    "synonyms": [
      "Beckeneingangskontraktur mit fetopelvinem Missverhältnis",
      "Beckeneingangsverengung bei Gravidität",
      "Beckeneingangsverengung bei Schwangerschaft",
      "Betreuung der Mutter bei Beckeneingangsverengung",
      "Schnittentbindung bei verengtem Beckeneingang"
    ]
  },
  {
    "code": "O33.3",
    "name": "Beckenausgangsverengung bei Gravidität",
    "synonyms": [
      "Beckenausgangskontraktur mit fetopelvinem Missverhältnis",
      "Beckenausgangsverengung bei Gravidität",
      "Beckenausgangsverengung bei Schwangerschaft",
      "Beckenmittenkontraktur mit fetopelvinem Missverhältnis",
      "Betreuung der Mutter bei Beckenausgangsverengung",
      "Betreuung der Mutter bei Beckenmittenverengung",
      "Schnittentbindung bei verengtem Beckenausgang",
      "Spondylolisthesis mit fetopelvinem Missverhältnis",
      "Spondylose mit fetopelvinem Missverhältnis",
      "Trichterbecken mit fetopelvinem Missverhältnis"
    ]
  },
  {
    "code": "O33.4",
    "name": "Missverhältnis bei kombinierter mütterlicher und fetaler Ursache",
    "synonyms": [
      "Missverhältnis bei kombinierter mütterlicher und fetaler Ursache"
    ]
  },
  {
    "code": "O33.5",
    "name": "Missverhältnis durch großen Fetus",
    "synonyms": [
      "Betreuung der Mutter bei ungewöhnlich großem Fetus",
      "Betreuung der Schwangeren bei fetalem Missverhältnis",
      "Fetale Makrosomie",
      "Gravida-Betreuung bei fetalem Missverhältnis",
      "Missverhältnis durch großen Fetus",
      "Missverhältnis durch Übergröße des Fetus",
      "Missverhältnis fetaler Ursache bei normal ausgebildetem Fetus",
      "Schnittentbindung bei ungewöhnlich großem Fetus"
    ]
  },
  {
    "code": "O33.6",
    "name": "Missverhältnis durch fetalen Hydrozephalus",
    "synonyms": [
      "Fetopelvines Missverhältnis durch Hydrozephalus des Fetus",
      "Missverhältnis durch fetalen Hydrozephalus",
      "Schnittentbindung bei Hydrozephalus des Fetus"
    ]
  },
  {
    "code": "O33.7",
    "name": "Betreuung der Mutter bei fetaler Doppelfehlbildung",
    "synonyms": [
      "Betreuung der Mutter bei Fetusdeformität a.n.k.",
      "Betreuung der Mutter bei fetalem Aszites",
      "Betreuung der Mutter bei fetalem Steißteratom",
      "Betreuung der Mutter bei fetalem Tumor",
      "Betreuung der Mutter bei fetaler Doppelfehlbildung",
      "Betreuung der Mutter bei fetaler Myelomeningozele",
      "Betreuung der Mutter bei zusammengewachsenen Zwillingen",
      "Betreuung der Schwangeren bei fetaler Deformität",
      "Fetale Deformität mit Missverhältnis zwischen Becken und Frucht",
      "Fetopelvines Missverhältnis durch zusammengewachsene Zwillinge",
      "Gravida-Betreuung bei fetaler Deformität"
    ]
  },
  {
    "code": "O33.8",
    "name": "Distorsion der Lendenwirbelsäule mit Missverhältnis zwischen Fetus und Becken",
    "synonyms": [
      "Distorsion der Lendenwirbelsäule mit Missverhältnis zwischen Fetus und Becken",
      "Verformung der Lendenwirbelsäule mit Missverhältnis zwischen Fetus und Becken"
    ]
  },
  {
    "code": "O33.9",
    "name": "Gravida-Betreuung bei Kopf-Becken-Missverhältnis",
    "synonyms": [
      "Becken-Schädel-Missverhältnis",
      "Betreuung der Schwangeren bei Kopf-Becken-Missverhältnis",
      "Fetopelvines Missverhältnis",
      "Gravida-Betreuung bei Kopf-Becken-Missverhältnis",
      "Missverhältnis zwischen Fetus und Becken",
      "Missverhältnis zwischen Kopf und Becken",
      "Schnittentbindung bei fetopelvinem Missverhältnis"
    ]
  },
  {
    "code": "O34.0",
    "name": "Betreuung der Schwangeren bei Uterus bicornis",
    "synonyms": [
      "Angeborene Uterusfehlbildung bei Gravidität",
      "Angeborene Uterusfehlbildung bei Schwangerschaft",
      "Betreuung der Schwangeren bei Uterus bicornis",
      "Betreuung der Schwangeren bei Uterus duplex",
      "Betreuung der Schwangeren bei Uterusfehlbildung",
      "Doppelter Uterus bei Entbindung",
      "Doppelter Uterus bei Schwangerschaft",
      "Gravida-Betreuung bei Uterus bicornis",
      "Gravida-Betreuung bei Uterus duplex",
      "Gravida-Betreuung bei Uterusfehlbildung",
      "Kongenitale Uterusanomalie bei Gravidität",
      "Kongenitale Uterusanomalie bei Schwangerschaft",
      "Schnittentbindung bei kongenital abnormem Uterus",
      "Uterus bicornis bei Gravidität",
      "Uterus bicornis bei Schwangerschaft",
      "Uterus duplex bei Gravidität",
      "Uterus duplex bei Schwangerschaft"
    ]
  },
  {
    "code": "O34.1",
    "name": "Betreuung der Schwangeren bei Tumor des Corpus uteri",
    "synonyms": [
      "Betreuung der Mutter bei Polyp des Corpus uteri",
      "Betreuung der Mutter bei Tumor des Corpus uteri",
      "Betreuung der Mutter bei Uterusleiomyom",
      "Betreuung der Schwangeren bei Tumor des Corpus uteri",
      "Deziduapolyp",
      "Entbindung bei Fibroid",
      "Fibromyom des Uterus bei Entbindung",
      "Fibromyom des Uterus bei Schwangerschaft",
      "Schwangerschaft mit Fibroid",
      "Uterusfibrom bei Gravidität",
      "Uterusfibrom bei Schwangerschaft",
      "Uterusmyom bei Gravidität",
      "Uterusmyom bei Schwangerschaft",
      "Uterustumor bei Gravidität",
      "Uterustumor bei Schwangerschaft"
    ]
  },
  {
    "code": "O34.2",
    "name": "Uterusnarbe durch früheren Eingriff",
    "synonyms": [
      "Betreuung der Mutter bei Narbe durch vorangegangene Schnittentbindung",
      "Betreuung der Mutter bei Uterusnarbe durch vorangegangenen chirurgischen Eingriff",
      "Betreuung der Schwangeren bei vorausgegangener Sektio",
      "Entbindungskomplikation durch vorangegangenen chirurgischen Eingriff am Uterus",
      "Frühere Schnittentbindung",
      "Gravida-Betreuung bei vorausgegangener Sektio",
      "Schnittentbindung bei Uterusnarbe",
      "Uterusnarbe bei Entbindung",
      "Uterusnarbe bei Schwangerschaft",
      "Uterusnarbe durch früheren Eingriff"
    ]
  },
  {
    "code": "O34.31",
    "name": "Betreuung der Mutter bei Fruchtblasenprolaps",
    "synonyms": [
      "Betreuung der Mutter bei Fruchtblasenprolaps"
    ]
  },
  {
    "code": "O34.39",
    "name": "Betreuung der Schwangeren bei Zervixinsuffizienz",
    "synonyms": [
      "Betreuung der Mutter bei Cerclage",
      "Betreuung der Mutter bei Cerclage mit Insuffizienz der Cervix uteri",
      "Betreuung der Mutter bei Cerclage mit Zervixinsuffizienz",
      "Betreuung der Mutter bei Shirodkar-Naht",
      "Betreuung der Mutter bei Shirodkar-Naht mit Insuffizienz der Cervix uteri",
      "Betreuung der Mutter bei Shirodkar-Naht mit Zervixinsuffizienz",
      "Betreuung der Schwangeren bei Cerclage",
      "Betreuung der Schwangeren bei Insuffizienz der Cervix uteri",
      "Betreuung der Schwangeren bei Shirodkar-Naht",
      "Betreuung der Schwangeren bei Zervixinsuffizienz",
      "Cerclage bei Insuffizienz der Cervix uteri während der Schwangerschaft",
      "Cerclage bei Zervixinsuffizienz während der Schwangerschaft",
      "Gravida-Betreuung bei Cerclage",
      "Gravida-Betreuung bei Shirodkar-Naht",
      "Gravida-Betreuung bei Zervixinsuffizienz",
      "Gravidität mit Zervixinsuffizienz",
      "Schnittentbindung bei Cerclage",
      "Schnittentbindung bei Shirodkar-Naht",
      "Schwangerschaft mit Insuffizienz der Cervix uteri",
      "Schwangerschaft mit Zervixinsuffizienz",
      "Schwangerschaftskomplikation durch Dilatation der Cervix uteri",
      "Schwangerschaftskomplikation durch Zervixdilatation",
      "Shirodkar-Naht bei Schwangerschaft",
      "Verschlussunfähigkeit der Cervix uteri bei Gravidität",
      "Verschlussunfähigkeit der Cervix uteri bei Schwangerschaft",
      "Verschlussunfähigkeit der Zervix bei Gravidität"
    ]
  },
  {
    "code": "O34.4",
    "name": "Zervixpolyp bei Gravidität",
    "synonyms": [
      "Abnormität der Cervix uteri bei Schwangerschaft a.n.k.",
      "Amputation der Cervix uteri als Schwangerschaftskomplikation",
      "Anomalie der Cervix uteri bei Gravidität",
      "Anomalie der Cervix uteri bei Schwangerschaft",
      "Betreuung der Mutter bei Polyp der Cervix uteri",
      "Betreuung der Mutter bei Stenose der Cervix uteri",
      "Betreuung der Mutter bei Striktur der Cervix uteri",
      "Betreuung der Mutter bei Tumor der Cervix uteri",
      "Betreuung der Mutter bei vorangegangenem chirurgischen Eingriff an der Cervix uteri",
      "Betreuung der Schwangeren bei Anomalie der Cervix uteri",
      "Betreuung der Schwangeren bei Zervixanomalie",
      "Gravida-Betreuung bei Zervixanomalie",
      "Narbe der Cervix uteri als Schwangerschaftskomplikation",
      "Polyp der Cervix uteri bei Gravidität",
      "Polyp der Cervix uteri bei Schwangerschaft",
      "Schnittentbindung bei Narbe der Cervix uteri",
      "Schnittentbindung bei Polyp der Cervix uteri",
      "Schnittentbindung bei Stenose der Cervix uteri",
      "Schnittentbindung bei Striktur der Cervix uteri",
      "Schnittentbindung bei Tumor der Cervix uteri",
      "Schnittentbindung bei Zervixnarbe",
      "Schnittentbindung bei Zervixpolyp",
      "Schnittentbindung bei Zervixtumor",
      "Schnittentbindung bei abnormer Cervix uteri",
      "Schnittentbindung bei abnormer Zervix",
      "Schnittentbindung bei rigider Cervix uteri",
      "Schnittentbindung bei rigider Zervix",
      "Schwangerschaftskomplikation durch Atresie der Cervix uteri",
      "Schwangerschaftskomplikation durch Dysplasie der Cervix uteri",
      "Schwangerschaftskomplikation durch Stenose der Cervix uteri",
      "Schwangerschaftskomplikation durch Zervixstenose",
      "Striktur der Cervix uteri bei Entbindung",
      "Striktur der Cervix uteri bei Schwangerschaft",
      "Tumor der Cervix uteri bei Gravidität",
      "Tumor der Cervix uteri bei Schwangerschaft",
      "Zervixabnormität bei Schwangerschaft a.n.k.",
      "Zervixanomalie bei Gravidität",
      "Zervixpolyp bei Gravidität",
      "Zervixstriktur bei Entbindung",
      "Zervixstriktur bei Schwangerschaft",
      "Zervixtumor bei Gravidität",
      "Zervixtumor bei Schwangerschaft"
    ]
  },
  {
    "code": "O34.5",
    "name": "Betreuung der Schwangeren bei Uterusanomalie",
    "synonyms": [
      "Betreuung der Mutter bei Inkarzeration des graviden Uterus",
      "Betreuung der Mutter bei Prolaps des graviden Uterus",
      "Betreuung der Mutter bei Retroversion des graviden Uterus",
      "Betreuung der Schwangeren bei Retroflexio uteri",
      "Betreuung der Schwangeren bei Uterusanomalie",
      "Descensus uteri bei Schwangerschaft",
      "Eingeklemmter Uterus durch Gravidität",
      "Eingeklemmter Uterus durch Schwangerschaft",
      "Gravida-Betreuung bei Retroflexio uteri",
      "Gravida-Betreuung bei Uterusanomalie",
      "Gravidität mit Lageanomalie des Uterus",
      "Hernie des graviden Uterus",
      "Hysterozele bei Gravidität",
      "Hysterozele bei Schwangerschaft",
      "Infantiler Uterus als Entbindungskomplikation",
      "Retroversio uteri bei Entbindung",
      "Retroversio uteri bei Schwangerschaft",
      "Retrovertierter Uterus durch Gravidität",
      "Retrovertierter Uterus durch Schwangerschaft",
      "Sackartige Ausstülpung des graviden Uterus als Entbindungskomplikation",
      "Schnittentbindung bei Anteversio uteri",
      "Schnittentbindung bei Lageanomalie des Uterus a.n.k.",
      "Schnittentbindung bei Lateroversion des Uterus",
      "Schnittentbindung bei Sackbildung am graviden Uterus",
      "Schnittentbindung bei Uterusinkarzeration",
      "Schnittentbindung bei Uterusretroversion",
      "Schnittentbindung bei Uterusverlagerung a.n.k.",
      "Schnittentbindung bei Uterusvorfall",
      "Schwangerschaft mit Lageanomalie des Uterus",
      "Uterusanteversion bei Entbindung",
      "Uterusanteversion bei Schwangerschaft",
      "Uterusinkarzeration bei Gravidität",
      "Uterusinkarzeration bei Schwangerschaft",
      "Uterusprolaps bei Gravidität",
      "Uterusprolaps bei Schwangerschaft",
      "Uterustorsion bei Gravidität",
      "Uterustorsion bei Schwangerschaft",
      "Uterusverlagerung bei Gravidität a.n.k.",
      "Uterusverlagerung bei Schwangerschaft a.n.k.",
      "Uterusvorfall als Entbindungskomplikation"
    ]
  },
  {
    "code": "O34.6",
    "name": "Betreuung der Schwangeren bei Anomalie der Vagina",
    "synonyms": [
      "Betreuung der Mutter bei Vaginalseptum",
      "Betreuung der Mutter bei Vaginalstenose",
      "Betreuung der Mutter bei Vaginalstriktur",
      "Betreuung der Mutter bei Vaginaltumor",
      "Betreuung der Mutter bei vorangegangenem chirurgischen Eingriff an der Vagina",
      "Betreuung der Schwangeren bei Anomalie der Vagina",
      "Entbindungskomplikation durch vorangegangenen chirurgischen Eingriff an der Vagina",
      "Gravida-Betreuung bei Vaginaanomalie",
      "Schnittentbindung bei abnormer Vagina",
      "Schnittentbindung bei rigider Vagina",
      "Schwangerschaftskomplikation durch Vaginalstenose",
      "Vaginalabnormität bei Gravidität",
      "Vaginalabnormität bei Schwangerschaft",
      "Vaginaltumor bei Schwangerschaft"
    ]
  },
  {
    "code": "O34.7",
    "name": "Gravida-Betreuung bei Perineumanomalie",
    "synonyms": [
      "Betreuung der Mutter bei Perineumfibrose",
      "Betreuung der Mutter bei Rigidität des Perineums",
      "Betreuung der Mutter bei Vulvatumor",
      "Betreuung der Mutter bei vorangegangenem chirurgischen Eingriff am Perineum",
      "Betreuung der Mutter bei vorangegangenem chirurgischen Eingriff an der Vulva",
      "Betreuung der Schwangeren bei Perineumanomalie",
      "Betreuung der Schwangeren bei Vulvaanomalie",
      "Entbindungskomplikation durch vorangegangenen chirurgischen Eingriff am Perineum",
      "Entbindungskomplikation durch vorangegangenen chirurgischen Eingriff an der Vulva",
      "Gravida-Betreuung bei Perineumanomalie",
      "Gravida-Betreuung bei Vulvaanomalie",
      "Perineumanomalie bei Gravidität",
      "Perineumanomalie bei Schwangerschaft",
      "Perineumfibrose bei Schwangerschaft",
      "Perineumtumor bei Schwangerschaft",
      "Persistierendes Hymen bei Schwangerschaft",
      "Schnittentbindung bei abnormer Vulva",
      "Schnittentbindung bei rigidem Perineum",
      "Schnittentbindung bei rigider Vulva",
      "Vulvaabnormität bei Gravidität",
      "Vulvaabnormität bei Schwangerschaft",
      "Vulvatumor bei Schwangerschaft"
    ]
  },
  {
    "code": "O34.8",
    "name": "Beckenbodeninsuffizienz bei Schwangerschaft",
    "synonyms": [
      "Abnorme Lage des graviden Uterus",
      "Beckenbodeninsuffizienz bei Schwangerschaft",
      "Beckenbodenplastik bei Schwangerschaft",
      "Beckenbodenrigidität bei Entbindung",
      "Beckenbodenrigidität bei Schwangerschaft",
      "Beckentumor bei Schwangerschaft",
      "Betreuung der Mutter bei Hängebauch",
      "Betreuung der Mutter bei Rektozele",
      "Betreuung der Mutter bei Rigidität des Beckenbodens",
      "Betreuung der Mutter bei Zystozele",
      "Betreuung der Mutter bei vorangegangener Beckenbodenplastik",
      "Entbindungskomplikation nach vorangegangenem gynäkologischen chirurgischer Eingriff a.n.k.",
      "Hängebauch bei Schwangerschaft",
      "Infantile Genitalien als Entbindungskomplikation",
      "Ovarialzyste bei Entbindung",
      "Ovarialzyste bei Schwangerschaft",
      "Ovartumor bei Gravidität",
      "Ovartumor bei Schwangerschaft",
      "Pendelndes Abdomen bei Schwangerschaft",
      "Rektozele bei Schwangerschaft",
      "Schnittentbindung bei Beckentumor a.n.k.",
      "Schnittentbindung bei Deformität der Beckenorgane a.n.k.",
      "Schnittentbindung bei Deformität des Beckenbindegewebes a.n.k.",
      "Schnittentbindung bei Lageanomalie der Beckenorgane a.n.k.",
      "Schnittentbindung bei Lageanomalie des Beckenbindegewebes a.n.k.",
      "Schnittentbindung bei Rektozele",
      "Schnittentbindung bei Tumor der Beckenorgane a.n.k.",
      "Schnittentbindung bei Tumor des Beckengewebes a.n.k.",
      "Schnittentbindung bei Zystozele",
      "Schnittentbindung bei rigidem Beckenboden",
      "Stromaler Ovartumor bei Entbindung",
      "Stromaler Ovartumor bei Schwangerschaft",
      "Zyste des weiblichen Beckens bei Entbindung",
      "Zyste des weiblichen Beckens bei Schwangerschaft",
      "Zystozele bei Entbindung",
      "Zystozele bei Gravidität",
      "Zystozele bei Schwangerschaft"
    ]
  },
  {
    "code": "O34.9",
    "name": "Abnormität der Beckenweichteile bei Gravidität",
    "synonyms": [
      "Abnormität der Beckenweichteile bei Gravidität",
      "Abnormität der Beckenweichteile bei Schwangerschaft",
      "Betreuung der Schwangeren bei Anomalie der Beckenorgane",
      "Fehlbildung der Beckenorgane bei Entbindung",
      "Fehlbildung der Beckenorgane bei Schwangerschaft",
      "Fehlbildung des Beckengewebes bei Entbindung",
      "Fehlbildung des Beckengewebes bei Schwangerschaft",
      "Gravida-Betreuung bei Anomalie der Beckenorgane"
    ]
  },
  {
    "code": "O35.0",
    "name": "Gravida-Betreuung bei Hydrozephalus des Fetus",
    "synonyms": [
      "Betreuung der Mutter bei Anenzephalus des Fetus",
      "Betreuung der Mutter bei Hydrozephalus des Fetus",
      "Betreuung der Mutter bei Spina bifida des Fetus",
      "Betreuung der Mutter bei fetaler Anenzephalie",
      "Betreuung der Mutter bei offenem Rücken beim Fetus",
      "Betreuung der Schwangeren bei Fehlbildung des Zentralnervensystems des Fetus",
      "Betreuung der Schwangeren bei fetalem Anenzephalus",
      "Betreuung der Schwangeren bei fetalem Hydrozephalus",
      "Betreuung der Schwangeren bei fetaler Missbildung des Zentralnervensystems",
      "Betreuung der Schwangeren bei fetaler Spina bifida",
      "Gravida-Betreuung bei Fehlbildung des Zentralnervensystems des Fetus",
      "Gravida-Betreuung bei Hydrozephalus des Fetus",
      "Gravida-Betreuung bei fetalem Anenzephalus",
      "Gravida-Betreuung bei fetalem Hydrozephalus",
      "Gravida-Betreuung bei fetaler Spina bifida"
    ]
  },
  {
    "code": "O35.1",
    "name": "Betreuung der Schwangeren bei fetalem Down-Syndrom",
    "synonyms": [
      "Betreuung der Schwangeren bei Chromosomenanomalie des Fetus",
      "Betreuung der Schwangeren bei fetalem Down-Syndrom",
      "Gravida-Betreuung bei Chromosomenanomalie des Fetus"
    ]
  },
  {
    "code": "O35.2",
    "name": "Betreuung der Schwangeren bei fetalem Schaden durch hereditäre Krankheit",
    "synonyms": [
      "Betreuung der Schwangeren bei fetalem Schaden durch hereditäre Krankheit",
      "Gravida-Betreuung bei fetalem Schaden durch hereditäre Krankheit"
    ]
  },
  {
    "code": "O35.3",
    "name": "Betreuung der Mutter bei Fetusschädigung durch mütterliche Röteln",
    "synonyms": [
      "Betreuung der Mutter bei Fetusschädigung durch mütterliche Röteln",
      "Betreuung der Mutter bei Fetusschädigung durch mütterliche Viruskrankheit",
      "Betreuung der Mutter bei Fetusschädigung durch mütterliche Zytomegalie",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch mütterliche Röteln",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch mütterliche Zytomegalie"
    ]
  },
  {
    "code": "O35.4",
    "name": "Betreuung der Mutter bei Fetusschädigung durch Alkohol",
    "synonyms": [
      "Betreuung der Mutter bei Fetusschädigung durch Alkohol",
      "Betreuung der Schwangeren bei Fetusschädigung durch Alkohol",
      "Gravida-Betreuung bei Fetusschädigung durch Alkohol"
    ]
  },
  {
    "code": "O35.5",
    "name": "Betreuung der Mutter bei Fetusschädigung durch Arzneimittelabhängigkeit",
    "synonyms": [
      "Betreuung der Mutter bei Fetusschädigung durch Arzneimittelabhängigkeit",
      "Betreuung der Mutter bei Fetusschädigung durch Drogenabhängigkeit",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch Arzneimittelabhängigkeit",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch Drogenabhängigkeit"
    ]
  },
  {
    "code": "O35.6",
    "name": "Betreuung der Mutter bei Fetusschädigung durch Strahleneinwirkung",
    "synonyms": [
      "Betreuung der Mutter bei Fetusschädigung durch Strahleneinwirkung"
    ]
  },
  {
    "code": "O35.7",
    "name": "Betreuung der Schwangeren bei Fetusschädigung durch Amniozentese",
    "synonyms": [
      "Betreuung der Mutter bei Fetusschädigung durch hämatologische Untersuchung",
      "Betreuung der Mutter bei Fetusschädigung durch intrauterine Kontrazeptiva",
      "Betreuung der Mutter bei Fetusschädigung durch intrauterine Operation",
      "Betreuung der Mutter bei Fetusschädigung durch medizinische Maßnahme",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch hämatologische Untersuchung",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch intrauterine Operation",
      "Betreuung der Schwangeren bei Fetusschädigung durch Amniozentese",
      "Betreuung der Schwangeren bei Fetusschädigung durch Biopsie",
      "Betreuung der Schwangeren bei Fetusschädigung durch Intrauterinpessar",
      "Gravida-Betreuung bei Fetusschädigung durch Biopsie",
      "Gravida-Betreuung bei Fetusschädigung durch Intrauterinpessar"
    ]
  },
  {
    "code": "O35.8",
    "name": "Gravida-Betreuung bei fetalem Hygroma colli",
    "synonyms": [
      "Betreuung der Mutter bei AV-Block des Fetus mit drohendem Herzversagen",
      "Betreuung der Mutter bei Fetusschädigung durch Toxoplasmose",
      "Betreuung der Mutter bei Fetusschädigung durch mütterliche Listeriose",
      "Betreuung der Mutter bei Kehlkopf- und Luftröhrenverschluss beim Fetus",
      "Betreuung der Mutter bei Krankheit des Fetus a.n.k.",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch Absorption chemischer Substanzen über die Plazenta",
      "Betreuung der Mutter bei Verdacht auf Fetusschädigung durch mütterliche Listeriose",
      "Betreuung der Mutter bei Verengung der fetalen Semilunarklappen",
      "Betreuung der Mutter bei Verengung des Foramen ovale beim Fetus",
      "Betreuung der Mutter bei fetaler Gastroschisis",
      "Betreuung der Mutter bei fetaler Harnabflussstörung",
      "Betreuung der Mutter bei kongenitaler Zwerchfellhernie beim Fetus",
      "Betreuung der Schwangeren bei Fetusschädigung durch Toxoplasmose",
      "Betreuung der Schwangeren bei Fetusschädigung durch mütterliche Listeriose",
      "Betreuung der Schwangeren bei fetalem Hygroma colli",
      "Gravida-Betreuung bei Fetusschädigung durch Toxoplasmose",
      "Gravida-Betreuung bei Fetusschädigung durch mütterliche Listeriose",
      "Gravida-Betreuung bei fetalem Hygroma colli"
    ]
  },
  {
    "code": "O35.9",
    "name": "Erhöhtes genetisches Risiko beim Fetus",
    "synonyms": [
      "Betreuung der Schwangeren bei Fetalanomalie",
      "Betreuung der Schwangeren bei Fetalschädigung",
      "Erhöhtes Missbildungsrisiko beim Fetus",
      "Erhöhtes genetisches Risiko beim Fetus",
      "Gravida-Betreuung bei Fetalanomalie",
      "Gravida-Betreuung bei Fetalschädigung",
      "Gravida-Betreuung bei fetaler Schädigung"
    ]
  },
  {
    "code": "O36.0",
    "name": "Gravida-Betreuung bei Rh [Rhesus]-Inkompatibilität",
    "synonyms": [
      "Anti-D-Antikörper bei der Mutter",
      "Betreuung der Mutter bei Anti-D-Antikörper",
      "Betreuung der Mutter bei Rh-Antikörper",
      "Betreuung der Mutter bei Rh-Inkompatibilität mit Hydrops fetalis",
      "Betreuung der Schwangeren bei Rh [Rhesus]-Inkompatibilität",
      "Betreuung der Schwangeren bei Rhesus-Inkompatibilität",
      "Gravida-Betreuung bei Rh [Rhesus]-Inkompatibilität",
      "Gravida-Betreuung bei Rh [Rhesus]-Isoimmunisierung",
      "Positiver Anti-E-Titer bei Schwangerschaft",
      "Rh-Antikörper bei der Mutter",
      "Rh-Immunisierung bei Gravidität",
      "Rh-Immunisierung bei Schwangerschaft",
      "Rh-Inkompatibilität bei Gravidität",
      "Rh-Inkompatibilität bei Schwangerschaft",
      "Rh-Sensibilisierung bei Gravidität",
      "Rh-Sensibilisierung bei Schwangerschaft",
      "Rh-Unverträglichkeit bei Gravidität",
      "Rh-Unverträglichkeit bei Schwangerschaft"
    ]
  },
  {
    "code": "O36.1",
    "name": "Betreuung der Schwangeren bei Isoimmunisierung",
    "synonyms": [
      "Antikörper der Mutter",
      "Betreuung der Mutter bei AB0-Isoimmunisierung",
      "Betreuung der Mutter bei Isoimmunisierung mit Hydrops fetalis",
      "Betreuung der Schwangeren bei AB0-Immunisierung",
      "Betreuung der Schwangeren bei AB0-Inkompatibilität",
      "Betreuung der Schwangeren bei Blutgruppenunverträglichkeit",
      "Betreuung der Schwangeren bei Isoimmunisierung",
      "Blutgruppenantikörper der Mutter",
      "Gravida-Betreuung bei AB0-Isoimmunisierung"
    ]
  },
  {
    "code": "O36.2",
    "name": "Betreuung der Schwangeren bei Hydrops fetalis",
    "synonyms": [
      "Betreuung der Mutter bei Hydrops fetalis",
      "Betreuung der Mutter bei Hydrops fetalis, nicht in Verbindung mit Isoimmunisierung",
      "Betreuung der Mutter bei fetalem Hydrothorax",
      "Betreuung der Schwangeren bei Hydrops fetalis",
      "Gravida-Betreuung bei Hydrops fetalis",
      "Gravidität mit Hydrops fetalis a.n.k.",
      "Schwangerschaft mit Hydrops fetalis a.n.k."
    ]
  },
  {
    "code": "O36.3",
    "name": "Betreuung der Schwangeren bei fetaler Herztonalteration",
    "synonyms": [
      "Betreuung der Schwangeren bei fetalem Distress",
      "Betreuung der Schwangeren bei fetaler Anomalie des Säure-Basen-Gleichgewichts",
      "Betreuung der Schwangeren bei fetaler Azidämie",
      "Betreuung der Schwangeren bei fetaler Bradykardie",
      "Betreuung der Schwangeren bei fetaler Herzrhythmusanomalie",
      "Betreuung der Schwangeren bei fetaler Herztonalteration",
      "Betreuung der Schwangeren bei fetaler Hypoxie",
      "Gravida-Betreuung bei fetalem Distress",
      "Gravida-Betreuung bei fetaler Anomalie des Säure-Basen-Gleichgewichts",
      "Gravida-Betreuung bei fetaler Bradykardie",
      "Gravida-Betreuung bei fetaler Herzrhythmusanomalie",
      "Gravida-Betreuung bei fetaler Hypoxie",
      "Schnittentbindung bei Mekonium im Fruchtwasser",
      "Schnittentbindung bei fetalem Distress"
    ]
  },
  {
    "code": "O36.4",
    "name": "Betreuung der Schwangeren bei Fetaltod",
    "synonyms": [
      "Betreuung der Mutter bei retiniertem totem Fetus",
      "Betreuung der Schwangeren bei Fetaltod",
      "Betreuung der Schwangeren bei Fruchttod",
      "Betreuung der Schwangeren bei intrauterinem Fruchttod",
      "Betreuung der Schwangeren bei intrauterinem Tod",
      "Gravida-Betreuung bei intrauterinem Fruchttod",
      "Missed labor",
      "Retention des toten Fetus"
    ]
  },
  {
    "code": "O36.5",
    "name": "Betreuung der Schwangeren bei fetaler Wachstumsretardierung",
    "synonyms": [
      "Betreuung der Mutter bei Light-for-date-baby",
      "Betreuung der Mutter bei Plazentainsuffizienz",
      "Betreuung der Mutter bei Small-for-date-baby",
      "Betreuung der Mutter bei fetalem Entwicklungsstillstand",
      "Betreuung der Mutter bei fetalem Wachstumsstillstand",
      "Betreuung der Mutter bei fetaler Wachstumsretardierung",
      "Betreuung der Mutter bei unzureichendem Wachstum des Fetus",
      "Betreuung der Schwangeren bei Light-for-date-baby",
      "Betreuung der Schwangeren bei Plazentainsuffizienz",
      "Betreuung der Schwangeren bei Small-for-date-baby",
      "Betreuung der Schwangeren bei fetaler Retardierung",
      "Betreuung der Schwangeren bei fetaler Wachstumsretardierung",
      "Betreuung der Schwangeren bei fetoplazentarer Insuffizienz",
      "Betreuung der Schwangeren bei unzureichendem Wachstum des Fetus",
      "Gravida-Betreuung bei Light-for-date-baby",
      "Gravida-Betreuung bei Plazentainsuffizienz",
      "Gravida-Betreuung bei Small-for-date-baby",
      "Gravida-Betreuung bei fetaler Retardierung",
      "Gravida-Betreuung bei unzureichendem Wachstum des Fetus",
      "Plazentainsuffizienz",
      "Schnittentbindung bei plazentarer Insuffizienz"
    ]
  },
  {
    "code": "O36.6",
    "name": "Betreuung der Schwangeren bei fetaler Hypertrophie",
    "synonyms": [
      "Betreuung der Mutter bei Large-for-date-baby",
      "Betreuung der Mutter bei fetaler Hypertrophie",
      "Betreuung der Schwangeren bei Large-for-date-baby",
      "Betreuung der Schwangeren bei fetaler Hypertrophie",
      "Betreuung der Schwangeren bei übermäßigem Wachstum des Fetus",
      "Gravida-Betreuung bei Large-for-date-baby",
      "Gravida-Betreuung bei fetaler Hypertrophie",
      "Gravida-Betreuung bei übermäßigem Wachstum des Fetus"
    ]
  },
  {
    "code": "O36.7",
    "name": "Graviditas abdominalis mit lebensfähigem Fetus",
    "synonyms": [
      "Graviditas abdominalis mit lebensfähigem Fetus"
    ]
  },
  {
    "code": "O36.8",
    "name": "Fehlende Kindsbewegungen",
    "synonyms": [
      "Betreuung der Mutter bei Acranius acardius bei fetalen Gemini",
      "Betreuung der Mutter bei diskordanten monochorialen fetalen Gemini",
      "Fehlende Kindsbewegungen"
    ]
  },
  {
    "code": "O36.9",
    "name": "Betreuung der Schwangeren bei fetaler Komplikation",
    "synonyms": [
      "Betreuung der Mutter bei fetalem Problem",
      "Betreuung der Schwangeren bei fetaler Komplikation",
      "Gravida-Betreuung bei fetaler Komplikation"
    ]
  },
  {
    "code": "O40",
    "name": "Polyhydramnie",
    "synonyms": [
      "Amnionhydrops",
      "Betreuung der Mutter bei Polyhydramnion beim Fetus",
      "Gesteigerte Fruchtwasserbildung",
      "Hydramnion",
      "Hydramnion bei Gravidität",
      "Hydramnion bei Schwangerschaft",
      "Polyhydramnie",
      "Polyhydramnie bei Gravidität",
      "Polyhydramnie bei Schwangerschaft",
      "Polyhydramnion"
    ]
  },
  {
    "code": "O41.0",
    "name": "Oligohydramnion",
    "synonyms": [
      "Anhydramnion",
      "Anhydramnion bei Schwangerschaft",
      "Oligohydramnie bei Gravidität",
      "Oligohydramnie bei Schwangerschaft",
      "Oligohydramnion"
    ]
  },
  {
    "code": "O41.1",
    "name": "Infektion der Fruchtblase und Eihäute",
    "synonyms": [
      "Amnioninfektionssyndrom",
      "Amnionitis",
      "Amnionitis bei Gravidität",
      "Amnionitis bei Schwangerschaft",
      "CIUE [Chronische Intervillositis unbekannter Ätiologie]",
      "Chorioamnionitis",
      "Chorionamnionitis",
      "Deziduale Endometritis bei Gravidität",
      "Deziduale Endometritis bei Schwangerschaft",
      "Deziduitis bei Gravidität",
      "Deziduitis bei Schwangerschaft",
      "Entzündung der Eihäute",
      "Fruchtblaseninfektion",
      "Infektion der Amnionhöhle",
      "Infektion der Fruchtblase und Eihäute",
      "Infektion des Fruchtwassers",
      "Plazentitis",
      "Plazentitis bei Gravidität",
      "Plazentitis bei Schwangerschaft",
      "Schwangerschaftskomplikation durch Amnionitis",
      "Schwangerschaftskomplikation durch Plazentitis"
    ]
  },
  {
    "code": "O41.8",
    "name": "Adhäsion zwischen Amnion und Fetus",
    "synonyms": [
      "Adhäsion zwischen Amnion und Fetus",
      "Amnionfibrose",
      "Amnionzyste",
      "Chorioamniale Separation",
      "Chorionfibrose",
      "Chorionzyste"
    ]
  },
  {
    "code": "O41.9",
    "name": "Amnionhöhlenstörung",
    "synonyms": [
      "Abnormes Fruchtwasser",
      "Abnormität der Eihäute",
      "Amnionabnormität",
      "Amnionhöhlenstörung",
      "Chorionabnormität",
      "Eihäuteschädigung",
      "Eihäutestörung",
      "Eihäuteveränderung",
      "Fruchtwasserstörung",
      "Fruchtwasserveränderung"
    ]
  },
  {
    "code": "O42.0",
    "name": "Vorzeitiger Blasensprung mit Wehenbeginn innerhalb 24 Stunden",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenbeginn innerhalb 24 Stunden"
    ]
  },
  {
    "code": "O42.11",
    "name": "Vorzeitiger Blasensprung mit Wehenbeginn nach Ablauf von 1 bis 7 Tagen",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenbeginn nach Ablauf von 1 bis 7 Tagen",
      "Vorzeitiger Blasensprung mit Wehenbeginn nach Ablauf von 24 Stunden"
    ]
  },
  {
    "code": "O42.12",
    "name": "Vorzeitiger Blasensprung mit Wehenbeginn nach Ablauf von mehr als 7 Tagen",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenbeginn nach Ablauf von mehr als 7 Tagen"
    ]
  },
  {
    "code": "O42.20",
    "name": "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, Wehenbeginn innerhalb von 24 Stunden",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, Wehenbeginn innerhalb von 24 Stunden"
    ]
  },
  {
    "code": "O42.21",
    "name": "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, Wehenbeginn nach Ablauf von 1 bis 7 Tagen",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, Wehenbeginn nach Ablauf von 1 bis 7 Tagen"
    ]
  },
  {
    "code": "O42.22",
    "name": "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, Wehenbeginn nach Ablauf von mehr als 7 Tagen",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, Wehenbeginn nach Ablauf von mehr als 7 Tagen"
    ]
  },
  {
    "code": "O42.29",
    "name": "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, ohne Angabe des Wehenbeginns",
    "synonyms": [
      "Vorzeitiger Blasensprung mit Wehenhemmung durch Therapie, ohne Angabe des Wehenbeginns"
    ]
  },
  {
    "code": "O42.9",
    "name": "Hydrorrhoea gravidarum",
    "synonyms": [
      "Durchsickern von Fruchtwasser",
      "Hoher Blasensprung",
      "Hydrorrhoe bei Gravidität",
      "Hydrorrhoe bei Schwangerschaft",
      "Hydrorrhoea gravidarum",
      "Vorzeitiger Blasensprung als Entbindungskomplikation",
      "Vorzeitiger Blasensprung bei Gravidität",
      "Vorzeitiger Blasensprung bei Schwangerschaft"
    ]
  },
  {
    "code": "O43.0",
    "name": "Transplazentares Transfusionssyndrom",
    "synonyms": [
      "Betreuung der Mutter bei fetofetalem Transfusionssyndrom",
      "Fetofetale Transfusion",
      "Fetofetales Transfusionssyndrom",
      "Fetomaternale Transfusion",
      "Fetomaternales Transfusionssyndrom",
      "Maternofetale Transfusion",
      "Maternofetales Transfusionssyndrom",
      "Schnittentbindung bei fetomaternaler Blutung",
      "TRAP [Twin reversed arterial perfusion]-Sequenz",
      "Transplazentares Transfusionssyndrom",
      "Transplazentares Transfusionssyndrom bei der Mutter",
      "Zwillings-Anämie-Polyzythämie-Sequenz"
    ]
  },
  {
    "code": "O43.1",
    "name": "Plazentafehlbildung",
    "synonyms": [
      "Abnorme Plazenta a.n.k.",
      "Amniotische Plazentazyste",
      "Betreuung der Schwangeren bei Plazentaanomalie",
      "Betreuung der Schwangeren bei Plazentafehlbildung",
      "Doppelte Plazenta",
      "Formabweichung der Plazenta bei Gravidität",
      "Formabweichung der Plazenta bei Schwangerschaft",
      "Gravida-Betreuung bei Plazentaanomalie",
      "Gravida-Betreuung bei Plazentafehlbildung",
      "Insertio centralis",
      "Insertio lateralis",
      "Insertio marginalis",
      "Insertio velamentosa",
      "Mikroplazenta",
      "Nebenplazenta",
      "Placenta bipartita",
      "Placenta circumvallata",
      "Placenta duplex",
      "Placenta fenestrata",
      "Placenta membranacea",
      "Placenta multilobulata",
      "Placenta multipartita",
      "Placenta succenturiata",
      "Placenta tripartita",
      "Placenta triplex",
      "Plazenta mit randständigem Nabelschnuransatz",
      "Plazentaabnormität a.n.k.",
      "Plazentaabnormität als Entbindungskomplikation a.n.k.",
      "Plazentaangiom",
      "Plazentaanomalie a.n.k.",
      "Plazentafehlbildung",
      "Plazentafehlbildung als Entbindungskomplikation a.n.k."
    ]
  },
  {
    "code": "O43.20",
    "name": "Placenta accreta",
    "synonyms": [
      "Placenta accreta",
      "Placenta accreta als Entbindungskomplikation",
      "Placenta adhaerens",
      "Placenta adhaerens als Entbindungskomplikation"
    ]
  },
  {
    "code": "O43.21",
    "name": "Placenta increta",
    "synonyms": [
      "Placenta increta",
      "Placenta increta als Entbindungskomplikation",
      "Placenta percreta als Entbindungskomplikation"
    ]
  },
  {
    "code": "O43.8",
    "name": "Plakopathie",
    "synonyms": [
      "Betreuung der Schwangeren bei retroplazentarer Blutung",
      "Endangiopathia obliterans placentae",
      "Gravida-Betreuung bei retroplazentarer Blutung",
      "Obliteration eines plazentaren Blutgefäßes",
      "Plakopathie",
      "Plazentadegeneration",
      "Plazentadysfunktion",
      "Plazentafibrose",
      "Plazentagefäßvarikose",
      "Plazentahyperplasie",
      "Plazentahämatom",
      "Plazentainfarkt",
      "Plazentainfarkt bei Gravidität",
      "Plazentainfarkt bei Schwangerschaft",
      "Plazentanekrose",
      "Plazentare Dysfunktion",
      "Plazentavarizen",
      "Variköses Gefäß der Plazenta",
      "Vorzeitige Plazentaerweichung"
    ]
  },
  {
    "code": "O43.9",
    "name": "Plazentastörung",
    "synonyms": [
      "Pathologischer Zustand der Plazenta",
      "Plazentaaffektion",
      "Plazentakrankheit a.n.k.",
      "Plazentakrankheit als Entbindungskomplikation",
      "Plazentastörung"
    ]
  },
  {
    "code": "O44.00",
    "name": "Tiefer Plazentasitz ohne Blutung",
    "synonyms": [
      "Entbindungskomplikation durch falschen Sitz der Plazenta",
      "Falscher Sitz der Plazenta",
      "Fehllage der Plazenta",
      "Gravidität mit Komplikation durch Lageanomalie der Plazenta",
      "Lageanomalie der Plazenta",
      "Lageanomalie der Plazenta als Entbindungskomplikation ohne Blutung",
      "Schwangerschaft mit Komplikation durch Lageanomalie der Plazenta",
      "Tiefer Plazentasitz",
      "Tiefer Plazentasitz ohne Blutung",
      "Tiefer Sitz der Plazenta als Entbindungskomplikation ohne Blutung",
      "Tiefsitzende Plazenta",
      "Zervixplazenta"
    ]
  },
  {
    "code": "O44.01",
    "name": "Placenta praevia ohne Blutung",
    "synonyms": [
      "Placenta lateralis",
      "Placenta praevia",
      "Placenta praevia marginalis",
      "Placenta praevia marginalis anterior",
      "Placenta praevia marginalis posterior",
      "Placenta praevia ohne Blutung",
      "Placenta praevia partialis",
      "Placenta praevia totalis",
      "Schnittentbindung bei Placenta praevia ohne Blutung"
    ]
  },
  {
    "code": "O44.10",
    "name": "Tiefer Plazentasitz mit Blutung",
    "synonyms": [
      "Entbindungskomplikation durch tiefen Sitz der Plazenta mit Blutung",
      "Tiefer Plazentasitz mit Blutung"
    ]
  },
  {
    "code": "O44.11",
    "name": "Placenta praevia mit Blutung",
    "synonyms": [
      "Entbindungskomplikation durch Placenta praevia mit Blutung",
      "Placenta praevia marginalis mit Blutung",
      "Placenta praevia mit Blutung",
      "Placenta praevia mit Hämorrhagie",
      "Placenta praevia partialis mit Blutung",
      "Placenta praevia totalis mit Blutung",
      "Schnittentbindung bei Placenta praevia mit Blutung"
    ]
  },
  {
    "code": "O45.0",
    "name": "Vorzeitige Plazentalösung bei Gerinnungsstörung",
    "synonyms": [
      "Ablatio placentae mit verstärkter Blutung bei Afibrinogenämie",
      "Ablatio placentae mit verstärkter Blutung bei Hyperfibrinolyse",
      "Ablatio placentae mit verstärkter Blutung bei Hypofibrinogenämie",
      "Ablatio placentae mit verstärkter Blutung bei disseminierter intravasaler Gerinnung",
      "Abruptio placentae bei Gerinnungsstörung",
      "Abruptio placentae mit verstärkter Blutung bei Afibrinogenämie",
      "Abruptio placentae mit verstärkter Blutung bei Hyperfibrinolyse",
      "Abruptio placentae mit verstärkter Blutung bei Hypofibrinogenämie",
      "Abruptio placentae mit verstärkter Blutung bei disseminierter intravasaler Gerinnung",
      "Defibrinationssyndrom mit vorzeitiger Plazentalösung",
      "Vorzeitige Plazentalösung bei Gerinnungsstörung",
      "Vorzeitige Plazentalösung mit Blutung bei Gerinnungsdefekt",
      "Vorzeitige Plazentalösung mit Blutung bei Koagulationsdefekt"
    ]
  },
  {
    "code": "O45.8",
    "name": "Uteroplazentare Apoplexie",
    "synonyms": [
      "Couvelaire-Krankheit",
      "Couvelaire-Syndrom",
      "Couvelaire-Uterus",
      "Couvelaire-Uterus als Entbindungskomplikation",
      "Uteroplazentare Apoplexie",
      "Vorzeitige Plazentalösung nach Abdomenprellung",
      "Vorzeitige Plazentalösung nach Bauchprellung"
    ]
  },
  {
    "code": "O45.9",
    "name": "Vorzeitige Plazentalösung",
    "synonyms": [
      "Ablatio placentae",
      "Abruptio placentae",
      "Abruptio placentae als Entbindungskomplikation a.n.k.",
      "Entbindungskomplikation durch vorzeitige Lösung der Plazenta",
      "Plazentaablösung als Entbindungskomplikation",
      "Plazentalösung",
      "Schnittentbindung bei Abruptio placentae",
      "Vorzeitige Plazentalösung",
      "Vorzeitige Plazentalösung mit Blutung"
    ]
  },
  {
    "code": "O46.0",
    "name": "Präpartale Blutung bei Gerinnungsstörung",
    "synonyms": [
      "Antepartale Blutung bei Gerinnungsdefekt",
      "Antepartale Blutung bei Koagulationsdefekt",
      "Antepartale Fibrinolyse",
      "Blutdyskrasie mit Vorgeburtsblutung",
      "Defibrinationssyndrom mit präpartaler Blutung",
      "Haemorrhagia ante partum bei Afibrinogenämie",
      "Haemorrhagia ante partum bei Gerinnungsstörung",
      "Haemorrhagia ante partum bei disseminierter intravasaler Gerinnung",
      "Präpartale Blutung bei Gerinnungsstörung",
      "Präpartale Verbrauchskoagulopathie",
      "Präpartaler Koagulationsfaktorenmangel",
      "Verstärkte präpartale Blutung bei Afibrinogenämie",
      "Verstärkte präpartale Blutung bei Hyperfibrinolyse",
      "Verstärkte präpartale Blutung bei Hypofibrinogenämie",
      "Verstärkte präpartale Blutung bei disseminierter intravasaler Gerinnung"
    ]
  },
  {
    "code": "O46.8",
    "name": "Traumatische antepartale Blutung",
    "synonyms": [
      "Antepartale Plazentablutung",
      "Blutender Sinus marginalis placentae",
      "Plazentaanomalie mit Blutung",
      "Plazentablutung",
      "Plazentablutung durch instrumentelle Schädigung",
      "Plazentahämorrhagie a.n.k.",
      "Plazentahämorrhagie durch instrumentelle Schädigung",
      "Randsinusblutung der Plazenta",
      "Ruptur des plazentaren Randsinus mit Blutung",
      "Rupturierter Sinus marginalis placentae",
      "Traumatische antepartale Blutung"
    ]
  },
  {
    "code": "O46.9",
    "name": "Blutung bei Gravidität",
    "synonyms": [
      "Akzidentelle Blutung vor der Entbindung",
      "Akzidentelle Hämorrhagie vor der Entbindung",
      "Antepartale Blutung",
      "Blutung bei Gravidität",
      "Blutung bei Schwangerschaft",
      "Blutung vor Entbindung",
      "Blutung vor der Geburt",
      "Entbindung vorausgehende Blutung",
      "Haemorrhagia ante partum",
      "Präpartale Blutung",
      "Präpartale Hämorrhagie",
      "Schnittentbindung bei präpartaler Blutung"
    ]
  },
  {
    "code": "O47.0",
    "name": "Frühgeburtsbestrebung",
    "synonyms": [
      "Frustrane Kontraktionen vor 37 vollendeten Schwangerschaftswochen",
      "Frühgeburtsbestrebung",
      "Unnütze Wehen vor 37 vollendeten Schwangerschaftswochen"
    ]
  },
  {
    "code": "O47.1",
    "name": "Unnütze Wehen ab 37 vollendeten Schwangerschaftswochen",
    "synonyms": [
      "Frustrane Kontraktionen ab 37 vollendeten Schwangerschaftswochen",
      "Unnütze Wehen ab 37 vollendeten Schwangerschaftswochen"
    ]
  },
  {
    "code": "O47.9",
    "name": "Frustrane Kontraktionen",
    "synonyms": [
      "Braxton-Hick-Wehen",
      "Drohende Wehen",
      "Falsche vergebliche Wehen",
      "Frustrane Kontraktionen",
      "Frustrane Kontraktionen mit Wehenschmerzen",
      "Frustrane nichtmuttermundwirksame Wehen",
      "Unnütze Wehen",
      "Vorwehen"
    ]
  },
  {
    "code": "O48",
    "name": "Übertragene Schwangerschaft",
    "synonyms": [
      "Betreuung der Mutter bei Tragzeitüberschreitung",
      "Gravidität über dem Termin",
      "Tragzeitüberschreitung",
      "Verlängerte Gravidität",
      "Verlängerte Schwangerschaft",
      "Übertragene Gravidität",
      "Übertragene Schwangerschaft"
    ]
  },
  {
    "code": "O60.0",
    "name": "Vorzeitige muttermundwirksame Wehentätigkeit",
    "synonyms": [
      "Drohende Frühgeburt",
      "Vorzeitige Wehen ohne Entbindung",
      "Vorzeitige induzierte Wehen ohne Entbindung",
      "Vorzeitige muttermundwirksame Wehentätigkeit",
      "Vorzeitige spontane Wehen ohne Entbindung",
      "Vorzeitiges Einsetzen muttermundwirksamer Wehen"
    ]
  },
  {
    "code": "O60.1",
    "name": "Vorzeitiger Entbindungsbeginn",
    "synonyms": [
      "Entbindung vor dem Termin a.n.k.",
      "Spontaner Geburtsbeginn vor der vollendeten 37. Schwangerschaftswoche",
      "Vorzeitige Entbindung a.n.k.",
      "Vorzeitige Wehen mit Entbindung",
      "Vorzeitige spontane Wehen mit vorzeitiger Entbindung",
      "Vorzeitige spontane Wehen mit vorzeitiger Entbindung durch Kaiserschnitt",
      "Vorzeitiger Entbindungsbeginn",
      "Vorzeitiger Geburtsbeginn"
    ]
  },
  {
    "code": "O60.2",
    "name": "Vorzeitige Wehen mit termingerechter Entbindung",
    "synonyms": [
      "Vorzeitige Wehen mit termingerechter Entbindung",
      "Vorzeitige spontane Wehen mit termingerechter Entbindung durch Kaiserschnitt"
    ]
  },
  {
    "code": "O60.3",
    "name": "Schnittentbindung bei fetaler Unreife",
    "synonyms": [
      "Schnittentbindung bei fetaler Unreife",
      "Vorzeitige Entbindung durch Kaiserschnitt, ohne spontane Wehen",
      "Vorzeitige Entbindung ohne spontane Wehen",
      "Vorzeitige induzierte Entbindung"
    ]
  },
  {
    "code": "O61.0",
    "name": "Misslungene medikamentöse Geburtseinleitung",
    "synonyms": [
      "Misslungene Geburtseinleitung durch Oxytocin",
      "Misslungene Geburtseinleitung durch Prostaglandine",
      "Misslungene Weheninduktion durch Ocytocin",
      "Misslungene Weheninduktion durch Prostaglandine",
      "Misslungene medikamentöse Geburtseinleitung"
    ]
  },
  {
    "code": "O61.1",
    "name": "Misslungene instrumentelle Geburtseinleitung",
    "synonyms": [
      "Misslungene instrumentelle Geburtseinleitung",
      "Misslungene mechanische Geburtseinleitung",
      "Misslungene operative Geburtseinleitung"
    ]
  },
  {
    "code": "O61.9",
    "name": "Misslungene Geburtseinleitung",
    "synonyms": [
      "Misslungene Geburtseinleitung"
    ]
  },
  {
    "code": "O62.0",
    "name": "Primäre Wehenschwäche",
    "synonyms": [
      "Ausbleiben der Eröffnung der Cervix uteri bei Wehen",
      "Dystokie der Cervix uteri",
      "Entbindungskomplikation durch primäre Wehenschwäche",
      "Entbindungskomplikation durch primäre hypotonische Funktionsstörung des Uterus",
      "Nichteröffneter Muttermund",
      "Primäre Inertia uteri",
      "Primäre Inertia uteri als Entbindungskomplikation",
      "Primäre Wehenschwäche",
      "Primäre hypotone uterine Dysfunktion",
      "Primäre unzulängliche Uteruskontraktur",
      "Schnittentbindung bei mangelnder Eröffnung des Muttermundes",
      "Schnittentbindung bei primärer Wehenschwäche",
      "Späte Dilatation der Cervix uteri als Entbindungskomplikation",
      "Späte Zervixdilatation als Entbindungskomplikation",
      "Unvollständige Dilatation der Cervix uteri als Entbindungskomplikation",
      "Unvollständige Erweiterung der Cervix uteri als Entbindungskomplikation",
      "Unvollständige Zervixdilatation als Entbindungskomplikation",
      "Wehenschwäche während der Latenzphase",
      "Zervikale Dystokie als Entbindungskomplikation",
      "Zervixdystokie"
    ]
  },
  {
    "code": "O62.1",
    "name": "Sekundäre Wehenschwäche",
    "synonyms": [
      "Entbindungskomplikation durch sekundäre Wehenschwäche",
      "Entbindungskomplikation durch sekundäre hypotonische Funktionsstörung des Uterus",
      "Schnittentbindung bei sekundärer Wehenschwäche",
      "Sekundäre Inertia uteri",
      "Sekundäre Inertia uteri als Entbindungskomplikation",
      "Sekundäre Wehenschwäche",
      "Sekundäre hypotone uterine Dysfunktion",
      "Sekundäre unzulängliche Uteruskontraktur",
      "Stillstand in der aktiven Wehenphase",
      "Unterbrochene aktive Wehenphase"
    ]
  },
  {
    "code": "O62.2",
    "name": "Wehenschwäche",
    "synonyms": [
      "Flüchtige Wehen",
      "Geringe Wehen-Kontraktion",
      "Geringe Wehentätigkeit",
      "Hypotone Uteruskontraktion als Entbindungskomplikation",
      "Hypotone uterine Dysfunktion",
      "Hypotonische Funktionsstörung des Uterus als Entbindungskomplikation a.n.k.",
      "Inertia des Uterus bei Schwangerschaft",
      "Inertia uteri",
      "Inertia uteri als Entbindungskomplikation",
      "Irreguläre Wehen",
      "Schnittentbindung bei Uterusatonie",
      "Schnittentbindung bei Wehenschwäche",
      "Sporadische Wehen",
      "Unregelmäßige Wehen",
      "Uterusatonie als Entbindungskomplikation",
      "Uterusatonie unter der Geburt",
      "Uterusatonie während der Wehentätigkeit",
      "Uterushypotonie als Entbindungskomplikation",
      "Wehenschwäche",
      "Wehenschwäche als Entbindungskomplikation"
    ]
  },
  {
    "code": "O62.3",
    "name": "Überstürzte Geburt",
    "synonyms": [
      "Partus praecipitatus",
      "Rasche Austreibungsphase bei der Entbindung",
      "Sturzgeburt",
      "Verkürzte Austreibungsperiode bei der Entbindung",
      "Wehen bei überstürzter Geburt",
      "Überstürzte Entbindung",
      "Überstürzte Geburt"
    ]
  },
  {
    "code": "O62.4",
    "name": "Krampfwehen",
    "synonyms": [
      "Anhaltende Wehen",
      "Bandl-Kontraktionsring",
      "Bandl-Ring",
      "Clonus uteri",
      "Diskoordinierte Wehentätigkeit",
      "Dyskoordinierte Wehen",
      "Hypertone Uteruskontraktionen",
      "Hypertone Wehen",
      "Hypertone uterine Dysfunktion",
      "Hypertonische Funktionsstörung des Uterus als Entbindungskomplikation a.n.k.",
      "Hypertonische Wehenstörung",
      "Klonische Uteruskontraktion",
      "Kontraktionsring als Entbindungskomplikation",
      "Krampfwehen",
      "Pathologischer Retraktionsring des Uterus",
      "Pathologischer Retraktionsring des Uterus als Entbindungskomplikation",
      "Ringförmige Kontraktur als Entbindungskomplikation",
      "Sanduhrkontraktion des Uterus",
      "Sanduhrkontraktion des Uterus als Entbindungskomplikation",
      "Schnittentbindung bei unkoordinierter Uterustätigkeit",
      "Spasmus der Cervix uteri als Entbindungskomplikation",
      "Tetania uteri als Entbindungskomplikation",
      "Tetanische Uteruskontraktion",
      "Tetanus uteri",
      "Therapieresistente Wehen",
      "Unkoordinierte Uterustätigkeit als Entbindungskomplikation",
      "Unkoordinierte Wehen",
      "Unkoordinierte Wehentätigkeit",
      "Uterine Dystokie a.n.k.",
      "Uteruskonstriktion als Entbindungskomplikation",
      "Uterustetanie",
      "Verlängerte Kontraktur des Uterus während der Wehen",
      "Wehendystokie"
    ]
  },
  {
    "code": "O62.8",
    "name": "Wehensturm",
    "synonyms": [
      "Hyperaktivität des Uterus während der Schwangerschaft",
      "Wehensturm"
    ]
  },
  {
    "code": "O62.9",
    "name": "Abnorme Wehentätigkeit a.n.k.",
    "synonyms": [
      "Abnorme Uteruskontraktion",
      "Abnorme Uteruswehen",
      "Abnorme Wehentätigkeit a.n.k.",
      "Abnorme Wehentätigkeit als Entbindungskomplikation",
      "Abnorme uterine Kontrakturen als Entbindungskomplikation",
      "Anomale Wehen a.n.k.",
      "Funktionsstörung des Uterus als Entbindungskomplikation a.n.k."
    ]
  },
  {
    "code": "O63.0",
    "name": "Geburt mit protrahiert verlaufender Eröffnungsperiode",
    "synonyms": [
      "Geburt mit protrahiert verlaufender Eröffnungsperiode",
      "Geburtsverlängerung im ersten Geburtsabschnitt",
      "Verlängerte Wehen im ersten Geburtsabschnitt"
    ]
  },
  {
    "code": "O63.1",
    "name": "Geburt mit protrahiert verlaufender Austreibungsperiode",
    "synonyms": [
      "Geburt mit protrahiert verlaufender Austreibungsperiode",
      "Geburtsverlängerung im zweiten Geburtsabschnitt",
      "Verlängerte Wehen im zweiten Geburtsabschnitt"
    ]
  },
  {
    "code": "O63.2",
    "name": "Geburtsverzögerung beim 2. Zwilling",
    "synonyms": [
      "Geburtsverzögerung beim 2. Zwilling",
      "Protrahiert verlaufende Austreibungsperiode beim 2. Zwilling",
      "Protrahierte Geburt beim 2. Zwilling"
    ]
  },
  {
    "code": "O63.9",
    "name": "Geburtsverlängerung",
    "synonyms": [
      "Entbindungsverzögerung a.n.k.",
      "Geburtsverlängerung",
      "Geburtsverzögerung a.n.k.",
      "Protrahierte Entbindung a.n.k.",
      "Protrahierte Geburt a.n.k.",
      "Protrahierte Geburt als Entbindungskomplikation",
      "Schnittentbindung bei verlängerter Geburt",
      "Verlängerte Wehen",
      "Verzögerte Entbindung a.n.k.",
      "Wehenverlängerung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O64.0",
    "name": "Entbindung bei tiefer Querlage",
    "synonyms": [
      "Entbindung bei hinterer Hinterhauptslage",
      "Entbindung bei tiefer Querlage",
      "Geburtshindernis durch konstante hintere Hinterhauptslage",
      "Geburtshindernis durch konstante vordere Hinterhauptslage",
      "Geburtshindernis durch persistierende okzipitoiliakale Kindslage",
      "Geburtshindernis durch persistierende okzipitosakrale Kindslage",
      "Geburtshindernis durch persistierende okzipitotransversale Kindslage",
      "Geburtshindernis durch tiefen Querstand",
      "Geburtsstillstand bei tiefem Querstand",
      "Wehen bei tiefem Querstand"
    ]
  },
  {
    "code": "O64.1",
    "name": "Geburtshindernis durch Beckenendlage",
    "synonyms": [
      "Beckenendlage als Entbindungskomplikation",
      "Geburtshindernis durch Beckenendlage",
      "Geburtshindernis durch Beinprolaps",
      "Geburtshindernis durch Beinvorfall",
      "Geburtshindernis durch Fußlage",
      "Geburtshindernis durch Steiß-Fuß-Lage",
      "Geburtshindernis durch Steißlage",
      "Steißlage als Entbindungskomplikation"
    ]
  },
  {
    "code": "O64.2",
    "name": "Geburtshindernis durch Gesichtslage",
    "synonyms": [
      "Geburtshindernis durch Gesichtslage",
      "Geburtshindernis durch Kinnlage",
      "Gesichtslage als Entbindungskomplikation"
    ]
  },
  {
    "code": "O64.3",
    "name": "Geburtshindernis durch Stirnlage",
    "synonyms": [
      "Geburtshindernis durch Stirnlage",
      "Stirnlage als Entbindungskomplikation",
      "Vorderhauptslage als Entbindungskomplikation"
    ]
  },
  {
    "code": "O64.4",
    "name": "Geburtshindernis durch Querlage",
    "synonyms": [
      "Entbindung bei Schulterlage",
      "Geburtshindernis durch Armprolaps",
      "Geburtshindernis durch Armvorfall",
      "Geburtshindernis durch Handprolaps",
      "Geburtshindernis durch Querlage",
      "Geburtshindernis durch Schräglage",
      "Geburtshindernis durch Schulterlage"
    ]
  },
  {
    "code": "O64.5",
    "name": "Geburtshindernis durch kombinierte Einstellungsanomalien",
    "synonyms": [
      "Geburtshindernis durch kombinierte Einstellungsanomalien"
    ]
  },
  {
    "code": "O64.8",
    "name": "Geburtshindernis durch fehlenden Eintritt des Kopfes in den Beckeneingang",
    "synonyms": [
      "Geburtshindernis durch Nichteinstellen des kindlichen Kopfes",
      "Geburtshindernis durch fehlenden Eintritt des Kopfes in den Beckeneingang"
    ]
  },
  {
    "code": "O64.9",
    "name": "Geburtshindernis durch Einstellungsanomalie",
    "synonyms": [
      "Dystokie durch Einstellungsanomalie",
      "Dystokie durch Haltungsanomalie",
      "Dystokie durch Lageanomalie",
      "Entbindung bei regelwidriger Kindslage",
      "Geburtshindernis durch Einstellungsanomalie",
      "Geburtshindernis durch Haltungsanomalie",
      "Geburtshindernis durch Lageanomalie",
      "Mechanisch behinderte Geburt durch Lageanomalie"
    ]
  },
  {
    "code": "O65.0",
    "name": "Geburtshindernis durch Beckendeformität",
    "synonyms": [
      "Geburtshindernis durch Beckendeformität",
      "Geburtshindernis durch Beckenskoliose mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch Lendenwirbelsäulendistorsion mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch Spondylose mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch Verformung der Lendenwirbelsäule mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch flaches Becken mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch pithekoides Becken mit fetopelvinem Missverhältnis"
    ]
  },
  {
    "code": "O65.1",
    "name": "Geburtshindernis durch allgemein verengtes Becken",
    "synonyms": [
      "Geburtshindernis durch Beckenkontraktur mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch allgemein verengtes Becken"
    ]
  },
  {
    "code": "O65.2",
    "name": "Geburtshindernis durch Beckeneingangsverengung",
    "synonyms": [
      "Geburtshindernis durch Beckeneingangsverengung"
    ]
  },
  {
    "code": "O65.3",
    "name": "Geburtshindernis durch Beckenausgangs- und Beckenmittenverengung",
    "synonyms": [
      "Geburtshindernis durch Beckenausgangs- und Beckenmittenverengung",
      "Geburtshindernis durch Trichterbecken mit fetopelvinem Missverhältnis",
      "Geburtshindernis durch androides Becken mit fetopelvinem Missverhältnis"
    ]
  },
  {
    "code": "O65.4",
    "name": "Geburtshindernis durch Missverhältnis zwischen Fetus und Becken",
    "synonyms": [
      "Geburtshindernis durch Missverhältnis zwischen Fetus und Becken",
      "Geburtshindernis durch fetopelvines Missverhältnis a.n.k.",
      "Geburtshindernis durch zephalopelvine Disproportion"
    ]
  },
  {
    "code": "O65.5",
    "name": "Geburtshindernis durch Anomalie der mütterlichen Beckenorgane",
    "synonyms": [
      "Amputation der Cervix uteri als Entbindungskomplikation",
      "Atresie der Cervix uteri als Entbindungskomplikation",
      "Entbindungskomplikation durch vorangegangenen chirurgischen Eingriff an der Cervix uteri",
      "Entbindungskomplikation durch vorangegangenen chirurgischen Eingriff an der Zervix",
      "Geburtsbehinderung durch Beckenweichteilgewebe",
      "Geburtsbehinderung durch Rektozele",
      "Geburtshindernis durch Anomalie der mütterlichen Beckenorgane",
      "Geburtshindernis durch Anteversion der Cervix uteri",
      "Geburtshindernis durch Anteversion des Uterus",
      "Geburtshindernis durch Beckenbodenrigidität",
      "Geburtshindernis durch Beckentumor a.n.k.",
      "Geburtshindernis durch Beckenzyste",
      "Geburtshindernis durch Fehlbildung der mütterlichen Beckenorgane",
      "Geburtshindernis durch Fibromyom des Uterus",
      "Geburtshindernis durch Inkarzeration des graviden Uterus",
      "Geburtshindernis durch Lateroversion der Cervix uteri",
      "Geburtshindernis durch Lateroversion des Uterus",
      "Geburtshindernis durch Narbe der Cervix uteri",
      "Geburtshindernis durch Ovarzyste",
      "Geburtshindernis durch Perineumabnormität",
      "Geburtshindernis durch Perineumfibrose",
      "Geburtshindernis durch Polyp der Cervix uteri",
      "Geburtshindernis durch Rektozele",
      "Geburtshindernis durch Retroversio uteri",
      "Geburtshindernis durch Retroversion der Cervix uteri",
      "Geburtshindernis durch Retroversion des Uterus",
      "Geburtshindernis durch Rigidität der Cervix uteri",
      "Geburtshindernis durch Rigidität des Perineums",
      "Geburtshindernis durch Stenose",
      "Geburtshindernis durch Stenose der Cervix uteri",
      "Geburtshindernis durch Tumor der Cervix uteri",
      "Geburtshindernis durch Tumor des Perineums",
      "Geburtshindernis durch Uterus bicornis",
      "Geburtshindernis durch Uterus duplex",
      "Geburtshindernis durch Uterusanomalie",
      "Geburtshindernis durch Uterusfibrom",
      "Geburtshindernis durch Uterusinkarzeration",
      "Geburtshindernis durch Uteruspolyp",
      "Geburtshindernis durch Uterusprolaps",
      "Geburtshindernis durch Uterustumor in der Schwangerschaft",
      "Geburtshindernis durch Vaginaabnormität",
      "Geburtshindernis durch Vaginalstenose",
      "Geburtshindernis durch Vaginaltumor in der Schwangerschaft",
      "Geburtshindernis durch Vaginarigidität",
      "Geburtshindernis durch Verlagerung des Uterus a.n.k.",
      "Geburtshindernis durch Vulvaabnormität",
      "Geburtshindernis durch Vulvarigidität",
      "Geburtshindernis durch Vulvatumor in der Schwangerschaft",
      "Geburtshindernis durch Zervixanomalie",
      "Geburtshindernis durch Zervixnarbe",
      "Geburtshindernis durch Zervixpolyp",
      "Geburtshindernis durch Zervixrigidität",
      "Geburtshindernis durch Zervixstenose",
      "Geburtshindernis durch Zervixtumor in der Schwangerschaft",
      "Geburtshindernis durch Zystozele",
      "Geburtshindernis durch rigide Cervix uteri",
      "Geburtshindernis durch rigide Vagina",
      "Geburtshindernis durch rigide Vulva",
      "Geburtshindernis durch rigide Zervix",
      "Geburtshindernis durch rigiden Beckenboden",
      "Geburtshindernis durch rigides Perineum",
      "Lageanomalie der Cervix uteri als Entbindungskomplikation",
      "Lageanomalie der Zervix als Entbindungskomplikation",
      "Lageanomalie des Uterus als Entbindungskomplikation",
      "Narbe der Cervix uteri als Entbindungskomplikation",
      "Stenose der Cervix uteri als Entbindungskomplikation",
      "Striktur der Cervix uteri als Entbindungskomplikation",
      "Tumor der Beckenorgane als Entbindungskomplikation a.n.k.",
      "Tumor des Beckenbindegewebes als Entbindungskomplikation a.n.k.",
      "Vaginalstenose als Entbindungskomplikation",
      "Zervixstenose als Entbindungskomplikation"
    ]
  },
  {
    "code": "O65.8",
    "name": "Geburtshindernis durch lumbosakrale Spondylolyse",
    "synonyms": [
      "Geburtshindernis durch lumbosakrale Spondylolyse"
    ]
  },
  {
    "code": "O65.9",
    "name": "Geburtshindernis durch Anomalie des mütterlichen Beckens",
    "synonyms": [
      "Geburtsbehinderung durch abnorme Beckenknochen",
      "Geburtshindernis durch Anomalie des mütterlichen Beckens"
    ]
  },
  {
    "code": "O66.0",
    "name": "Geburtshindernis durch Schulterdystokie",
    "synonyms": [
      "Einklemmung durch Schulterlage",
      "Geburtshindernis durch Schulterdystokie",
      "Geburtshindernis durch eingekeilte Schultern"
    ]
  },
  {
    "code": "O66.1",
    "name": "Geburtshindernis durch verhakte Zwillinge",
    "synonyms": [
      "Entbindung festsitzender Zwillinge",
      "Geburtshindernis durch festsitzende Zwillinge",
      "Geburtshindernis durch verhakte Zwillinge"
    ]
  },
  {
    "code": "O66.2",
    "name": "Geburtshindernis durch ungewöhnlich großen Fetus",
    "synonyms": [
      "Dystokie durch ungewöhnlich großen Fetus",
      "Geburtshindernis durch ungewöhnlich großen Fetus",
      "Geburtshindernis durch übermäßig großen Fetus"
    ]
  },
  {
    "code": "O66.3",
    "name": "Dystokie durch fetale Anomalie",
    "synonyms": [
      "Dystokie durch Doppelfehlbildung",
      "Dystokie durch Hydrops fetalis",
      "Dystokie durch Hydrozephalus beim Fetus",
      "Dystokie durch fetale Anomalie",
      "Dystokie durch fetale Meningomyelozele",
      "Dystokie durch fetalen Aszites",
      "Dystokie durch fetalen Tumor",
      "Dystokie durch fetales Steißteratom",
      "Dystokie durch zusammengewachsene Zwillinge",
      "Fetale Deformität als Entbindungskomplikation",
      "Geburtshindernis durch Fetalanomalie",
      "Geburtshindernis durch Hydrozephalus des Fetus",
      "Geburtshindernis durch Tumor des Fetus",
      "Geburtshindernis durch fetale Deformität",
      "Geburtshindernis durch fetale Meningomyelozele",
      "Geburtshindernis durch fetales Steißteratom"
    ]
  },
  {
    "code": "O66.4",
    "name": "Fehlversuch einer Entbindung",
    "synonyms": [
      "Fehlversuch einer Entbindung",
      "Schnittentbindung bei fehlgeschlagenem Entbindungsversuch a.n.k."
    ]
  },
  {
    "code": "O66.5",
    "name": "Fehlversuch einer Zangenentbindung",
    "synonyms": [
      "Fehlgeschlagene Anwendung einer Zange mit nachfolgender Schnittentbindung a.n.k.",
      "Fehlgeschlagene Vakuumextraktion mit nachfolgender Schnittentbindung a.n.k.",
      "Fehlgeschlagene Vakuumextraktion mit nachfolgender Zangenentbindung a.n.k.",
      "Fehlversuch einer Zangenentbindung",
      "Schnittentbindung bei fehlgeschlagenem Schröpfkopf",
      "Schnittentbindung bei fehlgeschlagener Vakuumextraktion",
      "Schnittentbindung bei fehlgeschlagener Zangenanwendung"
    ]
  },
  {
    "code": "O66.8",
    "name": "Entbindungskomplikation durch Harnblasendilatation",
    "synonyms": [
      "Entbindungskomplikation durch Harnblasendilatation"
    ]
  },
  {
    "code": "O66.9",
    "name": "Geburtsbehinderung",
    "synonyms": [
      "Dystokie",
      "Dystokie durch fetale Ursachen",
      "Dystokie durch mütterliche Ursachen",
      "Geburtsbehinderung",
      "Geburtshindernis",
      "Mechanisch behinderte Geburt a.n.k.",
      "Obstruktive Wehen"
    ]
  },
  {
    "code": "O67.0",
    "name": "Intrapartale Blutung bei Gerinnungsstörung",
    "synonyms": [
      "Blutdyskrasie mit intrapartaler Blutung",
      "Defibrinationssyndrom mit intrapartaler Blutung",
      "Entbindungskomplikation durch Blutung bei Afibrinogenämie",
      "Entbindungskomplikation durch Blutung bei Gerinnungsdefekt",
      "Entbindungskomplikation durch Blutung bei Hyperfibrinolyse",
      "Entbindungskomplikation durch Blutung bei Hypofibrinogenämie",
      "Entbindungskomplikation durch Blutung bei Koagulationsdefekt",
      "Intrapartale Blutung bei Gerinnungsstörung",
      "Intrapartale Fibrinolyse",
      "Intrapartaler Gerinnungsdefekt",
      "Intrapartaler Koagulationsdefekt",
      "Verbrauchskoagulopathie intra partum",
      "Verstärkte intrapartale Blutung bei Afibrinogenämie",
      "Verstärkte intrapartale Blutung bei Hyperfibrinolyse",
      "Verstärkte intrapartale Blutung bei Hypofibrinogenämie",
      "Verstärkte intrapartale Blutung bei disseminierter intravasaler Gerinnung",
      "Verstärkte intrapartale Blutung bei intravaskulärer Hämolyse"
    ]
  },
  {
    "code": "O67.8",
    "name": "Verstärkte intrapartale Blutung",
    "synonyms": [
      "Entbindungskomplikation durch Leiomyom des Uterus mit Blutung",
      "Entbindungskomplikation durch Trauma mit Blutung",
      "Intrapartale Plazentablutung",
      "Intrapartale Plazentahämorrhagie",
      "Plazentablutung als Entbindungskomplikation a.n.k.",
      "Verstärkte intrapartale Blutung"
    ]
  },
  {
    "code": "O67.9",
    "name": "Intrapartale Blutung",
    "synonyms": [
      "Blutung als Entbindungskomplikation",
      "Blutung intra partum",
      "Haemorrhagia intra partum",
      "Hämorrhagie als Entbindungskomplikation",
      "Intrapartale Blutung",
      "Schnittentbindung bei intrapartaler Blutung"
    ]
  },
  {
    "code": "O68.0",
    "name": "Dip 0 [Dezeleration, intrapartal]",
    "synonyms": [
      "Dip 0 [Dezeleration, intrapartal]",
      "Dip 1 [Dezeleration, intrapartal]",
      "Dip 2 [Dezeleration, intrapartal]",
      "Fetale Arrhythmie bei Entbindung",
      "Fetale Bradykardie bei Entbindung",
      "Fetale Dezeleration bei Entbindung",
      "Fetale Herzrhythmusstörung als Entbindungskomplikation",
      "Fetale Herzschlagstörung als Entbindungskomplikation",
      "Fetale Tachykardie bei Entbindung",
      "Frühdezeleration",
      "Spätdezeleration",
      "Unregelmäßige fetale Herzfrequenz als Entbindungskomplikation"
    ]
  },
  {
    "code": "O68.1",
    "name": "Entbindungskomplikation durch Mekonium im Fruchtwasser",
    "synonyms": [
      "Entbindungskomplikation durch Mekonium im Fruchtwasser"
    ]
  },
  {
    "code": "O68.2",
    "name": "Entbindungskomplikation durch abnorme fetale Herzfrequenz mit Mekonium im Fruchtwasser",
    "synonyms": [
      "Entbindungskomplikation durch abnorme fetale Herzfrequenz mit Mekonium im Fruchtwasser",
      "Entbindungskomplikation durch fetale Herzrhythmusstörung mit Mekonium im Fruchtwasser"
    ]
  },
  {
    "code": "O68.3",
    "name": "Fetale Azidose bei Wehen",
    "synonyms": [
      "Entbindungskomplikation durch fetalen Distress, biochemisch nachgewiesen",
      "Fetale Azidose bei Entbindung",
      "Fetale Azidose bei Wehen",
      "Gestörter fetaler Säure-Basen-Haushalt bei Entbindung",
      "Gestörter fetaler Säure-Basen-Haushalt bei Wehen"
    ]
  },
  {
    "code": "O68.8",
    "name": "Nachweis von fetalem Distress bei Wehen durch Elektrokardiogramm",
    "synonyms": [
      "Nachweis von fetalem Distress bei Entbindung durch Elektrokardiogramm",
      "Nachweis von fetalem Distress bei Entbindung durch Ultraschall",
      "Nachweis von fetalem Distress bei Wehen durch Elektrokardiogramm",
      "Nachweis von fetalem Distress bei Wehen durch Ultraschall"
    ]
  },
  {
    "code": "O68.9",
    "name": "Fetaler Distress bei Entbindung durch Arzneimittelgabe",
    "synonyms": [
      "Fetaler Distress als Entbindungskomplikation",
      "Fetaler Distress bei Entbindung durch Arzneimittelgabe",
      "Fetaler Distress bei Wehen durch Arzneimittelgabe"
    ]
  },
  {
    "code": "O69.0",
    "name": "Nabelschnurprolaps als Entbindungskomplikation",
    "synonyms": [
      "Nabelschnurprolaps als Entbindungskomplikation",
      "Schnittentbindung bei Nabelschnurvorfall"
    ]
  },
  {
    "code": "O69.1",
    "name": "Nabelschnurkompression durch Nabelschnurumschlingung um den Hals",
    "synonyms": [
      "Nabelschnurkompression durch Nabelschnurumschlingung um den Hals"
    ]
  },
  {
    "code": "O69.2",
    "name": "Nabelschnurkompression als Entbindungskomplikation",
    "synonyms": [
      "Echter Nabelschnurknoten",
      "Nabelschnurknoten als Entbindungskomplikation",
      "Nabelschnurkompression als Entbindungskomplikation",
      "Nabelschnurumschlingung als Entbindungskomplikation",
      "Nabelschnurverschlingung bei monoamniotischen Zwillingen",
      "Nabelschnurverwicklung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O69.3",
    "name": "Kurze Nabelschnur als Entbindungskomplikation",
    "synonyms": [
      "Kurze Nabelschnur als Entbindungskomplikation",
      "Nabelschnurverkürzung"
    ]
  },
  {
    "code": "O69.4",
    "name": "Vasa praevia",
    "synonyms": [
      "Blutung der Vasa praevia",
      "Hämorrhagie der Vasa praevia",
      "Vasa praevia",
      "Vasa praevia als Entbindungskomplikation"
    ]
  },
  {
    "code": "O69.5",
    "name": "Nabelschnurquetschung als Entbindungskomplikation",
    "synonyms": [
      "Gefäßschädigung der Nabelschnur als Entbindungskomplikation",
      "Nabelschnurblutung als Entbindungskomplikation",
      "Nabelschnurgefäßthrombose",
      "Nabelschnurhämatom",
      "Nabelschnurhämatom als Entbindungskomplikation",
      "Nabelschnurhämorrhagie als Entbindungskomplikation",
      "Nabelschnurquetschung",
      "Nabelschnurquetschung als Entbindungskomplikation",
      "Nabelschnurthrombose als Entbindungskomplikation",
      "Nabelvenenthrombose als Entbindungskomplikation"
    ]
  },
  {
    "code": "O69.8",
    "name": "Nabelschnurtorsion als Entbindungskomplikation",
    "synonyms": [
      "Fehlbildung der Nabelschnur als Entbindungskomplikation a.n.k.",
      "Insertio velamentosa der Nabelschnur als Entbindungskomplikation",
      "Nabelschnurriss als Entbindungskomplikation",
      "Nabelschnurruptur als Entbindungskomplikation",
      "Nabelschnurtorsion als Entbindungskomplikation",
      "Nabelschnurumschlingung ohne Kompression als Entbindungskomplikation"
    ]
  },
  {
    "code": "O69.9",
    "name": "Nabelschnurkomplikation als Entbindungskomplikation",
    "synonyms": [
      "Abnorme Nabelschnur als Entbindungskomplikation",
      "Nabelschnuranomalie mit Komplikationen bei Wehen",
      "Nabelschnurkomplikation als Entbindungskomplikation",
      "Nabelschnurveränderung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O70.0",
    "name": "Dammriss 1. Grades bei Geburt",
    "synonyms": [
      "Dammriss 1. Grades bei Geburt",
      "Dammriss mit Beteiligung der Labien bei Geburt",
      "Dammriss mit Beteiligung der Schamlippen bei Geburt",
      "Dammriss mit Beteiligung der Vagina bei Geburt",
      "Dammriss mit Beteiligung der Vulva bei Geburt",
      "Dammriss mit Beteiligung des Frenulum labiorum pudendi bei Geburt",
      "Dammriss mit Beteiligung des Hymens bei Geburt",
      "Dammverletzung bei Entbindung",
      "Entbindungskomplikation durch Vaginazerreißung mit Dammriss",
      "Geringfügige Perineumruptur bei Geburt",
      "Geringfügige Perineumverletzung bei Geburt",
      "Geringfügiger Perineumriss bei Geburt",
      "Labienlazeration als Entbindungskomplikation",
      "Lazeration des Frenulum labiorum pudendi als Entbindungskomplikation",
      "Lazeration des periurethralen Gewebes als Geburtsverletzung der Mutter",
      "Perineumriss mit Beteiligung der Haut bei Geburt",
      "Perineumriss mit Beteiligung der Labien bei Geburt",
      "Perineumriss mit Beteiligung der Vagina bei Geburt",
      "Perineumriss mit Beteiligung der Vulva bei Geburt",
      "Perineumriss mit Beteiligung des Frenulum labiorum pudendi bei Geburt",
      "Perineumruptur mit Beteiligung der Haut bei Geburt",
      "Perineumruptur mit Beteiligung der Labien bei Geburt",
      "Perineumruptur mit Beteiligung der Vagina bei Geburt",
      "Perineumruptur mit Beteiligung der Vulva bei Geburt",
      "Perineumruptur mit Beteiligung des Frenulum labiorum pudendi bei Geburt",
      "Perineumverletzung mit Beteiligung der Haut bei Geburt",
      "Perineumverletzung mit Beteiligung der Labien bei Geburt",
      "Perineumverletzung mit Beteiligung der Vagina bei Geburt",
      "Perineumverletzung mit Beteiligung der Vulva bei Geburt",
      "Perineumverletzung mit Beteiligung des Frenulum labiorum pudendi bei Geburt",
      "Riss von periurethralem Gewebe bei Geburt",
      "Ruptur des periurethralen Gewebes bei Geburt",
      "Schamlippenlazeration als Entbindungskomplikation",
      "Scheidendammriss 1. Grades bei Geburt",
      "Vaginalazeration als Entbindungskomplikation",
      "Vaginalazeration mit Beteiligung des Perineums bei Geburt",
      "Vaginaruptur als Entbindungskomplikation",
      "Verletzung des periurethralen Gewebes bei Geburt",
      "Vulvalazeration als Entbindungskomplikation",
      "Vulvariss als Entbindungskomplikation",
      "Vulvaruptur als Entbindungskomplikation",
      "Vulvaverletzung bei Entbindung"
    ]
  },
  {
    "code": "O70.1",
    "name": "Dammriss 2. Grades bei Geburt",
    "synonyms": [
      "Beckenbodenlazeration als Entbindungskomplikation",
      "Beckenbodenperforation als Entbindungskomplikation",
      "Beckenbodenriss als Entbindungskomplikation",
      "Beckenbodenruptur als Entbindungskomplikation",
      "Beckenbodenverletzung als Entbindungskomplikation",
      "Beckenbodenzerreißung als Entbindungskomplikation",
      "Dammriss 2. Grades bei Geburt",
      "Dammriss mit Beteiligung der Dammmuskulatur bei Geburt",
      "Dammriss mit Beteiligung der Vaginalmuskulatur bei Geburt",
      "Dammriss mit Beteiligung des Beckenbodens bei Geburt",
      "Entbindungskomplikation durch Vaginalmuskelzerreißung mit Dammriss",
      "Scheidendammriss 2. Grades bei Geburt"
    ]
  },
  {
    "code": "O70.2",
    "name": "Dammriss 3. Grades bei Geburt",
    "synonyms": [
      "Analsphinkterruptur als Entbindungskomplikation",
      "Anuslazeration als Entbindungskomplikation",
      "Anuszerreißung als Entbindungskomplikation",
      "Dammriss 3. Grades bei Geburt",
      "Dammriss mit Beteiligung des Septum rectovaginale bei Geburt",
      "Dammriss mit Beteiligung des Sphincter ani bei Geburt",
      "Dammriss mit Beteiligung eines Sphinkters bei Geburt",
      "Rektovaginale Lazeration mit Beteiligung des Perineums bei Geburt",
      "Scheidendammriss 3. Grades bei Geburt"
    ]
  },
  {
    "code": "O70.3",
    "name": "Dammriss 4. Grades bei Geburt",
    "synonyms": [
      "Anuslazeration mit Zerreißung der Analschleimhaut als Entbindungskomplikation",
      "Anuslazeration mit Zerreißung der Rektumschleimhaut als Entbindungskomplikation",
      "Dammriss 4. Grades bei Geburt",
      "Dammriss mit Beteiligung der Analschleimhaut bei Geburt",
      "Dammriss mit Beteiligung der Rektumschleimhaut bei Geburt",
      "Entbindungskomplikation durch Zerreißung der Analschleimhaut",
      "Entbindungskomplikation durch Zerreißung des Sphincter ani mit Analschleimhaut",
      "Entbindungskomplikation durch Zerreißung des Sphincter ani mit Rektumschleimhaut",
      "Scheidendammriss 4. Grades bei Geburt"
    ]
  },
  {
    "code": "O70.9",
    "name": "Dammriss bei Entbindung",
    "synonyms": [
      "Dammriss als Entbindungskomplikation",
      "Dammriss bei Entbindung",
      "Episiotomie mit nachfolgendem Weiterreißen",
      "Weiterreißen des Dammes nach Episiotomie",
      "Zentrale Dammlazeration als Entbindungskomplikation",
      "Zentraler Dammriss bei Entbindung"
    ]
  },
  {
    "code": "O71.0",
    "name": "Uterusruptur vor Wehenbeginn",
    "synonyms": [
      "Uterusriss vor Wehenbeginn",
      "Uterusruptur vor Wehenbeginn",
      "Uteruszerreißung vor Wehenbeginn"
    ]
  },
  {
    "code": "O71.1",
    "name": "Uterusruptur bei Geburt",
    "synonyms": [
      "Eindringen von Instrumenten in den graviden Uterus als Entbindungskomplikation",
      "Ruptur des graviden Uterus während der Wehen",
      "Uteruslazeration als Geburtsverletzung der Mutter a.n.k.",
      "Uterusperforation als Geburtsverletzung der Mutter",
      "Uterusriss bei Geburt",
      "Uterusruptur als Entbindungskomplikation",
      "Uterusruptur bei Geburt",
      "Uteruszerreißung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O71.2",
    "name": "Postpartale Inversio uteri",
    "synonyms": [
      "Inversio uteri bei Entbindung",
      "Postpartale Inversio uteri"
    ]
  },
  {
    "code": "O71.3",
    "name": "Zervixriss bei Geburt",
    "synonyms": [
      "Emmet-Riss",
      "Lazeration der Cervix uteri als Geburtsverletzung der Mutter",
      "Perforation der Cervix uteri als Geburtsverletzung der Mutter",
      "Ringförmige Abtrennung der Cervix uteri bei Entbindung",
      "Ringförmige Zervixabtrennung bei Entbindung",
      "Riss der Cervix uteri bei Geburt",
      "Ruptur der Cervix uteri als Entbindungskomplikation",
      "Ruptur der Cervix uteri als Geburtsverletzung der Mutter",
      "Zerreißung der Cervix uteri als Entbindungskomplikation",
      "Zervixlazeration bei Entbindung",
      "Zervixriss bei Geburt",
      "Zervixruptur als Entbindungskomplikation",
      "Zervixruptur als Geburtsverletzung der Mutter",
      "Zervixzerreißung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O71.4",
    "name": "Hoher Scheidenriss bei Entbindung",
    "synonyms": [
      "Hoher Scheidenriss bei Entbindung",
      "Hoher Scheidenriss bei Entbindung ohne Dammriss",
      "Hoher Vaginalriss bei Entbindung",
      "Rektovaginale Lazeration als Entbindungskomplikation",
      "Riss am Sulcus vaginalis unter der Geburt",
      "Riss im mittleren Scheidendrittel unter der Geburt",
      "Riss im oberen Scheidendrittel unter der Geburt"
    ]
  },
  {
    "code": "O71.5",
    "name": "Harnblasenverletzung bei Geburt",
    "synonyms": [
      "Beckenorganlazeration bei Geburt",
      "Beckenorganriss als Geburtsverletzung der Mutter",
      "Beckenorganruptur als Entbindungskomplikation",
      "Beckenorganruptur bei Geburt",
      "Beckenorganschädigung als Entbindungskomplikation",
      "Beckenorganverletzung bei Geburt a.n.k.",
      "Darmlazeration als Geburtsverletzung der Mutter",
      "Darmperforation als Geburtsverletzung der Mutter",
      "Darmruptur als Geburtsverletzung der Mutter",
      "Darmzerreißung als Entbindungskomplikation",
      "Duodenalperforation als Geburtsverletzung der Mutter",
      "Duodenalruptur als Geburtsverletzung der Mutter",
      "Geburtsverletzung der Harnröhre",
      "Geburtsverletzung der Urethra",
      "Harnblasenlazeration als Geburtsverletzung der Mutter",
      "Harnblasenperforation als Geburtsverletzung der Mutter",
      "Harnblasenriss als Geburtsverletzung der Mutter",
      "Harnblasenruptur als Entbindungskomplikation",
      "Harnblasenruptur als Geburtsverletzung der Mutter",
      "Harnblasenverletzung bei Geburt",
      "Harnblasenzerreißung als Entbindungskomplikation",
      "Ileumperforation als Geburtsverletzung der Mutter",
      "Ileumruptur als Geburtsverletzung der Mutter",
      "Intestinalperforation als Geburtsverletzung der Mutter",
      "Intestinalruptur als Geburtsverletzung der Mutter",
      "Jejunumperforation als Geburtsverletzung der Mutter",
      "Jejunumruptur als Geburtsverletzung der Mutter",
      "Kolonperforation als Geburtsverletzung der Mutter",
      "Kolonruptur als Geburtsverletzung der Mutter",
      "Peritoneumlazeration als Geburtsverletzung der Mutter",
      "Peritoneumzerreißung als Entbindungskomplikation",
      "Periurethraler Einriss mit Beteiligung der Urethra",
      "Rektumperforation als Geburtsverletzung der Mutter",
      "Rektumruptur als Geburtsverletzung der Mutter",
      "Sigmaperforation als Geburtsverletzung der Mutter",
      "Sigmaruptur als Geburtsverletzung der Mutter",
      "Urethralazeration als Geburtsverletzung der Mutter",
      "Urethraperforation als Geburtsverletzung der Mutter",
      "Urethrariss bei Geburt",
      "Urethraruptur als Entbindungskomplikation",
      "Urethraruptur als Geburtsverletzung der Mutter",
      "Urethraverletzung bei Geburt",
      "Urethrazerreißung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O71.6",
    "name": "Verletzung des Steißbeins bei Geburt",
    "synonyms": [
      "Abriss des Symphysenknorpels bei Geburt",
      "Auseinanderweichen der Symphyse als Entbindungskomplikation",
      "Auseinanderweichen des Os pubis als Entbindungskomplikation",
      "Beckenbandschädigung bei Geburt",
      "Beckengelenkschädigung bei Geburt",
      "Lazeration des Ligamentum latum uteri als Geburtsverletzung der Mutter",
      "Perforation des Ligamentum latum uteri als Geburtsverletzung der Mutter",
      "Riss des Ligamentum latum uteri als Geburtsverletzung der Mutter",
      "Schambeinabtrennung bei Geburt",
      "Schambeinfugenruptur bei Geburt",
      "Sprengung der Symphyse bei Entbindung",
      "Steißbeinfraktur bei Geburt",
      "Steißbeinschädigung als Entbindungskomplikation",
      "Steißbeinschädigung bei Geburt",
      "Symphysenabtrennung bei Geburt",
      "Symphysenspaltenluxation bei Geburt",
      "Traumatische Symphysenruptur bei Geburt",
      "Traumatische Symphysensprengung bei Geburt",
      "Traumatischer Symphyseneinriss bei Geburt",
      "Verletzung des Steißbeins bei Geburt",
      "Verletzung eines Beckenbandes bei Geburt",
      "Verletzung eines Beckengelenks bei Geburt"
    ]
  },
  {
    "code": "O71.7",
    "name": "Beckenhämatom bei Geburt",
    "synonyms": [
      "Beckenhämatom bei Entbindung",
      "Beckenhämatom bei Geburt",
      "Dammhämatom bei Entbindung",
      "Perineumhämatom bei Geburt",
      "Sitzbeinstachelhämatom als Entbindungskomplikation",
      "Vaginalhämatom bei Entbindung",
      "Vaginalhämatom bei Geburt",
      "Vulvahämatom bei Entbindung",
      "Vulvahämatom bei Geburt"
    ]
  },
  {
    "code": "O71.8",
    "name": "Rektusdiastase als Entbindungskomplikation",
    "synonyms": [
      "Auseinanderweichen der Musculi recti abdominis als Entbindungskomplikation",
      "Rektusdiastase als Entbindungskomplikation"
    ]
  },
  {
    "code": "O71.9",
    "name": "Verletzung der Mutter bei Geburt",
    "synonyms": [
      "Geburtshilfliche Verletzung a.n.k.",
      "Geburtshilfliche Verletzung als Entbindungskomplikation",
      "Geburtsverletzung der Mutter",
      "Geburtsverletzung der Mutter als Entbindungskomplikation",
      "Geburtsverletzung der Mutter durch ein Instrument",
      "Geburtsverletzung der mütterlichen Geschlechtsorgane",
      "Trauma als Entbindungskomplikation a.n.k.",
      "Verletzung bei Geburtshilfe a.n.k.",
      "Verletzung der Mutter bei Geburt"
    ]
  },
  {
    "code": "O72.0",
    "name": "Blutung in der Nachgeburtsperiode",
    "synonyms": [
      "Blutung in der Nachgeburtsperiode",
      "Lösungsblutung",
      "Nachblutung bei Plazentaretention",
      "Nachgeburtsblutung",
      "Partielle Plazentaretention",
      "Plazentaadhäsion als Entbindungskomplikation",
      "Plazentarest nach Spontangeburt",
      "Plazentaretention",
      "Plazentaretention mit Blutung",
      "Plazentaretention mit Blutung als Entbindungskomplikation",
      "Postpartale Blutung durch zurückgebliebene Plazenta",
      "Postpartale Hämorrhagie durch zurückgebliebene Plazenta",
      "Retention der Nachgeburt mit Blutung als Entbindungskomplikation"
    ]
  },
  {
    "code": "O72.1",
    "name": "Postpartale Blutung",
    "synonyms": [
      "Atonische Blutung nach Entbindung",
      "Atonische Hämorrhagie nach Entbindung",
      "Atonische Metrorrhagie post partum a.n.k.",
      "Atonische postpartale Blutung",
      "Blutung im Wochenbett",
      "Blutung nach Ausstoßung der Plazenta",
      "Blutung nach Ausstoßung des Fetus",
      "Blutung nach Geburt des Kindes",
      "Blutung post partum",
      "Haemorrhagia post partum a.n.k.",
      "Hypotone Uteruskontraktion a.n.k.",
      "Hämorrhagie post partum",
      "Metrorrhagie nach Ausstoßung der Plazenta",
      "Metrorrhagie post partum a.n.k.",
      "Postpartale Blutung",
      "Postpartale Hämorrhagie",
      "Postpartale Nachblutung",
      "Postpartale Uterushypotonie",
      "Puerperale Blutung",
      "Puerperale Hämorrhagie",
      "Uterusatonie",
      "Uterushypotonie"
    ]
  },
  {
    "code": "O72.2",
    "name": "Späte Nachblutung nach Entbindung",
    "synonyms": [
      "Metrorrhagie im Wochenbett",
      "Partielle Retentio secundinae",
      "Partielle Retention der Nachgeburt als Entbindungskomplikation",
      "Plazentaretention als Entbindungskomplikation",
      "Puerperale kapilläre Blutung",
      "Puerperale kapilläre Hämorrhagie",
      "Retentio secundinae im Wochenbett",
      "Retention der Dezidua mit Blutung",
      "Retention der Eihäute als Entbindungskomplikation",
      "Retention von Eihautresten",
      "Retention von Eihautresten mit Blutung",
      "Retention von Konzeptionsprodukten nach der Entbindung",
      "Retention von Plazentafragmenten mit Blutung",
      "Retention von Plazentaresten",
      "Retention von Plazentaresten mit Blutung",
      "Retentionsmembran als Entbindungskomplikation mit Blutung",
      "Sekundäre Nachblutung nach Entbindung",
      "Sekundäre postpartale Blutung",
      "Sekundäre postpartale Hämorrhagie",
      "Sekundäre puerperale Hämorrhagie",
      "Späte Nachblutung nach Entbindung",
      "Späte postpartale Blutung",
      "Späte postpartale Hämorrhagie",
      "Späte postpartale Nachblutung",
      "Verzögerte Blutung im Wochenbett",
      "Verzögerte Blutung im Wochenbett durch zurückgebliebene Plazentareste",
      "Verzögerte puerperale Hämorrhagie"
    ]
  },
  {
    "code": "O72.3",
    "name": "Postpartale Gerinnungsstörung",
    "synonyms": [
      "Afibrinogenämie im Wochenbett",
      "Antithrombinämie nach Entbindung",
      "Antithromboplastinogenämie nach Entbindung",
      "Antithromboplastinämie nach Entbindung",
      "Blutdyskrasie im Wochenbett",
      "Hyperheparinämie nach Entbindung",
      "Hämorrhagische Diathese durch Antikörper gegen Gerinnungsfaktoren nach Entbindung",
      "Koagulopathie im Wochenbett",
      "Postpartale Afibrinogenämie",
      "Postpartale Blutdyskrasie",
      "Postpartale Blutungsneigung",
      "Postpartale Fibrinolyse",
      "Postpartale Gerinnungsstörung",
      "Postpartale Thrombozytopenie",
      "Postpartale intravaskuläre Hämolyse",
      "Postpartaler Gerinnungsdefekt",
      "Postpartaler Koagulationsdefekt",
      "Postpartaler Koagulationsfaktorenmangel",
      "Postpartales Defibrinationssyndrom",
      "Puerperale Blutdyskrasie",
      "Puerperale Thrombozytopenie",
      "Thrombozytopenie im Wochenbett",
      "Verbrauchskoagulopathie post partum"
    ]
  },
  {
    "code": "O73.0",
    "name": "Plazentaretention ohne Blutung",
    "synonyms": [
      "Plazentaretention als Entbindungskomplikation ohne Blutung",
      "Plazentaretention ohne Blutung",
      "Retentio secundinae ohne Blutung",
      "Retention der Nachgeburt als Entbindungskomplikation ohne Blutung"
    ]
  },
  {
    "code": "O73.1",
    "name": "Plazentarest ohne Blutung",
    "synonyms": [
      "Partielle Retentio secundinae ohne Blutung",
      "Partielle Retention der Nachgeburt als Entbindungskomplikation ohne Blutung",
      "Plazentarest ohne Blutung",
      "Retention von Konzeptionsprodukten nach der Entbindung ohne Blutung",
      "Retention von Plazentafragmenten ohne Blutung"
    ]
  },
  {
    "code": "O74.0",
    "name": "Aspiration durch Anästhesie bei Geburt",
    "synonyms": [
      "Aspiration durch Anästhesie bei Geburt",
      "Aspiration von Mageninhalt durch Anästhesie während der Entbindung",
      "Aspiration von Mageninhalt durch Anästhesie während der Wehentätigkeit",
      "Aspiration von Magensekret durch Anästhesie während der Entbindung",
      "Aspiration von Magensekret durch Anästhesie während der Wehentätigkeit",
      "Aspirationspneumonie durch Anästhesie während der Entbindung",
      "Aspirationspneumonie durch Anästhesie während der Wehentätigkeit",
      "Chemische Pneumonitis durch Aspiration bei Anästhesie während der Entbindung",
      "Chemische Pneumonitis durch Aspiration bei Anästhesie während der Wehentätigkeit",
      "Mendelson-Syndrom bei Entbindung",
      "Mendelson-Syndrom durch Anästhesie während der Entbindung",
      "Mendelson-Syndrom durch Anästhesie während der Wehentätigkeit",
      "Pneumonie durch Anästhesie während der Entbindung",
      "Pneumonie durch Anästhesie während der Wehentätigkeit",
      "Pneumonitis durch Anästhesie während der Entbindung",
      "Pneumonitis durch Anästhesie während der Wehentätigkeit",
      "Postoperative Pneumonitis während der Entbindung",
      "Postoperative Pneumonitis während der Wehentätigkeit"
    ]
  },
  {
    "code": "O74.1",
    "name": "Pulmonale Geburtskomplikation durch Anästhesie",
    "synonyms": [
      "Pneumothorax durch Anästhesie während der Entbindung",
      "Pneumothorax durch Anästhesie während der Wehentätigkeit",
      "Pulmonale Geburtskomplikation durch Anästhesie",
      "Pulmonaler Kollaps durch Anästhesie bei Geburt"
    ]
  },
  {
    "code": "O74.2",
    "name": "Kardiale Geburtskomplikation durch Anästhesie",
    "synonyms": [
      "Herzstillstand durch Anästhesie während der Entbindung",
      "Herzstillstand durch Anästhesie während der Wehentätigkeit",
      "Herzversagen durch Anästhesie während der Entbindung",
      "Herzversagen durch Anästhesie während der Wehentätigkeit",
      "Kardiale Geburtskomplikation durch Anästhesie"
    ]
  },
  {
    "code": "O74.3",
    "name": "Geburtskomplikation des Zentralnervensystems durch Anästhesie",
    "synonyms": [
      "Geburtskomplikation des Zentralnervensystems durch Anästhesie",
      "Zerebrale Anoxie durch Anästhesie während Entbindung",
      "Zerebrale Anoxie durch Anästhesie während der Wehentätigkeit"
    ]
  },
  {
    "code": "O74.4",
    "name": "Toxische Reaktion auf Lokalanästhesie bei Wehen und Entbindung",
    "synonyms": [
      "Toxische Reaktion auf Lokalanästhesie bei Wehen und Entbindung"
    ]
  },
  {
    "code": "O74.5",
    "name": "Kopfschmerzen nach Spinal- oder Periduralanästhesie bei der Entbindung",
    "synonyms": [
      "Kopfschmerzen nach Spinal- oder Periduralanästhesie bei der Entbindung"
    ]
  },
  {
    "code": "O74.6",
    "name": "Komplikation bei Spinal- und Periduralanästhesie bei Wehen und Entbindung a.n.k.",
    "synonyms": [
      "Komplikation bei Spinal- und Periduralanästhesie bei Wehen und Entbindung a.n.k."
    ]
  },
  {
    "code": "O74.7",
    "name": "Schwierigkeiten bei der Intubation bei der Entbindung",
    "synonyms": [
      "Misslingen der Intubation bei der Entbindung",
      "Schwierigkeiten bei der Intubation bei der Entbindung"
    ]
  },
  {
    "code": "O74.9",
    "name": "Geburtskomplikation durch Narkose",
    "synonyms": [
      "Geburtskomplikation durch Narkose",
      "Komplikation bei der Mutter durch Verabreichung eines Allgemeinanästhetikums während der Entbindung",
      "Komplikation bei der Mutter durch Verabreichung eines Allgemeinanästhetikums während der Wehentätigkeit",
      "Komplikation bei der Mutter durch Verabreichung eines Analgetikums während der Entbindung",
      "Komplikation bei der Mutter durch Verabreichung eines Analgetikums während der Wehentätigkeit",
      "Komplikation bei der Mutter durch Verabreichung eines Lokalanästhetikums während der Entbindung",
      "Komplikation bei der Mutter durch Verabreichung eines Lokalanästhetikums während der Wehentätigkeit",
      "Komplikation bei der Mutter durch eine Beruhigungsmaßnahme während der Entbindung",
      "Komplikation bei der Mutter durch eine Beruhigungsmaßnahme während der Wehentätigkeit",
      "Komplikation durch Sedierung bei Wehen und Entbindung",
      "Narkosetod als Entbindungskomplikation",
      "Narkosetod während der Entbindung",
      "Tod durch Anästhesie als Entbindungskomplikation",
      "Tod durch Anästhesie während der Entbindung"
    ]
  },
  {
    "code": "O75.0",
    "name": "Maternaler Distress bei Entbindung",
    "synonyms": [
      "Maternaler Distress bei Entbindung",
      "Schnittentbindung bei maternalem Distress"
    ]
  },
  {
    "code": "O75.1",
    "name": "Schock bei Wehen und Entbindung",
    "synonyms": [
      "Geburtsschock",
      "Kreislaufkollaps bei Wehen und Entbindung",
      "Schock bei Wehen und Entbindung",
      "Vaskulärer Kollaps bei Wehen und Entbindung"
    ]
  },
  {
    "code": "O75.2",
    "name": "Fieber bei Wehen",
    "synonyms": [
      "Fieber bei Geburt",
      "Fieber bei Wehen"
    ]
  },
  {
    "code": "O75.3",
    "name": "Allgemeine Infektion bei Wehen",
    "synonyms": [
      "Allgemeine Infektion bei Wehen",
      "Infektion bei Geburt a.n.k.",
      "Sepsis bei Geburt",
      "Sepsis bei Wehen"
    ]
  },
  {
    "code": "O75.4",
    "name": "Herzstillstand nach Schnittentbindung",
    "synonyms": [
      "Herzinsuffizienz als Entbindungskomplikation",
      "Herzstillstand nach Schnittentbindung",
      "Herzstillstand nach einer geburtshilflichen Maßnahme (einschließlich Entbindung)",
      "Herzversagen nach Schnittentbindung",
      "Herzversagen nach einer geburtshilflichen Maßnahme (einschließlich Entbindung)",
      "Zerebrale Anoxie nach Schnittentbindung",
      "Zerebrale Anoxie nach einer geburtshilflichen Maßnahme (einschließlich Entbindung)"
    ]
  },
  {
    "code": "O75.5",
    "name": "Protrahierte Geburt nach Blasensprengung",
    "synonyms": [
      "Künstlich eingeleiteter Blasensprung mit verzögerter Entbindung",
      "Protrahierte Geburt nach Blasensprengung",
      "Verzögerte Entbindung nach Blasensprengung"
    ]
  },
  {
    "code": "O75.6",
    "name": "Verzögerte Entbindung nach Blasensprung",
    "synonyms": [
      "Durchsickern von Fruchtwasser mit verzögerter Entbindung",
      "Protrahierte Geburt nach Blasensprung",
      "Verzögerte Entbindung nach Blasensprung"
    ]
  },
  {
    "code": "O75.7",
    "name": "Vaginale Entbindung nach vorangegangener Schnittentbindung",
    "synonyms": [
      "Vaginale Entbindung nach vorangegangener Schnittentbindung"
    ]
  },
  {
    "code": "O75.8",
    "name": "Stoffwechselstörung bei Wehen und Entbindung",
    "synonyms": [
      "Hypotonie bei Wehen und Entbindung",
      "Stoffwechselstörung bei Wehen und Entbindung",
      "Wehen mit akutem Nierenversagen"
    ]
  },
  {
    "code": "O75.9",
    "name": "Wehen und Entbindung mit Komplikation",
    "synonyms": [
      "Entbindungskomplikation",
      "Entbindungskomplikation nach vorangegangener Schnittentbindung",
      "Geburtsstillstand",
      "Wehen und Entbindung mit Komplikation"
    ]
  },
  {
    "code": "O80",
    "name": "Spontangeburt eines Einlings",
    "synonyms": [
      "Einlingsgeburt",
      "Entbindung",
      "Entbindung eines Einlings",
      "Eröffnungswehen",
      "Normale Entbindung",
      "Normale Geburt",
      "Partus",
      "Spontane Entbindung",
      "Spontane Vaginalgeburt eines Einlings",
      "Spontanentbindung aus Beckenendlage",
      "Spontanentbindung aus Schädellage",
      "Spontangeburt",
      "Spontangeburt aus Beckenendlage",
      "Spontangeburt aus Schädellage",
      "Spontangeburt eines Einlings",
      "Unkomplizierte Entbindung"
    ]
  },
  {
    "code": "O81",
    "name": "Zangenentbindung mit Rotation aus Beckenmitte",
    "synonyms": [
      "Entbindung durch Kombination von Vakuum- und Zangenextraktion",
      "Entbindung durch Saugglocke a.n.k.",
      "Entbindung durch Vakuumextraktion a.n.k.",
      "Entbindung durch Vakuumextraktor",
      "Geburt durch Vakuumextraktion",
      "Vakuumentbindung",
      "Zangenentbindung a.n.k.",
      "Zangenentbindung aus Beckenausgang",
      "Zangenentbindung aus Beckenmitte",
      "Zangenentbindung mit Rotation aus Beckenmitte",
      "Zangengeburt"
    ]
  },
  {
    "code": "O82",
    "name": "Geburt durch elektive Schnittentbindung",
    "synonyms": [
      "Geburt durch Kaiserschnitt",
      "Geburt durch Schnittentbindung",
      "Geburt durch Schnittentbindung bei Gefahrenzustand für Mutter und Kind",
      "Geburt durch Schnittentbindung mit Hysterektomie",
      "Geburt durch Sektio",
      "Geburt durch elektive Schnittentbindung",
      "Primäre Sectio caesarea",
      "Primäre Sektio",
      "Re-Sectio caesarea a.n.k.",
      "Schnittentbindung",
      "Sectio caesarea",
      "Sekundäre Sectio caesarea",
      "Sekundäre Sektio"
    ]
  },
  {
    "code": "O85",
    "name": "Postpartale Endometritis",
    "synonyms": [
      "Allgemeine Infektion im Wochenbett",
      "Beckenperitonitis im Wochenbett",
      "Beckensepsis im Wochenbett",
      "Endometritis puerperalis",
      "Febris puerperalis",
      "Generalisierte Infektion im Wochenbett",
      "Kindbettfieber",
      "Kindbettfieber mit Sepsis",
      "Metroperitonitis im Wochenbett",
      "Metrosalpingitis im Wochenbett",
      "Metrovaginitis im Wochenbett",
      "Parametritis im Wochenbett",
      "Pelviperitonitis im Wochenbett",
      "Perimetrosalpingitis im Wochenbett",
      "Peritoneale Infektion im Wochenbett",
      "Peritoneumabszess im Wochenbett",
      "Peritonitis puerperalis",
      "Postpartale Endometritis",
      "Postpartale Peritonitis",
      "Postpartaler Peritoneumabszess",
      "Puerperale Pelviperitonitis",
      "Puerperale intrauterine Infektion",
      "Puerperalendometritis",
      "Puerperalfieber",
      "Puerperalperitonitis",
      "Puerperalsepsis",
      "Pyometra im Wochenbett",
      "Pyosalpingitis im Wochenbett",
      "Pyosalpinx im Wochenbett",
      "Pyämie im Wochenbett",
      "Salpingoperitonitis im Wochenbett",
      "Sepsis im Wochenbett",
      "Sepsis post partum",
      "Wochenbettfieber"
    ]
  },
  {
    "code": "O86.0",
    "name": "Wundinfektion einer Episiotomienaht",
    "synonyms": [
      "Infektion der Sektiowunde",
      "Infektion einer Episiotomiewunde",
      "Infizierte Dammnaht nach Entbindung",
      "Infizierte Schnittentbindungswunde nach Entbindung",
      "Puerperale Infektion der Dammnaht",
      "Puerperale Infektion der Episiotomie",
      "Puerperale Infektion der Schnittentbindungswunde",
      "Puerperale Infektion einer geburtshilflichen Operationswunde",
      "Wundinfektion einer Episiotomienaht",
      "Wundinfektion einer Sektionaht"
    ]
  },
  {
    "code": "O86.1",
    "name": "Vaginitis nach Entbindung",
    "synonyms": [
      "Abszess der Bartholin-Drüse im Wochenbett",
      "Abszess der Cervix uteri im Wochenbett",
      "Abszess der Geschlechtsorgane im Wochenbett",
      "Abszess der vulvovaginalen Drüsen im Wochenbett",
      "Adnexitis im Wochenbett",
      "Genitalorganinfektion im Wochenbett a.n.k.",
      "Genitaltraktinfektion im Wochenbett a.n.k.",
      "Infektion der Cervix uteri im Wochenbett",
      "Perikolpitis im Wochenbett",
      "Perimetritis im Wochenbett",
      "Perivaginitis im Wochenbett",
      "Postpartale Infektion der Genitalorgane",
      "Postpartale Vaginitis",
      "Postpartale Vulvitis",
      "Postpartale Zervizitis",
      "Postpartaler Abszess der Genitalorgane bei der Frau",
      "Postpartaler Abszess der Labia majora pudendi",
      "Postpartaler Abszess der Labia minora pudendi",
      "Postpartaler Vulvaabszess",
      "Puerperale Salpingo-Oophoritis",
      "Puerperale Vaginitis",
      "Puerperale Vulvitis",
      "Puerperale Zervizitis",
      "Puerperaler Abszess der Genitalorgane bei der Frau",
      "Puerperaler Abszess der Labia majora pudendi",
      "Puerperaler Abszess der Labia minora pudendi",
      "Puerperaler Vulvaabszess",
      "Salpingo-Oophoritis im Wochenbett",
      "Tuboovariale Krankheit im Wochenbett",
      "Uterusabszess im Wochenbett",
      "Vaginaabszess im Wochenbett",
      "Vaginalinfektion im Wochenbett",
      "Vaginitis im Wochenbett",
      "Vaginitis nach Entbindung",
      "Vaginorektaler Abszess im Wochenbett",
      "Vulvitis im Wochenbett",
      "Vulvovaginitis im Wochenbett",
      "Zervixabszess im Wochenbett",
      "Zervixinfektion im Wochenbett",
      "Zervizitis im Wochenbett",
      "Zervizitis nach Entbindung"
    ]
  },
  {
    "code": "O86.2",
    "name": "Postpartale Infektion des Harntraktes",
    "synonyms": [
      "Asymptomatische Harnwegsinfektion im Wochenbett",
      "Harnwegsabszess im Wochenbett a.n.k.",
      "Harnwegsinfektion im Wochenbett a.n.k.",
      "Nierenabszess im Wochenbett",
      "Niereninfektion im Wochenbett",
      "Perinephritis im Wochenbett",
      "Postpartale Infektion des Harntraktes",
      "Postpartale Niereninfektion",
      "Postpartale Pyelitis",
      "Postpartale Zystitis",
      "Postpartale Zystopyelitis",
      "Postpartale asymptomatische Bakteriurie",
      "Postpartaler Nierenabszess",
      "Puerperale Pyelitis",
      "Puerperale Zystitis",
      "Puerperale asymptomatische Bakteriurie",
      "Pyelitis im Wochenbett",
      "Pyelonephritis im Wochenbett",
      "Pyelonephrose im Wochenbett",
      "Pyelozystitis im Wochenbett",
      "Pyonephritis im Wochenbett",
      "Pyozystitis im Wochenbett",
      "Renale Infektion im Wochenbett",
      "Zystitis im Wochenbett",
      "Zystitis nach Entbindung",
      "Zystopyelitis im Wochenbett",
      "Zystopyelitis nach Entbindung"
    ]
  },
  {
    "code": "O86.3",
    "name": "Wochenbettinfektion des Urogenitaltraktes",
    "synonyms": [
      "Wochenbettinfektion des Urogenitaltraktes"
    ]
  },
  {
    "code": "O86.4",
    "name": "Pyrexie im Wochenbett",
    "synonyms": [
      "Fieber im Wochenbett",
      "Fieber nach Entbindung",
      "Fieberanfall im Wochenbett",
      "Postpartales Fieber",
      "Puerperale Infektion",
      "Pyrexie im Wochenbett",
      "Wochenbettinfektion"
    ]
  },
  {
    "code": "O86.8",
    "name": "Puerperales Erysipel",
    "synonyms": [
      "Lymphangitis im Wochenbett",
      "Lymphangitis nach Entbindung",
      "Lymphangitis post partum",
      "Postpartales Erysipel",
      "Puerperale Lymphangitis",
      "Puerperales Erysipel"
    ]
  },
  {
    "code": "O87.0",
    "name": "Oberflächliche Thrombophlebitis im Wochenbett",
    "synonyms": [
      "Oberflächliche Phlebitis im Wochenbett",
      "Oberflächliche Thrombophlebitis im Wochenbett",
      "Oberflächliche Thrombophlebitis nach Entbindung",
      "Oberflächliche Thrombophlebitis post partum",
      "Oberflächliche postpartale Phlebitis",
      "Oberflächliche postpartale Thrombose",
      "Puerperale oberflächliche Thrombophlebitis",
      "Puerperale oberflächliche Thrombose"
    ]
  },
  {
    "code": "O87.1",
    "name": "Tiefe Venenthrombose im Wochenbett",
    "synonyms": [
      "Beckenvenenthrombose bei Entbindung",
      "Beckenvenenthrombose im Wochenbett",
      "Phlebitis des Beckens im Wochenbett",
      "Phlegmasia alba dolens",
      "Phlegmasia alba dolens im Wochenbett",
      "Postpartale Beckenphlebitis",
      "Postpartale Phlegmasia alba dolens",
      "Postpartale Thrombophlebitis einer Beckenvene",
      "Postpartale Thrombose einer Beckenvene",
      "Postpartale tiefe Phlebitis",
      "Postpartale tiefe Thrombophlebitis",
      "Puerperale Beckenphlebitis",
      "Puerperale Thrombophlebitis einer Beckenvene",
      "Puerperale tiefe Venenthrombose",
      "Thrombophlebitis des Beckens im Wochenbett",
      "Tiefe Phlebitis im Wochenbett",
      "Tiefe Thrombophlebitis im Wochenbett",
      "Tiefe Venenthrombose im Wochenbett",
      "Tiefe postpartale Venenthrombose",
      "Tiefe puerperale Phlebothrombose"
    ]
  },
  {
    "code": "O87.2",
    "name": "Hämorrhoiden im Wochenbett",
    "synonyms": [
      "Hämorrhoiden im Wochenbett",
      "Varikose einer Analvene im Wochenbett",
      "Varikose einer Rektumvene im Wochenbett"
    ]
  },
  {
    "code": "O87.3",
    "name": "Hirnvenenthrombose im Wochenbett",
    "synonyms": [
      "Hirnvenenthrombose im Wochenbett",
      "Puerperale zerebrale venöse Thrombose",
      "Thrombose eines zerebralen Venensinus im Wochenbett",
      "Zerebrovenöse Sinusthrombose im Wochenbett"
    ]
  },
  {
    "code": "O87.8",
    "name": "Varikose im Wochenbett",
    "synonyms": [
      "Beinvarizen im Wochenbett",
      "Genitalvarizen im Wochenbett",
      "Perineumvarizen im Wochenbett",
      "Varikose im Wochenbett",
      "Variköse Beinvenen im Wochenbett",
      "Variköse Venen der Vulva im Wochenbett",
      "Variköse Venen des Perineums im Wochenbett",
      "Varizen im Wochenbett",
      "Venenvarikose im Wochenbett",
      "Vulvavarizen im Wochenbett"
    ]
  },
  {
    "code": "O87.9",
    "name": "Phlebopathie im Wochenbett",
    "synonyms": [
      "Phlebitis im Wochenbett",
      "Phlebopathie im Wochenbett",
      "Postpartale Phlebitis",
      "Postpartale Thrombophlebitis",
      "Postpartale Thrombose",
      "Postpartale Venenthrombose",
      "Puerperalphlebitis",
      "Puerperalphlebopathie",
      "Puerperalthrombose",
      "Thrombose im Wochenbett",
      "Venenkrankheit bei Geburt",
      "Venenkrankheit bei Wehentätigkeit",
      "Venenkrankheit im Wochenbett",
      "Venöse Komplikation im Wochenbett"
    ]
  },
  {
    "code": "O88.0",
    "name": "Luftembolie in der Gestationsperiode",
    "synonyms": [
      "Luftembolie bei Entbindung",
      "Luftembolie bei Gravidität",
      "Luftembolie bei Schwangerschaft",
      "Luftembolie im Wochenbett",
      "Luftembolie in der Gestationsperiode"
    ]
  },
  {
    "code": "O88.1",
    "name": "Fruchtwasserembolie",
    "synonyms": [
      "Amnioninfusionssyndrom",
      "Anaphylaktoides Syndrom der Schwangerschaft",
      "Entbindungskomplikation durch Fruchtwasserembolie",
      "Fruchtwasserembolie",
      "Fruchtwasserembolie im Wochenbett"
    ]
  },
  {
    "code": "O88.20",
    "name": "Lungenembolie im Wochenbett",
    "synonyms": [
      "Lungenembolie bei Geburt",
      "Lungenembolie bei Gravidität",
      "Lungenembolie bei Schwangerschaft",
      "Lungenembolie im Wochenbett",
      "Lungenembolie in der Gestationsperiode",
      "Puerperale Lungenembolie"
    ]
  },
  {
    "code": "O88.28",
    "name": "Thromboembolie in der Gestationsperiode",
    "synonyms": [
      "Blutgerinnselembolie bei Entbindung",
      "Blutgerinnselembolie bei Gravidität",
      "Blutgerinnselembolie bei Schwangerschaft",
      "Embolie als Entbindungskomplikation",
      "Embolie bei Entbindung",
      "Embolie bei Gravidität",
      "Embolie im Wochenbett",
      "Embolie in der Gestationsperiode",
      "Embolie in der Schwangerschaft",
      "Gehirnembolie bei Entbindung",
      "Gehirnembolie bei Schwangerschaft",
      "Gehirnembolie im Wochenbett",
      "Puerperale Embolie",
      "Thromboembolie im Wochenbett",
      "Thromboembolie in der Gestationsperiode"
    ]
  },
  {
    "code": "O88.3",
    "name": "Septische Embolie bei Entbindung",
    "synonyms": [
      "Pyämische Embolie bei Entbindung",
      "Pyämische Embolie bei Gravidität",
      "Pyämische Embolie bei Schwangerschaft",
      "Pyämische Embolie im Wochenbett",
      "Pyämische Embolie während der Gestationsperiode",
      "Septische Embolie bei Entbindung",
      "Septische Embolie bei Gravidität",
      "Septische Embolie bei Schwangerschaft",
      "Septische Embolie im Wochenbett"
    ]
  },
  {
    "code": "O88.8",
    "name": "Fettembolie bei Entbindung",
    "synonyms": [
      "Fettembolie bei Entbindung",
      "Fettembolie im Wochenbett",
      "Fettembolie in der Gestationsperiode",
      "Fettembolie in der Schwangerschaft"
    ]
  },
  {
    "code": "O89.0",
    "name": "Puerperales Mendelson-Syndrom",
    "synonyms": [
      "Aspiration von Mageninhalt durch Anästhesie im Wochenbett",
      "Aspiration von Magensekret durch Anästhesie im Wochenbett",
      "Aspirationspneumonie durch Anästhesie im Wochenbett",
      "Chemische Pneumonitis durch Aspiration bei Anästhesie im Wochenbett",
      "Mendelson-Syndrom durch Anästhesie im Wochenbett",
      "Pneumothorax durch Anästhesie im Wochenbett",
      "Postpartale Aspiration von Mageninhalt durch Anästhesie",
      "Postpartale Pneumonie nach Anästhesie",
      "Postpartaler Lungenkollaps durch Anästhesie",
      "Postpartales Mendelson-Syndrom",
      "Puerperale Aspiration von Mageninhalt durch Anästhesie",
      "Puerperaler Lungenkollaps durch Anästhesie",
      "Puerperales Mendelson-Syndrom",
      "Pulmonale Komplikation durch Anästhesie im Wochenbett"
    ]
  },
  {
    "code": "O89.1",
    "name": "Herzstillstand durch Anästhesie im Wochenbett",
    "synonyms": [
      "Herzstillstand durch Anästhesie im Wochenbett",
      "Herzversagen durch Anästhesie im Wochenbett",
      "Kardiale Komplikation durch Anästhesie im Wochenbett"
    ]
  },
  {
    "code": "O89.2",
    "name": "Zerebrale Anoxie durch Anästhesie im Wochenbett",
    "synonyms": [
      "Komplikation des Zentralnervensystems durch Anästhesie im Wochenbett",
      "Zerebrale Anoxie durch Anästhesie im Wochenbett"
    ]
  },
  {
    "code": "O89.3",
    "name": "Toxische postpartale Reaktion auf Lokalanästhesie",
    "synonyms": [
      "Toxische postpartale Reaktion auf Lokalanästhesie"
    ]
  },
  {
    "code": "O89.4",
    "name": "Kopfschmerzen nach Spinal- oder Periduralanästhesie im Wochenbett",
    "synonyms": [
      "Kopfschmerzen nach Spinal- oder Periduralanästhesie im Wochenbett"
    ]
  },
  {
    "code": "O89.5",
    "name": "Komplikation bei Spinal- und Periduralanästhesie im Wochenbett a.n.k.",
    "synonyms": [
      "Komplikation bei Spinal- und Periduralanästhesie im Wochenbett a.n.k."
    ]
  },
  {
    "code": "O89.6",
    "name": "Schwierigkeiten bei der Intubation im Wochenbett",
    "synonyms": [
      "Misslingen der Intubation im Wochenbett",
      "Schwierigkeiten bei der Intubation im Wochenbett"
    ]
  },
  {
    "code": "O89.8",
    "name": "Puerperaler Narkosetod a.n.k.",
    "synonyms": [
      "Postpartaler Narkosetod a.n.k.",
      "Postpartaler Tod durch Anästhesie",
      "Puerperaler Narkosetod a.n.k.",
      "Puerperaler Tod durch Anästhesie",
      "Tod im Wochenbett durch Anästhesie"
    ]
  },
  {
    "code": "O89.9",
    "name": "Komplikation bei Anästhesie im Wochenbett",
    "synonyms": [
      "Komplikation bei Anästhesie im Wochenbett",
      "Komplikation bei der Mutter durch Verabreichung eines Analgetikums im Wochenbett",
      "Komplikation bei der Mutter durch Verabreichung eines Lokalanästhetikums im Wochenbett",
      "Komplikation bei der Mutter durch eine Beruhigungsmaßnahme im Wochenbett"
    ]
  },
  {
    "code": "O90.0",
    "name": "Dehiszenz einer Schnittentbindungswunde",
    "synonyms": [
      "Aufreißen einer Sektiowunde",
      "Dehiszenz einer Schnittentbindungswunde",
      "Nahtdehiszenz einer Sektiowunde"
    ]
  },
  {
    "code": "O90.1",
    "name": "Dehiszenz einer geburtshilflichen Dammwunde",
    "synonyms": [
      "Dammriss post partum",
      "Dammrissdehiszenz",
      "Dammrisswunde im Wochenbett",
      "Dehiszenz einer Episiotomienaht",
      "Dehiszenz einer geburtshilflichen Dammnaht",
      "Dehiszenz einer geburtshilflichen Dammwunde",
      "Dehiszenz einer perinealen Wunde post partum",
      "Epidehiszenz",
      "Episiotomiedehiszenz",
      "Nahtdehiszenz einer Dammrisswunde",
      "Nahtdehiszenz nach Entbindung",
      "Sekundärer Dammriss",
      "Sekundärer perinealer Riss im Wochenbett",
      "Sekundärheilung eines Dammrisses"
    ]
  },
  {
    "code": "O90.2",
    "name": "Hämatom einer geburtshilfliche Wunde",
    "synonyms": [
      "Blutung einer Episiotomiewunde",
      "Blutung einer Sektiowunde",
      "Episiotomiehämatom",
      "Hämatom einer Episiotomiewunde",
      "Hämatom einer Sektiowunde",
      "Hämatom einer geburtshilfliche Wunde",
      "Hämatom einer geburtshilflichen Dammnaht",
      "Hämatom nach Dammriss im Wochenbett"
    ]
  },
  {
    "code": "O90.3",
    "name": "Kardiomyopathie im Wochenbett",
    "synonyms": [
      "Kardiomyopathie im Wochenbett",
      "Meadows-Syndrom",
      "Myokardiopathie im Wochenbett",
      "Postpartale Kardiomyopathie"
    ]
  },
  {
    "code": "O90.4",
    "name": "Akutes postpartales Nierenversagen",
    "synonyms": [
      "Akutes postpartales Nierenversagen",
      "Hepatorenales Syndrom im Wochenbett",
      "Hepatorenales Syndrom nach Wehen und Entbindung",
      "Lebernekrose mit Nierenversagen im Wochenbett",
      "Niereninsuffizienz nach Wehen und Entbindung",
      "Nierenversagen im Wochenbett",
      "Urämie durch Nierenversagen im Wochenbett"
    ]
  },
  {
    "code": "O90.5",
    "name": "Postpartale Thyreoiditis",
    "synonyms": [
      "Postpartale Thyreoiditis",
      "Puerperale Thyreoiditis",
      "Thyreoiditis im Wochenbett"
    ]
  },
  {
    "code": "O90.8",
    "name": "Puerperale Uterushypertrophie",
    "synonyms": [
      "Glomeruläre Krankheit im Wochenbett (Zustände unter N00-N07)",
      "Ikterus im Wochenbett",
      "Komplikation einer Schnittentbindungswunde a.n.k.",
      "Komplikation nach einer geburtshilflichen Dammnaht a.n.k.",
      "Lochialstauung",
      "Lochiometra",
      "Nachwehen",
      "Nekrose der Leber im Wochenbett (Zustände unter K72.0)",
      "Nephritis post partum",
      "Neuritis puerperalis",
      "Nierenkrankheit im Wochenbett a.n.k.",
      "Paralyse des Harnblasensphinkters im Wochenbett",
      "Plazentapolyp",
      "Plazentapolyp im Wochenbett",
      "Postpartale Neuritis",
      "Postpartale zervikovaginale Adhäsion",
      "Postpartales Zervixödem",
      "Postpartales Ödem der Cervix uteri",
      "Puerperale Nephritis",
      "Puerperale Subinvolutio uteri",
      "Puerperale Subinvolution",
      "Puerperale Uterushypertrophie",
      "Putride Lochien",
      "Subinvolutio uteri bei Entbindung",
      "Subinvolutio uteri im Wochenbett",
      "Uterusrückbildungsstörung im Wochenbett",
      "Verzögerte Uterusrückbildung im Wochenbett"
    ]
  },
  {
    "code": "O90.9",
    "name": "Wochenbettkomplikation",
    "synonyms": [
      "Krankheit im Wochenbett",
      "Puerperale Krankheit a.n.k.",
      "Wochenbettkomplikation"
    ]
  },
  {
    "code": "O91.00",
    "name": "Mamillenabszess in der Schwangerschaft",
    "synonyms": [
      "Abszess der Areola mammae im Wochenbett",
      "Brustwarzenabszess im Wochenbett",
      "Brustwarzeninfektion im Wochenbett",
      "Brustwarzeninfektion in der Schwangerschaft",
      "Gestationsbedingte Brustwarzenentzündung",
      "Gestationsbedingte Thelitis",
      "Mamillenabszess im Wochenbett",
      "Mamillenabszess in der Schwangerschaft",
      "Mamilleninfektion in der Schwangerschaft",
      "Postpartale Entzündung der Areola mammae",
      "Postpartale Infektion der Brustwarze",
      "Postpartale Mamillitis",
      "Postpartale Thelitis",
      "Postpartaler Abszess der Areola mammae",
      "Postpartaler Abszess der Brustwarze",
      "Puerperale Entzündung der Areola mammae",
      "Puerperale Mamillitis",
      "Puerperale Thelitis",
      "Schwangerschaftsbedingter Brustwarzenabszess",
      "Thelitis im Wochenbett"
    ]
  },
  {
    "code": "O91.01",
    "name": "Gestationsbedingte Brustwarzeninfektion mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Gestationsbedingte Brustwarzeninfektion mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O91.10",
    "name": "Mammaabszess in der Schwangerschaft",
    "synonyms": [
      "Brustdrüsenabszess im Wochenbett",
      "Brustdrüsenfistel durch Mastitis im Wochenbett",
      "Eitrige Mastitis im Wochenbett",
      "Eitrige Mastitis puerperalis",
      "Eitrige gestationsbedingte Lymphadenitis der Mamma",
      "Eitrige puerperale Lymphadenitis der Mamma",
      "Gestationsbedingte Brustdrüseneiterung",
      "Gestationsbedingte Brustdrüsenfistel durch Mastitis",
      "Gestationsbedingte Brustwarzenfistel durch Mastitis",
      "Gestationsbedingte Mammaeiterung",
      "Gestationsbedingte Mammafistel durch Mastitis",
      "Mammaabszess im Wochenbett",
      "Mammaabszess in der Schwangerschaft",
      "Mammafistel durch Mastitis im Wochenbett",
      "Postpartale Brustdrüseneiterung",
      "Postpartale Brustdrüsenfistel durch Mastitis",
      "Postpartale Brustwarzenfistel durch Mastitis",
      "Postpartale Fistula mamillaris",
      "Postpartale Mammaeiterung",
      "Postpartale Mammafistel",
      "Postpartale Mammafistel durch Mastitis",
      "Postpartale eitrige Mastitis",
      "Puerperale Brustdrüseneiterung",
      "Puerperale Brustdrüsenfistel durch Mastitis",
      "Puerperale Brustwarzenfistel durch Mastitis",
      "Puerperale Fistula mamillaris",
      "Puerperale Mammaeiterung",
      "Puerperale Mammafistel",
      "Puerperale Milchfistel",
      "Puerperaler Brustdrüsenabszess",
      "Puerperaler Mammaabszess",
      "Schwangerschaftsbedingte eitrige Mastitis",
      "Schwangerschaftsbedingter Mammaabszess",
      "Schwangerschaftsbedingter Subareolärabszess",
      "Subareolärabszess im Wochenbett",
      "Warzenhofabszess im Wochenbett"
    ]
  },
  {
    "code": "O91.11",
    "name": "Gestationsbedingter Mammaabszess mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Gestationsbedingter Mammaabszess mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O91.20",
    "name": "Postpartale Infektion der Brust",
    "synonyms": [
      "Gestationsbedingte Brustdrüsenentzündung",
      "Gestationsbedingte Galaktophoritis",
      "Gestationsbedingte Lymphadenitis der Mamma",
      "Gestationsbedingte Lymphangitis der Mamma",
      "Gestationsbedingte Mammaentzündung",
      "Gestationsbedingte Mastitis",
      "Gestationsbedingte interstitielle Mastitis",
      "Gestationsbedingte parenchymatöse Mastitis",
      "Interstitielle Mastitis im Wochenbett",
      "Interstitielle Mastitis puerperalis",
      "Lymphangitis der Brustdrüse im Wochenbett",
      "Lymphangitis der Mamma im Wochenbett",
      "Mammainfektion in der Schwangerschaft",
      "Mastitis bei Gestation",
      "Mastitis bei Laktation a.n.k.",
      "Mastitis im Wochenbett",
      "Mastitis lactantium",
      "Mastitis puerperalis",
      "Nichteitrige Mastitis puerperalis",
      "Parenchymatöse Mastitis im Wochenbett",
      "Parenchymatöse Mastitis puerperalis",
      "Postpartale Brustdrüsenentzündung",
      "Postpartale Galaktophoritis",
      "Postpartale Infektion der Brust",
      "Postpartale Lymphadenitis der Mamma",
      "Postpartale Lymphangitis der Mamma",
      "Postpartale Mammaentzündung",
      "Postpartale Mastitis",
      "Puerperale Brustdrüsenentzündung",
      "Puerperale Galaktophoritis",
      "Puerperale Lymphadenitis der Mamma",
      "Puerperale Lymphangitis der Mamma",
      "Puerperale Mammaentzündung",
      "Puerperale interstitielle Mastitis",
      "Retentionsmastitis",
      "Schwangerschaftsbedingte Lymphangitis der Mamma",
      "Schwangerschaftsbedingte Mastitis",
      "Schwangerschaftsbedingte interstitielle Mastitis",
      "Schwangerschaftsbedingte parenchymatöse Mastitis",
      "Stauungsmastitis"
    ]
  },
  {
    "code": "O91.21",
    "name": "Gestationsbedingte nichteitrige Mastitis mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Gestationsbedingte nichteitrige Mastitis mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.00",
    "name": "Hohlwarze bei Gestation",
    "synonyms": [
      "Gestationsbedingte Brustwarzeninversion",
      "Gestationsbedingte Brustwarzenretraktion",
      "Hohlwarze bei Gestation",
      "Postpartale Brustwarzeninversion",
      "Postpartale Brustwarzenretraktion"
    ]
  },
  {
    "code": "O92.01",
    "name": "Hohlwarze bei Gestation mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Hohlwarze bei Gestation mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.10",
    "name": "Brustwarzenrhagade in der Schwangerschaft",
    "synonyms": [
      "Brustwarzenfissur im Wochenbett",
      "Brustwarzenrhagade in der Schwangerschaft",
      "Fissur der Brustwarze im Wochenbett",
      "Postpartale Brustrhagade",
      "Postpartale Brustwarzenrhagade",
      "Postpartale Fissur der Brustwarze",
      "Postpartale Rhagade der Mamille",
      "Schwangerschaftsbedingte Brustwarzenfissur"
    ]
  },
  {
    "code": "O92.11",
    "name": "Gestationsbedingte Brustwarzenrhagade mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Gestationsbedingte Brustwarzenrhagade mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.20",
    "name": "Postpartale Affektion der Mamma",
    "synonyms": [
      "Brustdrüsenatrophie im Wochenbett",
      "Brustdrüsenhypertrophie im Wochenbett",
      "Fibröse Mammainduration im Wochenbett",
      "Mammaatrophie im Wochenbett",
      "Mammahypertrophie im Wochenbett",
      "Postpartale Affektion der Mamma",
      "Postpartale Brustschwellung"
    ]
  },
  {
    "code": "O92.30",
    "name": "Agalaktie",
    "synonyms": [
      "Agalaktie",
      "Agalaktie im Wochenbett",
      "Ausbleibende Laktation",
      "Laktationsversagen",
      "Laktationsversagen im Wochenbett",
      "Primäre Agalaktie"
    ]
  },
  {
    "code": "O92.31",
    "name": "Agalaktie mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Agalaktie mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.40",
    "name": "Hypogalaktie",
    "synonyms": [
      "Hypogalaktie",
      "Hypogalaktie im Wochenbett",
      "Milchmangel im Wochenbett",
      "Partielles Ausbleiben der Laktation",
      "Postpartale Hypogalaktie",
      "Teilweises Versagen der Laktation im Wochenbett"
    ]
  },
  {
    "code": "O92.41",
    "name": "Hypogalaktie mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Hypogalaktie mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.50",
    "name": "Laktationshemmung",
    "synonyms": [
      "Abstillen",
      "Elektive Agalaktie",
      "Laktationshemmung",
      "Primäres Abstillen",
      "Sekundäre Agalaktie",
      "Sekundäres Abstillen",
      "Therapeutische Agalaktie",
      "Verminderte Laktation"
    ]
  },
  {
    "code": "O92.51",
    "name": "Hemmung der Laktation mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Hemmung der Laktation mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.60",
    "name": "Laktationsatrophie",
    "synonyms": [
      "Chiari-Frommel-Syndrom",
      "Galaktorrhoe",
      "Galaktorrhoe bei Schwangerschaft",
      "Galaktorrhoe im Wochenbett",
      "Hypergalaktie im Wochenbett",
      "Laktationsatrophie",
      "Milchfluss",
      "Milchhypersekretion",
      "Übermäßige Laktation",
      "Übermäßige Milchsekretion"
    ]
  },
  {
    "code": "O92.61",
    "name": "Galaktorrhoe mit Schwierigkeiten beim Anlegen",
    "synonyms": [
      "Galaktorrhoe mit Schwierigkeiten beim Anlegen"
    ]
  },
  {
    "code": "O92.70",
    "name": "Milchfieber im Wochenbett",
    "synonyms": [
      "Galaktostase",
      "Galaktozele im Wochenbett",
      "Laktationsstau",
      "Laktationsstörung a.n.k.",
      "Laktationsstörung im Wochenbett",
      "Milchfieber im Wochenbett",
      "Milchretention",
      "Milchstauung",
      "Milchstauung im Wochenbett",
      "Milchverhaltung",
      "Milchzyste im Wochenbett",
      "Postpartale Milchretention",
      "Puerperale Galaktozele",
      "Puerperale Laktationsstörung",
      "Puerperale Milchretention",
      "Schmerzhafter Milcheinschuss",
      "Stillangst",
      "Stillbeschwerden",
      "Stillhindernis",
      "Stillkonflikt",
      "Stillproblem",
      "Stillschwierigkeiten"
    ]
  },
  {
    "code": "O94",
    "name": "Folgen von Komplikationen während der Schwangerschaft",
    "synonyms": [
      "Folgen von Komplikationen im Wochenbett",
      "Folgen von Komplikationen während der Geburt",
      "Folgen von Komplikationen während der Schwangerschaft"
    ]
  },
  {
    "code": "O95",
    "name": "Sterbefall in der Gestationsperiode",
    "synonyms": [
      "Plötzlicher Tod unbekannter Ursache bei der Entbindung",
      "Plötzlicher Tod unbekannter Ursache im Wochenbett",
      "Plötzlicher Tod unbekannter Ursache in der Gestationsperiode",
      "Plötzlicher puerperaler Tod",
      "Postpartaler plötzlicher Tod unbekannter Ursache",
      "Sterbefall in der Gestationsperiode",
      "Tod durch Gravidität a.n.k.",
      "Tod durch Schwangerschaft a.n.k.",
      "Tod durch gestationsbedingte Ursachen"
    ]
  },
  {
    "code": "O96.0",
    "name": "Direkter gestationsbedingter Tod, zwischen 42 Tagen und einem Jahr nach Entbindung",
    "synonyms": [
      "Direkter gestationsbedingter Tod, zwischen 42 Tagen und einem Jahr nach Entbindung"
    ]
  },
  {
    "code": "O96.1",
    "name": "Indirekter gestationsbedingter Tod, zwischen 42 Tagen und einem Jahr nach Entbindung",
    "synonyms": [
      "Indirekter gestationsbedingter Tod, zwischen 42 Tagen und einem Jahr nach Entbindung"
    ]
  },
  {
    "code": "O96.9",
    "name": "Gestationsbedingter Tod, zwischen 42 Tagen und einem Jahr nach Entbindung",
    "synonyms": [
      "Gestationsbedingter Tod, zwischen 42 Tagen und einem Jahr nach Entbindung"
    ]
  },
  {
    "code": "O97.0",
    "name": "Direkter gestationsbedingter Tod, ein Jahr oder später nach Entbindung",
    "synonyms": [
      "Direkter gestationsbedingter Tod, ein Jahr oder später nach Entbindung"
    ]
  },
  {
    "code": "O97.1",
    "name": "Indirekter gestationsbedingter Tod, ein Jahr oder später nach Entbindung",
    "synonyms": [
      "Indirekter gestationsbedingter Tod, ein Jahr oder später nach Entbindung"
    ]
  },
  {
    "code": "O97.9",
    "name": "Gestationsbedingter Tod, ein Jahr oder später nach Entbindung",
    "synonyms": [
      "Gestationsbedingter Tod, ein Jahr oder später nach Entbindung"
    ]
  },
  {
    "code": "O98.0",
    "name": "Tuberkulose bei Schwangerschaft",
    "synonyms": [
      "Plazentatuberkulose",
      "Tuberkulose bei Schwangerschaft"
    ]
  },
  {
    "code": "O98.1",
    "name": "Syphilis bei Schwangerschaft",
    "synonyms": [
      "Lues bei Schwangerschaft",
      "Plazentasyphilis",
      "Syphilis bei Schwangerschaft",
      "Syphilitische Komplikation bei Entbindung oder im Wochenbett",
      "Syphilitische Komplikation bei Schwangerschaft",
      "Syphilitische Plazenta"
    ]
  },
  {
    "code": "O98.2",
    "name": "Gonokokken-Infektion bei Schwangerschaft",
    "synonyms": [
      "Gonokokken-Infektion bei Gravidität",
      "Gonokokken-Infektion bei Schwangerschaft",
      "Gonorrhoe bei Schwangerschaft"
    ]
  },
  {
    "code": "O98.3",
    "name": "Geschlechtskrankheit bei Schwangerschaft",
    "synonyms": [
      "Geschlechtskrankheit bei Schwangerschaft",
      "Gravidität mit Infektion, hauptsächlich durch Geschlechtsverkehr übertragen",
      "Schwangerschaft mit Infektion, hauptsächlich durch Geschlechtsverkehr übertragen"
    ]
  },
  {
    "code": "O98.4",
    "name": "Virushepatitis bei Schwangerschaft",
    "synonyms": [
      "Virushepatitis bei Geburt",
      "Virushepatitis bei Schwangerschaft",
      "Virushepatitis im Wochenbett"
    ]
  },
  {
    "code": "O98.5",
    "name": "Röteln bei Schwangerschaft",
    "synonyms": [
      "Rubella bei Schwangerschaft",
      "Röteln bei Schwangerschaft"
    ]
  },
  {
    "code": "O98.6",
    "name": "Malaria bei Schwangerschaft",
    "synonyms": [
      "Malaria bei Gravidität",
      "Malaria bei Schwangerschaft",
      "Protozoen-Krankheit bei Gravidität a.n.k.",
      "Protozoen-Krankheit bei Schwangerschaft a.n.k."
    ]
  },
  {
    "code": "O98.7",
    "name": "HIV-Krankheit bei Schwangerschaft",
    "synonyms": [
      "HIV-Krankheit bei Geburt",
      "HIV-Krankheit bei Schwangerschaft",
      "HIV-Krankheit im Wochenbett"
    ]
  },
  {
    "code": "O98.8",
    "name": "Kandidose bei Schwangerschaft",
    "synonyms": [
      "Infektiöse Krankheit bei Gravidität a.n.k.",
      "Kandidose bei Schwangerschaft",
      "Parasitäre Krankheit bei Gravidität a.n.k.",
      "Parasitäre Krankheit bei Schwangerschaft a.n.k."
    ]
  },
  {
    "code": "O98.9",
    "name": "Infektion bei Gravidität",
    "synonyms": [
      "Infektion bei Gravidität",
      "Infektion bei Schwangerschaft",
      "Infektiöse Krankheit bei Schwangerschaft",
      "Infektiöse Krankheit durch Entbindung",
      "Infektiöse Krankheit im Wochenbett"
    ]
  },
  {
    "code": "O99.0",
    "name": "Makrozytäre Anämie bei Gravidität",
    "synonyms": [
      "Anämie bei Gravidität",
      "Anämie im Wochenbett",
      "Eisenmangelanämie bei Gravidität",
      "Eisenmangelanämie bei Schwangerschaft",
      "Makrozytäre Anämie als Schwangerschaftskomplikation",
      "Makrozytäre Anämie bei Gravidität",
      "Makrozytäre Anämie bei Schwangerschaft",
      "Puerperale Anämie",
      "Puerperale Anämie durch Blutung",
      "Schwangerschaftsanämie"
    ]
  },
  {
    "code": "O99.2",
    "name": "Schilddrüsenfunktionsstörung bei Gravidität",
    "synonyms": [
      "Ernährungsmangelkrankheit bei Gravidität a.n.k.",
      "Ernährungsmangelkrankheit bei Schwangerschaft a.n.k.",
      "Schilddrüsenfunktionsstörung bei Gravidität",
      "Schilddrüsenfunktionsstörung bei Schwangerschaft",
      "Schwangerschaftskomplikation durch Schilddrüsendysfunktion",
      "Schwangerschaftskomplikation durch Thyreoideadysfunktion",
      "Stoffwechselkrankheit bei Gravidität",
      "Stoffwechselkrankheit bei Schwangerschaft"
    ]
  },
  {
    "code": "O99.3",
    "name": "Psychische Störung bei Gravidität",
    "synonyms": [
      "Abhängigkeit von Drogen bei Gravidität",
      "Alkoholabhängigkeit bei Schwangerschaft",
      "Arzneimittelabhängigkeit bei Gravidität",
      "Arzneimittelabhängigkeit bei Schwangerschaft",
      "Depression bei Gravidität",
      "Drogenabhängigkeit bei Schwangerschaft",
      "Generationspsychose",
      "Gestationspsychose",
      "Graviditätspsychoneurose",
      "Graviditätspsychose",
      "Medikamentenabhängigkeit bei Gravidität",
      "Polyneuritis bei Schwangerschaft",
      "Polyneuritis gestationis",
      "Psychische Störung bei Gravidität",
      "Psychische Störung bei Schwangerschaft",
      "Schwangerschaftsdepression",
      "Schwangerschaftspsychoneurose",
      "Schwangerschaftspsychose",
      "Seelische Störung bei Gravidität",
      "Seelische Störung bei Schwangerschaft",
      "Zerebrale Hemiplegie im Wochenbett"
    ]
  },
  {
    "code": "O99.4",
    "name": "Orthostatische Dysregulation bei Gravidität",
    "synonyms": [
      "Apoplexie im Wochenbett",
      "Bulbäre Blutung im Wochenbett",
      "Extradurale Blutung im Wochenbett",
      "Gehirnblutung als Entbindungskomplikation",
      "Gehirnblutung im Wochenbett",
      "Gehirnthrombose bei Entbindung",
      "Gehirnthrombose bei Schwangerschaft",
      "Gehirnthrombose im Wochenbett",
      "Intrakranielle Blutung im Wochenbett",
      "Intrapontine Blutung im Wochenbett",
      "Intrazerebrale Blutung als Entbindungskomplikation",
      "Intrazerebrale Blutung bei Schwangerschaft",
      "Intrazerebrale Blutung im Wochenbett",
      "Intrazerebrale Hämorrhagie als Entbindungskomplikation",
      "Intrazerebrale Hämorrhagie bei Schwangerschaft",
      "Intrazerebrale Hämorrhagie im Wochenbett",
      "Kardiomyopathie bei Schwangerschaft",
      "Kleinhirnblutung im Wochenbett",
      "Kortikale Blutung im Wochenbett",
      "Kreislaufdysfunktion bei Gravidität",
      "Kreislaufdysfunktion bei Schwangerschaft",
      "Kreislauflabilität bei Gravidität",
      "Kreislauflabilität bei Schwangerschaft",
      "Meningenblutung im Wochenbett",
      "Orthostatische Dysregulation bei Gravidität",
      "Orthostatische Dysregulation bei Schwangerschaft",
      "Pontine Blutung im Wochenbett",
      "Postpartale Gehirnblutung",
      "Postpartale Gehirnhämorrhagie",
      "Postpartale subarachnoidale Blutung",
      "Postpartale subarachnoidale Hämorrhagie",
      "Schlaganfall im Wochenbett",
      "Schnittentbindung bei mütterlicher Herzkrankheit a.n.k.",
      "Subarachnoidale Blutung im Wochenbett",
      "Subdurale Blutung im Wochenbett",
      "Subdurales Hämatom im Wochenbett",
      "Subkortikale Blutung im Wochenbett",
      "Ventrikuläre Blutung im Wochenbett",
      "Zerebrale Apoplexie als Entbindungskomplikation",
      "Zerebrale Blutung im Wochenbett",
      "Zerebrale Ischämie im Wochenbett",
      "Zerebrovaskuläre Affektion im Wochenbett",
      "Zerebrovaskuläre Krankheit als Entbindungskomplikation",
      "Zerebrovaskuläre Krankheit bei Schwangerschaft",
      "Zerebrovaskuläre Krankheit im Wochenbett",
      "Zerebrovaskuläre Störung im Wochenbett (Zustände unter I60-I69)"
    ]
  },
  {
    "code": "O99.5",
    "name": "Krankheiten des Atmungssystems, die Schwangerschaft, Geburt und Wochenbett komplizieren",
    "synonyms": [
      "Krankheiten des Atmungssystems, die Schwangerschaft, Geburt und Wochenbett komplizieren"
    ]
  },
  {
    "code": "O99.6",
    "name": "Appendizitis bei Gravidität",
    "synonyms": [
      "Appendizitis bei Gravidität",
      "Appendizitis bei Schwangerschaft",
      "Gingivitis gravidarum",
      "Schwangerschaftsgingivitis"
    ]
  },
  {
    "code": "O99.7",
    "name": "Papulöse Schwangerschaftsdermatose",
    "synonyms": [
      "Papulöse Schwangerschaftsdermatose",
      "Schwangerschaftsdermatose",
      "Schwangerschaftspigmentierung"
    ]
  },
  {
    "code": "O99.8",
    "name": "Anomale Glukosetoleranz bei Gravidität",
    "synonyms": [
      "Anomale Glukosetoleranz bei Gravidität",
      "Anomale Glukosetoleranz bei Schwangerschaft",
      "Gravidität bei kongenitaler Herz-Kreislauf-Krankheit",
      "Ischialgie bei Gravidität",
      "Ischialgie bei Schwangerschaft",
      "Lendenwirbelsäulensyndrom bei Gravidität",
      "Lendenwirbelsäulensyndrom bei Schwangerschaft",
      "Lumbago bei Gravidität",
      "Lumbago bei Schwangerschaft",
      "Lumboischialgie bei Gravidität",
      "Lumboischialgie bei Schwangerschaft",
      "Morbus von Bechterew bei Gravidität",
      "Morbus von Bechterew bei Schwangerschaft",
      "Neubildung bei Gravidität a.n.k.",
      "Neubildung bei Schwangerschaft a.n.k.",
      "Nichtgeburtshilfliche Störung im Wochenbett a.n.k.",
      "Osteomalazie bei Gravidität",
      "Osteomalazie bei Schwangerschaft",
      "Prädiabetes bei Schwangerschaft",
      "Schwangerschaft bei kongenitaler Herz-Kreislauf-Krankheit",
      "Tumor bei Gravidität a.n.k.",
      "Tumor bei Schwangerschaft a.n.k."
    ]
  },
  {
    "code": "P00.0",
    "name": "Fetusschädigung durch Präeklampsie",
    "synonyms": [
      "Fetusschädigung durch Eklampsie der Mutter",
      "Fetusschädigung durch Hypertonie der Mutter (Zustände unter O10-O11, O13-O16)",
      "Fetusschädigung durch Präeklampsie",
      "Fetusschädigung durch Toxikose der Mutter",
      "Fetusschädigung durch präeklamptische Proteinurie",
      "Schädigung des Neugeborenen durch Eklampsie der Mutter",
      "Schädigung des Neugeborenen durch Hypertonie der Mutter (Zustände unter O10-O11, O13-O16)",
      "Schädigung des Neugeborenen durch Präeklampsie",
      "Schädigung des Neugeborenen durch Toxikose der Mutter",
      "Schädigung des Neugeborenen durch präeklamptische Proteinurie"
    ]
  },
  {
    "code": "P00.1",
    "name": "Fetusschädigung durch Urämie der Mutter",
    "synonyms": [
      "Fetusschädigung durch Kortikalnekrose der Niere der Mutter",
      "Fetusschädigung durch Nephritis der Mutter (Zustände unter N00-N08)",
      "Fetusschädigung durch Nephrose der Mutter (Zustände unter N00-N08)",
      "Fetusschädigung durch Nierenabszess der Mutter",
      "Fetusschädigung durch Nierenkrankheit der Mutter",
      "Fetusschädigung durch Nierenrindennekrose der Mutter",
      "Fetusschädigung durch Nierenversagen der Mutter",
      "Fetusschädigung durch Proteinurie der Mutter",
      "Fetusschädigung durch Pyelitis der Mutter",
      "Fetusschädigung durch Pyelonephritis der Mutter",
      "Fetusschädigung durch Urämie der Mutter",
      "Fetusschädigung durch Zystitis der Mutter",
      "Fetusschädigung durch glomeruläre Krankheit der Mutter (Zustände unter N00-N08)",
      "Fetusschädigung durch nephrotisches Syndrom der Mutter (Zustände unter N00-N08)",
      "Schädigung des Neugeborenen durch Kortikalnekrose der Niere der Mutter",
      "Schädigung des Neugeborenen durch Nephritis der Mutter (Zustände unter N00-N08)",
      "Schädigung des Neugeborenen durch Nephrose der Mutter (Zustände unter N00-N08)",
      "Schädigung des Neugeborenen durch Nierenabszess der Mutter",
      "Schädigung des Neugeborenen durch Nierenkrankheit der Mutter",
      "Schädigung des Neugeborenen durch Nierenrindennekrose der Mutter",
      "Schädigung des Neugeborenen durch Nierenversagen der Mutter",
      "Schädigung des Neugeborenen durch Proteinurie der Mutter",
      "Schädigung des Neugeborenen durch Pyelitis der Mutter",
      "Schädigung des Neugeborenen durch Pyelonephritis der Mutter",
      "Schädigung des Neugeborenen durch Urämie der Mutter",
      "Schädigung des Neugeborenen durch Zystitis der Mutter",
      "Schädigung des Neugeborenen durch glomeruläre Krankheit der Mutter (Zustände unter N00-N08)",
      "Schädigung des Neugeborenen durch nephrotisches Syndrom der Mutter (Zustände unter N00-N08)"
    ]
  },
  {
    "code": "P00.2",
    "name": "Fetaler Schaden durch Viruskrankheit",
    "synonyms": [
      "Fetaler Schaden durch Listeriose",
      "Fetaler Schaden durch Toxoplasmose",
      "Fetaler Schaden durch Viruskrankheit",
      "Fetusschädigung durch Grippe [Influenza] der Mutter",
      "Fetusschädigung durch Malaria der Mutter",
      "Fetusschädigung durch Rubella der Mutter",
      "Fetusschädigung durch Röteln der Mutter (Zustände unter B06.-)",
      "Fetusschädigung durch Syphilis der Mutter (Zustände unter A50-A53)",
      "Fetusschädigung durch Tuberkulose der Mutter",
      "Fetusschädigung durch Zika-Viruskrankheit der Mutter",
      "Fetusschädigung durch akute Hepatitis der Mutter",
      "Fetusschädigung durch infektiöse Krankheit der Mutter (Zustände unter A00-B99, J09-J11)",
      "Fetusschädigung durch parasitäre Krankheit der Mutter (Zustände unter A00-B99, J09-J11)",
      "Schädigung des Neugeborenen durch COVID-19-Infektion der Mutter",
      "Schädigung des Neugeborenen durch Grippe [Influenza] der Mutter",
      "Schädigung des Neugeborenen durch Malaria der Mutter",
      "Schädigung des Neugeborenen durch Rubella der Mutter",
      "Schädigung des Neugeborenen durch Röteln der Mutter (Zustände unter B06.-)",
      "Schädigung des Neugeborenen durch Syphilis der Mutter (Zustände unter A50-A53)",
      "Schädigung des Neugeborenen durch Toxoplasmose der Mutter (Zustände unter B58.-)",
      "Schädigung des Neugeborenen durch Tuberkulose der Mutter",
      "Schädigung des Neugeborenen durch Zika-Viruskrankheit der Mutter",
      "Schädigung des Neugeborenen durch akute Hepatitis der Mutter",
      "Schädigung des Neugeborenen durch infektiöse Krankheit der Mutter (Zustände unter A00-B99, J09-J11)",
      "Schädigung des Neugeborenen durch parasitäre Krankheit der Mutter (Zustände unter A00-B99, J09-J11)"
    ]
  },
  {
    "code": "P00.3",
    "name": "Fetusschädigung durch kongenitale Herzkrankheit der Mutter (Zustände unter Q20-Q24)",
    "synonyms": [
      "Fetusschädigung durch Thrombophlebitis der Mutter",
      "Fetusschädigung durch antepartale Thrombophlebitis der Mutter",
      "Fetusschädigung durch kongenitale Herzkrankheit der Mutter (Zustände unter Q20-Q24)",
      "Fetusschädigung durch rheumatische Herzkrankheit der Mutter (Zustände unter I05-I09)",
      "Schädigung des Neugeborenen durch Thrombophlebitis der Mutter",
      "Schädigung des Neugeborenen durch antepartale Thrombophlebitis der Mutter",
      "Schädigung des Neugeborenen durch kongenitale Herzkrankheit der Mutter (Zustände unter Q20-Q24)",
      "Schädigung des Neugeborenen durch rheumatische Herzkrankheit der Mutter (Zustände unter I05-I09)"
    ]
  },
  {
    "code": "P00.4",
    "name": "Schädigung des Neugeborenen durch Malnutrition der Mutter",
    "synonyms": [
      "Fetusschädigung durch Ernährungsmangelkrankheit der Mutter",
      "Fetusschädigung durch Ernährungsstörung der Mutter (Zustände unter E40-E64)",
      "Fetusschädigung durch Fehlernährung der Mutter",
      "Fetusschädigung durch Malnutrition der Mutter",
      "Fetusschädigung durch Mangelernährung der Mutter",
      "Fetusschädigung durch maternalen Riboflavinmangel",
      "Schädigung des Neugeborenen durch Ernährungsmangelkrankheit der Mutter",
      "Schädigung des Neugeborenen durch Ernährungsstörung der Mutter (Zustände unter E40-E64)",
      "Schädigung des Neugeborenen durch Malnutrition der Mutter",
      "Schädigung des Neugeborenen durch Mangelernährung der Mutter"
    ]
  },
  {
    "code": "P00.5",
    "name": "Schädigung des Neugeborenen durch Sturz der Mutter",
    "synonyms": [
      "Fetusschädigung durch Sturz der Mutter",
      "Fetusschädigung durch Verletzung der Mutter während der Schwangerschaft",
      "Schädigung des Neugeborenen durch Sturz der Mutter",
      "Schädigung des Neugeborenen durch Verletzung der Mutter während der Schwangerschaft"
    ]
  },
  {
    "code": "P00.6",
    "name": "Fetusschädigung durch Operation der Mutter ohne Zusammenhang mit der Entbindung",
    "synonyms": [
      "Fetusschädigung durch Operation der Mutter ohne Zusammenhang mit der Entbindung",
      "Schädigung des Neugeborenen durch Operation der Mutter ohne Zusammenhang mit der Entbindung"
    ]
  },
  {
    "code": "P00.7",
    "name": "Fetusschädigung durch radiologische Maßnahmen bei der Mutter",
    "synonyms": [
      "Fetusschädigung durch radiologische Maßnahmen bei der Mutter"
    ]
  },
  {
    "code": "P00.8",
    "name": "Fetusschädigung durch Lebernekrose der Mutter",
    "synonyms": [
      "Fetusschädigung durch Endometritis der Mutter",
      "Fetusschädigung durch Genitalorganinfektion der Mutter",
      "Fetusschädigung durch Hepatitis der Mutter",
      "Fetusschädigung durch Lebernekrose der Mutter",
      "Fetusschädigung durch Vaginitis der Mutter",
      "Fetusschädigung durch Zervizitis der Mutter",
      "Fetusschädigung durch akute gelbe Leberatrophie der Mutter",
      "Fetusschädigung durch entzündliche Beckenkrankheit der Mutter",
      "Fetusschädigung durch mütterliche Infektion",
      "Fetusschädigung durch systemischen Lupus erythematodes der Mutter",
      "Fetusschädigung während der Schwangerschaft durch Salpingo-Oophoritis",
      "Neonataler Lupus erythematosus",
      "Schädigung des Neugeborenen durch Endometritis der Mutter",
      "Schädigung des Neugeborenen durch Hepatitis der Mutter",
      "Schädigung des Neugeborenen durch Lebernekrose der Mutter",
      "Schädigung des Neugeborenen durch Salpingo-Oophoritis während der Schwangerschaft",
      "Schädigung des Neugeborenen durch Vaginitis der Mutter",
      "Schädigung des Neugeborenen durch Zervizitis der Mutter",
      "Schädigung des Neugeborenen durch akute gelbe Leberatrophie der Mutter",
      "Schädigung des Neugeborenen durch entzündliche Beckenkrankheit der Mutter",
      "Schädigung des Neugeborenen durch mütterliche Infektion",
      "Schädigung des Neugeborenen durch systemischen Lupus erythematodes der Mutter"
    ]
  },
  {
    "code": "P00.9",
    "name": "Fetusschädigung durch Krankheit der Mutter a.n.k.",
    "synonyms": [
      "Fetusschädigung durch Krankheit der Mutter a.n.k.",
      "Schädigung des Neugeborenen durch Krankheit der Mutter a.n.k."
    ]
  },
  {
    "code": "P01.0",
    "name": "Schädigung des Neugeborenen durch Zervixinsuffizienz",
    "synonyms": [
      "Fetusschädigung durch Zervixdilatation",
      "Fetusschädigung durch Zervixinsuffizienz",
      "Schädigung des Neugeborenen durch Dilatation der Cervix uteri",
      "Schädigung des Neugeborenen durch Insuffizienz der Cervix uteri",
      "Schädigung des Neugeborenen durch Zervixdilatation",
      "Schädigung des Neugeborenen durch Zervixinsuffizienz"
    ]
  },
  {
    "code": "P01.1",
    "name": "Schädigung des Neugeborenen durch vorzeitigen Blasensprung",
    "synonyms": [
      "Fetusschädigung durch Blasensprung mit verzögerter Entbindung",
      "Fetusschädigung durch vorzeitigen Blasensprung",
      "Schädigung des Neugeborenen durch Blasensprung mit verzögerter Entbindung",
      "Schädigung des Neugeborenen durch vorzeitigen Blasensprung"
    ]
  },
  {
    "code": "P01.2",
    "name": "Fetusschädigung durch Oligohydramnion",
    "synonyms": [
      "Fetusschädigung durch Anhydramnion",
      "Fetusschädigung durch Oligohydramnion",
      "Schädigung des Neugeborenen durch Anhydramnion",
      "Schädigung des Neugeborenen durch Oligohydramnion"
    ]
  },
  {
    "code": "P01.3",
    "name": "Schädigung des Neugeborenen durch Hydramnion",
    "synonyms": [
      "Fetusschädigung durch Hydramnion",
      "Fetusschädigung durch Polyhydramnion",
      "Schädigung des Neugeborenen durch Hydramnion",
      "Schädigung des Neugeborenen durch Polyhydramnion"
    ]
  },
  {
    "code": "P01.4",
    "name": "Schädigung des Neugeborenen durch Gravidität im Uterushorn",
    "synonyms": [
      "Fetusschädigung durch Gravidität im Uterushorn",
      "Schädigung des Neugeborenen durch Gravidität im Uterushorn",
      "Schädigung des Neugeborenen durch Schwangerschaft im Uterushorn"
    ]
  },
  {
    "code": "P01.5",
    "name": "Fetusschädigung durch Mehrlingsgeburt",
    "synonyms": [
      "Fetusschädigung bei Vierlingsgravidität",
      "Fetusschädigung bei Zwillingsgravidität",
      "Fetusschädigung bei multipler Geburt",
      "Fetusschädigung durch Drillingsschwangerschaft",
      "Fetusschädigung durch Fünflingsgravidität",
      "Fetusschädigung durch Fünflingsschwangerschaft",
      "Fetusschädigung durch Geminigravidität",
      "Fetusschädigung durch Mehrlingsgeburt",
      "Fetusschädigung durch Sechslingsgravidität",
      "Fetusschädigung durch Sechslingsschwangerschaft",
      "Fetusschädigung durch Vierlingsschwangerschaft",
      "Fetusschädigung durch Zwillingsgeburt",
      "Fetusschädigung durch Zwillingsschwangerschaft",
      "Schädigung des Neugeborenen bei Drillingsschwangerschaft",
      "Schädigung des Neugeborenen bei Fünflingsgravidität",
      "Schädigung des Neugeborenen bei Fünflingsschwangerschaft",
      "Schädigung des Neugeborenen bei Gemini-Schwangerschaft",
      "Schädigung des Neugeborenen bei Geminigravidität",
      "Schädigung des Neugeborenen bei Mehrlingsgeburt",
      "Schädigung des Neugeborenen bei Sechslingsgravidität",
      "Schädigung des Neugeborenen bei Sechslingsschwangerschaft",
      "Schädigung des Neugeborenen bei Vierlingsgravidität",
      "Schädigung des Neugeborenen bei Vierlingsschwangerschaft",
      "Schädigung des Neugeborenen bei Zwillingsgeburt",
      "Schädigung des Neugeborenen bei Zwillingsgravidität",
      "Schädigung des Neugeborenen bei Zwillingsschwangerschaft",
      "Schädigung des Neugeborenen bei multipler Geburt"
    ]
  },
  {
    "code": "P01.6",
    "name": "Schädigung des Neugeborenen durch Schnittentbindung post mortem",
    "synonyms": [
      "Fetusschädigung durch Schnittentbindung post mortem",
      "Fetusschädigung durch Tod der Mutter",
      "Schädigung des Neugeborenen durch Schnittentbindung post mortem",
      "Schädigung des Neugeborenen durch Tod der Mutter"
    ]
  },
  {
    "code": "P01.7",
    "name": "Fetusschädigung durch Gesichtslage",
    "synonyms": [
      "Fetusschädigung durch Beckenendlage vor den Wehen",
      "Fetusschädigung durch Gesichtslage",
      "Fetusschädigung durch Gesichtslage vor den Wehen",
      "Fetusschädigung durch Querlage vor den Wehen",
      "Fetusschädigung durch wechselnde Kindslage vor den Wehen",
      "Fetusschädigung durch äußere Wendung vor den Wehen",
      "Schädigung des Neugeborenen durch Beckenendlage vor den Wehen",
      "Schädigung des Neugeborenen durch Gesichtslage",
      "Schädigung des Neugeborenen durch Gesichtslage vor den Wehen",
      "Schädigung des Neugeborenen durch Querlage vor den Wehen",
      "Schädigung des Neugeborenen durch wechselnde Kindslage vor den Wehen",
      "Schädigung des Neugeborenen durch äußere Wendung vor den Wehen",
      "Wechselnde Kindslage vor den Wehen",
      "Wechselnde Lage des Fetus vor den Wehen"
    ]
  },
  {
    "code": "P01.8",
    "name": "Fetusschädigung durch anhaltendes Erbrechen der Mutter",
    "synonyms": [
      "Fetusschädigung durch Abortus imminens",
      "Fetusschädigung durch Hyperemesis gravidarum",
      "Fetusschädigung durch anhaltendes Erbrechen der Mutter",
      "Fetusschädigung durch drohende Fehlgeburt",
      "Fetusschädigung durch drohende Wehen",
      "Fetusschädigung durch drohenden Abort",
      "Schädigung des Neugeborenen durch Hyperemesis gravidarum",
      "Schädigung des Neugeborenen durch anhaltendes Erbrechen der Mutter",
      "Spontanabort des Fetus"
    ]
  },
  {
    "code": "P01.9",
    "name": "Fetusschädigung durch Schwangerschaftskomplikation der Mutter a.n.k.",
    "synonyms": [
      "Fetusschädigung durch Schwangerschaftskomplikation der Mutter a.n.k.",
      "Schädigung des Neugeborenen durch Schwangerschaftskomplikation der Mutter a.n.k."
    ]
  },
  {
    "code": "P02.0",
    "name": "Schädigung des Neugeborenen durch tiefsitzende Plazenta",
    "synonyms": [
      "Fetusschädigung durch Placenta praevia",
      "Fetusschädigung durch tiefsitzende Plazenta",
      "Schädigung des Neugeborenen durch Placenta praevia",
      "Schädigung des Neugeborenen durch tiefsitzende Plazenta"
    ]
  },
  {
    "code": "P02.1",
    "name": "Fetusschädigung durch Abruptio placentae",
    "synonyms": [
      "Fetusschädigung durch Ablatio placentae",
      "Fetusschädigung durch Abruptio placentae",
      "Fetusschädigung durch Blutverlust der Mutter",
      "Fetusschädigung durch Plazentablutung",
      "Fetusschädigung durch Plazentahämorrhagie",
      "Fetusschädigung durch Plazentahämorrhagie durch chirurgische oder instrumentelle Schädigung",
      "Fetusschädigung durch Schädigung der Plazenta durch Amniozentese",
      "Fetusschädigung durch Schädigung der Plazenta durch Schnittentbindung",
      "Fetusschädigung durch akzidentelle Blutung der Mutter",
      "Fetusschädigung durch antepartalen Mangel an Koagulationsfaktoren",
      "Fetusschädigung durch gestationsbedingte Blutung der Mutter",
      "Fetusschädigung durch gestationsbedingte Hämorrhagie der Mutter",
      "Fetusschädigung durch intrapartale Verbrauchskoagulopathie",
      "Fetusschädigung durch mütterlichen Blutverlust",
      "Schädigung des Neugeborenen durch Blutverlust der Mutter",
      "Schädigung des Neugeborenen durch Plazentablutung durch chirurgische oder instrumentelle Schädigung",
      "Schädigung des Neugeborenen durch Plazentahämorrhagie durch chirurgische oder instrumentelle Schädigung",
      "Schädigung des Neugeborenen durch Schädigung der Plazenta durch Amniozentese",
      "Schädigung des Neugeborenen durch Schädigung der Plazenta durch Schnittentbindung",
      "Schädigung des Neugeborenen durch akzidentelle Blutung der Mutter",
      "Schädigung des Neugeborenen durch antepartalen Mangel an Koagulationsfaktoren",
      "Schädigung des Neugeborenen durch intrapartale Verbrauchskoagulopathie"
    ]
  },
  {
    "code": "P02.2",
    "name": "Fetusschädigung durch Plazentafehlbildung",
    "synonyms": [
      "Fetusschädigung durch Plazentaanomalie",
      "Fetusschädigung durch Plazentafehlbildung",
      "Fetusschädigung durch Plazentainfarkt",
      "Fetusschädigung durch Plazentainsuffizienz",
      "Fetusschädigung durch Plazentakrankheit",
      "Schädigung des Neugeborenen durch Plazentaanomalie",
      "Schädigung des Neugeborenen durch Plazentafehlbildung",
      "Schädigung des Neugeborenen durch Plazentainfarkt",
      "Schädigung des Neugeborenen durch Plazentainsuffizienz",
      "Schädigung des Neugeborenen durch Plazentakrankheit"
    ]
  },
  {
    "code": "P02.3",
    "name": "Zwillings-Transfusions-Syndrom",
    "synonyms": [
      "Fetusschädigung durch fetofetale Transfusion",
      "Fetusschädigung durch fetomaternale Transfusion",
      "Fetusschädigung durch transplazentare Transfusion",
      "Schädigung des Neugeborenen durch fetofetale Transfusion",
      "Schädigung des Neugeborenen durch fetomaternale Transfusion",
      "Schädigung des Neugeborenen durch transplazentare Transfusion",
      "Zwillings-Transfusions-Syndrom"
    ]
  },
  {
    "code": "P02.4",
    "name": "Fetusschädigung durch Nabelschnurvorfall",
    "synonyms": [
      "Fetusschädigung durch Nabelschnurvorfall",
      "Nabelschnurprolaps beim Fetus"
    ]
  },
  {
    "code": "P02.5",
    "name": "Fetusschädigung durch Nabelschnurkompression",
    "synonyms": [
      "Fetusschädigung durch Nabelschnurknoten",
      "Fetusschädigung durch Nabelschnurkompression",
      "Fetusschädigung durch Nabelschnurstrangulation",
      "Fetusschädigung durch Nabelschnurtorsion",
      "Fetusschädigung durch Nabelschnurumschlingung",
      "Fetusschädigung durch Nabelschnurverdrehung",
      "Fetusschädigung durch Nabelschnurverschlingung",
      "Fetusschädigung durch Nabelschnurverwicklung",
      "Fetusschädigung durch straff um den Hals gelegte Nabelschnur",
      "Schädigung des Neugeborenen durch straff um den Hals gelegte Nabelschnur"
    ]
  },
  {
    "code": "P02.6",
    "name": "Fetusschädigung durch Nabelschnurveränderung",
    "synonyms": [
      "Fetusschädigung durch Nabelschnurnekrose",
      "Fetusschädigung durch Nabelschnurquetschung",
      "Fetusschädigung durch Nabelschnurthrombose als Entbindungskomplikation",
      "Fetusschädigung durch Nabelschnurvarizen",
      "Fetusschädigung durch Nabelschnurverkürzung",
      "Fetusschädigung durch Nabelschnurveränderung",
      "Fetusschädigung durch Schädigung der Nabelschnurgefäße als Entbindungskomplikation",
      "Fetusschädigung durch Vasa praevia",
      "Fetusschädigung durch kurze Nabelschnur",
      "Schädigung des Neugeborenen durch Nabelschnurquetschung",
      "Schädigung des Neugeborenen durch Nabelschnurthrombose als Entbindungskomplikation",
      "Schädigung des Neugeborenen durch Nabelschnurverkürzung",
      "Schädigung des Neugeborenen durch Schädigung der Nabelschnurgefäße als Entbindungskomplikation",
      "Schädigung des Neugeborenen durch zu kurze Nabelschnur"
    ]
  },
  {
    "code": "P02.7",
    "name": "Fetusschädigung durch Plazentitis",
    "synonyms": [
      "Amnioninfektionssyndrom beim Neugeborenen",
      "Fetusschädigung durch Amnionitis",
      "Fetusschädigung durch Chorionamnionitis",
      "Fetusschädigung durch Entzündung der Eihäute",
      "Fetusschädigung durch Plazentitis",
      "Schädigung des Neugeborenen durch Amnionitis",
      "Schädigung des Neugeborenen durch Entzündung der Eihäute",
      "Schädigung des Neugeborenen durch Plazentitis"
    ]
  },
  {
    "code": "P02.8",
    "name": "Postinfektiöse Amnionadhäsion mit Schädigung des Neugeborenen",
    "synonyms": [
      "Postinfektiöse Amnionadhäsion mit Fetusschädigung",
      "Postinfektiöse Amnionadhäsion mit Schädigung des Neugeborenen"
    ]
  },
  {
    "code": "P02.9",
    "name": "Fetusschädigung durch Abnormität der Eihäute",
    "synonyms": [
      "Fetusschädigung durch Abnormität der Eihäute",
      "Fetusschädigung durch Amnionabnormität",
      "Fetusschädigung durch Chorionabnormität",
      "Fetusschädigung durch Störung der Eihäute",
      "Fetusschädigung durch Störung des Fruchtwassers",
      "Fetusschädigung durch abnormes Fruchtwasser",
      "Schädigung des Neugeborenen durch Amnionabnormität",
      "Schädigung des Neugeborenen durch Chorionabnormität",
      "Schädigung des Neugeborenen durch Störung der Eihäute",
      "Schädigung des Neugeborenen durch Störung des Fruchtwassers",
      "Schädigung des Neugeborenen durch abnormes Fruchtwasser"
    ]
  },
  {
    "code": "P03.0",
    "name": "Schädigung des Neugeborenen durch Extraktion aus Beckenendlage",
    "synonyms": [
      "Fetusschädigung durch Entbindung aus Beckenendlage",
      "Fetusschädigung durch Extraktion aus Beckenendlage",
      "Schädigung des Neugeborenen durch Entbindung aus Beckenendlage",
      "Schädigung des Neugeborenen durch Extraktion aus Beckenendlage"
    ]
  },
  {
    "code": "P03.1",
    "name": "Schädigung des Neugeborenen durch Dystokie",
    "synonyms": [
      "Armprolaps beim Fetus",
      "Armvorfall beim Fetus",
      "Beinprolaps beim Fetus",
      "Beinvorfall beim Fetus",
      "Fetusschädigung durch Beckendeformität mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch Beckenkontraktur mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch Beckenskoliose mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch Beckenverengung der Mutter",
      "Fetusschädigung durch Geburtshindernis",
      "Fetusschädigung durch Lendenwirbelsäulendistorsion mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch Lendenwirbelsäulenverformung mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch Querlage",
      "Fetusschädigung durch Querstand",
      "Fetusschädigung durch Schultereinklemmung",
      "Fetusschädigung durch Spondylose mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch Trichterbecken mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch androides Becken mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch persistierende hintere Hinterhauptslage",
      "Fetusschädigung durch pithekoides Becken mit fetopelvinem Missverhältnis",
      "Fetusschädigung durch tiefen Querstand",
      "Geburtshindernis durch Fehlbildung der Beckenorgane mit Fetusschädigung",
      "Geburtshindernis durch Fehlbildung der Beckenorgane mit Schädigung des Neugeborenen",
      "Gliedmaßenvorfall beim Fetus a.n.k.",
      "Handprolaps beim Fetus",
      "Schädigung des Neugeborenen durch Beckendeformität mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch Beckenkontraktur mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch Beckenskoliose mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch Beckenverengung der Mutter",
      "Schädigung des Neugeborenen durch Dystokie",
      "Schädigung des Neugeborenen durch Geburtshindernis",
      "Schädigung des Neugeborenen durch Lendenwirbelsäulendistorsion mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch Lendenwirbelsäulenverformung mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch Querlage",
      "Schädigung des Neugeborenen durch Querstand",
      "Schädigung des Neugeborenen durch Schultereinklemmung",
      "Schädigung des Neugeborenen durch Spondylose mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch Trichterbecken mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch androides Becken mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch persistierende hintere Hinterhauptslage",
      "Schädigung des Neugeborenen durch pithekoides Becken mit fetopelvinem Missverhältnis",
      "Schädigung des Neugeborenen durch tiefen Querstand"
    ]
  },
  {
    "code": "P03.2",
    "name": "Schädigung des Neugeborenen durch Zangengeburt",
    "synonyms": [
      "Schädigung des Neugeborenen durch Zangengeburt"
    ]
  },
  {
    "code": "P03.3",
    "name": "Schädigung des Neugeborenen durch Vakuumextraktion",
    "synonyms": [
      "Schädigung des Neugeborenen durch Vakuumextraktion"
    ]
  },
  {
    "code": "P03.4",
    "name": "Schädigung des Neugeborenen durch Schnittentbindung",
    "synonyms": [
      "Fetusschädigung durch Schnittentbindung",
      "Schädigung des Neugeborenen durch Schnittentbindung"
    ]
  },
  {
    "code": "P03.5",
    "name": "Schädigung des Neugeborenen durch Sturzgeburt",
    "synonyms": [
      "Fetusschädigung durch Sturzgeburt",
      "Fetusschädigung durch verkürzte Austreibungsperiode",
      "Schädigung des Neugeborenen durch Sturzgeburt",
      "Schädigung des Neugeborenen durch verkürzte Austreibungsperiode"
    ]
  },
  {
    "code": "P03.6",
    "name": "Fetusschädigung durch Bandl-Ring",
    "synonyms": [
      "Fetusschädigung durch Bandl-Ring",
      "Fetusschädigung durch Kontraktionsring",
      "Fetusschädigung durch Sanduhrkontraktur des Uterus",
      "Fetusschädigung durch Stillstand der aktiven Wehenphase",
      "Fetusschädigung durch Tetanus uteri",
      "Fetusschädigung durch Uterusatonie während der Wehentätigkeit",
      "Fetusschädigung durch Uterusdysfunktion als Entbindungskomplikation",
      "Fetusschädigung durch Wehenschwäche",
      "Fetusschädigung durch abnorme Wehentätigkeit",
      "Fetusschädigung durch anomale Wehen",
      "Fetusschädigung durch dyskoordinierte Wehen",
      "Fetusschädigung durch flüchtige Wehen",
      "Fetusschädigung durch hypertone Wehenform",
      "Fetusschädigung durch hypertonische Wehen",
      "Fetusschädigung durch irreguläre Wehen",
      "Fetusschädigung durch sporadische Wehen",
      "Fetusschädigung durch unkoordinierte Wehen",
      "Fetusschädigung durch unregelmäßige Wehen",
      "Fetusschädigung durch unvollständige Zervixdilatation",
      "Schädigung des Neugeborenen durch Bandl-Ring",
      "Schädigung des Neugeborenen durch Kontraktionsring",
      "Schädigung des Neugeborenen durch Sanduhrkontraktur des Uterus",
      "Schädigung des Neugeborenen durch Stillstand der aktiven Wehenphase",
      "Schädigung des Neugeborenen durch Tetanus uteri",
      "Schädigung des Neugeborenen durch Uterusatonie während der Wehentätigkeit",
      "Schädigung des Neugeborenen durch Uterusdysfunktion als Entbindungskomplikation",
      "Schädigung des Neugeborenen durch Wehenschwäche",
      "Schädigung des Neugeborenen durch abnorme Wehentätigkeit",
      "Schädigung des Neugeborenen durch anomale Wehen",
      "Schädigung des Neugeborenen durch dyskoordinierte Wehen",
      "Schädigung des Neugeborenen durch flüchtige Wehen",
      "Schädigung des Neugeborenen durch hypertone Wehenform",
      "Schädigung des Neugeborenen durch hypertonische Wehen",
      "Schädigung des Neugeborenen durch irreguläre Wehen",
      "Schädigung des Neugeborenen durch sporadische Wehen",
      "Schädigung des Neugeborenen durch unkoordinierte Wehen",
      "Schädigung des Neugeborenen durch unregelmäßige Wehen",
      "Schädigung des Neugeborenen durch unvollständige Dilatation der Cervix uteri",
      "Schädigung des Neugeborenen durch unvollständige Zervixdilatation"
    ]
  },
  {
    "code": "P03.8",
    "name": "Schädelzertrümmerung beim Fetus",
    "synonyms": [
      "Amputation am Fetus zur Geburtserleichterung",
      "Extraktion des Fetus mit Haken",
      "Fetale Dekapitation zur Geburtserleichterung",
      "Fetale Kranioklasie",
      "Fetale Kraniotomie",
      "Fetusschädigung bei Entbindung durch Beckentumor",
      "Fetusschädigung bei Entbindung durch Rektozele",
      "Fetusschädigung bei Entbindung durch Tumor des Perineums",
      "Fetusschädigung bei Entbindung durch Uterustumor",
      "Fetusschädigung bei Entbindung durch Vaginalstenose",
      "Fetusschädigung bei Entbindung durch Vaginaltumor",
      "Fetusschädigung bei Entbindung durch Vulvatumor",
      "Fetusschädigung bei Entbindung durch Zervixtumor",
      "Fetusschädigung durch Abnormität der Beckenorgane",
      "Fetusschädigung durch Beckenbodenrigidität",
      "Fetusschädigung durch Geburtseinleitung",
      "Fetusschädigung durch Hysterotomie",
      "Fetusschädigung durch Prolaps des graviden Uterus",
      "Fetusschädigung durch Uterus bicornis",
      "Fetusschädigung durch Uterus duplex",
      "Fetusschädigung durch Uterusanomalie",
      "Fetusschädigung durch Uterusanteversion",
      "Fetusschädigung durch Uterusfibromyom",
      "Fetusschädigung durch Uterusnarbe",
      "Fetusschädigung durch Uteruspolyp",
      "Fetusschädigung durch Uterusruptur nach den Wehen",
      "Fetusschädigung durch Uterusruptur während der Wehen",
      "Fetusschädigung durch Weichteilanomalie der Mutter",
      "Fetusschädigung durch Zervixnarbe",
      "Fetusschädigung durch Zervixpolyp",
      "Fetusschädigung durch Zervixrigidität",
      "Fetusschädigung durch Zervixstenose",
      "Fetusschädigung durch Zystozele der Mutter",
      "Fetusschädigung durch manuelle Rotation",
      "Fetusschädigung durch verlängerte Wehen",
      "Fetusschädigung während der Schwangerschaft durch Beckentumor",
      "Fetusschädigung während der Schwangerschaft durch Rektozele",
      "Fetusschädigung während der Schwangerschaft durch Tumor des Perineums",
      "Fetusschädigung während der Schwangerschaft durch Uterustumor",
      "Fetusschädigung während der Schwangerschaft durch Vaginaltumor",
      "Fetusschädigung während der Schwangerschaft durch Vulvatumor",
      "Fetusschädigung während der Schwangerschaft durch Zervixtumor",
      "Fetusschädigung während der Schwangerschaft durch doppelten Uterus",
      "Kindszerstückelung",
      "Kindszerstückelung zur Geburtserleichterung",
      "Kleidotomie beim Fetus",
      "Schädelzertrümmerung beim Fetus",
      "Schädigung des Neugeborenen bei Entbindung durch Beckentumor",
      "Schädigung des Neugeborenen bei Entbindung durch Rektozele",
      "Schädigung des Neugeborenen bei Entbindung durch Tumor der Cervix uteri",
      "Schädigung des Neugeborenen bei Entbindung durch Tumor des Perineums",
      "Schädigung des Neugeborenen bei Entbindung durch Uterustumor",
      "Schädigung des Neugeborenen bei Entbindung durch Vaginaltumor",
      "Schädigung des Neugeborenen bei Entbindung durch Vulvatumor",
      "Schädigung des Neugeborenen bei Entbindung durch Zervixtumor",
      "Schädigung des Neugeborenen durch Abnormität der Beckenorgane",
      "Schädigung des Neugeborenen durch Beckenbodenrigidität",
      "Schädigung des Neugeborenen durch Beckentumor während der Schwangerschaft",
      "Schädigung des Neugeborenen durch Entbindungsoperation",
      "Schädigung des Neugeborenen durch Geburtseinleitung",
      "Schädigung des Neugeborenen durch Hysterotomie",
      "Schädigung des Neugeborenen durch Narbe der Cervix uteri",
      "Schädigung des Neugeborenen durch Polyp der Cervix uteri",
      "Schädigung des Neugeborenen durch Prolaps des graviden Uterus",
      "Schädigung des Neugeborenen durch Rektozele während der Schwangerschaft",
      "Schädigung des Neugeborenen durch Rigidität der Cervix uteri",
      "Schädigung des Neugeborenen durch Stenose der Cervix uteri",
      "Schädigung des Neugeborenen durch Stenose der Vagina der Mutter",
      "Schädigung des Neugeborenen durch Striktur der Vagina der Mutter",
      "Schädigung des Neugeborenen durch Tumor der Cervix uteri während der Schwangerschaft",
      "Schädigung des Neugeborenen durch Tumor des Perineums während der Schwangerschaft",
      "Schädigung des Neugeborenen durch Uterus bicornis",
      "Schädigung des Neugeborenen durch Uterus duplex",
      "Schädigung des Neugeborenen durch Uterusanomalie",
      "Schädigung des Neugeborenen durch Uterusanteversion",
      "Schädigung des Neugeborenen durch Uterusfibromyom",
      "Schädigung des Neugeborenen durch Uterusnarbe",
      "Schädigung des Neu"
    ]
  },
  {
    "code": "P03.9",
    "name": "Schädigung des Neugeborenen durch anomale Geburt a.n.k.",
    "synonyms": [
      "Fetusschädigung durch abnormen Geburtsvorgang",
      "Schädigung des Neugeborenen durch Geburtsverzögerung",
      "Schädigung des Neugeborenen durch abnormen Geburtsvorgang",
      "Schädigung des Neugeborenen durch anomale Geburt a.n.k.",
      "Schädigung des Neugeborenen durch schwierige Geburt"
    ]
  },
  {
    "code": "P04.0",
    "name": "Fetusschädigung durch Analgesie der Mutter",
    "synonyms": [
      "Fetusschädigung durch Analgesie der Mutter",
      "Fetusschädigung durch Anästhesie der Mutter",
      "Fetusschädigung durch Narkose der Mutter",
      "Schädigung des Neugeborenen durch Analgesie der Mutter",
      "Schädigung des Neugeborenen durch Anästhesie der Mutter",
      "Schädigung des Neugeborenen durch Narkose der Mutter"
    ]
  },
  {
    "code": "P04.1",
    "name": "Fetaler Schaden durch Medikamente",
    "synonyms": [
      "Arzneimittelabsorption über die Plazenta",
      "Drogenabsorption über die Plazenta",
      "Fetaler Schaden durch Arzneimittel",
      "Fetaler Schaden durch Medikamente",
      "Fetusschädigung durch Chemotherapie bei Krebs der Mutter",
      "Fetusschädigung durch zytotoxisches Arzneimittel der Mutter",
      "Schädigung des Neugeborenen durch zytotoxisches Arzneimittel der Mutter"
    ]
  },
  {
    "code": "P04.2",
    "name": "Schädigung des Neugeborenen durch Tabakkonsum der Mutter",
    "synonyms": [
      "Fetusschädigung durch Tabakkonsum der Mutter",
      "Schädigung des Neugeborenen durch Tabakkonsum der Mutter"
    ]
  },
  {
    "code": "P04.3",
    "name": "Schaden durch Alkohol beim Fetus",
    "synonyms": [
      "Fetusschädigung durch Alkoholismus",
      "Fetusschädigung durch Alkoholkonsum der Mutter",
      "Neugeborenes mit Alkoholschaden",
      "Schaden durch Alkohol beim Fetus",
      "Schädigung des Neugeborenen durch Alkoholismus",
      "Schädigung des Neugeborenen durch Alkoholkonsum der Mutter"
    ]
  },
  {
    "code": "P04.4",
    "name": "Fetusschädigung durch Arzneimittelabhängigkeit der Mutter",
    "synonyms": [
      "Fetusschädigung durch Absorption eines abhängigkeitserzeugenden Arzneimittels über die Plazenta",
      "Fetusschädigung durch Arzneimittelabhängigkeit der Mutter",
      "Schädigung des Neugeborenen durch Absorption eines abhängigkeitserzeugenden Arzneimittels über die Plazenta",
      "Schädigung des Neugeborenen durch Arzneimittelabhängigkeit der Mutter"
    ]
  },
  {
    "code": "P04.5",
    "name": "Fetusschädigung durch Absorption chemischer Substanzen, die mit der Nahrung der Mutter aufgenommen wurden",
    "synonyms": [
      "Fetusschädigung durch Absorption chemischer Substanzen, die mit der Nahrung der Mutter aufgenommen wurden"
    ]
  },
  {
    "code": "P04.6",
    "name": "Fetusschädigung durch Absorption chemischer Substanzen aus der Umwelt",
    "synonyms": [
      "Fetusschädigung durch Absorption chemischer Substanzen aus der Umwelt",
      "Schädigung des Neugeborenen durch Absorption chemischer Substanzen aus der Umwelt"
    ]
  },
  {
    "code": "P04.8",
    "name": "Fetaler Schaden durch Bestrahlung",
    "synonyms": [
      "Fetaler Schaden durch Bestrahlung"
    ]
  },
  {
    "code": "P04.9",
    "name": "Fetale Schädigung",
    "synonyms": [
      "Absorption einer chemischen Substanz über die Plazenta",
      "Fetale Schädigung"
    ]
  },
  {
    "code": "P05.0",
    "name": "Für das Gestationsalter zu leichtes Neugeborenes",
    "synonyms": [
      "Für das Gestationsalter zu leichter Fetus",
      "Für das Gestationsalter zu leichtes Neugeborenes",
      "Light-for-date-Fetus"
    ]
  },
  {
    "code": "P05.1",
    "name": "Für das Gestationsalter zu kleines Neugeborenes",
    "synonyms": [
      "Für das Gestationsalter zu kleines Neugeborenes",
      "Selektive intrauterine Wachstumsretardierung",
      "Small-and-light-for-date-Fetus",
      "Small-and-light-for-date-baby",
      "Small-for-date-Fetus",
      "Small-for-date-baby"
    ]
  },
  {
    "code": "P05.2",
    "name": "Fetale Dystrophie",
    "synonyms": [
      "Fetale Dystrophie",
      "Fetale Hypotrophie",
      "Fetale Malnutrition",
      "Fetale Mangelernährung",
      "Intrauterine Malnutrition",
      "Intrauterine Mangelernährung"
    ]
  },
  {
    "code": "P05.9",
    "name": "Intrauterine Retardierung",
    "synonyms": [
      "Entwicklungshemmung beim Fetus",
      "Entwicklungsstillstand beim Fetus",
      "Fetale Wachstumsretardierung a.n.k.",
      "Fetale Wachstumsstörung",
      "Fetus dysmaturus",
      "Gestörte intrauterine fetale Entwicklung",
      "Hypotrophes Reifgeborenes",
      "Intrauterine Dystrophie",
      "Intrauterine Mangelentwicklung",
      "Intrauterine Retardierung",
      "Körperlicher Entwicklungsrückstand beim Fetus",
      "Mangelgeburt",
      "Mangelhaftes fetales Wachstum",
      "Retardierung des intrauterinen Wachstums",
      "Unterentwicklung des Fetus",
      "Unterentwicklung des Neugeborenen",
      "Unvollständige Entwicklung beim Fetus",
      "Unzureichende Fetusentwicklung",
      "Unzureichendes fetales Wachstum a.n.k.",
      "Wachstumshemmung beim Fetus",
      "Wachstumsstillstand beim Fetus"
    ]
  },
  {
    "code": "P07.00",
    "name": "Geburtsgewicht unter 500 Gramm",
    "synonyms": [
      "Frühgeborenes unter 500 Gramm",
      "Geburtsgewicht unter 500 Gramm"
    ]
  },
  {
    "code": "P07.01",
    "name": "Geburtsgewicht 500 bis unter 750 Gramm",
    "synonyms": [
      "Frühgeborenes zwischen 500 und 749 Gramm",
      "Geburtsgewicht 500 bis unter 750 Gramm"
    ]
  },
  {
    "code": "P07.02",
    "name": "Geburtsgewicht 750 bis unter 1000 Gramm",
    "synonyms": [
      "Frühgeborenes zwischen 750 und 999 Gramm",
      "Geburtsgewicht 750 bis unter 1000 Gramm"
    ]
  },
  {
    "code": "P07.10",
    "name": "Geburtsgewicht 1000 bis unter 1250 Gramm",
    "synonyms": [
      "Frühgeborenes zwischen 1000 und 1249 Gramm",
      "Geburtsgewicht 1000 bis unter 1250 Gramm"
    ]
  },
  {
    "code": "P07.11",
    "name": "Geburtsgewicht 1250 bis unter 1500 Gramm",
    "synonyms": [
      "Frühgeborenes zwischen 1250 und 1499 Gramm",
      "Geburtsgewicht 1250 bis unter 1500 Gramm"
    ]
  },
  {
    "code": "P07.12",
    "name": "Geburtsgewicht 1500 bis unter 2500 Gramm",
    "synonyms": [
      "Frühgeborenes zwischen 1500 und 2499 Gramm",
      "Geburtsgewicht 1500 bis unter 2500 Gramm"
    ]
  },
  {
    "code": "P07.2",
    "name": "Neugeborenes mit extremer Unreife",
    "synonyms": [
      "Extrem unreifes Frühgeborenes a.n.k.",
      "Extreme Prämaturität",
      "Neugeborenes mit extremer Unreife",
      "Prämaturität mit weniger als 28 vollendeten Wochen"
    ]
  },
  {
    "code": "P07.3",
    "name": "Hypotrophes Frühgeborenes",
    "synonyms": [
      "Drillingsfrühgeborenes",
      "Dysmaturität",
      "Eutrophes Frühgeborenes",
      "Frühgeborenes",
      "Frühgeburt a.n.k.",
      "Geburt vor dem Termin",
      "Hypotrophes Frühgeborenes",
      "Immaturität",
      "Mehrlingsfrühgeborenes",
      "Partus praematurus",
      "Prämaturität a.n.k.",
      "Unreife des Neugeborenen",
      "Unreifes Frühgeborenes",
      "Unreifes Neugeborenes",
      "Vor dem Termin Geborenes",
      "Vor dem Termin geboren a.n.k.",
      "Zwillingsfrühgeborenes"
    ]
  },
  {
    "code": "P08.0",
    "name": "Übergewichtiges Neugeborenes",
    "synonyms": [
      "Außergewöhnlich großes Neugeborenes",
      "Geburtsgewicht von 4500 Gramm oder mehr",
      "Zu hohes Geburtsgewicht",
      "Übergewichtiges Neugeborenes"
    ]
  },
  {
    "code": "P08.1",
    "name": "Large-for-date-Fetus a.n.k.",
    "synonyms": [
      "Für das Gestationsalter zu schweres Neugeborenes",
      "Heavy-for-date-Säugling a.n.k.",
      "Heavy-for-date-baby",
      "LGA [Large for gestational age]-Fetus",
      "Large-for-date-Fetus a.n.k.",
      "Large-for-date-Neugeborenes",
      "Large-for-date-Säugling a.n.k",
      "Übergröße des Fetus",
      "Übermäßiges fetales Wachstum"
    ]
  },
  {
    "code": "P08.2",
    "name": "Überreifes Neugeborenes",
    "synonyms": [
      "Ballantyne-Runge-Syndrom",
      "Clifford-Syndrom",
      "Nach dem Termin Geborenes",
      "Spätgeburt",
      "Spätgeburt des Fetus",
      "Spätgeburt des Neugeborenen",
      "Überreife des Fetus",
      "Überreife des Neugeborenen",
      "Überreifes Neugeborenes",
      "Übertragenes Kind",
      "Übertragung des Fetus",
      "Übertragung des Neugeborenen"
    ]
  },
  {
    "code": "P10.0",
    "name": "Subdurale Blutung durch Geburtsverletzung",
    "synonyms": [
      "Lokalisiertes subdurales Hämatom durch Geburtsverletzung",
      "Subdurale Blutung durch Geburtsverletzung",
      "Subdurale Hämorrhagie durch Geburtsverletzung"
    ]
  },
  {
    "code": "P10.1",
    "name": "Zerebrale Blutung durch Geburtsverletzung",
    "synonyms": [
      "Gehirnblutung durch Geburtsverletzung",
      "Gehirnhämatom durch Geburtsverletzung",
      "Gehirnhämorrhagie durch Geburtsverletzung",
      "Gehirnlazeration durch Geburtsverletzung mit Blutung",
      "Hirnblutung durch Geburtsverletzung",
      "Zerebrale Blutung durch Geburtsverletzung",
      "Zerebrale Lazeration durch Geburtsverletzung mit Blutung"
    ]
  },
  {
    "code": "P10.2",
    "name": "Intraventrikuläre Blutung durch Geburtsverletzung",
    "synonyms": [
      "Intraventrikuläre Blutung durch Geburtsverletzung"
    ]
  },
  {
    "code": "P10.3",
    "name": "Subarachnoidale Blutung durch Geburtsverletzung",
    "synonyms": [
      "Subarachnoidale Blutung durch Geburtsverletzung",
      "Subarachnoidale Hämorrhagie durch Geburtsverletzung",
      "Subarachnoidales Hämatom durch Geburtsverletzung"
    ]
  },
  {
    "code": "P10.4",
    "name": "Tentoriumriss durch Geburtsverletzung",
    "synonyms": [
      "Tentoriumriss durch Geburtsverletzung"
    ]
  },
  {
    "code": "P10.8",
    "name": "Extradurale Hämorrhagie durch Geburtsverletzung",
    "synonyms": [
      "Extradurale Blutung durch Geburtsverletzung",
      "Extradurale Hämorrhagie durch Geburtsverletzung",
      "Gehirnlazeration bei Geburt",
      "Gehirnzerreißung durch Geburtsverletzung",
      "Zephalhämatozele beim Fetus durch Geburtsverletzung",
      "Zephalhämatozele beim Neugeborenen durch Geburtsverletzung",
      "Zerebrale Lazeration während der Geburt"
    ]
  },
  {
    "code": "P10.9",
    "name": "Intrakranielle Hämorrhagie durch Geburtsverletzung",
    "synonyms": [
      "Intrakranielle Blutung durch Geburtsverletzung",
      "Intrakranielle Hämorrhagie durch Geburtsverletzung",
      "Intrakranielle Lazeration durch Geburtsverletzung"
    ]
  },
  {
    "code": "P11.0",
    "name": "Hirnödem durch Geburtsverletzung",
    "synonyms": [
      "Gehirnödem durch Geburtsverletzung",
      "Hirnödem durch Geburtsverletzung",
      "Steigerung des intrakraniellen Drucks durch Geburtsverletzung"
    ]
  },
  {
    "code": "P11.1",
    "name": "Enzephalopathie durch Geburtsverletzung",
    "synonyms": [
      "Enzephalopathie durch Geburtsverletzung",
      "Geburtsverletzung der Basalganglien",
      "Geburtsverletzung des Kleinhirns"
    ]
  },
  {
    "code": "P11.2",
    "name": "Intrakranielle Geburtsverletzung",
    "synonyms": [
      "Geburtsverletzung des Gehirns",
      "Gehirnschaden durch Geburtsverletzung",
      "Intrakranielle Geburtsverletzung"
    ]
  },
  {
    "code": "P11.3",
    "name": "Geburtsverletzung des Nervus facialis",
    "synonyms": [
      "Fazialislähmung durch Geburtsverletzung",
      "Ganglionitis geniculata beim Neugeborenen",
      "Ganglionitis geniculi beim Neugeborenen",
      "Geburtsbedingte Fazialisparese",
      "Geburtsverletzung des Nervus facialis",
      "Neuritis des Hirnnerven VII durch Geburtsverletzung",
      "Neuritis des Nervus facialis beim Neugeborenen",
      "Neuritis des Nervus facialis durch Geburtsverletzung",
      "Paralyse des Gesichtsnerven beim Neugeborenen",
      "Paralyse des Nervus facialis beim Neugeborenen",
      "Paralyse des Nervus facialis durch Geburtsverletzung",
      "Verletzung des Nervus facialis beim Neugeborenen"
    ]
  },
  {
    "code": "P11.4",
    "name": "Sehnervverletzung bei Geburt",
    "synonyms": [
      "Geburtsverletzung eines Hirnnerven a.n.k.",
      "Sehnervverletzung bei Geburt"
    ]
  },
  {
    "code": "P11.50",
    "name": "Geburtsverletzung der Wirbelsäule mit akuter Querschnittlähmung",
    "synonyms": [
      "Geburtsverletzung der Wirbelsäule mit akuter Querschnittlähmung"
    ]
  },
  {
    "code": "P11.51",
    "name": "Geburtsverletzung der Wirbelsäule mit chronischer Querschnittlähmung",
    "synonyms": [
      "Geburtsverletzung der Wirbelsäule mit chronischer Querschnittlähmung"
    ]
  },
  {
    "code": "P11.59",
    "name": "Geburtsverletzung der Wirbelsäule",
    "synonyms": [
      "Geburtsverletzung der Wirbelsäule",
      "Geburtsverletzung des Rückenmarks",
      "Hämatomyelie beim Neugeborenen durch Geburtsverletzung",
      "Hämatorrhachis beim Neugeborenen durch Geburtsverletzung",
      "Rückenmarkblutung beim Neugeborenen durch Geburtsverletzung",
      "Rückenmarkhämatom beim Neugeborenen durch Geburtsverletzung",
      "Rückenmarkhämorrhagie beim Neugeborenen durch Geburtsverletzung",
      "Rückenmarklazeration beim Neugeborenen",
      "Rückenmarkruptur beim Neugeborenen",
      "Wirbelfraktur beim Neugeborenen",
      "Wirbelfraktur durch Geburtsverletzung",
      "Wirbelsäulenfraktur durch Geburtsverletzung"
    ]
  },
  {
    "code": "P11.9",
    "name": "Tetraplegie beim Neugeborenen a.n.k.",
    "synonyms": [
      "Geburtsverletzung des Zentralnervensystems a.n.k.",
      "Hemiplegie beim Neugeborenen durch Geburtsverletzung",
      "Tetraplegie beim Neugeborenen a.n.k."
    ]
  },
  {
    "code": "P12.0",
    "name": "Kephalhämatom durch Geburtsverletzung",
    "synonyms": [
      "Kephalhämatom durch Geburtsverletzung"
    ]
  },
  {
    "code": "P12.1",
    "name": "Geburtsgeschwulst durch Geburtsverletzung",
    "synonyms": [
      "Caput succedaneum",
      "Chignon-Krankheit beim Neugeborenen",
      "Geburtsgeschwulst durch Geburtsverletzung"
    ]
  },
  {
    "code": "P12.2",
    "name": "Epikranielle subaponeurotische Blutung durch Geburtsverletzung",
    "synonyms": [
      "Epikranielle subaponeurotische Blutung durch Geburtsverletzung",
      "Subgaleales Hämatom durch Geburtsverletzung"
    ]
  },
  {
    "code": "P12.3",
    "name": "Quetschwunde der behaarten Kopfhaut durch Geburtsverletzung",
    "synonyms": [
      "Prellung der behaarten Kopfhaut durch Geburtsverletzung",
      "Quetschwunde der behaarten Kopfhaut durch Geburtsverletzung"
    ]
  },
  {
    "code": "P12.4",
    "name": "Geburtsverletzung der behaarten Kopfhaut durch Probeinzision",
    "synonyms": [
      "Geburtsverletzung der behaarten Kopfhaut durch Elektrode",
      "Geburtsverletzung der behaarten Kopfhaut durch Kopfschwartenklammer",
      "Geburtsverletzung der behaarten Kopfhaut durch Probeinzision"
    ]
  },
  {
    "code": "P12.8",
    "name": "Kopfschwartenverletzung durch Geburt",
    "synonyms": [
      "Kopfschwartenverletzung durch Geburt"
    ]
  },
  {
    "code": "P12.9",
    "name": "Geburtsverletzung der behaarten Kopfhaut",
    "synonyms": [
      "Geburtsverletzung der behaarten Kopfhaut",
      "Verletzung der behaarten Kopfhaut des Fetus",
      "Verletzung der behaarten Kopfhaut des Neugeborenen"
    ]
  },
  {
    "code": "P13.0",
    "name": "Schädelfraktur durch Geburtsverletzung",
    "synonyms": [
      "Schädelfraktur durch Geburtsverletzung"
    ]
  },
  {
    "code": "P13.1",
    "name": "Verformung des kindlichen Kopfes während der Geburt",
    "synonyms": [
      "Ruptur der Fontanelle",
      "Schädelverletzung durch Geburtsverletzung a.n.k.",
      "Verformung des kindlichen Kopfes während der Geburt"
    ]
  },
  {
    "code": "P13.2",
    "name": "Geburtsverletzung des Femurs",
    "synonyms": [
      "Femurfraktur durch Geburtsverletzung",
      "Geburtsverletzung des Femurs"
    ]
  },
  {
    "code": "P13.3",
    "name": "Fraktur von Tibia und Fibula als Geburtsverletzung",
    "synonyms": [
      "Fraktur von Radius und Ulna als Geburtsverletzung",
      "Fraktur von Tibia und Fibula als Geburtsverletzung",
      "Humerusfraktur als Geburtsverletzung",
      "Proximale Humerusfraktur als Geburtsverletzung"
    ]
  },
  {
    "code": "P13.4",
    "name": "Klavikulafraktur durch Geburtsverletzung",
    "synonyms": [
      "Klavikulafraktur durch Geburtsverletzung",
      "Perinatale Klavikulafraktur",
      "Schlüsselbeinfraktur durch Geburtsverletzung"
    ]
  },
  {
    "code": "P13.9",
    "name": "Geburtsverletzung des Skeletts",
    "synonyms": [
      "Geburtsverletzung des Skeletts",
      "Knochenfraktur durch Geburtsverletzung"
    ]
  },
  {
    "code": "P14.0",
    "name": "Erb-Lähmung durch Geburtstrauma",
    "synonyms": [
      "Duchenne-Erb-Syndrom",
      "Duchenne-Lähmung durch Geburtsverletzung",
      "Duchenne-Paralyse durch Geburtsverletzung",
      "Erb-Armplexuslähmung",
      "Erb-Lähmung durch Geburtstrauma",
      "Erb-Paralyse durch Geburtstrauma",
      "Obere Armplexuslähmung durch Geburtsverletzung",
      "Obere Brachialplexuslähmung durch Geburtsverletzung"
    ]
  },
  {
    "code": "P14.1",
    "name": "Klumpke-Lähmung durch Geburtsverletzung",
    "synonyms": [
      "Déjerine-Klumpke-Syndrom",
      "Klumpke-Déjerine-Lähmung",
      "Klumpke-Déjerine-Paralyse",
      "Klumpke-Geburtslähmung",
      "Klumpke-Lähmung",
      "Klumpke-Lähmung beim Neugeborenen",
      "Klumpke-Lähmung durch Geburtsverletzung",
      "Klumpke-Syndrom",
      "Untere Armplexuslähmung beim Neugeborenen",
      "Untere Armplexuslähmung durch Geburtsverletzung",
      "Untere Brachialplexuslähmung durch Geburtsverletzung"
    ]
  },
  {
    "code": "P14.2",
    "name": "Phrenikusparese durch Geburt",
    "synonyms": [
      "Paralyse des Nervus phrenicus durch Geburt",
      "Phrenikusparese durch Geburt",
      "Verletzung des Nervus phrenicus durch Geburt"
    ]
  },
  {
    "code": "P14.3",
    "name": "Geburtsverletzung des Plexus brachialis",
    "synonyms": [
      "Brachialplexusparalyse beim Neugeborenen",
      "Brachialplexusverletzung beim Neugeborenen",
      "Geburtsverletzung des Plexus brachialis",
      "Paralyse des Nervus radialis beim Neugeborenen",
      "Paralyse des Nervus radialis durch Geburtsverletzung",
      "Persistierende geburtstraumatische Läsion des Plexus brachialis",
      "Radikuläres Syndrom der oberen Gliedmaßen beim Neugeborenen",
      "Verletzung des Plexus brachialis beim Neugeborenen"
    ]
  },
  {
    "code": "P14.9",
    "name": "Geburtsverletzung des peripheres Nervensystems",
    "synonyms": [
      "Geburtsparalyse beim Neugeborenen a.n.k.",
      "Geburtsverletzung des peripheres Nervensystems",
      "Nervenparalyse durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.0",
    "name": "Geburtsverletzung der Leber",
    "synonyms": [
      "Geburtsverletzung der Leber",
      "Leberhämatom durch Geburtsverletzung",
      "Leberruptur durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.1",
    "name": "Geburtsverletzung der Milz",
    "synonyms": [
      "Geburtsverletzung der Milz",
      "Kongenitale Milzruptur",
      "Milzruptur durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.2",
    "name": "Verletzung des Musculus sternocleidomastoideus durch Geburtsverletzung",
    "synonyms": [
      "Tortikollis durch Geburtsverletzung",
      "Verletzung des Musculus sternocleidomastoideus durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.3",
    "name": "Lidverletzung bei Geburt",
    "synonyms": [
      "Augenschaden durch Geburtsverletzung",
      "Bindehautverletzung bei Geburt",
      "Geburtstrauma des Auges",
      "Geburtsverletzung des Auges",
      "Hornhautverletzung bei Geburt",
      "Konjunktivaverletzung bei Geburt",
      "Lidverletzung bei Geburt",
      "Luxatio bulbi bei Geburt",
      "Netzhautverletzung bei Geburt",
      "Orbitaverletzung bei Geburt",
      "Retinaverletzung bei Geburt",
      "Subkonjunktivale Blutung durch Geburtsverletzung",
      "Traumatisches Glaukom durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.4",
    "name": "Gesichtsverletzung bei Geburt",
    "synonyms": [
      "Blutstauung im Gesicht durch Geburtsverletzung",
      "Gesichtsverletzung bei Geburt"
    ]
  },
  {
    "code": "P15.5",
    "name": "Geburtsverletzung der äußeren Genitalorgane",
    "synonyms": [
      "Geburtsverletzung der Vulva",
      "Geburtsverletzung der äußeren Genitalorgane",
      "Geburtsverletzung des Hodens",
      "Geburtsverletzung des Penis",
      "Hodenhämatom durch Geburtsverletzung",
      "Oberflächliches Skrotumhämatom durch Geburtsverletzung",
      "Penishämatom durch Geburtsverletzung",
      "Testishämatom durch Geburtsverletzung",
      "Vulvahämatom durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.6",
    "name": "Adiponecrosis subcutanea neonatorum durch Geburtsverletzung",
    "synonyms": [
      "Adiponecrosis subcutanea neonatorum durch Geburtsverletzung",
      "Subkutane Fettnekrose durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.8",
    "name": "Eviszeration durch Geburtsverletzung",
    "synonyms": [
      "Eviszeration durch Geburtsverletzung",
      "Hämatom durch Geburtsverletzung a.n.k.",
      "Nierenruptur durch Geburtsverletzung",
      "Skalpellwunde beim Neugeborenen durch Geburtsverletzung"
    ]
  },
  {
    "code": "P15.9",
    "name": "Geburtstrauma",
    "synonyms": [
      "Fetuskompression während der Geburt",
      "Geburtsläsion",
      "Geburtstrauma",
      "Geburtsverletzung",
      "Kompression des Neugeborenen während der Geburt",
      "Partusverletzung",
      "Verletzung des Fetus bei der Entbindung",
      "Verletzung des Neugeborenen bei der Entbindung"
    ]
  },
  {
    "code": "P20.0",
    "name": "Intrauterine Hypoxie, erstmals festgestellt vor Wehenbeginn",
    "synonyms": [
      "Anoxie vor Wehenbeginn",
      "Fetaler Distress, erstmals festgestellt vor Wehenbeginn",
      "Intrauterine Hypoxie, erstmals festgestellt vor Wehenbeginn"
    ]
  },
  {
    "code": "P20.1",
    "name": "Intrauterine Hypoxie, erstmals festgestellt bei Wehen oder Entbindung",
    "synonyms": [
      "Fetaler Distress, erstmals festgestellt bei Wehen oder Entbindung",
      "Intrauterine Hypoxie, erstmals festgestellt bei Wehen oder Entbindung"
    ]
  },
  {
    "code": "P20.9",
    "name": "Intrauterine Hypoxie",
    "synonyms": [
      "Abnorme fetale Herzfrequenz",
      "Abnormer fetaler Herzschlag",
      "Fetale Anoxie",
      "Fetale Asphyxie",
      "Fetale Azidose",
      "Fetale Bradykardie",
      "Fetale Hypoxie",
      "Fetale kardiale Dysrhythmie",
      "Fetaler Distress",
      "Fetaler Gefahrenzustand",
      "Fetaler Mekoniumabgang",
      "Grünes Fruchtwasser",
      "Intrauterine Anoxie",
      "Intrauterine Asphyxie",
      "Intrauterine Azidose",
      "Intrauterine Bradykardie",
      "Intrauterine Hypoxie",
      "Intrauterine Tachykardie",
      "Intrauteriner Distress",
      "Intrauteriner Gefahrenzustand",
      "Intrauteriner Mekoniumabgang",
      "Mekonium im Fruchtwasser",
      "Persistierende fetale Tachykardie",
      "Pränatale Asphyxie"
    ]
  },
  {
    "code": "P21.0",
    "name": "Schwere Asphyxie bei Geburt",
    "synonyms": [
      "Asphyxia pallida",
      "Asphyxie mit Apgar-Score 0-3 für 1 Minute postnatal",
      "Schwere Asphyxie bei Geburt",
      "Weiße Asphyxie"
    ]
  },
  {
    "code": "P21.1",
    "name": "Leichte Asphyxie bei Geburt",
    "synonyms": [
      "Asphyxia livida",
      "Asphyxie mit Apgar-Score 4-7 für 1 Minute postnatal",
      "Blaue Asphyxie",
      "Leichte Asphyxie bei Geburt",
      "Mäßige Asphyxie bei Geburt"
    ]
  },
  {
    "code": "P21.9",
    "name": "Asphyxie bei Geburt",
    "synonyms": [
      "Anoxie bei Geburt",
      "Anoxie beim Neugeborenen",
      "Anoxämie beim Neugeborenen",
      "Asphyxie bei Geburt",
      "Asphyxie beim Neugeborenen",
      "Hypoxie bei Geburt",
      "Hypoxie beim Neugeborenen",
      "Neonatale Asphyxie",
      "Perinatale Asphyxie",
      "Postnatale Asphyxie",
      "Verzögerung der primären Respiration"
    ]
  },
  {
    "code": "P22.0",
    "name": "Hyaline Membranenkrankheit der Neugeborenenlunge",
    "synonyms": [
      "Atemnotsyndrom beim Frühgeborenen",
      "Atemnotsyndrom beim Neugeborenen",
      "Atemnotsyndrom beim Säugling",
      "Hyaline Membranenkrankheit beim Neugeborenen",
      "Hyaline Membranenkrankheit der Neugeborenenlunge",
      "Hyalines Membransyndrom",
      "IRDS [Infant respiratory distress syndrome]",
      "Idiopathisches kardiorespiratorisches Distresssyndrom beim Neugeborenen",
      "Membransyndrom",
      "Neonatales Atemnotsyndrom",
      "RDS [Respiratory distress syndrome] beim Neugeborenen",
      "Respiratory-distress-Syndrom beim Neugeborenen",
      "Respiratory-distress-Syndrom beim Säugling"
    ]
  },
  {
    "code": "P22.1",
    "name": "Transitorische Tachypnoe beim Neugeborenen",
    "synonyms": [
      "Flüchtige Tachypnoe beim Neugeborenen",
      "Transitorische Tachypnoe beim Neugeborenen"
    ]
  },
  {
    "code": "P22.8",
    "name": "Respiratorische Anpassungsstörung beim Neugeborenen",
    "synonyms": [
      "Dyspnoe beim Neugeborenen",
      "Interstitielle pulmonale Glykogenose",
      "Respiratorische Anpassungsstörung beim Neugeborenen"
    ]
  },
  {
    "code": "P22.9",
    "name": "Respiratorischer Distress beim Neugeborenen",
    "synonyms": [
      "Respiratorischer Distress beim Neugeborenen"
    ]
  },
  {
    "code": "P23.0",
    "name": "Angeborene Pneumonie durch Viren",
    "synonyms": [
      "Angeborene Pneumonie durch Respiratory-Syncytial-Viren [RS-Viren]",
      "Angeborene Pneumonie durch Viren",
      "Angeborene virale Pneumonie"
    ]
  },
  {
    "code": "P23.1",
    "name": "Angeborene Pneumonie durch Chlamydien",
    "synonyms": [
      "Angeborene Pneumonie durch Chlamydien"
    ]
  },
  {
    "code": "P23.2",
    "name": "Angeborene Pneumonie durch Staphylokokken",
    "synonyms": [
      "Angeborene Pneumonie durch Staphylokokken"
    ]
  },
  {
    "code": "P23.3",
    "name": "Angeborene Pneumonie durch Streptokokken der Gruppe B",
    "synonyms": [
      "Angeborene Pneumonie durch Streptokokken der Gruppe B"
    ]
  },
  {
    "code": "P23.4",
    "name": "Angeborene Pneumonie durch Escherichia coli",
    "synonyms": [
      "Angeborene Pneumonie durch Escherichia coli"
    ]
  },
  {
    "code": "P23.5",
    "name": "Angeborene Pneumonie durch Pseudomonasarten",
    "synonyms": [
      "Angeborene Pneumonie durch Pseudomonasarten"
    ]
  },
  {
    "code": "P23.6",
    "name": "Angeborene Pneumonie durch Streptokokken, ausgenommen Gruppe B",
    "synonyms": [
      "Angeborene Pneumonie durch Bakterien a.n.k.",
      "Angeborene Pneumonie durch Streptokokken",
      "Angeborene Pneumonie durch Streptokokken, ausgenommen Gruppe B"
    ]
  },
  {
    "code": "P23.9",
    "name": "Angeborene Pneumonie",
    "synonyms": [
      "Angeborene Pneumonie",
      "Bei Geburt erworbene infektionsbedingte Pneumonie",
      "In utero erworbene infektionsbedingte Pneumonie",
      "Konnatale Pneumonie",
      "Neonatale Pneumonie"
    ]
  },
  {
    "code": "P24.0",
    "name": "Mekoniumaspiration",
    "synonyms": [
      "Mekoniumaspiration",
      "Mekoniumaspiration durch das Neugeborene",
      "Mekoniumaspirations-Syndrom",
      "Mekoniumaspirations-Syndrom des Neugeborenen",
      "Mekoniuminhalation",
      "Mekoniumpneumonie"
    ]
  },
  {
    "code": "P24.1",
    "name": "Fruchtwasseraspiration",
    "synonyms": [
      "Asphyxie durch Schleim beim Neugeborenen",
      "Aspiration eines Schleimpfropfes durch das Neugeborene",
      "Aspiration von Liquor amnii",
      "Fruchtwasseraspiration",
      "Pneumonie durch Fruchtwasseraspiration",
      "Schleimaspiration durch das Neugeborene"
    ]
  },
  {
    "code": "P24.2",
    "name": "Blutaspiration beim Neugeborenen",
    "synonyms": [
      "Blutaspiration beim Neugeborenen"
    ]
  },
  {
    "code": "P24.3",
    "name": "Milchaspiration",
    "synonyms": [
      "Asphyxie durch Fremdkörper beim Neugeborenen",
      "Milchaspiration"
    ]
  },
  {
    "code": "P24.8",
    "name": "Aspiration von Vernix caseosa",
    "synonyms": [
      "Aspiration von Vernix caseosa"
    ]
  },
  {
    "code": "P24.9",
    "name": "Aspirationssyndrom beim Neugeborenen",
    "synonyms": [
      "Aspirationspneumonie beim Neugeborenen",
      "Aspirationssyndrom beim Neugeborenen",
      "Neonatale Aspirationspneumonie"
    ]
  },
  {
    "code": "P25.0",
    "name": "Angeborenes interstitielles Emphysem",
    "synonyms": [
      "Angeborenes interstitielles Emphysem",
      "Interstitielles Emphysem beim Neugeborenen",
      "Interstitielles Emphysem in der Perinatalperiode",
      "Kongenitales interstitielles Emphysem"
    ]
  },
  {
    "code": "P25.1",
    "name": "Kongenitaler Pneumothorax",
    "synonyms": [
      "Kongenitaler Pneumothorax",
      "Pneumothorax in der Perinatalperiode",
      "Spontanpneumothorax beim Fetus",
      "Spontanpneumothorax beim Neugeborenen"
    ]
  },
  {
    "code": "P25.2",
    "name": "Perinatales Pneumomediastinum",
    "synonyms": [
      "Konnatales Pneumomediastinum",
      "Mediastinales Emphysem beim Fetus",
      "Mediastinales Emphysem beim Neugeborenen",
      "Perinatales Pneumomediastinum"
    ]
  },
  {
    "code": "P25.3",
    "name": "Pneumoperikard beim Neugeborenen",
    "synonyms": [
      "Kongenitales Pneumoperikard",
      "Pneumoperikard beim Neugeborenen"
    ]
  },
  {
    "code": "P25.8",
    "name": "Bläschenlunge beim Fetus",
    "synonyms": [
      "Bläschenlunge beim Fetus",
      "Bläschenlunge beim Neugeborenen"
    ]
  },
  {
    "code": "P26.0",
    "name": "Tracheobronchiale Hämorrhagie beim Neugeborenen",
    "synonyms": [
      "Tracheobronchiale Blutung beim Neugeborenen",
      "Tracheobronchiale Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P26.1",
    "name": "Massive Lungenblutung mit Ursprung in der Perinatalperiode",
    "synonyms": [
      "Massive Lungenblutung beim Neugeborenen",
      "Massive Lungenblutung mit Ursprung in der Perinatalperiode",
      "Massive Lungenhämorrhagie beim Neugeborenen",
      "Massive pulmonale Blutung beim Neugeborenen",
      "Massive pulmonale Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P26.8",
    "name": "Intraalveoläre Hämorrhagie beim Neugeborenen",
    "synonyms": [
      "Intraalveoläre Blutung beim Neugeborenen",
      "Intraalveoläre Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P26.9",
    "name": "Hämoptyse beim Neugeborenen",
    "synonyms": [
      "Hämoptyse beim Neugeborenen",
      "Lungenblutung beim Neugeborenen",
      "Lungenhämorrhagie beim Neugeborenen",
      "Pulmonale Blutung beim Neugeborenen",
      "Pulmonale Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P27.0",
    "name": "Mikity-Wilson-Syndrom",
    "synonyms": [
      "Dysmaturität der Lunge",
      "Mikity-Wilson-Krankheit",
      "Mikity-Wilson-Syndrom",
      "Pulmonale Dysmaturität"
    ]
  },
  {
    "code": "P27.1",
    "name": "Bronchopulmonale Dysplasie [BPD] perinatalen Ursprungs",
    "synonyms": [
      "Bronchopulmonale Dysplasie",
      "Bronchopulmonale Dysplasie [BPD] perinatalen Ursprungs",
      "Bronchopulmonale Dysplasie mit Ursprung in der Perinatalperiode",
      "Bronchopulmonale perinatale Dysplasie"
    ]
  },
  {
    "code": "P27.8",
    "name": "Beatmungslunge beim Neugeborenen",
    "synonyms": [
      "Angeborene Lungenfibrose",
      "Beatmungslunge beim Neugeborenen",
      "Kongenitale alveolar-kapilläre Dysplasie"
    ]
  },
  {
    "code": "P27.9",
    "name": "Chronische Krankheit der Atmungsorgane beim Neugeborenen",
    "synonyms": [
      "Chronische Krankheit der Atmungsorgane beim Neugeborenen"
    ]
  },
  {
    "code": "P28.0",
    "name": "Primäre Atelektase beim Neugeborenen",
    "synonyms": [
      "Akute neonatale Atemnot durch Surfactantprotein-B-Mangel",
      "Fehlende Entfaltung der terminalen Lungenabschnitte beim Neugeborenen",
      "Lungenunreife",
      "Nichtentfaltung der Lunge",
      "Nichtentfaltung der Lunge beim Neugeborenen",
      "Primäre Atelektase beim Neugeborenen",
      "Pulmonale Hypoplasie bei kurzer Schwangerschaftsdauer",
      "Unzureichende Lungenentwicklung bei kurzer Schwangerschaftsdauer"
    ]
  },
  {
    "code": "P28.1",
    "name": "Unvollständige Belüftung der Lunge beim Neugeborenen",
    "synonyms": [
      "Atelektase beim Neugeborenen",
      "Partielle Atelektase beim Neugeborenen",
      "Resorptionsatelektase beim Neugeborenen ohne Atemnotsyndrom",
      "Sekundäre Atelektase beim Neugeborenen",
      "Unvollständige Belüftung der Lunge beim Neugeborenen"
    ]
  },
  {
    "code": "P28.2",
    "name": "Zyanoseanfall beim Neugeborenen",
    "synonyms": [
      "Akrozyanose beim Neugeborenen",
      "Zyanoseanfall beim Neugeborenen"
    ]
  },
  {
    "code": "P28.3",
    "name": "Primäre Schlafapnoe beim Neugeborenen",
    "synonyms": [
      "Obstruktive Schlafapnoe beim Neugeborenen",
      "Primäre Schlafapnoe beim Neugeborenen",
      "Schlafapnoe beim Neugeborenen",
      "Zentrale Schlafapnoe beim Neugeborenen"
    ]
  },
  {
    "code": "P28.4",
    "name": "Apnoe beim Neugeborenen a.n.k",
    "synonyms": [
      "Apnoe bei Prämaturität",
      "Apnoe beim Frühgeborenen",
      "Apnoe beim Neugeborenen a.n.k",
      "Apnoe-Bradykardie-Syndrom beim Frühgeborenen",
      "Obstruktive Apnoe beim Neugeborenen"
    ]
  },
  {
    "code": "P28.5",
    "name": "Respiratorisches Versagen beim Neugeborenen",
    "synonyms": [
      "Atmungsinsuffizienz beim Neugeborenen a.n.k.",
      "Depression der Atmung beim Neugeborenen",
      "Lungeninsuffizienz beim Neugeborenen",
      "Pulmonale Insuffizienz beim Neugeborenen",
      "Respiratorische Insuffizienz beim Neugeborenen",
      "Respiratorisches Versagen beim Neugeborenen",
      "Unzureichende Lungenbelüftung beim Neugeborenen",
      "Unzureichende Lungenfunktion beim Neugeborenen",
      "Versagen der Atmung beim Neugeborenen"
    ]
  },
  {
    "code": "P28.8",
    "name": "Laryngealer Stridor congenitus",
    "synonyms": [
      "Abnorme Lungenbelüftung beim Neugeborenen",
      "Abnorme Lungenfunktion beim Neugeborenen",
      "Atemschwäche beim Neugeborenen",
      "Atemstillstand beim Neugeborenen",
      "Chronische Rhinitis beim Neugeborenen",
      "Chronischer Schnupfen beim Neugeborenen",
      "Kongenitaler Laryngismus",
      "Laryngealer Stridor congenitus",
      "Pleuraerguss beim Fetus",
      "Pleuraerguss beim Neugeborenen",
      "Schnupfen beim Neugeborenen",
      "Stridor congenitus",
      "Stridor congenitus laryngis",
      "Unreife des Atemzentrums beim Frühgeborenen"
    ]
  },
  {
    "code": "P28.9",
    "name": "Krankheit der Atmungsorgane beim Neugeborenen",
    "synonyms": [
      "Krankheit der Atmungsorgane beim Neugeborenen"
    ]
  },
  {
    "code": "P29.0",
    "name": "Herzinsuffizienz beim Neugeborenen",
    "synonyms": [
      "Herzinsuffizienz beim Neugeborenen",
      "Herzinsuffizienz durch Stauung beim Neugeborenen",
      "Herzversagen beim Neugeborenen",
      "Kardiale Insuffizienz beim Neugeborenen",
      "Kardiales Versagen beim Neugeborenen",
      "Kongenitales Herzversagen",
      "Myokardinsuffizienz beim Neugeborenen"
    ]
  },
  {
    "code": "P29.1",
    "name": "Herzrhythmusstörung beim Neugeborenen",
    "synonyms": [
      "Arrhythmie beim Neugeborenen",
      "Herzrhythmusstörung beim Neugeborenen",
      "Herzstillstand beim Neugeborenen",
      "Idiopathisches neonatales Vorhofflattern"
    ]
  },
  {
    "code": "P29.2",
    "name": "Hypertonie beim Neugeborenen",
    "synonyms": [
      "Hypertonie beim Neugeborenen"
    ]
  },
  {
    "code": "P29.3",
    "name": "Persistierender Fetalkreislauf",
    "synonyms": [
      "PFC [Persistent fetal circulation]-Syndrom",
      "Persistierende pulmonale Hypertonie beim Neugeborenen",
      "Persistierender Fetalkreislauf",
      "Verzögerter Verschluss des Ductus arteriosus"
    ]
  },
  {
    "code": "P29.4",
    "name": "Transitorische Myokardischämie beim Neugeborenen",
    "synonyms": [
      "Transitorische Myokardischämie beim Neugeborenen"
    ]
  },
  {
    "code": "P29.8",
    "name": "Kreislaufkollaps beim Neugeborenen",
    "synonyms": [
      "Kardiovaskulärer Kollaps beim Neugeborenen",
      "Kreislaufinsuffizienz beim Fetus",
      "Kreislaufinsuffizienz beim Neugeborenen",
      "Kreislaufkollaps beim Neugeborenen",
      "Thrombose der renalen Vene beim Fetus",
      "Thrombose der renalen Vene beim Neugeborenen",
      "Vaskulärer Kollaps beim Neugeborenen"
    ]
  },
  {
    "code": "P29.9",
    "name": "Kardiovaskuläre Krankheit beim Fetus",
    "synonyms": [
      "Kardiovaskuläre Krankheit beim Fetus",
      "Kardiovaskuläre Krankheit beim Neugeborenen"
    ]
  },
  {
    "code": "P35.0",
    "name": "Rötelnembryopathie",
    "synonyms": [
      "Angeborene Pneumonie durch Röteln",
      "Embryopathia rubeolaris",
      "Fetaler Schaden durch Röteln",
      "Fetales Röteln-Syndrom",
      "Kongenitale Pneumonitis durch Röteln",
      "Kongenitale Rubella",
      "Kongenitale Röteln",
      "Kongenitale Rötelnpneumonie",
      "Kongenitales Röteln-Syndrom",
      "Rubeolenembryopathie",
      "Rötelnembryofetopathie",
      "Rötelnembryopathie"
    ]
  },
  {
    "code": "P35.1",
    "name": "Angeborene Zytomegalie",
    "synonyms": [
      "Angeborene Zytomegalie",
      "Fetales Zytomegalie-Syndrom",
      "Kongenitale Infektion durch Zytomegalieviren",
      "Kongenitale Zytomegalie",
      "Pränatale Zytomegalievirus-Infektion",
      "Vorgeburtliche CMV [Zytomegalievirus]-Infektion",
      "Vorgeburtliche Zytomegalievirus-Infektion",
      "Wyatt-Syndrom [Angeborene Zytomegalie]",
      "Zytomegalievirus-Embryofetopathie"
    ]
  },
  {
    "code": "P35.2",
    "name": "Angeborene Infektion durch Herpesviren",
    "synonyms": [
      "Angeborene Infektion durch Herpesviren",
      "Kongenitale Infektion durch Herpes-simplex-Viren",
      "Kongenitale Infektion durch Herpesvirus",
      "Kongenitaler Herpes simplex"
    ]
  },
  {
    "code": "P35.3",
    "name": "Angeborene Virushepatitis",
    "synonyms": [
      "Angeborene Virushepatitis",
      "Kongenitale Infektion durch Hepatitisviren"
    ]
  },
  {
    "code": "P35.4",
    "name": "Angeborene Zika-Viruskrankheit",
    "synonyms": [
      "Angeborene Zika-Viruskrankheit",
      "Mikrozephalie durch kongenitale Zika-Viruskrankheit"
    ]
  },
  {
    "code": "P35.8",
    "name": "Kongenitale Poliomyelitis",
    "synonyms": [
      "Angeborene Varizellen",
      "Angeborene Windpocken",
      "Kongenitale Enterovirus-Infektion",
      "Kongenitale Epstein-Barr-Virus-Infektion",
      "Kongenitale Infektion durch Impfpocken",
      "Kongenitale Infektion durch Vacciniavirus",
      "Kongenitale Infektion durch Varizellen",
      "Kongenitale Poliomyelitis",
      "Kongenitales Varizellen-Syndrom",
      "Manifestation der Grippe beim Säugling",
      "Parvovirus-Embryopathie",
      "Vaccinia congenitalis"
    ]
  },
  {
    "code": "P35.9",
    "name": "Angeborene Viruskrankheit",
    "synonyms": [
      "Angeborene Viruskrankheit",
      "Kongenitale Virusinfektion",
      "Virusembryopathie"
    ]
  },
  {
    "code": "P36.0",
    "name": "Sepsis durch Streptokokken Gruppe B beim Neugeborenen",
    "synonyms": [
      "Kongenitale Sepsis durch Streptokokken Gruppe B",
      "Kongenitale Sepsis durch Streptokokken Gruppe B beim Frühgeborenen",
      "Sepsis durch Streptokokken Gruppe B beim Frühgeborenen",
      "Sepsis durch Streptokokken Gruppe B beim Neugeborenen"
    ]
  },
  {
    "code": "P36.1",
    "name": "Neonatale Sepsis durch Streptokokken",
    "synonyms": [
      "Kongenitale Sepsis durch Streptokokken",
      "Kongenitale Sepsis durch Streptokokken beim Frühgeborenen",
      "Neonatale Sepsis durch Streptokokken",
      "Sepsis durch Streptokokken beim Frühgeborenen"
    ]
  },
  {
    "code": "P36.2",
    "name": "Sepsis durch Staphylococcus aureus beim Neugeborenen",
    "synonyms": [
      "Sepsis durch Staphylococcus aureus beim Frühgeborenen",
      "Sepsis durch Staphylococcus aureus beim Neugeborenen"
    ]
  },
  {
    "code": "P36.3",
    "name": "Sepsis durch Staphylokokken beim Neugeborenen a.n.k.",
    "synonyms": [
      "Sepsis durch Staphylokokken beim Frühgeborenen anderenorts nicht klassifiziert",
      "Sepsis durch Staphylokokken beim Neugeborenen a.n.k."
    ]
  },
  {
    "code": "P36.4",
    "name": "Sepsis durch Escherichia coli beim Neugeborenen",
    "synonyms": [
      "Kongenitale Sepsis durch Escherichia coli",
      "Kongenitale Sepsis durch Escherichia coli beim Frühgeborenen",
      "Sepsis durch Escherichia coli beim Frühgeborenen",
      "Sepsis durch Escherichia coli beim Neugeborenen"
    ]
  },
  {
    "code": "P36.5",
    "name": "Sepsis durch Anaerobier beim Neugeborenen",
    "synonyms": [
      "Sepsis durch Anaerobier beim Neugeborenen"
    ]
  },
  {
    "code": "P36.8",
    "name": "Sepsis durch Enterobacter beim Neugeborenen",
    "synonyms": [
      "Sepsis durch Enterobacter beim Frühgeborenen",
      "Sepsis durch Enterobacter beim Neugeborenen"
    ]
  },
  {
    "code": "P36.9",
    "name": "Bakterielle Sepsis beim Neugeborenen",
    "synonyms": [
      "Angeborene Sepsis beim Frühgeborenen",
      "Angeborene Sepsis beim Neugeborenen",
      "Bakterielle Sepsis beim Frühgeborenen",
      "Bakterielle Sepsis beim Neugeborenen",
      "Frühgeborenensepsis",
      "Nabelschnursepsis beim Neugeborenen",
      "Nabelsepsis",
      "Neugeborenensepsis"
    ]
  },
  {
    "code": "P37.0",
    "name": "Kongenitale Tuberkulose",
    "synonyms": [
      "Angeborene Tuberkulose",
      "Kongenitale Tuberkulose"
    ]
  },
  {
    "code": "P37.1",
    "name": "Angeborene Toxoplasmose",
    "synonyms": [
      "Angeborene Toxoplasmose",
      "Kongenitale Lymphadenopathie durch Toxoplasmose",
      "Konnatale Mikrozephalie durch Toxoplasmose",
      "Konnatale Toxoplasmose",
      "Konnataler Hydrozephalus durch Toxoplasmose",
      "Konnataler Mikrophthalmus durch Toxoplasmose",
      "Neugeborenentoxoplasmose"
    ]
  },
  {
    "code": "P37.2",
    "name": "Neugeborenenlisteriose",
    "synonyms": [
      "Fetale Listeriose",
      "Kongenitale Infektion durch Listeria monocytogenes",
      "Kongenitale disseminierte Listeriose",
      "Neugeborenenlisteriose"
    ]
  },
  {
    "code": "P37.3",
    "name": "Angeborene Malaria tropica",
    "synonyms": [
      "Angeborene Malaria tropica",
      "Kongenitale Infektion durch Plasmodium falciparum",
      "Kongenitale Malaria falciparum"
    ]
  },
  {
    "code": "P37.4",
    "name": "Kongenitale Malaria a.n.k.",
    "synonyms": [
      "Kongenitale Malaria a.n.k."
    ]
  },
  {
    "code": "P37.5",
    "name": "Kandidose beim Neugeborenen",
    "synonyms": [
      "Infektion durch Candida beim Neugeborenen",
      "Kandidose beim Neugeborenen",
      "Kongenitale Infektion durch Candida",
      "Kongenitale Kandidose",
      "Neonatale Infektion durch Monilia",
      "Neonatale Kandidose",
      "Neonatale Moniliasis"
    ]
  },
  {
    "code": "P37.9",
    "name": "Kongenitale infektiöse Krankheit",
    "synonyms": [
      "Kongenitale infektiöse Krankheit"
    ]
  },
  {
    "code": "P38",
    "name": "Omphalitis beim Neugeborenen",
    "synonyms": [
      "Kongenitale Omphalitis",
      "Nabelabszess beim Neugeborenen",
      "Nabelentzündung beim Neugeborenen",
      "Nabelgranulom beim Neugeborenen",
      "Nabelinfektion beim Neugeborenen",
      "Nabelphlegmone beim Neugeborenen",
      "Nabelschnurphlegmone",
      "Omphalitis beim Neugeborenen",
      "Omphalitis mit leichter Blutung",
      "Omphalophlegmone beim Neugeborenen",
      "Schleichende Nabelinfektion beim Neugeborenen"
    ]
  },
  {
    "code": "P39.0",
    "name": "Infektiöse Mastitis beim Neugeborenen",
    "synonyms": [
      "Infektiöse Brustdrüsenentzündung beim Neugeborenen",
      "Infektiöse Mastitis beim Neugeborenen",
      "Infektiöse neonatale Mastitis",
      "Mammaentzündung beim Neugeborenen"
    ]
  },
  {
    "code": "P39.1",
    "name": "Conjunctivitis neonatorum",
    "synonyms": [
      "Akute Dakryozystitis beim Neugeborenen",
      "Conjunctivitis neonatorum",
      "Dacryocystitis neonatorum",
      "Konjunktivitis beim Neugeborenen",
      "Konjunktivitis durch Chlamydien beim Neugeborenen",
      "Neugeborenenkonjunktivitis",
      "Ophthalmia neonatorum"
    ]
  },
  {
    "code": "P39.2",
    "name": "Intraamniale Fetalinfektion",
    "synonyms": [
      "Intraamniale Fetalinfektion"
    ]
  },
  {
    "code": "P39.3",
    "name": "Harnwegsinfektion beim Neugeborenen",
    "synonyms": [
      "Harnwegsinfektion beim Neugeborenen"
    ]
  },
  {
    "code": "P39.4",
    "name": "Hautinfektion beim Neugeborenen",
    "synonyms": [
      "Hautinfektion beim Neugeborenen",
      "Pyodermie beim Neugeborenen"
    ]
  },
  {
    "code": "P39.9",
    "name": "Neonatale Infektion",
    "synonyms": [
      "Infektion des Fetus",
      "Infektion des Neugeborenen",
      "Kongenitale Infektion a.n.k.",
      "Neonatale Infektion"
    ]
  },
  {
    "code": "P50.0",
    "name": "Fetaler Blutverlust bei Insertio velamentosa",
    "synonyms": [
      "Blutung bei Vasa praevia beim Fetus",
      "Fetale Blutung bei Vasa praevia",
      "Fetale Hämorrhagie bei Vasa praevia",
      "Fetaler Blutverlust bei Insertio velamentosa",
      "Fetaler Blutverlust bei Vasa praevia",
      "Fetusschädigung durch Blutung aus Vasa praevia",
      "Hämorrhagie bei Vasa praevia beim Fetus",
      "Schädigung des Neugeborenen durch Blutung aus Vasa praevia"
    ]
  },
  {
    "code": "P50.1",
    "name": "Fetaler Blutverlust aus rupturierter Nabelschnur",
    "synonyms": [
      "Fetale Blutung aus der rupturierten Nabelschnur",
      "Fetale Hämorrhagie aus der rupturierten Nabelschnur",
      "Fetaler Blutverlust aus rupturierter Nabelschnur",
      "Fetusschädigung durch Nabelschnurriss",
      "Schädigung des Neugeborenen durch Nabelschnurriss"
    ]
  },
  {
    "code": "P50.2",
    "name": "Fetaler Blutverlust aus Plazenta",
    "synonyms": [
      "Fetale Blutung aus der Plazenta",
      "Fetale Hämorrhagie aus der Plazenta",
      "Fetaler Blutverlust aus Plazenta"
    ]
  },
  {
    "code": "P50.3",
    "name": "Fetofetale Blutung",
    "synonyms": [
      "Blutung durch fetofetale Transfusion",
      "Fetofetale Blutung",
      "Hämorrhagie durch fetofetale Transfusion"
    ]
  },
  {
    "code": "P50.4",
    "name": "Fetomaternale Blutung",
    "synonyms": [
      "Fetomaternale Blutung",
      "Fetomaternale Hämorrhagie"
    ]
  },
  {
    "code": "P50.5",
    "name": "Fetale Hämorrhagie aus dem durchtrennten Ende der Nabelschnur eines anderen Mehrlings",
    "synonyms": [
      "Fetale Blutung aus dem durchtrennten Ende der Nabelschnur eines anderen Mehrlings",
      "Fetale Hämorrhagie aus dem durchtrennten Ende der Nabelschnur eines anderen Mehrlings"
    ]
  },
  {
    "code": "P50.9",
    "name": "Fetaler Blutverlust",
    "synonyms": [
      "Blutung des Fetus",
      "Fetale Blutung",
      "Fetale Hämorrhagie",
      "Fetaler Blutverlust",
      "Hämorrhagie des Fetus"
    ]
  },
  {
    "code": "P51.0",
    "name": "Massive Nabelblutung beim Neugeborenen",
    "synonyms": [
      "Massive Nabelblutung beim Neugeborenen",
      "Massive Nabelhämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P51.8",
    "name": "Unsachgemäße Abnabelung",
    "synonyms": [
      "Blutung durch Sichlösen einer Nabelschnurligatur",
      "Blutung durch unsachgemäße Abnabelung",
      "Hämorrhagie durch Sichlösen einer Nabelschnurligatur",
      "Sichlösen einer Nabelschnurligatur",
      "Unsachgemäße Abnabelung",
      "Verschiebung einer Nabelschnurunterbindung"
    ]
  },
  {
    "code": "P51.9",
    "name": "Nabelblutung beim Neugeborenen",
    "synonyms": [
      "Hämorrhagie des Nabelstumpfes",
      "Nabelblutung beim Neugeborenen",
      "Nabelhämorrhagie beim Neugeborenen",
      "Nabelstumpfblutung",
      "Omphalorrhagie",
      "Omphalorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P52.0",
    "name": "Subependymblutung beim Neugeborenen ohne intraventrikuläre Ausdehnung",
    "synonyms": [
      "Intrakranielle nichttraumatische Blutung 1. Grades beim Fetus",
      "Intrakranielle nichttraumatische Blutung 1. Grades beim Neugeborenen",
      "Subependymale Hämorrhagie beim Fetus",
      "Subependymale Hämorrhagie beim Neugeborenen",
      "Subependymblutung beim Fetus ohne intraventrikuläre Ausdehnung",
      "Subependymblutung beim Neugeborenen ohne intraventrikuläre Ausdehnung"
    ]
  },
  {
    "code": "P52.1",
    "name": "Intraventrikuläre nichttraumatische Blutung 2. Grades beim Fetus",
    "synonyms": [
      "Intraventrikuläre nichttraumatische Blutung 2. Grades beim Fetus",
      "Intraventrikuläre nichttraumatische Blutung 2. Grades beim Neugeborenen",
      "Leichte bis mäßige Ventrikeleinbruchsblutung von weniger als 50 % des Ventrikelvolumens beim Fetus",
      "Leichte bis mäßige Ventrikeleinbruchsblutung von weniger als 50 % des Ventrikelvolumens beim Neugeborenen",
      "Subependymblutung beim Fetus mit intraventrikulärer Ausdehnung 2. Grades",
      "Subependymblutung mit intraventrikulärer Ausdehnung 2. Grades beim Neugeborenen"
    ]
  },
  {
    "code": "P52.2",
    "name": "Intraventrikuläre nichttraumatische Blutung 3. Grades beim Fetus",
    "synonyms": [
      "Intraventrikuläre nichttraumatische Blutung 3. Grades beim Fetus",
      "Intraventrikuläre nichttraumatische Blutung 3. Grades beim Neugeborenen",
      "Schwere Ventrikeleinbruchsblutung von 50 % oder mehr des Ventrikelvolumens beim Fetus",
      "Schwere Ventrikeleinbruchsblutung von 50 % oder mehr des Ventrikelvolumens beim Neugeborenen",
      "Subependymblutung mit intraventrikulärer Ausdehnung 3. Grades beim Fetus",
      "Subependymblutung mit intraventrikulärer Ausdehnung 3. Grades beim Neugeborenen"
    ]
  },
  {
    "code": "P52.3",
    "name": "Intraventrikuläre Hämorrhagie beim Neugeborenen",
    "synonyms": [
      "Intraventrikuläre Blutung beim Neugeborenen",
      "Intraventrikuläre Hämorrhagie beim Fetus",
      "Intraventrikuläre Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P52.4",
    "name": "Hirnblutung beim Neugeborenen",
    "synonyms": [
      "Gehirnblutung beim Fetus",
      "Gehirnblutung beim Neugeborenen",
      "Gehirnhämatom beim Fetus a.n.k.",
      "Gehirnhämatom beim Neugeborenen a.n.k.",
      "Gehirnödem beim Fetus",
      "Gehirnödem beim Neugeborenen",
      "Hirnblutung beim Neugeborenen",
      "Intrazerebrale Blutung beim Neugeborenen",
      "Intrazerebrale Hämorrhagie beim Fetus",
      "Intrazerebrale Hämorrhagie beim Neugeborenen",
      "Intrazerebrale nichttraumatische Blutung beim Fetus",
      "Intrazerebrale nichttraumatische Blutung beim Neugeborenen",
      "Nichttraumatische Gehirnblutung beim Neugeborenen",
      "Nichttraumatische Gehirnhämorrhagie beim Fetus",
      "Nichttraumatische Gehirnhämorrhagie beim Neugeborenen",
      "Zerebrale Blutung beim Neugeborenen",
      "Zerebrale Hämorrhagie beim Fetus",
      "Zerebrale Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P52.5",
    "name": "Nichttraumatische Subarachnoidalblutung beim Fetus",
    "synonyms": [
      "Nichttraumatische Subarachnoidalblutung beim Fetus",
      "Nichttraumatische Subarachnoidalblutung beim Neugeborenen",
      "Subarachnoidalblutung beim Fetus",
      "Subarachnoidalblutung beim Neugeborenen",
      "Subarachnoidale Hämorrhagie beim Fetus",
      "Subarachnoidale Hämorrhagie beim Neugeborenen",
      "Subarachnoidales Hämatom beim Fetus",
      "Subarachnoidales Hämatom beim Neugeborenen"
    ]
  },
  {
    "code": "P52.6",
    "name": "Nichttraumatische Kleinhirnblutung beim Fetus",
    "synonyms": [
      "Blutung der Fossa cranii posterior beim Fetus",
      "Blutung der Fossa cranii posterior beim Neugeborenen",
      "Hämorrhagie der Fossa cranii posterior beim Fetus",
      "Hämorrhagie der Fossa cranii posterior beim Neugeborenen",
      "Nichttraumatische Kleinhirnblutung beim Fetus",
      "Nichttraumatische Kleinhirnblutung beim Neugeborenen",
      "Zerebellare Blutung beim Neugeborenen",
      "Zerebellare Hämorrhagie beim Fetus",
      "Zerebellare Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P52.8",
    "name": "Zephalhämatozele beim Neugeborenen",
    "synonyms": [
      "Extradurale Blutung beim Fetus",
      "Extradurale Blutung beim Neugeborenen",
      "Extradurale Hämorrhagie beim Fetus",
      "Extradurale Hämorrhagie beim Neugeborenen",
      "Nichttraumatisches subdurales Hämatom beim Fetus",
      "Nichttraumatisches subdurales Hämatom beim Neugeborenen",
      "Subdurale Blutung beim Neugeborenen",
      "Subdurale Hämorrhagie beim Fetus",
      "Subdurale Hämorrhagie beim Neugeborenen",
      "Zephalhämatozele beim Fetus",
      "Zephalhämatozele beim Neugeborenen"
    ]
  },
  {
    "code": "P52.9",
    "name": "Intrakranielle Blutung durch Anoxie beim Neugeborenen",
    "synonyms": [
      "Intrakranielle Blutung beim Neugeborenen",
      "Intrakranielle Blutung durch Anoxie beim Fetus",
      "Intrakranielle Blutung durch Anoxie beim Neugeborenen",
      "Intrakranielle Blutung durch Hypoxie beim Fetus",
      "Intrakranielle Blutung durch Hypoxie beim Neugeborenen",
      "Intrakranielle Hämorrhagie beim Fetus",
      "Intrakranielle Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P53",
    "name": "Vitamin-K-Mangel beim Neugeborenen",
    "synonyms": [
      "Hämorrhagische Krankheit beim Neugeborenen",
      "Morbus haemorrhagicus beim Neugeborenen",
      "Vitamin-K-Mangel beim Neugeborenen"
    ]
  },
  {
    "code": "P54.0",
    "name": "Hämatemesis beim Neugeborenen",
    "synonyms": [
      "Hämatemesis beim Neugeborenen"
    ]
  },
  {
    "code": "P54.1",
    "name": "Meläna beim Neugeborenen",
    "synonyms": [
      "Meläna beim Neugeborenen"
    ]
  },
  {
    "code": "P54.2",
    "name": "Rektumblutung beim Neugeborenen",
    "synonyms": [
      "Rektumblutung beim Neugeborenen",
      "Rektumhämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P54.3",
    "name": "Gastrointestinale Hämorrhagie beim Neugeborenen",
    "synonyms": [
      "Darmblutung beim Neugeborenen",
      "Darmhämorrhagie beim Neugeborenen",
      "Gastroenterische Blutung beim Neugeborenen",
      "Gastroenterische Hämorrhagie beim Neugeborenen",
      "Gastrointestinale Blutung beim Neugeborenen",
      "Gastrointestinale Hämorrhagie beim Neugeborenen",
      "Hämorrhagie des Intestinums beim Neugeborenen",
      "Magenblutung beim Neugeborenen",
      "Magenhämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P54.4",
    "name": "Nebennierenblutung beim Neugeborenen",
    "synonyms": [
      "Nebennierenblutung beim Neugeborenen"
    ]
  },
  {
    "code": "P54.5",
    "name": "Hautblutung beim Neugeborenen",
    "synonyms": [
      "Ekchymose beim Neugeborenen",
      "Hautblutung beim Neugeborenen",
      "Hämorrhagie der Haut beim Neugeborenen",
      "Oberflächliches Hämatom beim Neugeborenen",
      "Petechien beim Neugeborenen",
      "Prellung beim Neugeborenen",
      "Quetschwunde beim Neugeborenen"
    ]
  },
  {
    "code": "P54.6",
    "name": "Vaginalblutung beim Neugeborenen",
    "synonyms": [
      "Pseudomenstruation",
      "Pseudomenstruation beim Neugeborenen",
      "Vaginalblutung beim Neugeborenen",
      "Vaginalhämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P54.8",
    "name": "Hämothorax beim Neugeborenen",
    "synonyms": [
      "Blutung der inneren Organe beim Neugeborenen",
      "Hämoperikard beim Neugeborenen",
      "Hämorrhagie der inneren Organe beim Neugeborenen",
      "Hämothorax beim Neugeborenen",
      "Konjunktivablutung beim Neugeborenen",
      "Konjunktivahämorrhagie beim Neugeborenen",
      "Nasenblutung beim Neugeborenen",
      "Nasenhämorrhagie beim Neugeborenen",
      "Schleimhautblutung beim Neugeborenen",
      "Schleimhauthämorrhagie beim Neugeborenen",
      "Viszerale Blutung beim Neugeborenen",
      "Viszerale Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P54.9",
    "name": "Hämorrhagie beim Neugeborenen",
    "synonyms": [
      "Blutung beim Neugeborenen",
      "Hämorrhagie beim Neugeborenen"
    ]
  },
  {
    "code": "P55.0",
    "name": "Rh [Rhesus]-Isoimmunisierung beim Fetus",
    "synonyms": [
      "Anti-D-Antikörper der Mutter beim Fetus",
      "Anti-D-Antikörper der Mutter beim Neugeborenen",
      "Fetale Gelbsucht durch Rh [Rhesus]-Inkompatibilität",
      "Fetale Gelbsucht durch Rh [Rhesus]-Isoimmunisierung",
      "Fetale Rh [Rhesus]-Erythroblastose",
      "Fetaler Ikterus durch Rh [Rhesus]-Inkompatibilität",
      "Fetaler Ikterus durch Rh [Rhesus]-Isoimmunisierung",
      "Hämolytische Krankheit durch Rh-Faktor beim Neugeborenen",
      "Rh [Rhesus]-Isoimmunisierung beim Fetus",
      "Rh [Rhesus]-Isoimmunisierung beim Neugeborenen",
      "Rh [Rhesus]-Unverträglichkeit beim Fetus",
      "Rh [Rhesus]-Unverträglichkeit beim Neugeborenen",
      "Rh-Antikörper der Mutter beim Fetus",
      "Rh-Antikörper der Mutter beim Neugeborenen"
    ]
  },
  {
    "code": "P55.1",
    "name": "AB0-Isoimmunisierung beim Fetus",
    "synonyms": [
      "AB0-Isoimmunisierung beim Fetus",
      "AB0-Isoimmunisierung beim Neugeborenen",
      "AB0-hämolytische Krankheit beim Fetus",
      "AB0-hämolytische Krankheit beim Neugeborenen",
      "Fetale AB0-Inkompatibilität",
      "Fetale Erythroblastose durch AB0-Isoimmunisierung",
      "Fetale Gelbsucht durch AB0-Inkompatibilität",
      "Fetale Gelbsucht durch AB0-Isoimmunisierung",
      "Fetaler Ikterus durch AB0-Inkompatibilität",
      "Fetaler Ikterus durch AB0-Isoimmunisierung"
    ]
  },
  {
    "code": "P55.8",
    "name": "Blutgruppenunverträglichkeit beim Fetus",
    "synonyms": [
      "Blutgruppenunverträglichkeit beim Fetus",
      "Blutgruppenunverträglichkeit beim Neugeborenen",
      "Hämolytische Krankheit des Neugeborenen durch Kell-Alloimmunisierung"
    ]
  },
  {
    "code": "P55.9",
    "name": "Fetale Erythroblastose",
    "synonyms": [
      "Akute hämolytische Anämie beim Fetus",
      "Akute hämolytische Anämie beim Neugeborenen",
      "Angeborene Anämie durch Isoimmunisation a.n.k.",
      "Erythroblasten-Anämie beim Fetus",
      "Erythroblasten-Anämie beim Neugeborenen",
      "Fetale Erythroblastose",
      "Hämolytische Krankheit beim Fetus",
      "Hämolytische Krankheit beim Neugeborenen",
      "Isoimmunisation beim Neugeborenen a.n.k.",
      "Morbus haemolyticus neonatorum",
      "Neonatale Gelbsucht durch Isoimmunisation a.n.k.",
      "Neonatale Gelbsucht durch maternal-fetale Inkompatibilität a.n.k.",
      "Neonataler Ikterus durch Isoimmunisation a.n.k.",
      "Neonataler Ikterus durch maternal-fetale Inkompatibilität a.n.k."
    ]
  },
  {
    "code": "P56.0",
    "name": "Hydrops fetalis durch Isoimmunisierung",
    "synonyms": [
      "Hydrops fetalis durch Isoimmunisierung"
    ]
  },
  {
    "code": "P57.0",
    "name": "Kernikterus durch Isoimmunisierung",
    "synonyms": [
      "Encephalopathia hyperbilirubinaemica beim Neugeborenen durch Isoimmunisierung",
      "Encephalopathia hyperbilirubinaemica durch Isoimmunisierung",
      "Kernikterus durch Isoimmunisierung"
    ]
  },
  {
    "code": "P57.8",
    "name": "Chronische Bilirubin-Enzephalopathie",
    "synonyms": [
      "Chronische Bilirubin-Enzephalopathie"
    ]
  },
  {
    "code": "P57.9",
    "name": "Kernikterus",
    "synonyms": [
      "Akute Bilirubin-Enzephalopathie",
      "Bilirubinenzephalopathie",
      "Bilirubingehirnschaden",
      "Bilirubinhirnschaden",
      "Encephalopathia hyperbilirubinaemica beim Neugeborenen",
      "Kernikterus",
      "Kernikterus beim Neugeborenen",
      "Kernikterus-Syndrom",
      "Stammganglienikterus"
    ]
  },
  {
    "code": "P58.0",
    "name": "Neugeborenenikterus durch Quetschwunde",
    "synonyms": [
      "Neonatale Gelbsucht durch Quetschung",
      "Neonataler Ikterus durch Quetschung",
      "Neugeborenenikterus durch Quetschwunde"
    ]
  },
  {
    "code": "P58.1",
    "name": "Neugeborenenikterus durch Blutung",
    "synonyms": [
      "Fetale Gelbsucht durch Blutung",
      "Fetaler Ikterus durch Blutung",
      "Neonatale Gelbsucht durch Blutung",
      "Neonataler Ikterus durch Blutung",
      "Neugeborenenikterus durch Blutung"
    ]
  },
  {
    "code": "P58.2",
    "name": "Neugeborenenikterus durch Infektion",
    "synonyms": [
      "Neonatale Gelbsucht durch Infektion",
      "Neonataler Ikterus durch Infektion",
      "Neugeborenenikterus durch Infektion"
    ]
  },
  {
    "code": "P58.3",
    "name": "Neugeborenenikterus durch Polyglobulie",
    "synonyms": [
      "Neonatale Gelbsucht durch Polyzythämie",
      "Neonataler Ikterus durch Polyzythämie",
      "Neugeborenenikterus durch Polyglobulie"
    ]
  },
  {
    "code": "P58.4",
    "name": "Fetale Gelbsucht durch von der Mutter übertragene Arzneimittel",
    "synonyms": [
      "Fetale Gelbsucht durch von der Mutter übertragene Arzneimittel",
      "Fetaler Ikterus durch von der Mutter übertragene Arzneimittel"
    ]
  },
  {
    "code": "P58.5",
    "name": "Neugeborenenikterus durch Verschlucken mütterlichen Blutes",
    "synonyms": [
      "Neonatale Gelbsucht durch Verschlucken mütterlichen Blutes",
      "Neonataler Ikterus durch Verschlucken mütterlichen Blutes",
      "Neugeborenenikterus durch Verschlucken mütterlichen Blutes"
    ]
  },
  {
    "code": "P58.8",
    "name": "Gesteigerte neonatale Hämolyse",
    "synonyms": [
      "Gesteigerte neonatale Hämolyse",
      "Neonatale Gelbsucht durch Sphärozytose",
      "Neonatale Gelbsucht durch hereditäre hämolytische Anämie",
      "Neonataler Ikterus durch Sphärozytose",
      "Neonataler Ikterus durch hereditäre hämolytische Anämie"
    ]
  },
  {
    "code": "P58.9",
    "name": "Icterus neonatorum durch gesteigerte Hämolyse",
    "synonyms": [
      "Icterus neonatorum durch gesteigerte Hämolyse",
      "Neonatale Gelbsucht durch gesteigerte Hämolyse a.n.k.",
      "Neonataler Ikterus durch gesteigerte Hämolyse a.n.k.",
      "Neugeborenenikterus durch gesteigerte Hämolyse"
    ]
  },
  {
    "code": "P59.0",
    "name": "Neugeborenenikterus bei vorzeitiger Geburt",
    "synonyms": [
      "Hyperbilirubinämie bei Prämaturität",
      "Neonatale Gelbsucht durch vorzeitige Entbindung",
      "Neonataler Ikterus durch vorzeitige Entbindung",
      "Neugeborenenikterus bei vorzeitiger Geburt",
      "Neugeborenenikterus durch verzögerte Konjugation bei vorzeitiger Geburt"
    ]
  },
  {
    "code": "P59.1",
    "name": "Gallepfropfsyndrom beim Neugeborenen",
    "synonyms": [
      "Gallepfropfsyndrom beim Neugeborenen",
      "Inspissated-bile-Syndrom",
      "Inspissated-bile-Syndrom beim Neugeborenen",
      "Neonatale Gelbsucht durch Inspissated-bile-Syndrom",
      "Neonataler Ikterus durch Inspissated-bile-Syndrom"
    ]
  },
  {
    "code": "P59.2",
    "name": "Hepatitis beim Neugeborenen",
    "synonyms": [
      "Fetale Riesenzellhepatitis",
      "Fetale idiopathische Hepatitis",
      "Hepatitis beim Neugeborenen",
      "Neonatale Gelbsucht durch Leberzellschaden",
      "Neonatale Riesenzellhepatitis",
      "Neonatale idiopathische Hepatitis",
      "Neonatale toxische Hepatitis",
      "Neonataler Ikterus durch Leberzellschaden"
    ]
  },
  {
    "code": "P59.3",
    "name": "Neugeborenenikterus durch Muttermilch-Inhibitor",
    "synonyms": [
      "Neonatale Gelbsucht durch Muttermilch-Inhibitor zur Glukuronkonjugation",
      "Neonataler Ikterus durch Muttermilch-Inhibitor zur Glukuronkonjugation",
      "Neugeborenenikterus durch Muttermilch-Inhibitor"
    ]
  },
  {
    "code": "P59.8",
    "name": "Fetale Gelbsucht durch Ausbleiben der hepatischen Glukuronkonjugation des Bilirubins",
    "synonyms": [
      "Fetale Gelbsucht durch Ausbleiben der hepatischen Glukuronkonjugation des Bilirubins",
      "Fetaler Ikterus durch Ausbleiben der hepatischen Glukuronkonjugation des Bilirubins",
      "Lucey-Driscoll-Syndrom",
      "Neonatale Gelbsucht durch Störung im Enzymsystem für die Bilirubinkonjugation",
      "Neonatale Gelbsucht durch verzögerte Konjugation",
      "Neonataler Ikterus durch Störung im Enzymsystem für die Bilirubinkonjugation",
      "Neonataler Ikterus durch verzögerte Konjugation"
    ]
  },
  {
    "code": "P59.9",
    "name": "Neugeborenenikterus",
    "synonyms": [
      "Icterus neonatorum",
      "Icterus neonatorum gravis",
      "Icterus neonatorum prolongatus",
      "Konjugationsikterus",
      "Neugeborenengelbsucht",
      "Neugeborenenhyperbilirubinämie",
      "Neugeborenenikterus",
      "Physiologische fetale Gelbsucht",
      "Physiologische neonatale Gelbsucht",
      "Physiologischer fetaler Ikterus",
      "Physiologischer neonataler Ikterus",
      "Verlängerter physiologischer Neugeborenenikterus",
      "Verstärkter physiologischer Neugeborenenikterus"
    ]
  },
  {
    "code": "P60",
    "name": "Disseminierte intravasale Gerinnung beim Fetus",
    "synonyms": [
      "Defibrinationssyndrom beim Fetus",
      "Defibrinationssyndrom beim Neugeborenen",
      "Disseminierte intravasale Gerinnung beim Fetus",
      "Disseminierte intravasale Gerinnung beim Neugeborenen",
      "Verbrauchskoagulopathie beim Fetus",
      "Verbrauchskoagulopathie beim Neugeborenen"
    ]
  },
  {
    "code": "P61.0",
    "name": "Transitorische Thrombozytopenie beim Neugeborenen",
    "synonyms": [
      "Fetale und neonatale Alloimmunthrombozytopenie",
      "Flüchtige neonatale Thrombozytopenie",
      "Flüchtige neonatale thrombozytopenische Purpura",
      "Thrombozytopenie durch Austauschtransfusion beim Neugeborenen",
      "Thrombozytopenie durch Isoimmunisierung beim Neugeborenen",
      "Thrombozytopenie durch idiopathische Thrombozytopenie der Mutter beim Neugeborenen",
      "Transitorische Thrombozytopenie beim Neugeborenen",
      "Transitorische neonatale Thrombozytopenie"
    ]
  },
  {
    "code": "P61.1",
    "name": "Polyglobulie beim Neugeborenen",
    "synonyms": [
      "Neonatale Polyglobulie",
      "Polyglobulie beim Neugeborenen"
    ]
  },
  {
    "code": "P61.2",
    "name": "Anämie bei Prämaturität",
    "synonyms": [
      "Anämie bei Prämaturität"
    ]
  },
  {
    "code": "P61.3",
    "name": "Angeborene Anämie durch fetalen Blutverlust",
    "synonyms": [
      "Angeborene Anämie durch fetalen Blutverlust",
      "Anämie des Fetus durch fetalen Blutverlust",
      "Anämie des Neugeborenen durch fetalen Blutverlust",
      "Kongenitale Anämie durch fetalen Blutverlust",
      "Posthämorrhagische Anaemia neonatorum",
      "Posthämorrhagische Anämie beim Neugeborenen"
    ]
  },
  {
    "code": "P61.4",
    "name": "Angeborene Anämie",
    "synonyms": [
      "Anaemia neonatorum",
      "Angeborene Anämie",
      "Kongenitale Anämie"
    ]
  },
  {
    "code": "P61.5",
    "name": "Transitorische Neutropenie beim Neugeborenen",
    "synonyms": [
      "Neonatale Alloimmunneutropenie",
      "Transitorische Neutropenie beim Neugeborenen"
    ]
  },
  {
    "code": "P61.6",
    "name": "Transitorische Hypoprothrombinämie beim Neugeborenen",
    "synonyms": [
      "Abnorme transitorische Gerinnungsstörung beim Neugeborenen",
      "Transitorische Hypoprothrombinämie beim Neugeborenen",
      "Transitorische neonatale Gerinnungsstörung",
      "Transitorische neonatale Koagulationsstörung",
      "Vorübergehender Gerinnungsdefekt beim Neugeborenen",
      "Vorübergehender Koagulationsdefekt beim Neugeborenen"
    ]
  },
  {
    "code": "P61.9",
    "name": "Blutdyskrasie beim Fetus",
    "synonyms": [
      "Blutdyskrasie beim Fetus",
      "Blutdyskrasie beim Neugeborenen",
      "Hämatologische Störung beim Fetus",
      "Hämatologische Störung beim Neugeborenen"
    ]
  },
  {
    "code": "P70.0",
    "name": "Schädigung des Neugeborenen durch gestationsbedingten Diabetes mellitus",
    "synonyms": [
      "Fetusschädigung durch gestationsbedingten Diabetes mellitus",
      "Neonatale Hypoglykämie durch gestationsbedingten Diabetes mellitus der Mutter",
      "Schädigung des Neugeborenen durch gestationsbedingten Diabetes mellitus",
      "Syndrom des Kindes einer Mutter mit gestationsbedingtem Diabetes mellitus"
    ]
  },
  {
    "code": "P70.1",
    "name": "Diabetische Fetopathie",
    "synonyms": [
      "Diabetische Embryopathie",
      "Diabetische Fetopathie",
      "Hypoglykämie des Säuglings durch den Diabetes mellitus der Mutter",
      "Syndrom des Kindes einer diabetischen Mutter"
    ]
  },
  {
    "code": "P70.2",
    "name": "Diabetes mellitus beim Neugeborenen",
    "synonyms": [
      "Diabetes mellitus beim Neugeborenen",
      "Neonataler Diabetes mellitus",
      "Permanenter neonataler Diabetes mellitus",
      "Transitorischer neonataler Diabetes mellitus"
    ]
  },
  {
    "code": "P70.3",
    "name": "Iatrogene Hypoglykämie beim Neugeborenen",
    "synonyms": [
      "Iatrogene Hypoglykämie beim Neugeborenen"
    ]
  },
  {
    "code": "P70.4",
    "name": "Transitorische neonatale Hypoglykämie",
    "synonyms": [
      "Transitorische Hypoglykämie beim Neugeborenen",
      "Transitorische neonatale Hypoglykämie"
    ]
  },
  {
    "code": "P70.9",
    "name": "Transitorische neonatale Kohlenhydratstoffwechselstörung",
    "synonyms": [
      "Transitorische neonatale Kohlenhydratstoffwechselstörung"
    ]
  },
  {
    "code": "P71.0",
    "name": "Kuhmilch-Hypokalzämie beim Neugeborenen",
    "synonyms": [
      "Kuhmilch-Hypokalzämie beim Neugeborenen"
    ]
  },
  {
    "code": "P71.1",
    "name": "Hypokalzämie beim Neugeborenen",
    "synonyms": [
      "Hypokalzämie beim Neugeborenen"
    ]
  },
  {
    "code": "P71.2",
    "name": "Hypomagnesiämie beim Neugeborenen",
    "synonyms": [
      "Hypomagnesiämie beim Neugeborenen",
      "Neonatale Hypomagnesiämie"
    ]
  },
  {
    "code": "P71.3",
    "name": "Tetanie beim Neugeborenen ohne Kalzium- oder Magnesiummangel",
    "synonyms": [
      "Neonatale Tetanie ohne Kalzium- oder Magnesiummangel",
      "Neugeborenentetanie",
      "Tetanie beim Neugeborenen ohne Kalzium- oder Magnesiummangel"
    ]
  },
  {
    "code": "P71.4",
    "name": "Transitorischer Hypoparathyreoidismus beim Neugeborenen",
    "synonyms": [
      "Neonataler transitorischer Hypoparathyreoidismus",
      "Transitorischer Hypoparathyreoidismus beim Neugeborenen"
    ]
  },
  {
    "code": "P71.8",
    "name": "Neonatale Hypermagnesiämie",
    "synonyms": [
      "Neonatale Hypermagnesiämie"
    ]
  },
  {
    "code": "P71.9",
    "name": "Transitorische Störung des Magnesiumstoffwechsels beim Neugeborenen",
    "synonyms": [
      "Transitorische Störung des Kalziumstoffwechsels beim Neugeborenen",
      "Transitorische Störung des Magnesiumstoffwechsels beim Neugeborenen"
    ]
  },
  {
    "code": "P72.0",
    "name": "Neonataler Kropf a.n.k.",
    "synonyms": [
      "Kongenitaler transitorischer Kropf mit normaler Funktion",
      "Neonatale Struma a.n.k.",
      "Neonataler Kropf a.n.k.",
      "Neugeborenenstruma",
      "Struma neonatorum",
      "Transitorische Struma congenita mit normaler Funktion beim Neugeborenen"
    ]
  },
  {
    "code": "P72.1",
    "name": "Transitorische Hyperthyreose beim Neugeborenen",
    "synonyms": [
      "Thyreotoxikose beim Neugeborenen",
      "Transitorische Hyperthyreose beim Neugeborenen",
      "Transitorische neonatale Thyreotoxikose"
    ]
  },
  {
    "code": "P72.2",
    "name": "Transitorischer Hypothyreoidismus beim Neugeborenen",
    "synonyms": [
      "Angeborene Hypothyreose durch mütterliche Einnahme von Thyreostatika",
      "Angeborene Hypothyreose durch transplazentare Passage von maternalen TSH-Rezeptor-blockierenden Antikörpern",
      "Angeborene transitorische Hypothyreose durch heterozygote THOX2-Genmutationen",
      "Transitorische Hypothyreose beim Neugeborenen",
      "Transitorische Hypothyreose beim Neugeborenen durch erhöhte Jodzufuhr",
      "Transitorische neonatale Funktionsstörung der Schilddrüsen a.n.k.",
      "Transitorischer Hypothyreoidismus beim Neugeborenen"
    ]
  },
  {
    "code": "P72.8",
    "name": "Transitorischer neonataler multipler Acyl-CoA-Dehydrogenase-Mangel",
    "synonyms": [
      "Transitorischer neonataler multipler Acyl-CoA-Dehydrogenase-Mangel"
    ]
  },
  {
    "code": "P72.9",
    "name": "Neonatale transitorische endokrine Störung",
    "synonyms": [
      "Neonatale transitorische endokrine Störung"
    ]
  },
  {
    "code": "P74.0",
    "name": "Metabolische Spätazidose beim Neugeborenen",
    "synonyms": [
      "Metabolische Spätazidose beim Neugeborenen"
    ]
  },
  {
    "code": "P74.1",
    "name": "Dehydratation beim Neugeborenen",
    "synonyms": [
      "Dehydratation beim Neugeborenen",
      "Flüssigkeitsverlust beim Neugeborenen"
    ]
  },
  {
    "code": "P74.2",
    "name": "Störung des Natriumgleichgewichtes beim Neugeborenen",
    "synonyms": [
      "Störung des Natriumgleichgewichtes beim Neugeborenen"
    ]
  },
  {
    "code": "P74.3",
    "name": "Störung des Kaliumgleichgewichtes beim Neugeborenen",
    "synonyms": [
      "Störung des Kaliumgleichgewichtes beim Neugeborenen"
    ]
  },
  {
    "code": "P74.4",
    "name": "Störung des Wasser- und Elektrolythaushaltes beim Neugeborenen",
    "synonyms": [
      "Neonatale flüchtige Blutgerinnungsstörung",
      "Störung des Wasser- und Elektrolythaushaltes beim Neugeborenen",
      "Transitorische Elektrolytstörung beim Neugeborenen"
    ]
  },
  {
    "code": "P74.5",
    "name": "Transitorische Hypertyrosinämie beim Neugeborenen",
    "synonyms": [
      "Neonatale transiente Tyrosinämie",
      "Transiente Tyrosinämie beim Neugeborenen",
      "Transitorische Hypertyrosinämie beim Neugeborenen"
    ]
  },
  {
    "code": "P74.8",
    "name": "Transitorische neonatale Aminosäurestoffwechselstörung",
    "synonyms": [
      "Neugeborenen-Hypoalbuminämie",
      "Transiente Hyperammonämie des Neugeborenen",
      "Transitorische neonatale Aminosäurestoffwechselstörung"
    ]
  },
  {
    "code": "P74.9",
    "name": "Neonatale transitorische Stoffwechselstörung",
    "synonyms": [
      "Neonatale transitorische Stoffwechselstörung"
    ]
  },
  {
    "code": "P76.0",
    "name": "Mekoniumpfropfsyndrom a.n.k.",
    "synonyms": [
      "Mekoniumileus durch Guanylatcyclase-2C-Mangel",
      "Mekoniumileus im Sinne von Mekoniumpfropf ohne zystische Fibrose",
      "Mekoniumileus ohne zystische Fibrose",
      "Mekoniumobstruktion beim Neugeborenen",
      "Mekoniumpfropfsyndrom a.n.k."
    ]
  },
  {
    "code": "P76.1",
    "name": "Transitorischer Ileus beim Neugeborenen",
    "synonyms": [
      "Transitorischer Ileus beim Neugeborenen"
    ]
  },
  {
    "code": "P76.2",
    "name": "Darmverschluss durch eingedickte Milch beim Neugeborenen",
    "synonyms": [
      "Darmverschluss durch eingedickte Milch beim Neugeborenen",
      "Darmverschluss durch kondensierte Milch beim Neugeborenen"
    ]
  },
  {
    "code": "P76.8",
    "name": "Darmverschluss durch Kotsteine beim Neugeborenen",
    "synonyms": [
      "Darmverschluss durch Kotsteine beim Neugeborenen",
      "Volvulus beim Neugeborenen"
    ]
  },
  {
    "code": "P76.9",
    "name": "Darmverschluss beim Neugeborenen",
    "synonyms": [
      "Darmverschluss beim Neugeborenen"
    ]
  },
  {
    "code": "P77",
    "name": "Enterocolitis necroticans beim Fetus",
    "synonyms": [
      "Enterocolitis necroticans beim Fetus",
      "Enterocolitis necroticans beim Neugeborenen",
      "NEC [nekrotisierende Enterokolitis] beim Neugeborenen",
      "Nekrotisierende Enteritis beim Fetus",
      "Nekrotisierende Enteritis beim Neugeborenen",
      "Nekrotisierende Enterokolitis beim Fetus",
      "Nekrotisierende Enterokolitis beim Neugeborenen"
    ]
  },
  {
    "code": "P78.0",
    "name": "Darmperforation in der Perinatalperiode",
    "synonyms": [
      "Darmperforation beim Neugeborenen",
      "Darmperforation in der Perinatalperiode",
      "Darmruptur beim Fetus",
      "Darmruptur beim Neugeborenen",
      "Duodenalperforation beim Fetus",
      "Duodenalperforation beim Neugeborenen",
      "Duodenalruptur beim Fetus",
      "Duodenalruptur beim Neugeborenen",
      "Ileumperforation beim Fetus",
      "Ileumperforation beim Neugeborenen",
      "Ileumruptur beim Fetus",
      "Ileumruptur beim Neugeborenen",
      "Intestinalperforation beim Fetus",
      "Intestinalperforation beim Neugeborenen",
      "Intestinalruptur beim Fetus",
      "Intestinalruptur beim Neugeborenen",
      "Jejunumperforation beim Fetus",
      "Jejunumperforation beim Neugeborenen",
      "Jejunumruptur beim Fetus",
      "Jejunumruptur beim Neugeborenen",
      "Kolonperforation beim Fetus",
      "Kolonperforation beim Neugeborenen",
      "Kolonruptur beim Fetus",
      "Kolonruptur beim Neugeborenen",
      "Mekoniumperitonitis",
      "Rektumperforation beim Fetus",
      "Rektumperforation beim Neugeborenen",
      "Rektumruptur beim Fetus",
      "Rektumruptur beim Neugeborenen",
      "Sigmaperforation beim Fetus",
      "Sigmaperforation beim Neugeborenen",
      "Sigmaruptur beim Fetus",
      "Sigmaruptur beim Neugeborenen",
      "Spontane intestinale Perforation beim Neugeborenen"
    ]
  },
  {
    "code": "P78.1",
    "name": "Kongenitale Peritonitis a.n.k.",
    "synonyms": [
      "Kongenitale Peritonitis a.n.k.",
      "Neonatale Peritonitis",
      "Peritonitis beim Neugeborenen"
    ]
  },
  {
    "code": "P78.2",
    "name": "Hämatemesis und Meläna beim Neugeborenen durch Verschlucken mütterlichen Bluts",
    "synonyms": [
      "Hämatemesis und Meläna beim Neugeborenen durch Verschlucken mütterlichen Bluts"
    ]
  },
  {
    "code": "P78.3",
    "name": "Nichtinfektiöse Diarrhoe beim Neugeborenen",
    "synonyms": [
      "Angeborene chronische Diarrhoe mit exsudativer Enteropathie",
      "Kongenitale Chlorid-Diarrhoe",
      "Kongenitale Natrium-Diarrhoe",
      "Nichtinfektiöse Diarrhoe beim Neugeborenen",
      "Nichtinfektiöse neonatale Diarrhoe"
    ]
  },
  {
    "code": "P78.8",
    "name": "Angeborene Leberzirrhose",
    "synonyms": [
      "Angeborene Leberzirrhose",
      "Neonataler ösophagealer Reflux",
      "Ulcus pepticum beim Neugeborenen"
    ]
  },
  {
    "code": "P78.9",
    "name": "Störung des Verdauungssystems beim Neugeborenen",
    "synonyms": [
      "Störung des Verdauungssystems beim Neugeborenen"
    ]
  },
  {
    "code": "P80.0",
    "name": "Kältesyndrom beim Neugeborenen",
    "synonyms": [
      "Kältesyndrom beim Neugeborenen",
      "Schwere neonatale Hypothermie",
      "Trauma durch Kälte beim Neugeborenen"
    ]
  },
  {
    "code": "P80.8",
    "name": "Geringgradige Hypothermie beim Neugeborenen",
    "synonyms": [
      "Geringgradige Hypothermie beim Neugeborenen",
      "Geringgradige neonatale Hypothermie",
      "Umgebungsbedingte neonatale Hypothermie a.n.k."
    ]
  },
  {
    "code": "P80.9",
    "name": "Hypothermie beim Neugeborenen",
    "synonyms": [
      "Hypothermie beim Neugeborenen",
      "Neonatale Hypothermie"
    ]
  },
  {
    "code": "P81.0",
    "name": "Umweltbedingte Hyperthermie beim Neugeborenen",
    "synonyms": [
      "Umweltbedingte Hyperthermie beim Neugeborenen",
      "Umweltbedingtes Fieber beim Neugeborenen"
    ]
  },
  {
    "code": "P81.9",
    "name": "Fieber beim Neugeborenen",
    "synonyms": [
      "Fieber beim Neugeborenen",
      "Störung der Temperaturregulation beim Neugeborenen"
    ]
  },
  {
    "code": "P83.0",
    "name": "Sclerema neonatorum",
    "synonyms": [
      "Sclerema adiposum neonatorum",
      "Sclerema neonatorum",
      "Sclerema oedematosum neonatorum",
      "Sklerem beim Neugeborenen",
      "Sklerödem beim Neugeborenen"
    ]
  },
  {
    "code": "P83.1",
    "name": "Erythema toxicum neonatorum",
    "synonyms": [
      "Erythema toxicum neonatorum"
    ]
  },
  {
    "code": "P83.2",
    "name": "Nichtimmunologischer Hydrops fetalis",
    "synonyms": [
      "Anasarka beim Neugeborenen",
      "Generalisiertes fetales Ödem",
      "Hydrops fetalis",
      "Hydrops fetalis, nicht durch hämolytische Krankheit bedingt",
      "Nichtimmunologischer Hydrops fetalis"
    ]
  },
  {
    "code": "P83.3",
    "name": "Ödem beim Fetus a.n.k.",
    "synonyms": [
      "Ödem beim Fetus a.n.k.",
      "Ödem beim Neugeborenen a.n.k."
    ]
  },
  {
    "code": "P83.4",
    "name": "Brustdrüsenschwellung beim Neugeborenen",
    "synonyms": [
      "Brustdrüsenhypertrophie beim Neugeborenen",
      "Brustdrüsenschwellung beim Neugeborenen",
      "Hexenmilch",
      "Mammahypertrophie beim Neugeborenen",
      "Mammaschwellung beim Neugeborenen",
      "Neonatale nichtinfektiöse Mastitis",
      "Neugeborenes mit Brustdrüsenschwellung",
      "Nichtinfektiöse Mastitis beim Neugeborenen"
    ]
  },
  {
    "code": "P83.5",
    "name": "Kongenitale Hydrozele",
    "synonyms": [
      "Angeborene Hydrozele",
      "Hydrozele beim Neugeborenen",
      "Hydrozele des Fetus",
      "Kongenitale Hydrocele vaginalis communicans",
      "Kongenitale Hydrozele"
    ]
  },
  {
    "code": "P83.6",
    "name": "Umbilikaler Polyp beim Neugeborenen",
    "synonyms": [
      "Umbilikaler Polyp beim Neugeborenen"
    ]
  },
  {
    "code": "P83.8",
    "name": "Urticaria neonatorum",
    "synonyms": [
      "Bronze-Baby",
      "Bronze-Baby-Syndrom",
      "Erythema neonatorum",
      "Erythematöser Ausschlag beim Neugeborenen",
      "Erythrodermia neonatorum",
      "Hashimoto-Pritzker-Syndrom",
      "Kongenitale erosive und vesikuläre Dermatose",
      "Nekrose des Unterhautfettgewebes beim Neugeborenen",
      "Neonatale Sklerodermie",
      "Pseudosklerem beim Neugeborenen",
      "Sklerodermie beim Neugeborenen",
      "Urticaria neonatorum"
    ]
  },
  {
    "code": "P83.9",
    "name": "Hautstörung beim Neugeborenen",
    "synonyms": [
      "Hautkrankheit beim Fetus",
      "Hautkrankheit beim Neugeborenen",
      "Hautstörung beim Fetus",
      "Hautstörung beim Neugeborenen"
    ]
  },
  {
    "code": "P90",
    "name": "Krampf beim Neugeborenen",
    "synonyms": [
      "Konvulsionen beim Neugeborenen",
      "Krampf beim Neugeborenen"
    ]
  },
  {
    "code": "P91.0",
    "name": "Zerebrale Ischämie beim Neugeborenen",
    "synonyms": [
      "Zerebrale Ischämie beim Neugeborenen"
    ]
  },
  {
    "code": "P91.1",
    "name": "Erworbene periventrikuläre Zyste beim Neugeborenen",
    "synonyms": [
      "Erworbene periventrikuläre Zyste beim Neugeborenen"
    ]
  },
  {
    "code": "P91.2",
    "name": "Zerebrale Leukomalazie beim Neugeborenen",
    "synonyms": [
      "Periventrikuläre Leukomalazie beim Frühgeborenen",
      "Zerebrale Leukomalazie beim Neugeborenen"
    ]
  },
  {
    "code": "P91.3",
    "name": "Zerebrale Übererregbarkeit beim Neugeborenen",
    "synonyms": [
      "Hyperexzitabilität beim Neugeborenen",
      "Zerebrale Irritabilität beim Neugeborenen",
      "Zerebrale Reizung beim Neugeborenen",
      "Zerebrale Übererregbarkeit beim Neugeborenen"
    ]
  },
  {
    "code": "P91.4",
    "name": "Zerebraler Depressionszustand beim Neugeborenen",
    "synonyms": [
      "Zerebraler Depressionszustand beim Neugeborenen"
    ]
  },
  {
    "code": "P91.5",
    "name": "Koma beim Neugeborenen",
    "synonyms": [
      "Koma beim Neugeborenen"
    ]
  },
  {
    "code": "P91.6",
    "name": "Hypoxisch-ischämische Enzephalopathie beim Neugeborenen",
    "synonyms": [
      "HIE [Hypoxisch-ischämische Enzephalopathie] beim Neugeborenen",
      "Hypoxisch-ischämische Enzephalopathie beim Neugeborenen"
    ]
  },
  {
    "code": "P91.7",
    "name": "Erworbener Hydrozephalus beim Neugeborenen",
    "synonyms": [
      "Erworbener Hydrozephalus beim Neugeborenen",
      "Posthämorrhagischer Hydrozephalus beim Neugeborenen"
    ]
  },
  {
    "code": "P91.80",
    "name": "Locked-in-Syndrom beim Neugeborenen",
    "synonyms": [
      "Apallisches Syndrom beim Neugeborenen",
      "Locked-in-Syndrom beim Neugeborenen"
    ]
  },
  {
    "code": "P91.88",
    "name": "Hemiplegie beim Neugeborenen a.n.k.",
    "synonyms": [
      "Hemiplegie beim Neugeborenen a.n.k.",
      "Hirnstamm-Dysfunktion beim Neugeborenen",
      "Versagen lebenswichtiger Zentren beim Neugeborenen"
    ]
  },
  {
    "code": "P91.9",
    "name": "Infantile zerebrale Störung",
    "synonyms": [
      "Frühkindliche Gehirnschädigung mit zerebralem Residualsyndrom",
      "Frühkindliche Hirnschädigung mit zerebralem Residualsyndrom",
      "Frühkindlicher Gehirnschaden",
      "Frühkindlicher Hirnschaden",
      "Infantile zerebrale Störung",
      "Perinatale Gehirnschädigung",
      "Perinatale Hirnschädigung",
      "Zerebrale Störung beim Neugeborenen"
    ]
  },
  {
    "code": "P92.0",
    "name": "Erbrechen beim Neugeborenen",
    "synonyms": [
      "Erbrechen beim Neugeborenen"
    ]
  },
  {
    "code": "P92.1",
    "name": "Rumination beim Neugeborenen",
    "synonyms": [
      "Nahrungsmittelregurgitation beim Neugeborenen",
      "Rumination beim Neugeborenen"
    ]
  },
  {
    "code": "P92.2",
    "name": "Trinkunlust beim Neugeborenen",
    "synonyms": [
      "Trinkschwierigkeiten beim Neugeborenen",
      "Trinkschwäche beim Neugeborenen",
      "Trinkunlust beim Neugeborenen"
    ]
  },
  {
    "code": "P92.3",
    "name": "Unterernährung beim Neugeborenen",
    "synonyms": [
      "Unterernährung beim Neugeborenen"
    ]
  },
  {
    "code": "P92.4",
    "name": "Überernährung beim Neugeborenen",
    "synonyms": [
      "Überernährung beim Neugeborenen"
    ]
  },
  {
    "code": "P92.5",
    "name": "Schwierigkeiten bei Brusternährung beim Neugeborenen",
    "synonyms": [
      "Schwierigkeiten bei Brusternährung beim Neugeborenen",
      "Stillproblem beim Neugeborenen"
    ]
  },
  {
    "code": "P92.9",
    "name": "Ernährungsproblem beim Neugeborenen",
    "synonyms": [
      "Ernährungsproblem beim Neugeborenen",
      "Ernährungsschwierigkeiten beim Neugeborenen",
      "Essstörung beim Neugeborenen"
    ]
  },
  {
    "code": "P93",
    "name": "Arzneimittelreaktion beim Neugeborenen",
    "synonyms": [
      "Arzneimittelreaktion beim Neugeborenen",
      "Grey-Syndrom",
      "Grey-Syndrom durch Chloramphenicol beim Neugeborenen"
    ]
  },
  {
    "code": "P94.0",
    "name": "Transitorische Myasthenia gravis beim Neugeborenen",
    "synonyms": [
      "Transiente neonatale Myasthenia gravis",
      "Transitorische Myasthenia gravis beim Neugeborenen"
    ]
  },
  {
    "code": "P94.1",
    "name": "Angeborene Muskelhypertonie",
    "synonyms": [
      "Angeborene Muskelhypertonie",
      "Angeborene Muskelhypertonie beim Neugeborenen"
    ]
  },
  {
    "code": "P94.2",
    "name": "Angeborene Muskelhypotonie",
    "synonyms": [
      "Angeborene Muskelatonie",
      "Angeborene Muskelhypotonie",
      "Angeborene atonische Pseudoparalyse",
      "Floppy-Infant-Syndrom",
      "Kongenitale Atonie",
      "Unspezifisches Floppy-Infant-Syndrom"
    ]
  },
  {
    "code": "P94.9",
    "name": "Muskeltonusstörung beim Neugeborenen",
    "synonyms": [
      "Muskeltonusstörung beim Neugeborenen"
    ]
  },
  {
    "code": "P95",
    "name": "Totgeburt a.n.k.",
    "synonyms": [
      "Dead-fetus-Syndrom",
      "Fetaltod",
      "Fetaltod unbekannter Ursache",
      "Fruchttod",
      "Infans mortuus",
      "Intrauteriner Fetaltod",
      "Intrauteriner Fruchttod",
      "Intrauteriner Tod",
      "Lithopädion",
      "Mazeration des Fetus",
      "Mazeration des Fetus ohne Hinweis auf die Ursache",
      "Pergamentkind",
      "Spalding-Zeichen",
      "Steinkind",
      "Totgeborener Fetus a.n.k.",
      "Totgeburt a.n.k."
    ]
  },
  {
    "code": "P96.0",
    "name": "Angeborene Niereninsuffizienz",
    "synonyms": [
      "Angeborene Niereninsuffizienz",
      "Angeborene membranöse Nephropathie durch fetomaternale Alloimmunisierung gegen neutrale Endopeptidase",
      "Angeborene membranöse Nephropathie durch maternale Antikörper gegen neutrale Endopeptidase",
      "Angeborenes Nierenversagen",
      "Anurie beim Neugeborenen",
      "Kongenitale Urämie",
      "Urämie beim Neugeborenen"
    ]
  },
  {
    "code": "P96.1",
    "name": "Drogenentzugssyndrom beim Neugeborenen",
    "synonyms": [
      "Arzneimittelabhängigkeit beim Fetus",
      "Arzneimittelabhängigkeit beim Neugeborenen",
      "Arzneimittelentzugssyndrom beim Neugeborenen bei abhängiger Mutter",
      "Drogenabhängigkeit beim Fetus",
      "Drogenabhängigkeit beim Neugeborenen",
      "Drogenentzugssyndrom beim Neugeborenen",
      "Drogenentzugssyndrom beim Neugeborenen bei abhängiger Mutter",
      "Neonatales Abstinenzsyndrom"
    ]
  },
  {
    "code": "P96.2",
    "name": "Entzugssymptome bei therapeutischer Anwendung von Arzneimitteln beim Neugeborenen",
    "synonyms": [
      "Entzugssymptome bei therapeutischer Anwendung von Arzneimitteln beim Neugeborenen"
    ]
  },
  {
    "code": "P96.3",
    "name": "Weite Schädelnähte beim Neugeborenen",
    "synonyms": [
      "Kraniotabes beim Neugeborenen",
      "Weite Schädelnähte beim Neugeborenen"
    ]
  },
  {
    "code": "P96.5",
    "name": "Komplikation nach intrauterinem Eingriff",
    "synonyms": [
      "Komplikation nach intrauterinem Eingriff"
    ]
  },
  {
    "code": "P96.8",
    "name": "Erschöpfung beim Neugeborenen",
    "synonyms": [
      "Erschöpfung beim Neugeborenen",
      "Kollateralkreislauf beim Fetus",
      "Kollateralkreislauf beim Neugeborenen",
      "Kreislaufversagen beim Fetus",
      "Kreislaufversagen beim Neugeborenen",
      "Neonataler Tod a.n.k.",
      "Schock des Fetus durch die Geburt a.n.k.",
      "Schock des Neugeborenen durch die Geburt a.n.k.",
      "Schwaches Neugeborenes",
      "Vitalitätsverlust des Neugeborenen"
    ]
  },
  {
    "code": "P96.9",
    "name": "Angeborene Schwäche a.n.k.",
    "synonyms": [
      "Angeborene Schwäche a.n.k.",
      "Störung beim Neugeborenen"
    ]
  },
  {
    "code": "Q00.0",
    "name": "Akranie",
    "synonyms": [
      "Akranie",
      "Akranius",
      "Amyelenzephalie",
      "Amyelenzephalus",
      "Anenzephalie",
      "Anenzephalus",
      "Angeborene Schädeldeformität mit Anenzephalie",
      "Angeborenes Fehlen von Schädelknochen mit Anenzephalie",
      "Azephalie",
      "Azephalus",
      "Exenzephalie",
      "Fehlen des Gehirns",
      "Gehirnagenesie",
      "Gehirnaplasie",
      "Hemianenzephalie",
      "Hemianenzephalus",
      "Hemienzephalie",
      "Hemikranie im Sinne von Hemizephalie",
      "Hemizephalie",
      "Hemizephalus",
      "Mangelhafter Schädelverschluss mit Anenzephalus",
      "Schädelknochenanomalie mit Anenzephalus",
      "Schädelknochenhypoplasie mit Anenzephalus"
    ]
  },
  {
    "code": "Q00.1",
    "name": "Kraniorhachischisis",
    "synonyms": [
      "Kraniorhachischisis",
      "Kraniorhachischisis totalis"
    ]
  },
  {
    "code": "Q00.2",
    "name": "Inienzephalie",
    "synonyms": [
      "Inienzephalie",
      "Inienzephalus"
    ]
  },
  {
    "code": "Q01.0",
    "name": "Frontale Enzephalozele",
    "synonyms": [
      "Frontale Enzephalozele"
    ]
  },
  {
    "code": "Q01.1",
    "name": "Nasofrontale Enzephalozele",
    "synonyms": [
      "Nasofrontale Enzephalozele"
    ]
  },
  {
    "code": "Q01.2",
    "name": "Okzipitale Enzephalozele",
    "synonyms": [
      "Okzipitale Enzephalozele"
    ]
  },
  {
    "code": "Q01.8",
    "name": "Enaurale Hernia cerebri",
    "synonyms": [
      "Basale Enzephalozele",
      "Enaurale Hernia cerebri",
      "Kongenitale Hernie im Foramen magnum",
      "Parietale Enzephalozele"
    ]
  },
  {
    "code": "Q01.9",
    "name": "Enzephalomeningozele",
    "synonyms": [
      "Angeborene Schädeldeformität mit Enzephalozele",
      "Angeborenes Fehlen von Schädelknochen mit Enzephalozele",
      "Enzephalomeningozele",
      "Enzephalomyelozele",
      "Enzephalozele",
      "Gehirnbruch",
      "Gehirnprolaps",
      "Hirnbruch",
      "Hirnhernie",
      "Hirnprolaps",
      "Hydroenzephalomeningozele",
      "Hydroenzephalozele",
      "Isolierte Enzephalozele",
      "Kongenitale Gehirnhernie",
      "Kongenitale Hernia cerebri",
      "Kongenitale Hydroenzephalomeningozele",
      "Kongenitale Hydroenzephalozele",
      "Kraniale Meningozele",
      "Kranielle Hydromeningozele",
      "Mangelhafter Schädelverschluss mit Enzephalozele",
      "Meningoenzephalozele",
      "Myeloenzephalozele",
      "Podenzephalie",
      "Podenzephalus",
      "Schädelknochenanomalie mit Enzephalozele",
      "Schädelknochenhypoplasie mit Enzephalozele",
      "Schädelknochenverformung mit Enzephalozele",
      "Sinus pericranii",
      "Zephalozele",
      "Zerebrale Meningozele"
    ]
  },
  {
    "code": "Q02",
    "name": "Mikrozephalus",
    "synonyms": [
      "Angeborene Schädeldeformität mit Mikrozephalie",
      "Angeborenes Fehlen von Schädelknochen mit Mikrozephalie",
      "Autosomal-dominante primäre Mikrozephalie",
      "Autosomal-rezessive primäre Mikrozephalie",
      "Gehirnhypoplasie",
      "Hydromikrozephalie",
      "Isolierte kongenitale Mikrozephalie",
      "Kongenitale Gehirnunterentwicklung",
      "Kongenitale zerebrale Unterentwicklung",
      "Letale Mikrozephalie Typ Amish",
      "Mangelhafter Schädelverschluss mit Mikrozephalus",
      "Mikrenzephalie",
      "Mikroenzephalie",
      "Mikrozephalie",
      "Mikrozephalus",
      "PLAA-assoziierte neurologische Entwicklungsstörung",
      "Schädelknochenanomalie mit Mikrozephalus",
      "Schädelknochenhypoplasie mit Mikrozephalus",
      "Schädelknochenverformung mit Mikrozephalie",
      "Spastische Tetraplegie mit dünnem Corpus callosum und progressiver postnataler Mikrozephalie",
      "Syndrom der progressiven Mikrozephalie mit Krämpfen, kortikaler Blindheit und Entwicklungsverzögerung",
      "Syndrom der progressiven Mikrozephalie mit diffuser zerebraler und zerebellarer Atrophie und therapieresistenten Krämpfen",
      "Zephale Hypoplasie"
    ]
  },
  {
    "code": "Q03.0",
    "name": "Fehlbildung des Aquaeductus cerebri",
    "synonyms": [
      "Angeborene Obstruktion des Aquaeductus cerebri",
      "Angeborene Striktur des Aquaeductus cerebri",
      "Anomalie des Aquaeductus cerebri",
      "Anomalie des Sylvius-Aquäduktes",
      "Atresie des Aquaeductus cerebri",
      "Atresie des Sylvius-Aquäduktes",
      "Bickers-Adams-Syndrom",
      "Fehlbildung des Aquaeductus cerebri",
      "Hydrozephalus durch Verschluss des Aquaeductus Sylvii",
      "Hydrozephalus mit Stenose des Aquaeductus Sylvii",
      "Kongenitale Obstruktion des Aquaeductus cerebri",
      "Kongenitaler Verschluss des Aquaeductus cerebri",
      "Septum des Aquaeductus cerebri",
      "Septum des Sylvius-Aquäduktes",
      "Stenose des Aquaeductus cerebri"
    ]
  },
  {
    "code": "Q03.1",
    "name": "Dandy-Walker-Syndrom",
    "synonyms": [
      "Atresie der Apertura lateralis ventriculi quarti",
      "Atresie der Apertura mediana",
      "Atresie der Apertura mediana ventriculi quarti",
      "Atresie der Aperturae laterales",
      "Atresie der Foramina Luschkae",
      "Atresie des Foramen Magendii",
      "Blake-Pouch-Zyste",
      "Dandy-Walker-Anomalie",
      "Dandy-Walker-Fehlbildung",
      "Dandy-Walker-Syndrom",
      "Dandy-Walker-Zyste",
      "Isolierte Dandy-Walker-Fehlbildung mit Hydrozephalus",
      "Isolierte Dandy-Walker-Malformation",
      "Kongenitale Blockade des Foramen Magendii",
      "Kongenitale Blockade des Foramen Magendii mit Hydrozephalus",
      "Megacisterna magna"
    ]
  },
  {
    "code": "Q03.8",
    "name": "Kongenitale Obstruktion des Foramen interventriculare Monroi",
    "synonyms": [
      "Kongenitale Obstruktion des Foramen interventriculare Monroi",
      "Kongenitaler kommunizierender Hydrozephalus",
      "Kongenitaler obstruktiver Hydrozephalus"
    ]
  },
  {
    "code": "Q03.9",
    "name": "Angeborener Hydrozephalus",
    "synonyms": [
      "Angeborene Schädeldeformität mit Hydrozephalus",
      "Angeborener Hydrozephalus",
      "Angeborenes Fehlen von Schädelknochen mit Hydrozephalus",
      "Hydrocephalus congenitus",
      "Hydrozephalus beim Neugeborenen",
      "Kongenitale Gehirndegeneration bei Hydrozephalus",
      "Mangelhafter Schädelverschluss mit Hydrozephalus",
      "Schädelknochenanomalie mit Hydrozephalus",
      "Schädelknochenhypoplasie mit Hydrozephalus",
      "Schädelknochenverformung mit Hydrozephalus"
    ]
  },
  {
    "code": "Q04.0",
    "name": "Angeborene Fehlbildung des Corpus callosum",
    "synonyms": [
      "ACS [Akrokallosales Syndrom]",
      "Agenesie des Corpus callosum",
      "Aicardi-Syndrom",
      "Akrokallosales Syndrom",
      "Angeborene Fehlbildung des Corpus callosum",
      "Aplasie des Corpus callosum",
      "Balkenagenesie",
      "Balkenaplasie",
      "Balkenhypoplasie",
      "Corpus-callosum-Agenesie mit Makrozephalie und Hypertelorismus",
      "Corpus-callosum-Agenesie-Syndrom",
      "Fehlen des Corpus callosum",
      "Hypoplasie des Corpus callosum",
      "Isolierte Form der Corpus callosum-Agenesie"
    ]
  },
  {
    "code": "Q04.1",
    "name": "Arrhinenzephalie",
    "synonyms": [
      "Arhinenzephalie",
      "Arrhinenzephalie",
      "Arrhinenzephaliesyndrom",
      "Isolierte Arhinenzephalie"
    ]
  },
  {
    "code": "Q04.2",
    "name": "Holoprosenzephaliesyndrom",
    "synonyms": [
      "Alobäre Holoprosenzephalie",
      "HPE [Holoprosenzephalie]",
      "Holoprosenzephalie",
      "Holoprosenzephalie mit Kraniosynostose",
      "Holoprosenzephaliesyndrom",
      "Lobäre Holoprosenzephalie",
      "Mikroform der Holoprosenzephalie",
      "Mittlere interhemisphärische Variante der Holoprosenzephalie",
      "Morse-Rawnsley-Sargent-Syndrom",
      "Semilobäre Holoprosenzephalie",
      "Septopräoptische Holoprosenzephalie",
      "Syntelenzephalie"
    ]
  },
  {
    "code": "Q04.3",
    "name": "Hydranenzephalie",
    "synonyms": [
      "Agenesie des Vermis cerebelli",
      "Agenesie eines Gehirnteils",
      "Agyrie",
      "Angeborene Reduktionsdeformität des Gehirns",
      "Angeborener Hirnsubstanzdefekt",
      "Aplasie eines Gehirnteils",
      "Aprosenzephalie",
      "Aprosenzephalie mit zerebellarer Dysgenesie",
      "Atelenzephalie",
      "Autosomal-rezessive frontotemporale Pachygyrie",
      "Bilaterale Polymikrogyrie",
      "Bilaterale frontale Polymikrogyrie",
      "Bilaterale frontoparietale Polymikrogyrie",
      "Bilaterale generalisierte Polymikrogyrie",
      "Bilaterale parasagittale parietookzipitale Polymikrogyrie",
      "Bilaterale perisylvische Polymikrogyrie",
      "Einseitige Polymikrogyrie",
      "Einseitige fokale Polymikrogyrie",
      "Einseitige hemisphärische Polymikrogyrie",
      "Fehlen des Kleinhirns",
      "Fehlen des Wurms des Kleinhirns",
      "Fehlen des Zerebellums",
      "Fehlen eines Gehirnteils",
      "Garcia-Lurie-Syndrom",
      "HARD-Syndrom [Hydrozephalus mit Agyrie und Retinadysplasie]",
      "Hydranenzephalie",
      "Hydranzephalie",
      "Hydrozephalus-Agyrie-Retinadysplasie-Syndrom",
      "Hypoplasie der Gehirnwindungen",
      "Hypoplasie eines Gehirnteils",
      "Isolierte Agenesie des Kleinhirnwurmes",
      "Isolierte Lissenzephalie Typ 1 ohne bekannten genetischen Defekt",
      "Isolierte bilaterale Hypoplasie der Kleinhirnhemisphären",
      "Isolierte komplette Agenesie des Kleinhirnwurmes",
      "Isolierte komplette Agenesie des Vermis cerebelli",
      "Isolierte komplette Aplasie des Kleinhirnwurmes",
      "Isolierte partielle Agenesie des Kleinhirnwurmes",
      "Isolierte partielle Agenesie des Vermis cerebelli",
      "Isolierte unilaterale Hypoplasie einer Kleinhirnhemisphäre",
      "Isolierte zerebelläre Vermishypoplasie",
      "Joubert-Boltshauser-Syndrom",
      "Joubert-Syndrom",
      "Joubert-Syndrom Typ A",
      "Joubert-Syndrom mit Retinopathie",
      "Joubert-Syndrom mit asphyxierender Thoraxdystrophie Typ Jeune",
      "Joubert-Syndrom mit kongenitaler hepatischer Fibrose",
      "Joubert-Syndrom mit okulo-renalem Defekt",
      "Klassische Lissenzephalie",
      "Kleinhirnagenesie",
      "Kleinhirnagenesie mit Hydrozephalus",
      "Kleinhirnaplasie",
      "Kleinhirnhypoplasie",
      "Kongenitale Mikrogyrie",
      "Kraniotelenzephale Dysplasie",
      "Lissenzephalie",
      "Lissenzephalie Typ 1",
      "Lissenzephalie Typ 1 mit DCX [Doublecortin]-Genmutation",
      "Lissenzephalie Typ 2",
      "Lissenzephalie Typ 3",
      "Lissenzephalie Typ 3 mit metakarpaler Knochendysplasie",
      "Lissenzephalie Typ 9 mit komplexer Hirnstammfehlbildung",
      "Lissenzephalie durch LIS1-Genmutation",
      "Lissenzephalie durch TUBA1A-Genmutation",
      "Lissenzephalie mit zerebellärer Hypoplasie Typ A",
      "Lissenzephalie mit zerebellärer Hypoplasie Typ B",
      "Lissenzephalie mit zerebellärer Hypoplasie Typ C",
      "Lissenzephalie mit zerebellärer Hypoplasie Typ D",
      "Lissenzephalie mit zerebellärer Hypoplasie Typ E",
      "Lissenzephalie mit zerebellärer Hypoplasie Typ F",
      "Lissenzephalie-Syndrom Typ Norman-Roberts",
      "Mikro-Syndrom",
      "Mikrogyrie",
      "Mikrolissenzephalie",
      "Mikrolissenzephalie mit Mikromelie",
      "Okzipitale Pachygyrie und Polymikrogyrie",
      "Pachygyrie",
      "Pflasterstein-Lissenzephalie ohne muskuläre oder okuläre Beteiligung",
      "Polymikrogyrie durch TUBB2B-Genmutation",
      "Polymikrogyrie mit Sehnerv-Hypoplasie",
      "Pontozerebellare Hypoplasie Typ 1",
      "Pontozerebellare Hypoplasie Typ 10",
      "Pontozerebellare Hypoplasie Typ 11",
      "Pontozerebellare Hypoplasie Typ 12",
      "Pontozerebellare Hypoplasie Typ 13",
      "Pontozerebellare Hypoplasie Typ 14",
      "Pontozerebellare Hypoplasie Typ 2",
      "Pontozerebellare Hypoplasie Typ 3",
      "Pontozerebellare Hypoplasie Typ 4",
      "Pontozerebellare Hypoplasie Typ 6",
      "Pontozerebellare Hypoplasie Typ 7",
      "Pontozerebellare Hypoplasie Typ 8",
      "Pontozerebellare Hypoplasie Typ 9",
      "Rhombenzephalosynapsis",
      "Subkortikale Bandheterotopie",
      "Syndrom der Lissenzephalie Typ 3 mit familiärer fetaler Akinesie-Sequenz",
      "Syndrom der Pachygyrie mit Intelligenzminderung und Epilepsie",
      "Syndrom der letalen pontozerebellaren Hypoplasie mit Hypotonie und respiratorischer Insuffizienz",
      "Syndrom der letalen pontozerebellaren Hypoplasie mit Hypotonie und respiratorischer Insuffizienz durch Punktmutation",
      "Syndrom der letalen pontozerebellaren Hypoplasie mit Hypotonie und respiratorischer Insuffizienz durch biallelische Deletion im ATAD3-Gencluster",
      "Syndrom der partiellen Agenesie des Corpus callosum mit Hypoplasie des Vermis cerebelli und Zysten der hinteren Schädelgrube",
      "Tubulinopathie-assoziierte Dysgyrie",
      "Unilaterale Pol"
    ]
  },
  {
    "code": "Q04.4",
    "name": "Septooptische Dysplasie",
    "synonyms": [
      "De-Morsier-Syndrom",
      "Septooptische Dysplasie"
    ]
  },
  {
    "code": "Q04.5",
    "name": "Megalenzephalie",
    "synonyms": [
      "Hemimegalenzephalie",
      "Makrenzephalie",
      "Megalenzephalie"
    ]
  },
  {
    "code": "Q04.6",
    "name": "Angeborene Gehirnzyste",
    "synonyms": [
      "Angeborene Gehirnzyste",
      "Angeborene Zyste der Paraphysis cerebri",
      "Angeborene Zyste des dritten Hirnventrikels",
      "Angeborene arachnoidale Gehirnzyste",
      "Entwicklungsbedingte Porenzephalie",
      "Ependymale Zyste",
      "Familiäre Porenzephalie",
      "Kongenitale Gehirnzyste",
      "Kongenitale Porenzephalie",
      "Kongenitale zystische Gehirndegeneration",
      "Porenzephale Zyste",
      "Porenzephalie",
      "Schizenzephalie",
      "Schizozephalie"
    ]
  },
  {
    "code": "Q04.8",
    "name": "Makrogyrie",
    "synonyms": [
      "Angeborene Deformität der Gehirnmeningen",
      "Angeborene kaudale Hirnstammverlagerung",
      "Angeborene kaudale Kleinhirnverlagerung",
      "Angeborener Hirnrindendefekt",
      "Bilaterale zentrale Makrogyrie",
      "CRASH [Corpus-callosum-Agenesie, Intelligenzminderung, adduzierte Daumen, spastische Paraplegie, Hydrozephalus]-Syndrom",
      "Fehlbildung der Gehirnmeningen",
      "Gehirnektopie",
      "Gyriverformung",
      "Hypoplasie der weißen Gehirnsubstanz mit Agenesie des Corpus callosum und Intelligenzminderung",
      "Isolierte fokale kortikale Dysplasie",
      "Isolierte fokale kortikale Dysplasie Typ I",
      "Isolierte fokale kortikale Dysplasie Typ II",
      "Isolierte fokale kortikale Dysplasie Typ IIa",
      "Isolierte fokale kortikale Dysplasie Typ IIb",
      "Isolierte fokale kortikale Dysplasie Typ Ia",
      "Isolierte fokale kortikale Dysplasie Typ Ib",
      "Isolierte fokale kortikale Dysplasie Typ Ic",
      "Kongenitale Enzephalomalazie",
      "Kongenitale Hirnventrikeldilatation",
      "Kongenitale Lageanomalie des Gehirngewebes",
      "Kongenitale Makrogyrie",
      "Kongenitale ventrikuläre zerebrale Dilatation",
      "Kortikale Dysplasie mit pontozerebellarer Hypoplasie durch TUBB3-Genmutation",
      "MPPH [Megalenzephalie, Polymikrogyrie, postaxiale Polydaktylie, Hydrozephalus]-Syndrom",
      "Makrogyrie",
      "Mikrozephalie-Hirnfehlbildung-Spastik-Hypernatriämie-Syndrom",
      "NDE1-abhängige Mikrohydranenzephalie",
      "Noduläre neuronale Heterotopie",
      "Periventrikuläre noduläre Heterotopie",
      "Pontine Tegmentale Capdysplasie",
      "Subependymale noduläre Heterotopie",
      "Subkortikale noduläre Heterotopie",
      "Syndrom der Corpus-callosum-Agenesie mit Intelligenzminderung, adduzierten Daumen, spastischer Paraplegie und Hydrozephalus",
      "Syndrom der Megalenzephalie mit Polymikrogyrie, postaxialer Polydaktylie und Hydrozephalus",
      "Ulegyrie",
      "Zerebrale Ektopie",
      "Zerebrale Heterotopie",
      "Zerebrale Kalzifikation Typ Rajab",
      "Zerebrale kortikale Dysplasie",
      "Zerebro-zerebelläre Fehlbildung mit fokaler Epilepsie und Intelligenzminderung"
    ]
  },
  {
    "code": "Q04.9",
    "name": "Kongenitale Gehirnanomalie",
    "synonyms": [
      "Angeborene Duraanomalie",
      "Angeborene Fehlbildung des Gehirns",
      "Angeborene Gehirnanomalie",
      "Angeborene Gehirndegeneration beim Kind",
      "Angeborene Gehirnkrankheit",
      "Angeborene Gehirnschädigung",
      "Angeborene zerebrale Anomalie",
      "Anomalie der Dura mater encephali",
      "Fehlbildung der Dura mater",
      "Fehlbildung der Dura mater encephali",
      "Gehirndeformität",
      "Gehirndysplasie",
      "Gehirnfehlbildung",
      "Gehirnmissbildung",
      "Gehirnverformung",
      "Hirnmissbildung",
      "Kongenitale Gehirnanomalie",
      "Kongenitale Gehirnkrankheit",
      "Kongenitaler Gehirnschaden",
      "Multiple Gehirnanomalien",
      "Zerebrale Fehlbildung",
      "Zyklenzephalie"
    ]
  },
  {
    "code": "Q05.0",
    "name": "Zervikale Spina bifida mit Hydrozephalus",
    "synonyms": [
      "Hydrocephalus congenitus mit zervikaler Spina bifida",
      "Zervikale Spina bifida mit Hydrozephalus"
    ]
  },
  {
    "code": "Q05.1",
    "name": "Thorakale Spina bifida mit Hydrozephalus",
    "synonyms": [
      "Dorsale Spina bifida mit Hydrozephalus",
      "Hydrocephalus congenitus mit dorsaler Spina bifida",
      "Hydrocephalus congenitus mit thorakaler Spina bifida",
      "Hydrocephalus congenitus mit thorakolumbaler Spina bifida",
      "Thorakale Spina bifida mit Hydrozephalus",
      "Thorakolumbale Spina bifida mit Hydrozephalus"
    ]
  },
  {
    "code": "Q05.2",
    "name": "Lumbale Spina bifida mit Hydrozephalus",
    "synonyms": [
      "Hydrocephalus congenitus mit lumbaler Spina bifida",
      "Hydrocephalus congenitus mit lumbosakraler Spina bifida",
      "Lumbale Spina bifida mit Hydrozephalus",
      "Lumbosakrale Spina bifida mit Hydrozephalus"
    ]
  },
  {
    "code": "Q05.3",
    "name": "Sakrale Spina bifida mit Hydrozephalus",
    "synonyms": [
      "Hydrocephalus congenitus mit sakraler Spina bifida",
      "Sakrale Spina bifida mit Hydrozephalus"
    ]
  },
  {
    "code": "Q05.4",
    "name": "Spina bifida mit Hydrozephalus a.n.k.",
    "synonyms": [
      "Angeborene Schädeldeformität mit Hydrozephalus und mit Spina bifida",
      "Anomalie des Aquaeductus cerebri mit Spina bifida",
      "Anomalie des Sylvius-Aquäduktes mit Spina bifida",
      "Atresie der Apertura lateralis ventriculi quarti mit Spina bifida",
      "Atresie der Apertura mediana ventriculi quarti mit Spina bifida",
      "Atresie des Aquaeductus cerebri mit Spina bifida",
      "Atresie des Foramen Luschkae mit Spina bifida",
      "Atresie des Foramen Magendii mit Spina bifida",
      "Atresie des Sylvius-Aquäduktes mit Spina bifida",
      "Fehlen des Schädelknochens mit Hydrozephalus und mit Spina bifida",
      "Hydranenzephalie mit Spina bifida",
      "Hydranzephalie mit Spina bifida",
      "Hydrocele spinalis mit Hydrozephalus",
      "Hydrocephalus congenitus mit Spina bifida",
      "Hydromeningozele mit Hydrozephalus",
      "Hydromyelozele mit Hydrozephalus",
      "Hydrozephalus mit Spina bifida beim Neugeborenen",
      "Kongenitale Blockade des Foramen Magendii mit Spina bifida",
      "Kongenitale Obstruktion des Aquaeductus cerebri mit Spina bifida",
      "Kongenitaler Verschluss des Aquaeductus cerebri mit Spina bifida",
      "Kongenitaler mangelhafter Verschluss der Wirbelsäule mit Hydrozephalus",
      "Meningomyelozele mit Hydrozephalus",
      "Meningozele mit Hydrozephalus",
      "Myelomeningozele mit Hydrozephalus",
      "Myelozele mit Hydrozephalus",
      "Myelozystozele mit Hydrozephalus",
      "Obstruktion des Foramen interventriculare Monroi mit Spina bifida",
      "Rachischisis mit Hydrozephalus",
      "Rückenmarkhernie mit Hydrozephalus",
      "Schädelanomalie mit Hydrozephalus und mit Spina bifida",
      "Schädelknochenagenesie mit Hydrozephalus und mit Spina bifida",
      "Schädelknochenanomalie mit Hydrozephalus und mit Spina bifida",
      "Septum des Aquaeductus cerebri mit Spina bifida",
      "Septum des Sylvius-Aquäduktes mit Spina bifida",
      "Spina bifida mit Hydrozephalus a.n.k.",
      "Stenose des Aquaeductus cerebri mit Spina bifida",
      "Syringomyelozele mit Hydrozephalus",
      "Wirbelsäulenfissur mit Hydrozephalus"
    ]
  },
  {
    "code": "Q05.5",
    "name": "Zervikale Spina bifida ohne Hydrozephalus",
    "synonyms": [
      "Zervikale Myelozystozele",
      "Zervikale Spina bifida aperta",
      "Zervikale Spina bifida cystica",
      "Zervikale Spina bifida ohne Hydrozephalus"
    ]
  },
  {
    "code": "Q05.6",
    "name": "Thorakale Spina bifida ohne Hydrozephalus",
    "synonyms": [
      "Dorsale Spina bifida",
      "Thorakale Myelozystozele",
      "Thorakale Spina bifida ohne Hydrozephalus",
      "Thorakolumbale Spina bifida"
    ]
  },
  {
    "code": "Q05.7",
    "name": "Lumbale Spina bifida ohne Hydrozephalus",
    "synonyms": [
      "Leptomyelolipom",
      "Lumbale Spina bifida ohne Hydrozephalus",
      "Lumbosakrale Spina bifida",
      "Lumbosakrale Spina bifida aperta",
      "Lumbosakrale Spina bifida cystica",
      "Terminale Myelozystozele"
    ]
  },
  {
    "code": "Q05.8",
    "name": "Sakrale Spina bifida ohne Hydrozephalus",
    "synonyms": [
      "Sakrale Spina bifida ohne Hydrozephalus"
    ]
  },
  {
    "code": "Q05.9",
    "name": "Myelozystozele",
    "synonyms": [
      "Hydrocele spinalis",
      "Hydromeningozele",
      "Hydromyelozele",
      "Kongenitale Wirbelsäulenfissur",
      "Lipomyelomeningozele",
      "Mangelhafter Wirbelsäulenverschluss",
      "Meningomyelozele",
      "Meningozele",
      "Meningozystozele",
      "Myelomeningozele",
      "Myelomeningozele des Rückenmarks",
      "Myeloschisis",
      "Myelozele",
      "Myelozystozele",
      "Neuralrohrdefekt",
      "Posteriore Meningozele",
      "Rachischisis",
      "Rhachischisis",
      "Rückenmarkhernie",
      "Spina bifida",
      "Spina bifida aperta",
      "Spina bifida cystica",
      "Spinale Hydromeningozele",
      "Spinale Meningozele",
      "Syringomyelozele"
    ]
  },
  {
    "code": "Q06.0",
    "name": "Amyelie",
    "synonyms": [
      "Amyelie",
      "Isolierte Amyelie",
      "Rückenmarkagenesie",
      "Rückenmarkaplasie"
    ]
  },
  {
    "code": "Q06.1",
    "name": "Atelomyelie",
    "synonyms": [
      "Angeborene Rückenmarkmyelodysplasie",
      "Aplasie der Vorderhörner des Rückenmarks",
      "Atelomyelie",
      "Hypoplasie der Vorderhornzellen des Rückenmarks",
      "Myelatelie",
      "Myeloradikulodysplasie",
      "Myeloradikulodysplasie des Rückenmarks",
      "Rückenmarkdysplasie",
      "Rückenmarkhypoplasie",
      "Rückenmarkmyelodysplasie"
    ]
  },
  {
    "code": "Q06.2",
    "name": "Diastematomyelie",
    "synonyms": [
      "Diastematomyelie",
      "Split-Cord-Malformation, gemischter Typ",
      "Split-cord-Malformation",
      "Split-cord-Malformation Typ 1",
      "Split-cord-Malformation Typ 2"
    ]
  },
  {
    "code": "Q06.3",
    "name": "Anomalie der Cauda equina",
    "synonyms": [
      "Anomalie der Cauda equina",
      "Entwicklungsbedingter Defekt der Cauda equina",
      "Hemmungsfehlbildung der Cauda equina",
      "Kongenitale fehlerhafte Entwicklung der Cauda equina"
    ]
  },
  {
    "code": "Q06.4",
    "name": "Hydromyelie",
    "synonyms": [
      "Hydromyelie",
      "Hydrorrhachis",
      "Primäre Syringomyelie"
    ]
  },
  {
    "code": "Q06.8",
    "name": "Adhäsionssyndrom des unteren Rückenmarks [Tethered-cord-Syndrom]",
    "synonyms": [
      "Adhäsionssyndrom des unteren Rückenmarks [Tethered-cord-Syndrom]",
      "Angeborene neurenterische Zyste",
      "Dilatatio Cavum septi pellucidi",
      "Diplomyelie",
      "Kongenitale Adhäsion spinaler Meningen",
      "Kongenitale Lageanomalie des Rückenmarks",
      "Kongenitale Mikromyelie",
      "Mikromyelie",
      "Rückenmarkverformung",
      "Spinale Heterotopie",
      "Tethered-cord-Syndrom [Adhäsionssyndrom des unteren Rückenmarks]",
      "Unvollständiges akzessorisches Rückenmark",
      "Unvollständiges doppeltes Rückenmark",
      "Verdoppelung des Rückenmarks"
    ]
  },
  {
    "code": "Q06.9",
    "name": "Rückenmarkanomalie",
    "synonyms": [
      "Angeborene Deformität der Rückenmarkhäute",
      "Angeborene Deformität der Rückenmarkmeningen",
      "Angeborene Krankheit der Rückenmarkhäute",
      "Angeborene Rückenmarkdeformität",
      "Angeborene Rückenmarkkrankheit",
      "Angeborene Rückenmarkschädigung",
      "Angeborene Schädigung der Rückenmarkhäute",
      "Anomalie der Dura mater spinalis",
      "Anomalie der Rückenmarkhäute",
      "Fehlbildung der Dura mater spinalis",
      "Fehlbildung der Rückenmarkmeningen",
      "Kongenitale Rückenmarkkrankheit",
      "Kongenitale Rückenmarkschädigung",
      "Rückenmarkanomalie",
      "Rückenmarkdeformität",
      "Rückenmarkfehlbildung"
    ]
  },
  {
    "code": "Q07.0",
    "name": "Arnold-Chiari-Missbildung",
    "synonyms": [
      "Arnold-Chiari-Fehlbildung Typ I",
      "Arnold-Chiari-Fehlbildung Typ II",
      "Arnold-Chiari-Krankheit",
      "Arnold-Chiari-Missbildung",
      "Arnold-Chiari-Obstruktion",
      "Arnold-Chiari-Syndrom",
      "Chiari-Malformation Typ 1",
      "Chiari-Malformation Typ 2"
    ]
  },
  {
    "code": "Q07.8",
    "name": "Nervenagenesie",
    "synonyms": [
      "Akzessorische Teile des Nervensystems a.n.k.",
      "Alternierende Hemiplegie der Kindheit",
      "Angeborene Fehlbildung des Plexus chorioideus",
      "Angeborene Spinalnervenwurzeldeformität",
      "Angeborene Verlagerung des Plexus brachialis",
      "Angeborene anomale Konstriktion eines Meningenbandes",
      "Anomalie des Hirnnerven VIII",
      "Anomalie des Nervus acusticus",
      "Anomalie des Nervus opticus",
      "Anomalie des Plexus chorioideus",
      "Aplasie des Nervus cochlearis",
      "Deformität des Plexus chorioideus",
      "Gunn-Syndrom",
      "Hypoplasie des Nervus cochlearis",
      "Isolierte Aplasie des Nervus opticus",
      "Isolierte Hypoplasie des Nervus opticus",
      "Isolierte Sehnervaplasie",
      "Isolierte Sehnervhypoplasie",
      "Isolierte hereditäre kongenitale Fazialisparese",
      "Isolierte kongenitale Anosmie",
      "Kiefer-Lid-Phänomen",
      "Kiefer-Lid-Syndrom",
      "Kongenitale Lageanomalie des Nervensystems a.n.k.",
      "Kongenitale Lageanomalie des Plexus brachialis",
      "Kongenitale Lageanomalie eines Nerven",
      "Kongenitale Meningenadhäsion",
      "Kongenitale Verlagerung des Plexus brachialis",
      "Marcus-Gunn-Phänomen",
      "Marcus-Gunn-Syndrom",
      "Nervenagenesie",
      "Nervenaplasie",
      "Nervenkernagenesie",
      "Nervenkernaplasie",
      "Nervenverformung",
      "Sehnervanomalie",
      "Sinnesorgananomalie a.n.k.",
      "Spinalnervenwurzelanomalie",
      "Spinalnervenwurzelfehlbildung",
      "Teilagenesie des Nervensystems a.n.k.",
      "Teilaplasie des Nervensystems a.n.k."
    ]
  },
  {
    "code": "Q07.9",
    "name": "Nervensystemanomalie",
    "synonyms": [
      "Angeborene Deformität der Meningen",
      "Angeborene Fehlbildung der Meningen",
      "Angeborene Nervenanomalie",
      "Angeborene Nervensystemkrankheit",
      "Angeborene Nervensystemschädigung",
      "Anomalie der Meningen",
      "Anomalie des Zentralnervensystems a.n.k.",
      "Anomalie einer Meningenfalte",
      "Anomalie eines Meningenbandes",
      "Dysplasie des Nervensystems a.n.k.",
      "Dysrhaphie",
      "Dysrhaphiesyndrom",
      "Fehlbildung des Zentralnervensystems",
      "Hypoplasie des Nervensystems a.n.k.",
      "Kongenitale Nervensystemschädigung",
      "Nervensystemanomalie",
      "Nervensystemdeformität"
    ]
  },
  {
    "code": "Q10.0",
    "name": "Angeborene Ptose",
    "synonyms": [
      "Angeborene Ptose",
      "Angeborene isolierte Blepharochalasis",
      "Kongenitale Augenlidptose",
      "Kongenitale Blepharochalasis",
      "Kongenitale Blepharoptosis",
      "Kongenitale Ptosis"
    ]
  },
  {
    "code": "Q10.1",
    "name": "Angeborenes Ektropium",
    "synonyms": [
      "Angeborenes Ektropium",
      "Isoliertes kongenitales Ektropion",
      "Kongenitales Ektropion uveae",
      "Kongenitales Ektropium"
    ]
  },
  {
    "code": "Q10.2",
    "name": "Angeborenes Entropium",
    "synonyms": [
      "Angeborenes Entropium",
      "Angeborenes Tarsusknickung-Syndrom",
      "Kongenitale Einwärtskehrung des Lids",
      "Kongenitales Entropium",
      "Tarsal-kink-Syndrom"
    ]
  },
  {
    "code": "Q10.3",
    "name": "Kongenitale Lidanomalie",
    "synonyms": [
      "Ablepharie",
      "Ablepharon",
      "Akzessorischer Augenmuskel",
      "Akzessorisches Augenlid",
      "Angeborene Atrophie der Fascia tarsoorbitalis",
      "Angeborene Augenlidanomalie",
      "Angeborene Augenlidfehlbildung",
      "Angeborene Augenmuskeldeformität",
      "Angeborene Blepharophimose",
      "Angeborene Kanthusdeformität",
      "Angeborene Liddeformität",
      "Angeborene Lidfaltendeformität",
      "Angeborene Lidfehlbildung",
      "Angeborene Vermehrung der Augenlidhaut",
      "Angeborene Wimperndeformität",
      "Angeborener mangelhafter Augenlidverschluss",
      "Angeborenes Ankyloblepharon filiforme",
      "Angeborenes Fehlen der Augenlidfalte",
      "Angeborenes Fehlen der Wimpern",
      "Ankyloblepharon filiforme adnatum",
      "Augenlidagenesie",
      "Augenlidhypoplasie",
      "Augenlidkolobom",
      "Augenwimpernagenesie",
      "BPES [Blepharophimose-Ptosis-Epikanthus inversus-Syndrom]",
      "BPES [Blepharophimose-Ptosis-Epikanthus inversus-Syndrom] Typ 1",
      "BPES [Blepharophimose-Ptosis-Epikanthus inversus-Syndrom] Typ 2",
      "Blepharophimose Typ 1",
      "Blepharophimose Typ 2",
      "Blepharophimose-Ptosis-Epicanthus inversus-Syndrom Typ 2",
      "Blepharophimose-Ptosis-Epikanthus inversus-Syndrom",
      "Blepharophimose-Ptosis-Epikanthus inversus-Syndrom Typ 1",
      "Blepharophimose-Syndrom",
      "Distichiasis",
      "Epiblepharon",
      "Epikanthus",
      "Euryblepharon",
      "Fehlen der Augenwimpern",
      "Fehlen des Augenlids",
      "Fehlen eines Augenmuskels",
      "Isolierte Distichiasis",
      "Isoliertes Ankyloblepharon filiforme adnatum",
      "Kanthusanomalie",
      "Kolobom des Oberlides",
      "Kolobom des Unterlides",
      "Kongenitale Augenlidhypotrichose",
      "Kongenitale Augenlidretraktion",
      "Kongenitale Blepharophimose",
      "Kongenitale Blepharosynechie",
      "Kongenitale Insuffizienz der tarsoorbitalen Faszie",
      "Kongenitale Lidanomalie",
      "Kongenitale Lidverklebung",
      "Kongenitaler Epikanthus",
      "Kongenitales Ankyloblepharon",
      "Kongenitales Epiblepharon",
      "Kongenitales Fehlen der Zilien",
      "Kongenitales Lidkolobom",
      "Kongenitales Symblepharon",
      "Lidfaltenagenesie",
      "Lidkolobom",
      "Lopes-Gorlin-Syndrom",
      "Wimpernagenesie",
      "Wimpernanomalie",
      "Zilienagenesie"
    ]
  },
  {
    "code": "Q10.4",
    "name": "Agenesie der Tränendrüse",
    "synonyms": [
      "Agenesie der Tränendrüse",
      "Agenesie der Tränenpünktchen",
      "Agenesie des Canaliculus lacrimalis",
      "Agenesie des Punctum lacrimale",
      "Agenesie des Tränenapparates",
      "Angeborenes Fehlen des Canaliculus lacrimalis",
      "Angeborenes Fehlen des Punctum lacrimale",
      "Fehlen des Punctum lacrimale",
      "Fehlen des Tränenkanals",
      "Kongenital verlegte Tränenpünktchen"
    ]
  },
  {
    "code": "Q10.5",
    "name": "Angeborene Tränenkanalstriktur",
    "synonyms": [
      "Angeborene Nasolakrimalstenose",
      "Angeborene Stenose des Punctum lacrimale",
      "Angeborene Tränenkanalstenose",
      "Angeborene Tränenkanalstriktur",
      "Angeborene Tränensackstenose",
      "Atresie des Tränenapparates",
      "Familiäre kongenitale Obstruktion des Ductus nasolacrimalis",
      "Kongenitale Dakryostenose",
      "Kongenitale Obstruktion des Ductus nasolacrimalis",
      "Kongenitale Stenose des Canaliculus lacrimalis",
      "Kongenitale Striktur des Ductus lacrimalis",
      "Kongenitale Striktur des Ductus nasolacrimalis",
      "Kongenitale Striktur des Punctum lacrimale",
      "Kongenitale Tränengangsstenose",
      "Kongenitale Tränennasengangsstenose",
      "Kongenitale Tränenwegobstruktion",
      "Kongenitale Tränenwegstenose",
      "Kongenitale Tränenwegstriktur",
      "Kongenitaler Verschluss des Ductus nasolacrimalis"
    ]
  },
  {
    "code": "Q10.6",
    "name": "Kongenitale Tränenapparatfehlbildung",
    "synonyms": [
      "Akzessorische Tränenorgane",
      "Angeborene Deformität der Canaliculi lacrimales",
      "Angeborene Deformität der Caruncula lacrimalis",
      "Angeborene Deformität der Tränenwege a.n.k.",
      "Angeborene Deformität des Tränenganges a.n.k.",
      "Angeborene Tränenapparatfehlbildung",
      "Angeborene Verlagerung des Canaliculus lacrimalis",
      "Angeborene Verlagerung des Ductus nasolacrimalis",
      "Angeborene Verlagerung des Punctum lacrimale",
      "Anomalie der Caruncula lacrimalis",
      "Isolierte kongenitale Alakrimie",
      "Kongenitale Tränenapparatfehlbildung",
      "Kongenitale Tränenapparatverlagerung",
      "Kongenitaler Tränenflüssigkeitsmangel",
      "Tränenkanalanomalie",
      "Tränenorgananomalie"
    ]
  },
  {
    "code": "Q10.7",
    "name": "Angeborene Orbitafehlbildung",
    "synonyms": [
      "Angeborene Augenhöhlendeformität",
      "Angeborene Orbitadeformität",
      "Angeborene Orbitafehlbildung",
      "Augenhöhlenanomalie",
      "Orbitaanomalie"
    ]
  },
  {
    "code": "Q11.0",
    "name": "Zystenauge",
    "synonyms": [
      "Cystic eyeball",
      "Zystenauge"
    ]
  },
  {
    "code": "Q11.1",
    "name": "Anophthalmus",
    "synonyms": [
      "Angeborenes Fehlen eines Augapfels",
      "Angeborenes Fehlen eines Auges",
      "Anophthalmie",
      "Anophthalmus",
      "Augenagenesie",
      "Augenaplasie",
      "Kongenitale Anophthalmie",
      "Kongenitaler Anophthalmus"
    ]
  },
  {
    "code": "Q11.2",
    "name": "Kryptophthalmus",
    "synonyms": [
      "Angeborene Dysplasie des Auges",
      "Augendysplasie",
      "Augenhypoplasie",
      "Bakrania-Ragge-Syndrom",
      "Isolierte Kryptophthalmie",
      "Kongenitaler Mikrophthalmus",
      "Kryptophthalmus",
      "MIDAS [Mikrophthalmie, dermale Aplasie, Sklerokornea]-Syndrom",
      "Matthew-Wood-Syndrom",
      "Mikrophtalmie mit Kolobom-Zysten",
      "Mikrophthalmie",
      "Mikrophthalmie Typ Lenz",
      "Mikrophthalmie mit Ankyloblepharon und Intelligenzminderung",
      "Mikrophthalmie mit Hirnatrophie",
      "Mikrophthalmus",
      "Nanophthalmus",
      "Rudimentäres Auge",
      "Syndromale Mikrophthalmie Typ 5"
    ]
  },
  {
    "code": "Q11.3",
    "name": "Makrophthalmus",
    "synonyms": [
      "Makrophthalmus",
      "Megalophthalmus"
    ]
  },
  {
    "code": "Q12.0",
    "name": "Angeborene Katarakt",
    "synonyms": [
      "Angeborene Katarakt",
      "Angeborener grauer Star",
      "Cataracta caerulea",
      "Cataracta centralis",
      "Cataracta congenita",
      "Cataracta congenita membranacea",
      "Cataracta congenita polaris anterior",
      "Cataracta congenita polaris posterior",
      "Cataracta congenita totalis",
      "Cataracta coralliformis",
      "Cataracta coronaria",
      "Cataracta perinuclearis",
      "Cataracta polaris anterior",
      "Cataracta polaris posterior",
      "Cataracta pulverulenta",
      "Cataracta punctata",
      "Cataracta pyramidalis",
      "Cataracta zonularis",
      "Embryonale Cataracta nuclearis",
      "Embryonalkatarakt",
      "Kongenitale Augenlinsentrübung",
      "Kongenitale Cataracta coerulea",
      "Kongenitale Cataracta pulverulenta",
      "Koralliforme Katarakt",
      "Kristalline Katarakt",
      "Pyramidenstar"
    ]
  },
  {
    "code": "Q12.1",
    "name": "Kongenitaler Linsenvorfall",
    "synonyms": [
      "Angeborene Linsenverlagerung",
      "Ectopia lentis congenita",
      "Familiäre Ectopia lentis",
      "Kongenitale Lageanomalie der Linse",
      "Kongenitale Linsendislokation",
      "Kongenitale Linsenluxation",
      "Kongenitaler Linsenvorfall",
      "Linsenektopie"
    ]
  },
  {
    "code": "Q12.2",
    "name": "Linsenkolobom",
    "synonyms": [
      "Linsenkolobom",
      "Persistierende Tunica vasculosa lentis"
    ]
  },
  {
    "code": "Q12.3",
    "name": "Kongenitale Aphakie",
    "synonyms": [
      "Angeborene Aphakie",
      "Angeborenes Fehlen der Linse",
      "Kongenitale Aphakie",
      "Linsenagenesie",
      "Primäre kongenitale Aphakie"
    ]
  },
  {
    "code": "Q12.4",
    "name": "Sphärophakie",
    "synonyms": [
      "Erhöhte Sphärizität der Linse",
      "Isolierte Mikrosphärophakie",
      "Sphärophakie"
    ]
  },
  {
    "code": "Q12.8",
    "name": "Lentiglobus",
    "synonyms": [
      "Angeborener Lentiglobus",
      "Hypoplasie der Zonula ciliaris",
      "Kongenitale Linsenzyste",
      "Kongenitale Mikrophakie",
      "Kongenitaler Lentikonus",
      "Lenticonus anterior",
      "Lenticonus posterior",
      "Lentiglobus",
      "Lentiglobus posterior",
      "Lentikonus",
      "Linsenverformung",
      "Mikrophakie"
    ]
  },
  {
    "code": "Q12.9",
    "name": "Kongenitale Linsenfehlbildung",
    "synonyms": [
      "Angeborene Augenlinsenanomalie",
      "Angeborene Linsenanomalie",
      "Angeborene Linsendeformität",
      "Kongenitale Linsenfehlbildung"
    ]
  },
  {
    "code": "Q13.0",
    "name": "Kolobom",
    "synonyms": [
      "Angeborener mangelhafter Irisverschluss",
      "Angeborenes Iriskolobom",
      "Coloboma - s.a. Kolobom",
      "Iriskolobom",
      "Kolobom",
      "Uvea-Kolobom-Syndrom"
    ]
  },
  {
    "code": "Q13.1",
    "name": "Angeborenes Fehlen der Iris",
    "synonyms": [
      "Angeborenes Fehlen der Iris",
      "Aniridie",
      "Aniridie-Syndrom",
      "Irideremie",
      "Irisagenesie",
      "Irisaplasie",
      "Isolierte Aniridie",
      "Kongenitale Aniridie",
      "Kongenitaler Irisverlust",
      "Walker-Dyson-Syndrom"
    ]
  },
  {
    "code": "Q13.2",
    "name": "Pupillenektopie",
    "synonyms": [
      "Agenesie der Dilatator-Fasern der Iris",
      "Angeborene Anisokorie",
      "Angeborene Deformität optikoziliarer Gefäße",
      "Angeborene Irisanomalie",
      "Angeborene Irisdeformität",
      "Angeborene Irisfehlbildung",
      "Angeborene Mikrokorie",
      "Angeborene Miosis",
      "Angeborene Pupillenanomalie",
      "Angeborene Pupillendeformität",
      "Anomalie optikoziliarer Gefäße",
      "Ectopia pupillae",
      "Heterochromie",
      "Irishypoplasie",
      "Kongenitale Anisokorie",
      "Kongenitale Heterochromie",
      "Kongenitale Pupillendifferenz",
      "Kongenitale Pupillenektopie",
      "Korektopie",
      "Polykorie",
      "Pupillenatresie",
      "Pupillenektopie"
    ]
  },
  {
    "code": "Q13.3",
    "name": "Kongenitales Hornhautstaphylom",
    "synonyms": [
      "Angeborene Hornhauttrübung",
      "Isolierte kongenitale Sklerokornea",
      "Kongenitale Hornhauttrübung",
      "Kongenitale Undurchsichtigkeit der Kornea",
      "Kongenitales Hornhautstaphylom"
    ]
  },
  {
    "code": "Q13.4",
    "name": "Applanatio corneae",
    "synonyms": [
      "Angeborene Hornhautfehlbildung",
      "Angeborene Korneadeformität",
      "Angeborene Korneafehlbildung",
      "Applanatio corneae",
      "Arcus lipoides juvenilis",
      "Cornea plana",
      "Embryotoxon",
      "Embryotoxon posterius",
      "Formanomalie der Kornea",
      "Keratomegalie",
      "Kongenitale Cornea plana",
      "Kongenitale Keratektasie",
      "Kongenitale Melanose der Kornea",
      "Kongenitale Mikrokornea",
      "Kongenitale hereditäre endotheliale Dystrophie",
      "Kongenitaler Keratokonus",
      "Mikrokornea",
      "Peters-Anomalie",
      "Peters-Anomalie mit Kleinwuchs",
      "Peters-plus-Syndrom",
      "Pränatale Melanose der Kornea",
      "Verkalkende Axenfeld-Degeneration"
    ]
  },
  {
    "code": "Q13.5",
    "name": "Blaue Sklera",
    "synonyms": [
      "Blaue Sklera"
    ]
  },
  {
    "code": "Q13.8",
    "name": "Rieger-Syndrom",
    "synonyms": [
      "Angeborene Katarakt mit Mikrokornea und Hornhauttrübung",
      "Autosomal-rezessive Dysgenesie des vorderen Augensegmentes",
      "Axenfeld-Anomalie",
      "Axenfeld-Rieger-Syndrom",
      "EDICT [Endotheldystrophie, Irishypoplasie, kongenitale Katarakt, Ausdünnung des Hornhautstromas]-Syndrom",
      "Katarakt-Mikrokornea-Syndrom",
      "Kongenitale Melanose der Konjunktiva",
      "Kongenitale Melanose der Sklera",
      "Kongenitaler Defekt der Descemet-Membran",
      "Membran der hinteren Linsenkapsel",
      "Mesostromale Dysgenesie",
      "Persistierende Pupillenmembran",
      "Rieger-Anomalie",
      "Rieger-Axenfeld-Anomalie",
      "Rieger-Syndrom",
      "Syndrom der angeborenen Aphakie mit Irishypoplasie, Mikrophthalmie und Mikrokornea"
    ]
  },
  {
    "code": "Q13.9",
    "name": "Kongenitale Fehlbildung des vorderen Augenabschnittes",
    "synonyms": [
      "Anomalie des vorderen Augenabschnittes",
      "Kongenitale Fehlbildung des vorderen Augenabschnittes"
    ]
  },
  {
    "code": "Q14.0",
    "name": "Bergmeister-Papille",
    "synonyms": [
      "Angeborene Deformität des Corpus vitreum",
      "Angeborene Glaskörperdeformität",
      "Angeborene Glaskörpertrübung",
      "Anomalie des Corpus vitreum",
      "Anomalie des Humor vitreus",
      "Bergmeister-Papille",
      "Glaskörperanomalie",
      "Kongenitale Glaskörperfehlbildung",
      "Kongenitale Glaskörperundurchsichtigkeit",
      "Mittendorf-Flecken",
      "Persistierende Arteria hyaloidea",
      "Persistierender Cloquet-Kanal",
      "Persistierender hyperplastischer primärer Glaskörper",
      "Persistierender hyperplastischer primärer Vitreus",
      "Überrest des Cloquet-Kanals"
    ]
  },
  {
    "code": "Q14.1",
    "name": "X-chromosomale Retinoschisis",
    "synonyms": [
      "Ablatio retinae exsudativa bei kongenitaler Fehlbildung",
      "Angeborene Blindheit durch Nicht-Anheftung der Netzhaut",
      "Angeborene Deformität der Netzhautarterie",
      "Angeborene Deformität der Retinaarterie",
      "Angeborene Dysplasie der Retina",
      "Angeborene Retinoschisis",
      "Angeborene Tortuositas eines Netzhautgefäßes",
      "Angeborene Tortuositas eines Retinagefäßes",
      "Angeborene gruppierte Pigmentierung der Retina",
      "Angeborene nävusähnliche Pigmentierung der Retina",
      "Angeborenes Retinaaneurysma",
      "Anomalie der Fovea centralis retinae",
      "Anomalie der Netzhautarterie",
      "Anomalie der Retinaarterie",
      "Aplasie der Fovea centralis retinae",
      "Heredoretinopathie",
      "Hypoplasie einer Retinaarterie",
      "Isolierte Foveahypoplasie",
      "Kongenitale Makulaverlagerung",
      "Kongenitale Netzhautablösung",
      "Kongenitale Netzhautdysplasie",
      "Kongenitale Retinafehlbildung",
      "Kongenitale Retinoschisis",
      "Kongenitale Striktur einer Retinaarterie",
      "Kongenitales Netzhautaneurysma",
      "Mangelhafter Retinaverschluss",
      "Tortuositas der retinalen Arterien",
      "X-chromosomale Netzhautdysplasie",
      "X-chromosomale Retinadysplasie",
      "X-chromosomale Retinoschisis",
      "X-chromosomale juvenile Retinoschisis"
    ]
  },
  {
    "code": "Q14.2",
    "name": "Tilted disc [Schräger Sehnerveneintritt]",
    "synonyms": [
      "Angeborene Anomalie der Sehnervenpapille",
      "Angeborene Deformität eines Gefäßes der Sehnervenpapille",
      "Angeborene Pseudoneuritis optica",
      "Angeborenes Pseudopapillenödem",
      "Grubenpapille",
      "Inversion der Sehnervenpapille",
      "Isolierte Megalopapille",
      "Kaverne der Sehnervenpapille",
      "Kolobom der Papilla nervi optici",
      "Kongenitale Drusenpapille",
      "Kongenitale Grubenpapille",
      "Kongenitale Papillenfehlbildung",
      "Kongenitale Pigmentierung der Sehnervenpapille",
      "Mangelhafter Verschluss der Sehnerveintrittstelle",
      "Mikropapille",
      "Morning-Glory-Syndrom",
      "Papillenhypoplasie",
      "Papillenkolobom",
      "Tilted disc [Schräger Sehnerveneintritt]"
    ]
  },
  {
    "code": "Q14.3",
    "name": "Kongenitale Chorioideafehlbildung",
    "synonyms": [
      "Aderhautkolobom",
      "Angeborene Chorioideadeformität",
      "Angeborene Pigmentationsstörung der Chorioidea",
      "Angeborene Pigmentierung der Chorioidea",
      "Angeborenes Fuchs-Kolobom",
      "Chorioideaanomalie",
      "Kongenitale Chorioideafehlbildung",
      "Mangelhafter Verschluss der Chorioidea"
    ]
  },
  {
    "code": "Q14.8",
    "name": "Kongenitale Fehlbildung des hinteren Augenabschnittes",
    "synonyms": [
      "Angeborene Anastomose zwischen Netzhautgefäß und Aderhautgefäß",
      "Angeborene Anastomose zwischen Retinagefäß und Chorioideagefäß",
      "Conus",
      "Kolobom der Chorioidea und Retina",
      "Kolobom des Augenhintergrundes",
      "Kolobom des Fundus oculi",
      "Kongenitale Fehlbildung des hinteren Augenabschnittes",
      "Kongenitale retinale arteriovenöse Kommunikation",
      "Kongenitaler Konus",
      "Konus",
      "Makulakolobom",
      "Persistenz einer zilioretinalen Arterie",
      "Persistenz einer zilioretinalen Vene",
      "Syndrom der kolobomatösen Papille mit Makulaatrophie und Chorioretinopathie",
      "Undurchsichtiger Kapselüberrest"
    ]
  },
  {
    "code": "Q14.9",
    "name": "Anomalie des hinteren Augenabschnitts",
    "synonyms": [
      "Anomalie des hinteren Augenabschnitts"
    ]
  },
  {
    "code": "Q15.0",
    "name": "Angeborenes Glaukom",
    "synonyms": [
      "Angeborener Buphthalmus",
      "Angeborener Keratoglobus mit Glaukom",
      "Angeborenes Glaukom",
      "Buphthalmie",
      "Buphthalmus",
      "Glaukom beim Neugeborenen",
      "Hydrophthalmus",
      "Infantiles Glaukom",
      "Infantiles primäres Glaukom",
      "Irisatresie",
      "Juveniles Glaukom",
      "Kammerwinkelatresie",
      "Kongenitales Glaukom",
      "Kongenitales primäres Glaukom",
      "Makrokornea mit Glaukom",
      "Makrophthalmus bei angeborenem Glaukom",
      "Megalokornea mit Glaukom"
    ]
  },
  {
    "code": "Q15.8",
    "name": "Kongenitale Bindehautadhäsion",
    "synonyms": [
      "Agenesie der Augenanhangsgebilde",
      "Angeborene Augapfeldeformität",
      "Angeborene Augenzyste",
      "Atypisches Norrie-Syndrom durch Mikrodeletion Xp11.3",
      "Augenarterienanomalie",
      "Augenarterienatresie a.n.k.",
      "Augenmuskelagenesie",
      "Augenmuskelhypoplasie",
      "Blepharoptose mit Myopie und Linsenektopie",
      "Familiäre progressive Netzhautdystrophie mit Iriskolobom und angeborener Katarakt",
      "Isolierte kongenitale Megalokornea",
      "Kongenitale Augapfelverlagerung",
      "Kongenitale Augenmelanose",
      "Kongenitale Augenzyste",
      "Kongenitale Bindehautadhäsion",
      "Kongenitale Bindehautfehlbildung",
      "Kongenitale Konjunktivaadhäsion",
      "Kongenitale Konjunktivafehlbildung",
      "Kongenitale Lageanomalie des Auges",
      "Kongenitale Ophthalmozele",
      "Kongenitale Veränderung der Lage des Augapfels",
      "Kongenitaler Exophthalmus",
      "Kongenitaler Keratoglobus",
      "MACOM [Mikrokornea, kolobomatöse Mikrophthalmie]-Syndrom",
      "MMCAT [Mikrokornea, myopische chorioretinale Atrophie, Telekanthus]-Syndrom",
      "MRCS [Microcornea, rod-cone dystrophy, cataract, posterior staphyloma]-Syndrom",
      "Makrokornea",
      "Megalokornea",
      "Megalokornea mit Sphärophakie und sekundärem Glaukom",
      "Norrie-Syndrom",
      "Ophthalmozele",
      "Syndrom der Ectopia lentis mit chorioretinaler Dystrophie und Myopie",
      "Syndrom der Foveahypoplasie mit Anomalie des Chiasma opticum und Dysgenesie des vorderen Augensegmentes",
      "Syndrom der Mikrokornea mit Lenticonus posterior, persistierendem hyperplastischem primärem Vitreus und Kolobom",
      "Syndrom der Mikrophthalmie mit Retinitis pigmentosa, Foveoschisis und Drusenpapille",
      "Syndrom der Ptosis mit Strabismus und Pupillenektopie",
      "Verformung des Auges"
    ]
  },
  {
    "code": "Q15.9",
    "name": "Kongenitale Augenfehlbildung",
    "synonyms": [
      "Angeborene Augendeformität",
      "Augenanomalie",
      "Augenfehlbildung",
      "Kongenitale Augenfehlbildung"
    ]
  },
  {
    "code": "Q16.0",
    "name": "Angeborenes Fehlen der Ohrmuschel",
    "synonyms": [
      "Angeborenes Fehlen der Ohrmuschel",
      "Ohrmuschelagenesie"
    ]
  },
  {
    "code": "Q16.1",
    "name": "Kongenitale Gehörgangsstenose",
    "synonyms": [
      "Angeborene Gehörgangsanomalie",
      "Angeborene Striktur des knöchernen Gehörganges",
      "Angeborenes Fehlen des äußeren Gehörganges",
      "Atresie des Meatus acusticus",
      "Atresie des knöchernen Gehörganges",
      "Gehörgangsagenesie",
      "Gehörgangsatresie",
      "Gehörgangsfusion",
      "Kongenitale Gehörgangsstenose",
      "Kongenitale Striktur des äußeren Gehörganges",
      "Striktur des Meatus acusticus",
      "Striktur des Meatus osseus"
    ]
  },
  {
    "code": "Q16.2",
    "name": "Angeborenes Fehlen der Tuba auditiva",
    "synonyms": [
      "Agenesie der Eustachi-Röhre",
      "Angeborenes Fehlen der Tuba auditiva",
      "Ohrtrompetenagenesie"
    ]
  },
  {
    "code": "Q16.3",
    "name": "Angeborene Fehlbildung der Gehörknöchelchen",
    "synonyms": [
      "Akzessorisches Gehörknöchelchen",
      "Ambossagenesie",
      "Angeborene Fehlbildung der Gehörknöchelchen",
      "Angeborene Ohrknöchelchenanomalie",
      "Angeborene Verformung der Ohrknöchelchen",
      "Angeborene Verschmelzung der Gehörknöchelchen",
      "Angeborenes Fehlen des Amboss",
      "Isolierte kongenitale Fehlbildung der Gehörknöchelchen",
      "Kongenitale Lageanomalie der Ohrknöchelchen",
      "Kongenitale Ohrknöchelchenfusion",
      "Persistierende Arteria stapedia"
    ]
  },
  {
    "code": "Q16.4",
    "name": "Abnormer Verlauf der Eustachi-Röhre",
    "synonyms": [
      "Abnormer Verlauf der Eustachi-Röhre",
      "Angeborene Deformität der Eustachi-Röhre a.n.k.",
      "Angeborene Mittelohranomalie",
      "Angeborene Mittelohrdeformität",
      "Angeborene Mittelohrfehlbildung",
      "Anomalie der Eustachi-Röhre",
      "Atresie der Eustachi-Röhre",
      "Atresie der Tuba pharyngotympanica",
      "Hypoplasie der Eustachi-Röhre",
      "Kongenitale Dilatation der Eustachi-Röhre",
      "Kongenitale Lageanomalie der Eustachi-Röhre",
      "Kongenitale Lageanomalie der Ohrtrompete",
      "Kongenitale Lageanomalie des Gehörganges",
      "Kongenitale Striktur der Tuba auditiva",
      "Mangelhafter Trommelfellverschluss",
      "Mittelohrdeformität",
      "Mittelohrfehlbildung",
      "Mittelohrhypoplasie",
      "Verformung der Eustachi-Röhre"
    ]
  },
  {
    "code": "Q16.5",
    "name": "Angeborene Fehlbildung des Innenohres",
    "synonyms": [
      "Agenesie des Corti-Organs",
      "Agenesie des häutigen Labyrinths",
      "Angeborene Deformität des Corti-Organs",
      "Angeborene Deformität des Innenohres",
      "Angeborene Dilatation des Sacculus",
      "Angeborene Fehlbildung des Innenohres",
      "Angeborenes Fehlen des Corti-Organs",
      "Angeborenes Fehlen des Innenohres",
      "Anomalie des Corti-Organs",
      "Anomalie des Innenohres",
      "Anomalie des Labyrinthus membranaceus",
      "Anomalie des häutiges Labyrinths",
      "Aplasie des Labyrinthus membranaceus",
      "Fehlbildung des Innenohres",
      "Hypoplasie des Corti-Organs",
      "Hypoplasie des Labyrinthus membranaceus",
      "Kochleovestibuläre Dysplasie",
      "Kongenitale Degeneration des Sacculus",
      "Kongenitale Labyrinthdegeneration mit Beeinträchtigung des Hörvermögens",
      "Kongenitaler Kollaps des Labyrinthus membranaceus",
      "Schwerhörigkeit mit Labyrinthaplasie, Mikrotie und Mikrodontie",
      "Verformung des Corti-Organs",
      "Verformung des Innenohres"
    ]
  },
  {
    "code": "Q16.9",
    "name": "Angeborenes Fehlen eines Ohres",
    "synonyms": [
      "Angeborenes Fehlen eines Ohres",
      "Hypoplasie des Gehörganges mit Beeinträchtigung des Hörvermögens",
      "Kongenitale Lageanomalie des Gehörganges mit Beeinträchtigung des Hörvermögens",
      "Kongenitale Lageanomalie des Ohres mit Beeinträchtigung des Hörvermögens",
      "Ohragenesie",
      "Ohranomalie mit Beeinträchtigung des Hörvermögens",
      "Schwerhörigkeit durch Ohranomalie",
      "Taubheit durch Ohranomalie"
    ]
  },
  {
    "code": "Q17.0",
    "name": "Aurikularanhänge",
    "synonyms": [
      "Akzessorische Aurikularanhänge",
      "Akzessorische Ohrmuschel",
      "Akzessorische Präaurikularanhänge",
      "Akzessorischer Ohrlobus",
      "Akzessorischer Tragus",
      "Akzessorisches Ohr",
      "Akzessorisches Ohrläppchen",
      "Aurikularanhänge",
      "Ohranhänge",
      "Polyotie",
      "Präaurikularanhänge",
      "Überzähliges Ohr",
      "Überzähliges Ohrläppchen"
    ]
  },
  {
    "code": "Q17.1",
    "name": "Makrotie",
    "synonyms": [
      "Angeborenes Großohr",
      "Kongenitale Makrotie",
      "Makrotie",
      "Makrotie des äußeren Ohres"
    ]
  },
  {
    "code": "Q17.2",
    "name": "Mikrotie",
    "synonyms": [
      "Kongenitale Mikrotie",
      "Mikrotie",
      "Mikrotie des äußeren Ohres",
      "Ohrhypoplasie",
      "Ohrmuschelhypoplasie"
    ]
  },
  {
    "code": "Q17.3",
    "name": "Makakusohr",
    "synonyms": [
      "Angeborene Auriculadeformität am Ohr",
      "Angeborene Deformität der Concha auriculae",
      "Angeborene Ohrmuscheldeformität",
      "Angeborene Ohrmuschelfehlbildung",
      "Angeborenes Spitzohr",
      "Anomalie der Concha auriculae",
      "Aztekenohr",
      "Hängeohr",
      "Hängeohrdeformität",
      "Katzenohr",
      "Makakusohr",
      "Ohrmuschelverformung",
      "Rudimentäres Ohrläppchen",
      "Spitzohr",
      "Verformung des äußeren Ohres"
    ]
  },
  {
    "code": "Q17.4",
    "name": "Lageanomalie des Ohres",
    "synonyms": [
      "Angeborene Ohrmuschelverlagerung",
      "Kongenitale Lageanomalie der Ohrmuschel",
      "Lageanomalie des Ohres",
      "Melotie",
      "Ohrtiefstand"
    ]
  },
  {
    "code": "Q17.5",
    "name": "Abstehendes Ohr",
    "synonyms": [
      "Abstehendes Ohr",
      "Angeborene prominente Ohrmuschel",
      "Otopexie"
    ]
  },
  {
    "code": "Q17.8",
    "name": "Darwin-Höcker",
    "synonyms": [
      "Akzessorischer Gehörgang",
      "Angeborene Deformität des äußeren Gehörganges",
      "Angeborene Fissur des Ohrläppchens",
      "Angeborene Ohrmuschelanomalie",
      "Angeborene Ohrmuschelfistel",
      "Angeborenes Fehlen des Ohrläppchens",
      "Anotie",
      "Darwin-Höcker",
      "Doppelter Gehörgang",
      "Gehörgangshypoplasie",
      "Hypoplasie des knöchernen Gehörganges",
      "Hypoplasie des äußeren Gehörgangs",
      "Kongenitale Ohrtrompetenstriktur",
      "Ohrläppchenagenesie",
      "Ohrmuscheldysplasie",
      "Ohrmuschelelefantiasis",
      "Ohrmuschelelephantiasis",
      "Ohrmuschelhyperplasie",
      "Schneckenohr",
      "Stahlohr"
    ]
  },
  {
    "code": "Q17.9",
    "name": "Abstrusio auriculae",
    "synonyms": [
      "Abstrusio auriculae",
      "Angeborene Ohranomalie",
      "Angeborene Ohrdeformität",
      "Ohrfehlbildung"
    ]
  },
  {
    "code": "Q18.0",
    "name": "Laterale Halszyste",
    "synonyms": [
      "Anomalie des 1. Kiemenbogens",
      "Anomalie des 2. Kiemenbogens",
      "Anomalie des 3. Kiemenbogens",
      "Anomalie des 4. Kiemenbogens",
      "Branchiogene Fistel",
      "Branchiogene Zyste",
      "Branchiogener Sinus",
      "Branchiogener Überrest am Hals",
      "Branchiogenes Überbleibsel",
      "Branchiogenes Überbleibsel am Hals",
      "Infektiöse branchiogene Zyste",
      "Kiemengangfistel",
      "Kiemengangzyste",
      "Laterale Halszyste",
      "Mangelhafter Kiemenspaltenverschluss",
      "Mangelhafter Verschluss eines Kiefersinus",
      "Persistierender Kiemenbogen",
      "Pharynx-Kiemengang-Fistel",
      "Sinus der Kiemenspalte"
    ]
  },
  {
    "code": "Q18.1",
    "name": "Präaurikuläre Fistel",
    "synonyms": [
      "Angeborene aurikuläre Fistel",
      "Laterale Halsfistel",
      "Mangelhafter Verschluss eines präaurikulären Sinus",
      "Präaurikuläre Fistel",
      "Präaurikuläre Zyste",
      "Präaurikulärer Sinus",
      "Prätragale Zyste",
      "Prätragaler Sinus",
      "Zervikoaurikuläre Fistel",
      "Äußere Ohrzyste"
    ]
  },
  {
    "code": "Q18.2",
    "name": "Branchialknorpel",
    "synonyms": [
      "Angeborener Branchialknorpel",
      "Branchialknorpel",
      "Branchio-otisches Syndrom",
      "Branchiogene Fehlbildung",
      "Branchiogene Spalte",
      "Halsanhang",
      "Otozephalie",
      "Zervikale Ohrmuschel"
    ]
  },
  {
    "code": "Q18.3",
    "name": "Flügelfell des Halses",
    "synonyms": [
      "Flügelfell des Halses",
      "Pterygium colli"
    ]
  },
  {
    "code": "Q18.4",
    "name": "Makrostomie",
    "synonyms": [
      "Kongenitale Makrostomie",
      "Makrostomie"
    ]
  },
  {
    "code": "Q18.5",
    "name": "Mikrostomie",
    "synonyms": [
      "Kongenitale Mikrostomie",
      "Mikrostomie"
    ]
  },
  {
    "code": "Q18.6",
    "name": "Makrocheilie",
    "synonyms": [
      "Angeborene Lippenverdickung",
      "Kongenitale Lippenhypertrophie",
      "Kongenitale Makrocheilie",
      "Makrocheilie"
    ]
  },
  {
    "code": "Q18.7",
    "name": "Mikrocheilie",
    "synonyms": [
      "Mikrocheilie"
    ]
  },
  {
    "code": "Q18.8",
    "name": "Gesichtsspalte",
    "synonyms": [
      "Agenesie von Teilen des Halses",
      "Angeborenes Fehlen des Kinns",
      "Aprosopie",
      "Branchio-okulo-faziales Syndrom",
      "Diprosopus",
      "Doppelgesicht",
      "Faziale Dermoidzyste",
      "Fehlen des Gesichts",
      "Gesichtshypoplasie",
      "Gesichtsspalte",
      "Gesichtsspalte Nr.4 nach Tessier",
      "Gesichtsspalte Nr.5 nach Tessier",
      "Gesichtsspalte Nr.6 nach Tessier",
      "Isoliertes asymmetrisches Schreigesicht",
      "Kinnagenesie",
      "Kongenitale Lageanomalie der Gesichtszüge",
      "Mediale Fistel des Halses und des Gesichts",
      "Mediale Zyste des Halses und des Gesichts",
      "Medialer Sinus des Halses und des Gesichts",
      "Mediane Gesichtsspalte",
      "Mediane Halsfistel",
      "Mediane Halsspalte",
      "Mediane Halszyste",
      "Nasale Dermoidzyste",
      "Nasenrückenfistel",
      "Schräge Gesichtsspalte"
    ]
  },
  {
    "code": "Q18.9",
    "name": "Gesichtsdysmorphie",
    "synonyms": [
      "Angeborene Gesichtsdeformität",
      "Angeborene Halsdeformität",
      "Angeborene Kinndeformität",
      "Angeborene Wangendeformität",
      "Gesichtsanomalie",
      "Gesichtsdysmorphie",
      "Gesichtsfehlbildung",
      "Gesichtsmissbildung",
      "Halsanomalie",
      "Kinnanomalie",
      "Wangenanomalie"
    ]
  },
  {
    "code": "Q20.0",
    "name": "Truncus arteriosus communis",
    "synonyms": [
      "Angeborener Truncus arteriosus communis",
      "Persistierender Truncus arteriosus",
      "TAC [Truncus arteriosus communis]",
      "Truncus arteriosus communis",
      "Truncus arteriosus persistens"
    ]
  },
  {
    "code": "Q20.1",
    "name": "Rechter Doppelausstromventrikel",
    "synonyms": [
      "DORV [Double outlet right ventricle]",
      "DORV [Double outlet right ventricle] mit subaortalem Ventrikelseptumdefekt und Pulmonalstenose",
      "Double outlet right ventricle",
      "Double outlet right ventricle mit double-committed Ventrikelseptumdefekt",
      "Double outlet right ventricle mit double-committed subpulmonalem Ventrikelseptumdefekt",
      "Double outlet right ventricle mit non-committed subpulmonalem VSD [Ventrikelseptumdefekt]",
      "Double outlet right ventricle mit subaortalem VSD [Ventrikelseptumdefekt]",
      "Double outlet right ventricle mit subaortalem Ventrikelseptumdefekt",
      "Double outlet right ventricle mit subaortalem Ventrikelseptumdefekt und Pulmonalstenose",
      "Double outlet right ventricle mit subpulmonalem VSD [Ventrikelseptumdefekt]",
      "Rechter Doppelausstromventrikel",
      "Taussig-Bing-Komplex",
      "Taussig-Bing-Syndrom"
    ]
  },
  {
    "code": "Q20.2",
    "name": "Linker Doppelausstromventrikel",
    "synonyms": [
      "Double outlet left ventricle",
      "Linker Doppelausstromventrikel"
    ]
  },
  {
    "code": "Q20.3",
    "name": "Diskordante ventrikuloarterielle Verbindung",
    "synonyms": [
      "Angeborene vollständige Transposition eines großen Gefäßes",
      "Aortentransposition",
      "Dextrotransposition der Aorta",
      "Diskordante ventrikuloarterielle Verbindung",
      "Isolierte kongenitale nicht korrigierte Transposition der großen Gefäße",
      "Isolierte kongenitale unkorrigierte Transposition der großen Arterien",
      "Isolierte ventrikuloarterielle Diskordanz",
      "Komplette Transposition der großen Arterien",
      "Kongenitale nicht korrigierte Transposition der großen Gefäße",
      "Kongenitale unkorrigierte Transposition der großen Arterien",
      "Kongenitale unkorrigierte Transposition der großen Arterien mit Koarktation",
      "Kongenitale unkorrigierte Transposition der großen Gefäße mit Koarktation",
      "TGA [Transposition der großen Arterien]",
      "TGA [Transposition der großen Arterien] mit Koarktation",
      "Transposition der großen Arterien",
      "Transposition der großen Gefäße",
      "Ventrikuloarterielle Diskordanz mit atrioventrikulärer Konkordanz"
    ]
  },
  {
    "code": "Q20.4",
    "name": "Doppeleinstromventrikel",
    "synonyms": [
      "Agenesie des Herzkammerseptums",
      "Angeborenes Fehlen des Ventrikelseptums",
      "Cor triloculare biatriatum",
      "Cor univentriculare",
      "DILV [Double inlet left ventricle]",
      "Doppeleinstromventrikel",
      "Double inlet left ventricle",
      "Double inlet ventricle",
      "Gemeinsamer Ventrikel",
      "Single ventricle",
      "Singulärer Ventrikel",
      "Univentrikuläres Herz",
      "Verlagerung des Ventrikelseptums mit rudimentärem Ventrikel"
    ]
  },
  {
    "code": "Q20.5",
    "name": "Diskordante atrioventrikuläre Verbindung",
    "synonyms": [
      "Diskordante atrioventrikuläre Verbindung",
      "Kongenital korrigierte Transposition der großen Arterien",
      "Kongenital korrigierte Transposition der großen Gefäße",
      "Korrigierte Transposition eines großen Gefäßes",
      "L-Transposition der großen Arterien",
      "Lävotransposition",
      "Ventrikelinversion",
      "Verbindung des linken Ventrikels mit dem rechten Vorhof"
    ]
  },
  {
    "code": "Q20.6",
    "name": "Ivemark-Syndrom",
    "synonyms": [
      "Ivemark-Syndrom",
      "Linksatrialer Isomerismus",
      "Rechtsatrialer Isomerismus",
      "Vorhofisomerismus",
      "Vorhofisomerismus mit Asplenie",
      "Vorhofisomerismus mit Polysplenie"
    ]
  },
  {
    "code": "Q20.8",
    "name": "Cor biloculare",
    "synonyms": [
      "Aorto-linksventrikulärer Tunnel",
      "Aorto-rechtsventrikulärer Tunnel",
      "Aortoventrikulärer Tunnel",
      "Cor biloculare",
      "Cor triloculare",
      "Doppelter Herzvorhof",
      "Doppeltes Herzohr",
      "Ektasie des linken Vorhofohres",
      "Ektasie des rechten Vorhofohres",
      "Familiäre Dilatation des rechten Atriums",
      "Herzkammeranomalie",
      "Herzohranomalie",
      "Herzventrikelanomalie",
      "Herzvorhofanomalie",
      "Juxtaposition der Vorhofohren"
    ]
  },
  {
    "code": "Q20.9",
    "name": "Double-outlet-Syndrom",
    "synonyms": [
      "Double outlet ventricle",
      "Double-outlet-Syndrom",
      "Herzhöhlenanomalie"
    ]
  },
  {
    "code": "Q21.0",
    "name": "Ventrikelseptumdefekt",
    "synonyms": [
      "Angeborener Ventrikelseptumdefekt",
      "Bulbärer Ventrikelseptumdefekt",
      "Defekt des Septum interventriculare des Herzens a.n.k.",
      "Einfacher Ventrikelseptumdefekt",
      "GERBODE-Defekt [Ventrikelseptumdefekt mit linksventrikulärem-rechtsatrialem-Shunt]",
      "Herzkammerscheidewanddefekt",
      "Herzkammerseptumanomalie",
      "Herzventrikelseptumdefekt",
      "Infundibulärer Ventrikelseptumdefekt",
      "Interventrikuläre Kommunikation",
      "Interventrikuläres Septumaneurysma",
      "Isolierter Ventrikelseptumdefekt",
      "Kammerscheidewanddefekt",
      "Kammerseptumdefekt",
      "Kongenitaler Ventrikelseptumdefekt",
      "Kongenitaler mangelhafter Verschluss des Kammerseptums",
      "Kongenitaler mangelhafter Verschluss des Septum interventriculare",
      "Kongenitaler mangelhafter Verschluss des Ventrikelseptums",
      "Mangelhafter Kammerseptumverschluss",
      "Multiple Ventrikelseptumdefekte",
      "Roger-Krankheit",
      "Roger-Syndrom",
      "VSD [Ventrikelseptumdefekt] - s.a. Ventrikelseptumdefekt",
      "Ventrikelseptumanomalie",
      "Ventrikelseptumdefekt",
      "Ventrikelseptumverlagerung"
    ]
  },
  {
    "code": "Q21.1",
    "name": "Vorhofseptumdefekt",
    "synonyms": [
      "ASD [Atrioseptaldefekt] - s.a. Atrioseptaldefekt oder s.a. Vorhofseptumdefekt",
      "ASD [Atrioseptaldefekt] vom Koronarsinus-Typ",
      "ASD [Atrioseptaldefekt] vom Secundum Typ",
      "ASD [Atrioseptaldefekt] vom Sinus venosus Typ",
      "Abnormität des Sinus venosus",
      "Agenesie des Herzvorhofseptums",
      "Angeborener Vorhofseptumdefekt",
      "Angeborenes Fehlen des Vorhofseptums",
      "Atrialer Septumdefekt",
      "Atriales Septumaneurysma",
      "Atrioseptaldefekt",
      "Atrioseptaldefekt vom Septum-secundum-Typ",
      "Atriumseptumdefekt",
      "Atriumseptumdefekt mit Reizleitungsstörung",
      "Atriumseptumdefekt vom Koronarsinus Typ",
      "Atriumseptumdefekt vom Secundum Typ",
      "Atriumseptumdefekt vom Septum-secundum-Typ",
      "Atriumseptumdefekt vom Sinus venosus Typ",
      "Cor triloculare biventriculare",
      "Cossio-Syndrom",
      "Defekt des Foramen ovale",
      "Defekt des Koronarsinus",
      "Defekt des Septum interatriale des Herzens a.n.k.",
      "Defekt des Sinus coronarius",
      "Defekt des Sinus venosus",
      "Defekter Verschluss des Vorhofseptums",
      "Herzvorhofseptumanomalie",
      "Herzvorhofseptumdefekt",
      "Interatriale Kommunikation",
      "Kongenitale Anomalie des Koronarsinus",
      "Kongenitaler Vorhofseptumdefekt",
      "Kongenitaler mangelhafter Verschluss des Septum interatriale",
      "Koronarsinusatresie",
      "Koronarsinusstenose",
      "Lutembacher-Komplex",
      "Lutembacher-Syndrom",
      "Mangelhafter Verschluss des Foramen ovale",
      "Mangelhafter Vorhofseptumverschluss",
      "Offenes Foramen ovale",
      "Offenes Ostium secundum",
      "Offenes Vorhofseptum",
      "Ostium-secundum-Defekt",
      "Persistierendes Foramen ovale",
      "Persistierendes Ostium secundum",
      "Septum-secundum-Defekt",
      "Singulärer Vorhof",
      "Vorhofscheidewanddefekt",
      "Vorhofseptumanomalie",
      "Vorhofseptumdefekt",
      "Vorhofseptumdefekt mit Reizleitungsstörung",
      "Vorhofseptumdefekt vom Koronarsinus-Typ",
      "Vorhofseptumdefekt vom Sekundumtyp",
      "Vorhofseptumdefekt vom Sinus-venosus-Typ"
    ]
  },
  {
    "code": "Q21.2",
    "name": "Defekt des Vorhofseptums und Kammerseptums",
    "synonyms": [
      "ASD [Atrioseptaldefekt] vom Ostium primum Typ",
      "AV [Atrioventrikular]-Kanal",
      "AV [Atrioventrikular]-Kanaldefekt",
      "AVSD [Atrioventrikulärer Septumdefekt]",
      "Anomalie des Atrioventrikularkanals",
      "Atrioventrikularkanal",
      "Atrioventrikularkanaldefekt",
      "Atrioventrikulärer Septaldefekt",
      "Atriumseptumdefekt vom Ostium primum Typ",
      "Canalis atrioventricularis communis",
      "Defekt des Septum atrioventriculare des Herzens a.n.k.",
      "Defekt des Vorhofseptums und Kammerseptums",
      "Defekt des Vorhofseptums und des Ventrikelseptums",
      "Endokardkissendefekt",
      "Intermediärer atrioventrikulärer Septumdefekt",
      "Kompletter AV [Atrioventrikular]-Kanal",
      "Kompletter atrioventriculärer Kanal mit Ventrikelhypoplasie",
      "Kompletter atrioventrikulärer Kanal mit Linksherzobstruktion",
      "Kompletter atrioventrikulärer Septumdefekt",
      "Mangelhafter Verschluss des Ostium atrioventriculare",
      "Offenes Ostium primum",
      "Ostium atrioventriculare commune",
      "Ostium-primum-Defekt",
      "Partieller atrioventrikulärer Kanal",
      "Persistenz des Ostium atrioventriculare commune",
      "Persistierender Atrioventrikularkanal",
      "Persistierendes Ostium primum",
      "Septum-primum-Defekt",
      "Vorhofseptumdefekt vom Ostium-primum-Typ"
    ]
  },
  {
    "code": "Q21.3",
    "name": "Ventrikelseptumdefekt mit Pulmonalatresie, Aortendextroposition und Hypertrophie des rechten Ventrikels",
    "synonyms": [
      "Fallot-Tetralogie [Ventrikelseptumdefekt mit Pulmonalarterienstenose oder -atresie, Aortendextroposition und Hypertrophie des rechten Ventrikels]",
      "Pulmonalatresie mit Ventrikelseptumdefekt bei Fallot-Tetralogie",
      "Ventrikelseptumdefekt mit Pulmonalarterienstenose, Aortendextroposition und Hypertrophie des rechten Ventrikels",
      "Ventrikelseptumdefekt mit Pulmonalatresie, Aortendextroposition und Hypertrophie des rechten Ventrikels"
    ]
  },
  {
    "code": "Q21.4",
    "name": "Aortopulmonaler Septumdefekt",
    "synonyms": [
      "Agenesie des Septum aortopulmonale",
      "Aortikopulmonale Arterienfistel",
      "Aortikopulmonalfenster",
      "Aortopulmonale Fensterung",
      "Aortopulmonaler Septumdefekt",
      "Aortopulmonales Fenster",
      "Defekt des Septum aorticopulmonale",
      "Defekt des Septums zwischen Aorta und Arteria pulmonalis a.n.k.",
      "Fehlen des Septum aorticopulmonale",
      "Mangelhafter Verschluss des Septum aortopulmonale",
      "Verbindung zwischen Aortenbasis und Arteria pulmonalis"
    ]
  },
  {
    "code": "Q21.80",
    "name": "Fallot-Pentalogie [Ventrikelseptumdefekt mit Pulmonalarterienstenose oder -atresie, Aortendextroposition und Hypertrophie des rechten Ventrikels sowie Vorhofseptumdefekt]",
    "synonyms": [
      "Fallot-Pentalogie [Ventrikelseptumdefekt mit Pulmonalarterienstenose oder -atresie, Aortendextroposition und Hypertrophie des rechten Ventrikels sowie Vorhofseptumdefekt]"
    ]
  },
  {
    "code": "Q21.88",
    "name": "Fallot-Trilogie [(valvuläre) Pulmonalarterienstenose, Vorhofseptumdefekt und Hypertrophie des rechten Ventrikels]",
    "synonyms": [
      "Eisenmenger-Defekt",
      "Fallot-Trilogie [(valvuläre) Pulmonalarterienstenose, Vorhofseptumdefekt und Hypertrophie des rechten Ventrikels]",
      "Persistierender Bulbus arteriosus des linken Ventrikels",
      "Vorzeitiger Verschluss des Foramen ovale"
    ]
  },
  {
    "code": "Q21.9",
    "name": "Angeborene Fehlbildung des Herzseptums",
    "synonyms": [
      "Angeborene Fehlbildung des Herzseptums",
      "Angeborene Herzseptumdeformität",
      "Herzseptumanomalie",
      "Herzseptumdefekt",
      "Kongenitaler mangelhafter Verschluss des Herzseptums",
      "Septumdefekt"
    ]
  },
  {
    "code": "Q22.0",
    "name": "Pulmonalklappenatresie",
    "synonyms": [
      "Pulmonalatresie mit intaktem Ventrikelseptum",
      "Pulmonalklappenatresie"
    ]
  },
  {
    "code": "Q22.1",
    "name": "Angeborene Pulmonalklappenstenose",
    "synonyms": [
      "Angeborene Pulmonalklappenstenose",
      "Fusion der Pulmonalklappenzipfel",
      "Kongenitale Pulmonalklappenstriktur",
      "Kongenitale valvuläre Pulmonalstenose"
    ]
  },
  {
    "code": "Q22.2",
    "name": "Angeborene Pulmonalklappeninsuffizienz",
    "synonyms": [
      "Angeborene Pulmonalklappeninsuffizienz",
      "Fenster eines Pulmonalklappenzipfels",
      "Fensterung eines Pulmonalklappenzipfels",
      "Kongenitale fehlerhafte Pulmonalklappenentwicklung",
      "Regurgitation bei angeborener Pulmonalklappeninsuffizienz"
    ]
  },
  {
    "code": "Q22.3",
    "name": "Kongenitale Pulmonalklappenanomalie",
    "synonyms": [
      "Akzessorische Pulmonalklappe",
      "Akzessorischer Pulmonalklappenzipfel",
      "Angeborene Pulmonalklappenfehlbildung",
      "Kongenitale Pulmonalklappenanomalie",
      "Kongenitales Fehlen der Pulmonalklappe",
      "Pulmonalklappenagenesie"
    ]
  },
  {
    "code": "Q22.4",
    "name": "Angeborene Trikuspidalklappenstenose",
    "synonyms": [
      "Agenesie der Trikuspidalklappe",
      "Angeborene Trikuspidalklappenstenose",
      "Kongenitale Trikuspidalatresie",
      "Kongenitale Trikuspidalklappenstriktur",
      "Trikuspidalatresie",
      "Trikuspidalklappenatresie"
    ]
  },
  {
    "code": "Q22.5",
    "name": "Ebstein-Anomalie",
    "synonyms": [
      "Ebstein-Anomalie",
      "Ebstein-Deformität der Trikuspidalklappe",
      "Ebstein-Herzanomalie",
      "Ebstein-Malformation",
      "Ebstein-Syndrom"
    ]
  },
  {
    "code": "Q22.6",
    "name": "Hypoplastisches Rechtsherzsyndrom",
    "synonyms": [
      "Hypoplastisches Rechtsherzsyndrom",
      "Rechtsventrikuläre Hypoplasie"
    ]
  },
  {
    "code": "Q22.8",
    "name": "Kongenitale Trikuspidalklappeninsuffizienz",
    "synonyms": [
      "Anomalie der Chordae tendineae der Trikuspidalklappe",
      "Anomalie des subvalvulären Halteapparates der Trikuspidalklappe",
      "Kongenitale Trikuspidaldysplasie",
      "Kongenitale Trikuspidalklappeninsuffizienz",
      "Parachute-Trikuspidalklappe",
      "Straddling der Trikuspidalklappe",
      "Trikuspidalklappe mit akzessorischem Gewebe",
      "Überreitende Trikuspidalklappe"
    ]
  },
  {
    "code": "Q22.9",
    "name": "Kongenitale Trikuspidalklappenanomalie",
    "synonyms": [
      "Kongenitale Trikuspidalklappenanomalie",
      "Kongenitale Trikuspidalklappenfehlbildung"
    ]
  },
  {
    "code": "Q23.0",
    "name": "Valvuläre kongenitale Aortenstenose",
    "synonyms": [
      "Angeborene Aortenklappenatresie",
      "Angeborene Aortenklappenstenose",
      "Kongenitale Aortenklappenstriktur",
      "Valvuläre kongenitale Aortenstenose"
    ]
  },
  {
    "code": "Q23.1",
    "name": "Aortenklappenhypoplasie",
    "synonyms": [
      "Angeborene Aorteninsuffizienz",
      "Aortenklappenhypoplasie",
      "Bikuspidale Aortenklappe",
      "Familiäre bikuspidale Aortenklappe",
      "Kongenitale Aortenklappeninsuffizienz"
    ]
  },
  {
    "code": "Q23.2",
    "name": "Angeborene Mitralklappenstenose",
    "synonyms": [
      "Angeborene Mitralatresie",
      "Angeborene Mitralklappenstenose",
      "Duroziez-Krankheit",
      "Fusion der Mitralklappenzipfel",
      "Hypoplasie des Mitralklappenanulus",
      "Kongenitale Mitralklappenstriktur",
      "Kongenitale Mitralstenose",
      "Kongenitaler supravalvulärer Mitralring",
      "Mitralklappenatresie"
    ]
  },
  {
    "code": "Q23.3",
    "name": "Angeborene Mitralklappeninsuffizienz",
    "synonyms": [
      "Angeborene Mitralklappeninsuffizienz",
      "Kongenitale unbedeckte Mitralöffnung",
      "Mitralklappenagenesie"
    ]
  },
  {
    "code": "Q23.4",
    "name": "Hypoplastisches Linksherzsyndrom",
    "synonyms": [
      "Angeborene Aortenatresie mit Hypoplasie der Aorta ascendens und fehlerhafter Entwicklung des linken Ventrikels",
      "Aortenatresie bei hypoplastischem Linksherzsyndrom",
      "Aortenklappenhypoplasie bei hypoplastischem Linksherz-Syndrom",
      "HLHS [Hypoplastisches Linksherzsyndrom]",
      "Hypoplasie der Aorta ascendens bei hypoplastischem Linksherzsyndrom",
      "Hypoplastisches Linksherzsyndrom",
      "Kongenitale fehlerhafte Entwicklung des linken Herzventrikels bei hypoplastischem Linksherz-Syndrom",
      "Linksherzhypoplasiesyndrom",
      "Mitralklappenatresie bei hypoplastischem Linksherzsyndrom",
      "Ventrikelhypoplasie links"
    ]
  },
  {
    "code": "Q23.8",
    "name": "Quadrikuspidale Aortenklappe",
    "synonyms": [
      "Akzessorischer Aortenklappenzipfel",
      "Angeborene Aortenklappendeformität",
      "Angeborene Aortenzipfeldeformität",
      "Anomalie der subvalvulären Strukturen der Mitralklappe",
      "Double-orifice-Mitralklappe",
      "Mitralklappe mit akzessorischem Gewebe",
      "Mitralklappenspalt",
      "Quadrikuspidale Aortenklappe",
      "Quadrikuspide Aortenklappe",
      "Shone-Komplex",
      "Straddling der Mitralklappe",
      "Überreitende Mitralklappe"
    ]
  },
  {
    "code": "Q23.9",
    "name": "Kongenitale Aortenklappenanomalie",
    "synonyms": [
      "Angeborene Aortenklappenanomalie a.n.k.",
      "Angeborene Aortenklappenfehlbildung",
      "Angeborene Aortenklappenzipfelanomalie a.n.k.",
      "Aortenklappendysplasie",
      "Kongenitale Aortenklappenanomalie",
      "Kongenitale Mitralklappenanomalie",
      "Mitralklappenanomalie",
      "Mitralklappenfehlbildung"
    ]
  },
  {
    "code": "Q24.0",
    "name": "Dextrokardie",
    "synonyms": [
      "Dextrokardie",
      "Dextropositio cordis",
      "Echte Dextrokardie",
      "Herztransposition"
    ]
  },
  {
    "code": "Q24.1",
    "name": "Lävokardie",
    "synonyms": [
      "Isolierte Lävokardie",
      "Laevokardie und Situs inversus",
      "Lävokardie"
    ]
  },
  {
    "code": "Q24.2",
    "name": "Cor triatriatum",
    "synonyms": [
      "Cor triatriatum",
      "Cor triatriatum dexter",
      "Cor triatriatum sinister"
    ]
  },
  {
    "code": "Q24.3",
    "name": "Pulmonale Infundibulumstenose",
    "synonyms": [
      "Infundibuläre Pulmonalarterienstenose",
      "Infundibuläre Pulmonalstenose",
      "Pulmonale Infundibulumstenose",
      "Subpulmonalstenose"
    ]
  },
  {
    "code": "Q24.4",
    "name": "Angeborene subvalvuläre Aortenstenose",
    "synonyms": [
      "Angeborene subvalvuläre Aortenstenose",
      "Diskrete fibromuskuläre Subaortenstenose",
      "Diskrete fixierte membranöse Subaortenstenose",
      "Fixierte Subaortenstenose",
      "Subaortenstenose",
      "Subaortenstenose vom Tunneltyp"
    ]
  },
  {
    "code": "Q24.5",
    "name": "Fehlbildung eines Koronargefäßes",
    "synonyms": [
      "Aberranter aortopulmonaler Verlauf der Koronararterien",
      "Aberranter intramuraler Verlauf der Koronararterien",
      "Aberranter intramyokardialer Verlauf der Koronararterien",
      "Abgang der linken Koronararterie aus der Pulmonalarterie",
      "Akzessorische Koronararterien",
      "Angeborene Koronararteriendeformität",
      "Angeborene Koronararterienfistel",
      "Angeborene koronare arteriovenöse Fistel",
      "Angeborenes Koronararterienaneurysma",
      "Anomale Anzahl der Koronarostien",
      "Anomaler Abgang der linken Koronararterie",
      "Anomaler Abgang der rechten Koronararterie",
      "Anomalie der Abgänge der Arteriae coronariae",
      "Anomalie der Arteriae coronariae cordis",
      "Anomalie der Valvula sinus coronarii",
      "Anomalie eines Koronargefäßes",
      "Bland-White-Garland-Syndrom [Koronararterienanomalie]",
      "Fehlbildung eines Koronargefäßes",
      "Fehlen einer Koronararterie",
      "Fehllage des Koronarostium",
      "Kongenitale Fehlbildung der Koronararterien",
      "Kongenitale Koronararterienkrankheit",
      "Kongenitale Koronararterienstriktur",
      "Kongenitale Lageanomalie einer Koronararterie",
      "Koronararterienagenesie",
      "Koronararterienanomalie",
      "Koronararterienatresie a.n.k.",
      "Koronararterienhypoplasie",
      "Koronarostiumatresie",
      "Koronarostiumstenose"
    ]
  },
  {
    "code": "Q24.6",
    "name": "Angeborener Herzblock",
    "synonyms": [
      "Angeborener Herzblock",
      "Kongenitaler atrioventrikulärer Block"
    ]
  },
  {
    "code": "Q24.8",
    "name": "Ektokardie",
    "synonyms": [
      "Abnormer Gewebestrang des Herzens",
      "Akzessorische Herzklappe a.n.k.",
      "Akzessorischer Herzklappenzipfel a.n.k.",
      "Akzessorisches Herz",
      "Angeborene Herzinsuffizienz",
      "Angeborene Herzklappendeformität",
      "Angeborene Herzklappenverformung",
      "Angeborene Herzverformung",
      "Angeborene Lageanomalie des Herzens a.n.k.",
      "Angeborene Myokardfehlbildung",
      "Angeborene Perikarddeformität",
      "Angeborene Perikardfehlbildung",
      "Angeborene perikardiale Zyste",
      "Angeborener Gewebestrang des Herzens",
      "Angeborenes Aneurysma des linken Ventrikels",
      "Angeborenes Divertikel des linken Ventrikels",
      "Angeborenes Fehlen des Perikards",
      "Anomalie der Chordae tendineae",
      "Anomalie der herznahen Klappe der Vena cava inferior",
      "Chiari-Netzwerk",
      "Criss-cross Herz",
      "Ectopia cordis",
      "Ektokardie",
      "FLNA-assoziierte X-chromosomale myxomatöse Herzklappendysplasie",
      "Fenster eines Herzklappenzipfels a.n.k.",
      "Fensterung eines Herzklappenzipfels a.n.k.",
      "Fusion eines Herzklappenzipfels a.n.k.",
      "Hemikardie",
      "Hernia cordis",
      "Herzagenesie",
      "Herzbandanomalie",
      "Herzektopie",
      "Herzfaltenanomalie",
      "Herzhypoplasie",
      "Herzklappenagenesie a.n.k.",
      "Herzklappenanomalie a.n.k.",
      "Herzklappenatresie a.n.k.",
      "Herzmuskelanomalie",
      "Herzspitzenspaltung",
      "Herzunterentwicklung",
      "Hypoplasie des Myokards im rechten Ventrikel",
      "Kongenitale Dilatatio cordis",
      "Kongenitale Herzdilatation",
      "Kongenitale Herzhypertrophie a.n.k.",
      "Kongenitale Herzklappendysplasie",
      "Kongenitale Herzklappeninsuffizienz",
      "Kongenitale Herzklappenstriktur a.n.k.",
      "Kongenitale Herzverlagerung",
      "Kongenitale Kardiomegalie",
      "Kongenitale Ventrikelhypertrophie",
      "Kongenitale fehlerhafte Entwicklung des linken Herzventrikels",
      "Kongenitale fehlerhafte Herzklappenentwicklung",
      "Kongenitale komplette Perikardagenesie",
      "Kongenitale obstruktive hypertrophische Kardiomyopathie",
      "Kongenitale partielle Perikardagenesie",
      "Kongenitales Herzdivertikel",
      "Kongenitales Perikarddivertikel",
      "Malposition des Herzens",
      "Mesokardie",
      "Myokardanomalie",
      "Papillarmuskelanomalie",
      "Perikardagenesie",
      "Perikardanomalie",
      "Perikardzyste",
      "Pleuroperikardiale Zyste",
      "Uhl-Anomalie",
      "Uhl-Krankheit",
      "Verdrehte atrio-ventrikuläre Verbindungen"
    ]
  },
  {
    "code": "Q24.9",
    "name": "Kongenitaler Herzfehler",
    "synonyms": [
      "Angeborene Herzanomalie",
      "Angeborene Herzdeformität",
      "Angeborene Herzfehlbildung",
      "Angeborene Herzkrankheit",
      "Angeborene azyanotische Herzkrankheit",
      "Angeborene zyanotische Herzkrankheit",
      "Angeborener Herzfehler",
      "Angeborenes Vitium cordis",
      "Atelokardie",
      "Azyanotische Herzkrankheit",
      "Blaues Neugeborenes",
      "Blue baby",
      "Herzanomalie",
      "Herzfehlbildung a.n.k.",
      "Herzinfantilismus",
      "Herzmissbildung",
      "Kardiale Anomalie",
      "Kongenitale Herzfehlbildung",
      "Kongenitale unvollkommene Herzentwicklung",
      "Kongenitaler Herzfehler",
      "Kongenitaler kardialer Schaden",
      "Kongenitales Vitium cordis",
      "Morbus caeruleus"
    ]
  },
  {
    "code": "Q25.0",
    "name": "Persistierender Ductus arteriosus",
    "synonyms": [
      "Deformität des Ductus arteriosus",
      "Ductus arteriosus persistens (Botalli)",
      "Familiärer persistierender Ductus arteriosus",
      "Kongenitaler mangelhafter Verschluss des Ductus Botalli",
      "Kongenitaler mangelhafter Verschluss des Ductus arteriosus",
      "Offener Ductus Botalli",
      "Offener Ductus arteriosus",
      "Offener Ductus arteriosus Botalli",
      "Persistierender Ductus arteriosus"
    ]
  },
  {
    "code": "Q25.1",
    "name": "Aortenkoarktation",
    "synonyms": [
      "Abdominale Aortenkoarktation",
      "Anomalie der Aortenkoarktation",
      "Aortenisthmusstenose",
      "Aortenkoarktation",
      "Atypische Aortenkoarktation",
      "Autosomal-dominante Aortenisthmusstenose",
      "Coarctatio aortae",
      "ISTA [Isthmusstenose der Aorta]",
      "Koarktation der Aorta",
      "Kongenitale Aortenisthmusstenose",
      "Mid-Aortic-Syndrom",
      "Postduktale Aortenisthmusstenose",
      "Postduktale Aortenkoarktation",
      "Postduktale Coarctatio aortae",
      "Präduktale Aortenisthmusstenose",
      "Präduktale Aortenkoarktation",
      "Präduktale Coarctatio aortae"
    ]
  },
  {
    "code": "Q25.2",
    "name": "Aortenatresie",
    "synonyms": [
      "Angeborene Aortenatresie",
      "Aortenatresie",
      "Aortenbogenatresie",
      "Aortenringatresie"
    ]
  },
  {
    "code": "Q25.3",
    "name": "Supravalvuläre Aortenstenose",
    "synonyms": [
      "Angeborene Aortenstenose",
      "Angeborene Stenose der Aorta ascendens",
      "Angeborene Striktur der Aorta ascendens",
      "Angeborener Aortenverschluss",
      "Supravalvuläre Aortenstenose",
      "Supraventrikuläre Aortenstenose"
    ]
  },
  {
    "code": "Q25.4",
    "name": "Aortenaplasie",
    "synonyms": [
      "Akzessorischer Aortenbogen",
      "Aneurysma des Sinus Valsalvae",
      "Angeborene Aortendeformität",
      "Angeborene Aortendilatation",
      "Angeborene Deformität des Aortenbogens",
      "Angeborenes Aneurysma des Sinus aortae",
      "Angeborenes Aortenaneurysma",
      "Angeborenes Fehlen der Aorta",
      "Angeborenes Fehlen des Aortenbogens",
      "Anomalie der Aorta ascendens",
      "Anomalie des Aortengefäßrings",
      "Anomalie des Sinus Valsalvae",
      "Aortenagenesie",
      "Aortenanomalie a.n.k.",
      "Aortenaplasie",
      "Aortenbogen-Defekt",
      "Aortenbogenanomalie a.n.k.",
      "Aortenbogenunterbrechung",
      "Aortenfehlbildung",
      "Aortenhypoplasie",
      "Aortenverlagerung",
      "Deformität des Sinus Valsalvae",
      "Doppelter Aortenbogen",
      "Doppelter Aortenbogen mit zirkulärer Einengung von Trachea und Ösophagus",
      "Gefäßring der Aorta",
      "Kommerell-Divertikel",
      "Kongenitale Aortentorsion",
      "Kongenitale Lageanomalie der Aorta",
      "Neuhauser-Anomalie",
      "Persistenz des rechten Aortenbogens",
      "Persistierende Gefäßkonvolute im Bereich des Aortenbogens",
      "Persistierende linke Aortenwurzel mit rechtem Aortenbogen",
      "Persistierender doppelter Aortenbogen",
      "Persistierender fünfter Aortenbogen",
      "Persistierender rechter Aortenbogen",
      "Pseudotruncus arteriosus communis",
      "Rechter Aortenbogen",
      "Reitende Aorta",
      "Rupturiertes Aneurysma des Sinus Valsalvae",
      "Unterbrochener Aortenbogen",
      "Zervikaler Aortenbogen"
    ]
  },
  {
    "code": "Q25.5",
    "name": "Atresie der Arteria pulmonalis",
    "synonyms": [
      "Atresie der Arteria pulmonalis",
      "Lungenarterienatresie a.n.k.",
      "Pulmonalarterienatresie",
      "Pulmonalatresie"
    ]
  },
  {
    "code": "Q25.6",
    "name": "Kongenitale Pulmonalisstenose",
    "synonyms": [
      "Kongenitale Pulmonalisstenose",
      "Kongenitale Stenose der Lungenarterie",
      "Periphere Pulmonalstenose",
      "Pulmonalarterienstenose",
      "Pulmonalarterienstriktur",
      "Pulmonalarterienverengung",
      "Stenose der Arteria pulmonalis",
      "Striktur der Arteria pulmonalis",
      "Supravalvuläre Pulmonalarterienstenose"
    ]
  },
  {
    "code": "Q25.7",
    "name": "Pulmonalarterienanomalie",
    "synonyms": [
      "Aberrierende Arteria pulmonalis",
      "Abnormaler Abgang der Pulmonalarterie",
      "Agenesie der Arteria pulmonalis",
      "Angeborene Anomalie der Arteria pulmonalis",
      "Angeborene Hypoplasie der Arteria pulmonalis",
      "Angeborene Pulmonalarterienabnormität",
      "Angeborene Verbindung zwischen Pulmonalarterie und Pulmonalvene",
      "Angeborenes Aneurysma der Arteria pulmonalis",
      "Angeborenes Fehlen der Pulmonalarterie",
      "Anomalie des Abganges der Arteria pulmonalis",
      "Kongenitale Lageanomalie der Pulmonalarterie",
      "Kongenitale pulmonale arteriovenöse Fistel",
      "Kongenitaler arteriovenöser pulmonaler Shunt",
      "Kongenitales Pulmonalarterienaneurysma",
      "Lungenarterienhypoplasie",
      "Pulmonalarterie, dem offenem Ductus arteriosus entstammend",
      "Pulmonalarterie, der Aorta entstammend",
      "Pulmonalarterienagenesie",
      "Pulmonalarterienanomalie",
      "Pulmonalarterienhypoplasie",
      "Pulmonales arteriovenöses Aneurysma"
    ]
  },
  {
    "code": "Q25.8",
    "name": "Pseudocoarctatio aortae [Kinking]",
    "synonyms": [
      "Angeborener Gefäßring",
      "Angeborenes Aneurysma des persistierenden Ductus arteriosus",
      "Anomalie des Abganges der Arteria subclavia",
      "Anomalie des Abganges des Truncus brachiocephalicus",
      "Dysphagia lusoria",
      "Kongenitale Lageanomalie eines Gefäßstamms",
      "Letales Arteriopathie-Syndrom durch Fibulin-4-Mangel",
      "Pseudocoarctatio aortae [Kinking]",
      "Vorzeitiger Verschluss des Ductus arteriosus"
    ]
  },
  {
    "code": "Q25.9",
    "name": "Angeborene Fehlbildung großer Arterien",
    "synonyms": [
      "Angeborene Fehlbildung großer Arterien",
      "Anomalie großer Arterien"
    ]
  },
  {
    "code": "Q26.0",
    "name": "Angeborene Stenose der Vena cava",
    "synonyms": [
      "Angeborene Stenose der Vena cava",
      "Angeborene Stenose der Vena cava inferior",
      "Angeborene Stenose der Vena cava superior",
      "Kongenitale Hohlvenenstenose",
      "Kongenitale Striktur der Vena cava"
    ]
  },
  {
    "code": "Q26.1",
    "name": "Persistenz der linken Vena cava superior",
    "synonyms": [
      "Persistenz der linken Vena cava superior",
      "Persistenz der linken Vena cava superior mit Mündung in das Dach des linken Vorhofs",
      "Persistenz der linken Vena cava superior mit Mündung in den linken Vorhof",
      "Persistenz der linken oberen Hohlvene mit Mündung in den linken Vorhof",
      "Persistenz der linken oberen Hohlvene mit Mündung über den Koronarsinus in den linken Vorhof",
      "Persistenz der linken oberen Hohlvene mit Mündung über den Sinus coronarius in den linken Vorhof"
    ]
  },
  {
    "code": "Q26.2",
    "name": "Totale Fehleinmündung der Lungenvenen",
    "synonyms": [
      "Kongenitale totale Lungenvenen Fehleinmündung",
      "Totale Anomalie der Lungenvenenverbindung",
      "Totale Anomalie der pulmonalen Venenverbindung",
      "Totale Fehleinmündung der Lungenvenen"
    ]
  },
  {
    "code": "Q26.3",
    "name": "Partielle Fehleinmündung der Lungenvenen",
    "synonyms": [
      "Angeborene Pulmonalvenenatresie",
      "Anomale Endung der rechten Lungenvene",
      "Atresie der Venae pulmonales",
      "Kongenitale partielle Lungenvenen Fehleinmündung",
      "Partielle Anomalie der Lungenvenenverbindung",
      "Partielle Anomalie pulmonaler Venenverbindungen",
      "Partielle Fehleinmündung der Lungenvenen",
      "Pulmonalvenenatresie"
    ]
  },
  {
    "code": "Q26.4",
    "name": "Anomale Durchtrittsstelle eines Lungengefäßes",
    "synonyms": [
      "Anomale Durchtrittsstelle eines Lungengefäßes",
      "Anomalie der Lungenvenenverbindung",
      "Falsche Lungenveneneinmündung",
      "Kongenitale Fehleinmündung der Lungenvenen"
    ]
  },
  {
    "code": "Q26.5",
    "name": "Fehleinmündung der Pfortader",
    "synonyms": [
      "Angeborene Pfortaderdeformität",
      "Angeborene portosystemische Venenfistel",
      "Angeborener portosystemischer Shunt",
      "Angeborenes Fehlen der Vena portae",
      "Atresie der Vena portae",
      "Falsche Einmündung der Vena portae",
      "Falsche Pfortadereinmündung",
      "Fehleinmündung der Pfortader",
      "Pfortaderagenesie",
      "Pfortaderanomalie",
      "Pfortaderatresie",
      "Pfortaderhypoplasie"
    ]
  },
  {
    "code": "Q26.6",
    "name": "Fistel zwischen der Vena portae und der Arteria hepatica",
    "synonyms": [
      "Angeborene Fistel zwischen Leberarterie und Pfortader",
      "Fistel zwischen der Vena portae und der Arteria hepatica"
    ]
  },
  {
    "code": "Q26.8",
    "name": "Scimitar-Syndrom",
    "synonyms": [
      "Agenesie der Vena cava",
      "Agenesie der Vena cava inferior",
      "Agenesie der Vena cava superior",
      "Agenesie der oberen Hohlvene",
      "Agenesie großer Venen a.n.k.",
      "Angeborene Anomalie des Venenrücklaufs",
      "Angeborene Pulmonalvenenstenose",
      "Atresie der Vena cava inferior",
      "Atresie der Vena cava superior",
      "Atresie großer Venen",
      "Azygos-Kontinuation der Vena cava inferior",
      "Fehlen der Kopf-Armvene",
      "Fehlen der Vena brachiocephalica",
      "Fehlen der Vena cava inferior",
      "Fehlen der Vena cava superior",
      "Fehlen der Vena innominata",
      "Halasz-Syndrom",
      "Hypogenetisches Lungensyndrom",
      "Hypoplasie der Vena cava",
      "Hypoplasie der Vena cava inferior",
      "Hypoplasie der Vena cava superior",
      "Hypoplasie großer Venen",
      "Kongenitale Anomalie der Lebervene",
      "Kongenitale Lageanomalie der Vena cava",
      "Kongenitale Lageanomalie großer Venen",
      "Kongenitales pulmonales venolobares Syndrom",
      "Nierenvenenanomalie",
      "Persistenz der linken Vena cardinalis posterior",
      "Persistenz des Sinus venosus mit mangelhafter Verbindung in den rechten Vorhof",
      "Persistierende Eustachische Klappe",
      "Persistierende linke hintere Kardinalvene",
      "Primäre Pulmonalvenenstenose",
      "Rechte Vena cava inferior verbunden mit dem linken Vorhof",
      "Rechte Vena cava superior verbunden mit dem linken Vorhof",
      "SVC [Vena cava superior]-Agenesie",
      "Scimitar-Anomalie",
      "Scimitar-Syndrom",
      "Subaortaler Verlauf der Vena brachiocephalica",
      "Unterbrechung der Vena cava inferior",
      "Vena azygos-Kontinuations-Syndrom"
    ]
  },
  {
    "code": "Q26.9",
    "name": "Angeborene Fehlbildung großer Venen",
    "synonyms": [
      "Angeborene Deformität der Vena cava inferior",
      "Angeborene Deformität der Vena cava superior",
      "Angeborene Deformität großer Venen",
      "Angeborene Fehlbildung großer Venen",
      "Anomalie der Vena cava inferior",
      "Anomalie der Vena cava superior",
      "Anomalie großer Venen",
      "Kongenitale Anomalie der unteren Hohlvene"
    ]
  },
  {
    "code": "Q27.0",
    "name": "Agenesie der Nabelschnurarterie",
    "synonyms": [
      "Agenesie der Nabelschnurarterie",
      "Angeborenes Fehlen der Nabelarterie",
      "Anomalie der Arteria umbilicalis",
      "Hypoplasie der Arteria umbilicalis",
      "Hypoplasie der Nabelschnurarterie",
      "Kongenitale Striktur der Nabelschnurarterie",
      "Nabelarterienagenesie",
      "Nabelarterienanomalie",
      "Nabelarterienatresie a.n.k.",
      "Singuläre Arteria umbilicalis"
    ]
  },
  {
    "code": "Q27.1",
    "name": "Angeborene Nierenarterienstenose",
    "synonyms": [
      "Angeborene Nierenarterienstenose",
      "Angeborene Nierenarterienstriktur"
    ]
  },
  {
    "code": "Q27.2",
    "name": "Versorgungsanomalie der Niere",
    "synonyms": [
      "Akzessorische Nierenarterie",
      "Angeborene Fehlbildung der Nierenarterie",
      "Angeborenes Fehlen der Nierenarterie",
      "Anomalie der renalen Arterie",
      "Anomalie des Abganges der Arteria renalis",
      "Deformität einer Nierenarterie",
      "Doppelte Nierenarterie",
      "Dysplasie der Arteria renalis",
      "Dysplasie der Nierenhauptarterie",
      "Multiple Nierenarterien",
      "Nierenarterienanomalie",
      "Nierenarteriendysplasie",
      "Versorgungsanomalie der Niere"
    ]
  },
  {
    "code": "Q27.3",
    "name": "Arteriovenöse Fehlbildung peripherer Gefäße",
    "synonyms": [
      "Arteriovenöse Fehlbildung des Gesichts",
      "Arteriovenöse Fehlbildung peripherer Gefäße",
      "Arteriovenöse aneurysmatische Fehlbildung",
      "CM-AVM [Kapilläre Malformation, arteriovenöse Malformation]",
      "Cobb-Syndrom",
      "Frontonasale arteriovenöse Fehlbildung",
      "Kapilläre Fehlbildung und arteriovenöse Fehlbildung",
      "Kongenitale arteriovenöse Fistel",
      "Kongenitale systemische arteriovenöse Fistel",
      "Kongenitales arteriovenöses Aneurysma",
      "Kutaneomeningospinale Angiomatose",
      "Mandibuläre arteriovenöse Fehlbildung",
      "Maxilläre arteriovenöse Fehlbildung",
      "Spinales arteriovenöses metameres Syndrom"
    ]
  },
  {
    "code": "Q27.4",
    "name": "Angeborene Phlebektasie",
    "synonyms": [
      "Angeborene Phlebektasie",
      "Bockenheimer-Syndrom",
      "Genuine diffuse Phlebektasie",
      "Kongenitale Phlebektasie"
    ]
  },
  {
    "code": "Q27.8",
    "name": "Aberrierendes Nierengefäß",
    "synonyms": [
      "Aberrierende Arteria subclavia",
      "Aberrierendes Nierengefäß",
      "Aberrierendes Nierenpolgefäß",
      "Agenesie peripherer Arterien",
      "Agenesie peripherer Venen",
      "Akzessorisches Nierenpolgefäß",
      "Angeborene Arterienstriktur",
      "Angeborene Varizen",
      "Angeborene Venenvarikose",
      "Angeborenes Arteria-mesenterica-superior-Syndrom",
      "Angeborenes Fehlen peripherer Arterien",
      "Angeborenes Fehlen peripherer Venen",
      "Angeborenes Wilkie-Syndrom",
      "Angeborenes peripheres Aneurysma",
      "Arterienaberration a.n.k.",
      "Arterienatresie a.n.k.",
      "Bean-Syndrom",
      "Blaues Gummibläschen-Naevus-Syndrom",
      "Blue-Rubber-Bleb-Nävus-Syndrom",
      "Cutis marmorata teleangiectatica congenita [CMTC]",
      "Erythema palmare hereditarium",
      "Fehlen einer Arterie a.n.k.",
      "Fehlen einer Vene a.n.k.",
      "Gefäßatresie a.n.k.",
      "Hypoplasie eines peripheren Gefäßes",
      "Hypoplasie peripherer Arterien",
      "Hypoplasie peripherer Venen",
      "Kongenitale Arterienhypertrophie a.n.k.",
      "Kongenitale Arterienstriktur",
      "Kongenitale Lageanomalie des peripheren Gefäßsystems",
      "Kongenitale Lageanomalie einer Arterie",
      "Kongenitale Lageanomalie einer Vene",
      "Kongenitale Orbitavarizen",
      "Kongenitale Varizen",
      "Kongenitale Ösophagusvarizen",
      "Kongenitales Aneurysma racemosum",
      "Kongenitales peripheres Aneurysma a.n.k.",
      "Kongenitales venöses Aneurysma",
      "Kutane und muköse venöse Malformation",
      "Mukokutane venöse Fehlbildung",
      "Nierengefäßanomalie",
      "Renales Nussknackersyndrom",
      "Servelle-Martorell-Syndrom",
      "Van-Lohuizen-Syndrom [Cutis marmorata teleangiectatica congenita]",
      "Venenaberration a.n.k.",
      "Venenatresie a.n.k.",
      "Viszerokutane Hämangiomatose"
    ]
  },
  {
    "code": "Q27.9",
    "name": "Akzessorisches Blutgefäß a.n.k.",
    "synonyms": [
      "Akzessorisches Blutgefäß a.n.k.",
      "Angeborene Arterienanomalie",
      "Angeborene Deformität einer Vene",
      "Angeborene Deformität peripherer Arterien a.n.k.",
      "Angeborene Gefäßanomalie a.n.k.",
      "Angeborene Venenanomalie",
      "Angeborene vaskuläre Deformität a.n.k.",
      "Anomalie der Kapillaren",
      "Anomalie des peripheren Gefäßsystems",
      "Anomalie peripherer Arterien",
      "Anomalie peripherer Venen",
      "Kongenitaler vaskulärer Defekt"
    ]
  },
  {
    "code": "Q28.00",
    "name": "Angeborenes nichtrupturiertes arteriovenöses Aneurysma extrakranieller hirnversorgender Gefäße",
    "synonyms": [
      "Angeborenes arteriovenöses Aneurysma der präzerebralen Gefäße",
      "Angeborenes nichtrupturiertes arteriovenöses Aneurysma extrakranieller hirnversorgender Gefäße",
      "Arteriovenöses Aneurysma extrakranieller hirnversorgender Gefäße"
    ]
  },
  {
    "code": "Q28.01",
    "name": "Angeborene arteriovenöse Fistel präzerebraler Gefäße",
    "synonyms": [
      "Angeborene arteriovenöse Fistel präzerebraler Gefäße"
    ]
  },
  {
    "code": "Q28.09",
    "name": "Arteriovenöse Fehlbildung extrakranieller hirnversorgender Gefäße",
    "synonyms": [
      "Arteriovenöse Fehlbildung extrakranieller hirnversorgender Gefäße"
    ]
  },
  {
    "code": "Q28.10",
    "name": "Angeborenes Aneurysma eines extrakraniellen hirnversorgenden Gefäßes",
    "synonyms": [
      "Angeborenes Aneurysma eines extrakraniellen hirnversorgenden Gefäßes",
      "Angeborenes Aneurysma eines präzerebralen Gefäßes",
      "Angeborenes nichtrupturiertes Aneurysma eines extrakraniellen hirnversorgenden Gefäßes"
    ]
  },
  {
    "code": "Q28.11",
    "name": "Angeborene Fistel eines präzerebralen Gefäßes",
    "synonyms": [
      "Angeborene Fistel eines präzerebralen Gefäßes"
    ]
  },
  {
    "code": "Q28.18",
    "name": "Agenesie der Arteria carotis interna",
    "synonyms": [
      "Agenesie der Arteria carotis interna"
    ]
  },
  {
    "code": "Q28.19",
    "name": "Angeborene Fehlbildung extrakranieller hirnversorgender Gefäße",
    "synonyms": [
      "Angeborene Fehlbildung extrakranieller hirnversorgender Gefäße",
      "Anomalie der Arteria basilaris a.n.k.",
      "Anomalie der Arteria vertebralis a.n.k.",
      "Anomalie extrakranieller hirnversorgender Gefäße"
    ]
  },
  {
    "code": "Q28.20",
    "name": "Angeborenes nichtrupturiertes arteriovenöses Hirngefäßaneurysma",
    "synonyms": [
      "Angeborenes Vena-Galeni-Aneurysma",
      "Angeborenes arteriovenöses Gehirnaneurysma",
      "Angeborenes nichtrupturiertes arteriovenöses Hirngefäßaneurysma",
      "Arteriovenöses Aneurysma des Sinus cavernosus",
      "Arteriovenöses zerebrales Aneurysma"
    ]
  },
  {
    "code": "Q28.21",
    "name": "Angeborene arteriovenöse Fistel zerebraler Gefäße",
    "synonyms": [
      "Angeborene arteriovenöse Fistel zerebraler Gefäße",
      "Arteriovenöser zerebraler Shunt",
      "Kraniale durale arteriovenöse Fistel"
    ]
  },
  {
    "code": "Q28.28",
    "name": "Zerebrofaziales arteriovenöses metameres Syndrom",
    "synonyms": [
      "Bonnet-Dechaume-Blanc-Syndrom",
      "Kraniale durale arteriovenöse Fehlbildung",
      "Vena Galeni-Malformation",
      "Wyburn-Mason-Syndrom",
      "Zerebrofaziales arteriovenöses metameres Syndrom",
      "Zerebrofaziales arteriovenöses metameres Syndrom Typ 1",
      "Zerebrofaziales arteriovenöses metameres Syndrom Typ 2",
      "Zerebrofaziales arteriovenöses metameres Syndrom Typ 3"
    ]
  },
  {
    "code": "Q28.29",
    "name": "Arteriovenöse Fehlbildung eines Hirngefäßes",
    "synonyms": [
      "Arteriovenöse Fehlbildung des Gehirns",
      "Arteriovenöse Fehlbildung eines Hirngefäßes",
      "Arteriovenöse intrazerebrale Malformation",
      "Arteriovenöse zerebrale Fehlbildung"
    ]
  },
  {
    "code": "Q28.30",
    "name": "Angeborenes nichtrupturiertes Hirngefäßaneurysma",
    "synonyms": [
      "Angeborenes Aneurysma des Circulus arteriosus cerebri",
      "Angeborenes nichtrupturiertes Hirngefäßaneurysma",
      "Familiäres zerebrales sakkuläres Aneurysma",
      "Kongenitales Gehirnaneurysma",
      "Kongenitales zerebrales Aneurysma"
    ]
  },
  {
    "code": "Q28.31",
    "name": "Angeborene Fistel eines zerebralen Gefäßes",
    "synonyms": [
      "Angeborene Fistel eines zerebralen Gefäßes"
    ]
  },
  {
    "code": "Q28.38",
    "name": "Zerebrale Gefäßatresie a.n.k.",
    "synonyms": [
      "Angeborenes Fehlen einer Hirnarterie",
      "Angeborenes Fehlen einer Hirnvene",
      "Familiäres Kavernom des Zentralnervensystems",
      "Familiäres kavernöses Hämangiom des Gehirns",
      "Familiäres zerebrales Kavernom",
      "Gehirnarterienatresie a.n.k.",
      "Gehirnarterienhypoplasie",
      "Gehirnvenenhypoplasie",
      "Hereditäre zerebrale kavernöse Fehlbildung",
      "Hereditäres kavernöses Angiom",
      "Hereditäres zerebrales Kavernom",
      "Hirnarterienagenesie",
      "Hirnvenenagenesie",
      "Kongenitale Striktur einer Hirnarterie",
      "Zerebrale Gefäßatresie a.n.k."
    ]
  },
  {
    "code": "Q28.39",
    "name": "Angeborene Fehlbildung eines Hirngefäßes",
    "synonyms": [
      "Angeborene Fehlbildung eines Hirngefäßes",
      "Angeborene zerebrale Arteriendeformität",
      "Anomalie der Arteria cerebri",
      "Anomalie einer Gehirnarterie",
      "Anomalie einer Gehirnvene",
      "Gehirngefäßanomalie"
    ]
  },
  {
    "code": "Q28.80",
    "name": "Angeborenes Aneurysma a.n.k.",
    "synonyms": [
      "Angeborenes Aneurysma a.n.k."
    ]
  },
  {
    "code": "Q28.88",
    "name": "Arteriovenöse Malformation",
    "synonyms": [
      "Angeborene kardiovaskuläre Anomalie",
      "Arteriovenöse Malformation",
      "Generalisierte infantile Arterienkalzifikation",
      "Herzanomalien-Heterotaxie-Syndrom",
      "Idiopathische infantile arterielle Kalzifikation",
      "Infantile Arteriosklerose",
      "Infantile okklusive Arteriopathie",
      "PHACE-Syndrom [Posterior Fossa Malformation, Hemangioma, Arterial Anomalies, Coarctation of the Aorta, Cardiac Defects, Eye Anomalies]",
      "Pascual-Castroviejo-Syndrom Typ 2"
    ]
  },
  {
    "code": "Q28.9",
    "name": "Anomalie des Kreislaufsystems a.n.k.",
    "synonyms": [
      "Agenesie des Kreislaufsystems a.n.k.",
      "Angeborene Anomalie des Kreislaufsystems",
      "Angeborene Deformität des Herz-Kreislauf-Systems",
      "Angeborene Deformität des Kreislaufsystems",
      "Angeborene Deformität des kardiovaskulären Systems",
      "Anomalie des Kreislaufsystems a.n.k.",
      "Fehlbildung des Kreislaufsystems a.n.k.",
      "Kongenitale Kreislaufstörung",
      "Kongenitale kardiovaskuläre Krankheit",
      "Kongenitaler Kreislaufdefekt",
      "Kreislaufdefekt beim Neugeborenen"
    ]
  },
  {
    "code": "Q30.0",
    "name": "Choanalatresie",
    "synonyms": [
      "Angeborene Stenose der hinteren Nasenöffnungen",
      "Angeborene Stenose der vorderen Nasenöffnungen",
      "Atresie der hinteren Nasenöffnungen",
      "Atresie der vorderen Nasenöffnungen",
      "Beidseitige Choanalatresie",
      "Choanalatresie",
      "Choanalfusion",
      "Choanalstenose",
      "Einseitige Choanalatresie",
      "Fusion der Nasenlöcher",
      "Kongenitale Naseneingangsstenose",
      "Kongenitale Stenose der hinteren Nasenöffnungen",
      "Kongenitale Stenose der vorderen Nasenöffnungen",
      "Kongenitale Striktur der Nasenöffnungen",
      "Kongenitaler Nasenverschluss",
      "Nasenlochatresie"
    ]
  },
  {
    "code": "Q30.1",
    "name": "Nasenhypoplasie",
    "synonyms": [
      "Angeborenes Fehlen der Nase",
      "Arrhinie",
      "Nasenagenesie",
      "Nasenhypoplasie",
      "Unterentwicklung der Nase"
    ]
  },
  {
    "code": "Q30.2",
    "name": "Nasenfurche",
    "synonyms": [
      "Bifide Nase",
      "Kongenitale Kerbe der Nasenspitze",
      "Mangelhafter Nasenverschluss",
      "Naseneinkerbung",
      "Nasenfissur",
      "Nasenfurche",
      "Nasenspalte",
      "Nasenspaltung",
      "Spaltnase"
    ]
  },
  {
    "code": "Q30.3",
    "name": "Angeborene Perforation des Nasenseptums",
    "synonyms": [
      "Angeborene Perforation des Nasenseptums",
      "Kongenitaler mangelhafter Verschluss des Nasenseptums"
    ]
  },
  {
    "code": "Q30.8",
    "name": "Kongenitale knorpelige Schiefnase",
    "synonyms": [
      "Akzessorische Nase",
      "Angeborene Deformität der Nasennebenhöhlenwand",
      "Angeborene Nasenseptumdeformität",
      "Anomalie der Nasennebenhöhlenwand",
      "Doppelnase",
      "Familiäre Form des Syndroms der fehlenden Nasenzilien",
      "Glioma nasale",
      "Isolierte kongenitale Stenose der Apertura piriformis",
      "Kongenitale Lageanomalie der Nase",
      "Kongenitale Lageanomalie des Nasenseptums",
      "Kongenitale Perforation der Nasennebenhöhle",
      "Kongenitale knorpelige Schiefnase",
      "Kraniorhinie",
      "Nasales Gliom",
      "Nasenhöhlenatresie",
      "Nasenverdoppelung",
      "Nasenverformung",
      "Polyrhinie",
      "Proboscis lateralis",
      "Rhinodymie",
      "Überzähliges Nasenloch"
    ]
  },
  {
    "code": "Q30.9",
    "name": "Angeborene Nasenfehlbildung",
    "synonyms": [
      "Angeborene Anomalie des Nasenknochens",
      "Angeborene Nasendeformität",
      "Angeborene Nasenfehlbildung",
      "Anomalie des Nasenknorpels",
      "Anomalie des Nasenseptums"
    ]
  },
  {
    "code": "Q31.0",
    "name": "Kehlkopfsegel",
    "synonyms": [
      "Angeborene Larynxmembran",
      "Glottische Kehlkopfmembran",
      "Glottische Larynxmembran",
      "Glottisches Kehlkopfsegel",
      "Glottisches Larynxsegel",
      "Kehlkopfsegel",
      "Larynxsegel",
      "Subglottische Kehlkopfmembran",
      "Subglottische Larynxmembran",
      "Subglottisches Kehlkopfsegel",
      "Subglottisches Larynxsegel"
    ]
  },
  {
    "code": "Q31.1",
    "name": "Angeborene subglottische Stenose",
    "synonyms": [
      "Angeborene subglottische Kehlkopfstriktur",
      "Angeborene subglottische Stenose",
      "Kongenitale Subglottisstenose",
      "Kongenitale subglottische Larynxkonstriktion",
      "Kongenitale subglottische Larynxstriktur"
    ]
  },
  {
    "code": "Q31.2",
    "name": "Kehlkopfhypoplasie",
    "synonyms": [
      "Epiglottishypoplasie",
      "Glottishypoplasie",
      "Kehlkopfhypoplasie",
      "Larynxhypoplasie",
      "Ringknorpelhypoplasie",
      "Schildknorpelhypoplasie"
    ]
  },
  {
    "code": "Q31.3",
    "name": "Laryngozele",
    "synonyms": [
      "Angeborene Kehlkopfdilatation",
      "Angeborene Laryngozele",
      "Angeborene Larynxdilatation",
      "Kongenitale Laryngozele",
      "Laryngocele ventricularis",
      "Laryngozele",
      "Ventrikuläre Laryngozele"
    ]
  },
  {
    "code": "Q31.5",
    "name": "Angeborene Laryngomalazie",
    "synonyms": [
      "Angeborene Laryngomalazie"
    ]
  },
  {
    "code": "Q31.8",
    "name": "Schildknorpelspalte",
    "synonyms": [
      "Akzessorische Stimmbänder",
      "Angeborene Deformität der Cartilago cricoidea",
      "Angeborene Epiglottisdeformität",
      "Angeborene Epiglottisfissur",
      "Angeborene Kehlkopfdeformität",
      "Angeborene Kehlkopfstenose a.n.k.",
      "Angeborene Kehlkopfstriktur a.n.k.",
      "Angeborene Larynxdeformität",
      "Angeborene Ringknorpeldeformität",
      "Angeborene Schildknorpeldeformität",
      "Angeborenes Fehlen der Epiglottis",
      "Angeborenes Fehlen der Glottis",
      "Angeborenes Fehlen des Kehlkopfes",
      "Angeborenes Fehlen des Larynx",
      "Angeborenes Fehlen des Ringknorpels",
      "Angeborenes Fehlen des Schildknorpels",
      "Anomalie der Cartilago cricoidea",
      "Anomalie der Vallecula epiglottica",
      "Anomalie der aryepiglottischen Falte",
      "Epiglottisagenesie",
      "Epiglottisanomalie",
      "Epiglottisatresie",
      "Epiglottischondromalazie",
      "Glottisagenesie",
      "Glottisanomalie",
      "Glottisatresie",
      "Hintere Spalte des Ringknorpels",
      "Kehlkopfagenesie",
      "Kehlkopfatresie",
      "Knorpelerweichung der Epiglottis",
      "Kongenitale Epiglottisfissur",
      "Kongenitale Epiglottiszyste",
      "Kongenitale Lageanomalie der Epiglottis",
      "Kongenitale Lageanomalie der Glottis",
      "Kongenitale Lageanomalie des Larynx",
      "Kongenitale Lageanomalie des Schildknorpels",
      "Kongenitale Larynxfissur",
      "Kongenitale Larynxkonstriktion",
      "Kongenitale Larynxobstruktion",
      "Kongenitale Larynxstenose a.n.k.",
      "Kongenitale Larynxstriktur a.n.k.",
      "Kongenitale Larynxzyste",
      "Kongenitale Schildknorpelspalte",
      "Kongenitaler Larynxverschluss",
      "Laryngotracheale Spalte",
      "Larynxagenesie",
      "Larynxatresie",
      "Larynxchondromalazie",
      "Mangelhafter Glottisverschluss",
      "Mangelhafter Larynxverschluss",
      "Mangelhafter Ringknorpelverschluss",
      "Partielle laryngotracheale Spalte",
      "Ringknorpelagenesie des Kehlkopfes",
      "Ringknorpelagenesie des Larynx",
      "Ringknorpelanomalie",
      "Ringknorpelatresie",
      "Schildknorpelagenesie",
      "Schildknorpelanomalie",
      "Schildknorpelatresie",
      "Schildknorpelspalte",
      "Totale laryngotracheale Spalte",
      "Verlängerung des Epiglottisstiels"
    ]
  },
  {
    "code": "Q31.9",
    "name": "Angeborene Kehlkopffehlbildung",
    "synonyms": [
      "Angeborene Kehlkopffehlbildung",
      "Angeborene Larynxfehlbildung",
      "Anomalie der Kehlkopfmuskeln",
      "Anomalie der Larynxmuskeln"
    ]
  },
  {
    "code": "Q32.0",
    "name": "Angeborene Tracheomalazie",
    "synonyms": [
      "Angeborene Tracheomalazie",
      "Kongenitale Tracheomalazie"
    ]
  },
  {
    "code": "Q32.1",
    "name": "Angeborene Tracheozele",
    "synonyms": [
      "Angeborene Tracheadeformität",
      "Angeborene Tracheadilatation",
      "Angeborene Tracheafehlbildung",
      "Angeborene Tracheafistel",
      "Angeborene Tracheastenose",
      "Angeborene Tracheobronchomegalie",
      "Angeborene Tracheozele",
      "Angeborenes Fehlen des Luftröhrenknorpels",
      "Angeborenes Fehlen des Tracheaknorpels",
      "Anomalie des Tracheaknorpels",
      "Entwicklungsstillstand der Trachealringe",
      "Kongenitale Lageanomalie der Trachea",
      "Kongenitale Luftröhrendilatation",
      "Kongenitale Tracheadilatation",
      "Kongenitale Tracheastenose",
      "Kongenitale Tracheastriktur",
      "Kongenitale Tracheaverlagerung",
      "Kongenitale Tracheozele",
      "Luftröhrenagenesie",
      "Luftröhrenanomalie",
      "Luftröhrenatresie",
      "Mangelhafter Tracheaverschluss",
      "Mounier-Kuhn-Syndrom",
      "Tracheaagenesie",
      "Tracheaanomalie",
      "Tracheaatresie",
      "Tracheadivertikel",
      "Tracheafehlbildung",
      "Tracheafistel",
      "Tracheaspaltung",
      "Verformung des Tracheaknorpels",
      "Wachstumsstillstand der Trachealringe"
    ]
  },
  {
    "code": "Q32.2",
    "name": "Angeborene Bronchomalazie",
    "synonyms": [
      "Angeborene Bronchomalazie",
      "Williams-Campbell-Syndrom"
    ]
  },
  {
    "code": "Q32.3",
    "name": "Angeborene Bronchusstenose",
    "synonyms": [
      "Angeborene Bronchusstenose",
      "Angeborene Bronchusstriktur"
    ]
  },
  {
    "code": "Q32.4",
    "name": "Bronchusagenesie",
    "synonyms": [
      "Angeborene Bronchusdeformität",
      "Angeborene Bronchusfehlbildung",
      "Angeborenes Bronchusdivertikel",
      "Angeborenes Fehlen eines Bronchus",
      "Blind endender Bronchus",
      "Bridging-Bronchus",
      "Bronchusagenesie",
      "Bronchusanomalie",
      "Bronchusaplasie",
      "Bronchusatresie",
      "Bronchushypoplasie",
      "Kongenitale Lageanomalie eines Bronchus",
      "Kongenitales Bronchusdivertikel",
      "Nicht-syndromale angeborene Bronchialatresie",
      "Rudimentärer Trachealbronchus",
      "Taschenbildung eines Bronchus",
      "Unvollständige Bronchialbaumentwicklung"
    ]
  },
  {
    "code": "Q33.0",
    "name": "Angeborene Zystenlunge",
    "synonyms": [
      "Angeborene Wabenlunge",
      "Angeborene Zystenlunge",
      "Angeborene polyzystische Lunge",
      "Angeborene polyzystische Lungenkrankheit",
      "Angeborene zystische Lungenkrankheit",
      "CCAM [Kongenitale zystische adenomatoide Fehlbildung der Lunge]",
      "Kongenitale Wabenlunge",
      "Kongenitale bronchogene Zyste",
      "Kongenitale zystische Krankheit der Lunge",
      "Kongenitale zystische adenomatoide Fehlbildung der Lunge",
      "Kongenitale zystische adenomatoide Fehlbildung der Lunge Typ 0",
      "Kongenitale zystische adenomatoide Fehlbildung der Lunge Typ 1",
      "Kongenitale zystische adenomatoide Fehlbildung der Lunge Typ 2",
      "Kongenitale zystische adenomatoide Fehlbildung der Lunge Typ 3",
      "Kongenitale zystische adenomatoide Fehlbildung der Lunge Typ 4"
    ]
  },
  {
    "code": "Q33.1",
    "name": "Nebenlunge",
    "synonyms": [
      "Akzessorischer Lungenlappen",
      "Lobus venae azygos",
      "Lungendystopie",
      "Nebenlunge"
    ]
  },
  {
    "code": "Q33.2",
    "name": "Lungensequestration",
    "synonyms": [
      "Angeborene Lungensequestration",
      "Angeborene extralobäre Lungensequestration",
      "Angeborene intralobäre Lungensequestration",
      "Kongenitale Lungensequestration",
      "Lungensequestration"
    ]
  },
  {
    "code": "Q33.3",
    "name": "Lungenagenesie",
    "synonyms": [
      "Agenesie der Lunge",
      "Angeborenes Fehlen der Lunge",
      "Angeborenes Fehlen eines Lungenlappens",
      "Lungenagenesie"
    ]
  },
  {
    "code": "Q33.4",
    "name": "Angeborene Bronchiektasie",
    "synonyms": [
      "Angeborene Bronchiektasie",
      "Kongenitale Bronchiektasie"
    ]
  },
  {
    "code": "Q33.5",
    "name": "Angeborenes ektopisches Gewebe der Lunge",
    "synonyms": [
      "Angeborenes ektopisches Gewebe der Lunge",
      "Ektopischer Knochen in der Lunge",
      "Ektopischer Knorpel in der Lunge"
    ]
  },
  {
    "code": "Q33.6",
    "name": "Lungendysplasie",
    "synonyms": [
      "Angeborene Lungendysplasie",
      "Kongenitale unilaterale pulmonale Hypoplasie",
      "Lungendysplasie",
      "Lungenhypoplasie",
      "Lungenunterentwicklung",
      "Pulmonale Hypoplasie",
      "Unvollkommene kongenitale Lungenentwicklung (nicht verbunden mit kurzer Schwangerschaftsdauer)",
      "Unzureichende Lungenentwicklung"
    ]
  },
  {
    "code": "Q33.8",
    "name": "Kongenitale zystische pulmonale Lymphangiektasie",
    "synonyms": [
      "Angeborene Lungendegeneration",
      "Kongenitale Lageanomalie der Lunge",
      "Kongenitale Lageanomalie eines Lungenlappens",
      "Kongenitale pulmonale Lymphangiektasie",
      "Kongenitale zystische pulmonale Lymphangiektasie",
      "Kongenitales lobäres Emphysem",
      "Lungenaplasie",
      "Lungenlappenfusion",
      "Pulmonale Lymphangiomatose"
    ]
  },
  {
    "code": "Q33.9",
    "name": "Angeborene Lungenfehlbildung",
    "synonyms": [
      "Angeborene Lungenanomalie",
      "Angeborene Lungendeformität",
      "Angeborene Lungenfehlbildung",
      "Lungenfehlbildung",
      "Lungenmissbildung",
      "Pulmonale Anomalie"
    ]
  },
  {
    "code": "Q34.0",
    "name": "Angeborene Pleuraanomalie",
    "synonyms": [
      "Abnormität der Pleura",
      "Angeborene Deformität der Pleurafalten",
      "Angeborene Pleuraanomalie"
    ]
  },
  {
    "code": "Q34.1",
    "name": "Angeborene Mediastinalzyste",
    "synonyms": [
      "Angeborene Mediastinalzyste"
    ]
  },
  {
    "code": "Q34.8",
    "name": "Primäre ziliare Dyskinesie [PCD] [Angeborene bronchiale Ziliendyskinesie]",
    "synonyms": [
      "Agenesie der Atmungsorgane a.n.k.",
      "Akzessorische Atmungsorgane a.n.k.",
      "Angeborene Verbindung zwischen Perikardialsack und Pleurasack",
      "Angeborene laryngotracheale Fistel",
      "Doppelte Atmungsorgane a.n.k.",
      "Dyskinetisches Ziliensyndrom",
      "Fusion von Larynx und Trachea",
      "Hypoplasie der Atmungsorgane a.n.k.",
      "Kongenitale Lageanomalie der Atmungsorgane",
      "Kongenitale Lageanomalie des Atmungssystems a.n.k.",
      "Kongenitale Obstruktion der oberen Atemwege",
      "Laryngo-tracheo-ösophageale Spalte",
      "Laryngo-tracheo-ösophageale Spalte Typ 0",
      "Laryngo-tracheo-ösophageale Spalte Typ 1",
      "Laryngo-tracheo-ösophageale Spalte Typ 2",
      "Laryngo-tracheo-ösophageale Spalte Typ 3",
      "Laryngo-tracheo-ösophageale Spalte Typ 4",
      "Nasopharynxatresie",
      "Primäre ziliare Dyskinesie [PCD] [Angeborene bronchiale Ziliendyskinesie]",
      "Syndrom der immotilen Zilien",
      "Unvollständige Entwicklung des Respirationstraktes"
    ]
  },
  {
    "code": "Q34.9",
    "name": "Anomalie der Atmungsorgane",
    "synonyms": [
      "Angeborene Anomalie der Atmungsorgane",
      "Angeborene Deformität des Atmungssystems",
      "Angeborenes Fehlen der Atmungsorgane",
      "Anomalie der Atmungsorgane",
      "Fehlbildung der Atmungsorgane",
      "Kongenitaler Defekt der Atmungsorgane"
    ]
  },
  {
    "code": "Q35.1",
    "name": "Spalte des harten Gaumens",
    "synonyms": [
      "Angeborene Gaumendachperforation",
      "Spaltbildung des harten Gaumens",
      "Spalte des harten Gaumens"
    ]
  },
  {
    "code": "Q35.3",
    "name": "Spalte des weichen Gaumens",
    "synonyms": [
      "Gaumensegelspalte",
      "Mediane Gaumensegelspalte",
      "Perforation des weichen Gaumens",
      "Spalte des weichen Gaumens",
      "Velumspalte"
    ]
  },
  {
    "code": "Q35.5",
    "name": "Spalte des harten und weichen Gaumens",
    "synonyms": [
      "Mediane Gaumen- und Gaumensegelspalte",
      "Mediane beidseitige Gaumen- und Gaumensegelspalte",
      "Spalte des harten und weichen Gaumens",
      "Spaltfehlbildung des harten und weichen Gaumens"
    ]
  },
  {
    "code": "Q35.7",
    "name": "Uvulaspalte",
    "synonyms": [
      "Mangelhafter Uvulaverschluss",
      "Uvula bifida",
      "Uvulaspalte",
      "Uvulaspaltfehlbildung",
      "Uvulaspaltung",
      "Zweigeteiltes Gaumenzäpfchen"
    ]
  },
  {
    "code": "Q35.9",
    "name": "Gaumenspalte",
    "synonyms": [
      "Angeborene Gaumenperforation",
      "Angeborene Gaumenspalte",
      "Gaumenfissur",
      "Gaumenspalte",
      "Kongenitale Gaumenfissur",
      "Mangelhafter Gaumenverschluss",
      "Oronasale Fistel",
      "Palatoschisis",
      "Submuköse Gaumenspalte",
      "Uranoschisis"
    ]
  },
  {
    "code": "Q36.0",
    "name": "Beidseitige Lippenspalte",
    "synonyms": [
      "Beidseitige Lippenspalte",
      "Beidseitige Lippenspaltfehlbildung"
    ]
  },
  {
    "code": "Q36.1",
    "name": "Mediane Lippenspalte",
    "synonyms": [
      "Familiäre mediane Spalte der Ober- und Unterlippe",
      "Mediane Lippenspalte",
      "Mediane Unterlippenspalte"
    ]
  },
  {
    "code": "Q36.9",
    "name": "Lippenspalte",
    "synonyms": [
      "Angeborene Lippenfissur",
      "Cheiloschisis",
      "Einseitige Lippenspalte",
      "Isolierte Lippenspalte",
      "Lippenspalte",
      "Lippenspaltfehlbildung",
      "Mangelhafter Lippenverschluss",
      "Oberlippenspalte",
      "Unterlippenspalte"
    ]
  },
  {
    "code": "Q37.0",
    "name": "Spalte des harten Gaumens mit beidseitiger Lippenspalte",
    "synonyms": [
      "Beidseitige Lippen-Kieferspalte",
      "Spalte des harten Gaumens mit beidseitiger Lippenspalte"
    ]
  },
  {
    "code": "Q37.1",
    "name": "Spalte des harten Gaumens mit einseitiger Lippenspalte",
    "synonyms": [
      "Cheilognathoschisis",
      "Diastematognathie",
      "Einseitige Lippen-Kieferspalte",
      "Gnathoschisis",
      "Kieferspalte",
      "Lippen-Kieferspalte",
      "Spalte des harten Gaumens mit Lippenspalte",
      "Spalte des harten Gaumens mit einseitiger Lippenspalte"
    ]
  },
  {
    "code": "Q37.2",
    "name": "Spalte des weichen Gaumens mit beidseitiger Lippenspalte",
    "synonyms": [
      "Spalte des weichen Gaumens mit beidseitiger Lippenspalte",
      "Spaltfehlbildung des weichen Gaumens mit beidseitiger Lippenspalte"
    ]
  },
  {
    "code": "Q37.3",
    "name": "Spalte des weichen Gaumens mit einseitiger Lippenspalte",
    "synonyms": [
      "Spalte des weichen Gaumens mit Lippenspalte",
      "Spalte des weichen Gaumens mit einseitiger Lippenspalte",
      "Spaltfehlbildung des weichen Gaumens mit einseitiger Lippenspalte"
    ]
  },
  {
    "code": "Q37.4",
    "name": "Spalte des harten und weichen Gaumens mit beidseitiger Lippenspalte",
    "synonyms": [
      "Beidseitige Lippen-Kiefer-Gaumen-Spalte",
      "Beidseitige Lippenspalte mit Spalte des alveolären Anteils",
      "Spalte des harten und weichen Gaumens mit beidseitiger Lippenspalte"
    ]
  },
  {
    "code": "Q37.5",
    "name": "Spalte des harten und weichen Gaumens mit einseitiger Lippenspalte",
    "synonyms": [
      "Cheilognathopalatoschisis",
      "Einseitige Lippen-Kiefer-Gaumen-Spalte",
      "Einseitige Lippen-Kiefer-Gaumen-Spaltfehlbildung",
      "Einseitige Lippenspalte mit Spalte des alveolären Anteils",
      "Gnathopalatoschisis",
      "Kiefer-Gaumen-Spalte",
      "Lippen-Kiefer-Gaumen-Spalte",
      "Lippenspalte mit Spalte des alveolären Anteils",
      "Mediane Spalte der Oberlippe und des Oberkiefers",
      "Spalte des harten und weichen Gaumens mit Lippenspalte",
      "Spalte des harten und weichen Gaumens mit einseitiger Lippenspalte"
    ]
  },
  {
    "code": "Q37.8",
    "name": "Gaumenspalte mit beidseitiger Lippenspalte",
    "synonyms": [
      "Gaumenspalte mit beidseitiger Lippenspalte",
      "Spaltfehlbildung des Gaumens mit beidseitiger Lippenspaltfehlbildung"
    ]
  },
  {
    "code": "Q37.9",
    "name": "Lippen-Gaumen-Spalte",
    "synonyms": [
      "Gaumenspalte mit Lippenspalte",
      "Gaumenspalte mit einseitiger Lippenspalte",
      "Gaumenspaltfehlbildung mit einseitiger Lippenspaltfehlbildung",
      "Lippen-Gaumen-Spalte"
    ]
  },
  {
    "code": "Q38.0",
    "name": "Lippenagenesie",
    "synonyms": [
      "Angeborene Lippendeformität a.n.k.",
      "Angeborene Lippenfehlbildung",
      "Angeborene Lippenfistel",
      "Angeborenes Lippenektropion",
      "Angeborenes Lippenektropium",
      "Angeborenes medianes Knötchen der Oberlippe",
      "Kommissurale Lippenfistel",
      "Kongenitale Lippenfistel",
      "Lippenagenesie",
      "Lippenanomalie",
      "Unterlippenfistel",
      "Van-der-Woude-Syndrom"
    ]
  },
  {
    "code": "Q38.1",
    "name": "Ankyloglosson",
    "synonyms": [
      "Angeborenes verkürztes Frenulum linguae",
      "Ankyloglossie",
      "Ankyloglosson",
      "Ankyloglossum-superius-Syndrom",
      "Frenulumverkürzung",
      "Verkürztes Zungenbändchen",
      "Verkürzung des Zungenbändchens"
    ]
  },
  {
    "code": "Q38.2",
    "name": "Makroglossie",
    "synonyms": [
      "Kongenitale Makroglossie",
      "Kongenitale Zungenhypertrophie",
      "Lingua hypertrophica",
      "Makroglossie"
    ]
  },
  {
    "code": "Q38.3",
    "name": "Aglossie",
    "synonyms": [
      "Aglossie",
      "Akzessorische Zunge",
      "Angeborene Abwärtsverlagerung der Zunge",
      "Angeborene Adhäsion der Zunge am Zahnfleisch",
      "Angeborene Zungenadhäsion",
      "Angeborene Zungenanomalie",
      "Angeborene Zungendeformität",
      "Angeborene Zungenfehlbildung",
      "Angeborene Zungenfissur",
      "Angeborenes Fehlen der Zunge",
      "Diastematoglossie",
      "Doppelte Zunge",
      "Dreigeteilte Zunge",
      "Glossoschisis",
      "Hypoglossie",
      "Isolierte kongenitale Aglossie",
      "Isolierte kongenitale Hypoglossie",
      "Kongenitale Aglossie",
      "Kongenitale Faltenzunge",
      "Kongenitale Lageanomalie der Zunge",
      "Kongenitale Lingua plicata",
      "Kongenitale Lingua scrotalis",
      "Kongenitale Mikroglossie",
      "Kongenitale Skrotalzunge",
      "Kongenitale Zungenadhäsion",
      "Kongenitale Zungenfurche",
      "Kongenitale Zungenzyste",
      "Lingua bifida",
      "Mikroglossie",
      "Spaltzunge",
      "Zungenagenesie",
      "Zungenhypoplasie",
      "Zungenspaltung",
      "Zungenverformung",
      "Zystische Duplikatur der Zunge"
    ]
  },
  {
    "code": "Q38.4",
    "name": "Akzessorische Speicheldrüse",
    "synonyms": [
      "Agenesie der Unterkieferdrüse",
      "Akzessorische Ohrspeicheldrüse",
      "Akzessorische Parotis",
      "Akzessorische Speicheldrüse",
      "Akzessorische Unterkieferdrüse",
      "Akzessorischer Parotisgang",
      "Akzessorischer Speicheldrüsengang",
      "Angeborene Deformität der Unterkieferdrüse",
      "Angeborene Deformität des Speicheldrüsenganges",
      "Angeborene Ohrspeicheldrüsendeformität",
      "Angeborene Parotisdeformität",
      "Angeborene Speicheldrüsendeformität",
      "Angeborene Speicheldrüsenfistel",
      "Angeborene Stenose des Ductus sublingualis",
      "Angeborene Verlagerung einer Speicheldrüse",
      "Angeborenes Fehlen der Speicheldrüse",
      "Anomalie der Ohrspeicheldrüse",
      "Anomalie der Unterkieferdrüse",
      "Anomalie des Ductus parotideus",
      "Anomalie des Ductus sublingualis major",
      "Anomalie des Speicheldrüsenganges",
      "Atresie des Ductus parotideus",
      "Atresie des Ductus sublingualis",
      "Atresie des Ductus submandibularis",
      "Atresie des Speicheldrüsenganges",
      "Doppelter Speicheldrüsengang",
      "Fehlen des Speicheldrüsenganges",
      "Fusion des Ductus sublingualis und Ductus submandibularis",
      "Hypoplasie der Ohrspeicheldrüse",
      "Kongenitale Fistel der Glandula sublingualis",
      "Kongenitale Froschgeschwulst",
      "Kongenitale Hypertrophie der Unterzungendrüse",
      "Kongenitale Ranula",
      "Kongenitale Speicheldrüsenfistel",
      "Kongenitale Speicheldrüsenhypertrophie",
      "Kongenitale Speicheldrüsenzyste",
      "Kongenitale Unterkieferdrüsenfistel",
      "Kongenitale Verlagerung der Unterzungendrüse",
      "Kongenitale Verlagerung des Unterzungendrüsenganges",
      "Kongenitaler Stein des Ductus sublingualis",
      "Parotisagenesie",
      "Parotisanomalie",
      "Parotishypoplasie",
      "Speicheldrüsenagenesie",
      "Speicheldrüsenatresie",
      "Verlagerung der Öffnung des Wharton-Ganges"
    ]
  },
  {
    "code": "Q38.5",
    "name": "Fehlen der Uvula",
    "synonyms": [
      "Angeborene Fehlbildung des weichen Gaumens",
      "Angeborene Gaumendeformität",
      "Angeborene Gaumenfehlbildung",
      "Angeborene Gaumenverkürzung",
      "Angeborene Uvuladeformität",
      "Angeborene Uvulaverkürzung",
      "Angeborener hoher Gaumen",
      "Angeborener hoher Gaumenbogen",
      "Angeborenes Fehlen der Uvula",
      "Angeborenes Fehlen des Zäpfchens",
      "Anomalie des harten Gaumens a.n.k.",
      "Anomalie des weichen Gaumens a.n.k.",
      "Fehlen der Uvula",
      "Gaumenanomalie a.n.k.",
      "Uvulaagenesie",
      "Uvulaanomalie"
    ]
  },
  {
    "code": "Q38.6",
    "name": "Angeborene Mundfehlbildung",
    "synonyms": [
      "Angeborene Aberration der Mundschleimhaut",
      "Angeborene Aberration der Talgdrüsen des Mundes",
      "Angeborene Mundanomalie",
      "Angeborene Mundfehlbildung",
      "Angeborene Zahnfleischanomalie",
      "Fordyce-Krankheit",
      "Kongenitale Alveolarfortsatzaplasie",
      "Naevus spongiosus albus mucosae",
      "Nävus der Mundschleimhaut",
      "Versprengtes Gewebe der Ohrspeicheldrüse in Halsstrukturen",
      "Versprengtes Gewebe der Ohrspeicheldrüse in Lymphknoten",
      "Versprengtes Gewebe der Unterkieferdrüse in Faszie",
      "Versprengtes Gewebe der Unterkieferdrüse in Halsmuskulatur",
      "Versprengtes Gewebe der Unterkieferdrüse in Lymphknoten",
      "Versprengtes Parotisgewebe in Halsstrukturen",
      "Versprengtes Parotisgewebe in Lymphknoten",
      "Weißer Schleimhautnävus",
      "Weißer Schwamm - s.a. Nävus der Mundschleimhaut",
      "X-chromosomale Gaumenspalte mit Ankyloglossie",
      "Zahnfleischfehlbildung"
    ]
  },
  {
    "code": "Q38.7",
    "name": "Hypopharynxdivertikel",
    "synonyms": [
      "Hypopharynxdivertikel",
      "Kongenitales Pharynxdivertikel",
      "Pharynxdivertikel",
      "Rachendivertikel",
      "Taschenbildung des Hypopharynx",
      "Taschenbildung des Pharynx",
      "Taschenbildung des Schlundes",
      "Ösophagopharyngeales Grenzdivertikel"
    ]
  },
  {
    "code": "Q38.8",
    "name": "Rachenmissbildung",
    "synonyms": [
      "Angeborene Pharynxdeformität",
      "Angeborene Rachenfehlbildung",
      "Angeborene velopharyngeale Inkompetenz",
      "Pharynxanomalie",
      "Pharynximperforation",
      "Rachenanomalie",
      "Rachenfehlbildung",
      "Rachenmissbildung"
    ]
  },
  {
    "code": "Q39.0",
    "name": "Ösophagusatresie ohne Fistel",
    "synonyms": [
      "Angeborener undurchgängiger Ösophagus",
      "Angeborener undurchgängiger Ösophagus ohne Fistel",
      "Speiseröhrenatresie",
      "Speiseröhrenatresie ohne Fistel",
      "Ösophagusatresie",
      "Ösophagusatresie Typ 1 nach Vogt",
      "Ösophagusatresie Typ 2 nach Vogt",
      "Ösophagusatresie ohne Fistel",
      "Ösophagusimperforation"
    ]
  },
  {
    "code": "Q39.1",
    "name": "Ösophagusatresie mit Ösophagotrachealfistel",
    "synonyms": [
      "Speiseröhrenatresie mit Ösophagotrachealfistel",
      "Undurchgängiger Ösophagus mit Ösophagotrachealfistel",
      "Ösophagusatresie Typ 3a nach Vogt",
      "Ösophagusatresie Typ 3b nach Vogt",
      "Ösophagusatresie Typ 3c nach Vogt",
      "Ösophagusatresie mit Ösophagobronchialfistel",
      "Ösophagusatresie mit Ösophagotrachealfistel",
      "Ösophagusimperforation mit Ösophagotrachealfistel"
    ]
  },
  {
    "code": "Q39.2",
    "name": "Angeborene Ösophagotrachealfistel ohne Atresie",
    "synonyms": [
      "Angeborene Ösophagotrachealfistel",
      "Angeborene Ösophagotrachealfistel ohne Atresie",
      "Angeborene ösophagotracheale H-Fistel ohne Atresie Typ 4 nach Vogt",
      "Isolierte Tracheoösophagealfistel",
      "Isolierte angeborene Tracheoösophagealfistel",
      "Kongenitale Tracheoösophagealfistel",
      "Kongenitale Ösophagobronchialfistel",
      "Kongenitale Ösophagotrachealfistel",
      "Kongenitale Ösophagusfistel"
    ]
  },
  {
    "code": "Q39.3",
    "name": "Kongenitale Ösophagusstenose",
    "synonyms": [
      "Kongenitale Ösophagusstenose",
      "Kongenitale Ösophagusstriktur"
    ]
  },
  {
    "code": "Q39.4",
    "name": "Membranöse Speiseröhre",
    "synonyms": [
      "Angeborene Ösophagusmembran",
      "Membranöse Speiseröhre"
    ]
  },
  {
    "code": "Q39.5",
    "name": "Angeborene Ösophagusdilatation",
    "synonyms": [
      "Angeborene Achalasie",
      "Angeborene Ösophagusdilatation",
      "Angeborener Kardiospasmus mit Megaösophagus",
      "Kongenitale Ösophagusdilatation",
      "Kongenitaler Megaösophagus",
      "Kongenitaler Riesenösophagus"
    ]
  },
  {
    "code": "Q39.6",
    "name": "Kongenitales Ösophagusdivertikel",
    "synonyms": [
      "Angeborene Taschenbildung des Ösophagus",
      "Angeborenes pharyngoösophageales Divertikel",
      "Kongenitales Ösophagusdivertikel",
      "Speiseröhrendivertikel",
      "Taschenbildung des Ösophagus",
      "Ösophagusdivertikel"
    ]
  },
  {
    "code": "Q39.8",
    "name": "Duplikatur des Ösophagus",
    "synonyms": [
      "Akzessorische Speiseröhre",
      "Akzessorischer Ösophagus",
      "Angeborene Verlagerung der Ösophagusschleimhaut in die Kardia",
      "Angeborene Ösophagushypoplasie",
      "Angeborene Ösophagusverlagerung",
      "Angeborenes Fehlen der Speiseröhre",
      "Angeborenes Fehlen des Ösophagus",
      "Doppelter Ösophagus",
      "Duplikationszyste des Ösophagus",
      "Duplikatur des Ösophagus",
      "Fusion von Trachea und Ösophagus",
      "Kongenitale Verkürzung des Ösophagus",
      "Kongenitale Ösophagusverlagerung",
      "Kongenitale Ösophaguszyste",
      "Tubuläre Duplikation des Ösophagus",
      "Ösophagusagenesie"
    ]
  },
  {
    "code": "Q39.9",
    "name": "Angeborene Ösophagusfehlbildung",
    "synonyms": [
      "Angeborene Ösophagusdeformität",
      "Angeborene Ösophagusfehlbildung",
      "Kongenitaler Ösophagusdefekt",
      "Speiseröhrenanomalie",
      "Ösophagusanomalie"
    ]
  },
  {
    "code": "Q40.0",
    "name": "Angeborene hypertrophische Pylorusstenose",
    "synonyms": [
      "Angeborene Pylorushypertrophie",
      "Angeborene Pyloruskonstriktion",
      "Angeborene Pylorusstenose",
      "Angeborene Pylorusstriktur",
      "Angeborene hypertrophische Pylorusstenose",
      "Angeborener Pylorospasmus",
      "Infantile Pylorushypertrophie",
      "Infantile Pyloruskonstriktion",
      "Infantile Pylorusobstruktion",
      "Infantile Pylorusstenose",
      "Infantile Pylorusstriktur",
      "Infantiler Pylorospasmus",
      "Kongenitale Pyloruskonstriktion",
      "Kongenitale Pylorusobstruktion",
      "Kongenitale Pylorusstenose",
      "Kongenitale Pylorusstriktur",
      "Kongenitale hypertrophische Pylorusstenose",
      "Pylorospasmus beim Säugling",
      "Pylorusachalasie",
      "Pyloruskonstriktion im Säuglingsalter",
      "Pylorusstriktur beim Säugling"
    ]
  },
  {
    "code": "Q40.1",
    "name": "Angeborene Hiatushernie",
    "synonyms": [
      "Angeborene Hiatushernie",
      "Kongenitale Hernia paraoesophagealis",
      "Verlagerung der Kardia durch den Hiatus oesophageus"
    ]
  },
  {
    "code": "Q40.2",
    "name": "Angeborene Megalogastrie",
    "synonyms": [
      "Akzessorischer Magen",
      "Angeborene Magendilatation",
      "Angeborene Magenschleimhautverlagerung",
      "Angeborene Magenverlagerung",
      "Angeborene Megalogastrie",
      "Angeborener Kardiospasmus ohne Megaösophagus",
      "Angeborener Sanduhrmagen",
      "Angeborenes Fehlen des Magens",
      "Angeborenes Magendivertikel",
      "Doppelter Magen",
      "Ektopie der Magenschleimhaut",
      "Kongenitale Magenobstruktion",
      "Kongenitale Magenstriktur",
      "Kongenitale Mikrogastrie",
      "Kongenitale Sanduhrkontraktur des Magens",
      "Kongenitale gastrokolische Fistel",
      "Kongenitaler Sanduhrmagen",
      "Magenagenesie",
      "Magenduplikatur",
      "Magentransposition",
      "Mikrogastrie"
    ]
  },
  {
    "code": "Q40.3",
    "name": "Magenanomalie",
    "synonyms": [
      "Angeborene Magendeformität",
      "Angeborene Pylorusdeformität",
      "Magenanomalie",
      "Pylorusanomalie"
    ]
  },
  {
    "code": "Q40.8",
    "name": "Pylorusatresie",
    "synonyms": [
      "Agenesie der oberen Verdauungsorgane",
      "Angeborenes Fehlen des oberen Verdauungstraktes",
      "Atresie der oberen Verdauungsorgane a.n.k.",
      "Hypoplasie der oberen Verdauungsorgane",
      "Kongenitale Lageanomalie der oberen Verdauungsorgane",
      "Pylorusatresie"
    ]
  },
  {
    "code": "Q40.9",
    "name": "Angeborene Anomalie des oberen Verdauungstraktes a.n.k.",
    "synonyms": [
      "Angeborene Anomalie des oberen Verdauungstraktes a.n.k.",
      "Angeborene Deformität des oberen Verdauungstraktes"
    ]
  },
  {
    "code": "Q41.0",
    "name": "Duodenalatresie",
    "synonyms": [
      "Angeborenes Fehlen des Duodenums",
      "Atresia duodeni",
      "Duodenalagenesie",
      "Duodenalatresie",
      "Duodenalatresie Typ 1",
      "Duodenalatresie Typ 2",
      "Duodenalatresie Typ 3",
      "Kongenitale Duodenalstenose",
      "Kongenitale Duodenalstriktur",
      "Zwölffingerdarmatresie"
    ]
  },
  {
    "code": "Q41.1",
    "name": "Angeborenes Fehlen des Jejunums",
    "synonyms": [
      "Angeborene Jejunumstenose",
      "Angeborene Jejunumstriktur",
      "Angeborenes Fehlen des Jejunums",
      "Apfelschalen-Syndrom",
      "Apfelschalen-Syndrom des Jejunums",
      "Apple-peel-Syndrom",
      "Apple-peel-Syndrom des Jejunums",
      "Hereditäre Jejunalatresie",
      "Jejunalatresie",
      "Jejunalatresie Typ I",
      "Jejunalatresie Typ II",
      "Jejunalatresie Typ IIIa",
      "Jejunalatresie Typ IIIb",
      "Jejunalatresie Typ IV",
      "Jejunum imperforatum",
      "Jejunumagenesie",
      "Jejunumatresie",
      "Jejunumimperforation"
    ]
  },
  {
    "code": "Q41.2",
    "name": "Ileumatresie",
    "synonyms": [
      "Angeborene Ileumstenose",
      "Angeborene Ileumstriktur",
      "Angeborenes Fehlen des Ileums",
      "Ileumagenesie",
      "Ileumatresie",
      "Ileumatresie Typ I",
      "Ileumatresie Typ II",
      "Ileumatresie Typ IIIa",
      "Ileumatresie Typ IIIb",
      "Ileumatresie Typ IV"
    ]
  },
  {
    "code": "Q41.9",
    "name": "Darmatresie",
    "synonyms": [
      "Angeborene Darmatresie",
      "Angeborene Darmobstruktion",
      "Angeborene Darmokklusion",
      "Angeborene Darmstenose",
      "Angeborene Darmstriktur",
      "Angeborene Dünndarmobstruktion",
      "Angeborene Dünndarmokklusion",
      "Angeborene Dünndarmstenose",
      "Angeborene Dünndarmstriktur",
      "Angeborener Darmverschluss",
      "Angeborener Dünndarmverschluss",
      "Angeborenes Fehlen des Darmes",
      "Darmagenesie",
      "Darmatresie",
      "Darmhypoplasie",
      "Dünndarmagenesie",
      "Dünndarmatresie",
      "Dünndarmhypoplasie",
      "Intestinalatresie",
      "Kongenitales Kurzdarm-Syndrom",
      "Undurchgängiger Darm",
      "Undurchgängiger Dünndarm"
    ]
  },
  {
    "code": "Q42.0",
    "name": "Mastdarmatresie mit Fistel",
    "synonyms": [
      "Angeborene Rektumatresie mit Fistel",
      "Angeborene rektokutane Fistel mit Rektumstenose",
      "Fehlen des Rektums mit Fistel",
      "Kongenitale Rektumstriktur mit Fistel",
      "Kongenitale rektale Fistel mit Rektumstenose",
      "Kongenitales undurchgängiges Rektum mit Fistel",
      "Mastdarmagenesie mit Fistel",
      "Mastdarmatresie mit Fistel",
      "Rektale Fistel mit Fehlen des Rektums",
      "Rektale Fistel mit Rektumatresie",
      "Rektokutane Fistel mit Fehlen des Rektums",
      "Rektokutane Fistel mit Rektumatresie",
      "Rektumagenesie mit Fistel",
      "Rektumatresie mit Fistel",
      "Rektumhypoplasie mit Fistel",
      "Rektumimperforation mit Fistel"
    ]
  },
  {
    "code": "Q42.1",
    "name": "Rektumatresie",
    "synonyms": [
      "Angeborene Rektumatresie",
      "Angeborene Rektumatresie ohne Fistel",
      "Angeborene Rektumstenose",
      "Angeborene Rektumstenose ohne Fistel",
      "Angeborenes Fehlen des Rektums",
      "Angeborenes Fehlen des Rektums ohne Fistel",
      "Kongenitale Striktur des Rektumsphinkters",
      "Mastdarmagenesie",
      "Mastdarmatresie",
      "Rectum imperforatum",
      "Rektumagenesie",
      "Rektumatresie",
      "Rektumhypoplasie",
      "Rektumimperforation",
      "Undurchgängiges Rektum"
    ]
  },
  {
    "code": "Q42.2",
    "name": "Anusatresie mit Fistel",
    "synonyms": [
      "Analseptum mit Fistel",
      "Angeborene Anusatresie mit rektobulbärer Fistel",
      "Angeborene Anusatresie mit rektoprostatischer Fistel",
      "Angeborene Anusatresie mit rektourethraler Fistel",
      "Angeborene Anusatresie mit rektovesikaler Fistel",
      "Anusagenesie mit Fistel",
      "Anusatresie mit Fistel",
      "Anushypoplasie mit Fistel",
      "Anusimperforation mit Fistel",
      "Fehlen des Anus mit Fistel",
      "Hypoplasie des Analkanals mit Fistel",
      "Kongenitale Anusstenose mit Fistel",
      "Kongenitale Anusstriktur mit Fistel",
      "Kongenitaler Anusverschluss mit Fistel",
      "Kongenitaler undurchgängiger Anus mit Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit H-Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit perinealer Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit rektobulbärer Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit rektoprostatischer Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit rektourethraler Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit rektovaginaler Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit rektovesikaler Fistel",
      "Nicht-syndromale anorektale Malformation (Anusatresie) mit rektovestibulärer Fistel",
      "Persistierende Analmembran mit Fistel"
    ]
  },
  {
    "code": "Q42.3",
    "name": "Analatresie",
    "synonyms": [
      "Agenesie des Analkanals",
      "Analagenesie",
      "Analatresie",
      "Analseptum",
      "Angeborene Analatresie ohne Fistel",
      "Angeborene Analstenose",
      "Angeborene Anusstenose ohne Fistel",
      "Angeborenes Fehlen des Anus",
      "Angeborenes Fehlen des Anus ohne Fistel",
      "Anus imperforatus",
      "Anusagenesie",
      "Anushypoplasie",
      "Anusstriktur beim Säugling",
      "Hypoplasie des Analkanals",
      "Imperforatio ani",
      "Kongenitale Analsphinkterstriktur",
      "Kongenitale Anusstenose",
      "Kongenitaler Anusverschluss",
      "Nicht-syndromale anorektale Malformation (Anusatresie) ohne Fistel",
      "Persistierende Analmembran",
      "Undurchgängiger Anus"
    ]
  },
  {
    "code": "Q42.8",
    "name": "Appendixagenesie",
    "synonyms": [
      "Angeborenes Fehlen der Appendix",
      "Appendixagenesie",
      "Zäkumagenesie",
      "Zäkumatresie",
      "Zäkumhypoplasie"
    ]
  },
  {
    "code": "Q42.9",
    "name": "Dickdarmatresie",
    "synonyms": [
      "Angeborene Dickdarmobstruktion",
      "Angeborene Dickdarmokklusion",
      "Angeborene Dickdarmstenose",
      "Angeborene Dickdarmstriktur",
      "Angeborener Dickdarmverschluss",
      "Angeborenes Fehlen des Dickdarmes",
      "Currarino-Syndrom",
      "Dickdarmagenesie",
      "Dickdarmatresie",
      "Dickdarmhypoplasie",
      "Kolonagenesie",
      "Kolonatresie",
      "Kolonhypoplasie",
      "Kongenitale Kolonstenose",
      "Kongenitale Kolonstriktur",
      "Undurchgängiger Dickdarm"
    ]
  },
  {
    "code": "Q43.0",
    "name": "Meckel-Divertikel",
    "synonyms": [
      "Diverticulum ilei verum",
      "Kongenitale Hypertrophie eines Meckel-Divertikels",
      "Kongenitale Torsion eines Meckel-Divertikels",
      "Kongenitaler mangelhafter Verschluss des Ductus omphaloentericus",
      "Kongenitaler mangelhafter Verschluss des Ductus vitellinus",
      "Meckel-Divertikel",
      "Meckel-Dünndarmdivertikel",
      "Offener Ductus omphaloentericus",
      "Offener Ductus vitellinus",
      "Omphalomesenterische Zyste",
      "Persistenz des Dotterganges",
      "Persistenz des Ductus omphaloentericus",
      "Persistierender Ductus omphaloentericus",
      "Persistierender Ductus vitellinus",
      "Persistierendes Meckel-Divertikel",
      "Ulkus eines Meckel-Divertikels"
    ]
  },
  {
    "code": "Q43.1",
    "name": "Aganglionose",
    "synonyms": [
      "Aganglionose",
      "Aganglionose des Kolons",
      "Aganglionose des Rektums",
      "Aganglionose des Rektums und des Sigmas",
      "Aganglionose des Rektums, des Sigmas und des Kolon descendens",
      "Aganglionose des Rektums, des Sigmas, des Kolon descendens und des Kolon transversums",
      "Aganglionosis",
      "Aganglionotisches Megakolon",
      "Aganglionäres Megacolon congenitum",
      "HSCR [Hirschsprung-Krankheit]",
      "Hirschsprung-Krankheit",
      "Jirásek-Zuelzer-Wilson-Krankheit",
      "Jirásek-Zuelzer-Wilson-Syndrom",
      "Kongenitale intestinale Aganglionose",
      "Kongenitales Riesenkolon",
      "Makrokolon",
      "Megakolon bei Hirschsprung-Krankheit",
      "Morbus Hirschsprung",
      "Totale Aganglionose des Kolons",
      "Totale Aganglionose des Kolons mit Beteiligung des Dünndarms",
      "Totale intestinale Aganglionose"
    ]
  },
  {
    "code": "Q43.2",
    "name": "Angeborenes Makrosigma",
    "synonyms": [
      "Angeborene Kolondilatation",
      "Angeborenes Makrosigma",
      "Angeborenes Makrosigmoideum",
      "Aplastische Desmosis coli",
      "Kongenitale Kolondilatation",
      "Kongenitale Kolonhypertrophie",
      "Kongenitale funktionelle Kolonkrankheit",
      "Kongenitale funktionelle Kolonstörung",
      "Kongenitales Megasigma",
      "Kongenitales Megasigmoideum"
    ]
  },
  {
    "code": "Q43.3",
    "name": "Caecum mobile",
    "synonyms": [
      "Abnormer Gewebestrang des Omentums",
      "Angeborene Dickdarmverlagerung",
      "Angeborene anomale vom Netz ausgehende Darmadhäsion",
      "Angeborene anomale vom Peritoneum ausgehende Darmadhäsion",
      "Angeborener Gewebestrang des Omentums",
      "Angeborener periappendikaler Gewebestrang",
      "Angeborenes anomales vom Netz ausgehendes Darmband",
      "Angeborenes anomales vom Peritoneum ausgehendes Darmband",
      "Anomalie der Darmfixation",
      "Ausbleibende Kolonrotation",
      "Ausbleibende Zäkumrotation",
      "Caecum mobile",
      "Chilaiditi-Anomalie",
      "Chilaiditi-Syndrom",
      "Coecum mobile",
      "Darmanomalie mit Malrotation",
      "Darmanomalie mit abnormer Adhäsion",
      "Darmanomalie mit abnormer Fixation",
      "Familiäre intestinale Malrotation",
      "Fehlerhafte Kolondrehung",
      "Jackson-Membran",
      "Kongenitale Kolonverlagerung",
      "Kongenitale Lageanomalie des Darmes mit Malrotation",
      "Kongenitale Lageanomalie des Darmes mit abnormer Adhäsion",
      "Kongenitale Lageanomalie des Darmes mit abnormer Fixation",
      "Kongenitale abnorme Adhäsion des Omentums",
      "Kongenitale peritoneale Adhäsion",
      "Maldescensus des Kolons",
      "Maldescensus des Zäkums",
      "Malrotation des Darmes",
      "Malrotation des Kolons",
      "Malrotation des Zäkums",
      "Mesenterium commune",
      "Mesenterium ileocolicum commune",
      "Ungenügende Kolondrehung",
      "Ungenügende Kolonrotation",
      "Ungenügende Zäkumrotation",
      "Unvollständige Kolondrehung",
      "Unvollständige Kolonrotation",
      "Unvollständige Zäkumrotation"
    ]
  },
  {
    "code": "Q43.40",
    "name": "Akzessorischer Dünndarm",
    "synonyms": [
      "Akzessorischer Dünndarm",
      "Doppelter Dünndarm"
    ]
  },
  {
    "code": "Q43.41",
    "name": "Akzessorisches Zäkum",
    "synonyms": [
      "Akzessorische Appendix",
      "Akzessorischer Dickdarm",
      "Akzessorisches Zäkum",
      "Doppelte Appendix",
      "Doppelter Dickdarm",
      "Doppeltes Zäkum"
    ]
  },
  {
    "code": "Q43.42",
    "name": "Akzessorischer Anus",
    "synonyms": [
      "Akzessorischer Anus",
      "Doppelter Anus",
      "Duplikatur des Rektums"
    ]
  },
  {
    "code": "Q43.49",
    "name": "Darmduplikatur",
    "synonyms": [
      "Darmduplikatur",
      "Doppelter Darm"
    ]
  },
  {
    "code": "Q43.5",
    "name": "Ektopia ani",
    "synonyms": [
      "Anusektopie",
      "Ektopia ani"
    ]
  },
  {
    "code": "Q43.6",
    "name": "Kongenitale Kotfistel",
    "synonyms": [
      "Kongenitale Analfistel",
      "Kongenitale Kotfistel",
      "Kongenitale Rektumfistel"
    ]
  },
  {
    "code": "Q43.7",
    "name": "Kloakenpersistenz",
    "synonyms": [
      "Cloaca persistens",
      "Kloakenpersistenz",
      "Persistierende Kloake"
    ]
  },
  {
    "code": "Q43.8",
    "name": "Megaloduodenum",
    "synonyms": [
      "Angeborene Kolondivertikulitis",
      "Angeborene Kolonklappe",
      "Angeborenes Blind-loop-Syndrom",
      "Angeborenes Darmdivertikel",
      "Angeborenes Pouch-Kolon",
      "Angeborenes Syndrom der blinden Schlinge",
      "Appendixanomalie",
      "Appendixdeformität",
      "Appendixtransposition",
      "Berdon-Syndrom",
      "Darmtransposition",
      "Dickdarmtransposition",
      "Dolichokolie",
      "Dolichokolon",
      "Duodenalseptum",
      "Dünndarmtransposition",
      "Ekstrophia splanchnica",
      "Enterozyste",
      "Enterozystom",
      "Epiploischer Darmanhang",
      "Jejunumanomalie",
      "Kloakenekstrophie",
      "Kolontransposition",
      "Kolonverlängerung",
      "Kongenitale Analfissur",
      "Kongenitale Duodenaldivertikulitis",
      "Kongenitale Duodenaldivertikulose",
      "Kongenitale Intussuszeption",
      "Kongenitale Lageanomalie der Appendix",
      "Kongenitale Lageanomalie der unteren Verdauungsorgane",
      "Kongenitale Lageanomalie des Darmes",
      "Kongenitale Lageanomalie des Kolons",
      "Kongenitale Lageanomalie des Zäkums",
      "Kongenitale Sigmadivertikulitis",
      "Kongenitale Sigmadivertikulose",
      "Kongenitale Zäkumdivertikulitis",
      "Kongenitale Zäkumdivertikulose",
      "Kongenitale enterale Zyste",
      "Kongenitale rektosigmoidale Divertikulitis",
      "Kongenitale rektosigmoidale Divertikulose",
      "Kongenitale retrozäkale Appendix",
      "Kongenitale retrozäkale Appendixverlagerung",
      "Kongenitaler Volvulus",
      "Kongenitales Duodenaldivertikel",
      "Kongenitales Mikrokolon",
      "Kongenitales Sigmadivertikel",
      "Kongenitales Zäkumdivertikel",
      "Kongenitales rektosigmoidales Divertikel",
      "MMIHS [Megazystis-Mikrokolon-intestinale Hypoperistaltik]-Syndrom",
      "Megaduodenum",
      "Megaloappendix",
      "Megaloduodenum",
      "Mikrokolon",
      "Multiple intestinale Atresie",
      "Nicht-syndromale Kloakenfehlbildung",
      "Okulo-gastro-intestinale Muskeldystrophie",
      "Persistenz von pankreatischem Gewebe im Verdauungstrakt",
      "Retrozäkale Appendix",
      "Sigmaelongation",
      "Sigmaverlagerung",
      "Tricho-hepato-enterisches Syndrom"
    ]
  },
  {
    "code": "Q43.9",
    "name": "Darmmissbildung",
    "synonyms": [
      "Analanomalie",
      "Angeborene Anomalie des unteren Verdauungstraktes a.n.k.",
      "Angeborene Darmdeformität a.n.k.",
      "Angeborene Dickdarmdeformität a.n.k.",
      "Angeborene Duodenaldeformität",
      "Angeborene Dünndarmdeformität a.n.k.",
      "Angeborene Ileozäkalklappendeformität",
      "Angeborene Ileozäkalschlingendeformität",
      "Angeborene Ileumdeformität",
      "Angeborene Kolondeformität",
      "Angeborene Rektumdeformität",
      "Angeborene Sigmadeformität",
      "Angeborene Zäkumdeformität",
      "Anomalie der Bauhin-Klappe",
      "Anomalie der Ileozäkalklappe",
      "Anomalie der Sigmaflexur",
      "Darmanomalie",
      "Darmmissbildung",
      "Duodenalanomalie",
      "Ileumanomalie",
      "Kolonanomalie",
      "Kolonfehlbildung",
      "Nicht-syndromale anorektale Fehlbildung",
      "Rektumanomalie",
      "Sigmaanomalie",
      "Zäkumanomalie"
    ]
  },
  {
    "code": "Q44.0",
    "name": "Gallenblasenagenesie",
    "synonyms": [
      "Angeborenes Fehlen der Gallenblase",
      "Gallenblasenagenesie",
      "Gallenblasenaplasie",
      "Gallenblasenhypoplasie"
    ]
  },
  {
    "code": "Q44.1",
    "name": "Doppelgallenblase",
    "synonyms": [
      "Akzessorische Gallenblase",
      "Angeborene Gallenblasendeformität",
      "Angeborene Gallenblasenfehlbildung",
      "Angeborene Wandergallenblase",
      "Angeborene mobile Gallenblase",
      "Angeborener Gallenblasenverschluss",
      "Angeborener Gewebestrang der Gallenblase",
      "Doppelgallenblase",
      "Gallenblasenanomalie",
      "Gallenblasenatresie",
      "Gallenblasenfehlbildung",
      "Gallenblasenseptum",
      "Gallenblasenverdoppelung",
      "Intrahepatische Gallenblase",
      "Kongenitale Gallenblasenobstruktion",
      "Kongenitale Gallenblasentorsion",
      "Kongenitale Gallenblasenverlagerung",
      "Kongenitale Sanduhrkontraktur der Gallenblase"
    ]
  },
  {
    "code": "Q44.2",
    "name": "Gallengangsatresie",
    "synonyms": [
      "Angeborener undurchgängiger Gallengang",
      "Atresie der Gallengänge",
      "Atresie des Ductus choledochus",
      "Atresie des Ductus cysticus",
      "Atresie des Ductus hepaticus",
      "Gallengangsatresie"
    ]
  },
  {
    "code": "Q44.3",
    "name": "Angeborene Gallengangsstenose",
    "synonyms": [
      "Angeborene Gallengangsobstruktion",
      "Angeborene Gallengangsstenose",
      "Angeborene Gallengangsstriktur",
      "Angeborene Stenose des Ductus choledochus",
      "Angeborene Stenose des Ductus hepaticus",
      "Kongenitale Gallengangsobliteration",
      "Neonatale Gelbsucht durch angeborene Gallengangsobliteration",
      "Neonataler Ikterus durch angeborene Gallengangsobliteration"
    ]
  },
  {
    "code": "Q44.4",
    "name": "Choledochuszyste",
    "synonyms": [
      "Angeborene Choledochuszyste",
      "Angeborene Zyste des Ductus choledochus",
      "Choledochuszyste"
    ]
  },
  {
    "code": "Q44.5",
    "name": "Gallengangsdysplasie",
    "synonyms": [
      "Aberration des Ductus hepaticus",
      "Akzessorischer Ductus cysticus",
      "Akzessorischer Ductus hepaticus",
      "Akzessorischer Gallengang",
      "Akzessorischer Gallenweg",
      "Akzessorischer Lebergang",
      "Angeborene Deformität der Gallenwege",
      "Angeborene Deformität des Ductus cysticus",
      "Angeborene Deformität des Ductus hepaticus",
      "Angeborene Dilatation des Ductus choledochus",
      "Angeborene Dilatation des Ductus cysticus",
      "Angeborene Dilatation des Gallenblasenganges",
      "Angeborene Gallengangsanomalie",
      "Angeborene Gallengangsdeformität",
      "Angeborene Gallengangsdilatation",
      "Angeborene Gallengangsfehlbildung",
      "Angeborene Gallenwegsanomalie",
      "Angeborene Verkürzung des Ductus choledochus",
      "Angeborene bronchobiliäre Fistel",
      "Angeborenes Fehlen des Gallenganges",
      "Anomalie des Ductus choledochus",
      "Anomalie des Ductus cysticus",
      "Anomalie des Ductus hepaticus",
      "Caroli-Syndrom",
      "Doppelter Ductus choledochus",
      "Doppelter Ductus cysticus",
      "Doppelter Gallengang",
      "Duplikatur des Gallenblasengangs",
      "Gallengangsagenesie",
      "Gallengangsaplasie",
      "Gallengangsduplikatur",
      "Gallengangsdysplasie",
      "Gallengangshypoplasie",
      "Gallengangsverformung",
      "Gallenwegsagenesie",
      "Gallenwegsverformung",
      "Hypoplasie der Gallenwege",
      "Kongenitale Fistel des Ductus cysticus",
      "Kongenitale Gallengangstorsion",
      "Kongenitale Lageanomalie der Gallenwege",
      "Kongenitale Lageanomalie des Ductus hepaticus",
      "Kongenitale Verkürzung des Ductus cysticus",
      "Verformung des Ductus cysticus",
      "Verformung des Ductus hepaticus",
      "Verlängerung des Ductus choledochus",
      "Verlängerung des Ductus cysticus"
    ]
  },
  {
    "code": "Q44.6",
    "name": "Zystische Leberkrankheit",
    "synonyms": [
      "Angeborene Zystenleber",
      "Autosomal-dominante polyzystische Leberkrankheit",
      "Caroli-Krankheit",
      "Fibrozystische Leberkrankheit",
      "Isolierte angeborene Leberfibrose",
      "Isolierte kongenitale hepatische Fibrose",
      "Kongenitale Zystenleber",
      "Kongenitale fibrozystische Leberkrankheit",
      "Kongenitale polyzystische Leberkrankheit",
      "Kongenitale zystische Leberdegeneration",
      "Polyzystische Leber",
      "Polyzystische Leberkrankheit",
      "Zystenleber",
      "Zystische Leberkrankheit"
    ]
  },
  {
    "code": "Q44.7",
    "name": "Konnatale Hepatomegalie",
    "synonyms": [
      "Akzessorische Leber",
      "Alagille-Syndrom",
      "Alagille-Syndrom durch JAG1-Gen-Punktmutation",
      "Alagille-Syndrom durch Mikrodeletion 20p12",
      "Alagille-Syndrom durch Monosomie 20p12",
      "Alagille-Syndrom durch NOTCH2-Gen-Punktmutation",
      "Alagille-Watson-Syndrom",
      "Alagille-Watson-Syndrom durch JAG1-Gen-Punktmutation",
      "Alagille-Watson-Syndrom durch Monosomie 20p12",
      "Alagille-Watson-Syndrom durch NOTCH2-Gen-Punktmutation",
      "Angeborene Hepatomegalie",
      "Angeborene Leberanomalie",
      "Angeborene Leberdeformität",
      "Angeborene Leberfehlbildung",
      "Angeborene Lebervergrößerung",
      "Angeborenes Fehlen der Leber",
      "Anomale Lappenbildung der Leber",
      "Arteriohepatische Dysplasie",
      "Arteriohepatische Dysplasie durch JAG1-Gen-Punktmutation",
      "Arteriohepatische Dysplasie durch Monosomie 20p12",
      "Arteriohepatische Dysplasie durch NOTCH2-Gen-Punktmutation",
      "Doppelte Leber",
      "Intrahepatische Gallenganghypoplasie durch JAG1-Gen-Punktmutation",
      "Intrahepatische Gallenganghypoplasie durch Monosomie 20p12",
      "Intrahepatische Gallenganghypoplasie durch NOTCH2-Gen-Punktmutation",
      "Kongenitale Hepatomegalie",
      "Kongenitale Lageanomalie der Leber",
      "Kongenitale Leberhyperplasie",
      "Kongenitale Leberzyste",
      "Konnatale Hepatomegalie",
      "Konnatale Leberhypertrophie",
      "Leberagenesie",
      "Leberdystopie",
      "Leberhypoplasie",
      "Lebermissbildung",
      "Leberverformung",
      "Nebenleber",
      "Riedel-Leberlappen"
    ]
  },
  {
    "code": "Q45.0",
    "name": "Angeborenes Fehlen des Pankreas",
    "synonyms": [
      "Angeborenes Fehlen der Bauchspeicheldrüse",
      "Angeborenes Fehlen des Pankreas",
      "Pankreasagenesie",
      "Pankreasaplasie",
      "Pankreashypoplasie",
      "Partielle Pankreasagenesie"
    ]
  },
  {
    "code": "Q45.1",
    "name": "Pancreas anulare",
    "synonyms": [
      "Pancreas anulare",
      "Ring-Pankreas"
    ]
  },
  {
    "code": "Q45.2",
    "name": "Angeborene Pankreaszyste",
    "synonyms": [
      "Angeborene Pankreaszyste",
      "Kongenitale Pankreaszyste"
    ]
  },
  {
    "code": "Q45.3",
    "name": "Angeborene Pankreasfehlbildung",
    "synonyms": [
      "Akzessorisches Pankreas",
      "Angeborene Fehlbildung des Ductus pancreaticus",
      "Angeborene Pankreasdeformität",
      "Angeborene Pankreasfehlbildung",
      "Angeborene Pankreashypertrophie",
      "Doppeltes Pankreas",
      "Kongenitale Lageanomalie des Pankreas",
      "Pancreas accessorium",
      "Pancreas divisum",
      "Pankreasaberration",
      "Pankreasanomalie",
      "Pankreasektopie",
      "Pankreasganganomalie",
      "Pankreasverformung"
    ]
  },
  {
    "code": "Q45.8",
    "name": "Hydromphalus",
    "synonyms": [
      "Agenesie der Verdauungsorgane a.n.k.",
      "Akzessorische Verdauungsorgane a.n.k.",
      "Angeborene Hypoplasie der Verdauungsorgane a.n.k.",
      "Angeborene Malposition der Verdauungsorgane",
      "Angeborenes Fehlen der Verdauungsorgane",
      "Atresie der Verdauungsorgane a.n.k.",
      "Doppelte Verdauungsorgane a.n.k.",
      "Duplikatur der Verdauungsorgane",
      "Ectopia viscerum",
      "Ekstrophie der Bauchorgane",
      "Ektopie der Baucheingeweide",
      "Hydromphalus",
      "Hydromphalus seit Geburt",
      "Kongenitale Lageanomalie der Verdauungsorgane a.n.k.",
      "Kongenitale Lageanomalie des Gastrointestinaltraktes",
      "Kongenitale Zyste des Omentums",
      "Syndrom des hypoplastischen Pankreas mit Intestinalatresie und hypoplastischer Gallenblase",
      "Teilweise Agenesie der Verdauungsorgane a.n.k.",
      "Teilweises Fehlen des Verdauungskanals",
      "Vollständige Agenesie der Verdauungsorgane a.n.k.",
      "Vollständiges Fehlen des Verdauungskanals"
    ]
  },
  {
    "code": "Q45.9",
    "name": "Angeborene Anomalie des Magen-Darm-Traktes a.n.k.",
    "synonyms": [
      "Angeborene Anomalie der Verdauungsorgane a.n.k.",
      "Angeborene Anomalie des Magen-Darm-Traktes a.n.k.",
      "Angeborene Anomalie des Verdauungssystems",
      "Angeborene Deformität des Gastrointestinaltraktes",
      "Angeborene Deformität des Magen-Darm-Kanals a.n.k.",
      "Angeborene Deformität des Verdauungssystems",
      "Angeborene Deformität des Verdauungstraktes",
      "Angeborene Mesenteriumdeformität",
      "Mesenteriumanomalie"
    ]
  },
  {
    "code": "Q50.0",
    "name": "Angeborenes Fehlen des Ovars",
    "synonyms": [
      "Angeborenes Fehlen des Eierstocks",
      "Angeborenes Fehlen des Ovars",
      "Ovarialagenesie",
      "Ovarialaplasie"
    ]
  },
  {
    "code": "Q50.1",
    "name": "Dysontogenetische Ovarialzyste",
    "synonyms": [
      "Angeborene Ovarialzyste",
      "Dysontogenetische Ovarialzyste",
      "Entwicklungsbedingte Ovarialzyste"
    ]
  },
  {
    "code": "Q50.2",
    "name": "Angeborene Torsion des Ovars",
    "synonyms": [
      "Angeborene Torsion des Ovars",
      "Angeborener gedrehter Ovarialstiel"
    ]
  },
  {
    "code": "Q50.3",
    "name": "Ovarfehlbildung",
    "synonyms": [
      "Akzessorisches Ovar",
      "Angeborene Ovaradhäsion",
      "Angeborene Ovardeformität",
      "Angeborene Ovarfehlbildung",
      "Angeborene Ovarhypoplasie",
      "Angeborene Ovarverlagerung frei in die Bauchhöhle",
      "Kongenitale Eierstockadhäsion",
      "Kongenitale Lageanomalie des Ovars",
      "Kongenitale Ovarverlagerung",
      "Kongenitales kleines Ovar",
      "Ovaranomalie a.n.k.",
      "Ovarfehlbildung",
      "Ovarialdysgenesie",
      "Ovarstreifen",
      "Streak-Ovar"
    ]
  },
  {
    "code": "Q50.4",
    "name": "Embryonale Zyste der Tuba uterina",
    "synonyms": [
      "Embryonale Zyste der Tuba uterina",
      "Fimbrienzyste",
      "Kongenitale Eileiterzyste",
      "Kongenitale Zyste der Tuba uterina",
      "Zyste des Müller-Ganges"
    ]
  },
  {
    "code": "Q50.5",
    "name": "Embryonale Zyste des Ligamentum latum uteri",
    "synonyms": [
      "Embryonale Zyste des Ligamentum latum uteri",
      "Epoophoronzyste",
      "Morgagni-Hydatide bei der Frau",
      "Paroophoronzyste",
      "Parovarialzyste",
      "Zyste des Gartner-Ganges"
    ]
  },
  {
    "code": "Q50.6",
    "name": "Agenesie der Tuba uterina",
    "synonyms": [
      "Agenesie der Tuba uterina",
      "Akzessorische Tuba uterina",
      "Akzessorischer Eileiter",
      "Akzessorisches Ligamentum latum uteri",
      "Angeborene Fehlbildung der Tuba uterina",
      "Angeborene Fehlbildung des Ligamentum latum uteri",
      "Angeborenes Fehlen der Tuba uterina",
      "Angeborenes Fehlen des Eileiters",
      "Anomalie der Tuba uterina",
      "Anomalie des Gartner-Ganges",
      "Anomalie des Ligamentum latum uteri",
      "Atresie der Tuba uterina",
      "Atresie des Ligamentum latum uteri",
      "Eileiteragenesie",
      "Eileiteranomalie",
      "Eileiteratresie",
      "Eileiterverformung",
      "Fehlen der Tuba uterina",
      "Fehlen des Ligamentum latum uteri",
      "Kongenitale Eileiterverlagerung",
      "Kongenitale Lageanomalie der Tuba uterina",
      "Kongenitale Verlagerung der Tuba uterina",
      "Kongenitaler Eileiterverschluss",
      "Kongenitaler Verschluss der Tuba uterina",
      "Ovarienreste in der Tuba uterina",
      "Persistierende Ovarienreste in der Tuba uterina",
      "Persistierender Gartner-Gang",
      "Persistierendes Eileiterkonvolut",
      "Persistierendes Konvolut der Tuba uterina",
      "Verformung der Tuba uterina"
    ]
  },
  {
    "code": "Q51.0",
    "name": "Uterusagenesie",
    "synonyms": [
      "Angeborenes Fehlen des Uterus",
      "Uterusagenesie",
      "Uterusaplasie"
    ]
  },
  {
    "code": "Q51.1",
    "name": "Uterus duplex mit Uterus bicollis bei Vagina duplex",
    "synonyms": [
      "Uterus duplex mit Uterus bicollis bei Vagina duplex",
      "Uterus duplex mit Vagina duplex",
      "Uterus duplex mit doppelter Cervix uteri",
      "Uterus duplex mit doppelter Zervix"
    ]
  },
  {
    "code": "Q51.2",
    "name": "Uterus duplex",
    "synonyms": [
      "Akzessorischer Uterus",
      "Doppelter Uterus",
      "Komplett septierter Uterus",
      "Uterus bicollis",
      "Uterus didelphys",
      "Uterus duplex",
      "Uterus septus",
      "Uterusdoppelbildung",
      "Uterusseptum"
    ]
  },
  {
    "code": "Q51.3",
    "name": "Uterus bicornis",
    "synonyms": [
      "Bizervikaler Uterus bicornis mit offener Zervix und Vagina",
      "Bizervikaler Uterus bicornis und blind endende Hemivagina",
      "Unizervikaler Uterus bicornis",
      "Uterus bicornis",
      "Uterus bicornis bicanalis unicollis",
      "Uterus biforis suprasimplex",
      "Uterusspaltung"
    ]
  },
  {
    "code": "Q51.4",
    "name": "Uterus unicornis",
    "synonyms": [
      "Echter Uterus unicornis",
      "Unilaterale Aplasie des Müller-Ganges",
      "Uterus pseudounicornis",
      "Uterus unicornis"
    ]
  },
  {
    "code": "Q51.5",
    "name": "Agenesie der Cervix uteri",
    "synonyms": [
      "Agenesie der Cervix uteri",
      "Angeborene Zervixaplasie",
      "Angeborenes Fehlen der Cervix uteri",
      "Aplasie der Cervix uteri"
    ]
  },
  {
    "code": "Q51.6",
    "name": "Embryonale Zyste der Cervix uteri",
    "synonyms": [
      "Embryonale Zyste der Cervix uteri"
    ]
  },
  {
    "code": "Q51.7",
    "name": "Kongenitale uterorektale Fistel",
    "synonyms": [
      "Kongenitale Verbindung zwischen Uterus und Darm",
      "Kongenitale Verbindung zwischen Uterus und Harnblase",
      "Kongenitale Verbindung zwischen Uterus und Harntrakt",
      "Kongenitale Verbindung zwischen Uterus und Rektum",
      "Kongenitale Verbindung zwischen Uterus und Verdauungstrakt",
      "Kongenitale enterouterine Fistel",
      "Kongenitale rektouterine Fistel",
      "Kongenitale uteroabdominale Fistel",
      "Kongenitale uterointestinale Fistel",
      "Kongenitale uterorektale Fistel",
      "Kongenitale uterourethrale Fistel",
      "Kongenitale uterovesikale Fistel",
      "Kongenitale vesikouterine Fistel"
    ]
  },
  {
    "code": "Q51.8",
    "name": "Angeborene Portioektopie",
    "synonyms": [
      "Akzessorischer äußerer Muttermund",
      "Angeborene Atresie der Cervix uteri",
      "Angeborene Hypoplasie der Cervix uteri",
      "Angeborene Portioektopie",
      "Angeborene Uteruslateroversion",
      "Angeborene Verlängerung der Cervix uteri",
      "Angeborene Zervixatresie",
      "Angeborene Zervixhypoplasie",
      "Angeborene Zervixverlängerung",
      "Atresia uteri",
      "Doppelte Cervix uteri",
      "Doppelte Zervix",
      "Doppelter äußerer Muttermund",
      "Dreifacher Uterus",
      "Embryonale Uteruszyste",
      "Hypoplasia uteri",
      "Hypotropher Uterus",
      "Imperforation der Cervix uteri",
      "Kongenitale Atresie der Cervix uteri",
      "Kongenitale Gebärmutterhalshypertrophie",
      "Kongenitale Hypertrophie der Cervix uteri",
      "Kongenitale Retroversio uteri",
      "Kongenitale Stenose der Cervix uteri",
      "Kongenitale Striktur der Cervix uteri",
      "Kongenitale Uterusanteversion",
      "Kongenitale Verlagerung von Plattenepithel in den Zervikalkanal",
      "Kongenitale Verlagerung von Plattenepithel in die Uterusschleimhaut",
      "Kongenitale Zervixhypertrophie",
      "Kongenitale Zervixstenose",
      "Kongenitale Zervixstriktur",
      "Kongenitaler Prolaps der Cervix uteri",
      "Kongenitaler Uterusprolaps",
      "Kongenitaler Zervixprolaps",
      "Mangelhafter Uterusverschluss",
      "Mayer-Rokitansky-Küster-Hauser-Syndrom Typ 1",
      "Muttermundatresie",
      "Müller-Gang-Aplasie und Hyperandrogenismus",
      "Portioatresie",
      "Rudimentäre Cervix uteri",
      "Rudimentärer Uterus",
      "Teilung des äußeren Muttermundes in zwei Öffnungen durch ein Frenulum",
      "Uterus arcuatus",
      "Uterus fetalis",
      "Uterus subseptus",
      "Uterus triplex",
      "Uterusanomalie mit nur einem funktionstüchtigen Horn",
      "Uterusatresie",
      "Uterushypoplasie",
      "Verlagerung von Zylinderepithel über den äußeren Muttermund hinaus"
    ]
  },
  {
    "code": "Q51.9",
    "name": "Uterusmissbildung",
    "synonyms": [
      "Angeborene Deformität der Cervix uteri",
      "Angeborene Uterusdeformität",
      "Angeborene Zervixdeformität a.n.k.",
      "Anomalie der Cervix uteri",
      "Uterusanomalie",
      "Uterusfehlbildung",
      "Uterusmissbildung",
      "Uterusverformung",
      "Verformung der Cervix uteri",
      "Zervixanomalie",
      "Zervixverformung"
    ]
  },
  {
    "code": "Q52.0",
    "name": "Angeborenes Fehlen der Vagina",
    "synonyms": [
      "Angeborenes Fehlen der Vagina",
      "Isolierte partielle Vaginalagenesie",
      "Kongenitale Vaginalaplasie",
      "Rudimentäre Vagina",
      "Scheidenaplasie",
      "Vaginalagenesie",
      "Vaginalaplasie"
    ]
  },
  {
    "code": "Q52.1",
    "name": "Vaginalseptum",
    "synonyms": [
      "Akzessorische Vagina",
      "Doppelte Vagina",
      "Queres Vaginalseptum",
      "Sagittales Scheidenseptum",
      "Sagittales Vaginalseptum",
      "Scheidenseptum",
      "Septierte Vagina",
      "Transversales Vaginalseptum",
      "Vagina bipartita",
      "Vagina duplex",
      "Vagina septa",
      "Vaginalseptum"
    ]
  },
  {
    "code": "Q52.2",
    "name": "Angeborene rektovaginale Fistel",
    "synonyms": [
      "Angeborene rektovaginale Fistel",
      "Angeborene rektovaginale H-Fistel",
      "Angeborene rektovestibuläre Fistel",
      "Kongenitale enterovaginale Fistel",
      "Kongenitale rektovaginale Fistel"
    ]
  },
  {
    "code": "Q52.3",
    "name": "Hymen cribriformis",
    "synonyms": [
      "Atresia hymenalis",
      "Hymen cribriformis",
      "Hymen imperforatus",
      "Hymen imperforatus sive occlusus",
      "Hymen septus",
      "Hymen subseptus",
      "Hymenalatresie",
      "Hymenalplattenverschluss",
      "Hymenalseptum",
      "Hymenfusion",
      "Kongenitaler Hymenverschluss"
    ]
  },
  {
    "code": "Q52.4",
    "name": "Scheidenatresie",
    "synonyms": [
      "Akzessorisches Hymen",
      "Angeborene Hymendeformität",
      "Angeborene Vaginadeformität",
      "Angeborene Vaginafehlbildung",
      "Angeborene Vaginalatresie",
      "Angeborene Vaginaverkürzung",
      "Angeborene Zyste des Nuck-Kanals",
      "Angeborene Zyste des Processus vaginalis peritonei",
      "Angeborenes Fehlen des Hymen",
      "Anomalie des Nuck-Kanals",
      "Deformität des Nuck-Kanals",
      "Embryonale Hymenzyste",
      "Embryonale Vaginalzyste",
      "Hymen falciformis",
      "Hymen fimbriatus",
      "Hymen semilunaris bifenestratus",
      "Hymenagenesie",
      "Hymenalfehlbildung",
      "Hymenanomalie",
      "Hymenverformung",
      "Imperforatio vaginae",
      "Kongenitale Aufwärtsverlagerung des Hymen",
      "Kongenitale Hymenhyperplasie",
      "Kongenitale Hymenhypertrophie",
      "Kongenitale Vaginalstenose",
      "Kongenitale Vaginalstriktur",
      "Kongenitale Vaginazyste",
      "Kongenitaler Vaginalverschluss",
      "Nuck-Divertikel",
      "Offener Nuck-Kanal",
      "Scheidenatresie",
      "Vaginafusion",
      "Vaginalanomalie",
      "Vaginale Missbildung",
      "Vaginalfehlbildung",
      "Vaginalhypoplasie",
      "Vaginaverformung"
    ]
  },
  {
    "code": "Q52.5",
    "name": "Labienverschmelzung",
    "synonyms": [
      "Kongenitale Adhäsion der Labia majora pudendi",
      "Kongenitale Adhäsion der Labia minora pudendi",
      "Kongenitale Adhäsion der Schamlippen",
      "Kongenitale Fusion der Labia majora pudendi",
      "Kongenitale Fusion der Labia minora pudendi",
      "Labiensynechie",
      "Labienverschmelzung",
      "Vulvafusion"
    ]
  },
  {
    "code": "Q52.6",
    "name": "Angeborene Klitorisfehlbildung",
    "synonyms": [
      "Angeborene Klitorisdeformität",
      "Angeborene Klitorisfehlbildung",
      "Angeborenes Fehlen der Klitoris",
      "Klitorisagenesie",
      "Klitorisanomalie",
      "Klitorisspaltung",
      "Klitorisverformung",
      "Kongenitale Klitorishyperplasie",
      "Kongenitale Klitorishypertrophie",
      "Präputialschürze der Klitoris"
    ]
  },
  {
    "code": "Q52.7",
    "name": "Vulvafehlbildung",
    "synonyms": [
      "Agenesie der Labia majora pudendi",
      "Agenesie der Labia minora pudendi",
      "Agenesie äußerer weiblicher Genitalorgane",
      "Akzessorische Vulva",
      "Akzessorische äußere weibliche Geschlechtsorgane",
      "Angeborene Deformität der Labia majora pudendi",
      "Angeborene Deformität der Labia minora pudendi",
      "Angeborene Deformität der äußeren weiblichen Geschlechtsorgane",
      "Angeborene Hypoplasie der Labia majora pudendi",
      "Angeborene Hypoplasie der Labia minora pudendi",
      "Angeborene Hypoplasie der äußeren weiblichen Geschlechtsorgane",
      "Angeborene Teilung der Labia minora pudendi",
      "Angeborene Vulvadeformität",
      "Angeborene Vulvafehlbildung",
      "Angeborene Vulvahypoplasie",
      "Angeborene Vulvazyste",
      "Angeborene ungenügende Entwicklung der äußeren weiblichen Geschlechtsorgane",
      "Angeborenes Fehlen der Vulva",
      "Angeborenes Fehlen der äußeren weiblichen Geschlechtsorgane",
      "Anomalie der Labia majora pudendi",
      "Anomalie der Labia minora pudendi",
      "Anomalie äußerer weiblicher Genitalorgane",
      "Atresie äußerer weiblicher Geschlechtsorgane",
      "Doppelte Vulva",
      "Kongenitale Lageanomalie der äußeren weiblichen Geschlechtsorgane a.n.k.",
      "Kongenitale adhäsive Vulvitis",
      "Kongenitale rektovulväre Fistel",
      "Kongenitale vulvorektale Fistel",
      "Kongenitaler mangelhafter Verschluss der äußeren weiblichen Geschlechtsorgane",
      "Labienmissbildung",
      "Verformung der Labia majora pudendi",
      "Verformung der Labia minora pudendi",
      "Vulvaagenesie",
      "Vulvaanomalie",
      "Vulvaaplasie",
      "Vulvaatresie",
      "Vulvafehlbildung",
      "Vulvainfantilismus",
      "Vulvaverformung"
    ]
  },
  {
    "code": "Q52.8",
    "name": "Weibliche Mikrogenitalien",
    "synonyms": [
      "Agenesie der weiblichen Genitalorgane",
      "Agenesie des Ligamentum rotundum",
      "Akzessorische weibliche Geschlechtsorgane",
      "Angeborene Hypoplasie der weiblichen Geschlechtsorgane",
      "Angeborene ungenügende Entwicklung der inneren weiblichen Geschlechtsorgane",
      "Angeborene ungenügende Entwicklung der weiblichen Geschlechtsorgane",
      "Angeborenes Fehlen der inneren weiblichen Geschlechtsorgane a.n.k.",
      "Angeborenes Fehlen der weiblichen Genitalorgane",
      "Angeborenes Fehlen der weiblichen Urogenitalorgane",
      "Anomalie des Ligamentum rotundum",
      "Anomalie des Ligamentum teres uteri",
      "Aplasie des Ligamentum teres uteri",
      "Atresie der weiblichen Geschlechtsorgane",
      "Gynatresie",
      "Kongenitale Lageanomalie der inneren weiblichen Geschlechtsorgane a.n.k.",
      "Kongenitale Lageanomalie der weiblichen Geschlechtsorgane",
      "Kongenitale zervikovaginale Adhäsion",
      "Kongenitaler mangelhafter Verschluss der weiblichen Geschlechtsorgane a.n.k.",
      "Persistenz des Sinus urogenitalis bei der Frau",
      "Weibliche Mikrogenitalien",
      "Zyste des Urnierenganges bei der Frau",
      "Zyste des Wolff-Ganges bei der Frau"
    ]
  },
  {
    "code": "Q52.9",
    "name": "Angeborene Deformität der weiblichen Geschlechtsorgane a.n.k.",
    "synonyms": [
      "Angeborene Deformität der weiblichen Geschlechtsorgane a.n.k.",
      "Anomalie der weiblichen Geschlechtsorgane",
      "Anomalie des Urogenitalsystems bei der Frau a.n.k."
    ]
  },
  {
    "code": "Q53.0",
    "name": "Hodenektopie",
    "synonyms": [
      "Beidseitige Ektopia testis",
      "Einseitige Ektopia testis",
      "Ektopia testis",
      "Hodenektopie"
    ]
  },
  {
    "code": "Q53.1",
    "name": "Einseitiger Nondescensus testis",
    "synonyms": [
      "Einseitige Hodenretention",
      "Einseitige Retentio testis",
      "Einseitiger Kryptorchismus",
      "Einseitiger Leistenhoden",
      "Einseitiger Maldescensus testis",
      "Einseitiger Nondescensus testis",
      "Einseitiger mangelhafter Descensus testis"
    ]
  },
  {
    "code": "Q53.2",
    "name": "Beidseitiger Nondescensus testis",
    "synonyms": [
      "Beidseitige Hodenretention",
      "Beidseitige Retentio testis",
      "Beidseitiger Kryptorchismus",
      "Beidseitiger Leistenhoden",
      "Beidseitiger Maldescensus testis",
      "Beidseitiger Nondescensus testis",
      "Beidseitiger mangelhafter Descensus testis"
    ]
  },
  {
    "code": "Q53.9",
    "name": "Bauchhoden",
    "synonyms": [
      "Abdominalhoden",
      "Bauchhoden",
      "Hoden bei Kryptorchismus",
      "Hodenhochstand",
      "Hodenmaldeszension",
      "Hodenretention",
      "Hodenverlagerung in den Bauchraum",
      "Inguinalhoden",
      "Kryptorchismus",
      "Leistenhoden",
      "Maldescensus testis",
      "Mangelhafter Descensus testis",
      "Nondescensus testis",
      "Retentio testis",
      "Testikelmaldeszension"
    ]
  },
  {
    "code": "Q54.0",
    "name": "Glanduläre Hypospadie",
    "synonyms": [
      "Glanduläre Hypospadie",
      "Hypospadia coronaria",
      "Hypospadia glandularis"
    ]
  },
  {
    "code": "Q54.1",
    "name": "Penile Hypospadie",
    "synonyms": [
      "Penile Hypospadie"
    ]
  },
  {
    "code": "Q54.2",
    "name": "Penoskrotale Hypospadie",
    "synonyms": [
      "Penoskrotale Hypospadie"
    ]
  },
  {
    "code": "Q54.3",
    "name": "Perineale Hypospadie",
    "synonyms": [
      "Perineale Hypospadie"
    ]
  },
  {
    "code": "Q54.4",
    "name": "Angeborene Ventralverkrümmung des Penis",
    "synonyms": [
      "Angeborene Chorda penis",
      "Angeborene Gryposis penis ventralis",
      "Angeborene Ventralverkrümmung des Penis",
      "Angeborene Ventralverkürzung des Penis"
    ]
  },
  {
    "code": "Q54.8",
    "name": "Weibliche Hypospadie",
    "synonyms": [
      "Familäre Hypospadie",
      "Weibliche Hypospadie"
    ]
  },
  {
    "code": "Q54.9",
    "name": "Hypospadie",
    "synonyms": [
      "Fissura urethrae inferioris",
      "Hypospadie",
      "Paraspadie",
      "Untere Harnröhrenspalte",
      "Untere Urethraspalte"
    ]
  },
  {
    "code": "Q55.0",
    "name": "Hodenagenesie",
    "synonyms": [
      "Angeborenes Fehlen des Hodens",
      "Angeborenes Fehlen des Testis",
      "Anorchidie",
      "Anorchie",
      "Hodenagenesie",
      "Hodenaplasie",
      "Monorchie",
      "Monorchismus",
      "Testikuläres Regressionssyndrom",
      "Testisagenesie"
    ]
  },
  {
    "code": "Q55.1",
    "name": "Hodenfusion",
    "synonyms": [
      "Hodenfusion",
      "Hodenhypoplasie",
      "Hodenverschmelzung",
      "Synorchidie",
      "Testisfusion",
      "Testishypoplasie"
    ]
  },
  {
    "code": "Q55.2",
    "name": "Gleithoden",
    "synonyms": [
      "Akzessorischer Hoden",
      "Angeborene Hodendeformität",
      "Angeborene Hodenfehlbildung",
      "Angeborene Skrotumdeformität",
      "Angeborene Skrotumfehlbildung",
      "Angeborenes Fehlen des Skrotums",
      "Appendix testis",
      "Flottierender Hoden",
      "Gleithoden",
      "Hernie der Tunica vaginalis testis",
      "Hodenanomalie",
      "Hodendysplasie",
      "Inversio testis",
      "Kongenitale Hodenhypertrophie",
      "Kongenitale Skrotumagenesie",
      "Kongenitale Testishypertrophie",
      "Pendelhoden",
      "Polyorchidie",
      "Polyorchie",
      "Retroversio testis",
      "Skrotumagenesie",
      "Skrotumanomalie",
      "Skrotumaplasie",
      "Skrotumspalte",
      "Skrotumspaltung",
      "Testikuläre Morgagni-Hydatide beim Mann",
      "Testisanomalie",
      "Testisdysplasie",
      "Wanderhoden"
    ]
  },
  {
    "code": "Q55.3",
    "name": "Atresie des Ductus deferens",
    "synonyms": [
      "Atresie des Ductus deferens",
      "Atresie des Vas deferens"
    ]
  },
  {
    "code": "Q55.4",
    "name": "Angeborene Vergrößerung der Samenblase",
    "synonyms": [
      "Agenesie des Ductus deferens",
      "Agenesie des Ductus ejaculatorius",
      "Agenesie des Ductus spermaticus",
      "Agenesie des Funiculus spermaticus",
      "Agenesie des Vas deferens",
      "Angeborene Deformität der Bläschendrüse",
      "Angeborene Deformität der Vesicula seminalis",
      "Angeborene Deformität des Ductus deferens",
      "Angeborene Deformität des Ductus ejaculatorius",
      "Angeborene Deformität des Samenstranges",
      "Angeborene Deformität des Vas deferens",
      "Angeborene Epididymisdeformität",
      "Angeborene Epididymishypoplasie",
      "Angeborene Fehlbildung der Vesicula seminalis",
      "Angeborene Fehlbildung des Ductus deferens",
      "Angeborene Nebenhodendeformität",
      "Angeborene Nebenhodenfehlbildung",
      "Angeborene Nebenhodenhypoplasie",
      "Angeborene Prostatadeformität",
      "Angeborene Prostatafehlbildung",
      "Angeborene Striktur des Ductus deferens",
      "Angeborene Striktur des Ductus ejaculatorius",
      "Angeborene Vergrößerung der Samenblase",
      "Angeborenes Fehlen der Epididymis",
      "Angeborenes Fehlen der Prostata",
      "Angeborenes Fehlen der Vesiculae seminales",
      "Angeborenes Fehlen des Ductus deferens",
      "Angeborenes Fehlen des Ductus spermaticus",
      "Angeborenes Fehlen des Funiculus spermaticus",
      "Angeborenes Fehlen des Nebenhodens",
      "Angeborenes Fehlen des Samenleiters",
      "Angeborenes Fehlen des Samenstranges",
      "Angeborenes Fehlen des Vas deferens",
      "Anomalie der Vesicula seminalis",
      "Anomalie des Ductus deferens",
      "Anomalie des Ductus ejaculatorius",
      "Anomalie des Funiculus spermaticus",
      "Anomalie des Vas deferens",
      "Aplasie des Funiculus spermaticus",
      "Appendix epididymidis",
      "Atresie des Ductus ejaculatorius",
      "Bläschendrüsenanomalie",
      "Epididymisagenesie",
      "Epididymisanomalie",
      "Fehlen der Prostata",
      "Fehlen des Funiculus spermaticus",
      "Kongenitale Prostatahypertrophie",
      "Kongenitale Samenstrangadhäsion",
      "Kongenitale Spermatozele",
      "Kongenitale bilaterale Vas-deferens-Aplasie",
      "Morgagni-Hydatide beim Mann",
      "Nebenhodenagenesie",
      "Nebenhodenanomalie",
      "Nebenhodendysplasie",
      "Prostataagenesie",
      "Prostataanomalie",
      "Prostataaplasie",
      "Samenblasenaplasie",
      "Samenleiteragenesie",
      "Samenleiteranomalie",
      "Samenstrangagenesie",
      "Samenstranganomalie",
      "Samenstrangaplasie",
      "Zyste des Urnierenganges beim Mann",
      "Zyste des Wolff-Ganges beim Mann"
    ]
  },
  {
    "code": "Q55.5",
    "name": "Penisagenesie",
    "synonyms": [
      "Angeborenes Fehlen des Penis",
      "Penisagenesie",
      "Penisaplasie"
    ]
  },
  {
    "code": "Q55.6",
    "name": "Diphallus",
    "synonyms": [
      "Akzessorischer Penis",
      "Angeborene Penisdeformität",
      "Angeborene Penisfehlbildung",
      "Angeborene Penisverkürzung",
      "Angeborene Präputiumdeformität",
      "Anomalie der Glans penis",
      "Diphallie",
      "Diphallus",
      "Doppelter Penis",
      "Gryposis penis lateralis",
      "Idiopathischer Mikropenis",
      "Kongenitale Penistorsion",
      "Kongenitale Zyste des Präputiums",
      "Laterale Penisverkürzung",
      "Penisdeviation",
      "Penisdorsalverbiegung",
      "Penishypoplasie",
      "Penismissbildung",
      "Penisspalte",
      "Penisverkrümmung",
      "Präputialschürze des Penis",
      "Präputiumanomalie",
      "Teilung der Glans penis",
      "Verlängerung des Frenulum praeputii"
    ]
  },
  {
    "code": "Q55.8",
    "name": "Männliche Mikrogenitalien",
    "synonyms": [
      "Agenesie der männlichen Genitalorgane",
      "Akzessorische männliche Geschlechtsorgane",
      "Angeborene ungenügende Entwicklung der männlichen Geschlechtsorgane",
      "Angeborenes Fehlen der männlichen Urogenitalorgane",
      "Atresie der inneren männlichen Geschlechtsorgane",
      "Atresie der äußeren männlichen Geschlechtsorgane",
      "Hodenreifungsstörung",
      "Hypoplasie der männlichen Geschlechtsorgane",
      "Kongenitale Adhäsion des Penis mit dem Skrotum",
      "Kongenitale Lageanomalie der männlichen Geschlechtsorgane",
      "Kongenitaler mangelhafter Verschluss der männlichen Geschlechtsorgane",
      "Männliche Mikrogenitalien",
      "Müller-Gang-Persistenzsyndrom",
      "Penoskrotale Transposition",
      "Persistenz des Sinus urogenitalis beim Mann"
    ]
  },
  {
    "code": "Q55.9",
    "name": "Anomalie der männlichen Genitalorgane",
    "synonyms": [
      "Angeborene Deformität der männlichen Genitalorgane",
      "Angeborene Deformität der männlichen Geschlechtsorgane a.n.k.",
      "Anomalie der männlichen Genitalorgane",
      "Anomalie der männlichen Geschlechtsorgane",
      "Anomalie des Urogenitalsystems beim Mann a.n.k."
    ]
  },
  {
    "code": "Q56.0",
    "name": "Gynandrismus",
    "synonyms": [
      "Echter Hermaphroditismus",
      "Echter Zwitter",
      "Gynandrie",
      "Gynandrismus",
      "Hermaphroditismus",
      "Ovotestikuläre Störung der Geschlechtsentwicklung bei Karyotyp 46,XX",
      "Ovotestikuläre Störung der Geschlechtsentwicklung bei Karyotyp 46,XY",
      "Ovotestis",
      "Testovar",
      "Zweigeschlechtlichkeit",
      "Zwitter"
    ]
  },
  {
    "code": "Q56.1",
    "name": "Androgynie",
    "synonyms": [
      "Androgynie",
      "Partielle 46,XY-Gonadendysgenesie",
      "Pseudohermaphroditismus masculinus",
      "Pseudohermaphroditismus masculinus mit Skrotumspalte",
      "Rudimentärer Uterus beim Mann"
    ]
  },
  {
    "code": "Q56.2",
    "name": "Pseudohermaphroditismus femininus",
    "synonyms": [
      "Intersexualität bei Karyotyp 46,XX",
      "Pseudohermaphroditismus femininus",
      "Störung der Geschlechtsentwicklung bei Karyotyp 46,XX"
    ]
  },
  {
    "code": "Q56.3",
    "name": "Pseudohermaphroditismus",
    "synonyms": [
      "Pseudohermaphroditismus",
      "Scheinzwitter"
    ]
  },
  {
    "code": "Q56.4",
    "name": "Unbestimmbares Geschlecht",
    "synonyms": [
      "Nicht eindeutig differenzierbare Genitalien",
      "Unbestimmbares Geschlecht"
    ]
  },
  {
    "code": "Q60.0",
    "name": "Einseitige Nierenagenesie",
    "synonyms": [
      "Angeborene Singulärniere",
      "Angeborene Solitärniere",
      "Angeborenes einseitiges Fehlen der Niere",
      "Einseitige Nierenagenesie",
      "Einzelniere",
      "Unilaterale Nierenagenesie"
    ]
  },
  {
    "code": "Q60.1",
    "name": "Beidseitige Nierenagenesie",
    "synonyms": [
      "Angeborenes beidseitiges Fehlen der Niere",
      "Beidseitige Nierenagenesie"
    ]
  },
  {
    "code": "Q60.2",
    "name": "Nierenagenesie",
    "synonyms": [
      "Angeborenes Fehlen der Niere",
      "Nierenagenesie",
      "Nierenaplasie"
    ]
  },
  {
    "code": "Q60.3",
    "name": "Einseitige Nierenhypoplasie",
    "synonyms": [
      "Angeborene einseitige Nierenatrophie",
      "Einseitige Nierendysgenesie",
      "Einseitige Nierenhypoplasie",
      "Infantile einseitige Nierenatrophie",
      "Unilaterale Nierenhypoplasie"
    ]
  },
  {
    "code": "Q60.4",
    "name": "Beidseitige Nierenhypoplasie",
    "synonyms": [
      "Angeborene beidseitige Nierenatrophie",
      "Beidseitige Nierendysgenesie",
      "Beidseitige Nierenhypoplasie",
      "Bilaterale Nierenhypoplasie",
      "Infantile beidseitige Nierenatrophie",
      "Oligomeganephronie"
    ]
  },
  {
    "code": "Q60.5",
    "name": "Nierenunreife",
    "synonyms": [
      "Angeborene Nierenatrophie",
      "Infantile Nierenatrophie",
      "Nierendysgenesie",
      "Nierenhypoplasie",
      "Nierenunreife",
      "Unreife Niere",
      "Zwergniere"
    ]
  },
  {
    "code": "Q60.6",
    "name": "Potter-Syndrom",
    "synonyms": [
      "Angeborene renofaziale Dysplasie",
      "Potter-Fazies",
      "Potter-Sequenz",
      "Potter-Syndrom"
    ]
  },
  {
    "code": "Q61.0",
    "name": "Angeborene solitäre Nierenzyste",
    "synonyms": [
      "Angeborene solitäre Nierenzyste",
      "Kongenitale Nierenzyste"
    ]
  },
  {
    "code": "Q61.1",
    "name": "Autosomal-rezessive polyzystische Niere vom infantilen Typ",
    "synonyms": [
      "ARPKD [Autosomal-rezessive polyzystische Nierenkrankheit]",
      "Autosomal-rezessive polyzystische Niere vom infantilen Typ",
      "Autosomal-rezessive polyzystische Nierenkrankheit",
      "Infantile Form der polyzystischen Nierenkrankheit",
      "Multiple autosomal-rezessive Zystenniere",
      "Polyzystische Niere, autosomal-rezessiv",
      "Polyzystische Niere, infantiler Typ",
      "Polyzystische Nierendegeneration vom infantilen Typ",
      "Polyzystische Nierenerkrankung Potter Typ I"
    ]
  },
  {
    "code": "Q61.2",
    "name": "Autosomal-dominante polyzystische Niere vom Erwachsenentyp",
    "synonyms": [
      "ADPKD [Autosomal-dominante polyzystische Nierenkrankheit]",
      "Autosomal-dominante polyzystische Niere vom Erwachsenentyp",
      "Autosomal-dominante polyzystische Nierenkrankheit",
      "Multiple autosomal-dominante Zystenniere",
      "Polyzystische Niere, Erwachsenentyp",
      "Polyzystische Niere, autosomal-dominant",
      "Polyzystische Nierendegeneration vom Erwachsenentyp",
      "Polyzystische Nierenerkrankung Potter Typ III",
      "Polyzystisches Syndrom"
    ]
  },
  {
    "code": "Q61.3",
    "name": "Polyzystische Niere",
    "synonyms": [
      "Multiple Nierenzysten",
      "Polyzystische Niere",
      "Polyzystische Nierendegeneration",
      "Polyzystische Nierenkrankheit"
    ]
  },
  {
    "code": "Q61.4",
    "name": "Nierendysplasie",
    "synonyms": [
      "Beidseitige Nierendysplasie",
      "Beidseitige multizystische Nierendysplasie",
      "Einseitige Nierendysplasie",
      "Einseitige multizystische Nierendysplasie",
      "Entwicklungsbedingte multizystische Nieren",
      "Multizystische Nierendysplasie",
      "Multizystische Nierenkrankheit",
      "Multizystische renale Dysplasie [Potter Typ II]",
      "Nierendysplasie",
      "Renale Dysplasie"
    ]
  },
  {
    "code": "Q61.5",
    "name": "Medulläre Zystenniere",
    "synonyms": [
      "Autosomal-dominante medulläre zystische Nierenkrankheit",
      "Autosomal-dominante medulläre zystische Nierenkrankheit mit Hyperurikämie",
      "Autosomal-dominante tubulointerstitielle Nierenkrankheit",
      "Cacchi-Ricci-Syndrom",
      "Infantile Form der Nephronophthise",
      "Juvenile Form der Nephronophthise",
      "MUC1-assoziierte autosomal-dominante tubulointerstitielle Nierenkrankheit",
      "Markschwammniere",
      "Medulläre Zystenniere",
      "Nephronophthise",
      "Präkalizielle Tubuloektasie",
      "Schwammniere",
      "Spät beginnende Form der Nephronophthise",
      "UMOD-assoziierte autosomal-dominante tubulointerstitielle Nierenkrankheit"
    ]
  },
  {
    "code": "Q61.8",
    "name": "Fibrozystische Niere",
    "synonyms": [
      "Fibrozystische Niere",
      "Fibrozystische Nierendegeneration",
      "Fibrozystische Nierenkrankheit",
      "Nierenmarkzyste"
    ]
  },
  {
    "code": "Q61.9",
    "name": "Zystische Nierendegeneration",
    "synonyms": [
      "Angeborene zystische Nierendegeneration",
      "Angeborene zystische Nierenkrankheit",
      "Dysencephalia splanchnocystica",
      "Gruber-Syndrom",
      "Meckel-Gruber-Syndrom",
      "Meckel-Syndrom",
      "Meckel-Syndrom Typ 7",
      "Zystenniere",
      "Zystische Nierendegeneration",
      "Zystische Nierenerkrankung",
      "Zystische Nierenkrankheit"
    ]
  },
  {
    "code": "Q62.0",
    "name": "Angeborene Hydronephrose",
    "synonyms": [
      "Angeborene Hydronephrose",
      "Kongenitale Harnstauungsniere",
      "Kongenitale Hydronephrose",
      "Kongenitale Verstopfungsniere",
      "Kongenitale Wassersackniere"
    ]
  },
  {
    "code": "Q62.1",
    "name": "Ureteratresie",
    "synonyms": [
      "Angeborene Stenose des Ostium ureteris",
      "Angeborene Stenose des ureteropelviner Überganges",
      "Angeborene Striktur der Uretermündung",
      "Angeborene Ureterstenose",
      "Angeborene Ureterundurchgängigkeit",
      "Angeborener Ureterverschluss",
      "Angeborener Verschluss der Uretermündung",
      "Angeborener Verschluss der ureterovesikalen Öffnung",
      "Angeborener Verschluss des Ostium ureteris",
      "Angeborener Verschluss des ureteropelvinen Überganges",
      "Angeborener undurchgängiger Ureter",
      "Atresia ureteris",
      "Atresie der Ostia ureterum",
      "Atresie des ureteropelvinen Überganges",
      "Harnleiteratresie",
      "Kongenitale Ureterstriktur",
      "Kongenitale ureteropelvine Striktur",
      "Kongenitale ureterovesikale Striktur",
      "Ureteratresie"
    ]
  },
  {
    "code": "Q62.2",
    "name": "Angeborener Megaureter",
    "synonyms": [
      "Angeborene Ureterdilatation",
      "Angeborener Megaureter",
      "Kongenitale Harnleiterdilatation",
      "Kongenitale Ureterdilatation",
      "Kongenitaler Megaureter",
      "Kongenitaler Riesenharnleiter",
      "Kongenitaler Riesenureter",
      "Kongenitaler primärer Megaureter",
      "Primärer Megaureter"
    ]
  },
  {
    "code": "Q62.3",
    "name": "Kongenitaler Hydroureter",
    "synonyms": [
      "Angeborene Nierenbeckenobstruktion",
      "Angeborene Ureterklappe",
      "Angeborene Ureterozele",
      "Kongenitale Ureterobstruktion",
      "Kongenitale Ureterozele",
      "Kongenitaler Hydroureter",
      "Nierenhohlsystemdoppelung",
      "Obstruktive Harnleiteranomalie a.n.k.",
      "Obstruktive Ureteranomalie a.n.k.",
      "Obstruktiver Nierenbeckendefekt",
      "Primärer Hydroureter"
    ]
  },
  {
    "code": "Q62.4",
    "name": "Ureteragenesie",
    "synonyms": [
      "Angeborenes Fehlen des Harnleiters",
      "Angeborenes Fehlen des Ureters",
      "Fehlen des Ureters",
      "Harnleiteragenesie",
      "Harnleiteraplasie",
      "Ureteragenesie",
      "Ureteraplasie"
    ]
  },
  {
    "code": "Q62.5",
    "name": "Akzessorischer Ureter",
    "synonyms": [
      "Akzessorischer Harnleiter",
      "Akzessorischer Ureter",
      "Akzessorisches Nierenbecken mit doppeltem Ureter",
      "Doppelter Harnleiter",
      "Doppelter Ureter",
      "Doppeltes Nierenbecken mit doppeltem Harnleiter",
      "Doppeltes Nierenbecken mit doppeltem Ureter",
      "Harnleiterdoppelung",
      "Ureter duplex",
      "Ureterduplikatur"
    ]
  },
  {
    "code": "Q62.6",
    "name": "Ureterdislokation",
    "synonyms": [
      "Angeborene Ureterdeviation",
      "Anomale Implantation der Uretermündung",
      "Anomale Ureterimplantation",
      "Deviation der Uretermündung",
      "Ektopie der Uretermündung",
      "Harnleiterdislokation",
      "Harnleiterektopie",
      "Harnleiterverlagerung",
      "Hoher Harnleiterabgang",
      "Hoher Ureterabgang",
      "Lageanomalie des Harnleiters",
      "Retrokavaler Harnleiter",
      "Retrokavaler Ureter",
      "Ureterdislokation",
      "Ureterektopie",
      "Ureterlageanomalie",
      "Ureterverlagerung",
      "Verlagerung der Uretermündung"
    ]
  },
  {
    "code": "Q62.7",
    "name": "Kongenitaler vesikoureterorenaler Reflux",
    "synonyms": [
      "Angeborener vesikoureteraler Reflux",
      "Kongenitaler vesikoureterorenaler Reflux",
      "Megazystis-Megaureter-Syndrom"
    ]
  },
  {
    "code": "Q62.8",
    "name": "Harnleiteranomalie",
    "synonyms": [
      "Angeborene Ureterdeformität",
      "Angeborene Ureterostiuminsuffizienz",
      "Dreifacher Harnleiter",
      "Dreifacher Ureter",
      "Harnleiteranomalie",
      "Kongenitale Harnleiterdivertikulitis",
      "Kongenitale Harnleiterdivertikulose",
      "Kongenitale Ureterdivertikulitis",
      "Kongenitale Ureterdivertikulose",
      "Kongenitale Zyste der ureterovesikalen Öffnung",
      "Kongenitales Harnleiterdivertikel",
      "Kongenitales Ureterdivertikel",
      "Ureter bifidus",
      "Ureter triplex",
      "Ureteranomalie",
      "Ureterhypoplasie",
      "Ureterspaltung",
      "Ureterverformung"
    ]
  },
  {
    "code": "Q63.0",
    "name": "Akzessorische Niere",
    "synonyms": [
      "Akzessorische Niere",
      "Doppelniere mit doppeltem Nierenbecken",
      "Dreifache Niere"
    ]
  },
  {
    "code": "Q63.1",
    "name": "Klumpenniere",
    "synonyms": [
      "Doppelniere",
      "Fusionsniere",
      "Gelappte Niere",
      "Hufeisenniere",
      "Klumpenniere",
      "Kongenitale Hufeisenniere",
      "Kuchenniere",
      "Lappenbildung der fetalen Niere",
      "Nierendoppelsystem",
      "Nierendoppelung",
      "Ren arcuatus",
      "Ren scutulatus",
      "Ren unguliformis",
      "Verschmelzungsniere",
      "Verschmolzene Niere"
    ]
  },
  {
    "code": "Q63.2",
    "name": "Nierendystopie",
    "synonyms": [
      "Angeborene Beckenniere",
      "Angeborene Nierenverlagerung",
      "Angeborener Nierenprolaps",
      "Beckenniere",
      "Intrathorakale Niere",
      "Kongenitale Lageanomalie der Niere",
      "Kongenitale Nierenverlagerung",
      "Nierenbeckenektopie",
      "Nierendystopie",
      "Nierenektopie",
      "Nierenfehldrehung",
      "Nierenmalrotation",
      "Nierenpositionsanomalie",
      "Renale Ektopie"
    ]
  },
  {
    "code": "Q63.3",
    "name": "Langniere",
    "synonyms": [
      "Angeborene Riesenniere",
      "Kongenitale Nierenhypertrophie",
      "Langniere",
      "Nierenhyperplasie",
      "Riesenniere"
    ]
  },
  {
    "code": "Q63.8",
    "name": "Nierenbuckel",
    "synonyms": [
      "Angeborene Megakalikose",
      "Angeborener Nierenbeckendefekt",
      "Angeborener Nierenstein",
      "Beidseitige angeborene Megakalikose",
      "Doppeltes Nierenbecken",
      "Einseitige angeborene Megakalikose",
      "Kongenitale Megakalikose",
      "Kongenitale Nephrolithiasis",
      "Kongenitale Nephroptose",
      "Kongenitale Nierenkontraktur",
      "Kongenitale Nierenptose",
      "Kongenitale Senkniere",
      "Kongenitale Wanderniere",
      "L-förmige Niere",
      "Nierenbeckenspaltung",
      "Nierenbuckel",
      "Nierendysmorphie",
      "Nierenhöcker",
      "Nierenkelchelongation",
      "Nierenspaltung",
      "Ren bifidus",
      "Ren mobilis congenitalis",
      "Ren trifidus",
      "Renale tubuläre Dysgenesie"
    ]
  },
  {
    "code": "Q63.9",
    "name": "Angeborene Nierenfehlbildung",
    "synonyms": [
      "Angeborene Nierenanomalie",
      "Angeborene Nierenbeckendeformität",
      "Angeborene Nierendeformität",
      "Angeborene Nierenfehlbildung",
      "Angeborene renale Anomalie",
      "Nierendeformierung",
      "Nierenfehlbildung",
      "Nierenmalformation",
      "Nierenmissbildung"
    ]
  },
  {
    "code": "Q64.0",
    "name": "Epispadia clitorica",
    "synonyms": [
      "Anaspadie",
      "Epispadia clitorica",
      "Epispadie",
      "Epispadie bei der Frau",
      "Epispadie beim Mann",
      "Harnröhrenspalte",
      "Klitorisepispadie",
      "Kongenitale Harnröhrenspalte",
      "Kongenitale Urethraspalte",
      "Urethraspalte",
      "Weibliche Epispadie"
    ]
  },
  {
    "code": "Q64.1",
    "name": "Harnblasenekstrophie",
    "synonyms": [
      "Blasenekstrophie",
      "Ectopia vesicae",
      "Ekstrophie der Harnblase",
      "Harnblasenekstrophie",
      "Harnblasenektopie",
      "Harnblasenextraversion",
      "Harnblasenextroversion",
      "Kongenitale Harnblasenverlagerung",
      "Kongenitale Lageanomalie der Harnblase"
    ]
  },
  {
    "code": "Q64.2",
    "name": "Harnröhrenklappe",
    "synonyms": [
      "Angeborene Striktur durch Urethraklappe",
      "Angeborene Urethraklappe in der hinteren Urethra",
      "Angeborene Urethralklappe in der hinteren Harnröhre",
      "Harnröhrenklappe",
      "PUV [Posteriore Urethralklappen]",
      "Posteriore Urethralklappen",
      "Urethraklappe",
      "Urethralklappe"
    ]
  },
  {
    "code": "Q64.3",
    "name": "Blasenhalsatresie",
    "synonyms": [
      "Angeborene Harnblasenhalsobstruktion",
      "Angeborene Stenose des Meatus urinarius",
      "Angeborene Stenose des Ostium urethrae",
      "Angeborene Striktur des Meatus urethrae",
      "Angeborene Striktur des Meatus urinarius",
      "Angeborene Urethrastenose",
      "Angeborene Urethrastriktur",
      "Atresie des Meatus urinarius",
      "Atresie des Ostium urethrae",
      "Blasenhalsatresie",
      "Harnblasenhalsatresie",
      "Harnröhrenatresie",
      "Kongenitale Harnblasenhalsobstruktion",
      "Kongenitale Harnblasenhalsstenose",
      "Kongenitale Harnröhrenmündungsstriktur",
      "Kongenitale Harnröhrenstriktur",
      "Kongenitale Striktur der vesikourethralen Öffnung",
      "Kongenitale Urethramündungsstriktur",
      "Kongenitale Urethraobstruktion",
      "Kongenitale Urethrastriktur",
      "Kongenitaler Urethraverschluss",
      "Obstruierende Urethraverformung",
      "Obstruktive Harnröhrenanomalie",
      "Obstruktive Urethraanomalie a.n.k.",
      "Undurchgängige Urethra",
      "Urethraatresie",
      "Urethraimperforation",
      "Urethraundurchgängigkeit"
    ]
  },
  {
    "code": "Q64.4",
    "name": "Urachusfehlbildung",
    "synonyms": [
      "Angeborene Urachusdeformität",
      "Angeborene Urachusfistel",
      "Angeborene Urachuszyste",
      "Angeborener Urachusprolaps",
      "Offener Urachus",
      "Persistierender Urachus",
      "Urachusanomalie",
      "Urachusdivertikel",
      "Urachusfehlbildung",
      "Urachusfistel",
      "Urachuspersistenz",
      "Urachusprolaps",
      "Urachussinus",
      "Urachuszyste",
      "Urachusüberrest"
    ]
  },
  {
    "code": "Q64.5",
    "name": "Harnblasenatresie",
    "synonyms": [
      "Angeborenes Fehlen der Harnblase",
      "Angeborenes Fehlen der Harnröhre",
      "Angeborenes Fehlen der Urethra",
      "Azystie",
      "Harnblasenagenesie",
      "Harnblasenaplasie",
      "Harnblasenatresie",
      "Harnröhrenagenesie",
      "Harnröhrenaplasie",
      "Urethraagenesie",
      "Urethraaplasie"
    ]
  },
  {
    "code": "Q64.6",
    "name": "Angeborenes Harnblasendivertikel",
    "synonyms": [
      "Angeborenes Harnblasendivertikel",
      "Kongenitale Divertikulitis vesicae",
      "Kongenitale Harnblasendivertikulose"
    ]
  },
  {
    "code": "Q64.7",
    "name": "Akzessorische Harnblase",
    "synonyms": [
      "Akzessorische Harnblase",
      "Akzessorische Harnröhre",
      "Akzessorische Urethra",
      "Akzessorischer Meatus urinarius",
      "Angeborene Blasenanomalie",
      "Angeborene Deformität der Blasenöffnung a.n.k.",
      "Angeborene Deformität der Harnröhrenöffnung a.n.k.",
      "Angeborene Deformität der Urethraöffnung a.n.k.",
      "Angeborene Deformität des Ostium urethrae internum a.n.k.",
      "Angeborene Harnblasenanomalie",
      "Angeborene Harnblasendeformität",
      "Angeborene Harnblasenfehlbildung",
      "Angeborene Harnblasenhernie",
      "Angeborene Hernie des Meatus urinarius",
      "Angeborene Urethraanomalie",
      "Angeborene Urethradeformität",
      "Angeborene Urethrafehlbildung",
      "Angeborene Urethrahernie",
      "Angeborene Urethrozele",
      "Angeborene rektovesikale Fistel",
      "Angeborene urethrorektale Fistel",
      "Angeborener Prolaps der Harnblasenschleimhaut",
      "Angeborener Prolaps des Meatus urinarius",
      "Angeborener Urethraprolaps",
      "Anomalie des Ductus paraurethralis",
      "Anomalie des Meatus urinarius a.n.k.",
      "Anomalie des Orificium urethrae a.n.k.",
      "Anteriore Urethralklappen",
      "Blasenmissbildung",
      "Doppelte Harnblase",
      "Doppelte Harnröhre",
      "Doppelte Urethra",
      "Doppelter Meatus urinarius",
      "Duplikatur des Meatus urinarius",
      "Harnblasenhypoplasie",
      "Harnblasenmissbildung",
      "Harnblasenverformung",
      "Harnröhrenanomalie a.n.k.",
      "Harnröhrendoppelung",
      "Kongenitale Harnblasendilatation",
      "Kongenitale Harnblasenhernie",
      "Kongenitale Harnröhrendivertikulitis",
      "Kongenitale Harnröhrendivertikulose",
      "Kongenitale Sanduhrkontraktur der Harnblase",
      "Kongenitale Schrumpfharnblase",
      "Kongenitale Urethradivertikulitis",
      "Kongenitale Urethradivertikulose",
      "Kongenitale Urethrafistel",
      "Kongenitale periurethrale Zyste",
      "Kongenitale rektourethrale Fistel",
      "Kongenitale rektovesikale Fistel",
      "Kongenitale urethrorektale Fistel",
      "Kongenitale vesikorektale Fistel",
      "Kongenitaler Harnblasenprolaps",
      "Kongenitaler Urethraprolaps",
      "Kongenitales Harnröhrendivertikel",
      "Kongenitales Urethradivertikel",
      "Megalourethra",
      "Megazystis",
      "Paramedianes Ostium urethrae internum",
      "Paraurethraler Gang",
      "Urethraanomalie a.n.k.",
      "Urethraduplikatur",
      "Urethraspaltung",
      "Urethraverdoppelung",
      "Urethraverformung",
      "Verdoppelung des Meatus urinarius"
    ]
  },
  {
    "code": "Q64.8",
    "name": "Harnwegedoppelung",
    "synonyms": [
      "Agenesie der Harnorgane a.n.k.",
      "Akzessorische Harnorgane a.n.k.",
      "Atresie der Harnorgane a.n.k.",
      "Blasenscheitel-Nabel-Fistel",
      "Harntraktdoppelung",
      "Harnwegedoppelung",
      "Vesikoumbilikale Fistel"
    ]
  },
  {
    "code": "Q64.9",
    "name": "Harnwegsanomalie",
    "synonyms": [
      "Angeborene Abflussbehinderung der Harnwege",
      "Angeborene Deformität des Harnsystems",
      "Angeborene Harntraktdeformität",
      "Anomalie der Harnorgane",
      "Anomalie des Harnsystems",
      "Fehlbildung der Harnorgane",
      "Harnwegsanomalie"
    ]
  },
  {
    "code": "Q65.0",
    "name": "Einseitige angeborene Hüftgelenkluxation",
    "synonyms": [
      "Einseitige Luxatio coxae congenita",
      "Einseitige angeborene Hüftgelenkluxation",
      "Einseitige kongenitale Hüftdislokation"
    ]
  },
  {
    "code": "Q65.1",
    "name": "Beidseitige angeborene Hüftgelenkluxation",
    "synonyms": [
      "Beidseitige Luxatio coxae congenita",
      "Beidseitige angeborene Hüftgelenkluxation",
      "Beidseitige kongenitale Hüftdislokation"
    ]
  },
  {
    "code": "Q65.2",
    "name": "Angeborene Hüftgelenkluxation",
    "synonyms": [
      "Angeborene Hüftgelenkluxation",
      "Kongenitale Hüftdislokation",
      "Kongenitale Hüftluxation",
      "Luxatio coxae congenita"
    ]
  },
  {
    "code": "Q65.3",
    "name": "Angeborene einseitige Subluxation des Hüftgelenks",
    "synonyms": [
      "Angeborene einseitige Subluxation des Hüftgelenks"
    ]
  },
  {
    "code": "Q65.4",
    "name": "Angeborene beidseitige Subluxation des Hüftgelenks",
    "synonyms": [
      "Angeborene beidseitige Subluxation des Hüftgelenks"
    ]
  },
  {
    "code": "Q65.5",
    "name": "Angeborene Hüftgelenksubluxation",
    "synonyms": [
      "Angeborene Hüftgelenksubluxation"
    ]
  },
  {
    "code": "Q65.6",
    "name": "Angeborenes instabiles Hüftgelenk",
    "synonyms": [
      "Angeborene Präluxation der Hüfte",
      "Angeborene dislozierbare Hüfte",
      "Angeborene luxierbare Hüfte",
      "Angeborenes instabiles Hüftgelenk",
      "Hüftgelenkinstabilität",
      "Hüftgelenkreifungsverzögerung",
      "Luxierbare Hüfte",
      "Subluxierbare Hüfte"
    ]
  },
  {
    "code": "Q65.8",
    "name": "Angeborene Coxa vara",
    "synonyms": [
      "Angeborene Azetabulumdysplasie",
      "Angeborene Coxa valga",
      "Angeborene Coxa vara",
      "Angeborene Flexionsdeformität des Hüftgelenks",
      "Angeborene Hüftgelenkkrankheit",
      "Angeborene Rotationsdeformität des Hüftgelenks",
      "Angeborene vermehrte Antetorsion des Oberschenkelhalses",
      "Anomale Hüftflexion",
      "Anomale Oberschenkelflexion",
      "Cilliers-Beighton-Syndrom",
      "Coxa valga congenita",
      "Coxa vara congenita",
      "Dysplasiehüfte",
      "Hüftdysplasie",
      "Hüftdysplasie Typ Beukes",
      "Hüftgelenkdysplasie",
      "Kongenitale Hüftdysplasie",
      "Kongenitale Hüftgelenkkontraktur",
      "Kongenitale Hüftverkürzung",
      "Kongenitale Lageanomalie des Hüftgelenks",
      "Leichte Dysplasiehüfte",
      "Leichte Hüftdysplasie",
      "Leichte Hüftgelenkdysplasie",
      "Rotationsanomalie der Hüfte",
      "Rotationsanomalie des Oberschenkels",
      "Schwere Dysplasiehüfte",
      "Schwere Hüftdysplasie",
      "Schwere Hüftgelenkdysplasie",
      "Vermehrte Antetorsion des Oberschenkelhalses"
    ]
  },
  {
    "code": "Q65.9",
    "name": "Angeborene Hüftdeformität",
    "synonyms": [
      "Angeborene Hüftdeformität"
    ]
  },
  {
    "code": "Q66.0",
    "name": "Klumpfuß",
    "synonyms": [
      "Familiärer Klumpfuß ohne Anomalie der unteren Extremitäten",
      "Klumpfuß",
      "Kongenitaler Klumpfuß",
      "Kongenitaler Pes equinovarus",
      "Kongenitaler Spitz-Klumpfuß",
      "Pes equinovarus",
      "Pes equinovarus congenitus",
      "Pes varus congenitus",
      "Spitz-Klumpfuß"
    ]
  },
  {
    "code": "Q66.1",
    "name": "Pes calcaneovarus congenitus",
    "synonyms": [
      "Pes calcaneovarus congenitus"
    ]
  },
  {
    "code": "Q66.2",
    "name": "Sichelfuß",
    "synonyms": [
      "Angeborener Sichelfuß",
      "Kongenitaler Metatarsus varus",
      "Kongenitaler Metatarsus varus adductus",
      "Pes adductus",
      "Pes adductus congenitus",
      "Sichelfuß"
    ]
  },
  {
    "code": "Q66.3",
    "name": "Metatarsus primus varus congenitus",
    "synonyms": [
      "Angeborene Varusdeformität des Fußes a.n.k.",
      "Hallux varus congenitus",
      "Metatarsus primus varus congenitus",
      "Varusanomalie des Fußes"
    ]
  },
  {
    "code": "Q66.4",
    "name": "Pes calcaneovalgus congenitus",
    "synonyms": [
      "Angeborener Hacken-Knickfuß",
      "Angeborener Knick-Hackenfuß",
      "Hacken-Knickfuß",
      "Knick-Hackenfuß",
      "Pes calcaneovalgus congenitus"
    ]
  },
  {
    "code": "Q66.5",
    "name": "Pes planus congenitus",
    "synonyms": [
      "Angeborene spastische Fußabflachung",
      "Angeborener Plattfuß",
      "Angeborener Senkfuß",
      "Evertierter Senkfuß",
      "Kongenitale Fußabflachung",
      "Kongenitale Fußgewölberelaxation",
      "Kontrakte Fußabflachung",
      "Kontrakter Plattfuß",
      "Kontrakter Senkfuß",
      "Pes planus congenitus",
      "Spastischer Senkfuß",
      "Spastischer evertierter Plattfuß"
    ]
  },
  {
    "code": "Q66.6",
    "name": "Knickfuß",
    "synonyms": [
      "Angeborene Valgusdeformität des Fußes a.n.k.",
      "Angeborener Knick-Plattfuß",
      "Angeborener Knick-Senkfuß",
      "Angeborener Metatarsus valgus",
      "Knick-Plattfuß",
      "Knick-Senkfuß",
      "Knickfuß",
      "Kongenitale Fußeversion a.n.k.",
      "Kongenitaler Hallux valgus",
      "Kongenitaler Knickfuß",
      "Metatarsus valgus",
      "Pes equinovalgus congenitus",
      "Pes planovalgus congenitus",
      "Pes valgus",
      "Senk-Knickfuß"
    ]
  },
  {
    "code": "Q66.7",
    "name": "Hohlfuß",
    "synonyms": [
      "Ballenhohlfuß",
      "Hohl-Spreizfuß",
      "Hohlfuß",
      "Kongenitaler Hohlfuß",
      "Pes cavus",
      "Pes excavatus congenitus"
    ]
  },
  {
    "code": "Q66.8",
    "name": "Angeborener Kletterfuß",
    "synonyms": [
      "Angeborene Hammerzehe",
      "Angeborene Mittelfußdeformität",
      "Angeborener Hackenfuß",
      "Angeborener Kletterfuß",
      "Angeborener Spitzfuß",
      "Asymmetrischer Talipes",
      "Fusion tarsaler Knochenkerne",
      "Fußasymmetrie",
      "Hackenfuß",
      "Kalkaneus-Navikulare-Fusion",
      "Klauenfuß",
      "Klauenhohlfuß",
      "Klauenzehe",
      "Knick-Hohl-Spreizfuß",
      "Knick-Platt-Spreizfuß",
      "Knick-Spreizfuß",
      "Kongenitale Achillessehnenkontraktur",
      "Kongenitale Hammerzehe",
      "Kongenitale Klauenzehe",
      "Kongenitale Mittelfußverkürzung",
      "Kongenitale Sehnenverkürzung mit Gelenkkontraktur",
      "Kongenitaler Klauenfuß",
      "Kongenitaler Spitzfuß",
      "Kongenitaler Spreizfuß",
      "Kongenitaler Talus verticalis",
      "Kongenitaler vertikaler Talus",
      "Krallenfuß",
      "Krallenzehe",
      "Pes calcaneus congenitus",
      "Pes equinus congenitus",
      "Pes transversus",
      "SSF [Senk-Spreizfuß] - s.a. Senk-Spreizfuß",
      "Senk-Knick-Spreizfuß",
      "Senk-Spreizfuß",
      "Spitzfuß",
      "Spreizfuß",
      "Talipes",
      "Talus bipartitus",
      "Talus verticalis",
      "Tarsale Koalition",
      "Verschmelzung tarsaler Knochenkerne"
    ]
  },
  {
    "code": "Q66.9",
    "name": "Angeborene Fußdeformität",
    "synonyms": [
      "Angeborene Fersendeformität",
      "Angeborene Fußdeformität",
      "Angeborene Zehendeformität",
      "Fußverformung",
      "Kongenitale Lageanomalie einer Zehe",
      "Kongenitale Lageanomalie eines Fußes",
      "Zehenverformung"
    ]
  },
  {
    "code": "Q67.0",
    "name": "Gesichtsasymmetrie",
    "synonyms": [
      "Gesichtsasymmetrie",
      "Hemifaziale Myohyperplasie"
    ]
  },
  {
    "code": "Q67.1",
    "name": "Flach gedrücktes Gesicht",
    "synonyms": [
      "Flach gedrücktes Gesicht"
    ]
  },
  {
    "code": "Q67.2",
    "name": "Dolichozephalie",
    "synonyms": [
      "Dolichozephalie",
      "Dolichozephalus"
    ]
  },
  {
    "code": "Q67.3",
    "name": "Plagiozephalie",
    "synonyms": [
      "Einseitige nicht-syndromale Koronarnahtsynostose",
      "Isolierte Plagiozephalie",
      "Isolierte frontale Plagiozephalie",
      "Isolierte okzipitale Plagiozephalie",
      "Nicht-syndromale anteriore synostotische Plagiozephalie",
      "Plagiozephalie",
      "Plagiozephalus"
    ]
  },
  {
    "code": "Q67.4",
    "name": "Asymmetrie des Schädels beim Säugling",
    "synonyms": [
      "Angeborene Hakennase",
      "Angeborene Nasenscheidewanddeviation",
      "Angeborene Nasenscheidewandverbiegung",
      "Angeborene Nasenseptumdeviation",
      "Angeborene Nasenseptumverbiegung",
      "Angeborene Plattnase",
      "Angeborene Rhinoseptumdeviation",
      "Angeborene Rhinoseptumverbiegung",
      "Angeborene Septumdeviation",
      "Angeborene Septumverbiegung",
      "Angeborene hemifaziale Atrophie",
      "Asymmetrie des Schädels beim Säugling",
      "Bencze-Syndrom",
      "Deviatio septi nasi congenitalis",
      "Faziale Hemihypertrophie",
      "Gesichtshemiatrophie",
      "Gesichtshemihypertrophie",
      "Hemiatrophia faciei",
      "Hemifaziale Hypertrophie",
      "Holtermüller-Wiedemann-Syndrom",
      "Höckernase",
      "Isolierte Pachyzephalie",
      "Isolierte kongenitale Syngnathie",
      "Kongenitale Anomalie der Schädelknochen und Gesichtsknochen",
      "Kongenitale Nasenscheidewanddeviation",
      "Kongenitale Nasenseptumdeviation",
      "Kongenitale Nasenseptumverbiegung",
      "Kongenitale Schädelknochenanomalie",
      "Plattnase",
      "Rhinokyphose",
      "Schädeleindellung"
    ]
  },
  {
    "code": "Q67.5",
    "name": "Dysplasia spondylothoracica",
    "synonyms": [
      "Angeborene Kyphoskoliose",
      "Angeborene Skoliose",
      "Angeborene Wirbelsäulendeformität",
      "Angeborene lagebedingte Skoliose",
      "Dysplasia spondylothoracica",
      "Kongenitale Kyphoskoliose",
      "Kongenitale Skoliose",
      "Kongenitale Wirbelsäulenverkrümmung",
      "Lavy-Palmer-Merritt-Syndrom"
    ]
  },
  {
    "code": "Q67.6",
    "name": "Trichterbrust",
    "synonyms": [
      "Angeborene Trichterbrust",
      "Kongenitale Trichterbrust",
      "Pectus excavatum",
      "Trichterbrust"
    ]
  },
  {
    "code": "Q67.7",
    "name": "Pectus carinatum",
    "synonyms": [
      "Angeborene Kielbrust",
      "Pectus carinatum"
    ]
  },
  {
    "code": "Q67.8",
    "name": "Angeborene Brustkorbdeformität",
    "synonyms": [
      "Angeborene Brustkorbdeformität",
      "Angeborene Brustwandanomalie",
      "Angeborene Brustwanddeformität",
      "Angeborene Thoraxdeformität",
      "Angeborene Thoraxwanddeformität",
      "Anomalie der Thoraxwand",
      "Kongenitale Thoraxabflachung",
      "Thoraxanomalie",
      "Verformung der Thoraxwand"
    ]
  },
  {
    "code": "Q68.0",
    "name": "Angeborene Deformität des Musculus sternocleidomastoideus",
    "synonyms": [
      "Angeborene Deformität des Musculus sternocleidomastoideus",
      "Angeborene Kontraktur des Sternocleidomastoideus",
      "Angeborener Tortikollis",
      "Angeborenes Kopfnickerhämatom",
      "Kongenitaler Tortikollis",
      "Kongenitaler muskulärer Tortikollis",
      "Kontraktur des Musculus sternocleidomastoideus",
      "Kopfnickerhämatom",
      "Torticollis congenitus muscularis"
    ]
  },
  {
    "code": "Q68.1",
    "name": "Angeborene Handdeformität",
    "synonyms": [
      "Angeborene Daumendeformität a.n.k.",
      "Angeborene Fingerdeformität",
      "Angeborene Handdeformität",
      "Angeborene Handgelenkdeformität",
      "Angeborene Krallenhand",
      "Angeborene Löffelhand",
      "Angeborener Klumpfinger",
      "Familiäre isolierte Klinodaktylie der Finger",
      "Fingerverformung",
      "Flossenhand",
      "Handgelenkverformung",
      "Handknochenverformung",
      "Isolierte kongenitale Trommelschlegelfinger",
      "Kamptodaktylie der Finger",
      "Kamptodaktylie mit Taurinurie",
      "Kongenitale Fehlbildung der Finger",
      "Kongenitale Fingerkontraktur",
      "Kongenitale Klauenhand",
      "Kongenitale Krallenhand",
      "Kongenitale Lageanomalie einer Hand",
      "Kongenitale Lageanomalie eines Fingers",
      "Löffelhand"
    ]
  },
  {
    "code": "Q68.2",
    "name": "Angeborene Kniedeformität a.n.k.",
    "synonyms": [
      "Angeborene Kniedeformität a.n.k.",
      "Angeborene Kniegelenkluxation",
      "Angeborene Patelladeformität",
      "Angeborenes Genu recurvatum",
      "Kniegelenkverformung",
      "Kongenitale Kniedislokation",
      "Kongenitales Genu extrorsum",
      "Patellaverformung"
    ]
  },
  {
    "code": "Q68.3",
    "name": "Angeborene Verbiegung des Femurs",
    "synonyms": [
      "Angeborene Verbiegung des Femurs"
    ]
  },
  {
    "code": "Q68.4",
    "name": "Angeborene Verbiegung von Tibia und Fibula",
    "synonyms": [
      "Angeborene Fibulaverbiegung",
      "Angeborene Verbiegung von Tibia und Fibula",
      "Kongenitale Tibia recurvata"
    ]
  },
  {
    "code": "Q68.5",
    "name": "Angeborene Verbiegung der langen Beinknochen",
    "synonyms": [
      "Angeborene Verbiegung der langen Beinknochen"
    ]
  },
  {
    "code": "Q68.8",
    "name": "Arthrogryposis",
    "synonyms": [
      "Angeborene Armdeformität",
      "Angeborene Beindeformität",
      "Angeborene Ellenbogendeformität",
      "Angeborene Ellenbogendislokation",
      "Angeborene Ellenbogenluxation",
      "Angeborene Extremitätendeformität, ausgenommen Reduktionsdefekt",
      "Angeborene Flexionsdeformität a.n.k.",
      "Angeborene Gelenkdeformität",
      "Angeborene Gliedmaßendeformität, ausgenommen Reduktionsdeformität",
      "Angeborene Klavikuladeformität",
      "Angeborene Knöcheldeformität a.n.k.",
      "Angeborene Oberschenkeldeformität a.n.k.",
      "Angeborene Radiusdeformität",
      "Angeborene Radiuskopfdislokation",
      "Angeborene Schulterblattdeformität",
      "Angeborene Schultergelenkdislokation",
      "Angeborene Schultergelenkluxation",
      "Angeborene Schulterluxation",
      "Angeborene Skapuladeformität",
      "Angeborene Tibiadeformität a.n.k.",
      "Angeborene Ulnadeformität a.n.k.",
      "Angeborene Unterarmdeformität",
      "Angeborene Unterschenkeldeformität",
      "Angeborener Cubitus valgus",
      "Angeborener Cubitus varus",
      "Angeborenes verkürztes Ligamentum transversum scapulae superius",
      "Armverformung a.n.k.",
      "Arthrogryposis",
      "Arthrogryposis congenita",
      "Beals-Syndrom",
      "Beidseitige angeborene Ellenbogendislokation",
      "Beinverformung a.n.k.",
      "Distale Arthrogryposis Typ 1",
      "Distale Arthrogryposis Typ 10",
      "Distale Arthrogryposis Typ 2B",
      "Distale Arthrogryposis Typ 3",
      "Distale Arthrogryposis Typ 4",
      "Distale Arthrogryposis Typ 5",
      "Distale Arthrogryposis Typ 5D",
      "Distale Arthrogryposis Typ 6",
      "Distale Arthrogryposis Typ 7",
      "Distale Arthrogryposis Typ 9",
      "Einseitige angeborene Ellenbogendislokation",
      "Femurverformung a.n.k.",
      "Fibulaverformung a.n.k.",
      "Hecht-Syndrom",
      "Humerusverformung a.n.k.",
      "Kongenitale Dislokation a.n.k.",
      "Kongenitale Ellenbogendislokation",
      "Kongenitale Lageanomalie eines Gelenks a.n.k.",
      "Kongenitale Lageanomalie von Gliedmaßen",
      "Kongenitale Schulterdislokation",
      "Kongenitale Schultergelenksubluxation",
      "Kongenitale Subluxation eines Gelenks der oberen Gliedmaßen",
      "Kongenitale Subluxation eines Gelenks der unteren Gliedmaßen, ausgenommen Hüfte",
      "Kongenitale Verbiegung der langen Knochen",
      "Kongenitale kontrakturale Arachnodaktylie",
      "Kongenitale multiple Gelenkstarre",
      "Kongenitale multiple artikuläre Rigiditäten",
      "Pleonosteose Leri",
      "Radiusverformung a.n.k.",
      "Sheldon-Hall-Syndrom",
      "Syndrom der angeborenen letalen Kontrakturen",
      "Syndrom der angeborenen letalen Kontrakturen Typ 1",
      "Syndrom der angeborenen letalen Kontrakturen Typ 2",
      "Syndrom der angeborenen letalen Kontrakturen Typ 3",
      "Tibiaverformung a.n.k.",
      "Trismus-Pseudokamptodaktylie-Syndrom",
      "Ulnaverformung a.n.k."
    ]
  },
  {
    "code": "Q69.0",
    "name": "Akzessorischer Finger",
    "synonyms": [
      "Akzessorischer Finger",
      "Polydaktylie des Zeigefingers",
      "Postaxiale Polydaktylie Typ A",
      "Postaxiale Polydaktylie Typ B",
      "Zentrale Polydaktylie der Finger"
    ]
  },
  {
    "code": "Q69.1",
    "name": "Akzessorischer Daumen",
    "synonyms": [
      "Akzessorischer Daumen",
      "Polydaktylie des biphalangealen Daumens",
      "Polydaktylie des triphalangealen Daumens"
    ]
  },
  {
    "code": "Q69.2",
    "name": "Akzessorische Zehe",
    "synonyms": [
      "Akzessorische Großzehe",
      "Akzessorische Zehe",
      "Kongenitale Lageanomalie einer überzähligen Zehe",
      "Postaxiale Polydaktylie der Zehen",
      "Präaxiale Polydaktylie der Zehen",
      "Zentrale Polydaktylie der Zehen"
    ]
  },
  {
    "code": "Q69.9",
    "name": "Polydaktylie",
    "synonyms": [
      "Digitus accessorius",
      "Hexadaktylie",
      "Hyperdaktylie",
      "Polydaktylie",
      "Sechsfingrigkeit",
      "Spiegelbild-Polydaktylie",
      "Überzählige Zehe",
      "Überzähliger Finger"
    ]
  },
  {
    "code": "Q70.0",
    "name": "Miteinander verwachsene Finger",
    "synonyms": [
      "Fingerfusion",
      "Fingersyndaktylie mit Synostose",
      "Knöcherne Fingersyndaktylie",
      "Knöcherne Fingersyndaktylie Typ 3",
      "Komplexe Fingersyndaktylie",
      "Kongenitale Fingeradhäsion",
      "Miteinander verwachsene Finger",
      "Syndaktylie Typ 8",
      "Versagen der Fingersegmentation",
      "Verwachsene Finger"
    ]
  },
  {
    "code": "Q70.1",
    "name": "Schwimmhautbildung der Finger",
    "synonyms": [
      "Distalisierte Zwischenfingerfalte",
      "Häutige Fingersyndaktylie",
      "Häutige Fingersyndaktylie Typ 3",
      "Häutige Fingersyndaktylie ohne Synostose",
      "Komplette häutige Syndaktylie von Fingern",
      "Partielle häutige Syndaktylie von Fingern",
      "Schwimmhautbildung der Finger",
      "Syndaktylie Typ 3"
    ]
  },
  {
    "code": "Q70.2",
    "name": "Miteinander verwachsene Zehen",
    "synonyms": [
      "Knöcherne Zehensyndaktylie",
      "Komplexe Zehensyndaktylie",
      "Kongenitale Zehenadhäsion",
      "Miteinander verwachsene Zehen",
      "Versagen der Zehensegmentation",
      "Verwachsene Zehen",
      "Zehenfusion",
      "Zehensyndaktylie mit Synostose"
    ]
  },
  {
    "code": "Q70.3",
    "name": "Schwimmhautbildung der Zehen",
    "synonyms": [
      "Häutige Zehensyndaktylie",
      "Häutige Zehensyndaktylie ohne Synostose",
      "Schwimmhautbildung der Zehen"
    ]
  },
  {
    "code": "Q70.4",
    "name": "Polysyndaktylie",
    "synonyms": [
      "Gekreuzte Polysyndaktylie",
      "Mesoaxiale synostotische Syndaktylie mit Reduktion der Phalangen",
      "Polysyndaktylie",
      "Syndaktylie Typ 1",
      "Syndaktylie Typ 2",
      "Syndaktylie Typ 4",
      "Syndaktylie Typ 5",
      "Syndaktylie Typ 6",
      "Syndaktylie Typ Malik-Percin"
    ]
  },
  {
    "code": "Q70.9",
    "name": "Syndaktylie",
    "synonyms": [
      "Distaler Symphalangismus",
      "Einfache häutige Syndaktylie ohne Synostose",
      "Komplexe knöcherne Syndaktylie mit Synostose",
      "Proximaler Symphalangismus",
      "Symphalangie",
      "Syndaktylie"
    ]
  },
  {
    "code": "Q71.0",
    "name": "Angeborenes vollständiges Fehlen der oberen Extremität",
    "synonyms": [
      "Agenesie der oberen Gliedmaßen",
      "Amelie der oberen Extremitäten",
      "Amelie einer oberen Extremität",
      "Angeborenes Fehlen eines Arms",
      "Angeborenes vollständiges Fehlen der oberen Extremität",
      "Aplasie der oberen Gliedmaßen",
      "Monobrachius",
      "Vollständige Armagenesie"
    ]
  },
  {
    "code": "Q71.1",
    "name": "Angeborenes Fehlen von Oberarm und Unterarm bei vorhandener Hand",
    "synonyms": [
      "Agenesie der oberen Gliedmaßen bei vorhandener Hand",
      "Angeborenes Fehlen von Oberarm und Unterarm bei vorhandener Hand",
      "Phokomelie der oberen Gliedmaßen"
    ]
  },
  {
    "code": "Q71.2",
    "name": "Angeborenes Fehlen von Unterarm und Hand",
    "synonyms": [
      "Angeborenes Fehlen von Unterarm und Hand"
    ]
  },
  {
    "code": "Q71.3",
    "name": "Fingeradaktylie",
    "synonyms": [
      "Acheirie",
      "Agenesie der Hand",
      "Agenesie der Mittelhandknochen",
      "Angeborenes Fehlen der Hand",
      "Angeborenes Fehlen eines Daumens",
      "Angeborenes Fehlen eines Fingers",
      "Daumenaplasie",
      "Einseitige Adaktylie der Hand",
      "Fingeradaktylie",
      "Fingeragenesie",
      "Fingeraplasie",
      "Handwurzelagenesie",
      "Kongenitale Aplasie des Daumens"
    ]
  },
  {
    "code": "Q71.4",
    "name": "Longitudinaler Reduktionsdefekt des Radius",
    "synonyms": [
      "Angeborene Klumphand",
      "Angeborenes Fehlen des Radius",
      "Klumphand",
      "Kongenitale Radiusverkürzung",
      "Kongenitale longitudinale Radiusdefizienz",
      "Longitudinaler Reduktionsdefekt des Radius",
      "Radiale Hemimelie",
      "Radiale Klumphand",
      "Radiale longitudinale Meromelie",
      "Radiusagenesie",
      "Radiusaplasie"
    ]
  },
  {
    "code": "Q71.5",
    "name": "Longitudinaler Reduktionsdefekt der Ulna",
    "synonyms": [
      "Longitudinaler Reduktionsdefekt der Ulna",
      "Ulnaagenesie",
      "Ulnare Hemimelie"
    ]
  },
  {
    "code": "Q71.6",
    "name": "Spalthand",
    "synonyms": [
      "Handspaltung",
      "Spalthand"
    ]
  },
  {
    "code": "Q71.8",
    "name": "Brachydaktylie der Finger",
    "synonyms": [
      "Angeborene Fingerhypoplasie",
      "Angeborene Handwurzelhypoplasie",
      "Angeborene Humerushypoplasie",
      "Angeborene Ulnahypoplasie",
      "Angeborene Verkürzung der oberen Extremität",
      "Brachydaktylie der Finger",
      "Brachydaktyliesyndrom der Finger",
      "Einseitige Hypodaktylie der Handphalangen 2-5",
      "Ektrodaktylie der Finger",
      "Fingerperodaktylie",
      "Hemimelie der oberen Gliedmaßen",
      "Humerusagenesie",
      "Humerushypoplasie",
      "Kongenitale Armverkürzung",
      "Kongenitale Hypoplasie des Daumens",
      "Mesomele Dysplasie der oberen Extremität",
      "Mittelhandhypoplasie",
      "Radioulnare Agenesie",
      "Radioulnare Hypoplasie",
      "Radiushypoplasie"
    ]
  },
  {
    "code": "Q71.9",
    "name": "Reduktionsdefekt der oberen Extremität",
    "synonyms": [
      "Angeborene Armhypoplasie",
      "Ektromelie der oberen Extremität",
      "Hypoplasie der oberen Extremität",
      "Reduktionsdefekt der oberen Extremität",
      "Reduktionsdeformität der oberen Extremität",
      "Rudimentärer Arm"
    ]
  },
  {
    "code": "Q72.0",
    "name": "Monopodie",
    "synonyms": [
      "Agenesie der unteren Gliedmaßen",
      "Amelie der unteren Extremitäten",
      "Amelie einer unteren Extremität",
      "Angeborenes vollständiges Fehlen der unteren Extremität",
      "Aplasie der unteren Gliedmaßen",
      "Monopodie",
      "Vollständige Beinagenesie"
    ]
  },
  {
    "code": "Q72.1",
    "name": "Angeborenes Fehlen von Oberschenkel und Unterschenkel bei vorhandenem Fuß",
    "synonyms": [
      "Angeborenes Fehlen von Oberschenkel und Unterschenkel bei vorhandenem Fuß",
      "Phokomelie der unteren Gliedmaßen"
    ]
  },
  {
    "code": "Q72.2",
    "name": "Angeborenes Fehlen von Unterschenkel und Fuß",
    "synonyms": [
      "Agenesie von Unterschenkel und Fuß",
      "Angeborenes Fehlen von Unterschenkel und Fuß",
      "Angeborenes beidseitiges Fehlen der Unterschenkel und Füße"
    ]
  },
  {
    "code": "Q72.3",
    "name": "Zehenadaktylie",
    "synonyms": [
      "Agenesie der Fußwurzelknochen",
      "Agenesie der Mittelfußknochen",
      "Angeborene Fehlen von Fuß und Knöchel",
      "Angeborenes Fehlen einer Zehe",
      "Apodie",
      "Fußagenesie",
      "Zehenadaktylie",
      "Zehenagenesie",
      "Zehenaplasie"
    ]
  },
  {
    "code": "Q72.4",
    "name": "Longitudinaler Reduktionsdefekt des Femurs",
    "synonyms": [
      "Angeborenes Fehlen des Femurs",
      "Femur-Fibula-Ulna-Dysostose",
      "Femur-Fibula-Ulna-Komplex",
      "Femur-Fibula-Ulna-Syndrom",
      "Femuragenesie",
      "Femurhypoplasie",
      "Kongenitale Femurverkürzung",
      "Kongenitale Oberschenkelverkürzung",
      "Longitudinaler Reduktionsdefekt des Femurs",
      "Proximal femoral focal deficiency",
      "Proximaler angeborener Femurdefekt"
    ]
  },
  {
    "code": "Q72.5",
    "name": "Longitudinaler Reduktionsdefekt der Tibia",
    "synonyms": [
      "Longitudinaler Reduktionsdefekt der Tibia",
      "Tibiaagenesie",
      "Tibiale Hemimelie"
    ]
  },
  {
    "code": "Q72.6",
    "name": "Longitudinaler Reduktionsdefekt der Fibula",
    "synonyms": [
      "Fibulaagenesie",
      "Fibulare Hemimelie",
      "Fibulare longitudinale Meromelie",
      "Kongenitaler longitudinaler Reduktionsdefekt der Fibula",
      "Longitudinaler Reduktionsdefekt der Fibula"
    ]
  },
  {
    "code": "Q72.7",
    "name": "Spaltfuß",
    "synonyms": [
      "Fußspaltung",
      "Spaltfuß"
    ]
  },
  {
    "code": "Q72.8",
    "name": "Angeborene Beinverkürzung",
    "synonyms": [
      "Angeborene Beinverkürzung",
      "Angeborene Femurhypoplasie",
      "Angeborene Fibulahypoplasie",
      "Angeborene Verkürzung der unteren Extremität",
      "Angeborene tibiofibulare Hypoplasie",
      "Angeborenes Fehlen eines Beins",
      "Brachydaktylie der Zehen",
      "Brachydaktyliesyndrom der Zehen",
      "Ektrodaktylie einer Zehen",
      "Fußwurzelhypoplasie",
      "Hemimelie der unteren Gliedmaßen",
      "Mittelfußhypoplasie",
      "Tibiahypoplasie",
      "Tibiofibulare Agenesie",
      "Unterschenkelagenesie",
      "Zehenhypoplasie"
    ]
  },
  {
    "code": "Q72.9",
    "name": "Reduktionsdefekt der unteren Extremität",
    "synonyms": [
      "Angeborene Beinhypoplasie",
      "Angeborene Beinlängendifferenz",
      "Ektromelie der unteren Extremität",
      "Hypoplasie der unteren Extremität",
      "Kongenitale Ungleichmäßigkeit der Beine",
      "Reduktionsdefekt der unteren Extremität",
      "Reduktionsdeformität der unteren Extremität",
      "Zehenperodaktylie"
    ]
  },
  {
    "code": "Q73.0",
    "name": "Amelie",
    "synonyms": [
      "Amelie",
      "Angeborenes Fehlen einer Extremität",
      "Autosomal-rezessive Amelie",
      "Kongenitale Gliedmaßenaplasie",
      "Tetraamelie",
      "Vollständige Gliedmaßenagenesie"
    ]
  },
  {
    "code": "Q73.1",
    "name": "Phokomelie",
    "synonyms": [
      "Phokomelie"
    ]
  },
  {
    "code": "Q73.8",
    "name": "Dysmelie",
    "synonyms": [
      "Acheiropodie",
      "Angeborene Reduktionsdeformität einer Extremität",
      "Brachydaktylie",
      "Brachydaktylie Typ A1",
      "Brachydaktylie Typ A2",
      "Brachydaktylie Typ A4",
      "Brachydaktylie Typ A5",
      "Brachydaktylie Typ A6",
      "Brachydaktylie Typ A7",
      "Brachydaktylie Typ B",
      "Brachydaktylie Typ B2",
      "Brachydaktylie Typ C",
      "Brachydaktylie Typ E",
      "Brachydaktylie-Syndrom",
      "Du-Pan-Syndrom",
      "Dysmelie",
      "Dysmelie-Syndrom",
      "Ektrodaktylie",
      "Ektromelie",
      "Extremitätenektromelie",
      "Extremitätenhemimelie",
      "Extremitätenhypoplasie",
      "Extremitätenreduktionsdefekt",
      "Fibula-Aplasie mit Ektrodaktylie",
      "Fibulaaplasie mit komplexer Brachydaktylie",
      "Gollop-Wolfgang-Komplex",
      "Hemiektromelie",
      "Hemimelie",
      "Liebenberg-Syndrom",
      "Longitudinale Meromelie",
      "Longitudinale Reduktionsdeformität einer Extremität",
      "Mikromelie",
      "Perodaktylie",
      "Peromelie",
      "Radiusaplasie-Tibiahypoplasie-Syndrom",
      "Sommer-Hines-Syndrom",
      "Sugarman-Brachydaktylie",
      "Symbrachydaktylie der Hände und Füße",
      "Tetramele postaxiale Oligodaktylie",
      "Tibiaaplasie mit Ektrodaktylie",
      "Ulnahypoplasie-Spaltfuß-Syndrom"
    ]
  },
  {
    "code": "Q74.0",
    "name": "Craniocleidodysostosis",
    "synonyms": [
      "Akzessorischer Handwurzelknochen",
      "Akzessorisches Kahnbein des Handgelenks",
      "Akzessorisches Sesambein der Hand",
      "Angeborene Fusion der oberen Extremität",
      "Angeborene Handgelenkverkrümmung",
      "Angeborene Humerusdeformität",
      "Angeborene Klavikulahypoplasie",
      "Angeborene Megalodaktylie",
      "Angeborene Mittelhanddeformität",
      "Angeborene Pseudarthrose der Ulna",
      "Angeborene Pseudarthrose des Schlüsselbeins",
      "Angeborene Pseudoarthrose der Klavikula",
      "Angeborene Schlüsselbeinhypoplasie",
      "Angeborene Schulterdeformität",
      "Angeborene Sprengel-Deformität",
      "Angeborener Schulterblatthochstand",
      "Angeborener Schulterhochstand",
      "Anomalie der oberen Gliedmaßen",
      "Aplasie der Trochlea humeri",
      "Armanomalie",
      "Beidseitige Makrodaktylie der Finger",
      "Beidseitige humeroulnare Synostose",
      "Beidseitige radioulnare Synostose",
      "Craniocleidodysostosis",
      "Daumenanomalie",
      "Dolichostenomelie",
      "Dreigliedriger Daumen",
      "Dysostosis cleidocranialis",
      "Einseitige Makrodaktylie der Finger",
      "Einseitige humeroulnare Synostose",
      "Einseitige radioulnare Synostose",
      "Ellenbogenanomalie",
      "Fingeranomalie",
      "Fingerfehlstellung",
      "Handanomalie",
      "Handgelenkanomalie",
      "Handwurzelanomalie",
      "Hapnes-Boman-Skeie-Syndrom",
      "Hereditäre kleidokraniale Dysostose",
      "Hultkrantz-Syndrom",
      "Humero-radial-ulnare Synostose",
      "Humeroradiale Synostose",
      "Humeroulnare Synostose",
      "Humerusanomalie",
      "Hyperphalangie der Finger",
      "Karpusanomalie",
      "Klavikulaagenesie",
      "Klavikulaanomalie",
      "Klavikulaverformung",
      "Kleidokraniale Dysostose",
      "Kleidokraniale Dysplasie",
      "Kongenital erhöhtes Schulterblatt",
      "Kongenitale Lageanomalie der Klavikula",
      "Kongenitale Lageanomalie der Schulter",
      "Kongenitale Lageanomalie der Skapula",
      "Kongenitale Pseudarthrose der Klavikula",
      "Kongenitale idiopathische progressive Radiusverkrümmung",
      "Kongenitale radioulnare Synostose",
      "Kongenitaler Hammerfinger",
      "Kongenitaler schnappender Finger",
      "Kongenitaler schnellender Finger",
      "Madelung-Deformität",
      "Makrodaktylie",
      "Makrodaktylie der Finger",
      "Makrodaktylie des Daumens",
      "Makrodaktylie eines Fingers",
      "Manus valga",
      "Megalodaktylie",
      "Megalodaktylie des Daumens",
      "Megalodaktylie eines Fingers",
      "Mittelhandanomalie",
      "Perobrachius",
      "Präaxiale Brachydaktylie und Syndaktylie der Finger",
      "Radioulnare Synostose",
      "Radiusanomalie",
      "Scheuthauer-Marie-Sainton-Syndrom",
      "Schlüsselbeinagenesie",
      "Schulteragenesie",
      "Schulteranomalie",
      "Schulterblatthypoplasie",
      "Schulterblattverformung",
      "Schultergelenkanomalie",
      "Schultergürtelanomalie",
      "Schultergürtelhypoplasie",
      "Schultergürtelverformung",
      "Skapulaagenesie",
      "Skapulaanomalie",
      "Spaltung des Os scaphoideum",
      "Sprengel-Deformität",
      "Sprengel-Syndrom",
      "Synostosis radioulnaris",
      "Triphalanger Daumen",
      "Triphalangie des Daumens",
      "Ulnaanomalie",
      "Unterarmanomalie"
    ]
  },
  {
    "code": "Q74.1",
    "name": "Angeborene Kniefehlbildung",
    "synonyms": [
      "Angeborene Kniefehlbildung",
      "Angeborene Patellaluxation",
      "Angeborene Varusstellung des Kniegelenks",
      "Angeborene Verlängerung des Ligamentum patellae",
      "Angeborenes Fehlen der Kniescheibe",
      "Angeborenes Fehlen der Patella",
      "Angeborenes Genu valgum",
      "Angeborenes Genu varum",
      "Aplasie der Patella",
      "Ischiopatellare Dysplasie",
      "Knieanomalie",
      "Kniescheibenagenesie",
      "Kniescheibenanomalie",
      "Kongenitale Lageanomalie der Patella",
      "Kongenitale Meniskushypertrophie des Knies",
      "Kongenitale O-Beinstellung",
      "Kongenitale Patelladislokation",
      "Kongenitale X-Beine",
      "Patella bipartita",
      "Patellaagenesie",
      "Patellaanomalie",
      "Patelladysplasie",
      "Patellahypoplasie",
      "Patellaspaltung",
      "Rudimentäre Patella"
    ]
  },
  {
    "code": "Q74.2",
    "name": "Sympodie",
    "synonyms": [
      "Agenesie des Beckengürtels",
      "Akzessorischer Fußwurzelknochen",
      "Akzessorisches Sesambein des Fußes",
      "Androides Becken",
      "Angeborene Beckenanomalie",
      "Angeborene Beckendeformität",
      "Angeborene Beckengürtelfehlbildung",
      "Angeborene Deformität der unteren Extremität",
      "Angeborene Deformität des Iliosakralgelenks",
      "Angeborene Deformität des Os ilium",
      "Angeborene Deformität des Os ischii",
      "Angeborene Fehlbildung der unteren Extremität",
      "Angeborene Femurverkrümmung",
      "Angeborene Fusion der unteren Extremität",
      "Angeborene Fußanomalie a.n.k.",
      "Angeborene Fußpronation",
      "Angeborene Hüftanomalie a.n.k.",
      "Angeborene Iliosakralgelenkfehlbildung",
      "Angeborene Iliosakralgelenkverschmelzung",
      "Angeborene Knöchelfehlbildung",
      "Angeborene Nichtvereinigung der Symphyse",
      "Angeborene Pseudarthrose der Tibia",
      "Angeborene Sprunggelenkfehlbildung",
      "Angeborene Tibiaverkrümmung",
      "Angeborenes Naegele-Becken",
      "Angeborenes flaches Becken",
      "Angeborenes längsverengtes Becken",
      "Anomalie der unteren Gliedmaßen",
      "Anomalie des Iliosakralgelenks a.n.k.",
      "Anomalie des Os ilium a.n.k.",
      "Anomalie des Os ischii a.n.k.",
      "Anthropoides Becken",
      "Beckenanomalie a.n.k.",
      "Beckendysplasie",
      "Beckendysplasie mit Arthrogrypose der unteren Extremitäten",
      "Beckengürtelanomalie a.n.k.",
      "Beckengürtelhypoplasie",
      "Beckenhypoplasie",
      "Beckenknochenanomalie a.n.k.",
      "Beidseitige Makrodaktylie der Zehen",
      "Beinanomalie a.n.k.",
      "Beindysplasie",
      "Einseitige Makrodaktylie der Zehen",
      "Fehlbildung der Hüfte",
      "Fehlbildung der unteren Extremität",
      "Femuranomalie a.n.k.",
      "Fersenanomalie a.n.k.",
      "Fibulaanomalie a.n.k.",
      "Fußwurzelanomalie a.n.k.",
      "Hyperphalangie der Zehen",
      "Knöchelanomalie",
      "Kongenitale Dislokation der Articulatio sacroiliaca",
      "Kongenitale Fußhypertrophie",
      "Kongenitale Fußpronation",
      "Kongenitale Iliosakralgelenkdislokation",
      "Kongenitale Lageanomalie der Symphysis pubica",
      "Kongenitale Verlagerung des Iliosakralgelenks",
      "Kongenitale Zehenhypertrophie",
      "Kongenitale iliosakrale Fusion",
      "Kongenitaler Hallux rigidus",
      "Kongenitales Trichterbecken",
      "Makrodaktylie der Zehen",
      "Makrodaktylie einer Zehe",
      "Megalodaktylie einer Zehe",
      "Mittelfußanomalie a.n.k.",
      "Oberschenkelanomalie a.n.k.",
      "Pithekoides Becken",
      "Querverengtes Becken",
      "Robert-Becken",
      "Sprunggelenkanomalie",
      "Sympodie",
      "Sympus",
      "Talus-Navikulare-Fusion",
      "Talus-Navikulare-Synostose",
      "Tarsusanomalie a.n.k.",
      "Tibiaanomalie a.n.k.",
      "Tibiofibulare Synostose",
      "Verformung des Iliosakralgelenks",
      "Zehenanomalie",
      "Zehenfehlbildung",
      "Zehenspaltung a.n.k."
    ]
  },
  {
    "code": "Q74.3",
    "name": "Arthrogryposis multiplex congenita",
    "synonyms": [
      "AMC [Arthrogryposis multiplex congenita]",
      "Arthrogryposis multiplex congenita",
      "Arthromyodysplasia congenita",
      "Autosomal-rezessive myogene Arthrogryposis multiplex congenita",
      "Crisponi-Syndrom",
      "Gliederstarre",
      "Guérin-Stern-Syndrom",
      "KLHL7-assoziiertes Crisponi-ähnliches Syndrom",
      "Kongenitale Arthromyodysplasie",
      "Kongenitale Gliederstarre",
      "Kuskokwim-Syndrom",
      "MYBPC1-assoziiertes autosomal-rezessives nicht-letales Arthrogryposis-multiplex-congenita-Syndrom",
      "Marden-Walker-Syndrom",
      "Multiple kongenitale Arthrogrypose",
      "Multiple kongenitale Kontrakturen",
      "Neurogene Arthrogryposis multiplex congenita",
      "Van den Ende-Gupta-Syndrom",
      "Wieacker-Wolff-Syndrom"
    ]
  },
  {
    "code": "Q74.8",
    "name": "Angeborener Extremitätenlängenunterschied",
    "synonyms": [
      "Akro-pektoro-vertebrale Dysplasie",
      "Akzessorisches Sesambein",
      "Angeborene Extremitätenfusion",
      "Angeborene Gelenkdysplasie",
      "Angeborene Pseudarthrose der Gliedmaßen",
      "Angeborener Extremitätenlängenunterschied",
      "Angeborenes Fehlen eines Extremitätengelenks a.n.k.",
      "Autosomal-dominantes Larsen-Syndrom",
      "Banki-Syndrom",
      "CHST3-assoziierte Skelettdysplasie",
      "Cenani-Lenz-Syndaktylie",
      "Cooks-Syndrom",
      "Dysplasia epiphysealis hemimelica",
      "Fuhrmann-Syndrom",
      "Hyperphalangie",
      "Kamptobrachydaktylie",
      "Kongenitale Gelenkfusion",
      "Kongenitale Gelenkrelaxation a.n.k.",
      "Larsen-Syndrom",
      "Mononen-Karnes-Senac-Syndrom",
      "Polymelie",
      "SFMMP [Spaltfuß-Fehlbildung mit mesoaxialer Polydaktylie]-Syndrom",
      "Symphalangismus mit multiplen Anomalien der Hände und Füße",
      "Syndrom des triphalangealen Daumens mit Brachyektrodaktylie",
      "Tarsal-Karpal-Fusions-Syndrom",
      "Wahab-Syndrom",
      "Überzählige Phalangen"
    ]
  },
  {
    "code": "Q74.9",
    "name": "Extremitätenmissbildung",
    "synonyms": [
      "Angeborene Extremitätenanomalie",
      "Angeborene Extremitätenfehlbildung",
      "Angeborene Rotationsdeformität",
      "Anomale Gelenkflexion a.n.k.",
      "Extremitätenfehlbildung",
      "Extremitätenmissbildung",
      "Gelenkanomalie a.n.k.",
      "Gliedmaßenanomalie"
    ]
  },
  {
    "code": "Q75.0",
    "name": "Vorzeitige Sagittalnahtsynostose",
    "synonyms": [
      "Akrozephalie",
      "Akrozephalus",
      "Baller-Gerold-Syndrom [Kraniosynostose-Radiusaplasie-Syndrom]",
      "Brachyzephalie",
      "Brachyzephalus",
      "Familiäres Skaphozephalie-Syndrom Typ McGillivray",
      "Hypsizephalie",
      "Isolierte Brachyzephalie",
      "Isolierte Sagittalnaht-Synostose",
      "Isolierte Skaphozephalie",
      "Isolierte Trigonozephalie",
      "Isolierte einseitige Synostose der Sphenofrontalnaht",
      "Isolierte einseitige frontosphenoidale Kraniosynostose",
      "Isoliertes Kleeblattschädel-Syndrom",
      "Kahnschädel",
      "Kielkopf",
      "Kraniostenose",
      "Kraniosynostose",
      "Kraniosynostose Typ Boston",
      "Kraniosynostose Typ Philadelphia",
      "Kraniosynostose mit intrakraniellen Verkalkungen",
      "Kreiborg-Pakistani-Syndrom",
      "Mangelhafte kraniofaziale Achse",
      "Mangelhafter Schädelverschluss",
      "Nicht-syndromale Pansynostose",
      "Nicht-syndromale Sagittalnaht-Synostose",
      "Nicht-syndromale Synostose der Sutura metopica und der Sutura sagittalis",
      "Nicht-syndromale beidseitige Synostose der Suturae coronalis und der Sutura metopica",
      "Nicht-syndromale beidseitige Synostose der Suturae coronalis und der Sutura sagittalis",
      "Nicht-syndromale beidseitige Synostose der Suturae lambdoideae",
      "Nicht-syndromale einseitige Synostose der Sutura coronalis und der Sutura sagittalis",
      "Nicht-syndromale einseitige Synostose der Sutura squamosa",
      "Nicht-syndromale frontoparietale Kraniosynostose",
      "Nicht-syndromaler Oxyzephalus",
      "Oxyzephalie",
      "Oxyzephalus",
      "Pyrgozephalie",
      "Pyrgozephalus",
      "Skaphozephalie",
      "Skaphozephalus",
      "Sphenozephalie",
      "Spitzschädel",
      "Syndrom der Kraniosynostose und Radiusaplasie",
      "Trigonozephalie",
      "Trigonozephalus",
      "Turmschädel",
      "Turrizephalie",
      "Unvollkommene Fusion der Schädelknochen",
      "Unvollständige Verschmelzung der Schädelknochen",
      "Vorzeitige Fontanellenossifikation",
      "Vorzeitige Sagittalnahtsynostose",
      "Vorzeitiger Schädelnahtverschluss"
    ]
  },
  {
    "code": "Q75.1",
    "name": "Dysostosis craniofacialis",
    "synonyms": [
      "Akro-fronto-fazio-nasale Dysostose",
      "Crouzon-Krankheit",
      "Crouzon-Syndrom",
      "Crouzon-Syndrom mit Acanthosis nigricans",
      "Dysostosis craniofacialis",
      "Dysostosis craniofacialis Crouzon",
      "Dysostosis craniofacialis hereditaria",
      "Familiäre Osteodysplasie Typ Anderson",
      "Fronto-fazio-nasale Dysplasie",
      "Frontonasale Dysplasie Typ 1",
      "Frontonasale Dysplasie Typ 3",
      "Kranio-fronto-nasale Dysplasie",
      "Kraniofaziale Dysostose Typ Crouzon",
      "Morbus Crouzon",
      "Okulo-maxillo-faziale Dysostose",
      "SIX2-assoziierte frontonasale Dysplasie",
      "Summitt-Syndrom"
    ]
  },
  {
    "code": "Q75.2",
    "name": "Hypertelorismus",
    "synonyms": [
      "Greig-II-Syndrom [Hereditärer Hypertelorismus]",
      "Greig-Zephalopolysyndaktylie-Syndrom",
      "Hypertelorismus",
      "Okulärer Hypertelorismus",
      "Orbitaler Hypertelorismus"
    ]
  },
  {
    "code": "Q75.3",
    "name": "Makrozephalie",
    "synonyms": [
      "Makrozephalie",
      "Makrozephalie-Entwicklungsverzögerung-Syndrom",
      "Megalozephalie a.n.k.",
      "Megalozephalus a.n.k."
    ]
  },
  {
    "code": "Q75.4",
    "name": "Dysostosis mandibulofacialis",
    "synonyms": [
      "Akrodysostose",
      "Akrodysostose mit multipler Hormonresistenz",
      "Akrofaziale Dysostose Typ Catania",
      "Akrofaziale Dysostose Typ Kennedy-Teebi",
      "Akrofaziale Dysostose Typ Nager",
      "Akrofaziale Dysostose Typ Palagonia",
      "Akrofaziale Dysostose Typ Rodriguez",
      "Akrofaziale Dysostose Typ Weyers",
      "Berry-Syndrom",
      "Dysostosis mandibulofacialis",
      "Franceschetti-I-Syndrom [Mandibulofaziale Missbildungskombination]",
      "Franceschetti-Klein-Syndrom",
      "Franceschetti-Zwahlen-Syndrom",
      "Hypomandibuläre faziokraniale Dysostose",
      "Mandibulofaziale Dysostose ohne Extremitätenanomalien",
      "Mandibulofaziale Missbildungskombination [Franceschetti-I-Syndrom]",
      "Nager-Syndrom",
      "Postaxiale akrofaziale Dysostose",
      "Thomson-Komplex",
      "Treacher-Collins-Syndrom",
      "Wildervanck-Syndrom",
      "X-chromosomale mandibulofaziale Dysostose"
    ]
  },
  {
    "code": "Q75.5",
    "name": "Okulo-mandibulo-faziales Syndrom",
    "synonyms": [
      "Okulo-mandibulo-faziale Dysostose",
      "Okulo-mandibulo-faziales Syndrom"
    ]
  },
  {
    "code": "Q75.8",
    "name": "Basale Impression",
    "synonyms": [
      "Agenesie des Augenhöhlendaches",
      "Agenesie des Orbitadaches",
      "Akzessorischer Gesichtsknochen",
      "Akzessorischer Stirnfortsatz",
      "Angeborene Kopfdeformität",
      "Angeborene Kraniumdeformität",
      "Angeborene Schädeldeformität",
      "Angeborene Stirnbeindeformität",
      "Angeborene Stirndeformität",
      "Angeborener Lückenschädel",
      "Angeborenes Fehlen von Schädelknochen",
      "Aurikulokondyläres Syndrom",
      "Basale Impression",
      "Basiläre Impression",
      "Binder-Syndrom",
      "Bonnaire-Syndrom",
      "Bürstenschädel",
      "Catlin-marks",
      "Cranium bifidum",
      "Fehlbildung des Processus mastoideus",
      "Foramina parietalia",
      "Foramina parietalia permagna",
      "Gesichtsknochenagenesie a.n.k.",
      "Gesichtsknochenhypoplasie a.n.k.",
      "Gesichtsknochenverformung a.n.k.",
      "Hereditäres Cranium bifidum",
      "Hypotelorismus",
      "Kongenitale Schädelhyperostose",
      "Kongenitale Schädelknochendiastase a.n.k.",
      "Kranio-lentikulo-suturale Dysplasie",
      "Kranioschisis",
      "Lakunärer Schädel",
      "Lückenschädel",
      "Mangelhafter Augenhöhlendachverschluss",
      "Mangelhafter Orbitadachverschluss",
      "Mittelgesichtshypoplasie",
      "Platybasie",
      "Primäre basiläre Invagination",
      "Reliefschädel",
      "Schädelknochenagenesie",
      "Schädelknochenhypoplasie",
      "Schädelknochenverformung a.n.k.",
      "Stenozephalie",
      "Stirnanomalie",
      "Tribasilarsynostose",
      "Vergrößertes Foramina parietalia",
      "Verzögerte membranöse Ossifikation des Kraniums",
      "Vogelgesicht",
      "Wabenschädel"
    ]
  },
  {
    "code": "Q75.9",
    "name": "Kopfanomalie",
    "synonyms": [
      "Angeborene Anomalie der Gesichtsschädelknochen",
      "Kopfanomalie",
      "Kraniofaziale Fehlbildung",
      "Schädelanomalie",
      "Stirnbeinanomalie"
    ]
  },
  {
    "code": "Q76.0",
    "name": "Spina bifida occulta",
    "synonyms": [
      "Okkulte spinale Dysraphie",
      "Spina bifida occulta"
    ]
  },
  {
    "code": "Q76.1",
    "name": "Klippel-Feil-Syndrom",
    "synonyms": [
      "Klippel-Feil-Anomalie mit Myopathie und Gesichtsdysmorphie",
      "Klippel-Feil-Deformität",
      "Klippel-Feil-Krankheit",
      "Klippel-Feil-Syndrom",
      "Kongenitale Halswirbelsäulenfusion",
      "Verschmelzung von Halswirbelkörpern"
    ]
  },
  {
    "code": "Q76.21",
    "name": "Kongenitale Spondylolisthesis",
    "synonyms": [
      "Angeborene Retrolisthese",
      "Angeborene Spondylolisthesis",
      "Kongenitale Präspondylolisthesis",
      "Kongenitale Spondylolisthesis",
      "Präspondylolisthesis"
    ]
  },
  {
    "code": "Q76.22",
    "name": "Angeborene Spondylolyse",
    "synonyms": [
      "Angeborene Spondylolyse"
    ]
  },
  {
    "code": "Q76.3",
    "name": "Halbwirbelverschmelzung mit kongenitaler Skoliose",
    "synonyms": [
      "Autosomal-dominante Brachyolmie",
      "Autosomal-rezessive Brachyolmie",
      "Brachyolmie Typ 3",
      "Brachyolmie mit Skoliose",
      "Halbwirbelverschmelzung mit kongenitaler Skoliose",
      "Knochenfehlbildung mit kongenitaler Skoliose",
      "Segmentationsfehler der Wirbelsäule mit Skoliose",
      "Segmentationsfehler mit kongenitaler Skoliose"
    ]
  },
  {
    "code": "Q76.4",
    "name": "Sacrum arcuatum",
    "synonyms": [
      "Akzessorischer Wirbel",
      "Angeborene Deformität des Lumbosakralgelenks",
      "Angeborene Fehlbildung der Lumbosakralregion",
      "Angeborene Fehlbildung der Lumbosakralregion ohne Skoliose",
      "Angeborene Fehlbildung des Lumbosakralgelenks",
      "Angeborene Fehlbildung des Lumbosakralgelenks ohne Skoliose",
      "Angeborene Instabilität des Lumbosakralgelenks",
      "Angeborene Kyphose",
      "Angeborene Kyphose ohne Skoliose",
      "Angeborene Lordose",
      "Angeborene Lordose ohne Skoliose",
      "Angeborene Sakrumdeformität",
      "Angeborene Sakrumverkrümmung a.n.k.",
      "Angeborene Steißbeinverkrümmung a.n.k.",
      "Angeborene Wirbelanomalie",
      "Angeborene Wirbellumbalisation",
      "Angeborene Wirbelsäulenanomalie",
      "Angeborene Wirbelsäulenfusion",
      "Angeborene Wirbelsäulenfusion ohne Skoliose",
      "Angeborener Buckel",
      "Angeborener flacher Rücken",
      "Angeborenes Fehlen der Wirbelsäule",
      "Angeborenes Fehlen des Kreuzbeins",
      "Angeborenes Fehlen des Sakrums",
      "Angeborenes Fehlen des Steißbeins",
      "Angeborenes Fehlen eines Wirbels",
      "Angeborenes Fehlen von Wirbeln ohne Skoliose",
      "Anomalie des Wirbelbogenschlusses",
      "Anomalie in der Lumbosakralgegend",
      "Asymmetrischer lumbosakraler Übergangswirbel",
      "Bandscheibenanomalie",
      "Brachyolmie",
      "Brachyolmie Typ 2",
      "Brachyolmie Typ Maroteaux",
      "Dystrophia brevicollis congenita",
      "Halbwirbel",
      "Halbwirbel ohne Skoliose",
      "Kongenitale Kyphose",
      "Kongenitale Lordose",
      "Kongenitale Wirbelblockade",
      "Kongenitale Wirbeldislokation",
      "Kongenitale lumbosakrale Dislokation",
      "Kongenitale lumbosakrale Fusion",
      "Kongenitaler Buckel",
      "Kreuzbeinagenesie",
      "Kreuzbeinhypoplasie",
      "Kreuzbeinverformung",
      "Kurzhals",
      "Lendenwirbelsäulenverformung",
      "Lumbosakralgelenkanomalie",
      "Lumbosakralgelenkverformung",
      "Melhem-Fahl-Syndrom",
      "Platyspondylie",
      "Platyspondylie ohne Skoliose",
      "Sacrum arcuatum",
      "Sakralisation",
      "Sakrumanomalie a.n.k.",
      "Schmetterlingswirbel",
      "Spaltwirbel",
      "Steißbeinagenesie",
      "Steißbeinanomalie",
      "Steißbeinhypoplasie",
      "Steißbeinverformung",
      "Unvollständige Wirbelsegmentation",
      "Unvollständige lumbosakrale Wirbelsegmentation",
      "Verformung in der Lumbosakralgegend",
      "Versagen der Wirbelsegmentation",
      "Vertebrale Anomalie",
      "Wirbelagenesie",
      "Wirbelhypoplasie",
      "Wirbelmissbildung",
      "Wirbelspaltung",
      "Wirbelsäulenagenesie",
      "Wirbelsäulenfehlbildung",
      "Wirbelsäulenfehlbildung ohne Skoliose",
      "Wirbelsäulenhypoplasie",
      "Wirbelsäulenverformung",
      "Wirbelverformung",
      "Überzähliger Wirbel",
      "Überzähliger Wirbel ohne Skoliose"
    ]
  },
  {
    "code": "Q76.5",
    "name": "Halsrippe",
    "synonyms": [
      "Akzessorische Halsrippe",
      "Angeborene Halsrippendeformität",
      "Costa cervicalis",
      "Halsrippe",
      "Halsrippenanomalie",
      "Halsrippensyndrom",
      "Überzählige Rippe in der Halsregion"
    ]
  },
  {
    "code": "Q76.6",
    "name": "Akzessorische Rippe",
    "synonyms": [
      "Akzessorische Rippe",
      "Angeborene Rippendeformität",
      "Angeborene Rippenfehlbildung",
      "Angeborene Rippenverschmelzung",
      "Angeborenes Fehlen einer Rippe",
      "Costa fluctuans",
      "Hohe Brustrippe",
      "Kongenitale Lageanomalie einer Rippe",
      "Rippenagenesie",
      "Rippenanomalie",
      "Rippenfusion",
      "Rippenhypoplasie",
      "Rippenspaltung"
    ]
  },
  {
    "code": "Q76.7",
    "name": "Angeborene Sternumfehlbildung",
    "synonyms": [
      "Akzessorisches Sternum",
      "Angeborene Brustbeindeformität",
      "Angeborene Sternumdeformität a.n.k.",
      "Angeborene Sternumfehlbildung",
      "Angeborenes Fehlen des Brustbeins",
      "Angeborenes Fehlen des Sternums",
      "Brustbeinagenesie",
      "Brustbeinanomalie a.n.k.",
      "Kongenitale Lageanomalie des Sternums a.n.k.",
      "Kongenitale Sternumretraktion",
      "Sternum bifidum",
      "Sternumagenesie",
      "Sternumanomalie a.n.k.",
      "Sternumhypoplasie",
      "Sternumspalte",
      "Sternumverformung a.n.k."
    ]
  },
  {
    "code": "Q76.8",
    "name": "Flachthorax",
    "synonyms": [
      "Autosomal-dominante spondylokostale Dysostose",
      "Autosomal-rezessive spondylokostale Dysostose",
      "Flachthorax",
      "Jarcho-Levin-Syndrom"
    ]
  },
  {
    "code": "Q76.9",
    "name": "Thoraxmissbildung",
    "synonyms": [
      "Anomalie der knöchernen Brustwand",
      "Knöcherne Thoraxanomalie",
      "Thoraxmissbildung"
    ]
  },
  {
    "code": "Q77.0",
    "name": "Achondrogenesie",
    "synonyms": [
      "Achondrogenesie",
      "Achondrogenesie Typ 1A",
      "Achondrogenesie Typ 1B",
      "Achondrogenesie Typ 2",
      "Hypochondrogenesie"
    ]
  },
  {
    "code": "Q77.1",
    "name": "Thanatophore Dysplasie",
    "synonyms": [
      "TD [Thanatophore Dysplasie]",
      "Thanatophore Dysplasie",
      "Thanatophore Dysplasie Typ 1",
      "Thanatophore Dysplasie Typ 2",
      "Thanatophorer Kleinwuchs",
      "Thanatophorer Minderwuchs"
    ]
  },
  {
    "code": "Q77.2",
    "name": "Kurzrippen-Polydaktylie-Syndrom",
    "synonyms": [
      "Asphyxierende Thoraxdysostose",
      "Asphyxierende Thoraxdysplasie",
      "Asphyxierende Thoraxdystrophie",
      "Barnes-Syndrom",
      "Jeune-Krankheit",
      "Jeune-Syndrom",
      "Kurzrippen-Polydaktylie-Syndrom",
      "Kurzrippen-Polydaktylie-Syndrom Typ 5",
      "Kurzrippen-Polydaktylie-Syndrom Typ Beemer-Langer",
      "Kurzrippen-Polydaktylie-Syndrom Typ Majewski",
      "Kurzrippen-Polydaktylie-Syndrom Typ Saldino-Noonan",
      "Kurzrippen-Polydaktylie-Syndrom Typ Verma-Naumoff"
    ]
  },
  {
    "code": "Q77.3",
    "name": "Chondrodysplasia-punctata-Syndrom",
    "synonyms": [
      "Astley-Kendall-Dysplasie",
      "Brachytelephalangealer Typ der Chondrodysplasia punctata",
      "CDPX2 [X-chromosomal-dominante Chondrodysplasia punctata]",
      "Chondrodysplasia calcificans congenita",
      "Chondrodysplasia punctata",
      "Chondrodysplasia punctata Typ Sheffield",
      "Chondrodysplasia punctata Typ Toriello",
      "Chondrodysplasia punctata rhizomeler Typ",
      "Chondrodysplasia punctata vom tibiametakarpalen Typ",
      "Chondrodysplasia-punctata-Syndrom",
      "Chondrodystrophia calcarea",
      "Chondrodystrophia calcificans congenita",
      "Chondrodystrophia punctata",
      "Conradi-Hünermann-Happle-Syndrom",
      "Conradi-Hünermann-Krankheit",
      "Conradi-Hünermann-Syndrom",
      "Dysplasia epiphysealis",
      "Dysplasia epiphysealis multiplex",
      "Dysplasia epiphysealis punctata",
      "Eiken-Syndrom",
      "Gefleckte diaphysäre Dysplasie",
      "Greenberg-Dysplasie",
      "Multiple epiphysäre Dysplasie",
      "Multiple epiphysäre Dysplasie Typ 1",
      "Multiple epiphysäre Dysplasie Typ 4",
      "Multiple epiphysäre Dysplasie Typ 5",
      "Multiple epiphysäre Dysplasie Typ 7",
      "Multiple epiphysäre Dysplasie Typ Al-Gazali",
      "Multiple epiphysäre Dysplasie Typ Beighton",
      "Multiple epiphysäre Dysplasie durch Kollagen 9-Anomalie",
      "Multiple epiphysäre Dysplasie mit schwerer proximaler Femurdysplasie",
      "Rhizomele Chondrodysplasia punctata Typ 1",
      "Rhizomele Chondrodysplasia punctata Typ 2",
      "Rhizomele Chondrodysplasia punctata Typ 3",
      "Rhizomele Chondrodysplasia punctata Typ 5",
      "Skelettdysplasie vom Typ Greenberg",
      "X-chromosomal-dominante Chondrodysplasia punctata",
      "X-chromosomale Chondrodysplasia punctata Typ 2"
    ]
  },
  {
    "code": "Q77.4",
    "name": "Chondrogenesis imperfecta",
    "synonyms": [
      "Achondroplasie",
      "Achondroplastischer Minderwuchs",
      "Angeborene Osteosklerose",
      "Chondrodysplasia fetalis",
      "Chondrodystrophischer Minderwuchs",
      "Chondrogenesis imperfecta",
      "Hypochondroplasie",
      "Hypochondroplastischer Kleinwuchs",
      "Hypochondroplastischer Minderwuchs",
      "Parrot-Kaufmann-Krankheit",
      "Parrot-Krankheit",
      "Parrot-Syndrom",
      "SADDAN [Schwergradige Achondroplasie, Entwicklungsverzögerung, Acanthosis nigricans]-Dysplasie",
      "Schwergradige Achondroplasie mit Entwicklungsverzögerung und Acanthosis nigricans"
    ]
  },
  {
    "code": "Q77.5",
    "name": "Diastrophische Dysplasie",
    "synonyms": [
      "Atelosteogenesis Typ 2",
      "Diastrophische Dysplasie"
    ]
  },
  {
    "code": "Q77.6",
    "name": "Chondroektodermale Dysplasie",
    "synonyms": [
      "Chondroektodermale Dysplasie",
      "Ellis-van-Creveld-Krankheit",
      "Ellis-van-Creveld-Syndrom"
    ]
  },
  {
    "code": "Q77.7",
    "name": "Dysplasia spondyloepiphysaria",
    "synonyms": [
      "Anauxetische Dysplasie",
      "Dyggve-Melchior-Clausen-Syndrom",
      "Dysplasia spondyloepiphysaria",
      "Dysplasia spondyloepiphysaria tarda",
      "Dyssegmentale Dysplasie Typ Rolland-Desbuquois",
      "Dyssegmentale Dysplasie Typ Silverman-Handmaker",
      "EXOC6B-assoziierte spondyloepimetaphysäre Dysplasie mit Gelenklaxität",
      "Fibrochondrogenesis",
      "Kleinwuchs mit Brachydaktylie Typ Mseleni",
      "Kongenitale spondyloepiphysäre Dysplasie",
      "MATN3-assoziierte spondyloepimetaphysäre Dysplasie",
      "MIR140-assoziierte spondyloepiphysäre Dysplasie",
      "Oto-spondylo-megaepiphysäre Dysplasie",
      "SPONASTRIME [Spondyläre und nasale Veränderungen mit Striae der Metaphyse]-Dysplasie",
      "Schneckenbecken-Dysplasie",
      "Smith-McCort-Dysplasie",
      "Spondyloenchondromatose",
      "Spondyloepimetaphysäre Dysplasie Typ Aggrecan",
      "Spondyloepimetaphysäre Dysplasie Typ Bieganski",
      "Spondyloepimetaphysäre Dysplasie Typ Czarny-Ratajczak",
      "Spondyloepimetaphysäre Dysplasie Typ Genevieve",
      "Spondyloepimetaphysäre Dysplasie Typ Handigodu",
      "Spondyloepimetaphysäre Dysplasie Typ Irapa",
      "Spondyloepimetaphysäre Dysplasie Typ Isidor",
      "Spondyloepimetaphysäre Dysplasie Typ Isidor-Toutain",
      "Spondyloepimetaphysäre Dysplasie Typ Missouri",
      "Spondyloepimetaphysäre Dysplasie Typ Pakistan",
      "Spondyloepimetaphysäre Dysplasie Typ Shohat",
      "Spondyloepimetaphysäre Dysplasie Typ Strudwick",
      "Spondyloepimetaphysäre Dysplasie mit Gelenklaxität Typ Beighton",
      "Spondyloepimetaphysäre Dysplasie mit Hypotrichose",
      "Spondyloepimetaphysäre Dysplasie mit gestörter Zahnentwicklung",
      "Spondyloepimetaphysäre Dysplasie mit kurzen Extremitäten und anormaler Kalzifizierung",
      "Spondyloepimetaphysäre Dysplasie mit multiplen Luxationen",
      "Spondyloepimetaphysäre Dysplasie mit multiplen Luxationen Typ Hall",
      "Spondyloepiphysäre Dysplasie Typ Cantu",
      "Spondyloepiphysäre Dysplasie Typ Kimberley",
      "Spondyloepiphysäre Dysplasie Typ Kohn",
      "Spondyloepiphysäre Dysplasie Typ MacDermot",
      "Spondyloepiphysäre Dysplasie Typ Maroteaux",
      "Spondyloepiphysäre Dysplasie Typ Nishimura",
      "Spondyloepiphysäre Dysplasie Typ Reardon",
      "Spondyloepiphysäre Dysplasie Typ Stanescu",
      "Spondyloepiphysäre Dysplasie mit progressiver Arthropathie",
      "Spondylomegaepimetaphysäre Dysplasie",
      "Spondyloperiphere Dysplasie mit Ulnaverkürzung",
      "Syndrom der spondyloepiphysären Dysplasie mit Brachydaktylie und Sprechstörung",
      "Tschechische Dysplasie vom metatarsalen Typ",
      "Weissenbacher-Zweymüller-Syndrom",
      "X-chromosomale spondyloepimetaphysäre Dysplasie"
    ]
  },
  {
    "code": "Q77.8",
    "name": "Familiäre Dyschondrosteose",
    "synonyms": [
      "Akromesomele Dysplasie Typ Maroteaux",
      "Akromikrische Dysplasie",
      "Autosomal-rezessive spondylometaphysäre Dysplasie Typ Megarbane",
      "Axiale spondyloepimetaphysäre Dysplasie",
      "Familiäre Dyschondrosteose",
      "Léri-Weill-Syndrom",
      "Mesomele Dysplasie Typ Langer",
      "Metatrope Dysplasie",
      "Metatropischer Minderwuchs",
      "NEK9-assoziierte letale Skelettdysplasie",
      "Platyspondylitische Dysplasie Typ Torrance",
      "Pseudoachondroplasie",
      "Regressive spondylometaphysäre Dysplasie",
      "SBDS-assoziierte schwere neonatale spondylometaphysäre Dysplasie",
      "Spondylo-Kamptodaktylie-Syndrom",
      "Spondyloepimetaphysäre Dysplasie Typ A4",
      "Spondyloepimetaphysäre Dysplasie mit Unterarmverbiegung und Gesichtsdysmorphien",
      "Spondylometaphysäre Dysplasie Typ Golden",
      "Spondylometaphysäre Dysplasie Typ Kozlowski",
      "Spondylometaphysäre Dysplasie Typ Schmidt",
      "Spondylometaphysäre Dysplasie Typ Sedaghatian",
      "Spondylometaphysäre Dysplasie Typ Sutcliffe",
      "Spondylometaphysäre Dysplasie mit Stäbchen-Zapfen-Dystrophie",
      "Thorakomele Dysplasie",
      "Wallis-Zieff-Goldblatt-Syndrom",
      "Weismann-Netter-Syndrom"
    ]
  },
  {
    "code": "Q77.9",
    "name": "Osteochondrodysplasie mit Wachstumsstörungen der Röhrenknochen und der Wirbelsäule",
    "synonyms": [
      "Osteochondrodysplasie mit Wachstumsstörungen der Röhrenknochen und der Wirbelsäule"
    ]
  },
  {
    "code": "Q78.0",
    "name": "Osteogenesis imperfecta",
    "synonyms": [
      "Angeborene Knochenbrüchigkeit",
      "Bruck-Syndrom",
      "Cole-Carpenter-Syndrom",
      "Fragilitas ossium",
      "Fragilitas ossium hereditaria",
      "Glasknochenerkrankung",
      "Glasknochenkrankheit",
      "Lobstein-Krankheit",
      "Lobstein-Syndrom",
      "OI [Osteogenesis imperfecta]",
      "Osteogenesis imperfecta",
      "Osteogenesis imperfecta Typ 1",
      "Osteogenesis imperfecta Typ 2",
      "Osteogenesis imperfecta Typ 3",
      "Osteogenesis imperfecta Typ 4",
      "Osteogenesis imperfecta Typ 5",
      "Osteopsathyrose",
      "Osteopsathyrosis",
      "Osteopsathyrosis idiopathica",
      "Ostitis fragilitans",
      "Porak-Durante-Krankheit",
      "Van-der-Hoeve-Syndrom",
      "Van-der-Hoeve-Trias",
      "Van-der-Hoeve-de-Kleyn-Syndrom",
      "Vrolik-Syndrom"
    ]
  },
  {
    "code": "Q78.1",
    "name": "Polyostotische fibröse Dysplasie",
    "synonyms": [
      "Albright-McCune-Sternberg-Syndrom",
      "Albright-Syndrom",
      "Jaffé-Lichtenstein-Syndrom",
      "McCune-Albright-Syndrom",
      "Osteodystrophia fibrosa disseminata",
      "Ostitis fibrosa disseminata",
      "Polyostotische Jaffé-Lichtenstein-Krankheit",
      "Polyostotische fibröse Dysplasie",
      "Polyostotisches Jaffé-Lichtenstein-Syndrom"
    ]
  },
  {
    "code": "Q78.2",
    "name": "Osteosklerose",
    "synonyms": [
      "Albers-Schönberg-Krankheit",
      "Albers-Schönberg-Syndrom",
      "Autosomal-dominante Osteopetrose Typ 1",
      "Autosomal-dominante Osteopetrose Typ 2",
      "Autosomal-dominante Osteosklerose Typ Worth",
      "Autosomal-rezessive maligne Osteopetrose",
      "Generalisierte Osteosklerose",
      "Intermediäre Osteopetrosis",
      "Marmorknochen",
      "Marmorknochenkrankheit",
      "Osteofibrose",
      "Osteomesopyknose",
      "Osteopetrose",
      "Osteopetrosis",
      "Osteopetrosis Albers-Schönberg",
      "Osteopetrosis familiaris",
      "Osteosclerosis",
      "Osteosclerosis congenita diffusa",
      "Osteosclerosis fragilitans",
      "Osteosklerose",
      "Osteosklerotische Knochendysplasie, letale Form",
      "Raine-Syndrom"
    ]
  },
  {
    "code": "Q78.3",
    "name": "Progrediente diaphysäre Dysplasie",
    "synonyms": [
      "Camurati-Engelmann-Krankheit",
      "Camurati-Engelmann-Syndrom",
      "Osteopathia hyperostotica multiplex infantum",
      "Progrediente diaphysäre Dysplasie",
      "Progressive diaphysäre Dysplasie"
    ]
  },
  {
    "code": "Q78.4",
    "name": "Enchondromatose",
    "synonyms": [
      "Angeborenes multiples Enchondrom",
      "Cheirospondyloenchondromatose",
      "Chondrodysplasie mit Angiomatose",
      "Chondrodysplasie mit Hämangiom",
      "Dyschondroplasie",
      "Dyschondroplasie mit Hämangiom",
      "Dysspondyloenchondromatose",
      "Enchondromatose",
      "Genochondromatose Typ 1",
      "Genochondromatose Typ 2",
      "Hemichondrodysplasie",
      "Hemichondrodystrophie",
      "Karpotarsale Osteochondromatose",
      "Kartilaginäre Enchondromatose",
      "Kast-Syndrom",
      "Maffucci-Syndrom",
      "Metachondromatose",
      "Multiple Enchondromatose",
      "Ollier-Chondrodysplasie",
      "Ollier-Krankheit",
      "Ollier-Syndrom",
      "Osteochondromatose-Syndrom",
      "Upington-Krankheit"
    ]
  },
  {
    "code": "Q78.5",
    "name": "Metaphysäre Dysplasie",
    "synonyms": [
      "Knorpel-Haar-Hypoplasie",
      "Metaphysäre Akroscyphodysplasie",
      "Metaphysäre Anadysplasie",
      "Metaphysäre Chondrodysplasie",
      "Metaphysäre Chondrodysplasie Typ Jansen",
      "Metaphysäre Chondrodysplasie Typ Kaitila",
      "Metaphysäre Chondrodysplasie Typ McKusick",
      "Metaphysäre Chondrodysplasie Typ Rosenberg",
      "Metaphysäre Chondrodysplasie Typ Schmid",
      "Metaphysäre Chondrodysplasie Typ Spahr",
      "Metaphysäre Dysplasie",
      "Metaphysäre Dysplasie Typ Braun-Tinschert",
      "Metaphysäre Dysplasie der Ulna",
      "Osteosklerotische metaphysäre Dysplasie",
      "Pyle-Krankheit",
      "Pyle-Syndrom"
    ]
  },
  {
    "code": "Q78.6",
    "name": "Angeborene multiple Exostosen",
    "synonyms": [
      "Angeborene multiple Exostosen",
      "Bessel-Hagen-Krankheit",
      "Kongenitales multiples Osteochondrom",
      "Multiple kartilaginäre Exostosen"
    ]
  },
  {
    "code": "Q78.8",
    "name": "Osteopoikilie",
    "synonyms": [
      "ASPED [Engelförmige phalango-epiphysäre Dysplasie]",
      "Akro-capito-femorale Dysplasie",
      "Akromesomele Dysplasie Typ Grebe",
      "Akromesomele Dysplasie Typ Hunter-Thompson",
      "Anomale Synchondrose",
      "Atelosteogenesis",
      "Atelosteogenesis Typ 1",
      "Atelosteogenesis Typ 3",
      "Autosomal-dominante Omodysplasie",
      "Autosomal-rezessive Omodysplasie",
      "Blomstrand-Chondrodysplasie",
      "Chondrodysplasie Typ Grebe",
      "Chondrodystrophia myotonica",
      "Desbuquois-Syndrom",
      "Diaphanospondylodysostose",
      "Doughnut-förmige Läsionen der Schädelkalotte mit Knochenfragilität",
      "Dysosteosklerose",
      "Dysplastische Hyperostosis corticalis",
      "Dysplastische Hyperostosis corticalis Typ Kozlowski-Tsuruta",
      "Engelförmige phalango-epiphysäre Dysplasie",
      "Epiphysäre multiple Dysplasie Typ Lowry",
      "Familiäre Pleonostose",
      "Gnathodiaphysäre Dysplasie",
      "Goldblatt-Chondrodysplasie",
      "Hyperostosis corticalis generalisata",
      "Ischio-vertebrale Dysplasie",
      "Isolierte Osteopoikilose",
      "Kamptodaktylie Typ Goodman",
      "Komplexe letale Osteochondrodysplasie",
      "Kongenitale Synostose",
      "Kranio-metaphysäre Dysplasie",
      "Kyphomele Dysplasie",
      "Letale Kniest-Syndrom-ähnliche Dysplasie",
      "Letale Knochendysplasie Typ Holmgren",
      "Letale autosomal-rezessive Chondrodysplasie",
      "Léri-II-Syndrom",
      "Maroteaux-Stanescu-Cousin-Syndrom",
      "Melorheostose mit Osteopoikilose",
      "Mesomele Dysplasie Typ Kantaputra",
      "Mesomele Dysplasie Typ Nievergelt",
      "Mesomele Dysplasie Typ Reardon",
      "Mesomele Dysplasie Typ Reinhardt-Pfeiffer",
      "Mesomele Dysplasie Typ Savarirayan",
      "Mesomelie-Synostosen-Syndrom",
      "Metaphysäre Dysplasie mit Maxillahypoplasie und Brachydaktylie",
      "Meyer-Dysplasie des Femurkopfes",
      "Multiple Synostosen-Syndrom",
      "Myotone Chondrodystrophie",
      "Müller-Ribbing-Clement-Syndrom",
      "Omodysplasie",
      "Opsismodysplasie",
      "Osteokraniostenose",
      "Osteopathia condensans disseminata",
      "Osteopoikilie",
      "Osteopoikilose",
      "Osteosklerose Typ Stanescu",
      "Pseudodiastrophische Dysplasie",
      "Pyknoachondrogenesis",
      "Pyknodysostose",
      "Pyknodysostose-Syndrom",
      "Rhizomele Dysplasie Typ Patterson-Lowry",
      "Ribbing-Syndrom",
      "Sakrumdysplasie",
      "Schwartz-Jampel-Syndrom",
      "Singleton-Merten-Syndrom",
      "Spondylokarpotarsale Synostose",
      "Stippled epiphyses",
      "Stüve-Wiedemann-Syndrom",
      "Synchondrosenabnormität",
      "Synostose",
      "Synostosis",
      "Unvollständige Knochensegmentation a.n.k."
    ]
  },
  {
    "code": "Q78.9",
    "name": "Chondrodystrophie",
    "synonyms": [
      "Achondrodysplasie",
      "Chondrodysplasie",
      "Chondrodystrophia",
      "Chondrodystrophie",
      "Familiäre Chondrodystrophie",
      "Fetale Chondrodystrophie",
      "Generalisierte Skelettanomalie a.n.k.",
      "Hypoplastische Chondrodystrophie",
      "Kongenitale Osteodystrophie",
      "Osteochondrodysplasie",
      "Osteodystrophia",
      "Osteodystrophie",
      "X-chromosomal-dominante Chondrodysplasie Typ Chassaing-Lacombe"
    ]
  },
  {
    "code": "Q79.0",
    "name": "Enterothorax beim Neugeborenen [Angeborener Zwerchfelldefekt mit Eventration]",
    "synonyms": [
      "Angeborene Zwerchfellhernie",
      "Enterothorax beim Neugeborenen [Angeborener Zwerchfelldefekt mit Eventration]",
      "Kongenitale Hernia diaphragmatica",
      "Kongenitale Zwerchfellhernie"
    ]
  },
  {
    "code": "Q79.1",
    "name": "Angeborener Zwerchfelldefekt mit Eventration",
    "synonyms": [
      "Angeborene Abnormität der Zwerchfellöffnungen",
      "Angeborene Diaphragmadeformität",
      "Angeborene Vergrößerung der Zwerchfellöffnungen",
      "Angeborene Zwerchfelldeformität",
      "Angeborene Zwerchfellfehlbildung",
      "Angeborener Zwerchfelldefekt mit Eventration",
      "Angeborener Zwerchfellhochstand",
      "Angeborenes Fehlen des Zwerchfells",
      "Anomale Diaphragmaöffnungen a.n.k.",
      "Anomalie der Zwerchfellöffnungen a.n.k.",
      "Eventratio diaphragmatica",
      "Fehlen des Zwerchfells",
      "Kongenitale Eventratio diaphragmatica",
      "Kongenitale Hypertrophie des Hiatus oesophageus",
      "Kongenitale Zwerchfellerhöhung",
      "Kongenitaler Zwerchfelldefekt",
      "Zwerchfellagenesie mit Hernie",
      "Zwerchfellfehlbildung"
    ]
  },
  {
    "code": "Q79.2",
    "name": "Omphalozele",
    "synonyms": [
      "Exomphalus",
      "Nabelschnurbruch",
      "Omphalozele"
    ]
  },
  {
    "code": "Q79.3",
    "name": "Gastroschisis",
    "synonyms": [
      "Bauchwandspalte",
      "Gastroschisis",
      "Kongenitale Gastroschisis",
      "Laparoschisis"
    ]
  },
  {
    "code": "Q79.4",
    "name": "Prune-belly-Syndrom [Bauchdeckenaplasie-Syndrom]",
    "synonyms": [
      "Bauchdeckenaplasiesyndrom",
      "Eagle-Barett-Syndrom",
      "Kongenitales Fehlen der Bauchmuskulatur",
      "Obrinsky-Syndrom",
      "Pflaumenbauchsyndrom",
      "Prune-belly-Syndrom [Bauchdeckenaplasie-Syndrom]"
    ]
  },
  {
    "code": "Q79.5",
    "name": "Bauchwandanomalie a.n.k.",
    "synonyms": [
      "Angeborene Bauchwanddeformität",
      "Bauchwandanomalie a.n.k.",
      "Ektopia viscerum durch vorderen Bauchwanddefekt",
      "Ektopie der Baucheingeweide durch vorderen Bauchwanddefekt",
      "Kongenitale Rektusdiastase",
      "Kongenitaler Bauchwanddefekt"
    ]
  },
  {
    "code": "Q79.6",
    "name": "Ehlers-Danlos-Syndrom",
    "synonyms": [
      "Adduzierte Daumen mit Arthrogrypose vom Typ Dundar",
      "Brittle-Cornea-Syndrom",
      "EDS [Ehlers-Danlos-Syndrom] Typ IV",
      "EDS [Ehlers-Danlos-Syndrom] Typ Kosho",
      "EDS [Ehlers-Danlos-Syndrom] vom Herzklappentyp",
      "EDS [Ehlers-Danlos-Syndrom] vom arthrogryposen Typ",
      "EDS [Ehlers-Danlos-Syndrom] vom muskulo-kontrakturalen Typ",
      "EDS [Ehlers-Danlos-Syndrom] vom progeroiden Typ",
      "Ehlers-Danlos-Syndrom",
      "Ehlers-Danlos-Syndrom Typ 10",
      "Ehlers-Danlos-Syndrom Typ 3",
      "Ehlers-Danlos-Syndrom Typ 4",
      "Ehlers-Danlos-Syndrom Typ 6",
      "Ehlers-Danlos-Syndrom Typ 7",
      "Ehlers-Danlos-Syndrom Typ 8",
      "Ehlers-Danlos-Syndrom Typ Kosho",
      "Ehlers-Danlos-Syndrom mit periventrikulärer Heterotopie",
      "Ehlers-Danlos-Syndrom vom Typ Dermatosparaxis",
      "Ehlers-Danlos-Syndrom vom arthrogryposen Typ",
      "Ehlers-Danlos-Syndrom vom hypermobilen Typ",
      "Ehlers-Danlos-Syndrom vom klassisch-ähnlichen Typ 1",
      "Ehlers-Danlos-Syndrom vom klassisch-ähnlichen Typ 2",
      "Ehlers-Danlos-Syndrom vom kyphoskoliotischen Typ",
      "Ehlers-Danlos-Syndrom vom kyphoskoliotischen Typ durch Lysyl-Hydroxylase-1-Mangel",
      "Ehlers-Danlos-Syndrom vom kyphoskoliotischen Typ mit Schwerhörigkeit",
      "Ehlers-Danlos-Syndrom vom muskulo-kontrakturalen Typ",
      "Ehlers-Danlos-Syndrom vom myopathischen Typ",
      "Ehlers-Danlos-Syndrom vom progeroiden Typ",
      "Ehlers-Danlos-Syndrom vom spondylocheiro-dysplastischen Typ",
      "Ehlers-Danlos-Syndrom vom spondylodysplastischen Typ",
      "Ehlers-Danlos-Syndrom vom vaskulären Typ",
      "Familiäres Gelenkhypermobilitäts-Syndrom",
      "Familiäres Gelenkinstabilitäts-Syndrom",
      "Sack-Barabas-Syndrom",
      "X-chromosomales Ehlers-Danlos-Syndrom"
    ]
  },
  {
    "code": "Q79.8",
    "name": "Poland-Syndrom",
    "synonyms": [
      "Agenesie des Muskel-Skelett-Systems a.n.k.",
      "Akromikrie",
      "Akzessorische Sehne",
      "Akzessorischer Knochen a.n.k.",
      "Akzessorischer Muskel",
      "Al-Gazali-al-Talabani-Syndrom",
      "Amniotische Schnürfurchen",
      "Amyoplasia congenita",
      "Amyoplasie",
      "Amyotrophia congenita",
      "Angeborene Schnürringe",
      "Angeborene Sehnenverkürzung",
      "Angeborenes Fehlen einer Sehne",
      "Angeborenes Fehlen eines Muskels",
      "Chondrodysplasie mit Gelenkluxationen Typ gPAPP",
      "Eng-Strom-Syndrom",
      "FGFR2-assoziierte Knochendysplasie",
      "Fehlen einer Sehne",
      "Fehlen eines Muskels",
      "Hunter-Rudd-Hoffmann-Syndrom",
      "Knochenagenesie a.n.k.",
      "Knorpelagenesie",
      "Kongenitale Amyoplasie",
      "Kongenitale Bandkontraktur",
      "Kongenitale Muskeldiastase",
      "Kongenitale Sehnenverkürzung",
      "Kongenitale Thorakogastroschisis",
      "Morava-Mehes-Syndrom",
      "Muskelagenesie",
      "Muskeldysplasie",
      "Muskelhypoplasie",
      "Myatrophia congenita",
      "Poland-Anomalie",
      "Poland-Sequenz",
      "Poland-Syndrom",
      "Schnürring-Syndrom",
      "Sehnenagenesie",
      "Sillence-Syndrom",
      "Steel-Syndrom",
      "Suarez-Stickler-Syndrom",
      "Syndrom der Gesichtsdysmorphien mit Pectus carinatum und Laxizität der Gelenke",
      "Syndrom der Hyperphalangie der Finger mit Zehenanomalien und schwergradigem Pectus excavatum",
      "Syndrom der Ossifikationsanomalien mit psychomotorischer Entwicklungsverzögerung",
      "Syndrom der sakralen Agenesie mit abnormaler Ossifikation der Wirbelkörper und persistierendem notochordalem Kanal",
      "Syndrom des Kleinwuchses mit beschleunigter Knochenalterung und früh beginnender Osteoarthritis",
      "Tel-Hashomer-Kamptodaktylie",
      "Thorakogastroschisis",
      "Thorakoschisis"
    ]
  },
  {
    "code": "Q79.9",
    "name": "Angeborene Deformität des Muskel-Skelett-Systems",
    "synonyms": [
      "Angeborene Deformität des Muskel-Skelett-Systems",
      "Angeborene Deformität eines Ligaments",
      "Angeborene Muskelanomalie",
      "Angeborene Muskelkrankheit",
      "Anomalie des Muskel-Skelett-Systems",
      "Anomalie eines Ligaments",
      "Bandanomalie",
      "Faszienanomalie",
      "Knochenanomalie a.n.k.",
      "Knochenhypoplasie a.n.k.",
      "Kongenitale Knochenfusion",
      "Schleimbeutelanomalie",
      "Sehnenanomalie"
    ]
  },
  {
    "code": "Q80.0",
    "name": "Ichthyosis vulgaris",
    "synonyms": [
      "Autosomal-dominante Ichthyosis vulgaris",
      "Ichthyosis follicularis",
      "Ichthyosis follicularis mit Alopezie und Photophobie",
      "Ichthyosis simplex",
      "Ichthyosis vulgaris"
    ]
  },
  {
    "code": "Q80.1",
    "name": "X-chromosomal-rezessive Ichthyosis",
    "synonyms": [
      "Steroidsulfatase-Mangel",
      "X-chromosomal-rezessive Ichthyosis",
      "X-chromosomale syndromale Ichthyose"
    ]
  },
  {
    "code": "Q80.2",
    "name": "Lamelläre Ichthyosis",
    "synonyms": [
      "Bathing-suit-Ichthyose",
      "Kollodium-Baby",
      "Lamelläre Ichthyosis",
      "Nicht-bullöse kongenitale ichthyosiforme Erythrodermie",
      "Selbstheilendes Kollodium-Baby",
      "Selbstheilendes Kollodiumbaby, akrale Form"
    ]
  },
  {
    "code": "Q80.3",
    "name": "Bullöse kongenitale ichthyosiforme Erythrodermie",
    "synonyms": [
      "Anuläre epidermolytische Ichthyose",
      "Autosomal-rezessive epidermolytische Ichthyose",
      "Bullöse Ichthyose",
      "Bullöse kongenitale ichthyosiforme Erythrodermie",
      "Bullöse kongenitale ichthyosiforme Erythrodermie Brocq",
      "Bullöses kongenitales ichthyosiformes Erythem",
      "CRIE [Kongenitale retikuläre ichthyosiforme Erythrodermie]",
      "Epidermolytische Hyperkeratose",
      "Epidermolytische Ichthyose",
      "Epidermolytischer epidermaler Nävus",
      "Erythrodermia ichthyosiformis congenita bullosa",
      "Kongenitale retikuläre ichthyosiforme Erythrodermie"
    ]
  },
  {
    "code": "Q80.4",
    "name": "Ichthyosis congenita gravis",
    "synonyms": [
      "Harlekin-Ichthyosis",
      "Harlekinfetus",
      "Ichthyosis congenita gravis",
      "Ichthyosis fetalis"
    ]
  },
  {
    "code": "Q80.8",
    "name": "Ichthyosis hystrix",
    "synonyms": [
      "Akrales Peeling-Skin-Syndrom",
      "Comèl-Netherton-Syndrom",
      "Exfoliative Ichthyose",
      "Generalisiertes Peeling-Skin-Syndrom",
      "Ichthyose-Hypotrichose-Syndrom",
      "Ichthyosis hystrix",
      "Ichthyosis hystrix Curth-Macklin",
      "Ichthyosis vera",
      "KID [Keratitis-Ichthyosis-Taubheit]-Syndrom",
      "Netherton-Syndrom",
      "Peeling-Skin-Syndrom Typ A",
      "Peeling-Skin-Syndrom Typ B",
      "SAM [Schwere Dermatitis, multiple Allergien, metabolischer Verlust]-Syndrom",
      "Superfizielle epidermolytische Ichthyose"
    ]
  },
  {
    "code": "Q80.9",
    "name": "Ichthyosis congenita",
    "synonyms": [
      "Fischschuppenkrankheit",
      "Hereditäre Ichthyose",
      "Ichthyosis",
      "Ichthyosis congenita"
    ]
  },
  {
    "code": "Q81.0",
    "name": "Epidermolysis bullosa simplex",
    "synonyms": [
      "Epidermolysis bullosa simplex",
      "Epidermolysis bullosa simplex Typ Dowling-Meara",
      "Epidermolysis bullosa simplex Typ Ogna",
      "Epidermolysis bullosa simplex durch BP230 [Bullöses Pemphigoid-Antigen-1]-Defizienz",
      "Epidermolysis bullosa simplex durch Exophilin 5-Mangel",
      "Epidermolysis bullosa simplex durch Plakophilin-Mangel",
      "Epidermolysis bullosa simplex mit Pylorusatresie",
      "Epidermolysis bullosa simplex mit fleckiger Pigmentierung",
      "Epidermolysis bullosa simplex mit gesprenkelter Pigmentierung",
      "Epidermolysis bullosa simplex superficialis",
      "Generalisierte intermediäre Epidermolysis bullosa simplex",
      "Goldscheider-Krankheit",
      "KRT14-assoziierte autosomal-rezessive Epidermolysis bullosa simplex",
      "Köbner-Krankheit",
      "Letale akantholytische Epidermolysis bullosa",
      "Lokalisierte Epidermolysis bullosa simplex",
      "Migratorische Epidermolysis bullosa simplex",
      "Weber-Cockayne-Syndrom"
    ]
  },
  {
    "code": "Q81.1",
    "name": "Epidermolysis bullosa atrophicans gravis",
    "synonyms": [
      "Epidermolysis bullosa atrophicans generalisata gravis",
      "Epidermolysis bullosa atrophicans gravis",
      "Epidermolysis bullosa junctionalis vom Typ Herlitz",
      "Epidermolysis bullosa junctionalis vom Typ Herlitz-Pearson",
      "Epidermolysis bullosa letalis",
      "Herlitz-Syndrom",
      "JEB-H [Junktionale Epidermolysis bullosa Typ Herlitz]",
      "Junktionale Epidermolysis bullosa Typ Herlitz"
    ]
  },
  {
    "code": "Q81.2",
    "name": "Epidermolysis bullosa dystrophica",
    "synonyms": [
      "Akrale dystrophe Epidermolysis bullosa",
      "Dermolytische Epidermolysis bullosa",
      "Dominante dystrophe Epidermolysis bullosa, isolierter Nagelbefall",
      "Dystrophe Epidermolysis bullosa",
      "Dystrophe Epidermolysis bullosa inversa",
      "Epidermolysis bullosa dystrophica",
      "Generalisierte autosomal-dominante dystrophe Epidermolysis bullosa",
      "Generalisierte intermediäre autosomal-rezessive dystrophe Epidermolysis bullosa",
      "Lokalisierte dystrophe Epidermolysis bullosa",
      "Pasini-Krankheit",
      "Pasini-Syndrom",
      "Pruriginöse dystrophe Epidermolysis bullosa",
      "Prätibiale dystrophe Epidermolysis bullosa",
      "Schwere generalisierte rezessive dystrophe Epidermolysis bullosa",
      "Transiente bullöse Dermolyse des Neugeborenen"
    ]
  },
  {
    "code": "Q81.8",
    "name": "Bulla acantholytica",
    "synonyms": [
      "Bulla acantholytica",
      "Carmi-Syndrom",
      "Epidermolysis bullosa junctionalis inversa",
      "Epidermolysis bullosa progressiva",
      "Generalisierte intermediäre junktionale Epidermolysis bullosa",
      "JEB-nH [Junktionale Epidermolysis bullosa Typ non-Herlitz]",
      "JEB-nH loc [Lokalisierte junktionale Epidermolysis bullosa Typ non-Herlitz]",
      "Junktionale Epidermolysis bullosa Typ non-Herlitz",
      "Kindler-Syndrom",
      "LOC [Laryngo-onycho-kutanes]-Syndrom",
      "Laryngo-onycho-kutanes Syndrom"
    ]
  },
  {
    "code": "Q81.9",
    "name": "Epidermolysis bullosa",
    "synonyms": [
      "Epidermolysis bullosa",
      "Epidermolysis-bullosa-Syndrom"
    ]
  },
  {
    "code": "Q82.00",
    "name": "Hereditäres Lymphödem der oberen Extremität, Stadium I",
    "synonyms": [
      "GJC2-abhängiges angeborenes primäres Lymphödem der oberen und unteren Extremitäten, Stadium I",
      "GJC2-abhängiges angeborenes primäres Lymphödem der unteren Extremität, Stadium I",
      "Hereditäres Lymphödem der oberen Extremität, Stadium I",
      "Hereditäres Lymphödem der unteren Extremität, Stadium I"
    ]
  },
  {
    "code": "Q82.01",
    "name": "Hereditäres Lymphödem der oberen Extremität, Stadium II",
    "synonyms": [
      "GJC2-abhängiges angeborenes primäres Lymphödem der oberen und unteren Extremitäten, Stadium II",
      "GJC2-abhängiges angeborenes primäres Lymphödem der unteren Extremität, Stadium II",
      "Hereditäres Lymphödem der oberen Extremität, Stadium II",
      "Hereditäres Lymphödem der unteren Extremität, Stadium II"
    ]
  },
  {
    "code": "Q82.02",
    "name": "Hereditäres Lymphödem der oberen Extremität, Stadium III",
    "synonyms": [
      "GJC2-abhängiges angeborenes primäres Lymphödem der oberen und unteren Extremitäten, Stadium III",
      "GJC2-abhängiges angeborenes primäres Lymphödem der unteren Extremität, Stadium III",
      "Hereditäres Lymphödem der oberen Extremität, Stadium III",
      "Hereditäres Lymphödem der unteren Extremität, Stadium III"
    ]
  },
  {
    "code": "Q82.03",
    "name": "Hereditäres Lymphödem des Kopfes, Stadium I",
    "synonyms": [
      "Hereditäres Lymphödem der Thoraxwand, Stadium I",
      "Hereditäres Lymphödem des Genitalbereiches, Stadium I",
      "Hereditäres Lymphödem des Halses, Stadium I",
      "Hereditäres Lymphödem des Kopfes, Stadium I"
    ]
  },
  {
    "code": "Q82.04",
    "name": "Hereditäres Lymphödem des Kopfes, Stadium II",
    "synonyms": [
      "Hereditäres Lymphödem der Thoraxwand, Stadium II",
      "Hereditäres Lymphödem des Genitalbereiches, Stadium II",
      "Hereditäres Lymphödem des Halses, Stadium II",
      "Hereditäres Lymphödem des Kopfes, Stadium II"
    ]
  },
  {
    "code": "Q82.05",
    "name": "Hereditäres Lymphödem des Kopfes, Stadium III",
    "synonyms": [
      "Hereditäres Lymphödem der Thoraxwand, Stadium III",
      "Hereditäres Lymphödem des Genitalbereiches, Stadium III",
      "Hereditäres Lymphödem des Halses, Stadium III",
      "Hereditäres Lymphödem des Kopfes, Stadium III"
    ]
  },
  {
    "code": "Q82.08",
    "name": "Lymphödem-Distichiasis-Syndrom",
    "synonyms": [
      "CELSR1-assoziiertes primäres Lymphödem mit spätem Beginn",
      "Lymphödem-Distichiasis-Syndrom"
    ]
  },
  {
    "code": "Q82.09",
    "name": "Hereditäres Lymphödem",
    "synonyms": [
      "Angeborene hereditäre Elephantiasis",
      "Angeborenes primäres Lymphödem Typ Gordon",
      "Elephantiasis congenita hereditaria",
      "GJC2-abhängiges angeborenes primäres Lymphödem",
      "Generalisierte lymphatische Dysplasie Typ Fotiou",
      "Hereditäres Lymphödem",
      "Hereditäres Lymphödem Typ I",
      "Hereditäres Lymphödem Typ II",
      "Hereditäres Trophödem",
      "Kongenitales primäres Lymphödem",
      "Meige-Krankheit",
      "Meige-Lymphödem",
      "Meige-Milroy-Krankheit",
      "Milroy-Krankheit",
      "Nonne-Milroy-Krankheit",
      "Nonne-Milroy-Lymphödem",
      "Nonne-Milroy-Meige-Syndrom",
      "Syndrom des primären Lymphödems mit Warzen, Immundefekt und anogenitaler Dysplasie",
      "Trophödem",
      "WILD [Warzen, Immundefekt, Lymphödem, anogenitale Dysplasie]-Syndrom"
    ]
  },
  {
    "code": "Q82.1",
    "name": "Xeroderma pigmentosum",
    "synonyms": [
      "Atrophodermia pigmentosum",
      "Melanosis lenticularis progressiva",
      "XP [Xeroderma pigmentosum]",
      "XPV [Xeroderma pigmentosum-Variante]",
      "Xeroderma pigmentosum",
      "Xeroderma pigmentosum-Variante"
    ]
  },
  {
    "code": "Q82.2",
    "name": "Urticaria pigmentosa",
    "synonyms": [
      "Angeborene Mastozytose",
      "Diffuse kutane Mastozytose",
      "Kutane Mastozytose",
      "Kutanes Mastozytom",
      "Mastozytose",
      "Mastozytose-Syndrom",
      "Nettleship-Syndrom",
      "Noduläre Form der Urticaria pigmentosa",
      "Plaqueförmige Urticaria pigmentosa",
      "Teleangiectasia macularis eruptiva perstans",
      "Urticaria pigmentosa",
      "Urticaria xanthelasmoidea"
    ]
  },
  {
    "code": "Q82.3",
    "name": "Incontinentia pigmenti",
    "synonyms": [
      "Bloch-Siemens-Syndrom",
      "Bloch-Sulzberger-Krankheit",
      "Bloch-Sulzberger-Syndrom",
      "Incontinentia pigmenti",
      "Melanoblastosis cutis linearis sive systematisata",
      "Melanosis corii degenerativa"
    ]
  },
  {
    "code": "Q82.4",
    "name": "Anhidrotische ektodermale Dysplasie",
    "synonyms": [
      "ANOTHER [Alopezie, Nageldystrophie, Ophthalmologische Komplikationen, Thyreoid-Dysfunktion, Hypohidrose, Epheliden, Respirationstraktinfektion]-Syndrom",
      "Amelo-onycho-hypohidrotisches Syndrom",
      "Angeborene Hautdysplasie",
      "Anhidrosis hypotrichotica",
      "Anhidrotische ektodermale Dysplasie",
      "Anhidrotische ektodermale Dysplasie mit Immundefekt",
      "Böök-Syndrom",
      "Christ-Siemens-Touraine-Syndrom",
      "Dermatopathia pigmentosa reticularis",
      "Dermoodontodysplasie",
      "Ektodermaldysplasie",
      "HED [Hypohidrotische ektodermale Dysplasie]",
      "Hay-Wells-Syndrom",
      "Hypohidrotische ektodermale Dysplasie",
      "Hypohidrotische ektodermale Dysplasie mit Immundefekt",
      "Naegeli-Franceschetti-Jadassohn-Syndrom",
      "Robinson-Miller-Bensimon-Syndrom",
      "X-chromosomale anhidrotische ektodermale Dysplasie",
      "X-chromosomale hypohidrotische ektodermale Dysplasie"
    ]
  },
  {
    "code": "Q82.5",
    "name": "Feuermal",
    "synonyms": [
      "Angeborener nichtneoplastischer Nävus",
      "Angorahaarnävus-Syndrom",
      "Familiäre multiple Naevi flammei",
      "Feuermal",
      "Himbeermal",
      "ILVEN [Inflammatorischer lineärer verruköser epidermaler Nävus]",
      "Inflammatorischer lineärer verruköser epidermaler Nävus",
      "Komedonennävus der Handflächen",
      "Multiple familiäre Portwein-Flecken",
      "Muttermal",
      "Naevus comedonicus",
      "Naevus flammeus",
      "Naevus teleangiectaticus lateralis",
      "Naevus unius lateris",
      "Naevus vasculosus",
      "Naevus verrucosus",
      "Porokeratotischer ekkriner Ostiumnaevus",
      "Portwein-Flecken [Naevus flammeus]",
      "Portwein-Nävus",
      "Storchenbiss",
      "Syndrom des linearen verrukösen Naevus",
      "Unna-Nävus",
      "Wollhaarnaevus"
    ]
  },
  {
    "code": "Q82.8",
    "name": "Lichen pilaris",
    "synonyms": [
      "ALDH18A1-abhängiges De-Barsy-Syndrom",
      "Abnorme Handfurchen",
      "Acrokeratosis verruciformis Hopf",
      "Akrokeratosis verruciformis",
      "Akzessorischer Hautanhang",
      "Angeborene Keratodermatitis",
      "Angeborene elastische Haut",
      "Angeborenes Hautanhängsel",
      "Angeborenes Tyloma palmaris et plantaris",
      "Angeborenes zusätzliches Hautanhängsel",
      "Angiomatose",
      "Angiomatosis",
      "Autosomal-dominante Cutis laxa",
      "Autosomal-dominante Palmoplantarkeratose mit kongenitaler Alopezie",
      "Autosomal-rezessive Cutis laxa Typ 1",
      "Autosomal-rezessive Cutis laxa Typ 1C",
      "Autosomal-rezessive Cutis laxa Typ 2",
      "Autosomal-rezessive Cutis laxa Typ 2A",
      "Autosomal-rezessive Cutis laxa Typ 2B",
      "Basan-Syndrom",
      "Bazex-Dupré-Christol-Syndrom",
      "Benigne Akanthose",
      "Berlin-Syndrom",
      "Bloom-Machacek-Torre-Syndrom",
      "Bloom-Syndrom",
      "Bork-Syndrom",
      "Brauer-Syndrom",
      "Brugsch-Syndrom",
      "CEDNIK [Zerebrale Dysgenesie, Neuropathie, Ichthyose, palmo-plantares Keratoderm]-Syndrom",
      "CHAND [Kraushaar, Ankyloblepharon, Nageldysplasie]-Syndrom",
      "Chronischer benigner familiärer Pemphigus",
      "Clouston-Syndrom",
      "Cole-Krankheit",
      "Cronkhite-Canada-Syndrom",
      "Cutis hyperelastica",
      "Cutis laxa congenita [Cutis laxa hyperelastica] [Cutis laxa (hereditaria)]",
      "Cutis laxa hyperelastica",
      "Cutis laxa mit Gelenkinstabilität und Entwicklungsverzögerung",
      "Cutis verticis gyrata",
      "Darier-I-Syndrom",
      "Darier-Krankheit",
      "Darier-White-Krankheit",
      "De-Barsy-Syndrom",
      "Dermatochalasis",
      "Dermatoglyphenanomalie",
      "Dermatolyse",
      "Dermatorrhexis",
      "Diffuse Palmoplantarkeratose mit Akrozyanose",
      "Diffuse neonatale Hämangiomatose",
      "Diffuse palmoplantare progressive Hyperkeratose",
      "Diffuse progressive PPK [Palmoplantare Keratose]",
      "Disseminierte superfizielle aktinische Porokeratose",
      "Dyskeratosis congenita",
      "Dyskeratosis follicularis Darier",
      "Dyskeratosis follicularis vegetans Darier",
      "EDSS1 [Ektodermale Dysplasie-Syndaktylie-Syndrom 1]",
      "EDSS2 [Ektodermale Dysplasie-Syndaktylie-Syndrom 2]",
      "EEC [Ektrodaktylie, ektodermale Dysplasie, Lippen-Kiefer-Gaumen-Spalte]-Syndrom",
      "Ektodermale Dysplasie mit natalen Zähnen Typ Turnpenny",
      "Ektodermale Dysplasie vom tricho-odonto-onychalen Typ",
      "Ektodermale Dysplasie, Haar-Nagel-Typ",
      "Ektodermale Dysplasie-Syndaktylie-Syndrom 1",
      "Ektodermale Dysplasie-Syndaktylie-Syndrom 2",
      "Ektodermale odonto-mikronychiale Dysplasie",
      "Ektodermalsyndrom a.n.k.",
      "Elastische Haut",
      "Elastoma",
      "Erythrokeratoderma en cocardes",
      "Erythrokeratodermia progressiva symmetrica",
      "Erythrokeratodermia variabilis",
      "Exfoliative Dermatolyse",
      "Familiäres kutanes Kollagenom",
      "Feinmesser-Zelig-Syndrom",
      "Fischer-Syndrom",
      "Fistula umbilicalis",
      "Fokale Palmoplantarkeratose mit Hyperkeratose an den Gelenken",
      "Fokale akrale Hyperkeratose",
      "Fokale dermale Hypoplasie",
      "Fokale faziale dermale Dysplasie",
      "Fokale faziale dermale Dysplasie Typ I",
      "Fokale faziale dermale Dysplasie Typ II",
      "Fokale faziale dermale Dysplasie Typ III",
      "Fokale palmoplantare und gingivale Keratose",
      "Geroderma osteodysplastica",
      "Gougerot-Hailey-Hailey-Syndrom",
      "Gougerot-Hailey-Krankheit",
      "Greither-Syndrom",
      "Groenblad-Strandberg-Syndrom",
      "HBID [Hereditäre benigne intraepitheliale Dyskeratose]",
      "HOPP [Hypotrichose, Osteolyse, Periodontitis, Palmoplantarkeratose]-Syndrom",
      "Hailey-Hailey-Krankheit",
      "Haim-Munk-Syndrom",
      "Handfurchenabnormität",
      "Hanhart-Syndrom [Keratodermia palmoplantaris papulosa]",
      "Hauthypoplasie",
      "Hautleistenanomalie",
      "Hereditäre Palmoplantarkeratose",
      "Hereditäre Palmoplantarkeratose Typ Gamborg-Nielsen",
      "Hereditäre akrokeratotische Poikilodermie",
      "Hereditäre benigne intraepitheliale Dyskeratose",
      "Hereditäre fibröse Poikilodermie mit Sehnenkontraktur, Myopathie und Lungenfibrose",
      "Hereditäre sklerosierende Poikilodermie Typ Weary",
      "Hereditäre symmetrische Keratosis palmaris et plantaris",
      "Hidrotisch ektodermale Dysplasie Typ Christianson-Fourie",
      "Hidrotisch ektodermale Dysplasie Typ Halal",
      "Hidrotische Ektodermaldysplasie",
      "Huriez-Syndrom",
      "Hyperkeratose-Hyperpigmentierungs-Syndrom",
      "Hyperkeratosis follicularis",
      "Hämangiomatose",
      "Ichthyosis palmaris et plantaris",
      "Isolierte kongenitale Adermatoglyphie",
      "Isolierte nichtepidermolytische fokale Palmoplantarkeratose",
      "Jagell-Holmgren-Hofer-Syndrom",
      "Juveniles Elastom",
      "KRT1-assoziierte nichtepidermolytische diffuse P"
    ]
  },
  {
    "code": "Q82.9",
    "name": "Ektodermale Anomalie",
    "synonyms": [
      "Angeborene Hautanomalie",
      "Angeborene Hautdeformität",
      "Angeborene ektodermale Deformität",
      "Ektodermale Anomalie",
      "Hautfehlbildung a.n.k.",
      "Kongenitaler ektodermaler Defekt",
      "Talgdrüsenanomalie"
    ]
  },
  {
    "code": "Q83.0",
    "name": "Amastie mit angeborenem Fehlen der Brustwarze",
    "synonyms": [
      "Amastie mit angeborenem Fehlen der Brustwarze",
      "Angeborenes Fehlen der Mamma mit Fehlen der Brustwarze",
      "Brustdrüsenagenesie mit Fehlen der Brustwarze",
      "Isolierte kongenitale Amastie",
      "Mammaagenesie mit Fehlen der Mamille"
    ]
  },
  {
    "code": "Q83.1",
    "name": "Polymastie",
    "synonyms": [
      "Akzessorische Brustdrüse",
      "Akzessorische Mamma",
      "Akzessorisches axilläres Brustdrüsengewebe",
      "Akzessorisches axilläres Mammagewebe",
      "Axilläre Brustdrüse",
      "Axilläre Mamma",
      "Polymastie",
      "Tetramastie",
      "Überzählige Brustdrüse",
      "Überzählige Mamma"
    ]
  },
  {
    "code": "Q83.2",
    "name": "Athelie",
    "synonyms": [
      "Angeborenes Fehlen der Brustwarze",
      "Athelie",
      "Brustwarzenagenesie"
    ]
  },
  {
    "code": "Q83.3",
    "name": "Polythelie",
    "synonyms": [
      "Akzessorische Brustwarze",
      "Familiäre Polythelie",
      "Isolierte Polythelie",
      "Polythelie",
      "Überzählige Brustwarze"
    ]
  },
  {
    "code": "Q83.80",
    "name": "Tubuläre Brust",
    "synonyms": [
      "Tubuläre Brust"
    ]
  },
  {
    "code": "Q83.88",
    "name": "Mammaasymmetrie",
    "synonyms": [
      "Aberrierende Mamma",
      "Agenesie der Brustdrüse bei vorhandener Brustwarze",
      "Agenesie der Mamma bei vorhandener Brustwarze",
      "Amastie",
      "Amastie bei vorhandener Brustwarze",
      "Angeborene Brustdrüsenhypoplasie",
      "Angeborene Hypoplasie der Areola mammae",
      "Angeborenes Fehlen der Mamma",
      "Brustdrüsenaberration",
      "Ektopie von Brustdrüsengewebe",
      "Ektopie von Mammagewebe",
      "Hypomastie",
      "Isolierte kongenitale Mammahypoplasie",
      "Knospenbrust [Mikromastie]",
      "Kongenitale Brustwarzeninversion",
      "Kongenitale Brustwarzenretraktion",
      "Kongenitale Lageanomalie der Brustdrüse",
      "Kongenitale Lageanomalie der Mamma",
      "Mammaaberration",
      "Mammaasymmetrie",
      "Mammahypoplasie",
      "Mammahypotrophie",
      "Mikromastie",
      "Rüsselbrust"
    ]
  },
  {
    "code": "Q83.9",
    "name": "Angeborene Mammafehlbildung",
    "synonyms": [
      "Angeborene Brustdeformität",
      "Angeborene Brustdrüsendeformität",
      "Angeborene Brustwarzendeformität",
      "Angeborene Mammadeformität",
      "Angeborene Mammafehlbildung",
      "Brustdrüsenanomalie",
      "Brustwarzenanomalie",
      "Mamillenanomalie",
      "Mammaanomalie"
    ]
  },
  {
    "code": "Q84.0",
    "name": "Angeborene Alopezie",
    "synonyms": [
      "Agenesie der Haare",
      "Alopecia congenita",
      "Angeborene Alopezie",
      "Angeborene Atrichie",
      "Atrichia congenita universalis",
      "Atrichie mit papulösen Läsionen",
      "Hypotrichose vom Typ Marie Unna",
      "Kongenitale Hypotrichose",
      "Kongenitale Oligotrichie",
      "Unna-Syndrom"
    ]
  },
  {
    "code": "Q84.1",
    "name": "Monilethrix",
    "synonyms": [
      "Angeborene Monilethrichose",
      "Angeborene Pili anulati",
      "Angeborene Pili torti",
      "Angeborenes Wollhaar",
      "Angeborenes perliges Haar",
      "Angeborenes verdrehtes Haar",
      "Kongenitale Monilethrix",
      "Kongenitale Pinselhaare",
      "Kongenitale Ringelhaare",
      "Kongenitale Spindelhaare",
      "Kongenitale Trichostasis spinulosa",
      "Monilethrichose",
      "Monilethrix",
      "Monilitrichie",
      "Pili anulati",
      "Pili torti",
      "Pili trianguli et canaliculi",
      "Pinselhaare",
      "Ringelhaare",
      "Sabouraud-Syndrom",
      "Spindelhaare",
      "Trichostasis spinulosa",
      "Wollhaar"
    ]
  },
  {
    "code": "Q84.2",
    "name": "Angeborenes Ulerythema ophryogenes",
    "synonyms": [
      "Ambras-Syndrom",
      "Angeborene Fehlbildung der Haare",
      "Angeborene Haaranomalie",
      "Angeborene Hypertrichose",
      "Angeborenes Ulerythema ophryogenes",
      "Familiäre isolierte Trichomegalie",
      "Fortbestehende Lanugo",
      "Hypertrichosis cubiti",
      "Hypoplasie der Haare",
      "Kongenitale Canities",
      "Kongenitale Hypertrichose",
      "Kongenitale Hypertrichosis lanuginosa",
      "Kongenitales Ergrauen der Haare",
      "Lanuginöse Hypertrichose",
      "Lanugobehaarung",
      "Persistierende Lanugo",
      "Persistierende Lanugobehaarung"
    ]
  },
  {
    "code": "Q84.3",
    "name": "Anonychie",
    "synonyms": [
      "Agenesie der Nägel",
      "Angeborene Anonychie",
      "Angeborene totale Anonychie",
      "Anonychie"
    ]
  },
  {
    "code": "Q84.4",
    "name": "Angeborene Leukonychie",
    "synonyms": [
      "Angeborene Leukonychia totalis",
      "Angeborene Leukonychie",
      "Kongenitale Leukonychie",
      "Kongenitale Leukopathia unguinum"
    ]
  },
  {
    "code": "Q84.5",
    "name": "Pachyonychie",
    "synonyms": [
      "Angeborene Onychauxis",
      "Kongenitale Nagelhypertrophie",
      "Kongenitale Nagelverdickung",
      "Kongenitale Onychauxis",
      "Kongenitale Pachyonychie",
      "PC [Pachyonychia congenita]",
      "Pachyonychia congenita",
      "Pachyonychie",
      "Skleronychie"
    ]
  },
  {
    "code": "Q84.6",
    "name": "Angeborene Nagelanomalie",
    "synonyms": [
      "Akzessorischer Nagel",
      "Angeborene Koilonychie",
      "Angeborene Nagelanomalie",
      "Angeborene Nageldeformität",
      "Angeborene Nagelfehlbildung",
      "Angeborener Klumpnagel",
      "Atrophia unguium congenita",
      "Autosomal-rezessive Nageldysplasie",
      "Jadassohn-Lewandowsky-Syndrom",
      "Kongenitale Koilonychie",
      "Kongenitale Lageanomalie eines Nagels",
      "Kongenitale Löffelnägel",
      "Kongenitale Nageldemineralisation",
      "Kongenitale Nageldystrophie",
      "Kongenitale Nagelverlagerung",
      "Kongenitale Onychodysplasie",
      "Kongenitale Onychodystrophie",
      "Kongenitale Onychorrhexis",
      "Kongenitale Platyonychie",
      "Kongenitale Querfurchen der Nägel",
      "Kongenitale longitudinale Furchen der Nägel",
      "Kongenitale longitudinale Streifen der Nägel",
      "Kongenitaler Fingernagelüberrest",
      "Kongenitaler Klumpnagel",
      "Nagelfehlbildung",
      "Nagelhypoplasie",
      "Persistierender abnormer Nagel",
      "Platyonychie",
      "Polyonychie"
    ]
  },
  {
    "code": "Q84.8",
    "name": "Kongenitale Hautaplasie",
    "synonyms": [
      "Aplasia cutis congenita",
      "Didymosis aplasticosebacea",
      "Kongenitale Hautaplasie",
      "Odonto-Onycho-Dysplasie mit Alopezie",
      "PLACK [Peeling skin, Leukonychie, punktierte akrale Keratose, Cheilitis, Fingerknöchelpolster]-Syndrom",
      "Rezessive Aplasia cutis congenita der Gliedmaßen",
      "SCALP [Naevus sebaceus, ZNS-Fehlbildungen, Aplasia cutis congenita, limbales Dermoid, pigmentierter Naevus]-Syndrom",
      "Syndrom der Leukonychie mit peeling skin, punktierter akraler Keratose, Cheilitis und Fingerknöchelpolster"
    ]
  },
  {
    "code": "Q84.9",
    "name": "Angeborene Integumentumanomalie",
    "synonyms": [
      "Angeborene Integumentdeformität",
      "Angeborene Integumentumanomalie"
    ]
  },
  {
    "code": "Q85.0",
    "name": "Nichtbösartige Neurofibromatose",
    "synonyms": [
      "Gutartige Neurofibromatose",
      "Legius-Syndrom",
      "Morbus von Recklinghausen [Neurofibromatose]",
      "Mosaik-Legius-Syndrom",
      "Mosaik-Neurofibromatose Typ 1",
      "Mosaik-Neurofibromatose Typ 2",
      "Mosaik-Neurofibromatose Typ 3",
      "Multiple Neurofibromatose",
      "NF [Neurofibromatose] Typ 1",
      "NF [Neurofibromatose] Typ 2",
      "NF [Neurofibromatose] Typ 3",
      "NF1 [Neurofibromatose Typ 1]-Mikrodeletionssyndrom",
      "Neurofibromatose",
      "Neurofibromatose Typ 1",
      "Neurofibromatose Typ 1 durch NF1-Genmutation",
      "Neurofibromatose Typ 1 durch intragenische Deletion",
      "Neurofibromatose Typ 2",
      "Neurofibromatose Typ 3",
      "Neurofibromatose Typ 6",
      "Neurofibromatose-Typ-1-Mikrodeletionssyndrom",
      "Nichtbösartige Neurofibromatose",
      "Nichtmaligne Neurofibromatose",
      "Nichtmaligne Schwannomatose",
      "Schwannomatose",
      "Von-Recklinghausen-Krankheit",
      "Von-Recklinghausen-Neurofibromatose",
      "Von-Recklinghausen-Syndrom",
      "Watson-Syndrom"
    ]
  },
  {
    "code": "Q85.1",
    "name": "Bourneville-Syndrom",
    "synonyms": [
      "Adenoma sebaceum Pringle",
      "Bourneville-Krankheit",
      "Bourneville-Phakomatose",
      "Bourneville-Pringle-Syndrom",
      "Bourneville-Syndrom",
      "Epiloia",
      "Pringle-Krankheit",
      "Pringle-Syndrom",
      "Spongioblastosis centralis circumscripta",
      "Tuberöse Gehirnsklerose",
      "Tuberöse Hirnsklerose",
      "Tuberöse Sklerose",
      "Tuberöse Sklerose-Komplex"
    ]
  },
  {
    "code": "Q85.8",
    "name": "Morbus von Hippel-Lindau",
    "synonyms": [
      "Angeborener panfollikulärer Naevus",
      "Angeborenes Hamartom der glatten Muskulatur",
      "Angiomatosis cerebelli et retinae",
      "Angiomatosis encephalofacialis",
      "Angiomatosis retinocerebellaris",
      "Basalzellnävussyndrom",
      "Birt-Hogg-Dubé-Syndrom",
      "Cowden-Syndrom",
      "Enzephalokutane Angiomatose",
      "Enzephalotrigeminale Angiomatose",
      "Familiäre retino-zerebelläre Angiomatose",
      "Gorlin-Goltz-Syndrom",
      "Hornstein-Knickenberg-Syndrom",
      "Krabbe-III-Syndrom",
      "Lindau-Krankheit",
      "Lindau-Syndrom",
      "Morbus von Hippel-Lindau",
      "Naevus comedonicus-Syndrom",
      "Netzhautangiomatose",
      "PJS [Peutz-Jeghers-Syndrom]",
      "Peutz-Jeghers-Syndrom",
      "Phakomatosis cesioflammea",
      "Phakomatosis cesiomarmorata",
      "Phakomatosis pigmentokeratotica",
      "Phakomatosis pigmentovascularis",
      "Phakomatosis pigmentovascularis Typ II",
      "Phakomatosis pigmentovascularis Typ III",
      "Phakomatosis pigmentovascularis Typ V",
      "Phakomatosis spilorosea",
      "Pigmentfleckenpolyposis",
      "Retino-zerebelläre Angiomatose Hippel-Lindau",
      "Schimmelpenning-Feuerstein-Mims-Syndrom",
      "Sturge-Weber-Dimitri-Syndrom",
      "Sturge-Weber-Krabbe Angiomatose",
      "Sturge-Weber-Krabbe-Syndrom",
      "Sturge-Weber-Krankheit",
      "Sturge-Weber-Syndrom",
      "Syndrom der generalisierten basaloiden follikulären Hamartome",
      "Syndrom des linearen Naevus sebaceus",
      "VHL [Von-Hippel-Lindau-Syndrom]",
      "Von-Hippel-Lindau-Krankheit",
      "Von-Hippel-Lindau-Syndrom",
      "Zerebroretinale Angiomatose",
      "Zystisches Hamartom der Lunge und der Nieren"
    ]
  },
  {
    "code": "Q85.9",
    "name": "Hamartose",
    "synonyms": [
      "Hamartie",
      "Hamartoblastom",
      "Hamartom",
      "Hamartose",
      "Phakomatose"
    ]
  },
  {
    "code": "Q86.0",
    "name": "Alkoholembryopathie mit Dysmorphien",
    "synonyms": [
      "Alkoholembryopathie",
      "Alkoholembryopathie mit Dysmorphien",
      "Angeborenes Fehlbildungssyndrom durch Alkohol",
      "Dysmorphie durch Alkohol",
      "Embryofetales Alkoholsyndrom",
      "Embryofetopathia alcoholica",
      "Fetales Alkoholsyndrom"
    ]
  },
  {
    "code": "Q86.1",
    "name": "Antiepileptikaembryopathie",
    "synonyms": [
      "Angeborenes Fehlbildungssyndrom durch Antiepileptika",
      "Angeborenes Fehlbildungssyndrom durch Hydantoin",
      "Antiepileptikaembryopathie",
      "Embryofetales Hydantoin-Syndrom",
      "Hydantoin-Embryopathie",
      "Hydantoindysmorphie"
    ]
  },
  {
    "code": "Q86.2",
    "name": "Warfarinembryopathie",
    "synonyms": [
      "Angeborenes Fehlbildungssyndrom durch Warfarin",
      "Embryopathie durch Cumarine",
      "Embryopathie durch Vitamin K-Antagonisten",
      "Warfarindysmorphie",
      "Warfarinembryopathie"
    ]
  },
  {
    "code": "Q86.80",
    "name": "Thalidomid-Embryopathie",
    "synonyms": [
      "Thalidomid-Embryopathie",
      "Thalidomid-Fetopathie"
    ]
  },
  {
    "code": "Q86.88",
    "name": "Embryopathie",
    "synonyms": [
      "Aminopterin-Embryopathie",
      "Angeborene Fehlbildung durch maternale Hyperthermie",
      "Diethylstilböstrol-Syndrom",
      "Dysmorphie durch äußere Ursache a.n.k.",
      "Embryopathie",
      "Embryopathie durch äußere Ursache a.n.k.",
      "Fetales Carbamazepin-Syndrom",
      "Fetales Minoxidil-Syndrom",
      "Fetales Trimethadion-Syndrom",
      "Indometacin-Embryopathie",
      "Isotretinoin-Embryofetopathie",
      "Kokain-Embryofetopathie",
      "Methimazol-Embryofetopathie",
      "Mycophenolat-Mofetil-Embryopathie",
      "Phenobarbital-Embryopathie",
      "Propylthiouracil-Embryopathie",
      "Retinoid-Embryopathie",
      "Toluol-Embryopathie",
      "Valproat-Embryopathie"
    ]
  },
  {
    "code": "Q87.0",
    "name": "Goldenhar-Syndrom",
    "synonyms": [
      "ACS [Akrozephalosyndaktylie]",
      "ACS [Akrozephalosyndaktylie] Typ 3",
      "ACS [Akrozephalosyndaktylie] Typ 5",
      "Ablepharon-Makrostomie-Syndrom",
      "Adduzierte Daumen mit Arthrogrypose vom Typ Christian",
      "Aglossie-Adaktylie-Syndrom",
      "Akro-kranio-faziale Dysostose",
      "Akro-oto-okuläres Syndrom",
      "Akromele frontonasale Dysplasie",
      "Akrozephalopolydaktyle Dysplasie",
      "Akrozephalopolysyndaktylie Typ 4",
      "Akrozephalopolysyndaktylie-Syndrom",
      "Akrozephalopolysyndaktylie-Syndrom, Formenkreis [Carpenter-Syndrom]",
      "Akrozephalosyndaktylie",
      "Akrozephalosyndaktylie Typ 3",
      "Akrozephalosyndaktylie Typ 5",
      "Akrozephalosyndaktylie-Syndrom",
      "Akrozephalosyndaktylie-Syndrom, Formenkreis [Apert-Syndrom]",
      "Angeborene Pierre-Robin-Deformität",
      "Angeborene okulofaziale Paralyse",
      "Angeborenes faziales Diplegie-Syndrom",
      "Angeborenes okulo-aurikulo-vertebrales Syndrom",
      "Angeborenes okulofaziales Diplegie-Syndrom",
      "Antley-Bixler-Syndrom",
      "Apert-Syndrom [Form des Akrozephalosyndaktylie-Syndroms]",
      "Arrhinie mit Choanalatresie und Mikrophthalmie",
      "Ascher-Syndrom",
      "Au-Kline-Syndrom",
      "Autosomal-dominante Myopie mit Mittelgesichtsretrusion, sensorineuraler Schwerhörigkeit und rhizomeler Dysplasie",
      "Autosomal-rezessives Stickler-Syndrom",
      "Autosomal-rezessives fazio-digito-genitales Syndrom",
      "Bainbridge-Ropers-Syndrom",
      "Barber-Say-Syndrom",
      "Basel-Vanagaite-Smirin-Yosef-Syndrom",
      "Beaulieu-Boycott-Innes-Syndrom",
      "Beidseitige Mikrotie mit Schwerhörigkeit und Gaumenspalte",
      "Blepharo-cheilo-dontie-Syndrom",
      "Blepharo-naso-faziales Syndrom",
      "Bosma-Arhinie-Mikrophthalmie-Syndrom",
      "Brachytelephalangie mit Dysmorphien und Kallmann-Syndrom",
      "CDHS [Craniofacial-deafness-hand syndrome]",
      "CDK13-assoziiertes Syndrom der angeborenen Herzfehler mit Intelligenzminderung und Gesichtsdysmorphien",
      "Carey-Fineman-Ziter-Syndrom",
      "Carpenter-Syndrom [Form des Akrozephalopolysyndaktylie-Syndroms]",
      "Charlie-M-Syndrom",
      "Chung-Jansen-Syndrom",
      "Clark-Baraitser-Syndrom",
      "Coffin-Lowry-Syndrom",
      "Corpus-callosum-Agenesie mit schwerer Intelligenzminderung, Gesichtsdysmorphien und zerebellarer Ataxie",
      "Culler-Jones-Syndrom",
      "Curry-Jones-Syndrom",
      "DPG [Duplication of the pituitary gland]-plus-Syndrom",
      "DYRK1A-abhängiges Intelligenzminderungs-Syndrom",
      "Dennis-Fairhurst-Moore-Syndrom",
      "Diets-Jongmans-Syndrom",
      "Dyskraniopygophalangie",
      "Dysplasia oculo-auriculo-vertebralis",
      "ERF-assoziierte syndromale Kraniosynostose",
      "Elschnig-Syndrom",
      "Epilepsie-Teleangiektasie-Syndrom",
      "FHEIG [Faziale Dysmorphien, Hypertrichose, Epilepsie, Intelligenzminderung mit Entwicklungsverzögerung, Gingivahypertrophie]-Syndrom",
      "Faziales Fehlbildungssyndrom",
      "Fazio-aurikulo-vertebrale Dysplasie",
      "First-arch-Syndrom",
      "Fraser-Syndrom",
      "Freeman-Sheldon-Syndrom",
      "Friedman-Goodman-Syndrom",
      "Frontometaphysäre Dysplasie",
      "Frontonasale Dysplasie mit Alopezie und Genitalanomalien",
      "Fryns-Smeets-Thiry-Syndrom",
      "Gabriele-de-Vries-Syndrom",
      "Gaumenspalte mit Kleinwuchs und Wirbelanomalien",
      "Goldenhar-Symptomenkomplex [Dysplasia oculo-auriculo-vertebralis]",
      "Goldenhar-Syndrom",
      "Goodman-Syndrom",
      "Gorlin-Chaudhry-Moss-Syndrom",
      "Guadalajara-Kamptodaktylie-Syndrom Typ 3",
      "HMC [Hypertelorismus, Mikrotie, Gesichtsspalten]-Syndrom",
      "HPPD [Hypertelorismus, präaurikulärer Sinus, punktförmige Grübchen, Schwerhörigkeit]-Syndrom",
      "Hallermann-Streiff-Syndrom",
      "Hallermann-Streiff-ähnliches Syndrom",
      "Hamamy-Syndrom",
      "Hanhart-Syndrom [Oroakraler Fehlbildungskomplex]",
      "Heimler-Syndrom",
      "Hemifaziale Mikrosomie",
      "Hepatische Fibrose mit Nierenzysten und Intelligenzminderung",
      "Hereditäre progressive Arthro-Ophthalmopathie",
      "Hunter-McAlpine-Syndrom",
      "Hyde-Forster-McCarthy-Berry-Syndrom",
      "Hypotrichose mit Intelligenzminderung Typ Lopes",
      "Intelligenzminderungs-Syndrom durch Punktmutation im DYRK1A-Gen",
      "Juberg-Marsidi-Syndrom",
      "Kardiale kraniozerebelläre Dysplasie",
      "Keipert-Syndrom",
      "Khalifa-Graham-Syndrom",
      "Kongenitale hereditäre Fazialisparese mit variablem Hörverlust",
      "Kongenitales Fehlbildungssyndrom mit vorwiegender Gesichtsbeteiligung",
      "Kranio-fazio-fronto-digitales Syndrom",
      "Kraniodigitales Syndrom Scott",
      "Kraniofaziale Dyssynostose",
      "Kraniofaziale Mikrosomie",
      "Kraniofaziales Syndrom Simosa",
      "Kraniokarpotarsale Dysplasie",
      "Kraniokarpotarsale Dystrophie",
      "Kraniom"
    ]
  },
  {
    "code": "Q87.1",
    "name": "Prader-Willi-Syndrom",
    "synonyms": [
      "7-Dehydrocholesterinreduktase-Mangel",
      "AUTS2-Syndrom",
      "Aarskog-Scott-Syndrom",
      "Aarskog-Syndrom",
      "Al-Gazali-Aziz-Salem-Syndrom",
      "Alazami-Syndrom",
      "Amsterdamer Degenerationstyp",
      "Autismus-Spektrum-Störung durch AUTS2-Mangel",
      "Autosomal-dominantes Kenny-Caffey-Syndrom",
      "Autosomal-dominantes Robinow-Syndrom",
      "Autosomal-dominantes multiples Pterygium-Syndrom",
      "Autosomal-rezessives Kenny-Caffey-Syndrom",
      "Autosomal-rezessives Robinow-Syndrom",
      "Autosomal-rezessives multiples Pterygium-Syndrom",
      "BOD [Brachymorphie, Onychodysplasie, Dysphalangie]-Syndrom",
      "Bonneman-Meinecke-Reich-Syndrom",
      "Bonnevie-Ullrich-Syndrom",
      "Bruck-de-Lange-Krankheit",
      "Bumerang-Dysplasie",
      "Cockayne-Syndrom",
      "Cockayne-Syndrom Typ 1",
      "Cockayne-Syndrom Typ 2",
      "Cockayne-Syndrom Typ 3",
      "Coffin-Siris-Syndrom",
      "Cornelia-de-Lange-I-Syndrom",
      "Cornelia-de-Lange-II-Syndrom",
      "Cornelia-de-Lange-Syndrom",
      "Coxoaurikuläres Syndrom",
      "DONSON-assoziierte Mikrozphalie mit Kleinwuchs und Extremitätenanomalien",
      "De-Lange-II-Syndrom",
      "De-Lange-Syndrom",
      "Distale Osteolyse mit Kleinwuchs und Intelligenzminderung",
      "Dubowitz-Syndrom",
      "EXTL3-assoziiertes Syndrom der neuro-immuno-skelettalen Dysplasie",
      "FILS [Gesichtsdysmorphien-Immundefekt-Livedo-Kleinwuchs]-Syndrom",
      "Familiäres multiples lentigines Syndrom",
      "Fazio-genitale Dysplasie",
      "Fazio-genito-digitales Syndrom",
      "Fenton-Wilkinson-Toselano-Syndrom",
      "Fetal face-Syndrom",
      "Fettalkohol NAD+-Oxidoreduktase-Mangel",
      "Flughautkrankheit",
      "Flügelfell des Halses bei Turner-ähnlichem Syndrom",
      "GEMSS [Glaukom, ektopische Linse, Mikrosphärophakie, steife Gelenke, Kleinwuchs]-Syndrom",
      "Gaumenspalte-Makrotie-Kleinwuchs-Syndrom",
      "Geleophysische Dysplasie",
      "Gesichtsdysmorphien-Immundefekt-Livedo-Kleinwuchs-Syndrom",
      "Guadalajara-Kamptodaktylie-Syndrom Typ 1",
      "Guadalajara-Kamptodaktylie-Syndrom Typ 2",
      "Hereditäre makuläre bullöse Dystrophie",
      "Hyperostotischer Kleinwuchs Typ Lenz-Majewski",
      "IMAGE [Intrauterine Wachstumsverzögerung, metaphysäre Dysplasie, angeborene adrenale Hypoplasie, Genitalanomalien]-Syndrom",
      "Jung-Wolff-Back-Stahl-Syndrom",
      "Kampomele Dysplasie",
      "Kardiomyopathische Lentiginose",
      "Kenny-Caffey-Syndrom",
      "Kleinwuchs mit Brachydaktylie, Adipositas und globaler Entwicklungsverzögerung",
      "Kleinwuchs mit zerebellären und Hypophysendefekten und kleiner Sella turcica",
      "Kleinwuchs-Syndrom Typ Brüssel",
      "Kniest-Dysplasie",
      "Kniest-Syndrom",
      "Lange-II-Syndrom",
      "Larsen-ähnliches Syndrom mit Knochendysplasie und Kleinwuchs",
      "Larsen-ähnliches Syndrom, letale Form",
      "Lenz-Majewski-Syndrom",
      "Letales multiples Pterygium-Syndrom",
      "Liberfarb-Syndrom",
      "MAGEL2-assoziiertes Prader-Willi-ähnliches Syndrom",
      "MMM [Miller, McKusick, Malvaux]-Syndrom",
      "Meier-Gorlin-Syndrom",
      "Mikati-Najjar-Sahli-Syndrom",
      "Mikrozephaler osteodysplastischer primordialer Kleinwuchs Typ 1",
      "Mikrozephaler osteodysplastischer primordialer Kleinwuchs Typ 2",
      "Mikrozephaler osteodysplastischer primordialer Kleinwuchs Typ 3",
      "Mikrozephaler primordialer Kleinwuchs Typ Dauber",
      "Mikrozephaler primordialer Kleinwuchs Typ Toriello",
      "Mikrozephaler primordialer Kleinwuchs durch RTTN-Defekt",
      "Mikrozephaler primordialer Kleinwuchs durch ZNF335-Mangel",
      "Moyamoya-Krankheit mit Kleinwuchs, Gesichtsdysmorphien und hypergonadotropem Hypogonadismus",
      "Neurofibromatose-Noonan-Syndrom",
      "Nivelon-Nivelon-Mabille Syndrom",
      "Noonan-Syndrom",
      "Noonan-ähnliches Syndrom mit losem Anagenhaar",
      "Ohr-Patella-Kleinwuchs-Syndrom",
      "Okulo-palato-zerebraler Kleinwuchs",
      "Okulo-skeleto-dentales Syndrom",
      "Osteochondrodysplastischer Kleinwuchs mit Schwerhörigkeit und Retinitis pigmentosa",
      "Osteoglophone Dysplasie",
      "PUM1-assoziierte Entwicklungsstörung mit Ataxie und Krampfanfällen",
      "Parastremmatische Dysplasie",
      "Passwell-Goodman-Ziprkowski-Syndrom",
      "Pfeiffer-Palm-Teller-Syndrom",
      "Prader-Labhart-Willi-Syndrom",
      "Prader-Willi-Syndrom",
      "Prader-Willi-Syndrom durch paternale Deletion 15q11.13",
      "Prader-Willi-ähnliches Syndrom",
      "Pseudo-Turner-Syndrom",
      "Pseudo-Ullrich-Turner-Syndrom",
      "Pterygium colli bei Turner-ähnlichem Syndrom",
      "Pterygiumsyndrom",
      "QRICH1-assoziiertes Intelligenzminderungs-Chondrodysplasie-Syndrom",
      "RAPADILINO-Syndrom",
      "Rhizomeles Syndrom Typ Urbach",
      "Robinow-Silverman-Smith-Syndrom",
      "Robinow-Syndrom",
      "SAMS [Kl"
    ]
  },
  {
    "code": "Q87.2",
    "name": "VACTERL-Assoziation [Vertebraldefekte, Analatresie, kardiale Anomalien, Tracheo-Ösophageal-Fistel mit Ösophagusatresie, renale und Extremitätenanomalien]",
    "synonyms": [
      "Adams-Oliver-Syndrom",
      "Akrorenales Syndrom",
      "Al-Awadi-Raas-Rothschild-Syndrom",
      "Angio-osteo-hypertrophisches Syndrom",
      "Antekubitales Pterygium-Syndrom",
      "Aphalangie mit Syndaktylie und Mikrozephalie",
      "Atriodigitale Dysplasie Typ 1",
      "Atriodigitale Dysplasie Typ 3",
      "Bartsocas-Papas-Syndrom",
      "Brachydaktylie mit langem Daumen",
      "CATSHL [Kampodaktylie, Hochwuchs, Skoliose, Hörverlust]-Syndrom",
      "Collins-Pope-Syndrom",
      "Hecht-Scott-Syndrom",
      "Herz-Hand-Syndrom",
      "Herz-Hand-Syndrom Typ 1",
      "Herz-Hand-Syndrom Typ 2",
      "Herz-Hand-Syndrom Typ 3",
      "Herz-Hand-Syndrom vom slowenischen Typ",
      "Holt-Oram-Syndrom",
      "Illum-Syndrom",
      "Inverses Klippel-Trenaunay-Syndrom",
      "Jancar-Syndrom",
      "Kardiomeles Syndrom Typ 3",
      "Kardioskelettales Syndrom Typ Kuwait",
      "Klippel-Trenaunay-Weber-Syndrom",
      "Kozlowski-Krajewska-Syndrom",
      "Laurin-Sandrow-Syndrom",
      "Limb-Mammary-Syndrom",
      "Mamma-Finger-Nagel-Syndrom",
      "Metaphysäre Dysostose mit Intelligenzminderung und Schallleitungsschwerhörigkeit",
      "Mietens-Syndrom",
      "Mietens-Weber-Syndrom",
      "Nagel-Patella-Syndrom",
      "Offener Ductus arteriosus mit bikuspider Aortenklappe und Handfehlbildungen",
      "Osteoonychodysostose",
      "Osteoonychodysplasie",
      "Parkes-Weber-Syndrom",
      "Piussan-Lenaerts-Mathieu-Syndrom",
      "Präaxiales Brachydaktylie-Syndrom Typ Temtamy",
      "Radioulnare Synostose mit amegakaryozytischer Thrombozytopenie",
      "Rubinstein-Taybi-Syndrom",
      "Rubinstein-Taybi-Syndrom durch CREBBP-Genmutation",
      "Rubinstein-Taybi-Syndrom durch EP300-Genmutation",
      "Sirenomelie",
      "Sirenomelie-Syndrom",
      "Stoll-Lévy-Francfort-Syndrom",
      "Syndrom der Polydaktylie mit Myopie",
      "Syndrom der Radiusaplasie mit anogenitalen Anomalien",
      "Syndrom der Radiushypoplasie mit triphalangealem Daumen, Hypospadie, Progenie und maxillärem Diastema",
      "Syndrom der Skalpdefekte mit postaxialer Polydaktylie",
      "Syndrom der Spalthand mit Spaltfuß und Schwerhörigkeit",
      "Syndrom der Ulnahypoplasie mit geistiger Retardierung",
      "Syndrom der postaxialen Polydaktylie mit Intelligenzminderung",
      "Syndrom der postaxialen Polydaktylie mit dentalen und vertebralen Anomalien",
      "Syndrom der präaxialen Polydaktylie mit Kolobomen und geistiger Retardierung",
      "Syndrom der schweren Intelligenzminderung mit progressiver spastischer Diplegie",
      "Syndrom der spiegelbildlichen Polydaktylie mit vertebralen Segmentierungsdefekten und Extremitätenanomalien",
      "Syndrom der terminalen Knochendysplasie mit Pigmentstörungen",
      "Syndrom der tibialen Hemimelie mit Polysyndaktylie und triphalangealem Daumen",
      "TAR-Syndrom",
      "Tabatznik-Syndrom",
      "Thrombozytopenie mit Radiusaplasie [TAR]",
      "Thrombozytopenie-Radiusaplasie-Syndrom",
      "Turner-Kieser-Syndrom",
      "VACTERL-Assoziation [Vertebraldefekte, Analatresie, kardiale Anomalien, Tracheo-Ösophageal-Fistel mit Ösophagusatresie, renale und Extremitätenanomalien]",
      "VACTERL-Syndrom [Vertebraldefekte, Analatresie, kardiale Anomalien, Tracheo-Ösophageal-Fistel mit Ösophagusatresie, renale und Extremitätenanomalien]",
      "VATER-Assoziation [Vertebraldefekte, Analatresie, kardiale Anomalien, Tracheo-Ösophageal-Fistel mit Ösophagusatresie, renale und Radiusdysplasie]",
      "VATER-Syndrom [Vertebraldefekte, Analatresie, kardiale Anomalien, Tracheo-Ösophageal-Fistel mit Ösophagusatresie, renale und Radiusdysplasie]",
      "Waardenburg-Anophthalmie-Syndrom"
    ]
  },
  {
    "code": "Q87.3",
    "name": "Sotos-Syndrom",
    "synonyms": [
      "BWS [Beckwith-Wiedemann Syndrom]",
      "Beckwith-Wiedemann-Syndrom durch 11p15 Inversion",
      "Beckwith-Wiedemann-Syndrom durch 11p15 Translokation",
      "Beckwith-Wiedemann-Syndrom durch CDKN1C-Mutation",
      "Beckwith-Wiedemann-Syndrom durch Imprintingdefekt von 11p15",
      "Beckwith-Wiedemann-Syndrom durch Mikrodeletion 11p15",
      "Beckwith-Wiedemann-Syndrom durch Mikroduplikation 11p15",
      "Beckwith-Wiedemann-Syndrom durch NSD1-Mutation",
      "Beckwith-Wiedemann-Syndrom durch paternale uniparentale Disomie 11",
      "Beschleunigte Knochenalterung mit Gesichtsanomalie und Gedeihstörung",
      "CHD8-assoziiertes Großwuchs-Syndrom",
      "CLAPO-Syndrom [Capillary malformation of the lower lip, lymphatic malformation of the face and neck, asymmetry and partial or generalized overgrowth]",
      "CLOVES-Syndrom [Congenital lipomatous overgrowth, vascular malformation, epidermal nevi, spinal anomaly]",
      "Cantu-Syndrom",
      "DNMT3A-abhängiges Großwuchs-Syndrom",
      "Exomphalos mit Makroglossie und Gigantismus",
      "Großwuchs-Makrozephalie-Gesichtsdysmorphie-Syndrom",
      "Großwuchs-Syndrom mit Translokation 2q37",
      "HHML [Hemihyperplasie-multiple Lipomatosis-Syndrom]",
      "Hemi-3-Syndrom",
      "Hemihyperplasie-multiple Lipomatosis-Syndrom",
      "Hypertrichose mit Osteochondrodysplasie Typ Cantu",
      "Isolierte Hemihyperplasie",
      "Kosaki-Großwuchssyndrom",
      "MOMO [Macrosomia, obesity, macrocephaly, ocular abnormalities]-Syndrom",
      "Makrozephalie und cutis marmorata telangiectatica congenita",
      "Makrozephalie und kapilläre Fehlbildung-Syndrom",
      "Malan-Großwuchssyndrom",
      "Marshall-Smith-Syndrom",
      "Megalenzephalie mit kapillärer Fehlbildung und Polymikrogyrie-Syndrom",
      "Megalenzephalie und cutis marmorata telangiectatica congenita",
      "Megalenzephalie und kapilläre Fehlbildung-Syndrom",
      "Moreno-Nishimura-Schmidt-Syndrom",
      "Nephroblastom mit fetaler Aszites mit Makrosomie mit Wilms-Tumor",
      "Perlman-Syndrom",
      "Proteus-Syndrom",
      "Proteus-ähnliches Syndrom",
      "Simpson-Golabi-Behmel-Syndrom",
      "Sotos-Syndrom",
      "Sotos-Syndrom Typ 2",
      "Syndrom der Megalenzephalie mit schwergradiger Kyphoskoliose und Hochwuchs",
      "Syndrom des Großwuchses mit langen Großzehen und multiplen zusätzlichen Epiphysen",
      "Tatton-Brown-Rahman-Syndrom",
      "Thauvin-Robinet-Faivre-Syndrom",
      "Weaver-Syndrom",
      "Wiedemann-Beckwith-Syndrom",
      "Zerebraler Gigantismus"
    ]
  },
  {
    "code": "Q87.4",
    "name": "Marfan-Syndrom",
    "synonyms": [
      "Aneurysma-Osteoarthritis-Syndrom",
      "Aortenaneurysma-Syndrom durch TGFbeta-Rezeptor-Anomalie",
      "Arachnodaktylie",
      "Loeys-Dietz-Syndrom",
      "Loeys-Dietz-Syndrom Typ 1",
      "Loeys-Dietz-Syndrom Typ 2",
      "MFS [Marfan-Syndrom]",
      "MFS1 [Marfan-Syndrom Typ 1]",
      "MFS2 [Marfan-Syndrom Typ 2]",
      "Marfan-Syndrom",
      "Marfan-Syndrom Typ 1",
      "Marfan-Syndrom Typ 2",
      "Neonatales MFS [Marfan-Syndrom]",
      "Neonatales Marfan-Syndrom",
      "Spinnenfingrigkeit",
      "Spinnengliedrigkeit"
    ]
  },
  {
    "code": "Q87.5",
    "name": "Kabuki-Syndrom",
    "synonyms": [
      "Aurikulo-Osteodysplasie",
      "Becken-Schulter-Dysplasie",
      "Benallegue-Lacete-Syndrom",
      "Cousin-Syndrom",
      "Crane-Heise-Syndrom",
      "Exostosen mit Anetodermie und Typ E-Brachydaktylie",
      "Gemischte sklerosierende Knochendystrophie mit extraskelettalen Manifestationen",
      "Glossopalatine Ankylose",
      "Grant-Syndrom (Form einer Osteogenesis imperfecta)",
      "Gurrieri-Sammito-Bellussi-Syndrom",
      "Kabuki-Niikawa-Kuroki-Syndrom",
      "Kabuki-Syndrom",
      "Kagami-Ogata-Syndrom",
      "Kranioektodermale Dysplasie",
      "Kraniofaziale Konodysplasie",
      "LMS [Laterale-Meningozele-Syndrom]",
      "Laterale-Meningozele-Syndrom",
      "Letales Syndrom der okzipitalen Enzephalozele mit Skelettdysplasie",
      "Lowry-Wood-Syndrom",
      "MONA [Multizentrische Osteolyse, Nodulose, Arthropathie]-Spektrum",
      "MTX2-assoziierte mandibulo-akrale Dysplasie",
      "Mandibulo-akrale Dysplasie",
      "Medeira-Dennis-Donnai-Syndrom",
      "Melnick-Needles-Syndrom",
      "Mikrozephale osteodysplastische Dysplasie Typ Saul-Wilson",
      "Okulo-osteo-kutanes Syndrom",
      "Osteopathia striata mit kranialer Sklerose",
      "Osteoporose-Pseudoglioma-Syndrom",
      "Otoonychoperoneales Syndrom",
      "Roifman-Syndrom",
      "Saldino-Mainzer-Syndrom",
      "Sensenbrenner-Syndrom",
      "Skapulo-iliakale Dysostose",
      "Spondylookuläres Syndrom",
      "Syndrom der Knochenfragilität mit Kontrakturen, Arterienrupturen und Schwerhörigkeit",
      "Syndrom der Osteosklerose mit Entwicklungsverzögerung und Kraniosynostose",
      "Syndrom der Osteosklerose mit Ichthyose und vorzeitiger Ovarialinsuffizienz",
      "Syndrom der mesomelen Dysplasie mit digitalen Anomalien und Intelligenzminderung",
      "Syndromale progrediente nicht-infektiöse Wirbelfusion",
      "X-chromosomales Skelettdysplasie-Intelligenzminderungs-Syndrom",
      "Yunis-Varon-Syndrom",
      "Zerebro-fazio-thorakale Dysplasie",
      "Zerebro-kosto-mandibuläres Syndrom"
    ]
  },
  {
    "code": "Q87.8",
    "name": "Alport-Syndrom",
    "synonyms": [
      "ADNP [Aktivitäts-abhängiges neuroprotektives Protein]-Syndrom",
      "ADULT [Akro-dermato-ungual-lakrimal-dental]-Syndrom",
      "AMME [Alport-Syndrom, mentale Retardierung, Mittelgesichtshypoplasie, Elliptozytose]-Syndrom",
      "ANE [Alopezie, progressiver neurologischer Defekt, Endokrinopathie]-Syndrom",
      "AREDYLD [Akral-renal-ektodermale-Dysplasie, lipatrophischer Diabetes]-Syndrom",
      "Aase-Smith-Syndrom Typ I",
      "Abruzzo-Erickson-Syndrom",
      "Achalasie-Mikrozephalie-Syndrom",
      "Ahn-Lerman-Sagie-Syndrom",
      "Akro-kardio-faziales Syndrom",
      "Akrorenomandibuläres Syndrom",
      "Akrorenookuläres Syndrom",
      "Aldred-Syndrom",
      "Alkuraya-Kucinskas-Syndrom",
      "Alopezie-Intelligenzminderungs-Syndrom",
      "Alport-Syndrom",
      "Alström-Syndrom",
      "Angeborenes vertebral-kardial-renales Fehlbildungssyndrom",
      "Aniridie-Patellaaplasie-Syndrom",
      "Ankyloblepharon filiformis-Anus imperforatus-Syndrom",
      "Appelt-Gerken-Lenz-Syndrom",
      "Arachnodaktylie mit Intelligenzminderung und Dysmorphien",
      "Arachnodaktylie mit Ossifikationsstörungen und Intelligenzminderung",
      "Athabasken-Hirnstammdysgenesie-Syndrom",
      "Atherosklerose mit Schwerhörigkeit, Diabetes mellitus, Epilepsie und Nephropathie",
      "Atkin-Flaitz-Syndrom",
      "Autosomal-dominantes Alport-Syndrom",
      "Autosomal-dominantes popliteales Pterygium-Syndrom",
      "Autosomal-rezessive fetale Akinesie",
      "Autosomal-rezessives Alport-Syndrom",
      "Autosomal-rezessives Chorioretinopathie-Mikrozephalie-Syndrom",
      "Autosomal-rezessives Syndrom des marfanoiden Habitus mit Intelligenzminderung",
      "Axiale mesodermale Dysplasie",
      "BASM [Biliäre Atresie, Milzfehlbildung]-Syndrom",
      "BDV [Blakemore-Durmaz-Vasileiou]-Syndrom",
      "BNAR [Bifide Nase, anorektale und renale Anomalien]-Syndrom",
      "BOR-Syndrom [Branchio-oto-renales Syndrom]",
      "BRESEK [Brain anomalies, mental retardation, ectodermal dysplasia, skeletal deformities, ear/eye anomalies, kidney dysplasia/hypoplasia]-Syndrom",
      "Baker-Gordon-Syndrom",
      "Baralle-Macken-Syndrom",
      "Bardet-Biedl-Syndrom",
      "Bart-Pumphrey-Syndrom",
      "Beare-Stevenson-Cutis-gyrata-Syndrom",
      "Becker-Nävus-Syndrom",
      "Beemer-Ertbruggen-Syndrom",
      "Berant-Syndrom",
      "Berlin-breakage-Syndrom",
      "Biedl-Syndrom",
      "Biemond-Syndrom",
      "Biemond-Syndrom Typ 2",
      "Bindewald-Ulmer-Müller-Syndrom",
      "Birk-Barel-Syndrom",
      "Björnstad-Syndrom",
      "Blakemore-Durmaz-Vasileiou-Syndrom",
      "Blepharophimose mit Ptosis, Esotropie, Syndaktylie und Kleinwuchs",
      "Blepharophimose-Intelligenzminderung-Syndrom Typ Maat-Kievit-Brunner",
      "Blepharophimose-Intelligenzminderung-Syndrom Typ Verloes",
      "Bohring-Opitz-Syndrom",
      "Bosley-Salih-Alorainy-Syndrom",
      "Bowen-Conradi-Syndrom",
      "Braddock-Syndrom",
      "Branchio-oto-renales Syndrom",
      "Branchioskeletogenitales Syndrom",
      "Braun-Bayer-Syndrom",
      "Börjeson-Forssmann-Lehmann-Syndrom",
      "C-Trigonozephalie-Syndrom",
      "CADDS [Contiguous-ABCD1-and-DXS1,3,5,7E-deletion-Syndrom]",
      "CAGSSS [Katarakt, Wachstumshormonmangel, sensorische Neuropathie, sensorineurale Schwerhörigkeit, Skelettdysplasie]",
      "CAHMR [Katarakt mit Hypertrichose und mentaler Retardierung]-Syndrom",
      "CFC-Syndrom [Cardiofaciocutaneous syndrome]",
      "CHARGE-Syndrom [CHARGE-Assoziation] [Fehlbildungskomplex mit Kolobom, Herzfehler, Choanalatresie, psychomotorischer Retardierung, Genitalhypoplasie und Ohranomalie]",
      "CHILD-Syndrom [Congenital hemidysplasia with ichthyosiform erythroderma and limb defects]",
      "CHIME-Syndrom [Kolobom mit kongenitaler Herzkrankheit, ichthyosiformer Dermatose, Intelligenzminderung und Ohranomalie]",
      "CHOPS [Kognitive Störung, grobe Gesichtsszüge, Herzdefekte, Adipositas, pulmonale Beteiligung, Kleinwuchs, Skelettdysplasie]-Syndrom",
      "CIMDAG [Zerebelläre Hypoplasie, Intelligenzminderung, angeborene Mikrozephalie, Dystonie, Anämie, Wachstumsstörung]-Syndrom",
      "CLCN4-assoziiertes Syndrom der X-chromosomalen Intelligenzminderung",
      "CODAS [Cerebro-okulo-dento-aurikulo-skelettales]-Syndrom",
      "COFS-Syndrom [Cerebro-oculo-facio-sceletal syndrome]",
      "COMMAD [Kolobom, Osteopetrose, Mikrophthalmie, Makrozephalie, Albinismus, Schwerhörigkeit]-Syndrom",
      "CTCF-assoziierte neurologische Entwicklungsstörung",
      "Cabezas-Syndrom",
      "Cantrell-Syndrom",
      "Carney-Komplex mit Trismus und Pseudokamptodaktylie",
      "Carvajal-Syndrom",
      "Casamassima-Morton-Nance-Syndrom",
      "Catel-Manzke-Syndrom",
      "Cerebro-oculo-facio-s"
    ]
  },
  {
    "code": "Q89.00",
    "name": "Konnatale Splenomegalie",
    "synonyms": [
      "Angeborene Splenomegalie",
      "Kongenitale Splenomegalie",
      "Konnatale Splenomegalie"
    ]
  },
  {
    "code": "Q89.01",
    "name": "Alienie",
    "synonyms": [
      "Alienie",
      "Alieniesyndrom",
      "Angeborene Asplenie",
      "Angeborenes Fehlen der Milz",
      "Asplenie",
      "Aspleniesyndrom",
      "Isolierte familiäre kongenitale Asplenie",
      "Milzagenesie"
    ]
  },
  {
    "code": "Q89.08",
    "name": "Angeborene Milzfehlbildung",
    "synonyms": [
      "Akzessorische Milz",
      "Angeborene Milzdeformität",
      "Angeborene Milzfehlbildung",
      "Angeborene Milzverformung",
      "Angeborene Milzverlagerung",
      "Isolierte splenogonadale Fusion",
      "Kongenitale Lageanomalie der Milz",
      "Lappenbildung der Milz",
      "Lien accessorius",
      "Milzaberration",
      "Milzanomalie",
      "Milzhypoplasie",
      "Polysplenie"
    ]
  },
  {
    "code": "Q89.1",
    "name": "Angeborene Nebennierenfehlbildung",
    "synonyms": [
      "Akzessorische Nebenniere",
      "Angeborene Nebennierenfehlbildung",
      "Angeborenes Fehlen der Nebenniere",
      "Hufeisennebenniere",
      "Kongenitale Lageanomalie der Nebenniere",
      "Kongenitale Nebennierenverlagerung",
      "Kongenitale Nebennierenzyste",
      "Nebennierenagenesie",
      "Nebennierenanomalie",
      "Nebennierenrindenaberration"
    ]
  },
  {
    "code": "Q89.2",
    "name": "Thymusagenesie",
    "synonyms": [
      "Aberration einer endokrinen Drüse a.n.k.",
      "Agenesie der Nebenschilddrüse",
      "Agenesie endokriner Drüsen a.n.k.",
      "Akzessorische Hypophyse",
      "Akzessorische Nebenschilddrüse",
      "Akzessorische Schilddrüse",
      "Akzessorische endokrine Drüse a.n.k.",
      "Akzessorischer Thymus",
      "Angeborene Gewebsdeformität des Thymus",
      "Angeborene Hypophysendeformität",
      "Angeborene Hypophysenhypoplasie",
      "Angeborene Nebenschilddrüsenfehlbildung",
      "Angeborene Schilddrüsendeformität",
      "Angeborene Schilddrüsenfehlbildung",
      "Angeborenes Fehlen der Hypophyse",
      "Angeborenes Fehlen der Nebenschilddrüse",
      "Angeborenes Fehlen einer endokrinen Drüse a.n.k.",
      "Anomalie der Epithelkörperchen",
      "Anomalie einer endokrinen Drüse a.n.k.",
      "Deformität der Epithelkörperchen",
      "Deformität der Nebenschilddrüse",
      "Deformität einer endokrinen Drüse a.n.k.",
      "Familiäre thyreoglossale Fistel",
      "Fistel des Ductus thyreoglossus",
      "Hypophysen-Verdoppelung",
      "Hypophysenaberration",
      "Hypophysenagenesie",
      "Hypophysenanomalie",
      "Hypoplasie der Nebenschilddrüse",
      "Hypoplasie einer endokrinen Drüse a.n.k.",
      "Kongenitale Lageanomalie der Hypophyse",
      "Kongenitale Lageanomalie der Nebenschilddrüse",
      "Kongenitale Lageanomalie der Schilddrüse",
      "Kongenitale Lageanomalie des Thymus",
      "Kongenitale Lageanomalie einer endokrinen Drüse a.n.k.",
      "Kongenitale Thymuszyste",
      "Kongenitale substernale Schilddrüse",
      "Lingualer Kropf",
      "Nebenschilddrüsenaberration",
      "Nebenschilddrüsenanomalie",
      "Persistenz des Ductus thyreoglossus",
      "Persistierender Ductus thyreoglossus",
      "Rachendachhypophyse",
      "Rachenhypophyse",
      "Retrosternale Schilddrüse",
      "Schilddrüsenaberration",
      "Schilddrüsenanomalie",
      "Thymusaberration",
      "Thymusagenesie",
      "Thymusanomalie",
      "Thyreoglossale Fistel",
      "Thyreoglossuszyste",
      "Thyreoideaanomalie",
      "Zungengrundschilddrüse",
      "Zungengrundstruma",
      "Zungenwurzelstruma",
      "Zyste des Ductus thyreoglossus",
      "Überrest des Ductus thyreoglossus"
    ]
  },
  {
    "code": "Q89.3",
    "name": "Situs inversus",
    "synonyms": [
      "Dextrokardie mit vollständiger spiegelbildlicher Verlagerung der inneren Organe",
      "Herztransposition mit vollständiger Eingeweideinversion",
      "Heterotaxie",
      "Inkompletter Situs inversus",
      "Inversio viscerum",
      "Kartagener-Syndrom [Situs inversus viscerum, Bronchiektasie, chronische Sinusitis und Nasenpolypen] [Pluriglanduläre Insuffizienz infolge mukoziliarer Transportstörung] [Immotile cilia syndrome] [Kartagener-Trias]",
      "Kartagener-Trias",
      "Kompletter Situs inversus",
      "Kompletter Situs inversus viscerum",
      "Magentransposition mit vollständiger Eingeweideinversion",
      "Partieller Situs inversus",
      "Situs ambiguus",
      "Situs inversus",
      "Situs inversus mit Dextrokardie",
      "Situs inversus sive transversus abdominalis",
      "Situs inversus sive transversus cordis",
      "Situs inversus sive transversus cordis bei Situs inversus totalis",
      "Situs inversus sive transversus thoracalis",
      "Situs inversus sive transversus viscerum totalis",
      "Situs inversus totalis",
      "Situs transversus",
      "Spiegelbildliche Anordnung der Vorhöfe mit Situs inversus",
      "Transpositio viscerum abdominalis",
      "Transpositio viscerum thoracalis",
      "Transposition der Baucheingeweide",
      "Transposition des Viscerum abdominalis",
      "Transposition des Viscerum thoracalis"
    ]
  },
  {
    "code": "Q89.4",
    "name": "Siamesische Zwillinge",
    "synonyms": [
      "Dizephalus",
      "Doppelfehlbildung",
      "Duplicitas asymmetra [Doppelmissbildung]",
      "Epignathus",
      "Heteropagus",
      "Ischiopagus",
      "Ischiothorakopagus",
      "Janizeps",
      "Kraniopagus",
      "Pygopagus",
      "Siamesische Zwillinge",
      "Sternopagus",
      "Synzephalus",
      "Thorakopagus",
      "Xiphopagus",
      "Zephalothorakopagus",
      "Zwillingsfusion"
    ]
  },
  {
    "code": "Q89.7",
    "name": "Komplexes Fehlbildungssyndrom",
    "synonyms": [
      "Angeborene multiple Anomalien",
      "Angeborene multiple Deformitäten a.n.k.",
      "Angeborenes Fehlbildungssyndrom a.n.k.",
      "Arthrogrypose mit Nierenfunktionsstörung und Cholestase",
      "Komplexes Fehlbildungssyndrom",
      "Multiple Anomalien a.n.k.",
      "Multiple Fehlbildungen",
      "Parazephalus"
    ]
  },
  {
    "code": "Q89.8",
    "name": "Acardiacus amorphus",
    "synonyms": [
      "Acardiacus amorphus",
      "Angeborene Hepatosplenomegalie",
      "Angeborenes Fehlen eines Organs",
      "Atresia-multiplex-congenita-Syndrom",
      "Azephalobrachius",
      "Azephalochirus",
      "Azephalogaster",
      "Azephalostomus",
      "Azephalothorax",
      "Bannayan-Riley-Ruvalcaba-Syndrom",
      "Bannayan-Zonana-Syndrom",
      "Buschke-Ollendorff-Syndrom",
      "Coffin-Syndrom",
      "Gametopathie",
      "Kongenitale Zyste a.n.k.",
      "Lymphgefäßdysplasie",
      "Mittellinien-Syndrom",
      "Riley-Smith-Syndrom",
      "Ruvalcaba-Myhre-Smith-Syndrom",
      "Ventrales Defekt-Syndrom"
    ]
  },
  {
    "code": "Q89.9",
    "name": "Angeborene Fehlbildung",
    "synonyms": [
      "Angeborene Abdomendeformität",
      "Angeborene Anomalie",
      "Angeborene Deformität",
      "Angeborene Deformität des Lymphsystems",
      "Angeborene Fehlbildung",
      "Angeborene Rumpfdeformität",
      "Anomalie",
      "Fetale Anomalie",
      "Fetale Deformität",
      "Fetale Missbildung",
      "Intrauterine fetale Fehlbildung",
      "Kongenitale Anomalie",
      "Kongenitale Deformität",
      "Kongenitale Missbildung",
      "Missbildung"
    ]
  },
  {
    "code": "Q90.0",
    "name": "Trisomie 21, meiotische Non-disjunction",
    "synonyms": [
      "Trisomie 21, meiotische Non-disjunction"
    ]
  },
  {
    "code": "Q90.1",
    "name": "Trisomie 21, Mosaik, mitotische Non-disjunction",
    "synonyms": [
      "Trisomie 21, Mosaik, mitotische Non-disjunction"
    ]
  },
  {
    "code": "Q90.2",
    "name": "Trisomie 21, Translokation",
    "synonyms": [
      "Down-Syndrom, Translokation",
      "Trisomie 21, Translokation"
    ]
  },
  {
    "code": "Q90.9",
    "name": "Down-Syndrom",
    "synonyms": [
      "Down-Syndrom",
      "Langdon-Down-Syndrom",
      "Morbus Down",
      "Partiale Trisomie 21",
      "Trisomie 21"
    ]
  },
  {
    "code": "Q91.0",
    "name": "Trisomie 18, meiotische Non-disjunction",
    "synonyms": [
      "Trisomie 18, meiotische Non-disjunction"
    ]
  },
  {
    "code": "Q91.1",
    "name": "Trisomie 18, Mosaik, mitotische Non-disjunction",
    "synonyms": [
      "Trisomie 18, Mosaik, mitotische Non-disjunction"
    ]
  },
  {
    "code": "Q91.2",
    "name": "Trisomie 18, Translokation",
    "synonyms": [
      "Trisomie 18, Translokation"
    ]
  },
  {
    "code": "Q91.3",
    "name": "Edwards-Syndrom",
    "synonyms": [
      "E1-Trisomie",
      "Edwards-Syndrom",
      "Partiale Trisomie 18",
      "Trisomie 18"
    ]
  },
  {
    "code": "Q91.4",
    "name": "Trisomie 13, meiotische Non-disjunction",
    "synonyms": [
      "Trisomie 13, meiotische Non-disjunction"
    ]
  },
  {
    "code": "Q91.5",
    "name": "Trisomie 13, Mosaik, mitotische Non-disjunction",
    "synonyms": [
      "Trisomie 13, Mosaik, mitotische Non-disjunction"
    ]
  },
  {
    "code": "Q91.6",
    "name": "Trisomie 13, Translokation",
    "synonyms": [
      "Trisomie 13, Translokation"
    ]
  },
  {
    "code": "Q91.7",
    "name": "Patau-Syndrom",
    "synonyms": [
      "D1-Trisomie",
      "Partiale Trisomie 13",
      "Patau-Syndrom",
      "Pätau-Syndrom",
      "Trisomie 13"
    ]
  },
  {
    "code": "Q92.0",
    "name": "Vollständige Trisomie, meiotische Non-disjunction",
    "synonyms": [
      "Vollständige Trisomie, meiotische Non-disjunction"
    ]
  },
  {
    "code": "Q92.1",
    "name": "Vollständige Trisomie, Mosaik, mitotische Non-disjunction",
    "synonyms": [
      "Mosaik-Trisomie 1",
      "Mosaik-Trisomie 10",
      "Mosaik-Trisomie 12",
      "Mosaik-Trisomie 14",
      "Mosaik-Trisomie 15",
      "Mosaik-Trisomie 16",
      "Mosaik-Trisomie 17",
      "Mosaik-Trisomie 2",
      "Mosaik-Trisomie 20",
      "Mosaik-Trisomie 22",
      "Mosaik-Trisomie 3",
      "Mosaik-Trisomie 4",
      "Mosaik-Trisomie 5",
      "Mosaik-Trisomie 7",
      "Mosaik-Trisomie 8",
      "Mosaik-Trisomie 9",
      "Vollständige Trisomie, Mosaik, mitotische Non-disjunction"
    ]
  },
  {
    "code": "Q92.2",
    "name": "Partielle Trisomie, Majorform",
    "synonyms": [
      "Partielle Trisomie 8q",
      "Partielle Trisomie 9p",
      "Partielle Trisomie, Majorform",
      "Trisomie 10p",
      "Trisomie 18p",
      "Trisomie 20p",
      "Trisomie 4p",
      "Trisomie 8p",
      "Verdoppelung eines ganzen Chromosomenarms"
    ]
  },
  {
    "code": "Q92.3",
    "name": "Partielle Trisomie, Minorform",
    "synonyms": [
      "Distale Trisomie 10q",
      "Distale Trisomie 11q",
      "Distale Trisomie 13q",
      "Distale Trisomie 16p",
      "Distale Trisomie 16q",
      "Distale Trisomie 17q22",
      "Distale Trisomie 1p36",
      "Distale Trisomie 20q",
      "Distale Trisomie 22q",
      "Distale Trisomie 2p",
      "Distale Trisomie 2q",
      "Distale Trisomie 3p",
      "Distale Trisomie 4q",
      "Distale Trisomie 5q",
      "Distale Trisomie 6q",
      "Distale Trisomie 7p",
      "Distale Trisomie 8q",
      "Distale Trisomie 9q",
      "Distales Mikroduplikationssyndrom 22q11.2",
      "Duplikation 19q",
      "Mikroduplikationssyndrom 10q22.3q23.3",
      "Mikroduplikationssyndrom 10q24",
      "Mikroduplikationssyndrom 11p15.4",
      "Mikroduplikationssyndrom 14q11.2",
      "Mikroduplikationssyndrom 15q11-q13",
      "Mikroduplikationssyndrom 16p11.2p12.2",
      "Mikroduplikationssyndrom 16p13.11",
      "Mikroduplikationssyndrom 17p11.2",
      "Mikroduplikationssyndrom 17p13.3",
      "Mikroduplikationssyndrom 17q11.2",
      "Mikroduplikationssyndrom 17q12",
      "Mikroduplikationssyndrom 17q21.31",
      "Mikroduplikationssyndrom 19p13.3",
      "Mikroduplikationssyndrom 1q21.1",
      "Mikroduplikationssyndrom 20q11.2",
      "Mikroduplikationssyndrom 22q11",
      "Mikroduplikationssyndrom 3q26",
      "Mikroduplikationssyndrom 3q29",
      "Mikroduplikationssyndrom 4p16.3",
      "Mikroduplikationssyndrom 5p13",
      "Mikroduplikationssyndrom 5q35",
      "Mikroduplikationssyndrom 7p22.1",
      "Mikroduplikationssyndrom 7q11.23",
      "Mikroduplikationssyndrom 8p23.1",
      "Mikroduplikationssyndrom 8q12",
      "Partielle Trisomie, Minorform",
      "Proximales Mikroduplikationssyndrom 16p11.2",
      "Syndaktylie-Nystagmus-Syndrom durch Mikroduplikation 2q31.1",
      "Trisomie 12p",
      "Trisomie 5p",
      "Verdoppelung eines inkompletten Chromosomenarms"
    ]
  },
  {
    "code": "Q92.4",
    "name": "Chromosomenduplikation, Prometaphase",
    "synonyms": [
      "Akzessorische Chromosomen mit komplexen Rearrangements, nur in Prometaphase sichtbar",
      "Chromosomenduplikation, Prometaphase",
      "Doppelchromosom, nur in Prometaphase sichtbar a.n.k."
    ]
  },
  {
    "code": "Q92.5",
    "name": "Akzessorische Chromosomen mit komplexen Rearrangements a.n.k.",
    "synonyms": [
      "Akzessorische Chromosomen mit komplexen Rearrangements a.n.k.",
      "Doppelchromosom mit komplexen Rearrangements a.n.k.",
      "Invertierte Duplikation/Deletion 8p"
    ]
  },
  {
    "code": "Q92.6",
    "name": "Überzählige Markerchromosomen",
    "synonyms": [
      "Akzessorische Markerchromosomen",
      "Emanuel-Syndrom",
      "Überzählige Markerchromosomen"
    ]
  },
  {
    "code": "Q92.7",
    "name": "Polyploidie",
    "synonyms": [
      "Polyploidie",
      "Tetraploidie",
      "Triploidie"
    ]
  },
  {
    "code": "Q92.8",
    "name": "Trisomie 22",
    "synonyms": [
      "Katzenaugen-Syndrom",
      "Partielle Trisomie a.n.k.",
      "Trisomie 20 (p) (q)",
      "Trisomie 22",
      "Unbalancierte Insertion",
      "Unbalancierte Translokation"
    ]
  },
  {
    "code": "Q92.9",
    "name": "Trisomie",
    "synonyms": [
      "Akzessorische Autosomen a.n.k.",
      "Akzessorische Chromosomen a.n.k.",
      "Autosomentrisomie a.n.k.",
      "Trisomie",
      "Trisomie eines ganzen Chromosoms",
      "Trisomie-Syndrom a.n.k."
    ]
  },
  {
    "code": "Q93.0",
    "name": "Vollständige Monosomie, meiotische Non-disjunction",
    "synonyms": [
      "Familiäres Monosomie-7-Syndrom",
      "Vollständige Monosomie, meiotische Non-disjunction"
    ]
  },
  {
    "code": "Q93.1",
    "name": "Vollständige Monosomie, Mosaik, mitotische Non-disjunction",
    "synonyms": [
      "Vollständige Monosomie, Mosaik, mitotische Non-disjunction"
    ]
  },
  {
    "code": "Q93.2",
    "name": "Ringchromosom",
    "synonyms": [
      "Dizentrische Chromosomen",
      "Ringchromosom",
      "Ringchromosom 1",
      "Ringchromosom 10",
      "Ringchromosom 11",
      "Ringchromosom 12",
      "Ringchromosom 13",
      "Ringchromosom 14",
      "Ringchromosom 15",
      "Ringchromosom 16",
      "Ringchromosom 17",
      "Ringchromosom 18",
      "Ringchromosom 19",
      "Ringchromosom 2",
      "Ringchromosom 20",
      "Ringchromosom 21",
      "Ringchromosom 22",
      "Ringchromosom 3",
      "Ringchromosom 4",
      "Ringchromosom 5",
      "Ringchromosom 6",
      "Ringchromosom 7",
      "Ringchromosom 8",
      "Ringchromosom 9",
      "Ringchromosom-1-Syndrom",
      "Ringchromosom-10-Syndrom",
      "Ringchromosom-11-Syndrom",
      "Ringchromosom-12-Syndrom",
      "Ringchromosom-13-Syndrom",
      "Ringchromosom-14-Syndrom",
      "Ringchromosom-15-Syndrom",
      "Ringchromosom-16-Syndrom",
      "Ringchromosom-17-Syndrom",
      "Ringchromosom-18-Syndrom",
      "Ringchromosom-19-Syndrom",
      "Ringchromosom-2-Syndrom",
      "Ringchromosom-20-Syndrom",
      "Ringchromosom-21-Syndrom",
      "Ringchromosom-22-Syndrom",
      "Ringchromosom-3-Syndrom",
      "Ringchromosom-4-Syndrom",
      "Ringchromosom-5-Syndrom",
      "Ringchromosom-6-Syndrom",
      "Ringchromosom-7-Syndrom",
      "Ringchromosom-8-Syndrom",
      "Ringchromosom-9-Syndrom",
      "Ringförmiges Chromosom"
    ]
  },
  {
    "code": "Q93.3",
    "name": "Deletion des kurzen Arms von Chromosom 4",
    "synonyms": [
      "Deletion des kurzen Arms von Chromosom 4",
      "Partielle Deletion des kurzen Arms des Chromosoms 4",
      "Wolf-Hirschhorn-Syndrom",
      "Wolf-Syndrom [Deletion des kurzen Arms des Chromosoms 4]"
    ]
  },
  {
    "code": "Q93.4",
    "name": "Deletion des kurzen Arms von Chromosom 5",
    "synonyms": [
      "Cri-du-chat-Syndrom",
      "Deletion des kurzen Arms von Chromosom 5",
      "Katzenschrei-Syndrom",
      "Lejeune-Syndrom",
      "Partielle Deletion des kurzen Arms des Chromosoms 5"
    ]
  },
  {
    "code": "Q93.5",
    "name": "Williams-Beuren-Syndrom",
    "synonyms": [
      "1p36-Deletionssyndrom",
      "Angelman-Syndrom",
      "Angelman-Syndrom durch Punktmutation",
      "De Grouchy-Syndrom Typ I",
      "Deletion 1p36",
      "Deletion 22q13",
      "Deletion des langen Arms von Chromosom 18",
      "Deletion eines Chromosomenteils",
      "Distale Deletion 17q",
      "Distale Deletion 3p",
      "Distale Monosomie 10p",
      "Distale Monosomie 13q32",
      "Distale Monosomie 15q",
      "Distale Monosomie 4q",
      "Distale Monosomie 7p",
      "Distale Monosomie 7q36",
      "Distale Monosomie 9p",
      "Distales Mikrodeletionssyndrom 22q11.2",
      "Distales Mikrodeletionssyndrom 7q11.23",
      "Entwicklungs- und Sprachverzögerung durch SOX5-Mangel",
      "FOXG1-Syndrom",
      "FOXG1-Syndrom durch Mikrodeletion 14q12",
      "FOXG1-Syndrom durch intragenische Veränderung",
      "FOXG1-assoziierte epileptisch-dyskinetische Enzephalopathie",
      "Happy-puppet-Syndrom",
      "Jacobsen-Syndrom",
      "Koolen-De Vries-Syndrom",
      "Lamb-Shaffer-Syndrom",
      "Mikrodeletion 9q22.3",
      "Mikrodeletionssyndrom 10q22.3q23.3",
      "Mikrodeletionssyndrom 11q22.2-q22.3",
      "Mikrodeletionssyndrom 12p12.1",
      "Mikrodeletionssyndrom 12p13.33",
      "Mikrodeletionssyndrom 12q14",
      "Mikrodeletionssyndrom 12q15q21.1",
      "Mikrodeletionssyndrom 13q12.3",
      "Mikrodeletionssyndrom 13q14",
      "Mikrodeletionssyndrom 14q11.2",
      "Mikrodeletionssyndrom 14q12",
      "Mikrodeletionssyndrom 14q22-q23",
      "Mikrodeletionssyndrom 14q24.1-q24.3",
      "Mikrodeletionssyndrom 15q11.2",
      "Mikrodeletionssyndrom 15q13.3",
      "Mikrodeletionssyndrom 15q14",
      "Mikrodeletionssyndrom 15q24",
      "Mikrodeletionssyndrom 16p11.2-p12.2",
      "Mikrodeletionssyndrom 16p13.11",
      "Mikrodeletionssyndrom 16p13.2",
      "Mikrodeletionssyndrom 16q24.1",
      "Mikrodeletionssyndrom 16q24.3",
      "Mikrodeletionssyndrom 17q12",
      "Mikrodeletionssyndrom 17q23.1q23.2",
      "Mikrodeletionssyndrom 17q24.2",
      "Mikrodeletionssyndrom 19p13.12",
      "Mikrodeletionssyndrom 19p13.13",
      "Mikrodeletionssyndrom 19q13.11",
      "Mikrodeletionssyndrom 1p21.3",
      "Mikrodeletionssyndrom 1p31-p32",
      "Mikrodeletionssyndrom 1p35.2",
      "Mikrodeletionssyndrom 1q21.1",
      "Mikrodeletionssyndrom 1q41q42",
      "Mikrodeletionssyndrom 1q44",
      "Mikrodeletionssyndrom 20p12.3",
      "Mikrodeletionssyndrom 20p13",
      "Mikrodeletionssyndrom 20q11.2",
      "Mikrodeletionssyndrom 20q13.33",
      "Mikrodeletionssyndrom 21q22.11q22.12",
      "Mikrodeletionssyndrom 2p13.2",
      "Mikrodeletionssyndrom 2p15-p16.1",
      "Mikrodeletionssyndrom 2p21",
      "Mikrodeletionssyndrom 2p21 ohne Zystinurie",
      "Mikrodeletionssyndrom 2q23.1",
      "Mikrodeletionssyndrom 2q24",
      "Mikrodeletionssyndrom 2q31.1",
      "Mikrodeletionssyndrom 2q32q33",
      "Mikrodeletionssyndrom 2q33.1",
      "Mikrodeletionssyndrom 2q37",
      "Mikrodeletionssyndrom 3p25.3",
      "Mikrodeletionssyndrom 3q13",
      "Mikrodeletionssyndrom 3q26q27",
      "Mikrodeletionssyndrom 3q27.3",
      "Mikrodeletionssyndrom 3q29",
      "Mikrodeletionssyndrom 4q21",
      "Mikrodeletionssyndrom 5q14.3",
      "Mikrodeletionssyndrom 5q35",
      "Mikrodeletionssyndrom 6p22",
      "Mikrodeletionssyndrom 6q16",
      "Mikrodeletionssyndrom 6q25",
      "Mikrodeletionssyndrom 7q31",
      "Mikrodeletionssyndrom 8p11.2",
      "Mikrodeletionssyndrom 8p23.1",
      "Mikrodeletionssyndrom 8q21.11",
      "Mikrodeletionssyndrom 8q22.1",
      "Mikrodeletionssyndrom 8q24.3",
      "Mikrodeletionssyndrom 9p13",
      "Mikrodeletionssyndrom 9q21.13",
      "Mikrodeletionssyndrom 9q31.1-q31.3",
      "Mikrodeletionssyndrom 9q33.3q34.11",
      "Miller-Dieker-Syndrom",
      "Monosomie 13q34",
      "Monosomie 18p",
      "Monosomie 18q",
      "Monosomie 1p36",
      "Monosomie 1qter",
      "Monosomie 9p",
      "PDE4D-Haploinsuffizienz-Syndrom",
      "Partielle Monosomie 18p",
      "Potocki-Shaffer-Syndrom",
      "Proximales Mikrodeletionssyndrom 16p11.2",
      "Schwerhörigkeit-Infertilität-Syndrom",
      "Smith-Magenis-Syndrom",
      "Subtelomere 1p36-Deletion",
      "Williams-Beuren-Syndrom"
    ]
  },
  {
    "code": "Q93.6",
    "name": "Deletion in der Prometaphase",
    "synonyms": [
      "Deletion in der Prometaphase",
      "Deletion, die nur in der Prometaphase sichtbar wird"
    ]
  },
  {
    "code": "Q93.7",
    "name": "Chromosomendeletion mit komplexen Rearrangements a.n.k.",
    "synonyms": [
      "Chromosomendeletion mit komplexen Rearrangements a.n.k.",
      "Deletion des langen Arms von Chromosom 18 mit komplexen Rearrangements a.n.k."
    ]
  },
  {
    "code": "Q93.9",
    "name": "Monosomie",
    "synonyms": [
      "Autosomendeletion",
      "Deletionssyndrom",
      "Monosomie"
    ]
  },
  {
    "code": "Q95.0",
    "name": "Balancierte Chromosomentranslokation beim normalen Individuum",
    "synonyms": [
      "Balancierte Autosomentranslokation beim normalen Individuum",
      "Balancierte Chromosomentranslokation beim normalen Individuum"
    ]
  },
  {
    "code": "Q95.1",
    "name": "Chromosomeninversion beim normalen Individuum",
    "synonyms": [
      "Chromosomeninversion beim normalen Individuum"
    ]
  },
  {
    "code": "Q95.2",
    "name": "Balanciertes Rearrangement der Autosomen beim abnormen Individuum",
    "synonyms": [
      "Balanciertes Rearrangement der Autosomen beim abnormen Individuum",
      "Balanciertes Rearrangement der Chromosomen beim abnormen Individuum",
      "Edinburgh-Fehlbildungssyndrom"
    ]
  },
  {
    "code": "Q95.3",
    "name": "Balanciertes Rearrangement der Gonosomen und Autosomen beim abnormen Individuum",
    "synonyms": [
      "Balanciertes Rearrangement der Gonosomen und Autosomen beim abnormen Individuum"
    ]
  },
  {
    "code": "Q95.4",
    "name": "Individuum mit Marker-Heterochromatin",
    "synonyms": [
      "Individuum mit Marker-Heterochromatin",
      "Marker-Heterochromatin"
    ]
  },
  {
    "code": "Q95.5",
    "name": "Individuum mit Autosomenbruchstelle",
    "synonyms": [
      "Bruchstelle eines Autosoms",
      "Individuum mit Autosomenbruchstelle"
    ]
  },
  {
    "code": "Q95.8",
    "name": "Balancierte reziproke Translokation",
    "synonyms": [
      "Balancierte reziproke Insertion",
      "Balancierte reziproke Translokation",
      "Robertson-Insertion",
      "Robertson-Translokation"
    ]
  },
  {
    "code": "Q95.9",
    "name": "Balanciertes Rearrangement der Chromosomen",
    "synonyms": [
      "Balancierte Autosomentranslokation",
      "Balancierte Chromosomentranslokation",
      "Balanciertes Rearrangement der Chromosomen"
    ]
  },
  {
    "code": "Q96.0",
    "name": "Karyotyp 45,X",
    "synonyms": [
      "45,X-Syndrom",
      "Karyotyp 45,X",
      "X-Monosomie"
    ]
  },
  {
    "code": "Q96.1",
    "name": "Karyotyp 46,X iso (Xq)",
    "synonyms": [
      "Karyotyp 46,X iso (Xq)"
    ]
  },
  {
    "code": "Q96.2",
    "name": "Karyotyp 46,X mit Gonosomenanomalie, ausgenommen iso (Xq)",
    "synonyms": [
      "Karyotyp 46,X mit Gonosomenanomalie, ausgenommen iso (Xq)"
    ]
  },
  {
    "code": "Q96.3",
    "name": "45,X/46,XX-Mosaik",
    "synonyms": [
      "45,X/46,XX-Mosaik",
      "45,X/46,XX-Syndrom",
      "45,X/46,XY-Mosaik"
    ]
  },
  {
    "code": "Q96.4",
    "name": "Mosaik 45,X/Zelllinien mit Gonosomenanomalie",
    "synonyms": [
      "Mosaik 45,X/Zelllinien mit Gonosomenanomalie"
    ]
  },
  {
    "code": "Q96.8",
    "name": "46,XX-Ovarialdysgenesie-Kleinwuchs-Syndrom",
    "synonyms": [
      "46,XX-Ovarialdysgenesie-Kleinwuchs-Syndrom"
    ]
  },
  {
    "code": "Q96.9",
    "name": "Gonadendysgenesie",
    "synonyms": [
      "Gonadendysgenesie",
      "Turner-Anomalie der Geschlechtschromosomen",
      "Turner-Syndrom",
      "UTS [Ullrich-Turner-Syndrom]",
      "Ullrich-Turner-Syndrom",
      "X0-Syndrom"
    ]
  },
  {
    "code": "Q97.0",
    "name": "Weiblicher Phänotyp mit Karyotyp 47,XXX",
    "synonyms": [
      "3-X-Syndrom",
      "47,XXX-Syndrom",
      "Dreifaches X-Chromosom mit weiblichem Phänotyp",
      "Karyotyp 47,XXX",
      "Super female syndrome",
      "Tripel-X-Syndrom",
      "Triplo-X-Syndrom",
      "Trisomie X",
      "Weiblicher Phänotyp mit Karyotyp 47,XXX",
      "XXX-Syndrom"
    ]
  },
  {
    "code": "Q97.1",
    "name": "Weiblicher Phänotyp mit mehr als drei X-Chromosomen",
    "synonyms": [
      "48,XXXX-Syndrom",
      "49,XXXXX-Syndrom",
      "5-X-Syndrom",
      "Penta-X-Syndrom",
      "Pentasomie X",
      "Pentasomie-X-Syndrom",
      "Tetra-X-Syndrom",
      "Tetrasomie X",
      "Weiblicher Phänotyp mit mehr als drei X-Chromosomen"
    ]
  },
  {
    "code": "Q97.2",
    "name": "Mosaik, Zelllinien mit unterschiedlicher Anzahl von X-Chromosomen",
    "synonyms": [
      "Mosaik, Zelllinien mit unterschiedlicher Anzahl von X-Chromosomen"
    ]
  },
  {
    "code": "Q97.3",
    "name": "Weiblicher Phänotyp mit Karyotyp 46,XY",
    "synonyms": [
      "Weiblicher Phänotyp mit Karyotyp 46,XY"
    ]
  },
  {
    "code": "Q97.8",
    "name": "Fehlen von Geschlechtschromosomen bei weiblichem Phänotyp",
    "synonyms": [
      "Akzessorische Geschlechtschromosomen bei weiblichem Phänotyp",
      "Fehlen von Geschlechtschromosomen bei weiblichem Phänotyp",
      "Mosaik der weiblichen Geschlechtschromosomen a.n.k."
    ]
  },
  {
    "code": "Q97.9",
    "name": "Anomalie der Geschlechtschromosomen bei weiblichem Phänotyp",
    "synonyms": [
      "Angeborenes Fehlbildungssyndrom bei weiblichem Phänotyp",
      "Anomalie der Geschlechtschromosomen bei weiblichem Phänotyp"
    ]
  },
  {
    "code": "Q98.0",
    "name": "Klinefelter-Syndrom, Karyotyp 47,XXY",
    "synonyms": [
      "47,XXY-Syndrom",
      "Klinefelter-Syndrom, Karyotyp 47,XXY",
      "XXY-Syndrom"
    ]
  },
  {
    "code": "Q98.1",
    "name": "Klinefelter-Syndrom, männlicher Phänotyp, mit mehr als zwei X-Chromosomen",
    "synonyms": [
      "48,XXXY-Syndrom",
      "49,XXXXY-Syndrom",
      "Klinefelter-Syndrom, männlicher Phänotyp, mit mehr als zwei X-Chromosomen",
      "XXXXY-Syndrom"
    ]
  },
  {
    "code": "Q98.2",
    "name": "Klinefelter-Syndrom, männlicher Phänotyp, mit Karyotyp 46,XX",
    "synonyms": [
      "Klinefelter-Syndrom, männlicher Phänotyp, mit Karyotyp 46,XX"
    ]
  },
  {
    "code": "Q98.4",
    "name": "Klinefelter-Syndrom",
    "synonyms": [
      "Klinefelter-Anomalie der Geschlechtschromosomen",
      "Klinefelter-Reifenstein-Syndrom",
      "Klinefelter-Syndrom"
    ]
  },
  {
    "code": "Q98.5",
    "name": "XYY-Syndrom",
    "synonyms": [
      "47,XYY-Syndrom",
      "Karyotyp 47,XYY",
      "Männlicher Phänotyp mit Karyotyp 47,XYY",
      "XYY-Syndrom"
    ]
  },
  {
    "code": "Q98.6",
    "name": "Männlicher Phänotyp mit Strukturanomalie der Gonosomen",
    "synonyms": [
      "Isochromosom Yp",
      "Männlicher Phänotyp mit Strukturanomalie der Geschlechtschromosomen",
      "Männlicher Phänotyp mit Strukturanomalie der Gonosomen",
      "Partielle Deletion des Y-Chromosoms",
      "Ringchromosom Y"
    ]
  },
  {
    "code": "Q98.7",
    "name": "Männlicher Phänotyp mit Gonosomen-Mosaik",
    "synonyms": [
      "Mosaik der männlichen Geschlechtschromosomen a.n.k.",
      "Männlicher Phänotyp mit Gonosomen-Mosaik"
    ]
  },
  {
    "code": "Q98.8",
    "name": "Fehlen von Geschlechtschromosomen bei männlichem Phänotyp",
    "synonyms": [
      "48,XXYY-Syndrom",
      "48,XYYY-Syndrom",
      "49,XXXYY-Syndrom",
      "49,XYYYY-Syndrom",
      "Akzessorische Geschlechtschromosomen bei männlichem Phänotyp",
      "Fehlen von Geschlechtschromosomen bei männlichem Phänotyp"
    ]
  },
  {
    "code": "Q98.9",
    "name": "Anomalie der Geschlechtschromosomen bei männlichem Phänotyp",
    "synonyms": [
      "Angeborenes Fehlbildungssyndrom der Geschlechtschromosomen bei männlichem Phänotyp",
      "Anomalie der Geschlechtschromosomen bei männlichem Phänotyp"
    ]
  },
  {
    "code": "Q99.0",
    "name": "Chimäre 46,XX/46,XY",
    "synonyms": [
      "46,XX/46,XY-Chimerismus",
      "Chimäre 46,XX/46,XY",
      "Chimäre 46,XX/46,XY mit Hermaphroditismus verus"
    ]
  },
  {
    "code": "Q99.1",
    "name": "Hermaphroditismus verus mit Karyotyp 46,XX",
    "synonyms": [
      "46,XX mit testikulärer Störung der Geschlechtsentwicklung",
      "46,XX-Gonadendysgenesie",
      "46,XY reine Gonadendysgenesie",
      "Genetisch bedingte Störung der Geschlechtsentwicklung, 46,XX",
      "Hermaphroditismus 46,XX mit Streak-Gonaden",
      "Hermaphroditismus 46,XY mit Streak-Gonaden",
      "Hermaphroditismus verus mit Karyotyp 46,XX",
      "Karyotyp 46,XX mit Streak-Gonaden",
      "Karyotyp 46,XY mit Streak-Gonaden",
      "Reine Gonadendysgenesie",
      "Swyer-Syndrom",
      "Vollständige 46,XY-Gonadendysgenesie"
    ]
  },
  {
    "code": "Q99.2",
    "name": "Fragiles X-Chromosom",
    "synonyms": [
      "FXS [Fragiles X-Syndrom]",
      "Fragiles X-Chromosom",
      "Fragiles X-Syndrom",
      "Martin-Bell-Syndrom",
      "Symptomatisches Syndrom des fragilen X-Chromosoms bei weiblicher Anlageträgerin",
      "Syndrom des fragilen X-Chromosoms"
    ]
  },
  {
    "code": "Q99.8",
    "name": "Chromosomale Translokation",
    "synonyms": [
      "45,X/46,XY-gemischte Gonadendysgenesie",
      "Abnorme Geschlechtschromosomen a.n.k.",
      "Anomalie der Geschlechtschromosomen",
      "BAP1-assoziiertes Tumorprädispositionssyndrom",
      "Chromosomale Translokation",
      "Chromosomenfehlbildung",
      "Chromosomentranslokation a.n.k.",
      "DDX41-assoziiertes Prädispositionssyndrom für hämatologische Tumore",
      "Duplikationssyndrom Xp22.13p22.2",
      "Duplikationssyndrom Xq12-q13.3",
      "Isochromosom Yq",
      "Isodizentrisches Chromosom 15",
      "MITF-assoziiertes Prädispositionssyndrom für Melanome und Nierenzellkarzinome",
      "Maternale uniparentale Disomie 1",
      "Maternale uniparentale Disomie 16",
      "Maternale uniparentale Disomie 2",
      "Maternale uniparentale Disomie 6",
      "Maternale uniparentale Disomie X",
      "Mikrodeletionssyndrom Xp22.3",
      "Mikroduplikationssyndrom Xp11.23-p11.22",
      "Mikroduplikationssyndrom Xq25",
      "Mikroduplikationssyndrom Xq27.3-q28",
      "Pallister-Killian-Syndrom",
      "Paternale uniparentale Disomie 1",
      "Paternale uniparentale Disomie 13",
      "Paternale uniparentale Disomie 6",
      "Paternale uniparentale Disomie X",
      "Pseudohypokaliämiesyndrom",
      "Tetrasomie 11q24.1",
      "Tetrasomie 12p",
      "Tetrasomie 16p12.1p12.3",
      "Tetrasomie 18p",
      "Tetrasomie 21",
      "Tetrasomie 5p",
      "Tetrasomie 9p",
      "Variables Aneuploidie-Mosaik-Syndrom"
    ]
  },
  {
    "code": "Q99.9",
    "name": "Chromosomenanomalie",
    "synonyms": [
      "Autosomenabnormität a.n.k.",
      "Autosomenanomalie a.n.k.",
      "Chromosomenaberration",
      "Chromosomenabnormität a.n.k.",
      "Chromosomenanomalie",
      "Chromosomendefekt",
      "Gordan-Overstreet-Syndrom",
      "Zytogenetische Abnormität"
    ]
  },
  {
    "code": "R00.0",
    "name": "Tachykardie",
    "synonyms": [
      "Beschleunigte Herzfrequenz",
      "Beschleunigung des Herzschlages",
      "Herzjagen",
      "Herzrasen",
      "Sinuaurikuläre Tachykardie",
      "Sinustachykardie",
      "Tachykardie"
    ]
  },
  {
    "code": "R00.1",
    "name": "Bradykardie",
    "synonyms": [
      "Bradykardie",
      "Bradykardie bei Synkope",
      "Bradykardie, jeder Typ",
      "Sinuatriale Bradykardie",
      "Sinusbradykardie",
      "Vagale Bradykardie",
      "Verlangsamung der Herzfrequenz",
      "Verlangsamung des Herzschlages"
    ]
  },
  {
    "code": "R00.2",
    "name": "Herzklopfen",
    "synonyms": [
      "Herzklopfen",
      "Palpitatio cordis",
      "Palpitationen",
      "Palpitationen des Herzens",
      "Unangenehm empfundener Herzschlag"
    ]
  },
  {
    "code": "R00.3",
    "name": "PEA [Pulslose elektrische Aktivität]",
    "synonyms": [
      "PEA [Pulslose elektrische Aktivität]",
      "Pulslose elektrische Aktivität"
    ]
  },
  {
    "code": "R00.8",
    "name": "Pulsus alternans",
    "synonyms": [
      "Abnorme Herzfrequenz a.n.k.",
      "Abnormer Herzschlag",
      "Bigeminie",
      "Galopprhythmus",
      "Herzschlagstörung",
      "Pulsus alternans",
      "Pulsus bigeminus",
      "Pulsus trigeminus",
      "Trigeminie"
    ]
  },
  {
    "code": "R01.0",
    "name": "Akzidentelles Herzgeräusch",
    "synonyms": [
      "Akzidentelles Herzgeräusch",
      "Akzidentelles Systolikum",
      "Benignes akzidentelles Herzgeräusch",
      "Funktionelles Herzgeräusch",
      "Nichtorganisches Herzgeräusch"
    ]
  },
  {
    "code": "R01.1",
    "name": "Herzgeräusch",
    "synonyms": [
      "Herzgeräusch",
      "Kardiales Geräusch",
      "Systolikum",
      "Systolisches Herzgeräusch"
    ]
  },
  {
    "code": "R01.2",
    "name": "Präkordiales Reiben",
    "synonyms": [
      "Abnorme Herzgeräusche a.n.k.",
      "Kardiales Reibungsgeräusch",
      "Präkordiales Reiben",
      "Spaltung der Herztöne",
      "Verbreiterte Herzdämpfung",
      "Verringerte Herzdämpfung"
    ]
  },
  {
    "code": "R02.00",
    "name": "Nekrose der Haut und Unterhaut am Kopf a.n.k.",
    "synonyms": [
      "Nekrose der Haut und Unterhaut am Hals a.n.k.",
      "Nekrose der Haut und Unterhaut am Kopf a.n.k."
    ]
  },
  {
    "code": "R02.01",
    "name": "Nekrose der Haut und Unterhaut der Schulterregion a.n.k.",
    "synonyms": [
      "Nekrose der Haut und Unterhaut am Ellenbogen a.n.k.",
      "Nekrose der Haut und Unterhaut am Oberarm a.n.k.",
      "Nekrose der Haut und Unterhaut der Schulterregion a.n.k."
    ]
  },
  {
    "code": "R02.02",
    "name": "Nekrose der Haut und Unterhaut am Unterarm a.n.k.",
    "synonyms": [
      "Nekrose der Haut und Unterhaut am Handgelenk a.n.k.",
      "Nekrose der Haut und Unterhaut am Unterarm a.n.k."
    ]
  },
  {
    "code": "R02.03",
    "name": "Nekrose der Haut und Unterhaut am Hand a.n.k.",
    "synonyms": [
      "Nekrose der Haut und Unterhaut am Finger a.n.k.",
      "Nekrose der Haut und Unterhaut am Hand a.n.k."
    ]
  },
  {
    "code": "R02.04",
    "name": "Nabelgangrän",
    "synonyms": [
      "Bauchwandnekrose",
      "Nabelgangrän",
      "Nekrose der Haut und Unterhaut am Rumpf a.n.k.",
      "Nekrose der Haut und Unterhaut am Rücken a.n.k.",
      "Nekrose der Haut und Unterhaut an der Bauchdecke a.n.k.",
      "Nekrose der Haut und Unterhaut an der Brustwand a.n.k."
    ]
  },
  {
    "code": "R02.05",
    "name": "Nekrose der Haut und Unterhaut der Beckenregion a.n.k.",
    "synonyms": [
      "Nekrose der Haut und Unterhaut am Gesäß a.n.k.",
      "Nekrose der Haut und Unterhaut am Oberschenkel a.n.k.",
      "Nekrose der Haut und Unterhaut an der Hüfte a.n.k.",
      "Nekrose der Haut und Unterhaut der Beckenregion a.n.k."
    ]
  },
  {
    "code": "R02.06",
    "name": "Unterschenkelnekrose",
    "synonyms": [
      "Nekrose der Haut und Unterhaut am Knie a.n.k.",
      "Nekrose der Haut und Unterhaut am Unterschenkel a.n.k.",
      "Unterschenkelnekrose"
    ]
  },
  {
    "code": "R02.07",
    "name": "Fersennekrose",
    "synonyms": [
      "Fersennekrose",
      "Fußnekrose",
      "Nekrose der Haut und Unterhaut am Fuß a.n.k.",
      "Nekrose der Haut und Unterhaut an der Zehe a.n.k.",
      "Nekrose der Haut und Unterhaut der Knöchelregion a.n.k."
    ]
  },
  {
    "code": "R02.09",
    "name": "Hautgangrän",
    "synonyms": [
      "Ausgebreitete Hautgangrän",
      "Gangränöser Pemphigus",
      "Hautbrand",
      "Hautgangrän",
      "Hautnekrose a.n.k.",
      "Hautulkus mit Gangrän",
      "Kutane Gangrän",
      "Nekrose des subkutanen Gewebes a.n.k."
    ]
  },
  {
    "code": "R02.8",
    "name": "Beingangrän",
    "synonyms": [
      "Aseptische Nekrose",
      "Bauchdeckengangrän",
      "Beingangrän",
      "Bindegewebegangrän",
      "Brand - s.a. Gangrän",
      "Extremitätengangrän",
      "Fersengangrän",
      "Feuchte Gangrän",
      "Feuchtes phagedänisches Geschwür",
      "Fressendes Geschwür",
      "Fußgangrän",
      "Fäulnisbrand",
      "Gangraena",
      "Gangrän",
      "Gangrän der Abdomenwand",
      "Gangrän des Perineum",
      "Geometrisches phagedänisches Geschwür",
      "Gerinnungsnekrose",
      "Gewebsnekrose",
      "Ischämische Nekrose",
      "Koagulationsnekrose",
      "Kolliquationsnekrose",
      "Nekrose",
      "Ohrmuschelgangrän",
      "Ohrmuschelnoma",
      "Phagedäna",
      "Phagedänisches Geschwür",
      "Sphakelus",
      "Trockene Gangrän",
      "Trockenes phagedänisches Geschwür",
      "Ulzeröse Gangrän",
      "Unterschenkelgangrän",
      "Verflüssigungsnekrose",
      "Vorfußgangrän",
      "Wirbelsäulengangrän",
      "Ödematöse Gangrän"
    ]
  },
  {
    "code": "R03.0",
    "name": "Hoher Blutdruck ohne Hochdruckkrankheit als einmaliger Messwert",
    "synonyms": [
      "Blutdrucksteigerung",
      "Hoher Blutdruck ohne Diagnose einer Hypertonie als Nebenbefund",
      "Hoher Blutdruck ohne Hochdruckkrankheit als einmaliger Messwert",
      "RR [Riva-Rocci]-Blutdruckwert-Erhöhung"
    ]
  },
  {
    "code": "R03.1",
    "name": "Unspezifischer niedriger Blutdruckwert",
    "synonyms": [
      "Niedriger Blutdruck ohne Diagnose einer Hypotonie als Nebenbefund",
      "Niedriger Blutdruck ohne hypotone Regulationsstörung",
      "Niedriger Blutdruck ohne hypotone Regulationsstörung als einmaliger Messwert",
      "Niedriger RR [Riva-Rocci]-Blutdruckwert",
      "Unspezifischer niedriger Blutdruckwert"
    ]
  },
  {
    "code": "R04.0",
    "name": "Epistaxis",
    "synonyms": [
      "Blutung aus der Nase",
      "Epistaxis",
      "Multiple Epistaxis",
      "Nasenbluten",
      "Nasenhämorrhagie",
      "Nasenmuschelhämorrhagie",
      "Postnasale Blutung",
      "Postnasale Hämorrhagie",
      "Rhinorrhagie"
    ]
  },
  {
    "code": "R04.1",
    "name": "Rachenblutung",
    "synonyms": [
      "Blutung des Nasopharynx",
      "Blutung des Oropharynx",
      "Epipharynxblutung",
      "Epipharynxhämorrhagie",
      "Hypopharyngeale Blutung",
      "Hypopharyngeale Hämorrhagie",
      "Hämorrhagie des Nasopharynx",
      "Rachenblutung",
      "Rachenhämorrhagie",
      "Schlundblutung"
    ]
  },
  {
    "code": "R04.2",
    "name": "Hämoptoe",
    "synonyms": [
      "Auswurf mit Blut",
      "Bluthusten",
      "Blutiges Sputum",
      "Blutspucken",
      "Blutsturz",
      "Haemoptysis",
      "Husten mit Blutung",
      "Husten mit Hämorrhagie",
      "Hämoptoe",
      "Hämoptyse",
      "Sputum mit Blut"
    ]
  },
  {
    "code": "R04.8",
    "name": "Lungenblutung",
    "synonyms": [
      "Blutung aus dem Bronchialsystem",
      "Blutung der oberen Atemwege",
      "Blutung des tracheobronchialen Systems",
      "Blutung eines Hauptbronchus",
      "Bronchialblutung",
      "Bronchorrhagie",
      "Bronchostaxis",
      "Bronchusblutung",
      "Diffuse alveoläre Hämorrhagie",
      "Lungenblutung",
      "Lungenhilusblutung",
      "Lungenhämatom",
      "Lungenhämorrhagie",
      "Lungenparenchymblutung",
      "Pleurablutung",
      "Pneumorrhagie",
      "Pulmonale Blutung",
      "Pulmonale Hämorrhagie",
      "Tracheaausgussblutung",
      "Tracheablutung",
      "Tracheobronchiale Blutung",
      "Tracheobronchiale Hämorrhagie"
    ]
  },
  {
    "code": "R04.9",
    "name": "Blutung der Atemwege",
    "synonyms": [
      "Blutung der Atemwege",
      "Hämorrhagie der Atemwege"
    ]
  },
  {
    "code": "R05",
    "name": "Husten",
    "synonyms": [
      "Bellender Husten",
      "Bronchialer Husten",
      "Dauerhusten",
      "Epidemischer Husten",
      "Husten",
      "Hustenreiz",
      "Krampfhafter laryngealer Husten",
      "Nervöser Husten",
      "Reizhusten",
      "Synkope bei Husten",
      "Tussis",
      "Uncharakteristischer feuchter Husten",
      "Uncharakteristischer trockener Husten"
    ]
  },
  {
    "code": "R06.0",
    "name": "Schnappatmung",
    "synonyms": [
      "Atemnot",
      "Atemschwäche",
      "Atmungsdistress",
      "Belastungsdyspnoe",
      "Dyspnoe",
      "Hyperventilationsdyspnoe",
      "Keuchen",
      "Kurzatmigkeit",
      "Lufthungergefühl",
      "Luftnot",
      "Mühsame Atmung",
      "Nächtliche Dyspnoe",
      "Orthopnoe",
      "Paroxysmale Dyspnoe",
      "Respiratorischer Distress",
      "Ruhedyspnoe",
      "Schnappatmung",
      "Schnappende Atmung",
      "Uncharakteristische Belastungsdyspnoe"
    ]
  },
  {
    "code": "R06.1",
    "name": "Stridor",
    "synonyms": [
      "Pfeifende Atmung",
      "Pfeifendes Atemgeräusch",
      "Stertor",
      "Stridor"
    ]
  },
  {
    "code": "R06.2",
    "name": "Ziehende Atmung",
    "synonyms": [
      "Einziehende Atmung",
      "Ziehende Atmung"
    ]
  },
  {
    "code": "R06.3",
    "name": "Periodische Atmung",
    "synonyms": [
      "Cheyne-Stokes-Atmung",
      "Periodische Atmung"
    ]
  },
  {
    "code": "R06.4",
    "name": "Hyperventilation",
    "synonyms": [
      "Beschleunigte Atmung",
      "Hyperpnoe",
      "Hyperventilation",
      "Hyperventilationstetanie",
      "Übermäßige Atmung"
    ]
  },
  {
    "code": "R06.5",
    "name": "Schnarchen",
    "synonyms": [
      "Mundatmung",
      "Nichtsyphilitisches Schniefen",
      "Rhonchopathie",
      "Schnarchen",
      "Schniefen"
    ]
  },
  {
    "code": "R06.6",
    "name": "Singultus",
    "synonyms": [
      "Reflektorischer Diaphragmaspasmus",
      "Schluckauf",
      "Schlucksen",
      "Singultus"
    ]
  },
  {
    "code": "R06.7",
    "name": "Niesen",
    "synonyms": [
      "Niesen",
      "Unstillbares Niesen"
    ]
  },
  {
    "code": "R06.80",
    "name": "Akutes lebensbedrohliches Ereignis im Säuglingsalter",
    "synonyms": [
      "Akutes lebensbedrohliches Ereignis im Säuglingsalter",
      "Apparent life-threatening event [ALTE]",
      "Near-missed SIDS [Sudden infant death syndrome]"
    ]
  },
  {
    "code": "R06.88",
    "name": "Respiratorischer Affektkrampf",
    "synonyms": [
      "Abnormität der Atmung a.n.k.",
      "Alveoläre Hypoventilation",
      "Apnoe",
      "Apnoischer Anfall",
      "Atemanhalten",
      "Atemanhalten beim Kind",
      "Atembehinderung",
      "Atemlosigkeit",
      "Atemlähmung",
      "Atemmuskellähmung",
      "Atemmuskelparalyse",
      "Atemparalyse",
      "Atmungsinsuffizienz",
      "Atmungsparalyse",
      "Atmungsstörung",
      "Behinderung der Nasenatmung",
      "Bradypnoe",
      "Erstickungsgefühl",
      "Gähnen",
      "Hyperkapnie",
      "Hypoventilation",
      "Irreguläre Atmung",
      "Nasenventilationsbehinderung",
      "Respirationsstörung",
      "Respiratorische Abnormität",
      "Respiratorischer Affektkrampf",
      "Seufzen",
      "Seufzeratmung",
      "Störung des Atemantriebes",
      "Tachypnoe",
      "Tetanie bei Hyperpnoe",
      "Transitorische Tachypnoe",
      "Unzureichende Lungenfunktion",
      "Ventilationsinsuffizienz",
      "Ventilationsstörung",
      "Zentral bedingte Atemstörung"
    ]
  },
  {
    "code": "R07.0",
    "name": "Halsschmerzen",
    "synonyms": [
      "Halsschmerzen",
      "Unklare Halsschmerzen"
    ]
  },
  {
    "code": "R07.1",
    "name": "Brustschmerzen bei Atmung",
    "synonyms": [
      "Atemabhängige Brustkorbschmerzen",
      "Atemabhängige Thoraxschmerzen",
      "Brustschmerzen bei Atmung",
      "Schmerzhafte Atmung"
    ]
  },
  {
    "code": "R07.2",
    "name": "Präkordialschmerzen",
    "synonyms": [
      "Herzschmerzen",
      "Linksthorakale Schmerzen",
      "Perikardiale Schmerzen",
      "Präkordialschmerzen",
      "Schmerzen in der Herzgegend"
    ]
  },
  {
    "code": "R07.3",
    "name": "Retrosternale Schmerzen",
    "synonyms": [
      "Brennen im Brustkorb",
      "Muskuloskeletale Brustschmerzen",
      "Nichttumorbedingte Pleuraschmerzen",
      "Pleuralgie",
      "Pleuraschmerzen",
      "Pleuritische Schmerzen",
      "Pleurodynie",
      "Retrosternale Schmerzen",
      "Rippenschmerzen",
      "Schmerzen der Thoraxvorderwand",
      "Schmerzen der vorderen Brustwand",
      "Seitenstechen",
      "Vorderes Brustwandsyndrom"
    ]
  },
  {
    "code": "R07.4",
    "name": "Brustschmerzen",
    "synonyms": [
      "Brustkorbschmerzen",
      "Brustschmerzen",
      "Thorakale Schmerzen",
      "Thorakales Schmerzsyndrom",
      "Thorakalgie",
      "Thorakodynie",
      "Thoraxbeschwerden",
      "Thoraxschmerzen",
      "Uncharakteristische Brustschmerzen"
    ]
  },
  {
    "code": "R09.0",
    "name": "Scheintod",
    "synonyms": [
      "Anoxie",
      "Anoxämie",
      "Asphyxia",
      "Asphyxie",
      "Asphyxie außerhalb der Geburt",
      "Hypoxämie",
      "Pathologische Anoxie",
      "Pathologische Asphyxie",
      "Sauerstoffmangel",
      "Scheintod"
    ]
  },
  {
    "code": "R09.1",
    "name": "Akute Rippenfellentzündung",
    "synonyms": [
      "Adhäsive Pleuritis",
      "Akute Pleuritis",
      "Akute Rippenfellentzündung",
      "Basalpleuritis",
      "Beidseitige Pleuritis",
      "Brustfellentzündung",
      "Chronische Pleuritis",
      "Fibrinöse Pleuritis",
      "Pleurabelag",
      "Pleuraentzündung",
      "Pleuraretraktion",
      "Pleuritis",
      "Pleuritis mit Verwachsung",
      "Pleuritis sicca",
      "Rippenfellentzündung",
      "Subakute Pleuritis",
      "Trockene Pleuritis"
    ]
  },
  {
    "code": "R09.2",
    "name": "Atemstillstand",
    "synonyms": [
      "Atemstillstand",
      "Atemstillstand zentraler Ursache",
      "Atemversagen",
      "Atmungsstillstand",
      "Atmungsversagen",
      "Herz-Lungen-Versagen",
      "Kardiopulmonale Dekompensation",
      "Kardiopulmonales Versagen",
      "Kardiorespiratorische Dekompensation",
      "Kardiorespiratorisches Versagen"
    ]
  },
  {
    "code": "R09.3",
    "name": "Abnormes Sputum",
    "synonyms": [
      "Abnorme Sputumfarbe",
      "Abnorme Sputummenge",
      "Abnormer Sputumgeruch",
      "Abnormes Sputum",
      "Dysmukorrhoe",
      "Mukorrhoe",
      "Vermehrter Auswurf",
      "Vermehrter Auswurf unbekannter Ursache",
      "Vermehrtes Sputum",
      "Verminderte Bronchialsekretion",
      "Übermäßige Bronchialsekretion"
    ]
  },
  {
    "code": "R09.8",
    "name": "Kardiovaskuläres Symptom",
    "synonyms": [
      "Abnorme Brusttöne a.n.k.",
      "Abnormer Befund bei Thoraxauskultation",
      "Abnormer Perkussionsschall des Thorax",
      "Arteriengeräusch",
      "Giemen",
      "Kardiovaskuläres Symptom",
      "Pulsschwäche",
      "Rasselgeräusch über der Lunge",
      "Reibungsgeräusch im Brustkorb",
      "Reibungsgeräusch im Thorax",
      "Schwacher Puls",
      "Thoraxtympanie",
      "Tympanie des Brustkorbs",
      "Tympanitischer Klopfschall im Thorax",
      "Veränderter Klopfschall des Thorax"
    ]
  },
  {
    "code": "R10.0",
    "name": "Akuter Bauch",
    "synonyms": [
      "Abdomenrigidität mit starken Abdomenschmerzen",
      "Akuter Bauch",
      "Akutes Abdomen",
      "Starke Abdomenschmerzen",
      "Starke Abdomenschmerzen mit Bauchdeckenspannung",
      "Starke Bauchschmerzen",
      "Starke Bauchschmerzen mit Bauchdeckenspannung"
    ]
  },
  {
    "code": "R10.1",
    "name": "Gastrodynie",
    "synonyms": [
      "Akute Oberbauchkolik",
      "Akute Oberbauchschmerzen",
      "Akute Oberbauchsymptomatik",
      "Chronische Dyspepsie",
      "Dyspepsie",
      "Dyspeptische Beschwerden",
      "Epigastralgie",
      "Gastralgie",
      "Gastrische Schmerzen",
      "Gastrodynie",
      "Leberschmerzhaftigkeit",
      "Magenkolik",
      "Magenkrampf",
      "Magenschmerzen",
      "Oberbauchbeschwerden",
      "Oberbauchschmerzen",
      "Schmerzen im Epigastrium",
      "Unklare Oberbauchschmerzen",
      "Unklarer Oberbauch",
      "Viszerale Abdominalschmerzen des Oberbauches"
    ]
  },
  {
    "code": "R10.2",
    "name": "Chronische Beckenschmerzen",
    "synonyms": [
      "Akute Beckenschmerzen",
      "Akute Dammschmerzen",
      "Akute pelvine Schmerzen",
      "Akute perineale Schmerzen",
      "Beckenschmerzen",
      "Chronische Beckenschmerzen",
      "Dammschmerzen",
      "Pelvine Schmerzen",
      "Pelvisschmerzen",
      "Perineale Schmerzen"
    ]
  },
  {
    "code": "R10.3",
    "name": "Leistenschmerzen",
    "synonyms": [
      "Akute Unterbauchschmerzen",
      "Akute Unterleibschmerzen",
      "Leistenbeschwerden",
      "Leistenschmerzen",
      "Schmerzen in der Leistengegend",
      "Unklare Unterbauchschmerzen",
      "Unterbauchbeschwerden",
      "Unterbauchschmerzen",
      "Unterleibsbeschwerden",
      "Zäkumschmerzen"
    ]
  },
  {
    "code": "R10.4",
    "name": "Nabelkolik",
    "synonyms": [
      "Abdomenkolik",
      "Abdomenkrampf",
      "Abdomenopathie",
      "Abdomenschmerzen",
      "Abdomenschmerzen ohne Krankheit",
      "Abdominalbeschwerden",
      "Abdominale Krise",
      "Abdominaler Spasmus",
      "Abdominalkolik",
      "Abdominalschmerzen",
      "Bauchdeckenschmerzhaftigkeit",
      "Bauchkrampf",
      "Bauchschmerzen",
      "Bauchschmerzen ohne Krankheit",
      "Bauchweh",
      "Chronische Abdomenschmerzen",
      "Chronische Bauchschmerzen",
      "Colica - s.a. Kolik",
      "Colica spastica",
      "Darmkrampf",
      "Darmkrampfschmerzen",
      "Diffuse abdominale Schmerzen",
      "Dreimonatskolik",
      "Druckschmerzhaftigkeit des Abdomens",
      "Druckschmerzhaftigkeit des Bauches",
      "Flankenschmerzen",
      "Gastrointestinaler Krampf",
      "Ikterische Kolik",
      "Intestinale Kolik",
      "Kleinkinderkolik",
      "Kolik",
      "Kolonschmerzen",
      "Konkrementkolik",
      "Leibschmerzen",
      "Mittelbauchkrampf",
      "Nabelkolik",
      "Rezidivierende Kolik",
      "Steinkolik",
      "Säuglingskolik",
      "Trimenonkolik",
      "Unklare Abdomenschmerzen",
      "Unklare Abdominalbeschwerden",
      "Unklare Bauchbeschwerden",
      "Unklare Bauchschmerzen",
      "Unklarer Bauch",
      "Unklares Abdomen",
      "Viszeraler Spasmus",
      "Viszeralneuralgie"
    ]
  },
  {
    "code": "R11",
    "name": "Meryzismus",
    "synonyms": [
      "Azetonämisches Erbrechen",
      "Biliäres Erbrechen unbekannter Ursache",
      "Brechreiz",
      "Emesis",
      "Erbrechen",
      "Erbrechen außerhalb der Neugeborenenperiode",
      "Erbrechen beim Kleinkind",
      "Erbrechen über 1 Woche",
      "Fäkulentes Erbrechen",
      "Galliges Erbrechen unbekannter Ursache",
      "Habituelles Erbrechen",
      "Hyperemesis",
      "Infekterbrechen",
      "Koterbrechen",
      "Meryzismus",
      "Miserere",
      "Nausea",
      "Periodisches Erbrechen",
      "Regurgitation von Mageninhalt",
      "Regurgitation von Nahrungsmitteln",
      "Rumination",
      "Sterkorales Erbrechen",
      "Stuhlerbrechen",
      "Unklares Erbrechen",
      "Unklares azetonämisches Erbrechen",
      "Unstillbares Erbrechen",
      "Vomitus",
      "Vomitus faeculentus",
      "Vomitus matutinus",
      "Wiederkäuen",
      "Würgen",
      "Zyklisches Erbrechen",
      "Übelkeit"
    ]
  },
  {
    "code": "R12",
    "name": "Sodbrennen",
    "synonyms": [
      "Pyrosis",
      "Sodbrennen",
      "Sodbrennen bei Gravidität"
    ]
  },
  {
    "code": "R13.0",
    "name": "Dysphagie mit Beaufsichtigungspflicht während der Nahrungsaufnahme",
    "synonyms": [
      "Dysphagie mit Beaufsichtigungspflicht während der Nahrungsaufnahme"
    ]
  },
  {
    "code": "R13.1",
    "name": "Dysphagie bei absaugpflichtigem Tracheostoma mit geblockter Trachealkanüle",
    "synonyms": [
      "Dysphagie bei absaugpflichtigem Tracheostoma mit geblockter Trachealkanüle"
    ]
  },
  {
    "code": "R13.9",
    "name": "Dysphagie",
    "synonyms": [
      "Dysphagie",
      "Schluck-Paralyse",
      "Schluckbeschwerden",
      "Schlucklähmung",
      "Schluckproblem",
      "Schluckstörung"
    ]
  },
  {
    "code": "R14",
    "name": "Aufstoßen",
    "synonyms": [
      "Aufgedunsensein",
      "Aufgetriebenes Abdomen",
      "Aufstoßen",
      "Blähbauch",
      "Blähsucht",
      "Blähungen",
      "Colica flatulenta",
      "Darmblähung",
      "Eructatio",
      "Eruktation",
      "Flatulenz",
      "Flatus",
      "Gas im Magen",
      "Gasbauch",
      "Meteorismus",
      "Oberbauchmeteorismus",
      "Ruktation",
      "Saures Aufstoßen",
      "Schmerzhafte Blähungen",
      "Schmerzhafte Darmgase",
      "Tympanie des Abdomens",
      "Verhaltung von Winden",
      "Vermehrter Abgang von Darmgasen"
    ]
  },
  {
    "code": "R15",
    "name": "Enkopresis",
    "synonyms": [
      "Einkoten",
      "Enkopresis",
      "Incontinentia alvi",
      "Incontinentia faecalis",
      "Inkontinenz des Afterschließmuskels",
      "Inkontinenz des Sphincter ani",
      "Stuhlabgang",
      "Stuhlinkontinenz",
      "Stuhlschmiere",
      "Unfreiwilliger Stuhlabgang",
      "Verlust der Kontrolle über den Rektumsphinkter"
    ]
  },
  {
    "code": "R16.0",
    "name": "Hepatomegalie",
    "synonyms": [
      "Hepatomegalie",
      "Leberhypertrophie",
      "Leberschwellung",
      "Lebervergrößerung"
    ]
  },
  {
    "code": "R16.1",
    "name": "Splenomegalie",
    "synonyms": [
      "Idiopathische Splenomegalie",
      "Megalosplenie",
      "Milzschwellung",
      "Milzvergrößerung",
      "Splenomegalia",
      "Splenomegalie"
    ]
  },
  {
    "code": "R16.2",
    "name": "Hepatosplenomegalie",
    "synonyms": [
      "Hepatomegalie mit Splenomegalie",
      "Hepatosplenomegalie"
    ]
  },
  {
    "code": "R17.0",
    "name": "Ikterus - s.a. Icterus",
    "synonyms": [
      "Gelbsucht - s.a. Ikterus",
      "Hautikterus",
      "Hyperbilirubinämie mit Angabe von Gelbsucht",
      "Icterus - s.a. Ikterus",
      "Ikterus - s.a. Icterus",
      "Konjunktivaikterus",
      "Rubinikterus",
      "Sklerenikterus"
    ]
  },
  {
    "code": "R17.9",
    "name": "Cholämie",
    "synonyms": [
      "Cholaemia",
      "Cholämie",
      "Hyperbilirubinämie",
      "Hyperbilirubinämie ohne Angabe von Gelbsucht"
    ]
  },
  {
    "code": "R18",
    "name": "Aszites - s.a. Ascites oder s.a. Bauchwassersucht",
    "synonyms": [
      "Abdomenwassersucht",
      "Aszites - s.a. Ascites oder s.a. Bauchwassersucht",
      "Aszites durch bösartige Neubildung",
      "Bauchwassersucht",
      "Blutiger Aszites",
      "Flüssigkeit im Abdomen",
      "Flüssigkeit in der Peritonealhöhle",
      "Flüssigkeitsansammlung in der Bauchhöhle",
      "Hydroperitoneum",
      "Hydrops in der Bauchhöhle",
      "Maligner Aszites",
      "Wasseransammlung in der Bauchhöhle"
    ]
  },
  {
    "code": "R19.0",
    "name": "Dünndarmkonglomerattumor",
    "synonyms": [
      "Abdomenschwellung",
      "Abdominale Raumforderung",
      "Bauchschwellung",
      "Beckenschwellung",
      "Diffuse Raumforderung des Nabels",
      "Diffuse Raumforderung im Becken",
      "Diffuse intraabdominale Raumforderung",
      "Diffuse intraabdominale Schwellung",
      "Diffuse pelvine Raumforderung",
      "Diffuse pelvine Schwellung",
      "Diffuse umbilikale Raumforderung",
      "Diffuse umbilikale Schwellung",
      "Dünndarmkonglomerattumor",
      "Generalisierte Raumforderung des Nabels",
      "Generalisierte Raumforderung im Becken",
      "Generalisierte intraabdominale Raumforderung",
      "Generalisierte intraabdominale Schwellung",
      "Generalisierte pelvine Raumforderung",
      "Generalisierte pelvine Schwellung",
      "Generalisierte umbilikale Raumforderung",
      "Generalisierte umbilikale Schwellung",
      "Intraabdominale Schwellung",
      "Intraabdominaler Knoten",
      "Knoten im Becken",
      "Konglomerattumor im Unterbauch",
      "Nabelschwellung",
      "Pelvine Raumforderung",
      "Pelvine Schwellung",
      "Pelviner Knoten",
      "Raumforderung im Abdomen",
      "Umbilikale Raumforderung",
      "Umbilikale Schwellung"
    ]
  },
  {
    "code": "R19.1",
    "name": "Abnorme Darmgeräusche",
    "synonyms": [
      "Abnorme Darmgeräusche",
      "Fehlen der Darmgeräusche",
      "Fehlende Darmgeräusche",
      "Übermäßige Darmgeräusche"
    ]
  },
  {
    "code": "R19.2",
    "name": "Sichtbare Peristaltik",
    "synonyms": [
      "Antiperistaltik",
      "Hyperperistaltik",
      "Sichtbare Darmbewegungen",
      "Sichtbare Peristaltik"
    ]
  },
  {
    "code": "R19.3",
    "name": "Bauchdeckenspannung",
    "synonyms": [
      "Abdominalrigidität",
      "Abwehrspannung des Abdomens",
      "Bauchdeckenspannung"
    ]
  },
  {
    "code": "R19.4",
    "name": "Veränderung der Stuhlgewohnheit",
    "synonyms": [
      "Häufiger Stuhlgang",
      "Veränderung der Stuhlgewohnheit"
    ]
  },
  {
    "code": "R19.5",
    "name": "Okkultes Blut im Stuhl",
    "synonyms": [
      "Abnorme Stuhlbestandteile",
      "Abnorme Stuhlfarbe",
      "Abnormer Stuhl a.n.k.",
      "Eiter im Stuhl",
      "Eitriger Stuhl",
      "Erhöhte Stuhlmenge",
      "Erhöhung der Stuhlmenge",
      "Fett im Stuhl",
      "Fettstuhl",
      "Okkultes Blut im Stuhl",
      "Schleim im Stuhl",
      "Schleimiger Stuhl",
      "Stuhlveränderung"
    ]
  },
  {
    "code": "R19.6",
    "name": "Mundgeruch",
    "synonyms": [
      "Foetor ex ore",
      "Halitosis",
      "Mundgeruch"
    ]
  },
  {
    "code": "R19.80",
    "name": "Abdominales Kompartmentsyndrom",
    "synonyms": [
      "ACS [Abdominelles Kompartmentsyndrom]",
      "Abdominales Kompartmentsyndrom",
      "Abdominelles Kompartmentsyndrom"
    ]
  },
  {
    "code": "R19.88",
    "name": "Völlegefühl",
    "synonyms": [
      "Kaubeschwerden",
      "Rektaler Tenesmus",
      "Schmerzhafte Defäkation",
      "Tenesmus",
      "Völlegefühl"
    ]
  },
  {
    "code": "R20.0",
    "name": "Anästhesie der Haut",
    "synonyms": [
      "Anaesthesia",
      "Analgesie",
      "Anästhesie",
      "Anästhesie der Haut",
      "Hemianalgesie",
      "Hemianästhesie"
    ]
  },
  {
    "code": "R20.1",
    "name": "Hypästhesie der Haut",
    "synonyms": [
      "Hemihypästhesie",
      "Hypoästhesie",
      "Hypästhesie",
      "Hypästhesie der Haut",
      "Taubheitsgefühl der Haut"
    ]
  },
  {
    "code": "R20.2",
    "name": "Parästhesie der Haut",
    "synonyms": [
      "Ameisenlaufen",
      "Ameisenlaufen des Arms",
      "Berger-Parästhesie",
      "Brennen der Haut",
      "Eingeschlafene Hände",
      "Hemiparästhesie",
      "Kribbeln",
      "Kribbeln der Haut",
      "Kribbeln im Bein",
      "Lageabhängige Parästhesie",
      "Lhermitte-Zeichen",
      "Nadelstichgefühl",
      "Nadelstichgefühl der Haut",
      "Parästhesie",
      "Parästhesie der Haut",
      "Pelzigkeit",
      "Prickeln der Haut"
    ]
  },
  {
    "code": "R20.3",
    "name": "Hyperästhesie der Haut",
    "synonyms": [
      "Hemihyperästhesie",
      "Hyperästhesie",
      "Hyperästhesie der Haut",
      "Hyperästhesie der Körperoberfläche"
    ]
  },
  {
    "code": "R20.8",
    "name": "Sensibilitätsstörung der Haut",
    "synonyms": [
      "Allocheirie",
      "Allodynie",
      "Berührungssinnverlust",
      "Dysästhesie",
      "Empfindlichkeitsstörung der Haut",
      "Fehlen der Hitzeempfindung",
      "Fehlen der Kälteempfindung",
      "Gesteigerte Schmerzempfindlichkeit",
      "Hemihypalgesie",
      "Hypalgesie",
      "Hyperalgesie",
      "Hyperpathie",
      "Kongenitales Analgiesyndrom",
      "Kältegefühl",
      "Schmerzhypersensibilität",
      "Sensibilitätsstörung",
      "Sensibilitätsstörung der Haut",
      "Störung der Tiefensensibilität der Haut",
      "Störung des Gefühlssinns",
      "Synästhesie",
      "Tastsinnstörung",
      "Tastsinnverlust",
      "Temperaturempfindungsstörung",
      "Tiefe Sensibilitätsstörung der Haut",
      "Verlust der Tastlokalisation",
      "Vibrationsempfindung der Haut"
    ]
  },
  {
    "code": "R21",
    "name": "Unspezifische Hauteruption und Hautausschlag",
    "synonyms": [
      "Ausschlag",
      "Eruption",
      "Exanthem",
      "Exanthema",
      "Hautausschlag",
      "Hauteffloreszenz",
      "Hautexanthem",
      "Makulopapulöser Hautausschlag",
      "Morbilliformes Exanthem",
      "Scharlachartiger Hautausschlag",
      "Uncharakteristische Effloreszenz",
      "Uncharakteristischer Ausschlag",
      "Uncharakteristisches Exanthem",
      "Unspezifische Hauteruption und Hautausschlag",
      "Unspezifischer Hautausschlag",
      "Vesikuläres Exanthem"
    ]
  },
  {
    "code": "R22.0",
    "name": "Umschriebene Schwellung der Haut des Kopfes und des Nackens",
    "synonyms": [
      "Raumforderung der Kopfhaut",
      "Umschriebene Raumforderung der Kopfhaut",
      "Umschriebene Schwellung der Haut des Kopfes und des Nackens"
    ]
  },
  {
    "code": "R22.1",
    "name": "Umschriebene Schwellung der Haut des Halses",
    "synonyms": [
      "Raumforderung der Haut des Halses",
      "Umschriebene Raumforderung der Haut des Halses",
      "Umschriebene Schwellung der Haut des Halses",
      "Umschriebene Schwellung der Haut des Nackens"
    ]
  },
  {
    "code": "R22.2",
    "name": "Bauchdeckeninfiltrat",
    "synonyms": [
      "Bauchdeckeninfiltrat",
      "Brustschwellung",
      "Leistenschwellung",
      "Raumforderung im Brustkorb",
      "Raumforderung im Thorax",
      "Umschriebene Brustkorbschwellung",
      "Umschriebene Hautschwellung am Stamm",
      "Umschriebene Raumforderung der Haut am Stamm",
      "Umschriebene Thoraxschwellung"
    ]
  },
  {
    "code": "R22.3",
    "name": "Umschriebene Raumforderung an der Haut einer oberen Extremität",
    "synonyms": [
      "Umschriebene Raumforderung an der Haut einer oberen Extremität"
    ]
  },
  {
    "code": "R22.4",
    "name": "Beinschwellung",
    "synonyms": [
      "Beinschwellung",
      "Geschwollenes Bein"
    ]
  },
  {
    "code": "R22.7",
    "name": "Umschriebene Raumforderung der Haut an mehreren Lokalisationen",
    "synonyms": [
      "Umschriebene Raumforderung der Haut an mehreren Lokalisationen"
    ]
  },
  {
    "code": "R22.9",
    "name": "Lokalisierte Schwellung",
    "synonyms": [
      "Kutaner Knoten",
      "Lokalisierte Raumforderung",
      "Lokalisierte Schwellung",
      "Noduli cutanei",
      "Oberflächliche Hautschwellung",
      "Oberflächliche Raumforderung",
      "Oberflächliche lokalisierte Schwellung",
      "Subkutaner Knoten",
      "Subkutanes lokalisiertes Knötchen",
      "Umschriebene Hautschwellung",
      "Umschriebene Raumforderung",
      "Unklare Schwellung",
      "Unklares Infiltrat"
    ]
  },
  {
    "code": "R23.0",
    "name": "Zyanose",
    "synonyms": [
      "Blausucht",
      "Lippenzyanose",
      "Zyanose"
    ]
  },
  {
    "code": "R23.1",
    "name": "Hautblässe",
    "synonyms": [
      "Blässe",
      "Erbleichung",
      "Feuchtkalte Haut",
      "Hautblässe",
      "Kalte Füße",
      "Livedo",
      "Livedo anularis",
      "Livedo racemosa",
      "Livedo reticularis",
      "Pallor"
    ]
  },
  {
    "code": "R23.2",
    "name": "Errötung",
    "synonyms": [
      "Abnormes Erröten",
      "Erröten",
      "Errötung",
      "Flush",
      "Gesichtsrötung",
      "Rubeosis faciei",
      "Übermäßiges Erröten"
    ]
  },
  {
    "code": "R23.3",
    "name": "Spontane Ekchymose",
    "synonyms": [
      "Hautblutung",
      "Hauthämorrhagie",
      "Hautpetechien",
      "Kutane Blutung",
      "Kutane Hämorrhagie",
      "Perikardpetechien",
      "Petechiale Blutung",
      "Petechiale Hämorrhagie",
      "Petechien",
      "Spontane Ekchymose",
      "Subkutane Blutung",
      "Subkutane Hämorrhagie",
      "Suffusion",
      "Sugillation",
      "Tentoriumpetechien"
    ]
  },
  {
    "code": "R23.4",
    "name": "Veränderung des Hautreliefs",
    "synonyms": [
      "Abschuppung der Haut",
      "Desquamation der Haut",
      "Fingerrhagade",
      "Fissur des Dammbereiches",
      "Hautfissur",
      "Hautinduration",
      "Hautkruste",
      "Hautrhagade",
      "Hautverdickung",
      "Hautverhärtung",
      "Parakeratose",
      "Parakeratosis",
      "Rhagade",
      "Veränderung des Hautreliefs"
    ]
  },
  {
    "code": "R23.8",
    "name": "Uncharakteristische Hautflecken",
    "synonyms": [
      "Blase",
      "Blasenausschlag der Haut",
      "Bläschen",
      "Bläschen eines Fingers",
      "Bulla",
      "Bullae",
      "Bullöser Ausschlag",
      "Cutis marmorata",
      "Hautablagerung",
      "Hautbläschen",
      "Hautveränderung",
      "Hämorrhagische Bullae",
      "Kutane Ablagerung",
      "Kutane Bläschen",
      "Marmorhaut",
      "Multiple nichttraumatische Hautbläschen",
      "Papeln",
      "Papula",
      "Pickel",
      "Ringelförmiger Ausschlag",
      "Schmerfluss",
      "Seborrhoe",
      "Seborrhoea",
      "Seborrhoea oleosa",
      "Sebostase",
      "Spannung der Haut",
      "Uncharakteristische Hautflecken",
      "Vesikulärer Ausschlag",
      "Waschfrauenhaut",
      "Waschfrauenhände"
    ]
  },
  {
    "code": "R25.0",
    "name": "Abnorme Kopfbewegung",
    "synonyms": [
      "Abnorme Kopfbewegung",
      "Jactatio capitis"
    ]
  },
  {
    "code": "R25.1",
    "name": "Tremor",
    "synonyms": [
      "Hemitremor",
      "Tremor",
      "Zittern"
    ]
  },
  {
    "code": "R25.2",
    "name": "Gesichtskrampf",
    "synonyms": [
      "Beinkrampf",
      "Crampi",
      "Crampus-Syndrom",
      "Fokale Spastizität",
      "Gesichtskrampf",
      "Hemispasmus",
      "Kaumuskelkrampf",
      "Krampf der oberen Gliedmaßen a.n.k.",
      "Krampf der unteren Gliedmaßen a.n.k.",
      "Muskelkrampf",
      "Nächtlicher Wadenkrampf",
      "Spasmus",
      "Spastik",
      "Trismus",
      "Wadenkrampf"
    ]
  },
  {
    "code": "R25.3",
    "name": "Faszikulation",
    "synonyms": [
      "Faszikulation",
      "Faszikuläre Zuckungen",
      "Muskelfaszikulation",
      "Zuckungen"
    ]
  },
  {
    "code": "R25.8",
    "name": "Abnorme unwillkürliche Bewegungen",
    "synonyms": [
      "Abnorme unwillkürliche Bewegungen",
      "Asterixis",
      "Athetose",
      "Choreiforme Bewegungen",
      "Dystone Bewegungen",
      "Erworbene Athetose",
      "Hemiathetose",
      "Klonus",
      "Nichtepileptischer Nickkrampf",
      "Nichtepileptischer Salaamkrampf",
      "Nichtepileptischer Salaamtic",
      "Reflexkonvulsionen",
      "Unilaterale Athetose"
    ]
  },
  {
    "code": "R26.0",
    "name": "Ataktischer Gang",
    "synonyms": [
      "Ataktischer Gang",
      "Gang-Ataxie",
      "Schwankender Gang",
      "Taumelnder Gang"
    ]
  },
  {
    "code": "R26.1",
    "name": "Paretischer Gang",
    "synonyms": [
      "Paralytischer Gang",
      "Paretischer Gang",
      "Spastischer Gang"
    ]
  },
  {
    "code": "R26.2",
    "name": "Dysbasia",
    "synonyms": [
      "Dysbasia",
      "Gehbeschwerden",
      "Problem beim Gehen"
    ]
  },
  {
    "code": "R26.3",
    "name": "Bettlägerigkeit",
    "synonyms": [
      "Angewiesensein auf Krankenstuhl",
      "Bettlägerigkeit",
      "Immobilität",
      "Mobilitätsbeeinträchtigung",
      "Mobilitätseinschränkung"
    ]
  },
  {
    "code": "R26.8",
    "name": "Standunsicherheit",
    "synonyms": [
      "Abnormer Gang",
      "Außenrotationsgang",
      "Ganganomalie",
      "Gangstörung",
      "Gehbehinderung",
      "Gehunfähigkeit",
      "Innenrotationsgang",
      "Laufstörung",
      "Standunsicherheit",
      "Zehenspitzengang"
    ]
  },
  {
    "code": "R27.0",
    "name": "Ataxie",
    "synonyms": [
      "Ataxia",
      "Ataxie"
    ]
  },
  {
    "code": "R27.8",
    "name": "Koordinationsstörung",
    "synonyms": [
      "Akute Ataxie",
      "Asynergie",
      "Ataxoadynamie",
      "Detrusor-Beckenboden-Ataxie",
      "Detrusor-Beckenboden-Dyssynergie",
      "Detrusor-Blasenhals-Dyssynergie",
      "Detrusor-Harnblasenhals-Ataxie",
      "Dysdiadochokinese",
      "Dysgraphie",
      "Dysmetrie",
      "Dyspraxie",
      "Generelle Ataxie",
      "Koordinationsstörung",
      "Muskuläre Inkoordination",
      "Visuomotorische Koordinationsstörung",
      "Zentrale Koordinationsstörung"
    ]
  },
  {
    "code": "R29.0",
    "name": "Tetanie",
    "synonyms": [
      "Achsensyndrom der Tetanie",
      "Hyperkinetische Tetanie",
      "Karpopedalspasmus",
      "Konvulsionstetanie",
      "Krampfbereitschaft",
      "Pseudotetanie",
      "Spasmophilie",
      "Tetania",
      "Tetanie"
    ]
  },
  {
    "code": "R29.1",
    "name": "Meningismus",
    "synonyms": [
      "Meningismus",
      "Meningismus durch Impfstoffe",
      "Meningismus durch Serum"
    ]
  },
  {
    "code": "R29.2",
    "name": "Feinmotorikstörung",
    "synonyms": [
      "Abnorme Reflexe a.n.k.",
      "Anomaler Glabella-Reflex",
      "Feinmotorikstörung",
      "Hyperreflexie",
      "Hyporeflexie",
      "Motorische Störung",
      "Reflexstörung"
    ]
  },
  {
    "code": "R29.3",
    "name": "Haltungsanomalie",
    "synonyms": [
      "Abnorme Körperhaltung",
      "Haltungsanomalie",
      "Haltungsschaden",
      "Haltungsschwäche",
      "Haltungsschwäche im Schultergürtelbereich",
      "Haltungsstörung",
      "Koordinationsstörung der Körperhaltung",
      "Mangelhafte Körperhaltung",
      "Schlechte Haltung",
      "Statisch-dynamische Haltungsinsuffizienz",
      "Unsichere Haltung"
    ]
  },
  {
    "code": "R29.4",
    "name": "Schnappende Hüfte",
    "synonyms": [
      "Ortolani-Phänomen",
      "Schnappende Hüfte",
      "Schnellende Hüfte beim Neugeborenen"
    ]
  },
  {
    "code": "R29.5",
    "name": "Asomatognosie",
    "synonyms": [
      "Asomatognosie",
      "Halbseitige Vernachlässigung",
      "Hemiakinesie",
      "Hemineglect",
      "Linksseitiges Neglect",
      "Neurologisches Hemineglect",
      "Neurologisches Neglect",
      "Sensorische Extinktion",
      "Sensorisches Neglect",
      "Visuell-räumliches Neglect"
    ]
  },
  {
    "code": "R29.6",
    "name": "Sturzneigung a.n.k.",
    "synonyms": [
      "Sturzneigung a.n.k.",
      "Sturzneigung auf Grund sonstiger unklarer Krankheitszustände",
      "Sturzneigung beim älteren Menschen"
    ]
  },
  {
    "code": "R29.8",
    "name": "Akinetisches hypotones Syndrom",
    "synonyms": [
      "Akinesie",
      "Akinetisches hypotones Syndrom",
      "Bewegungshemmung",
      "Bewegungslosigkeit",
      "Bewegungsstarre",
      "Bewegungsunfähigkeit",
      "Bewegungsunsicherheit",
      "Chirobrachialgie",
      "Druckempfindlichkeit eines Nervenaustrittspunktes",
      "Erhöhter Muskeltonus",
      "Fußfehlstatik",
      "Hirnstammsymptomatik",
      "Hirnstammzeichen",
      "Instabiler intrakranieller Druck",
      "Muskelhypotonie",
      "Muskelsteifigkeit",
      "Neurologische Störung a.n.k.",
      "Neurologisches Problem a.n.k.",
      "Opisthotonus",
      "Pseudoparalyse des Arms",
      "Pseudoparalyse des Beins",
      "Rigidität der Skelettmuskulatur",
      "Statische Beschwerden",
      "Statische Fußbeschwerden",
      "Statische Insuffizienz des Fußes",
      "Transitorische Armparalyse",
      "Transitorische Beinparalyse",
      "Transitorische Extremitätenparalyse",
      "Transitorische Monoplegie",
      "Unklare Muskelhypotonie",
      "Vorübergehende Armparalyse",
      "Vorübergehende Beinparalyse",
      "Vorübergehende Extremitätenparalyse",
      "Vorübergehende Monoplegie",
      "Wachstumsschmerzen",
      "Wadenschmerzen",
      "Zerebrale Unterfunktion"
    ]
  },
  {
    "code": "R30.0",
    "name": "Strangurie",
    "synonyms": [
      "Algurie",
      "Dysurie",
      "Schmerzhafter Harndrang",
      "Strangurie"
    ]
  },
  {
    "code": "R30.1",
    "name": "Blasenkrampf",
    "synonyms": [
      "Blasendrang",
      "Blasenkrampf",
      "Blasentenesmen",
      "Harnblasenkrampf",
      "Harnblasentenesmen",
      "Tenesmus vesicae",
      "Vesikaler Tenesmus"
    ]
  },
  {
    "code": "R30.9",
    "name": "Schmerzhaftes Harnlassen",
    "synonyms": [
      "Brennen beim Wasserlassen",
      "Schmerzen beim Wasserlassen",
      "Schmerzhafte Harnentleerung",
      "Schmerzhafte Miktion",
      "Schmerzhaftes Harnlassen",
      "Schmerzhaftes Urinieren"
    ]
  },
  {
    "code": "R31",
    "name": "Harnblutung",
    "synonyms": [
      "Blut im Harn",
      "Blut im Urin",
      "Blutharn",
      "Blutiger Harn",
      "Blutung aus dem oberen Harntrakt",
      "Blutung des Urogenitaltraktes a.n.k.",
      "Erythrozyturie",
      "Essentielle Hämaturie",
      "Harnblutung",
      "Hämaturie",
      "Hämorrhagie des Urogenitaltraktes a.n.k.",
      "Makrohämaturie",
      "Massenhämaturie",
      "Mikrohämaturie",
      "Zystitische Hämaturie"
    ]
  },
  {
    "code": "R32",
    "name": "Harninkontinenz",
    "synonyms": [
      "Anischurie",
      "Bettnässen",
      "Blasenhalsinsuffizienz",
      "Blaseninkontinenz",
      "Detrusorinsuffizienz",
      "Detrusormyasthenie",
      "Detrusorschwäche",
      "Einnässen",
      "Enuresis",
      "Enuresis diurna",
      "Enuresis nocturna",
      "Enuresis nocturna persistens",
      "Enuresis nocturna secundaria",
      "Enuretisches Syndrom",
      "Harnblaseninsuffizienz",
      "Harninkontinenz",
      "Hosennässen",
      "Imperativer Harndrang",
      "Incontinentia - s.a. Inkontinenz",
      "Incontinentia urinae",
      "Incontinentia vesicae",
      "Inkontinenz",
      "Inkontinenz des Harnröhrenschließmuskels",
      "Inkontinenz des Urethraschließmuskels",
      "Insuffizienz des Harnblasensphinkters",
      "Insuffizienz des Urethrasphinkters",
      "Kontinenzschwäche",
      "Kontinenzschwäche der Blase",
      "Nachteinnässen",
      "Nächtliches Einnässen",
      "Stillicidium urinae",
      "Ständiges Harnträufeln",
      "Stürmischer Harndrang",
      "Tageseinnässen",
      "Unfreiwilliger Harnabgang",
      "Unwillkürlicher Harnabgang",
      "Urethrasphinkterinsuffizienz",
      "Urininkontinenz"
    ]
  },
  {
    "code": "R33",
    "name": "Harnsperre",
    "synonyms": [
      "Harnretention",
      "Harnsperre",
      "Harnverhaltung",
      "Ischurie",
      "Retentio urinae"
    ]
  },
  {
    "code": "R34",
    "name": "Anurie",
    "synonyms": [
      "Anurie",
      "Komplexe Anurie",
      "Mangel an Harnsekretion",
      "Mangelhafte Harnausscheidung",
      "Oligo-Anurie",
      "Oligurie",
      "Verminderte Harnsekretion",
      "Verminderte Urinsekretion"
    ]
  },
  {
    "code": "R35.0",
    "name": "Polyurie",
    "synonyms": [
      "Entlastungspolyurie",
      "Harnflut",
      "Hyperurese",
      "Osmotische Diurese",
      "Polyurie",
      "Urina-spastica-Syndrom",
      "Vermehrte Harnausscheidung",
      "Vermehrte Harnmenge",
      "Vermehrte Urinmenge",
      "Verstärkte Diurese",
      "Wasserdiurese",
      "Übermäßige Urinsekretion"
    ]
  },
  {
    "code": "R35.1",
    "name": "Harndrang",
    "synonyms": [
      "Erhöhte Miktionsfrequenz",
      "Gehäufter Harndrang",
      "Harndrang",
      "Häufige Miktion",
      "Häufiges Harnlassen",
      "Häufiges Wasserlassen",
      "Pollakisurie"
    ]
  },
  {
    "code": "R35.2",
    "name": "Nykturie",
    "synonyms": [
      "Häufige nächtliche Miktion",
      "Häufiges nächtliches Wasserlassen",
      "Nykturie",
      "Nächtliche Polyurie",
      "Nächtlicher Harnabgang"
    ]
  },
  {
    "code": "R36",
    "name": "Urethralausfluss",
    "synonyms": [
      "Harnröhrenausfluss",
      "Penisausfluss",
      "Urethraausfluss",
      "Urethralausfluss",
      "Urethrorrhoe"
    ]
  },
  {
    "code": "R39.0",
    "name": "Harninfiltration",
    "synonyms": [
      "Extravasater Harn",
      "Harnextravasation",
      "Harninfiltration",
      "Urinextravasation",
      "Urinom"
    ]
  },
  {
    "code": "R39.1",
    "name": "Harntransportstörung",
    "synonyms": [
      "Abnormität beim Harnlassen a.n.k.",
      "Abnormität beim Wasserlassen a.n.k.",
      "Beeinträchtigung des Harnstrahls",
      "Blasenentleerungsstörung",
      "Eingeschränkter Harnfluss",
      "Eingeschränkter Urinfluss",
      "Gedrehter Harnstrahl",
      "Gespaltener Harnstrahl",
      "Harnblasenentleerungsstörung",
      "Harnentleerungsstörung",
      "Harnstrahlabschwächung",
      "Harnstrahldrehung",
      "Harnstrahlspaltung",
      "Harnstrahlveränderung",
      "Harntransportstörung",
      "Miktionsbehinderung",
      "Miktionsbeschwerden",
      "Miktionsstörung a.n.k.",
      "Reduzierter Harnfluss",
      "Reduzierter Urinfluss",
      "Residualharn",
      "Restharn",
      "Restharnretention",
      "Schwacher Harnstrahl",
      "Stakkatoartiger Harnstrahl",
      "Störung beim Wasserlassen",
      "Unterbrochener Harnstrahl",
      "Verlängerte Miktion",
      "Verlängertes Wasserlassen",
      "Vermehrter Restharn",
      "Verminderter Harnfluss",
      "Verminderter Urinfluss",
      "Verzögerte Miktion",
      "Verzögerter Miktionsbeginn"
    ]
  },
  {
    "code": "R39.2",
    "name": "Extrarenale Urämie",
    "synonyms": [
      "Extrarenale Reststickstoffvermehrung",
      "Extrarenale Stickstoffretention",
      "Extrarenale Urämie",
      "Prärenale Urämie"
    ]
  },
  {
    "code": "R39.8",
    "name": "Urethralgie",
    "synonyms": [
      "Blasenschmerzen",
      "Harnblasenschmerzen",
      "Luftharnen",
      "Minderperfusion der Niere",
      "Pneumaturie",
      "Spasmus der ableitenden Harnwege",
      "Urethralgie",
      "Vesikale Schmerzen",
      "Zystalgie"
    ]
  },
  {
    "code": "R40.0",
    "name": "Somnolenz",
    "synonyms": [
      "Benommenheit",
      "Bewusstseinstrübung",
      "Schläfrigkeit",
      "Somnolenz",
      "Vigilanzminderung"
    ]
  },
  {
    "code": "R40.1",
    "name": "Präkoma - s.a. Praecoma",
    "synonyms": [
      "Idiopathischer rezidivierender Stupor",
      "Komaartige Störung",
      "Komaartiger Zustand",
      "Praecoma - s.a. Präkoma",
      "Präkoma - s.a. Praecoma",
      "Sopor",
      "Stupor"
    ]
  },
  {
    "code": "R40.2",
    "name": "Bewusstlosigkeit",
    "synonyms": [
      "Bewusstlosigkeit",
      "Coma",
      "Coma cardiale",
      "Coma cerebrale",
      "Coma hypercapnicum",
      "Coma prolongé",
      "Irritations-Syndrom des Mesodienzephalon",
      "Koma",
      "Komatöser Zustand",
      "Zerebrales Koma"
    ]
  },
  {
    "code": "R41.0",
    "name": "Verwirrtheitszustand",
    "synonyms": [
      "Desorientiertheit",
      "Orientierungsstörung",
      "Verwirrtheit",
      "Verwirrtheitszustand"
    ]
  },
  {
    "code": "R41.1",
    "name": "Anterograde Amnesie",
    "synonyms": [
      "Anterograde Amnesie"
    ]
  },
  {
    "code": "R41.2",
    "name": "Retrograde Amnesie",
    "synonyms": [
      "Retrograde Amnesie"
    ]
  },
  {
    "code": "R41.3",
    "name": "Amnesie",
    "synonyms": [
      "Amnesie",
      "Gedächtnislücke",
      "Gedächtnisminderung",
      "Gedächtnisstörung",
      "Mangel des Erinnerungsvermögens",
      "Paramnesie",
      "Störung des Erinnerungsvermögens",
      "Verlust des Erinnerungsvermögens"
    ]
  },
  {
    "code": "R41.8",
    "name": "Nachlassende Merkfähigkeit",
    "synonyms": [
      "Akinetischer Mutismus",
      "Allgemeine Vergesslichkeit",
      "Altersabhängige Abnahme kognitiver Funktionen",
      "Anosognosie",
      "Bewusstseinsstörung",
      "Bewusstseinsveränderung",
      "Grenzwertige intellektuelle Funktion",
      "Hypervigilität",
      "Inkohärenz",
      "Nachlassende Merkfähigkeit",
      "Trance",
      "Trancezustand"
    ]
  },
  {
    "code": "R42",
    "name": "Vaskuläre vertebragene Vertigo",
    "synonyms": [
      "Arteriosklerotische Vertigo",
      "Drehschwindel",
      "Gleichgewichtsstörung",
      "Gleichgewichtsstörung und Schwindel",
      "Präsynkope",
      "Schwindel",
      "Schwindel und Taumel",
      "Schwindel unklarer Genese",
      "Schwindelattacke",
      "Spondylogener Schwindel",
      "Taumel",
      "Uncharakteristische Vertigo",
      "Uncharakteristischer Schwindel",
      "Unklarer Drehschwindel",
      "Unklarer Schwindel",
      "Vaskuläre vertebragene Vertigo",
      "Vaskulärer Schwindel",
      "Vertebragene Vertigo",
      "Vertebragener Schwindel",
      "Vertigo",
      "Zervikaler Schwindel",
      "Zervikogener Schwindel"
    ]
  },
  {
    "code": "R43.0",
    "name": "Anosmie",
    "synonyms": [
      "Anosmie",
      "Geruchssinnverlust",
      "Hyposmie"
    ]
  },
  {
    "code": "R43.1",
    "name": "Parosmie",
    "synonyms": [
      "Geruchstäuschung",
      "Hyperosmie",
      "Kakosmie",
      "Parosmie"
    ]
  },
  {
    "code": "R43.2",
    "name": "Ageusie",
    "synonyms": [
      "Ageusie",
      "Dysgeusie",
      "Geschmackssinnverlust",
      "Parageusie"
    ]
  },
  {
    "code": "R43.8",
    "name": "Geruchssinnstörung",
    "synonyms": [
      "Geruchssinnstörung",
      "Geruchssinnstörung mit Geschmackssinnstörung",
      "Geruchssinnverlust mit Geschmackssinnverlust",
      "Geschmackssinnstörung",
      "Hypogeusie",
      "Perverser Geruchssinn",
      "Perverser Geschmackssinn",
      "Problem mit dem Geruchssinn",
      "Problem mit dem Geschmackssinn"
    ]
  },
  {
    "code": "R44.0",
    "name": "Akustische Halluzination",
    "synonyms": [
      "Akustische Halluzination"
    ]
  },
  {
    "code": "R44.1",
    "name": "Optische Halluzination",
    "synonyms": [
      "Optische Halluzination",
      "Visuelle Halluzination"
    ]
  },
  {
    "code": "R44.2",
    "name": "Gustatorische Halluzination",
    "synonyms": [
      "Gustatorische Halluzination",
      "Olfaktorische Halluzination",
      "Phantosmie",
      "Taktile Halluzination"
    ]
  },
  {
    "code": "R44.3",
    "name": "Halluzination",
    "synonyms": [
      "Halluzination",
      "Trugwahrnehmung"
    ]
  },
  {
    "code": "R44.8",
    "name": "Visuelle Wahrnehmungsstörung",
    "synonyms": [
      "Olfaktorische Intoleranz",
      "Verlust von Sinnesfunktionen",
      "Visuelle Wahrnehmungsstörung",
      "Wahrnehmungsstörung"
    ]
  },
  {
    "code": "R45.0",
    "name": "Nervosität",
    "synonyms": [
      "Funktionelle nervöse Störung",
      "Innere Unruhe",
      "Nervosität",
      "Nervöse Reizung",
      "Nervöse Spannung",
      "Nervöser Spannungszustand"
    ]
  },
  {
    "code": "R45.1",
    "name": "Erregung",
    "synonyms": [
      "Agitatio",
      "Erregung",
      "Erregungszustand",
      "Motorische Unruhe",
      "Psychomotorische Unruhe",
      "Psychovegetativer Erregungszustand",
      "Psychovegetativer Unruhezustand",
      "Ruhelosigkeit",
      "Unruhe",
      "Unruhezustand"
    ]
  },
  {
    "code": "R45.2",
    "name": "Unglücklichsein",
    "synonyms": [
      "Sorge",
      "Unglücklichsein"
    ]
  },
  {
    "code": "R45.3",
    "name": "Apathie",
    "synonyms": [
      "Apathie",
      "Demoralisierung",
      "Teilnahmslosigkeit"
    ]
  },
  {
    "code": "R45.4",
    "name": "Reizbarkeit",
    "synonyms": [
      "Irritabilität",
      "Reizbarkeit",
      "Wut",
      "Zorn"
    ]
  },
  {
    "code": "R45.5",
    "name": "Feindseligkeit",
    "synonyms": [
      "Feindseligkeit"
    ]
  },
  {
    "code": "R45.6",
    "name": "Körperliche Gewalt",
    "synonyms": [
      "Körperliche Gewalt"
    ]
  },
  {
    "code": "R45.7",
    "name": "Emotionaler Schock",
    "synonyms": [
      "Emotionaler Schock",
      "Emotionaler Stress"
    ]
  },
  {
    "code": "R45.8",
    "name": "Psycholabilität",
    "synonyms": [
      "Affektverarmung",
      "Anhedonie",
      "Antriebssteigerung",
      "Emotionale Labilität",
      "Enthemmung",
      "Neigung zur Selbsttötung",
      "Neurovegetative Labilität",
      "Psychische Verstimmung",
      "Psycholabilität",
      "Psychovegetative Imbalance",
      "Psychovegetative Labilität",
      "Selbstmordneigung",
      "Selbsttötungsgefahr",
      "Selbsttötungstendenz",
      "Stimmungslabilität",
      "Suizidale Gefahr",
      "Suizidalität",
      "Suizidgedanken",
      "Suizidgefahr - kodiere Diagnose",
      "Suizidneigung - kodiere Diagnose",
      "Vegetative Labilität"
    ]
  },
  {
    "code": "R46.0",
    "name": "Stark vernachlässigte Körperpflege",
    "synonyms": [
      "Stark vernachlässigte Körperpflege",
      "Vernachlässigung der Körperpflege"
    ]
  },
  {
    "code": "R46.1",
    "name": "Besonders auffälliges äußeres Erscheinungsbild",
    "synonyms": [
      "Besonders auffälliges äußeres Erscheinungsbild"
    ]
  },
  {
    "code": "R46.2",
    "name": "Verhaltensauffälligkeit",
    "synonyms": [
      "Seltsames Verhalten",
      "Unerklärliches Verhalten",
      "Verhaltensauffälligkeit",
      "Verlust der Selbstbeherrschung"
    ]
  },
  {
    "code": "R46.3",
    "name": "Hyperaktivität",
    "synonyms": [
      "Hyperaktives Verhalten",
      "Hyperaktivität"
    ]
  },
  {
    "code": "R46.4",
    "name": "Verlangsamung und herabgesetztes Reaktionsvermögen",
    "synonyms": [
      "Verlangsamtes Verhalten",
      "Verlangsamung und herabgesetztes Reaktionsvermögen"
    ]
  },
  {
    "code": "R46.5",
    "name": "Misstrauen",
    "synonyms": [
      "Ausweichendes Verhalten",
      "Misstrauen",
      "Misstrauisches Verhalten"
    ]
  },
  {
    "code": "R46.6",
    "name": "Unangemessene Betroffenheit und Beschäftigung mit Stressereignissen",
    "synonyms": [
      "Unangemessene Betroffenheit und Beschäftigung mit Stressereignissen"
    ]
  },
  {
    "code": "R46.7",
    "name": "Wortschwall",
    "synonyms": [
      "Umständliche Detailschilderung, die die Gründe für eine Konsultation oder Inanspruchnahme verschleiert",
      "Wortschwall"
    ]
  },
  {
    "code": "R46.8",
    "name": "Anomalie des Benehmens",
    "synonyms": [
      "Anomalie des Benehmens",
      "Pathologische Verhaltensänderung",
      "Pathologische Veränderung der Aktiviertheit",
      "Vernachlässigung der eigenen Person"
    ]
  },
  {
    "code": "R47.0",
    "name": "Alalie",
    "synonyms": [
      "Alalie",
      "Amnestische Aphasie",
      "Aphasia",
      "Aphasie",
      "Aphemie",
      "Begriffsaphasie",
      "Broca-Aphasie",
      "Dysphasie",
      "Globale Aphasie",
      "Motorische Aphasie",
      "Mutismus",
      "Paraphasie",
      "Semantische Aphasie",
      "Stummheit",
      "Syntaktische Aphasie"
    ]
  },
  {
    "code": "R47.1",
    "name": "Dysarthrie",
    "synonyms": [
      "Anarthrie",
      "Dysarthrie",
      "Undeutliches Sprechen"
    ]
  },
  {
    "code": "R47.8",
    "name": "Sprachstörung",
    "synonyms": [
      "Bulbäre Sprache",
      "Inspiratorisches Sprechen",
      "Sprachdefekt",
      "Sprachfehler",
      "Sprachproblem",
      "Sprachstörung",
      "Sprachverlangsamung",
      "Sprechproblem",
      "Sprechstörung"
    ]
  },
  {
    "code": "R48.0",
    "name": "Dyslexie",
    "synonyms": [
      "Alexie",
      "Dyslexie",
      "Lesestörung"
    ]
  },
  {
    "code": "R48.1",
    "name": "Astereognosie",
    "synonyms": [
      "Agnosie",
      "Agnosie des Körperschemas",
      "Agnosie sonstiger Sinne",
      "Akustische Agnosie",
      "Anton-Babinski-Syndrom",
      "Astereognosie",
      "Autotopagnosie",
      "Optische Agnosie",
      "Pragmatagnosie",
      "Seelenblindheit",
      "Seelentaubheit",
      "Stereoagnosie",
      "Taktile Agnosie",
      "Verbale Agnosie",
      "Visuelle Agnosie"
    ]
  },
  {
    "code": "R48.2",
    "name": "Apraxie",
    "synonyms": [
      "Apraxie",
      "Ideokinetische Apraxie",
      "Ideomotorische Apraxie",
      "Klassische Apraxie",
      "Motorische Apraxie",
      "Verbale Apraxie"
    ]
  },
  {
    "code": "R48.8",
    "name": "Dysgrammatismus",
    "synonyms": [
      "Absolute Agraphie",
      "Agrammatismus",
      "Agraphie",
      "Akalkulie",
      "Akustische Amnesie",
      "Amimie",
      "Amusie",
      "Anomie",
      "Asymbolie",
      "Auditorische Amnesie",
      "Bianchi-Syndrom",
      "Dysgrammatismus",
      "Dyskalkulie",
      "Dysnomie",
      "Echolalie",
      "Palilalie",
      "Perseveration",
      "Sekundäre Strephosymbolie durch organische Schädigung",
      "Sprachverlust",
      "Symbolische Dysfunktion a.n.k.",
      "Tonische Perseveration",
      "Werkzeugstörung"
    ]
  },
  {
    "code": "R49.0",
    "name": "Hypofunktionelle Dysphonie",
    "synonyms": [
      "Dysphonie",
      "Heiserkeit",
      "Hyperfunktionelle Dysphonie",
      "Hypofunktionelle Dysphonie",
      "Senile Dysphonie"
    ]
  },
  {
    "code": "R49.1",
    "name": "Aphonie",
    "synonyms": [
      "Aphonie",
      "Organische Aphonie",
      "Stimmlosigkeit",
      "Stimmverlust"
    ]
  },
  {
    "code": "R49.2",
    "name": "Rhinophonia",
    "synonyms": [
      "Rhinolalia",
      "Rhinolalia aperta",
      "Rhinolalia clausa",
      "Rhinolalia mixta",
      "Rhinophasia",
      "Rhinophasia aperta",
      "Rhinophasia clausa",
      "Rhinophasia mixta",
      "Rhinophonia",
      "Rhinophonia aperta",
      "Rhinophonia clausa",
      "Rhinophonia mixta"
    ]
  },
  {
    "code": "R49.8",
    "name": "Stimmstörung",
    "synonyms": [
      "Stimmdefekt",
      "Stimmermüdung",
      "Stimmproblem",
      "Stimmstörung",
      "Stimmveränderung"
    ]
  },
  {
    "code": "R50.2",
    "name": "Medikamenteninduziertes Fieber",
    "synonyms": [
      "Drug fever",
      "Medikamenteninduziertes Fieber"
    ]
  },
  {
    "code": "R50.80",
    "name": "Unklares Fieber",
    "synonyms": [
      "Erhöhte Körpertemperatur unbekannter Ursache",
      "Fieber unbekannter Ursache",
      "Hyperpyrexie unbekannter Ursache",
      "Hyperthermie unbekannter Ursache",
      "Intermittierendes Fieber unbekannter Ursache",
      "Pyrexie unbekannter Ursache",
      "Unklares Fieber"
    ]
  },
  {
    "code": "R50.88",
    "name": "Fieber mit Schüttelfrost",
    "synonyms": [
      "Anhaltendes Fieber",
      "Fieber mit Schüttelfrost",
      "Fieberschauer a.n.k.",
      "Persistierende Pyrexie",
      "Persistierendes Fieber",
      "Status febrilis",
      "Zentrales Fieber"
    ]
  },
  {
    "code": "R50.9",
    "name": "Temperaturentgleisung",
    "synonyms": [
      "Eintagsfieber",
      "Entkräftungsfieber",
      "Febris",
      "Fever",
      "Fieber - s.a. Febris",
      "Fieberanstieg",
      "Fieberschub",
      "Hyperpyrexie",
      "Hyperthermie",
      "Inanition bei Fieber",
      "Pyrexie",
      "Temperaturentgleisung",
      "Uncharakteristisches Fieber",
      "Vorübergehendes Fieber"
    ]
  },
  {
    "code": "R51",
    "name": "Chronische Gesichtsschmerzen",
    "synonyms": [
      "Cephalaea",
      "Cephalalgia",
      "Cephalgia - s.a Kephalgie oder s.a. Zephalgie",
      "Chronische Gesichtsschmerzen",
      "Chronische Kopfschmerzen",
      "Gesichtsschmerzen",
      "Kephalgie",
      "Kombinationskopfschmerzen",
      "Kopfdruck",
      "Kopfschmerzen",
      "Kopfschmerzen unklarer Genese",
      "Prosopalgie",
      "Unspezifische Kopfschmerzen",
      "Zephalgie"
    ]
  },
  {
    "code": "R52.0",
    "name": "Akute Schmerzen a.n.k.",
    "synonyms": [
      "Akute Schmerzen a.n.k."
    ]
  },
  {
    "code": "R52.1",
    "name": "Chronische unbeeinflussbare Schmerzen",
    "synonyms": [
      "Chronische unbeeinflussbare Schmerzen",
      "Schmerzen bei Karzinom",
      "Thalamisches Schmerzsyndrom",
      "Therapieresistente Schmerzen",
      "Tumorschmerzen"
    ]
  },
  {
    "code": "R52.2",
    "name": "Chronischer Schmerzpatient",
    "synonyms": [
      "Chronische Schmerzen a.n.k.",
      "Chronischer Schmerzpatient",
      "Chronisches Schmerzsyndrom"
    ]
  },
  {
    "code": "R52.9",
    "name": "Intermittierende Schmerzen",
    "synonyms": [
      "Diffuse Schmerzen a.n.k.",
      "Generalisierte Schmerzen",
      "Intermittierende Schmerzen",
      "Panalgesie",
      "Schmerzen",
      "Unklare Schmerzen",
      "Unklarer Schmerzzustand"
    ]
  },
  {
    "code": "R53",
    "name": "Unwohlsein und Ermüdung",
    "synonyms": [
      "Adynamie",
      "Allgemeine Ermüdungserscheinungen",
      "Allgemeine Mattigkeit und Müdigkeit",
      "Allgemeine Schwäche",
      "Allgemeiner Abbau",
      "Allgemeiner Abbauprozess",
      "Allgemeiner Schwächezustand",
      "Allgemeiner körperlicher Abbau",
      "Allgemeiner körperlicher Verfall",
      "Allgemeiner physischer Abbauprozess",
      "Allgemeiner physischer und psychischer Abbauprozess",
      "Allgemeiner psychischer Abbauprozess",
      "Allgemeines Erschöpfungssyndrom",
      "Asthenie",
      "Chronische Schwäche",
      "Chronischer Erschöpfungszustand",
      "Entkräftung",
      "Ermattung",
      "Ermüdung",
      "Erschöpfung",
      "Erschöpfungszustand",
      "Indisposition",
      "Kraftlosigkeit",
      "Krankhafte Schwäche",
      "Krankheitsgefühl",
      "Kräfteverfall",
      "Körperliche Erschöpfung",
      "Körperlicher Abbauprozess",
      "Körperschwäche",
      "Lassitudo",
      "Leistungsabfall",
      "Lethargie",
      "Malaise",
      "Mattigkeit",
      "Müdigkeit",
      "Niedergeschlagenheit",
      "Physischer Abbauprozess",
      "Postvirales Syndrom a.n.k.",
      "Reduzierter Allgemeinzustand",
      "Schlechter Allgemeinzustand",
      "Schwäche",
      "Schwächezustand",
      "Unklares Erschöpfungsgefühl",
      "Unwohlsein",
      "Unwohlsein und Ermüdung",
      "Vitalitätsverlust",
      "Überarbeitung"
    ]
  },
  {
    "code": "R54",
    "name": "Presbykardie",
    "synonyms": [
      "Allgemeines seniles Versagen",
      "Alter",
      "Altern",
      "Altersabbau",
      "Altersatrophie",
      "Altersauszehrung",
      "Alterserschöpfung",
      "Altersgebrechlichkeit",
      "Altersherz",
      "Altersinvolution",
      "Alterskachexie",
      "Altersschwäche",
      "Alterstod",
      "Altersveränderung",
      "Frailty",
      "Frailty-Syndrom",
      "Hohes Alter",
      "Hohes Alter, ohne Angabe einer Psychose",
      "Körperliche Altersschwäche",
      "Marasmus senilis",
      "Presbykardie",
      "Präsenilität",
      "Seneszenz",
      "Seneszenz ohne Angabe einer Psychose",
      "Senile Asthenie",
      "Senile Atrophie",
      "Senile Degeneration",
      "Senile Dysfunktion",
      "Senile Ermüdung",
      "Senile Erschöpfung",
      "Senile Fibrose",
      "Senile Gebrechlichkeit",
      "Senile Kachexie",
      "Senile Lassitudo",
      "Senile Schwäche",
      "Seniler Marasmus",
      "Seniler Tremor",
      "Seniles Herz",
      "Senilität",
      "Senium",
      "Vergreisung"
    ]
  },
  {
    "code": "R55",
    "name": "Sympathikovasaler Anfall",
    "synonyms": [
      "Allgemeiner Kollaps",
      "Blackout",
      "Gowers-Syndrom",
      "Herzsynkope",
      "Kardiale Synkope",
      "Kollaps",
      "Kurzfristiger Bewusstseinsverlust",
      "Miktionssynkope",
      "Ohnmacht",
      "Ohnmachtsanfall",
      "Ohnmachtssyndrom",
      "Sympathikovasaler Anfall",
      "Synkopaler Anfall",
      "Synkope",
      "Synkope mit Vasokonstriktion",
      "Vagusbedingte Ohnmacht",
      "Vagusbedingter Ohnmachtsanfall",
      "Vasomotorische Instabilität",
      "Vasomotorischer Anfall",
      "Vasomotorisches Phänomen",
      "Vasovagale Synkope",
      "Vasovagaler Anfall",
      "Vasovagaler Reflex",
      "Vasovagales Phänomen",
      "Vasovagalsyndrom"
    ]
  },
  {
    "code": "R56.0",
    "name": "Fieberanfall",
    "synonyms": [
      "Anfall bei Fieber",
      "Fieberanfall",
      "Fieberkrampf",
      "Konvulsionen bei Fieber"
    ]
  },
  {
    "code": "R56.8",
    "name": "Zerebraler Krampfanfall",
    "synonyms": [
      "Affektkrampf",
      "Anfall",
      "Coma eclampticum",
      "Epileptiforme Konvulsionen",
      "Epileptiformer Anfall",
      "Epileptoider Anfall",
      "Generalisierte Konvulsionen",
      "Generalisierter Krampf",
      "Hirnorganischer Anfall",
      "Idiopathische Konvulsionen",
      "Infantile Konvulsionen",
      "Konvulsionen",
      "Krampf",
      "Krampfanfall",
      "Paroxysmaler Anfall",
      "Sensorisch-motorischer Anfall",
      "Zerebraler Anfall",
      "Zerebraler Krampf",
      "Zerebraler Krampfanfall"
    ]
  },
  {
    "code": "R57.0",
    "name": "Kardiogener Schock",
    "synonyms": [
      "Kardialer Schock",
      "Kardiogener Schock",
      "Kardiorespiratorischer Kollaps",
      "Kardiovaskulärer Schock"
    ]
  },
  {
    "code": "R57.1",
    "name": "Hypovolämischer Schock",
    "synonyms": [
      "Blutungsschock",
      "Hypovolämischer Schock",
      "Hämorrhagischer Schock",
      "Schock durch Blutung",
      "Volumenmangelschock"
    ]
  },
  {
    "code": "R57.2",
    "name": "Septischer Schock",
    "synonyms": [
      "Septisch-toxischer Schock",
      "Septischer Schock"
    ]
  },
  {
    "code": "R57.8",
    "name": "Endotoxinschock",
    "synonyms": [
      "Aseptischer Schock",
      "Endotoxinschock",
      "Hämatologischer Schock"
    ]
  },
  {
    "code": "R57.9",
    "name": "Schock",
    "synonyms": [
      "Akute Kreislaufinsuffizienz",
      "Akutes peripheres Kreislaufversagen",
      "Kardiovaskulärer Kollaps",
      "Kreislaufkollaps",
      "Kreislaufversagen",
      "Peripherer vaskulärer Kollaps",
      "Peripheres Kreislaufversagen",
      "Schock"
    ]
  },
  {
    "code": "R58",
    "name": "Intraabdominale Blutung",
    "synonyms": [
      "Abdomenblutung",
      "Abdomenhämorrhagie",
      "Abdominalblutung",
      "Arterienblutung",
      "Arterienhämorrhagie",
      "Bauchdeckenblutung",
      "Bauchdeckenhämatom",
      "Blutextravasation",
      "Blutgefäßruptur",
      "Blutung",
      "Blutung der inneren Organe a.n.k.",
      "Blutung in die freie Bauchfellhöhle",
      "Einblutung",
      "Ekchymose",
      "Haemorrhagia",
      "Hämorrhagie - s.a. Blutung",
      "Hämorrhagie der Schleimhaut a.n.k.",
      "Hämorrhagie der inneren Organe a.n.k.",
      "Innere Blutung",
      "Intraabdominale Blutung",
      "Intraabdominale Hämorrhagie",
      "Mikroblutung",
      "Milzvenenruptur",
      "Okkulte Blutung a.n.k.",
      "Okkulte Hämorrhagie a.n.k.",
      "Retroperitonealblutung",
      "Retroperitoneale Hämorrhagie",
      "Ruptur der Vena cava",
      "Schleimhautblutung a.n.k.",
      "Sekundäre nichttraumatische Blutung",
      "Sekundäre nichttraumatische Hämorrhagie",
      "Subdiaphragmatische Blutung",
      "Subdiaphragmatische Hämorrhagie",
      "Venöse Blutung",
      "Venöse Hämorrhagie",
      "Viszerale Blutung",
      "Viszerale Hämorrhagie",
      "Weichteilblutung"
    ]
  },
  {
    "code": "R59.0",
    "name": "Umschriebene Lymphknotenvergrößerung",
    "synonyms": [
      "Axillalymphknotenschwellung",
      "Halslymphknotenschwellung",
      "Hyperplasie von Halslymphknoten",
      "Hypertrophie von Hiluslymphknoten",
      "Inguinale Lymphadenopathie",
      "Leistendrüsenschwellung",
      "Lokalisierte Lymphadenopathie",
      "Lokalisierte Lymphknotenhyperplasie",
      "Lokalisierte Lymphknotenhypertrophie",
      "Lokalisierte Lymphknotenschwellung",
      "Lokalisierte Lymphknotenvergrößerung",
      "Mediastinale Lymphadenopathie",
      "Mesenteriale Lymphadenopathie",
      "Tracheobronchiale Lymphadenopathie",
      "Umschriebene Lymphknotenvergrößerung",
      "Zervikaldrüsenschwellung"
    ]
  },
  {
    "code": "R59.1",
    "name": "Generalisierte Lymphknotenvergrößerung",
    "synonyms": [
      "Generalisierte Lymphadenopathie",
      "Generalisierte Lymphknotenhyperplasie a.n.k.",
      "Generalisierte Lymphknotenhypertrophie a.n.k.",
      "Generalisierte Lymphknotenschwellung",
      "Generalisierte Lymphknotenvergrößerung",
      "Konstitutioneller Status lymphaticus",
      "Lymphadenie",
      "Lymphadenopathie"
    ]
  },
  {
    "code": "R59.9",
    "name": "Lymphdrüsenschwellung",
    "synonyms": [
      "Drüsenschwellung",
      "Geschwollene Drüse",
      "Geschwollener Lymphknoten",
      "Lymphdrüsenkatarrh",
      "Lymphdrüsenschwellung",
      "Lymphknotenhyperplasie",
      "Lymphknotenhypertrophie",
      "Lymphknotenschwellung",
      "Lymphknotenvergrößerung"
    ]
  },
  {
    "code": "R60.0",
    "name": "Prätibiales Ödem",
    "synonyms": [
      "Beinödem",
      "Dellenbildung der Lippe",
      "Fußrückenödem",
      "Fußödem",
      "Gesichtsödem",
      "Knöchelödem",
      "Lippenödem",
      "Lokalisiertes Ödem",
      "Mundödem",
      "Peripheres Ödem",
      "Prätibiales Ödem",
      "Sommerbeine bei der Frau",
      "Umschriebenes Ödem",
      "Unterschenkelödem",
      "Ödematöses Bein"
    ]
  },
  {
    "code": "R60.1",
    "name": "Generalisiertes Ödem",
    "synonyms": [
      "Anasarka",
      "Generalisiertes Ödem",
      "Ödematose"
    ]
  },
  {
    "code": "R60.9",
    "name": "Fettgewebsödem",
    "synonyms": [
      "Fettgewebsödem",
      "Flüssigkeitsretention",
      "Gewebswassersucht",
      "Hydrops",
      "Infektiöses Ödem",
      "Mukosaödem",
      "Oedema",
      "Schleimhautödem",
      "Toxisches Ödem a.n.k.",
      "Wasserretention",
      "Wassersucht",
      "Ödem",
      "Ödem mit Dellenbildung"
    ]
  },
  {
    "code": "R61.0",
    "name": "Fußschweiß",
    "synonyms": [
      "Fußschweiß",
      "Umschriebene Hyperhidrose",
      "Übermäßiges lokalisiertes Schwitzen"
    ]
  },
  {
    "code": "R61.1",
    "name": "Generalisierte Hyperhidrose",
    "synonyms": [
      "Generalisierte Hyperhidrose",
      "Gustatorisches Reflexschwitzen"
    ]
  },
  {
    "code": "R61.9",
    "name": "Nachtschweiß",
    "synonyms": [
      "Allgemeine Hyperhidrose",
      "Hyperhidrose",
      "Hyperhidrosis",
      "Krankhaft vermehrte Schweißabsonderung",
      "Nachtschweiß",
      "Schweißausbruch",
      "Schweißneigung",
      "Steigerung der Schweißsekretion",
      "Übermäßiges Schwitzen",
      "Übermäßiges nächtliches Schwitzen"
    ]
  },
  {
    "code": "R62.0",
    "name": "Verzögertes Erreichen von Entwicklungsstufen",
    "synonyms": [
      "Spätes Laufenlernen",
      "Spätes Sprechenlernen",
      "Verspätung beim Laufenlernen",
      "Verspätung beim Sprechenlernen",
      "Verzögertes Eintreten einer erwarteten physiologischen Entwicklungsstufe",
      "Verzögertes Erreichen von Entwicklungsstufen",
      "Verzögertes Laufenlernen",
      "Verzögertes Sprechenlernen"
    ]
  },
  {
    "code": "R62.8",
    "name": "Gedeihstörung",
    "synonyms": [
      "Entwicklungshemmung beim Kind",
      "Entwicklungsrückstand",
      "Entwicklungsstillstand",
      "Entwicklungsstillstand beim Kind",
      "Gedeihstörung",
      "Gedeihstörung bei Kindern",
      "Infantilismus",
      "Körperliche Retardierung beim Kind",
      "Körperliches Zurückbleiben",
      "Mangelhaftes Wachstum",
      "Mangelnde Gewichtszunahme",
      "Stiller-Krankheit",
      "Stiller-Syndrom",
      "Verkürzung der Körpergröße",
      "Wachstumshemmung",
      "Wachstumsretardierung",
      "Wachstumsrückstand",
      "Wachstumsstillstand beim Kind",
      "Wachstumsstörung",
      "Wachstumsverzögerung"
    ]
  },
  {
    "code": "R62.9",
    "name": "Ausbleiben der erwarteten normalen physiologischen Entwicklung",
    "synonyms": [
      "Ausbleiben der erwarteten normalen physiologischen Entwicklung"
    ]
  },
  {
    "code": "R63.0",
    "name": "Aphagie",
    "synonyms": [
      "Anorektisches Syndrom",
      "Anorexia",
      "Anorexie",
      "Aphagie",
      "Appetitlosigkeit",
      "Appetitmangel",
      "Appetitstörung",
      "Appetitverlust",
      "Dysorexie",
      "Essunlust",
      "Inappetenz",
      "Magersucht",
      "Reduziertes Essverhalten"
    ]
  },
  {
    "code": "R63.1",
    "name": "Polydipsie",
    "synonyms": [
      "Krankhafter Durst",
      "Polydipsie",
      "Vermehrter Durst",
      "Übermäßiger Durst"
    ]
  },
  {
    "code": "R63.2",
    "name": "Überernährung",
    "synonyms": [
      "Essattacken",
      "Hyperalimentation",
      "Hyperalimentationssyndrom",
      "Hyperphagie",
      "Polyphagie",
      "Überernährung",
      "Überessen",
      "Überfütterung",
      "Übermäßige Nahrungsaufnahme",
      "Übermäßiger Appetit",
      "Übermäßiges Essen"
    ]
  },
  {
    "code": "R63.3",
    "name": "Ernährungsproblem",
    "synonyms": [
      "Ernährungsproblem",
      "Ernährungsschwierigkeiten",
      "Falsche Ernährung",
      "Unsachgemäße Ernährung"
    ]
  },
  {
    "code": "R63.4",
    "name": "Abnorme Gewichtsabnahme",
    "synonyms": [
      "Abnorme Gewichtsabnahme",
      "Abnormer Gewichtsverlust",
      "Dystrophie durch abnorme Gewichtsabnahme",
      "Gewichtsverlust",
      "Ungewöhnliche Gewichtsabnahme",
      "Unklare Gewichtsabnahme",
      "Untergewicht"
    ]
  },
  {
    "code": "R63.5",
    "name": "Abnorme Gewichtszunahme",
    "synonyms": [
      "Abnorme Gewichtszunahme",
      "Gewichtserhöhung"
    ]
  },
  {
    "code": "R63.6",
    "name": "Ungenügende Aufnahme von Nahrung und Flüssigkeit durch Vernachlässigung der eigenen Person",
    "synonyms": [
      "Ungenügende Aufnahme von Nahrung und Flüssigkeit",
      "Ungenügende Aufnahme von Nahrung und Flüssigkeit durch Vernachlässigung der eigenen Person"
    ]
  },
  {
    "code": "R63.8",
    "name": "Gewichtsproblem",
    "synonyms": [
      "Gewichtsproblem",
      "Hypometabolismus"
    ]
  },
  {
    "code": "R64",
    "name": "Denutrition",
    "synonyms": [
      "Auszehrung - s.a. Kachexie",
      "Cachexia - s.a. Kachexie",
      "Denutrition",
      "Inanition",
      "Kachexia",
      "Kachexie",
      "Kachexie durch bösartige Neubildung",
      "Kachexie-Syndrom a.n.k.",
      "Kanzeröse Kachexie",
      "Maligne Kachexie",
      "Pädatrophie",
      "Säuglingsdystrophie",
      "Tumorkachexie",
      "Wasting disease a.n.k."
    ]
  },
  {
    "code": "R68.0",
    "name": "Hypothermie ohne niedrige Umgebungstemperatur",
    "synonyms": [
      "Hypothermie ohne niedrige Umgebungstemperatur"
    ]
  },
  {
    "code": "R68.1",
    "name": "Unspezifische Allgemeinsymptome im Kleinkindalter",
    "synonyms": [
      "Andauerndes Schreien beim Säugling",
      "Irritabilität beim Kleinkind",
      "Langdauerndes Schreien beim Säugling",
      "Reizbares Kleinkind",
      "Reizbarkeit beim Kleinkind",
      "Schreiendes Kind",
      "Ungewöhnlich häufiges und starkes Schreien des Kleinkindes",
      "Unspezifische Allgemeinsymptome im Kleinkindalter",
      "Übererregtes Kleinkind",
      "Übermäßiges Schreien beim Kleinkind"
    ]
  },
  {
    "code": "R68.2",
    "name": "Mundtrockenheit",
    "synonyms": [
      "Mundtrockenheit",
      "Trockener Mund"
    ]
  },
  {
    "code": "R68.3",
    "name": "Klumpfinger",
    "synonyms": [
      "Digiti hippocratici",
      "Glockenklöppelfinger",
      "Klumpfinger",
      "Kolbenfinger",
      "Spatelfinger [Trommelschlegelfinger]",
      "Trommelschlegelfinger",
      "Uhrglasnägel"
    ]
  },
  {
    "code": "R68.8",
    "name": "Multiorganversagen",
    "synonyms": [
      "Abiotrophie",
      "Abnahme der Tatkraft",
      "Abnormer klinischer Befund a.n.k.",
      "Abulie",
      "Aktive Hyperämie",
      "Akute Hyperämie",
      "Autodigestion",
      "Autointoxikation",
      "Autolyse",
      "Autotoxikose",
      "Blutfülle",
      "Chronische Invalidität",
      "Erschöpfungstoxikose",
      "Frösteln",
      "Fugue",
      "Gebrechlichkeit",
      "Generalisierte Hyperämie",
      "Hemiatrophia",
      "Hemiatrophie",
      "Hyperämie",
      "Invalidität",
      "Invalidität seit Geburt",
      "Körperlicher Verfall",
      "Multiorganversagen",
      "Necrobiosis",
      "Nekrobiose",
      "Nicht klimakterischer Hitzeanfall",
      "Organische Insuffizienz",
      "Passive Hyperämie",
      "Rötung",
      "Schüttelfrost",
      "Selbstverdauung",
      "Selbstvergiftung",
      "Toxikose",
      "Toxikose bei Stasis",
      "Verminderte funktionelle Aktivität",
      "Viszerale Hyperämie"
    ]
  },
  {
    "code": "R69",
    "name": "Unklare Beschwerden",
    "synonyms": [
      "Krankheit",
      "Krankheit unbekannter Ursache",
      "Nichtdiagnostizierte Krankheit",
      "Seltene Krankheit ohne eindeutige Diagnose nach ausgeschöpfter Diagnostik durch ein Zentrum für Seltene Erkrankungen",
      "Unklare Beschwerden"
    ]
  },
  {
    "code": "R70.0",
    "name": "Beschleunigte Blutkörperchensenkungsreaktion",
    "synonyms": [
      "BKS [Blutkörperchensenkungsgeschwindigkeit]-Beschleunigung",
      "BSG [Blutkörperchensenkungsgeschwindigkeit]-Beschleunigung",
      "Beschleunigte Blutkörperchensenkungsreaktion",
      "Rezidivierende BKS [Blutkörperchensenkungsgeschwindigkeit]-Erhöhung",
      "Unklare BKS [Blutkörperchensenkungsgeschwindigkeit]-Erhöhung",
      "Unklare BSG [Blutkörperchensenkungsgeschwindigkeit]-Erhöhung",
      "Unklare Erhöhung der Blutkörperchensenkungsgeschwindigkeit"
    ]
  },
  {
    "code": "R70.1",
    "name": "Veränderung der Plasmaviskosität",
    "synonyms": [
      "Abnorme Plasmaviskosität",
      "Hyperviskositätssyndrom",
      "Polyklonales Hyperviskositätssyndrom",
      "Veränderung der Plasmaviskosität"
    ]
  },
  {
    "code": "R71",
    "name": "Erythrozytenveränderung",
    "synonyms": [
      "Abnorme Erythrozyten",
      "Anisozytose",
      "Erythrozytenveränderung",
      "Pathologisch erhöhter MCV-Wert",
      "Pathologisch verändertes rotes Blutbild",
      "Poikilozytose",
      "Veränderte Erythrozytenmorphologie",
      "Verändertes Erythrozytenvolumen"
    ]
  },
  {
    "code": "R72",
    "name": "Leukozytenveränderung",
    "synonyms": [
      "Abnorme Leukozyten",
      "Abnorme weiße Blutkörperchen a.n.k.",
      "Abnormes Differenzialblutbild",
      "Atypische Lymphozyten",
      "Auffälliges Differenzialblutbild",
      "Erhöhte Leukozytenzahl",
      "Erniedrigte Leukozytenzahl",
      "Leukozytenveränderung",
      "Monozytopenie",
      "Reduzierte CD8-Zellzahl",
      "Verminderte CD4-Lymphozytenzahl"
    ]
  },
  {
    "code": "R73.0",
    "name": "Abnormer Glukosetoleranztest",
    "synonyms": [
      "Abnahme der Glukosetoleranz",
      "Abnormer Glukosetoleranztest",
      "Beeinträchtigte Glukosetoleranz",
      "Erniedrigte Glukosetoleranz",
      "Frühdiabetes",
      "Gestörte Glukosetoleranz",
      "Latenter Diabetes mellitus",
      "Pathologische Glukosetoleranz",
      "Pathologischer Glukosetoleranztest",
      "Prädiabetes",
      "Subklinischer Diabetes mellitus",
      "Verminderte Glukosetoleranz"
    ]
  },
  {
    "code": "R73.9",
    "name": "Erhöhter Blutglukosewert",
    "synonyms": [
      "Erhöhter Blutglukosewert",
      "Erhöhter Blutzucker",
      "Erhöhter Blutzuckerspiegel",
      "Hyperglykämie"
    ]
  },
  {
    "code": "R74.0",
    "name": "Unklare Transaminasenerhöhung",
    "synonyms": [
      "Erhöhung der Alanin-Amino-Transferase [ALAT]",
      "Erhöhung der Aspartat-Amino-Transferase [ASAT]",
      "Erhöhung der Glutamat-Oxalacetat-Transaminase [GOT]",
      "Erhöhung der Glutamat-Pyruvat-Transaminase [GPT]",
      "Erhöhung der Laktatdehydrogenase [LDH]",
      "Leberenzymerhöhung",
      "Unklare Transaminasenerhöhung"
    ]
  },
  {
    "code": "R74.8",
    "name": "Abnormer Blutwert der alkalischen Phosphatase",
    "synonyms": [
      "Abnormer Alanin-Aminotransferase-Wert",
      "Abnormer Amylase-Blutwert",
      "Abnormer Amylase-Serumspiegel",
      "Abnormer Aspartat-Aminotransferase-Wert",
      "Abnormer Blutwert der alkalischen Phosphatase",
      "Abnormer Blutwert der sauren Phosphatase",
      "Abnormer Gamma-Glutamyl-Transferasewert [GGT]",
      "Abnormer Gamma-Glutamyl-Transpeptidasewert [GGT]",
      "Abnormer Leberwert",
      "Abnormer Lipase-Blutwert",
      "Abnormer Lipase-Serumspiegel",
      "Abnormer Pankreasenzym-Serumspiegel",
      "Abnormer Serumspiegel der Kreatinphosphokinase [CPK]",
      "Abnormer Serumspiegel der alkalischen Phosphatase",
      "Abnormer Serumspiegel der sauren Phosphatase",
      "Abnormer Triacylglyzerinlipase-Blutwert",
      "Abnormer Triacylglyzerinlipase-Serumspiegel",
      "Isolierte, asymptomatische Erhöhung der Kreatinphosphokinase",
      "Pathologisch erhöhter Wert der Leucin-Amino-Peptidase"
    ]
  },
  {
    "code": "R74.9",
    "name": "Abnorme Serumenzyme",
    "synonyms": [
      "Abnorme Serumenzyme"
    ]
  },
  {
    "code": "R75",
    "name": "Laborhinweis auf Humanes Immundefizienz-Virus",
    "synonyms": [
      "Laborhinweis auf Humanes Immundefizienz-Virus",
      "Nichteindeutiger HIV-Test beim Kleinkind",
      "Positiver HIV-Test"
    ]
  },
  {
    "code": "R76.0",
    "name": "Antikörpertiteränderung",
    "synonyms": [
      "Anstieg antinukleärer Antikörper [ANA]",
      "Antikörpertiteränderung",
      "Erhöhter Antikörpertiter"
    ]
  },
  {
    "code": "R76.1",
    "name": "Abnormer Mendel-Mantoux-Test",
    "synonyms": [
      "Abnorme Reaktion beim Tuberkulin-Hauttest",
      "Abnormer Befund bei Tuberkulintest",
      "Abnormer Mantoux-Test",
      "Abnormer Mendel-Mantoux-Test",
      "Abnormer Stempeltest auf Tuberkulose",
      "Abnormer Tine-Test",
      "Abnormes Ergebnis der Tuberkulinprobe"
    ]
  },
  {
    "code": "R76.2",
    "name": "Falsch-positiver serologischer Syphilistest",
    "synonyms": [
      "Falsch-positive Wassermann-Reaktion",
      "Falsch-positive serologische Syphilisreaktion",
      "Falsch-positiver VDRL-Test [Venereal diseases research laboratories]",
      "Falsch-positiver serologischer Syphilisbefund",
      "Falsch-positiver serologischer Syphilistest"
    ]
  },
  {
    "code": "R76.8",
    "name": "Erhöhung der Immunglobuline",
    "synonyms": [
      "Erhöhter Immunglobulinwert",
      "Erhöhung der Immunglobuline",
      "Nachweis von Anti-Hirudin-Antikörper",
      "Nachweis von Anti-Thrombozyten-Antikörper",
      "Nachweis von Antikörpern gegen Somatropin",
      "Nachweis von Antikörpern gegen glatte Muskulatur",
      "Nachweis von Antistreptokinase-Antikörper",
      "Nachweis von Insulinantikörpern",
      "Nachweis von antierythrozytären Antikörpern",
      "Nachweis von antimitochondrialen Antikörpern",
      "Nachweis von antineutrophilen zytoplasmatischen Antikörpern gegen Myeloperoxidase",
      "Nachweis von neutralisierenden Anti-Interferon-Antikörpern [NAK]",
      "Positiver Befund auf Schilddrüsen-Antikörper",
      "Positiver Coombs-Test"
    ]
  },
  {
    "code": "R76.9",
    "name": "Abnorme immunologische Serumwerte",
    "synonyms": [
      "Abnorme immunologische Serumwerte"
    ]
  },
  {
    "code": "R77.0",
    "name": "Albuminveränderung",
    "synonyms": [
      "Abnormes Albumin",
      "Albuminveränderung"
    ]
  },
  {
    "code": "R77.1",
    "name": "Globulinveränderung",
    "synonyms": [
      "Abnormes Globulin",
      "Globulinveränderung",
      "Hyperglobulinämie"
    ]
  },
  {
    "code": "R77.2",
    "name": "Veränderung des Alpha-Fetoproteins",
    "synonyms": [
      "Abnormes Alpha-Fetoprotein",
      "Alpha-Fetoprotein-Erhöhung",
      "Angeborener Alpha-Fetoprotein-Mangel",
      "Erniedrigtes Alpha-Fetoprotein",
      "Hereditäre Persistenz des Alpha-Fetoproteins",
      "Pathologisch erhöhter AFP [Alpha-Fetoprotein]-Wert",
      "Pathologisch erniedrigter AFP [Alpha-Fetoprotein]-Wert",
      "Veränderung des Alpha-Fetoproteins"
    ]
  },
  {
    "code": "R77.80",
    "name": "Veränderung des prostataspezifischen Antigens",
    "synonyms": [
      "PSA [prostataspezifisches Antigen]-Veränderung",
      "Veränderung des prostataspezifischen Antigens"
    ]
  },
  {
    "code": "R77.88",
    "name": "Dysproteinämie",
    "synonyms": [
      "Benigne Hyperferritinämie",
      "Dysproteinämie",
      "Erniedrigter Spiegel des insulinartigen Wachstumsfaktor-Bindungsproteins",
      "Hyperproteinämie",
      "Hypoproteinämie",
      "Pathologische Erhöhung von C-reaktivem Protein"
    ]
  },
  {
    "code": "R77.9",
    "name": "Abnormes Plasmaprotein",
    "synonyms": [
      "Abnormes Plasmaprotein"
    ]
  },
  {
    "code": "R78.0",
    "name": "Nachweis von Alkohol im Blut",
    "synonyms": [
      "Nachweis von Alkohol im Blut",
      "Positiver Blutalkohol-Test"
    ]
  },
  {
    "code": "R78.1",
    "name": "Nachweis von Opiaten im Blut",
    "synonyms": [
      "Nachweis von Opiaten im Blut"
    ]
  },
  {
    "code": "R78.2",
    "name": "Nachweis von Kokain im Blut",
    "synonyms": [
      "Nachweis von Kokain im Blut"
    ]
  },
  {
    "code": "R78.3",
    "name": "Nachweis von Halluzinogenen im Blut",
    "synonyms": [
      "Nachweis von Halluzinogenen im Blut"
    ]
  },
  {
    "code": "R78.5",
    "name": "Nachweis von psychotropen Drogen im Blut",
    "synonyms": [
      "Nachweis von psychotropen Drogen im Blut"
    ]
  },
  {
    "code": "R78.6",
    "name": "Nachweis von Steroiden im Blut",
    "synonyms": [
      "Nachweis von Steroiden im Blut"
    ]
  },
  {
    "code": "R78.7",
    "name": "Nachweis von abnormen Schwermetall-Blutwerten",
    "synonyms": [
      "Nachweis von abnormen Schwermetall-Blutwerten"
    ]
  },
  {
    "code": "R78.8",
    "name": "Nachweis eines abnormen Lithium-Blutwertes",
    "synonyms": [
      "Nachweis eines abnormen Lithium-Blutwertes"
    ]
  },
  {
    "code": "R78.9",
    "name": "Nachweis im Blut, einer normalerweise im Blut nicht vorhandenen Substanz",
    "synonyms": [
      "Abnorme Blutbestandteile",
      "Abnormer toxikologischer Befund",
      "Nachweis im Blut, einer normalerweise im Blut nicht vorhandenen Substanz"
    ]
  },
  {
    "code": "R79.0",
    "name": "Abnormer Mineralblutwert a.n.k.",
    "synonyms": [
      "Abnormer Eisen-Blutwert",
      "Abnormer Kobalt-Blutwert",
      "Abnormer Kupfer-Blutwert",
      "Abnormer Magnesium-Blutwert",
      "Abnormer Mineralblutwert a.n.k.",
      "Abnormer Zink-Blutwert",
      "Pathologische Erhöhung des Plasma-Aluminiumspiegels"
    ]
  },
  {
    "code": "R79.8",
    "name": "Verlängerte Blutungszeit",
    "synonyms": [
      "Abnormer Anstieg des Blutspiegels von Glycerol",
      "Abnormer Bilirubinwert",
      "Abnormer Blutgaswert",
      "Abnormer Kreatinin-Serumspiegel",
      "Azetonämie",
      "Azotämie",
      "Erhöhter Ammoniakspiegel",
      "Erhöhter Osteocalcin-Spiegel",
      "Erhöhter Parathormonwert",
      "Erhöhter Triglyzerid-Serumspiegel",
      "Erhöhung des Cholesterols",
      "Erhöhung von Non-Protein-Nitrogen [NPN]",
      "Erniedrigte C-Peptid-Konzentration",
      "Erniedrigter Glutathion-Spiegel",
      "Erniedrigter Hämatokrit",
      "Erniedrigter Hämoglobinwert",
      "Erniedrigter Quickwert",
      "Hyperfibrinogenämie",
      "Hyperlaktatämie",
      "Low-T3 [Trijodthyronin]-Low-T4 [Thyroxin]-Syndrom",
      "Melanämie",
      "Pathologisch erhöhte Serumosmolarität",
      "Pathologisch erhöhter INR-Wert",
      "Pathologischer Anstieg des Myoglobins",
      "Verlängerte Blutung",
      "Verlängerte Blutungszeit",
      "Verlängerte Gerinnung",
      "Verlängerte Gerinnungszeit",
      "Verlängerte Koagulation",
      "Verlängerte Thromboplastinzeit"
    ]
  },
  {
    "code": "R79.9",
    "name": "Abnorme Blutchemie",
    "synonyms": [
      "Abnorme Blutchemie",
      "Abnormer Blutbefund"
    ]
  },
  {
    "code": "R80",
    "name": "Bence-Jones-Proteinurie a.n.k.",
    "synonyms": [
      "Akute Albuminurie",
      "Albuminurie",
      "Albuminverlust",
      "Bence-Jones-Albuminurie a.n.k.",
      "Bence-Jones-Proteinurie a.n.k.",
      "Chronische Albuminurie",
      "Eiweiß im Urin",
      "Eiweißausscheidung im Urin",
      "Isolierte Proteinurie",
      "Leichtkettenproteinurie",
      "Mikroalbuminurie",
      "Protein-Erythrozyturie",
      "Proteinurie",
      "Subakute Albuminurie",
      "Tubuläre Proteinurie"
    ]
  },
  {
    "code": "R81",
    "name": "Glukosurie",
    "synonyms": [
      "Glukosurie",
      "Harnzuckerausscheidung",
      "Zucker im Urin"
    ]
  },
  {
    "code": "R82.0",
    "name": "Chylurie",
    "synonyms": [
      "Chylurie",
      "Chylurie, nicht durch Filarien",
      "Galakturie",
      "Lipurie"
    ]
  },
  {
    "code": "R82.1",
    "name": "Myoglobinurie",
    "synonyms": [
      "Autosomal-dominante Myoglobinurie",
      "Genetisch bedingte rekurrente Myoglobinurie",
      "Myoglobinurie",
      "Myoglobulinurie",
      "Primäre Myoglobinurie",
      "Primäre Myoglobulinurie"
    ]
  },
  {
    "code": "R82.2",
    "name": "Cholurie",
    "synonyms": [
      "Bilirubinurie",
      "Cholurie"
    ]
  },
  {
    "code": "R82.3",
    "name": "Hämoglobinurie",
    "synonyms": [
      "Globinurie",
      "Hämoglobinurie",
      "Methämoglobinurie"
    ]
  },
  {
    "code": "R82.4",
    "name": "Ketonurie",
    "synonyms": [
      "Azetonurie",
      "Ketonurie"
    ]
  },
  {
    "code": "R82.5",
    "name": "Erhöhter Indolessigsäure-Urinwert",
    "synonyms": [
      "Erhöhter 17-Ketosteroid-Urinwert",
      "Erhöhter Indolessigsäure-Urinwert",
      "Erhöhter Katecholamin-Urinwert",
      "Erhöhter Steroid-Urinwert"
    ]
  },
  {
    "code": "R82.6",
    "name": "Abnormer Schwermetall-Urinwert",
    "synonyms": [
      "Abnormer Schwermetall-Urinwert",
      "Abnormer Urinwert für eine nichtmedizinische Substanz"
    ]
  },
  {
    "code": "R82.7",
    "name": "Abnormer mikrobiologischer Urinbefund",
    "synonyms": [
      "Abnormer mikrobiologischer Urinbefund",
      "Positive Kulturen bei Urinuntersuchung"
    ]
  },
  {
    "code": "R82.8",
    "name": "Leukozyturie",
    "synonyms": [
      "Abnormer histologischer Urinbefund",
      "Abnormer zytologischer Urinbefund",
      "Leukozyturie",
      "Mikroleukozyturie"
    ]
  },
  {
    "code": "R82.9",
    "name": "Abnormer Urinbefund",
    "synonyms": [
      "Abnorme Urinbestandteile a.n.k.",
      "Abnormer Urinbefund",
      "Ausscheidung von Kristallen im Harn",
      "Chromaturie",
      "Fäkalurie",
      "Harnsäureauskristallisation",
      "Hyperurikosurie",
      "Hypocitraturie",
      "Kalziurie",
      "Kristallurie",
      "Melanurie",
      "Pathologischer Abfall der Hydroxiprolinausscheidung im Urin",
      "Pathologischer Harnbefund a.n.k.",
      "Pathologischer Urinbefund a.n.k.",
      "Pathologisches Harnsediment",
      "Urikosurie",
      "Urobilinogenurie",
      "Verfärbung des Urins",
      "Zellen im Urin",
      "Zylinder im Urin",
      "Zylindrurie"
    ]
  },
  {
    "code": "R83.0",
    "name": "Abnormer Enzymwert im Liquor",
    "synonyms": [
      "Abnormer Enzymwert im Liquor"
    ]
  },
  {
    "code": "R83.1",
    "name": "Abnormer Hormonwert im Liquor",
    "synonyms": [
      "Abnormer Hormonwert im Liquor"
    ]
  },
  {
    "code": "R83.3",
    "name": "Abnormer Wert im Liquor für Substanzen vorwiegend nichtmedizinischer Herkunft",
    "synonyms": [
      "Abnormer Wert im Liquor für Substanzen vorwiegend nichtmedizinischer Herkunft"
    ]
  },
  {
    "code": "R83.4",
    "name": "Abnormer immunologischer Liquorbefund",
    "synonyms": [
      "Abnormer immunologischer Liquorbefund"
    ]
  },
  {
    "code": "R83.5",
    "name": "Abnormer mikrobiologischer Liquorbefund",
    "synonyms": [
      "Abnormer mikrobiologischer Liquorbefund"
    ]
  },
  {
    "code": "R83.6",
    "name": "Abnormer zytologischer Liquorbefund",
    "synonyms": [
      "Abnormer zytologischer Liquorbefund"
    ]
  },
  {
    "code": "R83.7",
    "name": "Abnormer histologischer Liquorbefund",
    "synonyms": [
      "Abnormer histologischer Liquorbefund"
    ]
  },
  {
    "code": "R83.9",
    "name": "Abnormer Liquorbefund",
    "synonyms": [
      "Abnormer Liquorbefund",
      "Abnormität des Liquor cerebrospinalis"
    ]
  },
  {
    "code": "R84.5",
    "name": "Positive Kultur aus dem Nasensekret",
    "synonyms": [
      "Positive Kultur aus dem Nasensekret",
      "Positive Kultur aus dem Rachen",
      "Positive Kultur aus dem Sputum"
    ]
  },
  {
    "code": "R84.9",
    "name": "Abnormer Befund in der Bronchiallavage",
    "synonyms": [
      "Abnormer Befund im Nasenschleimhautsekret",
      "Abnormer Befund im Rachenabstrich",
      "Abnormer Befund im Sputum",
      "Abnormer Befund in der Bronchiallavage",
      "Abnormer Befund in der Pleuraflüssigkeit"
    ]
  },
  {
    "code": "R85.8",
    "name": "Positiver Haemoccult-Test",
    "synonyms": [
      "Positiver Haemoccult-Test"
    ]
  },
  {
    "code": "R85.9",
    "name": "Abnormer Speichelbefund",
    "synonyms": [
      "Abnormer Befund in der Peritonealflüssigkeit",
      "Abnormer Speichelbefund"
    ]
  },
  {
    "code": "R86.6",
    "name": "Teratospermie",
    "synonyms": [
      "Teratospermie",
      "Teratozoospermie"
    ]
  },
  {
    "code": "R86.9",
    "name": "Asthenospermie",
    "synonyms": [
      "Abnorme Samenflüssigkeit",
      "Abnorme Spermatozoen",
      "Abnormer Befund im Prostatasekret",
      "Abnormer Samen",
      "Abnormer Spermabefund",
      "Abnormes Prostatasekret",
      "Abnormität des Prostatasekrets",
      "Abnormität des Samens",
      "Asthenospermie",
      "Eingeschränkte Spermienmobilität",
      "Reduzierte Spermienmobilität",
      "Veränderte Spermien"
    ]
  },
  {
    "code": "R87.6",
    "name": "Zervixzytologischer Papanicolaou-Abstrich PAP II",
    "synonyms": [
      "Abnormer Befund bei Papanicolaou-Abstrich der Cervix uteri",
      "Abnormer Vaginalbefund",
      "Abnormer Vulvabefund",
      "Abstrich der Cervix uteri mit atypischen Kernen",
      "Suspekter zervixzytologischer Papanicolaou-Befund",
      "Suspekter zytologischer Befund aus weiblichen Genitalorganen",
      "Unspezifischer Papanicolaou-Befund",
      "Zervixabstrich mit atypischen Kernen",
      "Zervixzytologischer Papanicolaou-Abstrich PAP II"
    ]
  },
  {
    "code": "R87.9",
    "name": "Abnormer Befund im Sekret der Cervix uteri",
    "synonyms": [
      "Abnormer Befund im Abstrich der Cervix uteri",
      "Abnormer Befund im Abstrich der Vagina",
      "Abnormer Befund im Abstrich der Vulva",
      "Abnormer Befund im Sekret der Cervix uteri",
      "Abnormer Befund im Sekret der Vagina",
      "Abnormer Befund im Sekret der Vulva",
      "Abnormer Befund in der Vaginalflüssigkeit",
      "Abnormität des Untersuchungsmaterials der Cervix uteri",
      "Abnormität des Untersuchungsmaterials der Vagina",
      "Abnormität des Untersuchungsmaterials der Vulva",
      "Zervixmetaplasie"
    ]
  },
  {
    "code": "R89.1",
    "name": "Abnormer Hormonwert",
    "synonyms": [
      "Abnormer Hormonwert"
    ]
  },
  {
    "code": "R89.4",
    "name": "Abnormer immunologischer Befund",
    "synonyms": [
      "Abnormer immunologischer Befund"
    ]
  },
  {
    "code": "R89.5",
    "name": "Abnormer mikrobiologischer Befund",
    "synonyms": [
      "Abnormer mikrobiologischer Befund",
      "Positive Kultur aus einer Wunde"
    ]
  },
  {
    "code": "R89.6",
    "name": "Abnormer zytologischer Befund",
    "synonyms": [
      "Abnormer zytologischer Befund"
    ]
  },
  {
    "code": "R89.7",
    "name": "Abnormer histologischer Befund a.n.k.",
    "synonyms": [
      "Abnormer histologischer Befund a.n.k.",
      "Kalkhaltiges Infiltrat a.n.k.",
      "Kalkige Degeneration a.n.k.",
      "Kalziumsalzinfiltration",
      "Mallory-Körperchen"
    ]
  },
  {
    "code": "R89.8",
    "name": "Abnormer Chromosomenbefund",
    "synonyms": [
      "Abnormer Chromosomenbefund",
      "Abnormer Karyotyp"
    ]
  },
  {
    "code": "R89.9",
    "name": "Abnormer Befund",
    "synonyms": [
      "Abnormer Befund",
      "Abnormer Befund im Wundsekret",
      "Abnormer Befund in der Amnionflüssigkeit",
      "Abnormer Befund in der Brustwarzenabsonderung",
      "Abnormer Befund in der Gelenkflüssigkeit",
      "Abnormer Befund in der Synovialflüssigkeit"
    ]
  },
  {
    "code": "R90.0",
    "name": "Intrakranielle Raumforderung",
    "synonyms": [
      "Intrakranielle Raumforderung",
      "Schädigung durch intrakranielle Raumforderung a.n.k."
    ]
  },
  {
    "code": "R90.8",
    "name": "Abnormes Echoenzephalogramm",
    "synonyms": [
      "Abnormes Echoenzephalogramm",
      "Abnormität des Zentralnervensystems bei bildgebender Diagnostik a.n.k.",
      "Krankheit der weißen Substanz",
      "White matter disease"
    ]
  },
  {
    "code": "R91",
    "name": "Lungenrundherd",
    "synonyms": [
      "Abnormität der Lunge bei bildgebender Diagnostik",
      "Abnormität eines Lungenfelds bei bildgebender Diagnostik",
      "Lungenrundherd",
      "Lungenschatten",
      "Raumforderung in der Lunge"
    ]
  },
  {
    "code": "R92",
    "name": "Abnormer mammasonographischer Verdichtungsbezirk",
    "synonyms": [
      "Abnormer CT [Computertomographie]-Befund der Mamma",
      "Abnormer Mammasonographiebefund",
      "Abnormer Mammathermographiebefund",
      "Abnormer Mammographiebefund",
      "Abnormer mammasonographischer Verdichtungsbezirk",
      "Abnormer mammathermographischer Verdichtungsbezirk",
      "Abnormer mammographischer Verdichtungsbezirk",
      "Abnormität der Mamma bei bildgebender Diagnostik",
      "Mammakalkherd",
      "Mikrokalkherd der Mamma",
      "Präpathologischer Mammographiebefund",
      "Raumforderung in der Brustdrüse",
      "Suspekter Mammographiebefund"
    ]
  },
  {
    "code": "R93.0",
    "name": "Abnormität des Kopfes bei bildgebender Diagnostik",
    "synonyms": [
      "Abnormität des Kopfes bei bildgebender Diagnostik",
      "Abnormität des Schädels bei bildgebender Diagnostik"
    ]
  },
  {
    "code": "R93.1",
    "name": "Abnormer Herzschatten",
    "synonyms": [
      "Abnormer Herzschatten",
      "Abnormes Echokardiogramm",
      "Abnormität des Herzens bei bildgebender Diagnostik",
      "Abnormität des Koronarkreislaufs bei bildgebender Diagnostik",
      "Ventrikuläre Hypokinesie"
    ]
  },
  {
    "code": "R93.2",
    "name": "Pathologischer Sonographiebefund der Leber",
    "synonyms": [
      "Abnormität der Leber bei bildgebender Diagnostik",
      "Abnormität des Gallensystems bei bildgebender Diagnostik",
      "Nichtdarstellung der Gallenblase",
      "Nichtdarstellung der Gallenblase bei bildgebender Diagnostik",
      "Pathologischer Sonographiebefund der Gallenwege",
      "Pathologischer Sonographiebefund der Leber"
    ]
  },
  {
    "code": "R93.3",
    "name": "Pathologischer Sonographiebefund des Verdauungstraktes",
    "synonyms": [
      "Abnormer Röntgenbefund des Darmes",
      "Abnormität des Gastrointestinaltraktes bei bildgebender Diagnostik",
      "Abnormität des Magen-Darm-Kanals bei bildgebender Diagnostik",
      "Abnormität des Verdauungstraktes bei bildgebender Diagnostik a.n.k.",
      "Pathologischer Sonographiebefund des Verdauungstraktes"
    ]
  },
  {
    "code": "R93.4",
    "name": "Pathologischer Sonographiebefund der Harnorgane",
    "synonyms": [
      "Abnormität der Harnorgane bei bildgebender Diagnostik",
      "Harnblasenfüllungsdefekt",
      "Harnleiterfüllungsdefekt",
      "Nierenfüllungsdefekt",
      "Pathologischer Sonographiebefund der Harnorgane",
      "Ureterfüllungsdefekt"
    ]
  },
  {
    "code": "R93.5",
    "name": "Auffälliger Kolposkopiebefund",
    "synonyms": [
      "Abnormer CT [Computertomographie]-Befund des Abdomens",
      "Abnormer Sonographiebefund des Abdomens",
      "Abnormer Sonographiebefund des Beckens",
      "Abnormität des Abdomens bei bildgebender Diagnostik a.n.k.",
      "Abnormität des Retroperitoneums bei bildgebender Diagnostik",
      "Auffälliger Kolposkopiebefund",
      "Endometriumverdickung"
    ]
  },
  {
    "code": "R93.6",
    "name": "Abnormität der Extremitäten bei bildgebender Diagnostik",
    "synonyms": [
      "Abnormität der Extremitäten bei bildgebender Diagnostik",
      "Abnormität der Gliedmaßen bei bildgebender Diagnostik"
    ]
  },
  {
    "code": "R93.7",
    "name": "Abnormität des Muskel-Skelett-Systems bei bildgebender Diagnostik a.n.k.",
    "synonyms": [
      "Abnormität des Muskel-Skelett-Systems bei bildgebender Diagnostik a.n.k."
    ]
  },
  {
    "code": "R93.8",
    "name": "Erythroplakie der Portio",
    "synonyms": [
      "Abnormer radiologischer Befund der Haut",
      "Abnormer radiologischer Befund des Unterhautgewebes",
      "Abnormität der intrathorakalen Organe bei bildgebender Diagnostik a.n.k.",
      "Abnormität des Hautgewebes bei bildgebender Diagnostik",
      "Abnormität des Unterhautgewebes bei bildgebender Diagnostik",
      "Abnormität des Urogenitaltraktes bei bildgebender Diagnostik",
      "Erythroplakie der Portio",
      "Mediastinumverlagerung",
      "Mittelfellverlagerung",
      "Mosaik der Portio"
    ]
  },
  {
    "code": "R94.0",
    "name": "Abnormes Elektroenzephalogramm",
    "synonyms": [
      "Abnormes Elektroenzephalogramm",
      "Abnormes Funktionsprüfungsergebnis des Gehirns",
      "Abnormes Funktionsprüfungsergebnis des Zentralnervensystems"
    ]
  },
  {
    "code": "R94.1",
    "name": "Pathologisches Funktionsprüfungsergebnis der Sinnesorgane",
    "synonyms": [
      "Abnorme Reaktion auf Nervenstimulation",
      "Abnorme kalorische Nystagmus-Prüfung",
      "Abnorme visuell evozierte Potentiale [VEP]",
      "Abnormes Elektromyogramm [EMG]",
      "Abnormes Elektrookulogramm [EOG]",
      "Abnormes Elektroretinogramm [ERG]",
      "Abnormes Funktionsprüfungsergebnis der Sinnesorgane",
      "Abnormes Funktionsprüfungsergebnis des peripheren Nervensystems",
      "Pathologische VEP [Visuell evozierte Potentiale]",
      "Pathologische visuell evozierte Potentiale [VEP]",
      "Pathologisches EOG [Elektrookulogramm]",
      "Pathologisches ERG [Elektroretinogramm]",
      "Pathologisches Funktionsprüfungsergebnis der Sinnesorgane",
      "Pathologisches Funktionsprüfungsergebnis des peripheren Nervensystems"
    ]
  },
  {
    "code": "R94.2",
    "name": "Obstruktive Ventilationsstörung",
    "synonyms": [
      "Abnormer Lungenfunktionsbefund",
      "Abnormes Funktionsprüfungsergebnis der Lunge",
      "Bronchiale Hyperreagibilität [Übererregbarkeit]",
      "Bronchiale Übererregbarkeit",
      "Hyperreaktives Bronchialsystem",
      "Obstruktive Ventilationsstörung",
      "Restriktive Ventilationsstörung",
      "Verminderte Atemreserve",
      "Verminderte Ventilation",
      "Verminderte Vitalkapazität"
    ]
  },
  {
    "code": "R94.3",
    "name": "Abnormes Elektrokardiogramm",
    "synonyms": [
      "Abnorme intrakardiale elektrophysiologische Untersuchung",
      "Abnormes Elektrokardiogramm",
      "Abnormes Funktionsprüfungsergebnis des Kreislaufsystems",
      "Abnormes Phonokardiogramm [PKG]",
      "Abnormes Vektorkardiogramm [VKG]",
      "Pathologische Erhöhung des linksventrikulären enddiastolischen Druckes",
      "Verlängertes QT-Intervall",
      "Verlängerung des QRS-Komplexes"
    ]
  },
  {
    "code": "R94.4",
    "name": "Abnormes Funktionsprüfungsergebnis der Niere",
    "synonyms": [
      "Abnormer Befund bei Nierenfunktionstest",
      "Abnormes Funktionsprüfungsergebnis der Niere",
      "Verminderung der Kreatinin-Clearance"
    ]
  },
  {
    "code": "R94.5",
    "name": "Abnormes Funktionsprüfungsergebnis der Leber",
    "synonyms": [
      "Abnormes Funktionsprüfungsergebnis der Leber"
    ]
  },
  {
    "code": "R94.6",
    "name": "Abnormes Funktionsprüfungsergebnis der Schilddrüse",
    "synonyms": [
      "Abnormes Funktionsprüfungsergebnis der Schilddrüse"
    ]
  },
  {
    "code": "R94.7",
    "name": "Abnormes endokrines Funktionsprüfungsergebnis",
    "synonyms": [
      "Abnormes endokrines Funktionsprüfungsergebnis"
    ]
  },
  {
    "code": "R94.8",
    "name": "Erhöhter Grundumsatz",
    "synonyms": [
      "Abnormer Grundumsatz",
      "Abnormes Ergebnis eines Harnblasenfunktionstests",
      "Abnormes Ergebnis eines Milzfunktionstests",
      "Abnormes Funktionsprüfungsergebnis der Harnblase",
      "Abnormes Funktionsprüfungsergebnis der Milz",
      "Erhöhter Grundumsatz",
      "Niedriger Grundumsatz"
    ]
  },
  {
    "code": "R95.0",
    "name": "Plötzlicher Kindstod vor Vollendung des ersten Lebensjahres, mit Obduktion",
    "synonyms": [
      "Plötzlicher Kindstod vor Vollendung des ersten Lebensjahres, mit Obduktion"
    ]
  },
  {
    "code": "R95.9",
    "name": "Syndrom des plötzlichen Todes im Säuglingsalter",
    "synonyms": [
      "Kindstod, vor Vollendung des ersten Lebensjahres",
      "Krippentod, vor Vollendung des ersten Lebensjahres",
      "Plötzlicher Kindstod, vor Vollendung des ersten Lebensjahres",
      "Plötzlicher ungeklärter Tod, vor Vollendung des ersten Lebensjahres",
      "SIDS [Sudden infant death syndrome], vor Vollendung des ersten Lebensjahres",
      "Sudden infant death syndrome, vor Vollendung des ersten Lebensjahres",
      "Syndrom des plötzlichen Kindstodes, vor Vollendung des ersten Lebensjahres",
      "Syndrom des plötzlichen Todes im Säuglingsalter"
    ]
  },
  {
    "code": "R96.0",
    "name": "Plötzlich eingetretener Tod",
    "synonyms": [
      "Augenblicklicher Tod",
      "Augenblicklicher Tod durch Synkope",
      "Fatale Synkope unbekannter Ursache",
      "Kindstod, nach Vollendung des ersten Lebensjahres",
      "Krippentod, nach Vollendung des ersten Lebensjahres",
      "Plötzlich eingetretener Tod",
      "Plötzlicher Exitus",
      "Plötzlicher Kindstod, nach Vollendung des ersten Lebensjahres",
      "Plötzlicher Tod",
      "Plötzlicher Tod unbekannter Ursache",
      "Plötzlicher ungeklärter Tod beim Erwachsenen",
      "Plötzlicher ungeklärter Tod, nach Vollendung des ersten Lebensjahres",
      "SADS [Sudden Adult Death Syndrome]",
      "SIDS [Sudden infant death syndrome], nach Vollendung des ersten Lebensjahres",
      "Sudden infant death syndrome, nach Vollendung des ersten Lebensjahres",
      "Syndrom des plötzlichen Kindstodes, nach Vollendung des ersten Lebensjahres"
    ]
  },
  {
    "code": "R96.1",
    "name": "Exitus innerhalb 24 Stunden nach Beginn der Symptome",
    "synonyms": [
      "Exitus innerhalb 24 Stunden nach Beginn der Symptome",
      "Tod innerhalb von 24 Stunden nach Symptombeginn",
      "Tod ohne Anzeichen einer Krankheit",
      "Tod, der nachweislich weder gewaltsam noch plötzlich eintrat und dessen Ursache nicht festgestellt werden kann"
    ]
  },
  {
    "code": "R98",
    "name": "Tod, nicht in Anwesenheit anderer Personen",
    "synonyms": [
      "Aufgefundene Leiche",
      "Aufgefundene Leiche, Todesursache unbekannt",
      "Aufgefundener Toter",
      "Aufgefundener Toter, Todesursache unbekannt",
      "Tod ohne Anwesenheit anderer Personen",
      "Tod unbekannter Ursache ohne ärztliche Behandlung",
      "Tod, nicht in Anwesenheit anderer Personen",
      "Unbeobachteter Tod unbekannter Ursache"
    ]
  },
  {
    "code": "R99",
    "name": "Ungenaue Todesursache",
    "synonyms": [
      "Hirntod",
      "Sterbefall",
      "Tod",
      "Tod unbekannter Ursache",
      "Unbekannte Todesursache",
      "Ungenaue Todesursache",
      "Zerebraler Tod"
    ]
  },
  {
    "code": "S00.00",
    "name": "Oberflächliche Verletzung des behaarten Kopfes",
    "synonyms": [
      "Oberflächliche Verletzung der Regio occipitalis",
      "Oberflächliche Verletzung der Regio parietalis",
      "Oberflächliche Verletzung des behaarten Kopfes"
    ]
  },
  {
    "code": "S00.05",
    "name": "Kopfschwartenhämatom",
    "synonyms": [
      "Galeablutung",
      "Galeahämatom",
      "Kopfschwartenblutung",
      "Kopfschwartenhämatom",
      "Prellung der Hinterhauptgegend",
      "Prellung der Regio parietalis",
      "Prellung der Schädelkalotte",
      "Prellung der behaarten Kopfhaut",
      "Subgaleale Prellung",
      "Subgaleales Hämatom"
    ]
  },
  {
    "code": "S00.1",
    "name": "Prellung der Periokularregion",
    "synonyms": [
      "Augenbrauenprellung",
      "Augenlidprellung",
      "Augenwinkelprellung",
      "Blaues Auge",
      "Brillenhämatom",
      "Lidhämatom",
      "Lidprellung",
      "Lidquetschung",
      "Monokelhämatom",
      "Oberflächliche Augenbrauenverletzung",
      "Prellung der Periokularregion",
      "Prellung des Periokularbezirks",
      "Traumatische Ekchymose des Augenlids"
    ]
  },
  {
    "code": "S00.20",
    "name": "Oberflächliche Verletzung der Orbita",
    "synonyms": [
      "Oberflächliche Augenlidverletzung",
      "Oberflächliche Augenwinkelverletzung",
      "Oberflächliche Verletzung der Augenhöhlengegend",
      "Oberflächliche Verletzung der Orbita",
      "Oberflächliche Verletzung der Orbitaregion",
      "Oberflächliche Verletzung der Periokularregion",
      "Oberflächliche Verletzung der Regio orbitalis",
      "Oberflächliche Verletzung des Lids"
    ]
  },
  {
    "code": "S00.23",
    "name": "Insektenstich des Lids",
    "synonyms": [
      "Insektenstich des Lids"
    ]
  },
  {
    "code": "S00.24",
    "name": "Lidfremdkörper",
    "synonyms": [
      "Lidfremdkörper"
    ]
  },
  {
    "code": "S00.30",
    "name": "Oberflächliche Verletzung der Nase",
    "synonyms": [
      "Oberflächliche Verletzung der Nase"
    ]
  },
  {
    "code": "S00.35",
    "name": "Nasenbeinprellung",
    "synonyms": [
      "Nasenbeinprellung",
      "Nasenprellung"
    ]
  },
  {
    "code": "S00.40",
    "name": "Oberflächliche Verletzung des Ohres",
    "synonyms": [
      "Oberflächliche Gehörgangsverletzung",
      "Oberflächliche Trommelfellverletzung",
      "Oberflächliche Verletzung des Ohres"
    ]
  },
  {
    "code": "S00.48",
    "name": "Traumatisches Auriculahämatom",
    "synonyms": [
      "Traumatisches Auriculahämatom"
    ]
  },
  {
    "code": "S00.50",
    "name": "Oberflächliche Verletzung der Lippe",
    "synonyms": [
      "Oberflächliche Verletzung der Lippe",
      "Oberflächliche Verletzung der Mundhöhle",
      "Oberflächliche Verletzung der Uvula",
      "Oberflächliche Verletzung der Zunge",
      "Oberflächliche Verletzung der inneren Wange",
      "Oberflächliche Verletzung des Alveolarfortsatzes",
      "Oberflächliche Verletzung des Gaumens",
      "Oberflächliche Verletzung eines Zahns",
      "Oberflächliche Wunde im Mund",
      "Oberflächliche Zahnfleischverletzung"
    ]
  },
  {
    "code": "S00.7",
    "name": "Multiple oberflächliche Verletzungen des Kopfes",
    "synonyms": [
      "Multiple oberflächliche Verletzungen des Kopfes"
    ]
  },
  {
    "code": "S00.80",
    "name": "Oberflächliche Gesichtsverletzung",
    "synonyms": [
      "Oberflächliche Gesichtsverletzung",
      "Oberflächliche Kieferverletzung",
      "Oberflächliche Kinnverletzung",
      "Oberflächliche Schläfenverletzung",
      "Oberflächliche Stirnverletzung",
      "Oberflächliche Verletzung der Regio temporalis",
      "Oberflächliche Verletzung der Wangenregion",
      "Oberflächliche Wangenverletzung",
      "Oberflächliche Warzenfortsatzverletzung",
      "Oberflächliche submaxilläre Verletzung",
      "Oberflächliche submentale Verletzung",
      "Oberflächliche supraorbitale Verletzung"
    ]
  },
  {
    "code": "S00.85",
    "name": "Gesichtsprellung",
    "synonyms": [
      "Gesichtsprellung",
      "Prellung der Schläfengegend",
      "Schläfenprellung",
      "Stirnprellung",
      "Supraorbitale Prellung"
    ]
  },
  {
    "code": "S00.90",
    "name": "Oberflächliche Kopfverletzung",
    "synonyms": [
      "Oberflächliche Kopfverletzung"
    ]
  },
  {
    "code": "S00.91",
    "name": "Kopfschürfwunde",
    "synonyms": [
      "Kopfschürfwunde"
    ]
  },
  {
    "code": "S00.95",
    "name": "Schädelprellung",
    "synonyms": [
      "Contusio capitis",
      "Kopfprellung",
      "Schädelprellung"
    ]
  },
  {
    "code": "S01.0",
    "name": "Offene Wunde des behaarten Kopfes",
    "synonyms": [
      "Offene Augenbrauenwunde",
      "Offene Wunde des behaarten Kopfes"
    ]
  },
  {
    "code": "S01.1",
    "name": "Offene Lidwunde mit Tränenwegverletzung",
    "synonyms": [
      "Augenlidlazeration",
      "Augenlidzerreißung",
      "Lazeration eines Augenanhangsgebildes a.n.k.",
      "Lidavulsion",
      "Lidlazeration",
      "Lidwunde",
      "Offene Lidwunde",
      "Offene Lidwunde mit Tränenwegverletzung",
      "Offene Wunde der Periokularregion",
      "Offene Wunde der Periorbitalregion",
      "Offene Wunde des Augenlids",
      "Offene Wunde des Augenwinkels",
      "Offene Wunde des Augenwinkels mit Zerreißung des Augenwinkels",
      "Offene Wunde des Canaliculus lacrimalis",
      "Offene Wunde des Canaliculus lacrimalis mit Wunde des Augenlids",
      "Offene Wunde des Tränenganges mit Wunde des Augenlids",
      "Offene perforierende Lidwunde"
    ]
  },
  {
    "code": "S01.20",
    "name": "Offene Nasenwunde",
    "synonyms": [
      "Offene Nasenwunde"
    ]
  },
  {
    "code": "S01.30",
    "name": "Offene Ohrwunde",
    "synonyms": [
      "Offene Ohrwunde"
    ]
  },
  {
    "code": "S01.31",
    "name": "Offene Ohrmuschelwunde",
    "synonyms": [
      "Offene Ohrmuschelwunde"
    ]
  },
  {
    "code": "S01.34",
    "name": "Offene Wunde des äußeren Gehörganges",
    "synonyms": [
      "Offene Wunde des äußeren Gehörganges"
    ]
  },
  {
    "code": "S01.38",
    "name": "Offene Wunde der Kochlea",
    "synonyms": [
      "Offene Wunde am Innenohr",
      "Offene Wunde der Kochlea"
    ]
  },
  {
    "code": "S01.41",
    "name": "Offene Wangenwunde",
    "synonyms": [
      "Offene Wangenwunde",
      "Offene Wunde der Wangenregion"
    ]
  },
  {
    "code": "S01.49",
    "name": "Offene Wunde der Temporomandibularregion",
    "synonyms": [
      "Offene Wunde der Temporomandibularregion"
    ]
  },
  {
    "code": "S01.50",
    "name": "Offene Wunde der Mundhöhle",
    "synonyms": [
      "Offene Mundwunde",
      "Offene Wunde der Mundhöhle"
    ]
  },
  {
    "code": "S01.51",
    "name": "Offene Lippenwunde",
    "synonyms": [
      "Lippenplatzwunde",
      "Offene Lippenwunde"
    ]
  },
  {
    "code": "S01.52",
    "name": "Offene Wunde der inneren Wange",
    "synonyms": [
      "Offene Wunde der inneren Wange"
    ]
  },
  {
    "code": "S01.53",
    "name": "Offene Zahnfleischwunde",
    "synonyms": [
      "Offene Zahnfleischwunde"
    ]
  },
  {
    "code": "S01.54",
    "name": "Frenulum-linguae-Einriss",
    "synonyms": [
      "Frenulum-linguae-Abriss",
      "Frenulum-linguae-Einriss",
      "Frenulum-linguae-Riss",
      "Frenulum-linguae-Ruptur",
      "Offene Zungenwunde"
    ]
  },
  {
    "code": "S01.55",
    "name": "Offene Uvulawunde",
    "synonyms": [
      "Offene Gaumenwunde",
      "Offene Uvulawunde"
    ]
  },
  {
    "code": "S01.59",
    "name": "Offene Speicheldrüsenwunde",
    "synonyms": [
      "Offene Speicheldrüsenwunde",
      "Offene Wunde im Bereich des Alveolarfortsatzes"
    ]
  },
  {
    "code": "S01.7",
    "name": "Multiple offene Wunden des Kopfes",
    "synonyms": [
      "Multiple offene Wunden des Kopfes"
    ]
  },
  {
    "code": "S01.80",
    "name": "Weichteilverletzung des Gesichts",
    "synonyms": [
      "Offene Gesichtswunde a.n.k.",
      "Offene Kinnwunde",
      "Offene Nasopharynxwunde",
      "Offene Schläfenwunde",
      "Offene Schädelwunde",
      "Offene Stirnwunde",
      "Offene Wunde der Schläfengegend",
      "Offene Wunde der Submaxillarregion",
      "Offene Wunde der Submentalgegend",
      "Offene Wunde der Warzenfortsatzgegend",
      "Offene Wunde in der Kieferregion",
      "Weichteilverletzung des Gesichts"
    ]
  },
  {
    "code": "S01.9",
    "name": "Große Weichteilverletzung des Kopfes",
    "synonyms": [
      "Große Weichteilverletzung des Kopfes",
      "Kopfplatzwunde",
      "Offene Kopfverletzung",
      "Offene Kopfwunde"
    ]
  },
  {
    "code": "S02.0",
    "name": "Kalottenfraktur",
    "synonyms": [
      "Fraktur der Pars squamosa des Os temporale",
      "Fraktur des Os frontale",
      "Fraktur des Os parietale",
      "Kalottenfraktur",
      "Kalottentrümmerfraktur",
      "Scheitelbeinfraktur",
      "Schädeldachbruch",
      "Schädeldachfraktur",
      "Schädelkalottenbruch",
      "Schädelkalottenfraktur",
      "Stirnbeinfraktur",
      "Stirnhöhlenwandbruch",
      "Stirnhöhlenwandfraktur",
      "Teevanfraktur",
      "Vertexfraktur"
    ]
  },
  {
    "code": "S02.1",
    "name": "Orbitadachfraktur",
    "synonyms": [
      "Ambossfraktur",
      "Felsenbeinabsprengung",
      "Felsenbeinbruch",
      "Felsenbeinfraktur",
      "Felsenbeinlängsbruch",
      "Felsenbeinlängsfraktur",
      "Felsenbeinquerbruch",
      "Felsenbeinquerfraktur",
      "Fraktur der Fossa cranii anterior",
      "Fraktur der Fossa cranii media",
      "Fraktur der Fossa cranii posterior",
      "Fraktur der hinteren Schädelgrube",
      "Fraktur der mittleren Schädelgrube",
      "Fraktur der vorderen Schädelgrube",
      "Fraktur des Augenhöhlendaches",
      "Fraktur des Os occipitale",
      "Fraktur des Os sphenoidale",
      "Fraktur des Os temporale",
      "Fraktur des Os temporale, ausgenommen Pars squamosa",
      "Fraktur des Sinus ethmoidalis",
      "Fraktur des Sinus frontalis",
      "Fraktur des Sinus sphenoidalis",
      "Fraktur des knöchernen Gehörganges",
      "Fraktur des knöchernen Labyrinths",
      "Hinterhauptbeinfraktur",
      "Keilbeinfraktur",
      "Multiple Schädelbasisfrakturen",
      "Orbitadachfraktur",
      "Schläfenbeinfraktur",
      "Schädelbasisbruch",
      "Schädelbasisfissur",
      "Schädelbasisfraktur",
      "Schädelbasisringbruch",
      "Schädelbasisringfraktur",
      "Schädelbasisscharnierbruch",
      "Schädelbasisscharnierfraktur",
      "Siebbeinfraktur"
    ]
  },
  {
    "code": "S02.2",
    "name": "Nasenbeinfraktur",
    "synonyms": [
      "Geschlossene Nasenbeinfraktur",
      "Nasenbeinbruch",
      "Nasenbeinfraktur",
      "Nasenfraktur",
      "Pflugscharbeinfraktur",
      "Vomerfraktur"
    ]
  },
  {
    "code": "S02.3",
    "name": "Blow-out-Fraktur",
    "synonyms": [
      "Augenhöhlenbodenfraktur",
      "Blow-out-Fraktur",
      "Orbitabodenfraktur"
    ]
  },
  {
    "code": "S02.41",
    "name": "Jochbogenfraktur",
    "synonyms": [
      "Fraktur des Arcus zygomaticus des Jochbeins",
      "Jochbogenbruch",
      "Jochbogenfraktur"
    ]
  },
  {
    "code": "S02.42",
    "name": "Jochbeinimpressionsbruch",
    "synonyms": [
      "Fraktur des Os zygomaticum",
      "Jochbeinbruch",
      "Jochbeinfraktur",
      "Jochbeinimpressionsbruch",
      "Jochbeinimpressionsfraktur"
    ]
  },
  {
    "code": "S02.43",
    "name": "Alveolarfortsatzfraktur des Oberkiefers",
    "synonyms": [
      "Alveolarfortsatzfraktur des Oberkiefers",
      "Fraktur des Pars alveolaris des Oberkiefers"
    ]
  },
  {
    "code": "S02.48",
    "name": "Oberkieferfraktur",
    "synonyms": [
      "Fraktur des Tuber maxillae",
      "Le-Fort-I-Fraktur",
      "Maxillabruch",
      "Maxillafraktur",
      "Oberkiefer-Le-Fort-I-Fraktur",
      "Oberkieferbruch",
      "Oberkieferfraktur",
      "Oberkieferknochenfraktur"
    ]
  },
  {
    "code": "S02.49",
    "name": "Oberkiefer-Le-Fort-III-Fraktur",
    "synonyms": [
      "Backenknochenfraktur",
      "Jochbeinfraktur und Oberkieferfraktur",
      "Le-Fort-II-Fraktur",
      "Le-Fort-III-Fraktur",
      "Oberkiefer-Le-Fort-II-Fraktur",
      "Oberkiefer-Le-Fort-III-Fraktur"
    ]
  },
  {
    "code": "S02.5",
    "name": "Zahnfraktur",
    "synonyms": [
      "Gebrochener Zahn",
      "Zahnfraktur",
      "Zahnwurzelfraktur"
    ]
  },
  {
    "code": "S02.60",
    "name": "Kieferfraktur",
    "synonyms": [
      "Geschlossene Unterkieferfraktur",
      "Kieferfraktur",
      "Mandibulabruch",
      "Mandibulafraktur",
      "Unterkieferbruch",
      "Unterkieferfraktur"
    ]
  },
  {
    "code": "S02.61",
    "name": "Kollumfraktur (Processus condylaris mandibulae)",
    "synonyms": [
      "Fraktur des Caput mandibulae",
      "Fraktur des Processus condylaris mandibulae",
      "Kollumfraktur (Processus condylaris mandibulae)",
      "Kollumfraktur des Unterkiefers (Processus condylaris mandibulae)"
    ]
  },
  {
    "code": "S02.62",
    "name": "Subkondyläre Unterkieferfraktur",
    "synonyms": [
      "Subkondyläre Unterkieferfraktur"
    ]
  },
  {
    "code": "S02.63",
    "name": "Kiefergelenkfortsatzfraktur",
    "synonyms": [
      "Fraktur des Processus coronoideus mandibulae",
      "Kiefergelenkbruch",
      "Kiefergelenkfortsatzbruch",
      "Kiefergelenkfortsatzfraktur",
      "Kiefergelenkfraktur"
    ]
  },
  {
    "code": "S02.64",
    "name": "Ramusfraktur",
    "synonyms": [
      "Fraktur des Ramus mandibulae",
      "Ramusfraktur"
    ]
  },
  {
    "code": "S02.65",
    "name": "Kieferwinkelfraktur",
    "synonyms": [
      "Kieferwinkelfraktur"
    ]
  },
  {
    "code": "S02.66",
    "name": "Fraktur der Symphysis mandibulae",
    "synonyms": [
      "Fraktur der Symphysis mandibulae"
    ]
  },
  {
    "code": "S02.67",
    "name": "Alveolarfortsatzfraktur des Unterkiefers",
    "synonyms": [
      "Alveolarfortsatzfraktur des Unterkiefers",
      "Unterkieferfraktur des Pars alveolaris"
    ]
  },
  {
    "code": "S02.7",
    "name": "Panfaziale Fraktur",
    "synonyms": [
      "Gesichts- und Schädelfraktur",
      "Gesichtsknochenfraktur mit Schädelknochenfraktur",
      "Gesichtsknochenfraktur mit multipler Schädelknochenfraktur",
      "Mittelgesichtsfraktur",
      "Mittelgesichtstrümmerbruch",
      "Mittelgesichtstrümmerfraktur",
      "Multiple Gesichtsknochenfrakturen",
      "Multiple Kopffrakturen",
      "Multiple Mittelgesichtsfrakturen",
      "Multiple Schädelfakturen",
      "Nasoethmoidale Fraktur",
      "Panfaziale Fraktur",
      "Schädeltrümmerbruch",
      "Schädeltrümmerfraktur"
    ]
  },
  {
    "code": "S02.8",
    "name": "Orbitafraktur",
    "synonyms": [
      "Alveolarfortsatzfraktur",
      "Augenhöhlenfraktur",
      "Gaumenfraktur",
      "Orbitafraktur"
    ]
  },
  {
    "code": "S02.9",
    "name": "Schädelfraktur",
    "synonyms": [
      "Fraktur der Gesichtsknochen",
      "Gesichtsfraktur",
      "Gesichtsschädelbruch",
      "Gesichtsschädelfraktur",
      "Schädelberstungsfraktur",
      "Schädelbruch",
      "Schädelfraktur"
    ]
  },
  {
    "code": "S03.0",
    "name": "Temporomandibuläre Luxation",
    "synonyms": [
      "Dislokation des Temporomandibulargelenks",
      "Kieferdiskusluxation",
      "Kieferdislokation",
      "Kiefergelenkluxation",
      "Kieferknorpelluxation",
      "Kieferluxation",
      "Mandibuladislokation",
      "Temporomandibuläre Luxation",
      "Unterkieferdislokation"
    ]
  },
  {
    "code": "S03.1",
    "name": "Luxation des knorpeligen Nasenseptums",
    "synonyms": [
      "Dislokation des Septumknorpels der Nase",
      "Luxation des knorpeligen Nasenseptums"
    ]
  },
  {
    "code": "S03.2",
    "name": "Zahnluxation",
    "synonyms": [
      "Zahnabriss",
      "Zahndislokation",
      "Zahnluxation"
    ]
  },
  {
    "code": "S03.3",
    "name": "Dislokation von Teilen des Kopfes a.n.k.",
    "synonyms": [
      "Dislokation von Teilen des Kopfes a.n.k.",
      "Kopfluxation"
    ]
  },
  {
    "code": "S03.4",
    "name": "Mandibuladistorsion",
    "synonyms": [
      "Distorsion des Kiefergelenks",
      "Kieferdistorsion",
      "Kiefergelenkverstauchung",
      "Kiefergelenkzerrung",
      "Mandibuladistorsion",
      "Temporomandibuläre Distorsion",
      "Unterkieferdistorsion",
      "Verstauchung eines Kieferbandes",
      "Zerrung eines Kieferbandes"
    ]
  },
  {
    "code": "S03.5",
    "name": "Nasendistorsion",
    "synonyms": [
      "Multiple Dislokationen des Kopfes",
      "Nasendistorsion"
    ]
  },
  {
    "code": "S04.0",
    "name": "Sehbahnverletzung",
    "synonyms": [
      "Sehbahnverletzung",
      "Sehnervverletzung",
      "Sehrindenverletzung",
      "Verletzung des Chiasma opticum",
      "Verletzung des Hirnnerven II",
      "Verletzung des Nervus opticus",
      "Verletzung des visuellen Kortex"
    ]
  },
  {
    "code": "S04.1",
    "name": "Verletzung des Nervus oculomotorius",
    "synonyms": [
      "Verletzung des Hirnnerven III",
      "Verletzung des Nervus oculomotorius"
    ]
  },
  {
    "code": "S04.2",
    "name": "Verletzung des Nervus trochlearis",
    "synonyms": [
      "Verletzung des Hirnnerven IV",
      "Verletzung des Nervus trochlearis"
    ]
  },
  {
    "code": "S04.3",
    "name": "Verletzung des Nervus trigeminus",
    "synonyms": [
      "Verletzung des Gasser-Ganglions",
      "Verletzung des Hirnnerven V",
      "Verletzung des Nervus trigeminus"
    ]
  },
  {
    "code": "S04.4",
    "name": "Verletzung des Nervus abducens",
    "synonyms": [
      "Verletzung des Hirnnerven VI",
      "Verletzung des Nervus abducens"
    ]
  },
  {
    "code": "S04.5",
    "name": "Verletzung des Nervus facialis",
    "synonyms": [
      "Verletzung des Hirnnerven VII",
      "Verletzung des Nervus facialis"
    ]
  },
  {
    "code": "S04.6",
    "name": "Verletzung des Nervus vestibulocochlearis",
    "synonyms": [
      "Verletzung des Gehörs, zur Taubheit führend",
      "Verletzung des Hirnnerven VIII",
      "Verletzung des Hörnerven",
      "Verletzung des Nervus acusticus",
      "Verletzung des Nervus statoacusticus",
      "Verletzung des Nervus vestibulocochlearis"
    ]
  },
  {
    "code": "S04.7",
    "name": "Verletzung des Nervus accessorius",
    "synonyms": [
      "Verletzung des Hirnnerven XI",
      "Verletzung des Nervus accessorius"
    ]
  },
  {
    "code": "S04.8",
    "name": "Verletzung des Hirnnerven IX",
    "synonyms": [
      "Verletzung des Hirnnerven I",
      "Verletzung des Hirnnerven IX",
      "Verletzung des Hirnnerven X",
      "Verletzung des Hirnnerven XII",
      "Verletzung des Nervus glossopharyngeus",
      "Verletzung des Nervus hypoglossus",
      "Verletzung des Nervus olfactorius",
      "Verletzung des Nervus vagus"
    ]
  },
  {
    "code": "S04.9",
    "name": "Hirnnervverletzung",
    "synonyms": [
      "Hirnnervverletzung"
    ]
  },
  {
    "code": "S05.0",
    "name": "Traumatische Hornhauterosion",
    "synonyms": [
      "Abrasio corneae",
      "Bindehaut- und Hornhauttrauma",
      "Bindehautwunde",
      "Konjunktiva- und Korneatrauma",
      "Konjunktivaprellung",
      "Konjunktivawunde",
      "Korneaverletzung durch Abrasion",
      "Lamelläre Hornhautverletzung",
      "Oberflächliche Konjunktivaverletzung",
      "Oberflächliche Korneaverletzung",
      "Subkonjunktivale Prellung",
      "Subkonjunktivale Verletzung",
      "Tiefe Hornhautverletzung",
      "Traumatische Erosio corneae",
      "Traumatische Hornhauterosion",
      "Traumatische Korneaerosion",
      "Traumatisches Hyposphagma"
    ]
  },
  {
    "code": "S05.1",
    "name": "Traumatisches Hyphäma",
    "synonyms": [
      "Augapfelkontusion",
      "Augapfelprellung",
      "Augenhöhlenhämatom mit Augenhöhlenverletzung",
      "Augenhöhlenprellung",
      "Bulbusprellung des Auges",
      "Bulbusprellung mit Orbitagewebeprellung",
      "Contusio bulbi",
      "Contusio orbitae",
      "Contusio retinae mit Berlin-Ödem",
      "Hornhautprellung",
      "Irisprellung",
      "Korneaprellung",
      "Linsenprellung",
      "Orbitahämatom mit Orbitaverletzung",
      "Orbitaprellung",
      "Prellung des Orbitabindegewebes",
      "Skleraprellung",
      "Traumatische Ekchymose des Auges",
      "Traumatischer Linsenvorfall",
      "Traumatisches Hyphäma",
      "Traumatisches Orbitahämatom"
    ]
  },
  {
    "code": "S05.2",
    "name": "Glaskörperprolaps nach Contusio bulbi",
    "synonyms": [
      "Augapfellazeration mit Verlust intraokularen Gewebes",
      "Augapfellazeration mit Vorfall intraokularen Gewebes",
      "Bulbusperforation mit Prolaps",
      "Bulbusruptur mit Prolaps",
      "Glaskörperprolaps bei Bulbusruptur",
      "Glaskörperprolaps nach Contusio bulbi",
      "Hernie des Corpus vitreum",
      "Hornhaut-Sklera-Perforation mit Hornhautprolaps",
      "Hornhautperforation mit Irisprolaps",
      "Hornhautruptur mit Irisprolaps",
      "Inkarzeration der Iris in einer Wunde",
      "Inkarzeration der Linse in einer Wunde",
      "Penetrierende Augapfelverletzung mit Verlust intraokularen Gewebes",
      "Penetrierende Augapfelverletzung mit Vorfall intraokularen Gewebes",
      "Prolaps der Glaskörperflüssigkeit in eine Wunde",
      "Rissverletzung des Auges mit Prolaps und Verlust intraokularen Gewebes",
      "Ruptur des Auges mit Prolaps und Verlust intraokularen Gewebes",
      "Traumatische Hernia lentis",
      "Traumatische Irishernie",
      "Traumatische Ziliarkörperhernie",
      "Traumatischer Irisprolaps",
      "Traumatischer Uvealprolaps",
      "Traumatischer Ziliarkörperprolaps"
    ]
  },
  {
    "code": "S05.3",
    "name": "Iriszerreißung",
    "synonyms": [
      "Augapfellazeration ohne Prolaps",
      "Augapfelruptur",
      "Bulbusruptur ohne Prolaps",
      "Hornhautperforation ohne Irisprolaps",
      "Hornhautruptur ohne Irisprolaps",
      "Iriszerreißung",
      "Okuläre Rissverletzung mit okulärer Ruptur",
      "Rissverletzung des Auges",
      "Rissverletzung des Auges ohne Prolaps und ohne Verlust intraokularen Gewebes",
      "Ruptur des Auges ohne Vorfall intraokularen Gewebes",
      "Skleraperforation ohne Prolaps",
      "Skleraruptur",
      "Ziliarkörperzerreißung"
    ]
  },
  {
    "code": "S05.4",
    "name": "Perforierende Orbitaverletzung",
    "synonyms": [
      "Fremdkörper in der Augenhöhle",
      "Fremdkörper in der Orbita",
      "Fremdkörper in einem Augenmuskel",
      "Offene Wunde der extraokulären Augenmuskeln",
      "Penetrierende Augenhöhlenverletzung",
      "Penetrierende Orbitaverletzung",
      "Penetrierende Wunde der Orbita mit Fremdkörper",
      "Penetrierende Wunde der Orbita ohne Fremdkörper",
      "Penetrierende offene okuläre Orbitawunde",
      "Perforierende Orbitaverletzung"
    ]
  },
  {
    "code": "S05.5",
    "name": "Perforierender Hornhautfremdkörper",
    "synonyms": [
      "Bulbusperforation mit Fremdkörper",
      "Fremdkörper im Ziliarkörper",
      "Fremdkörper in der vorderen Augenkammer",
      "Glaskörperfremdkörper ohne Netzhautaufschlag",
      "Glaskörperfremdkörper ohne Retinaaufschlag",
      "Intraokularer Fremdkörper",
      "Intraokularer amagnetischer Fremdkörper",
      "Intraokularer magnetischer Fremdkörper",
      "Irisfremdkörper",
      "Linsenfremdkörper",
      "Linsenfremdkörper der Vorderkammer",
      "Netzhautfremdkörper",
      "Penetrierende offene okuläre Wunde mit Fremdkörper",
      "Perforierende Verletzung mit Fremdkörper des Augapfels",
      "Perforierender Hornhautfremdkörper",
      "Retinafremdkörper"
    ]
  },
  {
    "code": "S05.6",
    "name": "Perforierende Verletzung ohne Fremdkörper des Augapfels",
    "synonyms": [
      "Augenperforation",
      "Bulbusperforation",
      "Bulbusperforation ohne Fremdkörper",
      "Bulbusperforation ohne Prolaps",
      "Intraokulare Verletzung",
      "Penetrierende Augapfellazeration",
      "Penetrierende Augapfelverletzung",
      "Penetrierende Augapfelwunde",
      "Penetrierende Augenverletzung",
      "Penetrierende Irisverletzung",
      "Penetrierende Retinaverletzung",
      "Penetrierende Skleraverletzung",
      "Penetrierende okuläre Wunde",
      "Perforierende Augapfelverletzung",
      "Perforierende Hornhautverletzung des Auges",
      "Perforierende Verletzung ohne Fremdkörper des Augapfels"
    ]
  },
  {
    "code": "S05.7",
    "name": "Augapfelabriss",
    "synonyms": [
      "Akute traumatische Enukleation eines Auges",
      "Augapfelabriss",
      "Augenabriss",
      "Bulbusabriss",
      "Enukleation eines Auges",
      "Herausreißung eines Auges",
      "Offene Wunde durch okulären Abriss",
      "Traumatische Enukleation",
      "Traumatische Eviszeration eines Auges"
    ]
  },
  {
    "code": "S05.8",
    "name": "Skleraverletzung ohne Perforation",
    "synonyms": [
      "Akute traumatische Ablatio retinae",
      "Augenlinsenverletzung",
      "Augenprellung a.n.k.",
      "Berlin-Ödem",
      "Blindheit durch Erschütterung",
      "Blindheit durch Explosionsdruck",
      "Chorioideaverletzung",
      "Commotio retinae",
      "Glaskörperverletzung",
      "Iristrauma",
      "Irisverletzung",
      "Korneaverletzung",
      "Oberflächliche Augapfelverletzung a.n.k.",
      "Oberflächliche Augenverletzung",
      "Oberflächliche Bulbusverletzung",
      "Oberflächliche Skleraverletzung",
      "Oberflächliche Verletzung der Augenanhangsgebilde",
      "Oberflächliche Verletzung des Tränenapparates",
      "Oberflächliche Verletzung des Tränensacks",
      "Oberflächliche Verletzung einer Tränendrüse",
      "Oberflächliche subkonjunktivale Verletzung",
      "Offene Korneawunde",
      "Offene Wunde der Augenanhangsgebilde",
      "Offene Wunde der okulären Anhangsgebilde",
      "Offene Wunde des Tränenganges",
      "Prellung der Augenanhangsgebilde a.n.k.",
      "Retinaverletzung",
      "Skleraverletzung",
      "Skleraverletzung ohne Perforation",
      "Sphinkterverletzung der Iris",
      "Tiefe Verletzung der Tränenwege",
      "Traumatische Bulbusluxation",
      "Traumatische Iridodialyse",
      "Traumatische Linsendislokation",
      "Traumatische Netzhautblutung",
      "Traumatische Retinablutung",
      "Traumatische Tränenwegsruptur",
      "Traumatisches Berlin-Ödem",
      "Tränenapparatprellung",
      "Tränendrüsenprellung",
      "Tränendrüsenverletzung",
      "Tränensackprellung",
      "Verletzung der vorderen Augenkammer",
      "Verletzung des Ductus lacrimalis",
      "Verletzung des Ductus nasolacrimalis",
      "Ziliarkörperverletzung"
    ]
  },
  {
    "code": "S05.9",
    "name": "Offene Orbitawunde",
    "synonyms": [
      "Augapfelverletzung",
      "Augenhöhlenverletzung",
      "Augenverletzung",
      "Blindheit durch Verletzung",
      "Bulbusverletzung",
      "Offene Orbitawunde",
      "Offene okuläre Wunde",
      "Orbitaverletzung",
      "Traumatische Amaurose",
      "Traumatische Blindheit"
    ]
  },
  {
    "code": "S06.0",
    "name": "Isolierte Kommotio des Gehirns",
    "synonyms": [
      "Akute Gehirnerschütterung",
      "Akute traumatische Enzephalopathie",
      "Commotio cerebri",
      "Gehirnerschütterung",
      "Gehirnerschütterung mit leichter Nebenverletzung",
      "Gehirnverletzung durch Explosionsdruck",
      "Isolierte Gehirnerschütterung",
      "Isolierte Kommotio des Gehirns",
      "Kommotio des Gehirns bei leichter Nebenverletzung",
      "Schädelhirntrauma I. Grades",
      "Traumatische Reizung der Meningen"
    ]
  },
  {
    "code": "S06.1",
    "name": "Traumatisches Hirnödem",
    "synonyms": [
      "Traumatisches Gehirnödem",
      "Traumatisches Hirnödem"
    ]
  },
  {
    "code": "S06.20",
    "name": "Diffuse Hirnverletzung",
    "synonyms": [
      "Akute postkontusionelle Enzephalopathie",
      "Diffuse Gehirnlazeration",
      "Diffuse Gehirnverletzung",
      "Diffuse Hirnverletzung",
      "Diffuse Verletzung eines großen Gehirngewebebereiches",
      "Diffuse Verletzung eines großen Hirngewebebereiches",
      "Diffuse zerebrale Verletzung",
      "Gedeckte schwere Schädelhirnverletzung",
      "Traumatische diffuse intrazerebrale Blutung",
      "Traumatische diffuse intrazerebrale Hämorrhagie"
    ]
  },
  {
    "code": "S06.21",
    "name": "Hirnprellung",
    "synonyms": [
      "Contusio cerebri",
      "Diffuse Gehirnprellung",
      "Diffuse Hirnrindenprellung",
      "Diffuse zerebrale Prellung",
      "Gehirnhämatom mit zerebraler Prellung",
      "Gehirnkontusion",
      "Hirnkontusion",
      "Hirnprellung"
    ]
  },
  {
    "code": "S06.22",
    "name": "Kleinhirnprellung",
    "synonyms": [
      "Diffuse Kleinhirnkontusionen",
      "Kleinhirnprellung"
    ]
  },
  {
    "code": "S06.23",
    "name": "Traumatische multiple intrazerebrale Blutungen",
    "synonyms": [
      "Traumatische multiple intrazerebrale Blutungen",
      "Traumatische multiple intrazerebrale und zerebellare Hämatome"
    ]
  },
  {
    "code": "S06.28",
    "name": "Multiple Rissverletzungen des Groß- und Kleinhirns",
    "synonyms": [
      "Diffuse zerebrale Lazeration",
      "Gehirnhämatom mit zerebraler Zerreißung",
      "Gehirnkompression durch Kontusion",
      "Gehirnkompression durch Verletzung a.n.k.",
      "Intrakranielle Lazeration a.n.k.",
      "Kleinhirnlazeration",
      "Lazeration des Tentorium cerebelli",
      "Meningenlazeration",
      "Multiple Rissverletzungen des Groß- und Kleinhirns",
      "Zerebellumlazeration",
      "Zerebrale Kortexlazeration"
    ]
  },
  {
    "code": "S06.30",
    "name": "Umschriebene Hirnverletzung",
    "synonyms": [
      "Diffuse Verletzung eines begrenzten Hirngewebebereiches",
      "Diffuse Verletzung eines umschriebenen Gehirngewebebereiches",
      "Diffuse Verletzung eines umschriebenen Hirngewebebereiches",
      "Umschriebene Gehirnlazeration",
      "Umschriebene Gehirnverletzung",
      "Umschriebene Hirnverletzung",
      "Umschriebene zerebrale Lazeration",
      "Umschriebene zerebrale Verletzung"
    ]
  },
  {
    "code": "S06.31",
    "name": "Hirnrindenkontusion",
    "synonyms": [
      "Gehirnkompression durch umschriebene Kontusion",
      "Hirnrindenkontusion",
      "Hirnrindenprellung",
      "Umschriebene Gehirnprellung",
      "Umschriebene Hirnrindenprellung",
      "Umschriebene zerebrale Prellung"
    ]
  },
  {
    "code": "S06.32",
    "name": "Umschriebene Kleinhirnkontusion",
    "synonyms": [
      "Umschriebene Kleinhirnkontusion"
    ]
  },
  {
    "code": "S06.33",
    "name": "Intrazerebrales Hämatom",
    "synonyms": [
      "Fokale traumatische intrazerebrale Blutung",
      "Fokale traumatische intrazerebrale Hämorrhagie",
      "Intrazerebrales Hämatom",
      "Umschriebenes zerebrales Hämatom"
    ]
  },
  {
    "code": "S06.34",
    "name": "Traumatische umschriebene zerebellare Blutung",
    "synonyms": [
      "Traumatische umschriebene zerebellare Blutung",
      "Umschriebene zerebellare Blutung"
    ]
  },
  {
    "code": "S06.38",
    "name": "Rissverletzung des Groß- und Kleinhirns",
    "synonyms": [
      "Rissverletzung des Groß- und Kleinhirns",
      "Traumatische Gehirnhernie"
    ]
  },
  {
    "code": "S06.4",
    "name": "Epidurale Blutung",
    "synonyms": [
      "Epidurale Blutung",
      "Epidurales Hämatom",
      "Extradurales Hämatom",
      "Traumatische epidurale Blutung",
      "Traumatische epidurale Hämorrhagie",
      "Traumatische extradurale Blutung",
      "Traumatische extradurale Hämorrhagie",
      "Traumatisches epidurales Hämatom"
    ]
  },
  {
    "code": "S06.5",
    "name": "Traumatische subdurale Blutung",
    "synonyms": [
      "Akute traumatische subdurale Blutung",
      "Durablutung",
      "Durahämatom",
      "Subduralblutung",
      "Subdurale Hämorrhagie",
      "Subduralhämatom",
      "Subtentoriale Blutung",
      "Subtentoriale Hämorrhagie",
      "Traumatische subdurale Blutung",
      "Traumatische subdurale Hämorrhagie",
      "Traumatisches subdurales Hämatom"
    ]
  },
  {
    "code": "S06.6",
    "name": "Traumatische subarachnoidale Blutung",
    "synonyms": [
      "Traumatische subarachnoidale Blutung",
      "Traumatische subarachnoidale Hämorrhagie",
      "Traumatisches arachnoidales Hämatom",
      "Traumatisches subarachnoidales Hämatom"
    ]
  },
  {
    "code": "S06.8",
    "name": "Traumatische Hirnblutung",
    "synonyms": [
      "Durchtrennung des Hypophysenstiels",
      "Hirnhautprellung",
      "Hirnhautriss",
      "Hirnhautverletzung",
      "Intrakranielle Kontusion",
      "Kleinhirnkontusion",
      "Kleinhirnverletzung",
      "Meningenprellung",
      "Meningenriss",
      "Meningenverletzung",
      "Schädelhöhlenverletzung",
      "Tentoriumblutung",
      "Tentoriumhämatom",
      "Traumatische Fistel des Sinus cavernosus",
      "Traumatische Gehirnblutung",
      "Traumatische Gehirnhämorrhagie",
      "Traumatische Hirnblutung",
      "Traumatische Hämorrhagie des Tentoriums a.n.k.",
      "Traumatische Kleinhirnblutung",
      "Traumatische infratentorielle Gehirnblutung",
      "Traumatische infratentorielle Hirnblutung",
      "Traumatische intrakranielle Blutung",
      "Traumatische intrakranielle Hämorrhagie",
      "Traumatische supratentorielle Gehirnblutung",
      "Traumatische supratentorielle Hirnblutung",
      "Traumatische zerebellare Hämorrhagie",
      "Traumatisches Gehirnhämatom",
      "Traumatisches Kleinhirnhämatom",
      "Traumatisches intrakranielles Hämatom",
      "Verletzung der zerebralen Meningen",
      "Verletzung des Hinterhauptlappens",
      "Verletzung des Lobus occipitalis",
      "Verletzung des Lobus parietalis",
      "Verletzung des Sinus cavernosus",
      "Verletzung des zerebralen Kortex",
      "Verletzung einer Meningenarterie",
      "Verletzung eines intrakraniellen Blutgefäßes",
      "Zerebellumverletzung",
      "Zerebrale Arterienverletzung",
      "Zerebrale Blutgefäßverletzung",
      "Zerebrale Kontusionsblutung"
    ]
  },
  {
    "code": "S06.9",
    "name": "Intrakranielle Verletzung",
    "synonyms": [
      "Gehirntrauma",
      "Gehirnverletzung",
      "Geschlossenes Schädelhirntrauma",
      "Hirnstammverletzung",
      "Hirntrauma",
      "Hirnverletzung",
      "Intrakranielle Verletzung",
      "Offenes Schädelhirntrauma",
      "SHT [Schädelhirntrauma]",
      "Schädelhirntrauma",
      "Zerebrale Verletzung"
    ]
  },
  {
    "code": "S07.0",
    "name": "Gesichtszerquetschung",
    "synonyms": [
      "Gesichtszerquetschung",
      "Lippenzerquetschung",
      "Nasenzerquetschung",
      "Ohrzerquetschung",
      "Wangenzerquetschung"
    ]
  },
  {
    "code": "S07.1",
    "name": "Schädelzerquetschung",
    "synonyms": [
      "Schädelzerquetschung"
    ]
  },
  {
    "code": "S07.8",
    "name": "Zerquetschung der behaarten Kopfhaut",
    "synonyms": [
      "Zerquetschung der behaarten Kopfhaut"
    ]
  },
  {
    "code": "S07.9",
    "name": "Kopfzerquetschung",
    "synonyms": [
      "Kopfzerquetschung"
    ]
  },
  {
    "code": "S08.0",
    "name": "Skalpierungsverletzung",
    "synonyms": [
      "Abriss der behaarten Kopfhaut",
      "Skalpierungsverletzung"
    ]
  },
  {
    "code": "S08.1",
    "name": "Traumatische Ohramputation",
    "synonyms": [
      "Traumatische Ohramputation"
    ]
  },
  {
    "code": "S08.8",
    "name": "Traumatische Nasenamputation",
    "synonyms": [
      "Traumatische Nasenamputation"
    ]
  },
  {
    "code": "S09.0",
    "name": "Verletzung eines Blutgefäßes des Kopfes",
    "synonyms": [
      "Verletzung eines Blutgefäßes des Kopfes"
    ]
  },
  {
    "code": "S09.1",
    "name": "Muskelverletzung des Kopfes",
    "synonyms": [
      "Muskelverletzung des Kopfes",
      "Sehnenverletzung des Kopfes"
    ]
  },
  {
    "code": "S09.2",
    "name": "Traumatische Trommelfellruptur",
    "synonyms": [
      "Offene Trommelfellwunde",
      "Traumatische Trommelfellperforation",
      "Traumatische Trommelfellruptur"
    ]
  },
  {
    "code": "S09.7",
    "name": "Multiple Verletzungen des Kopfes",
    "synonyms": [
      "Gehirnverletzung mit Hirnnervenbeteiligung",
      "Kopfschussverletzung",
      "Multiple Verletzungen des Kopfes",
      "Schädeldurchschuss"
    ]
  },
  {
    "code": "S09.8",
    "name": "Traumatisches Zephalhämatom",
    "synonyms": [
      "Traumatische Zephalhämatozele",
      "Traumatisches Zephalhämatom"
    ]
  },
  {
    "code": "S09.9",
    "name": "Schädeltrauma",
    "synonyms": [
      "Adenoide Verletzung",
      "Alveolarfortsatzverletzung",
      "Augenbrauenverletzung",
      "Augenlidverletzung",
      "Augenwinkelverletzung",
      "Gehörgangsverletzung",
      "Gesichtsschädelverletzung",
      "Gesichtsverletzung",
      "Kieferverletzung",
      "Kinnverletzung",
      "Kopftrauma",
      "Kopfverletzung",
      "Lippenverletzung",
      "Maxillaverletzung",
      "Mittelohrverletzung",
      "Mundverletzung",
      "Nasenhöhlenverletzung",
      "Nasenverletzung",
      "Nasopharynxverletzung",
      "Oberkieferverletzung",
      "Ohrmuschelverletzung",
      "Ohrverletzung",
      "Scheitelverletzung",
      "Schläfenverletzung",
      "Schädeltrauma",
      "Schädelverletzung a.n.k.",
      "Speicheldrüsenverletzung",
      "Stirnverletzung",
      "Submaxilläre Verletzung",
      "Submentale Verletzung",
      "Supraorbitale Verletzung",
      "Tonsillenverletzung",
      "Uvulaverletzung",
      "Verletzung der Eustachi-Röhre",
      "Verletzung der Regio temporalis",
      "Verletzung der Scheitelgegend",
      "Verletzung der Schläfengegend",
      "Verletzung der Sinus paranasales",
      "Verletzung der Temporalregion",
      "Verletzung der Warzenfortsatzgegend",
      "Verletzung der behaarten Kopfhaut",
      "Verletzung der behaarten Kopfhaut der Hinterhauptgegend",
      "Verletzung der okzipitalen Region",
      "Verletzung der parietalen Region",
      "Verletzung des Nasenrachenraums",
      "Verletzung des Nasenseptums",
      "Verletzung des Ohrlabyrinths",
      "Verletzung des Speicheldrüsenganges",
      "Verletzung des harten Gaumens",
      "Verletzung des weichen Gaumens",
      "Verletzung des äußeren Gehörganges",
      "Verletzung des äußeren Ohres",
      "Wangenverletzung",
      "Wangenwandverletzung",
      "Warzenfortsatzverletzung",
      "Zahnfleischverletzung",
      "Zahnverletzung",
      "Zungenverletzung"
    ]
  },
  {
    "code": "S10.0",
    "name": "Rachenprellung",
    "synonyms": [
      "Epiglottiskontusion",
      "Kehlkopfprellung",
      "Larynxprellung",
      "Pharynxprellung",
      "Prellung der Pars cervicalis der Trachea",
      "Prellung der Pars cervicalis des Ösophagus",
      "Rachenprellung",
      "Stimmbandhämatom",
      "Stimmbandprellung",
      "Stimmlippenprellung",
      "Tracheaprellung"
    ]
  },
  {
    "code": "S10.10",
    "name": "Oberflächliche Verletzung des Rachens",
    "synonyms": [
      "Oberflächliche Kehlkopfverletzung",
      "Oberflächliche Verletzung der Epiglottis",
      "Oberflächliche Verletzung der Trachea",
      "Oberflächliche Verletzung des Kehldeckels",
      "Oberflächliche Verletzung des Larynx",
      "Oberflächliche Verletzung des Pharynx",
      "Oberflächliche Verletzung des Rachens",
      "Oberflächliche Verletzung des Ösophagus, Pars cervicalis",
      "Oberflächliche Verletzung einer Stimmlippe",
      "Oberflächliche Verletzung eines Stimmbandes"
    ]
  },
  {
    "code": "S10.7",
    "name": "Multiple oberflächliche Verletzungen des Halses",
    "synonyms": [
      "Multiple oberflächliche Verletzungen des Halses"
    ]
  },
  {
    "code": "S10.80",
    "name": "Oberflächliche Verletzung der Fossa supraclavicularis",
    "synonyms": [
      "Oberflächliche Verletzung der Fossa supraclavicularis"
    ]
  },
  {
    "code": "S10.85",
    "name": "Prellung der Supraklavikulargrube",
    "synonyms": [
      "Prellung der Supraklavikulargrube"
    ]
  },
  {
    "code": "S10.90",
    "name": "Oberflächliche Verletzung des Halses",
    "synonyms": [
      "Oberflächliche Verletzung des Halses"
    ]
  },
  {
    "code": "S10.91",
    "name": "Schürfwunde am Hals",
    "synonyms": [
      "Schürfwunde am Hals"
    ]
  },
  {
    "code": "S10.95",
    "name": "Halsprellung",
    "synonyms": [
      "Halsprellung"
    ]
  },
  {
    "code": "S10.96",
    "name": "Subkutanes Décollement am Hals",
    "synonyms": [
      "Subkutanes Décollement am Hals"
    ]
  },
  {
    "code": "S11.01",
    "name": "Offene Kehlkopfwunde",
    "synonyms": [
      "Offene Epiglottiswunde",
      "Offene Kehlkopfwunde",
      "Offene Larynxwunde"
    ]
  },
  {
    "code": "S11.02",
    "name": "Offene Trachealwunde",
    "synonyms": [
      "Offene Trachealwunde",
      "Offene Wunde der Trachea, Pars cervicalis"
    ]
  },
  {
    "code": "S11.1",
    "name": "Offene Wunde mit Beteiligung der Schilddrüse",
    "synonyms": [
      "Offene Schilddrüsenwunde",
      "Offene Thyreoideawunde",
      "Offene Wunde mit Beteiligung der Schilddrüse"
    ]
  },
  {
    "code": "S11.21",
    "name": "Offene Rachenwunde",
    "synonyms": [
      "Offene Pharynxwunde",
      "Offene Rachenwunde"
    ]
  },
  {
    "code": "S11.22",
    "name": "Offene Wunde der Pars cervicalis des Ösophagus",
    "synonyms": [
      "Offene Wunde der Pars cervicalis des Ösophagus"
    ]
  },
  {
    "code": "S11.7",
    "name": "Multiple offene Wunden des Halses",
    "synonyms": [
      "Multiple offene Wunden des Halses"
    ]
  },
  {
    "code": "S11.80",
    "name": "Offene Wunde der Supraklavikularregion",
    "synonyms": [
      "Offene Nackenwunde",
      "Offene Wunde der Supraklavikularregion"
    ]
  },
  {
    "code": "S11.9",
    "name": "Offene Halswunde",
    "synonyms": [
      "Offene Halswunde"
    ]
  },
  {
    "code": "S12.0",
    "name": "Fraktur des 1. Halswirbels",
    "synonyms": [
      "Atlasfraktur",
      "Fraktur des 1. Halswirbels",
      "Fraktur des Atlasbogens",
      "Jefferson-Fraktur"
    ]
  },
  {
    "code": "S12.1",
    "name": "Densfraktur des 2. Halswirbels",
    "synonyms": [
      "Axisfraktur",
      "Densfraktur des 2. Halswirbels",
      "Doppelseitige Bogenwurzelfraktur des Axis",
      "Fraktur des 2. Halswirbels",
      "Fraktur des Dens axis"
    ]
  },
  {
    "code": "S12.21",
    "name": "Fraktur des 3. Halswirbels",
    "synonyms": [
      "Fraktur des 3. Halswirbels"
    ]
  },
  {
    "code": "S12.22",
    "name": "Fraktur des 4. Halswirbels",
    "synonyms": [
      "Fraktur des 4. Halswirbels"
    ]
  },
  {
    "code": "S12.23",
    "name": "Fraktur des 5. Halswirbels",
    "synonyms": [
      "Fraktur des 5. Halswirbels"
    ]
  },
  {
    "code": "S12.24",
    "name": "Fraktur des 6. Halswirbels",
    "synonyms": [
      "Fraktur des 6. Halswirbels"
    ]
  },
  {
    "code": "S12.25",
    "name": "Fraktur des 7. Halswirbels",
    "synonyms": [
      "Fraktur des 7. Halswirbels"
    ]
  },
  {
    "code": "S12.7",
    "name": "Multiple Frakturen der Halswirbelsäule",
    "synonyms": [
      "Multiple Frakturen der Halswirbelsäule",
      "Multiple Halsfrakturen"
    ]
  },
  {
    "code": "S12.8",
    "name": "Kehlkopffraktur",
    "synonyms": [
      "Fraktur der Cartilagines tracheales",
      "Fraktur der Cartilago cricoidea",
      "Fraktur der Knorpelspangen der Luftröhre",
      "Fraktur des Tracheaknorpels",
      "Fraktur knorpeliger Trachealspangen",
      "Kehlkopffraktur",
      "Larynxfraktur",
      "Ringknorpelfraktur",
      "Schildknorpelfraktur",
      "Tracheafraktur",
      "Zungenbeinfraktur"
    ]
  },
  {
    "code": "S12.9",
    "name": "Halsfraktur",
    "synonyms": [
      "Bogenwurzelfraktur der Halswirbelkörper",
      "Fraktur der zervikalen Wirbelsäule",
      "Fraktur eines Zervikalwirbels",
      "Fraktur eines zervikalen Dornfortsatzes",
      "Fraktur eines zervikalen Querfortsatzes",
      "Fraktur eines zervikalen Wirbelbogens",
      "HWS-Fraktur",
      "Halsfraktur",
      "Halswirbelfraktur",
      "Halswirbelkörperfraktur",
      "Halswirbelsäulenfraktur",
      "Zervikale Fraktur"
    ]
  },
  {
    "code": "S13.0",
    "name": "Traumatische Ruptur der zervikalen Bandscheibe",
    "synonyms": [
      "Traumatische Ruptur der zervikalen Bandscheibe"
    ]
  },
  {
    "code": "S13.10",
    "name": "HWS-Luxation",
    "synonyms": [
      "Dislokation der Halswirbelsäule",
      "HWS-Luxation",
      "Halsdislokation",
      "Halswirbeldislokation",
      "Zervikale Wirbelsäulendislokation",
      "Zervikalwirbeldislokation"
    ]
  },
  {
    "code": "S13.11",
    "name": "Atlasluxation",
    "synonyms": [
      "Atlantookzipitale Dislokation",
      "Atlasdislokation",
      "Atlasluxation",
      "Axisdislokation",
      "Dislokation des Atlantoaxialgelenks",
      "Dislokation des Atlantoepistrophealgelenks"
    ]
  },
  {
    "code": "S13.12",
    "name": "Halswirbelluxation C2/C3",
    "synonyms": [
      "Halswirbelluxation C2/C3"
    ]
  },
  {
    "code": "S13.13",
    "name": "Halswirbelluxation C3/C4",
    "synonyms": [
      "Halswirbelluxation C3/C4"
    ]
  },
  {
    "code": "S13.14",
    "name": "Halswirbelluxation C4/C5",
    "synonyms": [
      "Halswirbelluxation C4/C5"
    ]
  },
  {
    "code": "S13.15",
    "name": "Halswirbelluxation C5/C6",
    "synonyms": [
      "Halswirbelluxation C5/C6"
    ]
  },
  {
    "code": "S13.16",
    "name": "Halswirbelluxation C6/C7",
    "synonyms": [
      "Halswirbelluxation C6/C7"
    ]
  },
  {
    "code": "S13.17",
    "name": "Halswirbelluxation C7/T1",
    "synonyms": [
      "Halswirbelluxation C7/T1"
    ]
  },
  {
    "code": "S13.2",
    "name": "Dislokation des Krikoarytänoidalgelenks",
    "synonyms": [
      "Dislokation des Krikoarytänoidalgelenks",
      "Dislokation des Krikothyreoidalgelenks",
      "Halsluxation",
      "Schildknorpeldislokation"
    ]
  },
  {
    "code": "S13.3",
    "name": "Multiple Luxationen des Halses",
    "synonyms": [
      "Multiple Dislokationen der Halswirbel",
      "Multiple Dislokationen der Halswirbelsäule",
      "Multiple Dislokationen des Halses",
      "Multiple Luxationen des Halses"
    ]
  },
  {
    "code": "S13.4",
    "name": "Schleudertrauma",
    "synonyms": [
      "Atlantoaxiale Distorsion",
      "Atlantoaxiale Verstauchung",
      "Atlantoaxiale Zerrung",
      "Atlantookzipitale Distorsion",
      "Atlantookzipitale Verstauchung",
      "Atlantookzipitale Zerrung",
      "Atlasdistorsion",
      "Distorsion der Halswirbelsäule",
      "Distorsion des zervikalen Ligamentum longitudinale anterius",
      "Frischer traumatischer Tortikollis a.n.k.",
      "HWS-Distorsion",
      "HWS-Schleudertrauma",
      "HWS-Verstauchung",
      "HWS-Zerrung",
      "Halswirbelsäulenschleudertrauma",
      "Halswirbelverletzung",
      "Nackenzerrung mit Blockierung",
      "Peitschenhieb-Syndrom",
      "Schleudertrauma",
      "Stauchung der Halswirbelsäule",
      "Verstauchung des Atlantoaxialgelenks",
      "Verstauchung des Atlantookzipitalgelenks",
      "Verstauchung des zervikalen Ligamentum longitudinale anterius",
      "Whiplash-Verletzung",
      "Windschutzscheiben-Syndrom",
      "Zerrung des Atlantoaxialgelenks",
      "Zerrung des Atlantookzipitalgelenks",
      "Zerrung des zervikalen Ligamentum longitudinale anterius",
      "Zervikale Distorsion",
      "Zervikodorsale Distorsion",
      "Zervikothorakale Distorsion"
    ]
  },
  {
    "code": "S13.5",
    "name": "Distorsion des Krikothyreoidalbandes",
    "synonyms": [
      "Distorsion der Schilddrüsengegend",
      "Distorsion des Krikothyreoidalbandes",
      "Distorsion des Krikothyreoidalgelenks",
      "Distorsion des Ring-Gießbeckenknorpelgelenks",
      "Distorsion des Ring-Schildknorpelgelenks",
      "Krikoarytänoidale Verstauchung",
      "Krikoarytänoidale Zerrung",
      "Krikothyreoidale Verstauchung",
      "Krikothyreoidale Zerrung",
      "Schildknorpeldistorsion",
      "Verstauchung des Krikoarytänoidalgelenks",
      "Verstauchung des Krikothyreoidalgelenks",
      "Zerrung des Krikoarytänoidalgelenks",
      "Zerrung des Krikothyreoidalgelenks"
    ]
  },
  {
    "code": "S13.6",
    "name": "Halsdistorsion",
    "synonyms": [
      "Halsdistorsion"
    ]
  },
  {
    "code": "S14.0",
    "name": "Zervikale Rückenmarkerschütterung",
    "synonyms": [
      "Zervikale Rückenmarkerschütterung",
      "Zervikale Rückenmarkprellung"
    ]
  },
  {
    "code": "S14.10",
    "name": "Halsmarkverletzung",
    "synonyms": [
      "Akute Phase einer traumatischen Tetraplegie",
      "Halsmarkverletzung",
      "Multiple Halsmarkverletzungen",
      "Rückenmarkverletzung der Halswirbelsäule",
      "Zervikale Rückenmarkverletzung"
    ]
  },
  {
    "code": "S14.11",
    "name": "Komplette Querschnittverletzung des zervikalen Rückenmarkes",
    "synonyms": [
      "Komplette Querschnittverletzung des zervikalen Rückenmarkes"
    ]
  },
  {
    "code": "S14.12",
    "name": "Zentrale Halsmarkverletzung",
    "synonyms": [
      "Zentrale Halsmarkverletzung"
    ]
  },
  {
    "code": "S14.2",
    "name": "Nervenwurzelverletzung der Halswirbelsäule",
    "synonyms": [
      "Nervenwurzelverletzung der Halswirbelsäule",
      "Nervenwurzelverletzung des zervikalen Rückenmarkes"
    ]
  },
  {
    "code": "S14.3",
    "name": "Verletzung des Plexus brachialis",
    "synonyms": [
      "Brachialplexusverletzung",
      "Verletzung des Plexus brachialis"
    ]
  },
  {
    "code": "S14.4",
    "name": "Periphere Nervenverletzung des Halses",
    "synonyms": [
      "Periphere Nervenverletzung des Halses"
    ]
  },
  {
    "code": "S14.5",
    "name": "Verletzung der zervikalen sympathischen Nerven",
    "synonyms": [
      "Traumatische Horner-Trias",
      "Traumatisches Claude-Bernard-Horner-Syndrom",
      "Verletzung der sympathischen Halsnerven",
      "Verletzung der zervikalen sympathischen Nerven",
      "Verletzung des Halssympathikus"
    ]
  },
  {
    "code": "S14.6",
    "name": "Nervenverletzung am Hals",
    "synonyms": [
      "Nervenverletzung am Hals"
    ]
  },
  {
    "code": "S15.00",
    "name": "Verletzung der Arteria carotis",
    "synonyms": [
      "Kopfschlagaderverletzung",
      "Verletzung der Arteria carotis"
    ]
  },
  {
    "code": "S15.01",
    "name": "Verletzung der Arteria carotis communis",
    "synonyms": [
      "Verletzung der Arteria carotis communis"
    ]
  },
  {
    "code": "S15.02",
    "name": "Verletzung der Arteria carotis externa",
    "synonyms": [
      "Verletzung der Arteria carotis externa"
    ]
  },
  {
    "code": "S15.03",
    "name": "Verletzung der Arteria carotis interna",
    "synonyms": [
      "Verletzung der Arteria carotis interna"
    ]
  },
  {
    "code": "S15.1",
    "name": "Verletzung der Arteria vertebralis",
    "synonyms": [
      "Verletzung der Arteria vertebralis"
    ]
  },
  {
    "code": "S15.2",
    "name": "Verletzung der Vena jugularis externa",
    "synonyms": [
      "Verletzung der Vena jugularis externa",
      "Verletzung der äußeren Drosselvene"
    ]
  },
  {
    "code": "S15.3",
    "name": "Verletzung der Vena jugularis interna",
    "synonyms": [
      "Verletzung der Vena jugularis interna",
      "Verletzung der inneren Drosselvene"
    ]
  },
  {
    "code": "S15.7",
    "name": "Multiple Verletzungen von Blutgefäßen des Halses",
    "synonyms": [
      "Multiple Verletzungen von Blutgefäßen des Halses"
    ]
  },
  {
    "code": "S15.80",
    "name": "Verletzung epiduraler Blutgefäße in Halshöhe",
    "synonyms": [
      "Verletzung epiduraler Blutgefäße in Halshöhe"
    ]
  },
  {
    "code": "S15.81",
    "name": "Verletzung subduraler Blutgefäße in Halshöhe",
    "synonyms": [
      "Verletzung subduraler Blutgefäße in Halshöhe"
    ]
  },
  {
    "code": "S15.82",
    "name": "Verletzung subarachnoidaler Blutgefäße in Halshöhe",
    "synonyms": [
      "Verletzung subarachnoidaler Blutgefäße in Halshöhe"
    ]
  },
  {
    "code": "S15.9",
    "name": "Verletzung eines Blutgefäßes in Halshöhe",
    "synonyms": [
      "Verletzung eines Blutgefäßes in Halshöhe"
    ]
  },
  {
    "code": "S16",
    "name": "Verletzung von Muskeln in Halshöhe",
    "synonyms": [
      "Muskelzerrung im HWS-Bereich",
      "Sehnenverletzung in Halshöhe",
      "Verletzung von Muskeln in Halshöhe"
    ]
  },
  {
    "code": "S17.0",
    "name": "Kehlkopfzerquetschung",
    "synonyms": [
      "Kehlkopfzerquetschung",
      "Larynxzerquetschung",
      "Tracheazerquetschung"
    ]
  },
  {
    "code": "S17.8",
    "name": "Pharynxzerquetschung",
    "synonyms": [
      "Pharynxzerquetschung",
      "Rachenzerquetschung"
    ]
  },
  {
    "code": "S17.9",
    "name": "Halszerquetschung",
    "synonyms": [
      "Halszerquetschung"
    ]
  },
  {
    "code": "S18",
    "name": "Traumatische Amputation in Halshöhe",
    "synonyms": [
      "Dekapitation",
      "Enthauptung",
      "Traumatische Amputation in Halshöhe",
      "Vollständiger Abriss des Kopfes"
    ]
  },
  {
    "code": "S19.7",
    "name": "Multiple Verletzungen des Halses",
    "synonyms": [
      "Multiple Verletzungen des Halses"
    ]
  },
  {
    "code": "S19.80",
    "name": "Verletzung zervikaler Rückenmarkhäute",
    "synonyms": [
      "Verletzung zervikaler Rückenmarkhäute"
    ]
  },
  {
    "code": "S19.88",
    "name": "Pharynxverletzung",
    "synonyms": [
      "Pharynxverletzung"
    ]
  },
  {
    "code": "S19.9",
    "name": "Epiglottisverletzung a.n.k.",
    "synonyms": [
      "Epiglottisverletzung a.n.k.",
      "Halsverletzung",
      "Kehlkopfverletzung",
      "Larynxverletzung a.n.k.",
      "Rachenverletzung a.n.k.",
      "Schilddrüsenverletzung a.n.k.",
      "Verletzung der Fossa supraclavicularis a.n.k.",
      "Verletzung der Kehle a.n.k.",
      "Verletzung der Pars cervicalis der Trachea a.n.k.",
      "Zervikale Ösophagusverletzung a.n.k."
    ]
  },
  {
    "code": "S20.0",
    "name": "Mammaprellung",
    "synonyms": [
      "Mammaprellung"
    ]
  },
  {
    "code": "S20.10",
    "name": "Oberflächliche Mammaverletzung",
    "synonyms": [
      "Oberflächliche Brustdrüsenverletzung",
      "Oberflächliche Mammaverletzung"
    ]
  },
  {
    "code": "S20.16",
    "name": "Subkutanes Décollement der Mamma",
    "synonyms": [
      "Subkutanes Décollement der Mamma"
    ]
  },
  {
    "code": "S20.2",
    "name": "Thoraxprellung",
    "synonyms": [
      "Brustbeinprellung",
      "Brustkorbprellung",
      "Brustprellung",
      "Brustquetschung",
      "Brustwandprellung",
      "Contusio thoracis",
      "Prellung der Brustwirbelsäule",
      "Prellung der Interskapularregion",
      "Prellung der Kostalregion",
      "Prellung der Sternalregion",
      "Rippenprellung",
      "Sternumprellung",
      "Thoraxprellung",
      "Thoraxquetschung",
      "Thoraxwandhämatom"
    ]
  },
  {
    "code": "S20.30",
    "name": "Oberflächliche Verletzung des vorderen Thorax",
    "synonyms": [
      "Oberflächliche Verletzung der Brustbeingegend",
      "Oberflächliche Verletzung der Sternalregion",
      "Oberflächliche Verletzung der vorderen Rippengegend",
      "Oberflächliche Verletzung des vorderen Thorax"
    ]
  },
  {
    "code": "S20.31",
    "name": "Schürfwunde am vorderen Thorax",
    "synonyms": [
      "Schürfwunde am vorderen Thorax"
    ]
  },
  {
    "code": "S20.36",
    "name": "Subkutanes Décollement der vorderen Thoraxwand",
    "synonyms": [
      "Subkutanes Décollement der vorderen Thoraxwand"
    ]
  },
  {
    "code": "S20.40",
    "name": "Oberflächliche Verletzung des hinteren Thorax",
    "synonyms": [
      "Oberflächliche Verletzung der Interskapularregion",
      "Oberflächliche Verletzung der hinteren Rippengegend",
      "Oberflächliche Verletzung des hinteren Thorax"
    ]
  },
  {
    "code": "S20.41",
    "name": "Schürfwunde am hinteren Thorax",
    "synonyms": [
      "Schürfwunde am hinteren Thorax"
    ]
  },
  {
    "code": "S20.46",
    "name": "Subkutanes Décollement der hinteren Thoraxwand",
    "synonyms": [
      "Subkutanes Décollement der hinteren Thoraxwand"
    ]
  },
  {
    "code": "S20.7",
    "name": "Multiple oberflächliche Verletzungen des Thorax",
    "synonyms": [
      "Multiple oberflächliche Verletzungen der Brustwand",
      "Multiple oberflächliche Verletzungen der Rippengegend",
      "Multiple oberflächliche Verletzungen des Thorax"
    ]
  },
  {
    "code": "S20.80",
    "name": "Oberflächliche Verletzung des Thorax",
    "synonyms": [
      "Oberflächliche Verletzung der Brustwand",
      "Oberflächliche Verletzung der Rippengegend",
      "Oberflächliche Verletzung der Rippenregion",
      "Oberflächliche Verletzung des Thorax"
    ]
  },
  {
    "code": "S20.81",
    "name": "Schürfwunde am Thorax",
    "synonyms": [
      "Schürfwunde am Thorax"
    ]
  },
  {
    "code": "S20.86",
    "name": "Subkutanes Décollement der Brustwand",
    "synonyms": [
      "Subkutanes Décollement der Brustwand",
      "Subkutanes Décollement der Rippenregion",
      "Subkutanes Décollement der Thoraxwand"
    ]
  },
  {
    "code": "S21.0",
    "name": "Offene Wunde der Mamma",
    "synonyms": [
      "Offene Wunde der Brustdrüse",
      "Offene Wunde der Mamma"
    ]
  },
  {
    "code": "S21.1",
    "name": "Offene Wunde des vorderen Thorax",
    "synonyms": [
      "Offene Wunde der Brustbeingegend",
      "Offene Wunde der Sternalregion",
      "Offene Wunde der vorderen Brustwand",
      "Offene Wunde der vorderen Rippengegend",
      "Offene Wunde des vorderen Thorax"
    ]
  },
  {
    "code": "S21.2",
    "name": "Offene Wunde des hinteren Thorax",
    "synonyms": [
      "Offene Rückenwunde",
      "Offene Wunde der Interskapularregion",
      "Offene Wunde der hinteren Brustwand",
      "Offene Wunde der hinteren Rippengegend",
      "Offene Wunde des hinteren Thorax"
    ]
  },
  {
    "code": "S21.7",
    "name": "Multiple offene Wunden der Thoraxwand",
    "synonyms": [
      "Mehrere offene Wunden des Thorax",
      "Multiple offene Wunden der Thoraxwand"
    ]
  },
  {
    "code": "S21.9",
    "name": "Offene Thoraxwunde",
    "synonyms": [
      "Offene Thoraxwunde",
      "Offene Wunde der Rippengegend",
      "Offene Wunde der Thoraxwand",
      "Offene Wunde der äußeren Brustwand"
    ]
  },
  {
    "code": "S22.00",
    "name": "Brustwirbelfraktur",
    "synonyms": [
      "Brustwirbelfraktur",
      "Dorsale Wirbelfraktur",
      "Fraktur eines Thorakalwirbels",
      "Fraktur eines thorakalen Dornfortsatzes",
      "Fraktur eines thorakalen Querfortsatzes",
      "Fraktur eines thorakalen Wirbelbogens"
    ]
  },
  {
    "code": "S22.01",
    "name": "Brustwirbelfraktur T1",
    "synonyms": [
      "Brustwirbelfraktur T1",
      "Brustwirbelfraktur T2"
    ]
  },
  {
    "code": "S22.02",
    "name": "Brustwirbelfraktur T3",
    "synonyms": [
      "Brustwirbelfraktur T3",
      "Brustwirbelfraktur T4"
    ]
  },
  {
    "code": "S22.03",
    "name": "Brustwirbelfraktur T5",
    "synonyms": [
      "Brustwirbelfraktur T5",
      "Brustwirbelfraktur T6"
    ]
  },
  {
    "code": "S22.04",
    "name": "Brustwirbelfraktur T7",
    "synonyms": [
      "Brustwirbelfraktur T7",
      "Brustwirbelfraktur T8"
    ]
  },
  {
    "code": "S22.05",
    "name": "Brustwirbelfraktur T9",
    "synonyms": [
      "Brustwirbelfraktur T10",
      "Brustwirbelfraktur T9"
    ]
  },
  {
    "code": "S22.06",
    "name": "Brustwirbelfraktur T11",
    "synonyms": [
      "Brustwirbelfraktur T11",
      "Brustwirbelfraktur T12"
    ]
  },
  {
    "code": "S22.1",
    "name": "Multiple Frakturen der Brustwirbelsäule",
    "synonyms": [
      "Multiple Frakturen der Brustwirbelsäule",
      "Multiple dorsale Wirbelfrakturen"
    ]
  },
  {
    "code": "S22.20",
    "name": "Sternumfraktur",
    "synonyms": [
      "Sternumbruch",
      "Sternumfraktur"
    ]
  },
  {
    "code": "S22.21",
    "name": "Fraktur des Manubrium sterni",
    "synonyms": [
      "Fraktur des Manubrium sterni"
    ]
  },
  {
    "code": "S22.22",
    "name": "Fraktur des Corpus sterni",
    "synonyms": [
      "Fraktur des Corpus sterni"
    ]
  },
  {
    "code": "S22.23",
    "name": "Fraktur des Processus xiphoideus",
    "synonyms": [
      "Fraktur des Processus xiphoideus"
    ]
  },
  {
    "code": "S22.31",
    "name": "Fraktur der ersten Rippe",
    "synonyms": [
      "Fraktur der ersten Rippe"
    ]
  },
  {
    "code": "S22.32",
    "name": "Rippenfraktur",
    "synonyms": [
      "Rippenbruch",
      "Rippenfraktur",
      "Rippenknorpelfraktur"
    ]
  },
  {
    "code": "S22.40",
    "name": "Rippenserienfraktur",
    "synonyms": [
      "Multiple Rippenfrakturen",
      "Rippenserienbruch",
      "Rippenserienfraktur"
    ]
  },
  {
    "code": "S22.41",
    "name": "Multiple Rippenfrakturen mit Fraktur der ersten Rippe",
    "synonyms": [
      "Multiple Rippenfrakturen mit Fraktur der ersten Rippe"
    ]
  },
  {
    "code": "S22.42",
    "name": "Rippenserienfraktur mit Beteiligung von zwei Rippen",
    "synonyms": [
      "Rippenserienfraktur mit Beteiligung von zwei Rippen"
    ]
  },
  {
    "code": "S22.43",
    "name": "Rippenserienfraktur mit Beteiligung von drei Rippen",
    "synonyms": [
      "Rippenserienfraktur mit Beteiligung von drei Rippen"
    ]
  },
  {
    "code": "S22.44",
    "name": "Rippenserienfraktur mit Beteiligung von vier und mehr Rippen",
    "synonyms": [
      "Rippenserienfraktur mit Beteiligung von vier und mehr Rippen"
    ]
  },
  {
    "code": "S22.5",
    "name": "Thoraxinstabilität",
    "synonyms": [
      "Instabiler Thorax",
      "Rippenfraktur mit instabilem Thorax",
      "Sternumfraktur mit instabilem Thorax",
      "Thoraxinstabilität"
    ]
  },
  {
    "code": "S22.8",
    "name": "Multiple Thoraxfrakturen",
    "synonyms": [
      "Multiple Thoraxfrakturen"
    ]
  },
  {
    "code": "S22.9",
    "name": "Fraktur des knöchernen Thorax",
    "synonyms": [
      "Fraktur des knöchernen Thorax",
      "Offene Thoraxluxation"
    ]
  },
  {
    "code": "S23.0",
    "name": "Traumatische Ruptur einer thorakalen Bandscheibe",
    "synonyms": [
      "Traumatische Ruptur einer thorakalen Bandscheibe"
    ]
  },
  {
    "code": "S23.10",
    "name": "Brustwirbelluxation",
    "synonyms": [
      "Brustwirbeldislokation",
      "Brustwirbelluxation",
      "Luxation der Brustwirbelsäule",
      "Thorakale Nucleus-pulposus-Hernie durch schwere Verletzung",
      "Thorakale Wirbelsäulendislokation",
      "Thorakalwirbeldislokation",
      "Thorakolumbale Nucleus-pulposus-Hernie durch schwere Verletzung"
    ]
  },
  {
    "code": "S23.11",
    "name": "Brustwirbelluxation T2/T3",
    "synonyms": [
      "Brustwirbelluxation T1/T2",
      "Brustwirbelluxation T2/T3"
    ]
  },
  {
    "code": "S23.12",
    "name": "Brustwirbelluxation T4/T5",
    "synonyms": [
      "Brustwirbelluxation T3/T4",
      "Brustwirbelluxation T4/T5"
    ]
  },
  {
    "code": "S23.13",
    "name": "Brustwirbelluxation T6/T7",
    "synonyms": [
      "Brustwirbelluxation T5/T6",
      "Brustwirbelluxation T6/T7"
    ]
  },
  {
    "code": "S23.14",
    "name": "Brustwirbelluxation T7/T8",
    "synonyms": [
      "Brustwirbelluxation T7/T8",
      "Brustwirbelluxation T8/T9"
    ]
  },
  {
    "code": "S23.15",
    "name": "Brustwirbelluxation T9/T10",
    "synonyms": [
      "Brustwirbelluxation T10/T11",
      "Brustwirbelluxation T9/T10"
    ]
  },
  {
    "code": "S23.16",
    "name": "Brustwirbelluxation T11/T12",
    "synonyms": [
      "Brustwirbelluxation T11/T12"
    ]
  },
  {
    "code": "S23.17",
    "name": "Brustwirbelluxation T12/L1",
    "synonyms": [
      "Brustwirbelluxation T12/L1"
    ]
  },
  {
    "code": "S23.2",
    "name": "Brustbeindislokation",
    "synonyms": [
      "Brustbeindislokation",
      "Luftröhrendislokation",
      "Multiple Dislokationen des Thorax",
      "Rippendislokation",
      "Rippenknorpeldislokation",
      "Sternalknorpeldislokation",
      "Sternumdislokation",
      "Tracheadislokation",
      "Xiphoiddislokation"
    ]
  },
  {
    "code": "S23.3",
    "name": "BWS-Verstauchung",
    "synonyms": [
      "BWS-Verstauchung",
      "BWS-Zerrung",
      "Distorsion der Brustwirbelsäule"
    ]
  },
  {
    "code": "S23.4",
    "name": "Rippenzerrung",
    "synonyms": [
      "Brustbeindistorsion",
      "Chondrokostale Distorsion",
      "Chondrosternale Distorsion",
      "Rippendistorsion",
      "Rippenknorpeldistorsion",
      "Rippenverstauchung",
      "Rippenzerrung",
      "Schwertfortsatzdistorsion",
      "Sternalknorpeldistorsion",
      "Sternumdistorsion",
      "Sternumverstauchung"
    ]
  },
  {
    "code": "S23.5",
    "name": "Thoraxdistorsion a.n.k.",
    "synonyms": [
      "Thoraxdistorsion a.n.k."
    ]
  },
  {
    "code": "S24.0",
    "name": "Thorakale Rückenmarkerschütterung",
    "synonyms": [
      "Thorakale Rückenmarkerschütterung",
      "Thorakale Rückenmarkprellung"
    ]
  },
  {
    "code": "S24.10",
    "name": "Brustmarkverletzung",
    "synonyms": [
      "Brustmarkverletzung",
      "Thorakale Rückenmarkverletzung"
    ]
  },
  {
    "code": "S24.11",
    "name": "Komplette Querschnittverletzung des thorakalen Rückenmarks",
    "synonyms": [
      "Komplette Querschnittverletzung des thorakalen Rückenmarks"
    ]
  },
  {
    "code": "S24.12",
    "name": "Hinterhornsyndrom",
    "synonyms": [
      "Hinterhornsyndrom",
      "Inkompletter thorakaler Querschnitt",
      "Vorderhornsyndrom",
      "Zentrales Rückenmarksyndrom"
    ]
  },
  {
    "code": "S24.2",
    "name": "Nervenwurzelverletzung der Brustwirbelsäule",
    "synonyms": [
      "Nervenwurzelverletzung der Brustwirbelsäule",
      "Nervenwurzelverletzung des thorakalen Rückenmarkes"
    ]
  },
  {
    "code": "S24.3",
    "name": "Verletzung peripherer Nerven des Thorax",
    "synonyms": [
      "Verletzung peripherer Nerven des Thorax"
    ]
  },
  {
    "code": "S24.4",
    "name": "Verletzung thorakaler sympathischer Nerven",
    "synonyms": [
      "Verletzung der Ganglia thoracica",
      "Verletzung des Ganglion cervicothoracicum",
      "Verletzung des Ganglion stellatum",
      "Verletzung des Plexus cardiacus",
      "Verletzung des Plexus oesophageus",
      "Verletzung des Plexus pulmonalis",
      "Verletzung sympathischer Nerven des Thorax",
      "Verletzung thorakaler sympathischer Nerven"
    ]
  },
  {
    "code": "S24.6",
    "name": "Nervenverletzung am Thorax",
    "synonyms": [
      "Nervenverletzung am Thorax"
    ]
  },
  {
    "code": "S25.0",
    "name": "Verletzung der Aorta thoracica",
    "synonyms": [
      "Aortenverletzung",
      "Traumatische Aortenruptur",
      "Verletzung der Aorta thoracica"
    ]
  },
  {
    "code": "S25.1",
    "name": "Verletzung des Truncus brachiocephalicus",
    "synonyms": [
      "Verletzung der Arteria anonyma, Truncus brachiocephalicus",
      "Verletzung der Arteria subclavia",
      "Verletzung der Schlüsselbeinschlagader",
      "Verletzung des Truncus brachiocephalicus"
    ]
  },
  {
    "code": "S25.2",
    "name": "Verletzung der Vena cava superior",
    "synonyms": [
      "Verletzung der Vena cava",
      "Verletzung der Vena cava superior",
      "Verletzung der oberen Hohlvene"
    ]
  },
  {
    "code": "S25.3",
    "name": "Verletzung der Vena brachiocephalica",
    "synonyms": [
      "Verletzung der Schlüsselbeinvene",
      "Verletzung der Vena brachiocephalica",
      "Verletzung der Vena subclavia"
    ]
  },
  {
    "code": "S25.4",
    "name": "Pulmonalgefäßverletzung",
    "synonyms": [
      "Pulmonalgefäßverletzung",
      "Verletzung der Arteria pulmonalis",
      "Verletzung einer Pulmonalarterie",
      "Verletzung einer Pulmonalvene"
    ]
  },
  {
    "code": "S25.5",
    "name": "Interkostalgefäßverletzung",
    "synonyms": [
      "Interkostalgefäßverletzung",
      "Verletzung der Arteriae intercostales",
      "Verletzung der Venae intercostales"
    ]
  },
  {
    "code": "S25.7",
    "name": "Verletzung multipler Blutgefäße des Thorax",
    "synonyms": [
      "Verletzung multipler Blutgefäße des Thorax"
    ]
  },
  {
    "code": "S25.80",
    "name": "Verletzung epiduraler Blutgefäße in Höhe des Thorax",
    "synonyms": [
      "Verletzung epiduraler Blutgefäße in Höhe des Thorax"
    ]
  },
  {
    "code": "S25.81",
    "name": "Verletzung subduraler Blutgefäße in Höhe des Thorax",
    "synonyms": [
      "Verletzung subduraler Blutgefäße in Höhe des Thorax"
    ]
  },
  {
    "code": "S25.82",
    "name": "Verletzung subarachnoidaler Blutgefäße in Höhe des Thorax",
    "synonyms": [
      "Verletzung subarachnoidaler Blutgefäße in Höhe des Thorax"
    ]
  },
  {
    "code": "S25.88",
    "name": "Verletzung der Vena azygos",
    "synonyms": [
      "Verletzung der Arteria mammaria",
      "Verletzung der Vena azygos",
      "Verletzung der Vena mammaria"
    ]
  },
  {
    "code": "S25.9",
    "name": "Verletzung eines Blutgefäßes des Thorax",
    "synonyms": [
      "Verletzung eines Blutgefäßes des Thorax"
    ]
  },
  {
    "code": "S26.0",
    "name": "Herzverletzung mit Hämoperikard",
    "synonyms": [
      "Herzlazeration mit Hämoperikard",
      "Herzverletzung mit Hämoperikard",
      "Hämoperikard bei traumatischer Stichwunde des Herzens",
      "Traumatisches Hämoperikard"
    ]
  },
  {
    "code": "S26.81",
    "name": "Herzprellung",
    "synonyms": [
      "Contusio cordis",
      "Herzprellung"
    ]
  },
  {
    "code": "S26.82",
    "name": "Rissverletzung des Herzens ohne Eröffnung einer Herzhöhle",
    "synonyms": [
      "Rissverletzung des Herzens ohne Eröffnung einer Herzhöhle"
    ]
  },
  {
    "code": "S26.83",
    "name": "Rissverletzung des Herzens mit Eröffnung einer Herzhöhle",
    "synonyms": [
      "Rissverletzung des Herzens mit Eröffnung einer Herzhöhle"
    ]
  },
  {
    "code": "S26.88",
    "name": "Traumatisches Pneumoperikard",
    "synonyms": [
      "Herzlazeration",
      "Herzzerreißung",
      "Posttraumatisches Pneumoperikard",
      "Traumatische Herzruptur",
      "Traumatische Myokardruptur",
      "Traumatische Stichwunde des Herzens",
      "Traumatisches Pneumoperikard"
    ]
  },
  {
    "code": "S26.9",
    "name": "Herzverletzung",
    "synonyms": [
      "Herzverletzung",
      "Myokardverletzung"
    ]
  },
  {
    "code": "S27.0",
    "name": "Traumatischer Pneumothorax",
    "synonyms": [
      "Lungenverletzung mit Pneumothorax",
      "Traumatischer Pneumothorax"
    ]
  },
  {
    "code": "S27.1",
    "name": "Traumatischer Hämatothorax",
    "synonyms": [
      "Lungenverletzung mit Hämothorax",
      "Traumatischer Hämatothorax",
      "Traumatischer Hämothorax"
    ]
  },
  {
    "code": "S27.2",
    "name": "Traumatischer Hämatopneumothorax",
    "synonyms": [
      "Lungenverletzung mit Hämatopneumothorax",
      "Lungenverletzung mit Pneumohämatothorax",
      "Traumatischer Hämatopneumothorax",
      "Traumatischer Hämothorax mit Pneumothorax"
    ]
  },
  {
    "code": "S27.31",
    "name": "Lungenkontusion",
    "synonyms": [
      "Lungenkontusion",
      "Lungenprellung"
    ]
  },
  {
    "code": "S27.32",
    "name": "Rissverletzung der Lunge",
    "synonyms": [
      "Lungenabriss",
      "Rissverletzung der Lunge"
    ]
  },
  {
    "code": "S27.38",
    "name": "Traumatischer Hydropneumothorax",
    "synonyms": [
      "Akute Lungenverletzung",
      "Lungenverletzung",
      "Traumatischer Hydropneumothorax"
    ]
  },
  {
    "code": "S27.4",
    "name": "Bronchusverletzung",
    "synonyms": [
      "Bronchusverletzung"
    ]
  },
  {
    "code": "S27.5",
    "name": "Tracheaverletzung der Pars thoracica",
    "synonyms": [
      "Oberflächliche Verletzung der Trachea, Pars thoracica",
      "Offene Wunde der intrathorakalen Trachea",
      "Tracheaprellung der Pars thoracica",
      "Tracheaverletzung der Pars thoracica"
    ]
  },
  {
    "code": "S27.6",
    "name": "Pleuraverletzung",
    "synonyms": [
      "Akute traumatische Pleuritis",
      "Pleuraverletzung",
      "Späte traumatische Pleuritis"
    ]
  },
  {
    "code": "S27.7",
    "name": "Multiple Verletzungen intrathorakaler Organe",
    "synonyms": [
      "Multiple Verletzungen intrathorakaler Organe",
      "Multiple Verletzungen thorakaler Eingeweide a.n.k."
    ]
  },
  {
    "code": "S27.81",
    "name": "Diaphragmaeinriss",
    "synonyms": [
      "Diaphragmaeinriss",
      "Diaphragmaverletzung",
      "Traumatische Diaphragmaruptur"
    ]
  },
  {
    "code": "S27.82",
    "name": "Verletzung des Ductus thoracicus",
    "synonyms": [
      "Verletzung des Ductus thoracicus"
    ]
  },
  {
    "code": "S27.83",
    "name": "Ösophagusverletzung",
    "synonyms": [
      "Oberflächliche thorakale Ösophagusverletzung",
      "Thorakale Ösophagusprellung",
      "Ösophagusverletzung"
    ]
  },
  {
    "code": "S27.84",
    "name": "Thymusverletzung",
    "synonyms": [
      "Thymusverletzung"
    ]
  },
  {
    "code": "S27.88",
    "name": "Mediastinumhämatom",
    "synonyms": [
      "Mediastinumhämatom",
      "Mediastinumverletzung",
      "Traumatischer Hydrothorax"
    ]
  },
  {
    "code": "S27.9",
    "name": "Verletzung eines intrathorakalen Organs",
    "synonyms": [
      "Innere Thoraxverletzung",
      "Verletzung der Thoraxhöhle",
      "Verletzung eines intrathorakalen Organs"
    ]
  },
  {
    "code": "S28.0",
    "name": "Brustkorbzerquetschung",
    "synonyms": [
      "Asphyxie durch Verschüttung mit Zerquetschung",
      "Asphyxie durch Zerquetschung",
      "Brustkorbzerquetschung",
      "Thoraxzerquetschung",
      "Traumatische Asphyxie durch Brustkorbzerquetschung a.n.k.",
      "Traumatische Asphyxie durch Thoraxzerquetschung a.n.k."
    ]
  },
  {
    "code": "S28.1",
    "name": "Traumatische Amputation eines Thoraxteils",
    "synonyms": [
      "Traumatische Amputation eines Thoraxteils"
    ]
  },
  {
    "code": "S29.0",
    "name": "Verletzung von Muskeln am Thorax",
    "synonyms": [
      "Verletzung von Muskeln am Thorax"
    ]
  },
  {
    "code": "S29.7",
    "name": "Multiple Verletzungen des Thorax",
    "synonyms": [
      "Multiple Verletzungen des Thorax"
    ]
  },
  {
    "code": "S29.80",
    "name": "Verletzung thorakaler Rückenmarkhäute",
    "synonyms": [
      "Verletzung thorakaler Rückenmarkhäute"
    ]
  },
  {
    "code": "S29.88",
    "name": "Schmerzen nach Thoraxtrauma",
    "synonyms": [
      "Schmerzen nach Thoraxtrauma"
    ]
  },
  {
    "code": "S29.9",
    "name": "Thoraxtrauma",
    "synonyms": [
      "Brustkorbtrauma",
      "Brustverletzung a.n.k.",
      "Kostale Verletzung a.n.k.",
      "Kostochondrale Verletzung a.n.k.",
      "Stumpfes Thoraxtrauma",
      "Thorakale Verletzung",
      "Thoraxtrauma",
      "Thoraxverletzung",
      "Verletzung der Brustbeingegend",
      "Verletzung der Sternalregion"
    ]
  },
  {
    "code": "S30.0",
    "name": "Gesäßprellung",
    "synonyms": [
      "Beckenprellung",
      "Gesäßprellung",
      "Glutäalhämatom",
      "LWS-Prellung",
      "Oberflächliches traumatisches Beckenhämatom",
      "Prellung der Kreuzbeingegend",
      "Prellung der Lendenwirbelsäule",
      "Prellung der Lumbalgegend",
      "Prellung der Lumbalregion",
      "Prellung der Lumbosakralgegend",
      "Prellung der Sakralgegend",
      "Steißbeinprellung",
      "Wirbelsäulenprellung der Lumbalregion"
    ]
  },
  {
    "code": "S30.1",
    "name": "Leistenprellung",
    "synonyms": [
      "Bauchdeckenprellung",
      "Flankenprellung",
      "Leistenprellung",
      "Lendenprellung",
      "Oberflächliche Verletzung der Bauchdecke",
      "Prellung der Darmbeingegend",
      "Prellung der Iliakalregion",
      "Prellung der Inguinalregion",
      "Prellung der Leistengegend",
      "Prellung der Lendengegend",
      "Prellung der Schamgegend",
      "Prellung des Abdomens",
      "Prellung des Epigastriums",
      "Rektusscheidenhämatom durch Bauchwandprellung"
    ]
  },
  {
    "code": "S30.2",
    "name": "Prellung der äußeren Genitalorgane",
    "synonyms": [
      "Epididymisprellung",
      "Hodenkontusion",
      "Hodenprellung",
      "Hodenquetschung",
      "Klitorisprellung",
      "Labienprellung",
      "Nebenhodenprellung",
      "Oberflächliche Verletzung der äußeren Genitalien",
      "Penisprellung",
      "Penisquetschung",
      "Perineales Hämatom",
      "Perineumprellung",
      "Prellung der Labia majora pudendi",
      "Prellung der Labia minora pudendi",
      "Prellung der Tunica vaginalis testis",
      "Prellung der äußeren Genitalorgane",
      "Prellung der äußeren Geschlechtsorgane",
      "Prellung des Corpus cavernosum",
      "Prellung des Präputiums",
      "Prellung des Testis",
      "Skrotumhämatom",
      "Skrotumkontusion",
      "Skrotumprellung",
      "Skrotumquetschung",
      "Traumatische Hodenblutung",
      "Vulvaprellung",
      "Vulvaquetschung"
    ]
  },
  {
    "code": "S30.7",
    "name": "Multiple oberflächliche Verletzungen des Beckens, der Bauchregion und der Lumbosakralregion",
    "synonyms": [
      "Multiple oberflächliche Verletzungen des Abdomens, der Beckengegend und der Lumbosakralregion",
      "Multiple oberflächliche Verletzungen des Beckens, der Bauchregion und der Lumbosakralregion"
    ]
  },
  {
    "code": "S30.81",
    "name": "Schürfwunde am Abdomen",
    "synonyms": [
      "Schürfwunde am Abdomen",
      "Schürfwunde am Becken",
      "Schürfwunde an der Lumbosakralgegend"
    ]
  },
  {
    "code": "S30.82",
    "name": "Nichtthermische Blasenbildung am Abdomen",
    "synonyms": [
      "Nichtthermische Blasenbildung am Abdomen",
      "Nichtthermische Blasenbildung am Becken",
      "Nichtthermische Blasenbildung an der Lumbosakralgegend"
    ]
  },
  {
    "code": "S30.83",
    "name": "Ungiftiger Insektenbiss am Abdomen",
    "synonyms": [
      "Ungiftiger Insektenbiss am Abdomen",
      "Ungiftiger Insektenbiss am Becken",
      "Ungiftiger Insektenbiss an der Lumbosakralgegend"
    ]
  },
  {
    "code": "S30.84",
    "name": "Oberflächlicher Fremdkörper am Abdomen",
    "synonyms": [
      "Oberflächlicher Fremdkörper am Abdomen",
      "Oberflächlicher Fremdkörper am Becken",
      "Oberflächlicher Fremdkörper an der Lumbosakralgegend",
      "Splitter am Abdomen",
      "Splitter am Becken",
      "Splitter an der Lumbosakralgegend"
    ]
  },
  {
    "code": "S30.86",
    "name": "Subkutanes Décollement am Abdomen",
    "synonyms": [
      "Subkutanes Décollement am Abdomen",
      "Subkutanes Décollement am Becken",
      "Subkutanes Décollement an der Lumbosakralgegend"
    ]
  },
  {
    "code": "S30.9",
    "name": "Oberflächliche Gesäßverletzung",
    "synonyms": [
      "Oberflächliche Abdomenverletzung",
      "Oberflächliche Anusverletzung",
      "Oberflächliche Beckenverletzung",
      "Oberflächliche Dammverletzung",
      "Oberflächliche Epididymisverletzung",
      "Oberflächliche Flankenverletzung",
      "Oberflächliche Gesäßverletzung",
      "Oberflächliche Hodenverletzung",
      "Oberflächliche Klitorisverletzung",
      "Oberflächliche Lendenverletzung",
      "Oberflächliche Nebenhodenverletzung",
      "Oberflächliche Penisverletzung",
      "Oberflächliche Testisverletzung",
      "Oberflächliche Vaginaverletzung",
      "Oberflächliche Verletzung der Abdomenwand",
      "Oberflächliche Verletzung der Darmbeingegend",
      "Oberflächliche Verletzung der Kreuzbeingegend",
      "Oberflächliche Verletzung der Labia majora pudendi",
      "Oberflächliche Verletzung der Labia minora pudendi",
      "Oberflächliche Verletzung der Leistengegend",
      "Oberflächliche Verletzung der Lumbosakralgegend",
      "Oberflächliche Verletzung der Pudenda",
      "Oberflächliche Verletzung der Regio lumbalis",
      "Oberflächliche Verletzung der Regio pubica",
      "Oberflächliche Verletzung der Regio sacralis",
      "Oberflächliche Verletzung der Schamgegend",
      "Oberflächliche Verletzung der Tunica vaginalis testis",
      "Oberflächliche Verletzung des Epigastriums",
      "Oberflächliche Verletzung des Perineums",
      "Oberflächliche Verletzung des Präputiums",
      "Oberflächliche Verletzung des Skrotums",
      "Oberflächliche Verletzung des unteren Rückens",
      "Oberflächliche Vulvaverletzung"
    ]
  },
  {
    "code": "S31.0",
    "name": "Offene Gesäßwunde",
    "synonyms": [
      "Beckenbodenlazeration",
      "Beckenbodenlazeration, nicht das Wochenbett betreffend",
      "Beckenbodenperforation",
      "Dammriss",
      "Dammriss beim Mann",
      "Dammriss, nicht bei Geburt",
      "Offene Beckenwunde",
      "Offene Gesäßwunde",
      "Offene Lendenwunde",
      "Offene Perinealwunde",
      "Offene Wunde der Beckenregion",
      "Offene Wunde der Kreuzbeingegend",
      "Offene Wunde der Lumbalgegend",
      "Offene Wunde der Lumbosakralregion",
      "Offene Wunde der Sakralgegend",
      "Offene Wunde der Sakroiliakalgegend",
      "Offene Wunde des Beckenbodens",
      "Perineale Lazeration beim Mann",
      "Perineallazeration",
      "Perinealriss"
    ]
  },
  {
    "code": "S31.1",
    "name": "Offene Bauchdeckenwunde",
    "synonyms": [
      "Nabelwunde",
      "Offene Bauchdeckenwunde",
      "Offene Flankenwunde",
      "Offene Leistenwunde",
      "Offene Wunde der Darmbeingegend",
      "Offene Wunde der Iliakalregion",
      "Offene Wunde der Inguinalregion",
      "Offene Wunde der Leistengegend",
      "Offene Wunde der Nabelgegend",
      "Offene Wunde der Oberbauchgegend",
      "Offene Wunde der Regio inguinalis",
      "Offene Wunde der Schambeinregion",
      "Offene Wunde der Schamgegend",
      "Offene Wunde der Unterbauchgegend",
      "Offene Wunde des Epigastriums",
      "Offene Wunde des Hypochondrium"
    ]
  },
  {
    "code": "S31.2",
    "name": "Penisruptur",
    "synonyms": [
      "Offene Peniswunde",
      "Offene Wunde des Präputiums",
      "Penisablederung",
      "Penisdécollement",
      "Penisruptur",
      "Traumatische Penisruptur"
    ]
  },
  {
    "code": "S31.3",
    "name": "Offene Hodenwunde",
    "synonyms": [
      "Offene Hodenwunde",
      "Offene Skrotalwunde",
      "Offene Wunde der Epididymis",
      "Offene Wunde der Tunica vaginalis testis",
      "Offene Wunde des Nebenhodens",
      "Offene Wunde des skrotalen Samenstranges"
    ]
  },
  {
    "code": "S31.4",
    "name": "Schnittverletzung der Vagina",
    "synonyms": [
      "Dammscheidenriss",
      "Klitorisriss",
      "Kolporrhexis",
      "Labienriss",
      "Offene Hymenwunde",
      "Offene Klitoriswunde",
      "Offene Vaginalwunde",
      "Offene Vulvawunde",
      "Offene Wunde der Labia majora pudendi",
      "Offene Wunde der Labia minora pudendi",
      "Offene Wunde der Pudenda",
      "Scheidendammriss",
      "Scheidenriss",
      "Schnittverletzung der Vagina",
      "Traumatische Vaginaruptur",
      "Vaginalazeration",
      "Vaginariss",
      "Vaginaruptur",
      "Vulvalazeration"
    ]
  },
  {
    "code": "S31.5",
    "name": "Offene Wunde der äußeren Genitalorgane",
    "synonyms": [
      "Offene Wunde der äußeren Genitalorgane",
      "Offene Wunde der äußeren Geschlechtsorgane a.n.k."
    ]
  },
  {
    "code": "S31.7",
    "name": "Multiple offene Wunden an Lumbosakralregion, Becken und Abdomen",
    "synonyms": [
      "Multiple offene Wunden an Lumbosakralregion, Becken und Abdomen"
    ]
  },
  {
    "code": "S31.80",
    "name": "Offene Abdominalwunde",
    "synonyms": [
      "Afterriss",
      "Analriss",
      "Analsphinkterlazeration",
      "Analsphinkterriss",
      "Lazeration des Septum rectovaginale",
      "Offene Abdominalwunde",
      "Offene Analwunde",
      "Offene Wunde des Abdomens",
      "Offene Wunde des Analsphinkters",
      "Offene Wunde des Septum rectovaginale"
    ]
  },
  {
    "code": "S32.00",
    "name": "Lendenwirbelfraktur",
    "synonyms": [
      "Fraktur der Lendenwirbelsäule",
      "Fraktur eines Lumbosakralwirbels",
      "Fraktur eines lumbosakralen Dornfortsatzes",
      "Fraktur eines lumbosakralen Querfortsatzes",
      "Fraktur eines lumbosakralen Wirbelbogens",
      "Kompressionsfraktur des Lendenwirbels",
      "LWS-Fraktur",
      "Lendenwirbelfraktur",
      "Offene Lendenwirbelsäulenluxation"
    ]
  },
  {
    "code": "S32.01",
    "name": "Lendenwirbelfraktur L1",
    "synonyms": [
      "Lendenwirbelfraktur L1"
    ]
  },
  {
    "code": "S32.02",
    "name": "Lendenwirbelfraktur L2",
    "synonyms": [
      "Lendenwirbelfraktur L2"
    ]
  },
  {
    "code": "S32.03",
    "name": "Lendenwirbelfraktur L3",
    "synonyms": [
      "Lendenwirbelfraktur L3"
    ]
  },
  {
    "code": "S32.04",
    "name": "Lendenwirbelfraktur L4",
    "synonyms": [
      "Lendenwirbelfraktur L4"
    ]
  },
  {
    "code": "S32.05",
    "name": "Lendenwirbelfraktur L5",
    "synonyms": [
      "Lendenwirbelfraktur L5"
    ]
  },
  {
    "code": "S32.1",
    "name": "Fraktur des Os sacrum",
    "synonyms": [
      "Fraktur des Os sacrum",
      "Kreuzbeinfraktur"
    ]
  },
  {
    "code": "S32.2",
    "name": "Steißbeinfraktur",
    "synonyms": [
      "Fraktur des Os coccygis",
      "Steißbeinbruch",
      "Steißbeinfraktur"
    ]
  },
  {
    "code": "S32.3",
    "name": "Fraktur des Os ilium",
    "synonyms": [
      "Darmbeinfraktur",
      "Fraktur des Os ilium",
      "Hüftbeinfraktur",
      "Iliumfraktur"
    ]
  },
  {
    "code": "S32.4",
    "name": "Hüftgelenkpfannendachfraktur",
    "synonyms": [
      "Azetabulumbruch",
      "Azetabulumfraktur",
      "Hüftgelenkpfannendachfraktur",
      "Hüftgelenkpfannenfraktur",
      "Hüftpfannengrundfraktur"
    ]
  },
  {
    "code": "S32.5",
    "name": "Schambeinfraktur",
    "synonyms": [
      "Fraktur der Symphysis pubica",
      "Fraktur des Os pubis",
      "Fraktur des Ramus inferior des Os pubis",
      "Fraktur des Ramus superior des Os pubis",
      "Schambeinbruch",
      "Schambeinfraktur"
    ]
  },
  {
    "code": "S32.7",
    "name": "Malgaigne-Beckenringfraktur",
    "synonyms": [
      "Beckenringbruch",
      "Beckenringfraktur",
      "Komplexe Beckenfraktur",
      "Laterale Kompressionsfraktur des Beckens",
      "Malgaigne-Beckenfraktur",
      "Malgaigne-Beckenringfraktur",
      "Multiple Beckenknochenfrakturen",
      "Multiple Frakturen des Beckens und der Lendenwirbelsäule",
      "Multiple Lendenwirbelfrakturen",
      "Schmetterlingsbruch des Beckens",
      "Vertical shear fracture des Beckens",
      "Vertikale Abscher-Fraktur [Vertical shear fracture]"
    ]
  },
  {
    "code": "S32.81",
    "name": "Sitzbeinfraktur",
    "synonyms": [
      "Fraktur des Os ischii",
      "Sitzbeinfraktur"
    ]
  },
  {
    "code": "S32.82",
    "name": "Lendenwirbelsäulenfraktur mit Kreuzbeinfraktur",
    "synonyms": [
      "Lendenwirbelsäulenfraktur mit Kreuzbeinfraktur"
    ]
  },
  {
    "code": "S32.89",
    "name": "Beckenbruch",
    "synonyms": [
      "Beckenbruch",
      "Beckenfraktur",
      "Beckenknochenfraktur",
      "Beckenrandfraktur"
    ]
  },
  {
    "code": "S33.0",
    "name": "Traumatische Ruptur der lumbalen Bandscheibe",
    "synonyms": [
      "Traumatische Ruptur der lumbalen Bandscheibe"
    ]
  },
  {
    "code": "S33.10",
    "name": "LWS-Luxation",
    "synonyms": [
      "Akute traumatische lumbale Spondylolisthesis",
      "Akute traumatische lumbosakrale Spondylolisthesis",
      "LWS-Luxation",
      "Lendenwirbeldislokation",
      "Lendenwirbelsäulenluxation",
      "Lumbale Wirbelsäulendislokation",
      "Lumbosakrale Dislokation"
    ]
  },
  {
    "code": "S33.11",
    "name": "Lendenwirbelluxation L1/L2",
    "synonyms": [
      "Lendenwirbelluxation L1/L2"
    ]
  },
  {
    "code": "S33.12",
    "name": "Lendenwirbelluxation L2/L3",
    "synonyms": [
      "Lendenwirbelluxation L2/L3"
    ]
  },
  {
    "code": "S33.13",
    "name": "Lendenwirbelluxation L3/L4",
    "synonyms": [
      "Lendenwirbelluxation L3/L4"
    ]
  },
  {
    "code": "S33.14",
    "name": "Lendenwirbelluxation L4/L5",
    "synonyms": [
      "Lendenwirbelluxation L4/L5"
    ]
  },
  {
    "code": "S33.15",
    "name": "Lendenwirbelluxation L5/S1",
    "synonyms": [
      "Lendenwirbelluxation L5/S1"
    ]
  },
  {
    "code": "S33.2",
    "name": "Dislokation der Articulatio sacroiliaca",
    "synonyms": [
      "Dislokation der Articulatio sacroiliaca",
      "Dislokation des Iliosakralgelenks",
      "Frische Iliosakralgelenkverschiebung",
      "Kreuzbeindislokation",
      "Sakrokokzygeale Dislokation",
      "Sakrumdislokation",
      "Steißbeindislokation"
    ]
  },
  {
    "code": "S33.3",
    "name": "Beckendislokation",
    "synonyms": [
      "Beckendislokation",
      "Dislokation der Schambeinfuge",
      "Luxation der Symphysenspalte",
      "Offene Beckenluxation"
    ]
  },
  {
    "code": "S33.4",
    "name": "Traumatische Symphysensprengung",
    "synonyms": [
      "Traumatische Schambeinfugenruptur",
      "Traumatische Symphysenruptur",
      "Traumatische Symphysensprengung",
      "Traumatischer Symphyseneinriss"
    ]
  },
  {
    "code": "S33.50",
    "name": "LWS-Verstauchung",
    "synonyms": [
      "Distorsion der Lendenwirbelsäule",
      "LWS-Distorsion",
      "LWS-Verstauchung",
      "LWS-Zerrung"
    ]
  },
  {
    "code": "S33.51",
    "name": "Lumbosakrale Distorsion",
    "synonyms": [
      "Lumbosakrale Distorsion",
      "Verstauchung der Junctura lumbosacralis und ihrer Bänder",
      "Zerrung der Bänder der Junctura lumbosacralis"
    ]
  },
  {
    "code": "S33.6",
    "name": "Iliosakrale Distorsion",
    "synonyms": [
      "Distorsion der Kreuzbeinverbindung",
      "Distorsion eines iliosakralen Bandes",
      "Iliosakrale Distorsion"
    ]
  },
  {
    "code": "S33.7",
    "name": "Beckendistorsion a.n.k.",
    "synonyms": [
      "Beckendistorsion a.n.k.",
      "Beckendistorsion an der Schambeinverbindung a.n.k.",
      "Distorsion der Symphysis pubica",
      "Distorsion des Ligamentum sacrotuberale",
      "Kreuzbeindistorsion",
      "Sakrokokzygeale Distorsion",
      "Steißbeindistorsion"
    ]
  },
  {
    "code": "S34.0",
    "name": "Kontusion des lumbalen Rückenmarks mit Ödem",
    "synonyms": [
      "Kontusion des lumbalen Rückenmarks mit Ödem",
      "Lumbale Rückenmarkerschütterung",
      "Lumbale Rückenmarkprellung"
    ]
  },
  {
    "code": "S34.10",
    "name": "Komplette Querschnittverletzung des lumbalen Rückenmarks",
    "synonyms": [
      "Komplette Querschnittverletzung des lumbalen Rückenmarks"
    ]
  },
  {
    "code": "S34.11",
    "name": "Inkomplette Querschnittverletzung des lumbalen Rückenmarks",
    "synonyms": [
      "Inkomplette Querschnittverletzung des lumbalen Rückenmarks"
    ]
  },
  {
    "code": "S34.18",
    "name": "Lumbale Rückenmarkverletzung",
    "synonyms": [
      "Lumbale Rückenmarkverletzung"
    ]
  },
  {
    "code": "S34.2",
    "name": "Verletzung der sakralen Nervenwurzel",
    "synonyms": [
      "Verletzung der lumbalen Nervenwurzel",
      "Verletzung der lumbosakralen Nervenwurzel",
      "Verletzung der sakralen Nervenwurzel"
    ]
  },
  {
    "code": "S34.30",
    "name": "Komplettes traumatisches Cauda-equina-Syndrom",
    "synonyms": [
      "Komplettes traumatisches Cauda-equina-Syndrom"
    ]
  },
  {
    "code": "S34.31",
    "name": "Inkomplettes traumatisches Cauda-equina-Syndrom",
    "synonyms": [
      "Inkomplettes traumatisches Cauda-equina-Syndrom"
    ]
  },
  {
    "code": "S34.38",
    "name": "Verletzung der Cauda equina",
    "synonyms": [
      "Erschütterung der Cauda equina",
      "Erschütterung des Conus medullaris",
      "Rückenmarkprellung der Cauda equina",
      "Rückenmarkprellung des Conus medullaris",
      "Verletzung der Cauda equina"
    ]
  },
  {
    "code": "S34.4",
    "name": "Verletzung des Plexus lumbosacralis",
    "synonyms": [
      "Verletzung des Plexus lumbosacralis",
      "Verletzung des Plexus sacralis",
      "Verletzung des Sakralnervengeflechtes"
    ]
  },
  {
    "code": "S34.5",
    "name": "Verletzung der Ganglia coeliaca",
    "synonyms": [
      "Verletzung der Ganglia coeliaca",
      "Verletzung der Nervi splanchnici",
      "Verletzung des Plexus coeliacus",
      "Verletzung des Plexus hypogastricus",
      "Verletzung des Plexus mesentericus inferior",
      "Verletzung des Plexus mesentericus superior",
      "Verletzung eines sympathischen Nerven a.n.k."
    ]
  },
  {
    "code": "S34.6",
    "name": "Verletzung peripherer Nerven der Lumbosakralgegend",
    "synonyms": [
      "Verletzung peripherer Nerven der Lumbosakralgegend",
      "Verletzung peripherer Nerven des Abdomens",
      "Verletzung peripherer Nerven des Beckens"
    ]
  },
  {
    "code": "S34.8",
    "name": "Nervenverletzung in Höhe des Abdomens",
    "synonyms": [
      "Nervenverletzung der Lumbosakralgegend",
      "Nervenverletzung des Beckens",
      "Nervenverletzung in Höhe des Abdomens"
    ]
  },
  {
    "code": "S35.0",
    "name": "Verletzung der Aorta abdominalis",
    "synonyms": [
      "Traumatische Aortenruptur im Abdomen",
      "Traumatische Ruptur der Aorta abdominalis",
      "Verletzung der Aorta abdominalis"
    ]
  },
  {
    "code": "S35.1",
    "name": "Verletzung der Vena cava inferior",
    "synonyms": [
      "Verletzung der Vena cava inferior",
      "Verletzung der Venae hepaticae",
      "Verletzung der unteren Hohlvene"
    ]
  },
  {
    "code": "S35.2",
    "name": "Verletzung der Arteria gastrica",
    "synonyms": [
      "Verletzung der Arteria coeliaca",
      "Verletzung der Arteria gastrica",
      "Verletzung der Arteria gastroduodenalis",
      "Verletzung der Arteria hepatica",
      "Verletzung der Arteria lienalis",
      "Verletzung der Arteria mesenterica",
      "Verletzung der Arteria mesenterica inferior",
      "Verletzung der Arteria mesenterica superior",
      "Verletzung der Milzarterie",
      "Verletzung des Truncus coeliacus",
      "Verletzung einer Mesenterialarterie"
    ]
  },
  {
    "code": "S35.3",
    "name": "Verletzung der Vena mesenterica inferior",
    "synonyms": [
      "Pfortaderverletzung",
      "Verletzung der Milzvene",
      "Verletzung der Vena lienalis",
      "Verletzung der Vena mesenterica",
      "Verletzung der Vena mesenterica inferior",
      "Verletzung der Vena mesenterica superior",
      "Verletzung der Vena portae",
      "Verletzung einer Mesenterialvene"
    ]
  },
  {
    "code": "S35.4",
    "name": "Verletzung eines Blutgefäßes der Niere",
    "synonyms": [
      "Verletzung der Arteria renalis",
      "Verletzung der Arteriae renales",
      "Verletzung der Vena renalis",
      "Verletzung der Venae renales",
      "Verletzung eines Blutgefäßes der Niere"
    ]
  },
  {
    "code": "S35.5",
    "name": "Verletzung eines Blutgefäßes der Iliakalregion",
    "synonyms": [
      "Verletzung der Arteria iliaca",
      "Verletzung der Vena iliaca",
      "Verletzung eines Blutgefäßes der Iliakalregion"
    ]
  },
  {
    "code": "S35.7",
    "name": "Multiple Blutgefäßverletzungen am Abdomen",
    "synonyms": [
      "Multiple Blutgefäßverletzungen am Abdomen",
      "Multiple Blutgefäßverletzungen im Becken",
      "Multiple Blutgefäßverletzungen in der Lumbosakralgegend"
    ]
  },
  {
    "code": "S35.80",
    "name": "Verletzung epiduraler Blutgefäße in Höhe des Abdomens",
    "synonyms": [
      "Verletzung epiduraler Blutgefäße in Höhe der Lumbosakralgegend",
      "Verletzung epiduraler Blutgefäße in Höhe des Abdomens",
      "Verletzung epiduraler Blutgefäße in Höhe des Beckens"
    ]
  },
  {
    "code": "S35.81",
    "name": "Verletzung subduraler Blutgefäße in Höhe des Abdomens",
    "synonyms": [
      "Verletzung subduraler Blutgefäße in Höhe der Lumbosakralgegend",
      "Verletzung subduraler Blutgefäße in Höhe des Abdomens",
      "Verletzung subduraler Blutgefäße in Höhe des Beckens"
    ]
  },
  {
    "code": "S35.82",
    "name": "Verletzung subarachnoidaler Blutgefäße in Höhe des Abdomens",
    "synonyms": [
      "Verletzung subarachnoidaler Blutgefäße in Höhe der Lumbosakralgegend",
      "Verletzung subarachnoidaler Blutgefäße in Höhe des Abdomens",
      "Verletzung subarachnoidaler Blutgefäße in Höhe des Beckens"
    ]
  },
  {
    "code": "S35.88",
    "name": "Verletzung der Vena uterina",
    "synonyms": [
      "Verletzung der Arteria hypogastrica",
      "Verletzung der Arteria ovarica",
      "Verletzung der Arteria uterina",
      "Verletzung der Vena gastrica",
      "Verletzung der Vena hypogastrica",
      "Verletzung der Vena ovarica",
      "Verletzung der Vena uterina"
    ]
  },
  {
    "code": "S35.9",
    "name": "Verletzung eines Blutgefäßes des Abdomens",
    "synonyms": [
      "Verletzung eines Blutgefäßes der Lumbosakralregion",
      "Verletzung eines Blutgefäßes der Milz",
      "Verletzung eines Blutgefäßes des Abdomens",
      "Verletzung eines Blutgefäßes des Beckens",
      "Verletzung eines mesenterialen Blutgefäßes"
    ]
  },
  {
    "code": "S36.00",
    "name": "Milzverletzung",
    "synonyms": [
      "Milzverletzung"
    ]
  },
  {
    "code": "S36.01",
    "name": "Milzhämatom",
    "synonyms": [
      "Milzhämatom"
    ]
  },
  {
    "code": "S36.02",
    "name": "Kapselriss der Milz ohne größeren Einriss des Parenchyms",
    "synonyms": [
      "Kapselriss der Milz ohne größeren Einriss des Parenchyms"
    ]
  },
  {
    "code": "S36.03",
    "name": "Rissverletzung der Milz mit Beteiligung des Parenchyms",
    "synonyms": [
      "Rissverletzung der Milz mit Beteiligung des Parenchyms"
    ]
  },
  {
    "code": "S36.04",
    "name": "Massive Parenchymruptur der Milz",
    "synonyms": [
      "Abriss des Milzhilus",
      "Massive Parenchymruptur der Milz"
    ]
  },
  {
    "code": "S36.08",
    "name": "Milzriss",
    "synonyms": [
      "Milzriss",
      "Milzruptur",
      "Traumatische Milzruptur"
    ]
  },
  {
    "code": "S36.10",
    "name": "Leberverletzung",
    "synonyms": [
      "Leberverletzung"
    ]
  },
  {
    "code": "S36.11",
    "name": "Leberhämatom",
    "synonyms": [
      "Leberhämatom",
      "Leberprellung"
    ]
  },
  {
    "code": "S36.12",
    "name": "Traumatische Leberruptur",
    "synonyms": [
      "Lebereinriss",
      "Leberriss",
      "Leberruptur",
      "Traumatische Leberruptur"
    ]
  },
  {
    "code": "S36.13",
    "name": "Leberkapselriss",
    "synonyms": [
      "Leberkapselriss",
      "Leichte Rissverletzung der Leber"
    ]
  },
  {
    "code": "S36.14",
    "name": "Mittelschwere Rissverletzung der Leber",
    "synonyms": [
      "Mittelschwere Rissverletzung der Leber"
    ]
  },
  {
    "code": "S36.15",
    "name": "Schwere Rissverletzung der Leber",
    "synonyms": [
      "Schwere Rissverletzung der Leber"
    ]
  },
  {
    "code": "S36.17",
    "name": "Gallenblasenverletzung",
    "synonyms": [
      "Gallenblasenverletzung"
    ]
  },
  {
    "code": "S36.18",
    "name": "Gallengangsverletzung",
    "synonyms": [
      "Gallengangsverletzung",
      "Verletzung des Ductus choledochus",
      "Verletzung des Ductus cysticus",
      "Verletzung des Ductus hepaticus"
    ]
  },
  {
    "code": "S36.20",
    "name": "Pankreasverletzung",
    "synonyms": [
      "Pankreasverletzung",
      "Traumatische Pankreasruptur"
    ]
  },
  {
    "code": "S36.21",
    "name": "Verletzung des Pankreaskopfes",
    "synonyms": [
      "Verletzung des Pankreaskopfes"
    ]
  },
  {
    "code": "S36.22",
    "name": "Verletzung des Pankreaskörpers",
    "synonyms": [
      "Verletzung des Pankreaskörpers"
    ]
  },
  {
    "code": "S36.23",
    "name": "Verletzung des Pankreasschwanzes",
    "synonyms": [
      "Verletzung des Pankreasschwanzes"
    ]
  },
  {
    "code": "S36.3",
    "name": "Magenverletzung",
    "synonyms": [
      "Magenverletzung",
      "Traumatische Magenruptur"
    ]
  },
  {
    "code": "S36.40",
    "name": "Dünndarmverletzung",
    "synonyms": [
      "Dünndarmverletzung"
    ]
  },
  {
    "code": "S36.41",
    "name": "Duodenalverletzung",
    "synonyms": [
      "Duodenalverletzung",
      "Traumatische Duodenalperforation",
      "Traumatische Duodenalruptur"
    ]
  },
  {
    "code": "S36.49",
    "name": "Ileumverletzung",
    "synonyms": [
      "Ileumverletzung",
      "Jejunumverletzung",
      "Traumatische Ileumperforation",
      "Traumatische Ileumruptur",
      "Traumatische Jejunumperforation",
      "Traumatische Jejunumruptur"
    ]
  },
  {
    "code": "S36.50",
    "name": "Dickdarmverletzung",
    "synonyms": [
      "Dickdarmverletzung",
      "Kolonverletzung",
      "Traumatische Kolonperforation",
      "Traumatische Kolonruptur"
    ]
  },
  {
    "code": "S36.51",
    "name": "Verletzung des Colon ascendens",
    "synonyms": [
      "Verletzung des Colon ascendens"
    ]
  },
  {
    "code": "S36.52",
    "name": "Verletzung des Colon transversum",
    "synonyms": [
      "Verletzung des Colon transversum"
    ]
  },
  {
    "code": "S36.53",
    "name": "Verletzung des Colon descendens",
    "synonyms": [
      "Verletzung des Colon descendens"
    ]
  },
  {
    "code": "S36.54",
    "name": "Traumatische Sigmaperforation",
    "synonyms": [
      "Traumatische Sigmaperforation",
      "Traumatische Sigmaruptur",
      "Verletzung des Colon sigmoideum"
    ]
  },
  {
    "code": "S36.59",
    "name": "Zäkumverletzung",
    "synonyms": [
      "Zäkumverletzung"
    ]
  },
  {
    "code": "S36.6",
    "name": "Rektumverletzung",
    "synonyms": [
      "Rektumverletzung",
      "Traumatische Rektumperforation"
    ]
  },
  {
    "code": "S36.7",
    "name": "Multiple Eingeweideverletzungen",
    "synonyms": [
      "Multiple Eingeweideverletzungen",
      "Multiple Verletzungen der Viszera",
      "Multiple intraabdominale Organverletzungen"
    ]
  },
  {
    "code": "S36.81",
    "name": "Traumatisches Hämoperitoneum",
    "synonyms": [
      "Peritonealverletzung",
      "Traumatisches Hämoperitoneum"
    ]
  },
  {
    "code": "S36.82",
    "name": "Mesenterialabriss",
    "synonyms": [
      "Mesenterialabriss",
      "Mesenterialriss",
      "Mesenterialruptur",
      "Mesenterialverletzung"
    ]
  },
  {
    "code": "S36.83",
    "name": "Retroperitoneale Verletzung",
    "synonyms": [
      "Retroperitoneale Verletzung",
      "Traumatisches retroperitoneales Hämatom"
    ]
  },
  {
    "code": "S36.9",
    "name": "Verletzung intraabdominaler Organe",
    "synonyms": [
      "Darmverletzung",
      "Magen-Darm-Trakt-Verletzung",
      "Traumatische Darmperforation",
      "Traumatische Darmruptur",
      "Traumatische Intestinalperforation",
      "Traumatische Intestinalruptur",
      "Verletzung intraabdominaler Organe"
    ]
  },
  {
    "code": "S37.00",
    "name": "Nierenläsion",
    "synonyms": [
      "Geschlossene Nierenverletzung",
      "Nierenläsion",
      "Nierenpoltrauma",
      "Nierentrauma",
      "Nierenverletzung"
    ]
  },
  {
    "code": "S37.01",
    "name": "Nierenhämatom",
    "synonyms": [
      "Commotio renis",
      "Nierenhämatom",
      "Nierenkontusion",
      "Nierenprellung",
      "Nierenquetschung",
      "Perirenales Hämatom",
      "Renales Hämatom"
    ]
  },
  {
    "code": "S37.02",
    "name": "Nierenbeckenruptur",
    "synonyms": [
      "Nierenbeckenruptur",
      "Nierenstielabriss",
      "Nierenstielverletzung",
      "Riss der Nierenkapsel",
      "Rissverletzung der Niere mit Kapselriss",
      "Rissverletzung der Niere mit Verletzung der Nierenkapsel",
      "Rissverletzung der Niere mit Verletzung des Nierenbeckens"
    ]
  },
  {
    "code": "S37.03",
    "name": "Nierenberstung",
    "synonyms": [
      "Komplette Ruptur des Nierenparenchyms",
      "Nierenberstung",
      "Nierenparenchymriss",
      "Nierenparenchymruptur",
      "Nierenperforation",
      "Nierenquerruptur",
      "Nierenrindenriss",
      "Nierenruptur",
      "Traumatische Nierenruptur"
    ]
  },
  {
    "code": "S37.1",
    "name": "Harnleiterruptur",
    "synonyms": [
      "Geschlossene Harnleiterverletzung",
      "Geschlossene Ureterverletzung",
      "Harnleiterabriss",
      "Harnleiterruptur",
      "Harnleiterverletzung",
      "Traumatische Ureterruptur",
      "Ureterabriss",
      "Ureterruptur",
      "Ureterverletzung"
    ]
  },
  {
    "code": "S37.20",
    "name": "Blasenläsion",
    "synonyms": [
      "Blasenläsion",
      "Blasenverletzung",
      "Geschlossene Blasenverletzung",
      "Harnblasenläsion",
      "Harnblasenverletzung"
    ]
  },
  {
    "code": "S37.21",
    "name": "Prellung der Harnblase",
    "synonyms": [
      "Prellung der Harnblase"
    ]
  },
  {
    "code": "S37.22",
    "name": "Harnblasenperforation",
    "synonyms": [
      "Blasenperforation",
      "Harnblasenlazeration",
      "Harnblasenperforation",
      "Traumatische Blasenruptur",
      "Traumatische Harnblasenperforation",
      "Traumatische Harnblasenruptur",
      "Traumatische extraperitoneale Harnblasenruptur",
      "Traumatische intraperitoneale Harnblasenruptur",
      "Traumatischer Harnblasenriss"
    ]
  },
  {
    "code": "S37.28",
    "name": "Vesikale Sphinkterverletzung",
    "synonyms": [
      "Vesikale Sphinkterverletzung"
    ]
  },
  {
    "code": "S37.30",
    "name": "Traumatische Harnröhrenruptur",
    "synonyms": [
      "Harnröhrenabriss",
      "Harnröhrenläsion",
      "Harnröhrenverletzung",
      "Lazeration periurethralen Gewebes",
      "Traumatische Harnröhrenruptur",
      "Traumatische Urethraruptur",
      "Urethraabriss",
      "Urethraläsion",
      "Urethraverletzung",
      "Verletzung von periurethralem Gewebe"
    ]
  },
  {
    "code": "S37.31",
    "name": "Verletzung der Pars membranacea der Harnröhre",
    "synonyms": [
      "Verletzung der Pars membranacea der Harnröhre",
      "Verletzung der Pars membranacea der Urethra"
    ]
  },
  {
    "code": "S37.32",
    "name": "Verletzung der Pars spongiosa der Harnröhre",
    "synonyms": [
      "Verletzung der Pars spongiosa der Harnröhre",
      "Verletzung der Pars spongiosa der Urethra"
    ]
  },
  {
    "code": "S37.33",
    "name": "Verletzung der Pars prostatica der Harnröhre",
    "synonyms": [
      "Verletzung der Pars prostatica der Harnröhre",
      "Verletzung der Pars prostatica der Urethra"
    ]
  },
  {
    "code": "S37.4",
    "name": "Ovarialverletzung",
    "synonyms": [
      "Ovarialverletzung"
    ]
  },
  {
    "code": "S37.5",
    "name": "Verletzung der Tuba uterina",
    "synonyms": [
      "Verletzung der Tuba uterina"
    ]
  },
  {
    "code": "S37.6",
    "name": "Uteruslazeration",
    "synonyms": [
      "Gebärmutterperforation",
      "Gebärmutterriss",
      "Traumatische Lazeration der Cervix uteri",
      "Traumatische Ruptur der Cervix uteri",
      "Traumatische Uterusperforation",
      "Traumatische Uterusruptur",
      "Traumatische Zervixruptur",
      "Traumatischer Risse der Cervix uteri",
      "Traumatischer Zervixriss",
      "Uteruslazeration",
      "Uterusperforation",
      "Uterusriss",
      "Uterusruptur",
      "Uterusverletzung",
      "Verletzung der Cervix uteri",
      "Zervixverletzung"
    ]
  },
  {
    "code": "S37.7",
    "name": "Verletzung mehrerer Beckenorgane",
    "synonyms": [
      "Multiple Verletzungen der inneren Beckenorgane",
      "Verletzung mehrerer Beckenorgane"
    ]
  },
  {
    "code": "S37.81",
    "name": "Nebennierenverletzung",
    "synonyms": [
      "Nebennierenverletzung"
    ]
  },
  {
    "code": "S37.82",
    "name": "Prostataverletzung",
    "synonyms": [
      "Prostatatrauma",
      "Prostataverletzung",
      "Traumatische Prostataruptur"
    ]
  },
  {
    "code": "S37.83",
    "name": "Samenblasenverletzung",
    "synonyms": [
      "Bläschendrüsenverletzung",
      "Samenblasenverletzung",
      "Traumatisches Hämatom der Samenblase",
      "Verletzung der Vesicula seminalis"
    ]
  },
  {
    "code": "S37.84",
    "name": "Verletzung des Vas deferens",
    "synonyms": [
      "Samenleiterverletzung",
      "Traumatisches Hämatom des Vas deferens",
      "Traumatisches Samenleiterhämatom",
      "Verletzung des Vas deferens"
    ]
  },
  {
    "code": "S37.88",
    "name": "Verletzung des Ligamentum latum uteri",
    "synonyms": [
      "Distorsion des Ligamentum latum uteri",
      "Distorsion des Ligamentum teres uteri",
      "Mesosalpinxverletzung",
      "Traumatisches Hämatom der Mesosalpinx",
      "Traumatisches Hämatom des Ligamentum latum uteri",
      "Vaginaprellung",
      "Verletzung des Ligamentum latum uteri",
      "Verletzung des Ligamentum teres uteri",
      "Verletzung des pelvinen Samenstranges"
    ]
  },
  {
    "code": "S37.9",
    "name": "Harnwegsläsion",
    "synonyms": [
      "Harnwegsläsion",
      "Traumatisches Beckenhämatom der Beckenorgane",
      "Verletzung der Beckenorgane",
      "Verletzung der inneren Geschlechtsorgane"
    ]
  },
  {
    "code": "S38.0",
    "name": "Zerquetschung der äußeren Genitalorgane",
    "synonyms": [
      "Zerquetschung der Labia majora pudendi",
      "Zerquetschung der Labia minora pudendi",
      "Zerquetschung der äußeren Genitalorgane",
      "Zerquetschung der äußeren männlichen Geschlechtsorgane",
      "Zerquetschung der äußeren weiblichen Geschlechtsorgane"
    ]
  },
  {
    "code": "S38.1",
    "name": "Abdomenzerquetschung",
    "synonyms": [
      "Abdomenzerquetschung",
      "Beckenzerquetschung",
      "Zerquetschung der Lumbosakralgegend",
      "Zerquetschung des Gesäßes",
      "Zerquetschung des unteren Rückens"
    ]
  },
  {
    "code": "S38.2",
    "name": "Traumatische Semikastration",
    "synonyms": [
      "Traumatische Amputation der Labia majora pudendi",
      "Traumatische Amputation der Labia minora pudendi",
      "Traumatische Amputation der äußeren Geschlechtsorgane",
      "Traumatische Amputation des Testis",
      "Traumatische Hodenamputation",
      "Traumatische Kastration beim Mann",
      "Traumatische Penisamputation",
      "Traumatische Semikastration",
      "Traumatische Skrotumamputation",
      "Traumatische Vulvaamputation"
    ]
  },
  {
    "code": "S38.3",
    "name": "Traumatische Amputation von Teilen des Beckens a.n.k.",
    "synonyms": [
      "Traumatische Amputation von Teilen der Lumbosakralgegend",
      "Traumatische Amputation von Teilen des Abdomens",
      "Traumatische Amputation von Teilen des Beckens a.n.k."
    ]
  },
  {
    "code": "S39.0",
    "name": "Muskelzerrung im LWS-Bereich",
    "synonyms": [
      "Muskelverletzung der Lumbosakralgegend",
      "Muskelverletzung des Abdomens",
      "Muskelverletzung des Beckens",
      "Muskelzerrung im LWS-Bereich",
      "Sehnenverletzung der Beckenorgane",
      "Sehnenverletzung der Lumbosakralregion",
      "Sehnenverletzung des Abdomens"
    ]
  },
  {
    "code": "S39.6",
    "name": "Verletzung des Abdomens mit Verletzung von Beckenorganen",
    "synonyms": [
      "Verletzung des Abdomens mit Verletzung von Beckenorganen"
    ]
  },
  {
    "code": "S39.7",
    "name": "Multiple Verletzungen des Abdomens, der Lumbosakralgegend und des Beckens",
    "synonyms": [
      "Multiple Verletzungen des Abdomens, der Lumbosakralgegend und des Beckens"
    ]
  },
  {
    "code": "S39.80",
    "name": "Penisfraktur",
    "synonyms": [
      "Penisfraktur",
      "Verletzung der Tunica albuginea des Penisschwellkörpers"
    ]
  },
  {
    "code": "S39.81",
    "name": "Verletzung lumbosakraler Rückenmarkhäute",
    "synonyms": [
      "Verletzung lumbosakraler Rückenmarkhäute"
    ]
  },
  {
    "code": "S39.88",
    "name": "Verletzung des skrotalen Samenstranges",
    "synonyms": [
      "Verletzung des Septum rectovaginale a.n.k.",
      "Verletzung des skrotalen Samenstranges"
    ]
  },
  {
    "code": "S39.9",
    "name": "Genitaltrauma",
    "synonyms": [
      "Abdomentrauma",
      "Abdomenverletzung",
      "Anusverletzung",
      "Bauchtrauma",
      "Bauchverletzung",
      "Beckenverletzung",
      "Contusio abdominis",
      "Dammverletzung",
      "Epididymisverletzung",
      "Genitaltrauma",
      "Gesäßverletzung",
      "Hodentrauma",
      "Hodenverletzung",
      "Hymenverletzung",
      "Klitorisverletzung",
      "Kohabitationsverletzung",
      "Lendenverletzung",
      "Nebenhodenverletzung",
      "Penistrauma",
      "Penisverletzung",
      "Posttraumatische Hodenschwellung",
      "Präputiumverletzung",
      "Rückenverletzung",
      "Skrotumverletzung",
      "Steißbeinverletzung",
      "Stumpfes Abdomentrauma",
      "Stumpfes Bauchtrauma",
      "Testisverletzung",
      "Traumatische Spinalläsion",
      "Vaginaverletzung",
      "Verletzung der Labia majora pudendi",
      "Verletzung der Labia minora pudendi",
      "Verletzung der Leistengegend",
      "Verletzung der Lumbosakralgegend",
      "Verletzung der Pudenda",
      "Verletzung der Schamgegend",
      "Verletzung der Tunica vaginalis testis",
      "Verletzung der äußeren Geschlechtsorgane",
      "Verletzung des Epigastriums",
      "Verletzung des Perineums",
      "Verletzung im iliakalen Bereich",
      "Vulvaverletzung"
    ]
  },
  {
    "code": "S40.0",
    "name": "Schulterprellung",
    "synonyms": [
      "Achselhöhlenprellung",
      "Oberarmhämatom",
      "Oberarmprellung",
      "Prellung der Regio scapularis",
      "Schulterprellung"
    ]
  },
  {
    "code": "S40.7",
    "name": "Multiple Prellungen an Schulter und Oberarm",
    "synonyms": [
      "Multiple Prellungen an Schulter und Oberarm",
      "Multiple Prellungen der Regio scapularis",
      "Multiple oberflächliche Verletzungen der Schulter"
    ]
  },
  {
    "code": "S40.81",
    "name": "Schürfwunde am Oberarm",
    "synonyms": [
      "Schürfwunde am Oberarm"
    ]
  },
  {
    "code": "S40.86",
    "name": "Subkutanes Décollement am Oberarm",
    "synonyms": [
      "Subkutanes Décollement am Oberarm",
      "Subkutanes Décollement an der Schulter"
    ]
  },
  {
    "code": "S40.9",
    "name": "Oberflächliche Schulterverletzung",
    "synonyms": [
      "Oberflächliche Achselhöhlenverletzung",
      "Oberflächliche Oberarmverletzung",
      "Oberflächliche Schulterverletzung",
      "Oberflächliche Verletzung der Regio scapularis",
      "Oberflächliche Verletzung der Skapularregion"
    ]
  },
  {
    "code": "S41.0",
    "name": "Offene Schulterwunde",
    "synonyms": [
      "Offene Schulterwunde"
    ]
  },
  {
    "code": "S41.1",
    "name": "Offene Oberarmwunde",
    "synonyms": [
      "Offene Oberarmwunde"
    ]
  },
  {
    "code": "S41.7",
    "name": "Multiple offene Wunden an Schulter und Oberarm",
    "synonyms": [
      "Multiple offene Wunden an Schulter und Oberarm"
    ]
  },
  {
    "code": "S41.80",
    "name": "Offene Axillarwunde",
    "synonyms": [
      "Offene Axillarwunde",
      "Offene Wunde der Achselhöhle",
      "Offene Wunde der Schulterblattregion",
      "Offene Wunde der Schultergegend",
      "Offene Wunde des Schultergürtels"
    ]
  },
  {
    "code": "S42.00",
    "name": "Schlüsselbeinbruch",
    "synonyms": [
      "Klavikulabruch",
      "Klavikulafraktur",
      "Schlüsselbeinbruch",
      "Schlüsselbeinfraktur"
    ]
  },
  {
    "code": "S42.01",
    "name": "Klavikulafraktur im medialen Drittel",
    "synonyms": [
      "Klavikulafraktur im medialen Drittel"
    ]
  },
  {
    "code": "S42.02",
    "name": "Klavikulafraktur im mittleren Drittel",
    "synonyms": [
      "Klavikulafraktur im mittleren Drittel"
    ]
  },
  {
    "code": "S42.03",
    "name": "Klavikulafraktur im lateralen Drittel",
    "synonyms": [
      "Klavikulafraktur im lateralen Drittel"
    ]
  },
  {
    "code": "S42.10",
    "name": "Skapulafraktur",
    "synonyms": [
      "Schulterblattfraktur",
      "Skapulafraktur"
    ]
  },
  {
    "code": "S42.11",
    "name": "Fraktur des Korpus der Skapula",
    "synonyms": [
      "Fraktur des Korpus der Skapula"
    ]
  },
  {
    "code": "S42.12",
    "name": "Fraktur der Spina scapulae",
    "synonyms": [
      "Akromionfraktur",
      "Fraktur der Spina scapulae"
    ]
  },
  {
    "code": "S42.13",
    "name": "Fraktur des Processus coracoideus",
    "synonyms": [
      "Fraktur des Processus coracoideus"
    ]
  },
  {
    "code": "S42.14",
    "name": "Fraktur der Cavitas glenoidalis scapulae",
    "synonyms": [
      "Fraktur der Cavitas glenoidalis scapulae",
      "Fraktur der Gelenkpfanne der Schulter"
    ]
  },
  {
    "code": "S42.19",
    "name": "Multiple Skapulafrakturen",
    "synonyms": [
      "Multiple Skapulafrakturen"
    ]
  },
  {
    "code": "S42.20",
    "name": "Humerusfraktur des proximalen Endes",
    "synonyms": [
      "Humerusfraktur des proximalen Endes",
      "Proximale Oberarmfraktur",
      "Subkapitale Humerusfraktur"
    ]
  },
  {
    "code": "S42.21",
    "name": "Humeruskopffraktur",
    "synonyms": [
      "Fractura capitis humeri",
      "Fraktur der oberen Epiphyse des Humerus",
      "Fraktur der proximalen Epiphyse des Humerus",
      "Humeruskopffraktur",
      "Humeruskopffraktur mit zwei bis vier Fragmenten",
      "Oberarmkopfbruch",
      "Oberarmkopffraktur",
      "Proximale Fraktur der Humerusepiphyse"
    ]
  },
  {
    "code": "S42.22",
    "name": "Fraktur des Collum chirurgicum humeri",
    "synonyms": [
      "Fraktur des Collum chirurgicum humeri"
    ]
  },
  {
    "code": "S42.23",
    "name": "Fraktur des Collum anatomicum humeri",
    "synonyms": [
      "Fraktur des Collum anatomicum humeri"
    ]
  },
  {
    "code": "S42.24",
    "name": "Fraktur des Tuberculum majus humeri",
    "synonyms": [
      "Fraktur des Tuberculum majus humeri"
    ]
  },
  {
    "code": "S42.29",
    "name": "Fraktur des Tuberculum minus",
    "synonyms": [
      "Fraktur des Tuberculum minus"
    ]
  },
  {
    "code": "S42.3",
    "name": "Humerusfraktur",
    "synonyms": [
      "Fractura humeri",
      "Humerusfraktur",
      "Humerusschaftfraktur",
      "Multiple Humerusschaftfrakturen",
      "Oberarmbruch",
      "Oberarmfraktur",
      "Oberarmschaftfraktur",
      "Offene Oberarmluxation"
    ]
  },
  {
    "code": "S42.40",
    "name": "Distale Humerusfraktur",
    "synonyms": [
      "Distale Humerusfraktur",
      "Distale Oberarmfraktur"
    ]
  },
  {
    "code": "S42.41",
    "name": "Suprakondyläre Humerusfraktur",
    "synonyms": [
      "Fraktur der suprakondylären Region des Humerus",
      "Suprakondyläre Ellenbogenfraktur",
      "Suprakondyläre Humerusfraktur"
    ]
  },
  {
    "code": "S42.42",
    "name": "Fraktur des Epicondylus lateralis humeri",
    "synonyms": [
      "Fraktur des Epicondylus lateralis humeri"
    ]
  },
  {
    "code": "S42.43",
    "name": "Fraktur des Epicondylus medialis humeri",
    "synonyms": [
      "Fraktur des Epicondylus medialis humeri"
    ]
  },
  {
    "code": "S42.44",
    "name": "Fraktur der distalen Humerusepiphyse",
    "synonyms": [
      "Bikondyläre distale Oberarmfraktur",
      "Fraktur der distalen Humerusepiphyse",
      "Fraktur der unteren Humerusepiphyse",
      "Fraktur des Gelenkfortsatzes des Humerus",
      "Fraktur des Humeruskondylus"
    ]
  },
  {
    "code": "S42.45",
    "name": "Fraktur der interkondylären Region des Humerus",
    "synonyms": [
      "Fraktur der interkondylären Region des Humerus"
    ]
  },
  {
    "code": "S42.49",
    "name": "Fraktur der Trochlea humeri",
    "synonyms": [
      "Fraktur der Trochlea des Humerus",
      "Fraktur der Trochlea humeri"
    ]
  },
  {
    "code": "S42.7",
    "name": "Multiple Frakturen der Klavikula, der Skapula und des Humerus",
    "synonyms": [
      "Humerusfraktur mit Klavikulafraktur",
      "Humerusfraktur mit Skapulafraktur",
      "Multiple Frakturen der Klavikula, der Skapula und des Humerus",
      "Multiple Oberarmfrakturen"
    ]
  },
  {
    "code": "S42.9",
    "name": "Schultergürtelfraktur",
    "synonyms": [
      "Schulterfraktur",
      "Schultergürtelfraktur",
      "Schulterluxationsfraktur"
    ]
  },
  {
    "code": "S43.00",
    "name": "Schulterluxation",
    "synonyms": [
      "Dislokation der Cavitas glenoidalis",
      "Dislokation des Glenohumeralgelenks",
      "Dislokation des Processus coracoideus",
      "Dislokation des Rabenschnabelfortsatzes",
      "Dislokation des proximalen Endes des Humerus",
      "Frische Schulterschädigung",
      "Infrakorakoidale Dislokation",
      "Komplizierte Schulterluxation",
      "Luxatio humeri",
      "Proximale Humerusluxation",
      "Schultergelenkdislokation",
      "Schultergelenkluxation",
      "Schulterluxation",
      "Subglenoidale Dislokation"
    ]
  },
  {
    "code": "S43.01",
    "name": "Bankart-Läsion",
    "synonyms": [
      "Bankart-Läsion",
      "Luxation des Humerus nach vorne"
    ]
  },
  {
    "code": "S43.02",
    "name": "Luxation des Humerus nach hinten",
    "synonyms": [
      "Luxation des Humerus nach hinten"
    ]
  },
  {
    "code": "S43.03",
    "name": "Luxation des Humerus nach unten",
    "synonyms": [
      "Luxation des Humerus nach unten"
    ]
  },
  {
    "code": "S43.1",
    "name": "Akromioklavikularluxation",
    "synonyms": [
      "Akromioklavikularluxation",
      "Dislokation des Akromioklavikulargelenks",
      "Klavikuladislokation",
      "Luxation des Akromioklavikulargelenks",
      "Schlüsselbeindislokation",
      "Schultereckgelenksprengung"
    ]
  },
  {
    "code": "S43.2",
    "name": "Sternoklavikulargelenkluxation",
    "synonyms": [
      "Dislokation des Sternoklavikulargelenks",
      "Sternoklavikulargelenkluxation"
    ]
  },
  {
    "code": "S43.3",
    "name": "Skapuladislokation",
    "synonyms": [
      "Schultergürteldislokation",
      "Schultergürtelluxation",
      "Skapuladislokation",
      "Skapulaluxation"
    ]
  },
  {
    "code": "S43.4",
    "name": "Korakohumerale Distorsion",
    "synonyms": [
      "Distorsion der Rotatorenmanschettenkapsel",
      "Distorsion des Ligamentum coracohumerale",
      "Korakohumerale Distorsion",
      "Schultergelenkdistorsion",
      "Verletzung des Labrums des Schultergelenkes",
      "Verstauchung des Kapselanteils der Rotatorenmanschette",
      "Verstauchung des Ligamentum coracohumerale",
      "Zerrung des Kapselanteils der Rotatorenmanschette",
      "Zerrung des Ligamentum coracohumerale",
      "Zerrung des Ligamentum glenohumerale inferius",
      "Zerrung des Ligamentum glenohumerale medius",
      "Zerrung des Ligamentum glenohumerale superius"
    ]
  },
  {
    "code": "S43.5",
    "name": "Distorsion des Akromioklavikulargelenks",
    "synonyms": [
      "Distorsion des Akromioklavikularbandes",
      "Distorsion des Akromioklavikulargelenks",
      "Verstauchung des Ligamentum acromioclaviculare",
      "Zerrung des Ligamentum acromioclaviculare"
    ]
  },
  {
    "code": "S43.6",
    "name": "Distorsion des Sternoklavikulargelenks",
    "synonyms": [
      "Distorsion des Sternoklavikulargelenks"
    ]
  },
  {
    "code": "S43.7",
    "name": "Schulterverstauchung",
    "synonyms": [
      "Distorsion des Schultergürtels a.n.k.",
      "Korakoklavikulare Distorsion",
      "Schulterblattdistorsion",
      "Schulterdistorsion",
      "Schulterverstauchung",
      "Schulterzerrung",
      "Skapuladistorsion",
      "Verstauchung des Schultergürtels",
      "Zerrung des Schultergürtels"
    ]
  },
  {
    "code": "S44.0",
    "name": "Verletzung des Nervus ulnaris in Höhe des Oberarms",
    "synonyms": [
      "Verletzung des Nervus ulnaris in Höhe des Oberarms"
    ]
  },
  {
    "code": "S44.1",
    "name": "Verletzung des Nervus medianus in Höhe des Oberarms",
    "synonyms": [
      "Verletzung des Nervus medianus in Höhe des Oberarms"
    ]
  },
  {
    "code": "S44.2",
    "name": "Verletzung des Nervus radialis in Höhe des Oberarms",
    "synonyms": [
      "Verletzung des Nervus radialis in Höhe des Oberarms"
    ]
  },
  {
    "code": "S44.3",
    "name": "Verletzung des Nervus axillaris",
    "synonyms": [
      "Verletzung des Nervus axillaris"
    ]
  },
  {
    "code": "S44.4",
    "name": "Verletzung des Nervus musculocutaneus",
    "synonyms": [
      "Verletzung des Nervus musculocutaneus"
    ]
  },
  {
    "code": "S44.5",
    "name": "Verletzung der sensiblen Hautnerven in Höhe der Schulter",
    "synonyms": [
      "Verletzung der sensiblen Hautnerven in Höhe der Schulter",
      "Verletzung der sensiblen Hautnerven in Höhe des Oberarms"
    ]
  },
  {
    "code": "S44.7",
    "name": "Verletzung multipler Nerven am Oberarm",
    "synonyms": [
      "Verletzung multipler Nerven am Oberarm",
      "Verletzung multipler Nerven an der Schulter"
    ]
  },
  {
    "code": "S44.9",
    "name": "Nervenverletzung in Höhe des Oberarms",
    "synonyms": [
      "Nervenverletzung der Schulter",
      "Nervenverletzung in Höhe des Oberarms"
    ]
  },
  {
    "code": "S45.0",
    "name": "Verletzung der Arteria axillaris",
    "synonyms": [
      "Verletzung der Arteria axillaris"
    ]
  },
  {
    "code": "S45.1",
    "name": "Verletzung der Arteria brachialis",
    "synonyms": [
      "Verletzung der Arteria brachialis"
    ]
  },
  {
    "code": "S45.2",
    "name": "Verletzung der Vena axillaris",
    "synonyms": [
      "Verletzung der Vena axillaris",
      "Verletzung der Venae brachiales"
    ]
  },
  {
    "code": "S45.3",
    "name": "Verletzung einer oberflächlichen Vene in Höhe der Schulter",
    "synonyms": [
      "Verletzung einer oberflächlichen Vene in Höhe der Schulter",
      "Verletzung einer oberflächlichen Vene in Höhe des Oberarms"
    ]
  },
  {
    "code": "S45.7",
    "name": "Verletzung mehrerer Blutgefäße in Höhe der Schulter",
    "synonyms": [
      "Verletzung mehrerer Blutgefäße in Höhe der Schulter",
      "Verletzung mehrerer Blutgefäße in Höhe des Oberarms"
    ]
  },
  {
    "code": "S45.9",
    "name": "Verletzung eines Blutgefäßes der Schulter",
    "synonyms": [
      "Verletzung eines Blutgefäßes der Achselhöhle",
      "Verletzung eines Blutgefäßes der Schulter",
      "Verletzung eines Blutgefäßes des Oberarms"
    ]
  },
  {
    "code": "S46.0",
    "name": "Traumatische Rotatorenmanschettenruptur der Schulter",
    "synonyms": [
      "Distorsion der Rotatorenmanschette",
      "Rotatorenmanschettenverletzung",
      "Traumatische Rotatorenmanschettenruptur der Schulter",
      "Verletzung der Muskeln und der Sehnen der Rotatorenmanschette"
    ]
  },
  {
    "code": "S46.1",
    "name": "Muskelverletzung des Caput longum des Musculus biceps brachii",
    "synonyms": [
      "Muskelverletzung des Caput longum des Musculus biceps brachii"
    ]
  },
  {
    "code": "S46.2",
    "name": "Bizepssehnenruptur",
    "synonyms": [
      "Bizepssehnenruptur",
      "Verletzung des Musculus biceps brachii"
    ]
  },
  {
    "code": "S46.3",
    "name": "Verletzung des Musculus triceps brachii",
    "synonyms": [
      "Verletzung des Musculus triceps brachii"
    ]
  },
  {
    "code": "S46.7",
    "name": "Verletzung multipler Muskeln der Schulter",
    "synonyms": [
      "Verletzung multipler Muskeln der Schulter",
      "Verletzung multipler Muskeln des Oberarms"
    ]
  },
  {
    "code": "S46.9",
    "name": "Muskelzerrung des Oberarms",
    "synonyms": [
      "Muskelverletzung der Schulter",
      "Muskelverletzung des Oberarms",
      "Muskelzerrung des Oberarms",
      "Oberarmverstauchung",
      "Oberarmzerrung"
    ]
  },
  {
    "code": "S47",
    "name": "Zerquetschung der Achselhöhle",
    "synonyms": [
      "Oberarmzerquetschung",
      "Schulterzerquetschung",
      "Zerquetschung der Achselhöhle",
      "Zerquetschung der Skapularregion"
    ]
  },
  {
    "code": "S48.0",
    "name": "Traumatische Amputation im Schultergelenk",
    "synonyms": [
      "Traumatische Amputation im Schultergelenk"
    ]
  },
  {
    "code": "S48.1",
    "name": "Traumatische Amputation zwischen Schulter und Ellenbogen",
    "synonyms": [
      "Traumatische Amputation zwischen Schulter und Ellenbogen"
    ]
  },
  {
    "code": "S48.9",
    "name": "Traumatische Amputation des Oberarms",
    "synonyms": [
      "Traumatische Amputation des Oberarms"
    ]
  },
  {
    "code": "S49.7",
    "name": "Multiple Verletzungen an Oberarm und Schulter",
    "synonyms": [
      "Multiple Verletzungen an Oberarm und Schulter"
    ]
  },
  {
    "code": "S49.9",
    "name": "Schulterverletzung",
    "synonyms": [
      "Oberarmverletzung",
      "Schulterverletzung",
      "Verletzung der Achselhöhle",
      "Verletzung der Skapularregion"
    ]
  },
  {
    "code": "S50.0",
    "name": "Ellenbogenprellung",
    "synonyms": [
      "Ellenbogenprellung"
    ]
  },
  {
    "code": "S50.1",
    "name": "Unterarmprellung",
    "synonyms": [
      "Unterarmprellung"
    ]
  },
  {
    "code": "S50.7",
    "name": "Multiple oberflächliche Verletzungen des Ellenbogens",
    "synonyms": [
      "Multiple oberflächliche Verletzungen des Ellenbogens",
      "Multiple oberflächliche Verletzungen des Unterarms"
    ]
  },
  {
    "code": "S50.81",
    "name": "Schürfwunde am Unterarm",
    "synonyms": [
      "Schürfwunde am Ellenbogen",
      "Schürfwunde am Unterarm"
    ]
  },
  {
    "code": "S50.86",
    "name": "Unterarmdécollement",
    "synonyms": [
      "Subkutanes Décollement am Unterarm",
      "Unterarmdécollement"
    ]
  },
  {
    "code": "S50.9",
    "name": "Oberflächliche Verletzung des Unterarms",
    "synonyms": [
      "Oberflächliche Ellenbogenverletzung",
      "Oberflächliche Verletzung des Unterarms"
    ]
  },
  {
    "code": "S51.0",
    "name": "Offene Ellenbogenwunde",
    "synonyms": [
      "Offene Ellenbogenwunde"
    ]
  },
  {
    "code": "S51.7",
    "name": "Multiple offene Unterarmwunden",
    "synonyms": [
      "Multiple offene Unterarmwunden"
    ]
  },
  {
    "code": "S51.9",
    "name": "Offene Wunde des Unterarms",
    "synonyms": [
      "Offene Wunde des Unterarms"
    ]
  },
  {
    "code": "S52.00",
    "name": "Proximale Ulnafraktur",
    "synonyms": [
      "Ellenbogenfraktur",
      "Fraktur der oberen Ulnaepiphyse",
      "Proximale Ulnafraktur"
    ]
  },
  {
    "code": "S52.01",
    "name": "Olekranonfraktur",
    "synonyms": [
      "Olekranonfraktur"
    ]
  },
  {
    "code": "S52.02",
    "name": "Fraktur des Kronenfortsatzes der Ulna",
    "synonyms": [
      "Fraktur des Kronenfortsatzes der Ulna",
      "Fraktur des Processus coronoideus ulnae"
    ]
  },
  {
    "code": "S52.10",
    "name": "Proximale Radiusfraktur",
    "synonyms": [
      "Fraktur der oberen Radiusepiphyse",
      "Proximale Radiusfraktur"
    ]
  },
  {
    "code": "S52.11",
    "name": "Radiusköpfchenfraktur",
    "synonyms": [
      "Radiusköpfchenfraktur"
    ]
  },
  {
    "code": "S52.12",
    "name": "Radiushalsfraktur",
    "synonyms": [
      "Fraktur des Collum radii",
      "Radiushalsfraktur"
    ]
  },
  {
    "code": "S52.20",
    "name": "Ulnaschaftfraktur",
    "synonyms": [
      "Ellenfraktur",
      "Ulnafraktur",
      "Ulnaschaftfraktur"
    ]
  },
  {
    "code": "S52.21",
    "name": "Monteggia-Fraktur",
    "synonyms": [
      "Fraktur des proximalen Ulnaschaftes mit Luxation des Radiuskopfes",
      "Monteggia-Fraktur",
      "Monteggia-Luxationsfraktur"
    ]
  },
  {
    "code": "S52.30",
    "name": "Radiusfraktur",
    "synonyms": [
      "Radiusfraktur",
      "Radiusgrünholzfraktur",
      "Radiusschaftfraktur",
      "Speichenbruch",
      "Speichenfraktur"
    ]
  },
  {
    "code": "S52.31",
    "name": "Galeazzi-Fraktur",
    "synonyms": [
      "Fraktur des distalen Radiusschaftes mit Luxation des Ulnakopfes",
      "Galeazzi-Fraktur"
    ]
  },
  {
    "code": "S52.4",
    "name": "Fraktur von Radius- und Ulnaschaft",
    "synonyms": [
      "Fraktur von Radius- und Ulnaschaft"
    ]
  },
  {
    "code": "S52.50",
    "name": "Distale Radiusfraktur",
    "synonyms": [
      "Distale Radiusfraktur",
      "Distale Radiustrümmerfraktur",
      "Fraktur der unteren Radiusepiphyse",
      "Typische Speichenfraktur",
      "Typischer Speichenbruch"
    ]
  },
  {
    "code": "S52.51",
    "name": "Colles-Fraktur",
    "synonyms": [
      "Colles-Fraktur",
      "Extensionsfraktur des distalen Radius",
      "Radiusfraktur loco typico"
    ]
  },
  {
    "code": "S52.52",
    "name": "Barton-Fraktur",
    "synonyms": [
      "Barton-Fraktur",
      "Flexionsfraktur des distalen Radius",
      "Smith-Fraktur"
    ]
  },
  {
    "code": "S52.59",
    "name": "Intraartikuläre Fraktur des Radius",
    "synonyms": [
      "Intraartikuläre Fraktur des Radius"
    ]
  },
  {
    "code": "S52.6",
    "name": "Distale Radiusfraktur mit Ulnafraktur",
    "synonyms": [
      "Distale Radiusfraktur mit Ulnafraktur"
    ]
  },
  {
    "code": "S52.7",
    "name": "Komplette Unterarmfraktur",
    "synonyms": [
      "Komplette Unterarmfraktur",
      "Multiple Radiusfrakturen a.n.k.",
      "Multiple Ulnafrakturen a.n.k.",
      "Multiple Unterarmfrakturen a.n.k.",
      "Radiusfraktur mit Ulnafraktur"
    ]
  },
  {
    "code": "S52.8",
    "name": "Fraktur des Caput ulnae",
    "synonyms": [
      "Distale Ulnafraktur",
      "Distale Unterarmfraktur",
      "Fraktur der unteren Ulnaepiphyse",
      "Fraktur des Caput ulnae",
      "Fraktur des Griffelfortsatzes der Ulna",
      "Fraktur des Processus styloideus ulnae",
      "Fraktur des Ulnaköpfchens",
      "Proximale Unterarmfraktur"
    ]
  },
  {
    "code": "S52.9",
    "name": "Unterarmfraktur",
    "synonyms": [
      "Unterarmbruch",
      "Unterarmfraktur",
      "Unterarmgrünholzfraktur"
    ]
  },
  {
    "code": "S53.0",
    "name": "Radiusköpfchenluxation",
    "synonyms": [
      "Chassaignac-Lähmung [Subluxatio radii per anularis des Kleinkindes] [Pronatio dolorosa des Kleinkindes]",
      "Dislokation des Radiohumeralgelenks",
      "Luxation der Articulatio humeroradialis",
      "Proximale Radiusdislokation",
      "Radiusköpfchenluxation"
    ]
  },
  {
    "code": "S53.10",
    "name": "Ellenbogenluxation",
    "synonyms": [
      "Dislokation des Ulnohumeralgelenks",
      "Ellenbogendislokation",
      "Ellenbogenluxation",
      "Luxation der Articulatio humeroulnaris",
      "Proximale Dislokation des Radioulnargelenks",
      "Proximale Ulnadislokation",
      "Verrenkung des Ellenbogengelenks"
    ]
  },
  {
    "code": "S53.2",
    "name": "Traumatische Ruptur des Ligamentum collaterale radiale",
    "synonyms": [
      "Traumatische Ruptur des Ligamentum collaterale radiale"
    ]
  },
  {
    "code": "S53.3",
    "name": "Traumatische Ruptur des Ligamentum collaterale ulnare",
    "synonyms": [
      "Riss des ulnaren Ellenbogenseitenbandes",
      "Traumatische Ruptur des Ligamentum collaterale ulnare"
    ]
  },
  {
    "code": "S53.40",
    "name": "Ellenbogenverstauchung",
    "synonyms": [
      "Ellenbogendistorsion",
      "Ellenbogenverstauchung",
      "Ellenbogenzerrung"
    ]
  },
  {
    "code": "S53.41",
    "name": "Zerrung des Ligamentum collaterale radiale",
    "synonyms": [
      "Zerrung des Ligamentum collaterale radiale"
    ]
  },
  {
    "code": "S53.42",
    "name": "Zerrung des Ligamentum collaterale ulnare",
    "synonyms": [
      "Zerrung des Ligamentum collaterale ulnare"
    ]
  },
  {
    "code": "S53.43",
    "name": "Radiohumerale Distorsion",
    "synonyms": [
      "Radiohumerale Distorsion"
    ]
  },
  {
    "code": "S53.44",
    "name": "Ulnohumerale Distorsion",
    "synonyms": [
      "Ulnohumerale Distorsion"
    ]
  },
  {
    "code": "S54.0",
    "name": "Verletzung des Nervus ulnaris in Höhe des Unterarms",
    "synonyms": [
      "Verletzung des Nervus ulnaris",
      "Verletzung des Nervus ulnaris in Höhe des Unterarms"
    ]
  },
  {
    "code": "S54.1",
    "name": "Verletzung des Nervus medianus in Höhe des Unterarms",
    "synonyms": [
      "Verletzung des Nervus medianus",
      "Verletzung des Nervus medianus in Höhe des Unterarms"
    ]
  },
  {
    "code": "S54.2",
    "name": "Verletzung des Nervus radialis in Höhe des Unterarms",
    "synonyms": [
      "Verletzung des Nervus radialis",
      "Verletzung des Nervus radialis in Höhe des Unterarms"
    ]
  },
  {
    "code": "S54.3",
    "name": "Verletzung der sensiblen Hautnerven in Höhe des Unterarms",
    "synonyms": [
      "Verletzung der sensiblen Hautnerven in Höhe des Unterarms"
    ]
  },
  {
    "code": "S54.7",
    "name": "Verletzung multipler Nerven am Unterarm",
    "synonyms": [
      "Verletzung multipler Nerven am Unterarm"
    ]
  },
  {
    "code": "S54.9",
    "name": "Nervenverletzung in Höhe des Unterarms",
    "synonyms": [
      "Nervenverletzung in Höhe des Unterarms"
    ]
  },
  {
    "code": "S55.0",
    "name": "Verletzung der Arteria ulnaris in Höhe des Unterarms",
    "synonyms": [
      "Verletzung der Arteria ulnaris in Höhe des Unterarms"
    ]
  },
  {
    "code": "S55.1",
    "name": "Verletzung der Arteria radialis in Höhe des Unterarms",
    "synonyms": [
      "Verletzung der Arteria radialis in Höhe des Unterarms"
    ]
  },
  {
    "code": "S55.2",
    "name": "Verletzung einer Vene in Höhe des Unterarms",
    "synonyms": [
      "Verletzung einer Vene in Höhe des Unterarms"
    ]
  },
  {
    "code": "S55.7",
    "name": "Verletzung multipler Blutgefäße am Unterarm",
    "synonyms": [
      "Verletzung multipler Blutgefäße am Unterarm"
    ]
  },
  {
    "code": "S55.9",
    "name": "Verletzung eines Blutgefäßes in Höhe des Unterarms",
    "synonyms": [
      "Verletzung eines Blutgefäßes in Höhe des Unterarms"
    ]
  },
  {
    "code": "S56.1",
    "name": "Verletzung eines Beugemuskels am Finger",
    "synonyms": [
      "Verletzung eines Beugemuskels am Finger"
    ]
  },
  {
    "code": "S56.3",
    "name": "Verletzung von Abduktormuskeln in Unterarm-Höhe",
    "synonyms": [
      "Verletzung von Abduktormuskeln in Unterarm-Höhe"
    ]
  },
  {
    "code": "S56.7",
    "name": "Verletzung multipler Unterarmmuskeln",
    "synonyms": [
      "Verletzung multipler Unterarmmuskeln"
    ]
  },
  {
    "code": "S56.8",
    "name": "Unterarmverstauchung",
    "synonyms": [
      "Muskelverletzung des Unterarms",
      "Unterarmverstauchung",
      "Unterarmzerrung"
    ]
  },
  {
    "code": "S57.0",
    "name": "Ellenbogenzerquetschung",
    "synonyms": [
      "Ellenbogenzerquetschung"
    ]
  },
  {
    "code": "S57.9",
    "name": "Unterarmzerquetschung",
    "synonyms": [
      "Unterarmzerquetschung"
    ]
  },
  {
    "code": "S58.0",
    "name": "Traumatische Amputation in Höhe des Ellenbogens",
    "synonyms": [
      "Traumatische Amputation in Höhe des Ellenbogens"
    ]
  },
  {
    "code": "S58.1",
    "name": "Traumatische Amputation zwischen Ellenbogen und Handgelenk",
    "synonyms": [
      "Traumatische Amputation zwischen Ellenbogen und Handgelenk"
    ]
  },
  {
    "code": "S58.9",
    "name": "Traumatische Amputation des Unterarms",
    "synonyms": [
      "Traumatische Amputation des Unterarms"
    ]
  },
  {
    "code": "S59.7",
    "name": "Multiple Verletzungen des Unterarms",
    "synonyms": [
      "Multiple Verletzungen des Unterarms",
      "Multiple Verletzungen von Ellenbogen und Unterarm"
    ]
  },
  {
    "code": "S59.9",
    "name": "Unterarmverletzung",
    "synonyms": [
      "Ellenbogenverletzung",
      "Unterarmverletzung"
    ]
  },
  {
    "code": "S60.0",
    "name": "Fingerprellung",
    "synonyms": [
      "Daumenprellung",
      "Fingerprellung"
    ]
  },
  {
    "code": "S60.1",
    "name": "Fingerprellung mit Nagelschädigung",
    "synonyms": [
      "Daumenprellung mit Nagelschädigung",
      "Fingernagelprellung",
      "Fingerprellung mit Nagelschädigung"
    ]
  },
  {
    "code": "S60.2",
    "name": "Handprellung",
    "synonyms": [
      "Handgelenkprellung",
      "Handprellung"
    ]
  },
  {
    "code": "S60.7",
    "name": "Multiple oberflächliche Verletzungen an Hand und Handgelenk",
    "synonyms": [
      "Multiple oberflächliche Verletzungen an Hand und Handgelenk"
    ]
  },
  {
    "code": "S60.81",
    "name": "Daumenschrunde",
    "synonyms": [
      "Daumenschrunde",
      "Kleine Schürfwunde des Handrückens",
      "Schürfwunde an der Hand"
    ]
  },
  {
    "code": "S60.84",
    "name": "Nagelfremdkörper",
    "synonyms": [
      "Nagelfremdkörper"
    ]
  },
  {
    "code": "S60.86",
    "name": "Subkutanes Décollement an der Hand",
    "synonyms": [
      "Subkutanes Décollement am Handgelenk",
      "Subkutanes Décollement an der Hand"
    ]
  },
  {
    "code": "S60.9",
    "name": "Oberflächliche Verletzung der Hand",
    "synonyms": [
      "Oberflächliche Daumenverletzung",
      "Oberflächliche Fingernagelverletzung",
      "Oberflächliche Fingerverletzung",
      "Oberflächliche Verletzung der Hand",
      "Oberflächliche Verletzung des Handgelenks",
      "Oberflächliche subunguale Fingerverletzung"
    ]
  },
  {
    "code": "S61.0",
    "name": "Offene Fingerwunde ohne Nagelschädigung",
    "synonyms": [
      "Offene Daumenwunde",
      "Offene Fingerkuppenwunde",
      "Offene Fingerwunde",
      "Offene Fingerwunde ohne Nagelschädigung",
      "Schnittverletzung des Daumens"
    ]
  },
  {
    "code": "S61.1",
    "name": "Offene Fingerwunde mit Nagelschädigung",
    "synonyms": [
      "Offene Daumennagelwunde",
      "Offene Daumenwunde mit Nagelschädigung",
      "Offene Fingernagelwunde",
      "Offene Fingerwunde mit Nagelschädigung"
    ]
  },
  {
    "code": "S61.7",
    "name": "Multiple offene Wunden an Hand und Handgelenk",
    "synonyms": [
      "Multiple offene Wunden an Hand und Handgelenk"
    ]
  },
  {
    "code": "S61.80",
    "name": "Offene Handflächenwunde",
    "synonyms": [
      "Offene Handflächenwunde"
    ]
  },
  {
    "code": "S61.9",
    "name": "Offene Handwunde",
    "synonyms": [
      "Offene Handwunde",
      "Offene Wunde des Handgelenks"
    ]
  },
  {
    "code": "S62.0",
    "name": "Fraktur des Os scaphoideum der Hand",
    "synonyms": [
      "Fraktur des Os naviculare manus",
      "Fraktur des Os scaphoideum der Hand",
      "Kahnbeinfraktur der Hand"
    ]
  },
  {
    "code": "S62.10",
    "name": "Fraktur der Karpalknochen a.n.k.",
    "synonyms": [
      "Fraktur der Karpalknochen a.n.k.",
      "Handwurzelfraktur",
      "Handwurzelknochenfraktur a.n.k."
    ]
  },
  {
    "code": "S62.11",
    "name": "Mondbeinfraktur des Handgelenks",
    "synonyms": [
      "Fraktur des Os lunatum",
      "Mondbeinfraktur des Handgelenks"
    ]
  },
  {
    "code": "S62.12",
    "name": "Fraktur des Os triquetrum",
    "synonyms": [
      "Fraktur des Os triquetrum",
      "Keilbeinfraktur der Handwurzel"
    ]
  },
  {
    "code": "S62.13",
    "name": "Erbsenbeinfraktur",
    "synonyms": [
      "Erbsenbeinfraktur",
      "Fraktur des Os pisiforme",
      "Sesambeinfraktur der Hand"
    ]
  },
  {
    "code": "S62.14",
    "name": "Fraktur des großen Vieleckbeins",
    "synonyms": [
      "Fraktur des Os trapezium",
      "Fraktur des großen Vieleckbeins"
    ]
  },
  {
    "code": "S62.15",
    "name": "Fraktur des kleinen Vieleckbeins",
    "synonyms": [
      "Fraktur des Os trapezoideum",
      "Fraktur des kleinen Vieleckbeins"
    ]
  },
  {
    "code": "S62.16",
    "name": "Fraktur des Os capitatum",
    "synonyms": [
      "Fraktur des Os capitatum"
    ]
  },
  {
    "code": "S62.17",
    "name": "Hakenbeinfraktur",
    "synonyms": [
      "Fraktur des Os hamatum",
      "Hakenbeinfraktur"
    ]
  },
  {
    "code": "S62.20",
    "name": "Fraktur des ersten Mittelhandknochens",
    "synonyms": [
      "Fraktur des ersten Metakarpalknochens",
      "Fraktur des ersten Mittelhandknochens"
    ]
  },
  {
    "code": "S62.21",
    "name": "Os-metacarpale-I-Basisfraktur",
    "synonyms": [
      "Bennett-Fraktur",
      "Fraktur der Basis des 1. Mittelhandknochens",
      "Os-metacarpale-I-Basisfraktur",
      "Winterstein-Fraktur [basisnahe Querfraktur des 1. Mittelhandknochens ohne Gelenkbeteiligung]"
    ]
  },
  {
    "code": "S62.22",
    "name": "Fraktur des Schaftes des ersten Mittelhandknochens",
    "synonyms": [
      "Fraktur des Schaftes des ersten Mittelhandknochens"
    ]
  },
  {
    "code": "S62.23",
    "name": "Fraktur des Kollums des ersten Mittelhandknochens",
    "synonyms": [
      "Fraktur des Kollums des ersten Mittelhandknochens"
    ]
  },
  {
    "code": "S62.24",
    "name": "Fraktur des Kopfes des ersten Mittelhandknochens",
    "synonyms": [
      "Fraktur des Kopfes des ersten Mittelhandknochens"
    ]
  },
  {
    "code": "S62.30",
    "name": "Fraktur des Metakarpale V",
    "synonyms": [
      "Fraktur des Metakarpale V",
      "Metakarpalknochenfraktur",
      "Metakarpusfraktur",
      "Mittelhandbruch",
      "Mittelhandfraktur",
      "Mittelhandknochenfraktur"
    ]
  },
  {
    "code": "S62.4",
    "name": "Multiple Frakturen der Mittelhandknochen",
    "synonyms": [
      "Multiple Frakturen der Metakarpalknochen",
      "Multiple Frakturen der Mittelhandknochen"
    ]
  },
  {
    "code": "S62.50",
    "name": "Daumenfraktur",
    "synonyms": [
      "Daumenbruch",
      "Daumenfraktur"
    ]
  },
  {
    "code": "S62.51",
    "name": "Fraktur der proximalen Phalanx des Daumens",
    "synonyms": [
      "Fraktur der proximalen Phalanx des Daumens"
    ]
  },
  {
    "code": "S62.52",
    "name": "Fraktur der distalen Phalanx des Daumens",
    "synonyms": [
      "Fraktur der distalen Phalanx des Daumens"
    ]
  },
  {
    "code": "S62.60",
    "name": "Fingergliederfraktur",
    "synonyms": [
      "Fingerfraktur",
      "Fingergliederfraktur",
      "Phalanxfraktur der Hand"
    ]
  },
  {
    "code": "S62.63",
    "name": "Mittelfingerendgliedfraktur",
    "synonyms": [
      "Mittelfingerendgliedfraktur"
    ]
  },
  {
    "code": "S62.7",
    "name": "Multiple Frakturen der Finger",
    "synonyms": [
      "Multiple Frakturen der Finger"
    ]
  },
  {
    "code": "S62.8",
    "name": "Trümmerfraktur der Hand",
    "synonyms": [
      "Handfraktur",
      "Handgelenkfraktur",
      "Mittelhand- und Fingerfraktur",
      "Multiple Handfrakturen",
      "Trümmerfraktur der Hand"
    ]
  },
  {
    "code": "S63.00",
    "name": "Handgelenkluxation",
    "synonyms": [
      "Dislokation der Handwurzelknochen",
      "Dislokation der Karpalknochen",
      "Dislokation des Os naviculare manus",
      "Dislokation des Os scaphoideum",
      "Handgelenkdislokation",
      "Handgelenkluxation",
      "Kahnbeindislokation der Hand",
      "Proximale Metakarpalknochendislokation"
    ]
  },
  {
    "code": "S63.01",
    "name": "Distale Dislokation des Radioulnargelenks",
    "synonyms": [
      "Distale Dislokation des Radioulnargelenks"
    ]
  },
  {
    "code": "S63.02",
    "name": "Dislokation des Radiokarpalgelenks",
    "synonyms": [
      "Dislokation des Radiokarpalgelenks",
      "Distale Radiusdislokation"
    ]
  },
  {
    "code": "S63.03",
    "name": "Dislokation des Mediokarpalgelenks",
    "synonyms": [
      "Dislokation des Mediokarpalgelenks",
      "Dislokation des Mittelhandgelenks"
    ]
  },
  {
    "code": "S63.04",
    "name": "Dislokation des Karpometakarpalgelenks",
    "synonyms": [
      "Dislokation des Karpometakarpalgelenks"
    ]
  },
  {
    "code": "S63.08",
    "name": "Distale Ulnadislokation",
    "synonyms": [
      "Distale Ulnadislokation"
    ]
  },
  {
    "code": "S63.10",
    "name": "Baseballfinger",
    "synonyms": [
      "Baseballfinger",
      "Daumendislokation",
      "Dislokation einer Phalanx der Hand",
      "Dislokation einer Phalanx eines Fingers",
      "Fingerdislokation",
      "Fingerluxation"
    ]
  },
  {
    "code": "S63.11",
    "name": "Dislokation eines Metakarpophalangealgelenks",
    "synonyms": [
      "Dislokation eines Metakarpophalangealgelenks",
      "Distale Metakarpalknochendislokation"
    ]
  },
  {
    "code": "S63.12",
    "name": "Interphalangealgelenkdislokation der Hand",
    "synonyms": [
      "Interphalangealgelenkdislokation der Hand"
    ]
  },
  {
    "code": "S63.2",
    "name": "Multiple Luxationen der Finger",
    "synonyms": [
      "Multiple Dislokationen der Finger",
      "Multiple Luxationen der Finger"
    ]
  },
  {
    "code": "S63.3",
    "name": "Traumatische Ruptur des Ligamentum collaterale carpi ulnare",
    "synonyms": [
      "Traumatische Ruptur des Ligamentum collaterale carpi radiale",
      "Traumatische Ruptur des Ligamentum collaterale carpi ulnare",
      "Traumatische Ruptur des Ligamentum radiocarpeum dorsale",
      "Traumatische Ruptur des Ligamentum radiocarpeum palmare",
      "Traumatische Ruptur des Ligamentum ulnocarpeum palmare",
      "Traumatische Ruptur des TFCC [triangulärer fibrokartilaginärer Komplex]",
      "Traumatische Ruptur des triangulären fibrokartilaginären Komplexes"
    ]
  },
  {
    "code": "S63.4",
    "name": "Knöcherner Ausriss des ulnaren Seitenbandes des Daumens",
    "synonyms": [
      "Knöcherner Ausriss des ulnaren Seitenbandes des Daumens",
      "Traumatische Ruptur des Ligamentum palmare",
      "Traumatische Ruptur eines kollateralen Fingerbandes",
      "Traumatische Ruptur eines kollateralen Ligaments",
      "Traumatische Ruptur eines palmaren Fingerbandes",
      "Traumatische Ruptur eines volaren Fingerbandes"
    ]
  },
  {
    "code": "S63.50",
    "name": "Handgelenkzerrung",
    "synonyms": [
      "Handgelenkdistorsion",
      "Handgelenkverstauchung",
      "Handgelenkzerrung"
    ]
  },
  {
    "code": "S63.51",
    "name": "Karpalgelenkdistorsion",
    "synonyms": [
      "Karpalgelenkdistorsion"
    ]
  },
  {
    "code": "S63.52",
    "name": "Verstauchung des Radiokarpalgelenks",
    "synonyms": [
      "Distorsion des Radiokarpalgelenks",
      "Verstauchung des Radiokarpalgelenks"
    ]
  },
  {
    "code": "S63.53",
    "name": "Distorsion des Karpometakarpalgelenks",
    "synonyms": [
      "Distorsion des Karpometakarpalgelenks"
    ]
  },
  {
    "code": "S63.60",
    "name": "Fingerdistorsion",
    "synonyms": [
      "Daumendistorsion",
      "Fingerdistorsion",
      "Fingergelenkkapselriss bei Distorsion",
      "Fingerverstauchung",
      "Fingerzerrung"
    ]
  },
  {
    "code": "S63.61",
    "name": "Daumengrundgelenkdistorsion",
    "synonyms": [
      "Daumengrundgelenkdistorsion",
      "Distorsion eines Metakarpophalangealgelenks",
      "Skidaumen"
    ]
  },
  {
    "code": "S63.62",
    "name": "Interphalangeale Fingerdistorsion",
    "synonyms": [
      "Interphalangeale Fingerdistorsion"
    ]
  },
  {
    "code": "S63.7",
    "name": "Dislokation der Metakarpalknochen",
    "synonyms": [
      "Dislokation der Metakarpalknochen",
      "Distorsion des Metakarpalgelenks",
      "Handdistorsion",
      "Kahnbeindistorsion",
      "Mittelhanddistorsion"
    ]
  },
  {
    "code": "S64.0",
    "name": "Verletzung des Nervus ulnaris in Höhe des Handgelenks",
    "synonyms": [
      "Verletzung des Nervus ulnaris in Höhe der Hand",
      "Verletzung des Nervus ulnaris in Höhe des Handgelenks"
    ]
  },
  {
    "code": "S64.1",
    "name": "Verletzung des Nervus medianus in Höhe des Handgelenks",
    "synonyms": [
      "Verletzung des Nervus medianus in Höhe der Hand",
      "Verletzung des Nervus medianus in Höhe des Handgelenks"
    ]
  },
  {
    "code": "S64.2",
    "name": "Verletzung des Nervus radialis in Höhe des Handgelenks",
    "synonyms": [
      "Verletzung des Nervus radialis in Höhe der Hand",
      "Verletzung des Nervus radialis in Höhe des Handgelenks"
    ]
  },
  {
    "code": "S64.3",
    "name": "Verletzung der Nervi digitales des Daumens",
    "synonyms": [
      "Nervenverletzung des Daumens",
      "Verletzung der Nervi digitales des Daumens"
    ]
  },
  {
    "code": "S64.4",
    "name": "Nervenverletzung am Finger",
    "synonyms": [
      "Nervenverletzung am Finger",
      "Verletzung der Nervi digitales"
    ]
  },
  {
    "code": "S64.7",
    "name": "Verletzung multipler Nerven am Handgelenk",
    "synonyms": [
      "Verletzung multipler Nerven am Handgelenk",
      "Verletzung multipler Nerven an der Hand"
    ]
  },
  {
    "code": "S64.9",
    "name": "Nervenverletzung an der Hand",
    "synonyms": [
      "Nervenverletzung am Handgelenk",
      "Nervenverletzung an der Hand"
    ]
  },
  {
    "code": "S65.0",
    "name": "Verletzung der Arteria ulnaris in Höhe des Handgelenks",
    "synonyms": [
      "Verletzung der Arteria ulnaris in Höhe der Hand",
      "Verletzung der Arteria ulnaris in Höhe des Handgelenks"
    ]
  },
  {
    "code": "S65.1",
    "name": "Verletzung der Arteria radialis in Höhe des Handgelenks",
    "synonyms": [
      "Verletzung der Arteria radialis in Höhe der Hand",
      "Verletzung der Arteria radialis in Höhe des Handgelenks"
    ]
  },
  {
    "code": "S65.2",
    "name": "Verletzung eines Gefäßes des Arcus palmaris superficialis",
    "synonyms": [
      "Verletzung des Arcus palmaris superficialis",
      "Verletzung eines Gefäßes des Arcus palmaris superficialis"
    ]
  },
  {
    "code": "S65.3",
    "name": "Verletzung eines Gefäßes des Arcus palmaris profundus",
    "synonyms": [
      "Verletzung eines Gefäßes des Arcus palmaris profundus"
    ]
  },
  {
    "code": "S65.4",
    "name": "Verletzung eines Blutgefäßes am Daumen",
    "synonyms": [
      "Verletzung eines Blutgefäßes am Daumen"
    ]
  },
  {
    "code": "S65.5",
    "name": "Verletzung eines Blutgefäßes am Finger",
    "synonyms": [
      "Verletzung der Arteriae digitales",
      "Verletzung eines Blutgefäßes am Finger"
    ]
  },
  {
    "code": "S65.7",
    "name": "Verletzung multipler Blutgefäße an der Hand",
    "synonyms": [
      "Verletzung multipler Blutgefäße am Handgelenk",
      "Verletzung multipler Blutgefäße an der Hand"
    ]
  },
  {
    "code": "S65.9",
    "name": "Verletzung eines Blutgefäßes am Handgelenk",
    "synonyms": [
      "Verletzung eines Blutgefäßes am Handgelenk",
      "Verletzung eines Blutgefäßes der Hand"
    ]
  },
  {
    "code": "S66.0",
    "name": "Verletzung des langen Beugemuskels des Daumens",
    "synonyms": [
      "Verletzung des Musculus flexor pollicis longus",
      "Verletzung des langen Beugemuskels des Daumens"
    ]
  },
  {
    "code": "S66.4",
    "name": "Verletzung des kurzen Muskels des Daumens",
    "synonyms": [
      "Verletzung des kurzen Muskels des Daumens"
    ]
  },
  {
    "code": "S66.6",
    "name": "Verletzung multipler Beugemuskeln am Handgelenk",
    "synonyms": [
      "Verletzung multipler Beugemuskeln am Handgelenk",
      "Verletzung multipler Beugemuskeln der Hand"
    ]
  },
  {
    "code": "S66.9",
    "name": "Verletzung eines Muskels an der Hand",
    "synonyms": [
      "Verletzung eines Muskel am Handgelenk",
      "Verletzung eines Muskels an der Hand"
    ]
  },
  {
    "code": "S67.0",
    "name": "Daumenzerquetschung",
    "synonyms": [
      "Daumenzerquetschung",
      "Fingerzerquetschung"
    ]
  },
  {
    "code": "S67.8",
    "name": "Handzerquetschung",
    "synonyms": [
      "Daumenzerquetschung mit Handbeteiligung",
      "Fingerzerquetschung mit Handbeteiligung",
      "Handgelenkzerquetschung",
      "Handzerquetschung"
    ]
  },
  {
    "code": "S68.0",
    "name": "Traumatische Amputation des Daumens",
    "synonyms": [
      "Traumatische Amputation des Daumens"
    ]
  },
  {
    "code": "S68.1",
    "name": "Traumatische Amputation eines Fingers",
    "synonyms": [
      "Fingeramputation",
      "Traumatische Amputation eines Fingers"
    ]
  },
  {
    "code": "S68.2",
    "name": "Traumatische Amputation mehrerer Finger",
    "synonyms": [
      "Traumatische Amputation mehrerer Finger"
    ]
  },
  {
    "code": "S68.3",
    "name": "Traumatische Amputation eines Fingers und anderer Teile der Hand",
    "synonyms": [
      "Traumatische Amputation eines Fingers und anderer Teile der Hand",
      "Traumatische Amputation von zwei (oder mehr) Fingern und anderen Teilen der Hand"
    ]
  },
  {
    "code": "S68.4",
    "name": "Traumatische Amputation der Hand in Höhe des Handgelenks",
    "synonyms": [
      "Traumatische Amputation der Hand in Höhe des Handgelenks"
    ]
  },
  {
    "code": "S68.9",
    "name": "Traumatische Amputation der Hand",
    "synonyms": [
      "Traumatische Amputation der Hand",
      "Traumatische Amputation von Hand und Handgelenk"
    ]
  },
  {
    "code": "S69.7",
    "name": "Fingerverletzung mit Sehnenbeteiligung",
    "synonyms": [
      "Fingerverletzung mit Sehnenbeteiligung",
      "Handverletzung mit Sehnenbeteiligung",
      "Handwurzelverletzung mit Sehnenbeteiligung",
      "Multiple Verletzungen von Hand und Handgelenk"
    ]
  },
  {
    "code": "S69.9",
    "name": "Fingerverletzung",
    "synonyms": [
      "Daumenverletzung",
      "Fingernagelverletzung",
      "Fingerverletzung",
      "Handgelenkverletzung",
      "Handverletzung",
      "Handwurzelverletzung",
      "Subunguale Fingerverletzung",
      "Verletzung der Phalangen der Hand"
    ]
  },
  {
    "code": "S70.0",
    "name": "Hüftprellung",
    "synonyms": [
      "Hüftkontusion",
      "Hüftprellung"
    ]
  },
  {
    "code": "S70.1",
    "name": "Oberschenkelprellung",
    "synonyms": [
      "Oberschenkelprellung",
      "Prellung des Musculus quadriceps femoris",
      "Traumatisches Oberschenkelhämatom"
    ]
  },
  {
    "code": "S70.7",
    "name": "Multiple oberflächliche Verletzungen der Hüfte",
    "synonyms": [
      "Multiple oberflächliche Verletzungen der Hüfte",
      "Multiple oberflächliche Verletzungen des Oberschenkels"
    ]
  },
  {
    "code": "S70.81",
    "name": "Oberschenkelschürfwunde",
    "synonyms": [
      "Oberschenkelschürfwunde",
      "Schürfwunde an der Hüfte"
    ]
  },
  {
    "code": "S70.86",
    "name": "Subkutanes Décollement an der Hüfte",
    "synonyms": [
      "Subkutanes Décollement am Oberschenkel",
      "Subkutanes Décollement an der Hüfte"
    ]
  },
  {
    "code": "S70.9",
    "name": "Oberflächliche Verletzung des Oberschenkels",
    "synonyms": [
      "Oberflächliche Verletzung der Hüfte",
      "Oberflächliche Verletzung des Oberschenkels"
    ]
  },
  {
    "code": "S71.0",
    "name": "Offene Wunde der Hüfte",
    "synonyms": [
      "Offene Wunde der Hüfte"
    ]
  },
  {
    "code": "S71.1",
    "name": "Offene Oberschenkelwunde",
    "synonyms": [
      "Offene Oberschenkelwunde"
    ]
  },
  {
    "code": "S71.7",
    "name": "Multiple offene Wunden an Hüfte und Oberschenkel",
    "synonyms": [
      "Multiple offene Wunden an Hüfte und Oberschenkel"
    ]
  },
  {
    "code": "S71.80",
    "name": "Offene Wunde des Beckengürtels a.n.k.",
    "synonyms": [
      "Offene Wunde des Beckengürtels a.n.k."
    ]
  },
  {
    "code": "S72.00",
    "name": "Femurhalsfraktur",
    "synonyms": [
      "Femurhalsfraktur",
      "Oberschenkelhalsbruch",
      "Oberschenkelhalsfraktur",
      "Schenkelhalsbruch",
      "Schenkelhalsfraktur"
    ]
  },
  {
    "code": "S72.01",
    "name": "Mediale Schenkelhalsfraktur",
    "synonyms": [
      "Intrakapsuläre Schenkelhalsfraktur",
      "Mediale Schenkelhalsfraktur"
    ]
  },
  {
    "code": "S72.02",
    "name": "Fraktur der oberen Femurepiphyse",
    "synonyms": [
      "Fraktur der oberen Femurepiphyse",
      "Fraktur des Femurepiphysenkopfes"
    ]
  },
  {
    "code": "S72.03",
    "name": "Subkapitale Schenkelhalsfraktur",
    "synonyms": [
      "Subkapitale Schenkelhalsfraktur"
    ]
  },
  {
    "code": "S72.04",
    "name": "Transzervikale Schenkelhalsfraktur",
    "synonyms": [
      "Mediozervikale Schenkelhalsfraktur",
      "Transzervikale Femurfraktur",
      "Transzervikale Schenkelhalsfraktur",
      "Transzervikaler Schenkelhalsbruch"
    ]
  },
  {
    "code": "S72.05",
    "name": "Zervikotrochantäre Schenkelhalsfraktur",
    "synonyms": [
      "Basizervikale Femurfraktur",
      "Zervikotrochantäre Schenkelhalsfraktur"
    ]
  },
  {
    "code": "S72.08",
    "name": "Laterale Schenkelhalsfraktur",
    "synonyms": [
      "Femurkopffraktur",
      "Fraktur des Caput femoris",
      "Hüftfraktur",
      "Hüftkopfbruch",
      "Hüftkopffraktur",
      "Laterale Schenkelhalsfraktur",
      "Pipkin-Fraktur"
    ]
  },
  {
    "code": "S72.10",
    "name": "Pertrochantäre Fraktur",
    "synonyms": [
      "Fraktur des Trochanter major",
      "Fraktur des Trochanter minor",
      "Pertrochantäre Femurfraktur",
      "Pertrochantäre Fraktur",
      "Pertrochantäre Oberschenkelfraktur",
      "Transtrochantäre Femurfraktur",
      "Transtrochantäre Fraktur"
    ]
  },
  {
    "code": "S72.11",
    "name": "Intertrochantäre Femurfraktur",
    "synonyms": [
      "Intertrochantäre Femurfraktur",
      "Intratrochantäre Femurfraktur"
    ]
  },
  {
    "code": "S72.2",
    "name": "Dislozierte subtrochantäre Femurfraktur",
    "synonyms": [
      "Dislozierte subtrochantäre Femurfraktur",
      "Subtrochantäre Femurfraktur",
      "Subtrochantäre Fraktur",
      "Subtrochantäre Oberschenkelfraktur"
    ]
  },
  {
    "code": "S72.3",
    "name": "Femurschaftfraktur",
    "synonyms": [
      "Femurschaftfraktur",
      "Oberschenkelschaftbruch",
      "Oberschenkelschaftfraktur"
    ]
  },
  {
    "code": "S72.40",
    "name": "Distale Femurfraktur",
    "synonyms": [
      "Distale Femurfraktur",
      "Distale Fraktur des Femurs",
      "Distale Oberschenkelfraktur"
    ]
  },
  {
    "code": "S72.41",
    "name": "Fraktur des Femurkondylus",
    "synonyms": [
      "Fraktur des Femurepikondylus",
      "Fraktur des Femurkondylus",
      "Kondyläre Femurfraktur"
    ]
  },
  {
    "code": "S72.42",
    "name": "Fraktur der unteren Femurepiphyse",
    "synonyms": [
      "Fraktur der unteren Femurepiphyse"
    ]
  },
  {
    "code": "S72.43",
    "name": "Suprakondyläre distale Femurfraktur",
    "synonyms": [
      "Suprakondyläre distale Femurfraktur"
    ]
  },
  {
    "code": "S72.44",
    "name": "Interkondyläre distale Femurfraktur",
    "synonyms": [
      "Interkondyläre distale Femurfraktur"
    ]
  },
  {
    "code": "S72.7",
    "name": "Multiple Femurfrakturen",
    "synonyms": [
      "Multiple Femurfrakturen"
    ]
  },
  {
    "code": "S72.9",
    "name": "Femurfraktur",
    "synonyms": [
      "Femurfraktur",
      "Oberschenkelbruch",
      "Oberschenkelfraktur",
      "Oberschenkeltrümmerbruch",
      "Oberschenkeltrümmerfraktur"
    ]
  },
  {
    "code": "S73.00",
    "name": "Hüftgelenkluxation",
    "synonyms": [
      "Hüftdislokation",
      "Hüftgelenkluxation",
      "Hüftgelenkpfannendislokation",
      "Hüftluxation",
      "Proximale Femurdislokation",
      "Proximale Oberschenkeldislokation"
    ]
  },
  {
    "code": "S73.01",
    "name": "Hüftluxation nach posterior",
    "synonyms": [
      "Hüftluxation nach posterior"
    ]
  },
  {
    "code": "S73.02",
    "name": "Hüftluxation nach anterior",
    "synonyms": [
      "Hüftluxation nach anterior"
    ]
  },
  {
    "code": "S73.10",
    "name": "Hüftverstauchung",
    "synonyms": [
      "Hüftdistorsion",
      "Hüftverstauchung"
    ]
  },
  {
    "code": "S73.11",
    "name": "Iliofemorale Distorsion",
    "synonyms": [
      "Iliofemorale Distorsion"
    ]
  },
  {
    "code": "S73.12",
    "name": "Ischiokapsuläre Distorsion",
    "synonyms": [
      "Ischiokapsuläre Distorsion"
    ]
  },
  {
    "code": "S73.18",
    "name": "Pubofemorale Distorsion",
    "synonyms": [
      "Azetabulumdistorsion a.n.k.",
      "Distorsion des Ligamentum teres femoris",
      "Femurkopfdistorsion",
      "Ischiofemorale Distorsion",
      "Pubofemorale Distorsion"
    ]
  },
  {
    "code": "S74.0",
    "name": "Verletzung des Nervus ischiadicus in Höhe der Hüfte",
    "synonyms": [
      "Verletzung des Nervus ischiadicus in Höhe der Hüfte",
      "Verletzung des Nervus ischiadicus in Höhe des Oberschenkels"
    ]
  },
  {
    "code": "S74.1",
    "name": "Verletzung des Nervus femoralis in Höhe der Hüfte",
    "synonyms": [
      "Verletzung des Nervus femoralis in Höhe der Hüfte",
      "Verletzung des Nervus femoralis in Höhe des Oberschenkels"
    ]
  },
  {
    "code": "S74.2",
    "name": "Verletzung der sensiblen Hautnerven in Höhe der Hüfte",
    "synonyms": [
      "Verletzung der sensiblen Hautnerven in Höhe der Hüfte",
      "Verletzung der sensiblen Hautnerven in Höhe des Oberschenkels"
    ]
  },
  {
    "code": "S74.7",
    "name": "Verletzung multipler Nerven am Oberschenkel",
    "synonyms": [
      "Verletzung multipler Nerven am Oberschenkel",
      "Verletzung multipler Nerven an der Hüfte"
    ]
  },
  {
    "code": "S74.9",
    "name": "Nervenverletzung am Oberschenkel",
    "synonyms": [
      "Nervenverletzung am Beckengürtel",
      "Nervenverletzung am Oberschenkel",
      "Nervenverletzung an der Hüfte"
    ]
  },
  {
    "code": "S75.0",
    "name": "Verletzung der Arteria femoralis",
    "synonyms": [
      "Verletzung der Arteria femoralis"
    ]
  },
  {
    "code": "S75.1",
    "name": "Verletzung der Vena femoralis in Höhe der Hüfte",
    "synonyms": [
      "Verletzung der Vena femoralis in Höhe der Hüfte",
      "Verletzung der Vena femoralis in Höhe des Oberschenkels"
    ]
  },
  {
    "code": "S75.2",
    "name": "Verletzung der Vena saphena magna in Höhe der Hüfte",
    "synonyms": [
      "Verletzung der Vena saphena magna in Höhe der Hüfte",
      "Verletzung der Vena saphena magna in Höhe des Oberschenkels"
    ]
  },
  {
    "code": "S75.7",
    "name": "Verletzung multipler Blutgefäße an der Hüfte",
    "synonyms": [
      "Verletzung multipler Blutgefäße am Oberschenkel",
      "Verletzung multipler Blutgefäße an der Hüfte"
    ]
  },
  {
    "code": "S75.9",
    "name": "Verletzung eines Blutgefäßes am Oberschenkel",
    "synonyms": [
      "Verletzung eines Blutgefäßes am Oberschenkel",
      "Verletzung eines Blutgefäßes der Hüfte"
    ]
  },
  {
    "code": "S76.0",
    "name": "Muskelverletzung der Hüfte",
    "synonyms": [
      "Muskelverletzung der Hüfte",
      "Sehnenverletzung der Hüfte"
    ]
  },
  {
    "code": "S76.1",
    "name": "Patellarsehnenabriss",
    "synonyms": [
      "Distorsion des Ligamentum patellae a.n.k.",
      "Patellarsehnenabriss",
      "Verletzung des Ligamentum patellae",
      "Verletzung des Musculus quadriceps femoris"
    ]
  },
  {
    "code": "S76.2",
    "name": "Adduktorenzerrung des Oberschenkels",
    "synonyms": [
      "Adduktorenzerrung des Oberschenkels"
    ]
  },
  {
    "code": "S76.4",
    "name": "Muskelfaserriss des Oberschenkels",
    "synonyms": [
      "Muskelfaserriss des Oberschenkels",
      "Muskelverletzung des Oberschenkels a.n.k.",
      "Muskelzerrung des Oberschenkels",
      "Oberschenkelzerrung"
    ]
  },
  {
    "code": "S76.7",
    "name": "Verletzung multipler Muskeln am Oberschenkel",
    "synonyms": [
      "Verletzung multipler Muskeln am Oberschenkel",
      "Verletzung multipler Muskeln an der Hüfte"
    ]
  },
  {
    "code": "S77.0",
    "name": "Hüftzerquetschung",
    "synonyms": [
      "Hüftzerquetschung"
    ]
  },
  {
    "code": "S77.1",
    "name": "Oberschenkelzerquetschung",
    "synonyms": [
      "Oberschenkelzerquetschung"
    ]
  },
  {
    "code": "S77.2",
    "name": "Hüftzerquetschung mit Oberschenkelzerquetschung",
    "synonyms": [
      "Hüftzerquetschung mit Oberschenkelzerquetschung"
    ]
  },
  {
    "code": "S78.0",
    "name": "Traumatische Amputation im Hüftgelenk",
    "synonyms": [
      "Traumatische Amputation im Hüftgelenk"
    ]
  },
  {
    "code": "S78.1",
    "name": "Traumatische Amputation zwischen Hüfte und Knie",
    "synonyms": [
      "Traumatische Amputation zwischen Hüfte und Knie"
    ]
  },
  {
    "code": "S78.9",
    "name": "Traumatische Amputation des Oberschenkels",
    "synonyms": [
      "Traumatische Amputation des Oberschenkels"
    ]
  },
  {
    "code": "S79.7",
    "name": "Multiple Verletzungen an Hüfte und Oberschenkel",
    "synonyms": [
      "Multiple Verletzungen an Hüfte und Oberschenkel"
    ]
  },
  {
    "code": "S79.9",
    "name": "Oberschenkelverletzung",
    "synonyms": [
      "Oberschenkelverletzung",
      "Verletzung der Hüfte"
    ]
  },
  {
    "code": "S80.0",
    "name": "Kniegelenkprellung",
    "synonyms": [
      "Kniegelenkprellung",
      "Kniehämatom",
      "Knieprellung",
      "Traumatisches Hämarthros des Kniegelenks"
    ]
  },
  {
    "code": "S80.1",
    "name": "Unterschenkelprellung",
    "synonyms": [
      "Unterschenkelprellung"
    ]
  },
  {
    "code": "S80.7",
    "name": "Multiple Unterschenkelprellungen",
    "synonyms": [
      "Multiple Unterschenkelprellungen",
      "Multiple oberflächliche Unterschenkelverletzungen",
      "Multiple oberflächliche Verletzungen an Knie und Unterschenkel"
    ]
  },
  {
    "code": "S80.81",
    "name": "Schürfwunde am Knie",
    "synonyms": [
      "Schürfwunde am Knie",
      "Schürfwunde am Unterschenkel"
    ]
  },
  {
    "code": "S80.86",
    "name": "Subkutanes Décollement am Unterschenkel",
    "synonyms": [
      "Subkutanes Décollement am Unterschenkel"
    ]
  },
  {
    "code": "S80.9",
    "name": "Oberflächliche Verletzung des Unterschenkels",
    "synonyms": [
      "Oberflächliche Kniekehlenverletzung",
      "Oberflächliche Knieverletzung",
      "Oberflächliche Verletzung des Unterschenkels"
    ]
  },
  {
    "code": "S81.0",
    "name": "Offene Kniewunde",
    "synonyms": [
      "Offene Kniewunde"
    ]
  },
  {
    "code": "S81.7",
    "name": "Multiple offene Unterschenkelwunden",
    "synonyms": [
      "Mehrere offene Wadenwunden",
      "Multiple offene Unterschenkelwunden",
      "Multiple offene Wunden an Unterschenkel und Knie"
    ]
  },
  {
    "code": "S81.80",
    "name": "Offene Wunde der Schienbeingegend",
    "synonyms": [
      "Offene Wunde der Kniekehle",
      "Offene Wunde der Schienbeingegend",
      "Offene Wunde der Tibiaregion",
      "Offene Wunde der Wade"
    ]
  },
  {
    "code": "S81.9",
    "name": "Offene Unterschenkelwunde",
    "synonyms": [
      "Offene Unterschenkelwunde"
    ]
  },
  {
    "code": "S82.0",
    "name": "Patellafraktur",
    "synonyms": [
      "Kniescheibenbruch",
      "Kniescheibenfraktur",
      "Patellafraktur"
    ]
  },
  {
    "code": "S82.11",
    "name": "Fraktur des Condylus medialis tibiae mit Fibulafraktur",
    "synonyms": [
      "Fraktur der Tuberositas tibiae mit Fibulafraktur",
      "Fraktur des Condylus lateralis tibiae mit Fibulafraktur",
      "Fraktur des Condylus medialis tibiae mit Fibulafraktur",
      "Proximale Tibiafraktur mit Fibulafraktur"
    ]
  },
  {
    "code": "S82.18",
    "name": "Proximale Tibiafraktur",
    "synonyms": [
      "Fraktur der Eminentia intercondylaris der Tibia",
      "Fraktur der Tuberositas tibiae",
      "Fraktur der oberen Tibiaepiphyse",
      "Fraktur des Tibiakondylus",
      "Isolierte proximale Tibiafraktur",
      "Laterale Tibiakopffraktur",
      "Proximale Tibiafraktur",
      "Tibiakopffraktur",
      "Tibiaplateaufraktur"
    ]
  },
  {
    "code": "S82.21",
    "name": "Fibulafraktur mit Tibiafraktur",
    "synonyms": [
      "Fibulafraktur mit Tibiafraktur",
      "Isolierte Tibiaschaftfraktur mit Fibulafraktur",
      "Tibiaschaftfraktur mit Fibulafraktur"
    ]
  },
  {
    "code": "S82.28",
    "name": "Tibiafraktur",
    "synonyms": [
      "Isolierte Tibiaschaftfraktur",
      "Schienbeinbruch",
      "Schienbeinfraktur",
      "Tibiafraktur",
      "Tibiaschaftfraktur",
      "Unterschenkelschaftfraktur"
    ]
  },
  {
    "code": "S82.31",
    "name": "Distale Tibiafraktur mit Fibulafraktur",
    "synonyms": [
      "Distale Tibiafraktur mit Fibulafraktur",
      "Isolierte distale Tibiafraktur mit Fibulafraktur"
    ]
  },
  {
    "code": "S82.38",
    "name": "Distale Tibiafraktur",
    "synonyms": [
      "Distale Tibiafraktur",
      "Distale Unterschenkelfraktur",
      "Fraktur der unteren Tibiaepiphyse",
      "Isolierte distale Tibiafraktur"
    ]
  },
  {
    "code": "S82.40",
    "name": "Fibulafraktur",
    "synonyms": [
      "Fibulafraktur",
      "Wadenbeinbruch",
      "Wadenbeinfraktur"
    ]
  },
  {
    "code": "S82.41",
    "name": "Fibulaköpfchenfraktur",
    "synonyms": [
      "Fibulaköpfchenfraktur",
      "Fraktur des Fibulakopfes",
      "Kollumfraktur der Fibula"
    ]
  },
  {
    "code": "S82.42",
    "name": "Isolierte Fibulaschaftfraktur",
    "synonyms": [
      "Isolierte Fibulaschaftfraktur"
    ]
  },
  {
    "code": "S82.49",
    "name": "Multiple Fibulafrakturen",
    "synonyms": [
      "Multiple Fibulafrakturen"
    ]
  },
  {
    "code": "S82.5",
    "name": "Tibiapilonfraktur",
    "synonyms": [
      "Fraktur des Malleolus medialis tibiae",
      "Innenknöchelfraktur",
      "Pilonfraktur",
      "Tibiafraktur mit Beteiligung des oberen Sprunggelenks",
      "Tibiafraktur mit Knöchelbeteiligung",
      "Tibiapilonfraktur"
    ]
  },
  {
    "code": "S82.6",
    "name": "Außenknöchelfraktur",
    "synonyms": [
      "Außenknöchelfraktur",
      "Fibulafraktur mit Beteiligung des oberen Sprunggelenks",
      "Fibulafraktur mit Knöchelbeteiligung",
      "Fraktur des Malleolus lateralis fibulae",
      "Weber-A-Fraktur des oberen Sprunggelenks",
      "Weber-B-Fraktur des oberen Sprunggelenks",
      "Weber-C-Fraktur",
      "Weber-C-Fraktur des oberen Sprunggelenks"
    ]
  },
  {
    "code": "S82.7",
    "name": "Multiple Frakturen des Unterschenkels",
    "synonyms": [
      "Komplette Unterschenkelfraktur",
      "Maisonneuve-Fraktur des Unterschenkels",
      "Multiple Frakturen des Unterschenkels"
    ]
  },
  {
    "code": "S82.81",
    "name": "Bimalleolare Sprunggelenkfraktur",
    "synonyms": [
      "Bimalleolare Sprunggelenkfraktur",
      "Bimalleolarfraktur",
      "Dupuytren-Fraktur",
      "Dupuytren-Fraktur der Fibula",
      "Dupuytren-Fraktur des Knöchels"
    ]
  },
  {
    "code": "S82.82",
    "name": "Trimalleolarfraktur",
    "synonyms": [
      "Trimalleolare Sprunggelenkfraktur",
      "Trimalleolarfraktur"
    ]
  },
  {
    "code": "S82.88",
    "name": "Sprunggelenkfraktur",
    "synonyms": [
      "Fractura malleolaris",
      "Fraktur des oberen Sprunggelenks",
      "Knöchelbruch",
      "Knöchelfraktur",
      "Malleolarfraktur",
      "Malleolusfraktur",
      "Sprunggelenkfraktur",
      "Sprunggelenkluxationsfraktur"
    ]
  },
  {
    "code": "S82.9",
    "name": "Unterschenkelfraktur",
    "synonyms": [
      "Unterschenkelbruch",
      "Unterschenkelfraktur"
    ]
  },
  {
    "code": "S83.0",
    "name": "Patellaluxation",
    "synonyms": [
      "Kniescheibendislokation",
      "Patelladislokation",
      "Patellaluxation"
    ]
  },
  {
    "code": "S83.10",
    "name": "Kniegelenkluxation",
    "synonyms": [
      "Dislokation des oberen Tibiofibulargelenks",
      "Distale Femurdislokation",
      "Distale Oberschenkeldislokation",
      "Kniedislokation",
      "Kniegelenkluxation",
      "Luxation der Articulatio tibiofibularis",
      "Proximale Fibuladislokation",
      "Proximale Tibiadislokation",
      "Proximale Unterschenkeldislokation"
    ]
  },
  {
    "code": "S83.11",
    "name": "Luxation des distalen Femurs nach posterior",
    "synonyms": [
      "Luxation der proximalen Tibia nach anterior",
      "Luxation des distalen Femurs nach posterior"
    ]
  },
  {
    "code": "S83.12",
    "name": "Luxation der proximalen Tibia nach posterior",
    "synonyms": [
      "Luxation der proximalen Tibia nach posterior"
    ]
  },
  {
    "code": "S83.13",
    "name": "Luxation der proximalen Tibia nach medial",
    "synonyms": [
      "Luxation der proximalen Tibia nach medial"
    ]
  },
  {
    "code": "S83.14",
    "name": "Luxation der proximalen Tibia nach lateral",
    "synonyms": [
      "Luxation der proximalen Tibia nach lateral"
    ]
  },
  {
    "code": "S83.2",
    "name": "Akuter Meniskusriss",
    "synonyms": [
      "Akuter Außenmeniskuskorbhenkelriss",
      "Akuter Innenmeniskuskorbhenkelriss",
      "Akuter Korbhenkelriss",
      "Akuter Meniskusriss",
      "Außenmeniskuskorbhenkelriss",
      "Frischer Korbhenkelriss",
      "Innenmeniskushinterhornlappenriss",
      "Innenmeniskushinterhornquerriss",
      "Innenmeniskushinterhornriss",
      "Innenmeniskuskorbhenkelriss",
      "Innenmeniskuskorbhenkelruptur",
      "Innenmeniskusriss",
      "Korbhenkelriss",
      "Korbhenkelriss des Meniskus des Knies",
      "Korbhenkelriss des Semilunarknorpels",
      "Meniskusabriss",
      "Meniskusabriss des Knies",
      "Meniskusdistorsion mit frischem Riss",
      "Meniskuseinriss",
      "Meniskuslazeration",
      "Meniskusriss",
      "Meniskusruptur",
      "Meniskusverletzung",
      "Riss des inneren Meniskus des Knies",
      "Riss des seitlichen Meniskus des Knies",
      "Semilunarknorpeldistorsion mit frischem Riss",
      "Semilunarknorpelriss",
      "Semilunarknorpelruptur"
    ]
  },
  {
    "code": "S83.3",
    "name": "Akuter Kniegelenkknorpelriss",
    "synonyms": [
      "Akuter Kniegelenkknorpelriss",
      "Frischer traumatischer Knorpelabriss im Knie",
      "Knorpelruptur des Knies"
    ]
  },
  {
    "code": "S83.40",
    "name": "Seitenbandriss des Kniegelenks",
    "synonyms": [
      "Distorsion der Seitenbänder des Knies",
      "Seitenbandriss des Kniegelenks"
    ]
  },
  {
    "code": "S83.41",
    "name": "Distorsion der lateralen Seitenbänder des Knies",
    "synonyms": [
      "Distorsion der fibularen Seitenbänder des Knies",
      "Distorsion der lateralen Seitenbänder des Knies"
    ]
  },
  {
    "code": "S83.42",
    "name": "Distorsion des medialen kollateralen Kniegelenkbandes",
    "synonyms": [
      "Distorsion der medialen Seitenbänder des Knies",
      "Distorsion der tibialen Seitenbänder des Knies",
      "Distorsion des medialen kollateralen Kniegelenkbandes"
    ]
  },
  {
    "code": "S83.43",
    "name": "Partieller Riss des Außenbandes des Knies",
    "synonyms": [
      "Kompletter Riss des Außenbandes des Knies",
      "Kompletter Riss des fibularen Seitenbandes des Knies",
      "Partieller Riss des Außenbandes des Knies",
      "Partieller Riss des fibularen Seitenbandes des Knies"
    ]
  },
  {
    "code": "S83.44",
    "name": "Innenbandruptur des Kniegelenks",
    "synonyms": [
      "Innenbandruptur des Kniegelenks",
      "Kompletter Riss des Innenbandes des Knies",
      "Kompletter Riss des tibialen Seitenbandes des Knies",
      "Partieller Riss des Innenbandes des Knies",
      "Partieller Riss des tibialen Seitenbandes des Knies"
    ]
  },
  {
    "code": "S83.50",
    "name": "Kreuzbandriss",
    "synonyms": [
      "Distorsion eines Ligamentum cruciatum genus",
      "Kreuzbanddistorsion des Knies",
      "Kreuzbandriss",
      "Kreuzbandruptur",
      "Kreuzbandruptur des Kniegelenks"
    ]
  },
  {
    "code": "S83.51",
    "name": "Distorsion des vorderen Kreuzbandes",
    "synonyms": [
      "Distorsion des vorderen Kreuzbandes"
    ]
  },
  {
    "code": "S83.52",
    "name": "Distorsion des hinteren Kreuzbandes",
    "synonyms": [
      "Distorsion des hinteren Kreuzbandes"
    ]
  },
  {
    "code": "S83.53",
    "name": "Ruptur des vorderen Kreuzbandes des Kniegelenks",
    "synonyms": [
      "Kompletter Riss des vorderen Kreuzbandes",
      "Partieller Riss des vorderen Kreuzbandes",
      "Riss des vorderen Kreuzbandes des Knies",
      "Ruptur des vorderen Kreuzbandes des Kniegelenks"
    ]
  },
  {
    "code": "S83.54",
    "name": "Partieller Riss des hinteren Kreuzbandes",
    "synonyms": [
      "Kompletter Riss des hinteren Kreuzbandes",
      "Partieller Riss des hinteren Kreuzbandes"
    ]
  },
  {
    "code": "S83.6",
    "name": "Muskelzerrung im Kniebereich",
    "synonyms": [
      "Distorsio genus",
      "Distorsion des Semilunarknorpels des Knies",
      "Distorsion des oberen Tibiofibulargelenks",
      "Distorsion des proximalen Endes der Tibia",
      "Distorsion des proximalen Endes des Schienbeins",
      "Kniedistorsion a.n.k.",
      "Kniegelenkdistorsion",
      "Kniegelenkverstauchung",
      "Kniegelenkzerrung",
      "Kniescheibendistorsion",
      "Meniskusdistorsion",
      "Muskelzerrung im Kniebereich",
      "Patelladistorsion",
      "Proximale Verstauchung des Tibiofibularbandes",
      "Proximale Verstauchung des Tibiofibulargelenks",
      "Proximale Zerrung des Tibiofibularbandes",
      "Proximale Zerrung des Tibiofibulargelenks",
      "Proximale tibiofibulare Kniedistorsion a.n.k.",
      "Proximale tibiofibulare Verstauchung",
      "Proximale tibiofibulare Zerrung"
    ]
  },
  {
    "code": "S83.7",
    "name": "Verletzung des Außenmeniskus mit Verletzung eines Seitenbandes",
    "synonyms": [
      "Multiple Knieverletzungen a.n.k.",
      "Verletzung des Außenmeniskus mit Verletzung eines Kreuzbandes",
      "Verletzung des Außenmeniskus mit Verletzung eines Seitenbandes",
      "Verletzung des Innenmeniskus mit Verletzung eines Kreuzbandes",
      "Verletzung des Innenmeniskus mit Verletzung eines Seitenbandes",
      "Verletzung des Meniskus des Knies mit Bandverletzung"
    ]
  },
  {
    "code": "S84.0",
    "name": "Verletzung des Nervus tibialis in Höhe des Unterschenkels",
    "synonyms": [
      "Verletzung des Nervus tibialis in Höhe des Unterschenkels"
    ]
  },
  {
    "code": "S84.1",
    "name": "Verletzung des Nervus peronaeus in Höhe des Unterschenkels",
    "synonyms": [
      "Verletzung des Nervus peronaeus in Höhe des Unterschenkels"
    ]
  },
  {
    "code": "S84.2",
    "name": "Verletzung der sensiblen Hautnerven in Höhe des Unterschenkels",
    "synonyms": [
      "Verletzung der sensiblen Hautnerven in Höhe des Unterschenkels"
    ]
  },
  {
    "code": "S84.7",
    "name": "Verletzung multipler Nerven am Unterschenkel",
    "synonyms": [
      "Verletzung multipler Nerven am Unterschenkel"
    ]
  },
  {
    "code": "S84.9",
    "name": "Nervenverletzung am Unterschenkel",
    "synonyms": [
      "Nervenverletzung am Unterschenkel"
    ]
  },
  {
    "code": "S85.0",
    "name": "Verletzung der Arteria poplitea",
    "synonyms": [
      "Verletzung der Arteria poplitea",
      "Verletzung der Poplitealarterie"
    ]
  },
  {
    "code": "S85.1",
    "name": "Verletzung der Arteria tibialis",
    "synonyms": [
      "Verletzung der Arteria tibialis"
    ]
  },
  {
    "code": "S85.2",
    "name": "Verletzung der Arteria peronaea",
    "synonyms": [
      "Verletzung der Arteria peronaea"
    ]
  },
  {
    "code": "S85.3",
    "name": "Verletzung der Vena saphena magna in Höhe des Unterschenkels",
    "synonyms": [
      "Verletzung der Vena saphena magna",
      "Verletzung der Vena saphena magna in Höhe des Unterschenkels"
    ]
  },
  {
    "code": "S85.4",
    "name": "Verletzung der Vena saphena parva in Höhe des Unterschenkels",
    "synonyms": [
      "Verletzung der Vena saphena parva in Höhe des Unterschenkels"
    ]
  },
  {
    "code": "S85.5",
    "name": "Verletzung der Vena poplitea",
    "synonyms": [
      "Verletzung der Poplitealvene",
      "Verletzung der Vena poplitea"
    ]
  },
  {
    "code": "S85.7",
    "name": "Verletzung multipler Blutgefäße am Unterschenkel",
    "synonyms": [
      "Verletzung multipler Blutgefäße am Unterschenkel"
    ]
  },
  {
    "code": "S85.9",
    "name": "Verletzung eines Blutgefäßes am Unterschenkel",
    "synonyms": [
      "Verletzung eines Blutgefäßes am Unterschenkel",
      "Verletzung eines poplitealen Blutgefäßes"
    ]
  },
  {
    "code": "S86.0",
    "name": "Achillessehnenverletzung",
    "synonyms": [
      "Achillessehnendistorsion",
      "Achillessehnenlazeration",
      "Achillessehnenriss",
      "Achillessehnenruptur",
      "Achillessehnenverletzung"
    ]
  },
  {
    "code": "S86.2",
    "name": "Verletzung der anterioren Muskelgruppe in Unterschenkel-Höhe",
    "synonyms": [
      "Verletzung der anterioren Muskelgruppe in Unterschenkel-Höhe"
    ]
  },
  {
    "code": "S86.3",
    "name": "Verletzung der peronäalen Muskelgruppe in Unterschenkel-Höhe",
    "synonyms": [
      "Verletzung der peronäalen Muskelgruppe in Unterschenkel-Höhe"
    ]
  },
  {
    "code": "S86.7",
    "name": "Verletzung multipler Muskeln am Unterschenkel",
    "synonyms": [
      "Verletzung multipler Muskeln am Unterschenkel"
    ]
  },
  {
    "code": "S86.9",
    "name": "Muskelzerrung der Wade",
    "synonyms": [
      "Muskelfaserriss der Wade",
      "Muskelverletzung des Unterschenkels",
      "Muskelverstauchung des Unterschenkels",
      "Muskelzerrung der Wade",
      "Muskelzerrung des Unterschenkels",
      "Sehnenverstauchung des Unterschenkels",
      "Sehnenzerrung des Unterschenkels",
      "Wadenzerrung"
    ]
  },
  {
    "code": "S87.0",
    "name": "Kniezerquetschung",
    "synonyms": [
      "Kniezerquetschung"
    ]
  },
  {
    "code": "S87.8",
    "name": "Unterschenkelzerquetschung",
    "synonyms": [
      "Unterschenkelzerquetschung"
    ]
  },
  {
    "code": "S88.0",
    "name": "Traumatische Amputation in Höhe des Knies",
    "synonyms": [
      "Traumatische Amputation in Höhe des Knies"
    ]
  },
  {
    "code": "S88.1",
    "name": "Traumatische Amputation zwischen Knie und oberem Sprunggelenk",
    "synonyms": [
      "Traumatische Amputation zwischen Knie und oberem Sprunggelenk"
    ]
  },
  {
    "code": "S88.9",
    "name": "Traumatische Amputation des Unterschenkels",
    "synonyms": [
      "Abtrennung des Unterschenkels",
      "Traumatische Amputation des Unterschenkels"
    ]
  },
  {
    "code": "S89.7",
    "name": "Multiple Verletzungen des Unterschenkels",
    "synonyms": [
      "Multiple Verletzungen des Unterschenkels",
      "Multiple Verletzungen von Knie und Unterschenkel"
    ]
  },
  {
    "code": "S89.9",
    "name": "Unterschenkeltrauma",
    "synonyms": [
      "Frische Knieschädigung",
      "Knieverletzung",
      "Unterschenkeltrauma",
      "Unterschenkelverletzung",
      "Verletzung der Kniekehle"
    ]
  },
  {
    "code": "S90.0",
    "name": "Prellung der Knöchelregion",
    "synonyms": [
      "Knöchelprellung",
      "Prellung der Knöchelregion",
      "Prellung des oberen Sprunggelenks"
    ]
  },
  {
    "code": "S90.1",
    "name": "Zehenprellung",
    "synonyms": [
      "Prellung der Kleinzehe",
      "Zehenprellung"
    ]
  },
  {
    "code": "S90.2",
    "name": "Zehenprellung mit Nagelschädigung",
    "synonyms": [
      "Zehennagelprellung",
      "Zehenprellung mit Nagelschädigung"
    ]
  },
  {
    "code": "S90.3",
    "name": "Vorfußprellung",
    "synonyms": [
      "Fersenprellung",
      "Fußprellung",
      "Fußrückenprellung",
      "Vorfußprellung"
    ]
  },
  {
    "code": "S90.7",
    "name": "Multiple Prellungen von Knöchel und Fuß",
    "synonyms": [
      "Multiple Prellungen von Knöchel und Fuß",
      "Multiple oberflächliche Verletzungen an Fuß und Knöchelregion"
    ]
  },
  {
    "code": "S90.81",
    "name": "Schürfwunde am Knöchel",
    "synonyms": [
      "Schürfwunde am Fuß",
      "Schürfwunde am Knöchel"
    ]
  },
  {
    "code": "S90.86",
    "name": "Subkutanes Décollement an der Knöchelregion",
    "synonyms": [
      "Subkutanes Décollement am Fuß",
      "Subkutanes Décollement an der Knöchelregion"
    ]
  },
  {
    "code": "S90.9",
    "name": "Oberflächliche Fußverletzung",
    "synonyms": [
      "Oberflächliche Fersenverletzung",
      "Oberflächliche Fußverletzung",
      "Oberflächliche Knöchelverletzung",
      "Oberflächliche Verletzung der Knöchelregion",
      "Oberflächliche Zehennagelverletzung",
      "Oberflächliche Zehenverletzung",
      "Oberflächliche subunguale Zehenverletzung",
      "Subunguale Zehenverletzung"
    ]
  },
  {
    "code": "S91.0",
    "name": "Offene Wunde der Knöchelregion",
    "synonyms": [
      "Offene Wunde der Knöchelregion"
    ]
  },
  {
    "code": "S91.1",
    "name": "Offene Zehenwunde ohne Nagelschädigung",
    "synonyms": [
      "Offene Zehenwunde",
      "Offene Zehenwunde ohne Nagelschädigung"
    ]
  },
  {
    "code": "S91.2",
    "name": "Offene Zehenwunde mit Nagelschädigung",
    "synonyms": [
      "Offene Zehennagelwunde",
      "Offene Zehenwunde mit Nagelschädigung"
    ]
  },
  {
    "code": "S91.3",
    "name": "Offene Fußwunde",
    "synonyms": [
      "Offene Fersenwunde",
      "Offene Fußwunde",
      "Offene Wunde des Spanns",
      "Schnittverletzung des Fußrückens"
    ]
  },
  {
    "code": "S91.7",
    "name": "Multiple offene Wunden an Fuß und Knöchelregion",
    "synonyms": [
      "Multiple offene Wunden an Fuß und Knöchelregion"
    ]
  },
  {
    "code": "S92.0",
    "name": "Fersenbeinbruch",
    "synonyms": [
      "Fersenbeinbruch",
      "Fersenbeinfraktur",
      "Fraktur des Os calcis",
      "Fraktur des Os scaphoideum des Fußes",
      "Kalkaneusfraktur",
      "Kalkaneustrümmerfraktur"
    ]
  },
  {
    "code": "S92.1",
    "name": "Talusfraktur",
    "synonyms": [
      "Astragalusfraktur",
      "Sprungbeinfraktur",
      "Talusfraktur"
    ]
  },
  {
    "code": "S92.20",
    "name": "Fußwurzelfraktur",
    "synonyms": [
      "Fraktur der Ossa tarsi eines Fußes",
      "Fußwurzelfraktur",
      "Fußwurzelknochenfraktur",
      "Tarsusfraktur"
    ]
  },
  {
    "code": "S92.21",
    "name": "Kahnbeinfraktur des Fußes",
    "synonyms": [
      "Fraktur des Os naviculare pedis",
      "Fraktur des Os scaphoideum",
      "Kahnbeinfraktur des Fußes"
    ]
  },
  {
    "code": "S92.22",
    "name": "Würfelbeinfraktur",
    "synonyms": [
      "Fraktur des Os cuboideum",
      "Würfelbeinfraktur"
    ]
  },
  {
    "code": "S92.23",
    "name": "Fraktur des Os cuneiforme",
    "synonyms": [
      "Fraktur des Os cuneiforme",
      "Keilbeinfraktur des Fußes"
    ]
  },
  {
    "code": "S92.3",
    "name": "Metatarsalfraktur",
    "synonyms": [
      "Deutschländer-Fraktur",
      "Deutschländer-Syndrom",
      "Metatarsalfraktur",
      "Metatarsalknochenfraktur",
      "Mittelfußbruch",
      "Mittelfußfraktur"
    ]
  },
  {
    "code": "S92.4",
    "name": "Großzehenfraktur",
    "synonyms": [
      "Großzehenfraktur",
      "Sesambeinfraktur des Fußes"
    ]
  },
  {
    "code": "S92.5",
    "name": "Zehenfraktur",
    "synonyms": [
      "Phalanxfraktur des Fußes",
      "Zehenfraktur",
      "Zehengliedfraktur"
    ]
  },
  {
    "code": "S92.7",
    "name": "Multiple Frakturen des Fußes",
    "synonyms": [
      "Multiple Frakturen des Fußes"
    ]
  },
  {
    "code": "S92.9",
    "name": "Fußfraktur",
    "synonyms": [
      "Fußfraktur"
    ]
  },
  {
    "code": "S93.0",
    "name": "Sprunggelenkluxation",
    "synonyms": [
      "Astragalusdislokation",
      "Dislokation des oberen Sprunggelenks",
      "Dislokation des unteren Tibiofibulargelenks",
      "Distale Fibuladislokation",
      "Distale Fibulaluxation",
      "Distale Tibiadislokation",
      "Distale Tibialuxation",
      "Distale Unterschenkeldislokation",
      "Sprunggelenkluxation",
      "Talusdislokation",
      "Talusluxation"
    ]
  },
  {
    "code": "S93.10",
    "name": "Zehenluxation",
    "synonyms": [
      "Dislokation des Zehengelenks",
      "Dislokation einer Phalanx des Fußes",
      "Dislokation einer Phalanx einer Zehe",
      "Zehendislokation",
      "Zehenluxation"
    ]
  },
  {
    "code": "S93.11",
    "name": "Dislokation eines Metatarsophalangealgelenks",
    "synonyms": [
      "Dislokation eines Metatarsophalangealgelenks"
    ]
  },
  {
    "code": "S93.12",
    "name": "Zehendislokation im Interphalangealgelenk",
    "synonyms": [
      "Zehendislokation im Interphalangealgelenk"
    ]
  },
  {
    "code": "S93.2",
    "name": "Außenbandruptur des Sprunggelenks",
    "synonyms": [
      "Außenbandruptur des Sprunggelenks",
      "Außenbandruptur des oberen Sprunggelenks",
      "Traumatische Bandruptur des oberen Sprunggelenks"
    ]
  },
  {
    "code": "S93.30",
    "name": "Fußluxation",
    "synonyms": [
      "Fußdislokation",
      "Fußluxation"
    ]
  },
  {
    "code": "S93.31",
    "name": "Dislokation eines Tarsalgelenks",
    "synonyms": [
      "Dislokation der Tarsalknochen",
      "Dislokation des Os naviculare pedis",
      "Dislokation eines Tarsalgelenks",
      "Kahnbeindislokation des Fußes"
    ]
  },
  {
    "code": "S93.32",
    "name": "Dislokation des Mediotarsalgelenks",
    "synonyms": [
      "Dislokation des Mediotarsalgelenks"
    ]
  },
  {
    "code": "S93.33",
    "name": "Dislokation des Lisfranc-Gelenks",
    "synonyms": [
      "Dislokation des Lisfranc-Gelenks",
      "Dislokation des Tarsometatarsalgelenks"
    ]
  },
  {
    "code": "S93.34",
    "name": "Dislokation des Chopart-Gelenks",
    "synonyms": [
      "Dislokation der Metatarsalknochen",
      "Dislokation des Chopart-Gelenks"
    ]
  },
  {
    "code": "S93.40",
    "name": "Sprunggelenkdistorsion",
    "synonyms": [
      "Außenbandläsion des oberen Sprunggelenks",
      "Bänderdehnung des oberen Sprunggelenks",
      "Distorsion des oberen Sprunggelenks",
      "Kapselbandverletzung des oberen Sprunggelenks",
      "Kapselbandzerrung des Sprunggelenks",
      "Knöchelverstauchung",
      "Sprunggelenkdistorsion",
      "Verstauchung des oberen Sprunggelenks",
      "Zerrung des oberen Sprunggelenks"
    ]
  },
  {
    "code": "S93.41",
    "name": "Distorsion des Innenbandes des oberen Sprunggelenks",
    "synonyms": [
      "Distorsion des Innenbandes des oberen Sprunggelenks",
      "Distorsion des Ligamentum deltoideum am Knöchel"
    ]
  },
  {
    "code": "S93.42",
    "name": "Distorsion des Ligamentum calcaneofibulare",
    "synonyms": [
      "Distorsion des Ligamentum calcaneofibulare",
      "Distorsion des Ligamentum fibulocalcaneare"
    ]
  },
  {
    "code": "S93.43",
    "name": "Distorsion des distalen Ligamentum tibiofibulare",
    "synonyms": [
      "Distorsion des distalen Ligamentum tibiofibulare",
      "Distorsion des unteren Tibiofibulargelenks"
    ]
  },
  {
    "code": "S93.48",
    "name": "Distorsion des Ligamentum talofibulare",
    "synonyms": [
      "Distorsion der talofibularen Bänder",
      "Distorsion des Ligamentum talofibulare"
    ]
  },
  {
    "code": "S93.5",
    "name": "Zehenverstauchung",
    "synonyms": [
      "Interphalangeale Verstauchung",
      "Interphalangeale Zehendistorsion",
      "Interphalangeale Zerrung",
      "Metatarsophalangeale Distorsion",
      "Metatarsophalangeale Verstauchung",
      "Metatarsophalangeale Zerrung",
      "Verstauchung eines Interphalangealgelenks",
      "Verstauchung eines Metatarsophalangealgelenks",
      "Zehendistorsion",
      "Zehenverstauchung",
      "Zehenzerrung",
      "Zerrung eines Interphalangealgelenks",
      "Zerrung eines Metatarsophalangealgelenks"
    ]
  },
  {
    "code": "S93.6",
    "name": "Fußgelenkübertretung",
    "synonyms": [
      "Distorsio pedis",
      "Distorsion des Chopart-Gelenks",
      "Distorsion des Lisfranc-Gelenks",
      "Fußdistorsion",
      "Fußgelenkdistorsion",
      "Fußgelenkverstauchung",
      "Fußgelenkzerrung",
      "Fußgelenkübertretung",
      "Fußverstauchung",
      "Fußzerrung",
      "Mediotarsale Distorsion",
      "Metatarsaldistorsion",
      "Mittelfußdistorsion",
      "Tarsale Distorsion",
      "Tarsale Verstauchung",
      "Tarsale Zerrung",
      "Tarsometatarsale Distorsion",
      "Tarsometatarsale Verstauchung",
      "Tarsometatarsale Zerrung",
      "Verstauchung eines Tarsalbandes",
      "Verstauchung eines Tarsometatarsalbandes",
      "Zerrung eines Tarsalbandes",
      "Zerrung eines Tarsometatarsalbandes"
    ]
  },
  {
    "code": "S94.0",
    "name": "Verletzung des Nervus plantaris lateralis",
    "synonyms": [
      "Verletzung des Nervus plantaris lateralis"
    ]
  },
  {
    "code": "S94.1",
    "name": "Verletzung des Nervus plantaris medialis",
    "synonyms": [
      "Verletzung des Nervus plantaris medialis"
    ]
  },
  {
    "code": "S94.2",
    "name": "Verletzung des Nervus peronaeus profundus in Höhe des Knöchels",
    "synonyms": [
      "Verletzung des Nervus peronaeus profundus in Fußhöhe",
      "Verletzung des Nervus peronaeus profundus in Höhe des Knöchels",
      "Verletzung des lateralen Endastes des Nervus peronaeus profundus"
    ]
  },
  {
    "code": "S94.3",
    "name": "Verletzung der sensiblen Hautnerven in Höhe des Knöchels",
    "synonyms": [
      "Verletzung der sensiblen Hautnerven in Fußhöhe",
      "Verletzung der sensiblen Hautnerven in Höhe des Knöchels"
    ]
  },
  {
    "code": "S94.7",
    "name": "Verletzung multipler Nerven am Knöchel",
    "synonyms": [
      "Verletzung multipler Nerven am Fuß",
      "Verletzung multipler Nerven am Knöchel"
    ]
  },
  {
    "code": "S94.9",
    "name": "Nervenverletzung am Fuß",
    "synonyms": [
      "Nervenverletzung am Fuß",
      "Nervenverletzung am Knöchel",
      "Nervenverletzung einer Zehe"
    ]
  },
  {
    "code": "S95.0",
    "name": "Verletzung der Arteria dorsalis pedis",
    "synonyms": [
      "Verletzung der Arteria dorsalis pedis"
    ]
  },
  {
    "code": "S95.1",
    "name": "Verletzung der Arteria plantaris pedis",
    "synonyms": [
      "Verletzung der Arteria plantaris pedis"
    ]
  },
  {
    "code": "S95.2",
    "name": "Verletzung einer Vene des Fußrückens",
    "synonyms": [
      "Verletzung einer Vene des Fußrückens"
    ]
  },
  {
    "code": "S95.7",
    "name": "Verletzung multipler Blutgefäße am Fuß",
    "synonyms": [
      "Verletzung multipler Blutgefäße am Fuß",
      "Verletzung multipler Blutgefäße am Knöchel"
    ]
  },
  {
    "code": "S95.9",
    "name": "Verletzung eines Blutgefäßes am Knöchel",
    "synonyms": [
      "Verletzung eines Blutgefäßes am Fuß",
      "Verletzung eines Blutgefäßes am Knöchel"
    ]
  },
  {
    "code": "S96.0",
    "name": "Verletzung eines Beugemuskels einer Zehe",
    "synonyms": [
      "Verletzung eines Beugemuskels einer Zehe"
    ]
  },
  {
    "code": "S96.7",
    "name": "Verletzung multipler Muskeln am Fuß",
    "synonyms": [
      "Verletzung multipler Muskeln am Fuß",
      "Verletzung multipler Muskeln am Knöchel"
    ]
  },
  {
    "code": "S96.9",
    "name": "Muskelverstauchung des Knöchels",
    "synonyms": [
      "Muskelverletzung des Fußes",
      "Muskelverletzung des Knöchels",
      "Muskelverstauchung des Fußes",
      "Muskelverstauchung des Knöchels",
      "Sehnenverstauchung des Fußes",
      "Sehnenverstauchung des Knöchels"
    ]
  },
  {
    "code": "S97.0",
    "name": "Zerquetschung des oberen Sprunggelenks",
    "synonyms": [
      "Zerquetschung des oberen Sprunggelenks"
    ]
  },
  {
    "code": "S97.1",
    "name": "Zehenzerquetschung",
    "synonyms": [
      "Zehenzerquetschung"
    ]
  },
  {
    "code": "S97.8",
    "name": "Fußzerquetschung",
    "synonyms": [
      "Fersenzerquetschung",
      "Fußzerquetschung",
      "Zerquetschung des oberen Sprunggelenks mit Beteiligung des Fußes"
    ]
  },
  {
    "code": "S98.0",
    "name": "Traumatische Amputation des Fußes in Höhe des oberen Sprunggelenks",
    "synonyms": [
      "Traumatische Amputation des Fußes in Höhe des oberen Sprunggelenks"
    ]
  },
  {
    "code": "S98.1",
    "name": "Traumatische Amputation einer Zehe",
    "synonyms": [
      "Traumatische Amputation einer Zehe"
    ]
  },
  {
    "code": "S98.2",
    "name": "Traumatische Amputation mehrerer Zehen",
    "synonyms": [
      "Traumatische Amputation mehrerer Zehen"
    ]
  },
  {
    "code": "S98.3",
    "name": "Traumatische Amputation einer Zehe und von Teilen des Fußes",
    "synonyms": [
      "Traumatische Amputation einer Zehe und von Teilen des Fußes",
      "Traumatische Amputation zweier oder mehrerer Zehen und von Teilen des Fußes"
    ]
  },
  {
    "code": "S98.4",
    "name": "Traumatische Amputation des Fußes",
    "synonyms": [
      "Traumatische Amputation des Fußes"
    ]
  },
  {
    "code": "S99.7",
    "name": "Zehenverletzung mit Sehnenbeteiligung",
    "synonyms": [
      "Fußverletzung mit Sehnenbeteiligung",
      "Knöchelverletzung mit Sehnenbeteiligung",
      "Multiple Verletzungen von Fuß und Knöchelregion",
      "Zehenverletzung mit Sehnenbeteiligung"
    ]
  },
  {
    "code": "S99.9",
    "name": "Fußverletzung",
    "synonyms": [
      "Fersenverletzung",
      "Fußverletzung",
      "Knöchelverletzung",
      "Verletzung der Phalangen des Fußes",
      "Zehenverletzung"
    ]
  },
  {
    "code": "T00.6",
    "name": "Oberflächliche Verletzung an multiplen Lokalisationen der oberen Extremität und der unteren Extremität",
    "synonyms": [
      "Oberflächliche Verletzung an multiplen Lokalisationen der oberen Extremität und der unteren Extremität"
    ]
  },
  {
    "code": "T00.8",
    "name": "Oberflächliche Verletzung an der oberen Extremität und am Thorax",
    "synonyms": [
      "Oberflächliche Verletzung an der oberen Extremität und am Abdomen",
      "Oberflächliche Verletzung an der oberen Extremität und am Becken",
      "Oberflächliche Verletzung an der oberen Extremität und am Thorax",
      "Oberflächliche Verletzung an der oberen Extremität und an der Lumbosakralregion",
      "Oberflächliche Verletzung an der unteren Extremität und am Abdomen",
      "Oberflächliche Verletzung an der unteren Extremität und am Becken",
      "Oberflächliche Verletzung an der unteren Extremität und am Thorax",
      "Oberflächliche Verletzung an der unteren Extremität und an der Lumbosakralregion"
    ]
  },
  {
    "code": "T00.9",
    "name": "Multiple Prellungen",
    "synonyms": [
      "Leichte kombinierte Verletzung",
      "Multiple Hämatome",
      "Multiple Kontusionen",
      "Multiple Prellungen",
      "Multiple Quetschwunden",
      "Multiple Schürfwunden",
      "Multiple nichtthermische Blasenbildungen",
      "Multiple oberflächliche Verletzungen",
      "Multiple ungiftige Insektenbisse",
      "Multiple ungiftige Insektenstiche"
    ]
  },
  {
    "code": "T01.0",
    "name": "Mehrere offene Wunden an Hals und Kopf",
    "synonyms": [
      "Mehrere offene Wunden an Hals und Kopf"
    ]
  },
  {
    "code": "T01.1",
    "name": "Offene Wunde des Rumpfes an multiplen Lokalisationen",
    "synonyms": [
      "Mehrere offene Wunden an Thorax und Abdomen",
      "Mehrere offene Wunden an Thorax und Becken",
      "Mehrere offene Wunden an Thorax und Lumbosakralregion",
      "Offene Wunde des Rumpfes an multiplen Lokalisationen"
    ]
  },
  {
    "code": "T01.2",
    "name": "Offene Wunde an multiplen Lokalisationen der oberen Extremität",
    "synonyms": [
      "Offene Wunde an multiplen Lokalisationen der oberen Extremität"
    ]
  },
  {
    "code": "T01.3",
    "name": "Offene Wunde an multiplen Lokalisationen der unteren Extremität",
    "synonyms": [
      "Offene Wunde an multiplen Lokalisationen der unteren Extremität"
    ]
  },
  {
    "code": "T01.6",
    "name": "Mehrere offene Wunden an der oberen Extremität und an der unteren Extremität",
    "synonyms": [
      "Mehrere offene Wunden an der oberen Extremität und an der unteren Extremität"
    ]
  },
  {
    "code": "T01.8",
    "name": "Mehrere offene Wunden der unteren Extremität und des Thorax",
    "synonyms": [
      "Mehrere offene Wunden der oberen Extremität und der Lumbosakralregion",
      "Mehrere offene Wunden der oberen Extremität und des Abdomens",
      "Mehrere offene Wunden der oberen Extremität und des Beckens",
      "Mehrere offene Wunden der oberen Extremität und des Thorax",
      "Mehrere offene Wunden der unteren Extremität und der Lumbosakralregion",
      "Mehrere offene Wunden der unteren Extremität und des Abdomens",
      "Mehrere offene Wunden der unteren Extremität und des Beckens",
      "Mehrere offene Wunden der unteren Extremität und des Thorax"
    ]
  },
  {
    "code": "T01.9",
    "name": "Multiple Lazerationen",
    "synonyms": [
      "Mehrere offene Wunden",
      "Multiple Lazerationen",
      "Multiple Risswunden",
      "Multiple Schnittwunden",
      "Multiple Stichwunden",
      "Multiple Tierbisse"
    ]
  },
  {
    "code": "T02.00",
    "name": "Multiple Frakturen an Hals und Kopf",
    "synonyms": [
      "Geschlossene multiple Frakturen mit Beteiligung von Kopf und Hals",
      "Multiple Frakturen an Hals und Kopf"
    ]
  },
  {
    "code": "T02.01",
    "name": "Offene multiple Frakturen mit Beteiligung von Kopf und Hals",
    "synonyms": [
      "Offene multiple Frakturen mit Beteiligung von Kopf und Hals"
    ]
  },
  {
    "code": "T02.10",
    "name": "Multiple Rumpffrakturen",
    "synonyms": [
      "Multiple Frakturen an Thorax und Becken",
      "Multiple Frakturen an Thorax und Lumbosakralgegend",
      "Multiple Rumpffrakturen",
      "Multiple Rumpfskelettfrakturen a.n.k.",
      "Multiple Wirbelfrakturen",
      "Multiple Wirbelsäulenfrakturen",
      "Multiple geschlossene Frakturen an Thorax und Becken",
      "Multiple geschlossene Frakturen an Thorax und Lumbosakralgegend"
    ]
  },
  {
    "code": "T02.11",
    "name": "Multiple offene Frakturen an Thorax und Becken",
    "synonyms": [
      "Multiple offene Frakturen an Thorax und Becken",
      "Multiple offene Frakturen an Thorax und Lumbosakralgegend"
    ]
  },
  {
    "code": "T02.20",
    "name": "Multiple Frakturen der oberen Extremität a.n.k.",
    "synonyms": [
      "Multiple Frakturen der oberen Extremität a.n.k.",
      "Multiple geschlossene Frakturen der oberen Extremität"
    ]
  },
  {
    "code": "T02.21",
    "name": "Multiple offene Frakturen der oberen Extremität",
    "synonyms": [
      "Multiple offene Frakturen der oberen Extremität"
    ]
  },
  {
    "code": "T02.30",
    "name": "Multiple Frakturen der unteren Extremität a.n.k.",
    "synonyms": [
      "Multiple Frakturen der unteren Extremität a.n.k.",
      "Multiple geschlossene Frakturen der unteren Extremität"
    ]
  },
  {
    "code": "T02.31",
    "name": "Multiple offene Frakturen der unteren Extremität",
    "synonyms": [
      "Multiple offene Frakturen der unteren Extremität"
    ]
  },
  {
    "code": "T02.40",
    "name": "Fraktur beider oberer Extremitäten",
    "synonyms": [
      "Fraktur beider oberer Extremitäten",
      "Multiple geschlossene Frakturen beider oberer Extremitäten"
    ]
  },
  {
    "code": "T02.41",
    "name": "Multiple offene Frakturen beider oberer Extremitäten",
    "synonyms": [
      "Multiple offene Frakturen beider oberer Extremitäten"
    ]
  },
  {
    "code": "T02.50",
    "name": "Fraktur beider unterer Extremitäten",
    "synonyms": [
      "Fraktur beider unterer Extremitäten",
      "Multiple geschlossene Frakturen beider unterer Extremitäten"
    ]
  },
  {
    "code": "T02.51",
    "name": "Multiple offene Frakturen beider unterer Extremitäten",
    "synonyms": [
      "Multiple offene Frakturen beider unterer Extremitäten"
    ]
  },
  {
    "code": "T02.60",
    "name": "Multiple Frakturen der oberen Extremität und der unteren Extremität",
    "synonyms": [
      "Multiple Frakturen der oberen Extremität und der unteren Extremität",
      "Multiple geschlossene Frakturen der oberen Extremität und der unteren Extremität"
    ]
  },
  {
    "code": "T02.61",
    "name": "Multiple offene Frakturen der oberen Extremität und der unteren Extremität",
    "synonyms": [
      "Multiple offene Frakturen der oberen Extremität und der unteren Extremität"
    ]
  },
  {
    "code": "T02.70",
    "name": "Fraktur des Rumpfes mit Beteiligung der Extremitäten",
    "synonyms": [
      "Fraktur des Rumpfes mit Beteiligung der Extremitäten",
      "Fraktur des Thorax mit Beteiligung der Extremitäten",
      "Multiple Frakturen an oberer Extremität, Thorax und Becken",
      "Multiple Frakturen an oberer Extremität, Thorax und Lumbosakralgegend",
      "Multiple Frakturen an unterer Extremität, Thorax und Becken",
      "Multiple Frakturen an unterer Extremität, Thorax und Lumbosakralgegend",
      "Multiple geschlossene Frakturen an Extremität, Thorax und Becken",
      "Multiple geschlossene Frakturen an Extremität, Thorax und Lumbosakralgegend"
    ]
  },
  {
    "code": "T02.71",
    "name": "Multiple offene Frakturen an Extremität, Thorax und Becken",
    "synonyms": [
      "Multiple offene Frakturen an Extremität, Thorax und Becken",
      "Multiple offene Frakturen an Extremität, Thorax und Lumbosakralgegend"
    ]
  },
  {
    "code": "T02.80",
    "name": "Multiple Frakturen an Hals und anderen Körperregionen",
    "synonyms": [
      "Multiple Frakturen an Hals und anderen Körperregionen",
      "Multiple Kopffrakturen mit Beteiligung anderer Körperregionen",
      "Multiple Rumpffrakturen mit Beteiligung anderer Körperregionen a.n.k.",
      "Multiple Thoraxfrakturen mit Beteiligung anderer Körperregionen a.n.k."
    ]
  },
  {
    "code": "T02.91",
    "name": "Multiple offene Frakturen",
    "synonyms": [
      "Multiple offene Frakturen"
    ]
  },
  {
    "code": "T03.0",
    "name": "Distorsion von Hals und Kopf",
    "synonyms": [
      "Distorsion von Hals und Kopf",
      "Multiple Dislokationen an Hals und Kopf"
    ]
  },
  {
    "code": "T03.1",
    "name": "Multiple Dislokationen am Rumpf",
    "synonyms": [
      "Mehrere Distorsionen am Rumpf",
      "Multiple Dislokationen am Rumpf",
      "Thoraxdistorsion mit Beteiligung der Lumbosakralgegend und des Beckens"
    ]
  },
  {
    "code": "T03.2",
    "name": "Multiple Dislokationen an der oberen Extremität",
    "synonyms": [
      "Mehrere Distorsionen an der oberen Extremität",
      "Multiple Dislokationen an der oberen Extremität"
    ]
  },
  {
    "code": "T03.3",
    "name": "Multiple Dislokationen an der unteren Extremität",
    "synonyms": [
      "Mehrere Distorsionen an der unteren Extremität",
      "Multiple Dislokationen an der unteren Extremität"
    ]
  },
  {
    "code": "T03.4",
    "name": "Dislokation der oberen und unteren Extremität",
    "synonyms": [
      "Dislokation der oberen und unteren Extremität",
      "Distorsion der oberen und unteren Extremität"
    ]
  },
  {
    "code": "T03.8",
    "name": "Dislokation der zervikothorakalen Wirbelsäule",
    "synonyms": [
      "Dislokation an multiplen Körperregionen a.n.k.",
      "Dislokation der zervikothorakalen Wirbelsäule",
      "Distorsion an unterer Extremität, Thorax, Lumbosakralgegend und Becken",
      "Distorsion multipler Körperregionen a.n.k.",
      "Multiple Dislokationen an Hals und sonstigen Körperregionen",
      "Multiple Dislokationen an oberer Extremität, Thorax, Lumbosakralgegend und Becken",
      "Multiple Dislokationen an unterer Extremität, Thorax, Lumbosakralgegend und Becken",
      "Zervikothorakale Wirbeldislokation"
    ]
  },
  {
    "code": "T03.9",
    "name": "Mehrere Distorsionen",
    "synonyms": [
      "Mehrere Distorsionen"
    ]
  },
  {
    "code": "T04.0",
    "name": "Quetschung von Hals und Kopf",
    "synonyms": [
      "Quetschung von Hals und Kopf"
    ]
  },
  {
    "code": "T04.1",
    "name": "Rumpfzerquetschung",
    "synonyms": [
      "Multiple Zerquetschungen an Thorax und Abdomen",
      "Multiple Zerquetschungen an Thorax und Becken",
      "Multiple Zerquetschungen an Thorax und Lumbosakralgegend",
      "Rumpfzerquetschung",
      "Rumpfzerquetschung an multiplen Lokalisationen"
    ]
  },
  {
    "code": "T04.2",
    "name": "Zerquetschung der oberen Extremität",
    "synonyms": [
      "Armzerquetschung",
      "Multiple Zerquetschungen der oberen Extremität",
      "Zerquetschung der oberen Extremität"
    ]
  },
  {
    "code": "T04.3",
    "name": "Zerquetschung der unteren Extremität",
    "synonyms": [
      "Beinzerquetschung",
      "Multiple Zerquetschungen der unteren Extremität",
      "Zerquetschung der unteren Extremität"
    ]
  },
  {
    "code": "T04.4",
    "name": "Multiple Zerquetschungen der oberen Extremität und der unteren Extremität",
    "synonyms": [
      "Multiple Zerquetschungen der oberen Extremität und der unteren Extremität"
    ]
  },
  {
    "code": "T04.7",
    "name": "Zerquetschung von Rumpf und Extremität",
    "synonyms": [
      "Multiple Zerquetschungen an einer unteren Extremität, Thorax und Abdomen",
      "Multiple Zerquetschungen an einer unteren Extremität, Thorax und Becken",
      "Multiple Zerquetschungen an einer unteren Extremität, Thorax und Lumbosakralgegend",
      "Zerquetschung von Rumpf und Extremität"
    ]
  },
  {
    "code": "T04.9",
    "name": "Multiple Zerquetschungen",
    "synonyms": [
      "Multiple Zerquetschungen"
    ]
  },
  {
    "code": "T05.0",
    "name": "Traumatische Amputation beider Hände",
    "synonyms": [
      "Traumatische Amputation beider Hände"
    ]
  },
  {
    "code": "T05.1",
    "name": "Traumatische Amputation der Hand und der anderen oberen Extremität",
    "synonyms": [
      "Traumatische Amputation der Hand und der anderen oberen Extremität"
    ]
  },
  {
    "code": "T05.2",
    "name": "Traumatische Amputation beider Arme",
    "synonyms": [
      "Traumatische Amputation beider Arme",
      "Traumatische Amputation beider oberer Extremitäten"
    ]
  },
  {
    "code": "T05.3",
    "name": "Traumatische Amputation beider Füße",
    "synonyms": [
      "Traumatische Amputation beider Füße"
    ]
  },
  {
    "code": "T05.4",
    "name": "Traumatische Amputation des Fußes und der anderen unteren Extremität",
    "synonyms": [
      "Traumatische Amputation des Fußes und der anderen unteren Extremität",
      "Traumatische Amputation des Fußes und des anderen Unterschenkels"
    ]
  },
  {
    "code": "T05.5",
    "name": "Traumatische Amputation beider Beine",
    "synonyms": [
      "Traumatische Amputation beider Beine",
      "Traumatische Amputation beider Unterschenkel"
    ]
  },
  {
    "code": "T05.6",
    "name": "Traumatische Amputation der Arme und Beine, jede Kombination",
    "synonyms": [
      "Traumatische Amputation der Arme und Beine, jede Kombination"
    ]
  },
  {
    "code": "T05.8",
    "name": "Querschnittverletzung des Rumpfes",
    "synonyms": [
      "Durchtrennung des Rumpfes",
      "Querschnittverletzung des Rumpfes",
      "Querschnittverletzung in Höhe des Abdomens",
      "Querschnittverletzung in Höhe des Thorax"
    ]
  },
  {
    "code": "T05.9",
    "name": "Multiple traumatische Amputationen",
    "synonyms": [
      "Multiple traumatische Amputationen"
    ]
  },
  {
    "code": "T06.0",
    "name": "Verletzung von Gehirn und Rückenmark in Halshöhe",
    "synonyms": [
      "Verletzung von Gehirn und Rückenmark in Halshöhe"
    ]
  },
  {
    "code": "T06.2",
    "name": "Multiple Nervenverletzungen",
    "synonyms": [
      "Multiple Nervenverletzungen",
      "Nervenverletzung mit Beteiligung mehrerer Körperregionen"
    ]
  },
  {
    "code": "T06.3",
    "name": "Verletzung eines Blutgefäßes multipler Regionen",
    "synonyms": [
      "Multiple Blutgefäßverletzungen",
      "Multiple Blutgefäßverletzungen des Arms",
      "Verletzung eines Blutgefäßes multipler Regionen"
    ]
  },
  {
    "code": "T06.4",
    "name": "Multiple Verletzungen von Muskeln und Sehnen",
    "synonyms": [
      "Multiple Verletzungen von Muskeln",
      "Multiple Verletzungen von Muskeln und Sehnen"
    ]
  },
  {
    "code": "T06.5",
    "name": "Traumatische Eviszeration a.n.k.",
    "synonyms": [
      "Multiple innere Rumpfverletzungen",
      "Multiple innere Verletzungen",
      "Traumatische Eviszeration a.n.k."
    ]
  },
  {
    "code": "T07",
    "name": "Schwere kombinierte Verletzung",
    "synonyms": [
      "Mehrfachverletzung",
      "Multiple Verletzungen",
      "Polytrauma",
      "Schwere kombinierte Verletzung",
      "Verletzung an multiplen Lokalisationen",
      "Verletzung mehrerer Körperregionen",
      "Vielfachtrauma"
    ]
  },
  {
    "code": "T08.0",
    "name": "Wirbelsäulenfraktur",
    "synonyms": [
      "Deckenplatteneinbruch",
      "Deckplattenimpressionsfraktur",
      "Wirbelbogenfraktur",
      "Wirbeleinbruch",
      "Wirbelfraktur",
      "Wirbelkörperbruch",
      "Wirbelkörperfraktur",
      "Wirbelkörperkompressionsfraktur",
      "Wirbelsäulenfraktur"
    ]
  },
  {
    "code": "T09.00",
    "name": "Oberflächliche Verletzung des Rumpfes a.n.k.",
    "synonyms": [
      "Oberflächliche Verletzung des Rumpfes a.n.k."
    ]
  },
  {
    "code": "T09.05",
    "name": "Rumpfkontusion",
    "synonyms": [
      "Rumpfkontusion",
      "Rumpfprellung",
      "Rückenprellung",
      "WS-Prellung",
      "Wirbelsäulenprellung",
      "Wirbelsäulenprellung des Rumpfes"
    ]
  },
  {
    "code": "T09.1",
    "name": "Große Weichteilverletzung des Rumpfes",
    "synonyms": [
      "Große Weichteilverletzung des Rumpfes",
      "Offene Wunde des Rumpfes a.n.k."
    ]
  },
  {
    "code": "T09.2",
    "name": "Rückendislokation",
    "synonyms": [
      "Dislokation der Wirbelsäule",
      "Dislokation des Processus articularis",
      "Distorsion der Vertebrae",
      "Rückendislokation",
      "Rückendistorsion",
      "Traumatische Bandscheibenruptur",
      "Wirbelgelenkdislokation",
      "Wirbelkörperdislokation",
      "Wirbelsäulendistorsion"
    ]
  },
  {
    "code": "T09.3",
    "name": "Rückenmarkverletzung",
    "synonyms": [
      "Commotio spinalis",
      "Contusio spinalis",
      "Rückenmarkerschütterung",
      "Rückenmarklazeration",
      "Rückenmarkruptur",
      "Rückenmarkschock",
      "Rückenmarkverletzung",
      "Traumatische Querschnittlähmung in der akuten Phase",
      "Traumatische Rückenmarkschädigung",
      "Traumatisches Rückenmarködem"
    ]
  },
  {
    "code": "T09.4",
    "name": "Nervenverletzung am Rumpf",
    "synonyms": [
      "Nervenverletzung am Rumpf",
      "Spinale Nervenverletzung",
      "Verletzung des Plexus spinalis",
      "Verletzung einer Nervenwurzel des Rückenmarks a.n.k.",
      "Verletzung einer spinalen Nervenwurzel",
      "Verletzung eines Nervengeflechts des Rückenmarks"
    ]
  },
  {
    "code": "T09.5",
    "name": "Verletzung eines Muskels am Rumpf",
    "synonyms": [
      "Verletzung eines Muskels am Rumpf"
    ]
  },
  {
    "code": "T09.6",
    "name": "Traumatische Amputation des Rumpfes a.n.k.",
    "synonyms": [
      "Traumatische Amputation des Rumpfes a.n.k."
    ]
  },
  {
    "code": "T09.9",
    "name": "Rumpfverletzung",
    "synonyms": [
      "Rumpfverletzung",
      "Verletzung der Zwischenwirbelscheibe"
    ]
  },
  {
    "code": "T10.0",
    "name": "Fraktur der oberen Extremität",
    "synonyms": [
      "Armfraktur",
      "Fraktur der oberen Extremität",
      "Geschlossen gebrochener Arm",
      "Geschlossene Armfraktur"
    ]
  },
  {
    "code": "T10.1",
    "name": "Offen gebrochener Arm",
    "synonyms": [
      "Offen gebrochener Arm",
      "Offene Armfraktur"
    ]
  },
  {
    "code": "T11.00",
    "name": "Oberflächliche Verletzung der oberen Extremität a.n.k.",
    "synonyms": [
      "Oberflächliche Verletzung der oberen Extremität a.n.k."
    ]
  },
  {
    "code": "T11.05",
    "name": "Prellung der oberen Extremität",
    "synonyms": [
      "Armprellung",
      "Kontusion der oberen Extremität",
      "Prellung der oberen Extremität"
    ]
  },
  {
    "code": "T11.1",
    "name": "Große Weichteilverletzung des Arms",
    "synonyms": [
      "Große Weichteilverletzung des Arms",
      "Offene Wunde der oberen Extremität a.n.k.",
      "Offene Wunde der oberen Gliedmaßen a.n.k."
    ]
  },
  {
    "code": "T11.2",
    "name": "Armdistorsion",
    "synonyms": [
      "Armdistorsion",
      "Dislokation der oberen Extremität",
      "Distorsion der oberen Extremität",
      "Unterarmdislokation"
    ]
  },
  {
    "code": "T11.3",
    "name": "Nervenverletzung am Arm",
    "synonyms": [
      "Nervenverletzung am Arm",
      "Nervenverletzung der oberen Extremität",
      "Nervenverletzung der oberen Gliedmaßen",
      "Traumatische transitorische Armparalyse a.n.k."
    ]
  },
  {
    "code": "T11.4",
    "name": "Verletzung eines Blutgefäßes am Arm",
    "synonyms": [
      "Blutgefäßverletzung der oberen Extremität",
      "Verletzung eines Blutgefäßes am Arm"
    ]
  },
  {
    "code": "T11.5",
    "name": "Verletzung eines Muskels am Arm",
    "synonyms": [
      "Verletzung eines Muskels am Arm",
      "Verletzung eines Muskels der oberen Extremität"
    ]
  },
  {
    "code": "T11.6",
    "name": "Traumatische Armamputation",
    "synonyms": [
      "Traumatische Amputation der oberen Extremität",
      "Traumatische Armamputation"
    ]
  },
  {
    "code": "T11.8",
    "name": "Große Weichteilverletzung des Arms mit Sehnenbeteiligung",
    "synonyms": [
      "Große Weichteilverletzung des Arms mit Sehnenbeteiligung"
    ]
  },
  {
    "code": "T11.9",
    "name": "Verletzung der oberen Extremität",
    "synonyms": [
      "Armverletzung",
      "Verletzung der oberen Extremität"
    ]
  },
  {
    "code": "T12.0",
    "name": "Fraktur der unteren Extremität",
    "synonyms": [
      "Fraktur der unteren Extremität",
      "Geschlossen gebrochenes Bein",
      "Geschlossene Beinfraktur"
    ]
  },
  {
    "code": "T12.1",
    "name": "Offen gebrochenes Bein",
    "synonyms": [
      "Offen gebrochenes Bein",
      "Offene Beinfraktur"
    ]
  },
  {
    "code": "T13.05",
    "name": "Prellung der unteren Extremität",
    "synonyms": [
      "Beinprellung",
      "Kontusion der unteren Extremität",
      "Prellung der unteren Extremität"
    ]
  },
  {
    "code": "T13.1",
    "name": "Große Weichteilverletzung des Beins",
    "synonyms": [
      "Große Weichteilverletzung des Beins",
      "Offene Wunde der unteren Extremität a.n.k.",
      "Offene Wunde der unteren Gliedmaßen a.n.k."
    ]
  },
  {
    "code": "T13.2",
    "name": "Distorsion der unteren Extremität",
    "synonyms": [
      "Dislokation der unteren Extremität",
      "Distorsion der unteren Extremität"
    ]
  },
  {
    "code": "T13.3",
    "name": "Nervenverletzung am Bein",
    "synonyms": [
      "Nervenverletzung am Bein",
      "Nervenverletzung der unteren Extremität",
      "Nervenverletzung der unteren Gliedmaßen",
      "Traumatische transitorische Beinparalyse a.n.k."
    ]
  },
  {
    "code": "T13.4",
    "name": "Verletzung eines Blutgefäßes der unteren Extremität",
    "synonyms": [
      "Verletzung eines Blutgefäßes der unteren Extremität"
    ]
  },
  {
    "code": "T13.5",
    "name": "Verletzung eines Muskels am Bein",
    "synonyms": [
      "Muskelverletzung der unteren Extremität",
      "Verletzung eines Muskels am Bein"
    ]
  },
  {
    "code": "T13.6",
    "name": "Traumatische Beinamputation",
    "synonyms": [
      "Traumatische Amputation der unteren Extremität, ausgenommen Zehen",
      "Traumatische Beinamputation"
    ]
  },
  {
    "code": "T13.8",
    "name": "Große Weichteilverletzung mit Sehnenbeteiligung des Beins",
    "synonyms": [
      "Große Weichteilverletzung mit Sehnenbeteiligung des Beins",
      "Haartourniquet beim Neugeborenen",
      "Haartourniquet beim Säugling"
    ]
  },
  {
    "code": "T13.9",
    "name": "Beinverletzung",
    "synonyms": [
      "Beinverletzung",
      "Verletzung der unteren Extremität"
    ]
  },
  {
    "code": "T14.00",
    "name": "Hautwunde",
    "synonyms": [
      "Geschlossene Verletzung",
      "Hautwunde",
      "Oberflächliche Extremitätenverletzung",
      "Oberflächliche Hautverletzung a.n.k.",
      "Oberflächliche Verletzung",
      "Oberflächliche subkutane Verletzung a.n.k.",
      "Subkutane Verletzung a.n.k.",
      "Wundlaufen der Haut",
      "Äußere Verletzung"
    ]
  },
  {
    "code": "T14.01",
    "name": "Exkoriation",
    "synonyms": [
      "Abschürfung",
      "Exkoriation",
      "Hautabschürfung",
      "Schürfwunde",
      "Traumatische Exkoriation"
    ]
  },
  {
    "code": "T14.03",
    "name": "Flohbiss",
    "synonyms": [
      "Flohbiss",
      "Flohstich",
      "Insektenbiss",
      "Insektenstich",
      "Mückenstich",
      "Spinnenbiss",
      "Ungiftiger Spinnenbiss",
      "Zecken am Körper",
      "Zeckenbiss",
      "Zeckenstich - s.a. Zeckenbiss"
    ]
  },
  {
    "code": "T14.04",
    "name": "Splitterinkorporation",
    "synonyms": [
      "Fremdkörper in Haut und Unterhaut",
      "Hautfremdkörper",
      "Oberflächlicher Fremdkörper ohne offene Wunde",
      "Splitterinkorporation"
    ]
  },
  {
    "code": "T14.05",
    "name": "Hämatom der Haut",
    "synonyms": [
      "Blutbeule",
      "Bluterguss",
      "Contusio",
      "Hautprellung a.n.k.",
      "Hämatom",
      "Hämatom der Haut",
      "Hämatom ohne Hautverletzung",
      "Knochenkontusion",
      "Knochenprellung a.n.k.",
      "Kontusion - s.a. Contusio oder s.a. Prellung",
      "Prellung",
      "Prellung ohne Hautverletzung",
      "Quetschung",
      "Quetschwunde",
      "Subkutane Prellung a.n.k.",
      "Subperiostale Prellung a.n.k.",
      "Subunguales Hämatom",
      "Traumatisches Hämatom"
    ]
  },
  {
    "code": "T14.08",
    "name": "Serom",
    "synonyms": [
      "Katzenkratzer",
      "Kratzspuren",
      "Kratzwunde",
      "Serom",
      "Surfer-Knoten",
      "Surfer-Schwielen"
    ]
  },
  {
    "code": "T14.1",
    "name": "Nagelabriss",
    "synonyms": [
      "Ausschusswunde",
      "Biss durch Menschen",
      "Bissverletzung",
      "Bisswunde",
      "Gewehrschusswunde",
      "Hundebiss",
      "Hundebissverletzung",
      "Kleine Platzwunde",
      "Kleine offene chirurgisch versorgte Wunde",
      "Lazeration",
      "Messerschnittwunde",
      "Messerstichverletzung",
      "Nagelabriss",
      "Nagelluxation",
      "Offene Hautwunde a.n.k.",
      "Offene Risswunde",
      "Offene Verletzung",
      "Offene Wunde",
      "Offene Wunde durch Tierbiss",
      "Offene Wunde durch penetrierenden Fremdkörper",
      "Perforierende Verletzung",
      "Platzwunde",
      "Rissquetschwunde",
      "Risswunde",
      "Schnittverletzung",
      "Schnittwunde",
      "Schussverletzung",
      "Schusswunde",
      "Stichverletzung",
      "Stichwunde",
      "Stichwunde mit penetrierendem Fremdkörper",
      "Tierbiss",
      "Tierbissverletzung",
      "Äußere Schnittwunde"
    ]
  },
  {
    "code": "T14.20",
    "name": "Dislozierte Fraktur",
    "synonyms": [
      "Abduktionsfraktur",
      "Absprengungsfraktur",
      "Adduktionsfraktur",
      "Bone bruise",
      "Dislozierte Fraktur",
      "Extremitätenfraktur",
      "Fraktur",
      "Fraktur mit Dislokation",
      "Gelenkfraktur",
      "Geschlossene Fraktur",
      "Grünholzfraktur",
      "Knochenbruch",
      "Knochenfraktur",
      "Kompressionsfraktur",
      "Splitterfraktur",
      "Trümmerfraktur",
      "Verschobene geschlossene Fraktur"
    ]
  },
  {
    "code": "T14.21",
    "name": "Verschobene offene Fraktur",
    "synonyms": [
      "Offene Fraktur",
      "Verschobene offene Fraktur"
    ]
  },
  {
    "code": "T14.3",
    "name": "Bänderdehnung",
    "synonyms": [
      "Bandruptur",
      "Bänderdehnung",
      "Bänderriss",
      "Bänderzerrung",
      "Dislokation",
      "Dislokation einer Extremität",
      "Distorsion - s.a. Verstauchung",
      "Distorsion eines Bandes",
      "Distorsion eines Gelenks",
      "Faszienruptur",
      "Frische Gelenkknorpelruptur",
      "Frischer Gelenkschaden",
      "Gelenkabriss",
      "Gelenkdislokation",
      "Gelenkkapselabriss",
      "Gelenkkapselverstauchung",
      "Gelenkkapselzerreißung",
      "Gelenkkapselzerrung",
      "Gelenkverstauchung",
      "Gelenkzerreißung",
      "Gelenkzerrung",
      "Knorpelabriss",
      "Knöcherner Bandausriss",
      "Ligamentabriss",
      "Ligamentlazeration",
      "Ligamentverstauchung",
      "Ligamentzerreißung",
      "Ligamentzerrung",
      "Luxatio",
      "Luxation",
      "Ruptur eines Ligaments",
      "Subluxation",
      "Teilweise Durchtrennung eines Ligaments",
      "Traumatische Gelenkkapselruptur",
      "Traumatische Ligamentruptur",
      "Traumatische Subluxation einer Gelenkkapsel",
      "Traumatische Subluxation eines Gelenks",
      "Traumatische Subluxation eines Ligaments",
      "Traumatischer Gelenkkapselriss",
      "Traumatischer Hämarthros einer Gelenkkapsel",
      "Traumatischer Hämarthros eines Gelenks",
      "Traumatischer Hämarthros eines Ligaments",
      "Traumatischer Ligamentriss",
      "Verrenkung",
      "Verstauchung",
      "Vollständige Durchtrennung eines Ligaments",
      "Zerrung"
    ]
  },
  {
    "code": "T14.4",
    "name": "Nervendurchtrennung",
    "synonyms": [
      "Nervendurchtrennung",
      "Nervenverletzung",
      "Periphere Nervenverletzung",
      "Traumatische Hämatomyelie",
      "Traumatische Nervendurchtrennung",
      "Traumatische Nervenverletzung",
      "Traumatische flüchtige Monoplegie a.n.k.",
      "Traumatische flüchtige Paralyse a.n.k.",
      "Traumatische transitorische Monoplegie a.n.k.",
      "Traumatische transitorische Paralyse a.n.k.",
      "Traumatische vorübergehende Lähmung"
    ]
  },
  {
    "code": "T14.5",
    "name": "Blutgefäßverletzung a.n.k.",
    "synonyms": [
      "Arterielles Hämatom durch Verletzung",
      "Arterienverletzung",
      "Blutgefäßabriss",
      "Blutgefäßverletzung a.n.k.",
      "Blutgefäßverletzung einer Extremität",
      "Gefäßläsion",
      "Gefäßverletzung",
      "Rissverletzung eines Blutgefäßes",
      "Schnittverletzung eines Blutgefäßes",
      "Traumatische Arterienruptur",
      "Traumatische Blutgefäßruptur",
      "Traumatische arteriovenöse Fistel",
      "Traumatische arteriovenöse Fistel eines Blutgefäßes",
      "Traumatisches arteriovenöses Aneurysma",
      "Traumatisches arteriovenöses Aneurysma eines Blutgefäßes",
      "Traumatisches arteriovenöses Hämatom eines Blutgefäßes",
      "Venenverletzung"
    ]
  },
  {
    "code": "T14.6",
    "name": "Strecksehnenriss",
    "synonyms": [
      "Beugesehnenverletzung",
      "Muskelabriss",
      "Muskeldistorsion",
      "Muskelfaserriss",
      "Muskelprellung",
      "Muskelriss",
      "Muskelruptur",
      "Muskelverletzung",
      "Muskelverstauchung",
      "Muskelzerrung",
      "Oberflächliche Muskelverletzung",
      "Schnittverletzung einer Sehne",
      "Schnittverletzung eines Muskels",
      "Sehnenabriss",
      "Sehnenlazeration",
      "Sehnenriss",
      "Sehnenruptur",
      "Sehnenverletzung",
      "Sehnenverstauchung",
      "Sehnenzerrung",
      "Strecksehnenriss",
      "Teilweise Muskeldurchtrennung",
      "Traumatische Muskelruptur",
      "Traumatische Sehnendurchtrennung",
      "Traumatische Sehnenruptur",
      "Vollständige Muskeldurchtrennung"
    ]
  },
  {
    "code": "T14.7",
    "name": "Abriss",
    "synonyms": [
      "Abriss",
      "Quetschung im Sinne von Crush",
      "Schwere Quetschung",
      "Schwere Zerquetschung bei Verschüttung",
      "Traumatische Amputation",
      "Traumatische Amputation einer Extremität",
      "Traumatischer Abriss",
      "Zerquetschung",
      "Zerquetschung innerer Organe"
    ]
  },
  {
    "code": "T14.8",
    "name": "Innere Verletzung",
    "synonyms": [
      "Innere Verletzung"
    ]
  },
  {
    "code": "T14.9",
    "name": "Weichteiltrauma",
    "synonyms": [
      "Extremitätenverletzung",
      "Gelenkverletzung a.n.k.",
      "Hautverletzung",
      "Isolierte Hautverletzung",
      "Knochenverletzung",
      "Nichtchirurgische instrumentelle Verletzung",
      "Schaden durch Verletzung",
      "Trauma",
      "Traumatische Myalgie a.n.k.",
      "Traumatische Schädigung a.n.k.",
      "Verletzung",
      "Weichteiltrauma",
      "Weichteilverletzung",
      "Wunde"
    ]
  },
  {
    "code": "T15.0",
    "name": "Tiefer Hornhautfremdkörper ohne Perforation",
    "synonyms": [
      "Hornhautfremdkörper",
      "Hornhautübersplitterung",
      "Inkrustation der Kornea durch Fremdkörper",
      "Kornealfremdkörper",
      "Korneaprellung durch Fremdkörper",
      "Oberflächliche Korneaverletzung mit Fremdkörper",
      "Oberflächlicher Fremdkörper der Hornhaut mit Rosthof",
      "Oberflächlicher Fremdkörper der Hornhaut ohne Rosthof",
      "Tiefer Hornhautfremdkörper ohne Perforation"
    ]
  },
  {
    "code": "T15.1",
    "name": "Tiefer Bindehautfremdkörper",
    "synonyms": [
      "Augenwinkelfremdkörper",
      "Bindehautfremdkörper",
      "Bindehautsackfremdkörper",
      "Bindehautübersplitterung mit Fremdkörpern",
      "Konjunktivafremdkörper",
      "Konjunktivalsackfremdkörper",
      "Konjunktivaprellung mit Fremdkörper im Konjunktivalsack",
      "Konjunktivaübersplitterung mit Fremdkörpern",
      "Konjunktivitis durch Fremdkörpereinwirkung",
      "Oberflächliche Konjunktivaverletzung mit Fremdkörper",
      "Oberflächlicher Bindehautfremdkörper",
      "Oberflächlicher Konjunktivafremdkörper",
      "Sklerafremdkörper",
      "Subtarsaler Bindehautfremdkörper",
      "Subtarsaler Konjunktivafremdkörper",
      "Tiefer Bindehautfremdkörper",
      "Tiefer Konjunktivafremdkörper"
    ]
  },
  {
    "code": "T15.8",
    "name": "Tränenwegfremdkörper",
    "synonyms": [
      "Augapfelfremdkörper",
      "Fremdkörper im Punctum lacrimale",
      "Fremdkörper im Tränenapparat",
      "Fremdkörper im Tränengang",
      "Fremdkörper in der Tränendrüse",
      "Tränenwegfremdkörper"
    ]
  },
  {
    "code": "T15.9",
    "name": "Augenfremdkörper",
    "synonyms": [
      "Augenfremdkörper",
      "Fremdkörper im äußeren Auge a.n.k."
    ]
  },
  {
    "code": "T16",
    "name": "Gehörgangsfremdkörper",
    "synonyms": [
      "Fremdkörper in der Ohrmuschel",
      "Gehörgangsfremdkörper",
      "Ohrfremdkörper"
    ]
  },
  {
    "code": "T17.0",
    "name": "Nasennebenhöhlenfremdkörper",
    "synonyms": [
      "Asphyxie durch Fremdkörper in der Nasennebenhöhle",
      "Asphyxie durch Schleim in der Nasennebenhöhle",
      "Fremdkörper im Antrum Highmori",
      "Fremdkörper in der Kieferhöhle",
      "Fremdkörper in der Stirnhöhle",
      "Nasennebenhöhlenfremdkörper",
      "Schleimaspiration in die Nasennebenhöhle"
    ]
  },
  {
    "code": "T17.1",
    "name": "Nasenlochfremdkörper",
    "synonyms": [
      "Asphyxie durch Nasenfremdkörper",
      "Asphyxie durch Nasenlochfremdkörper",
      "Asphyxie durch Schleim in der Nase",
      "Asphyxie durch Schleim in einem Nasenloch",
      "Nasenfremdkörper",
      "Nasenlochfremdkörper",
      "Schleimaspiration in die Nase",
      "Schleimaspiration in ein Nasenloch"
    ]
  },
  {
    "code": "T17.2",
    "name": "Rachenfremdkörper",
    "synonyms": [
      "Asphyxie durch Fremdkörper im Nasenrachenraum",
      "Asphyxie durch Fremdkörper im Rachen",
      "Asphyxie durch Fremdkörper im Schlund",
      "Asphyxie durch Schleim im Nasopharynx",
      "Asphyxie durch Schleim im Rachen",
      "Asphyxie durch Schleim im Schlund",
      "Fremdkörper im Hypopharynx",
      "Fremdkörper im Nasopharynx",
      "Fremdkörper im Pharynx",
      "Fremdkörper im Schlund",
      "Fremdkörper im Sinus piriformis",
      "Rachenfremdkörper",
      "Schleimaspiration in den Rachen",
      "Schleimaspiration in den Schlund",
      "Tonsillärer Fremdkörper"
    ]
  },
  {
    "code": "T17.3",
    "name": "Kehlkopffremdkörper",
    "synonyms": [
      "Asphyxie durch Fremdkörper im Kehlkopf",
      "Asphyxie durch Fremdkörper im Larynx",
      "Asphyxie durch Schleim im Kehlkopf",
      "Asphyxie durch Schleim im Larynx",
      "Fremdkörper im Larynx",
      "Kehlkopffremdkörper"
    ]
  },
  {
    "code": "T17.4",
    "name": "Luftröhrenfremdkörper",
    "synonyms": [
      "Asphyxie durch Fremdkörper in der Luftröhre",
      "Asphyxie durch Fremdkörper in der Trachea",
      "Asphyxie durch Schleim in der Trachea",
      "Luftröhrenfremdkörper",
      "Schleimaspiration in die Luftröhre",
      "Schleimaspiration in die Trachea",
      "Schleimpfropf in der Luftröhre",
      "Schleimpfropf in der Trachea",
      "Tracheafremdkörper"
    ]
  },
  {
    "code": "T17.5",
    "name": "Bronchialfremdkörper",
    "synonyms": [
      "Asphyxie durch Fremdkörper im Bronchus",
      "Asphyxie durch Schleim im Bronchus",
      "Bronchialfremdkörper",
      "Fremdkörper im Hauptbronchus",
      "Schleimaspiration in einen Bronchus",
      "Schleimpfropf in den Bronchien"
    ]
  },
  {
    "code": "T17.8",
    "name": "Fremdkörper in Bronchiolen",
    "synonyms": [
      "Asphyxie durch Fremdkörper in den Bronchiolen",
      "Asphyxie durch Fremdkörper in der Lunge",
      "Asphyxie durch Schleim in den Bronchiolen",
      "Asphyxie durch Schleim in der Lunge",
      "Fremdkörper in Bronchiolen",
      "Fremdkörper in der Lunge",
      "Schleimaspiration in die Bronchiolen",
      "Schleimaspiration in die Lunge"
    ]
  },
  {
    "code": "T17.9",
    "name": "Nahrungsmittelaspiration",
    "synonyms": [
      "Asphyxie durch Erbrechen",
      "Asphyxie durch Fremdkörper",
      "Asphyxie durch Fremdkörper in den Atemwegen",
      "Asphyxie durch Nahrungsmittel",
      "Asphyxie durch Schleim",
      "Asphyxie durch Schleim in den Atemwegen",
      "Aspiration von Erbrochenem",
      "Aspiration von Mageninhalt",
      "Aspiration von Magensekret",
      "Atemwegsfremdkörper",
      "Erstickung durch Erbrechen a.n.k.",
      "Erstickung durch Fremdkörper",
      "Erstickung durch Inhalation von Öl",
      "Erstickung durch Nahrungsmittel a.n.k.",
      "Erstickung durch Schleim a.n.k.",
      "Erstickung durch regurgitierte Nahrung",
      "Flüssigkeitsaspiration",
      "Flüssigkeitsinhalation",
      "Fremdkörper im Respirationstrakt",
      "Fremdkörperaspiration",
      "Fremdkörperinhalation",
      "Fremdkörperinspiration",
      "Inhalation von Erbrochenem",
      "Inhalation von Mageninhalt",
      "Inhalation von Nahrungsmitteln",
      "Inhalation von Schleim",
      "Inspiration von Nahrung",
      "Nahrungsmittelaspiration",
      "Schleimaspiration",
      "Schleimaspiration in die Atemwege",
      "Schleiminspiration",
      "Speiseaspiration",
      "Suffokation durch Nahrungsmittel",
      "Suffokation durch Schleim"
    ]
  },
  {
    "code": "T18.0",
    "name": "Mundfremdkörper",
    "synonyms": [
      "Fremdkörper im Alveolarfortsatz",
      "Fremdkörper im Gaumen",
      "Fremdkörper im Zahnfleisch",
      "Fremdkörper in der Mundhöhle",
      "Fremdkörper in der Zunge",
      "Mundfremdkörper"
    ]
  },
  {
    "code": "T18.1",
    "name": "Ösophagusfremdkörper",
    "synonyms": [
      "Fremdkörper in der Speiseröhre",
      "Ösophagusfremdkörper"
    ]
  },
  {
    "code": "T18.2",
    "name": "Magenfremdkörper",
    "synonyms": [
      "Haarknäuel im Magen",
      "Magenbezoar",
      "Magenfremdkörper",
      "Magenphytobezoar",
      "Magentrichobezoar",
      "Magentrichophytobezoar"
    ]
  },
  {
    "code": "T18.3",
    "name": "Dünndarmfremdkörper",
    "synonyms": [
      "Darmbezoar",
      "Darmfremdkörper",
      "Darmtrichobezoar",
      "Darmtrichophytobezoar",
      "Dünndarmfremdkörper",
      "Fremdkörper im Duodenum",
      "Fremdkörper im Ileum",
      "Phytobezoar des Darmes"
    ]
  },
  {
    "code": "T18.4",
    "name": "Dickdarmfremdkörper",
    "synonyms": [
      "Dickdarmfremdkörper",
      "Fremdkörper im Appendix",
      "Fremdkörper im Kolon",
      "Fremdkörper im Zäkum"
    ]
  },
  {
    "code": "T18.5",
    "name": "Anusfremdkörper",
    "synonyms": [
      "Anusfremdkörper",
      "Fremdkörper im Rektosigmoid",
      "Mastdarmfremdkörper",
      "Rektumfremdkörper"
    ]
  },
  {
    "code": "T18.9",
    "name": "Bezoar",
    "synonyms": [
      "Bezoar",
      "Fremdkörper im Gastrointestinaltrakt",
      "Fremdkörper im Magen-Darm-Trakt",
      "Fremdkörper im Verdauungssystem",
      "Fremdkörper im Verdauungstrakt",
      "Fremdkörper in den Verdauungsorganen a.n.k.",
      "Fremdkörperingestion beim Kind",
      "Phytobezoar",
      "Trichobezoar",
      "Trichophytobezoar",
      "Verschlucken eines Fremdkörpers",
      "Verschluckter Fremdkörper a.n.k."
    ]
  },
  {
    "code": "T19.0",
    "name": "Harnröhrenfremdkörper",
    "synonyms": [
      "Harnröhrenfremdkörper",
      "Urethrafremdkörper"
    ]
  },
  {
    "code": "T19.1",
    "name": "Harnblasenfremdkörper",
    "synonyms": [
      "Harnblasenfremdkörper"
    ]
  },
  {
    "code": "T19.2",
    "name": "Vulvafremdkörper",
    "synonyms": [
      "Dislozierter Tampon",
      "Vaginalfremdkörper",
      "Vulvafremdkörper"
    ]
  },
  {
    "code": "T19.3",
    "name": "Uterusfremdkörper",
    "synonyms": [
      "Fremdkörper in der Cervix uteri",
      "Uterusfremdkörper",
      "Zervixfremdkörper"
    ]
  },
  {
    "code": "T19.8",
    "name": "Penisfremdkörper",
    "synonyms": [
      "Fremdkörper im Ureter",
      "Penisfremdkörper",
      "Penisstriktur durch Fremdkörper"
    ]
  },
  {
    "code": "T19.9",
    "name": "Fremdkörper im Urogenitaltrakt",
    "synonyms": [
      "Fremdkörper im Urogenitaltrakt"
    ]
  },
  {
    "code": "T20.0",
    "name": "Kopfverbrennung",
    "synonyms": [
      "Augenverbrennung mit Verbrennung anderer Gesichtsteile",
      "Augenverbrennung mit Verbrennung von Halsteilen",
      "Augenverbrennung mit Verbrennung von Kopfteilen",
      "Gehörgangsverbrennung",
      "Gesichtsverbrennung",
      "Halsverbrennung",
      "Kopfverbrennung",
      "Lippenverbrennung",
      "Nasenscheidewandverbrennung",
      "Nasenverbrennung",
      "Ohrmuschelverbrennung",
      "Ohrverbrennung",
      "Schläfenverbrennung",
      "Trommelfellverbrennung",
      "Verbrennung der behaarten Kopfhaut",
      "Verbrennung des Nasenseptums",
      "Verbrennung des äußeren Ohres"
    ]
  },
  {
    "code": "T20.1",
    "name": "Kopfverbrennung 1. Grades",
    "synonyms": [
      "Halsverbrennung 1. Grades",
      "Kopfverbrennung 1. Grades"
    ]
  },
  {
    "code": "T20.20",
    "name": "Kopfverbrennung 2. Grades",
    "synonyms": [
      "Halsverbrennung 2. Grades",
      "Halsverbrennung Grad 2a",
      "Kopfverbrennung 2. Grades",
      "Kopfverbrennung Grad 2a"
    ]
  },
  {
    "code": "T20.21",
    "name": "Kopfverbrennung Grad 2b",
    "synonyms": [
      "Halsverbrennung Grad 2b",
      "Kopfverbrennung Grad 2b"
    ]
  },
  {
    "code": "T20.3",
    "name": "Kopfverbrennung 3. Grades",
    "synonyms": [
      "Halsverbrennung 3. Grades",
      "Kopfverbrennung 3. Grades"
    ]
  },
  {
    "code": "T20.4",
    "name": "Kopfverätzung",
    "synonyms": [
      "Augenverätzung mit Verätzung anderer Gesichtsteile",
      "Augenverätzung mit Verätzung von Halsteilen",
      "Augenverätzung mit Verätzung von Kopfteilen",
      "Gehörgangsverätzung",
      "Gesichtsverätzung",
      "Halsverätzung",
      "Kopfverätzung",
      "Lippenverätzung",
      "Nasenscheidewandverätzung",
      "Nasenverätzung",
      "Ohrmuschelverätzung",
      "Ohrverätzung",
      "Schläfenverätzung",
      "Trommelfellverätzung",
      "Verätzung der behaarten Kopfhaut",
      "Verätzung des Nasenseptums",
      "Verätzung des äußeren Ohres"
    ]
  },
  {
    "code": "T20.5",
    "name": "Kopfverätzung 1. Grades",
    "synonyms": [
      "Halsverätzung 1. Grades",
      "Kopfverätzung 1. Grades"
    ]
  },
  {
    "code": "T20.60",
    "name": "Kopfverätzung 2. Grades",
    "synonyms": [
      "Halsverätzung 2. Grades",
      "Halsverätzung Grad 2a",
      "Kopfverätzung 2. Grades",
      "Kopfverätzung Grad 2a"
    ]
  },
  {
    "code": "T20.61",
    "name": "Kopfverätzung Grad 2b",
    "synonyms": [
      "Halsverätzung Grad 2b",
      "Kopfverätzung Grad 2b"
    ]
  },
  {
    "code": "T20.7",
    "name": "Kopfverätzung 3. Grades",
    "synonyms": [
      "Halsverätzung 3. Grades",
      "Kopfverätzung 3. Grades"
    ]
  },
  {
    "code": "T21.00",
    "name": "Rumpfverbrennung",
    "synonyms": [
      "Rumpfverbrennung"
    ]
  },
  {
    "code": "T21.01",
    "name": "Mammaverbrennung",
    "synonyms": [
      "Brustdrüsenverbrennung",
      "Mammaverbrennung"
    ]
  },
  {
    "code": "T21.02",
    "name": "Brustwandverbrennung",
    "synonyms": [
      "Brustwandverbrennung",
      "Verbrennung der Rippengegend",
      "Verbrennung der Thoraxwand",
      "Verbrennung des äußeren Thorax"
    ]
  },
  {
    "code": "T21.03",
    "name": "Bauchwandverbrennung",
    "synonyms": [
      "Bauchdeckenverbrennung",
      "Bauchwandverbrennung",
      "Flankenverbrennung",
      "Leistenverbrennung",
      "Verbrennung der Darmbeingegend",
      "Verbrennung des Epigastrium"
    ]
  },
  {
    "code": "T21.04",
    "name": "Anusverbrennung",
    "synonyms": [
      "Anusverbrennung",
      "Gesäßverbrennung",
      "Rückenverbrennung",
      "Verbrennung der Interskapularregion",
      "Verbrennung der Kreuzbeingegend",
      "Verbrennung der Lendengegend",
      "Verbrennung der Lumbosakralgegend"
    ]
  },
  {
    "code": "T21.05",
    "name": "Hodenverbrennung",
    "synonyms": [
      "Hodenverbrennung",
      "Klitorisverbrennung",
      "Nebenhodenverbrennung",
      "Penisverbrennung",
      "Perineumverbrennung",
      "Skrotumverbrennung",
      "Testisverbrennung",
      "Verbrennung der Labia majora pudendi",
      "Verbrennung der Labia minora pudendi",
      "Verbrennung der Pudendalregion",
      "Verbrennung der Schamgegend",
      "Verbrennung der Tunica vaginalis testis",
      "Verbrennung der großen Schamlippen",
      "Verbrennung der kleinen Schamlippen",
      "Verbrennung der äußeren Urogenitalorgane",
      "Verbrennung des Präputiums",
      "Vulvaverbrennung"
    ]
  },
  {
    "code": "T21.09",
    "name": "Beckenverbrennung",
    "synonyms": [
      "Beckenverbrennung"
    ]
  },
  {
    "code": "T21.10",
    "name": "Rumpfverbrennung 1. Grades",
    "synonyms": [
      "Rumpfverbrennung 1. Grades"
    ]
  },
  {
    "code": "T21.11",
    "name": "Mammaverbrennung 1. Grades",
    "synonyms": [
      "Brustdrüsenverbrennung 1. Grades",
      "Mammaverbrennung 1. Grades"
    ]
  },
  {
    "code": "T21.12",
    "name": "Verbrennung der Thoraxwand 1. Grades",
    "synonyms": [
      "Verbrennung der Thoraxwand 1. Grades"
    ]
  },
  {
    "code": "T21.13",
    "name": "Leistenverbrennung 1. Grades",
    "synonyms": [
      "Bauchdeckenverbrennung 1. Grades",
      "Flankenverbrennung 1. Grades",
      "Leistenverbrennung 1. Grades"
    ]
  },
  {
    "code": "T21.14",
    "name": "Anusverbrennung 1. Grades",
    "synonyms": [
      "Anusverbrennung 1. Grades",
      "Gesäßverbrennung 1. Grades",
      "Rückenverbrennung 1. Grades",
      "Verbrennung der Interskapularregion 1. Grades"
    ]
  },
  {
    "code": "T21.15",
    "name": "Labienverbrennung 1. Grades",
    "synonyms": [
      "Hodenverbrennung 1. Grades",
      "Labienverbrennung 1. Grades",
      "Penisverbrennung 1. Grades",
      "Perineumverbrennung 1. Grades",
      "Skrotumverbrennung 1. Grades",
      "Testisverbrennung 1. Grades",
      "Verbrennung 1. Grades der äußeren Genitale",
      "Verbrennung der Labia majora pudendi 1. Grades",
      "Verbrennung der Labia minora pudendi 1. Grades",
      "Vulvaverbrennung 1. Grades"
    ]
  },
  {
    "code": "T21.20",
    "name": "Rumpfverbrennung 2. Grades",
    "synonyms": [
      "Rumpfverbrennung 2. Grades",
      "Rumpfverbrennung Grad 2a"
    ]
  },
  {
    "code": "T21.21",
    "name": "Mammaverbrennung 2. Grades",
    "synonyms": [
      "Brustdrüsenverbrennung 2. Grades",
      "Brustdrüsenverbrennung Grad 2a",
      "Mammaverbrennung 2. Grades",
      "Mammaverbrennung Grad 2a"
    ]
  },
  {
    "code": "T21.22",
    "name": "Verbrennung der Thoraxwand 2. Grades",
    "synonyms": [
      "Verbrennung der Thoraxwand 2. Grades",
      "Verbrennung der Thoraxwand Grad 2a"
    ]
  },
  {
    "code": "T21.23",
    "name": "Bauchdeckenverbrennung 2. Grades",
    "synonyms": [
      "Bauchdeckenverbrennung 2. Grades",
      "Bauchdeckenverbrennung Grad 2a",
      "Flankenverbrennung 2. Grades",
      "Flankenverbrennung Grad 2a",
      "Leistenverbrennung 2. Grades",
      "Leistenverbrennung Grad 2a"
    ]
  },
  {
    "code": "T21.24",
    "name": "Anusverbrennung 2. Grades",
    "synonyms": [
      "Anusverbrennung 2. Grades",
      "Anusverbrennung Grad 2a",
      "Gesäßverbrennung 2. Grades",
      "Gesäßverbrennung Grad 2a",
      "Rückenverbrennung 2. Grades",
      "Rückenverbrennung Grad 2a",
      "Verbrennung der Interskapularregion 2. Grades",
      "Verbrennung der Interskapularregion Grad 2a"
    ]
  },
  {
    "code": "T21.25",
    "name": "Labienverbrennung 2. Grades",
    "synonyms": [
      "Hodenverbrennung 2. Grades",
      "Hodenverbrennung Grad 2a",
      "Labienverbrennung 2. Grades",
      "Labienverbrennung Grad 2a",
      "Penisverbrennung 2. Grades",
      "Penisverbrennung Grad 2a",
      "Perineumverbrennung 2. Grades",
      "Perineumverbrennung Grad 2a",
      "Skrotumverbrennung 2. Grades",
      "Skrotumverbrennung Grad 2a",
      "Testisverbrennung 2. Grades",
      "Testisverbrennung Grad 2a",
      "Verbrennung 2. Grades der äußeren Genitale",
      "Verbrennung der Labia majora pudendi 2. Grades",
      "Verbrennung der Labia majora pudendi Grad 2a",
      "Verbrennung der Labia minora pudendi 2. Grades",
      "Verbrennung der Labia minora pudendi Grad 2a",
      "Vulvaverbrennung 2. Grades",
      "Vulvaverbrennung Grad 2a"
    ]
  },
  {
    "code": "T21.30",
    "name": "Rumpfverbrennung 3. Grades",
    "synonyms": [
      "Rumpfverbrennung 3. Grades"
    ]
  },
  {
    "code": "T21.31",
    "name": "Mammaverbrennung 3. Grades",
    "synonyms": [
      "Brustdrüsenverbrennung 3. Grades",
      "Mammaverbrennung 3. Grades"
    ]
  },
  {
    "code": "T21.32",
    "name": "Verbrennung der Thoraxwand 3. Grades",
    "synonyms": [
      "Verbrennung der Thoraxwand 3. Grades"
    ]
  },
  {
    "code": "T21.33",
    "name": "Bauchdeckenverbrennung 3. Grades",
    "synonyms": [
      "Bauchdeckenverbrennung 3. Grades",
      "Flankenverbrennung 3. Grades",
      "Leistenverbrennung 3. Grades"
    ]
  },
  {
    "code": "T21.34",
    "name": "Anusverbrennung 3. Grades",
    "synonyms": [
      "Anusverbrennung 3. Grades",
      "Gesäßverbrennung 3. Grades",
      "Rückenverbrennung 3. Grades",
      "Verbrennung der Interskapularregion 3. Grades"
    ]
  },
  {
    "code": "T21.35",
    "name": "Labienverbrennung 3. Grades",
    "synonyms": [
      "Hodenverbrennung 3. Grades",
      "Labienverbrennung 3. Grades",
      "Penisverbrennung 3. Grades",
      "Perineumverbrennung 3. Grades",
      "Skrotumverbrennung 3. Grades",
      "Testisverbrennung 3. Grades",
      "Verbrennung 3. Grades der äußeren Genitale",
      "Verbrennung der Labia majora pudendi 3. Grades",
      "Verbrennung der Labia minora pudendi 3. Grades",
      "Vulvaverbrennung 3. Grades"
    ]
  },
  {
    "code": "T21.40",
    "name": "Rumpfverätzung",
    "synonyms": [
      "Rumpfverätzung"
    ]
  },
  {
    "code": "T21.41",
    "name": "Mammaverätzung",
    "synonyms": [
      "Brustdrüsenverätzung",
      "Mammaverätzung"
    ]
  },
  {
    "code": "T21.42",
    "name": "Verätzung der Thoraxwand",
    "synonyms": [
      "Verätzung der Thoraxwand",
      "Verätzung der äußeren Thoraxwand",
      "Verätzung des äußeren Thorax"
    ]
  },
  {
    "code": "T21.43",
    "name": "Bauchwandverätzung",
    "synonyms": [
      "Bauchdeckenverätzung",
      "Bauchwandverätzung",
      "Flankenverätzung",
      "Leistenverätzung"
    ]
  },
  {
    "code": "T21.44",
    "name": "Anusverätzung",
    "synonyms": [
      "Anusverätzung",
      "Gesäßverätzung",
      "Rückenverätzung",
      "Verätzung der Interskapularregion",
      "Verätzung der Lumbosakralgegend"
    ]
  },
  {
    "code": "T21.45",
    "name": "Verätzung der Labia majora pudendi",
    "synonyms": [
      "Hodenverätzung",
      "Penisverätzung",
      "Perineumverätzung",
      "Skrotumverätzung",
      "Testisverätzung",
      "Verätzung der Labia majora pudendi",
      "Verätzung der Labia minora pudendi",
      "Verätzung der äußeren Urogenitalorgane",
      "Vulvaverätzung"
    ]
  },
  {
    "code": "T21.49",
    "name": "Beckenverätzung",
    "synonyms": [
      "Beckenverätzung"
    ]
  },
  {
    "code": "T21.50",
    "name": "Rumpfverätzung 1. Grades",
    "synonyms": [
      "Rumpfverätzung 1. Grades"
    ]
  },
  {
    "code": "T21.51",
    "name": "Mammaverätzung 1. Grades",
    "synonyms": [
      "Brustdrüsenverätzung 1. Grades",
      "Mammaverätzung 1. Grades"
    ]
  },
  {
    "code": "T21.52",
    "name": "Verätzung der Thoraxwand 1. Grades",
    "synonyms": [
      "Verätzung der Thoraxwand 1. Grades"
    ]
  },
  {
    "code": "T21.53",
    "name": "Leistenverätzung 1. Grades",
    "synonyms": [
      "Bauchdeckenverätzung 1. Grades",
      "Flankenverätzung 1. Grades",
      "Leistenverätzung 1. Grades"
    ]
  },
  {
    "code": "T21.54",
    "name": "Anusverätzung 1. Grades",
    "synonyms": [
      "Anusverätzung 1. Grades",
      "Gesäßverätzung 1. Grades",
      "Rückenverätzung 1. Grades",
      "Verätzung der Interskapularregion 1. Grades"
    ]
  },
  {
    "code": "T21.55",
    "name": "Labienverätzung 1. Grades",
    "synonyms": [
      "Hodenverätzung 1. Grades",
      "Labienverätzung 1. Grades",
      "Penisverätzung 1. Grades",
      "Perineumverätzung 1. Grades",
      "Skrotumverätzung 1. Grades",
      "Testisverätzung 1. Grades",
      "Verätzung 1. Grades der äußeren Genitale",
      "Verätzung der Labia majora pudendi 1. Grades",
      "Verätzung der Labia minora pudendi 1. Grades",
      "Vulvaverätzung 1. Grades"
    ]
  },
  {
    "code": "T21.60",
    "name": "Rumpfverätzung 2. Grades",
    "synonyms": [
      "Rumpfverätzung 2. Grades",
      "Rumpfverätzung Grad 2a"
    ]
  },
  {
    "code": "T21.61",
    "name": "Mammaverätzung 2. Grades",
    "synonyms": [
      "Brustdrüsenverätzung 2. Grades",
      "Brustdrüsenverätzung Grad 2a",
      "Mammaverätzung 2. Grades",
      "Mammaverätzung Grad 2a"
    ]
  },
  {
    "code": "T21.62",
    "name": "Verätzung der Thoraxwand 2. Grades",
    "synonyms": [
      "Verätzung der Thoraxwand 2. Grades",
      "Verätzung der Thoraxwand Grad 2a"
    ]
  },
  {
    "code": "T21.63",
    "name": "Flankenverätzung 2. Grades",
    "synonyms": [
      "Bauchdeckenverätzung 2. Grades",
      "Bauchdeckenverätzung Grad 2a",
      "Flankenverätzung 2. Grades",
      "Flankenverätzung Grad 2a",
      "Leistenverätzung 2. Grades",
      "Leistenverätzung Grad 2a"
    ]
  },
  {
    "code": "T21.64",
    "name": "Gesäßverätzung 2. Grades",
    "synonyms": [
      "Anusverätzung 2. Grades",
      "Anusverätzung Grad 2a",
      "Gesäßverätzung 2. Grades",
      "Gesäßverätzung Grad 2a",
      "Rückenverätzung 2. Grades",
      "Rückenverätzung Grad 2a",
      "Verätzung der Interskapularregion 2. Grades",
      "Verätzung der Interskapularregion Grad 2a"
    ]
  },
  {
    "code": "T21.65",
    "name": "Labienverätzung 2. Grades",
    "synonyms": [
      "Hodenverätzung 2. Grades",
      "Hodenverätzung Grad 2a",
      "Labienverätzung 2. Grades",
      "Labienverätzung Grad 2a",
      "Penisverätzung 2. Grades",
      "Penisverätzung Grad 2a",
      "Perineumverätzung 2. Grades",
      "Perineumverätzung Grad 2a",
      "Skrotumverätzung 2. Grades",
      "Skrotumverätzung Grad 2a",
      "Testisverätzung 2. Grades",
      "Testisverätzung Grad 2a",
      "Verätzung 2. Grades der äußeren Genitale",
      "Verätzung der Labia majora pudendi 2. Grades",
      "Verätzung der Labia majora pudendi Grad 2a",
      "Verätzung der Labia minora pudendi 2. Grades",
      "Verätzung der Labia minora pudendi Grad 2a",
      "Vulvaverätzung 2. Grades",
      "Vulvaverätzung Grad 2a"
    ]
  },
  {
    "code": "T21.70",
    "name": "Rumpfverätzung 3. Grades",
    "synonyms": [
      "Rumpfverätzung 3. Grades"
    ]
  },
  {
    "code": "T21.71",
    "name": "Mammaverätzung 3. Grades",
    "synonyms": [
      "Brustdrüsenverätzung 3. Grades",
      "Mammaverätzung 3. Grades"
    ]
  },
  {
    "code": "T21.72",
    "name": "Verätzung der Thoraxwand 3. Grades",
    "synonyms": [
      "Verätzung der Thoraxwand 3. Grades"
    ]
  },
  {
    "code": "T21.73",
    "name": "Leistenverätzung 3. Grades",
    "synonyms": [
      "Bauchdeckenverätzung 3. Grades",
      "Flankenverätzung 3. Grades",
      "Leistenverätzung 3. Grades"
    ]
  },
  {
    "code": "T21.74",
    "name": "Anusverätzung 3. Grades",
    "synonyms": [
      "Anusverätzung 3. Grades",
      "Gesäßverätzung 3. Grades",
      "Rückenverätzung 3. Grades",
      "Verätzung der Interskapularregion 3. Grades"
    ]
  },
  {
    "code": "T21.75",
    "name": "Labienverätzung 3. Grades",
    "synonyms": [
      "Hodenverätzung 3. Grades",
      "Labienverätzung 3. Grades",
      "Penisverätzung 3. Grades",
      "Perineumverätzung 3. Grades",
      "Skrotumverätzung 3. Grades",
      "Testisverätzung 3. Grades",
      "Verätzung 3. Grades der äußeren Genitale",
      "Verätzung der Labia majora pudendi 3. Grades",
      "Verätzung der Labia minora pudendi 3. Grades",
      "Vulvaverätzung 3. Grades"
    ]
  },
  {
    "code": "T21.80",
    "name": "Rumpfverbrennung Grad 2b",
    "synonyms": [
      "Rumpfverbrennung Grad 2b"
    ]
  },
  {
    "code": "T21.81",
    "name": "Brustdrüsenverbrennung Grad 2b",
    "synonyms": [
      "Brustdrüsenverbrennung Grad 2b",
      "Mammaverbrennung Grad 2b"
    ]
  },
  {
    "code": "T21.82",
    "name": "Verbrennung der Thoraxwand Grad 2b",
    "synonyms": [
      "Verbrennung der Thoraxwand Grad 2b"
    ]
  },
  {
    "code": "T21.83",
    "name": "Bauchdeckenverbrennung Grad 2b",
    "synonyms": [
      "Bauchdeckenverbrennung Grad 2b",
      "Flankenverbrennung Grad 2b",
      "Leistenverbrennung Grad 2b"
    ]
  },
  {
    "code": "T21.84",
    "name": "Anusverbrennung Grad 2b",
    "synonyms": [
      "Anusverbrennung Grad 2b",
      "Gesäßverbrennung Grad 2b",
      "Rückenverbrennung Grad 2b",
      "Verbrennung der Interskapularregion Grad 2b"
    ]
  },
  {
    "code": "T21.85",
    "name": "Labienverbrennung Grad 2b",
    "synonyms": [
      "Hodenverbrennung Grad 2b",
      "Labienverbrennung Grad 2b",
      "Penisverbrennung Grad 2b",
      "Perineumverbrennung Grad 2b",
      "Skrotumverbrennung Grad 2b",
      "Testisverbrennung Grad 2b",
      "Verbrennung Grad 2b der äußeren Genitale",
      "Verbrennung der Labia majora pudendi Grad 2b",
      "Verbrennung der Labia minora pudendi Grad 2b",
      "Vulvaverbrennung Grad 2b"
    ]
  },
  {
    "code": "T21.90",
    "name": "Rumpfverätzung Grad 2b",
    "synonyms": [
      "Rumpfverätzung Grad 2b"
    ]
  },
  {
    "code": "T21.91",
    "name": "Mammaverätzung Grad 2b",
    "synonyms": [
      "Brustdrüsenverätzung Grad 2b",
      "Mammaverätzung Grad 2b"
    ]
  },
  {
    "code": "T21.92",
    "name": "Verätzung der Thoraxwand Grad 2b",
    "synonyms": [
      "Verätzung der Thoraxwand Grad 2b"
    ]
  },
  {
    "code": "T21.93",
    "name": "Flankenverätzung Grad 2b",
    "synonyms": [
      "Bauchdeckenverätzung Grad 2b",
      "Flankenverätzung Grad 2b",
      "Leistenverätzung Grad 2b"
    ]
  },
  {
    "code": "T21.94",
    "name": "Anusverätzung Grad 2b",
    "synonyms": [
      "Anusverätzung Grad 2b",
      "Gesäßverätzung Grad 2b",
      "Rückenverätzung Grad 2b",
      "Verätzung der Interskapularregion Grad 2b"
    ]
  },
  {
    "code": "T21.95",
    "name": "Labienverätzung Grad 2b",
    "synonyms": [
      "Hodenverätzung Grad 2b",
      "Labienverätzung Grad 2b",
      "Penisverätzung Grad 2b",
      "Perineumverätzung Grad 2b",
      "Skrotumverätzung Grad 2b",
      "Testisverätzung Grad 2b",
      "Verätzung Grad 2b der äußeren Genitale",
      "Verätzung der Labia majora pudendi Grad 2b",
      "Verätzung der Labia minora pudendi Grad 2b",
      "Vulvaverätzung Grad 2b"
    ]
  },
  {
    "code": "T22.00",
    "name": "Verbrennung der oberen Extremität",
    "synonyms": [
      "Verbrennung der oberen Extremität"
    ]
  },
  {
    "code": "T22.02",
    "name": "Schulterverbrennung",
    "synonyms": [
      "Armverbrennung",
      "Schulterverbrennung",
      "Verbrennung der Schulterblattgegend",
      "Verbrennung der Skapularregion"
    ]
  },
  {
    "code": "T22.03",
    "name": "Achselhöhlenverbrennung",
    "synonyms": [
      "Achselhöhlenverbrennung"
    ]
  },
  {
    "code": "T22.11",
    "name": "Ellenbogenverbrennung 1. Grades",
    "synonyms": [
      "Ellenbogenverbrennung 1. Grades",
      "Unterarmverbrennung 1. Grades"
    ]
  },
  {
    "code": "T22.12",
    "name": "Schulterverbrennung 1. Grades",
    "synonyms": [
      "Armverbrennung 1. Grades",
      "Schulterverbrennung 1. Grades",
      "Verbrennung der Skapularregion 1. Grades"
    ]
  },
  {
    "code": "T22.13",
    "name": "Achselhöhlenverbrennung 1. Grades",
    "synonyms": [
      "Achselhöhlenverbrennung 1. Grades"
    ]
  },
  {
    "code": "T22.21",
    "name": "Ellenbogenverbrennung 2. Grades",
    "synonyms": [
      "Ellenbogenverbrennung 2. Grades",
      "Ellenbogenverbrennung Grad 2a",
      "Unterarmverbrennung 2. Grades",
      "Unterarmverbrennung Grad 2a"
    ]
  },
  {
    "code": "T22.22",
    "name": "Schulterverbrennung 2. Grades",
    "synonyms": [
      "Armverbrennung 2. Grades",
      "Armverbrennung Grad 2a",
      "Schulterverbrennung 2. Grades",
      "Schulterverbrennung Grad 2a",
      "Verbrennung der Skapularregion 2. Grades",
      "Verbrennung der Skapularregion Grad 2a"
    ]
  },
  {
    "code": "T22.23",
    "name": "Achselhöhlenverbrennung 2. Grades",
    "synonyms": [
      "Achselhöhlenverbrennung 2. Grades",
      "Achselhöhlenverbrennung Grad 2a"
    ]
  },
  {
    "code": "T22.31",
    "name": "Ellenbogenverbrennung 3. Grades",
    "synonyms": [
      "Ellenbogenverbrennung 3. Grades",
      "Unterarmverbrennung 3. Grades"
    ]
  },
  {
    "code": "T22.32",
    "name": "Schulterverbrennung 3. Grades",
    "synonyms": [
      "Armverbrennung 3. Grades",
      "Schulterverbrennung 3. Grades",
      "Verbrennung der Skapularregion 3. Grades"
    ]
  },
  {
    "code": "T22.33",
    "name": "Achselhöhlenverbrennung 3. Grades",
    "synonyms": [
      "Achselhöhlenverbrennung 3. Grades"
    ]
  },
  {
    "code": "T22.40",
    "name": "Verätzung der oberen Extremität",
    "synonyms": [
      "Verätzung der oberen Extremität"
    ]
  },
  {
    "code": "T22.42",
    "name": "Armverätzung",
    "synonyms": [
      "Armverätzung",
      "Oberarmverätzung",
      "Schulterverätzung",
      "Verätzung der Skapularregion"
    ]
  },
  {
    "code": "T22.43",
    "name": "Achselhöhlenverätzung",
    "synonyms": [
      "Achselhöhlenverätzung"
    ]
  },
  {
    "code": "T22.51",
    "name": "Ellenbogenverätzung 1. Grades",
    "synonyms": [
      "Ellenbogenverätzung 1. Grades",
      "Unterarmverätzung 1. Grades"
    ]
  },
  {
    "code": "T22.52",
    "name": "Armverätzung 1. Grades",
    "synonyms": [
      "Armverätzung 1. Grades",
      "Schulterverätzung 1. Grades",
      "Verätzung der Skapularregion 1. Grades"
    ]
  },
  {
    "code": "T22.53",
    "name": "Achselhöhlenverätzung 1. Grades",
    "synonyms": [
      "Achselhöhlenverätzung 1. Grades"
    ]
  },
  {
    "code": "T22.61",
    "name": "Ellenbogenverätzung 2. Grades",
    "synonyms": [
      "Ellenbogenverätzung 2. Grades",
      "Ellenbogenverätzung Grad 2a",
      "Unterarmverätzung 2. Grades",
      "Unterarmverätzung Grad 2a"
    ]
  },
  {
    "code": "T22.62",
    "name": "Armverätzung 2. Grades",
    "synonyms": [
      "Armverätzung 2. Grades",
      "Armverätzung Grad 2a",
      "Schulterverätzung 2. Grades",
      "Schulterverätzung Grad 2a",
      "Verätzung der Skapularregion 2. Grades",
      "Verätzung der Skapularregion Grad 2a"
    ]
  },
  {
    "code": "T22.63",
    "name": "Achselhöhlenverätzung 2. Grades",
    "synonyms": [
      "Achselhöhlenverätzung 2. Grades",
      "Achselhöhlenverätzung Grad 2a"
    ]
  },
  {
    "code": "T22.71",
    "name": "Ellenbogenverätzung 3. Grades",
    "synonyms": [
      "Ellenbogenverätzung 3. Grades",
      "Unterarmverätzung 3. Grades"
    ]
  },
  {
    "code": "T22.72",
    "name": "Armverätzung 3. Grades",
    "synonyms": [
      "Armverätzung 3. Grades",
      "Schulterverätzung 3. Grades",
      "Verätzung der Skapularregion 3. Grades"
    ]
  },
  {
    "code": "T22.73",
    "name": "Achselhöhlenverätzung 3. Grades",
    "synonyms": [
      "Achselhöhlenverätzung 3. Grades"
    ]
  },
  {
    "code": "T22.81",
    "name": "Ellenbogenverbrennung Grad 2b",
    "synonyms": [
      "Ellenbogenverbrennung Grad 2b",
      "Unterarmverbrennung Grad 2b"
    ]
  },
  {
    "code": "T22.82",
    "name": "Schulterverbrennung Grad 2b",
    "synonyms": [
      "Armverbrennung Grad 2b",
      "Schulterverbrennung Grad 2b",
      "Verbrennung der Skapularregion Grad 2b"
    ]
  },
  {
    "code": "T22.83",
    "name": "Achselhöhlenverbrennung Grad 2b",
    "synonyms": [
      "Achselhöhlenverbrennung Grad 2b"
    ]
  },
  {
    "code": "T22.91",
    "name": "Ellenbogenverätzung Grad 2b",
    "synonyms": [
      "Ellenbogenverätzung Grad 2b",
      "Unterarmverätzung Grad 2b"
    ]
  },
  {
    "code": "T22.92",
    "name": "Schulterverätzung Grad 2b",
    "synonyms": [
      "Armverätzung Grad 2b",
      "Schulterverätzung Grad 2b",
      "Verätzung der Skapularregion Grad 2b"
    ]
  },
  {
    "code": "T22.93",
    "name": "Achselhöhlenverätzung Grad 2b",
    "synonyms": [
      "Achselhöhlenverätzung Grad 2b"
    ]
  },
  {
    "code": "T23.0",
    "name": "Handverbrennung",
    "synonyms": [
      "Daumennagelverbrennung",
      "Daumenverbrennung",
      "Fingernagelverbrennung",
      "Fingerverbrennung",
      "Handflächenverbrennung",
      "Handgelenkverbrennung",
      "Handrückenverbrennung",
      "Handverbrennung",
      "Subunguale Verbrennung der Finger"
    ]
  },
  {
    "code": "T23.1",
    "name": "Handverbrennung 1. Grades",
    "synonyms": [
      "Handgelenkverbrennung 1. Grades",
      "Handverbrennung 1. Grades"
    ]
  },
  {
    "code": "T23.20",
    "name": "Handverbrennung 2. Grades",
    "synonyms": [
      "Handgelenkverbrennung 2. Grades",
      "Handgelenkverbrennung Grad 2a",
      "Handverbrennung 2. Grades",
      "Handverbrennung Grad 2a"
    ]
  },
  {
    "code": "T23.21",
    "name": "Handverbrennung Grad 2b",
    "synonyms": [
      "Handgelenkverbrennung Grad 2b",
      "Handverbrennung Grad 2b"
    ]
  },
  {
    "code": "T23.3",
    "name": "Handverbrennung 3. Grades",
    "synonyms": [
      "Handgelenkverbrennung 3. Grades",
      "Handverbrennung 3. Grades"
    ]
  },
  {
    "code": "T23.4",
    "name": "Daumenverätzung",
    "synonyms": [
      "Daumennagelverätzung",
      "Daumenverätzung",
      "Fingernagelverätzung",
      "Fingerverätzung",
      "Handverätzung",
      "Subunguale Verätzung der Finger",
      "Verätzung der Handfläche",
      "Verätzung der Phalangen der Hand",
      "Verätzung von Hand und Handgelenk"
    ]
  },
  {
    "code": "T23.5",
    "name": "Handgelenkverätzung 1. Grades",
    "synonyms": [
      "Handgelenkverätzung 1. Grades",
      "Handverätzung 1. Grades"
    ]
  },
  {
    "code": "T23.60",
    "name": "Handgelenkverätzung 2. Grades",
    "synonyms": [
      "Handgelenkverätzung 2. Grades",
      "Handgelenkverätzung Grad 2a",
      "Handverätzung 2. Grades",
      "Handverätzung Grad 2a"
    ]
  },
  {
    "code": "T23.61",
    "name": "Handgelenkverätzung Grad 2b",
    "synonyms": [
      "Handgelenkverätzung Grad 2b",
      "Handverätzung Grad 2b"
    ]
  },
  {
    "code": "T23.7",
    "name": "Handgelenkverätzung 3. Grades",
    "synonyms": [
      "Handgelenkverätzung 3. Grades",
      "Handverätzung 3. Grades"
    ]
  },
  {
    "code": "T24.0",
    "name": "Hüftverbrennung",
    "synonyms": [
      "Beinverbrennung",
      "Beinverbrennung, ausgenommen Knöchelregion und Fuß",
      "Hüftverbrennung",
      "Knieverbrennung",
      "Oberschenkelverbrennung",
      "Verbrennung der unteren Extremität"
    ]
  },
  {
    "code": "T24.1",
    "name": "Hüftverbrennung 1. Grades",
    "synonyms": [
      "Beinverbrennung 1. Grades",
      "Hüftverbrennung 1. Grades"
    ]
  },
  {
    "code": "T24.20",
    "name": "Hüftverbrennung 2. Grades",
    "synonyms": [
      "Beinverbrennung 2. Grades ohne Knöchelregion und Fuß",
      "Beinverbrennung Grad 2a ohne Knöchelregion und Fuß",
      "Hüftverbrennung 2. Grades",
      "Hüftverbrennung Grad 2a"
    ]
  },
  {
    "code": "T24.21",
    "name": "Hüftverbrennung Grad 2b",
    "synonyms": [
      "Beinverbrennung Grad 2b ohne Knöchelregion und Fuß",
      "Hüftverbrennung Grad 2b"
    ]
  },
  {
    "code": "T24.3",
    "name": "Hüftverbrennung 3. Grades",
    "synonyms": [
      "Beinverbrennung 3. Grades",
      "Hüftverbrennung 3. Grades"
    ]
  },
  {
    "code": "T24.4",
    "name": "Beinverätzung",
    "synonyms": [
      "Beinverätzung",
      "Beinverätzung, ausgenommen Knöchelregion und Fuß",
      "Femurverätzung",
      "Knieverätzung",
      "Unterschenkelverätzung",
      "Verätzung der Hüfte",
      "Verätzung der unteren Extremität"
    ]
  },
  {
    "code": "T24.5",
    "name": "Beinverätzung 1. Grades ohne Knöchelregion und Fuß",
    "synonyms": [
      "Beinverätzung 1. Grades ohne Knöchelregion und Fuß",
      "Hüftverätzung 1. Grades"
    ]
  },
  {
    "code": "T24.60",
    "name": "Beinverätzung 2. Grades ohne Knöchelregion und Fuß",
    "synonyms": [
      "Beinverätzung 2. Grades ohne Knöchelregion und Fuß",
      "Beinverätzung Grad 2a ohne Knöchelregion und Fuß",
      "Hüftverätzung 2. Grades",
      "Hüftverätzung Grad 2a"
    ]
  },
  {
    "code": "T24.61",
    "name": "Beinverätzung Grad 2b ohne Knöchelregion und Fuß",
    "synonyms": [
      "Beinverätzung Grad 2b ohne Knöchelregion und Fuß",
      "Hüftverätzung Grad 2b"
    ]
  },
  {
    "code": "T24.7",
    "name": "Beinverätzung 3. Grades ohne Knöchelregion und Fuß",
    "synonyms": [
      "Beinverätzung 3. Grades ohne Knöchelregion und Fuß",
      "Hüftverätzung 3. Grades"
    ]
  },
  {
    "code": "T25.0",
    "name": "Knöchelverbrennung",
    "synonyms": [
      "Fußverbrennung",
      "Knöchelverbrennung",
      "Subunguale Verbrennung einer Zehe",
      "Zehennagelverbrennung",
      "Zehenverbrennung"
    ]
  },
  {
    "code": "T25.1",
    "name": "Knöchelverbrennung 1. Grades",
    "synonyms": [
      "Fußverbrennung 1. Grades",
      "Knöchelverbrennung 1. Grades"
    ]
  },
  {
    "code": "T25.20",
    "name": "Knöchelverbrennung 2. Grades",
    "synonyms": [
      "Fußverbrennung 2. Grades",
      "Fußverbrennung Grad 2a",
      "Knöchelverbrennung 2. Grades",
      "Knöchelverbrennung Grad 2a"
    ]
  },
  {
    "code": "T25.21",
    "name": "Knöchelverbrennung Grad 2b",
    "synonyms": [
      "Fußverbrennung Grad 2b",
      "Knöchelverbrennung Grad 2b"
    ]
  },
  {
    "code": "T25.3",
    "name": "Knöchelverbrennung 3. Grades",
    "synonyms": [
      "Fußverbrennung 3. Grades",
      "Knöchelverbrennung 3. Grades"
    ]
  },
  {
    "code": "T25.4",
    "name": "Verätzung von Fuß und Knöchelregion",
    "synonyms": [
      "Fußverätzung",
      "Verätzung der Knöchelregion",
      "Verätzung der Phalangen des Fußes",
      "Verätzung von Fuß und Knöchelregion",
      "Zehennagelverätzung",
      "Zehenverätzung"
    ]
  },
  {
    "code": "T25.5",
    "name": "Knöchelverätzung 1. Grades",
    "synonyms": [
      "Fußverätzung 1. Grades",
      "Knöchelverätzung 1. Grades"
    ]
  },
  {
    "code": "T25.60",
    "name": "Knöchelverätzung 2. Grades",
    "synonyms": [
      "Fußverätzung 2. Grades",
      "Fußverätzung Grad 2a",
      "Knöchelverätzung 2. Grades",
      "Knöchelverätzung Grad 2a"
    ]
  },
  {
    "code": "T25.61",
    "name": "Knöchelverätzung Grad 2b",
    "synonyms": [
      "Fußverätzung Grad 2b",
      "Knöchelverätzung Grad 2b"
    ]
  },
  {
    "code": "T25.7",
    "name": "Knöchelverätzung 3. Grades",
    "synonyms": [
      "Fußverätzung 3. Grades",
      "Knöchelverätzung 3. Grades"
    ]
  },
  {
    "code": "T26.0",
    "name": "Verbrennung von Lid und Periokularregion",
    "synonyms": [
      "Periokulare Verbrennung",
      "Verbrennung von Lid und Periokularregion"
    ]
  },
  {
    "code": "T26.1",
    "name": "Bindehautverbrennung",
    "synonyms": [
      "Bindehautverbrennung",
      "Hornhautverbrennung des Auges",
      "Konjunktivaverbrennung",
      "Korneaverbrennung"
    ]
  },
  {
    "code": "T26.2",
    "name": "Bulbusverbrennung mit Ruptur",
    "synonyms": [
      "Augenverbrennung mit Ruptur und Zerstörung des Augapfels",
      "Bulbusverbrennung mit Ruptur"
    ]
  },
  {
    "code": "T26.3",
    "name": "Skleraverbrennung",
    "synonyms": [
      "Skleraverbrennung",
      "Verbrennung der Tränendrüse",
      "Verbrennung des Tränenapparates",
      "Verbrennung des Tränenganges",
      "Verbrennung des Tränensacks"
    ]
  },
  {
    "code": "T26.4",
    "name": "Augenverblitzung",
    "synonyms": [
      "Augenverblitzung",
      "Augenverbrennung",
      "Verbrennung der Augenanhangsgebilde"
    ]
  },
  {
    "code": "T26.5",
    "name": "Lidverätzung",
    "synonyms": [
      "Augenlidverätzung",
      "Lidverätzung",
      "Verätzung der Periokularregion"
    ]
  },
  {
    "code": "T26.6",
    "name": "Korneaverätzung",
    "synonyms": [
      "Bindehautverätzung",
      "Hornhautverätzung des Auges",
      "Hornhautverätzung des Auges durch Lauge",
      "Hornhautverätzung des Auges durch Säure",
      "Konjunktivalsackverätzung",
      "Konjunktivaverätzung",
      "Korneaverätzung"
    ]
  },
  {
    "code": "T26.7",
    "name": "Bulbusverätzung mit Ruptur",
    "synonyms": [
      "Augenverätzung mit Ruptur und Destruktion des Augapfels",
      "Bulbusverätzung mit Ruptur"
    ]
  },
  {
    "code": "T26.8",
    "name": "Skleraverätzung",
    "synonyms": [
      "Skleraverätzung",
      "Verätzung der Tränendrüse",
      "Verätzung des Tränenapparates",
      "Verätzung des Tränenganges",
      "Verätzung des Tränensacks"
    ]
  },
  {
    "code": "T26.9",
    "name": "Augenverätzung",
    "synonyms": [
      "Augenverätzung",
      "Augenverätzung durch Kalk",
      "Augenverätzung durch Mörtel",
      "Verätzung der Augenanhangsgebilde"
    ]
  },
  {
    "code": "T27.0",
    "name": "Kehlkopfverbrennung",
    "synonyms": [
      "Kehlkopfverbrennung",
      "Larynxverbrennung",
      "Luftröhrenverbrennung",
      "Tracheaverbrennung"
    ]
  },
  {
    "code": "T27.1",
    "name": "Verbrennung des Kehlkopfes und der Trachea mit Beteiligung der Lunge",
    "synonyms": [
      "Tracheaverbrennung mit Beteiligung der Lunge",
      "Verbrennung des Kehlkopfes und der Trachea mit Beteiligung der Lunge",
      "Verbrennung des Larynx und der Trachea mit Beteiligung der Lunge"
    ]
  },
  {
    "code": "T27.2",
    "name": "Verbrennung der Thoraxhöhle",
    "synonyms": [
      "Verbrennung der Thoraxhöhle"
    ]
  },
  {
    "code": "T27.3",
    "name": "Flammeninhalation",
    "synonyms": [
      "Flammeninhalation",
      "Verbrennung durch Inhalation"
    ]
  },
  {
    "code": "T27.4",
    "name": "Kehlkopfverätzung",
    "synonyms": [
      "Kehlkopfverätzung",
      "Larynxverätzung",
      "Tracheaverätzung"
    ]
  },
  {
    "code": "T27.5",
    "name": "Verätzung des Kehlkopfes und der Trachea mit Beteiligung der Lunge",
    "synonyms": [
      "Larynxverätzung mit Beteiligung der Lunge",
      "Tracheaverätzung mit Beteiligung der Lunge",
      "Verätzung des Kehlkopfes und der Trachea mit Beteiligung der Lunge",
      "Verätzung des Larynx und der Trachea mit Beteiligung der Lunge"
    ]
  },
  {
    "code": "T27.7",
    "name": "Verätzung der Atemwege",
    "synonyms": [
      "Verätzung der Atemwege",
      "Verätzung durch Inhalation"
    ]
  },
  {
    "code": "T28.0",
    "name": "Verbrennung des Mundes und des Rachens",
    "synonyms": [
      "Pharynxverbrennung",
      "Rachenverbrennung",
      "Tonsillenverbrennung",
      "Verbrennung des Mundes und des Rachens",
      "Zungenverbrennung"
    ]
  },
  {
    "code": "T28.1",
    "name": "Ösophagusverbrennung",
    "synonyms": [
      "Speiseröhrenverbrennung",
      "Ösophagusverbrennung"
    ]
  },
  {
    "code": "T28.2",
    "name": "Verbrennung des Magen-Darm-Traktes a.n.k.",
    "synonyms": [
      "Kolonverbrennung",
      "Rektumstriktur durch Verätzung",
      "Rektumverbrennung",
      "Verbrennung des Magen-Darm-Traktes a.n.k.",
      "Verbrennung des Verdauungstraktes a.n.k."
    ]
  },
  {
    "code": "T28.3",
    "name": "Verbrennung innerer Organe des Urogenitaltraktes",
    "synonyms": [
      "Uterusverbrennung",
      "Vaginalverbrennung",
      "Vaginalverbrennung 1. Grades",
      "Vaginalverbrennung 2. Grades",
      "Vaginalverbrennung 3. Grades",
      "Vaginalverbrennung Grad 2a",
      "Vaginalverbrennung Grad 2b",
      "Verbrennung der Cervix uteri",
      "Verbrennung der inneren Urogenitalorgane",
      "Verbrennung innerer Organe des Urogenitaltraktes",
      "Zervixverbrennung"
    ]
  },
  {
    "code": "T28.4",
    "name": "Verbrennung innerer Organe a.n.k.",
    "synonyms": [
      "Verbrennung innerer Organe a.n.k."
    ]
  },
  {
    "code": "T28.5",
    "name": "Verätzung des Mundes und des Rachens",
    "synonyms": [
      "Mundverätzung",
      "Rachenverätzung",
      "Schlundverätzung",
      "Tonsillenverätzung",
      "Verätzung des Mundes und des Rachens",
      "Zungenverätzung"
    ]
  },
  {
    "code": "T28.6",
    "name": "Ösophagusverätzung",
    "synonyms": [
      "Ösophagusverätzung"
    ]
  },
  {
    "code": "T28.7",
    "name": "Verätzung des Magen-Darm-Traktes a.n.k.",
    "synonyms": [
      "Darmverätzung",
      "Dickdarmverätzung",
      "Dünndarmverätzung",
      "Kolonverätzung",
      "Magenverätzung",
      "Rektumverätzung",
      "Verätzung des Magen-Darm-Traktes a.n.k."
    ]
  },
  {
    "code": "T28.8",
    "name": "Verätzung innerer Organe des Urogenitaltraktes",
    "synonyms": [
      "Uterusverätzung",
      "Vaginalverätzung",
      "Vaginalverätzung 1. Grades",
      "Vaginalverätzung 2. Grades",
      "Vaginalverätzung 3. Grades",
      "Vaginalverätzung Grad 2a",
      "Vaginalverätzung Grad 2b",
      "Verätzung der Cervix uteri",
      "Verätzung innerer Organe des Urogenitaltraktes",
      "Verätzung innerer Urogenitalorgane",
      "Zervixverätzung"
    ]
  },
  {
    "code": "T28.9",
    "name": "Verätzung innerer Organe a.n.k.",
    "synonyms": [
      "Verätzung der inneren Thoraxwand",
      "Verätzung innerer Organe a.n.k."
    ]
  },
  {
    "code": "T29.0",
    "name": "Verkohlung",
    "synonyms": [
      "Fußverbrennung mit Beinbeteiligung",
      "Handgelenkverbrennung mit Armbeteiligung",
      "Handverbrennung mit Armbeteiligung",
      "Multiple Verbrennungen",
      "Verbrennung des ganzen Körpers",
      "Verbrennung multipler Körperregionen",
      "Verbrennung von Knöchelregion und Fuß mit Beteiligung des Beins",
      "Verkohlung",
      "Verkohlung des ganzen Körpers"
    ]
  },
  {
    "code": "T29.1",
    "name": "Verbrennung multipler Körperregionen 1. Grades",
    "synonyms": [
      "Ganzkörperverbrennung 1. Grades",
      "Verbrennung multipler Körperregionen 1. Grades"
    ]
  },
  {
    "code": "T29.20",
    "name": "Verbrennung multipler Körperregionen 2. Grades",
    "synonyms": [
      "Ganzkörperverbrennung 2. Grades",
      "Verbrennung multipler Körperregionen 2. Grades",
      "Verbrennung multipler Körperregionen Grad 2a"
    ]
  },
  {
    "code": "T29.21",
    "name": "Verbrennung multipler Körperregionen Grad 2b",
    "synonyms": [
      "Verbrennung multipler Körperregionen Grad 2b"
    ]
  },
  {
    "code": "T29.3",
    "name": "Verbrennung multipler Körperregionen 3. Grades",
    "synonyms": [
      "Ganzkörperverbrennung 3. Grades",
      "Verbrennung multipler Körperregionen 3. Grades"
    ]
  },
  {
    "code": "T29.4",
    "name": "Verätzung multipler Körperregionen",
    "synonyms": [
      "Armverätzung mit Beteiligung des Handgelenks und der Hand",
      "Beinverätzung mit Beteiligung von Knöchelregion und Fuß",
      "Fußverätzung mit Beteiligung des Beins",
      "Handverätzung mit Beteiligung des Arms",
      "Multiple Verätzungen",
      "Oberarmverätzung mit Beteiligung des Handgelenks und der Hand",
      "Unterschenkelverätzung mit Beteiligung von Knöchelregion und Fuß",
      "Verätzung der Knöchelregion mit Beteiligung des Beins",
      "Verätzung multipler Körperregionen"
    ]
  },
  {
    "code": "T29.5",
    "name": "Verätzung multipler Körperregionen 1. Grades",
    "synonyms": [
      "Verätzung multipler Körperregionen 1. Grades"
    ]
  },
  {
    "code": "T29.60",
    "name": "Verätzung multipler Körperregionen 2. Grades",
    "synonyms": [
      "Verätzung multipler Körperregionen 2. Grades",
      "Verätzung multipler Körperregionen Grad 2a"
    ]
  },
  {
    "code": "T29.61",
    "name": "Verätzung multipler Körperregionen Grad 2b",
    "synonyms": [
      "Verätzung multipler Körperregionen Grad 2b"
    ]
  },
  {
    "code": "T29.7",
    "name": "Verätzung multipler Körperregionen 3. Grades",
    "synonyms": [
      "Verätzung multipler Körperregionen 3. Grades"
    ]
  },
  {
    "code": "T30.0",
    "name": "Hautverbrennung a.n.k.",
    "synonyms": [
      "Brandverletzung",
      "Brandwunde - s.a. Verbrennung",
      "Hautverbrennung a.n.k.",
      "Röntgenverbrennung",
      "Stromverbrennung",
      "Verbrennung",
      "Verbrennung durch Dampf",
      "Verbrennung durch Elektrizität",
      "Verbrennung durch Flamme",
      "Verbrennung durch Strahleneinwirkung",
      "Verbrennung durch heiße Flüssigkeit",
      "Verbrennung durch heiße Gase",
      "Verbrennung durch heißen Gegenstand",
      "Verbrühung - s.a. Verbrennung"
    ]
  },
  {
    "code": "T30.1",
    "name": "Verbrennung 1. Grades",
    "synonyms": [
      "Verbrennung 1. Grades"
    ]
  },
  {
    "code": "T30.20",
    "name": "Verbrennung 2. Grades",
    "synonyms": [
      "Verbrennung 2. Grades",
      "Verbrennung Grad 2a"
    ]
  },
  {
    "code": "T30.21",
    "name": "Verbrennung Grad 2b",
    "synonyms": [
      "Verbrennung Grad 2b"
    ]
  },
  {
    "code": "T30.3",
    "name": "Verbrennung 3. Grades",
    "synonyms": [
      "Verbrennung 3. Grades"
    ]
  },
  {
    "code": "T30.4",
    "name": "Säureverätzung",
    "synonyms": [
      "Chemische Verätzung",
      "Hautverätzung a.n.k.",
      "Innere Verätzung",
      "Säureverätzung",
      "Verletzung durch Verätzung",
      "Verätzung",
      "Verätzung durch Kalk",
      "Äußere Verätzung"
    ]
  },
  {
    "code": "T30.5",
    "name": "Verätzung 1. Grades",
    "synonyms": [
      "Verätzung 1. Grades"
    ]
  },
  {
    "code": "T30.60",
    "name": "Verätzung 2. Grades",
    "synonyms": [
      "Verätzung 2. Grades",
      "Verätzung Grad 2a"
    ]
  },
  {
    "code": "T30.61",
    "name": "Verätzung Grad 2b",
    "synonyms": [
      "Verätzung Grad 2b"
    ]
  },
  {
    "code": "T30.7",
    "name": "Verätzung 3. Grades",
    "synonyms": [
      "Verätzung 3. Grades"
    ]
  },
  {
    "code": "T33.0",
    "name": "Oberflächliche Erfrierung des Kopfes",
    "synonyms": [
      "Oberflächliche Erfrierung des Gesichts",
      "Oberflächliche Erfrierung des Kopfes"
    ]
  },
  {
    "code": "T33.1",
    "name": "Oberflächliche Erfrierung des Halses",
    "synonyms": [
      "Oberflächliche Erfrierung des Halses"
    ]
  },
  {
    "code": "T33.2",
    "name": "Oberflächliche Erfrierung des Thorax",
    "synonyms": [
      "Oberflächliche Erfrierung des Thorax"
    ]
  },
  {
    "code": "T33.3",
    "name": "Oberflächliche Bauchwanderfrierung",
    "synonyms": [
      "Oberflächliche Bauchwanderfrierung",
      "Oberflächliche Beckenerfrierung"
    ]
  },
  {
    "code": "T33.4",
    "name": "Oberflächliche Erfrierung des Arms",
    "synonyms": [
      "Oberflächliche Erfrierung des Arms"
    ]
  },
  {
    "code": "T33.5",
    "name": "Oberflächliche Handgelenkerfrierung",
    "synonyms": [
      "Oberflächliche Fingererfrierung",
      "Oberflächliche Handerfrierung",
      "Oberflächliche Handgelenkerfrierung"
    ]
  },
  {
    "code": "T33.6",
    "name": "Oberflächliche Oberschenkelerfrierung",
    "synonyms": [
      "Oberflächliche Hüfterfrierung",
      "Oberflächliche Oberschenkelerfrierung"
    ]
  },
  {
    "code": "T33.7",
    "name": "Oberflächliche Unterschenkelerfrierung",
    "synonyms": [
      "Oberflächliche Knieerfrierung",
      "Oberflächliche Unterschenkelerfrierung"
    ]
  },
  {
    "code": "T33.8",
    "name": "Oberflächliche Erfrierung der Knöchelregion",
    "synonyms": [
      "Oberflächliche Erfrierung der Knöchelregion",
      "Oberflächliche Fußerfrierung"
    ]
  },
  {
    "code": "T33.9",
    "name": "Oberflächliche Erfrierung",
    "synonyms": [
      "Erfrierung mit Oberhautnekrose",
      "Oberflächliche Beinerfrierung",
      "Oberflächliche Erfrierung",
      "Oberflächliche Rumpferfrierung"
    ]
  },
  {
    "code": "T34.0",
    "name": "Kopferfrierung mit Gewebsnekrose",
    "synonyms": [
      "Gesichtserfrierung mit Gewebsnekrose",
      "Kopferfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.1",
    "name": "Halserfrierung mit Gewebsnekrose",
    "synonyms": [
      "Halserfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.2",
    "name": "Thoraxerfrierung mit Gewebsnekrose",
    "synonyms": [
      "Thoraxerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.3",
    "name": "Bauchwanderfrierung mit Gewebsnekrose",
    "synonyms": [
      "Bauchwanderfrierung mit Gewebsnekrose",
      "Beckenerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.4",
    "name": "Armerfrierung mit Gewebsnekrose",
    "synonyms": [
      "Armerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.5",
    "name": "Handgelenkerfrierung mit Gewebsnekrose",
    "synonyms": [
      "Fingererfrierung mit Gewebsnekrose",
      "Handerfrierung mit Gewebsnekrose",
      "Handgelenkerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.6",
    "name": "Oberschenkelerfrierung mit Gewebsnekrose",
    "synonyms": [
      "Hüfterfrierung mit Gewebsnekrose",
      "Oberschenkelerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.7",
    "name": "Unterschenkelerfrierung mit Gewebsnekrose",
    "synonyms": [
      "Knieerfrierung mit Gewebsnekrose",
      "Unterschenkelerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.8",
    "name": "Erfrierung der Knöchelregion mit Gewebsnekrose",
    "synonyms": [
      "Erfrierung der Knöchelregion mit Gewebsnekrose",
      "Fußerfrierung mit Gewebsnekrose",
      "Zehenerfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T34.9",
    "name": "Erfrierung mit Gewebsnekrose",
    "synonyms": [
      "Beinerfrierung mit Gewebsnekrose",
      "Erfrierung mit Gewebsnekrose",
      "Erfrierungsgangrän",
      "Frostgangrän",
      "Rumpferfrierung mit Gewebsnekrose"
    ]
  },
  {
    "code": "T35.0",
    "name": "Multiple oberflächliche Erfrierungen",
    "synonyms": [
      "Multiple oberflächliche Erfrierungen"
    ]
  },
  {
    "code": "T35.1",
    "name": "Multiple Erfrierungen mit Gewebsnekrose",
    "synonyms": [
      "Multiple Erfrierungen mit Gewebsnekrose"
    ]
  },
  {
    "code": "T35.2",
    "name": "Gesichtserfrierung",
    "synonyms": [
      "Gesichtserfrierung",
      "Halserfrierung",
      "Kopferfrierung"
    ]
  },
  {
    "code": "T35.3",
    "name": "Bauchwanderfrierung",
    "synonyms": [
      "Bauchwanderfrierung",
      "Beckenerfrierung",
      "Erfrierung des Rumpfes",
      "Thoraxerfrierung"
    ]
  },
  {
    "code": "T35.4",
    "name": "Fingererfrierung",
    "synonyms": [
      "Erfrierung der oberen Extremität",
      "Fingererfrierung",
      "Handerfrierung",
      "Handgelenkerfrierung"
    ]
  },
  {
    "code": "T35.5",
    "name": "Fußerfrierung",
    "synonyms": [
      "Erfrierung der Hüfte",
      "Erfrierung der Knöchelregion",
      "Erfrierung der unteren Extremität",
      "Fußerfrierung",
      "Knieerfrierung",
      "Oberschenkelerfrierung",
      "Zehenerfrierung"
    ]
  },
  {
    "code": "T35.6",
    "name": "Erfrierung multipler Körperregionen",
    "synonyms": [
      "Erfrierung multipler Körperregionen",
      "Multiple Erfrierungen"
    ]
  },
  {
    "code": "T35.7",
    "name": "Congelatio",
    "synonyms": [
      "Congelatio",
      "Erfrierung"
    ]
  },
  {
    "code": "T36.0",
    "name": "Vergiftung durch Penicilline",
    "synonyms": [
      "Vergiftung durch Penicilline"
    ]
  },
  {
    "code": "T36.5",
    "name": "Vergiftung durch Streptomycin",
    "synonyms": [
      "Vergiftung durch Streptomycin"
    ]
  },
  {
    "code": "T37.0",
    "name": "Anurie durch Überdosis an Sulfonamiden",
    "synonyms": [
      "Anurie durch Überdosis an Sulfonamiden"
    ]
  },
  {
    "code": "T37.2",
    "name": "Chininintoxikation",
    "synonyms": [
      "Chininintoxikation",
      "Vergiftung durch Chinin"
    ]
  },
  {
    "code": "T37.8",
    "name": "Nitrit-Krise durch gegebene falsche Substanz",
    "synonyms": [
      "Nitrit-Krise bei Überdosis",
      "Nitrit-Krise durch gegebene falsche Substanz",
      "Vergiftung durch Hydroxychinolin-Derivat"
    ]
  },
  {
    "code": "T38.0",
    "name": "Vergiftung durch Glukokortikosteroide",
    "synonyms": [
      "Steroiddiabetes durch Überdosis",
      "Vergiftung durch Glukokortikosteroide"
    ]
  },
  {
    "code": "T38.2",
    "name": "Vergiftung durch Thyreostatika",
    "synonyms": [
      "Vergiftung durch Thyreostatika"
    ]
  },
  {
    "code": "T38.3",
    "name": "Zwischenfall bei Insulingabe",
    "synonyms": [
      "Hypoglykämie durch Insulin als therapeutischer Zwischenfall",
      "Hypoglykämische Reaktion durch Insulin als therapeutischer Zwischenfall",
      "Zwischenfall bei Insulingabe"
    ]
  },
  {
    "code": "T38.4",
    "name": "Vergiftung durch orales Kontrazeptivum",
    "synonyms": [
      "Pillenikterus",
      "Vergiftung durch orales Kontrazeptivum"
    ]
  },
  {
    "code": "T38.5",
    "name": "Vergiftung durch östrogenhaltige Mixtur",
    "synonyms": [
      "Vergiftung durch gestagenhaltige Mixtur",
      "Vergiftung durch gestagenhaltigen Ersatzstoff",
      "Vergiftung durch östrogenhaltige Mixtur",
      "Vergiftung durch östrogenhaltigen Ersatzstoff"
    ]
  },
  {
    "code": "T38.6",
    "name": "Vergiftung durch Tamoxifen",
    "synonyms": [
      "Vergiftung durch Enzalutamid",
      "Vergiftung durch Tamoxifen"
    ]
  },
  {
    "code": "T38.8",
    "name": "Vergiftung durch ein Adenohypophysenhormon",
    "synonyms": [
      "Vergiftung durch ein Adenohypophysenhormon",
      "Vergiftung durch ein Hypophysenvorderlappenhormon"
    ]
  },
  {
    "code": "T39.0",
    "name": "Vergiftung durch Salizylate",
    "synonyms": [
      "Salizylismus bei Überdosis",
      "Vergiftung durch Salizylate"
    ]
  },
  {
    "code": "T39.1",
    "name": "Vergiftung durch 4-Aminophenol-Derivate",
    "synonyms": [
      "Intoxikation durch Paracetamol",
      "Vergiftung durch 4-Aminophenol-Derivate"
    ]
  },
  {
    "code": "T39.2",
    "name": "Vergiftung durch Pyrazolon-Derivate",
    "synonyms": [
      "Vergiftung durch Pyrazolon-Derivate"
    ]
  },
  {
    "code": "T39.9",
    "name": "Vergiftung durch nichtopioidhaltige Analgetika",
    "synonyms": [
      "Intoxikation durch nichtopioidhaltige Analgetika",
      "Vergiftung durch nichtopioidhaltige Analgetika"
    ]
  },
  {
    "code": "T40.0",
    "name": "Vergiftung durch Opium",
    "synonyms": [
      "Akute Vergiftung durch Opium",
      "Vergiftung durch Opium"
    ]
  },
  {
    "code": "T40.1",
    "name": "Vergiftung durch Heroin",
    "synonyms": [
      "Akute Vergiftung durch Heroin",
      "Heroinintoxikation",
      "Vergiftung durch Heroin"
    ]
  },
  {
    "code": "T40.2",
    "name": "Vergiftung durch Codein",
    "synonyms": [
      "Akute Vergiftung durch Codein",
      "Akute Vergiftung durch Morphin",
      "Vergiftung durch Codein",
      "Vergiftung durch Fentanyl",
      "Vergiftung durch Kodein",
      "Vergiftung durch Morphin"
    ]
  },
  {
    "code": "T40.3",
    "name": "Vergiftung durch Methadon",
    "synonyms": [
      "Vergiftung durch Methadon"
    ]
  },
  {
    "code": "T40.4",
    "name": "Vergiftung durch Pethidin",
    "synonyms": [
      "Vergiftung durch Pethidin"
    ]
  },
  {
    "code": "T40.5",
    "name": "Vergiftung durch Kokain",
    "synonyms": [
      "Kokainintoxikation",
      "Vergiftung durch Kokain"
    ]
  },
  {
    "code": "T40.6",
    "name": "Vergiftung durch Betäubungsmittel",
    "synonyms": [
      "Vergiftung durch Betäubungsmittel"
    ]
  },
  {
    "code": "T40.7",
    "name": "Vergiftung durch Cannabis",
    "synonyms": [
      "Vergiftung durch Cannabis",
      "Vergiftung durch ein Cannabis-Derivat"
    ]
  },
  {
    "code": "T40.8",
    "name": "Vergiftung durch Lysergid",
    "synonyms": [
      "Vergiftung durch LSD [Lysergsäurediäthylamid]",
      "Vergiftung durch Lysergid"
    ]
  },
  {
    "code": "T40.9",
    "name": "Vergiftung durch Psilocin",
    "synonyms": [
      "Vergiftung durch Mescalin",
      "Vergiftung durch Psilocin",
      "Vergiftung durch Psilocybin"
    ]
  },
  {
    "code": "T41.0",
    "name": "Vergiftung durch Inhalationsanästhetika",
    "synonyms": [
      "Halothanschädigung",
      "Vergiftung durch Inhalationsanästhetika"
    ]
  },
  {
    "code": "T41.1",
    "name": "Vergiftung durch intravenöse Anästhetika",
    "synonyms": [
      "Vergiftung durch Thiobarbiturate",
      "Vergiftung durch intravenöse Anästhetika"
    ]
  },
  {
    "code": "T41.3",
    "name": "Vergiftung durch Lokalanästhetikum",
    "synonyms": [
      "Vergiftung durch Lokalanästhetikum"
    ]
  },
  {
    "code": "T41.5",
    "name": "Vergiftung durch therapeutische Gase",
    "synonyms": [
      "Vergiftung durch Kohlendioxid",
      "Vergiftung durch Sauerstoff",
      "Vergiftung durch therapeutische Gase"
    ]
  },
  {
    "code": "T42.0",
    "name": "Vergiftung durch Hydantoin-Derivate",
    "synonyms": [
      "Vergiftung durch Hydantoin-Derivate"
    ]
  },
  {
    "code": "T42.1",
    "name": "Vergiftung durch Iminostilbene",
    "synonyms": [
      "Vergiftung durch Carbamazepin",
      "Vergiftung durch Iminostilbene"
    ]
  },
  {
    "code": "T42.2",
    "name": "Vergiftung durch Succinimide",
    "synonyms": [
      "Vergiftung durch Oxazolidine",
      "Vergiftung durch Succinimide"
    ]
  },
  {
    "code": "T42.3",
    "name": "Barbituratintoxikation",
    "synonyms": [
      "Barbituratintoxikation",
      "Vergiftung durch Barbiturate"
    ]
  },
  {
    "code": "T42.4",
    "name": "Vergiftung durch Benzodiazepin",
    "synonyms": [
      "Benzodiazepinintoxikation",
      "Vergiftung durch Benzodiazepin"
    ]
  },
  {
    "code": "T42.6",
    "name": "Vergiftung durch Methaqualon",
    "synonyms": [
      "Vergiftung durch Methaqualon",
      "Vergiftung durch Valproinsäure"
    ]
  },
  {
    "code": "T42.7",
    "name": "Vergiftung durch Schlaftabletten",
    "synonyms": [
      "Schlaftablettenvergiftung mit Suizidabsicht",
      "Vergiftung durch Schlafmittel",
      "Vergiftung durch Schlaftabletten",
      "Vergiftung durch Schlaftrunk"
    ]
  },
  {
    "code": "T42.8",
    "name": "Vergiftung durch Amantadin",
    "synonyms": [
      "Vergiftung durch Amantadin",
      "Vergiftung durch Anti-Parkinsonmittel"
    ]
  },
  {
    "code": "T43.0",
    "name": "Vergiftung durch tetrazyklische Antidepressiva",
    "synonyms": [
      "Akute Vergiftung durch trizyklische Antidepressiva",
      "Vergiftung durch tetrazyklische Antidepressiva",
      "Vergiftung durch trizyklische Antidepressiva"
    ]
  },
  {
    "code": "T43.1",
    "name": "Vergiftung durch Monoaminooxidase-hemmende Antidepressiva",
    "synonyms": [
      "Vergiftung durch Monoaminooxidase-hemmende Antidepressiva"
    ]
  },
  {
    "code": "T43.2",
    "name": "Vergiftung durch Antidepressiva",
    "synonyms": [
      "Vergiftung durch Antidepressiva"
    ]
  },
  {
    "code": "T43.3",
    "name": "Clozapinvergiftung",
    "synonyms": [
      "Clozapinvergiftung"
    ]
  },
  {
    "code": "T43.5",
    "name": "Vergiftung durch Meprobamat",
    "synonyms": [
      "Intoxikation durch Neuroleptika",
      "Vergiftung durch Meprobamat",
      "Vergiftung durch Neuroleptika",
      "Vergiftung durch Tranquilizer"
    ]
  },
  {
    "code": "T43.8",
    "name": "Lithium-Vergiftung",
    "synonyms": [
      "Lithium-Vergiftung"
    ]
  },
  {
    "code": "T43.9",
    "name": "Akute Psychopharmakavergiftung",
    "synonyms": [
      "Akute Psychopharmakavergiftung"
    ]
  },
  {
    "code": "T44.0",
    "name": "Vergiftung durch Cholinesterase-Hemmer",
    "synonyms": [
      "Vergiftung durch Cholinesterase-Hemmer"
    ]
  },
  {
    "code": "T44.1",
    "name": "Vergiftung durch Parasympathomimetika",
    "synonyms": [
      "Akutes cholinerges Syndrom",
      "Vergiftung durch Parasympathomimetika"
    ]
  },
  {
    "code": "T44.3",
    "name": "Atropinvergiftung",
    "synonyms": [
      "Anticholinerges Delir",
      "Anticholinerges Syndrom",
      "Atropinvergiftung",
      "Intoxikation durch Spasmolytika",
      "Vergiftung durch Papaverin"
    ]
  },
  {
    "code": "T44.4",
    "name": "Vergiftung durch Metaraminol",
    "synonyms": [
      "Vergiftung durch Metaraminol"
    ]
  },
  {
    "code": "T44.9",
    "name": "Vergiftung durch kombinierte Alpha- und Beta-Rezeptoren-Stimulanzien",
    "synonyms": [
      "Vergiftung durch kombinierte Alpha- und Beta-Rezeptoren-Stimulanzien"
    ]
  },
  {
    "code": "T45.0",
    "name": "Vergiftung durch Antiallergika",
    "synonyms": [
      "Vergiftung durch Antiallergika",
      "Vergiftung durch Antiemetika"
    ]
  },
  {
    "code": "T45.1",
    "name": "Bleomycinlunge",
    "synonyms": [
      "5-Fluorouracil-Vergiftung",
      "Bleomycinlunge",
      "Methotrexat-Vergiftung",
      "Vergiftung durch Cytarabin",
      "Vergiftung durch antineoplastische Antibiotika",
      "Zytostatikaschaden"
    ]
  },
  {
    "code": "T45.2",
    "name": "Hypervitaminose A durch plötzliche Überdosis",
    "synonyms": [
      "Hypervitaminose A durch plötzliche Überdosis",
      "Hypervitaminose D durch plötzliche Überdosis"
    ]
  },
  {
    "code": "T45.4",
    "name": "Vergiftung durch Eisen",
    "synonyms": [
      "Vergiftung durch Eisen",
      "Vergiftung durch Eisenverbindungen"
    ]
  },
  {
    "code": "T45.5",
    "name": "Vergiftung durch Antikoagulanzien",
    "synonyms": [
      "Vergiftung durch Antikoagulanzien",
      "Vergiftung durch Cumarin"
    ]
  },
  {
    "code": "T45.7",
    "name": "Hypervitaminose von Vitamin K durch Überdosis",
    "synonyms": [
      "Hypervitaminose von Vitamin K durch Überdosis"
    ]
  },
  {
    "code": "T45.8",
    "name": "Vergiftung durch ein Blutprodukt",
    "synonyms": [
      "Vergiftung durch Antianämika",
      "Vergiftung durch Leberextrakt",
      "Vergiftung durch ein Blutprodukt",
      "Vergiftung durch ein Plasmaersatzmittel"
    ]
  },
  {
    "code": "T46.0",
    "name": "Digitalisintoxikation",
    "synonyms": [
      "Digitalisintoxikation",
      "Digitalisvergiftung"
    ]
  },
  {
    "code": "T46.1",
    "name": "Vergiftung durch Kalziumantagonisten",
    "synonyms": [
      "Vergiftung durch Kalziumantagonisten"
    ]
  },
  {
    "code": "T46.3",
    "name": "Vergiftung durch Dipyridamol",
    "synonyms": [
      "Vergiftung durch Dipyridamol"
    ]
  },
  {
    "code": "T46.5",
    "name": "Vergiftung durch Clonidin",
    "synonyms": [
      "Vergiftung durch Clonidin",
      "Vergiftung durch Guanethidin",
      "Vergiftung durch ein Rauwolfiaalkaloid"
    ]
  },
  {
    "code": "T46.7",
    "name": "Vergiftung durch periphere Vasodilatatoren",
    "synonyms": [
      "Vergiftung durch Nikotinsäure",
      "Vergiftung durch ein Nikotinsäurederivat",
      "Vergiftung durch periphere Vasodilatatoren"
    ]
  },
  {
    "code": "T46.9",
    "name": "Herzrhythmusstörung durch medikamentöse Nebenwirkung",
    "synonyms": [
      "Herzrhythmusstörung durch medikamentöse Nebenwirkung"
    ]
  },
  {
    "code": "T47.0",
    "name": "Vergiftung durch Histamin-H2-Rezeptorenblocker",
    "synonyms": [
      "Vergiftung durch Histamin-H2-Rezeptorenblocker"
    ]
  },
  {
    "code": "T47.2",
    "name": "Vergiftung durch stimulierende Laxanzien",
    "synonyms": [
      "Vergiftung durch stimulierende Laxanzien"
    ]
  },
  {
    "code": "T47.4",
    "name": "Vergiftung durch ein Darmatonie-Arzneimittel",
    "synonyms": [
      "Vergiftung durch ein Darmatonie-Arzneimittel"
    ]
  },
  {
    "code": "T47.5",
    "name": "Vergiftung durch Digestiva",
    "synonyms": [
      "Vergiftung durch Digestiva"
    ]
  },
  {
    "code": "T47.6",
    "name": "Vergiftung durch Antidiarrhoika",
    "synonyms": [
      "Vergiftung durch Antidiarrhoika"
    ]
  },
  {
    "code": "T47.7",
    "name": "Vergiftung durch Emetika",
    "synonyms": [
      "Vergiftung durch Emetika"
    ]
  },
  {
    "code": "T48.0",
    "name": "Vergiftung durch Oxytozin",
    "synonyms": [
      "Vergiftung durch Oxytozin"
    ]
  },
  {
    "code": "T48.1",
    "name": "Vergiftung durch Muskelrelaxanzien",
    "synonyms": [
      "Vergiftung durch Muskelrelaxanzien",
      "Vergiftung durch neuromuskuläre Blocker"
    ]
  },
  {
    "code": "T48.3",
    "name": "Vergiftung durch Antitussiva",
    "synonyms": [
      "Vergiftung durch Antitussiva"
    ]
  },
  {
    "code": "T48.4",
    "name": "Vergiftung durch Expektoranzien",
    "synonyms": [
      "Vergiftung durch Expektoranzien"
    ]
  },
  {
    "code": "T48.6",
    "name": "Vergiftung durch Salbutamol",
    "synonyms": [
      "Vergiftung durch Salbutamol"
    ]
  },
  {
    "code": "T49.1",
    "name": "Vergiftung durch Antipruriginosa",
    "synonyms": [
      "Vergiftung durch Antipruriginosa"
    ]
  },
  {
    "code": "T49.5",
    "name": "Vergiftung durch Ophthalmika",
    "synonyms": [
      "Vergiftung durch Ophthalmika",
      "Vergiftung durch ein Augen-Antiinfektivum"
    ]
  },
  {
    "code": "T49.6",
    "name": "Vergiftung durch ein Ohr-Antiinfektivum",
    "synonyms": [
      "Vergiftung durch ein Nasen-Antiinfektivum",
      "Vergiftung durch ein Ohr-Antiinfektivum",
      "Vergiftung durch ein Rachen-Antiinfektivum"
    ]
  },
  {
    "code": "T49.7",
    "name": "Amalgamintoxikation",
    "synonyms": [
      "Amalgamintoxikation",
      "Amalgamvergiftung"
    ]
  },
  {
    "code": "T49.8",
    "name": "Vergiftung durch ein Glukokortikoid bei topischer Anwendung",
    "synonyms": [
      "Vergiftung durch ein Glukokortikoid bei topischer Anwendung",
      "Vergiftung durch ein Spermizid"
    ]
  },
  {
    "code": "T50.0",
    "name": "Vergiftung durch Mineralokortikosteroide",
    "synonyms": [
      "Vergiftung durch Mineralokortikosteroide"
    ]
  },
  {
    "code": "T50.1",
    "name": "Vergiftung durch Schleifendiuretika",
    "synonyms": [
      "Vergiftung durch High-ceiling-Diuretika",
      "Vergiftung durch Schleifendiuretika"
    ]
  },
  {
    "code": "T50.2",
    "name": "Vergiftung durch Azetazolamid",
    "synonyms": [
      "Vergiftung durch Azetazolamid"
    ]
  },
  {
    "code": "T50.3",
    "name": "Vergiftung durch ein Salz zur oralen Rehydratation",
    "synonyms": [
      "Vergiftung durch ein Salz zur oralen Rehydratation"
    ]
  },
  {
    "code": "T50.4",
    "name": "Vergiftung durch ein Urikostatikum",
    "synonyms": [
      "Colchizin-Vergiftung",
      "Vergiftung durch ein Urikostatikum",
      "Vergiftung durch ein Urikosurikum"
    ]
  },
  {
    "code": "T50.5",
    "name": "Vergiftung durch Appetitzügler",
    "synonyms": [
      "Vergiftung durch Appetitzügler"
    ]
  },
  {
    "code": "T50.6",
    "name": "Vergiftung durch ein Alkoholentwöhnungsmittel",
    "synonyms": [
      "Vergiftung durch ein Alkoholentwöhnungsmittel"
    ]
  },
  {
    "code": "T50.8",
    "name": "Vergiftung durch Diagnostika",
    "synonyms": [
      "Vergiftung durch Diagnostika"
    ]
  },
  {
    "code": "T50.9",
    "name": "Tablettenintoxikation",
    "synonyms": [
      "Akute Vergiftung durch membranstabilisierende Arzneimittel",
      "Arzneimittelintoxikation",
      "Arzneimittelvergiftung",
      "Arzneimittelüberdosierung",
      "Medikamentenintoxikation",
      "Medikamentenvergiftung",
      "Medikamentenvergiftung durch Überdosis",
      "Reaktion durch Arzneimittelvergiftung",
      "Reaktion durch Arzneimittelüberdosis",
      "Tabletteningestion",
      "Tablettenintoxikation",
      "Tablettenvergiftung",
      "Vergiftung durch Drogen",
      "Vergiftung durch Impfstoff",
      "Vergiftung durch Letrozol",
      "Vergiftung durch Pharmaka",
      "Vergiftung durch ein Immunglobulin",
      "Vergiftung durch ein Nebenschilddrüsenhormon",
      "Vergiftung durch ein Nebenschilddrüsenhormonderivat",
      "Vergiftung durch ein alkalisierendes Arzneimittel",
      "Vergiftung durch ein ansäuerndes Arzneimittel",
      "Vergiftung durch ein lipotropes Arzneimittel",
      "Vergiftung durch eine biologisch aktive Substanz",
      "Vergiftung durch eine immunologisch wirksame Substanz",
      "Überdosierung",
      "Überdosis"
    ]
  },
  {
    "code": "T51.0",
    "name": "Toxische Wirkung von Äthanol",
    "synonyms": [
      "Toxische Wirkung von Äthanol",
      "Toxische Wirkung von Äthylalkohol",
      "Äthanolintoxikation",
      "Äthanolvergiftung"
    ]
  },
  {
    "code": "T51.1",
    "name": "Toxische Wirkung von Methanol",
    "synonyms": [
      "Toxische Wirkung von Methanol",
      "Toxische Wirkung von Methylalkohol",
      "Vergiftung durch Methanol"
    ]
  },
  {
    "code": "T51.2",
    "name": "Toxische Wirkung von 2-Propanol",
    "synonyms": [
      "Toxische Wirkung von 2-Propanol",
      "Toxische Wirkung von Isopropylalkohol"
    ]
  },
  {
    "code": "T51.3",
    "name": "Toxische Wirkung von Fuselöl",
    "synonyms": [
      "Toxische Wirkung von 1-Butanol",
      "Toxische Wirkung von 1-Propanol",
      "Toxische Wirkung von Amylalkohol",
      "Toxische Wirkung von Butylalkohol",
      "Toxische Wirkung von Fuselöl",
      "Toxische Wirkung von Propylalkohol"
    ]
  },
  {
    "code": "T51.9",
    "name": "Toxische Wirkung von Alkohol",
    "synonyms": [
      "Alkoholintoxikation",
      "Alkoholintoxikation mit Tablettenintoxikation",
      "Alkoholvergiftung",
      "Alkoholvergiftung mit Tablettenvergiftung",
      "Gasping-Syndrom",
      "Intoxikation durch Tabletten und Alkohol",
      "Toxische Wirkung von Alkohol"
    ]
  },
  {
    "code": "T52.0",
    "name": "Toxische Wirkung von Erdölprodukten",
    "synonyms": [
      "Toxische Wirkung von Benzin",
      "Toxische Wirkung von Erdölprodukten",
      "Toxische Wirkung von Kerosin",
      "Toxische Wirkung von Paraffin",
      "Toxische Wirkung von Paraffinöl",
      "Toxische Wirkung von Petroläther"
    ]
  },
  {
    "code": "T52.1",
    "name": "Benzolvergiftung",
    "synonyms": [
      "Benzolvergiftung",
      "Toxische Wirkung von Benzol"
    ]
  },
  {
    "code": "T52.2",
    "name": "Toxische Wirkung von Benzol-Homologen",
    "synonyms": [
      "Toxische Wirkung von Benzol-Homologen",
      "Toxische Wirkung von Dimethylbenzol",
      "Toxische Wirkung von Methylbenzol",
      "Toxische Wirkung von Toluol",
      "Toxische Wirkung von Xylol"
    ]
  },
  {
    "code": "T52.3",
    "name": "Toxische Wirkung von Glykol",
    "synonyms": [
      "Toxische Wirkung von Ethylenglykol",
      "Toxische Wirkung von Glykol"
    ]
  },
  {
    "code": "T52.4",
    "name": "Toxische Wirkung von Ketonen",
    "synonyms": [
      "Toxische Wirkung von Ketonen"
    ]
  },
  {
    "code": "T53.0",
    "name": "Toxische Wirkung von Tetrachlorkohlenstoff",
    "synonyms": [
      "Toxische Wirkung von Tetrachlorkohlenstoff",
      "Toxische Wirkung von Tetrachlormethan"
    ]
  },
  {
    "code": "T53.1",
    "name": "Chloroformvergiftung",
    "synonyms": [
      "Chloroformintoxikation",
      "Chloroformvergiftung",
      "Toxische Wirkung von Chloroform",
      "Toxische Wirkung von Trichlormethan",
      "Trichlormethanintoxikation",
      "Trichlormethanvergiftung"
    ]
  },
  {
    "code": "T53.2",
    "name": "Toxische Wirkung von Trichloräthylen",
    "synonyms": [
      "Toxische Wirkung von Trichloräthen",
      "Toxische Wirkung von Trichloräthylen"
    ]
  },
  {
    "code": "T53.3",
    "name": "Toxische Wirkung von Tetrachloräthylen",
    "synonyms": [
      "Toxische Wirkung von Perchloräthylen",
      "Toxische Wirkung von Tetrachloräthen",
      "Toxische Wirkung von Tetrachloräthylen"
    ]
  },
  {
    "code": "T53.4",
    "name": "Toxische Wirkung von Dichlormethan",
    "synonyms": [
      "Toxische Wirkung von Dichlormethan",
      "Toxische Wirkung von Methylenchlorid"
    ]
  },
  {
    "code": "T53.5",
    "name": "Toxische Wirkung von Fluorchlorkohlenwasserstoffen",
    "synonyms": [
      "Toxische Wirkung von FCKW [Fluorchlorkohlenwasserstoffe]",
      "Toxische Wirkung von Fluorchlorkohlenwasserstoffen",
      "Vergiftung durch Fluorchlorkohlenwasserstoffe"
    ]
  },
  {
    "code": "T54.0",
    "name": "Toxische Wirkung von Phenol-Homologen",
    "synonyms": [
      "Toxische Wirkung von Phenol",
      "Toxische Wirkung von Phenol-Homologen"
    ]
  },
  {
    "code": "T54.2",
    "name": "Oxalsäurevergiftung",
    "synonyms": [
      "Oxalsäureintoxikation",
      "Oxalsäurevergiftung",
      "Phosphornekrose",
      "Toxische Wirkung von Salzsäure",
      "Toxische Wirkung von Schwefelsäure"
    ]
  },
  {
    "code": "T54.3",
    "name": "Toxische Wirkung von Kaliumhydroxid",
    "synonyms": [
      "Toxische Wirkung von Kaliumhydroxid",
      "Toxische Wirkung von Natriumhydroxid"
    ]
  },
  {
    "code": "T54.9",
    "name": "Toxische Wirkung einer ätzenden Substanz",
    "synonyms": [
      "Exposition gegenüber Säure",
      "Toxische Wirkung einer ätzenden Substanz"
    ]
  },
  {
    "code": "T55",
    "name": "Toxische Seifenwirkung",
    "synonyms": [
      "Spülmittelvergiftung",
      "Toxische Detergenzienwirkung",
      "Toxische Seifenwirkung",
      "Vergiftung durch Seife"
    ]
  },
  {
    "code": "T56.0",
    "name": "Bleilähmung",
    "synonyms": [
      "Bleienzephalopathie",
      "Bleiintoxikation",
      "Bleikolik",
      "Bleilähmung",
      "Bleiparalyse",
      "Bleivergiftung",
      "Cachexia saturnina",
      "Colica saturnina a.n.k.",
      "Encephalopathia saturnina",
      "Kachexie durch Blei",
      "Paralysis saturnina",
      "Saturnismus",
      "Toxische Wirkung von Blei",
      "Toxische Wirkung von Bleiverbindungen"
    ]
  },
  {
    "code": "T56.1",
    "name": "Selter-Swift-Feer-Syndrom",
    "synonyms": [
      "Akrodynie",
      "Akrodynie infolge frühkindlicher Quecksilbervergiftung",
      "Dermatopolyneuritis",
      "Erythrödem",
      "Feer-Krankheit",
      "Hydrargyrosis a.n.k.",
      "Merkurialismus a.n.k.",
      "Minamata-Krankheit",
      "Pink disease",
      "Polyneuritis bei Feer-Krankheit",
      "Polyneuropathisches Erythrödem",
      "Quecksilbervergiftung",
      "Rosa-Krankheit",
      "Selter-Swift-Feer-Krankheit",
      "Selter-Swift-Feer-Syndrom",
      "Swift-Feer-Krankheit",
      "Toxische Wirkung von Quecksilber",
      "Toxische Wirkung von Quecksilberverbindungen",
      "Tremor durch Quecksilber",
      "Tremor durch Quecksilberverbindungen",
      "Trophodermatoneurose"
    ]
  },
  {
    "code": "T56.2",
    "name": "Chromatvergiftung",
    "synonyms": [
      "Chromatvergiftung"
    ]
  },
  {
    "code": "T56.3",
    "name": "Itai-Itai-Krankheit",
    "synonyms": [
      "Itai-Itai-Krankheit"
    ]
  },
  {
    "code": "T56.4",
    "name": "Kupfervergiftung",
    "synonyms": [
      "Kupfervergiftung"
    ]
  },
  {
    "code": "T56.5",
    "name": "Gießerfieber",
    "synonyms": [
      "Gießerfieber"
    ]
  },
  {
    "code": "T56.8",
    "name": "Argyrie",
    "synonyms": [
      "Antimon-Cholera",
      "Argyrie",
      "Argyrose",
      "Fieber durch Metalldampf",
      "Kupferschmied-Krankheit",
      "Silbervergiftung",
      "Thalliumvergiftung",
      "Toxische Wirkung von Thallium"
    ]
  },
  {
    "code": "T56.9",
    "name": "Toxische Wirkung von Metallen",
    "synonyms": [
      "Schwermetallvergiftung",
      "Toxische Wirkung von Metalldampf",
      "Toxische Wirkung von Metallen",
      "Toxische Wirkung von Metallrauch"
    ]
  },
  {
    "code": "T57.0",
    "name": "Arsenvergiftung",
    "synonyms": [
      "Arsenvergiftung"
    ]
  },
  {
    "code": "T57.2",
    "name": "Manganvergiftung",
    "synonyms": [
      "Manganvergiftung",
      "Toxische Wirkung von Mangan",
      "Toxische Wirkung von Manganverbindungen"
    ]
  },
  {
    "code": "T57.3",
    "name": "Blausäurevergiftung",
    "synonyms": [
      "Blausäureintoxikation",
      "Blausäurevergiftung",
      "Toxische Wirkung von Blausäure"
    ]
  },
  {
    "code": "T57.8",
    "name": "Intoxikation durch Selen",
    "synonyms": [
      "Intoxikation durch Selen"
    ]
  },
  {
    "code": "T58",
    "name": "Toxische Wirkung von Kohlenmonoxid",
    "synonyms": [
      "Asphyxie durch Kohlenmonoxid",
      "Inhalation von Kohlenmonoxid",
      "Kohlenoxidhämoglobin",
      "Leuchtgasvergiftung",
      "Toxische Wirkung von Kohlenmonoxid"
    ]
  },
  {
    "code": "T59.0",
    "name": "Toxische Wirkung von Stickstoffoxiden",
    "synonyms": [
      "Toxische Wirkung von Stickstoffoxiden"
    ]
  },
  {
    "code": "T59.1",
    "name": "Toxische Wirkung von Schwefeldioxid",
    "synonyms": [
      "Toxische Wirkung von Schwefeldioxid"
    ]
  },
  {
    "code": "T59.2",
    "name": "Toxische Wirkung von Formaldehyd",
    "synonyms": [
      "Toxische Wirkung von Formaldehyd"
    ]
  },
  {
    "code": "T59.3",
    "name": "Toxische Wirkung von Tränengas",
    "synonyms": [
      "Toxische Wirkung von Tränengas"
    ]
  },
  {
    "code": "T59.4",
    "name": "Toxische Wirkung von Chlorgas",
    "synonyms": [
      "Toxische Wirkung von Chlorgas"
    ]
  },
  {
    "code": "T59.5",
    "name": "Toxische Fluorgaswirkung",
    "synonyms": [
      "Toxische Fluorgaswirkung",
      "Toxische Fluorwasserstoffwirkung"
    ]
  },
  {
    "code": "T59.6",
    "name": "Toxische Wirkung von Schwefelwasserstoff",
    "synonyms": [
      "Toxische Wirkung von Schwefelwasserstoff"
    ]
  },
  {
    "code": "T59.7",
    "name": "Toxische Wirkung von Kohlendioxid",
    "synonyms": [
      "Toxische Wirkung von Kohlendioxid"
    ]
  },
  {
    "code": "T59.8",
    "name": "Gärgasvergiftung",
    "synonyms": [
      "Fieber durch Polyesterdämpfe",
      "Gärgasintoxikation",
      "Gärgasvergiftung",
      "Hyperoxie",
      "Phosgen-Vergiftung",
      "Toxische Wirkung von Aerosol-Treibgas"
    ]
  },
  {
    "code": "T59.9",
    "name": "Gasvergiftung a.n.k.",
    "synonyms": [
      "Asphyxie durch Dampf",
      "Asphyxie durch Gas a.n.k.",
      "Asphyxie durch Rauch",
      "Erstickung durch Gas a.n.k.",
      "Gasintoxikation",
      "Gasvergiftung a.n.k.",
      "Inhalation von Gas a.n.k.",
      "Inhalation von Rauch a.n.k.",
      "Rauchintoxikation",
      "Rauchvergiftung",
      "Toxische Wirkung von Dampf",
      "Toxische Wirkung von Gas",
      "Toxische Wirkung von Rauch"
    ]
  },
  {
    "code": "T60.0",
    "name": "Toxische Wirkung von Organophosphat- und Carbamat-Insektiziden",
    "synonyms": [
      "Toxische Wirkung von Organophosphat- und Carbamat-Insektiziden"
    ]
  },
  {
    "code": "T60.1",
    "name": "Toxische Wirkung von halogenierten Insektiziden",
    "synonyms": [
      "Intoxikation durch Methylbromid",
      "Toxische Wirkung von halogenierten Insektiziden"
    ]
  },
  {
    "code": "T60.2",
    "name": "Vergiftung durch Insektizide",
    "synonyms": [
      "Vergiftung durch Insektizide"
    ]
  },
  {
    "code": "T60.3",
    "name": "Toxische Wirkung von Herbiziden",
    "synonyms": [
      "Paraquat-Vergiftung",
      "Systemische Monochloracetat-Vergiftung",
      "Toxische Wirkung von Fungiziden",
      "Toxische Wirkung von Herbiziden",
      "Vergiftung durch Chlorat"
    ]
  },
  {
    "code": "T60.4",
    "name": "Toxische Wirkung von Rodentiziden",
    "synonyms": [
      "Toxische Wirkung von Rodentiziden"
    ]
  },
  {
    "code": "T60.9",
    "name": "Toxische Wirkung von Holzschutzmitteln",
    "synonyms": [
      "Holzschutzmittel-Syndrom",
      "Toxische Wirkung von Holzschutzmitteln",
      "Vergiftung durch Biozide",
      "Vergiftung durch Holzschutzmittel",
      "Vergiftung durch Pestizide"
    ]
  },
  {
    "code": "T61.0",
    "name": "Ciguatera-Fischvergiftung",
    "synonyms": [
      "Ciguatera-Fischvergiftung",
      "Ichthyismus durch Ciguatera"
    ]
  },
  {
    "code": "T61.1",
    "name": "Scombroid-Fischvergiftung",
    "synonyms": [
      "Histaminähnliches Syndrom",
      "Ichthyismus durch Scombroid",
      "Scombroid-Fischvergiftung"
    ]
  },
  {
    "code": "T61.2",
    "name": "Ichthyismus",
    "synonyms": [
      "Epidemische Fischvergiftung",
      "Fischvergiftung",
      "Haffkrankheit",
      "Ichthyismus",
      "Ichthyismus durch Schalentiere a.n.k.",
      "Mytilotoxismus",
      "Vergiftung durch verdorbene Muscheln",
      "Vergiftung durch verdorbene Schalentiere"
    ]
  },
  {
    "code": "T61.8",
    "name": "Ichthyismus durch essbare Meerestiere a.n.k.",
    "synonyms": [
      "Ichthyismus durch essbare Meerestiere a.n.k."
    ]
  },
  {
    "code": "T61.9",
    "name": "Vergiftung durch essbares Meerestier",
    "synonyms": [
      "Vergiftung durch essbares Meerestier"
    ]
  },
  {
    "code": "T62.0",
    "name": "Toxische Wirkung von verzehrten Pilzen",
    "synonyms": [
      "Myzetismus",
      "Toxische Wirkung von verzehrten Pilzen",
      "Vergiftung durch giftige Pilze"
    ]
  },
  {
    "code": "T62.1",
    "name": "Toxische Wirkung von verzehrten Beeren",
    "synonyms": [
      "Toxische Wirkung von verzehrten Beeren",
      "Vergiftung durch giftige Beeren",
      "Vergiftung durch verdorbene Beeren"
    ]
  },
  {
    "code": "T62.2",
    "name": "Toxische Wirkung von Giftpflanzen",
    "synonyms": [
      "Akute Akee-Frucht-Vergiftung",
      "Ergotismus",
      "Exogene spastische Spinalparalyse",
      "Jake-Paralyse",
      "Lathyrismus",
      "Lathyrismus-Syndrom",
      "Neurolathyrismus",
      "Rizinismus",
      "Toxische Wirkung von Giftpflanzen",
      "Vergiftung durch Rizin",
      "Vergiftung durch giftige Pflanzen"
    ]
  },
  {
    "code": "T62.8",
    "name": "Milk sickness",
    "synonyms": [
      "Milk sickness",
      "Toxic-oil-Syndrom"
    ]
  },
  {
    "code": "T62.9",
    "name": "Nahrungsmittelvergiftung",
    "synonyms": [
      "Ingestions-Unfall",
      "Lebensmittelvergiftung",
      "Nahrungsmittelvergiftung",
      "Vergiftung durch Ptomaine",
      "Vergiftung durch Wurst",
      "Vergiftung durch ein giftiges Nahrungsmittel",
      "Vergiftung durch ein verdorbenes Nahrungsmittel",
      "Vergiftung durch schlechtes Fleisch",
      "Wirkung eines giftigen Nahrungsmittels"
    ]
  },
  {
    "code": "T63.0",
    "name": "Toxische Wirkung von Schlangengift",
    "synonyms": [
      "Biss durch giftige Seeschlange",
      "Schlangenbiss",
      "Toxische Wirkung von Schlangengift",
      "Toxische Wirkung von Seeschlangengift",
      "Vergiftung durch Schlangenbiss",
      "Vergiftung durch Seeschlangenbiss",
      "Vergiftung durch Seeschlangenstich"
    ]
  },
  {
    "code": "T63.1",
    "name": "Biss durch giftige Echse",
    "synonyms": [
      "Biss durch Reptil a.n.k.",
      "Biss durch giftige Echse",
      "Toxische Wirkung von Echsengift",
      "Vergiftung durch Echsenbiss",
      "Vergiftung durch Reptilbiss a.n.k."
    ]
  },
  {
    "code": "T63.2",
    "name": "Toxische Wirkung von Skorpiongift",
    "synonyms": [
      "Biss durch Skorpion",
      "Stich durch Skorpion",
      "Toxische Wirkung von Skorpiongift",
      "Vergiftung durch Skorpionstiche"
    ]
  },
  {
    "code": "T63.3",
    "name": "Toxische Wirkung von Spinnengift",
    "synonyms": [
      "Arachnidismus",
      "Latrodektismus-Syndrom",
      "Toxische Wirkung von Spinnengift"
    ]
  },
  {
    "code": "T63.4",
    "name": "Wespenstich",
    "synonyms": [
      "Bienenstich",
      "Biss durch Arthropoden a.n.k.",
      "Biss durch Tausendfüßler",
      "Biss durch giftiges Insekt",
      "Paralyse durch Zeckenbiss",
      "Stich durch Arthropoden a.n.k.",
      "Stich durch giftiges Insekt a.n.k.",
      "Toxische Wirkung eines giftigen Insektenbisses",
      "Toxische Wirkung eines giftigen Insektenstiches",
      "Vergiftung durch Arthropodenbiss a.n.k.",
      "Vergiftung durch Arthropodenstich a.n.k.",
      "Vergiftung durch giftiges Insekt a.n.k.",
      "Wespenstich"
    ]
  },
  {
    "code": "T63.6",
    "name": "Vergiftung durch Quallen",
    "synonyms": [
      "Biss durch giftiges Meerestier a.n.k.",
      "Toxische Wirkung durch Kontakt mit einem Schalentier",
      "Toxische Wirkung durch Kontakt mit einem Seestern",
      "Toxische Wirkung durch Kontakt mit einer Qualle",
      "Toxische Wirkung durch Kontakt mit einer Seeanemone",
      "Vergiftung durch Biss einer Seeanemone",
      "Vergiftung durch Biss eines Meerestiers a.n.k.",
      "Vergiftung durch Biss eines Schalentiers",
      "Vergiftung durch Quallen",
      "Vergiftung durch Stich einer Seeanemone",
      "Vergiftung durch Stich eines Meerestiers a.n.k.",
      "Vergiftung durch Stich eines Schalentiers",
      "Vergiftung durch Stich eines Seesterns"
    ]
  },
  {
    "code": "T63.8",
    "name": "Biss durch giftige Amphibie",
    "synonyms": [
      "Biss durch giftige Amphibie",
      "Toxische Wirkung von Amphibiengift"
    ]
  },
  {
    "code": "T63.9",
    "name": "Giftiger Biss",
    "synonyms": [
      "Giftiger Biss",
      "Giftiger Tierbiss",
      "Vergiftung durch Biss",
      "Vergiftung durch Stich"
    ]
  },
  {
    "code": "T65.0",
    "name": "Toxische Wirkung von Zyaniden",
    "synonyms": [
      "Toxische Wirkung von Zyaniden",
      "Vergiftungen durch Nitrile",
      "Zyanid-Vergiftung"
    ]
  },
  {
    "code": "T65.1",
    "name": "Toxische Wirkung von Strychnin",
    "synonyms": [
      "Toxische Wirkung von Strychnin",
      "Toxische Wirkung von Strychninsalz"
    ]
  },
  {
    "code": "T65.2",
    "name": "Toxische Wirkung von Tabak",
    "synonyms": [
      "Tabakose",
      "Tabakvergiftung",
      "Toxische Wirkung von Nikotin",
      "Toxische Wirkung von Tabak",
      "Zigaretteningestion"
    ]
  },
  {
    "code": "T65.3",
    "name": "Toxische Wirkung von Aminobenzol",
    "synonyms": [
      "Toxische Wirkung von Aminobenzol",
      "Toxische Wirkung von Anilin",
      "Toxische Wirkung von Nitrobenzol",
      "Toxische Wirkung von Trinitrotoluol"
    ]
  },
  {
    "code": "T65.4",
    "name": "Toxische Wirkung von Schwefelkohlenstoff",
    "synonyms": [
      "Toxische Wirkung von Schwefelkohlenstoff"
    ]
  },
  {
    "code": "T65.5",
    "name": "Toxische Wirkung von 1-Propantriol",
    "synonyms": [
      "Toxische Wirkung von 1-Propantriol",
      "Toxische Wirkung von 2-Propantriol",
      "Toxische Wirkung von 3-Propantriol",
      "Toxische Wirkung von Trinitrat"
    ]
  },
  {
    "code": "T65.6",
    "name": "Vergiftung durch Farbe",
    "synonyms": [
      "Vergiftung durch Farbe",
      "Vergiftung durch Farbstoffe"
    ]
  },
  {
    "code": "T65.8",
    "name": "Wismutvergiftung",
    "synonyms": [
      "Intoxikation durch Acrylnitril",
      "Intoxikation durch Methacrylnitril",
      "Vergiftung durch Düngemittel",
      "Vergiftung durch Klebstoff",
      "Wismutvergiftung"
    ]
  },
  {
    "code": "T65.9",
    "name": "Vergiftung durch nichtmedizinische Stoffe",
    "synonyms": [
      "Absorption einer chemischen Substanz",
      "Akute Vergiftung",
      "Chemikalienvergiftung",
      "Intoxikation - s.a. Vergiftung",
      "Intoxikation durch Chemikalie",
      "Schaden durch Vergiftung",
      "Toxische Wirkung einer chemischen Substanz a.n.k.",
      "Vergiftung",
      "Vergiftung durch nichtmedizinische Stoffe"
    ]
  },
  {
    "code": "T66",
    "name": "Radionekrose a.n.k.",
    "synonyms": [
      "Akute Strahlenkrankheit",
      "Bestrahlungsschaden",
      "Bestrahlungssyndrom",
      "Komplikation durch Radiotherapie a.n.k.",
      "Komplikation durch Strahlenbehandlung a.n.k.",
      "Komplikation durch Strahlung",
      "Radionekrose a.n.k.",
      "Radiumschädigung a.n.k.",
      "Schaden durch Röntgenstrahlen a.n.k.",
      "Schädliche Strahlenwirkung a.n.k.",
      "Schädliche Wirkung von Bestrahlung a.n.k.",
      "Schädliche Wirkung von Radium a.n.k.",
      "Schädliche Wirkung von Röntgenstrahlen a.n.k.",
      "Schädliche Wirkung von Teleröntgentherapie a.n.k.",
      "Schädliche Wirkung von radioaktivem Fallout a.n.k.",
      "Schädliche Wirkung von radioaktivem Niederschlag a.n.k.",
      "Schädliche Wirkung von radioaktiven Substanzen a.n.k.",
      "Strahlenfolgen",
      "Strahlenkrankheit a.n.k.",
      "Strahlenschaden a.n.k.",
      "Unerwünschte Reaktion auf Radiatio a.n.k.",
      "Unerwünschte Reaktion auf Röntgenstrahlen a.n.k.",
      "Unerwünschte Reaktion auf Ultraviolettstrahlen a.n.k.",
      "Unerwünschte Reaktion durch Nachbestrahlung a.n.k.",
      "Unerwünschte Strahlenreaktion a.n.k.",
      "Unerwünschte Wirkung der Fluoroskopie a.n.k.",
      "Unerwünschte Wirkung einer Radiotherapie a.n.k.",
      "Unerwünschte Wirkung einer Röntgenaufnahme a.n.k.",
      "Unerwünschte Wirkung einer Röntgendurchleuchtung a.n.k.",
      "Unerwünschte Wirkung einer Strahlentherapie a.n.k.",
      "Unerwünschte Wirkung einer Teleröntgentherapie a.n.k.",
      "Unerwünschte Wirkung einer radioaktiven Substanz a.n.k.",
      "Unerwünschte Wirkung radioaktiver Isotope a.n.k.",
      "Unerwünschte Wirkung von Bestrahlung a.n.k.",
      "Unerwünschte Wirkung von Infrarotstrahlen a.n.k.",
      "Unerwünschte Wirkung von Mesothorium a.n.k.",
      "Unerwünschte Wirkung von Polonium a.n.k.",
      "Unerwünschte Wirkung von Radioaktivität a.n.k.",
      "Unerwünschte Wirkung von Röntgenstrahlen a.n.k.",
      "Unerwünschte Wirkung von Ultraviolettstrahlen a.n.k.",
      "Unerwünschte Wirkung von Uran a.n.k.",
      "Unerwünschte Wirkung von radioaktivem Kobalt",
      "Unerwünschte Wirkung von radioaktivem Niederschlag a.n.k.",
      "Uranintoxikation",
      "Uranvergiftung",
      "Vergiftung mit transuranen Schwermetallnukliden",
      "Verletzung durch Bestrahlung a.n.k.",
      "Verletzung durch Infrarotstrahlen a.n.k.",
      "Verletzung durch Röntgenstrahlen a.n.k.",
      "Verletzung durch Ultraviolettstrahlen a.n.k.",
      "Zwischenfall bei Bestrahlung a.n.k.",
      "Zwischenfall bei Strahlentherapie a.n.k."
    ]
  },
  {
    "code": "T67.0",
    "name": "Hitzschlag",
    "synonyms": [
      "Atmosphärische Pyrexie",
      "Hitzeapoplexie",
      "Hitzefieber",
      "Hitzepyrexie",
      "Hitzschlag",
      "Hitzschlag mit Fieber",
      "Hyperpyrexie durch Hitze",
      "Ictus solaris",
      "Insolation",
      "Pyrexie durch Hitze",
      "Sonnenstich",
      "Thermoplegie"
    ]
  },
  {
    "code": "T67.1",
    "name": "Hitzekollaps",
    "synonyms": [
      "Hitzekollaps",
      "Hitzeohnmacht",
      "Hitzesynkope"
    ]
  },
  {
    "code": "T67.2",
    "name": "Hitzekrampf",
    "synonyms": [
      "Hitzekrampf",
      "Hitzetetanie"
    ]
  },
  {
    "code": "T67.3",
    "name": "Hitzeerschöpfung durch Wasserverlust",
    "synonyms": [
      "Anhydrotische Hitzeerschöpfung",
      "Hitzeerschöpfung durch Wasserverlust"
    ]
  },
  {
    "code": "T67.4",
    "name": "Hitzeerschöpfung durch Salzverlust",
    "synonyms": [
      "Hitzeerschöpfung durch Salzverlust",
      "Hitzeerschöpfung durch verminderten Natriumgehalt",
      "Hitzeerschöpfung durch verminderten Salzgehalt"
    ]
  },
  {
    "code": "T67.5",
    "name": "Hitzeerschöpfung",
    "synonyms": [
      "Hitzeerschöpfung"
    ]
  },
  {
    "code": "T67.6",
    "name": "Passagere Hitzeermüdung",
    "synonyms": [
      "Hitzeermüdung",
      "Hitzemüdigkeit",
      "Passagere Hitzeermüdung"
    ]
  },
  {
    "code": "T67.7",
    "name": "Hitzeödem",
    "synonyms": [
      "Hitzeödem"
    ]
  },
  {
    "code": "T67.8",
    "name": "Salzverlustsyndrom durch Hitze",
    "synonyms": [
      "Belastungsbedingter Hitzschlag",
      "Salzverlustsyndrom durch Hitze"
    ]
  },
  {
    "code": "T67.9",
    "name": "Hitzeschaden",
    "synonyms": [
      "Auswirkungen von Hitze",
      "Hitzeschaden",
      "Sonnenlichtschaden",
      "Wirkung von Hitze",
      "Wirkung von heißem Wetter",
      "Wirkung von überhitzten Stellen"
    ]
  },
  {
    "code": "T68",
    "name": "Hypothermie",
    "synonyms": [
      "Hypothermie",
      "Hypothermie durch Unfall",
      "Hypothermie durch niedrige Umgebungstemperatur",
      "Unfallbedingte Hypothermie",
      "Unterkühlung"
    ]
  },
  {
    "code": "T69.0",
    "name": "Schützengrabenfuß",
    "synonyms": [
      "Kälte-Nässe-Schaden der Füße",
      "Kälte-Nässe-Schaden der Hände",
      "Schützengrabenfuß",
      "Trench foot"
    ]
  },
  {
    "code": "T69.1",
    "name": "Pernio",
    "synonyms": [
      "Dermatitis congelationis",
      "Erythema a frigore",
      "Frostbeule",
      "Kälte-Erythem",
      "Pernio",
      "Pernioerythem",
      "Perniones"
    ]
  },
  {
    "code": "T69.8",
    "name": "Erschöpfung durch Kälte",
    "synonyms": [
      "Erschöpfung durch Kälte"
    ]
  },
  {
    "code": "T69.9",
    "name": "Kälte-Nässe-Schaden",
    "synonyms": [
      "Ausgesetztsein gegenüber Kälte",
      "Auswirkungen von Kälte",
      "Kälte-Nässe-Schaden",
      "Kälteschaden",
      "Kältetrauma",
      "Ungewöhnliche Schäden durch Kälte"
    ]
  },
  {
    "code": "T70.0",
    "name": "Aerootitis",
    "synonyms": [
      "Aerootitis",
      "Aerootitis media",
      "Barootitis",
      "Barotitis",
      "Barotrauma des Ohres",
      "Fliegerohr",
      "Luftdruckschaden des Ohres",
      "Ohrschaden durch Luftdruckwechsel",
      "Ohrschaden durch Wasserdruckwechsel",
      "Schwerhörigkeit durch Einwirkung großer Höhe auf die Ohren",
      "Taubheit durch Einwirkung großer Höhe auf die Ohren",
      "Wirkung großer Höhe auf die Ohren"
    ]
  },
  {
    "code": "T70.1",
    "name": "Barotrauma der Nasennebenhöhlen",
    "synonyms": [
      "Aerosinusitis",
      "Barosinusitis",
      "Barotrauma der Kieferhöhle",
      "Barotrauma der Nasennebenhöhlen",
      "Barotrauma der Stirnhöhle",
      "Fliegersinusitis",
      "Luftdruckschaden der Nasennebenhöhlen",
      "Nasennebenhöhlenschaden durch Luftdruckwechsel",
      "Sinusitis durch Barotrauma",
      "Wirkung großer Höhe auf die Nebenhöhlen"
    ]
  },
  {
    "code": "T70.2",
    "name": "Barodontalgie",
    "synonyms": [
      "Alpenkrankheit",
      "Anden-Krankheit",
      "Anoxie in großer Höhe",
      "Ballonfahrerkrankheit",
      "Ballonkrankheit",
      "Barodontalgie",
      "Barotrauma",
      "Barotrauma mit Odontalgie",
      "Bergkrankheit",
      "Fliegerkrankheit",
      "Hypobarismus",
      "Hypobaropathie",
      "Höhenkrankheit",
      "Luftdruckkrankheit",
      "Lungenödem durch große Höhe",
      "Monge-Krankheit",
      "Sauerstoffmangel in großer Höhe",
      "Unterdruckbeschwerden",
      "Wirkung von großer Höhe a.n.k."
    ]
  },
  {
    "code": "T70.3",
    "name": "Caisson-Krankheit",
    "synonyms": [
      "Aeroembolismus",
      "Caisson-Krankheit",
      "Dekompressionskrankheit",
      "Druckluftkrankheit",
      "Dysbarismus",
      "Paralyse durch Druckluft",
      "Taucher-Paralyse",
      "Taucherkrankheit",
      "Wirkung eines hohen atmosphärischer Drucks"
    ]
  },
  {
    "code": "T70.4",
    "name": "Schaden durch Hochdruckflüssigkeiten",
    "synonyms": [
      "Industriell bedingte Sprühinjektion",
      "Industrielle Hochdruck-Spritzverletzung",
      "Schaden durch Hochdruckflüssigkeiten",
      "Sprühinjektion",
      "Sprühinjektion durch Farblösungen",
      "Sprühinjektion durch Luft",
      "Sprühinjektion durch Wasser",
      "Wirkung von Hochdruckflüssigkeiten"
    ]
  },
  {
    "code": "T70.8",
    "name": "Verletzung durch Explosionsdruck a.n.k.",
    "synonyms": [
      "Explosionstrauma",
      "Generalisierte Verletzung durch Explosionsdruck",
      "Verletzung durch Explosionsdruck a.n.k.",
      "Verletzung mehrerer Organe durch Explosionsdruck",
      "Wirkung von atmosphärischem Druck durch Explosion"
    ]
  },
  {
    "code": "T70.9",
    "name": "Schaden durch Wasserdruck",
    "synonyms": [
      "Luftdruckschaden",
      "Schaden durch Wasserdruck",
      "Schaden durch eine Druckwelle",
      "Wirkung von Wasserdruck a.n.k.",
      "Wirkung von atmosphärischem Druck"
    ]
  },
  {
    "code": "T71",
    "name": "Erhängen",
    "synonyms": [
      "Asphyxie durch Bettzeug",
      "Asphyxie durch Druck",
      "Asphyxie durch Erhängen",
      "Asphyxie durch Konstriktion",
      "Asphyxie durch Strangulation",
      "Asphyxie durch Verschüttung",
      "Erhängen",
      "Erstickung",
      "Erstickung durch Abschnüren",
      "Erstickung durch Babytragetuch",
      "Erstickung durch Bettzeug",
      "Erstickung durch Druck",
      "Erstickung durch Erhängen",
      "Erstickung durch Konstriktion",
      "Erstickung durch Plastikhülle",
      "Erstickung durch Strangulation",
      "Erstickung durch Verschüttung",
      "Erstickungstod",
      "Gravitationsbedingte Asphyxie",
      "Mechanische Asphyxie",
      "Mechanische Erstickung",
      "Strangulation",
      "Systemischer Sauerstoffmangel",
      "Systemischer Sauerstoffmangel durch mechanische Atmungsbehinderung",
      "Systemischer Sauerstoffmangel durch niedrigen Sauerstoffgehalt der Umgebungsluft",
      "Traumatische Asphyxie a.n.k."
    ]
  },
  {
    "code": "T73.0",
    "name": "Schaden durch Hunger",
    "synonyms": [
      "Entkräftung durch Hunger",
      "Hunger",
      "Hunger durch Nahrungsmangel",
      "Hungern",
      "Hungertod",
      "Inanition durch Verhungern",
      "Nahrungsmangel",
      "Nahrungsmittelmangel",
      "Schaden durch Hunger",
      "Schaden durch Hungersnot",
      "Verhungern",
      "Wirkung von Hunger"
    ]
  },
  {
    "code": "T73.1",
    "name": "Schaden durch Durst",
    "synonyms": [
      "Durst durch Wassermangel",
      "Schaden durch Durst",
      "Schädigende Wirkung von Durst",
      "Schädigung durch Wassermangel",
      "Verdursten durch Wassermangel",
      "Wassermangel"
    ]
  },
  {
    "code": "T73.2",
    "name": "Erschöpfung durch Ausgesetztsein",
    "synonyms": [
      "Erschöpfung durch Ausgesetztsein",
      "Erschöpfung durch Witterungseinflüsse",
      "Erschöpfung durch klimatische Einflüsse"
    ]
  },
  {
    "code": "T73.3",
    "name": "Erschöpfung durch übermäßige Anstrengung",
    "synonyms": [
      "Erschöpfung durch Überanstrengung",
      "Erschöpfung durch übermäßige Anstrengung",
      "Schaden durch Überanstrengung",
      "Wirkung von übermäßiger Anstrengung",
      "Überanstrengung"
    ]
  },
  {
    "code": "T74.0",
    "name": "Imstichlassen",
    "synonyms": [
      "Aussetzen",
      "Aussetzen eines Neugeborenen",
      "Imstichlassen",
      "Malnutrition durch Vernachlässigung eines Kindes",
      "Malnutrition durch mangelnde Pflege eines Kindes",
      "Mangel an Pflege eines Kindes",
      "Mangelnde Betreuung eines Säuglings",
      "Vernachlässigung",
      "Vernachlässigung eines Kindes",
      "Vernachlässigung eines Neugeborenen",
      "Vernachlässigungssyndrom"
    ]
  },
  {
    "code": "T74.1",
    "name": "Körperlicher Missbrauch",
    "synonyms": [
      "Battered-child-Syndrom",
      "Ehegattenmisshandlung",
      "Ehegattenmisshandlungssyndrom",
      "Kindesmisshandlung",
      "Kindesmisshandlungssyndrom a.n.k.",
      "Körperliche Misshandlung durch Bekannten",
      "Körperliche Misshandlung durch Ehegatten",
      "Körperliche Misshandlung durch Eltern",
      "Körperliche Misshandlung durch Freund",
      "Körperliche Misshandlung durch Partner",
      "Körperlicher Missbrauch"
    ]
  },
  {
    "code": "T74.2",
    "name": "Sexueller Missbrauch",
    "synonyms": [
      "Sexueller Missbrauch",
      "Vergewaltigung"
    ]
  },
  {
    "code": "T74.3",
    "name": "Psychischer Missbrauch",
    "synonyms": [
      "Psychischer Missbrauch",
      "Psychogener Missbrauch",
      "Seelische Grausamkeit",
      "Verlust emotionaler Zuwendung beim Kleinkind",
      "Verlust soziale Beziehungen beim Kleinkind"
    ]
  },
  {
    "code": "T74.8",
    "name": "Mischform des Missbrauchs von Personen",
    "synonyms": [
      "Mischform des Missbrauchs von Personen"
    ]
  },
  {
    "code": "T74.9",
    "name": "Misshandlungssyndrom",
    "synonyms": [
      "Emotionale Kindesmisshandlung",
      "Emotionales Kindesmisshandlungssyndrom",
      "Ernährungsmäßiges Kindesmisshandlungssyndrom",
      "Kindesmisshandlung durch Unterernährung",
      "Misshandlung",
      "Misshandlungssyndrom",
      "Schaden durch Missbrauch beim Erwachsenen",
      "Schaden durch Missbrauch beim Kind"
    ]
  },
  {
    "code": "T75.0",
    "name": "Schaden durch Blitzschlag",
    "synonyms": [
      "Blitzschlag",
      "Folgen eines Blitzschlags",
      "Keraunoparalyse",
      "Schaden durch Blitzschlag",
      "Schock durch Blitzschlag",
      "Schädigung durch Blitzschlag",
      "Verkohlung durch Blitzschlag",
      "Wirkung eines Blitzes"
    ]
  },
  {
    "code": "T75.1",
    "name": "Krampf beim Schwimmen",
    "synonyms": [
      "Anoxie durch Untertauchen",
      "Asphyxie durch Ertrinken",
      "Asphyxie durch Untertauchen",
      "Erstickung durch Ertrinken",
      "Ertrinken",
      "Ertrinkungsunfall",
      "Krampf beim Schwimmen",
      "Lungenödem durch Untertauchen",
      "Nichttödliches Untertauchen",
      "Schwimmkrampf",
      "Tödliches Untertauchen",
      "Unfall durch Ertrinken",
      "Untertauchen"
    ]
  },
  {
    "code": "T75.2",
    "name": "Schaden durch Vibration",
    "synonyms": [
      "Krankheit durch Vibration a.n.k.",
      "Pressluftbohrer-Krankheit",
      "Pressluftbohrer-Syndrom",
      "Presslufthammer-Krankheit",
      "Presslufthammer-Syndrom",
      "Schaden durch Vibration",
      "Schwindel durch Infraschall",
      "Schwindel durch Vibration",
      "Traumatisches Vasospasmus-Syndrom",
      "Wirkung von Vibration"
    ]
  },
  {
    "code": "T75.3",
    "name": "Kinetose",
    "synonyms": [
      "Autokrankheit",
      "Bewegungskrankheit",
      "Bewegungskrankheit bei Reisen mit jedem Fahrzeug",
      "Bewegungsübelkeit bei Reisen mit jedem Fahrzeug",
      "Eisenbahnkrankheit",
      "Karussellkrankheit",
      "Kinetose",
      "Luftkrankheit",
      "Nausea marina",
      "Reisekrankheit",
      "Schaukelbewegungskrankheit",
      "Seekrankheit",
      "Wirkung von Bewegung",
      "Übelkeit durch Bewegung von Karussell oder Schaukel"
    ]
  },
  {
    "code": "T75.4",
    "name": "Schaden durch elektrischen Strom",
    "synonyms": [
      "Elektroschock",
      "Nichttödliche Auswirkungen durch elektrischen Strom",
      "Nichttödlicher Schaden durch elektrischen Strom",
      "Schaden durch elektrischen Strom",
      "Schlag durch Elektrizität",
      "Schlag durch elektrischen Strom",
      "Schock durch Elektrizität",
      "Schock durch elektrischen Strom",
      "Stromunfall",
      "Tod durch Strom",
      "Tödlicher Schlag durch elektrischen Strom",
      "Wirkung von elektrischem Strom"
    ]
  },
  {
    "code": "T75.8",
    "name": "Ausgesetztsein",
    "synonyms": [
      "Ausgesetztsein",
      "Ausgesetztsein gegenüber Witterungsunbilden",
      "Auswirkungen von Schwerelosigkeit",
      "Auswirkungen von abnormen Gravitationskräften",
      "Schaden durch abnorme Gravitationskräfte",
      "Sick-Building-Syndrom",
      "Wirkung von Schwerelosigkeit",
      "Wirkung von außergewöhnlich starker Schwerkraft"
    ]
  },
  {
    "code": "T76",
    "name": "Wirkung einer äußeren Ursache a.n.k.",
    "synonyms": [
      "Schaden durch absichtliche Selbstbeschädigung",
      "Schaden durch absichtliche Selbsttötung",
      "Schaden durch tätlichen Angriff",
      "Schaden durch äußere Ursache",
      "Wirkung einer äußeren Ursache a.n.k."
    ]
  },
  {
    "code": "T78.0",
    "name": "Schock durch Nahrungsmittelunverträglichkeit",
    "synonyms": [
      "Anaphylaktischer Schock durch Nahrungsmittel a.n.k.",
      "Schock durch Nahrungsmittelunverträglichkeit"
    ]
  },
  {
    "code": "T78.1",
    "name": "Allergie gegen Nahrungsmittel",
    "synonyms": [
      "Allergie gegen Nahrungsmittel",
      "Allergische Reaktion durch Nahrungsmittel a.n.k.",
      "Eiprotein-Allergie",
      "Eiprotein-Überempfindlichkeit",
      "Erdnussprotein-Allergie",
      "Erdnussöl-Allergie",
      "Erdnussöl-Überempfindlichkeit",
      "Fisch-Allergie",
      "Fischeiweiß-Überempfindlichkeit",
      "Gelatine-Überempfindlichkeit",
      "Hühnereiweiß-Allergie",
      "Kuhmilchproteinintoleranz",
      "Kürbisfrüchte-Allergie",
      "Leguminosen-Allergie",
      "Nahrungsmittelunverträglichkeit",
      "Nuss-Überempfindlichkeit",
      "Rinderprotein-Überempfindlichkeit",
      "Sesamöl-Allergie",
      "Soja-Allergie",
      "Soja-Überempfindlichkeit",
      "Sojaprotein-Allergie",
      "Sojaprotein-Überempfindlichkeit",
      "Sorbitol-Allergie",
      "Sorbitol-Überempfindlichkeit",
      "Sorbitolunverträglichkeit",
      "Zimt-Allergie",
      "Zimt-Überempfindlichkeit",
      "Zitrusfrüchte-Überempfindlichkeit",
      "Überempfindlichkeit gegen Farbstoffe in Nahrungsmitteln",
      "Überempfindlichkeit gegen Konservierungsmittel",
      "Überempfindlichkeit gegen Nahrungsmittelzusatzstoffe"
    ]
  },
  {
    "code": "T78.2",
    "name": "Anaphylaktischer Schock",
    "synonyms": [
      "Allergischer Schock",
      "Anaphylaktischer Schock",
      "Anaphylaxie",
      "Herxheimer-Reaktion",
      "Schock durch Arzneimittel"
    ]
  },
  {
    "code": "T78.3",
    "name": "Angioneurotisches Ödem",
    "synonyms": [
      "AAE [Erworbenes Angioödem]",
      "ACE [Angiotensin-Konversionsenzym]-Hemmer-induziertes Angioödem",
      "Akutes Quincke-Ödem der Haut",
      "Akutes essentielles Ödem",
      "Akutes umschriebenes Ödem",
      "Akutes zirkumskriptes Ödem",
      "Allergisches Angioödem",
      "Allergisches Glottisödem",
      "Allergisches angioneurotisches Ödem",
      "Angioneurotisches Ödem",
      "Angioneurotisches Ödem mit Urtikaria",
      "Angioödem",
      "Angioödem mit Urtikaria",
      "Bannister-Krankheit",
      "Erworbenes Angioödem",
      "Erworbenes Angioödem Typ 1",
      "Erworbenes Angioödem Typ 2",
      "Erworbenes Bradykinin-induziertes Angioödem",
      "Erworbenes angioneurotisches Ödem",
      "Erworbenes nicht-Histamin-induziertes Angioödem",
      "Larynxurtikaria",
      "Medikamentenbedingtes Angioödem",
      "Periodisches Ödem",
      "Quincke-Syndrom",
      "Quincke-Ödem",
      "RAAS [Renin-Angiotensin-Aldosteron-System]-Blocker-induziertes Angioödem",
      "Urticaria gigantea"
    ]
  },
  {
    "code": "T78.4",
    "name": "Allergie",
    "synonyms": [
      "Allergie",
      "Allergie gegen Alkohol",
      "Allergie gegen echtes Karmin [E 120]",
      "Allergische Diathese",
      "Allergische Reaktion",
      "Allergische Reaktion bei Kontakt mit Platinverbindung",
      "Allurarot-Allergie [E 129]",
      "Allurarot-Überempfindlichkeit [E 129]",
      "Amaranth-Allergie [E 123]",
      "Amaranth-Überempfindlichkeit [E 123]",
      "Annatto-Allergie",
      "Annatto-Überempfindlichkeit",
      "Arthus-Phänomen",
      "Atopie",
      "Azorubin-Allergie [E 122]",
      "Azorubin-Überempfindlichkeit [E 122]",
      "Benzalkoniumchlorid-Allergie",
      "Benzalkoniumchlorid-Überempfindlichkeit",
      "Benzoesäure-Allergie",
      "Benzoesäure-Überempfindlichkeit",
      "Benzolsulfonsäure-Allergie",
      "Benzolsulfonsäure-Überempfindlichkeit",
      "Benzylalkohol-Allergie",
      "Benzylalkohol-Überempfindlichkeit",
      "Bernsteinsäure-Allergie",
      "Bernsteinsäure-Überempfindlichkeit",
      "Braun-Allergie [E 155]",
      "Braun-Überempfindlichkeit [E 155]",
      "Brillantschwarz-Allergie [E 151]",
      "Brillantschwarz-Überempfindlichkeit [E 151]",
      "Butylhydroxyanisol-Allergie",
      "Butylhydroxyanisol-Überempfindlichkeit",
      "Butylhydroxytoluol-Allergie",
      "Butylhydroxytoluol-Überempfindlichkeit",
      "Carrageen-Allergie [E 407]",
      "Carrageen-Überempfindlichkeit [E 407]",
      "Cetylalkohol-Allergie",
      "Cetylalkohol-Überempfindlichkeit",
      "Cetylstearylalkohol-Überempfindlichkeit",
      "Chinazolin-Allergie",
      "Chinazolin-Überempfindlichkeit",
      "Chinolingelb-Allergie [E 104]",
      "Chinolingelb-Überempfindlichkeit [E 104]",
      "Chlorocresol-Allergie",
      "Chlorocresol-Überempfindlichkeit",
      "Chrysanthemen-Allergie",
      "Chrysanthemen-Überempfindlichkeit",
      "Cochenillerot-Allergie [E 124]",
      "Cochenillerot-Überempfindlichkeit [E 124]",
      "Doldengewächs-Allergie",
      "Doldengewächs-Überempfindlichkeit",
      "Erythrosin-Allergie [E 127]",
      "Erythrosin-Überempfindlichkeit [E 127]",
      "Ethanol-Allergie",
      "Ethanol-Überempfindlichkeit",
      "Formaldehyd-Allergie",
      "Formaldehyd-Überempfindlichkeit",
      "Gallate-Allergie",
      "Gallate-Überempfindlichkeit",
      "Gallussäure-Allergie",
      "Gelborange-Allergie [E 110]",
      "Gelborange-Überempfindlichkeit [E 110]",
      "Guarkernmehl-Allergie [E 412]",
      "Guarkernmehl-Überempfindlichkeit [E 412]",
      "Hamsterprotein-Allergie",
      "Hamsterprotein-Überempfindlichkeit",
      "Hyperergische Reaktion",
      "Hyperergische Reaktion gegen mikrobielle Allergene",
      "Hypersensibilität",
      "Idiosynkrasie",
      "Isopropylalkohol-Allergie",
      "Isopropylalkohol-Überempfindlichkeit",
      "Jodallergie",
      "Johannisbrotkernmehl-Allergie [E 410]",
      "Johannisbrotkernmehl-Überempfindlichkeit [E 410]",
      "Kaninchenallergie",
      "Karaya-Allergie [E 416]",
      "Karaya-Überempfindlichkeit [E 416]",
      "Korbblütler-Allergie",
      "Korbblütler-Überempfindlichkeit",
      "Kurkumin-Allergie [E 100]",
      "Kurkumin-Überempfindlichkeit [E 100]",
      "Litholrubin-Allergie [E 180]",
      "Litholrubin-Überempfindlichkeit [E 180]",
      "Lysozym-Allergie",
      "Lysozym-Überempfindlichkeit",
      "MCS [Multiple-Chemical-Sensitivity]-Syndrom",
      "Macrogolglycerolricinoleat-Allergie",
      "Macrogolglycerolricinoleat-Überempfindlichkeit",
      "Mausprotein-Allergie",
      "Mausprotein-Überempfindlichkeit",
      "Multiple Allergien",
      "Multiple-Chemical-Sensitivity [MCS]-Syndrom",
      "Natriumbenzoat-Allergie",
      "Natriumbenzoat-Überempfindlichkeit",
      "Natriumdisulfit-Allergie",
      "Natriumdisulfit-Überempfindlichkeit",
      "Natriumedetat-Allergie",
      "Natriumedetat-Überempfindlichkeit",
      "Nitroverbindungen-Allergie",
      "Nitroverbindungen-Überempfindlichkeit",
      "Norfluran-Allergie",
      "Norfluran-Überempfindlichkeit",
      "Para-Hydroxybenzoesäureester-Allergie",
      "Para-Hydroxybenzoesäureester-Überempfindlichkeit",
      "Parabene-Allergie",
      "Parabene-Überempfindlichkeit",
      "Paragruppen-Allergie",
      "Phenolrot-Allergie",
      "Phenolrot-Überempfindlichkeit",
      "Ponceau-Allergie [E 124]",
      "Ponceau-Überempfindlichkeit [E 124]",
      "Propylenglycol-Allergie",
      "Propylenglycol-Überempfindlichkeit",
      "Propylgallate-Allergie",
      "Pyrrolidon-Allergie",
      "Pyrrolidon-Überempfindlichkeit",
      "Rot-Allergie [E 128]",
      "Rot-Überempfindlichkeit [E 128]",
      "Schwefeldioxid-Allergie",
      "Schwefeldioxid-Überempfindlichkeit",
      "Schwermetallüberempfindlichkeit",
      "Sorbinsäure-Allergie",
      "Sorbinsäure-Überempfindlichkeit",
      "Stearylalkohol-Allergie",
      "Stearylalkohol-Überempfindlichkeit",
      "Sulfit-Allergie",
      "Sulfit-Überempfindlichkeit",
      "Tartrazin-Allergie [E 102]",
      "Tartrazin-Überempfindlichkeit [E 102]",
      "Thioharnstoff-Überempfindlichkeit",
      "Thionamid-Derivate-Allergie",
      "Thionamid-Derivate-Überempfindlichkeit",
      "Tragan"
    ]
  },
  {
    "code": "T78.8",
    "name": "Radiation-Recall-Phänomen",
    "synonyms": [
      "Radiation-Recall-Phänomen"
    ]
  },
  {
    "code": "T78.9",
    "name": "Unerwünschte Nebenwirkung",
    "synonyms": [
      "Nebenwirkung a.n.k.",
      "Schädliche Nebenwirkung",
      "Unerwünschte Nebenwirkung",
      "Ungünstige Nebenwirkung"
    ]
  },
  {
    "code": "T79.0",
    "name": "Luftembolie",
    "synonyms": [
      "Gasembolie",
      "Luftembolie",
      "Traumatische Luftembolie"
    ]
  },
  {
    "code": "T79.1",
    "name": "Traumatische Fettembolie",
    "synonyms": [
      "Atheromembolie",
      "Cholesterinembolie",
      "Fettembolie",
      "Traumatische Fettembolie"
    ]
  },
  {
    "code": "T79.2",
    "name": "Sekundäre Nachblutung nach traumatisch bedingter Blutung",
    "synonyms": [
      "Sekundäre Blutung nach traumatisch bedingter Blutung",
      "Sekundäre Hämorrhagie nach traumatisch bedingter Blutung",
      "Sekundäre Nachblutung nach traumatisch bedingter Blutung",
      "Wiederholte Blutung nach traumatisch bedingter Blutung",
      "Wiederholte Hämorrhagie nach traumatisch bedingter Blutung",
      "Wiederholte Nachblutung nach traumatisch bedingter Blutung"
    ]
  },
  {
    "code": "T79.3",
    "name": "Posttraumatische Wundinfektion",
    "synonyms": [
      "Infizierte Verletzung",
      "Infizierte Wunde",
      "Infizierte Wunde ohne Erstversorgung",
      "Infizierter Insektenstich",
      "Lokale Wundinfektion",
      "Posttraumatische Infektion a.n.k.",
      "Posttraumatische Wundinfektion",
      "Sekundär infizierte Wunde",
      "Wundinfektion a.n.k."
    ]
  },
  {
    "code": "T79.4",
    "name": "Traumatischer Schock",
    "synonyms": [
      "Atmungsverminderung bei traumatischem Schock",
      "Blutdruckabfall durch Schock nach Verletzung",
      "Blutdruckverminderung bei traumatischem Schock",
      "Hypovolämie bei traumatischem Schock",
      "Kleiner schneller Puls durch Schock nach Verletzung",
      "Niedriger Blutdruck durch Schock nach Verletzung",
      "Schock nach Verletzung",
      "Schwache Atmung durch Schock nach Verletzung",
      "Traumatischer Schock",
      "Traumatischer hypovolämischer Schock",
      "Unmittelbarer Schock nach Verletzung",
      "Verzögerter Schock nach Verletzung"
    ]
  },
  {
    "code": "T79.5",
    "name": "Traumatische Anurie",
    "synonyms": [
      "Bywaters-Syndrom",
      "Crush-Syndrom",
      "Crushniere",
      "Muskelzerfallssyndrom",
      "Myorenales Syndrom",
      "Niereninsuffizienz nach Crush-Verletzung",
      "Nierenversagen bei Zerquetschung",
      "Quetschungssyndrom",
      "Traumatische Anurie",
      "Tubulovaskuläres Syndrom",
      "Verschüttung",
      "Verschüttungssyndrom"
    ]
  },
  {
    "code": "T79.60",
    "name": "Volkmann-Kontraktur",
    "synonyms": [
      "Ischämische Muskelkontraktur",
      "Ischämische Muskelparalyse",
      "Ischämische Volkmann-Paralyse als Verletzungskomplikation",
      "Traumatische Muskelischämie der oberen Extremität",
      "Volkmann-Kontraktur",
      "Volkmann-Paralyse"
    ]
  },
  {
    "code": "T79.61",
    "name": "Traumatische Muskelischämie des Oberschenkels",
    "synonyms": [
      "Traumatische Muskelischämie der Hüfte",
      "Traumatische Muskelischämie des Oberschenkels"
    ]
  },
  {
    "code": "T79.62",
    "name": "Arteria-tibialis-anterior-Syndrom",
    "synonyms": [
      "Arteria-tibialis-anterior-Syndrom",
      "Traumatische Muskelischämie des Unterschenkels"
    ]
  },
  {
    "code": "T79.63",
    "name": "Traumatische Muskelischämie des Fußes",
    "synonyms": [
      "Traumatische Muskelischämie des Fußes"
    ]
  },
  {
    "code": "T79.69",
    "name": "Traumatische Muskelischämie",
    "synonyms": [
      "Kompartmentsyndrom",
      "Traumatische Muskelischämie",
      "Traumatische Rhabdomyolyse"
    ]
  },
  {
    "code": "T79.7",
    "name": "Traumatisches subkutanes Emphysem",
    "synonyms": [
      "Traumatisches Augenlidemphysem",
      "Traumatisches Bindegewebeemphysem",
      "Traumatisches Emphysem des Unterhautzellgewebes",
      "Traumatisches subkutanes Emphysem"
    ]
  },
  {
    "code": "T79.8",
    "name": "Knochenmarkembolie",
    "synonyms": [
      "Knochenmarkembolie",
      "Traumatische Meningitis",
      "Traumatische Pneumonie"
    ]
  },
  {
    "code": "T79.9",
    "name": "Frühkomplikation eines Traumas",
    "synonyms": [
      "Frühkomplikation eines Traumas"
    ]
  },
  {
    "code": "T80.0",
    "name": "Luftembolie nach therapeutischer Injektion",
    "synonyms": [
      "Luftembolie nach Infusion",
      "Luftembolie nach Transfusion",
      "Luftembolie nach therapeutischer Injektion"
    ]
  },
  {
    "code": "T80.1",
    "name": "Phlebitis nach Infusion, therapeutischer Injektion oder Transfusion",
    "synonyms": [
      "Embolia cutis medicamentosa",
      "Gefäßkomplikation nach Infusion, therapeutischer Injektion oder Transfusion",
      "Nicolau-Syndrom",
      "Phlebitis nach Infusion, therapeutischer Injektion oder Transfusion",
      "Thromboembolie nach Infusion, therapeutischer Injektion oder Transfusion",
      "Thrombophlebitis nach Infusion, therapeutischer Injektion oder Transfusion"
    ]
  },
  {
    "code": "T80.2",
    "name": "Sepsis nach Infusion, therapeutischer Injektion oder Transfusion",
    "synonyms": [
      "Infektion nach Infusion, therapeutischer Injektion oder Transfusion",
      "Sepsis nach Infusion, therapeutischer Injektion oder Transfusion"
    ]
  },
  {
    "code": "T80.3",
    "name": "Inkompatible Bluttransfusion",
    "synonyms": [
      "Blutgruppenunverträglichkeitsreaktion",
      "Infusionsreaktion durch AB0-Unverträglichkeit",
      "Inkompatible Bluttransfusion",
      "Reaktion durch Blutgruppenunverträglichkeit bei einer Transfusion",
      "Transfusionsreaktion durch AB0-Unverträglichkeit"
    ]
  },
  {
    "code": "T80.4",
    "name": "Transfusionsreaktion durch Rh-Faktor",
    "synonyms": [
      "Immunisierung durch Rhesus-Faktor bei Transfusion",
      "Infusionsreaktion durch Rh [Rhesus]-Unverträglichkeit",
      "Infusionsreaktion durch Rh-Faktor",
      "Transfusionsreaktion durch Rh [Rhesus]-Unverträglichkeit",
      "Transfusionsreaktion durch Rh-Faktor",
      "Unverträglichkeitsreaktion durch Rh-Faktor"
    ]
  },
  {
    "code": "T80.5",
    "name": "Anaphylaktischer Schock durch Serum",
    "synonyms": [
      "Allergischer Schock durch Immunisierung",
      "Allergischer Schock durch Serum",
      "Allergischer Schock durch Transfusion",
      "Anaphylaktischer Schock durch Immunisation",
      "Anaphylaktischer Schock durch Serum",
      "Anaphylaxie durch Vakzination a.n.k.",
      "Sofortreaktion durch Serum"
    ]
  },
  {
    "code": "T80.6",
    "name": "Serumdermatitis a.n.k.",
    "synonyms": [
      "Allergische Reaktion durch Serum",
      "Arthus-Phänomen durch Serum",
      "Eiweißschock durch Vakzination",
      "Enzephalopathie durch Schutzimpfung",
      "Enzephalopathie durch Serum",
      "Exanthem durch Serumbehandlung",
      "HLA-Hyperimmunisierung nach Transfusion",
      "Serumallergie",
      "Serumausschlag a.n.k.",
      "Serumdermatitis a.n.k.",
      "Serumexanthem a.n.k.",
      "Serumintoxikation",
      "Serumkrankheit a.n.k.",
      "Serumreaktion",
      "Serumurtikaria a.n.k.",
      "Serumvergiftung a.n.k."
    ]
  },
  {
    "code": "T80.8",
    "name": "Transfusionshämosiderose",
    "synonyms": [
      "Fat-Overload-Syndrom",
      "Hämoglobinämie durch Bluttransfusion",
      "Hämolyse durch Lymphozytentransfusion",
      "Hämolyse durch Plasmatransfusion",
      "Ikterus durch hämolytische Transfusionsreaktion",
      "Schock durch Bluttransfusion",
      "Schock durch Lymphozytentransfusion",
      "Schock durch Plasmatransfusion",
      "Transfusionshämosiderose",
      "Transfusionsikterus"
    ]
  },
  {
    "code": "T80.9",
    "name": "Injektionskomplikation",
    "synonyms": [
      "Infusionskomplikation a.n.k.",
      "Injektionskomplikation",
      "Komplikation bei Dialyse a.n.k.",
      "Komplikation bei extrakorporalem Kreislauf",
      "Komplikation durch Bluttransfusion",
      "Komplikation durch Infusionsmaßnahme a.n.k.",
      "Komplikation durch Injektion",
      "Komplikation durch Injektionsmaßnahme",
      "Komplikation durch Inokulation",
      "Komplikation durch Lymphozytentransfusion",
      "Komplikation durch Plasmatransfusion",
      "Komplikationen der Hämodialyse",
      "Perfusionskomplikation a.n.k.",
      "Spritzenkomplikation",
      "Transfusionsreaktion",
      "Transfusionszwischenfall"
    ]
  },
  {
    "code": "T81.0",
    "name": "Nachblutung",
    "synonyms": [
      "Blutung einer Gefäßligatur",
      "Blutung einer Zahnalveole nach Extraktion",
      "Blutung eines Amputationsstumpfes nach Operation",
      "Blutung nach Eingriff",
      "Expulsive Blutung nach Kataraktextraktion",
      "Hämatom als Komplikation eines Eingriffes",
      "Hämatom nach Operation",
      "Hämatom nach chirurgischem Eingriff",
      "Hämorrhagie einer Gefäßligatur",
      "Hämorrhagie einer Zahnalveole nach Extraktion",
      "Hämorrhagie eines Amputationsstumpfes nach Operation",
      "Hämorrhagie nach chirurgischem Eingriff",
      "Nachblutung",
      "Postoperative Blutung",
      "Postoperative Hämorrhagie",
      "Postoperatives Hämatom"
    ]
  },
  {
    "code": "T81.1",
    "name": "Hypovolämie bei postoperativem Schock",
    "synonyms": [
      "Endotoxischer Schock während eines Eingriffes",
      "Hypovolämie bei postoperativem Schock",
      "Hypovolämischer Schock nach Eingriff",
      "Hypovolämischer Schock während eines Eingriffes",
      "Kollaps nach Eingriff",
      "Kollaps während eines Eingriffes",
      "Postoperativer Schock",
      "Postoperativer kardiovaskulärer Kollaps",
      "Schock durch Endotoxine nach Eingriff",
      "Schock durch Endotoxine während eines Eingriffes",
      "Schock durch therapeutischen Unglücksfall a.n.k.",
      "Schock nach chirurgischem Eingriff",
      "Schock während oder als Folge eines Eingriffes"
    ]
  },
  {
    "code": "T81.2",
    "name": "Perforation bei Endoskopie",
    "synonyms": [
      "Diaphragmaparalyse durch versehentliche Resektion des Nervus phrenicus bei ärztlicher Behandlung",
      "Drainageperforation",
      "Komplikation durch versehentliche Zerreißung während einer ärztlichen Maßnahme",
      "Komplikation durch versehentlichen Einstich während einer ärztlichen Maßnahme",
      "Operationskomplikation durch versehentliche Lazeration",
      "Operationskomplikation durch versehentliche Punktion",
      "Perforation bei Endoskopie",
      "Uterusschnittverletzung bei einem Eingriff",
      "Verletzung bei chirurgischem Eingriff",
      "Versehentliche Blutgefäßperforation durch eine Sonde während eines Eingriffes",
      "Versehentliche Nervenperforation durch eine Sonde während eines Eingriffes",
      "Versehentliche Organperforation durch eine Sonde während eines Eingriffes",
      "Versehentliche chirurgische Perforation eines Blutgefäßes",
      "Versehentliche chirurgische Perforation von Nerven",
      "Versehentliche chirurgische Perforation von Organen",
      "Versehentliche ärztliche Uterusperforation"
    ]
  },
  {
    "code": "T81.3",
    "name": "Sekundärheilung einer Wunde",
    "synonyms": [
      "Aufbrechen der Operationswunde a.n.k.",
      "Aufplatzen von Stichen und Nähten",
      "Aufreißen der Operationswunde a.n.k.",
      "Dehiszenz einer Operationswunde a.n.k.",
      "Eviszeration durch Operationswunde",
      "Eviszeration nach chirurgischem Eingriff",
      "Nahtdehiszenz",
      "Nahtdehiszenz der Bindehaut",
      "Nahtdehiszenz der Hornhaut",
      "Nahtdehiszenz der Konjunktiva",
      "Nahtinsuffizienz",
      "Nahtruptur mit Hornhautprolaps",
      "Nahtruptur mit Skleraprolaps",
      "Nahtruptur ohne Hornhautprolaps",
      "Nahtruptur ohne Skleraprolaps",
      "Platzbauch",
      "Postoperative Dehiszenz a.n.k.",
      "Postoperative Wundruptur",
      "Ruptur einer Operationswunde",
      "Sekundär verheilende Wunde nach Eingriff",
      "Sekundärheilung einer Wunde",
      "Wunddehiszenz",
      "Wunddehiszenz mit Platzbauch"
    ]
  },
  {
    "code": "T81.4",
    "name": "Postoperative Infektion",
    "synonyms": [
      "Abszess einer Operationswunde",
      "Anastomositis",
      "Entzündung des Operations-Bereiches",
      "Iatrogener Abszess",
      "Infektion einer Operationswunde",
      "Infektion einer postoperativen Wunde",
      "Infizierte Nahtdehiszenz",
      "Intraabdominaler Abszess nach medizinischen Maßnahmen",
      "Intubationsgranulom",
      "Lokalisierte eitrige Entzündung einer Operationswunde",
      "Nahtabszess",
      "Nahtabszess nach chirurgischem Eingriff",
      "Nahtabszess nach medizinischen Maßnahmen",
      "Postoperative Infektion",
      "Postoperative Sepsis",
      "Postoperative infektiöse Wundheilungsstörung",
      "Postoperativer Abszess",
      "Postoperativer Peritoneumabszess",
      "Postoperativer subphrenischer Abszess",
      "Postoperatives Fieber durch Infektion",
      "Sepsis nach medizinischen Maßnahmen",
      "Subphrenischer Abszess nach medizinischen Maßnahmen",
      "Ureterstumpfinfektion",
      "Wundabszess nach medizinischen Maßnahmen"
    ]
  },
  {
    "code": "T81.5",
    "name": "Versehentlich in der Operationswunde zurückgelassene Nadel",
    "synonyms": [
      "Adhäsion durch einen versehentlich in einer Körperhöhle zurückgebliebenen Fremdkörper",
      "Adhäsion durch einen versehentlich in einer Operationswunde zurückgebliebenen Fremdkörper",
      "Granulom durch Fremdkörper in der Operationswunde",
      "Obstruktion durch einen versehentlich in einer Körperhöhle zurückgebliebenen Fremdkörper",
      "Obstruktion durch einen versehentlich in einer Operationswunde zurückgebliebenen Fremdkörper",
      "Perforation durch einen versehentlich in einer Körperhöhle zurückgebliebenen Fremdkörper",
      "Perforation durch einen versehentlich in einer Operationswunde zurückgebliebenen Fremdkörper",
      "Postoperative Adhäsion durch einen versehentlich in einer Operationswunde zurückgebliebenen Fremdkörper",
      "Versehentlich in der Operationswunde zurückgelassene Nadel",
      "Versehentlich in der Operationswunde zurückgelassener Fremdkörper",
      "Versehentlich in der Operationswunde zurückgelassener Schwamm",
      "Versehentlich in der Operationswunde zurückgelassener Tupfer"
    ]
  },
  {
    "code": "T81.6",
    "name": "Bariumperitonitis",
    "synonyms": [
      "Aseptische Peritonitis",
      "Bariumperitonitis",
      "Chemische Peritonitis",
      "Granulom durch Talkum in der Operationswunde",
      "Peritonitis durch eine chemische Substanz"
    ]
  },
  {
    "code": "T81.7",
    "name": "Postoperative Phlebitis",
    "synonyms": [
      "Cholesterinkristallembolie nach einem Eingriff",
      "Gefäßkomplikation nach chirurgischem Eingriff",
      "Komplikation an einem peripheren Gefäß nach chirurgischem Eingriff",
      "Luftembolie nach einem Eingriff a.n.k.",
      "Phlebitis bei medizinischen Maßnahmen",
      "Postoperative Gefäßkomplikation",
      "Postoperative Phlebitis",
      "Postoperative Thrombophlebitis",
      "Thrombophlebitis nach ärztlichen Maßnahmen a.n.k.",
      "Thrombophlebitis während einer ärztlichen Maßnahme a.n.k."
    ]
  },
  {
    "code": "T81.8",
    "name": "Fadenfistel",
    "synonyms": [
      "Augenlidemphysem nach chirurgischem Eingriff",
      "Emphysem des Bindegewebes nach chirurgischem Eingriff",
      "Emphysem des Unterhautzellgewebes nach chirurgischem Eingriff",
      "Emphysem nach chirurgischem Eingriff",
      "Fadenfistel",
      "Fistel nach chirurgischem Eingriff",
      "Floppy-Iris-Syndrom",
      "Granulomatöse Operationswunde",
      "Herzinsuffizienz bei chirurgischem Eingriff",
      "Herzstillstand bei chirurgischem Eingriff",
      "Herzversagen bei Operation",
      "Iatrogene Obstruktion",
      "Komplikation bei Beatmungstherapie a.n.k.",
      "Komplikation bei Inhalationstherapie a.n.k.",
      "Komplikation bei respiratorischer Therapie a.n.k.",
      "Nahtgranulom der Operationswunde",
      "Persistierende postoperative Fistel",
      "Postoperative Wundheilungsstörung",
      "Postoperatives Nahtgranulom",
      "Postoperatives Serom",
      "Subkutanes Emphysem nach chirurgischem Eingriff",
      "Tourniquet-Syndrom"
    ]
  },
  {
    "code": "T81.9",
    "name": "Komplikation nach chirurgischem Eingriff",
    "synonyms": [
      "Komplikation durch Operation",
      "Komplikation nach chirurgischem Eingriff",
      "Postoperative Komplikation",
      "Postoperatives Syndrom a.n.k."
    ]
  },
  {
    "code": "T82.0",
    "name": "Herzfehllage durch Herzklappenprothese",
    "synonyms": [
      "Fehllage einer Herzklappenprothese",
      "Gefäßfehllage durch Herzklappenprothese",
      "Gefäßleckage durch Herzklappenprothese",
      "Gefäßperforation durch Herzklappenprothese",
      "Gefäßprotrusion durch Herzklappenprothese",
      "Gefäßverlagerung durch Herzklappenprothese",
      "Herzfehllage durch Herzklappenprothese",
      "Herzleckage durch Herzklappenprothese",
      "Herzperforation durch Herzklappenprothese",
      "Herzprotrusion durch Herzklappenprothese",
      "Herzverlagerung durch Herzklappenprothese",
      "Mechanische Gefäßobstruktion durch Herzklappenprothese",
      "Mechanische Herzobstruktion durch Herzklappenprothese",
      "Mechanische Komplikation durch Herzklappenprothese",
      "Mechanisches Gefäßversagen durch Herzklappenprothese",
      "Mechanisches Herzversagen durch Herzklappenprothese"
    ]
  },
  {
    "code": "T82.1",
    "name": "Dysfunktion eines implantierten Cardioverter-Defibrillators",
    "synonyms": [
      "Batterieerschöpfung eines ICD [Implantierbarer Cardioverter-Defibrillator]-Systems",
      "Batterieerschöpfung eines implantierten Cardioverter-Defibrillators",
      "Batterieerschöpfung eines implantierten Herzschrittmachers",
      "Dysfunktion eines ICD [Implantierbarer Cardioverter-Defibrillator]-Systems",
      "Dysfunktion eines implantierten Cardioverter-Defibrillators",
      "Dysfunktion eines implantierten Herzschrittmachers",
      "Fehllage eines elektronischen Apparates am Herz",
      "Mechanische Schrittmacher-Komplikation",
      "Schrittmacher-Dysfunktion"
    ]
  },
  {
    "code": "T82.2",
    "name": "Dysfunktion eines Koronararterienbypasses",
    "synonyms": [
      "Dysfunktion eines Koronararterienbypasses",
      "Fehllage eines Koronararterientransplantates",
      "Leckage eines Koronararterientransplantates",
      "Mechanische Komplikation durch Koronararterienbypass",
      "Mechanische Komplikation durch Koronararterientransplantat",
      "Obstruktion eines Koronararterientransplantates",
      "Perforation eines Koronararterientransplantates"
    ]
  },
  {
    "code": "T82.3",
    "name": "Dysfunktion eines Gefäßtransplantates a.n.k.",
    "synonyms": [
      "Dysfunktion eines Gefäßtransplantates a.n.k.",
      "Dysfunktion eines Shunts a.n.k.",
      "Fehllage eines Arterientransplantates a.n.k.",
      "Leckage eines Arterientransplantates a.n.k.",
      "Mechanische Komplikation durch Arterientransplantat",
      "Mechanische Komplikation durch Gefäßanastomose",
      "Obstruktion eines Arterientransplantates a.n.k.",
      "Obstruktion eines Gefäßtransplantates a.n.k.",
      "Perforation eines Arterientransplantates a.n.k.",
      "Problem mit einem Arterientransplantat a.n.k.",
      "Verlagerung eines Arterientransplantates a.n.k.",
      "Versagen eines Arterientransplantates a.n.k."
    ]
  },
  {
    "code": "T82.4",
    "name": "Dysfunktion eines Dialysekatheters",
    "synonyms": [
      "Dysfunktion eines Dialysekatheters",
      "Fehllage eines Dialysekatheters",
      "Leckage eines Dialysekatheters",
      "Mechanische Komplikation durch Dialysekatheter",
      "Obstruktion durch Dialysekatheter",
      "Perforation durch Dialysekatheter",
      "Verlagerung eines Dialysekatheters"
    ]
  },
  {
    "code": "T82.5",
    "name": "Shuntverschluss",
    "synonyms": [
      "Dysfunktion eines Infusionskatheters a.n.k.",
      "Fehllage eines Infusionskatheters a.n.k.",
      "Leckage eines Infusionskatheters a.n.k.",
      "Mechanische Komplikation durch Infusionskatheter",
      "Mechanische Komplikation durch Shunt",
      "Mechanische Komplikation durch künstliches Herz",
      "Mechanische Komplikation durch operativ angelegte arteriovenöse Fistel",
      "Mechanische Komplikation durch vaskuläres Ballon-Gerät",
      "Shuntverschluss",
      "Verlagerung eines Infusionskatheters a.n.k."
    ]
  },
  {
    "code": "T82.6",
    "name": "Endokarditis durch Klappenprothese",
    "synonyms": [
      "Endokarditis durch Klappenprothese",
      "Endokarditis durch künstliche Herzklappe",
      "Endokarditis durch prothetische Herzklappe",
      "Entzündung durch Herzklappenprothese"
    ]
  },
  {
    "code": "T82.7",
    "name": "Infektion durch ICD [Implantierbarer Cardioverter-Defibrillator]-System",
    "synonyms": [
      "Entzündung durch Dialysekatheter",
      "Entzündung durch Gegenpulsationsgerät in der Aorta",
      "Entzündung durch Herzklappentransplantat",
      "Entzündung durch Herzschrittmacher",
      "Entzündung durch Infusionskatheter",
      "Entzündung durch Koronararterienbypass",
      "Entzündung durch einen elektronischen Apparat am Herz",
      "Entzündung durch künstliches Herz",
      "Entzündung einer Gefäßanastomose",
      "Entzündung einer operativ angelegten arteriovenösen Fistel",
      "Entzündung eines Arterientransplantates a.n.k.",
      "Entzündung eines Gefäßshunts",
      "Gefäßentzündung durch Apparat, Implantat oder Transplantat a.n.k.",
      "Infektion durch Dialysekatheter",
      "Infektion durch Gegenpulsationsgerät in der Aorta",
      "Infektion durch Herzschrittmacher",
      "Infektion durch ICD [Implantierbarer Cardioverter-Defibrillator]-System",
      "Infektion durch Infusionskatheter a.n.k.",
      "Infektion durch Koronararterienbypass",
      "Infektion durch implantierten Cardioverter-Defibrillator",
      "Infektion durch implantierten Herzschrittmacher",
      "Infektion durch künstliches Herz",
      "Infektion einer Gefäßanastomose",
      "Infektion einer operativ angelegten arteriovenösen Fistel",
      "Infektion eines Arterientransplantates a.n.k.",
      "Infektion eines Gefäßkatheters",
      "Infektion eines Gefäßshunts",
      "Sepsis durch Arterientransplantat a.n.k.",
      "Sepsis durch Dialysekatheter",
      "Sepsis durch Herzklappentransplantat",
      "Sepsis durch Infusionskatheter a.n.k."
    ]
  },
  {
    "code": "T82.8",
    "name": "Blutung durch Prothese im Herzen",
    "synonyms": [
      "Blutung durch Apparate am Herz a.n.k.",
      "Blutung durch Arterientransplantat a.n.k.",
      "Blutung durch Gefäßimplantat",
      "Blutung durch Gefäßprothese",
      "Blutung durch Gefäßtransplantat",
      "Blutung durch Herzimplantat",
      "Blutung durch Herztransplantat",
      "Blutung durch Prothese im Herzen",
      "Embolie durch Dialysekatheter",
      "Embolie durch Gefäßimplantat",
      "Embolie durch Gefäßprothese",
      "Embolie durch Gefäßtransplantat",
      "Embolie durch Herzimplantat",
      "Embolie durch Herzprothese",
      "Embolie durch Herztransplantat",
      "Embolie durch Infusionskatheter a.n.k.",
      "Fibrose durch Arterientransplantat a.n.k.",
      "Fibrose durch Dialysekatheter",
      "Fibrose durch Gefäßimplantat",
      "Fibrose durch Gefäßprothese",
      "Fibrose durch Gefäßtransplantat",
      "Fibrose durch Herzimplantat",
      "Fibrose durch Herzprothese",
      "Fibrose durch Herztransplantat",
      "Fibrose durch Infusionskatheter a.n.k.",
      "Fibrose durch elektronischen Apparat am Herz",
      "Hämorrhagie durch Apparat am Herz a.n.k.",
      "Hämorrhagie durch Arterientransplantat a.n.k.",
      "Schmerzen durch Arterientransplantat a.n.k.",
      "Schmerzen durch Gefäßimplantat",
      "Schmerzen durch Gefäßprothese",
      "Schmerzen durch Gefäßtransplantat",
      "Schmerzen durch Herzimplantat",
      "Schmerzen durch Herzprothese",
      "Schmerzen durch Herztransplantat",
      "Stenose durch Dialysekatheter",
      "Stenose durch Gefäßimplantat",
      "Stenose durch Gefäßprothese",
      "Stenose durch Gefäßtransplantat",
      "Stenose durch Herzimplantat",
      "Stenose durch Herzprothese",
      "Stenose durch Herztransplantat",
      "Stenose durch Infusionskatheter a.n.k.",
      "Stenose durch ein Arterientransplantat a.n.k.",
      "Thrombose durch Arterientransplantat a.n.k.",
      "Thrombose durch Dialysekatheter",
      "Thrombose durch Gefäßimplantat",
      "Thrombose durch Gefäßprothese",
      "Thrombose durch Gefäßtransplantat",
      "Thrombose durch Herzimplantat",
      "Thrombose durch Herzprothese",
      "Thrombose durch Herztransplantat",
      "Thrombose durch Infusionskatheter",
      "Thrombose eines AV-Shunts aus körpereigenem Material",
      "Thrombose eines autogenen AV-Shunts"
    ]
  },
  {
    "code": "T82.9",
    "name": "Komplikation durch operativ angelegten arteriovenösen Shunt",
    "synonyms": [
      "Komplikation durch Dialysekatheter",
      "Komplikation durch Gefäßimplantat",
      "Komplikation durch Gefäßprothese",
      "Komplikation durch Gefäßtransplantat",
      "Komplikation durch Gegenpulsationsgerät in der Aorta",
      "Komplikation durch Herzimplantat",
      "Komplikation durch Herzklappenprothese",
      "Komplikation durch Herzklappentransplantat",
      "Komplikation durch Herzprothese",
      "Komplikation durch Herzschrittmacher",
      "Komplikation durch Herztransplantat",
      "Komplikation durch Koronararterienbypass",
      "Komplikation durch Vena-cava-Schirm",
      "Komplikation durch elektronischen Herzstimulator",
      "Komplikation durch kardiale Prothese, Implantat oder Transplantat",
      "Komplikation durch kardialen Schrittmacher",
      "Komplikation durch künstliches Herz",
      "Komplikation durch operativ angelegte arteriovenöse Fistel",
      "Komplikation durch operativ angelegten arteriovenösen Shunt",
      "Komplikation durch vaskuläre Anastomose",
      "Komplikation durch vaskuläres Ballon-Gerät"
    ]
  },
  {
    "code": "T83.0",
    "name": "Mechanische Komplikation durch Harnwegskatheter",
    "synonyms": [
      "Dysfunktion eines Harnwegskatheters a.n.k.",
      "Dysfunktion eines Zystostomiekatheters",
      "Fehllage eines Harnwegskatheters",
      "Katheterokklusion bei suprapubischem Fistelkatheter",
      "Leckage eines Harnwegskatheters",
      "Mechanische Komplikation durch Harnwegskatheter",
      "Obstruktion eines Harnblasenkatheters",
      "Perforation durch Harnwegskatheter",
      "Verlagerung eines Harnwegskatheters"
    ]
  },
  {
    "code": "T83.1",
    "name": "Dysfunktion eines Gerätes im Harntrakt a.n.k.",
    "synonyms": [
      "Dysfunktion eines Gerätes im Harntrakt a.n.k.",
      "Fehllage eines elektronischen Apparates im Harntrakt",
      "Mechanische Komplikation durch Blasenapparat",
      "Mechanische Komplikation durch elektronischen Harnblasenstimulator"
    ]
  },
  {
    "code": "T83.2",
    "name": "Fehllage eines Harntrakttransplantates",
    "synonyms": [
      "Fehllage eines Harntrakttransplantates",
      "Leckage eines Transplantates im Harntrakt",
      "Mechanische Komplikation durch Harnorgantransplantat"
    ]
  },
  {
    "code": "T83.3",
    "name": "Lost IUP [Intrauterinpessar]",
    "synonyms": [
      "Dislokation eines IUP [Intrauterinpessar]",
      "Disloziertes Intrauterinpessar",
      "Fehllage eines Intrauterinpessars",
      "Lost IUP [Intrauterinpessar]",
      "Mechanische Komplikation durch Intrauterinpessar",
      "Okkultes Intrauterinpessar",
      "Perforation durch IUD [Intrauterine device]",
      "Uterusperforation durch intrauterine Kontrazeptionseinlage",
      "Verlagerung eines Intrauterinpessars"
    ]
  },
  {
    "code": "T83.4",
    "name": "Mechanische Komplikation durch Penisprothese",
    "synonyms": [
      "Mechanische Komplikation durch Genitalorgantransplantat",
      "Mechanische Komplikation durch Genitaltrakttransplantat",
      "Mechanische Komplikation durch Penisprothese",
      "Mechanische Komplikation durch Samenleiterimplantat",
      "Mechanische Komplikation durch Samenleiterprothese",
      "Postoperative Erosion nach TVT"
    ]
  },
  {
    "code": "T83.5",
    "name": "Bauchdeckeninfektion durch Blasenfistelkatheter",
    "synonyms": [
      "Bauchdeckeninfektion durch Blasenfistelkatheter",
      "Entzündung durch Blasenapparat",
      "Entzündung durch Blasenkatheter",
      "Entzündung durch Harnwegskatheter",
      "Entzündung durch elektronischen Apparat im Harntrakt",
      "Entzündung durch elektronischen Harnblasenstimulator",
      "Entzündung eines Harnorgantransplantates",
      "Infektion durch Blasenapparat",
      "Infektion durch Harnwegskatheter",
      "Infektion durch Zystostomiekatheter",
      "Infektion durch elektronischen Harnblasenstimulator",
      "Infektion eines Harnorgantransplantates",
      "Sepsis durch Harnwegskatheter"
    ]
  },
  {
    "code": "T83.6",
    "name": "Entzündung durch Intrauterinpessar",
    "synonyms": [
      "Endozervizitis durch Intrauterinpessar",
      "Entzündung durch Genitalorgantransplantat",
      "Entzündung durch Genitaltrakttransplantat",
      "Entzündung durch Intrauterinpessar",
      "Entzündung durch Penisprothese",
      "Entzündung durch Samenleiterimplantat",
      "Entzündung durch Samenleiterprothese",
      "Infektion durch Genitalorgantransplantat",
      "Infektion durch Genitaltrakttransplantat",
      "Infektion durch Intrauterinpessar",
      "Infektion durch Penisprothese",
      "Infektion durch Samenleiterimplantat",
      "Infektion durch Samenleiterprothese"
    ]
  },
  {
    "code": "T83.8",
    "name": "Fibrose durch Harnwegskatheter",
    "synonyms": [
      "Blutung durch einen Apparat im Genitaltrakt a.n.k.",
      "Blutung durch einen Apparat im Harntrakt a.n.k.",
      "Embolie durch Harnwegskatheter",
      "Embolie durch elektronischen Apparat im Harntrakt",
      "Fibrose durch Harnwegskatheter",
      "Fibrose durch elektronischen Apparat im Harntrakt",
      "Hämorrhagie durch einen Apparat im Genitaltrakt a.n.k.",
      "Hämorrhagie durch einen Apparat im Harntrakt a.n.k.",
      "Postoperativer Harnverhalt nach TVT",
      "Stenose durch Harnwegskatheter",
      "Thrombose durch Harnwegskatheter"
    ]
  },
  {
    "code": "T83.9",
    "name": "Komplikation durch Intrauterinpessar",
    "synonyms": [
      "Komplikation durch Blasenapparat",
      "Komplikation durch Genitaltraktimplantat",
      "Komplikation durch Genitaltraktprothese",
      "Komplikation durch Genitaltrakttransplantat",
      "Komplikation durch Harnröhrenkatheter",
      "Komplikation durch Harntraktimplantat",
      "Komplikation durch Intrauterinpessar",
      "Komplikation durch Prothese im Harntrakt",
      "Komplikation durch Samenleiterimplantat",
      "Komplikation durch Samenleiterprothese",
      "Komplikation durch Transplantat im Harntrakt",
      "Komplikation durch Urethrakatheter",
      "Komplikation durch elektronischen Blasenstimulator",
      "Komplikation durch implantierte Penisprothese",
      "Komplikation durch intrauterine Kontrazeptionseinlage"
    ]
  },
  {
    "code": "T84.00",
    "name": "Mechanische Komplikation einer Schultergelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Schultergelenkendoprothese"
    ]
  },
  {
    "code": "T84.01",
    "name": "Mechanische Komplikation einer Ellenbogengelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Ellenbogengelenkendoprothese"
    ]
  },
  {
    "code": "T84.02",
    "name": "Mechanische Komplikation einer Radiuskopfgelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Radiuskopfgelenkendoprothese"
    ]
  },
  {
    "code": "T84.03",
    "name": "Mechanische Komplikation einer Handgelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Handgelenkendoprothese"
    ]
  },
  {
    "code": "T84.04",
    "name": "Pfannenlockerung einer Hüftgelenktotalendoprothese [Hüft-TEP]",
    "synonyms": [
      "Bruch einer Hüftgelenktotalendoprothese [Hüft-TEP]",
      "Lockerung einer Hüftgelenktotalendoprothese [Hüft-TEP]",
      "Lockerung einer TEP [Totalendoprothese] des Hüftgelenks",
      "Luxation einer Hüftgelenktotalendoprothese [Hüft-TEP]",
      "Mechanische Komplikation einer Hüftgelenkendoprothese",
      "Pfannenlockerung einer Hüftgelenktotalendoprothese [Hüft-TEP]",
      "Pfannenlockerung einer TEP [Totalendoprothese] des Hüftgelenks",
      "Schaftlockerung einer TEP [Totalendoprothese] des Hüftgelenks"
    ]
  },
  {
    "code": "T84.05",
    "name": "Mechanische Komplikation einer Kniegelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Kniegelenkendoprothese"
    ]
  },
  {
    "code": "T84.06",
    "name": "Mechanische Komplikation einer Sprunggelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Sprunggelenkendoprothese"
    ]
  },
  {
    "code": "T84.07",
    "name": "Mechanische Komplikation einer Bandscheibenendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Bandscheibenendoprothese"
    ]
  },
  {
    "code": "T84.08",
    "name": "Mechanische Komplikation einer Fingergelenkendoprothese",
    "synonyms": [
      "Mechanische Komplikation einer Fingergelenkendoprothese",
      "Mechanische Komplikation einer Großzehengrundgelenkendoprothese",
      "Mechanische Komplikation einer Kiefergelenkendoprothese"
    ]
  },
  {
    "code": "T84.10",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Schulterregion",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Akromioklavikulargelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Schultergelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Sternoklavikulargelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Klavikula",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Schulterregion",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Skapula"
    ]
  },
  {
    "code": "T84.11",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Oberarm",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Ellenbogengelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Oberarm"
    ]
  },
  {
    "code": "T84.12",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Unterarm",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Handgelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Unterarm"
    ]
  },
  {
    "code": "T84.13",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Hand",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Hand"
    ]
  },
  {
    "code": "T84.14",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Beckenregion",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Hüftgelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Iliosakralgelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Oberschenkel",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Beckenregion"
    ]
  },
  {
    "code": "T84.15",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Unterschenkel",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Kniegelenk",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Unterschenkel"
    ]
  },
  {
    "code": "T84.16",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Knöchel",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Fuß",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Knöchel",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Sprunggelenk"
    ]
  },
  {
    "code": "T84.20",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Wirbelsäule",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Wirbelsäule"
    ]
  },
  {
    "code": "T84.28",
    "name": "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Rippe",
    "synonyms": [
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Schädelknochen",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung am Sternum",
      "Mechanische Komplikation durch eine interne Osteosynthesevorrichtung an der Rippe"
    ]
  },
  {
    "code": "T84.3",
    "name": "Fehllage eines elektronischen Knochenstimulators",
    "synonyms": [
      "Fehllage eines elektronischen Knochenstimulators",
      "Fehllage eines orthopädischen Knochentransplantates",
      "Mechanische Komplikation durch Knochenstimulator",
      "Mechanische Komplikation durch Knochentransplantat",
      "Mechanische Komplikation durch elektronischen Knochenstimulator"
    ]
  },
  {
    "code": "T84.4",
    "name": "Mechanische Komplikation durch elektronischen Muskelstimulator",
    "synonyms": [
      "Mechanische Komplikation durch Muskeltransplantat",
      "Mechanische Komplikation durch Sehnentransplantat",
      "Mechanische Komplikation durch elektronischen Muskelstimulator"
    ]
  },
  {
    "code": "T84.5",
    "name": "Entzündung durch Gelenkprothese",
    "synonyms": [
      "Entzündung durch Gelenkprothese",
      "Implantatassoziierte Infektion durch Gelenkendoprothese",
      "Infektion durch Gelenkprothese",
      "Infektion nach Schultergelenkendoprothese",
      "Periimplantäre Infektion durch Gelenkendoprothese",
      "Sepsis durch Gelenkprothese"
    ]
  },
  {
    "code": "T84.6",
    "name": "Entzündung einer inneren orthopädischen Fixation a.n.k.",
    "synonyms": [
      "Entzündung einer inneren orthopädischen Fixation a.n.k.",
      "Implantatassoziierte Infektion durch interne Osteosynthesevorrichtung",
      "Infektion einer inneren orthopädischen Fixation a.n.k.",
      "Periimplantäre Infektion durch interne Osteosynthesevorrichtung",
      "Sepsis durch innere orthopädische Fixation a.n.k."
    ]
  },
  {
    "code": "T84.7",
    "name": "Entzündung durch elektronische Knochenapparate",
    "synonyms": [
      "Entzündung durch ein Knochentransplantat",
      "Entzündung durch ein Muskeltransplantat",
      "Entzündung durch ein Sehnentransplantat",
      "Entzündung durch einen Knochenstimulator",
      "Entzündung durch einen elektronischen Muskelstimulator",
      "Entzündung durch elektronische Knochenapparate",
      "Infektion durch ein Knochentransplantat",
      "Infektion durch ein Muskeltransplantat",
      "Infektion durch ein Sehnentransplantat",
      "Infektion durch einen Knochenstimulator",
      "Infektion durch einen elektronischen Muskelstimulator",
      "Periimplantäre Infektion",
      "Periimplantäre implantatassoziierte Infektion",
      "Sepsis durch Osteosynthesevorrichtung"
    ]
  },
  {
    "code": "T84.8",
    "name": "Embolie durch Gelenkprothese",
    "synonyms": [
      "Blutung durch Gelenkprothese",
      "Blutung durch einen orthopädischen Apparat a.n.k.",
      "Blutung durch innere orthopädische Fixation a.n.k.",
      "Embolie durch Gelenkprothese",
      "Embolie durch innere orthopädische Fixation a.n.k.",
      "Embolie durch orthopädischen Apparat, orthopädisches Implantat oder orthopädisches Transplantat a.n.k.",
      "Fibrose durch Gelenkprothese",
      "Fibrose durch einen elektrischen Apparat im Knochen",
      "Fibrose durch innere orthopädische Fixation a.n.k.",
      "Hämorrhagie durch Gelenkprothese",
      "Hämorrhagie durch einen orthopädischen Apparat a.n.k.",
      "Hämorrhagie durch innere orthopädische Fixation a.n.k.",
      "Knochenzementreaktion",
      "Palacos-Reaktion",
      "Schmerzen durch Gelenkprothese",
      "Schmerzen durch innere orthopädische Fixation a.n.k.",
      "Stenose durch Gelenkprothese",
      "Stenose durch innere orthopädische Fixation a.n.k.",
      "Thrombose durch Gelenkprothese",
      "Thrombose durch innere orthopädische Fixation a.n.k."
    ]
  },
  {
    "code": "T84.9",
    "name": "Komplikation durch orthopädische Endoprothese",
    "synonyms": [
      "Beschwerden bei TEP [Totalendoprothese]",
      "Komplikation durch Gelenkimplantat",
      "Komplikation durch Gelenkprothese",
      "Komplikation durch Gelenktransplantat",
      "Komplikation durch Knochenstimulator",
      "Komplikation durch Knochentransplantat",
      "Komplikation durch Muskelstimulator",
      "Komplikation durch innere Gelenkprothese",
      "Komplikation durch inneres orthopädisches Fixationsgerät",
      "Komplikation durch orthopädische Endoprothese"
    ]
  },
  {
    "code": "T85.0",
    "name": "Liquorventildysfunktion",
    "synonyms": [
      "Dysfunktion eines ventrikulären Shunts",
      "Fehllage eines intrakraniellen ventrikulären Shunts",
      "Leckage eines intrakraniellen ventrikulären Shunts",
      "Liquorventildysfunktion",
      "Mechanische Komplikation durch intrakraniellen ventrikulären Shunt",
      "Mechanisches Problem eines intrakraniellen ventrikulären Shunts",
      "Obstruktion eines intrakraniellen ventrikulären Shunts",
      "Verlagerung eines intrakraniellen ventrikulären Shunts",
      "Versagen eines intrakraniellen ventrikulären Shunts"
    ]
  },
  {
    "code": "T85.1",
    "name": "Mechanische Komplikation durch Gehirnnervenstimulator",
    "synonyms": [
      "Fehllage eines elektronischen Apparates im Nervensystem",
      "Mechanische Komplikation durch Gehirnnervenstimulator",
      "Mechanische Komplikation durch elektronischen Stimulator im Nervensystem"
    ]
  },
  {
    "code": "T85.2",
    "name": "Dezentrierung einer IOL [Intraokulare Linse]",
    "synonyms": [
      "Dezentrierung einer IOL [Intraokulare Linse]",
      "Dislokation einer IOL [Intraokulare Linse]",
      "Eintrübung einer intraokularen Linse",
      "Fehllage einer intraokularen Linse",
      "Leckage durch eine intraokulare Linse",
      "Mechanische Komplikation durch intraokulare Linse",
      "Mechanische Obstruktion durch eine intraokulare Linse",
      "Mechanisches Versagen einer intraokularen Linse",
      "Perforation durch eine intraokulare Linse",
      "Protrusion einer intraokularen Linse",
      "Verlagerung einer intraokularen Linse"
    ]
  },
  {
    "code": "T85.3",
    "name": "Dislokation einer Keratoprothese",
    "synonyms": [
      "Dislokation einer Keratoprothese",
      "Extrusion eines Augenimplantates",
      "Fehllage eines Hornhauttransplantates a.n.k.",
      "Fibrose durch Hornhauttransplantat a.n.k.",
      "Leckage einer Orbitaprothese a.n.k.",
      "Leckage eines Hornhauttransplantates a.n.k.",
      "Mechanische Komplikation durch Augenimplantat",
      "Mechanische Komplikation durch Hornhauttransplantat",
      "Mechanisches Problem bei Augenprothese",
      "Prolaps einer Augenprothese",
      "Verlagerung einer Orbitaprothese a.n.k.",
      "Verlagerung eines Hornhauttransplantates a.n.k.",
      "Versagen einer Orbitaprothese a.n.k.",
      "Versagen eines Hornhauttransplantates a.n.k."
    ]
  },
  {
    "code": "T85.4",
    "name": "Perforation einer Mammaprothese",
    "synonyms": [
      "Fehllage einer Mammaprothese",
      "Fältelung einer Mammaprothese",
      "Kapselruptur einer Mammaprothese",
      "Leckage einer Mammaprothese",
      "Leckage eines Brustimplantates",
      "Mechanische Komplikation durch Brustimplantat",
      "Mechanisches Problem eines Brustimplantates",
      "Perforation einer Mammaprothese",
      "Perforation eines Brustimplantates",
      "Verlagerung einer Mammaprothese",
      "Verlagerung eines Brustimplantates",
      "Versagen eines Brustimplantates"
    ]
  },
  {
    "code": "T85.50",
    "name": "Mechanische Komplikation durch ösophageale Antirefluxvorrichtung",
    "synonyms": [
      "Mechanische Komplikation durch ösophageale Antirefluxvorrichtung"
    ]
  },
  {
    "code": "T85.51",
    "name": "Mechanische Komplikation durch perkutan-endoskopische Gastrostomie-Sonde",
    "synonyms": [
      "Mechanische Komplikation durch PEG-Sonde",
      "Mechanische Komplikation durch perkutan-endoskopische Gastrostomie-Sonde"
    ]
  },
  {
    "code": "T85.52",
    "name": "Mechanische Komplikation durch perkutan-endoskopische Jejunostomie-Sonde",
    "synonyms": [
      "Mechanische Komplikation durch PEJ-Sonde",
      "Mechanische Komplikation durch perkutan-endoskopische Jejunostomie-Sonde"
    ]
  },
  {
    "code": "T85.53",
    "name": "Mechanische Komplikation durch Gallengangsimplantat",
    "synonyms": [
      "Mechanische Komplikation durch Gallengangsimplantat",
      "Mechanische Komplikation durch Gallengangsprothese"
    ]
  },
  {
    "code": "T85.54",
    "name": "Mechanische Komplikation durch Implantate im Pankreas",
    "synonyms": [
      "Mechanische Komplikation durch Implantate im Pankreas",
      "Mechanische Komplikation durch Prothesen im Pankreas"
    ]
  },
  {
    "code": "T85.59",
    "name": "Leckage eines gastrointestinalen Implantates",
    "synonyms": [
      "Leckage eines gastrointestinalen Implantates",
      "Mechanische Komplikation durch gastrointestinales Ballon-Gerät",
      "Mechanisches Versagen eines gastrointestinalen Implantates",
      "Mechanisches Versagen eines gastrointestinalen Transplantates"
    ]
  },
  {
    "code": "T85.6",
    "name": "Mechanisches Problem mit Implantat",
    "synonyms": [
      "Dysfunktion eines Katheters zur Peritonealdialyse",
      "Fehllage eines Implantates",
      "Fehllage eines Transplantates",
      "Katheterdysfunktion a.n.k.",
      "Katheterfehllage a.n.k.",
      "Katheterleckage a.n.k.",
      "Katheterobstruktion a.n.k.",
      "Katheterverlagerung a.n.k.",
      "Katheterversagen a.n.k.",
      "Leckage eines Katheters zur Peritonealdialyse",
      "Leckage eines spinalen Infusionskatheters",
      "Mechanische Komplikation durch Dauernaht",
      "Mechanische Komplikation durch Implantat a.n.k.",
      "Mechanische Komplikation durch Katheter a.n.k.",
      "Mechanische Komplikation durch Katheter zur Peritonealdialyse",
      "Mechanische Komplikation durch Kinnplastik",
      "Mechanische Komplikation durch Nerventransplantat",
      "Mechanische Komplikation durch Prothese a.n.k.",
      "Mechanische Komplikation durch Spinalkatheter",
      "Mechanische Komplikation durch Transplantat a.n.k.",
      "Mechanisches Problem eines Katheters a.n.k.",
      "Mechanisches Problem mit Implantat",
      "Obstruktion durch Apparat, Implantat oder Transplantat",
      "Obstruktion eines Katheters zur Peritonealdialyse",
      "Obstruktion eines spinalen Infusionskatheters",
      "Problem durch Apparat, Implantat oder Transplantat",
      "Verlagerung durch Apparat, Implantat und Transplantat",
      "Verlagerung eines Katheters zur Peritonealdialyse",
      "Verlagerung eines spinalen Infusionskatheters"
    ]
  },
  {
    "code": "T85.71",
    "name": "Infektion durch Katheter zur Peritonealdialyse",
    "synonyms": [
      "Entzündung durch Katheter zur Peritonealdialyse",
      "Infektion durch Katheter zur Peritonealdialyse",
      "Sepsis durch Katheter zur Peritonealdialyse"
    ]
  },
  {
    "code": "T85.72",
    "name": "Entzündung durch intrakraniellen ventrikulären Shunt",
    "synonyms": [
      "Entzündung durch Gehirnnervenstimulator",
      "Entzündung durch Nerventransplantat",
      "Entzündung durch Spinalkatheter",
      "Entzündung durch einen elektronischen Stimulator im Nervensystem",
      "Entzündung durch intrakraniellen ventrikulären Shunt",
      "Entzündung durch spinalen Infusionskatheter",
      "Entzündung eines elektronischen Apparates im Nervensystem",
      "Infektion durch Gehirnnervenstimulator",
      "Infektion durch Nerventransplantat",
      "Infektion durch Spinalkatheter",
      "Infektion durch einen elektronischen Stimulator im Nervensystem",
      "Infektion durch intrakraniellen ventrikulären Shunt",
      "Sepsis durch intrakraniellen ventrikulären Shunt",
      "Sepsis durch spinalen Infusionskatheter"
    ]
  },
  {
    "code": "T85.73",
    "name": "Infektion durch Mammaprothese",
    "synonyms": [
      "Entzündliche Reaktion durch Mammaimplantat",
      "Entzündliche Reaktion durch Mammaprothese",
      "Infektion durch Mammaprothese",
      "Infektion durch Mammimplantat"
    ]
  },
  {
    "code": "T85.74",
    "name": "Infektion durch perkutan-endoskopische Gastrostomie-Sonde",
    "synonyms": [
      "Entzündliche Reaktion durch PEG-Sonde",
      "Entzündliche Reaktion durch PEJ-Sonde",
      "Entzündliche Reaktion durch perkutan-endoskopische Gastrostomie-Sonde",
      "Entzündliche Reaktion durch perkutan-endoskopische Jejunostomie-Sonde",
      "Infektion durch PEG-Sonde",
      "Infektion durch PEJ-Sonde",
      "Infektion durch perkutan-endoskopische Gastrostomie-Sonde",
      "Infektion durch perkutan-endoskopische Jejunostomie-Sonde"
    ]
  },
  {
    "code": "T85.75",
    "name": "Infektion durch interne Prothese im hepatobiliären System",
    "synonyms": [
      "Entzündliche Reaktion durch Implantat im Pankreas",
      "Entzündliche Reaktion durch Implantat im hepatobiliären System",
      "Entzündliche Reaktion durch interne Prothese im Pankreas",
      "Entzündliche Reaktion durch interne Prothese im hepatobiliären System",
      "Infektion durch Implantat im Pankreas",
      "Infektion durch Implantat im hepatobiliären System",
      "Infektion durch interne Prothese im Pankreas",
      "Infektion durch interne Prothese im hepatobiliären System"
    ]
  },
  {
    "code": "T85.76",
    "name": "Entzündliche Reaktion durch Implantat im Gastrointestinaltrakt",
    "synonyms": [
      "Entzündliche Reaktion durch Implantat im Gastrointestinaltrakt",
      "Entzündliche Reaktion durch Transplantat im Gastrointestinaltrakt",
      "Entzündliche Reaktion durch interne Prothese im Gastrointestinaltrakt",
      "Infektion durch Implantat im Gastrointestinaltrakt",
      "Infektion durch Transplantat im Gastrointestinaltrakt",
      "Infektion durch interne Prothese im Gastrointestinaltrakt"
    ]
  },
  {
    "code": "T85.78",
    "name": "Entzündung durch Apparat",
    "synonyms": [
      "Entzündung durch Apparat",
      "Entzündung durch Augenimplantat",
      "Entzündung durch Brustimplantat",
      "Entzündung durch Dauernaht",
      "Entzündung durch Gallengangsimplantat",
      "Entzündung durch Hornhauttransplantat a.n.k.",
      "Entzündung durch Implantat",
      "Entzündung durch Katheter a.n.k.",
      "Entzündung durch Kinnplastik",
      "Entzündung durch Orbitaprothese a.n.k.",
      "Entzündung durch Prothese a.n.k.",
      "Entzündung durch Transplantat",
      "Entzündung durch intraokulare Linsenprothese",
      "Entzündung durch ösophageale Antirefluxvorrichtung",
      "Infektion durch Apparate, Implantate oder Transplantate a.n.k.",
      "Infektion durch Augenimplantat",
      "Infektion durch Brustimplantat",
      "Infektion durch Dauernaht",
      "Infektion durch Gallengangsimplantat",
      "Infektion durch Hornhauttransplantat",
      "Infektion durch Katheter a.n.k.",
      "Infektion durch Kinnplastik",
      "Infektion durch Prothese a.n.k.",
      "Infektion durch intraokulare Linsenprothese",
      "Infektion durch ösophageale Antirefluxvorrichtung",
      "Sepsis durch Apparat",
      "Sepsis durch Brustimplantat",
      "Sepsis durch Hornhauttransplantat a.n.k.",
      "Sepsis durch Implantat",
      "Sepsis durch Katheter a.n.k.",
      "Sepsis durch Orbitaprothese a.n.k.",
      "Sepsis durch Transplantat"
    ]
  },
  {
    "code": "T85.81",
    "name": "Embolie durch intrakraniellen ventrikulären Shunt",
    "synonyms": [
      "Blutung durch intrakraniellen ventrikulären Shunt",
      "Embolie durch Spinalkatheter",
      "Embolie durch elektronischen Apparat im Nervensystem",
      "Embolie durch intrakraniellen ventrikulären Shunt",
      "Fibrose durch elektronischen Apparat im Nervensystem",
      "Fibrose durch intrakraniellen ventrikulären Shunt",
      "Hämorrhagie durch intrakraniellen ventrikulären Shunt",
      "Schmerzen durch intrakraniellen ventrikulären Shunt",
      "Schmerzen durch spinalen Infusionskatheter",
      "Stenose durch intrakraniellen ventrikulären Shunt",
      "Stenose durch spinalen Infusionskatheter",
      "Thrombose durch intrakraniellen ventrikulären Shunt",
      "Thrombose durch spinalen Infusionskatheter"
    ]
  },
  {
    "code": "T85.82",
    "name": "Kapselfibrose durch Mammaprothese",
    "synonyms": [
      "Fibrose durch Brustimplantat",
      "Kapselfibrose durch Mammaimplantat",
      "Kapselfibrose durch Mammaprothese"
    ]
  },
  {
    "code": "T85.83",
    "name": "Komplikation durch Mammaimplantat",
    "synonyms": [
      "Blutung durch Brustimplantat",
      "Embolie durch Brustimplantat",
      "Hämorrhagie durch Brustimplantat",
      "Komplikation durch Mammaimplantat",
      "Komplikation durch Mammaprothese",
      "Schmerzen durch Brustimplantat",
      "Stenose durch Brustimplantat",
      "Thrombose durch Brustimplantat"
    ]
  },
  {
    "code": "T85.88",
    "name": "Komplikation nach Plomben-OP",
    "synonyms": [
      "Blutung durch Apparate, Implantate oder Transplantate",
      "Blutung durch Hornhauttransplantat a.n.k.",
      "Blutung durch Katheter a.n.k.",
      "Blutung durch Orbitaprothese a.n.k.",
      "Blutung durch gastrointestinalen Apparat",
      "Embolie durch Hornhauttransplantat a.n.k.",
      "Embolie durch Katheter a.n.k.",
      "Embolie durch Katheter zur Peritonealdialyse",
      "Embolie durch Orbitaprothese a.n.k.",
      "Embolie durch gastrointestinalen Apparat, gastrointestinales Implantat oder gastrointestinales Transplantat",
      "Fibrose durch Katheter a.n.k.",
      "Hämorrhagie durch Apparate, Implantate oder Transplantate",
      "Hämorrhagie durch Hornhauttransplantat a.n.k.",
      "Hämorrhagie durch Katheter a.n.k.",
      "Hämorrhagie durch Orbitaprothese a.n.k.",
      "Hämorrhagie durch gastrointestinalen Apparat",
      "Komplikation nach Plomben-OP",
      "Krankheit durch Katheter a.n.k.",
      "Postinfektiöse Irisadhäsion durch Hornhauttransplantat a.n.k.",
      "Pumpentaschenserom",
      "Schmerzen durch Hornhauttransplantat a.n.k.",
      "Schmerzen durch Infusion a.n.k.",
      "Schmerzen durch Katheter a.n.k.",
      "Schmerzen durch Orbitaprothese a.n.k.",
      "Stenose durch Apparat, Implantat oder Transplantat",
      "Stenose durch Hornhauttransplantat a.n.k.",
      "Stenose durch Katheter a.n.k.",
      "Stenose durch Katheter zur Peritonealdialyse",
      "Stenose durch Orbitaprothese a.n.k.",
      "Thrombose durch Apparat, Implantat oder Transplantat",
      "Thrombose durch Hornhauttransplantat a.n.k.",
      "Thrombose durch Katheter a.n.k.",
      "Thrombose durch Katheter zur Peritonealdialyse",
      "Thrombose durch Orbitaprothese a.n.k."
    ]
  },
  {
    "code": "T85.9",
    "name": "Implantatproblem",
    "synonyms": [
      "Implantatproblem",
      "Komplikation durch Augenimplantat",
      "Komplikation durch Augenprothese",
      "Komplikation durch Augentransplantat",
      "Komplikation durch Brustimplantat",
      "Komplikation durch Brustprothese",
      "Komplikation durch Brusttransplantat",
      "Komplikation durch Bypass a.n.k.",
      "Komplikation durch Dauernaht",
      "Komplikation durch Drahtnaht",
      "Komplikation durch Gallengangsimplantat",
      "Komplikation durch Gallengangsprothese",
      "Komplikation durch Gehirnnervenstimulator",
      "Komplikation durch Hornhauttransplantat",
      "Komplikation durch Implantat",
      "Komplikation durch Katheter a.n.k.",
      "Komplikation durch Katheter zur Peritonealdialyse",
      "Komplikation durch Kinnplastik",
      "Komplikation durch Magen-Darm-Trakt-Implantat",
      "Komplikation durch Magen-Darm-Trakt-Prothese",
      "Komplikation durch Magen-Darm-Trakt-Transplantat",
      "Komplikation durch Nervenstimulator",
      "Komplikation durch Neurostimulator",
      "Komplikation durch Prothese",
      "Komplikation durch Re-Implantat a.n.k.",
      "Komplikation durch Shunt",
      "Komplikation durch Transplantat a.n.k.",
      "Komplikation durch eine Anastomose a.n.k.",
      "Komplikation durch gastrointestinales Ballon-Gerät",
      "Komplikation durch interne Prothese",
      "Komplikation durch internes Implantat",
      "Komplikation durch internes Transplantat",
      "Komplikation durch intraokulare Linsenprothese",
      "Komplikation durch nichtresorbierbares Dauernahtmaterial a.n.k.",
      "Komplikation durch respiratorischen Apparat",
      "Komplikation durch respiratorisches Implantat",
      "Komplikation durch respiratorisches Transplantat",
      "Komplikation durch ösophageale Antirefluxvorrichtung"
    ]
  },
  {
    "code": "T86.00",
    "name": "Knochenmarktransplantatabstoßung",
    "synonyms": [
      "Knochenmarktransplantatabstoßung",
      "Knochenmarktransplantatversagen",
      "Transplantatabstoßung nach Stammzelltransplantation"
    ]
  },
  {
    "code": "T86.01",
    "name": "Akute Graft-versus-Host-Krankheit, Grad II",
    "synonyms": [
      "Akute Graft-versus-Host-Krankheit, Grad I",
      "Akute Graft-versus-Host-Krankheit, Grad II"
    ]
  },
  {
    "code": "T86.02",
    "name": "Akute Graft-versus-Host-Krankheit, Grad IV",
    "synonyms": [
      "Akute Graft-versus-Host-Krankheit, Grad III",
      "Akute Graft-versus-Host-Krankheit, Grad IV"
    ]
  },
  {
    "code": "T86.05",
    "name": "Chronische Graft-versus-Host-Krankheit, milde Form",
    "synonyms": [
      "Chronische Graft-versus-Host-Krankheit, milde Form"
    ]
  },
  {
    "code": "T86.06",
    "name": "Chronische Graft-versus-Host-Krankheit, moderate Form",
    "synonyms": [
      "Chronische Graft-versus-Host-Krankheit, moderate Form"
    ]
  },
  {
    "code": "T86.07",
    "name": "Chronische Graft-versus-Host-Krankheit, schwere Form",
    "synonyms": [
      "Chronische Graft-versus-Host-Krankheit, schwere Form"
    ]
  },
  {
    "code": "T86.09",
    "name": "Graft-versus-Host-Reaktion",
    "synonyms": [
      "Graft-versus-Host-Krankheit",
      "Graft-versus-Host-Reaktion",
      "GvH-Krankheit - s.a. Graft-versus-host-Krankheit",
      "GvH-Reaktion"
    ]
  },
  {
    "code": "T86.10",
    "name": "Akute Nierentransplantatabstoßung",
    "synonyms": [
      "Abstoßungskrise nach Nierentransplantation",
      "Akute Funktionsverschlechterung eines Nierentransplantates",
      "Akute Nierentransplantatabstoßung"
    ]
  },
  {
    "code": "T86.11",
    "name": "Chronische Funktionsverschlechterung eines Nierentransplantates",
    "synonyms": [
      "Chronische Funktionsverschlechterung eines Nierentransplantates",
      "Chronische Nierentransplantatabstoßung"
    ]
  },
  {
    "code": "T86.12",
    "name": "Verzögerte Aufnahme der Funktion des Nierentransplantates",
    "synonyms": [
      "Verzögerte Aufnahme der Funktion des Nierentransplantates"
    ]
  },
  {
    "code": "T86.19",
    "name": "Nierentransplantatabstoßung",
    "synonyms": [
      "Nierentransplantatabstoßung",
      "Nierentransplantatversagen",
      "Transplantatversagen bei Zustand nach Nierentransplantation"
    ]
  },
  {
    "code": "T86.2",
    "name": "Herztransplantatversagen",
    "synonyms": [
      "Herztransplantatabstoßung",
      "Herztransplantatversagen"
    ]
  },
  {
    "code": "T86.3",
    "name": "Versagen eines Herz-Lungen-Transplantates",
    "synonyms": [
      "Abstoßung eines Herz-Lungen-Transplantates",
      "Versagen eines Herz-Lungen-Transplantates"
    ]
  },
  {
    "code": "T86.40",
    "name": "Lebertransplantatabstoßung innerhalb der ersten 28 Tage nach Transplantation",
    "synonyms": [
      "Funktionsverschlechterung eines Lebertransplantates innerhalb der ersten 28 Tage nach Transplantation",
      "Lebertransplantatabstoßung innerhalb der ersten 28 Tage nach Transplantation"
    ]
  },
  {
    "code": "T86.41",
    "name": "Lebertransplantatabstoßung 29 oder mehr Tage nach Transplantation",
    "synonyms": [
      "Funktionsverschlechterung eines Lebertransplantates 29 oder mehr Tage nach Transplantation",
      "Lebertransplantatabstoßung 29 oder mehr Tage nach Transplantation"
    ]
  },
  {
    "code": "T86.49",
    "name": "Lebertransplantatabstoßung",
    "synonyms": [
      "Lebertransplantatabstoßung",
      "Lebertransplantatversagen",
      "Transplantatversagen bei Zustand nach Lebertransplantation"
    ]
  },
  {
    "code": "T86.50",
    "name": "Durchblutungsstörung eines Hauttransplantates",
    "synonyms": [
      "Durchblutungsstörung eines Hauttransplantates",
      "Durchblutungsstörung eines Mammatransplantats mit Hautanteil",
      "Durchblutungsstörung eines fasziokutanen Transplantats",
      "Durchblutungsstörung eines lipokutanen Transplantats",
      "Durchblutungsstörung eines myokutanen Transplantats"
    ]
  },
  {
    "code": "T86.51",
    "name": "Nekrose eines Hauttransplantates",
    "synonyms": [
      "Nekrose eines Hauttransplantates",
      "Nekrose eines Mammatransplantats mit Hautanteil",
      "Nekrose eines fasziokutanen Transplantats",
      "Nekrose eines lipokutanen Transplantats",
      "Nekrose eines myokutanen Transplantats"
    ]
  },
  {
    "code": "T86.52",
    "name": "Verlust eines Hauttransplantates",
    "synonyms": [
      "Verlust eines Hauttransplantates",
      "Verlust eines Mammatransplantats mit Hautanteil",
      "Verlust eines fasziokutanen Transplantats",
      "Verlust eines lipokutanen Transplantats",
      "Verlust eines myokutanen Transplantats"
    ]
  },
  {
    "code": "T86.59",
    "name": "Komplikation durch Hauttransplantat",
    "synonyms": [
      "Abstoßung einer Mammaaugmentationsplastik mit Hautanteil",
      "Abstoßung einer Mammaplastik mit Hautanteil",
      "Abstoßung einer Mammaverschiebeplastik mit Hautanteil",
      "Abstoßung eines Mammatransplantats mit Hautanteil",
      "Abstoßung eines fasziokutanen Transplantats",
      "Abstoßung eines lipokutanen Transplantats",
      "Abstoßung eines myokutanen Transplantats",
      "Hauttransplantatabstoßung",
      "Hauttransplantatversagen",
      "Infektion eines Hauttransplantates",
      "Komplikation durch Hauttransplantat",
      "Mammatransplantatabstoßung mit Hautanteil",
      "Mammatransplantatversagen mit Hautanteil",
      "Versagen eines Mammatransplantats mit Hautanteil",
      "Versagen eines fasziokutanen Transplantats",
      "Versagen eines lipokutanen Transplantats",
      "Versagen eines myokutanen Transplantats"
    ]
  },
  {
    "code": "T86.81",
    "name": "Lungentransplantatabstoßung",
    "synonyms": [
      "Lungentransplantatabstoßung",
      "Lungentransplantatversagen"
    ]
  },
  {
    "code": "T86.82",
    "name": "Pankreastransplantatversagen",
    "synonyms": [
      "Pankreastransplantatabstoßung",
      "Pankreastransplantatversagen"
    ]
  },
  {
    "code": "T86.83",
    "name": "Hornhauttransplantatdekompensation",
    "synonyms": [
      "Akute Abstoßung eines Hornhauttransplantates",
      "Chronische Abstoßung eines Hornhauttransplantates",
      "Hornhauttransplantatdekompensation",
      "Hornhauttransplantatstörung"
    ]
  },
  {
    "code": "T86.84",
    "name": "Mammatransplantatabstoßung",
    "synonyms": [
      "Abstoßung einer Mammaaugmentationsplastik",
      "Abstoßung einer Mammaaugmentationsplastik ohne Hautanteil",
      "Abstoßung einer Mammaplastik",
      "Abstoßung einer Mammaplastik ohne Hautanteil",
      "Abstoßung einer Mammaverschiebeplastik",
      "Abstoßung einer Mammaverschiebeplastik ohne Hautanteil",
      "Abstoßung eines Mammatransplantats ohne Hautanteil",
      "Mammatransplantatabstoßung",
      "Mammatransplantatabstoßung ohne Hautanteil",
      "Mammatransplantatversagen",
      "Mammatransplantatversagen ohne Hautanteil",
      "Versagen eines Mammatransplantats ohne Hautanteil"
    ]
  },
  {
    "code": "T86.88",
    "name": "Knochentransplantatabstoßung",
    "synonyms": [
      "Darmtransplantatabstoßung",
      "Darmtransplantatversagen",
      "Knochentransplantatabstoßung",
      "Knochentransplantatversagen"
    ]
  },
  {
    "code": "T86.9",
    "name": "Transplantatabstoßung",
    "synonyms": [
      "Autotransplantatabstoßung",
      "Transplantatabstoßung",
      "Transplantatversagen"
    ]
  },
  {
    "code": "T87.2",
    "name": "Komplikation wieder angenähter Gliedmaßen",
    "synonyms": [
      "Abstoßung wieder angenähter Gliedmaßen",
      "Infektion wieder angenähter Gliedmaßen",
      "Komplikation wieder angenähter Gliedmaßen"
    ]
  },
  {
    "code": "T87.3",
    "name": "Amputationsstumpfneurom",
    "synonyms": [
      "Amputationsneurom",
      "Amputationsstumpfneurom",
      "Narbenneurom",
      "Nervenhyperregeneration [Narbenneurom]"
    ]
  },
  {
    "code": "T87.4",
    "name": "Amputationsstumpfinfektion",
    "synonyms": [
      "Amputationsstumpfentzündung",
      "Amputationsstumpfinfektion",
      "Infektion eines chirurgischen Amputationsstumpfes"
    ]
  },
  {
    "code": "T87.5",
    "name": "Amputationsstumpfnekrose",
    "synonyms": [
      "Amputationsstumpfnekrose",
      "Vaginalstumpfnekrose"
    ]
  },
  {
    "code": "T87.6",
    "name": "Nichtheilender Stumpf nach Amputation",
    "synonyms": [
      "Flexionskontraktur des Amputationsstumpfes",
      "Hämatom eines chirurgischen Amputationsstumpfes",
      "Komplikation durch chirurgischen Amputationsstumpf",
      "Kontraktur des Amputationsstumpfes",
      "Nichtheilender Stumpf nach Amputation",
      "Ödem eines chirurgischen Amputationsstumpfes",
      "Ödematöser chirurgischer Amputationsstumpf"
    ]
  },
  {
    "code": "T88.0",
    "name": "Infektion nach Impfung",
    "synonyms": [
      "Impfinfektion",
      "Infektion als Impfkomplikation",
      "Infektion nach Immunisierung",
      "Infektion nach Impfung",
      "Infektion nach Vakzination a.n.k.",
      "Postvakzinale Infektion",
      "Postvakzinale Pyämie",
      "Sepsis als Impfkomplikation",
      "Sepsis nach Immunisierung",
      "Sepsis nach Impfung",
      "Sepsis nach Vakzination",
      "Zellulitis nach Vakzination"
    ]
  },
  {
    "code": "T88.1",
    "name": "Impfkomplikation nach BCG [Bacille Calmette-Guérin]-Impfung",
    "synonyms": [
      "Allergische Reaktion nach Vakzination",
      "Ekzema vaccinatum durch Schutzimpfung",
      "Hautausschlag als Impfkomplikation",
      "Hautausschlag nach Impfung",
      "Hautausschlag nach Vakzination",
      "Hypoton-hyporesponsive Episode",
      "Impfkomplikation",
      "Impfkomplikation nach BCG [Bacille Calmette-Guérin]-Impfung",
      "Impfreaktion",
      "Impfstoffunverträglichkeit",
      "Komplikation durch Vakzination",
      "Mumpsähnliche Erkrankung nach Impfung",
      "Serumunverträglichkeit"
    ]
  },
  {
    "code": "T88.2",
    "name": "Schock durch Anästhesie",
    "synonyms": [
      "Lungenkollaps durch Anästhesie",
      "Pneumothorax durch Anästhesie",
      "Schock durch Anästhesie"
    ]
  },
  {
    "code": "T88.3",
    "name": "Maligne Hyperthermie durch Anästhesie",
    "synonyms": [
      "Bösartige Hyperpyrexie durch Anästhesie",
      "Maligne Hyperthermie durch Anästhesie"
    ]
  },
  {
    "code": "T88.4",
    "name": "Misslungene Intubation",
    "synonyms": [
      "Misslungene Intubation",
      "Problem durch Intubation bei Anästhesie",
      "Schwierige Intubation",
      "Versagen der Intubation während der Anästhesie"
    ]
  },
  {
    "code": "T88.5",
    "name": "Anästhesiekomplikation a.n.k.",
    "synonyms": [
      "Abnorme Anästhesiereaktion a.n.k.",
      "Abnorme Anästhesiewirkung",
      "Anästhesie mit Nebenwirkung a.n.k.",
      "Anästhesiekomplikation a.n.k.",
      "Gehirnschaden durch Anoxie nach chirurgischem Eingriff",
      "Hirnschaden durch Anoxie nach chirurgischem Eingriff",
      "Hypothermie nach Anästhesie",
      "Kopfschmerzen nach Spinal- und Epiduralanästhesie",
      "Kopfschmerzen nach Spinal- und Periduralanästhesie",
      "Periduralanästhesie mit Nebenwirkung",
      "Spinalanästhesie mit Nebenwirkung"
    ]
  },
  {
    "code": "T88.6",
    "name": "Anaphylaktische Reaktion auf Muskelrelaxantien",
    "synonyms": [
      "Anaphylaktische Reaktion auf Muskelrelaxantien"
    ]
  },
  {
    "code": "T88.7",
    "name": "Androgennebenwirkung",
    "synonyms": [
      "ACE-Hemmer-Allergie",
      "ACE-Hemmer-Überempfindlichkeit",
      "ACTH [Adrenocorticotropes Hormon]-Allergie",
      "ACTH [Adrenocorticotropes Hormon]-Überempfindlichkeit",
      "Abnorme Arzneimittelwirkung a.n.k.",
      "Aciclovir-Allergie",
      "Aciclovir-Überempfindlichkeit",
      "Acridin-Derivate-Allergie",
      "Acridin-Derivate-Überempfindlichkeit",
      "Adriblastinschädigung",
      "Allergie gegen adrenerge Mittel",
      "Allergie gegen halogenierte Kohlenwasserstoffe",
      "Allergie gegen jodhaltige Kontrastmittel",
      "Allergie gegen monoklonale Antikörper",
      "Allergie gegen normale humane Immunglobuline",
      "Allergie gegen trizyklische Antidepressiva",
      "Allergische Reaktion bei Therapie mit Platinverbindung",
      "Allergische Reaktion durch ein indikationsgerechtes Arzneimittel bei ordnungsgemäßer Verabreichung",
      "Allergische Reaktion durch eine indikationsgerechte Droge bei ordnungsgemäßer Verabreichung",
      "Allergisches Medikamentenexanthem",
      "Alpha-Adrenorezeptor-Antagonisten-Allergie",
      "Alpha-Adrenorezeptor-Antagonisten-Überempfindlichkeit",
      "Amantadin-Allergie",
      "Amantadin-Überempfindlichkeit",
      "Amid-Lokalanästhetika-Allergie",
      "Amid-Lokalanästhetika-Überempfindlichkeit",
      "Amidin-Allergie",
      "Amidin-Überempfindlichkeit",
      "Aminochinoline-Allergie",
      "Aminochinoline-Überempfindlichkeit",
      "Aminoglykosid-Allergie",
      "Aminoglykosid-Überempfindlichkeit",
      "Amoxicillin-Allergie",
      "Amoxicillin-Überempfindlichkeit",
      "Amphotericin-B-Allergie",
      "Amphotericin-B-Überempfindlichkeit",
      "Analgetikaintoleranz",
      "Androgennebenwirkung",
      "Anthracen-Derivate-Allergie",
      "Anthracen-Derivate-Überempfindlichkeit",
      "Anthracyclin-Allergie",
      "Anthracyclin-Überempfindlichkeit",
      "Antiandrogen-Nebenwirkung",
      "Antibiotikaunverträglichkeit",
      "Anticholinergika-Allergie",
      "Anticholinergika-Überempfindlichkeit",
      "Antidiabetika-Nebenwirkung",
      "Antihistaminika-Allergie",
      "Antihistaminika-Überempfindlichkeit",
      "Antiöstrogen-Nebenwirkung",
      "Arzneimittelallergie",
      "Arzneimittelbedingte Überhangeffekte",
      "Arzneimittelexanthem mit Eosinophilie und systemischen Symptomen",
      "Arzneimittelinduzierte Toleranzentwicklung",
      "Arzneimittelinduziertes Hypersensitivitätssyndrom",
      "Arzneimittelreaktion a.n.k.",
      "Arzneimittelunverträglichkeit",
      "Arzneimittelüberempfindlichkeit",
      "Atropin-Allergie",
      "Atropin-Überempfindlichkeit",
      "Azol-Derivate-Allergie",
      "Azol-Derivate-Überempfindlichkeit",
      "Baldrianwurzel-Allergie",
      "Baldrianwurzel-Überempfindlichkeit",
      "Barbiturate-Allergie",
      "Barbiturate-Überempfindlichkeit",
      "Benzamid-Allergie",
      "Benzamid-Überempfindlichkeit",
      "Benzimidazol-Derivate-Allergie",
      "Benzimidazol-Derivate-Überempfindlichkeit",
      "Benzodiazepin-Allergie",
      "Benzodiazepin-Überempfindlichkeit",
      "Beta-Adrenorezeptor-Antagonisten-Allergie",
      "Beta-Adrenorezeptor-Antagonisten-Überempfindlichkeit",
      "Beta-Laktamase-Inhibitoren-Allergie",
      "Beta-Laktamase-Inhibitoren-Überempfindlichkeit",
      "Betablocker-Allergie",
      "Betablocker-Überempfindlichkeit",
      "Betalaktam-Antibiotika-Allergie",
      "Betalaktam-Antibiotika-Überempfindlichkeit",
      "Bisphosphonat-Allergie",
      "Bisphosphonat-Überempfindlichkeit",
      "Butyrophenon-Derivate-Allergie",
      "Butyrophenon-Derivate-Überempfindlichkeit",
      "Carbamat-Allergie",
      "Carbamat-Überempfindlichkeit",
      "Carbamazepin-Allergie",
      "Carbamazepin-Überempfindlichkeit",
      "Carbapenem-Allergie",
      "Carbapenem-Überempfindlichkeit",
      "Cefotaxim-Allergie",
      "Cefotaxim-Überempfindlichkeit",
      "Cephalosporin-Allergie",
      "Cephalosporin-Überempfindlichkeit",
      "Chemotherapie-Nebenwirkung",
      "Chinolin-Allergie",
      "Chinolin-Überempfindlichkeit",
      "Chinolon-Allergie",
      "Chinolon-Überempfindlichkeit",
      "Chlormadinonacetat-Nebenwirkung",
      "Clindamycin-Allergie",
      "Clindamycin-Überempfindlichkeit",
      "Cyproteronazetat-Nebenwirkung",
      "DHEA [Dehydroepiandrosteron]-Sulfat-Nebenwirkung",
      "DRESS [Drug Rash with Eosinophilia and Systemic Symptoms]-Syndrom",
      "Dacarbazin-Allergie",
      "Dacarbazin-Überempfindlichkeit",
      "Darbepoetin-alfa-Allergie",
      "Darbepoetin-alfa-Überempfindlichkeit",
      "Dehydroepiandrosteronsulfat-Nebenwirkung",
      "Desirudin-Allergie",
      "Desirudin-Überempfindlichkeit",
      "Desogestrel-Nebenwirkung",
      "Dihydropyridin-Allergie",
      "Dihydropyridin-Überempfindlichkeit",
      "Diphenylbutylpiperidin-Allergie",
      "Diphenylbutylpiperidin-Überempfindlichkeit",
      "Drogenwirkung a.n.k.",
      "Erythromycin-Allergie",
      "Erythromycin-Überempfindlichkeit",
      "Ester-Lokalanästhetika-Allergie"
    ]
  },
  {
    "code": "T88.8",
    "name": "Postoperativer Schädeldefekt als Komplikation",
    "synonyms": [
      "Hospitalinfektion",
      "Myospherulose",
      "Nosokomialinfektion",
      "Paraffingranulom",
      "Paraffinom",
      "Postoperativer Schädeldefekt als Komplikation",
      "Reperfusionsverletzung (kein oder langsamer Rückfluss)"
    ]
  },
  {
    "code": "T88.9",
    "name": "Brillenfehlrefraktion",
    "synonyms": [
      "Brillenfehlrefraktion",
      "Komplikation bei Elektroschocktherapie a.n.k.",
      "Komplikation bei Phototherapie",
      "Komplikation bei Ultraschalltherapie a.n.k.",
      "Komplikation durch medizinische Maßnahmen",
      "Nebenwirkung einer medizinischen Behandlung",
      "Problem beim Tragen einer Brille",
      "Zwischenfall a.n.k.",
      "Zwischenfall bei lokaler Anwendung a.n.k.",
      "Zwischenfall bei medizinischer Behandlung"
    ]
  },
  {
    "code": "T89.03",
    "name": "Schlecht heilende Wunde",
    "synonyms": [
      "Schlecht heilende Wunde",
      "Sekundäre Wundheilung",
      "Sekundärheilung einer Wunde nach Trauma",
      "Verzögerte Behandlung einer offenen Wunde",
      "Verzögerte Wundheilung",
      "Verzögerte Wundheilung einer offenen Wunde",
      "Wunddehiszenz nach Trauma",
      "Wundheilungsstörung",
      "Wundheilungsstörung des Knies"
    ]
  },
  {
    "code": "T90.0",
    "name": "Folgen einer Gesichtsprellung",
    "synonyms": [
      "Folgen einer Gesichtsprellung",
      "Folgen einer Kopfprellung",
      "Folgen einer oberflächlichen Gesichtsverletzung",
      "Folgen einer oberflächlichen Kopfverletzung"
    ]
  },
  {
    "code": "T90.1",
    "name": "Folgen einer offenen Kopfwunde",
    "synonyms": [
      "Folgen einer offenen Gesichtswunde",
      "Folgen einer offenen Kopfwunde"
    ]
  },
  {
    "code": "T90.2",
    "name": "Folgen einer Schädelfraktur",
    "synonyms": [
      "Folgen einer Gesichtsknochenfraktur",
      "Folgen einer Schädelfraktur",
      "Folgen einer Schädelfraktur mit intrakraniellen Verletzung"
    ]
  },
  {
    "code": "T90.3",
    "name": "Folgen einer Verletzung der Hirnnerven",
    "synonyms": [
      "Folgen einer Verletzung der Hirnnerven"
    ]
  },
  {
    "code": "T90.4",
    "name": "Posttraumatische Iritis",
    "synonyms": [
      "Blindheit als Folgen einer Verletzung am Auge",
      "Folgen einer Augenverletzung",
      "Folgen einer Bulbusperforation",
      "Folgen einer Contusio bulbi",
      "Folgen einer Lidverletzung",
      "Folgen einer Orbitaverletzung",
      "Folgen einer offenen Augenwunde",
      "Folgen einer offenen Orbitawunde",
      "Posttraumatische Iritis"
    ]
  },
  {
    "code": "T90.5",
    "name": "Folgen einer intrakraniellen Verletzung",
    "synonyms": [
      "Epilepsia traumatica",
      "Folgen einer Gehirnverletzung",
      "Folgen einer intrakraniellen Verletzung",
      "Folgen einer traumatischen subduralen Blutung",
      "Traumatische Epilepsie"
    ]
  },
  {
    "code": "T90.8",
    "name": "Folgen einer Kieferdislokation",
    "synonyms": [
      "Folgen einer Blutgefäßverletzung des Kopfes",
      "Folgen einer Gesichtszerquetschung",
      "Folgen einer Kieferdislokation",
      "Folgen einer Kieferverstauchung",
      "Folgen einer Kieferzerrung",
      "Folgen einer Kopfzerquetschung",
      "Folgen einer Muskelverletzung des Gesichts",
      "Folgen einer Muskelverletzung des Kopfes",
      "Folgen einer Sehnenverletzung des Gesichts",
      "Folgen einer Sehnenverletzung des Kopfes",
      "Folgen einer traumatischen Gesichtsamputation",
      "Folgen einer traumatischen Kopfteilamputation"
    ]
  },
  {
    "code": "T90.9",
    "name": "Folgen einer Kopfverletzung",
    "synonyms": [
      "Folgen einer Kopfverletzung"
    ]
  },
  {
    "code": "T91.0",
    "name": "Folgen einer Rumpfprellung",
    "synonyms": [
      "Folgen einer Halsprellung",
      "Folgen einer Rumpfprellung",
      "Folgen einer oberflächlichen Halsverletzung",
      "Folgen einer oberflächlichen Rumpfverletzung",
      "Folgen einer offenen Halswunde",
      "Folgen einer offenen Rumpfwunde"
    ]
  },
  {
    "code": "T91.1",
    "name": "Folgen einer Fraktur der Wirbelsäule",
    "synonyms": [
      "Folgen einer Fraktur der Wirbelsäule"
    ]
  },
  {
    "code": "T91.2",
    "name": "Folgen einer Beckenfraktur",
    "synonyms": [
      "Folgen einer Beckenfraktur",
      "Folgen einer Thoraxfraktur"
    ]
  },
  {
    "code": "T91.3",
    "name": "Folgen einer Verletzung des Rückenmarks",
    "synonyms": [
      "Folgen einer Verletzung des Rückenmarks",
      "Traumatische Tetraplegie"
    ]
  },
  {
    "code": "T91.4",
    "name": "Folgen einer Verletzung intrathorakaler Organe",
    "synonyms": [
      "Folgen einer Verletzung intrathorakaler Organe"
    ]
  },
  {
    "code": "T91.5",
    "name": "Folgen einer Verletzung intraabdominaler Organe",
    "synonyms": [
      "Folgen einer Verletzung der Beckenorgane",
      "Folgen einer Verletzung intraabdominaler Organe"
    ]
  },
  {
    "code": "T91.8",
    "name": "Folgen einer Thoraxdislokation",
    "synonyms": [
      "Folgen einer Beckendislokation",
      "Folgen einer Blutgefäßverletzung des Abdomens",
      "Folgen einer Blutgefäßverletzung des Beckens",
      "Folgen einer Blutgefäßverletzung des Halses",
      "Folgen einer Blutgefäßverletzung des Thorax",
      "Folgen einer Dislokation der Lumbosakralgegend",
      "Folgen einer Halsdislokation",
      "Folgen einer Halsverstauchung",
      "Folgen einer Halszerquetschung",
      "Folgen einer Halszerrung",
      "Folgen einer Muskelverletzung des Halses",
      "Folgen einer Muskelverletzung des Rumpfes",
      "Folgen einer Nervenverletzung des Halses",
      "Folgen einer Nervenverletzung des Rumpfes",
      "Folgen einer Rumpfdislokation",
      "Folgen einer Rumpfverstauchung",
      "Folgen einer Rumpfzerquetschung",
      "Folgen einer Rumpfzerrung",
      "Folgen einer Sehnenverletzung des Halses",
      "Folgen einer Sehnenverletzung des Rumpfes",
      "Folgen einer Thoraxdislokation",
      "Folgen einer Verletzung der Spinalnervenwurzeln",
      "Folgen einer Verletzung eines Spinalnervenplexus",
      "Folgen einer spinalen Wirbelsäulenverletzung",
      "Folgen einer traumatischen Rumpfamputation"
    ]
  },
  {
    "code": "T91.9",
    "name": "Folgen einer Verletzung des Halses",
    "synonyms": [
      "Folgen einer Verletzung des Halses",
      "Folgen einer Verletzung des Rumpfes",
      "Folgen einer Verletzung innerer Organe"
    ]
  },
  {
    "code": "T92.0",
    "name": "Folgen einer offenen Wunde der oberen Extremität",
    "synonyms": [
      "Folgen einer offenen Wunde der oberen Extremität"
    ]
  },
  {
    "code": "T92.1",
    "name": "Folgen einer Fraktur des Arms",
    "synonyms": [
      "Folgen einer Fraktur der Schulter",
      "Folgen einer Fraktur des Arms",
      "Folgen einer Fraktur des Schultergürtels"
    ]
  },
  {
    "code": "T92.2",
    "name": "Folgen einer Fraktur in Höhe des Handgelenks",
    "synonyms": [
      "Folgen einer Daumenfraktur",
      "Folgen einer Fingerfraktur",
      "Folgen einer Fraktur in Höhe der Hand",
      "Folgen einer Fraktur in Höhe des Handgelenks"
    ]
  },
  {
    "code": "T92.3",
    "name": "Folgen einer Luxation der oberen Extremität",
    "synonyms": [
      "Folgen einer Dislokation der oberen Extremität",
      "Folgen einer Luxation der oberen Extremität",
      "Folgen einer Verstauchung der oberen Extremität",
      "Folgen einer Zerrung der oberen Extremität"
    ]
  },
  {
    "code": "T92.4",
    "name": "Folgen einer Verletzung der Nerven der oberen Extremität",
    "synonyms": [
      "Folgen einer Verletzung der Nerven der oberen Extremität"
    ]
  },
  {
    "code": "T92.5",
    "name": "Folgen einer Verletzung von Muskeln und Sehnen der oberen Extremität",
    "synonyms": [
      "Folgen einer Verletzung von Muskeln und Sehnen der oberen Extremität"
    ]
  },
  {
    "code": "T92.6",
    "name": "Folgen einer Zerquetschung der oberen Extremität",
    "synonyms": [
      "Folgen einer Zerquetschung der oberen Extremität",
      "Folgen einer traumatischen Amputation der oberen Extremität",
      "Stumpfschmerzen nach traumatischer Armamputation"
    ]
  },
  {
    "code": "T92.8",
    "name": "Folgen einer Prellung der oberen Extremität",
    "synonyms": [
      "Folgen einer Blutgefäßverletzung der oberen Extremität",
      "Folgen einer Prellung der oberen Extremität",
      "Folgen einer oberflächlichen Verletzung der oberen Extremität"
    ]
  },
  {
    "code": "T92.9",
    "name": "Folgen einer Verletzung der oberen Extremität",
    "synonyms": [
      "Folgen einer Verletzung der oberen Extremität"
    ]
  },
  {
    "code": "T93.0",
    "name": "Folgen einer offenen Wunde der unteren Extremität",
    "synonyms": [
      "Folgen einer offenen Wunde der unteren Extremität"
    ]
  },
  {
    "code": "T93.1",
    "name": "Folgen einer Femurfraktur",
    "synonyms": [
      "Folgen einer Femurfraktur",
      "Folgen einer Oberschenkelfraktur"
    ]
  },
  {
    "code": "T93.2",
    "name": "Folgen einer Unterschenkelfraktur",
    "synonyms": [
      "Folgen einer Beinfraktur",
      "Folgen einer Fußfraktur",
      "Folgen einer Unterschenkelfraktur"
    ]
  },
  {
    "code": "T93.3",
    "name": "Folgen einer Luxation der unteren Extremität",
    "synonyms": [
      "Folgen einer Dislokation der unteren Extremität",
      "Folgen einer Luxation der unteren Extremität",
      "Folgen einer Verstauchung der unteren Extremität",
      "Folgen einer Zerrung der unteren Extremität"
    ]
  },
  {
    "code": "T93.4",
    "name": "Folgen einer Verletzung der Nerven der unteren Extremität",
    "synonyms": [
      "Folgen einer Verletzung der Nerven der unteren Extremität"
    ]
  },
  {
    "code": "T93.5",
    "name": "Folgen einer Verletzung von Muskeln und Sehnen der unteren Extremität",
    "synonyms": [
      "Folgen einer Verletzung von Muskeln und Sehnen der unteren Extremität"
    ]
  },
  {
    "code": "T93.6",
    "name": "Folgen einer Zerquetschung der unteren Extremität",
    "synonyms": [
      "Folgen einer Zerquetschung der unteren Extremität",
      "Folgen einer traumatischen Amputation der unteren Extremität",
      "Stumpfschmerzen nach traumatischer Beinamputation"
    ]
  },
  {
    "code": "T93.8",
    "name": "Folgen einer Prellung der unteren Extremität",
    "synonyms": [
      "Folgen einer Blutgefäßverletzung der unteren Extremität",
      "Folgen einer Prellung der unteren Extremität",
      "Folgen einer oberflächlichen Verletzung der unteren Extremität"
    ]
  },
  {
    "code": "T93.9",
    "name": "Folgen einer Verletzung der unteren Extremität",
    "synonyms": [
      "Folgen einer Verletzung der unteren Extremität"
    ]
  },
  {
    "code": "T94.0",
    "name": "Folgen einer Fraktur multipler Körperregionen",
    "synonyms": [
      "Folgen einer Dislokation multipler Körperregionen",
      "Folgen einer Fraktur multipler Körperregionen",
      "Folgen einer Muskelverletzung multipler Körperregionen",
      "Folgen einer Nervenverletzung multipler Körperregionen",
      "Folgen einer Prellung multipler Körperregionen",
      "Folgen einer Sehnenverletzung multipler Körperregionen",
      "Folgen einer Verletzung multipler Körperregionen",
      "Folgen einer Verstauchung multipler Körperregionen",
      "Folgen einer Zerquetschung multipler Körperregionen",
      "Folgen einer Zerrung multipler Körperregionen",
      "Folgen einer oberflächlichen Verletzung multipler Körperregionen",
      "Folgen einer offenen Wunde multipler Körperregionen"
    ]
  },
  {
    "code": "T94.1",
    "name": "Verletzungsfolgen a.n.k.",
    "synonyms": [
      "Folgen einer Blutgefäßverletzung",
      "Folgen einer Dislokation",
      "Folgen einer Fraktur",
      "Folgen einer Muskelverletzung",
      "Folgen einer Nervenverletzung a.n.k.",
      "Folgen einer Prellung",
      "Folgen einer Sehnenverletzung",
      "Folgen einer Verstauchung",
      "Folgen einer Zerquetschung",
      "Folgen einer Zerrung",
      "Folgen einer oberflächlichen Verletzung",
      "Folgen einer offenen Wunde",
      "Folgen einer peripheren Nervenverletzung a.n.k.",
      "Folgen einer traumatischen Amputation",
      "Verletzungsfolgen a.n.k."
    ]
  },
  {
    "code": "T95.0",
    "name": "Folgen einer Verbrennung des Halses",
    "synonyms": [
      "Folgen einer Erfrierung des Gesichtes",
      "Folgen einer Erfrierung des Halses",
      "Folgen einer Erfrierung des Kopfes",
      "Folgen einer Verbrennung des Gesichtes",
      "Folgen einer Verbrennung des Halses",
      "Folgen einer Verbrennung des Kopfes",
      "Folgen einer Verätzung des Gesichtes",
      "Folgen einer Verätzung des Halses",
      "Folgen einer Verätzung des Kopfes"
    ]
  },
  {
    "code": "T95.1",
    "name": "Folgen einer Erfrierung des Rumpfes",
    "synonyms": [
      "Folgen einer Erfrierung des Rumpfes",
      "Folgen einer Verbrennung des Rumpfes",
      "Folgen einer Verätzung des Rumpfes"
    ]
  },
  {
    "code": "T95.2",
    "name": "Folgen einer Verbrennung der oberen Extremität",
    "synonyms": [
      "Folgen einer Erfrierung der oberen Extremität",
      "Folgen einer Verbrennung der oberen Extremität",
      "Folgen einer Verätzung der oberen Extremität"
    ]
  },
  {
    "code": "T95.3",
    "name": "Folgen einer Verbrennung der unteren Extremität",
    "synonyms": [
      "Folgen einer Erfrierung der unteren Extremität",
      "Folgen einer Verbrennung der unteren Extremität",
      "Folgen einer Verätzung der unteren Extremität"
    ]
  },
  {
    "code": "T95.8",
    "name": "Folgen einer Erfrierung des Auges",
    "synonyms": [
      "Folgen einer Erfrierung des Auges",
      "Folgen einer Erfrierung multipler Körperregionen",
      "Folgen einer Verbrennung des Auges",
      "Folgen einer Verbrennung multipler Körperregionen",
      "Folgen einer Verätzung des Auges",
      "Folgen einer Verätzung multipler Körperregionen"
    ]
  },
  {
    "code": "T95.9",
    "name": "Erfrierungsfolgen",
    "synonyms": [
      "Erfrierungsfolgen",
      "Folgen einer Verbrennung",
      "Folgen einer Verätzung",
      "Verbrennungsschock"
    ]
  },
  {
    "code": "T96",
    "name": "Thorotrastfibrose",
    "synonyms": [
      "Thorotrastfibrose",
      "Thorotrastleber",
      "Thorotrastom",
      "Thorotrastorgan",
      "Thorotrastschaden"
    ]
  },
  {
    "code": "T97",
    "name": "Folgen einer Alkoholvergiftung",
    "synonyms": [
      "Folgen einer Alkoholvergiftung",
      "Folgen einer Kohlenmonoxidvergiftung"
    ]
  },
  {
    "code": "T98.0",
    "name": "Folgen eines Fremdkörpers in den Atemwegen",
    "synonyms": [
      "Folgen eines Fremdkörpers in den Atemwegen"
    ]
  },
  {
    "code": "T98.1",
    "name": "Folgen eines Schadens durch äußere Ursachen a.n.k.",
    "synonyms": [
      "Folgen eines Schadens durch Strahlung",
      "Folgen eines Schadens durch äußere Ursachen a.n.k."
    ]
  },
  {
    "code": "T98.2",
    "name": "Folgen einer traumatischen Luftembolie",
    "synonyms": [
      "Folgen einer posttraumatischen Wundinfektion",
      "Folgen einer traumatischen Fettembolie",
      "Folgen einer traumatischen Luftembolie"
    ]
  },
  {
    "code": "T98.3",
    "name": "Reanimationsfolgen",
    "synonyms": [
      "Folgen nach Behandlung mit immunsuppressiven Medikamenten",
      "Postoperative Folgen einer Amputation a.n.k.",
      "Reanimationsfolgen"
    ]
  },
  {
    "code": "U04.9",
    "name": "Schweres akutes respiratorisches Syndrom [SARS]",
    "synonyms": [
      "SARS [Schweres akutes respiratorisches Syndrom]",
      "Schweres akutes respiratorisches Syndrom [SARS]"
    ]
  },
  {
    "code": "U08.9",
    "name": "COVID-19 in der Eigenanamnese",
    "synonyms": [
      "COVID-19 in der Eigenanamnese"
    ]
  },
  {
    "code": "U10.9",
    "name": "Multisystemisches Entzündungssyndrom in Verbindung mit COVID-19",
    "synonyms": [
      "Kawasaki-like-Syndrom zeitlich assoziiert mit COVID-19",
      "MIS-C [Multisystem Inflammatory Syndrome in Children] zeitlich assoziiert mit COVID-19",
      "Multisystem Inflammatory Syndrome in Children zeitlich assoziiert mit COVID-19",
      "Multisystemisches Entzündungssyndrom in Verbindung mit COVID-19",
      "PIMS [Paediatric Inflammatory Multisystem Syndrome] zeitlich assoziiert mit COVID-19",
      "Paediatric Inflammatory Multisystem Syndrome zeitlich assoziiert mit COVID-19",
      "Zytokinsturm zeitlich assoziiert mit COVID-19"
    ]
  },
  {
    "code": "U11.9",
    "name": "Notwendigkeit der Impfung gegen COVID-19",
    "synonyms": [
      "Notwendigkeit der Immunisierung gegen COVID-19",
      "Notwendigkeit der Impfung gegen COVID-19",
      "Notwendigkeit einer COVID-19-Immunisierung",
      "Notwendigkeit einer COVID-19-Impfung",
      "Prophylaktische COVID-19-Impfung"
    ]
  },
  {
    "code": "U50.00",
    "name": "Barthel-Index 100 Punkte",
    "synonyms": [
      "Barthel-Index 100 Punkte"
    ]
  },
  {
    "code": "U50.01",
    "name": "Motorischer FIM [Functional Independence Measure] 85-91 Punkte",
    "synonyms": [
      "Motorischer FIM [Functional Independence Measure] 85-91 Punkte"
    ]
  },
  {
    "code": "U50.10",
    "name": "Barthel-Index 80-95 Punkte",
    "synonyms": [
      "Barthel-Index 80-95 Punkte"
    ]
  },
  {
    "code": "U50.11",
    "name": "Motorischer FIM [Functional Independence Measure] 69-84 Punkte",
    "synonyms": [
      "Motorischer FIM [Functional Independence Measure] 69-84 Punkte"
    ]
  },
  {
    "code": "U50.20",
    "name": "Barthel-Index 60-75 Punkte",
    "synonyms": [
      "Barthel-Index 60-75 Punkte"
    ]
  },
  {
    "code": "U50.21",
    "name": "Motorischer FIM [Functional Independence Measure] 59-68 Punkte",
    "synonyms": [
      "Motorischer FIM [Functional Independence Measure] 59-68 Punkte"
    ]
  },
  {
    "code": "U50.30",
    "name": "Barthel-Index 40-55 Punkte",
    "synonyms": [
      "Barthel-Index 40-55 Punkte"
    ]
  },
  {
    "code": "U50.31",
    "name": "Motorischer FIM [Functional Independence Measure] 43-58 Punkte",
    "synonyms": [
      "Motorischer FIM [Functional Independence Measure] 43-58 Punkte"
    ]
  },
  {
    "code": "U50.40",
    "name": "Barthel-Index 20-35 Punkte",
    "synonyms": [
      "Barthel-Index 20-35 Punkte"
    ]
  },
  {
    "code": "U50.41",
    "name": "Motorischer FIM [Functional Independence Measure] 31-42 Punkte",
    "synonyms": [
      "Motorischer FIM [Functional Independence Measure] 31-42 Punkte"
    ]
  },
  {
    "code": "U50.50",
    "name": "Barthel-Index 0-15 Punkte",
    "synonyms": [
      "Barthel-Index 0-15 Punkte"
    ]
  },
  {
    "code": "U50.51",
    "name": "Motorischer FIM [Functional Independence Measure] 13-30 Punkte",
    "synonyms": [
      "Motorischer FIM [Functional Independence Measure] 13-30 Punkte"
    ]
  },
  {
    "code": "U51.00",
    "name": "Erweiterter Barthel-Index 70-90 Punkte",
    "synonyms": [
      "Erweiterter Barthel-Index 70-90 Punkte"
    ]
  },
  {
    "code": "U51.01",
    "name": "Kognitiver FIM [Functional Independence Measure] 30-35 Punkte",
    "synonyms": [
      "Kognitiver FIM [Functional Independence Measure] 30-35 Punkte"
    ]
  },
  {
    "code": "U51.02",
    "name": "MMSE [Mini-Mental State Examination] 24-30 Punkte",
    "synonyms": [
      "MMSE [Mini-Mental State Examination] 24-30 Punkte"
    ]
  },
  {
    "code": "U51.10",
    "name": "Erweiterter Barthel-Index 20-65 Punkte",
    "synonyms": [
      "Erweiterter Barthel-Index 20-65 Punkte"
    ]
  },
  {
    "code": "U51.11",
    "name": "Kognitiver FIM [Functional Independence Measure] 11-29 Punkte",
    "synonyms": [
      "Kognitiver FIM [Functional Independence Measure] 11-29 Punkte"
    ]
  },
  {
    "code": "U51.12",
    "name": "MMSE [Mini-Mental State Examination] 17-23 Punkte",
    "synonyms": [
      "MMSE [Mini-Mental State Examination] 17-23 Punkte"
    ]
  },
  {
    "code": "U51.20",
    "name": "Erweiterter Barthel-Index 0-15 Punkte",
    "synonyms": [
      "Erweiterter Barthel-Index 0-15 Punkte"
    ]
  },
  {
    "code": "U51.21",
    "name": "Kognitiver FIM [Functional Independence Measure] 5-10 Punkte",
    "synonyms": [
      "Kognitiver FIM [Functional Independence Measure] 5-10 Punkte"
    ]
  },
  {
    "code": "U51.22",
    "name": "MMSE [Mini-Mental State Examination] 0-16 Punkte",
    "synonyms": [
      "MMSE [Mini-Mental State Examination] 0-16 Punkte"
    ]
  },
  {
    "code": "U52.0",
    "name": "Frührehabilitations-Barthel-Index nach Schönle 31 und mehr Punkte",
    "synonyms": [
      "Frührehabilitations-Barthel-Index nach Schönle 31 und mehr Punkte"
    ]
  },
  {
    "code": "U52.1",
    "name": "Frührehabilitations-Barthel-Index nach Schönle -75 bis 30 Punkte",
    "synonyms": [
      "Frührehabilitations-Barthel-Index nach Schönle -75 bis 30 Punkte"
    ]
  },
  {
    "code": "U52.2",
    "name": "Frührehabilitations-Barthel-Index nach Schönle -200 bis -76 Punkte",
    "synonyms": [
      "Frührehabilitations-Barthel-Index nach Schönle -200 bis -76 Punkte"
    ]
  },
  {
    "code": "U52.3",
    "name": "Frührehabilitations-Barthel-Index nach Schönle weniger als -200 Punkte",
    "synonyms": [
      "Frührehabilitations-Barthel-Index nach Schönle weniger als -200 Punkte"
    ]
  },
  {
    "code": "U55.10",
    "name": "Registrierung zur Herztransplantation ohne Dringlichkeitsstufe U [Urgency] oder HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Herztransplantation ohne Dringlichkeitsstufe U [Urgency] oder HU [High Urgency]"
    ]
  },
  {
    "code": "U55.11",
    "name": "Registrierung zur Herztransplantation mit Dringlichkeitsstufe U [Urgency]",
    "synonyms": [
      "Registrierung zur Herztransplantation mit Dringlichkeitsstufe U [Urgency]"
    ]
  },
  {
    "code": "U55.12",
    "name": "Registrierung zur Herztransplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Herztransplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "U55.20",
    "name": "Registrierung zur Lungentransplantation ohne Dringlichkeitsstufe U [Urgency] oder HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Lungentransplantation ohne Dringlichkeitsstufe U [Urgency] oder HU [High Urgency]"
    ]
  },
  {
    "code": "U55.21",
    "name": "Registrierung zur Lungentransplantation mit Dringlichkeitsstufe U [Urgency]",
    "synonyms": [
      "Registrierung zur Lungentransplantation mit Dringlichkeitsstufe U [Urgency]"
    ]
  },
  {
    "code": "U55.22",
    "name": "Registrierung zur Lungentransplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Lungentransplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "U55.30",
    "name": "Registrierung zur Herz-Lungen-Transplantation ohne Dringlichkeitsstufe U [Urgency] oder HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Herz-Lungen-Transplantation ohne Dringlichkeitsstufe U [Urgency] oder HU [High Urgency]"
    ]
  },
  {
    "code": "U55.31",
    "name": "Registrierung zur Herz-Lungen-Transplantation mit Dringlichkeitsstufe U [Urgency]",
    "synonyms": [
      "Registrierung zur Herz-Lungen-Transplantation mit Dringlichkeitsstufe U [Urgency]"
    ]
  },
  {
    "code": "U55.32",
    "name": "Registrierung zur Herz-Lungen-Transplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Herz-Lungen-Transplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z00.0",
    "name": "Check up",
    "synonyms": [
      "Allgemeine Untersuchung",
      "Check up",
      "Durchuntersuchung",
      "Erstuntersuchung eines neuen Patienten",
      "Gesundheitsuntersuchung",
      "Jugendvorsorgeuntersuchung",
      "Periodische Untersuchung",
      "Routineuntersuchung",
      "Vorsorge a.n.k.",
      "Vorsorgeuntersuchung a.n.k.",
      "Ärztliche Allgemeinuntersuchung"
    ]
  },
  {
    "code": "Z00.1",
    "name": "Gesundheitsvorsorgeuntersuchung beim Kind (U1, U2, U3, usw.)",
    "synonyms": [
      "Check up beim Kleinkind",
      "Ernährungsberatung beim Kleinkind",
      "Gesundheitsvorsorgeuntersuchung beim Kind (U1, U2, U3, usw.)",
      "Intelligenztest beim Kind",
      "Kindervorsorgeuntersuchung a.n.k.",
      "Kleinkindervorsorgeuntersuchung a.n.k.",
      "Kontrolle des Entwicklungsstandes eines Kindes",
      "Kontrolle des Entwicklungsstandes eines Kleinkindes",
      "Prüfung des Entwicklungsstandes eines Kindes",
      "Prüfung des Entwicklungsstandes eines Säuglings",
      "Untersuchung beim Kind",
      "Untersuchung beim Kleinkind",
      "Untersuchung des gesunden Säuglings"
    ]
  },
  {
    "code": "Z00.2",
    "name": "Untersuchung aufgrund eines Wachstumsschubs in der Kindheit",
    "synonyms": [
      "Beschleunigtes Wachstum in der Kindheit",
      "Kontrolle des Entwicklungsstandes aufgrund eins Wachstumsschubs in der Kindheit",
      "Untersuchung aufgrund eines Wachstumsschubs in der Kindheit"
    ]
  },
  {
    "code": "Z00.3",
    "name": "Untersuchung aufgrund des Entwicklungsstandes während der Adoleszenz",
    "synonyms": [
      "Untersuchung aufgrund des Entwicklungsstandes während der Adoleszenz",
      "Untersuchung aufgrund des Pubertätsstadiums"
    ]
  },
  {
    "code": "Z00.4",
    "name": "Psychiatrische Untersuchung a.n.k.",
    "synonyms": [
      "Psychiatrische Untersuchung a.n.k."
    ]
  },
  {
    "code": "Z00.5",
    "name": "Untersuchung potentieller Organ- oder Gewebespender",
    "synonyms": [
      "Untersuchung potentieller Organ- oder Gewebespender"
    ]
  },
  {
    "code": "Z00.6",
    "name": "Ärztliche Untersuchung einer Kontrollperson für klinische Forschungszwecke",
    "synonyms": [
      "Ärztliche Untersuchung einer Kontrollperson für klinische Forschungszwecke"
    ]
  },
  {
    "code": "Z00.8",
    "name": "Untersuchung des Gesundheitszustandes bei Bevölkerungsstichproben",
    "synonyms": [
      "Untersuchung des Gesundheitszustandes bei Bevölkerungsstichproben",
      "Ärztliche Untersuchung wegen Bevölkerungserhebung"
    ]
  },
  {
    "code": "Z01.0",
    "name": "Visusprüfung und Untersuchung der Augen",
    "synonyms": [
      "Untersuchung des Sehvermögens",
      "Visusprüfung",
      "Visusprüfung und Untersuchung der Augen",
      "Visustest"
    ]
  },
  {
    "code": "Z01.1",
    "name": "Hörprüfung und Untersuchung der Ohren",
    "synonyms": [
      "Hörprüfung und Untersuchung der Ohren",
      "Hörtest",
      "Untersuchung des Hörvermögens"
    ]
  },
  {
    "code": "Z01.2",
    "name": "Untersuchung der Zähne",
    "synonyms": [
      "Untersuchung der Zähne",
      "Zahnärztliche Untersuchung"
    ]
  },
  {
    "code": "Z01.3",
    "name": "Blutdruckmessung",
    "synonyms": [
      "Blutdruckmessung",
      "Blutdrucktest",
      "Blutdruckuntersuchung"
    ]
  },
  {
    "code": "Z01.4",
    "name": "Gynäkologische Untersuchung",
    "synonyms": [
      "Allgemeine gynäkologische Untersuchung",
      "Gynäkologische Routineuntersuchung",
      "Gynäkologische Untersuchung",
      "Gynäkologische Vorsorgeuntersuchung a.n.k.",
      "Papanicolaou-Abstrich",
      "Routinemäßige Untersuchung des weiblichen Beckens",
      "Routinemäßiger Papanicolaou-Abstrich der Cervix uteri",
      "Routinemäßiger Papanicolaou-Abstrich der Zervix"
    ]
  },
  {
    "code": "Z01.5",
    "name": "Diagnostische Sensibilisierungstestung",
    "synonyms": [
      "Allergentestung",
      "Diagnostische Hauttestung",
      "Diagnostische Sensibilisierungstestung",
      "Diagnostischer Hauttest auf Überempfindlichkeit",
      "Hauttest auf Hypersensitivität",
      "Hauttest auf eine bakterielle Krankheit",
      "Hautuntersuchung",
      "Hautuntersuchung auf Überempfindlichkeit",
      "Untersuchung einer Allergie",
      "Untersuchung einer Überempfindlichkeit"
    ]
  },
  {
    "code": "Z01.6",
    "name": "Röntgenuntersuchung",
    "synonyms": [
      "Galaktographie",
      "Radiologische Untersuchung a.n.k.",
      "Routinemäßige Mammographie",
      "Routinemäßige Röntgenuntersuchung a.n.k.",
      "Routinemäßige Röntgenuntersuchung des Thorax",
      "Routinemäßiges Mammogramm",
      "Röntgenuntersuchung"
    ]
  },
  {
    "code": "Z01.7",
    "name": "Laboruntersuchung",
    "synonyms": [
      "Antibiogramm",
      "Antikörpersuchtest",
      "Bakterielle Kultur mit Resistenzbestimmung",
      "Blutgruppenbestimmung",
      "Exfoliativzytodiagnostik",
      "Laborparameteruntersuchung",
      "Laboruntersuchung",
      "Test eines Laborparameters"
    ]
  },
  {
    "code": "Z01.80",
    "name": "Abklärung einer Disposition für maligne Herzrhythmusstörungen",
    "synonyms": [
      "Abklärung einer Disposition für maligne Herzrhythmusstörungen"
    ]
  },
  {
    "code": "Z01.81",
    "name": "Abklärung einer Disposition für Kardiomyopathien",
    "synonyms": [
      "Abklärung einer Disposition für Kardiomyopathien"
    ]
  },
  {
    "code": "Z01.88",
    "name": "Dual-Photonen-Absorptiometrie",
    "synonyms": [
      "Dual-Photonen-Absorptiometrie",
      "Dual-X-ray-Absorptiometrie",
      "Ganzkörperknochenszintigraphie",
      "Ganzkörperszintigraphie",
      "Humangenetische Untersuchung",
      "Intelligenztest a.n.k."
    ]
  },
  {
    "code": "Z01.9",
    "name": "Spezielle Untersuchung",
    "synonyms": [
      "Spezielle Untersuchung"
    ]
  },
  {
    "code": "Z02",
    "name": "Aufnahmeuntersuchung für Bildungseinrichtung",
    "synonyms": [
      "Attestausstellung",
      "Aufnahmeuntersuchung für Altersheim",
      "Aufnahmeuntersuchung für Bildungseinrichtung",
      "Aufnahmeuntersuchung für Streitkräfte",
      "Aufnahmeuntersuchung für Wohneinrichtung",
      "Ausstellung einer ärztlichen Bescheinigung",
      "Ausstellung einer ärztlichen Bescheinigung zur Invalidität",
      "Ausstellung einer ärztlichen Bescheinigung zur Nichttauglichkeit",
      "Ausstellung einer ärztlichen Bescheinigung zur Tauglichkeit",
      "Ausstellung einer ärztlichen Bescheinigung zur Todesursache",
      "Einstellungsuntersuchung",
      "Führerscheinuntersuchung",
      "Konsultation wegen Bescheinigungen für Verwaltungszwecke",
      "Musterungsuntersuchung",
      "Sportuntersuchung",
      "Untersuchung wegen Adoption",
      "Untersuchung wegen Aufnahme in ein Ferienlager",
      "Untersuchung wegen Aufnahme in eine Haftanstalt",
      "Untersuchung wegen Eheschließung",
      "Untersuchung wegen Einbürgerung",
      "Untersuchung wegen Einwanderung",
      "Untersuchung zu Versicherungszwecken",
      "Untersuchung zur Aufnahme in die Vorschule",
      "Untersuchung zur Teilnahme am Sport",
      "Ärztliche Untersuchung wegen Bescheinigungen für Verwaltungszwecke",
      "Ärztliche Untersuchung wegen Fahrerlaubnis",
      "Ärztliche Untersuchung wegen Schulzulassung"
    ]
  },
  {
    "code": "Z03.0",
    "name": "Beobachtung bei Verdacht auf Tuberkulose",
    "synonyms": [
      "Abklärung bei Verdacht auf Tuberkulose",
      "Beobachtung bei Verdacht auf Tuberkulose"
    ]
  },
  {
    "code": "Z03.1",
    "name": "Beobachtung bei Verdacht auf bösartige Neubildung",
    "synonyms": [
      "Abklärung bei Verdacht auf bösartige Neubildung",
      "Beobachtung bei Verdacht auf bösartige Neubildung"
    ]
  },
  {
    "code": "Z03.2",
    "name": "Beobachtung bei Verdacht auf Verhaltensstörung",
    "synonyms": [
      "Abklärung bei Verdacht auf Verhaltensstörung",
      "Abklärung bei Verdacht auf psychische Krankheit",
      "Abklärung bei Verdacht auf psychische Störung",
      "Abklärung von Bandenverhalten ohne manifeste psychische Störung",
      "Abklärung von dissozialem Verhalten ohne manifeste psychische Störung",
      "Auffälliges Sozialverhalten ohne manifeste psychiatrische Störung",
      "Bandenaktivität ohne Manifestation einer psychischen Verhaltensstörung",
      "Beobachtung bei Verdacht auf Verhaltensstörung",
      "Beobachtung bei Verdacht auf psychische Krankheit",
      "Beobachtung wegen Brandstiftung",
      "Beobachtung wegen Brandstiftung ohne manifeste psychische Störung",
      "Beobachtung wegen Ladendiebstahl ohne manifeste psychische Störung"
    ]
  },
  {
    "code": "Z03.3",
    "name": "Beobachtung bei Verdacht auf neurologische Krankheit",
    "synonyms": [
      "Abklärung bei Verdacht auf Gehirnerschütterung",
      "Abklärung bei Verdacht auf neurologische Krankheit",
      "Beobachtung bei Verdacht auf neurologische Krankheit"
    ]
  },
  {
    "code": "Z03.4",
    "name": "Beobachtung bei Verdacht auf Herzinfarkt",
    "synonyms": [
      "Abklärung bei Verdacht auf Herzinfarkt",
      "Beobachtung bei Verdacht auf Herzinfarkt"
    ]
  },
  {
    "code": "Z03.5",
    "name": "Abklärung bei Verdacht auf Herz-Kreislauf-Krankheit a.n.k.",
    "synonyms": [
      "Abklärung bei Verdacht auf Herz-Kreislauf-Krankheit a.n.k.",
      "Abklärung bei Verdacht auf Herzkrankheit a.n.k."
    ]
  },
  {
    "code": "Z03.6",
    "name": "Abklärung bei unerwünschter Nebenwirkung eines Arzneimittels",
    "synonyms": [
      "Abklärung bei angeblichem Verdacht auf Selbstbeschädigung",
      "Abklärung bei angeblichem Verdacht auf Selbsttötung",
      "Abklärung bei angeblichem Verdacht auf Selbstvergiftung",
      "Abklärung bei unerwünschter Nebenwirkung eines Arzneimittels",
      "Abklärung der toxischen Wirkungen einer aufgenommenen Substanz"
    ]
  },
  {
    "code": "Z03.8",
    "name": "Abklärung bei angeblichem Selbstmordversuch a.n.k.",
    "synonyms": [
      "Abklärung bei Verdacht auf angeblichen Selbsttötungsversuch",
      "Abklärung bei Verdacht auf gutartige Neubildung",
      "Abklärung bei Verdacht auf nichtisolierungspflichtige Infektionskrankheit",
      "Abklärung bei angeblichem Parasuizid",
      "Abklärung bei angeblichem Selbstmordversuch a.n.k.",
      "COVID-19 durch negatives Labortestergebnis ausgeschlossen",
      "Negativer COVID-19-Test"
    ]
  },
  {
    "code": "Z03.9",
    "name": "Beobachtung bei Verdachtsfall",
    "synonyms": [
      "Abklärung einer Krankheit",
      "Abklärung eines Verdachtsfalles",
      "Ausschluss eines Verdachtsfalles",
      "Ausschluss eines verdächtigen Befundes",
      "Beobachtung bei Verdachtsfall",
      "Keine Krankheit gefunden",
      "Kontrolle eines Verdachtsbefundes",
      "Ohne Befund [o.B.]",
      "Unter Beobachtung sein"
    ]
  },
  {
    "code": "Z04.1",
    "name": "Untersuchung und Beobachtung nach Transportmittelunfall",
    "synonyms": [
      "Abklärung nach Transportmittelunfall",
      "Untersuchung nach Kraftfahrzeugunfall",
      "Untersuchung und Beobachtung nach Transportmittelunfall"
    ]
  },
  {
    "code": "Z04.2",
    "name": "Untersuchung und Beobachtung nach Arbeitsunfall",
    "synonyms": [
      "Abklärung nach Arbeitsunfall",
      "Untersuchung und Beobachtung nach Arbeitsunfall"
    ]
  },
  {
    "code": "Z04.3",
    "name": "Beobachtung nach Unfall",
    "synonyms": [
      "Abklärung bei unfallbedingter Verletzung a.n.k.",
      "Abklärung nach Unfall a.n.k.",
      "Beobachtung nach Unfall",
      "Untersuchung nach Unfall a.n.k."
    ]
  },
  {
    "code": "Z04.5",
    "name": "Abklärung bei angeblichen sexuellen Missbrauchs",
    "synonyms": [
      "Abklärung bei Verdacht auf Misshandlung",
      "Abklärung bei angeblichen Vergewaltigung",
      "Abklärung bei angeblichen sexuellen Missbrauchs",
      "Abklärung bei zugefügter Verletzung a.n.k.",
      "Untersuchung von Opfer oder Beschuldigtem nach angegebener Vergewaltigung oder sexuellem Missbrauch"
    ]
  },
  {
    "code": "Z04.8",
    "name": "Alkoholbestimmung im Blut",
    "synonyms": [
      "Alkoholbestimmung im Blut",
      "Allgemeine psychiatrische Untersuchung auf behördliche Anforderung",
      "Anforderung eines Expertengutachtens",
      "Blutalkoholtest",
      "Drogenbestimmung im Blut",
      "Laborparametertest aus rechtsmedizinischen Gründen a.n.k.",
      "Test auf Arzneimittel im Blut",
      "Test auf Drogen im Blut",
      "Untersuchung auf Gebrauch von Drogen",
      "Untersuchung auf Gebrauch von Stimulanzien",
      "Untersuchung aus rechtsmedizinischen Gründen",
      "Überweisung an Facharzt",
      "Überweisung an Gutachter"
    ]
  },
  {
    "code": "Z04.9",
    "name": "Beobachtung",
    "synonyms": [
      "Abklärung",
      "Abklärung ohne Bedarf weiterer ärztlicher Versorgung",
      "Beobachtung",
      "Kontrolle ohne Notwendigkeit weiterer medizinischer Betreuung",
      "Überwachung"
    ]
  },
  {
    "code": "Z08.0",
    "name": "Nachuntersuchung nach chirurgischem Eingriff wegen bösartiger Neubildung",
    "synonyms": [
      "Karzinom-Nachsorgeuntersuchung nach chirurgischer Therapie",
      "Nachuntersuchung nach chirurgischem Eingriff wegen bösartiger Neubildung"
    ]
  },
  {
    "code": "Z08.1",
    "name": "Nachuntersuchung nach Strahlentherapie wegen bösartiger Neubildung",
    "synonyms": [
      "Karzinom-Nachsorgeuntersuchung nach Strahlentherapie",
      "Nachuntersuchung nach Strahlentherapie wegen bösartiger Neubildung"
    ]
  },
  {
    "code": "Z08.2",
    "name": "Nachuntersuchung nach Chemotherapie wegen bösartiger Neubildung",
    "synonyms": [
      "Karzinom-Nachsorgeuntersuchung nach Chemotherapie",
      "Nachuntersuchung nach Chemotherapie wegen bösartiger Neubildung"
    ]
  },
  {
    "code": "Z08.7",
    "name": "Nachuntersuchung nach Kombinationstherapie wegen bösartiger Neubildung",
    "synonyms": [
      "Nachuntersuchung nach Kombinationstherapie wegen bösartiger Neubildung"
    ]
  },
  {
    "code": "Z08.9",
    "name": "Karzinomnachsorge",
    "synonyms": [
      "Karzinomnachsorge",
      "Krebsnachsorge",
      "Nachsorgeuntersuchung nach bösartiger Neubildung",
      "Onkologische Nachsorge"
    ]
  },
  {
    "code": "Z09.0",
    "name": "Nachuntersuchung nach Operation",
    "synonyms": [
      "Nachsorgeuntersuchung nach chirurgischem Eingriff a.n.k.",
      "Nachuntersuchung nach Operation",
      "Postoperative Kontrolle"
    ]
  },
  {
    "code": "Z09.1",
    "name": "Hautinspektion nach Radiatio",
    "synonyms": [
      "Hautinspektion nach Radiatio",
      "Nachuntersuchung nach Strahlentherapie"
    ]
  },
  {
    "code": "Z09.2",
    "name": "Nachuntersuchung nach Chemotherapie",
    "synonyms": [
      "Nachuntersuchung nach Chemotherapie"
    ]
  },
  {
    "code": "Z09.3",
    "name": "Nachuntersuchung nach Psychotherapie",
    "synonyms": [
      "Nachuntersuchung nach Psychotherapie"
    ]
  },
  {
    "code": "Z09.4",
    "name": "Nachuntersuchung nach Frakturbehandlung",
    "synonyms": [
      "Nachuntersuchung nach Frakturbehandlung",
      "Nachuntersuchung nach Knochenbruchbehandlung"
    ]
  },
  {
    "code": "Z09.80",
    "name": "Nachuntersuchung nach Organtransplantation",
    "synonyms": [
      "Nachuntersuchung nach Organtransplantation"
    ]
  },
  {
    "code": "Z09.9",
    "name": "Nachuntersuchung",
    "synonyms": [
      "Medizinische Überwachung nach Behandlung",
      "Nachuntersuchung",
      "Routinemäßige Nachsorgeuntersuchung",
      "Tumornachsorge",
      "Untersuchung nach Behandlung"
    ]
  },
  {
    "code": "Z10",
    "name": "Allgemeine Reihenuntersuchung als arbeitsmedizinische Untersuchung",
    "synonyms": [
      "Allgemeine Reihenuntersuchung als arbeitsmedizinische Untersuchung",
      "Allgemeine Reihenuntersuchung von Angehörigen der Streitkräfte",
      "Allgemeine Reihenuntersuchung von Bewohnern institutioneller Einrichtungen",
      "Allgemeine Reihenuntersuchung von Schulkinder",
      "Allgemeine Reihenuntersuchung von Sportmannschaften",
      "Allgemeine Reihenuntersuchung von Studenten",
      "Arbeitsmedizinischer Check up",
      "Betriebsärztliche Untersuchung",
      "Untersuchung auf Chromosomenanomalie bei Athleten",
      "Ärztliche Untersuchung von Angehörigen der Streitkräfte",
      "Ärztliche Untersuchung von Athleten",
      "Ärztliche Untersuchung von Flüchtlingen",
      "Ärztliche Untersuchung von Gefangenen",
      "Ärztliche Untersuchung von Prostituierten"
    ]
  },
  {
    "code": "Z11",
    "name": "Spezielle Untersuchung auf infektiöse Darmkrankheit",
    "synonyms": [
      "Spezielle Untersuchung auf Lungentuberkulose",
      "Spezielle Untersuchung auf infektiöse Darmkrankheit",
      "Spezielles Untersuchung auf HIV",
      "Untersuchung auf Brucellose",
      "Untersuchung auf Candida-Infektion",
      "Untersuchung auf Chagas-Krankheit",
      "Untersuchung auf Chlamydien-Infektion",
      "Untersuchung auf Cholera",
      "Untersuchung auf Dengue-Fieber",
      "Untersuchung auf Diphtherie",
      "Untersuchung auf Filariasis",
      "Untersuchung auf Frambösie",
      "Untersuchung auf Gelbfieber",
      "Untersuchung auf Geschlechtskrankheit",
      "Untersuchung auf HIV",
      "Untersuchung auf Keuchhusten",
      "Untersuchung auf Leishmaniose",
      "Untersuchung auf Lepra",
      "Untersuchung auf Leptospirose",
      "Untersuchung auf Malaria",
      "Untersuchung auf Masern",
      "Untersuchung auf Mykosen-Infektion",
      "Untersuchung auf Parasitenbefall",
      "Untersuchung auf Pest",
      "Untersuchung auf Pilzinfektion",
      "Untersuchung auf Poliomyelitis",
      "Untersuchung auf Protozoen-Krankheit",
      "Untersuchung auf Rickettsien-Krankheit",
      "Untersuchung auf Röteln",
      "Untersuchung auf Schistosomiasis",
      "Untersuchung auf Schlafkrankheit",
      "Untersuchung auf Spirochäten-Infektion",
      "Untersuchung auf Tetanus",
      "Untersuchung auf Trachom",
      "Untersuchung auf Trypanosomiasis",
      "Untersuchung auf Virusenzephalitis",
      "Untersuchung auf bakterielle Krankheit a.n.k.",
      "Untersuchung auf eine virusbedingte Krankheit a.n.k.",
      "Untersuchung auf eine virusbedingte Störung a.n.k.",
      "Untersuchung auf hämorrhagisches Fieber",
      "Untersuchung auf infektiöse Krankheit",
      "Untersuchung auf intestinale Helminthose",
      "Untersuchung auf intestinale Infektion",
      "Untersuchung auf intestinale Würmer",
      "Untersuchung auf parasitäre Infektion a.n.k.",
      "Untersuchung auf venerische Krankheit",
      "Wassermann-Test"
    ]
  },
  {
    "code": "Z12.0",
    "name": "Spezielle Untersuchung auf Neubildung des Magens",
    "synonyms": [
      "Spezielle Untersuchung auf Neubildung des Magens"
    ]
  },
  {
    "code": "Z12.1",
    "name": "Spezielle Untersuchung auf Neubildung des Darmtraktes",
    "synonyms": [
      "Screening auf Darmneubildung",
      "Spezielle Untersuchung auf Neubildung des Darmtraktes"
    ]
  },
  {
    "code": "Z12.2",
    "name": "Spezielle Untersuchung auf Neubildung der Atmungsorgane",
    "synonyms": [
      "Spezielle Untersuchung auf Neubildung der Atmungsorgane"
    ]
  },
  {
    "code": "Z12.3",
    "name": "Spezielle Untersuchung auf Neubildung der Mamma",
    "synonyms": [
      "Früherkennungsmammographie",
      "Mammogramm",
      "Mammographie",
      "Röntgenuntersuchung der Brust",
      "Screening auf Mammaneubildung",
      "Screening auf bösartige Neubildung der Brustdrüse",
      "Spezielle Untersuchung auf Neubildung der Mamma"
    ]
  },
  {
    "code": "Z12.4",
    "name": "Spezielle Untersuchung auf Neubildung der Cervix uteri",
    "synonyms": [
      "Abstrich der Cervix uteri nach Papanicolaou",
      "Papanicolaou-Abstrich der Cervix uteri bei Verdacht auf Neubildung",
      "Papanicolaou-Abstrich der Zervix bei Verdacht auf Neubildung",
      "Screening auf Cervix-uteri-Neoplasma",
      "Spezielle Untersuchung auf Neubildung der Cervix uteri",
      "Zervixabstrich nach Papanicolaou"
    ]
  },
  {
    "code": "Z12.5",
    "name": "Spezielle Untersuchung auf Neubildung der Prostata",
    "synonyms": [
      "Spezielle Untersuchung auf Neubildung der Prostata"
    ]
  },
  {
    "code": "Z12.6",
    "name": "Spezielle Untersuchung auf Neubildung der Harnblase",
    "synonyms": [
      "Screening auf Blasenneoplasma",
      "Screening auf Harnblasenneoplasma",
      "Spezielle Untersuchung auf Neubildung der Harnblase"
    ]
  },
  {
    "code": "Z12.8",
    "name": "Screening auf Hodgkin-Krankheit",
    "synonyms": [
      "Screening auf Hodgkin-Krankheit",
      "Screening auf Leukämie",
      "Screening auf Lymphome",
      "Untersuchung auf bösartige Neubildung der Lymphknoten",
      "Untersuchung auf bösartige Neubildung des Blutes",
      "Untersuchung auf bösartige Neubildung des hämatopoetischen Systems"
    ]
  },
  {
    "code": "Z12.9",
    "name": "Karzinomvorsorge",
    "synonyms": [
      "Karzinomvorsorge",
      "Krebsfrüherkennung",
      "Krebsvorsorgeuntersuchung",
      "Prophylaktische Untersuchung auf Krebs",
      "Screening auf Neubildung"
    ]
  },
  {
    "code": "Z13.0",
    "name": "Screening auf Anämie",
    "synonyms": [
      "Screening auf Anämie",
      "Screening auf Blutkrankheit",
      "Screening auf Hämoglobulinopathie a.n.k.",
      "Screening auf Immunkrankheit",
      "Screening auf Sichelzellen-Erbanlage",
      "Screening auf Sichelzellenkrankheit",
      "Untersuchung auf Krankheit der blutbildenden Organe"
    ]
  },
  {
    "code": "Z13.1",
    "name": "Spezielle Untersuchung auf Diabetes mellitus",
    "synonyms": [
      "Screening auf Diabetes mellitus",
      "Spezielle Untersuchung auf Diabetes mellitus"
    ]
  },
  {
    "code": "Z13.2",
    "name": "Spezielle Untersuchung auf Ernährungsstörungen",
    "synonyms": [
      "Screening auf Fehlernährung",
      "Screening auf Mangelernährung",
      "Spezielle Untersuchung auf Ernährungsstörungen"
    ]
  },
  {
    "code": "Z13.4",
    "name": "Spezielle Untersuchung auf bestimmte Entwicklungsstörungen in der Kindheit",
    "synonyms": [
      "Spezielle Untersuchung auf bestimmte Entwicklungsstörungen in der Kindheit"
    ]
  },
  {
    "code": "Z13.5",
    "name": "Spezielle Untersuchung auf Augenkrankheiten",
    "synonyms": [
      "Screening auf Glaukom",
      "Screening auf Katarakt",
      "Screening auf kongenitale Augenkrankheit",
      "Spezielle Untersuchung auf Augenkrankheiten",
      "Spezielle Untersuchung auf Ohrenkrankheiten"
    ]
  },
  {
    "code": "Z13.6",
    "name": "Spezielle Untersuchung auf kardiovaskuläre Krankheiten",
    "synonyms": [
      "Screening auf Bluthochdruck",
      "Screening auf Herzkrankheit a.n.k.",
      "Screening auf Hypertonie",
      "Screening auf gefäßbedingte Krankheit a.n.k.",
      "Screening auf kardiovaskuläre Affektion a.n.k.",
      "Spezielle Untersuchung auf kardiovaskuläre Krankheiten"
    ]
  },
  {
    "code": "Z13.7",
    "name": "Screening auf Chromosomenanomalie",
    "synonyms": [
      "Postnatales Screening auf Chromosomenanomalie",
      "Screening auf Chromosomenanomalie",
      "Screening auf angeborene Hüftgelenkluxation",
      "Screening auf kongenitale Anomalie",
      "Spezielle Untersuchung auf Chromosomenanomalie",
      "Spezielle Untersuchung auf Deformität",
      "Spezielle Untersuchung auf angeborene Fehlbildung"
    ]
  },
  {
    "code": "Z13.8",
    "name": "Spezielle Untersuchung auf psychische Krankheiten",
    "synonyms": [
      "Screening auf Alkoholismus",
      "Screening auf Aufnahme einer radioaktiven Substanz",
      "Screening auf Depression",
      "Screening auf Fettsucht",
      "Screening auf Galaktosämie",
      "Screening auf Gicht",
      "Screening auf Hautaffektion",
      "Screening auf Ingestion einer radioaktiven Substanz",
      "Screening auf Kontamination a.n.k.",
      "Screening auf Lungenemphysem",
      "Screening auf Magen-Darm-Affektion a.n.k.",
      "Screening auf Magen-Darm-Krankheit a.n.k.",
      "Screening auf Mukoviszidose",
      "Screening auf Nephropathie",
      "Screening auf Nierenkrankheit",
      "Screening auf Phenylketonurie",
      "Screening auf Schilddrüsenkrankheit",
      "Screening auf Strahlenschädigung",
      "Screening auf Vergiftung",
      "Screening auf Vergiftung durch Chemikalien",
      "Screening auf Vergiftung durch Schwermetalle",
      "Screening auf asymptomatische Bakteriurie",
      "Screening auf chronische Bronchitis",
      "Screening auf chronische Polyarthritis",
      "Screening auf entwicklungsbedingte Behinderung",
      "Screening auf geistige Retardierung",
      "Screening auf neurologische Affektion",
      "Screening auf respiratorische Affektion a.n.k.",
      "Screening auf rheumatische Krankheit a.n.k.",
      "Screening auf zystische Fibrose",
      "Screening auf Übergewichtigkeit",
      "Spezielle Untersuchung auf Verhaltensstörungen",
      "Spezielle Untersuchung auf psychische Krankheiten",
      "Untersuchung auf Affektion der Harn- und Geschlechtsorgane a.n.k.",
      "Untersuchung auf Atemwegskrankheit a.n.k.",
      "Untersuchung auf Krankheit der Harn- und Geschlechtsorgane a.n.k.",
      "Untersuchung auf Zahnkrankheit",
      "Untersuchung auf angeborene Stoffwechselstörung",
      "Untersuchung auf endokrine Störung"
    ]
  },
  {
    "code": "Z13.9",
    "name": "Mehrstufiges Screening",
    "synonyms": [
      "Mehrstufiges Screening",
      "Screening auf Affektion",
      "Screening auf Krankheit oder Störung"
    ]
  },
  {
    "code": "Z20.0",
    "name": "Salmonellose-Inkubation",
    "synonyms": [
      "Kontakt mit Cholera",
      "Kontakt mit infektiösen Darmbakterien",
      "Kontakt mit infektiöser Darmkrankheit",
      "Salmonellose-Inkubation"
    ]
  },
  {
    "code": "Z20.1",
    "name": "Kontakt mit TBC [Tuberkulose]",
    "synonyms": [
      "Kontakt mit TBC [Tuberkulose]",
      "Kontakt mit Tuberkulose",
      "Tuberkulose-Inkubation"
    ]
  },
  {
    "code": "Z20.2",
    "name": "Kontakt mit Gonokokken",
    "synonyms": [
      "Kontakt mit Gonokokken",
      "Kontakt mit Gonorrhoe",
      "Kontakt mit Lues",
      "Kontakt mit Syphilis",
      "Kontakt mit einer Geschlechtskrankheit",
      "Kontakt mit einer durch Geschlechtsverkehr übertragenen Krankheit"
    ]
  },
  {
    "code": "Z20.3",
    "name": "Kontakt mit Tollwut",
    "synonyms": [
      "Exposition gegenüber Tollwut",
      "Kontakt mit Tollwut"
    ]
  },
  {
    "code": "Z20.4",
    "name": "Exposition gegenüber Röteln",
    "synonyms": [
      "Exposition gegenüber Röteln",
      "Kontakt mit Röteln",
      "Rötelninkubation"
    ]
  },
  {
    "code": "Z20.5",
    "name": "Hepatitis-Inkubation",
    "synonyms": [
      "Hepatitis-Inkubation",
      "Kontakt mit Virushepatitis"
    ]
  },
  {
    "code": "Z20.6",
    "name": "HIV-Inkubation",
    "synonyms": [
      "Exposition gegenüber HIV",
      "HIV-Inkubation",
      "Kontakt mit AIDS-Virus",
      "Kontakt mit HIV"
    ]
  },
  {
    "code": "Z20.7",
    "name": "Kontakt mit Parasiten a.n.k.",
    "synonyms": [
      "Kontakt mit Akariose",
      "Kontakt mit Parasiten a.n.k.",
      "Kontakt mit parasitärer Krankheit"
    ]
  },
  {
    "code": "Z20.8",
    "name": "Kontakt mit Masern",
    "synonyms": [
      "Kontakt mit Masern",
      "Kontakt mit Pocken",
      "Kontakt mit Poliomyelitis",
      "Kontakt mit Viruskrankheit a.n.k.",
      "Kontakt mit Windpocken",
      "Masern-Inkubation",
      "Mumps-Inkubation",
      "Pertussis-Inkubation",
      "Varizellen-Inkubation"
    ]
  },
  {
    "code": "Z20.9",
    "name": "Kontakt mit übertragbarer Krankheit",
    "synonyms": [
      "Kontakt mit übertragbarer Krankheit"
    ]
  },
  {
    "code": "Z21",
    "name": "Asymptomatische HIV-Infektion",
    "synonyms": [
      "Asymptomatische HIV-Infektion",
      "Asymptomatischer Status einer HIV-Krankheit",
      "HIV-Infektion",
      "HIV-positiv"
    ]
  },
  {
    "code": "Z22.0",
    "name": "Keimträger von Typhus abdominalis",
    "synonyms": [
      "Keimträger von Typhus abdominalis",
      "Überträger von Typhus"
    ]
  },
  {
    "code": "Z22.1",
    "name": "Keimträger einer infektiösen Darmerkrankung",
    "synonyms": [
      "Keimträger einer infektiösen Darmerkrankung",
      "Keimträger pathogener Keime des Gastrointestinaltraktes a.n.k.",
      "Keimträger von Amöbiasis",
      "Keimträger von Cholera",
      "Keimträger von Salmonellen",
      "Salmonellen-Dauerausscheider",
      "Überträger von Amöben-Ruhr",
      "Überträger von Amöbiasis",
      "Überträger von Cholera",
      "Überträger von gastrointestinalen Erregern a.n.k."
    ]
  },
  {
    "code": "Z22.2",
    "name": "Keimträger von Diphtherie",
    "synonyms": [
      "Keimträger von Diphtherie",
      "Überträger von Diphtherie"
    ]
  },
  {
    "code": "Z22.3",
    "name": "Keimträger einer bakteriellen Krankheit a.n.k.",
    "synonyms": [
      "Keimträger einer bakteriellen Krankheit a.n.k.",
      "Keimträger von Meningokokken",
      "Keimträger von Staphylokokken",
      "Keimträger von Streptokokken",
      "Überträger einer bakteriellen Krankheit a.n.k.",
      "Überträger von Meningokokken",
      "Überträger von Staphylokokken",
      "Überträger von Streptokokken"
    ]
  },
  {
    "code": "Z22.4",
    "name": "Keimträger von Gonorrhoe",
    "synonyms": [
      "Keimträger einer venerischen Krankheit a.n.k.",
      "Keimträger von Gonorrhoe",
      "Keimträger von Syphilis",
      "Überträger einer Geschlechtskrankheit a.n.k.",
      "Überträger von Gonorrhoe",
      "Überträger von Syphilis"
    ]
  },
  {
    "code": "Z22.6",
    "name": "Keimträger der humanen T-Zell-lymphotropen Viruskrankheit Typ I [HTLV-1]",
    "synonyms": [
      "Keimträger der humanen T-Zell-lymphotropen Viruskrankheit Typ I [HTLV-1]",
      "Überträger der humanen T-Zell-lymphotropen Viruskrankheit Typ I (HTLV-1)"
    ]
  },
  {
    "code": "Z22.7",
    "name": "Latente Tuberkulose",
    "synonyms": [
      "Latente Tuberkulose"
    ]
  },
  {
    "code": "Z22.8",
    "name": "Keimträger des humanen Papillomavirus [HPV]",
    "synonyms": [
      "Keimträger des humanen Papillomavirus [HPV]"
    ]
  },
  {
    "code": "Z22.9",
    "name": "Keimträger eines Infektionserregers",
    "synonyms": [
      "Keimträger eines Infektionserregers",
      "Überträger eines Infektionserregers a.n.k."
    ]
  },
  {
    "code": "Z23.0",
    "name": "Notwendigkeit der Impfung gegen Cholera",
    "synonyms": [
      "Cholera-Vakzination",
      "Notwendigkeit der Impfung gegen Cholera"
    ]
  },
  {
    "code": "Z23.1",
    "name": "Notwendigkeit der Impfung gegen Typhus-Paratyphus [TAB]",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Typhus-Paratyphus [TAB]",
      "Typhus-Paratyphus [TAB]-Vakzination"
    ]
  },
  {
    "code": "Z23.2",
    "name": "Notwendigkeit der Impfung gegen Tuberkulose [BCG (Bacille Calmette-Guérin)]",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Tuberkulose [BCG (Bacille Calmette-Guérin)]",
      "Tuberkulose-Vakzination"
    ]
  },
  {
    "code": "Z23.3",
    "name": "Notwendigkeit der Impfung gegen Pest",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Pest",
      "Pest-Vakzination"
    ]
  },
  {
    "code": "Z23.4",
    "name": "Notwendigkeit der Impfung gegen Tularämie",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Tularämie",
      "Tularämie-Vakzination"
    ]
  },
  {
    "code": "Z23.5",
    "name": "Notwendigkeit der Impfung gegen Tetanus",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Tetanus",
      "Postexpositionelle Simultanimpfung gegen Tetanus",
      "Tetanus-Impfung",
      "Tetanus-Vakzination"
    ]
  },
  {
    "code": "Z23.6",
    "name": "Notwendigkeit der Impfung gegen Diphtherie",
    "synonyms": [
      "Diphtherie-Vakzination",
      "Notwendigkeit der Impfung gegen Diphtherie"
    ]
  },
  {
    "code": "Z23.7",
    "name": "Keuchhusten-Vakzination",
    "synonyms": [
      "Impfung gegen Keuchhusten [Pa] [aP]",
      "Impfung gegen Pertussis [Pa] [aP]",
      "Keuchhusten-Vakzination",
      "Pertussis-Vakzination"
    ]
  },
  {
    "code": "Z23.8",
    "name": "Vakzination gegen Pneumokokken-Infektion",
    "synonyms": [
      "Impfung gegen Meningokokken-Infektion",
      "Notwendigkeit der Impfung gegen Haemophilus influenzae Typ b [Hib]",
      "Notwendigkeit der Impfung gegen Pneumokokken-Infektion",
      "Vakzination gegen Haemophilus influenzae Typ b [Hib]",
      "Vakzination gegen Pneumokokken-Infektion"
    ]
  },
  {
    "code": "Z24.0",
    "name": "Notwendigkeit der Impfung gegen Poliomyelitis [IPV (Inaktivierte Polio-Vakzine)]",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Poliomyelitis [IPV (Inaktivierte Polio-Vakzine)]",
      "Notwendigkeit der trivalenten Poliomyelitis-Schluckimpfung [OPV (Orale Polio-Vakzine)]",
      "Poliomyelitis-Vakzination [IPV]"
    ]
  },
  {
    "code": "Z24.1",
    "name": "Notwendigkeit der Impfung gegen durch Arthropoden übertragene Virusenzephalitis",
    "synonyms": [
      "Impfung gegen FSME [Zentraleuropäische Frühsommer-Meningoenzephalitis]",
      "Impfung gegen Zentraleuropäische Frühsommer-Meningoenzephalitis",
      "Notwendigkeit der Impfung gegen durch Arthropoden übertragene Virusenzephalitis",
      "Vakzination gegen Zentraleuropäische Frühsommer-Meningoenzephalitis"
    ]
  },
  {
    "code": "Z24.2",
    "name": "Notwendigkeit der Impfung gegen Tollwut",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Tollwut",
      "Postexpositionelle Simultanimpfung gegen Tollwut",
      "Tollwut-Vakzination"
    ]
  },
  {
    "code": "Z24.3",
    "name": "Notwendigkeit der Impfung gegen Gelbfieber",
    "synonyms": [
      "Gelbfieber-Vakzination",
      "Notwendigkeit der Impfung gegen Gelbfieber"
    ]
  },
  {
    "code": "Z24.4",
    "name": "Notwendigkeit der Impfung gegen Masern",
    "synonyms": [
      "Masern-Vakzination",
      "Notwendigkeit der Impfung gegen Masern"
    ]
  },
  {
    "code": "Z24.5",
    "name": "Notwendigkeit der Impfung gegen Röteln",
    "synonyms": [
      "Fehlende Rötelnimmunität",
      "Fragliche Rötelnimmunität",
      "Notwendigkeit der Impfung gegen Röteln",
      "Rötelnvakzination"
    ]
  },
  {
    "code": "Z24.6",
    "name": "Notwendigkeit der Impfung gegen Virushepatitis",
    "synonyms": [
      "Fehlende Virushepatitis-Immunität",
      "Hepatitis-A-Vakzination",
      "Hepatitis-B-Vakzination",
      "Hepatitis-Impfung",
      "Impfung gegen Hepatitis A und B [HAB]",
      "Notwendigkeit der Impfung gegen Hepatitis A",
      "Notwendigkeit der Impfung gegen Hepatitis B",
      "Notwendigkeit der Impfung gegen Virushepatitis",
      "Postexpositionelle Simultanimpfung gegen Hepatitis B"
    ]
  },
  {
    "code": "Z25.0",
    "name": "Notwendigkeit der Impfung gegen Mumps",
    "synonyms": [
      "Mumps-Vakzination",
      "Notwendigkeit der Impfung gegen Mumps"
    ]
  },
  {
    "code": "Z25.1",
    "name": "Notwendigkeit der Impfung gegen Grippe [Influenza]",
    "synonyms": [
      "Grippe [Influenza]-Vakzination",
      "Notwendigkeit der Impfung gegen Grippe [Influenza]",
      "Prophylaktische Impfung gegen Erkältung"
    ]
  },
  {
    "code": "Z25.8",
    "name": "Windpocken-Vakzination",
    "synonyms": [
      "Impfung gegen Dengue",
      "Impfung gegen Rotaviren",
      "Impfung gegen Viruserkrankung",
      "Impfung gegen Windpocken [Varizellen]",
      "Impfung gegen humanes Papillomvirus",
      "Notwendigkeit der Impfung gegen Varizellen",
      "Prophylaktische Impfung gegen Pocken",
      "Varizellen-Vakzination",
      "Windpocken-Vakzination"
    ]
  },
  {
    "code": "Z26.0",
    "name": "Notwendigkeit der Impfung gegen Leishmaniose",
    "synonyms": [
      "Leishmaniose-Vakzination",
      "Notwendigkeit der Impfung gegen Leishmaniose"
    ]
  },
  {
    "code": "Z26.9",
    "name": "Einzelimpfung - s.a. Einzeleinträge der Impfungen",
    "synonyms": [
      "Beratung und Impfung",
      "Einzelimpfung - s.a. Einzeleinträge der Impfungen",
      "Grundimmunisierung - s.a. Impfung",
      "Immunisation - s.a. Impfung",
      "Immunisierung - s.a. Impfung oder s.a. Isoimmunisierung",
      "Impfung",
      "Prophylaktische Impfung",
      "Schutzimpfung - s.a. Impfung",
      "Vakzination - s.a. Impfung",
      "Vorbeugende Impfung"
    ]
  },
  {
    "code": "Z27.0",
    "name": "Notwendigkeit der Impfung gegen Cholera mit Typhus-Paratyphus [Cholera+TAB]",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Cholera mit Typhus-Paratyphus [Cholera+TAB]",
      "Vakzination gegen Cholera mit Typhus-Paratyphus [Cholera+TAB]"
    ]
  },
  {
    "code": "Z27.1",
    "name": "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus [DPT] [DTPa] [DaPT]",
    "synonyms": [
      "Diphtherie-Pertussis-Tetanus-Vakzination [DPT] [DTPa] [DaPT]",
      "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus [DPT] [DTPa] [DaPT]"
    ]
  },
  {
    "code": "Z27.2",
    "name": "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus mit Typhus-Paratyphus [DPT+TAB] [DTPa+TAB] [DaPT-TAB]",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus mit Typhus-Paratyphus [DPT+TAB] [DTPa+TAB] [DaPT-TAB]",
      "Vakzination gegen Diphtherie-Pertussis-Tetanus mit Typhus-Paratyphus [DPT+TAB] [DTPa+TAB] [DaPT-TAB]"
    ]
  },
  {
    "code": "Z27.3",
    "name": "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus mit Poliomyelitis [DPT-IPV] [DTPa-IPV] [DaPT-IPV]",
    "synonyms": [
      "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus mit Poliomyelitis [DPT-IPV] [DTPa-IPV] [DaPT-IPV]",
      "Vakzination gegen Diphtherie-Pertussis-Tetanus mit Poliomyelitis [DPT-IPV] [DTPa-IPV] [DaPT-IPV]"
    ]
  },
  {
    "code": "Z27.4",
    "name": "Notwendigkeit der Impfung gegen Masern-Mumps-Röteln [MMR]",
    "synonyms": [
      "Masern-Mumps-Röteln-Vakzination [MMR]",
      "Notwendigkeit der Impfung gegen Masern-Mumps-Röteln [MMR]"
    ]
  },
  {
    "code": "Z27.8",
    "name": "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus-Haemophilus influenzae Typ b [DPT-Hib] [DTPa-Hib] [DaPT-Hib]",
    "synonyms": [
      "Diphtherie-Tetanus-Vakzination [DT] [Td]",
      "Impfung gegen Diphtherie-Pertussis-Tetanus-Haemophilus influenzae Typ b mit Poliomyelitis [DPT-IPV-Hib] [DTPa-IPV-Hib] [DaPT-IPV-Hib]",
      "Impfung gegen Diphtherie-Tetanus [DT] [Td]",
      "Impfung gegen Diphtherie-Tetanus-Haemophilus influenzae Typ b [DT-Hib]",
      "Impfung gegen Diphtherie-Tetanus-Poliomyelitis-Pertussis-Haemophilus influenzae Typ b (Hib) mit Hepatitis B",
      "Impfung gegen Hepatitis B-Haemophilus influenzae Typ b (HB-Hib)",
      "Impfung gegen Tetanus-Diphtherie mit Poliomyelitis [Td-IPV]",
      "Masern-Mumps-Vakzination [MM]",
      "Notwendigkeit der Impfung gegen Diphtherie-Pertussis-Tetanus-Haemophilus influenzae Typ b [DPT-Hib] [DTPa-Hib] [DaPT-Hib]",
      "Notwendigkeit der Impfung gegen Diphtherie-Tetanus [TD] [Td]",
      "Notwendigkeit der Impfung gegen Diphtherie-Tetanus-Haemophilus influenzae Typ b [TD-Hib]",
      "Notwendigkeit der Impfung gegen Masern-Mumps [MM]",
      "Notwendigkeit der Impfung gegen Mumps-Masern-Röteln-Varizellen"
    ]
  },
  {
    "code": "Z27.9",
    "name": "Kombinierte Impfung - s.a. Einzeleinträge der Kombinationsimpfungen",
    "synonyms": [
      "Kombinationsimpfung - s.a. Einzeleinträge der Kombinationsimpfungen",
      "Kombinierte Impfung - s.a. Einzeleinträge der Kombinationsimpfungen"
    ]
  },
  {
    "code": "Z28",
    "name": "Nicht durchgeführte Impfung",
    "synonyms": [
      "Nicht durchgeführte Impfung",
      "Nicht durchgeführte Impfung aus Glaubensgründen",
      "Nicht durchgeführte Impfung wegen Gruppendruck",
      "Nicht durchgeführte Impfung wegen Kontraindikation",
      "Nicht durchgeführte Impfung wegen vom Patienten unabhängigen Gründen",
      "Verweigerung einer Impfung als Entscheidung des Patienten a.n.k.",
      "Verweigerung einer Impfung aus Glaubensgründen",
      "Verweigerung einer Impfung wegen Gruppendruck"
    ]
  },
  {
    "code": "Z29.0",
    "name": "Isolierung",
    "synonyms": [
      "Isolierung"
    ]
  },
  {
    "code": "Z29.1",
    "name": "Immunprophylaxe",
    "synonyms": [
      "Immunglobulinprophylaxe",
      "Immunprophylaxe",
      "Immunprophylaxe [passive Impfung] gegen Hepatitis B (mit spezifischem Immunglobulin)",
      "Immunprophylaxe [passive Impfung] gegen Tetanus (mit spezifischem Immunglobulin)",
      "Immunprophylaxe [passive Impfung] gegen Tollwut (mit spezifischem Immunglobulin)",
      "Prophylaktische Immunglobulingabe",
      "Prophylaktische Immuntherapie",
      "Prophylaktische Verabreichung von Gammaglobulinen",
      "Vorbeugende Immunisierung",
      "Vorbeugende Immuntherapie"
    ]
  },
  {
    "code": "Z29.20",
    "name": "Prophylaktische lokale Antibiotikagabe",
    "synonyms": [
      "Lokale Antibiotikaprophylaxe",
      "Lokale Chemoprophylaxe",
      "Prophylaktische lokale Antibiotikagabe",
      "Prophylaktische lokale Chemotherapeutikagabe",
      "Prophylaktische lokale Chemotherapie",
      "Vorbeugende lokale Chemotherapie a.n.k."
    ]
  },
  {
    "code": "Z29.21",
    "name": "Antibiotische Endokarditisprophylaxe",
    "synonyms": [
      "Antibiotische Endokarditisprophylaxe",
      "Endokarditisprophylaxe",
      "Prophylaktische systemische Antibiotikagabe",
      "Prophylaktische systemische Chemotherapeutikagabe",
      "Prophylaktische systemische Chemotherapie",
      "Systemische Antibiotikaprophylaxe",
      "Systemische Chemoprophylaxe",
      "Vorbeugende systemische Chemotherapie a.n.k."
    ]
  },
  {
    "code": "Z29.22",
    "name": "HIV-Präexpositionsprophylaxe",
    "synonyms": [
      "HIV-Präexpositionsprophylaxe"
    ]
  },
  {
    "code": "Z29.28",
    "name": "Chemoprophylaxe",
    "synonyms": [
      "Chemoprophylaxe",
      "Prophylaktische Antibiotikaverabreichung"
    ]
  },
  {
    "code": "Z29.8",
    "name": "Kariesprophylaxe durch Fluoridgabe",
    "synonyms": [
      "Kariesprophylaxe durch Fluoridgabe",
      "Prophylaxe von Karies und Rachitis",
      "Rachitisprophylaxe durch Vitamin-D-Gabe"
    ]
  },
  {
    "code": "Z29.9",
    "name": "Prophylaktische Maßnahme",
    "synonyms": [
      "Prophylaktische Maßnahme"
    ]
  },
  {
    "code": "Z30.0",
    "name": "Antrag auf Interruptio graviditatis",
    "synonyms": [
      "Antrag auf Abruptio graviditatis",
      "Antrag auf Graviditätsabbruch",
      "Antrag auf Interruptio graviditatis",
      "Antrag auf Schwangerschaftsabbruch",
      "Beratung nach Paragraph 218",
      "Beratung wegen Empfängnisregelung",
      "Beratung wegen Familienplanung",
      "Beratung wegen Interruptio",
      "Beratung wegen Schwangerschaftsabbruch",
      "Erstverordnung eines Kontrazeptivums",
      "Kontrazeptionsberatung",
      "Verordnung eines Kontrazeptivums",
      "Verordnung von Ovulationshemmern"
    ]
  },
  {
    "code": "Z30.1",
    "name": "Einsetzen eines intrauterinen Pessars zur Kontrazeption",
    "synonyms": [
      "Einlage eines Intrauterinpessars",
      "Einsetzen eines intrauterinen Pessars zur Kontrazeption",
      "Pessareinlage",
      "Pessareinlage zur Kontrazeption"
    ]
  },
  {
    "code": "Z30.2",
    "name": "Sterilisierung",
    "synonyms": [
      "Antrag auf Sterilisation bei der Frau",
      "Antrag auf Sterilisation beim Mann",
      "Durchtrennung der Eileiter",
      "Durchtrennung des Samenstranges",
      "Prophylaktische Sterilisation",
      "Sterilisation bei der Frau",
      "Sterilisation beim Mann",
      "Sterilisationsberatung",
      "Sterilisationswunsch",
      "Sterilisierung",
      "Sterilisierungswunsch",
      "Tubenligatur",
      "Tubensterilisation",
      "Unterbindung der Eileiter",
      "Unterbrechung der Tuba uterina",
      "Unterbrechung der Vas deferens",
      "Vasektomie",
      "Vasektomiewunsch"
    ]
  },
  {
    "code": "Z30.3",
    "name": "Auslösung der Menstruation (zur Kontrazeption)",
    "synonyms": [
      "Abbruchblutung",
      "Auslösung der Menstruation (zur Kontrazeption)",
      "Interzeption",
      "Regulierung der Menstruation (zur Kontrazeption)"
    ]
  },
  {
    "code": "Z30.4",
    "name": "Überwachung bei medikamentöser Kontrazeption",
    "synonyms": [
      "Gynäkologische Untersuchung wegen Weiterführung kontrazeptiver Maßnahmen",
      "Hormonelle Kontrazeption",
      "Kontrolluntersuchung bei Ovulationshemmeranwendung",
      "Kontrolluntersuchung bei medikamentöser Kontrazeption",
      "Orale Kontrazeption",
      "Pillenrezept (Kontrazeptivum)",
      "Wiederholte Pillenverordnung (Kontrazeptivum)",
      "Wiederholungsrezept zur Kontrazeption",
      "Wiederverordnung eines Kontrazeptivums",
      "Überwachung bei medikamentöser Kontrazeption",
      "Überwachung einer Ein-Phasen-Methode (Kontrazeption)"
    ]
  },
  {
    "code": "Z30.5",
    "name": "Entfernung eines Intrauterinpessars",
    "synonyms": [
      "Entfernung eines Intrauterinpessars",
      "Entfernung eines Pessars (zur Kontrazeption)",
      "Extraktion eines IUP [Intrauterinpessar]",
      "Gynäkologische Untersuchung wegen Weitereinnahme kontrazeptiver Mittel",
      "Kontrolle eines Intrauterinpessars",
      "Kontrolle eines kontrazeptiven Mittels",
      "Wechsel eines Pessars",
      "Wiedereinlage eines Kontrazeptivums",
      "Wiedereinsetzen eines Intrauterinpessars",
      "Überwachung einer Pessarträgerin (wegen Kontrazeption)"
    ]
  },
  {
    "code": "Z30.8",
    "name": "Alternative Kontrazeption",
    "synonyms": [
      "Alternative Kontrazeption",
      "Spermienzählung nach Vasektomie"
    ]
  },
  {
    "code": "Z30.9",
    "name": "Empfängnisverhütung",
    "synonyms": [
      "Abgeschlossene Familienplanung",
      "Antikonzeption",
      "Antikonzeptionsmaßnahmen",
      "Empfängnisverhütende Maßnahmen",
      "Empfängnisverhütung",
      "Kontrazeption",
      "Kontrazeptive Maßnahmen",
      "Kontrolluntersuchung bei Kontrazeption",
      "Konzeptionsverhütung",
      "Schwangerschaftsprophylaxe",
      "Überwachung bei Kontrazeption"
    ]
  },
  {
    "code": "Z31.0",
    "name": "Tubenplastik nach früherer Sterilisation",
    "synonyms": [
      "Tubenplastik nach früherer Sterilisation",
      "Tubenplastik nach vorausgegangener Sterilisation",
      "Vasoplastik nach früherer Sterilisation",
      "Vasoplastik nach vorausgegangener Sterilisation"
    ]
  },
  {
    "code": "Z31.1",
    "name": "Künstliche Insemination",
    "synonyms": [
      "Artifizielle Insemination",
      "Artifizielle homologe Insemination",
      "Beratung wegen Insemination",
      "Heterologe Insemination",
      "Homologe Insemination",
      "Intrauterine Insemination",
      "Künstliche Befruchtung",
      "Künstliche Insemination",
      "Synchrone hysteroskopische Insemination",
      "Transvaginaler intratubarer Spermientransfer"
    ]
  },
  {
    "code": "Z31.2",
    "name": "Eizellentnahme",
    "synonyms": [
      "Eizellenimplantation",
      "Eizellentnahme",
      "Eizellentnahme zur In-vitro-Fertilisation",
      "Embryotransfer",
      "Extrakorporale Befruchtung",
      "Extrakorporale Fertilisation",
      "Extrakorporale Insemination",
      "Gametentransfer",
      "In-vitro-Fertilisation",
      "Intraperitonealer Gametentransfer",
      "Intratubare Fertilisation",
      "Intratubarer Embryotransfer",
      "Intratubarer Pronukleustransfer",
      "Intratubarer Zygotentransfer",
      "Intratubarer transabdominaler Gametentransfer",
      "Intrauteriner Embryotransfer",
      "Intrazytoplasmatische Spermieninjektion",
      "Transvaginaler Embryotransfer",
      "Transzervikaler transuteriner Gametentransfer",
      "Tubarer Embryotransfer"
    ]
  },
  {
    "code": "Z31.3",
    "name": "Epididymale Spermatozoenaspiration",
    "synonyms": [
      "Epididymale Spermatozoenaspiration",
      "Fertilisationsunterstützung a.n.k."
    ]
  },
  {
    "code": "Z31.4",
    "name": "Spermienzählung",
    "synonyms": [
      "Clomifentest",
      "Durchblasung der Eileiter",
      "Farnkrautphänomen [Zyklus- bzw. Fertilisationstest]",
      "Fertilisationstest",
      "Fertilitätstest",
      "Fertilitätsuntersuchung",
      "Gestagentest",
      "Insufflation der Tuben",
      "Pertubation",
      "Spermatogramm",
      "Spermienzählung",
      "Test auf follikelstimulierendes Hormon",
      "Tubendurchblasung"
    ]
  },
  {
    "code": "Z31.5",
    "name": "Genetische Beratung im Zusammenhang mit der Fertilisation",
    "synonyms": [
      "Genetische Beratung im Zusammenhang mit der Fertilisation",
      "Genetische Untersuchung im Zusammenhang mit der Fertilisation"
    ]
  },
  {
    "code": "Z31.6",
    "name": "Sterilitätsberatung",
    "synonyms": [
      "Fertilisationsberatung",
      "Kinderwunsch",
      "Sterile Ehe",
      "Sterilitätsberatung"
    ]
  },
  {
    "code": "Z31.9",
    "name": "Fertilisationsfördernde Maßnahmen",
    "synonyms": [
      "Fertilisationsfördernde Maßnahmen",
      "Fertilisationsförderung"
    ]
  },
  {
    "code": "Z32",
    "name": "Konzeption",
    "synonyms": [
      "Ausgebliebene Schwangerschaft",
      "Ausschluss einer Schwangerschaft",
      "Bestätigte Schwangerschaft",
      "Graviditätsbestätigung",
      "Graviditätsvermutung",
      "Intrauterine Gravidität",
      "Intrauterine Schwangerschaft",
      "Konzeption",
      "Schwangerschaft noch nicht bestätigt",
      "Schwangerschaftsbestätigung",
      "Schwangerschaftsfeststellung",
      "Schwangerschaftstest",
      "Schwangerschaftsverdacht",
      "Schwangerschaftsvermutung",
      "Vermutliche Schwangerschaft"
    ]
  },
  {
    "code": "Z34",
    "name": "Antepartale Vorstellung",
    "synonyms": [
      "Antepartale Vorstellung",
      "Betreuung der Schwangeren bei vorderer Hinterhauptslage",
      "Betreuung einer normalen Schwangerschaft",
      "Gravidität am Termin",
      "MSV [Mutterschaftsvorsorge]",
      "Pränatale Vorsorge während normaler Schwangerschaft",
      "Pränatale Vorsorgeuntersuchung bei normal verlaufender Schwangerschaft",
      "Pränatale Überwachung einer normalen Schwangerschaft",
      "Schwangerschaft am Termin",
      "Schwangerschaftsüberwachung",
      "Überwachung einer Drittgebärenden",
      "Überwachung einer normalen Erstschwangerschaft",
      "Überwachung einer normalen Schwangerschaft"
    ]
  },
  {
    "code": "Z35.0",
    "name": "Überwachung einer Schwangerschaft bei Infertilitätsanamnese",
    "synonyms": [
      "Überwachung einer Schwangerschaft bei Infertilitätsanamnese",
      "Überwachung einer Schwangerschaft bei vorausgegangener Unfruchtbarkeit"
    ]
  },
  {
    "code": "Z35.1",
    "name": "Überwachung einer Schwangerschaft bei Abortanamnese",
    "synonyms": [
      "Blasenmole in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Blasenmole in der Anamnese, die die Schwangerschaftsvorsorge beeinflusst",
      "Hydatidiforme Mole in der Anamnese, die die Schwangerschaftsvorsorge beeinflusst",
      "Mola hydatidosa in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Trophoblastische Krankheit in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Trophoblastische Krankheit in der Anamnese, die die Schwangerschaftsvorsorge beeinflusst",
      "Vorausgegangene Fehlgeburt in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Überwachung einer Schwangerschaft bei Abortanamnese"
    ]
  },
  {
    "code": "Z35.2",
    "name": "Vorzeitige Entbindung in der Anamnese, die die Schwangerschaftsvorsorge beeinflusst",
    "synonyms": [
      "Postpartale Blutung in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Präpartale Blutung in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Schwangerschaftsblutung in der Anamnese",
      "Schwangerschaftshämorrhagie in der Anamnese",
      "Schwierige Geburt in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Vorausgegangene Totgeburt in der Anamnese, die die Schwangerschaftsüberwachung beeinflusst",
      "Vorausgegangene Zangengeburt in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Vorzeitige Entbindung in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Vorzeitige Entbindung in der Anamnese, die die Schwangerschaftsvorsorge beeinflusst"
    ]
  },
  {
    "code": "Z35.3",
    "name": "Verborgene Schwangerschaft",
    "synonyms": [
      "Verborgene Schwangerschaft",
      "Verheimlichte Schwangerschaft"
    ]
  },
  {
    "code": "Z35.4",
    "name": "Überwachung einer Schwangerschaft bei ausgeprägter Multiparität",
    "synonyms": [
      "Überwachung einer Schwangerschaft bei ausgeprägter Multiparität"
    ]
  },
  {
    "code": "Z35.5",
    "name": "Überwachung einer Schwangerschaft bei einer älteren Erstschwangeren",
    "synonyms": [
      "Schwangerschaftsüberwachung bei älterer Erstgebärender",
      "Ältere Erstgebärende",
      "Ältere Erstschwangere",
      "Ältere Primipara",
      "Überwachung einer Schwangerschaft bei einer älteren Erstschwangeren"
    ]
  },
  {
    "code": "Z35.6",
    "name": "Überwachung einer Schwangerschaft bei einer sehr jungen Erstschwangeren",
    "synonyms": [
      "Junge Erstgebärende",
      "Junge Erstschwangere",
      "Sehr junge Primipara",
      "Überwachung einer Schwangerschaft bei einer sehr jungen Erstschwangeren"
    ]
  },
  {
    "code": "Z35.8",
    "name": "Überwachung einer Risikoschwangerschaft, durch soziales Problem bedingt",
    "synonyms": [
      "Bösartige Krankheit in der Anamnese, die den Schwangerschaftsverlauf beeinflusst a.n.k.",
      "Nichtgeburtshilfliche Affektion in der Anamnese, die den Schwangerschaftsverlauf beeinflusst",
      "Schweres Trauma in der Anamnese, das die Schwangerschaftsvorsorge beeinflusst",
      "Unfall in der Anamnese, der die Schwangerschaftsvorsorge beeinflusst",
      "Überwachung einer Risikoschwangerschaft, durch soziales Problem bedingt"
    ]
  },
  {
    "code": "Z35.9",
    "name": "Überwachung einer Risikoschwangerschaft",
    "synonyms": [
      "Risikogravidität",
      "Risikoschwangerschaft",
      "Überwachung einer Risikoschwangerschaft"
    ]
  },
  {
    "code": "Z36.0",
    "name": "Pränatales Screening auf Chromosomenanomalie",
    "synonyms": [
      "Fruchtwasseruntersuchung auf Chromosomenanomalie",
      "Karyotypisierung",
      "Pränatale Chromosomenanalyse",
      "Pränatale Chromosomendiagnostik",
      "Pränatales Screening auf Chromosomenanomalie",
      "Vaginale Entnahme einer Plazentagewebeprobe"
    ]
  },
  {
    "code": "Z36.1",
    "name": "Pränatales Screening auf erhöhten Alpha-Fetoproteinspiegel",
    "synonyms": [
      "Erhöhter Alpha-Fetoproteingehalt im Fruchtwasser",
      "Pränatales Screening auf erhöhten Alpha-Fetoproteinspiegel"
    ]
  },
  {
    "code": "Z36.2",
    "name": "Pränatales Screening mittels Amniozentese",
    "synonyms": [
      "Amniozentese-Screening",
      "Fruchtwasserscreening",
      "Fruchtwasseruntersuchung",
      "Pränatale Fruchtwasseruntersuchung a.n.k.",
      "Pränatales Screening mittels Amniozentese"
    ]
  },
  {
    "code": "Z36.3",
    "name": "Amniographie",
    "synonyms": [
      "Amniographie",
      "Amnioskopie",
      "Pränatales Screening auf Fehlbildung",
      "Pränatales Screening auf Fehlbildung mittels Ultraschall"
    ]
  },
  {
    "code": "Z36.4",
    "name": "Pränatales Screening auf fetale Wachstumsretardierung",
    "synonyms": [
      "Pränatales Screening auf fetale Wachstumsretardierung"
    ]
  },
  {
    "code": "Z36.5",
    "name": "Pränatales Screening auf Isoimmunisierung",
    "synonyms": [
      "Pränatales Screening auf Isoimmunisierung"
    ]
  },
  {
    "code": "Z36.8",
    "name": "Fetalblutanalyse",
    "synonyms": [
      "Fetalblutanalyse",
      "Pränatales Screening auf Hämoglobinopathie",
      "Screening auf Hämoglobinopathie"
    ]
  },
  {
    "code": "Z36.9",
    "name": "Pränatales Screening",
    "synonyms": [
      "Antenatales Screening",
      "Fruchtwasserdiagnostik",
      "Pränatales Screening"
    ]
  },
  {
    "code": "Z38.0",
    "name": "Geburt eines Neugeborenen im Krankenhaus",
    "synonyms": [
      "Geburt eines Neugeborenen im Krankenhaus"
    ]
  },
  {
    "code": "Z38.1",
    "name": "Geburt eines Neugeborenen außerhalb des Krankenhauses",
    "synonyms": [
      "Geburt eines Neugeborenen außerhalb des Krankenhauses",
      "Hausgeburt"
    ]
  },
  {
    "code": "Z38.2",
    "name": "Reifes Neugeborenes",
    "synonyms": [
      "Gesundes Neugeborenes",
      "Lebendgeborener Einling",
      "Lebendgeborenes Kind",
      "Neugeborener Einling",
      "Neugeborenes",
      "Neugeborenes Kind",
      "Reifes Neugeborenes",
      "Reifes gesundes Neugeborenes"
    ]
  },
  {
    "code": "Z38.3",
    "name": "Zwilling, Geburt im Krankenhaus",
    "synonyms": [
      "Zwilling, Geburt im Krankenhaus"
    ]
  },
  {
    "code": "Z38.4",
    "name": "Zwilling, Geburt außerhalb des Krankenhauses",
    "synonyms": [
      "Zwilling, Geburt außerhalb des Krankenhauses"
    ]
  },
  {
    "code": "Z38.6",
    "name": "Geburt von Mehrlingen im Krankenhaus",
    "synonyms": [
      "Geburt von Mehrlingen im Krankenhaus"
    ]
  },
  {
    "code": "Z38.7",
    "name": "Geburt von Mehrlingen außerhalb des Krankenhauses",
    "synonyms": [
      "Geburt von Mehrlingen außerhalb des Krankenhauses"
    ]
  },
  {
    "code": "Z39.0",
    "name": "Betreuung und Untersuchung der Mutter unmittelbar nach Entbindung",
    "synonyms": [
      "Betreuung der Mutter unmittelbar post partum",
      "Betreuung und Untersuchung der Mutter unmittelbar nach Entbindung",
      "Untersuchung der Mutter unmittelbar post partum"
    ]
  },
  {
    "code": "Z39.1",
    "name": "Betreuung und Untersuchung der stillenden Mutter",
    "synonyms": [
      "Betreuung und Untersuchung der stillenden Mutter",
      "Betreuung und Untersuchung während der Laktationsperiode",
      "Betreuung und Untersuchung während der Stillperiode",
      "Untersuchung der stillenden Mutter",
      "Überwachung der Laktation",
      "Überwachung der Stillperiode"
    ]
  },
  {
    "code": "Z39.2",
    "name": "Routinemäßige postpartale Nachuntersuchung der Mutter",
    "synonyms": [
      "Postpartale Betreuung der Mutter",
      "Postpartale Untersuchung der Mutter",
      "Postpartaler Zustandsbefund a.n.k.",
      "Routinemäßige postpartale Nachuntersuchung der Mutter",
      "Routinemäßige postpartale Untersuchung"
    ]
  },
  {
    "code": "Z40.00",
    "name": "Prophylaktische Mastektomie",
    "synonyms": [
      "Prophylaktische Mastektomie",
      "Prophylaktische Operation an der Brustdrüse"
    ]
  },
  {
    "code": "Z40.01",
    "name": "Prophylaktische Ovarektomie",
    "synonyms": [
      "Prophylaktische Operation am Ovar",
      "Prophylaktische Ovarektomie"
    ]
  },
  {
    "code": "Z40.08",
    "name": "Prophylaktische Operation wegen Neoplasma",
    "synonyms": [
      "Aufnahme wegen prophylaktischer Organentfernung",
      "Prophylaktische Operation wegen Neoplasma",
      "Prophylaktische Organentfernung wegen Neoplasiebehandlung"
    ]
  },
  {
    "code": "Z40.9",
    "name": "Prophylaktische Operation",
    "synonyms": [
      "Prophylaktische Operation"
    ]
  },
  {
    "code": "Z41.1",
    "name": "Vorhandensein eines Mammaimplantates",
    "synonyms": [
      "Kosmetische Brustauffüllung",
      "Kosmetische Brustreduzierung",
      "Kosmetische Haartransplantation",
      "Kosmetische plastische Operation",
      "Kosmetisches Face-Lifting",
      "Vorhandensein eines Brustimplantates",
      "Vorhandensein eines Mammaimplantates"
    ]
  },
  {
    "code": "Z41.2",
    "name": "Zirkumzision [Circumcisio] als Routinemaßnahme",
    "synonyms": [
      "Beschneidung",
      "Beschneidung ohne medizinische Indikation",
      "Circumcisio - s.a. Zirkumzision",
      "Rituelle Beschneidung",
      "Routinemäßige Beschneidung",
      "Zirkumzision [Circumcisio] als Routinemaßnahme",
      "Zirkumzision [Circumcisio] aus rituellen Gründen"
    ]
  },
  {
    "code": "Z41.8",
    "name": "Haartransplantation",
    "synonyms": [
      "Durchstechen des Ohrläppchens",
      "Haartransplantat",
      "Haartransplantation",
      "Ohrlochstechen"
    ]
  },
  {
    "code": "Z41.9",
    "name": "Elektive Operation",
    "synonyms": [
      "Elektive Operation"
    ]
  },
  {
    "code": "Z42.0",
    "name": "Rekonstruktive Operation an Kopf und Hals",
    "synonyms": [
      "Rekonstruktive Operation an Kopf und Hals",
      "Revision von Narbengewebe an Kopf und Hals"
    ]
  },
  {
    "code": "Z42.1",
    "name": "Rekonstruktive Operation der Mamma",
    "synonyms": [
      "Narbengewebsrevision der Mamma",
      "Rekonstruktive Operation der Mamma"
    ]
  },
  {
    "code": "Z42.2",
    "name": "Rekonstruktive Operation am Rumpf",
    "synonyms": [
      "Rekonstruktive Operation am Rumpf",
      "Revision von Narbengewebe am Rumpf"
    ]
  },
  {
    "code": "Z42.3",
    "name": "Rekonstruktive Operation an der oberen Extremität",
    "synonyms": [
      "Rekonstruktive Operation an der oberen Extremität",
      "Revision von Narbengewebe der oberen Extremität"
    ]
  },
  {
    "code": "Z42.4",
    "name": "Rekonstruktive Operation an der unteren Extremität",
    "synonyms": [
      "Rekonstruktive Operation an der unteren Extremität",
      "Revision von Narbengewebe der unteren Extremität"
    ]
  },
  {
    "code": "Z42.9",
    "name": "Revision von Narbengewebe",
    "synonyms": [
      "Narbengewebeplastik",
      "Rekonstruktive Operation nach abgeheilter Verletzung",
      "Revision von Narbengewebe"
    ]
  },
  {
    "code": "Z43.0",
    "name": "Tracheostomapflege",
    "synonyms": [
      "Tracheostomapflege",
      "Tracheostomaversorgung"
    ]
  },
  {
    "code": "Z43.1",
    "name": "Versorgung eines Gastrostomas",
    "synonyms": [
      "Versorgung eines Gastrostomas"
    ]
  },
  {
    "code": "Z43.2",
    "name": "Versorgung eines Ileostomas",
    "synonyms": [
      "Versorgung eines Ileostomas"
    ]
  },
  {
    "code": "Z43.3",
    "name": "Kolostomaversorgung",
    "synonyms": [
      "Kolostomaversorgung"
    ]
  },
  {
    "code": "Z43.5",
    "name": "Versorgung eines Zystostomas",
    "synonyms": [
      "Versorgung eines Zystostomas"
    ]
  },
  {
    "code": "Z43.6",
    "name": "Nephrostomaversorgung",
    "synonyms": [
      "Nephrostomaversorgung",
      "Ureterostomaversorgung",
      "Urethrostomaversorgung"
    ]
  },
  {
    "code": "Z43.7",
    "name": "Versorgung einer künstlichen Vagina",
    "synonyms": [
      "Versorgung einer künstlichen Vagina"
    ]
  },
  {
    "code": "Z43.80",
    "name": "Versorgung eines Thorakostomas",
    "synonyms": [
      "Versorgung eines Thorakostomas"
    ]
  },
  {
    "code": "Z43.9",
    "name": "Wiederherstellung einer künstlichen Körperöffnung",
    "synonyms": [
      "Einführen von Bougies",
      "Einführen von Sonden",
      "Pflege einer künstlichen Körperöffnung",
      "Reinigung einer künstlichen Körperöffnung",
      "Säuberung einer künstlichen Körperöffnung",
      "Umbildung einer künstlichen Körperöffnung",
      "Verschluss einer künstlichen Körperöffnung",
      "Versorgung einer künstlichen Körperöffnung",
      "Wiederherstellung einer künstlichen Körperöffnung"
    ]
  },
  {
    "code": "Z44.0",
    "name": "Anpassung eines künstlichen Arms",
    "synonyms": [
      "Anpassung eines künstlichen Arms"
    ]
  },
  {
    "code": "Z44.1",
    "name": "Anpassung eines künstlichen Beins",
    "synonyms": [
      "Anpassung eines künstlichen Beins"
    ]
  },
  {
    "code": "Z44.2",
    "name": "Künstliche Augenlinse",
    "synonyms": [
      "Anpassung eines künstlichen Auges",
      "Künstliche Augenlinse"
    ]
  },
  {
    "code": "Z44.3",
    "name": "Anpassung einer künstlichen Brust",
    "synonyms": [
      "Anpassung einer extrakorporalen Brustprothese",
      "Anpassung einer künstlichen Brust"
    ]
  },
  {
    "code": "Z44.9",
    "name": "Anpassung einer Ektoprothese",
    "synonyms": [
      "Anpassung einer Ektoprothese",
      "Anpassung einer Prothese",
      "Handhabung einer Ektoprothese",
      "Handhabung einer Prothese"
    ]
  },
  {
    "code": "Z45.00",
    "name": "Anpassung eines Herzschrittmachers",
    "synonyms": [
      "Aggregatwechsel eines Herzschrittmachers",
      "Anpassung eines Herzschrittmachers",
      "Handhabung eines Herzschrittmachers a.n.k.",
      "Kontrolle der Batterie eines Herzschrittmachers",
      "Kontrolle eines Herzschrittmachers",
      "Versorgung mit einem Herzschrittmacher",
      "Wechsel eines Schrittmachers"
    ]
  },
  {
    "code": "Z45.01",
    "name": "Anpassung eines implantierten Kardiodefibrillators",
    "synonyms": [
      "Anpassung eines implantierten Kardiodefibrillators"
    ]
  },
  {
    "code": "Z45.02",
    "name": "Anpassung eines herzunterstützenden Systems",
    "synonyms": [
      "Anpassung einer extrakorporalen Pumpe",
      "Anpassung einer intrakorporalen Pumpe",
      "Anpassung einer parakorporalen Pumpe",
      "Anpassung eines Kunstherzens",
      "Anpassung eines herzunterstützenden Systems",
      "Handhabung eines herzunterstützenden Systems"
    ]
  },
  {
    "code": "Z45.1",
    "name": "Handhabung einer Infusionspumpe",
    "synonyms": [
      "Handhabung einer Infusionspumpe"
    ]
  },
  {
    "code": "Z45.20",
    "name": "Handhabung eines Port-Systems",
    "synonyms": [
      "Handhabung eines Port-Systems"
    ]
  },
  {
    "code": "Z45.29",
    "name": "Entfernung eines Gefäßzugangs",
    "synonyms": [
      "Entfernung eines Gefäßzugangs",
      "Handhabung eines vaskulären Zugangs"
    ]
  },
  {
    "code": "Z45.3",
    "name": "Handhabung eines implantierten Gerätes für das Innenohr",
    "synonyms": [
      "Handhabung eines implantierten Gerätes für das Innenohr",
      "Handhabung eines implantierten Gerätes für die Knochenleitung"
    ]
  },
  {
    "code": "Z45.80",
    "name": "Anpassung eines Neurostimulators",
    "synonyms": [
      "Anpassung eines Neurostimulators",
      "Anpassung eines Vorderwurzelstimulators",
      "Handhabung eines Neurostimulators",
      "Handhabung eines Vorderwurzelstimulators"
    ]
  },
  {
    "code": "Z45.81",
    "name": "Überprüfung der Funktionsparameter eines Zwerchfellstimulators",
    "synonyms": [
      "Anpassung und Handhabung eines Zwerchfellschrittmachers",
      "Überprüfung der Funktionsparameter eines Zwerchfellstimulators"
    ]
  },
  {
    "code": "Z45.82",
    "name": "Überprüfung der Funktionsparameter einer Medikamentenpumpe",
    "synonyms": [
      "Überprüfung der Funktionsparameter einer Medikamentenpumpe"
    ]
  },
  {
    "code": "Z45.84",
    "name": "Anpassung eines Bronchialstents",
    "synonyms": [
      "Anpassung eines Bronchialstents",
      "Handhabung eines Bronchialstents"
    ]
  },
  {
    "code": "Z45.85",
    "name": "Anpassung eines Trachealstents",
    "synonyms": [
      "Anpassung eines Trachealstents",
      "Handhabung eines Trachealstents"
    ]
  },
  {
    "code": "Z45.9",
    "name": "Handhabung eines implantierten Gerätes",
    "synonyms": [
      "Handhabung eines implantierten Gerätes"
    ]
  },
  {
    "code": "Z46.0",
    "name": "Versorgung mit einer Brille",
    "synonyms": [
      "Anpassung einer Brille",
      "Anpassung einer Lesebrille",
      "Anpassung von Kontaktlinsen",
      "Versorgung mit Kontaktlinsen",
      "Versorgung mit einer Brille"
    ]
  },
  {
    "code": "Z46.1",
    "name": "Anpassung eines Hörgerätes",
    "synonyms": [
      "Anpassung eines Hörgerätes",
      "Versorgung mit einem Hörgerät"
    ]
  },
  {
    "code": "Z46.2",
    "name": "Anpassung eines optischen Hilfsmittels",
    "synonyms": [
      "Anpassung eines akustischen Gerätes",
      "Anpassung eines optischen Hilfsmittels"
    ]
  },
  {
    "code": "Z46.3",
    "name": "Anpassung einer Zahnprothese",
    "synonyms": [
      "Anpassung einer Zahnprothese",
      "Anpassung künstlicher Zähne",
      "Anpassung von Zahnersatz",
      "Versorgung mit einer Zahnprothese"
    ]
  },
  {
    "code": "Z46.4",
    "name": "Anpassung eines kieferorthopädischen Gerätes",
    "synonyms": [
      "Anpassung eines kieferorthopädischen Gerätes",
      "Kieferorthopädische Maßnahmen",
      "Kieferorthopädische Nachbehandlung",
      "Versorgung mit einem kieferorthopädischen Gerät"
    ]
  },
  {
    "code": "Z46.5",
    "name": "Anpassung eines Ileostomas",
    "synonyms": [
      "Anpassung eines Ileostomas",
      "Anpassung eines Kolostomas",
      "Anpassung eines Kolostomiegurtes",
      "Anpassung eines abdominalen Gerätes",
      "Anpassung von Vorrichtungen im Darmtrakt a.n.k.",
      "Versorgung mit einem Kolostoma"
    ]
  },
  {
    "code": "Z46.6",
    "name": "Anpassung eines Gerätes im Harntrakt",
    "synonyms": [
      "Anpassung eines Gerätes im Harntrakt",
      "Entfernung eines Dauerkatheters",
      "Entfernung eines Urinkatheters",
      "Entfernung eines Verweilkatheters",
      "Versorgung mit einem Gerät im Harntrakt",
      "Wechsel eines Dauerkatheters",
      "Wechsel eines Verweilkatheters"
    ]
  },
  {
    "code": "Z46.7",
    "name": "Anpassung eines orthopädischen Hilfsmittels",
    "synonyms": [
      "Anpassung einer Bandage",
      "Anpassung eines orthopädischen Gipsverbandes",
      "Anpassung eines orthopädischen Hilfsmittels",
      "Anpassung eines orthopädischen Mieders",
      "Anpassung eines orthopädischen Stützapparates",
      "Anpassung eines orthopädischen Verbandes",
      "Anpassung eines orthopädisches Korsetts",
      "Anpassung von orthopädischen Schuhen",
      "Versorgen mit einem orthopädischen Gipsverband",
      "Versorgen mit einem orthopädischen Korsett",
      "Versorgen mit einem orthopädischen Stützapparat",
      "Versorgen mit orthopädischen Schuhen",
      "Versorgung mit einem orthopädischen Hilfsmittel"
    ]
  },
  {
    "code": "Z46.8",
    "name": "Anpassung eines Rollstuhls",
    "synonyms": [
      "Anpassung eines Rollstuhls"
    ]
  },
  {
    "code": "Z46.9",
    "name": "Anpassung von Hilfsmitteln a.n.k.",
    "synonyms": [
      "Anpassung von Geräten a.n.k.",
      "Anpassung von Hilfsmitteln a.n.k."
    ]
  },
  {
    "code": "Z47.0",
    "name": "Metallentfernung nach Fraktur",
    "synonyms": [
      "Entfernung einer Frakturplatte",
      "Entfernung einer inneren Fixierungsvorrichtung",
      "Entfernung eines Kirschner-Drahtes",
      "Entfernung eines Nagels",
      "Entfernung eines Stabes",
      "Kontrolle einer inneren Fixierungsvorrichtung",
      "Kontrolle eines Kirschner-Drahtes",
      "Metallentfernung nach Fraktur",
      "Schraubenentfernung",
      "Wechsel einer inneren Fixierungsvorrichtung",
      "Wechsel eines Kirschner-Drahtes"
    ]
  },
  {
    "code": "Z47.8",
    "name": "Entfernung einer äußeren Extensionsvorrichtung",
    "synonyms": [
      "Entfernung einer äußeren Extensionsvorrichtung",
      "Entfernung einer äußeren Fixationsvorrichtung",
      "Entfernung einer äußeren Schiene",
      "Entfernung eines Gipsverbandes",
      "Entfernung eines äußeren Zuggurtungsapparates",
      "Kontrolle einer äußeren Fixierungsvorrichtung",
      "Kontrolle einer äußeren Schiene",
      "Kontrolle eines Gipsverbandes",
      "Wechsel einer Fixierungsvorrichtung",
      "Wechsel einer Zuggurtungsfixierung",
      "Wechsel einer äußeren Fixierungsvorrichtung",
      "Wechsel einer äußeren Schiene",
      "Wechsel eines Gipsverbandes"
    ]
  },
  {
    "code": "Z47.9",
    "name": "Orthopädische Nachbehandlung",
    "synonyms": [
      "Orthopädische Nachbehandlung"
    ]
  },
  {
    "code": "Z48.0",
    "name": "Kontrolle von Verbänden und Nähten nach chirurgischem Eingriff",
    "synonyms": [
      "Entfernung eines Verbandes",
      "Entfernung von Nahtmaterial [z.B. Fäden ziehen]",
      "Kontrolle von Verbänden und Nähten nach chirurgischem Eingriff",
      "Nahtwechsel",
      "Verbandwechsel",
      "Versorgung chirurgischer Nähte",
      "Versorgung eines Verbandes"
    ]
  },
  {
    "code": "Z48.8",
    "name": "Entfernung eines Parazenteseröhrchens",
    "synonyms": [
      "Entfernung eines Parazenteseröhrchens"
    ]
  },
  {
    "code": "Z48.9",
    "name": "Nachbehandlung nach chirurgischem Eingriff",
    "synonyms": [
      "Nachbehandlung nach chirurgischem Eingriff",
      "Postoperative Nachbehandlung"
    ]
  },
  {
    "code": "Z49.0",
    "name": "Vorbereitung auf eine Dialyse",
    "synonyms": [
      "Shuntanlage",
      "Vorbereitung auf eine Dialyse"
    ]
  },
  {
    "code": "Z49.1",
    "name": "Hämodialyse",
    "synonyms": [
      "Dialyse bei Niereninsuffizienz",
      "Extrakorporale Dialyse",
      "Hämodialyse",
      "Renale Dialyse"
    ]
  },
  {
    "code": "Z49.2",
    "name": "Peritonealdialyse",
    "synonyms": [
      "Peritonealdialyse"
    ]
  },
  {
    "code": "Z51.0",
    "name": "Bestrahlungstherapie",
    "synonyms": [
      "Bestrahlungstherapie",
      "Radiotherapiesitzung",
      "Strahlentherapiesitzung",
      "Therapeutische Applikation einer radioaktiven Substanz"
    ]
  },
  {
    "code": "Z51.1",
    "name": "Chemotherapie bei Karzinom",
    "synonyms": [
      "Chemotherapie als Erhaltungsdosis bei Neubildung a.n.k.",
      "Chemotherapie bei Karzinom",
      "Chemotherapie bei Krebs",
      "Chemotherapie bei Neubildung",
      "Dauertherapie mit Chemotherapeutika bei Neubildung"
    ]
  },
  {
    "code": "Z51.2",
    "name": "Chemotherapie",
    "synonyms": [
      "Chemotherapie",
      "Chemotherapie mit Erhaltungsdosis a.n.k.",
      "Chemotherapiesitzung",
      "Dauertherapie mit Chemotherapeutika",
      "Zytostatische Therapie bei nichtmaligner Erkrankung"
    ]
  },
  {
    "code": "Z51.3",
    "name": "Bluttransfusion ohne angegebene Diagnose",
    "synonyms": [
      "Bluttransfusion",
      "Bluttransfusion ohne angegebene Diagnose"
    ]
  },
  {
    "code": "Z51.4",
    "name": "Vorbereitung auf nachfolgende Behandlung",
    "synonyms": [
      "Vorbereitung auf nachfolgende Behandlung"
    ]
  },
  {
    "code": "Z51.5",
    "name": "Palliativbehandlung",
    "synonyms": [
      "Palliativbehandlung",
      "Palliative Betreuung"
    ]
  },
  {
    "code": "Z51.6",
    "name": "Desensibilisierung gegenüber Allergenen",
    "synonyms": [
      "Desensibilisierung gegenüber Allergenen",
      "Hyposensibilisierung gegenüber Allergenen"
    ]
  },
  {
    "code": "Z51.81",
    "name": "Apherese",
    "synonyms": [
      "Apherese"
    ]
  },
  {
    "code": "Z51.82",
    "name": "Kombinierte Strahlen- und Chemotherapiesitzung wegen bösartiger Neubildung",
    "synonyms": [
      "Kombinierte Strahlen- und Chemotherapiesitzung wegen bösartiger Neubildung"
    ]
  },
  {
    "code": "Z51.83",
    "name": "Opiatsubstitution",
    "synonyms": [
      "Drogensubstitution",
      "Methadonsubstitution",
      "Opiatsubstitution"
    ]
  },
  {
    "code": "Z51.9",
    "name": "Nachbehandlung",
    "synonyms": [
      "Nachbehandlung",
      "Therapie"
    ]
  },
  {
    "code": "Z52.00",
    "name": "Blutspender",
    "synonyms": [
      "Blutspender"
    ]
  },
  {
    "code": "Z52.01",
    "name": "Stammzellenspender",
    "synonyms": [
      "Stammzellenspender"
    ]
  },
  {
    "code": "Z52.08",
    "name": "Lymphozytenspender",
    "synonyms": [
      "Lymphozytenspender",
      "Thrombozytenspender"
    ]
  },
  {
    "code": "Z52.1",
    "name": "Hautspender",
    "synonyms": [
      "Hautspender"
    ]
  },
  {
    "code": "Z52.2",
    "name": "Knochenspender",
    "synonyms": [
      "Knochenspender"
    ]
  },
  {
    "code": "Z52.3",
    "name": "Knochenmarkspender",
    "synonyms": [
      "Knochenmarkspender"
    ]
  },
  {
    "code": "Z52.4",
    "name": "Nierenspender",
    "synonyms": [
      "Nierenspender"
    ]
  },
  {
    "code": "Z52.5",
    "name": "Korneaspender",
    "synonyms": [
      "Hornhautspender",
      "Korneaspender"
    ]
  },
  {
    "code": "Z52.6",
    "name": "Leberspender",
    "synonyms": [
      "Leberspender"
    ]
  },
  {
    "code": "Z52.7",
    "name": "Herzspender",
    "synonyms": [
      "Herzspender"
    ]
  },
  {
    "code": "Z52.80",
    "name": "Lungenspender",
    "synonyms": [
      "Lungenspender"
    ]
  },
  {
    "code": "Z52.88",
    "name": "Samenspender",
    "synonyms": [
      "Samenspender",
      "Spermienspender"
    ]
  },
  {
    "code": "Z52.9",
    "name": "Gewebespender",
    "synonyms": [
      "Gewebespender",
      "Organspender",
      "Spender"
    ]
  },
  {
    "code": "Z53",
    "name": "Nicht durchgeführte Operation",
    "synonyms": [
      "Maßnahme nicht durchgeführt wegen vom Patienten unabhängigen Gründen",
      "Nicht durchgeführte Maßnahme aus Glaubensgründen",
      "Nicht durchgeführte Maßnahme wegen Gruppendruck",
      "Nicht durchgeführte Maßnahme wegen Kontraindikation",
      "Nicht durchgeführte Operation",
      "Verweigerung der Behandlung",
      "Verweigerung der Behandlung als Entscheidung des Patienten",
      "Verweigerung einer Behandlung aus Glaubensgründen",
      "Verweigerung einer Behandlung wegen Gruppendruck"
    ]
  },
  {
    "code": "Z55",
    "name": "Bildungsnachteil",
    "synonyms": [
      "Analphabetentum",
      "Ausbildungsbedingte Benachteiligung",
      "Ausbildungsbedingtes Problem",
      "Bildungsbedingte Anpassungsstörung",
      "Bildungsbedingte Benachteiligung",
      "Bildungsbedingtes Problem",
      "Bildungsnachteil",
      "Geringes Niveau des Lese-Schreib-Vermögens",
      "Inadäquater Unterricht",
      "Mangelnde Anpassung an schulische Anforderungen",
      "Nichtverfügbarkeit von Schulunterricht",
      "Problem mit Lehrern",
      "Problem mit Lese-Schreib-Vermögen",
      "Problem mit Mitschülern",
      "Problem mit Studium",
      "Problem mit der Hochschulausbildung",
      "Problem mit der Rechtschreibung durch inadäquaten Unterricht",
      "Problem mit inadäquatem bildungsbezogenen Unterricht",
      "Problem mit nicht bestandenen Prüfungen",
      "Schulproblem",
      "Schulschwierigkeiten",
      "Schwache schulische Leistung",
      "Ungenügende schulische Leistung",
      "Ungenügender Unterricht",
      "Unstimmigkeit mit Lehrern",
      "Unstimmigkeit mit Mitschülern",
      "Unzufriedenheit mit Schulmilieu",
      "Unzulängliche schulische Leistung"
    ]
  },
  {
    "code": "Z56",
    "name": "Schwierige Arbeitsbedingungen",
    "synonyms": [
      "Anpassungsproblem wegen Arbeitsplatzwechsel",
      "Arbeitsplatzbedingte Schwierigkeiten",
      "Belastung durch Einteilung der Arbeitszeit",
      "Berufsbedingte Anpassungsstörung",
      "Berufsbedingte Schwierigkeiten",
      "Berufsbedingtes Problem",
      "Nichtzusagende Arbeit",
      "Physische Belastung durch Arbeit",
      "Physischer Stress durch Arbeit",
      "Problem bei der Berufswahl",
      "Problem mit Arbeitgeber",
      "Problem mit Arbeitskollegen",
      "Problem mit Vorgesetzten",
      "Problem mit den Arbeitsbedingungen a.n.k.",
      "Problem wegen Arbeitslosigkeit",
      "Problem wegen drohender Arbeitslosigkeit",
      "Psychische Belastung durch Arbeit",
      "Psychischer Stress durch Arbeit",
      "Psychosoziale Wirkung des Arbeitsplatzes",
      "Schichtarbeit",
      "Schwierige Arbeitsbedingungen",
      "Sorge wegen Arbeitslosigkeit",
      "Sorge wegen Arbeitsplatzverlust",
      "Sorge wegen Jobwechsel",
      "Unstimmigkeit mit Arbeitgeber",
      "Unstimmigkeit mit Arbeitskollegen",
      "Unstimmigkeit mit Vorgesetzten",
      "Unstimmigkeit mit anderen Beschäftigten",
      "Unzufriedenheit mit Berufstätigkeit",
      "Unzulängliche Umgebung bei der Arbeit a.n.k."
    ]
  },
  {
    "code": "Z57",
    "name": "Berufliche Exposition gegenüber Luftverschmutzung a.n.k.",
    "synonyms": [
      "Berufliche Exposition gegenüber Bodenverschmutzung",
      "Berufliche Exposition gegenüber Immission",
      "Berufliche Exposition gegenüber Luftverschmutzung a.n.k.",
      "Berufliche Exposition gegenüber Lärm",
      "Berufliche Exposition gegenüber Risikofaktoren",
      "Berufliche Exposition gegenüber Staub",
      "Berufliche Exposition gegenüber Strahlung",
      "Berufliche Exposition gegenüber Vibration",
      "Berufliche Exposition gegenüber extremer Temperatur",
      "Berufliche Exposition gegenüber mechanischen Schwingungen",
      "Berufliche Exposition gegenüber toxischen Substanzen in der Landwirtschaft",
      "Exposition gegenüber einem industriellen toxischen Feststoff",
      "Exposition gegenüber einer industriellen toxischen Flüssigkeit",
      "Exposition gegenüber einer industriellen toxischen Substanz",
      "Exposition gegenüber industriellen toxischen Dampfes"
    ]
  },
  {
    "code": "Z58",
    "name": "Unzulängliche Trinkwasserversorgung",
    "synonyms": [
      "Belastung durch elektromagnetische hochfrequente Felder",
      "Elektrosensibilität",
      "Exposition gegenüber Bodenverschmutzung",
      "Exposition gegenüber Erdbodenimmission",
      "Exposition gegenüber Immission a.n.k.",
      "Exposition gegenüber Kontamination der Luft a.n.k.",
      "Exposition gegenüber Luftverschmutzung",
      "Exposition gegenüber Lärm",
      "Exposition gegenüber Staub a.n.k.",
      "Exposition gegenüber Strahlung a.n.k.",
      "Exposition gegenüber Wasserverschmutzung",
      "Exposition gegenüber mechanischen Schwingungen",
      "Nichtberufliche Exposition gegenüber extremer Temperatur",
      "Nichtberufliche Exposition gegenüber industriellen toxischen Substanzen",
      "Nichtberufliche Exposition gegenüber toxischen Substanzen in der Landwirtschaft",
      "Problem mit kommunaler Umwelt",
      "Problem mit unzulänglicher Umgebung bei kommunaler Umwelt",
      "Schimmelpilzbelastung",
      "Unzulängliche Trinkwasserversorgung"
    ]
  },
  {
    "code": "Z59",
    "name": "Obdachloser",
    "synonyms": [
      "Andauernder Mangel an Wohnmöglichkeit",
      "Armut",
      "Beengte Wohnverhältnisse",
      "Extreme Armut",
      "Extreme Verarmung",
      "Finanzielle Schwierigkeiten, die die Versorgung beeinflussen a.n.k.",
      "Finanzielles Problem",
      "Geringes Einkommen",
      "Inadäquate Wohnverhältnisse",
      "Internatsschüler",
      "Isoliert lebende Person",
      "Landstreicher",
      "Mangel an Heizmöglichkeit",
      "Mangel an Unterkunft",
      "Mangel an adäquater Nahrung a.n.k.",
      "Mangel an finanziellen Mitteln",
      "Mangel an materiellen Gütern",
      "Nichtsesshaftigkeit",
      "Nomade",
      "Obdachloser",
      "Obdachlosigkeit",
      "Person ohne festen Wohnsitz",
      "Problem durch Leben in einer Wohneinrichtung",
      "Problem mit Haushalts- und Wohnverhältnissen, die die Versorgung beeinflussen",
      "Problem mit Zwangsvollstreckung einer Darlehensschuld",
      "Problem mit dem Gläubiger",
      "Problem mit den Wohnverhältnissen",
      "Problem mit der Unterkunft",
      "Problem wegen Bankrotts",
      "Sorge wegen Bankrotts",
      "Technische Mängel in der Unterkunft, die keine angemessene Pflege zulassen",
      "Ungenügende Fürsorgeunterstützung",
      "Ungenügendes Einkommen",
      "Unstimmigkeit mit Mietern",
      "Unstimmigkeit mit Nachbarn",
      "Unstimmigkeit mit Vermieter",
      "Unzulängliche Umgebung a.n.k.",
      "Vagabund",
      "Verarmung a.n.k.",
      "Vorübergehender Mangel an Wohnmöglichkeit",
      "Wirtschaftliches Problem",
      "Ärztliche Beratung bei Bewohner einer institutionellen Einrichtung"
    ]
  },
  {
    "code": "Z60",
    "name": "Diskriminierung",
    "synonyms": [
      "Adoleszentenkrise",
      "Anpassungsproblem an den Ruhestand",
      "Anpassungsproblem an die Übergangsphasen im Lebenszyklus",
      "Anpassungsproblem wegen Ablehnung",
      "Anpassungsproblem wegen Ausgrenzung",
      "Anpassungsproblem wegen Vereinsamung",
      "Atypische familiäre Situation",
      "Diskriminierung",
      "Diskriminierung wegen der Geschlechtszugehörigkeit",
      "Empty nest syndrome",
      "Ethnische Diskriminierung",
      "Exposition gegenüber Diskriminierung",
      "Exposition gegenüber Verfolgung",
      "Gesellschaftliche Verfolgung",
      "Kulturell bedingter schmerzlicher Verlust",
      "Kulturell bedingtes Schockerlebnis",
      "Mobbing",
      "Politische Diskriminierung",
      "Problem mit der kulturellen Eingewöhnung",
      "Problem wegen Ablehnung",
      "Problem wegen Diskriminierung",
      "Problem wegen Pensionierung",
      "Problem wegen atypischer Familiensituation",
      "Problem wegen des sozialen Umfelds",
      "Problem, weil alleinlebend",
      "Pubertätskonflikt",
      "Pubertätskrise",
      "Rassische Diskriminierung",
      "Religiöse Diskriminierung",
      "Sorge wegen Migration",
      "Soziale Ablehnung",
      "Soziale Anpassungsstörung",
      "Soziale Anpassungsstörung wegen Ablehnung",
      "Soziale Anpassungsstörung wegen Diskriminierung",
      "Soziale Anpassungsstörung wegen Verfolgung",
      "Soziale Anpassungsstörung wegen einer Übergangsphase im Lebenszyklus",
      "Soziale Anpassungsstörung wegen kultureller Eingewöhnung",
      "Soziale Ausgrenzung",
      "Soziale Isolierung",
      "Soziale Verfolgung",
      "Syndrom des leeren Nestes",
      "Verlust des Kulturraums",
      "Verlust sozialer Beziehungen",
      "Versetzung in andere soziale Umgebung",
      "Ärztliche Beratung einer allein stehenden Person"
    ]
  },
  {
    "code": "Z61",
    "name": "Demütigung in der Kindheit",
    "synonyms": [
      "Demütigende Ereignisse in der Kindheit",
      "Demütigung in der Kindheit",
      "Deprivationssyndrom",
      "Eltern-Kind-Problem",
      "Herauslösung aus dem Elternhaus in der Kindheit",
      "Herauslösung aus dem Elternhaus in der Kindheit, in ein Pflegeheim",
      "Problem durch angsterregende Erlebnisse in der Kindheit",
      "Problem durch negative Kindheitserlebnisse",
      "Problem eines Kindes mit einem neuen Elternteil",
      "Problem eines Kindes wegen Geburt eines Geschwisters",
      "Problem eines Kindes wegen Kindesmisshandlung",
      "Psychisches Trauma in der Kindheit",
      "Verlust der Eltern in der Kindheit",
      "Verlust der Familie in der Kindheit",
      "Verlust einer nahen Bezugsperson in der Kindheit",
      "Verlust von Selbstwertgefühl in der Kindheit",
      "Veränderung der Familienbeziehungen in der Kindheit"
    ]
  },
  {
    "code": "Z62",
    "name": "Problem wegen elterlicher Überprotektion",
    "synonyms": [
      "Ein Kind betreffende Institutionalisierung",
      "Emotionale Vernachlässigung in der Kindheit",
      "Feindseligkeit gegenüber einem Kind",
      "Institutionelle Erziehung",
      "Institutioneller Aufenthalt",
      "Mangel an Lernerfahrung in der Kindheit",
      "Mangel an Spielerfahrung in der Kindheit",
      "Problem durch unangebrachten elterlichen Druck",
      "Problem mit der Erziehung",
      "Problem mit der Kindererziehung a.n.k.",
      "Problem wegen elterlicher Überprotektion",
      "Schuldzuweisung an ein Kind",
      "Ungenügende Beaufsichtigung des Kindes durch die Eltern",
      "Ungenügende elterliche Überwachung des Kindes",
      "Überprotektion der Eltern"
    ]
  },
  {
    "code": "Z63",
    "name": "Ehescheidung",
    "synonyms": [
      "Ambivalentes Partnerschaftsproblem",
      "Behinderter in der Familie",
      "Betreuung eines kranken Familienmitglieds",
      "Ehekonflikt",
      "Eheliche Anpassungsstörung",
      "Eheproblem",
      "Ehescheidung",
      "Einzeln Hinterbliebener",
      "Entfremdung",
      "Erziehungsschwierigkeiten",
      "Familienzerrüttung",
      "Familienzerrüttung durch Scheidung",
      "Familiäre Konfliktsituation",
      "Familiäres Problem",
      "Fehlen eines Familienangehörigen",
      "Gesundheitliches Problem in der Familie",
      "Hinterbliebener",
      "Hochgradige Affektbereitschaft in der Familie",
      "Häusliche Betreuung eines Kranken in der Familie",
      "Interaktionsstörung Mutter-Kind",
      "Isolierung der Familie",
      "Kranker in der Familie",
      "Partnerkonflikt",
      "Partnerschaftliche Anpassungsstörung",
      "Partnerschaftsbeziehungsstörung",
      "Partnerschaftsproblem",
      "Problem durch ein Pflegekind",
      "Problem durch ein adoptiertes Kind",
      "Problem im engeren Familienkreis",
      "Problem mit Alkoholismus in der Familie",
      "Problem mit Ehepartner",
      "Problem mit Eltern",
      "Problem mit Partner",
      "Problem mit Schwiegereltern",
      "Problem wegen Scheidung",
      "Problem wegen Trennung",
      "Problem wegen des Todes eines Familienangehörigen",
      "Trennungskind",
      "Ungenügende familiäre Kommunikation",
      "Ungenügende familiäre Unterstützung",
      "Unstimmigkeit in der Familie",
      "Unstimmigkeit mit Ehepartner oder Partner",
      "Unstimmigkeit mit Eltern",
      "Unstimmigkeit mit Schwiegereltern",
      "Unstimmigkeit mit angeheirateten Verwandten",
      "Vermuteter Tod eines Familienangehörigen",
      "Verschwinden eines Familienangehörigen",
      "Zerrüttung der Ehe",
      "Zurückgezogen lebende Familie"
    ]
  },
  {
    "code": "Z64.0",
    "name": "Problem wegen unerwünschter Schwangerschaft",
    "synonyms": [
      "Problem wegen unerwünschter Schwangerschaft",
      "Schwangerschaftskonflikt",
      "Unerwünschte Geburt",
      "Unerwünschte Schwangerschaft a.n.k."
    ]
  },
  {
    "code": "Z64.1",
    "name": "Multiparität",
    "synonyms": [
      "Ausgeprägte Multiparität",
      "Mehrgebärende",
      "Multiparität",
      "Problem wegen Multiparität"
    ]
  },
  {
    "code": "Z64.8",
    "name": "Problem mit einer Beratungsperson",
    "synonyms": [
      "Problem mit einem Bewährungshelfer",
      "Problem mit einem Sozialarbeiter",
      "Problem mit einer Beratungsperson"
    ]
  },
  {
    "code": "Z65",
    "name": "Terrorismusopfer",
    "synonyms": [
      "Betroffensein von Krieg",
      "Betroffensein von einer Katastrophe",
      "Exposition gegenüber Folterung",
      "Exposition gegenüber Terrorismus",
      "Kriegsopfer",
      "Opfer",
      "Opfer einer Katastrophe",
      "Opfer von Folterung a.n.k.",
      "Problem durch Kindersorgerechts- oder Unterhaltsverfahren",
      "Problem mit Gefängnisstrafe oder Freiheitsstrafe",
      "Problem wegen Entlassung aus dem Gefängnis",
      "Problem wegen Inhaftierung",
      "Problem wegen Verurteilung in Rechtsverfahren",
      "Psychosoziales Problem",
      "Rechtsproblem",
      "Sorge wegen Entlassung aus dem Gefängnis",
      "Sorge wegen Freiheitsstrafe",
      "Sorge wegen Gefängnisstrafe",
      "Sorge wegen Inhaftierung",
      "Sorge wegen Prozess",
      "Sorge wegen Rechtsstreitigkeit",
      "Sorge wegen Strafverfolgung",
      "Sorge wegen Verurteilung",
      "Sozialkonflikt",
      "Terrorismusopfer",
      "Verbrechensopfer",
      "Verlust emotionaler Zuwendung a.n.k.",
      "Verurteilung mit Gefängnisstrafe"
    ]
  },
  {
    "code": "Z70",
    "name": "Sexualerziehung",
    "synonyms": [
      "Beratung wegen Einstellung zur Sexualität",
      "Beratung wegen Impotenz",
      "Beratung wegen Nichtansprechbarkeit",
      "Beratung wegen Promiskuität",
      "Beratung wegen sexueller Orientierung",
      "Sexualberatung",
      "Sexualberatung im Namen einer dritten Person",
      "Sexualberatung zu kombinierten Problemen",
      "Sexualerziehung"
    ]
  },
  {
    "code": "Z71",
    "name": "Reiseimpfberatung",
    "synonyms": [
      "Befundbesprechung",
      "Befunderläuterung",
      "Befürchteter Zustand nicht nachgewiesen",
      "Beratung",
      "Beratung bei Arzneimittel- oder Drogenabhängigkeit",
      "Beratung bei Blutsverwandtschaft",
      "Beratung bei Konsanguinität",
      "Beratung bei Missbrauch einer Substanz",
      "Beratung für nicht anwesende dritte Person",
      "Beratung in Bezug auf HIV",
      "Beratung wegen Adipositas",
      "Beratung wegen Alkoholabhängigkeit",
      "Beratung wegen Alkoholmissbrauch",
      "Beratung wegen Arzneimittelmissbrauch",
      "Beratung wegen Drogenmissbrauch",
      "Beratung wegen Tabakabhängigkeit",
      "Beratung wegen Tabakmissbrauch",
      "Beratung zur Erläuterung von Untersuchungsergebnissen",
      "Diätberatung",
      "Diätberatung bei Diabetes mellitus",
      "Diätberatung bei Nahrungsmittelallergie",
      "Diätberatung bei Nahrungsmittelintoleranz",
      "Diätetische Beratung bei Gastritis",
      "Diätetische Beratung bei Hypercholesterinämie",
      "Diätetische Beratung bei Hypoglykämie",
      "Diätetische Beratung bei Kolitis",
      "Diätetische Überwachung bei Diabetes mellitus",
      "Diätetische Überwachung bei Gastritis",
      "Diätetische Überwachung bei Hypercholesterinämie",
      "Diätetische Überwachung bei Kolitis",
      "Diätkontrolle",
      "Diätüberwachung",
      "Diätüberwachung bei Diabetes mellitus",
      "Diätüberwachung bei Nahrungsmittelallergie",
      "Diätüberwachung bei Nahrungsmittelintoleranz",
      "Erläuterung von Untersuchungsergebnissen",
      "Erläuterung von Verordnungen",
      "Ernährungsberatung",
      "Ernährungsüberwachung",
      "Furcht vor Krankheit ohne diagnostische Bestätigung",
      "Impfberatung",
      "Konsultation ohne Beschwerden",
      "Konsultation zur Befunderläuterung",
      "Medizinische Beratung",
      "Problem erwies sich als Normalbefund",
      "Reiseimpfberatung",
      "Unbegründete Besorgnis bei normalem Gesundheitszustand",
      "Ärztliche Beratung",
      "Überwachung bei Arzneimittel- oder Drogenabhängigkeit",
      "Überwachung bei Arzneimittel- oder Drogenmissbrauch",
      "Überwachung wegen Alkoholabhängigkeit",
      "Überwachung wegen Alkoholmissbrauch",
      "Überwachung wegen Tabakabhängigkeit"
    ]
  },
  {
    "code": "Z72.0",
    "name": "Tabakkonsum a.n.k.",
    "synonyms": [
      "Alkoholkonsum a.n.k.",
      "Nikotinkonsum a.n.k.",
      "Tabakkonsum a.n.k."
    ]
  },
  {
    "code": "Z72.8",
    "name": "Riskantes Sexualverhalten",
    "synonyms": [
      "Beteiligung an Glücksspiel",
      "Beteiligung an Wetten",
      "Inadäquate Essgewohnheiten",
      "Mangel an körperlicher Bewegung",
      "Risikofaktor Sexualverhalten",
      "Riskantes Sexualverhalten",
      "Selbstschädigendes Verhalten",
      "Ungeeignete Ernährungsgewohnheiten",
      "Ungeeignete Essgewohnheiten",
      "Unsoziales Verhalten beim Kind oder Erwachsenen"
    ]
  },
  {
    "code": "Z72.9",
    "name": "Problem bei der Lebensführung",
    "synonyms": [
      "Problem bei der Lebensführung"
    ]
  },
  {
    "code": "Z73",
    "name": "Emanzipationskonflikt",
    "synonyms": [
      "Akzentuierung der Persönlichkeit",
      "Akzentuierung von Persönlichkeitszügen",
      "Akzentuierung von Persönlichkeitszügen vom Typ A",
      "Ausgebranntsein",
      "Burn-out-Erschöpfung",
      "Burn-out-Syndrom",
      "Burn-out-Zustand",
      "Einschränkung von Aktivitäten durch Behinderung",
      "Emanzipationskonflikt",
      "Mangel an Entspannung",
      "Mangel an Freizeit",
      "Physische Überforderung a.n.k.",
      "Physischer Stress a.n.k.",
      "Problem bei der Lebensbewältigung",
      "Psychische Belastung",
      "Psychischer Stress a.n.k.",
      "Sozialer Rollenkonflikt a.n.k.",
      "Stress",
      "Stresssituation",
      "Totale Erschöpfung a.n.k.",
      "Typ-A-Persönlichkeit",
      "Typ-A-Verhalten",
      "Unzulängliche soziale Fähigkeiten a.n.k.",
      "Zukunftsangst"
    ]
  },
  {
    "code": "Z74.0",
    "name": "Bettlägerigkeit, die Gesundheitspflege erfordert",
    "synonyms": [
      "Abhängigkeit vom Krankenstuhl, die Gesundheitspflege erfordert",
      "Bettlägerigkeit, die Gesundheitspflege erfordert",
      "Hilfebedürftigkeit durch eingeschränkte Mobilität"
    ]
  },
  {
    "code": "Z74.1",
    "name": "Notwendigkeit der Hilfestellung bei der Körperpflege",
    "synonyms": [
      "Notwendigkeit der Hilfestellung bei der Körperpflege"
    ]
  },
  {
    "code": "Z74.2",
    "name": "Mangel an einer Person, die Pflege übernehmen kann",
    "synonyms": [
      "Mangel an einer Person, die Pflege übernehmen kann",
      "Mangel an häuslicher Pflegemöglichkeit für Kranken"
    ]
  },
  {
    "code": "Z74.3",
    "name": "Notwendigkeit der ständigen Beaufsichtigung",
    "synonyms": [
      "Notwendigkeit der ständigen Beaufsichtigung"
    ]
  },
  {
    "code": "Z74.9",
    "name": "Pflegebedürftigkeit",
    "synonyms": [
      "Abhängigkeit von Pflege",
      "Pflegebedürftigkeit"
    ]
  },
  {
    "code": "Z75.2",
    "name": "Wartezeit auf eine Untersuchung oder Behandlung",
    "synonyms": [
      "Wartezeit auf eine Untersuchung oder Behandlung"
    ]
  },
  {
    "code": "Z75.60",
    "name": "Registrierung zur Nierentransplantation ohne Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Nierentransplantation ohne Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.64",
    "name": "Registrierung zur Nieren-Pankreas-Transplantation ohne Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Nieren-Pankreas-Transplantation ohne Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.65",
    "name": "Registrierung zur Pankreastransplantation ohne Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Pankreastransplantation ohne Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.66",
    "name": "Registrierung zur Dünndarmtransplantation ohne Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Dünndarmtransplantation ohne Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.67",
    "name": "Registrierung zur Lebertransplantation ohne Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Lebertransplantation ohne Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.70",
    "name": "Registrierung zur Nierentransplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Nierentransplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.74",
    "name": "Registrierung zur Nieren-Pankreas-Transplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Nieren-Pankreas-Transplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.75",
    "name": "Registrierung zur Pankreastransplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Pankreastransplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.76",
    "name": "Registrierung zur Dünndarmtransplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Dünndarmtransplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.77",
    "name": "Registrierung zur Lebertransplantation mit Dringlichkeitsstufe HU [High Urgency]",
    "synonyms": [
      "Registrierung zur Lebertransplantation mit Dringlichkeitsstufe HU [High Urgency]"
    ]
  },
  {
    "code": "Z75.8",
    "name": "Hauspflege nicht verfügbar",
    "synonyms": [
      "Hauspflege nicht verfügbar",
      "Nichtverfügbarkeit eines Betts in einer medizinischen Einrichtung",
      "Nichtverfügbarkeit häuslicher medizinischer Betreuungsmöglichkeit",
      "Nichtverfügbarkeit medizinischer Betreuungsmöglichkeit",
      "Nichtverfügbarkeit medizinischer Betreuungsmöglichkeit in der Poliklinik",
      "Nichtverfügbarkeit von Gesundheitsfürsorgediensten a.n.k.",
      "Nichtverfügbarkeit von Sozialhilfestellen",
      "Person, die auf Aufnahme in eine angemessene Betreuungseinrichtung wartet",
      "Urlaubsbetreuung für Pflegebedürftige",
      "Zeitlich befristete Betreuung"
    ]
  },
  {
    "code": "Z75.9",
    "name": "Problem mit der Gesundheitsversorgung",
    "synonyms": [
      "Problem mit der Gesundheitsversorgung"
    ]
  },
  {
    "code": "Z76.0",
    "name": "Rezeptverschreibung",
    "synonyms": [
      "Ausstellung einer wiederholten Verordnung",
      "Rezeptverschreibung",
      "Wiederverordnung einer Brille",
      "Wiederverordnung eines Apparates",
      "Wiederverordnung eines Arzneimittels"
    ]
  },
  {
    "code": "Z76.1",
    "name": "Findelkind",
    "synonyms": [
      "Betreuung eines Findelkindes",
      "Findelkind"
    ]
  },
  {
    "code": "Z76.2",
    "name": "Betreuung eines gesunden Säuglings",
    "synonyms": [
      "Betreuung eines Kindes",
      "Betreuung eines gesunden Säuglings"
    ]
  },
  {
    "code": "Z76.3",
    "name": "Gesunde Begleitperson eines Kranken",
    "synonyms": [
      "Gesunde Begleitperson eines Kranken"
    ]
  },
  {
    "code": "Z76.4",
    "name": "Aufgenommene Person im Krankenhaus a.n.k.",
    "synonyms": [
      "Aufgenommene Person im Krankenhaus a.n.k."
    ]
  },
  {
    "code": "Z76.8",
    "name": "Simulant",
    "synonyms": [
      "Simulant",
      "Simulieren",
      "Vorgetäuschte Krankheit"
    ]
  },
  {
    "code": "Z76.9",
    "name": "Inanspruchnahme des Gesundheitswesens",
    "synonyms": [
      "Inanspruchnahme des Gesundheitswesens"
    ]
  },
  {
    "code": "Z80.0",
    "name": "Bösartige Neubildung der Verdauungsorgane in der Familienanamnese",
    "synonyms": [
      "Bösartige Neubildung der Verdauungsorgane in der Familienanamnese",
      "Bösartige Neubildung im Gastrointestinaltrakt in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.1",
    "name": "Bösartige Neubildung der Lunge in der Familienanamnese",
    "synonyms": [
      "Bösartige Neubildung der Bronchien in der Familienanamnese",
      "Bösartige Neubildung der Lunge in der Familienanamnese",
      "Bösartige Neubildung der Trachea in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.2",
    "name": "Bösartige Neubildung intrathorakaler Organe in der Familienanamnese a.n.k.",
    "synonyms": [
      "Bösartige Neubildung der Atmungsorgane in der Familienanamnese a.n.k.",
      "Bösartige Neubildung intrathorakaler Organe in der Familienanamnese a.n.k."
    ]
  },
  {
    "code": "Z80.3",
    "name": "Mammakarzinom in der Familienanamnese",
    "synonyms": [
      "Bösartige Neubildung der Brustdrüse in der Familienanamnese",
      "Bösartige Neubildung der Mamma in der Familienanamnese",
      "Mammakarzinom in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.4",
    "name": "Bösartige Neubildung der Genitalorgane in der Familienanamnese",
    "synonyms": [
      "Bösartige Neubildung der Genitalorgane in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.5",
    "name": "Blasenkarzinom in der Familienanamnese",
    "synonyms": [
      "Blasenkarzinom in der Familienanamnese",
      "Bösartige Neubildung der Harnorgane in der Familienanamnese",
      "Bösartige Neubildung des Harntraktes in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.6",
    "name": "Leukämie in der Familienanamnese",
    "synonyms": [
      "Leukämie in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.7",
    "name": "Bösartige Neubildung des hämatopoetischen Gewebes in der Familienanamnese a.n.k.",
    "synonyms": [
      "Bösartige Neubildung des hämatopoetischen Gewebes in der Familienanamnese a.n.k.",
      "Bösartige Neubildung des lymphatischen Gewebes in der Familienanamnese a.n.k."
    ]
  },
  {
    "code": "Z80.8",
    "name": "Bösartige Neubildung der Haut in der Familienanamnese",
    "synonyms": [
      "Bösartige Neubildung der Haut in der Familienanamnese"
    ]
  },
  {
    "code": "Z80.9",
    "name": "Bösartige Neubildung in der Familienanamnese",
    "synonyms": [
      "Bösartige Neubildung in der Familienanamnese",
      "Familiäre Karzinombelastung",
      "Karzinomdisposition"
    ]
  },
  {
    "code": "Z81",
    "name": "Psychische Krankheit in der Familienanamnese",
    "synonyms": [
      "Alkoholmissbrauch in der Familienanamnese",
      "Arzneimittel- und Drogenmissbrauch in der Familienanamnese a.n.k.",
      "Geistige Retardierung in der Familienanamnese",
      "Geistige Störung in der Familienanamnese",
      "Missbrauch psychotroper Substanzen in der Familienanamnese a.n.k.",
      "Psychische Krankheit in der Familienanamnese",
      "Selbstschädigendes Verhalten in der Familienanamnese",
      "Tabakmissbrauch in der Familienanamnese",
      "Tourette-Syndrom in der Familienanamnese",
      "Verhaltensstörung in der Familienanamnese"
    ]
  },
  {
    "code": "Z82",
    "name": "Familiäres arterielles Thromboserisiko",
    "synonyms": [
      "Apoplexie in der Familienanamnese",
      "Arthritis in der Familienanamnese",
      "Asthma bronchiale in der Familienanamnese",
      "Behinderung in der Familienanamnese a.n.k.",
      "Blindheit in der Familienanamnese",
      "Chorea Huntington in der Familienanamnese",
      "Chromosomenanomalie in der Familienanamnese",
      "Chronische Atmungsbeschwerden in der Familienanamnese a.n.k.",
      "Chronische Krankheit der unteren Atemwege in der Familienanamnese",
      "Epilepsie in der Familienanamnese",
      "Familiäres Thromboserisiko",
      "Familiäres arterielles Thromboserisiko",
      "Familiäres venöses Thromboserisiko",
      "Hereditäre Muskelerkrankung in der Familienanamnese",
      "Hörverlust in der Familienanamnese",
      "Ischämische Herzkrankheit in der Familienanamnese",
      "KHK [Koronare Herzkrankheit] in der Familienanamnese",
      "Kardiovaskuläre Krankheit in der Familienanamnese",
      "Krankheiten des Muskel-Skelett-Systems in der Familienanamnese a.n.k.",
      "Neurologische Krankheit in der Familienanamnese",
      "QT-Syndrom in der Familienanamnese",
      "Schlaganfall in der Familienanamnese",
      "Sehverlust in der Familienanamnese",
      "Taubheit in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.1",
    "name": "HIV-Krankheit in der Familienanamnese",
    "synonyms": [
      "HIV-Krankheit in der Familienanamnese",
      "Infektiöse Krankheit in der Familienanamnese",
      "Parasitäre Krankheit in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.2",
    "name": "Faktor-V-Genmutation in der Familienanamnese",
    "synonyms": [
      "Anämie in der Familienanamnese",
      "Faktor-V-Genmutation in der Familienanamnese",
      "Glukose-6-Phosphat-Dehydrogenase-Mangel [G6PD-Mangel] in der Familienanamnese",
      "Hämatologische Krankheit in der Familienanamnese",
      "Krankheit der blutbildenden Organe in der Familienanamnese",
      "Krankheit des Blutes in der Familienanamnese",
      "Störung des Immunsystems in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.3",
    "name": "Diabetes mellitus in der Familienanamnese",
    "synonyms": [
      "Diabetes mellitus in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.4",
    "name": "Stoffwechselstörung in der Familienanamnese",
    "synonyms": [
      "Endokrine Krankheit in der Familienanamnese",
      "Ernährungsstörung in der Familienanamnese a.n.k.",
      "Stoffwechselstörung in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.5",
    "name": "Augenkrankheit in der Familienanamnese",
    "synonyms": [
      "Augenkrankheit in der Familienanamnese",
      "Ohrenkrankheit in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.6",
    "name": "Krankheit der Atemwege in der Familienanamnese",
    "synonyms": [
      "Krankheit der Atemwege in der Familienanamnese"
    ]
  },
  {
    "code": "Z83.7",
    "name": "Krankheit des Verdauungssystems in der Familienanamnese",
    "synonyms": [
      "Krankheit des Verdauungssystems in der Familienanamnese",
      "Lebererkrankung in der Familienanamnese",
      "Leberfunktionsstörung in der Familienanamnese"
    ]
  },
  {
    "code": "Z84.0",
    "name": "Krankheit der Haut und der Unterhaut in der Familienanamnese",
    "synonyms": [
      "Krankheit der Haut und der Unterhaut in der Familienanamnese",
      "Psoriasis in der Familienanamnese"
    ]
  },
  {
    "code": "Z84.1",
    "name": "Krankheit des Ureters in der Familienanamnese",
    "synonyms": [
      "Krankheit der Niere in der Familienanamnese",
      "Krankheit des Ureters in der Familienanamnese"
    ]
  },
  {
    "code": "Z84.2",
    "name": "Krankheit des Urogenitalsystems in der Familienanamnese a.n.k.",
    "synonyms": [
      "Krankheit des Urogenitalsystems in der Familienanamnese a.n.k."
    ]
  },
  {
    "code": "Z84.3",
    "name": "Konsanguinität in der Familienanamnese",
    "synonyms": [
      "Blutsverwandtschaft in der Familienanamnese",
      "Konsanguinität in der Familienanamnese"
    ]
  },
  {
    "code": "Z84.8",
    "name": "Allergie in der Familienanamnese",
    "synonyms": [
      "Allergie in der Familienanamnese"
    ]
  },
  {
    "code": "Z85.0",
    "name": "Bösartige Neubildung der Verdauungsorgane in der Eigenanamnese",
    "synonyms": [
      "Bösartige Neubildung der Verdauungsorgane in der Eigenanamnese",
      "Bösartige Neubildung des Gastrointestinaltraktes in der Anamnese"
    ]
  },
  {
    "code": "Z85.1",
    "name": "Bösartige Neubildung der Lunge in der Eigenanamnese",
    "synonyms": [
      "Bösartige Neubildung der Bronchien in der Eigenanamnese",
      "Bösartige Neubildung der Lunge in der Eigenanamnese",
      "Bösartige Neubildung der Trachea in der Eigenanamnese"
    ]
  },
  {
    "code": "Z85.2",
    "name": "Bösartige Neubildung intrathorakaler Organe in der Anamnese a.n.k.",
    "synonyms": [
      "Bösartige Neubildung intrathorakaler Organe in der Anamnese a.n.k."
    ]
  },
  {
    "code": "Z85.3",
    "name": "Mammakarzinom in der Eigenanamnese",
    "synonyms": [
      "Bösartige Neubildung der Brust in der Anamnese",
      "Mammakarzinom in der Eigenanamnese"
    ]
  },
  {
    "code": "Z85.4",
    "name": "Bösartige Neubildung der Genitalorgane in der Eigenanamnese",
    "synonyms": [
      "Bösartige Neubildung der Genitalorgane in der Eigenanamnese"
    ]
  },
  {
    "code": "Z85.5",
    "name": "Blasenkarzinom in der Eigenanamnese",
    "synonyms": [
      "Blasenkarzinom in der Eigenanamnese",
      "Bösartige Neubildung der Harnorgane in der Eigenanamnese",
      "Bösartige Neubildung des Harntraktes in der Eigenanamnese"
    ]
  },
  {
    "code": "Z85.6",
    "name": "Leukämie in der Anamnese",
    "synonyms": [
      "Leukämie in der Anamnese"
    ]
  },
  {
    "code": "Z85.7",
    "name": "Bösartige Neubildung des lymphatischen Gewebes in der Anamnese a.n.k.",
    "synonyms": [
      "Bösartige Neubildung des hämatopoetischen Gewebes in der Anamnese a.n.k.",
      "Bösartige Neubildung des lymphatischen Gewebes in der Anamnese a.n.k."
    ]
  },
  {
    "code": "Z85.8",
    "name": "Bösartige Neubildung der Haut in der Anamnese",
    "synonyms": [
      "Bösartige Neubildung der Haut in der Anamnese"
    ]
  },
  {
    "code": "Z85.9",
    "name": "Bösartige Neubildung in der Eigenanamnese",
    "synonyms": [
      "Bösartige Neubildung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.0",
    "name": "Gutartige Neubildung in der Eigenanamnese",
    "synonyms": [
      "Gutartige Neubildung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.1",
    "name": "Infektanfälligkeit",
    "synonyms": [
      "Antibiotika-assoziierte Kolitis in der Eigenanamnese",
      "Hepatitis in der Eigenanamnese",
      "Herpesvirus-Infektion in der Eigenanamnese",
      "Infektanfälligkeit",
      "Infektiöse Krankheit in der Eigenanamnese",
      "Infektneigung",
      "Parasitäre Krankheit in der Eigenanamnese",
      "Tuberkulose in der Eigenanamnese",
      "VZV [Varizella-Zoster-Virus]-Infektion in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.2",
    "name": "Krankheit der blutbildenden Organe in der Eigenanamnese",
    "synonyms": [
      "Autoimmunerkrankung in der Eigenanamnese",
      "Blutdyskrasie in der Eigenanamnese",
      "Blutkrankheit in der Eigenanamnese",
      "Hämatologische Krankheit in der Eigenanamnese",
      "Immunitätsstörung in der Eigenanamnese",
      "Krankheit der blutbildenden Organe in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.3",
    "name": "Mangelernährung in der Anamnese",
    "synonyms": [
      "Ernährungsstörung in der Eigenanamnese",
      "Krankheit eines endokrinen Organs in der Eigenanamnese",
      "Mangelernährung in der Anamnese",
      "Schilddrüsenkrankheit in der Eigenanamnese",
      "Stoffwechselstörung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.4",
    "name": "Alkoholmissbrauch in der Anamnese",
    "synonyms": [
      "Alkoholmissbrauch in der Anamnese",
      "Arzneimittel- und Drogenmissbrauch in der Anamnese",
      "Tabakmissbrauch in der Anamnese"
    ]
  },
  {
    "code": "Z86.5",
    "name": "Wochenbettpsychose in der Eigenanamnese",
    "synonyms": [
      "Essstörung in der Eigenanamnese",
      "Psychische Störung in der Anamnese",
      "Wochenbettpsychose in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.6",
    "name": "Krankheit des Nervensystems in der Eigenanamnese",
    "synonyms": [
      "Augenkrankheit in der Eigenanamnese",
      "Epilepsie in der Eigenanamnese",
      "Krankheit des Nervensystems in der Eigenanamnese",
      "Krankheit eines Sinnesorgans in der Eigenanamnese",
      "Malignes Neuroleptikasyndrom in der Eigenanamnese",
      "Ohrenkrankheit in der Eigenanamnese",
      "Transitorische ischämische Attacke in der Eigenanamnese",
      "Zerebrale ischämische Attacke in der Eigenanamnese"
    ]
  },
  {
    "code": "Z86.7",
    "name": "Krankheit des Kreislaufsystems in der Eigenanamnese",
    "synonyms": [
      "Alter folgenloser Schlaganfall",
      "Aneurysmatische Subarachnoidalblutung in der Eigenanamnese",
      "Apoplex in der Eigenanamnese",
      "Herzrhythmusstörungen in der Eigenanamnese",
      "Krankheit des Kreislaufsystems in der Eigenanamnese",
      "Orthostatische Dysregulation in der Eigenanamnese",
      "Thromboembolie in der Eigenanamnese",
      "Zerebraler Insult in der Eigenanamnese"
    ]
  },
  {
    "code": "Z87.0",
    "name": "Krankheit der Atmungsorgane in der Eigenanamnese",
    "synonyms": [
      "Arzneimittelinduzierte Lungenfibrose in der Eigenanamnese",
      "Krankheit der Atmungsorgane in der Eigenanamnese"
    ]
  },
  {
    "code": "Z87.1",
    "name": "Krankheit des Verdauungssystems in der Eigenanamnese",
    "synonyms": [
      "Colitis in der Eigenanamnese",
      "Darmblutung in der Eigenanamnese",
      "Darmgeschwür in der Eigenanamnese",
      "Gastrointestinale Erkrankung in der Eigenanamnese",
      "Hämatemesis in der Eigenanamnese",
      "Krankheit des Verdauungssystems in der Eigenanamnese",
      "Lebererkrankung in der Eigenanamnese",
      "Magenblutung in der Eigenanamnese",
      "Magengeschwür in der Eigenanamnese",
      "Pankreatitis in der Eigenanamnese",
      "Ösophagitis in der Eigenanamnese"
    ]
  },
  {
    "code": "Z87.2",
    "name": "Hautkrankheit in der Eigenanamnese",
    "synonyms": [
      "Erythema exsudativum multiforme in der Eigenanamnese",
      "Hautkrankheit in der Eigenanamnese",
      "Krankheit des Unterhautzellgewebes in der Eigenanamnese",
      "Phototoxischen Reaktion durch Arzneimittel in der Eigenanamnese",
      "Psoriasis in der Eigenanamnese"
    ]
  },
  {
    "code": "Z87.3",
    "name": "Arthritis in der Anamnese",
    "synonyms": [
      "Arthritis in der Anamnese",
      "Arzneimittelinduzierte Fibrose in der Eigenanamnese",
      "Hereditäre Muskelerkrankung in der Eigenanamnese",
      "Krankheit des Muskel-Skelett-Systems in der Eigenanamnese a.n.k."
    ]
  },
  {
    "code": "Z87.4",
    "name": "Krankheit der Genitalorgane in der Eigenanamnese",
    "synonyms": [
      "Endometriumhyperplasie in der Eigenanamnese",
      "Krankheit der Genitalorgane in der Eigenanamnese",
      "Krankheit des Harnsystems in der Eigenanamnese",
      "Nephrolithiasis in der Eigenanamnese",
      "Nierenfunktionsstörung in der Eigenanamnese",
      "Nierenstein in der Eigenanamnese"
    ]
  },
  {
    "code": "Z87.5",
    "name": "Geburtskomplikation in der Eigenanamnese",
    "synonyms": [
      "Ektopische Schwangerschaft in der Eigenanamnese",
      "Geburtskomplikation in der Eigenanamnese",
      "Gestose in der Eigenanamnese",
      "Schwangerschaftsdiabetes in der Eigenanamnese",
      "Schwangerschaftsikterus in der Eigenanamnese",
      "Spontanaborte in der Eigenanamnese",
      "Trophoblastische Störung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z87.6",
    "name": "Perinatale Störung in der Anamnese",
    "synonyms": [
      "Perinatale Störung in der Anamnese"
    ]
  },
  {
    "code": "Z87.7",
    "name": "Chromosomenanomalie in der Anamnese",
    "synonyms": [
      "Angeborene Fehlbildung in der Anamnese",
      "Chromosomenanomalie in der Anamnese"
    ]
  },
  {
    "code": "Z87.8",
    "name": "Krankheit in der Anamnese",
    "synonyms": [
      "Anaphylaktischer Schock in der Eigenanamnese",
      "Anticholinerges Syndrom in der Eigenanamnese",
      "Fraktur in der Eigenanamnese",
      "Krankheit in der Anamnese",
      "Schädel-Hirn-Trauma in der Eigenanamnese"
    ]
  },
  {
    "code": "Z88.0",
    "name": "Penicillin-Allergie in der Eigenanamnese",
    "synonyms": [
      "Penicillin-Allergie in der Eigenanamnese"
    ]
  },
  {
    "code": "Z88.1",
    "name": "Allergie gegen Antibiotika in der Eigenanamnese",
    "synonyms": [
      "Allergie gegen Antibiotika in der Eigenanamnese"
    ]
  },
  {
    "code": "Z88.2",
    "name": "Allergie gegen Sulfonamide in der Eigenanamnese",
    "synonyms": [
      "Allergie gegen Sulfonamide in der Eigenanamnese"
    ]
  },
  {
    "code": "Z88.3",
    "name": "Allergie gegen antiinfektiöse Mittel in der Eigenanamnese a.n.k.",
    "synonyms": [
      "Allergie gegen antiinfektiöse Mittel in der Eigenanamnese a.n.k."
    ]
  },
  {
    "code": "Z88.4",
    "name": "Maligne Hyperthermie in der Anamnese",
    "synonyms": [
      "Allergie gegen Anästhetika in der Eigenanamnese a.n.k.",
      "Maligne Hyperthermie in der Anamnese"
    ]
  },
  {
    "code": "Z88.5",
    "name": "Allergie gegen Narkotika in der Eigenanamnese a.n.k.",
    "synonyms": [
      "Allergie gegen Narkotika in der Eigenanamnese a.n.k."
    ]
  },
  {
    "code": "Z88.6",
    "name": "Allergie gegen Analgetika in der Eigenanamnese",
    "synonyms": [
      "Allergie gegen Analgetika in der Eigenanamnese"
    ]
  },
  {
    "code": "Z88.7",
    "name": "Allergie gegen Impfstoffe in der Eigenanamnese",
    "synonyms": [
      "Allergie gegen Impfstoffe in der Eigenanamnese",
      "Allergie gegen Seren in der Eigenanamnese"
    ]
  },
  {
    "code": "Z88.9",
    "name": "Angioneurotisches Ödem in der Eigenanamnese",
    "synonyms": [
      "Angioneurotisches Ödem in der Eigenanamnese",
      "Überempfindlichkeitsreaktion gegenüber Arzneimitteln in der Eigenanamnese"
    ]
  },
  {
    "code": "Z89.0",
    "name": "Erworbenes Fehlen von Fingern",
    "synonyms": [
      "Erworbenes Fehlen des Daumens",
      "Erworbenes Fehlen von Fingern"
    ]
  },
  {
    "code": "Z89.1",
    "name": "Erworbenes Fehlen der Hand",
    "synonyms": [
      "Erworbenes Fehlen der Hand",
      "Erworbenes Fehlen des Handgelenks"
    ]
  },
  {
    "code": "Z89.2",
    "name": "Erworbenes Fehlen eines Arms",
    "synonyms": [
      "Erworbenes Fehlen eines Arms",
      "Erworbenes einseitiges Fehlen der oberen Extremität",
      "Erworbenes einseitiges Fehlen des Unterarms"
    ]
  },
  {
    "code": "Z89.3",
    "name": "Verlust beider Arme",
    "synonyms": [
      "Beidseitiger Verlust des Daumens",
      "Beidseitiger Verlust eines oder mehrerer Finger",
      "Beidseitiges erworbenes Fehlen von Hand und Handgelenk",
      "Erworbenes beidseitiges Fehlen des Arms",
      "Erworbenes beidseitiges Fehlen des Daumens",
      "Erworbenes beidseitiges Fehlen mehrerer Finger",
      "Verlust beider Arme"
    ]
  },
  {
    "code": "Z89.4",
    "name": "Erworbenes Fehlen des Fußes",
    "synonyms": [
      "Erworbenes Fehlen des Fußes",
      "Erworbenes Fehlen des Knöchels",
      "Erworbenes Fehlen von Zehen"
    ]
  },
  {
    "code": "Z89.5",
    "name": "Zustand nach Unterschenkelamputation",
    "synonyms": [
      "Erworbenes Fehlen eines Beins unterhalb des Knies",
      "Zustand nach Unterschenkelamputation"
    ]
  },
  {
    "code": "Z89.6",
    "name": "Erworbenes Fehlen eines Beins oberhalb des Knies",
    "synonyms": [
      "Erworbenes Fehlen eines Beins",
      "Erworbenes Fehlen eines Beins oberhalb des Knies",
      "Erworbenes einseitiges Fehlen der unteren Extremität oberhalb des Knies"
    ]
  },
  {
    "code": "Z89.7",
    "name": "Erworbenes beidseitiges Fehlen der Beine",
    "synonyms": [
      "Beidseitiges erworbenes Fehlen von Fuß und Knöchel",
      "Erworbenes beidseitiges Fehlen der Beine"
    ]
  },
  {
    "code": "Z89.8",
    "name": "Erworbenes Fehlen von Bein und Arm",
    "synonyms": [
      "Beidseitiges Fehlen der unteren Extremität und der oberen Extremität",
      "Beidseitiges Fehlen von Bein und Arm",
      "Erworbenes Fehlen der Hand und der unteren Extremität",
      "Erworbenes Fehlen des Fußes und der oberen Extremität",
      "Erworbenes Fehlen von Bein und Arm",
      "Fehlen einer oberen und unteren Extremität"
    ]
  },
  {
    "code": "Z89.9",
    "name": "Extremitätenverlust",
    "synonyms": [
      "Abgeheilter Amputationsstumpf a.n.k.",
      "Alter Amputationsstumpf a.n.k.",
      "Amputierter",
      "Beidseitig Amputierter",
      "Erworbenes Fehlen einer Extremität",
      "Extremitätenverlust",
      "Postoperativer Extremitätenverlust",
      "Posttraumatischer Extremitätenverlust"
    ]
  },
  {
    "code": "Z90.0",
    "name": "Erworbene Anophthalmie",
    "synonyms": [
      "Erworbene Anophthalmie",
      "Erworbenes Fehlen der Nase",
      "Erworbenes Fehlen des Augapfels",
      "Erworbenes Fehlen des Auges",
      "Erworbenes Fehlen des Kehlkopfes",
      "Erworbenes Fehlen des Larynx",
      "Erworbenes Fehlen des Ohres",
      "Erworbenes Fehlen eines Augenlids",
      "Erworbenes Fehlen von Teilen des Kopfes a.n.k.",
      "Status nach Laryngektomie",
      "Verlust der Nase",
      "Verlust des Larynx"
    ]
  },
  {
    "code": "Z90.1",
    "name": "Mammaverlust",
    "synonyms": [
      "Erworbenes Fehlen der Brust",
      "Erworbenes Fehlen der Mamma",
      "Mammaverlust",
      "Status nach einseitiger oder beidseitiger Mastektomie",
      "Verlust der Brust",
      "Zustand nach Ablatio mammae"
    ]
  },
  {
    "code": "Z90.2",
    "name": "Status nach teilweiser oder vollständiger Pneumonektomie",
    "synonyms": [
      "Erworbenes Fehlen der Lunge",
      "Status nach teilweiser oder vollständiger Pneumonektomie"
    ]
  },
  {
    "code": "Z90.3",
    "name": "Erworbenes Fehlen des Magens",
    "synonyms": [
      "Erworbenes Fehlen des Magens",
      "Erworbenes partielles Fehlen des Magens",
      "Status nach teilweiser oder vollständiger Gastrektomie"
    ]
  },
  {
    "code": "Z90.4",
    "name": "Erworbenes Fehlen von Verdauungsorganen",
    "synonyms": [
      "Erworbenes Fehlen der Bauchspeicheldrüse",
      "Erworbenes Fehlen der Gallenblase",
      "Erworbenes Fehlen der Speiseröhre",
      "Erworbenes Fehlen des Dickdarmes",
      "Erworbenes Fehlen des Duodenums",
      "Erworbenes Fehlen des Dünndarmes",
      "Erworbenes Fehlen des Ileums",
      "Erworbenes Fehlen des Jejunums",
      "Erworbenes Fehlen des Pankreas",
      "Erworbenes Fehlen des Rektums",
      "Erworbenes Fehlen des Ösophagus",
      "Erworbenes Fehlen von Verdauungsorganen",
      "Status nach Cholezystektomie",
      "Status nach Pankreatektomie",
      "Status nach teilweiser oder vollständiger Kolektomie"
    ]
  },
  {
    "code": "Z90.5",
    "name": "Erworbenes Fehlen der Niere",
    "synonyms": [
      "Erworbenes Fehlen der Niere",
      "Status nach teilweiser oder vollständiger Nephrektomie"
    ]
  },
  {
    "code": "Z90.6",
    "name": "Status nach Zystektomie der Harnblase",
    "synonyms": [
      "Erworbenes Fehlen eines Ureters",
      "Status nach Zystektomie der Harnblase"
    ]
  },
  {
    "code": "Z90.7",
    "name": "Zustand nach Hysterektomie",
    "synonyms": [
      "Erworbenes Fehlen der Cervix uteri",
      "Erworbenes Fehlen der Epididymis",
      "Erworbenes Fehlen der Genitalorgane",
      "Erworbenes Fehlen der Prostata",
      "Erworbenes Fehlen der Tuba uterina",
      "Erworbenes Fehlen der Vesicula seminalis",
      "Erworbenes Fehlen der Zervix",
      "Erworbenes Fehlen des Eierstocks",
      "Erworbenes Fehlen des Eileiters",
      "Erworbenes Fehlen des Hodens",
      "Erworbenes Fehlen des Nebenhodens",
      "Erworbenes Fehlen des Ovar",
      "Erworbenes Fehlen des Penis",
      "Erworbenes Fehlen des Testis",
      "Erworbenes Fehlen des Uterus",
      "Erworbenes Fehlen des Vas deferens",
      "Status nach teilweiser oder vollständiger Hysterektomie",
      "Status nach teilweiser oder vollständiger Oophorektomie",
      "Status nach teilweiser oder vollständiger Salpingo-Oophorektomie",
      "Uterusablation",
      "Zustand nach Amputation der Cervix uteri",
      "Zustand nach Amputation der Zervix",
      "Zustand nach Hysterektomie"
    ]
  },
  {
    "code": "Z90.8",
    "name": "Organverlust",
    "synonyms": [
      "Erworbenes Fehlen einer Rippe",
      "Erworbenes Fehlen eines Organs",
      "Organverlust",
      "Postoperativer Verlust eines Körperteils",
      "Posttraumatischer Verlust eines Körperteils"
    ]
  },
  {
    "code": "Z91.1",
    "name": "Non-Compliance in der Eigenanamnese",
    "synonyms": [
      "Nichtbefolgung ärztlicher Anordnungen in der Anamnese",
      "Non-Compliance in der Eigenanamnese",
      "Verweigerung der Erfüllung ärztlicher Anordnungen"
    ]
  },
  {
    "code": "Z91.70",
    "name": "FGM [Female genital mutilation], Typ nicht näher bezeichnet",
    "synonyms": [
      "FGM [Female genital mutilation], Typ nicht näher bezeichnet",
      "Female genital mutilation, Typ nicht näher bezeichnet",
      "Weibliche Beschneidung",
      "Weibliche Genitalverstümmelung",
      "Weibliche Zirkumzision"
    ]
  },
  {
    "code": "Z91.71",
    "name": "Weibliche Genitalverstümmelung, Typ 1",
    "synonyms": [
      "FGM [Female genital mutilation], type 1",
      "Female genital mutilation, type 1",
      "Weibliche Genitalverstümmelung, Typ 1"
    ]
  },
  {
    "code": "Z91.72",
    "name": "Weibliche Genitalverstümmelung, Typ 2",
    "synonyms": [
      "FGM [Female genital mutilation], type 2",
      "Female genital mutilation, type 2",
      "Weibliche Genitalverstümmelung, Typ 2"
    ]
  },
  {
    "code": "Z91.73",
    "name": "Weibliche Genitalverstümmelung, Typ 3",
    "synonyms": [
      "FGM [Female genital mutilation], type 3",
      "Female genital mutilation, type 3",
      "Weibliche Genitalverstümmelung, Typ 3"
    ]
  },
  {
    "code": "Z91.74",
    "name": "Weibliche Genitalverstümmelung, Typ 4",
    "synonyms": [
      "FGM [Female genital mutilation], type 4",
      "Female genital mutilation, type 4",
      "Weibliche Genitalverstümmelung, Typ 4"
    ]
  },
  {
    "code": "Z91.8",
    "name": "Selbstschädigung in der Eigenanamnese",
    "synonyms": [
      "Körperverletzung in der Anamnese",
      "Mangelhafte persönliche Hygiene in der Anamnese",
      "Missbrauch in der Anamnese",
      "Misshandlung in der Anamnese",
      "Parasuizid in der Anamnese",
      "Problem mit Einfluss auf den Gesundheitsstatus a.n.k.",
      "Problem mit der persönlichen Hygiene",
      "Psychischer Restschaden in der Eigenanamnese",
      "Psychisches Trauma in der Anamnese",
      "Risikofaktoren in der Anamnese a.n.k.",
      "Schlaf-Wach-Rhythmus-Störung in der Anamnese",
      "Selbstmordversuch - kodiere Art der Verletzung oder Intoxikation",
      "Selbstschädigung in der Eigenanamnese",
      "Selbsttötungsversuch in der Eigenanamnese",
      "Selbstvergiftungsversuch in der Anamnese",
      "Suizidversuch - kodiere Art der Verletzung oder Intoxikation",
      "Suizidversuch in der Anamnese",
      "Trauma in der Anamnese",
      "Ungesunder Schlaf-Wach-Rhythmus in der Anamnese",
      "Vergiftung in der Anamnese",
      "Verletzung in der Anamnese",
      "Versuchte Selbsttötung - kodiere Art der Verletzung oder Intoxikation"
    ]
  },
  {
    "code": "Z92.1",
    "name": "Antikoagulanzientherapie",
    "synonyms": [
      "Antikoagulanzientherapie",
      "Dauertherapie mit Antikoagulanzien in der Eigenanamnese",
      "Dauertherapie mit Antikoagulanzien ohne Blutung",
      "Dauertherapie mit Cumarinen ohne Blutung",
      "Dauertherapie mit Heparinen ohne Blutung",
      "Marcumartherapie"
    ]
  },
  {
    "code": "Z92.2",
    "name": "Thrombozytenaggregationshemmertherapie (z.B. Acetylsalicylsäure)",
    "synonyms": [
      "Aspirindauertherapie in der Anamnese",
      "Dauertherapie mit Arzneimitteln in der Anamnese",
      "Dauertherapie mit Thrombozytenaggregationshemmern ohne Blutung",
      "Thrombozytenaggregationshemmertherapie (z.B. Acetylsalicylsäure)"
    ]
  },
  {
    "code": "Z92.3",
    "name": "Bestrahlung in der Eigenanamnese",
    "synonyms": [
      "Bestrahlung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z92.4",
    "name": "Großer chirurgischer Eingriff in der Anamnese",
    "synonyms": [
      "Großer chirurgischer Eingriff in der Anamnese"
    ]
  },
  {
    "code": "Z92.6",
    "name": "Zytostatische Chemotherapie wegen bösartiger Neubildung in der Eigenanamnese",
    "synonyms": [
      "Zytostatische Chemotherapie wegen bösartiger Neubildung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z92.8",
    "name": "Kontrazeption in der Eigenanamnese",
    "synonyms": [
      "Kontrazeption in der Eigenanamnese",
      "Rehabilitationsmaßnahmen in der Eigenanamnese"
    ]
  },
  {
    "code": "Z92.9",
    "name": "Medizinische Behandlung in der Eigenanamnese",
    "synonyms": [
      "Medizinische Behandlung in der Eigenanamnese"
    ]
  },
  {
    "code": "Z93.0",
    "name": "Vorhandensein eines Tracheostomas",
    "synonyms": [
      "Vorhandensein eines Tracheostomas",
      "Zustand nach Tracheostomie"
    ]
  },
  {
    "code": "Z93.1",
    "name": "Vorhandensein einer PEG-Sonde [perkutane endoskopische Gastrostomie]",
    "synonyms": [
      "Vorhandensein einer PEG-Sonde [perkutane endoskopische Gastrostomie]",
      "Vorhandensein eines Gastrostomas",
      "Zustandsbefund nach Gastrostomie"
    ]
  },
  {
    "code": "Z93.2",
    "name": "Vorhandensein eines Ileostomas",
    "synonyms": [
      "Vorhandensein eines Ileostomas",
      "Zustandsbefund nach Ileostomie"
    ]
  },
  {
    "code": "Z93.3",
    "name": "Vorhandensein eines Kolostomas",
    "synonyms": [
      "Vorhandensein eines Kolostomas",
      "Zustandsbefund nach Kolostomie"
    ]
  },
  {
    "code": "Z93.5",
    "name": "Zustandsbefund nach Zystostomie",
    "synonyms": [
      "Vorhandensein eines Zystostomas",
      "Zustandsbefund nach Zystostomie"
    ]
  },
  {
    "code": "Z93.6",
    "name": "Vorhandensein eines Nephrostomas",
    "synonyms": [
      "Vorhandensein eines Nephrostomas",
      "Vorhandensein eines Ureterostomas",
      "Vorhandensein eines Urethrostomas",
      "Zustandsbefund nach Nephrostomie",
      "Zustandsbefund nach Ureterostomie",
      "Zustandsbefund nach Urethrostomie"
    ]
  },
  {
    "code": "Z93.80",
    "name": "Vorhandensein eines Thorakostomas",
    "synonyms": [
      "Vorhandensein eines Thorakostomas"
    ]
  },
  {
    "code": "Z93.88",
    "name": "Vorhandensein einer künstlichen Vagina",
    "synonyms": [
      "Vorhandensein einer künstlichen Vagina"
    ]
  },
  {
    "code": "Z93.9",
    "name": "Zustandsbefund einer künstlichen Körperöffnung",
    "synonyms": [
      "Zustandsbefund einer künstlichen Körperöffnung"
    ]
  },
  {
    "code": "Z94.0",
    "name": "Nierentransplantat",
    "synonyms": [
      "Nierentransplantat",
      "Zustand nach Nierentransplantation"
    ]
  },
  {
    "code": "Z94.1",
    "name": "Herztransplantat",
    "synonyms": [
      "Herztransplantat",
      "Zustand nach Herztransplantation"
    ]
  },
  {
    "code": "Z94.2",
    "name": "Lungentransplantat",
    "synonyms": [
      "Lungentransplantat"
    ]
  },
  {
    "code": "Z94.3",
    "name": "Zustand nach Herz-Lungen-Transplantation",
    "synonyms": [
      "Zustand nach Herz-Lungen-Transplantation"
    ]
  },
  {
    "code": "Z94.4",
    "name": "Lebertransplantat",
    "synonyms": [
      "Lebertransplantat"
    ]
  },
  {
    "code": "Z94.5",
    "name": "Hauttransplantat",
    "synonyms": [
      "Hauttransplantat",
      "Zustand nach autogener Hauttransplantation"
    ]
  },
  {
    "code": "Z94.6",
    "name": "Knochentransplantat",
    "synonyms": [
      "Knochentransplantat"
    ]
  },
  {
    "code": "Z94.7",
    "name": "Hornhauttransplantat",
    "synonyms": [
      "Hornhauttransplantat"
    ]
  },
  {
    "code": "Z94.80",
    "name": "Knochenmarktransplantat",
    "synonyms": [
      "Knochenmarktransplantat",
      "Zustand nach allogener Stammzelltransplantation",
      "Zustand nach hämatopoetischer Stammzelltransplantation ohne gegenwärtige Immunsuppression"
    ]
  },
  {
    "code": "Z94.81",
    "name": "Zustand nach hämatopoetischer Stammzelltransplantation mit gegenwärtiger Immunsuppression",
    "synonyms": [
      "Zustand nach hämatopoetischer Stammzelltransplantation mit gegenwärtiger Immunsuppression"
    ]
  },
  {
    "code": "Z94.88",
    "name": "Darmtransplantat",
    "synonyms": [
      "Darmtransplantat",
      "Pankreastransplantat",
      "Zustand nach Stammzelltransplantation"
    ]
  },
  {
    "code": "Z94.9",
    "name": "Zustand nach Transplantation",
    "synonyms": [
      "Gewebetransplantat",
      "Organtransplantat",
      "Zustand nach Transplantation"
    ]
  },
  {
    "code": "Z95.0",
    "name": "Vorhandensein eines Herzschrittmachers",
    "synonyms": [
      "Vorhandensein eines Herzschrittmachers",
      "Vorhandensein eines Kardiodefibrillators",
      "Vorhandensein eines automatischen implantierbaren Kardioverter-Defibrillators [AICD]",
      "Vorhandensein eines implantierbaren Kardioverter-Defibrillators [ICD]",
      "Vorhandensein eines kardialen Resynchronisationstherapie-Defibrillators",
      "Vorhandensein eines kardialen Resynchronisationstherapie-Schrittmachers"
    ]
  },
  {
    "code": "Z95.1",
    "name": "Aortokoronarer Venenbypass [ACVB]",
    "synonyms": [
      "Aortokoronarer Venenbypass [ACVB]",
      "Vorhandensein eines aortokoronaren Bypasses",
      "Vorhandensein eines aortokoronaren Transplantates",
      "Zustand nach ACVB [Aortokoronarer Venenbypass]-Operation",
      "Zustandsbefund bei aortokoronarem Bypass"
    ]
  },
  {
    "code": "Z95.2",
    "name": "Vorhandensein einer künstlichen Herzklappe",
    "synonyms": [
      "Vorhandensein einer Herzklappenprothese",
      "Vorhandensein einer künstlichen Herzklappe"
    ]
  },
  {
    "code": "Z95.3",
    "name": "Vorhandensein einer xenogenen Herzklappe",
    "synonyms": [
      "Vorhandensein einer xenogenen Herzklappe"
    ]
  },
  {
    "code": "Z95.4",
    "name": "Herzklappentransplantat",
    "synonyms": [
      "Herzklappentransplantat",
      "Vorhandensein eines funktionellen Herzklappen-Implantates a.n.k.",
      "Zustand nach Aortenklappenersatz",
      "Zustand nach Mitralklappenersatz"
    ]
  },
  {
    "code": "Z95.5",
    "name": "Vorhandensein eines koronaren Gefäßtransplantates",
    "synonyms": [
      "Vorhandensein einer koronaren Gefäßprothese",
      "Vorhandensein eines koronaren Gefäßtransplantates",
      "Zustandsbefund bei koronarer Gefäßplastik"
    ]
  },
  {
    "code": "Z95.80",
    "name": "Vorhandensein eines künstlichen Herzens",
    "synonyms": [
      "Vorhandensein eines herzunterstützenden Systems",
      "Vorhandensein eines künstlichen Herzens"
    ]
  },
  {
    "code": "Z95.81",
    "name": "Vorhandensein eines Ports",
    "synonyms": [
      "Vorhandensein eines Ports",
      "Vorhandensein eines portokavalen Shunts"
    ]
  },
  {
    "code": "Z95.88",
    "name": "Vorhandensein eines intravaskulären Implantates a.n.k.",
    "synonyms": [
      "Vorhandensein einer Gefäßprothese",
      "Vorhandensein eines intravaskulären Implantates a.n.k.",
      "Vorhandensein eines transjugulären intrahepatischen portosystemischen Shunts [TIPS]",
      "Zustandsbefund nach peripherer Angioplastie a.n.k."
    ]
  },
  {
    "code": "Z95.9",
    "name": "Vorhandensein eines vaskulären Implantates",
    "synonyms": [
      "Vorhandensein eines Herztransplantates a.n.k.",
      "Vorhandensein eines vaskulären Implantates"
    ]
  },
  {
    "code": "Z96.0",
    "name": "Vorhandensein eines urogenitalen Implantates",
    "synonyms": [
      "Vorhandensein eines Harnblasenimplantates",
      "Vorhandensein eines ureteralen Stents",
      "Vorhandensein eines urethralen Stents",
      "Vorhandensein eines urogenitalen Implantates"
    ]
  },
  {
    "code": "Z96.1",
    "name": "Pseudophakie",
    "synonyms": [
      "Pseudophakie",
      "Vorhandensein eines intraokularen Linsenimplantates"
    ]
  },
  {
    "code": "Z96.2",
    "name": "Vorhandensein eines audiologischen Implantates",
    "synonyms": [
      "Vorhandensein einer Tuba-Eustachii-Plastik",
      "Vorhandensein einer äußerlichen Hörhilfe",
      "Vorhandensein eines Hörgerätes für Knochenleitung",
      "Vorhandensein eines Kochlearimplantates [CI]",
      "Vorhandensein eines Parazenteseröhrchens",
      "Vorhandensein eines Stapes-Implantates",
      "Vorhandensein eines audiologischen Implantates",
      "Vorhandensein eines knochenverankerten Hörsystems [BAHA]",
      "Vorhandensein otologischer Implantate"
    ]
  },
  {
    "code": "Z96.3",
    "name": "Vorhandensein eines Larynximplantates",
    "synonyms": [
      "Vorhandensein eines Larynximplantates",
      "Vorhandensein eines künstlichen Larynx"
    ]
  },
  {
    "code": "Z96.4",
    "name": "Vorhandensein eines endokrinen Implantates",
    "synonyms": [
      "Vorhandensein einer Insulinpumpe",
      "Vorhandensein eines endokrinen Implantates"
    ]
  },
  {
    "code": "Z96.5",
    "name": "Vorhandensein eines dentalen Unterkieferimplantates",
    "synonyms": [
      "Vorhandensein eines Zahnwurzelimplantates",
      "Vorhandensein eines dentalen Unterkieferimplantates"
    ]
  },
  {
    "code": "Z96.60",
    "name": "Vorhandensein einer Schulterprothese",
    "synonyms": [
      "Vorhandensein einer Schulterprothese"
    ]
  },
  {
    "code": "Z96.61",
    "name": "Vorhandensein einer Ellenbogenprothese",
    "synonyms": [
      "Vorhandensein einer Ellenbogenprothese"
    ]
  },
  {
    "code": "Z96.62",
    "name": "Vorhandensein einer Radiuskopfprothese",
    "synonyms": [
      "Vorhandensein einer Radiuskopfprothese"
    ]
  },
  {
    "code": "Z96.63",
    "name": "Vorhandensein einer Handgelenkprothese",
    "synonyms": [
      "Vorhandensein einer Handgelenkprothese"
    ]
  },
  {
    "code": "Z96.64",
    "name": "Vorhandensein eines Hüftgelenkimplantates",
    "synonyms": [
      "Vorhandensein einer Hüftgelenkprothese",
      "Vorhandensein eines Hüftgelenkimplantates"
    ]
  },
  {
    "code": "Z96.65",
    "name": "Vorhandensein eines Kniegelenkimplantates",
    "synonyms": [
      "Vorhandensein einer Kniegelenkprothese",
      "Vorhandensein eines Kniegelenkimplantates"
    ]
  },
  {
    "code": "Z96.66",
    "name": "Vorhandensein einer Sprunggelenkprothese",
    "synonyms": [
      "Vorhandensein einer Sprunggelenkprothese"
    ]
  },
  {
    "code": "Z96.67",
    "name": "Vorhandensein einer Bandscheibenprothese",
    "synonyms": [
      "Vorhandensein einer Bandscheibenprothese"
    ]
  },
  {
    "code": "Z96.68",
    "name": "Vorhandensein eines orthopädischen Gelenkimplantates",
    "synonyms": [
      "Vorhandensein einer Gelenkprothese",
      "Vorhandensein eines Fingergelenkersatzes",
      "Vorhandensein eines Fingergelenkimplantates",
      "Vorhandensein eines Gelenkimplantates",
      "Vorhandensein eines Großzehengrundgelenkersatzes",
      "Vorhandensein eines Kiefergelenkersatzes",
      "Vorhandensein eines orthopädischen Gelenkimplantates"
    ]
  },
  {
    "code": "Z96.7",
    "name": "Vorhandensein eines Sehnenimplantates",
    "synonyms": [
      "Vorhandensein eines Schädelplattenimplantates",
      "Vorhandensein eines Sehnenimplantates"
    ]
  },
  {
    "code": "Z96.80",
    "name": "Vorhandensein eines Bronchialstents",
    "synonyms": [
      "Vorhandensein eines Bronchialstents"
    ]
  },
  {
    "code": "Z96.81",
    "name": "Vorhandensein eines Trachealstents",
    "synonyms": [
      "Vorhandensein eines Trachealstents"
    ]
  },
  {
    "code": "Z96.9",
    "name": "Vorhandensein eines funktionellen Implantates",
    "synonyms": [
      "Vorhandensein eines funktionellen Implantates",
      "Vorhandensein eines implantierten Gerätes"
    ]
  },
  {
    "code": "Z97.1",
    "name": "Vorhandensein einer künstlichen Extremität",
    "synonyms": [
      "Vorhandensein einer künstlichen Extremität"
    ]
  },
  {
    "code": "Z97.8",
    "name": "Vorhandenes Intrauterinpessar",
    "synonyms": [
      "Dauerkatheterträger",
      "Vorhandener transurethraler Dauerkatheter",
      "Vorhandenes Intrauterinpessar",
      "Vorhandensein einer Brille",
      "Vorhandensein einer Zahnprothese",
      "Vorhandensein eines künstlichen Auges",
      "Vorhandensein eines äußeren Hörgerätes",
      "Vorhandensein medizinischer Geräte a.n.k.",
      "Vorhandensein von Kontaktlinsen"
    ]
  },
  {
    "code": "Z98.0",
    "name": "Intestinale Anastomose",
    "synonyms": [
      "Intestinale Anastomose",
      "Vorhandensein einer intestinalen Anastomose",
      "Vorhandensein eines intestinalen Bypasses",
      "Zustandsbefund bei Anastomose",
      "Zustandsbefund bei intestinalem Bypass"
    ]
  },
  {
    "code": "Z98.1",
    "name": "Zustand nach Arthrodese",
    "synonyms": [
      "Ankylose nach chirurgischer Fusion",
      "Chirurgische iliosakrale Fusion",
      "Chirurgische lumbosakrale Fusion",
      "Gelenksteife nach chirurgischer Fusion",
      "Postoperativ Ankylose",
      "Postoperative Gelenksteife",
      "Wirbelblockade nach Arthrodese",
      "Wirbelblockade nach operativem Eingriff",
      "Zustand nach Arthrodese",
      "Zustandsbefund nach Arthrodese"
    ]
  },
  {
    "code": "Z98.2",
    "name": "Liquor-cerebrospinalis-Shunt",
    "synonyms": [
      "Ableitung der Hirnventrikel",
      "Ableitung der Zerebrospinalflüssigkeit in situ",
      "Ableitung des Liquor cerebrospinalis in situ",
      "Drainage des Liquor cerebrospinalis",
      "Kommunizierender Hirnventrikelshunt",
      "Liquor-cerebrospinalis-Shunt",
      "Zustandsbefund bei Hirnventrikelshunt",
      "Zustandsbefund nach Ableitungsoperation am Gehirnventrikel"
    ]
  },
  {
    "code": "Z98.8",
    "name": "Zustandsbefund nach chirurgischem Eingriff a.n.k.",
    "synonyms": [
      "Zustand nach Hysterotomie",
      "Zustandsbefund nach Operation a.n.k.",
      "Zustandsbefund nach chirurgischem Eingriff a.n.k."
    ]
  },
  {
    "code": "Z99.0",
    "name": "Abhängigkeit vom Aspirator",
    "synonyms": [
      "Abhängigkeit vom Absauggerät",
      "Abhängigkeit vom Aspirator",
      "Abhängigkeit vom Hustenunterstützungsgerät",
      "Abhängigkeit vom In-/Exsufflator",
      "Abhängigkeit von Geräten zum Sekretmanagement",
      "Langzeitige Abhängigkeit vom Absauggerät",
      "Langzeitige Abhängigkeit vom Aspirator",
      "Langzeitige Abhängigkeit vom Hustenunterstützungsgerät",
      "Langzeitige Abhängigkeit vom In-/Exsufflator",
      "Langzeitige Abhängigkeit von Geräten zum Sekretmanagement"
    ]
  },
  {
    "code": "Z99.1",
    "name": "Abhängigkeit vom Respirator",
    "synonyms": [
      "Abhängigkeit vom Beatmungsgerät",
      "Abhängigkeit vom Respirator",
      "Langzeitige Abhängigkeit vom Beatmungsgerät",
      "Langzeitige Abhängigkeit vom Respirator"
    ]
  },
  {
    "code": "Z99.2",
    "name": "Langzeitdialyse bei Niereninsuffizienz",
    "synonyms": [
      "Abhängigkeit von der Nierendialyse",
      "Arteriovenöser Shunt für Dialysezwecke",
      "Langzeitdialyse bei Niereninsuffizienz",
      "Operativ angelegte arteriovenöse Fistel",
      "Zustandsbefund nach Nierendialyse"
    ]
  },
  {
    "code": "Z99.3",
    "name": "Abhängigkeit vom Rollstuhl",
    "synonyms": [
      "Abhängigkeit vom Rollstuhl"
    ]
  },
  {
    "code": "Z99.4",
    "name": "Langzeitige Abhängigkeit vom Kunstherz",
    "synonyms": [
      "Abhängigkeit vom Kunstherz",
      "Langzeitige Abhängigkeit vom Kunstherz"
    ]
  },
  {
    "code": "Z99.9",
    "name": "Abhängigkeit von medizinischem Gerät",
    "synonyms": [
      "Abhängigkeit von medizinischem Gerät"
    ]
  }
];
